// locales/ar/common.json
var common_default = {
  app: {
    name: "BatiFlow"
  },
  languages: {
    fr: "Fran\xE7ais",
    ar: "\u0627\u0644\u0639\u0631\u0628\u064A\u0629",
    en: "English"
  },
  actions: {
    save: "\u062D\u0641\u0638",
    cancel: "\u0625\u0644\u063A\u0627\u0621",
    confirm: "\u062A\u0623\u0643\u064A\u062F",
    delete: "\u062D\u0630\u0641",
    close: "\u0625\u063A\u0644\u0627\u0642",
    retry: "\u0625\u0639\u0627\u062F\u0629 \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629",
    back: "\u0631\u062C\u0648\u0639",
    next: "\u0627\u0644\u062A\u0627\u0644\u064A",
    search: "\u0628\u062D\u062B",
    copyDetails: "\u0646\u0633\u062E \u0627\u0644\u062A\u0641\u0627\u0635\u064A\u0644"
  },
  states: {
    loading: "\u062C\u0627\u0631\u064D \u0627\u0644\u062A\u062D\u0645\u064A\u0644\u2026",
    empty: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0639\u0646\u0627\u0635\u0631 \u062D\u0627\u0644\u064A\u064B\u0627.",
    saved: "\u062A\u0645 \u062D\u0641\u0638 \u0627\u0644\u062A\u063A\u064A\u064A\u0631\u0627\u062A."
  },
  errors: {
    generic: "\u062D\u062F\u062B \u062E\u0637\u0623 \u063A\u064A\u0631 \u0645\u062A\u0648\u0642\u0639. \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629 \u0628\u0639\u062F \u0642\u0644\u064A\u0644.",
    traceId: "\u0627\u0644\u0645\u0631\u062C\u0639 \u0627\u0644\u062A\u0642\u0646\u064A: {traceId}",
    BAD_REQUEST: "\u0627\u0644\u0637\u0644\u0628 \u063A\u064A\u0631 \u0635\u0627\u0644\u062D.",
    VALIDATION_FAILED: "\u0628\u0639\u0636 \u0627\u0644\u062D\u0642\u0648\u0644 \u063A\u064A\u0631 \u0635\u0627\u0644\u062D\u0629. \u0635\u062D\u0651\u062D\u0647\u0627 \u062B\u0645 \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629.",
    NOT_FOUND: "\u0647\u0630\u0627 \u0627\u0644\u0639\u0646\u0635\u0631 \u063A\u064A\u0631 \u0645\u0648\u062C\u0648\u062F \u0623\u0648 \u0644\u064A\u0633\u062A \u0644\u062F\u064A\u0643 \u0635\u0644\u0627\u062D\u064A\u0629 \u0627\u0644\u0648\u0635\u0648\u0644 \u0625\u0644\u064A\u0647.",
    PAYLOAD_TOO_LARGE: "\u0627\u0644\u0645\u062D\u062A\u0648\u0649 \u0627\u0644\u0645\u0631\u0633\u0644 \u0643\u0628\u064A\u0631 \u062C\u062F\u064B\u0627.",
    UNSUPPORTED_MEDIA_TYPE: "\u0647\u0630\u0647 \u0627\u0644\u0635\u064A\u063A\u0629 \u063A\u064A\u0631 \u0645\u0642\u0628\u0648\u0644\u0629.",
    RATE_LIMITED: "\u0637\u0644\u0628\u0627\u062A \u0643\u062B\u064A\u0631\u0629 \u062C\u062F\u064B\u0627. \u0627\u0646\u062A\u0638\u0631 \u0628\u0636\u0639 \u062B\u0648\u0627\u0646\u064D \u062B\u0645 \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629.",
    INTERNAL_ERROR: "\u062D\u062F\u062B \u062E\u0637\u0623 \u063A\u064A\u0631 \u0645\u062A\u0648\u0642\u0639. \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629 \u0628\u0639\u062F \u0642\u0644\u064A\u0644.",
    SERVICE_UNAVAILABLE: "\u0627\u0644\u062E\u062F\u0645\u0629 \u063A\u064A\u0631 \u0645\u062A\u0627\u062D\u0629 \u0645\u0624\u0642\u062A\u064B\u0627. \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629 \u0628\u0639\u062F \u0642\u0644\u064A\u0644.",
    SESSION_EXPIRED: "\u0627\u0646\u062A\u0647\u062A \u062C\u0644\u0633\u062A\u0643. \u0633\u062C\u0651\u0644 \u0627\u0644\u062F\u062E\u0648\u0644 \u0645\u0646 \u062C\u062F\u064A\u062F.",
    CSRF_INVALID: "\u0627\u0644\u0635\u0641\u062D\u0629 \u0644\u0645 \u062A\u0639\u062F \u0645\u062D\u062F\u0651\u062B\u0629. \u0623\u0639\u062F \u062A\u062D\u0645\u064A\u0644\u0647\u0627 \u062B\u0645 \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629.",
    MFA_REQUIRED: "\u064A\u062A\u0637\u0644\u0628 \u062F\u0648\u0631\u0643 \u0627\u0644\u0645\u0635\u0627\u062F\u0642\u0629 \u0627\u0644\u062B\u0646\u0627\u0626\u064A\u0629. \u0641\u0639\u0651\u0644\u0647\u0627 \u0644\u0644\u0645\u062A\u0627\u0628\u0639\u0629.",
    STEP_UP_REQUIRED: "\u0623\u0643\u0651\u062F \u0647\u0648\u064A\u062A\u0643 \u0644\u062A\u0646\u0641\u064A\u0630 \u0647\u0630\u0627 \u0627\u0644\u0625\u062C\u0631\u0627\u0621.",
    FORBIDDEN: "\u0644\u064A\u0633\u062A \u0644\u062F\u064A\u0643 \u0635\u0644\u0627\u062D\u064A\u0629 \u062A\u0646\u0641\u064A\u0630 \u0647\u0630\u0627 \u0627\u0644\u0625\u062C\u0631\u0627\u0621.",
    PLAN_LIMIT_REACHED: "\u0627\u0634\u062A\u0631\u0627\u0643\u0643 \u0644\u0627 \u064A\u0633\u0645\u062D \u0628\u0647\u0630\u0627 \u0627\u0644\u0625\u062C\u0631\u0627\u0621. \u0627\u0646\u062A\u0642\u0644 \u0625\u0644\u0649 \u0627\u0634\u062A\u0631\u0627\u0643 \u0623\u0639\u0644\u0649 \u0623\u0648 \u0627\u062A\u0635\u0644 \u0628\u0645\u0627\u0644\u0643 \u0627\u0644\u062D\u0633\u0627\u0628.",
    ORGANIZATION_READ_ONLY: "\u062D\u0633\u0627\u0628 \u0645\u0643\u062A\u0628\u0643 \u0641\u064A \u0648\u0636\u0639 \u0627\u0644\u0642\u0631\u0627\u0621\u0629 \u0641\u0642\u0637. \u0639\u0644\u0649 \u0627\u0644\u0645\u0627\u0644\u0643 \u062A\u0633\u0648\u064A\u0629 \u0627\u0644\u0627\u0634\u062A\u0631\u0627\u0643.",
    STALE_VERSION: "\u0639\u062F\u0651\u0644 \u0634\u062E\u0635 \u0622\u062E\u0631 \u0647\u0630\u0627 \u0627\u0644\u0639\u0646\u0635\u0631. \u0623\u0639\u062F \u062A\u062D\u0645\u064A\u0644\u0647 \u062B\u0645 \u0637\u0628\u0651\u0642 \u062A\u063A\u064A\u064A\u0631\u0627\u062A\u0643 \u0645\u0646 \u062C\u062F\u064A\u062F.",
    PRECONDITION_REQUIRED: "\u0646\u0633\u062E\u0629 \u0627\u0644\u0639\u0646\u0635\u0631 \u0645\u0641\u0642\u0648\u062F\u0629. \u0623\u0639\u062F \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0635\u0641\u062D\u0629.",
    IDEMPOTENCY_KEY_REUSED: "\u0633\u0628\u0642 \u0625\u0631\u0633\u0627\u0644 \u0647\u0630\u0627 \u0627\u0644\u0625\u062C\u0631\u0627\u0621 \u0628\u0645\u062D\u062A\u0648\u0649 \u0645\u062E\u062A\u0644\u0641.",
    FILE_TYPE_NOT_ALLOWED: "\u0646\u0648\u0639 \u0627\u0644\u0645\u0644\u0641 \u0647\u0630\u0627 \u063A\u064A\u0631 \u0645\u0642\u0628\u0648\u0644.",
    FILE_TOO_LARGE: "\u062D\u062C\u0645 \u0647\u0630\u0627 \u0627\u0644\u0645\u0644\u0641 \u064A\u062A\u062C\u0627\u0648\u0632 \u0627\u0644\u062D\u062F \u0627\u0644\u0623\u0642\u0635\u0649 \u0627\u0644\u0645\u0633\u0645\u0648\u062D \u0628\u0647.",
    QUOTA_EXCEEDED: "\u0645\u0633\u0627\u062D\u0629 \u0627\u0644\u062A\u062E\u0632\u064A\u0646 \u0641\u064A \u0627\u0634\u062A\u0631\u0627\u0643\u0643 \u0645\u0645\u062A\u0644\u0626\u0629.",
    PHASE_HAS_UNAPPROVED_DELIVERABLES: "\u0645\u0627 \u0632\u0627\u0644\u062A \u0641\u064A \u0647\u0630\u0647 \u0627\u0644\u0645\u0631\u062D\u0644\u0629 \u0645\u062E\u0631\u062C\u0627\u062A \u0644\u0645 \u062A\u062A\u0645 \u0627\u0644\u0645\u0635\u0627\u062F\u0642\u0629 \u0639\u0644\u064A\u0647\u0627.",
    INVOICE_ALREADY_ISSUED: "\u0635\u062F\u0631\u062A \u0647\u0630\u0647 \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629 \u0648\u0644\u0645 \u064A\u0639\u062F \u0628\u0627\u0644\u0625\u0645\u0643\u0627\u0646 \u062A\u0639\u062F\u064A\u0644\u0647\u0627.",
    COMPUTATION_CHANGED: "\u062A\u063A\u064A\u0651\u0631\u062A \u0627\u0644\u0645\u0628\u0627\u0644\u063A \u0645\u0646\u0630 \u0627\u0644\u0645\u0639\u0627\u064A\u0646\u0629. \u062A\u062D\u0642\u0651\u0642 \u0645\u0646\u0647\u0627 \u0642\u0628\u0644 \u0627\u0644\u0625\u0635\u062F\u0627\u0631.",
    DOCUMENT_LOCKED: "\u0647\u0630\u0647 \u0627\u0644\u0648\u062B\u064A\u0642\u0629 \u0642\u064A\u062F \u0627\u0644\u0645\u0635\u0627\u062F\u0642\u0629 \u0648\u0644\u0627 \u064A\u0645\u0643\u0646 \u0625\u0636\u0627\u0641\u0629 \u0646\u0633\u062E\u0629 \u062C\u062F\u064A\u062F\u0629 \u0644\u0647\u0627.",
    LEGAL_HOLD: "\u064A\u062C\u0628 \u0627\u0644\u0627\u062D\u062A\u0641\u0627\u0638 \u0628\u0647\u0630\u0647 \u0627\u0644\u0648\u062B\u064A\u0642\u0629 (\u0627\u0644\u062A\u0632\u0627\u0645 \u0642\u0627\u0646\u0648\u0646\u064A) \u0648\u0644\u0627 \u064A\u0645\u0643\u0646 \u062D\u0630\u0641\u0647\u0627.",
    DEPENDENCY_CYCLE: "\u0647\u0630\u0627 \u0627\u0644\u0627\u0631\u062A\u0628\u0627\u0637 \u0633\u064A\u064F\u062D\u062F\u062B \u062D\u0644\u0642\u0629 \u0628\u064A\u0646 \u0627\u0644\u0645\u0647\u0627\u0645.",
    ALREADY_A_MEMBER: "\u0647\u0630\u0627 \u0627\u0644\u0634\u062E\u0635 \u0639\u0636\u0648 \u0641\u064A \u0645\u0643\u062A\u0628\u0643 \u0628\u0627\u0644\u0641\u0639\u0644.",
    INVITATION_ALREADY_PENDING: "\u062A\u0648\u062C\u062F \u062F\u0639\u0648\u0629 \u0645\u0639\u0644\u0651\u0642\u0629 \u0644\u0647\u0630\u0627 \u0627\u0644\u0639\u0646\u0648\u0627\u0646.",
    INVITATION_NO_LONGER_VALID: "\u0644\u0645 \u062A\u0639\u062F \u0647\u0630\u0647 \u0627\u0644\u062F\u0639\u0648\u0629 \u0635\u0627\u0644\u062D\u0629: \u0641\u0642\u062F \u0627\u0646\u062A\u0647\u062A \u0635\u0644\u0627\u062D\u064A\u062A\u0647\u0627 \u0623\u0648 \u0623\u064F\u0644\u063A\u064A\u062A \u0623\u0648 \u0633\u0628\u0642 \u0627\u0633\u062A\u0639\u0645\u0627\u0644\u0647\u0627.",
    INVITATION_EMAIL_MISMATCH: "\u0647\u0630\u0647 \u0627\u0644\u062F\u0639\u0648\u0629 \u0645\u0648\u062C\u0651\u0647\u0629 \u0625\u0644\u0649 \u0639\u0646\u0648\u0627\u0646 \u0628\u0631\u064A\u062F \u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A \u063A\u064A\u0631 \u0639\u0646\u0648\u0627\u0646 \u062D\u0633\u0627\u0628\u0643.",
    EMAIL_NOT_VERIFIED: "\u0623\u0643\u0651\u062F \u0639\u0646\u0648\u0627\u0646 \u0628\u0631\u064A\u062F\u0643 \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A \u0623\u0648\u0644\u064B\u0627.",
    EVENT_READ_ONLY: "\u0647\u0630\u0627 \u0627\u0644\u0623\u062C\u0644 \u0622\u062A\u064D \u0645\u0646 \u0645\u0647\u0645\u0629 \u0623\u0648 \u0645\u0631\u062D\u0644\u0629 \u0623\u0648 \u062A\u0623\u0634\u064A\u0631\u0629: \u0639\u062F\u0651\u0644\u0647 \u0645\u0646 \u0645\u0635\u062F\u0631\u0647.",
    MEMBER_CAP_REACHED: "\u062A\u0645 \u0628\u0644\u0648\u063A \u0627\u0644\u062D\u062F \u0627\u0644\u0623\u0642\u0635\u0649 \u0644\u0639\u062F\u062F \u0627\u0644\u0623\u0634\u062E\u0627\u0635 \u0641\u064A \u0647\u0630\u0647 \u0627\u0644\u0634\u0631\u0627\u0643\u0629.",
    SCOPE_EXCEEDS_PARTNERSHIP: "\u0647\u0630\u0647 \u0627\u0644\u0645\u062C\u0644\u062F\u0627\u062A \u0623\u0648 \u0627\u0644\u0642\u0646\u0648\u0627\u062A \u062A\u062A\u062C\u0627\u0648\u0632 \u0645\u0627 \u062A\u0633\u0645\u062D \u0628\u0647 \u0627\u0644\u0634\u0631\u0627\u0643\u0629.",
    RIGHTS_EXCEED_PARTNERSHIP: "\u0647\u0630\u0647 \u0627\u0644\u0635\u0644\u0627\u062D\u064A\u0627\u062A \u062A\u062A\u062C\u0627\u0648\u0632 \u0635\u0644\u0627\u062D\u064A\u0627\u062A \u0627\u0644\u0634\u0631\u0627\u0643\u0629.",
    DELEGATE_NOT_A_MEMBER: "\u0647\u0630\u0627 \u0627\u0644\u0634\u062E\u0635 \u0644\u064A\u0633 \u0639\u0636\u0648\u0627\u064B \u0641\u064A \u0645\u0624\u0633\u0633\u062A\u0643.",
    PARTNERSHIP_ALREADY_EXISTS: "\u0647\u0630\u0647 \u0627\u0644\u0645\u0624\u0633\u0633\u0629 \u0634\u0631\u064A\u0643\u0629 \u0641\u064A \u0647\u0630\u0627 \u0627\u0644\u0641\u0636\u0627\u0621 \u0628\u0627\u0644\u0641\u0639\u0644 \u0623\u0648 \u0644\u062F\u064A\u0647\u0627 \u062F\u0639\u0648\u0629 \u0645\u0639\u0644\u0651\u0642\u0629.",
    SPACE_CLOSED: "\u0647\u0630\u0627 \u0627\u0644\u0641\u0636\u0627\u0621 \u0645\u063A\u0644\u0642: \u0644\u0645 \u064A\u0639\u062F \u0645\u0646 \u0627\u0644\u0645\u0645\u0643\u0646 \u062A\u0639\u062F\u064A\u0644\u0647.",
    GUEST_DOMAIN_NOT_ALLOWED: "\u0644\u0627 \u064A\u0645\u0643\u0646 \u0644\u0636\u064A\u0648\u0641 \u0647\u0630\u0627 \u0627\u0644\u0641\u0636\u0627\u0621 \u0623\u0646 \u064A\u0623\u062A\u0648\u0627 \u0645\u0646 \u0646\u0637\u0627\u0642 \u0627\u0644\u0628\u0631\u064A\u062F \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A \u0647\u0630\u0627.",
    ALREADY_SPACE_MEMBER: "\u0647\u0630\u0627 \u0627\u0644\u0634\u062E\u0635 \u0644\u062F\u064A\u0647 \u0648\u0635\u0648\u0644 \u0625\u0644\u0649 \u0647\u0630\u0627 \u0627\u0644\u0641\u0636\u0627\u0621 \u0628\u0627\u0644\u0641\u0639\u0644.",
    QUOTE_LOCKED: "\u062A\u0645 \u0642\u0628\u0648\u0644 \u0647\u0630\u0627 \u0627\u0644\u0639\u0631\u0636 \u0627\u0644\u0645\u0627\u0644\u064A \u0623\u0648 \u0631\u0641\u0636\u0647: \u0644\u0645 \u064A\u0639\u062F \u0645\u0646 \u0627\u0644\u0645\u0645\u0643\u0646 \u062A\u0639\u062F\u064A\u0644\u0647.",
    QUOTE_EXPIRED: "\u0644\u0645 \u064A\u0639\u062F \u0647\u0630\u0627 \u0627\u0644\u0639\u0631\u0636 \u0627\u0644\u0645\u0627\u0644\u064A \u0635\u0627\u0644\u062D\u0627. \u0627\u0637\u0644\u0628 \u0639\u0631\u0636\u0627 \u062C\u062F\u064A\u062F\u0627 \u0645\u0646 \u0627\u0644\u0645\u0643\u062A\u0628.",
    QUOTE_NOT_ACCEPTED: "\u0644\u0645 \u064A\u0642\u0628\u0644 \u0627\u0644\u062D\u0631\u064A\u0641 \u0647\u0630\u0627 \u0627\u0644\u0639\u0631\u0636 \u0627\u0644\u0645\u0627\u0644\u064A \u0628\u0639\u062F.",
    CONTRACT_REFERENCE_TAKEN: "\u064A\u0648\u062C\u062F \u0639\u0642\u062F \u0622\u062E\u0631 \u064A\u062D\u0645\u0644 \u0647\u0630\u0627 \u0627\u0644\u0645\u0631\u062C\u0639.",
    CONTRACT_EXISTS_FOR_QUOTE: "\u062A\u0645 \u0625\u0646\u0634\u0627\u0621 \u0639\u0642\u062F \u0645\u0646 \u0647\u0630\u0627 \u0627\u0644\u0639\u0631\u0636 \u0627\u0644\u0645\u0627\u0644\u064A \u0645\u0646 \u0642\u0628\u0644.",
    PDF_NOT_READY: "\u064A\u062A\u0645 \u0625\u0639\u062F\u0627\u062F \u0645\u0644\u0641 PDF. \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629 \u0628\u0639\u062F \u0628\u0636\u0639 \u062B\u0648\u0627\u0646.",
    INVOICE_NOT_ISSUED: "\u0644\u0645 \u064A\u062A\u0645 \u0625\u0635\u062F\u0627\u0631 \u0647\u0630\u0647 \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629 \u0628\u0639\u062F.",
    CREDIT_EXCEEDS_INVOICE: "\u062A\u062A\u062C\u0627\u0648\u0632 \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629 \u0627\u0644\u062A\u0639\u062F\u064A\u0644\u064A\u0629 \u0627\u0644\u0645\u0628\u0644\u063A \u0627\u0644\u0645\u062A\u0628\u0642\u064A \u0645\u0646 \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629.",
    OVERPAYMENT: "\u062A\u062A\u062C\u0627\u0648\u0632 \u0647\u0630\u0647 \u0627\u0644\u062F\u0641\u0639\u0629 \u0627\u0644\u0645\u0628\u0644\u063A \u0627\u0644\u0645\u062A\u0628\u0642\u064A.",
    PERIOD_CLOSED: "\u0647\u0630\u0647 \u0627\u0644\u0641\u062A\u0631\u0629 \u0627\u0644\u0645\u062D\u0627\u0633\u0628\u064A\u0629 \u0645\u062E\u062A\u0648\u0645\u0629: \u0644\u0645 \u062A\u0639\u062F \u0627\u0644\u0639\u0645\u0644\u064A\u0629 \u0645\u0645\u0643\u0646\u0629 \u0628\u062A\u0627\u0631\u064A\u062E \u0636\u0645\u0646 \u0647\u0630\u0627 \u0627\u0644\u0634\u0647\u0631. \u0627\u0633\u062A\u0639\u0645\u0644 \u0634\u0647\u0631\u0627 \u0645\u0641\u062A\u0648\u062D\u0627 \u0623\u0648 \u0627\u0637\u0644\u0628 \u0625\u0639\u0627\u062F\u0629 \u0641\u062A\u062D \u0627\u0644\u0634\u0647\u0631.",
    PERIOD_IN_FUTURE: "\u0644\u0645 \u064A\u0628\u062F\u0623 \u0647\u0630\u0627 \u0627\u0644\u0634\u0647\u0631 \u0628\u0639\u062F: \u0644\u0627 \u064A\u0645\u0643\u0646 \u062E\u062A\u0645 \u0625\u0644\u0627 \u0627\u0644\u0634\u0647\u0631 \u0627\u0644\u062C\u0627\u0631\u064A \u0623\u0648 \u0634\u0647\u0631 \u0633\u0627\u0628\u0642.",
    ACCOUNTING_EXPORT_NOT_READY: "\u0627\u0644\u0645\u0644\u0641 \u0642\u064A\u062F \u0627\u0644\u0625\u0639\u062F\u0627\u062F. \u062D\u0627\u0648\u0644 \u0645\u062C\u062F\u062F\u0627 \u0628\u0639\u062F \u062B\u0648\u0627\u0646\u064D.",
    EXPENSE_INVALID_TRANSITION: "\u0644\u0645 \u064A\u0639\u062F \u0647\u0630\u0627 \u0627\u0644\u0645\u0635\u0631\u0648\u0641 \u0641\u064A \u0627\u0644\u062D\u0627\u0644\u0629 \u0627\u0644\u062A\u064A \u064A\u062A\u0637\u0644\u0628\u0647\u0627 \u0647\u0630\u0627 \u0627\u0644\u0625\u062C\u0631\u0627\u0621. \u0623\u0639\u062F \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0635\u0641\u062D\u0629.",
    EXPENSE_SELF_APPROVAL: "\u0644\u0627 \u064A\u0645\u0643\u0646\u0643 \u0627\u0644\u0628\u062A\u0651 \u0641\u064A \u0645\u0635\u0631\u0648\u0641\u0643 \u0627\u0644\u062E\u0627\u0635: \u064A\u062C\u0628 \u0623\u0646 \u064A\u062A\u0648\u0644\u0649 \u0630\u0644\u0643 \u0645\u0633\u0624\u0648\u0644 \u0622\u062E\u0631 \u0639\u0646 \u0627\u0644\u0645\u0648\u0627\u0641\u0642\u0629.",
    RECEIPT_NOT_READY: "\u0645\u0627 \u0632\u0627\u0644 \u0627\u0644\u0645\u0633\u062A\u0646\u062F \u0627\u0644\u062F\u0627\u0639\u0645 \u0642\u064A\u062F \u0627\u0644\u062A\u062D\u0642\u0642. \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629 \u0628\u0639\u062F \u0628\u0636\u0639 \u062B\u0648\u0627\u0646.",
    SIGNING_CREDENTIAL_INVALID: "\u0627\u0644\u0634\u0647\u0627\u062F\u0629 \u0623\u0648 \u0627\u0644\u0645\u0641\u062A\u0627\u062D \u0627\u0644\u062E\u0627\u0635 \u063A\u064A\u0631 \u0635\u0627\u0644\u062D. \u062A\u062D\u0642\u0642 \u0645\u0646 \u0627\u0644\u0645\u0644\u0641\u064A\u0646 \u062B\u0645 \u062D\u0627\u0648\u0644 \u0645\u062C\u062F\u062F\u064B\u0627.",
    SIGNING_KEY_MISMATCH: "\u0627\u0644\u0645\u0641\u062A\u0627\u062D \u0627\u0644\u062E\u0627\u0635 \u0644\u0627 \u064A\u0637\u0627\u0628\u0642 \u0627\u0644\u0634\u0647\u0627\u062F\u0629.",
    SIGNING_CREDENTIAL_EXPIRED: "\u0627\u0646\u062A\u0647\u062A \u0635\u0644\u0627\u062D\u064A\u0629 \u0647\u0630\u0647 \u0627\u0644\u0634\u0647\u0627\u062F\u0629. \u0623\u0636\u0641 \u0634\u0647\u0627\u062F\u0629 \u0644\u0627 \u062A\u0632\u0627\u0644 \u0635\u0627\u0644\u062D\u0629.",
    SIGNING_CREDENTIAL_DUPLICATE: "\u0647\u0630\u0647 \u0627\u0644\u0634\u0647\u0627\u062F\u0629 \u0645\u0633\u062C\u064E\u0651\u0644\u0629 \u0628\u0627\u0644\u0641\u0639\u0644 \u0644\u0645\u0643\u062A\u0628\u0643\u0645.",
    EINVOICE_NOT_RESUBMITTABLE: "\u0644\u0627 \u064A\u0645\u0643\u0646 \u0625\u0639\u0627\u062F\u0629 \u0625\u0631\u0633\u0627\u0644 \u0647\u0630\u0647 \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629 \u0625\u0644\u0649 TTN \u0641\u064A \u062D\u0627\u0644\u062A\u0647\u0627 \u0627\u0644\u062D\u0627\u0644\u064A\u0629.",
    EINVOICE_ALREADY_FINAL: "\u0642\u0628\u0644 TTN \u0647\u0630\u0647 \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629 \u0628\u0627\u0644\u0641\u0639\u0644: \u0644\u0627 \u064A\u0645\u0643\u0646 \u0625\u0639\u0627\u062F\u0629 \u0625\u0631\u0633\u0627\u0644\u0647\u0627.",
    EINVOICE_NOT_REQUIRED: "\u0647\u0630\u0647 \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629 \u063A\u064A\u0631 \u0645\u0639\u0646\u064A\u0629 \u0628\u0627\u0644\u0641\u0648\u062A\u0631\u0629 \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A\u0629.",
    TEIF_NOT_READY: "\u0645\u0644\u0641 TEIF \u0644\u064A\u0633 \u062C\u0627\u0647\u0632\u064B\u0627 \u0628\u0639\u062F. \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629 \u0628\u0639\u062F \u0628\u0636\u0639 \u062B\u0648\u0627\u0646.",
    PLAN_ON_QUOTE: "\u0647\u0630\u0647 \u0627\u0644\u0628\u0627\u0642\u0629 \u062A\u064F\u0628\u0627\u0639 \u062D\u0633\u0628 \u0639\u0631\u0636 \u0633\u0639\u0631. \u0627\u062A\u0635\u0644\u0648\u0627 \u0628\u0627\u0644\u0641\u0631\u064A\u0642 \u0627\u0644\u062A\u062C\u0627\u0631\u064A \u0644\u0640 BatiFlow.",
    SUBSCRIPTION_DOWNGRADE_BLOCKED: "\u0647\u0630\u0647 \u0627\u0644\u0628\u0627\u0642\u0629 \u0623\u0635\u063A\u0631 \u0645\u0646 \u0627\u0633\u062A\u0639\u0645\u0627\u0644\u0643\u0645 \u0627\u0644\u062D\u0627\u0644\u064A. \u0642\u0644\u0651\u0635\u0648\u0627 \u0623\u0648\u0644\u0627\u064B \u0645\u0627 \u0647\u0648 \u0645\u0628\u064A\u0651\u0646 \u062B\u0645 \u0623\u0639\u064A\u062F\u0648\u0627 \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629.",
    SUBSCRIPTION_INVALID_STATE: "\u0627\u0634\u062A\u0631\u0627\u0643\u0643\u0645 \u0644\u064A\u0633 \u0641\u064A \u0627\u0644\u062D\u0627\u0644\u0629 \u0627\u0644\u0645\u0637\u0644\u0648\u0628\u0629 \u0644\u0647\u0630\u0627 \u0627\u0644\u0625\u062C\u0631\u0627\u0621. \u0623\u0639\u064A\u062F\u0648\u0627 \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0635\u0641\u062D\u0629.",
    SUBSCRIPTION_INVOICE_PENDING: "\u0647\u0646\u0627\u0643 \u0641\u0627\u062A\u0648\u0631\u0629 \u0627\u0634\u062A\u0631\u0627\u0643 \u0641\u064A \u0627\u0646\u062A\u0638\u0627\u0631 \u0627\u0644\u062F\u0641\u0639. \u0633\u062F\u0651\u062F\u0648\u0647\u0627 \u0642\u0628\u0644 \u0623\u064A \u062A\u063A\u064A\u064A\u0631 \u0622\u062E\u0631.",
    PAUSE_LIMIT_REACHED: "\u0644\u0642\u062F \u0627\u0633\u062A\u0639\u0645\u0644\u062A\u0645 \u0627\u0644\u0623\u0634\u0647\u0631 \u0627\u0644\u062B\u0644\u0627\u062B\u0629 \u0627\u0644\u0645\u0633\u0645\u0648\u062D \u0628\u0647\u0627 \u0644\u0644\u062A\u0648\u0642\u0641 \u0627\u0644\u0645\u0624\u0642\u062A \u0647\u0630\u0627 \u0627\u0644\u0639\u0627\u0645.",
    BILLING_INVOICE_NOT_OPEN: "\u0647\u0630\u0647 \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629 \u0645\u0633\u062F\u0651\u062F\u0629 \u0623\u0648 \u0645\u0644\u063A\u0627\u0629.",
    PAYMENT_PROVIDER_UNAVAILABLE: "\u062E\u062F\u0645\u0629 \u0627\u0644\u062F\u0641\u0639 \u0639\u0628\u0631 \u0627\u0644\u0625\u0646\u062A\u0631\u0646\u062A \u0644\u0627 \u062A\u0633\u062A\u062C\u064A\u0628. \u0623\u0639\u064A\u062F\u0648\u0627 \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629 \u0628\u0639\u062F \u062F\u0642\u0627\u0626\u0642 \u0623\u0648 \u0627\u062F\u0641\u0639\u0648\u0627 \u0628\u062A\u062D\u0648\u064A\u0644 \u0628\u0646\u0643\u064A.",
    WEBHOOK_SIGNATURE_INVALID: "\u0625\u0634\u0639\u0627\u0631 \u0627\u0644\u062F\u0641\u0639 \u063A\u064A\u0631 \u0645\u0648\u062B\u0648\u0642.",
    WEBAUTHN_REQUIRED: "\u0633\u062C\u0651\u0644 \u0627\u0644\u062F\u062E\u0648\u0644 \u0628\u0645\u0641\u062A\u0627\u062D \u0627\u0644\u0623\u0645\u0627\u0646 (WebAuthn) \u0644\u0644\u0648\u0635\u0648\u0644 \u0625\u0644\u0649 \u0625\u062F\u0627\u0631\u0629 \u0627\u0644\u0645\u0646\u0635\u0651\u0629.",
    BREAK_GLASS_SELF_APPROVAL: "\u064A\u062C\u0628 \u0623\u0646 \u064A\u0648\u0627\u0641\u0642 \u0645\u0633\u0624\u0648\u0644 \u0622\u062E\u0631 \u0639\u0644\u0649 \u0637\u0644\u0628 \u0627\u0644\u0648\u0635\u0648\u0644 \u0647\u0630\u0627.",
    BREAK_GLASS_INVALID_STATE: "\u0644\u0645 \u064A\u0639\u062F \u0637\u0644\u0628 \u0627\u0644\u0648\u0635\u0648\u0644 \u0647\u0630\u0627 \u0641\u064A \u0627\u0644\u062D\u0627\u0644\u0629 \u0627\u0644\u0645\u0646\u062A\u0638\u0631\u0629. \u0623\u0639\u062F \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0635\u0641\u062D\u0629.",
    SUPPORT_IDENTITY_MISSING: "\u062D\u0633\u0627\u0628 \u0627\u0644\u062F\u0639\u0645 \u0627\u0644\u062E\u0627\u0635 \u0628\u0643 \u063A\u064A\u0631 \u0645\u0631\u062A\u0628\u0637 \u0628\u0639\u062F: \u0627\u0637\u0644\u0628 \u0645\u0646 \u0645\u0633\u0624\u0648\u0644 \u0625\u0639\u062F\u0627\u062F\u0647.",
    PAYMENT_ALREADY_CONFIRMED: "\u0647\u0630\u0647 \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629 \u0645\u0633\u062F\u0651\u062F\u0629 \u0628\u0627\u0644\u0641\u0639\u0644.",
    ORGANIZATION_CLOSED: "\u0647\u0630\u0647 \u0627\u0644\u0645\u0624\u0633\u0633\u0629 \u0645\u063A\u0644\u0642\u0629\u060C \u0648\u0644\u0645 \u064A\u0639\u062F \u0645\u0646 \u0627\u0644\u0645\u0645\u0643\u0646 \u062A\u0639\u062F\u064A\u0644 \u0627\u0634\u062A\u0631\u0627\u0643\u0647\u0627.",
    EXPORT_REQUIRED: "\u0642\u0628\u0644 \u0637\u0644\u0628 \u0627\u0644\u062D\u0630\u0641\u060C \u0646\u0632\u0651\u0644 \u0646\u0633\u062E\u0629 \u0643\u0627\u0645\u0644\u0629 \u0645\u0646 \u0628\u064A\u0627\u0646\u0627\u062A \u0627\u0644\u0645\u0624\u0633\u0633\u0629 (\u0639\u0645\u0631\u0647\u0627 \u0623\u0642\u0644 \u0645\u0646 30 \u064A\u0648\u0645\u064B\u0627) \u0623\u0648 \u0635\u0631\u0651\u062D \u0628\u0623\u0646\u0643 \u0644\u0627 \u062A\u0631\u064A\u062F\u0647\u0627.",
    EXPORT_NOT_READY: "\u0647\u0630\u0647 \u0627\u0644\u0646\u0633\u062E\u0629 \u063A\u064A\u0631 \u0645\u062A\u0627\u062D\u0629: \u0647\u064A \u0642\u064A\u062F \u0627\u0644\u0625\u0639\u062F\u0627\u062F \u0623\u0648 \u0641\u0634\u0644\u062A \u0623\u0648 \u0627\u0646\u062A\u0647\u062A \u0635\u0644\u0627\u062D\u064A\u062A\u0647\u0627. \u0627\u0637\u0644\u0628 \u0646\u0633\u062E\u0629 \u062C\u062F\u064A\u062F\u0629.",
    EXPORT_IN_PROGRESS: "\u0647\u0646\u0627\u0643 \u0646\u0633\u062E\u0629 \u0645\u0646 \u0647\u0630\u0627 \u0627\u0644\u0646\u0648\u0639 \u0642\u064A\u062F \u0627\u0644\u0625\u0639\u062F\u0627\u062F. \u0633\u0646\u064F\u0639\u0644\u0645\u0643 \u0641\u0648\u0631 \u062C\u0627\u0647\u0632\u064A\u062A\u0647\u0627.",
    DELETION_ALREADY_SCHEDULED: "\u062D\u0630\u0641 \u0647\u0630\u0647 \u0627\u0644\u0645\u0624\u0633\u0633\u0629 \u0645\u0628\u0631\u0645\u062C \u0645\u0633\u0628\u0642\u064B\u0627.",
    DELETION_NOT_SCHEDULED: "\u0644\u0627 \u064A\u0648\u062C\u062F \u062D\u0630\u0641 \u0645\u0628\u0631\u0645\u062C \u064A\u0645\u0643\u0646 \u0625\u0644\u063A\u0627\u0624\u0647. \u064A\u062A\u0648\u0642\u0641 \u0627\u0644\u062D\u0630\u0641 \u0627\u0644\u0646\u0627\u062A\u062C \u0639\u0646 \u0639\u062F\u0645 \u0627\u0644\u062F\u0641\u0639 \u0628\u0645\u062C\u0631\u062F \u062A\u0633\u062F\u064A\u062F \u0627\u0644\u0627\u0634\u062A\u0631\u0627\u0643.",
    CONFIRMATION_MISMATCH: "\u0627\u0644\u0627\u0633\u0645 \u0627\u0644\u0645\u064F\u062F\u062E\u0644 \u0644\u0627 \u064A\u0637\u0627\u0628\u0642 \u0627\u0644\u0627\u0633\u0645 \u0627\u0644\u0642\u0627\u0646\u0648\u0646\u064A \u0644\u0644\u0645\u0624\u0633\u0633\u0629.",
    ROLE_ESCALATION: "\u0644\u0627 \u064A\u0645\u0643\u0646\u0643 \u0645\u0646\u062D \u0635\u0644\u0627\u062D\u064A\u0627\u062A \u0644\u0627 \u062A\u0645\u0644\u0643\u0647\u0627 \u0628\u0646\u0641\u0633\u0643.",
    ROLE_IN_USE: "\u0645\u0627 \u0632\u0627\u0644 \u0647\u0630\u0627 \u0627\u0644\u062F\u0648\u0631 \u0645\u064F\u0633\u0646\u062F\u064B\u0627 \u0625\u0644\u0649 \u0623\u0639\u0636\u0627\u0621 \u0623\u0648 \u062F\u0639\u0648\u0627\u062A \u0645\u0639\u0644\u0651\u0642\u0629. \u063A\u064A\u0651\u0631 \u062F\u0648\u0631\u0647\u0645 \u0623\u0648\u0644\u064B\u0627.",
    MEMBERSHIP_SUSPENDED: "\u062A\u0645 \u062A\u0639\u0644\u064A\u0642 \u0648\u0635\u0648\u0644\u0643 \u0625\u0644\u0649 \u0647\u0630\u0647 \u0627\u0644\u0645\u0624\u0633\u0633\u0629 \u0645\u0646 \u0642\u0628\u0644 \u062F\u0639\u0645 BatiFlow. \u064A\u0631\u062C\u0649 \u0627\u0644\u062A\u0648\u0627\u0635\u0644 \u0645\u0639 \u0627\u0644\u062F\u0639\u0645.",
    MEMBER_STATE_INVALID: "\u062D\u0627\u0644\u0629 \u0647\u0630\u0627 \u0627\u0644\u0639\u0636\u0648 \u0644\u0627 \u062A\u0633\u0645\u062D \u0628\u0647\u0630\u0627 \u0627\u0644\u0625\u062C\u0631\u0627\u0621. \u0623\u0639\u062F \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0635\u0641\u062D\u0629.",
    OWNER_PROTECTED: "\u0644\u0627 \u064A\u0645\u0643\u0646 \u0625\u0632\u0627\u0644\u0629 \u0627\u0644\u0645\u0627\u0644\u0643: \u0627\u0646\u0642\u0644 \u0645\u0644\u0643\u064A\u0629 \u0627\u0644\u0645\u0624\u0633\u0633\u0629 \u0623\u0648\u0644\u0627\u064B.",
    ACCOUNT_NOT_DELETABLE: "\u0644\u0627 \u064A\u0645\u0643\u0646 \u062D\u0630\u0641 \u0647\u0630\u0627 \u0627\u0644\u062D\u0633\u0627\u0628 \u0628\u0639\u062F: \u0641\u0647\u0648 \u064A\u0645\u0644\u0643 \u0645\u0624\u0633\u0633\u0629 \u0623\u0648 \u064A\u064F\u0633\u062A\u0639\u0645\u0644 \u0643\u0647\u0648\u064A\u0629 \u0644\u0644\u062F\u0639\u0645.",
    PLATFORM_ORGANIZATION_PROTECTED: "\u0644\u0627 \u064A\u0645\u0643\u0646 \u062D\u0630\u0641 \u0645\u0624\u0633\u0633\u0629 \u0627\u0644\u0645\u0646\u0635\u0629.",
    DELETION_ALREADY_REQUESTED: "\u064A\u0648\u062C\u062F \u0637\u0644\u0628 \u062D\u0630\u0641 \u0644\u0647\u0630\u0647 \u0627\u0644\u0645\u0624\u0633\u0633\u0629 \u0641\u064A \u0627\u0646\u062A\u0638\u0627\u0631 \u0627\u0644\u0642\u0631\u0627\u0631.",
    DELETION_SELF_APPROVAL: "\u064A\u062C\u0628 \u0623\u0646 \u064A\u0642\u0631\u0631 \u0645\u0633\u0624\u0648\u0644 \u0622\u062E\u0631 \u0628\u0634\u0623\u0646 \u0647\u0630\u0627 \u0627\u0644\u062D\u0630\u0641.",
    DELETION_INVALID_STATE: "\u062A\u0645\u062A \u0645\u0639\u0627\u0644\u062C\u0629 \u0637\u0644\u0628 \u0627\u0644\u062D\u0630\u0641 \u0647\u0630\u0627 \u0628\u0627\u0644\u0641\u0639\u0644. \u0623\u0639\u062F \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0635\u0641\u062D\u0629.",
    DELETION_PENDING: "\u064A\u0648\u062C\u062F \u0637\u0644\u0628 \u062D\u0630\u0641 \u0644\u0647\u0630\u0647 \u0627\u0644\u0645\u0624\u0633\u0633\u0629 \u0641\u064A \u0627\u0646\u062A\u0638\u0627\u0631 \u0627\u0644\u0642\u0631\u0627\u0631: \u0644\u0627 \u064A\u0645\u0643\u0646 \u062A\u063A\u064A\u064A\u0631 \u0627\u0644\u062D\u0627\u0644\u0629.",
    REAUTH_REQUIRED: "\u0644\u0623\u0633\u0628\u0627\u0628 \u0623\u0645\u0646\u064A\u0629\u060C \u0623\u0643\u0651\u062F \u0647\u0648\u064A\u062A\u0643 \u0642\u0628\u0644 \u062A\u063A\u064A\u064A\u0631 \u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631.",
    PASSWORD_POLICY: "\u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631 \u0647\u0630\u0647 \u063A\u064A\u0631 \u0645\u0642\u0628\u0648\u0644\u0629: 12 \u062D\u0631\u0641\u064B\u0627 \u0639\u0644\u0649 \u0627\u0644\u0623\u0642\u0644\u060C \u0648\u0645\u062E\u062A\u0644\u0641\u0629 \u0639\u0646 \u0628\u0631\u064A\u062F\u0643 \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A \u0648\u0639\u0646 \u0622\u062E\u0631 5 \u0643\u0644\u0645\u0627\u062A \u0645\u0631\u0648\u0631.",
    LAST_SECOND_FACTOR: "\u0627\u0644\u062A\u062D\u0642\u0642 \u0628\u062E\u0637\u0648\u062A\u064A\u0646 \u0625\u0644\u0632\u0627\u0645\u064A \u0641\u064A \u0645\u0624\u0633\u0633\u062A\u0643: \u0623\u0636\u0641 \u0637\u0631\u064A\u0642\u0629 \u0623\u062E\u0631\u0649 \u0642\u0628\u0644 \u0625\u0632\u0627\u0644\u0629 \u0647\u0630\u0647 \u0627\u0644\u0637\u0631\u064A\u0642\u0629.",
    SIGNATURE_NOT_PENDING: "\u0644\u0645 \u064A\u0639\u062F \u0647\u0630\u0627 \u0627\u0644\u0637\u0644\u0628 \u064A\u0646\u062A\u0638\u0631 \u062A\u0648\u0642\u064A\u0639\u0627: \u0641\u0642\u062F \u0627\u0643\u062A\u0645\u0644 \u0623\u0648 \u0631\u064F\u0641\u0636 \u0623\u0648 \u0623\u064F\u0644\u063A\u064A.",
    SIGNATURE_EXPIRED: "\u0627\u0646\u062A\u0647\u062A \u0635\u0644\u0627\u062D\u064A\u0629 \u0647\u0630\u0627 \u0627\u0644\u0637\u0644\u0628: \u0644\u0645 \u064A\u0639\u062F \u0628\u0627\u0644\u0625\u0645\u0643\u0627\u0646 \u062A\u0648\u0642\u064A\u0639\u0647. \u0627\u0637\u0644\u0628 \u0637\u0644\u0628\u0627 \u062C\u062F\u064A\u062F\u0627.",
    SIGNATURE_CODE_INVALID: "\u0647\u0630\u0627 \u0627\u0644\u0631\u0645\u0632 \u063A\u064A\u0631 \u0635\u062D\u064A\u062D. \u062A\u062D\u0642\u0642 \u0645\u0646\u0647 \u0641\u064A \u0627\u0644\u0631\u0633\u0627\u0644\u0629 \u0627\u0644\u0645\u0633\u062A\u0644\u0645\u0629 \u062B\u0645 \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629. \u0628\u0639\u062F \u0628\u0636\u0639\u0629 \u0623\u062E\u0637\u0627\u0621 \u0633\u064A\u0644\u0632\u0645 \u0637\u0644\u0628 \u0631\u0645\u0632 \u062C\u062F\u064A\u062F.",
    SIGNATURE_CODE_LOCKED: "\u0644\u0645 \u064A\u0639\u062F \u0628\u0627\u0644\u0625\u0645\u0643\u0627\u0646 \u0627\u0633\u062A\u0639\u0645\u0627\u0644 \u0647\u0630\u0627 \u0627\u0644\u0631\u0645\u0632 (\u0645\u062D\u0627\u0648\u0644\u0627\u062A \u0643\u062B\u064A\u0631\u0629 \u0623\u0648 \u0631\u0645\u0632 \u0645\u0646\u062A\u0647\u064A). \u0627\u0637\u0644\u0628 \u0631\u0645\u0632\u0627 \u062C\u062F\u064A\u062F\u0627.",
    SIGNATURE_CODE_TOO_SOON: "\u0623\u064F\u0631\u0633\u0644 \u0631\u0645\u0632 \u0644\u0644\u062A\u0648. \u0627\u0646\u062A\u0638\u0631 \u062F\u0642\u064A\u0642\u0629 \u0642\u0628\u0644 \u0637\u0644\u0628 \u0631\u0645\u0632 \u062C\u062F\u064A\u062F.",
    SIGNATURE_DOCUMENT_NOT_READY: "\u0645\u0627 \u0632\u0627\u0644 \u0645\u0644\u0641 \u0647\u0630\u0647 \u0627\u0644\u0648\u062B\u064A\u0642\u0629 \u0642\u064A\u062F \u0627\u0644\u062A\u062D\u0642\u0642. \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629 \u0628\u0639\u062F \u0644\u062D\u0638\u0627\u062A.",
    SIGNATURE_SIGNER_INVALID: "\u0644\u0627 \u064A\u0645\u0643\u0646 \u0627\u0639\u062A\u0645\u0627\u062F \u0623\u062D\u062F \u0627\u0644\u0645\u0648\u0642\u0650\u0651\u0639\u064A\u0646: \u064A\u062C\u0628 \u0623\u0646 \u064A\u0643\u0648\u0646 \u0639\u0636\u0648\u0627 \u0641\u0639\u0651\u0627\u0644\u0627 \u0641\u064A \u0645\u0643\u062A\u0628\u0643 \u0648\u0623\u0646 \u064A\u0633\u062A\u0637\u064A\u0639 \u0642\u0631\u0627\u0621\u0629 \u0647\u0630\u0647 \u0627\u0644\u0648\u062B\u064A\u0642\u0629. \u0639\u062F\u0651\u0644 \u0627\u0644\u0642\u0627\u0626\u0645\u0629 \u062B\u0645 \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629.",
    SIGNATURE_EVIDENCE_NOT_READY: "\u0645\u0627 \u0632\u0627\u0644\u062A \u0634\u0647\u0627\u062F\u0629 \u0627\u0644\u0625\u062B\u0628\u0627\u062A \u0642\u064A\u062F \u0627\u0644\u0625\u0639\u062F\u0627\u062F. \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629 \u0628\u0639\u062F \u0628\u0636\u0639 \u062B\u0648\u0627\u0646.",
    SIGNATURE_PROVIDER_FAILED: "\u0644\u0645 \u062A\u0633\u062A\u062C\u0628 \u0645\u0646\u0635\u0629 \u0627\u0644\u062A\u0648\u0642\u064A\u0639 \u0643\u0645\u0627 \u0647\u0648 \u0645\u062A\u0648\u0642\u0639. \u0644\u0645 \u064A\u062A\u0645 \u062A\u0648\u0642\u064A\u0639 \u0623\u064A \u0634\u064A\u0621: \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629 \u0628\u0639\u062F \u0644\u062D\u0638\u0627\u062A.",
    DIGIGO_NOTHING_TO_SIGN: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0641\u0627\u062A\u0648\u0631\u0629 \u062A\u0646\u062A\u0638\u0631 \u062A\u0648\u0642\u064A\u0639 DigiGO \u062D\u0627\u0644\u064A\u0627.",
    DIGIGO_NO_CREDENTIAL: "\u0644\u0627 \u064A\u0648\u062C\u062F \u062D\u0633\u0627\u0628 DigiGO \u0641\u0639\u0651\u0627\u0644 \u0644\u0645\u0643\u062A\u0628\u0643. \u0623\u0636\u0650\u0641\u0647 \u0641\u064A \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629 \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A\u0629\u060C \u0634\u0647\u0627\u062F\u0627\u062A \u0627\u0644\u062A\u0648\u0642\u064A\u0639.",
    SIGNING_BATCH_NOT_PENDING: "\u0644\u0645 \u062A\u0639\u062F \u0647\u0630\u0647 \u0627\u0644\u0645\u062C\u0645\u0648\u0639\u0629 \u062A\u0646\u062A\u0638\u0631 \u0631\u0645\u0632\u0627: \u0641\u0642\u062F \u062A\u0645 \u062A\u0648\u0642\u064A\u0639\u0647\u0627 \u0623\u0648 \u0627\u0646\u062A\u0647\u062A \u0623\u0648 \u0623\u064F\u0644\u063A\u064A\u062A. \u0623\u0639\u062F \u062A\u0634\u063A\u064A\u0644 \xAB\u062A\u0648\u0642\u064A\u0639 \u0627\u0644\u0645\u062C\u0645\u0648\u0639\u0629\xBB."
  },
  taxId: {
    EMPTY: "\u0623\u062F\u062E\u0644 \u0627\u0644\u0645\u0639\u0631\u0651\u0641 \u0627\u0644\u062C\u0628\u0627\u0626\u064A.",
    FORMAT: "\u0627\u0644\u0635\u064A\u063A\u0629 \u0627\u0644\u0645\u0646\u062A\u0638\u0631\u0629: \u20661234567 A / A / M / 000\u2069.",
    INCOMPLETE: "\u0627\u0644\u0645\u0639\u0631\u0651\u0641 \u0627\u0644\u062C\u0628\u0627\u0626\u064A \u063A\u064A\u0631 \u0645\u0643\u062A\u0645\u0644: \u0623\u0636\u0641 \u0631\u0645\u0632 \u0627\u0644\u0623\u062F\u0627\u0621 \u0639\u0644\u0649 \u0627\u0644\u0642\u064A\u0645\u0629 \u0627\u0644\u0645\u0636\u0627\u0641\u0629 \u0648\u0627\u0644\u0635\u0646\u0641 \u0648\u0631\u0642\u0645 \u0627\u0644\u0645\u0624\u0633\u0633\u0629.",
    CHECK_LETTER: "\u062D\u0631\u0641 \u0627\u0644\u0645\u0631\u0627\u0642\u0628\u0629 \u063A\u064A\u0631 \u0635\u0627\u0644\u062D (\u0644\u0627 \u062A\u064F\u0633\u062A\u0639\u0645\u0644 \u0627\u0644\u062D\u0631\u0648\u0641 I \u0648O \u0648U).",
    VAT_CODE: "\u064A\u062C\u0628 \u0623\u0646 \u064A\u0643\u0648\u0646 \u0631\u0645\u0632 \u0627\u0644\u0623\u062F\u0627\u0621 \u0639\u0644\u0649 \u0627\u0644\u0642\u064A\u0645\u0629 \u0627\u0644\u0645\u0636\u0627\u0641\u0629 A \u0623\u0648 P \u0623\u0648 B \u0623\u0648 D \u0623\u0648 N.",
    CATEGORY: "\u064A\u062C\u0628 \u0623\u0646 \u064A\u0643\u0648\u0646 \u0627\u0644\u0635\u0646\u0641 M \u0623\u0648 P \u0623\u0648 C \u0623\u0648 N \u0623\u0648 E.",
    ESTABLISHMENT: "\u064A\u062C\u0628 \u0623\u0646 \u064A\u062A\u0643\u0648\u0651\u0646 \u0631\u0642\u0645 \u0627\u0644\u0645\u0624\u0633\u0633\u0629 \u0645\u0646 3 \u0623\u0631\u0642\u0627\u0645."
  },
  holidays: {
    new_year: "\u0631\u0623\u0633 \u0627\u0644\u0633\u0646\u0629 \u0627\u0644\u0645\u064A\u0644\u0627\u062F\u064A\u0629",
    independence_day: "\u0639\u064A\u062F \u0627\u0644\u0627\u0633\u062A\u0642\u0644\u0627\u0644",
    martyrs_day: "\u0639\u064A\u062F \u0627\u0644\u0634\u0647\u062F\u0627\u0621",
    labour_day: "\u0639\u064A\u062F \u0627\u0644\u0634\u063A\u0644",
    republic_day: "\u0639\u064A\u062F \u0627\u0644\u062C\u0645\u0647\u0648\u0631\u064A\u0629",
    womens_day: "\u0639\u064A\u062F \u0627\u0644\u0645\u0631\u0623\u0629",
    evacuation_day: "\u0639\u064A\u062F \u0627\u0644\u062C\u0644\u0627\u0621",
    revolution_day: "\u0639\u064A\u062F \u0627\u0644\u062B\u0648\u0631\u0629",
    eid_al_fitr_1: "\u0639\u064A\u062F \u0627\u0644\u0641\u0637\u0631",
    eid_al_fitr_2: "\u0639\u064A\u062F \u0627\u0644\u0641\u0637\u0631 (\u0627\u0644\u064A\u0648\u0645 \u0627\u0644\u062B\u0627\u0646\u064A)",
    eid_al_adha_1: "\u0639\u064A\u062F \u0627\u0644\u0623\u0636\u062D\u0649",
    eid_al_adha_2: "\u0639\u064A\u062F \u0627\u0644\u0623\u0636\u062D\u0649 (\u0627\u0644\u064A\u0648\u0645 \u0627\u0644\u062B\u0627\u0646\u064A)",
    islamic_new_year: "\u0631\u0623\u0633 \u0627\u0644\u0633\u0646\u0629 \u0627\u0644\u0647\u062C\u0631\u064A\u0629",
    mawlid: "\u0627\u0644\u0645\u0648\u0644\u062F \u0627\u0644\u0646\u0628\u0648\u064A \u0627\u0644\u0634\u0631\u064A\u0641"
  }
};

// locales/en/common.json
var common_default2 = {
  app: {
    name: "BatiFlow"
  },
  languages: {
    fr: "Fran\xE7ais",
    ar: "\u0627\u0644\u0639\u0631\u0628\u064A\u0629",
    en: "English"
  },
  actions: {
    save: "Save",
    cancel: "Cancel",
    confirm: "Confirm",
    delete: "Delete",
    close: "Close",
    retry: "Try again",
    back: "Back",
    next: "Next",
    search: "Search",
    copyDetails: "Copy details"
  },
  states: {
    loading: "Loading\u2026",
    empty: "Nothing here yet.",
    saved: "Changes saved."
  },
  errors: {
    generic: "Something went wrong. Please try again in a moment.",
    traceId: "Technical reference: {traceId}",
    BAD_REQUEST: "The request is not valid.",
    VALIDATION_FAILED: "Some fields are not valid. Correct them and try again.",
    NOT_FOUND: "This item does not exist or you do not have access to it.",
    PAYLOAD_TOO_LARGE: "What you sent is too large.",
    UNSUPPORTED_MEDIA_TYPE: "This format is not accepted.",
    RATE_LIMITED: "Too many requests. Wait a few seconds and try again.",
    INTERNAL_ERROR: "Something went wrong. Please try again in a moment.",
    SERVICE_UNAVAILABLE: "The service is temporarily unavailable. Please try again in a moment.",
    SESSION_EXPIRED: "Your session has expired. Please sign in again.",
    CSRF_INVALID: "This page is out of date. Reload it and try again.",
    MFA_REQUIRED: "Your role requires two-factor authentication. Turn it on to continue.",
    STEP_UP_REQUIRED: "Confirm your identity to perform this action.",
    FORBIDDEN: "You are not allowed to perform this action.",
    PLAN_LIMIT_REACHED: "Your plan does not include this. Upgrade your plan or contact the account owner.",
    ORGANIZATION_READ_ONLY: "Your office's account is read-only. The owner needs to settle the subscription.",
    STALE_VERSION: "Someone else changed this item. Reload it and apply your changes again.",
    PRECONDITION_REQUIRED: "The item's version is missing. Reload the page.",
    IDEMPOTENCY_KEY_REUSED: "This action was already sent with different content.",
    FILE_TYPE_NOT_ALLOWED: "This file type is not accepted.",
    FILE_TOO_LARGE: "This file is larger than the maximum allowed size.",
    QUOTA_EXCEEDED: "Your plan's storage is full.",
    PHASE_HAS_UNAPPROVED_DELIVERABLES: "This phase still has deliverables that are not approved.",
    INVOICE_ALREADY_ISSUED: "This invoice has been issued and can no longer be changed.",
    COMPUTATION_CHANGED: "The amounts changed since the preview. Check them before issuing.",
    DOCUMENT_LOCKED: "This document is under approval and cannot receive a new version.",
    LEGAL_HOLD: "This document must be kept (legal obligation) and cannot be deleted.",
    DEPENDENCY_CYCLE: "This dependency would create a loop between tasks.",
    ALREADY_A_MEMBER: "This person is already part of your office.",
    INVITATION_ALREADY_PENDING: "An invitation is already pending for this address.",
    INVITATION_NO_LONGER_VALID: "This invitation is no longer valid: it has expired, was cancelled or was already used.",
    INVITATION_EMAIL_MISMATCH: "This invitation is meant for another email address than the one of your account.",
    EMAIL_NOT_VERIFIED: "Confirm your email address first.",
    EVENT_READ_ONLY: "This deadline comes from a task, a phase or an approval: change it at its source.",
    MEMBER_CAP_REACHED: "The maximum number of people of this partnership is reached.",
    SCOPE_EXCEEDS_PARTNERSHIP: "These folders or channels go beyond what the partnership allows.",
    RIGHTS_EXCEED_PARTNERSHIP: "These rights go beyond those of the partnership.",
    DELEGATE_NOT_A_MEMBER: "This person is not a member of your organisation.",
    PARTNERSHIP_ALREADY_EXISTS: "This organisation is already a partner of this space or already has a pending invitation.",
    SPACE_CLOSED: "This space is closed: it can no longer be changed.",
    GUEST_DOMAIN_NOT_ALLOWED: "Guests of this space cannot come from this e-mail domain.",
    ALREADY_SPACE_MEMBER: "This person already has access to this space.",
    QUOTE_LOCKED: "This quote was accepted or declined: it can no longer be changed.",
    QUOTE_EXPIRED: "This quote is no longer valid. Ask the office for a new proposal.",
    QUOTE_NOT_ACCEPTED: "The client has not accepted this quote yet.",
    CONTRACT_REFERENCE_TAKEN: "Another contract already has this reference.",
    CONTRACT_EXISTS_FOR_QUOTE: "A contract has already been created from this quote.",
    PDF_NOT_READY: "The PDF is being prepared. Try again in a few seconds.",
    INVOICE_NOT_ISSUED: "This invoice has not been issued yet.",
    CREDIT_EXCEEDS_INVOICE: "The credit note exceeds what is left of the invoice.",
    OVERPAYMENT: "This payment exceeds the amount still due.",
    PERIOD_CLOSED: "This accounting period is closed: the operation is no longer possible for a date in that month. Use an open month or have the month reopened.",
    PERIOD_IN_FUTURE: "This month has not started yet: only the current or a past month can be closed.",
    ACCOUNTING_EXPORT_NOT_READY: "The file is still being prepared. Try again in a few seconds.",
    EXPENSE_INVALID_TRANSITION: "This expense is no longer in the state this action needs. Reload the page.",
    EXPENSE_SELF_APPROVAL: "You cannot decide on your own expense: another approver has to do it.",
    RECEIPT_NOT_READY: "The receipt is still being checked. Try again in a few seconds.",
    SIGNING_CREDENTIAL_INVALID: "The certificate or the private key is not valid. Check the files, then try again.",
    SIGNING_KEY_MISMATCH: "The private key does not match the certificate.",
    SIGNING_CREDENTIAL_EXPIRED: "This certificate has expired. Add a certificate that is still valid.",
    SIGNING_CREDENTIAL_DUPLICATE: "This certificate is already registered for your office.",
    EINVOICE_NOT_RESUBMITTABLE: "This invoice cannot be sent to TTN again in its current state.",
    EINVOICE_ALREADY_FINAL: "TTN already accepted this invoice: it can no longer be sent again.",
    EINVOICE_NOT_REQUIRED: "This invoice is not concerned by electronic invoicing.",
    TEIF_NOT_READY: "The TEIF file is not ready yet. Try again in a few seconds.",
    PLAN_ON_QUOTE: "This plan is sold on quote. Contact the BatiFlow sales team.",
    SUBSCRIPTION_DOWNGRADE_BLOCKED: "This plan is too small for what you use today. Reduce what is listed first, then try again.",
    SUBSCRIPTION_INVALID_STATE: "Your subscription is not in the state this action needs. Reload the page.",
    SUBSCRIPTION_INVOICE_PENDING: "A subscription invoice is already waiting for payment. Pay it before making another change.",
    PAUSE_LIMIT_REACHED: "You have already used the 3 months of pause allowed this year.",
    BILLING_INVOICE_NOT_OPEN: "This invoice is already paid or cancelled.",
    PAYMENT_PROVIDER_UNAVAILABLE: "The online payment service is not answering. Try again in a few minutes or pay by bank transfer.",
    WEBHOOK_SIGNATURE_INVALID: "The payment notification is not authentic.",
    WEBAUTHN_REQUIRED: "Sign in with your security key (WebAuthn) to reach the platform administration.",
    BREAK_GLASS_SELF_APPROVAL: "Another administrator must approve this access request.",
    BREAK_GLASS_INVALID_STATE: "This access request is no longer in the expected state. Reload the page.",
    SUPPORT_IDENTITY_MISSING: "Your support account is not linked yet: ask an administrator to set it up.",
    PAYMENT_ALREADY_CONFIRMED: "This invoice is already paid.",
    ORGANIZATION_CLOSED: "This organisation is closed: its subscription can no longer be changed.",
    EXPORT_REQUIRED: "Before asking for the deletion, download a complete export of the organisation (less than 30 days old) or say that you do not want one.",
    EXPORT_NOT_READY: "This export is not available: it is being prepared, failed or expired. Ask for a new one.",
    EXPORT_IN_PROGRESS: "An export of this kind is already being prepared. You will be told as soon as it is ready.",
    DELETION_ALREADY_SCHEDULED: "The deletion of this organisation is already scheduled.",
    DELETION_NOT_SCHEDULED: "No deletion that can be cancelled is scheduled. A deletion caused by an unpaid subscription stops as soon as the subscription is paid.",
    CONFIRMATION_MISMATCH: "The name you typed is not the organisation\u2019s legal name.",
    ROLE_ESCALATION: "You cannot grant permissions you do not hold yourself.",
    ROLE_IN_USE: "This role is still given to members or pending invitations. Change their role first.",
    MEMBERSHIP_SUSPENDED: "Your access to this organisation is suspended by BatiFlow support. Please contact support.",
    MEMBER_STATE_INVALID: "This member is not in the right state for this action. Reload the page.",
    OWNER_PROTECTED: "The owner cannot be removed: transfer the organisation\u2019s ownership first.",
    ACCOUNT_NOT_DELETABLE: "This account cannot be deleted yet: it owns an organisation or is a support identity.",
    PLATFORM_ORGANIZATION_PROTECTED: "The platform\u2019s own organisation cannot be deleted.",
    DELETION_ALREADY_REQUESTED: "A deletion of this organisation is already waiting for a decision.",
    DELETION_SELF_APPROVAL: "Another administrator must decide on this deletion.",
    DELETION_INVALID_STATE: "This deletion request was already handled. Reload the page.",
    DELETION_PENDING: "A deletion of this organisation is waiting for a decision: its status cannot be changed.",
    REAUTH_REQUIRED: "For your security, confirm it\u2019s you before changing your password.",
    PASSWORD_POLICY: "This password is not accepted: at least 12 characters, different from your e-mail address and from your last 5 passwords.",
    LAST_SECOND_FACTOR: "Two-step verification is required in your organisation: add another method before removing this one.",
    SIGNATURE_NOT_PENDING: "This request no longer waits for a signature: it is completed, declined or cancelled.",
    SIGNATURE_EXPIRED: "This request has expired: it can no longer be signed. Ask for a new one.",
    SIGNATURE_CODE_INVALID: "That code is not right. Check it in the message you received and try again. After a few mistakes you will need a new code.",
    SIGNATURE_CODE_LOCKED: "This code can no longer be used (too many attempts, or it expired). Ask for a new code.",
    SIGNATURE_CODE_TOO_SOON: "A code was just sent. Wait a minute before asking for a new one.",
    SIGNATURE_DOCUMENT_NOT_READY: "The file of this document is still being checked. Try again in a few moments.",
    SIGNATURE_SIGNER_INVALID: "One of the signers cannot be accepted: they must be an active member of your office and be able to read this document. Change the list and try again.",
    SIGNATURE_EVIDENCE_NOT_READY: "The evidence certificate is still being prepared. Try again in a few seconds.",
    SIGNATURE_PROVIDER_FAILED: "The signing platform did not answer as expected. Nothing was signed: try again in a moment.",
    DIGIGO_NOTHING_TO_SIGN: "No invoice is waiting for a DigiGO signature right now.",
    DIGIGO_NO_CREDENTIAL: "No DigiGO account is active for your office. Add it in E-invoicing, signing certificates.",
    SIGNING_BATCH_NOT_PENDING: 'This batch no longer waits for a code: it is already signed, expired or cancelled. Start "Sign the batch" again.'
  },
  taxId: {
    EMPTY: "Enter the tax ID (matricule fiscal).",
    FORMAT: "Expected format: 1234567 A / A / M / 000.",
    INCOMPLETE: "Incomplete tax ID: add the VAT code, the category and the establishment number.",
    CHECK_LETTER: "The check letter is not valid (I, O and U are never used).",
    VAT_CODE: "The VAT code must be A, P, B, D or N.",
    CATEGORY: "The category must be M, P, C, N or E.",
    ESTABLISHMENT: "The establishment number must have 3 digits."
  },
  holidays: {
    new_year: "New Year's Day",
    independence_day: "Independence Day",
    martyrs_day: "Martyrs' Day",
    labour_day: "Labour Day",
    republic_day: "Republic Day",
    womens_day: "Women's Day",
    evacuation_day: "Evacuation Day",
    revolution_day: "Revolution Day",
    eid_al_fitr_1: "Eid al-Fitr",
    eid_al_fitr_2: "Eid al-Fitr (day 2)",
    eid_al_adha_1: "Eid al-Adha",
    eid_al_adha_2: "Eid al-Adha (day 2)",
    islamic_new_year: "Islamic New Year",
    mawlid: "Mawlid"
  }
};

// locales/fr/common.json
var common_default3 = {
  app: {
    name: "BatiFlow"
  },
  languages: {
    fr: "Fran\xE7ais",
    ar: "\u0627\u0644\u0639\u0631\u0628\u064A\u0629",
    en: "English"
  },
  actions: {
    save: "Enregistrer",
    cancel: "Annuler",
    confirm: "Confirmer",
    delete: "Supprimer",
    close: "Fermer",
    retry: "R\xE9essayer",
    back: "Retour",
    next: "Suivant",
    search: "Rechercher",
    copyDetails: "Copier les d\xE9tails"
  },
  states: {
    loading: "Chargement\u2026",
    empty: "Aucun \xE9l\xE9ment pour le moment.",
    saved: "Modifications enregistr\xE9es."
  },
  errors: {
    generic: "Une erreur inattendue s'est produite. R\xE9essayez dans un instant.",
    traceId: "R\xE9f\xE9rence technique\xA0: {traceId}",
    BAD_REQUEST: "La demande n'est pas valide.",
    VALIDATION_FAILED: "Certains champs ne sont pas valides. Corrigez-les puis r\xE9essayez.",
    NOT_FOUND: "Cet \xE9l\xE9ment n'existe pas ou vous n'y avez pas acc\xE8s.",
    PAYLOAD_TOO_LARGE: "Le contenu envoy\xE9 est trop volumineux.",
    UNSUPPORTED_MEDIA_TYPE: "Ce format n'est pas accept\xE9.",
    RATE_LIMITED: "Trop de demandes. Patientez quelques secondes puis r\xE9essayez.",
    INTERNAL_ERROR: "Une erreur inattendue s'est produite. R\xE9essayez dans un instant.",
    SERVICE_UNAVAILABLE: "Le service est momentan\xE9ment indisponible. R\xE9essayez dans un instant.",
    SESSION_EXPIRED: "Votre session a expir\xE9. Reconnectez-vous.",
    CSRF_INVALID: "La page n'est plus \xE0 jour. Rechargez-la puis r\xE9essayez.",
    MFA_REQUIRED: "Votre r\xF4le exige la double authentification. Activez-la pour continuer.",
    STEP_UP_REQUIRED: "Confirmez votre identit\xE9 pour effectuer cette action.",
    FORBIDDEN: "Vous n'avez pas l'autorisation d'effectuer cette action.",
    PLAN_LIMIT_REACHED: "Votre offre ne permet pas cette action. Passez \xE0 une offre sup\xE9rieure ou contactez le propri\xE9taire du compte.",
    ORGANIZATION_READ_ONLY: "Le compte de votre bureau est en lecture seule. Le propri\xE9taire doit r\xE9gulariser l'abonnement.",
    STALE_VERSION: "Cet \xE9l\xE9ment a \xE9t\xE9 modifi\xE9 par quelqu'un d'autre. Rechargez-le puis appliquez \xE0 nouveau vos changements.",
    PRECONDITION_REQUIRED: "La version de l'\xE9l\xE9ment est manquante. Rechargez la page.",
    IDEMPOTENCY_KEY_REUSED: "Cette action a d\xE9j\xE0 \xE9t\xE9 envoy\xE9e avec un contenu diff\xE9rent.",
    FILE_TYPE_NOT_ALLOWED: "Ce type de fichier n'est pas accept\xE9.",
    FILE_TOO_LARGE: "Ce fichier d\xE9passe la taille maximale autoris\xE9e.",
    QUOTA_EXCEEDED: "L'espace de stockage de votre offre est plein.",
    PHASE_HAS_UNAPPROVED_DELIVERABLES: "Cette phase a encore des livrables non vis\xE9s.",
    INVOICE_ALREADY_ISSUED: "Cette facture est d\xE9j\xE0 \xE9mise et ne peut plus \xEAtre modifi\xE9e.",
    COMPUTATION_CHANGED: "Les montants ont chang\xE9 depuis l'aper\xE7u. V\xE9rifiez-les avant d'\xE9mettre.",
    DOCUMENT_LOCKED: "Ce document est en cours de visa et ne peut pas recevoir de nouvelle version.",
    LEGAL_HOLD: "Ce document doit \xEAtre conserv\xE9 (obligation l\xE9gale) et ne peut pas \xEAtre supprim\xE9.",
    DEPENDENCY_CYCLE: "Cette d\xE9pendance cr\xE9erait une boucle entre les t\xE2ches.",
    ALREADY_A_MEMBER: "Cette personne fait d\xE9j\xE0 partie de votre bureau.",
    INVITATION_ALREADY_PENDING: "Une invitation est d\xE9j\xE0 en attente pour cette adresse.",
    INVITATION_NO_LONGER_VALID: "Cette invitation n'est plus valable\xA0: elle a expir\xE9, a \xE9t\xE9 annul\xE9e ou a d\xE9j\xE0 \xE9t\xE9 utilis\xE9e.",
    INVITATION_EMAIL_MISMATCH: "Cette invitation est destin\xE9e \xE0 une autre adresse e-mail que celle de votre compte.",
    EMAIL_NOT_VERIFIED: "Confirmez d'abord votre adresse e-mail.",
    EVENT_READ_ONLY: "Cette \xE9ch\xE9ance vient d'une t\xE2che, d'une phase ou d'un visa\xA0: modifiez-la \xE0 sa source.",
    MEMBER_CAP_REACHED: "Le nombre maximum de personnes de ce partenariat est atteint.",
    SCOPE_EXCEEDS_PARTNERSHIP: "Ces dossiers ou ces canaux d\xE9passent ce que le partenariat permet.",
    RIGHTS_EXCEED_PARTNERSHIP: "Ces droits d\xE9passent ceux du partenariat.",
    DELEGATE_NOT_A_MEMBER: "Cette personne ne fait pas partie de votre organisation.",
    PARTNERSHIP_ALREADY_EXISTS: "Cette organisation est d\xE9j\xE0 partenaire de cet espace ou a d\xE9j\xE0 une invitation en attente.",
    SPACE_CLOSED: "Cet espace est ferm\xE9 : il n'est plus possible de le modifier.",
    GUEST_DOMAIN_NOT_ALLOWED: "Les invit\xE9s de cet espace ne peuvent pas venir de ce domaine d'adresse e-mail.",
    ALREADY_SPACE_MEMBER: "Cette personne a d\xE9j\xE0 acc\xE8s \xE0 cet espace.",
    QUOTE_LOCKED: "Ce devis a \xE9t\xE9 accept\xE9 ou refus\xE9 : il ne peut plus \xEAtre modifi\xE9.",
    QUOTE_EXPIRED: "Ce devis n\u2019est plus valable. Demandez une nouvelle proposition au bureau.",
    QUOTE_NOT_ACCEPTED: "Ce devis n\u2019a pas encore \xE9t\xE9 accept\xE9 par le client.",
    CONTRACT_REFERENCE_TAKEN: "Un autre contrat porte d\xE9j\xE0 cette r\xE9f\xE9rence.",
    CONTRACT_EXISTS_FOR_QUOTE: "Un contrat a d\xE9j\xE0 \xE9t\xE9 cr\xE9\xE9 \xE0 partir de ce devis.",
    PDF_NOT_READY: "Le PDF est en cours de pr\xE9paration. R\xE9essayez dans quelques secondes.",
    INVOICE_NOT_ISSUED: "Cette facture n\u2019est pas encore \xE9mise.",
    CREDIT_EXCEEDS_INVOICE: "L\u2019avoir d\xE9passe le montant restant de la facture.",
    OVERPAYMENT: "Ce paiement d\xE9passe le montant restant d\xFB.",
    PERIOD_CLOSED: "Cette p\xE9riode comptable est cl\xF4tur\xE9e : l\u2019op\xE9ration n\u2019est plus possible pour une date de ce mois. Utilisez un mois ouvert ou faites rouvrir le mois.",
    PERIOD_IN_FUTURE: "Ce mois n\u2019a pas encore commenc\xE9 : seul un mois en cours ou pass\xE9 peut \xEAtre cl\xF4tur\xE9.",
    ACCOUNTING_EXPORT_NOT_READY: "Le fichier est encore en pr\xE9paration. R\xE9essayez dans quelques secondes.",
    EXPENSE_INVALID_TRANSITION: "Cette note de frais n\u2019est plus dans l\u2019\xE9tat attendu pour cette action. Rechargez la page.",
    EXPENSE_SELF_APPROVAL: "Vous ne pouvez pas d\xE9cider de votre propre note de frais : un autre approbateur doit s\u2019en charger.",
    RECEIPT_NOT_READY: "Le justificatif est en cours de v\xE9rification. R\xE9essayez dans quelques secondes.",
    SIGNING_CREDENTIAL_INVALID: "Le certificat ou la cl\xE9 priv\xE9e n\u2019est pas valide. V\xE9rifiez les fichiers puis r\xE9essayez.",
    SIGNING_KEY_MISMATCH: "La cl\xE9 priv\xE9e ne correspond pas au certificat.",
    SIGNING_CREDENTIAL_EXPIRED: "Ce certificat est expir\xE9. Ajoutez un certificat encore valable.",
    SIGNING_CREDENTIAL_DUPLICATE: "Ce certificat est d\xE9j\xE0 enregistr\xE9 pour votre bureau.",
    EINVOICE_NOT_RESUBMITTABLE: "Cette facture ne peut pas \xEAtre renvoy\xE9e \xE0 TTN dans son \xE9tat actuel.",
    EINVOICE_ALREADY_FINAL: "Cette facture a d\xE9j\xE0 \xE9t\xE9 accept\xE9e par TTN\xA0: elle ne peut plus \xEAtre renvoy\xE9e.",
    EINVOICE_NOT_REQUIRED: "Cette facture n\u2019est pas concern\xE9e par la facturation \xE9lectronique.",
    TEIF_NOT_READY: "Le fichier TEIF n\u2019est pas encore pr\xEAt. R\xE9essayez dans quelques secondes.",
    PLAN_ON_QUOTE: "Ce forfait est vendu sur devis. Contactez l\u2019\xE9quipe commerciale de BatiFlow.",
    SUBSCRIPTION_DOWNGRADE_BLOCKED: "Ce forfait est trop petit pour votre usage actuel. R\xE9duisez d\u2019abord ce qui est indiqu\xE9, puis r\xE9essayez.",
    SUBSCRIPTION_INVALID_STATE: "Votre abonnement n\u2019est pas dans l\u2019\xE9tat attendu pour cette action. Rechargez la page.",
    SUBSCRIPTION_INVOICE_PENDING: "Une facture d\u2019abonnement attend d\xE9j\xE0 son paiement. R\xE9glez-la avant de faire un autre changement.",
    PAUSE_LIMIT_REACHED: "Vous avez d\xE9j\xE0 utilis\xE9 les 3 mois de pause permis cette ann\xE9e.",
    BILLING_INVOICE_NOT_OPEN: "Cette facture est d\xE9j\xE0 r\xE9gl\xE9e ou annul\xE9e.",
    PAYMENT_PROVIDER_UNAVAILABLE: "Le service de paiement en ligne ne r\xE9pond pas. R\xE9essayez dans quelques minutes ou payez par virement.",
    WEBHOOK_SIGNATURE_INVALID: "La notification de paiement n\u2019est pas authentique.",
    WEBAUTHN_REQUIRED: "Connectez-vous avec votre cl\xE9 de s\xE9curit\xE9 (WebAuthn) pour acc\xE9der \xE0 l\u2019administration de la plateforme.",
    BREAK_GLASS_SELF_APPROVAL: "Un autre administrateur doit approuver cette demande d\u2019acc\xE8s.",
    BREAK_GLASS_INVALID_STATE: "Cette demande d\u2019acc\xE8s n\u2019est plus dans l\u2019\xE9tat attendu. Rechargez la page.",
    SUPPORT_IDENTITY_MISSING: "Votre compte support n\u2019est pas encore reli\xE9 : demandez \xE0 un administrateur de le configurer.",
    PAYMENT_ALREADY_CONFIRMED: "Cette facture est d\xE9j\xE0 r\xE9gl\xE9e.",
    ORGANIZATION_CLOSED: "Cette organisation est cl\xF4tur\xE9e : son abonnement ne peut plus \xEAtre modifi\xE9.",
    EXPORT_REQUIRED: "Avant de demander la suppression, t\xE9l\xE9chargez un export complet de l\u2019organisation (de moins de 30 jours) ou indiquez que vous n\u2019en voulez pas.",
    EXPORT_NOT_READY: "Cet export n\u2019est pas disponible : il est en pr\xE9paration, a \xE9chou\xE9 ou a expir\xE9. Demandez-en un nouveau.",
    EXPORT_IN_PROGRESS: "Un export de ce type est d\xE9j\xE0 en pr\xE9paration. Vous serez pr\xE9venu d\xE8s qu\u2019il sera pr\xEAt.",
    DELETION_ALREADY_SCHEDULED: "La suppression de cette organisation est d\xE9j\xE0 programm\xE9e.",
    DELETION_NOT_SCHEDULED: "Aucune suppression annulable n\u2019est programm\xE9e. Une suppression li\xE9e \xE0 un impay\xE9 s\u2019arr\xEAte d\xE8s que l\u2019abonnement est r\xE9gl\xE9.",
    CONFIRMATION_MISMATCH: "Le nom saisi ne correspond pas \xE0 la raison sociale de l\u2019organisation.",
    ROLE_ESCALATION: "Vous ne pouvez pas accorder des droits que vous n'avez pas vous-m\xEAme.",
    ROLE_IN_USE: "Ce r\xF4le est encore attribu\xE9 \xE0 des membres ou \xE0 des invitations en attente. Changez d'abord leur r\xF4le.",
    MEMBERSHIP_SUSPENDED: "Votre acc\xE8s \xE0 cette organisation est suspendu par le support BatiFlow. Contactez le support.",
    MEMBER_STATE_INVALID: "Ce membre n\u2019est pas dans l\u2019\xE9tat voulu pour cette action. Rechargez la page.",
    OWNER_PROTECTED: "Le propri\xE9taire ne peut pas \xEAtre retir\xE9 : transf\xE9rez d\u2019abord la propri\xE9t\xE9 de l\u2019organisation.",
    ACCOUNT_NOT_DELETABLE: "Ce compte ne peut pas encore \xEAtre supprim\xE9 : il poss\xE8de une organisation ou sert d\u2019identit\xE9 de support.",
    PLATFORM_ORGANIZATION_PROTECTED: "L\u2019organisation de la plateforme ne peut pas \xEAtre supprim\xE9e.",
    DELETION_ALREADY_REQUESTED: "Une suppression de cette organisation attend d\xE9j\xE0 une d\xE9cision.",
    DELETION_SELF_APPROVAL: "Un autre administrateur doit d\xE9cider de cette suppression.",
    DELETION_INVALID_STATE: "Cette demande de suppression a d\xE9j\xE0 \xE9t\xE9 trait\xE9e. Rechargez la page.",
    DELETION_PENDING: "Une suppression de cette organisation attend une d\xE9cision : le statut ne peut pas \xEAtre modifi\xE9.",
    REAUTH_REQUIRED: "Pour des raisons de s\xE9curit\xE9, confirmez votre identit\xE9 avant de changer le mot de passe.",
    PASSWORD_POLICY: "Ce mot de passe n\u2019est pas accept\xE9 : 12 caract\xE8res au moins, diff\xE9rent de votre adresse e-mail et de vos 5 derniers mots de passe.",
    LAST_SECOND_FACTOR: "La v\xE9rification en deux \xE9tapes est obligatoire dans votre organisation : ajoutez une autre m\xE9thode avant de retirer celle-ci.",
    SIGNATURE_NOT_PENDING: "Cette demande n\u2019attend plus de signature\xA0: elle est termin\xE9e, refus\xE9e ou annul\xE9e.",
    SIGNATURE_EXPIRED: "Cette demande a expir\xE9\xA0: elle ne peut plus \xEAtre sign\xE9e. Demandez-en une nouvelle.",
    SIGNATURE_CODE_INVALID: "Ce code n\u2019est pas le bon. V\xE9rifiez-le dans le message re\xE7u puis r\xE9essayez. Apr\xE8s quelques erreurs, il faudra demander un nouveau code.",
    SIGNATURE_CODE_LOCKED: "Ce code ne peut plus \xEAtre utilis\xE9 (trop d\u2019essais ou code expir\xE9). Demandez un nouveau code.",
    SIGNATURE_CODE_TOO_SOON: "Un code vient d\u2019\xEAtre envoy\xE9. Patientez une minute avant d\u2019en demander un nouveau.",
    SIGNATURE_DOCUMENT_NOT_READY: "Le fichier de ce document est encore en cours de v\xE9rification. R\xE9essayez dans quelques instants.",
    SIGNATURE_SIGNER_INVALID: "Un des signataires ne peut pas \xEAtre retenu\xA0: il doit \xEAtre un membre actif de votre bureau et pouvoir lire ce document. Modifiez la liste puis r\xE9essayez.",
    SIGNATURE_EVIDENCE_NOT_READY: "Le certificat de preuve est encore en pr\xE9paration. R\xE9essayez dans quelques secondes.",
    SIGNATURE_PROVIDER_FAILED: "La plateforme de signature n\u2019a pas r\xE9pondu comme pr\xE9vu. Rien n\u2019a \xE9t\xE9 sign\xE9\xA0: r\xE9essayez dans un instant.",
    DIGIGO_NOTHING_TO_SIGN: "Aucune facture n\u2019attend de signature DigiGO pour le moment.",
    DIGIGO_NO_CREDENTIAL: "Aucun compte DigiGO n\u2019est actif pour votre bureau. Ajoutez-le dans Facture \xE9lectronique, certificats de signature.",
    SIGNING_BATCH_NOT_PENDING: "Ce lot n\u2019attend plus de code\xA0: il est d\xE9j\xE0 sign\xE9, expir\xE9 ou annul\xE9. Relancez \xAB\xA0Signer le lot\xA0\xBB."
  },
  taxId: {
    EMPTY: "Saisissez le matricule fiscal.",
    FORMAT: "Format attendu\xA0: 1234567 A / A / M / 000.",
    INCOMPLETE: "Matricule incomplet\xA0: ajoutez le code TVA, la cat\xE9gorie et le num\xE9ro d'\xE9tablissement.",
    CHECK_LETTER: "La lettre de contr\xF4le n'est pas valide (I, O et U ne sont jamais utilis\xE9es).",
    VAT_CODE: "Le code TVA doit \xEAtre A, P, B, D ou N.",
    CATEGORY: "La cat\xE9gorie doit \xEAtre M, P, C, N ou E.",
    ESTABLISHMENT: "Le num\xE9ro d'\xE9tablissement doit comporter 3 chiffres."
  },
  holidays: {
    new_year: "Jour de l'an",
    independence_day: "F\xEAte de l'ind\xE9pendance",
    martyrs_day: "Journ\xE9e des martyrs",
    labour_day: "F\xEAte du travail",
    republic_day: "F\xEAte de la R\xE9publique",
    womens_day: "F\xEAte de la femme",
    evacuation_day: "F\xEAte de l'\xE9vacuation",
    revolution_day: "F\xEAte de la r\xE9volution",
    eid_al_fitr_1: "A\xEFd el-Fitr",
    eid_al_fitr_2: "A\xEFd el-Fitr (2e jour)",
    eid_al_adha_1: "A\xEFd el-Idha",
    eid_al_adha_2: "A\xEFd el-Idha (2e jour)",
    islamic_new_year: "Ras el-Am el-Hejri",
    mawlid: "Mouled"
  }
};

// locales/ar/web.json
var web_default = {
  session: {
    loading: "\u062C\u0627\u0631\u064D \u062A\u062D\u0645\u064A\u0644 \u0645\u0633\u0627\u062D\u0629 \u0639\u0645\u0644\u0643\u2026",
    redirecting: "\u062C\u0627\u0631\u064D \u0627\u0644\u062A\u062D\u0648\u064A\u0644 \u0625\u0644\u0649 \u0635\u0641\u062D\u0629 \u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062F\u062E\u0648\u0644\u2026"
  },
  unavailable: {
    title: "\u062E\u062F\u0645\u0629 \u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062F\u062E\u0648\u0644 \u063A\u064A\u0631 \u0645\u062A\u0627\u062D\u0629 \u0628\u0639\u062F",
    body: "\u0644\u0627 \u064A\u0645\u0643\u0646\u0646\u0627 \u0627\u0644\u062A\u062D\u0642\u0642 \u0645\u0646 \u062C\u0644\u0633\u062A\u0643 \u062D\u0627\u0644\u064A\u064B\u0627. \u0628\u064A\u0627\u0646\u0627\u062A\u0643 \u0628\u0623\u0645\u0627\u0646. \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629 \u0628\u0639\u062F \u0642\u0644\u064A\u0644\u060C \u0648\u0625\u0630\u0627 \u0627\u0633\u062A\u0645\u0631\u062A \u0627\u0644\u0645\u0634\u0643\u0644\u0629 \u0641\u062A\u0648\u0627\u0635\u0644 \u0645\u0639 \u0627\u0644\u062F\u0639\u0645."
  },
  notFound: {
    title: "\u0647\u0630\u0647 \u0627\u0644\u0635\u0641\u062D\u0629 \u063A\u064A\u0631 \u0645\u0648\u062C\u0648\u062F\u0629",
    body: "\u0631\u0628\u0645\u0627 \u064A\u0643\u0648\u0646 \u0627\u0644\u0631\u0627\u0628\u0637 \u0642\u062F\u064A\u0645\u064B\u0627 \u0623\u0648 \u0628\u0647 \u062E\u0637\u0623 \u0641\u064A \u0627\u0644\u0643\u062A\u0627\u0628\u0629. \u0639\u062F \u0625\u0644\u0649 \u0627\u0644\u0635\u0641\u062D\u0629 \u0627\u0644\u0631\u0626\u064A\u0633\u064A\u0629 \u0644\u0644\u0645\u062A\u0627\u0628\u0639\u0629.",
    home: "\u0627\u0644\u0639\u0648\u062F\u0629 \u0625\u0644\u0649 \u0627\u0644\u0631\u0626\u064A\u0633\u064A\u0629"
  },
  error: {
    title: "\u062D\u062F\u062B\u062A \u0645\u0634\u0643\u0644\u0629",
    body: "\u062A\u0639\u0630\u0651\u0631 \u0639\u0631\u0636 \u0647\u0630\u0647 \u0627\u0644\u0635\u0641\u062D\u0629. \u0628\u064A\u0627\u0646\u0627\u062A\u0643 \u0628\u0623\u0645\u0627\u0646. \u0623\u0639\u062F \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0635\u0641\u062D\u0629\u060C \u0648\u0625\u0630\u0627 \u0627\u0633\u062A\u0645\u0631\u062A \u0627\u0644\u0645\u0634\u0643\u0644\u0629 \u0641\u0623\u0631\u0633\u0644 \u0627\u0644\u062A\u0641\u0627\u0635\u064A\u0644 \u0627\u0644\u062A\u0642\u0646\u064A\u0629 \u0625\u0644\u0649 \u0627\u0644\u062F\u0639\u0645.",
    reload: "\u0625\u0639\u0627\u062F\u0629 \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0635\u0641\u062D\u0629",
    details: "\u0627\u0644\u062A\u0641\u0627\u0635\u064A\u0644 \u0627\u0644\u062A\u0642\u0646\u064A\u0629",
    noTrace: "\u063A\u064A\u0631 \u0645\u062A\u0648\u0641\u0631",
    release: "\u0627\u0644\u0625\u0635\u062F\u0627\u0631: {release}",
    copied: "\u062A\u0645 \u0646\u0633\u062E \u0627\u0644\u062A\u0641\u0627\u0635\u064A\u0644 \u0625\u0644\u0649 \u0627\u0644\u062D\u0627\u0641\u0638\u0629.",
    copyFailed: "\u062A\u0639\u0630\u0651\u0631 \u0627\u0644\u0646\u0633\u062E. \u062D\u062F\u0651\u062F \u0627\u0644\u0646\u0635 \u0623\u0639\u0644\u0627\u0647 \u0644\u0646\u0633\u062E\u0647 \u064A\u062F\u0648\u064A\u064B\u0627."
  },
  onboarding: {
    title: "\u0645\u0631\u062D\u0628\u064B\u0627 \u0628\u0643 \u0641\u064A BatiFlow",
    body: "\u0623\u0646\u0634\u0626 \u0645\u0644\u0641 \u0645\u0643\u062A\u0628 \u062F\u0631\u0627\u0633\u0627\u062A\u0643 \u0641\u064A \u0628\u0636\u0639 \u062F\u0642\u0627\u0626\u0642. \u0633\u062A\u0643\u0648\u0646 \u0645\u0627\u0644\u0643\u0647 \u0648\u062A\u0633\u062A\u0641\u064A\u062F \u0645\u0646 \u0641\u062A\u0631\u0629 \u062A\u062C\u0631\u064A\u0628\u064A\u0629 \u0644\u0639\u0631\u0636 Pro \u0645\u062F\u062A\u0647\u0627 14 \u064A\u0648\u0645\u064B\u0627.",
    hint: "\u0625\u0630\u0627 \u0643\u0627\u0646 \u0645\u0643\u062A\u0628 \u0627\u0644\u062F\u0631\u0627\u0633\u0627\u062A \u0627\u0644\u0630\u064A \u062A\u0639\u0645\u0644 \u0641\u064A\u0647 \u064A\u0633\u062A\u0639\u0645\u0644 BatiFlow\u060C \u0641\u0627\u0637\u0644\u0628 \u062F\u0639\u0648\u0629 \u0645\u0646 \u0645\u0634\u0631\u0641\u0647 \u0628\u062F\u0644 \u0625\u0646\u0634\u0627\u0621 \u0645\u0624\u0633\u0633\u0629 \u062C\u062F\u064A\u062F\u0629.",
    stepCounter: "\u0627\u0644\u062E\u0637\u0648\u0629 {current} \u0645\u0646 {total}",
    steps: {
      identity: {
        title: "\u0647\u0648\u064A\u0629 \u0627\u0644\u0645\u0643\u062A\u0628",
        description: "\u062A\u0638\u0647\u0631 \u0647\u0630\u0647 \u0627\u0644\u0645\u0639\u0644\u0648\u0645\u0627\u062A \u0641\u064A \u0648\u062B\u0627\u0626\u0642\u0643 \u0627\u0644\u0631\u0633\u0645\u064A\u0629."
      },
      disciplines: {
        title: "\u0627\u0644\u0627\u062E\u062A\u0635\u0627\u0635\u0627\u062A",
        description: "\u062D\u062F\u0651\u062F \u0627\u0644\u0627\u062E\u062A\u0635\u0627\u0635\u0627\u062A \u0627\u0644\u062A\u064A \u064A\u0645\u0627\u0631\u0633\u0647\u0627 \u0645\u0643\u062A\u0628 \u062F\u0631\u0627\u0633\u0627\u062A\u0643."
      },
      address: {
        title: "\u0627\u0644\u0639\u0646\u0648\u0627\u0646 \u0648\u0627\u0644\u0648\u0644\u0627\u064A\u0629",
        description: "\u0623\u062F\u062E\u0644 \u0639\u0646\u0648\u0627\u0646 \u0645\u0642\u0631\u0651 \u0645\u0643\u062A\u0628\u0643."
      },
      summary: {
        title: "\u0627\u0644\u0645\u0644\u062E\u0651\u0635",
        description: "\u0631\u0627\u062C\u0639 \u0647\u0630\u0647 \u0627\u0644\u0645\u0639\u0644\u0648\u0645\u0627\u062A \u0642\u0628\u0644 \u0625\u0646\u0634\u0627\u0621 \u0645\u0624\u0633\u0633\u062A\u0643."
      }
    },
    fields: {
      legalName: {
        label: "\u0627\u0644\u0627\u0633\u0645 \u0627\u0644\u0642\u0627\u0646\u0648\u0646\u064A",
        hint: "\u0627\u0644\u0627\u0633\u0645 \u0627\u0644\u0631\u0633\u0645\u064A \u0644\u0645\u0643\u062A\u0628\u0643 \u0643\u0645\u0627 \u0647\u0648 \u0645\u0633\u062C\u0651\u0644 \u0641\u064A \u0627\u0644\u0633\u062C\u0644 \u0627\u0644\u062A\u062C\u0627\u0631\u064A."
      },
      tradeName: {
        label: "\u0627\u0644\u0627\u0633\u0645 \u0627\u0644\u062A\u062C\u0627\u0631\u064A (\u0627\u062E\u062A\u064A\u0627\u0631\u064A)",
        hint: "\u0627\u0644\u0627\u0633\u0645 \u0627\u0644\u0630\u064A \u064A\u0639\u0631\u0641\u0643 \u0628\u0647 \u062D\u0631\u0641\u0627\u0624\u0643."
      },
      legalForm: {
        label: "\u0627\u0644\u0634\u0643\u0644 \u0627\u0644\u0642\u0627\u0646\u0648\u0646\u064A",
        placeholder: "\u0627\u062E\u062A\u0631 \u0627\u0644\u0634\u0643\u0644 \u0627\u0644\u0642\u0627\u0646\u0648\u0646\u064A"
      },
      taxId: {
        label: "\u0627\u0644\u0645\u0639\u0631\u0651\u0641 \u0627\u0644\u062C\u0628\u0627\u0626\u064A",
        hint: "\u0633\u062A\u062C\u062F\u0647 \u0641\u064A \u0634\u0647\u0627\u062F\u0629 \u0627\u0644\u0648\u062C\u0648\u062F \u0627\u0644\u062E\u0627\u0635\u0629 \u0628\u0645\u0643\u062A\u0628\u0643."
      },
      disciplines: {
        legend: "\u0627\u062E\u062A\u0635\u0627\u0635\u0627\u062A \u0627\u0644\u0645\u0643\u062A\u0628",
        hint: "\u064A\u0645\u0643\u0646\u0643 \u0627\u062E\u062A\u064A\u0627\u0631 \u0623\u0643\u062B\u0631 \u0645\u0646 \u0627\u062E\u062A\u0635\u0627\u0635."
      },
      line1: {
        label: "\u0627\u0644\u0639\u0646\u0648\u0627\u0646"
      },
      line2: {
        label: "\u062A\u062A\u0645\u0629 \u0627\u0644\u0639\u0646\u0648\u0627\u0646 (\u0627\u062E\u062A\u064A\u0627\u0631\u064A)"
      },
      city: {
        label: "\u0627\u0644\u0645\u062F\u064A\u0646\u0629"
      },
      postalCode: {
        label: "\u0627\u0644\u0631\u0645\u0632 \u0627\u0644\u0628\u0631\u064A\u062F\u064A"
      },
      governorate: {
        label: "\u0627\u0644\u0648\u0644\u0627\u064A\u0629",
        placeholder: "\u0627\u062E\u062A\u0631 \u0627\u0644\u0648\u0644\u0627\u064A\u0629"
      }
    },
    summary: {
      notProvided: "\u063A\u064A\u0631 \u0645\u0630\u0643\u0648\u0631"
    },
    actions: {
      create: "\u0625\u0646\u0634\u0627\u0621 \u0645\u0624\u0633\u0633\u062A\u064A",
      creating: "\u062C\u0627\u0631\u064D \u0627\u0644\u0625\u0646\u0634\u0627\u0621\u2026"
    },
    errors: {
      legalNameRequired: "\u0623\u062F\u062E\u0644 \u0627\u0644\u0627\u0633\u0645 \u0627\u0644\u0642\u0627\u0646\u0648\u0646\u064A \u0644\u0645\u0643\u062A\u0628\u0643.",
      tooLong: "\u0644\u0627 \u064A\u0645\u0643\u0646 \u0623\u0646 \u064A\u062A\u062C\u0627\u0648\u0632 \u0647\u0630\u0627 \u0627\u0644\u062D\u0642\u0644 {max} \u062D\u0631\u0641\u064B\u0627.",
      legalFormRequired: "\u0627\u062E\u062A\u0631 \u0627\u0644\u0634\u0643\u0644 \u0627\u0644\u0642\u0627\u0646\u0648\u0646\u064A.",
      disciplinesRequired: "\u0627\u062E\u062A\u0631 \u0627\u062E\u062A\u0635\u0627\u0635\u064B\u0627 \u0648\u0627\u062D\u062F\u064B\u0627 \u0639\u0644\u0649 \u0627\u0644\u0623\u0642\u0644.",
      line1Required: "\u0623\u062F\u062E\u0644 \u0639\u0646\u0648\u0627\u0646 \u0645\u0643\u062A\u0628\u0643.",
      cityRequired: "\u0623\u062F\u062E\u0644 \u0627\u0644\u0645\u062F\u064A\u0646\u0629.",
      postalCodeRequired: "\u0623\u062F\u062E\u0644 \u0627\u0644\u0631\u0645\u0632 \u0627\u0644\u0628\u0631\u064A\u062F\u064A.",
      postalCodeFormat: "\u0623\u062F\u062E\u0644 \u0631\u0645\u0632\u064B\u0627 \u0628\u0631\u064A\u062F\u064A\u064B\u0627 \u0635\u062D\u064A\u062D\u064B\u0627\u060C \u0645\u062B\u0644 1002.",
      governorateRequired: "\u0627\u062E\u062A\u0631 \u0627\u0644\u0648\u0644\u0627\u064A\u0629.",
      taxIdTaken: "\u0647\u0630\u0627 \u0627\u0644\u0645\u0639\u0631\u0651\u0641 \u0627\u0644\u062C\u0628\u0627\u0626\u064A \u0645\u0633\u062A\u0639\u0645\u0644 \u0628\u0627\u0644\u0641\u0639\u0644 \u0645\u0646 \u0637\u0631\u0641 \u0645\u0643\u062A\u0628 \u0639\u0644\u0649 BatiFlow. \u0627\u0637\u0644\u0628 \u0645\u0646 \u0645\u0627\u0644\u0643\u0647 \u0623\u0646 \u064A\u062F\u0639\u0648\u0643.",
      fieldInvalid: "\u0647\u0630\u0647 \u0627\u0644\u0642\u064A\u0645\u0629 \u063A\u064A\u0631 \u0645\u0642\u0628\u0648\u0644\u0629. \u062A\u062D\u0642\u0651\u0642 \u0645\u0646\u0647\u0627 \u062B\u0645 \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629.",
      submitTitle: "\u062A\u0639\u0630\u0651\u0631 \u0625\u0646\u0634\u0627\u0621 \u0627\u0644\u0645\u0624\u0633\u0633\u0629"
    }
  },
  legalForms: {
    individual: "\u0645\u0624\u0633\u0633\u0629 \u0641\u0631\u062F\u064A\u0629",
    suarl: "\u0634\u0631\u0643\u0629 \u0630\u0627\u062A \u0645\u0633\u0624\u0648\u0644\u064A\u0629 \u0645\u062D\u062F\u0648\u062F\u0629 \u0628\u0634\u0631\u064A\u0643 \u0648\u062D\u064A\u062F (SUARL)",
    sarl: "\u0634\u0631\u0643\u0629 \u0630\u0627\u062A \u0645\u0633\u0624\u0648\u0644\u064A\u0629 \u0645\u062D\u062F\u0648\u062F\u0629 (SARL)",
    sa: "\u0634\u0631\u0643\u0629 \u062E\u0641\u064A\u0629 \u0627\u0644\u0627\u0633\u0645 (SA)",
    snc: "\u0634\u0631\u0643\u0629 \u0627\u0644\u062A\u0636\u0627\u0645\u0646 (SNC)",
    scs: "\u0634\u0631\u0643\u0629 \u0627\u0644\u062A\u0648\u0635\u064A\u0629 \u0627\u0644\u0628\u0633\u064A\u0637\u0629 (SCS)",
    gie: "\u0645\u062C\u0645\u0651\u0639 \u0645\u0635\u0644\u062D\u0629 \u0627\u0642\u062A\u0635\u0627\u062F\u064A\u0629 (GIE)",
    other: "\u0623\u062E\u0631\u0649"
  },
  governorates: {
    tunis: "\u062A\u0648\u0646\u0633",
    ariana: "\u0623\u0631\u064A\u0627\u0646\u0629",
    ben_arous: "\u0628\u0646 \u0639\u0631\u0648\u0633",
    manouba: "\u0645\u0646\u0648\u0628\u0629",
    nabeul: "\u0646\u0627\u0628\u0644",
    zaghouan: "\u0632\u063A\u0648\u0627\u0646",
    bizerte: "\u0628\u0646\u0632\u0631\u062A",
    beja: "\u0628\u0627\u062C\u0629",
    jendouba: "\u062C\u0646\u062F\u0648\u0628\u0629",
    kef: "\u0627\u0644\u0643\u0627\u0641",
    siliana: "\u0633\u0644\u064A\u0627\u0646\u0629",
    kairouan: "\u0627\u0644\u0642\u064A\u0631\u0648\u0627\u0646",
    kasserine: "\u0627\u0644\u0642\u0635\u0631\u064A\u0646",
    sidi_bouzid: "\u0633\u064A\u062F\u064A \u0628\u0648\u0632\u064A\u062F",
    sousse: "\u0633\u0648\u0633\u0629",
    monastir: "\u0627\u0644\u0645\u0646\u0633\u062A\u064A\u0631",
    mahdia: "\u0627\u0644\u0645\u0647\u062F\u064A\u0629",
    sfax: "\u0635\u0641\u0627\u0642\u0633",
    gafsa: "\u0642\u0641\u0635\u0629",
    tozeur: "\u062A\u0648\u0632\u0631",
    kebili: "\u0642\u0628\u0644\u064A",
    gabes: "\u0642\u0627\u0628\u0633",
    medenine: "\u0645\u062F\u0646\u064A\u0646",
    tataouine: "\u062A\u0637\u0627\u0648\u064A\u0646"
  },
  activity: {
    title: "\u0627\u0644\u0646\u0634\u0627\u0637",
    body: "\u0633\u062A\u0638\u0647\u0631 \u0647\u0646\u0627 \u0627\u0644\u0625\u0634\u0627\u0631\u0627\u062A \u0625\u0644\u064A\u0643 \u0648\u0637\u0644\u0628\u0627\u062A \u0627\u0644\u0645\u0648\u0627\u0641\u0642\u0629 \u0648\u0627\u0644\u0645\u0647\u0627\u0645 \u0627\u0644\u0645\u0633\u0646\u062F\u0629 \u0625\u0644\u064A\u0643.",
    empty: "\u0644\u0627 \u062C\u062F\u064A\u062F \u0641\u064A \u0627\u0644\u0648\u0642\u062A \u0627\u0644\u062D\u0627\u0644\u064A.",
    setup: {
      title: "\u0623\u0643\u0645\u0644 \u0625\u0639\u062F\u0627\u062F \u0645\u0643\u062A\u0628\u0643",
      intro: "\u062B\u0644\u0627\u062B \u062E\u0637\u0648\u0627\u062A \u0644\u0644\u0628\u062F\u0621 \u0639\u0644\u0649 \u0623\u0641\u0636\u0644 \u0648\u062C\u0647 \u0645\u0639 BatiFlow.",
      dismiss: "\u0625\u062E\u0641\u0627\u0621",
      dismissLabel: "\u0625\u062E\u0641\u0627\u0621 \u0628\u0637\u0627\u0642\u0629 \u0627\u0644\u0625\u0639\u062F\u0627\u062F",
      listLabel: "\u062E\u0637\u0648\u0627\u062A \u0627\u0644\u0625\u0639\u062F\u0627\u062F",
      invite: {
        title: "\u0627\u062F\u0639\u064F \u0641\u0631\u064A\u0642\u0643",
        description: "\u0623\u0636\u0641 \u0627\u0644\u0645\u0647\u0646\u062F\u0633\u064A\u0646 \u0648\u0627\u0644\u0631\u0633\u0651\u0627\u0645\u064A\u0646 \u0648\u0628\u0642\u064A\u0629 \u0627\u0644\u0645\u062A\u0639\u0627\u0648\u0646\u064A\u0646.",
        action: "\u062F\u0639\u0648\u0629"
      },
      clients: {
        title: "\u0623\u0636\u0641 \u062D\u0631\u064A\u0641\u064B\u0627",
        description: "\u0633\u062C\u0651\u0644 \u0623\u0635\u062D\u0627\u0628 \u0627\u0644\u0645\u0634\u0627\u0631\u064A\u0639 \u0644\u062A\u062C\u062F\u0647\u0645 \u0641\u064A \u0645\u0634\u0627\u0631\u064A\u0639\u0643.",
        action: "\u0625\u0636\u0627\u0641\u0629 \u062D\u0631\u064A\u0641"
      },
      project: {
        title: "\u0623\u0646\u0634\u0626 \u0645\u0634\u0631\u0648\u0639\u064B\u0627",
        description: "\u0627\u0628\u062F\u0623 \u0645\u0644\u0641 \u062F\u0631\u0627\u0633\u062A\u0643 \u0627\u0644\u0623\u0648\u0644.",
        action: "\u0625\u0646\u0634\u0627\u0621 \u0645\u0634\u0631\u0648\u0639"
      }
    }
  },
  comingSoon: {
    body: "\u0633\u064A\u062A\u0648\u0641\u0631 \u0641\u064A \u0625\u0635\u062F\u0627\u0631 \u0642\u0627\u062F\u0645 \u0645\u0646 BatiFlow. \u0648\u0625\u0644\u0649 \u0630\u0644\u0643 \u0627\u0644\u062D\u064A\u0646\u060C \u062A\u0627\u0628\u0639 \u0627\u0644\u0645\u0633\u062A\u062C\u062F\u0627\u062A \u0641\u064A \u0635\u0641\u062D\u0629 \u0627\u0644\u0646\u0634\u0627\u0637.",
    title: "\u0647\u0630\u0627 \u0627\u0644\u0642\u0633\u0645 \u0642\u0627\u062F\u0645 \u0642\u0631\u064A\u0628\u064B\u0627",
    backToActivity: "\u0627\u0644\u0627\u0646\u062A\u0642\u0627\u0644 \u0625\u0644\u0649 \u0627\u0644\u0646\u0634\u0627\u0637"
  },
  search: {
    close: "\u0625\u063A\u0644\u0627\u0642"
  },
  signOut: {
    failed: "\u062A\u0639\u0630\u0651\u0631 \u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062E\u0631\u0648\u062C. \u0623\u063A\u0644\u0642 \u0645\u062A\u0635\u0641\u062D\u0643 \u0644\u0625\u0646\u0647\u0627\u0621 \u0627\u0644\u062C\u0644\u0633\u0629 \u0628\u0623\u0645\u0627\u0646.",
    title: "\u0644\u0645 \u064A\u0643\u062A\u0645\u0644 \u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062E\u0631\u0648\u062C"
  },
  mfa: {
    title: "\u0641\u0639\u0651\u0644 \u0627\u0644\u062A\u062D\u0642\u0642 \u0628\u062E\u0637\u0648\u062A\u064A\u0646",
    body: "\u064A\u0634\u062A\u0631\u0637 \u0645\u0643\u062A\u0628 \u0627\u0644\u062F\u0631\u0627\u0633\u0627\u062A \u0627\u0644\u062A\u062D\u0642\u0642 \u0628\u062E\u0637\u0648\u062A\u064A\u0646 \u0644\u062D\u0633\u0627\u0628\u0643: \u0625\u0636\u0627\u0641\u0629 \u0625\u0644\u0649 \u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631\u060C \u062A\u064F\u062F\u062E\u0644 \u0631\u0645\u0632\u064B\u0627 \u0645\u0646 \u0633\u062A\u0629 \u0623\u0631\u0642\u0627\u0645 \u064A\u0642\u062F\u0651\u0645\u0647 \u062A\u0637\u0628\u064A\u0642 \u0645\u0635\u0627\u062F\u0642\u0629 \u0639\u0644\u0649 \u0647\u0627\u062A\u0641\u0643\u060C \u0645\u062B\u0644 Google Authenticator \u0623\u0648 Microsoft Authenticator \u0623\u0648 FreeOTP.",
    hint: "\u064A\u0633\u062A\u063A\u0631\u0642 \u0630\u0644\u0643 \u062F\u0642\u064A\u0642\u062A\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u064B\u0627. \u0623\u0628\u0642\u0650 \u0647\u0627\u062A\u0641\u0643 \u0641\u064A \u0645\u062A\u0646\u0627\u0648\u0644 \u064A\u062F\u0643.",
    setUp: "\u062A\u0641\u0639\u064A\u0644 \u0627\u0644\u0622\u0646",
    alreadyDone: "\u0641\u0639\u0651\u0644\u062A\u0647 \u0645\u0633\u0628\u0642\u064B\u0627"
  },
  stepUp: {
    reason: "\u0647\u0630\u0627 \u0627\u0644\u0625\u062C\u0631\u0627\u0621 \u0645\u062D\u0645\u064A\u0651 \u0644\u0623\u0646\u0647 \u064A\u0645\u0633\u0651 \u0628\u064A\u0627\u0646\u0627\u062A \u062D\u0633\u0627\u0633\u0629 \u0644\u0645\u0643\u062A\u0628 \u0627\u0644\u062F\u0631\u0627\u0633\u0627\u062A.",
    noSecondFactorTitle: "\u0627\u0644\u062A\u062D\u0642\u0642 \u0628\u062E\u0637\u0648\u062A\u064A\u0646 \u0645\u0637\u0644\u0648\u0628",
    noSecondFactorBody: "\u0644\u062A\u0623\u0643\u064A\u062F \u0647\u0648\u064A\u062A\u0643 \u0642\u0628\u0644 \u0647\u0630\u0627 \u0627\u0644\u0625\u062C\u0631\u0627\u0621\u060C \u0641\u0639\u0651\u0644 \u0623\u0648\u0644\u064B\u0627 \u0627\u0644\u062A\u062D\u0642\u0642 \u0628\u062E\u0637\u0648\u062A\u064A\u0646.",
    setUp: "\u062A\u0641\u0639\u064A\u0644 \u0627\u0644\u062A\u062D\u0642\u0642"
  },
  pendingAction: {
    replayed: "\u062A\u0645\u0651: \u0646\u064F\u0641\u0651\u0630 \u0625\u062C\u0631\u0627\u0624\u0643 \u0628\u0639\u062F \u062A\u0623\u0643\u064A\u062F \u0647\u0648\u064A\u062A\u0643.",
    failed: "\u062A\u0645\u0651 \u062A\u0623\u0643\u064A\u062F \u0647\u0648\u064A\u062A\u0643\u060C \u0644\u0643\u0646 \u0627\u0644\u0625\u062C\u0631\u0627\u0621 \u0644\u0645 \u064A\u0643\u062A\u0645\u0644. \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629.",
    stepUpFailed: "\u062A\u0639\u0630\u0651\u0631 \u062A\u0623\u0643\u064A\u062F \u0647\u0648\u064A\u062A\u0643. \u0644\u0645 \u064A\u064F\u063A\u064A\u064E\u0651\u0631 \u0623\u064A\u0651 \u0634\u064A\u0621."
  },
  signedOut: {
    title: "\u062A\u0645 \u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062E\u0631\u0648\u062C",
    body: "\u0623\u064F\u063A\u0644\u0642\u062A \u062C\u0644\u0633\u062A\u0643 \u0641\u064A BatiFlow \u0639\u0644\u0649 \u0647\u0630\u0627 \u0627\u0644\u062C\u0647\u0627\u0632. \u0644\u0645\u062A\u0627\u0628\u0639\u0629 \u0627\u0644\u0639\u0645\u0644\u060C \u0633\u062C\u0651\u0644 \u0627\u0644\u062F\u062E\u0648\u0644 \u0645\u0646 \u062C\u062F\u064A\u062F.",
    signIn: "\u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062F\u062E\u0648\u0644",
    reasons: {
      login_failed: {
        title: "\u0644\u0645 \u064A\u0643\u062A\u0645\u0644 \u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062F\u062E\u0648\u0644",
        body: "\u0627\u0646\u0642\u0637\u0639 \u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062F\u062E\u0648\u0644 \u0623\u0648 \u0627\u0646\u062A\u0647\u062A \u0645\u0647\u0644\u062A\u0647. \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629\u061B \u0648\u0625\u0630\u0627 \u0627\u0633\u062A\u0645\u0631\u0651\u062A \u0627\u0644\u0645\u0634\u0643\u0644\u0629 \u0641\u0627\u062A\u0635\u0644 \u0628\u0627\u0644\u062F\u0639\u0645."
      },
      cancelled: {
        title: "\u0623\u064F\u0644\u063A\u064A \u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062F\u062E\u0648\u0644",
        body: "\u0623\u0644\u063A\u064A\u062A \u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062F\u062E\u0648\u0644. \u064A\u0645\u0643\u0646\u0643 \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629 \u0645\u0646 \u062C\u062F\u064A\u062F \u0641\u064A \u0623\u064A \u0648\u0642\u062A."
      },
      email_not_verified: {
        title: "\u0623\u0643\u0651\u062F \u0628\u0631\u064A\u062F\u0643 \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A \u0623\u0648\u0644\u064B\u0627",
        body: "\u0627\u0641\u062A\u062D \u0631\u0633\u0627\u0644\u0629 BatiFlow \u0627\u0644\u062A\u064A \u0648\u0635\u0644\u062A\u0643 \u0639\u0644\u0649 \u0628\u0631\u064A\u062F\u0643 \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A \u0648\u0627\u062A\u0628\u0639 \u0631\u0627\u0628\u0637 \u0627\u0644\u062A\u0623\u0643\u064A\u062F\u060C \u062B\u0645 \u0633\u062C\u0651\u0644 \u0627\u0644\u062F\u062E\u0648\u0644 \u0645\u0646 \u062C\u062F\u064A\u062F."
      },
      account_disabled: {
        title: "\u062D\u0633\u0627\u0628\u0643 \u0645\u0642\u0641\u0644",
        body: "\u062A\u0645 \u062D\u0638\u0631 \u0627\u0644\u0648\u0635\u0648\u0644 \u0625\u0644\u0649 \u0647\u0630\u0627 \u0627\u0644\u062D\u0633\u0627\u0628 \u0645\u0646 \u0642\u0628\u0644 \u062F\u0639\u0645 BatiFlow. \u062A\u0648\u0627\u0635\u0644 \u0645\u0639 \u0627\u0644\u062F\u0639\u0645 \u0644\u0645\u0632\u064A\u062F \u0645\u0646 \u0627\u0644\u0645\u0639\u0644\u0648\u0645\u0627\u062A."
      }
    }
  },
  standalone: {
    backHome: "\u0627\u0644\u0639\u0648\u062F\u0629 \u0625\u0644\u0649 \u0627\u0644\u0631\u0626\u064A\u0633\u064A\u0629"
  },
  security: {
    title: "\u0623\u0645\u0627\u0646 \u0627\u0644\u062D\u0633\u0627\u0628",
    mfa: {
      title: "\u0627\u0644\u062A\u062D\u0642\u0642 \u0628\u062E\u0637\u0648\u062A\u064A\u0646",
      active: "\u0645\u0641\u0639\u0651\u0644",
      inactive: "\u063A\u064A\u0631 \u0645\u0641\u0639\u0651\u0644",
      activeBody: "\u062A\u0645 \u062A\u0623\u0643\u064A\u062F \u062C\u0644\u0633\u062A\u0643 \u0627\u0644\u062D\u0627\u0644\u064A\u0629 \u0628\u0639\u0627\u0645\u0644 \u062B\u0627\u0646\u064D: \u0625\u0636\u0627\u0641\u0629 \u0625\u0644\u0649 \u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631\u060C \u0623\u062F\u062E\u0644\u062A \u0631\u0645\u0632\u064B\u0627 \u0645\u0646 \u062A\u0637\u0628\u064A\u0642 \u0627\u0644\u0645\u0635\u0627\u062F\u0642\u0629 \u0623\u0648 \u0627\u0633\u062A\u0639\u0645\u0644\u062A \u0645\u0641\u062A\u0627\u062D \u0623\u0645\u0627\u0646.",
      inactiveBody: "\u064A\u0639\u062A\u0645\u062F \u062A\u0633\u062C\u064A\u0644 \u062F\u062E\u0648\u0644\u0643 \u0639\u0644\u0649 \u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631 \u0648\u062D\u062F\u0647\u0627. \u0623\u0636\u0641 \u0631\u0645\u0632\u064B\u0627 \u0645\u0646 \u0633\u062A\u0629 \u0623\u0631\u0642\u0627\u0645 \u064A\u0642\u062F\u0651\u0645\u0647 \u062A\u0637\u0628\u064A\u0642 \u0645\u0635\u0627\u062F\u0642\u0629 \u0639\u0644\u0649 \u0647\u0627\u062A\u0641\u0643 \u0644\u062D\u0645\u0627\u064A\u0629 \u062D\u0633\u0627\u0628\u0643 \u0648\u0628\u064A\u0627\u0646\u0627\u062A \u0645\u0643\u062A\u0628 \u0627\u0644\u062F\u0631\u0627\u0633\u0627\u062A \u0628\u0634\u0643\u0644 \u0623\u0641\u0636\u0644.",
      setUp: "\u062A\u0641\u0639\u064A\u0644 \u0627\u0644\u062A\u062D\u0642\u0642 \u0628\u062E\u0637\u0648\u062A\u064A\u0646",
      listLabel: "\u0637\u0631\u0642 \u0627\u0644\u062A\u062D\u0642\u0642 \u0627\u0644\u062E\u0627\u0635\u0629 \u0628\u0643",
      kind: {
        totp: "\u062A\u0637\u0628\u064A\u0642 \u0627\u0644\u0645\u0635\u0627\u062F\u0642\u0629",
        securityKey: "\u0645\u0641\u062A\u0627\u062D \u0623\u0645\u0627\u0646"
      },
      addedOn: "\u0623\u064F\u0636\u064A\u0641\u062A \u0641\u064A {date}",
      remove: "\u0625\u0632\u0627\u0644\u0629",
      removeLabel: "\u0625\u0632\u0627\u0644\u0629 {name}",
      removeTitle: "\u0625\u0632\u0627\u0644\u0629 \xAB{name}\xBB\u061F",
      removeBody: "\u0644\u0646 \u062A\u064F\u0633\u062A\u0639\u0645\u0644 \u0647\u0630\u0647 \u0627\u0644\u0637\u0631\u064A\u0642\u0629 \u0644\u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062F\u062E\u0648\u0644 \u0628\u0639\u062F \u0627\u0644\u0622\u0646. \u0644\u0644\u0623\u0645\u0627\u0646\u060C \u0633\u062A\u0624\u0643\u0651\u062F \u0647\u0648\u064A\u062A\u0643 \u0623\u0648\u0644\u0627\u064B.",
      removed: "\u062A\u0645\u062A \u0625\u0632\u0627\u0644\u0629 \xAB{name}\xBB.",
      add: "\u0625\u0636\u0627\u0641\u0629 \u062A\u0637\u0628\u064A\u0642 \u0645\u0635\u0627\u062F\u0642\u0629"
    },
    password: {
      title: "\u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631",
      body: "\u063A\u064A\u0651\u0631 \u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631 \u0647\u0646\u0627 \u062F\u0648\u0646 \u0645\u063A\u0627\u062F\u0631\u0629 BatiFlow. \u0644\u0644\u0623\u0645\u0627\u0646\u060C \u062A\u0624\u0643\u0651\u062F \u0647\u0648\u064A\u062A\u0643 \u0623\u0648\u0644\u0627\u064B.",
      updatedAt: "\u0622\u062E\u0631 \u062A\u0639\u062F\u064A\u0644: {date}",
      neverSet: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0643\u0644\u0645\u0629 \u0645\u0631\u0648\u0631 \u0644\u0647\u0630\u0627 \u0627\u0644\u062D\u0633\u0627\u0628 (\u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062F\u062E\u0648\u0644 \u0639\u0628\u0631 Google \u0623\u0648 Microsoft).",
      change: "\u062A\u063A\u064A\u064A\u0631 \u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631",
      reauthHint: "\u0633\u062A\u0624\u0643\u0651\u062F \u0647\u0648\u064A\u062A\u0643 \u0623\u0648\u0644\u0627\u064B \u0641\u064A \u0635\u0641\u062D\u0629 \u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062F\u062E\u0648\u0644 \u0625\u0644\u0649 BatiFlow\u060C \u062B\u0645 \u062A\u0639\u0648\u062F \u0625\u0644\u0649 \u0647\u0646\u0627 \u0644\u0625\u062F\u062E\u0627\u0644 \u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631 \u0627\u0644\u062C\u062F\u064A\u062F\u0629.",
      confirmIdentity: "\u062A\u0623\u0643\u064A\u062F \u0647\u0648\u064A\u062A\u064A",
      dialog: {
        title: "\u062A\u063A\u064A\u064A\u0631 \u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631",
        intro: "\u0627\u062E\u062A\u0631 \u0643\u0644\u0645\u0629 \u0645\u0631\u0648\u0631 \u0644\u0627 \u062A\u0633\u062A\u0639\u0645\u0644\u0647\u0627 \u0641\u064A \u0623\u064A \u0645\u0643\u0627\u0646 \u0622\u062E\u0631. \u0627\u0644\u0639\u0628\u0627\u0631\u0629 \u0627\u0644\u0645\u0643\u0648\u0651\u0646\u0629 \u0645\u0646 \u0639\u062F\u0629 \u0643\u0644\u0645\u0627\u062A \u0633\u0647\u0644\u0629 \u0627\u0644\u062A\u0630\u0643\u0651\u0631 \u0648\u0635\u0639\u0628\u0629 \u0627\u0644\u062A\u062E\u0645\u064A\u0646.",
        newLabel: "\u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631 \u0627\u0644\u062C\u062F\u064A\u062F\u0629",
        confirmLabel: "\u062A\u0623\u0643\u064A\u062F \u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631 \u0627\u0644\u062C\u062F\u064A\u062F\u0629",
        rules: "{min} \u062D\u0631\u0641\u064B\u0627 \u0639\u0644\u0649 \u0627\u0644\u0623\u0642\u0644\u060C \u0648\u0645\u062E\u062A\u0644\u0641\u0629 \u0639\u0646 \u0628\u0631\u064A\u062F\u0643 \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A \u0648\u0639\u0646 \u0622\u062E\u0631 5 \u0643\u0644\u0645\u0627\u062A \u0645\u0631\u0648\u0631.",
        signOutOthers: "\u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062E\u0631\u0648\u062C \u0645\u0646 \u0623\u062C\u0647\u0632\u062A\u064A \u0627\u0644\u0623\u062E\u0631\u0649",
        submit: "\u062D\u0641\u0638 \u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631",
        saving: "\u062C\u0627\u0631\u064D \u0627\u0644\u062D\u0641\u0638\u2026",
        done: "{count, plural, =0 {\u062A\u0645 \u062A\u063A\u064A\u064A\u0631 \u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631.} one {\u062A\u0645 \u062A\u063A\u064A\u064A\u0631 \u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631 \u0648\u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062E\u0631\u0648\u062C \u0645\u0646 \u062C\u0647\u0627\u0632 \u0622\u062E\u0631 \u0648\u0627\u062D\u062F.} other {\u062A\u0645 \u062A\u063A\u064A\u064A\u0631 \u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631 \u0648\u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062E\u0631\u0648\u062C \u0645\u0646 # \u0623\u062C\u0647\u0632\u0629 \u0623\u062E\u0631\u0649.}}",
        errors: {
          length: "\u064A\u062C\u0628 \u0623\u0646 \u062A\u062A\u0643\u0648\u0651\u0646 \u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631 \u0645\u0646 {min} \u0625\u0644\u0649 {max} \u062D\u0631\u0641\u064B\u0627.",
          mismatch: "\u0643\u0644\u0645\u062A\u0627 \u0627\u0644\u0645\u0631\u0648\u0631 \u063A\u064A\u0631 \u0645\u062A\u0637\u0627\u0628\u0642\u062A\u064A\u0646.",
          policy: "\u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631 \u0647\u0630\u0647 \u063A\u064A\u0631 \u0645\u0642\u0628\u0648\u0644\u0629: \u064A\u062C\u0628 \u0623\u0646 \u062A\u062A\u0643\u0648\u0651\u0646 \u0645\u0646 12 \u062D\u0631\u0641\u064B\u0627 \u0639\u0644\u0649 \u0627\u0644\u0623\u0642\u0644 \u0648\u0623\u0646 \u062A\u062E\u062A\u0644\u0641 \u0639\u0646 \u0628\u0631\u064A\u062F\u0643 \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A \u0648\u0639\u0646 \u0622\u062E\u0631 5 \u0643\u0644\u0645\u0627\u062A \u0645\u0631\u0648\u0631."
        }
      }
    },
    sessions: {
      title: "\u0627\u0644\u062C\u0644\u0633\u0627\u062A \u0627\u0644\u0646\u0634\u0637\u0629",
      intro: "\u0623\u0646\u062A \u0645\u0633\u062C\u0651\u0644 \u0627\u0644\u062F\u062E\u0648\u0644 \u0639\u0644\u0649 \u0647\u0630\u0647 \u0627\u0644\u0623\u062C\u0647\u0632\u0629. \u0623\u0646\u0647\u0650 \u0627\u0644\u062C\u0644\u0633\u0627\u062A \u0639\u0644\u0649 \u0627\u0644\u0623\u062C\u0647\u0632\u0629 \u0627\u0644\u062A\u064A \u0644\u0627 \u062A\u0639\u0631\u0641\u0647\u0627.",
      listLabel: "\u062C\u0644\u0633\u0627\u062A\u0643 \u0627\u0644\u0646\u0634\u0637\u0629",
      currentDevice: "\u0647\u0630\u0627 \u0627\u0644\u062C\u0647\u0627\u0632",
      flagged: "\u062A\u0645 \u0631\u0635\u062F \u062A\u063A\u064A\u064A\u0631",
      flaggedHint: "\u062A\u063A\u064A\u0651\u0631\u062A \u0627\u0644\u0634\u0628\u0643\u0629 \u0623\u0648 \u0627\u0644\u0645\u062A\u0635\u0641\u062D \u0623\u062B\u0646\u0627\u0621 \u0627\u0644\u062C\u0644\u0633\u0629. \u0625\u0646 \u0644\u0645 \u062A\u0643\u0646 \u0623\u0646\u062A \u0645\u0646 \u0641\u0639\u0644 \u0630\u0644\u0643\u060C \u0641\u0623\u0646\u0647\u0650 \u062C\u0644\u0633\u0629 \u0647\u0630\u0627 \u0627\u0644\u062C\u0647\u0627\u0632.",
      unknownDevice: "\u062C\u0647\u0627\u0632 \u063A\u064A\u0631 \u0645\u0639\u0631\u0648\u0641",
      lastActivity: "\u0622\u062E\u0631 \u0646\u0634\u0627\u0637:",
      network: "\u0627\u0644\u0634\u0628\u0643\u0629:",
      revoke: "\u0625\u0646\u0647\u0627\u0621 \u0627\u0644\u062C\u0644\u0633\u0629",
      revokeLabel: "\u0625\u0646\u0647\u0627\u0621 \u0627\u0644\u062C\u0644\u0633\u0629 \u0639\u0644\u0649 {device}",
      revokeTitle: "\u0625\u0646\u0647\u0627\u0621 \u0627\u0644\u062C\u0644\u0633\u0629 \u0639\u0644\u0649 \xAB{device}\xBB\u061F",
      revokeBody: "\u0633\u064A\u062A\u0639\u064A\u0651\u0646 \u0639\u0644\u0649 \u0647\u0630\u0627 \u0627\u0644\u062C\u0647\u0627\u0632 \u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062F\u062E\u0648\u0644 \u0645\u0646 \u062C\u062F\u064A\u062F \u0644\u0627\u0633\u062A\u0639\u0645\u0627\u0644 BatiFlow. \u0644\u0627 \u062A\u062A\u063A\u064A\u0651\u0631 \u0628\u064A\u0627\u0646\u0627\u062A\u0643.",
      revoked: "\u062A\u0645 \u0625\u0646\u0647\u0627\u0621 \u0627\u0644\u062C\u0644\u0633\u0629 \u0639\u0644\u0649 \u0627\u0644\u062C\u0647\u0627\u0632 \xAB{device}\xBB.",
      alreadyEnded: "\u0643\u0627\u0646\u062A \u0647\u0630\u0647 \u0627\u0644\u062C\u0644\u0633\u0629 \u0642\u062F \u0627\u0646\u062A\u0647\u062A \u0628\u0627\u0644\u0641\u0639\u0644.",
      revokeFailed: "\u062A\u0639\u0630\u0651\u0631 \u0625\u0646\u0647\u0627\u0621 \u0627\u0644\u062C\u0644\u0633\u0629 \u0639\u0644\u0649 \u0647\u0630\u0627 \u0627\u0644\u062C\u0647\u0627\u0632. \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629\u060C \u0648\u0625\u0630\u0627 \u0627\u0633\u062A\u0645\u0631\u062A \u0627\u0644\u0645\u0634\u0643\u0644\u0629 \u0641\u062A\u0648\u0627\u0635\u0644 \u0645\u0639 \u0627\u0644\u062F\u0639\u0645.",
      revokeOthers: "\u0625\u0646\u0647\u0627\u0621 \u0627\u0644\u062C\u0644\u0633\u0627\u062A \u0639\u0644\u0649 \u0627\u0644\u0623\u062C\u0647\u0632\u0629 \u0627\u0644\u0623\u062E\u0631\u0649",
      revokeOthersTitle: "\u0625\u0646\u0647\u0627\u0621 \u0627\u0644\u062C\u0644\u0633\u0627\u062A \u0639\u0644\u0649 \u0643\u0644 \u0627\u0644\u0623\u062C\u0647\u0632\u0629 \u0627\u0644\u0623\u062E\u0631\u0649\u061F",
      revokeOthersBody: "{count, plural, one {\u0633\u064A\u062A\u0645 \u0625\u0646\u0647\u0627\u0621 \u0627\u0644\u062C\u0644\u0633\u0629 \u0639\u0644\u0649 \u062C\u0647\u0627\u0632 \u0622\u062E\u0631 \u0648\u0627\u062D\u062F \u0648\u0633\u064A\u062A\u0639\u064A\u0651\u0646 \u0639\u0644\u064A\u0647 \u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062F\u062E\u0648\u0644 \u0645\u0646 \u062C\u062F\u064A\u062F.} two {\u0633\u064A\u062A\u0645 \u0625\u0646\u0647\u0627\u0621 \u0627\u0644\u062C\u0644\u0633\u0629 \u0639\u0644\u0649 \u062C\u0647\u0627\u0632\u064A\u0646 \u0622\u062E\u0631\u064A\u0646 \u0648\u0633\u064A\u062A\u0639\u064A\u0651\u0646 \u0639\u0644\u064A\u0647\u0645\u0627 \u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062F\u062E\u0648\u0644 \u0645\u0646 \u062C\u062F\u064A\u062F.} few {\u0633\u064A\u062A\u0645 \u0625\u0646\u0647\u0627\u0621 \u0627\u0644\u062C\u0644\u0633\u0627\u062A \u0639\u0644\u0649 # \u0623\u062C\u0647\u0632\u0629 \u0623\u062E\u0631\u0649 \u0648\u0633\u064A\u062A\u0639\u064A\u0651\u0646 \u0639\u0644\u064A\u0647\u0627 \u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062F\u062E\u0648\u0644 \u0645\u0646 \u062C\u062F\u064A\u062F.} many {\u0633\u064A\u062A\u0645 \u0625\u0646\u0647\u0627\u0621 \u0627\u0644\u062C\u0644\u0633\u0627\u062A \u0639\u0644\u0649 # \u062C\u0647\u0627\u0632\u064B\u0627 \u0622\u062E\u0631 \u0648\u0633\u064A\u062A\u0639\u064A\u0651\u0646 \u0639\u0644\u064A\u0647\u0627 \u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062F\u062E\u0648\u0644 \u0645\u0646 \u062C\u062F\u064A\u062F.} other {\u0633\u064A\u062A\u0645 \u0625\u0646\u0647\u0627\u0621 \u0627\u0644\u062C\u0644\u0633\u0627\u062A \u0639\u0644\u0649 # \u062C\u0647\u0627\u0632 \u0622\u062E\u0631 \u0648\u0633\u064A\u062A\u0639\u064A\u0651\u0646 \u0639\u0644\u064A\u0647\u0627 \u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062F\u062E\u0648\u0644 \u0645\u0646 \u062C\u062F\u064A\u062F.}} \u064A\u0628\u0642\u0649 \u0647\u0630\u0627 \u0627\u0644\u062C\u0647\u0627\u0632 \u0645\u0633\u062C\u0651\u0644 \u0627\u0644\u062F\u062E\u0648\u0644.",
      revokedOthers: "{count, plural, =0 {\u0644\u0645 \u064A\u0643\u0646 \u0647\u0646\u0627\u0643 \u0623\u064A \u062C\u0647\u0627\u0632 \u0622\u062E\u0631 \u0645\u0633\u062C\u0651\u0644 \u0627\u0644\u062F\u062E\u0648\u0644.} one {\u062A\u0645 \u0625\u0646\u0647\u0627\u0621 \u0627\u0644\u062C\u0644\u0633\u0629 \u0639\u0644\u0649 \u062C\u0647\u0627\u0632 \u0622\u062E\u0631 \u0648\u0627\u062D\u062F.} two {\u062A\u0645 \u0625\u0646\u0647\u0627\u0621 \u0627\u0644\u062C\u0644\u0633\u0629 \u0639\u0644\u0649 \u062C\u0647\u0627\u0632\u064A\u0646 \u0622\u062E\u0631\u064A\u0646.} few {\u062A\u0645 \u0625\u0646\u0647\u0627\u0621 \u0627\u0644\u062C\u0644\u0633\u0627\u062A \u0639\u0644\u0649 # \u0623\u062C\u0647\u0632\u0629 \u0623\u062E\u0631\u0649.} many {\u062A\u0645 \u0625\u0646\u0647\u0627\u0621 \u0627\u0644\u062C\u0644\u0633\u0627\u062A \u0639\u0644\u0649 # \u062C\u0647\u0627\u0632\u064B\u0627 \u0622\u062E\u0631.} other {\u062A\u0645 \u0625\u0646\u0647\u0627\u0621 \u0627\u0644\u062C\u0644\u0633\u0627\u062A \u0639\u0644\u0649 # \u062C\u0647\u0627\u0632 \u0622\u062E\u0631.}}",
      revokeOthersFailed: "\u062A\u0639\u0630\u0651\u0631 \u0625\u0646\u0647\u0627\u0621 \u0627\u0644\u062C\u0644\u0633\u0627\u062A \u0639\u0644\u0649 \u0627\u0644\u0623\u062C\u0647\u0632\u0629 \u0627\u0644\u0623\u062E\u0631\u0649. \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629\u060C \u0648\u0625\u0630\u0627 \u0627\u0633\u062A\u0645\u0631\u062A \u0627\u0644\u0645\u0634\u0643\u0644\u0629 \u0641\u062A\u0648\u0627\u0635\u0644 \u0645\u0639 \u0627\u0644\u062F\u0639\u0645.",
      noOthers: "\u0644\u0627 \u064A\u0648\u062C\u062F \u0623\u064A \u062C\u0647\u0627\u0632 \u0622\u062E\u0631 \u0645\u0633\u062C\u0651\u0644 \u0627\u0644\u062F\u062E\u0648\u0644.",
      empty: "\u0644\u0627 \u062A\u0648\u062C\u062F \u062C\u0644\u0633\u0627\u062A \u0646\u0634\u0637\u0629 \u0644\u0639\u0631\u0636\u0647\u0627.",
      loadFailedTitle: "\u062A\u0639\u0630\u0651\u0631 \u0639\u0631\u0636 \u062C\u0644\u0633\u0627\u062A\u0643",
      loadFailedBody: "\u062A\u0639\u0630\u0651\u0631 \u062A\u062D\u0645\u064A\u0644 \u062C\u0644\u0633\u0627\u062A\u0643. \u0628\u064A\u0627\u0646\u0627\u062A\u0643 \u0628\u0623\u0645\u0627\u0646. \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629\u060C \u0648\u0625\u0630\u0627 \u0627\u0633\u062A\u0645\u0631\u062A \u0627\u0644\u0645\u0634\u0643\u0644\u0629 \u0641\u062A\u0648\u0627\u0635\u0644 \u0645\u0639 \u0627\u0644\u062F\u0639\u0645."
    },
    loadFailed: "\u062A\u0639\u0630\u0651\u0631 \u062A\u062D\u0645\u064A\u0644 \u0645\u0639\u0644\u0648\u0645\u0627\u062A \u0623\u0645\u0627\u0646 \u062D\u0633\u0627\u0628\u0643. \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629\u061B \u0648\u0625\u0646 \u0627\u0633\u062A\u0645\u0631\u062A \u0627\u0644\u0645\u0634\u0643\u0644\u0629\u060C \u062A\u0648\u0627\u0635\u0644 \u0645\u0639 \u0627\u0644\u062F\u0639\u0645."
  },
  admin: {
    nav: {
      label: "\u0625\u062F\u0627\u0631\u0629 \u0627\u0644\u0645\u0624\u0633\u0633\u0629",
      title: "\u0627\u0644\u0625\u062F\u0627\u0631\u0629",
      members: "\u0627\u0644\u0623\u0639\u0636\u0627\u0621",
      roles: "\u0627\u0644\u0623\u062F\u0648\u0627\u0631 \u0648\u0627\u0644\u0635\u0644\u0627\u062D\u064A\u0627\u062A",
      profile: "\u0627\u0644\u0645\u0624\u0633\u0633\u0629",
      policies: "\u0627\u0644\u0633\u064A\u0627\u0633\u0627\u062A",
      fiscal: "\u0627\u0644\u0645\u0644\u0641 \u0627\u0644\u062C\u0628\u0627\u0626\u064A",
      audit: "\u0633\u062C\u0644 \u0627\u0644\u062A\u062F\u0642\u064A\u0642",
      documents: "\u0627\u0644\u0648\u062B\u0627\u0626\u0642",
      templates: "\u0646\u0645\u0627\u0630\u062C \u0627\u0644\u0645\u0634\u0627\u0631\u064A\u0639",
      checklists: "\u0642\u0648\u0627\u0626\u0645 \u0627\u0644\u062A\u062D\u0642\u0642",
      storage: "\u0627\u0644\u062A\u062E\u0632\u064A\u0646",
      data: "\u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A \u0648\u0627\u0644\u062D\u0630\u0641",
      subscription: "\u0627\u0644\u0627\u0634\u062A\u0631\u0627\u0643"
    }
  },
  more: {
    admin: {
      title: "\u0627\u0644\u0625\u062F\u0627\u0631\u0629",
      description: "\u0623\u0639\u0636\u0627\u0621 \u0645\u0643\u062A\u0628\u0643 \u0648\u062F\u0639\u0648\u0627\u062A\u0647\u0645 \u0648\u0623\u062F\u0648\u0627\u0631\u0647\u0645 \u0648\u0635\u0644\u0627\u062D\u064A\u0627\u062A\u0647\u0645."
    },
    soon: "\u0633\u062A\u062A\u0648\u0641\u0631 \u0623\u0642\u0633\u0627\u0645 \u0623\u062E\u0631\u0649 \u0641\u064A \u0627\u0644\u0625\u0635\u062F\u0627\u0631\u0627\u062A \u0627\u0644\u0642\u0627\u062F\u0645\u0629 \u0645\u0646 BatiFlow.",
    partnerships: {
      title: "\u0627\u0644\u0634\u0631\u0627\u0643\u0627\u062A",
      description: "\u0637\u0644\u0628\u0627\u062A \u0627\u0644\u0634\u0631\u0627\u0643\u0629 \u0627\u0644\u0648\u0627\u0631\u062F\u0629 \u0648\u0641\u0636\u0627\u0621\u0627\u062A \u0627\u0644\u0645\u0624\u0633\u0633\u0627\u062A \u0627\u0644\u0623\u062E\u0631\u0649 \u0627\u0644\u062A\u064A \u062A\u062F\u064A\u0631 \u0641\u064A\u0647\u0627 \u0645\u0646\u062F\u0648\u0628\u064A \u0645\u0624\u0633\u0633\u062A\u0643."
    },
    approvals: {
      title: "\u0627\u0644\u0645\u0648\u0627\u0641\u0642\u0629 \u0639\u0644\u0649 \u0627\u0644\u0648\u0635\u0648\u0644 \u0627\u0644\u062E\u0627\u0631\u062C\u064A",
      description: "\u0627\u0645\u0646\u062D \u0623\u0648 \u0627\u0631\u0641\u0636 \u0648\u0635\u0648\u0644 \u0639\u0636\u0648 \u0625\u0644\u0649 \u0641\u0636\u0627\u0621 \u0645\u0624\u0633\u0633\u0629 \u0623\u062E\u0631\u0649."
    },
    directory: {
      title: "\u062F\u0644\u064A\u0644 \u0627\u0644\u0645\u0643\u0627\u062A\u0628",
      description: "\u0627\u0628\u062D\u062B\u0648\u0627 \u0639\u0646 \u0645\u0643\u0627\u062A\u0628 \u062F\u0631\u0627\u0633\u0627\u062A \u0623\u062E\u0631\u0649 \u0639\u0644\u0649 \u0628\u062A\u064A \u0641\u0644\u0648 \u0648\u0631\u0627\u0633\u0644\u0648\u0647\u0627."
    },
    timesheets: {
      title: "\u0627\u0644\u0648\u0642\u062A",
      description: "\u0623\u062F\u062E\u0644 \u0633\u0627\u0639\u0627\u062A\u0643\u060C \u0648\u0627\u062D\u0635\u0644 \u0639\u0644\u0649 \u0645\u0648\u0627\u0641\u0642\u0629 \u0627\u0644\u0623\u0633\u0627\u0628\u064A\u0639\u060C \u0648\u062A\u0627\u0628\u0639 \u062D\u0645\u0644 \u0627\u0644\u0641\u0631\u064A\u0642."
    },
    tenders: {
      title: "\u0637\u0644\u0628\u0627\u062A \u0627\u0644\u0639\u0631\u0648\u0636",
      description: "\u062A\u0627\u0628\u0639 \u0637\u0644\u0628\u0627\u062A \u0627\u0644\u0639\u0631\u0648\u0636 \u0645\u0646 \u0627\u0644\u0645\u0631\u0627\u0642\u0628\u0629 \u0625\u0644\u0649 \u0627\u0644\u0646\u062A\u064A\u062C\u0629\u060C \u0648\u062D\u0636\u0651\u0631 \u0648\u062B\u0627\u0626\u0642\u0643 \u0648\u062D\u0627\u0641\u0638 \u0639\u0644\u0649 \u062A\u062D\u062F\u064A\u062B \u0634\u0647\u0627\u062F\u0627\u062A\u0643."
    },
    signatures: {
      title: "\u0627\u0644\u062A\u0648\u0642\u064A\u0639\u0627\u062A",
      description: "\u0648\u0642\u0651\u0639 \u0627\u0644\u0648\u062B\u0627\u0626\u0642 \u0627\u0644\u0645\u0637\u0644\u0648\u0628 \u062A\u0648\u0642\u064A\u0639\u0647\u0627 \u0648\u062A\u0627\u0628\u0639 \u0637\u0644\u0628\u0627\u062A \u0627\u0644\u062A\u0648\u0642\u064A\u0639 \u0627\u0644\u062A\u064A \u0642\u062F\u0651\u0645\u062A\u0647\u0627."
    }
  },
  members: {
    title: "\u0627\u0644\u0623\u0639\u0636\u0627\u0621",
    you: "\u0623\u0646\u062A",
    none: "\u2014",
    tableCaption: "\u0623\u0639\u0636\u0627\u0621 \u0627\u0644\u0645\u0624\u0633\u0633\u0629",
    seats: {
      used: "\u0645\u0642\u0627\u0639\u062F \u0645\u0633\u062A\u0639\u0645\u0644\u0629",
      unlimited: "\u0645\u0642\u0627\u0639\u062F \u0645\u0633\u062A\u0639\u0645\u0644\u0629 (\u062F\u0648\u0646 \u062D\u062F\u0651 \u0623\u0642\u0635\u0649)"
    },
    tabs: {
      members: "\u0627\u0644\u0623\u0639\u0636\u0627\u0621",
      invitations: "\u0627\u0644\u062F\u0639\u0648\u0627\u062A \u0627\u0644\u0645\u0639\u0644\u0651\u0642\u0629"
    },
    filters: {
      label: "\u062A\u0635\u0641\u064A\u0629 \u0627\u0644\u0623\u0639\u0636\u0627\u0621",
      search: "\u0627\u0644\u0628\u062D\u062B \u0639\u0646 \u0639\u0636\u0648",
      searchPlaceholder: "\u0627\u0644\u0627\u0633\u0645 \u0623\u0648 \u0639\u0646\u0648\u0627\u0646 \u0627\u0644\u0628\u0631\u064A\u062F \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A",
      role: "\u0627\u0644\u062A\u0635\u0641\u064A\u0629 \u062D\u0633\u0628 \u0627\u0644\u062F\u0648\u0631",
      allRoles: "\u0643\u0644 \u0627\u0644\u0623\u062F\u0648\u0627\u0631",
      status: "\u0627\u0644\u062A\u0635\u0641\u064A\u0629 \u062D\u0633\u0628 \u0627\u0644\u062D\u0627\u0644\u0629",
      allStatuses: "\u0643\u0644 \u0627\u0644\u062D\u0627\u0644\u0627\u062A",
      clear: "\u0645\u0633\u062D \u0639\u0648\u0627\u0645\u0644 \u0627\u0644\u062A\u0635\u0641\u064A\u0629"
    },
    columns: {
      name: "\u0627\u0644\u0627\u0633\u0645",
      email: "\u0627\u0644\u0628\u0631\u064A\u062F \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A",
      role: "\u0627\u0644\u062F\u0648\u0631",
      status: "\u0627\u0644\u062D\u0627\u0644\u0629",
      joined: "\u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0627\u0646\u0636\u0645\u0627\u0645",
      actions: "\u0627\u0644\u0625\u062C\u0631\u0627\u0621\u0627\u062A"
    },
    status: {
      active: "\u0646\u0634\u0637",
      invited: "\u0645\u062F\u0639\u0648",
      suspended: "\u0645\u0639\u0644\u0651\u0642 \u0645\u0646 \u0642\u0628\u0644 \u0627\u0644\u062F\u0639\u0645",
      deactivated: "\u0645\u0639\u0637\u0651\u0644"
    },
    roles: {
      owner: "\u0645\u0627\u0644\u0643",
      admin: "\u0645\u0634\u0631\u0641",
      project_manager: "\u0631\u0626\u064A\u0633 \u0645\u0634\u0631\u0648\u0639",
      engineer: "\u0645\u0647\u0646\u062F\u0633 \u0623\u0648 \u0645\u0639\u0645\u0627\u0631\u064A",
      draftsman: "\u0631\u0633\u0651\u0627\u0645",
      accountant: "\u0645\u062D\u0627\u0633\u0628"
    },
    roleDescriptions: {
      admin: "\u064A\u062F\u064A\u0631 \u0627\u0644\u0623\u0639\u0636\u0627\u0621 \u0648\u0627\u0644\u0625\u0639\u062F\u0627\u062F\u0627\u062A \u0648\u0627\u0644\u0645\u0627\u0644\u064A\u0629 \u0648\u0643\u0644 \u0645\u0634\u0627\u0631\u064A\u0639 \u0627\u0644\u0645\u0643\u062A\u0628.",
      project_manager: "\u064A\u0646\u0634\u0626 \u0645\u0634\u0627\u0631\u064A\u0639\u0647 \u0648\u064A\u062F\u064A\u0631\u0647\u0627 \u0648\u064A\u062A\u0627\u0628\u0639 \u0627\u0644\u0623\u062A\u0639\u0627\u0628 \u0648\u0623\u0648\u0642\u0627\u062A \u0627\u0644\u0639\u0645\u0644 \u0648\u0628\u064A\u0627\u0646\u0627\u062A \u0627\u0644\u0645\u0635\u0627\u0631\u064A\u0641.",
      engineer: "\u064A\u0634\u0627\u0631\u0643 \u0641\u064A \u0627\u0644\u0645\u0634\u0627\u0631\u064A\u0639 \u0627\u0644\u062A\u064A \u062A\u0636\u064A\u0641\u0647 \u0625\u0644\u064A\u0647\u0627: \u0627\u0644\u0648\u062B\u0627\u0626\u0642 \u0648\u0627\u0644\u0645\u0647\u0627\u0645 \u0648\u0627\u0644\u0645\u062D\u0627\u062F\u062B\u0627\u062A.",
      draftsman: "\u064A\u0639\u062F\u0651 \u0627\u0644\u0645\u062E\u0637\u0637\u0627\u062A \u0648\u064A\u0631\u0641\u0639\u0647\u0627 \u0641\u064A \u0627\u0644\u0645\u0634\u0627\u0631\u064A\u0639 \u0627\u0644\u062A\u064A \u062A\u0636\u064A\u0641\u0647 \u0625\u0644\u064A\u0647\u0627.",
      accountant: "\u064A\u062F\u064A\u0631 \u0639\u0631\u0648\u0636 \u0627\u0644\u0623\u0633\u0639\u0627\u0631 \u0648\u0627\u0644\u0641\u0648\u0627\u062A\u064A\u0631 \u0648\u0627\u0644\u0645\u062F\u0641\u0648\u0639\u0627\u062A \u0648\u0627\u0644\u0634\u0624\u0648\u0646 \u0627\u0644\u062C\u0628\u0627\u0626\u064A\u0629 \u0644\u0644\u0645\u0643\u062A\u0628."
    },
    actions: {
      open: "\u0625\u062C\u0631\u0627\u0621\u0627\u062A \u062E\u0627\u0635\u0629 \u0628\u0640 {name}",
      changeRole: "\u062A\u063A\u064A\u064A\u0631 \u0627\u0644\u062F\u0648\u0631",
      deactivate: "\u062A\u0639\u0637\u064A\u0644",
      transferOwnership: "\u0646\u0642\u0644 \u0627\u0644\u0645\u0644\u0643\u064A\u0629"
    },
    empty: {
      title: "\u0644\u0627 \u064A\u0648\u062C\u062F \u0623\u0639\u0636\u0627\u0621 \u0628\u0639\u062F",
      description: "\u0627\u062F\u0639\u064F \u0641\u0631\u064A\u0642\u0643 \u0644\u0644\u0639\u0645\u0644 \u0645\u0639\u064B\u0627 \u0639\u0644\u0649 \u0645\u0634\u0627\u0631\u064A\u0639\u0643.",
      filteredTitle: "\u0644\u0627 \u064A\u0648\u062C\u062F \u0639\u0636\u0648 \u0645\u0637\u0627\u0628\u0642",
      filteredDescription: "\u062C\u0631\u0651\u0628 \u0627\u0633\u0645\u064B\u0627 \u0622\u062E\u0631 \u0623\u0648 \u0623\u0632\u0644 \u0625\u062D\u062F\u0649 \u0639\u0648\u0627\u0645\u0644 \u0627\u0644\u062A\u0635\u0641\u064A\u0629."
    },
    loadFailedTitle: "\u062A\u0639\u0630\u0651\u0631 \u0639\u0631\u0636 \u0627\u0644\u0623\u0639\u0636\u0627\u0621",
    loadFailedBody: "\u062A\u0639\u0630\u0651\u0631 \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0642\u0627\u0626\u0645\u0629. \u0628\u064A\u0627\u0646\u0627\u062A\u0643 \u0641\u064A \u0623\u0645\u0627\u0646. \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629\u060C \u0648\u0625\u0646 \u0627\u0633\u062A\u0645\u0631\u0651\u062A \u0627\u0644\u0645\u0634\u0643\u0644\u0629 \u0641\u062A\u0648\u0627\u0635\u0644 \u0645\u0639 \u0627\u0644\u062F\u0639\u0645.",
    loadMore: "\u0639\u0631\u0636 \u0627\u0644\u0645\u0632\u064A\u062F \u0645\u0646 \u0627\u0644\u0623\u0639\u0636\u0627\u0621",
    loadingMore: "\u062C\u0627\u0631\u064D \u0627\u0644\u062A\u062D\u0645\u064A\u0644\u2026",
    invite: {
      button: "\u062F\u0639\u0648\u0629",
      title: "\u062F\u0639\u0648\u0629 \u0639\u0636\u0648",
      intro: "\u064A\u062A\u0644\u0642\u0649 \u0627\u0644\u0634\u062E\u0635 \u0631\u0633\u0627\u0644\u0629 \u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A\u0629 \u062A\u062A\u0636\u0645\u0646 \u0631\u0627\u0628\u0637\u064B\u0627 \u0644\u0644\u0627\u0646\u0636\u0645\u0627\u0645 \u0625\u0644\u0649 \u0645\u0643\u062A\u0628\u0643. \u0627\u0644\u062F\u0639\u0648\u0629 \u0635\u0627\u0644\u062D\u0629 \u0644\u0645\u062F\u0629 7 \u0623\u064A\u0627\u0645.",
      email: {
        label: "\u0627\u0644\u0628\u0631\u064A\u062F \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A"
      },
      role: {
        label: "\u0627\u0644\u062F\u0648\u0631"
      },
      locale: {
        label: "\u0644\u063A\u0629 \u0627\u0644\u0631\u0633\u0627\u0644\u0629",
        hint: "\u062A\u064F\u0643\u062A\u0628 \u0627\u0644\u062F\u0639\u0648\u0629 \u0628\u0647\u0630\u0647 \u0627\u0644\u0644\u063A\u0629."
      },
      submit: "\u0625\u0631\u0633\u0627\u0644 \u0627\u0644\u062F\u0639\u0648\u0629",
      sending: "\u062C\u0627\u0631\u064D \u0627\u0644\u0625\u0631\u0633\u0627\u0644\u2026",
      sent: "\u062A\u0645 \u0625\u0631\u0633\u0627\u0644 \u0627\u0644\u062F\u0639\u0648\u0629 \u0625\u0644\u0649 {email}.",
      resendExisting: "\u0625\u0639\u0627\u062F\u0629 \u0625\u0631\u0633\u0627\u0644 \u0627\u0644\u062F\u0639\u0648\u0629",
      errors: {
        emailRequired: "\u0623\u062F\u062E\u0644 \u0639\u0646\u0648\u0627\u0646 \u0627\u0644\u0628\u0631\u064A\u062F \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A \u0644\u0644\u0634\u062E\u0635 \u0627\u0644\u0645\u0631\u0627\u062F \u062F\u0639\u0648\u062A\u0647.",
        emailInvalid: "\u0623\u062F\u062E\u0644 \u0639\u0646\u0648\u0627\u0646 \u0628\u0631\u064A\u062F \u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A \u0635\u062D\u064A\u062D\u064B\u0627\u060C \u0645\u062B\u0644 name@example.tn.",
        alreadyMember: "\u0647\u0630\u0627 \u0627\u0644\u0639\u0646\u0648\u0627\u0646 \u064A\u062E\u0635\u0651 \u0639\u0636\u0648\u064B\u0627 \u0641\u064A \u0645\u0643\u062A\u0628\u0643 \u0628\u0627\u0644\u0641\u0639\u0644.",
        pending: "\u062A\u0648\u062C\u062F \u062F\u0639\u0648\u0629 \u0645\u0639\u0644\u0651\u0642\u0629 \u0644\u0647\u0630\u0627 \u0627\u0644\u0639\u0646\u0648\u0627\u0646. \u064A\u0645\u0643\u0646\u0643 \u0625\u0639\u0627\u062F\u0629 \u0625\u0631\u0633\u0627\u0644\u0647\u0627.",
        pendingElsewhere: "\u062A\u0648\u062C\u062F \u062F\u0639\u0648\u0629 \u0645\u0639\u0644\u0651\u0642\u0629 \u0644\u0647\u0630\u0627 \u0627\u0644\u0639\u0646\u0648\u0627\u0646. \u0633\u062A\u062C\u062F\u0647\u0627 \u0641\u064A \u0639\u0644\u0627\u0645\u0629 \u0627\u0644\u062A\u0628\u0648\u064A\u0628 \xAB\u0627\u0644\u062F\u0639\u0648\u0627\u062A \u0627\u0644\u0645\u0639\u0644\u0651\u0642\u0629\xBB."
      }
    },
    upgrade: {
      askOwner: "\u062C\u0645\u064A\u0639 \u0645\u0642\u0627\u0639\u062F \u0639\u0631\u0636\u0643 \u0645\u0633\u062A\u0639\u0645\u0644\u0629. \u0627\u0637\u0644\u0628 \u0645\u0646 \u0645\u0627\u0644\u0643 \u0645\u0643\u062A\u0628\u0643 \u0625\u0636\u0627\u0641\u0629 \u0645\u0642\u0639\u062F \u0623\u0648 \u062A\u063A\u064A\u064A\u0631 \u0627\u0644\u0639\u0631\u0636 \u062D\u062A\u0649 \u062A\u062A\u0645\u0643\u0646 \u0645\u0646 \u062F\u0639\u0648\u0629 \u0627\u0644\u0645\u0632\u064A\u062F \u0645\u0646 \u0627\u0644\u0623\u0634\u062E\u0627\u0635.",
      addSeat: "\u062C\u0645\u064A\u0639 \u0645\u0642\u0627\u0639\u062F \u0639\u0631\u0636\u0643 \u0645\u0633\u062A\u0639\u0645\u0644\u0629. \u0623\u0636\u0641 \u0645\u0642\u0639\u062F\u064B\u0627 \u0644\u062F\u0639\u0648\u0629 \u0634\u062E\u0635 \u0622\u062E\u0631. \u0633\u064A\u062A\u0648\u0641\u0631 \u0647\u0630\u0627 \u0627\u0644\u062E\u064A\u0627\u0631 \u0642\u0631\u064A\u0628\u064B\u0627 \u0641\u064A \u0627\u0644\u0625\u062F\u0627\u0631\u0629\u060C \u0648\u0625\u0644\u0649 \u0630\u0644\u0643 \u0627\u0644\u062D\u064A\u0646 \u062A\u0648\u0627\u0635\u0644 \u0645\u0639 \u062F\u0639\u0645 BatiFlow.",
      upgradePlan: "\u062C\u0645\u064A\u0639 \u0645\u0642\u0627\u0639\u062F \u0639\u0631\u0636\u0643 \u0645\u0633\u062A\u0639\u0645\u0644\u0629. \u0627\u0646\u062A\u0642\u0644 \u0625\u0644\u0649 \u0639\u0631\u0636 {plan} \u0644\u0644\u062D\u0635\u0648\u0644 \u0639\u0644\u0649 \u0627\u0644\u0645\u0632\u064A\u062F. \u0633\u064A\u062A\u0648\u0641\u0631 \u0627\u062E\u062A\u064A\u0627\u0631 \u0627\u0644\u0639\u0631\u0636 \u0642\u0631\u064A\u0628\u064B\u0627 \u0641\u064A \u0627\u0644\u0625\u062F\u0627\u0631\u0629\u060C \u0648\u0625\u0644\u0649 \u0630\u0644\u0643 \u0627\u0644\u062D\u064A\u0646 \u062A\u0648\u0627\u0635\u0644 \u0645\u0639 \u062F\u0639\u0645 BatiFlow.",
      noHigherPlan: "\u062C\u0645\u064A\u0639 \u0645\u0642\u0627\u0639\u062F \u0639\u0631\u0636\u0643 \u0645\u0633\u062A\u0639\u0645\u0644\u0629 \u0648\u0644\u0627 \u064A\u0648\u062C\u062F \u0639\u0631\u0636 \u0623\u0639\u0644\u0649 \u0645\u062A\u0627\u062D \u0639\u0628\u0631 \u0627\u0644\u0645\u0648\u0642\u0639. \u062A\u0648\u0627\u0635\u0644 \u0645\u0639 \u0641\u0631\u064A\u0642 BatiFlow \u0644\u0625\u0636\u0627\u0641\u0629 \u0645\u0642\u0627\u0639\u062F.",
      plans: {
        solo: "Solo",
        starter: "Starter",
        pro: "Pro",
        business: "Business",
        enterprise: "Enterprise"
      }
    },
    invitations: {
      tableCaption: "\u0627\u0644\u062F\u0639\u0648\u0627\u062A \u0627\u0644\u0645\u0639\u0644\u0651\u0642\u0629",
      columns: {
        email: "\u0627\u0644\u0628\u0631\u064A\u062F \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A",
        role: "\u0627\u0644\u062F\u0648\u0631",
        invitedBy: "\u062A\u0645\u062A \u0627\u0644\u062F\u0639\u0648\u0629 \u0645\u0646",
        expires: "\u062A\u0646\u062A\u0647\u064A \u0641\u064A"
      },
      expired: "\u0645\u0646\u062A\u0647\u064A\u0629 \u0627\u0644\u0635\u0644\u0627\u062D\u064A\u0629",
      empty: {
        title: "\u0644\u0627 \u062A\u0648\u062C\u062F \u062F\u0639\u0648\u0627\u062A \u0645\u0639\u0644\u0651\u0642\u0629",
        description: "\u064A\u0638\u0647\u0631 \u0647\u0646\u0627 \u0627\u0644\u0623\u0634\u062E\u0627\u0635 \u0627\u0644\u0630\u064A\u0646 \u062F\u0639\u0648\u062A\u0647\u0645 \u0648\u0644\u0645 \u064A\u0642\u0628\u0644\u0648\u0627 \u0627\u0644\u062F\u0639\u0648\u0629 \u0628\u0639\u062F."
      },
      resend: "\u0625\u0639\u0627\u062F\u0629 \u0627\u0644\u0625\u0631\u0633\u0627\u0644",
      resendLabel: "\u0625\u0639\u0627\u062F\u0629 \u0625\u0631\u0633\u0627\u0644 \u0627\u0644\u062F\u0639\u0648\u0629 \u0625\u0644\u0649 {email}",
      resent: "\u062A\u0645\u062A \u0625\u0639\u0627\u062F\u0629 \u0625\u0631\u0633\u0627\u0644 \u0627\u0644\u062F\u0639\u0648\u0629 \u0625\u0644\u0649 {email}.",
      revoke: "\u0625\u0644\u063A\u0627\u0621",
      revokeLabel: "\u0625\u0644\u063A\u0627\u0621 \u062F\u0639\u0648\u0629 {email}",
      revokeTitle: "\u0625\u0644\u063A\u0627\u0621 \u062F\u0639\u0648\u0629 {email}\u061F",
      revokeBody: "\u0633\u064A\u062A\u0648\u0642\u0641 \u0627\u0644\u0631\u0627\u0628\u0637 \u0627\u0644\u0630\u064A \u0648\u0635\u0644 \u0628\u0627\u0644\u0628\u0631\u064A\u062F \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A \u0639\u0646 \u0627\u0644\u0639\u0645\u0644. \u064A\u0645\u0643\u0646\u0643 \u062F\u0639\u0648\u0629 \u0647\u0630\u0627 \u0627\u0644\u0634\u062E\u0635 \u0645\u0646 \u062C\u062F\u064A\u062F.",
      revoked: "\u062A\u0645 \u0625\u0644\u063A\u0627\u0621 \u062F\u0639\u0648\u0629 {email}.",
      alreadyGone: "\u0647\u0630\u0647 \u0627\u0644\u062F\u0639\u0648\u0629 \u0644\u0645 \u062A\u0639\u062F \u0645\u0648\u062C\u0648\u062F\u0629: \u0641\u0642\u062F \u0642\u064F\u0628\u0644\u062A \u0623\u0648 \u0623\u064F\u0644\u063A\u064A\u062A \u0645\u0646 \u0642\u0628\u0644.",
      loadFailedTitle: "\u062A\u0639\u0630\u0651\u0631 \u0639\u0631\u0636 \u0627\u0644\u062F\u0639\u0648\u0627\u062A",
      loadFailedBody: "\u062A\u0639\u0630\u0651\u0631 \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0642\u0627\u0626\u0645\u0629. \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629\u060C \u0648\u0625\u0646 \u0627\u0633\u062A\u0645\u0631\u0651\u062A \u0627\u0644\u0645\u0634\u0643\u0644\u0629 \u0641\u062A\u0648\u0627\u0635\u0644 \u0645\u0639 \u0627\u0644\u062F\u0639\u0645."
    },
    changeRole: {
      title: "\u062A\u063A\u064A\u064A\u0631 \u062F\u0648\u0631 {name}",
      current: "\u0627\u0644\u062F\u0648\u0631 \u0627\u0644\u062D\u0627\u0644\u064A: {role}.",
      label: "\u0627\u0644\u062F\u0648\u0631 \u0627\u0644\u062C\u062F\u064A\u062F",
      placeholder: "\u0627\u062E\u062A\u0631 \u062F\u0648\u0631\u064B\u0627",
      required: "\u0627\u062E\u062A\u0631 \u0627\u0644\u062F\u0648\u0631 \u0627\u0644\u062C\u062F\u064A\u062F.",
      stepUpNote: "\u0644\u062D\u0645\u0627\u064A\u062A\u0643\u060C \u0642\u062F \u064A\u064F\u0637\u0644\u0628 \u0645\u0646\u0643 \u062A\u0623\u0643\u064A\u062F \u0647\u0648\u064A\u062A\u0643 \u0642\u0628\u0644 \u062A\u0637\u0628\u064A\u0642 \u0627\u0644\u062A\u063A\u064A\u064A\u0631.",
      submit: "\u062A\u063A\u064A\u064A\u0631 \u0627\u0644\u062F\u0648\u0631",
      saving: "\u062C\u0627\u0631\u064D \u0627\u0644\u062D\u0641\u0638\u2026",
      done: "\u0623\u0635\u0628\u062D \u062F\u0648\u0631 {name} \u0627\u0644\u0622\u0646 \xAB{role}\xBB.",
      stale: "\u062A\u063A\u064A\u0651\u0631\u062A \u0628\u064A\u0627\u0646\u0627\u062A {name} \u0641\u064A \u0627\u0644\u0623\u062B\u0646\u0627\u0621. \u0623\u064F\u0639\u064A\u062F \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0642\u0627\u0626\u0645\u0629: \u062A\u062D\u0642\u0642 \u0645\u0646\u0647\u0627 \u062B\u0645 \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629."
    },
    deactivate: {
      explain: {
        title: "\u062A\u0639\u0637\u064A\u0644 {name}",
        intro: "\u0647\u0630\u0627 \u0645\u0627 \u064A\u062D\u062F\u062B \u0639\u0646\u062F \u062A\u0639\u0637\u064A\u0644 {name}:",
        access: "\u064A\u0646\u0642\u0637\u0639 \u0627\u0644\u0648\u0635\u0648\u0644 \u0625\u0644\u0649 \u0645\u0643\u062A\u0628\u0643 \u0641\u0648\u0631\u064B\u0627 \u0639\u0644\u0649 \u062C\u0645\u064A\u0639 \u0623\u062C\u0647\u0632\u062A\u0647.",
        content: "\u062A\u0628\u0642\u0649 \u0648\u062B\u0627\u0626\u0642\u0647 \u0648\u0631\u0633\u0627\u0626\u0644\u0647 \u0648\u0645\u0647\u0627\u0645\u0647 \u0641\u064A \u0645\u0643\u0627\u0646\u0647\u0627 \u0648\u062A\u062D\u062A\u0641\u0638 \u0628\u0627\u0633\u0645\u0647.",
        seat: "\u064A\u064F\u062D\u0631\u064E\u0651\u0631 \u0627\u0644\u0645\u0642\u0639\u062F \u0641\u064A \u0641\u062A\u0631\u0629 \u0627\u0644\u0641\u0648\u062A\u0631\u0629 \u0627\u0644\u0645\u0642\u0628\u0644\u0629."
      },
      plan: {
        title: "\u0645\u0627\u0630\u0627 \u0646\u0641\u0639\u0644 \u0628\u0645\u0627 \u064A\u0645\u0644\u0643\u0647 {name}\u061F",
        intro: "{count, plural, one {\u0639\u0646\u0635\u0631 \u0648\u0627\u062D\u062F \u0628\u062D\u0648\u0632\u0629 {name}} two {\u0639\u0646\u0635\u0631\u0627\u0646 \u0628\u062D\u0648\u0632\u0629 {name}} few {# \u0639\u0646\u0627\u0635\u0631 \u0628\u062D\u0648\u0632\u0629 {name}} many {# \u0639\u0646\u0635\u0631\u064B\u0627 \u0628\u062D\u0648\u0632\u0629 {name}} other {# \u0639\u0646\u0635\u0631 \u0628\u062D\u0648\u0632\u0629 {name}}}. \u0627\u062E\u062A\u0631 \u0645\u0646 \u0633\u064A\u062A\u0648\u0644\u0627\u0647\u0627.",
        nothing: "\u0644\u0627 \u064A\u0648\u062C\u062F \u0634\u064A\u0621 \u0644\u0646\u0642\u0644\u0647 \u062D\u0627\u0644\u064A\u064B\u0627: {name} \u0644\u0627 \u064A\u0645\u0644\u0643 \u0623\u064A \u0639\u0646\u0635\u0631 \u064A\u062C\u0628 \u0625\u0633\u0646\u0627\u062F\u0647 \u0625\u0644\u0649 \u0634\u062E\u0635 \u0622\u062E\u0631.",
        loadFailed: "\u062A\u0639\u0630\u0651\u0631 \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0639\u0646\u0627\u0635\u0631 \u0627\u0644\u0645\u0631\u0627\u062F \u0646\u0642\u0644\u0647\u0627. \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629 \u0642\u0628\u0644 \u0627\u0644\u0645\u062A\u0627\u0628\u0639\u0629.",
        defaultAssignee: "\u0627\u0644\u0645\u0633\u062A\u0644\u0645 \u0627\u0644\u0627\u0641\u062A\u0631\u0627\u0636\u064A",
        defaultAssigneeHint: "\u064A\u062A\u0633\u0644\u0651\u0645 \u0643\u0644 \u0639\u0646\u0635\u0631 \u0644\u0627 \u062A\u062E\u062A\u0627\u0631 \u0644\u0647 \u0623\u062D\u062F\u064B\u0627.",
        noDefault: "\u0628\u062F\u0648\u0646 \u0645\u0633\u062A\u0644\u0645 \u0627\u0641\u062A\u0631\u0627\u0636\u064A",
        useDefault: "\u0627\u0633\u062A\u062E\u062F\u0627\u0645 \u0627\u0644\u0645\u0633\u062A\u0644\u0645 \u0627\u0644\u0627\u0641\u062A\u0631\u0627\u0636\u064A",
        listLabel: "\u0627\u0644\u0639\u0646\u0627\u0635\u0631 \u0627\u0644\u0645\u0631\u0627\u062F \u0646\u0642\u0644\u0647\u0627",
        errors: {
          missing: "\u0627\u062E\u062A\u0631 \u0634\u062E\u0635\u064B\u0627 \u0644\u0643\u0644 \u0639\u0646\u0635\u0631\u060C \u0623\u0648 \u0645\u0633\u062A\u0644\u0645\u064B\u0627 \u0627\u0641\u062A\u0631\u0627\u0636\u064A\u064B\u0627."
        }
      },
      confirm: {
        title: "\u062A\u0639\u0637\u064A\u0644 {name}\u061F",
        body: "\u064A\u0641\u0642\u062F {name} \u0627\u0644\u0648\u0635\u0648\u0644 \u0625\u0644\u0649 \u0645\u0643\u062A\u0628\u0643 \u0641\u0648\u0631\u064B\u0627. {count, plural, =0 {\u0644\u0627 \u064A\u0648\u062C\u062F \u0645\u0627 \u064A\u064F\u0646\u0642\u0644.} one {\u0633\u064A\u064F\u0646\u0642\u0644 \u0639\u0646\u0635\u0631 \u0648\u0627\u062D\u062F.} two {\u0633\u064A\u064F\u0646\u0642\u0644 \u0639\u0646\u0635\u0631\u0627\u0646.} few {\u0633\u064A\u062A\u0645 \u0646\u0642\u0644 # \u0639\u0646\u0627\u0635\u0631.} many {\u0633\u064A\u062A\u0645 \u0646\u0642\u0644 # \u0639\u0646\u0635\u0631\u064B\u0627.} other {\u0633\u064A\u062A\u0645 \u0646\u0642\u0644 # \u0639\u0646\u0635\u0631.}}",
        action: "\u062A\u0639\u0637\u064A\u0644"
      },
      done: "\u062A\u0645 \u062A\u0639\u0637\u064A\u0644 {name}.",
      alreadyGone: "\u0647\u0630\u0627 \u0627\u0644\u0639\u0636\u0648 \u0644\u0645 \u064A\u0639\u062F \u0646\u0634\u0637\u064B\u0627: \u0641\u0642\u062F \u062A\u0645 \u062A\u0639\u0637\u064A\u0644\u0647 \u0645\u0646 \u0642\u0628\u0644."
    },
    ownerTransfer: {
      theOwner: "\u0627\u0644\u0645\u0627\u0644\u0643",
      pendingTitle: "\u0646\u0642\u0644 \u0627\u0644\u0645\u0644\u0643\u064A\u0629 \u0642\u064A\u062F \u0627\u0644\u062A\u0646\u0641\u064A\u0630",
      pendingBody: "\u0641\u064A \u0627\u0646\u062A\u0638\u0627\u0631 \u0631\u062F\u0651 {name}\u060C \u0627\u0644\u0630\u064A \u0639\u0644\u064A\u0647 \u0623\u0646 \u064A\u0642\u0628\u0644 \u0644\u064A\u0635\u0628\u062D \u0627\u0644\u0645\u0627\u0644\u0643.",
      expires: "\u064A\u0646\u062A\u0647\u064A \u0641\u064A",
      cancel: "\u0625\u0644\u063A\u0627\u0621 \u0627\u0644\u0646\u0642\u0644",
      cancelled: "\u062A\u0645 \u0625\u0644\u063A\u0627\u0621 \u0646\u0642\u0644 \u0627\u0644\u0645\u0644\u0643\u064A\u0629.",
      offerTitle: "{name} \u064A\u0631\u064A\u062F \u062A\u0639\u064A\u064A\u0646\u0643 \u0645\u0627\u0644\u0643\u064B\u0627",
      offerBody: "\u0633\u062A\u062A\u0648\u0644\u0649 \u0645\u0644\u0643\u064A\u0629 {organization}: \u0627\u0644\u0641\u0648\u062A\u0631\u0629 \u0648\u062D\u0630\u0641 \u0627\u0644\u0645\u0624\u0633\u0633\u0629 \u0648\u0646\u0642\u0644 \u0645\u0644\u0643\u064A\u062A\u0647\u0627.",
      accept: "\u0642\u0628\u0648\u0644",
      decline: "\u0631\u0641\u0636",
      declined: "\u0644\u0642\u062F \u0631\u0641\u0636\u062A \u0646\u0642\u0644 \u0627\u0644\u0645\u0644\u0643\u064A\u0629.",
      acceptTitle: "\u0623\u0646 \u062A\u0635\u0628\u062D \u0645\u0627\u0644\u0643 {organization}\u061F",
      acceptBody: "\u0633\u062A\u0635\u0628\u062D \u0627\u0644\u0645\u0627\u0644\u0643 \u0648\u064A\u0635\u0628\u062D {name} \u0645\u0634\u0631\u0641\u064B\u0627. \u0633\u064A\u064F\u0637\u0644\u0628 \u0645\u0646\u0643 \u062A\u0623\u0643\u064A\u062F \u0647\u0648\u064A\u062A\u0643.",
      acceptAction: "\u0623\u0635\u0628\u062D \u0627\u0644\u0645\u0627\u0644\u0643",
      accepted: "\u0623\u0646\u062A \u0627\u0644\u0622\u0646 \u0645\u0627\u0644\u0643 {organization}.",
      proposeTitle: "\u0646\u0642\u0644 \u0627\u0644\u0645\u0644\u0643\u064A\u0629 \u0625\u0644\u0649 {name}\u061F",
      proposeBody: "\u0633\u064A\u062A\u0644\u0642\u0649 {name} \u0627\u0644\u0627\u0642\u062A\u0631\u0627\u062D \u0648\u0639\u0644\u064A\u0647 \u0642\u0628\u0648\u0644\u0647. \u0625\u0630\u0627 \u0642\u0628\u0644\u060C \u064A\u0635\u0628\u062D \u0647\u0648 \u0627\u0644\u0645\u0627\u0644\u0643 \u0648\u062A\u0635\u0628\u062D \u0623\u0646\u062A \u0645\u0634\u0631\u0641\u064B\u0627. \u064A\u0645\u0643\u0646\u0643 \u0627\u0644\u0625\u0644\u063A\u0627\u0621 \u0645\u0627 \u062F\u0627\u0645 \u0644\u0645 \u064A\u0631\u062F\u0651.",
      proposeAction: "\u0625\u0631\u0633\u0627\u0644 \u0627\u0644\u0627\u0642\u062A\u0631\u0627\u062D",
      proposed: "\u062A\u0645 \u0625\u0631\u0633\u0627\u0644 \u0627\u0644\u0627\u0642\u062A\u0631\u0627\u062D \u0625\u0644\u0649 {name}. \u064A\u0635\u0628\u062D \u0633\u0627\u0631\u064A\u064B\u0627 \u0639\u0646\u062F\u0645\u0627 \u064A\u0642\u0628\u0644\u0647."
    }
  },
  invitation: {
    opening: "\u062C\u0627\u0631\u064D \u0641\u062A\u062D \u062F\u0639\u0648\u062A\u0643\u2026",
    loading: "\u062C\u0627\u0631\u064D \u062A\u062D\u0645\u064A\u0644 \u062F\u0639\u0648\u062A\u0643\u2026",
    joining: "\u062C\u0627\u0631\u064D \u0641\u062A\u062D \u0645\u0633\u0627\u062D\u0629 \u0639\u0645\u0644\u0643\u2026",
    toHome: "\u0627\u0644\u0627\u0646\u062A\u0642\u0627\u0644 \u0625\u0644\u0649 \u0627\u0644\u0635\u0641\u062D\u0629 \u0627\u0644\u0631\u0626\u064A\u0633\u064A\u0629",
    missing: {
      title: "\u0644\u0645 \u062A\u0639\u062F \u062F\u0639\u0648\u062A\u0643 \u0645\u0641\u062A\u0648\u062D\u0629 \u0641\u064A \u0647\u0630\u0647 \u0627\u0644\u0635\u0641\u062D\u0629",
      body: "\u0627\u0641\u062A\u062D \u0645\u0646 \u062C\u062F\u064A\u062F \u0627\u0644\u0631\u0627\u0628\u0637 \u0627\u0644\u0630\u064A \u0648\u0635\u0644\u0643 \u0628\u0627\u0644\u0628\u0631\u064A\u062F \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A \u0644\u0639\u0631\u0636 \u062F\u0639\u0648\u062A\u0643. \u0648\u0625\u0646 \u0644\u0645 \u062A\u062C\u062F \u0627\u0644\u0631\u0633\u0627\u0644\u0629\u060C \u0641\u0627\u0637\u0644\u0628 \u062F\u0639\u0648\u0629 \u062C\u062F\u064A\u062F\u0629 \u0645\u0646 \u0627\u0644\u0634\u062E\u0635 \u0627\u0644\u0630\u064A \u062F\u0639\u0627\u0643."
    },
    signedOut: {
      title: "\u062A\u0645\u062A \u062F\u0639\u0648\u062A\u0643 \u0644\u0644\u0627\u0646\u0636\u0645\u0627\u0645 \u0625\u0644\u0649 \u0645\u0643\u062A\u0628 \u062F\u0631\u0627\u0633\u0627\u062A \u0639\u0644\u0649 BatiFlow",
      body: "\u0633\u062C\u0651\u0644 \u0627\u0644\u062F\u062E\u0648\u0644 \u0628\u0639\u0646\u0648\u0627\u0646 \u0627\u0644\u0628\u0631\u064A\u062F \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A \u0627\u0644\u0630\u064A \u0648\u0635\u0644\u062A\u0647 \u0627\u0644\u062F\u0639\u0648\u0629 \u0644\u0645\u0639\u0631\u0641\u0629 \u0627\u0644\u0645\u0643\u062A\u0628 \u0627\u0644\u0645\u0639\u0646\u064A \u0648\u0627\u0644\u0627\u0646\u0636\u0645\u0627\u0645 \u0625\u0644\u064A\u0647.",
      account: "\u0644\u064A\u0633 \u0644\u062F\u064A\u0643 \u062D\u0633\u0627\u0628 \u0628\u0639\u062F\u061F \u064A\u0645\u0643\u0646\u0643 \u0625\u0646\u0634\u0627\u0624\u0647 \u0641\u064A \u0635\u0641\u062D\u0629 \u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062F\u062E\u0648\u0644 \u062B\u0645 \u062A\u0639\u0648\u062F \u0625\u0644\u0649 \u0647\u0646\u0627.",
      action: "\u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062F\u062E\u0648\u0644 \u0623\u0648 \u0625\u0646\u0634\u0627\u0621 \u062D\u0633\u0627\u0628"
    },
    problems: {
      unknown: {
        title: "\u0631\u0627\u0628\u0637 \u0627\u0644\u062F\u0639\u0648\u0629 \u0647\u0630\u0627 \u063A\u064A\u0631 \u0645\u0639\u0631\u0648\u0641",
        body: "\u0631\u0628\u0645\u0627 \u0627\u0644\u0631\u0627\u0628\u0637 \u0646\u0627\u0642\u0635 \u0623\u0648 \u0642\u062F\u064A\u0645. \u0627\u0641\u062A\u062D \u0645\u0646 \u062C\u062F\u064A\u062F \u0627\u0644\u0631\u0633\u0627\u0644\u0629 \u0627\u0644\u062A\u064A \u0648\u0635\u0644\u062A\u0643 \u0628\u0627\u0644\u0628\u0631\u064A\u062F \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A\u060C \u0623\u0648 \u0627\u0637\u0644\u0628 \u062F\u0639\u0648\u0629 \u062C\u062F\u064A\u062F\u0629."
      },
      invalid: {
        title: "\u0644\u0645 \u062A\u0639\u062F \u0647\u0630\u0647 \u0627\u0644\u062F\u0639\u0648\u0629 \u0635\u0627\u0644\u062D\u0629",
        body: "\u0627\u0646\u062A\u0647\u062A \u0635\u0644\u0627\u062D\u064A\u062A\u0647\u0627 \u0623\u0648 \u0623\u064F\u0644\u063A\u064A\u062A \u0623\u0648 \u0633\u0628\u0642 \u0627\u0633\u062A\u0639\u0645\u0627\u0644\u0647\u0627. \u0627\u0637\u0644\u0628 \u062F\u0639\u0648\u0629 \u062C\u062F\u064A\u062F\u0629 \u0645\u0646 \u0627\u0644\u0634\u062E\u0635 \u0627\u0644\u0630\u064A \u062F\u0639\u0627\u0643."
      },
      mismatch: {
        title: "\u0647\u0630\u0647 \u0627\u0644\u062F\u0639\u0648\u0629 \u0645\u0648\u062C\u0651\u0647\u0629 \u0625\u0644\u0649 \u0639\u0646\u0648\u0627\u0646 \u0622\u062E\u0631",
        body: "\u0623\u064F\u0631\u0633\u0644\u062A \u0625\u0644\u0649",
        next: "\u0623\u0646\u062A \u0645\u0633\u062C\u0651\u0644 \u0627\u0644\u062F\u062E\u0648\u0644 \u0628\u0639\u0646\u0648\u0627\u0646 \u0622\u062E\u0631. \u0633\u062C\u0651\u0644 \u0627\u0644\u062E\u0631\u0648\u062C\u060C \u062B\u0645 \u0627\u0641\u062A\u062D \u0645\u0646 \u062C\u062F\u064A\u062F \u0627\u0644\u0631\u0627\u0628\u0637 \u0627\u0644\u0630\u064A \u0648\u0635\u0644\u0643 \u0628\u0627\u0644\u0628\u0631\u064A\u062F \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A \u0648\u0633\u062C\u0651\u0644 \u0627\u0644\u062F\u062E\u0648\u0644 \u0628\u0627\u0644\u0639\u0646\u0648\u0627\u0646 \u0627\u0644\u0645\u062F\u0639\u0648.",
        generic: "\u0623\u0646\u062A \u0645\u0633\u062C\u0651\u0644 \u0627\u0644\u062F\u062E\u0648\u0644 \u0628\u0639\u0646\u0648\u0627\u0646 \u063A\u064A\u0631 \u0627\u0644\u0639\u0646\u0648\u0627\u0646 \u0627\u0644\u0645\u062F\u0639\u0648. \u0633\u062C\u0651\u0644 \u0627\u0644\u062E\u0631\u0648\u062C\u060C \u062B\u0645 \u0627\u0641\u062A\u062D \u0645\u0646 \u062C\u062F\u064A\u062F \u0627\u0644\u0631\u0627\u0628\u0637 \u0627\u0644\u0630\u064A \u0648\u0635\u0644\u0643 \u0628\u0627\u0644\u0628\u0631\u064A\u062F \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A \u0648\u0633\u062C\u0651\u0644 \u0627\u0644\u062F\u062E\u0648\u0644 \u0628\u0627\u0644\u0639\u0646\u0648\u0627\u0646 \u0627\u0644\u0645\u062F\u0639\u0648."
      },
      unverified: {
        title: "\u0623\u0643\u0651\u062F \u0639\u0646\u0648\u0627\u0646 \u0628\u0631\u064A\u062F\u0643 \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A \u0623\u0648\u0644\u064B\u0627",
        body: "\u0627\u0641\u062A\u062D \u0631\u0633\u0627\u0644\u0629 BatiFlow \u0627\u0644\u062A\u064A \u0648\u0635\u0644\u062A \u0625\u0644\u0649 \u0639\u0646\u0648\u0627\u0646\u0643 \u0648\u0627\u062A\u0628\u0639 \u0631\u0627\u0628\u0637 \u0627\u0644\u062A\u0623\u0643\u064A\u062F. \u062B\u0645 \u0639\u062F \u0648\u0627\u0641\u062A\u062D \u0631\u0627\u0628\u0637 \u0627\u0644\u062F\u0639\u0648\u0629 \u0645\u0646 \u062C\u062F\u064A\u062F."
      },
      full: {
        title: "\u0644\u0627 \u064A\u0648\u062C\u062F \u0645\u0642\u0639\u062F \u0634\u0627\u063A\u0631 \u0641\u064A \u0647\u0630\u0627 \u0627\u0644\u0645\u0643\u062A\u0628",
        body: "\u062C\u0645\u064A\u0639 \u0645\u0642\u0627\u0639\u062F \u0639\u0631\u0636 \u0627\u0644\u0645\u0643\u062A\u0628 \u0645\u0633\u062A\u0639\u0645\u0644\u0629. \u062A\u0648\u0627\u0635\u0644 \u0645\u0639 \u0627\u0644\u0634\u062E\u0635 \u0627\u0644\u0630\u064A \u062F\u0639\u0627\u0643: \u064A\u0645\u0643\u0646\u0647 \u062A\u062D\u0631\u064A\u0631 \u0645\u0642\u0639\u062F \u0623\u0648 \u0625\u0636\u0627\u0641\u0629 \u0645\u0642\u0639\u062F \u062B\u0645 \u062F\u0639\u0648\u062A\u0643 \u0645\u0646 \u062C\u062F\u064A\u062F."
      },
      already: {
        title: "\u0623\u0646\u062A \u0639\u0636\u0648 \u0641\u064A \u0647\u0630\u0627 \u0627\u0644\u0645\u0643\u062A\u0628 \u0628\u0627\u0644\u0641\u0639\u0644",
        body: "\u062D\u0633\u0627\u0628\u0643 \u0639\u0636\u0648 \u0641\u064A \u0647\u0630\u0647 \u0627\u0644\u0645\u0624\u0633\u0633\u0629 \u0645\u0646 \u0642\u0628\u0644. \u0639\u062F \u0625\u0644\u0649 \u0627\u0644\u0635\u0641\u062D\u0629 \u0627\u0644\u0631\u0626\u064A\u0633\u064A\u0629 \u0644\u0641\u062A\u062D\u0647\u0627."
      },
      other: {
        title: "\u062A\u0639\u0630\u0651\u0631\u062A \u0645\u0639\u0627\u0644\u062C\u0629 \u062F\u0639\u0648\u062A\u0643",
        body: "\u062D\u062F\u062B \u062E\u0637\u0623. \u0628\u064A\u0627\u0646\u0627\u062A\u0643 \u0641\u064A \u0623\u0645\u0627\u0646. \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629\u060C \u0648\u0625\u0646 \u0627\u0633\u062A\u0645\u0631\u0651\u062A \u0627\u0644\u0645\u0634\u0643\u0644\u0629 \u0641\u062A\u0648\u0627\u0635\u0644 \u0645\u0639 \u0627\u0644\u062F\u0639\u0645."
      }
    },
    ready: {
      title: "\u0627\u0644\u0627\u0646\u0636\u0645\u0627\u0645 \u0625\u0644\u0649 {organization}",
      intro: "\u062A\u0645\u062A \u062F\u0639\u0648\u062A\u0643 \u0644\u0644\u0627\u0646\u0636\u0645\u0627\u0645 \u0625\u0644\u0649 \u0645\u0643\u062A\u0628 \u0627\u0644\u062F\u0631\u0627\u0633\u0627\u062A \u0647\u0630\u0627 \u0639\u0644\u0649 BatiFlow. \u062A\u062D\u0642\u0642 \u0645\u0646 \u0627\u0644\u0645\u0639\u0644\u0648\u0645\u0627\u062A \u0623\u062F\u0646\u0627\u0647.",
      organization: "\u0627\u0644\u0645\u0643\u062A\u0628",
      role: "\u0627\u0644\u062F\u0648\u0631",
      email: "\u0627\u0644\u0639\u0646\u0648\u0627\u0646 \u0627\u0644\u0645\u062F\u0639\u0648",
      expires: "\u0635\u0627\u0644\u062D\u0629 \u0625\u0644\u0649 \u063A\u0627\u064A\u0629",
      join: "\u0627\u0644\u0627\u0646\u0636\u0645\u0627\u0645 \u0625\u0644\u0649 {organization}",
      joining: "\u0644\u062D\u0638\u0629 \u0645\u0646 \u0641\u0636\u0644\u0643\u2026"
    }
  },
  rolesMatrix: {
    title: "\u0627\u0644\u0623\u062F\u0648\u0627\u0631 \u0648\u0627\u0644\u0635\u0644\u0627\u062D\u064A\u0627\u062A",
    intro: "\u0647\u0630\u0627 \u0645\u0627 \u064A\u0645\u0643\u0646 \u0644\u0643\u0644 \u062F\u0648\u0631 \u0641\u0639\u0644\u0647 \u0641\u064A \u0645\u0643\u062A\u0628\u0643. \u0647\u0630\u0647 \u0627\u0644\u0623\u062F\u0648\u0627\u0631 \u064A\u062D\u062F\u0651\u062F\u0647\u0627 BatiFlow\u060C \u0648\u0647\u0630\u0627 \u0627\u0644\u062C\u062F\u0648\u0644 \u0644\u0644\u0642\u0631\u0627\u0621\u0629 \u0641\u0642\u0637.",
    regionLabel: "\u062C\u062F\u0648\u0644 \u0627\u0644\u0635\u0644\u0627\u062D\u064A\u0627\u062A \u062D\u0633\u0628 \u0627\u0644\u062F\u0648\u0631 (\u064A\u0645\u0643\u0646 \u062A\u0645\u0631\u064A\u0631\u0647 \u0623\u0641\u0642\u064A\u064B\u0627)",
    caption: "\u0627\u0644\u0635\u0644\u0627\u062D\u064A\u0627\u062A \u0627\u0644\u0645\u0645\u0646\u0648\u062D\u0629 \u0644\u0643\u0644 \u062F\u0648\u0631",
    permission: "\u0627\u0644\u0635\u0644\u0627\u062D\u064A\u0629",
    legend: {
      label: "\u062F\u0644\u064A\u0644 \u0631\u0645\u0648\u0632 \u0627\u0644\u062C\u062F\u0648\u0644"
    },
    marks: {
      yes: {
        text: "\u0645\u0645\u0646\u0648\u062D\u0629",
        legend: "\u0645\u0645\u0646\u0648\u062D\u0629"
      },
      project: {
        symbol: "P",
        text: "\u0645\u0645\u0646\u0648\u062D\u0629 \u0641\u064A \u0645\u0634\u0627\u0631\u064A\u0639\u0647 \u0627\u0644\u062E\u0627\u0635\u0629 \u0641\u0642\u0637",
        legend: "\u0645\u0645\u0646\u0648\u062D\u0629 \u0641\u064A \u0645\u0634\u0627\u0631\u064A\u0639\u0647 \u0627\u0644\u062E\u0627\u0635\u0629 \u0641\u0642\u0637"
      },
      delegable: {
        symbol: "D",
        text: "\u063A\u064A\u0631 \u0645\u0645\u0646\u0648\u062D\u0629 \u0627\u0641\u062A\u0631\u0627\u0636\u064A\u064B\u0627 \u0648\u064A\u0645\u0643\u0646 \u0644\u0644\u0645\u0627\u0644\u0643 \u062A\u0641\u0648\u064A\u0636\u0647\u0627",
        legend: "\u063A\u064A\u0631 \u0645\u0645\u0646\u0648\u062D\u0629 \u0627\u0641\u062A\u0631\u0627\u0636\u064A\u064B\u0627\u060C \u0648\u064A\u0645\u0643\u0646 \u0644\u0644\u0645\u0627\u0644\u0643 \u062A\u0641\u0648\u064A\u0636\u0647\u0627"
      },
      no: {
        text: "\u063A\u064A\u0631 \u0645\u0645\u0646\u0648\u062D\u0629",
        legend: "\u063A\u064A\u0631 \u0645\u0645\u0646\u0648\u062D\u0629"
      }
    },
    areas: {
      organization: "\u0627\u0644\u0645\u0624\u0633\u0633\u0629",
      billing: "\u0627\u0644\u0627\u0634\u062A\u0631\u0627\u0643",
      members: "\u0627\u0644\u0623\u0639\u0636\u0627\u0621 \u0648\u0627\u0644\u0623\u062F\u0648\u0627\u0631",
      audit: "\u0633\u062C\u0644 \u0627\u0644\u062A\u062F\u0642\u064A\u0642",
      clients: "\u0627\u0644\u062D\u0631\u0641\u0627\u0621",
      projects: "\u0627\u0644\u0645\u0634\u0627\u0631\u064A\u0639",
      sharing: "\u0627\u0644\u0645\u0634\u0627\u0631\u0643\u0629 \u0648\u0627\u0644\u0645\u0633\u0627\u062D\u0627\u062A",
      finance: "\u0627\u0644\u0645\u0627\u0644\u064A\u0629",
      time: "\u0627\u0644\u0648\u0642\u062A \u0648\u0627\u0644\u062A\u0643\u0627\u0644\u064A\u0641",
      other: "\u0623\u062E\u0631\u0649"
    },
    permissions: {
      org_update: "\u062A\u0639\u062F\u064A\u0644 \u0645\u0644\u0641 \u0627\u0644\u0645\u0643\u062A\u0628",
      org_fiscal_read: "\u0627\u0644\u0627\u0637\u0644\u0627\u0639 \u0639\u0644\u0649 \u0627\u0644\u0645\u0644\u0641 \u0627\u0644\u062C\u0628\u0627\u0626\u064A",
      org_fiscal_update: "\u062A\u0639\u062F\u064A\u0644 \u0627\u0644\u0645\u0644\u0641 \u0627\u0644\u062C\u0628\u0627\u0626\u064A",
      org_policy_update: "\u062A\u0639\u062F\u064A\u0644 \u0627\u0644\u0633\u064A\u0627\u0633\u0627\u062A (\u0627\u0644\u0645\u0634\u0627\u0631\u0643\u0629 \u0648\u0627\u0644\u0623\u0645\u0627\u0646)",
      org_delete: "\u062D\u0630\u0641 \u0627\u0644\u0645\u0624\u0633\u0633\u0629",
      org_transfer_ownership: "\u0646\u0642\u0644 \u0627\u0644\u0645\u0644\u0643\u064A\u0629",
      data_export: "\u062A\u0635\u062F\u064A\u0631 \u0628\u064A\u0627\u0646\u0627\u062A \u0627\u0644\u0645\u0643\u062A\u0628",
      billing_read: "\u0627\u0644\u0627\u0637\u0644\u0627\u0639 \u0639\u0644\u0649 \u0627\u0644\u0627\u0634\u062A\u0631\u0627\u0643 \u0648\u0641\u0648\u0627\u062A\u064A\u0631 BatiFlow",
      billing_manage: "\u0625\u062F\u0627\u0631\u0629 \u0627\u0644\u0627\u0634\u062A\u0631\u0627\u0643 \u0648\u0627\u0644\u0645\u0642\u0627\u0639\u062F",
      member_read: "\u0639\u0631\u0636 \u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u0623\u0639\u0636\u0627\u0621",
      member_invite: "\u062F\u0639\u0648\u0629 \u0623\u0639\u0636\u0627\u0621",
      member_update: "\u062A\u063A\u064A\u064A\u0631 \u062F\u0648\u0631 \u0639\u0636\u0648",
      member_deactivate: "\u062A\u0639\u0637\u064A\u0644 \u0639\u0636\u0648",
      role_manage: "\u0625\u062F\u0627\u0631\u0629 \u0627\u0644\u0623\u062F\u0648\u0627\u0631",
      audit_read: "\u0627\u0644\u0627\u0637\u0644\u0627\u0639 \u0639\u0644\u0649 \u0633\u062C\u0644 \u0627\u0644\u062A\u062F\u0642\u064A\u0642",
      audit_read_finance: "\u0627\u0644\u0627\u0637\u0644\u0627\u0639 \u0639\u0644\u0649 \u0633\u062C\u0644 \u0627\u0644\u062A\u062F\u0642\u064A\u0642 \u0627\u0644\u0645\u0627\u0644\u064A",
      audit_export: "\u062A\u0635\u062F\u064A\u0631 \u0633\u062C\u0644 \u0627\u0644\u062A\u062F\u0642\u064A\u0642",
      audit_verify: "\u0627\u0644\u062A\u062D\u0642\u0642 \u0645\u0646 \u0633\u0644\u0627\u0645\u0629 \u0633\u062C\u0644 \u0627\u0644\u062A\u062F\u0642\u064A\u0642",
      client_read: "\u0639\u0631\u0636 \u0627\u0644\u062D\u0631\u0641\u0627\u0621",
      client_create: "\u0625\u0646\u0634\u0627\u0621 \u062D\u0631\u0641\u0627\u0621",
      client_update: "\u062A\u0639\u062F\u064A\u0644 \u0628\u064A\u0627\u0646\u0627\u062A \u0627\u0644\u062D\u0631\u0641\u0627\u0621",
      client_archive: "\u0623\u0631\u0634\u0641\u0629 \u0627\u0644\u062D\u0631\u0641\u0627\u0621",
      project_create: "\u0625\u0646\u0634\u0627\u0621 \u0645\u0634\u0627\u0631\u064A\u0639",
      project_view_all: "\u0639\u0631\u0636 \u0643\u0644 \u0627\u0644\u0645\u0634\u0627\u0631\u064A\u0639",
      project_manage_all: "\u0625\u062F\u0627\u0631\u0629 \u0643\u0644 \u0627\u0644\u0645\u0634\u0627\u0631\u064A\u0639",
      project_fees_read: "\u0639\u0631\u0636 \u0623\u062A\u0639\u0627\u0628 \u0627\u0644\u0645\u0634\u0627\u0631\u064A\u0639",
      space_create: "\u0625\u0646\u0634\u0627\u0621 \u0645\u0633\u0627\u062D\u0627\u062A \u062A\u0639\u0627\u0648\u0646",
      space_share_external: "\u0645\u0634\u0627\u0631\u0643\u0629 \u0645\u0633\u0627\u062D\u0629 \u0645\u0639 \u0623\u0637\u0631\u0627\u0641 \u062E\u0627\u0631\u062C\u064A\u0629",
      space_approve_external_membership: "\u0627\u0644\u0645\u0648\u0627\u0641\u0642\u0629 \u0639\u0644\u0649 \u0648\u0635\u0648\u0644 \u0627\u0644\u0645\u062A\u062F\u062E\u0644\u064A\u0646 \u0627\u0644\u062E\u0627\u0631\u062C\u064A\u064A\u0646",
      document_publish_to_client: "\u0646\u0634\u0631 \u0627\u0644\u0648\u062B\u0627\u0626\u0642 \u0644\u0644\u062D\u0631\u064A\u0641",
      quote_read: "\u0639\u0631\u0636 \u0639\u0631\u0648\u0636 \u0627\u0644\u0623\u0633\u0639\u0627\u0631",
      quote_create: "\u0625\u0646\u0634\u0627\u0621 \u0639\u0631\u0648\u0636 \u0623\u0633\u0639\u0627\u0631",
      quote_send: "\u0625\u0631\u0633\u0627\u0644 \u0639\u0631\u0648\u0636 \u0627\u0644\u0623\u0633\u0639\u0627\u0631",
      contract_read: "\u0639\u0631\u0636 \u0627\u0644\u0639\u0642\u0648\u062F",
      contract_manage: "\u0625\u062F\u0627\u0631\u0629 \u0627\u0644\u0639\u0642\u0648\u062F",
      invoice_read: "\u0639\u0631\u0636 \u0627\u0644\u0641\u0648\u0627\u062A\u064A\u0631",
      invoice_create: "\u0625\u0646\u0634\u0627\u0621 \u0641\u0648\u0627\u062A\u064A\u0631",
      invoice_update: "\u062A\u0639\u062F\u064A\u0644 \u0627\u0644\u0641\u0648\u0627\u062A\u064A\u0631 (\u0627\u0644\u0645\u0633\u0648\u062F\u0627\u062A)",
      invoice_issue: "\u0625\u0635\u062F\u0627\u0631 \u0627\u0644\u0641\u0648\u0627\u062A\u064A\u0631",
      einvoicing_manage: "\u0625\u062F\u0627\u0631\u0629 \u0627\u0644\u0641\u0648\u062A\u0631\u0629 \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A\u0629 (TTN)",
      payment_read: "\u0639\u0631\u0636 \u0627\u0644\u0645\u062F\u0641\u0648\u0639\u0627\u062A",
      payment_create: "\u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u0645\u062F\u0641\u0648\u0639\u0627\u062A",
      expense_submit: "\u062A\u0642\u062F\u064A\u0645 \u0628\u064A\u0627\u0646\u0627\u062A \u0627\u0644\u0645\u0635\u0627\u0631\u064A\u0641 \u0627\u0644\u062E\u0627\u0635\u0629",
      expense_read_all: "\u0639\u0631\u0636 \u0643\u0644 \u0628\u064A\u0627\u0646\u0627\u062A \u0627\u0644\u0645\u0635\u0627\u0631\u064A\u0641",
      expense_approve: "\u0627\u0644\u0645\u0648\u0627\u0641\u0642\u0629 \u0639\u0644\u0649 \u0628\u064A\u0627\u0646\u0627\u062A \u0627\u0644\u0645\u0635\u0627\u0631\u064A\u0641",
      finance_dashboard: "\u0639\u0631\u0636 \u0644\u0648\u062D\u0629 \u0627\u0644\u0642\u064A\u0627\u062F\u0629 \u0627\u0644\u0645\u0627\u0644\u064A\u0629",
      finance_export: "\u062A\u0635\u062F\u064A\u0631 \u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A \u0627\u0644\u0645\u0627\u0644\u064A\u0629",
      supplier_manage: "\u0625\u062F\u0627\u0631\u0629 \u0627\u0644\u0645\u0632\u0648\u0651\u062F\u064A\u0646",
      time_submit: "\u062A\u0633\u062C\u064A\u0644 \u0623\u0648\u0642\u0627\u062A \u0627\u0644\u0639\u0645\u0644 \u0627\u0644\u062E\u0627\u0635\u0629",
      time_approve: "\u0627\u0644\u0645\u0648\u0627\u0641\u0642\u0629 \u0639\u0644\u0649 \u0623\u0648\u0642\u0627\u062A \u0627\u0644\u0639\u0645\u0644",
      time_read_all: "\u0639\u0631\u0636 \u0643\u0644 \u0623\u0648\u0642\u0627\u062A \u0627\u0644\u0639\u0645\u0644",
      cost_rate_manage: "\u0625\u062F\u0627\u0631\u0629 \u062A\u0643\u0644\u0641\u0629 \u0627\u0644\u0633\u0627\u0639\u0629",
      payroll_manage: "\u0625\u062F\u0627\u0631\u0629 \u0627\u0644\u0623\u062C\u0648\u0631",
      tender_manage: "\u0625\u062F\u0627\u0631\u0629 \u0637\u0644\u0628\u0627\u062A \u0627\u0644\u0639\u0631\u0648\u0636",
      checklist_manage: "\u0625\u062F\u0627\u0631\u0629 \u0642\u0648\u0627\u0626\u0645 \u0627\u0644\u0645\u0631\u0627\u062C\u0639\u0629"
    }
  },
  orgProfile: {
    title: "\u0627\u0644\u0645\u0624\u0633\u0633\u0629",
    formLabel: "\u0645\u0644\u0641 \u0627\u0644\u0645\u0624\u0633\u0633\u0629",
    noChange: "\u0644\u0627 \u064A\u0648\u062C\u062F \u0645\u0627 \u064A\u064F\u062D\u0641\u0638.",
    saved: "\u062A\u0645 \u062D\u0641\u0638 \u0645\u0644\u0641 \u0627\u0644\u0645\u0624\u0633\u0633\u0629.",
    stale: "\u0639\u062F\u0651\u0644 \u0634\u062E\u0635 \u0622\u062E\u0631 \u0645\u0644\u0641 \u0627\u0644\u0645\u0624\u0633\u0633\u0629 \u0623\u062B\u0646\u0627\u0621 \u062A\u0639\u062F\u064A\u0644\u0643 \u0644\u0647. \u0644\u0645 \u062A\u064F\u062D\u0641\u0638 \u062A\u0639\u062F\u064A\u0644\u0627\u062A\u0643: \u0623\u064F\u0639\u064A\u062F \u062A\u062D\u0645\u064A\u0644 \u0622\u062E\u0631 \u0646\u0633\u062E\u0629 \u0644\u0644\u062A\u0648\u060C \u0641\u0623\u0639\u062F \u062A\u0637\u0628\u064A\u0642 \u062A\u063A\u064A\u064A\u0631\u0627\u062A\u0643.",
    saving: "\u062C\u0627\u0631\u064D \u0627\u0644\u062D\u0641\u0638\u2026",
    saveFailedTitle: "\u062A\u0639\u0630\u0651\u0631 \u062D\u0641\u0638 \u0627\u0644\u0645\u0644\u0641",
    loadFailedTitle: "\u062A\u0639\u0630\u0651\u0631 \u0639\u0631\u0636 \u0627\u0644\u0645\u0644\u0641",
    loadFailedBody: "\u062A\u0639\u0630\u0651\u0631 \u062A\u062D\u0645\u064A\u0644 \u0645\u0644\u0641 \u0627\u0644\u0645\u0624\u0633\u0633\u0629. \u0628\u064A\u0627\u0646\u0627\u062A\u0643 \u0633\u0644\u064A\u0645\u0629. \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629\u060C \u0648\u0625\u0646 \u0627\u0633\u062A\u0645\u0631\u062A \u0627\u0644\u0645\u0634\u0643\u0644\u0629 \u0641\u062A\u0648\u0627\u0635\u0644 \u0645\u0639 \u0627\u0644\u062F\u0639\u0645.",
    taxIdReadOnly: "\u0627\u0644\u0645\u0639\u0631\u0651\u0641 \u0627\u0644\u062C\u0628\u0627\u0626\u064A \u064A\u062D\u062F\u0651\u062F \u0647\u0648\u064A\u0629 \u0645\u0643\u062A\u0628\u0643\u060C \u0644\u0630\u0627 \u0644\u0627 \u064A\u0645\u0643\u0646 \u062A\u063A\u064A\u064A\u0631\u0647 \u0647\u0646\u0627. \u0644\u062A\u0635\u062D\u064A\u062D\u0647 \u062A\u0648\u0627\u0635\u0644 \u0645\u0639 \u062F\u0639\u0645 BatiFlow.",
    notProvided: "\u063A\u064A\u0631 \u0645\u0630\u0643\u0648\u0631",
    sections: {
      identity: {
        title: "\u0647\u0648\u064A\u0629 \u0627\u0644\u0645\u0643\u062A\u0628",
        description: "\u062A\u0638\u0647\u0631 \u0647\u0630\u0647 \u0627\u0644\u0645\u0639\u0644\u0648\u0645\u0627\u062A \u0641\u064A \u0648\u062B\u0627\u0626\u0642\u0643 \u0627\u0644\u0631\u0633\u0645\u064A\u0629."
      },
      references: {
        title: "\u0627\u0644\u0645\u0631\u0627\u062C\u0639 \u0627\u0644\u0645\u0647\u0646\u064A\u0629 \u0648\u0627\u0644\u0644\u063A\u0629",
        description: "\u0627\u062E\u062A\u064A\u0627\u0631\u064A\u0629\u060C \u0628\u0627\u0633\u062A\u062B\u0646\u0627\u0621 \u0627\u0644\u0644\u063A\u0629 \u0627\u0644\u0627\u0641\u062A\u0631\u0627\u0636\u064A\u0629 \u0644\u0648\u062B\u0627\u0626\u0642 \u0627\u0644\u0645\u0624\u0633\u0633\u0629."
      }
    },
    fields: {
      professionalRegistration: {
        label: "\u0627\u0644\u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u0645\u0647\u0646\u064A (\u0627\u062E\u062A\u064A\u0627\u0631\u064A)",
        hint: "\u0645\u062B\u0644\u064B\u0627 \u0631\u0642\u0645 \u0627\u0644\u062A\u0633\u062C\u064A\u0644 \u0644\u062F\u0649 \u0647\u064A\u0626\u0629 \u0627\u0644\u0645\u0647\u0646\u062F\u0633\u064A\u0646 \u0623\u0648 \u0627\u0644\u0645\u0639\u0645\u0627\u0631\u064A\u064A\u0646."
      },
      agreementNumber: {
        label: "\u0631\u0642\u0645 \u0627\u0644\u0627\u0639\u062A\u0645\u0627\u062F (\u0627\u062E\u062A\u064A\u0627\u0631\u064A)",
        hint: "\u0631\u0642\u0645 \u0627\u0639\u062A\u0645\u0627\u062F \u0645\u0643\u062A\u0628 \u0627\u0644\u062F\u0631\u0627\u0633\u0627\u062A \u0625\u0646 \u0648\u064F\u062C\u062F."
      },
      defaultLocale: {
        label: "\u0627\u0644\u0644\u063A\u0629 \u0627\u0644\u0627\u0641\u062A\u0631\u0627\u0636\u064A\u0629 \u0644\u0644\u0645\u0624\u0633\u0633\u0629",
        hint: "\u062A\u064F\u0633\u062A\u0639\u0645\u0644 \u0641\u064A \u0627\u0644\u0648\u062B\u0627\u0626\u0642 \u0648\u0627\u0644\u0631\u0633\u0627\u0626\u0644 \u0627\u0644\u0645\u0631\u0633\u0644\u0629 \u0628\u0627\u0633\u0645 \u0627\u0644\u0645\u0643\u062A\u0628."
      }
    },
    readOnly: {
      title: "\u0645\u0644\u0641 \u0627\u0644\u0645\u0624\u0633\u0633\u0629",
      description: "\u064A\u0645\u0643\u0646\u0643 \u0627\u0644\u0627\u0637\u0644\u0627\u0639 \u0639\u0644\u0649 \u0647\u0630\u0647 \u0627\u0644\u0645\u0639\u0644\u0648\u0645\u0627\u062A. \u0627\u0644\u0645\u0627\u0644\u0643 \u0648\u0627\u0644\u0645\u0634\u0631\u0641\u0648\u0646 \u0648\u062D\u062F\u0647\u0645 \u064A\u0633\u062A\u0637\u064A\u0639\u0648\u0646 \u062A\u0639\u062F\u064A\u0644\u0647\u0627.",
      address: "\u0627\u0644\u0639\u0646\u0648\u0627\u0646"
    },
    logo: {
      title: "\u0627\u0644\u0634\u0639\u0627\u0631",
      description: "\u064A\u0638\u0647\u0631 \u0627\u0644\u0634\u0639\u0627\u0631 \u0639\u0644\u0649 \u0648\u062B\u0627\u0626\u0642\u0643 \u0627\u0644\u0631\u0633\u0645\u064A\u0629. \u0627\u0644\u0635\u064A\u063A \u0627\u0644\u0645\u0642\u0628\u0648\u0644\u0629: PNG \u0623\u0648 JPEG \u0623\u0648 WebP\u060C \u0648\u0628\u062D\u062F \u0623\u0642\u0635\u0649 2 \u0645\u064A\u063A\u0627\u0628\u0627\u064A\u062A.",
      alt: "\u0627\u0644\u0634\u0639\u0627\u0631 \u0627\u0644\u062D\u0627\u0644\u064A \u0644\u0644\u0645\u0624\u0633\u0633\u0629",
      none: "\u0644\u0627 \u064A\u0648\u062C\u062F \u0634\u0639\u0627\u0631 \u0628\u0639\u062F.",
      loadFailed: "\u062A\u0639\u0630\u0651\u0631 \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0634\u0639\u0627\u0631.",
      choose: "\u0627\u062E\u062A\u064A\u0627\u0631 \u0635\u0648\u0631\u0629",
      remove: "\u062D\u0630\u0641 \u0627\u0644\u0634\u0639\u0627\u0631",
      applying: "\u062C\u0627\u0631\u064D \u062A\u0637\u0628\u064A\u0642 \u0627\u0644\u0634\u0639\u0627\u0631\u2026",
      saved: "\u062A\u0645 \u062A\u062D\u062F\u064A\u062B \u0634\u0639\u0627\u0631 \u0627\u0644\u0645\u0624\u0633\u0633\u0629.",
      removed: "\u062A\u0645 \u062D\u0630\u0641 \u0627\u0644\u0634\u0639\u0627\u0631.",
      errors: {
        type: "\u0627\u062E\u062A\u0631 \u0635\u0648\u0631\u0629 \u0628\u0635\u064A\u063A\u0629 PNG \u0623\u0648 JPEG \u0623\u0648 WebP.",
        tooLarge: "\u062A\u062A\u062C\u0627\u0648\u0632 \u0647\u0630\u0647 \u0627\u0644\u0635\u0648\u0631\u0629 {max}. \u0627\u062E\u062A\u0631 \u0635\u0648\u0631\u0629 \u0623\u062E\u0641.",
        notReady: "\u0645\u0627 \u0632\u0627\u0644\u062A \u0627\u0644\u0635\u0648\u0631\u0629 \u0642\u064A\u062F \u0627\u0644\u0641\u062D\u0635. \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629 \u0628\u0639\u062F \u0642\u0644\u064A\u0644.",
        invalid: "\u0647\u0630\u0647 \u0627\u0644\u0635\u0648\u0631\u0629 \u063A\u064A\u0631 \u0645\u0642\u0628\u0648\u0644\u0629: \u0627\u062E\u062A\u0631 \u0635\u0648\u0631\u0629 \u0628\u0635\u064A\u063A\u0629 PNG \u0623\u0648 JPEG \u0623\u0648 WebP \u0628\u062D\u062C\u0645 2 \u0645\u064A\u063A\u0627\u0628\u0627\u064A\u062A \u0639\u0644\u0649 \u0627\u0644\u0623\u0643\u062B\u0631.",
        targetFailed: "\u0645\u062C\u0644\u062F \u0627\u0644\u0634\u0639\u0627\u0631 \u063A\u064A\u0631 \u0645\u062A\u0627\u062D \u062D\u0627\u0644\u064A\u064B\u0627. \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629 \u0628\u0639\u062F \u0642\u0644\u064A\u0644.",
        saveFailed: "\u062A\u0639\u0630\u0651\u0631 \u062D\u0641\u0638 \u0627\u0644\u0634\u0639\u0627\u0631. \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629.",
        removeFailed: "\u062A\u0639\u0630\u0651\u0631 \u062D\u0630\u0641 \u0627\u0644\u0634\u0639\u0627\u0631. \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629."
      }
    },
    directory: {
      title: "\u0638\u0627\u0647\u0631 \u0641\u064A \u062F\u0644\u064A\u0644 \u0628\u062A\u064A \u0641\u0644\u0648",
      description: "\u0639\u0631\u0651\u0641 \u0628\u0645\u0643\u062A\u0628\u0643 \u0644\u062F\u0649 \u0645\u0643\u0627\u062A\u0628 \u0627\u0644\u062F\u0631\u0627\u0633\u0627\u062A \u0627\u0644\u0623\u062E\u0631\u0649 \u0639\u0644\u0649 \u0628\u062A\u064A \u0641\u0644\u0648\u060C \u0645\u062B\u0644\u064B\u0627 \u0644\u062F\u0639\u0648\u062A\u0643\u0645 \u0625\u0644\u0649 \u0641\u0636\u0627\u0621 \u0645\u0634\u062A\u0631\u0643.",
      switchLabel: "\u0625\u0638\u0647\u0627\u0631 \u0645\u0643\u062A\u0628\u064A \u0641\u064A \u0627\u0644\u062F\u0644\u064A\u0644",
      on: "\u0645\u0643\u062A\u0628\u0643\u0645 \u0638\u0627\u0647\u0631 \u0641\u064A \u0627\u0644\u062F\u0644\u064A\u0644.",
      off: "\u0645\u0643\u062A\u0628\u0643\u0645 \u063A\u064A\u0631 \u0638\u0627\u0647\u0631 \u0641\u064A \u0627\u0644\u062F\u0644\u064A\u0644.",
      descriptionLabel: "\u062A\u0642\u062F\u064A\u0645 \u0642\u0635\u064A\u0631 (\u0627\u062E\u062A\u064A\u0627\u0631\u064A)",
      descriptionHint: "\u062C\u0645\u0644\u0629 \u0623\u0648 \u062C\u0645\u0644\u062A\u0627\u0646 \u0639\u0646 \u0645\u0643\u062A\u0628\u0643\u0645 \u0628\u0646\u0635 \u0628\u0633\u064A\u0637 (300 \u062D\u0631\u0641 \u0643\u062D\u062F \u0623\u0642\u0635\u0649).",
      counter: "{count} / {max} \u062D\u0631\u0641",
      shownTitle: "\u0645\u0627 \u062A\u0631\u0627\u0647 \u0627\u0644\u0645\u0643\u0627\u062A\u0628 \u0627\u0644\u0623\u062E\u0631\u0649",
      shown: "\u0627\u0633\u0645 \u0627\u0644\u0645\u0643\u062A\u0628 \u0648\u0627\u062E\u062A\u0635\u0627\u0635\u0627\u062A\u0647 \u0648\u0648\u0644\u0627\u064A\u062A\u0647 \u0648\u0645\u062F\u064A\u0646\u062A\u0647 \u0648\u0647\u0630\u0627 \u0627\u0644\u062A\u0642\u062F\u064A\u0645.",
      notShown: "\u0644\u0627 \u062A\u0638\u0647\u0631 \u0623\u0628\u062F\u064B\u0627 \u0627\u0644\u0623\u0639\u0636\u0627\u0621 \u0648\u0644\u0627 \u0628\u064A\u0627\u0646\u0627\u062A \u0627\u0644\u0627\u062A\u0635\u0627\u0644 \u0648\u0644\u0627 \u0627\u0644\u0645\u0639\u0631\u0651\u0641 \u0627\u0644\u062C\u0628\u0627\u0626\u064A \u0648\u0644\u0627 \u0627\u0644\u0639\u0646\u0648\u0627\u0646.",
      contactNote: "\u064A\u0645\u0643\u0646 \u0644\u0645\u0643\u062A\u0628 \u0622\u062E\u0631 \u0645\u0631\u0627\u0633\u0644\u062A\u0643\u0645 \u0645\u0646 \u0627\u0644\u062F\u0644\u064A\u0644. \u062A\u0635\u0644 \u0627\u0644\u0631\u0633\u0627\u0644\u0629 \u0628\u0627\u0644\u0628\u0631\u064A\u062F \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A \u0625\u0644\u0649 \u0627\u0644\u0645\u0627\u0644\u0643\u064A\u0646 \u0648\u0627\u0644\u0645\u0633\u0624\u0648\u0644\u064A\u0646\u060C \u0648\u064A\u064F\u0631\u0633\u0644 \u0627\u0644\u0631\u062F \u0625\u0644\u064A\u0647\u0645 \u0645\u0628\u0627\u0634\u0631\u0629.",
      readOnly: "\u064A\u0645\u0643\u0646 \u0644\u0644\u0645\u0627\u0644\u0643 \u0648\u0627\u0644\u0645\u0633\u0624\u0648\u0644\u064A\u0646 \u0641\u0642\u0637 \u062A\u063A\u064A\u064A\u0631 \u0627\u0644\u0638\u0647\u0648\u0631 \u0641\u064A \u0627\u0644\u062F\u0644\u064A\u0644.",
      save: "\u062D\u0641\u0638",
      saving: "\u062C\u0627\u0631\u064D \u0627\u0644\u062D\u0641\u0638\u2026",
      saved: "\u062A\u0645 \u062D\u0641\u0638 \u0625\u0639\u062F\u0627\u062F\u0627\u062A \u0627\u0644\u062F\u0644\u064A\u0644.",
      saveFailed: "\u062A\u0639\u0630\u0651\u0631 \u062D\u0641\u0638 \u0625\u0639\u062F\u0627\u062F\u0627\u062A \u0627\u0644\u062F\u0644\u064A\u0644.",
      loadFailedTitle: "\u062A\u0639\u0630\u0651\u0631 \u0639\u0631\u0636 \u0625\u0639\u062F\u0627\u062F\u0627\u062A \u0627\u0644\u062F\u0644\u064A\u0644",
      loadFailedBody: "\u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629\u060C \u0648\u0625\u0630\u0627 \u0627\u0633\u062A\u0645\u0631\u062A \u0627\u0644\u0645\u0634\u0643\u0644\u0629 \u0641\u0627\u062A\u0635\u0644 \u0628\u0627\u0644\u062F\u0639\u0645."
    }
  },
  policies: {
    title: "\u0627\u0644\u0633\u064A\u0627\u0633\u0627\u062A",
    formLabel: "\u0633\u064A\u0627\u0633\u0627\u062A \u0627\u0644\u0645\u0624\u0633\u0633\u0629",
    noChange: "\u0644\u0627 \u064A\u0648\u062C\u062F \u0645\u0627 \u064A\u064F\u062D\u0641\u0638.",
    saved: "\u062A\u0645 \u062D\u0641\u0638 \u0627\u0644\u0633\u064A\u0627\u0633\u0627\u062A.",
    stale: "\u0639\u062F\u0651\u0644 \u0634\u062E\u0635 \u0622\u062E\u0631 \u0627\u0644\u0633\u064A\u0627\u0633\u0627\u062A \u0623\u062B\u0646\u0627\u0621 \u062A\u0639\u062F\u064A\u0644\u0643 \u0644\u0647\u0627. \u0644\u0645 \u062A\u064F\u062D\u0641\u0638 \u062A\u0639\u062F\u064A\u0644\u0627\u062A\u0643: \u0623\u064F\u0639\u064A\u062F \u062A\u062D\u0645\u064A\u0644 \u0622\u062E\u0631 \u0646\u0633\u062E\u0629 \u0644\u0644\u062A\u0648\u060C \u0641\u0623\u0639\u062F \u062A\u0637\u0628\u064A\u0642 \u062A\u063A\u064A\u064A\u0631\u0627\u062A\u0643.",
    saving: "\u062C\u0627\u0631\u064D \u0627\u0644\u062D\u0641\u0638\u2026",
    saveFailedTitle: "\u062A\u0639\u0630\u0651\u0631 \u062D\u0641\u0638 \u0627\u0644\u0633\u064A\u0627\u0633\u0627\u062A",
    loadFailedTitle: "\u062A\u0639\u0630\u0651\u0631 \u0639\u0631\u0636 \u0627\u0644\u0633\u064A\u0627\u0633\u0627\u062A",
    loadFailedBody: "\u062A\u0639\u0630\u0651\u0631 \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0633\u064A\u0627\u0633\u0627\u062A. \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629\u060C \u0648\u0625\u0646 \u0627\u0633\u062A\u0645\u0631\u062A \u0627\u0644\u0645\u0634\u0643\u0644\u0629 \u0641\u062A\u0648\u0627\u0635\u0644 \u0645\u0639 \u0627\u0644\u062F\u0639\u0645.",
    stepUpNote: "\u0644\u062D\u0645\u0627\u064A\u062A\u0643\u060C \u0633\u064A\u064F\u0637\u0644\u0628 \u0645\u0646\u0643 \u062A\u0623\u0643\u064A\u062F \u0647\u0648\u064A\u062A\u0643 \u0639\u0646\u062F \u0627\u0644\u062D\u0641\u0638.",
    sharing: {
      title: "\u0627\u0644\u0645\u0634\u0627\u0631\u0643\u0629 \u0645\u0639 \u0627\u0644\u0623\u0637\u0631\u0627\u0641 \u0627\u0644\u062E\u0627\u0631\u062C\u064A\u0629",
      description: "\u062A\u062D\u062F\u0651\u062F \u0637\u0631\u064A\u0642\u0629 \u062A\u0639\u0627\u0648\u0646 \u0645\u0643\u062A\u0628\u0643 \u0645\u0639 \u0627\u0644\u0634\u0631\u0643\u0627\u0621 \u0648\u0627\u0644\u0639\u0645\u0644\u0627\u0621 \u0648\u0627\u0644\u0645\u0643\u0627\u062A\u0628 \u0627\u0644\u0623\u062E\u0631\u0649.",
      requireApproval: {
        label: "\u0645\u0648\u0627\u0641\u0642\u0629 \u0645\u0637\u0644\u0648\u0628\u0629 \u0644\u0644\u0627\u0646\u0636\u0645\u0627\u0645 \u0625\u0644\u0649 \u0641\u0636\u0627\u0621 \u062E\u0627\u0631\u062C\u064A",
        hint: "\u0639\u0646\u062F \u062A\u0641\u0639\u064A\u0644 \u0647\u0630\u0627 \u0627\u0644\u062E\u064A\u0627\u0631 \u0644\u0627 \u064A\u0633\u062A\u0637\u064A\u0639 \u0627\u0644\u0639\u0636\u0648 \u0627\u0644\u0627\u0646\u0636\u0645\u0627\u0645 \u0625\u0644\u0649 \u0641\u0636\u0627\u0621 \u0645\u0624\u0633\u0633\u0629 \u0623\u062E\u0631\u0649 \u0625\u0644\u0627 \u0628\u0639\u062F \u0645\u0648\u0627\u0641\u0642\u0629 \u0623\u062D\u062F \u0627\u0644\u0645\u0634\u0631\u0641\u064A\u0646.",
        seeRequests: "\u0639\u0631\u0636 \u0627\u0644\u0637\u0644\u0628\u0627\u062A \u0627\u0644\u0645\u0639\u0644\u0651\u0642\u0629"
      },
      managersCanShare: {
        label: "\u064A\u0645\u0643\u0646 \u0644\u0631\u0624\u0633\u0627\u0621 \u0627\u0644\u0645\u0634\u0627\u0631\u064A\u0639 \u0627\u0644\u0645\u0634\u0627\u0631\u0643\u0629",
        hint: "\u0639\u0646\u062F \u062A\u0641\u0639\u064A\u0644 \u0647\u0630\u0627 \u0627\u0644\u062E\u064A\u0627\u0631 \u064A\u0633\u062A\u0637\u064A\u0639 \u0631\u0624\u0633\u0627\u0621 \u0627\u0644\u0645\u0634\u0627\u0631\u064A\u0639 \u0641\u062A\u062D \u0641\u0636\u0627\u0621 \u0645\u0634\u0627\u0631\u064A\u0639\u0647\u0645 \u0623\u0645\u0627\u0645 \u0627\u0644\u0634\u0631\u0643\u0627\u0621. \u0648\u0625\u0644\u0627 \u0641\u0627\u0644\u0645\u0627\u0644\u0643 \u0648\u0627\u0644\u0645\u0634\u0631\u0641\u0648\u0646 \u0648\u062D\u062F\u0647\u0645 \u064A\u0633\u062A\u0637\u064A\u0639\u0648\u0646 \u0630\u0644\u0643."
      },
      domains: {
        label: "\u0627\u0644\u0646\u0637\u0627\u0642\u0627\u062A \u0627\u0644\u0645\u0633\u0645\u0648\u062D \u0628\u0647\u0627 \u0644\u0644\u0636\u064A\u0648\u0641",
        hint: "\u0627\u0643\u062A\u0628 \u0646\u0637\u0627\u0642\u064B\u0627\u060C \u0645\u062B\u0644 client.tn\u060C \u062B\u0645 \u0627\u0636\u063A\u0637 Enter. \u0644\u0646 \u064A\u062A\u0645\u0643\u0646 \u0627\u0644\u0636\u064A\u0648\u0641 \u0627\u0644\u062E\u0627\u0631\u062C\u064A\u0648\u0646 \u0645\u0646 \u0627\u0644\u0627\u0646\u0636\u0645\u0627\u0645 \u0625\u0644\u0627 \u0645\u0646 \u0647\u0630\u0647 \u0627\u0644\u0646\u0637\u0627\u0642\u0627\u062A.",
        placeholder: "client.tn",
        add: "\u0625\u0636\u0627\u0641\u0629",
        empty: "\u0644\u0627 \u064A\u0648\u062C\u062F \u0646\u0637\u0627\u0642: \u064A\u0645\u0643\u0646 \u0644\u0644\u0636\u064A\u0648\u0641 \u0627\u0644\u0642\u062F\u0648\u0645 \u0645\u0646 \u0623\u064A \u0639\u0646\u0648\u0627\u0646 \u0628\u0631\u064A\u062F \u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A.",
        listLabel: "\u0627\u0644\u0646\u0637\u0627\u0642\u0627\u062A \u0627\u0644\u0645\u0633\u0645\u0648\u062D \u0628\u0647\u0627",
        remove: "\u0625\u0632\u0627\u0644\u0629 {domain}",
        errors: {
          empty: "\u0627\u0643\u062A\u0628 \u0646\u0637\u0627\u0642\u064B\u0627\u060C \u0645\u062B\u0644 client.tn.",
          invalid: "\u0647\u0630\u0627 \u0627\u0644\u0646\u0637\u0627\u0642 \u063A\u064A\u0631 \u0635\u0627\u0644\u062D. \u0627\u0643\u062A\u0628\u0647 \u062F\u0648\u0646 \xAB@\xBB \u0648\u062F\u0648\u0646 \u0645\u0633\u0627\u0641\u0627\u062A\u060C \u0645\u062B\u0644 client.tn.",
          duplicate: "\u0647\u0630\u0627 \u0627\u0644\u0646\u0637\u0627\u0642 \u0645\u0648\u062C\u0648\u062F \u0641\u064A \u0627\u0644\u0642\u0627\u0626\u0645\u0629 \u0628\u0627\u0644\u0641\u0639\u0644.",
          limit: "\u0644\u0627 \u064A\u0645\u0643\u0646 \u0623\u0646 \u062A\u062A\u062C\u0627\u0648\u0632 \u0627\u0644\u0642\u0627\u0626\u0645\u0629 {max} \u0646\u0637\u0627\u0642\u064B\u0627."
        }
      }
    },
    security: {
      title: "\u0623\u0645\u0627\u0646 \u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062F\u062E\u0648\u0644",
      description: "\u062A\u062D\u062F\u0651\u062F \u0645\u062F\u0629 \u0627\u0644\u062C\u0644\u0633\u0627\u062A \u0648\u0645\u0633\u062A\u0648\u0649 \u0627\u0644\u062D\u0645\u0627\u064A\u0629 \u0627\u0644\u0645\u0637\u0644\u0648\u0628 \u0645\u0646 \u062C\u0645\u064A\u0639 \u0627\u0644\u0623\u0639\u0636\u0627\u0621.",
      sessionHours: {
        label: "\u0623\u0642\u0635\u0649 \u0645\u062F\u0629 \u0644\u0644\u062C\u0644\u0633\u0629",
        hint: "\u0628\u0639\u062F \u0647\u0630\u0647 \u0627\u0644\u0645\u062F\u0629 \u064A\u062C\u0628 \u0639\u0644\u0649 \u0627\u0644\u0639\u0636\u0648 \u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062F\u062E\u0648\u0644 \u0645\u0646 \u062C\u062F\u064A\u062F \u062D\u062A\u0649 \u0644\u0648 \u0643\u0627\u0646 \u0646\u0634\u0637\u064B\u0627.",
        default: "\u0627\u0644\u0645\u062F\u0629 \u0627\u0644\u0627\u0641\u062A\u0631\u0627\u0636\u064A\u0629 \u0644\u0644\u0645\u0646\u0635\u0629 (12 \u0633\u0627\u0639\u0629)",
        option: "{count, plural, one {\u0633\u0627\u0639\u0629 \u0648\u0627\u062D\u062F\u0629} two {\u0633\u0627\u0639\u062A\u0627\u0646} few {# \u0633\u0627\u0639\u0627\u062A} many {# \u0633\u0627\u0639\u0629} other {# \u0633\u0627\u0639\u0629}}"
      },
      mfaForAll: {
        label: "\u0627\u0644\u062A\u062D\u0642\u0642 \u0628\u062E\u0637\u0648\u062A\u064A\u0646 \u0644\u062C\u0645\u064A\u0639 \u0627\u0644\u0623\u0639\u0636\u0627\u0621",
        hint: "\u0639\u0646\u062F \u062A\u0641\u0639\u064A\u0644 \u0647\u0630\u0627 \u0627\u0644\u062E\u064A\u0627\u0631 \u064A\u062C\u0628 \u0639\u0644\u0649 \u0643\u0644 \u0639\u0636\u0648 \u0625\u0639\u062F\u0627\u062F \u062A\u0637\u0628\u064A\u0642 \u0645\u0635\u0627\u062F\u0642\u0629 \u0639\u0646\u062F \u062F\u062E\u0648\u0644\u0647 \u0627\u0644\u062A\u0627\u0644\u064A\u060C \u0648\u0625\u0644\u0627 \u0644\u0646 \u064A\u0633\u062A\u0637\u064A\u0639 \u0627\u0633\u062A\u062E\u062F\u0627\u0645 BatiFlow. \u0627\u0644\u0645\u0627\u0644\u0643 \u0648\u0627\u0644\u0645\u0634\u0631\u0641\u0648\u0646 \u0648\u0627\u0644\u0645\u062D\u0627\u0633\u0628\u0648\u0646 \u0645\u0644\u0632\u0645\u0648\u0646 \u0628\u0630\u0644\u0643 \u0623\u0635\u0644\u064B\u0627."
      }
    }
  },
  fiscal: {
    title: "\u0627\u0644\u0645\u0644\u0641 \u0627\u0644\u062C\u0628\u0627\u0626\u064A",
    loadFailedTitle: "\u062A\u0639\u0630\u0651\u0631 \u0639\u0631\u0636 \u0627\u0644\u0645\u0644\u0641 \u0627\u0644\u062C\u0628\u0627\u0626\u064A",
    loadFailedBody: "\u062A\u0639\u0630\u0651\u0631 \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0645\u0644\u0641 \u0627\u0644\u062C\u0628\u0627\u0626\u064A. \u0628\u064A\u0627\u0646\u0627\u062A\u0643 \u0633\u0644\u064A\u0645\u0629. \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629\u060C \u0648\u0625\u0646 \u0627\u0633\u062A\u0645\u0631\u062A \u0627\u0644\u0645\u0634\u0643\u0644\u0629 \u0641\u062A\u0648\u0627\u0635\u0644 \u0645\u0639 \u0627\u0644\u062F\u0639\u0645.",
    empty: {
      title: "\u0644\u0627 \u064A\u0648\u062C\u062F \u0645\u0644\u0641 \u062C\u0628\u0627\u0626\u064A \u0628\u0639\u062F",
      description: "\u064A\u062D\u062F\u0651\u062F \u0627\u0644\u0645\u0644\u0641 \u0627\u0644\u062C\u0628\u0627\u0626\u064A \u0627\u0644\u0623\u062F\u0627\u0621 \u0639\u0644\u0649 \u0627\u0644\u0642\u064A\u0645\u0629 \u0627\u0644\u0645\u0636\u0627\u0641\u0629 \u0648\u0627\u0644\u0646\u0638\u0627\u0645 \u0627\u0644\u062C\u0628\u0627\u0626\u064A \u0648\u0627\u0644\u062E\u0635\u0645 \u0645\u0646 \u0627\u0644\u0645\u0648\u0631\u062F \u0648\u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A \u0627\u0644\u0628\u0646\u0643\u064A\u0629 \u0644\u0641\u0648\u0627\u062A\u064A\u0631\u0643."
    },
    current: {
      title: "\u0627\u0644\u0646\u0633\u062E\u0629 \u0627\u0644\u0633\u0627\u0631\u064A\u0629",
      description: "\u062A\u064F\u0637\u0628\u064E\u0651\u0642 \u0647\u0630\u0647 \u0627\u0644\u0642\u064A\u0645 \u0639\u0644\u0649 \u0627\u0644\u0641\u0648\u0627\u062A\u064A\u0631 \u0627\u0644\u062C\u062F\u064A\u062F\u0629."
    },
    history: {
      title: "\u0633\u062C\u0644 \u0627\u0644\u0646\u0633\u062E",
      description: "\u0627\u0644\u0646\u0633\u062E\u0629 \u0627\u0644\u062C\u062F\u064A\u062F\u0629 \u0644\u0627 \u062A\u063A\u064A\u0651\u0631 \u0627\u0644\u0642\u062F\u064A\u0645\u0629 \u0623\u0628\u062F\u064B\u0627: \u062A\u062D\u062A\u0641\u0638 \u0627\u0644\u0641\u0648\u0627\u062A\u064A\u0631 \u0627\u0644\u0635\u0627\u062F\u0631\u0629 \u0628\u0627\u0644\u0646\u0633\u062E\u0629 \u0627\u0644\u062A\u064A \u0643\u0627\u0646\u062A \u0633\u0627\u0631\u064A\u0629.",
      caption: "\u0646\u0633\u062E \u0627\u0644\u0645\u0644\u0641 \u0627\u0644\u062C\u0628\u0627\u0626\u064A \u0645\u0646 \u0627\u0644\u0623\u062D\u062F\u062B \u0625\u0644\u0649 \u0627\u0644\u0623\u0642\u062F\u0645"
    },
    columns: {
      effectiveFrom: "\u0633\u0627\u0631\u064A\u0629 \u0645\u0646\u0630",
      status: "\u0627\u0644\u062D\u0627\u0644\u0629",
      createdBy: "\u0623\u0646\u0634\u0623\u0647\u0627",
      vat: "\u0627\u0644\u0623\u062F\u0627\u0621 \u0639\u0644\u0649 \u0627\u0644\u0642\u064A\u0645\u0629 \u0627\u0644\u0645\u0636\u0627\u0641\u0629",
      regime: "\u0627\u0644\u0646\u0638\u0627\u0645 \u0627\u0644\u062C\u0628\u0627\u0626\u064A",
      withholding: "\u0627\u0644\u0635\u0641\u0629 \u0628\u0627\u0644\u0646\u0633\u0628\u0629 \u0625\u0644\u0649 \u0627\u0644\u062E\u0635\u0645 \u0645\u0646 \u0627\u0644\u0645\u0648\u0631\u062F",
      footer: "\u062A\u0630\u064A\u064A\u0644 \u0627\u0644\u0641\u0648\u0627\u062A\u064A\u0631",
      bank: "\u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A \u0627\u0644\u0628\u0646\u0643\u064A\u0629"
    },
    status: {
      current: "\u0633\u0627\u0631\u064A\u0629",
      scheduled: "\u0645\u0628\u0631\u0645\u062C\u0629",
      past: "\u0633\u0627\u0628\u0642\u0629"
    },
    values: {
      vatYes: "\u062E\u0627\u0636\u0639 \u0644\u0644\u0623\u062F\u0627\u0621 \u0639\u0644\u0649 \u0627\u0644\u0642\u064A\u0645\u0629 \u0627\u0644\u0645\u0636\u0627\u0641\u0629",
      vatNo: "\u063A\u064A\u0631 \u062E\u0627\u0636\u0639 \u0644\u0644\u0623\u062F\u0627\u0621 \u0639\u0644\u0649 \u0627\u0644\u0642\u064A\u0645\u0629 \u0627\u0644\u0645\u0636\u0627\u0641\u0629",
      noFooter: "\u0644\u0627 \u0634\u064A\u0621"
    },
    regimes: {
      real: "\u0627\u0644\u0646\u0638\u0627\u0645 \u0627\u0644\u062D\u0642\u064A\u0642\u064A",
      flat_rate: "\u0627\u0644\u0646\u0638\u0627\u0645 \u0627\u0644\u062A\u0642\u062F\u064A\u0631\u064A"
    },
    withholding: {
      legal_entity: "\u0634\u062E\u0635 \u0645\u0639\u0646\u0648\u064A",
      real_regime: "\u0634\u062E\u0635 \u0637\u0628\u064A\u0639\u064A \u062E\u0627\u0636\u0639 \u0644\u0644\u0646\u0638\u0627\u0645 \u0627\u0644\u062D\u0642\u064A\u0642\u064A",
      other: "\u0623\u062E\u0631\u0649"
    },
    bank: {
      none: "\u0644\u0627 \u0634\u064A\u0621",
      show: "\u0625\u0638\u0647\u0627\u0631 \u0627\u0644\u0647\u0648\u064A\u0629 \u0627\u0644\u0628\u0646\u0643\u064A\u0629 \u0643\u0627\u0645\u0644\u0629",
      hide: "\u0625\u062E\u0641\u0627\u0621",
      rib: "\u0627\u0644\u0647\u0648\u064A\u0629 \u0627\u0644\u0628\u0646\u0643\u064A\u0629 (RIB)",
      iban: "IBAN",
      copyRib: "\u0646\u0633\u062E \u0627\u0644\u0647\u0648\u064A\u0629 \u0627\u0644\u0628\u0646\u0643\u064A\u0629",
      copyIban: "\u0646\u0633\u062E IBAN",
      copied: "\u062A\u0645 \u0627\u0644\u0646\u0633\u062E \u0625\u0644\u0649 \u0627\u0644\u062D\u0627\u0641\u0638\u0629.",
      copyFailed: "\u062A\u0639\u0630\u0651\u0631 \u0627\u0644\u0646\u0633\u062E. \u062D\u062F\u0651\u062F \u0627\u0644\u0631\u0642\u0645 \u0648\u0627\u0646\u0633\u062E\u0647 \u064A\u062F\u0648\u064A\u064B\u0627.",
      stepUp: "\u0623\u0643\u0651\u062F \u0647\u0648\u064A\u062A\u0643 \u0641\u064A \u0627\u0644\u0646\u0627\u0641\u0630\u0629 \u0627\u0644\u062A\u064A \u0641\u064F\u062A\u062D\u062A \u0644\u0644\u062A\u0648\u060C \u062B\u0645 \u0627\u0636\u063A\u0637 \u0645\u0646 \u062C\u062F\u064A\u062F \u0639\u0644\u0649 \xAB\u0625\u0638\u0647\u0627\u0631 \u0627\u0644\u0647\u0648\u064A\u0629 \u0627\u0644\u0628\u0646\u0643\u064A\u0629 \u0643\u0627\u0645\u0644\u0629\xBB.",
      loading: "\u062C\u0627\u0631\u064D \u0627\u0644\u062A\u062D\u0645\u064A\u0644\u2026"
    },
    newVersion: {
      button: "\u0646\u0633\u062E\u0629 \u062C\u062F\u064A\u062F\u0629",
      title: "\u0646\u0633\u062E\u0629 \u062C\u062F\u064A\u062F\u0629 \u0645\u0646 \u0627\u0644\u0645\u0644\u0641 \u0627\u0644\u062C\u0628\u0627\u0626\u064A",
      intro: "\u062A\u064F\u0633\u062A\u0639\u0627\u062F \u0642\u064A\u0645 \u0627\u0644\u0646\u0633\u062E\u0629 \u0627\u0644\u0633\u0627\u0631\u064A\u0629: \u063A\u064A\u0651\u0631 \u0645\u0627 \u062A\u063A\u064A\u0651\u0631 \u0641\u0642\u0637. \u062A\u0628\u0642\u0649 \u0627\u0644\u0646\u0633\u062E\u0629 \u0627\u0644\u0633\u0627\u0628\u0642\u0629 \u0645\u062D\u0641\u0648\u0638\u0629.",
      start: {
        legend: "\u0628\u062F\u0627\u064A\u0629 \u0627\u0644\u062A\u0637\u0628\u064A\u0642",
        now: "\u0627\u0644\u0622\u0646",
        later: "\u0641\u064A \u062A\u0627\u0631\u064A\u062E \u0644\u0627\u062D\u0642",
        date: "\u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0628\u062F\u0627\u064A\u0629"
      },
      vat: {
        label: "\u062E\u0627\u0636\u0639 \u0644\u0644\u0623\u062F\u0627\u0621 \u0639\u0644\u0649 \u0627\u0644\u0642\u064A\u0645\u0629 \u0627\u0644\u0645\u0636\u0627\u0641\u0629"
      },
      withholdingHint: "\u064A\u062D\u062F\u0651\u062F \u0627\u0644\u062E\u0635\u0645 \u0645\u0646 \u0627\u0644\u0645\u0648\u0631\u062F \u0627\u0644\u0645\u0637\u0628\u0651\u0642 \u0639\u0644\u0649 \u0641\u0648\u0627\u062A\u064A\u0631\u0643.",
      footerHint: "\u0646\u0635 \u064A\u0638\u0647\u0631 \u0623\u0633\u0641\u0644 \u0641\u0648\u0627\u062A\u064A\u0631\u0643 (\u0625\u0634\u0639\u0627\u0631\u0627\u062A \u0642\u0627\u0646\u0648\u0646\u064A\u0629\u060C \u0634\u0631\u0648\u0637 \u0627\u0644\u062F\u0641\u0639\u2026).",
      bank: {
        legend: "\u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A \u0627\u0644\u0628\u0646\u0643\u064A\u0629 (\u0627\u062E\u062A\u064A\u0627\u0631\u064A)",
        hint: "\u0644\u0627 \u062A\u064F\u0646\u0642\u0644 \u0645\u0646 \u0627\u0644\u0646\u0633\u062E\u0629 \u0627\u0644\u0633\u0627\u0628\u0642\u0629: \u0623\u062F\u062E\u0644\u0647\u0627 \u0645\u0646 \u062C\u062F\u064A\u062F\u060C \u0623\u0648 \u0627\u062A\u0631\u0643\u0647\u0627 \u0641\u0627\u0631\u063A\u0629 \u0644\u0646\u0633\u062E\u0629 \u062F\u0648\u0646 \u0628\u064A\u0627\u0646\u0627\u062A \u0628\u0646\u0643\u064A\u0629.",
        name: "\u0627\u0633\u0645 \u0627\u0644\u0628\u0646\u0643",
        rib: "\u0627\u0644\u0647\u0648\u064A\u0629 \u0627\u0644\u0628\u0646\u0643\u064A\u0629 (RIB)",
        ribHint: "20 \u0631\u0642\u0645\u064B\u0627\u060C \u062F\u0648\u0646 \u0627\u0644\u0628\u0627\u062F\u0626\u0629 \xABTN59\xBB."
      },
      stepUpNote: "\u0644\u062D\u0645\u0627\u064A\u062A\u0643\u060C \u0633\u064A\u064F\u0637\u0644\u0628 \u0645\u0646\u0643 \u062A\u0623\u0643\u064A\u062F \u0647\u0648\u064A\u062A\u0643 \u0639\u0646\u062F \u0627\u0644\u062D\u0641\u0638.",
      saving: "\u062C\u0627\u0631\u064D \u0627\u0644\u062D\u0641\u0638\u2026",
      submit: "\u0625\u0646\u0634\u0627\u0621 \u0627\u0644\u0646\u0633\u062E\u0629",
      done: "\u0623\u0635\u0628\u062D\u062A \u0627\u0644\u0646\u0633\u062E\u0629 \u0627\u0644\u062C\u062F\u064A\u062F\u0629 \u0645\u0646 \u0627\u0644\u0645\u0644\u0641 \u0627\u0644\u062C\u0628\u0627\u0626\u064A \u0633\u0627\u0631\u064A\u0629.",
      doneLater: "\u062A\u0645\u062A \u0628\u0631\u0645\u062C\u0629 \u0627\u0644\u0646\u0633\u062E\u0629 \u0627\u0644\u062C\u062F\u064A\u062F\u0629 \u0645\u0646 \u0627\u0644\u0645\u0644\u0641 \u0627\u0644\u062C\u0628\u0627\u0626\u064A.",
      errors: {
        dateRequired: "\u0627\u062E\u062A\u0631 \u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0628\u062F\u0627\u064A\u0629.",
        datePast: "\u0644\u0627 \u064A\u0645\u0643\u0646 \u0623\u0646 \u064A\u0643\u0648\u0646 \u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0628\u062F\u0627\u064A\u0629 \u0641\u064A \u0627\u0644\u0645\u0627\u0636\u064A.",
        footerTooLong: "\u0644\u0627 \u064A\u0645\u0643\u0646 \u0623\u0646 \u064A\u062A\u062C\u0627\u0648\u0632 \u0627\u0644\u062A\u0630\u064A\u064A\u0644 {max} \u062D\u0631\u0641\u064B\u0627.",
        bankNameRequired: "\u0627\u0643\u062A\u0628 \u0627\u0633\u0645 \u0627\u0644\u0628\u0646\u0643.",
        bankNameTooLong: "\u0644\u0627 \u064A\u0645\u0643\u0646 \u0623\u0646 \u064A\u062A\u062C\u0627\u0648\u0632 \u0627\u0633\u0645 \u0627\u0644\u0628\u0646\u0643 {max} \u062D\u0631\u0641\u064B\u0627.",
        ribInvalid: "\u062A\u062A\u0643\u0648\u0646 \u0627\u0644\u0647\u0648\u064A\u0629 \u0627\u0644\u0628\u0646\u0643\u064A\u0629 \u0645\u0646 20 \u0631\u0642\u0645\u064B\u0627. \u062A\u062D\u0642\u0642 \u0645\u0646\u0647\u0627 \u062B\u0645 \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629."
      }
    },
    series: {
      title: "\u0633\u0644\u0627\u0633\u0644 \u062A\u0631\u0642\u064A\u0645 \u0627\u0644\u0641\u0648\u0627\u062A\u064A\u0631",
      description: "\u0644\u0643\u0644 \u0633\u0644\u0633\u0644\u0629 \u0639\u062F\u0651\u0627\u062F \u062E\u0627\u0635 \u0628\u0647\u0627 \u062F\u0648\u0646 \u0641\u062C\u0648\u0627\u062A. \u062A\u064F\u0642\u062A\u0631\u062D \u0627\u0644\u0633\u0644\u0633\u0644\u0629 \u0627\u0644\u0627\u0641\u062A\u0631\u0627\u0636\u064A\u0629 \u0639\u0644\u0649 \u0627\u0644\u0641\u0648\u0627\u062A\u064A\u0631 \u0627\u0644\u062C\u062F\u064A\u062F\u0629.",
      caption: "\u0633\u0644\u0627\u0633\u0644 \u062A\u0631\u0642\u064A\u0645 \u0627\u0644\u0641\u0648\u0627\u062A\u064A\u0631",
      add: "\u0625\u0636\u0627\u0641\u0629 \u0633\u0644\u0633\u0644\u0629",
      addTitle: "\u0625\u0636\u0627\u0641\u0629 \u0633\u0644\u0633\u0644\u0629 \u0641\u0648\u0627\u062A\u064A\u0631",
      editTitle: "\u062A\u0639\u062F\u064A\u0644 \u0627\u0644\u0633\u0644\u0633\u0644\u0629 {code}",
      codeHint: "\u0645\u0646 1 \u0625\u0644\u0649 10 \u0623\u062D\u0631\u0641 \u0623\u0648 \u0623\u0631\u0642\u0627\u0645\u060C \u0645\u062B\u0644 FAC. \u0644\u0627 \u064A\u0645\u0643\u0646 \u062A\u063A\u064A\u064A\u0631 \u0627\u0644\u0631\u0645\u0632 \u0644\u0627\u062D\u0642\u064B\u0627.",
      codeFixed: "\u0644\u0627 \u064A\u0645\u0643\u0646 \u062A\u063A\u064A\u064A\u0631 \u0627\u0644\u0631\u0645\u0632: \u0627\u0644\u0623\u0631\u0642\u0627\u0645 \u0627\u0644\u0635\u0627\u062F\u0631\u0629 \u0633\u0627\u0628\u0642\u064B\u0627 \u062A\u0634\u064A\u0631 \u0625\u0644\u064A\u0647.",
      prefixHint: "\u0628\u062F\u0627\u064A\u0629 \u0643\u0644 \u0631\u0642\u0645\u060C \u0645\u062B\u0644 \xABFAC-\xBB.",
      resetYearly: {
        label: "\u0625\u0639\u0627\u062F\u0629 \u0627\u0644\u062A\u0631\u0642\u064A\u0645 \u0643\u0644 \u0633\u0646\u0629",
        hint: "\u0639\u0646\u062F \u062A\u0641\u0639\u064A\u0644 \u0647\u0630\u0627 \u0627\u0644\u062E\u064A\u0627\u0631 \u064A\u0639\u0648\u062F \u0627\u0644\u0639\u062F\u0651\u0627\u062F \u0625\u0644\u0649 1 \u0641\u064A \u0628\u062F\u0627\u064A\u0629 \u0643\u0644 \u0633\u0646\u0629."
      },
      makeDefault: "\u0627\u0644\u0633\u0644\u0633\u0644\u0629 \u0627\u0644\u0627\u0641\u062A\u0631\u0627\u0636\u064A\u0629",
      saving: "\u062C\u0627\u0631\u064D \u0627\u0644\u062D\u0641\u0638\u2026",
      created: "\u062A\u0645\u062A \u0625\u0636\u0627\u0641\u0629 \u0627\u0644\u0633\u0644\u0633\u0644\u0629 {code}.",
      updated: "\u062A\u0645 \u062A\u0639\u062F\u064A\u0644 \u0627\u0644\u0633\u0644\u0633\u0644\u0629 {code}.",
      stale: "\u0639\u062F\u0651\u0644 \u0634\u062E\u0635 \u0622\u062E\u0631 \u0647\u0630\u0647 \u0627\u0644\u0633\u0644\u0633\u0644\u0629. \u0623\u064F\u0639\u064A\u062F \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0642\u0627\u0626\u0645\u0629 \u0644\u0644\u062A\u0648: \u062A\u062D\u0642\u0642 \u0645\u0646\u0647\u0627 \u062B\u0645 \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629.",
      nowDefault: "\u0623\u0635\u0628\u062D\u062A \u0627\u0644\u0633\u0644\u0633\u0644\u0629 {code} \u0647\u064A \u0627\u0644\u0633\u0644\u0633\u0644\u0629 \u0627\u0644\u0627\u0641\u062A\u0631\u0627\u0636\u064A\u0629.",
      deleted: "\u062A\u0645 \u062D\u0630\u0641 \u0627\u0644\u0633\u0644\u0633\u0644\u0629 {code}.",
      deleteTitle: "\u062D\u0630\u0641 \u0627\u0644\u0633\u0644\u0633\u0644\u0629 {code}\u061F",
      deleteBody: "\u0644\u0646 \u062A\u064F\u0642\u062A\u0631\u062D \u0647\u0630\u0647 \u0627\u0644\u0633\u0644\u0633\u0644\u0629 \u0628\u0639\u062F \u0627\u0644\u0622\u0646. \u0644\u0627 \u064A\u0645\u0643\u0646 \u0627\u0644\u062A\u0631\u0627\u062C\u0639 \u0639\u0646 \u0647\u0630\u0627 \u0627\u0644\u0625\u062C\u0631\u0627\u0621.",
      resetYes: "\u0643\u0644 \u0633\u0646\u0629",
      resetNo: "\u0623\u0628\u062F\u064B\u0627",
      defaultBadge: "\u0627\u0641\u062A\u0631\u0627\u0636\u064A\u0629",
      emptyTitle: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0633\u0644\u0627\u0633\u0644 \u0641\u0648\u0627\u062A\u064A\u0631",
      emptyDescription: "\u0623\u0636\u0641 \u0633\u0644\u0633\u0644\u0629 \u0644\u062A\u0631\u0642\u064A\u0645 \u0641\u0648\u0627\u062A\u064A\u0631\u0643.",
      loadFailedTitle: "\u062A\u0639\u0630\u0651\u0631 \u0639\u0631\u0636 \u0627\u0644\u0633\u0644\u0627\u0633\u0644",
      loadFailedBody: "\u062A\u0639\u0630\u0651\u0631 \u062A\u062D\u0645\u064A\u0644 \u0633\u0644\u0627\u0633\u0644 \u0627\u0644\u0641\u0648\u0627\u062A\u064A\u0631. \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629\u060C \u0648\u0625\u0646 \u0627\u0633\u062A\u0645\u0631\u062A \u0627\u0644\u0645\u0634\u0643\u0644\u0629 \u0641\u062A\u0648\u0627\u0635\u0644 \u0645\u0639 \u0627\u0644\u062F\u0639\u0645.",
      columns: {
        code: "\u0627\u0644\u0631\u0645\u0632",
        prefix: "\u0627\u0644\u0628\u0627\u062F\u0626\u0629",
        resetYearly: "\u0625\u0639\u0627\u062F\u0629 \u0627\u0644\u062A\u0635\u0641\u064A\u0631",
        default: "\u0627\u0644\u0633\u0644\u0633\u0644\u0629 \u0627\u0644\u0627\u0641\u062A\u0631\u0627\u0636\u064A\u0629",
        actions: "\u0627\u0644\u0625\u062C\u0631\u0627\u0621\u0627\u062A"
      },
      actions: {
        open: "\u0625\u062C\u0631\u0627\u0621\u0627\u062A \u0627\u0644\u0633\u0644\u0633\u0644\u0629 {code}",
        edit: "\u062A\u0639\u062F\u064A\u0644",
        makeDefault: "\u062C\u0639\u0644\u0647\u0627 \u0627\u0641\u062A\u0631\u0627\u0636\u064A\u0629",
        delete: "\u062D\u0630\u0641"
      },
      errors: {
        codeInvalid: "\u064A\u062A\u0643\u0648\u0646 \u0627\u0644\u0631\u0645\u0632 \u0645\u0646 1 \u0625\u0644\u0649 10 \u0623\u062D\u0631\u0641 \u0623\u0648 \u0623\u0631\u0642\u0627\u0645\u060C \u062F\u0648\u0646 \u0645\u0633\u0627\u0641\u0627\u062A \u0623\u0648 \u0639\u0644\u0627\u0645\u0627\u062A \u062A\u0634\u0643\u064A\u0644.",
        codeTaken: "\u0633\u0644\u0633\u0644\u0629 \u0623\u062E\u0631\u0649 \u062A\u0633\u062A\u0639\u0645\u0644 \u0647\u0630\u0627 \u0627\u0644\u0631\u0645\u0632 \u0628\u0627\u0644\u0641\u0639\u0644. \u0627\u062E\u062A\u0631 \u0631\u0645\u0632\u064B\u0627 \u0622\u062E\u0631.",
        prefixRequired: "\u0627\u0643\u062A\u0628 \u0628\u0627\u062F\u0626\u0629 \u0627\u0644\u0623\u0631\u0642\u0627\u0645.",
        prefixTooLong: "\u0644\u0627 \u064A\u0645\u0643\u0646 \u0623\u0646 \u062A\u062A\u062C\u0627\u0648\u0632 \u0627\u0644\u0628\u0627\u062F\u0626\u0629 {max} \u062D\u0631\u0641\u064B\u0627.",
        isDefault: "\u0644\u0627 \u064A\u0645\u0643\u0646 \u062D\u0630\u0641 \u0627\u0644\u0633\u0644\u0633\u0644\u0629 \u0627\u0644\u0627\u0641\u062A\u0631\u0627\u0636\u064A\u0629. \u0627\u062C\u0639\u0644 \u0633\u0644\u0633\u0644\u0629 \u0623\u062E\u0631\u0649 \u0627\u0641\u062A\u0631\u0627\u0636\u064A\u0629 \u0623\u0648\u0644\u064B\u0627."
      }
    }
  },
  auditLog: {
    title: "\u0633\u062C\u0644 \u0627\u0644\u062A\u062F\u0642\u064A\u0642",
    tableCaption: "\u0623\u062D\u062F\u0627\u062B \u0633\u062C\u0644 \u0627\u0644\u062A\u062F\u0642\u064A\u0642 \u0645\u0646 \u0627\u0644\u0623\u062D\u062F\u062B \u0625\u0644\u0649 \u0627\u0644\u0623\u0642\u062F\u0645",
    financeOnly: "\u0628\u0635\u0641\u062A\u0643 \u0645\u062D\u0627\u0633\u0628\u064B\u0627\u060C \u062A\u0631\u0649 \u0627\u0644\u0623\u062D\u062F\u0627\u062B \u0627\u0644\u0645\u0627\u0644\u064A\u0629 \u0641\u0642\u0637: \u0627\u0644\u0641\u0648\u0627\u062A\u064A\u0631 \u0648\u0639\u0631\u0648\u0636 \u0627\u0644\u0623\u0633\u0639\u0627\u0631 \u0648\u0627\u0644\u0639\u0642\u0648\u062F \u0648\u0627\u0644\u0645\u062F\u0641\u0648\u0639\u0627\u062A \u0648\u0627\u0644\u0645\u0635\u0627\u0631\u064A\u0641 \u0648\u0627\u0644\u0625\u0639\u062F\u0627\u062F\u0627\u062A \u0627\u0644\u062C\u0628\u0627\u0626\u064A\u0629. \u0628\u0627\u0642\u064A \u0627\u0644\u0623\u062D\u062F\u0627\u062B \u0645\u062E\u0635\u0635\u0629 \u0644\u0644\u0645\u0627\u0644\u0643 \u0648\u0627\u0644\u0645\u0634\u0631\u0641\u064A\u0646.",
    loadFailedTitle: "\u062A\u0639\u0630\u0651\u0631 \u0639\u0631\u0636 \u0627\u0644\u0633\u062C\u0644",
    loadFailedBody: "\u062A\u0639\u0630\u0651\u0631 \u062A\u062D\u0645\u064A\u0644 \u0633\u062C\u0644 \u0627\u0644\u062A\u062F\u0642\u064A\u0642. \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629\u060C \u0648\u0625\u0646 \u0627\u0633\u062A\u0645\u0631\u062A \u0627\u0644\u0645\u0634\u0643\u0644\u0629 \u0641\u062A\u0648\u0627\u0635\u0644 \u0645\u0639 \u0627\u0644\u062F\u0639\u0645.",
    loadMore: "\u0639\u0631\u0636 \u0627\u0644\u0645\u0632\u064A\u062F \u0645\u0646 \u0627\u0644\u0623\u062D\u062F\u0627\u062B",
    loadingMore: "\u062C\u0627\u0631\u064D \u0627\u0644\u062A\u062D\u0645\u064A\u0644\u2026",
    columns: {
      when: "\u0627\u0644\u062A\u0627\u0631\u064A\u062E \u0648\u0627\u0644\u0648\u0642\u062A",
      actor: "\u0627\u0644\u0645\u0646\u0641\u0651\u0630",
      action: "\u0627\u0644\u0625\u062C\u0631\u0627\u0621",
      resource: "\u0627\u0644\u0639\u0646\u0635\u0631 \u0627\u0644\u0645\u0639\u0646\u064A"
    },
    actorTypes: {
      user: "\u0645\u0633\u062A\u062E\u062F\u0645 \u063A\u064A\u0631 \u0645\u0639\u0631\u0648\u0641",
      system: "\u0646\u0638\u0627\u0645 BatiFlow",
      platform_admin: "\u062F\u0639\u0645 BatiFlow"
    },
    actions: {
      unknown: "\u0625\u062C\u0631\u0627\u0621 \u0645\u0633\u062C\u064E\u0651\u0644",
      auth_logged_in: "\u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062F\u062E\u0648\u0644",
      auth_logged_out: "\u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062E\u0631\u0648\u062C",
      auth_stepped_up: "\u062A\u0623\u0643\u064A\u062F \u0627\u0644\u0647\u0648\u064A\u0629",
      auth_mfa_changed: "\u062A\u063A\u064A\u064A\u0631 \u0627\u0644\u062A\u062D\u0642\u0642 \u0628\u062E\u0637\u0648\u062A\u064A\u0646",
      auth_session_revoked: "\u0625\u0646\u0647\u0627\u0621 \u062C\u0644\u0633\u0629",
      organization_created: "\u0625\u0646\u0634\u0627\u0621 \u0627\u0644\u0645\u0624\u0633\u0633\u0629",
      organization_updated: "\u062A\u0639\u062F\u064A\u0644 \u0645\u0644\u0641 \u0627\u0644\u0645\u0624\u0633\u0633\u0629",
      organization_policy_changed: "\u062A\u0639\u062F\u064A\u0644 \u0633\u064A\u0627\u0633\u0627\u062A \u0627\u0644\u0645\u0624\u0633\u0633\u0629",
      membership_invited: "\u062F\u0639\u0648\u0629 \u0639\u0636\u0648",
      membership_joined: "\u0627\u0646\u0636\u0645\u0627\u0645 \u0639\u0636\u0648 \u0625\u0644\u0649 \u0627\u0644\u0645\u0624\u0633\u0633\u0629",
      membership_role_changed: "\u062A\u063A\u064A\u064A\u0631 \u062F\u0648\u0631 \u0639\u0636\u0648",
      membership_deactivated: "\u062A\u0639\u0637\u064A\u0644 \u0639\u0636\u0648",
      membership_invitation_resent: "\u0625\u0639\u0627\u062F\u0629 \u0625\u0631\u0633\u0627\u0644 \u062F\u0639\u0648\u0629",
      membership_invitation_revoked: "\u0625\u0644\u063A\u0627\u0621 \u062F\u0639\u0648\u0629",
      organization_owner_transfer_proposed: "\u0627\u0642\u062A\u0631\u0627\u062D \u0646\u0642\u0644 \u0627\u0644\u0645\u0644\u0643\u064A\u0629",
      organization_owner_transfer_cancelled: "\u0625\u0644\u063A\u0627\u0621 \u0646\u0642\u0644 \u0627\u0644\u0645\u0644\u0643\u064A\u0629",
      organization_owner_transferred: "\u0646\u0642\u0644 \u0645\u0644\u0643\u064A\u0629 \u0627\u0644\u0645\u0624\u0633\u0633\u0629",
      organization_fiscal_profile_created: "\u0646\u0633\u062E\u0629 \u062C\u062F\u064A\u062F\u0629 \u0645\u0646 \u0627\u0644\u0645\u0644\u0641 \u0627\u0644\u062C\u0628\u0627\u0626\u064A",
      organization_bank_details_viewed: "\u0627\u0644\u0627\u0637\u0644\u0627\u0639 \u0639\u0644\u0649 \u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A \u0627\u0644\u0628\u0646\u0643\u064A\u0629 \u0643\u0627\u0645\u0644\u0629",
      organization_invoice_series_changed: "\u062A\u0639\u062F\u064A\u0644 \u0633\u0644\u0633\u0644\u0629 \u0641\u0648\u0627\u062A\u064A\u0631",
      client_created: "\u0625\u0646\u0634\u0627\u0621 \u0639\u0645\u064A\u0644",
      client_updated: "\u062A\u0639\u062F\u064A\u0644 \u0639\u0645\u064A\u0644",
      client_archived: "\u0623\u0631\u0634\u0641\u0629 \u0639\u0645\u064A\u0644",
      client_contact_changed: "\u062A\u0639\u062F\u064A\u0644 \u062C\u0647\u0629 \u0627\u062A\u0635\u0627\u0644 \u0639\u0645\u064A\u0644",
      platform_break_glass_granted: "\u0645\u0646\u062D \u0648\u0635\u0648\u0644 \u0627\u0633\u062A\u062B\u0646\u0627\u0626\u064A \u0644\u0644\u062F\u0639\u0645",
      system_checked: "\u0641\u062D\u0635 \u062A\u0642\u0646\u064A",
      quote_created: "\u0625\u0646\u0634\u0627\u0621 \u0639\u0631\u0636 \u0645\u0627\u0644\u064A",
      quote_updated: "\u062A\u0639\u062F\u064A\u0644 \u0639\u0631\u0636 \u0645\u0627\u0644\u064A",
      quote_deleted: "\u062D\u0630\u0641 \u0639\u0631\u0636 \u0645\u0627\u0644\u064A",
      quote_sent: "\u0625\u0631\u0633\u0627\u0644 \u0639\u0631\u0636 \u0645\u0627\u0644\u064A \u0625\u0644\u0649 \u0627\u0644\u062D\u0631\u064A\u0641",
      quote_accepted: "\u0642\u0628\u0648\u0644 \u0627\u0644\u062D\u0631\u064A\u0641 \u0644\u0644\u0639\u0631\u0636 \u0627\u0644\u0645\u0627\u0644\u064A",
      quote_rejected: "\u0631\u0641\u0636 \u0627\u0644\u0639\u0631\u0636 \u0627\u0644\u0645\u0627\u0644\u064A",
      quote_converted: "\u062A\u062D\u0648\u064A\u0644 \u0627\u0644\u0639\u0631\u0636 \u0627\u0644\u0645\u0627\u0644\u064A \u0625\u0644\u0649 \u0645\u0634\u0631\u0648\u0639",
      quote_fee_scale_created: "\u0625\u0636\u0627\u0641\u0629 \u0633\u0644\u0651\u0645 \u0623\u062A\u0639\u0627\u0628",
      quote_fee_scale_deleted: "\u062D\u0630\u0641 \u0633\u0644\u0651\u0645 \u0623\u062A\u0639\u0627\u0628",
      contract_created: "\u0625\u0646\u0634\u0627\u0621 \u0639\u0642\u062F",
      contract_updated: "\u062A\u0639\u062F\u064A\u0644 \u0639\u0642\u062F",
      contract_amendment_added: "\u0625\u0636\u0627\u0641\u0629 \u0645\u0644\u062D\u0642 \u0639\u0642\u062F",
      invoice_created: "\u0625\u0646\u0634\u0627\u0621 \u0645\u0633\u0648\u062F\u0629 \u0641\u0627\u062A\u0648\u0631\u0629",
      invoice_updated: "\u062A\u0639\u062F\u064A\u0644 \u0645\u0633\u0648\u062F\u0629 \u0641\u0627\u062A\u0648\u0631\u0629",
      invoice_deleted: "\u062D\u0630\u0641 \u0645\u0633\u0648\u062F\u0629 \u0641\u0627\u062A\u0648\u0631\u0629",
      invoice_issued: "\u0625\u0635\u062F\u0627\u0631 \u0641\u0627\u062A\u0648\u0631\u0629",
      invoice_credited: "\u0625\u0635\u062F\u0627\u0631 \u0641\u0627\u062A\u0648\u0631\u0629 \u062A\u0639\u062F\u064A\u0644\u064A\u0629",
      invoice_transferred: "\u0646\u0642\u0644 \u0645\u0633\u0648\u062F\u0627\u062A \u0641\u0648\u0627\u062A\u064A\u0631",
      payment_recorded: "\u062A\u0633\u062C\u064A\u0644 \u062F\u0641\u0639\u0629",
      payment_certificate_linked: "\u0625\u0631\u0641\u0627\u0642 \u0634\u0647\u0627\u062F\u0629 \u062E\u0635\u0645 \u0645\u0646 \u0627\u0644\u0645\u0648\u0631\u062F",
      expense_submitted: "\u062A\u0642\u062F\u064A\u0645 \u0645\u0630\u0643\u0631\u0629 \u0645\u0635\u0627\u0631\u064A\u0641",
      expense_approved: "\u0627\u0644\u0645\u0648\u0627\u0641\u0642\u0629 \u0639\u0644\u0649 \u0645\u0630\u0643\u0631\u0629 \u0645\u0635\u0627\u0631\u064A\u0641",
      expense_rejected: "\u0631\u0641\u0636 \u0645\u0630\u0643\u0631\u0629 \u0645\u0635\u0627\u0631\u064A\u0641",
      expense_reimbursed: "\u0627\u0633\u062A\u0631\u062C\u0627\u0639 \u0645\u0630\u0643\u0631\u0629 \u0645\u0635\u0627\u0631\u064A\u0641",
      invoice_reminders_changed: "\u062A\u0639\u062F\u064A\u0644 \u062A\u0630\u0643\u064A\u0631\u0627\u062A \u0627\u0644\u0641\u0648\u0627\u062A\u064A\u0631",
      organization_directory_updated: "\u062A\u063A\u064A\u064A\u0631 \u0627\u0644\u0638\u0647\u0648\u0631 \u0641\u064A \u0627\u0644\u062F\u0644\u064A\u0644",
      directory_contact_received: "\u0631\u0633\u0627\u0644\u0629 \u0648\u0627\u0631\u062F\u0629 \u0645\u0646 \u0627\u0644\u062F\u0644\u064A\u0644"
    },
    resources: {
      organization: "\u0627\u0644\u0645\u0624\u0633\u0633\u0629",
      membership: "\u0639\u0636\u0648",
      member_invitation: "\u062F\u0639\u0648\u0629",
      owner_transfer: "\u0646\u0642\u0644 \u0627\u0644\u0645\u0644\u0643\u064A\u0629",
      organization_fiscal_profile: "\u0627\u0644\u0645\u0644\u0641 \u0627\u0644\u062C\u0628\u0627\u0626\u064A",
      invoice_series: "\u0633\u0644\u0633\u0644\u0629 \u0641\u0648\u0627\u062A\u064A\u0631",
      client: "\u0639\u0645\u064A\u0644"
    },
    families: {
      organization: "\u0627\u0644\u0645\u0624\u0633\u0633\u0629 \u0648\u0627\u0644\u0625\u0639\u062F\u0627\u062F\u0627\u062A",
      membership: "\u0627\u0644\u0623\u0639\u0636\u0627\u0621 \u0648\u0627\u0644\u062F\u0639\u0648\u0627\u062A",
      client: "\u0627\u0644\u0639\u0645\u0644\u0627\u0621",
      auth: "\u0627\u0644\u062F\u062E\u0648\u0644 \u0648\u0627\u0644\u0623\u0645\u0627\u0646",
      invoice: "\u0627\u0644\u0641\u0648\u0627\u062A\u064A\u0631",
      quote: "\u0639\u0631\u0648\u0636 \u0627\u0644\u0623\u0633\u0639\u0627\u0631",
      contract: "\u0627\u0644\u0639\u0642\u0648\u062F",
      payment: "\u0627\u0644\u0645\u062F\u0641\u0648\u0639\u0627\u062A",
      expense: "\u0627\u0644\u0645\u0635\u0627\u0631\u064A\u0641"
    },
    filters: {
      label: "\u0639\u0648\u0627\u0645\u0644 \u062A\u0635\u0641\u064A\u0629 \u0627\u0644\u0633\u062C\u0644",
      actor: "\u0627\u0644\u0645\u0646\u0641\u0651\u0630",
      allActors: "\u0627\u0644\u062C\u0645\u064A\u0639",
      action: "\u0646\u0648\u0639 \u0627\u0644\u0625\u062C\u0631\u0627\u0621",
      allActions: "\u0643\u0644 \u0627\u0644\u0625\u062C\u0631\u0627\u0621\u0627\u062A",
      from: "\u0645\u0646",
      to: "\u0625\u0644\u0649",
      clear: "\u0645\u0633\u062D \u0639\u0648\u0627\u0645\u0644 \u0627\u0644\u062A\u0635\u0641\u064A\u0629"
    },
    empty: {
      title: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0623\u062D\u062F\u0627\u062B \u0628\u0639\u062F",
      description: "\u0633\u062A\u0638\u0647\u0631 \u0647\u0646\u0627 \u0627\u0644\u0625\u062C\u0631\u0627\u0621\u0627\u062A \u0627\u0644\u062D\u0633\u0627\u0633\u0629 \u0644\u0645\u0643\u062A\u0628\u0643 \u0641\u0648\u0631 \u062D\u062F\u0648\u062B\u0647\u0627.",
      filteredTitle: "\u0644\u0627 \u064A\u0648\u062C\u062F \u062D\u062F\u062B \u0645\u0637\u0627\u0628\u0642",
      filteredDescription: "\u062C\u0631\u0651\u0628 \u0639\u0648\u0627\u0645\u0644 \u062A\u0635\u0641\u064A\u0629 \u0623\u062E\u0631\u0649 \u0623\u0648 \u0641\u062A\u0631\u0629 \u0623\u0648\u0633\u0639."
    },
    verify: {
      title: "\u0633\u0644\u0627\u0645\u0629 \u0627\u0644\u0633\u062C\u0644",
      description: "\u0645\u062E\u0635\u0635 \u0644\u0644\u0645\u0627\u0644\u0643.",
      intro: "\u064A\u0631\u062A\u0628\u0637 \u0643\u0644 \u062D\u062F\u062B \u0628\u0627\u0644\u062D\u062F\u062B \u0627\u0644\u0630\u064A \u064A\u0633\u0628\u0642\u0647 \u0628\u0628\u0635\u0645\u0629. \u064A\u0639\u064A\u062F \u0627\u0644\u0641\u062D\u0635 \u062D\u0633\u0627\u0628 \u0647\u0630\u0627 \u0627\u0644\u062A\u0633\u0644\u0633\u0644 \u0648\u064A\u064F\u0628\u0644\u063A \u0625\u0646 \u062A\u0645 \u062A\u0639\u062F\u064A\u0644 \u062D\u062F\u062B \u0623\u0648 \u062D\u0630\u0641\u0647 \u0623\u0648 \u0646\u0642\u0644\u0647.",
      button: "\u0627\u0644\u062A\u062D\u0642\u0642 \u0645\u0646 \u0627\u0644\u0633\u0644\u0627\u0645\u0629",
      running: "\u062C\u0627\u0631\u064D \u0627\u0644\u062A\u062D\u0642\u0642\u2026",
      okTitle: "\u0627\u0644\u0633\u062C\u0644 \u0633\u0644\u064A\u0645",
      okBody: "\u0644\u0645 \u064A\u064F\u0643\u062A\u0634\u0641 \u0623\u064A \u062A\u0639\u062F\u064A\u0644 \u0623\u0648 \u062D\u0630\u0641. \u062A\u0645 \u0627\u0644\u062A\u062D\u0642\u0642 \u0641\u064A",
      brokenTitle: "\u062A\u0645 \u0627\u0644\u0639\u0628\u062B \u0628\u0627\u0644\u0633\u062C\u0644",
      brokenBody: "\u062A\u0633\u0644\u0633\u0644 \u0627\u0644\u0633\u062C\u0644 \u0645\u0646\u0642\u0637\u0639 \u0627\u0628\u062A\u062F\u0627\u0621\u064B \u0645\u0646 \u0627\u0644\u062D\u062F\u062B \u0631\u0642\u0645 {position}: {reason}. \u0627\u062D\u062A\u0641\u0638 \u0628\u0647\u0630\u0647 \u0627\u0644\u0634\u0627\u0634\u0629 \u0648\u062A\u0648\u0627\u0635\u0644 \u0645\u0639 \u062F\u0639\u0645 BatiFlow \u0641\u0648\u0631\u064B\u0627.",
      failedTitle: "\u0644\u0645 \u064A\u0643\u062A\u0645\u0644 \u0627\u0644\u062A\u062D\u0642\u0642",
      reasons: {
        content_modified: "\u062A\u0645 \u062A\u0639\u062F\u064A\u0644 \u0645\u062D\u062A\u0648\u0649 \u062D\u062F\u062B \u0628\u0639\u062F \u062A\u0633\u062C\u064A\u0644\u0647",
        sequence_gap: "\u0627\u062E\u062A\u0641\u0649 \u062D\u062F\u062B \u0623\u0648 \u0623\u0643\u062B\u0631 \u0645\u0646 \u0627\u0644\u062A\u0633\u0644\u0633\u0644",
        link_broken: "\u0627\u0644\u0631\u0627\u0628\u0637 \u0628\u064A\u0646 \u062D\u062F\u062B\u064A\u0646 \u0645\u0646\u0642\u0637\u0639",
        unknown: "\u062A\u0645 \u0627\u0643\u062A\u0634\u0627\u0641 \u0639\u062F\u0645 \u0627\u062A\u0633\u0627\u0642"
      }
    }
  },
  meNav: {
    profile: "\u0627\u0644\u0645\u0644\u0641 \u0627\u0644\u0634\u062E\u0635\u064A",
    security: "\u0627\u0644\u0623\u0645\u0627\u0646",
    notifications: "\u0627\u0644\u0625\u0634\u0639\u0627\u0631\u0627\u062A"
  },
  meProfile: {
    title: "\u0645\u0644\u0641\u064A \u0627\u0644\u0634\u062E\u0635\u064A",
    saving: "\u062C\u0627\u0631\u064D \u0627\u0644\u062D\u0641\u0638\u2026",
    errors: {
      nameRequired: "\u0627\u0643\u062A\u0628 \u0627\u0633\u0645\u0643.",
      nameTooLong: "\u0644\u0627 \u064A\u0645\u0643\u0646 \u0623\u0646 \u064A\u062A\u062C\u0627\u0648\u0632 \u0627\u0644\u0627\u0633\u0645 {max} \u062D\u0631\u0641\u064B\u0627."
    },
    identity: {
      title: "\u0627\u0644\u0647\u0648\u064A\u0629",
      description: "\u0627\u0633\u0645\u0643 \u0643\u0645\u0627 \u064A\u0631\u0627\u0647 \u0632\u0645\u0644\u0627\u0624\u0643.",
      name: "\u0627\u0644\u0627\u0633\u0645 \u0627\u0644\u0645\u0639\u0631\u0648\u0636",
      email: "\u0639\u0646\u0648\u0627\u0646 \u0627\u0644\u0628\u0631\u064A\u062F \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A",
      emailHint: "\u064A\u064F\u062F\u0627\u0631 \u0639\u0646\u0648\u0627\u0646 \u0627\u0644\u0628\u0631\u064A\u062F \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A \u0645\u0646 \u062D\u0633\u0627\u0628\u0643 \u0641\u064A BatiFlow: \u0644\u0627 \u064A\u0645\u0643\u0646 \u062A\u063A\u064A\u064A\u0631\u0647 \u0647\u0646\u0627.",
      saved: "\u062A\u0645 \u062D\u0641\u0638 \u0627\u0633\u0645\u0643."
    },
    region: {
      title: "\u0627\u0644\u0644\u063A\u0629 \u0648\u0627\u0644\u0645\u0646\u0637\u0642\u0629",
      description: "\u064A\u064F\u062D\u0641\u0638 \u0643\u0644 \u0627\u062E\u062A\u064A\u0627\u0631 \u0628\u0645\u062C\u0631\u062F \u0623\u0646 \u062A\u0642\u0648\u0645 \u0628\u0647.",
      language: {
        label: "\u0644\u063A\u0629 \u0627\u0644\u0648\u0627\u062C\u0647\u0629",
        hint: "\u064A\u0633\u0631\u064A \u0627\u0644\u062A\u063A\u064A\u064A\u0631 \u0641\u0648\u0631\u064B\u0627\u060C \u0628\u0645\u0627 \u0641\u064A \u0630\u0644\u0643 \u0627\u062A\u062C\u0627\u0647 \u0627\u0644\u0642\u0631\u0627\u0621\u0629 \u0644\u0644\u063A\u0629 \u0627\u0644\u0639\u0631\u0628\u064A\u0629.",
        saved: "\u062A\u0645 \u062D\u0641\u0638 \u0644\u063A\u062A\u0643."
      },
      timeZone: {
        label: "\u0627\u0644\u0645\u0646\u0637\u0642\u0629 \u0627\u0644\u0632\u0645\u0646\u064A\u0629",
        hint: "\u062A\u064F\u0639\u0631\u0636 \u0627\u0644\u062A\u0648\u0627\u0631\u064A\u062E \u0648\u0627\u0644\u0623\u0648\u0642\u0627\u062A \u0648\u0641\u0642 \u0647\u0630\u0647 \u0627\u0644\u0645\u0646\u0637\u0642\u0629 \u0627\u0644\u0632\u0645\u0646\u064A\u0629.",
        saved: "\u062A\u0645 \u062D\u0641\u0638 \u0645\u0646\u0637\u0642\u062A\u0643 \u0627\u0644\u0632\u0645\u0646\u064A\u0629."
      },
      digits: {
        legend: "\u0623\u0631\u0642\u0627\u0645 \u0627\u0644\u0648\u0627\u062C\u0647\u0629 \u0627\u0644\u0639\u0631\u0628\u064A\u0629",
        hint: "\u064A\u0633\u0631\u064A \u0641\u0642\u0637 \u0639\u0646\u062F\u0645\u0627 \u062A\u0643\u0648\u0646 \u0627\u0644\u0648\u0627\u062C\u0647\u0629 \u0628\u0627\u0644\u0639\u0631\u0628\u064A\u0629.",
        latn: "\u0623\u0631\u0642\u0627\u0645 \u0644\u0627\u062A\u064A\u0646\u064A\u0629 (0123456789)",
        arab: "\u0623\u0631\u0642\u0627\u0645 \u0639\u0631\u0628\u064A\u0629 \u0647\u0646\u062F\u064A\u0629 (\u0660\u0661\u0662\u0663\u0664\u0665\u0666\u0667\u0668\u0669)",
        saved: "\u062A\u0645 \u062D\u0641\u0638 \u0627\u062E\u062A\u064A\u0627\u0631\u0643 \u0644\u0644\u0623\u0631\u0642\u0627\u0645."
      }
    },
    appearance: {
      title: "\u0627\u0644\u0645\u0638\u0647\u0631",
      description: "\u064A\u0628\u0642\u0649 \u0647\u0630\u0627 \u0627\u0644\u0627\u062E\u062A\u064A\u0627\u0631 \u0639\u0644\u0649 \u0647\u0630\u0627 \u0627\u0644\u062C\u0647\u0627\u0632: \u0644\u0627 \u064A\u064F\u062D\u0641\u0638 \u0641\u064A \u062D\u0633\u0627\u0628\u0643.",
      theme: "\u0627\u0644\u0633\u0645\u0629"
    }
  },
  meNotifications: {
    title: "\u0625\u0634\u0639\u0627\u0631\u0627\u062A\u064A",
    formLabel: "\u062A\u0641\u0636\u064A\u0644\u0627\u062A \u0627\u0644\u0625\u0634\u0639\u0627\u0631\u0627\u062A",
    noChange: "\u0644\u0627 \u064A\u0648\u062C\u062F \u0645\u0627 \u064A\u064F\u062D\u0641\u0638.",
    saved: "\u062A\u0645 \u062D\u0641\u0638 \u062A\u0641\u0636\u064A\u0644\u0627\u062A \u0627\u0644\u0625\u0634\u0639\u0627\u0631\u0627\u062A.",
    stale: "\u062A\u063A\u064A\u0651\u0631\u062A \u062A\u0641\u0636\u064A\u0644\u0627\u062A\u0643 \u0645\u0646 \u0645\u0643\u0627\u0646 \u0622\u062E\u0631 \u0623\u062B\u0646\u0627\u0621 \u062A\u0639\u062F\u064A\u0644\u0643 \u0644\u0647\u0627. \u0644\u0645 \u062A\u064F\u062D\u0641\u0638 \u062A\u0639\u062F\u064A\u0644\u0627\u062A\u0643: \u0623\u064F\u0639\u064A\u062F \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u062A\u0641\u0636\u064A\u0644\u0627\u062A \u0627\u0644\u062D\u0627\u0644\u064A\u0629 \u0644\u0644\u062A\u0648\u060C \u0641\u0623\u0639\u062F \u062A\u0637\u0628\u064A\u0642 \u062A\u063A\u064A\u064A\u0631\u0627\u062A\u0643.",
    saving: "\u062C\u0627\u0631\u064D \u0627\u0644\u062D\u0641\u0638\u2026",
    saveFailedTitle: "\u062A\u0639\u0630\u0651\u0631 \u062D\u0641\u0638 \u0627\u0644\u062A\u0641\u0636\u064A\u0644\u0627\u062A",
    loadFailedTitle: "\u062A\u0639\u0630\u0651\u0631 \u0639\u0631\u0636 \u062A\u0641\u0636\u064A\u0644\u0627\u062A\u0643",
    loadFailedBody: "\u062A\u0639\u0630\u0651\u0631 \u062A\u062D\u0645\u064A\u0644 \u062A\u0641\u0636\u064A\u0644\u0627\u062A \u0627\u0644\u0625\u0634\u0639\u0627\u0631\u0627\u062A. \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629\u060C \u0648\u0625\u0646 \u0627\u0633\u062A\u0645\u0631\u062A \u0627\u0644\u0645\u0634\u0643\u0644\u0629 \u0641\u062A\u0648\u0627\u0635\u0644 \u0645\u0639 \u0627\u0644\u062F\u0639\u0645.",
    reset: "\u0627\u0633\u062A\u0639\u0627\u062F\u0629 \u0627\u0644\u0642\u064A\u0645 \u0627\u0644\u0627\u0641\u062A\u0631\u0627\u0636\u064A\u0629",
    resetNote: "\u0627\u0633\u062A\u0639\u0627\u062F\u0629 \u0627\u0644\u0642\u064A\u0645 \u0627\u0644\u0627\u0641\u062A\u0631\u0627\u0636\u064A\u0629 \u062A\u0645\u0644\u0623 \u0627\u0644\u0646\u0645\u0648\u0630\u062C \u0641\u0642\u0637: \u0644\u0627 \u064A\u062A\u063A\u064A\u0651\u0631 \u0634\u064A\u0621 \u062D\u062A\u0649 \u062A\u062D\u0641\u0638.",
    channels: {
      inApp: "\u062F\u0627\u062E\u0644 \u0627\u0644\u062A\u0637\u0628\u064A\u0642",
      email: "\u0628\u0627\u0644\u0628\u0631\u064A\u062F \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A",
      push: "\u0625\u0634\u0639\u0627\u0631 \u0641\u0648\u0631\u064A (Push)",
      pushLater: "\u062A\u0637\u0628\u064A\u0642 \u0627\u0644\u0647\u0627\u062A\u0641\u060C \u0642\u0631\u064A\u0628\u064B\u0627"
    },
    emailModes: {
      off: "\u0623\u0628\u062F\u064B\u0627",
      immediate: "\u0641\u0648\u0631\u064B\u0627",
      digest: "\u0636\u0645\u0646 \u0627\u0644\u0645\u0644\u062E\u0635"
    },
    groups: {
      conversations: "\u0627\u0644\u0645\u062D\u0627\u062F\u062B\u0627\u062A",
      tasks: "\u0627\u0644\u0645\u0647\u0627\u0645",
      approvals: "\u0627\u0644\u062A\u0623\u0634\u064A\u0631\u0627\u062A \u0648\u0627\u0644\u0645\u0648\u0627\u0641\u0642\u0627\u062A",
      external: "\u0627\u0644\u0634\u0631\u0643\u0627\u0621 \u0648\u0627\u0644\u0641\u0636\u0627\u0621\u0627\u062A \u0627\u0644\u062E\u0627\u0631\u062C\u064A\u0629",
      security: "\u0627\u0644\u0623\u0645\u0627\u0646",
      finance: "\u0627\u0644\u0641\u0648\u062A\u0631\u0629 \u0648\u0627\u0644\u0627\u0634\u062A\u0631\u0627\u0643",
      calendar: "\u0627\u0644\u062A\u0642\u0648\u064A\u0645",
      meetings: "\u0627\u0644\u0627\u062C\u062A\u0645\u0627\u0639\u0627\u062A \u0648\u0627\u0644\u0645\u0643\u0627\u0644\u0645\u0627\u062A",
      planning: "\u0627\u0644\u0648\u0642\u062A \u0648\u0627\u0644\u062A\u062E\u0637\u064A\u0637",
      tenders: "\u0637\u0644\u0628\u0627\u062A \u0627\u0644\u0639\u0631\u0648\u0636 \u0648\u062E\u0632\u0646\u0629 \u0627\u0644\u0648\u062B\u0627\u0626\u0642",
      signatures: "\u0627\u0644\u062A\u0648\u0642\u064A\u0639\u0627\u062A \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A\u0629"
    },
    types: {
      mention: "\u062A\u062A\u0645 \u0627\u0644\u0625\u0634\u0627\u0631\u0629 \u0625\u0644\u064A\u0643",
      reply: "\u0631\u062F \u0639\u0644\u0649 \u0625\u062D\u062F\u0649 \u0631\u0633\u0627\u0626\u0644\u0643",
      task_assigned: "\u0625\u0633\u0646\u0627\u062F \u0645\u0647\u0645\u0629 \u0625\u0644\u064A\u0643",
      task_due: "\u0627\u0642\u062A\u0631\u0627\u0628 \u0645\u0648\u0639\u062F \u0645\u0647\u0645\u0629",
      task_overdue: "\u062A\u0623\u062E\u0631 \u0645\u0647\u0645\u0629",
      phase_due: "\u0627\u0642\u062A\u0631\u0627\u0628 \u0645\u0648\u0639\u062F \u0646\u0647\u0627\u064A\u0629 \u0645\u0631\u062D\u0644\u0629",
      phase_overdue: "\u062A\u0623\u062E\u0631 \u0645\u0631\u062D\u0644\u0629",
      approval_requested: "\u0637\u0644\u0628 \u062A\u0623\u0634\u064A\u0631\u0629 \u0628\u0627\u0646\u062A\u0638\u0627\u0631\u0643",
      approval_decided: "\u0642\u0631\u0627\u0631 \u0628\u0634\u0623\u0646 \u062A\u0623\u0634\u064A\u0631\u0629 \u0637\u0644\u0628\u062A\u0647\u0627",
      space_invitation: "\u062F\u0639\u0648\u0629 \u0625\u0644\u0649 \u0641\u0636\u0627\u0621 \u0645\u0634\u062A\u0631\u0643",
      partnership_request: "\u0637\u0644\u0628 \u0634\u0631\u0627\u0643\u0629",
      access_revoked: "\u0625\u0644\u063A\u0627\u0621 \u0648\u0635\u0648\u0644\u0643 \u0625\u0644\u0649 \u0641\u0636\u0627\u0621",
      einvoice_status: "\u0646\u062A\u064A\u062C\u0629 \u0641\u0627\u062A\u0648\u0631\u0629 \u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A\u0629 (TTN)",
      payment_received: "\u0627\u0633\u062A\u0644\u0627\u0645 \u062F\u0641\u0639\u0629",
      plan_limit: "\u0628\u0644\u0648\u063A \u062D\u062F \u0639\u0631\u0636\u0643",
      event_reminder: "\u0627\u0642\u062A\u0631\u0627\u0628 \u0645\u0648\u0639\u062F \u062D\u062F\u062B \u0641\u064A \u0627\u0644\u062A\u0642\u0648\u064A\u0645",
      quote_accepted: "\u064A\u0642\u0628\u0644 \u062D\u0631\u064A\u0641 \u0623\u062D\u062F \u0639\u0631\u0648\u0636\u0643 \u0627\u0644\u0645\u0627\u0644\u064A\u0629",
      invoice_suggested: "\u064A\u0645\u0643\u0646 \u0641\u0648\u062A\u0631\u0629 \u0645\u0631\u062D\u0644\u0629 \u0645\u063A\u0644\u0642\u0629",
      bond_release_due: "\u064A\u0645\u0643\u0646 \u0642\u0631\u064A\u0628\u0627 \u0631\u0641\u0639 \u0627\u0644\u064A\u062F \u0639\u0646 \u0636\u0645\u0627\u0646",
      expense_submitted: "\u0645\u0630\u0643\u0631\u0629 \u0645\u0635\u0627\u0631\u064A\u0641 \u0641\u064A \u0627\u0646\u062A\u0638\u0627\u0631 \u0645\u0648\u0627\u0641\u0642\u062A\u0643",
      expense_decided: "\u062A\u0645\u062A \u0627\u0644\u0645\u0648\u0627\u0641\u0642\u0629 \u0639\u0644\u0649 \u0645\u0630\u0643\u0631\u0629 \u0645\u0635\u0627\u0631\u064A\u0641\u0643 \u0623\u0648 \u0631\u0641\u0636\u0647\u0627",
      subscription_status: "\u062D\u0627\u0644\u0629 \u0627\u0634\u062A\u0631\u0627\u0643\u0643\u0645 \u0641\u064A BatiFlow (\u0627\u0644\u0627\u0633\u062A\u062D\u0642\u0627\u0642\u060C \u0639\u062F\u0645 \u0627\u0644\u062F\u0641\u0639\u060C \u0627\u0644\u0642\u0631\u0627\u0621\u0629 \u0641\u0642\u0637)",
      data_export: "\u0646\u0633\u062E\u0629 \u0628\u064A\u0627\u0646\u0627\u062A \u0627\u0644\u0645\u0624\u0633\u0633\u0629 \u062C\u0627\u0647\u0632\u0629 \u0644\u0644\u062A\u0646\u0632\u064A\u0644 (\u0623\u0648 \u0641\u0634\u0644\u062A)",
      organization_deletion: "\u062D\u0630\u0641 \u0627\u0644\u0645\u0624\u0633\u0633\u0629 \u0645\u0628\u0631\u0645\u062C \u0623\u0648 \u0623\u064F\u0644\u063A\u064A",
      meeting_started: "\u0628\u062F\u0623 \u0627\u062C\u062A\u0645\u0627\u0639 \u064A\u0645\u0643\u0646\u0643 \u0627\u0644\u0627\u0646\u0636\u0645\u0627\u0645 \u0625\u0644\u064A\u0647",
      meeting_invited: "\u062A\u0645\u062A \u062F\u0639\u0648\u062A\u0643 \u0625\u0644\u0649 \u0627\u062C\u062A\u0645\u0627\u0639",
      call_missed: "\u0645\u0643\u0627\u0644\u0645\u0629 \u0644\u0645 \u064A\u062A\u0645 \u0627\u0644\u0631\u062F \u0639\u0644\u064A\u0647\u0627",
      minutes_published: "\u062A\u0645 \u0646\u0634\u0631 \u0645\u062D\u0636\u0631 \u0627\u062C\u062A\u0645\u0627\u0639 \u0634\u0627\u0631\u0643\u062A \u0641\u064A\u0647",
      timesheet_reminder: "\u062A\u0630\u0643\u064A\u0631 \u064A\u0648\u0645 \u0627\u0644\u062C\u0645\u0639\u0629 \u0628\u062A\u0633\u0644\u064A\u0645 \u062C\u062F\u0648\u0644 \u0627\u0644\u0648\u0642\u062A",
      phase_deadline: "\u0627\u0642\u062A\u0631\u0628 \u0627\u0644\u0623\u062C\u0644 \u0627\u0644\u062A\u0639\u0627\u0642\u062F\u064A \u0644\u0645\u0631\u062D\u0644\u0629 \u0623\u0648 \u062A\u062C\u0627\u0648\u0632\u0647\u0627",
      vault_expiring: "\u062A\u0646\u062A\u0647\u064A \u062E\u0644\u0627\u0644 \u0623\u0642\u0644 \u0645\u0646 30 \u064A\u0648\u0645\u064B\u0627 \u0635\u0644\u0627\u062D\u064A\u0629 \u0648\u062B\u064A\u0642\u0629 \u0641\u064A \u0627\u0644\u062E\u0632\u0646\u0629 (\u0634\u0647\u0627\u062F\u0629\u060C \u062A\u0623\u0645\u064A\u0646\u2026)",
      time_budget: "\u0627\u0633\u062A\u0647\u0644\u0643\u062A \u0645\u0631\u062D\u0644\u0629 \u0645\u0646 \u0645\u0634\u0627\u0631\u064A\u0639\u0643\u0645 80 % \u0645\u0646 \u0645\u064A\u0632\u0627\u0646\u064A\u062A\u0647\u0627 \u0627\u0644\u0632\u0645\u0646\u064A\u0629",
      signature_requested: "\u064A\u0637\u0644\u0628 \u0645\u0646\u0643 \u0623\u062D\u062F \u0627\u0644\u0623\u0639\u0636\u0627\u0621 \u062A\u0648\u0642\u064A\u0639 \u0648\u062B\u064A\u0642\u0629",
      signature_update: "\u062A\u0645 \u062A\u0648\u0642\u064A\u0639 \u0637\u0644\u0628\u0627\u062A \u0627\u0644\u062A\u0648\u0642\u064A\u0639 \u0627\u0644\u062E\u0627\u0635\u0629 \u0628\u0643 \u0623\u0648 \u0631\u0641\u0636\u0647\u0627"
    },
    matrix: {
      title: "\u0645\u0627\u0630\u0627\u060C \u0648\u0623\u064A\u0646",
      description: "\u0627\u062E\u062A\u0631 \u0644\u0643\u0644 \u0646\u0648\u0639 \u0645\u0646 \u0627\u0644\u0625\u0634\u0639\u0627\u0631\u0627\u062A \u0647\u0644 \u062A\u0631\u0627\u0647 \u062F\u0627\u062E\u0644 \u0627\u0644\u062A\u0637\u0628\u064A\u0642 \u0648\u0647\u0644 \u062A\u062A\u0644\u0642\u0627\u0647 \u0628\u0627\u0644\u0628\u0631\u064A\u062F \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A.",
      region: "\u062C\u062F\u0648\u0644 \u062A\u0641\u0636\u064A\u0644\u0627\u062A \u0627\u0644\u0625\u0634\u0639\u0627\u0631\u0627\u062A",
      caption: "\u062A\u0641\u0636\u064A\u0644\u0627\u062A \u0627\u0644\u0625\u0634\u0639\u0627\u0631\u0627\u062A \u062D\u0633\u0628 \u0627\u0644\u0646\u0648\u0639 \u0648\u0627\u0644\u0642\u0646\u0627\u0629",
      type: "\u0627\u0644\u0625\u0634\u0639\u0627\u0631",
      cell: "{type}: {channel}",
      alwaysOn: "\u064A\u0638\u0644 \u0647\u0630\u0627 \u0627\u0644\u062A\u0646\u0628\u064A\u0647 \u0627\u0644\u0645\u0647\u0645 \u0645\u0641\u0639\u0651\u0644\u064B\u0627 \u062F\u0627\u0626\u0645\u064B\u0627 \u062F\u0627\u062E\u0644 \u0627\u0644\u062A\u0637\u0628\u064A\u0642."
    },
    digest: {
      title: "\u0645\u0644\u062E\u0635 \u0627\u0644\u0628\u0631\u064A\u062F \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A",
      description: "\u064A\u062C\u0645\u0639 \u0627\u0644\u0645\u0644\u062E\u0635 \u0627\u0644\u0625\u0634\u0639\u0627\u0631\u0627\u062A \u0627\u0644\u0645\u0636\u0628\u0648\u0637\u0629 \u0639\u0644\u0649 \xAB\u0636\u0645\u0646 \u0627\u0644\u0645\u0644\u062E\u0635\xBB \u0641\u064A \u0631\u0633\u0627\u0644\u0629 \u0628\u0631\u064A\u062F \u0648\u0627\u062D\u062F\u0629. \u0648\u0644\u0627 \u064A\u064F\u0631\u0633\u0644 \u0625\u0644\u0627 \u0625\u0630\u0627 \u0627\u062E\u062A\u0631\u062A \u0648\u062A\u064A\u0631\u0629 \u0644\u0647.",
      label: "\u0648\u062A\u064A\u0631\u0629 \u0627\u0644\u0645\u0644\u062E\u0635",
      options: {
        off: "\u0628\u062F\u0648\u0646 \u0645\u0644\u062E\u0635",
        hourly: "\u0643\u0644 \u0633\u0627\u0639\u0629",
        daily: "\u0643\u0644 \u064A\u0648\u0645"
      },
      warningTitle: "\u0627\u0644\u0645\u0644\u062E\u0635 \u0645\u0639\u0637\u0651\u0644",
      warningBody: "\u0628\u0639\u0636 \u0627\u0644\u0625\u0634\u0639\u0627\u0631\u0627\u062A \u0645\u0636\u0628\u0648\u0637\u0629 \u0639\u0644\u0649 \xAB\u0636\u0645\u0646 \u0627\u0644\u0645\u0644\u062E\u0635\xBB \u0644\u0643\u0646 \u0644\u0627 \u064A\u064F\u0631\u0633\u0644 \u0623\u064A \u0645\u0644\u062E\u0635: \u0633\u062A\u0628\u0642\u0649 \u062F\u0627\u062E\u0644 \u0627\u0644\u062A\u0637\u0628\u064A\u0642 \u0641\u0642\u0637. \u0627\u062E\u062A\u0631 \u0648\u062A\u064A\u0631\u0629 \u0644\u062A\u0644\u0642\u064A\u0647\u0627 \u0628\u0627\u0644\u0628\u0631\u064A\u062F \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A."
    },
    quietHours: {
      title: "\u0633\u0627\u0639\u0627\u062A \u0627\u0644\u0647\u062F\u0648\u0621",
      description: "\u062E\u0644\u0627\u0644 \u0647\u0630\u0647 \u0627\u0644\u0633\u0627\u0639\u0627\u062A \u0644\u0627 \u062A\u0635\u0644\u0643 \u0631\u0633\u0627\u0626\u0644 \u0627\u0644\u0625\u0634\u0639\u0627\u0631\u0627\u062A \u0628\u0627\u0644\u0628\u0631\u064A\u062F \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A\u060C \u0648\u062A\u0635\u0644\u0643 \u0628\u0639\u062F\u0647\u0627. \u0627\u0644\u0633\u0627\u0639\u0627\u062A \u0648\u0641\u0642 \u0645\u0646\u0637\u0642\u062A\u0643 \u0627\u0644\u0632\u0645\u0646\u064A\u0629.",
      enable: "\u062A\u0641\u0639\u064A\u0644 \u0633\u0627\u0639\u0627\u062A \u0627\u0644\u0647\u062F\u0648\u0621",
      start: "\u0627\u0644\u0628\u062F\u0627\u064A\u0629",
      end: "\u0627\u0644\u0646\u0647\u0627\u064A\u0629",
      invalid: "\u064A\u062C\u0628 \u0623\u0646 \u062A\u0643\u0648\u0646 \u0627\u0644\u0628\u062F\u0627\u064A\u0629 \u0648\u0627\u0644\u0646\u0647\u0627\u064A\u0629 \u0648\u0642\u062A\u064A\u0646 \u0645\u062E\u062A\u0644\u0641\u064A\u0646."
    },
    ring: {
      title: "\u0646\u063A\u0645\u0629 \u0627\u0644\u0645\u0643\u0627\u0644\u0645\u0627\u062A",
      description: "\u062A\u0634\u063A\u064A\u0644 \u0646\u063A\u0645\u0629 \u0639\u0644\u0649 \u0647\u0630\u0627 \u0627\u0644\u062C\u0647\u0627\u0632 \u0639\u0646\u062F\u0645\u0627 \u064A\u062A\u0635\u0644 \u0628\u0643 \u0623\u062D\u062F. \u0647\u0630\u0627 \u0627\u0644\u0625\u0639\u062F\u0627\u062F \u063A\u064A\u0631 \u0645\u0634\u062A\u0631\u0643 \u0645\u0639 \u0623\u062C\u0647\u0632\u062A\u0643 \u0627\u0644\u0623\u062E\u0631\u0649.",
      label: "\u0646\u063A\u0645\u0629 \u0627\u0644\u0645\u0643\u0627\u0644\u0645\u0627\u062A"
    }
  },
  documentSettings: {
    title: "\u0627\u0644\u0648\u062B\u0627\u0626\u0642",
    formLabel: "\u0625\u0639\u062F\u0627\u062F\u0627\u062A \u0627\u0644\u0648\u062B\u0627\u0626\u0642",
    loadFailedTitle: "\u062A\u0639\u0630\u0651\u0631 \u0639\u0631\u0636 \u0625\u0639\u062F\u0627\u062F\u0627\u062A \u0627\u0644\u0648\u062B\u0627\u0626\u0642",
    loadFailedBody: "\u062A\u0639\u0630\u0651\u0631 \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0625\u0639\u062F\u0627\u062F\u0627\u062A. \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629\u060C \u0648\u0625\u0646 \u0627\u0633\u062A\u0645\u0631\u062A \u0627\u0644\u0645\u0634\u0643\u0644\u0629 \u0641\u062A\u0648\u0627\u0635\u0644 \u0645\u0639 \u0627\u0644\u062F\u0639\u0645.",
    pattern: {
      title: "\u0646\u0645\u0637 \u0631\u0645\u0632 \u0627\u0644\u0648\u062B\u0627\u0626\u0642",
      description: "\u062A\u062D\u0635\u0644 \u0643\u0644 \u0648\u062B\u064A\u0642\u0629 \u0639\u0644\u0649 \u0631\u0645\u0632 \u064A\u064F\u0643\u0648\u064E\u0651\u0646 \u0648\u0641\u0642 \u0647\u0630\u0627 \u0627\u0644\u0646\u0645\u0637: \u064A\u064F\u0633\u062A\u062E\u062F\u0645 \u0644\u062A\u0639\u0631\u064A\u0641\u0647\u0627 \u0639\u0644\u0649 \u0627\u0644\u0645\u062E\u0637\u0637\u0627\u062A \u0648\u0627\u0644\u0645\u0631\u0627\u0633\u0644\u0627\u062A \u0648\u0642\u0648\u0627\u0626\u0645 \u0627\u0644\u0625\u0631\u0633\u0627\u0644.",
      label: "\u0627\u0644\u0646\u0645\u0637",
      hint: "\u0623\u062D\u0631\u0641 \u0644\u0627\u062A\u064A\u0646\u064A\u0629 \u0643\u0628\u064A\u0631\u0629 \u0648\u0623\u0631\u0642\u0627\u0645 \u0648\u0627\u0644\u0631\u0645\u0648\u0632 - _ . \u0641\u0642\u0637. \u0627\u0644\u0639\u0646\u0635\u0631\u0627\u0646 {num} \u0648{idx} \u0625\u0644\u0632\u0627\u0645\u064A\u0627\u0646."
    },
    legend: {
      label: "\u0639\u0646\u0627\u0635\u0631 \u0627\u0644\u0646\u0645\u0637",
      PROJECT: "\u0631\u0645\u0632 \u0627\u0644\u0645\u0634\u0631\u0648\u0639",
      PHASE: "\u0627\u0644\u0645\u0631\u062D\u0644\u0629 (ESQ \u0648APS \u0648APD\u2026)",
      DISC: "\u0627\u0644\u062A\u062E\u0635\u0635 (ARC \u0648STR \u0648VRD\u2026)",
      TYPE: "\u0646\u0648\u0639 \u0627\u0644\u0648\u062B\u064A\u0642\u0629 (PLN \u0648NDC \u0648RAP\u2026)",
      NUM: "\u0627\u0644\u0631\u0642\u0645 \u0627\u0644\u062A\u0633\u0644\u0633\u0644\u064A\u060C \u064A\u064F\u0633\u0646\u0650\u062F\u0647 BatiFlow",
      IDX: "\u0645\u0624\u0634\u0631 \u0627\u0644\u0645\u0631\u0627\u062C\u0639\u0629 (A \u0648B\u2026 \u0623\u0648 0 \u06481\u2026)",
      ZONE: "\u0627\u0644\u0645\u0646\u0637\u0642\u0629 \u0623\u0648 \u0627\u0644\u0628\u0646\u0627\u064A\u0629 \u0639\u0646\u062F \u0630\u0643\u0631\u0647\u0627"
    },
    example: {
      label: "\u0645\u062B\u0627\u0644 \u0639\u0644\u0649 \u0627\u0644\u0631\u0645\u0632",
      invalid: "\u0627\u0644\u0646\u0645\u0637 \u063A\u064A\u0631 \u0635\u0627\u0644\u062D \u0628\u0639\u062F: \u0644\u0627 \u0645\u062B\u0627\u0644.",
      sample: "\u0644\u0645\u062E\u0637\u0637 \u0647\u064A\u0627\u0643\u0644 \u0641\u064A \u0645\u0631\u062D\u0644\u0629 APS\u060C \u0623\u0648\u0644 \u0648\u062B\u064A\u0642\u0629\u060C \u0627\u0644\u0645\u0646\u0637\u0642\u0629 RDC."
    },
    problems: {
      length: "\u064A\u062C\u0628 \u0623\u0646 \u064A\u062A\u0631\u0627\u0648\u062D \u0637\u0648\u0644 \u0627\u0644\u0646\u0645\u0637 \u0628\u064A\u0646 5 \u0648100 \u062D\u0631\u0641.",
      characters: "\u0627\u0633\u062A\u062E\u062F\u0645 \u0623\u062D\u0631\u0641\u064B\u0627 \u0644\u0627\u062A\u064A\u0646\u064A\u0629 \u0643\u0628\u064A\u0631\u0629 \u0648\u0623\u0631\u0642\u0627\u0645\u064B\u0627 \u0648\u0627\u0644\u0631\u0645\u0648\u0632 - _ . \u0648\u0639\u0646\u0627\u0635\u0631 \u0628\u064A\u0646 \u0623\u0642\u0648\u0627\u0633 \u0645\u0639\u0642\u0648\u0641\u0629 \u0641\u0642\u0637.",
      unknownToken: "\u0639\u0646\u0635\u0631 \u0628\u064A\u0646 \u0623\u0642\u0648\u0627\u0633 \u0645\u0639\u0642\u0648\u0641\u0629 \u063A\u064A\u0631 \u0645\u0639\u0631\u0648\u0641: \u0631\u0627\u062C\u0639 \u0627\u0644\u0642\u0627\u0626\u0645\u0629 \u0623\u062F\u0646\u0627\u0647.",
      braces: "\u0627\u0644\u0623\u0642\u0648\u0627\u0633 \u0627\u0644\u0645\u0639\u0642\u0648\u0641\u0629 \u063A\u064A\u0631 \u0645\u062A\u0648\u0627\u0632\u0646\u0629.",
      needsNumberAndIndex: "\u064A\u062C\u0628 \u0623\u0646 \u064A\u062D\u062A\u0648\u064A \u0627\u0644\u0646\u0645\u0637 \u0639\u0644\u0649 \u0627\u0644\u0639\u0646\u0635\u0631\u064A\u0646 {num} \u0648{idx}."
    },
    serverRefused: "\u0644\u0645 \u064A\u064F\u0642\u0628\u0644 \u0627\u0644\u0646\u0645\u0637: \u064A\u062C\u0628 \u0623\u0646 \u064A\u062D\u062A\u0648\u064A \u0639\u0644\u0649 {num} \u0648{idx} \u0648\u0639\u0644\u0649 \u0639\u0646\u0627\u0635\u0631 \u0645\u0639\u0631\u0648\u0641\u0629 \u0641\u0642\u0637.",
    index: {
      title: "\u0646\u0645\u0637 \u0645\u0624\u0634\u0631\u0627\u062A \u0627\u0644\u0645\u0631\u0627\u062C\u0639\u0629",
      description: "\u0627\u0644\u0645\u0624\u0634\u0631 \u0627\u0644\u0630\u064A \u062A\u062D\u0635\u0644 \u0639\u0644\u064A\u0647 \u0643\u0644 \u0646\u0633\u062E\u0629 \u062C\u062F\u064A\u062F\u0629 \u0645\u0646 \u0627\u0644\u0648\u062B\u064A\u0642\u0629.",
      letters: "\u062D\u0631\u0648\u0641: A \u0648B \u0648C\u2026",
      numbers: "\u0623\u0631\u0642\u0627\u0645: 0 \u06481 \u06482\u2026"
    },
    noChange: "\u0644\u0627 \u062A\u0648\u062C\u062F \u062A\u0639\u062F\u064A\u0644\u0627\u062A \u0644\u062D\u0641\u0638\u0647\u0627.",
    saved: "\u062A\u0645 \u062D\u0641\u0638 \u0625\u0639\u062F\u0627\u062F\u0627\u062A \u0627\u0644\u0648\u062B\u0627\u0626\u0642.",
    saving: "\u062C\u0627\u0631\u064D \u0627\u0644\u062D\u0641\u0638\u2026",
    saveFailedTitle: "\u062A\u0639\u0630\u0651\u0631 \u062D\u0641\u0638 \u0627\u0644\u0625\u0639\u062F\u0627\u062F\u0627\u062A",
    existingCodes: "\u0644\u0627 \u062A\u062A\u063A\u064A\u0631 \u0627\u0644\u0631\u0645\u0648\u0632 \u0627\u0644\u0645\u0633\u0646\u062F\u0629 \u0633\u0627\u0628\u0642\u064B\u0627: \u064A\u0646\u0637\u0628\u0642 \u0627\u0644\u0646\u0645\u0637 \u0627\u0644\u062C\u062F\u064A\u062F \u0639\u0644\u0649 \u0627\u0644\u0648\u062B\u0627\u0626\u0642 \u0627\u0644\u062C\u062F\u064A\u062F\u0629 \u0648\u0639\u0644\u0649 \u0627\u0644\u0648\u062B\u0627\u0626\u0642 \u0627\u0644\u062A\u064A \u062A\u064F\u0639\u062F\u064E\u0651\u0644 \u0645\u0639\u0644\u0648\u0645\u0627\u062A\u0647\u0627.",
    readOnly: "\u0644\u0627 \u064A\u0645\u0643\u0646 \u062A\u063A\u064A\u064A\u0631 \u0647\u0630\u0647 \u0627\u0644\u0625\u0639\u062F\u0627\u062F\u0627\u062A \u0625\u0644\u0627 \u0644\u0645\u0646 \u064A\u0645\u0644\u0643 \u0635\u0644\u0627\u062D\u064A\u0629 \u062A\u0639\u062F\u064A\u0644 \u0627\u0644\u0645\u0624\u0633\u0633\u0629."
  },
  storage: {
    title: "\u0627\u0644\u062A\u062E\u0632\u064A\u0646",
    loadFailedTitle: "\u062A\u0639\u0630\u0651\u0631 \u062A\u062D\u0645\u064A\u0644 \u0627\u0633\u062A\u062E\u062F\u0627\u0645 \u0627\u0644\u062A\u062E\u0632\u064A\u0646",
    loadFailedBody: "\u062A\u062D\u0642\u0642 \u0645\u0646 \u0627\u062A\u0635\u0627\u0644\u0643 \u062B\u0645 \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629.",
    usage: {
      title: "\u0627\u0644\u0645\u0633\u0627\u062D\u0629 \u0627\u0644\u0645\u0633\u062A\u062E\u062F\u0645\u0629",
      description: "\u062C\u0645\u064A\u0639 \u0645\u0644\u0641\u0627\u062A \u0645\u0634\u0627\u0631\u064A\u0639\u0643\u060C \u0628\u0645\u0627 \u0641\u064A\u0647\u0627 \u0627\u0644\u0646\u0633\u062E \u0627\u0644\u0633\u0627\u0628\u0642\u0629.",
      summary: "{used} \u0645\u0633\u062A\u062E\u062F\u0645\u0629 \u0645\u0646 \u0623\u0635\u0644 {quota}",
      unlimited: "{used} \u0645\u0633\u062A\u062E\u062F\u0645\u0629. \u0644\u0627 \u064A\u062D\u062F\u062F \u0639\u0642\u062F\u0643 \u062D\u062F\u064B\u0627 \u0644\u0644\u0645\u0633\u0627\u062D\u0629.",
      percent: "\u062A\u0645 \u0627\u0633\u062A\u062E\u062F\u0627\u0645 {percent} \u0645\u0646 \u0627\u0644\u0645\u0633\u0627\u062D\u0629",
      barLabel: "\u0645\u0633\u0627\u062D\u0629 \u0627\u0644\u062A\u062E\u0632\u064A\u0646 \u0627\u0644\u0645\u0633\u062A\u062E\u062F\u0645\u0629",
      notes: {
        warning: "\u0644\u0642\u062F \u0627\u0633\u062A\u062E\u062F\u0645\u062A \u0623\u0643\u062B\u0631 \u0645\u0646 80% \u0645\u0646 \u0645\u0633\u0627\u062D\u062A\u0643. \u0641\u0643\u0651\u0631 \u0641\u064A \u062D\u0630\u0641 \u0627\u0644\u0645\u0644\u0641\u0627\u062A \u063A\u064A\u0631 \u0627\u0644\u0636\u0631\u0648\u0631\u064A\u0629 \u0623\u0648 \u0634\u0631\u0627\u0621 \u0645\u0633\u0627\u062D\u0629 \u062A\u062E\u0632\u064A\u0646 \u0625\u0636\u0627\u0641\u064A\u0629.",
        critical: "\u062A\u0628\u0642\u0651\u0649 \u0623\u0642\u0644 \u0645\u0646 5% \u0645\u0646 \u0645\u0633\u0627\u062D\u062A\u0643. \u0623\u0641\u0631\u063A \u0628\u0639\u0636 \u0627\u0644\u0645\u0633\u0627\u062D\u0629 \u0623\u0648 \u0627\u0634\u062A\u0631\u0650 \u0645\u0633\u0627\u062D\u0629 \u062A\u062E\u0632\u064A\u0646 \u0642\u0628\u0644 \u0623\u0646 \u064A\u062A\u0645 \u0631\u0641\u0636 \u0625\u0636\u0627\u0641\u0629 \u0627\u0644\u0645\u0644\u0641\u0627\u062A.",
        full: "\u0645\u0633\u0627\u062D\u062A\u0643 \u0645\u0645\u062A\u0644\u0626\u0629: \u064A\u062A\u0645 \u0631\u0641\u0636 \u0627\u0644\u0645\u0644\u0641\u0627\u062A \u0627\u0644\u062C\u062F\u064A\u062F\u0629. \u0623\u0641\u0631\u063A \u0628\u0639\u0636 \u0627\u0644\u0645\u0633\u0627\u062D\u0629 \u0623\u0648 \u0627\u0634\u062A\u0631\u0650 \u0645\u0633\u0627\u062D\u0629 \u062A\u062E\u0632\u064A\u0646."
      }
    },
    buy: {
      label: "\u0634\u0631\u0627\u0621 \u0645\u0633\u0627\u062D\u0629 \u062A\u062E\u0632\u064A\u0646",
      note: "\u0633\u064A\u062A\u0648\u0641\u0631 \u0634\u0631\u0627\u0621 \u0645\u0633\u0627\u062D\u0629 \u0627\u0644\u062A\u062E\u0632\u064A\u0646 \u0645\u0639 \u0627\u0644\u0641\u0648\u062A\u0631\u0629\u060C \u0648\u0647\u064A \u0642\u0627\u062F\u0645\u0629 \u0644\u0627\u062D\u0642\u064B\u0627."
    },
    spaces: {
      title: "\u0627\u0644\u062A\u062E\u0632\u064A\u0646 \u062D\u0633\u0628 \u0627\u0644\u0645\u0634\u0631\u0648\u0639",
      description: "\u062D\u062C\u0645 \u0645\u0644\u0641\u0627\u062A \u0643\u0644 \u0645\u0634\u0631\u0648\u0639 \u0648\u0622\u062E\u0631 \u0648\u0642\u062A \u062A\u0645 \u0641\u064A\u0647 \u0627\u062D\u062A\u0633\u0627\u0628 \u0647\u0630\u0627 \u0627\u0644\u062D\u062C\u0645.",
      caption: "\u0627\u0644\u062A\u062E\u0632\u064A\u0646 \u062D\u0633\u0628 \u0627\u0644\u0645\u0634\u0631\u0648\u0639",
      columns: {
        name: "\u0627\u0644\u0645\u0634\u0631\u0648\u0639 \u0623\u0648 \u0627\u0644\u0645\u0633\u0627\u062D\u0629",
        size: "\u0627\u0644\u062D\u062C\u0645",
        reconciledAt: "\u0622\u062E\u0631 \u0627\u062D\u062A\u0633\u0627\u0628"
      },
      never: "\u0644\u0645 \u064A\u064F\u062D\u062A\u0633\u0628 \u0628\u0639\u062F",
      empty: {
        title: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0645\u0644\u0641\u0627\u062A \u0628\u0639\u062F",
        description: "\u0633\u064A\u0638\u0647\u0631 \u062D\u062C\u0645 \u0643\u0644 \u0645\u0634\u0631\u0648\u0639 \u0647\u0646\u0627 \u0628\u0645\u062C\u0631\u062F \u0623\u0646 \u064A\u062D\u062A\u0648\u064A \u0639\u0644\u0649 \u0645\u0644\u0641\u0627\u062A."
      }
    },
    files: {
      title: "\u0623\u0643\u0628\u0631 10 \u0645\u0644\u0641\u0627\u062A",
      description: "\u0627\u0644\u0645\u0644\u0641\u0627\u062A \u0627\u0644\u062D\u0627\u0644\u064A\u0629 \u0627\u0644\u0623\u0643\u062B\u0631 \u0627\u0633\u062A\u0647\u0644\u0627\u0643\u064B\u0627 \u0644\u0644\u0645\u0633\u0627\u062D\u0629. \u062D\u0630\u0641 \u0645\u0644\u0641 \u063A\u064A\u0631 \u0636\u0631\u0648\u0631\u064A \u0623\u0648 \u0627\u0633\u062A\u0628\u062F\u0627\u0644\u0647 \u064A\u0641\u0631\u0651\u063A \u0645\u0633\u0627\u062D\u0629.",
      caption: "\u0623\u0643\u0628\u0631 \u0639\u0634\u0631\u0629 \u0645\u0644\u0641\u0627\u062A",
      columns: {
        code: "\u0627\u0644\u0631\u0645\u0632",
        title: "\u0627\u0644\u0639\u0646\u0648\u0627\u0646",
        size: "\u0627\u0644\u062D\u062C\u0645"
      },
      noCode: "\u0628\u062F\u0648\u0646 \u0631\u0645\u0632",
      empty: {
        title: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0645\u0644\u0641\u0627\u062A \u0628\u0639\u062F",
        description: "\u0633\u062A\u0638\u0647\u0631 \u0647\u0646\u0627 \u0623\u0643\u0628\u0631 \u0627\u0644\u0645\u0644\u0641\u0627\u062A \u062D\u062C\u0645\u064B\u0627."
      }
    }
  },
  realtime: {
    accessRevoked: {
      space: "\u0644\u0645 \u064A\u0639\u062F \u0628\u0625\u0645\u0643\u0627\u0646\u0643 \u0627\u0644\u0648\u0635\u0648\u0644 \u0625\u0644\u0649 \u0647\u0630\u0647 \u0627\u0644\u0645\u0633\u0627\u062D\u0629. \u0623\u0639\u062F\u0646\u0627\u0643 \u0625\u0644\u0649 \u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u0645\u0634\u0627\u0631\u064A\u0639.",
      organization: "\u0644\u0645 \u064A\u0639\u062F \u0628\u0625\u0645\u0643\u0627\u0646\u0643 \u0627\u0644\u0648\u0635\u0648\u0644 \u0625\u0644\u0649 \u0647\u0630\u0627 \u0627\u0644\u0645\u0643\u062A\u0628. \u0623\u0639\u062F\u0646\u0627\u0643 \u0625\u0644\u0649 \u0627\u0644\u0635\u0641\u062D\u0629 \u0627\u0644\u0631\u0626\u064A\u0633\u064A\u0629."
    }
  },
  guest: {
    badge: "\u0636\u064A\u0641",
    navLabel: "\u0627\u0644\u062A\u0646\u0642\u0644 \u0644\u0644\u0636\u064A\u0641",
    nav: {
      spaces: "\u0641\u0636\u0627\u0621\u0627\u062A\u064A",
      invitations: "\u0627\u0644\u062F\u0639\u0648\u0627\u062A"
    }
  },
  finance: {
    nav: {
      label: "\u0623\u0642\u0633\u0627\u0645 \u0627\u0644\u0645\u0627\u0644\u064A\u0629"
    },
    empty: {
      quotes: {
        title: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0639\u0631\u0648\u0636 \u0645\u0627\u0644\u064A\u0629 \u0628\u0639\u062F",
        body: "\u0633\u062A\u0638\u0647\u0631 \u0647\u0646\u0627 \u0627\u0644\u0639\u0631\u0648\u0636 \u0627\u0644\u0645\u0627\u0644\u064A\u0629 \u0627\u0644\u062E\u0627\u0635\u0629 \u0628\u0645\u0643\u062A\u0628\u0643\u0645."
      },
      contracts: {
        title: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0639\u0642\u0648\u062F \u0628\u0639\u062F",
        body: "\u0633\u062A\u0638\u0647\u0631 \u0647\u0646\u0627 \u0627\u0644\u0639\u0642\u0648\u062F \u0627\u0644\u0645\u0628\u0631\u0645\u0629 \u0645\u0639 \u062D\u0631\u0641\u0627\u0626\u0643\u0645."
      },
      invoices: {
        title: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0641\u0648\u0627\u062A\u064A\u0631 \u0628\u0639\u062F",
        body: "\u0633\u062A\u0638\u0647\u0631 \u0647\u0646\u0627 \u0641\u0648\u0627\u062A\u064A\u0631\u0643\u0645 \u0648\u062D\u0627\u0644\u0629 \u0625\u0631\u0633\u0627\u0644\u0647\u0627."
      },
      payments: {
        title: "\u0644\u0627 \u062A\u0648\u062C\u062F \u062F\u0641\u0648\u0639\u0627\u062A \u0645\u0633\u062C\u0644\u0629",
        body: "\u0633\u062A\u0638\u0647\u0631 \u0647\u0646\u0627 \u0627\u0644\u062F\u0641\u0648\u0639\u0627\u062A \u0627\u0644\u0648\u0627\u0631\u062F\u0629 \u0645\u0646 \u062D\u0631\u0641\u0627\u0626\u0643\u0645."
      },
      expenses: {
        title: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0645\u0630\u0643\u0631\u0627\u062A \u0645\u0635\u0627\u0631\u064A\u0641",
        body: "\u0633\u062A\u0638\u0647\u0631 \u0647\u0646\u0627 \u0645\u0630\u0643\u0631\u0627\u062A \u0645\u0635\u0627\u0631\u064A\u0641\u0643\u0645."
      },
      suppliers: {
        title: "\u0644\u0627 \u064A\u0648\u062C\u062F \u0645\u0632\u0648\u0651\u062F\u0648\u0646 \u0628\u0639\u062F",
        body: "\u0633\u064A\u0638\u0647\u0631 \u0647\u0646\u0627 \u0645\u0632\u0648\u0651\u062F\u0648\u0643 \u0648\u0627\u0644\u0645\u062A\u0639\u0627\u0642\u062F\u0648\u0646 \u0645\u0639\u0643 \u0645\u0646 \u0627\u0644\u0628\u0627\u0637\u0646."
      },
      supplierInvoices: {
        title: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0641\u0648\u0627\u062A\u064A\u0631 \u0645\u0632\u0648\u0651\u062F\u064A\u0646",
        body: "\u0633\u062A\u0638\u0647\u0631 \u0647\u0646\u0627 \u0627\u0644\u0641\u0648\u0627\u062A\u064A\u0631 \u0627\u0644\u0648\u0627\u0631\u062F\u0629 \u0645\u0646 \u0645\u0632\u0648\u0651\u062F\u064A\u0643."
      },
      withholding: {
        title: "\u0644\u0627 \u062A\u0648\u062C\u062F \u062E\u0635\u0648\u0645\u0627\u062A \u0644\u0644\u0639\u0631\u0636",
        body: "\u0633\u062A\u0638\u0647\u0631 \u0647\u0646\u0627 \u062E\u0635\u0648\u0645\u0627\u062A \u0627\u0644\u0634\u0647\u0631 \u0648\u0639\u0645\u0644\u064A\u0627\u062A \u0627\u0644\u062A\u0635\u062F\u064A\u0631 \u0625\u0644\u0649 TEJ."
      },
      accounting: {
        title: "\u0644\u0627 \u062A\u0648\u062C\u062F \u062A\u0635\u062F\u064A\u0631\u0627\u062A \u0628\u0639\u062F",
        body: "\u0633\u062A\u0638\u0647\u0631 \u0647\u0646\u0627 \u0627\u0644\u062A\u0635\u062F\u064A\u0631\u0627\u062A \u0627\u0644\u0645\u062D\u0627\u0633\u0628\u064A\u0629 \u0648\u0627\u0644\u0623\u0634\u0647\u0631 \u0627\u0644\u0645\u062E\u062A\u0648\u0645\u0629."
      },
      dashboard: {
        title: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0645\u0624\u0634\u0631\u0627\u062A \u0628\u0639\u062F",
        body: "\u0633\u062A\u0638\u0647\u0631 \u0647\u0646\u0627 \u0627\u0644\u0645\u0624\u0634\u0631\u0627\u062A \u0627\u0644\u0645\u0627\u0644\u064A\u0629 \u0627\u0644\u0623\u0633\u0627\u0633\u064A\u0629 \u0644\u0645\u0643\u062A\u0628\u0643\u0645."
      },
      management: {
        title: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0623\u0631\u0642\u0627\u0645 \u0642\u064A\u0627\u062F\u0629 \u0628\u0639\u062F",
        body: "\u0633\u062A\u0638\u0647\u0631 \u0647\u0646\u0627 \u0623\u0631\u0642\u0627\u0645 \u062A\u0633\u064A\u064A\u0631 \u0645\u0643\u062A\u0628\u0643\u0645."
      },
      treasury: {
        title: "\u0644\u0627 \u062A\u0648\u062C\u062F \u062A\u0648\u0642\u0639\u0627\u062A \u0628\u0639\u062F",
        body: "\u0633\u062A\u0638\u0647\u0631 \u0647\u0646\u0627 \u0627\u0644\u0645\u0642\u0628\u0648\u0636\u0627\u062A \u0627\u0644\u0645\u0646\u062A\u0638\u0631\u0629 \u0639\u0644\u0649 \u0645\u062F\u0649 90 \u064A\u0648\u0645\u064B\u0627."
      },
      profitability: {
        title: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0645\u0631\u062F\u0648\u062F\u064A\u0629 \u0644\u0644\u0639\u0631\u0636 \u0628\u0639\u062F",
        body: "\u0633\u062A\u0638\u0647\u0631 \u0647\u0646\u0627 \u0647\u0648\u0627\u0645\u0634 \u0631\u0628\u062D \u0645\u0634\u0627\u0631\u064A\u0639\u0643\u0645."
      },
      costRates: {
        title: "\u0644\u0627 \u062A\u0648\u062C\u062F \u062A\u0643\u0644\u0641\u0629 \u0633\u0627\u0639\u0629 \u0645\u062D\u062F\u062F\u0629",
        body: "\u0633\u062A\u0638\u0647\u0631 \u0647\u0646\u0627 \u062A\u0643\u0644\u0641\u0629 \u0633\u0627\u0639\u0629 \u0627\u0644\u0639\u0645\u0644 \u0644\u0641\u0631\u064A\u0642\u0643\u0645."
      },
      einvoicing: {
        title: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0634\u0647\u0627\u062F\u0629 \u0628\u0639\u062F",
        body: "\u0633\u064A\u0638\u0647\u0631 \u0647\u0646\u0627 \u0646\u0645\u0637 \u0627\u0644\u0641\u0648\u062A\u0631\u0629 \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A\u0629 \u0648\u0634\u0647\u0627\u062F\u0627\u062A \u0627\u0644\u062A\u0648\u0642\u064A\u0639 \u0627\u0644\u062E\u0627\u0635\u0629 \u0628\u0643\u0645."
      }
    }
  },
  billing: {
    locked: {
      read_only: {
        owner: "\u062D\u0633\u0627\u0628 \u0645\u0643\u062A\u0628\u0643 \u0641\u064A \u0648\u0636\u0639 \u0627\u0644\u0642\u0631\u0627\u0621\u0629 \u0641\u0642\u0637. \u0633\u0648\u0650\u0651 \u0627\u0644\u0627\u0634\u062A\u0631\u0627\u0643 \u0644\u062A\u062A\u0645\u0643\u0646 \u0645\u0646 \u0627\u0644\u0625\u0646\u0634\u0627\u0621 \u0648\u0627\u0644\u062A\u0639\u062F\u064A\u0644 \u0645\u0646 \u062C\u062F\u064A\u062F.",
        member: "\u062D\u0633\u0627\u0628 \u0645\u0643\u062A\u0628\u0643 \u0641\u064A \u0648\u0636\u0639 \u0627\u0644\u0642\u0631\u0627\u0621\u0629 \u0641\u0642\u0637. \u0627\u0637\u0644\u0628 \u0645\u0646 \u0645\u0627\u0644\u0643 \u0627\u0644\u0645\u0643\u062A\u0628 \u062A\u0633\u0648\u064A\u0629 \u0627\u0644\u0627\u0634\u062A\u0631\u0627\u0643."
      },
      suspended: {
        owner: "\u062D\u0633\u0627\u0628 \u0645\u0643\u062A\u0628\u0643 \u0645\u0648\u0642\u0648\u0641. \u0633\u0648\u0650\u0651 \u0627\u0644\u0627\u0634\u062A\u0631\u0627\u0643 \u0644\u0625\u0639\u0627\u062F\u0629 \u062A\u0641\u0639\u064A\u0644\u0647.",
        member: "\u062D\u0633\u0627\u0628 \u0645\u0643\u062A\u0628\u0643 \u0645\u0648\u0642\u0648\u0641. \u0627\u0637\u0644\u0628 \u0645\u0646 \u0645\u0627\u0644\u0643 \u0627\u0644\u0645\u0643\u062A\u0628 \u062A\u0633\u0648\u064A\u0629 \u0627\u0644\u0627\u0634\u062A\u0631\u0627\u0643."
      }
    },
    banner: {
      trial_ending: {
        title: "\u0641\u062A\u0631\u062A\u0643 \u0627\u0644\u062A\u062C\u0631\u064A\u0628\u064A\u0629 \u062A\u0648\u0634\u0643 \u0639\u0644\u0649 \u0627\u0644\u0627\u0646\u062A\u0647\u0627\u0621",
        body: "{count, plural, =0 {\u062A\u0646\u062A\u0647\u064A \u0641\u062A\u0631\u062A\u0643 \u0627\u0644\u062A\u062C\u0631\u064A\u0628\u064A\u0629 \u0627\u0644\u064A\u0648\u0645\u060C {date}.} one {\u062A\u0628\u0642\u0651\u0649 \u064A\u0648\u0645 \u062A\u062C\u0631\u064A\u0628\u064A \u0648\u0627\u062D\u062F\u060C \u062D\u062A\u0649 {date}.} two {\u062A\u0628\u0642\u0651\u0649 \u064A\u0648\u0645\u0627\u0646 \u062A\u062C\u0631\u064A\u0628\u064A\u0627\u0646\u060C \u062D\u062A\u0649 {date}.} few {\u062A\u0628\u0642\u0651\u062A {n} \u0623\u064A\u0627\u0645 \u062A\u062C\u0631\u064A\u0628\u064A\u0629\u060C \u062D\u062A\u0649 {date}.} many {\u062A\u0628\u0642\u0651\u0649 {n} \u064A\u0648\u0645\u064B\u0627 \u062A\u062C\u0631\u064A\u0628\u064A\u064B\u0627\u060C \u062D\u062A\u0649 {date}.} other {\u062A\u0628\u0642\u0651\u0649 {n} \u064A\u0648\u0645 \u062A\u062C\u0631\u064A\u0628\u064A\u060C \u062D\u062A\u0649 {date}.}}",
        owner: "\u0627\u062E\u062A\u0631 \u0628\u0627\u0642\u0629 \u0644\u0644\u0627\u062D\u062A\u0641\u0627\u0638 \u0628\u0627\u0644\u0648\u0635\u0648\u0644 \u0627\u0644\u0643\u0627\u0645\u0644 \u0625\u0644\u0649 \u0645\u0643\u062A\u0628\u0643.",
        member: "\u0627\u0637\u0644\u0628 \u0645\u0646 \u0645\u0627\u0644\u0643 \u0627\u0644\u0645\u0643\u062A\u0628 \u0627\u062E\u062A\u064A\u0627\u0631 \u0628\u0627\u0642\u0629."
      },
      read_only_trial: {
        title: "\u0627\u0646\u062A\u0647\u062A \u0641\u062A\u0631\u062A\u0643 \u0627\u0644\u062A\u062C\u0631\u064A\u0628\u064A\u0629",
        body: "\u0645\u0643\u062A\u0628\u0643 \u0641\u064A \u0648\u0636\u0639 \u0627\u0644\u0642\u0631\u0627\u0621\u0629 \u0641\u0642\u0637: \u064A\u0645\u0643\u0646\u0643 \u0627\u0644\u0627\u0637\u0644\u0627\u0639 \u0639\u0644\u0649 \u0628\u064A\u0627\u0646\u0627\u062A\u0643 \u0648\u062A\u0635\u062F\u064A\u0631\u0647\u0627\u060C \u0644\u0643\u0646 \u0644\u0627 \u064A\u0645\u0643\u0646\u0643 \u0627\u0644\u0625\u0646\u0634\u0627\u0621 \u0623\u0648 \u0627\u0644\u062A\u0639\u062F\u064A\u0644.",
        owner: "\u0627\u062E\u062A\u0631 \u0628\u0627\u0642\u0629 \u0648\u0633\u062F\u0651\u062F \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629 \u0644\u0625\u0639\u0627\u062F\u0629 \u062A\u0641\u0639\u064A\u0644 \u0643\u0644 \u0634\u064A\u0621.",
        member: "\u0627\u0637\u0644\u0628 \u0645\u0646 \u0645\u0627\u0644\u0643 \u0627\u0644\u0645\u0643\u062A\u0628 \u0627\u062E\u062A\u064A\u0627\u0631 \u0628\u0627\u0642\u0629."
      },
      read_only_unpaid: {
        title: "\u0645\u0643\u062A\u0628\u0643 \u0641\u064A \u0648\u0636\u0639 \u0627\u0644\u0642\u0631\u0627\u0621\u0629 \u0641\u0642\u0637",
        body: "\u0644\u0645 \u064A\u064F\u0633\u062F\u064E\u0651\u062F \u0627\u0644\u0627\u0634\u062A\u0631\u0627\u0643: \u064A\u0645\u0643\u0646\u0643 \u0627\u0644\u0627\u0637\u0644\u0627\u0639 \u0639\u0644\u0649 \u0628\u064A\u0627\u0646\u0627\u062A\u0643 \u0648\u062A\u0635\u062F\u064A\u0631\u0647\u0627\u060C \u0644\u0643\u0646 \u0644\u0627 \u064A\u0645\u0643\u0646\u0643 \u0627\u0644\u0625\u0646\u0634\u0627\u0621 \u0623\u0648 \u0627\u0644\u062A\u0639\u062F\u064A\u0644.",
        owner: "\u0633\u0648\u0650\u0651 \u0627\u0644\u0627\u0634\u062A\u0631\u0627\u0643 \u0644\u0625\u0639\u0627\u062F\u0629 \u062A\u0641\u0639\u064A\u0644 \u0643\u0644 \u0634\u064A\u0621.",
        member: "\u0627\u0637\u0644\u0628 \u0645\u0646 \u0645\u0627\u0644\u0643 \u0627\u0644\u0645\u0643\u062A\u0628 \u062A\u0633\u0648\u064A\u0629 \u0627\u0644\u0627\u0634\u062A\u0631\u0627\u0643."
      },
      suspended: {
        title: "\u0645\u0643\u062A\u0628\u0643 \u0645\u0648\u0642\u0648\u0641",
        body: "\u0623\u064F\u0648\u0642\u0641 \u0645\u0643\u062A\u0628\u0643 \u0628\u0633\u0628\u0628 \u0639\u062F\u0645 \u0627\u0644\u0633\u062F\u0627\u062F. \u0644\u0627 \u064A\u0632\u0627\u0644 \u0628\u0625\u0645\u0643\u0627\u0646\u0643 \u062A\u0635\u062F\u064A\u0631 \u0628\u064A\u0627\u0646\u0627\u062A\u0643\u061B \u0648\u0625\u0646 \u0628\u0642\u064A \u0627\u0644\u0627\u0634\u062A\u0631\u0627\u0643 \u063A\u064A\u0631 \u0645\u0633\u062F\u064E\u0651\u062F \u0641\u0633\u062A\u064F\u062D\u0630\u0641 \u0641\u064A \u0646\u0647\u0627\u064A\u0629 \u0627\u0644\u0645\u0637\u0627\u0641.",
        owner: "\u0633\u0648\u0650\u0651 \u0627\u0644\u0627\u0634\u062A\u0631\u0627\u0643 \u0644\u0625\u0639\u0627\u062F\u0629 \u062A\u0641\u0639\u064A\u0644 \u0645\u0643\u062A\u0628\u0643.",
        member: "\u0627\u0637\u0644\u0628 \u0645\u0646 \u0645\u0627\u0644\u0643 \u0627\u0644\u0645\u0643\u062A\u0628 \u062A\u0633\u0648\u064A\u0629 \u0627\u0644\u0627\u0634\u062A\u0631\u0627\u0643."
      },
      past_due: {
        title: "\u0647\u0646\u0627\u0643 \u062F\u0641\u0639\u0629 \u0645\u062A\u0623\u062E\u0631\u0629",
        body: "\u0641\u0627\u062A\u0648\u0631\u0629 \u0627\u0634\u062A\u0631\u0627\u0643\u0643 \u063A\u064A\u0631 \u0645\u0633\u062F\u064E\u0651\u062F\u0629 \u0645\u0646\u0630 {date}. \u0648\u0625\u0646 \u0644\u0645 \u062A\u064F\u0633\u062F\u064E\u0651\u062F \u0641\u0633\u064A\u062A\u062D\u0648\u0644 \u0627\u0644\u0645\u0643\u062A\u0628 \u0625\u0644\u0649 \u0648\u0636\u0639 \u0627\u0644\u0642\u0631\u0627\u0621\u0629 \u0641\u0642\u0637.",
        owner: "\u0633\u062F\u0651\u062F \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629 \u0644\u062A\u0641\u0627\u062F\u064A \u0623\u064A \u0627\u0646\u0642\u0637\u0627\u0639.",
        member: "\u0627\u0637\u0644\u0628 \u0645\u0646 \u0645\u0627\u0644\u0643 \u0627\u0644\u0645\u0643\u062A\u0628 \u062A\u0633\u0648\u064A\u0629 \u0627\u0644\u0627\u0634\u062A\u0631\u0627\u0643."
      },
      paused: {
        title: "\u0627\u0634\u062A\u0631\u0627\u0643\u0643 \u0645\u062A\u0648\u0642\u0641 \u0645\u0624\u0642\u062A\u064B\u0627",
        body: "\u0627\u0644\u0627\u0634\u062A\u0631\u0627\u0643 \u0645\u062A\u0648\u0642\u0641 \u0645\u0624\u0642\u062A\u064B\u0627 \u062D\u062A\u0649 {date}.",
        owner: "\u0627\u0633\u062A\u0623\u0646\u0641\u0647 \u0639\u0646\u062F\u0645\u0627 \u062A\u062D\u062A\u0627\u062C \u0625\u0644\u064A\u0647.",
        member: "\u0627\u0637\u0644\u0628 \u0645\u0646 \u0645\u0627\u0644\u0643 \u0627\u0644\u0645\u0643\u062A\u0628 \u0627\u0633\u062A\u0626\u0646\u0627\u0641\u0647."
      },
      cancelling: {
        title: "\u0627\u0634\u062A\u0631\u0627\u0643\u0643 \u0639\u0644\u0649 \u0648\u0634\u0643 \u0627\u0644\u0627\u0646\u062A\u0647\u0627\u0621",
        body: "\u064A\u0646\u062A\u0647\u064A \u0627\u0644\u0627\u0634\u062A\u0631\u0627\u0643 \u0641\u064A {date}\u060C \u0648\u0633\u064A\u062A\u062D\u0648\u0644 \u0627\u0644\u0645\u0643\u062A\u0628 \u0639\u0646\u062F\u0626\u0630\u064D \u0625\u0644\u0649 \u0648\u0636\u0639 \u0627\u0644\u0642\u0631\u0627\u0621\u0629 \u0641\u0642\u0637.",
        owner: "\u0647\u0644 \u063A\u064A\u0651\u0631\u062A \u0631\u0623\u064A\u0643\u061F \u064A\u0645\u0643\u0646\u0643 \u0627\u0644\u062A\u0631\u0627\u062C\u0639 \u0639\u0646 \u0627\u0644\u0625\u0644\u063A\u0627\u0621 \u0642\u0628\u0644 \u0647\u0630\u0627 \u0627\u0644\u062A\u0627\u0631\u064A\u062E.",
        member: "\u0627\u0633\u0623\u0644 \u0645\u0627\u0644\u0643 \u0627\u0644\u0645\u0643\u062A\u0628 \u0625\u0646 \u0643\u0646\u062A \u062A\u0631\u064A\u062F \u0627\u0644\u0627\u062D\u062A\u0641\u0627\u0638 \u0628\u0647."
      },
      cancelled: {
        title: "\u062A\u0645\u0651 \u0625\u0644\u063A\u0627\u0621 \u0627\u0634\u062A\u0631\u0627\u0643\u0643",
        body: "\u0627\u0646\u062A\u0647\u0649 \u0627\u0644\u0627\u0634\u062A\u0631\u0627\u0643 \u064A\u0648\u0645 {date}: \u0645\u0643\u062A\u0628\u0643 \u0641\u064A \u0648\u0636\u0639 \u0627\u0644\u0642\u0631\u0627\u0621\u0629 \u0641\u0642\u0637. \u0645\u0627 \u0632\u0627\u0644 \u0628\u0625\u0645\u0643\u0627\u0646\u0643 \u0627\u0644\u0627\u0637\u0651\u0644\u0627\u0639 \u0639\u0644\u0649 \u0628\u064A\u0627\u0646\u0627\u062A\u0643 \u0648\u062A\u0635\u062F\u064A\u0631\u0647\u0627.",
        owner: "\u0627\u062E\u062A\u0631 \u0628\u0627\u0642\u0629 \u0644\u0625\u0639\u0627\u062F\u0629 \u062A\u0641\u0639\u064A\u0644 \u0643\u0644\u0651 \u0634\u064A\u0621.",
        member: "\u0627\u0637\u0644\u0628 \u0645\u0646 \u0645\u0627\u0644\u0643 \u0645\u0643\u062A\u0628\u0643 \u0627\u0644\u0627\u0634\u062A\u0631\u0627\u0643 \u0645\u0646 \u062C\u062F\u064A\u062F."
      },
      action: {
        choose: "\u0627\u062E\u062A\u064A\u0627\u0631 \u0628\u0627\u0642\u0629",
        pay: "\u0633\u062F\u0627\u062F \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629",
        resume: "\u0627\u0633\u062A\u0626\u0646\u0627\u0641",
        withdraw: "\u0627\u0644\u062A\u0631\u0627\u062C\u0639 \u0639\u0646 \u0627\u0644\u0625\u0644\u063A\u0627\u0621",
        view: "\u0639\u0631\u0636 \u0627\u0644\u0627\u0634\u062A\u0631\u0627\u0643"
      }
    }
  },
  subscription: {
    title: "\u0627\u0644\u0627\u0634\u062A\u0631\u0627\u0643",
    loadFailedTitle: "\u062A\u0639\u0630\u0651\u0631 \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0627\u0634\u062A\u0631\u0627\u0643",
    loadFailedBody: "\u062A\u062D\u0642\u0642 \u0645\u0646 \u0627\u062A\u0635\u0627\u0644\u0643 \u062B\u0645 \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629.",
    readOnlyNote: "\u0623\u0646\u062A \u062A\u0637\u0651\u0644\u0639 \u0639\u0644\u0649 \u0627\u0644\u0627\u0634\u062A\u0631\u0627\u0643 \u0644\u0644\u0642\u0631\u0627\u0621\u0629 \u0641\u0642\u0637. \u0648\u062D\u062F\u0647 \u0645\u0627\u0644\u0643 \u0627\u0644\u0645\u0643\u062A\u0628 \u064A\u0645\u0643\u0646\u0647 \u062A\u0639\u062F\u064A\u0644\u0647 \u0623\u0648 \u0633\u062F\u0627\u062F \u0627\u0644\u0641\u0648\u0627\u062A\u064A\u0631.",
    enterpriseNote: "\u0628\u0627\u0642\u0629 Enterprise \u0627\u0644\u062E\u0627\u0635\u0629 \u0628\u0643 \u062A\u064F\u062F\u0627\u0631 \u0628\u0639\u0642\u062F. \u0644\u062A\u0639\u062F\u064A\u0644\u0647\u0627\u060C \u062A\u0648\u0627\u0635\u0644 \u0645\u0639 \u0627\u0644\u0641\u0631\u064A\u0642 \u0627\u0644\u062A\u062C\u0627\u0631\u064A \u0641\u064A BatiFlow.",
    pay: "\u0633\u062F\u0627\u062F",
    taxIncluded: "\u0634\u0627\u0645\u0644 \u0627\u0644\u0636\u0631\u064A\u0628\u0629",
    status: {
      trialing: "\u0641\u062A\u0631\u0629 \u062A\u062C\u0631\u064A\u0628\u064A\u0629",
      active: "\u0646\u0634\u0637",
      past_due: "\u062F\u0641\u0639\u0629 \u0645\u062A\u0623\u062E\u0631\u0629",
      read_only: "\u0642\u0631\u0627\u0621\u0629 \u0641\u0642\u0637",
      suspended: "\u0645\u0648\u0642\u0648\u0641",
      paused: "\u0645\u062A\u0648\u0642\u0641 \u0645\u0624\u0642\u062A\u064B\u0627",
      cancelled: "\u0645\u0644\u063A\u0649"
    },
    plans: {
      solo: "Solo",
      starter: "Starter",
      pro: "Pro",
      business: "Business",
      enterprise: "Enterprise"
    },
    cycle: {
      monthly: "\u0634\u0647\u0631\u064A",
      annual: "\u0633\u0646\u0648\u064A"
    },
    paymentMethods: {
      card: "\u0628\u0637\u0627\u0642\u0629 \u0645\u0635\u0631\u0641\u064A\u0629",
      bank_transfer: "\u062A\u062D\u0648\u064A\u0644 \u0645\u0635\u0631\u0641\u064A",
      cheque: "\u0634\u064A\u0643",
      online: "\u0627\u0644\u062F\u0641\u0639 \u0639\u0628\u0631 \u0627\u0644\u0625\u0646\u062A\u0631\u0646\u062A",
      transfer: "\u062A\u062D\u0648\u064A\u0644 \u0628\u0646\u0643\u064A"
    },
    current: {
      title: "\u0628\u0627\u0642\u062A\u0643",
      description: "\u0628\u0627\u0642\u0629 \u0627\u0634\u062A\u0631\u0627\u0643\u0643 \u0641\u064A BatiFlow \u0648\u062D\u0627\u0644\u062A\u0647 \u0648\u0633\u0639\u0631\u0647 (\u0627\u0644\u0623\u0633\u0639\u0627\u0631 \u062F\u0648\u0646 \u0627\u062D\u062A\u0633\u0627\u0628 \u0627\u0644\u0636\u0631\u064A\u0628\u0629).",
      plan: "\u0627\u0644\u0628\u0627\u0642\u0629",
      cycle: "\u0627\u0644\u0641\u0648\u062A\u0631\u0629",
      period: "\u0627\u0644\u0641\u062A\u0631\u0629 \u0627\u0644\u062D\u0627\u0644\u064A\u0629",
      periodRange: "\u0645\u0646 {start} \u0625\u0644\u0649 {end}",
      nextDue: "\u0627\u0644\u0627\u0633\u062A\u062D\u0642\u0627\u0642 \u0627\u0644\u0642\u0627\u062F\u0645",
      noDue: "\u0644\u0627 \u064A\u0648\u062C\u062F",
      trialEnds: "\u0646\u0647\u0627\u064A\u0629 \u0627\u0644\u0641\u062A\u0631\u0629 \u0627\u0644\u062A\u062C\u0631\u064A\u0628\u064A\u0629",
      price: "\u0627\u0644\u0633\u0639\u0631 \u0644\u0643\u0644 \u0641\u062A\u0631\u0629 (\u062F\u0648\u0646 \u0636\u0631\u064A\u0628\u0629)",
      onQuote: "\u062D\u0633\u0628 \u0639\u0631\u0636 \u0627\u0644\u0633\u0639\u0631",
      perPeriod: {
        monthly: "\u0634\u0647\u0631\u064A\u064B\u0627",
        annual: "\u0633\u0646\u0648\u064A\u064B\u0627"
      },
      extras: "\u0627\u0644\u062E\u064A\u0627\u0631\u0627\u062A",
      noExtras: "\u0644\u0627 \u062A\u0648\u062C\u062F \u062E\u064A\u0627\u0631\u0627\u062A",
      extraSeatsValue: "{count, plural, one {\u0645\u0642\u0639\u062F \u0625\u0636\u0627\u0641\u064A \u0648\u0627\u062D\u062F} two {\u0645\u0642\u0639\u062F\u0627\u0646 \u0625\u0636\u0627\u0641\u064A\u0627\u0646} few {{n} \u0645\u0642\u0627\u0639\u062F \u0625\u0636\u0627\u0641\u064A\u0629} many {{n} \u0645\u0642\u0639\u062F\u064B\u0627 \u0625\u0636\u0627\u0641\u064A\u064B\u0627} other {{n} \u0645\u0642\u0639\u062F \u0625\u0636\u0627\u0641\u064A}}",
      addonValue: "{count, plural, one {{n} \xD7 {size} \u0645\u0646 \u0627\u0644\u062A\u062E\u0632\u064A\u0646} two {{n} \xD7 {size} \u0645\u0646 \u0627\u0644\u062A\u062E\u0632\u064A\u0646} few {{n} \xD7 {size} \u0645\u0646 \u0627\u0644\u062A\u062E\u0632\u064A\u0646} many {{n} \xD7 {size} \u0645\u0646 \u0627\u0644\u062A\u062E\u0632\u064A\u0646} other {{n} \xD7 {size} \u0645\u0646 \u0627\u0644\u062A\u062E\u0632\u064A\u0646}}",
      payment: "\u0637\u0631\u064A\u0642\u0629 \u0627\u0644\u062F\u0641\u0639",
      paymentNone: "\u0644\u0645 \u062A\u064F\u062E\u062A\u0631 \u0628\u0639\u062F",
      paymentHelp: "\u062A\u064F\u0633\u062F\u064E\u0651\u062F \u0643\u0644 \u0641\u0627\u062A\u0648\u0631\u0629 \u0639\u0628\u0631 \u0627\u0644\u0625\u0646\u062A\u0631\u0646\u062A \u0628\u0627\u0644\u0628\u0637\u0627\u0642\u0629 \u0627\u0644\u0645\u0635\u0631\u0641\u064A\u0629\u060C \u0623\u0648 \u0628\u062A\u062D\u0648\u064A\u0644 \u0645\u0635\u0631\u0641\u064A \u0623\u0648 \u0628\u0634\u064A\u0643\u060C \u0648\u0641\u064A \u0647\u0630\u0647 \u0627\u0644\u062D\u0627\u0644\u0629 \u064A\u0624\u0643\u062F \u0641\u0631\u064A\u0642 BatiFlow \u0627\u0633\u062A\u0644\u0627\u0645 \u0627\u0644\u062F\u0641\u0639\u0629."
    },
    openInvoice: {
      title: "\u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629 {number} \u0641\u064A \u0627\u0646\u062A\u0638\u0627\u0631 \u0627\u0644\u0633\u062F\u0627\u062F",
      body: "\u0627\u0644\u0645\u0628\u0644\u063A \u0627\u0644\u0645\u0633\u062A\u062D\u0642:"
    },
    pending: {
      title: "\u0647\u0646\u0627\u0643 \u062A\u063A\u064A\u064A\u0631 \u0645\u0628\u0631\u0645\u062C",
      scheduled: "\u0641\u064A {date}\u060C \u0633\u064A\u0646\u062A\u0642\u0644 \u0627\u0634\u062A\u0631\u0627\u0643\u0643 \u0625\u0644\u0649 \u0628\u0627\u0642\u0629 {plan} ({cycle}).",
      pause: "\u0627\u0628\u062A\u062F\u0627\u0621\u064B \u0645\u0646 {date}\u060C \u0633\u064A\u062A\u0648\u0642\u0641 \u0627\u0634\u062A\u0631\u0627\u0643\u0643 \u0645\u0624\u0642\u062A\u064B\u0627 \u0644\u0645\u062F\u0629 {count, plural, one {\u0634\u0647\u0631 \u0648\u0627\u062D\u062F} two {\u0634\u0647\u0631\u064A\u0646} few {{n} \u0623\u0634\u0647\u0631} many {{n} \u0634\u0647\u0631\u064B\u0627} other {{n} \u0634\u0647\u0631}}.",
      cancel: "\u0633\u064A\u064F\u0644\u063A\u0649 \u0627\u0634\u062A\u0631\u0627\u0643\u0643 \u0641\u064A {date}.",
      withdraw: "\u0627\u0644\u062A\u0631\u0627\u062C\u0639 \u0639\u0646 \u0647\u0630\u0627 \u0627\u0644\u062A\u063A\u064A\u064A\u0631",
      withdrawn: "\u062A\u0645 \u0627\u0644\u062A\u0631\u0627\u062C\u0639 \u0639\u0646 \u0627\u0644\u062A\u063A\u064A\u064A\u0631 \u0627\u0644\u0645\u0628\u0631\u0645\u062C."
    },
    usage: {
      title: "\u0627\u0644\u0627\u0633\u062A\u062E\u062F\u0627\u0645",
      description: "\u0645\u0627 \u064A\u0633\u062A\u062E\u062F\u0645\u0647 \u0645\u0643\u062A\u0628\u0643 \u0645\u0642\u0627\u0631\u0646\u0629\u064B \u0628\u062D\u062F\u0648\u062F \u0628\u0627\u0642\u062A\u0643.",
      seats: "\u0627\u0644\u0645\u0642\u0627\u0639\u062F",
      storage: "\u0627\u0644\u062A\u062E\u0632\u064A\u0646",
      hostedSpaces: "\u0627\u0644\u0645\u0633\u0627\u062D\u0627\u062A \u0627\u0644\u0645\u0634\u062A\u0631\u0643\u0629 \u0627\u0644\u0645\u0633\u062A\u0636\u0627\u0641\u0629",
      of: "{used} \u0645\u0646 {limit}",
      unlimitedOf: "{used} (\u062F\u0648\u0646 \u062D\u062F\u0651 \u0623\u0642\u0635\u0649)",
      percent: "{percent}%"
    },
    compare: {
      title: "\u0645\u0642\u0627\u0631\u0646\u0629 \u0627\u0644\u0628\u0627\u0642\u0627\u062A",
      description: "\u0627\u0644\u0623\u0633\u0639\u0627\u0631 \u062F\u0648\u0646 \u0627\u062D\u062A\u0633\u0627\u0628 \u0627\u0644\u0636\u0631\u064A\u0628\u0629. \u064A\u0643\u0644\u0651\u0641 \u0627\u0644\u0627\u0634\u062A\u0631\u0627\u0643 \u0627\u0644\u0633\u0646\u0648\u064A 10 \u0623\u0634\u0647\u0631 \u0628\u062F\u0644 12.",
      caption: "\u0645\u0642\u0627\u0631\u0646\u0629 \u0628\u064A\u0646 \u0628\u0627\u0642\u0627\u062A BatiFlow",
      loading: "\u062C\u0627\u0631\u064D \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0628\u0627\u0642\u0627\u062A\u2026",
      failed: "\u062A\u0639\u0630\u0651\u0631 \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0628\u0627\u0642\u0627\u062A \u062D\u0627\u0644\u064A\u064B\u0627.",
      current: "\u0628\u0627\u0642\u062A\u0643",
      monthly: "\u0627\u0644\u0633\u0639\u0631 \u0627\u0644\u0634\u0647\u0631\u064A (\u062F\u0648\u0646 \u0636\u0631\u064A\u0628\u0629)",
      annual: "\u0627\u0644\u0633\u0639\u0631 \u0627\u0644\u0633\u0646\u0648\u064A (\u062F\u0648\u0646 \u0636\u0631\u064A\u0628\u0629)",
      seats: "\u0627\u0644\u0645\u0642\u0627\u0639\u062F \u0627\u0644\u0645\u0634\u0645\u0648\u0644\u0629",
      extraSeat: "\u0645\u0642\u0639\u062F \u0625\u0636\u0627\u0641\u064A (\u0634\u0647\u0631\u064A\u064B\u0627)",
      storage: "\u0627\u0644\u062A\u062E\u0632\u064A\u0646 \u0627\u0644\u0645\u0634\u0645\u0648\u0644",
      hostedSpaces: "\u0627\u0644\u0645\u0633\u0627\u062D\u0627\u062A \u0627\u0644\u0645\u0634\u062A\u0631\u0643\u0629 \u0627\u0644\u0645\u0633\u062A\u0636\u0627\u0641\u0629",
      meetingParticipants: "\u0627\u0644\u0645\u0634\u0627\u0631\u0643\u0648\u0646 \u0641\u064A \u0643\u0644 \u0627\u062C\u062A\u0645\u0627\u0639",
      unlimited: "\u063A\u064A\u0631 \u0645\u062D\u062F\u0648\u062F",
      byContract: "\u062D\u0633\u0628 \u0627\u0644\u0639\u0642\u062F",
      onQuote: "\u062D\u0633\u0628 \u0639\u0631\u0636 \u0627\u0644\u0633\u0639\u0631",
      notOffered: "\u063A\u064A\u0631 \u0645\u062A\u0627\u062D",
      enterprise: "\u062A\u064F\u0628\u0627\u0639 \u0628\u0627\u0642\u0629 Enterprise \u0628\u0639\u0631\u0636 \u0633\u0639\u0631: \u062A\u0648\u0627\u0635\u0644 \u0645\u0639 \u0627\u0644\u0641\u0631\u064A\u0642 \u0627\u0644\u062A\u062C\u0627\u0631\u064A \u0641\u064A BatiFlow."
    },
    change: {
      button: "\u062A\u0639\u062F\u064A\u0644 \u0627\u0644\u0627\u0634\u062A\u0631\u0627\u0643",
      title: "\u062A\u0639\u062F\u064A\u0644 \u0627\u0644\u0627\u0634\u062A\u0631\u0627\u0643",
      intro: "\u0627\u062E\u062A\u0631 \u0627\u0644\u0628\u0627\u0642\u0629 \u0648\u0641\u062A\u0631\u0629 \u0627\u0644\u0641\u0648\u062A\u0631\u0629 \u0648\u0627\u0644\u062E\u064A\u0627\u0631\u0627\u062A. \u064A\u0638\u0647\u0631 \u0627\u0644\u0633\u0639\u0631 \u0642\u0628\u0644 \u062A\u0623\u0643\u064A\u062F \u0623\u064A \u0634\u064A\u0621.",
      plan: "\u0627\u0644\u0628\u0627\u0642\u0629",
      planOnQuote: "{plan} (\u062D\u0633\u0628 \u0639\u0631\u0636 \u0627\u0644\u0633\u0639\u0631)",
      cycle: "\u0627\u0644\u0641\u0648\u062A\u0631\u0629",
      cycleHint: "\u0633\u0646\u0648\u064A: \u062A\u062F\u0641\u0639 10 \u0623\u0634\u0647\u0631 \u0645\u0642\u0627\u0628\u0644 12.",
      extraSeats: "\u0627\u0644\u0645\u0642\u0627\u0639\u062F \u0627\u0644\u0625\u0636\u0627\u0641\u064A\u0629",
      noExtraSeats: "\u0644\u0627 \u062A\u062A\u064A\u062D \u0647\u0630\u0647 \u0627\u0644\u0628\u0627\u0642\u0629 \u0645\u0642\u0627\u0639\u062F \u0625\u0636\u0627\u0641\u064A\u0629.",
      addon: "\u062A\u062E\u0632\u064A\u0646 \u0625\u0636\u0627\u0641\u064A {size}",
      stepUpNote: "\u0644\u062A\u0623\u0643\u064A\u062F \u0627\u0644\u062A\u0639\u062F\u064A\u0644\u060C \u0633\u064A\u064F\u0637\u0644\u0628 \u0645\u0646\u0643 \u062A\u0623\u0643\u064A\u062F \u0647\u0648\u064A\u062A\u0643.",
      confirm: "\u062A\u0623\u0643\u064A\u062F \u0627\u0644\u062A\u0639\u062F\u064A\u0644",
      confirmPay: "\u0627\u0644\u062A\u0623\u0643\u064A\u062F \u0648\u0627\u0633\u062A\u0644\u0627\u0645 \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629",
      confirming: "\u062C\u0627\u0631\u064D \u0627\u0644\u0625\u0631\u0633\u0627\u0644\u2026",
      scheduledDone: "\u062A\u0645\u062A \u0628\u0631\u0645\u062C\u0629 \u0627\u0644\u062A\u0639\u062F\u064A\u0644: \u0633\u064A\u064F\u0637\u0628\u064E\u0651\u0642 \u0641\u064A {date}."
    },
    quote: {
      title: "\u0645\u0639\u0627\u064A\u0646\u0629 \u0627\u0644\u0633\u0639\u0631",
      loading: "\u062C\u0627\u0631\u064D \u0627\u062D\u062A\u0633\u0627\u0628 \u0627\u0644\u0633\u0639\u0631\u2026",
      unchanged: "\u0627\u062E\u062A\u0631 \u0628\u0627\u0642\u0629 \u0623\u062E\u0631\u0649 \u0623\u0648 \u062E\u064A\u0627\u0631\u0627\u062A \u0623\u062E\u0631\u0649 \u0644\u0639\u0631\u0636 \u0627\u0644\u0633\u0639\u0631.",
      caption: "\u062A\u0641\u0635\u064A\u0644 \u0627\u0644\u0633\u0639\u0631",
      columns: {
        label: "\u0627\u0644\u0628\u0646\u062F",
        quantity: "\u0627\u0644\u0643\u0645\u064A\u0629",
        unitPrice: "\u0633\u0639\u0631 \u0627\u0644\u0648\u062D\u062F\u0629",
        amount: "\u0627\u0644\u0645\u0628\u0644\u063A"
      },
      totalHt: "\u0627\u0644\u0625\u062C\u0645\u0627\u0644\u064A \u062F\u0648\u0646 \u0636\u0631\u064A\u0628\u0629",
      totalTtc: "\u0627\u0644\u0625\u062C\u0645\u0627\u0644\u064A \u0634\u0627\u0645\u0644 \u0627\u0644\u0636\u0631\u064A\u0628\u0629",
      kind: {
        start: "\u064A\u0628\u062F\u0623 \u0627\u0634\u062A\u0631\u0627\u0643\u0643 \u0627\u0644\u0645\u062F\u0641\u0648\u0639. \u062A\u064F\u0635\u062F\u0631 \u0641\u0627\u062A\u0648\u0631\u0629 \u0627\u0644\u0622\u0646\u060C \u0648\u064A\u0633\u0631\u064A \u0627\u0644\u062A\u0639\u062F\u064A\u0644 \u0628\u0645\u062C\u0631\u062F \u0633\u062F\u0627\u062F\u0647\u0627. \u0627\u0644\u0641\u062A\u0631\u0629 \u0627\u0644\u062C\u062F\u064A\u062F\u0629: \u0645\u0646 {start} \u0625\u0644\u0649 {end}.",
        upgrade: "\u062A\u064F\u0635\u062F\u0631 \u0627\u0644\u0622\u0646 \u0641\u0627\u062A\u0648\u0631\u0629 \u0628\u0627\u0644\u062A\u0646\u0627\u0633\u0628 ({remaining} \u064A\u0648\u0645\u064B\u0627 \u0645\u062A\u0628\u0642\u064A\u064B\u0627 \u0645\u0646 {total})\u060C \u0648\u064A\u0633\u0631\u064A \u0627\u0644\u062A\u0639\u062F\u064A\u0644 \u0628\u0645\u062C\u0631\u062F \u0633\u062F\u0627\u062F\u0647\u0627.",
        restart: "\u064A\u064F\u0639\u0627\u062F \u062A\u0634\u063A\u064A\u0644 \u0627\u0634\u062A\u0631\u0627\u0643\u0643. \u062A\u064F\u0635\u062F\u0631 \u0641\u0627\u062A\u0648\u0631\u0629 \u0627\u0644\u0622\u0646\u060C \u0648\u064A\u0633\u062A\u0623\u0646\u0641 \u0628\u0645\u062C\u0631\u062F \u0633\u062F\u0627\u062F\u0647\u0627. \u0627\u0644\u0641\u062A\u0631\u0629 \u0627\u0644\u062C\u062F\u064A\u062F\u0629: \u0645\u0646 {start} \u0625\u0644\u0649 {end}.",
        scheduled: "\u0644\u0627 \u062F\u0641\u0639 \u0627\u0644\u0622\u0646. \u0633\u064A\u064F\u0637\u0628\u064E\u0651\u0642 \u0627\u0644\u062A\u0639\u062F\u064A\u0644 \u0641\u064A {date}\u060C \u0639\u0646\u062F \u0646\u0647\u0627\u064A\u0629 \u0627\u0644\u0641\u062A\u0631\u0629 \u0627\u0644\u062D\u0627\u0644\u064A\u0629.",
        none: "\u0644\u0627 \u062A\u063A\u064A\u064A\u0631: \u0647\u0630\u0627 \u0627\u0644\u0627\u062E\u062A\u064A\u0627\u0631 \u0647\u0648 \u0646\u0641\u0633\u0647 \u0627\u0634\u062A\u0631\u0627\u0643\u0643 \u0627\u0644\u062D\u0627\u0644\u064A."
      },
      lines: {
        plan: "\u0627\u0644\u0628\u0627\u0642\u0629",
        extra_seats: "\u0627\u0644\u0645\u0642\u0627\u0639\u062F \u0627\u0644\u0625\u0636\u0627\u0641\u064A\u0629",
        addon: "\u062A\u062E\u0632\u064A\u0646 \u0625\u0636\u0627\u0641\u064A {size}",
        proration: "\u062A\u0633\u0648\u064A\u0629 \u0628\u0627\u0644\u062A\u0646\u0627\u0633\u0628",
        credit_unused: "\u0631\u0635\u064A\u062F \u0639\u0646 \u0627\u0644\u0641\u062A\u0631\u0629 \u063A\u064A\u0631 \u0627\u0644\u0645\u0633\u062A\u0639\u0645\u0644\u0629",
        pause: "\u0625\u064A\u0642\u0627\u0641 \u0645\u0624\u0642\u062A (20% \u0645\u0646 \u0627\u0644\u0633\u0639\u0631)",
        fair_billing: "\u0631\u0635\u064A\u062F \u0627\u0644\u0641\u0648\u062A\u0631\u0629 \u0627\u0644\u0639\u0627\u062F\u0644\u0629"
      },
      blockedTitle: "\u0647\u0630\u0647 \u0627\u0644\u0628\u0627\u0642\u0629 \u0623\u0635\u063A\u0631 \u0645\u0646 \u0627\u0633\u062A\u062E\u062F\u0627\u0645\u0643 \u0627\u0644\u062D\u0627\u0644\u064A. \u0644\u0627\u062E\u062A\u064A\u0627\u0631\u0647\u0627:",
      blockers: {
        seats: "\u0642\u0644\u0651\u0635 \u0627\u0644\u0645\u0642\u0627\u0639\u062F \u0645\u0646 {used} \u0625\u0644\u0649 {limit}.",
        storage: "\u062D\u0631\u0651\u0631 \u0645\u0633\u0627\u062D\u0629 \u062A\u062E\u0632\u064A\u0646: {used} \u0645\u0633\u062A\u0639\u0645\u0644\u0629 \u0645\u0642\u0627\u0628\u0644 {limit} \u0645\u062A\u0627\u062D\u0629.",
        hosted_spaces: "\u0642\u0644\u0651\u0635 \u0627\u0644\u0645\u0633\u0627\u062D\u0627\u062A \u0627\u0644\u0645\u0634\u062A\u0631\u0643\u0629 \u0627\u0644\u0645\u0633\u062A\u0636\u0627\u0641\u0629 \u0645\u0646 {used} \u0625\u0644\u0649 {limit}."
      },
      reduce: {
        seats: "\u0642\u0644\u0651\u0635 \u0639\u062F\u062F \u0627\u0644\u0645\u0642\u0627\u0639\u062F \u0627\u0644\u0645\u0633\u062A\u0639\u0645\u0644\u0629.",
        storage: "\u062D\u0631\u0651\u0631 \u0645\u0633\u0627\u062D\u0629 \u062A\u062E\u0632\u064A\u0646.",
        hostedSpaces: "\u0642\u0644\u0651\u0635 \u0639\u062F\u062F \u0627\u0644\u0645\u0633\u0627\u062D\u0627\u062A \u0627\u0644\u0645\u0634\u062A\u0631\u0643\u0629 \u0627\u0644\u0645\u0633\u062A\u0636\u0627\u0641\u0629."
      }
    },
    invoiceIssued: {
      title: "\u0635\u062F\u0631\u062A \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629 {number}",
      amount: "\u0627\u0644\u0645\u0628\u0644\u063A \u0627\u0644\u0645\u0633\u062A\u062D\u0642:",
      later: "\u0644\u0627\u062D\u0642\u064B\u0627",
      applies: {
        start: "\u064A\u0633\u0631\u064A \u0627\u0644\u062A\u0639\u062F\u064A\u0644 \u0628\u0645\u062C\u0631\u062F \u0633\u062F\u0627\u062F \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629.",
        upgrade: "\u064A\u0633\u0631\u064A \u0627\u0644\u062A\u0639\u062F\u064A\u0644 \u0628\u0645\u062C\u0631\u062F \u0633\u062F\u0627\u062F \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629.",
        restart: "\u064A\u064F\u0633\u062A\u0623\u0646\u0641 \u0627\u0644\u0627\u0634\u062A\u0631\u0627\u0643 \u0628\u0645\u062C\u0631\u062F \u0633\u062F\u0627\u062F \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629.",
        renewal: "\u064A\u062A\u0623\u0643\u062F \u0627\u0644\u062A\u062C\u062F\u064A\u062F \u0628\u0645\u062C\u0631\u062F \u0633\u062F\u0627\u062F \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629.",
        resume: "\u064A\u064F\u0633\u062A\u0623\u0646\u0641 \u0627\u0644\u0627\u0634\u062A\u0631\u0627\u0643 \u0628\u0645\u062C\u0631\u062F \u0633\u062F\u0627\u062F \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629."
      }
    },
    invoices: {
      title: "\u0641\u0648\u0627\u062A\u064A\u0631 \u0627\u0644\u0627\u0634\u062A\u0631\u0627\u0643",
      description: "\u0627\u0644\u0641\u0648\u0627\u062A\u064A\u0631 \u0627\u0644\u062A\u064A \u0623\u0635\u062F\u0631\u062A\u0647\u0627 BatiFlow \u0644\u0643. \u064A\u0645\u0643\u0646 \u0633\u062F\u0627\u062F \u0627\u0644\u0641\u0648\u0627\u062A\u064A\u0631 \u0627\u0644\u0645\u0641\u062A\u0648\u062D\u0629 \u0639\u0628\u0631 \u0627\u0644\u0625\u0646\u062A\u0631\u0646\u062A.",
      caption: "\u0641\u0648\u0627\u062A\u064A\u0631 \u0627\u0634\u062A\u0631\u0627\u0643 BatiFlow",
      columns: {
        number: "\u0627\u0644\u0631\u0642\u0645",
        purpose: "\u0627\u0644\u063A\u0631\u0636",
        issueDate: "\u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0625\u0635\u062F\u0627\u0631",
        dueDate: "\u0627\u0644\u0633\u062F\u0627\u062F \u0642\u0628\u0644",
        total: "\u0627\u0644\u0625\u062C\u0645\u0627\u0644\u064A \u0634\u0627\u0645\u0644 \u0627\u0644\u0636\u0631\u064A\u0628\u0629",
        status: "\u0627\u0644\u062D\u0627\u0644\u0629",
        actions: "\u0627\u0644\u0625\u062C\u0631\u0627\u0621\u0627\u062A"
      },
      purpose: {
        start: "\u0628\u062F\u0627\u064A\u0629 \u0627\u0644\u0627\u0634\u062A\u0631\u0627\u0643",
        upgrade: "\u062A\u063A\u064A\u064A\u0631 \u0627\u0644\u0628\u0627\u0642\u0629",
        restart: "\u0625\u0639\u0627\u062F\u0629 \u0627\u0644\u062A\u0634\u063A\u064A\u0644",
        renewal: "\u0627\u0644\u062A\u062C\u062F\u064A\u062F",
        resume: "\u0627\u0644\u0627\u0633\u062A\u0626\u0646\u0627\u0641 \u0628\u0639\u062F \u0627\u0644\u0625\u064A\u0642\u0627\u0641 \u0627\u0644\u0645\u0624\u0642\u062A"
      },
      status: {
        open: "\u0644\u0644\u0633\u062F\u0627\u062F",
        paid: "\u0645\u0633\u062F\u064E\u0651\u062F\u0629",
        void: "\u0645\u0644\u063A\u0627\u0629"
      },
      pdf: "PDF",
      pdfFor: "\u062A\u0646\u0632\u064A\u0644 PDF \u0644\u0644\u0641\u0627\u062A\u0648\u0631\u0629 {number}",
      payFor: "\u0633\u062F\u0627\u062F \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629 {number}",
      loadFailedTitle: "\u062A\u0639\u0630\u0651\u0631 \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0641\u0648\u0627\u062A\u064A\u0631",
      empty: {
        title: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0641\u0648\u0627\u062A\u064A\u0631 \u0628\u0639\u062F",
        description: "\u0633\u062A\u0638\u0647\u0631 \u0641\u0648\u0627\u062A\u064A\u0631 \u0627\u0634\u062A\u0631\u0627\u0643\u0643 \u0647\u0646\u0627."
      }
    },
    actions: {
      title: "\u0625\u062F\u0627\u0631\u0629 \u0627\u0644\u0627\u0634\u062A\u0631\u0627\u0643",
      description: "\u0627\u0644\u062A\u062C\u062F\u064A\u062F \u0623\u0648 \u0627\u0644\u0625\u064A\u0642\u0627\u0641 \u0627\u0644\u0645\u0624\u0642\u062A \u0623\u0648 \u0627\u0644\u0625\u0644\u063A\u0627\u0621. \u0647\u0630\u0647 \u0627\u0644\u0625\u062C\u0631\u0627\u0621\u0627\u062A \u0645\u062E\u0635\u0635\u0629 \u0644\u0645\u0627\u0644\u0643 \u0627\u0644\u0645\u0643\u062A\u0628.",
      renew: {
        title: "\u0627\u0644\u062A\u062C\u062F\u064A\u062F \u0627\u0644\u0622\u0646",
        hint: "\u062A\u0646\u062A\u0647\u064A \u0641\u062A\u0631\u062A\u0643 \u0627\u0644\u062D\u0627\u0644\u064A\u0629 \u0641\u064A {date}. \u062C\u062F\u0651\u062F \u0627\u0644\u0622\u0646 \u0644\u062A\u062A\u0644\u0642\u0649 \u0641\u0627\u062A\u0648\u0631\u0629 \u0627\u0644\u0641\u062A\u0631\u0629 \u0627\u0644\u062A\u0627\u0644\u064A\u0629.",
        button: "\u062A\u062C\u062F\u064A\u062F",
        confirmTitle: "\u062A\u062C\u062F\u064A\u062F \u0627\u0644\u0627\u0634\u062A\u0631\u0627\u0643\u061F",
        confirmBody: "\u062A\u064F\u0635\u062F\u0631 \u0627\u0644\u0622\u0646 \u0641\u0627\u062A\u0648\u0631\u0629 \u062A\u062C\u062F\u064A\u062F \u0644\u0644\u0641\u062A\u0631\u0629 \u0627\u0644\u062A\u064A \u062A\u0644\u064A {date}. \u064A\u0645\u0643\u0646\u0643 \u0633\u062F\u0627\u062F\u0647\u0627 \u0641\u0648\u0631\u064B\u0627.",
        confirm: "\u062A\u062C\u062F\u064A\u062F"
      },
      pause: {
        title: "\u0625\u064A\u0642\u0627\u0641 \u0645\u0624\u0642\u062A",
        hint: "{count, plural, one {\u062A\u0628\u0642\u0651\u0649 \u0644\u0643 \u0634\u0647\u0631 \u0648\u0627\u062D\u062F \u0645\u0646 \u0627\u0644\u0625\u064A\u0642\u0627\u0641 \u0627\u0644\u0645\u0624\u0642\u062A \u0647\u0630\u0627 \u0627\u0644\u0639\u0627\u0645 (3 \u0643\u062D\u062F\u0651 \u0623\u0642\u0635\u0649).} two {\u062A\u0628\u0642\u0651\u0649 \u0644\u0643 \u0634\u0647\u0631\u0627\u0646 \u0645\u0646 \u0627\u0644\u0625\u064A\u0642\u0627\u0641 \u0627\u0644\u0645\u0624\u0642\u062A \u0647\u0630\u0627 \u0627\u0644\u0639\u0627\u0645 (3 \u0643\u062D\u062F\u0651 \u0623\u0642\u0635\u0649).} few {\u062A\u0628\u0642\u0651\u062A \u0644\u0643 {n} \u0623\u0634\u0647\u0631 \u0645\u0646 \u0627\u0644\u0625\u064A\u0642\u0627\u0641 \u0627\u0644\u0645\u0624\u0642\u062A \u0647\u0630\u0627 \u0627\u0644\u0639\u0627\u0645 (3 \u0643\u062D\u062F\u0651 \u0623\u0642\u0635\u0649).} many {\u062A\u0628\u0642\u0651\u0649 \u0644\u0643 {n} \u0634\u0647\u0631\u064B\u0627 \u0645\u0646 \u0627\u0644\u0625\u064A\u0642\u0627\u0641 \u0627\u0644\u0645\u0624\u0642\u062A \u0647\u0630\u0627 \u0627\u0644\u0639\u0627\u0645 (3 \u0643\u062D\u062F\u0651 \u0623\u0642\u0635\u0649).} other {\u062A\u0628\u0642\u0651\u0649 \u0644\u0643 {n} \u0634\u0647\u0631 \u0645\u0646 \u0627\u0644\u0625\u064A\u0642\u0627\u0641 \u0627\u0644\u0645\u0624\u0642\u062A \u0647\u0630\u0627 \u0627\u0644\u0639\u0627\u0645 (3 \u0643\u062D\u062F\u0651 \u0623\u0642\u0635\u0649).}} \u0623\u062B\u0646\u0627\u0621 \u0627\u0644\u0625\u064A\u0642\u0627\u0641 \u0627\u0644\u0645\u0624\u0642\u062A \u062A\u062F\u0641\u0639 20% \u0645\u0646 \u0627\u0644\u0633\u0639\u0631.",
        none: "\u0627\u0633\u062A\u0639\u0645\u0644\u062A \u0623\u0634\u0647\u0631 \u0627\u0644\u0625\u064A\u0642\u0627\u0641 \u0627\u0644\u0645\u0624\u0642\u062A \u0627\u0644\u062B\u0644\u0627\u062B\u0629 \u0627\u0644\u0645\u0633\u0645\u0648\u062D \u0628\u0647\u0627 \u0647\u0630\u0627 \u0627\u0644\u0639\u0627\u0645.",
        duration: "\u0645\u062F\u0629 \u0627\u0644\u0625\u064A\u0642\u0627\u0641 \u0627\u0644\u0645\u0624\u0642\u062A",
        option: "{count, plural, one {\u0634\u0647\u0631 \u0648\u0627\u062D\u062F} two {\u0634\u0647\u0631\u0627\u0646} few {{n} \u0623\u0634\u0647\u0631} many {{n} \u0634\u0647\u0631\u064B\u0627} other {{n} \u0634\u0647\u0631}}",
        button: "\u0625\u064A\u0642\u0627\u0641 \u0645\u0624\u0642\u062A",
        confirmTitle: "\u0625\u064A\u0642\u0627\u0641 \u0627\u0644\u0627\u0634\u062A\u0631\u0627\u0643 \u0645\u0624\u0642\u062A\u064B\u0627\u061F",
        confirmBody: "\u064A\u0628\u062F\u0623 \u0627\u0644\u0625\u064A\u0642\u0627\u0641 \u0627\u0644\u0645\u0624\u0642\u062A \u0639\u0646\u062F \u0646\u0647\u0627\u064A\u0629 \u0627\u0644\u0641\u062A\u0631\u0629 \u0627\u0644\u062D\u0627\u0644\u064A\u0629 ({date}) \u0648\u064A\u0633\u062A\u0645\u0631 {count, plural, one {\u0634\u0647\u0631\u064B\u0627 \u0648\u0627\u062D\u062F\u064B\u0627} two {\u0634\u0647\u0631\u064A\u0646} few {{n} \u0623\u0634\u0647\u0631} many {{n} \u0634\u0647\u0631\u064B\u0627} other {{n} \u0634\u0647\u0631}}. \u062A\u062F\u0641\u0639 20% \u0645\u0646 \u0627\u0644\u0633\u0639\u0631 \u0639\u0646 \u0647\u0630\u0647 \u0627\u0644\u0623\u0634\u0647\u0631 \u0639\u0646\u062F \u0627\u0644\u0627\u0633\u062A\u0626\u0646\u0627\u0641. \u064A\u0645\u0643\u0646\u0643 \u0627\u0644\u0627\u0633\u062A\u0626\u0646\u0627\u0641 \u0645\u062A\u0649 \u0634\u0626\u062A.",
        confirm: "\u0625\u064A\u0642\u0627\u0641 \u0645\u0624\u0642\u062A",
        done: "\u062A\u0645\u062A \u0628\u0631\u0645\u062C\u0629 \u0627\u0644\u0625\u064A\u0642\u0627\u0641 \u0627\u0644\u0645\u0624\u0642\u062A \u0627\u0628\u062A\u062F\u0627\u0621\u064B \u0645\u0646 {date}."
      },
      resume: {
        title: "\u0627\u0633\u062A\u0626\u0646\u0627\u0641 \u0627\u0644\u0627\u0634\u062A\u0631\u0627\u0643",
        hint: "\u0627\u0634\u062A\u0631\u0627\u0643\u0643 \u0645\u062A\u0648\u0642\u0641 \u0645\u0624\u0642\u062A\u064B\u0627 \u062D\u062A\u0649 {date}. \u064A\u0645\u0643\u0646\u0643 \u0627\u0633\u062A\u0626\u0646\u0627\u0641\u0647 \u0642\u0628\u0644 \u0630\u0644\u0643.",
        hintNoDate: "\u0627\u0634\u062A\u0631\u0627\u0643\u0643 \u0645\u062A\u0648\u0642\u0641 \u0645\u0624\u0642\u062A\u064B\u0627. \u0627\u0633\u062A\u0623\u0646\u0641\u0647 \u0645\u062A\u0649 \u0634\u0626\u062A.",
        button: "\u0627\u0633\u062A\u0626\u0646\u0627\u0641",
        confirmTitle: "\u0627\u0633\u062A\u0626\u0646\u0627\u0641 \u0627\u0644\u0627\u0634\u062A\u0631\u0627\u0643\u061F",
        confirmBody: "\u062A\u064F\u0635\u062F\u0631 \u0627\u0644\u0622\u0646 \u0641\u0627\u062A\u0648\u0631\u0629: \u0623\u0634\u0647\u0631 \u0627\u0644\u0625\u064A\u0642\u0627\u0641 \u0627\u0644\u0645\u0624\u0642\u062A \u0628\u0646\u0633\u0628\u0629 20% \u0645\u0646 \u0627\u0644\u0633\u0639\u0631\u060C \u0625\u0636\u0627\u0641\u0629\u064B \u0625\u0644\u0649 \u0641\u062A\u0631\u0629 \u062C\u062F\u064A\u062F\u0629. \u064A\u064F\u0633\u062A\u0623\u0646\u0641 \u0627\u0644\u0627\u0634\u062A\u0631\u0627\u0643 \u0628\u0645\u062C\u0631\u062F \u0633\u062F\u0627\u062F\u0647\u0627.",
        confirm: "\u0627\u0633\u062A\u0626\u0646\u0627\u0641"
      },
      cancel: {
        title: "\u0625\u0644\u063A\u0627\u0621 \u0627\u0644\u0627\u0634\u062A\u0631\u0627\u0643",
        hint: "\u064A\u0633\u0631\u064A \u0627\u0644\u0625\u0644\u063A\u0627\u0621 \u0639\u0646\u062F \u0646\u0647\u0627\u064A\u0629 \u0627\u0644\u0641\u062A\u0631\u0629 \u0627\u0644\u062D\u0627\u0644\u064A\u0629\u060C \u0641\u064A {date}.",
        button: "\u0625\u0644\u063A\u0627\u0621 \u0627\u0644\u0627\u0634\u062A\u0631\u0627\u0643",
        confirmTitle: "\u0625\u0644\u063A\u0627\u0621 \u0627\u0644\u0627\u0634\u062A\u0631\u0627\u0643\u061F",
        confirmBody: "\u064A\u0628\u0642\u0649 \u0627\u0634\u062A\u0631\u0627\u0643\u0643 \u0646\u0634\u0637\u064B\u0627 \u062D\u062A\u0649 {date}\u060C \u062B\u0645 \u064A\u0646\u062A\u0647\u064A.",
        afterwards: "\u0628\u0639\u062F \u0630\u0644\u0643\u060C \u064A\u062A\u062D\u0648\u0644 \u0645\u0643\u062A\u0628\u0643 \u0625\u0644\u0649 \u0648\u0636\u0639 \u0627\u0644\u0642\u0631\u0627\u0621\u0629 \u0641\u0642\u0637 \u0644\u0645\u062F\u0629 90 \u064A\u0648\u0645\u064B\u0627: \u064A\u0645\u0643\u0646\u0643 \u0627\u0644\u0627\u0637\u0644\u0627\u0639 \u0639\u0644\u0649 \u0628\u064A\u0627\u0646\u0627\u062A\u0643 \u0648\u062A\u0635\u062F\u064A\u0631\u0647\u0627. \u0648\u0628\u0639\u062F \u0647\u0630\u0647 \u0627\u0644\u0645\u0647\u0644\u0629 \u062A\u064F\u062D\u0630\u0641. \u0645\u0627 \u062F\u0627\u0645\u062A \u0627\u0644\u0641\u062A\u0631\u0629 \u0644\u0645 \u062A\u0646\u062A\u0647\u0650\u060C \u064A\u0645\u0643\u0646\u0643 \u0627\u0644\u062A\u0631\u0627\u062C\u0639 \u0639\u0646 \u0627\u0644\u0625\u0644\u063A\u0627\u0621.",
        confirm: "\u0625\u0644\u063A\u0627\u0621 \u0627\u0644\u0627\u0634\u062A\u0631\u0627\u0643",
        done: "\u062A\u0645\u062A \u0628\u0631\u0645\u062C\u0629 \u0627\u0644\u0625\u0644\u063A\u0627\u0621: \u0633\u064A\u0646\u062A\u0647\u064A \u0627\u0644\u0627\u0634\u062A\u0631\u0627\u0643 \u0641\u064A {date}."
      }
    }
  },
  dataExport: {
    columns: {
      requestedAt: "\u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0637\u0644\u0628",
      scope: "\u0627\u0644\u0646\u0648\u0639",
      requestedBy: "\u0637\u0644\u0628\u0647",
      status: "\u0627\u0644\u062D\u0627\u0644\u0629",
      size: "\u0627\u0644\u062D\u062C\u0645",
      expiresAt: "\u0645\u062A\u0627\u062D \u062D\u062A\u0649",
      actions: "\u0627\u0644\u0625\u062C\u0631\u0627\u0621\u0627\u062A"
    },
    scope: {
      organization: "\u0643\u0627\u0645\u0644",
      finance: "\u0645\u0627\u0644\u064A"
    },
    status: {
      queued: "\u0641\u064A \u0627\u0644\u0627\u0646\u062A\u0638\u0627\u0631",
      running: "\u0642\u064A\u062F \u0627\u0644\u0625\u0639\u062F\u0627\u062F",
      ready: "\u062C\u0627\u0647\u0632",
      failed: "\u0641\u0634\u0644",
      expired: "\u0645\u0646\u062A\u0647\u064A \u0627\u0644\u0635\u0644\u0627\u062D\u064A\u0629"
    },
    download: "\u062A\u0646\u0632\u064A\u0644",
    downloadFor: "\u062A\u0646\u0632\u064A\u0644 \u0627\u0644\u0646\u0633\u062E\u0629 \u0627\u0644\u0645\u0637\u0644\u0648\u0628\u0629 \u0628\u062A\u0627\u0631\u064A\u062E {date}",
    none: "\u063A\u064A\u0631 \u0645\u062A\u0627\u062D"
  },
  adminData: {
    title: "\u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A \u0648\u0627\u0644\u062D\u0630\u0641",
    loadFailedBody: "\u062A\u062D\u0642\u0642 \u0645\u0646 \u0627\u062A\u0635\u0627\u0644\u0643 \u062B\u0645 \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629.",
    export: {
      title: "\u062A\u0635\u062F\u064A\u0631 \u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A",
      descriptionFull: "\u062A\u062C\u0645\u0639 \u0627\u0644\u0646\u0633\u062E\u0629 \u0627\u0644\u0643\u0627\u0645\u0644\u0629 \u0643\u0644 \u0628\u064A\u0627\u0646\u0627\u062A \u0627\u0644\u0645\u0624\u0633\u0633\u0629 \u0641\u064A \u0645\u0644\u0641 \u0648\u0627\u062D\u062F.",
      descriptionFinance: "\u064A\u062A\u064A\u062D \u0644\u0643 \u062F\u0648\u0631\u0643 \u062A\u0635\u062F\u064A\u0631 \u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A \u0627\u0644\u0645\u0627\u0644\u064A\u0629 \u0644\u0644\u0645\u0624\u0633\u0633\u0629 \u0641\u0642\u0637. \u0627\u0644\u0646\u0633\u062E\u0629 \u0627\u0644\u0643\u0627\u0645\u0644\u0629 \u0645\u062E\u0635\u0635\u0629 \u0644\u0644\u0645\u0627\u0644\u0643 \u0648\u0627\u0644\u0645\u0633\u0624\u0648\u0644\u064A\u0646.",
      contents: {
        tables: "\u0643\u0644 \u062C\u062F\u0627\u0648\u0644 \u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A \u0628\u0635\u064A\u063A\u0629 JSON.",
        documents: "\u0627\u0644\u0648\u062B\u0627\u0626\u0642 \u0645\u0631\u062A\u0628\u0629 \u0641\u064A \u0645\u062C\u0644\u062F\u0627\u062A\u0647\u0627.",
        pdfs: "\u0645\u0644\u0641\u0627\u062A PDF \u0627\u0644\u062A\u064A \u064A\u0646\u0634\u0626\u0647\u0627 BatiFlow.",
        finance: "\u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A \u0627\u0644\u0645\u0627\u0644\u064A\u0629 \u0644\u0644\u0645\u0624\u0633\u0633\u0629 \u0641\u0642\u0637."
      },
      retention: "\u064A\u064F\u062D\u0641\u0638 \u0645\u0644\u0641 ZIP \u0644\u0645\u062F\u0629 7 \u0623\u064A\u0627\u0645 \u062B\u0645 \u064A\u064F\u062D\u0630\u0641.",
      notification: "\u064A\u062A\u0644\u0642\u0649 \u0645\u0646 \u0637\u0644\u0628 \u0627\u0644\u0646\u0633\u062E\u0629 \u0625\u0634\u0639\u0627\u0631\u064B\u0627 \u0628\u0645\u062C\u0631\u062F \u0623\u0646 \u062A\u0635\u0628\u062D \u062C\u0627\u0647\u0632\u0629.",
      buttonFull: "\u062A\u062D\u0636\u064A\u0631 \u0646\u0633\u062E\u0629 \u0643\u0627\u0645\u0644\u0629",
      buttonFinance: "\u062A\u062D\u0636\u064A\u0631 \u0646\u0633\u062E\u0629 \u0645\u0627\u0644\u064A\u0629",
      requested: "\u062C\u0627\u0631\u064D \u0625\u0639\u062F\u0627\u062F \u0646\u0633\u062E\u062A\u0643. \u0633\u062A\u062A\u0644\u0642\u0649 \u0625\u0634\u0639\u0627\u0631\u064B\u0627 \u0639\u0646\u062F\u0645\u0627 \u062A\u0635\u0628\u062D \u062C\u0627\u0647\u0632\u0629.",
      caption: "\u0646\u0633\u062E \u0628\u064A\u0627\u0646\u0627\u062A \u0627\u0644\u0645\u0624\u0633\u0633\u0629",
      loadFailedTitle: "\u062A\u0639\u0630\u0651\u0631 \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0646\u0633\u062E",
      empty: {
        title: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0646\u0633\u062E \u0628\u0639\u062F",
        description: "\u062D\u0636\u0651\u0631 \u0646\u0633\u062E\u0629 \u0644\u062A\u062D\u0635\u0644 \u0639\u0644\u0649 \u0646\u0633\u062E\u0629 \u0645\u0646 \u0628\u064A\u0627\u0646\u0627\u062A \u0627\u0644\u0645\u0624\u0633\u0633\u0629."
      }
    },
    delete: {
      title: "\u062D\u0630\u0641 \u0627\u0644\u0645\u0624\u0633\u0633\u0629",
      description: "\u0647\u0630\u0627 \u0627\u0644\u0625\u062C\u0631\u0627\u0621 \u0646\u0647\u0627\u0626\u064A. \u0627\u0642\u0631\u0623 \u0645\u0627 \u064A\u0644\u064A \u0642\u0628\u0644 \u0627\u0644\u0645\u062A\u0627\u0628\u0639\u0629.",
      points: {
        delay: "\u064A\u062A\u0645 \u0627\u0644\u062D\u0630\u0641 \u0628\u0639\u062F 90 \u064A\u0648\u0645\u064B\u0627 \u0645\u0646 \u0637\u0644\u0628\u0643. \u064A\u0645\u0643\u0646\u0643 \u0625\u0644\u063A\u0627\u0624\u0647 \u062D\u062A\u0649 \u0630\u0644\u0643 \u0627\u0644\u062A\u0627\u0631\u064A\u062E.",
        irreversible: "\u0644\u0627 \u064A\u0645\u0643\u0646 \u0627\u0644\u062A\u0631\u0627\u062C\u0639 \u0639\u0646\u0647: \u062A\u064F\u0645\u062D\u0649 \u0643\u0644 \u0628\u064A\u0627\u0646\u0627\u062A \u0627\u0644\u0645\u0624\u0633\u0633\u0629 \u0648\u0645\u0644\u0641\u0627\u062A\u0647\u0627\u060C \u0648\u062A\u064F\u063A\u0644\u0642 \u062D\u0633\u0627\u0628\u0627\u062A \u0627\u0644\u0623\u0634\u062E\u0627\u0635 \u0627\u0644\u0630\u064A\u0646 \u0644\u0627 \u064A\u0646\u062A\u0645\u0648\u0646 \u0625\u0644\u0649 \u0645\u0624\u0633\u0633\u0629 \u0623\u062E\u0631\u0649.",
        kept: "\u064A\u064F\u062D\u062A\u0641\u0638 \u0628\u0645\u0627 \u064A\u0644\u064A: \u0627\u0633\u0645 \u0627\u0644\u0645\u0624\u0633\u0633\u0629 \u0648\u0645\u0639\u0631\u0651\u0641\u0647\u0627 \u0627\u0644\u062C\u0628\u0627\u0626\u064A (\u0644\u0634\u0647\u0627\u062F\u0629 \u0627\u0644\u062D\u0630\u0641) \u0648\u0633\u062C\u0644 \u0627\u0644\u062A\u062F\u0642\u064A\u0642 \u0644\u0645\u062F\u0629 3 \u0633\u0646\u0648\u0627\u062A.",
        export: "\u0642\u0628\u0644 \u0627\u0644\u0628\u062F\u0621\u060C \u062D\u0636\u0651\u0631 \u0646\u0633\u062E\u0629 \u0643\u0627\u0645\u0644\u0629 \u0644\u0644\u0627\u062D\u062A\u0641\u0627\u0638 \u0628\u0646\u0633\u062E\u0629 \u0645\u0646 \u0628\u064A\u0627\u0646\u0627\u062A\u0643."
      },
      button: "\u062D\u0630\u0641 \u0627\u0644\u0645\u0624\u0633\u0633\u0629",
      loadFailedTitle: "\u062A\u0639\u0630\u0651\u0631 \u062A\u062D\u0645\u064A\u0644 \u062D\u0627\u0644\u0629 \u0627\u0644\u062D\u0630\u0641",
      running: {
        title: "\u0627\u0644\u062D\u0630\u0641 \u062C\u0627\u0631\u064D",
        body: "\u062A\u062C\u0631\u064A \u0627\u0644\u0622\u0646 \u0625\u0632\u0627\u0644\u0629 \u0628\u064A\u0627\u0646\u0627\u062A \u0627\u0644\u0645\u0624\u0633\u0633\u0629. \u0644\u0645 \u064A\u0639\u062F \u0628\u0627\u0644\u0625\u0645\u0643\u0627\u0646 \u0625\u064A\u0642\u0627\u0641 \u0627\u0644\u0639\u0645\u0644\u064A\u0629."
      },
      scheduled: {
        title: "\u0627\u0644\u062D\u0630\u0641 \u0645\u0628\u0631\u0645\u062C \u0628\u062A\u0627\u0631\u064A\u062E {date}",
        by: "\u0637\u0644\u0628\u0647 {name}.",
        reasons: {
          unpaid: "\u0628\u062F\u0623 \u0647\u0630\u0627 \u0627\u0644\u0625\u062C\u0631\u0627\u0621 \u0644\u0623\u0646 \u0627\u0644\u0627\u0634\u062A\u0631\u0627\u0643 \u063A\u064A\u0631 \u0645\u0633\u062F\u064E\u0651\u062F.",
          trial_expired: "\u0628\u062F\u0623 \u0647\u0630\u0627 \u0627\u0644\u0625\u062C\u0631\u0627\u0621 \u0644\u0623\u0646 \u0627\u0644\u0641\u062A\u0631\u0629 \u0627\u0644\u062A\u062C\u0631\u064A\u0628\u064A\u0629 \u0627\u0646\u062A\u0647\u062A \u062F\u0648\u0646 \u0627\u0634\u062A\u0631\u0627\u0643.",
          cancelled: "\u0628\u062F\u0623 \u0647\u0630\u0627 \u0627\u0644\u0625\u062C\u0631\u0627\u0621 \u0644\u0623\u0646 \u0627\u0644\u0627\u0634\u062A\u0631\u0627\u0643 \u0623\u064F\u0644\u063A\u064A.",
          owner_request: "\u064A\u0645\u0643\u0646\u0643 \u0625\u0644\u063A\u0627\u0624\u0647 \u0645\u0627 \u062F\u0627\u0645 \u0644\u0645 \u064A\u0628\u062F\u0623.",
          platform_admin: "\u062A\u0642\u0631\u0651\u0631 \u0630\u0644\u0643 \u0645\u0646 \u0642\u0628\u0644 \u062F\u0639\u0645 BatiFlow."
        },
        payToStop: "\u0633\u062F\u0627\u062F \u0627\u0644\u0627\u0634\u062A\u0631\u0627\u0643 \u064A\u0648\u0642\u0641 \u0627\u0644\u062D\u0630\u0641.",
        subscriptionLink: "\u0627\u0644\u0627\u0646\u062A\u0642\u0627\u0644 \u0625\u0644\u0649 \u0627\u0644\u0627\u0634\u062A\u0631\u0627\u0643",
        cancel: "\u0625\u0644\u063A\u0627\u0621 \u0627\u0644\u062D\u0630\u0641",
        cancelTitle: "\u0647\u0644 \u062A\u0631\u064A\u062F \u0625\u0644\u063A\u0627\u0621 \u062D\u0630\u0641 \u0627\u0644\u0645\u0624\u0633\u0633\u0629\u061F",
        cancelBody: "\u0644\u0646 \u064A\u062A\u0645 \u0627\u0644\u062D\u0630\u0641 \u0627\u0644\u0645\u0628\u0631\u0645\u062C \u0628\u062A\u0627\u0631\u064A\u062E {date}. \u062A\u0628\u0642\u0649 \u0627\u0644\u0645\u0624\u0633\u0633\u0629 \u0648\u0628\u064A\u0627\u0646\u0627\u062A\u0647\u0627 \u0643\u0645\u0627 \u0647\u064A \u0627\u0644\u064A\u0648\u0645.",
        cancelConfirm: "\u0646\u0639\u0645\u060C \u0623\u0644\u063A\u0650 \u0627\u0644\u062D\u0630\u0641",
        cancelKeep: "\u0644\u0627\u060C \u0623\u0628\u0642\u0650 \u0627\u0644\u062D\u0630\u0641 \u0645\u0628\u0631\u0645\u062C\u064B\u0627",
        cancelled: "\u062A\u0645 \u0625\u0644\u063A\u0627\u0621 \u0627\u0644\u062D\u0630\u0641."
      },
      dialog: {
        title: "\u062D\u0630\u0641 \u0627\u0644\u0645\u0624\u0633\u0633\u0629",
        intro: "\u0623\u0646\u062A \u062A\u0637\u0644\u0628 \u0627\u0644\u062D\u0630\u0641 \u0627\u0644\u0646\u0647\u0627\u0626\u064A \u0644\u0640 {name}. \u0633\u064A\u062A\u0645 \u0627\u0644\u062D\u0630\u0641 \u0628\u0639\u062F 90 \u064A\u0648\u0645\u064B\u0627.",
        exportRecent: "\u062A\u062A\u0648\u0641\u0631 \u0646\u0633\u062E\u0629 \u0643\u0627\u0645\u0644\u0629 \u0639\u0645\u0631\u0647\u0627 \u0623\u0642\u0644 \u0645\u0646 30 \u064A\u0648\u0645\u064B\u0627 (\u0623\u064F\u0639\u062F\u0651\u062A \u0628\u062A\u0627\u0631\u064A\u062E {date}). \u062A\u0630\u0643\u0651\u0631 \u062A\u0646\u0632\u064A\u0644\u0647\u0627 \u0642\u0628\u0644 \u0627\u0644\u062D\u0630\u0641.",
        exportNone: "\u0644\u0627 \u062A\u062A\u0648\u0641\u0631 \u0646\u0633\u062E\u0629 \u0643\u0627\u0645\u0644\u0629 \u0639\u0645\u0631\u0647\u0627 \u0623\u0642\u0644 \u0645\u0646 30 \u064A\u0648\u0645\u064B\u0627. \u062D\u0636\u0651\u0631 \u0646\u0633\u062E\u0629 \u0641\u064A \u0642\u0633\u0645 \xAB\u062A\u0635\u062F\u064A\u0631 \u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A\xBB \u0642\u0628\u0644 \u0627\u0644\u0645\u062A\u0627\u0628\u0639\u0629\u060C \u0623\u0648 \u0635\u0631\u0651\u062D \u0623\u062F\u0646\u0627\u0647 \u0628\u0623\u0646\u0643 \u0644\u0627 \u062A\u0631\u064A\u062F\u0647\u0627.",
        decline: "\u0644\u0627 \u0623\u0631\u063A\u0628 \u0641\u064A \u0646\u0633\u062E\u0629 \u0645\u0646 \u0628\u064A\u0627\u0646\u0627\u062A\u064A",
        confirmLabel: "\u0627\u0643\u062A\u0628 \u0627\u0644\u0627\u0633\u0645 \u0627\u0644\u0642\u0627\u0646\u0648\u0646\u064A \u0644\u0644\u0645\u0624\u0633\u0633\u0629 \u0644\u0644\u062A\u0623\u0643\u064A\u062F",
        confirmHint: "\u0627\u0646\u0633\u062E\u0647 \u0643\u0645\u0627 \u0647\u0648 \u062A\u0645\u0627\u0645\u064B\u0627: {name}",
        stepUpNote: "\u0644\u062D\u0645\u0627\u064A\u062A\u0643\u060C \u0633\u0646\u0637\u0644\u0628 \u0645\u0646\u0643 \u062A\u0623\u0643\u064A\u062F \u0647\u0648\u064A\u062A\u0643.",
        submit: "\u0628\u0631\u0645\u062C\u0629 \u0627\u0644\u062D\u0630\u0641",
        done: "\u062A\u0645\u062A \u0628\u0631\u0645\u062C\u0629 \u0627\u0644\u062D\u0630\u0641.",
        errors: {
          mismatch: "\u0647\u0630\u0627 \u0627\u0644\u0646\u0635 \u0644\u064A\u0633 \u0627\u0644\u0627\u0633\u0645 \u0627\u0644\u0642\u0627\u0646\u0648\u0646\u064A \u0644\u0644\u0645\u0624\u0633\u0633\u0629.",
          exportChoice: "\u0636\u0639 \u0639\u0644\u0627\u0645\u0629 \u0641\u064A \u0647\u0630\u0647 \u0627\u0644\u062E\u0627\u0646\u0629 \u0644\u0644\u0645\u062A\u0627\u0628\u0639\u0629 \u062F\u0648\u0646 \u0646\u0633\u062E\u0629\u060C \u0623\u0648 \u062D\u0636\u0651\u0631 \u0646\u0633\u062E\u0629 \u0643\u0627\u0645\u0644\u0629 \u0623\u0648\u0644\u064B\u0627."
        }
      }
    }
  },
  meData: {
    title: "\u0628\u064A\u0627\u0646\u0627\u062A\u064A \u0627\u0644\u0634\u062E\u0635\u064A\u0629",
    description: "\u064A\u0645\u0646\u062D\u0643 \u0627\u0644\u0642\u0627\u0646\u0648\u0646 \u0627\u0644\u0623\u0633\u0627\u0633\u064A \u0639\u062F\u062F 63 \u0644\u0633\u0646\u0629 2004 \u062D\u0642 \u0627\u0644\u0627\u0637\u0644\u0627\u0639 \u0639\u0644\u0649 \u0628\u064A\u0627\u0646\u0627\u062A\u0643 \u0627\u0644\u0634\u062E\u0635\u064A\u0629 \u0627\u0644\u062A\u064A \u064A\u062D\u062A\u0641\u0638 \u0628\u0647\u0627 BatiFlow.",
    button: "\u062A\u0635\u062F\u064A\u0631 \u0628\u064A\u0627\u0646\u0627\u062A\u064A",
    note: "\u062A\u062A\u0644\u0642\u0649 \u0625\u0634\u0639\u0627\u0631\u064B\u0627 \u0639\u0646\u062F\u0645\u0627 \u062A\u0635\u0628\u062D \u0627\u0644\u0646\u0633\u062E\u0629 \u062C\u0627\u0647\u0632\u0629. \u064A\u0628\u064A\u0651\u0646 \u0627\u0644\u062C\u062F\u0648\u0644 \u0622\u062E\u0631 \u0645\u0648\u0639\u062F \u0644\u062A\u0646\u0632\u064A\u0644\u0647\u0627.",
    requested: "\u062C\u0627\u0631\u064D \u0625\u0639\u062F\u0627\u062F \u0646\u0633\u062E\u062A\u0643. \u0633\u062A\u062A\u0644\u0642\u0649 \u0625\u0634\u0639\u0627\u0631\u064B\u0627 \u0639\u0646\u062F\u0645\u0627 \u062A\u0635\u0628\u062D \u062C\u0627\u0647\u0632\u0629.",
    caption: "\u0646\u0633\u062E \u0628\u064A\u0627\u0646\u0627\u062A\u064A",
    loadFailed: "\u062A\u0639\u0630\u0651\u0631 \u062A\u062D\u0645\u064A\u0644 \u0646\u0633\u062E \u0628\u064A\u0627\u0646\u0627\u062A\u0643. \u062A\u062D\u0642\u0642 \u0645\u0646 \u0627\u062A\u0635\u0627\u0644\u0643 \u062B\u0645 \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629.",
    empty: {
      title: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0646\u0633\u062E \u0628\u0639\u062F",
      description: "\u0627\u0637\u0644\u0628 \u0646\u0633\u062E\u0629 \u0644\u062A\u062D\u0635\u0644 \u0639\u0644\u0649 \u0646\u0633\u062E\u0629 \u0645\u0646 \u0628\u064A\u0627\u0646\u0627\u062A\u0643 \u0627\u0644\u0634\u062E\u0635\u064A\u0629."
    }
  },
  statusMessage: {
    title: "\u0631\u0633\u0627\u0644\u0629 \u0627\u0644\u062D\u0627\u0644\u0629",
    description: "\u064A\u0631\u0627\u0647\u0627 \u0632\u0645\u0644\u0627\u0624\u0643 \u0628\u062C\u0627\u0646\u0628 \u062D\u0627\u0644\u062A\u0643 ({max} \u062D\u0631\u0641\u064B\u0627 \u0643\u062D\u062F \u0623\u0642\u0635\u0649).",
    label: "\u0631\u0633\u0627\u0644\u062A\u0643",
    counter: "{length} / {max}",
    save: "\u062D\u0641\u0638",
    clear: "\u0645\u0633\u062D \u0627\u0644\u0631\u0633\u0627\u0644\u0629",
    cancel: "\u0625\u0644\u063A\u0627\u0621",
    saved: "\u062A\u0645 \u062D\u0641\u0638 \u0631\u0633\u0627\u0644\u0629 \u062D\u0627\u0644\u062A\u0643.",
    cleared: "\u062A\u0645 \u0645\u0633\u062D \u0631\u0633\u0627\u0644\u0629 \u062D\u0627\u0644\u062A\u0643."
  },
  customRoles: {
    title: "\u0627\u0644\u0623\u062F\u0648\u0627\u0631 \u0627\u0644\u0645\u062E\u0635\u0635\u0629",
    intro: "\u0623\u0646\u0634\u0626 \u0623\u062F\u0648\u0627\u0631\u064B\u0627 \u062E\u0627\u0635\u0629 \u0628\u0645\u0643\u062A\u0628\u0643 \u0627\u0646\u0637\u0644\u0627\u0642\u064B\u0627 \u0645\u0646 \u062F\u0648\u0631 \u0623\u0633\u0627\u0633\u064A\u060C \u062B\u0645 \u0639\u062F\u0651\u0644 \u0627\u0644\u0635\u0644\u0627\u062D\u064A\u0627\u062A \u0648\u0627\u062D\u062F\u0629 \u0648\u0627\u062D\u062F\u0629. \u0647\u0630\u0647 \u0627\u0644\u0645\u064A\u0632\u0629 \u0645\u062A\u0636\u0645\u0646\u0629 \u0641\u064A \u0627\u0634\u062A\u0631\u0627\u0643 Business.",
    loading: "\u062C\u0627\u0631\u064D \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0623\u062F\u0648\u0627\u0631\u2026",
    loadFailed: "\u062A\u0639\u0630\u0651\u0631 \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0623\u062F\u0648\u0627\u0631 \u0627\u0644\u0645\u062E\u0635\u0635\u0629.",
    upsell: "\u0627\u0644\u0623\u062F\u0648\u0627\u0631 \u0627\u0644\u0645\u062E\u0635\u0635\u0629 \u0645\u062A\u0636\u0645\u0646\u0629 \u0641\u064A \u0627\u0634\u062A\u0631\u0627\u0643 Business. \u0627\u0637\u0644\u0628 \u0645\u0646 \u0645\u0627\u0644\u0643 \u0627\u0644\u062D\u0633\u0627\u0628 \u0627\u0644\u0627\u0646\u062A\u0642\u0627\u0644 \u0625\u0644\u0649 \u0647\u0630\u0627 \u0627\u0644\u0627\u0634\u062A\u0631\u0627\u0643 \u0644\u0625\u0646\u0634\u0627\u0621 \u0623\u062F\u0648\u0627\u0631\u0643 \u0627\u0644\u062E\u0627\u0635\u0629.",
    empty: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0623\u062F\u0648\u0627\u0631 \u0645\u062E\u0635\u0635\u0629 \u062D\u0627\u0644\u064A\u064B\u0627. \u0627\u0633\u062A\u062E\u062F\u0645 \xAB\u062F\u0648\u0631 \u062C\u062F\u064A\u062F\xBB \u0644\u0625\u0646\u0634\u0627\u0621 \u062F\u0648\u0631.",
    caption: "\u0627\u0644\u0623\u062F\u0648\u0627\u0631 \u0627\u0644\u0645\u062E\u0635\u0635\u0629 \u0641\u064A \u0645\u0643\u062A\u0628\u0643",
    columns: {
      name: "\u0627\u0644\u0627\u0633\u0645",
      basedOn: "\u0645\u0628\u0646\u064A \u0639\u0644\u0649",
      keys: "\u0627\u0644\u0635\u0644\u0627\u062D\u064A\u0627\u062A",
      members: "\u0627\u0644\u0623\u0639\u0636\u0627\u0621",
      invitations: "\u0627\u0644\u062F\u0639\u0648\u0627\u062A \u0627\u0644\u0645\u0639\u0644\u0651\u0642\u0629",
      actions: "\u0627\u0644\u0625\u062C\u0631\u0627\u0621\u0627\u062A"
    },
    new: "\u062F\u0648\u0631 \u062C\u062F\u064A\u062F",
    actions: {
      edit: "\u062A\u0639\u062F\u064A\u0644 \u0627\u0644\u062F\u0648\u0631 {name}",
      editShort: "\u062A\u0639\u062F\u064A\u0644",
      delete: "\u062D\u0630\u0641 \u0627\u0644\u062F\u0648\u0631 {name}",
      deleteShort: "\u062D\u0630\u0641",
      inUse: "\u0627\u0644\u062F\u0648\u0631 \u0645\u0627 \u0632\u0627\u0644 \u0645\u0633\u062A\u062E\u062F\u0645\u064B\u0627 (\u0627\u0644\u0623\u0639\u0636\u0627\u0621: {members}\u060C \u0627\u0644\u062F\u0639\u0648\u0627\u062A: {invitations}). \u063A\u064A\u0651\u0631 \u062F\u0648\u0631\u0647\u0645 \u0623\u0648\u0644\u064B\u0627 \u0644\u062A\u062A\u0645\u0643\u0646 \u0645\u0646 \u062D\u0630\u0641\u0647."
    },
    create: {
      title: "\u062F\u0648\u0631 \u0645\u062E\u0635\u0635 \u062C\u062F\u064A\u062F",
      intro: "\u0627\u062E\u062A\u0631 \u0627\u0633\u0645\u064B\u0627 \u0648\u0627\u0644\u062F\u0648\u0631 \u0627\u0644\u0623\u0633\u0627\u0633\u064A. \u0633\u062A\u0636\u0628\u0637 \u0627\u0644\u0635\u0644\u0627\u062D\u064A\u0627\u062A \u0628\u0639\u062F \u0630\u0644\u0643 \u0641\u064A \u0627\u0644\u0645\u062D\u0631\u0631.",
      name: "\u0627\u0633\u0645 \u0627\u0644\u062F\u0648\u0631",
      basedOn: "\u0645\u0628\u0646\u064A \u0639\u0644\u0649",
      basePlaceholder: "\u0627\u062E\u062A\u0631 \u062F\u0648\u0631\u064B\u0627 \u0623\u0633\u0627\u0633\u064A\u064B\u0627",
      nameRequired: "\u0623\u062F\u062E\u0644 \u0627\u0633\u0645\u064B\u0627 \u0644\u0647\u0630\u0627 \u0627\u0644\u062F\u0648\u0631.",
      baseRequired: "\u0627\u062E\u062A\u0631 \u0627\u0644\u062F\u0648\u0631 \u0627\u0644\u0623\u0633\u0627\u0633\u064A.",
      submit: "\u0625\u0646\u0634\u0627\u0621 \u0648\u0636\u0628\u0637 \u0627\u0644\u0635\u0644\u0627\u062D\u064A\u0627\u062A",
      saving: "\u062C\u0627\u0631\u064D \u0627\u0644\u0625\u0646\u0634\u0627\u0621\u2026"
    },
    editor: {
      title: "\u0627\u0644\u062F\u0648\u0631 {name}",
      intro: "\u062F\u0648\u0631 \u0645\u0628\u0646\u064A \u0639\u0644\u0649 \xAB{base}\xBB. \u0641\u0639\u0651\u0644 \u0643\u0644 \u0635\u0644\u0627\u062D\u064A\u0629 \u0623\u0648 \u0639\u0637\u0651\u0644\u0647\u0627.",
      reset: "\u0625\u0639\u0627\u062F\u0629 \u0627\u0644\u0636\u0628\u0637 \u0625\u0644\u0649 \u0627\u0644\u062F\u0648\u0631 \u0627\u0644\u0623\u0633\u0627\u0633\u064A",
      count: "\u0627\u0644\u0635\u0644\u0627\u062D\u064A\u0627\u062A \u0627\u0644\u0645\u0641\u0639\u0651\u0644\u0629: {total}",
      locked: "\u064A\u062A\u0628\u0639 \u0627\u0644\u062F\u0648\u0631 \u0627\u0644\u0623\u0633\u0627\u0633\u064A: \u0644\u0627 \u064A\u0645\u0643\u0646 \u062A\u063A\u064A\u064A\u0631 \u0647\u0630\u0647 \u0627\u0644\u0635\u0644\u0627\u062D\u064A\u0629.",
      notHeld: "\u0644\u0627 \u062A\u0645\u0644\u0643 \u0647\u0630\u0647 \u0627\u0644\u0635\u0644\u0627\u062D\u064A\u0629",
      save: "\u062D\u0641\u0638",
      saving: "\u062C\u0627\u0631\u064D \u0627\u0644\u062D\u0641\u0638\u2026",
      saved: "\u062A\u0645 \u062D\u0641\u0638 \u0627\u0644\u062F\u0648\u0631 \xAB{name}\xBB.",
      stale: "\u0639\u062F\u0651\u0644 \u0634\u062E\u0635 \u0622\u062E\u0631 \u0627\u0644\u062F\u0648\u0631 \xAB{name}\xBB. \u0623\u064F\u0639\u064A\u062F \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0642\u0627\u0626\u0645\u0629: \u0627\u0641\u062A\u062D \u0627\u0644\u062F\u0648\u0631 \u0645\u062C\u062F\u062F\u064B\u0627 \u0648\u0623\u0639\u062F \u062A\u0637\u0628\u064A\u0642 \u062A\u063A\u064A\u064A\u0631\u0627\u062A\u0643."
    },
    delete: {
      title: "\u062D\u0630\u0641 \u0627\u0644\u062F\u0648\u0631 \xAB{name}\xBB\u061F",
      body: "\u0633\u064A\u064F\u062D\u0630\u0641 \u0647\u0630\u0627 \u0627\u0644\u062F\u0648\u0631 \u0646\u0647\u0627\u0626\u064A\u064B\u0627. \u0644\u0627 \u064A\u0633\u062A\u062E\u062F\u0645\u0647 \u0623\u064A \u0639\u0636\u0648 \u0648\u0644\u0627 \u0623\u064A \u062F\u0639\u0648\u0629.",
      confirm: "\u062D\u0630\u0641",
      done: "\u062A\u0645 \u062D\u0630\u0641 \u0627\u0644\u062F\u0648\u0631 \xAB{name}\xBB.",
      inUse: "\u0645\u0627 \u0632\u0627\u0644 \u0647\u0630\u0627 \u0627\u0644\u062F\u0648\u0631 \u0645\u064F\u0633\u0646\u062F\u064B\u0627 \u0625\u0644\u0649 \u0623\u0639\u0636\u0627\u0621 \u0623\u0648 \u062F\u0639\u0648\u0627\u062A \u0645\u0639\u0644\u0651\u0642\u0629. \u063A\u064A\u0651\u0631 \u062F\u0648\u0631\u0647\u0645 \u0623\u0648\u0644\u064B\u0627.",
      stale: "\u062A\u0645 \u062A\u0639\u062F\u064A\u0644 \u0647\u0630\u0627 \u0627\u0644\u062F\u0648\u0631 \u0641\u064A \u0627\u0644\u0623\u062B\u0646\u0627\u0621. \u0623\u064F\u0639\u064A\u062F \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0642\u0627\u0626\u0645\u0629: \u062D\u0627\u0648\u0644 \u0645\u062C\u062F\u062F\u064B\u0627."
    },
    escalation: "\u0644\u0627 \u064A\u0645\u0643\u0646\u0643 \u0645\u0646\u062D \u0635\u0644\u0627\u062D\u064A\u0627\u062A \u0644\u0627 \u062A\u0645\u0644\u0643\u0647\u0627 \u0628\u0646\u0641\u0633\u0643: {keys}.",
    stepUpNote: "\u0645\u0646 \u0623\u062C\u0644 \u0623\u0645\u0627\u0646\u0643\u060C \u0633\u064A\u064F\u0637\u0644\u0628 \u0645\u0646\u0643 \u062A\u0623\u0643\u064A\u062F \u0647\u0648\u064A\u062A\u0643.",
    picker: {
      group: "\u0627\u0644\u0623\u062F\u0648\u0627\u0631 \u0627\u0644\u0645\u062E\u0635\u0635\u0629",
      hint: "\u062F\u0648\u0631 \u0645\u062E\u0635\u0635 \u0645\u0628\u0646\u064A \u0639\u0644\u0649 \xAB{base}\xBB."
    }
  },
  directory: {
    title: "\u062F\u0644\u064A\u0644 \u0627\u0644\u0645\u0643\u0627\u062A\u0628",
    intro: "\u0645\u0643\u0627\u062A\u0628 \u0627\u0644\u062F\u0631\u0627\u0633\u0627\u062A \u0639\u0644\u0649 \u0628\u062A\u064A \u0641\u0644\u0648 \u0627\u0644\u062A\u064A \u0627\u062E\u062A\u0627\u0631\u062A \u0627\u0644\u0638\u0647\u0648\u0631 \u0647\u0646\u0627. \u0631\u0627\u0633\u0644\u0648\u0647\u0627 \u0623\u0648 \u0627\u0628\u062D\u062B\u0648\u0627 \u0639\u0646\u0647\u0627 \u0644\u0625\u0642\u0627\u0645\u0629 \u0634\u0631\u0627\u0643\u0629.",
    searchLabel: "\u0627\u0644\u0628\u062D\u062B \u0639\u0646 \u0645\u0643\u062A\u0628",
    searchPlaceholder: "\u0627\u0633\u0645 \u0627\u0644\u0645\u0643\u062A\u0628",
    disciplineLabel: "\u0627\u0644\u0627\u062E\u062A\u0635\u0627\u0635",
    governorateLabel: "\u0627\u0644\u0648\u0644\u0627\u064A\u0629",
    allDisciplines: "\u0643\u0644 \u0627\u0644\u0627\u062E\u062A\u0635\u0627\u0635\u0627\u062A",
    allGovernorates: "\u0643\u0644 \u0627\u0644\u0648\u0644\u0627\u064A\u0627\u062A",
    clear: "\u0645\u0633\u062D \u0639\u0648\u0627\u0645\u0644 \u0627\u0644\u062A\u0635\u0641\u064A\u0629",
    resultsLabel: "\u0645\u0643\u0627\u062A\u0628 \u0627\u0644\u062F\u0644\u064A\u0644",
    empty: {
      title: "\u0644\u0627 \u064A\u0648\u062C\u062F \u0645\u0643\u062A\u0628 \u0641\u064A \u0627\u0644\u062F\u0644\u064A\u0644 \u062D\u0627\u0644\u064A\u064B\u0627",
      description: "\u062A\u0638\u0647\u0631 \u0627\u0644\u0645\u0643\u0627\u062A\u0628 \u0647\u0646\u0627 \u0639\u0646\u062F\u0645\u0627 \u062A\u062E\u062A\u0627\u0631 \u0623\u0646 \u062A\u0643\u0648\u0646 \u0638\u0627\u0647\u0631\u0629."
    },
    emptyFiltered: {
      title: "\u0644\u0627 \u064A\u0648\u062C\u062F \u0645\u0643\u062A\u0628 \u0645\u0637\u0627\u0628\u0642",
      description: "\u062C\u0631\u0651\u0628 \u0627\u0633\u0645\u064B\u0627 \u0622\u062E\u0631 \u0623\u0648 \u0623\u0632\u0644 \u0639\u0627\u0645\u0644 \u062A\u0635\u0641\u064A\u0629."
    },
    loadFailedTitle: "\u062A\u0639\u0630\u0651\u0631 \u0639\u0631\u0636 \u0627\u0644\u062F\u0644\u064A\u0644",
    loadFailedBody: "\u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629\u060C \u0648\u0625\u0630\u0627 \u0627\u0633\u062A\u0645\u0631\u062A \u0627\u0644\u0645\u0634\u0643\u0644\u0629 \u0641\u0627\u062A\u0635\u0644 \u0628\u0627\u0644\u062F\u0639\u0645.",
    moreFailed: "\u062A\u0639\u0630\u0651\u0631 \u062A\u062D\u0645\u064A\u0644 \u0628\u0642\u064A\u0629 \u0627\u0644\u0642\u0627\u0626\u0645\u0629. \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629.",
    more: "\u0639\u0631\u0636 \u0627\u0644\u0645\u0632\u064A\u062F",
    loadingMore: "\u062C\u0627\u0631\u064D \u0627\u0644\u062A\u062D\u0645\u064A\u0644\u2026",
    location: "{governorate}\u060C {city}",
    contact: {
      button: "\u0645\u0631\u0627\u0633\u0644\u0629",
      buttonLabel: "\u0645\u0631\u0627\u0633\u0644\u0629 {name}",
      title: "\u0645\u0631\u0627\u0633\u0644\u0629 {name}",
      intro: "\u062A\u064F\u0631\u0633\u0644 \u0631\u0633\u0627\u0644\u062A\u0643\u0645 \u0628\u0627\u0644\u0628\u0631\u064A\u062F \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A \u0625\u0644\u0649 \u0645\u0627\u0644\u0643\u064A \u0647\u0630\u0627 \u0627\u0644\u0645\u0643\u062A\u0628 \u0648\u0645\u0633\u0624\u0648\u0644\u064A\u0647.",
      replyNote: "\u0633\u064A\u0635\u0644 \u0631\u062F\u0647\u0645 \u0625\u0644\u0649 \u0628\u0631\u064A\u062F\u0643\u0645 \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A\u060C \u0648\u0633\u064A\u0631\u0627\u0647 \u0647\u0630\u0627 \u0627\u0644\u0645\u0643\u062A\u0628.",
      subject: "\u0627\u0644\u0645\u0648\u0636\u0648\u0639",
      message: "\u0627\u0644\u0631\u0633\u0627\u0644\u0629",
      counter: "{count} / {max} \u062D\u0631\u0641",
      send: "\u0625\u0631\u0633\u0627\u0644 \u0627\u0644\u0631\u0633\u0627\u0644\u0629",
      sending: "\u062C\u0627\u0631\u064D \u0627\u0644\u0625\u0631\u0633\u0627\u0644\u2026",
      sent: "\u062A\u0645 \u0625\u0631\u0633\u0627\u0644 \u0631\u0633\u0627\u0644\u062A\u0643\u0645 \u0625\u0644\u0649 {name}.",
      errors: {
        subjectRequired: "\u0627\u0643\u062A\u0628\u0648\u0627 \u0645\u0648\u0636\u0648\u0639 \u0627\u0644\u0631\u0633\u0627\u0644\u0629.",
        messageRequired: "\u0627\u0643\u062A\u0628\u0648\u0627 \u0631\u0633\u0627\u0644\u062A\u0643\u0645.",
        emailNotVerified: "\u0623\u0643\u0651\u062F\u0648\u0627 \u0628\u0631\u064A\u062F\u0643\u0645 \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A \u0623\u0648\u0644\u064B\u0627 \u0644\u0645\u0631\u0627\u0633\u0644\u0629 \u0645\u0643\u062A\u0628.",
        notFound: "\u0644\u0645 \u064A\u0639\u062F \u0647\u0630\u0627 \u0627\u0644\u0645\u0643\u062A\u0628 \u0641\u064A \u0627\u0644\u062F\u0644\u064A\u0644. \u062D\u062F\u0651\u062B\u0648\u0627 \u0627\u0644\u0642\u0627\u0626\u0645\u0629.",
        rateLimited: "\u0623\u0631\u0633\u0644\u062A\u0645 \u0631\u0633\u0627\u0626\u0644 \u0643\u062B\u064A\u0631\u0629. \u0623\u0639\u064A\u062F\u0648\u0627 \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629 \u0628\u0639\u062F \u0633\u0627\u0639\u0629."
      }
    },
    count: "{count, plural, zero {\u0644\u0627 \u064A\u0648\u062C\u062F \u0645\u0643\u062A\u0628} one {\u0645\u0643\u062A\u0628 \u0648\u0627\u062D\u062F} two {\u0645\u0643\u062A\u0628\u0627\u0646} few {# \u0645\u0643\u0627\u062A\u0628} many {# \u0645\u0643\u062A\u0628\u064B\u0627} other {# \u0645\u0643\u062A\u0628}}",
    countMore: "{count, plural, zero {\u0623\u0643\u062B\u0631 \u0645\u0646 \u0635\u0641\u0631 \u0645\u0643\u062A\u0628} one {\u0623\u0643\u062B\u0631 \u0645\u0646 \u0645\u0643\u062A\u0628 \u0648\u0627\u062D\u062F} two {\u0623\u0643\u062B\u0631 \u0645\u0646 \u0645\u0643\u062A\u0628\u064A\u0646} few {\u0623\u0643\u062B\u0631 \u0645\u0646 # \u0645\u0643\u0627\u062A\u0628} many {\u0623\u0643\u062B\u0631 \u0645\u0646 # \u0645\u0643\u062A\u0628\u064B\u0627} other {\u0623\u0643\u062B\u0631 \u0645\u0646 # \u0645\u0643\u062A\u0628}}"
  },
  timesheets: {
    upgrade: {
      title: "\u062A\u062A\u0628\u0639 \u0627\u0644\u0648\u0642\u062A \u063A\u064A\u0631 \u0645\u0634\u0645\u0648\u0644 \u0641\u064A \u0627\u0634\u062A\u0631\u0627\u0643\u0643",
      body: "\u0627\u0646\u062A\u0642\u0644 \u0625\u0644\u0649 \u0627\u0634\u062A\u0631\u0627\u0643 \u0623\u0639\u0644\u0649 \u0644\u0625\u062F\u062E\u0627\u0644 \u0633\u0627\u0639\u0627\u062A \u0627\u0644\u0641\u0631\u064A\u0642 \u0648\u0627\u0644\u0645\u0648\u0627\u0641\u0642\u0629 \u0639\u0644\u0649 \u0627\u0644\u0623\u0633\u0627\u0628\u064A\u0639 \u0648\u0645\u062A\u0627\u0628\u0639\u0629 \u062D\u0645\u0644 \u0627\u0644\u0639\u0645\u0644."
    },
    title: "\u0627\u0644\u0648\u0642\u062A",
    tabsLabel: "\u0623\u0642\u0633\u0627\u0645 \u062A\u062A\u0628\u0639 \u0627\u0644\u0648\u0642\u062A",
    tabs: {
      week: "\u0623\u0633\u0628\u0648\u0639\u064A",
      approvals: "\u0628\u0627\u0646\u062A\u0638\u0627\u0631 \u0627\u0644\u0645\u0648\u0627\u0641\u0642\u0629",
      capacity: "\u062D\u0645\u0644 \u0627\u0644\u0641\u0631\u064A\u0642",
      leave: "\u0627\u0644\u063A\u064A\u0627\u0628\u0627\u062A"
    },
    duration: {
      h: "{h} \u0633",
      hm: "{h} \u0633 {m}"
    },
    categories: {
      studies: "\u062F\u0631\u0627\u0633\u0627\u062A",
      site: "\u0648\u0631\u0634\u0629",
      meeting: "\u0627\u062C\u062A\u0645\u0627\u0639",
      travel: "\u062A\u0646\u0642\u0644",
      admin: "\u0625\u062F\u0627\u0631\u064A",
      other: "\u0623\u062E\u0631\u0649"
    },
    line: {
      noPhase: "\u0628\u062F\u0648\u0646 \u0645\u0631\u062D\u0644\u0629",
      phase: "\u0645\u0631\u062D\u0644\u0629",
      name: "{project}\u060C {phase}\u060C {category}"
    },
    week: {
      navLabel: "\u0627\u062E\u062A\u064A\u0627\u0631 \u0627\u0644\u0623\u0633\u0628\u0648\u0639",
      prev: "\u0627\u0644\u0623\u0633\u0628\u0648\u0639 \u0627\u0644\u0633\u0627\u0628\u0642",
      next: "\u0627\u0644\u0623\u0633\u0628\u0648\u0639 \u0627\u0644\u062A\u0627\u0644\u064A",
      today: "\u0647\u0630\u0627 \u0627\u0644\u0623\u0633\u0628\u0648\u0639",
      label: "\u0623\u0633\u0628\u0648\u0639 {range}",
      total: "\u0645\u062C\u0645\u0648\u0639 \u0627\u0644\u0623\u0633\u0628\u0648\u0639:",
      totalOnly: "\u0645\u062C\u0645\u0648\u0639 \u0627\u0644\u0623\u0633\u0628\u0648\u0639:",
      outOf: "\u0645\u0646",
      overCapacity: "\u0623\u0639\u0644\u0649 \u0645\u0646 \u0637\u0627\u0642\u0629 \u0627\u0644\u0623\u0633\u0628\u0648\u0639",
      statusOpen: "\u0627\u0644\u0623\u0633\u0628\u0648\u0639 \u0642\u064A\u062F \u0627\u0644\u0625\u062F\u062E\u0627\u0644",
      statusSubmitted: "\u062A\u0645 \u062A\u0633\u0644\u064A\u0645 \u0627\u0644\u0623\u0633\u0628\u0648\u0639 \u0641\u064A {date}",
      lockedNotice: "\u062A\u0645 \u062A\u0633\u0644\u064A\u0645 \u0647\u0630\u0627 \u0627\u0644\u0623\u0633\u0628\u0648\u0639: \u0644\u0627 \u064A\u0645\u0643\u0646 \u062A\u0639\u062F\u064A\u0644\u0647 \u0625\u0644\u0649 \u0623\u0646 \u064A\u0628\u062A\u0651 \u0641\u064A\u0647 \u0645\u0633\u0624\u0648\u0644\u0648\u0643.",
      capacityUnknown: "\u0637\u0627\u0642\u0629 \u0647\u0630\u0627 \u0627\u0644\u0623\u0633\u0628\u0648\u0639 \u063A\u064A\u0631 \u0645\u0639\u0631\u0648\u0641\u0629: \u0631\u0648\u0632\u0646\u0627\u0645\u0629 \u0627\u0644\u0639\u0637\u0644 \u0627\u0644\u0631\u0633\u0645\u064A\u0629 \u0644\u0644\u0633\u0646\u0629 \u063A\u064A\u0631 \u0645\u062A\u0648\u0641\u0631\u0629."
    },
    empty: {
      title: "\u0644\u0627 \u064A\u0648\u062C\u062F \u0623\u064A \u0633\u0637\u0631 \u0644\u0647\u0630\u0627 \u0627\u0644\u0623\u0633\u0628\u0648\u0639",
      description: "\u0623\u0636\u0641 \u0633\u0637\u0631\u064B\u0627 (\u0645\u0634\u0631\u0648\u0639\u060C \u0645\u0631\u062D\u0644\u0629\u060C \u0641\u0626\u0629) \u062B\u0645 \u0623\u062F\u062E\u0644 \u0633\u0627\u0639\u0627\u062A\u0643 \u064A\u0648\u0645\u064B\u0627 \u0628\u064A\u0648\u0645."
    },
    grid: {
      label: "\u0625\u062F\u062E\u0627\u0644 \u0648\u0642\u062A \u0627\u0644\u0623\u0633\u0628\u0648\u0639",
      line: "\u0627\u0644\u0645\u0634\u0631\u0648\u0639 \u0648\u0627\u0644\u0645\u0631\u062D\u0644\u0629 \u0648\u0627\u0644\u0641\u0626\u0629",
      total: "\u0627\u0644\u0645\u062C\u0645\u0648\u0639",
      dayTotal: "\u0645\u062C\u0645\u0648\u0639 \u0627\u0644\u064A\u0648\u0645",
      help: "\u0627\u0633\u062A\u0639\u0645\u0644 \u0627\u0644\u0623\u0633\u0647\u0645 \u0644\u0644\u062A\u0646\u0642\u0644 \u0628\u064A\u0646 \u0627\u0644\u062E\u0627\u0646\u0627\u062A\u060C \u0648Enter \u0644\u0625\u062F\u062E\u0627\u0644 \u0645\u062F\u0629 (\u0645\u062B\u0644 7:30 \u0623\u0648 7.5)\u060C \u0648Enter \u0644\u0644\u062A\u0623\u0643\u064A\u062F\u060C \u0648Escape \u0644\u0644\u0625\u0644\u063A\u0627\u0621\u060C \u0648Delete \u0644\u0644\u0645\u0633\u062D. \u062A\u064F\u062F\u062E\u0644 \u0627\u0644\u0645\u062F\u062F \u0628\u0623\u0631\u0628\u0627\u0639 \u0627\u0644\u0633\u0627\u0639\u0629.",
      helpLocked: "\u062A\u0645 \u062A\u0633\u0644\u064A\u0645 \u0627\u0644\u0623\u0633\u0628\u0648\u0639: \u0627\u0644\u062E\u0627\u0646\u0627\u062A \u0644\u0644\u0642\u0631\u0627\u0621\u0629 \u0641\u0642\u0637.",
      cellLabel: "{where}: {value}",
      cellValue: "{duration}",
      cellEmpty: "\u0644\u0627 \u064A\u0648\u062C\u062F \u0625\u062F\u062E\u0627\u0644",
      editing: "\u0642\u064A\u062F \u0627\u0644\u0625\u062F\u062E\u0627\u0644",
      multiple: "\u0639\u062F\u0629 \u0625\u062F\u062E\u0627\u0644\u0627\u062A\u060C \u0644\u0627 \u064A\u0645\u0643\u0646 \u062A\u0639\u062F\u064A\u0644\u0647\u0627 \u0647\u0646\u0627",
      statuses: {
        draft: "\u0645\u0633\u0648\u062F\u0629",
        submitted: "\u0645\u0633\u0644\u064E\u0651\u0645\u0629",
        approved: "\u0645\u0648\u0627\u0641\u064E\u0642 \u0639\u0644\u064A\u0647\u0627",
        rejected: "\u0645\u0631\u0641\u0648\u0636\u0629"
      },
      reason: "\u0627\u0644\u0633\u0628\u0628: {reason}",
      holiday: "\u0639\u0637\u0644\u0629: {name}",
      estimated: "\u062A\u0642\u062F\u064A\u0631\u064A\u0629",
      leave: "\u063A\u064A\u0627\u0628",
      removeLine: "\u0625\u0632\u0627\u0644\u0629 \u0627\u0644\u0633\u0637\u0631 {line}",
      invalid: {
        format: "\u0623\u062F\u062E\u0644 \u0645\u062F\u0629 \u0645\u062B\u0644 7:30 \u0623\u0648 7.5 \u0623\u0648 2h30.",
        step: "\u064A\u064F\u062F\u062E\u0644 \u0627\u0644\u0648\u0642\u062A \u0628\u0623\u0631\u0628\u0627\u0639 \u0627\u0644\u0633\u0627\u0639\u0629 (15 \u062F\u0642\u064A\u0642\u0629).",
        max: "\u0644\u0627 \u064A\u0645\u0643\u0646 \u0623\u0646 \u064A\u062A\u062C\u0627\u0648\u0632 \u0627\u0644\u064A\u0648\u0645 24 \u0633\u0627\u0639\u0629."
      },
      title: "\u0648\u0631\u0642\u0629 \u0627\u0644\u0648\u0642\u062A",
      legend: "\u0645\u0641\u062A\u0627\u062D \u0648\u0631\u0642\u0629 \u0627\u0644\u0648\u0642\u062A",
      legendStatuses: {
        draft: "\u0645\u0633\u0648\u062F\u0629",
        submitted: "\u0645\u064F\u0631\u0633\u064E\u0644\u0629",
        approved: "\u0645\u0648\u0627\u0641\u064E\u0642 \u0639\u0644\u064A\u0647\u0627",
        rejected: "\u0645\u0631\u0641\u0648\u0636\u0629"
      },
      legendOff: "\u0639\u0637\u0644\u0629 \u0646\u0647\u0627\u064A\u0629 \u0627\u0644\u0623\u0633\u0628\u0648\u0639 \u0623\u0648 \u0639\u0637\u0644\u0629 \u0631\u0633\u0645\u064A\u0629 \u0623\u0648 \u063A\u064A\u0627\u0628",
      today: "\u0627\u0644\u064A\u0648\u0645"
    },
    addLine: {
      open: "\u0625\u0636\u0627\u0641\u0629 \u0633\u0637\u0631",
      title: "\u0633\u0637\u0631 \u0648\u0642\u062A \u062C\u062F\u064A\u062F",
      add: "\u0625\u0636\u0627\u0641\u0629 \u0627\u0644\u0633\u0637\u0631",
      noProjects: "\u0623\u0646\u062A \u0644\u0627 \u062A\u0639\u0645\u0644 \u0639\u0644\u0649 \u0623\u064A \u0645\u0634\u0631\u0648\u0639. \u0627\u0637\u0644\u0628 \u0645\u0646 \u0645\u0633\u0624\u0648\u0644 \u0645\u0634\u0631\u0648\u0639 \u0623\u0646 \u064A\u0636\u064A\u0641\u0643 \u0625\u0644\u0649 \u0627\u0644\u0641\u0631\u064A\u0642."
    },
    picker: {
      project: "\u0627\u0644\u0645\u0634\u0631\u0648\u0639",
      projectPlaceholder: "\u0627\u062E\u062A\u0631 \u0645\u0634\u0631\u0648\u0639\u064B\u0627",
      phase: "\u0627\u0644\u0645\u0631\u062D\u0644\u0629 (\u0627\u062E\u062A\u064A\u0627\u0631\u064A)",
      category: "\u0627\u0644\u0641\u0626\u0629"
    },
    submit: {
      button: "\u062A\u0633\u0644\u064A\u0645 \u0627\u0644\u0623\u0633\u0628\u0648\u0639",
      title: "\u062A\u0633\u0644\u064A\u0645 \u0627\u0644\u0623\u0633\u0628\u0648\u0639\u061F",
      body: "\u0633\u062A\u0633\u0644\u0651\u0645 {total} \u0639\u0646 \u0623\u0633\u0628\u0648\u0639 {range}. \u0628\u0639\u062F \u0627\u0644\u062A\u0633\u0644\u064A\u0645 \u0644\u0627 \u064A\u0645\u0643\u0646 \u062A\u0639\u062F\u064A\u0644 \u0627\u0644\u0623\u0633\u0628\u0648\u0639 \u0625\u0644\u0649 \u0623\u0646 \u064A\u0628\u062A\u0651 \u0641\u064A\u0647 \u0645\u0633\u0624\u0648\u0644\u0648\u0643.",
      confirm: "\u062A\u0633\u0644\u064A\u0645",
      done: "\u062A\u0645 \u062A\u0633\u0644\u064A\u0645 \u0627\u0644\u0623\u0633\u0628\u0648\u0639."
    },
    rejected: {
      title: "\u0625\u062F\u062E\u0627\u0644\u0627\u062A \u0645\u0631\u0641\u0648\u0636\u0629",
      item: "{project}\u060C {day} ({duration}): {reason}.",
      noReason: "\u0644\u0645 \u064A\u064F\u0630\u0643\u0631 \u0633\u0628\u0628",
      by: "\u0631\u0641\u0636\u0647\u0627 {name}.",
      hint: "\u0635\u062D\u0651\u062D \u0647\u0630\u0647 \u0627\u0644\u0625\u062F\u062E\u0627\u0644\u0627\u062A \u062B\u0645 \u0633\u0644\u0651\u0645 \u0627\u0644\u0623\u0633\u0628\u0648\u0639 \u0645\u0646 \u062C\u062F\u064A\u062F."
    },
    loadFailed: {
      title: "\u062A\u0639\u0630\u0651\u0631 \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0623\u0633\u0628\u0648\u0639",
      body: "\u062A\u062D\u0642\u0642 \u0645\u0646 \u0627\u062A\u0635\u0627\u0644\u0643 \u062B\u0645 \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629."
    },
    timer: {
      title: "\u0627\u0644\u0645\u0624\u0642\u0651\u062A",
      description: "\u0634\u063A\u0651\u0644 \u0627\u0644\u0645\u0624\u0642\u0651\u062A \u0639\u0644\u0649 \u0645\u0634\u0631\u0648\u0639. \u0639\u0646\u062F \u0625\u064A\u0642\u0627\u0641\u0647 \u064A\u064F\u0642\u0631\u064E\u0651\u0628 \u0627\u0644\u0648\u0642\u062A \u0625\u0644\u0649 \u0631\u0628\u0639 \u0627\u0644\u0633\u0627\u0639\u0629 \u0627\u0644\u0623\u0639\u0644\u0649 \u0648\u064A\u064F\u0636\u0627\u0641 \u0625\u0644\u0649 \u0627\u0644\u064A\u0648\u0645.",
      start: "\u0628\u062F\u0621",
      stop: "\u0625\u064A\u0642\u0627\u0641 \u0648\u0625\u0636\u0627\u0641\u0629",
      discard: "\u062A\u062E\u0644\u064D\u0651",
      elapsed: "\u0627\u0644\u0648\u0642\u062A \u0627\u0644\u0645\u0646\u0642\u0636\u064A: {time}",
      roundedTo: "\u0633\u064A\u064F\u0636\u0627\u0641:",
      added: "\u062A\u0645\u062A \u0625\u0636\u0627\u0641\u0629 {duration} \u0625\u0644\u0649 \u0627\u0644\u064A\u0648\u0645.",
      unknownProject: "\u0645\u0634\u0631\u0648\u0639",
      running: "\u0642\u064A\u062F \u0627\u0644\u062A\u0634\u063A\u064A\u0644"
    },
    approvals: {
      description: "\u0625\u062F\u062E\u0627\u0644\u0627\u062A \u0627\u0644\u0648\u0642\u062A \u0627\u0644\u0645\u0633\u0644\u064E\u0651\u0645\u0629 \u0639\u0644\u0649 \u0627\u0644\u0645\u0634\u0627\u0631\u064A\u0639 \u0627\u0644\u062A\u064A \u062A\u062F\u064A\u0631\u0647\u0627. \u062D\u062F\u0651\u062F\u0647\u0627 \u0644\u0644\u0645\u0648\u0627\u0641\u0642\u0629 \u0639\u0644\u064A\u0647\u0627 \u0623\u0648 \u0631\u0641\u0636\u0647\u0627.",
      weekFilter: "\u0627\u0644\u0623\u0633\u0628\u0648\u0639",
      allWeeks: "\u0643\u0644 \u0627\u0644\u0623\u0633\u0627\u0628\u064A\u0639",
      approve: "\u0627\u0644\u0645\u0648\u0627\u0641\u0642\u0629 \u0639\u0644\u0649 \u0627\u0644\u0645\u062D\u062F\u064E\u0651\u062F ({count})",
      reject: "\u0631\u0641\u0636 \u0627\u0644\u0645\u062D\u062F\u064E\u0651\u062F ({count})",
      group: "{name}\u060C \u0623\u0633\u0628\u0648\u0639 {range}",
      selectGroup: "\u062A\u062D\u062F\u064A\u062F \u0643\u0644 \u0625\u062F\u062E\u0627\u0644\u0627\u062A {group}",
      selectEntry: "\u062A\u062D\u062F\u064A\u062F \u0625\u062F\u062E\u0627\u0644 {project} \u0628\u062A\u0627\u0631\u064A\u062E {day}",
      project: "\u0627\u0644\u0645\u0634\u0631\u0648\u0639",
      date: "\u0627\u0644\u062A\u0627\u0631\u064A\u062E",
      category: "\u0627\u0644\u0641\u0626\u0629",
      note: "\u0645\u0644\u0627\u062D\u0638\u0629",
      duration: "\u0627\u0644\u0645\u062F\u0629",
      rejectTitle: "\u0631\u0641\u0636 \u0625\u062F\u062E\u0627\u0644\u0627\u062A \u0627\u0644\u0648\u0642\u062A",
      rejectBody: "\u0633\u062A\u0631\u0641\u0636 {count} \u0625\u062F\u062E\u0627\u0644(\u0627\u062A). \u064A\u0645\u0643\u0646 \u0644\u0644\u0634\u062E\u0635 \u062A\u0635\u062D\u064A\u062D\u0647\u0627 \u062B\u0645 \u062A\u0633\u0644\u064A\u0645 \u0623\u0633\u0628\u0648\u0639\u0647 \u0645\u0646 \u062C\u062F\u064A\u062F.",
      reasonLabel: "\u0633\u0628\u0628 \u0627\u0644\u0631\u0641\u0636 (\u0625\u0644\u0632\u0627\u0645\u064A)",
      reasonRequired: "\u0627\u0630\u0643\u0631 \u0633\u0628\u0628 \u0627\u0644\u0631\u0641\u0636 (3 \u0623\u062D\u0631\u0641 \u0639\u0644\u0649 \u0627\u0644\u0623\u0642\u0644).",
      confirmReject: "\u0631\u0641\u0636",
      approved: "\u0627\u0644\u0625\u062F\u062E\u0627\u0644\u0627\u062A \u0627\u0644\u0645\u0648\u0627\u0641\u064E\u0642 \u0639\u0644\u064A\u0647\u0627: {count}.",
      rejected: "\u0627\u0644\u0625\u062F\u062E\u0627\u0644\u0627\u062A \u0627\u0644\u0645\u0631\u0641\u0648\u0636\u0629: {count}.",
      loadFailedTitle: "\u062A\u0639\u0630\u0651\u0631 \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0625\u062F\u062E\u0627\u0644\u0627\u062A \u0628\u0627\u0646\u062A\u0638\u0627\u0631 \u0627\u0644\u0645\u0648\u0627\u0641\u0642\u0629",
      empty: {
        title: "\u0644\u0627 \u0634\u064A\u0621 \u0644\u0644\u0645\u0648\u0627\u0641\u0642\u0629 \u0639\u0644\u064A\u0647",
        description: "\u0633\u062A\u0638\u0647\u0631 \u0647\u0646\u0627 \u0625\u062F\u062E\u0627\u0644\u0627\u062A \u0627\u0644\u0648\u0642\u062A \u0627\u0644\u0645\u0633\u0644\u064E\u0651\u0645\u0629 \u0639\u0644\u0649 \u0645\u0634\u0627\u0631\u064A\u0639\u0643."
      },
      summaryLabel: "\u0645\u0644\u062E\u0635 \u0627\u0644\u062A\u0633\u062C\u064A\u0644\u0627\u062A \u0627\u0644\u0645\u0646\u062A\u0638\u0631\u0629 \u0644\u0644\u0645\u0648\u0627\u0641\u0642\u0629",
      pending: "\u0627\u0644\u062A\u0633\u062C\u064A\u0644\u0627\u062A \u0627\u0644\u0645\u0646\u062A\u0638\u0631\u0629",
      pendingCaption: "\u0645\u064F\u0631\u0633\u064E\u0644\u0629 \u0639\u0644\u0649 \u0645\u0634\u0627\u0631\u064A\u0639\u0643",
      hours: "\u0627\u0644\u0648\u0642\u062A \u0627\u0644\u0645\u0646\u062A\u0638\u0631 \u0644\u0644\u0645\u0648\u0627\u0641\u0642\u0629",
      hoursCaption: "\u0645\u062C\u0645\u0648\u0639 \u0627\u0644\u062A\u0633\u062C\u064A\u0644\u0627\u062A \u0627\u0644\u0645\u0646\u062A\u0638\u0631\u0629",
      people: "\u0627\u0644\u0623\u0634\u062E\u0627\u0635",
      weeksCount: "\u0639\u062F\u062F \u0627\u0644\u0623\u0633\u0627\u0628\u064A\u0639: {count}",
      noSelection: "\u0644\u0627 \u064A\u0648\u062C\u062F \u062A\u0633\u062C\u064A\u0644 \u0645\u062D\u062F\u064E\u0651\u062F",
      selection: "\u0627\u0644\u062A\u0633\u062C\u064A\u0644\u0627\u062A \u0627\u0644\u0645\u062D\u062F\u064E\u0651\u062F\u0629: {count} \xB7 {duration}"
    },
    capacity: {
      description: "\u0627\u0644\u0648\u0642\u062A \u0627\u0644\u0645\u064F\u062F\u062E\u064E\u0644 \u0645\u0642\u0627\u0631\u0646\u0629 \u0628\u0637\u0627\u0642\u0629 \u0643\u0644 \u0634\u062E\u0635 (\u0633\u0627\u0639\u0627\u062A \u0627\u0644\u0639\u0642\u062F \u0646\u0627\u0642\u0635 \u0627\u0644\u0639\u0637\u0644 \u0627\u0644\u0631\u0633\u0645\u064A\u0629 \u0648\u0627\u0644\u063A\u064A\u0627\u0628\u0627\u062A). \u0641\u0648\u0642 110\u066A \u064A\u0643\u0648\u0646 \u0627\u0644\u0623\u0633\u0628\u0648\u0639 \u0641\u064A \u062D\u0627\u0644\u0629 \u0636\u063A\u0637 \u0632\u0627\u0626\u062F.",
      navLabel: "\u0627\u0644\u0641\u062A\u0631\u0629 \u0627\u0644\u0645\u0639\u0631\u0648\u0636\u0629",
      earlier: "\u0627\u0644\u0623\u0633\u0627\u0628\u064A\u0639 \u0627\u0644\u0633\u0627\u0628\u0642\u0629",
      later: "\u0627\u0644\u0623\u0633\u0627\u0628\u064A\u0639 \u0627\u0644\u062A\u0627\u0644\u064A\u0629",
      weeksLabel: "\u0645\u062F\u0629 \u0627\u0644\u0639\u0631\u0636",
      weeksOption: "{count} \u0623\u0633\u0628\u0648\u0639",
      caption: "\u062D\u0645\u0644 \u0627\u0644\u0641\u0631\u064A\u0642 \u062D\u0633\u0628 \u0627\u0644\u0623\u0633\u0628\u0648\u0639",
      person: "\u0627\u0644\u0634\u062E\u0635",
      contract: "\u0627\u0644\u0639\u0642\u062F:",
      editContract: "\u062A\u0639\u062F\u064A\u0644 \u0633\u0627\u0639\u0627\u062A \u0639\u0642\u062F {name}",
      contractTitle: "\u0633\u0627\u0639\u0627\u062A \u0639\u0642\u062F {name}",
      contractLabel: "\u0627\u0644\u0633\u0627\u0639\u0627\u062A \u0641\u064A \u0627\u0644\u0623\u0633\u0628\u0648\u0639",
      contractHint: "\u0645\u062B\u0644 40 \u0623\u0648 37:30. \u062A\u064F\u062F\u062E\u0644 \u0627\u0644\u0645\u062F\u062F \u0628\u0623\u0631\u0628\u0627\u0639 \u0627\u0644\u0633\u0627\u0639\u0629\u060C \u0648\u0628\u062D\u062F \u0623\u0642\u0635\u0649 70 \u0633\u0627\u0639\u0629.",
      contractSaved: "\u062A\u0645 \u062D\u0641\u0638 \u0633\u0627\u0639\u0627\u062A \u0627\u0644\u0639\u0642\u062F.",
      contractInvalid: {
        format: "\u0623\u062F\u062E\u0644 \u0633\u0627\u0639\u0627\u062A \u0645\u062B\u0644 40 \u0623\u0648 37.5 \u0623\u0648 37:30.",
        step: "\u062A\u064F\u062F\u062E\u0644 \u0627\u0644\u0633\u0627\u0639\u0627\u062A \u0628\u0623\u0631\u0628\u0627\u0639 \u0627\u0644\u0633\u0627\u0639\u0629.",
        max: "\u0644\u0627 \u064A\u0645\u0643\u0646 \u0623\u0646 \u064A\u062A\u062C\u0627\u0648\u0632 \u0627\u0644\u0623\u0633\u0628\u0648\u0639 70 \u0633\u0627\u0639\u0629."
      },
      missingHolidays: "\u0631\u0648\u0632\u0646\u0627\u0645\u0629 \u0627\u0644\u0639\u0637\u0644 \u0627\u0644\u0631\u0633\u0645\u064A\u0629 \u063A\u064A\u0631 \u0645\u062A\u0648\u0641\u0631\u0629 \u0644\u0633\u0646\u0629 {years}: \u062A\u062A\u062C\u0627\u0647\u0644 \u0637\u0627\u0642\u0629 \u0647\u0630\u0647 \u0627\u0644\u0623\u0633\u0627\u0628\u064A\u0639 \u0627\u0644\u0639\u0637\u0644 \u0627\u0644\u0631\u0633\u0645\u064A\u0629.",
      cellLabel: "{name}\u060C \u0623\u0633\u0628\u0648\u0639 {range}: {load} \u0645\u064F\u062F\u062E\u064E\u0644\u0629 \u0645\u0646 {capacity}\u060C {state}",
      unknown: "\u0637\u0627\u0642\u0629 \u063A\u064A\u0631 \u0645\u0639\u0631\u0648\u0641\u0629",
      states: {
        ok: "\u0636\u0645\u0646 \u0627\u0644\u0637\u0627\u0642\u0629",
        high: "\u0641\u0648\u0642 100\u066A",
        over: "\u0636\u063A\u0637 \u0632\u0627\u0626\u062F (\u0623\u0643\u062B\u0631 \u0645\u0646 110\u066A)",
        none: "\u0627\u0644\u0637\u0627\u0642\u0629 \u063A\u064A\u0631 \u0645\u0639\u0631\u0648\u0641\u0629"
      },
      percent: "{percent}\u066A",
      noTime: "\u0644\u0645 \u064A\u064F\u062F\u062E\u064E\u0644 \u0623\u064A \u0648\u0642\u062A \u0647\u0630\u0627 \u0627\u0644\u0623\u0633\u0628\u0648\u0639.",
      projectLine: "{project}: {duration}",
      loadFailedTitle: "\u062A\u0639\u0630\u0651\u0631 \u062A\u062D\u0645\u064A\u0644 \u062D\u0645\u0644 \u0627\u0644\u0641\u0631\u064A\u0642",
      empty: {
        title: "\u0644\u0627 \u0623\u062D\u062F \u0644\u0644\u0639\u0631\u0636",
        description: "\u064A\u0638\u0647\u0631 \u0627\u0644\u062D\u0645\u0644 \u0644\u0623\u0639\u0636\u0627\u0621 \u0641\u0631\u064A\u0642\u0643 \u0628\u0645\u062C\u0631\u062F \u0625\u062F\u062E\u0627\u0644\u0647\u0645 \u0644\u0644\u0648\u0642\u062A."
      },
      legend: "\u0645\u0641\u062A\u0627\u062D \u0639\u0628\u0621 \u0627\u0644\u0639\u0645\u0644"
    },
    leave: {
      description: "\u0627\u0644\u0639\u0637\u0644 \u0648\u0627\u0644\u0645\u0631\u0636 \u0648\u0627\u0644\u062A\u0643\u0648\u064A\u0646. \u064A\u062E\u0641\u0651\u0636 \u0627\u0644\u063A\u064A\u0627\u0628 \u0637\u0627\u0642\u0629 \u0627\u0644\u0623\u0633\u0627\u0628\u064A\u0639 \u0627\u0644\u062A\u064A \u064A\u0634\u0645\u0644\u0647\u0627.",
      formLabel: "\u0625\u0636\u0627\u0641\u0629 \u063A\u064A\u0627\u0628",
      person: "\u0627\u0644\u0634\u062E\u0635",
      me: "\u0623\u0646\u0627",
      startsOn: "\u0645\u0646",
      endsOn: "\u0625\u0644\u0649",
      kind: "\u0627\u0644\u0646\u0648\u0639",
      kinds: {
        leave: "\u0639\u0637\u0644\u0629",
        sick: "\u0645\u0631\u0636",
        training: "\u062A\u0643\u0648\u064A\u0646",
        other: "\u0623\u062E\u0631\u0649"
      },
      noteLabel: "\u0645\u0644\u0627\u062D\u0638\u0629 (\u0627\u062E\u062A\u064A\u0627\u0631\u064A)",
      note: "\u0645\u0644\u0627\u062D\u0638\u0629",
      add: "\u0625\u0636\u0627\u0641\u0629 \u0627\u0644\u063A\u064A\u0627\u0628",
      created: "\u062A\u0645\u062A \u0625\u0636\u0627\u0641\u0629 \u0627\u0644\u063A\u064A\u0627\u0628.",
      deleted: "\u062A\u0645 \u062D\u0630\u0641 \u0627\u0644\u063A\u064A\u0627\u0628.",
      delete: "\u062D\u0630\u0641 \u063A\u064A\u0627\u0628 {name} ({period})",
      deleteTitle: "\u062D\u0630\u0641 \u0647\u0630\u0627 \u0627\u0644\u063A\u064A\u0627\u0628\u061F",
      deleteBody: "\u0633\u062A\u064F\u062D\u0633\u0628 \u0645\u0646 \u062C\u062F\u064A\u062F \u0637\u0627\u0642\u0629 \u0627\u0644\u0623\u0633\u0627\u0628\u064A\u0639 \u0627\u0644\u0645\u0639\u0646\u064A\u0629.",
      period: "\u0627\u0644\u0641\u062A\u0631\u0629",
      periodValue: "\u0645\u0646 {from} \u0625\u0644\u0649 {to}",
      actions: "\u0627\u0644\u0625\u062C\u0631\u0627\u0621\u0627\u062A",
      datesRequired: "\u0623\u062F\u062E\u0644 \u062A\u0627\u0631\u064A\u062E\u064E\u064A \u0627\u0644\u0628\u062F\u0627\u064A\u0629 \u0648\u0627\u0644\u0646\u0647\u0627\u064A\u0629.",
      endBeforeStart: "\u0644\u0627 \u064A\u0645\u0643\u0646 \u0623\u0646 \u064A\u0633\u0628\u0642 \u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0646\u0647\u0627\u064A\u0629 \u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0628\u062F\u0627\u064A\u0629.",
      loadFailedTitle: "\u062A\u0639\u0630\u0651\u0631 \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u063A\u064A\u0627\u0628\u0627\u062A",
      empty: {
        title: "\u0644\u0627 \u064A\u0648\u062C\u062F \u063A\u064A\u0627\u0628",
        description: "\u0633\u062A\u0638\u0647\u0631 \u0647\u0646\u0627 \u0627\u0644\u0639\u0637\u0644 \u0648\u0627\u0644\u0623\u0645\u0631\u0627\u0636 \u0648\u0627\u0644\u062A\u0643\u0648\u064A\u0646\u0627\u062A \u0641\u064A \u0647\u0630\u0647 \u0627\u0644\u0641\u062A\u0631\u0629."
      },
      upcoming: "\u0627\u0644\u0642\u0627\u062F\u0645\u0629 \u0648\u0627\u0644\u062C\u0627\u0631\u064A\u0629",
      past: "\u0627\u0644\u0633\u0627\u0628\u0642\u0629",
      workingDays: "{count, plural, zero {\u0644\u0627 \u0623\u064A\u0627\u0645 \u0639\u0645\u0644} one {\u064A\u0648\u0645 \u0639\u0645\u0644 \u0648\u0627\u062D\u062F} two {\u064A\u0648\u0645\u0627 \u0639\u0645\u0644} few {# \u0623\u064A\u0627\u0645 \u0639\u0645\u0644} many {# \u064A\u0648\u0645 \u0639\u0645\u0644} other {# \u064A\u0648\u0645 \u0639\u0645\u0644}}"
    },
    errors: {
      network: "\u0641\u0634\u0644 \u0627\u0644\u0627\u062A\u0635\u0627\u0644. \u062A\u062D\u0642\u0642 \u0645\u0646 \u0627\u0644\u0634\u0628\u0643\u0629 \u062B\u0645 \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629.",
      TIMESHEET_LOCKED: "\u062A\u0645 \u062A\u0633\u0644\u064A\u0645 \u0647\u0630\u0627 \u0627\u0644\u0623\u0633\u0628\u0648\u0639 \u0623\u0648 \u062A\u0645 \u0627\u0644\u0628\u062A\u0651 \u0641\u064A \u0647\u0630\u0627 \u0627\u0644\u0625\u062F\u062E\u0627\u0644: \u0644\u0645 \u064A\u0639\u062F \u0642\u0627\u0628\u0644\u064B\u0627 \u0644\u0644\u062A\u0639\u062F\u064A\u0644.",
      NOT_FOUND: "\u0623\u0646\u062A \u0644\u0627 \u062A\u0639\u0645\u0644 \u0639\u0644\u0649 \u0647\u0630\u0627 \u0627\u0644\u0645\u0634\u0631\u0648\u0639\u060C \u0623\u0648 \u0623\u0646 \u0647\u0630\u0627 \u0627\u0644\u0639\u0646\u0635\u0631 \u0644\u0645 \u064A\u0639\u062F \u0645\u0648\u062C\u0648\u062F\u064B\u0627.",
      FORBIDDEN: "\u063A\u064A\u0631 \u0645\u0633\u0645\u0648\u062D \u0644\u0643 \u0628\u0647\u0630\u0627 \u0627\u0644\u0625\u062C\u0631\u0627\u0621 (\u0644\u0627 \u062A\u0628\u062A\u0651 \u0641\u064A \u0648\u0642\u062A\u0643 \u0627\u0644\u062E\u0627\u0635).",
      STALE_VERSION: "\u062A\u063A\u064A\u0651\u0631 \u0647\u0630\u0627 \u0627\u0644\u0625\u062F\u062E\u0627\u0644 \u0641\u064A \u0627\u0644\u0623\u062B\u0646\u0627\u0621. \u0623\u064F\u0639\u064A\u062F \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0623\u0633\u0628\u0648\u0639 \u0644\u0644\u062A\u0648\u060C \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629."
    },
    kpis: {
      label: "\u0645\u0644\u062E\u0635 \u0627\u0644\u0623\u0633\u0628\u0648\u0639",
      entered: "\u0627\u0644\u0645\u0633\u062C\u064E\u0651\u0644 \u0647\u0630\u0627 \u0627\u0644\u0623\u0633\u0628\u0648\u0639",
      noCapacity: "\u0637\u0627\u0642\u0629 \u0627\u0644\u0623\u0633\u0628\u0648\u0639 \u063A\u064A\u0631 \u0645\u0639\u0631\u0648\u0641\u0629",
      progressLabel: "\u0627\u0644\u0648\u0642\u062A \u0627\u0644\u0645\u0633\u062C\u064E\u0651\u0644 \u0645\u0642\u0627\u0631\u0646\u0629 \u0628\u0637\u0627\u0642\u0629 \u0627\u0644\u0623\u0633\u0628\u0648\u0639",
      remaining: "\u0627\u0644\u0645\u062A\u0628\u0642\u064A \u0644\u0644\u062A\u0633\u062C\u064A\u0644",
      remainingDone: "\u062A\u0645 \u0628\u0644\u0648\u063A \u0637\u0627\u0642\u0629 \u0627\u0644\u0623\u0633\u0628\u0648\u0639",
      remainingCaption: "\u0644\u0628\u0644\u0648\u063A \u0637\u0627\u0642\u0629 \u0627\u0644\u0623\u0633\u0628\u0648\u0639",
      days: "\u0627\u0644\u0623\u064A\u0627\u0645 \u0627\u0644\u0645\u0633\u062C\u064E\u0651\u0644\u0629",
      daysCaption: "\u0623\u064A\u0627\u0645 \u0627\u0644\u0639\u0645\u0644 \u062F\u0648\u0646 \u0627\u0644\u0639\u0637\u0644 \u0648\u0627\u0644\u063A\u064A\u0627\u0628\u0627\u062A",
      status: "\u062D\u0627\u0644\u0629 \u0627\u0644\u0623\u0633\u0628\u0648\u0639",
      statusOpen: "\u0642\u064A\u062F \u0627\u0644\u062A\u0633\u062C\u064A\u0644",
      statusSubmitted: "\u0645\u064F\u0631\u0633\u064E\u0644",
      toSubmit: "\u062C\u0627\u0647\u0632 \u0644\u0644\u0625\u0631\u0633\u0627\u0644: {duration}",
      rejected: "{count, plural, zero {\u0644\u0627 \u062A\u0633\u062C\u064A\u0644\u0627\u062A \u0645\u0631\u0641\u0648\u0636\u0629} one {\u062A\u0633\u062C\u064A\u0644 \u0645\u0631\u0641\u0648\u0636 \u0648\u0627\u062D\u062F} two {\u062A\u0633\u062C\u064A\u0644\u0627\u0646 \u0645\u0631\u0641\u0648\u0636\u0627\u0646} few {# \u062A\u0633\u062C\u064A\u0644\u0627\u062A \u0645\u0631\u0641\u0648\u0636\u0629} many {# \u062A\u0633\u062C\u064A\u0644\u064B\u0627 \u0645\u0631\u0641\u0648\u0636\u064B\u0627} other {# \u062A\u0633\u062C\u064A\u0644 \u0645\u0631\u0641\u0648\u0636}}",
      rejectedCaption: "\u0635\u062D\u0651\u062D\u0647\u0627 \u062B\u0645 \u0623\u0631\u0633\u0644\u0647\u0627 \u0645\u0646 \u062C\u062F\u064A\u062F",
      currentWeek: "\u0627\u0644\u0623\u0633\u0628\u0648\u0639 \u0627\u0644\u062D\u0627\u0644\u064A"
    }
  }
};

// locales/en/web.json
var web_default2 = {
  session: {
    loading: "Loading your workspace\u2026",
    redirecting: "Redirecting to the sign-in page\u2026"
  },
  unavailable: {
    title: "The sign-in service is not available yet",
    body: "We cannot check your session right now. Your data is safe. Try again in a moment; if the problem continues, contact support."
  },
  notFound: {
    title: "This page does not exist",
    body: "The link may be old or mistyped. Go back to the home page to continue.",
    home: "Back to home"
  },
  error: {
    title: "Something went wrong",
    body: "This page could not be displayed. Your data is safe. Reload the page; if the problem continues, send the technical details to support.",
    reload: "Reload the page",
    details: "Technical details",
    noTrace: "not available",
    release: "Version: {release}",
    copied: "Details copied to the clipboard.",
    copyFailed: "Copy failed. Select the text above to copy it by hand."
  },
  onboarding: {
    title: "Welcome to BatiFlow",
    body: "Set up your design office profile in a few minutes. You will be its owner and get a 14-day trial of the Pro plan.",
    hint: "If your design office already uses BatiFlow, ask its administrator for an invitation instead of creating a new organisation.",
    stepCounter: "Step {current} of {total}",
    steps: {
      identity: {
        title: "Office identity",
        description: "This information appears on your official documents."
      },
      disciplines: {
        title: "Disciplines",
        description: "Tick the disciplines your design office practises."
      },
      address: {
        title: "Address and governorate",
        description: "Enter the address of your office headquarters."
      },
      summary: {
        title: "Summary",
        description: "Check this information before creating your organisation."
      }
    },
    fields: {
      legalName: {
        label: "Legal name",
        hint: "The official name of your office, as it appears in the trade register."
      },
      tradeName: {
        label: "Trade name (optional)",
        hint: "The name your clients know you by."
      },
      legalForm: {
        label: "Legal form",
        placeholder: "Choose a legal form"
      },
      taxId: {
        label: "Tax id",
        hint: "You will find it on your office's certificate of existence."
      },
      disciplines: {
        legend: "Office disciplines",
        hint: "You can choose several."
      },
      line1: {
        label: "Address"
      },
      line2: {
        label: "Address line 2 (optional)"
      },
      city: {
        label: "City"
      },
      postalCode: {
        label: "Postal code"
      },
      governorate: {
        label: "Governorate",
        placeholder: "Choose a governorate"
      }
    },
    summary: {
      notProvided: "Not provided"
    },
    actions: {
      create: "Create my organisation",
      creating: "Creating\u2026"
    },
    errors: {
      legalNameRequired: "Enter the legal name of your office.",
      tooLong: "This field cannot be longer than {max} characters.",
      legalFormRequired: "Choose the legal form.",
      disciplinesRequired: "Choose at least one discipline.",
      line1Required: "Enter the address of your office.",
      cityRequired: "Enter the city.",
      postalCodeRequired: "Enter the postal code.",
      postalCodeFormat: "Enter a valid postal code, for example 1002.",
      governorateRequired: "Choose the governorate.",
      taxIdTaken: "This tax id is already used by an office on BatiFlow. Ask its owner to invite you.",
      fieldInvalid: "This value is not accepted. Check it and try again.",
      submitTitle: "The organisation could not be created"
    }
  },
  legalForms: {
    individual: "Sole proprietorship",
    suarl: "Single-member limited company (SUARL)",
    sarl: "Limited liability company (SARL)",
    sa: "Public limited company (SA)",
    snc: "General partnership (SNC)",
    scs: "Limited partnership (SCS)",
    gie: "Economic interest group (GIE)",
    other: "Other"
  },
  governorates: {
    tunis: "Tunis",
    ariana: "Ariana",
    ben_arous: "Ben Arous",
    manouba: "Manouba",
    nabeul: "Nabeul",
    zaghouan: "Zaghouan",
    bizerte: "Bizerte",
    beja: "Beja",
    jendouba: "Jendouba",
    kef: "Kef",
    siliana: "Siliana",
    kairouan: "Kairouan",
    kasserine: "Kasserine",
    sidi_bouzid: "Sidi Bouzid",
    sousse: "Sousse",
    monastir: "Monastir",
    mahdia: "Mahdia",
    sfax: "Sfax",
    gafsa: "Gafsa",
    tozeur: "Tozeur",
    kebili: "Kebili",
    gabes: "Gabes",
    medenine: "Medenine",
    tataouine: "Tataouine"
  },
  activity: {
    title: "Activity",
    body: "Your mentions, approvals and assignments will appear here.",
    empty: "Nothing new for now.",
    setup: {
      title: "Finish setting up your office",
      intro: "Three steps to get started with BatiFlow.",
      dismiss: "Hide",
      dismissLabel: "Hide the setup card",
      listLabel: "Setup steps",
      invite: {
        title: "Invite your team",
        description: "Add your engineers, draftsmen and colleagues.",
        action: "Invite"
      },
      clients: {
        title: "Add a client",
        description: "Record your project owners to find them in your projects.",
        action: "Add a client"
      },
      project: {
        title: "Create a project",
        description: "Start your first study file.",
        action: "Create a project"
      }
    }
  },
  comingSoon: {
    body: "It will be available in a future version of BatiFlow. Meanwhile, follow what is new in Activity.",
    title: "This section is coming soon",
    backToActivity: "Go to Activity"
  },
  search: {
    close: "Close"
  },
  signOut: {
    failed: "Sign-out did not complete. Close your browser to end the session safely.",
    title: "Sign-out incomplete"
  },
  mfa: {
    title: "Turn on two-step verification",
    body: "Your design office requires two-step verification for your account: besides your password, you enter a six-digit code from an authenticator app on your phone (Google Authenticator, Microsoft Authenticator, FreeOTP\u2026).",
    hint: "It takes about two minutes. Keep your phone at hand.",
    setUp: "Turn it on now",
    alreadyDone: "I have already turned it on"
  },
  stepUp: {
    reason: "This action is protected because it touches sensitive data of your design office.",
    noSecondFactorTitle: "Two-step verification needed",
    noSecondFactorBody: "To confirm your identity before this action, first turn on two-step verification.",
    setUp: "Turn it on"
  },
  pendingAction: {
    replayed: "Done: your action was completed after you confirmed your identity.",
    failed: "Your identity is confirmed, but the action did not go through. Please do it again.",
    stepUpFailed: "We could not confirm your identity. Nothing was changed."
  },
  signedOut: {
    title: "You are signed out",
    body: "Your BatiFlow session is closed on this device. To continue, sign in again.",
    signIn: "Sign in",
    reasons: {
      login_failed: {
        title: "Sign-in did not complete",
        body: "The sign-in was interrupted or took too long. Try again; if the problem continues, contact support."
      },
      cancelled: {
        title: "Sign-in cancelled",
        body: "You cancelled the sign-in. You can start again whenever you like."
      },
      email_not_verified: {
        title: "Confirm your email address first",
        body: "Open the BatiFlow message sent to your email address, follow the confirmation link, then sign in again."
      },
      account_disabled: {
        title: "Your account is locked",
        body: "Access to this account was blocked by BatiFlow support. Contact support to find out more."
      }
    }
  },
  standalone: {
    backHome: "Back to home"
  },
  security: {
    title: "Account security",
    mfa: {
      title: "Two-step verification",
      active: "Turned on",
      inactive: "Not turned on",
      activeBody: "Your current session was confirmed with a second factor: besides your password, you entered a code from an authenticator app or used a security key.",
      inactiveBody: "Your sign-in relies on your password alone. Add a six-digit code from an authenticator app on your phone to better protect your account and your design office's data.",
      setUp: "Turn on two-step verification",
      listLabel: "Your verification methods",
      kind: {
        totp: "Authenticator app",
        securityKey: "Security key"
      },
      addedOn: "added on {date}",
      remove: "Remove",
      removeLabel: "Remove {name}",
      removeTitle: "Remove \u201C{name}\u201D?",
      removeBody: "This method will no longer work to sign in. For your security, you confirm it\u2019s you first.",
      removed: "\u201C{name}\u201D was removed.",
      add: "Add an authenticator app"
    },
    password: {
      title: "Password",
      body: "Change your password here, without leaving BatiFlow. For your security, you confirm it\u2019s you first.",
      updatedAt: "Last changed: {date}",
      neverSet: "This account has no password (it signs in with Google or Microsoft).",
      change: "Change password",
      reauthHint: "You will first confirm it\u2019s you on the BatiFlow sign-in page, then come straight back here to type the new password.",
      confirmIdentity: "Confirm it\u2019s me",
      dialog: {
        title: "Change password",
        intro: "Choose a password you use nowhere else. A phrase of several words is easy to remember and hard to guess.",
        newLabel: "New password",
        confirmLabel: "Confirm the new password",
        rules: "At least {min} characters, different from your e-mail address and from your last 5 passwords.",
        signOutOthers: "Sign out my other devices",
        submit: "Save password",
        saving: "Saving\u2026",
        done: "{count, plural, =0 {Your password was changed.} one {Your password was changed and # other device was signed out.} other {Your password was changed and # other devices were signed out.}}",
        errors: {
          length: "The password must have {min} to {max} characters.",
          mismatch: "The two passwords are not the same.",
          policy: "This password is not accepted: it needs at least 12 characters and must differ from your e-mail address and from your last 5 passwords."
        }
      }
    },
    sessions: {
      title: "Active sessions",
      intro: "You are signed in on these devices. Sign out the ones you do not recognise.",
      listLabel: "Your active sessions",
      currentDevice: "This device",
      flagged: "Change detected",
      flaggedHint: "The network or the browser changed during the session. If that was not you, sign this device out.",
      unknownDevice: "Unknown device",
      lastActivity: "Last activity:",
      network: "Network:",
      revoke: "Sign out",
      revokeLabel: "Sign out {device}",
      revokeTitle: "Sign out \u201C{device}\u201D?",
      revokeBody: "This device will have to sign in again to use BatiFlow. Your data is not changed.",
      revoked: "The device \u201C{device}\u201D was signed out.",
      alreadyEnded: "This session had already ended.",
      revokeFailed: "Signing this device out did not work. Try again; if the problem continues, contact support.",
      revokeOthers: "Sign out other devices",
      revokeOthersTitle: "Sign out all other devices?",
      revokeOthersBody: "{count, plural, one {# other device will be signed out and will have to sign in again.} other {# other devices will be signed out and will have to sign in again.}} This device stays signed in.",
      revokedOthers: "{count, plural, =0 {No other device was signed in.} one {# other device was signed out.} other {# other devices were signed out.}}",
      revokeOthersFailed: "Signing the other devices out did not work. Try again; if the problem continues, contact support.",
      noOthers: "No other device is signed in.",
      empty: "No active session to show.",
      loadFailedTitle: "Your sessions cannot be shown",
      loadFailedBody: "Your sessions could not be loaded. Your data is not lost. Try again; if the problem continues, contact support."
    },
    loadFailed: "Your account\u2019s security details could not be loaded. Try again; if it keeps happening, contact support."
  },
  admin: {
    nav: {
      label: "Organisation administration",
      title: "Administration",
      members: "Members",
      roles: "Roles and permissions",
      profile: "Organisation",
      policies: "Policies",
      fiscal: "Fiscal profile",
      audit: "Audit log",
      documents: "Documents",
      templates: "Project templates",
      checklists: "Checklists",
      storage: "Storage",
      data: "Data and deletion",
      subscription: "Subscription"
    }
  },
  more: {
    admin: {
      title: "Administration",
      description: "Members, invitations, roles and permissions of your office."
    },
    soon: "More sections will arrive in future versions of BatiFlow.",
    partnerships: {
      title: "Partnerships",
      description: "Partnership requests received, and spaces of other organisations where you manage your delegates."
    },
    approvals: {
      title: "External access approvals",
      description: "Grant or refuse a member access to another organisation's space."
    },
    directory: {
      title: "Office directory",
      description: "Find other BatiFlow design offices and write to them."
    },
    timesheets: {
      title: "Time",
      description: "Enter your hours, get weeks approved and follow the team\u2019s workload."
    },
    tenders: {
      title: "Tenders",
      description: "Follow consultations from watch to result, prepare your documents and keep your certificates up to date."
    },
    signatures: {
      title: "Signatures",
      description: "Sign the documents you are asked to sign and follow your signature requests."
    }
  },
  members: {
    title: "Members",
    you: "you",
    none: "\u2014",
    tableCaption: "Organisation members",
    seats: {
      used: "seats used",
      unlimited: "seats used (no limit)"
    },
    tabs: {
      members: "Members",
      invitations: "Pending invitations"
    },
    filters: {
      label: "Filter members",
      search: "Search for a member",
      searchPlaceholder: "Name or email address",
      role: "Filter by role",
      allRoles: "All roles",
      status: "Filter by status",
      allStatuses: "All statuses",
      clear: "Clear filters"
    },
    columns: {
      name: "Name",
      email: "Email address",
      role: "Role",
      status: "Status",
      joined: "Joined",
      actions: "Actions"
    },
    status: {
      active: "Active",
      invited: "Invited",
      suspended: "Suspended by support",
      deactivated: "Deactivated"
    },
    roles: {
      owner: "Owner",
      admin: "Administrator",
      project_manager: "Project manager",
      engineer: "Engineer or architect",
      draftsman: "Draftsman",
      accountant: "Accountant"
    },
    roleDescriptions: {
      admin: "Manages the members, the settings, finance and every project of the office.",
      project_manager: "Creates and runs their projects, follows fees, time and expense reports.",
      engineer: "Takes part in the projects you add them to: documents, tasks and discussions.",
      draftsman: "Prepares and uploads drawings on the projects you add them to.",
      accountant: "Manages quotes, invoices, payments and the office's tax matters."
    },
    actions: {
      open: "Actions for {name}",
      changeRole: "Change role",
      deactivate: "Deactivate",
      transferOwnership: "Transfer ownership"
    },
    empty: {
      title: "No members yet",
      description: "Invite your team to work together on your projects.",
      filteredTitle: "No member matches",
      filteredDescription: "Try another name or remove a filter."
    },
    loadFailedTitle: "Cannot show the members",
    loadFailedBody: "The list could not be loaded. Your data is safe. Try again; if the problem continues, contact support.",
    loadMore: "Show more members",
    loadingMore: "Loading\u2026",
    invite: {
      button: "Invite",
      title: "Invite a member",
      intro: "The person receives an email with a link to join your office. The invitation is valid for 7 days.",
      email: {
        label: "Email address"
      },
      role: {
        label: "Role"
      },
      locale: {
        label: "Language of the email",
        hint: "The invitation is written in this language."
      },
      submit: "Send the invitation",
      sending: "Sending\u2026",
      sent: "The invitation was sent to {email}.",
      resendExisting: "Resend the invitation",
      errors: {
        emailRequired: "Enter the email address of the person to invite.",
        emailInvalid: "Enter a valid email address, for example name@example.tn.",
        alreadyMember: "This address already belongs to a member of your office.",
        pending: "An invitation is already pending for this address. You can resend it.",
        pendingElsewhere: 'An invitation is already pending for this address. Find it in the "Pending invitations" tab.'
      }
    },
    upgrade: {
      askOwner: "All the seats of your plan are in use. Ask the owner of your office to add a seat or change plan so you can invite more people.",
      addSeat: "All the seats of your plan are in use. Add a seat to invite one more person. This option is coming soon to the administration: meanwhile, contact BatiFlow support.",
      upgradePlan: "All the seats of your plan are in use. Switch to the {plan} plan to get more. Choosing a plan is coming soon to the administration: meanwhile, contact BatiFlow support.",
      noHigherPlan: "All the seats of your plan are in use and no higher plan is offered online. Contact the BatiFlow team to add seats.",
      plans: {
        solo: "Solo",
        starter: "Starter",
        pro: "Pro",
        business: "Business",
        enterprise: "Enterprise"
      }
    },
    invitations: {
      tableCaption: "Pending invitations",
      columns: {
        email: "Email address",
        role: "Role",
        invitedBy: "Invited by",
        expires: "Expires on"
      },
      expired: "Expired",
      empty: {
        title: "No pending invitations",
        description: "People you invited who have not accepted yet appear here."
      },
      resend: "Resend",
      resendLabel: "Resend the invitation to {email}",
      resent: "The invitation was resent to {email}.",
      revoke: "Revoke",
      revokeLabel: "Revoke the invitation of {email}",
      revokeTitle: "Revoke the invitation of {email}?",
      revokeBody: "The link received by email will stop working. You can invite this person again.",
      revoked: "The invitation of {email} was revoked.",
      alreadyGone: "This invitation no longer exists: it was already accepted or revoked.",
      loadFailedTitle: "Cannot show the invitations",
      loadFailedBody: "The list could not be loaded. Try again; if the problem continues, contact support."
    },
    changeRole: {
      title: "Change the role of {name}",
      current: "Current role: {role}.",
      label: "New role",
      placeholder: "Choose a role",
      required: "Choose the new role.",
      stepUpNote: "For your security, you may need to confirm your identity before the change is applied.",
      submit: "Change role",
      saving: "Saving\u2026",
      done: '{name} now has the role "{role}".',
      stale: "The details of {name} changed in the meantime. The list was reloaded: check them, then try again."
    },
    deactivate: {
      explain: {
        title: "Deactivate {name}",
        intro: "Here is what happens when you deactivate {name}:",
        access: "Access to your office stops immediately, on every device.",
        content: "Their documents, messages and tasks stay in place and keep their name.",
        seat: "The seat is freed at the next billing period."
      },
      plan: {
        title: "What should happen to what {name} holds?",
        intro: "{count, plural, one {# item is held by {name}} other {# items are held by {name}}}. Choose who takes them over.",
        nothing: "There is nothing to hand over for now: {name} holds nothing that needs to go to someone else.",
        loadFailed: "The items to hand over could not be loaded. Try again before continuing.",
        defaultAssignee: "Default successor",
        defaultAssigneeHint: "Receives every item for which you choose nobody.",
        noDefault: "No default successor",
        useDefault: "Use the default successor",
        listLabel: "Items to hand over",
        errors: {
          missing: "Choose a person for each item, or a default successor."
        }
      },
      confirm: {
        title: "Deactivate {name}?",
        body: "{name} loses access to your office immediately. {count, plural, =0 {Nothing to hand over.} one {# item will be handed over.} other {# items will be handed over.}}",
        action: "Deactivate"
      },
      done: "{name} was deactivated.",
      alreadyGone: "This member is no longer active: they were already deactivated."
    },
    ownerTransfer: {
      theOwner: "The owner",
      pendingTitle: "Ownership transfer in progress",
      pendingBody: "Waiting for the answer of {name}, who must accept to become the owner.",
      expires: "Expires on",
      cancel: "Cancel the transfer",
      cancelled: "The ownership transfer was cancelled.",
      offerTitle: "{name} wants to make you the owner",
      offerBody: "You would take over the ownership of {organization}: billing, deleting the organisation and transferring it.",
      accept: "Accept",
      decline: "Decline",
      declined: "You declined the ownership transfer.",
      acceptTitle: "Become the owner of {organization}?",
      acceptBody: "You will become the owner and {name} will become an administrator. You will need to confirm your identity.",
      acceptAction: "Become the owner",
      accepted: "You are now the owner of {organization}.",
      proposeTitle: "Transfer ownership to {name}?",
      proposeBody: "{name} will receive the proposal and must accept it. If they accept, they become the owner and you become an administrator. You can cancel until they answer.",
      proposeAction: "Send the proposal",
      proposed: "The proposal was sent to {name}. It takes effect once they accept it."
    }
  },
  invitation: {
    opening: "Opening your invitation\u2026",
    loading: "Loading your invitation\u2026",
    joining: "Opening your workspace\u2026",
    toHome: "Go to the home page",
    missing: {
      title: "Your invitation is no longer open in this tab",
      body: "Open the link you received by email again to see your invitation. If you cannot find the message, ask the person who invited you for a new invitation."
    },
    signedOut: {
      title: "You are invited to join an engineering office on BatiFlow",
      body: "Sign in with the email address that received the invitation to see which office it is and join it.",
      account: "No account yet? You can create one on the sign-in page, then you come back here.",
      action: "Sign in or create an account"
    },
    problems: {
      unknown: {
        title: "This invitation link is not recognised",
        body: "The link may be incomplete or old. Open the email you received again, or ask for a new invitation."
      },
      invalid: {
        title: "This invitation is no longer valid",
        body: "It has expired, was cancelled or was already used. Ask the person who invited you for a new invitation."
      },
      mismatch: {
        title: "This invitation is meant for another address",
        body: "It was sent to",
        next: "You are signed in with another address. Sign out, then open the link you received by email again and sign in with the invited address.",
        generic: "You are signed in with a different address than the one invited. Sign out, then open the link you received by email again and sign in with the invited address."
      },
      unverified: {
        title: "Confirm your email address first",
        body: "Open the BatiFlow message sent to your address and follow the confirmation link. Then come back and open the invitation link again."
      },
      full: {
        title: "This office has no free seat left",
        body: "All the seats of the office's plan are in use. Contact the person who invited you: they can free or add a seat, then invite you again."
      },
      already: {
        title: "You are already part of this office",
        body: "Your account is already a member of this organisation. Go back to the home page to open it."
      },
      other: {
        title: "Your invitation could not be processed",
        body: "Something went wrong. Your data is safe. Try again; if the problem continues, contact support."
      }
    },
    ready: {
      title: "Join {organization}",
      intro: "You were invited to join this engineering office on BatiFlow. Check the details below.",
      organization: "Office",
      role: "Role",
      email: "Invited address",
      expires: "Valid until",
      join: "Join {organization}",
      joining: "One moment\u2026"
    }
  },
  rolesMatrix: {
    title: "Roles and permissions",
    intro: "This is what each role can do in your office. These roles are defined by BatiFlow: this table is read-only.",
    regionLabel: "Table of permissions by role (scrolls sideways)",
    caption: "Permissions granted to each role",
    permission: "Permission",
    legend: {
      label: "Table legend"
    },
    marks: {
      yes: {
        text: "Granted",
        legend: "Granted"
      },
      project: {
        symbol: "P",
        text: "Granted on their own projects only",
        legend: "Granted on their own projects only"
      },
      delegable: {
        symbol: "D",
        text: "Not granted by default, the owner can delegate it",
        legend: "Not granted by default; the owner can delegate it"
      },
      no: {
        text: "Not granted",
        legend: "Not granted"
      }
    },
    areas: {
      organization: "Organisation",
      billing: "Subscription",
      members: "Members and roles",
      audit: "Audit log",
      clients: "Clients",
      projects: "Projects",
      sharing: "Sharing and spaces",
      finance: "Finance",
      time: "Time and costs",
      other: "Other"
    },
    permissions: {
      org_update: "Edit the office profile",
      org_fiscal_read: "View the fiscal profile",
      org_fiscal_update: "Edit the fiscal profile",
      org_policy_update: "Edit policies (sharing, security)",
      org_delete: "Delete the organisation",
      org_transfer_ownership: "Transfer ownership",
      data_export: "Export the office data",
      billing_read: "View the subscription and BatiFlow invoices",
      billing_manage: "Manage the subscription and seats",
      member_read: "See the member list",
      member_invite: "Invite members",
      member_update: "Change a member's role",
      member_deactivate: "Deactivate a member",
      role_manage: "Manage roles",
      audit_read: "View the audit log",
      audit_read_finance: "View the finance audit log",
      audit_export: "Export the audit log",
      audit_verify: "Verify the audit log integrity",
      client_read: "View clients",
      client_create: "Create clients",
      client_update: "Edit clients",
      client_archive: "Archive clients",
      project_create: "Create projects",
      project_view_all: "See all projects",
      project_manage_all: "Manage all projects",
      project_fees_read: "See project fees",
      space_create: "Create collaboration spaces",
      space_share_external: "Share a space externally",
      space_approve_external_membership: "Approve access of external participants",
      document_publish_to_client: "Publish documents to the client",
      quote_read: "View quotes",
      quote_create: "Create quotes",
      quote_send: "Send quotes",
      contract_read: "View contracts",
      contract_manage: "Manage contracts",
      invoice_read: "View invoices",
      invoice_create: "Create invoices",
      invoice_update: "Edit invoices (drafts)",
      invoice_issue: "Issue invoices",
      einvoicing_manage: "Manage e-invoicing (TTN)",
      payment_read: "View payments",
      payment_create: "Record payments",
      expense_submit: "Submit their own expense reports",
      expense_read_all: "See all expense reports",
      expense_approve: "Approve expense reports",
      finance_dashboard: "See the finance dashboard",
      finance_export: "Export finance data",
      supplier_manage: "Manage suppliers",
      time_submit: "Log their own time",
      time_approve: "Approve timesheets",
      time_read_all: "See all timesheets",
      cost_rate_manage: "Manage cost rates",
      payroll_manage: "Manage payroll",
      tender_manage: "Manage tenders",
      checklist_manage: "Manage checklists"
    }
  },
  orgProfile: {
    title: "Organisation",
    formLabel: "Organisation profile",
    noChange: "There is nothing to save.",
    saved: "The organisation profile is saved.",
    stale: "Someone else changed the organisation profile while you were editing it. Your changes were not saved: the latest version has just been reloaded, so please apply your changes again.",
    saving: "Saving\u2026",
    saveFailedTitle: "The profile could not be saved",
    loadFailedTitle: "Unable to show the profile",
    loadFailedBody: "The organisation profile could not be loaded. Your data is safe. Try again; if the problem continues, contact support.",
    taxIdReadOnly: "The tax id identifies your office, so it cannot be changed here. To correct it, contact BatiFlow support.",
    notProvided: "Not provided",
    sections: {
      identity: {
        title: "Office identity",
        description: "This information appears on your official documents."
      },
      references: {
        title: "Professional references and language",
        description: "Optional, except the default language of the organisation's documents."
      }
    },
    fields: {
      professionalRegistration: {
        label: "Professional registration (optional)",
        hint: "For example the registration number with the order of engineers or architects."
      },
      agreementNumber: {
        label: "Agreement number (optional)",
        hint: "The approval number of your design office, if it has one."
      },
      defaultLocale: {
        label: "Default language of the organisation",
        hint: "Used for documents and messages sent on behalf of the office."
      }
    },
    readOnly: {
      title: "Organisation profile",
      description: "You can view this information. Only the owner and administrators can change it.",
      address: "Address"
    },
    logo: {
      title: "Logo",
      description: "The logo appears on your official documents. PNG, JPEG or WebP, 2 MB at most.",
      alt: "The organisation's current logo",
      none: "No logo yet.",
      loadFailed: "The logo could not be loaded.",
      choose: "Choose an image",
      remove: "Remove the logo",
      applying: "Applying the logo\u2026",
      saved: "The organisation's logo has been updated.",
      removed: "The logo has been removed.",
      errors: {
        type: "Choose a PNG, JPEG or WebP image.",
        tooLarge: "This image is larger than {max}. Choose a lighter image.",
        notReady: "The image is still being checked. Try again in a moment.",
        invalid: "This image is not accepted: choose a PNG, JPEG or WebP image of 2 MB at most.",
        targetFailed: "The logo folder is not available right now. Try again in a moment.",
        saveFailed: "The logo could not be saved. Try again.",
        removeFailed: "The logo could not be removed. Try again."
      }
    },
    directory: {
      title: "Visible in the BatiFlow directory",
      description: "Let other BatiFlow design offices find you, for example to invite you into a shared space.",
      switchLabel: "Show my office in the directory",
      on: "Your office is visible in the directory.",
      off: "Your office does not appear in the directory.",
      descriptionLabel: "Short presentation (optional)",
      descriptionHint: "One or two sentences about your office, in plain text (300 characters at most).",
      counter: "{count} / {max} characters",
      shownTitle: "What other offices see",
      shown: "Your office name, disciplines, governorate, city and this presentation.",
      notShown: "Never your members, contact details, tax id or address.",
      contactNote: "Another office can send you a message from the directory. It reaches the owners and administrators by e-mail, and the reply goes straight to them.",
      readOnly: "Only the owner and the administrators can change the visibility in the directory.",
      save: "Save",
      saving: "Saving\u2026",
      saved: "The directory settings are saved.",
      saveFailed: "The directory settings could not be saved.",
      loadFailedTitle: "The directory settings cannot be shown",
      loadFailedBody: "Try again; if the problem continues, contact support."
    }
  },
  policies: {
    title: "Policies",
    formLabel: "Organisation policies",
    noChange: "There is nothing to save.",
    saved: "The policies are saved.",
    stale: "Someone else changed the policies while you were editing them. Your changes were not saved: the latest version has just been reloaded, so please apply your changes again.",
    saving: "Saving\u2026",
    saveFailedTitle: "The policies could not be saved",
    loadFailedTitle: "Unable to show the policies",
    loadFailedBody: "The policies could not be loaded. Try again; if the problem continues, contact support.",
    stepUpNote: "For your security, saving will ask you to confirm your identity.",
    sharing: {
      title: "Sharing with outsiders",
      description: "Sets how your office works with partners, clients and other offices.",
      requireApproval: {
        label: "Approval required to join an external space",
        hint: "When this is on, a member can join another organisation's space only once an administrator has agreed.",
        seeRequests: "See the pending requests"
      },
      managersCanShare: {
        label: "Project managers can share",
        hint: "When this is on, project managers can open their projects' space to partners. Otherwise only the owner and administrators can."
      },
      domains: {
        label: "Allowed domains for guests",
        hint: "Type a domain, for example client.tn, then press Enter. External guests can then only come from these domains.",
        placeholder: "client.tn",
        add: "Add",
        empty: "No domain: guests can come from any e-mail address.",
        listLabel: "Allowed domains",
        remove: "Remove {domain}",
        errors: {
          empty: "Type a domain, for example client.tn.",
          invalid: 'This domain is not valid. Type it without "@" or spaces, for example client.tn.',
          duplicate: "This domain is already in the list.",
          limit: "The list cannot hold more than {max} domains."
        }
      }
    },
    security: {
      title: "Sign-in security",
      description: "Sets how long sessions last and how much protection every member must use.",
      sessionHours: {
        label: "Maximum length of a session",
        hint: "After this time the member must sign in again, even if they are active.",
        default: "Platform default (12 hours)",
        option: "{count, plural, one {# hour} other {# hours}}"
      },
      mfaForAll: {
        label: "Two-step verification for all members",
        hint: "When this is on, every member must set up an authenticator app at their next sign-in; without it they can no longer use BatiFlow. The owner, administrators and accountants already have to."
      }
    }
  },
  fiscal: {
    title: "Fiscal profile",
    loadFailedTitle: "Unable to show the fiscal profile",
    loadFailedBody: "The fiscal profile could not be loaded. Your data is safe. Try again; if the problem continues, contact support.",
    empty: {
      title: "No fiscal profile yet",
      description: "The fiscal profile sets the VAT, the tax regime, the withholding tax and the bank details of your invoices."
    },
    current: {
      title: "Version in force",
      description: "These values apply to new invoices."
    },
    history: {
      title: "Version history",
      description: "A new version never changes the old ones: issued invoices keep the version that was in force.",
      caption: "Fiscal profile versions, newest first"
    },
    columns: {
      effectiveFrom: "In force since",
      status: "Status",
      createdBy: "Created by",
      vat: "VAT",
      regime: "Tax regime",
      withholding: "Status for withholding tax",
      footer: "Invoice footer",
      bank: "Bank details"
    },
    status: {
      current: "In force",
      scheduled: "Scheduled",
      past: "Earlier"
    },
    values: {
      vatYes: "Registered for VAT",
      vatNo: "Not registered for VAT",
      noFooter: "None"
    },
    regimes: {
      real: "Real regime",
      flat_rate: "Flat-rate regime"
    },
    withholding: {
      legal_entity: "Legal entity",
      real_regime: "Individual under the real regime",
      other: "Other"
    },
    bank: {
      none: "None",
      show: "Show full RIB",
      hide: "Hide",
      rib: "RIB",
      iban: "IBAN",
      copyRib: "Copy the RIB",
      copyIban: "Copy the IBAN",
      copied: "Copied to the clipboard.",
      copyFailed: "Copying did not work. Select the number and copy it by hand.",
      stepUp: 'Confirm your identity in the window that just opened, then click "Show full RIB" again.',
      loading: "Loading\u2026"
    },
    newVersion: {
      button: "New version",
      title: "New version of the fiscal profile",
      intro: "The values of the version in force are kept: change only what is different. The previous version is kept.",
      start: {
        legend: "Start of application",
        now: "Right now",
        later: "On a later date",
        date: "Start date"
      },
      vat: {
        label: "Registered for VAT"
      },
      withholdingHint: "Decides the withholding tax that applies to your invoices.",
      footerHint: "Text shown at the bottom of your invoices (legal notices, payment terms\u2026).",
      bank: {
        legend: "Bank details (optional)",
        hint: "They are not carried over from the previous version: enter them again, or leave them empty for a version without bank details.",
        name: "Bank name",
        rib: "RIB",
        ribHint: '20 digits, without the "TN59" prefix.'
      },
      stepUpNote: "For your security, saving will ask you to confirm your identity.",
      saving: "Saving\u2026",
      submit: "Create the version",
      done: "The new fiscal profile version is in force.",
      doneLater: "The new fiscal profile version is scheduled.",
      errors: {
        dateRequired: "Choose the start date.",
        datePast: "The start date cannot be in the past.",
        footerTooLong: "The footer cannot exceed {max} characters.",
        bankNameRequired: "Type the bank name.",
        bankNameTooLong: "The bank name cannot exceed {max} characters.",
        ribInvalid: "A RIB has 20 digits. Check it and try again."
      }
    },
    series: {
      title: "Invoice numbering series",
      description: "Each series has its own gap-free counter. The default series is suggested on new invoices.",
      caption: "Invoice numbering series",
      add: "Add a series",
      addTitle: "Add an invoice series",
      editTitle: "Edit series {code}",
      codeHint: "1 to 10 letters or digits, for example FAC. The code cannot be changed afterwards.",
      codeFixed: "The code cannot be changed: numbers already issued refer to it.",
      prefixHint: 'Start of every number, for example "FAC-".',
      resetYearly: {
        label: "Restart the numbering every year",
        hint: "When this is on, the counter goes back to 1 at the start of each year."
      },
      makeDefault: "Default series",
      saving: "Saving\u2026",
      created: "Series {code} is added.",
      updated: "Series {code} is updated.",
      stale: "Someone else changed this series. The list has just been reloaded: check it, then try again.",
      nowDefault: "Series {code} is now the default series.",
      deleted: "Series {code} is deleted.",
      deleteTitle: "Delete series {code}?",
      deleteBody: "This series will no longer be offered. This cannot be undone.",
      resetYes: "Every year",
      resetNo: "Never",
      defaultBadge: "Default",
      emptyTitle: "No invoice series",
      emptyDescription: "Add a series to number your invoices.",
      loadFailedTitle: "Unable to show the series",
      loadFailedBody: "The invoice series could not be loaded. Try again; if the problem continues, contact support.",
      columns: {
        code: "Code",
        prefix: "Prefix",
        resetYearly: "Reset",
        default: "Default series",
        actions: "Actions"
      },
      actions: {
        open: "Actions for series {code}",
        edit: "Edit",
        makeDefault: "Make default",
        delete: "Delete"
      },
      errors: {
        codeInvalid: "The code has 1 to 10 letters or digits, with no spaces or accents.",
        codeTaken: "Another series already uses this code. Choose a different one.",
        prefixRequired: "Type the prefix of the numbers.",
        prefixTooLong: "The prefix cannot exceed {max} characters.",
        isDefault: "The default series cannot be deleted. Make another series the default first."
      }
    }
  },
  auditLog: {
    title: "Audit log",
    tableCaption: "Audit log events, newest first",
    financeOnly: "As an accountant you only see finance events: invoices, quotes, contracts, payments, expenses and fiscal settings. Other events are reserved for the owner and administrators.",
    loadFailedTitle: "Unable to show the log",
    loadFailedBody: "The audit log could not be loaded. Try again; if the problem continues, contact support.",
    loadMore: "Show more events",
    loadingMore: "Loading\u2026",
    columns: {
      when: "Date and time",
      actor: "Done by",
      action: "Action",
      resource: "Item concerned"
    },
    actorTypes: {
      user: "Unknown user",
      system: "BatiFlow system",
      platform_admin: "BatiFlow support"
    },
    actions: {
      unknown: "Recorded action",
      auth_logged_in: "Sign-in",
      auth_logged_out: "Sign-out",
      auth_stepped_up: "Identity confirmation",
      auth_mfa_changed: "Two-step verification changed",
      auth_session_revoked: "Session signed out",
      organization_created: "Organisation created",
      organization_updated: "Organisation profile changed",
      organization_policy_changed: "Organisation policies changed",
      membership_invited: "Member invited",
      membership_joined: "Member joined the organisation",
      membership_role_changed: "Member's role changed",
      membership_deactivated: "Member deactivated",
      membership_invitation_resent: "Invitation sent again",
      membership_invitation_revoked: "Invitation cancelled",
      organization_owner_transfer_proposed: "Ownership transfer proposed",
      organization_owner_transfer_cancelled: "Ownership transfer cancelled",
      organization_owner_transferred: "Organisation ownership transferred",
      organization_fiscal_profile_created: "New fiscal profile version",
      organization_bank_details_viewed: "Bank details viewed in full",
      organization_invoice_series_changed: "Invoice series changed",
      client_created: "Client created",
      client_updated: "Client changed",
      client_archived: "Client archived",
      client_contact_changed: "Client contact changed",
      platform_break_glass_granted: "Exceptional support access granted",
      system_checked: "Technical check",
      quote_created: "Quote created",
      quote_updated: "Quote changed",
      quote_deleted: "Quote deleted",
      quote_sent: "Quote sent to the client",
      quote_accepted: "Quote accepted by the client",
      quote_rejected: "Quote declined",
      quote_converted: "Quote turned into a project",
      quote_fee_scale_created: "Fee scale added",
      quote_fee_scale_deleted: "Fee scale deleted",
      contract_created: "Contract created",
      contract_updated: "Contract changed",
      contract_amendment_added: "Amendment added",
      invoice_created: "Draft invoice created",
      invoice_updated: "Draft invoice changed",
      invoice_deleted: "Draft invoice deleted",
      invoice_issued: "Invoice issued",
      invoice_credited: "Credit note issued",
      invoice_transferred: "Draft invoices transferred",
      payment_recorded: "Payment recorded",
      payment_certificate_linked: "Withholding certificate attached",
      expense_submitted: "Expense submitted",
      expense_approved: "Expense approved",
      expense_rejected: "Expense declined",
      expense_reimbursed: "Expense reimbursed",
      invoice_reminders_changed: "Invoice reminders changed",
      organization_directory_updated: "Directory visibility changed",
      directory_contact_received: "Message received from the directory"
    },
    resources: {
      organization: "Organisation",
      membership: "Member",
      member_invitation: "Invitation",
      owner_transfer: "Ownership transfer",
      organization_fiscal_profile: "Fiscal profile",
      invoice_series: "Invoice series",
      client: "Client"
    },
    families: {
      organization: "Organisation and settings",
      membership: "Members and invitations",
      client: "Clients",
      auth: "Sign-ins and security",
      invoice: "Invoices",
      quote: "Quotes",
      contract: "Contracts",
      payment: "Payments",
      expense: "Expenses"
    },
    filters: {
      label: "Log filters",
      actor: "Done by",
      allActors: "Everyone",
      action: "Type of action",
      allActions: "All actions",
      from: "From",
      to: "To",
      clear: "Clear the filters"
    },
    empty: {
      title: "No events yet",
      description: "Your office's sensitive actions will appear here as soon as they happen.",
      filteredTitle: "No event matches",
      filteredDescription: "Try other filters or a wider period."
    },
    verify: {
      title: "Log integrity",
      description: "Reserved for the owner.",
      intro: "Each event is linked to the previous one by a fingerprint. The check recomputes this chain and reports whether an event was changed, removed or moved.",
      button: "Verify integrity",
      running: "Checking\u2026",
      okTitle: "The log is intact",
      okBody: "No change or removal detected. Checked on",
      brokenTitle: "The log has been tampered with",
      brokenBody: "The log's chain is broken from event no. {position}: {reason}. Keep this screen and contact BatiFlow support right away.",
      failedTitle: "The check did not complete",
      reasons: {
        content_modified: "the content of an event was changed afterwards",
        sequence_gap: "one or more events are missing from the sequence",
        link_broken: "the link between two events is broken",
        unknown: "an inconsistency was detected"
      }
    }
  },
  meNav: {
    profile: "Profile",
    security: "Security",
    notifications: "Notifications"
  },
  meProfile: {
    title: "My profile",
    saving: "Saving\u2026",
    errors: {
      nameRequired: "Type your name.",
      nameTooLong: "The name cannot exceed {max} characters."
    },
    identity: {
      title: "Identity",
      description: "Your name as your colleagues see it.",
      name: "Display name",
      email: "E-mail address",
      emailHint: "The e-mail address is managed by your BatiFlow account: it cannot be changed here.",
      saved: "Your name is saved."
    },
    region: {
      title: "Language and region",
      description: "Each choice is saved as soon as you make it.",
      language: {
        label: "Interface language",
        hint: "The change applies immediately, including the reading direction for Arabic.",
        saved: "Your language is saved."
      },
      timeZone: {
        label: "Time zone",
        hint: "Dates and times are shown in this time zone.",
        saved: "Your time zone is saved."
      },
      digits: {
        legend: "Digits of the Arabic interface",
        hint: "Applies only when the interface is in Arabic.",
        latn: "Latin digits (0123456789)",
        arab: "Arabic-Indic digits (\u0660\u0661\u0662\u0663\u0664\u0665\u0666\u0667\u0668\u0669)",
        saved: "Your digit choice is saved."
      }
    },
    appearance: {
      title: "Appearance",
      description: "This choice stays on this device: it is not saved on your account.",
      theme: "Theme"
    }
  },
  meNotifications: {
    title: "My notifications",
    formLabel: "Notification preferences",
    noChange: "There is nothing to save.",
    saved: "Your notification preferences are saved.",
    stale: "Your preferences were changed elsewhere while you were editing them. Your changes were not saved: the current preferences have just been reloaded, so please apply your changes again.",
    saving: "Saving\u2026",
    saveFailedTitle: "The preferences could not be saved",
    loadFailedTitle: "Unable to show your preferences",
    loadFailedBody: "Your notification preferences could not be loaded. Try again; if the problem continues, contact support.",
    reset: "Restore the defaults",
    resetNote: "Restoring the defaults only fills in the form: nothing changes until you save.",
    channels: {
      inApp: "In the app",
      email: "By e-mail",
      push: "Push notification",
      pushLater: "Mobile app, coming later"
    },
    emailModes: {
      off: "Never",
      immediate: "Immediately",
      digest: "In the digest"
    },
    groups: {
      conversations: "Conversations",
      tasks: "Tasks",
      approvals: "Approvals and sign-offs",
      external: "Partners and external spaces",
      security: "Security",
      finance: "Billing and subscription",
      calendar: "Calendar",
      meetings: "Meetings and calls",
      planning: "Time and planning",
      tenders: "Tenders and document vault",
      signatures: "Electronic signatures"
    },
    types: {
      mention: "You are mentioned",
      reply: "Reply to one of your messages",
      task_assigned: "A task is assigned to you",
      task_due: "A task is coming due",
      task_overdue: "A task is overdue",
      phase_due: "A phase reaches its planned end date",
      phase_overdue: "A phase is overdue",
      approval_requested: "An approval request is waiting for you",
      approval_decided: "Decision on an approval you requested",
      space_invitation: "Invitation to a shared space",
      partnership_request: "Partnership request",
      access_revoked: "Your access to a space is removed",
      einvoice_status: "Result of an e-invoice (TTN)",
      payment_received: "Payment received",
      plan_limit: "Your plan limit is reached",
      event_reminder: "A calendar event is coming up",
      quote_accepted: "A client accepts one of your quotes",
      invoice_suggested: "A closed phase can be invoiced",
      bond_release_due: "A performance bond can soon be released",
      expense_submitted: "An expense waits for your approval",
      expense_decided: "Your expense is approved or declined",
      subscription_status: "Your BatiFlow subscription status (renewal, unpaid, read-only)",
      data_export: "The organisation\u2019s data export is ready to download (or failed)",
      organization_deletion: "The organisation\u2019s deletion is scheduled or cancelled",
      meeting_started: "A meeting you can join has started",
      meeting_invited: "You are invited to a meeting",
      call_missed: "A call nobody answered",
      minutes_published: "The minutes of a meeting you attended are published",
      timesheet_reminder: "Friday reminder to submit your timesheet",
      phase_deadline: "A phase\u2019s contractual deadline is near or past",
      vault_expiring: "A vault document (certificate, insurance\u2026) expires within 30 days",
      time_budget: "A phase of your projects has used 80% of its time budget",
      signature_requested: "A member asks you to sign a document",
      signature_update: "Your signature requests are signed or declined"
    },
    matrix: {
      title: "What, and where",
      description: "For each type of notification, choose whether you see it in the app and whether you receive it by e-mail.",
      region: "Notification preferences table",
      caption: "Notification preferences by type and channel",
      type: "Notification",
      cell: "{type}: {channel}",
      alwaysOn: "This important notice always stays on in the app."
    },
    digest: {
      title: "E-mail digest",
      description: 'The digest groups the notifications set to "In the digest" into a single e-mail. It is only sent when a frequency is chosen.',
      label: "Digest frequency",
      options: {
        off: "No digest",
        hourly: "Every hour",
        daily: "Every day"
      },
      warningTitle: "The digest is off",
      warningBody: 'Some notifications are set to "In the digest", but no digest is sent: they will only stay in the app. Choose a frequency to receive them by e-mail.'
    },
    quietHours: {
      title: "Quiet hours",
      description: "During these hours you do not receive notification e-mails; they reach you afterwards. The hours are in your time zone.",
      enable: "Turn on quiet hours",
      start: "Start",
      end: "End",
      invalid: "The start and the end must be two different times."
    },
    ring: {
      title: "Call ringtone",
      description: "Plays a ringtone on this device when someone calls you. This setting is not shared with your other devices.",
      label: "Call ringtone"
    }
  },
  documentSettings: {
    title: "Documents",
    formLabel: "Document settings",
    loadFailedTitle: "The document settings cannot be shown",
    loadFailedBody: "The settings could not be loaded. Try again; if the problem continues, contact support.",
    pattern: {
      title: "Document code pattern",
      description: "Every document gets a code built from this pattern: it identifies the document on drawings, letters and transmittals.",
      label: "Pattern",
      hint: "Capital letters, digits and the signs - _ . only. The elements {num} and {idx} are required."
    },
    legend: {
      label: "Pattern elements",
      PROJECT: "Project code",
      PHASE: "Phase (ESQ, APS, APD\u2026)",
      DISC: "Discipline (ARC, STR, VRD\u2026)",
      TYPE: "Document type (PLN, NDC, RAP\u2026)",
      NUM: "Sequence number, assigned by BatiFlow",
      IDX: "Revision index (A, B\u2026 or 0, 1\u2026)",
      ZONE: "Zone or building, when given"
    },
    example: {
      label: "Example code",
      invalid: "The pattern is not valid yet: no example.",
      sample: "For a structure drawing of the APS phase, first document, zone RDC."
    },
    problems: {
      length: "The pattern must be 5 to 100 characters long.",
      characters: "Use only capital letters, digits, the signs - _ . and elements between braces.",
      unknownToken: "An element between braces is not recognised: see the list below.",
      braces: "The braces are not balanced.",
      needsNumberAndIndex: "The pattern must contain the elements {num} and {idx}."
    },
    serverRefused: "The pattern was not accepted: it must contain {num} and {idx}, and only known elements.",
    index: {
      title: "Revision index style",
      description: "The index given to each new version of a document.",
      letters: "Letters: A, B, C\u2026",
      numbers: "Digits: 0, 1, 2\u2026"
    },
    noChange: "Nothing to save.",
    saved: "The document settings are saved.",
    saving: "Saving\u2026",
    saveFailedTitle: "The settings could not be saved",
    existingCodes: "Codes already assigned do not change: the new pattern applies to new documents and to those whose information is edited.",
    readOnly: "Only people allowed to edit the organisation can change these settings."
  },
  storage: {
    title: "Storage",
    loadFailedTitle: "Storage usage could not be loaded",
    loadFailedBody: "Check your connection, then try again.",
    usage: {
      title: "Space used",
      description: "All the files of your projects, including earlier versions.",
      summary: "{used} used of {quota}",
      unlimited: "{used} used. Your contract sets no space limit.",
      percent: "{percent} of the space is used",
      barLabel: "Storage space used",
      notes: {
        warning: "You have used more than 80% of your space. Consider deleting files you no longer need or buying storage.",
        critical: "Less than 5% of your space is left. Free some space or buy storage before adding files is refused.",
        full: "Your space is full: new files are refused. Free some space or buy storage."
      }
    },
    buy: {
      label: "Buy storage",
      note: "Buying storage will be available with billing, which comes later."
    },
    spaces: {
      title: "Storage per project",
      description: "Size of each project\u2019s files and when that size was last calculated.",
      caption: "Storage per project",
      columns: {
        name: "Project or space",
        size: "Size",
        reconciledAt: "Last calculated"
      },
      never: "Not calculated yet",
      empty: {
        title: "No files yet",
        description: "The size of each project will show here once it holds files."
      }
    },
    files: {
      title: "The 10 largest files",
      description: "The current files that take the most space. Deleting or replacing a file you no longer need frees space.",
      caption: "The ten largest files",
      columns: {
        code: "Code",
        title: "Title",
        size: "Size"
      },
      noCode: "No code",
      empty: {
        title: "No files yet",
        description: "The largest files will show here."
      }
    }
  },
  realtime: {
    accessRevoked: {
      space: "You no longer have access to this space. We took you back to the project list.",
      organization: "You no longer have access to this office. We took you back to the home page."
    }
  },
  guest: {
    badge: "Guest",
    navLabel: "Guest navigation",
    nav: {
      spaces: "My spaces",
      invitations: "Invitations"
    }
  },
  finance: {
    nav: {
      label: "Finance sections"
    },
    empty: {
      quotes: {
        title: "No quotes yet",
        body: "Your office\u2019s quotes will appear here."
      },
      contracts: {
        title: "No contracts yet",
        body: "Contracts signed with your clients will appear here."
      },
      invoices: {
        title: "No invoices yet",
        body: "Your invoices and their sending status will appear here."
      },
      payments: {
        title: "No payments recorded",
        body: "Payments received from your clients will appear here."
      },
      expenses: {
        title: "No expenses yet",
        body: "Your expense claims will appear here."
      },
      suppliers: {
        title: "No suppliers yet",
        body: "Your suppliers and subcontractors will appear here."
      },
      supplierInvoices: {
        title: "No supplier invoices",
        body: "Invoices received from your suppliers will appear here."
      },
      withholding: {
        title: "No withholding to show",
        body: "The month's withholding and the TEJ exports will appear here."
      },
      accounting: {
        title: "No export yet",
        body: "Accounting exports and closed months will appear here."
      },
      dashboard: {
        title: "No indicators yet",
        body: "Your office\u2019s key finance figures will appear here."
      },
      management: {
        title: "No management figures yet",
        body: "Your office\u2019s management figures will appear here."
      },
      treasury: {
        title: "No forecast yet",
        body: "Cash expected over 90 days will appear here."
      },
      profitability: {
        title: "No profitability to show yet",
        body: "Your projects\u2019 margins will appear here."
      },
      costRates: {
        title: "No cost rates",
        body: "Your team\u2019s cost rates will appear here."
      },
      einvoicing: {
        title: "No certificate yet",
        body: "The electronic invoicing mode and your signing certificates will appear here."
      }
    }
  },
  billing: {
    locked: {
      read_only: {
        owner: "Your office's account is read-only. Settle the subscription to create and edit again.",
        member: "Your office's account is read-only. Ask the owner of your office to settle the subscription."
      },
      suspended: {
        owner: "Your office's account is suspended. Settle the subscription to reactivate it.",
        member: "Your office's account is suspended. Ask the owner of your office to settle the subscription."
      }
    },
    banner: {
      trial_ending: {
        title: "Your trial ends soon",
        body: "{count, plural, =0 {Your trial ends today, {date}.} one {{n} day of trial left, until {date}.} other {{n} days of trial left, until {date}.}}",
        owner: "Choose a plan to keep full access to your office.",
        member: "Ask the owner of your office to choose a plan."
      },
      read_only_trial: {
        title: "Your trial has ended",
        body: "Your office is read-only: you can view and export your data, but not create or edit anything.",
        owner: "Choose a plan and pay the invoice to unlock everything.",
        member: "Ask the owner of your office to choose a plan."
      },
      read_only_unpaid: {
        title: "Your office is read-only",
        body: "The subscription has not been paid: you can view and export your data, but not create or edit anything.",
        owner: "Settle the subscription to unlock everything.",
        member: "Ask the owner of your office to settle the subscription."
      },
      suspended: {
        title: "Your office is suspended",
        body: "Your office is suspended for non-payment. You can still export your data; if the subscription stays unpaid, it will eventually be deleted.",
        owner: "Settle the subscription to reactivate your office.",
        member: "Ask the owner of your office to settle the subscription."
      },
      past_due: {
        title: "A payment is late",
        body: "Your subscription invoice has been unpaid since {date}. Without payment, the office will become read-only.",
        owner: "Pay the invoice to avoid any interruption.",
        member: "Ask the owner of your office to settle the subscription."
      },
      paused: {
        title: "Your subscription is paused",
        body: "The subscription is paused until {date}.",
        owner: "Resume it whenever you need it.",
        member: "Ask the owner of your office to resume it."
      },
      cancelling: {
        title: "Your subscription is about to end",
        body: "The subscription ends on {date}; the office will then become read-only.",
        owner: "Changed your mind? You can withdraw the cancellation before that date.",
        member: "Ask the owner of your office if you want to keep it."
      },
      cancelled: {
        title: "Your subscription is cancelled",
        body: "The subscription ended on {date}: your office is read-only. You can still view and export your data.",
        owner: "Choose a plan to reactivate everything.",
        member: "Ask the owner of your office to subscribe again."
      },
      action: {
        choose: "Choose a plan",
        pay: "Pay the invoice",
        resume: "Resume",
        withdraw: "Withdraw the cancellation",
        view: "View the subscription"
      }
    }
  },
  subscription: {
    title: "Subscription",
    loadFailedTitle: "Could not load the subscription",
    loadFailedBody: "Check your connection and try again.",
    readOnlyNote: "You are viewing the subscription in read-only mode. Only the owner of the office can change it or pay the invoices.",
    enterpriseNote: "Your Enterprise plan is managed by contract. To change it, contact the BatiFlow sales team.",
    pay: "Pay",
    taxIncluded: "incl. tax",
    status: {
      trialing: "Trial",
      active: "Active",
      past_due: "Payment late",
      read_only: "Read-only",
      suspended: "Suspended",
      paused: "Paused",
      cancelled: "Cancelled"
    },
    plans: {
      solo: "Solo",
      starter: "Starter",
      pro: "Pro",
      business: "Business",
      enterprise: "Enterprise"
    },
    cycle: {
      monthly: "Monthly",
      annual: "Annual"
    },
    paymentMethods: {
      card: "Bank card",
      bank_transfer: "Bank transfer",
      cheque: "Cheque",
      online: "Online payment",
      transfer: "Bank transfer"
    },
    current: {
      title: "Your plan",
      description: "The plan, state and price of your BatiFlow subscription (prices exclude tax).",
      plan: "Plan",
      cycle: "Billing",
      period: "Current period",
      periodRange: "{start} to {end}",
      nextDue: "Next due date",
      noDue: "None",
      trialEnds: "Trial ends",
      price: "Price per period (excl. tax)",
      onQuote: "On quote",
      perPeriod: {
        monthly: "per month",
        annual: "per year"
      },
      extras: "Options",
      noExtras: "No options",
      extraSeatsValue: "{count, plural, one {{n} extra seat} other {{n} extra seats}}",
      addonValue: "{count, plural, one {{n} \xD7 {size} of storage} other {{n} \xD7 {size} of storage}}",
      payment: "Payment method",
      paymentNone: "Not chosen yet",
      paymentHelp: "Each invoice is paid online by bank card, or by bank transfer or cheque, in which case the BatiFlow team confirms receipt of the payment."
    },
    openInvoice: {
      title: "Invoice {number} is waiting for payment",
      body: "Amount due:"
    },
    pending: {
      title: "A change is planned",
      scheduled: "On {date}, your subscription will move to the {plan} plan ({cycle}).",
      pause: "From {date}, your subscription will be paused for {count, plural, one {{n} month} other {{n} months}}.",
      cancel: "Your subscription will be cancelled on {date}.",
      withdraw: "Withdraw this change",
      withdrawn: "The planned change has been withdrawn."
    },
    usage: {
      title: "Usage",
      description: "What your office uses, compared with the limits of your plan.",
      seats: "Seats",
      storage: "Storage",
      hostedSpaces: "Hosted shared spaces",
      of: "{used} of {limit}",
      unlimitedOf: "{used} (no limit)",
      percent: "{percent}%"
    },
    compare: {
      title: "Compare plans",
      description: "Prices exclude tax. The annual subscription costs 10 months instead of 12.",
      caption: "Comparison of the BatiFlow plans",
      loading: "Loading the plans\u2026",
      failed: "Could not load the plans right now.",
      current: "Your plan",
      monthly: "Monthly price (excl. tax)",
      annual: "Annual price (excl. tax)",
      seats: "Seats included",
      extraSeat: "Extra seat (per month)",
      storage: "Storage included",
      hostedSpaces: "Hosted shared spaces",
      meetingParticipants: "Participants per meeting",
      unlimited: "Unlimited",
      byContract: "By contract",
      onQuote: "On quote",
      notOffered: "Not offered",
      enterprise: "The Enterprise plan is sold on quote: contact the BatiFlow sales team."
    },
    change: {
      button: "Change subscription",
      title: "Change the subscription",
      intro: "Choose the plan, the billing period and the options. The price is shown before you confirm anything.",
      plan: "Plan",
      planOnQuote: "{plan} (on quote)",
      cycle: "Billing",
      cycleHint: "Annual: 10 months paid for 12.",
      extraSeats: "Extra seats",
      noExtraSeats: "This plan does not offer extra seats.",
      addon: "Extra storage {size}",
      stepUpNote: "To confirm the change, you will need to verify your identity.",
      confirm: "Confirm the change",
      confirmPay: "Confirm and receive the invoice",
      confirming: "Sending\u2026",
      scheduledDone: "Change scheduled: it will apply on {date}."
    },
    quote: {
      title: "Price preview",
      loading: "Calculating the price\u2026",
      unchanged: "Choose another plan or other options to see the price.",
      caption: "Price breakdown",
      columns: {
        label: "Item",
        quantity: "Qty",
        unitPrice: "Unit price",
        amount: "Amount"
      },
      totalHt: "Total excl. tax",
      totalTtc: "Total incl. tax",
      kind: {
        start: "Your paid subscription starts. An invoice is issued now; the change applies as soon as it is paid. New period: {start} to {end}.",
        upgrade: "A prorated invoice ({remaining} days left out of {total}) is issued now; the change applies as soon as it is paid.",
        restart: "Your subscription restarts. An invoice is issued now; it resumes as soon as it is paid. New period: {start} to {end}.",
        scheduled: "No payment now. The change will apply on {date}, at the end of the current period.",
        none: "No change: this choice is the one of your current subscription."
      },
      lines: {
        plan: "Plan",
        extra_seats: "Extra seats",
        addon: "Extra storage {size}",
        proration: "Prorated adjustment",
        credit_unused: "Credit for the unused period",
        pause: "Pause (20% of the price)",
        fair_billing: "Fair-billing credit"
      },
      blockedTitle: "This plan is too small for your current usage. To choose it:",
      blockers: {
        seats: "Reduce the seats from {used} to {limit}.",
        storage: "Free up storage: {used} used for {limit} available.",
        hosted_spaces: "Reduce the hosted shared spaces from {used} to {limit}."
      },
      reduce: {
        seats: "Reduce the number of seats in use.",
        storage: "Free up storage.",
        hostedSpaces: "Reduce the number of hosted shared spaces."
      }
    },
    invoiceIssued: {
      title: "Invoice {number} issued",
      amount: "Amount due:",
      later: "Later",
      applies: {
        start: "The change applies as soon as the invoice is paid.",
        upgrade: "The change applies as soon as the invoice is paid.",
        restart: "The subscription resumes as soon as the invoice is paid.",
        renewal: "The renewal is confirmed as soon as the invoice is paid.",
        resume: "The subscription resumes as soon as the invoice is paid."
      }
    },
    invoices: {
      title: "Subscription invoices",
      description: "The invoices BatiFlow has issued to you. Open invoices can be paid online.",
      caption: "BatiFlow subscription invoices",
      columns: {
        number: "Number",
        purpose: "Purpose",
        issueDate: "Issued on",
        dueDate: "Due by",
        total: "Total incl. tax",
        status: "Status",
        actions: "Actions"
      },
      purpose: {
        start: "Subscription start",
        upgrade: "Plan change",
        restart: "Restart",
        renewal: "Renewal",
        resume: "Resumption after pause"
      },
      status: {
        open: "To pay",
        paid: "Paid",
        void: "Cancelled"
      },
      pdf: "PDF",
      pdfFor: "Download the PDF of invoice {number}",
      payFor: "Pay invoice {number}",
      loadFailedTitle: "Could not load the invoices",
      empty: {
        title: "No invoices yet",
        description: "Your subscription invoices will appear here."
      }
    },
    actions: {
      title: "Manage the subscription",
      description: "Renew, pause or cancel. These actions are reserved for the owner of the office.",
      renew: {
        title: "Renew now",
        hint: "Your current period ends on {date}. Renew now to receive the invoice for the next period.",
        button: "Renew",
        confirmTitle: "Renew the subscription?",
        confirmBody: "A renewal invoice is issued now for the period that follows {date}. You can pay it right away.",
        confirm: "Renew"
      },
      pause: {
        title: "Pause",
        hint: "{count, plural, one {You have {n} month of pause left this year (3 at most).} other {You have {n} months of pause left this year (3 at most).}} During the pause, you pay 20% of the price.",
        none: "You have used the 3 months of pause allowed this year.",
        duration: "Length of the pause",
        option: "{count, plural, one {{n} month} other {{n} months}}",
        button: "Pause",
        confirmTitle: "Pause the subscription?",
        confirmBody: "The pause starts at the end of the current period ({date}) and lasts {count, plural, one {{n} month} other {{n} months}}. You pay 20% of the price for these months when you resume. You can resume whenever you like.",
        confirm: "Pause",
        done: "Pause scheduled from {date}."
      },
      resume: {
        title: "Resume the subscription",
        hint: "Your subscription is paused until {date}. You can resume it earlier.",
        hintNoDate: "Your subscription is paused. Resume it whenever you like.",
        button: "Resume",
        confirmTitle: "Resume the subscription?",
        confirmBody: "An invoice is issued now: the paused months at 20% of the price, plus a new period. The subscription resumes as soon as it is paid.",
        confirm: "Resume"
      },
      cancel: {
        title: "Cancel the subscription",
        hint: "The cancellation takes effect at the end of the current period, on {date}.",
        button: "Cancel subscription",
        confirmTitle: "Cancel the subscription?",
        confirmBody: "Your subscription stays active until {date}, then it ends.",
        afterwards: "After that, your office becomes read-only for 90 days: you can view and export your data. After that delay, it is deleted. As long as the period has not ended, you can withdraw the cancellation.",
        confirm: "Cancel the subscription",
        done: "Cancellation scheduled: the subscription will end on {date}."
      }
    }
  },
  dataExport: {
    columns: {
      requestedAt: "Requested on",
      scope: "Type",
      requestedBy: "Requested by",
      status: "Status",
      size: "Size",
      expiresAt: "Available until",
      actions: "Actions"
    },
    scope: {
      organization: "Full",
      finance: "Finance"
    },
    status: {
      queued: "Queued",
      running: "Being prepared",
      ready: "Ready",
      failed: "Failed",
      expired: "Expired"
    },
    download: "Download",
    downloadFor: "Download the export requested on {date}",
    none: "Not available"
  },
  adminData: {
    title: "Data and deletion",
    loadFailedBody: "Check your connection and try again.",
    export: {
      title: "Export the data",
      descriptionFull: "A full export gathers all the data of the organisation in one file.",
      descriptionFinance: "Your role lets you export the financial data of the organisation only. The full export is reserved for the owner and the administrators.",
      contents: {
        tables: "Every data table, as JSON.",
        documents: "The documents, kept in their folders.",
        pdfs: "The PDFs generated by BatiFlow.",
        finance: "The financial data of the organisation, and nothing else."
      },
      retention: "The ZIP file is kept for 7 days, then deleted.",
      notification: "The person who asks for the export is notified as soon as it is ready.",
      buttonFull: "Prepare a full export",
      buttonFinance: "Prepare a finance export",
      requested: "Your export is being prepared. You will be notified when it is ready.",
      caption: "Data exports of the organisation",
      loadFailedTitle: "Could not load the exports",
      empty: {
        title: "No export yet",
        description: "Prepare an export to get a copy of the data of the organisation."
      }
    },
    delete: {
      title: "Delete the organisation",
      description: "This action is final. Read the following before you continue.",
      points: {
        delay: "Deletion takes place 90 days after your request. Until then, you can cancel it.",
        irreversible: "It cannot be undone: all the data and files of the organisation are erased, and the accounts of people who belong to no other organisation are closed.",
        kept: "What is kept: the name and tax ID of the organisation (for the deletion certificate) and the audit log for 3 years.",
        export: "Before you start, prepare a full export to keep a copy of your data."
      },
      button: "Delete the organisation",
      loadFailedTitle: "Could not load the deletion status",
      running: {
        title: "Deletion is in progress",
        body: "The data of the organisation is being erased. It can no longer be stopped."
      },
      scheduled: {
        title: "Deletion is scheduled for {date}",
        by: "Requested by {name}.",
        reasons: {
          unpaid: "It was triggered because the subscription is not paid.",
          trial_expired: "It was triggered because the trial ended without a subscription.",
          cancelled: "It was triggered because the subscription was cancelled.",
          owner_request: "You can cancel it until it has started.",
          platform_admin: "It was decided by BatiFlow support."
        },
        payToStop: "Paying the subscription stops the deletion.",
        subscriptionLink: "Go to the subscription",
        cancel: "Cancel the deletion",
        cancelTitle: "Cancel the deletion of the organisation?",
        cancelBody: "The deletion planned for {date} will not take place. The organisation and its data stay as they are today.",
        cancelConfirm: "Yes, cancel the deletion",
        cancelKeep: "No, keep it scheduled",
        cancelled: "The deletion is cancelled."
      },
      dialog: {
        title: "Delete the organisation",
        intro: "You are asking for the permanent deletion of {name}. It will take place in 90 days.",
        exportRecent: "A full export less than 30 days old is ready (prepared on {date}). Remember to download it before the deletion.",
        exportNone: "No full export less than 30 days old is available. Prepare one in the \u201CExport the data\u201D section before you continue, or say below that you do not want one.",
        decline: "I do not want an export of my data",
        confirmLabel: "Type the legal name to confirm",
        confirmHint: "Copy it exactly: {name}",
        stepUpNote: "For your security, we will ask you to confirm your identity.",
        submit: "Schedule the deletion",
        done: "The deletion is scheduled.",
        errors: {
          mismatch: "This text is not the legal name of the organisation.",
          exportChoice: "Tick this box to continue without an export, or prepare a full export first."
        }
      }
    }
  },
  meData: {
    title: "My personal data",
    description: "Organic law no. 2004-63 gives you the right to access the personal data BatiFlow holds about you.",
    button: "Export my data",
    note: "You are notified when the export is ready. The table shows until when you can download it.",
    requested: "Your export is being prepared. You will be notified when it is ready.",
    caption: "My data exports",
    loadFailed: "Could not load your exports. Check your connection and try again.",
    empty: {
      title: "No export yet",
      description: "Ask for an export to receive a copy of your personal data."
    }
  },
  statusMessage: {
    title: "Status message",
    description: "Your colleagues see it next to your status ({max} characters at most).",
    label: "Your message",
    counter: "{length} / {max}",
    save: "Save",
    clear: "Clear the message",
    cancel: "Cancel",
    saved: "Your status message is saved.",
    cleared: "Your status message is cleared."
  },
  customRoles: {
    title: "Custom roles",
    intro: "Create roles specific to your office from a base role, then adjust the permissions one by one. This feature is included in the Business plan.",
    loading: "Loading roles\u2026",
    loadFailed: "The custom roles could not be loaded.",
    upsell: "Custom roles are included in the Business plan. Ask the account owner to upgrade to that plan to create your own roles.",
    empty: 'No custom roles yet. Use "New role" to create one.',
    caption: "Custom roles of your office",
    columns: {
      name: "Name",
      basedOn: "Based on",
      keys: "Permissions",
      members: "Members",
      invitations: "Pending invitations",
      actions: "Actions"
    },
    new: "New role",
    actions: {
      edit: "Edit role {name}",
      editShort: "Edit",
      delete: "Delete role {name}",
      deleteShort: "Delete",
      inUse: "Role still in use (members: {members}, invitations: {invitations}). Change their role first to be able to delete it."
    },
    create: {
      title: "New custom role",
      intro: "Choose a name and the base role. You will then set the permissions in the editor.",
      name: "Role name",
      basedOn: "Based on",
      basePlaceholder: "Choose a base role",
      nameRequired: "Enter a name for this role.",
      baseRequired: "Choose the base role.",
      submit: "Create and set permissions",
      saving: "Creating\u2026"
    },
    editor: {
      title: "Role {name}",
      intro: 'Role based on "{base}". Turn each permission on or off.',
      reset: "Reset to base role",
      count: "Permissions on: {total}",
      locked: "Follows the base role: this permission cannot be changed.",
      notHeld: "You do not hold this permission",
      save: "Save",
      saving: "Saving\u2026",
      saved: 'Role "{name}" saved.',
      stale: 'Role "{name}" was changed by someone else. The list is reloaded: reopen the role and apply your changes again.'
    },
    delete: {
      title: 'Delete role "{name}"?',
      body: "This role will be permanently deleted. No member or invitation uses it.",
      confirm: "Delete",
      done: 'Role "{name}" deleted.',
      inUse: "This role is still given to members or pending invitations. Change their role first.",
      stale: "This role was changed meanwhile. The list is reloaded: try again."
    },
    escalation: "You cannot grant permissions you do not hold yourself: {keys}.",
    stepUpNote: "For your security, you will be asked to confirm your identity.",
    picker: {
      group: "Custom roles",
      hint: 'Custom role based on "{base}".'
    }
  },
  directory: {
    title: "Office directory",
    intro: "The BatiFlow design offices that chose to be listed. Write to them, or find them for a partnership.",
    searchLabel: "Search for an office",
    searchPlaceholder: "Office name",
    disciplineLabel: "Discipline",
    governorateLabel: "Governorate",
    allDisciplines: "All disciplines",
    allGovernorates: "All governorates",
    clear: "Clear filters",
    resultsLabel: "Offices in the directory",
    empty: {
      title: "No office in the directory yet",
      description: "Offices appear here when they choose to be visible."
    },
    emptyFiltered: {
      title: "No office matches",
      description: "Try another name or remove a filter."
    },
    loadFailedTitle: "The directory cannot be shown",
    loadFailedBody: "Try again; if the problem continues, contact support.",
    moreFailed: "The rest of the list could not be loaded. Try again.",
    more: "Show more",
    loadingMore: "Loading\u2026",
    location: "{governorate}, {city}",
    contact: {
      button: "Contact",
      buttonLabel: "Contact {name}",
      title: "Contact {name}",
      intro: "Your message is sent by e-mail to the owners and administrators of this office.",
      replyNote: "Their reply will come to your e-mail address. This office will see it.",
      subject: "Subject",
      message: "Message",
      counter: "{count} / {max} characters",
      send: "Send message",
      sending: "Sending\u2026",
      sent: "Your message was sent to {name}.",
      errors: {
        subjectRequired: "Enter the subject of your message.",
        messageRequired: "Write your message.",
        emailNotVerified: "Confirm your e-mail address first to write to an office.",
        notFound: "This office is no longer in the directory. Refresh the list.",
        rateLimited: "You have sent many messages. Try again in an hour."
      }
    },
    count: "{count, plural, =0 {No office} one {# office} other {# offices}}",
    countMore: "{count, plural, one {More than # office} other {More than # offices}}"
  },
  timesheets: {
    upgrade: {
      title: "Time tracking is not included in your plan",
      body: "Upgrade your plan to enter the team\u2019s hours, get weeks approved and follow the workload."
    },
    title: "Time",
    tabsLabel: "Time tracking sections",
    tabs: {
      week: "My week",
      approvals: "To approve",
      capacity: "Team workload",
      leave: "Leave"
    },
    duration: {
      h: "{h} h",
      hm: "{h} h {m}"
    },
    categories: {
      studies: "Studies",
      site: "Site",
      meeting: "Meeting",
      travel: "Travel",
      admin: "Administrative",
      other: "Other"
    },
    line: {
      noPhase: "No phase",
      phase: "Phase",
      name: "{project}, {phase}, {category}"
    },
    week: {
      navLabel: "Choose the week",
      prev: "Previous week",
      next: "Next week",
      today: "This week",
      label: "Week of {range}",
      total: "Week total:",
      totalOnly: "Week total:",
      outOf: "of",
      overCapacity: "Above the week\u2019s capacity",
      statusOpen: "Week being filled in",
      statusSubmitted: "Week submitted on {date}",
      lockedNotice: "This week is submitted: it cannot be changed until your managers have decided.",
      capacityUnknown: "This week\u2019s capacity is not known: the public holiday calendar for the year is missing."
    },
    empty: {
      title: "No line for this week",
      description: "Add a line (project, phase, category), then enter your hours day by day."
    },
    grid: {
      label: "Time entry for the week",
      line: "Project, phase and category",
      total: "Total",
      dayTotal: "Day total",
      help: "Arrow keys move between cells, Enter to type a duration (for example 7:30 or 7.5), Enter to confirm, Escape to cancel, Delete to clear. Durations go in quarter hours.",
      helpLocked: "The week is submitted: the cells are read-only.",
      cellLabel: "{where}: {value}",
      cellValue: "{duration}",
      cellEmpty: "no entry",
      editing: "editing",
      multiple: "several entries, not editable here",
      statuses: {
        draft: "draft",
        submitted: "submitted",
        approved: "approved",
        rejected: "rejected"
      },
      reason: "reason: {reason}",
      holiday: "Holiday: {name}",
      estimated: "estimated",
      leave: "Leave",
      removeLine: "Remove line {line}",
      invalid: {
        format: "Enter a duration such as 7:30, 7.5 or 2h30.",
        step: "Time is entered in quarter hours (15 minutes).",
        max: "A day cannot exceed 24 hours."
      },
      title: "Timesheet",
      legend: "Timesheet legend",
      legendStatuses: {
        draft: "Draft",
        submitted: "Submitted",
        approved: "Approved",
        rejected: "Rejected"
      },
      legendOff: "Weekend, holiday or leave",
      today: "Today"
    },
    addLine: {
      open: "Add a line",
      title: "New time line",
      add: "Add the line",
      noProjects: "You do not work on any project. Ask a project manager to add you to the team."
    },
    picker: {
      project: "Project",
      projectPlaceholder: "Choose a project",
      phase: "Phase (optional)",
      category: "Category"
    },
    submit: {
      button: "Submit the week",
      title: "Submit the week?",
      body: "You are submitting {total} for the week of {range}. Once submitted, the week cannot be changed until your managers have decided.",
      confirm: "Submit",
      done: "Week submitted."
    },
    rejected: {
      title: "Rejected entries",
      item: "{project}, {day} ({duration}): {reason}.",
      noReason: "no reason given",
      by: "Rejected by {name}.",
      hint: "Correct these entries, then submit the week again."
    },
    loadFailed: {
      title: "Unable to load the week",
      body: "Check your connection and try again."
    },
    timer: {
      title: "Timer",
      description: "Start the timer on a project. When you stop it, the time is rounded up to the next quarter hour and added to today.",
      start: "Start",
      stop: "Stop and add",
      discard: "Discard",
      elapsed: "Elapsed time: {time}",
      roundedTo: "Will be added:",
      added: "{duration} added to today.",
      unknownProject: "Project",
      running: "Running"
    },
    approvals: {
      description: "Submitted time entries on the projects you manage. Tick them to approve or reject them.",
      weekFilter: "Week",
      allWeeks: "All weeks",
      approve: "Approve the selection ({count})",
      reject: "Reject the selection ({count})",
      group: "{name}, week of {range}",
      selectGroup: "Select all entries of {group}",
      selectEntry: "Select the entry of {project} on {day}",
      project: "Project",
      date: "Date",
      category: "Category",
      note: "Note",
      duration: "Duration",
      rejectTitle: "Reject time entries",
      rejectBody: "You are rejecting {count} entry(ies). The person can correct them and submit their week again.",
      reasonLabel: "Reason for rejection (required)",
      reasonRequired: "Give the reason for the rejection (at least 3 characters).",
      confirmReject: "Reject",
      approved: "Entries approved: {count}.",
      rejected: "Entries rejected: {count}.",
      loadFailedTitle: "Unable to load the entries to approve",
      empty: {
        title: "Nothing to approve",
        description: "Time entries submitted on your projects will appear here."
      },
      summaryLabel: "Summary of the entries to approve",
      pending: "Pending entries",
      pendingCaption: "Submitted on your projects",
      hours: "Time to approve",
      hoursCaption: "Total of the pending entries",
      people: "People",
      weeksCount: "{count, plural, one {Over # week} other {Over # weeks}}",
      noSelection: "No entry selected",
      selection: "{count, plural, one {# entry selected} other {# entries selected}} \xB7 {duration}"
    },
    capacity: {
      description: "Time entered against each person\u2019s capacity (contract hours, minus public holidays and leave). Above 110%, the week is overloaded.",
      navLabel: "Period shown",
      earlier: "Earlier weeks",
      later: "Later weeks",
      weeksLabel: "Period length",
      weeksOption: "{count} week(s)",
      caption: "Team workload by week",
      person: "Person",
      contract: "Contract:",
      editContract: "Edit the contract hours of {name}",
      contractTitle: "Contract hours of {name}",
      contractLabel: "Hours per week",
      contractHint: "For example 40 or 37:30. Durations go in quarter hours, 70 hours at most.",
      contractSaved: "Contract hours saved.",
      contractInvalid: {
        format: "Enter hours such as 40, 37.5 or 37:30.",
        step: "Hours are entered in quarter hours.",
        max: "A week cannot exceed 70 hours."
      },
      missingHolidays: "The public holiday calendar is missing for {years}: the capacity of those weeks ignores public holidays.",
      cellLabel: "{name}, week of {range}: {load} entered of {capacity}, {state}",
      unknown: "unknown capacity",
      states: {
        ok: "Within capacity",
        high: "Above 100%",
        over: "Overloaded (more than 110%)",
        none: "Capacity unknown"
      },
      percent: "{percent}%",
      noTime: "No time entered this week.",
      projectLine: "{project}: {duration}",
      loadFailedTitle: "Unable to load the team workload",
      empty: {
        title: "Nobody to show",
        description: "Workload appears for your team members as soon as they enter time."
      },
      legend: "Load legend"
    },
    leave: {
      description: "Leave, sick days and training. An absence reduces the capacity of the weeks it covers.",
      formLabel: "Add an absence",
      person: "Person",
      me: "Me",
      startsOn: "From",
      endsOn: "To",
      kind: "Type",
      kinds: {
        leave: "Leave",
        sick: "Sick leave",
        training: "Training",
        other: "Other"
      },
      noteLabel: "Note (optional)",
      note: "Note",
      add: "Add the absence",
      created: "Absence added.",
      deleted: "Absence deleted.",
      delete: "Delete the absence of {name} ({period})",
      deleteTitle: "Delete this absence?",
      deleteBody: "The capacity of the weeks concerned will be recalculated.",
      period: "Period",
      periodValue: "from {from} to {to}",
      actions: "Actions",
      datesRequired: "Enter the start and end dates.",
      endBeforeStart: "The end date cannot be before the start date.",
      loadFailedTitle: "Unable to load the absences",
      empty: {
        title: "No absence",
        description: "Leave, sick days and training in this period will appear here."
      },
      upcoming: "Upcoming and current",
      past: "Past",
      workingDays: "{count, plural, =0 {No working day} one {# working day} other {# working days}}"
    },
    errors: {
      network: "The connection failed. Check your network and try again.",
      TIMESHEET_LOCKED: "This week is submitted, or this entry is already decided: it can no longer be changed.",
      NOT_FOUND: "You do not work on this project, or this item no longer exists.",
      FORBIDDEN: "You are not allowed to do this (you do not decide on your own time).",
      STALE_VERSION: "This entry changed in the meantime. The week has just been reloaded, try again."
    },
    kpis: {
      label: "Week summary",
      entered: "Entered this week",
      noCapacity: "The week's capacity is not known",
      progressLabel: "Time entered against the week's capacity",
      remaining: "Left to enter",
      remainingDone: "The week's capacity is reached",
      remainingCaption: "To reach the week's capacity",
      days: "Days filled in",
      daysCaption: "Working days, without holidays and leave",
      status: "Week status",
      statusOpen: "Being filled in",
      statusSubmitted: "Submitted",
      toSubmit: "{duration} ready to submit",
      rejected: "{count, plural, one {# entry rejected} other {# entries rejected}}",
      rejectedCaption: "Correct them, then submit again",
      currentWeek: "Current week"
    }
  }
};

// locales/fr/web.json
var web_default3 = {
  session: {
    loading: "Chargement de votre espace\u2026",
    redirecting: "Redirection vers la page de connexion\u2026"
  },
  unavailable: {
    title: "Le service de connexion n'est pas encore disponible",
    body: "Nous n'arrivons pas \xE0 v\xE9rifier votre session pour le moment. Vos donn\xE9es ne sont pas perdues. R\xE9essayez dans un instant\xA0; si le probl\xE8me continue, contactez le support."
  },
  notFound: {
    title: "Cette page n'existe pas",
    body: "Le lien est peut-\xEAtre ancien ou mal saisi. Revenez \xE0 l'accueil pour continuer.",
    home: "Retour \xE0 l'accueil"
  },
  error: {
    title: "Un probl\xE8me est survenu",
    body: "Cette page n'a pas pu s'afficher. Vos donn\xE9es ne sont pas perdues. Rechargez la page\xA0; si le probl\xE8me continue, transmettez les d\xE9tails techniques au support.",
    reload: "Recharger la page",
    details: "D\xE9tails techniques",
    noTrace: "non disponible",
    release: "Version\xA0: {release}",
    copied: "D\xE9tails copi\xE9s dans le presse-papiers.",
    copyFailed: "Copie impossible. S\xE9lectionnez le texte ci-dessus pour le copier \xE0 la main."
  },
  onboarding: {
    title: "Bienvenue sur BatiFlow",
    body: "Cr\xE9ez le profil de votre bureau d'\xE9tudes en quelques minutes. Vous en serez le propri\xE9taire et profiterez de 14 jours d'essai de l'offre Pro.",
    hint: "Si votre bureau d'\xE9tudes utilise d\xE9j\xE0 BatiFlow, demandez une invitation \xE0 son administrateur au lieu de cr\xE9er une nouvelle organisation.",
    stepCounter: "\xC9tape {current} sur {total}",
    steps: {
      identity: {
        title: "Identit\xE9 du bureau",
        description: "Ces informations figurent sur vos documents officiels."
      },
      disciplines: {
        title: "Disciplines",
        description: "Cochez les disciplines que votre bureau d'\xE9tudes exerce."
      },
      address: {
        title: "Adresse et gouvernorat",
        description: "Indiquez l'adresse du si\xE8ge de votre bureau."
      },
      summary: {
        title: "R\xE9capitulatif",
        description: "V\xE9rifiez ces informations avant de cr\xE9er votre organisation."
      }
    },
    fields: {
      legalName: {
        label: "Raison sociale",
        hint: "Le nom officiel de votre bureau, tel qu'il figure au registre du commerce."
      },
      tradeName: {
        label: "Nom commercial (facultatif)",
        hint: "Le nom sous lequel vos clients vous connaissent."
      },
      legalForm: {
        label: "Forme juridique",
        placeholder: "Choisissez une forme juridique"
      },
      taxId: {
        label: "Matricule fiscal",
        hint: "Vous le trouverez sur l'attestation d'existence de votre bureau."
      },
      disciplines: {
        legend: "Disciplines du bureau",
        hint: "Plusieurs choix sont possibles."
      },
      line1: {
        label: "Adresse"
      },
      line2: {
        label: "Compl\xE9ment d'adresse (facultatif)"
      },
      city: {
        label: "Ville"
      },
      postalCode: {
        label: "Code postal"
      },
      governorate: {
        label: "Gouvernorat",
        placeholder: "Choisissez un gouvernorat"
      }
    },
    summary: {
      notProvided: "Non renseign\xE9"
    },
    actions: {
      create: "Cr\xE9er mon organisation",
      creating: "Cr\xE9ation en cours\u2026"
    },
    errors: {
      legalNameRequired: "Saisissez la raison sociale de votre bureau.",
      tooLong: "Ce champ ne peut pas d\xE9passer {max} caract\xE8res.",
      legalFormRequired: "Choisissez la forme juridique.",
      disciplinesRequired: "Choisissez au moins une discipline.",
      line1Required: "Saisissez l'adresse de votre bureau.",
      cityRequired: "Saisissez la ville.",
      postalCodeRequired: "Saisissez le code postal.",
      postalCodeFormat: "Saisissez un code postal valide, par exemple 1002.",
      governorateRequired: "Choisissez le gouvernorat.",
      taxIdTaken: "Ce matricule fiscal est d\xE9j\xE0 utilis\xE9 par un bureau sur BatiFlow. Demandez \xE0 son propri\xE9taire de vous inviter.",
      fieldInvalid: "Cette valeur n'est pas accept\xE9e. V\xE9rifiez-la puis r\xE9essayez.",
      submitTitle: "L'organisation n'a pas pu \xEAtre cr\xE9\xE9e"
    }
  },
  legalForms: {
    individual: "Entreprise individuelle",
    suarl: "Soci\xE9t\xE9 unipersonnelle \xE0 responsabilit\xE9 limit\xE9e (SUARL)",
    sarl: "Soci\xE9t\xE9 \xE0 responsabilit\xE9 limit\xE9e (SARL)",
    sa: "Soci\xE9t\xE9 anonyme (SA)",
    snc: "Soci\xE9t\xE9 en nom collectif (SNC)",
    scs: "Soci\xE9t\xE9 en commandite simple (SCS)",
    gie: "Groupement d'int\xE9r\xEAt \xE9conomique (GIE)",
    other: "Autre"
  },
  governorates: {
    tunis: "Tunis",
    ariana: "Ariana",
    ben_arous: "Ben Arous",
    manouba: "La Manouba",
    nabeul: "Nabeul",
    zaghouan: "Zaghouan",
    bizerte: "Bizerte",
    beja: "B\xE9ja",
    jendouba: "Jendouba",
    kef: "Le Kef",
    siliana: "Siliana",
    kairouan: "Kairouan",
    kasserine: "Kasserine",
    sidi_bouzid: "Sidi Bouzid",
    sousse: "Sousse",
    monastir: "Monastir",
    mahdia: "Mahdia",
    sfax: "Sfax",
    gafsa: "Gafsa",
    tozeur: "Tozeur",
    kebili: "K\xE9bili",
    gabes: "Gab\xE8s",
    medenine: "M\xE9denine",
    tataouine: "Tataouine"
  },
  activity: {
    title: "Activit\xE9",
    body: "Vos mentions, approbations et affectations appara\xEEtront ici.",
    empty: "Rien de nouveau pour le moment.",
    setup: {
      title: "Terminez la configuration de votre bureau",
      intro: "Trois \xE9tapes pour bien d\xE9marrer avec BatiFlow.",
      dismiss: "Masquer",
      dismissLabel: "Masquer la carte de configuration",
      listLabel: "\xC9tapes de configuration",
      invite: {
        title: "Invitez votre \xE9quipe",
        description: "Ajoutez vos ing\xE9nieurs, dessinateurs et collaborateurs.",
        action: "Inviter"
      },
      clients: {
        title: "Ajoutez un client",
        description: "Enregistrez vos ma\xEEtres d'ouvrage pour les retrouver dans vos projets.",
        action: "Ajouter un client"
      },
      project: {
        title: "Cr\xE9ez un projet",
        description: "Lancez votre premier dossier d'\xE9tude.",
        action: "Cr\xE9er un projet"
      }
    }
  },
  comingSoon: {
    body: "Elle sera disponible dans une prochaine version de BatiFlow. En attendant, suivez les nouveaut\xE9s dans l'activit\xE9.",
    title: "Cette section arrive bient\xF4t",
    backToActivity: "Aller \xE0 l'activit\xE9"
  },
  search: {
    close: "Fermer"
  },
  signOut: {
    failed: "La d\xE9connexion n'a pas abouti. Fermez votre navigateur pour terminer la session en toute s\xE9curit\xE9.",
    title: "D\xE9connexion incompl\xE8te"
  },
  mfa: {
    title: "Activez la v\xE9rification en deux \xE9tapes",
    body: "Votre bureau d'\xE9tudes exige la v\xE9rification en deux \xE9tapes pour votre compte\xA0: en plus du mot de passe, vous saisissez un code \xE0 six chiffres donn\xE9 par une application d'authentification sur votre t\xE9l\xE9phone (Google Authenticator, Microsoft Authenticator, FreeOTP\u2026).",
    hint: "Cela prend environ deux minutes. Gardez votre t\xE9l\xE9phone \xE0 port\xE9e de main.",
    setUp: "Activer maintenant",
    alreadyDone: "Je l'ai d\xE9j\xE0 activ\xE9e"
  },
  stepUp: {
    reason: "Cette action est prot\xE9g\xE9e\xA0: elle touche \xE0 des donn\xE9es sensibles de votre bureau d'\xE9tudes.",
    noSecondFactorTitle: "V\xE9rification en deux \xE9tapes n\xE9cessaire",
    noSecondFactorBody: "Pour confirmer votre identit\xE9 avant cette action, activez d'abord la v\xE9rification en deux \xE9tapes.",
    setUp: "Activer la v\xE9rification"
  },
  pendingAction: {
    replayed: "C'est fait\xA0: votre action a \xE9t\xE9 effectu\xE9e apr\xE8s la confirmation de votre identit\xE9.",
    failed: "Votre identit\xE9 est confirm\xE9e, mais l'action n'a pas abouti. Recommencez-la.",
    stepUpFailed: "Nous n'avons pas pu confirmer votre identit\xE9. Rien n'a \xE9t\xE9 modifi\xE9."
  },
  signedOut: {
    title: "D\xE9connexion r\xE9ussie",
    body: "Votre session BatiFlow est ferm\xE9e sur cet appareil. Pour continuer, reconnectez-vous.",
    signIn: "Se connecter",
    reasons: {
      login_failed: {
        title: "La connexion n'a pas abouti",
        body: "La connexion a \xE9t\xE9 interrompue ou a expir\xE9. R\xE9essayez\xA0; si le probl\xE8me continue, contactez le support."
      },
      cancelled: {
        title: "Connexion annul\xE9e",
        body: "Vous avez annul\xE9 la connexion. Vous pouvez recommencer quand vous voulez."
      },
      email_not_verified: {
        title: "Confirmez d'abord votre adresse e-mail",
        body: "Ouvrez le message de BatiFlow re\xE7u \xE0 votre adresse e-mail et suivez le lien de confirmation, puis reconnectez-vous."
      },
      account_disabled: {
        title: "Votre compte est verrouill\xE9",
        body: "L\u2019acc\xE8s \xE0 ce compte a \xE9t\xE9 bloqu\xE9 par le support BatiFlow. Contactez le support pour en savoir plus."
      }
    }
  },
  standalone: {
    backHome: "Retour \xE0 l'accueil"
  },
  security: {
    title: "S\xE9curit\xE9 du compte",
    mfa: {
      title: "V\xE9rification en deux \xE9tapes",
      active: "Activ\xE9e",
      inactive: "Non activ\xE9e",
      activeBody: "Votre session actuelle a \xE9t\xE9 confirm\xE9e par un second facteur\xA0: en plus de votre mot de passe, vous avez saisi un code d'application d'authentification ou utilis\xE9 une cl\xE9 de s\xE9curit\xE9.",
      inactiveBody: "Votre connexion repose uniquement sur le mot de passe. Ajoutez un code \xE0 six chiffres, donn\xE9 par une application d'authentification sur votre t\xE9l\xE9phone, pour mieux prot\xE9ger votre compte et les donn\xE9es de votre bureau d'\xE9tudes.",
      setUp: "Activer la v\xE9rification en deux \xE9tapes",
      listLabel: "Vos m\xE9thodes de v\xE9rification",
      kind: {
        totp: "Application d\u2019authentification",
        securityKey: "Cl\xE9 de s\xE9curit\xE9"
      },
      addedOn: "ajout\xE9e le {date}",
      remove: "Retirer",
      removeLabel: "Retirer {name}",
      removeTitle: "Retirer \xAB {name} \xBB ?",
      removeBody: "Cette m\xE9thode ne pourra plus servir \xE0 vous connecter. Par s\xE9curit\xE9, vous confirmerez d\u2019abord votre identit\xE9.",
      removed: "\xAB {name} \xBB a \xE9t\xE9 retir\xE9e.",
      add: "Ajouter une application d\u2019authentification"
    },
    password: {
      title: "Mot de passe",
      body: "Changez votre mot de passe ici, sans quitter BatiFlow. Par s\xE9curit\xE9, vous confirmez d\u2019abord votre identit\xE9.",
      updatedAt: "Derni\xE8re modification : {date}",
      neverSet: "Aucun mot de passe n\u2019est d\xE9fini pour ce compte (connexion par Google ou Microsoft).",
      change: "Changer le mot de passe",
      reauthHint: "Vous confirmerez d\u2019abord votre identit\xE9 sur la page de connexion BatiFlow, puis vous reviendrez ici pour saisir le nouveau mot de passe.",
      confirmIdentity: "Confirmer mon identit\xE9",
      dialog: {
        title: "Changer le mot de passe",
        intro: "Choisissez un mot de passe que vous n\u2019utilisez nulle part ailleurs. Une phrase de plusieurs mots est facile \xE0 retenir et difficile \xE0 deviner.",
        newLabel: "Nouveau mot de passe",
        confirmLabel: "Confirmer le nouveau mot de passe",
        rules: "Au moins {min} caract\xE8res, diff\xE9rent de votre adresse e-mail et de vos 5 derniers mots de passe.",
        signOutOthers: "D\xE9connecter mes autres appareils",
        submit: "Enregistrer le mot de passe",
        saving: "Enregistrement\u2026",
        done: "{count, plural, =0 {Votre mot de passe a \xE9t\xE9 modifi\xE9.} one {Votre mot de passe a \xE9t\xE9 modifi\xE9 et # autre appareil a \xE9t\xE9 d\xE9connect\xE9.} other {Votre mot de passe a \xE9t\xE9 modifi\xE9 et # autres appareils ont \xE9t\xE9 d\xE9connect\xE9s.}}",
        errors: {
          length: "Le mot de passe doit compter entre {min} et {max} caract\xE8res.",
          mismatch: "Les deux mots de passe ne sont pas identiques.",
          policy: "Ce mot de passe n\u2019est pas accept\xE9 : il doit compter au moins 12 caract\xE8res et \xEAtre diff\xE9rent de votre adresse e-mail et de vos 5 derniers mots de passe."
        }
      }
    },
    sessions: {
      title: "Sessions actives",
      intro: "Vous \xEAtes connect\xE9 sur ces appareils. D\xE9connectez ceux que vous ne reconnaissez pas.",
      listLabel: "Vos sessions actives",
      currentDevice: "Cet appareil",
      flagged: "Changement d\xE9tect\xE9",
      flaggedHint: "Le r\xE9seau ou le navigateur a chang\xE9 pendant la session. Si ce n'\xE9tait pas vous, d\xE9connectez cet appareil.",
      unknownDevice: "Appareil inconnu",
      lastActivity: "Derni\xE8re activit\xE9\xA0:",
      network: "R\xE9seau\xA0:",
      revoke: "D\xE9connecter",
      revokeLabel: "D\xE9connecter {device}",
      revokeTitle: "D\xE9connecter \xAB\xA0{device}\xA0\xBB\xA0?",
      revokeBody: "Cet appareil devra se reconnecter pour acc\xE9der \xE0 BatiFlow. Vos donn\xE9es ne sont pas modifi\xE9es.",
      revoked: "L'appareil \xAB\xA0{device}\xA0\xBB a \xE9t\xE9 d\xE9connect\xE9.",
      alreadyEnded: "Cette session \xE9tait d\xE9j\xE0 termin\xE9e.",
      revokeFailed: "La d\xE9connexion de cet appareil n'a pas abouti. R\xE9essayez\xA0; si le probl\xE8me continue, contactez le support.",
      revokeOthers: "D\xE9connecter les autres appareils",
      revokeOthersTitle: "D\xE9connecter tous les autres appareils\xA0?",
      revokeOthersBody: "{count, plural, one {# autre appareil sera d\xE9connect\xE9 et devra} other {# autres appareils seront d\xE9connect\xE9s et devront}} se reconnecter. Cet appareil reste connect\xE9.",
      revokedOthers: "{count, plural, =0 {Aucun autre appareil n'\xE9tait connect\xE9.} one {# autre appareil a \xE9t\xE9 d\xE9connect\xE9.} other {# autres appareils ont \xE9t\xE9 d\xE9connect\xE9s.}}",
      revokeOthersFailed: "La d\xE9connexion des autres appareils n'a pas abouti. R\xE9essayez\xA0; si le probl\xE8me continue, contactez le support.",
      noOthers: "Aucun autre appareil n'est connect\xE9.",
      empty: "Aucune session active \xE0 afficher.",
      loadFailedTitle: "Impossible d'afficher vos sessions",
      loadFailedBody: "Vos sessions n'ont pas pu \xEAtre charg\xE9es. Vos donn\xE9es ne sont pas perdues. R\xE9essayez\xA0; si le probl\xE8me continue, contactez le support."
    },
    loadFailed: "Les informations de s\xE9curit\xE9 de votre compte n\u2019ont pas pu \xEAtre charg\xE9es. R\xE9essayez ; si le probl\xE8me continue, contactez le support."
  },
  admin: {
    nav: {
      label: "Administration de l'organisation",
      title: "Administration",
      members: "Membres",
      roles: "R\xF4les et permissions",
      profile: "Organisation",
      policies: "Politiques",
      fiscal: "Profil fiscal",
      audit: "Journal d'audit",
      documents: "Documents",
      templates: "Mod\xE8les de projet",
      checklists: "Check-lists",
      storage: "Stockage",
      data: "Donn\xE9es et suppression",
      subscription: "Abonnement"
    }
  },
  more: {
    admin: {
      title: "Administration",
      description: "Membres, invitations, r\xF4les et permissions de votre bureau."
    },
    soon: "D'autres sections arriveront dans les prochaines versions de BatiFlow.",
    partnerships: {
      title: "Partenariats",
      description: "Demandes de partenariat re\xE7ues et espaces d'autres organisations o\xF9 vous g\xE9rez vos d\xE9l\xE9gu\xE9s."
    },
    approvals: {
      title: "Approbations d'acc\xE8s externe",
      description: "Accordez ou refusez \xE0 un membre l'acc\xE8s \xE0 l'espace d'une autre organisation."
    },
    directory: {
      title: "Annuaire des bureaux",
      description: "Trouvez d'autres bureaux d'\xE9tudes BatiFlow et \xE9crivez-leur."
    },
    timesheets: {
      title: "Temps",
      description: "Saisissez vos heures, faites approuver les semaines et suivez la charge de l\u2019\xE9quipe."
    },
    tenders: {
      title: "Appels d'offres",
      description: "Suivez les consultations de la veille au r\xE9sultat, pr\xE9parez vos pi\xE8ces et gardez vos attestations \xE0 jour."
    },
    signatures: {
      title: "Signatures",
      description: "Signez les documents qu\u2019on vous demande de signer et suivez vos demandes de signature."
    }
  },
  members: {
    title: "Membres",
    you: "vous",
    none: "\u2014",
    tableCaption: "Membres de l'organisation",
    seats: {
      used: "si\xE8ges utilis\xE9s",
      unlimited: "si\xE8ges utilis\xE9s (sans limite)"
    },
    tabs: {
      members: "Membres",
      invitations: "Invitations en attente"
    },
    filters: {
      label: "Filtrer les membres",
      search: "Rechercher un membre",
      searchPlaceholder: "Nom ou adresse e-mail",
      role: "Filtrer par r\xF4le",
      allRoles: "Tous les r\xF4les",
      status: "Filtrer par statut",
      allStatuses: "Tous les statuts",
      clear: "Effacer les filtres"
    },
    columns: {
      name: "Nom",
      email: "Adresse e-mail",
      role: "R\xF4le",
      status: "Statut",
      joined: "Arriv\xE9e",
      actions: "Actions"
    },
    status: {
      active: "Actif",
      invited: "Invit\xE9",
      suspended: "Suspendu par le support",
      deactivated: "D\xE9sactiv\xE9"
    },
    roles: {
      owner: "Propri\xE9taire",
      admin: "Administrateur",
      project_manager: "Chef de projet",
      engineer: "Ing\xE9nieur ou architecte",
      draftsman: "Dessinateur",
      accountant: "Comptable"
    },
    roleDescriptions: {
      admin: "G\xE8re les membres, les param\xE8tres, la finance et tous les projets du bureau.",
      project_manager: "Cr\xE9e et pilote ses projets, suit les honoraires, les temps et les notes de frais.",
      engineer: "Participe aux projets auxquels vous l'ajoutez\xA0: documents, t\xE2ches et \xE9changes.",
      draftsman: "Pr\xE9pare et d\xE9pose les plans sur les projets auxquels vous l'ajoutez.",
      accountant: "G\xE8re les devis, les factures, les paiements et la fiscalit\xE9 du bureau."
    },
    actions: {
      open: "Actions pour {name}",
      changeRole: "Changer le r\xF4le",
      deactivate: "D\xE9sactiver",
      transferOwnership: "Transf\xE9rer la propri\xE9t\xE9"
    },
    empty: {
      title: "Aucun membre pour le moment",
      description: "Invitez votre \xE9quipe pour travailler ensemble sur vos projets.",
      filteredTitle: "Aucun membre ne correspond",
      filteredDescription: "Essayez un autre nom ou retirez un filtre."
    },
    loadFailedTitle: "Impossible d'afficher les membres",
    loadFailedBody: "La liste n'a pas pu \xEAtre charg\xE9e. Vos donn\xE9es ne sont pas perdues. R\xE9essayez\xA0; si le probl\xE8me continue, contactez le support.",
    loadMore: "Afficher plus de membres",
    loadingMore: "Chargement\u2026",
    invite: {
      button: "Inviter",
      title: "Inviter un membre",
      intro: "La personne re\xE7oit un e-mail avec un lien pour rejoindre votre bureau. L'invitation est valable 7 jours.",
      email: {
        label: "Adresse e-mail"
      },
      role: {
        label: "R\xF4le"
      },
      locale: {
        label: "Langue de l'e-mail",
        hint: "L'invitation est \xE9crite dans cette langue."
      },
      submit: "Envoyer l'invitation",
      sending: "Envoi en cours\u2026",
      sent: "L'invitation a \xE9t\xE9 envoy\xE9e \xE0 {email}.",
      resendExisting: "Renvoyer l'invitation",
      errors: {
        emailRequired: "Saisissez l'adresse e-mail de la personne \xE0 inviter.",
        emailInvalid: "Saisissez une adresse e-mail valide, par exemple nom@exemple.tn.",
        alreadyMember: "Cette adresse appartient d\xE9j\xE0 \xE0 un membre de votre bureau.",
        pending: "Une invitation est d\xE9j\xE0 en attente pour cette adresse. Vous pouvez la renvoyer.",
        pendingElsewhere: "Une invitation est d\xE9j\xE0 en attente pour cette adresse. Retrouvez-la dans l'onglet \xAB\xA0Invitations en attente\xA0\xBB."
      }
    },
    upgrade: {
      askOwner: "Tous les si\xE8ges de votre offre sont utilis\xE9s. Demandez au propri\xE9taire de votre bureau d'ajouter un si\xE8ge ou de changer d'offre pour inviter plus de personnes.",
      addSeat: "Tous les si\xE8ges de votre offre sont utilis\xE9s. Ajoutez un si\xE8ge pour inviter une personne de plus. Cette option arrive bient\xF4t dans l'administration\xA0: en attendant, contactez le support BatiFlow.",
      upgradePlan: "Tous les si\xE8ges de votre offre sont utilis\xE9s. Passez \xE0 l'offre {plan} pour en obtenir davantage. Le choix de l'offre arrive bient\xF4t dans l'administration\xA0: en attendant, contactez le support BatiFlow.",
      noHigherPlan: "Tous les si\xE8ges de votre offre sont utilis\xE9s et aucune offre sup\xE9rieure n'est propos\xE9e en libre-service. Contactez l'\xE9quipe BatiFlow pour ajouter des si\xE8ges.",
      plans: {
        solo: "Solo",
        starter: "Starter",
        pro: "Pro",
        business: "Business",
        enterprise: "Enterprise"
      }
    },
    invitations: {
      tableCaption: "Invitations en attente",
      columns: {
        email: "Adresse e-mail",
        role: "R\xF4le",
        invitedBy: "Invit\xE9 par",
        expires: "Expire le"
      },
      expired: "Expir\xE9e",
      empty: {
        title: "Aucune invitation en attente",
        description: "Les personnes invit\xE9es qui n'ont pas encore accept\xE9 apparaissent ici."
      },
      resend: "Renvoyer",
      resendLabel: "Renvoyer l'invitation \xE0 {email}",
      resent: "L'invitation a \xE9t\xE9 renvoy\xE9e \xE0 {email}.",
      revoke: "R\xE9voquer",
      revokeLabel: "R\xE9voquer l'invitation de {email}",
      revokeTitle: "R\xE9voquer l'invitation de {email}\xA0?",
      revokeBody: "Le lien re\xE7u par e-mail ne fonctionnera plus. Vous pourrez inviter \xE0 nouveau cette personne.",
      revoked: "L'invitation de {email} a \xE9t\xE9 r\xE9voqu\xE9e.",
      alreadyGone: "Cette invitation n'existe plus\xA0: elle a d\xE9j\xE0 \xE9t\xE9 accept\xE9e ou r\xE9voqu\xE9e.",
      loadFailedTitle: "Impossible d'afficher les invitations",
      loadFailedBody: "La liste n'a pas pu \xEAtre charg\xE9e. R\xE9essayez\xA0; si le probl\xE8me continue, contactez le support."
    },
    changeRole: {
      title: "Changer le r\xF4le de {name}",
      current: "R\xF4le actuel\xA0: {role}.",
      label: "Nouveau r\xF4le",
      placeholder: "Choisissez un r\xF4le",
      required: "Choisissez le nouveau r\xF4le.",
      stepUpNote: "Pour votre s\xE9curit\xE9, vous devrez peut-\xEAtre confirmer votre identit\xE9 avant que le changement ne soit appliqu\xE9.",
      submit: "Changer le r\xF4le",
      saving: "Enregistrement\u2026",
      done: "{name} a maintenant le r\xF4le \xAB\xA0{role}\xA0\xBB.",
      stale: "Les informations de {name} ont chang\xE9 entre-temps. La liste a \xE9t\xE9 recharg\xE9e\xA0: v\xE9rifiez-les, puis recommencez."
    },
    deactivate: {
      explain: {
        title: "D\xE9sactiver {name}",
        intro: "Voici ce qui se passe quand vous d\xE9sactivez {name}\xA0:",
        access: "L'acc\xE8s \xE0 votre bureau s'arr\xEAte imm\xE9diatement, sur tous ses appareils.",
        content: "Ses documents, messages et t\xE2ches restent en place et gardent son nom.",
        seat: "Le si\xE8ge est lib\xE9r\xE9 \xE0 la prochaine p\xE9riode de facturation."
      },
      plan: {
        title: "Que faire de ce que d\xE9tient {name}\xA0?",
        intro: "{count, plural, one {# \xE9l\xE9ment est confi\xE9 \xE0 {name}} other {# \xE9l\xE9ments sont confi\xE9s \xE0 {name}}}. Choisissez qui les reprend.",
        nothing: "Il n'y a rien \xE0 transf\xE9rer pour le moment\xA0: {name} ne d\xE9tient aucun \xE9l\xE9ment \xE0 confier \xE0 quelqu'un d'autre.",
        loadFailed: "Les \xE9l\xE9ments \xE0 transf\xE9rer n'ont pas pu \xEAtre charg\xE9s. R\xE9essayez avant de continuer.",
        defaultAssignee: "Reprise par d\xE9faut",
        defaultAssigneeHint: "Re\xE7oit tous les \xE9l\xE9ments pour lesquels vous ne choisissez personne.",
        noDefault: "Personne par d\xE9faut",
        useDefault: "Utiliser la reprise par d\xE9faut",
        listLabel: "\xC9l\xE9ments \xE0 transf\xE9rer",
        errors: {
          missing: "Choisissez une personne pour chaque \xE9l\xE9ment, ou une reprise par d\xE9faut."
        }
      },
      confirm: {
        title: "D\xE9sactiver {name}\xA0?",
        body: "{name} perd l'acc\xE8s \xE0 votre bureau imm\xE9diatement. {count, plural, =0 {Aucun \xE9l\xE9ment \xE0 transf\xE9rer.} one {# \xE9l\xE9ment sera transf\xE9r\xE9.} other {# \xE9l\xE9ments seront transf\xE9r\xE9s.}}",
        action: "D\xE9sactiver"
      },
      done: "{name} a \xE9t\xE9 d\xE9sactiv\xE9.",
      alreadyGone: "Ce membre n'est plus actif\xA0: il a d\xE9j\xE0 \xE9t\xE9 d\xE9sactiv\xE9."
    },
    ownerTransfer: {
      theOwner: "Le propri\xE9taire",
      pendingTitle: "Transfert de propri\xE9t\xE9 en cours",
      pendingBody: "En attente de la r\xE9ponse de {name}, qui doit accepter de devenir propri\xE9taire.",
      expires: "Expire le",
      cancel: "Annuler le transfert",
      cancelled: "Le transfert de propri\xE9t\xE9 a \xE9t\xE9 annul\xE9.",
      offerTitle: "{name} souhaite vous nommer propri\xE9taire",
      offerBody: "Vous prendriez la propri\xE9t\xE9 de {organization}\xA0: facturation, suppression de l'organisation et transfert.",
      accept: "Accepter",
      decline: "Refuser",
      declined: "Vous avez refus\xE9 le transfert de propri\xE9t\xE9.",
      acceptTitle: "Devenir propri\xE9taire de {organization}\xA0?",
      acceptBody: "Vous deviendrez propri\xE9taire et {name} deviendra administrateur. Vous devrez confirmer votre identit\xE9.",
      acceptAction: "Devenir propri\xE9taire",
      accepted: "Vous \xEAtes maintenant propri\xE9taire de {organization}.",
      proposeTitle: "Transf\xE9rer la propri\xE9t\xE9 \xE0 {name}\xA0?",
      proposeBody: "{name} recevra la proposition et devra l'accepter. Si elle l'accepte, elle devient propri\xE9taire et vous devenez administrateur. Vous pouvez annuler tant qu'elle n'a pas r\xE9pondu.",
      proposeAction: "Envoyer la proposition",
      proposed: "La proposition a \xE9t\xE9 envoy\xE9e \xE0 {name}. Elle prendra effet quand la personne l'aura accept\xE9e."
    }
  },
  invitation: {
    opening: "Ouverture de votre invitation\u2026",
    loading: "Chargement de votre invitation\u2026",
    joining: "Ouverture de votre espace\u2026",
    toHome: "Aller \xE0 l'accueil",
    missing: {
      title: "Votre invitation n'est plus ouverte dans cet onglet",
      body: "Ouvrez de nouveau le lien re\xE7u par e-mail pour afficher votre invitation. Si vous ne retrouvez plus le message, demandez une nouvelle invitation \xE0 la personne qui vous a invit\xE9."
    },
    signedOut: {
      title: "Vous \xEAtes invit\xE9 \xE0 rejoindre un bureau d'\xE9tudes sur BatiFlow",
      body: "Connectez-vous avec l'adresse e-mail qui a re\xE7u l'invitation pour voir de quel bureau il s'agit et le rejoindre.",
      account: "Vous n'avez pas encore de compte\xA0? Vous pourrez en cr\xE9er un sur la page de connexion, puis vous reviendrez ici.",
      action: "Se connecter ou cr\xE9er un compte"
    },
    problems: {
      unknown: {
        title: "Ce lien d'invitation n'est pas reconnu",
        body: "Le lien est peut-\xEAtre incomplet ou ancien. Ouvrez de nouveau le message re\xE7u par e-mail, ou demandez une nouvelle invitation."
      },
      invalid: {
        title: "Cette invitation n'est plus valable",
        body: "Elle a expir\xE9, a \xE9t\xE9 annul\xE9e ou a d\xE9j\xE0 \xE9t\xE9 utilis\xE9e. Demandez une nouvelle invitation \xE0 la personne qui vous a invit\xE9."
      },
      mismatch: {
        title: "Cette invitation est destin\xE9e \xE0 une autre adresse",
        body: "Elle a \xE9t\xE9 envoy\xE9e \xE0",
        next: "Vous \xEAtes connect\xE9 avec une autre adresse. D\xE9connectez-vous, puis ouvrez de nouveau le lien re\xE7u par e-mail et connectez-vous avec l'adresse invit\xE9e.",
        generic: "Vous \xEAtes connect\xE9 avec une autre adresse que celle de l'invitation. D\xE9connectez-vous, puis ouvrez de nouveau le lien re\xE7u par e-mail et connectez-vous avec l'adresse invit\xE9e."
      },
      unverified: {
        title: "Confirmez d'abord votre adresse e-mail",
        body: "Ouvrez le message de BatiFlow re\xE7u \xE0 votre adresse et suivez le lien de confirmation. Revenez ensuite ouvrir le lien de l'invitation."
      },
      full: {
        title: "Ce bureau n'a plus de si\xE8ge libre",
        body: "Tous les si\xE8ges de l'offre du bureau sont utilis\xE9s. Contactez la personne qui vous a invit\xE9\xA0: elle pourra lib\xE9rer ou ajouter un si\xE8ge, puis vous inviter de nouveau."
      },
      already: {
        title: "Vous faites d\xE9j\xE0 partie de ce bureau",
        body: "Votre compte est d\xE9j\xE0 membre de cette organisation. Retournez \xE0 l'accueil pour l'ouvrir."
      },
      other: {
        title: "Votre invitation n'a pas pu \xEAtre trait\xE9e",
        body: "Une erreur est survenue. Vos donn\xE9es ne sont pas perdues. R\xE9essayez\xA0; si le probl\xE8me continue, contactez le support."
      }
    },
    ready: {
      title: "Rejoindre {organization}",
      intro: "Vous avez \xE9t\xE9 invit\xE9 \xE0 rejoindre ce bureau d'\xE9tudes sur BatiFlow. V\xE9rifiez les informations ci-dessous.",
      organization: "Bureau",
      role: "R\xF4le",
      email: "Adresse invit\xE9e",
      expires: "Valable jusqu'au",
      join: "Rejoindre {organization}",
      joining: "Un instant\u2026"
    }
  },
  rolesMatrix: {
    title: "R\xF4les et permissions",
    intro: "Voici ce que chaque r\xF4le peut faire dans votre bureau. Ces r\xF4les sont d\xE9finis par BatiFlow\xA0: ce tableau est en lecture seule.",
    regionLabel: "Tableau des permissions par r\xF4le (d\xE9filement horizontal)",
    caption: "Permissions accord\xE9es \xE0 chaque r\xF4le",
    permission: "Permission",
    legend: {
      label: "L\xE9gende du tableau"
    },
    marks: {
      yes: {
        text: "Accord\xE9",
        legend: "Accord\xE9"
      },
      project: {
        symbol: "P",
        text: "Accord\xE9 sur ses propres projets uniquement",
        legend: "Accord\xE9 sur ses propres projets uniquement"
      },
      delegable: {
        symbol: "D",
        text: "Non accord\xE9 par d\xE9faut, le propri\xE9taire peut le d\xE9l\xE9guer",
        legend: "Non accord\xE9 par d\xE9faut\xA0; le propri\xE9taire peut le d\xE9l\xE9guer"
      },
      no: {
        text: "Non accord\xE9",
        legend: "Non accord\xE9"
      }
    },
    areas: {
      organization: "Organisation",
      billing: "Abonnement",
      members: "Membres et r\xF4les",
      audit: "Journal d'audit",
      clients: "Clients",
      projects: "Projets",
      sharing: "Partage et espaces",
      finance: "Finance",
      time: "Temps et co\xFBts",
      other: "Autres"
    },
    permissions: {
      org_update: "Modifier le profil du bureau",
      org_fiscal_read: "Consulter le profil fiscal",
      org_fiscal_update: "Modifier le profil fiscal",
      org_policy_update: "Modifier les politiques (partage, s\xE9curit\xE9)",
      org_delete: "Supprimer l'organisation",
      org_transfer_ownership: "Transf\xE9rer la propri\xE9t\xE9",
      data_export: "Exporter les donn\xE9es du bureau",
      billing_read: "Consulter l'abonnement et les factures BatiFlow",
      billing_manage: "G\xE9rer l'abonnement et les si\xE8ges",
      member_read: "Voir la liste des membres",
      member_invite: "Inviter des membres",
      member_update: "Changer le r\xF4le d'un membre",
      member_deactivate: "D\xE9sactiver un membre",
      role_manage: "G\xE9rer les r\xF4les",
      audit_read: "Consulter le journal d'audit",
      audit_read_finance: "Consulter le journal d'audit financier",
      audit_export: "Exporter le journal d'audit",
      audit_verify: "V\xE9rifier l'int\xE9grit\xE9 du journal d'audit",
      client_read: "Consulter les clients",
      client_create: "Cr\xE9er des clients",
      client_update: "Modifier des clients",
      client_archive: "Archiver des clients",
      project_create: "Cr\xE9er des projets",
      project_view_all: "Voir tous les projets",
      project_manage_all: "G\xE9rer tous les projets",
      project_fees_read: "Voir les honoraires des projets",
      space_create: "Cr\xE9er des espaces de collaboration",
      space_share_external: "Partager un espace avec l'ext\xE9rieur",
      space_approve_external_membership: "Approuver les acc\xE8s des intervenants externes",
      document_publish_to_client: "Publier des documents au client",
      quote_read: "Consulter les devis",
      quote_create: "Cr\xE9er des devis",
      quote_send: "Envoyer des devis",
      contract_read: "Consulter les contrats",
      contract_manage: "G\xE9rer les contrats",
      invoice_read: "Consulter les factures",
      invoice_create: "Cr\xE9er des factures",
      invoice_update: "Modifier des factures (brouillons)",
      invoice_issue: "\xC9mettre des factures",
      einvoicing_manage: "G\xE9rer la facturation \xE9lectronique (TTN)",
      payment_read: "Consulter les paiements",
      payment_create: "Enregistrer des paiements",
      expense_submit: "Soumettre ses propres notes de frais",
      expense_read_all: "Voir toutes les notes de frais",
      expense_approve: "Approuver les notes de frais",
      finance_dashboard: "Voir le tableau de bord financier",
      finance_export: "Exporter les donn\xE9es financi\xE8res",
      supplier_manage: "G\xE9rer les fournisseurs",
      time_submit: "Saisir ses propres temps",
      time_approve: "Approuver les temps",
      time_read_all: "Voir tous les temps",
      cost_rate_manage: "G\xE9rer les taux de co\xFBt",
      payroll_manage: "G\xE9rer la paie",
      tender_manage: "G\xE9rer les appels d'offres",
      checklist_manage: "G\xE9rer les listes de contr\xF4le"
    }
  },
  orgProfile: {
    title: "Organisation",
    formLabel: "Profil de l'organisation",
    noChange: "Aucune modification \xE0 enregistrer.",
    saved: "Le profil de l'organisation est enregistr\xE9.",
    stale: "Le profil de l'organisation a \xE9t\xE9 modifi\xE9 par quelqu'un d'autre pendant que vous le modifiiez. Vos modifications n'ont pas \xE9t\xE9 enregistr\xE9es\xA0: la derni\xE8re version vient d'\xEAtre recharg\xE9e, appliquez \xE0 nouveau vos changements.",
    saving: "Enregistrement\u2026",
    saveFailedTitle: "Le profil n'a pas pu \xEAtre enregistr\xE9",
    loadFailedTitle: "Impossible d'afficher le profil",
    loadFailedBody: "Le profil de l'organisation n'a pas pu \xEAtre charg\xE9. Vos donn\xE9es ne sont pas perdues. R\xE9essayez\xA0; si le probl\xE8me continue, contactez le support.",
    taxIdReadOnly: "Le matricule fiscal identifie votre bureau\xA0: il ne peut pas \xEAtre modifi\xE9 ici. Pour une correction, contactez le support BatiFlow.",
    notProvided: "Non renseign\xE9",
    sections: {
      identity: {
        title: "Identit\xE9 du bureau",
        description: "Ces informations figurent sur vos documents officiels."
      },
      references: {
        title: "R\xE9f\xE9rences professionnelles et langue",
        description: "Facultatif, sauf la langue par d\xE9faut des documents de l'organisation."
      }
    },
    fields: {
      professionalRegistration: {
        label: "Inscription professionnelle (facultatif)",
        hint: "Par exemple le num\xE9ro d'inscription \xE0 l'Ordre des ing\xE9nieurs ou des architectes."
      },
      agreementNumber: {
        label: "Num\xE9ro d'agr\xE9ment (facultatif)",
        hint: "Le num\xE9ro de l'agr\xE9ment de votre bureau d'\xE9tudes, s'il en a un."
      },
      defaultLocale: {
        label: "Langue par d\xE9faut de l'organisation",
        hint: "Utilis\xE9e pour les documents et les messages envoy\xE9s au nom du bureau."
      }
    },
    readOnly: {
      title: "Profil de l'organisation",
      description: "Vous pouvez consulter ces informations. Seuls le propri\xE9taire et les administrateurs peuvent les modifier.",
      address: "Adresse"
    },
    logo: {
      title: "Logo",
      description: "Le logo figure sur vos documents officiels. Formats PNG, JPEG ou WebP, 2\xA0Mo au maximum.",
      alt: "Logo actuel de l'organisation",
      none: "Aucun logo pour l'instant.",
      loadFailed: "Le logo n'a pas pu \xEAtre charg\xE9.",
      choose: "Choisir une image",
      remove: "Supprimer le logo",
      applying: "Application du logo\u2026",
      saved: "Le logo de l'organisation est mis \xE0 jour.",
      removed: "Le logo a \xE9t\xE9 supprim\xE9.",
      errors: {
        type: "Choisissez une image PNG, JPEG ou WebP.",
        tooLarge: "Cette image d\xE9passe {max}. Choisissez une image plus l\xE9g\xE8re.",
        notReady: "L'image est encore en cours de v\xE9rification. R\xE9essayez dans un instant.",
        invalid: "Cette image n'est pas accept\xE9e\xA0: choisissez une image PNG, JPEG ou WebP de 2\xA0Mo au maximum.",
        targetFailed: "Le dossier du logo n'est pas disponible pour le moment. R\xE9essayez dans un instant.",
        saveFailed: "Le logo n'a pas pu \xEAtre enregistr\xE9. R\xE9essayez.",
        removeFailed: "Le logo n'a pas pu \xEAtre supprim\xE9. R\xE9essayez."
      }
    },
    directory: {
      title: "Visible dans l'annuaire BatiFlow",
      description: "Faites-vous conna\xEEtre des autres bureaux d'\xE9tudes BatiFlow, par exemple pour vous inviter dans un espace partag\xE9.",
      switchLabel: "Afficher mon bureau dans l'annuaire",
      on: "Votre bureau est visible dans l'annuaire.",
      off: "Votre bureau n'appara\xEEt pas dans l'annuaire.",
      descriptionLabel: "Pr\xE9sentation courte (facultatif)",
      descriptionHint: "Une ou deux phrases sur votre bureau, en texte simple (300 caract\xE8res au maximum).",
      counter: "{count} / {max} caract\xE8res",
      shownTitle: "Ce que les autres bureaux voient",
      shown: "Le nom du bureau, ses disciplines, son gouvernorat, sa ville et cette pr\xE9sentation.",
      notShown: "Jamais les membres, les coordonn\xE9es, le matricule fiscal ni l'adresse.",
      contactNote: "Un autre bureau peut vous envoyer un message depuis l'annuaire. Il parvient par e-mail aux propri\xE9taires et aux administrateurs, et la r\xE9ponse leur est adress\xE9e directement.",
      readOnly: "Seuls le propri\xE9taire et les administrateurs peuvent modifier la visibilit\xE9 dans l'annuaire.",
      save: "Enregistrer",
      saving: "Enregistrement\u2026",
      saved: "Les r\xE9glages de l'annuaire sont enregistr\xE9s.",
      saveFailed: "Les r\xE9glages de l'annuaire n'ont pas pu \xEAtre enregistr\xE9s.",
      loadFailedTitle: "Impossible d'afficher les r\xE9glages de l'annuaire",
      loadFailedBody: "R\xE9essayez\xA0; si le probl\xE8me continue, contactez le support."
    }
  },
  policies: {
    title: "Politiques",
    formLabel: "Politiques de l'organisation",
    noChange: "Aucune modification \xE0 enregistrer.",
    saved: "Les politiques sont enregistr\xE9es.",
    stale: "Les politiques ont \xE9t\xE9 modifi\xE9es par quelqu'un d'autre pendant que vous les modifiiez. Vos modifications n'ont pas \xE9t\xE9 enregistr\xE9es\xA0: la derni\xE8re version vient d'\xEAtre recharg\xE9e, appliquez \xE0 nouveau vos changements.",
    saving: "Enregistrement\u2026",
    saveFailedTitle: "Les politiques n'ont pas pu \xEAtre enregistr\xE9es",
    loadFailedTitle: "Impossible d'afficher les politiques",
    loadFailedBody: "Les politiques n'ont pas pu \xEAtre charg\xE9es. R\xE9essayez\xA0; si le probl\xE8me continue, contactez le support.",
    stepUpNote: "Pour votre s\xE9curit\xE9, l'enregistrement vous demandera de confirmer votre identit\xE9.",
    sharing: {
      title: "Partage avec l'ext\xE9rieur",
      description: "D\xE9finit comment votre bureau collabore avec des partenaires, des clients et d'autres bureaux.",
      requireApproval: {
        label: "Approbation requise pour rejoindre un espace externe",
        hint: "Quand cette option est active, un membre ne peut rejoindre l'espace d'une autre organisation qu'apr\xE8s l'accord d'un administrateur.",
        seeRequests: "Voir les demandes en attente"
      },
      managersCanShare: {
        label: "Les chefs de projet peuvent partager",
        hint: "Quand cette option est active, les chefs de projet peuvent ouvrir l'espace de leurs projets \xE0 des partenaires. Sinon, seuls le propri\xE9taire et les administrateurs le peuvent."
      },
      domains: {
        label: "Domaines autoris\xE9s pour les invit\xE9s",
        hint: "Saisissez un domaine, par exemple client.tn, puis appuyez sur Entr\xE9e. Les invit\xE9s externes ne pourront venir que de ces domaines.",
        placeholder: "client.tn",
        add: "Ajouter",
        empty: "Aucun domaine\xA0: les invit\xE9s peuvent venir de n'importe quelle adresse e-mail.",
        listLabel: "Domaines autoris\xE9s",
        remove: "Retirer {domain}",
        errors: {
          empty: "Saisissez un domaine, par exemple client.tn.",
          invalid: "Ce domaine n'est pas valide. Saisissez-le sans \xAB\xA0@\xA0\xBB ni espace, par exemple client.tn.",
          duplicate: "Ce domaine est d\xE9j\xE0 dans la liste.",
          limit: "La liste ne peut pas d\xE9passer {max} domaines."
        }
      }
    },
    security: {
      title: "S\xE9curit\xE9 de la connexion",
      description: "D\xE9finit la dur\xE9e des sessions et le niveau de protection demand\xE9 \xE0 tous les membres.",
      sessionHours: {
        label: "Dur\xE9e maximale d'une session",
        hint: "Pass\xE9 ce d\xE9lai, le membre doit se reconnecter, m\xEAme s'il est actif.",
        default: "Dur\xE9e par d\xE9faut de la plateforme (12 heures)",
        option: "{count, plural, one {# heure} other {# heures}}"
      },
      mfaForAll: {
        label: "V\xE9rification en deux \xE9tapes pour tous les membres",
        hint: "Quand cette option est active, chaque membre doit configurer une application d'authentification \xE0 sa prochaine connexion\xA0; sans cela, il n'acc\xE8de plus \xE0 BatiFlow. Le propri\xE9taire, les administrateurs et les comptables y sont d\xE9j\xE0 tenus."
      }
    }
  },
  fiscal: {
    title: "Profil fiscal",
    loadFailedTitle: "Impossible d'afficher le profil fiscal",
    loadFailedBody: "Le profil fiscal n'a pas pu \xEAtre charg\xE9. Vos donn\xE9es ne sont pas perdues. R\xE9essayez\xA0; si le probl\xE8me continue, contactez le support.",
    empty: {
      title: "Aucun profil fiscal pour le moment",
      description: "Le profil fiscal fixe la TVA, le r\xE9gime, la retenue \xE0 la source et les coordonn\xE9es bancaires de vos factures."
    },
    current: {
      title: "Version en vigueur",
      description: "Ces valeurs s'appliquent aux nouvelles factures."
    },
    history: {
      title: "Historique des versions",
      description: "Une nouvelle version ne modifie jamais les anciennes\xA0: les factures \xE9mises gardent celle qui \xE9tait en vigueur.",
      caption: "Versions du profil fiscal, de la plus r\xE9cente \xE0 la plus ancienne"
    },
    columns: {
      effectiveFrom: "En vigueur depuis",
      status: "\xC9tat",
      createdBy: "Cr\xE9\xE9e par",
      vat: "TVA",
      regime: "R\xE9gime fiscal",
      withholding: "Statut pour la retenue \xE0 la source",
      footer: "Pied de page des factures",
      bank: "Coordonn\xE9es bancaires"
    },
    status: {
      current: "En vigueur",
      scheduled: "Programm\xE9e",
      past: "Ancienne"
    },
    values: {
      vatYes: "Assujetti \xE0 la TVA",
      vatNo: "Non assujetti \xE0 la TVA",
      noFooter: "Aucun"
    },
    regimes: {
      real: "R\xE9gime r\xE9el",
      flat_rate: "R\xE9gime forfaitaire"
    },
    withholding: {
      legal_entity: "Personne morale",
      real_regime: "Personne physique au r\xE9gime r\xE9el",
      other: "Autre"
    },
    bank: {
      none: "Aucune",
      show: "Afficher le RIB complet",
      hide: "Masquer",
      rib: "RIB",
      iban: "IBAN",
      copyRib: "Copier le RIB",
      copyIban: "Copier l'IBAN",
      copied: "Copi\xE9 dans le presse-papiers.",
      copyFailed: "La copie n'a pas abouti. S\xE9lectionnez le num\xE9ro et copiez-le \xE0 la main.",
      stepUp: "Confirmez votre identit\xE9 dans la fen\xEAtre qui vient de s'ouvrir, puis cliquez de nouveau sur \xAB\xA0Afficher le RIB complet\xA0\xBB.",
      loading: "Chargement\u2026"
    },
    newVersion: {
      button: "Nouvelle version",
      title: "Nouvelle version du profil fiscal",
      intro: "Les valeurs de la version en vigueur sont reprises\xA0: changez seulement ce qui \xE9volue. L'ancienne version est conserv\xE9e.",
      start: {
        legend: "D\xE9but d'application",
        now: "D\xE8s maintenant",
        later: "\xC0 une date ult\xE9rieure",
        date: "Date de d\xE9but"
      },
      vat: {
        label: "Assujetti \xE0 la TVA"
      },
      withholdingHint: "D\xE9termine la retenue \xE0 la source applicable \xE0 vos factures.",
      footerHint: "Texte affich\xE9 en bas de vos factures (mentions l\xE9gales, conditions de paiement\u2026).",
      bank: {
        legend: "Coordonn\xE9es bancaires (facultatif)",
        hint: "Elles ne sont pas reprises de la version pr\xE9c\xE9dente\xA0: saisissez-les de nouveau, ou laissez vide pour une version sans coordonn\xE9es bancaires.",
        name: "Nom de la banque",
        rib: "RIB",
        ribHint: "20 chiffres, sans le pr\xE9fixe \xAB\xA0TN59\xA0\xBB."
      },
      stepUpNote: "Pour votre s\xE9curit\xE9, l'enregistrement vous demandera de confirmer votre identit\xE9.",
      saving: "Enregistrement\u2026",
      submit: "Cr\xE9er la version",
      done: "La nouvelle version du profil fiscal est en vigueur.",
      doneLater: "La nouvelle version du profil fiscal est programm\xE9e.",
      errors: {
        dateRequired: "Choisissez la date de d\xE9but.",
        datePast: "La date de d\xE9but ne peut pas \xEAtre dans le pass\xE9.",
        footerTooLong: "Le pied de page ne peut pas d\xE9passer {max} caract\xE8res.",
        bankNameRequired: "Saisissez le nom de la banque.",
        bankNameTooLong: "Le nom de la banque ne peut pas d\xE9passer {max} caract\xE8res.",
        ribInvalid: "Un RIB comporte 20 chiffres. V\xE9rifiez-le puis r\xE9essayez."
      }
    },
    series: {
      title: "S\xE9ries de num\xE9rotation des factures",
      description: "Chaque s\xE9rie a son propre compteur sans trou. La s\xE9rie par d\xE9faut est propos\xE9e sur les nouvelles factures.",
      caption: "S\xE9ries de num\xE9rotation des factures",
      add: "Ajouter une s\xE9rie",
      addTitle: "Ajouter une s\xE9rie de factures",
      editTitle: "Modifier la s\xE9rie {code}",
      codeHint: "1 \xE0 10 lettres ou chiffres, par exemple FAC. Le code ne pourra plus \xEAtre chang\xE9.",
      codeFixed: "Le code ne peut pas \xEAtre chang\xE9\xA0: les num\xE9ros d\xE9j\xE0 \xE9mis s'y r\xE9f\xE8rent.",
      prefixHint: "D\xE9but de chaque num\xE9ro, par exemple \xAB\xA0FAC-\xA0\xBB.",
      resetYearly: {
        label: "Recommencer la num\xE9rotation chaque ann\xE9e",
        hint: "Quand cette option est active, le compteur repart de 1 au d\xE9but de chaque ann\xE9e."
      },
      makeDefault: "S\xE9rie par d\xE9faut",
      saving: "Enregistrement\u2026",
      created: "La s\xE9rie {code} est ajout\xE9e.",
      updated: "La s\xE9rie {code} est modifi\xE9e.",
      stale: "Cette s\xE9rie a \xE9t\xE9 modifi\xE9e par quelqu'un d'autre. La liste vient d'\xEAtre recharg\xE9e\xA0: v\xE9rifiez-la puis recommencez.",
      nowDefault: "La s\xE9rie {code} est maintenant la s\xE9rie par d\xE9faut.",
      deleted: "La s\xE9rie {code} est supprim\xE9e.",
      deleteTitle: "Supprimer la s\xE9rie {code}\xA0?",
      deleteBody: "Cette s\xE9rie ne sera plus propos\xE9e. Cette action est d\xE9finitive.",
      resetYes: "Chaque ann\xE9e",
      resetNo: "Jamais",
      defaultBadge: "Par d\xE9faut",
      emptyTitle: "Aucune s\xE9rie de factures",
      emptyDescription: "Ajoutez une s\xE9rie pour num\xE9roter vos factures.",
      loadFailedTitle: "Impossible d'afficher les s\xE9ries",
      loadFailedBody: "Les s\xE9ries de factures n'ont pas pu \xEAtre charg\xE9es. R\xE9essayez\xA0; si le probl\xE8me continue, contactez le support.",
      columns: {
        code: "Code",
        prefix: "Pr\xE9fixe",
        resetYearly: "Remise \xE0 z\xE9ro",
        default: "S\xE9rie par d\xE9faut",
        actions: "Actions"
      },
      actions: {
        open: "Actions pour la s\xE9rie {code}",
        edit: "Modifier",
        makeDefault: "D\xE9finir par d\xE9faut",
        delete: "Supprimer"
      },
      errors: {
        codeInvalid: "Le code comporte de 1 \xE0 10 lettres ou chiffres, sans espace ni accent.",
        codeTaken: "Une autre s\xE9rie utilise d\xE9j\xE0 ce code. Choisissez-en un autre.",
        prefixRequired: "Saisissez le pr\xE9fixe des num\xE9ros.",
        prefixTooLong: "Le pr\xE9fixe ne peut pas d\xE9passer {max} caract\xE8res.",
        isDefault: "La s\xE9rie par d\xE9faut ne peut pas \xEAtre supprim\xE9e. D\xE9finissez d'abord une autre s\xE9rie par d\xE9faut."
      }
    }
  },
  auditLog: {
    title: "Journal d'audit",
    tableCaption: "\xC9v\xE9nements du journal d'audit, du plus r\xE9cent au plus ancien",
    financeOnly: "En tant que comptable, vous voyez uniquement les \xE9v\xE9nements financiers\xA0: factures, devis, contrats, paiements, d\xE9penses et param\xE8tres fiscaux. Les autres \xE9v\xE9nements sont r\xE9serv\xE9s au propri\xE9taire et aux administrateurs.",
    loadFailedTitle: "Impossible d'afficher le journal",
    loadFailedBody: "Le journal d'audit n'a pas pu \xEAtre charg\xE9. R\xE9essayez\xA0; si le probl\xE8me continue, contactez le support.",
    loadMore: "Afficher plus d'\xE9v\xE9nements",
    loadingMore: "Chargement\u2026",
    columns: {
      when: "Date et heure",
      actor: "Auteur",
      action: "Action",
      resource: "\xC9l\xE9ment concern\xE9"
    },
    actorTypes: {
      user: "Utilisateur inconnu",
      system: "Syst\xE8me BatiFlow",
      platform_admin: "Support BatiFlow"
    },
    actions: {
      unknown: "Action enregistr\xE9e",
      auth_logged_in: "Connexion",
      auth_logged_out: "D\xE9connexion",
      auth_stepped_up: "Confirmation d'identit\xE9",
      auth_mfa_changed: "V\xE9rification en deux \xE9tapes modifi\xE9e",
      auth_session_revoked: "Session d\xE9connect\xE9e",
      organization_created: "Organisation cr\xE9\xE9e",
      organization_updated: "Profil de l'organisation modifi\xE9",
      organization_policy_changed: "Politiques de l'organisation modifi\xE9es",
      membership_invited: "Membre invit\xE9",
      membership_joined: "Membre arriv\xE9 dans l'organisation",
      membership_role_changed: "R\xF4le d'un membre modifi\xE9",
      membership_deactivated: "Membre d\xE9sactiv\xE9",
      membership_invitation_resent: "Invitation renvoy\xE9e",
      membership_invitation_revoked: "Invitation annul\xE9e",
      organization_owner_transfer_proposed: "Transfert de propri\xE9t\xE9 propos\xE9",
      organization_owner_transfer_cancelled: "Transfert de propri\xE9t\xE9 annul\xE9",
      organization_owner_transferred: "Propri\xE9t\xE9 de l'organisation transf\xE9r\xE9e",
      organization_fiscal_profile_created: "Nouvelle version du profil fiscal",
      organization_bank_details_viewed: "Coordonn\xE9es bancaires consult\xE9es en clair",
      organization_invoice_series_changed: "S\xE9rie de factures modifi\xE9e",
      client_created: "Client cr\xE9\xE9",
      client_updated: "Client modifi\xE9",
      client_archived: "Client archiv\xE9",
      client_contact_changed: "Contact d'un client modifi\xE9",
      platform_break_glass_granted: "Acc\xE8s exceptionnel du support accord\xE9",
      system_checked: "Contr\xF4le technique",
      quote_created: "Devis cr\xE9\xE9",
      quote_updated: "Devis modifi\xE9",
      quote_deleted: "Devis supprim\xE9",
      quote_sent: "Devis envoy\xE9 au client",
      quote_accepted: "Devis accept\xE9 par le client",
      quote_rejected: "Devis refus\xE9",
      quote_converted: "Devis transform\xE9 en projet",
      quote_fee_scale_created: "Bar\xE8me d\u2019honoraires ajout\xE9",
      quote_fee_scale_deleted: "Bar\xE8me d\u2019honoraires supprim\xE9",
      contract_created: "Contrat cr\xE9\xE9",
      contract_updated: "Contrat modifi\xE9",
      contract_amendment_added: "Avenant ajout\xE9",
      invoice_created: "Facture brouillon cr\xE9\xE9e",
      invoice_updated: "Facture brouillon modifi\xE9e",
      invoice_deleted: "Facture brouillon supprim\xE9e",
      invoice_issued: "Facture \xE9mise",
      invoice_credited: "Avoir \xE9mis",
      invoice_transferred: "Factures brouillons transf\xE9r\xE9es",
      payment_recorded: "Paiement enregistr\xE9",
      payment_certificate_linked: "Certificat de retenue joint",
      expense_submitted: "Note de frais soumise",
      expense_approved: "Note de frais approuv\xE9e",
      expense_rejected: "Note de frais refus\xE9e",
      expense_reimbursed: "Note de frais rembours\xE9e",
      invoice_reminders_changed: "Relances de factures modifi\xE9es",
      organization_directory_updated: "Visibilit\xE9 dans l'annuaire modifi\xE9e",
      directory_contact_received: "Message re\xE7u depuis l'annuaire"
    },
    resources: {
      organization: "Organisation",
      membership: "Membre",
      member_invitation: "Invitation",
      owner_transfer: "Transfert de propri\xE9t\xE9",
      organization_fiscal_profile: "Profil fiscal",
      invoice_series: "S\xE9rie de factures",
      client: "Client"
    },
    families: {
      organization: "Organisation et param\xE8tres",
      membership: "Membres et invitations",
      client: "Clients",
      auth: "Connexions et s\xE9curit\xE9",
      invoice: "Factures",
      quote: "Devis",
      contract: "Contrats",
      payment: "Paiements",
      expense: "D\xE9penses"
    },
    filters: {
      label: "Filtres du journal",
      actor: "Auteur",
      allActors: "Tous les auteurs",
      action: "Type d'action",
      allActions: "Toutes les actions",
      from: "Du",
      to: "Au",
      clear: "Effacer les filtres"
    },
    empty: {
      title: "Aucun \xE9v\xE9nement pour le moment",
      description: "Les actions sensibles de votre bureau appara\xEEtront ici d\xE8s qu'elles auront lieu.",
      filteredTitle: "Aucun \xE9v\xE9nement ne correspond",
      filteredDescription: "Essayez d'autres filtres ou une p\xE9riode plus large."
    },
    verify: {
      title: "Int\xE9grit\xE9 du journal",
      description: "R\xE9serv\xE9 au propri\xE9taire.",
      intro: "Chaque \xE9v\xE9nement est reli\xE9 au pr\xE9c\xE9dent par une empreinte. La v\xE9rification recalcule cet encha\xEEnement et signale si un \xE9v\xE9nement a \xE9t\xE9 modifi\xE9, supprim\xE9 ou d\xE9plac\xE9.",
      button: "V\xE9rifier l'int\xE9grit\xE9",
      running: "V\xE9rification en cours\u2026",
      okTitle: "Le journal est intact",
      okBody: "Aucune modification ni suppression d\xE9tect\xE9e. V\xE9rifi\xE9 le",
      brokenTitle: "Le journal a \xE9t\xE9 alt\xE9r\xE9",
      brokenBody: "L'encha\xEEnement du journal est rompu \xE0 partir de l'\xE9v\xE9nement n\xB0 {position}\xA0: {reason}. Conservez cet \xE9cran et contactez le support BatiFlow sans attendre.",
      failedTitle: "La v\xE9rification n'a pas abouti",
      reasons: {
        content_modified: "le contenu d'un \xE9v\xE9nement a \xE9t\xE9 modifi\xE9 apr\xE8s coup",
        sequence_gap: "un ou plusieurs \xE9v\xE9nements ont disparu de la s\xE9quence",
        link_broken: "le lien d'encha\xEEnement entre deux \xE9v\xE9nements est rompu",
        unknown: "une incoh\xE9rence a \xE9t\xE9 d\xE9tect\xE9e"
      }
    }
  },
  meNav: {
    profile: "Profil",
    security: "S\xE9curit\xE9",
    notifications: "Notifications"
  },
  meProfile: {
    title: "Mon profil",
    saving: "Enregistrement\u2026",
    errors: {
      nameRequired: "Saisissez votre nom.",
      nameTooLong: "Le nom ne peut pas d\xE9passer {max} caract\xE8res."
    },
    identity: {
      title: "Identit\xE9",
      description: "Votre nom tel que vos coll\xE8gues le voient.",
      name: "Nom affich\xE9",
      email: "Adresse e-mail",
      emailHint: "L'adresse e-mail est g\xE9r\xE9e par votre compte BatiFlow\xA0: elle ne se change pas ici.",
      saved: "Votre nom est enregistr\xE9."
    },
    region: {
      title: "Langue et r\xE9gion",
      description: "Chaque choix est enregistr\xE9 d\xE8s que vous le faites.",
      language: {
        label: "Langue de l'interface",
        hint: "Le changement s'applique imm\xE9diatement, y compris le sens de lecture pour l'arabe.",
        saved: "Votre langue est enregistr\xE9e."
      },
      timeZone: {
        label: "Fuseau horaire",
        hint: "Les dates et heures s'affichent dans ce fuseau.",
        saved: "Votre fuseau horaire est enregistr\xE9."
      },
      digits: {
        legend: "Chiffres de l'interface en arabe",
        hint: "S'applique uniquement lorsque l'interface est en arabe.",
        latn: "Chiffres latins (0123456789)",
        arab: "Chiffres arabes (\u0660\u0661\u0662\u0663\u0664\u0665\u0666\u0667\u0668\u0669)",
        saved: "Votre choix de chiffres est enregistr\xE9."
      }
    },
    appearance: {
      title: "Apparence",
      description: "Ce choix reste sur cet appareil\xA0: il n'est pas enregistr\xE9 sur votre compte.",
      theme: "Th\xE8me"
    }
  },
  meNotifications: {
    title: "Mes notifications",
    formLabel: "Pr\xE9f\xE9rences de notification",
    noChange: "Aucune modification \xE0 enregistrer.",
    saved: "Vos pr\xE9f\xE9rences de notification sont enregistr\xE9es.",
    stale: "Vos pr\xE9f\xE9rences ont \xE9t\xE9 modifi\xE9es ailleurs pendant que vous les modifiiez. Vos modifications n'ont pas \xE9t\xE9 enregistr\xE9es\xA0: les pr\xE9f\xE9rences actuelles viennent d'\xEAtre recharg\xE9es, appliquez \xE0 nouveau vos changements.",
    saving: "Enregistrement\u2026",
    saveFailedTitle: "Les pr\xE9f\xE9rences n'ont pas pu \xEAtre enregistr\xE9es",
    loadFailedTitle: "Impossible d'afficher vos pr\xE9f\xE9rences",
    loadFailedBody: "Vos pr\xE9f\xE9rences de notification n'ont pas pu \xEAtre charg\xE9es. R\xE9essayez\xA0; si le probl\xE8me continue, contactez le support.",
    reset: "R\xE9tablir les valeurs par d\xE9faut",
    resetNote: "R\xE9tablir les valeurs par d\xE9faut remplit le formulaire\xA0: rien n'est chang\xE9 tant que vous n'avez pas enregistr\xE9.",
    channels: {
      inApp: "Dans l'application",
      email: "Par e-mail",
      push: "Notification push",
      pushLater: "Application mobile, bient\xF4t"
    },
    emailModes: {
      off: "Jamais",
      immediate: "Imm\xE9diatement",
      digest: "Dans le r\xE9sum\xE9"
    },
    groups: {
      conversations: "Conversations",
      tasks: "T\xE2ches",
      approvals: "Visas et validations",
      external: "Partenaires et espaces externes",
      security: "S\xE9curit\xE9",
      finance: "Facturation et abonnement",
      calendar: "Calendrier",
      meetings: "R\xE9unions et appels",
      planning: "Temps et planning",
      tenders: "Appels d'offres et coffre-fort",
      signatures: "Signatures \xE9lectroniques"
    },
    types: {
      mention: "On vous mentionne",
      reply: "R\xE9ponse \xE0 l'un de vos messages",
      task_assigned: "Une t\xE2che vous est assign\xE9e",
      task_due: "Une t\xE2che arrive \xE0 \xE9ch\xE9ance",
      task_overdue: "Une t\xE2che est en retard",
      phase_due: "Une phase arrive \xE0 sa date de fin pr\xE9vue",
      phase_overdue: "Une phase est en retard",
      approval_requested: "Une demande de visa vous attend",
      approval_decided: "D\xE9cision sur un visa que vous avez demand\xE9",
      space_invitation: "Invitation dans un espace partag\xE9",
      partnership_request: "Demande de partenariat",
      access_revoked: "Votre acc\xE8s \xE0 un espace est retir\xE9",
      einvoice_status: "R\xE9sultat d'une facture \xE9lectronique (TTN)",
      payment_received: "Paiement re\xE7u",
      plan_limit: "Limite de votre offre atteinte",
      event_reminder: "Un \xE9v\xE9nement du calendrier approche",
      quote_accepted: "Un client accepte l\u2019un de vos devis",
      invoice_suggested: "Une phase close peut \xEAtre factur\xE9e",
      bond_release_due: "Une caution peut bient\xF4t \xEAtre lib\xE9r\xE9e",
      expense_submitted: "Une note de frais attend votre approbation",
      expense_decided: "Votre note de frais est approuv\xE9e ou refus\xE9e",
      subscription_status: "L\u2019\xE9tat de votre abonnement BatiFlow (\xE9ch\xE9ance, impay\xE9, lecture seule)",
      data_export: "L\u2019export des donn\xE9es de l\u2019organisation est pr\xEAt \xE0 t\xE9l\xE9charger (ou a \xE9chou\xE9)",
      organization_deletion: "La suppression de l\u2019organisation est programm\xE9e ou annul\xE9e",
      meeting_started: "Une r\xE9union \xE0 laquelle vous pouvez participer d\xE9marre",
      meeting_invited: "On vous invite \xE0 une r\xE9union",
      call_missed: "Un appel rest\xE9 sans r\xE9ponse",
      minutes_published: "Le proc\xE8s-verbal d\u2019une r\xE9union \xE0 laquelle vous avez particip\xE9 est publi\xE9",
      timesheet_reminder: "Rappel du vendredi pour soumettre votre feuille de temps",
      phase_deadline: "L\u2019\xE9ch\xE9ance contractuelle d\u2019une phase approche ou est d\xE9pass\xE9e",
      vault_expiring: "Un document du coffre-fort (attestation, assurance\u2026) expire dans moins de 30 jours",
      time_budget: "Une phase de vos projets a consomm\xE9 80 % de son budget de temps",
      signature_requested: "Un membre vous demande de signer un document",
      signature_update: "Vos demandes de signature sont sign\xE9es ou refus\xE9es"
    },
    matrix: {
      title: "Quoi, et o\xF9",
      description: "Choisissez, pour chaque type de notification, si vous la voyez dans l'application et si vous la recevez par e-mail.",
      region: "Tableau des pr\xE9f\xE9rences de notification",
      caption: "Pr\xE9f\xE9rences de notification par type et par canal",
      type: "Notification",
      cell: "{type}\xA0: {channel}",
      alwaysOn: "Cet avis important reste toujours actif dans l'application."
    },
    digest: {
      title: "R\xE9sum\xE9 par e-mail",
      description: "Le r\xE9sum\xE9 regroupe en un seul e-mail les notifications r\xE9gl\xE9es sur \xAB\xA0Dans le r\xE9sum\xE9\xA0\xBB. Il n'est envoy\xE9 que si une fr\xE9quence est choisie.",
      label: "Fr\xE9quence du r\xE9sum\xE9",
      options: {
        off: "Pas de r\xE9sum\xE9",
        hourly: "Chaque heure",
        daily: "Chaque jour"
      },
      warningTitle: "Le r\xE9sum\xE9 est d\xE9sactiv\xE9",
      warningBody: "Des notifications sont r\xE9gl\xE9es sur \xAB\xA0Dans le r\xE9sum\xE9\xA0\xBB, mais aucun r\xE9sum\xE9 n'est envoy\xE9\xA0: elles resteront uniquement dans l'application. Choisissez une fr\xE9quence pour les recevoir par e-mail."
    },
    quietHours: {
      title: "Heures calmes",
      description: "Pendant ces heures, vous ne recevez pas d'e-mail de notification\xA0; ils vous parviennent ensuite. Les heures sont celles de votre fuseau horaire.",
      enable: "Activer les heures calmes",
      start: "D\xE9but",
      end: "Fin",
      invalid: "Le d\xE9but et la fin doivent \xEAtre deux heures diff\xE9rentes."
    },
    ring: {
      title: "Sonnerie des appels",
      description: "Joue une sonnerie sur cet appareil quand quelqu\u2019un vous appelle. Ce r\xE9glage n\u2019est pas partag\xE9 avec vos autres appareils.",
      label: "Sonnerie des appels"
    }
  },
  documentSettings: {
    title: "Documents",
    formLabel: "R\xE9glages des documents",
    loadFailedTitle: "Impossible d'afficher les r\xE9glages des documents",
    loadFailedBody: "Les r\xE9glages n'ont pas pu \xEAtre charg\xE9s. R\xE9essayez\xA0; si le probl\xE8me continue, contactez le support.",
    pattern: {
      title: "Mod\xE8le de code des documents",
      description: "Chaque document re\xE7oit un code compos\xE9 selon ce mod\xE8le\xA0: il sert \xE0 le rep\xE9rer sur les plans, les courriers et les bordereaux d'envoi.",
      label: "Mod\xE8le",
      hint: "Majuscules, chiffres et les signes - _ . uniquement. Les \xE9l\xE9ments {num} et {idx} sont obligatoires."
    },
    legend: {
      label: "\xC9l\xE9ments du mod\xE8le",
      PROJECT: "Code du projet",
      PHASE: "Phase (ESQ, APS, APD\u2026)",
      DISC: "Discipline (ARC, STR, VRD\u2026)",
      TYPE: "Type de document (PLN, NDC, RAP\u2026)",
      NUM: "Num\xE9ro d'ordre, attribu\xE9 par BatiFlow",
      IDX: "Indice de r\xE9vision (A, B\u2026 ou 0, 1\u2026)",
      ZONE: "Zone ou b\xE2timent, lorsqu'elle est renseign\xE9e"
    },
    example: {
      label: "Exemple de code",
      invalid: "Le mod\xE8le n'est pas encore valide\xA0: pas d'exemple.",
      sample: "Pour un plan de structure de la phase APS, premier document, zone RDC."
    },
    problems: {
      length: "Le mod\xE8le doit comporter entre 5 et 100 caract\xE8res.",
      characters: "Utilisez uniquement des majuscules, des chiffres, les signes - _ . et des \xE9l\xE9ments entre accolades.",
      unknownToken: "Un \xE9l\xE9ment entre accolades n'est pas reconnu\xA0: voir la liste ci-dessous.",
      braces: "Les accolades ne sont pas \xE9quilibr\xE9es.",
      needsNumberAndIndex: "Le mod\xE8le doit contenir les \xE9l\xE9ments {num} et {idx}."
    },
    serverRefused: "Le mod\xE8le n'a pas \xE9t\xE9 accept\xE9\xA0: il doit contenir {num} et {idx}, et seulement des \xE9l\xE9ments connus.",
    index: {
      title: "Style des indices de r\xE9vision",
      description: "Indice attribu\xE9 \xE0 chaque nouvelle version d'un document.",
      letters: "Lettres\xA0: A, B, C\u2026",
      numbers: "Chiffres\xA0: 0, 1, 2\u2026"
    },
    noChange: "Aucune modification \xE0 enregistrer.",
    saved: "Les r\xE9glages des documents sont enregistr\xE9s.",
    saving: "Enregistrement\u2026",
    saveFailedTitle: "Les r\xE9glages n'ont pas pu \xEAtre enregistr\xE9s",
    existingCodes: "Les codes d\xE9j\xE0 attribu\xE9s ne changent pas\xA0: le nouveau mod\xE8le s'applique aux nouveaux documents et \xE0 ceux dont les informations sont modifi\xE9es.",
    readOnly: "Seules les personnes autoris\xE9es \xE0 modifier l'organisation peuvent changer ces r\xE9glages."
  },
  storage: {
    title: "Stockage",
    loadFailedTitle: "Impossible de charger l'utilisation du stockage",
    loadFailedBody: "V\xE9rifiez votre connexion puis r\xE9essayez.",
    usage: {
      title: "Espace utilis\xE9",
      description: "Tous les fichiers de vos projets, versions comprises.",
      summary: "{used} utilis\xE9s sur {quota}",
      unlimited: "{used} utilis\xE9s. Votre contrat ne fixe pas de limite d'espace.",
      percent: "{percent} de l'espace est utilis\xE9",
      barLabel: "Espace de stockage utilis\xE9",
      notes: {
        warning: "Vous avez utilis\xE9 plus de 80\xA0% de votre espace. Pensez \xE0 supprimer les fichiers inutiles ou \xE0 acheter du stockage.",
        critical: "Il reste moins de 5\xA0% de votre espace. Lib\xE9rez de la place ou achetez du stockage avant que l'ajout de fichiers soit refus\xE9.",
        full: "Votre espace est plein\xA0: les nouveaux fichiers sont refus\xE9s. Lib\xE9rez de la place ou achetez du stockage."
      }
    },
    buy: {
      label: "Acheter du stockage",
      note: "L'achat de stockage sera disponible avec la facturation, qui arrive plus tard."
    },
    spaces: {
      title: "Stockage par projet",
      description: "Taille des fichiers de chaque projet et dernier calcul de cette taille.",
      caption: "Stockage par projet",
      columns: {
        name: "Projet ou espace",
        size: "Taille",
        reconciledAt: "Dernier calcul"
      },
      never: "Pas encore calcul\xE9",
      empty: {
        title: "Aucun fichier pour l'instant",
        description: "La taille de chaque projet appara\xEEtra ici d\xE8s qu'il contiendra des fichiers."
      }
    },
    files: {
      title: "Les 10 plus gros fichiers",
      description: "Les fichiers actuels qui prennent le plus de place. Supprimer ou remplacer un fichier inutile lib\xE8re de l'espace.",
      caption: "Les dix plus gros fichiers",
      columns: {
        code: "Code",
        title: "Titre",
        size: "Taille"
      },
      noCode: "Sans code",
      empty: {
        title: "Aucun fichier pour l'instant",
        description: "Les fichiers les plus volumineux appara\xEEtront ici."
      }
    }
  },
  realtime: {
    accessRevoked: {
      space: "Vous n'avez plus acc\xE8s \xE0 cet espace. Nous vous avons ramen\xE9 \xE0 la liste des projets.",
      organization: "Vous n'avez plus acc\xE8s \xE0 ce bureau d'\xE9tudes. Nous vous avons ramen\xE9 \xE0 l'accueil."
    }
  },
  guest: {
    badge: "Invit\xE9",
    navLabel: "Navigation de l'invit\xE9",
    nav: {
      spaces: "Mes espaces",
      invitations: "Invitations"
    }
  },
  finance: {
    nav: {
      label: "Sections de la finance"
    },
    empty: {
      quotes: {
        title: "Aucun devis pour le moment",
        body: "Les devis de votre bureau appara\xEEtront ici."
      },
      contracts: {
        title: "Aucun contrat pour le moment",
        body: "Les contrats conclus avec vos clients appara\xEEtront ici."
      },
      invoices: {
        title: "Aucune facture pour le moment",
        body: "Vos factures et leur \xE9tat d\u2019envoi appara\xEEtront ici."
      },
      payments: {
        title: "Aucun paiement enregistr\xE9",
        body: "Les paiements re\xE7us de vos clients appara\xEEtront ici."
      },
      expenses: {
        title: "Aucune note de frais",
        body: "Vos notes de frais appara\xEEtront ici."
      },
      suppliers: {
        title: "Aucun fournisseur pour le moment",
        body: "Vos fournisseurs et sous-traitants appara\xEEtront ici."
      },
      supplierInvoices: {
        title: "Aucune facture fournisseur",
        body: "Les factures re\xE7ues de vos fournisseurs appara\xEEtront ici."
      },
      withholding: {
        title: "Aucune retenue \xE0 afficher",
        body: "Les retenues du mois et les exports TEJ appara\xEEtront ici."
      },
      accounting: {
        title: "Pas encore d\u2019export",
        body: "Les exports comptables et les mois cl\xF4tur\xE9s appara\xEEtront ici."
      },
      dashboard: {
        title: "Pas encore d\u2019indicateurs",
        body: "Les chiffres cl\xE9s de la finance de votre bureau appara\xEEtront ici."
      },
      management: {
        title: "Pas encore de pilotage",
        body: "Les chiffres de gestion de votre bureau appara\xEEtront ici."
      },
      treasury: {
        title: "Pas encore de pr\xE9vision",
        body: "Les encaissements attendus sur 90 jours appara\xEEtront ici."
      },
      profitability: {
        title: "Pas encore de rentabilit\xE9 \xE0 afficher",
        body: "Les marges de vos projets appara\xEEtront ici."
      },
      costRates: {
        title: "Aucun taux de co\xFBt",
        body: "Les taux de co\xFBt de votre \xE9quipe appara\xEEtront ici."
      },
      einvoicing: {
        title: "Pas encore de certificat",
        body: "Le mode de facturation \xE9lectronique et vos certificats de signature appara\xEEtront ici."
      }
    }
  },
  billing: {
    locked: {
      read_only: {
        owner: "Le compte de votre bureau est en lecture seule. R\xE9glez l'abonnement pour pouvoir de nouveau cr\xE9er et modifier.",
        member: "Le compte de votre bureau est en lecture seule. Demandez au propri\xE9taire de votre bureau de r\xE9gler l'abonnement."
      },
      suspended: {
        owner: "Le compte de votre bureau est suspendu. R\xE9glez l'abonnement pour le r\xE9activer.",
        member: "Le compte de votre bureau est suspendu. Demandez au propri\xE9taire de votre bureau de r\xE9gler l'abonnement."
      }
    },
    banner: {
      trial_ending: {
        title: "Votre p\xE9riode d'essai se termine bient\xF4t",
        body: "{count, plural, =0 {Votre p\xE9riode d'essai se termine aujourd'hui, le {date}.} one {Il reste {n} jour d'essai, jusqu'au {date}.} other {Il reste {n} jours d'essai, jusqu'au {date}.}}",
        owner: "Choisissez un forfait pour garder l'acc\xE8s complet \xE0 votre bureau.",
        member: "Demandez au propri\xE9taire de votre bureau de choisir un forfait."
      },
      read_only_trial: {
        title: "Votre p\xE9riode d'essai est termin\xE9e",
        body: "Votre bureau est en lecture seule : vous pouvez consulter et exporter vos donn\xE9es, mais plus cr\xE9er ni modifier.",
        owner: "Choisissez un forfait et payez la facture pour tout r\xE9activer.",
        member: "Demandez au propri\xE9taire de votre bureau de choisir un forfait."
      },
      read_only_unpaid: {
        title: "Votre bureau est en lecture seule",
        body: "L'abonnement n'est pas r\xE9gl\xE9 : vous pouvez consulter et exporter vos donn\xE9es, mais plus cr\xE9er ni modifier.",
        owner: "R\xE9glez l'abonnement pour tout r\xE9activer.",
        member: "Demandez au propri\xE9taire de votre bureau de r\xE9gler l'abonnement."
      },
      suspended: {
        title: "Votre bureau est suspendu",
        body: "Votre bureau est suspendu faute de paiement. Vous pouvez encore exporter vos donn\xE9es ; sans r\xE8glement, elles seront supprim\xE9es \xE0 terme.",
        owner: "R\xE9glez l'abonnement pour r\xE9activer votre bureau.",
        member: "Demandez au propri\xE9taire de votre bureau de r\xE9gler l'abonnement."
      },
      past_due: {
        title: "Un paiement est en retard",
        body: "Votre facture d'abonnement est impay\xE9e depuis le {date}. Sans r\xE8glement, le bureau passera en lecture seule.",
        owner: "Payez la facture pour \xE9viter toute interruption.",
        member: "Demandez au propri\xE9taire de votre bureau de r\xE9gler l'abonnement."
      },
      paused: {
        title: "Votre abonnement est en pause",
        body: "L'abonnement est en pause jusqu'au {date}.",
        owner: "Reprenez-le d\xE8s que vous en avez besoin.",
        member: "Demandez au propri\xE9taire de votre bureau de le reprendre."
      },
      cancelling: {
        title: "Votre abonnement va se terminer",
        body: "L'abonnement prend fin le {date} ; le bureau passera alors en lecture seule.",
        owner: "Vous avez chang\xE9 d'avis ? Vous pouvez annuler la r\xE9siliation avant cette date.",
        member: "Demandez au propri\xE9taire de votre bureau si vous souhaitez le conserver."
      },
      cancelled: {
        title: "Votre abonnement est r\xE9sili\xE9",
        body: "L'abonnement a pris fin le {date} : votre bureau est en lecture seule. Vous pouvez encore consulter et exporter vos donn\xE9es.",
        owner: "Choisissez un forfait pour tout r\xE9activer.",
        member: "Demandez au propri\xE9taire de votre bureau de reprendre un abonnement."
      },
      action: {
        choose: "Choisir un forfait",
        pay: "Payer la facture",
        resume: "Reprendre",
        withdraw: "Annuler la r\xE9siliation",
        view: "Voir l'abonnement"
      }
    }
  },
  subscription: {
    title: "Abonnement",
    loadFailedTitle: "Impossible de charger l'abonnement",
    loadFailedBody: "V\xE9rifiez votre connexion puis r\xE9essayez.",
    readOnlyNote: "Vous consultez l'abonnement en lecture seule. Seul le propri\xE9taire du bureau peut le modifier ou payer les factures.",
    enterpriseNote: "Votre forfait Enterprise est g\xE9r\xE9 par contrat. Pour le modifier, contactez l'\xE9quipe commerciale de BatiFlow.",
    pay: "Payer",
    taxIncluded: "TTC",
    status: {
      trialing: "P\xE9riode d'essai",
      active: "Actif",
      past_due: "Paiement en retard",
      read_only: "Lecture seule",
      suspended: "Suspendu",
      paused: "En pause",
      cancelled: "R\xE9sili\xE9"
    },
    plans: {
      solo: "Solo",
      starter: "Starter",
      pro: "Pro",
      business: "Business",
      enterprise: "Enterprise"
    },
    cycle: {
      monthly: "Mensuel",
      annual: "Annuel"
    },
    paymentMethods: {
      card: "Carte bancaire",
      bank_transfer: "Virement bancaire",
      cheque: "Ch\xE8que",
      online: "Paiement en ligne",
      transfer: "Virement bancaire"
    },
    current: {
      title: "Votre forfait",
      description: "Le forfait, l'\xE9tat et le prix de votre abonnement BatiFlow (prix hors taxes).",
      plan: "Forfait",
      cycle: "Facturation",
      period: "P\xE9riode en cours",
      periodRange: "du {start} au {end}",
      nextDue: "Prochaine \xE9ch\xE9ance",
      noDue: "Aucune",
      trialEnds: "Fin de l'essai",
      price: "Prix par p\xE9riode (HT)",
      onQuote: "Sur devis",
      perPeriod: {
        monthly: "par mois",
        annual: "par an"
      },
      extras: "Options",
      noExtras: "Aucune option",
      extraSeatsValue: "{count, plural, one {{n} si\xE8ge suppl\xE9mentaire} other {{n} si\xE8ges suppl\xE9mentaires}}",
      addonValue: "{count, plural, one {{n} \xD7 {size} de stockage} other {{n} \xD7 {size} de stockage}}",
      payment: "Mode de paiement",
      paymentNone: "Pas encore choisi",
      paymentHelp: "Chaque facture se r\xE8gle en ligne par carte bancaire, ou par virement ou ch\xE8que : dans ce cas, l'\xE9quipe BatiFlow confirme la r\xE9ception du paiement."
    },
    openInvoice: {
      title: "La facture {number} attend son paiement",
      body: "Montant \xE0 r\xE9gler :"
    },
    pending: {
      title: "Un changement est pr\xE9vu",
      scheduled: "Le {date}, votre abonnement passera au forfait {plan} ({cycle}).",
      pause: "\xC0 partir du {date}, votre abonnement sera en pause pendant {count, plural, one {{n} mois} other {{n} mois}}.",
      cancel: "Votre abonnement sera r\xE9sili\xE9 le {date}.",
      withdraw: "Annuler ce changement",
      withdrawn: "Le changement pr\xE9vu est annul\xE9."
    },
    usage: {
      title: "Utilisation",
      description: "Ce que votre bureau utilise, compar\xE9 aux limites de votre forfait.",
      seats: "Si\xE8ges",
      storage: "Stockage",
      hostedSpaces: "Espaces partag\xE9s h\xE9berg\xE9s",
      of: "{used} sur {limit}",
      unlimitedOf: "{used} (sans limite)",
      percent: "{percent} %"
    },
    compare: {
      title: "Comparer les forfaits",
      description: "Prix hors taxes. L'abonnement annuel co\xFBte 10 mois au lieu de 12.",
      caption: "Comparaison des forfaits BatiFlow",
      loading: "Chargement des forfaits\u2026",
      failed: "Impossible de charger les forfaits pour le moment.",
      current: "Votre forfait",
      monthly: "Prix mensuel (HT)",
      annual: "Prix annuel (HT)",
      seats: "Si\xE8ges inclus",
      extraSeat: "Si\xE8ge suppl\xE9mentaire (par mois)",
      storage: "Stockage inclus",
      hostedSpaces: "Espaces partag\xE9s h\xE9berg\xE9s",
      meetingParticipants: "Participants par r\xE9union",
      unlimited: "Illimit\xE9",
      byContract: "Selon contrat",
      onQuote: "Sur devis",
      notOffered: "Non propos\xE9",
      enterprise: "Le forfait Enterprise est vendu sur devis : contactez l'\xE9quipe commerciale de BatiFlow."
    },
    change: {
      button: "Modifier l'abonnement",
      title: "Modifier l'abonnement",
      intro: "Choisissez le forfait, la p\xE9riode de facturation et les options. Le prix s'affiche avant toute confirmation.",
      plan: "Forfait",
      planOnQuote: "{plan} (sur devis)",
      cycle: "Facturation",
      cycleHint: "Annuel : 10 mois pay\xE9s pour 12.",
      extraSeats: "Si\xE8ges suppl\xE9mentaires",
      noExtraSeats: "Ce forfait ne propose pas de si\xE8ge suppl\xE9mentaire.",
      addon: "Stockage suppl\xE9mentaire {size}",
      stepUpNote: "Pour valider le changement, vous devrez confirmer votre identit\xE9.",
      confirm: "Confirmer le changement",
      confirmPay: "Confirmer et recevoir la facture",
      confirming: "Envoi en cours\u2026",
      scheduledDone: "Changement planifi\xE9 : il s'appliquera le {date}."
    },
    quote: {
      title: "Aper\xE7u du prix",
      loading: "Calcul du prix\u2026",
      unchanged: "Choisissez un autre forfait ou d'autres options pour voir le prix.",
      caption: "D\xE9tail du prix",
      columns: {
        label: "D\xE9tail",
        quantity: "Qt\xE9",
        unitPrice: "Prix unitaire",
        amount: "Montant"
      },
      totalHt: "Total HT",
      totalTtc: "Total TTC",
      kind: {
        start: "Votre abonnement payant commence. Une facture est \xE9mise maintenant ; le changement s'applique d\xE8s qu'elle est pay\xE9e. Nouvelle p\xE9riode : du {start} au {end}.",
        upgrade: "Une facture au prorata ({remaining} jours restants sur {total}) est \xE9mise maintenant ; le changement s'applique d\xE8s qu'elle est pay\xE9e.",
        restart: "Votre abonnement red\xE9marre. Une facture est \xE9mise maintenant ; il reprend d\xE8s qu'elle est pay\xE9e. Nouvelle p\xE9riode : du {start} au {end}.",
        scheduled: "Aucun paiement maintenant. Le changement s'appliquera le {date}, \xE0 la fin de la p\xE9riode en cours.",
        none: "Aucun changement : ce choix est celui de votre abonnement actuel."
      },
      lines: {
        plan: "Forfait",
        extra_seats: "Si\xE8ges suppl\xE9mentaires",
        addon: "Stockage suppl\xE9mentaire {size}",
        proration: "Ajustement au prorata",
        credit_unused: "Cr\xE9dit de la p\xE9riode non utilis\xE9e",
        pause: "Pause (20 % du prix)",
        fair_billing: "Cr\xE9dit de facturation \xE9quitable"
      },
      blockedTitle: "Ce forfait est trop petit pour votre usage actuel. Pour le choisir :",
      blockers: {
        seats: "R\xE9duisez les si\xE8ges de {used} \xE0 {limit}.",
        storage: "Lib\xE9rez du stockage : {used} utilis\xE9s pour {limit} disponibles.",
        hosted_spaces: "R\xE9duisez les espaces partag\xE9s h\xE9berg\xE9s de {used} \xE0 {limit}."
      },
      reduce: {
        seats: "R\xE9duisez le nombre de si\xE8ges utilis\xE9s.",
        storage: "Lib\xE9rez du stockage.",
        hostedSpaces: "R\xE9duisez le nombre d'espaces partag\xE9s h\xE9berg\xE9s."
      }
    },
    invoiceIssued: {
      title: "Facture {number} \xE9mise",
      amount: "Montant \xE0 r\xE9gler :",
      later: "Plus tard",
      applies: {
        start: "Le changement s'applique d\xE8s que la facture est pay\xE9e.",
        upgrade: "Le changement s'applique d\xE8s que la facture est pay\xE9e.",
        restart: "L'abonnement reprend d\xE8s que la facture est pay\xE9e.",
        renewal: "Le renouvellement est confirm\xE9 d\xE8s que la facture est pay\xE9e.",
        resume: "L'abonnement reprend d\xE8s que la facture est pay\xE9e."
      }
    },
    invoices: {
      title: "Factures d'abonnement",
      description: "Les factures que BatiFlow vous a \xE9mises. Les factures ouvertes se r\xE8glent en ligne.",
      caption: "Factures d'abonnement BatiFlow",
      columns: {
        number: "Num\xE9ro",
        purpose: "Objet",
        issueDate: "\xC9mise le",
        dueDate: "\xC0 payer avant le",
        total: "Total TTC",
        status: "\xC9tat",
        actions: "Actions"
      },
      purpose: {
        start: "D\xE9but d'abonnement",
        upgrade: "Changement de forfait",
        restart: "Red\xE9marrage",
        renewal: "Renouvellement",
        resume: "Reprise apr\xE8s pause"
      },
      status: {
        open: "\xC0 payer",
        paid: "Pay\xE9e",
        void: "Annul\xE9e"
      },
      pdf: "PDF",
      pdfFor: "T\xE9l\xE9charger le PDF de la facture {number}",
      payFor: "Payer la facture {number}",
      loadFailedTitle: "Impossible de charger les factures",
      empty: {
        title: "Aucune facture pour l'instant",
        description: "Vos factures d'abonnement appara\xEEtront ici."
      }
    },
    actions: {
      title: "G\xE9rer l'abonnement",
      description: "Renouveler, mettre en pause ou r\xE9silier. Ces actions sont r\xE9serv\xE9es au propri\xE9taire du bureau.",
      renew: {
        title: "Renouveler maintenant",
        hint: "Votre p\xE9riode en cours se termine le {date}. Renouvelez d\xE8s maintenant pour recevoir la facture de la p\xE9riode suivante.",
        button: "Renouveler",
        confirmTitle: "Renouveler l'abonnement ?",
        confirmBody: "Une facture de renouvellement est \xE9mise maintenant pour la p\xE9riode qui suit le {date}. Vous pourrez la payer tout de suite.",
        confirm: "Renouveler"
      },
      pause: {
        title: "Mettre en pause",
        hint: "{count, plural, one {Il vous reste {n} mois de pause cette ann\xE9e (3 au maximum).} other {Il vous reste {n} mois de pause cette ann\xE9e (3 au maximum).}} Pendant la pause, vous payez 20 % du prix.",
        none: "Vous avez utilis\xE9 les 3 mois de pause permis cette ann\xE9e.",
        duration: "Dur\xE9e de la pause",
        option: "{count, plural, one {{n} mois} other {{n} mois}}",
        button: "Mettre en pause",
        confirmTitle: "Mettre l'abonnement en pause ?",
        confirmBody: "La pause commence \xE0 la fin de la p\xE9riode en cours ({date}) et dure {count, plural, one {{n} mois} other {{n} mois}}. Vous payez 20 % du prix pour ces mois, au moment de la reprise. Vous pouvez reprendre quand vous le souhaitez.",
        confirm: "Mettre en pause",
        done: "Pause planifi\xE9e \xE0 partir du {date}."
      },
      resume: {
        title: "Reprendre l'abonnement",
        hint: "Votre abonnement est en pause jusqu'au {date}. Vous pouvez le reprendre plus t\xF4t.",
        hintNoDate: "Votre abonnement est en pause. Reprenez-le quand vous le souhaitez.",
        button: "Reprendre",
        confirmTitle: "Reprendre l'abonnement ?",
        confirmBody: "Une facture est \xE9mise maintenant : les mois de pause \xE0 20 % du prix, plus une nouvelle p\xE9riode. L'abonnement reprend d\xE8s qu'elle est pay\xE9e.",
        confirm: "Reprendre"
      },
      cancel: {
        title: "R\xE9silier l'abonnement",
        hint: "La r\xE9siliation prend effet \xE0 la fin de la p\xE9riode en cours, le {date}.",
        button: "R\xE9silier",
        confirmTitle: "R\xE9silier l'abonnement ?",
        confirmBody: "Votre abonnement reste actif jusqu'au {date}, puis il prend fin.",
        afterwards: "Ensuite, votre bureau passe en lecture seule pendant 90 jours : vous pouvez consulter et exporter vos donn\xE9es. Pass\xE9 ce d\xE9lai, elles sont supprim\xE9es. Tant que la p\xE9riode n'est pas termin\xE9e, vous pouvez annuler la r\xE9siliation.",
        confirm: "R\xE9silier l'abonnement",
        done: "R\xE9siliation planifi\xE9e : l'abonnement prendra fin le {date}."
      }
    }
  },
  dataExport: {
    columns: {
      requestedAt: "Demand\xE9 le",
      scope: "Type",
      requestedBy: "Demand\xE9 par",
      status: "\xC9tat",
      size: "Taille",
      expiresAt: "Disponible jusqu'au",
      actions: "Actions"
    },
    scope: {
      organization: "Complet",
      finance: "Finances"
    },
    status: {
      queued: "En file d'attente",
      running: "En pr\xE9paration",
      ready: "Pr\xEAt",
      failed: "\xC9chec",
      expired: "Expir\xE9"
    },
    download: "T\xE9l\xE9charger",
    downloadFor: "T\xE9l\xE9charger l'export demand\xE9 le {date}",
    none: "Non disponible"
  },
  adminData: {
    title: "Donn\xE9es et suppression",
    loadFailedBody: "V\xE9rifiez votre connexion puis r\xE9essayez.",
    export: {
      title: "Exporter les donn\xE9es",
      descriptionFull: "Un export complet rassemble toutes les donn\xE9es de l'organisation dans un seul fichier.",
      descriptionFinance: "Votre r\xF4le vous permet d'exporter uniquement les donn\xE9es financi\xE8res de l'organisation. L'export complet est r\xE9serv\xE9 au propri\xE9taire et aux administrateurs.",
      contents: {
        tables: "Chaque table de donn\xE9es, au format JSON.",
        documents: "Les documents, rang\xE9s dans leurs dossiers.",
        pdfs: "Les PDF g\xE9n\xE9r\xE9s par BatiFlow.",
        finance: "Les donn\xE9es financi\xE8res de l'organisation, et elles seulement."
      },
      retention: "Le fichier ZIP est conserv\xE9 7 jours, puis supprim\xE9.",
      notification: "La personne qui demande l'export re\xE7oit une notification d\xE8s qu'il est pr\xEAt.",
      buttonFull: "Pr\xE9parer un export complet",
      buttonFinance: "Pr\xE9parer un export des finances",
      requested: "Votre export est en pr\xE9paration. Vous recevrez une notification quand il sera pr\xEAt.",
      caption: "Exports de donn\xE9es de l'organisation",
      loadFailedTitle: "Impossible de charger les exports",
      empty: {
        title: "Aucun export pour le moment",
        description: "Pr\xE9parez un export pour obtenir une copie des donn\xE9es de l'organisation."
      }
    },
    delete: {
      title: "Supprimer l'organisation",
      description: "Cette action est d\xE9finitive. Lisez ce qui suit avant de continuer.",
      points: {
        delay: "La suppression a lieu 90 jours apr\xE8s votre demande. Jusqu'\xE0 cette date, vous pouvez l'annuler.",
        irreversible: "Elle est irr\xE9versible : toutes les donn\xE9es et tous les fichiers de l'organisation sont effac\xE9s, et les comptes des personnes qui n'appartiennent \xE0 aucune autre organisation sont ferm\xE9s.",
        kept: "Sont conserv\xE9s : le nom et l'identifiant fiscal de l'organisation (pour l'attestation de suppression) et le journal d'audit pendant 3 ans.",
        export: "Avant de commencer, pr\xE9parez un export complet pour garder une copie de vos donn\xE9es."
      },
      button: "Supprimer l'organisation",
      loadFailedTitle: "Impossible de charger l'\xE9tat de la suppression",
      running: {
        title: "La suppression est en cours",
        body: "Les donn\xE9es de l'organisation sont en train d'\xEAtre effac\xE9es. Elle ne peut plus \xEAtre arr\xEAt\xE9e."
      },
      scheduled: {
        title: "La suppression est programm\xE9e le {date}",
        by: "Demand\xE9e par {name}.",
        reasons: {
          unpaid: "Elle a \xE9t\xE9 d\xE9clench\xE9e parce que l'abonnement n'est pas pay\xE9.",
          trial_expired: "Elle a \xE9t\xE9 d\xE9clench\xE9e parce que la p\xE9riode d'essai est termin\xE9e sans abonnement.",
          cancelled: "Elle a \xE9t\xE9 d\xE9clench\xE9e parce que l'abonnement a \xE9t\xE9 r\xE9sili\xE9.",
          owner_request: "Vous pouvez l'annuler tant qu'elle n'a pas commenc\xE9.",
          platform_admin: "Elle a \xE9t\xE9 d\xE9cid\xE9e par le support BatiFlow."
        },
        payToStop: "R\xE9gler l'abonnement arr\xEAte la suppression.",
        subscriptionLink: "Aller \xE0 l'abonnement",
        cancel: "Annuler la suppression",
        cancelTitle: "Annuler la suppression de l'organisation ?",
        cancelBody: "La suppression pr\xE9vue le {date} n'aura pas lieu. L'organisation et ses donn\xE9es restent comme aujourd'hui.",
        cancelConfirm: "Oui, annuler la suppression",
        cancelKeep: "Non, la laisser programm\xE9e",
        cancelled: "La suppression est annul\xE9e."
      },
      dialog: {
        title: "Supprimer l'organisation",
        intro: "Vous demandez la suppression d\xE9finitive de {name}. Elle aura lieu dans 90 jours.",
        exportRecent: "Un export complet de moins de 30 jours est pr\xEAt (pr\xE9par\xE9 le {date}). Pensez \xE0 le t\xE9l\xE9charger avant la suppression.",
        exportNone: "Aucun export complet de moins de 30 jours n'est disponible. Pr\xE9parez-en un dans la section \xAB Exporter les donn\xE9es \xBB avant de continuer, ou indiquez ci-dessous que vous n'en voulez pas.",
        decline: "Je ne souhaite pas d'export de mes donn\xE9es",
        confirmLabel: "Saisissez la raison sociale pour confirmer",
        confirmHint: "Recopiez exactement : {name}",
        stepUpNote: "Pour votre s\xE9curit\xE9, nous vous demanderons de confirmer votre identit\xE9.",
        submit: "Programmer la suppression",
        done: "La suppression est programm\xE9e.",
        errors: {
          mismatch: "Ce texte n'est pas la raison sociale de l'organisation.",
          exportChoice: "Cochez cette case pour continuer sans export, ou pr\xE9parez d'abord un export complet."
        }
      }
    }
  },
  meData: {
    title: "Mes donn\xE9es personnelles",
    description: "La loi organique n\xB0 2004-63 vous donne le droit d'acc\xE9der aux donn\xE9es personnelles que BatiFlow d\xE9tient sur vous.",
    button: "Exporter mes donn\xE9es",
    note: "Vous recevez une notification quand l'export est pr\xEAt. Le tableau indique jusqu'\xE0 quand le t\xE9l\xE9charger.",
    requested: "Votre export est en pr\xE9paration. Vous recevrez une notification quand il sera pr\xEAt.",
    caption: "Mes exports de donn\xE9es",
    loadFailed: "Impossible de charger vos exports. V\xE9rifiez votre connexion puis r\xE9essayez.",
    empty: {
      title: "Aucun export pour le moment",
      description: "Demandez un export pour recevoir une copie de vos donn\xE9es personnelles."
    }
  },
  statusMessage: {
    title: "Message de statut",
    description: "Vos coll\xE8gues le voient \xE0 c\xF4t\xE9 de votre statut ({max} caract\xE8res au maximum).",
    label: "Votre message",
    counter: "{length} / {max}",
    save: "Enregistrer",
    clear: "Effacer le message",
    cancel: "Annuler",
    saved: "Votre message de statut est enregistr\xE9.",
    cleared: "Votre message de statut est effac\xE9."
  },
  customRoles: {
    title: "R\xF4les personnalis\xE9s",
    intro: "Cr\xE9ez des r\xF4les propres \xE0 votre bureau \xE0 partir d'un r\xF4le de base, puis ajustez les droits un par un. Cette fonction est incluse dans l'offre Business.",
    loading: "Chargement des r\xF4les\u2026",
    loadFailed: "Impossible de charger les r\xF4les personnalis\xE9s.",
    upsell: "Les r\xF4les personnalis\xE9s sont inclus dans l'offre Business. Demandez au propri\xE9taire du compte de passer \xE0 cette offre pour cr\xE9er vos propres r\xF4les.",
    empty: "Aucun r\xF4le personnalis\xE9 pour le moment. Utilisez \xAB\xA0Nouveau r\xF4le\xA0\xBB pour en cr\xE9er un.",
    caption: "R\xF4les personnalis\xE9s de votre bureau",
    columns: {
      name: "Nom",
      basedOn: "Bas\xE9 sur",
      keys: "Droits",
      members: "Membres",
      invitations: "Invitations en attente",
      actions: "Actions"
    },
    new: "Nouveau r\xF4le",
    actions: {
      edit: "Modifier le r\xF4le {name}",
      editShort: "Modifier",
      delete: "Supprimer le r\xF4le {name}",
      deleteShort: "Supprimer",
      inUse: "R\xF4le encore attribu\xE9 (membres\xA0: {members}, invitations\xA0: {invitations}). Changez d'abord leur r\xF4le pour pouvoir le supprimer."
    },
    create: {
      title: "Nouveau r\xF4le personnalis\xE9",
      intro: "Choisissez un nom et le r\xF4le de base. Vous r\xE9glerez ensuite les droits dans l'\xE9diteur.",
      name: "Nom du r\xF4le",
      basedOn: "Bas\xE9 sur",
      basePlaceholder: "Choisir un r\xF4le de base",
      nameRequired: "Indiquez un nom pour ce r\xF4le.",
      baseRequired: "Choisissez le r\xF4le de base.",
      submit: "Cr\xE9er et r\xE9gler les droits",
      saving: "Cr\xE9ation\u2026"
    },
    editor: {
      title: "R\xF4le {name}",
      intro: "R\xF4le bas\xE9 sur \xAB\xA0{base}\xA0\xBB. Activez ou d\xE9sactivez chaque droit.",
      reset: "R\xE9initialiser au r\xF4le de base",
      count: "Droits activ\xE9s\xA0: {total}",
      locked: "Suit le r\xF4le de base\xA0: ce droit ne peut pas \xEAtre modifi\xE9.",
      notHeld: "Vous ne disposez pas de ce droit",
      save: "Enregistrer",
      saving: "Enregistrement\u2026",
      saved: "Le r\xF4le \xAB\xA0{name}\xA0\xBB est enregistr\xE9.",
      stale: "Le r\xF4le \xAB\xA0{name}\xA0\xBB a \xE9t\xE9 modifi\xE9 par quelqu'un d'autre. La liste est recharg\xE9e\xA0: rouvrez le r\xF4le puis appliquez \xE0 nouveau vos changements."
    },
    delete: {
      title: "Supprimer le r\xF4le \xAB\xA0{name}\xA0\xBB\xA0?",
      body: "Ce r\xF4le sera supprim\xE9 d\xE9finitivement. Aucun membre ni aucune invitation ne l'utilise.",
      confirm: "Supprimer",
      done: "Le r\xF4le \xAB\xA0{name}\xA0\xBB est supprim\xE9.",
      inUse: "Ce r\xF4le est encore attribu\xE9 \xE0 des membres ou \xE0 des invitations en attente. Changez d'abord leur r\xF4le.",
      stale: "Ce r\xF4le a \xE9t\xE9 modifi\xE9 entre-temps. La liste est recharg\xE9e\xA0: r\xE9essayez."
    },
    escalation: "Vous ne pouvez pas accorder des droits que vous n'avez pas vous-m\xEAme\xA0: {keys}.",
    stepUpNote: "Pour votre s\xE9curit\xE9, il vous sera demand\xE9 de confirmer votre identit\xE9.",
    picker: {
      group: "R\xF4les personnalis\xE9s",
      hint: "R\xF4le personnalis\xE9 bas\xE9 sur \xAB\xA0{base}\xA0\xBB."
    }
  },
  directory: {
    title: "Annuaire des bureaux",
    intro: "Les bureaux d'\xE9tudes BatiFlow qui ont choisi d'y figurer. Contactez-les par message, ou retrouvez-les pour un partenariat.",
    searchLabel: "Rechercher un bureau",
    searchPlaceholder: "Nom du bureau",
    disciplineLabel: "Discipline",
    governorateLabel: "Gouvernorat",
    allDisciplines: "Toutes les disciplines",
    allGovernorates: "Tous les gouvernorats",
    clear: "Effacer les filtres",
    resultsLabel: "Bureaux de l'annuaire",
    empty: {
      title: "Aucun bureau dans l'annuaire pour l'instant",
      description: "Les bureaux apparaissent ici lorsqu'ils choisissent d'\xEAtre visibles."
    },
    emptyFiltered: {
      title: "Aucun bureau ne correspond",
      description: "Essayez un autre nom ou retirez un filtre."
    },
    loadFailedTitle: "Impossible d'afficher l'annuaire",
    loadFailedBody: "R\xE9essayez\xA0; si le probl\xE8me continue, contactez le support.",
    moreFailed: "La suite de la liste n'a pas pu \xEAtre charg\xE9e. R\xE9essayez.",
    more: "Afficher plus",
    loadingMore: "Chargement\u2026",
    location: "{governorate}, {city}",
    contact: {
      button: "Contacter",
      buttonLabel: "Contacter {name}",
      title: "Contacter {name}",
      intro: "Votre message est envoy\xE9 par e-mail aux propri\xE9taires et aux administrateurs de ce bureau.",
      replyNote: "Leur r\xE9ponse arrivera \xE0 votre adresse e-mail. Elle sera visible par ce bureau.",
      subject: "Objet",
      message: "Message",
      counter: "{count} / {max} caract\xE8res",
      send: "Envoyer le message",
      sending: "Envoi\u2026",
      sent: "Votre message a \xE9t\xE9 envoy\xE9 \xE0 {name}.",
      errors: {
        subjectRequired: "Indiquez l'objet de votre message.",
        messageRequired: "\xC9crivez votre message.",
        emailNotVerified: "Confirmez d'abord votre adresse e-mail pour \xE9crire \xE0 un bureau.",
        notFound: "Ce bureau n'est plus dans l'annuaire. Actualisez la liste.",
        rateLimited: "Vous avez envoy\xE9 beaucoup de messages. R\xE9essayez dans une heure."
      }
    },
    count: "{count, plural, =0 {Aucun bureau} one {# bureau} other {# bureaux}}",
    countMore: "{count, plural, one {Plus de # bureau} other {Plus de # bureaux}}"
  },
  timesheets: {
    upgrade: {
      title: "La saisie des temps n\u2019est pas incluse dans votre offre",
      body: "Passez \xE0 une offre sup\xE9rieure pour saisir les heures de l\u2019\xE9quipe, faire approuver les semaines et suivre la charge."
    },
    title: "Temps",
    tabsLabel: "Sections du suivi du temps",
    tabs: {
      week: "Ma semaine",
      approvals: "\xC0 approuver",
      capacity: "Charge de l\u2019\xE9quipe",
      leave: "Absences"
    },
    duration: {
      h: "{h} h",
      hm: "{h} h {m}"
    },
    categories: {
      studies: "\xC9tudes",
      site: "Chantier",
      meeting: "R\xE9union",
      travel: "D\xE9placement",
      admin: "Administratif",
      other: "Autre"
    },
    line: {
      noPhase: "Sans phase",
      phase: "Phase",
      name: "{project}, {phase}, {category}"
    },
    week: {
      navLabel: "Choisir la semaine",
      prev: "Semaine pr\xE9c\xE9dente",
      next: "Semaine suivante",
      today: "Cette semaine",
      label: "Semaine du {range}",
      total: "Total de la semaine\xA0:",
      totalOnly: "Total de la semaine\xA0:",
      outOf: "sur",
      overCapacity: "Au-dessus de la capacit\xE9 de la semaine",
      statusOpen: "Semaine en cours de saisie",
      statusSubmitted: "Semaine soumise le {date}",
      lockedNotice: "Cette semaine est soumise\xA0: elle ne peut plus \xEAtre modifi\xE9e tant que vos responsables n\u2019ont pas d\xE9cid\xE9.",
      capacityUnknown: "La capacit\xE9 de cette semaine n\u2019est pas connue\xA0: le calendrier des jours f\xE9ri\xE9s de l\u2019ann\xE9e est absent."
    },
    empty: {
      title: "Aucune ligne pour cette semaine",
      description: "Ajoutez une ligne (projet, phase, cat\xE9gorie) puis saisissez vos heures jour par jour."
    },
    grid: {
      label: "Saisie du temps de la semaine",
      line: "Projet, phase et cat\xE9gorie",
      total: "Total",
      dayTotal: "Total du jour",
      help: "Fl\xE8ches pour passer d\u2019une cellule \xE0 l\u2019autre, Entr\xE9e pour saisir une dur\xE9e (par exemple 7:30 ou 7,5), Entr\xE9e pour valider, \xC9chap pour annuler, Suppr pour effacer. Les dur\xE9es vont par quarts d\u2019heure.",
      helpLocked: "La semaine est soumise\xA0: les cellules sont en lecture seule.",
      cellLabel: "{where}\xA0: {value}",
      cellValue: "{duration}",
      cellEmpty: "aucune saisie",
      editing: "saisie en cours",
      multiple: "plusieurs saisies, non modifiable ici",
      statuses: {
        draft: "brouillon",
        submitted: "soumise",
        approved: "approuv\xE9e",
        rejected: "refus\xE9e"
      },
      reason: "motif\xA0: {reason}",
      holiday: "F\xE9ri\xE9\xA0: {name}",
      estimated: "estim\xE9e",
      leave: "Absence",
      removeLine: "Retirer la ligne {line}",
      invalid: {
        format: "Saisissez une dur\xE9e comme 7:30, 7,5 ou 2h30.",
        step: "Le temps se saisit par quarts d\u2019heure (15 minutes).",
        max: "Une journ\xE9e ne peut pas d\xE9passer 24 heures."
      },
      title: "Feuille de temps",
      legend: "L\xE9gende de la feuille de temps",
      legendStatuses: {
        draft: "Brouillon",
        submitted: "Soumise",
        approved: "Approuv\xE9e",
        rejected: "Refus\xE9e"
      },
      legendOff: "Week-end, f\xE9ri\xE9 ou absence",
      today: "Aujourd'hui"
    },
    addLine: {
      open: "Ajouter une ligne",
      title: "Nouvelle ligne de temps",
      add: "Ajouter la ligne",
      noProjects: "Vous ne travaillez sur aucun projet. Demandez \xE0 un responsable de projet de vous ajouter \xE0 l\u2019\xE9quipe."
    },
    picker: {
      project: "Projet",
      projectPlaceholder: "Choisir un projet",
      phase: "Phase (facultatif)",
      category: "Cat\xE9gorie"
    },
    submit: {
      button: "Soumettre la semaine",
      title: "Soumettre la semaine\xA0?",
      body: "Vous soumettez {total} pour la semaine du {range}. Une fois soumise, la semaine ne peut plus \xEAtre modifi\xE9e tant que vos responsables n\u2019ont pas d\xE9cid\xE9.",
      confirm: "Soumettre",
      done: "Semaine soumise."
    },
    rejected: {
      title: "Saisies refus\xE9es",
      item: "{project}, {day} ({duration})\xA0: {reason}.",
      noReason: "aucun motif indiqu\xE9",
      by: "Refus\xE9e par {name}.",
      hint: "Corrigez ces saisies, puis soumettez de nouveau la semaine."
    },
    loadFailed: {
      title: "Impossible de charger la semaine",
      body: "V\xE9rifiez votre connexion puis r\xE9essayez."
    },
    timer: {
      title: "Chronom\xE8tre",
      description: "D\xE9marrez le chronom\xE8tre sur un projet. \xC0 l\u2019arr\xEAt, le temps est arrondi au quart d\u2019heure sup\xE9rieur et ajout\xE9 \xE0 la journ\xE9e d\u2019aujourd\u2019hui.",
      start: "D\xE9marrer",
      stop: "Arr\xEAter et ajouter",
      discard: "Abandonner",
      elapsed: "Temps \xE9coul\xE9\xA0: {time}",
      roundedTo: "Sera ajout\xE9\xA0:",
      added: "{duration} ajout\xE9es \xE0 aujourd\u2019hui.",
      unknownProject: "Projet",
      running: "En cours"
    },
    approvals: {
      description: "Saisies de temps soumises sur les projets que vous dirigez. Cochez-les pour les approuver ou les refuser.",
      weekFilter: "Semaine",
      allWeeks: "Toutes les semaines",
      approve: "Approuver la s\xE9lection ({count})",
      reject: "Refuser la s\xE9lection ({count})",
      group: "{name}, semaine du {range}",
      selectGroup: "S\xE9lectionner toutes les saisies de {group}",
      selectEntry: "S\xE9lectionner la saisie de {project} du {day}",
      project: "Projet",
      date: "Date",
      category: "Cat\xE9gorie",
      note: "Note",
      duration: "Dur\xE9e",
      rejectTitle: "Refuser des saisies de temps",
      rejectBody: "Vous refusez {count} saisie(s). La personne pourra les corriger puis soumettre de nouveau sa semaine.",
      reasonLabel: "Motif du refus (obligatoire)",
      reasonRequired: "Indiquez le motif du refus (3 caract\xE8res au moins).",
      confirmReject: "Refuser",
      approved: "Saisies approuv\xE9es\xA0: {count}.",
      rejected: "Saisies refus\xE9es\xA0: {count}.",
      loadFailedTitle: "Impossible de charger les saisies \xE0 approuver",
      empty: {
        title: "Rien \xE0 approuver",
        description: "Les saisies de temps soumises sur vos projets appara\xEEtront ici."
      },
      summaryLabel: "R\xE9sum\xE9 des saisies \xE0 approuver",
      pending: "Saisies en attente",
      pendingCaption: "Soumises sur vos projets",
      hours: "Temps \xE0 approuver",
      hoursCaption: "Total des saisies en attente",
      people: "Personnes",
      weeksCount: "{count, plural, one {Sur # semaine} other {Sur # semaines}}",
      noSelection: "Aucune saisie s\xE9lectionn\xE9e",
      selection: "{count, plural, one {# saisie s\xE9lectionn\xE9e} other {# saisies s\xE9lectionn\xE9es}} \xB7 {duration}"
    },
    capacity: {
      description: "Temps saisi par rapport \xE0 la capacit\xE9 de chaque personne (heures du contrat, moins les jours f\xE9ri\xE9s et les absences). Au-del\xE0 de 110 %, la semaine est en surcharge.",
      navLabel: "P\xE9riode affich\xE9e",
      earlier: "Semaines pr\xE9c\xE9dentes",
      later: "Semaines suivantes",
      weeksLabel: "Dur\xE9e affich\xE9e",
      weeksOption: "{count} semaine(s)",
      caption: "Charge de l\u2019\xE9quipe par semaine",
      person: "Personne",
      contract: "Contrat\xA0:",
      editContract: "Modifier les heures du contrat de {name}",
      contractTitle: "Heures du contrat de {name}",
      contractLabel: "Heures par semaine",
      contractHint: "Par exemple 40 ou 37:30. Les dur\xE9es vont par quarts d\u2019heure, 70 heures au plus.",
      contractSaved: "Heures du contrat enregistr\xE9es.",
      contractInvalid: {
        format: "Saisissez des heures comme 40, 37,5 ou 37:30.",
        step: "Les heures se saisissent par quarts d\u2019heure.",
        max: "Une semaine ne peut pas d\xE9passer 70 heures."
      },
      missingHolidays: "Le calendrier des jours f\xE9ri\xE9s manque pour {years}\xA0: la capacit\xE9 de ces semaines ignore les jours f\xE9ri\xE9s.",
      cellLabel: "{name}, semaine du {range}\xA0: {load} saisies sur {capacity}, {state}",
      unknown: "capacit\xE9 inconnue",
      states: {
        ok: "Dans la capacit\xE9",
        high: "Au-dessus de 100\xA0%",
        over: "Surcharge (plus de 110\xA0%)",
        none: "Capacit\xE9 inconnue"
      },
      percent: "{percent}\xA0%",
      noTime: "Aucun temps saisi cette semaine.",
      projectLine: "{project}\xA0: {duration}",
      loadFailedTitle: "Impossible de charger la charge de l\u2019\xE9quipe",
      empty: {
        title: "Personne \xE0 afficher",
        description: "La charge appara\xEEt pour les membres de votre \xE9quipe d\xE8s qu\u2019ils saisissent du temps."
      },
      legend: "L\xE9gende de la charge"
    },
    leave: {
      description: "Cong\xE9s, maladie et formations. Une absence r\xE9duit la capacit\xE9 des semaines qu\u2019elle couvre.",
      formLabel: "Ajouter une absence",
      person: "Personne",
      me: "Moi",
      startsOn: "Du",
      endsOn: "Au",
      kind: "Type",
      kinds: {
        leave: "Cong\xE9",
        sick: "Maladie",
        training: "Formation",
        other: "Autre"
      },
      noteLabel: "Note (facultatif)",
      note: "Note",
      add: "Ajouter l\u2019absence",
      created: "Absence ajout\xE9e.",
      deleted: "Absence supprim\xE9e.",
      delete: "Supprimer l\u2019absence de {name} ({period})",
      deleteTitle: "Supprimer cette absence\xA0?",
      deleteBody: "La capacit\xE9 des semaines concern\xE9es sera recalcul\xE9e.",
      period: "P\xE9riode",
      periodValue: "du {from} au {to}",
      actions: "Actions",
      datesRequired: "Indiquez les dates de d\xE9but et de fin.",
      endBeforeStart: "La date de fin ne peut pas pr\xE9c\xE9der la date de d\xE9but.",
      loadFailedTitle: "Impossible de charger les absences",
      empty: {
        title: "Aucune absence",
        description: "Les cong\xE9s, maladies et formations de cette p\xE9riode appara\xEEtront ici."
      },
      upcoming: "\xC0 venir et en cours",
      past: "Pass\xE9es",
      workingDays: "{count, plural, =0 {Aucun jour ouvr\xE9} one {# jour ouvr\xE9} other {# jours ouvr\xE9s}}"
    },
    errors: {
      network: "La connexion a \xE9chou\xE9. V\xE9rifiez votre r\xE9seau puis r\xE9essayez.",
      TIMESHEET_LOCKED: "Cette semaine est soumise, ou cette saisie est d\xE9j\xE0 d\xE9cid\xE9e\xA0: elle ne peut plus \xEAtre modifi\xE9e.",
      NOT_FOUND: "Vous ne travaillez pas sur ce projet, ou cet \xE9l\xE9ment n\u2019existe plus.",
      FORBIDDEN: "Vous n\u2019avez pas le droit de faire cette action (vous ne d\xE9cidez pas de votre propre temps).",
      STALE_VERSION: "Cette saisie a chang\xE9 entre-temps. La semaine vient d\u2019\xEAtre recharg\xE9e, r\xE9essayez."
    },
    kpis: {
      label: "R\xE9sum\xE9 de la semaine",
      entered: "Saisi cette semaine",
      noCapacity: "Capacit\xE9 de la semaine inconnue",
      progressLabel: "Temps saisi par rapport \xE0 la capacit\xE9 de la semaine",
      remaining: "Reste \xE0 saisir",
      remainingDone: "Capacit\xE9 de la semaine atteinte",
      remainingCaption: "Pour atteindre la capacit\xE9 de la semaine",
      days: "Jours renseign\xE9s",
      daysCaption: "Jours ouvr\xE9s, hors f\xE9ri\xE9s et absences",
      status: "Statut de la semaine",
      statusOpen: "En cours de saisie",
      statusSubmitted: "Soumise",
      toSubmit: "{duration} pr\xEAtes \xE0 soumettre",
      rejected: "{count, plural, one {# saisie refus\xE9e} other {# saisies refus\xE9es}}",
      rejectedCaption: "Corrigez-les puis soumettez \xE0 nouveau",
      currentWeek: "Semaine en cours"
    }
  }
};

// locales/ar/ui.json
var ui_default = {
  shell: {
    skipToContent: "\u0627\u0644\u0627\u0646\u062A\u0642\u0627\u0644 \u0625\u0644\u0649 \u0627\u0644\u0645\u062D\u062A\u0648\u0649 \u0627\u0644\u0631\u0626\u064A\u0633\u064A",
    appBarLabel: "\u0627\u0644\u062A\u0637\u0628\u064A\u0642\u0627\u062A",
    apps: {
      activity: "\u0627\u0644\u0646\u0634\u0627\u0637",
      chat: "\u0627\u0644\u0645\u062D\u0627\u062F\u062B\u0629",
      projects: "\u0627\u0644\u0645\u0634\u0627\u0631\u064A\u0639",
      calendar: "\u0627\u0644\u062A\u0642\u0648\u064A\u0645",
      files: "\u0627\u0644\u0645\u0644\u0641\u0627\u062A",
      finance: "\u0627\u0644\u0645\u0627\u0644\u064A\u0629",
      more: "\u0627\u0644\u0645\u0632\u064A\u062F"
    },
    badge: "{count, plural, zero {\u0644\u0627 \u062C\u062F\u064A\u062F} one {\u0639\u0646\u0635\u0631 \u062C\u062F\u064A\u062F \u0648\u0627\u062D\u062F} two {\u0639\u0646\u0635\u0631\u0627\u0646 \u062C\u062F\u064A\u062F\u0627\u0646} few {# \u0639\u0646\u0627\u0635\u0631 \u062C\u062F\u064A\u062F\u0629} many {# \u0639\u0646\u0635\u0631\u064B\u0627 \u062C\u062F\u064A\u062F\u064B\u0627} other {# \u0639\u0646\u0635\u0631 \u062C\u062F\u064A\u062F}}",
    search: {
      placeholder: "\u0627\u0628\u062D\u062B \u0641\u064A \u0627\u0644\u0645\u0634\u0627\u0631\u064A\u0639 \u0648\u0627\u0644\u0645\u0644\u0641\u0627\u062A \u0648\u0627\u0644\u0631\u0633\u0627\u0626\u0644\u2026",
      open: "\u0641\u062A\u062D \u0627\u0644\u0628\u062D\u062B"
    },
    notifications: "\u0627\u0644\u0625\u0634\u0639\u0627\u0631\u0627\u062A",
    help: "\u062F\u0644\u064A\u0644 \u0627\u0644\u0635\u0641\u062D\u0629",
    orgSwitcher: "\u062A\u063A\u064A\u064A\u0631 \u0627\u0644\u0645\u0624\u0633\u0633\u0629",
    externalSpaces: "\u0627\u0644\u0641\u0636\u0627\u0621\u0627\u062A \u0627\u0644\u062E\u0627\u0631\u062C\u064A\u0629",
    account: {
      menu: "\u0642\u0627\u0626\u0645\u0629 \u062D\u0633\u0627\u0628 {name}",
      status: "\u0627\u0644\u062D\u0627\u0644\u0629",
      profile: "\u0645\u0644\u0641\u064A \u0627\u0644\u0634\u062E\u0635\u064A",
      security: "\u0623\u0645\u0627\u0646 \u0627\u0644\u062D\u0633\u0627\u0628",
      language: "\u0627\u0644\u0644\u063A\u0629",
      theme: "\u0627\u0644\u0645\u0638\u0647\u0631",
      signOut: "\u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062E\u0631\u0648\u062C",
      statusValue: "\u0627\u0644\u062D\u0627\u0644\u0629: {status}",
      statusMessageSet: "\u062A\u0639\u064A\u064A\u0646 \u0631\u0633\u0627\u0644\u0629 \u062D\u0627\u0644\u0629",
      statusMessageEdit: "\u062A\u0639\u062F\u064A\u0644 \u0631\u0633\u0627\u0644\u0629 \u0627\u0644\u062D\u0627\u0644\u0629",
      statusMessageValue: "\u0627\u0644\u0631\u0633\u0627\u0644\u0629: {message}"
    },
    presence: {
      available: "\u0645\u062A\u0627\u062D",
      busy: "\u0645\u0634\u063A\u0648\u0644",
      in_meeting: "\u0641\u064A \u0627\u062C\u062A\u0645\u0627\u0639",
      on_site: "\u0641\u064A \u0627\u0644\u062D\u0636\u064A\u0631\u0629",
      away: "\u063A\u0627\u0626\u0628",
      offline: "\u063A\u064A\u0631 \u0645\u062A\u0635\u0644"
    },
    languages: {
      fr: "Fran\xE7ais",
      ar: "\u0627\u0644\u0639\u0631\u0628\u064A\u0629",
      en: "English"
    },
    themes: {
      system: "\u062D\u0633\u0628 \u0625\u0639\u062F\u0627\u062F\u0627\u062A \u0627\u0644\u062C\u0647\u0627\u0632",
      light: "\u0641\u0627\u062A\u062D",
      dark: "\u062F\u0627\u0643\u0646",
      highContrast: "\u062A\u0628\u0627\u064A\u0646 \u0639\u0627\u0644\u064D"
    },
    listPane: {
      label: "\u0627\u0644\u0642\u0627\u0626\u0645\u0629",
      resize: "\u062A\u063A\u064A\u064A\u0631 \u062D\u062C\u0645 \u0627\u0644\u0642\u0627\u0626\u0645\u0629",
      collapse: "\u0625\u062E\u0641\u0627\u0621 \u0627\u0644\u0642\u0627\u0626\u0645\u0629",
      expand: "\u0625\u0638\u0647\u0627\u0631 \u0627\u0644\u0642\u0627\u0626\u0645\u0629",
      open: "\u0641\u062A\u062D \u0627\u0644\u0642\u0627\u0626\u0645\u0629"
    },
    rightPanel: {
      close: "\u0625\u063A\u0644\u0627\u0642 \u0627\u0644\u0644\u0648\u062D\u0629"
    },
    breadcrumb: "\u0645\u0633\u0627\u0631 \u0627\u0644\u062A\u0646\u0642\u0644",
    tabs: "\u0639\u0644\u0627\u0645\u0627\u062A \u0627\u0644\u062A\u0628\u0648\u064A\u0628",
    tabsMoreShort: "\u0627\u0644\u0645\u0632\u064A\u062F",
    tabsMore: "{count, plural, zero {\u0644\u0627 \u062A\u0628\u0648\u064A\u0628\u0627\u062A \u0623\u062E\u0631\u0649} one {\u062A\u0628\u0648\u064A\u0628 \u0622\u062E\u0631} two {\u062A\u0628\u0648\u064A\u0628\u0627\u0646 \u0622\u062E\u0631\u0627\u0646} few {# \u062A\u0628\u0648\u064A\u0628\u0627\u062A \u0623\u062E\u0631\u0649} many {# \u062A\u0628\u0648\u064A\u0628\u064B\u0627 \u0622\u062E\u0631} other {# \u062A\u0628\u0648\u064A\u0628 \u0622\u062E\u0631}}",
    back: "\u0631\u062C\u0648\u0639",
    externalSpace: "\u0641\u0636\u0627\u0621 \u062E\u0627\u0631\u062C\u064A \u062A\u0633\u062A\u0636\u064A\u0641\u0647 {host}: \u064A\u062E\u0636\u0639 \u0627\u0644\u0645\u062D\u062A\u0648\u0649 \u0644\u0642\u0648\u0627\u0639\u062F\u0647\u0627.",
    bottomNav: "\u0627\u0644\u062A\u0646\u0642\u0644 \u0627\u0644\u0631\u0626\u064A\u0633\u064A",
    orgSwitcherCurrent: "\u062A\u063A\u064A\u064A\u0631 \u0627\u0644\u0645\u0624\u0633\u0633\u0629 (\u0627\u0644\u062D\u0627\u0644\u064A\u0629: {name})",
    externalSpacesCount: "\u0627\u0644\u0641\u0636\u0627\u0621\u0627\u062A \u0627\u0644\u062E\u0627\u0631\u062C\u064A\u0629 ({count})",
    notificationsCount: "{count, plural, zero {\u0627\u0644\u0625\u0634\u0639\u0627\u0631\u0627\u062A} one {\u0627\u0644\u0625\u0634\u0639\u0627\u0631\u0627\u062A\u060C \u0625\u0634\u0639\u0627\u0631 \u062C\u062F\u064A\u062F \u0648\u0627\u062D\u062F} two {\u0627\u0644\u0625\u0634\u0639\u0627\u0631\u0627\u062A\u060C \u0625\u0634\u0639\u0627\u0631\u0627\u0646 \u062C\u062F\u064A\u062F\u0627\u0646} few {\u0627\u0644\u0625\u0634\u0639\u0627\u0631\u0627\u062A\u060C # \u0625\u0634\u0639\u0627\u0631\u0627\u062A \u062C\u062F\u064A\u062F\u0629} many {\u0627\u0644\u0625\u0634\u0639\u0627\u0631\u0627\u062A\u060C # \u0625\u0634\u0639\u0627\u0631\u064B\u0627 \u062C\u062F\u064A\u062F\u064B\u0627} other {\u0627\u0644\u0625\u0634\u0639\u0627\u0631\u0627\u062A\u060C # \u0625\u0634\u0639\u0627\u0631 \u062C\u062F\u064A\u062F}}"
  },
  shortcuts: {
    title: "\u0627\u062E\u062A\u0635\u0627\u0631\u0627\u062A \u0644\u0648\u062D\u0629 \u0627\u0644\u0645\u0641\u0627\u062A\u064A\u062D",
    search: "\u0627\u0644\u0628\u062D\u062B",
    toggleListPane: "\u0625\u0638\u0647\u0627\u0631 \u0627\u0644\u0642\u0627\u0626\u0645\u0629 \u0623\u0648 \u0625\u062E\u0641\u0627\u0624\u0647\u0627",
    newChat: "\u0645\u062D\u0627\u062F\u062B\u0629 \u062C\u062F\u064A\u062F\u0629",
    previousItem: "\u0627\u0644\u0642\u0646\u0627\u0629 \u0623\u0648 \u0627\u0644\u0645\u062D\u0627\u062F\u062B\u0629 \u0627\u0644\u0633\u0627\u0628\u0642\u0629",
    nextItem: "\u0627\u0644\u0642\u0646\u0627\u0629 \u0623\u0648 \u0627\u0644\u0645\u062D\u0627\u062F\u062B\u0629 \u0627\u0644\u062A\u0627\u0644\u064A\u0629",
    close: "\u0625\u063A\u0644\u0627\u0642 \u0627\u0644\u0644\u0648\u062D\u0629 \u0623\u0648 \u0645\u0631\u0628\u0639 \u0627\u0644\u062D\u0648\u0627\u0631",
    help: "\u0639\u0631\u0636 \u0627\u0644\u0627\u062E\u062A\u0635\u0627\u0631\u0627\u062A",
    toggleMic: "\u062A\u0634\u063A\u064A\u0644 \u0627\u0644\u0645\u064A\u0643\u0631\u0648\u0641\u0648\u0646 \u0623\u0648 \u0643\u062A\u0645\u0647",
    toggleCamera: "\u062A\u0634\u063A\u064A\u0644 \u0627\u0644\u0643\u0627\u0645\u064A\u0631\u0627 \u0623\u0648 \u0625\u064A\u0642\u0627\u0641\u0647\u0627",
    app1: "\u0627\u0644\u0627\u0646\u062A\u0642\u0627\u0644 \u0625\u0644\u0649 \u0627\u0644\u0646\u0634\u0627\u0637",
    app2: "\u0627\u0644\u0627\u0646\u062A\u0642\u0627\u0644 \u0625\u0644\u0649 \u0627\u0644\u0645\u062D\u0627\u062F\u062B\u0629",
    app3: "\u0627\u0644\u0627\u0646\u062A\u0642\u0627\u0644 \u0625\u0644\u0649 \u0627\u0644\u0645\u0634\u0627\u0631\u064A\u0639",
    app4: "\u0627\u0644\u0627\u0646\u062A\u0642\u0627\u0644 \u0625\u0644\u0649 \u0627\u0644\u062A\u0642\u0648\u064A\u0645",
    app5: "\u0627\u0644\u0627\u0646\u062A\u0642\u0627\u0644 \u0625\u0644\u0649 \u0627\u0644\u0645\u0644\u0641\u0627\u062A",
    app6: "\u0627\u0644\u0627\u0646\u062A\u0642\u0627\u0644 \u0625\u0644\u0649 \u0627\u0644\u0645\u0627\u0644\u064A\u0629",
    app7: "\u0627\u0644\u0627\u0646\u062A\u0642\u0627\u0644 \u0625\u0644\u0649 \u0627\u0644\u0645\u0632\u064A\u062F",
    groups: {
      navigation: "\u0627\u0644\u062A\u0646\u0642\u0644",
      search: "\u0627\u0644\u0628\u062D\u062B",
      meeting: "\u0627\u0644\u0627\u062C\u062A\u0645\u0627\u0639\u0627\u062A",
      general: "\u0639\u0627\u0645"
    },
    disabledHint: "\u0644\u0627 \u062A\u0639\u0645\u0644 \u0627\u0644\u0627\u062E\u062A\u0635\u0627\u0631\u0627\u062A \u0623\u062B\u0646\u0627\u0621 \u0627\u0644\u0643\u062A\u0627\u0628\u0629 \u0641\u064A \u062D\u0642\u0644."
  },
  components: {
    common: {
      loading: "\u062C\u0627\u0631\u064D \u0627\u0644\u062A\u062D\u0645\u064A\u0644\u2026"
    },
    disciplines: {
      architecture: "\u0627\u0644\u0639\u0645\u0627\u0631\u0629",
      structure: "\u0627\u0644\u0647\u064A\u0627\u0643\u0644",
      vrd: "\u0627\u0644\u0637\u0631\u0642 \u0648\u0627\u0644\u0634\u0628\u0643\u0627\u062A \u0627\u0644\u0645\u062E\u062A\u0644\u0641\u0629",
      fluides: "\u0627\u0644\u0645\u0648\u0627\u0626\u0639",
      electricite: "\u0627\u0644\u0643\u0647\u0631\u0628\u0627\u0621",
      topographie: "\u0627\u0644\u0637\u0648\u0628\u0648\u063A\u0631\u0627\u0641\u064A\u0627",
      geotechnique: "\u0627\u0644\u062C\u064A\u0648\u062A\u0642\u0646\u064A\u0629",
      opc: "\u0627\u0644\u062A\u0646\u0633\u064A\u0642 \u0648\u0627\u0644\u0645\u062A\u0627\u0628\u0639\u0629"
    },
    userAvatar: {
      organisation: "\u0627\u0644\u0645\u0624\u0633\u0633\u0629: {name}",
      statusMessage: "\u0627\u0644\u0631\u0633\u0627\u0644\u0629: {message}"
    },
    moneyInput: {
      invalid: "\u0645\u0628\u0644\u063A \u063A\u064A\u0631 \u0635\u0627\u0644\u062D. \u0645\u062B\u0627\u0644: {example}.",
      tooManyDecimals: "\u064A\u0642\u0628\u0644 \u0647\u0630\u0627 \u0627\u0644\u0645\u0628\u0644\u063A {count, plural, one {\u0645\u0646\u0632\u0644\u0629 \u0639\u0634\u0631\u064A\u0629 \u0648\u0627\u062D\u062F\u0629} two {\u0645\u0646\u0632\u0644\u062A\u064A\u0646 \u0639\u0634\u0631\u064A\u062A\u064A\u0646} few {# \u0645\u0646\u0627\u0632\u0644 \u0639\u0634\u0631\u064A\u0629} many {# \u0645\u0646\u0632\u0644\u0629 \u0639\u0634\u0631\u064A\u0629} other {# \u0645\u0646\u0632\u0644\u0629 \u0639\u0634\u0631\u064A\u0629}} \u0639\u0644\u0649 \u0627\u0644\u0623\u0643\u062B\u0631."
    },
    dateInput: {
      before: "\u064A\u062C\u0628 \u0623\u0646 \u064A\u0643\u0648\u0646 \u0627\u0644\u062A\u0627\u0631\u064A\u062E {min} \u0623\u0648 \u0628\u0639\u062F\u0647.",
      after: "\u064A\u062C\u0628 \u0623\u0646 \u064A\u0643\u0648\u0646 \u0627\u0644\u062A\u0627\u0631\u064A\u062E {max} \u0623\u0648 \u0642\u0628\u0644\u0647."
    },
    confirmDialog: {
      confirm: "\u062A\u0623\u0643\u064A\u062F",
      cancel: "\u0625\u0644\u063A\u0627\u0621",
      busy: "\u062C\u0627\u0631\u064D \u0627\u0644\u062A\u0646\u0641\u064A\u0630\u2026"
    },
    stepUpDialog: {
      title: "\u0623\u0643\u0651\u062F \u0647\u0648\u064A\u062A\u0643",
      description: "\u0644\u062D\u0645\u0627\u064A\u0629 \u062D\u0633\u0627\u0628\u0643\u060C \u064A\u062A\u0637\u0644\u0628 \u0647\u0630\u0627 \u0627\u0644\u0625\u062C\u0631\u0627\u0621 \u062A\u0623\u0643\u064A\u062F \u0647\u0648\u064A\u062A\u0643 \u0645\u0646 \u062C\u062F\u064A\u062F. \u0633\u062A\u062A\u0645 \u0625\u0639\u0627\u062F\u0629 \u062A\u0648\u062C\u064A\u0647\u0643 \u0625\u0644\u0649 \u0635\u0641\u062D\u0629 \u0627\u0644\u062A\u0623\u0643\u064A\u062F \u062B\u0645 \u062A\u0639\u0648\u062F \u0625\u0644\u0649 \u0647\u0646\u0627.",
      continue: "\u0645\u062A\u0627\u0628\u0639\u0629",
      cancel: "\u0625\u0644\u063A\u0627\u0621"
    },
    upgradePrompt: {
      title: "\u063A\u064A\u0631 \u0645\u062A\u0627\u062D \u0641\u064A \u0639\u0631\u0636\u0643 \u0627\u0644\u062D\u0627\u0644\u064A",
      message: "\u0644\u0627 \u064A\u0633\u0645\u062D \u0639\u0631\u0636\u0643 \u0627\u0644\u062D\u0627\u0644\u064A \u0628\u0647\u0630\u0627 \u0627\u0644\u0625\u062C\u0631\u0627\u0621. \u0627\u0646\u062A\u0642\u0644 \u0625\u0644\u0649 \u0639\u0631\u0636 \u0623\u0639\u0644\u0649 \u0644\u0644\u0645\u062A\u0627\u0628\u0639\u0629.",
      action: "\u0639\u0631\u0636 \u0627\u0644\u0639\u0631\u0648\u0636",
      dismiss: "\u0644\u0627\u062D\u0642\u064B\u0627"
    },
    shortcutHelp: {
      toggle: "\u062A\u0641\u0639\u064A\u0644 \u0627\u062E\u062A\u0635\u0627\u0631\u0627\u062A \u0644\u0648\u062D\u0629 \u0627\u0644\u0645\u0641\u0627\u062A\u064A\u062D",
      empty: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0627\u062E\u062A\u0635\u0627\u0631\u0627\u062A \u0646\u0634\u0637\u0629 \u062D\u0627\u0644\u064A\u064B\u0627.",
      close: "\u0625\u063A\u0644\u0627\u0642"
    },
    phaseTimeline: {
      label: "\u0627\u0644\u062C\u062F\u0648\u0644 \u0627\u0644\u0632\u0645\u0646\u064A \u0644\u0644\u0645\u0631\u0627\u062D\u0644",
      legendPlanned: "\u0634\u0631\u064A\u0637 \u0645\u062A\u0642\u0637\u0639: \u0627\u0644\u0641\u062A\u0631\u0629 \u0627\u0644\u0645\u062E\u0637\u0637\u0629",
      legendActual: "\u0634\u0631\u064A\u0637 \u0645\u0645\u0644\u0648\u0621: \u0627\u0644\u0641\u062A\u0631\u0629 \u0627\u0644\u0641\u0639\u0644\u064A\u0629",
      today: "\u0627\u0644\u064A\u0648\u0645",
      todayLabel: "\u0627\u0644\u064A\u0648\u0645: {date}",
      todayOutside: "\u0627\u0644\u064A\u0648\u0645 ({date}) \u062E\u0627\u0631\u062C \u0627\u0644\u0641\u062A\u0631\u0629 \u0627\u0644\u0645\u0639\u0631\u0648\u0636\u0629.",
      notPlanned: "\u0627\u0644\u0645\u062E\u0637\u0637: \u063A\u064A\u0631 \u0645\u0628\u0631\u0645\u062C\u0629",
      plannedRange: "\u0627\u0644\u0645\u062E\u0637\u0637: \u0645\u0646 {start} \u0625\u0644\u0649 {end}",
      plannedOne: "\u0627\u0644\u0645\u062E\u0637\u0637: \u0641\u064A {date}",
      actualRange: "\u0627\u0644\u0641\u0639\u0644\u064A: \u0645\u0646 {start} \u0625\u0644\u0649 {end}",
      actualOngoing: "\u0627\u0644\u0641\u0639\u0644\u064A: \u0645\u0646\u0630 {start}\u060C \u0642\u064A\u062F \u0627\u0644\u062A\u0646\u0641\u064A\u0630",
      actualOne: "\u0627\u0644\u0641\u0639\u0644\u064A: \u0641\u064A {date}",
      noActual: "\u0627\u0644\u0641\u0639\u0644\u064A: \u0644\u0627 \u064A\u0648\u062C\u062F \u062A\u0627\u0631\u064A\u062E \u0628\u0639\u062F",
      unplannedTitle: "\u0645\u0631\u0627\u062D\u0644 \u0628\u062F\u0648\u0646 \u062A\u0648\u0627\u0631\u064A\u062E \u0645\u062E\u0637\u0637\u0629 \u0623\u0648 \u0641\u0639\u0644\u064A\u0629",
      itemName: "{name}. {details}"
    },
    kanban: {
      empty: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0639\u0646\u0627\u0635\u0631",
      columnLabel: "{column} ({count, plural, =0 {\u0644\u0627 \u062A\u0648\u062C\u062F \u0639\u0646\u0627\u0635\u0631} one {\u0639\u0646\u0635\u0631 \u0648\u0627\u062D\u062F} two {\u0639\u0646\u0635\u0631\u0627\u0646} few {# \u0639\u0646\u0627\u0635\u0631} many {# \u0639\u0646\u0635\u0631\u064B\u0627} other {# \u0639\u0646\u0635\u0631}})",
      dragHandle: "\u0633\u062D\u0628 \xAB{title}\xBB",
      moveTo: "\u0646\u0642\u0644 \xAB{title}\xBB\u2026",
      moveToGroup: "\u0646\u0642\u0644 \u0625\u0644\u0649",
      moveUp: "\u062A\u062D\u0631\u064A\u0643 \u0644\u0644\u0623\u0639\u0644\u0649 \u0641\u064A \u0627\u0644\u0639\u0645\u0648\u062F",
      moveDown: "\u062A\u062D\u0631\u064A\u0643 \u0644\u0644\u0623\u0633\u0641\u0644 \u0641\u064A \u0627\u0644\u0639\u0645\u0648\u062F",
      instructions: "\u0644\u0646\u0642\u0644 \u0627\u0644\u0628\u0637\u0627\u0642\u0629\u060C \u0627\u0636\u063A\u0637 \u0639\u0644\u0649 \u0627\u0644\u0645\u0633\u0627\u0641\u0629 \u0623\u0648 Enter\u060C \u062B\u0645 \u0627\u0633\u062A\u062E\u062F\u0645 \u0627\u0644\u0623\u0633\u0647\u0645 \u0644\u0627\u062E\u062A\u064A\u0627\u0631 \u0645\u0643\u0627\u0646\u0647\u0627\u060C \u062B\u0645 \u0627\u0644\u0645\u0633\u0627\u0641\u0629 \u0623\u0648 Enter \u0644\u0625\u0641\u0644\u0627\u062A\u0647\u0627\u060C \u0623\u0648 Esc \u0644\u0644\u0625\u0644\u063A\u0627\u0621. \u062A\u062A\u064A\u062D \u0642\u0627\u0626\u0645\u0629 \xAB\u0646\u0642\u0644\u2026\xBB \u0641\u0639\u0644 \u0630\u0644\u0643 \u062F\u0648\u0646 \u0633\u062D\u0628.",
      announce: {
        pickedUp: "\u062A\u0645 \u0627\u0644\u062A\u0642\u0627\u0637 \xAB{title}\xBB. \u0627\u0644\u0639\u0645\u0648\u062F: {column}\u060C \u0627\u0644\u0645\u0648\u0636\u0639 {position} \u0645\u0646 {total}.",
        over: "\xAB{title}\xBB: \u0627\u0644\u0639\u0645\u0648\u062F {column}\u060C \u0627\u0644\u0645\u0648\u0636\u0639 {position} \u0645\u0646 {total}.",
        dropped: "\u062A\u0645 \u0625\u0641\u0644\u0627\u062A \xAB{title}\xBB. \u0627\u0644\u0639\u0645\u0648\u062F: {column}\u060C \u0627\u0644\u0645\u0648\u0636\u0639 {position} \u0645\u0646 {total}.",
        cancelled: "\u0623\u064F\u0644\u063A\u064A \u0627\u0644\u0646\u0642\u0644. \u062A\u0628\u0642\u0649 \xAB{title}\xBB \u0641\u064A \u0645\u0643\u0627\u0646\u0647\u0627.",
        moved: "\u062A\u0645 \u0646\u0642\u0644 \xAB{title}\xBB. \u0627\u0644\u0639\u0645\u0648\u062F: {column}\u060C \u0627\u0644\u0645\u0648\u0636\u0639 {position} \u0645\u0646 {total}."
      }
    },
    richText: {
      toolbar: "\u0627\u0644\u062A\u0646\u0633\u064A\u0642",
      bold: "\u063A\u0627\u0645\u0642",
      italic: "\u0645\u0627\u0626\u0644",
      bulletList: "\u0642\u0627\u0626\u0645\u0629 \u0646\u0642\u0637\u064A\u0629",
      orderedList: "\u0642\u0627\u0626\u0645\u0629 \u0645\u0631\u0642\u0645\u0629",
      link: "\u0631\u0627\u0628\u0637",
      linkUrl: "\u0639\u0646\u0648\u0627\u0646 \u0627\u0644\u0631\u0627\u0628\u0637 (http \u0623\u0648 https)",
      linkApply: "\u062A\u0637\u0628\u064A\u0642 \u0627\u0644\u0631\u0627\u0628\u0637",
      linkRemove: "\u0625\u0632\u0627\u0644\u0629 \u0627\u0644\u0631\u0627\u0628\u0637",
      linkInvalid: "\u0623\u062F\u062E\u0644 \u0639\u0646\u0648\u0627\u0646\u064B\u0627 \u0643\u0627\u0645\u0644\u064B\u0627 \u064A\u0628\u062F\u0623 \u0628\u0640 http:// \u0623\u0648 https://.",
      mentionList: "\u0623\u0634\u062E\u0627\u0635 \u0644\u0644\u0625\u0634\u0627\u0631\u0629 \u0625\u0644\u064A\u0647\u0645",
      suggestions: "{count, plural, =0 {\u0644\u0645 \u064A\u062A\u0645 \u0627\u0644\u0639\u062B\u0648\u0631 \u0639\u0644\u0649 \u0623\u064A \u0634\u062E\u0635} one {\u0634\u062E\u0635 \u0648\u0627\u062D\u062F \u0645\u0642\u062A\u0631\u062D} two {\u0634\u062E\u0635\u0627\u0646 \u0645\u0642\u062A\u0631\u062D\u0627\u0646} few {# \u0623\u0634\u062E\u0627\u0635 \u0645\u0642\u062A\u0631\u062D\u064A\u0646} many {# \u0634\u062E\u0635\u064B\u0627 \u0645\u0642\u062A\u0631\u062D\u064B\u0627} other {# \u0634\u062E\u0635 \u0645\u0642\u062A\u0631\u062D}}",
      mentionPrefix: "\u0625\u0634\u0627\u0631\u0629"
    },
    userPicker: {
      placeholder: "\u0627\u0644\u0628\u062D\u062B \u0639\u0646 \u0634\u062E\u0635",
      remove: "\u0625\u0632\u0627\u0644\u0629 {name}",
      noOptions: "\u0644\u0645 \u064A\u062A\u0645 \u0627\u0644\u0639\u062B\u0648\u0631 \u0639\u0644\u0649 \u0623\u064A \u0634\u062E\u0635",
      open: "\u0639\u0631\u0636 \u0627\u0644\u0623\u0634\u062E\u0627\u0635: {label}"
    }
  }
};

// locales/en/ui.json
var ui_default2 = {
  shell: {
    skipToContent: "Skip to main content",
    appBarLabel: "Apps",
    apps: {
      activity: "Activity",
      chat: "Chat",
      projects: "Projects",
      calendar: "Calendar",
      files: "Files",
      finance: "Finance",
      more: "More"
    },
    badge: "{count, plural, one {# new item} other {# new items}}",
    search: {
      placeholder: "Search projects, files, messages\u2026",
      open: "Open search"
    },
    notifications: "Notifications",
    help: "Page guide",
    orgSwitcher: "Switch organisation",
    externalSpaces: "External spaces",
    account: {
      menu: "Account menu for {name}",
      status: "Status",
      profile: "My profile",
      security: "Account security",
      language: "Language",
      theme: "Theme",
      signOut: "Sign out",
      statusValue: "Status: {status}",
      statusMessageSet: "Set a status message",
      statusMessageEdit: "Edit the status message",
      statusMessageValue: "Message: {message}"
    },
    presence: {
      available: "Available",
      busy: "Busy",
      in_meeting: "In a meeting",
      on_site: "On site",
      away: "Away",
      offline: "Offline"
    },
    languages: {
      fr: "Fran\xE7ais",
      ar: "\u0627\u0644\u0639\u0631\u0628\u064A\u0629",
      en: "English"
    },
    themes: {
      system: "Same as the system",
      light: "Light",
      dark: "Dark",
      highContrast: "High contrast"
    },
    listPane: {
      label: "List",
      resize: "Resize the list",
      collapse: "Hide the list",
      expand: "Show the list",
      open: "Open the list"
    },
    rightPanel: {
      close: "Close the panel"
    },
    breadcrumb: "Breadcrumb",
    tabs: "Tabs",
    tabsMoreShort: "More",
    tabsMore: "{count, plural, one {# more tab} other {# more tabs}}",
    back: "Back",
    externalSpace: "External space hosted by {host}: content is subject to their policies.",
    bottomNav: "Main navigation",
    orgSwitcherCurrent: "Switch organisation (current: {name})",
    externalSpacesCount: "External spaces ({count})",
    notificationsCount: "{count, plural, =0 {Notifications} one {Notifications, # new} other {Notifications, # new}}"
  },
  shortcuts: {
    title: "Keyboard shortcuts",
    search: "Search",
    toggleListPane: "Show or hide the list",
    newChat: "New chat",
    previousItem: "Previous channel or conversation",
    nextItem: "Next channel or conversation",
    close: "Close the panel or dialog",
    help: "Show shortcuts",
    toggleMic: "Turn the microphone on or off",
    toggleCamera: "Turn the camera on or off",
    app1: "Go to Activity",
    app2: "Go to Chat",
    app3: "Go to Projects",
    app4: "Go to Calendar",
    app5: "Go to Files",
    app6: "Go to Finance",
    app7: "Go to More",
    groups: {
      navigation: "Navigation",
      search: "Search",
      meeting: "Meetings",
      general: "General"
    },
    disabledHint: "Shortcuts do not run while you type in a field."
  },
  components: {
    common: {
      loading: "Loading\u2026"
    },
    disciplines: {
      architecture: "Architecture",
      structure: "Structure",
      vrd: "Roads and utilities (VRD)",
      fluides: "Fluids (MEP)",
      electricite: "Electrical",
      topographie: "Surveying",
      geotechnique: "Geotechnics",
      opc: "Site coordination (OPC)"
    },
    userAvatar: {
      organisation: "Organisation: {name}",
      statusMessage: "Message: {message}"
    },
    moneyInput: {
      invalid: "Invalid amount. Example: {example}.",
      tooManyDecimals: "This amount accepts at most {count, plural, one {# decimal place} other {# decimal places}}."
    },
    dateInput: {
      before: "The date must be on or after {min}.",
      after: "The date must be on or before {max}."
    },
    confirmDialog: {
      confirm: "Confirm",
      cancel: "Cancel",
      busy: "Working\u2026"
    },
    stepUpDialog: {
      title: "Confirm your identity",
      description: "To protect your account, this action requires you to confirm your identity again. You will be redirected to the confirmation page, then brought back here.",
      continue: "Continue",
      cancel: "Cancel"
    },
    upgradePrompt: {
      title: "Not included in your plan",
      message: "Your plan does not allow this action. Upgrade to a higher plan to continue.",
      action: "See plans",
      dismiss: "Later"
    },
    shortcutHelp: {
      toggle: "Enable keyboard shortcuts",
      empty: "No active shortcuts right now.",
      close: "Close"
    },
    phaseTimeline: {
      label: "Phase timeline",
      legendPlanned: "Dashed bar: planned period",
      legendActual: "Solid bar: actual period",
      today: "Today",
      todayLabel: "Today: {date}",
      todayOutside: "Today ({date}) is outside the period shown.",
      notPlanned: "Planned: not scheduled",
      plannedRange: "Planned: {start} to {end}",
      plannedOne: "Planned: on {date}",
      actualRange: "Actual: {start} to {end}",
      actualOngoing: "Actual: since {start}, in progress",
      actualOne: "Actual: on {date}",
      noActual: "Actual: no date yet",
      unplannedTitle: "Phases without planned or actual dates",
      itemName: "{name}. {details}"
    },
    kanban: {
      empty: "No items",
      columnLabel: "{column} ({count, plural, =0 {no items} one {# item} other {# items}})",
      dragHandle: 'Drag "{title}"',
      moveTo: 'Move "{title}"\u2026',
      moveToGroup: "Move to",
      moveUp: "Move up in the column",
      moveDown: "Move down in the column",
      instructions: 'To move the card, press Space or Enter, use the arrow keys to choose its place, then Space or Enter to drop it, or Escape to cancel. The "Move\u2026" menu does the same without dragging.',
      announce: {
        pickedUp: '"{title}" picked up. Column: {column}, position {position} of {total}.',
        over: '"{title}": column {column}, position {position} of {total}.',
        dropped: '"{title}" dropped. Column: {column}, position {position} of {total}.',
        cancelled: 'Move cancelled. "{title}" stays where it was.',
        moved: '"{title}" moved. Column: {column}, position {position} of {total}.'
      }
    },
    richText: {
      toolbar: "Formatting",
      bold: "Bold",
      italic: "Italic",
      bulletList: "Bulleted list",
      orderedList: "Numbered list",
      link: "Link",
      linkUrl: "Link address (http or https)",
      linkApply: "Apply link",
      linkRemove: "Remove link",
      linkInvalid: "Enter a full address starting with http:// or https://.",
      mentionList: "People to mention",
      suggestions: "{count, plural, =0 {No person found} one {# person suggested} other {# people suggested}}",
      mentionPrefix: "Mention"
    },
    userPicker: {
      placeholder: "Search for a person",
      remove: "Remove {name}",
      noOptions: "No person found",
      open: "Show people: {label}"
    }
  }
};

// locales/fr/ui.json
var ui_default3 = {
  shell: {
    skipToContent: "Aller au contenu principal",
    appBarLabel: "Applications",
    apps: {
      activity: "Activit\xE9",
      chat: "Conversation",
      projects: "Projets",
      calendar: "Calendrier",
      files: "Fichiers",
      finance: "Finances",
      more: "Plus"
    },
    badge: "{count, plural, one {# nouveaut\xE9} other {# nouveaut\xE9s}}",
    search: {
      placeholder: "Rechercher des projets, fichiers, messages\u2026",
      open: "Ouvrir la recherche"
    },
    notifications: "Notifications",
    help: "Guide de la page",
    orgSwitcher: "Changer d'organisation",
    externalSpaces: "Espaces externes",
    account: {
      menu: "Menu du compte de {name}",
      status: "Statut",
      profile: "Mon profil",
      security: "S\xE9curit\xE9 du compte",
      language: "Langue",
      theme: "Th\xE8me",
      signOut: "Se d\xE9connecter",
      statusValue: "Statut\xA0: {status}",
      statusMessageSet: "D\xE9finir un message de statut",
      statusMessageEdit: "Modifier le message de statut",
      statusMessageValue: "Message\xA0: {message}"
    },
    presence: {
      available: "Disponible",
      busy: "Occup\xE9",
      in_meeting: "En r\xE9union",
      on_site: "Sur le chantier",
      away: "Absent",
      offline: "Hors ligne"
    },
    languages: {
      fr: "Fran\xE7ais",
      ar: "\u0627\u0644\u0639\u0631\u0628\u064A\u0629",
      en: "English"
    },
    themes: {
      system: "Comme le syst\xE8me",
      light: "Clair",
      dark: "Sombre",
      highContrast: "Contraste \xE9lev\xE9"
    },
    listPane: {
      label: "Liste",
      resize: "Redimensionner la liste",
      collapse: "Masquer la liste",
      expand: "Afficher la liste",
      open: "Ouvrir la liste"
    },
    rightPanel: {
      close: "Fermer le panneau"
    },
    breadcrumb: "Fil d'Ariane",
    tabs: "Onglets",
    tabsMoreShort: "Plus",
    tabsMore: "{count, plural, one {# autre onglet} other {# autres onglets}}",
    back: "Retour",
    externalSpace: "Espace externe h\xE9berg\xE9 par {host}\xA0: le contenu est soumis \xE0 ses r\xE8gles.",
    bottomNav: "Navigation principale",
    orgSwitcherCurrent: "Changer d'organisation (actuelle\xA0: {name})",
    externalSpacesCount: "Espaces externes ({count})",
    notificationsCount: "{count, plural, =0 {Notifications} one {Notifications, # nouvelle} other {Notifications, # nouvelles}}"
  },
  shortcuts: {
    title: "Raccourcis clavier",
    search: "Rechercher",
    toggleListPane: "Afficher ou masquer la liste",
    newChat: "Nouvelle conversation",
    previousItem: "Canal ou conversation pr\xE9c\xE9dent",
    nextItem: "Canal ou conversation suivant",
    close: "Fermer le panneau ou la bo\xEEte de dialogue",
    help: "Afficher les raccourcis",
    toggleMic: "Activer ou couper le micro",
    toggleCamera: "Activer ou couper la cam\xE9ra",
    app1: "Aller \xE0 Activit\xE9",
    app2: "Aller \xE0 Conversation",
    app3: "Aller \xE0 Projets",
    app4: "Aller \xE0 Calendrier",
    app5: "Aller \xE0 Fichiers",
    app6: "Aller \xE0 Finances",
    app7: "Aller \xE0 Plus",
    groups: {
      navigation: "Navigation",
      search: "Recherche",
      meeting: "R\xE9unions",
      general: "G\xE9n\xE9ral"
    },
    disabledHint: "Les raccourcis ne s'activent pas pendant la saisie dans un champ."
  },
  components: {
    common: {
      loading: "Chargement\u2026"
    },
    disciplines: {
      architecture: "Architecture",
      structure: "Structure",
      vrd: "VRD",
      fluides: "Fluides",
      electricite: "\xC9lectricit\xE9",
      topographie: "Topographie",
      geotechnique: "G\xE9otechnique",
      opc: "OPC"
    },
    userAvatar: {
      organisation: "Organisation\xA0: {name}",
      statusMessage: "Message\xA0: {message}"
    },
    moneyInput: {
      invalid: "Montant invalide. Exemple\xA0: {example}.",
      tooManyDecimals: "Ce montant accepte au plus {count, plural, one {# d\xE9cimale} other {# d\xE9cimales}}."
    },
    dateInput: {
      before: "La date doit \xEAtre le {min} ou apr\xE8s.",
      after: "La date doit \xEAtre le {max} ou avant."
    },
    confirmDialog: {
      confirm: "Confirmer",
      cancel: "Annuler",
      busy: "Traitement en cours\u2026"
    },
    stepUpDialog: {
      title: "Confirmez votre identit\xE9",
      description: "Pour prot\xE9ger votre compte, cette action exige de confirmer \xE0 nouveau votre identit\xE9. Vous serez redirig\xE9 vers la page de confirmation, puis ramen\xE9 ici.",
      continue: "Continuer",
      cancel: "Annuler"
    },
    upgradePrompt: {
      title: "Non incluse dans votre offre",
      message: "Votre offre ne permet pas cette action. Passez \xE0 une offre sup\xE9rieure pour continuer.",
      action: "Voir les offres",
      dismiss: "Plus tard"
    },
    shortcutHelp: {
      toggle: "Activer les raccourcis clavier",
      empty: "Aucun raccourci actif pour le moment.",
      close: "Fermer"
    },
    phaseTimeline: {
      label: "Frise des phases",
      legendPlanned: "Barre en pointill\xE9s\xA0: p\xE9riode pr\xE9vue",
      legendActual: "Barre pleine\xA0: p\xE9riode r\xE9elle",
      today: "Aujourd'hui",
      todayLabel: "Aujourd'hui\xA0: {date}",
      todayOutside: "Aujourd'hui ({date}) est en dehors de la p\xE9riode affich\xE9e.",
      notPlanned: "Pr\xE9vu\xA0: non planifi\xE9",
      plannedRange: "Pr\xE9vu\xA0: du {start} au {end}",
      plannedOne: "Pr\xE9vu\xA0: le {date}",
      actualRange: "R\xE9el\xA0: du {start} au {end}",
      actualOngoing: "R\xE9el\xA0: depuis le {start}, en cours",
      actualOne: "R\xE9el\xA0: le {date}",
      noActual: "R\xE9el\xA0: pas encore de date",
      unplannedTitle: "Phases sans dates pr\xE9vues ni r\xE9elles",
      itemName: "{name}. {details}"
    },
    kanban: {
      empty: "Aucun \xE9l\xE9ment",
      columnLabel: "{column} ({count, plural, =0 {aucun \xE9l\xE9ment} one {# \xE9l\xE9ment} other {# \xE9l\xE9ments}})",
      dragHandle: "Glisser \xAB\xA0{title}\xA0\xBB",
      moveTo: "D\xE9placer \xAB\xA0{title}\xA0\xBB\u2026",
      moveToGroup: "D\xE9placer vers",
      moveUp: "Monter dans la colonne",
      moveDown: "Descendre dans la colonne",
      instructions: "Pour d\xE9placer la carte, appuyez sur Espace ou Entr\xE9e, utilisez les fl\xE8ches pour choisir la place, puis Espace ou Entr\xE9e pour la d\xE9poser, ou \xC9chap pour annuler. Le menu \xAB\xA0D\xE9placer\u2026\xA0\xBB permet de faire la m\xEAme chose sans glisser.",
      announce: {
        pickedUp: "\xAB\xA0{title}\xA0\xBB saisie. Colonne \xA0: {column}, position {position} sur {total}.",
        over: "\xAB\xA0{title}\xA0\xBB\xA0: colonne {column}, position {position} sur {total}.",
        dropped: "\xAB\xA0{title}\xA0\xBB d\xE9pos\xE9e. Colonne \xA0: {column}, position {position} sur {total}.",
        cancelled: "D\xE9placement annul\xE9. \xAB\xA0{title}\xA0\xBB reste \xE0 sa place.",
        moved: "\xAB\xA0{title}\xA0\xBB d\xE9plac\xE9e. Colonne \xA0: {column}, position {position} sur {total}."
      }
    },
    richText: {
      toolbar: "Mise en forme",
      bold: "Gras",
      italic: "Italique",
      bulletList: "Liste \xE0 puces",
      orderedList: "Liste num\xE9rot\xE9e",
      link: "Lien",
      linkUrl: "Adresse du lien (http ou https)",
      linkApply: "Appliquer le lien",
      linkRemove: "Retirer le lien",
      linkInvalid: "Saisissez une adresse compl\xE8te commen\xE7ant par http:// ou https://.",
      mentionList: "Personnes \xE0 mentionner",
      suggestions: "{count, plural, =0 {Aucune personne trouv\xE9e} one {# personne sugg\xE9r\xE9e} other {# personnes sugg\xE9r\xE9es}}",
      mentionPrefix: "Mention"
    },
    userPicker: {
      placeholder: "Rechercher une personne",
      remove: "Retirer {name}",
      noOptions: "Aucune personne trouv\xE9e",
      open: "Afficher les personnes\xA0: {label}"
    }
  }
};

// locales/ar/email.json
var email_default = {
  layout: {
    footer: "\u062A\u0635\u0644\u0643 \u0647\u0630\u0647 \u0627\u0644\u0631\u0633\u0627\u0644\u0629 \u0644\u0623\u0646 \u0625\u062C\u0631\u0627\u0621\u064B \u062A\u0645\u0651 \u0644\u0641\u0627\u0626\u062F\u062A\u0643 \u0639\u0644\u0649 BatiFlow. \u0625\u0646 \u0644\u0645 \u062A\u0643\u0646 \u062A\u0646\u062A\u0638\u0631\u0647\u0627\u060C \u064A\u0645\u0643\u0646\u0643 \u062A\u062C\u0627\u0647\u0644\u0647\u0627.",
    brand: "BatiFlow"
  },
  memberInvitation: {
    subject: "\u064A\u062F\u0639\u0648\u0643 {inviter} \u0644\u0644\u0627\u0646\u0636\u0645\u0627\u0645 \u0625\u0644\u0649 {organization} \u0639\u0644\u0649 BatiFlow",
    preview: "\u0627\u0646\u0636\u0645\u0651 \u0625\u0644\u0649 {organization} \u0639\u0644\u0649 BatiFlow",
    heading: "\u0627\u0646\u0636\u0645\u0651 \u0625\u0644\u0649 {organization}",
    body: "\u064A\u062F\u0639\u0648\u0643 {inviter} \u0644\u0644\u0627\u0646\u0636\u0645\u0627\u0645 \u0625\u0644\u0649 \u0645\u0633\u0627\u062D\u0629 \u0639\u0645\u0644 {organization} \u0639\u0644\u0649 BatiFlow \u0628\u0635\u0641\u0629 {role}.",
    action: "\u0642\u0628\u0648\u0644 \u0627\u0644\u062F\u0639\u0648\u0629",
    account: "\u0633\u062C\u0651\u0644 \u0627\u0644\u062F\u062E\u0648\u0644 \u0628\u0639\u0646\u0648\u0627\u0646 \u0627\u0644\u0628\u0631\u064A\u062F \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A \u0647\u0630\u0627. \u0625\u0646 \u0644\u0645 \u064A\u0643\u0646 \u0644\u062F\u064A\u0643 \u062D\u0633\u0627\u0628 \u0628\u0639\u062F\u060C \u064A\u0631\u0633\u0644 \u0644\u0643 BatiFlow \u0631\u0633\u0627\u0644\u0629 \u062B\u0627\u0646\u064A\u0629 \u0644\u0627\u062E\u062A\u064A\u0627\u0631 \u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631.",
    expiry: "\u0647\u0630\u0647 \u0627\u0644\u062F\u0639\u0648\u0629 \u0635\u0627\u0644\u062D\u0629 \u0625\u0644\u0649 \u063A\u0627\u064A\u0629 {expiresAt}.",
    fallback: "\u0625\u0646 \u0644\u0645 \u064A\u0639\u0645\u0644 \u0627\u0644\u0632\u0631\u060C \u0627\u0646\u0633\u062E \u0647\u0630\u0627 \u0627\u0644\u0631\u0627\u0628\u0637 \u0641\u064A \u0645\u062A\u0635\u0641\u0651\u062D\u0643:"
  },
  notification: {
    action: "\u0641\u062A\u062D \u0641\u064A BatiFlow",
    fallback: "\u0625\u0646 \u0644\u0645 \u064A\u0639\u0645\u0644 \u0627\u0644\u0632\u0631\u060C \u0627\u0646\u0633\u062E \u0647\u0630\u0627 \u0627\u0644\u0631\u0627\u0628\u0637 \u0641\u064A \u0645\u062A\u0635\u0641\u0651\u062D\u0643:",
    settings: "\u064A\u0645\u0643\u0646\u0643 \u0627\u062E\u062A\u064A\u0627\u0631 \u0627\u0644\u0625\u0634\u0639\u0627\u0631\u0627\u062A \u0627\u0644\u062A\u064A \u062A\u0635\u0644\u0643 \u0628\u0627\u0644\u0628\u0631\u064A\u062F \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A \u0645\u0646 \u0645\u0644\u0641\u0643 \u0627\u0644\u0634\u062E\u0635\u064A\u060C \u0641\u064A \u0642\u0633\u0645 \u0627\u0644\u0625\u0634\u0639\u0627\u0631\u0627\u062A.",
    eventPlace: " \u0627\u0644\u0645\u0643\u0627\u0646: {location}.",
    types: {
      task_assigned: {
        subject: "\u0623\u0633\u0646\u062F \u0625\u0644\u064A\u0643 {actor} \u0627\u0644\u0645\u0647\u0645\u0629 \xAB{task}\xBB",
        heading: "\u0645\u0647\u0645\u0629 \u062C\u062F\u064A\u062F\u0629 \u0645\u064F\u0633\u0646\u062F\u0629 \u0625\u0644\u064A\u0643",
        body: "\u0623\u0633\u0646\u062F \u0625\u0644\u064A\u0643 {actor} \u0627\u0644\u0645\u0647\u0645\u0629 \xAB{task}\xBB \u0641\u064A \u0627\u0644\u0645\u0634\u0631\u0648\u0639 {project} \u0644\u062F\u0649 {organization}.",
        line: "\u0623\u0633\u0646\u062F \u0625\u0644\u064A\u0643 {actor} \u0627\u0644\u0645\u0647\u0645\u0629 \xAB{task}\xBB ({project})."
      },
      mention: {
        subject: "\u0630\u0643\u0631\u0643 {actor} \u0641\u064A \xAB{subject}\xBB",
        heading: "\u062A\u0645\u0651\u062A \u0627\u0644\u0625\u0634\u0627\u0631\u0629 \u0625\u0644\u064A\u0643",
        body: "\u0630\u0643\u0631\u0643 {actor} \u0641\u064A \u062A\u0639\u0644\u064A\u0642 \u0639\u0644\u0649 \xAB{subject}\xBB (\u0627\u0644\u0645\u0634\u0631\u0648\u0639 {project}\u060C {organization}).",
        line: "\u0630\u0643\u0631\u0643 {actor} \u0641\u064A \xAB{subject}\xBB ({project})."
      },
      mention_channel: {
        subject: "\u0630\u0643\u0631\u0643 {actor} \u0641\u064A \u0627\u0644\u0642\u0646\u0627\u0629 \xAB{subject}\xBB",
        heading: "\u062A\u0645\u0651\u062A \u0627\u0644\u0625\u0634\u0627\u0631\u0629 \u0625\u0644\u064A\u0643",
        body: "\u0630\u0643\u0631\u0643 {actor} \u0641\u064A \u0631\u0633\u0627\u0644\u0629 \u0636\u0645\u0646 \u0627\u0644\u0642\u0646\u0627\u0629 \xAB{subject}\xBB ({organization}).",
        line: "\u0630\u0643\u0631\u0643 {actor} \u0641\u064A \u0627\u0644\u0642\u0646\u0627\u0629 \xAB{subject}\xBB."
      },
      task_due: {
        subject: "\u062A\u0630\u0643\u064A\u0631: \u0645\u0648\u0639\u062F \u062A\u0633\u0644\u064A\u0645 \u0627\u0644\u0645\u0647\u0645\u0629 \xAB{task}\xBB \u0641\u064A {date}",
        heading: "\u0627\u0642\u062A\u0631\u0627\u0628 \u0645\u0648\u0639\u062F \u0627\u0644\u062A\u0633\u0644\u064A\u0645",
        body: "\u0645\u0648\u0639\u062F \u062A\u0633\u0644\u064A\u0645 \u0627\u0644\u0645\u0647\u0645\u0629 \xAB{task}\xBB \u0641\u064A \u0627\u0644\u0645\u0634\u0631\u0648\u0639 {project} \u0644\u062F\u0649 {organization} \u0647\u0648 {date}.",
        line: "\u0645\u0648\u0639\u062F \u062A\u0633\u0644\u064A\u0645 \u0627\u0644\u0645\u0647\u0645\u0629 \xAB{task}\xBB ({project}) \u0647\u0648 {date}."
      },
      task_overdue: {
        subject: "\u0645\u0647\u0645\u0629 \u0645\u062A\u0623\u062E\u0631\u0629: \xAB{task}\xBB",
        heading: "\u0645\u0647\u0645\u0629 \u0645\u062A\u0623\u062E\u0631\u0629",
        body: "\u0643\u0627\u0646 \u0645\u0648\u0639\u062F \u062A\u0633\u0644\u064A\u0645 \u0627\u0644\u0645\u0647\u0645\u0629 \xAB{task}\xBB \u0641\u064A \u0627\u0644\u0645\u0634\u0631\u0648\u0639 {project} \u0644\u062F\u0649 {organization} \u0647\u0648 {date} \u0648\u0644\u0645 \u062A\u064F\u0646\u062C\u064E\u0632 \u0628\u0639\u062F.",
        line: "\u0643\u0627\u0646 \u0645\u0648\u0639\u062F \u062A\u0633\u0644\u064A\u0645 \u0627\u0644\u0645\u0647\u0645\u0629 \xAB{task}\xBB ({project}) \u0647\u0648 {date}."
      },
      phase_due: {
        subject: "\u062A\u0630\u0643\u064A\u0631: \u062A\u0646\u062A\u0647\u064A \u0627\u0644\u0645\u0631\u062D\u0644\u0629 {phase} \u0641\u064A {date}",
        heading: "\u0627\u0642\u062A\u0631\u0627\u0628 \u0646\u0647\u0627\u064A\u0629 \u0627\u0644\u0645\u0631\u062D\u0644\u0629",
        body: "\u0627\u0644\u0646\u0647\u0627\u064A\u0629 \u0627\u0644\u0645\u0642\u0631\u0631\u0629 \u0644\u0644\u0645\u0631\u062D\u0644\u0629 {phase} \u0645\u0646 \u0627\u0644\u0645\u0634\u0631\u0648\u0639 {project} \u0644\u062F\u0649 {organization} \u0647\u064A {date}.",
        line: "\u062A\u0646\u062A\u0647\u064A \u0627\u0644\u0645\u0631\u062D\u0644\u0629 {phase} ({project}) \u0641\u064A {date}."
      },
      phase_overdue: {
        subject: "\u0645\u0631\u062D\u0644\u0629 \u0645\u062A\u0623\u062E\u0631\u0629: {phase}",
        heading: "\u0645\u0631\u062D\u0644\u0629 \u0645\u062A\u0623\u062E\u0631\u0629",
        body: "\u0643\u0627\u0646 \u0645\u0646 \u0627\u0644\u0645\u0642\u0631\u0631 \u0623\u0646 \u062A\u0646\u062A\u0647\u064A \u0627\u0644\u0645\u0631\u062D\u0644\u0629 {phase} \u0645\u0646 \u0627\u0644\u0645\u0634\u0631\u0648\u0639 {project} \u0644\u062F\u0649 {organization} \u0641\u064A {date} \u0648\u0644\u0645 \u062A\u064F\u063A\u0644\u0642 \u0628\u0639\u062F.",
        line: "\u0643\u0627\u0646 \u0645\u0646 \u0627\u0644\u0645\u0642\u0631\u0631 \u0623\u0646 \u062A\u0646\u062A\u0647\u064A \u0627\u0644\u0645\u0631\u062D\u0644\u0629 {phase} ({project}) \u0641\u064A {date}."
      },
      event_reminder: {
        subject: "\u062A\u0630\u0643\u064A\u0631: \xAB{event}\xBB \u064A\u0628\u062F\u0623 \u0641\u064A {when}",
        heading: "\u062D\u062F\u062B \u0642\u0631\u064A\u0628",
        body: "\u064A\u0628\u062F\u0623 \u0627\u0644\u062D\u062F\u062B \xAB{event}\xBB \u0644\u062F\u0649 {organization} \u0641\u064A {when}.{where}",
        line: "\u064A\u0628\u062F\u0623 \u0627\u0644\u062D\u062F\u062B \xAB{event}\xBB \u0641\u064A {when}."
      },
      bond_release_due: {
        subject: "\u062A\u0630\u0643\u064A\u0631: \u064A\u0645\u0643\u0646 \u0631\u0641\u0639 \u0627\u0644\u0643\u0641\u0627\u0644\u0629 \u0627\u0644\u0645\u062A\u0639\u0644\u0642\u0629 \u0628\u0627\u0644\u0639\u0642\u062F {subject} \u0641\u064A {date}",
        heading: "\u0637\u0644\u0628 \u0631\u0641\u0639 \u0627\u0644\u0643\u0641\u0627\u0644\u0629",
        body: "\u064A\u0645\u0643\u0646 \u0631\u0641\u0639 \u0643\u0641\u0627\u0644\u0629 \u062D\u0633\u0646 \u0627\u0644\u062A\u0646\u0641\u064A\u0630 \u0644\u0644\u0639\u0642\u062F {subject} \u0644\u062F\u0649 {organization} \u0641\u064A {date}. \u0644\u0627 \u062A\u0646\u0633\u064E \u0637\u0644\u0628 \u0631\u0641\u0639\u0647\u0627.",
        line: "\u064A\u0645\u0643\u0646 \u0631\u0641\u0639 \u0643\u0641\u0627\u0644\u0629 \u0627\u0644\u0639\u0642\u062F {subject} \u0641\u064A {date}."
      },
      partnership_request: {
        subject: "{organization} \u062A\u062F\u0639\u0648 {partner} \u0625\u0644\u0649 \u0627\u0644\u0641\u0636\u0627\u0621 \xAB{space}\xBB",
        heading: "\u0637\u0644\u0628 \u0634\u0631\u0627\u0643\u0629",
        body: "{actor} ({organization}) \u064A\u062F\u0639\u0648 \u0645\u0624\u0633\u0633\u062A\u0643\u0645 {partner} \u0625\u0644\u0649 \u0627\u0644\u062A\u0639\u0627\u0648\u0646 \u0641\u064A \u0627\u0644\u0641\u0636\u0627\u0621 \xAB{space}\xBB. \u0627\u0642\u0628\u0644\u0648\u0627 \u0627\u0644\u0637\u0644\u0628 \u0623\u0648 \u0627\u0631\u0641\u0636\u0648\u0647 \u0641\u064A BatiFlow\u060C \u062B\u0645 \u0627\u062E\u062A\u0627\u0631\u0648\u0627 \u0627\u0644\u0623\u0639\u0636\u0627\u0621 \u0627\u0644\u0630\u064A\u0646 \u0633\u064A\u062D\u0635\u0644\u0648\u0646 \u0639\u0644\u0649 \u0627\u0644\u0646\u0641\u0627\u0630.",
        line: "{organization} \u062A\u062F\u0639\u0648 {partner} \u0625\u0644\u0649 \u0627\u0644\u0641\u0636\u0627\u0621 \xAB{space}\xBB."
      },
      space_invitation_invited: {
        subject: "{actor} \u064A\u062F\u0639\u0648\u0643 \u0625\u0644\u0649 \u0627\u0644\u0641\u0636\u0627\u0621 \xAB{space}\xBB ({organization})",
        heading: "\u062F\u0639\u0648\u0629 \u0625\u0644\u0649 \u0641\u0636\u0627\u0621 \u0645\u0634\u062A\u0631\u0643",
        body: "{actor} \u064A\u062F\u0639\u0648\u0643 \u0644\u0644\u0627\u0646\u0636\u0645\u0627\u0645 \u0625\u0644\u0649 \u0627\u0644\u0641\u0636\u0627\u0621 \xAB{space}\xBB \u0627\u0644\u062A\u0627\u0628\u0639 \u0644\u0640{organization}. \u0627\u0641\u062A\u062D BatiFlow \u0644\u0644\u0642\u0628\u0648\u0644 \u0623\u0648 \u0627\u0644\u0631\u0641\u0636.",
        line: "\u062F\u0639\u0648\u0629 \u0625\u0644\u0649 \u0627\u0644\u0641\u0636\u0627\u0621 \xAB{space}\xBB ({organization})."
      },
      space_invitation_approval_requested: {
        subject: "\u0645\u0637\u0644\u0648\u0628 \u0645\u0648\u0627\u0641\u0642\u0629: \u062F\u0639\u0648\u0629 \u0623\u062D\u062F \u0627\u0644\u0623\u0639\u0636\u0627\u0621 \u0625\u0644\u0649 \u0641\u0636\u0627\u0621 \u062A\u0627\u0628\u0639 \u0644\u0640{organization}",
        heading: "\u0627\u0644\u0645\u0648\u0627\u0641\u0642\u0629 \u0639\u0644\u0649 \u0646\u0641\u0627\u0630 \u062E\u0627\u0631\u062C\u064A",
        body: "{actor} ({organization}) \u064A\u062F\u0639\u0648 \u0623\u062D\u062F \u0623\u0639\u0636\u0627\u0621 \u0645\u0624\u0633\u0633\u062A\u0643\u0645 \u0625\u0644\u0649 \u0627\u0644\u0641\u0636\u0627\u0621 \xAB{space}\xBB. \u062A\u0634\u062A\u0631\u0637 \u0645\u0624\u0633\u0633\u062A\u0643\u0645 \u0645\u0648\u0627\u0641\u0642\u0629 \u0623\u062D\u062F \u0627\u0644\u0645\u0634\u0631\u0641\u064A\u0646 \u0642\u0628\u0644 \u0623\u064A \u0646\u0641\u0627\u0630 \u062E\u0627\u0631\u062C\u064A.",
        line: "\u0646\u0641\u0627\u0630 \u062E\u0627\u0631\u062C\u064A \u0641\u064A \u0627\u0646\u062A\u0638\u0627\u0631 \u0627\u0644\u0645\u0648\u0627\u0641\u0642\u0629: \u0627\u0644\u0641\u0636\u0627\u0621 \xAB{space}\xBB ({organization})."
      },
      space_invitation_approval_reminder: {
        subject: "\u062A\u0630\u0643\u064A\u0631: \u0646\u0641\u0627\u0630 \u0625\u0644\u0649 \u0627\u0644\u0641\u0636\u0627\u0621 \xAB{space}\xBB \u0641\u064A \u0627\u0646\u062A\u0638\u0627\u0631 \u0645\u0648\u0627\u0641\u0642\u062A\u0643\u0645",
        heading: "\u0645\u0648\u0627\u0641\u0642\u0629 \u0645\u0639\u0644\u0651\u0642\u0629",
        body: "\u062F\u0639\u0648\u0629 {organization} \u0625\u0644\u0649 \u0627\u0644\u0641\u0636\u0627\u0621 \xAB{space}\xBB \u0645\u0627 \u0632\u0627\u0644\u062A \u0641\u064A \u0627\u0646\u062A\u0638\u0627\u0631 \u0645\u0648\u0627\u0641\u0642\u0629 \u0623\u062D\u062F \u0627\u0644\u0645\u0634\u0631\u0641\u064A\u0646. \u0633\u062A\u0646\u062A\u0647\u064A \u0635\u0644\u0627\u062D\u064A\u062A\u0647\u0627 \u0625\u0646 \u0644\u0645 \u064A\u064F\u0631\u062F \u0639\u0644\u064A\u0647\u0627.",
        line: "\u0645\u0627 \u0632\u0627\u0644\u062A \u0645\u0639\u0644\u0651\u0642\u0629: \u0627\u0644\u0641\u0636\u0627\u0621 \xAB{space}\xBB ({organization})."
      },
      space_invitation_partner_accepted: {
        subject: "{other} \u0642\u0628\u0644\u062A \u0627\u0644\u0627\u0646\u0636\u0645\u0627\u0645 \u0625\u0644\u0649 \u0627\u0644\u0641\u0636\u0627\u0621 \xAB{space}\xBB",
        heading: "\u062A\u0645 \u0642\u0628\u0648\u0644 \u0627\u0644\u0634\u0631\u0627\u0643\u0629",
        body: "\u0642\u0628\u0644\u062A {other} \u062F\u0639\u0648\u062A\u0643\u0645 \u0625\u0644\u0649 \u0627\u0644\u0641\u0636\u0627\u0621 \xAB{space}\xBB. \u064A\u0645\u0643\u0646 \u0644\u0645\u0634\u0631\u0641\u064A\u0647\u0627 \u0627\u0644\u0622\u0646 \u0625\u0636\u0627\u0641\u0629 \u0623\u0639\u0636\u0627\u0626\u0647\u0645.",
        line: "\u0627\u0646\u0636\u0645\u062A {other} \u0625\u0644\u0649 \u0627\u0644\u0641\u0636\u0627\u0621 \xAB{space}\xBB."
      },
      space_invitation_member_joined: {
        subject: "{actor} \u0627\u0646\u0636\u0645 \u0625\u0644\u0649 \u0627\u0644\u0641\u0636\u0627\u0621 \xAB{space}\xBB",
        heading: "\u0634\u062E\u0635 \u062C\u062F\u064A\u062F \u0641\u064A \u0627\u0644\u0641\u0636\u0627\u0621",
        body: "\u0623\u0635\u0628\u062D \u0644\u0640{actor} \u0646\u0641\u0627\u0630 \u0625\u0644\u0649 \u0627\u0644\u0641\u0636\u0627\u0621 \xAB{space}\xBB \u0627\u0644\u062A\u0627\u0628\u0639 \u0644\u0640{organization}.",
        line: "{actor} \u0627\u0646\u0636\u0645 \u0625\u0644\u0649 \u0627\u0644\u0641\u0636\u0627\u0621 \xAB{space}\xBB."
      },
      space_invitation_declined: {
        subject: "\u0631\u064F\u0641\u0636\u062A \u0627\u0644\u062F\u0639\u0648\u0629 \u0625\u0644\u0649 \u0627\u0644\u0641\u0636\u0627\u0621 \xAB{space}\xBB",
        heading: "\u062F\u0639\u0648\u0629 \u0645\u0631\u0641\u0648\u0636\u0629",
        body: "\u0631\u0641\u0636 {actor} \u0627\u0644\u062F\u0639\u0648\u0629 \u0625\u0644\u0649 \u0627\u0644\u0641\u0636\u0627\u0621 \xAB{space}\xBB.",
        line: "\u062F\u0639\u0648\u0629 \u0645\u0631\u0641\u0648\u0636\u0629: \u0627\u0644\u0641\u0636\u0627\u0621 \xAB{space}\xBB."
      },
      access_revoked_revoked: {
        subject: "\u062A\u0645 \u0633\u062D\u0628 \u0646\u0641\u0627\u0630\u0643 \u0625\u0644\u0649 \u0627\u0644\u0641\u0636\u0627\u0621 \xAB{space}\xBB",
        heading: "\u062A\u0645 \u0633\u062D\u0628 \u0627\u0644\u0646\u0641\u0627\u0630",
        body: "\u062A\u0645 \u0633\u062D\u0628 \u0646\u0641\u0627\u0630\u0643 \u0625\u0644\u0649 \u0627\u0644\u0641\u0636\u0627\u0621 \xAB{space}\xBB \u0627\u0644\u062A\u0627\u0628\u0639 \u0644\u0640{organization}. \u0644\u0645 \u062A\u0639\u062F \u0648\u062B\u0627\u0626\u0642 \u0647\u0630\u0627 \u0627\u0644\u0641\u0636\u0627\u0621 \u0648\u0645\u062D\u0627\u062F\u062B\u0627\u062A\u0647 \u0645\u062A\u0627\u062D\u0629 \u0644\u0643.",
        line: "\u062A\u0645 \u0633\u062D\u0628 \u0627\u0644\u0646\u0641\u0627\u0630: \u0627\u0644\u0641\u0636\u0627\u0621 \xAB{space}\xBB ({organization})."
      },
      access_revoked_expired: {
        subject: "\u0627\u0646\u062A\u0647\u062A \u0635\u0644\u0627\u062D\u064A\u0629 \u0646\u0641\u0627\u0630\u0643 \u0625\u0644\u0649 \u0627\u0644\u0641\u0636\u0627\u0621 \xAB{space}\xBB",
        heading: "\u0627\u0646\u062A\u0647\u062A \u0635\u0644\u0627\u062D\u064A\u0629 \u0627\u0644\u0646\u0641\u0627\u0630",
        body: "\u0628\u0644\u063A \u0646\u0641\u0627\u0630\u0643 \u0625\u0644\u0649 \u0627\u0644\u0641\u0636\u0627\u0621 \xAB{space}\xBB \u0627\u0644\u062A\u0627\u0628\u0639 \u0644\u0640{organization} \u062A\u0627\u0631\u064A\u062E \u0646\u0647\u0627\u064A\u062A\u0647. \u0627\u0637\u0644\u0628 \u0645\u0646 {organization} \u062A\u0645\u062F\u064A\u062F\u0647 \u0625\u0646 \u0643\u0646\u062A \u0645\u0627 \u0632\u0644\u062A \u0628\u062D\u0627\u062C\u0629 \u0625\u0644\u064A\u0647.",
        line: "\u0627\u0646\u062A\u0647\u062A \u0635\u0644\u0627\u062D\u064A\u0629 \u0627\u0644\u0646\u0641\u0627\u0630: \u0627\u0644\u0641\u0636\u0627\u0621 \xAB{space}\xBB ({organization})."
      },
      access_revoked_partner_removed: {
        subject: "\u0644\u0645 \u062A\u0639\u062F \u0645\u0624\u0633\u0633\u062A\u0643\u0645 \u062A\u0634\u0627\u0631\u0643 \u0641\u064A \u0627\u0644\u0641\u0636\u0627\u0621 \xAB{space}\xBB",
        heading: "\u0627\u0646\u062A\u0647\u062A \u0627\u0644\u0634\u0631\u0627\u0643\u0629",
        body: "\u0627\u0646\u062A\u0647\u062A \u0634\u0631\u0627\u0643\u0629 \u0645\u0624\u0633\u0633\u062A\u0643\u0645 \u0641\u064A \u0627\u0644\u0641\u0636\u0627\u0621 \xAB{space}\xBB \u0627\u0644\u062A\u0627\u0628\u0639 \u0644\u0640{organization}: \u062A\u0645 \u0633\u062D\u0628 \u0646\u0641\u0627\u0630\u0643.",
        line: "\u0627\u0646\u062A\u0647\u062A \u0627\u0644\u0634\u0631\u0627\u0643\u0629: \u0627\u0644\u0641\u0636\u0627\u0621 \xAB{space}\xBB ({organization})."
      },
      access_revoked_space_closed: {
        subject: "\u062A\u0645 \u0625\u063A\u0644\u0627\u0642 \u0627\u0644\u0641\u0636\u0627\u0621 \xAB{space}\xBB",
        heading: "\u0641\u0636\u0627\u0621 \u0645\u063A\u0644\u0642",
        body: "\u0623\u063A\u0644\u0642\u062A {organization} \u0627\u0644\u0641\u0636\u0627\u0621 \xAB{space}\xBB: \u062A\u0645 \u0633\u062D\u0628 \u0646\u0641\u0627\u0630\u0643.",
        line: "\u0641\u0636\u0627\u0621 \u0645\u063A\u0644\u0642: \xAB{space}\xBB ({organization})."
      },
      data_export_ready: {
        subject: "\u0646\u0633\u062E\u0629 \u0628\u064A\u0627\u0646\u0627\u062A {organization} \u062C\u0627\u0647\u0632\u0629",
        heading: "\u0646\u0633\u062E\u062A\u0643 \u062C\u0627\u0647\u0632\u0629",
        body: "\u0646\u0633\u062E\u0629 \u0628\u064A\u0627\u0646\u0627\u062A {organization} \u062C\u0627\u0647\u0632\u0629. \u0646\u0632\u0651\u0644\u0647\u0627 \u0645\u0646 \u0635\u0641\u062D\u0629 \u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A \u0648\u0627\u0644\u062D\u0630\u0641: \u062A\u0628\u0642\u0649 \u0645\u062A\u0627\u062D\u0629 7 \u0623\u064A\u0627\u0645.",
        line: "\u0646\u0633\u062E\u0629 \u0628\u064A\u0627\u0646\u0627\u062A {organization} \u062C\u0627\u0647\u0632\u0629."
      },
      data_export_failed: {
        subject: "\u0641\u0634\u0644 \u062A\u0635\u062F\u064A\u0631 \u0628\u064A\u0627\u0646\u0627\u062A {organization}",
        heading: "\u0641\u0634\u0644 \u0627\u0644\u062A\u0635\u062F\u064A\u0631",
        body: "\u062A\u0639\u0630\u0651\u0631 \u0625\u0639\u062F\u0627\u062F \u0646\u0633\u062E\u0629 \u0628\u064A\u0627\u0646\u0627\u062A {organization}. \u0627\u0637\u0644\u0628 \u0646\u0633\u062E\u0629 \u062C\u062F\u064A\u062F\u0629 \u0645\u0646 \u0635\u0641\u062D\u0629 \u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A \u0648\u0627\u0644\u062D\u0630\u0641.",
        line: "\u0641\u0634\u0644 \u062A\u0635\u062F\u064A\u0631 \u0628\u064A\u0627\u0646\u0627\u062A {organization}."
      },
      organization_deletion_scheduled: {
        subject: "\u062D\u0630\u0641 {organization} \u0645\u0628\u0631\u0645\u062C \u0628\u062A\u0627\u0631\u064A\u062E {date}",
        heading: "\u062D\u0630\u0641 \u0645\u0628\u0631\u0645\u062C",
        body: "\u0633\u062A\u064F\u062D\u0630\u0641 \u0628\u064A\u0627\u0646\u0627\u062A {organization} \u0646\u0647\u0627\u0626\u064A\u064B\u0627 \u0628\u062A\u0627\u0631\u064A\u062E {date}. \u0625\u0644\u0649 \u0630\u0644\u0643 \u0627\u0644\u062D\u064A\u0646\u060C \u0635\u062F\u0651\u0631 \u0627\u0644\u0648\u062B\u0627\u0626\u0642 \u0648\u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A \u0627\u0644\u062A\u064A \u062A\u062D\u062A\u0627\u062C\u0647\u0627. \u064A\u0645\u0643\u0646 \u0644\u0644\u0645\u0627\u0644\u0643 \u0625\u0644\u063A\u0627\u0621 \u0627\u0644\u062D\u0630\u0641 \u062D\u062A\u0649 \u0630\u0644\u0643 \u0627\u0644\u062A\u0627\u0631\u064A\u062E.",
        line: "\u062D\u0630\u0641 {organization} \u0645\u0628\u0631\u0645\u062C \u0628\u062A\u0627\u0631\u064A\u062E {date}."
      },
      organization_deletion_cancelled: {
        subject: "\u0623\u064F\u0644\u063A\u064A \u062D\u0630\u0641 {organization}",
        heading: "\u0623\u064F\u0644\u063A\u064A \u0627\u0644\u062D\u0630\u0641",
        body: "\u0623\u064F\u0644\u063A\u064A \u0627\u0644\u062D\u0630\u0641 \u0627\u0644\u0645\u0628\u0631\u0645\u062C \u0644\u0628\u064A\u0627\u0646\u0627\u062A {organization}. \u0644\u0645 \u064A\u064F\u062D\u0630\u0641 \u0623\u064A \u0634\u064A\u0621.",
        line: "\u0623\u064F\u0644\u063A\u064A \u062D\u0630\u0641 {organization}."
      },
      meeting_started: {
        subject: "\u0628\u062F\u0623 {by} \u0627\u0644\u0627\u062C\u062A\u0645\u0627\u0639 \xAB{meeting}\xBB",
        heading: "\u0627\u062C\u062A\u0645\u0627\u0639 \u062C\u0627\u0631\u064D",
        body: "\u0628\u062F\u0623 {by} \u0627\u0644\u0627\u062C\u062A\u0645\u0627\u0639 \xAB{meeting}\xBB \u0641\u064A {organization}. \u0627\u0646\u0636\u0645 \u0625\u0644\u064A\u0647 \u0645\u0646 BatiFlow.",
        line: "\u0628\u062F\u0623 {by} \u0627\u0644\u0627\u062C\u062A\u0645\u0627\u0639 \xAB{meeting}\xBB."
      },
      meeting_invited: {
        subject: "\u064A\u062F\u0639\u0648\u0643 {by} \u0625\u0644\u0649 \u0627\u0644\u0627\u062C\u062A\u0645\u0627\u0639 \xAB{meeting}\xBB",
        heading: "\u062F\u0639\u0648\u0629 \u0625\u0644\u0649 \u0627\u062C\u062A\u0645\u0627\u0639",
        body: "\u064A\u062F\u0639\u0648\u0643 {by} \u0625\u0644\u0649 \u0627\u0644\u0627\u062C\u062A\u0645\u0627\u0639 \xAB{meeting}\xBB \u0641\u064A {organization}.",
        line: "\u064A\u062F\u0639\u0648\u0643 {by} \u0625\u0644\u0649 \u0627\u0644\u0627\u062C\u062A\u0645\u0627\u0639 \xAB{meeting}\xBB."
      },
      call_missed: {
        subject: "\u0645\u0643\u0627\u0644\u0645\u0629 \u0641\u0627\u0626\u062A\u0629 \u0645\u0646 {caller}",
        heading: "\u0645\u0643\u0627\u0644\u0645\u0629 \u0641\u0627\u0626\u062A\u0629",
        body: "\u0627\u062A\u0635\u0644 \u0628\u0643 {caller} \u0639\u0644\u0649 BatiFlow ({organization}).",
        line: "\u0645\u0643\u0627\u0644\u0645\u0629 \u0641\u0627\u0626\u062A\u0629 \u0645\u0646 {caller}."
      },
      minutes_published: {
        subject: "\u0646\u064F\u0634\u0631 \u0627\u0644\u0645\u062D\u0636\u0631 {number}: \xAB{meeting}\xBB",
        heading: "\u0646\u064F\u0634\u0631 \u0645\u062D\u0636\u0631 \u0627\u0644\u0627\u062C\u062A\u0645\u0627\u0639",
        body: "\u0646\u0634\u0631 {by} \u0627\u0644\u0645\u062D\u0636\u0631 {number} \u0644\u0627\u062C\u062A\u0645\u0627\u0639 \xAB{meeting}\xBB \u0641\u064A {organization}.",
        line: "\u0646\u064F\u0634\u0631 \u0627\u0644\u0645\u062D\u0636\u0631 {number} \u0644\u0627\u062C\u062A\u0645\u0627\u0639 \xAB{meeting}\xBB."
      },
      timesheet_reminder: {
        subject: "\u0644\u0627 \u062A\u0646\u0633\u064E \u0625\u0631\u0633\u0627\u0644 \u0623\u0648\u0642\u0627\u062A \u0639\u0645\u0644\u0643 \u0644\u0647\u0630\u0627 \u0627\u0644\u0623\u0633\u0628\u0648\u0639",
        heading: "\u0648\u0631\u0642\u0629 \u0623\u0648\u0642\u0627\u062A \u0628\u0627\u0646\u062A\u0638\u0627\u0631 \u0627\u0644\u0625\u0631\u0633\u0627\u0644",
        body: "\u0644\u0645 \u062A\u064F\u0631\u0633\u0644 \u0628\u0639\u062F \u0623\u0633\u0628\u0648\u0639\u0643 \u0627\u0644\u0630\u064A \u064A\u0628\u062F\u0623 \u0641\u064A {week} \u0644\u062F\u0649 {organization}. \u0623\u062F\u062E\u0644 \u0623\u0648\u0642\u0627\u062A\u0643 \u062B\u0645 \u0623\u0631\u0633\u0644\u0647\u0627 \u0642\u0628\u0644 \u064A\u0648\u0645 \u0627\u0644\u0627\u062B\u0646\u064A\u0646.",
        line: "\u0644\u0645 \u062A\u064F\u0631\u0633\u0644 \u0628\u0639\u062F \u0623\u0633\u0628\u0648\u0639\u0643 \u0627\u0644\u0630\u064A \u064A\u0628\u062F\u0623 \u0641\u064A {week}."
      },
      phase_deadline: {
        subject: "\u0627\u0644\u0623\u062C\u0644 \u0627\u0644\u062A\u0639\u0627\u0642\u062F\u064A: {phase} \u2014 {project}",
        heading: "\u0627\u0644\u0623\u062C\u0644 \u0627\u0644\u062A\u0639\u0627\u0642\u062F\u064A \u0644\u0644\u0645\u0631\u062D\u0644\u0629",
        body: "\u062A\u0642\u062A\u0631\u0628 \u0627\u0644\u0645\u0631\u062D\u0644\u0629 {phase} \u0645\u0646 \u0627\u0644\u0645\u0634\u0631\u0648\u0639 {project} \u0645\u0646 \u0623\u062C\u0644\u0647\u0627 \u0627\u0644\u062A\u0639\u0627\u0642\u062F\u064A \u0641\u064A {deadline} (\u0644\u062F\u0649 {organization}). \u0623\u064A\u0627\u0645 \u0627\u0644\u062A\u0623\u062E\u064A\u0631: {daysLate}.",
        line: "\u0627\u0644\u0645\u0631\u062D\u0644\u0629 {phase} \u0645\u0646 {project}: \u0627\u0644\u0623\u062C\u0644 \u0627\u0644\u062A\u0639\u0627\u0642\u062F\u064A \u0641\u064A {deadline}."
      },
      vault_expiring: {
        subject: "\u0648\u062B\u064A\u0642\u0629 \u064A\u062C\u0628 \u062A\u062C\u062F\u064A\u062F\u0647\u0627: {subject}",
        heading: "\u0648\u062B\u064A\u0642\u0629 \u0641\u064A \u0627\u0644\u062E\u0632\u0646\u0629 \u062A\u0642\u062A\u0631\u0628 \u0645\u0646 \u0627\u0646\u062A\u0647\u0627\u0621 \u0635\u0644\u0627\u062D\u064A\u062A\u0647\u0627",
        body: "\u062A\u0646\u062A\u0647\u064A \u0635\u0644\u0627\u062D\u064A\u0629 \u0627\u0644\u0648\u062B\u064A\u0642\u0629 \xAB{subject}\xBB \u0641\u064A \u062E\u0632\u0646\u0629 {organization} \u0628\u062A\u0627\u0631\u064A\u062E {date}. \u062D\u0636\u0651\u0631\u0648\u0627 \u062A\u062C\u062F\u064A\u062F\u0647\u0627 \u062D\u062A\u0649 \u0644\u0627 \u064A\u062A\u0639\u0637\u0644 \u0631\u062F\u0643\u0645 \u0639\u0644\u0649 \u0637\u0644\u0628\u0627\u062A \u0627\u0644\u0639\u0631\u0648\u0636.",
        line: "\u062A\u0646\u062A\u0647\u064A \u0635\u0644\u0627\u062D\u064A\u0629 \xAB{subject}\xBB \u0628\u062A\u0627\u0631\u064A\u062E {date}."
      },
      time_budget: {
        subject: "\u0627\u0644\u0645\u064A\u0632\u0627\u0646\u064A\u0629 \u0627\u0644\u0632\u0645\u0646\u064A\u0629 \u0639\u0646\u062F {percent} %: {project}",
        heading: "\u0627\u0644\u0645\u064A\u0632\u0627\u0646\u064A\u0629 \u0627\u0644\u0632\u0645\u0646\u064A\u0629 \u0639\u0644\u0649 \u0648\u0634\u0643 \u0627\u0644\u0646\u0641\u0627\u062F",
        body: "\u0627\u0633\u062A\u0647\u0644\u0643\u062A \u0627\u0644\u0645\u0631\u062D\u0644\u0629 {phase} \u0645\u0646 \u0627\u0644\u0645\u0634\u0631\u0648\u0639 {project} \u200F{percent} % \u0645\u0646 \u0645\u064A\u0632\u0627\u0646\u064A\u062A\u0647\u0627 \u0627\u0644\u0632\u0645\u0646\u064A\u0629. \u0631\u0627\u062C\u0639\u0648\u0627 \u0631\u0628\u062D\u064A\u0629 \u0627\u0644\u0645\u0634\u0631\u0648\u0639 \u0648\u0639\u062F\u0651\u0644\u0648\u0627 \u0627\u0644\u062A\u062E\u0637\u064A\u0637 \u0623\u0648 \u0627\u0644\u0645\u064A\u0632\u0627\u0646\u064A\u0629.",
        line: "\u0627\u0644\u0645\u0631\u062D\u0644\u0629 {phase}: {percent} % \u0645\u0646 \u0627\u0644\u0645\u064A\u0632\u0627\u0646\u064A\u0629 \u0627\u0644\u0632\u0645\u0646\u064A\u0629."
      },
      signature_requested: {
        subject: "\u0645\u0637\u0644\u0648\u0628 \u062A\u0648\u0642\u064A\u0639\u0643: {title}",
        heading: "\u0648\u062B\u064A\u0642\u0629 \u0641\u064A \u0627\u0646\u062A\u0638\u0627\u0631 \u062A\u0648\u0642\u064A\u0639\u0643",
        body: "\u064A\u0637\u0644\u0628 \u0645\u0646\u0643 {requester} \u062A\u0648\u0642\u064A\u0639 \xAB{title}\xBB ({document}). \u0627\u0641\u062A\u062D \u0627\u0644\u0637\u0644\u0628 \u0641\u064A BatiFlow: \u0633\u064A\u0635\u0644\u0643 \u0631\u0645\u0632 \u0628\u0627\u0644\u0628\u0631\u064A\u062F \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A \u0644\u062A\u0623\u0643\u064A\u062F \u062A\u0648\u0642\u064A\u0639\u0643.",
        line: "{requester}: \xAB{title}\xBB."
      },
      signature_update: {
        subject: "\u0637\u0644\u0628 \u062A\u0648\u0642\u064A\u0639: {title}",
        heading: "\u062A\u063A\u064A\u0651\u0631 \u0637\u0644\u0628 \u0627\u0644\u062A\u0648\u0642\u064A\u0639",
        body: "\u062A\u063A\u064A\u0651\u0631 \u0637\u0644\u0628 \u0627\u0644\u062A\u0648\u0642\u064A\u0639 \xAB{title}\xBB. \u0627\u0641\u062A\u062D\u0647 \u0641\u064A BatiFlow \u0644\u0645\u0639\u0631\u0641\u0629 \u062D\u0627\u0644\u062A\u0647.",
        line: "\u062A\u063A\u064A\u0651\u0631 \xAB{title}\xBB."
      },
      signature_update_completed: {
        subject: "\u0648\u062B\u064A\u0642\u0629 \u0645\u0648\u0642\u0651\u0639\u0629: {title}",
        heading: "\u0648\u0642\u0651\u0639 \u062C\u0645\u064A\u0639 \u0627\u0644\u0645\u0648\u0642\u0651\u0639\u064A\u0646",
        body: "\u0648\u0642\u0651\u0639 \u062C\u0645\u064A\u0639 \u0627\u0644\u0645\u0648\u0642\u0651\u0639\u064A\u0646 \xAB{title}\xBB. \u0634\u0647\u0627\u062F\u0629 \u0627\u0644\u0625\u062B\u0628\u0627\u062A \u0645\u062A\u0627\u062D\u0629 \u0641\u064A \u0627\u0644\u0637\u0644\u0628.",
        line: "\xAB{title}\xBB \u0645\u0648\u0642\u0651\u0639\u0629."
      },
      signature_update_declined: {
        subject: "\u0631\u064F\u0641\u0636 \u0627\u0644\u062A\u0648\u0642\u064A\u0639: {title}",
        heading: "\u0631\u0641\u0636 \u0623\u062D\u062F \u0627\u0644\u0645\u0648\u0642\u0651\u0639\u064A\u0646 \u0627\u0644\u062A\u0648\u0642\u064A\u0639",
        body: "\u0631\u0641\u0636 {signer} \u062A\u0648\u0642\u064A\u0639 \xAB{title}\xBB. \u0627\u0641\u062A\u062D \u0627\u0644\u0637\u0644\u0628 \u0644\u0642\u0631\u0627\u0621\u0629 \u0627\u0644\u0633\u0628\u0628.",
        line: "\u0631\u0641\u0636 {signer} \xAB{title}\xBB."
      }
    },
    generic: {
      subject: "\u0625\u0634\u0639\u0627\u0631 \u062C\u062F\u064A\u062F \u0645\u0646 BatiFlow",
      heading: "\u0625\u0634\u0639\u0627\u0631 \u062C\u062F\u064A\u062F",
      body: "\u0644\u062F\u064A\u0643 \u0625\u0634\u0639\u0627\u0631 \u062C\u062F\u064A\u062F \u0645\u0646 {organization}.",
      line: "\u0625\u0634\u0639\u0627\u0631 \u062C\u062F\u064A\u062F."
    },
    phases: {
      esq: "\u0627\u0644\u0645\u062E\u0637\u0637 \u0627\u0644\u0623\u0648\u0644\u064A (\u2066ESQ\u2069)",
      aps: "\u0627\u0644\u062F\u0631\u0627\u0633\u0629 \u0627\u0644\u0623\u0648\u0644\u064A\u0629 \u0627\u0644\u0645\u0648\u062C\u0632\u0629 (\u2066APS\u2069)",
      apd: "\u0627\u0644\u062F\u0631\u0627\u0633\u0629 \u0627\u0644\u0623\u0648\u0644\u064A\u0629 \u0627\u0644\u0645\u0641\u0635\u0644\u0629 (\u2066APD\u2069)",
      pro: "\u062F\u0631\u0627\u0633\u0629 \u0627\u0644\u0645\u0634\u0631\u0648\u0639 (\u2066PRO\u2069)",
      dce: "\u0645\u0644\u0641 \u0637\u0644\u0628 \u0627\u0644\u0639\u0631\u0648\u0636 \u0644\u0644\u0645\u0642\u0627\u0648\u0644\u064A\u0646 (\u2066DCE\u2069)",
      act: "\u0627\u0644\u0645\u0633\u0627\u0639\u062F\u0629 \u0639\u0644\u0649 \u0625\u0628\u0631\u0627\u0645 \u0639\u0642\u0648\u062F \u0627\u0644\u0623\u0634\u063A\u0627\u0644 (\u2066ACT\u2069)",
      det: "\u0627\u0644\u0625\u0634\u0631\u0627\u0641 \u0639\u0644\u0649 \u062A\u0646\u0641\u064A\u0630 \u0627\u0644\u0623\u0634\u063A\u0627\u0644 (\u2066DET\u2069)",
      aor_provisional: "\u0627\u0644\u0645\u0633\u0627\u0639\u062F\u0629 \u0639\u0644\u0649 \u0627\u0644\u0642\u0628\u0648\u0644 \u0627\u0644\u0648\u0642\u062A\u064A (\u2066AOR\u2069 \u0627\u0644\u0645\u0624\u0642\u062A)",
      aor_final: "\u0627\u0644\u0645\u0633\u0627\u0639\u062F\u0629 \u0639\u0644\u0649 \u0627\u0644\u0642\u0628\u0648\u0644 \u0627\u0644\u0646\u0647\u0627\u0626\u064A (\u2066AOR\u2069 \u0627\u0644\u0646\u0647\u0627\u0626\u064A)"
    }
  },
  digest: {
    subject: "\u0645\u0644\u062E\u0651\u0635\u0643 \u0639\u0644\u0649 BatiFlow",
    preview: "\u0645\u0627 \u062D\u062F\u062B \u0641\u064A \u0645\u0634\u0627\u0631\u064A\u0639\u0643",
    heading: "\u0645\u0644\u062E\u0651\u0635 \u0625\u0634\u0639\u0627\u0631\u0627\u062A\u0643",
    intro: "\u0625\u0644\u064A\u0643 \u0645\u0627 \u062D\u062F\u062B \u0645\u0646\u0630 \u0645\u0644\u062E\u0651\u0635\u0643 \u0627\u0644\u0623\u062E\u064A\u0631.",
    open: "\u0641\u062A\u062D",
    action: "\u0641\u062A\u062D BatiFlow"
  },
  roles: {
    owner: "\u0645\u0627\u0644\u0643",
    admin: "\u0645\u0634\u0631\u0641",
    project_manager: "\u0631\u0626\u064A\u0633 \u0645\u0634\u0631\u0648\u0639",
    engineer: "\u0645\u0647\u0646\u062F\u0633 \u0623\u0648 \u0645\u0639\u0645\u0627\u0631\u064A",
    draftsman: "\u0631\u0633\u0651\u0627\u0645",
    accountant: "\u0645\u062D\u0627\u0633\u0628"
  },
  spaceInvitation: {
    subject: "{inviter} \u064A\u062F\u0639\u0648\u0643 \u0625\u0644\u0649 \u0627\u0644\u0641\u0636\u0627\u0621 \xAB{space}\xBB \u0627\u0644\u062A\u0627\u0628\u0639 \u0644\u0640{organization}",
    preview: "\u0627\u0646\u0636\u0645 \u0625\u0644\u0649 \u0627\u0644\u0641\u0636\u0627\u0621 \xAB{space}\xBB \u0639\u0644\u0649 BatiFlow",
    heading: "\u062F\u0639\u0648\u0629 \u0625\u0644\u0649 \u0627\u0644\u0641\u0636\u0627\u0621 \xAB{space}\xBB",
    body: "{inviter} ({organization}) \u064A\u062F\u0639\u0648\u0643 \u0625\u0644\u0649 \u0627\u0644\u062A\u0639\u0627\u0648\u0646 \u0641\u064A \u0627\u0644\u0641\u0636\u0627\u0621 \u0627\u0644\u0645\u0634\u062A\u0631\u0643 \xAB{space}\xBB \u0639\u0644\u0649 BatiFlow.",
    bodyGuest: "{inviter} ({organization}) \u064A\u062F\u0639\u0648\u0643 \u0643\u0636\u064A\u0641 \u0625\u0644\u0649 \u0627\u0644\u0641\u0636\u0627\u0621 \u0627\u0644\u0645\u0634\u062A\u0631\u0643 \xAB{space}\xBB \u0639\u0644\u0649 BatiFlow. \u0633\u062A\u0631\u0649 \u0641\u0642\u0637 \u0627\u0644\u0645\u0644\u0641\u0627\u062A \u0648\u0627\u0644\u0645\u062D\u0627\u062F\u062B\u0627\u062A \u0627\u0644\u0645\u0641\u062A\u0648\u062D\u0629 \u0644\u0643.",
    action: "\u0639\u0631\u0636 \u0627\u0644\u062F\u0639\u0648\u0629",
    account: "\u0633\u062C\u0651\u0644 \u0627\u0644\u062F\u062E\u0648\u0644 \u0628\u0639\u0646\u0648\u0627\u0646 \u0627\u0644\u0628\u0631\u064A\u062F \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A \u0647\u0630\u0627. \u0625\u0646 \u0644\u0645 \u064A\u0643\u0646 \u0644\u062F\u064A\u0643 \u062D\u0633\u0627\u0628 \u0628\u0639\u062F\u060C \u064A\u0631\u0633\u0644 \u0644\u0643 BatiFlow \u0631\u0633\u0627\u0644\u0629 \u062B\u0627\u0646\u064A\u0629 \u0644\u0627\u062E\u062A\u064A\u0627\u0631 \u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631.",
    expiry: "\u0647\u0630\u0647 \u0627\u0644\u062F\u0639\u0648\u0629 \u0635\u0627\u0644\u062D\u0629 \u062D\u062A\u0649 {expiresAt}.",
    fallback: "\u0625\u0646 \u0644\u0645 \u064A\u0639\u0645\u0644 \u0627\u0644\u0632\u0631\u060C \u0627\u0646\u0633\u062E \u0647\u0630\u0627 \u0627\u0644\u0631\u0627\u0628\u0637 \u0641\u064A \u0645\u062A\u0635\u0641\u062D\u0643:"
  },
  quoteSent: {
    subject: "\u0627\u0644\u0639\u0631\u0636 \u0627\u0644\u0645\u0627\u0644\u064A {number} \u0645\u0646 {organization}: {title}",
    preview: "\u0627\u0637\u0651\u0644\u0639 \u0639\u0644\u0649 \u0627\u0644\u0639\u0631\u0636 \u0627\u0644\u0645\u0627\u0644\u064A {number} \u0648\u0627\u0642\u0628\u0644\u0647 \u0639\u0628\u0631 \u0627\u0644\u0625\u0646\u062A\u0631\u0646\u062A",
    heading: "\u0627\u0644\u0639\u0631\u0636 \u0627\u0644\u0645\u0627\u0644\u064A {number}",
    body: "\u064A\u0631\u0633\u0644 \u0625\u0644\u064A\u0643 {sender} ({organization}) \u0627\u0644\u0639\u0631\u0636 \u0627\u0644\u0645\u0627\u0644\u064A {number} \xAB{title}\xBB. \u064A\u0645\u0643\u0646\u0643 \u0627\u0644\u0627\u0637\u0644\u0627\u0639 \u0639\u0644\u064A\u0647 \u0648\u062A\u0646\u0632\u064A\u0644\u0647 \u0628\u0635\u064A\u063A\u0629 PDF \u0648\u0642\u0628\u0648\u0644\u0647 \u0639\u0628\u0631 \u0627\u0644\u0625\u0646\u062A\u0631\u0646\u062A.",
    action: "\u0639\u0631\u0636 \u0627\u0644\u0639\u0631\u0636 \u0627\u0644\u0645\u0627\u0644\u064A",
    account: "\u0644\u0627 \u062D\u0627\u062C\u0629 \u0625\u0644\u0649 \u062D\u0633\u0627\u0628: \u064A\u0643\u0641\u064A \u0647\u0630\u0627 \u0627\u0644\u0631\u0627\u0628\u0637 \u0627\u0644\u0634\u062E\u0635\u064A. \u0644\u0627 \u062A\u0634\u0627\u0631\u0643\u0647 \u0645\u0639 \u063A\u064A\u0631\u0643.",
    expiry: "\u0647\u0630\u0627 \u0627\u0644\u0631\u0627\u0628\u0637 \u0635\u0627\u0644\u062D \u0625\u0644\u0649 \u063A\u0627\u064A\u0629 {expiresAt}.",
    fallback: "\u0625\u0630\u0627 \u0644\u0645 \u064A\u0639\u0645\u0644 \u0627\u0644\u0632\u0631\u060C \u0627\u0646\u0633\u062E \u0647\u0630\u0627 \u0627\u0644\u0631\u0627\u0628\u0637 \u0641\u064A \u0645\u062A\u0635\u0641\u062D\u0643:"
  },
  transmittalSent: {
    subject: "\u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u0625\u0631\u0633\u0627\u0644 {number} \u0645\u0646 {organization}: {title}",
    preview: "\u0627\u0637\u0651\u0644\u0639 \u0639\u0644\u0649 \u0648\u062B\u0627\u0626\u0642 \u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u0625\u0631\u0633\u0627\u0644 {number} \u0648\u0623\u0643\u0651\u062F \u0627\u0644\u0627\u0633\u062A\u0644\u0627\u0645",
    heading: "\u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u0625\u0631\u0633\u0627\u0644 {number}",
    body: "\u064A\u0631\u0633\u0644 \u0625\u0644\u064A\u0643 {sender} ({organization}) {count, plural, one {\u0648\u062B\u064A\u0642\u0629 \u0648\u0627\u062D\u062F\u0629} two {\u0648\u062B\u064A\u0642\u062A\u064A\u0646} few {# \u0648\u062B\u0627\u0626\u0642} many {# \u0648\u062B\u064A\u0642\u0629} other {# \u0648\u062B\u064A\u0642\u0629}} \u0639\u0628\u0631 \u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u0625\u0631\u0633\u0627\u0644 {number} \xAB{title}\xBB. \u064A\u0645\u0643\u0646\u0643 \u0627\u0644\u0627\u0637\u0644\u0627\u0639 \u0639\u0644\u064A\u0647\u0627 \u0648\u062A\u0646\u0632\u064A\u0644\u0647\u0627 \u0648\u062A\u0623\u0643\u064A\u062F \u0627\u0644\u0627\u0633\u062A\u0644\u0627\u0645 \u0639\u0628\u0631 \u0627\u0644\u0625\u0646\u062A\u0631\u0646\u062A.",
    action: "\u0641\u062A\u062D \u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u0625\u0631\u0633\u0627\u0644",
    account: "\u0644\u0627 \u062D\u0627\u062C\u0629 \u0625\u0644\u0649 \u062D\u0633\u0627\u0628: \u064A\u0643\u0641\u064A \u0647\u0630\u0627 \u0627\u0644\u0631\u0627\u0628\u0637 \u0627\u0644\u0634\u062E\u0635\u064A. \u0644\u0627 \u062A\u0634\u0627\u0631\u0643\u0647 \u0645\u0639 \u063A\u064A\u0631\u0643.",
    expiry: "\u0647\u0630\u0627 \u0627\u0644\u0631\u0627\u0628\u0637 \u0635\u0627\u0644\u062D \u0625\u0644\u0649 \u063A\u0627\u064A\u0629 {expiresAt}.",
    fallback: "\u0625\u0630\u0627 \u0644\u0645 \u064A\u0639\u0645\u0644 \u0627\u0644\u0632\u0631\u060C \u0627\u0646\u0633\u062E \u0647\u0630\u0627 \u0627\u0644\u0631\u0627\u0628\u0637 \u0641\u064A \u0645\u062A\u0635\u0641\u062D\u0643:"
  },
  invoiceReminder: {
    subject: "\u062A\u0630\u0643\u064A\u0631: \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629 {number} \u0645\u0646 {organization} \u0627\u0644\u0645\u0633\u062A\u062D\u0642\u0629 \u0641\u064A {dueDate}",
    preview: "\u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629 {number}: \u064A\u0628\u0642\u0649 {outstanding} \u0644\u0644\u062E\u0644\u0627\u0635",
    heading: "\u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629 {number} \u0641\u064A \u0627\u0646\u062A\u0638\u0627\u0631 \u0627\u0644\u062E\u0644\u0627\u0635",
    body: "\u0645\u0627 \u0644\u0645 \u0646\u0643\u0646 \u0645\u062E\u0637\u0626\u064A\u0646\u060C \u0644\u0645 \u064A\u062A\u0645 \u0628\u0639\u062F \u062E\u0644\u0627\u0635 \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629 {number} \u0645\u0646 {organization}\u060C \u0627\u0644\u0645\u0633\u062A\u062D\u0642\u0629 \u0641\u064A {dueDate}\u060C \u0628\u0627\u0644\u0643\u0627\u0645\u0644 (\u062A\u0623\u062E\u064A\u0631 {days} \u064A\u0648\u0645\u0627).",
    amount: "\u0627\u0644\u0645\u0628\u0644\u063A \u0627\u0644\u0645\u062A\u0628\u0642\u064A: {outstanding}",
    closing: "\u0625\u0630\u0627 \u062A\u0645 \u0627\u0644\u062E\u0644\u0627\u0635\u060C \u064A\u0631\u062C\u0649 \u0639\u062F\u0645 \u0627\u0639\u062A\u0628\u0627\u0631 \u0647\u0630\u0647 \u0627\u0644\u0631\u0633\u0627\u0644\u0629. \u0644\u0623\u064A \u0627\u0633\u062A\u0641\u0633\u0627\u0631\u060C \u0627\u062A\u0635\u0644 \u0645\u0628\u0627\u0634\u0631\u0629 \u0628\u0640 {organization}."
  },
  meetingInvitation: {
    subject: "\u064A\u062F\u0639\u0648\u0643 {inviter} \u0625\u0644\u0649 \u0627\u0644\u0627\u062C\u062A\u0645\u0627\u0639 \xAB{meeting}\xBB",
    preview: "\u0627\u0646\u0636\u0645 \u0625\u0644\u0649 \u0627\u0644\u0627\u062C\u062A\u0645\u0627\u0639 \xAB{meeting}\xBB \u0639\u0644\u0649 BatiFlow",
    heading: "\u062F\u0639\u0648\u0629 \u0625\u0644\u0649 \u0627\u0644\u0627\u062C\u062A\u0645\u0627\u0639 \xAB{meeting}\xBB",
    body: "\u064A\u062F\u0639\u0648\u0643 {inviter} ({organization}) \u0625\u0644\u0649 \u0627\u0644\u0645\u0634\u0627\u0631\u0643\u0629 \u0641\u064A \u0627\u0644\u0627\u062C\u062A\u0645\u0627\u0639 \xAB{meeting}\xBB \u0639\u0644\u0649 BatiFlow.",
    action: "\u0627\u0644\u0627\u0646\u0636\u0645\u0627\u0645 \u0625\u0644\u0649 \u0627\u0644\u0627\u062C\u062A\u0645\u0627\u0639",
    account: "\u0633\u062C\u0651\u0644 \u0627\u0644\u062F\u062E\u0648\u0644 \u0628\u0647\u0630\u0627 \u0627\u0644\u0628\u0631\u064A\u062F \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A. \u0625\u0646 \u0644\u0645 \u064A\u0643\u0646 \u0644\u062F\u064A\u0643 \u062D\u0633\u0627\u0628 \u0628\u0639\u062F\u060C \u0641\u0623\u0646\u0634\u0626\u0647 \u0628\u0627\u0644\u0639\u0646\u0648\u0627\u0646 \u0646\u0641\u0633\u0647.",
    expiry: "\u0647\u0630\u0627 \u0627\u0644\u0631\u0627\u0628\u0637 \u0635\u0627\u0644\u062D \u062D\u062A\u0649 {expiresAt} \u0648\u064A\u064F\u0633\u062A\u062E\u062F\u0645 \u0645\u0631\u0629 \u0648\u0627\u062D\u062F\u0629 \u0641\u0642\u0637.",
    fallback: "\u0625\u0646 \u0644\u0645 \u064A\u0639\u0645\u0644 \u0627\u0644\u0632\u0631\u060C \u0627\u0646\u0633\u062E \u0647\u0630\u0627 \u0627\u0644\u0631\u0627\u0628\u0637 \u0641\u064A \u0645\u062A\u0635\u0641\u062D\u0643:"
  },
  directoryContact: {
    subject: "\u0631\u0633\u0627\u0644\u0629 \u062C\u062F\u064A\u062F\u0629 \u0639\u0628\u0631 \u062F\u0644\u064A\u0644 BatiFlow: {subject}",
    preview: "{sender} \u064A\u0631\u0627\u0633\u0644\u0643\u0645 \u0639\u0628\u0631 \u062F\u0644\u064A\u0644 BatiFlow",
    heading: "\u0631\u0633\u0627\u0644\u0629 \u062C\u062F\u064A\u062F\u0629 \u0639\u0628\u0631 \u0627\u0644\u062F\u0644\u064A\u0644",
    body: "\u0643\u062A\u0628 {sender} ({senderOrganization}) \u0625\u0644\u0649 {organization} \u0639\u0628\u0631 \u062F\u0644\u064A\u0644 BatiFlow.",
    bodyNoOrganization: "\u0643\u062A\u0628 {sender} \u0625\u0644\u0649 {organization} \u0639\u0628\u0631 \u062F\u0644\u064A\u0644 BatiFlow.",
    subjectLabel: "\u0627\u0644\u0645\u0648\u0636\u0648\u0639",
    messageLabel: "\u0627\u0644\u0631\u0633\u0627\u0644\u0629",
    reply: "\u064A\u0643\u0641\u064A \u0623\u0646 \u062A\u0631\u062F\u0651 \u0639\u0644\u0649 \u0647\u0630\u0647 \u0627\u0644\u0631\u0633\u0627\u0644\u0629: \u0633\u064A\u0635\u0644 \u0631\u062F\u0651\u0643 \u0625\u0644\u0649 {sender}.",
    notice: "\u062A\u0635\u0644\u0643 \u0647\u0630\u0647 \u0627\u0644\u0631\u0633\u0627\u0644\u0629 \u0644\u0623\u0646 {organization} \u0645\u062F\u0631\u062C\u0629 \u0641\u064A \u062F\u0644\u064A\u0644 \u0627\u0644\u0634\u0631\u0643\u0627\u0621 \u0648\u0644\u0623\u0646\u0643 \u0645\u0627\u0644\u0643\u0647\u0627 \u0623\u0648 \u0623\u062D\u062F \u0645\u0634\u0631\u0641\u064A\u0647\u0627. \u064A\u0645\u0643\u0646\u0643 \u0625\u0644\u063A\u0627\u0621 \u0627\u0644\u0625\u062F\u0631\u0627\u062C \u0641\u064A \u0623\u064A \u0648\u0642\u062A \u0645\u0646 \u0625\u0639\u062F\u0627\u062F\u0627\u062A \u0627\u0644\u0645\u0624\u0633\u0633\u0629."
  },
  signatureCode: {
    signature: {
      subject: "\u0631\u0645\u0632 \u0627\u0644\u062A\u0648\u0642\u064A\u0639 \u0627\u0644\u062E\u0627\u0635 \u0628\u0643",
      preview: "\u0631\u0645\u0632 \u0644\u062A\u0648\u0642\u064A\u0639 \xAB{subject}\xBB",
      heading: "\u0631\u0645\u0632 \u0627\u0644\u062A\u0648\u0642\u064A\u0639 \u0627\u0644\u062E\u0627\u0635 \u0628\u0643",
      body: "\u0623\u062F\u062E\u0644 \u0647\u0630\u0627 \u0627\u0644\u0631\u0645\u0632 \u0641\u064A BatiFlow \u0644\u062A\u0648\u0642\u064A\u0639 \xAB{subject}\xBB."
    },
    batch: {
      subject: "\u0631\u0645\u0632 \u0627\u0644\u062A\u0648\u0642\u064A\u0639 DigiGO",
      preview: "\u0631\u0645\u0632 \u0644\u062A\u0648\u0642\u064A\u0639 {subject}",
      heading: "\u0623\u0643\u0651\u062F \u062A\u0648\u0642\u064A\u0639 \u0641\u0648\u0627\u062A\u064A\u0631\u0643",
      body: "\u0623\u062F\u062E\u0644 \u0647\u0630\u0627 \u0627\u0644\u0631\u0645\u0632 \u0641\u064A BatiFlow \u0644\u062A\u0648\u0642\u064A\u0639 {subject} \u0628\u0634\u0647\u0627\u062F\u0629 DigiGO \u0627\u0644\u062E\u0627\u0635\u0629 \u0628\u0643.",
      count: "{count} \u0641\u0627\u062A\u0648\u0631\u0629"
    },
    validity: "\u0647\u0630\u0627 \u0627\u0644\u0631\u0645\u0632 \u0635\u0627\u0644\u062D \u0644\u0645\u062F\u0629 {minutes} \u062F\u0642\u0627\u0626\u0642 \u0648\u0644\u0627 \u064A\u064F\u0633\u062A\u0639\u0645\u0644 \u0625\u0644\u0627 \u0645\u0631\u0629 \u0648\u0627\u062D\u062F\u0629.",
    notice: "\u0644\u0627 \u062A\u064F\u0637\u0644\u0639 \u0623\u062D\u062F\u064B\u0627 \u0639\u0644\u0649 \u0647\u0630\u0627 \u0627\u0644\u0631\u0645\u0632: \u0644\u0646 \u064A\u0637\u0644\u0628\u0647 \u0645\u0646\u0643 BatiFlow \u0623\u0628\u062F\u064B\u0627 \u0628\u0627\u0644\u0647\u0627\u062A\u0641. \u0625\u0646 \u0644\u0645 \u062A\u0643\u0646 \u0635\u0627\u062D\u0628 \u0647\u0630\u0627 \u0627\u0644\u0637\u0644\u0628 \u0641\u062A\u062C\u0627\u0647\u0644 \u0647\u0630\u0647 \u0627\u0644\u0631\u0633\u0627\u0644\u0629."
  }
};

// locales/en/email.json
var email_default2 = {
  layout: {
    footer: "You are receiving this message because someone took an action for you on BatiFlow. If you did not expect it, you can ignore it.",
    brand: "BatiFlow"
  },
  memberInvitation: {
    subject: "{inviter} invited you to join {organization} on BatiFlow",
    preview: "Join {organization} on BatiFlow",
    heading: "Join {organization}",
    body: "{inviter} invited you to join the {organization} workspace on BatiFlow as {role}.",
    action: "Accept the invitation",
    account: "Sign in with this email address. If you do not have an account yet, BatiFlow sends you a second message to choose your password.",
    expiry: "This invitation is valid until {expiresAt}.",
    fallback: "If the button does not work, copy this link into your browser:"
  },
  notification: {
    action: "Open in BatiFlow",
    fallback: "If the button does not work, copy this link into your browser:",
    settings: "You choose which notifications you receive by email in your profile, under Notifications.",
    eventPlace: " Location: {location}.",
    types: {
      task_assigned: {
        subject: "{actor} assigned you the task \u201C{task}\u201D",
        heading: "New task assigned",
        body: "{actor} assigned you the task \u201C{task}\u201D in the project {project}, at {organization}.",
        line: "{actor} assigned you the task \u201C{task}\u201D ({project})."
      },
      mention: {
        subject: "{actor} mentioned you in \u201C{subject}\u201D",
        heading: "You were mentioned",
        body: "{actor} mentioned you in a comment on \u201C{subject}\u201D (project {project}, {organization}).",
        line: "{actor} mentioned you in \u201C{subject}\u201D ({project})."
      },
      mention_channel: {
        subject: "{actor} mentioned you in the channel \u201C{subject}\u201D",
        heading: "You were mentioned",
        body: "{actor} mentioned you in a message in the channel \u201C{subject}\u201D ({organization}).",
        line: "{actor} mentioned you in the channel \u201C{subject}\u201D."
      },
      task_due: {
        subject: "Reminder: the task \u201C{task}\u201D is due on {date}",
        heading: "Due date approaching",
        body: "The task \u201C{task}\u201D in the project {project}, at {organization}, is due on {date}.",
        line: "The task \u201C{task}\u201D ({project}) is due on {date}."
      },
      task_overdue: {
        subject: "Overdue task: \u201C{task}\u201D",
        heading: "Task overdue",
        body: "The task \u201C{task}\u201D in the project {project}, at {organization}, was due on {date} and is not done.",
        line: "The task \u201C{task}\u201D ({project}) was due on {date}."
      },
      phase_due: {
        subject: "Reminder: the phase {phase} ends on {date}",
        heading: "Phase end approaching",
        body: "The phase {phase} of the project {project}, at {organization}, is planned to end on {date}.",
        line: "The phase {phase} ({project}) ends on {date}."
      },
      phase_overdue: {
        subject: "Overdue phase: {phase}",
        heading: "Phase overdue",
        body: "The phase {phase} of the project {project}, at {organization}, was planned to end on {date} and is not closed.",
        line: "The phase {phase} ({project}) was planned to end on {date}."
      },
      event_reminder: {
        subject: "Reminder: \u201C{event}\u201D starts on {when}",
        heading: "Upcoming event",
        body: "The event \u201C{event}\u201D at {organization} starts on {when}.{where}",
        line: "The event \u201C{event}\u201D starts on {when}."
      },
      bond_release_due: {
        subject: "Reminder: the bond of contract {subject} can be released on {date}",
        heading: "Bond release to request",
        body: "The performance bond of contract {subject} at {organization} can be released on {date}. Remember to request its release.",
        line: "The bond of contract {subject} can be released on {date}."
      },
      partnership_request: {
        subject: "{organization} invites {partner} to the space \u201C{space}\u201D",
        heading: "Partnership request",
        body: "{actor} ({organization}) invites your organisation {partner} to work together in the space \u201C{space}\u201D. Accept or decline the request in BatiFlow, then choose the members who will have access.",
        line: "{organization} invites {partner} to the space \u201C{space}\u201D."
      },
      space_invitation_invited: {
        subject: "{actor} invites you to the space \u201C{space}\u201D ({organization})",
        heading: "Invitation to a shared space",
        body: "{actor} invites you to join the space \u201C{space}\u201D of {organization}. Open BatiFlow to accept or decline.",
        line: "Invitation to the space \u201C{space}\u201D ({organization})."
      },
      space_invitation_approval_requested: {
        subject: "Approval requested: a member is invited to a space of {organization}",
        heading: "Approve an external access",
        body: "{actor} ({organization}) invites a member of your organisation to the space \u201C{space}\u201D. Your organisation requires an administrator\u2019s approval before any external access.",
        line: "External access to approve: space \u201C{space}\u201D ({organization})."
      },
      space_invitation_approval_reminder: {
        subject: "Reminder: an access to the space \u201C{space}\u201D is waiting for your approval",
        heading: "Approval pending",
        body: "The invitation from {organization} to the space \u201C{space}\u201D is still waiting for an administrator\u2019s approval. Without an answer it will expire.",
        line: "Still pending: space \u201C{space}\u201D ({organization})."
      },
      space_invitation_partner_accepted: {
        subject: "{other} accepted to join the space \u201C{space}\u201D",
        heading: "Partnership accepted",
        body: "{other} accepted your invitation to the space \u201C{space}\u201D. Its administrators can now add their members.",
        line: "{other} joined the space \u201C{space}\u201D."
      },
      space_invitation_member_joined: {
        subject: "{actor} joined the space \u201C{space}\u201D",
        heading: "New person in the space",
        body: "{actor} now has access to the space \u201C{space}\u201D of {organization}.",
        line: "{actor} joined the space \u201C{space}\u201D."
      },
      space_invitation_declined: {
        subject: "Invitation declined for the space \u201C{space}\u201D",
        heading: "Invitation declined",
        body: "{actor} declined the invitation to the space \u201C{space}\u201D.",
        line: "Invitation declined: space \u201C{space}\u201D."
      },
      access_revoked_revoked: {
        subject: "Your access to the space \u201C{space}\u201D was removed",
        heading: "Access removed",
        body: "Your access to the space \u201C{space}\u201D of {organization} was removed. Its documents and conversations are no longer available to you.",
        line: "Access removed: space \u201C{space}\u201D ({organization})."
      },
      access_revoked_expired: {
        subject: "Your access to the space \u201C{space}\u201D has expired",
        heading: "Access expired",
        body: "Your access to the space \u201C{space}\u201D of {organization} reached its end date. Ask {organization} to extend it if you still need it.",
        line: "Access expired: space \u201C{space}\u201D ({organization})."
      },
      access_revoked_partner_removed: {
        subject: "Your organisation no longer takes part in the space \u201C{space}\u201D",
        heading: "Partnership ended",
        body: "Your organisation\u2019s partnership in the space \u201C{space}\u201D of {organization} has ended: your access was removed.",
        line: "Partnership ended: space \u201C{space}\u201D ({organization})."
      },
      access_revoked_space_closed: {
        subject: "The space \u201C{space}\u201D was closed",
        heading: "Space closed",
        body: "{organization} closed the space \u201C{space}\u201D: your access was removed.",
        line: "Space closed: \u201C{space}\u201D ({organization})."
      },
      data_export_ready: {
        subject: "The data export of {organization} is ready",
        heading: "Your export is ready",
        body: "The data export of {organization} is ready. Download it from the Data and deletion page: it stays available for 7 days.",
        line: "The data export of {organization} is ready."
      },
      data_export_failed: {
        subject: "The data export of {organization} failed",
        heading: "The export failed",
        body: "The data export of {organization} could not be prepared. Ask for a new one from the Data and deletion page.",
        line: "The data export of {organization} failed."
      },
      organization_deletion_scheduled: {
        subject: "The deletion of {organization} is scheduled for {date}",
        heading: "Deletion scheduled",
        body: "The data of {organization} will be permanently deleted on {date}. Until then, export the documents and data you need. The owner can cancel the deletion until that date.",
        line: "The deletion of {organization} is scheduled for {date}."
      },
      organization_deletion_cancelled: {
        subject: "The deletion of {organization} is cancelled",
        heading: "Deletion cancelled",
        body: "The scheduled deletion of the data of {organization} was cancelled. Nothing was deleted.",
        line: "The deletion of {organization} is cancelled."
      },
      meeting_started: {
        subject: "{by} started the meeting \u201C{meeting}\u201D",
        heading: "Meeting in progress",
        body: "{by} started the meeting \u201C{meeting}\u201D at {organization}. Join it from BatiFlow.",
        line: "{by} started the meeting \u201C{meeting}\u201D."
      },
      meeting_invited: {
        subject: "{by} invites you to the meeting \u201C{meeting}\u201D",
        heading: "Meeting invitation",
        body: "{by} invites you to the meeting \u201C{meeting}\u201D at {organization}.",
        line: "{by} invites you to the meeting \u201C{meeting}\u201D."
      },
      call_missed: {
        subject: "Missed call from {caller}",
        heading: "Missed call",
        body: "{caller} called you on BatiFlow ({organization}).",
        line: "Missed call from {caller}."
      },
      minutes_published: {
        subject: "{number} published: \u201C{meeting}\u201D",
        heading: "Minutes published",
        body: "{by} published the minutes {number} of the meeting \u201C{meeting}\u201D at {organization}.",
        line: "{number} published for \u201C{meeting}\u201D."
      },
      timesheet_reminder: {
        subject: "Remember to submit this week\u2019s time",
        heading: "Timesheet to submit",
        body: "Your week of {week} is not submitted yet at {organization}. Enter your time, then submit it before Monday.",
        line: "Your week of {week} is not submitted yet."
      },
      phase_deadline: {
        subject: "Contractual deadline: {phase} \u2014 {project}",
        heading: "Phase contractual deadline",
        body: "The phase {phase} of the project {project} is reaching its contractual deadline of {deadline} (at {organization}). Days late: {daysLate}.",
        line: "Phase {phase} of {project}: contractual deadline of {deadline}."
      },
      vault_expiring: {
        subject: "Document to renew: {subject}",
        heading: "Vault document expiring soon",
        body: "The vault document \u201C{subject}\u201D of {organization} expires on {date}. Prepare its renewal so your tender answers are not held up.",
        line: "\u201C{subject}\u201D expires on {date}."
      },
      time_budget: {
        subject: "Time budget at {percent}%: {project}",
        heading: "Time budget almost used",
        body: "Phase {phase} of project {project} has used {percent}% of its time budget. Check the project\u2019s profitability and adjust the schedule or the budget.",
        line: "Phase {phase}: {percent}% of the time budget."
      },
      signature_requested: {
        subject: "Signature requested: {title}",
        heading: "A document is waiting for your signature",
        body: "{requester} asks you to sign \u201C{title}\u201D ({document}). Open the request in BatiFlow: a code will be emailed to you to confirm your signature.",
        line: "{requester}: \u201C{title}\u201D."
      },
      signature_update: {
        subject: "Signature request: {title}",
        heading: "Your signature request changed",
        body: "The signature request \u201C{title}\u201D changed. Open it in BatiFlow to see where it stands.",
        line: "\u201C{title}\u201D changed."
      },
      signature_update_completed: {
        subject: "Document signed: {title}",
        heading: "Every signer has signed",
        body: "\u201C{title}\u201D was signed by every signer. The evidence certificate is available in the request.",
        line: "\u201C{title}\u201D is signed."
      },
      signature_update_declined: {
        subject: "Signature declined: {title}",
        heading: "A signer declined to sign",
        body: "{signer} declined to sign \u201C{title}\u201D. Open the request to read their reason.",
        line: "{signer} declined \u201C{title}\u201D."
      }
    },
    generic: {
      subject: "New BatiFlow notification",
      heading: "New notification",
      body: "You have a new notification from {organization}.",
      line: "New notification."
    },
    phases: {
      esq: "Sketch design (ESQ)",
      aps: "Preliminary design (APS)",
      apd: "Detailed design (APD)",
      pro: "Project design (PRO)",
      dce: "Tender documents (DCE)",
      act: "Assistance with works contracts (ACT)",
      det: "Works supervision (DET)",
      aor_provisional: "Assistance with provisional acceptance (AOR provisional)",
      aor_final: "Assistance with final acceptance (AOR final)"
    }
  },
  digest: {
    subject: "Your BatiFlow summary",
    preview: "What happened on your projects",
    heading: "Your notification summary",
    intro: "Here is what happened since your last summary.",
    open: "Open",
    action: "Open BatiFlow"
  },
  roles: {
    owner: "owner",
    admin: "administrator",
    project_manager: "project manager",
    engineer: "engineer or architect",
    draftsman: "draftsman",
    accountant: "accountant"
  },
  spaceInvitation: {
    subject: "{inviter} invites you to the space \u201C{space}\u201D of {organization}",
    preview: "Join the space \u201C{space}\u201D on BatiFlow",
    heading: "Invitation to the space \u201C{space}\u201D",
    body: "{inviter} ({organization}) invites you to work together in the shared space \u201C{space}\u201D on BatiFlow.",
    bodyGuest: "{inviter} ({organization}) invites you as a guest to the shared space \u201C{space}\u201D on BatiFlow. You will only see the folders and conversations opened to you.",
    action: "See the invitation",
    account: "Sign in with this email address. If you do not have an account yet, BatiFlow sends you a second message to choose your password.",
    expiry: "This invitation is valid until {expiresAt}.",
    fallback: "If the button does not work, copy this link into your browser:"
  },
  quoteSent: {
    subject: "Quote {number} from {organization}: {title}",
    preview: "View and accept quote {number} online",
    heading: "Quote {number}",
    body: "{sender} ({organization}) sends you quote {number} \u201C{title}\u201D. You can view it, download the PDF and accept it online.",
    action: "View the quote",
    account: "No account is needed: this personal link is enough. Do not pass it on.",
    expiry: "This link is valid until {expiresAt}.",
    fallback: "If the button does not work, copy this link into your browser:"
  },
  transmittalSent: {
    subject: "Transmittal {number} from {organization}: {title}",
    preview: "View the documents of transmittal {number} and acknowledge receipt",
    heading: "Transmittal {number}",
    body: "{sender} ({organization}) sends you {count, plural, one {# document} other {# documents}} in transmittal {number} \u201C{title}\u201D. You can view and download them and acknowledge receipt online.",
    action: "Open the transmittal",
    account: "No account is needed: this personal link is enough. Do not pass it on.",
    expiry: "This link is valid until {expiresAt}.",
    fallback: "If the button does not work, copy this link into your browser:"
  },
  invoiceReminder: {
    subject: "Reminder: invoice {number} from {organization} was due on {dueDate}",
    preview: "Invoice {number}: {outstanding} still to pay",
    heading: "Invoice {number} to pay",
    body: "Unless we are mistaken, invoice {number} from {organization}, due on {dueDate}, is not fully paid yet ({days} days late).",
    amount: "Still to pay: {outstanding}",
    closing: "If you have already paid, please ignore this message. For any question, contact {organization} directly."
  },
  meetingInvitation: {
    subject: "{inviter} invites you to the meeting \u201C{meeting}\u201D",
    preview: "Join the meeting \u201C{meeting}\u201D on BatiFlow",
    heading: "Invitation to the meeting \u201C{meeting}\u201D",
    body: "{inviter} ({organization}) invites you to take part in the meeting \u201C{meeting}\u201D on BatiFlow.",
    action: "Join the meeting",
    account: "Sign in with this email address. If you do not have an account yet, create one with this same address.",
    expiry: "This link is valid until {expiresAt} and works only once.",
    fallback: "If the button does not work, copy this link into your browser:"
  },
  directoryContact: {
    subject: "New message through the BatiFlow directory: {subject}",
    preview: "{sender} wrote to you through the BatiFlow directory",
    heading: "New message through the directory",
    body: "{sender} ({senderOrganization}) wrote to {organization} through the BatiFlow directory.",
    bodyNoOrganization: "{sender} wrote to {organization} through the BatiFlow directory.",
    subjectLabel: "Subject",
    messageLabel: "Message",
    reply: "Just reply to this email: your answer goes to {sender}.",
    notice: "You receive this because {organization} is listed in the partner directory and you are its owner or an administrator. You can opt out at any time in the organisation settings."
  },
  signatureCode: {
    signature: {
      subject: "Your signature code",
      preview: "Code to sign \u201C{subject}\u201D",
      heading: "Your signature code",
      body: "Type this code in BatiFlow to sign \u201C{subject}\u201D."
    },
    batch: {
      subject: "Your DigiGO signature code",
      preview: "Code to sign {subject}",
      heading: "Confirm the signature of your invoices",
      body: "Type this code in BatiFlow to sign {subject} with your DigiGO certificate.",
      count: "{count} invoice(s)"
    },
    validity: "This code is valid for {minutes} minutes and works only once.",
    notice: "Never share this code: BatiFlow will never ask for it by phone. If you did not ask for it, ignore this email."
  }
};

// locales/fr/email.json
var email_default3 = {
  layout: {
    footer: "Vous recevez ce message parce qu\u2019une action a \xE9t\xE9 faite pour vous sur BatiFlow. Si vous ne l\u2019attendiez pas, ignorez-le.",
    brand: "BatiFlow"
  },
  memberInvitation: {
    subject: "{inviter} vous invite \xE0 rejoindre {organization} sur BatiFlow",
    preview: "Rejoignez {organization} sur BatiFlow",
    heading: "Rejoignez {organization}",
    body: "{inviter} vous invite \xE0 rejoindre l\u2019espace de travail de {organization} sur BatiFlow, en tant que {role}.",
    action: "Accepter l\u2019invitation",
    account: "Connectez-vous avec cette adresse e-mail. Si vous n\u2019avez pas encore de compte, BatiFlow vous envoie un second message pour choisir votre mot de passe.",
    expiry: "Cette invitation est valable jusqu\u2019au {expiresAt}.",
    fallback: "Si le bouton ne fonctionne pas, copiez ce lien dans votre navigateur\xA0:"
  },
  notification: {
    action: "Ouvrir dans BatiFlow",
    fallback: "Si le bouton ne fonctionne pas, copiez ce lien dans votre navigateur\xA0:",
    settings: "Vous choisissez les notifications re\xE7ues par e-mail dans votre profil, rubrique Notifications.",
    eventPlace: " Lieu : {location}.",
    types: {
      task_assigned: {
        subject: "{actor} vous a assign\xE9 la t\xE2che \xAB\xA0{task}\xA0\xBB",
        heading: "Nouvelle t\xE2che assign\xE9e",
        body: "{actor} vous a assign\xE9 la t\xE2che \xAB\xA0{task}\xA0\xBB dans le projet {project}, chez {organization}.",
        line: "{actor} vous a assign\xE9 la t\xE2che \xAB\xA0{task}\xA0\xBB ({project})."
      },
      mention: {
        subject: "{actor} vous a mentionn\xE9 dans \xAB\xA0{subject}\xA0\xBB",
        heading: "Vous avez \xE9t\xE9 mentionn\xE9",
        body: "{actor} vous a mentionn\xE9 dans un commentaire de \xAB\xA0{subject}\xA0\xBB (projet {project}, {organization}).",
        line: "{actor} vous a mentionn\xE9 dans \xAB\xA0{subject}\xA0\xBB ({project})."
      },
      mention_channel: {
        subject: "{actor} vous a mentionn\xE9 dans le canal \xAB\xA0{subject}\xA0\xBB",
        heading: "Vous avez \xE9t\xE9 mentionn\xE9",
        body: "{actor} vous a mentionn\xE9 dans un message du canal \xAB\xA0{subject}\xA0\xBB ({organization}).",
        line: "{actor} vous a mentionn\xE9 dans le canal \xAB\xA0{subject}\xA0\xBB."
      },
      task_due: {
        subject: "Rappel\xA0: la t\xE2che \xAB\xA0{task}\xA0\xBB arrive \xE0 \xE9ch\xE9ance le {date}",
        heading: "\xC9ch\xE9ance proche",
        body: "La t\xE2che \xAB\xA0{task}\xA0\xBB du projet {project} (chez {organization}) arrive \xE0 \xE9ch\xE9ance le {date}.",
        line: "La t\xE2che \xAB\xA0{task}\xA0\xBB ({project}) arrive \xE0 \xE9ch\xE9ance le {date}."
      },
      task_overdue: {
        subject: "T\xE2che en retard\xA0: \xAB\xA0{task}\xA0\xBB",
        heading: "T\xE2che en retard",
        body: "La t\xE2che \xAB\xA0{task}\xA0\xBB du projet {project} (chez {organization}) \xE9tait \xE0 rendre le {date} et n\u2019est pas termin\xE9e.",
        line: "La t\xE2che \xAB\xA0{task}\xA0\xBB ({project}) \xE9tait \xE0 rendre le {date}."
      },
      phase_due: {
        subject: "Rappel\xA0: la phase {phase} se termine le {date}",
        heading: "Fin de phase proche",
        body: "La fin pr\xE9vue de la phase {phase} du projet {project} (chez {organization}) est le {date}.",
        line: "La phase {phase} ({project}) se termine le {date}."
      },
      phase_overdue: {
        subject: "Phase en retard\xA0: {phase}",
        heading: "Phase en retard",
        body: "La phase {phase} du projet {project} (chez {organization}) devait se terminer le {date} et n\u2019est pas cl\xF4tur\xE9e.",
        line: "La phase {phase} ({project}) devait se terminer le {date}."
      },
      event_reminder: {
        subject: "Rappel : \xAB {event} \xBB commence le {when}",
        heading: "\xC9v\xE9nement \xE0 venir",
        body: "L\u2019\xE9v\xE9nement \xAB {event} \xBB (chez {organization}) commence le {when}.{where}",
        line: "L\u2019\xE9v\xE9nement \xAB {event} \xBB commence le {when}."
      },
      bond_release_due: {
        subject: "Rappel : la caution du contrat {subject} peut \xEAtre lib\xE9r\xE9e le {date}",
        heading: "Mainlev\xE9e de caution \xE0 demander",
        body: "La caution de bonne ex\xE9cution du contrat {subject} (chez {organization}) peut \xEAtre lib\xE9r\xE9e le {date}. Pensez \xE0 en demander la mainlev\xE9e.",
        line: "La caution du contrat {subject} peut \xEAtre lib\xE9r\xE9e le {date}."
      },
      partnership_request: {
        subject: "{organization} invite {partner} \xE0 l\u2019espace \xAB {space} \xBB",
        heading: "Demande de partenariat",
        body: "{actor} ({organization}) invite votre organisation {partner} \xE0 collaborer dans l\u2019espace \xAB {space} \xBB. Acceptez ou refusez la demande dans BatiFlow, puis choisissez les membres qui y auront acc\xE8s.",
        line: "{organization} invite {partner} \xE0 l\u2019espace \xAB {space} \xBB."
      },
      space_invitation_invited: {
        subject: "{actor} vous invite dans l\u2019espace \xAB {space} \xBB ({organization})",
        heading: "Invitation \xE0 un espace partag\xE9",
        body: "{actor} vous invite \xE0 rejoindre l\u2019espace \xAB {space} \xBB de {organization}. Ouvrez BatiFlow pour accepter ou refuser.",
        line: "Invitation \xE0 l\u2019espace \xAB {space} \xBB ({organization})."
      },
      space_invitation_approval_requested: {
        subject: "Approbation demand\xE9e : un membre est invit\xE9 dans un espace de {organization}",
        heading: "Approbation d\u2019un acc\xE8s externe",
        body: "{actor} ({organization}) invite un membre de votre organisation dans l\u2019espace \xAB {space} \xBB. Votre organisation demande l\u2019approbation d\u2019un administrateur avant tout acc\xE8s externe.",
        line: "Acc\xE8s externe \xE0 approuver : espace \xAB {space} \xBB ({organization})."
      },
      space_invitation_approval_reminder: {
        subject: "Rappel : un acc\xE8s \xE0 l\u2019espace \xAB {space} \xBB attend votre approbation",
        heading: "Approbation en attente",
        body: "L\u2019invitation de {organization} dans l\u2019espace \xAB {space} \xBB attend toujours l\u2019approbation d\u2019un administrateur. Sans r\xE9ponse, elle expirera.",
        line: "Toujours en attente : espace \xAB {space} \xBB ({organization})."
      },
      space_invitation_partner_accepted: {
        subject: "{other} a accept\xE9 de rejoindre l\u2019espace \xAB {space} \xBB",
        heading: "Partenariat accept\xE9",
        body: "{other} a accept\xE9 votre invitation dans l\u2019espace \xAB {space} \xBB. Ses administrateurs peuvent maintenant y ajouter leurs membres.",
        line: "{other} a rejoint l\u2019espace \xAB {space} \xBB."
      },
      space_invitation_member_joined: {
        subject: "{actor} a rejoint l\u2019espace \xAB {space} \xBB",
        heading: "Nouvelle personne dans l\u2019espace",
        body: "{actor} a maintenant acc\xE8s \xE0 l\u2019espace \xAB {space} \xBB de {organization}.",
        line: "{actor} a rejoint l\u2019espace \xAB {space} \xBB."
      },
      space_invitation_declined: {
        subject: "Invitation refus\xE9e pour l\u2019espace \xAB {space} \xBB",
        heading: "Invitation refus\xE9e",
        body: "{actor} a refus\xE9 l\u2019invitation \xE0 l\u2019espace \xAB {space} \xBB.",
        line: "Invitation refus\xE9e : espace \xAB {space} \xBB."
      },
      access_revoked_revoked: {
        subject: "Votre acc\xE8s \xE0 l\u2019espace \xAB {space} \xBB a \xE9t\xE9 retir\xE9",
        heading: "Acc\xE8s retir\xE9",
        body: "Votre acc\xE8s \xE0 l\u2019espace \xAB {space} \xBB de {organization} a \xE9t\xE9 retir\xE9. Les documents et discussions de cet espace ne vous sont plus accessibles.",
        line: "Acc\xE8s retir\xE9 : espace \xAB {space} \xBB ({organization})."
      },
      access_revoked_expired: {
        subject: "Votre acc\xE8s \xE0 l\u2019espace \xAB {space} \xBB a expir\xE9",
        heading: "Acc\xE8s expir\xE9",
        body: "Votre acc\xE8s \xE0 l\u2019espace \xAB {space} \xBB de {organization} est arriv\xE9 \xE0 sa date de fin. Demandez \xE0 {organization} de le prolonger si vous en avez encore besoin.",
        line: "Acc\xE8s expir\xE9 : espace \xAB {space} \xBB ({organization})."
      },
      access_revoked_partner_removed: {
        subject: "Votre organisation ne participe plus \xE0 l\u2019espace \xAB {space} \xBB",
        heading: "Partenariat termin\xE9",
        body: "Le partenariat de votre organisation dans l\u2019espace \xAB {space} \xBB de {organization} est termin\xE9 : votre acc\xE8s a \xE9t\xE9 retir\xE9.",
        line: "Partenariat termin\xE9 : espace \xAB {space} \xBB ({organization})."
      },
      access_revoked_space_closed: {
        subject: "L\u2019espace \xAB {space} \xBB a \xE9t\xE9 ferm\xE9",
        heading: "Espace ferm\xE9",
        body: "{organization} a ferm\xE9 l\u2019espace \xAB {space} \xBB : votre acc\xE8s a \xE9t\xE9 retir\xE9.",
        line: "Espace ferm\xE9 : \xAB {space} \xBB ({organization})."
      },
      data_export_ready: {
        subject: "L\u2019export des donn\xE9es de {organization} est pr\xEAt",
        heading: "Votre export est pr\xEAt",
        body: "L\u2019export des donn\xE9es de {organization} est pr\xEAt. T\xE9l\xE9chargez-le depuis la page Donn\xE9es et suppression : il reste disponible 7 jours.",
        line: "L\u2019export des donn\xE9es de {organization} est pr\xEAt."
      },
      data_export_failed: {
        subject: "L\u2019export des donn\xE9es de {organization} a \xE9chou\xE9",
        heading: "L\u2019export a \xE9chou\xE9",
        body: "L\u2019export des donn\xE9es de {organization} n\u2019a pas pu \xEAtre pr\xE9par\xE9. Demandez-en un nouveau depuis la page Donn\xE9es et suppression.",
        line: "L\u2019export des donn\xE9es de {organization} a \xE9chou\xE9."
      },
      organization_deletion_scheduled: {
        subject: "La suppression de {organization} est programm\xE9e le {date}",
        heading: "Suppression programm\xE9e",
        body: "Les donn\xE9es de {organization} seront d\xE9finitivement supprim\xE9es le {date}. D\u2019ici l\xE0, exportez les documents et donn\xE9es dont vous avez besoin. Le propri\xE9taire peut annuler la suppression jusqu\u2019\xE0 cette date.",
        line: "La suppression de {organization} est programm\xE9e le {date}."
      },
      organization_deletion_cancelled: {
        subject: "La suppression de {organization} est annul\xE9e",
        heading: "Suppression annul\xE9e",
        body: "La suppression programm\xE9e des donn\xE9es de {organization} a \xE9t\xE9 annul\xE9e. Rien n\u2019a \xE9t\xE9 supprim\xE9.",
        line: "La suppression de {organization} est annul\xE9e."
      },
      meeting_started: {
        subject: "{by} a d\xE9marr\xE9 la r\xE9union \xAB\xA0{meeting}\xA0\xBB",
        heading: "R\xE9union en cours",
        body: "{by} a d\xE9marr\xE9 la r\xE9union \xAB\xA0{meeting}\xA0\xBB chez {organization}. Rejoignez-la depuis BatiFlow.",
        line: "{by} a d\xE9marr\xE9 la r\xE9union \xAB\xA0{meeting}\xA0\xBB."
      },
      meeting_invited: {
        subject: "{by} vous invite \xE0 la r\xE9union \xAB\xA0{meeting}\xA0\xBB",
        heading: "Invitation \xE0 une r\xE9union",
        body: "{by} vous invite \xE0 la r\xE9union \xAB\xA0{meeting}\xA0\xBB chez {organization}.",
        line: "{by} vous invite \xE0 la r\xE9union \xAB\xA0{meeting}\xA0\xBB."
      },
      call_missed: {
        subject: "Appel manqu\xE9 de {caller}",
        heading: "Appel manqu\xE9",
        body: "{caller} vous a appel\xE9 dans BatiFlow ({organization}).",
        line: "Appel manqu\xE9 de {caller}."
      },
      minutes_published: {
        subject: "{number} publi\xE9\xA0: \xAB\xA0{meeting}\xA0\xBB",
        heading: "Proc\xE8s-verbal publi\xE9",
        body: "{by} a publi\xE9 le proc\xE8s-verbal {number} de la r\xE9union \xAB\xA0{meeting}\xA0\xBB chez {organization}.",
        line: "{number} publi\xE9 pour \xAB\xA0{meeting}\xA0\xBB."
      },
      timesheet_reminder: {
        subject: "Pensez \xE0 soumettre vos temps de la semaine",
        heading: "Feuille de temps \xE0 soumettre",
        body: "Votre semaine du {week} n\u2019est pas encore soumise chez {organization}. Saisissez vos temps puis soumettez-la avant lundi.",
        line: "Votre semaine du {week} n\u2019est pas encore soumise."
      },
      phase_deadline: {
        subject: "D\xE9lai contractuel : {phase} \u2014 {project}",
        heading: "D\xE9lai contractuel de la phase",
        body: "La phase {phase} du projet {project} arrive \xE0 son d\xE9lai contractuel du {deadline} (chez {organization}). Retards \xE9ventuels : {daysLate} jour(s).",
        line: "Phase {phase} de {project} : d\xE9lai contractuel du {deadline}."
      },
      vault_expiring: {
        subject: "Document \xE0 renouveler : {subject}",
        heading: "Document du coffre-fort bient\xF4t expir\xE9",
        body: "Le document \xAB {subject} \xBB du coffre-fort de {organization} expire le {date}. Pr\xE9parez son renouvellement pour ne pas bloquer vos r\xE9ponses aux appels d\u2019offres.",
        line: "\xAB {subject} \xBB expire le {date}."
      },
      time_budget: {
        subject: "Budget de temps \xE0 {percent} % : {project}",
        heading: "Budget de temps presque consomm\xE9",
        body: "La phase {phase} du projet {project} a consomm\xE9 {percent} % de son budget de temps. V\xE9rifiez la rentabilit\xE9 du projet et ajustez le planning ou le budget.",
        line: "Phase {phase} : {percent} % du budget de temps."
      },
      signature_requested: {
        subject: "Signature demand\xE9e : {title}",
        heading: "Un document attend votre signature",
        body: "{requester} vous demande de signer \xAB {title} \xBB ({document}). Ouvrez la demande dans BatiFlow : un code vous sera envoy\xE9 par e-mail pour confirmer votre signature.",
        line: "{requester} : \xAB {title} \xBB."
      },
      signature_update: {
        subject: "Demande de signature : {title}",
        heading: "Votre demande de signature a chang\xE9",
        body: "La demande de signature \xAB {title} \xBB a chang\xE9. Ouvrez-la dans BatiFlow pour voir o\xF9 elle en est.",
        line: "\xAB {title} \xBB a chang\xE9."
      },
      signature_update_completed: {
        subject: "Document sign\xE9 : {title}",
        heading: "Tous les signataires ont sign\xE9",
        body: "\xAB {title} \xBB a \xE9t\xE9 sign\xE9 par tous les signataires. Le certificat de preuve est disponible dans la demande.",
        line: "\xAB {title} \xBB est sign\xE9."
      },
      signature_update_declined: {
        subject: "Signature refus\xE9e : {title}",
        heading: "Un signataire a refus\xE9 de signer",
        body: "{signer} a refus\xE9 de signer \xAB {title} \xBB. Ouvrez la demande pour lire son motif.",
        line: "{signer} a refus\xE9 \xAB {title} \xBB."
      }
    },
    generic: {
      subject: "Nouvelle notification BatiFlow",
      heading: "Nouvelle notification",
      body: "Vous avez une nouvelle notification de {organization}.",
      line: "Nouvelle notification."
    },
    phases: {
      esq: "Esquisse (ESQ)",
      aps: "Avant-projet sommaire (APS)",
      apd: "Avant-projet d\xE9taill\xE9 (APD)",
      pro: "Projet (PRO)",
      dce: "Dossier de consultation des entreprises (DCE)",
      act: "Assistance aux contrats de travaux (ACT)",
      det: "Direction de l'ex\xE9cution des travaux (DET)",
      aor_provisional: "Assistance aux op\xE9rations de r\xE9ception provisoire (AOR provisoire)",
      aor_final: "Assistance aux op\xE9rations de r\xE9ception d\xE9finitive (AOR d\xE9finitive)"
    }
  },
  digest: {
    subject: "Votre r\xE9sum\xE9 BatiFlow",
    preview: "Ce qui s\u2019est pass\xE9 sur vos projets",
    heading: "Votre r\xE9sum\xE9 de notifications",
    intro: "Voici ce qui s\u2019est pass\xE9 depuis votre dernier r\xE9sum\xE9.",
    open: "Ouvrir",
    action: "Ouvrir BatiFlow"
  },
  roles: {
    owner: "propri\xE9taire",
    admin: "administrateur",
    project_manager: "chef de projet",
    engineer: "ing\xE9nieur ou architecte",
    draftsman: "dessinateur",
    accountant: "comptable"
  },
  spaceInvitation: {
    subject: "{inviter} vous invite dans l\u2019espace \xAB {space} \xBB de {organization}",
    preview: "Rejoignez l\u2019espace \xAB {space} \xBB sur BatiFlow",
    heading: "Invitation \xE0 l\u2019espace \xAB {space} \xBB",
    body: "{inviter} ({organization}) vous invite \xE0 collaborer dans l\u2019espace partag\xE9 \xAB {space} \xBB sur BatiFlow.",
    bodyGuest: "{inviter} ({organization}) vous invite comme invit\xE9 dans l\u2019espace partag\xE9 \xAB {space} \xBB sur BatiFlow. Vous y verrez seulement les dossiers et discussions qui vous sont ouverts.",
    action: "Voir l\u2019invitation",
    account: "Connectez-vous avec cette adresse e-mail. Si vous n\u2019avez pas encore de compte, BatiFlow vous envoie un second message pour choisir votre mot de passe.",
    expiry: "Cette invitation est valable jusqu\u2019au {expiresAt}.",
    fallback: "Si le bouton ne fonctionne pas, copiez ce lien dans votre navigateur :"
  },
  quoteSent: {
    subject: "Devis {number} de {organization} : {title}",
    preview: "Consultez et acceptez le devis {number} en ligne",
    heading: "Devis {number}",
    body: "{sender} ({organization}) vous adresse le devis {number} \xAB {title} \xBB. Vous pouvez le consulter, le t\xE9l\xE9charger en PDF et l\u2019accepter en ligne.",
    action: "Voir le devis",
    account: "Aucun compte n\u2019est n\xE9cessaire : ce lien personnel suffit. Ne le transmettez pas.",
    expiry: "Ce lien est valable jusqu\u2019au {expiresAt}.",
    fallback: "Si le bouton ne fonctionne pas, copiez ce lien dans votre navigateur :"
  },
  transmittalSent: {
    subject: "Bordereau d\u2019envoi {number} de {organization} : {title}",
    preview: "Consultez les documents du bordereau {number} et accusez r\xE9ception",
    heading: "Bordereau d\u2019envoi {number}",
    body: "{sender} ({organization}) vous transmet {count, plural, one {# document} other {# documents}} par le bordereau {number} \xAB {title} \xBB. Vous pouvez les consulter, les t\xE9l\xE9charger et accuser r\xE9ception en ligne.",
    action: "Ouvrir le bordereau",
    account: "Aucun compte n\u2019est n\xE9cessaire : ce lien personnel suffit. Ne le transmettez pas.",
    expiry: "Ce lien est valable jusqu\u2019au {expiresAt}.",
    fallback: "Si le bouton ne fonctionne pas, copiez ce lien dans votre navigateur :"
  },
  invoiceReminder: {
    subject: "Rappel : facture {number} de {organization} \xE9chue le {dueDate}",
    preview: "Facture {number} : {outstanding} restent \xE0 r\xE9gler",
    heading: "Facture {number} \xE0 r\xE9gler",
    body: "Sauf erreur de notre part, la facture {number} de {organization}, \xE9chue le {dueDate}, n\u2019est pas encore enti\xE8rement r\xE9gl\xE9e ({days} jours de retard).",
    amount: "Reste \xE0 payer : {outstanding}",
    closing: "Si le paiement est d\xE9j\xE0 parti, merci de ne pas tenir compte de ce message. Pour toute question, contactez directement {organization}."
  },
  meetingInvitation: {
    subject: "{inviter} vous invite \xE0 la r\xE9union \xAB\xA0{meeting}\xA0\xBB",
    preview: "Rejoignez la r\xE9union \xAB\xA0{meeting}\xA0\xBB sur BatiFlow",
    heading: "Invitation \xE0 la r\xE9union \xAB\xA0{meeting}\xA0\xBB",
    body: "{inviter} ({organization}) vous invite \xE0 participer \xE0 la r\xE9union \xAB\xA0{meeting}\xA0\xBB sur BatiFlow.",
    action: "Rejoindre la r\xE9union",
    account: "Connectez-vous avec cette adresse e-mail. Si vous n\u2019avez pas encore de compte, cr\xE9ez-le avec cette m\xEAme adresse.",
    expiry: "Ce lien est valable jusqu\u2019au {expiresAt} et ne sert qu\u2019une fois.",
    fallback: "Si le bouton ne fonctionne pas, copiez ce lien dans votre navigateur :"
  },
  directoryContact: {
    subject: "Nouveau message via l\u2019annuaire BatiFlow\xA0: {subject}",
    preview: "{sender} vous \xE9crit via l\u2019annuaire BatiFlow",
    heading: "Nouveau message via l\u2019annuaire",
    body: "{sender} ({senderOrganization}) a \xE9crit \xE0 {organization} via l\u2019annuaire BatiFlow.",
    bodyNoOrganization: "{sender} a \xE9crit \xE0 {organization} via l\u2019annuaire BatiFlow.",
    subjectLabel: "Objet",
    messageLabel: "Message",
    reply: "R\xE9pondez simplement \xE0 cet e-mail\xA0: votre r\xE9ponse sera envoy\xE9e \xE0 {sender}.",
    notice: "Vous recevez ce message car {organization} figure dans l\u2019annuaire des partenaires et que vous en \xEAtes propri\xE9taire ou administrateur. Vous pouvez en sortir \xE0 tout moment dans les param\xE8tres de l\u2019organisation."
  },
  signatureCode: {
    signature: {
      subject: "Votre code de signature",
      preview: "Code pour signer \xAB {subject} \xBB",
      heading: "Votre code de signature",
      body: "Saisissez ce code dans BatiFlow pour signer \xAB {subject} \xBB."
    },
    batch: {
      subject: "Votre code de signature DigiGO",
      preview: "Code pour signer {subject}",
      heading: "Confirmez la signature de vos factures",
      body: "Saisissez ce code dans BatiFlow pour signer {subject} avec votre certificat DigiGO.",
      count: "{count} facture(s)"
    },
    validity: "Ce code est valable {minutes} minutes et ne peut servir qu\u2019une fois.",
    notice: "Ne communiquez ce code \xE0 personne : BatiFlow ne vous le demandera jamais par t\xE9l\xE9phone. Si vous n\u2019\xEAtes pas \xE0 l\u2019origine de cette demande, ignorez cet e-mail."
  }
};

// locales/ar/clients.json
var clients_default = {
  title: "\u0627\u0644\u062D\u0631\u0641\u0627\u0621",
  none: "\u2014",
  more: {
    title: "\u0627\u0644\u062D\u0631\u0641\u0627\u0621",
    description: "\u0623\u0635\u062D\u0627\u0628 \u0627\u0644\u0645\u0634\u0627\u0631\u064A\u0639: \u0627\u0644\u0645\u0644\u0641 \u0627\u0644\u062C\u0628\u0627\u0626\u064A \u0648\u062C\u0647\u0627\u062A \u0627\u0644\u0627\u062A\u0635\u0627\u0644 \u0648\u0627\u0644\u0639\u0646\u0627\u0648\u064A\u0646."
  },
  status: {
    archived: "\u0645\u0624\u0631\u0634\u0641"
  },
  kinds: {
    public_entity: "\u0647\u064A\u0643\u0644 \u0639\u0645\u0648\u0645\u064A",
    private_company: "\u0634\u0631\u0643\u0629 \u062E\u0627\u0635\u0629",
    individual: "\u0634\u062E\u0635 \u0637\u0628\u064A\u0639\u064A",
    foreign: "\u062D\u0631\u064A\u0641 \u0623\u062C\u0646\u0628\u064A"
  },
  kindHints: {
    public_entity: "\u0627\u0644\u062F\u0648\u0644\u0629 \u0623\u0648 \u062C\u0645\u0627\u0639\u0629 \u0645\u062D\u0644\u064A\u0629 \u0623\u0648 \u0645\u0624\u0633\u0633\u0629 \u0639\u0645\u0648\u0645\u064A\u0629. \u0627\u0644\u0645\u0639\u0631\u0651\u0641 \u0627\u0644\u062C\u0628\u0627\u0626\u064A \u0625\u062C\u0628\u0627\u0631\u064A.",
    private_company: "\u0634\u0631\u0643\u0629 \u0623\u0648 \u062C\u0645\u0639\u064A\u0629 \u062E\u0627\u0636\u0639\u0629 \u0644\u0644\u0642\u0627\u0646\u0648\u0646 \u0627\u0644\u062E\u0627\u0635. \u0627\u0644\u0645\u0639\u0631\u0651\u0641 \u0627\u0644\u062C\u0628\u0627\u0626\u064A \u0625\u062C\u0628\u0627\u0631\u064A.",
    individual: "\u0634\u062E\u0635 \u0637\u0628\u064A\u0639\u064A. \u0627\u0644\u0645\u0639\u0631\u0651\u0641 \u0627\u0644\u062C\u0628\u0627\u0626\u064A \u0627\u062E\u062A\u064A\u0627\u0631\u064A.",
    foreign: "\u062D\u0631\u064A\u0641 \u0645\u0642\u064A\u0645 \u062E\u0627\u0631\u062C \u062A\u0648\u0646\u0633. \u0627\u0644\u0645\u0639\u0631\u0651\u0641 \u0627\u0644\u062C\u0628\u0627\u0626\u064A \u0646\u0635 \u062D\u0631 \u0648\u064A\u064F\u0642\u062A\u0631\u062D \u0646\u0638\u0627\u0645 \xAB\u0627\u0644\u062A\u0635\u062F\u064A\u0631\xBB \u0627\u0641\u062A\u0631\u0627\u0636\u064A\u064B\u0627."
  },
  vatRegimes: {
    subject: "\u062E\u0627\u0636\u0639 \u0644\u0644\u0623\u062F\u0627\u0621 \u0639\u0644\u0649 \u0627\u0644\u0642\u064A\u0645\u0629 \u0627\u0644\u0645\u0636\u0627\u0641\u0629",
    exempt: "\u0645\u0639\u0641\u0649 \u0645\u0646 \u0627\u0644\u0623\u062F\u0627\u0621 \u0639\u0644\u0649 \u0627\u0644\u0642\u064A\u0645\u0629 \u0627\u0644\u0645\u0636\u0627\u0641\u0629",
    suspended: "\u0623\u062F\u0627\u0621 \u0639\u0644\u0649 \u0627\u0644\u0642\u064A\u0645\u0629 \u0627\u0644\u0645\u0636\u0627\u0641\u0629 \u0645\u0639\u0644\u0651\u0642",
    export: "\u062A\u0635\u062F\u064A\u0631 (\u062E\u0627\u0631\u062C \u062A\u0648\u0646\u0633)"
  },
  vatRegimeHints: {
    subject: "\u0627\u0644\u062D\u0627\u0644\u0629 \u0627\u0644\u0639\u0627\u0645\u0629: \u064A\u064F\u062D\u062A\u0633\u0628 \u0627\u0644\u0623\u062F\u0627\u0621 \u0639\u0644\u0649 \u0627\u0644\u0642\u064A\u0645\u0629 \u0627\u0644\u0645\u0636\u0627\u0641\u0629 \u0641\u064A \u0641\u0627\u062A\u0648\u0631\u0629 \u0647\u0630\u0627 \u0627\u0644\u062D\u0631\u064A\u0641.",
    exempt: "\u064A\u0642\u062F\u0651\u0645 \u0627\u0644\u062D\u0631\u064A\u0641 \u0634\u0647\u0627\u062F\u0629 \u0625\u0639\u0641\u0627\u0621: \u0623\u062F\u062E\u0644 \u0645\u0631\u062C\u0639\u0647\u0627 \u0648\u062A\u0627\u0631\u064A\u062E \u0627\u0646\u062A\u0647\u0627\u0621 \u0635\u0644\u0627\u062D\u064A\u062A\u0647\u0627.",
    suspended: "\u0627\u0642\u062A\u0646\u0627\u0621\u0627\u062A \u0628\u0646\u0638\u0627\u0645 \u062A\u0639\u0644\u064A\u0642 \u0627\u0644\u0623\u062F\u0627\u0621: \u0623\u062F\u062E\u0644 \u0645\u0631\u062C\u0639 \u0634\u0647\u0627\u062F\u0629 \u0627\u0644\u062A\u0639\u0644\u064A\u0642\u060C \u0648\u0633\u062A\u064F\u0637\u0628\u0639 \u0639\u0644\u0649 \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629.",
    export: "\u062D\u0631\u064A\u0641 \u062E\u0627\u0631\u062C \u062A\u0648\u0646\u0633: \u0639\u0645\u0644\u064A\u0629 \u062A\u0635\u062F\u064A\u0631. \u064A\u0645\u0643\u0646 \u0625\u0636\u0627\u0641\u0629 \u0645\u0631\u062C\u0639 \u0639\u0646\u062F \u0627\u0644\u062D\u0627\u062C\u0629."
  },
  list: {
    tableCaption: "\u062D\u0631\u0641\u0627\u0621 \u0627\u0644\u0645\u0643\u062A\u0628",
    columns: {
      name: "\u0627\u0644\u0627\u0633\u0645",
      kind: "\u0627\u0644\u0646\u0648\u0639",
      taxId: "\u0627\u0644\u0645\u0639\u0631\u0651\u0641 \u0627\u0644\u062C\u0628\u0627\u0626\u064A",
      city: "\u0627\u0644\u0645\u062F\u064A\u0646\u0629",
      contact: "\u0627\u0644\u0628\u0631\u064A\u062F \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A \u0648\u0627\u0644\u0647\u0627\u062A\u0641"
    },
    filters: {
      label: "\u062A\u0635\u0641\u064A\u0629 \u0627\u0644\u062D\u0631\u0641\u0627\u0621",
      search: "\u0627\u0644\u0628\u062D\u062B \u0639\u0646 \u062D\u0631\u064A\u0641",
      searchPlaceholder: "\u0627\u0633\u0645 \u0627\u0644\u062D\u0631\u064A\u0641",
      kind: "\u0627\u0644\u062A\u0635\u0641\u064A\u0629 \u062D\u0633\u0628 \u0627\u0644\u0646\u0648\u0639",
      allKinds: "\u0643\u0644 \u0627\u0644\u0623\u0646\u0648\u0627\u0639",
      archived: "\u0639\u0631\u0636 \u0627\u0644\u062D\u0631\u0641\u0627\u0621 \u0627\u0644\u0645\u0624\u0631\u0634\u0641\u064A\u0646 \u0641\u0642\u0637",
      clear: "\u0645\u0633\u062D \u0639\u0648\u0627\u0645\u0644 \u0627\u0644\u062A\u0635\u0641\u064A\u0629"
    },
    new: "\u062D\u0631\u064A\u0641 \u062C\u062F\u064A\u062F",
    loadMore: "\u0639\u0631\u0636 \u0627\u0644\u0645\u0632\u064A\u062F \u0645\u0646 \u0627\u0644\u062D\u0631\u0641\u0627\u0621",
    loadingMore: "\u062C\u0627\u0631\u064D \u0627\u0644\u062A\u062D\u0645\u064A\u0644\u2026",
    loadFailedTitle: "\u062A\u0639\u0630\u0651\u0631 \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u062D\u0631\u0641\u0627\u0621",
    loadFailedBody: "\u062A\u062D\u0642\u0642 \u0645\u0646 \u0627\u062A\u0635\u0627\u0644\u0643 \u062B\u0645 \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629.",
    empty: {
      title: "\u0644\u0627 \u064A\u0648\u062C\u062F \u062D\u0631\u0641\u0627\u0621 \u0628\u0639\u062F",
      description: "\u0627\u0644\u062D\u0631\u064A\u0641\u060C \u0623\u0648 \u0635\u0627\u062D\u0628 \u0627\u0644\u0645\u0634\u0631\u0648\u0639\u060C \u0647\u0648 \u0627\u0644\u0634\u062E\u0635 \u0623\u0648 \u0627\u0644\u0647\u064A\u0643\u0644 \u0627\u0644\u0630\u064A \u062A\u0646\u062C\u0632 \u0644\u0647 \u0645\u0634\u0631\u0648\u0639\u064B\u0627. \u0623\u0636\u0641\u0647 \u0645\u0631\u0629 \u0648\u0627\u062D\u062F\u0629 \u0647\u0646\u0627: \u064A\u064F\u0633\u062A\u0639\u0645\u0644 \u0645\u0644\u0641\u0647 \u0627\u0644\u062C\u0628\u0627\u0626\u064A \u0641\u064A \u0639\u0631\u0648\u0636 \u0627\u0644\u0623\u0633\u0639\u0627\u0631 \u0648\u0627\u0644\u0641\u0648\u0627\u062A\u064A\u0631.",
      descriptionReadOnly: "\u0627\u0644\u062D\u0631\u064A\u0641\u060C \u0623\u0648 \u0635\u0627\u062D\u0628 \u0627\u0644\u0645\u0634\u0631\u0648\u0639\u060C \u0647\u0648 \u0627\u0644\u0634\u062E\u0635 \u0623\u0648 \u0627\u0644\u0647\u064A\u0643\u0644 \u0627\u0644\u0630\u064A \u062A\u0646\u062C\u0632 \u0644\u0647 \u0645\u0634\u0631\u0648\u0639\u064B\u0627. \u0644\u0645 \u062A\u062A\u0645 \u0625\u0636\u0627\u0641\u0629 \u0623\u064A \u062D\u0631\u064A\u0641 \u0628\u0639\u062F\u061B \u0627\u0637\u0644\u0628 \u0645\u0646 \u0645\u0633\u0624\u0648\u0644 \u0623\u0648 \u0645\u062F\u064A\u0631 \u0645\u0634\u0631\u0648\u0639 \u0625\u0646\u0634\u0627\u0621\u0647.",
      filteredTitle: "\u0644\u0627 \u064A\u0648\u062C\u062F \u062D\u0631\u064A\u0641 \u0645\u0637\u0627\u0628\u0642",
      filteredDescription: "\u062C\u0631\u0651\u0628 \u0627\u0633\u0645\u064B\u0627 \u0622\u062E\u0631 \u0623\u0648 \u0646\u0648\u0639\u064B\u0627 \u0622\u062E\u0631 \u0645\u0646 \u0627\u0644\u062D\u0631\u0641\u0627\u0621.",
      archivedTitle: "\u0644\u0627 \u064A\u0648\u062C\u062F \u062D\u0631\u0641\u0627\u0621 \u0645\u0624\u0631\u0634\u0641\u0648\u0646",
      archivedDescription: "\u064A\u0638\u0647\u0631 \u0647\u0646\u0627 \u0627\u0644\u062D\u0631\u0641\u0627\u0621 \u0627\u0644\u0630\u064A\u0646 \u062A\u0642\u0648\u0645 \u0628\u0623\u0631\u0634\u0641\u062A\u0647\u0645."
    }
  },
  create: {
    title: "\u062D\u0631\u064A\u0641 \u062C\u062F\u064A\u062F",
    intro: "\u0627\u062E\u062A\u0631 \u0623\u0648\u0644\u064B\u0627 \u0646\u0648\u0639 \u0627\u0644\u062D\u0631\u064A\u0641: \u064A\u062A\u0643\u064A\u0651\u0641 \u0627\u0644\u0646\u0645\u0648\u0630\u062C \u0648\u064A\u0636\u0628\u0637 \u0645\u0633\u0628\u0642\u064B\u0627 \u0627\u0644\u0623\u062F\u0627\u0621 \u0639\u0644\u0649 \u0627\u0644\u0642\u064A\u0645\u0629 \u0627\u0644\u0645\u0636\u0627\u0641\u0629 \u0648\u0627\u0644\u0627\u0642\u062A\u0637\u0627\u0639\u0627\u062A.",
    submit: "\u0625\u0646\u0634\u0627\u0621 \u0627\u0644\u062D\u0631\u064A\u0641",
    saving: "\u062C\u0627\u0631\u064D \u0627\u0644\u0625\u0646\u0634\u0627\u0621\u2026",
    done: "\u062A\u0645 \u0625\u0646\u0634\u0627\u0621 \u0627\u0644\u062D\u0631\u064A\u0641 \xAB{name}\xBB."
  },
  form: {
    groups: {
      identity: "\u0627\u0644\u0647\u0648\u064A\u0629",
      tax: "\u0627\u0644\u0623\u062F\u0627\u0621 \u0639\u0644\u0649 \u0627\u0644\u0642\u064A\u0645\u0629 \u0627\u0644\u0645\u0636\u0627\u0641\u0629 \u0648\u0627\u0644\u0627\u0642\u062A\u0637\u0627\u0639 \u0645\u0646 \u0627\u0644\u0645\u0635\u062F\u0631",
      address: "\u0627\u0644\u0639\u0646\u0648\u0627\u0646",
      contact: "\u0628\u064A\u0627\u0646\u0627\u062A \u0627\u0644\u0627\u062A\u0635\u0627\u0644"
    },
    fields: {
      kind: {
        label: "\u0646\u0648\u0639 \u0627\u0644\u062D\u0631\u064A\u0641"
      },
      name: {
        label: "\u0627\u0644\u0627\u0633\u0645 \u0623\u0648 \u0627\u0644\u062A\u0633\u0645\u064A\u0629 \u0627\u0644\u0627\u062C\u062A\u0645\u0627\u0639\u064A\u0629"
      },
      taxId: {
        label: "\u0627\u0644\u0645\u0639\u0631\u0651\u0641 \u0627\u0644\u062C\u0628\u0627\u0626\u064A",
        hint: "\u0627\u0644\u0635\u064A\u063A\u0629: \u20661234567 A / A / M / 000\u2069",
        hintShort: "\u0627\u062E\u062A\u064A\u0627\u0631\u064A. \u0627\u0644\u0635\u064A\u063A\u0629 \u0627\u0644\u0645\u062E\u062A\u0635\u0631\u0629 (7 \u0623\u0631\u0642\u0627\u0645 \u0648\u062D\u0631\u0641) \u0645\u0642\u0628\u0648\u0644\u0629."
      },
      taxIdForeign: {
        label: "\u0627\u0644\u0645\u0639\u0631\u0651\u0641 \u0627\u0644\u062C\u0628\u0627\u0626\u064A",
        hint: "\u0627\u062E\u062A\u064A\u0627\u0631\u064A. \u0646\u0635 \u062D\u0631 \u0644\u0627 \u064A\u062A\u062C\u0627\u0648\u0632 50 \u062D\u0631\u0641\u064B\u0627."
      },
      paymentTerms: {
        label: "\u0623\u062C\u0644 \u0627\u0644\u062F\u0641\u0639 (\u0628\u0627\u0644\u0623\u064A\u0627\u0645)",
        hint: "\u0639\u062F\u062F \u0627\u0644\u0623\u064A\u0627\u0645 \u0628\u0639\u062F \u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629. \u0627\u0644\u0642\u064A\u0645\u0629 \u0627\u0644\u0627\u0641\u062A\u0631\u0627\u0636\u064A\u0629 30."
      },
      vatRegime: {
        label: "\u0646\u0638\u0627\u0645 \u0627\u0644\u0623\u062F\u0627\u0621 \u0639\u0644\u0649 \u0627\u0644\u0642\u064A\u0645\u0629 \u0627\u0644\u0645\u0636\u0627\u0641\u0629"
      },
      exemptionRef: {
        label: {
          subject: "\u0627\u0644\u0645\u0631\u062C\u0639",
          exempt: "\u0645\u0631\u062C\u0639 \u0634\u0647\u0627\u062F\u0629 \u0627\u0644\u0625\u0639\u0641\u0627\u0621",
          suspended: "\u0645\u0631\u062C\u0639 \u0634\u0647\u0627\u062F\u0629 \u0627\u0644\u062A\u0639\u0644\u064A\u0642",
          export: "\u0627\u0644\u0645\u0631\u062C\u0639 (\u0627\u062E\u062A\u064A\u0627\u0631\u064A)"
        },
        hint: "\u0627\u0646\u0633\u062E\u0647 \u0643\u0645\u0627 \u064A\u0638\u0647\u0631 \u0641\u064A \u0627\u0644\u0648\u062B\u064A\u0642\u0629."
      },
      exemptionExpiresOn: {
        label: "\u0646\u0647\u0627\u064A\u0629 \u0627\u0644\u0635\u0644\u0627\u062D\u064A\u0629",
        hint: "\u0627\u0644\u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0630\u064A \u062A\u0646\u062A\u0647\u064A \u0639\u0646\u062F\u0647 \u0635\u0644\u0627\u062D\u064A\u0629 \u0627\u0644\u0634\u0647\u0627\u062F\u0629.",
        hintOptional: "\u0627\u062E\u062A\u064A\u0627\u0631\u064A. \u0627\u062A\u0631\u0643\u0647 \u0641\u0627\u0631\u063A\u064B\u0627 \u0625\u0646 \u0644\u0645 \u064A\u0643\u0646 \u0644\u0644\u0634\u0647\u0627\u062F\u0629 \u062A\u0627\u0631\u064A\u062E \u0627\u0646\u062A\u0647\u0627\u0621."
      },
      withholding: {
        label: "\u0627\u0644\u0627\u0642\u062A\u0637\u0627\u0639 \u0645\u0646 \u0627\u0644\u0645\u0635\u062F\u0631",
        hint: "\u0627\u0644\u0627\u0642\u062A\u0637\u0627\u0639 \u0645\u0646 \u0627\u0644\u0645\u0635\u062F\u0631 \u0647\u0648 \u062C\u0632\u0621 \u0645\u0646 \u0645\u0628\u0644\u063A \u0641\u0627\u062A\u0648\u0631\u062A\u0643 \u064A\u062D\u062A\u0641\u0638 \u0628\u0647 \u0627\u0644\u062D\u0631\u064A\u0641 \u0644\u064A\u062F\u0641\u0639\u0647 \u0645\u0628\u0627\u0634\u0631\u0629 \u0625\u0644\u0649 \u0627\u0644\u0625\u062F\u0627\u0631\u0629 \u0627\u0644\u062C\u0628\u0627\u0626\u064A\u0629. \u062A\u062A\u0633\u0644\u0651\u0645 \u0627\u0644\u0628\u0627\u0642\u064A \u0648\u064A\u0633\u0644\u0651\u0645\u0643 \u0627\u0644\u062D\u0631\u064A\u0641 \u0634\u0647\u0627\u062F\u0629 \u0627\u0642\u062A\u0637\u0627\u0639. \u064A\u0643\u0648\u0646 \u0645\u0641\u0639\u0651\u0644\u064B\u0627 \u0627\u0641\u062A\u0631\u0627\u0636\u064A\u064B\u0627 \u0644\u0644\u0647\u064A\u0627\u0643\u0644 \u0627\u0644\u0639\u0645\u0648\u0645\u064A\u0629 \u0648\u0627\u0644\u0634\u0631\u0643\u0627\u062A."
      },
      withholdingRate: {
        label: "\u0646\u0633\u0628\u0629 \u0627\u0642\u062A\u0637\u0627\u0639 \u062E\u0627\u0635\u0629 (%)",
        hint: "\u0627\u062A\u0631\u0643\u0647 \u0641\u0627\u0631\u063A\u064B\u0627 \u0644\u062A\u0637\u0628\u064A\u0642 \u0627\u0644\u0646\u0633\u0628\u0629 \u0627\u0644\u0642\u0627\u0646\u0648\u0646\u064A\u0629 \u0627\u0644\u062C\u0627\u0631\u064A \u0628\u0647\u0627 \u0627\u0644\u0639\u0645\u0644."
      },
      vatWithholding: {
        label: "\u0627\u0644\u0627\u0642\u062A\u0637\u0627\u0639 \u0645\u0646 \u0627\u0644\u0645\u0635\u062F\u0631 \u0639\u0644\u0649 \u0627\u0644\u0642\u064A\u0645\u0629 \u0627\u0644\u0645\u0636\u0627\u0641\u0629",
        hint: "\u0647\u0648 \u062C\u0632\u0621 \u0645\u0646 \u0627\u0644\u0623\u062F\u0627\u0621 \u0639\u0644\u0649 \u0627\u0644\u0642\u064A\u0645\u0629 \u0627\u0644\u0645\u0636\u0627\u0641\u0629 \u0627\u0644\u0645\u0636\u0645\u0651\u0646 \u0641\u064A \u0641\u0627\u062A\u0648\u0631\u062A\u0643 \u064A\u062D\u062A\u0641\u0638 \u0628\u0647 \u0627\u0644\u062D\u0631\u064A\u0641 \u0644\u064A\u062F\u0641\u0639\u0647 \u0625\u0644\u0649 \u0627\u0644\u062E\u0632\u064A\u0646\u0629\u060C \u0641\u062A\u062A\u0633\u0644\u0651\u0645 \u0627\u0644\u0645\u062A\u0628\u0642\u064A \u0641\u0642\u0637. \u064A\u0643\u0648\u0646 \u0645\u0641\u0639\u0651\u0644\u064B\u0627 \u0627\u0641\u062A\u0631\u0627\u0636\u064A\u064B\u0627 \u0644\u0644\u0647\u064A\u0627\u0643\u0644 \u0627\u0644\u0639\u0645\u0648\u0645\u064A\u0629. \u0627\u0644\u0646\u0633\u0628\u0629 \u0647\u064A \u0627\u0644\u0645\u062D\u062F\u062F\u0629 \u0628\u0627\u0644\u0642\u0627\u0646\u0648\u0646 \u0648\u0644\u0627 \u062A\u062D\u062A\u0627\u062C \u0625\u0644\u0649 \u0625\u062F\u062E\u0627\u0644 \u0623\u064A \u0634\u064A\u0621."
      },
      line1: {
        label: "\u0627\u0644\u0639\u0646\u0648\u0627\u0646"
      },
      line2: {
        label: "\u062A\u062A\u0645\u0629 \u0627\u0644\u0639\u0646\u0648\u0627\u0646"
      },
      city: {
        label: "\u0627\u0644\u0645\u062F\u064A\u0646\u0629"
      },
      postalCode: {
        label: "\u0627\u0644\u0631\u0645\u0632 \u0627\u0644\u0628\u0631\u064A\u062F\u064A"
      },
      country: {
        label: "\u0627\u0644\u0628\u0644\u062F (\u0631\u0645\u0632 \u0645\u0646 \u062D\u0631\u0641\u064A\u0646)",
        hint: "\u0645\u062B\u0644\u064B\u0627 FR \u0644\u0641\u0631\u0646\u0633\u0627 \u0648IT \u0644\u0625\u064A\u0637\u0627\u0644\u064A\u0627."
      },
      email: {
        label: "\u0627\u0644\u0628\u0631\u064A\u062F \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A"
      },
      phone: {
        label: "\u0627\u0644\u0647\u0627\u062A\u0641"
      }
    },
    errors: {
      required: "\u0647\u0630\u0627 \u0627\u0644\u062D\u0642\u0644 \u0625\u062C\u0628\u0627\u0631\u064A.",
      taxIdRequired: "\u0627\u0644\u0645\u0639\u0631\u0651\u0641 \u0627\u0644\u062C\u0628\u0627\u0626\u064A \u0625\u062C\u0628\u0627\u0631\u064A \u0644\u0647\u0630\u0627 \u0627\u0644\u0646\u0648\u0639 \u0645\u0646 \u0627\u0644\u062D\u0631\u0641\u0627\u0621.",
      taxIdTooLong: "\u0627\u0644\u0645\u0639\u0631\u0651\u0641 \u0627\u0644\u062C\u0628\u0627\u0626\u064A \u0645\u062D\u062F\u0648\u062F \u0628\u0640 50 \u062D\u0631\u0641\u064B\u0627.",
      exemptionRefRequired: "\u0623\u062F\u062E\u0644 \u0645\u0631\u062C\u0639 \u0634\u0647\u0627\u062F\u0629 \u0627\u0644\u0625\u0639\u0641\u0627\u0621.",
      suspensionRefRequired: "\u0623\u062F\u062E\u0644 \u0645\u0631\u062C\u0639 \u0634\u0647\u0627\u062F\u0629 \u0627\u0644\u062A\u0639\u0644\u064A\u0642.",
      exemptionExpiryRequired: "\u0623\u062F\u062E\u0644 \u062A\u0627\u0631\u064A\u062E \u0646\u0647\u0627\u064A\u0629 \u0635\u0644\u0627\u062D\u064A\u0629 \u0627\u0644\u0625\u0639\u0641\u0627\u0621.",
      rateInvalid: "\u0623\u062F\u062E\u0644 \u0646\u0633\u0628\u0629 \u0645\u0626\u0648\u064A\u0629 \u0628\u064A\u0646 0 \u0648100 (\u0645\u062B\u0644\u064B\u0627 1,5) \u0623\u0648 \u0627\u062A\u0631\u0643\u0647 \u0641\u0627\u0631\u063A\u064B\u0627.",
      paymentTermsInvalid: "\u0623\u062F\u062E\u0644 \u0639\u062F\u062F \u0623\u064A\u0627\u0645 \u0628\u064A\u0646 0 \u0648365.",
      postalCodeInvalid: "\u064A\u062A\u0643\u0648\u0646 \u0627\u0644\u0631\u0645\u0632 \u0627\u0644\u0628\u0631\u064A\u062F\u064A \u0645\u0646 3 \u0625\u0644\u0649 10 \u062E\u0627\u0646\u0627\u062A (\u0623\u0631\u0642\u0627\u0645 \u0623\u0648 \u062D\u0631\u0648\u0641).",
      countryInvalid: "\u0623\u062F\u062E\u0644 \u0631\u0645\u0632 \u0627\u0644\u0628\u0644\u062F \u0645\u0646 \u062D\u0631\u0641\u064A\u0646\u060C \u0645\u062B\u0644\u064B\u0627 FR.",
      emailInvalid: "\u0639\u0646\u0648\u0627\u0646 \u0627\u0644\u0628\u0631\u064A\u062F \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A \u063A\u064A\u0631 \u0635\u0627\u0644\u062D.",
      phoneInvalid: "\u0623\u062F\u062E\u0644 \u0631\u0642\u0645\u064B\u0627 \u0635\u0627\u0644\u062D\u064B\u0627\u060C \u0645\u062B\u0644\u064B\u0627 \u2066+216 71 000 000\u2069.",
      invalid: "\u0647\u0630\u0647 \u0627\u0644\u0642\u064A\u0645\u0629 \u063A\u064A\u0631 \u0635\u0627\u0644\u062D\u0629."
    },
    serverErrors: {
      EXEMPTION_REF_REQUIRED: "\u0627\u0644\u0645\u0631\u062C\u0639 \u0625\u062C\u0628\u0627\u0631\u064A \u0644\u0646\u0638\u0627\u0645 \u0627\u0644\u0623\u062F\u0627\u0621 \u0647\u0630\u0627.",
      EXEMPTION_EXPIRY_REQUIRED: "\u062A\u0627\u0631\u064A\u062E \u0646\u0647\u0627\u064A\u0629 \u0627\u0644\u0635\u0644\u0627\u062D\u064A\u0629 \u0625\u062C\u0628\u0627\u0631\u064A.",
      EXEMPTION_NOT_APPLICABLE: "\u0647\u0630\u0627 \u0627\u0644\u062D\u0642\u0644 \u0644\u0627 \u064A\u0646\u0637\u0628\u0642 \u0639\u0644\u0649 \u0646\u0638\u0627\u0645 \u0627\u0644\u0623\u062F\u0627\u0621 \u0627\u0644\u0645\u062E\u062A\u0627\u0631.",
      WITHHOLDING_RATE_NOT_APPLICABLE: "\u0627\u0644\u0646\u0633\u0628\u0629 \u0627\u0644\u062E\u0627\u0635\u0629 \u062A\u0642\u062A\u0636\u064A \u0623\u0646 \u064A\u0646\u0637\u0628\u0642 \u0627\u0644\u0627\u0642\u062A\u0637\u0627\u0639 \u0645\u0646 \u0627\u0644\u0645\u0635\u062F\u0631."
    }
  },
  detail: {
    client: "\u0627\u0644\u062D\u0631\u064A\u0641",
    tabs: {
      profile: "\u0627\u0644\u0645\u0644\u0641",
      contacts: "\u062C\u0647\u0627\u062A \u0627\u0644\u0627\u062A\u0635\u0627\u0644",
      projects: "\u0627\u0644\u0645\u0634\u0627\u0631\u064A\u0639",
      invoices: "\u0627\u0644\u0641\u0648\u0627\u062A\u064A\u0631"
    },
    notFoundTitle: "\u0627\u0644\u062D\u0631\u064A\u0641 \u063A\u064A\u0631 \u0645\u0648\u062C\u0648\u062F",
    notFoundBody: "\u0647\u0630\u0627 \u0627\u0644\u062D\u0631\u064A\u0641 \u063A\u064A\u0631 \u0645\u0648\u062C\u0648\u062F \u0623\u0648 \u0644\u064A\u0633\u062A \u0644\u0643 \u0635\u0644\u0627\u062D\u064A\u0629 \u0627\u0644\u0627\u0637\u0644\u0627\u0639 \u0639\u0644\u064A\u0647.",
    backToList: "\u0627\u0644\u0639\u0648\u062F\u0629 \u0625\u0644\u0649 \u0627\u0644\u062D\u0631\u0641\u0627\u0621",
    loadFailedTitle: "\u062A\u0639\u0630\u0651\u0631 \u062A\u062D\u0645\u064A\u0644 \u0647\u0630\u0627 \u0627\u0644\u062D\u0631\u064A\u0641",
    loadFailedBody: "\u062A\u062D\u0642\u0642 \u0645\u0646 \u0627\u062A\u0635\u0627\u0644\u0643 \u062B\u0645 \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629.",
    archivedNotice: "\u0647\u0630\u0627 \u0627\u0644\u062D\u0631\u064A\u0641 \u0645\u0624\u0631\u0634\u0641: \u0645\u0644\u0641\u0647 \u0644\u0644\u0627\u0637\u0644\u0627\u0639 \u0641\u0642\u0637."
  },
  later: {
    projects: {
      title: "\u0645\u0634\u0627\u0631\u064A\u0639 \u0647\u0630\u0627 \u0627\u0644\u062D\u0631\u064A\u0641 \u0633\u062A\u062A\u0648\u0641\u0631 \u0642\u0631\u064A\u0628\u064B\u0627",
      description: "\u0633\u064A\u0639\u0631\u0636 \u0647\u0630\u0627 \u0627\u0644\u062A\u0628\u0648\u064A\u0628 \u0627\u0644\u0645\u0634\u0627\u0631\u064A\u0639 \u0627\u0644\u0645\u0646\u062C\u0632\u0629 \u0644\u0641\u0627\u0626\u062F\u0629 \u0647\u0630\u0627 \u0627\u0644\u062D\u0631\u064A\u0641 \u0639\u0646\u062F \u0625\u0637\u0644\u0627\u0642 \u0648\u062D\u062F\u0629 \u0627\u0644\u0645\u0634\u0627\u0631\u064A\u0639."
    },
    invoices: {
      title: "\u0641\u0648\u0627\u062A\u064A\u0631 \u0647\u0630\u0627 \u0627\u0644\u062D\u0631\u064A\u0641 \u0633\u062A\u062A\u0648\u0641\u0631 \u0642\u0631\u064A\u0628\u064B\u0627",
      description: "\u0633\u064A\u0639\u0631\u0636 \u0647\u0630\u0627 \u0627\u0644\u062A\u0628\u0648\u064A\u0628 \u0639\u0631\u0648\u0636 \u0627\u0644\u0623\u0633\u0639\u0627\u0631 \u0648\u0627\u0644\u0641\u0648\u0627\u062A\u064A\u0631 \u0627\u0644\u062E\u0627\u0635\u0629 \u0628\u0647\u0630\u0627 \u0627\u0644\u062D\u0631\u064A\u0641 \u0639\u0646\u062F \u0625\u0637\u0644\u0627\u0642 \u0648\u062D\u062F\u0629 \u0627\u0644\u0645\u0627\u0644\u064A\u0629."
    }
  },
  profile: {
    edit: "\u062A\u0639\u062F\u064A\u0644",
    editLabel: "\u062A\u0639\u062F\u064A\u0644 \u0627\u0644\u062D\u0631\u064A\u0641 {name}",
    save: "\u062D\u0641\u0638",
    saving: "\u062C\u0627\u0631\u064D \u0627\u0644\u062D\u0641\u0638\u2026",
    saved: "\u062A\u0645 \u062A\u062D\u062F\u064A\u062B \u0627\u0644\u062D\u0631\u064A\u0641 \xAB{name}\xBB.",
    stale: "\u062A\u0645 \u062A\u0639\u062F\u064A\u0644 \xAB{name}\xBB \u0645\u0646 \u0637\u0631\u0641 \u0634\u062E\u0635 \u0622\u062E\u0631. \u0623\u064F\u0639\u064A\u062F \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0645\u0644\u0641: \u0637\u0628\u0651\u0642 \u062A\u063A\u064A\u064A\u0631\u0627\u062A\u0643 \u0645\u0646 \u062C\u062F\u064A\u062F.",
    yes: "\u0646\u0639\u0645",
    no: "\u0644\u0627",
    legalRate: "\u0627\u0644\u0646\u0633\u0628\u0629 \u0627\u0644\u0642\u0627\u0646\u0648\u0646\u064A\u0629",
    customRate: "\u0646\u0633\u0628\u0629 {percent} %",
    taxId: "\u0627\u0644\u0645\u0639\u0631\u0651\u0641 \u0627\u0644\u062C\u0628\u0627\u0626\u064A",
    paymentTerms: "\u0623\u062C\u0644 \u0627\u0644\u062F\u0641\u0639 (\u0628\u0627\u0644\u0623\u064A\u0627\u0645)",
    address: "\u0627\u0644\u0639\u0646\u0648\u0627\u0646",
    createdAt: "\u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0625\u0646\u0634\u0627\u0621"
  },
  archive: {
    button: "\u0623\u0631\u0634\u0641\u0629",
    title: "\u0623\u0631\u0634\u0641\u0629 \u0627\u0644\u062D\u0631\u064A\u0641 \xAB{name}\xBB\u061F",
    body: "\u064A\u062E\u062A\u0641\u064A \u0627\u0644\u062D\u0631\u064A\u0641 \u0645\u0646 \u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u062D\u0631\u0641\u0627\u0621 \u0627\u0644\u0646\u0634\u0637\u064A\u0646 \u0648\u0644\u0627 \u064A\u0645\u0643\u0646 \u062A\u0639\u062F\u064A\u0644 \u0645\u0644\u0641\u0647.",
    bodyKept: "\u062A\u0628\u0642\u0649 \u0645\u0634\u0627\u0631\u064A\u0639\u0647 \u0648\u0639\u0631\u0648\u0636 \u0623\u0633\u0639\u0627\u0631\u0647 \u0648\u0641\u0648\u0627\u062A\u064A\u0631\u0647 \u0627\u0644\u062D\u0627\u0644\u064A\u0629 \u0645\u062D\u0641\u0648\u0638\u0629. \u0648\u064A\u0645\u0643\u0646\u0643 \u062F\u0627\u0626\u0645\u064B\u0627 \u0627\u0644\u0627\u0637\u0644\u0627\u0639 \u0639\u0644\u0649 \u0645\u0644\u0641\u0647 \u0645\u0646 \u0627\u0644\u0642\u0627\u0626\u0645\u0629 \u0628\u0639\u0631\u0636 \u0627\u0644\u062D\u0631\u0641\u0627\u0621 \u0627\u0644\u0645\u0624\u0631\u0634\u0641\u064A\u0646.",
    confirm: "\u0623\u0631\u0634\u0641\u0629",
    done: "\u062A\u0645\u062A \u0623\u0631\u0634\u0641\u0629 \u0627\u0644\u062D\u0631\u064A\u0641 \xAB{name}\xBB.",
    stale: "\u062A\u0645 \u062A\u0639\u062F\u064A\u0644 \xAB{name}\xBB \u0645\u0646 \u0637\u0631\u0641 \u0634\u062E\u0635 \u0622\u062E\u0631. \u0623\u064F\u0639\u064A\u062F \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0645\u0644\u0641: \u0631\u0627\u062C\u0639\u0647 \u062B\u0645 \u0623\u0639\u062F \u0627\u0644\u0623\u0631\u0634\u0641\u0629 \u0639\u0646\u062F \u0627\u0644\u062D\u0627\u062C\u0629."
  },
  contacts: {
    intro: "\u0627\u0644\u0623\u0634\u062E\u0627\u0635 \u0627\u0644\u0630\u064A\u0646 \u064A\u0645\u0643\u0646 \u0627\u0644\u0627\u062A\u0635\u0627\u0644 \u0628\u0647\u0645 \u0644\u062F\u0649 \u0647\u0630\u0627 \u0627\u0644\u062D\u0631\u064A\u0641. \u062C\u0647\u0629 \u0627\u062A\u0635\u0627\u0644 \u0648\u0627\u062D\u062F\u0629 \u0641\u0642\u0637 \u0647\u064A \u0627\u0644\u0623\u0633\u0627\u0633\u064A\u0629.",
    add: "\u0625\u0636\u0627\u0641\u0629 \u062C\u0647\u0629 \u0627\u062A\u0635\u0627\u0644",
    addTitle: "\u062C\u0647\u0629 \u0627\u062A\u0635\u0627\u0644 \u062C\u062F\u064A\u062F\u0629",
    editTitle: "\u062A\u0639\u062F\u064A\u0644 \u062C\u0647\u0629 \u0627\u0644\u0627\u062A\u0635\u0627\u0644",
    tableCaption: "\u062C\u0647\u0627\u062A \u0627\u062A\u0635\u0627\u0644 \u0627\u0644\u062D\u0631\u064A\u0641",
    columns: {
      name: "\u0627\u0644\u0627\u0633\u0645",
      role: "\u0627\u0644\u0648\u0638\u064A\u0641\u0629",
      email: "\u0627\u0644\u0628\u0631\u064A\u062F \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A",
      phone: "\u0627\u0644\u0647\u0627\u062A\u0641",
      actions: "\u0627\u0644\u0625\u062C\u0631\u0627\u0621\u0627\u062A"
    },
    primary: "\u0623\u0633\u0627\u0633\u064A\u0629",
    fields: {
      name: "\u0627\u0644\u0627\u0633\u0645",
      role: "\u0627\u0644\u0648\u0638\u064A\u0641\u0629",
      roleHint: "\u0645\u062B\u0644\u064B\u0627 \u0645\u062F\u064A\u0631 \u0641\u0646\u064A \u0623\u0648 \u0645\u0643\u0644\u0641 \u0628\u0627\u0644\u0645\u0634\u0631\u0648\u0639.",
      email: "\u0627\u0644\u0628\u0631\u064A\u062F \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A",
      phone: "\u0627\u0644\u0647\u0627\u062A\u0641",
      primary: "\u062C\u0647\u0629 \u0627\u0644\u0627\u062A\u0635\u0627\u0644 \u0627\u0644\u0623\u0633\u0627\u0633\u064A\u0629",
      primaryHint: "\u062C\u0647\u0629 \u0627\u062A\u0635\u0627\u0644 \u0623\u0633\u0627\u0633\u064A\u0629 \u0648\u0627\u062D\u062F\u0629 \u0644\u0643\u0644 \u062D\u0631\u064A\u0641: \u062A\u062D\u062F\u064A\u062F \u0647\u0630\u0647 \u0627\u0644\u062E\u0627\u0646\u0629 \u064A\u0639\u0648\u0651\u0636 \u0627\u0644\u0633\u0627\u0628\u0642\u0629."
    },
    save: "\u062D\u0641\u0638",
    saving: "\u062C\u0627\u0631\u064D \u0627\u0644\u062D\u0641\u0638\u2026",
    actions: {
      open: "\u0625\u062C\u0631\u0627\u0621\u0627\u062A {name}",
      edit: "\u062A\u0639\u062F\u064A\u0644",
      makePrimary: "\u062A\u0639\u064A\u064A\u0646 \u0643\u0623\u0633\u0627\u0633\u064A\u0629",
      delete: "\u062D\u0630\u0641"
    },
    deleteTitle: "\u062D\u0630\u0641 \u062C\u0647\u0629 \u0627\u0644\u0627\u062A\u0635\u0627\u0644 {name}\u061F",
    deleteBody: "\u0633\u062A\u064F\u0632\u0627\u0644 \u062C\u0647\u0629 \u0627\u0644\u0627\u062A\u0635\u0627\u0644 \u0647\u0630\u0647 \u0645\u0646 \u0645\u0644\u0641 \u0627\u0644\u062D\u0631\u064A\u0641.",
    added: "\u062A\u0645\u062A \u0625\u0636\u0627\u0641\u0629 \u062C\u0647\u0629 \u0627\u0644\u0627\u062A\u0635\u0627\u0644 {name}.",
    updated: "\u062A\u0645 \u062A\u062D\u062F\u064A\u062B \u062C\u0647\u0629 \u0627\u0644\u0627\u062A\u0635\u0627\u0644 {name}.",
    primaryDone: "\u0623\u0635\u0628\u062D {name} \u062C\u0647\u0629 \u0627\u0644\u0627\u062A\u0635\u0627\u0644 \u0627\u0644\u0623\u0633\u0627\u0633\u064A\u0629.",
    deleted: "\u062A\u0645 \u062D\u0630\u0641 \u062C\u0647\u0629 \u0627\u0644\u0627\u062A\u0635\u0627\u0644 {name}.",
    stale: "\u062A\u0645 \u062A\u0639\u062F\u064A\u0644 \u062C\u0647\u0629 \u0627\u0644\u0627\u062A\u0635\u0627\u0644 {name} \u0645\u0646 \u0637\u0631\u0641 \u0634\u062E\u0635 \u0622\u062E\u0631. \u0623\u064F\u0639\u064A\u062F \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0642\u0627\u0626\u0645\u0629: \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629 \u0639\u0646\u062F \u0627\u0644\u062D\u0627\u062C\u0629.",
    empty: {
      title: "\u0644\u0627 \u062A\u0648\u062C\u062F \u062C\u0647\u0627\u062A \u0627\u062A\u0635\u0627\u0644",
      description: "\u0623\u0636\u0641 \u0627\u0644\u0634\u062E\u0635 \u0627\u0644\u0630\u064A \u062A\u0648\u062C\u064E\u0651\u0647 \u0625\u0644\u064A\u0647 \u0639\u0631\u0648\u0636 \u0627\u0644\u0623\u0633\u0639\u0627\u0631 \u0648\u0627\u0644\u0641\u0648\u0627\u062A\u064A\u0631.",
      descriptionReadOnly: "\u0644\u0645 \u062A\u062A\u0645 \u0625\u0636\u0627\u0641\u0629 \u0623\u064A \u062C\u0647\u0629 \u0627\u062A\u0635\u0627\u0644 \u0644\u0647\u0630\u0627 \u0627\u0644\u062D\u0631\u064A\u0641."
    },
    loadFailedTitle: "\u062A\u0639\u0630\u0651\u0631 \u062A\u062D\u0645\u064A\u0644 \u062C\u0647\u0627\u062A \u0627\u0644\u0627\u062A\u0635\u0627\u0644",
    loadFailedBody: "\u062A\u062D\u0642\u0642 \u0645\u0646 \u0627\u062A\u0635\u0627\u0644\u0643 \u062B\u0645 \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629.",
    errors: {
      nameRequired: "\u0623\u062F\u062E\u0644 \u0627\u0633\u0645 \u062C\u0647\u0629 \u0627\u0644\u0627\u062A\u0635\u0627\u0644.",
      emailInvalid: "\u0639\u0646\u0648\u0627\u0646 \u0627\u0644\u0628\u0631\u064A\u062F \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A \u063A\u064A\u0631 \u0635\u0627\u0644\u062D.",
      phoneInvalid: "\u0623\u062F\u062E\u0644 \u0631\u0642\u0645\u064B\u0627 \u0635\u0627\u0644\u062D\u064B\u0627\u060C \u0645\u062B\u0644\u064B\u0627 \u2066+216 71 000 000\u2069.",
      roleInvalid: "\u0647\u0630\u0647 \u0627\u0644\u0648\u0638\u064A\u0641\u0629 \u063A\u064A\u0631 \u0635\u0627\u0644\u062D\u0629.",
      invalid: "\u0647\u0630\u0647 \u0627\u0644\u0642\u064A\u0645\u0629 \u063A\u064A\u0631 \u0635\u0627\u0644\u062D\u0629."
    }
  }
};

// locales/en/clients.json
var clients_default2 = {
  title: "Clients",
  none: "\u2014",
  more: {
    title: "Clients",
    description: "Project owners: tax profile, contacts and details."
  },
  status: {
    archived: "Archived"
  },
  kinds: {
    public_entity: "Public body",
    private_company: "Private company",
    individual: "Individual",
    foreign: "Foreign client"
  },
  kindHints: {
    public_entity: "State, local authority or public company. The tax id is required.",
    private_company: "Private-law company or association. The tax id is required.",
    individual: "A private person. The tax id is optional.",
    foreign: 'A client based outside Tunisia. Free-text tax id; the "Export" regime is suggested by default.'
  },
  vatRegimes: {
    subject: "Subject to VAT",
    exempt: "VAT exempt",
    suspended: "VAT suspended",
    export: "Export (outside Tunisia)"
  },
  vatRegimeHints: {
    subject: "The usual case: VAT is charged to this client.",
    exempt: "The client holds an exemption certificate: enter its reference and its expiry date.",
    suspended: "Purchases with VAT suspended: enter the reference of the suspension attestation, it is printed on the invoice.",
    export: "A client outside Tunisia: an export operation. A reference can be added if needed."
  },
  list: {
    tableCaption: "Clients of the office",
    columns: {
      name: "Name",
      kind: "Type",
      taxId: "Tax id",
      city: "City",
      contact: "Email and phone"
    },
    filters: {
      label: "Filter clients",
      search: "Search for a client",
      searchPlaceholder: "Client name",
      kind: "Filter by type",
      allKinds: "All types",
      archived: "Show archived clients only",
      clear: "Clear the filters"
    },
    new: "New client",
    loadMore: "Show more clients",
    loadingMore: "Loading\u2026",
    loadFailedTitle: "The clients could not be loaded",
    loadFailedBody: "Check your connection, then try again.",
    empty: {
      title: "No clients yet",
      description: "A client, or project owner, is the person or body you carry out a project for. Add them once here: their tax profile is used for your quotes and invoices.",
      descriptionReadOnly: "A client, or project owner, is the person or body you carry out a project for. None has been added yet; ask an administrator or a project manager to create one.",
      filteredTitle: "No client matches",
      filteredDescription: "Try another name or another type of client.",
      archivedTitle: "No archived clients",
      archivedDescription: "The clients you archive appear here."
    }
  },
  create: {
    title: "New client",
    intro: "Choose the type of client first: the form adapts and pre-sets VAT and withholding.",
    submit: "Create the client",
    saving: "Creating\u2026",
    done: 'The client "{name}" was created.'
  },
  form: {
    groups: {
      identity: "Identity",
      tax: "VAT and withholding",
      address: "Address",
      contact: "Contact details"
    },
    fields: {
      kind: {
        label: "Type of client"
      },
      name: {
        label: "Name or company name"
      },
      taxId: {
        label: "Tax id (matricule fiscal)",
        hint: "Format: 1234567 A / A / M / 000",
        hintShort: "Optional. The short form (7 digits and a letter) is accepted."
      },
      taxIdForeign: {
        label: "Tax identifier",
        hint: "Optional. Free text, 50 characters at most."
      },
      paymentTerms: {
        label: "Payment terms (days)",
        hint: "Number of days after the invoice date. 30 by default."
      },
      vatRegime: {
        label: "VAT regime"
      },
      exemptionRef: {
        label: {
          subject: "Reference",
          exempt: "Exemption certificate reference",
          suspended: "Suspension attestation reference",
          export: "Reference (optional)"
        },
        hint: "Copy it as it appears on the document."
      },
      exemptionExpiresOn: {
        label: "Valid until",
        hint: "The date until which the certificate is valid.",
        hintOptional: "Optional. Leave empty if the attestation has no end date."
      },
      withholding: {
        label: "Withholding tax (RAS)",
        hint: "RAS is a share of your invoice amount that the client keeps and pays directly to the tax administration. You receive the rest, and the client gives you a withholding certificate. On by default for public bodies and companies."
      },
      withholdingRate: {
        label: "Specific withholding rate (%)",
        hint: "Leave empty to use the legal rate in force."
      },
      vatWithholding: {
        label: "VAT withholding (RAS TVA)",
        hint: "RAS TVA is a part of the VAT on your invoice that the client withholds and pays to the Treasury: you only receive the balance. On by default for public bodies. The rate is the one set by law, there is nothing to enter."
      },
      line1: {
        label: "Address"
      },
      line2: {
        label: "Address line 2"
      },
      city: {
        label: "City"
      },
      postalCode: {
        label: "Postal code"
      },
      country: {
        label: "Country (2-letter code)",
        hint: "For example FR for France, IT for Italy."
      },
      email: {
        label: "Email address"
      },
      phone: {
        label: "Phone"
      }
    },
    errors: {
      required: "This field is required.",
      taxIdRequired: "The tax id is required for this type of client.",
      taxIdTooLong: "The tax identifier is limited to 50 characters.",
      exemptionRefRequired: "Enter the exemption certificate reference.",
      suspensionRefRequired: "Enter the suspension attestation reference.",
      exemptionExpiryRequired: "Enter the date the exemption expires.",
      rateInvalid: "Enter a percentage between 0 and 100 (for example 1.5), or leave empty.",
      paymentTermsInvalid: "Enter a number of days between 0 and 365.",
      postalCodeInvalid: "The postal code has 3 to 10 characters (digits or letters).",
      countryInvalid: "Enter the 2-letter country code, for example FR.",
      emailInvalid: "This email address is not valid.",
      phoneInvalid: "Enter a valid number, for example +216 71 000 000.",
      invalid: "This value is not valid."
    },
    serverErrors: {
      EXEMPTION_REF_REQUIRED: "The reference is required for this VAT regime.",
      EXEMPTION_EXPIRY_REQUIRED: "The expiry date is required.",
      EXEMPTION_NOT_APPLICABLE: "This field does not apply to the chosen VAT regime.",
      WITHHOLDING_RATE_NOT_APPLICABLE: "A specific rate needs the withholding tax to apply."
    }
  },
  detail: {
    client: "Client",
    tabs: {
      profile: "Profile",
      contacts: "Contacts",
      projects: "Projects",
      invoices: "Invoices"
    },
    notFoundTitle: "Client not found",
    notFoundBody: "This client does not exist or you do not have access to it.",
    backToList: "Back to clients",
    loadFailedTitle: "This client could not be loaded",
    loadFailedBody: "Check your connection, then try again.",
    archivedNotice: "This client is archived: its record is read-only."
  },
  later: {
    projects: {
      title: "This client's projects are coming soon",
      description: "This tab will list the projects done for this client once the Projects module opens."
    },
    invoices: {
      title: "This client's invoices are coming soon",
      description: "This tab will list the quotes and invoices of this client once the Finance module opens."
    }
  },
  profile: {
    edit: "Edit",
    editLabel: "Edit the client {name}",
    save: "Save",
    saving: "Saving\u2026",
    saved: 'The client "{name}" was updated.',
    stale: '"{name}" was changed by someone else. The record has been reloaded: apply your changes again.',
    yes: "Yes",
    no: "No",
    legalRate: "legal rate",
    customRate: "rate of {percent}%",
    taxId: "Tax identifier",
    paymentTerms: "Payment terms (days)",
    address: "Address",
    createdAt: "Created on"
  },
  archive: {
    button: "Archive",
    title: 'Archive the client "{name}"?',
    body: "The client leaves the list of active clients and its record can no longer be edited.",
    bodyKept: "Its existing projects, quotes and invoices are kept. You can still open it from the list by showing archived clients.",
    confirm: "Archive",
    done: 'The client "{name}" was archived.',
    stale: '"{name}" was changed by someone else. The record has been reloaded: check it, then archive again if needed.'
  },
  contacts: {
    intro: "The people to reach at this client. Only one contact is the primary contact.",
    add: "Add a contact",
    addTitle: "New contact",
    editTitle: "Edit the contact",
    tableCaption: "The client's contacts",
    columns: {
      name: "Name",
      role: "Role",
      email: "Email",
      phone: "Phone",
      actions: "Actions"
    },
    primary: "Primary",
    fields: {
      name: "Name",
      role: "Role",
      roleHint: "For example technical director, project officer.",
      email: "Email address",
      phone: "Phone",
      primary: "Primary contact",
      primaryHint: "One primary contact per client: ticking this box replaces the previous one."
    },
    save: "Save",
    saving: "Saving\u2026",
    actions: {
      open: "Actions for {name}",
      edit: "Edit",
      makePrimary: "Make primary",
      delete: "Delete"
    },
    deleteTitle: "Delete the contact {name}?",
    deleteBody: "This contact will be removed from the client's record.",
    added: "The contact {name} was added.",
    updated: "The contact {name} was updated.",
    primaryDone: "{name} is now the primary contact.",
    deleted: "The contact {name} was deleted.",
    stale: "The contact {name} was changed by someone else. The list has been reloaded: try again if needed.",
    empty: {
      title: "No contacts",
      description: "Add the person your quotes and invoices are addressed to.",
      descriptionReadOnly: "No contact has been added for this client."
    },
    loadFailedTitle: "The contacts could not be loaded",
    loadFailedBody: "Check your connection, then try again.",
    errors: {
      nameRequired: "Enter the contact's name.",
      emailInvalid: "This email address is not valid.",
      phoneInvalid: "Enter a valid number, for example +216 71 000 000.",
      roleInvalid: "This role is not valid.",
      invalid: "This value is not valid."
    }
  }
};

// locales/fr/clients.json
var clients_default3 = {
  title: "Clients",
  none: "\u2014",
  more: {
    title: "Clients",
    description: "Ma\xEEtres d'ouvrage\xA0: fiche fiscale, contacts et coordonn\xE9es."
  },
  status: {
    archived: "Archiv\xE9"
  },
  kinds: {
    public_entity: "Organisme public",
    private_company: "Soci\xE9t\xE9 priv\xE9e",
    individual: "Particulier",
    foreign: "Client \xE9tranger"
  },
  kindHints: {
    public_entity: "\xC9tat, collectivit\xE9 ou entreprise publique. Matricule fiscal obligatoire.",
    private_company: "Soci\xE9t\xE9 ou association de droit priv\xE9. Matricule fiscal obligatoire.",
    individual: "Personne physique. Le matricule fiscal est facultatif.",
    foreign: "Client \xE9tabli hors de Tunisie. Identifiant fiscal libre\xA0; le r\xE9gime \xAB\xA0Export\xA0\xBB est propos\xE9 par d\xE9faut."
  },
  vatRegimes: {
    subject: "Assujetti \xE0 la TVA",
    exempt: "Exon\xE9r\xE9 de TVA",
    suspended: "TVA en suspension",
    export: "Export (hors Tunisie)"
  },
  vatRegimeHints: {
    subject: "Cas g\xE9n\xE9ral\xA0: la TVA est factur\xE9e \xE0 ce client.",
    exempt: "Le client pr\xE9sente un certificat d'exon\xE9ration\xA0: indiquez sa r\xE9f\xE9rence et sa date de fin de validit\xE9.",
    suspended: "Achats en suspension de TVA\xA0: indiquez la r\xE9f\xE9rence de l'attestation de suspension, elle sera imprim\xE9e sur la facture.",
    export: "Client hors de Tunisie\xA0: op\xE9ration d'exportation. Une r\xE9f\xE9rence peut \xEAtre ajout\xE9e si besoin."
  },
  list: {
    tableCaption: "Clients du bureau",
    columns: {
      name: "Nom",
      kind: "Type",
      taxId: "Matricule fiscal",
      city: "Ville",
      contact: "E-mail et t\xE9l\xE9phone"
    },
    filters: {
      label: "Filtrer les clients",
      search: "Rechercher un client",
      searchPlaceholder: "Nom du client",
      kind: "Filtrer par type",
      allKinds: "Tous les types",
      archived: "Afficher uniquement les clients archiv\xE9s",
      clear: "Effacer les filtres"
    },
    new: "Nouveau client",
    loadMore: "Afficher plus de clients",
    loadingMore: "Chargement\u2026",
    loadFailedTitle: "Impossible de charger les clients",
    loadFailedBody: "V\xE9rifiez votre connexion puis r\xE9essayez.",
    empty: {
      title: "Aucun client pour l'instant",
      description: "Un client, ou ma\xEEtre d'ouvrage, est la personne ou l'organisme pour qui vous r\xE9alisez un projet. Ajoutez-le une fois ici\xA0: sa fiche fiscale servira \xE0 vos devis et \xE0 vos factures.",
      descriptionReadOnly: "Un client, ou ma\xEEtre d'ouvrage, est la personne ou l'organisme pour qui vous r\xE9alisez un projet. Aucun n'a encore \xE9t\xE9 ajout\xE9\xA0; demandez \xE0 un administrateur ou \xE0 un chef de projet d'en cr\xE9er un.",
      filteredTitle: "Aucun client ne correspond",
      filteredDescription: "Essayez un autre nom ou un autre type de client.",
      archivedTitle: "Aucun client archiv\xE9",
      archivedDescription: "Les clients que vous archivez apparaissent ici."
    }
  },
  create: {
    title: "Nouveau client",
    intro: "Choisissez d'abord le type de client\xA0: le formulaire s'adapte et pr\xE9r\xE8gle la TVA et les retenues.",
    submit: "Cr\xE9er le client",
    saving: "Cr\xE9ation\u2026",
    done: "Le client \xAB\xA0{name}\xA0\xBB a \xE9t\xE9 cr\xE9\xE9."
  },
  form: {
    groups: {
      identity: "Identit\xE9",
      tax: "TVA et retenues \xE0 la source",
      address: "Adresse",
      contact: "Coordonn\xE9es"
    },
    fields: {
      kind: {
        label: "Type de client"
      },
      name: {
        label: "Nom ou raison sociale"
      },
      taxId: {
        label: "Matricule fiscal",
        hint: "Format\xA0: 1234567 A / A / M / 000",
        hintShort: "Facultatif. La forme courte (7 chiffres et une lettre) est accept\xE9e."
      },
      taxIdForeign: {
        label: "Identifiant fiscal",
        hint: "Facultatif. Texte libre, 50 caract\xE8res au maximum."
      },
      paymentTerms: {
        label: "D\xE9lai de paiement (jours)",
        hint: "Nombre de jours apr\xE8s la date de facture. 30 par d\xE9faut."
      },
      vatRegime: {
        label: "R\xE9gime de TVA"
      },
      exemptionRef: {
        label: {
          subject: "R\xE9f\xE9rence",
          exempt: "R\xE9f\xE9rence du certificat d'exon\xE9ration",
          suspended: "R\xE9f\xE9rence de l'attestation de suspension",
          export: "R\xE9f\xE9rence (facultatif)"
        },
        hint: "Recopiez-la telle qu'elle figure sur le document."
      },
      exemptionExpiresOn: {
        label: "Fin de validit\xE9",
        hint: "Date jusqu'\xE0 laquelle le certificat est valable.",
        hintOptional: "Facultatif. Laissez vide si l'attestation n'a pas de date de fin."
      },
      withholding: {
        label: "Retenue \xE0 la source (RAS)",
        hint: "La RAS est une part du montant de votre facture que le client garde pour la verser directement \xE0 l'administration fiscale. Vous recevez le reste, et le client vous remet un certificat de retenue. Activ\xE9e par d\xE9faut pour les organismes publics et les soci\xE9t\xE9s."
      },
      withholdingRate: {
        label: "Taux de retenue particulier (%)",
        hint: "Laissez vide pour appliquer le taux l\xE9gal en vigueur."
      },
      vatWithholding: {
        label: "Retenue \xE0 la source sur la TVA (RAS TVA)",
        hint: "La RAS TVA est une partie de la TVA de votre facture que le client retient pour la verser au Tr\xE9sor\xA0: vous ne recevez que le compl\xE9ment. Activ\xE9e par d\xE9faut pour les organismes publics. Le taux est celui de la loi, vous n'avez rien \xE0 saisir."
      },
      line1: {
        label: "Adresse"
      },
      line2: {
        label: "Compl\xE9ment d'adresse"
      },
      city: {
        label: "Ville"
      },
      postalCode: {
        label: "Code postal"
      },
      country: {
        label: "Pays (code \xE0 2 lettres)",
        hint: "Par exemple FR pour la France, IT pour l'Italie."
      },
      email: {
        label: "Adresse e-mail"
      },
      phone: {
        label: "T\xE9l\xE9phone"
      }
    },
    errors: {
      required: "Ce champ est obligatoire.",
      taxIdRequired: "Le matricule fiscal est obligatoire pour ce type de client.",
      taxIdTooLong: "L'identifiant fiscal est limit\xE9 \xE0 50 caract\xE8res.",
      exemptionRefRequired: "Indiquez la r\xE9f\xE9rence du certificat d'exon\xE9ration.",
      suspensionRefRequired: "Indiquez la r\xE9f\xE9rence de l'attestation de suspension.",
      exemptionExpiryRequired: "Indiquez la date de fin de validit\xE9 de l'exon\xE9ration.",
      rateInvalid: "Saisissez un pourcentage entre 0 et 100 (par exemple 1,5), ou laissez vide.",
      paymentTermsInvalid: "Saisissez un nombre de jours entre 0 et 365.",
      postalCodeInvalid: "Le code postal comporte 3 \xE0 10 caract\xE8res (chiffres ou lettres).",
      countryInvalid: "Saisissez le code du pays sur 2 lettres, par exemple FR.",
      emailInvalid: "Cette adresse e-mail n'est pas valide.",
      phoneInvalid: "Saisissez un num\xE9ro valide, par exemple +216 71 000 000.",
      invalid: "Cette valeur n'est pas valide."
    },
    serverErrors: {
      EXEMPTION_REF_REQUIRED: "La r\xE9f\xE9rence est obligatoire pour ce r\xE9gime de TVA.",
      EXEMPTION_EXPIRY_REQUIRED: "La date de fin de validit\xE9 est obligatoire.",
      EXEMPTION_NOT_APPLICABLE: "Ce champ ne s'applique pas au r\xE9gime de TVA choisi.",
      WITHHOLDING_RATE_NOT_APPLICABLE: "Un taux particulier suppose que la retenue \xE0 la source s'applique."
    }
  },
  detail: {
    client: "Client",
    tabs: {
      profile: "Profil",
      contacts: "Contacts",
      projects: "Projets",
      invoices: "Factures"
    },
    notFoundTitle: "Client introuvable",
    notFoundBody: "Ce client n'existe pas ou vous n'y avez pas acc\xE8s.",
    backToList: "Retour aux clients",
    loadFailedTitle: "Impossible de charger ce client",
    loadFailedBody: "V\xE9rifiez votre connexion puis r\xE9essayez.",
    archivedNotice: "Ce client est archiv\xE9\xA0: sa fiche est en lecture seule."
  },
  later: {
    projects: {
      title: "Les projets de ce client arrivent bient\xF4t",
      description: "Cet onglet listera les projets r\xE9alis\xE9s pour ce client d\xE8s l'ouverture du module Projets."
    },
    invoices: {
      title: "Les factures de ce client arrivent bient\xF4t",
      description: "Cet onglet listera les devis et les factures de ce client d\xE8s l'ouverture du module Finance."
    }
  },
  profile: {
    edit: "Modifier",
    editLabel: "Modifier le client {name}",
    save: "Enregistrer",
    saving: "Enregistrement\u2026",
    saved: "Le client \xAB\xA0{name}\xA0\xBB a \xE9t\xE9 mis \xE0 jour.",
    stale: "\xAB\xA0{name}\xA0\xBB a \xE9t\xE9 modifi\xE9 par quelqu'un d'autre. La fiche a \xE9t\xE9 recharg\xE9e\xA0: appliquez de nouveau vos changements.",
    yes: "Oui",
    no: "Non",
    legalRate: "taux l\xE9gal",
    customRate: "taux de {percent} %",
    taxId: "Identifiant fiscal",
    paymentTerms: "D\xE9lai de paiement (jours)",
    address: "Adresse",
    createdAt: "Cr\xE9\xE9 le"
  },
  archive: {
    button: "Archiver",
    title: "Archiver le client \xAB\xA0{name}\xA0\xBB\xA0?",
    body: "Le client dispara\xEEt de la liste des clients actifs et sa fiche ne peut plus \xEAtre modifi\xE9e.",
    bodyKept: "Ses projets, devis et factures existants sont conserv\xE9s. Vous pourrez toujours le consulter depuis la liste en affichant les clients archiv\xE9s.",
    confirm: "Archiver",
    done: "Le client \xAB\xA0{name}\xA0\xBB a \xE9t\xE9 archiv\xE9.",
    stale: "\xAB\xA0{name}\xA0\xBB a \xE9t\xE9 modifi\xE9 par quelqu'un d'autre. La fiche a \xE9t\xE9 recharg\xE9e\xA0: v\xE9rifiez-la puis archivez de nouveau si besoin."
  },
  contacts: {
    intro: "Les personnes \xE0 joindre chez ce client. Un seul contact est le contact principal.",
    add: "Ajouter un contact",
    addTitle: "Nouveau contact",
    editTitle: "Modifier le contact",
    tableCaption: "Contacts du client",
    columns: {
      name: "Nom",
      role: "Fonction",
      email: "E-mail",
      phone: "T\xE9l\xE9phone",
      actions: "Actions"
    },
    primary: "Principal",
    fields: {
      name: "Nom",
      role: "Fonction",
      roleHint: "Par exemple directeur technique, charg\xE9 de projet.",
      email: "Adresse e-mail",
      phone: "T\xE9l\xE9phone",
      primary: "Contact principal",
      primaryHint: "Un seul contact principal par client\xA0: cocher cette case remplace l'ancien."
    },
    save: "Enregistrer",
    saving: "Enregistrement\u2026",
    actions: {
      open: "Actions pour {name}",
      edit: "Modifier",
      makePrimary: "D\xE9finir comme principal",
      delete: "Supprimer"
    },
    deleteTitle: "Supprimer le contact {name}\xA0?",
    deleteBody: "Ce contact sera retir\xE9 de la fiche du client.",
    added: "Le contact {name} a \xE9t\xE9 ajout\xE9.",
    updated: "Le contact {name} a \xE9t\xE9 mis \xE0 jour.",
    primaryDone: "{name} est maintenant le contact principal.",
    deleted: "Le contact {name} a \xE9t\xE9 supprim\xE9.",
    stale: "Le contact {name} a \xE9t\xE9 modifi\xE9 par quelqu'un d'autre. La liste a \xE9t\xE9 recharg\xE9e\xA0: recommencez si besoin.",
    empty: {
      title: "Aucun contact",
      description: "Ajoutez la personne \xE0 qui adresser vos devis et vos factures.",
      descriptionReadOnly: "Aucun contact n'a \xE9t\xE9 ajout\xE9 pour ce client."
    },
    loadFailedTitle: "Impossible de charger les contacts",
    loadFailedBody: "V\xE9rifiez votre connexion puis r\xE9essayez.",
    errors: {
      nameRequired: "Indiquez le nom du contact.",
      emailInvalid: "Cette adresse e-mail n'est pas valide.",
      phoneInvalid: "Saisissez un num\xE9ro valide, par exemple +216 71 000 000.",
      roleInvalid: "Cette fonction n'est pas valide.",
      invalid: "Cette valeur n'est pas valide."
    }
  }
};

// locales/ar/tasks.json
var tasks_default = {
  newTask: "\u0645\u0647\u0645\u0629 \u062C\u062F\u064A\u062F\u0629",
  views: {
    label: "\u0639\u0631\u0636 \u0627\u0644\u0645\u0647\u0627\u0645",
    list: "\u0642\u0627\u0626\u0645\u0629",
    board: "\u0644\u0648\u062D\u0629"
  },
  filters: {
    label: "\u062A\u0635\u0641\u064A\u0629 \u0627\u0644\u0645\u0647\u0627\u0645",
    search: "\u0627\u0644\u0628\u062D\u062B \u0639\u0646 \u0645\u0647\u0645\u0629",
    searchPlaceholder: "\u0627\u0644\u0628\u062D\u062B \u0628\u0627\u0644\u0639\u0646\u0648\u0627\u0646",
    assignee: "\u0627\u0644\u0645\u0633\u0624\u0648\u0644",
    allAssignees: "\u0643\u0644 \u0627\u0644\u0645\u0633\u0624\u0648\u0644\u064A\u0646",
    status: "\u0627\u0644\u062D\u0627\u0644\u0629",
    allStatuses: "\u0643\u0644 \u0627\u0644\u062D\u0627\u0644\u0627\u062A",
    discipline: "\u0627\u0644\u0627\u062E\u062A\u0635\u0627\u0635",
    allDisciplines: "\u0643\u0644 \u0627\u0644\u0627\u062E\u062A\u0635\u0627\u0635\u0627\u062A",
    phase: "\u0627\u0644\u0645\u0631\u062D\u0644\u0629",
    allPhases: "\u0643\u0644 \u0627\u0644\u0645\u0631\u0627\u062D\u0644",
    dueBefore: "\u0627\u0644\u0627\u0633\u062A\u062D\u0642\u0627\u0642 \u0642\u0628\u0644",
    clear: "\u0645\u0633\u062D \u0639\u0648\u0627\u0645\u0644 \u0627\u0644\u062A\u0635\u0641\u064A\u0629"
  },
  statuses: {
    todo: "\u0644\u0644\u0625\u0646\u062C\u0627\u0632",
    in_progress: "\u0642\u064A\u062F \u0627\u0644\u062A\u0646\u0641\u064A\u0630",
    blocked: "\u0645\u062A\u0648\u0642\u0641\u0629",
    done: "\u0645\u0646\u062C\u0632\u0629"
  },
  priorities: {
    low: "\u0645\u0646\u062E\u0641\u0636\u0629",
    normal: "\u0639\u0627\u062F\u064A\u0629",
    high: "\u0639\u0627\u0644\u064A\u0629",
    urgent: "\u0639\u0627\u062C\u0644\u0629"
  },
  columns: {
    title: "\u0627\u0644\u0645\u0647\u0645\u0629",
    status: "\u0627\u0644\u062D\u0627\u0644\u0629",
    priority: "\u0627\u0644\u0623\u0648\u0644\u0648\u064A\u0629",
    assignees: "\u0627\u0644\u0645\u0633\u0624\u0648\u0644\u0648\u0646",
    phase: "\u0627\u0644\u0645\u0631\u062D\u0644\u0629",
    discipline: "\u0627\u0644\u0627\u062E\u062A\u0635\u0627\u0635",
    due: "\u0627\u0644\u0627\u0633\u062A\u062D\u0642\u0627\u0642",
    checklist: "\u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u0645\u0631\u0627\u062C\u0639\u0629"
  },
  fields: {
    title: "\u0627\u0644\u0639\u0646\u0648\u0627\u0646",
    status: "\u0627\u0644\u062D\u0627\u0644\u0629",
    priority: "\u0627\u0644\u0623\u0648\u0644\u0648\u064A\u0629",
    phase: "\u0627\u0644\u0645\u0631\u062D\u0644\u0629",
    discipline: "\u0627\u0644\u0627\u062E\u062A\u0635\u0627\u0635",
    due: "\u0627\u0644\u0627\u0633\u062A\u062D\u0642\u0627\u0642",
    assignees: "\u0627\u0644\u0645\u0633\u0624\u0648\u0644\u0648\u0646",
    parent: "\u0627\u0644\u0645\u0647\u0645\u0629 \u0627\u0644\u0623\u0635\u0644\u064A\u0629",
    start: "\u0627\u0644\u0628\u062F\u0627\u064A\u0629"
  },
  noAssignee: "\u0644\u0627 \u0623\u062D\u062F",
  noPhase: "\u0628\u062F\u0648\u0646 \u0645\u0631\u062D\u0644\u0629",
  noDiscipline: "\u0628\u062F\u0648\u0646 \u0627\u062E\u062A\u0635\u0627\u0635",
  noDue: "\u0628\u062F\u0648\u0646 \u0645\u0648\u0639\u062F",
  noChecklist: "\u0644\u0627 \u062A\u0648\u062C\u062F",
  overdue: "\u0645\u062A\u0623\u062E\u0631\u0629",
  checklistProgress: "{done} \u0645\u0646 {total} \u0645\u0646\u062C\u0632\u0629",
  list: {
    caption: "\u0645\u0647\u0627\u0645 \u0627\u0644\u0645\u0634\u0631\u0648\u0639",
    loadMore: "\u0639\u0631\u0636 \u0627\u0644\u0645\u0632\u064A\u062F \u0645\u0646 \u0627\u0644\u0645\u0647\u0627\u0645",
    loadFailedTitle: "\u062A\u0639\u0630\u0631 \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0645\u0647\u0627\u0645",
    loadFailedBody: "\u062A\u062D\u0642\u0642 \u0645\u0646 \u0627\u062A\u0635\u0627\u0644\u0643 \u062B\u0645 \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629.",
    empty: {
      title: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0645\u0647\u0627\u0645 \u0628\u0639\u062F",
      description: "\u0623\u0636\u0641 \u0623\u0648\u0644 \u0645\u0647\u0645\u0629 \u0641\u064A \u0627\u0644\u0645\u0634\u0631\u0648\u0639 \u0644\u062A\u0648\u0632\u064A\u0639 \u0627\u0644\u0639\u0645\u0644.",
      descriptionReadOnly: "\u0633\u062A\u0638\u0647\u0631 \u0645\u0647\u0627\u0645 \u0627\u0644\u0645\u0634\u0631\u0648\u0639 \u0647\u0646\u0627.",
      filteredTitle: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0645\u0647\u0645\u0629 \u0645\u0637\u0627\u0628\u0642\u0629",
      filteredDescription: "\u0639\u062F\u0651\u0644 \u0639\u0648\u0627\u0645\u0644 \u0627\u0644\u062A\u0635\u0641\u064A\u0629 \u0623\u0648 \u0627\u0645\u0633\u062D\u0647\u0627 \u0644\u0631\u0624\u064A\u0629 \u0645\u0647\u0627\u0645 \u0623\u062E\u0631\u0649."
    }
  },
  board: {
    label: "\u0644\u0648\u062D\u0629 \u0627\u0644\u0645\u0647\u0627\u0645"
  },
  move: {
    failed: "\u062A\u0639\u0630\u0631 \u0646\u0642\u0644 \u0627\u0644\u0645\u0647\u0645\u0629 \xAB{title}\xBB: \u0639\u0627\u062F\u062A \u0625\u0644\u0649 \u0645\u0643\u0627\u0646\u0647\u0627."
  },
  create: {
    title: "\u0645\u0647\u0645\u0629 \u062C\u062F\u064A\u062F\u0629",
    submit: "\u0625\u0646\u0634\u0627\u0621 \u0627\u0644\u0645\u0647\u0645\u0629",
    done: "\u062A\u0645 \u0625\u0646\u0634\u0627\u0621 \u0627\u0644\u0645\u0647\u0645\u0629 \xAB{title}\xBB.",
    noParent: "\u0628\u062F\u0648\u0646 (\u0645\u0647\u0645\u0629 \u0631\u0626\u064A\u0633\u064A\u0629)",
    parentHint: "\u0627\u062E\u062A\u0631 \u0645\u0647\u0645\u0629 \u0644\u0625\u0646\u0634\u0627\u0621 \u0645\u0647\u0645\u0629 \u0641\u0631\u0639\u064A\u0629. \u0644\u0627 \u064A\u0645\u0643\u0646 \u0623\u0646 \u062A\u062D\u062A\u0648\u064A \u0627\u0644\u0645\u0647\u0645\u0629 \u0627\u0644\u0641\u0631\u0639\u064A\u0629 \u0639\u0644\u0649 \u0645\u0647\u0627\u0645 \u0641\u0631\u0639\u064A\u0629.",
    errors: {
      titleRequired: "\u0623\u062F\u062E\u0644 \u0639\u0646\u0648\u0627\u0646\u064B\u0627.",
      titleTooLong: "\u0644\u0627 \u064A\u0645\u0643\u0646 \u0623\u0646 \u064A\u062A\u062C\u0627\u0648\u0632 \u0627\u0644\u0639\u0646\u0648\u0627\u0646 200 \u062D\u0631\u0641.",
      startsAfterDue: "\u0644\u0627 \u064A\u0645\u0643\u0646 \u0623\u0646 \u064A\u0643\u0648\u0646 \u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0628\u062F\u0627\u064A\u0629 \u0628\u0639\u062F \u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0627\u0633\u062A\u062D\u0642\u0627\u0642."
    }
  },
  panel: {
    title: "\u0645\u0647\u0645\u0629",
    close: "\u0625\u063A\u0644\u0627\u0642",
    readOnly: "\u064A\u0645\u0643\u0646\u0643 \u0627\u0644\u0627\u0637\u0644\u0627\u0639 \u0639\u0644\u0649 \u0647\u0630\u0647 \u0627\u0644\u0645\u0647\u0645\u0629 \u062F\u0648\u0646 \u062A\u0639\u062F\u064A\u0644\u0647\u0627.",
    stale: "\u062A\u0645 \u062A\u0639\u062F\u064A\u0644 \u0627\u0644\u0645\u0647\u0645\u0629 \xAB{title}\xBB \u0645\u0646 \u0642\u0628\u0644 \u0634\u062E\u0635 \u0622\u062E\u0631 \u0648\u0623\u064F\u0639\u064A\u062F \u062A\u062D\u0645\u064A\u0644\u0647\u0627: \u0637\u0628\u0651\u0642 \u062A\u063A\u064A\u064A\u0631\u0643 \u0645\u0646 \u062C\u062F\u064A\u062F.",
    loadFailedTitle: "\u062A\u0639\u0630\u0631 \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0645\u0647\u0645\u0629",
    loadFailedBody: "\u062A\u062D\u0642\u0642 \u0645\u0646 \u0627\u062A\u0635\u0627\u0644\u0643 \u062B\u0645 \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629.",
    notFoundTitle: "\u0627\u0644\u0645\u0647\u0645\u0629 \u063A\u064A\u0631 \u0645\u0648\u062C\u0648\u062F\u0629",
    notFoundBody: "\u062A\u0645 \u062D\u0630\u0641 \u0647\u0630\u0647 \u0627\u0644\u0645\u0647\u0645\u0629 \u0623\u0648 \u0644\u0645 \u064A\u0639\u062F \u0628\u0625\u0645\u0643\u0627\u0646\u0643 \u0627\u0644\u0648\u0635\u0648\u0644 \u0625\u0644\u064A\u0647\u0627."
  },
  description: {
    title: "\u0627\u0644\u0648\u0635\u0641",
    edit: "\u062A\u0639\u062F\u064A\u0644 \u0627\u0644\u0648\u0635\u0641",
    editorLabel: "\u0648\u0635\u0641 \u0627\u0644\u0645\u0647\u0645\u0629",
    empty: "\u0644\u0627 \u064A\u0648\u062C\u062F \u0648\u0635\u0641."
  },
  checklist: {
    title: "\u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u0645\u0631\u0627\u062C\u0639\u0629",
    empty: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0639\u0646\u0627\u0635\u0631 \u0628\u0639\u062F.",
    addLabel: "\u0639\u0646\u0635\u0631 \u062C\u062F\u064A\u062F \u0641\u064A \u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u0645\u0631\u0627\u062C\u0639\u0629",
    addPlaceholder: "\u0625\u0636\u0627\u0641\u0629 \u0639\u0646\u0635\u0631",
    add: "\u0625\u0636\u0627\u0641\u0629",
    renameLabel: "\u0627\u0633\u0645 \u0627\u0644\u0639\u0646\u0635\u0631",
    rename: "\u0625\u0639\u0627\u062F\u0629 \u062A\u0633\u0645\u064A\u0629 \xAB{label}\xBB",
    remove: "\u062D\u0630\u0641 \xAB{label}\xBB"
  },
  dependencies: {
    title: "\u0627\u0644\u062A\u0628\u0639\u064A\u0627\u062A",
    empty: "\u0644\u0627 \u062A\u0646\u062A\u0638\u0631 \u0647\u0630\u0647 \u0627\u0644\u0645\u0647\u0645\u0629 \u0623\u064A \u0645\u0647\u0645\u0629 \u0623\u062E\u0631\u0649.",
    addLabel: "\u0645\u0647\u0645\u0629 \u064A\u062C\u0628 \u0625\u0646\u0647\u0627\u0624\u0647\u0627 \u0642\u0628\u0644 \u0647\u0630\u0647 \u0627\u0644\u0645\u0647\u0645\u0629",
    choose: "\u0627\u062E\u062A\u0631 \u0645\u0647\u0645\u0629",
    add: "\u0625\u0636\u0627\u0641\u0629 \u0627\u0644\u062A\u0628\u0639\u064A\u0629",
    remove: "\u0625\u0632\u0627\u0644\u0629 \u0627\u0644\u062A\u0628\u0639\u064A\u0629 \xAB{title}\xBB",
    cycle: "\u0633\u062A\u0646\u0634\u0626 \u0647\u0630\u0647 \u0627\u0644\u062A\u0628\u0639\u064A\u0629 \u062D\u0644\u0642\u0629 \u0645\u063A\u0644\u0642\u0629: \u0644\u0627 \u064A\u0645\u0643\u0646 \u0644\u0645\u0647\u0645\u0629 \u0623\u0646 \u062A\u0646\u062A\u0638\u0631\u060C \u0648\u0644\u0648 \u0628\u0634\u0643\u0644 \u063A\u064A\u0631 \u0645\u0628\u0627\u0634\u0631\u060C \u0645\u0647\u0645\u0629 \u062A\u0646\u062A\u0638\u0631\u0647\u0627."
  },
  subtasks: {
    title: "\u0627\u0644\u0645\u0647\u0627\u0645 \u0627\u0644\u0641\u0631\u0639\u064A\u0629",
    empty: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0645\u0647\u0627\u0645 \u0641\u0631\u0639\u064A\u0629.",
    addLabel: "\u0639\u0646\u0648\u0627\u0646 \u0627\u0644\u0645\u0647\u0645\u0629 \u0627\u0644\u0641\u0631\u0639\u064A\u0629 \u0627\u0644\u062C\u062F\u064A\u062F\u0629",
    addPlaceholder: "\u0625\u0636\u0627\u0641\u0629 \u0645\u0647\u0645\u0629 \u0641\u0631\u0639\u064A\u0629",
    add: "\u0625\u0636\u0627\u0641\u0629"
  },
  comments: {
    title: "\u0627\u0644\u062A\u0639\u0644\u064A\u0642\u0627\u062A",
    empty: "\u0644\u0627 \u062A\u0648\u062C\u062F \u062A\u0639\u0644\u064A\u0642\u0627\u062A \u0628\u0639\u062F.",
    loadFailed: "\u062A\u0639\u0630\u0631 \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u062A\u0639\u0644\u064A\u0642\u0627\u062A.",
    newLabel: "\u062A\u0639\u0644\u064A\u0642 \u062C\u062F\u064A\u062F",
    editLabel: "\u062A\u0639\u062F\u064A\u0644 \u0627\u0644\u062A\u0639\u0644\u064A\u0642",
    mentionHint: "\u0627\u0643\u062A\u0628 @ \u0644\u0644\u0625\u0634\u0627\u0631\u0629 \u0625\u0644\u0649 \u0623\u062D\u062F \u0623\u0639\u0636\u0627\u0621 \u0627\u0644\u0645\u0634\u0631\u0648\u0639.",
    send: "\u0646\u0634\u0631 \u0627\u0644\u062A\u0639\u0644\u064A\u0642",
    edited: "\u0645\u0639\u062F\u0651\u0644",
    edit: "\u062A\u0639\u062F\u064A\u0644",
    delete: "\u062D\u0630\u0641",
    deleteTitle: "\u062D\u0630\u0641 \u062A\u0639\u0644\u064A\u0642 {author}\u061F",
    deleteBody: "\u0633\u064A\u064F\u062D\u0630\u0641 \u0647\u0630\u0627 \u0627\u0644\u062A\u0639\u0644\u064A\u0642 \u0646\u0647\u0627\u0626\u064A\u064B\u0627.",
    stale: "\u062A\u0645 \u062A\u0639\u062F\u064A\u0644 \u0647\u0630\u0627 \u0627\u0644\u062A\u0639\u0644\u064A\u0642 \u0645\u0646 \u0642\u0628\u0644 \u0634\u062E\u0635 \u0622\u062E\u0631. \u0623\u064F\u0639\u064A\u062F \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0642\u0627\u0626\u0645\u0629."
  },
  delete: {
    action: "\u062D\u0630\u0641 \u0627\u0644\u0645\u0647\u0645\u0629",
    title: "\u062D\u0630\u0641 \u0627\u0644\u0645\u0647\u0645\u0629 \xAB{title}\xBB\u061F",
    body: "\u0633\u062A\u064F\u062D\u0630\u0641 \u0627\u0644\u0645\u0647\u0645\u0629 \u0648\u0642\u0627\u0626\u0645\u0629 \u0645\u0631\u0627\u062C\u0639\u062A\u0647\u0627 \u0648\u0645\u0647\u0627\u0645\u0647\u0627 \u0627\u0644\u0641\u0631\u0639\u064A\u0629 \u0648\u062A\u0639\u0644\u064A\u0642\u0627\u062A\u0647\u0627.",
    done: "\u062A\u0645 \u062D\u0630\u0641 \u0627\u0644\u0645\u0647\u0645\u0629 \xAB{title}\xBB."
  },
  guard: {
    title: "\u0627\u0644\u0645\u063A\u0627\u062F\u0631\u0629 \u062F\u0648\u0646 \u062D\u0641\u0638\u061F",
    body: "\u0644\u0645 \u064A\u062A\u0645 \u062D\u0641\u0638 \u0627\u0644\u0648\u0635\u0641 \u0627\u0644\u0645\u0639\u062F\u0651\u0644. \u0625\u0630\u0627 \u063A\u0627\u062F\u0631\u062A \u0641\u0633\u062A\u0641\u0642\u062F \u062A\u063A\u064A\u064A\u0631\u0627\u062A\u0643.",
    stay: "\u0627\u0644\u0628\u0642\u0627\u0621",
    leave: "\u0627\u0644\u0645\u063A\u0627\u062F\u0631\u0629 \u062F\u0648\u0646 \u062D\u0641\u0638"
  },
  noStart: "\u0628\u062F\u0648\u0646 \u062A\u0627\u0631\u064A\u062E \u0628\u062F\u0627\u064A\u0629"
};

// locales/en/tasks.json
var tasks_default2 = {
  newTask: "New task",
  views: {
    label: "Task view",
    list: "List",
    board: "Board"
  },
  filters: {
    label: "Task filters",
    search: "Search for a task",
    searchPlaceholder: "Search by title",
    assignee: "Assignee",
    allAssignees: "All assignees",
    status: "Status",
    allStatuses: "All statuses",
    discipline: "Discipline",
    allDisciplines: "All disciplines",
    phase: "Phase",
    allPhases: "All phases",
    dueBefore: "Due before",
    clear: "Clear filters"
  },
  statuses: {
    todo: "To do",
    in_progress: "In progress",
    blocked: "Blocked",
    done: "Done"
  },
  priorities: {
    low: "Low",
    normal: "Normal",
    high: "High",
    urgent: "Urgent"
  },
  columns: {
    title: "Task",
    status: "Status",
    priority: "Priority",
    assignees: "Assignees",
    phase: "Phase",
    discipline: "Discipline",
    due: "Due",
    checklist: "Checklist"
  },
  fields: {
    title: "Title",
    status: "Status",
    priority: "Priority",
    phase: "Phase",
    discipline: "Discipline",
    due: "Due",
    assignees: "Assignees",
    parent: "Parent task",
    start: "Start"
  },
  noAssignee: "Nobody",
  noPhase: "No phase",
  noDiscipline: "No discipline",
  noDue: "No due date",
  noChecklist: "None",
  overdue: "overdue",
  checklistProgress: "{done} of {total} done",
  list: {
    caption: "Project tasks",
    loadMore: "Show more tasks",
    loadFailedTitle: "The tasks could not be loaded",
    loadFailedBody: "Check your connection and try again.",
    empty: {
      title: "No tasks yet",
      description: "Add the first task of the project to share out the work.",
      descriptionReadOnly: "The tasks of the project will appear here.",
      filteredTitle: "No task matches",
      filteredDescription: "Change or clear the filters to see other tasks."
    }
  },
  board: {
    label: "Task board"
  },
  move: {
    failed: 'The task "{title}" could not be moved: it went back to its place.'
  },
  create: {
    title: "New task",
    submit: "Create task",
    done: 'The task "{title}" was created.',
    noParent: "None (main task)",
    parentHint: "Choose a task to create a subtask. A subtask cannot have subtasks.",
    errors: {
      titleRequired: "Enter a title.",
      titleTooLong: "The title cannot exceed 200 characters.",
      startsAfterDue: "The start date cannot be after the due date."
    }
  },
  panel: {
    title: "Task",
    close: "Close",
    readOnly: "You can view this task but not change it.",
    stale: 'The task "{title}" was changed by someone else. It has been reloaded: apply your change again.',
    loadFailedTitle: "The task could not be loaded",
    loadFailedBody: "Check your connection and try again.",
    notFoundTitle: "Task not found",
    notFoundBody: "This task was deleted or you no longer have access to it."
  },
  description: {
    title: "Description",
    edit: "Edit the description",
    editorLabel: "Task description",
    empty: "No description."
  },
  checklist: {
    title: "Checklist",
    empty: "No items yet.",
    addLabel: "New checklist item",
    addPlaceholder: "Add an item",
    add: "Add",
    renameLabel: "Item name",
    rename: 'Rename "{label}"',
    remove: 'Delete "{label}"'
  },
  dependencies: {
    title: "Dependencies",
    empty: "This task does not wait for any other task.",
    addLabel: "Task to finish before this one",
    choose: "Choose a task",
    add: "Add dependency",
    remove: 'Remove dependency "{title}"',
    cycle: "This dependency would create a loop: a task cannot wait, even indirectly, for a task that waits for it."
  },
  subtasks: {
    title: "Subtasks",
    empty: "No subtasks.",
    addLabel: "Title of the new subtask",
    addPlaceholder: "Add a subtask",
    add: "Add"
  },
  comments: {
    title: "Comments",
    empty: "No comments yet.",
    loadFailed: "The comments could not be loaded.",
    newLabel: "New comment",
    editLabel: "Edit the comment",
    mentionHint: "Type @ to mention a project member.",
    send: "Post comment",
    edited: "edited",
    edit: "Edit",
    delete: "Delete",
    deleteTitle: "Delete the comment by {author}?",
    deleteBody: "This comment will be deleted permanently.",
    stale: "This comment was changed by someone else. The list has been reloaded."
  },
  delete: {
    action: "Delete task",
    title: 'Delete the task "{title}"?',
    body: "The task, its checklist, its subtasks and its comments will be deleted.",
    done: 'The task "{title}" was deleted.'
  },
  guard: {
    title: "Leave without saving?",
    body: "The edited description has not been saved. If you leave, your changes will be lost.",
    stay: "Stay",
    leave: "Leave without saving"
  },
  noStart: "No start date"
};

// locales/fr/tasks.json
var tasks_default3 = {
  newTask: "Nouvelle t\xE2che",
  views: {
    label: "Affichage des t\xE2ches",
    list: "Liste",
    board: "Tableau"
  },
  filters: {
    label: "Filtres des t\xE2ches",
    search: "Rechercher une t\xE2che",
    searchPlaceholder: "Rechercher par titre",
    assignee: "Responsable",
    allAssignees: "Tous les responsables",
    status: "Statut",
    allStatuses: "Tous les statuts",
    discipline: "Discipline",
    allDisciplines: "Toutes les disciplines",
    phase: "Phase",
    allPhases: "Toutes les phases",
    dueBefore: "\xC9ch\xE9ance avant le",
    clear: "Effacer les filtres"
  },
  statuses: {
    todo: "\xC0 faire",
    in_progress: "En cours",
    blocked: "Bloqu\xE9e",
    done: "Termin\xE9e"
  },
  priorities: {
    low: "Basse",
    normal: "Normale",
    high: "Haute",
    urgent: "Urgente"
  },
  columns: {
    title: "T\xE2che",
    status: "Statut",
    priority: "Priorit\xE9",
    assignees: "Responsables",
    phase: "Phase",
    discipline: "Discipline",
    due: "\xC9ch\xE9ance",
    checklist: "Liste de contr\xF4le"
  },
  fields: {
    title: "Titre",
    status: "Statut",
    priority: "Priorit\xE9",
    phase: "Phase",
    discipline: "Discipline",
    due: "\xC9ch\xE9ance",
    assignees: "Responsables",
    parent: "T\xE2che parente",
    start: "D\xE9but"
  },
  noAssignee: "Personne",
  noPhase: "Aucune phase",
  noDiscipline: "Aucune discipline",
  noDue: "Sans \xE9ch\xE9ance",
  noChecklist: "Aucune",
  overdue: "en retard",
  checklistProgress: "{done} sur {total} termin\xE9s",
  list: {
    caption: "T\xE2ches du projet",
    loadMore: "Afficher plus de t\xE2ches",
    loadFailedTitle: "Impossible de charger les t\xE2ches",
    loadFailedBody: "V\xE9rifiez votre connexion puis r\xE9essayez.",
    empty: {
      title: "Aucune t\xE2che pour le moment",
      description: "Ajoutez la premi\xE8re t\xE2che du projet pour r\xE9partir le travail.",
      descriptionReadOnly: "Les t\xE2ches du projet appara\xEEtront ici.",
      filteredTitle: "Aucune t\xE2che ne correspond",
      filteredDescription: "Modifiez ou effacez les filtres pour voir d'autres t\xE2ches."
    }
  },
  board: {
    label: "Tableau des t\xE2ches"
  },
  move: {
    failed: "La t\xE2che \xAB\xA0{title}\xA0\xBB n'a pas pu \xEAtre d\xE9plac\xE9e\xA0: elle est revenue \xE0 sa place."
  },
  create: {
    title: "Nouvelle t\xE2che",
    submit: "Cr\xE9er la t\xE2che",
    done: "La t\xE2che \xAB\xA0{title}\xA0\xBB a \xE9t\xE9 cr\xE9\xE9e.",
    noParent: "Aucune (t\xE2che principale)",
    parentHint: "Choisissez une t\xE2che pour cr\xE9er une sous-t\xE2che. Une sous-t\xE2che n'a pas de sous-t\xE2ches.",
    errors: {
      titleRequired: "Saisissez un titre.",
      titleTooLong: "Le titre ne peut pas d\xE9passer 200 caract\xE8res.",
      startsAfterDue: "La date de d\xE9but ne peut pas suivre l\u2019\xE9ch\xE9ance."
    }
  },
  panel: {
    title: "T\xE2che",
    close: "Fermer",
    readOnly: "Vous pouvez consulter cette t\xE2che mais pas la modifier.",
    stale: "La t\xE2che \xAB\xA0{title}\xA0\xBB a \xE9t\xE9 modifi\xE9e par quelqu'un d'autre. Elle a \xE9t\xE9 recharg\xE9e\xA0: appliquez de nouveau votre changement.",
    loadFailedTitle: "Impossible de charger la t\xE2che",
    loadFailedBody: "V\xE9rifiez votre connexion puis r\xE9essayez.",
    notFoundTitle: "T\xE2che introuvable",
    notFoundBody: "Cette t\xE2che a \xE9t\xE9 supprim\xE9e ou vous n'y avez plus acc\xE8s."
  },
  description: {
    title: "Description",
    edit: "Modifier la description",
    editorLabel: "Description de la t\xE2che",
    empty: "Aucune description."
  },
  checklist: {
    title: "Liste de contr\xF4le",
    empty: "Aucun \xE9l\xE9ment pour le moment.",
    addLabel: "Nouvel \xE9l\xE9ment de la liste de contr\xF4le",
    addPlaceholder: "Ajouter un \xE9l\xE9ment",
    add: "Ajouter",
    renameLabel: "Nom de l'\xE9l\xE9ment",
    rename: "Renommer \xAB\xA0{label}\xA0\xBB",
    remove: "Supprimer \xAB\xA0{label}\xA0\xBB"
  },
  dependencies: {
    title: "D\xE9pendances",
    empty: "Cette t\xE2che n'attend aucune autre t\xE2che.",
    addLabel: "T\xE2che \xE0 terminer avant celle-ci",
    choose: "Choisir une t\xE2che",
    add: "Ajouter la d\xE9pendance",
    remove: "Retirer la d\xE9pendance \xAB\xA0{title}\xA0\xBB",
    cycle: "Cette d\xE9pendance cr\xE9erait une boucle\xA0: une t\xE2che ne peut pas attendre, m\xEAme indirectement, une t\xE2che qui l'attend."
  },
  subtasks: {
    title: "Sous-t\xE2ches",
    empty: "Aucune sous-t\xE2che.",
    addLabel: "Titre de la nouvelle sous-t\xE2che",
    addPlaceholder: "Ajouter une sous-t\xE2che",
    add: "Ajouter"
  },
  comments: {
    title: "Commentaires",
    empty: "Aucun commentaire pour le moment.",
    loadFailed: "Impossible de charger les commentaires.",
    newLabel: "Nouveau commentaire",
    editLabel: "Modifier le commentaire",
    mentionHint: "Tapez @ pour mentionner un membre du projet.",
    send: "Publier le commentaire",
    edited: "modifi\xE9",
    edit: "Modifier",
    delete: "Supprimer",
    deleteTitle: "Supprimer le commentaire de\xA0{author}\xA0?",
    deleteBody: "Ce commentaire sera supprim\xE9 d\xE9finitivement.",
    stale: "Ce commentaire a \xE9t\xE9 modifi\xE9 par quelqu'un d'autre. La liste a \xE9t\xE9 recharg\xE9e."
  },
  delete: {
    action: "Supprimer la t\xE2che",
    title: "Supprimer la t\xE2che \xAB\xA0{title}\xA0\xBB\xA0?",
    body: "La t\xE2che, sa liste de contr\xF4le, ses sous-t\xE2ches et ses commentaires seront supprim\xE9s.",
    done: "La t\xE2che \xAB\xA0{title}\xA0\xBB a \xE9t\xE9 supprim\xE9e."
  },
  guard: {
    title: "Quitter sans enregistrer\xA0?",
    body: "La description modifi\xE9e n'a pas \xE9t\xE9 enregistr\xE9e. Si vous quittez, vos changements seront perdus.",
    stay: "Rester",
    leave: "Quitter sans enregistrer"
  },
  noStart: "Aucun d\xE9but"
};

// locales/ar/projects.json
var projects_default = {
  title: "\u0627\u0644\u0645\u0634\u0627\u0631\u064A\u0639",
  none: "\u2014",
  orgTemplates: {
    title: "\u0646\u0645\u0627\u0630\u062C \u0627\u0644\u0645\u0634\u0627\u0631\u064A\u0639",
    intro: "\u062A\u062D\u062F\u0651\u062F \u0646\u0645\u0627\u0630\u062C \u0627\u0644\u0645\u0643\u062A\u0628 \u0627\u0644\u0628\u0646\u064A\u0629 \u0627\u0644\u062A\u064A \u062A\u0646\u0637\u0644\u0642 \u0645\u0646\u0647\u0627 \u0645\u0634\u0627\u0631\u064A\u0639\u0643\u0645: \u0627\u0644\u0645\u0631\u0627\u062D\u0644 \u0648\u0627\u0644\u0645\u062C\u0644\u062F\u0627\u062A \u0648\u0642\u0646\u0648\u0627\u062A \u0627\u0644\u0646\u0642\u0627\u0634 \u0648\u0645\u0647\u0627\u0645 \u0627\u0644\u0627\u0646\u0637\u0644\u0627\u0642. \u0644\u0627 \u062A\u064F\u062D\u0641\u0638 \u0641\u064A\u0647\u0627 \u0623\u064A \u0648\u062B\u064A\u0642\u0629 \u0623\u0648 \u0634\u062E\u0635 \u0623\u0648 \u062A\u0627\u0631\u064A\u062E.",
    new: "\u0646\u0645\u0648\u0630\u062C \u062C\u062F\u064A\u062F",
    showArchived: "\u0625\u0638\u0647\u0627\u0631 \u0627\u0644\u0646\u0645\u0627\u0630\u062C \u0627\u0644\u0645\u0624\u0631\u0634\u0641\u0629",
    loadFailed: "\u062A\u0639\u0630\u0651\u0631 \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0646\u0645\u0627\u0630\u062C. \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629 \u0628\u0639\u062F \u0642\u0644\u064A\u0644.",
    caption: "\u0646\u0645\u0627\u0630\u062C \u0645\u0634\u0627\u0631\u064A\u0639 \u0627\u0644\u0645\u0643\u062A\u0628",
    columns: {
      name: "\u0627\u0644\u0646\u0645\u0648\u0630\u062C",
      content: "\u0627\u0644\u0645\u062D\u062A\u0648\u0649",
      author: "\u0627\u0644\u0645\u0624\u0644\u0641",
      updated: "\u0622\u062E\u0631 \u062A\u0639\u062F\u064A\u0644",
      actions: "\u0627\u0644\u0625\u062C\u0631\u0627\u0621\u0627\u062A"
    },
    archivedBadge: "\u0645\u0624\u0631\u0634\u0641",
    summary: "{phases, plural, one {\u0645\u0631\u062D\u0644\u0629 \u0648\u0627\u062D\u062F\u0629} two {\u0645\u0631\u062D\u0644\u062A\u0627\u0646} few {# \u0645\u0631\u0627\u062D\u0644} many {# \u0645\u0631\u062D\u0644\u0629} other {# \u0645\u0631\u062D\u0644\u0629}} \xB7 {folders, plural, one {\u0645\u062C\u0644\u062F \u0648\u0627\u062D\u062F} two {\u0645\u062C\u0644\u062F\u0627\u0646} few {# \u0645\u062C\u0644\u062F\u0627\u062A} many {# \u0645\u062C\u0644\u062F\u064B\u0627} other {# \u0645\u062C\u0644\u062F}} \xB7 {channels, plural, one {\u0642\u0646\u0627\u0629 \u0648\u0627\u062D\u062F\u0629} two {\u0642\u0646\u0627\u062A\u0627\u0646} few {# \u0642\u0646\u0648\u0627\u062A} many {# \u0642\u0646\u0627\u0629} other {# \u0642\u0646\u0627\u0629}} \xB7 {tasks, plural, one {\u0645\u0647\u0645\u0629 \u0648\u0627\u062D\u062F\u0629} two {\u0645\u0647\u0645\u062A\u0627\u0646} few {# \u0645\u0647\u0627\u0645} many {# \u0645\u0647\u0645\u0629} other {# \u0645\u0647\u0645\u0629}}",
    empty: {
      title: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0646\u0645\u0627\u0630\u062C \u0628\u0639\u062F",
      body: "\u0627\u0643\u062A\u0628\u0648\u0627 \u0646\u0645\u0648\u0630\u062C\u064B\u0627\u060C \u0623\u0648 \u0627\u062D\u0641\u0638\u0648\u0627 \u0645\u0634\u0631\u0648\u0639\u064B\u0627 \u0642\u0627\u0626\u0645\u064B\u0627 \u0643\u0646\u0645\u0648\u0630\u062C \u0645\u0646 \u0625\u0639\u062F\u0627\u062F\u0627\u062A\u0647."
    },
    emptyArchived: {
      title: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0646\u0645\u0627\u0630\u062C \u0645\u0624\u0631\u0634\u0641\u0629",
      body: "\u0627\u0644\u0646\u0645\u0627\u0630\u062C \u0627\u0644\u062A\u064A \u062A\u0624\u0631\u0634\u0641\u0648\u0646\u0647\u0627 \u0644\u0627 \u062A\u064F\u0642\u062A\u0631\u062D \u0639\u0646\u062F \u0625\u0646\u0634\u0627\u0621 \u0645\u0634\u0631\u0648\u0639\u061B \u0648\u062A\u0628\u0642\u0649 \u0645\u062D\u0641\u0648\u0638\u0629 \u0647\u0646\u0627."
    },
    actions: {
      edit: "\u062A\u0639\u062F\u064A\u0644 \u0627\u0644\u0646\u0645\u0648\u0630\u062C {name}",
      editShort: "\u062A\u0639\u062F\u064A\u0644",
      archive: "\u0623\u0631\u0634\u0641\u0629 \u0627\u0644\u0646\u0645\u0648\u0630\u062C {name}",
      archiveShort: "\u0623\u0631\u0634\u0641\u0629",
      restore: "\u0627\u0633\u062A\u0639\u0627\u062F\u0629 \u0627\u0644\u0646\u0645\u0648\u0630\u062C {name}",
      restoreShort: "\u0627\u0633\u062A\u0639\u0627\u062F\u0629",
      delete: "\u062D\u0630\u0641 \u0627\u0644\u0646\u0645\u0648\u0630\u062C {name}",
      deleteShort: "\u062D\u0630\u0641",
      authorOnly: "\u064A\u0642\u062A\u0635\u0631 \u0639\u0644\u0649 \u0645\u0624\u0644\u0641\u0647 \u0648\u0627\u0644\u0645\u0633\u0624\u0648\u0644\u064A\u0646"
    },
    archive: {
      done: "\u062A\u0645\u062A \u0623\u0631\u0634\u0641\u0629 \u0627\u0644\u0646\u0645\u0648\u0630\u062C \xAB{name}\xBB: \u0644\u0645 \u064A\u0639\u062F \u0645\u0642\u062A\u0631\u062D\u064B\u0627 \u0639\u0646\u062F \u0625\u0646\u0634\u0627\u0621 \u0645\u0634\u0631\u0648\u0639."
    },
    restore: {
      done: "\u0627\u0644\u0646\u0645\u0648\u0630\u062C \xAB{name}\xBB \u0645\u0642\u062A\u0631\u062D \u0645\u0646 \u062C\u062F\u064A\u062F \u0639\u0646\u062F \u0625\u0646\u0634\u0627\u0621 \u0645\u0634\u0631\u0648\u0639."
    },
    delete: {
      title: "\u062D\u0630\u0641 \u0627\u0644\u0646\u0645\u0648\u0630\u062C \xAB{name}\xBB\u061F",
      body: "\u0644\u0627 \u062A\u062A\u063A\u064A\u0651\u0631 \u0627\u0644\u0645\u0634\u0627\u0631\u064A\u0639 \u0627\u0644\u0645\u0646\u0634\u0623\u0629 \u0628\u0647\u0630\u0627 \u0627\u0644\u0646\u0645\u0648\u0630\u062C \u0633\u0627\u0628\u0642\u064B\u0627. \u0647\u0630\u0627 \u0627\u0644\u0625\u062C\u0631\u0627\u0621 \u0646\u0647\u0627\u0626\u064A\u061B \u0648\u0644\u0644\u0627\u062D\u062A\u0641\u0627\u0638 \u0628\u0647 \u062F\u0648\u0646 \u0627\u0642\u062A\u0631\u0627\u062D\u0647 \u0623\u0631\u0634\u0641\u0648\u0647 \u0628\u062F\u0644\u064B\u0627 \u0645\u0646 \u0630\u0644\u0643.",
      confirm: "\u062D\u0630\u0641 \u0627\u0644\u0646\u0645\u0648\u0630\u062C",
      done: "\u062A\u0645 \u062D\u0630\u0641 \u0627\u0644\u0646\u0645\u0648\u0630\u062C \xAB{name}\xBB."
    },
    stale: "\u0639\u062F\u0651\u0644 \u0634\u062E\u0635 \u0622\u062E\u0631 \u0647\u0630\u0627 \u0627\u0644\u0646\u0645\u0648\u0630\u062C. \u0623\u0639\u062F \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0642\u0627\u0626\u0645\u0629 \u062B\u0645 \u0637\u0628\u0651\u0642 \u062A\u063A\u064A\u064A\u0631\u0627\u062A\u0643 \u0645\u0646 \u062C\u062F\u064A\u062F.",
    saved: "\u062A\u0645 \u062D\u0641\u0638 \u0627\u0644\u0646\u0645\u0648\u0630\u062C \xAB{name}\xBB.",
    created: "\u062A\u0645 \u0625\u0646\u0634\u0627\u0621 \u0627\u0644\u0646\u0645\u0648\u0630\u062C \xAB{name}\xBB.",
    editor: {
      formLabel: "\u0646\u0645\u0648\u0630\u062C \u0645\u0634\u0631\u0648\u0639",
      newTitle: "\u0646\u0645\u0648\u0630\u062C \u0645\u0634\u0631\u0648\u0639 \u062C\u062F\u064A\u062F",
      editTitle: "\u062A\u0639\u062F\u064A\u0644 \u0627\u0644\u0646\u0645\u0648\u0630\u062C \xAB{name}\xBB",
      intro: "\u0635\u0650\u0641 \u0645\u0627 \u064A\u062D\u062A\u0648\u064A\u0647 \u0627\u0644\u0645\u0634\u0631\u0648\u0639 \u0627\u0644\u062C\u062F\u064A\u062F \u0639\u0646\u062F \u0627\u0646\u0637\u0644\u0627\u0642\u0647. \u0627\u0644\u062D\u0642\u0648\u0644 \u0627\u0644\u0645\u0639\u0644\u064E\u0651\u0645\u0629 \u0628\u0646\u062C\u0645\u0629 \u0625\u0644\u0632\u0627\u0645\u064A\u0629.",
      name: "\u0627\u0633\u0645 \u0627\u0644\u0646\u0645\u0648\u0630\u062C",
      description: "\u0627\u0644\u0648\u0635\u0641",
      descriptionHint: "\u0627\u062E\u062A\u064A\u0627\u0631\u064A\u060C \u2066{max}\u2069 \u062D\u0631\u0641 \u0639\u0644\u0649 \u0627\u0644\u0623\u0643\u062B\u0631. \u0644\u0627 \u064A\u064F\u0642\u0628\u0644 < \u0648\u0644\u0627 >.",
      structureLocked: "\u062D\u0635\u0635 \u0627\u0644\u0623\u062A\u0639\u0627\u0628 \u0645\u062E\u0635\u0635\u0629 \u0644\u0645\u0646 \u064A\u062D\u0642 \u0644\u0647 \u0627\u0644\u0627\u0637\u0644\u0627\u0639 \u0639\u0644\u0649 \u0627\u0644\u0623\u062A\u0639\u0627\u0628: \u064A\u0645\u0643\u0646\u0643 \u062A\u063A\u064A\u064A\u0631 \u0627\u0644\u0627\u0633\u0645 \u0648\u0627\u0644\u0648\u0635\u0641 \u062F\u0648\u0646 \u0628\u0646\u064A\u0629 \u0647\u0630\u0627 \u0627\u0644\u0646\u0645\u0648\u0630\u062C.",
      save: "\u062D\u0641\u0638 \u0627\u0644\u0646\u0645\u0648\u0630\u062C",
      saving: "\u062C\u0627\u0631\u064D \u0627\u0644\u062D\u0641\u0638\u2026"
    },
    phases: {
      title: "\u0627\u0644\u0645\u0631\u0627\u062D\u0644",
      count: "\u2066{count}\u2069 \u0645\u0646 \u2066{max}\u2069",
      hint: "\u064A\u0645\u0643\u0646 \u0627\u0633\u062A\u0639\u0645\u0627\u0644 \u0643\u0644 \u0645\u0631\u062D\u0644\u0629 \u0642\u064A\u0627\u0633\u064A\u0629 \u0645\u0631\u0629 \u0648\u0627\u062D\u062F\u0629. \u0623\u0636\u0641 \u0645\u0631\u0627\u062D\u0644 \u0645\u062E\u0635\u0635\u0629 \u0644\u0645\u0627 \u062A\u0628\u0642\u0649.",
      total: "\u0645\u062C\u0645\u0648\u0639 \u0627\u0644\u0623\u062A\u0639\u0627\u0628: \u2066{total}\u2069 \u0645\u0646 100 %",
      totalOver: "\u0627\u0644\u0645\u062C\u0645\u0648\u0639 \u064A\u062A\u062C\u0627\u0648\u0632 100 %",
      noFees: "\u0644\u064A\u0633 \u0644\u062F\u064A\u0643 \u0635\u0644\u0627\u062D\u064A\u0629 \u0627\u0644\u0627\u0637\u0644\u0627\u0639 \u0639\u0644\u0649 \u0627\u0644\u0623\u062A\u0639\u0627\u0628: \u0644\u0627 \u062A\u064F\u0639\u0631\u0636 \u0627\u0644\u062D\u0635\u0635 \u0648\u0644\u0627 \u062A\u064F\u062D\u0641\u0638.",
      position: "\u0627\u0644\u0645\u0631\u062D\u0644\u0629 \u2066{position}\u2069",
      moveUp: "\u0631\u0641\u0639 \u0627\u0644\u0645\u0631\u062D\u0644\u0629 \u2066{position}\u2069",
      moveDown: "\u0625\u0646\u0632\u0627\u0644 \u0627\u0644\u0645\u0631\u062D\u0644\u0629 \u2066{position}\u2069",
      remove: "\u0625\u0632\u0627\u0644\u0629 \u0627\u0644\u0645\u0631\u062D\u0644\u0629 \u2066{position}\u2069",
      type: "\u0646\u0648\u0639 \u0627\u0644\u0645\u0631\u062D\u0644\u0629",
      customName: "\u0627\u0633\u0645 \u0627\u0644\u0645\u0631\u062D\u0644\u0629",
      nameOptional: "\u0627\u0644\u0627\u0633\u0645 \u0627\u0644\u0645\u0639\u0631\u0648\u0636 (\u0627\u062E\u062A\u064A\u0627\u0631\u064A)",
      share: "\u062D\u0635\u0629 \u0627\u0644\u0623\u062A\u0639\u0627\u0628 (%)",
      shareHint: "\u0645\u062B\u0627\u0644 12.5. \u0644\u0627 \u064A\u062A\u062C\u0627\u0648\u0632 \u0627\u0644\u0645\u062C\u0645\u0648\u0639 100 %.",
      days: "\u0645\u062F\u0629 \u0627\u0644\u0639\u0642\u062F (\u0628\u0627\u0644\u0623\u064A\u0627\u0645)",
      daysHint: "\u0627\u062E\u062A\u064A\u0627\u0631\u064A\u060C \u0628\u064A\u0646 1 \u06483650.",
      add: "\u0625\u0636\u0627\u0641\u0629 \u0645\u0631\u062D\u0644\u0629"
    },
    folders: {
      title: "\u0627\u0644\u0645\u062C\u0644\u062F\u0627\u062A",
      count: "\u2066{count}\u2069 \u0645\u0646 \u2066{max}\u2069",
      hint: "\u062D\u062A\u0649 \u2066{depth}\u2069 \u0645\u0633\u062A\u0648\u064A\u0627\u062A. \u0627\u0633\u062A\u0639\u0645\u0644 \u0632\u0631 \xAB\u0645\u062C\u0644\u062F \u0641\u0631\u0639\u064A\xBB \u0641\u064A \u0623\u064A \u0633\u0637\u0631 \u0644\u0644\u062A\u062F\u0627\u062E\u0644.",
      empty: "\u0644\u0627 \u0645\u062C\u0644\u062F\u0627\u062A: \u0633\u064A\u0646\u0637\u0644\u0642 \u0627\u0644\u0645\u0634\u0631\u0648\u0639 \u062F\u0648\u0646 \u0634\u062C\u0631\u0629 \u0645\u062C\u0644\u062F\u0627\u062A.",
      name: "\u0627\u0633\u0645 \u0627\u0644\u0645\u062C\u0644\u062F (\u0627\u0644\u0645\u0633\u062A\u0648\u0649 \u2066{level}\u2069)",
      unnamed: "(\u0628\u0644\u0627 \u0627\u0633\u0645)",
      moveUp: "\u0631\u0641\u0639 \u0627\u0644\u0645\u062C\u0644\u062F {name}",
      moveDown: "\u0625\u0646\u0632\u0627\u0644 \u0627\u0644\u0645\u062C\u0644\u062F {name}",
      remove: "\u0625\u0632\u0627\u0644\u0629 \u0627\u0644\u0645\u062C\u0644\u062F {name} \u0648\u0645\u062D\u062A\u0648\u0627\u0647",
      addChild: "\u0625\u0636\u0627\u0641\u0629 \u0645\u062C\u0644\u062F \u0641\u0631\u0639\u064A \u062F\u0627\u062E\u0644 {name}",
      add: "\u0625\u0636\u0627\u0641\u0629 \u0645\u062C\u0644\u062F"
    },
    channels: {
      title: "\u0642\u0646\u0648\u0627\u062A \u0627\u0644\u0646\u0642\u0627\u0634",
      count: "\u2066{count}\u2069 \u0645\u0646 \u2066{max}\u2069",
      hint: "\u0642\u0646\u0627\u0629 \u0639\u0627\u0645\u0629 \u0644\u0644\u062C\u0645\u064A\u0639\u060C \u0623\u0648 \u0642\u0646\u0627\u0629 \u0645\u062E\u0635\u0635\u0629 \u0644\u0627\u062E\u062A\u0635\u0627\u0635 \u0648\u0627\u062D\u062F.",
      empty: "\u0644\u0627 \u0642\u0646\u0648\u0627\u062A: \u0633\u064A\u0646\u0637\u0644\u0642 \u0627\u0644\u0645\u0634\u0631\u0648\u0639 \u062F\u0648\u0646 \u0646\u0642\u0627\u0634\u0627\u062A.",
      unnamed: "(\u0628\u0644\u0627 \u0627\u0633\u0645)",
      name: "\u0627\u0633\u0645 \u0627\u0644\u0642\u0646\u0627\u0629",
      kind: "\u0646\u0648\u0639 \u0627\u0644\u0642\u0646\u0627\u0629",
      kinds: {
        general: "\u0639\u0627\u0645\u0629",
        discipline: "\u062D\u0633\u0628 \u0627\u0644\u0627\u062E\u062A\u0635\u0627\u0635"
      },
      discipline: "\u0627\u0644\u0627\u062E\u062A\u0635\u0627\u0635",
      disciplineChoose: "\u0627\u062E\u062A\u0631 \u0627\u062E\u062A\u0635\u0627\u0635\u064B\u0627",
      moveUp: "\u0631\u0641\u0639 \u0627\u0644\u0642\u0646\u0627\u0629 {name}",
      moveDown: "\u0625\u0646\u0632\u0627\u0644 \u0627\u0644\u0642\u0646\u0627\u0629 {name}",
      remove: "\u0625\u0632\u0627\u0644\u0629 \u0627\u0644\u0642\u0646\u0627\u0629 {name}",
      add: "\u0625\u0636\u0627\u0641\u0629 \u0642\u0646\u0627\u0629"
    },
    tasks: {
      title: "\u0645\u0647\u0627\u0645 \u0627\u0644\u0627\u0646\u0637\u0644\u0627\u0642",
      count: "\u2066{count}\u2069 \u0645\u0646 \u2066{max}\u2069",
      hint: "\u064A\u0645\u0643\u0646 \u0631\u0628\u0637 \u0643\u0644 \u0645\u0647\u0645\u0629 \u0628\u0645\u0631\u062D\u0644\u0629 \u0645\u0646 \u0627\u0644\u0646\u0645\u0648\u0630\u062C \u0648\u0625\u0631\u0641\u0627\u0642\u0647\u0627 \u0628\u0642\u0627\u0626\u0645\u0629 \u062A\u062D\u0642\u0642.",
      empty: "\u0644\u0627 \u0645\u0647\u0627\u0645: \u0633\u064A\u0646\u0637\u0644\u0642 \u0627\u0644\u0645\u0634\u0631\u0648\u0639 \u062F\u0648\u0646 \u0645\u0647\u0627\u0645.",
      unnamed: "(\u0628\u0644\u0627 \u0639\u0646\u0648\u0627\u0646)",
      taskTitle: "\u0639\u0646\u0648\u0627\u0646 \u0627\u0644\u0645\u0647\u0645\u0629",
      phase: "\u0627\u0644\u0645\u0631\u062D\u0644\u0629",
      phaseNone: "\u0628\u0644\u0627 \u0645\u0631\u062D\u0644\u0629",
      discipline: "\u0627\u0644\u0627\u062E\u062A\u0635\u0627\u0635",
      disciplineNone: "\u0628\u0644\u0627 \u0627\u062E\u062A\u0635\u0627\u0635",
      moveUp: "\u0631\u0641\u0639 \u0627\u0644\u0645\u0647\u0645\u0629 {title}",
      moveDown: "\u0625\u0646\u0632\u0627\u0644 \u0627\u0644\u0645\u0647\u0645\u0629 {title}",
      remove: "\u0625\u0632\u0627\u0644\u0629 \u0627\u0644\u0645\u0647\u0645\u0629 {title}",
      checklist: "\u0642\u0627\u0626\u0645\u0629 \u062A\u062D\u0642\u0642 \u0627\u0644\u0645\u0647\u0645\u0629 {title}",
      checklistCount: "\u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u062A\u062D\u0642\u0642: \u2066{count}\u2069 \u0645\u0646 \u2066{max}\u2069",
      checkItem: "\u0627\u0644\u0628\u0646\u062F \u2066{position}\u2069 \u0645\u0646 \u0627\u0644\u0645\u0647\u0645\u0629 {title}",
      checkMoveUp: "\u0631\u0641\u0639 \u0627\u0644\u0628\u0646\u062F \u2066{position}\u2069 \u0645\u0646 \u0627\u0644\u0645\u0647\u0645\u0629 {title}",
      checkMoveDown: "\u0625\u0646\u0632\u0627\u0644 \u0627\u0644\u0628\u0646\u062F \u2066{position}\u2069 \u0645\u0646 \u0627\u0644\u0645\u0647\u0645\u0629 {title}",
      checkRemove: "\u0625\u0632\u0627\u0644\u0629 \u0627\u0644\u0628\u0646\u062F \u2066{position}\u2069 \u0645\u0646 \u0627\u0644\u0645\u0647\u0645\u0629 {title}",
      checkAddFor: "\u0625\u0636\u0627\u0641\u0629 \u0628\u0646\u062F \u0625\u0644\u0649 \u0627\u0644\u0645\u0647\u0645\u0629 {title}",
      checkAdd: "\u0625\u0636\u0627\u0641\u0629 \u0628\u0646\u062F",
      add: "\u0625\u0636\u0627\u0641\u0629 \u0645\u0647\u0645\u0629"
    },
    errors: {
      summary: "{count, plural, one {\u062D\u0642\u0644 \u0648\u0627\u062D\u062F \u064A\u062D\u062A\u0627\u062C \u0625\u0644\u0649 \u062A\u0635\u062D\u064A\u062D.} two {\u062D\u0642\u0644\u0627\u0646 \u064A\u062D\u062A\u0627\u062C\u0627\u0646 \u0625\u0644\u0649 \u062A\u0635\u062D\u064A\u062D.} few {# \u062D\u0642\u0648\u0644 \u062A\u062D\u062A\u0627\u062C \u0625\u0644\u0649 \u062A\u0635\u062D\u064A\u062D.} many {# \u062D\u0642\u0644\u064B\u0627 \u064A\u062D\u062A\u0627\u062C \u0625\u0644\u0649 \u062A\u0635\u062D\u064A\u062D.} other {# \u062D\u0642\u0644 \u064A\u062D\u062A\u0627\u062C \u0625\u0644\u0649 \u062A\u0635\u062D\u064A\u062D.}}",
      required: "\u0647\u0630\u0627 \u0627\u0644\u062D\u0642\u0644 \u0625\u0644\u0632\u0627\u0645\u064A.",
      tooLong: "\u2066{max}\u2069 \u062D\u0631\u0641 \u0639\u0644\u0649 \u0627\u0644\u0623\u0643\u062B\u0631.",
      plain: "\u0627\u0633\u062A\u0639\u0645\u0644 \u0646\u0635\u064B\u0627 \u0639\u0627\u062F\u064A\u064B\u0627 \u062F\u0648\u0646 < \u0623\u0648 >.",
      folderName: "\u0644\u0627 \u064A\u062D\u062A\u0648\u064A \u0627\u0633\u0645 \u0627\u0644\u0645\u062C\u0644\u062F \u0639\u0644\u0649 / \u0623\u0648 \\ \u0648\u0644\u0627 \u064A\u0628\u062F\u0623 \u0628\u0646\u0642\u0637\u0629.",
      folderRepeated: "\u0644\u0627 \u064A\u0645\u0643\u0646 \u0644\u0645\u062C\u0644\u062F\u064A\u0646 \u0641\u064A \u0627\u0644\u0645\u0633\u062A\u0648\u0649 \u0646\u0641\u0633\u0647 \u0623\u0646 \u064A\u062D\u0645\u0644\u0627 \u0627\u0644\u0627\u0633\u0645 \u0646\u0641\u0633\u0647.",
      foldersPerLevel: "\u064A\u062D\u062A\u0648\u064A \u0627\u0644\u0645\u0633\u062A\u0648\u0649 \u0627\u0644\u0648\u0627\u062D\u062F \u0639\u0644\u0649 \u2066{max}\u2069 \u0645\u062C\u0644\u062F\u064B\u0627 \u0639\u0644\u0649 \u0627\u0644\u0623\u0643\u062B\u0631.",
      foldersMax: "\u064A\u062D\u062A\u0648\u064A \u0627\u0644\u0646\u0645\u0648\u0630\u062C \u0639\u0644\u0649 \u2066{max}\u2069 \u0645\u062C\u0644\u062F \u0639\u0644\u0649 \u0627\u0644\u0623\u0643\u062B\u0631.",
      foldersDepth: "\u062A\u062A\u062F\u0627\u062E\u0644 \u0627\u0644\u0645\u062C\u0644\u062F\u0627\u062A \u0639\u0644\u0649 \u2066{max}\u2069 \u0645\u0633\u062A\u0648\u064A\u0627\u062A \u0639\u0644\u0649 \u0627\u0644\u0623\u0643\u062B\u0631.",
      phasesNone: "\u0623\u0636\u0641 \u0645\u0631\u062D\u0644\u0629 \u0648\u0627\u062D\u062F\u0629 \u0639\u0644\u0649 \u0627\u0644\u0623\u0642\u0644.",
      phasesMax: "\u064A\u062D\u062A\u0648\u064A \u0627\u0644\u0646\u0645\u0648\u0630\u062C \u0639\u0644\u0649 \u2066{max}\u2069 \u0645\u0631\u062D\u0644\u0629 \u0639\u0644\u0649 \u0627\u0644\u0623\u0643\u062B\u0631.",
      phaseRepeated: "\u0647\u0630\u0647 \u0627\u0644\u0645\u0631\u062D\u0644\u0629 \u0645\u0648\u062C\u0648\u062F\u0629 \u0641\u064A \u0627\u0644\u0646\u0645\u0648\u0630\u062C. \u0627\u062E\u062A\u0631 \u0646\u0648\u0639\u064B\u0627 \u0622\u062E\u0631 \u0623\u0648 \u0645\u0631\u062D\u0644\u0629 \u0645\u062E\u0635\u0635\u0629.",
      customName: "\u0623\u0639\u0637\u0650 \u0647\u0630\u0647 \u0627\u0644\u0645\u0631\u062D\u0644\u0629 \u0627\u0644\u0645\u062E\u0635\u0635\u0629 \u0627\u0633\u0645\u064B\u0627.",
      share: "\u0623\u062F\u062E\u0644 \u0646\u0633\u0628\u0629 \u0628\u064A\u0646 0 \u0648100 \u0628\u062E\u0627\u0646\u062A\u064A\u0646 \u0639\u0634\u0631\u064A\u062A\u064A\u0646 \u0639\u0644\u0649 \u0627\u0644\u0623\u0643\u062B\u0631.",
      shareTotal: "\u064A\u062A\u062C\u0627\u0648\u0632 \u0645\u062C\u0645\u0648\u0639 \u062D\u0635\u0635 \u0627\u0644\u0623\u062A\u0639\u0627\u0628 100 %. \u062E\u0641\u0651\u0636 \u0628\u0639\u0636 \u0627\u0644\u062D\u0635\u0635.",
      days: "\u0623\u062F\u062E\u0644 \u0639\u062F\u062F\u064B\u0627 \u0635\u062D\u064A\u062D\u064B\u0627 \u0645\u0646 \u0627\u0644\u0623\u064A\u0627\u0645 \u0628\u064A\u0646 1 \u0648\u2066{max}\u2069.",
      channelsMax: "\u064A\u062D\u062A\u0648\u064A \u0627\u0644\u0646\u0645\u0648\u0630\u062C \u0639\u0644\u0649 \u2066{max}\u2069 \u0642\u0646\u0627\u0629 \u0639\u0644\u0649 \u0627\u0644\u0623\u0643\u062B\u0631.",
      channelDiscipline: "\u0627\u062E\u062A\u0631 \u0627\u062E\u062A\u0635\u0627\u0635 \u0647\u0630\u0647 \u0627\u0644\u0642\u0646\u0627\u0629.",
      tasksMax: "\u064A\u062D\u062A\u0648\u064A \u0627\u0644\u0646\u0645\u0648\u0630\u062C \u0639\u0644\u0649 \u2066{max}\u2069 \u0645\u0647\u0645\u0629 \u0639\u0644\u0649 \u0627\u0644\u0623\u0643\u062B\u0631.",
      taskPhase: "\u0647\u0630\u0647 \u0627\u0644\u0645\u0631\u062D\u0644\u0629 \u063A\u064A\u0631 \u0645\u0648\u062C\u0648\u062F\u0629 \u0641\u064A \u0627\u0644\u0646\u0645\u0648\u0630\u062C. \u0623\u0636\u0641\u0647\u0627 \u0623\u0648 \u0627\u062E\u062A\u0631 \u063A\u064A\u0631\u0647\u0627.",
      checklistMax: "\u062A\u062D\u062A\u0648\u064A \u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u062A\u062D\u0642\u0642 \u0639\u0644\u0649 \u2066{max}\u2069 \u0628\u0646\u062F\u064B\u0627 \u0639\u0644\u0649 \u0627\u0644\u0623\u0643\u062B\u0631.",
      invalid: "\u0627\u0644\u0646\u0645\u0648\u0630\u062C \u063A\u064A\u0631 \u0635\u0627\u0644\u062D. \u0631\u0627\u062C\u0639 \u0627\u0644\u0645\u0631\u0627\u062D\u0644 \u0648\u0627\u0644\u0645\u062C\u0644\u062F\u0627\u062A \u0648\u0627\u0644\u0642\u0646\u0648\u0627\u062A \u0648\u0627\u0644\u0645\u0647\u0627\u0645.",
      forbidden: "\u0644\u0627 \u064A\u062D\u0642 \u0644\u0643 \u062A\u0646\u0641\u064A\u0630 \u0647\u0630\u0627 \u0627\u0644\u0625\u062C\u0631\u0627\u0621 \u0639\u0644\u0649 \u0647\u0630\u0627 \u0627\u0644\u0646\u0645\u0648\u0630\u062C."
    }
  },
  archive: {
    banner: "\u0647\u0630\u0627 \u0627\u0644\u0645\u0634\u0631\u0648\u0639 \u0645\u0624\u0631\u0634\u0641: \u0647\u0648 \u0644\u0644\u0642\u0631\u0627\u0621\u0629 \u0641\u0642\u0637. \u0644\u0627 \u064A\u0645\u0643\u0646 \u062A\u0639\u062F\u064A\u0644 \u0623\u064A \u0634\u064A\u0621 \u0641\u064A\u0647 \u0642\u0628\u0644 \u0627\u0633\u062A\u0639\u0627\u062F\u062A\u0647.",
    actions: {
      title: "\u0625\u062C\u0631\u0627\u0621\u0627\u062A \u0627\u0644\u0645\u0634\u0631\u0648\u0639"
    },
    archive: {
      action: "\u0623\u0631\u0634\u0641\u0629 \u0627\u0644\u0645\u0634\u0631\u0648\u0639",
      help: "\u064A\u0628\u0642\u0649 \u0627\u0644\u0645\u0634\u0631\u0648\u0639 \u0642\u0627\u0628\u0644\u064B\u0627 \u0644\u0644\u0627\u0637\u0644\u0627\u0639 \u0644\u0643\u0646 \u0644\u0627 \u064A\u0645\u0643\u0646 \u062A\u0639\u062F\u064A\u0644\u0647. \u0648\u062A\u064F\u062D\u062A\u0633\u0628 \u0648\u062B\u0627\u0626\u0642\u0647 \u0628\u0646\u0635\u0641 \u062D\u062C\u0645\u0647\u0627 \u0641\u064A \u0645\u0633\u0627\u062D\u0629 \u0627\u0644\u062A\u062E\u0632\u064A\u0646.",
      confirmTitle: "\u0623\u0631\u0634\u0641\u0629 \u0627\u0644\u0645\u0634\u0631\u0648\u0639 \xAB{name}\xBB\u061F",
      confirmBody: "\u0639\u0646\u062F \u0623\u0631\u0634\u0641\u0629 \u0647\u0630\u0627 \u0627\u0644\u0645\u0634\u0631\u0648\u0639:",
      confirmReadOnly: "\u064A\u0635\u0628\u062D \u0644\u0644\u0642\u0631\u0627\u0621\u0629 \u0641\u0642\u0637: \u0644\u0627 \u064A\u0645\u0643\u0646 \u062A\u0639\u062F\u064A\u0644 \u0627\u0644\u0645\u0647\u0627\u0645 \u0648\u0627\u0644\u0645\u0631\u0627\u062D\u0644 \u0648\u0627\u0644\u0645\u062E\u0631\u062C\u0627\u062A \u0648\u0627\u0644\u0623\u0639\u0636\u0627\u0621 \u0648\u0627\u0644\u0648\u062B\u0627\u0626\u0642 \u0648\u0627\u0644\u0646\u0642\u0627\u0634\u0627\u062A\u061B",
      confirmStorage: "\u062A\u064F\u062D\u062A\u0633\u0628 \u0648\u062B\u0627\u0626\u0642\u0647 \u0628\u0646\u0633\u0628\u0629 50 % \u0645\u0646 \u0645\u0633\u0627\u062D\u0629 \u0627\u0644\u062A\u062E\u0632\u064A\u0646 \u0644\u062F\u064A\u0643\u0645\u061B",
      confirmRestore: "\u064A\u0645\u0643\u0646\u0643\u0645 \u0627\u0633\u062A\u0639\u0627\u062F\u062A\u0647 \u0641\u064A \u0623\u064A \u0648\u0642\u062A\u060C \u0641\u064A\u0639\u0648\u062F \u0628\u062D\u0627\u0644\u0629 \xAB\u0645\u063A\u0644\u0642\xBB.",
      confirm: "\u0623\u0631\u0634\u0641\u0629 \u0627\u0644\u0645\u0634\u0631\u0648\u0639",
      done: "\u062A\u0645\u062A \u0623\u0631\u0634\u0641\u0629 \u0627\u0644\u0645\u0634\u0631\u0648\u0639 \xAB{name}\xBB."
    },
    restore: {
      action: "\u0627\u0633\u062A\u0639\u0627\u062F\u0629 \u0627\u0644\u0645\u0634\u0631\u0648\u0639",
      help: "\u064A\u0635\u0628\u062D \u0627\u0644\u0645\u0634\u0631\u0648\u0639 \u0642\u0627\u0628\u0644\u064B\u0627 \u0644\u0644\u062A\u0639\u062F\u064A\u0644 \u0645\u0646 \u062C\u062F\u064A\u062F. \u064A\u0639\u0648\u062F \u0628\u062D\u0627\u0644\u0629 \xAB\u0645\u063A\u0644\u0642\xBB \u0648\u062A\u064F\u062D\u062A\u0633\u0628 \u0648\u062B\u0627\u0626\u0642\u0647 \u0643\u0627\u0645\u0644\u0629 \u0645\u0646 \u062C\u062F\u064A\u062F.",
      done: "\u062A\u0645\u062A \u0627\u0633\u062A\u0639\u0627\u062F\u0629 \u0627\u0644\u0645\u0634\u0631\u0648\u0639 \xAB{name}\xBB. \u062D\u0627\u0644\u062A\u0647 \xAB\u0645\u063A\u0644\u0642\xBB."
    },
    saveTemplate: {
      action: "\u062D\u0641\u0638 \u0643\u0646\u0645\u0648\u0630\u062C",
      help: "\u064A\u062D\u062A\u0641\u0638 \u0628\u0645\u0631\u0627\u062D\u0644 \u0647\u0630\u0627 \u0627\u0644\u0645\u0634\u0631\u0648\u0639 \u0648\u0645\u062C\u0644\u062F\u0627\u062A\u0647 \u0648\u0642\u0646\u0648\u0627\u062A\u0647 \u0648\u0645\u0647\u0627\u0645\u0647 \u0644\u0627\u0646\u0637\u0644\u0627\u0642 \u0645\u0634\u0627\u0631\u064A\u0639 \u0623\u062E\u0631\u0649. \u0644\u0627 \u062A\u064F\u0646\u0633\u062E \u0623\u064A \u0648\u062B\u064A\u0642\u0629 \u0623\u0648 \u0634\u062E\u0635 \u0623\u0648 \u062A\u0627\u0631\u064A\u062E.",
      title: "\u062D\u0641\u0638 \u0647\u0630\u0627 \u0627\u0644\u0645\u0634\u0631\u0648\u0639 \u0643\u0646\u0645\u0648\u0630\u062C",
      intro: "\u064A\u0623\u062E\u0630 \u0627\u0644\u0646\u0645\u0648\u0630\u062C \u0628\u0646\u064A\u0629 \u0627\u0644\u0645\u0634\u0631\u0648\u0639. \u0633\u062A\u062C\u062F\u0648\u0646\u0647 \u0641\u064A \u0627\u0644\u0625\u062F\u0627\u0631\u0629\u060C \u0646\u0645\u0627\u0630\u062C \u0627\u0644\u0645\u0634\u0627\u0631\u064A\u0639.",
      name: "\u0627\u0633\u0645 \u0627\u0644\u0646\u0645\u0648\u0630\u062C",
      description: "\u0627\u0644\u0648\u0635\u0641 (\u0627\u062E\u062A\u064A\u0627\u0631\u064A)",
      nameRequired: "\u0623\u0639\u0637\u0650 \u0627\u0644\u0646\u0645\u0648\u0630\u062C \u0627\u0633\u0645\u064B\u0627.",
      plain: "\u0627\u0633\u062A\u0639\u0645\u0644 \u0646\u0635\u064B\u0627 \u0639\u0627\u062F\u064A\u064B\u0627 \u062F\u0648\u0646 < \u0623\u0648 >.",
      invalid: "\u0644\u0627 \u064A\u0645\u0643\u0646 \u062D\u0641\u0638 \u0647\u0630\u0627 \u0627\u0644\u0645\u0634\u0631\u0648\u0639 \u0643\u0646\u0645\u0648\u0630\u062C \u0643\u0645\u0627 \u0647\u0648. \u0631\u0627\u062C\u0639 \u0645\u0631\u0627\u062D\u0644\u0647.",
      submit: "\u062D\u0641\u0638 \u0627\u0644\u0646\u0645\u0648\u0630\u062C",
      saving: "\u062C\u0627\u0631\u064D \u0627\u0644\u062D\u0641\u0638\u2026",
      done: "\u062A\u0645 \u0625\u0646\u0634\u0627\u0621 \u0627\u0644\u0646\u0645\u0648\u0630\u062C \xAB{name}\xBB \u0627\u0646\u0637\u0644\u0627\u0642\u064B\u0627 \u0645\u0646 \u0627\u0644\u0645\u0634\u0631\u0648\u0639."
    },
    errors: {
      PROJECT_ARCHIVED: "\u0647\u0630\u0627 \u0627\u0644\u0645\u0634\u0631\u0648\u0639 \u0645\u0624\u0631\u0634\u0641: \u0647\u0648 \u0644\u0644\u0642\u0631\u0627\u0621\u0629 \u0641\u0642\u0637. \u0627\u0633\u062A\u0639\u062F\u0647 \u0644\u062A\u0639\u062F\u064A\u0644\u0647."
    }
  },
  status: {
    draft: "\u0645\u0633\u0648\u062F\u0629",
    active: "\u062C\u0627\u0631\u064D",
    on_hold: "\u0645\u062A\u0648\u0642\u0641 \u0645\u0624\u0642\u062A\u064B\u0627",
    closed: "\u0645\u063A\u0644\u0642",
    archived: "\u0645\u0624\u0631\u0634\u0641"
  },
  statusHints: {
    draft: "\u0627\u0644\u0645\u0634\u0631\u0648\u0639 \u0642\u064A\u062F \u0627\u0644\u0625\u0639\u062F\u0627\u062F: \u0644\u0645 \u064A\u0646\u0637\u0644\u0642 \u0628\u0639\u062F.",
    active: "\u0627\u0644\u0645\u0634\u0631\u0648\u0639 \u062C\u0627\u0631\u064D.",
    on_hold: "\u0627\u0644\u0645\u0634\u0631\u0648\u0639 \u0645\u062A\u0648\u0642\u0641 \u0645\u0624\u0642\u062A\u064B\u0627 \u0648\u064A\u0645\u0643\u0646\u0647 \u0627\u0644\u0627\u0633\u062A\u0626\u0646\u0627\u0641.",
    closed: "\u0627\u0646\u062A\u0647\u062A \u0627\u0644\u0645\u0647\u0645\u0629. \u064A\u0645\u0643\u0646 \u0625\u0639\u0627\u062F\u0629 \u0641\u062A\u062D \u0627\u0644\u0645\u0634\u0631\u0648\u0639 \u0639\u0646\u062F \u0627\u0644\u062D\u0627\u062C\u0629.",
    archived: "\u0627\u0644\u0645\u0634\u0631\u0648\u0639 \u0645\u062D\u0641\u0648\u0638 \u0641\u064A \u0627\u0644\u0623\u0631\u0634\u064A\u0641: \u0644\u0627 \u064A\u0638\u0647\u0631 \u0641\u064A \u0627\u0644\u0642\u0648\u0627\u0626\u0645 \u0625\u0644\u0627 \u0628\u062A\u0635\u0641\u064A\u0629 \xAB\u0645\u0624\u0631\u0634\u0641\xBB."
  },
  missionTypes: {
    public_building: "\u0645\u0628\u0646\u0649 \u0639\u0645\u0648\u0645\u064A",
    collective_housing: "\u0633\u0643\u0646 \u062C\u0645\u0627\u0639\u064A",
    villa: "\u0641\u064A\u0644\u0627 \u0641\u0631\u062F\u064A\u0629",
    industrial: "\u0645\u0628\u0646\u0649 \u0635\u0646\u0627\u0639\u064A",
    facility: "\u062A\u062C\u0647\u064A\u0632",
    subdivision_vrd: "\u062A\u0642\u0633\u064A\u0645 \u0639\u0642\u0627\u0631\u064A \u0648\u0637\u0631\u0642 \u0648\u0634\u0628\u0643\u0627\u062A \u0645\u062E\u062A\u0644\u0641\u0629 (\u2066VRD\u2069)",
    expertise: "\u062E\u0628\u0631\u0629 \u0641\u0646\u064A\u0629"
  },
  phaseTypes: {
    esq: "\u2066ESQ\u2069",
    aps: "\u2066APS\u2069",
    apd: "\u2066APD\u2069",
    pro: "\u2066PRO\u2069",
    dce: "\u2066DCE\u2069",
    act: "\u2066ACT\u2069",
    det: "\u2066DET\u2069",
    aor_provisional: "\u2066AOR\u2069 \u0627\u0644\u0645\u0624\u0642\u062A",
    aor_final: "\u2066AOR\u2069 \u0627\u0644\u0646\u0647\u0627\u0626\u064A",
    custom: "\u0645\u0631\u062D\u0644\u0629 \u0645\u062E\u0635\u0651\u0635\u0629"
  },
  phaseNames: {
    esq: "\u0627\u0644\u0645\u062E\u0637\u0637 \u0627\u0644\u0623\u0648\u0644\u064A",
    aps: "\u0627\u0644\u062F\u0631\u0627\u0633\u0629 \u0627\u0644\u0623\u0648\u0644\u064A\u0629 \u0627\u0644\u0645\u0648\u062C\u0632\u0629",
    apd: "\u0627\u0644\u062F\u0631\u0627\u0633\u0629 \u0627\u0644\u0623\u0648\u0644\u064A\u0629 \u0627\u0644\u0645\u0641\u0635\u0644\u0629",
    pro: "\u062F\u0631\u0627\u0633\u0629 \u0627\u0644\u0645\u0634\u0631\u0648\u0639",
    dce: "\u0645\u0644\u0641 \u0637\u0644\u0628 \u0627\u0644\u0639\u0631\u0648\u0636 \u0644\u0644\u0645\u0642\u0627\u0648\u0644\u064A\u0646",
    act: "\u0627\u0644\u0645\u0633\u0627\u0639\u062F\u0629 \u0639\u0644\u0649 \u0625\u0628\u0631\u0627\u0645 \u0639\u0642\u0648\u062F \u0627\u0644\u0623\u0634\u063A\u0627\u0644",
    det: "\u0627\u0644\u0625\u0634\u0631\u0627\u0641 \u0639\u0644\u0649 \u062A\u0646\u0641\u064A\u0630 \u0627\u0644\u0623\u0634\u063A\u0627\u0644",
    aor_provisional: "\u0627\u0644\u0645\u0633\u0627\u0639\u062F\u0629 \u0639\u0644\u0649 \u0627\u0644\u0642\u0628\u0648\u0644 \u0627\u0644\u0648\u0642\u062A\u064A",
    aor_final: "\u0627\u0644\u0645\u0633\u0627\u0639\u062F\u0629 \u0639\u0644\u0649 \u0627\u0644\u0642\u0628\u0648\u0644 \u0627\u0644\u0646\u0647\u0627\u0626\u064A",
    custom: "\u0645\u0631\u062D\u0644\u0629 \u0645\u062E\u0635\u0651\u0635\u0629"
  },
  feeModes: {
    lump_sum: "\u0645\u0628\u0644\u063A \u062C\u0632\u0627\u0641\u064A",
    works_percentage: "\u0646\u0633\u0628\u0629 \u0645\u0646 \u0643\u0644\u0641\u0629 \u0627\u0644\u0623\u0634\u063A\u0627\u0644",
    time_based: "\u062D\u0633\u0628 \u0627\u0644\u0648\u0642\u062A \u0627\u0644\u0645\u0633\u062A\u063A\u0631\u0642"
  },
  roles: {
    manager: "\u0645\u0633\u0624\u0648\u0644",
    member: "\u0639\u0636\u0648"
  },
  tabs: {
    posts: "\u0627\u0644\u0645\u0646\u0634\u0648\u0631\u0627\u062A",
    files: "\u0627\u0644\u0645\u0644\u0641\u0627\u062A",
    tasks: "\u0627\u0644\u0645\u0647\u0627\u0645",
    phases: "\u0627\u0644\u0645\u0631\u0627\u062D\u0644",
    deliverables: "\u0627\u0644\u0645\u062E\u0631\u062C\u0627\u062A",
    approvals: "\u0627\u0644\u062A\u0623\u0634\u064A\u0631\u0627\u062A",
    calendar: "\u0627\u0644\u0631\u0632\u0646\u0627\u0645\u0629",
    finance: "\u0627\u0644\u0645\u0627\u0644\u064A\u0629",
    settings: "\u0627\u0644\u0625\u0639\u062F\u0627\u062F\u0627\u062A",
    meetings: "\u0627\u0644\u0627\u062C\u062A\u0645\u0627\u0639\u0627\u062A",
    planning: "\u0627\u0644\u062A\u062E\u0637\u064A\u0637",
    register: "\u0633\u062C\u0644 \u0627\u0644\u0645\u062E\u0637\u0637\u0627\u062A",
    checklists: "\u0642\u0648\u0627\u0626\u0645 \u0627\u0644\u062A\u062D\u0642\u0642",
    observations: "\u0627\u0644\u0645\u0644\u0627\u062D\u0638\u0627\u062A \u0648\u0627\u0644\u062A\u062D\u0641\u0651\u0638\u0627\u062A",
    profitability: "\u0627\u0644\u0645\u0631\u062F\u0648\u062F\u064A\u0629"
  },
  profitability: {
    noAccessTitle: "\u0627\u0644\u0645\u0631\u062F\u0648\u062F\u064A\u0629 \u063A\u064A\u0631 \u0645\u062A\u0627\u062D\u0629",
    noAccessBody: "\u0644\u064A\u0633 \u0644\u062F\u064A\u0643 \u0635\u0644\u0627\u062D\u064A\u0629 \u0627\u0644\u0627\u0637\u0644\u0627\u0639 \u0639\u0644\u0649 \u0645\u0631\u062F\u0648\u062F\u064A\u0629 \u0647\u0630\u0627 \u0627\u0644\u0645\u0634\u0631\u0648\u0639."
  },
  finance: {
    noAccessTitle: "\u0627\u0644\u0645\u0627\u0644\u064A\u0629 \u063A\u064A\u0631 \u0645\u062A\u0627\u062D\u0629",
    noAccessBody: "\u0644\u064A\u0633 \u0644\u062F\u064A\u0643 \u062D\u0642 \u0627\u0644\u0627\u0637\u0644\u0627\u0639 \u0639\u0644\u0649 \u0627\u0644\u0645\u0639\u0644\u0648\u0645\u0627\u062A \u0627\u0644\u0645\u0627\u0644\u064A\u0629 \u0644\u0647\u0630\u0627 \u0627\u0644\u0645\u0634\u0631\u0648\u0639."
  },
  later: {
    posts: {
      title: "\u0633\u062A\u0638\u0647\u0631 \u0647\u0646\u0627 \u0645\u0631\u0627\u0633\u0644\u0627\u062A \u0627\u0644\u0645\u0634\u0631\u0648\u0639",
      description: "\u0633\u062A\u0638\u0647\u0631 \u0641\u064A \u0647\u0630\u0627 \u0627\u0644\u062A\u0628\u0648\u064A\u0628 \u0642\u0646\u0648\u0627\u062A \u0627\u0644\u0646\u0642\u0627\u0634 \u062D\u0633\u0628 \u0627\u0644\u0627\u062E\u062A\u0635\u0627\u0635 (\u0647\u0646\u062F\u0633\u0629 \u0645\u0639\u0645\u0627\u0631\u064A\u0629\u060C \u0647\u064A\u0627\u0643\u0644\u060C \u0637\u0631\u0642\u0627\u062A \u0648\u0634\u0628\u0643\u0627\u062A\u2026) \u0648\u0645\u0646\u0634\u0648\u0631\u0627\u062A\u0647\u0627."
    },
    tasks: {
      title: "\u0633\u062A\u0638\u0647\u0631 \u0647\u0646\u0627 \u0645\u0647\u0627\u0645 \u0627\u0644\u0645\u0634\u0631\u0648\u0639",
      description: "\u0633\u062A\u064F\u0639\u0631\u0636 \u0645\u0647\u0627\u0645 \u0627\u0644\u0627\u0646\u0637\u0644\u0627\u0642 \u0641\u064A \u0627\u0644\u0646\u0645\u0648\u0630\u062C \u0648\u0645\u0647\u0627\u0645 \u0641\u0631\u064A\u0642\u0643 \u0641\u064A \u0634\u0643\u0644 \u0642\u0627\u0626\u0645\u0629 \u0648\u0644\u0648\u062D\u0629 \u0643\u0627\u0646\u0628\u0627\u0646."
    },
    phases: {
      title: "\u0633\u062A\u0638\u0647\u0631 \u0647\u0646\u0627 \u0645\u0631\u0627\u062D\u0644 \u0627\u0644\u0645\u0634\u0631\u0648\u0639",
      description: "\u0633\u064A\u0638\u0647\u0631 \u0641\u064A \u0647\u0630\u0627 \u0627\u0644\u062A\u0628\u0648\u064A\u0628 \u0634\u0631\u064A\u0637 \u0627\u0644\u0645\u0631\u0627\u062D\u0644 \u0645\u0646 \u0627\u0644\u0645\u062E\u0637\u0637 \u0627\u0644\u0623\u0648\u0644\u064A \u0625\u0644\u0649 \u0627\u0644\u0627\u0633\u062A\u0644\u0627\u0645\u060C \u0645\u0639 \u0627\u0644\u062A\u0648\u0627\u0631\u064A\u062E \u0627\u0644\u0645\u0628\u0631\u0645\u062C\u0629 \u0648\u0627\u0644\u0641\u0639\u0644\u064A\u0629."
    },
    deliverables: {
      title: "\u0633\u062A\u0638\u0647\u0631 \u0647\u0646\u0627 \u0645\u062E\u0631\u062C\u0627\u062A \u0627\u0644\u0645\u0634\u0631\u0648\u0639",
      description: "\u0633\u062A\u0638\u0647\u0631 \u0641\u064A \u0647\u0630\u0627 \u0627\u0644\u062A\u0628\u0648\u064A\u0628 \u0645\u062E\u0631\u062C\u0627\u062A \u0643\u0644 \u0645\u0631\u062D\u0644\u0629 \u0648\u062D\u0627\u0644\u0629 \u0627\u0644\u0645\u0648\u0627\u0641\u0642\u0629 \u0639\u0644\u064A\u0647\u0627."
    }
  },
  listPane: {
    title: "\u0645\u0634\u0627\u0631\u064A\u0639\u064A",
    label: "\u0645\u0634\u0627\u0631\u064A\u0639\u064A",
    empty: "\u0644\u0627 \u062A\u0634\u0627\u0631\u0643 \u0641\u064A \u0623\u064A \u0645\u0634\u0631\u0648\u0639 \u062D\u0627\u0644\u064A\u064B\u0627.",
    loadFailed: "\u062A\u0639\u0630\u0651\u0631 \u062A\u062D\u0645\u064A\u0644 \u0645\u0634\u0627\u0631\u064A\u0639\u0643.",
    seeAll: "\u0643\u0644 \u0627\u0644\u0645\u0634\u0627\u0631\u064A\u0639",
    section: "\u0627\u0644\u0645\u0634\u0627\u0631\u064A\u0639",
    count: "{count, plural, zero {\u0644\u0627 \u0645\u0634\u0627\u0631\u064A\u0639} one {\u0645\u0634\u0631\u0648\u0639 \u0648\u0627\u062D\u062F} two {\u0645\u0634\u0631\u0648\u0639\u0627\u0646} few {# \u0645\u0634\u0627\u0631\u064A\u0639} many {# \u0645\u0634\u0631\u0648\u0639\u064B\u0627} other {# \u0645\u0634\u0631\u0648\u0639}}",
    filter: "\u0627\u0644\u062A\u0635\u0641\u064A\u0629 \u0628\u0627\u0644\u0627\u0633\u0645 \u0623\u0648 \u0627\u0644\u0631\u0645\u0632",
    noMatch: "\u0644\u0627 \u064A\u0648\u062C\u062F \u0645\u0634\u0631\u0648\u0639 \u064A\u0637\u0627\u0628\u0642 \u0647\u0630\u0647 \u0627\u0644\u062A\u0635\u0641\u064A\u0629."
  },
  list: {
    tableCaption: "\u0645\u0634\u0627\u0631\u064A\u0639 \u0627\u0644\u0645\u0643\u062A\u0628",
    columns: {
      name: "\u0627\u0644\u0645\u0634\u0631\u0648\u0639",
      code: "\u0627\u0644\u0631\u0645\u0632",
      client: "\u0627\u0644\u062D\u0631\u064A\u0641",
      missionType: "\u0646\u0648\u0639 \u0627\u0644\u0645\u0647\u0645\u0629",
      status: "\u0627\u0644\u062D\u0627\u0644\u0629",
      phase: "\u0627\u0644\u0645\u0631\u0627\u062D\u0644"
    },
    filters: {
      label: "\u062A\u0635\u0641\u064A\u0629 \u0627\u0644\u0645\u0634\u0627\u0631\u064A\u0639",
      search: "\u0627\u0644\u0628\u062D\u062B \u0639\u0646 \u0645\u0634\u0631\u0648\u0639",
      searchPlaceholder: "\u0627\u0633\u0645 \u0627\u0644\u0645\u0634\u0631\u0648\u0639 \u0623\u0648 \u0631\u0645\u0632\u0647",
      status: "\u0627\u0644\u062A\u0635\u0641\u064A\u0629 \u062D\u0633\u0628 \u0627\u0644\u062D\u0627\u0644\u0629",
      allStatuses: "\u0643\u0644 \u0627\u0644\u062D\u0627\u0644\u0627\u062A",
      missionType: "\u0627\u0644\u062A\u0635\u0641\u064A\u0629 \u062D\u0633\u0628 \u0646\u0648\u0639 \u0627\u0644\u0645\u0647\u0645\u0629",
      allMissionTypes: "\u0643\u0644 \u0623\u0646\u0648\u0627\u0639 \u0627\u0644\u0645\u0647\u0627\u0645",
      client: "\u0627\u0644\u062A\u0635\u0641\u064A\u0629 \u062D\u0633\u0628 \u0627\u0644\u062D\u0631\u064A\u0641",
      allClients: "\u0643\u0644 \u0627\u0644\u062D\u0631\u0641\u0627\u0621",
      mine: "\u0645\u0634\u0627\u0631\u064A\u0639\u064A \u0641\u0642\u0637",
      clear: "\u0645\u0633\u062D \u0627\u0644\u062A\u0635\u0641\u064A\u0627\u062A"
    },
    view: {
      label: "\u0637\u0631\u064A\u0642\u0629 \u0627\u0644\u0639\u0631\u0636",
      grid: "\u0634\u0628\u0643\u0629",
      list: "\u0642\u0627\u0626\u0645\u0629"
    },
    new: "\u0645\u0634\u0631\u0648\u0639 \u062C\u062F\u064A\u062F",
    gridLabel: "\u0645\u0634\u0627\u0631\u064A\u0639 \u0627\u0644\u0645\u0643\u062A\u0628",
    loadMore: "\u0639\u0631\u0636 \u0627\u0644\u0645\u0632\u064A\u062F \u0645\u0646 \u0627\u0644\u0645\u0634\u0627\u0631\u064A\u0639",
    loadingMore: "\u062C\u0627\u0631\u064D \u0627\u0644\u062A\u062D\u0645\u064A\u0644\u2026",
    loadFailedTitle: "\u062A\u0639\u0630\u0651\u0631 \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0645\u0634\u0627\u0631\u064A\u0639",
    loadFailedBody: "\u062A\u062D\u0642\u0642 \u0645\u0646 \u0627\u062A\u0635\u0627\u0644\u0643 \u062B\u0645 \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629.",
    empty: {
      title: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0645\u0634\u0627\u0631\u064A\u0639 \u0628\u0639\u062F",
      description: "\u064A\u062C\u0645\u0639 \u0627\u0644\u0645\u0634\u0631\u0648\u0639 \u0645\u0631\u0627\u062D\u0644 \u0627\u0644\u0645\u0647\u0645\u0629 \u0648\u0645\u0644\u0641\u0627\u062A\u0647\u0627 \u0648\u0645\u0647\u0627\u0645\u0647\u0627 \u0648\u0645\u0631\u0627\u0633\u0644\u0627\u062A\u0647\u0627. \u0623\u0646\u0634\u0626\u0647 \u0627\u0646\u0637\u0644\u0627\u0642\u064B\u0627 \u0645\u0646 \u0646\u0645\u0648\u0630\u062C \u0645\u0647\u0645\u0629 \u0644\u062A\u0628\u062F\u0623 \u0628\u0627\u0644\u0645\u0631\u0627\u062D\u0644 \u0648\u0627\u0644\u0645\u062C\u0644\u062F\u0627\u062A \u0627\u0644\u0645\u0639\u062A\u0627\u062F\u0629.",
      descriptionReadOnly: "\u064A\u062C\u0645\u0639 \u0627\u0644\u0645\u0634\u0631\u0648\u0639 \u0645\u0631\u0627\u062D\u0644 \u0627\u0644\u0645\u0647\u0645\u0629 \u0648\u0645\u0644\u0641\u0627\u062A\u0647\u0627 \u0648\u0645\u0647\u0627\u0645\u0647\u0627 \u0648\u0645\u0631\u0627\u0633\u0644\u0627\u062A\u0647\u0627. \u0644\u0633\u062A \u0639\u0636\u0648\u064B\u0627 \u0641\u064A \u0623\u064A \u0645\u0634\u0631\u0648\u0639 \u0628\u0639\u062F: \u0627\u0637\u0644\u0628 \u0645\u0646 \u0645\u0633\u0624\u0648\u0644 \u0625\u0636\u0627\u0641\u062A\u0643 \u0625\u0644\u0649 \u0645\u0634\u0631\u0648\u0639 \u0623\u0648 \u0625\u0646\u0634\u0627\u0621 \u0645\u0634\u0631\u0648\u0639.",
      filteredTitle: "\u0644\u0627 \u064A\u0648\u062C\u062F \u0645\u0634\u0631\u0648\u0639 \u0645\u0637\u0627\u0628\u0642",
      filteredDescription: "\u062C\u0631\u0651\u0628 \u0627\u0633\u0645\u064B\u0627 \u0622\u062E\u0631 \u0623\u0648 \u062D\u0627\u0644\u0629 \u0623\u062E\u0631\u0649\u060C \u0623\u0648 \u0623\u0632\u0644 \u0625\u062D\u062F\u0649 \u0627\u0644\u062A\u0635\u0641\u064A\u0627\u062A."
    }
  },
  card: {
    noClient: "\u0628\u062F\u0648\u0646 \u062D\u0631\u064A\u0641",
    progress: "\u0627\u0644\u0645\u0631\u0627\u062D\u0644 \u0627\u0644\u0645\u063A\u0644\u0642\u0629: \u2066{closed} / {total}\u2069",
    noPhases: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0645\u0631\u0627\u062D\u0644",
    currentPhase: "\u0627\u0644\u0645\u0631\u062D\u0644\u0629 \u0627\u0644\u062D\u0627\u0644\u064A\u0629: {phase}",
    allClosed: "\u0643\u0644 \u0627\u0644\u0645\u0631\u0627\u062D\u0644 \u0645\u063A\u0644\u0642\u0629",
    progressLabel: "\u062A\u0642\u062F\u0651\u0645 \u0645\u0631\u0627\u062D\u0644 {name}"
  },
  create: {
    title: "\u0645\u0634\u0631\u0648\u0639 \u062C\u062F\u064A\u062F",
    intro: "\u0627\u062E\u062A\u0631 \u0623\u0648\u0644\u064B\u0627 \u0646\u0648\u0639 \u0627\u0644\u0645\u0647\u0645\u0629: \u064A\u0646\u0637\u0644\u0642 \u0627\u0644\u0645\u0634\u0631\u0648\u0639 \u0628\u0627\u0644\u0645\u0631\u0627\u062D\u0644 \u0648\u0627\u0644\u0645\u062C\u0644\u062F\u0627\u062A \u0648\u0627\u0644\u0645\u0647\u0627\u0645 \u0627\u0644\u0645\u0639\u062A\u0627\u062F\u0629 \u0644\u0647\u0630\u0627 \u0627\u0644\u0646\u0648\u0639.",
    submit: "\u0625\u0646\u0634\u0627\u0621 \u0627\u0644\u0645\u0634\u0631\u0648\u0639",
    saving: "\u062C\u0627\u0631\u064D \u0627\u0644\u0625\u0646\u0634\u0627\u0621\u2026",
    done: "\u062A\u0645 \u0625\u0646\u0634\u0627\u0621 \u0627\u0644\u0645\u0634\u0631\u0648\u0639 \xAB{name}\xBB.",
    fields: {
      missionType: {
        label: "\u0646\u0648\u0639 \u0627\u0644\u0645\u0647\u0645\u0629"
      },
      name: {
        label: "\u0627\u0633\u0645 \u0627\u0644\u0645\u0634\u0631\u0648\u0639",
        hint: "\u0645\u062B\u0627\u0644: \xAB\u0627\u0644\u0645\u0639\u0647\u062F \u0627\u0644\u0646\u0645\u0648\u0630\u062C\u064A \u0628\u0627\u0644\u0642\u064A\u0631\u0648\u0627\u0646\xBB."
      },
      code: {
        label: "\u0631\u0645\u0632 \u0627\u0644\u0645\u0634\u0631\u0648\u0639",
        hint: "\u0627\u062E\u062A\u064A\u0627\u0631\u064A. \u0625\u0646 \u062A\u064F\u0631\u0643 \u0641\u0627\u0631\u063A\u064B\u0627 \u064A\u064F\u0648\u0644\u064E\u0651\u062F \u0631\u0645\u0632 \u062A\u0644\u0642\u0627\u0626\u064A\u064B\u0627 (\u0645\u062B\u0644 \u20662026-014\u2069)."
      },
      client: {
        label: "\u0627\u0644\u062D\u0631\u064A\u0641 (\u0635\u0627\u062D\u0628 \u0627\u0644\u0645\u0634\u0631\u0648\u0639)",
        none: "\u0644\u0627 \u062D\u0631\u064A\u0641 \u062D\u0627\u0644\u064A\u064B\u0627",
        hint: "\u0627\u062E\u062A\u064A\u0627\u0631\u064A. \u064A\u0645\u0643\u0646\u0643 \u0625\u0636\u0627\u0641\u062A\u0647 \u0644\u0627\u062D\u0642\u064B\u0627."
      },
      governorate: {
        label: "\u0627\u0644\u0648\u0644\u0627\u064A\u0629",
        none: "\u063A\u064A\u0631 \u0645\u062D\u062F\u062F\u0629"
      },
      startsOn: {
        label: "\u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0627\u0646\u0637\u0644\u0627\u0642",
        hint: "\u0627\u062E\u062A\u064A\u0627\u0631\u064A. \u0645\u0639 \u062A\u062D\u062F\u064A\u062F \u062A\u0627\u0631\u064A\u062E\u060C \u062A\u062D\u0635\u0644 \u0643\u0644 \u0645\u0631\u062D\u0644\u0629 \u0639\u0644\u0649 \u062A\u0648\u0627\u0631\u064A\u062E \u0625\u0631\u0634\u0627\u062F\u064A\u0629\u060C \u0627\u0644\u0648\u0627\u062D\u062F\u0629 \u0628\u0639\u062F \u0627\u0644\u0623\u062E\u0631\u0649."
      }
    },
    orgTemplate: {
      label: "\u0646\u0645\u0648\u0630\u062C \u0627\u0644\u0645\u0643\u062A\u0628",
      hint: "\u0627\u062E\u062A\u064A\u0627\u0631\u064A. \u064A\u062D\u0644\u0651 \u0646\u0645\u0648\u0630\u062C \u0627\u0644\u0645\u0643\u062A\u0628 \u0645\u062D\u0644 \u0627\u0644\u0646\u0645\u0648\u0630\u062C \u0627\u0644\u0645\u0639\u062A\u0627\u062F \u0644\u0646\u0648\u0639 \u0627\u0644\u0645\u0647\u0645\u0629.",
      none: "\u0628\u062F\u0648\u0646: \u0646\u0645\u0648\u0630\u062C \u0646\u0648\u0639 \u0627\u0644\u0645\u0647\u0645\u0629",
      previewTitle: "\u0645\u062D\u062A\u0648\u0649 \u0627\u0644\u0646\u0645\u0648\u0630\u062C \xAB{name}\xBB"
    },
    template: {
      title: "\u0645\u062D\u062A\u0648\u0649 \u0647\u0630\u0627 \u0627\u0644\u0646\u0645\u0648\u0630\u062C",
      loading: "\u062C\u0627\u0631\u064D \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0646\u0645\u0648\u0630\u062C\u2026",
      unavailable: "\u062A\u0639\u0630\u0651\u0631 \u062A\u062D\u0645\u064A\u0644 \u0645\u062D\u062A\u0648\u0649 \u0627\u0644\u0646\u0645\u0648\u0630\u062C. \u064A\u0645\u0643\u0646\u0643 \u0645\u0639 \u0630\u0644\u0643 \u0625\u0646\u0634\u0627\u0621 \u0627\u0644\u0645\u0634\u0631\u0648\u0639.",
      phasesLabel: "\u0645\u0631\u0627\u062D\u0644 \u0627\u0644\u0646\u0645\u0648\u0630\u062C \u0628\u0627\u0644\u062A\u0631\u062A\u064A\u0628",
      share: "\u2066{share}\u2069 \u0645\u0646 \u0627\u0644\u0623\u062A\u0639\u0627\u0628",
      note: "\u062D\u0635\u0635 \u0627\u0644\u0623\u062A\u0639\u0627\u0628 \u0625\u0631\u0634\u0627\u062F\u064A\u0629\u061B \u064A\u0645\u0643\u0646\u0643 \u062A\u0639\u062F\u064A\u0644\u0647\u0627 \u0641\u064A \u062A\u0628\u0648\u064A\u0628 \u0627\u0644\u0645\u0631\u0627\u062D\u0644.",
      folders: "{count, plural, one {\u064A\u064F\u0646\u0634\u0623 \u0645\u062C\u0644\u062F \u0648\u0627\u062D\u062F} two {\u064A\u064F\u0646\u0634\u0623 \u0645\u062C\u0644\u062F\u0627\u0646} few {\u064A\u064F\u0646\u0634\u0623 # \u0645\u062C\u0644\u062F\u0627\u062A} many {\u064A\u064F\u0646\u0634\u0623 # \u0645\u062C\u0644\u062F\u064B\u0627} other {\u064A\u064F\u0646\u0634\u0623 # \u0645\u062C\u0644\u062F}}",
      tasks: "{count, plural, one {\u0645\u0647\u0645\u0629 \u0627\u0646\u0637\u0644\u0627\u0642 \u0648\u0627\u062D\u062F\u0629} two {\u0645\u0647\u0645\u062A\u0627 \u0627\u0646\u0637\u0644\u0627\u0642} few {# \u0645\u0647\u0627\u0645 \u0627\u0646\u0637\u0644\u0627\u0642} many {# \u0645\u0647\u0645\u0629 \u0627\u0646\u0637\u0644\u0627\u0642} other {# \u0645\u0647\u0645\u0629 \u0627\u0646\u0637\u0644\u0627\u0642}}",
      channels: "{count, plural, one {\u0642\u0646\u0627\u0629 \u0646\u0642\u0627\u0634 \u0648\u0627\u062D\u062F\u0629} two {\u0642\u0646\u0627\u062A\u0627 \u0646\u0642\u0627\u0634} few {# \u0642\u0646\u0648\u0627\u062A \u0646\u0642\u0627\u0634} many {# \u0642\u0646\u0627\u0629 \u0646\u0642\u0627\u0634} other {# \u0642\u0646\u0627\u0629 \u0646\u0642\u0627\u0634}}"
    },
    errors: {
      required: "\u0647\u0630\u0627 \u0627\u0644\u062D\u0642\u0644 \u0625\u0644\u0632\u0627\u0645\u064A.",
      nameTooLong: "\u0644\u0627 \u064A\u0645\u0643\u0646 \u0623\u0646 \u064A\u062A\u062C\u0627\u0648\u0632 \u0627\u0644\u0627\u0633\u0645 200 \u062D\u0631\u0641.",
      templateNotAvailable: "\u0644\u0645 \u064A\u0639\u062F \u0647\u0630\u0627 \u0627\u0644\u0646\u0645\u0648\u0630\u062C \u0645\u062A\u0627\u062D\u064B\u0627. \u0627\u062E\u062A\u0631 \u0646\u0645\u0648\u0630\u062C\u064B\u0627 \u0622\u062E\u0631 \u0623\u0648 \u0639\u064F\u062F \u0625\u0644\u0649 \u0646\u0645\u0648\u0630\u062C \u0646\u0648\u0639 \u0627\u0644\u0645\u0647\u0645\u0629.",
      codeInvalid: "\u0627\u0633\u062A\u0639\u0645\u0644 \u062D\u0631\u0648\u0641\u064B\u0627 \u0648\u0623\u0631\u0642\u0627\u0645\u064B\u0627 \u0648\u0627\u0644\u0631\u0645\u0648\u0632 . _ / - (30 \u062D\u0631\u0641\u064B\u0627 \u0639\u0644\u0649 \u0627\u0644\u0623\u0643\u062B\u0631)\u060C \u0645\u062B\u0644 \u20662026-014\u2069.",
      codeTaken: "\u064A\u0633\u062A\u0639\u0645\u0644 \u0645\u0634\u0631\u0648\u0639 \u0622\u062E\u0631 \u0641\u064A \u0627\u0644\u0645\u0643\u062A\u0628 \u0647\u0630\u0627 \u0627\u0644\u0631\u0645\u0632. \u0627\u062E\u062A\u0631 \u0631\u0645\u0632\u064B\u0627 \u0622\u062E\u0631.",
      invalid: "\u0647\u0630\u0647 \u0627\u0644\u0642\u064A\u0645\u0629 \u063A\u064A\u0631 \u0635\u0627\u0644\u062D\u0629."
    }
  },
  detail: {
    project: "\u0627\u0644\u0645\u0634\u0631\u0648\u0639",
    notFoundTitle: "\u0627\u0644\u0645\u0634\u0631\u0648\u0639 \u063A\u064A\u0631 \u0645\u0648\u062C\u0648\u062F",
    notFoundBody: "\u0647\u0630\u0627 \u0627\u0644\u0645\u0634\u0631\u0648\u0639 \u063A\u064A\u0631 \u0645\u0648\u062C\u0648\u062F\u060C \u0623\u0648 \u0644\u0633\u062A \u0639\u0636\u0648\u064B\u0627 \u0641\u064A\u0647. \u0627\u0637\u0644\u0628 \u0645\u0646 \u0623\u062D\u062F \u0645\u0633\u0624\u0648\u0644\u064A \u0627\u0644\u0645\u0634\u0631\u0648\u0639 \u0625\u0636\u0627\u0641\u062A\u0643.",
    backToList: "\u0627\u0644\u0639\u0648\u062F\u0629 \u0625\u0644\u0649 \u0627\u0644\u0645\u0634\u0627\u0631\u064A\u0639",
    loadFailedTitle: "\u062A\u0639\u0630\u0651\u0631 \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0645\u0634\u0631\u0648\u0639",
    loadFailedBody: "\u062A\u062D\u0642\u0642 \u0645\u0646 \u0627\u062A\u0635\u0627\u0644\u0643 \u062B\u0645 \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629.",
    summaryLabel: "\u0645\u0644\u062E\u0635 \u0627\u0644\u0645\u0634\u0631\u0648\u0639",
    code: "\u0627\u0644\u0631\u0645\u0632",
    client: "\u0627\u0644\u062D\u0631\u064A\u0641",
    noClient: "\u0628\u062F\u0648\u0646 \u062D\u0631\u064A\u0641"
  },
  settings: {
    readOnlyNotice: "\u0644\u0627 \u064A\u0645\u0643\u0646 \u0644\u063A\u064A\u0631 \u0645\u0633\u0624\u0648\u0644\u064A \u0627\u0644\u0645\u0634\u0631\u0648\u0639 \u062A\u0639\u062F\u064A\u0644 \u0647\u0630\u0647 \u0627\u0644\u0645\u0639\u0644\u0648\u0645\u0627\u062A.",
    formLabel: "\u0625\u0639\u062F\u0627\u062F\u0627\u062A {name}",
    save: "\u062D\u0641\u0638 \u0627\u0644\u062A\u0639\u062F\u064A\u0644\u0627\u062A",
    saving: "\u062C\u0627\u0631\u064D \u0627\u0644\u062D\u0641\u0638\u2026",
    reset: "\u0625\u0644\u063A\u0627\u0621 \u0627\u0644\u062A\u0639\u062F\u064A\u0644\u0627\u062A",
    saved: "\u062A\u0645 \u062A\u062D\u062F\u064A\u062B \u0627\u0644\u0645\u0634\u0631\u0648\u0639 \xAB{name}\xBB.",
    stale: "\u0639\u062F\u0651\u0644 \u0634\u062E\u0635 \u0622\u062E\u0631 \u0627\u0644\u0645\u0634\u0631\u0648\u0639 \xAB{name}\xBB. \u0623\u0639\u062F\u0646\u0627 \u062A\u062D\u0645\u064A\u0644\u0647: \u062A\u062D\u0642\u0642 \u0645\u0646 \u0627\u0644\u0642\u064A\u0645 \u062B\u0645 \u0637\u0628\u0651\u0642 \u062A\u0639\u062F\u064A\u0644\u0627\u062A\u0643 \u0645\u0646 \u062C\u062F\u064A\u062F.",
    groups: {
      general: "\u0645\u0639\u0644\u0648\u0645\u0627\u062A \u0639\u0627\u0645\u0629",
      location: "\u0627\u0644\u0645\u0648\u0642\u0639",
      planning: "\u0627\u0644\u062A\u0648\u0627\u0631\u064A\u062E",
      estimate: "\u0627\u0644\u0645\u0633\u0627\u062D\u0629 \u0648\u0627\u0644\u062A\u0642\u062F\u064A\u0631",
      fees: "\u0627\u0644\u0623\u062A\u0639\u0627\u0628",
      references: "\u0627\u0644\u0645\u0631\u0627\u062C\u0639",
      status: "\u062D\u0627\u0644\u0629 \u0627\u0644\u0645\u0634\u0631\u0648\u0639"
    },
    fields: {
      missionType: "\u0646\u0648\u0639 \u0627\u0644\u0645\u0647\u0645\u0629",
      name: "\u0627\u0633\u0645 \u0627\u0644\u0645\u0634\u0631\u0648\u0639",
      code: "\u0631\u0645\u0632 \u0627\u0644\u0645\u0634\u0631\u0648\u0639",
      codeHint: "\u064A\u064F\u0633\u062A\u0639\u0645\u0644 \u0641\u064A \u0648\u062B\u0627\u0626\u0642 \u0627\u0644\u0645\u0634\u0631\u0648\u0639 \u0648\u0641\u0648\u0627\u062A\u064A\u0631\u0647.",
      client: "\u0627\u0644\u062D\u0631\u064A\u0641 (\u0635\u0627\u062D\u0628 \u0627\u0644\u0645\u0634\u0631\u0648\u0639)",
      clientNone: "\u0628\u062F\u0648\u0646 \u062D\u0631\u064A\u0641",
      governorate: "\u0627\u0644\u0648\u0644\u0627\u064A\u0629",
      governorateNone: "\u063A\u064A\u0631 \u0645\u062D\u062F\u062F\u0629",
      delegation: "\u0627\u0644\u0645\u0639\u062A\u0645\u062F\u064A\u0629",
      startsOn: "\u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0627\u0646\u0637\u0644\u0627\u0642",
      endsOn: "\u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0627\u0646\u062A\u0647\u0627\u0621 \u0627\u0644\u0645\u0628\u0631\u0645\u062C",
      surfaceM2: "\u0627\u0644\u0645\u0633\u0627\u062D\u0629 (\u0645\xB2)",
      surfaceHint: "\u0627\u0644\u0645\u0633\u0627\u062D\u0629 \u0627\u0644\u062C\u0645\u0644\u064A\u0629 \u0644\u0644\u0645\u0634\u0631\u0648\u0639 \u0628\u0627\u0644\u0645\u062A\u0631 \u0627\u0644\u0645\u0631\u0628\u0639.",
      worksCostEstimate: "\u062A\u0642\u062F\u064A\u0631 \u0643\u0644\u0641\u0629 \u0627\u0644\u0623\u0634\u063A\u0627\u0644",
      feeMode: "\u0637\u0631\u064A\u0642\u0629 \u0627\u062D\u062A\u0633\u0627\u0628 \u0627\u0644\u0623\u062A\u0639\u0627\u0628",
      feeModeNone: "\u063A\u064A\u0631 \u0645\u062D\u062F\u062F\u0629",
      feeAmount: "\u0645\u0628\u0644\u063A \u0627\u0644\u0623\u062A\u0639\u0627\u0628",
      contractRef: "\u0645\u0631\u062C\u0639 \u0627\u0644\u0639\u0642\u062F",
      tunepsRef: "\u0645\u0631\u062C\u0639 \u2066TUNEPS\u2069",
      tunepsHint: "\u0645\u0631\u062C\u0639 \u0637\u0644\u0628 \u0627\u0644\u0639\u0631\u0648\u0636 \u0641\u064A \u0645\u0646\u0638\u0648\u0645\u0629 \u2066TUNEPS\u2069\u060C \u0625\u0646 \u0643\u0627\u0646\u062A \u0627\u0644\u0635\u0641\u0642\u0629 \u0639\u0645\u0648\u0645\u064A\u0629.",
      status: "\u0627\u0644\u062D\u0627\u0644\u0629"
    },
    errors: {
      required: "\u0647\u0630\u0627 \u0627\u0644\u062D\u0642\u0644 \u0625\u0644\u0632\u0627\u0645\u064A.",
      nameTooLong: "\u0644\u0627 \u064A\u0645\u0643\u0646 \u0623\u0646 \u064A\u062A\u062C\u0627\u0648\u0632 \u0627\u0644\u0627\u0633\u0645 200 \u062D\u0631\u0641.",
      codeInvalid: "\u0627\u0633\u062A\u0639\u0645\u0644 \u062D\u0631\u0648\u0641\u064B\u0627 \u0648\u0623\u0631\u0642\u0627\u0645\u064B\u0627 \u0648\u0627\u0644\u0631\u0645\u0648\u0632 . _ / - (30 \u062D\u0631\u0641\u064B\u0627 \u0639\u0644\u0649 \u0627\u0644\u0623\u0643\u062B\u0631)\u060C \u0645\u062B\u0644 \u20662026-014\u2069.",
      codeTaken: "\u064A\u0633\u062A\u0639\u0645\u0644 \u0645\u0634\u0631\u0648\u0639 \u0622\u062E\u0631 \u0641\u064A \u0627\u0644\u0645\u0643\u062A\u0628 \u0647\u0630\u0627 \u0627\u0644\u0631\u0645\u0632. \u0627\u062E\u062A\u0631 \u0631\u0645\u0632\u064B\u0627 \u0622\u062E\u0631.",
      surfaceInvalid: "\u0623\u062F\u062E\u0644 \u0645\u0633\u0627\u062D\u0629 \u0635\u062D\u064A\u062D\u0629 \u0628\u0627\u0644\u0645\u062A\u0631 \u0627\u0644\u0645\u0631\u0628\u0639 \u0644\u0627 \u062A\u0642\u0644 \u0639\u0646 1.",
      datesOrder: "\u0644\u0627 \u064A\u0645\u0643\u0646 \u0623\u0646 \u064A\u0633\u0628\u0642 \u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0627\u0646\u062A\u0647\u0627\u0621 \u0627\u0644\u0645\u0628\u0631\u0645\u062C \u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0627\u0646\u0637\u0644\u0627\u0642.",
      statusTransition: "\u0644\u0627 \u064A\u0645\u0643\u0646 \u0647\u0630\u0627 \u0627\u0644\u062A\u063A\u064A\u064A\u0631 \u0641\u064A \u0627\u0644\u062D\u0627\u0644\u0629 \u0627\u0646\u0637\u0644\u0627\u0642\u064B\u0627 \u0645\u0646 \u0627\u0644\u062D\u0627\u0644\u0629 \u0627\u0644\u062D\u0627\u0644\u064A\u0629.",
      clientNotAvailable: "\u0647\u0630\u0627 \u0627\u0644\u062D\u0631\u064A\u0641 \u0644\u0645 \u064A\u0639\u062F \u0645\u062A\u0627\u062D\u064B\u0627. \u0627\u062E\u062A\u0631 \u062D\u0631\u064A\u0641\u064B\u0627 \u0646\u0634\u0637\u064B\u0627.",
      feesForbidden: "\u0644\u064A\u0633 \u0644\u062F\u064A\u0643 \u0625\u0630\u0646 \u0628\u062A\u0639\u062F\u064A\u0644 \u0627\u0644\u0623\u062A\u0639\u0627\u0628.",
      invalid: "\u0647\u0630\u0647 \u0627\u0644\u0642\u064A\u0645\u0629 \u063A\u064A\u0631 \u0635\u0627\u0644\u062D\u0629."
    }
  },
  members: {
    title: "\u0623\u0639\u0636\u0627\u0621 \u0627\u0644\u0645\u0634\u0631\u0648\u0639",
    intro: "\u064A\u0637\u0651\u0644\u0639 \u0627\u0644\u0623\u0639\u0636\u0627\u0621 \u0639\u0644\u0649 \u0647\u0630\u0627 \u0627\u0644\u0645\u0634\u0631\u0648\u0639 \u0648\u064A\u0633\u0627\u0647\u0645\u0648\u0646 \u0641\u064A\u0647\u061B \u0648\u064A\u062A\u0648\u0644\u0649 \u0627\u0644\u0645\u0633\u0624\u0648\u0644\u0648\u0646 \u0625\u0639\u062F\u0627\u062F\u0627\u062A\u0647. \u064A\u0644\u0632\u0645 \u0645\u0633\u0624\u0648\u0644 \u0648\u0627\u062D\u062F \u0639\u0644\u0649 \u0627\u0644\u0623\u0642\u0644.",
    tableCaption: "\u0623\u0639\u0636\u0627\u0621 \u0627\u0644\u0645\u0634\u0631\u0648\u0639",
    columns: {
      name: "\u0627\u0644\u0627\u0633\u0645",
      role: "\u0627\u0644\u062F\u0648\u0631",
      actions: "\u0627\u0644\u0625\u062C\u0631\u0627\u0621\u0627\u062A"
    },
    you: "(\u0623\u0646\u062A)",
    roleOf: "\u062F\u0648\u0631 {name}",
    remove: "\u0625\u0632\u0627\u0644\u0629 {name} \u0645\u0646 \u0627\u0644\u0645\u0634\u0631\u0648\u0639",
    add: {
      label: "\u0625\u0636\u0627\u0641\u0629 \u0634\u062E\u0635 \u0645\u0646 \u0627\u0644\u0645\u0643\u062A\u0628",
      placeholder: "\u0627\u062E\u062A\u0631 \u0634\u062E\u0635\u064B\u0627",
      button: "\u0625\u0636\u0627\u0641\u0629",
      none: "\u0643\u0644 \u0627\u0644\u0623\u0634\u062E\u0627\u0635 \u0627\u0644\u0646\u0634\u0637\u064A\u0646 \u0641\u064A \u0627\u0644\u0645\u0643\u062A\u0628 \u0623\u0639\u0636\u0627\u0621 \u0641\u064A \u0627\u0644\u0645\u0634\u0631\u0648\u0639 \u0628\u0627\u0644\u0641\u0639\u0644."
    },
    save: "\u062D\u0641\u0638 \u0627\u0644\u0623\u0639\u0636\u0627\u0621",
    saving: "\u062C\u0627\u0631\u064D \u0627\u0644\u062D\u0641\u0638\u2026",
    reset: "\u0625\u0644\u063A\u0627\u0621 \u0627\u0644\u062A\u0639\u062F\u064A\u0644\u0627\u062A",
    saved: "\u062A\u0645 \u062A\u062D\u062F\u064A\u062B \u0623\u0639\u0636\u0627\u0621 \u0627\u0644\u0645\u0634\u0631\u0648\u0639.",
    loadFailed: "\u062A\u0639\u0630\u0651\u0631 \u062A\u062D\u0645\u064A\u0644 \u0623\u0639\u0636\u0627\u0621 \u0627\u0644\u0645\u0634\u0631\u0648\u0639. \u062A\u062D\u0642\u0642 \u0645\u0646 \u0627\u062A\u0635\u0627\u0644\u0643 \u062B\u0645 \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629.",
    errors: {
      lastManager: "\u064A\u062C\u0628 \u0623\u0646 \u064A\u0628\u0642\u0649 \u0641\u064A \u0627\u0644\u0645\u0634\u0631\u0648\u0639 \u0645\u0633\u0624\u0648\u0644 \u0648\u0627\u062D\u062F \u0639\u0644\u0649 \u0627\u0644\u0623\u0642\u0644. \u0639\u064A\u0651\u0646 \u0645\u0633\u0624\u0648\u0644\u064B\u0627 \u0622\u062E\u0631 \u0642\u0628\u0644 \u0625\u0632\u0627\u0644\u0629 \u0647\u0630\u0627 \u0627\u0644\u0645\u0633\u0624\u0648\u0644.",
      notActiveMember: "\u0623\u062D\u062F \u0627\u0644\u0623\u0634\u062E\u0627\u0635 \u0627\u0644\u0645\u0636\u0627\u0641\u064A\u0646 \u0644\u0645 \u064A\u0639\u062F \u0639\u0636\u0648\u064B\u0627 \u0646\u0634\u0637\u064B\u0627 \u0641\u064A \u0627\u0644\u0645\u0643\u062A\u0628. \u0623\u0632\u0644\u0647 \u0645\u0646 \u0627\u0644\u0642\u0627\u0626\u0645\u0629 \u062B\u0645 \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629.",
      invalid: "\u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u0623\u0639\u0636\u0627\u0621 \u063A\u064A\u0631 \u0635\u0627\u0644\u062D\u0629. \u062A\u062D\u0642\u0642 \u0645\u0646\u0647\u0627 \u062B\u0645 \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629."
    }
  },
  phases: {
    title: "\u0627\u0644\u0645\u0631\u0627\u062D\u0644",
    readOnlyNotice: "\u064A\u0645\u0643\u0646 \u0644\u0645\u0633\u0624\u0648\u0644\u064A \u0627\u0644\u0645\u0634\u0631\u0648\u0639 \u0648\u062D\u062F\u0647\u0645 \u062A\u0639\u062F\u064A\u0644 \u0627\u0644\u0645\u0631\u0627\u062D\u0644.",
    loadFailedTitle: "\u062A\u0639\u0630\u0651\u0631 \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0645\u0631\u0627\u062D\u0644",
    loadFailedBody: "\u062A\u062D\u0642\u0651\u0642 \u0645\u0646 \u0627\u062A\u0635\u0627\u0644\u0643 \u062B\u0645 \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629.",
    empty: {
      title: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0645\u0631\u0627\u062D\u0644 \u0641\u064A \u0647\u0630\u0627 \u0627\u0644\u0645\u0634\u0631\u0648\u0639 \u0628\u0639\u062F",
      description: "\u0633\u062A\u0638\u0647\u0631 \u0645\u0631\u0627\u062D\u0644 \u0627\u0644\u0645\u0634\u0631\u0648\u0639 \u0647\u0646\u0627 \u0628\u0645\u062C\u0631\u062F \u0623\u0646 \u064A\u0636\u064A\u0641\u0647\u0627 \u0627\u0644\u0645\u0633\u0624\u0648\u0644.",
      descriptionManage: "\u0623\u0636\u0641 \u0627\u0644\u0645\u0631\u062D\u0644\u0629 \u0627\u0644\u0623\u0648\u0644\u0649 \u0644\u062A\u062E\u0637\u064A\u0637 \u0627\u0644\u0645\u0647\u0645\u0629."
    },
    timelineLabel: "\u0627\u0644\u062C\u062F\u0648\u0644 \u0627\u0644\u0632\u0645\u0646\u064A \u0644\u0645\u0631\u0627\u062D\u0644 \u0627\u0644\u0645\u0634\u0631\u0648\u0639",
    tableCaption: "\u0645\u0631\u0627\u062D\u0644 \u0627\u0644\u0645\u0634\u0631\u0648\u0639",
    columns: {
      order: "\u0627\u0644\u0631\u0642\u0645",
      phase: "\u0627\u0644\u0645\u0631\u062D\u0644\u0629",
      planned: "\u0627\u0644\u0645\u062E\u0637\u0637",
      actual: "\u0627\u0644\u0641\u0639\u0644\u064A",
      status: "\u0627\u0644\u062D\u0627\u0644\u0629",
      schedule: "\u0627\u0644\u0623\u062C\u0644",
      share: "\u0627\u0644\u0623\u062A\u0639\u0627\u0628",
      actions: "\u0627\u0644\u0625\u062C\u0631\u0627\u0621\u0627\u062A"
    },
    status: {
      not_started: "\u0644\u0645 \u062A\u0628\u062F\u0623",
      in_progress: "\u0642\u064A\u062F \u0627\u0644\u062A\u0646\u0641\u064A\u0630",
      in_review: "\u0642\u064A\u062F \u0627\u0644\u0645\u0631\u0627\u062C\u0639\u0629",
      closed: "\u0645\u063A\u0644\u0642\u0629"
    },
    schedule: {
      not_planned: "\u063A\u064A\u0631 \u0645\u0628\u0631\u0645\u062C\u0629",
      on_track: "\u0636\u0645\u0646 \u0627\u0644\u0622\u062C\u0627\u0644",
      late_start: "{count, plural, one {\u0628\u062F\u0627\u064A\u0629 \u0645\u062A\u0623\u062E\u0631\u0629 \u0628\u064A\u0648\u0645 \u0648\u0627\u062D\u062F} two {\u0628\u062F\u0627\u064A\u0629 \u0645\u062A\u0623\u062E\u0631\u0629 \u0628\u064A\u0648\u0645\u064A\u0646} few {\u0628\u062F\u0627\u064A\u0629 \u0645\u062A\u0623\u062E\u0631\u0629 \u0628\u0640 # \u0623\u064A\u0627\u0645} many {\u0628\u062F\u0627\u064A\u0629 \u0645\u062A\u0623\u062E\u0631\u0629 \u0628\u0640 # \u064A\u0648\u0645\u064B\u0627} other {\u0628\u062F\u0627\u064A\u0629 \u0645\u062A\u0623\u062E\u0631\u0629 \u0628\u0640 # \u064A\u0648\u0645}}",
      overdue: "{count, plural, one {\u0645\u062A\u0623\u062E\u0631\u0629 \u0628\u064A\u0648\u0645 \u0648\u0627\u062D\u062F} two {\u0645\u062A\u0623\u062E\u0631\u0629 \u0628\u064A\u0648\u0645\u064A\u0646} few {\u0645\u062A\u0623\u062E\u0631\u0629 \u0628\u0640 # \u0623\u064A\u0627\u0645} many {\u0645\u062A\u0623\u062E\u0631\u0629 \u0628\u0640 # \u064A\u0648\u0645\u064B\u0627} other {\u0645\u062A\u0623\u062E\u0631\u0629 \u0628\u0640 # \u064A\u0648\u0645}}",
      done: "\u0623\u064F\u0646\u062C\u0632\u062A \u0636\u0645\u0646 \u0627\u0644\u0622\u062C\u0627\u0644",
      done_late: "{count, plural, one {\u0623\u064F\u0646\u062C\u0632\u062A \u0628\u062A\u0623\u062E\u0631 \u064A\u0648\u0645 \u0648\u0627\u062D\u062F} two {\u0623\u064F\u0646\u062C\u0632\u062A \u0628\u062A\u0623\u062E\u0631 \u064A\u0648\u0645\u064A\u0646} few {\u0623\u064F\u0646\u062C\u0632\u062A \u0628\u062A\u0623\u062E\u0631 # \u0623\u064A\u0627\u0645} many {\u0623\u064F\u0646\u062C\u0632\u062A \u0628\u062A\u0623\u062E\u0631 # \u064A\u0648\u0645\u064B\u0627} other {\u0623\u064F\u0646\u062C\u0632\u062A \u0628\u062A\u0623\u062E\u0631 # \u064A\u0648\u0645}}"
    },
    shares: {
      total: "\u0645\u062C\u0645\u0648\u0639 \u062D\u0635\u0635 \u0627\u0644\u0623\u062A\u0639\u0627\u0628 \u062D\u0633\u0628 \u0627\u0644\u0645\u0631\u062D\u0644\u0629: {total}",
      warningTitle: "\u062D\u0635\u0635 \u0627\u0644\u0623\u062A\u0639\u0627\u0628 \u062A\u062D\u062A\u0627\u062C \u0625\u0644\u0649 \u0645\u0631\u0627\u062C\u0639\u0629",
      warning: "\u0645\u062C\u0645\u0648\u0639 \u062D\u0635\u0635 \u0627\u0644\u0623\u062A\u0639\u0627\u0628 \u0647\u0648 {total} \u0628\u062F\u0644 \u2066100%\u2069. \u0647\u0630\u0627 \u0644\u0627 \u064A\u0645\u0646\u0639 \u0627\u0644\u0639\u0645\u0644: \u0639\u062F\u0651\u0644\u0647\u0627 \u0645\u062A\u0649 \u0634\u0626\u062A."
    },
    actions: {
      moveUp: "\u062A\u062D\u0631\u064A\u0643 \u0627\u0644\u0645\u0631\u062D\u0644\u0629 {name} \u0625\u0644\u0649 \u0627\u0644\u0623\u0639\u0644\u0649",
      moveDown: "\u062A\u062D\u0631\u064A\u0643 \u0627\u0644\u0645\u0631\u062D\u0644\u0629 {name} \u0625\u0644\u0649 \u0627\u0644\u0623\u0633\u0641\u0644",
      edit: "\u062A\u0639\u062F\u064A\u0644 \u0627\u0644\u0645\u0631\u062D\u0644\u0629 {name}",
      details: "\u0639\u0631\u0636 \u0627\u0644\u0645\u0631\u062D\u0644\u0629 {name}",
      close: "\u0625\u063A\u0644\u0627\u0642 \u0627\u0644\u0645\u0631\u062D\u0644\u0629 {name}"
    },
    reordered: "\u062A\u0645 \u062A\u062D\u062F\u064A\u062B \u062A\u0631\u062A\u064A\u0628 \u0627\u0644\u0645\u0631\u0627\u062D\u0644.",
    add: {
      open: "\u0625\u0636\u0627\u0641\u0629 \u0645\u0631\u062D\u0644\u0629",
      title: "\u0625\u0636\u0627\u0641\u0629 \u0645\u0631\u062D\u0644\u0629",
      type: "\u0646\u0648\u0639 \u0627\u0644\u0645\u0631\u062D\u0644\u0629",
      custom: "\u0645\u0631\u062D\u0644\u0629 \u0645\u062E\u0635\u0651\u0635\u0629",
      nameHint: "\u0627\u0633\u0645 \u0627\u0644\u0645\u0631\u062D\u0644\u0629 \u0643\u0645\u0627 \u0633\u064A\u0638\u0647\u0631 \u0641\u064A \u0627\u0644\u0645\u0634\u0631\u0648\u0639.",
      after: "\u0625\u062F\u0631\u0627\u062C\u0647\u0627 \u0628\u0639\u062F",
      afterEnd: "\u0641\u064A \u0646\u0647\u0627\u064A\u0629 \u0627\u0644\u0645\u0634\u0631\u0648\u0639",
      submit: "\u0625\u0636\u0627\u0641\u0629 \u0627\u0644\u0645\u0631\u062D\u0644\u0629",
      adding: "\u062C\u0627\u0631\u064D \u0627\u0644\u0625\u0636\u0627\u0641\u0629\u2026",
      added: "\u062A\u0645\u062A \u0625\u0636\u0627\u0641\u0629 \u0627\u0644\u0645\u0631\u062D\u0644\u0629 {name}."
    },
    panel: {
      label: "\u062A\u0641\u0627\u0635\u064A\u0644 \u0627\u0644\u0645\u0631\u062D\u0644\u0629 {name}",
      formLabel: "\u062A\u0639\u062F\u064A\u0644 \u0627\u0644\u0645\u0631\u062D\u0644\u0629 {name}",
      name: "\u0627\u0633\u0645 \u0627\u0644\u0645\u0631\u062D\u0644\u0629",
      plannedStart: "\u0627\u0644\u0628\u062F\u0627\u064A\u0629 \u0627\u0644\u0645\u062E\u0637\u0637\u0629",
      plannedEnd: "\u0627\u0644\u0646\u0647\u0627\u064A\u0629 \u0627\u0644\u0645\u062E\u0637\u0637\u0629",
      actualStart: "\u0627\u0644\u0628\u062F\u0627\u064A\u0629 \u0627\u0644\u0641\u0639\u0644\u064A\u0629",
      actualEnd: "\u0627\u0644\u0646\u0647\u0627\u064A\u0629 \u0627\u0644\u0641\u0639\u0644\u064A\u0629",
      share: "\u062D\u0635\u0629 \u0627\u0644\u0623\u062A\u0639\u0627\u0628",
      shareHint: "\u0646\u0633\u0628\u0629 \u0645\u0626\u0648\u064A\u0629 \u0645\u0646 \u0627\u0644\u0623\u062A\u0639\u0627\u0628\u060C \u0645\u062B\u0644 \u206612.5\u2069.",
      timeBudget: "\u0627\u0644\u0645\u064A\u0632\u0627\u0646\u064A\u0629 \u0627\u0644\u0632\u0645\u0646\u064A\u0629 (\u0628\u0627\u0644\u0633\u0627\u0639\u0627\u062A)",
      timeBudgetHint: "\u0627\u062E\u062A\u064A\u0627\u0631\u064A\u0629. \u0628\u062E\u0637\u0648\u0627\u062A \u0645\u0646 15 \u062F\u0642\u064A\u0642\u0629 (0.25 \u0633\u0627\u0639\u0629)\u060C \u0645\u062B\u0644 \u2066120\u2069 \u0623\u0648 \u206637.5\u2069. \u064A\u0646\u0628\u0651\u0647\u0643 \u0625\u0634\u0639\u0627\u0631 \u0639\u0646\u062F \u0627\u0633\u062A\u0647\u0644\u0627\u0643 80% \u0645\u0646 \u0627\u0644\u0645\u064A\u0632\u0627\u0646\u064A\u0629. \u0627\u062A\u0631\u0643\u0647\u0627 \u0641\u0627\u0631\u063A\u0629 \u0625\u0646 \u0644\u0645 \u062A\u062D\u062F\u062F \u0645\u064A\u0632\u0627\u0646\u064A\u0629.",
      timeBudgetView: "\u0627\u0644\u0645\u064A\u0632\u0627\u0646\u064A\u0629 \u0627\u0644\u0632\u0645\u0646\u064A\u0629",
      timeBudgetNone: "\u0628\u0644\u0627 \u0645\u064A\u0632\u0627\u0646\u064A\u0629",
      timeBudgetValue: "{hours} \u0633",
      statusHint: "\u062A\u062A\u0628\u0639 \u0627\u0644\u0645\u0631\u062D\u0644\u0629 \u0627\u0644\u062A\u0631\u062A\u064A\u0628: \u0644\u0645 \u062A\u0628\u062F\u0623\u060C \u0642\u064A\u062F \u0627\u0644\u062A\u0646\u0641\u064A\u0630\u060C \u0642\u064A\u062F \u0627\u0644\u0645\u0631\u0627\u062C\u0639\u0629. \u0644\u0644\u0627\u0646\u062A\u0647\u0627\u0621 \u0645\u0646\u0647\u0627 \u0627\u0633\u062A\u0639\u0645\u0644 \u0632\u0631 \xAB\u0625\u063A\u0644\u0627\u0642 \u0627\u0644\u0645\u0631\u062D\u0644\u0629\xBB.",
      save: "\u062D\u0641\u0638",
      saving: "\u062C\u0627\u0631\u064D \u0627\u0644\u062D\u0641\u0638\u2026",
      saved: "\u062A\u0645 \u062A\u062D\u062F\u064A\u062B \u0627\u0644\u0645\u0631\u062D\u0644\u0629 {name}.",
      stale: "\u0639\u062F\u0651\u0644 \u0634\u062E\u0635 \u0622\u062E\u0631 \u0627\u0644\u0645\u0631\u062D\u0644\u0629 {name}. \u0623\u064F\u0639\u064A\u062F \u062A\u062D\u0645\u064A\u0644\u0647\u0627: \u0637\u0628\u0651\u0642 \u062A\u063A\u064A\u064A\u0631\u0627\u062A\u0643 \u0645\u0646 \u062C\u062F\u064A\u062F.",
      closeAction: "\u0625\u063A\u0644\u0627\u0642 \u0627\u0644\u0645\u0631\u062D\u0644\u0629\u2026",
      closedNotice: "\u0647\u0630\u0647 \u0627\u0644\u0645\u0631\u062D\u0644\u0629 \u0645\u063A\u0644\u0642\u0629: \u0644\u0645 \u064A\u0639\u062F \u062A\u0639\u062F\u064A\u0644\u0647\u0627 \u0645\u0645\u0643\u0646\u064B\u0627.",
      closedOn: "\u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0625\u063A\u0644\u0627\u0642",
      waiver: "\u0627\u0633\u062A\u062B\u0646\u0627\u0621 \u0627\u0644\u0625\u063A\u0644\u0627\u0642"
    },
    errors: {
      required: "\u0647\u0630\u0627 \u0627\u0644\u062D\u0642\u0644 \u0625\u0644\u0632\u0627\u0645\u064A.",
      nameTooLong: "\u0644\u0627 \u064A\u0645\u0643\u0646 \u0623\u0646 \u064A\u062A\u062C\u0627\u0648\u0632 \u0627\u0644\u0627\u0633\u0645 \u2066120\u2069 \u062D\u0631\u0641\u064B\u0627.",
      datesPlanned: "\u0644\u0627 \u064A\u0645\u0643\u0646 \u0623\u0646 \u062A\u0633\u0628\u0642 \u0627\u0644\u0646\u0647\u0627\u064A\u0629 \u0627\u0644\u0645\u062E\u0637\u0637\u0629 \u0627\u0644\u0628\u062F\u0627\u064A\u0629 \u0627\u0644\u0645\u062E\u0637\u0637\u0629.",
      datesActual: "\u0644\u0627 \u064A\u0645\u0643\u0646 \u0623\u0646 \u062A\u0633\u0628\u0642 \u0627\u0644\u0646\u0647\u0627\u064A\u0629 \u0627\u0644\u0641\u0639\u0644\u064A\u0629 \u0627\u0644\u0628\u062F\u0627\u064A\u0629 \u0627\u0644\u0641\u0639\u0644\u064A\u0629.",
      datesInvalid: "\u0647\u0630\u0627 \u0627\u0644\u062A\u0627\u0631\u064A\u062E \u063A\u064A\u0631 \u0635\u0627\u0644\u062D.",
      shareInvalid: "\u0623\u062F\u062E\u0644 \u0646\u0633\u0628\u0629 \u0628\u064A\u0646 \u20660\u2069 \u0648\u2066100\u2069 \u0628\u062D\u062F \u0623\u0642\u0635\u0649 \u0631\u0642\u0645\u064A\u0646 \u0639\u0634\u0631\u064A\u064A\u0646.",
      typeTaken: "\u0644\u062F\u0649 \u0647\u0630\u0627 \u0627\u0644\u0645\u0634\u0631\u0648\u0639 \u0645\u0631\u062D\u0644\u0629 \u0645\u0646 \u0647\u0630\u0627 \u0627\u0644\u0646\u0648\u0639 \u0628\u0627\u0644\u0641\u0639\u0644. \u0627\u062E\u062A\u0631 \u0646\u0648\u0639\u064B\u0627 \u0622\u062E\u0631 \u0623\u0648 \u0645\u0631\u062D\u0644\u0629 \u0645\u062E\u0635\u0651\u0635\u0629.",
      statusTransition: "\u0647\u0630\u0627 \u0627\u0644\u062A\u063A\u064A\u064A\u0631 \u0641\u064A \u0627\u0644\u062D\u0627\u0644\u0629 \u063A\u064A\u0631 \u0645\u0645\u0643\u0646 \u0627\u0646\u0637\u0644\u0627\u0642\u064B\u0627 \u0645\u0646 \u0627\u0644\u062D\u0627\u0644\u0629 \u0627\u0644\u062D\u0627\u0644\u064A\u0629.",
      nameNotAllowed: "\u0627\u0644\u0645\u0631\u0627\u062D\u0644 \u0627\u0644\u0645\u062E\u0635\u0651\u0635\u0629 \u0648\u062D\u062F\u0647\u0627 \u0644\u0647\u0627 \u0627\u0633\u0645.",
      afterInvalid: "\u0627\u062E\u062A\u0631 \u0645\u0631\u062D\u0644\u0629 \u0645\u0646 \u0647\u0630\u0627 \u0627\u0644\u0645\u0634\u0631\u0648\u0639.",
      invalid: "\u0647\u0630\u0647 \u0627\u0644\u0642\u064A\u0645\u0629 \u063A\u064A\u0631 \u0635\u0627\u0644\u062D\u0629.",
      phaseClosed: "\u0647\u0630\u0647 \u0627\u0644\u0645\u0631\u062D\u0644\u0629 \u0645\u063A\u0644\u0642\u0629: \u0644\u0645 \u064A\u0639\u062F \u062A\u0639\u062F\u064A\u0644\u0647\u0627 \u0645\u0645\u0643\u0646\u064B\u0627.",
      feesForbidden: "\u0644\u064A\u0633 \u0644\u062F\u064A\u0643 \u0625\u0630\u0646 \u0628\u062A\u0639\u062F\u064A\u0644 \u062D\u0635\u0635 \u0627\u0644\u0623\u062A\u0639\u0627\u0628.",
      contractDays: "\u0623\u062F\u062E\u0644 \u0639\u062F\u062F\u064B\u0627 \u0635\u062D\u064A\u062D\u064B\u0627 \u0645\u0646 \u0627\u0644\u0623\u064A\u0627\u0645 \u0628\u064A\u0646 1 \u06483650.",
      timeBudget: "\u0623\u062F\u062E\u0644 \u0639\u062F\u062F \u0633\u0627\u0639\u0627\u062A \u0628\u062E\u0637\u0648\u0627\u062A \u0642\u062F\u0631\u0647\u0627 0.25 (15 \u062F\u0642\u064A\u0642\u0629)\u060C \u0628\u064A\u0646 0.25 \u0648876000."
    }
  },
  close: {
    title: "\u0625\u063A\u0644\u0627\u0642 \u0627\u0644\u0645\u0631\u062D\u0644\u0629 {name}\u061F",
    rule: "\u062A\u064F\u063A\u0644\u0642 \u0627\u0644\u0645\u0631\u062D\u0644\u0629 \u0639\u0646\u062F\u0645\u0627 \u062A\u0643\u0648\u0646 \u062C\u0645\u064A\u0639 \u0645\u062E\u0631\u062C\u0627\u062A\u0647\u0627 \u0645\u0639\u062A\u0645\u062F\u0629 \u0623\u0648 \u0645\u064F\u0631\u0633\u064E\u0644\u0629. \u0648\u0625\u0644\u0627 \u064A\u0645\u0643\u0646\u0643 \u0625\u063A\u0644\u0627\u0642\u0647\u0627 \u0628\u0627\u0633\u062A\u062B\u0646\u0627\u0621 \u0645\u0628\u0631\u064E\u0651\u0631 \u0643\u062A\u0627\u0628\u064A\u064B\u0627\u060C \u0648\u064A\u064F\u062D\u0641\u0638 \u0641\u064A \u0633\u062C\u0644 \u0627\u0644\u0645\u0634\u0631\u0648\u0639.",
    allDone: "\u0644\u0627 \u064A\u0648\u062C\u062F \u0623\u064A \u0645\u062E\u0631\u062C \u0645\u0639\u0644\u0651\u0642 \u0641\u064A \u0647\u0630\u0647 \u0627\u0644\u0645\u0631\u062D\u0644\u0629: \u064A\u0645\u0643\u0646\u0643 \u0625\u063A\u0644\u0627\u0642\u0647\u0627.",
    unfinished: "{count, plural, one {\u0645\u062E\u0631\u062C \u0648\u0627\u062D\u062F \u0641\u064A \u0647\u0630\u0647 \u0627\u0644\u0645\u0631\u062D\u0644\u0629 \u063A\u064A\u0631 \u0645\u0639\u062A\u0645\u062F \u0648\u063A\u064A\u0631 \u0645\u064F\u0631\u0633\u064E\u0644.} two {\u0645\u062E\u0631\u062C\u0627\u0646 \u0641\u064A \u0647\u0630\u0647 \u0627\u0644\u0645\u0631\u062D\u0644\u0629 \u063A\u064A\u0631 \u0645\u0639\u062A\u0645\u062F\u064A\u0646 \u0648\u063A\u064A\u0631 \u0645\u064F\u0631\u0633\u064E\u0644\u064A\u0646.} few {# \u0645\u062E\u0631\u062C\u0627\u062A \u0641\u064A \u0647\u0630\u0647 \u0627\u0644\u0645\u0631\u062D\u0644\u0629 \u063A\u064A\u0631 \u0645\u0639\u062A\u0645\u062F\u0629 \u0648\u063A\u064A\u0631 \u0645\u064F\u0631\u0633\u064E\u0644\u0629.} many {# \u0645\u062E\u0631\u062C\u064B\u0627 \u0641\u064A \u0647\u0630\u0647 \u0627\u0644\u0645\u0631\u062D\u0644\u0629 \u063A\u064A\u0631 \u0645\u0639\u062A\u0645\u062F \u0648\u063A\u064A\u0631 \u0645\u064F\u0631\u0633\u064E\u0644.} other {# \u0645\u062E\u0631\u062C \u0641\u064A \u0647\u0630\u0647 \u0627\u0644\u0645\u0631\u062D\u0644\u0629 \u063A\u064A\u0631 \u0645\u0639\u062A\u0645\u062F \u0648\u063A\u064A\u0631 \u0645\u064F\u0631\u0633\u064E\u0644.}}",
    waiverLabel: "\u0633\u0628\u0628 \u0627\u0644\u0627\u0633\u062A\u062B\u0646\u0627\u0621",
    counter: "\u2066{count} / {min}\u2069 \u062D\u0631\u0641\u064B\u0627 \u0639\u0644\u0649 \u0627\u0644\u0623\u0642\u0644",
    counterOk: "{count, plural, one {\u062D\u0631\u0641 \u0648\u0627\u062D\u062F} two {\u062D\u0631\u0641\u0627\u0646} few {# \u0623\u062D\u0631\u0641} many {# \u062D\u0631\u0641\u064B\u0627} other {# \u062D\u0631\u0641}}",
    waiverKept: "\u064A\u064F\u062D\u0641\u0638 \u0647\u0630\u0627 \u0627\u0644\u0633\u0628\u0628 \u0641\u064A \u0633\u062C\u0644 \u0627\u0644\u0645\u0634\u0631\u0648\u0639.",
    changed: "\u062A\u063A\u064A\u0651\u0631\u062A \u0628\u0639\u0636 \u0627\u0644\u0645\u062E\u0631\u062C\u0627\u062A \u0645\u0646\u0630 \u0641\u062A\u062D \u0647\u0630\u0647 \u0627\u0644\u0646\u0627\u0641\u0630\u0629: \u0623\u0635\u0628\u062D \u0627\u0644\u0627\u0633\u062A\u062B\u0646\u0627\u0621 \u0636\u0631\u0648\u0631\u064A\u064B\u0627 \u0627\u0644\u0622\u0646.",
    confirm: "\u0625\u063A\u0644\u0627\u0642 \u0627\u0644\u0645\u0631\u062D\u0644\u0629",
    confirmWaiver: "\u0627\u0644\u0625\u063A\u0644\u0627\u0642 \u0645\u0639 \u0627\u0633\u062A\u062B\u0646\u0627\u0621",
    closing: "\u062C\u0627\u0631\u064D \u0627\u0644\u0625\u063A\u0644\u0627\u0642\u2026",
    done: "\u062A\u0645 \u0625\u063A\u0644\u0627\u0642 \u0627\u0644\u0645\u0631\u062D\u0644\u0629 {name}.",
    doneWaiver: "\u062A\u0645 \u0625\u063A\u0644\u0627\u0642 \u0627\u0644\u0645\u0631\u062D\u0644\u0629 {name} \u0645\u0639 \u0627\u0633\u062A\u062B\u0646\u0627\u0621.",
    alreadyClosed: "\u0627\u0644\u0645\u0631\u062D\u0644\u0629 {name} \u0645\u063A\u0644\u0642\u0629 \u0628\u0627\u0644\u0641\u0639\u0644.",
    errors: {
      waiverInvalid: "\u0627\u0643\u062A\u0628 \u0633\u0628\u0628\u064B\u0627 \u0645\u0646 \u2066{min}\u2069 \u062D\u0631\u0641\u064B\u0627 \u0639\u0644\u0649 \u0627\u0644\u0623\u0642\u0644."
    }
  },
  deliverables: {
    title: "\u0627\u0644\u0645\u062E\u0631\u062C\u0627\u062A",
    add: "\u0625\u0636\u0627\u0641\u0629 \u0645\u062E\u0631\u062C",
    readOnlyNotice: "\u064A\u0645\u0643\u0646 \u0644\u0645\u0633\u0624\u0648\u0644\u064A \u0627\u0644\u0645\u0634\u0631\u0648\u0639 \u0648\u062D\u062F\u0647\u0645 \u062A\u0639\u062F\u064A\u0644 \u0627\u0644\u0645\u062E\u0631\u062C\u0627\u062A.",
    loadFailedTitle: "\u062A\u0639\u0630\u0651\u0631 \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0645\u062E\u0631\u062C\u0627\u062A",
    empty: {
      title: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0645\u0631\u0627\u062D\u0644 \u0641\u064A \u0647\u0630\u0627 \u0627\u0644\u0645\u0634\u0631\u0648\u0639 \u0628\u0639\u062F",
      description: "\u062A\u064F\u0631\u062A\u064E\u0651\u0628 \u0627\u0644\u0645\u062E\u0631\u062C\u0627\u062A \u062D\u0633\u0628 \u0627\u0644\u0645\u0631\u062D\u0644\u0629: \u0633\u062A\u0638\u0647\u0631 \u0645\u0631\u0627\u062D\u0644 \u0627\u0644\u0645\u0634\u0631\u0648\u0639 \u0647\u0646\u0627 \u0628\u0645\u062C\u0631\u062F \u0625\u0636\u0627\u0641\u062A\u0647\u0627."
    },
    phaseEmpty: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0645\u062E\u0631\u062C\u0627\u062A \u0641\u064A \u0647\u0630\u0647 \u0627\u0644\u0645\u0631\u062D\u0644\u0629.",
    tableCaption: "\u0645\u062E\u0631\u062C\u0627\u062A \u0627\u0644\u0645\u0631\u062D\u0644\u0629 {name}",
    columns: {
      title: "\u0627\u0644\u0645\u062E\u0631\u062C",
      type: "\u0627\u0644\u0646\u0648\u0639",
      discipline: "\u0627\u0644\u0627\u062E\u062A\u0635\u0627\u0635",
      status: "\u0627\u0644\u062D\u0627\u0644\u0629",
      due: "\u0627\u0644\u0623\u062C\u0644",
      actions: "\u0627\u0644\u0625\u062C\u0631\u0627\u0621\u0627\u062A"
    },
    types: {
      drawing: "\u0645\u062E\u0637\u0637",
      calculation_note: "\u0645\u0630\u0643\u0631\u0629 \u062D\u0633\u0627\u0628\u0627\u062A",
      report: "\u062A\u0642\u0631\u064A\u0631",
      specification: "\u0643\u0631\u0627\u0633 \u0634\u0631\u0648\u0637",
      bill_of_quantities: "\u062C\u062F\u0648\u0644 \u0627\u0644\u0643\u0645\u064A\u0627\u062A",
      estimate: "\u062A\u0642\u062F\u064A\u0631 \u0627\u0644\u0643\u0644\u0641\u0629",
      other: "\u0623\u062E\u0631\u0649"
    },
    statuses: {
      to_produce: "\u0644\u0644\u0625\u0646\u062C\u0627\u0632",
      in_progress: "\u0642\u064A\u062F \u0627\u0644\u0625\u0646\u062C\u0627\u0632",
      in_review: "\u0642\u064A\u062F \u0627\u0644\u0645\u0631\u0627\u062C\u0639\u0629",
      approved: "\u0645\u0639\u062A\u0645\u062F",
      transmitted: "\u0645\u064F\u0631\u0633\u064E\u0644"
    },
    noDiscipline: "\u0628\u062F\u0648\u0646 \u0627\u062E\u062A\u0635\u0627\u0635",
    closePhase: "\u0625\u063A\u0644\u0627\u0642 \u0627\u0644\u0645\u0631\u062D\u0644\u0629 {name}",
    closePhaseShort: "\u0625\u063A\u0644\u0627\u0642 \u0627\u0644\u0645\u0631\u062D\u0644\u0629",
    progress: "{done} \u0645\u0646 {total} \u0645\u0639\u062A\u0645\u062F \u0623\u0648 \u0645\u064F\u0631\u0633\u064E\u0644",
    closedOn: "\u062A\u0627\u0631\u064A\u062E \u0625\u063A\u0644\u0627\u0642 \u0627\u0644\u0645\u0631\u062D\u0644\u0629:",
    waiver: "\u0627\u0633\u062A\u062B\u0646\u0627\u0621: {reason}",
    edit: "\u062A\u0639\u062F\u064A\u0644 \u0627\u0644\u0645\u062E\u0631\u062C {title}",
    dialog: {
      addTitle: "\u0625\u0636\u0627\u0641\u0629 \u0645\u062E\u0631\u062C",
      editTitle: "\u062A\u0639\u062F\u064A\u0644 \u0627\u0644\u0645\u062E\u0631\u062C",
      phase: "\u0627\u0644\u0645\u0631\u062D\u0644\u0629",
      title: "\u0639\u0646\u0648\u0627\u0646 \u0627\u0644\u0645\u062E\u0631\u062C",
      type: "\u0627\u0644\u0646\u0648\u0639",
      discipline: "\u0627\u0644\u0627\u062E\u062A\u0635\u0627\u0635",
      due: "\u0627\u0644\u0623\u062C\u0644",
      status: "\u0627\u0644\u062D\u0627\u0644\u0629",
      save: "\u062D\u0641\u0638",
      saving: "\u062C\u0627\u0631\u064D \u0627\u0644\u062D\u0641\u0638\u2026",
      added: "\u062A\u0645\u062A \u0625\u0636\u0627\u0641\u0629 \u0627\u0644\u0645\u062E\u0631\u062C {title}.",
      updated: "\u062A\u0645 \u062A\u062D\u062F\u064A\u062B \u0627\u0644\u0645\u062E\u0631\u062C {title}.",
      stale: "\u0639\u062F\u0651\u0644 \u0634\u062E\u0635 \u0622\u062E\u0631 \u0627\u0644\u0645\u062E\u0631\u062C {title}. \u0623\u064F\u0639\u064A\u062F \u062A\u062D\u0645\u064A\u0644\u0647: \u0637\u0628\u0651\u0642 \u062A\u063A\u064A\u064A\u0631\u0627\u062A\u0643 \u0645\u0646 \u062C\u062F\u064A\u062F."
    },
    errors: {
      required: "\u0647\u0630\u0627 \u0627\u0644\u062D\u0642\u0644 \u0625\u0644\u0632\u0627\u0645\u064A.",
      titleTooLong: "\u0644\u0627 \u064A\u0645\u0643\u0646 \u0623\u0646 \u064A\u062A\u062C\u0627\u0648\u0632 \u0627\u0644\u0639\u0646\u0648\u0627\u0646 \u2066200\u2069 \u062D\u0631\u0641.",
      phaseInvalid: "\u0627\u062E\u062A\u0631 \u0645\u0631\u062D\u0644\u0629 \u0645\u0641\u062A\u0648\u062D\u0629 \u0645\u0646 \u0647\u0630\u0627 \u0627\u0644\u0645\u0634\u0631\u0648\u0639.",
      phaseClosed: "\u0647\u0630\u0647 \u0627\u0644\u0645\u0631\u062D\u0644\u0629 \u0645\u063A\u0644\u0642\u0629: \u0644\u0645 \u064A\u0639\u062F \u062A\u0639\u062F\u064A\u0644 \u0645\u062E\u0631\u062C\u0627\u062A\u0647\u0627 \u0645\u0645\u0643\u0646\u064B\u0627.",
      invalid: "\u0647\u0630\u0647 \u0627\u0644\u0642\u064A\u0645\u0629 \u063A\u064A\u0631 \u0635\u0627\u0644\u062D\u0629."
    }
  },
  meetings: {
    noSpaceTitle: "\u0627\u0644\u0627\u062C\u062A\u0645\u0627\u0639\u0627\u062A \u063A\u064A\u0631 \u0645\u062A\u0627\u062D\u0629",
    noSpaceBody: "\u0644\u064A\u0633 \u0644\u0647\u0630\u0627 \u0627\u0644\u0645\u0634\u0631\u0648\u0639 \u0645\u0633\u0627\u062D\u0629 \u0639\u0645\u0644 \u0628\u0639\u062F \u0644\u0627\u0633\u062A\u0636\u0627\u0641\u0629 \u0627\u0644\u0627\u062C\u062A\u0645\u0627\u0639\u0627\u062A."
  },
  calendarTab: {
    noSpaceTitle: "\u0627\u0644\u062A\u0642\u0648\u064A\u0645 \u063A\u064A\u0631 \u062C\u0627\u0647\u0632 \u0628\u0639\u062F",
    noSpaceBody: "\u0645\u0633\u0627\u062D\u0629 \u0627\u0644\u0645\u0634\u0631\u0648\u0639 \u0642\u064A\u062F \u0627\u0644\u0625\u0646\u0634\u0627\u0621. \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629 \u0628\u0639\u062F \u0642\u0644\u064A\u0644."
  },
  workspace: {
    title: "\u0641\u0636\u0627\u0621 \u0627\u0644\u0645\u0634\u0631\u0648\u0639",
    open: "\u0641\u0636\u0627\u0621 \u0627\u0644\u0645\u0634\u0631\u0648\u0639",
    openHint: "\u0641\u062A\u062D \u0647\u0630\u0627 \u0627\u0644\u0645\u0634\u0631\u0648\u0639 \u0628\u0645\u0644\u0621 \u0627\u0644\u0634\u0627\u0634\u0629 \u0641\u064A \u0639\u0644\u0627\u0645\u0629 \u062A\u0628\u0648\u064A\u0628 \u062C\u062F\u064A\u062F\u0629",
    navLabel: "\u0623\u0642\u0633\u0627\u0645 \u0627\u0644\u0645\u0634\u0631\u0648\u0639",
    overview: "\u0646\u0638\u0631\u0629 \u0639\u0627\u0645\u0629",
    backToApp: "\u0627\u0644\u0639\u0648\u062F\u0629 \u0625\u0644\u0649 \u0627\u0644\u0639\u0631\u0636 \u0627\u0644\u0639\u0627\u062F\u064A",
    groups: {
      steer: "\u0627\u0644\u0642\u064A\u0627\u062F\u0629",
      documents: "\u0627\u0644\u0648\u062B\u0627\u0626\u0642",
      collaborate: "\u0627\u0644\u062A\u0639\u0627\u0648\u0646",
      manage: "\u0627\u0644\u0625\u062F\u0627\u0631\u0629"
    },
    kpis: {
      label: "\u0627\u0644\u0623\u0631\u0642\u0627\u0645 \u0627\u0644\u0631\u0626\u064A\u0633\u064A\u0629",
      phases: "\u0627\u0644\u0645\u0631\u0627\u062D\u0644 \u0627\u0644\u0645\u063A\u0644\u0642\u0629",
      openTasks: "\u0627\u0644\u0645\u0647\u0627\u0645 \u0627\u0644\u0645\u0641\u062A\u0648\u062D\u0629",
      openTasksCaption: "\u0642\u064A\u062F \u0627\u0644\u0625\u0646\u062C\u0627\u0632: {inProgress} \xB7 \u0645\u062A\u0648\u0642\u0641\u0629: {blocked}",
      lateTasks: "\u0627\u0644\u0645\u0647\u0627\u0645 \u0627\u0644\u0645\u062A\u0623\u062E\u0631\u0629",
      lateCaption: "\u062A\u062C\u0627\u0648\u0632\u062A \u0645\u0648\u0639\u062F\u0647\u0627: \u062A\u064F\u0639\u0627\u0644\u062C \u0623\u0648\u0644\u064B\u0627",
      onTimeCaption: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0645\u0647\u0645\u0629 \u0645\u062A\u0623\u062E\u0631\u0629",
      team: "\u0623\u0639\u0636\u0627\u0621 \u0627\u0644\u0641\u0631\u064A\u0642",
      teamCaption: "{count, plural, zero {\u0644\u0627 \u064A\u0648\u062C\u062F \u0645\u0633\u0624\u0648\u0644} one {\u0645\u0633\u0624\u0648\u0644 \u0648\u0627\u062D\u062F} two {\u0645\u0633\u0624\u0648\u0644\u0627\u0646} few {# \u0645\u0633\u0624\u0648\u0644\u064A\u0646} many {# \u0645\u0633\u0624\u0648\u0644\u064B\u0627} other {# \u0645\u0633\u0624\u0648\u0644}}"
    },
    deadlines: {
      title: "\u0627\u0644\u0645\u0648\u0627\u0639\u064A\u062F \u0627\u0644\u0642\u0627\u062F\u0645\u0629",
      all: "\u0643\u0644 \u0627\u0644\u0645\u0647\u0627\u0645",
      empty: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0645\u0647\u0645\u0629 \u0645\u0641\u062A\u0648\u062D\u0629 \u0644\u0647\u0627 \u0645\u0648\u0639\u062F \u0646\u0647\u0627\u0626\u064A."
    },
    statusCard: {
      title: "\u0627\u0644\u0645\u0647\u0627\u0645 \u062D\u0633\u0628 \u0627\u0644\u062D\u0627\u0644\u0629",
      empty: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0645\u0647\u0627\u0645 \u0628\u0639\u062F.",
      count: "\u0627\u0644\u0639\u062F\u062F",
      share: "\u0627\u0644\u0646\u0633\u0628\u0629"
    },
    phasesCard: {
      title: "\u0645\u0631\u0627\u062D\u0644 \u0627\u0644\u0645\u0634\u0631\u0648\u0639",
      all: "\u0625\u062F\u0627\u0631\u0629 \u0627\u0644\u0645\u0631\u0627\u062D\u0644"
    },
    facts: {
      title: "\u0628\u0637\u0627\u0642\u0629 \u0627\u0644\u0645\u0634\u0631\u0648\u0639",
      edit: "\u062A\u0639\u062F\u064A\u0644",
      none: "\u063A\u064A\u0631 \u0645\u062D\u062F\u062F",
      surface: "{value, number} \u0645\xB2"
    },
    teamCard: {
      title: "\u0641\u0631\u064A\u0642 \u0627\u0644\u0645\u0634\u0631\u0648\u0639",
      manage: "\u0625\u062F\u0627\u0631\u0629 \u0627\u0644\u0623\u0639\u0636\u0627\u0621",
      empty: "\u0644\u0627 \u064A\u0648\u062C\u062F \u0623\u0639\u0636\u0627\u0621 \u0628\u0639\u062F."
    }
  }
};

// locales/en/projects.json
var projects_default2 = {
  title: "Projects",
  none: "\u2014",
  orgTemplates: {
    title: "Project templates",
    intro: "Office templates set the starting structure of your projects: phases, folders, discussion channels and starter tasks. No document, person or date is stored in them.",
    new: "New template",
    showArchived: "Show archived templates",
    loadFailed: "The templates could not be loaded. Try again in a moment.",
    caption: "The office's project templates",
    columns: {
      name: "Template",
      content: "Content",
      author: "Author",
      updated: "Updated",
      actions: "Actions"
    },
    archivedBadge: "Archived",
    summary: "{phases, plural, one {# phase} other {# phases}} \xB7 {folders, plural, one {# folder} other {# folders}} \xB7 {channels, plural, one {# channel} other {# channels}} \xB7 {tasks, plural, one {# task} other {# tasks}}",
    empty: {
      title: "No templates yet",
      body: "Write a template, or save an existing project as a template from its settings."
    },
    emptyArchived: {
      title: "No archived templates",
      body: "Templates you archive are no longer offered when creating a project; they are kept here."
    },
    actions: {
      edit: "Edit template {name}",
      editShort: "Edit",
      archive: "Archive template {name}",
      archiveShort: "Archive",
      restore: "Restore template {name}",
      restoreShort: "Restore",
      delete: "Delete template {name}",
      deleteShort: "Delete",
      authorOnly: "Only its author and administrators can change it"
    },
    archive: {
      done: 'Template "{name}" is archived: it is no longer offered when creating a project.'
    },
    restore: {
      done: 'Template "{name}" is offered again when creating a project.'
    },
    delete: {
      title: 'Delete template "{name}"?',
      body: "Projects already created from this template do not change. This cannot be undone; to keep it without offering it, archive it instead.",
      confirm: "Delete template",
      done: 'Template "{name}" was deleted.'
    },
    stale: "Someone else changed this template. Reload the list, then apply your changes again.",
    saved: 'Template "{name}" was saved.',
    created: 'Template "{name}" was created.',
    editor: {
      formLabel: "Project template",
      newTitle: "New project template",
      editTitle: 'Edit template "{name}"',
      intro: "Describe what a new project contains at the start. Fields marked with an asterisk are required.",
      name: "Template name",
      description: "Description",
      descriptionHint: "Optional, {max} characters at most. < and > are not accepted.",
      structureLocked: "Fee shares are reserved for people who may read fees: you can change the name and the description, but not the structure of this template.",
      save: "Save template",
      saving: "Saving\u2026"
    },
    phases: {
      title: "Phases",
      count: "{count} of {max}",
      hint: "Each standard phase can be used once. Add custom phases for anything else.",
      total: "Fee total: {total} of 100%",
      totalOver: "the total is over 100%",
      noFees: "You do not have access to fees: shares are neither shown nor saved.",
      position: "Phase {position}",
      moveUp: "Move phase {position} up",
      moveDown: "Move phase {position} down",
      remove: "Remove phase {position}",
      type: "Phase type",
      customName: "Phase name",
      nameOptional: "Displayed name (optional)",
      share: "Fee share (%)",
      shareHint: "For example 12.5. The total stays at or under 100%.",
      days: "Contract duration (days)",
      daysHint: "Optional, between 1 and 3,650.",
      add: "Add a phase"
    },
    folders: {
      title: "Folders",
      count: "{count} of {max}",
      hint: `Up to {depth} levels. Use a row's "subfolder" button to nest.`,
      empty: "No folders: the project will start without a folder tree.",
      name: "Folder name (level {level})",
      unnamed: "(unnamed)",
      moveUp: "Move folder {name} up",
      moveDown: "Move folder {name} down",
      remove: "Remove folder {name} and its content",
      addChild: "Add a subfolder in {name}",
      add: "Add a folder"
    },
    channels: {
      title: "Discussion channels",
      count: "{count} of {max}",
      hint: "A general channel for everyone, or a channel for one discipline.",
      empty: "No channels: the project will start without discussions.",
      unnamed: "(unnamed)",
      name: "Channel name",
      kind: "Channel type",
      kinds: {
        general: "General",
        discipline: "By discipline"
      },
      discipline: "Discipline",
      disciplineChoose: "Choose a discipline",
      moveUp: "Move channel {name} up",
      moveDown: "Move channel {name} down",
      remove: "Remove channel {name}",
      add: "Add a channel"
    },
    tasks: {
      title: "Starter tasks",
      count: "{count} of {max}",
      hint: "Each task can belong to a phase of the template and carry a checklist.",
      empty: "No tasks: the project will start without tasks.",
      unnamed: "(untitled)",
      taskTitle: "Task title",
      phase: "Phase",
      phaseNone: "No phase",
      discipline: "Discipline",
      disciplineNone: "No discipline",
      moveUp: "Move task {title} up",
      moveDown: "Move task {title} down",
      remove: "Remove task {title}",
      checklist: "Checklist of task {title}",
      checklistCount: "Checklist: {count} of {max}",
      checkItem: "Item {position} of task {title}",
      checkMoveUp: "Move item {position} of task {title} up",
      checkMoveDown: "Move item {position} of task {title} down",
      checkRemove: "Remove item {position} of task {title}",
      checkAddFor: "Add an item to task {title}",
      checkAdd: "Add an item",
      add: "Add a task"
    },
    errors: {
      summary: "{count, plural, one {One field needs fixing.} other {# fields need fixing.}}",
      required: "This field is required.",
      tooLong: "{max} characters at most.",
      plain: "Use plain text, without < or >.",
      folderName: "A folder name has no / or \\ and does not start with a dot.",
      folderRepeated: "Two folders on the same level cannot have the same name.",
      foldersPerLevel: "A level holds {max} folders at most.",
      foldersMax: "A template holds {max} folders at most.",
      foldersDepth: "Folders nest {max} levels at most.",
      phasesNone: "Add at least one phase.",
      phasesMax: "A template holds {max} phases at most.",
      phaseRepeated: "This phase is already in the template. Choose another type or a custom phase.",
      customName: "Give this custom phase a name.",
      share: "Enter a percentage between 0 and 100, with two decimals at most.",
      shareTotal: "The fee shares total more than 100%. Reduce some shares.",
      days: "Enter a whole number of days between 1 and {max}.",
      channelsMax: "A template holds {max} channels at most.",
      channelDiscipline: "Choose this channel's discipline.",
      tasksMax: "A template holds {max} tasks at most.",
      taskPhase: "This phase is not in the template. Add it or choose another.",
      checklistMax: "A checklist holds {max} items at most.",
      invalid: "The template is not valid. Check the phases, folders, channels and tasks.",
      forbidden: "You are not allowed to do this on this template."
    }
  },
  archive: {
    banner: "This project is archived: it is read-only. Nothing in it can be changed until it is restored.",
    actions: {
      title: "Project actions"
    },
    archive: {
      action: "Archive project",
      help: "The project stays readable but can no longer be changed. Its documents count for half in the storage space.",
      confirmTitle: 'Archive project "{name}"?',
      confirmBody: "By archiving this project:",
      confirmReadOnly: "it becomes read-only: tasks, phases, deliverables, members, documents and discussions can no longer be changed;",
      confirmStorage: "its documents count for 50% of your storage space;",
      confirmRestore: 'you can restore it at any time; it then comes back with the status "Closed".',
      confirm: "Archive project",
      done: 'Project "{name}" is archived.'
    },
    restore: {
      action: "Restore project",
      help: 'The project can be changed again. It comes back with the status "Closed" and its documents count in full again.',
      done: 'Project "{name}" is restored. Its status is "Closed".'
    },
    saveTemplate: {
      action: "Save as template",
      help: "Keeps this project's phases, folders, channels and tasks to start other projects. No document, person or date is copied.",
      title: "Save this project as a template",
      intro: "The template takes the project's structure. You will find it under Administration, Project templates.",
      name: "Template name",
      description: "Description (optional)",
      nameRequired: "Give the template a name.",
      plain: "Use plain text, without < or >.",
      invalid: "This project cannot be saved as a template as it is. Check its phases.",
      submit: "Save template",
      saving: "Saving\u2026",
      done: 'Template "{name}" was created from the project.'
    },
    errors: {
      PROJECT_ARCHIVED: "This project is archived: it is read-only. Restore it to change it."
    }
  },
  status: {
    draft: "Draft",
    active: "In progress",
    on_hold: "On hold",
    closed: "Closed",
    archived: "Archived"
  },
  statusHints: {
    draft: "The project is being prepared: it has not started yet.",
    active: "The project is under way.",
    on_hold: "The project is temporarily suspended; it can resume.",
    closed: "The mission is finished. The project can be reopened if needed.",
    archived: 'The project is put away: it no longer shows in lists, except with the "Archived" filter.'
  },
  missionTypes: {
    public_building: "Public building",
    collective_housing: "Collective housing",
    villa: "Private villa",
    industrial: "Industrial building",
    facility: "Facility",
    subdivision_vrd: "Subdivision and utilities (VRD)",
    expertise: "Expert assessment"
  },
  phaseTypes: {
    esq: "ESQ",
    aps: "APS",
    apd: "APD",
    pro: "PRO",
    dce: "DCE",
    act: "ACT",
    det: "DET",
    aor_provisional: "AOR provisional",
    aor_final: "AOR final",
    custom: "Custom phase"
  },
  phaseNames: {
    esq: "Sketch design",
    aps: "Preliminary design",
    apd: "Detailed design",
    pro: "Project design",
    dce: "Tender documents",
    act: "Assistance with works contracts",
    det: "Works supervision",
    aor_provisional: "Assistance with provisional acceptance",
    aor_final: "Assistance with final acceptance",
    custom: "Custom phase"
  },
  feeModes: {
    lump_sum: "Lump sum",
    works_percentage: "Percentage of the works cost",
    time_based: "Time spent"
  },
  roles: {
    manager: "Manager",
    member: "Member"
  },
  tabs: {
    posts: "Posts",
    files: "Files",
    tasks: "Tasks",
    phases: "Phases",
    deliverables: "Deliverables",
    approvals: "Approvals",
    calendar: "Calendar",
    finance: "Finance",
    settings: "Settings",
    meetings: "Meetings",
    planning: "Planning",
    register: "Drawing register",
    checklists: "Checklists",
    observations: "Observations and snags",
    profitability: "Profitability"
  },
  profitability: {
    noAccessTitle: "Profitability not available",
    noAccessBody: "You do not have access to this project\u2019s profitability figures."
  },
  finance: {
    noAccessTitle: "Finance not available",
    noAccessBody: "You do not have access to the financial information of this project."
  },
  later: {
    posts: {
      title: "Project conversations will appear here",
      description: "Discussion channels by discipline (architecture, structure, utilities\u2026) and their posts will appear in this tab."
    },
    tasks: {
      title: "Project tasks will appear here",
      description: "The template's starter tasks and your team's tasks will be shown as a list and as a Kanban board."
    },
    phases: {
      title: "Project phases will appear here",
      description: "The phase timeline, from sketch to acceptance, with planned and actual dates, will appear in this tab."
    },
    deliverables: {
      title: "Project deliverables will appear here",
      description: "The deliverables of each phase and their approval status will appear in this tab."
    }
  },
  listPane: {
    title: "My projects",
    label: "My projects",
    empty: "You are not on any project yet.",
    loadFailed: "Your projects could not be loaded.",
    seeAll: "All projects",
    section: "Projects",
    count: "{count, plural, one {# project} other {# projects}}",
    filter: "Filter by name or code",
    noMatch: "No project matches this filter."
  },
  list: {
    tableCaption: "Office projects",
    columns: {
      name: "Project",
      code: "Code",
      client: "Client",
      missionType: "Mission type",
      status: "Status",
      phase: "Phases"
    },
    filters: {
      label: "Filter projects",
      search: "Search projects",
      searchPlaceholder: "Project name or code",
      status: "Filter by status",
      allStatuses: "All statuses",
      missionType: "Filter by mission type",
      allMissionTypes: "All mission types",
      client: "Filter by client",
      allClients: "All clients",
      mine: "My projects only",
      clear: "Clear filters"
    },
    view: {
      label: "Display mode",
      grid: "Grid",
      list: "List"
    },
    new: "New project",
    gridLabel: "Office projects",
    loadMore: "Show more projects",
    loadingMore: "Loading\u2026",
    loadFailedTitle: "Projects could not be loaded",
    loadFailedBody: "Check your connection and try again.",
    empty: {
      title: "No projects yet",
      description: "A project gathers the phases, files, tasks and conversations of a mission. Create it from a mission template to start with the usual phases and folders.",
      descriptionReadOnly: "A project gathers the phases, files, tasks and conversations of a mission. You are not on a project yet: ask a manager to add you to one or to create one.",
      filteredTitle: "No matching projects",
      filteredDescription: "Try another name or status, or remove a filter."
    }
  },
  card: {
    noClient: "No client",
    progress: "Phases closed: {closed} / {total}",
    noPhases: "No phases",
    currentPhase: "Current phase: {phase}",
    allClosed: "All phases are closed",
    progressLabel: "Phase progress of {name}"
  },
  create: {
    title: "New project",
    intro: "Choose the mission type first: the project starts with the usual phases, folders and tasks of that type.",
    submit: "Create project",
    saving: "Creating\u2026",
    done: 'Project "{name}" was created.',
    fields: {
      missionType: {
        label: "Mission type"
      },
      name: {
        label: "Project name",
        hint: 'For example "Kairouan pilot high school".'
      },
      code: {
        label: "Project code",
        hint: "Optional. If left empty, a code is generated (for example 2026-014)."
      },
      client: {
        label: "Client (project owner)",
        none: "No client yet",
        hint: "Optional. You can add it later."
      },
      governorate: {
        label: "Governorate",
        none: "Not specified"
      },
      startsOn: {
        label: "Start date",
        hint: "Optional. With a date, each phase gets indicative dates, one after the other."
      }
    },
    orgTemplate: {
      label: "Office template",
      hint: "Optional. An office template replaces the usual template of the mission type.",
      none: "None: the mission type's template",
      previewTitle: 'What the template "{name}" contains'
    },
    template: {
      title: "What this template contains",
      loading: "Loading the template\u2026",
      unavailable: "The template's content could not be loaded. You can still create the project.",
      phasesLabel: "Template phases, in order",
      share: "{share} of the fees",
      note: "Fee shares are indicative; you can adjust them in the Phases tab.",
      folders: "{count, plural, one {# folder created} other {# folders created}}",
      tasks: "{count, plural, one {# starter task} other {# starter tasks}}",
      channels: "{count, plural, one {# discussion channel} other {# discussion channels}}"
    },
    errors: {
      required: "This field is required.",
      nameTooLong: "The name cannot be longer than 200 characters.",
      templateNotAvailable: "This template is no longer available. Choose another one or go back to the mission type's template.",
      codeInvalid: "Use letters, digits and the signs . _ / - (30 characters at most), for example 2026-014.",
      codeTaken: "Another project of the office already uses this code. Choose another one.",
      invalid: "This value is not valid."
    }
  },
  detail: {
    project: "Project",
    notFoundTitle: "Project not found",
    notFoundBody: "This project does not exist, or you are not a member of it. Ask a project manager to add you.",
    backToList: "Back to projects",
    loadFailedTitle: "The project could not be loaded",
    loadFailedBody: "Check your connection and try again.",
    summaryLabel: "Project summary",
    code: "Code",
    client: "Client",
    noClient: "No client"
  },
  settings: {
    readOnlyNotice: "Only the project's managers can change this information.",
    formLabel: "Settings of {name}",
    save: "Save changes",
    saving: "Saving\u2026",
    reset: "Discard changes",
    saved: 'Project "{name}" was updated.',
    stale: 'Project "{name}" was changed by someone else. We reloaded it: check the values, then apply your changes again.',
    groups: {
      general: "General information",
      location: "Location",
      planning: "Dates",
      estimate: "Area and estimate",
      fees: "Fees",
      references: "References",
      status: "Project status"
    },
    fields: {
      missionType: "Mission type",
      name: "Project name",
      code: "Project code",
      codeHint: "Used on the project's documents and invoices.",
      client: "Client (project owner)",
      clientNone: "No client",
      governorate: "Governorate",
      governorateNone: "Not specified",
      delegation: "Delegation",
      startsOn: "Start date",
      endsOn: "Planned end date",
      surfaceM2: "Area (m\xB2)",
      surfaceHint: "Total area of the project, in square metres.",
      worksCostEstimate: "Works cost estimate",
      feeMode: "Fee calculation method",
      feeModeNone: "Not specified",
      feeAmount: "Fee amount",
      contractRef: "Contract reference",
      tunepsRef: "TUNEPS reference",
      tunepsHint: "Reference of the tender on the TUNEPS platform, for public contracts.",
      status: "Status"
    },
    errors: {
      required: "This field is required.",
      nameTooLong: "The name cannot be longer than 200 characters.",
      codeInvalid: "Use letters, digits and the signs . _ / - (30 characters at most), for example 2026-014.",
      codeTaken: "Another project of the office already uses this code. Choose another one.",
      surfaceInvalid: "Enter a whole area in square metres, at least 1.",
      datesOrder: "The planned end date cannot be before the start date.",
      statusTransition: "This status change is not possible from the current status.",
      clientNotAvailable: "This client is no longer available. Choose an active client.",
      feesForbidden: "You are not allowed to change the fees.",
      invalid: "This value is not valid."
    }
  },
  members: {
    title: "Project members",
    intro: "Members see this project and contribute to it; managers handle its settings. At least one manager is required.",
    tableCaption: "Project members",
    columns: {
      name: "Name",
      role: "Role",
      actions: "Actions"
    },
    you: "(you)",
    roleOf: "Role of {name}",
    remove: "Remove {name} from the project",
    add: {
      label: "Add a person from the office",
      placeholder: "Choose a person",
      button: "Add",
      none: "Every active person of the office is already on the project."
    },
    save: "Save members",
    saving: "Saving\u2026",
    reset: "Discard changes",
    saved: "The project members were updated.",
    loadFailed: "The project members could not be loaded. Check your connection and try again.",
    errors: {
      lastManager: "The project must keep at least one manager. Name another manager before removing this one.",
      notActiveMember: "One of the people added is no longer an active member of the office. Remove them from the list and try again.",
      invalid: "The member list is not valid. Check it and try again."
    }
  },
  phases: {
    title: "Phases",
    readOnlyNotice: "Only the project's managers can change the phases.",
    loadFailedTitle: "Could not load the phases",
    loadFailedBody: "Check your connection and try again.",
    empty: {
      title: "This project has no phases yet",
      description: "The phases of the project will appear here once a manager adds them.",
      descriptionManage: "Add the first phase to plan the mission."
    },
    timelineLabel: "Project phase timeline",
    tableCaption: "Project phases",
    columns: {
      order: "No.",
      phase: "Phase",
      planned: "Planned",
      actual: "Actual",
      status: "Status",
      schedule: "Timing",
      share: "Fees",
      actions: "Actions"
    },
    status: {
      not_started: "Not started",
      in_progress: "In progress",
      in_review: "In review",
      closed: "Closed"
    },
    schedule: {
      not_planned: "Not scheduled",
      on_track: "On track",
      late_start: "{count, plural, one {Start # day late} other {Start # days late}}",
      overdue: "{count, plural, one {# day late} other {# days late}}",
      done: "Done on time",
      done_late: "{count, plural, one {Done # day late} other {Done # days late}}"
    },
    shares: {
      total: "Total of the fee shares per phase: {total}",
      warningTitle: "Fee shares to check",
      warning: "The fee shares add up to {total} instead of 100%. This does not block anything: adjust them when you wish."
    },
    actions: {
      moveUp: "Move phase {name} up",
      moveDown: "Move phase {name} down",
      edit: "Edit phase {name}",
      details: "View phase {name}",
      close: "Close phase {name}"
    },
    reordered: "The order of the phases has been updated.",
    add: {
      open: "Add a phase",
      title: "Add a phase",
      type: "Phase type",
      custom: "Custom phase",
      nameHint: "The name of the phase as it will appear in the project.",
      after: "Insert after",
      afterEnd: "At the end of the project",
      submit: "Add the phase",
      adding: "Adding\u2026",
      added: "Phase {name} has been added."
    },
    panel: {
      label: "Details of phase {name}",
      formLabel: "Edit phase {name}",
      name: "Phase name",
      plannedStart: "Planned start",
      plannedEnd: "Planned end",
      actualStart: "Actual start",
      actualEnd: "Actual end",
      share: "Fee share",
      shareHint: "As a percentage of the fees, for example 12.5.",
      timeBudget: "Time budget (hours)",
      timeBudgetHint: "Optional. In steps of 15 minutes (0.25 h), for example 120 or 37.5. An alert warns you at 80% of the budget used. Leave empty for no budget.",
      timeBudgetView: "Time budget",
      timeBudgetNone: "No budget",
      timeBudgetValue: "{hours} h",
      statusHint: 'A phase follows the order: not started, in progress, in review. To finish it, use the "Close phase" button.',
      save: "Save",
      saving: "Saving\u2026",
      saved: "Phase {name} has been updated.",
      stale: "Phase {name} was changed by someone else. It has been reloaded: apply your changes again.",
      closeAction: "Close phase\u2026",
      closedNotice: "This phase is closed: it can no longer be edited.",
      closedOn: "Closing date",
      waiver: "Closing waiver"
    },
    errors: {
      required: "This field is required.",
      nameTooLong: "The name cannot exceed 120 characters.",
      datesPlanned: "The planned end cannot be before the planned start.",
      datesActual: "The actual end cannot be before the actual start.",
      datesInvalid: "This date is not valid.",
      shareInvalid: "Enter a percentage between 0 and 100, with at most two decimals.",
      typeTaken: "This project already has a phase of this type. Choose another type or a custom phase.",
      statusTransition: "This status change is not possible from the current status.",
      nameNotAllowed: "Only custom phases have a name.",
      afterInvalid: "Choose a phase of this project.",
      invalid: "This value is not valid.",
      phaseClosed: "This phase is closed: it can no longer be edited.",
      feesForbidden: "You are not allowed to change the fee shares.",
      contractDays: "Enter a whole number of days between 1 and 3,650.",
      timeBudget: "Enter a number of hours in steps of 0.25 (15 minutes), between 0.25 and 876,000."
    }
  },
  close: {
    title: "Close phase {name}?",
    rule: "A phase is closed when all its deliverables are approved or transmitted. Otherwise you can close it with a waiver, explained in writing: it is kept in the project history.",
    allDone: "No deliverable of this phase is pending: you can close it.",
    unfinished: "{count, plural, one {# deliverable of this phase is neither approved nor transmitted.} other {# deliverables of this phase are neither approved nor transmitted.}}",
    waiverLabel: "Reason for the waiver",
    counter: "{count} / {min} characters at least",
    counterOk: "{count, plural, one {# character} other {# characters}}",
    waiverKept: "This reason is kept in the project history.",
    changed: "Some deliverables changed since this window was opened: a waiver is now needed.",
    confirm: "Close the phase",
    confirmWaiver: "Close with a waiver",
    closing: "Closing\u2026",
    done: "Phase {name} is closed.",
    doneWaiver: "Phase {name} is closed with a waiver.",
    alreadyClosed: "Phase {name} is already closed.",
    errors: {
      waiverInvalid: "Write a reason of at least {min} characters."
    }
  },
  deliverables: {
    title: "Deliverables",
    add: "Add a deliverable",
    readOnlyNotice: "Only the project's managers can change the deliverables.",
    loadFailedTitle: "Could not load the deliverables",
    empty: {
      title: "This project has no phases yet",
      description: "Deliverables are grouped by phase: the phases of the project will appear here once added."
    },
    phaseEmpty: "No deliverable in this phase.",
    tableCaption: "Deliverables of phase {name}",
    columns: {
      title: "Deliverable",
      type: "Type",
      discipline: "Discipline",
      status: "Status",
      due: "Due",
      actions: "Actions"
    },
    types: {
      drawing: "Drawing",
      calculation_note: "Calculation note",
      report: "Report",
      specification: "Specification",
      bill_of_quantities: "Bill of quantities",
      estimate: "Estimate",
      other: "Other"
    },
    statuses: {
      to_produce: "To produce",
      in_progress: "In progress",
      in_review: "In review",
      approved: "Approved",
      transmitted: "Transmitted"
    },
    noDiscipline: "No discipline",
    closePhase: "Close phase {name}",
    closePhaseShort: "Close phase",
    progress: "{done} of {total} approved or transmitted",
    closedOn: "Phase closed on",
    waiver: "waiver: {reason}",
    edit: "Edit deliverable {title}",
    dialog: {
      addTitle: "Add a deliverable",
      editTitle: "Edit the deliverable",
      phase: "Phase",
      title: "Deliverable title",
      type: "Type",
      discipline: "Discipline",
      due: "Due date",
      status: "Status",
      save: "Save",
      saving: "Saving\u2026",
      added: "Deliverable {title} has been added.",
      updated: "Deliverable {title} has been updated.",
      stale: "Deliverable {title} was changed by someone else. It has been reloaded: apply your changes again."
    },
    errors: {
      required: "This field is required.",
      titleTooLong: "The title cannot exceed 200 characters.",
      phaseInvalid: "Choose an open phase of this project.",
      phaseClosed: "This phase is closed: its deliverables can no longer be edited.",
      invalid: "This value is not valid."
    }
  },
  meetings: {
    noSpaceTitle: "Meetings unavailable",
    noSpaceBody: "This project has no workspace yet to hold meetings."
  },
  calendarTab: {
    noSpaceTitle: "The calendar is not ready yet",
    noSpaceBody: "The project\u2019s space is being created. Try again in a moment."
  },
  workspace: {
    title: "Project workspace",
    open: "Project workspace",
    openHint: "Open this project full screen, in a new tab",
    navLabel: "Project sections",
    overview: "Overview",
    backToApp: "Back to the standard view",
    groups: {
      steer: "Steering",
      documents: "Documents",
      collaborate: "Collaboration",
      manage: "Management"
    },
    kpis: {
      label: "Key figures",
      phases: "Closed phases",
      openTasks: "Open tasks",
      openTasksCaption: "{inProgress} in progress \xB7 {blocked} blocked",
      lateTasks: "Late tasks",
      lateCaption: "Past their due date: deal with them first",
      onTimeCaption: "No late task",
      team: "Team members",
      teamCaption: "{count, plural, =0 {No manager} one {# manager} other {# managers}}"
    },
    deadlines: {
      title: "Next deadlines",
      all: "All tasks",
      empty: "No open task has a due date."
    },
    statusCard: {
      title: "Tasks by status",
      empty: "No task yet.",
      count: "Count",
      share: "Share"
    },
    phasesCard: {
      title: "Project phases",
      all: "Manage phases"
    },
    facts: {
      title: "Project sheet",
      edit: "Edit",
      none: "Not specified",
      surface: "{value, number} m\xB2"
    },
    teamCard: {
      title: "Project team",
      manage: "Manage members",
      empty: "No member yet."
    }
  }
};

// locales/fr/projects.json
var projects_default3 = {
  title: "Projets",
  none: "\u2014",
  orgTemplates: {
    title: "Mod\xE8les de projet",
    intro: "Les mod\xE8les du bureau fixent la structure de d\xE9part de vos projets\xA0: phases, dossiers, canaux de discussion et t\xE2ches de d\xE9marrage. Aucun document, aucune personne ni aucune date n'y est enregistr\xE9.",
    new: "Nouveau mod\xE8le",
    showArchived: "Afficher les mod\xE8les archiv\xE9s",
    loadFailed: "Les mod\xE8les n'ont pas pu \xEAtre charg\xE9s. R\xE9essayez dans un instant.",
    caption: "Mod\xE8les de projet du bureau",
    columns: {
      name: "Mod\xE8le",
      content: "Contenu",
      author: "Auteur",
      updated: "Modifi\xE9 le",
      actions: "Actions"
    },
    archivedBadge: "Archiv\xE9",
    summary: "{phases, plural, one {# phase} other {# phases}} \xB7 {folders, plural, one {# dossier} other {# dossiers}} \xB7 {channels, plural, one {# canal} other {# canaux}} \xB7 {tasks, plural, one {# t\xE2che} other {# t\xE2ches}}",
    empty: {
      title: "Aucun mod\xE8le pour le moment",
      body: "\xC9crivez un mod\xE8le, ou enregistrez un projet existant comme mod\xE8le depuis ses param\xE8tres."
    },
    emptyArchived: {
      title: "Aucun mod\xE8le archiv\xE9",
      body: "Les mod\xE8les que vous archivez n'apparaissent plus \xE0 la cr\xE9ation d'un projet\xA0; ils sont conserv\xE9s ici."
    },
    actions: {
      edit: "Modifier le mod\xE8le {name}",
      editShort: "Modifier",
      archive: "Archiver le mod\xE8le {name}",
      archiveShort: "Archiver",
      restore: "Restaurer le mod\xE8le {name}",
      restoreShort: "Restaurer",
      delete: "Supprimer le mod\xE8le {name}",
      deleteShort: "Supprimer",
      authorOnly: "R\xE9serv\xE9 \xE0 son auteur et aux administrateurs"
    },
    archive: {
      done: "Le mod\xE8le \xAB\xA0{name}\xA0\xBB est archiv\xE9\xA0: il n'est plus propos\xE9 \xE0 la cr\xE9ation d'un projet."
    },
    restore: {
      done: "Le mod\xE8le \xAB\xA0{name}\xA0\xBB est de nouveau propos\xE9 \xE0 la cr\xE9ation d'un projet."
    },
    delete: {
      title: "Supprimer le mod\xE8le \xAB\xA0{name}\xA0\xBB\xA0?",
      body: "Les projets d\xE9j\xE0 cr\xE9\xE9s avec ce mod\xE8le ne changent pas. Cette action est d\xE9finitive\xA0; pour le garder sans le proposer, archivez-le plut\xF4t.",
      confirm: "Supprimer le mod\xE8le",
      done: "Le mod\xE8le \xAB\xA0{name}\xA0\xBB a \xE9t\xE9 supprim\xE9."
    },
    stale: "Ce mod\xE8le a \xE9t\xE9 modifi\xE9 par quelqu'un d'autre. Rechargez la liste puis appliquez \xE0 nouveau vos changements.",
    saved: "Le mod\xE8le \xAB\xA0{name}\xA0\xBB a \xE9t\xE9 enregistr\xE9.",
    created: "Le mod\xE8le \xAB\xA0{name}\xA0\xBB a \xE9t\xE9 cr\xE9\xE9.",
    editor: {
      formLabel: "Mod\xE8le de projet",
      newTitle: "Nouveau mod\xE8le de projet",
      editTitle: "Modifier le mod\xE8le \xAB\xA0{name}\xA0\xBB",
      intro: "D\xE9crivez ce qu'un nouveau projet contient au d\xE9part. Les champs marqu\xE9s d'un ast\xE9risque sont obligatoires.",
      name: "Nom du mod\xE8le",
      description: "Description",
      descriptionHint: "Facultatif, {max} caract\xE8res au maximum. Ni < ni > ne sont accept\xE9s.",
      structureLocked: "Les parts d'honoraires sont r\xE9serv\xE9es aux personnes qui peuvent les consulter\xA0: vous pouvez changer le nom et la description, mais pas la structure de ce mod\xE8le.",
      save: "Enregistrer le mod\xE8le",
      saving: "Enregistrement\u2026"
    },
    phases: {
      title: "Phases",
      count: "{count} sur {max}",
      hint: "Les phases standard ne peuvent \xEAtre utilis\xE9es qu'une fois. Ajoutez des phases personnalis\xE9es pour le reste.",
      total: "Total des honoraires\xA0: {total} sur 100 %",
      totalOver: "le total d\xE9passe 100 %",
      noFees: "Vous n'avez pas acc\xE8s aux honoraires\xA0: les parts ne sont ni affich\xE9es ni enregistr\xE9es.",
      position: "Phase {position}",
      moveUp: "Monter la phase {position}",
      moveDown: "Descendre la phase {position}",
      remove: "Retirer la phase {position}",
      type: "Type de phase",
      customName: "Nom de la phase",
      nameOptional: "Nom affich\xE9 (facultatif)",
      share: "Part des honoraires (%)",
      shareHint: "Par exemple 12,5. Le total ne d\xE9passe pas 100 %.",
      days: "Dur\xE9e du contrat (jours)",
      daysHint: "Facultatif, entre 1 et 3 650.",
      add: "Ajouter une phase"
    },
    folders: {
      title: "Dossiers",
      count: "{count} sur {max}",
      hint: "Jusqu'\xE0 {depth} niveaux. Utilisez le bouton \xAB\xA0sous-dossier\xA0\xBB d'une ligne pour imbriquer.",
      empty: "Aucun dossier\xA0: le projet d\xE9marrera sans arborescence.",
      name: "Nom du dossier (niveau {level})",
      unnamed: "(sans nom)",
      moveUp: "Monter le dossier {name}",
      moveDown: "Descendre le dossier {name}",
      remove: "Retirer le dossier {name} et son contenu",
      addChild: "Ajouter un sous-dossier dans {name}",
      add: "Ajouter un dossier"
    },
    channels: {
      title: "Canaux de discussion",
      count: "{count} sur {max}",
      hint: "Un canal g\xE9n\xE9ral pour tous, ou un canal r\xE9serv\xE9 \xE0 une discipline.",
      empty: "Aucun canal\xA0: le projet d\xE9marrera sans discussion.",
      unnamed: "(sans nom)",
      name: "Nom du canal",
      kind: "Type de canal",
      kinds: {
        general: "G\xE9n\xE9ral",
        discipline: "Par discipline"
      },
      discipline: "Discipline",
      disciplineChoose: "Choisir une discipline",
      moveUp: "Monter le canal {name}",
      moveDown: "Descendre le canal {name}",
      remove: "Retirer le canal {name}",
      add: "Ajouter un canal"
    },
    tasks: {
      title: "T\xE2ches de d\xE9marrage",
      count: "{count} sur {max}",
      hint: "Chaque t\xE2che peut \xEAtre rattach\xE9e \xE0 une phase du mod\xE8le et porter une liste de points \xE0 cocher.",
      empty: "Aucune t\xE2che\xA0: le projet d\xE9marrera sans t\xE2che.",
      unnamed: "(sans titre)",
      taskTitle: "Titre de la t\xE2che",
      phase: "Phase",
      phaseNone: "Aucune phase",
      discipline: "Discipline",
      disciplineNone: "Aucune discipline",
      moveUp: "Monter la t\xE2che {title}",
      moveDown: "Descendre la t\xE2che {title}",
      remove: "Retirer la t\xE2che {title}",
      checklist: "Liste \xE0 cocher de la t\xE2che {title}",
      checklistCount: "Liste \xE0 cocher\xA0: {count} sur {max}",
      checkItem: "Point {position} de la t\xE2che {title}",
      checkMoveUp: "Monter le point {position} de la t\xE2che {title}",
      checkMoveDown: "Descendre le point {position} de la t\xE2che {title}",
      checkRemove: "Retirer le point {position} de la t\xE2che {title}",
      checkAddFor: "Ajouter un point \xE0 la t\xE2che {title}",
      checkAdd: "Ajouter un point",
      add: "Ajouter une t\xE2che"
    },
    errors: {
      summary: "{count, plural, one {Un champ est \xE0 corriger.} other {# champs sont \xE0 corriger.}}",
      required: "Ce champ est obligatoire.",
      tooLong: "{max} caract\xE8res au maximum.",
      plain: "Utilisez du texte simple, sans < ni >.",
      folderName: "Un nom de dossier ne contient ni / ni \\ et ne commence pas par un point.",
      folderRepeated: "Deux dossiers du m\xEAme niveau ne peuvent pas porter le m\xEAme nom.",
      foldersPerLevel: "Un niveau contient {max} dossiers au maximum.",
      foldersMax: "Un mod\xE8le contient {max} dossiers au maximum.",
      foldersDepth: "Les dossiers s'imbriquent sur {max} niveaux au maximum.",
      phasesNone: "Ajoutez au moins une phase.",
      phasesMax: "Un mod\xE8le contient {max} phases au maximum.",
      phaseRepeated: "Cette phase est d\xE9j\xE0 dans le mod\xE8le. Choisissez un autre type ou une phase personnalis\xE9e.",
      customName: "Donnez un nom \xE0 cette phase personnalis\xE9e.",
      share: "Saisissez un pourcentage entre 0 et 100, avec deux d\xE9cimales au plus.",
      shareTotal: "Le total des parts d'honoraires d\xE9passe 100 %. R\xE9duisez certaines parts.",
      days: "Saisissez un nombre entier de jours entre 1 et {max}.",
      channelsMax: "Un mod\xE8le contient {max} canaux au maximum.",
      channelDiscipline: "Choisissez la discipline de ce canal.",
      tasksMax: "Un mod\xE8le contient {max} t\xE2ches au maximum.",
      taskPhase: "Cette phase n'est pas dans le mod\xE8le. Ajoutez-la ou choisissez-en une autre.",
      checklistMax: "Une liste \xE0 cocher contient {max} points au maximum.",
      invalid: "Le mod\xE8le n'est pas valide. V\xE9rifiez les phases, les dossiers, les canaux et les t\xE2ches.",
      forbidden: "Vous n'avez pas le droit de faire cette action sur ce mod\xE8le."
    }
  },
  archive: {
    banner: "Ce projet est archiv\xE9\xA0: il est en lecture seule. Rien n'y est modifiable tant qu'il n'est pas restaur\xE9.",
    actions: {
      title: "Actions sur le projet"
    },
    archive: {
      action: "Archiver le projet",
      help: "Le projet reste consultable mais n'est plus modifiable. Ses documents comptent pour moiti\xE9 dans l'espace de stockage.",
      confirmTitle: "Archiver le projet \xAB\xA0{name}\xA0\xBB\xA0?",
      confirmBody: "En archivant ce projet\xA0:",
      confirmReadOnly: "il passe en lecture seule\xA0: t\xE2ches, phases, livrables, membres, documents et discussions ne peuvent plus \xEAtre modifi\xE9s\xA0;",
      confirmStorage: "ses documents comptent pour 50 % dans votre espace de stockage\xA0;",
      confirmRestore: "vous pourrez le restaurer \xE0 tout moment, il reviendra alors au statut \xAB\xA0Cl\xF4tur\xE9\xA0\xBB.",
      confirm: "Archiver le projet",
      done: "Le projet \xAB\xA0{name}\xA0\xBB est archiv\xE9."
    },
    restore: {
      action: "Restaurer le projet",
      help: "Le projet redevient modifiable. Il revient au statut \xAB\xA0Cl\xF4tur\xE9\xA0\xBB et ses documents comptent de nouveau en entier.",
      done: "Le projet \xAB\xA0{name}\xA0\xBB est restaur\xE9. Il est au statut \xAB\xA0Cl\xF4tur\xE9\xA0\xBB."
    },
    saveTemplate: {
      action: "Enregistrer comme mod\xE8le",
      help: "Conserve les phases, les dossiers, les canaux et les t\xE2ches de ce projet pour en d\xE9marrer d'autres. Aucun document, aucune personne ni aucune date n'est copi\xE9.",
      title: "Enregistrer ce projet comme mod\xE8le",
      intro: "Le mod\xE8le reprend la structure du projet. Vous le retrouverez dans Administration, Mod\xE8les de projet.",
      name: "Nom du mod\xE8le",
      description: "Description (facultatif)",
      nameRequired: "Donnez un nom au mod\xE8le.",
      plain: "Utilisez du texte simple, sans < ni >.",
      invalid: "Ce projet ne peut pas \xEAtre enregistr\xE9 tel quel comme mod\xE8le. V\xE9rifiez ses phases.",
      submit: "Enregistrer le mod\xE8le",
      saving: "Enregistrement\u2026",
      done: "Le mod\xE8le \xAB\xA0{name}\xA0\xBB a \xE9t\xE9 cr\xE9\xE9 \xE0 partir du projet."
    },
    errors: {
      PROJECT_ARCHIVED: "Ce projet est archiv\xE9\xA0: il est en lecture seule. Restaurez-le pour le modifier."
    }
  },
  status: {
    draft: "Brouillon",
    active: "En cours",
    on_hold: "En pause",
    closed: "Cl\xF4tur\xE9",
    archived: "Archiv\xE9"
  },
  statusHints: {
    draft: "Le projet se pr\xE9pare\xA0: il n'a pas encore d\xE9marr\xE9.",
    active: "Le projet est en cours.",
    on_hold: "Le projet est suspendu temporairement\xA0; il peut reprendre.",
    closed: "La mission est termin\xE9e. Le projet peut \xEAtre rouvert si besoin.",
    archived: "Le projet est rang\xE9\xA0: il n'appara\xEEt plus dans les listes, sauf avec le filtre \xAB\xA0Archiv\xE9\xA0\xBB."
  },
  missionTypes: {
    public_building: "B\xE2timent public",
    collective_housing: "Logement collectif",
    villa: "Villa individuelle",
    industrial: "B\xE2timent industriel",
    facility: "\xC9quipement",
    subdivision_vrd: "Lotissement et VRD",
    expertise: "Expertise"
  },
  phaseTypes: {
    esq: "ESQ",
    aps: "APS",
    apd: "APD",
    pro: "PRO",
    dce: "DCE",
    act: "ACT",
    det: "DET",
    aor_provisional: "AOR provisoire",
    aor_final: "AOR d\xE9finitive",
    custom: "Phase personnalis\xE9e"
  },
  phaseNames: {
    esq: "Esquisse",
    aps: "Avant-projet sommaire",
    apd: "Avant-projet d\xE9taill\xE9",
    pro: "Projet",
    dce: "Dossier de consultation des entreprises",
    act: "Assistance aux contrats de travaux",
    det: "Direction de l'ex\xE9cution des travaux",
    aor_provisional: "Assistance aux op\xE9rations de r\xE9ception provisoire",
    aor_final: "Assistance aux op\xE9rations de r\xE9ception d\xE9finitive",
    custom: "Phase personnalis\xE9e"
  },
  feeModes: {
    lump_sum: "Forfait",
    works_percentage: "Pourcentage du co\xFBt des travaux",
    time_based: "Au temps pass\xE9"
  },
  roles: {
    manager: "Responsable",
    member: "Membre"
  },
  tabs: {
    posts: "Publications",
    files: "Fichiers",
    tasks: "T\xE2ches",
    phases: "Phases",
    deliverables: "Livrables",
    approvals: "Visas",
    calendar: "Calendrier",
    finance: "Finance",
    settings: "Param\xE8tres",
    meetings: "R\xE9unions",
    planning: "Planning",
    register: "Registre des plans",
    checklists: "Check-lists",
    observations: "Observations et r\xE9serves",
    profitability: "Rentabilit\xE9"
  },
  profitability: {
    noAccessTitle: "Rentabilit\xE9 non disponible",
    noAccessBody: "Vous n\u2019avez pas acc\xE8s aux informations de rentabilit\xE9 de ce projet."
  },
  finance: {
    noAccessTitle: "Finance non disponible",
    noAccessBody: "Vous n\u2019avez pas acc\xE8s aux informations financi\xE8res de ce projet."
  },
  later: {
    posts: {
      title: "Les \xE9changes du projet arriveront ici",
      description: "Les canaux de discussion par discipline (architecture, structure, VRD\u2026) et leurs publications appara\xEEtront dans cet onglet."
    },
    tasks: {
      title: "Les t\xE2ches du projet arriveront ici",
      description: "Les t\xE2ches de d\xE9marrage du mod\xE8le et celles de votre \xE9quipe seront pr\xE9sent\xE9es en liste et en tableau Kanban."
    },
    phases: {
      title: "Les phases du projet arriveront ici",
      description: "La frise des phases, de l'esquisse \xE0 la r\xE9ception, avec les dates pr\xE9vues et r\xE9elles, appara\xEEtra dans cet onglet."
    },
    deliverables: {
      title: "Les livrables du projet arriveront ici",
      description: "Les livrables de chaque phase et leur \xE9tat d'approbation appara\xEEtront dans cet onglet."
    }
  },
  listPane: {
    title: "Mes projets",
    label: "Mes projets",
    empty: "Vous ne participez \xE0 aucun projet pour le moment.",
    loadFailed: "Impossible de charger vos projets.",
    seeAll: "Tous les projets",
    section: "Projets",
    count: "{count, plural, one {# projet} other {# projets}}",
    filter: "Filtrer par nom ou code",
    noMatch: "Aucun projet ne correspond \xE0 ce filtre."
  },
  list: {
    tableCaption: "Projets du bureau",
    columns: {
      name: "Projet",
      code: "Code",
      client: "Client",
      missionType: "Type de mission",
      status: "Statut",
      phase: "Phases"
    },
    filters: {
      label: "Filtrer les projets",
      search: "Rechercher un projet",
      searchPlaceholder: "Nom ou code du projet",
      status: "Filtrer par statut",
      allStatuses: "Tous les statuts",
      missionType: "Filtrer par type de mission",
      allMissionTypes: "Tous les types de mission",
      client: "Filtrer par client",
      allClients: "Tous les clients",
      mine: "Mes projets uniquement",
      clear: "Effacer les filtres"
    },
    view: {
      label: "Mode d'affichage",
      grid: "Grille",
      list: "Liste"
    },
    new: "Nouveau projet",
    gridLabel: "Projets du bureau",
    loadMore: "Afficher plus de projets",
    loadingMore: "Chargement\u2026",
    loadFailedTitle: "Impossible de charger les projets",
    loadFailedBody: "V\xE9rifiez votre connexion puis r\xE9essayez.",
    empty: {
      title: "Aucun projet pour l'instant",
      description: "Un projet regroupe les phases, les fichiers, les t\xE2ches et les \xE9changes d'une mission. Cr\xE9ez-le \xE0 partir d'un mod\xE8le de mission pour d\xE9marrer avec les phases et les dossiers habituels.",
      descriptionReadOnly: "Un projet regroupe les phases, les fichiers, les t\xE2ches et les \xE9changes d'une mission. Vous n'avez pas encore de projet\xA0: demandez \xE0 un responsable de vous ajouter \xE0 un projet ou d'en cr\xE9er un.",
      filteredTitle: "Aucun projet ne correspond",
      filteredDescription: "Essayez un autre nom, un autre statut ou retirez un filtre."
    }
  },
  card: {
    noClient: "Sans client",
    progress: "Phases cl\xF4tur\xE9es\xA0: {closed} / {total}",
    noPhases: "Aucune phase",
    currentPhase: "Phase en cours\xA0: {phase}",
    allClosed: "Toutes les phases sont cl\xF4tur\xE9es",
    progressLabel: "Avancement des phases de {name}"
  },
  create: {
    title: "Nouveau projet",
    intro: "Choisissez d'abord le type de mission\xA0: le projet d\xE9marre avec les phases, les dossiers et les t\xE2ches habituels de ce type.",
    submit: "Cr\xE9er le projet",
    saving: "Cr\xE9ation\u2026",
    done: "Le projet \xAB\xA0{name}\xA0\xBB a \xE9t\xE9 cr\xE9\xE9.",
    fields: {
      missionType: {
        label: "Type de mission"
      },
      name: {
        label: "Nom du projet",
        hint: "Par exemple \xAB\xA0Lyc\xE9e pilote de Kairouan\xA0\xBB."
      },
      code: {
        label: "Code du projet",
        hint: "Facultatif. Laiss\xE9 vide, un code est g\xE9n\xE9r\xE9 (par exemple 2026-014)."
      },
      client: {
        label: "Client (ma\xEEtre d'ouvrage)",
        none: "Aucun client pour l'instant",
        hint: "Facultatif. Vous pourrez l'ajouter plus tard."
      },
      governorate: {
        label: "Gouvernorat",
        none: "Non pr\xE9cis\xE9"
      },
      startsOn: {
        label: "Date de d\xE9marrage",
        hint: "Facultatif. Avec une date, chaque phase re\xE7oit des dates indicatives, l'une apr\xE8s l'autre."
      }
    },
    orgTemplate: {
      label: "Mod\xE8le du bureau",
      hint: "Facultatif. Un mod\xE8le du bureau remplace le mod\xE8le habituel du type de mission.",
      none: "Aucun\xA0: mod\xE8le du type de mission",
      previewTitle: "Ce que contient le mod\xE8le \xAB\xA0{name}\xA0\xBB"
    },
    template: {
      title: "Ce que contient ce mod\xE8le",
      loading: "Chargement du mod\xE8le\u2026",
      unavailable: "Le contenu du mod\xE8le n'a pas pu \xEAtre charg\xE9. Vous pouvez tout de m\xEAme cr\xE9er le projet.",
      phasesLabel: "Phases du mod\xE8le, dans l'ordre",
      share: "{share} des honoraires",
      note: "Les parts d'honoraires sont indicatives\xA0; vous pourrez les ajuster dans l'onglet Phases.",
      folders: "{count, plural, one {# dossier cr\xE9\xE9} other {# dossiers cr\xE9\xE9s}}",
      tasks: "{count, plural, one {# t\xE2che de d\xE9marrage} other {# t\xE2ches de d\xE9marrage}}",
      channels: "{count, plural, one {# canal de discussion} other {# canaux de discussion}}"
    },
    errors: {
      required: "Ce champ est obligatoire.",
      nameTooLong: "Le nom ne peut pas d\xE9passer 200 caract\xE8res.",
      templateNotAvailable: "Ce mod\xE8le n'est plus disponible. Choisissez-en un autre ou revenez au mod\xE8le du type de mission.",
      codeInvalid: "Utilisez des lettres, des chiffres et les signes . _ / - (30 caract\xE8res au maximum), par exemple 2026-014.",
      codeTaken: "Un autre projet du bureau utilise d\xE9j\xE0 ce code. Choisissez-en un autre.",
      invalid: "Cette valeur n'est pas valide."
    }
  },
  detail: {
    project: "Projet",
    notFoundTitle: "Projet introuvable",
    notFoundBody: "Ce projet n'existe pas, ou vous n'en \xEAtes pas membre. Demandez \xE0 un responsable du projet de vous y ajouter.",
    backToList: "Retour aux projets",
    loadFailedTitle: "Impossible de charger le projet",
    loadFailedBody: "V\xE9rifiez votre connexion puis r\xE9essayez.",
    summaryLabel: "R\xE9sum\xE9 du projet",
    code: "Code",
    client: "Client",
    noClient: "Sans client"
  },
  settings: {
    readOnlyNotice: "Seuls les responsables du projet peuvent modifier ces informations.",
    formLabel: "Param\xE8tres de {name}",
    save: "Enregistrer les modifications",
    saving: "Enregistrement\u2026",
    reset: "Annuler les modifications",
    saved: "Le projet \xAB\xA0{name}\xA0\xBB a \xE9t\xE9 mis \xE0 jour.",
    stale: "Le projet \xAB\xA0{name}\xA0\xBB a \xE9t\xE9 modifi\xE9 par quelqu'un d'autre. Nous l'avons recharg\xE9\xA0: v\xE9rifiez les valeurs puis appliquez \xE0 nouveau vos changements.",
    groups: {
      general: "Informations g\xE9n\xE9rales",
      location: "Lieu",
      planning: "Dates",
      estimate: "Surface et estimation",
      fees: "Honoraires",
      references: "R\xE9f\xE9rences",
      status: "Statut du projet"
    },
    fields: {
      missionType: "Type de mission",
      name: "Nom du projet",
      code: "Code du projet",
      codeHint: "Utilis\xE9 sur les documents et les factures du projet.",
      client: "Client (ma\xEEtre d'ouvrage)",
      clientNone: "Aucun client",
      governorate: "Gouvernorat",
      governorateNone: "Non pr\xE9cis\xE9",
      delegation: "D\xE9l\xE9gation",
      startsOn: "Date de d\xE9marrage",
      endsOn: "Date de fin pr\xE9vue",
      surfaceM2: "Surface (m\xB2)",
      surfaceHint: "Surface totale du projet, en m\xE8tres carr\xE9s.",
      worksCostEstimate: "Estimation du co\xFBt des travaux",
      feeMode: "Mode de calcul des honoraires",
      feeModeNone: "Non pr\xE9cis\xE9",
      feeAmount: "Montant des honoraires",
      contractRef: "R\xE9f\xE9rence du contrat",
      tunepsRef: "R\xE9f\xE9rence TUNEPS",
      tunepsHint: "R\xE9f\xE9rence de la consultation sur la plateforme TUNEPS, si le march\xE9 est public.",
      status: "Statut"
    },
    errors: {
      required: "Ce champ est obligatoire.",
      nameTooLong: "Le nom ne peut pas d\xE9passer 200 caract\xE8res.",
      codeInvalid: "Utilisez des lettres, des chiffres et les signes . _ / - (30 caract\xE8res au maximum), par exemple 2026-014.",
      codeTaken: "Un autre projet du bureau utilise d\xE9j\xE0 ce code. Choisissez-en un autre.",
      surfaceInvalid: "Indiquez une surface enti\xE8re en m\xE8tres carr\xE9s, d'au moins 1.",
      datesOrder: "La date de fin pr\xE9vue ne peut pas pr\xE9c\xE9der la date de d\xE9marrage.",
      statusTransition: "Ce changement de statut n'est pas possible depuis le statut actuel.",
      clientNotAvailable: "Ce client n'est plus disponible. Choisissez un client actif.",
      feesForbidden: "Vous n'avez pas l'autorisation de modifier les honoraires.",
      invalid: "Cette valeur n'est pas valide."
    }
  },
  members: {
    title: "Membres du projet",
    intro: "Les membres voient ce projet et y contribuent\xA0; les responsables en g\xE8rent les param\xE8tres. Au moins un responsable est n\xE9cessaire.",
    tableCaption: "Membres du projet",
    columns: {
      name: "Nom",
      role: "R\xF4le",
      actions: "Actions"
    },
    you: "(vous)",
    roleOf: "R\xF4le de {name}",
    remove: "Retirer {name} du projet",
    add: {
      label: "Ajouter une personne du bureau",
      placeholder: "Choisir une personne",
      button: "Ajouter",
      none: "Toutes les personnes actives du bureau font d\xE9j\xE0 partie du projet."
    },
    save: "Enregistrer les membres",
    saving: "Enregistrement\u2026",
    reset: "Annuler les modifications",
    saved: "Les membres du projet ont \xE9t\xE9 mis \xE0 jour.",
    loadFailed: "Impossible de charger les membres du projet. V\xE9rifiez votre connexion puis r\xE9essayez.",
    errors: {
      lastManager: "Le projet doit garder au moins un responsable. D\xE9signez un autre responsable avant de retirer celui-ci.",
      notActiveMember: "Une des personnes ajout\xE9es n'est plus membre actif du bureau. Retirez-la de la liste puis r\xE9essayez.",
      invalid: "La liste des membres n'est pas valide. V\xE9rifiez-la puis r\xE9essayez."
    }
  },
  phases: {
    title: "Phases",
    readOnlyNotice: "Seuls les responsables du projet peuvent modifier les phases.",
    loadFailedTitle: "Impossible de charger les phases",
    loadFailedBody: "V\xE9rifiez votre connexion puis r\xE9essayez.",
    empty: {
      title: "Ce projet n'a pas encore de phases",
      description: "Les phases du projet appara\xEEtront ici d\xE8s que le responsable les aura ajout\xE9es.",
      descriptionManage: "Ajoutez la premi\xE8re phase pour planifier la mission."
    },
    timelineLabel: "Frise des phases du projet",
    tableCaption: "Phases du projet",
    columns: {
      order: "N\xB0",
      phase: "Phase",
      planned: "Pr\xE9vu",
      actual: "R\xE9el",
      status: "Statut",
      schedule: "D\xE9lai",
      share: "Honoraires",
      actions: "Actions"
    },
    status: {
      not_started: "Non d\xE9marr\xE9e",
      in_progress: "En cours",
      in_review: "En revue",
      closed: "Cl\xF4tur\xE9e"
    },
    schedule: {
      not_planned: "Non planifi\xE9e",
      on_track: "Dans les d\xE9lais",
      late_start: "{count, plural, one {D\xE9marrage en retard de # jour} other {D\xE9marrage en retard de # jours}}",
      overdue: "{count, plural, one {En retard de # jour} other {En retard de # jours}}",
      done: "Termin\xE9e dans les d\xE9lais",
      done_late: "{count, plural, one {Termin\xE9e avec # jour de retard} other {Termin\xE9e avec # jours de retard}}"
    },
    shares: {
      total: "Total des honoraires par phase\xA0: {total}",
      warningTitle: "Parts d'honoraires \xE0 v\xE9rifier",
      warning: "Les parts d'honoraires totalisent {total} au lieu de 100 %. Ce n'est pas bloquant\xA0: ajustez-les quand vous le souhaitez."
    },
    actions: {
      moveUp: "Monter la phase {name}",
      moveDown: "Descendre la phase {name}",
      edit: "Modifier la phase {name}",
      details: "Voir la phase {name}",
      close: "Cl\xF4turer la phase {name}"
    },
    reordered: "L'ordre des phases a \xE9t\xE9 mis \xE0 jour.",
    add: {
      open: "Ajouter une phase",
      title: "Ajouter une phase",
      type: "Type de phase",
      custom: "Phase personnalis\xE9e",
      nameHint: "Le nom de la phase tel qu'il appara\xEEtra dans le projet.",
      after: "Ins\xE9rer apr\xE8s",
      afterEnd: "\xC0 la fin du projet",
      submit: "Ajouter la phase",
      adding: "Ajout\u2026",
      added: "La phase {name} a \xE9t\xE9 ajout\xE9e."
    },
    panel: {
      label: "D\xE9tails de la phase {name}",
      formLabel: "Modifier la phase {name}",
      name: "Nom de la phase",
      plannedStart: "D\xE9but pr\xE9vu",
      plannedEnd: "Fin pr\xE9vue",
      actualStart: "D\xE9but r\xE9el",
      actualEnd: "Fin r\xE9elle",
      share: "Part des honoraires",
      shareHint: "En pourcentage des honoraires, par exemple 12,5.",
      timeBudget: "Budget temps (heures)",
      timeBudgetHint: "Facultatif. Par pas de 15 minutes (0,25 h), par exemple 120 ou 37,5. Une alerte vous pr\xE9vient \xE0 80\xA0% du budget consomm\xE9. Laissez vide pour ne pas fixer de budget.",
      timeBudgetView: "Budget temps",
      timeBudgetNone: "Aucun budget",
      timeBudgetValue: "{hours} h",
      statusHint: "Une phase suit l'ordre\xA0: non d\xE9marr\xE9e, en cours, en revue. Pour la terminer, utilisez le bouton \xAB\xA0Cl\xF4turer la phase\xA0\xBB.",
      save: "Enregistrer",
      saving: "Enregistrement\u2026",
      saved: "La phase {name} a \xE9t\xE9 mise \xE0 jour.",
      stale: "La phase {name} a \xE9t\xE9 modifi\xE9e par quelqu'un d'autre. Elle a \xE9t\xE9 recharg\xE9e\xA0: appliquez de nouveau vos changements.",
      closeAction: "Cl\xF4turer la phase\u2026",
      closedNotice: "Cette phase est cl\xF4tur\xE9e\xA0: elle n'est plus modifiable.",
      closedOn: "Date de cl\xF4ture",
      waiver: "D\xE9rogation de cl\xF4ture"
    },
    errors: {
      required: "Ce champ est obligatoire.",
      nameTooLong: "Le nom ne peut pas d\xE9passer 120 caract\xE8res.",
      datesPlanned: "La fin pr\xE9vue ne peut pas pr\xE9c\xE9der le d\xE9but pr\xE9vu.",
      datesActual: "La fin r\xE9elle ne peut pas pr\xE9c\xE9der le d\xE9but r\xE9el.",
      datesInvalid: "Cette date n'est pas valide.",
      shareInvalid: "Indiquez un pourcentage entre 0 et 100, avec au plus deux d\xE9cimales.",
      typeTaken: "Ce projet a d\xE9j\xE0 une phase de ce type. Choisissez un autre type ou une phase personnalis\xE9e.",
      statusTransition: "Ce changement de statut n'est pas possible depuis le statut actuel.",
      nameNotAllowed: "Seules les phases personnalis\xE9es ont un nom.",
      afterInvalid: "Choisissez une phase de ce projet.",
      invalid: "Cette valeur n'est pas valide.",
      phaseClosed: "Cette phase est cl\xF4tur\xE9e\xA0: elle n'est plus modifiable.",
      feesForbidden: "Vous n'avez pas l'autorisation de modifier les parts d'honoraires.",
      contractDays: "Indiquez un nombre entier de jours entre 1 et 3\xA0650.",
      timeBudget: "Indiquez un nombre d\u2019heures par pas de 0,25 (15 minutes), entre 0,25 et 876\xA0000."
    }
  },
  close: {
    title: "Cl\xF4turer la phase {name}\xA0?",
    rule: "Une phase se cl\xF4ture quand tous ses livrables sont approuv\xE9s ou transmis. Sinon, vous pouvez la cl\xF4turer avec une d\xE9rogation, motiv\xE9e par \xE9crit\xA0: elle est conserv\xE9e dans l'historique du projet.",
    allDone: "Aucun livrable de cette phase n'est en attente\xA0: vous pouvez la cl\xF4turer.",
    unfinished: "{count, plural, one {# livrable de cette phase n'est ni approuv\xE9 ni transmis.} other {# livrables de cette phase ne sont ni approuv\xE9s ni transmis.}}",
    waiverLabel: "Motif de la d\xE9rogation",
    counter: "{count} / {min} caract\xE8res au minimum",
    counterOk: "{count, plural, one {# caract\xE8re} other {# caract\xE8res}}",
    waiverKept: "Ce motif est conserv\xE9 dans l'historique du projet.",
    changed: "Des livrables ont chang\xE9 depuis l'ouverture de cette fen\xEAtre\xA0: une d\xE9rogation est maintenant n\xE9cessaire.",
    confirm: "Cl\xF4turer la phase",
    confirmWaiver: "Cl\xF4turer avec d\xE9rogation",
    closing: "Cl\xF4ture\u2026",
    done: "La phase {name} est cl\xF4tur\xE9e.",
    doneWaiver: "La phase {name} est cl\xF4tur\xE9e avec une d\xE9rogation.",
    alreadyClosed: "La phase {name} est d\xE9j\xE0 cl\xF4tur\xE9e.",
    errors: {
      waiverInvalid: "\xC9crivez un motif d'au moins {min} caract\xE8res."
    }
  },
  deliverables: {
    title: "Livrables",
    add: "Ajouter un livrable",
    readOnlyNotice: "Seuls les responsables du projet peuvent modifier les livrables.",
    loadFailedTitle: "Impossible de charger les livrables",
    empty: {
      title: "Ce projet n'a pas encore de phases",
      description: "Les livrables sont rang\xE9s par phase\xA0: les phases du projet appara\xEEtront ici d\xE8s leur ajout."
    },
    phaseEmpty: "Aucun livrable dans cette phase.",
    tableCaption: "Livrables de la phase {name}",
    columns: {
      title: "Livrable",
      type: "Type",
      discipline: "Discipline",
      status: "Statut",
      due: "\xC9ch\xE9ance",
      actions: "Actions"
    },
    types: {
      drawing: "Plan",
      calculation_note: "Note de calcul",
      report: "Rapport",
      specification: "Cahier des charges",
      bill_of_quantities: "Bordereau des quantit\xE9s",
      estimate: "Estimation",
      other: "Autre"
    },
    statuses: {
      to_produce: "\xC0 produire",
      in_progress: "En cours",
      in_review: "En revue",
      approved: "Approuv\xE9",
      transmitted: "Transmis"
    },
    noDiscipline: "Sans discipline",
    closePhase: "Cl\xF4turer la phase {name}",
    closePhaseShort: "Cl\xF4turer la phase",
    progress: "{done} sur {total} approuv\xE9s ou transmis",
    closedOn: "Phase cl\xF4tur\xE9e le",
    waiver: "d\xE9rogation\xA0: {reason}",
    edit: "Modifier le livrable {title}",
    dialog: {
      addTitle: "Ajouter un livrable",
      editTitle: "Modifier le livrable",
      phase: "Phase",
      title: "Titre du livrable",
      type: "Type",
      discipline: "Discipline",
      due: "\xC9ch\xE9ance",
      status: "Statut",
      save: "Enregistrer",
      saving: "Enregistrement\u2026",
      added: "Le livrable {title} a \xE9t\xE9 ajout\xE9.",
      updated: "Le livrable {title} a \xE9t\xE9 mis \xE0 jour.",
      stale: "Le livrable {title} a \xE9t\xE9 modifi\xE9 par quelqu'un d'autre. Il a \xE9t\xE9 recharg\xE9\xA0: appliquez de nouveau vos changements."
    },
    errors: {
      required: "Ce champ est obligatoire.",
      titleTooLong: "Le titre ne peut pas d\xE9passer 200 caract\xE8res.",
      phaseInvalid: "Choisissez une phase ouverte de ce projet.",
      phaseClosed: "Cette phase est cl\xF4tur\xE9e\xA0: ses livrables ne sont plus modifiables.",
      invalid: "Cette valeur n'est pas valide."
    }
  },
  meetings: {
    noSpaceTitle: "R\xE9unions indisponibles",
    noSpaceBody: "Ce projet n\u2019a pas encore d\u2019espace de travail pour accueillir des r\xE9unions."
  },
  calendarTab: {
    noSpaceTitle: "Le calendrier n\u2019est pas encore pr\xEAt",
    noSpaceBody: "L\u2019espace du projet est en cours de cr\xE9ation. R\xE9essayez dans un instant."
  },
  workspace: {
    title: "Espace projet",
    open: "Espace projet",
    openHint: "Ouvrir ce projet en plein \xE9cran, dans un nouvel onglet",
    navLabel: "Sections du projet",
    overview: "Vue d'ensemble",
    backToApp: "Revenir \xE0 la vue standard",
    groups: {
      steer: "Pilotage",
      documents: "Documents",
      collaborate: "Collaboration",
      manage: "Gestion"
    },
    kpis: {
      label: "Chiffres cl\xE9s",
      phases: "Phases cl\xF4tur\xE9es",
      openTasks: "T\xE2ches ouvertes",
      openTasksCaption: "{inProgress} en cours \xB7 {blocked, plural, one {# bloqu\xE9e} other {# bloqu\xE9es}}",
      lateTasks: "T\xE2ches en retard",
      lateCaption: "\xC9ch\xE9ance d\xE9pass\xE9e : \xE0 traiter en priorit\xE9",
      onTimeCaption: "Aucune t\xE2che en retard",
      team: "Membres de l'\xE9quipe",
      teamCaption: "{count, plural, =0 {Aucun responsable} one {# responsable} other {# responsables}}"
    },
    deadlines: {
      title: "Prochaines \xE9ch\xE9ances",
      all: "Toutes les t\xE2ches",
      empty: "Aucune t\xE2che ouverte n'a d'\xE9ch\xE9ance."
    },
    statusCard: {
      title: "T\xE2ches par statut",
      empty: "Aucune t\xE2che pour le moment.",
      count: "Nombre",
      share: "Part"
    },
    phasesCard: {
      title: "Phases du projet",
      all: "G\xE9rer les phases"
    },
    facts: {
      title: "Fiche du projet",
      edit: "Modifier",
      none: "Non renseign\xE9",
      surface: "{value, number} m\xB2"
    },
    teamCard: {
      title: "\xC9quipe du projet",
      manage: "G\xE9rer les membres",
      empty: "Aucun membre pour le moment."
    }
  }
};

// locales/ar/documents.json
var documents_default = {
  noSpace: {
    title: "\u0645\u0633\u0627\u062D\u0629 \u0627\u0644\u0645\u0644\u0641\u0627\u062A \u0644\u064A\u0633\u062A \u062C\u0627\u0647\u0632\u0629 \u0628\u0639\u062F",
    description: "\u0633\u062A\u062A\u0648\u0641\u0631 \u0645\u062C\u0644\u062F\u0627\u062A \u0647\u0630\u0627 \u0627\u0644\u0645\u0634\u0631\u0648\u0639 \u0628\u0645\u062C\u0631\u062F \u0625\u0646\u0634\u0627\u0621 \u0645\u0633\u0627\u062D\u062A\u0647 \u0627\u0644\u062F\u0627\u062E\u0644\u064A\u0629. \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629 \u0628\u0639\u062F \u0642\u0644\u064A\u0644 \u0623\u0648 \u062A\u0648\u0627\u0635\u0644 \u0645\u0639 \u0623\u062D\u062F \u0645\u0633\u0624\u0648\u0644\u064A \u0627\u0644\u0645\u0634\u0631\u0648\u0639."
  },
  tree: {
    label: "\u0645\u062C\u0644\u062F\u0627\u062A \u0627\u0644\u0645\u0634\u0631\u0648\u0639",
    all: "\u0643\u0644 \u0627\u0644\u0645\u062C\u0644\u062F\u0627\u062A",
    loading: "\u062C\u0627\u0631\u064D \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0645\u062C\u0644\u062F\u0627\u062A\u2026",
    loadFailed: "\u062A\u0639\u0630\u0651\u0631 \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0645\u062C\u0644\u062F\u0627\u062A.",
    childrenFailed: "\u0627\u0644\u0645\u062C\u0644\u062F\u0627\u062A \u0627\u0644\u0641\u0631\u0639\u064A\u0629 \u063A\u064A\u0631 \u0645\u062A\u0627\u062D\u0629"
  },
  breadcrumb: {
    label: "\u0645\u0633\u0627\u0631 \u0627\u0644\u0645\u062C\u0644\u062F",
    root: "\u0643\u0644 \u0627\u0644\u0645\u062C\u0644\u062F\u0627\u062A",
    hidden: "\u0645\u062C\u0644\u062F \u0644\u0627 \u064A\u0645\u0643\u0646\u0643 \u0627\u0644\u0648\u0635\u0648\u0644 \u0625\u0644\u064A\u0647"
  },
  content: {
    foldersLabel: "\u0627\u0644\u0645\u062C\u0644\u062F\u0627\u062A \u0627\u0644\u0641\u0631\u0639\u064A\u0629",
    loadFailed: "\u062A\u0639\u0630\u0651\u0631 \u062A\u062D\u0645\u064A\u0644 \u0647\u0630\u0627 \u0627\u0644\u0645\u062C\u0644\u062F.",
    customRights: "\u0635\u0644\u0627\u062D\u064A\u0627\u062A \u0645\u062E\u0635\u0651\u0635\u0629",
    noFolders: {
      title: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0645\u062C\u0644\u062F\u0627\u062A \u0641\u0631\u0639\u064A\u0629",
      description: "\u0644\u0627 \u064A\u062D\u062A\u0648\u064A \u0647\u0630\u0627 \u0627\u0644\u0645\u062C\u0644\u062F \u0639\u0644\u0649 \u0645\u062C\u0644\u062F\u0627\u062A \u0641\u0631\u0639\u064A\u0629 \u0628\u0639\u062F."
    },
    rootEmpty: {
      title: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0645\u062C\u0644\u062F\u0627\u062A \u0628\u0639\u062F",
      descriptionManage: "\u0623\u0646\u0634\u0626 \u0623\u0648\u0644 \u0645\u062C\u0644\u062F \u0644\u0644\u0645\u0634\u0631\u0648\u0639 \u0644\u062A\u0635\u0646\u064A\u0641 \u0627\u0644\u0648\u062B\u0627\u0626\u0642 \u0641\u064A\u0647.",
      descriptionRead: "\u0644\u0627 \u062A\u0631\u0649 \u0623\u064A \u0645\u062C\u0644\u062F \u062D\u0627\u0644\u064A\u064B\u0627. \u064A\u0645\u0643\u0646 \u0644\u0623\u062D\u062F \u0645\u0633\u0624\u0648\u0644\u064A \u0627\u0644\u0645\u0634\u0631\u0648\u0639 \u0625\u0646\u0634\u0627\u0621 \u0645\u062C\u0644\u062F \u0623\u0648 \u0645\u0646\u062D\u0643 \u062D\u0642 \u0627\u0644\u0648\u0635\u0648\u0644."
    },
    noDocuments: {
      title: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0648\u062B\u0627\u0626\u0642 \u0628\u0639\u062F",
      description: "\u0623\u0641\u0644\u062A \u0627\u0644\u0645\u0644\u0641\u0627\u062A \u0647\u0646\u0627 \u0623\u0648 \u0627\u0633\u062A\u062E\u062F\u0645 \xAB\u0625\u0636\u0627\u0641\u0629 \u0645\u0644\u0641\u0627\u062A\xBB.",
      descriptionRead: "\u0633\u062A\u0638\u0647\u0631 \u0648\u062B\u0627\u0626\u0642 \u0647\u0630\u0627 \u0627\u0644\u0645\u062C\u0644\u062F \u0647\u0646\u0627."
    }
  },
  actions: {
    newFolder: "\u0645\u062C\u0644\u062F \u062C\u062F\u064A\u062F",
    more: "\u0625\u062C\u0631\u0627\u0621\u0627\u062A \u0623\u062E\u0631\u0649",
    moreFor: "\u0625\u062C\u0631\u0627\u0621\u0627\u062A \u0623\u062E\u0631\u0649 \u0639\u0644\u0649 \u0627\u0644\u0645\u062C\u0644\u062F {name}",
    rename: "\u0625\u0639\u0627\u062F\u0629 \u0627\u0644\u062A\u0633\u0645\u064A\u0629\u2026",
    move: "\u0646\u0642\u0644\u2026",
    permissions: "\u0627\u0644\u0635\u0644\u0627\u062D\u064A\u0627\u062A\u2026",
    delete: "\u062D\u0630\u0641"
  },
  name: {
    required: "\u0623\u062F\u062E\u0644 \u0627\u0633\u0645 \u0627\u0644\u0645\u062C\u0644\u062F.",
    tooLong: "\u0644\u0627 \u064A\u0645\u0643\u0646 \u0623\u0646 \u064A\u062A\u062C\u0627\u0648\u0632 \u0627\u0644\u0627\u0633\u0645 200 \u062D\u0631\u0641.",
    invalid: '\u0644\u0627 \u064A\u0645\u0643\u0646 \u0623\u0646 \u064A\u062D\u062A\u0648\u064A \u0627\u0644\u0627\u0633\u0645 \u0639\u0644\u0649 \u0634\u0631\u0637\u0629 \u0645\u0627\u0626\u0644\u0629 \u0623\u0648 \u062D\u0631\u0641 \u062A\u062D\u0643\u0651\u0645\u060C \u0648\u0644\u0627 \u064A\u0645\u0643\u0646 \u0623\u0646 \u064A\u0643\u0648\u0646 "." \u0623\u0648 "..".'
  },
  create: {
    title: "\u0645\u062C\u0644\u062F \u062C\u062F\u064A\u062F",
    inFolder: "\u0641\u064A: {name}",
    inRoot: "\u0641\u064A \u062C\u0630\u0631 \u0627\u0644\u0645\u0634\u0631\u0648\u0639",
    nameLabel: "\u0627\u0633\u0645 \u0627\u0644\u0645\u062C\u0644\u062F",
    submit: "\u0625\u0646\u0634\u0627\u0621",
    saving: "\u062C\u0627\u0631\u064D \u0627\u0644\u0625\u0646\u0634\u0627\u0621\u2026",
    done: "\u062A\u0645 \u0625\u0646\u0634\u0627\u0621 \u0627\u0644\u0645\u062C\u0644\u062F {name}."
  },
  rename: {
    title: "\u0625\u0639\u0627\u062F\u0629 \u062A\u0633\u0645\u064A\u0629 \u0627\u0644\u0645\u062C\u0644\u062F",
    nameLabel: "\u0627\u0644\u0627\u0633\u0645 \u0627\u0644\u062C\u062F\u064A\u062F",
    submit: "\u0625\u0639\u0627\u062F\u0629 \u0627\u0644\u062A\u0633\u0645\u064A\u0629",
    saving: "\u062C\u0627\u0631\u064D \u0627\u0644\u062D\u0641\u0638\u2026",
    done: "\u062A\u0645\u062A \u0625\u0639\u0627\u062F\u0629 \u062A\u0633\u0645\u064A\u0629 \u0627\u0644\u0645\u062C\u0644\u062F \u0625\u0644\u0649 {name}."
  },
  move: {
    title: "\u0646\u0642\u0644 \u0627\u0644\u0645\u062C\u0644\u062F {name}",
    intro: "\u0627\u0641\u062A\u062D \u0627\u0644\u0645\u062C\u0644\u062F \u0627\u0644\u0648\u062C\u0647\u0629 \u062B\u0645 \u0623\u0643\u0651\u062F \u0628\u0627\u0644\u0636\u063A\u0637 \u0639\u0644\u0649 \xAB\u0627\u0644\u0646\u0642\u0644 \u0625\u0644\u0649 \u0647\u0646\u0627\xBB.",
    location: "\u0627\u0644\u0645\u0648\u0642\u0639: {name}",
    root: "\u062C\u0630\u0631 \u0627\u0644\u0645\u0634\u0631\u0648\u0639",
    up: "\u0627\u0644\u0635\u0639\u0648\u062F \u0645\u0633\u062A\u0648\u0649 \u0648\u0627\u062D\u062F\u064B\u0627",
    listLabel: "\u0645\u062C\u0644\u062F\u0627\u062A \u0627\u0644\u0648\u062C\u0647\u0629",
    open: "\u0641\u062A\u062D \u0627\u0644\u0645\u062C\u0644\u062F {name}",
    noSubfolders: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0645\u062C\u0644\u062F\u0627\u062A \u0641\u0631\u0639\u064A\u0629 \u0641\u064A \u0647\u0630\u0627 \u0627\u0644\u0645\u0648\u0642\u0639.",
    here: "\u0627\u0644\u0646\u0642\u0644 \u0625\u0644\u0649 \u0647\u0646\u0627",
    moving: "\u062C\u0627\u0631\u064D \u0627\u0644\u0646\u0642\u0644\u2026",
    alreadyHere: "\u0627\u0644\u0645\u062C\u0644\u062F \u0645\u0648\u062C\u0648\u062F \u0628\u0627\u0644\u0641\u0639\u0644 \u0641\u064A \u0647\u0630\u0627 \u0627\u0644\u0645\u0648\u0642\u0639.",
    rootNeedsManager: "\u064A\u0645\u0643\u0646 \u0644\u0645\u0633\u0624\u0648\u0644\u064A \u0627\u0644\u0645\u0634\u0631\u0648\u0639 \u0641\u0642\u0637 \u0648\u0636\u0639 \u0645\u062C\u0644\u062F \u0641\u064A \u0627\u0644\u062C\u0630\u0631.",
    noWrite: "\u0644\u0627 \u064A\u0645\u0643\u0646\u0643 \u0625\u0636\u0627\u0641\u0629 \u0645\u062C\u0644\u062F \u0641\u064A \u0647\u0630\u0627 \u0627\u0644\u0645\u0648\u0642\u0639.",
    done: "\u062A\u0645 \u0646\u0642\u0644 \u0627\u0644\u0645\u062C\u0644\u062F {name}."
  },
  delete: {
    title: "\u062D\u0630\u0641 \u0627\u0644\u0645\u062C\u0644\u062F {name}\u061F",
    body: "\u0633\u064A\u064F\u0646\u0642\u0644 \u0627\u0644\u0645\u062C\u0644\u062F \u0648\u0643\u0644 \u0645\u062C\u0644\u062F\u0627\u062A\u0647 \u0627\u0644\u0641\u0631\u0639\u064A\u0629 \u0625\u0644\u0649 \u0633\u0644\u0629 \u0627\u0644\u0645\u062D\u0630\u0648\u0641\u0627\u062A.",
    confirm: "\u062D\u0630\u0641",
    done: "\u062A\u0645 \u0646\u0642\u0644 \u0627\u0644\u0645\u062C\u0644\u062F {name} \u0625\u0644\u0649 \u0633\u0644\u0629 \u0627\u0644\u0645\u062D\u0630\u0648\u0641\u0627\u062A.",
    documentName: "{title} (\u0627\u0644\u0645\u0624\u0634\u0631 {index})",
    documentTitle: "\u062D\u0630\u0641 \u0627\u0644\u0648\u062B\u064A\u0642\u0629 {name}\u061F",
    documentsTitle: "\u062D\u0630\u0641 {count} \u0648\u062B\u064A\u0642\u0629\u061F",
    documentsBody: "{count, plural, one {\u0633\u062A\u064F\u0646\u0642\u0644 \u0627\u0644\u0648\u062B\u064A\u0642\u0629 \u0625\u0644\u0649 \u0633\u0644\u0629 \u0627\u0644\u0645\u062D\u0630\u0648\u0641\u0627\u062A.} other {\u0633\u062A\u064F\u0646\u0642\u0644 \u0627\u0644\u0648\u062B\u0627\u0626\u0642 \u0625\u0644\u0649 \u0633\u0644\u0629 \u0627\u0644\u0645\u062D\u0630\u0648\u0641\u0627\u062A.}}",
    andOthers: "\u0648{count} \u0623\u062E\u0631\u0649",
    documentsDone: "{count, plural, one {\u0646\u064F\u0642\u0644\u062A \u0627\u0644\u0648\u062B\u064A\u0642\u0629 \u0625\u0644\u0649 \u0633\u0644\u0629 \u0627\u0644\u0645\u062D\u0630\u0648\u0641\u0627\u062A.} two {\u0646\u064F\u0642\u0644\u062A \u0627\u0644\u0648\u062B\u064A\u0642\u062A\u0627\u0646 \u0625\u0644\u0649 \u0633\u0644\u0629 \u0627\u0644\u0645\u062D\u0630\u0648\u0641\u0627\u062A.} few {\u0646\u064F\u0642\u0644\u062A # \u0648\u062B\u0627\u0626\u0642 \u0625\u0644\u0649 \u0633\u0644\u0629 \u0627\u0644\u0645\u062D\u0630\u0648\u0641\u0627\u062A.} many {\u0646\u064F\u0642\u0644\u062A # \u0648\u062B\u064A\u0642\u0629 \u0625\u0644\u0649 \u0633\u0644\u0629 \u0627\u0644\u0645\u062D\u0630\u0648\u0641\u0627\u062A.} other {\u0646\u064F\u0642\u0644\u062A # \u0648\u062B\u064A\u0642\u0629 \u0625\u0644\u0649 \u0633\u0644\u0629 \u0627\u0644\u0645\u062D\u0630\u0648\u0641\u0627\u062A.}}",
    documentsPartial: "{deleted, plural, one {\u062D\u064F\u0630\u0641\u062A \u0648\u062B\u064A\u0642\u0629 \u0648\u0627\u062D\u062F\u0629} two {\u062D\u064F\u0630\u0641\u062A \u0648\u062B\u064A\u0642\u062A\u0627\u0646} few {\u062D\u064F\u0630\u0641\u062A # \u0648\u062B\u0627\u0626\u0642} many {\u062D\u064F\u0630\u0641\u062A # \u0648\u062B\u064A\u0642\u0629} other {\u062D\u064F\u0630\u0641\u062A # \u0648\u062B\u064A\u0642\u0629}}\u060C \u0648\u062A\u0639\u0630\u0651\u0631 \u062D\u0630\u0641 {failed, plural, one {\u0648\u062B\u064A\u0642\u0629 \u0648\u0627\u062D\u062F\u0629} two {\u0648\u062B\u064A\u0642\u062A\u064A\u0646} few {# \u0648\u062B\u0627\u0626\u0642} many {# \u0648\u062B\u064A\u0642\u0629} other {# \u0648\u062B\u064A\u0642\u0629}}. {reason}"
  },
  permissions: {
    title: "\u0635\u0644\u0627\u062D\u064A\u0627\u062A \u0627\u0644\u0645\u062C\u0644\u062F {name}",
    inheritParent: "\u0648\u0631\u0627\u062B\u0629 \u0635\u0644\u0627\u062D\u064A\u0627\u062A \u0627\u0644\u0645\u062C\u0644\u062F \u0627\u0644\u0623\u0635\u0644\u064A",
    inheritSpace: "\u0648\u0631\u0627\u062B\u0629 \u0635\u0644\u0627\u062D\u064A\u0627\u062A \u0627\u0644\u0645\u0634\u0631\u0648\u0639",
    inheritParentHint: "\u0627\u0644\u0623\u0634\u062E\u0627\u0635 \u0627\u0644\u0630\u064A\u0646 \u064A\u0635\u0644\u0648\u0646 \u0625\u0644\u0649 \u0627\u0644\u0645\u062C\u0644\u062F \u0627\u0644\u0623\u0635\u0644\u064A \u064A\u0635\u0644\u0648\u0646 \u0625\u0644\u0649 \u0647\u0630\u0627 \u0627\u0644\u0645\u062C\u0644\u062F.",
    inheritSpaceHint: "\u0627\u0644\u0623\u0634\u062E\u0627\u0635 \u0627\u0644\u0630\u064A\u0646 \u064A\u0635\u0644\u0648\u0646 \u0625\u0644\u0649 \u0627\u0644\u0645\u0634\u0631\u0648\u0639 \u064A\u0635\u0644\u0648\u0646 \u0625\u0644\u0649 \u0647\u0630\u0627 \u0627\u0644\u0645\u062C\u0644\u062F.",
    customHint: "\u0644\u0627 \u064A\u0635\u0644 \u0625\u0644\u0649 \u0647\u0630\u0627 \u0627\u0644\u0645\u062C\u0644\u062F \u0648\u0645\u062C\u0644\u062F\u0627\u062A\u0647 \u0627\u0644\u0641\u0631\u0639\u064A\u0629 \u0625\u0644\u0627 \u0627\u0644\u0623\u0634\u062E\u0627\u0635 \u0627\u0644\u0645\u062F\u0631\u062C\u0648\u0646 \u0623\u062F\u0646\u0627\u0647 \u0648\u0645\u0633\u0624\u0648\u0644\u0648 \u0627\u0644\u0645\u0634\u0631\u0648\u0639.",
    listLabel: "\u0627\u0644\u0623\u0634\u062E\u0627\u0635 \u0627\u0644\u0630\u064A\u0646 \u0644\u062F\u064A\u0647\u0645 \u062D\u0642 \u0627\u0644\u0648\u0635\u0648\u0644",
    everyone: "\u062C\u0645\u064A\u0639 \u0623\u0639\u0636\u0627\u0621 \u0627\u0644\u0645\u0643\u062A\u0628",
    relationOf: "\u0635\u0644\u0627\u062D\u064A\u0629 {name}",
    relations: {
      reader: "\u0642\u0627\u0631\u0626",
      writer: "\u0645\u062D\u0631\u0651\u0631"
    },
    remove: "\u0625\u0632\u0627\u0644\u0629 {name}",
    emptyCustom: "\u0644\u0627 \u0623\u062D\u062F \u0645\u062F\u0631\u062C: \u0644\u0627 \u064A\u0635\u0644 \u0625\u0644\u0649 \u0647\u0630\u0627 \u0627\u0644\u0645\u062C\u0644\u062F \u0625\u0644\u0627 \u0645\u0633\u0624\u0648\u0644\u0648 \u0627\u0644\u0645\u0634\u0631\u0648\u0639.",
    addLabel: "\u0625\u0636\u0627\u0641\u0629 \u0634\u062E\u0635 \u0645\u0646 \u0627\u0644\u0645\u0643\u062A\u0628",
    addPlaceholder: "\u0627\u062E\u062A\u0631 \u0634\u062E\u0635\u064B\u0627",
    addButton: "\u0625\u0636\u0627\u0641\u0629",
    addAll: "\u0625\u0636\u0627\u0641\u0629 \u062C\u0645\u064A\u0639 \u0623\u0639\u0636\u0627\u0621 \u0627\u0644\u0645\u0643\u062A\u0628",
    noneToAdd: "\u062C\u0645\u064A\u0639 \u0623\u0634\u062E\u0627\u0635 \u0627\u0644\u0645\u0643\u062A\u0628 \u0645\u062F\u0631\u062C\u0648\u0646 \u0628\u0627\u0644\u0641\u0639\u0644.",
    membersFailed: "\u0642\u0627\u0626\u0645\u0629 \u0623\u0634\u062E\u0627\u0635 \u0627\u0644\u0645\u0643\u062A\u0628 \u063A\u064A\u0631 \u0645\u062A\u0627\u062D\u0629. \u0644\u0627 \u064A\u0632\u0627\u0644 \u0628\u0625\u0645\u0643\u0627\u0646\u0643 \u0625\u0636\u0627\u0641\u0629 \u062C\u0645\u064A\u0639 \u0623\u0639\u0636\u0627\u0621 \u0627\u0644\u0645\u0643\u062A\u0628.",
    loadFailed: "\u062A\u0639\u0630\u0651\u0631 \u062A\u062D\u0645\u064A\u0644 \u0635\u0644\u0627\u062D\u064A\u0627\u062A \u0647\u0630\u0627 \u0627\u0644\u0645\u062C\u0644\u062F.",
    save: "\u062D\u0641\u0638",
    saving: "\u062C\u0627\u0631\u064D \u0627\u0644\u062D\u0641\u0638\u2026",
    done: "\u062A\u0645 \u062D\u0641\u0638 \u0635\u0644\u0627\u062D\u064A\u0627\u062A \u0627\u0644\u0645\u062C\u0644\u062F {name}."
  },
  errors: {
    nameTaken: "\u064A\u0648\u062C\u062F \u0645\u062C\u0644\u062F \u0628\u0647\u0630\u0627 \u0627\u0644\u0627\u0633\u0645 \u0641\u064A \u0647\u0630\u0627 \u0627\u0644\u0645\u0643\u0627\u0646. \u0627\u062E\u062A\u0631 \u0627\u0633\u0645\u064B\u0627 \u0622\u062E\u0631.",
    stale: "\u063A\u064A\u0651\u0631 \u0634\u062E\u0635 \u0622\u062E\u0631 \u0647\u0630\u0627 \u0627\u0644\u0645\u062C\u0644\u062F. \u062A\u0645\u062A \u0625\u0639\u0627\u062F\u0629 \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0645\u0639\u0644\u0648\u0645\u0627\u062A \u0644\u0644\u062A\u0648: \u0631\u0627\u062C\u0639\u0647\u0627 \u062B\u0645 \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629.",
    cycle: "\u0644\u0627 \u064A\u0645\u0643\u0646 \u0646\u0642\u0644 \u0645\u062C\u0644\u062F \u0625\u0644\u0649 \u0623\u062D\u062F \u0645\u062C\u0644\u062F\u0627\u062A\u0647 \u0627\u0644\u0641\u0631\u0639\u064A\u0629.",
    tooDeep: "\u0633\u062A\u0643\u0648\u0646 \u0634\u062C\u0631\u0629 \u0627\u0644\u0645\u062C\u0644\u062F\u0627\u062A \u0647\u0630\u0647 \u0639\u0645\u064A\u0642\u0629 \u062C\u062F\u064B\u0627 (16 \u0645\u0633\u062A\u0648\u0649 \u0643\u062D\u062F \u0623\u0642\u0635\u0649).",
    forbidden: "\u0644\u064A\u0633 \u0644\u062F\u064A\u0643 \u0627\u0644\u0625\u0630\u0646 \u0628\u062A\u0646\u0641\u064A\u0630 \u0647\u0630\u0627 \u0627\u0644\u0625\u062C\u0631\u0627\u0621 \u0639\u0644\u0649 \u0647\u0630\u0627 \u0627\u0644\u0645\u062C\u0644\u062F.",
    notFound: "\u0647\u0630\u0627 \u0627\u0644\u0645\u062C\u0644\u062F \u0644\u0645 \u064A\u0639\u062F \u0645\u0648\u062C\u0648\u062F\u064B\u0627 \u0623\u0648 \u0644\u0645 \u064A\u0639\u062F \u0628\u0625\u0645\u0643\u0627\u0646\u0643 \u0627\u0644\u0648\u0635\u0648\u0644 \u0625\u0644\u064A\u0647.",
    subjectNotAllowed: "\u0634\u062E\u0635 \u0641\u064A \u0627\u0644\u0642\u0627\u0626\u0645\u0629 \u0644\u064A\u0633 (\u0623\u0648 \u0644\u0645 \u064A\u0639\u062F) \u0639\u0636\u0648\u064B\u0627 \u0641\u064A \u0627\u0644\u0645\u0643\u062A\u0628. \u0623\u0632\u0644\u0647 \u062B\u0645 \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629.",
    invalid: "\u0628\u0639\u0636 \u0627\u0644\u0645\u0639\u0644\u0648\u0645\u0627\u062A \u063A\u064A\u0631 \u0635\u0627\u0644\u062D\u0629. \u0631\u0627\u062C\u0639\u0647\u0627 \u062B\u0645 \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629.",
    locked: "\u0647\u0630\u0647 \u0627\u0644\u0648\u062B\u064A\u0642\u0629 \u0641\u064A \u0645\u0633\u0627\u0631 \u0645\u0648\u0627\u0641\u0642\u0629 \u062C\u0627\u0631\u064D: \u0627\u0646\u062A\u0638\u0631 \u0627\u0646\u062A\u0647\u0627\u0621\u0647 \u0623\u0648 \u0623\u0644\u063A\u0650\u0647 \u062B\u0645 \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629.",
    documentStale: "\u0639\u062F\u0651\u0644 \u0634\u062E\u0635 \u0622\u062E\u0631 \u0647\u0630\u0647 \u0627\u0644\u0648\u062B\u064A\u0642\u0629. \u0623\u064F\u0639\u064A\u062F \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0642\u0627\u0626\u0645\u0629 \u0644\u0644\u062A\u0648: \u0631\u0627\u062C\u0639\u0647\u0627 \u062B\u0645 \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629.",
    versionNotAvailable: "\u0644\u0627 \u064A\u0645\u0643\u0646 \u0627\u0633\u062A\u0639\u0627\u062F\u0629 \u0625\u0644\u0627 \u0646\u0633\u062E\u0629 \u062A\u0645 \u0641\u062D\u0635\u0647\u0627 \u0648\u0647\u064A \u0645\u062A\u0627\u062D\u0629.",
    documentForbidden: "\u0644\u064A\u0633 \u0644\u062F\u064A\u0643 \u0635\u0644\u0627\u062D\u064A\u0629 \u062A\u0646\u0641\u064A\u0630 \u0647\u0630\u0627 \u0627\u0644\u0625\u062C\u0631\u0627\u0621 \u0639\u0644\u0649 \u0647\u0630\u0647 \u0627\u0644\u0648\u062B\u064A\u0642\u0629.",
    documentNotFound: "\u0644\u0645 \u062A\u0639\u062F \u0647\u0630\u0647 \u0627\u0644\u0648\u062B\u064A\u0642\u0629 \u0645\u0648\u062C\u0648\u062F\u0629 \u0623\u0648 \u0644\u0645 \u062A\u0639\u062F \u062A\u0645\u0644\u0643 \u0635\u0644\u0627\u062D\u064A\u0629 \u0627\u0644\u0648\u0635\u0648\u0644 \u0625\u0644\u064A\u0647\u0627.",
    legalHold: "\u064A\u062D\u062A\u0648\u064A \u0647\u0630\u0627 \u0627\u0644\u0645\u062C\u0644\u062F \u0639\u0644\u0649 \u0648\u062B\u064A\u0642\u0629 \u064A\u062C\u0628 \u0627\u0644\u0627\u062D\u062A\u0641\u0627\u0638 \u0628\u0647\u0627 (\u0627\u0644\u062A\u0632\u0627\u0645 \u0642\u0627\u0646\u0648\u0646\u064A)\u060C \u0644\u0630\u0644\u0643 \u0644\u0627 \u064A\u0645\u0643\u0646 \u062D\u0630\u0641\u0647."
  },
  upload: {
    region: "\u0625\u0636\u0627\u0641\u0629 \u0627\u0644\u0645\u0644\u0641\u0627\u062A",
    zone: {
      title: "\u0627\u0633\u062D\u0628 \u0627\u0644\u0645\u0644\u0641\u0627\u062A \u0623\u0648 \u0627\u0644\u0645\u062C\u0644\u062F\u0627\u062A \u0648\u0623\u0641\u0644\u062A\u0647\u0627 \u0647\u0646\u0627",
      dropNow: "\u0623\u0641\u0644\u0650\u062A \u0644\u0625\u0636\u0627\u0641\u062A\u0647\u0627 \u0625\u0644\u0649 \u0647\u0630\u0627 \u0627\u0644\u0645\u062C\u0644\u062F",
      hint: "\u0623\u0648 \u0627\u0633\u062A\u062E\u062F\u0645 \u0627\u0644\u0623\u0632\u0631\u0627\u0631 \u0623\u062F\u0646\u0627\u0647. \u0627\u0644\u062D\u062F \u0627\u0644\u0623\u0642\u0635\u0649 \u0644\u062D\u062C\u0645 \u0627\u0644\u0645\u0644\u0641: {max}. \u062A\u064F\u0636\u0627\u0641 \u0645\u0644\u0641\u0627\u062A \u0627\u0644\u0645\u062C\u0644\u062F \u0627\u0644\u0630\u064A \u062A\u064F\u0641\u0644\u062A\u0647 \u0645\u0628\u0627\u0634\u0631\u0629\u064B \u0625\u0644\u0649 \u0627\u0644\u0645\u062C\u0644\u062F \u0627\u0644\u0645\u0641\u062A\u0648\u062D.",
      addFiles: "\u0625\u0636\u0627\u0641\u0629 \u0645\u0644\u0641\u0627\u062A",
      addFolder: "\u0625\u0636\u0627\u0641\u0629 \u0645\u062C\u0644\u062F"
    },
    listLabel: "\u0627\u0644\u0645\u0644\u0641\u0627\u062A \u0642\u064A\u062F \u0627\u0644\u0625\u0636\u0627\u0641\u0629",
    progressLabel: "\u0625\u0631\u0633\u0627\u0644 {name}",
    scanningLabel: "\u0641\u062D\u0635 {name} \u0628\u062D\u062B\u064B\u0627 \u0639\u0646 \u0627\u0644\u0641\u064A\u0631\u0648\u0633\u0627\u062A",
    status: {
      sending: "\u062C\u0627\u0631\u064D \u0627\u0644\u0625\u0631\u0633\u0627\u0644",
      scanning: "\u062C\u0627\u0631\u064D \u0627\u0644\u0641\u062D\u0635 \u0628\u062D\u062B\u064B\u0627 \u0639\u0646 \u0627\u0644\u0641\u064A\u0631\u0648\u0633\u0627\u062A",
      added: "\u0623\u064F\u0636\u064A\u0641 \u0625\u0644\u0649 \u0627\u0644\u0645\u062C\u0644\u062F",
      refused: "\u0645\u0631\u0641\u0648\u0636",
      failed: "\u0641\u0634\u0644 \u0627\u0644\u0625\u0631\u0633\u0627\u0644"
    },
    withIssue: "{status}: {issue}",
    slow: "\u064A\u0633\u062A\u063A\u0631\u0642 \u0627\u0644\u0641\u062D\u0635 \u0648\u0642\u062A\u064B\u0627 \u0623\u0637\u0648\u0644 \u0645\u0646 \u0627\u0644\u0645\u0639\u062A\u0627\u062F\u061B \u0633\u064A\u0638\u0647\u0631 \u0627\u0644\u0645\u0644\u0641 \u0628\u0645\u062C\u0631\u062F \u0627\u0643\u062A\u0645\u0627\u0644\u0647.",
    cancel: "\u0625\u0644\u063A\u0627\u0621",
    dismiss: "\u0625\u0632\u0627\u0644\u0629",
    cancelLabel: "\u0625\u0644\u063A\u0627\u0621 \u0625\u0631\u0633\u0627\u0644 {name}",
    dismissLabel: "\u0625\u0632\u0627\u0644\u0629 {name} \u0645\u0646 \u0627\u0644\u0642\u0627\u0626\u0645\u0629",
    retryLabel: "\u0625\u0639\u0627\u062F\u0629 \u0645\u062D\u0627\u0648\u0644\u0629 \u0625\u0631\u0633\u0627\u0644 {name}",
    elsewhere: "\u0625\u0631\u0633\u0627\u0644\u0627\u062A \u0645\u0627 \u0632\u0627\u0644\u062A \u062C\u0627\u0631\u064A\u0629 \u0641\u064A \u0645\u062C\u0644\u062F\u0627\u062A \u0623\u062E\u0631\u0649: {count}",
    issue: {
      empty: "\u0647\u0630\u0627 \u0627\u0644\u0645\u0644\u0641 \u0641\u0627\u0631\u063A\u060C \u0644\u0630\u0644\u0643 \u0644\u0645 \u064A\u064F\u0636\u0641.",
      name: "\u0627\u0633\u0645 \u0647\u0630\u0627 \u0627\u0644\u0645\u0644\u0641 \u063A\u064A\u0631 \u0635\u0627\u0644\u062D. \u063A\u064A\u0651\u0631 \u0627\u0633\u0645\u0647 \u062B\u0645 \u0623\u0636\u0641\u0647 \u0645\u0646 \u062C\u062F\u064A\u062F.",
      type: "\u0646\u0648\u0639 \u0627\u0644\u0645\u0644\u0641 ({extension}) \u063A\u064A\u0631 \u0645\u0642\u0628\u0648\u0644. \u062D\u0648\u0651\u0644\u0647 \u0625\u0644\u0649 PDF \u0623\u0648 \u0623\u0631\u0633\u0644\u0647 \u062F\u0627\u062E\u0644 \u0623\u0631\u0634\u064A\u0641 ZIP.",
      typeNoExtension: "\u0647\u0630\u0627 \u0627\u0644\u0645\u0644\u0641 \u0628\u0644\u0627 \u0627\u0645\u062A\u062F\u0627\u062F \u0645\u0639\u0631\u0648\u0641\u060C \u0644\u0630\u0644\u0643 \u0644\u0627 \u064A\u0645\u0643\u0646 \u0642\u0628\u0648\u0644\u0647. \u0623\u0639\u062F \u062A\u0633\u0645\u064A\u062A\u0647 \u0628\u0627\u0645\u062A\u062F\u0627\u062F\u0647 \u0627\u0644\u0635\u062D\u064A\u062D \u0623\u0648 \u0623\u0631\u0633\u0644\u0647 \u062F\u0627\u062E\u0644 \u0623\u0631\u0634\u064A\u0641 ZIP.",
      tooLarge: "\u0647\u0630\u0627 \u0627\u0644\u0645\u0644\u0641 \u0643\u0628\u064A\u0631 \u062C\u062F\u064B\u0627. \u0627\u0644\u062D\u062F \u0627\u0644\u0623\u0642\u0635\u0649 \u0644\u0644\u062D\u062C\u0645 \u0647\u0648 {max}.",
      tooLargePlan: "\u064A\u062A\u062C\u0627\u0648\u0632 \u0647\u0630\u0627 \u0627\u0644\u0645\u0644\u0641 \u0627\u0644\u062D\u062C\u0645 \u0627\u0644\u0623\u0642\u0635\u0649 \u0627\u0644\u0645\u0633\u0645\u0648\u062D \u0628\u0647 \u0641\u064A \u0628\u0627\u0642\u062A\u0643.",
      quota: "\u0645\u0633\u0627\u062D\u0629 \u0627\u0644\u062A\u062E\u0632\u064A\u0646 \u0641\u064A \u0628\u0627\u0642\u062A\u0643 \u0645\u0645\u062A\u0644\u0626\u0629. \u0623\u0641\u0631\u063A \u0628\u0639\u0636 \u0627\u0644\u0645\u0633\u0627\u062D\u0629 \u0623\u0648 \u0627\u0637\u0644\u0628 \u0645\u0646 \u0645\u0627\u0644\u0643 \u0627\u0644\u062D\u0633\u0627\u0628 \u0632\u064A\u0627\u062F\u062A\u0647\u0627.",
      forbidden: "\u0644\u064A\u0633 \u0644\u062F\u064A\u0643 \u0635\u0644\u0627\u062D\u064A\u0629 \u0625\u0636\u0627\u0641\u0629 \u0645\u0644\u0641\u0627\u062A \u0625\u0644\u0649 \u0647\u0630\u0627 \u0627\u0644\u0645\u062C\u0644\u062F.",
      notFound: "\u0644\u0645 \u064A\u0639\u062F \u0647\u0630\u0627 \u0627\u0644\u0645\u062C\u0644\u062F \u0645\u0648\u062C\u0648\u062F\u064B\u0627 \u0623\u0648 \u0644\u0645 \u064A\u0639\u062F \u0628\u0625\u0645\u0643\u0627\u0646\u0643 \u0627\u0644\u0648\u0635\u0648\u0644 \u0625\u0644\u064A\u0647.",
      readOnly: "\u062D\u0633\u0627\u0628 \u0645\u0643\u062A\u0628\u0643 \u0641\u064A \u0648\u0636\u0639 \u0627\u0644\u0642\u0631\u0627\u0621\u0629 \u0641\u0642\u0637\u060C \u0648\u0644\u0627 \u064A\u0645\u0643\u0646 \u0625\u0636\u0627\u0641\u0629 \u0623\u064A \u0645\u0644\u0641.",
      expired: "\u0627\u0646\u062A\u0647\u062A \u0635\u0644\u0627\u062D\u064A\u0629 \u0627\u0644\u0625\u0631\u0633\u0627\u0644. \u0623\u0636\u0641 \u0627\u0644\u0645\u0644\u0641 \u0645\u0646 \u062C\u062F\u064A\u062F.",
      incomplete: "\u0644\u0645 \u064A\u0635\u0644 \u0627\u0644\u0645\u0644\u0641 \u0643\u0627\u0645\u0644\u064B\u0627. \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629.",
      busy: "\u0637\u0644\u0628\u0627\u062A \u0643\u062B\u064A\u0631\u0629 \u0641\u064A \u0648\u0642\u062A \u0648\u0627\u062D\u062F. \u0627\u0646\u062A\u0638\u0631 \u0628\u0636\u0639 \u062B\u0648\u0627\u0646\u064D \u062B\u0645 \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629.",
      interrupted: "\u0627\u0646\u0642\u0637\u0639 \u0627\u0644\u0625\u0631\u0633\u0627\u0644: \u0627\u0644\u0627\u062A\u0635\u0627\u0644 \u0645\u0641\u0642\u0648\u062F \u0623\u0648 \u063A\u064A\u0631 \u0645\u0633\u062A\u0642\u0631. \u062A\u062D\u0642\u0642 \u0645\u0646\u0647 \u062B\u0645 \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629.",
      statusLost: "\u062A\u0639\u0630\u0651\u0631 \u0627\u0644\u062A\u062D\u0642\u0642 \u0645\u0646 \u0646\u062A\u064A\u062C\u0629 \u0627\u0644\u0625\u0631\u0633\u0627\u0644. \u0623\u0639\u062F \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0635\u0641\u062D\u0629 \u0644\u0645\u0639\u0631\u0641\u0629 \u0645\u0627 \u0625\u0630\u0627 \u0623\u064F\u0636\u064A\u0641 \u0627\u0644\u0645\u0644\u0641.",
      unexpected: "\u062D\u062F\u062B \u062E\u0637\u0623 \u063A\u064A\u0631 \u0645\u062A\u0648\u0642\u0639. \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629 \u0628\u0639\u062F \u0642\u0644\u064A\u0644.",
      infected: "\u064A\u062D\u062A\u0648\u064A \u0647\u0630\u0627 \u0627\u0644\u0645\u0644\u0641 \u0639\u0644\u0649 \u0641\u064A\u0631\u0648\u0633\u060C \u0644\u0630\u0644\u0643 \u0631\u064F\u0641\u0636 \u0648\u062D\u064F\u0630\u0641.",
      scan_limits: "\u0647\u0630\u0627 \u0627\u0644\u0623\u0631\u0634\u064A\u0641 \u0643\u0628\u064A\u0631 \u062C\u062F\u064B\u0627 \u0623\u0648 \u0645\u062A\u062F\u0627\u062E\u0644 \u0628\u0639\u0645\u0642 \u064A\u0645\u0646\u0639 \u0641\u062D\u0635\u0647: \u0642\u0633\u0651\u0645\u0647 \u0625\u0644\u0649 \u0623\u0631\u0634\u064A\u0641\u0627\u062A \u0623\u0635\u063A\u0631.",
      type_mismatch: "\u0645\u062D\u062A\u0648\u0649 \u0647\u0630\u0627 \u0627\u0644\u0645\u0644\u0641 \u0644\u0627 \u064A\u0637\u0627\u0628\u0642 \u0627\u0645\u062A\u062F\u0627\u062F\u0647\u060C \u0644\u0630\u0644\u0643 \u0631\u064F\u0641\u0636.",
      html_content: "\u0635\u0641\u062D\u0627\u062A \u0627\u0644\u0648\u064A\u0628 (HTML) \u063A\u064A\u0631 \u0645\u0642\u0628\u0648\u0644\u0629\u060C \u0644\u0630\u0644\u0643 \u0631\u064F\u0641\u0636 \u0627\u0644\u0645\u0644\u0641.",
      size_mismatch: "\u062D\u062C\u0645 \u0627\u0644\u0645\u0644\u0641 \u0627\u0644\u0645\u0633\u062A\u0644\u0645 \u0644\u0627 \u064A\u0637\u0627\u0628\u0642 \u0627\u0644\u062D\u062C\u0645 \u0627\u0644\u0645\u0639\u0644\u0646\u060C \u0644\u0630\u0644\u0643 \u0631\u064F\u0641\u0636. \u0623\u0636\u0641\u0647 \u0645\u0646 \u062C\u062F\u064A\u062F.",
      sha256_mismatch: "\u062A\u063A\u064A\u0651\u0631 \u0627\u0644\u0645\u0644\u0641 \u0623\u062B\u0646\u0627\u0621 \u0627\u0644\u0625\u0631\u0633\u0627\u0644\u060C \u0644\u0630\u0644\u0643 \u0631\u064F\u0641\u0636. \u0623\u0636\u0641\u0647 \u0645\u0646 \u062C\u062F\u064A\u062F.",
      locked: "\u0647\u0630\u0647 \u0627\u0644\u0648\u062B\u064A\u0642\u0629 \u0641\u064A \u0645\u0633\u0627\u0631 \u0645\u0648\u0627\u0641\u0642\u0629 \u062C\u0627\u0631\u064D: \u0644\u0627 \u064A\u0645\u0643\u0646 \u0625\u0636\u0627\u0641\u0629 \u0646\u0633\u062E\u0629 \u062C\u062F\u064A\u062F\u0629 \u0625\u0644\u064A\u0647\u0627 \u062D\u0627\u0644\u064A\u064B\u0627."
    }
  },
  docTypes: {
    drawing: "\u0645\u062E\u0637\u0637",
    calculation_note: "\u0645\u0630\u0643\u0631\u0629 \u062D\u0633\u0627\u0628",
    report: "\u062A\u0642\u0631\u064A\u0631",
    specification: "\u062F\u0641\u062A\u0631 \u0627\u0644\u0634\u0631\u0648\u0637",
    bill_of_quantities: "\u062C\u062F\u0648\u0644 \u0627\u0644\u0643\u0645\u064A\u0627\u062A",
    estimate: "\u062A\u0642\u062F\u064A\u0631",
    minutes: "\u0645\u062D\u0636\u0631",
    correspondence: "\u0645\u0631\u0627\u0633\u0644\u0629",
    photo: "\u0635\u0648\u0631\u0629",
    other: "\u0623\u062E\u0631\u0649"
  },
  status: {
    uploading: "\u062C\u0627\u0631\u064D \u0627\u0644\u0625\u0631\u0633\u0627\u0644",
    scanning: "\u0641\u062D\u0635 \u0645\u0636\u0627\u062F \u0627\u0644\u0641\u064A\u0631\u0648\u0633\u0627\u062A",
    available: "\u0645\u062A\u0627\u062D",
    rejected: "\u0645\u0631\u0641\u0648\u0636",
    lockedHint: "\u0645\u0633\u0627\u0631 \u0645\u0648\u0627\u0641\u0642\u0629 \u062C\u0627\u0631\u064D: \u0644\u0627 \u0646\u0633\u062E\u0629 \u062C\u062F\u064A\u062F\u0629 \u0642\u0628\u0644 \u0627\u0646\u062A\u0647\u0627\u0626\u0647."
  },
  list: {
    title: "\u0627\u0644\u0648\u062B\u0627\u0626\u0642",
    region: "\u0648\u062B\u0627\u0626\u0642 \u0627\u0644\u0645\u062C\u0644\u062F",
    caption: "\u0648\u062B\u0627\u0626\u0642 \u0627\u0644\u0645\u062C\u0644\u062F \u0627\u0644\u0645\u0641\u062A\u0648\u062D",
    columns: {
      code: "\u0627\u0644\u0631\u0645\u0632",
      title: "\u0627\u0644\u0639\u0646\u0648\u0627\u0646",
      index: "\u0627\u0644\u0645\u0624\u0634\u0631",
      discipline: "\u0627\u0644\u062A\u062E\u0635\u0635",
      phase: "\u0627\u0644\u0645\u0631\u062D\u0644\u0629",
      status: "\u0627\u0644\u062D\u0627\u0644\u0629",
      approval: "\u0627\u0644\u062A\u0623\u0634\u064A\u0631",
      modified: "\u062A\u0627\u0631\u064A\u062E \u0627\u0644\u062A\u0639\u062F\u064A\u0644",
      author: "\u0627\u0644\u0645\u0624\u0633\u0633\u0629 \u0627\u0644\u0645\u064F\u0646\u0634\u0650\u0626\u0629"
    },
    none: "\u2014",
    partner: "\u0634\u0631\u064A\u0643",
    codeMissing: "\u0645\u0639\u0644\u0648\u0645\u0627\u062A \u0646\u0627\u0642\u0635\u0629: \u0644\u0645 \u064A\u064F\u0633\u0646\u064E\u062F \u0627\u0644\u0631\u0645\u0632 \u0628\u0639\u062F",
    selectAll: "\u062A\u062D\u062F\u064A\u062F \u0643\u0644 \u0627\u0644\u0648\u062B\u0627\u0626\u0642 \u0627\u0644\u0645\u0639\u0631\u0648\u0636\u0629",
    selectRow: "\u062A\u062D\u062F\u064A\u062F {name}",
    loadFailed: "\u062A\u0639\u0630\u0651\u0631 \u062A\u062D\u0645\u064A\u0644 \u0648\u062B\u0627\u0626\u0642 \u0647\u0630\u0627 \u0627\u0644\u0645\u062C\u0644\u062F.",
    moreFailed: "\u062A\u0639\u0630\u0651\u0631 \u062A\u062D\u0645\u064A\u0644 \u0628\u0642\u064A\u0629 \u0627\u0644\u0642\u0627\u0626\u0645\u0629. \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629.",
    shown: "{count, plural, one {\u0648\u062B\u064A\u0642\u0629 \u0648\u0627\u062D\u062F\u0629 \u0645\u0639\u0631\u0648\u0636\u0629} two {\u0648\u062B\u064A\u0642\u062A\u0627\u0646 \u0645\u0639\u0631\u0648\u0636\u062A\u0627\u0646} few {# \u0648\u062B\u0627\u0626\u0642 \u0645\u0639\u0631\u0648\u0636\u0629} many {# \u0648\u062B\u064A\u0642\u0629 \u0645\u0639\u0631\u0648\u0636\u0629} other {# \u0648\u062B\u064A\u0642\u0629 \u0645\u0639\u0631\u0648\u0636\u0629}}",
    loadMore: "\u0639\u0631\u0636 \u0627\u0644\u0645\u0632\u064A\u062F \u0645\u0646 \u0627\u0644\u0648\u062B\u0627\u0626\u0642",
    loadingMore: "\u062C\u0627\u0631\u064D \u0627\u0644\u062A\u062D\u0645\u064A\u0644\u2026",
    noMatch: {
      title: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0648\u062B\u064A\u0642\u0629 \u0645\u0637\u0627\u0628\u0642\u0629",
      description: "\u062C\u0631\u0651\u0628 \u0643\u0644\u0645\u0629 \u0623\u062E\u0631\u0649 \u0623\u0648 \u0623\u0632\u0644 \u0639\u0627\u0645\u0644 \u062A\u0635\u0641\u064A\u0629."
    }
  },
  filters: {
    label: "\u062A\u0635\u0641\u064A\u0629 \u0627\u0644\u0648\u062B\u0627\u0626\u0642",
    search: "\u0627\u0644\u0628\u062D\u062B \u0641\u064A \u0627\u0644\u0648\u062B\u0627\u0626\u0642",
    searchPlaceholder: "\u0627\u0644\u0631\u0645\u0632 \u0623\u0648 \u0627\u0644\u0639\u0646\u0648\u0627\u0646",
    chosen: "{filter}: {value}",
    all: "\u0627\u0644\u0643\u0644",
    clear: "\u0645\u0633\u062D \u0639\u0648\u0627\u0645\u0644 \u0627\u0644\u062A\u0635\u0641\u064A\u0629"
  },
  selection: {
    label: "\u0625\u062C\u0631\u0627\u0621\u0627\u062A \u0639\u0644\u0649 \u0627\u0644\u062A\u062D\u062F\u064A\u062F",
    count: "{count, plural, one {\u0648\u062B\u064A\u0642\u0629 \u0648\u0627\u062D\u062F\u0629 \u0645\u062D\u062F\u062F\u0629} two {\u0648\u062B\u064A\u0642\u062A\u0627\u0646 \u0645\u062D\u062F\u062F\u062A\u0627\u0646} few {# \u0648\u062B\u0627\u0626\u0642 \u0645\u062D\u062F\u062F\u0629} many {# \u0648\u062B\u064A\u0642\u0629 \u0645\u062D\u062F\u062F\u0629} other {# \u0648\u062B\u064A\u0642\u0629 \u0645\u062D\u062F\u062F\u0629}}",
    move: "\u0646\u0642\u0644 \u0625\u0644\u0649\u2026",
    delete: "\u062D\u0630\u0641",
    clear: "\u0625\u0644\u063A\u0627\u0621 \u0627\u0644\u062A\u062D\u062F\u064A\u062F"
  },
  moveDocuments: {
    title: "{count, plural, one {\u0646\u0642\u0644 \u0627\u0644\u0648\u062B\u064A\u0642\u0629} two {\u0646\u0642\u0644 \u0627\u0644\u0648\u062B\u064A\u0642\u062A\u064A\u0646} few {\u0646\u0642\u0644 # \u0648\u062B\u0627\u0626\u0642} many {\u0646\u0642\u0644 # \u0648\u062B\u064A\u0642\u0629} other {\u0646\u0642\u0644 # \u0648\u062B\u064A\u0642\u0629}}",
    intro: "\u0627\u0641\u062A\u062D \u0627\u0644\u0645\u062C\u0644\u062F \u0627\u0644\u0648\u062C\u0647\u0629 \u062B\u0645 \u0623\u0643\u0651\u062F \u0628\u0627\u0644\u0636\u063A\u0637 \u0639\u0644\u0649 \xAB\u0646\u0642\u0644 \u0625\u0644\u0649 \u0647\u0646\u0627\xBB.",
    pickFolder: "\u0627\u0641\u062A\u062D \u0645\u062C\u0644\u062F\u064B\u0627: \u0644\u0627 \u064A\u0645\u0643\u0646 \u0623\u0646 \u062A\u0628\u0642\u0649 \u0627\u0644\u0648\u062B\u0627\u0626\u0642 \u0641\u064A \u062C\u0630\u0631 \u0627\u0644\u0645\u0634\u0631\u0648\u0639.",
    alreadyHere: "\u0627\u0644\u0648\u062B\u0627\u0626\u0642 \u0645\u0648\u062C\u0648\u062F\u0629 \u0623\u0635\u0644\u064B\u0627 \u0641\u064A \u0647\u0630\u0627 \u0627\u0644\u0645\u062C\u0644\u062F.",
    noWrite: "\u0644\u0627 \u064A\u0645\u0643\u0646\u0643 \u0625\u0636\u0627\u0641\u0629 \u0648\u062B\u0627\u0626\u0642 \u0625\u0644\u0649 \u0647\u0630\u0627 \u0627\u0644\u0645\u062C\u0644\u062F.",
    done: "{count, plural, one {\u0646\u064F\u0642\u0644\u062A \u0627\u0644\u0648\u062B\u064A\u0642\u0629} two {\u0646\u064F\u0642\u0644\u062A \u0627\u0644\u0648\u062B\u064A\u0642\u062A\u0627\u0646} few {\u0646\u064F\u0642\u0644\u062A # \u0648\u062B\u0627\u0626\u0642} many {\u0646\u064F\u0642\u0644\u062A # \u0648\u062B\u064A\u0642\u0629} other {\u0646\u064F\u0642\u0644\u062A # \u0648\u062B\u064A\u0642\u0629}} \u0625\u0644\u0649 {folder}.",
    partial: "{moved, plural, one {\u0646\u064F\u0642\u0644\u062A \u0648\u062B\u064A\u0642\u0629 \u0648\u0627\u062D\u062F\u0629} two {\u0646\u064F\u0642\u0644\u062A \u0648\u062B\u064A\u0642\u062A\u0627\u0646} few {\u0646\u064F\u0642\u0644\u062A # \u0648\u062B\u0627\u0626\u0642} many {\u0646\u064F\u0642\u0644\u062A # \u0648\u062B\u064A\u0642\u0629} other {\u0646\u064F\u0642\u0644\u062A # \u0648\u062B\u064A\u0642\u0629}}\u060C \u0648\u062A\u0639\u0630\u0651\u0631 \u0646\u0642\u0644 {failed, plural, one {\u0648\u062B\u064A\u0642\u0629 \u0648\u0627\u062D\u062F\u0629} two {\u0648\u062B\u064A\u0642\u062A\u064A\u0646} few {# \u0648\u062B\u0627\u0626\u0642} many {# \u0648\u062B\u064A\u0642\u0629} other {# \u0648\u062B\u064A\u0642\u0629}}. {reason}"
  },
  metadata: {
    discipline: "\u0627\u0644\u062A\u062E\u0635\u0635",
    phase: "\u0627\u0644\u0645\u0631\u062D\u0644\u0629",
    docType: "\u0646\u0648\u0639 \u0627\u0644\u0648\u062B\u064A\u0642\u0629",
    zone: "\u0627\u0644\u0645\u0646\u0637\u0642\u0629",
    scale: "\u0627\u0644\u0645\u0642\u064A\u0627\u0633",
    title: "\u0627\u0644\u0639\u0646\u0648\u0627\u0646",
    notSet: "\u063A\u064A\u0631 \u0645\u062D\u062F\u062F",
    optional: "\u0627\u062E\u062A\u064A\u0627\u0631\u064A",
    phaseOption: "{code} \u2014 {name}",
    fields: {
      discipline: "\u0627\u0644\u062A\u062E\u0635\u0635",
      phaseType: "\u0627\u0644\u0645\u0631\u062D\u0644\u0629",
      docType: "\u0646\u0648\u0639 \u0627\u0644\u0648\u062B\u064A\u0642\u0629",
      zone: "\u0627\u0644\u0645\u0646\u0637\u0642\u0629"
    }
  },
  metadataDialog: {
    title: "{count, plural, one {\u0645\u0639\u0644\u0648\u0645\u0627\u062A \u0627\u0644\u0648\u062B\u064A\u0642\u0629} two {\u0645\u0639\u0644\u0648\u0645\u0627\u062A \u0627\u0644\u0648\u062B\u064A\u0642\u062A\u064A\u0646} few {\u0645\u0639\u0644\u0648\u0645\u0627\u062A # \u0648\u062B\u0627\u0626\u0642} many {\u0645\u0639\u0644\u0648\u0645\u0627\u062A # \u0648\u062B\u064A\u0642\u0629} other {\u0645\u0639\u0644\u0648\u0645\u0627\u062A # \u0648\u062B\u064A\u0642\u0629}}",
    intro: "{count, plural, one {\u062A\u064F\u0633\u062A\u062E\u062F\u0645 \u0647\u0630\u0647 \u0627\u0644\u0645\u0639\u0644\u0648\u0645\u0627\u062A \u0644\u062A\u0635\u0646\u064A\u0641 \u0627\u0644\u0648\u062B\u064A\u0642\u0629 \u0648\u062A\u0643\u0648\u064A\u0646 \u0631\u0645\u0632\u0647\u0627. \u064A\u0645\u0643\u0646\u0643 \u062A\u0639\u062F\u064A\u0644\u0647\u0627 \u0644\u0627\u062D\u0642\u064B\u0627.} other {\u062A\u0646\u0637\u0628\u0642 \u0647\u0630\u0647 \u0627\u0644\u0645\u0639\u0644\u0648\u0645\u0627\u062A \u0639\u0644\u0649 \u0643\u0644 \u0648\u062B\u0627\u0626\u0642 \u0647\u0630\u0647 \u0627\u0644\u0625\u0636\u0627\u0641\u0629. \u064A\u0645\u0643\u0646\u0643 \u062A\u0639\u062F\u064A\u0644\u0647\u0627 \u0644\u0627\u062D\u0642\u064B\u0627 \u0648\u062B\u064A\u0642\u0629\u064B \u0648\u062B\u064A\u0642\u0629.}}",
    titlesLabel: "\u0639\u0646\u0648\u0627\u0646 \u0643\u0644 \u0648\u062B\u064A\u0642\u0629",
    titleOf: "\u0639\u0646\u0648\u0627\u0646 {name}",
    titlesFromNames: "\u062A\u0624\u062E\u0630 \u0627\u0644\u0639\u0646\u0627\u0648\u064A\u0646 \u0645\u0646 \u0623\u0633\u0645\u0627\u0621 \u0627\u0644\u0645\u0644\u0641\u0627\u062A\u060C \u0648\u064A\u0645\u0643\u0646\u0643 \u062A\u0639\u062F\u064A\u0644\u0647\u0627 \u0628\u0639\u062F \u0630\u0644\u0643.",
    skip: "\u0625\u0636\u0627\u0641\u0629 \u0628\u062F\u0648\u0646 \u0645\u0639\u0644\u0648\u0645\u0627\u062A",
    add: "{count, plural, one {\u0625\u0636\u0627\u0641\u0629 \u0627\u0644\u0648\u062B\u064A\u0642\u0629} two {\u0625\u0636\u0627\u0641\u0629 \u0627\u0644\u0648\u062B\u064A\u0642\u062A\u064A\u0646} few {\u0625\u0636\u0627\u0641\u0629 # \u0648\u062B\u0627\u0626\u0642} many {\u0625\u0636\u0627\u0641\u0629 # \u0648\u062B\u064A\u0642\u0629} other {\u0625\u0636\u0627\u0641\u0629 # \u0648\u062B\u064A\u0642\u0629}}"
  },
  codePreview: {
    label: "\u0627\u0644\u0631\u0645\u0632 \u0627\u0644\u0645\u062A\u0648\u0642\u0639",
    number: "\u064A\u064F\u0633\u062A\u0628\u062F\u0644 ### \u0628\u0627\u0644\u0631\u0642\u0645 \u0627\u0644\u062A\u0633\u0644\u0633\u0644\u064A \u0627\u0644\u0630\u064A \u064A\u064F\u0633\u0646\u064E\u062F \u0639\u0646\u062F \u0625\u0636\u0627\u0641\u0629 \u0627\u0644\u0645\u0644\u0641.",
    missing: "\u0633\u064A\u064F\u0633\u0646\u064E\u062F \u0627\u0644\u0631\u0645\u0632 \u0628\u0645\u062C\u0631\u062F \u062A\u062D\u062F\u064A\u062F {fields}."
  },
  panel: {
    title: "\u0627\u0644\u0648\u062B\u064A\u0642\u0629",
    details: "\u0627\u0644\u062A\u0641\u0627\u0635\u064A\u0644",
    detailsRegion: "\u062A\u0641\u0627\u0635\u064A\u0644 \u0627\u0644\u0648\u062B\u064A\u0642\u0629",
    open: "\u0641\u062A\u062D",
    edit: "\u062A\u0639\u062F\u064A\u0644",
    locked: "\u0647\u0630\u0647 \u0627\u0644\u0648\u062B\u064A\u0642\u0629 \u0641\u064A \u0645\u0633\u0627\u0631 \u0645\u0648\u0627\u0641\u0642\u0629 \u062C\u0627\u0631\u064D: \u0644\u0627 \u064A\u0645\u0643\u0646 \u0625\u0636\u0627\u0641\u0629 \u0646\u0633\u062E\u0629 \u062C\u062F\u064A\u062F\u0629 \u0642\u0628\u0644 \u0627\u0646\u062A\u0647\u0627\u0621 \u0627\u0644\u0645\u0633\u0627\u0631 \u0623\u0648 \u0625\u0644\u063A\u0627\u0626\u0647.",
    missingMetadata: "\u0633\u064A\u064F\u0633\u0646\u064E\u062F \u0627\u0644\u0631\u0645\u0632 \u0628\u0645\u062C\u0631\u062F \u062A\u062D\u062F\u064A\u062F {fields}.",
    deliverables: "\u0627\u0644\u0645\u062E\u0631\u062C\u0627\u062A \u0627\u0644\u0645\u0631\u062A\u0628\u0637\u0629",
    noDeliverables: "\u0644\u0627 \u0645\u062E\u0631\u062C\u0627\u062A \u0645\u0631\u062A\u0628\u0637\u0629",
    notFoundTitle: "\u0644\u0645 \u062A\u0639\u062F \u0647\u0630\u0647 \u0627\u0644\u0648\u062B\u064A\u0642\u0629 \u0645\u0648\u062C\u0648\u062F\u0629",
    notFoundBody: "\u0631\u0628\u0645\u0627 \u062D\u064F\u0630\u0641\u062A \u0623\u0648 \u0646\u064F\u0642\u0644\u062A \u0625\u0644\u0649 \u0645\u062C\u0644\u062F \u0644\u0627 \u062A\u0645\u0644\u0643 \u0635\u0644\u0627\u062D\u064A\u0629 \u0627\u0644\u0648\u0635\u0648\u0644 \u0625\u0644\u064A\u0647.",
    loadFailedTitle: "\u062A\u0639\u0630\u0651\u0631 \u0639\u0631\u0636 \u0627\u0644\u0648\u062B\u064A\u0642\u0629",
    loadFailedBody: "\u062A\u0639\u0630\u0651\u0631 \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0648\u062B\u064A\u0642\u0629. \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629\u060C \u0648\u0625\u0646 \u0627\u0633\u062A\u0645\u0631\u062A \u0627\u0644\u0645\u0634\u0643\u0644\u0629 \u0641\u062A\u0648\u0627\u0635\u0644 \u0645\u0639 \u0627\u0644\u062F\u0639\u0645.",
    close: "\u0625\u063A\u0644\u0627\u0642"
  },
  edit: {
    formLabel: "\u062A\u0639\u062F\u064A\u0644 \u0627\u0644\u0648\u062B\u064A\u0642\u0629",
    titleRequired: "\u0623\u062F\u062E\u0644 \u0639\u0646\u0648\u0627\u0646\u064B\u0627.",
    noChange: "\u0644\u0627 \u062A\u0648\u062C\u062F \u062A\u0639\u062F\u064A\u0644\u0627\u062A \u0644\u062D\u0641\u0638\u0647\u0627.",
    saved: "\u062A\u0645 \u062A\u062D\u062F\u064A\u062B \u0627\u0644\u0648\u062B\u064A\u0642\u0629.",
    saving: "\u062C\u0627\u0631\u064D \u0627\u0644\u062D\u0641\u0638\u2026"
  },
  versions: {
    region: "\u0633\u062C\u0644 \u0627\u0644\u0646\u0633\u062E",
    title: "\u0627\u0644\u0646\u0633\u062E",
    listLabel: "\u0646\u0633\u062E \u0627\u0644\u0648\u062B\u064A\u0642\u0629 \u0645\u0646 \u0627\u0644\u0623\u062D\u062F\u062B \u0625\u0644\u0649 \u0627\u0644\u0623\u0642\u062F\u0645",
    newVersion: "\u0646\u0633\u062E\u0629 \u062C\u062F\u064A\u062F\u0629",
    none: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0646\u0633\u062E \u0628\u0639\u062F.",
    loadFailed: "\u062A\u0639\u0630\u0651\u0631 \u062A\u062D\u0645\u064A\u0644 \u0633\u062C\u0644 \u0627\u0644\u0646\u0633\u062E.",
    index: "\u0627\u0644\u0645\u0624\u0634\u0631 {index}",
    current: "\u0627\u0644\u0646\u0633\u062E\u0629 \u0627\u0644\u062D\u0627\u0644\u064A\u0629",
    reasonLabel: "\u0627\u0644\u0633\u0628\u0628:",
    restoredFrom: "\u0645\u0633\u062A\u0639\u0627\u062F\u0629 \u0645\u0646 \u0627\u0644\u0645\u0624\u0634\u0631 {index}",
    restoredFromOlder: "\u0645\u0633\u062A\u0639\u0627\u062F\u0629 \u0645\u0646 \u0646\u0633\u062E\u0629 \u0633\u0627\u0628\u0642\u0629",
    by: "\u0628\u0648\u0627\u0633\u0637\u0629 {author} ({organization})\u060C",
    unknownAuthor: "\u0645\u0624\u0644\u0641 \u063A\u064A\u0631 \u0645\u0639\u0631\u0648\u0641",
    code: "\u0627\u0644\u0631\u0645\u0632:",
    hash: "SHA-256:",
    copyHash: "\u0646\u0633\u062E \u0628\u0635\u0645\u0629 SHA-256 \u0627\u0644\u0643\u0627\u0645\u0644\u0629: {hash}",
    hashCopied: "\u062A\u0645 \u0646\u0633\u062E \u0628\u0635\u0645\u0629 SHA-256.",
    hashCopyFailed: "\u062A\u0639\u0630\u0651\u0631 \u0627\u0644\u0646\u0633\u062E. \u062D\u062F\u0651\u062F \u0627\u0644\u0628\u0635\u0645\u0629 \u0648\u0627\u0646\u0633\u062E\u0647\u0627 \u064A\u062F\u0648\u064A\u064B\u0627.",
    restore: "\u0627\u0633\u062A\u0639\u0627\u062F\u0629",
    restoreLabel: "\u0627\u0633\u062A\u0639\u0627\u062F\u0629 \u0627\u0644\u0646\u0633\u062E\u0629 \u0630\u0627\u062A \u0627\u0644\u0645\u0624\u0634\u0631 {index}",
    compareSelect: "\u0627\u062E\u062A\u064A\u0627\u0631 \u0627\u0644\u0645\u0631\u0627\u062C\u0639\u0629 {index} \u0644\u0644\u0645\u0642\u0627\u0631\u0646\u0629",
    compareAction: "\u0645\u0642\u0627\u0631\u0646\u0629 \u0627\u0644\u0645\u0631\u0627\u062C\u0639\u062A\u064A\u0646",
    compareHintNone: "\u062D\u062F\u0651\u062F \u0645\u0631\u0627\u062C\u0639\u062A\u064A\u0646 \u0644\u0645\u0642\u0627\u0631\u0646\u062A\u0647\u0645\u0627.",
    compareHintOne: "\u062D\u062F\u0651\u062F \u0645\u0631\u0627\u062C\u0639\u0629 \u062B\u0627\u0646\u064A\u0629.",
    compareHintReady: "\u062A\u0645 \u0627\u062E\u062A\u064A\u0627\u0631 \u0645\u0631\u0627\u062C\u0639\u062A\u064A\u0646."
  },
  reason: {
    label: "\u0627\u0644\u0633\u0628\u0628",
    hint: "\u0625\u0644\u0632\u0627\u0645\u064A: \u0645\u0646 3 \u0625\u0644\u0649 {max} \u062D\u0631\u0641\u064B\u0627.",
    required: "\u0627\u0630\u0643\u0631 \u0627\u0644\u0633\u0628\u0628 \u0641\u064A 3 \u0623\u062D\u0631\u0641 \u0639\u0644\u0649 \u0627\u0644\u0623\u0642\u0644."
  },
  restore: {
    title: "\u0627\u0633\u062A\u0639\u0627\u062F\u0629 \u0627\u0644\u0645\u0624\u0634\u0631 {index}",
    intro: "\u062A\u064F\u0636\u0627\u0641 \u0627\u0644\u0646\u0633\u062E\u0629 \u0627\u0644\u0645\u062E\u062A\u0627\u0631\u0629 \u0643\u0646\u0633\u062E\u0629 \u062C\u062F\u064A\u062F\u0629 \u0628\u0627\u0644\u0645\u0624\u0634\u0631 \u0627\u0644\u062A\u0627\u0644\u064A. \u064A\u064F\u062D\u062A\u0641\u0638 \u0628\u0627\u0644\u0633\u062C\u0644 \u0643\u0627\u0645\u0644\u064B\u0627: \u0644\u0627 \u0634\u064A\u0621 \u064A\u064F\u0645\u062D\u0649.",
    confirm: "\u0627\u0633\u062A\u0639\u0627\u062F\u0629",
    restoring: "\u062C\u0627\u0631\u064D \u0627\u0644\u0627\u0633\u062A\u0639\u0627\u062F\u0629\u2026",
    done: "\u062A\u0645\u062A \u0627\u0633\u062A\u0639\u0627\u062F\u0629 \u0627\u0644\u0645\u0624\u0634\u0631 {index}: \u0623\u0635\u0628\u062D \u0627\u0644\u0622\u0646 \u0627\u0644\u0645\u0624\u0634\u0631 {newIndex}."
  },
  newVersion: {
    title: "\u0646\u0633\u062E\u0629 \u062C\u062F\u064A\u062F\u0629",
    intro: "\u0623\u0636\u0641 \u0645\u0644\u0641\u064B\u0627 \u0643\u0646\u0633\u062E\u0629 \u062C\u062F\u064A\u062F\u0629 \u0645\u0646 {title}. \u0633\u064A\u062D\u0635\u0644 \u0639\u0644\u0649 \u0627\u0644\u0645\u0624\u0634\u0631 \u0627\u0644\u062A\u0627\u0644\u064A.",
    file: "\u0627\u0644\u0645\u0644\u0641",
    fileRequired: "\u0627\u062E\u062A\u0631 \u0645\u0644\u0641\u064B\u0627.",
    confirm: "\u0625\u0636\u0627\u0641\u0629 \u0627\u0644\u0646\u0633\u062E\u0629",
    started: "\u0628\u062F\u0623 \u0625\u0631\u0633\u0627\u0644 {name}: \u062A\u0627\u0628\u0639\u0647 \u062A\u062D\u062A \u0645\u0646\u0637\u0642\u0629 \u0625\u0636\u0627\u0641\u0629 \u0627\u0644\u0645\u0644\u0641\u0627\u062A."
  },
  approvals: {
    status: {
      in_progress: "\u0642\u064A\u062F \u0627\u0644\u062A\u0623\u0634\u064A\u0631",
      approved: "\u0645\u0624\u0634\u064E\u0651\u0631 \u0639\u0644\u064A\u0647 (VSO)",
      approved_with_comments: "\u0645\u0624\u0634\u064E\u0651\u0631 \u0639\u0644\u064A\u0647 \u0645\u0639 \u0645\u0644\u0627\u062D\u0638\u0627\u062A (VAO)",
      rejected: "\u0645\u0631\u0641\u0648\u0636 (REF)",
      cancelled: "\u0645\u0644\u063A\u0649"
    },
    decisions: {
      vso: {
        chip: "VSO \u2014 \u0645\u0624\u0634\u064E\u0651\u0631 \u0628\u062F\u0648\u0646 \u0645\u0644\u0627\u062D\u0638\u0627\u062A",
        short: "VSO",
        hint: "\u062A\u0648\u0627\u0641\u0642 \u0639\u0644\u0649 \u0627\u0644\u0648\u062B\u064A\u0642\u0629 \u0643\u0645\u0627 \u0647\u064A."
      },
      vao: {
        chip: "VAO \u2014 \u0645\u0624\u0634\u064E\u0651\u0631 \u0645\u0639 \u0645\u0644\u0627\u062D\u0638\u0627\u062A",
        short: "VAO",
        hint: "\u062A\u0648\u0627\u0641\u0642 \u0639\u0644\u0649 \u0627\u0644\u0648\u062B\u064A\u0642\u0629 \u0628\u0634\u0631\u0637 \u0645\u0631\u0627\u0639\u0627\u0629 \u0645\u0644\u0627\u062D\u0638\u0627\u062A\u0643. \u0627\u0644\u0645\u0644\u0627\u062D\u0638\u0629 \u0625\u0644\u0632\u0627\u0645\u064A\u0629."
      },
      ref: {
        chip: "REF \u2014 \u0645\u0631\u0641\u0648\u0636",
        short: "REF",
        hint: "\u062A\u0631\u0641\u0636 \u0647\u0630\u0647 \u0627\u0644\u0646\u0633\u062E\u0629: \u064A\u062A\u0648\u0642\u0641 \u0627\u0644\u0645\u0633\u0627\u0631 \u0648\u064A\u062C\u0628 \u062A\u0635\u062D\u064A\u062D \u0627\u0644\u0648\u062B\u064A\u0642\u0629. \u0627\u0644\u0645\u0644\u0627\u062D\u0638\u0629 \u0625\u0644\u0632\u0627\u0645\u064A\u0629."
      }
    },
    stepper: {
      label: "\u062E\u0637\u0648\u0627\u062A \u0645\u0633\u0627\u0631 \u0627\u0644\u062A\u0623\u0634\u064A\u0631",
      step: "\u0627\u0644\u062E\u0637\u0648\u0629 {n}",
      mode: {
        sequential: "\u0628\u0627\u0644\u062A\u0631\u062A\u064A\u0628",
        parallel: "\u0628\u0627\u0644\u062A\u0648\u0627\u0632\u064A"
      },
      current: "\u0627\u0644\u062E\u0637\u0648\u0629 \u0627\u0644\u062D\u0627\u0644\u064A\u0629",
      stepStatus: {
        waiting: "\u0642\u0627\u062F\u0645\u0629",
        cancelled: "\u0645\u0644\u063A\u0627\u0629"
      },
      due: "\u0627\u0644\u0623\u062C\u0644:",
      reviewers: "\u0645\u0631\u0627\u062C\u0639\u0648 \u0627\u0644\u062E\u0637\u0648\u0629 {n}",
      unknownReviewer: "\u0645\u0631\u0627\u062C\u0639 \u063A\u064A\u0631 \u0645\u0639\u0631\u0648\u0641",
      unknownOffice: "\u0645\u0643\u062A\u0628 \u063A\u064A\u0631 \u0645\u0639\u0631\u0648\u0641",
      you: "(\u0623\u0646\u062A)",
      turn: "\u062D\u0627\u0646 \u062F\u0648\u0631\u0647 \u0644\u0644\u0628\u062A\u0651",
      waiting: "\u0641\u064A \u0627\u0646\u062A\u0638\u0627\u0631 \u0631\u0623\u064A\u0647",
      later: "\u0644\u0645 \u064A\u064F\u0637\u0644\u0628 \u0645\u0646\u0647 \u0627\u0644\u0631\u0623\u064A \u0628\u0639\u062F"
    },
    steps: {
      step: "\u0627\u0644\u062E\u0637\u0648\u0629 {n}",
      moveStepUp: "\u0631\u0641\u0639 \u0627\u0644\u062E\u0637\u0648\u0629 {n}",
      moveStepDown: "\u0625\u0646\u0632\u0627\u0644 \u0627\u0644\u062E\u0637\u0648\u0629 {n}",
      removeStep: "\u062D\u0630\u0641 \u0627\u0644\u062E\u0637\u0648\u0629 {n}",
      mode: "\u0646\u0645\u0637 \u0627\u0644\u062E\u0637\u0648\u0629 {n}",
      sequential: "\u0628\u0627\u0644\u062A\u0631\u062A\u064A\u0628",
      parallel: "\u0628\u0627\u0644\u062A\u0648\u0627\u0632\u064A",
      sequentialHint: "\u064A\u064F\u0628\u062F\u064A \u0643\u0644 \u0645\u0631\u0627\u062C\u0639 \u0631\u0623\u064A\u0647 \u0628\u062F\u0648\u0631\u0647\u060C \u0648\u0641\u0642 \u062A\u0631\u062A\u064A\u0628 \u0627\u0644\u0642\u0627\u0626\u0645\u0629.",
      parallelHint: "\u064A\u0645\u0643\u0646 \u0644\u062C\u0645\u064A\u0639 \u0627\u0644\u0645\u0631\u0627\u062C\u0639\u064A\u0646 \u0627\u0644\u0631\u062F \u0641\u064A \u0648\u0642\u062A \u0648\u0627\u062D\u062F \u0648\u0628\u0623\u064A \u062A\u0631\u062A\u064A\u0628.",
      reviewersOf: "\u0645\u0631\u0627\u062C\u0639\u0648 \u0627\u0644\u062E\u0637\u0648\u0629 {n}",
      moveReviewerUp: "\u0631\u0641\u0639 {name} \u0641\u064A \u0627\u0644\u062E\u0637\u0648\u0629 {n}",
      moveReviewerDown: "\u0625\u0646\u0632\u0627\u0644 {name} \u0641\u064A \u0627\u0644\u062E\u0637\u0648\u0629 {n}",
      removeReviewer: "\u0625\u0632\u0627\u0644\u0629 {name} \u0645\u0646 \u0627\u0644\u062E\u0637\u0648\u0629 {n}",
      noReviewers: "\u0644\u0627 \u0645\u0631\u0627\u062C\u0639: \u0623\u0636\u0641 \u0634\u062E\u0635\u064B\u0627 \u0648\u0627\u062D\u062F\u064B\u0627 \u0639\u0644\u0649 \u0627\u0644\u0623\u0642\u0644.",
      addReviewerLabel: "\u0625\u0636\u0627\u0641\u0629 \u0645\u0631\u0627\u062C\u0639 \u0625\u0644\u0649 \u0627\u0644\u062E\u0637\u0648\u0629 {n}",
      addPlaceholder: "\u0627\u062E\u062A\u0631 \u0634\u062E\u0635\u064B\u0627",
      addReviewer: "\u0625\u0636\u0627\u0641\u0629",
      addReviewerTo: "\u0625\u0636\u0627\u0641\u0629 \u0627\u0644\u0645\u0631\u0627\u062C\u0639 \u0627\u0644\u0645\u062E\u062A\u0627\u0631 \u0625\u0644\u0649 \u0627\u0644\u062E\u0637\u0648\u0629 {n}",
      membersFailed: "\u0642\u0627\u0626\u0645\u0629 \u0623\u0634\u062E\u0627\u0635 \u0627\u0644\u0645\u0643\u062A\u0628 \u063A\u064A\u0631 \u0645\u062A\u0627\u062D\u0629 \u062D\u0627\u0644\u064A\u064B\u0627.",
      noneToAdd: "\u062C\u0645\u064A\u0639 \u0623\u0634\u062E\u0627\u0635 \u0627\u0644\u0645\u0643\u062A\u0628 \u0645\u0648\u062C\u0648\u062F\u0648\u0646 \u0628\u0627\u0644\u0641\u0639\u0644 \u0641\u064A \u0647\u0630\u0647 \u0627\u0644\u062E\u0637\u0648\u0629.",
      officesOf: "\u0627\u0644\u0645\u0643\u0627\u062A\u0628 \u0627\u0644\u0634\u0631\u064A\u0643\u0629 \u0641\u064A \u0627\u0644\u062E\u0637\u0648\u0629 {n}",
      addOfficeLabel: "\u0625\u0636\u0627\u0641\u0629 \u0645\u0643\u062A\u0628 \u0634\u0631\u064A\u0643 \u0625\u0644\u0649 \u0627\u0644\u062E\u0637\u0648\u0629 {n}",
      addOfficePlaceholder: "\u0627\u062E\u062A\u0631 \u0645\u0643\u062A\u0628\u064B\u0627 \u0634\u0631\u064A\u0643\u064B\u0627",
      addOffice: "\u0625\u0636\u0627\u0641\u0629 \u0627\u0644\u0645\u0643\u062A\u0628",
      addOfficeTo: "\u0625\u0636\u0627\u0641\u0629 \u0627\u0644\u0645\u0643\u062A\u0628 \u0627\u0644\u0645\u062E\u062A\u0627\u0631 \u0625\u0644\u0649 \u0627\u0644\u062E\u0637\u0648\u0629 {n}",
      removeOffice: "\u0625\u0632\u0627\u0644\u0629 \u0627\u0644\u0645\u0643\u062A\u0628 {name} \u0645\u0646 \u0627\u0644\u062E\u0637\u0648\u0629 {n}",
      officeHint: "\u0633\u064A\u064F\u0637\u0644\u0628 \u0631\u0623\u064A \u0645\u0639\u062A\u0645\u062F\u064A \u0647\u0630\u0627 \u0627\u0644\u0645\u0643\u062A\u0628 \u0641\u064A \u0627\u0644\u0641\u0636\u0627\u0621 \u0627\u0644\u0645\u0634\u062A\u0631\u0643.",
      addStep: "\u0625\u0636\u0627\u0641\u0629 \u062E\u0637\u0648\u0629",
      noReviewerProblem: "\u064A\u062C\u0628 \u0623\u0646 \u064A\u0643\u0648\u0646 \u0644\u0643\u0644 \u062E\u0637\u0648\u0629 \u0645\u0631\u0627\u062C\u0639 \u0648\u0627\u062D\u062F \u0639\u0644\u0649 \u0627\u0644\u0623\u0642\u0644."
    },
    summary: {
      sequential: "\u0627\u0644\u062E\u0637\u0648\u0629 {n}: {names}\u060C \u0628\u0647\u0630\u0627 \u0627\u0644\u062A\u0631\u062A\u064A\u0628",
      parallel: "\u0627\u0644\u062E\u0637\u0648\u0629 {n}: {names}\u060C \u0628\u0623\u064A \u062A\u0631\u062A\u064A\u0628",
      officeApprovers: "\u0645\u0639\u062A\u0645\u062F\u0648 {office} \u0641\u064A \u0627\u0644\u0641\u0636\u0627\u0621"
    },
    request: {
      title: "\u0637\u0644\u0628 \u062A\u0623\u0634\u064A\u0631\u0629 \u0639\u0644\u0649 \xAB{title}\xBB",
      intro: "\u062A\u064F\u0631\u0633\u064E\u0644 \u0627\u0644\u0646\u0633\u062E\u0629 \u0627\u0644\u062D\u0627\u0644\u064A\u0629 \u0645\u0646 \u0627\u0644\u0648\u062B\u064A\u0642\u0629 \u0625\u0644\u0649 \u0627\u0644\u0645\u0631\u0627\u062C\u0639\u064A\u0646. \u0623\u062B\u0646\u0627\u0621 \u0627\u0644\u0645\u0633\u0627\u0631 \u062A\u0643\u0648\u0646 \u0627\u0644\u0648\u062B\u064A\u0642\u0629 \u0645\u0642\u0641\u0644\u0629: \u0644\u0627 \u064A\u0645\u0643\u0646 \u0625\u0636\u0627\u0641\u0629 \u0646\u0633\u062E\u0629 \u062C\u062F\u064A\u062F\u0629 \u0642\u0628\u0644 \u0627\u0646\u062A\u0647\u0627\u0626\u0647 \u0623\u0648 \u0625\u0644\u063A\u0627\u0626\u0647.",
      sourceLabel: "\u0645\u0633\u0627\u0631 \u0627\u0644\u062A\u0623\u0634\u064A\u0631",
      fromTemplate: "\u0627\u0633\u062A\u062E\u062F\u0627\u0645 \u0646\u0645\u0648\u0630\u062C \u0645\u0646 \u0627\u0644\u0645\u0643\u062A\u0628",
      fromScratch: "\u062A\u0631\u0643\u064A\u0628 \u0627\u0644\u062E\u0637\u0648\u0627\u062A \u0628\u0646\u0641\u0633\u064A",
      templatesFailed: "\u062A\u0639\u0630\u0651\u0631 \u062A\u062D\u0645\u064A\u0644 \u0646\u0645\u0627\u0630\u062C \u0627\u0644\u0645\u0643\u062A\u0628: \u0631\u0643\u0651\u0628 \u0627\u0644\u062E\u0637\u0648\u0627\u062A \u0628\u0646\u0641\u0633\u0643.",
      templateLabel: "\u0627\u0644\u0646\u0645\u0648\u0630\u062C",
      templateRequired: "\u0627\u062E\u062A\u0631 \u0646\u0645\u0648\u0630\u062C\u064B\u0627.",
      templatePlaceholder: "\u0627\u062E\u062A\u0631 \u0646\u0645\u0648\u0630\u062C\u064B\u0627",
      dueLabel: "\u0627\u0644\u0623\u062C\u0644 (\u0627\u062E\u062A\u064A\u0627\u0631\u064A)",
      dueHint: "\u0627\u0644\u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0645\u0646\u062A\u0638\u0631 \u0641\u064A\u0647 \u0643\u0644 \u062E\u0637\u0648\u0629: \u064A\u062A\u0644\u0642\u0649 \u0627\u0644\u0645\u0631\u0627\u062C\u0639\u0648\u0646 \u062A\u0630\u0643\u064A\u0631\u0627\u062A.",
      summaryTitle: "\u0645\u0646 \u064A\u0642\u0631\u0651\u0631 \u0648\u0628\u0623\u064A \u062A\u0631\u062A\u064A\u0628",
      summaryRules: "\u0644\u0627 \u062A\u064F\u0641\u062A\u062D \u0627\u0644\u062E\u0637\u0648\u0629 \u0625\u0644\u0627 \u0628\u0639\u062F \u0627\u0646\u062A\u0647\u0627\u0621 \u0627\u0644\u062A\u064A \u0633\u0628\u0642\u062A\u0647\u0627. \u0648\u064A\u064F\u0639\u062A\u0645\u062F \u0627\u0644\u0631\u0623\u064A \u0627\u0644\u0623\u0634\u062F: \u064A\u0643\u0641\u064A \u0631\u0641\u0636 \u0648\u0627\u062D\u062F (REF) \u0644\u0625\u064A\u0642\u0627\u0641 \u0627\u0644\u0645\u0633\u0627\u0631.",
      send: "\u0625\u0631\u0633\u0627\u0644 \u0627\u0644\u0637\u0644\u0628",
      sending: "\u062C\u0627\u0631\u064D \u0627\u0644\u0625\u0631\u0633\u0627\u0644\u2026",
      done: "\u062A\u0645 \u0625\u0631\u0633\u0627\u0644 \u0637\u0644\u0628 \u0627\u0644\u062A\u0623\u0634\u064A\u0631\u0629 \u0639\u0644\u0649 \xAB{title}\xBB."
    },
    decide: {
      title: "\u0631\u0623\u064A\u0643 \u0641\u064A \xAB{document}\xBB",
      index: "\u0627\u0644\u0645\u0624\u0634\u0631",
      intro: "\u0631\u0623\u064A\u0643 \u0646\u0647\u0627\u0626\u064A: \u0644\u0646 \u062A\u0633\u062A\u0637\u064A\u0639 \u062A\u0639\u062F\u064A\u0644\u0647 \u0628\u0639\u062F \u0625\u0631\u0633\u0627\u0644\u0647.",
      choiceLabel: "\u0631\u0623\u064A\u0643",
      choiceRequired: "\u0627\u062E\u062A\u0631 \u0631\u0623\u064A\u0643: VSO \u0623\u0648 VAO \u0623\u0648 REF.",
      commentLabel: "\u0627\u0644\u0645\u0644\u0627\u062D\u0638\u0629",
      commentHint: "\u0627\u062E\u062A\u064A\u0627\u0631\u064A\u0629 \u0641\u064A \u062D\u0627\u0644\u0629 VSO.",
      commentRequiredHint: "\u0625\u0644\u0632\u0627\u0645\u064A\u0629 \u0641\u064A \u062D\u0627\u0644\u0629 VAO \u0623\u0648 REF\u060C \u0645\u0627 \u0644\u0645 \u062A\u064F\u0631\u0641\u0642 \u062A\u0639\u0644\u064A\u0642\u064B\u0627 \u062A\u0648\u0636\u064A\u062D\u064A\u064B\u0627.",
      commentRequired: "\u0627\u0643\u062A\u0628 \u0645\u0644\u0627\u062D\u0638\u0629 \u0623\u0648 \u0623\u0631\u0641\u0642 \u0623\u062D\u062F \u062A\u0639\u0644\u064A\u0642\u0627\u062A\u0643 \u0627\u0644\u062A\u0648\u0636\u064A\u062D\u064A\u0629.",
      annotationsLegend: "\u0625\u0631\u0641\u0627\u0642 \u062A\u0639\u0644\u064A\u0642\u0627\u062A\u064A \u0627\u0644\u062A\u0648\u0636\u064A\u062D\u064A\u0629",
      annotationsHint: "\u0627\u0644\u062A\u0639\u0644\u064A\u0642\u0627\u062A \u0627\u0644\u062A\u0648\u0636\u064A\u062D\u064A\u0629 \u0627\u0644\u0645\u062D\u062F\u062F\u0629 \u062A\u0631\u062A\u0628\u0637 \u0628\u0631\u0623\u064A\u0643.",
      annotationLine: "\u0627\u0644\u0635\u0641\u062D\u0629 {page}: {comment}",
      send: "\u0625\u0631\u0633\u0627\u0644 \u0631\u0623\u064A\u064A",
      sending: "\u062C\u0627\u0631\u064D \u0627\u0644\u0625\u0631\u0633\u0627\u0644\u2026",
      done: "\u062A\u0645 \u062A\u0633\u062C\u064A\u0644 \u0631\u0623\u064A\u0643 ({decision})."
    },
    decideFlow: {
      title: "\u0631\u0623\u064A\u0643 \u0641\u064A \u062A\u0623\u0634\u064A\u0631\u0629",
      loadFailed: "\u062A\u0639\u0630\u0651\u0631 \u062A\u062D\u0645\u064A\u0644 \u0645\u0633\u0627\u0631 \u0627\u0644\u062A\u0623\u0634\u064A\u0631. \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629\u060C \u0648\u0625\u0646 \u0627\u0633\u062A\u0645\u0631\u062A \u0627\u0644\u0645\u0634\u0643\u0644\u0629 \u0641\u062A\u0648\u0627\u0635\u0644 \u0645\u0639 \u0627\u0644\u062F\u0639\u0645.",
      nothingToDecide: "\u0644\u0645 \u064A\u0639\u062F \u0644\u062F\u064A\u0643 \u0631\u0623\u064A \u0644\u062A\u0628\u062F\u064A\u0647 \u0641\u064A \u0647\u0630\u0627 \u0627\u0644\u0645\u0633\u0627\u0631: \u0627\u0646\u062A\u0647\u0649\u060C \u0623\u0648 \u0633\u0628\u0642 \u0623\u0646 \u0623\u062C\u0628\u062A\u060C \u0623\u0648 \u0644\u0645 \u064A\u062D\u0646 \u062F\u0648\u0631\u0643 \u0628\u0639\u062F."
    },
    cancel: {
      title: "\u0625\u0644\u063A\u0627\u0621 \u0645\u0633\u0627\u0631 \u0627\u0644\u062A\u0623\u0634\u064A\u0631 \u0639\u0644\u0649 \xAB{document}\xBB\u061F",
      body: "\u0644\u0646 \u064A\u062A\u0645\u0643\u0646 \u0627\u0644\u0645\u0631\u0627\u062C\u0639\u0648\u0646 \u0645\u0646 \u0625\u0628\u062F\u0627\u0621 \u0622\u0631\u0627\u0626\u0647\u0645\u060C \u0648\u0633\u062A\u0642\u0628\u0644 \u0627\u0644\u0648\u062B\u064A\u0642\u0629 \u0646\u0633\u062E\u0629 \u062C\u062F\u064A\u062F\u0629 \u0645\u0646 \u062C\u062F\u064A\u062F. \u062A\u0628\u0642\u0649 \u0627\u0644\u0622\u0631\u0627\u0621 \u0627\u0644\u0645\u064F\u0639\u0637\u0627\u0629 \u0641\u064A \u0627\u0644\u0633\u062C\u0644.",
      confirm: "\u0625\u0644\u063A\u0627\u0621 \u0627\u0644\u0645\u0633\u0627\u0631",
      keep: "\u0625\u0628\u0642\u0627\u0621 \u0627\u0644\u0645\u0633\u0627\u0631",
      done: "\u062A\u0645 \u0625\u0644\u063A\u0627\u0621 \u0645\u0633\u0627\u0631 \u0627\u0644\u062A\u0623\u0634\u064A\u0631 \u0639\u0644\u0649 \xAB{document}\xBB."
    },
    flow: {
      decide: "\u0625\u0628\u062F\u0627\u0621 \u0631\u0623\u064A\u064A",
      decideFor: "\u0625\u0628\u062F\u0627\u0621 \u0631\u0623\u064A\u064A \u0641\u064A {document}",
      cancel: "\u0625\u0644\u063A\u0627\u0621 \u0627\u0644\u0645\u0633\u0627\u0631",
      cancelFor: "\u0625\u0644\u063A\u0627\u0621 \u0645\u0633\u0627\u0631 \u0627\u0644\u062A\u0623\u0634\u064A\u0631 \u0639\u0644\u0649 {document}",
      index: "\u0627\u0644\u0645\u0624\u0634\u0631",
      startedBy: "\u0637\u0644\u0628\u0647 {name} \u0641\u064A",
      started: "\u0637\u064F\u0644\u0628 \u0641\u064A",
      completed: "\u0627\u0646\u062A\u0647\u0649 \u0641\u064A",
      due: "\u0627\u0644\u0623\u062C\u0644:"
    },
    section: {
      loadFailed: "\u062A\u0639\u0630\u0651\u0631 \u062A\u062D\u0645\u064A\u0644 \u0645\u0633\u0627\u0631\u0627\u062A \u0627\u0644\u062A\u0623\u0634\u064A\u0631 \u0644\u0647\u0630\u0647 \u0627\u0644\u0648\u062B\u064A\u0642\u0629.",
      none: "\u0644\u0645 \u064A\u064F\u0637\u0644\u0628 \u0623\u064A \u062A\u0623\u0634\u064A\u0631 \u0644\u0647\u0630\u0647 \u0627\u0644\u0648\u062B\u064A\u0642\u0629.",
      past: "\u0627\u0644\u0645\u0633\u0627\u0631\u0627\u062A \u0627\u0644\u0633\u0627\u0628\u0642\u0629",
      region: "\u062A\u0623\u0634\u064A\u0631 \u0627\u0644\u0648\u062B\u064A\u0642\u0629",
      title: "\u0627\u0644\u062A\u0623\u0634\u064A\u0631",
      request: "\u0637\u0644\u0628 \u062A\u0623\u0634\u064A\u0631\u0629"
    },
    errors: {
      locked: "\u0647\u0630\u0647 \u0627\u0644\u0648\u062B\u064A\u0642\u0629 \u0641\u064A \u0645\u0633\u0627\u0631 \u062A\u0623\u0634\u064A\u0631 \u062C\u0627\u0631\u064D: \u0627\u0646\u062A\u0638\u0631 \u0627\u0646\u062A\u0647\u0627\u0621\u0647 \u0623\u0648 \u0623\u0644\u063A\u0650\u0647.",
      notYourTurn: "\u0644\u0645 \u064A\u062D\u0646 \u062F\u0648\u0631\u0643 \u0628\u0639\u062F: \u0639\u0644\u0649 \u0645\u0631\u0627\u062C\u0639 \u064A\u0633\u0628\u0642\u0643 \u0623\u0646 \u064A\u0628\u062F\u064A \u0631\u0623\u064A\u0647 \u0623\u0648\u0644\u064B\u0627.",
      closed: "\u0627\u0646\u062A\u0647\u0649 \u0647\u0630\u0627 \u0627\u0644\u0645\u0633\u0627\u0631 \u0623\u0648 \u0644\u0645 \u062A\u0639\u062F \u0647\u0630\u0647 \u0627\u0644\u062E\u0637\u0648\u0629 \u062A\u0646\u062A\u0638\u0631 \u0622\u0631\u0627\u0621. \u0623\u064F\u0639\u064A\u062F \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0642\u0627\u0626\u0645\u0629.",
      observationRequired: "\u0623\u0636\u0641 \u0645\u0644\u0627\u062D\u0638\u0629 (\u062A\u0639\u0644\u064A\u0642\u064B\u0627 \u0623\u0648 \u062A\u0639\u0644\u064A\u0642\u064B\u0627 \u062A\u0648\u0636\u064A\u062D\u064A\u064B\u0627) \u0641\u064A \u062D\u0627\u0644\u0629 VAO \u0623\u0648 REF.",
      reviewerCannotView: "\u0644\u0627 \u064A\u0633\u062A\u0637\u064A\u0639 \u0623\u062D\u062F \u0627\u0644\u0645\u0631\u0627\u062C\u0639\u064A\u0646 \u0641\u062A\u062D \u0647\u0630\u0647 \u0627\u0644\u0648\u062B\u064A\u0642\u0629. \u0627\u0645\u0646\u062D\u0647 \u0635\u0644\u0627\u062D\u064A\u0629 \u0627\u0644\u0648\u0635\u0648\u0644 \u0625\u0644\u064A\u0647\u0627 \u0623\u0648\u0644\u064B\u0627\u060C \u0623\u0648 \u0627\u062E\u062A\u0631 \u0634\u062E\u0635\u064B\u0627 \u0622\u062E\u0631.",
      versionNotAvailable: "\u0644\u0627 \u064A\u0645\u0643\u0646 \u0625\u0631\u0633\u0627\u0644 \u0625\u0644\u0627 \u0646\u0633\u062E\u0629 \u062A\u0645 \u0641\u062D\u0635\u0647\u0627 \u0648\u0647\u064A \u0645\u062A\u0627\u062D\u0629: \u0627\u0646\u062A\u0638\u0631 \u0627\u0646\u062A\u0647\u0627\u0621 \u0641\u062D\u0635 \u0645\u0636\u0627\u062F \u0627\u0644\u0641\u064A\u0631\u0648\u0633\u0627\u062A.",
      stepsInvalid: "\u0627\u0644\u062E\u0637\u0648\u0627\u062A \u063A\u064A\u0631 \u0635\u0627\u0644\u062D\u0629: \u062A\u062D\u062A\u0627\u062C \u0643\u0644 \u062E\u0637\u0648\u0629 \u0625\u0644\u0649 \u0645\u0631\u0627\u062C\u0639 \u0648\u0627\u062D\u062F \u0639\u0644\u0649 \u0627\u0644\u0623\u0642\u0644\u060C \u0648\u0644\u0627 \u064A\u0645\u0643\u0646 \u0625\u062F\u0631\u0627\u062C \u0627\u0644\u0634\u062E\u0635 \u0646\u0641\u0633\u0647 \u0645\u0631\u062A\u064A\u0646 \u0641\u064A \u062E\u0637\u0648\u0629.",
      officeUnknown: "\u0644\u0627 \u064A\u0645\u0643\u0646 \u0637\u0644\u0628 \u0627\u0644\u0631\u0623\u064A \u0625\u0644\u0627 \u0645\u0646 \u0627\u0644\u0645\u0643\u0627\u062A\u0628 \u0627\u0644\u0634\u0631\u064A\u0643\u0629 \u0641\u064A \u0641\u0636\u0627\u0621\u0627\u062A\u0643\u0645 \u0627\u0644\u0645\u0634\u062A\u0631\u0643\u0629.",
      officeNoReviewer: "\u0644\u064A\u0633 \u0644\u062F\u0649 \u0623\u062D\u062F \u0627\u0644\u0645\u0643\u0627\u062A\u0628 \u0627\u0644\u0634\u0631\u064A\u0643\u0629 \u0623\u064A \u0645\u0639\u062A\u0645\u062F \u0641\u064A \u0647\u0630\u0627 \u0627\u0644\u0641\u0636\u0627\u0621. \u0627\u0637\u0644\u0628 \u0645\u0646\u0647 \u062A\u0641\u0648\u064A\u0636 \u0634\u062E\u0635 \u064A\u0645\u0644\u0643 \u062D\u0642 \u0627\u0644\u0627\u0639\u062A\u0645\u0627\u062F\u060C \u0623\u0648 \u0627\u062E\u062A\u0631 \u0634\u062E\u0635\u064B\u0627 \u0622\u062E\u0631.",
      invalid: "\u0628\u0639\u0636 \u0627\u0644\u0645\u0639\u0644\u0648\u0645\u0627\u062A \u063A\u064A\u0631 \u0635\u0627\u0644\u062D\u0629. \u0631\u0627\u062C\u0639\u0647\u0627 \u062B\u0645 \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629.",
      forbidden: "\u0644\u064A\u0633 \u0644\u062F\u064A\u0643 \u0627\u0644\u0625\u0630\u0646 \u0628\u0647\u0630\u0627 \u0627\u0644\u0625\u062C\u0631\u0627\u0621: \u0644\u0633\u062A \u0645\u0631\u0627\u062C\u0639\u064B\u0627 \u0641\u064A \u0647\u0630\u0647 \u0627\u0644\u062E\u0637\u0648\u0629 \u0623\u0648 \u0644\u0645 \u062A\u0637\u0644\u0628 \u0647\u0630\u0647 \u0627\u0644\u062A\u0623\u0634\u064A\u0631\u0629.",
      notFound: "\u0644\u0645 \u064A\u0639\u062F \u0647\u0630\u0627 \u0627\u0644\u0645\u0633\u0627\u0631 \u0645\u0648\u062C\u0648\u062F\u064B\u0627 \u0623\u0648 \u0644\u0645 \u062A\u0639\u062F \u062A\u0645\u0644\u0643 \u0635\u0644\u0627\u062D\u064A\u0629 \u0627\u0644\u0648\u0635\u0648\u0644 \u0625\u0644\u064A\u0647."
    },
    tab: {
      noSpace: {
        title: "\u0645\u0633\u0627\u0631\u0627\u062A \u0627\u0644\u062A\u0623\u0634\u064A\u0631 \u063A\u064A\u0631 \u0645\u062A\u0627\u062D\u0629 \u0628\u0639\u062F",
        description: "\u0633\u062A\u0638\u0647\u0631 \u0628\u0645\u062C\u0631\u062F \u0623\u0646 \u062A\u0635\u0628\u062D \u0645\u0633\u0627\u062D\u0629 \u0645\u0644\u0641\u0627\u062A \u0627\u0644\u0645\u0634\u0631\u0648\u0639 \u062C\u0627\u0647\u0632\u0629."
      },
      columns: {
        document: "\u0627\u0644\u0648\u062B\u064A\u0642\u0629",
        index: "\u0627\u0644\u0645\u0624\u0634\u0631",
        status: "\u0627\u0644\u062D\u0627\u0644\u0629",
        step: "\u0627\u0644\u062E\u0637\u0648\u0629 \u0627\u0644\u062D\u0627\u0644\u064A\u0629",
        initiator: "\u0637\u0644\u0628\u0647",
        dates: "\u0627\u0644\u062A\u0648\u0627\u0631\u064A\u062E",
        actions: "\u0627\u0644\u0625\u062C\u0631\u0627\u0621\u0627\u062A"
      },
      stepOf: "\u0627\u0644\u062E\u0637\u0648\u0629 {current} \u0645\u0646 {total}",
      started: "\u0637\u064F\u0644\u0628 \u0641\u064A",
      completed: "\u0627\u0646\u062A\u0647\u0649 \u0641\u064A",
      due: "\u0627\u0644\u0623\u062C\u0644:",
      details: "\u0639\u0631\u0636 \u0627\u0644\u0645\u0633\u0627\u0631",
      detailsFor: "\u0639\u0631\u0636 \u0645\u0633\u0627\u0631 \u0627\u0644\u062A\u0623\u0634\u064A\u0631 \u0639\u0644\u0649 {document}",
      detailsTitle: "\u0645\u0633\u0627\u0631 \u0627\u0644\u062A\u0623\u0634\u064A\u0631 \u0639\u0644\u0649 \xAB{document}\xBB",
      filtersLabel: "\u062A\u0635\u0641\u064A\u0629 \u0645\u0633\u0627\u0631\u0627\u062A \u0627\u0644\u062A\u0623\u0634\u064A\u0631",
      filter: {
        all: "\u0627\u0644\u0643\u0644",
        in_progress: "\u0642\u064A\u062F \u0627\u0644\u062A\u0623\u0634\u064A\u0631",
        approved: "\u0645\u0624\u0634\u064E\u0651\u0631 \u0639\u0644\u064A\u0647\u0627",
        approved_with_comments: "\u0645\u0624\u0634\u064E\u0651\u0631 \u0639\u0644\u064A\u0647\u0627 \u0645\u0639 \u0645\u0644\u0627\u062D\u0638\u0627\u062A",
        rejected: "\u0645\u0631\u0641\u0648\u0636\u0629",
        cancelled: "\u0645\u0644\u063A\u0627\u0629",
        toDecide: "\u0645\u0627 \u0639\u0644\u064A\u0651 \u0627\u0644\u0628\u062A\u0651 \u0641\u064A\u0647"
      },
      loadFailedTitle: "\u062A\u0639\u0630\u0651\u0631 \u0639\u0631\u0636 \u0645\u0633\u0627\u0631\u0627\u062A \u0627\u0644\u062A\u0623\u0634\u064A\u0631",
      loadFailedBody: "\u062A\u0639\u0630\u0651\u0631 \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0642\u0627\u0626\u0645\u0629. \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629\u060C \u0648\u0625\u0646 \u0627\u0633\u062A\u0645\u0631\u062A \u0627\u0644\u0645\u0634\u0643\u0644\u0629 \u0641\u062A\u0648\u0627\u0635\u0644 \u0645\u0639 \u0627\u0644\u062F\u0639\u0645.",
      caption: "\u0645\u0633\u0627\u0631\u0627\u062A \u0627\u0644\u062A\u0623\u0634\u064A\u0631 \u0641\u064A \u0627\u0644\u0645\u0634\u0631\u0648\u0639",
      empty: {
        none: {
          title: "\u0644\u0627 \u0645\u0633\u0627\u0631\u0627\u062A \u062A\u0623\u0634\u064A\u0631",
          description: "\u0627\u0641\u062A\u062D \u0648\u062B\u064A\u0642\u0629 \u0641\u064A \u062A\u0628\u0648\u064A\u0628 \u0627\u0644\u0645\u0644\u0641\u0627\u062A \u0648\u0627\u0637\u0644\u0628 \u062A\u0623\u0634\u064A\u0631\u062A\u0647\u0627: \u0633\u064A\u0638\u0647\u0631 \u0627\u0644\u0645\u0633\u0627\u0631 \u0647\u0646\u0627."
        },
        filtered: {
          title: "\u0644\u0627 \u0645\u0633\u0627\u0631 \u0645\u0637\u0627\u0628\u0642",
          description: "\u0627\u062E\u062A\u0631 \u062D\u0627\u0644\u0629 \u0623\u062E\u0631\u0649 \u0644\u0639\u0631\u0636 \u0628\u0642\u064A\u0629 \u0627\u0644\u0645\u0633\u0627\u0631\u0627\u062A."
        },
        toDecide: {
          title: "\u0644\u0627 \u0634\u064A\u0621 \u0644\u0644\u0628\u062A\u0651 \u0641\u064A\u0647 \u062D\u0627\u0644\u064A\u064B\u0627",
          description: "\u0633\u062A\u0638\u0647\u0631 \u0647\u0646\u0627 \u0627\u0644\u0645\u0633\u0627\u0631\u0627\u062A \u0627\u0644\u062A\u064A \u062A\u0646\u062A\u0638\u0631 \u0631\u0623\u064A\u0643."
        }
      }
    },
    templates: {
      title: "\u0646\u0645\u0627\u0630\u062C \u0645\u0633\u0627\u0631\u0627\u062A \u0627\u0644\u062A\u0623\u0634\u064A\u0631",
      description: "\u0645\u0633\u0627\u0631\u0627\u062A \u062C\u0627\u0647\u0632\u0629 \u064A\u0645\u0643\u0646 \u0644\u0641\u0631\u064A\u0642\u0643 \u0627\u062E\u062A\u064A\u0627\u0631\u0647\u0627 \u0639\u0646\u062F \u0637\u0644\u0628 \u062A\u0623\u0634\u064A\u0631\u0629.",
      new: "\u0646\u0645\u0648\u0630\u062C \u062C\u062F\u064A\u062F",
      newTitle: "\u0646\u0645\u0648\u0630\u062C \u0645\u0633\u0627\u0631 \u062C\u062F\u064A\u062F",
      nameLabel: "\u0627\u0633\u0645 \u0627\u0644\u0646\u0645\u0648\u0630\u062C",
      nameRequired: "\u0623\u0639\u0637\u0650 \u0627\u0644\u0646\u0645\u0648\u0630\u062C \u0627\u0633\u0645\u064B\u0627.",
      create: "\u0625\u0646\u0634\u0627\u0621 \u0627\u0644\u0646\u0645\u0648\u0630\u062C",
      creating: "\u062C\u0627\u0631\u064D \u0627\u0644\u0625\u0646\u0634\u0627\u0621\u2026",
      created: "\u062A\u0645 \u0625\u0646\u0634\u0627\u0621 \u0627\u0644\u0646\u0645\u0648\u0630\u062C \xAB{name}\xBB.",
      loadFailed: "\u062A\u0639\u0630\u0651\u0631 \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0646\u0645\u0627\u0630\u062C.",
      empty: "\u0644\u0627 \u0646\u0645\u0627\u0630\u062C \u062D\u0627\u0644\u064A\u064B\u0627. \u064A\u0631\u0643\u0651\u0628 \u0627\u0644\u0641\u0631\u064A\u0642 \u0627\u0644\u062E\u0637\u0648\u0627\u062A \u0639\u0646\u062F\u0626\u0630\u064D \u0639\u0646\u062F \u0643\u0644 \u0637\u0644\u0628.",
      listLabel: "\u0646\u0645\u0627\u0630\u062C \u0645\u0633\u0627\u0631\u0627\u062A \u0627\u0644\u062A\u0623\u0634\u064A\u0631",
      deleteFor: "\u062D\u0630\u0641 \u0627\u0644\u0646\u0645\u0648\u0630\u062C {name}",
      deleteTitle: "\u062D\u0630\u0641 \u0627\u0644\u0646\u0645\u0648\u0630\u062C \xAB{name}\xBB\u061F",
      deleteBody: "\u0644\u0627 \u062A\u062A\u063A\u064A\u0631 \u0627\u0644\u0645\u0633\u0627\u0631\u0627\u062A \u0627\u0644\u062A\u064A \u0628\u062F\u0623\u062A \u0628\u0627\u0644\u0641\u0639\u0644.",
      delete: "\u062D\u0630\u0641",
      deleted: "\u062A\u0645 \u062D\u0630\u0641 \u0627\u0644\u0646\u0645\u0648\u0630\u062C \xAB{name}\xBB.",
      readOnly: "\u0625\u0646\u0634\u0627\u0621 \u0627\u0644\u0646\u0645\u0627\u0630\u062C \u0623\u0648 \u062D\u0630\u0641\u0647\u0627 \u0645\u062E\u0635\u0635 \u0644\u0645\u0646 \u064A\u0645\u0644\u0643 \u0635\u0644\u0627\u062D\u064A\u0629 \u062A\u0639\u062F\u064A\u0644 \u0627\u0644\u0645\u0624\u0633\u0633\u0629."
    }
  },
  trash: {
    open: "\u0633\u0644\u0629 \u0627\u0644\u0645\u062D\u0630\u0648\u0641\u0627\u062A",
    title: "\u0633\u0644\u0629 \u0627\u0644\u0645\u062D\u0630\u0648\u0641\u0627\u062A",
    back: "\u0627\u0644\u0639\u0648\u062F\u0629 \u0625\u0644\u0649 \u0627\u0644\u0645\u0644\u0641\u0627\u062A",
    intro: "\u062A\u0628\u0642\u0649 \u0627\u0644\u0645\u062C\u0644\u062F\u0627\u062A \u0648\u0627\u0644\u0648\u062B\u0627\u0626\u0642 \u0627\u0644\u0645\u062D\u0630\u0648\u0641\u0629 {days} \u064A\u0648\u0645\u064B\u0627 \u0641\u064A \u0633\u0644\u0629 \u0627\u0644\u0645\u062D\u0630\u0648\u0641\u0627\u062A \u062B\u0645 \u062A\u064F\u0645\u0633\u062D \u0646\u0647\u0627\u0626\u064A\u064B\u0627. \u064A\u0631\u0649 \u0627\u0644\u0645\u0633\u0624\u0648\u0644\u0648\u0646 \u0643\u0644 \u0634\u064A\u0621\u060C \u0648\u064A\u0631\u0649 \u0627\u0644\u0622\u062E\u0631\u0648\u0646 \u0645\u0627 \u062D\u0630\u0641\u0648\u0647 \u0647\u0645 \u0641\u0642\u0637.",
    listLabel: "\u0627\u0644\u0639\u0646\u0627\u0635\u0631 \u0627\u0644\u0645\u062D\u0630\u0648\u0641\u0629",
    deletedBy: "\u062D\u0630\u0641\u0647 {who} \u0628\u062A\u0627\u0631\u064A\u062E {date}.",
    deletedOn: "\u062D\u064F\u0630\u0641 \u0628\u062A\u0627\u0631\u064A\u062E {date}.",
    contains: "{count, plural, =0 {\u0645\u062C\u0644\u062F \u0641\u0627\u0631\u063A.} one {\u064A\u062D\u062A\u0648\u064A \u0639\u0644\u0649 \u0639\u0646\u0635\u0631 \u0648\u0627\u062D\u062F.} two {\u064A\u062D\u062A\u0648\u064A \u0639\u0644\u0649 \u0639\u0646\u0635\u0631\u064A\u0646.} few {\u064A\u062D\u062A\u0648\u064A \u0639\u0644\u0649 # \u0639\u0646\u0627\u0635\u0631.} many {\u064A\u062D\u062A\u0648\u064A \u0639\u0644\u0649 # \u0639\u0646\u0635\u0631\u064B\u0627.} other {\u064A\u062D\u062A\u0648\u064A \u0639\u0644\u0649 # \u0639\u0646\u0635\u0631.}}",
    purgeAfter: "\u064A\u064F\u0645\u0633\u062D \u0646\u0647\u0627\u0626\u064A\u064B\u0627 \u0628\u062A\u0627\u0631\u064A\u062E {date}.",
    restore: "\u0627\u0633\u062A\u0639\u0627\u062F\u0629",
    restoreFor: "\u0627\u0633\u062A\u0639\u0627\u062F\u0629 {name}",
    restored: "\u062A\u0645\u062A \u0627\u0633\u062A\u0639\u0627\u062F\u0629 \xAB{name}\xBB.",
    purgeFor: "\u062D\u0630\u0641 {name} \u0646\u0647\u0627\u0626\u064A\u064B\u0627",
    purge: {
      action: "\u062D\u0630\u0641 \u0646\u0647\u0627\u0626\u064A",
      title: "\u062D\u0630\u0641 \xAB{name}\xBB \u0646\u0647\u0627\u0626\u064A\u064B\u0627\u061F",
      bodyFolder: "{count, plural, =0 {\u0633\u064A\u064F\u0645\u0633\u062D \u0647\u0630\u0627 \u0627\u0644\u0645\u062C\u0644\u062F \u0627\u0644\u0641\u0627\u0631\u063A.} one {\u0633\u064A\u064F\u0645\u0633\u062D \u0647\u0630\u0627 \u0627\u0644\u0645\u062C\u0644\u062F \u0648\u0639\u0646\u0635\u0631\u0647 \u0645\u0639 \u0645\u0644\u0641\u0627\u062A\u0647\u0645\u0627.} two {\u0633\u064A\u064F\u0645\u0633\u062D \u0647\u0630\u0627 \u0627\u0644\u0645\u062C\u0644\u062F \u0648\u0639\u0646\u0635\u0631\u0627\u0647 \u0645\u0639 \u0645\u0644\u0641\u0627\u062A\u0647\u0645\u0627.} few {\u0633\u064A\u064F\u0645\u0633\u062D \u0647\u0630\u0627 \u0627\u0644\u0645\u062C\u0644\u062F \u0648\u0639\u0646\u0627\u0635\u0631\u0647 \u0627\u0644\u0640 # \u0645\u0639 \u0645\u0644\u0641\u0627\u062A\u0647\u0627.} many {\u0633\u064A\u064F\u0645\u0633\u062D \u0647\u0630\u0627 \u0627\u0644\u0645\u062C\u0644\u062F \u0648\u0639\u0646\u0627\u0635\u0631\u0647 \u0627\u0644\u0640 # \u0645\u0639 \u0645\u0644\u0641\u0627\u062A\u0647\u0627.} other {\u0633\u064A\u064F\u0645\u0633\u062D \u0647\u0630\u0627 \u0627\u0644\u0645\u062C\u0644\u062F \u0648\u0639\u0646\u0627\u0635\u0631\u0647 \u0627\u0644\u0640 # \u0645\u0639 \u0645\u0644\u0641\u0627\u062A\u0647\u0627.}} \u0644\u0627 \u064A\u0645\u0643\u0646 \u0627\u0644\u062A\u0631\u0627\u062C\u0639 \u0639\u0646 \u0647\u0630\u0627 \u0627\u0644\u0625\u062C\u0631\u0627\u0621.",
      bodyDocument: "\u0633\u062A\u064F\u0645\u0633\u062D \u0627\u0644\u0648\u062B\u064A\u0642\u0629 \u0648\u062C\u0645\u064A\u0639 \u0646\u0633\u062E\u0647\u0627 \u0648\u0645\u0644\u0641\u0627\u062A\u0647\u0627. \u0644\u0627 \u064A\u0645\u0643\u0646 \u0627\u0644\u062A\u0631\u0627\u062C\u0639 \u0639\u0646 \u0647\u0630\u0627 \u0627\u0644\u0625\u062C\u0631\u0627\u0621.",
      confirm: "\u062D\u0630\u0641 \u0646\u0647\u0627\u0626\u064A",
      started: "\u062C\u0627\u0631\u064D \u062D\u0630\u0641 \xAB{name}\xBB \u0646\u0647\u0627\u0626\u064A\u064B\u0627."
    },
    empty: {
      title: "\u0633\u0644\u0629 \u0627\u0644\u0645\u062D\u0630\u0648\u0641\u0627\u062A \u0641\u0627\u0631\u063A\u0629",
      description: "\u062A\u0635\u0644 \u0627\u0644\u0645\u062C\u0644\u062F\u0627\u062A \u0648\u0627\u0644\u0648\u062B\u0627\u0626\u0642 \u0627\u0644\u062A\u064A \u062A\u062D\u0630\u0641\u0647\u0627 \u0625\u0644\u0649 \u0647\u0646\u0627 \u0648\u062A\u0628\u0642\u0649 {days} \u064A\u0648\u0645\u064B\u0627 \u0642\u0628\u0644 \u0623\u0646 \u062A\u064F\u0645\u0633\u062D."
    },
    loadFailed: "\u062A\u0639\u0630\u0651\u0631 \u062A\u062D\u0645\u064A\u0644 \u0633\u0644\u0629 \u0627\u0644\u0645\u062D\u0630\u0648\u0641\u0627\u062A.",
    errors: {
      parentInTrash: "\u0627\u0644\u0645\u062C\u0644\u062F \u0627\u0644\u0630\u064A \u0643\u0627\u0646 \u064A\u062D\u062A\u0648\u064A \u0647\u0630\u0627 \u0627\u0644\u0639\u0646\u0635\u0631 \u0645\u0648\u062C\u0648\u062F \u0623\u064A\u0636\u064B\u0627 \u0641\u064A \u0633\u0644\u0629 \u0627\u0644\u0645\u062D\u0630\u0648\u0641\u0627\u062A. \u0627\u0633\u062A\u0639\u062F \u0647\u0630\u0627 \u0627\u0644\u0645\u062C\u0644\u062F \u0623\u0648\u0644\u064B\u0627.",
      nameTaken: "\u064A\u0648\u062C\u062F \u0645\u062C\u0644\u062F \u0628\u0627\u0644\u0627\u0633\u0645 \u0646\u0641\u0633\u0647 \u0641\u064A \u0647\u0630\u0627 \u0627\u0644\u0645\u0643\u0627\u0646. \u063A\u064A\u0651\u0631 \u0627\u0633\u0645 \u0627\u0644\u0645\u062C\u0644\u062F \u0627\u0644\u0622\u062E\u0631 \u0623\u0648 \u0627\u0646\u0642\u0644\u0647 \u062B\u0645 \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629.",
      legalHold: "\u064A\u062D\u062A\u0648\u064A \u0647\u0630\u0627 \u0627\u0644\u0639\u0646\u0635\u0631 \u0639\u0644\u0649 \u0648\u062B\u064A\u0642\u0629 \u064A\u062C\u0628 \u0627\u0644\u0627\u062D\u062A\u0641\u0627\u0638 \u0628\u0647\u0627 (\u0627\u0644\u062A\u0632\u0627\u0645 \u0642\u0627\u0646\u0648\u0646\u064A)\u060C \u0648\u0644\u0627 \u064A\u0645\u0643\u0646 \u0645\u0633\u062D\u0647 \u0642\u0628\u0644 \u0627\u0646\u062A\u0647\u0627\u0621 \u0647\u0630\u0627 \u0627\u0644\u0627\u0644\u062A\u0632\u0627\u0645.",
      forbidden: "\u0644\u064A\u0633 \u0644\u062F\u064A\u0643 \u0627\u0644\u0625\u0630\u0646 \u0628\u062A\u0646\u0641\u064A\u0630 \u0647\u0630\u0627 \u0627\u0644\u0625\u062C\u0631\u0627\u0621 \u0639\u0644\u0649 \u0647\u0630\u0627 \u0627\u0644\u0639\u0646\u0635\u0631.",
      notFound: "\u0644\u0645 \u064A\u0639\u062F \u0647\u0630\u0627 \u0627\u0644\u0639\u0646\u0635\u0631 \u0641\u064A \u0633\u0644\u0629 \u0627\u0644\u0645\u062D\u0630\u0648\u0641\u0627\u062A. \u062A\u0645 \u062A\u062D\u062F\u064A\u062B \u0627\u0644\u0642\u0627\u0626\u0645\u0629."
    }
  },
  filesApp: {
    tabsLabel: "\u0639\u0631\u0648\u0636 \u0627\u0644\u0645\u0644\u0641\u0627\u062A",
    tabs: {
      recent: "\u0627\u0644\u0623\u062D\u062F\u062B",
      organisation: "\u0627\u0644\u0645\u0624\u0633\u0633\u0629",
      shared: "\u0645\u0634\u062A\u0631\u0643\u0629 \u0645\u0639\u064A",
      search: "\u0628\u062D\u062B"
    },
    recent: {
      listLabel: "\u0627\u0644\u0645\u0644\u0641\u0627\u062A \u0627\u0644\u0645\u0639\u062F\u0651\u0644\u0629 \u0645\u0624\u062E\u0631\u064B\u0627",
      updated: "\u0639\u064F\u062F\u0651\u0644 {when}",
      inFolder: "\u0627\u0644\u0645\u062C\u0644\u062F {folder}",
      loadFailedTitle: "\u062A\u0639\u0630\u0651\u0631 \u0639\u0631\u0636 \u0627\u0644\u0645\u0644\u0641\u0627\u062A \u0627\u0644\u0623\u062D\u062F\u062B",
      loadFailedBody: "\u062A\u062D\u0642\u0651\u0642 \u0645\u0646 \u0627\u0644\u0627\u062A\u0635\u0627\u0644 \u062B\u0645 \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629.",
      emptyTitle: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0645\u0644\u0641\u0627\u062A \u062D\u062F\u064A\u062B\u0629",
      emptyBody: "\u0633\u062A\u0638\u0647\u0631 \u0647\u0646\u0627 \u0627\u0644\u0645\u0644\u0641\u0627\u062A \u0627\u0644\u0645\u0636\u0627\u0641\u0629 \u0623\u0648 \u0627\u0644\u0645\u0639\u062F\u0651\u0644\u0629 \u0641\u064A \u0645\u0634\u0627\u0631\u064A\u0639\u0643 \u0648\u0641\u0636\u0627\u0621\u0627\u062A\u0643."
    },
    organisation: {
      loadFailedTitle: "\u062A\u0639\u0630\u0651\u0631 \u0641\u062A\u062D \u0648\u062B\u0627\u0626\u0642 \u0627\u0644\u0645\u0624\u0633\u0633\u0629",
      loadFailedBody: "\u062A\u062D\u0642\u0651\u0642 \u0645\u0646 \u0627\u0644\u0627\u062A\u0635\u0627\u0644 \u062B\u0645 \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629.",
      noSpaceTitle: "\u0644\u0627 \u064A\u0648\u062C\u062F \u0641\u0636\u0627\u0621 \u0648\u062B\u0627\u0626\u0642 \u0628\u0639\u062F",
      noSpaceBody: "\u0641\u0636\u0627\u0621 \u0648\u062B\u0627\u0626\u0642 \u0627\u0644\u0645\u0624\u0633\u0633\u0629 \u063A\u064A\u0631 \u0645\u062A\u0627\u062D \u062D\u0627\u0644\u064A\u064B\u0627."
    },
    shared: {
      listLabel: "\u0641\u0636\u0627\u0621\u0627\u062A \u0645\u0624\u0633\u0633\u0627\u062A \u0623\u062E\u0631\u0649",
      loadFailedTitle: "\u062A\u0639\u0630\u0651\u0631 \u0639\u0631\u0636 \u0627\u0644\u0641\u0636\u0627\u0621\u0627\u062A \u0627\u0644\u0645\u0634\u062A\u0631\u0643\u0629",
      loadFailedBody: "\u062A\u062D\u0642\u0651\u0642 \u0645\u0646 \u0627\u0644\u0627\u062A\u0635\u0627\u0644 \u062B\u0645 \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629.",
      emptyTitle: "\u0644\u0627 \u0634\u064A\u0621 \u0645\u0634\u062A\u0631\u0643 \u0645\u0639\u0643",
      emptyBody: "\u0639\u0646\u062F\u0645\u0627 \u062A\u062F\u0639\u0648\u0643 \u0645\u0624\u0633\u0633\u0629 \u0623\u062E\u0631\u0649 \u0625\u0644\u0649 \u0623\u062D\u062F \u0641\u0636\u0627\u0621\u0627\u062A\u0647\u0627\u060C \u0633\u062A\u062C\u062F \u0648\u062B\u0627\u0626\u0642\u0647\u0627 \u0647\u0646\u0627."
    },
    search: {
      inputLabel: "\u0627\u0644\u0628\u062D\u062B \u0639\u0646 \u0645\u0644\u0641",
      placeholder: "\u0639\u0646\u0648\u0627\u0646 \u0627\u0644\u0648\u062B\u064A\u0642\u0629 \u0623\u0648 \u0631\u0645\u0632\u0647\u0627\u2026"
    }
  }
};

// locales/en/documents.json
var documents_default2 = {
  noSpace: {
    title: "The file space is not ready yet",
    description: "This project's folders will be available as soon as its internal space has been created. Try again in a moment or contact a project manager."
  },
  tree: {
    label: "Project folders",
    all: "All folders",
    loading: "Loading folders\u2026",
    loadFailed: "The folders could not be loaded.",
    childrenFailed: "Subfolders unavailable"
  },
  breadcrumb: {
    label: "Folder path",
    root: "All folders",
    hidden: "Folder you cannot access"
  },
  content: {
    foldersLabel: "Subfolders",
    loadFailed: "This folder could not be loaded.",
    customRights: "Custom permissions",
    noFolders: {
      title: "No subfolders",
      description: "This folder has no subfolders yet."
    },
    rootEmpty: {
      title: "No folders yet",
      descriptionManage: "Create the project's first folder to file documents in it.",
      descriptionRead: "You do not see any folder yet. A project manager can create one or give you access."
    },
    noDocuments: {
      title: "No documents yet",
      description: "Drop files here or use \u201CAdd files\u201D.",
      descriptionRead: "The documents of this folder will appear here."
    }
  },
  actions: {
    newFolder: "New folder",
    more: "More actions",
    moreFor: "More actions for the folder {name}",
    rename: "Rename\u2026",
    move: "Move\u2026",
    permissions: "Permissions\u2026",
    delete: "Delete"
  },
  name: {
    required: "Enter a folder name.",
    tooLong: "The name cannot be longer than 200 characters.",
    invalid: 'The name cannot contain a slash or a control character, and cannot be "." or "..".'
  },
  create: {
    title: "New folder",
    inFolder: "In: {name}",
    inRoot: "At the root of the project",
    nameLabel: "Folder name",
    submit: "Create",
    saving: "Creating\u2026",
    done: "The folder {name} has been created."
  },
  rename: {
    title: "Rename the folder",
    nameLabel: "New name",
    submit: "Rename",
    saving: "Saving\u2026",
    done: "The folder has been renamed to {name}."
  },
  move: {
    title: "Move the folder {name}",
    intro: 'Open the destination folder, then confirm with "Move here".',
    location: "Location: {name}",
    root: "Project root",
    up: "Go up one level",
    listLabel: "Destination folders",
    open: "Open the folder {name}",
    noSubfolders: "No subfolders at this location.",
    here: "Move here",
    moving: "Moving\u2026",
    alreadyHere: "The folder is already at this location.",
    rootNeedsManager: "Only project managers can place a folder at the root.",
    noWrite: "You cannot add a folder at this location.",
    done: "The folder {name} has been moved."
  },
  delete: {
    title: "Delete the folder {name}?",
    body: "The folder and all its subfolders will be moved to the trash.",
    confirm: "Delete",
    done: "The folder {name} has been moved to the trash.",
    documentName: "{title} (index {index})",
    documentTitle: "Delete the document {name}?",
    documentsTitle: "Delete {count} documents?",
    documentsBody: "{count, plural, one {The document will be moved to the trash.} other {The documents will be moved to the trash.}}",
    andOthers: "{count, plural, one {and # other document} other {and # other documents}}",
    documentsDone: "{count, plural, one {The document was moved to the trash.} other {# documents were moved to the trash.}}",
    documentsPartial: "{deleted, plural, one {# document was deleted} other {# documents were deleted}}, {failed, plural, one {# other could not be} other {# others could not be}}. {reason}"
  },
  permissions: {
    title: "Permissions of the folder {name}",
    inheritParent: "Inherit the rights of the parent folder",
    inheritSpace: "Inherit the rights of the project",
    inheritParentHint: "People who can access the parent folder can access this one.",
    inheritSpaceHint: "People who can access the project can access this folder.",
    customHint: "Only the people listed below and the project managers can reach this folder and its subfolders.",
    listLabel: "People with access",
    everyone: "All members of the office",
    relationOf: "Right of {name}",
    relations: {
      reader: "Reader",
      writer: "Editor"
    },
    remove: "Remove {name}",
    emptyCustom: "Nobody is listed: only the project managers can reach this folder.",
    addLabel: "Add a person from the office",
    addPlaceholder: "Choose a person",
    addButton: "Add",
    addAll: "Add all members of the office",
    noneToAdd: "Everyone in the office is already listed.",
    membersFailed: "The list of people in the office is not available. You can still add all members of the office.",
    loadFailed: "The permissions of this folder could not be loaded.",
    save: "Save",
    saving: "Saving\u2026",
    done: "The permissions of the folder {name} have been saved."
  },
  errors: {
    nameTaken: "A folder with this name already exists here. Choose another name.",
    stale: "Someone else changed this folder. The information has just been reloaded: check it, then try again.",
    cycle: "A folder cannot be moved into one of its own subfolders.",
    tooDeep: "This folder tree would be too deep (16 levels at most).",
    forbidden: "You are not allowed to do this on this folder.",
    notFound: "This folder no longer exists or you no longer have access to it.",
    subjectNotAllowed: "A person in the list is not (or no longer) a member of the office. Remove them, then try again.",
    invalid: "Some information is not valid. Check it, then try again.",
    locked: "This document is in an approval workflow: wait for it to end or cancel it, then try again.",
    documentStale: "Someone else changed this document. The list was just reloaded: check it, then try again.",
    versionNotAvailable: "Only a checked, available version can be restored.",
    documentForbidden: "You are not allowed to do this on this document.",
    documentNotFound: "This document no longer exists or you no longer have access to it.",
    legalHold: "This folder contains a document that must be kept (legal obligation), so it cannot be deleted."
  },
  upload: {
    region: "Adding files",
    zone: {
      title: "Drag and drop files or folders here",
      dropNow: "Drop to add to this folder",
      hint: "or use the buttons below. Maximum size per file: {max}. The files of a dropped folder are added straight into the open folder.",
      addFiles: "Add files",
      addFolder: "Add a folder"
    },
    listLabel: "Files being added",
    progressLabel: "Sending {name}",
    scanningLabel: "Virus check of {name}",
    status: {
      sending: "Sending",
      scanning: "Virus check in progress",
      added: "Added to the folder",
      refused: "Refused",
      failed: "Sending failed"
    },
    withIssue: "{status}: {issue}",
    slow: "The check is taking longer than usual; the file will appear as soon as it is done.",
    cancel: "Cancel",
    dismiss: "Remove",
    cancelLabel: "Cancel sending {name}",
    dismissLabel: "Remove {name} from the list",
    retryLabel: "Retry sending {name}",
    elsewhere: "Uploads still running in other folders: {count}",
    issue: {
      empty: "This file is empty, so it was not added.",
      name: "The name of this file is not valid. Rename it, then add it again.",
      type: "This type of file ({extension}) is not accepted. Convert it to PDF or send it in a ZIP archive.",
      typeNoExtension: "This file has no recognised extension, so it cannot be accepted. Rename it with its extension or send it in a ZIP archive.",
      tooLarge: "This file is too large. The maximum size is {max}.",
      tooLargePlan: "This file is larger than your plan allows.",
      quota: "Your plan's storage is full. Free some space or ask the account owner to increase it.",
      forbidden: "You are not allowed to add files to this folder.",
      notFound: "This folder no longer exists or you no longer have access to it.",
      readOnly: "Your office account is read-only, so no file can be added.",
      expired: "The upload has expired. Add the file again.",
      incomplete: "The file did not arrive in full. Try again.",
      busy: "Too many requests at once. Wait a few seconds, then try again.",
      interrupted: "Sending was interrupted: the connection is lost or too unstable. Check it, then try again.",
      statusLost: "The result of the upload could not be checked. Reload the page to see whether the file was added.",
      unexpected: "An unexpected error occurred. Try again in a moment.",
      infected: "This file contains a virus: it was refused and deleted.",
      scan_limits: "This archive is too large or too deeply nested to be checked: split it into smaller archives.",
      type_mismatch: "The content of this file does not match its extension: it was refused.",
      html_content: "Web pages (HTML) are not accepted: the file was refused.",
      size_mismatch: "The file received does not have the announced size: it was refused. Add it again.",
      sha256_mismatch: "The file changed during the upload: it was refused. Add it again.",
      locked: "This document is in an approval workflow: it cannot receive a new version for now."
    }
  },
  docTypes: {
    drawing: "Drawing",
    calculation_note: "Calculation note",
    report: "Report",
    specification: "Specification",
    bill_of_quantities: "Bill of quantities",
    estimate: "Estimate",
    minutes: "Minutes",
    correspondence: "Correspondence",
    photo: "Photo",
    other: "Other"
  },
  status: {
    uploading: "Uploading",
    scanning: "Antivirus check",
    available: "Available",
    rejected: "Refused",
    lockedHint: "An approval is in progress: no new version until it ends."
  },
  list: {
    title: "Documents",
    region: "Documents of the folder",
    caption: "Documents of the open folder",
    columns: {
      code: "Code",
      title: "Title",
      index: "Index",
      discipline: "Discipline",
      phase: "Phase",
      status: "Status",
      approval: "Approval",
      modified: "Modified",
      author: "Author organisation"
    },
    none: "\u2014",
    partner: "Partner",
    codeMissing: "Information missing: the code is not assigned yet",
    selectAll: "Select all displayed documents",
    selectRow: "Select {name}",
    loadFailed: "The documents of this folder could not be loaded.",
    moreFailed: "The rest of the list could not be loaded. Try again.",
    shown: "{count, plural, one {# document shown} other {# documents shown}}",
    loadMore: "Show more documents",
    loadingMore: "Loading\u2026",
    noMatch: {
      title: "No document matches",
      description: "Try another word or remove a filter."
    }
  },
  filters: {
    label: "Filter documents",
    search: "Search documents",
    searchPlaceholder: "Code or title",
    chosen: "{filter}: {value}",
    all: "All",
    clear: "Clear filters"
  },
  selection: {
    label: "Actions on the selection",
    count: "{count, plural, one {# document selected} other {# documents selected}}",
    move: "Move to\u2026",
    delete: "Delete",
    clear: "Clear selection"
  },
  moveDocuments: {
    title: "{count, plural, one {Move the document} other {Move # documents}}",
    intro: "Open the destination folder, then confirm with \u201CMove here\u201D.",
    pickFolder: "Open a folder: documents cannot stay at the root of the project.",
    alreadyHere: "The documents are already in this folder.",
    noWrite: "You cannot add documents to this folder.",
    done: "{count, plural, one {The document was moved} other {# documents were moved}} to {folder}.",
    partial: "{moved, plural, one {# document was moved} other {# documents were moved}}, {failed, plural, one {# other could not be} other {# others could not be}}. {reason}"
  },
  metadata: {
    discipline: "Discipline",
    phase: "Phase",
    docType: "Document type",
    zone: "Zone",
    scale: "Scale",
    title: "Title",
    notSet: "Not set",
    optional: "Optional",
    phaseOption: "{code} \u2014 {name}",
    fields: {
      discipline: "the discipline",
      phaseType: "the phase",
      docType: "the document type",
      zone: "the zone"
    }
  },
  metadataDialog: {
    title: "{count, plural, one {Document information} other {Information for # documents}}",
    intro: "{count, plural, one {This information files the document and builds its code. You can change it later.} other {This information applies to every document of this upload. You can change it later, document by document.}}",
    titlesLabel: "Title of each document",
    titleOf: "Title of {name}",
    titlesFromNames: "Titles are taken from the file names; you can change them afterwards.",
    skip: "Add without information",
    add: "{count, plural, one {Add the document} other {Add # documents}}"
  },
  codePreview: {
    label: "Planned code",
    number: "### is replaced by the sequence number, assigned when the file is added.",
    missing: "The code will be assigned once {fields} are set."
  },
  panel: {
    title: "Document",
    details: "Details",
    detailsRegion: "Document details",
    open: "Open",
    edit: "Edit",
    locked: "This document is in an approval workflow: it cannot receive a new version until the workflow ends or is cancelled.",
    missingMetadata: "The code will be assigned once {fields} are set.",
    deliverables: "Linked deliverables",
    noDeliverables: "No linked deliverable",
    notFoundTitle: "This document no longer exists",
    notFoundBody: "It may have been deleted, or moved to a folder you do not have access to.",
    loadFailedTitle: "The document cannot be shown",
    loadFailedBody: "The document could not be loaded. Try again; if the problem continues, contact support.",
    close: "Close"
  },
  edit: {
    formLabel: "Edit the document",
    titleRequired: "Enter a title.",
    noChange: "Nothing to save.",
    saved: "The document was updated.",
    saving: "Saving\u2026"
  },
  versions: {
    region: "Version history",
    title: "Versions",
    listLabel: "Versions of the document, newest first",
    newVersion: "New version",
    none: "No version yet.",
    loadFailed: "The version history could not be loaded.",
    index: "Index {index}",
    current: "Current version",
    reasonLabel: "Reason:",
    restoredFrom: "Restored from index {index}",
    restoredFromOlder: "Restored from an earlier version",
    by: "By {author} ({organization}),",
    unknownAuthor: "unknown author",
    code: "Code:",
    hash: "SHA-256:",
    copyHash: "Copy the full SHA-256 fingerprint: {hash}",
    hashCopied: "The SHA-256 fingerprint was copied.",
    hashCopyFailed: "Copying failed. Select the fingerprint and copy it by hand.",
    restore: "Restore",
    restoreLabel: "Restore the version with index {index}",
    compareSelect: "Pick revision {index} for the comparison",
    compareAction: "Compare the two revisions",
    compareHintNone: "Tick two revisions to compare.",
    compareHintOne: "Tick a second revision.",
    compareHintReady: "Two revisions picked."
  },
  reason: {
    label: "Reason",
    hint: "Required: 3 to {max} characters.",
    required: "Give a reason of at least 3 characters."
  },
  restore: {
    title: "Restore index {index}",
    intro: "The chosen version is added as a new version with the next index. The history is kept: nothing is erased.",
    confirm: "Restore",
    restoring: "Restoring\u2026",
    done: "Index {index} was restored: it is now index {newIndex}."
  },
  newVersion: {
    title: "New version",
    intro: "Add a file as a new version of {title}. It gets the next index.",
    file: "File",
    fileRequired: "Choose a file.",
    confirm: "Add the version",
    started: "Uploading {name} has started: follow it under the upload zone."
  },
  approvals: {
    status: {
      in_progress: "In approval",
      approved: "Approved (VSO)",
      approved_with_comments: "Approved with comments (VAO)",
      rejected: "Refused (REF)",
      cancelled: "Cancelled"
    },
    decisions: {
      vso: {
        chip: "VSO \u2014 Approved",
        short: "VSO",
        hint: "You approve the document as it is."
      },
      vao: {
        chip: "VAO \u2014 Approved with comments",
        short: "VAO",
        hint: "You approve the document provided your comments are taken into account. A comment is required."
      },
      ref: {
        chip: "REF \u2014 Refused",
        short: "REF",
        hint: "You refuse this version: the workflow stops and the document must be corrected. A comment is required."
      }
    },
    stepper: {
      label: "Steps of the approval workflow",
      step: "Step {n}",
      mode: {
        sequential: "In order",
        parallel: "In parallel"
      },
      current: "Current step",
      stepStatus: {
        waiting: "Upcoming",
        cancelled: "Cancelled"
      },
      due: "Due:",
      reviewers: "Reviewers of step {n}",
      unknownReviewer: "Unknown reviewer",
      unknownOffice: "Unknown office",
      you: "(you)",
      turn: "Their turn to decide",
      waiting: "Waiting for their opinion",
      later: "Not asked yet"
    },
    steps: {
      step: "Step {n}",
      moveStepUp: "Move step {n} up",
      moveStepDown: "Move step {n} down",
      removeStep: "Remove step {n}",
      mode: "Mode of step {n}",
      sequential: "In order",
      parallel: "In parallel",
      sequentialHint: "Each reviewer gives their opinion in turn, in the order of the list.",
      parallelHint: "All reviewers can answer at the same time, in any order.",
      reviewersOf: "Reviewers of step {n}",
      moveReviewerUp: "Move {name} up in step {n}",
      moveReviewerDown: "Move {name} down in step {n}",
      removeReviewer: "Remove {name} from step {n}",
      noReviewers: "No reviewer: add at least one person.",
      addReviewerLabel: "Add a reviewer to step {n}",
      addPlaceholder: "Choose a person",
      addReviewer: "Add",
      addReviewerTo: "Add the chosen reviewer to step {n}",
      membersFailed: "The list of people in the office is not available right now.",
      noneToAdd: "Everyone in the office is already in this step.",
      officesOf: "Partner offices of step {n}",
      addOfficeLabel: "Add a partner office to step {n}",
      addOfficePlaceholder: "Choose a partner office",
      addOffice: "Add the office",
      addOfficeTo: "Add the chosen office to step {n}",
      removeOffice: "Remove the office {name} from step {n}",
      officeHint: "This office's approvers in the shared space will be asked.",
      addStep: "Add a step",
      noReviewerProblem: "Every step needs at least one reviewer."
    },
    summary: {
      sequential: "Step {n}: {names}, in this order",
      parallel: "Step {n}: {names}, in any order",
      officeApprovers: "{office}'s approvers in the space"
    },
    request: {
      title: 'Request approval of "{title}"',
      intro: "The current version of the document is sent to the reviewers. While the workflow runs, the document is locked: no new version is possible until it ends or is cancelled.",
      sourceLabel: "Approval workflow",
      fromTemplate: "Use a template of the office",
      fromScratch: "Build the steps myself",
      templatesFailed: "The office's templates could not be loaded: build the steps yourself.",
      templateLabel: "Template",
      templateRequired: "Choose a template.",
      templatePlaceholder: "Choose a template",
      dueLabel: "Due date (optional)",
      dueHint: "The date each step is expected by: reviewers receive reminders.",
      summaryTitle: "Who decides, and in which order",
      summaryRules: "A step opens only once the previous one has ended. The strictest opinion wins: a single refusal (REF) stops the workflow.",
      send: "Send the request",
      sending: "Sending\u2026",
      done: 'The approval request for "{title}" has been sent.'
    },
    decide: {
      title: 'Your opinion on "{document}"',
      index: "Index",
      intro: "Your opinion is final: you will not be able to change it once sent.",
      choiceLabel: "Your opinion",
      choiceRequired: "Choose your opinion: VSO, VAO or REF.",
      commentLabel: "Comment",
      commentHint: "Optional for a VSO.",
      commentRequiredHint: "Required for a VAO or a REF, unless you attach an annotation.",
      commentRequired: "Write a comment or attach one of your annotations.",
      annotationsLegend: "Attach my annotations",
      annotationsHint: "The annotations you tick are linked to your opinion.",
      annotationLine: "Page {page}: {comment}",
      send: "Send my opinion",
      sending: "Sending\u2026",
      done: "Your opinion ({decision}) has been recorded."
    },
    decideFlow: {
      title: "Your opinion on an approval",
      loadFailed: "The approval workflow could not be loaded. Try again; if the problem continues, contact support.",
      nothingToDecide: "You have no opinion left to give on this workflow: it has ended, you have already answered, or it is not your turn yet."
    },
    cancel: {
      title: 'Cancel the approval workflow of "{document}"?',
      body: "Reviewers will no longer be able to give their opinion and the document will accept a new version again. Opinions already given stay in the history.",
      confirm: "Cancel the workflow",
      keep: "Keep the workflow",
      done: 'The approval workflow of "{document}" has been cancelled.'
    },
    flow: {
      decide: "Give my opinion",
      decideFor: "Give my opinion on {document}",
      cancel: "Cancel the workflow",
      cancelFor: "Cancel the approval workflow of {document}",
      index: "Index",
      startedBy: "Requested by {name} on",
      started: "Requested on",
      completed: "Ended on",
      due: "Due:"
    },
    section: {
      loadFailed: "The approval workflows of this document could not be loaded.",
      none: "No approval has been requested for this document.",
      past: "Previous workflows",
      region: "Document approval",
      title: "Approval",
      request: "Request approval"
    },
    errors: {
      locked: "This document is already in an approval workflow: wait for it to end or cancel it.",
      notYourTurn: "It is not your turn yet: a reviewer before you must give their opinion first.",
      closed: "This workflow has ended or this step no longer waits for opinions. The list has just been reloaded.",
      observationRequired: "Add a comment (or an annotation) for a VAO or a REF.",
      reviewerCannotView: "A reviewer cannot open this document. Give them access to the document first, or choose someone else.",
      versionNotAvailable: "Only a checked, available version can be sent for approval: wait for the antivirus check to finish.",
      stepsInvalid: "The steps are not valid: each step needs at least one reviewer, and nobody can appear twice in a step.",
      officeUnknown: "Only partner offices of your shared spaces can be asked.",
      officeNoReviewer: "A partner office has no approver in this space. Ask it to delegate someone with the right to approve, or choose someone else.",
      invalid: "Some information is not valid. Check it and try again.",
      forbidden: "You are not allowed to do this: you are not a reviewer of this step, or you did not request this approval.",
      notFound: "This workflow no longer exists or you no longer have access to it."
    },
    tab: {
      noSpace: {
        title: "Approval workflows are not available yet",
        description: "They will appear as soon as the project's file space is ready."
      },
      columns: {
        document: "Document",
        index: "Index",
        status: "Status",
        step: "Current step",
        initiator: "Requested by",
        dates: "Dates",
        actions: "Actions"
      },
      stepOf: "Step {current} of {total}",
      started: "Requested on",
      completed: "Ended on",
      due: "Due:",
      details: "View the workflow",
      detailsFor: "View the approval workflow of {document}",
      detailsTitle: 'Approval workflow of "{document}"',
      filtersLabel: "Filter approval workflows",
      filter: {
        all: "All",
        in_progress: "In approval",
        approved: "Approved",
        approved_with_comments: "Approved with comments",
        rejected: "Refused",
        cancelled: "Cancelled",
        toDecide: "To decide by me"
      },
      loadFailedTitle: "Unable to show the approval workflows",
      loadFailedBody: "The list could not be loaded. Try again; if the problem continues, contact support.",
      caption: "The project's approval workflows",
      empty: {
        none: {
          title: "No approval workflows",
          description: "Open a document in the Files tab and request its approval: the workflow will appear here."
        },
        filtered: {
          title: "No workflow matches",
          description: "Choose another status to see the other workflows."
        },
        toDecide: {
          title: "Nothing to decide for now",
          description: "Workflows waiting for your opinion will appear here."
        }
      }
    },
    templates: {
      title: "Approval workflow templates",
      description: "Ready-made workflows your team can pick when requesting an approval.",
      new: "New template",
      newTitle: "New workflow template",
      nameLabel: "Template name",
      nameRequired: "Give the template a name.",
      create: "Create the template",
      creating: "Creating\u2026",
      created: 'The template "{name}" has been created.',
      loadFailed: "The templates could not be loaded.",
      empty: "No template yet. Teams then build the steps for each request.",
      listLabel: "Approval workflow templates",
      deleteFor: "Delete the template {name}",
      deleteTitle: 'Delete the template "{name}"?',
      deleteBody: "Workflows already started do not change.",
      delete: "Delete",
      deleted: 'The template "{name}" has been deleted.',
      readOnly: "Creating or deleting a template is reserved for people who can edit the organisation."
    }
  },
  trash: {
    open: "Trash",
    title: "Trash",
    back: "Back to files",
    intro: "Deleted folders and documents stay in the trash for {days} days, then are removed for good. Managers see everything; everyone else sees what they deleted.",
    listLabel: "Deleted items",
    deletedBy: "Deleted by {who} on {date}.",
    deletedOn: "Deleted on {date}.",
    contains: "{count, plural, =0 {Empty folder.} one {Contains # item.} other {Contains # items.}}",
    purgeAfter: "Removed for good on {date}.",
    restore: "Restore",
    restoreFor: "Restore {name}",
    restored: "\u201C{name}\u201D was restored.",
    purgeFor: "Delete {name} for good",
    purge: {
      action: "Delete for good",
      title: "Delete \u201C{name}\u201D for good?",
      bodyFolder: "{count, plural, =0 {This empty folder will be erased.} one {This folder and its item will be erased with their files.} other {This folder and its # items will be erased with their files.}} This cannot be undone.",
      bodyDocument: "The document, all its versions and its files will be erased. This cannot be undone.",
      confirm: "Delete for good",
      started: "\u201C{name}\u201D is being removed for good."
    },
    empty: {
      title: "The trash is empty",
      description: "Folders and documents you delete land here and stay {days} days before they are erased."
    },
    loadFailed: "The trash could not be loaded.",
    errors: {
      parentInTrash: "The folder that held this item is in the trash too. Restore that folder first.",
      nameTaken: "A folder with this name already exists there. Rename or move the other folder, then try again.",
      legalHold: "This item holds a document that must be kept (legal obligation); it cannot be erased until that obligation ends.",
      forbidden: "You are not allowed to do this on this item.",
      notFound: "This item is no longer in the trash. The list has been refreshed."
    }
  },
  filesApp: {
    tabsLabel: "File views",
    tabs: {
      recent: "Recent",
      organisation: "Organisation",
      shared: "Shared with me",
      search: "Search"
    },
    recent: {
      listLabel: "Recently changed files",
      updated: "Changed {when}",
      inFolder: "Folder {folder}",
      loadFailedTitle: "Recent files could not be shown",
      loadFailedBody: "Check your connection, then try again.",
      emptyTitle: "No recent files",
      emptyBody: "Files added or changed in your projects and spaces will show here."
    },
    organisation: {
      loadFailedTitle: "The organisation's documents could not be opened",
      loadFailedBody: "Check your connection, then try again.",
      noSpaceTitle: "No document space yet",
      noSpaceBody: "The organisation's document space is not available right now."
    },
    shared: {
      listLabel: "Other organisations' spaces",
      loadFailedTitle: "Shared spaces could not be shown",
      loadFailedBody: "Check your connection, then try again.",
      emptyTitle: "Nothing is shared with you",
      emptyBody: "When another organisation invites you to one of its spaces, its documents will be here."
    },
    search: {
      inputLabel: "Search for a file",
      placeholder: "Document title or code\u2026"
    }
  }
};

// locales/fr/documents.json
var documents_default3 = {
  noSpace: {
    title: "L'espace de fichiers n'est pas encore pr\xEAt",
    description: "Les dossiers de ce projet seront disponibles d\xE8s que son espace interne aura \xE9t\xE9 cr\xE9\xE9. R\xE9essayez dans un instant ou contactez un responsable du projet."
  },
  tree: {
    label: "Dossiers du projet",
    all: "Tous les dossiers",
    loading: "Chargement des dossiers\u2026",
    loadFailed: "Impossible de charger les dossiers.",
    childrenFailed: "Sous-dossiers indisponibles"
  },
  breadcrumb: {
    label: "Chemin du dossier",
    root: "Tous les dossiers",
    hidden: "Dossier non accessible"
  },
  content: {
    foldersLabel: "Sous-dossiers",
    loadFailed: "Impossible de charger ce dossier.",
    customRights: "Droits personnalis\xE9s",
    noFolders: {
      title: "Aucun sous-dossier",
      description: "Ce dossier ne contient pas encore de sous-dossier."
    },
    rootEmpty: {
      title: "Aucun dossier pour l'instant",
      descriptionManage: "Cr\xE9ez le premier dossier du projet pour y classer les documents.",
      descriptionRead: "Vous ne voyez aucun dossier pour l'instant. Un responsable du projet peut en cr\xE9er ou vous y donner acc\xE8s."
    },
    noDocuments: {
      title: "Aucun document pour l'instant",
      description: "D\xE9posez des fichiers ici ou utilisez \xAB\xA0Ajouter des fichiers\xA0\xBB.",
      descriptionRead: "Les documents de ce dossier appara\xEEtront ici."
    }
  },
  actions: {
    newFolder: "Nouveau dossier",
    more: "Autres actions",
    moreFor: "Autres actions sur le dossier {name}",
    rename: "Renommer\u2026",
    move: "D\xE9placer\u2026",
    permissions: "Autorisations\u2026",
    delete: "Supprimer"
  },
  name: {
    required: "Saisissez un nom de dossier.",
    tooLong: "Le nom ne peut pas d\xE9passer 200 caract\xE8res.",
    invalid: "Le nom ne peut contenir ni barre oblique ni caract\xE8re de contr\xF4le, et ne peut pas \xEAtre \xAB\xA0.\xA0\xBB ou \xAB\xA0..\xA0\xBB."
  },
  create: {
    title: "Nouveau dossier",
    inFolder: "Dans\xA0: {name}",
    inRoot: "\xC0 la racine du projet",
    nameLabel: "Nom du dossier",
    submit: "Cr\xE9er",
    saving: "Cr\xE9ation\u2026",
    done: "Le dossier {name} a \xE9t\xE9 cr\xE9\xE9."
  },
  rename: {
    title: "Renommer le dossier",
    nameLabel: "Nouveau nom",
    submit: "Renommer",
    saving: "Enregistrement\u2026",
    done: "Le dossier a \xE9t\xE9 renomm\xE9 en {name}."
  },
  move: {
    title: "D\xE9placer le dossier {name}",
    intro: "Ouvrez le dossier de destination, puis validez avec \xAB\xA0D\xE9placer ici\xA0\xBB.",
    location: "Emplacement\xA0: {name}",
    root: "Racine du projet",
    up: "Remonter d'un niveau",
    listLabel: "Dossiers de destination",
    open: "Ouvrir le dossier {name}",
    noSubfolders: "Aucun sous-dossier \xE0 cet emplacement.",
    here: "D\xE9placer ici",
    moving: "D\xE9placement\u2026",
    alreadyHere: "Le dossier se trouve d\xE9j\xE0 \xE0 cet emplacement.",
    rootNeedsManager: "Seuls les responsables du projet peuvent placer un dossier \xE0 la racine.",
    noWrite: "Vous ne pouvez pas ajouter de dossier \xE0 cet emplacement.",
    done: "Le dossier {name} a \xE9t\xE9 d\xE9plac\xE9."
  },
  delete: {
    title: "Supprimer le dossier {name}\xA0?",
    body: "Le dossier et tous ses sous-dossiers seront plac\xE9s dans la corbeille.",
    confirm: "Supprimer",
    done: "Le dossier {name} a \xE9t\xE9 plac\xE9 dans la corbeille.",
    documentName: "{title} (indice {index})",
    documentTitle: "Supprimer le document {name}\xA0?",
    documentsTitle: "Supprimer {count} documents\xA0?",
    documentsBody: "{count, plural, one {Le document sera plac\xE9 dans la corbeille.} other {Les documents seront plac\xE9s dans la corbeille.}}",
    andOthers: "{count, plural, one {et # autre document} other {et # autres documents}}",
    documentsDone: "{count, plural, one {Le document a \xE9t\xE9 plac\xE9 dans la corbeille.} other {# documents ont \xE9t\xE9 plac\xE9s dans la corbeille.}}",
    documentsPartial: "{deleted, plural, one {# document a \xE9t\xE9 supprim\xE9} other {# documents ont \xE9t\xE9 supprim\xE9s}}, {failed, plural, one {# autre n'a pas pu l'\xEAtre} other {# autres n'ont pas pu l'\xEAtre}}. {reason}"
  },
  permissions: {
    title: "Autorisations du dossier {name}",
    inheritParent: "H\xE9riter des droits du dossier parent",
    inheritSpace: "H\xE9riter des droits du projet",
    inheritParentHint: "Les personnes qui ont acc\xE8s au dossier parent ont acc\xE8s \xE0 celui-ci.",
    inheritSpaceHint: "Les personnes qui ont acc\xE8s au projet ont acc\xE8s \xE0 ce dossier.",
    customHint: "Seules les personnes list\xE9es ci-dessous et les responsables du projet acc\xE8dent \xE0 ce dossier et \xE0 ses sous-dossiers.",
    listLabel: "Personnes ayant acc\xE8s",
    everyone: "Tous les membres du bureau",
    relationOf: "Droit de {name}",
    relations: {
      reader: "Lecteur",
      writer: "\xC9diteur"
    },
    remove: "Retirer {name}",
    emptyCustom: "Personne n'est list\xE9\xA0: seuls les responsables du projet acc\xE8dent \xE0 ce dossier.",
    addLabel: "Ajouter une personne du bureau",
    addPlaceholder: "Choisir une personne",
    addButton: "Ajouter",
    addAll: "Ajouter tous les membres du bureau",
    noneToAdd: "Toutes les personnes du bureau sont d\xE9j\xE0 list\xE9es.",
    membersFailed: "La liste des personnes du bureau n'est pas disponible. Vous pouvez tout de m\xEAme ajouter tous les membres du bureau.",
    loadFailed: "Impossible de charger les autorisations de ce dossier.",
    save: "Enregistrer",
    saving: "Enregistrement\u2026",
    done: "Les autorisations du dossier {name} ont \xE9t\xE9 enregistr\xE9es."
  },
  errors: {
    nameTaken: "Un dossier porte d\xE9j\xE0 ce nom \xE0 cet endroit. Choisissez un autre nom.",
    stale: "Ce dossier a \xE9t\xE9 modifi\xE9 par quelqu'un d'autre. Les informations viennent d'\xEAtre recharg\xE9es\xA0: v\xE9rifiez-les puis recommencez.",
    cycle: "Un dossier ne peut pas \xEAtre d\xE9plac\xE9 dans l'un de ses propres sous-dossiers.",
    tooDeep: "Cette arborescence serait trop profonde (16 niveaux au maximum).",
    forbidden: "Vous n'avez pas le droit d'effectuer cette action sur ce dossier.",
    notFound: "Ce dossier n'existe plus ou vous n'y avez plus acc\xE8s.",
    subjectNotAllowed: "Une personne de la liste ne fait pas (ou plus) partie du bureau. Retirez-la puis r\xE9essayez.",
    invalid: "Certaines informations ne sont pas valides. V\xE9rifiez-les puis r\xE9essayez.",
    locked: "Ce document est en cours d'approbation\xA0: attendez la fin du circuit ou annulez-le, puis r\xE9essayez.",
    documentStale: "Ce document a \xE9t\xE9 modifi\xE9 par quelqu'un d'autre. La liste vient d'\xEAtre recharg\xE9e\xA0: v\xE9rifiez-la puis recommencez.",
    versionNotAvailable: "Seule une version v\xE9rifi\xE9e et disponible peut \xEAtre restaur\xE9e.",
    documentForbidden: "Vous n'avez pas le droit d'effectuer cette action sur ce document.",
    documentNotFound: "Ce document n'existe plus ou vous n'y avez plus acc\xE8s.",
    legalHold: "Ce dossier contient un document qui doit \xEAtre conserv\xE9 (obligation l\xE9gale)\xA0: il ne peut pas \xEAtre supprim\xE9."
  },
  upload: {
    region: "Ajout de fichiers",
    zone: {
      title: "Glissez-d\xE9posez des fichiers ou des dossiers ici",
      dropNow: "D\xE9posez pour ajouter \xE0 ce dossier",
      hint: "ou utilisez les boutons ci-dessous. Taille maximale par fichier\xA0: {max}. Les fichiers d'un dossier d\xE9pos\xE9 sont ajout\xE9s directement dans le dossier ouvert.",
      addFiles: "Ajouter des fichiers",
      addFolder: "Ajouter un dossier"
    },
    listLabel: "Fichiers en cours d'ajout",
    progressLabel: "Envoi de {name}",
    scanningLabel: "V\xE9rification antivirus de {name}",
    status: {
      sending: "Envoi en cours",
      scanning: "V\xE9rification antivirus en cours",
      added: "Ajout\xE9 au dossier",
      refused: "Refus\xE9",
      failed: "\xC9chec de l'envoi"
    },
    withIssue: "{status}\xA0: {issue}",
    slow: "La v\xE9rification prend plus de temps que d'habitude\xA0; le fichier appara\xEEtra d\xE8s qu'elle sera termin\xE9e.",
    cancel: "Annuler",
    dismiss: "Retirer",
    cancelLabel: "Annuler l'envoi de {name}",
    dismissLabel: "Retirer {name} de la liste",
    retryLabel: "R\xE9essayer l'envoi de {name}",
    elsewhere: "Envois encore en cours dans d'autres dossiers\xA0: {count}",
    issue: {
      empty: "Ce fichier est vide\xA0: il n'a pas \xE9t\xE9 ajout\xE9.",
      name: "Le nom de ce fichier n'est pas valide. Renommez-le puis ajoutez-le de nouveau.",
      type: "Ce type de fichier ({extension}) n'est pas accept\xE9. Convertissez-le en PDF ou envoyez-le dans une archive ZIP.",
      typeNoExtension: "Ce fichier n'a pas d'extension reconnue\xA0: il ne peut pas \xEAtre accept\xE9. Renommez-le avec son extension ou envoyez-le dans une archive ZIP.",
      tooLarge: "Ce fichier est trop volumineux. La taille maximale est de {max}.",
      tooLargePlan: "Ce fichier d\xE9passe la taille maximale autoris\xE9e par votre offre.",
      quota: "L'espace de stockage de votre offre est plein. Lib\xE9rez de l'espace ou demandez au propri\xE9taire du compte de l'augmenter.",
      forbidden: "Vous n'avez pas le droit d'ajouter des fichiers dans ce dossier.",
      notFound: "Ce dossier n'existe plus ou vous n'y avez plus acc\xE8s.",
      readOnly: "Le compte de votre bureau est en lecture seule\xA0: aucun fichier ne peut \xEAtre ajout\xE9.",
      expired: "L'envoi a expir\xE9. Ajoutez le fichier de nouveau.",
      incomplete: "Le fichier n'est pas arriv\xE9 en entier. R\xE9essayez.",
      busy: "Trop de demandes \xE0 la fois. Patientez quelques secondes puis r\xE9essayez.",
      interrupted: "L'envoi a \xE9t\xE9 interrompu\xA0: la connexion est perdue ou trop instable. V\xE9rifiez-la puis r\xE9essayez.",
      statusLost: "Le r\xE9sultat de l'envoi n'a pas pu \xEAtre v\xE9rifi\xE9. Rechargez la page pour voir si le fichier a \xE9t\xE9 ajout\xE9.",
      unexpected: "Une erreur inattendue s'est produite. R\xE9essayez dans un instant.",
      infected: "Ce fichier contient un virus\xA0: il a \xE9t\xE9 refus\xE9 et supprim\xE9.",
      scan_limits: "Cette archive est trop grande ou trop profonde pour \xEAtre v\xE9rifi\xE9e\xA0: fractionnez-la en plusieurs archives plus petites.",
      type_mismatch: "Le contenu de ce fichier ne correspond pas \xE0 son extension\xA0: il a \xE9t\xE9 refus\xE9.",
      html_content: "Les pages web (HTML) ne sont pas accept\xE9es\xA0: le fichier a \xE9t\xE9 refus\xE9.",
      size_mismatch: "Le fichier re\xE7u n'a pas la taille annonc\xE9e\xA0: il a \xE9t\xE9 refus\xE9. Ajoutez-le de nouveau.",
      sha256_mismatch: "Le fichier a \xE9t\xE9 alt\xE9r\xE9 pendant l'envoi\xA0: il a \xE9t\xE9 refus\xE9. Ajoutez-le de nouveau.",
      locked: "Ce document est en cours d'approbation\xA0: il ne peut pas recevoir de nouvelle version pour l'instant."
    }
  },
  docTypes: {
    drawing: "Plan",
    calculation_note: "Note de calcul",
    report: "Rapport",
    specification: "Cahier des charges",
    bill_of_quantities: "Bordereau des quantit\xE9s",
    estimate: "Estimation",
    minutes: "Proc\xE8s-verbal",
    correspondence: "Courrier",
    photo: "Photo",
    other: "Autre"
  },
  status: {
    uploading: "Envoi en cours",
    scanning: "V\xE9rification antivirus",
    available: "Disponible",
    rejected: "Refus\xE9",
    lockedHint: "Un circuit d'approbation est en cours\xA0: pas de nouvelle version tant qu'il n'est pas termin\xE9."
  },
  list: {
    title: "Documents",
    region: "Documents du dossier",
    caption: "Documents du dossier ouvert",
    columns: {
      code: "Code",
      title: "Titre",
      index: "Indice",
      discipline: "Discipline",
      phase: "Phase",
      status: "Statut",
      approval: "Visa",
      modified: "Modifi\xE9 le",
      author: "Organisation auteur"
    },
    none: "\u2014",
    partner: "Partenaire",
    codeMissing: "Informations manquantes\xA0: le code n'est pas encore attribu\xE9",
    selectAll: "S\xE9lectionner tous les documents affich\xE9s",
    selectRow: "S\xE9lectionner {name}",
    loadFailed: "Impossible de charger les documents de ce dossier.",
    moreFailed: "Impossible de charger la suite de la liste. R\xE9essayez.",
    shown: "{count, plural, one {# document affich\xE9} other {# documents affich\xE9s}}",
    loadMore: "Afficher plus de documents",
    loadingMore: "Chargement\u2026",
    noMatch: {
      title: "Aucun document ne correspond",
      description: "Essayez un autre mot ou retirez un filtre."
    }
  },
  filters: {
    label: "Filtrer les documents",
    search: "Rechercher un document",
    searchPlaceholder: "Code ou titre",
    chosen: "{filter}\xA0: {value}",
    all: "Tous",
    clear: "Effacer les filtres"
  },
  selection: {
    label: "Actions sur la s\xE9lection",
    count: "{count, plural, one {# document s\xE9lectionn\xE9} other {# documents s\xE9lectionn\xE9s}}",
    move: "D\xE9placer vers\u2026",
    delete: "Supprimer",
    clear: "Tout d\xE9s\xE9lectionner"
  },
  moveDocuments: {
    title: "{count, plural, one {D\xE9placer le document} other {D\xE9placer # documents}}",
    intro: "Ouvrez le dossier de destination, puis validez avec \xAB\xA0D\xE9placer ici\xA0\xBB.",
    pickFolder: "Ouvrez un dossier\xA0: les documents ne peuvent pas rester \xE0 la racine du projet.",
    alreadyHere: "Les documents se trouvent d\xE9j\xE0 dans ce dossier.",
    noWrite: "Vous ne pouvez pas ajouter de document dans ce dossier.",
    done: "{count, plural, one {Le document a \xE9t\xE9 d\xE9plac\xE9} other {# documents ont \xE9t\xE9 d\xE9plac\xE9s}} vers {folder}.",
    partial: "{moved, plural, one {# document a \xE9t\xE9 d\xE9plac\xE9} other {# documents ont \xE9t\xE9 d\xE9plac\xE9s}}, {failed, plural, one {# autre n'a pas pu l'\xEAtre} other {# autres n'ont pas pu l'\xEAtre}}. {reason}"
  },
  metadata: {
    discipline: "Discipline",
    phase: "Phase",
    docType: "Type de document",
    zone: "Zone",
    scale: "\xC9chelle",
    title: "Titre",
    notSet: "Non renseign\xE9",
    optional: "Facultatif",
    phaseOption: "{code} \u2014 {name}",
    fields: {
      discipline: "la discipline",
      phaseType: "la phase",
      docType: "le type de document",
      zone: "la zone"
    }
  },
  metadataDialog: {
    title: "{count, plural, one {Informations du document} other {Informations des # documents}}",
    intro: "{count, plural, one {Ces informations servent \xE0 classer le document et \xE0 composer son code. Vous pourrez les modifier plus tard.} other {Ces informations s'appliquent \xE0 tous les documents de cet ajout. Vous pourrez les modifier plus tard, document par document.}}",
    titlesLabel: "Titre de chaque document",
    titleOf: "Titre de {name}",
    titlesFromNames: "Les titres reprennent les noms des fichiers\xA0; vous pourrez les modifier ensuite.",
    skip: "Ajouter sans informations",
    add: "{count, plural, one {Ajouter le document} other {Ajouter # documents}}"
  },
  codePreview: {
    label: "Code pr\xE9vu",
    number: "### sera remplac\xE9 par le num\xE9ro d'ordre, attribu\xE9 \xE0 l'ajout du fichier.",
    missing: "Le code sera attribu\xE9 d\xE8s que {fields} seront renseign\xE9s."
  },
  panel: {
    title: "Document",
    details: "D\xE9tails",
    detailsRegion: "D\xE9tails du document",
    open: "Ouvrir",
    edit: "Modifier",
    locked: "Ce document est en cours d'approbation\xA0: il ne peut pas recevoir de nouvelle version tant que le circuit n'est pas termin\xE9 ou annul\xE9.",
    missingMetadata: "Le code sera attribu\xE9 d\xE8s que {fields} seront renseign\xE9s.",
    deliverables: "Livrables li\xE9s",
    noDeliverables: "Aucun livrable li\xE9",
    notFoundTitle: "Ce document n'existe plus",
    notFoundBody: "Il a peut-\xEAtre \xE9t\xE9 supprim\xE9, ou d\xE9plac\xE9 dans un dossier auquel vous n'avez pas acc\xE8s.",
    loadFailedTitle: "Impossible d'afficher le document",
    loadFailedBody: "Le document n'a pas pu \xEAtre charg\xE9. R\xE9essayez\xA0; si le probl\xE8me continue, contactez le support.",
    close: "Fermer"
  },
  edit: {
    formLabel: "Modifier le document",
    titleRequired: "Saisissez un titre.",
    noChange: "Aucune modification \xE0 enregistrer.",
    saved: "Le document a \xE9t\xE9 mis \xE0 jour.",
    saving: "Enregistrement\u2026"
  },
  versions: {
    region: "Historique des versions",
    title: "Versions",
    listLabel: "Versions du document, de la plus r\xE9cente \xE0 la plus ancienne",
    newVersion: "Nouvelle version",
    none: "Aucune version pour l'instant.",
    loadFailed: "Impossible de charger l'historique des versions.",
    index: "Indice {index}",
    current: "Version actuelle",
    reasonLabel: "Raison\xA0:",
    restoredFrom: "Restaur\xE9e depuis l'indice {index}",
    restoredFromOlder: "Restaur\xE9e depuis une version pr\xE9c\xE9dente",
    by: "Par {author} ({organization}),",
    unknownAuthor: "auteur inconnu",
    code: "Code\xA0:",
    hash: "SHA-256\xA0:",
    copyHash: "Copier l'empreinte SHA-256 compl\xE8te\xA0: {hash}",
    hashCopied: "L'empreinte SHA-256 a \xE9t\xE9 copi\xE9e.",
    hashCopyFailed: "La copie a \xE9chou\xE9. S\xE9lectionnez l'empreinte et copiez-la \xE0 la main.",
    restore: "Restaurer",
    restoreLabel: "Restaurer la version d'indice {index}",
    compareSelect: "Choisir l'indice {index} pour la comparaison",
    compareAction: "Comparer les deux indices",
    compareHintNone: "Cochez deux indices \xE0 comparer.",
    compareHintOne: "Cochez un second indice.",
    compareHintReady: "Deux indices choisis."
  },
  reason: {
    label: "Raison",
    hint: "Obligatoire\xA0: 3 \xE0 {max} caract\xE8res.",
    required: "Indiquez la raison en 3 caract\xE8res au moins."
  },
  restore: {
    title: "Restaurer l'indice {index}",
    intro: "La version choisie sera ajout\xE9e comme nouvelle version, avec l'indice suivant. L'historique est conserv\xE9\xA0: rien n'est effac\xE9.",
    confirm: "Restaurer",
    restoring: "Restauration\u2026",
    done: "L'indice {index} a \xE9t\xE9 restaur\xE9\xA0: c'est maintenant l'indice {newIndex}."
  },
  newVersion: {
    title: "Nouvelle version",
    intro: "Ajoutez un fichier comme nouvelle version de {title}. L'indice suivant lui sera attribu\xE9.",
    file: "Fichier",
    fileRequired: "Choisissez un fichier.",
    confirm: "Ajouter la version",
    started: "L'envoi de {name} a commenc\xE9\xA0: suivez-le sous la zone d'ajout de fichiers."
  },
  approvals: {
    status: {
      in_progress: "En approbation",
      approved: "Approuv\xE9 (VSO)",
      approved_with_comments: "Approuv\xE9 avec observations (VAO)",
      rejected: "Refus\xE9 (REF)",
      cancelled: "Annul\xE9"
    },
    decisions: {
      vso: {
        chip: "VSO \u2014 Vis\xE9 sans observation",
        short: "VSO",
        hint: "Vous approuvez le document tel qu'il est."
      },
      vao: {
        chip: "VAO \u2014 Vis\xE9 avec observations",
        short: "VAO",
        hint: "Vous approuvez le document, \xE0 condition que vos observations soient prises en compte. Une observation est obligatoire."
      },
      ref: {
        chip: "REF \u2014 Refus\xE9",
        short: "REF",
        hint: "Vous refusez cette version\xA0: le circuit s'arr\xEAte et le document doit \xEAtre corrig\xE9. Une observation est obligatoire."
      }
    },
    stepper: {
      label: "\xC9tapes du circuit de visa",
      step: "\xC9tape {n}",
      mode: {
        sequential: "Dans l'ordre",
        parallel: "En parall\xE8le"
      },
      current: "\xC9tape en cours",
      stepStatus: {
        waiting: "\xC0 venir",
        cancelled: "Annul\xE9e"
      },
      due: "\xC9ch\xE9ance\xA0:",
      reviewers: "Relecteurs de l'\xE9tape {n}",
      unknownReviewer: "Relecteur inconnu",
      unknownOffice: "Bureau inconnu",
      you: "(vous)",
      turn: "\xC0 son tour de d\xE9cider",
      waiting: "En attente de son avis",
      later: "Pas encore sollicit\xE9"
    },
    steps: {
      step: "\xC9tape {n}",
      moveStepUp: "Monter l'\xE9tape {n}",
      moveStepDown: "Descendre l'\xE9tape {n}",
      removeStep: "Supprimer l'\xE9tape {n}",
      mode: "Mode de l'\xE9tape {n}",
      sequential: "Dans l'ordre",
      parallel: "En parall\xE8le",
      sequentialHint: "Chaque relecteur donne son avis \xE0 son tour, dans l'ordre de la liste.",
      parallelHint: "Tous les relecteurs peuvent r\xE9pondre en m\xEAme temps, dans n'importe quel ordre.",
      reviewersOf: "Relecteurs de l'\xE9tape {n}",
      moveReviewerUp: "Monter {name} dans l'\xE9tape {n}",
      moveReviewerDown: "Descendre {name} dans l'\xE9tape {n}",
      removeReviewer: "Retirer {name} de l'\xE9tape {n}",
      noReviewers: "Aucun relecteur\xA0: ajoutez au moins une personne.",
      addReviewerLabel: "Ajouter un relecteur \xE0 l'\xE9tape {n}",
      addPlaceholder: "Choisissez une personne",
      addReviewer: "Ajouter",
      addReviewerTo: "Ajouter le relecteur choisi \xE0 l'\xE9tape {n}",
      membersFailed: "La liste des personnes du bureau n'est pas disponible pour le moment.",
      noneToAdd: "Toutes les personnes du bureau sont d\xE9j\xE0 dans cette \xE9tape.",
      officesOf: "Bureaux partenaires de l'\xE9tape {n}",
      addOfficeLabel: "Ajouter un bureau partenaire \xE0 l'\xE9tape {n}",
      addOfficePlaceholder: "Choisissez un bureau partenaire",
      addOffice: "Ajouter le bureau",
      addOfficeTo: "Ajouter le bureau choisi \xE0 l'\xE9tape {n}",
      removeOffice: "Retirer le bureau {name} de l'\xE9tape {n}",
      officeHint: "Les approbateurs de ce bureau dans l'espace partag\xE9 seront sollicit\xE9s.",
      addStep: "Ajouter une \xE9tape",
      noReviewerProblem: "Chaque \xE9tape doit avoir au moins un relecteur."
    },
    summary: {
      sequential: "\xC9tape {n}\xA0: {names}, dans cet ordre",
      parallel: "\xC9tape {n}\xA0: {names}, dans n'importe quel ordre",
      officeApprovers: "approbateurs de {office} dans l'espace"
    },
    request: {
      title: "Demander le visa de \xAB\xA0{title}\xA0\xBB",
      intro: "La version actuelle du document est envoy\xE9e aux relecteurs. Pendant le circuit, le document est verrouill\xE9\xA0: aucune nouvelle version n'est possible tant qu'il n'est pas termin\xE9 ou annul\xE9.",
      sourceLabel: "Circuit de visa",
      fromTemplate: "Utiliser un mod\xE8le du bureau",
      fromScratch: "Composer les \xE9tapes moi-m\xEAme",
      templatesFailed: "Les mod\xE8les du bureau n'ont pas pu \xEAtre charg\xE9s\xA0: composez les \xE9tapes vous-m\xEAme.",
      templateLabel: "Mod\xE8le",
      templateRequired: "Choisissez un mod\xE8le.",
      templatePlaceholder: "Choisissez un mod\xE8le",
      dueLabel: "\xC9ch\xE9ance (facultative)",
      dueHint: "Date \xE0 laquelle chaque \xE9tape est attendue\xA0: les relecteurs re\xE7oivent des rappels.",
      summaryTitle: "Qui d\xE9cide, et dans quel ordre",
      summaryRules: "Une \xE9tape ne s'ouvre qu'une fois la pr\xE9c\xE9dente termin\xE9e. L'avis le plus s\xE9v\xE8re l'emporte\xA0: un seul refus (REF) arr\xEAte le circuit.",
      send: "Envoyer la demande",
      sending: "Envoi\u2026",
      done: "La demande de visa de \xAB\xA0{title}\xA0\xBB a \xE9t\xE9 envoy\xE9e."
    },
    decide: {
      title: "Votre avis sur \xAB\xA0{document}\xA0\xBB",
      index: "Indice",
      intro: "Votre avis est d\xE9finitif\xA0: vous ne pourrez plus le modifier une fois envoy\xE9.",
      choiceLabel: "Votre avis",
      choiceRequired: "Choisissez votre avis\xA0: VSO, VAO ou REF.",
      commentLabel: "Observation",
      commentHint: "Facultative pour un VSO.",
      commentRequiredHint: "Obligatoire pour un VAO ou un REF, sauf si vous joignez une annotation.",
      commentRequired: "\xC9crivez une observation ou joignez une de vos annotations.",
      annotationsLegend: "Joindre mes annotations",
      annotationsHint: "Les annotations coch\xE9es sont li\xE9es \xE0 votre avis.",
      annotationLine: "Page {page}\xA0: {comment}",
      send: "Envoyer mon avis",
      sending: "Envoi\u2026",
      done: "Votre avis ({decision}) a \xE9t\xE9 enregistr\xE9."
    },
    decideFlow: {
      title: "Votre avis sur un visa",
      loadFailed: "Le circuit de visa n'a pas pu \xEAtre charg\xE9. R\xE9essayez\xA0; si le probl\xE8me continue, contactez le support.",
      nothingToDecide: "Vous n'avez plus d'avis \xE0 donner sur ce circuit\xA0: il est termin\xE9, vous avez d\xE9j\xE0 r\xE9pondu ou ce n'est pas encore votre tour."
    },
    cancel: {
      title: "Annuler le circuit de visa de \xAB\xA0{document}\xA0\xBB\xA0?",
      body: "Les relecteurs ne pourront plus donner leur avis et le document pourra de nouveau recevoir une nouvelle version. Les avis d\xE9j\xE0 donn\xE9s restent dans l'historique.",
      confirm: "Annuler le circuit",
      keep: "Conserver le circuit",
      done: "Le circuit de visa de \xAB\xA0{document}\xA0\xBB est annul\xE9."
    },
    flow: {
      decide: "Donner mon avis",
      decideFor: "Donner mon avis sur {document}",
      cancel: "Annuler le circuit",
      cancelFor: "Annuler le circuit de visa de {document}",
      index: "Indice",
      startedBy: "Demand\xE9 par {name} le",
      started: "Demand\xE9 le",
      completed: "Termin\xE9 le",
      due: "\xC9ch\xE9ance\xA0:"
    },
    section: {
      loadFailed: "Les circuits de visa de ce document n'ont pas pu \xEAtre charg\xE9s.",
      none: "Aucun visa n'a \xE9t\xE9 demand\xE9 pour ce document.",
      past: "Circuits pr\xE9c\xE9dents",
      region: "Visa du document",
      title: "Visa",
      request: "Demander le visa"
    },
    errors: {
      locked: "Ce document est d\xE9j\xE0 en cours d'approbation\xA0: attendez la fin du circuit ou annulez-le.",
      notYourTurn: "Ce n'est pas encore votre tour\xA0: un relecteur qui vous pr\xE9c\xE8de doit d'abord donner son avis.",
      closed: "Ce circuit est termin\xE9 ou cette \xE9tape n'attend plus d'avis. La liste vient d'\xEAtre recharg\xE9e.",
      observationRequired: "Ajoutez une observation (un commentaire ou une annotation) pour un VAO ou un REF.",
      reviewerCannotView: "Un relecteur ne peut pas ouvrir ce document. Donnez-lui d'abord acc\xE8s au document, ou choisissez quelqu'un d'autre.",
      versionNotAvailable: "Seule une version v\xE9rifi\xE9e et disponible peut \xEAtre envoy\xE9e au visa\xA0: attendez la fin de la v\xE9rification antivirus.",
      stepsInvalid: "Les \xE9tapes ne sont pas valides\xA0: chaque \xE9tape a besoin d'au moins un relecteur, et personne ne peut figurer deux fois dans une \xE9tape.",
      officeUnknown: "Seuls les bureaux partenaires de vos espaces partag\xE9s peuvent \xEAtre sollicit\xE9s.",
      officeNoReviewer: "Un bureau partenaire n'a aucun approbateur dans cet espace. Demandez-lui de d\xE9l\xE9guer une personne avec le droit d'approuver, ou choisissez quelqu'un d'autre.",
      invalid: "Certaines informations ne sont pas valides. V\xE9rifiez-les puis r\xE9essayez.",
      forbidden: "Vous n'avez pas le droit d'effectuer cette action\xA0: vous n'\xEAtes pas relecteur de cette \xE9tape, ou vous n'avez pas demand\xE9 ce visa.",
      notFound: "Ce circuit n'existe plus ou vous n'y avez plus acc\xE8s."
    },
    tab: {
      noSpace: {
        title: "Les circuits de visa ne sont pas encore disponibles",
        description: "Ils appara\xEEtront d\xE8s que l'espace de fichiers du projet sera pr\xEAt."
      },
      columns: {
        document: "Document",
        index: "Indice",
        status: "\xC9tat",
        step: "\xC9tape en cours",
        initiator: "Demand\xE9 par",
        dates: "Dates",
        actions: "Actions"
      },
      stepOf: "\xC9tape {current} sur {total}",
      started: "Demand\xE9 le",
      completed: "Termin\xE9 le",
      due: "\xC9ch\xE9ance\xA0:",
      details: "Voir le circuit",
      detailsFor: "Voir le circuit de visa de {document}",
      detailsTitle: "Circuit de visa de \xAB\xA0{document}\xA0\xBB",
      filtersLabel: "Filtrer les circuits de visa",
      filter: {
        all: "Tous",
        in_progress: "En approbation",
        approved: "Approuv\xE9s",
        approved_with_comments: "Approuv\xE9s avec observations",
        rejected: "Refus\xE9s",
        cancelled: "Annul\xE9s",
        toDecide: "\xC0 d\xE9cider par moi"
      },
      loadFailedTitle: "Impossible d'afficher les circuits de visa",
      loadFailedBody: "La liste n'a pas pu \xEAtre charg\xE9e. R\xE9essayez\xA0; si le probl\xE8me continue, contactez le support.",
      caption: "Circuits de visa du projet",
      empty: {
        none: {
          title: "Aucun circuit de visa",
          description: "Ouvrez un document dans l'onglet Fichiers et demandez son visa\xA0: le circuit appara\xEEtra ici."
        },
        filtered: {
          title: "Aucun circuit ne correspond",
          description: "Choisissez un autre \xE9tat pour voir les autres circuits."
        },
        toDecide: {
          title: "Rien \xE0 d\xE9cider pour le moment",
          description: "Les circuits qui attendent votre avis appara\xEEtront ici."
        }
      }
    },
    templates: {
      title: "Mod\xE8les de circuit de visa",
      description: "Des circuits pr\xEAts \xE0 l'emploi que votre \xE9quipe peut choisir en demandant un visa.",
      new: "Nouveau mod\xE8le",
      newTitle: "Nouveau mod\xE8le de circuit",
      nameLabel: "Nom du mod\xE8le",
      nameRequired: "Donnez un nom au mod\xE8le.",
      create: "Cr\xE9er le mod\xE8le",
      creating: "Cr\xE9ation\u2026",
      created: "Le mod\xE8le \xAB\xA0{name}\xA0\xBB a \xE9t\xE9 cr\xE9\xE9.",
      loadFailed: "Les mod\xE8les n'ont pas pu \xEAtre charg\xE9s.",
      empty: "Aucun mod\xE8le pour le moment. Les \xE9quipes composent alors les \xE9tapes \xE0 chaque demande.",
      listLabel: "Mod\xE8les de circuit de visa",
      deleteFor: "Supprimer le mod\xE8le {name}",
      deleteTitle: "Supprimer le mod\xE8le \xAB\xA0{name}\xA0\xBB\xA0?",
      deleteBody: "Les circuits d\xE9j\xE0 lanc\xE9s ne changent pas.",
      delete: "Supprimer",
      deleted: "Le mod\xE8le \xAB\xA0{name}\xA0\xBB a \xE9t\xE9 supprim\xE9.",
      readOnly: "Cr\xE9er ou supprimer un mod\xE8le est r\xE9serv\xE9 aux personnes qui peuvent modifier l'organisation."
    }
  },
  trash: {
    open: "Corbeille",
    title: "Corbeille",
    back: "Retour aux fichiers",
    intro: "Les dossiers et documents supprim\xE9s restent {days} jours dans la corbeille, puis sont effac\xE9s pour de bon. Les responsables voient tout\xA0; les autres voient ce qu'ils ont supprim\xE9.",
    listLabel: "\xC9l\xE9ments supprim\xE9s",
    deletedBy: "Supprim\xE9 par {who} le {date}.",
    deletedOn: "Supprim\xE9 le {date}.",
    contains: "{count, plural, =0 {Dossier vide.} one {Avec # \xE9l\xE9ment.} other {Avec # \xE9l\xE9ments.}}",
    purgeAfter: "Effac\xE9 pour de bon le {date}.",
    restore: "Restaurer",
    restoreFor: "Restaurer {name}",
    restored: "\xAB\xA0{name}\xA0\xBB a \xE9t\xE9 restaur\xE9.",
    purgeFor: "Supprimer {name} d\xE9finitivement",
    purge: {
      action: "Supprimer d\xE9finitivement",
      title: "Supprimer \xAB\xA0{name}\xA0\xBB d\xE9finitivement\xA0?",
      bodyFolder: "{count, plural, =0 {Ce dossier vide sera effac\xE9.} one {Ce dossier et son \xE9l\xE9ment seront effac\xE9s avec leurs fichiers.} other {Ce dossier et ses # \xE9l\xE9ments seront effac\xE9s avec leurs fichiers.}} Cette action ne peut pas \xEAtre annul\xE9e.",
      bodyDocument: "Le document, toutes ses versions et ses fichiers seront effac\xE9s. Cette action ne peut pas \xEAtre annul\xE9e.",
      confirm: "Supprimer d\xE9finitivement",
      started: "\xAB\xA0{name}\xA0\xBB est en cours de suppression d\xE9finitive."
    },
    empty: {
      title: "La corbeille est vide",
      description: "Les dossiers et documents que vous supprimez arrivent ici et y restent {days} jours avant d'\xEAtre effac\xE9s."
    },
    loadFailed: "Impossible de charger la corbeille.",
    errors: {
      parentInTrash: "Le dossier qui contenait cet \xE9l\xE9ment est lui aussi dans la corbeille. Restaurez d'abord ce dossier.",
      nameTaken: "Un dossier porte d\xE9j\xE0 ce nom \xE0 cet endroit. Renommez ou d\xE9placez l'autre dossier, puis r\xE9essayez.",
      legalHold: "Cet \xE9l\xE9ment contient un document qui doit \xEAtre conserv\xE9 (obligation l\xE9gale)\xA0: il ne peut pas \xEAtre effac\xE9 avant la fin de cette obligation.",
      forbidden: "Vous n'avez pas le droit d'effectuer cette action sur cet \xE9l\xE9ment.",
      notFound: "Cet \xE9l\xE9ment n'est plus dans la corbeille. La liste vient d'\xEAtre actualis\xE9e."
    }
  },
  filesApp: {
    tabsLabel: "Vues des fichiers",
    tabs: {
      recent: "R\xE9cents",
      organisation: "Organisation",
      shared: "Partag\xE9s avec moi",
      search: "Rechercher"
    },
    recent: {
      listLabel: "Fichiers modifi\xE9s r\xE9cemment",
      updated: "Modifi\xE9 {when}",
      inFolder: "Dossier {folder}",
      loadFailedTitle: "Impossible d'afficher les fichiers r\xE9cents",
      loadFailedBody: "V\xE9rifiez votre connexion puis r\xE9essayez.",
      emptyTitle: "Aucun fichier r\xE9cent",
      emptyBody: "Les fichiers ajout\xE9s ou modifi\xE9s dans vos projets et vos espaces appara\xEEtront ici."
    },
    organisation: {
      loadFailedTitle: "Impossible d'ouvrir les documents de l'organisation",
      loadFailedBody: "V\xE9rifiez votre connexion puis r\xE9essayez.",
      noSpaceTitle: "Pas encore d'espace documentaire",
      noSpaceBody: "L'espace des documents de l'organisation n'est pas disponible pour le moment."
    },
    shared: {
      listLabel: "Espaces d'autres organisations",
      loadFailedTitle: "Impossible d'afficher les espaces partag\xE9s",
      loadFailedBody: "V\xE9rifiez votre connexion puis r\xE9essayez.",
      emptyTitle: "Rien n'est partag\xE9 avec vous",
      emptyBody: "Quand une autre organisation vous invite dans un de ses espaces, ses documents seront accessibles ici."
    },
    search: {
      inputLabel: "Rechercher un fichier",
      placeholder: "Titre ou code du document\u2026"
    }
  }
};

// locales/ar/viewer.json
var viewer_default = {
  page: {
    back: "\u0627\u0644\u0639\u0648\u062F\u0629 \u0625\u0644\u0649 \u0627\u0644\u0645\u0644\u0641\u0627\u062A",
    loading: "\u062C\u0627\u0631\u064D \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0645\u0633\u062A\u0646\u062F\u2026",
    loadFailedTitle: "\u062A\u0639\u0630\u0651\u0631 \u0641\u062A\u062D \u0647\u0630\u0627 \u0627\u0644\u0645\u0633\u062A\u0646\u062F",
    loadFailedBody: "\u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629 \u0628\u0639\u062F \u0642\u0644\u064A\u0644. \u0625\u0630\u0627 \u0627\u0633\u062A\u0645\u0631\u062A \u0627\u0644\u0645\u0634\u0643\u0644\u0629\u060C \u062A\u0648\u0627\u0635\u0644 \u0645\u0639 \u0645\u0633\u0624\u0648\u0644 \u0627\u0644\u0645\u0634\u0631\u0648\u0639.",
    notFoundTitle: "\u0627\u0644\u0645\u0633\u062A\u0646\u062F \u063A\u064A\u0631 \u0645\u0648\u062C\u0648\u062F",
    notFoundBody: "\u0647\u0630\u0627 \u0627\u0644\u0645\u0633\u062A\u0646\u062F \u063A\u064A\u0631 \u0645\u0648\u062C\u0648\u062F \u0623\u0648 \u0644\u064A\u0633\u062A \u0644\u062F\u064A\u0643 \u0635\u0644\u0627\u062D\u064A\u0629 \u0627\u0644\u0648\u0635\u0648\u0644 \u0625\u0644\u064A\u0647.",
    noSpaceTitle: "\u0645\u0633\u0627\u062D\u0629 \u0627\u0644\u0645\u0644\u0641\u0627\u062A \u063A\u064A\u0631 \u062C\u0627\u0647\u0632\u0629 \u0628\u0639\u062F",
    noSpaceBody: "\u0633\u062A\u062A\u0648\u0641\u0631 \u0645\u0633\u062A\u0646\u062F\u0627\u062A \u0647\u0630\u0627 \u0627\u0644\u0645\u0634\u0631\u0648\u0639 \u0628\u0645\u062C\u0631\u062F \u0625\u0646\u0634\u0627\u0621 \u0645\u0633\u0627\u062D\u062A\u0647 \u0627\u0644\u062F\u0627\u062E\u0644\u064A\u0629.",
    noVersionTitle: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0628\u0639\u062F \u0646\u0633\u062E\u0629 \u064A\u0645\u0643\u0646 \u0639\u0631\u0636\u0647\u0627 \u0644\u0647\u0630\u0627 \u0627\u0644\u0645\u0633\u062A\u0646\u062F",
    noVersionBody: "\u0633\u062A\u0638\u0647\u0631 \u0646\u0633\u062E\u0629 \u0647\u0646\u0627 \u0628\u0645\u062C\u0631\u062F \u0627\u0646\u062A\u0647\u0627\u0621 \u0641\u062D\u0635\u0647\u0627."
  },
  header: {
    version: "\u0646\u0633\u062E\u0629 \u0627\u0644\u0645\u0633\u062A\u0646\u062F",
    versionOption: "\u0627\u0644\u0645\u0631\u0627\u062C\u0639\u0629 {index} \xB7 {date}",
    versionOptionCurrent: "\u0627\u0644\u0645\u0631\u0627\u062C\u0639\u0629 {index} \xB7 {date} (\u0627\u0644\u0646\u0633\u062E\u0629 \u0627\u0644\u062D\u0627\u0644\u064A\u0629)",
    noIndex: "\u2014"
  },
  download: {
    button: "\u062A\u0646\u0632\u064A\u0644",
    busy: "\u062C\u0627\u0631\u064D \u062A\u062C\u0647\u064A\u0632 \u0627\u0644\u062A\u0646\u0632\u064A\u0644\u2026",
    preparing: "\u062C\u0627\u0631\u064D \u062A\u062C\u0647\u064A\u0632 \u0646\u0633\u062E\u0629 \u0628\u0627\u0633\u0645\u0643\u2026",
    denied: "\u0627\u0644\u062A\u0646\u0632\u064A\u0644 \u0645\u0639\u0637\u0651\u0644 \u0641\u064A \u0647\u0630\u0647 \u0627\u0644\u0645\u0633\u0627\u062D\u0629: \u064A\u0645\u0643\u0646\u0643 \u0627\u0644\u0627\u0637\u0644\u0627\u0639 \u0639\u0644\u0649 \u0647\u0630\u0627 \u0627\u0644\u0645\u0633\u062A\u0646\u062F \u062F\u0648\u0646 \u062A\u0646\u0632\u064A\u0644\u0647.",
    failed: "\u062A\u0639\u0630\u0651\u0631 \u0628\u062F\u0621 \u0627\u0644\u062A\u0646\u0632\u064A\u0644. \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629 \u0628\u0639\u062F \u0642\u0644\u064A\u0644."
  },
  watermark: {
    note: "\u062A\u062D\u0645\u0644 \u0647\u0630\u0647 \u0627\u0644\u0645\u0639\u0627\u064A\u0646\u0629 \u0639\u0644\u0627\u0645\u0629 \u0645\u0627\u0626\u064A\u0629 \u0628\u0627\u0633\u0645\u0643 \u0648\u0627\u0633\u0645 \u0645\u0624\u0633\u0633\u062A\u0643 \u0648\u0627\u0644\u062A\u0627\u0631\u064A\u062E."
  },
  states: {
    loadingPreview: "\u062C\u0627\u0631\u064D \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0645\u0639\u0627\u064A\u0646\u0629\u2026",
    preparing: {
      title: "\u062C\u0627\u0631\u064D \u062A\u062C\u0647\u064A\u0632 \u0627\u0644\u0645\u0639\u0627\u064A\u0646\u0629\u2026",
      body: "\u064A\u062C\u0631\u064A \u062A\u062D\u0648\u064A\u0644 \u0627\u0644\u0645\u0644\u0641 \u0644\u0644\u0639\u0631\u0636. \u064A\u0633\u062A\u063A\u0631\u0642 \u0630\u0644\u0643 \u0639\u0627\u062F\u0629\u064B \u0628\u0636\u0639 \u062B\u0648\u0627\u0646\u064D\u060C \u0648\u062A\u062A\u062D\u062F\u0651\u062B \u0627\u0644\u0635\u0641\u062D\u0629 \u062A\u0644\u0642\u0627\u0626\u064A\u064B\u0627."
    },
    preparingWatermark: {
      title: "\u062C\u0627\u0631\u064D \u062A\u062C\u0647\u064A\u0632 \u0646\u0633\u062E\u0629 \u0628\u0627\u0633\u0645\u0643\u2026",
      body: "\u062A\u062D\u0645\u0644 \u0647\u0630\u0647 \u0627\u0644\u0646\u0633\u062E\u0629 \u0627\u0633\u0645\u0643 \u0648\u0627\u0633\u0645 \u0645\u0624\u0633\u0633\u062A\u0643 \u0648\u0627\u0644\u062A\u0627\u0631\u064A\u062E. \u0633\u062A\u0638\u0647\u0631 \u0641\u0648\u0631 \u062C\u0627\u0647\u0632\u064A\u062A\u0647\u0627."
    },
    none: {
      title: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0645\u0639\u0627\u064A\u0646\u0629 \u0644\u0647\u0630\u0627 \u0627\u0644\u0646\u0648\u0639 \u0645\u0646 \u0627\u0644\u0645\u0644\u0641\u0627\u062A",
      body: "\u0646\u0632\u0651\u0644 \u0627\u0644\u0645\u0644\u0641 \u0644\u0641\u062A\u062D\u0647 \u0628\u062A\u0637\u0628\u064A\u0642 \u0645\u0646\u0627\u0633\u0628.",
      bodyNoDownload: "\u0644\u0627 \u064A\u0645\u0643\u0646 \u0639\u0631\u0636 \u0647\u0630\u0627 \u0627\u0644\u0646\u0648\u0639 \u0645\u0646 \u0627\u0644\u0645\u0644\u0641\u0627\u062A \u0647\u0646\u0627\u060C \u0648\u0627\u0644\u062A\u0646\u0632\u064A\u0644 \u063A\u064A\u0631 \u0645\u0633\u0645\u0648\u062D \u0628\u0647 \u0641\u064A \u0647\u0630\u0647 \u0627\u0644\u0645\u0633\u0627\u062D\u0629."
    },
    failed: {
      title: "\u062A\u0639\u0630\u0651\u0631 \u0625\u0646\u0634\u0627\u0621 \u0627\u0644\u0645\u0639\u0627\u064A\u0646\u0629",
      body: "\u0631\u0628\u0645\u0627 \u064A\u0643\u0648\u0646 \u0627\u0644\u0645\u0644\u0641 \u062A\u0627\u0644\u0641\u064B\u0627. \u0646\u0632\u0651\u0644\u0647 \u0644\u0641\u062A\u062D\u0647 \u0641\u064A \u0645\u0643\u0627\u0646 \u0622\u062E\u0631\u060C \u0623\u0648 \u0623\u0631\u0633\u0644 \u0646\u0633\u062E\u0629 \u062C\u062F\u064A\u062F\u0629.",
      bodyNoDownload: "\u0631\u0628\u0645\u0627 \u064A\u0643\u0648\u0646 \u0627\u0644\u0645\u0644\u0641 \u062A\u0627\u0644\u0641\u064B\u0627. \u0623\u0631\u0633\u0644 \u0646\u0633\u062E\u0629 \u062C\u062F\u064A\u062F\u0629\u060C \u0623\u0648 \u062A\u0648\u0627\u0635\u0644 \u0645\u0639 \u0645\u0633\u0624\u0648\u0644 \u0627\u0644\u0645\u0634\u0631\u0648\u0639."
    },
    unavailable: {
      uploading: {
        title: "\u0647\u0630\u0627 \u0627\u0644\u0645\u0644\u0641 \u0642\u064A\u062F \u0627\u0644\u0631\u0641\u0639",
        body: "\u0633\u064A\u0635\u0628\u062D \u0645\u062A\u0627\u062D\u064B\u0627 \u0644\u0644\u0639\u0631\u0636 \u0628\u0639\u062F \u0627\u0646\u062A\u0647\u0627\u0621 \u0627\u0644\u0631\u0641\u0639 \u0648\u0641\u062D\u0635 \u0627\u0644\u0641\u064A\u0631\u0648\u0633\u0627\u062A."
      },
      scanning: {
        title: "\u0647\u0630\u0627 \u0627\u0644\u0645\u0644\u0641 \u0642\u064A\u062F \u0627\u0644\u0641\u062D\u0635",
        body: "\u0633\u064A\u0635\u0628\u062D \u0645\u062A\u0627\u062D\u064B\u0627 \u0644\u0644\u0639\u0631\u0636 \u0628\u0639\u062F \u0627\u0646\u062A\u0647\u0627\u0621 \u0641\u062D\u0635 \u0627\u0644\u0641\u064A\u0631\u0648\u0633\u0627\u062A."
      },
      rejected: {
        title: "\u062A\u0645 \u0631\u0641\u0636 \u0647\u0630\u0627 \u0627\u0644\u0645\u0644\u0641",
        body: "\u0644\u0645 \u064A\u062C\u062A\u0632 \u0641\u062D\u0648\u0635\u0627\u062A \u0627\u0644\u0623\u0645\u0627\u0646 \u0648\u0644\u0627 \u064A\u0645\u0643\u0646 \u0641\u062A\u062D\u0647."
      }
    },
    previewFailed: {
      title: "\u062A\u0639\u0630\u0651\u0631 \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0645\u0639\u0627\u064A\u0646\u0629",
      body: "\u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629 \u0628\u0639\u062F \u0642\u0644\u064A\u0644. \u0625\u0630\u0627 \u0627\u0633\u062A\u0645\u0631\u062A \u0627\u0644\u0645\u0634\u0643\u0644\u0629\u060C \u062A\u0648\u0627\u0635\u0644 \u0645\u0639 \u0645\u0633\u0624\u0648\u0644 \u0627\u0644\u0645\u0634\u0631\u0648\u0639."
    },
    pdfFailed: {
      title: "\u062A\u0639\u0630\u0651\u0631 \u0639\u0631\u0636 \u0645\u0644\u0641 PDF \u0647\u0630\u0627",
      body: "\u0627\u0646\u0642\u0637\u0639 \u0627\u0644\u0627\u062A\u0635\u0627\u0644 \u0623\u0648 \u0623\u0646 \u0627\u0644\u0645\u0644\u0641 \u062A\u0627\u0644\u0641. \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629 \u0623\u0648 \u0646\u0632\u0651\u0644 \u0627\u0644\u0645\u0644\u0641."
    },
    pdfPassword: {
      title: "\u0645\u0644\u0641 PDF \u0647\u0630\u0627 \u0645\u062D\u0645\u064A \u0628\u0643\u0644\u0645\u0629 \u0645\u0631\u0648\u0631",
      body: "\u0644\u0627 \u064A\u0645\u0643\u0646 \u0639\u0631\u0636\u0647 \u0647\u0646\u0627. \u0646\u0632\u0651\u0644\u0647 \u0644\u0641\u062A\u062D\u0647 \u0628\u0627\u0633\u062A\u062E\u062F\u0627\u0645 \u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631."
    },
    imageFailed: {
      title: "\u062A\u0639\u0630\u0651\u0631 \u0639\u0631\u0636 \u0647\u0630\u0647 \u0627\u0644\u0635\u0648\u0631\u0629",
      body: "\u0627\u0646\u0642\u0637\u0639 \u0627\u0644\u0627\u062A\u0635\u0627\u0644 \u0623\u0648 \u0623\u0646 \u0627\u0644\u0645\u0644\u0641 \u062A\u0627\u0644\u0641. \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629 \u0623\u0648 \u0646\u0632\u0651\u0644 \u0627\u0644\u0645\u0644\u0641."
    },
    cadInvalid: {
      title: "\u062A\u0639\u0630\u0651\u0631 \u0639\u0631\u0636 \u0647\u0630\u0627 \u0627\u0644\u0645\u062E\u0637\u0637",
      body: "\u0645\u0644\u0641 \u0627\u0644\u0645\u0639\u0627\u064A\u0646\u0629 \u063A\u064A\u0631 \u0635\u0627\u0644\u062D. \u0646\u0632\u0651\u0644 \u0627\u0644\u0645\u062E\u0637\u0637 \u0627\u0644\u0623\u0635\u0644\u064A \u0623\u0648 \u0627\u0631\u0641\u0639 \u0646\u0633\u062E\u0629 \u062C\u062F\u064A\u062F\u0629."
    },
    cadFailed: {
      title: "\u062A\u0639\u0630\u0651\u0631 \u0639\u0631\u0636 \u0647\u0630\u0627 \u0627\u0644\u0645\u062E\u0637\u0637",
      body: "\u0627\u0646\u0642\u0637\u0639 \u0627\u0644\u0627\u062A\u0635\u0627\u0644. \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629 \u0623\u0648 \u0646\u0632\u0651\u0644 \u0627\u0644\u0645\u0644\u0641."
    }
  },
  pdf: {
    document: "\u0627\u0644\u0645\u0633\u062A\u0646\u062F: {title}",
    keyboardHelp: "\u0627\u0644\u0627\u062E\u062A\u0635\u0627\u0631\u0627\u062A: \xAB\u0627\u0644\u0635\u0641\u062D\u0629 \u0627\u0644\u062A\u0627\u0644\u064A\u0629\xBB \u0648\xAB\u0627\u0644\u0635\u0641\u062D\u0629 \u0627\u0644\u0633\u0627\u0628\u0642\u0629\xBB \u0623\u0648 \u0627\u0644\u0633\u0647\u0645\u0627\u0646 \u0627\u0644\u0623\u064A\u0645\u0646 \u0648\u0627\u0644\u0623\u064A\u0633\u0631 \u0644\u0644\u062A\u0646\u0642\u0644 \u0628\u064A\u0646 \u0627\u0644\u0635\u0641\u062D\u0627\u062A. \xABHome\xBB \u0648\xABEnd\xBB \u0644\u0644\u0627\u0646\u062A\u0642\u0627\u0644 \u0625\u0644\u0649 \u0627\u0644\u0635\u0641\u062D\u0629 \u0627\u0644\u0623\u0648\u0644\u0649 \u0648\u0627\u0644\u0623\u062E\u064A\u0631\u0629. \u0639\u0644\u0627\u0645\u062A\u0627 + \u0648 \u2212 \u0644\u0644\u062A\u0643\u0628\u064A\u0631 \u0648\u0627\u0644\u062A\u0635\u063A\u064A\u0631. Ctrl + F \u0644\u0644\u0628\u062D\u062B \u0641\u064A \u0627\u0644\u0645\u0633\u062A\u0646\u062F.",
    pageFailed: "\u062A\u0639\u0630\u0651\u0631 \u0639\u0631\u0636 \u0647\u0630\u0647 \u0627\u0644\u0635\u0641\u062D\u0629.",
    pageStatus: "\u0627\u0644\u0635\u0641\u062D\u0629 {page} \u0645\u0646 {total}",
    page: "\u0627\u0644\u0635\u0641\u062D\u0629 {page} \u0645\u0646 {total}",
    toolbar: {
      label: "\u0623\u062F\u0648\u0627\u062A \u0627\u0644\u0645\u0633\u062A\u0646\u062F",
      showThumbnails: "\u0625\u0638\u0647\u0627\u0631 \u0627\u0644\u0635\u0648\u0631 \u0627\u0644\u0645\u0635\u063A\u0651\u0631\u0629",
      hideThumbnails: "\u0625\u062E\u0641\u0627\u0621 \u0627\u0644\u0635\u0648\u0631 \u0627\u0644\u0645\u0635\u063A\u0651\u0631\u0629",
      previousPage: "\u0627\u0644\u0635\u0641\u062D\u0629 \u0627\u0644\u0633\u0627\u0628\u0642\u0629",
      nextPage: "\u0627\u0644\u0635\u0641\u062D\u0629 \u0627\u0644\u062A\u0627\u0644\u064A\u0629",
      goToPage: "\u0627\u0644\u0627\u0646\u062A\u0642\u0627\u0644 \u0625\u0644\u0649 \u0627\u0644\u0635\u0641\u062D\u0629",
      of: "\u0645\u0646",
      zoomIn: "\u062A\u0643\u0628\u064A\u0631",
      zoomOut: "\u062A\u0635\u063A\u064A\u0631",
      zoomValue: "\u0627\u0644\u062A\u0643\u0628\u064A\u0631: {percent}%",
      fitWidth: "\u0645\u0644\u0627\u0621\u0645\u0629 \u0627\u0644\u0639\u0631\u0636",
      fitPage: "\u0645\u0644\u0627\u0621\u0645\u0629 \u0627\u0644\u0635\u0641\u062D\u0629",
      search: "\u0627\u0644\u0628\u062D\u062B \u0641\u064A \u0627\u0644\u0645\u0633\u062A\u0646\u062F"
    },
    thumbnails: {
      label: "\u0627\u0644\u0635\u0648\u0631 \u0627\u0644\u0645\u0635\u063A\u0651\u0631\u0629 \u0644\u0644\u0635\u0641\u062D\u0627\u062A",
      page: "\u0627\u0644\u0635\u0641\u062D\u0629 {page}"
    },
    search: {
      label: "\u0627\u0644\u0628\u062D\u062B \u0641\u064A \u0627\u0644\u0645\u0633\u062A\u0646\u062F",
      input: "\u0627\u0644\u0628\u062D\u062B \u0641\u064A \u0627\u0644\u0645\u0633\u062A\u0646\u062F",
      placeholder: "\u0628\u062D\u062B\u2026",
      previous: "\u0627\u0644\u0646\u062A\u064A\u062C\u0629 \u0627\u0644\u0633\u0627\u0628\u0642\u0629",
      next: "\u0627\u0644\u0646\u062A\u064A\u062C\u0629 \u0627\u0644\u062A\u0627\u0644\u064A\u0629",
      close: "\u0625\u063A\u0644\u0627\u0642 \u0627\u0644\u0628\u062D\u062B",
      searching: "\u062C\u0627\u0631\u064D \u0627\u0644\u0628\u062D\u062B\u2026",
      none: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0646\u062A\u0627\u0626\u062C",
      position: "\u0627\u0644\u0646\u062A\u064A\u062C\u0629 {current} \u0645\u0646 {total}"
    }
  },
  image: {
    label: "\u0635\u0648\u0631\u0629: {title}",
    toolbar: "\u0623\u062F\u0648\u0627\u062A \u0627\u0644\u0635\u0648\u0631\u0629",
    keyboardHelp: "\u0627\u0644\u0627\u062E\u062A\u0635\u0627\u0631\u0627\u062A: \u0627\u0644\u0623\u0633\u0647\u0645 \u0644\u062A\u062D\u0631\u064A\u0643 \u0627\u0644\u0635\u0648\u0631\u0629\u060C \u0639\u0644\u0627\u0645\u062A\u0627 + \u0648 \u2212 \u0644\u0644\u062A\u0643\u0628\u064A\u0631 \u0648\u0627\u0644\u062A\u0635\u063A\u064A\u0631\u060C \u06480 \u0644\u0645\u0644\u0627\u0621\u0645\u0629 \u0627\u0644\u0635\u0648\u0631\u0629 \u0644\u0644\u0646\u0627\u0641\u0630\u0629.",
    zoomIn: "\u062A\u0643\u0628\u064A\u0631",
    zoomOut: "\u062A\u0635\u063A\u064A\u0631",
    zoomValue: "\u0627\u0644\u062A\u0643\u0628\u064A\u0631: {percent}%",
    fit: "\u0645\u0644\u0627\u0621\u0645\u0629 \u0627\u0644\u0646\u0627\u0641\u0630\u0629"
  },
  annotations: {
    tools: {
      label: "\u0623\u062F\u0648\u0627\u062A \u0627\u0644\u062A\u0639\u0644\u064A\u0642 \u0627\u0644\u062A\u0648\u0636\u064A\u062D\u064A",
      select: "\u062A\u062D\u062F\u064A\u062F",
      rect: "\u0645\u0633\u062A\u0637\u064A\u0644",
      cloud: "\u0633\u062D\u0627\u0628\u0629 \u0645\u0631\u0627\u062C\u0639\u0629",
      arrow: "\u0633\u0647\u0645",
      text: "\u0646\u0635"
    },
    colors: {
      label: "\u0627\u0644\u0644\u0648\u0646",
      red: "\u0623\u062D\u0645\u0631",
      orange: "\u0628\u0631\u062A\u0642\u0627\u0644\u064A",
      green: "\u0623\u062E\u0636\u0631",
      blue: "\u0623\u0632\u0631\u0642",
      black: "\u0623\u0633\u0648\u062F"
    },
    list: {
      show: "\u0625\u0638\u0647\u0627\u0631 \u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u062A\u0639\u0644\u064A\u0642\u0627\u062A \u0627\u0644\u062A\u0648\u0636\u064A\u062D\u064A\u0629",
      hide: "\u0625\u062E\u0641\u0627\u0621 \u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u062A\u0639\u0644\u064A\u0642\u0627\u062A \u0627\u0644\u062A\u0648\u0636\u064A\u062D\u064A\u0629",
      title: "\u0627\u0644\u062A\u0639\u0644\u064A\u0642\u0627\u062A \u0627\u0644\u062A\u0648\u0636\u064A\u062D\u064A\u0629",
      filterState: "\u062A\u0635\u0641\u064A\u0629 \u062D\u0633\u0628 \u0627\u0644\u062D\u0627\u0644\u0629",
      state_all: "\u0627\u0644\u0643\u0644",
      state_open: "\u0627\u0644\u0645\u0641\u062A\u0648\u062D\u0629",
      state_resolved: "\u0627\u0644\u0645\u062D\u0644\u0648\u0644\u0629",
      filterOrg: "\u062A\u0635\u0641\u064A\u0629 \u062D\u0633\u0628 \u0627\u0644\u0645\u0624\u0633\u0633\u0629",
      orgAll: "\u0643\u0644 \u0627\u0644\u0645\u0624\u0633\u0633\u0627\u062A",
      loading: "\u062C\u0627\u0631\u064D \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u062A\u0639\u0644\u064A\u0642\u0627\u062A \u0627\u0644\u062A\u0648\u0636\u064A\u062D\u064A\u0629\u2026",
      loadFailed: "\u062A\u0639\u0630\u0651\u0631 \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u062A\u0639\u0644\u064A\u0642\u0627\u062A \u0627\u0644\u062A\u0648\u0636\u064A\u062D\u064A\u0629.",
      empty: "\u0644\u0627 \u062A\u0648\u062C\u062F \u062A\u0639\u0644\u064A\u0642\u0627\u062A \u062A\u0648\u0636\u064A\u062D\u064A\u0629 \u0639\u0644\u0649 \u0647\u0630\u0647 \u0627\u0644\u0646\u0633\u062E\u0629 \u0628\u0639\u062F.",
      emptyFiltered: "\u0644\u0627 \u062A\u0648\u062C\u062F \u062A\u0639\u0644\u064A\u0642\u0627\u062A \u062A\u0648\u0636\u064A\u062D\u064A\u0629 \u062A\u0637\u0627\u0628\u0642 \u0647\u0630\u0647 \u0627\u0644\u062A\u0635\u0641\u064A\u0629.",
      itemNumber: "\u0627\u0644\u062A\u0639\u0644\u064A\u0642 \u0627\u0644\u062A\u0648\u0636\u064A\u062D\u064A {number}",
      itemPage: "\u0627\u0644\u0635\u0641\u062D\u0629 {page}"
    },
    org: {
      own: "\u0645\u0624\u0633\u0633\u062A\u064A",
      partner: "\u0645\u0624\u0633\u0633\u0629 \u0634\u0631\u064A\u0643\u0629"
    },
    author: {
      partner: "\u0634\u0631\u064A\u0643"
    },
    state: {
      open: "\u0645\u0641\u062A\u0648\u062D",
      resolved: "\u0645\u062D\u0644\u0648\u0644"
    },
    label: "\u0627\u0644\u062A\u0639\u0644\u064A\u0642 \u0627\u0644\u062A\u0648\u0636\u064A\u062D\u064A {number}\u060C \u0627\u0644\u0635\u0641\u062D\u0629 {page}: {comment}",
    labelResolved: "\u0627\u0644\u062A\u0639\u0644\u064A\u0642 \u0627\u0644\u062A\u0648\u0636\u064A\u062D\u064A {number}\u060C \u0627\u0644\u0635\u0641\u062D\u0629 {page}\u060C \u0645\u062D\u0644\u0648\u0644: {comment}",
    surface: {
      corners: "\u0645\u0646\u0637\u0642\u0629 \u0627\u0644\u0631\u0633\u0645 \u0641\u064A \u0627\u0644\u0635\u0641\u062D\u0629 {page}\u060C \u0627\u0644\u0623\u062F\u0627\u0629: {tool}. \u0627\u0644\u0623\u0633\u0647\u0645 \u062A\u062D\u0631\u0651\u0643 \u0627\u0644\u0645\u0624\u0634\u0631 (\u0645\u0639 Shift \u0623\u0633\u0631\u0639)\u060C \u0648Enter \u064A\u0636\u0639 \u0627\u0644\u0632\u0627\u0648\u064A\u0629 \u0627\u0644\u0623\u0648\u0644\u0649 \u062B\u0645 \u0627\u0644\u0632\u0627\u0648\u064A\u0629 \u0627\u0644\u0645\u0642\u0627\u0628\u0644\u0629\u060C \u0648Esc \u064A\u0644\u063A\u064A.",
      point: "\u0645\u0646\u0637\u0642\u0629 \u0627\u0644\u0631\u0633\u0645 \u0641\u064A \u0627\u0644\u0635\u0641\u062D\u0629 {page}\u060C \u0627\u0644\u0623\u062F\u0627\u0629: {tool}. \u0627\u0644\u0623\u0633\u0647\u0645 \u062A\u062D\u0631\u0651\u0643 \u0627\u0644\u0645\u0624\u0634\u0631\u060C \u0648Enter \u064A\u0636\u0639 \u0627\u0644\u0646\u0635\u060C \u0648Esc \u064A\u0644\u063A\u064A."
    },
    announce: {
      tooSmall: "\u0627\u0644\u0634\u0643\u0644 \u0635\u063A\u064A\u0631 \u062C\u062F\u064B\u0627: \u0627\u0631\u0633\u0645 \u0645\u0646\u0637\u0642\u0629 \u0623\u0643\u0628\u0631.",
      firstPoint: "\u062A\u0645 \u0648\u0636\u0639 \u0627\u0644\u0646\u0642\u0637\u0629 \u0627\u0644\u0623\u0648\u0644\u0649. \u062D\u0631\u0651\u0643 \u0627\u0644\u0645\u0624\u0634\u0631 \u0625\u0644\u0649 \u0627\u0644\u0632\u0627\u0648\u064A\u0629 \u0627\u0644\u0645\u0642\u0627\u0628\u0644\u0629 \u062B\u0645 \u0627\u0636\u063A\u0637 Enter.",
      cancelled: "\u0623\u064F\u0644\u063A\u064A \u0627\u0644\u0631\u0633\u0645.",
      toolActive: "\u0627\u0644\u0623\u062F\u0627\u0629 \u0627\u0644\u0646\u0634\u0637\u0629: {tool}.",
      added: "\u062A\u0645\u062A \u0625\u0636\u0627\u0641\u0629 \u0627\u0644\u062A\u0639\u0644\u064A\u0642 \u0627\u0644\u062A\u0648\u0636\u064A\u062D\u064A.",
      deleted: "\u062A\u0645 \u062D\u0630\u0641 \u0627\u0644\u062A\u0639\u0644\u064A\u0642 \u0627\u0644\u062A\u0648\u0636\u064A\u062D\u064A.",
      updated: "\u062A\u0645 \u062A\u0639\u062F\u064A\u0644 \u0627\u0644\u062A\u0639\u0644\u064A\u0642 \u0627\u0644\u062A\u0648\u0636\u064A\u062D\u064A.",
      replied: "\u062A\u0645 \u0625\u0631\u0633\u0627\u0644 \u0627\u0644\u0631\u062F.",
      resolved: "\u062A\u0645 \u062D\u0644\u0651 \u0627\u0644\u062A\u0639\u0644\u064A\u0642 \u0627\u0644\u062A\u0648\u0636\u064A\u062D\u064A.",
      reopened: "\u0623\u064F\u0639\u064A\u062F \u0641\u062A\u062D \u0627\u0644\u062A\u0639\u0644\u064A\u0642 \u0627\u0644\u062A\u0648\u0636\u064A\u062D\u064A."
    },
    details: {
      title: "\u0627\u0644\u062A\u0639\u0644\u064A\u0642 \u0627\u0644\u062A\u0648\u0636\u064A\u062D\u064A {number} \xB7 \u0627\u0644\u0635\u0641\u062D\u0629 {page}",
      onPlan: "\u0627\u0644\u0646\u0635 \u0639\u0644\u0649 \u0627\u0644\u0645\u062E\u0637\u0637: \xAB{text}\xBB",
      resolve: "\u062D\u0644\u0651",
      reopen: "\u0625\u0639\u0627\u062F\u0629 \u0641\u062A\u062D",
      edit: "\u062A\u0639\u062F\u064A\u0644"
    },
    new: {
      title: "\u062A\u0639\u0644\u064A\u0642 \u062A\u0648\u0636\u064A\u062D\u064A \u062C\u062F\u064A\u062F \xB7 \u0627\u0644\u0635\u0641\u062D\u0629 {page}",
      add: "\u0625\u0636\u0627\u0641\u0629 \u0627\u0644\u062A\u0639\u0644\u064A\u0642 \u0627\u0644\u062A\u0648\u0636\u064A\u062D\u064A"
    },
    fields: {
      label: {
        name: "\u0627\u0644\u0646\u0635 \u0627\u0644\u0645\u0639\u0631\u0648\u0636 \u0639\u0644\u0649 \u0627\u0644\u0645\u062E\u0637\u0637",
        required: "\u0627\u0643\u062A\u0628 \u0627\u0644\u0646\u0635 \u0627\u0644\u0630\u064A \u0633\u064A\u0638\u0647\u0631 \u0639\u0644\u0649 \u0627\u0644\u0645\u062E\u0637\u0637.",
        tooLong: "\u0647\u0630\u0627 \u0627\u0644\u0646\u0635 \u064A\u062A\u062C\u0627\u0648\u0632 500 \u062D\u0631\u0641."
      },
      comment: {
        name: "\u0627\u0644\u062A\u0639\u0644\u064A\u0642",
        hint: "\u0627\u0634\u0631\u062D \u0645\u0627 \u064A\u062C\u0628 \u062A\u0635\u062D\u064A\u062D\u0647 \u0623\u0648 \u0627\u0644\u062A\u062D\u0642\u0642 \u0645\u0646\u0647.",
        required: "\u0627\u0643\u062A\u0628 \u062A\u0639\u0644\u064A\u0642\u064B\u0627.",
        tooLong: "\u0647\u0630\u0627 \u0627\u0644\u062A\u0639\u0644\u064A\u0642 \u064A\u062A\u062C\u0627\u0648\u0632 2000 \u062D\u0631\u0641."
      }
    },
    thread: {
      title: "\u0627\u0644\u0646\u0642\u0627\u0634",
      loadFailed: "\u062A\u0639\u0630\u0651\u0631 \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0631\u062F\u0648\u062F.",
      empty: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0631\u062F\u0648\u062F \u0628\u0639\u062F.",
      reply: "\u0631\u062F\u0651",
      replyLabel: "\u0631\u062F\u0651\u0643",
      send: "\u0625\u0631\u0633\u0627\u0644"
    },
    delete: {
      title: "\u062D\u0630\u0641 \u0627\u0644\u062A\u0639\u0644\u064A\u0642 \u0627\u0644\u062A\u0648\u0636\u064A\u062D\u064A {number} (\u0627\u0644\u0635\u0641\u062D\u0629 {page})\u061F",
      body: "\u0633\u064A\u062A\u0645 \u062D\u0630\u0641 \xAB{comment}\xBB \u0648\u0631\u062F\u0648\u062F\u0647."
    },
    errors: {
      generic: "\u0644\u0645 \u062A\u0646\u062C\u062D \u0627\u0644\u0639\u0645\u0644\u064A\u0629. \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629 \u0628\u0639\u062F \u0642\u0644\u064A\u0644.",
      ANNOTATION_RESOLVED: "\u0647\u0630\u0627 \u0627\u0644\u062A\u0639\u0644\u064A\u0642 \u0627\u0644\u062A\u0648\u0636\u064A\u062D\u064A \u0645\u062D\u0644\u0648\u0644: \u0623\u0639\u062F \u0641\u062A\u062D\u0647 \u0644\u062A\u0639\u062F\u064A\u0644\u0647.",
      VERSION_NOT_AVAILABLE: "\u0647\u0630\u0647 \u0627\u0644\u0646\u0633\u062E\u0629 \u063A\u064A\u0631 \u0645\u062A\u0627\u062D\u0629 \u0644\u0644\u0639\u0631\u0636 \u0628\u0639\u062F\u060C \u0641\u0644\u0627 \u064A\u0645\u0643\u0646 \u0627\u0644\u062A\u0639\u0644\u064A\u0642 \u0639\u0644\u064A\u0647\u0627.",
      PAGE_OUT_OF_RANGE: "\u0647\u0630\u0647 \u0627\u0644\u0635\u0641\u062D\u0629 \u063A\u064A\u0631 \u0645\u0648\u062C\u0648\u062F\u0629 \u0641\u064A \u0627\u0644\u0645\u0633\u062A\u0646\u062F.",
      FORBIDDEN: "\u0644\u064A\u0633\u062A \u0644\u062F\u064A\u0643 \u0635\u0644\u0627\u062D\u064A\u0629 \u062A\u0646\u0641\u064A\u0630 \u0647\u0630\u0627 \u0627\u0644\u0625\u062C\u0631\u0627\u0621 \u0639\u0644\u0649 \u0647\u0630\u0627 \u0627\u0644\u062A\u0639\u0644\u064A\u0642 \u0627\u0644\u062A\u0648\u0636\u064A\u062D\u064A.",
      NOT_FOUND: "\u0644\u0645 \u064A\u0639\u062F \u0647\u0630\u0627 \u0627\u0644\u062A\u0639\u0644\u064A\u0642 \u0627\u0644\u062A\u0648\u0636\u064A\u062D\u064A \u0645\u0648\u062C\u0648\u062F\u064B\u0627. \u062A\u0645 \u062A\u062D\u062F\u064A\u062B \u0627\u0644\u0642\u0627\u0626\u0645\u0629.",
      stale: "\u0639\u062F\u0651\u0644 \u0634\u062E\u0635 \u0622\u062E\u0631 \u0647\u0630\u0627 \u0627\u0644\u062A\u0639\u0644\u064A\u0642 \u0627\u0644\u062A\u0648\u0636\u064A\u062D\u064A. \u062A\u0645 \u062A\u062D\u0645\u064A\u0644\u0647 \u0645\u0646 \u062C\u062F\u064A\u062F: \u0643\u0631\u0651\u0631 \u0625\u062C\u0631\u0627\u0621\u0643 \u0625\u0646 \u0644\u0632\u0645."
    }
  },
  cad: {
    toolbar: {
      label: "\u0623\u062F\u0648\u0627\u062A \u0627\u0644\u0645\u062E\u0637\u0637",
      showLayers: "\u0625\u0638\u0647\u0627\u0631 \u0627\u0644\u0637\u0628\u0642\u0627\u062A",
      hideLayers: "\u0625\u062E\u0641\u0627\u0621 \u0627\u0644\u0637\u0628\u0642\u0627\u062A",
      zoomIn: "\u062A\u0643\u0628\u064A\u0631",
      zoomOut: "\u062A\u0635\u063A\u064A\u0631",
      zoomValue: "\u0627\u0644\u062A\u0643\u0628\u064A\u0631: {percent}%",
      fit: "\u0645\u0644\u0627\u0621\u0645\u0629 \u0627\u0644\u0646\u0627\u0641\u0630\u0629",
      measure: "\u0642\u064A\u0627\u0633 \u0645\u0633\u0627\u0641\u0629",
      clearMeasure: "\u0645\u0633\u062D \u0627\u0644\u0642\u064A\u0627\u0633"
    },
    viewport: "\u0645\u0646\u0637\u0642\u0629 \u0627\u0644\u0645\u062E\u0637\u0637: {title}",
    drawing: "\u0627\u0644\u0631\u0633\u0645: {title}",
    truncated: "\u0645\u0639\u0627\u064A\u0646\u0629 \u062C\u0632\u0626\u064A\u0629: \u0627\u0644\u0631\u0633\u0645 \u0643\u0628\u064A\u0631 \u062C\u062F\u064B\u0627 \u0641\u0644\u0627 \u064A\u0645\u0643\u0646 \u0639\u0631\u0636\u0647 \u0643\u0627\u0645\u0644\u064B\u0627.",
    keyboardHelp: "\u0627\u062E\u062A\u0635\u0627\u0631\u0627\u062A: \u0645\u0641\u0627\u062A\u064A\u062D \u0627\u0644\u0623\u0633\u0647\u0645 \u062A\u062D\u0631\u0651\u0643 \u0627\u0644\u0645\u062E\u0637\u0637\u060C \u0648\u0639\u0644\u0627\u0645\u062A\u0627 \u0627\u0644\u0632\u0627\u0626\u062F \u0648\u0627\u0644\u0646\u0627\u0642\u0635 \u062A\u0643\u0628\u0651\u0631\u0627\u0646 \u0648\u062A\u0635\u063A\u0651\u0631\u0627\u0646\u060C \u0648\u0627\u0644\u0631\u0642\u0645 0 \u064A\u0644\u0627\u0626\u0645 \u0627\u0644\u0645\u062E\u0637\u0637 \u0645\u0639 \u0627\u0644\u0646\u0627\u0641\u0630\u0629. \u0645\u0639 \u0623\u062F\u0627\u0629 \u0627\u0644\u0642\u064A\u0627\u0633 \u062A\u062D\u0631\u0651\u0643 \u0627\u0644\u0623\u0633\u0647\u0645 \u0639\u0644\u0627\u0645\u0629 \u0627\u0644\u062A\u0635\u0648\u064A\u0628\u060C \u0648\u064A\u0636\u0639 Enter \u0646\u0642\u0637\u0629 (\u0646\u0642\u0637\u062A\u0627\u0646 \u062A\u0639\u0637\u064A\u0627\u0646 \u0627\u0644\u0645\u0633\u0627\u0641\u0629)\u060C \u0648\u064A\u0645\u0633\u062D Esc \u0627\u0644\u0642\u064A\u0627\u0633.",
    layers: {
      region: "\u0637\u0628\u0642\u0627\u062A \u0627\u0644\u0645\u062E\u0637\u0637",
      title: "\u0627\u0644\u0637\u0628\u0642\u0627\u062A ({visible} \u0645\u0646 {total} \u0638\u0627\u0647\u0631\u0629)",
      close: "\u0625\u063A\u0644\u0627\u0642",
      showAll: "\u0625\u0638\u0647\u0627\u0631 \u0627\u0644\u0643\u0644",
      hideAll: "\u0625\u062E\u0641\u0627\u0621 \u0627\u0644\u0643\u0644",
      none: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0637\u0628\u0642\u0627\u062A \u0641\u064A \u0647\u0630\u0627 \u0627\u0644\u0645\u062E\u0637\u0637.",
      list: "\u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u0637\u0628\u0642\u0627\u062A",
      unnamed: "(\u0628\u0644\u0627 \u0627\u0633\u0645)",
      shapes: "\u0627\u0644\u0639\u0646\u0627\u0635\u0631: {count}"
    },
    measure: {
      first: "\u0627\u0646\u0642\u0631 \u0639\u0644\u0649 \u0627\u0644\u0646\u0642\u0637\u0629 \u0627\u0644\u0623\u0648\u0644\u0649\u060C \u0623\u0648 \u062D\u0631\u0651\u0643 \u0639\u0644\u0627\u0645\u0629 \u0627\u0644\u062A\u0635\u0648\u064A\u0628 \u0628\u0645\u0641\u0627\u062A\u064A\u062D \u0627\u0644\u0623\u0633\u0647\u0645 \u062B\u0645 \u0627\u0636\u063A\u0637 Enter.",
      second: "\u0627\u0646\u0642\u0631 \u0639\u0644\u0649 \u0627\u0644\u0646\u0642\u0637\u0629 \u0627\u0644\u062B\u0627\u0646\u064A\u0629.",
      distance: "\u0627\u0644\u0645\u0633\u0627\u0641\u0629:",
      unitless: "\u0648\u062D\u062F\u0627\u062A"
    }
  },
  compare: {
    open: "\u0645\u0642\u0627\u0631\u0646\u0629",
    menu: "\u0645\u0642\u0627\u0631\u0646\u0629 \u0645\u0639 \u0646\u0633\u062E\u0629 \u0623\u062E\u0631\u0649",
    menuItem: "\u0645\u0639 \u0627\u0644\u0645\u0631\u0627\u062C\u0639\u0629 {index} \xB7 {date}",
    exit: "\u0645\u063A\u0627\u062F\u0631\u0629 \u0627\u0644\u0645\u0642\u0627\u0631\u0646\u0629",
    invalid: "\u0627\u062E\u062A\u0631 \u0646\u0633\u062E\u062A\u064A\u0646 \u0645\u062E\u062A\u0644\u0641\u062A\u064A\u0646 \u0645\u0646 \u0647\u0630\u0647 \u0627\u0644\u0648\u062B\u064A\u0642\u0629 \u0644\u0645\u0642\u0627\u0631\u0646\u062A\u0647\u0645\u0627.",
    olderPicker: "\u0627\u0644\u0646\u0633\u062E\u0629 \u0627\u0644\u0623\u0642\u062F\u0645",
    newerPicker: "\u0627\u0644\u0646\u0633\u062E\u0629 \u0627\u0644\u0623\u062D\u062F\u062B",
    toolbar: "\u0623\u062F\u0648\u0627\u062A \u0627\u0644\u0645\u0642\u0627\u0631\u0646\u0629",
    modes: {
      label: "\u0648\u0636\u0639 \u0627\u0644\u0645\u0642\u0627\u0631\u0646\u0629",
      side: "\u062C\u0646\u0628\u064B\u0627 \u0625\u0644\u0649 \u062C\u0646\u0628",
      overlay: "\u062A\u0631\u0627\u0643\u0628"
    },
    region: "\u0627\u0644\u0645\u0642\u0627\u0631\u0646\u0629: {title}",
    older: "\u0627\u0644\u0623\u0642\u062F\u0645",
    newer: "\u0627\u0644\u0623\u062D\u062F\u062B",
    caption: "\u0627\u0644\u0645\u0631\u0627\u062C\u0639\u0629 {index} ({kind})",
    page: {
      missing: "\u0644\u064A\u0633\u062A \u0641\u064A \u0647\u0630\u0647 \u0627\u0644\u0646\u0633\u062E\u0629 \u0635\u0641\u062D\u0629 {page}.",
      failed: "\u062A\u0639\u0630\u0651\u0631 \u0639\u0631\u0636 \u0627\u0644\u0635\u0641\u062D\u0629 {page}."
    },
    differencesOnly: "\u0627\u0644\u0627\u062E\u062A\u0644\u0627\u0641\u0627\u062A \u0641\u0642\u0637",
    overlay: {
      caption: "\u062A\u0631\u0627\u0643\u0628 \u0627\u0644\u0645\u0631\u0627\u062C\u0639\u062A\u064A\u0646 {older} \u0648{newer}",
      alt: "\u0627\u0644\u0627\u062E\u062A\u0644\u0627\u0641\u0627\u062A \u0628\u064A\u0646 \u0627\u0644\u0645\u0631\u0627\u062C\u0639\u0629 {older} \u0648\u0627\u0644\u0645\u0631\u0627\u062C\u0639\u0629 {newer}\u060C \u0627\u0644\u0635\u0641\u062D\u0629 {page}",
      computing: "\u062C\u0627\u0631\u064D \u062D\u0633\u0627\u0628 \u0627\u0644\u0627\u062E\u062A\u0644\u0627\u0641\u0627\u062A\u2026",
      failed: "\u062A\u0639\u0630\u0651\u0631 \u062D\u0633\u0627\u0628 \u0627\u0644\u0645\u0642\u0627\u0631\u0646\u0629 \u0644\u0647\u0630\u0647 \u0627\u0644\u0635\u0641\u062D\u0629. \u0627\u0633\u062A\u062E\u062F\u0645 \u0648\u0636\u0639 \u062C\u0646\u0628\u064B\u0627 \u0625\u0644\u0649 \u062C\u0646\u0628.",
      none: "\u0644\u0627 \u064A\u0648\u062C\u062F \u0627\u062E\u062A\u0644\u0627\u0641 \u0638\u0627\u0647\u0631 \u0628\u064A\u0646 \u0627\u0644\u0645\u0631\u0627\u062C\u0639\u062A\u064A\u0646 \u0641\u064A \u0647\u0630\u0647 \u0627\u0644\u0635\u0641\u062D\u0629.",
      changed: "\u0627\u062E\u062A\u0644\u0627\u0641\u0627\u062A \u0638\u0627\u0647\u0631\u0629: \u062A\u063A\u064A\u0651\u0631 {percent}% \u0645\u0646 \u062D\u0628\u0631 \u0647\u0630\u0647 \u0627\u0644\u0635\u0641\u062D\u0629.",
      onlyIn: "\u0627\u0644\u0635\u0641\u062D\u0629 {page} \u0645\u0648\u062C\u0648\u062F\u0629 \u0641\u064A \u0627\u0644\u0645\u0631\u0627\u062C\u0639\u0629 {index} \u0641\u0642\u0637."
    },
    legend: {
      title: "\u0645\u0641\u062A\u0627\u062D \u0627\u0644\u062A\u0631\u0627\u0643\u0628",
      older: "\u0641\u064A \u0627\u0644\u0645\u0631\u0627\u062C\u0639\u0629 {index} \u0641\u0642\u0637",
      newer: "\u0641\u064A \u0627\u0644\u0645\u0631\u0627\u062C\u0639\u0629 {index} \u0641\u0642\u0637",
      both: "\u0641\u064A \u0627\u0644\u0627\u062B\u0646\u062A\u064A\u0646",
      olderStyle: "\u0628\u0631\u062A\u0642\u0627\u0644\u064A\u060C \u062A\u062E\u0637\u064A\u0637 \u0645\u0627\u0626\u0644",
      newerStyle: "\u0623\u0632\u0631\u0642\u060C \u0646\u0642\u0627\u0637",
      bothStyle: "\u0631\u0645\u0627\u062F\u064A\u060C \u0645\u0635\u0645\u062A"
    },
    states: {
      loading: "\u062C\u0627\u0631\u064D \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0645\u0631\u0627\u062C\u0639\u0629 {index}\u2026",
      preparing: "\u062C\u0627\u0631\u064D \u062A\u062C\u0647\u064A\u0632 \u0645\u0639\u0627\u064A\u0646\u0629 \u0627\u0644\u0645\u0631\u0627\u062C\u0639\u0629 {index}\u2026",
      none: {
        title: "\u0644\u0627 \u064A\u0645\u0643\u0646 \u0645\u0642\u0627\u0631\u0646\u0629 \u0627\u0644\u0645\u0631\u0627\u062C\u0639\u0629 {index}",
        body: "\u064A\u0645\u0643\u0646 \u0645\u0642\u0627\u0631\u0646\u0629 \u0645\u0644\u0641\u0627\u062A PDF \u0648\u0627\u0644\u0635\u0648\u0631 \u0641\u0642\u0637 \u0628\u0635\u0631\u064A\u064B\u0627."
      },
      failed: {
        title: "\u062A\u0639\u0630\u0651\u0631 \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0645\u0631\u0627\u062C\u0639\u0629 {index}",
        body: "\u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629 \u0628\u0639\u062F \u0642\u0644\u064A\u0644."
      },
      unavailable: {
        title: "\u0627\u0644\u0645\u0631\u0627\u062C\u0639\u0629 {index} \u063A\u064A\u0631 \u0645\u062A\u0627\u062D\u0629 \u0644\u0644\u0639\u0631\u0636 \u0628\u0639\u062F",
        body: "\u0633\u062A\u0645\u0643\u0646 \u0645\u0642\u0627\u0631\u0646\u062A\u0647\u0627 \u0628\u0639\u062F \u0627\u0646\u062A\u0647\u0627\u0621 \u0641\u062D\u0635\u0647\u0627."
      }
    }
  }
};

// locales/en/viewer.json
var viewer_default2 = {
  page: {
    back: "Back to files",
    loading: "Loading the document\u2026",
    loadFailedTitle: "Can't open this document",
    loadFailedBody: "Try again in a moment. If the problem continues, contact a project manager.",
    notFoundTitle: "Document not found",
    notFoundBody: "This document doesn't exist or you don't have access to it.",
    noSpaceTitle: "The file space isn't ready yet",
    noSpaceBody: "This project's documents will be available once its internal space has been created.",
    noVersionTitle: "This document has no version to view yet",
    noVersionBody: "A version will appear here once its check is complete."
  },
  header: {
    version: "Document version",
    versionOption: "Revision {index} \xB7 {date}",
    versionOptionCurrent: "Revision {index} \xB7 {date} (current version)",
    noIndex: "\u2014"
  },
  download: {
    button: "Download",
    busy: "Preparing the download\u2026",
    preparing: "Preparing a copy with your name\u2026",
    denied: "Downloads are turned off in this space: you can view this document but not download it.",
    failed: "The download couldn't start. Try again in a moment."
  },
  watermark: {
    note: "This preview carries a watermark with your name, your organisation and the date."
  },
  states: {
    loadingPreview: "Loading the preview\u2026",
    preparing: {
      title: "Preparing the preview\u2026",
      body: "The file is being converted for display. This usually takes a few seconds, and the page updates by itself."
    },
    preparingWatermark: {
      title: "Preparing a copy with your name\u2026",
      body: "This copy carries your name, your organisation and the date. It will appear as soon as it is ready."
    },
    none: {
      title: "No preview for this type of file",
      body: "Download the file to open it with a suitable application.",
      bodyNoDownload: "This type of file can't be shown here, and downloads aren't allowed in this space."
    },
    failed: {
      title: "The preview couldn't be generated",
      body: "The file may be damaged. Download it to open it elsewhere, or upload a new version.",
      bodyNoDownload: "The file may be damaged. Upload a new version, or contact a project manager."
    },
    unavailable: {
      uploading: {
        title: "This file is being uploaded",
        body: "It can be viewed once the upload and the antivirus check are complete."
      },
      scanning: {
        title: "This file is being checked",
        body: "It can be viewed once the antivirus check is complete."
      },
      rejected: {
        title: "This file was rejected",
        body: "It didn't pass the security checks and can't be opened."
      }
    },
    previewFailed: {
      title: "Can't load the preview",
      body: "Try again in a moment. If the problem continues, contact a project manager."
    },
    pdfFailed: {
      title: "Can't display this PDF",
      body: "The connection was interrupted or the file is damaged. Try again, or download it."
    },
    pdfPassword: {
      title: "This PDF is password-protected",
      body: "It can't be shown here. Download it to open it with its password."
    },
    imageFailed: {
      title: "Can't display this image",
      body: "The connection was interrupted or the file is damaged. Try again, or download it."
    },
    cadInvalid: {
      title: "This drawing cannot be shown",
      body: "The preview file is not valid. Download the original drawing, or upload a new version."
    },
    cadFailed: {
      title: "The drawing could not be shown",
      body: "The connection was interrupted. Try again, or download the file."
    }
  },
  pdf: {
    document: "Document: {title}",
    keyboardHelp: "Shortcuts: Page Down and Page Up, or the right and left arrows, change page. Home and End go to the first and last page. Plus and minus zoom. Ctrl + F searches the document.",
    pageFailed: "This page couldn't be displayed.",
    pageStatus: "Page {page} of {total}",
    page: "Page {page} of {total}",
    toolbar: {
      label: "Document tools",
      showThumbnails: "Show thumbnails",
      hideThumbnails: "Hide thumbnails",
      previousPage: "Previous page",
      nextPage: "Next page",
      goToPage: "Go to page",
      of: "of",
      zoomIn: "Zoom in",
      zoomOut: "Zoom out",
      zoomValue: "Zoom: {percent}%",
      fitWidth: "Fit to width",
      fitPage: "Fit to page",
      search: "Search in the document"
    },
    thumbnails: {
      label: "Page thumbnails",
      page: "Page {page}"
    },
    search: {
      label: "Search in the document",
      input: "Search in the document",
      placeholder: "Search\u2026",
      previous: "Previous result",
      next: "Next result",
      close: "Close search",
      searching: "Searching\u2026",
      none: "No results",
      position: "Result {current} of {total}"
    }
  },
  image: {
    label: "Image: {title}",
    toolbar: "Image tools",
    keyboardHelp: "Shortcuts: arrows move the image, plus and minus zoom, 0 fits the image to the window.",
    zoomIn: "Zoom in",
    zoomOut: "Zoom out",
    zoomValue: "Zoom: {percent}%",
    fit: "Fit to window"
  },
  annotations: {
    tools: {
      label: "Annotation tools",
      select: "Select",
      rect: "Rectangle",
      cloud: "Revision cloud",
      arrow: "Arrow",
      text: "Text"
    },
    colors: {
      label: "Colour",
      red: "Red",
      orange: "Orange",
      green: "Green",
      blue: "Blue",
      black: "Black"
    },
    list: {
      show: "Show the list of annotations",
      hide: "Hide the list of annotations",
      title: "Annotations",
      filterState: "Filter by state",
      state_all: "All",
      state_open: "Open",
      state_resolved: "Resolved",
      filterOrg: "Filter by organisation",
      orgAll: "All organisations",
      loading: "Loading annotations\u2026",
      loadFailed: "The annotations could not be loaded.",
      empty: "No annotation on this version yet.",
      emptyFiltered: "No annotation matches these filters.",
      itemNumber: "Annotation {number}",
      itemPage: "Page {page}"
    },
    org: {
      own: "My organisation",
      partner: "Partner organisation"
    },
    author: {
      partner: "Partner"
    },
    state: {
      open: "Open",
      resolved: "Resolved"
    },
    label: "Annotation {number}, page {page}: {comment}",
    labelResolved: "Annotation {number}, page {page}, resolved: {comment}",
    surface: {
      corners: "Drawing area of page {page}, tool: {tool}. Arrow keys move the crosshair (hold Shift to go faster), Enter sets the first corner and then the opposite one, Escape cancels.",
      point: "Drawing area of page {page}, tool: {tool}. Arrow keys move the crosshair, Enter places the text, Escape cancels."
    },
    announce: {
      tooSmall: "The shape is too small: draw a larger area.",
      firstPoint: "First point set. Move the crosshair to the opposite corner, then press Enter.",
      cancelled: "Drawing cancelled.",
      toolActive: "Active tool: {tool}.",
      added: "Annotation added.",
      deleted: "Annotation deleted.",
      updated: "Annotation updated.",
      replied: "Reply sent.",
      resolved: "Annotation resolved.",
      reopened: "Annotation reopened."
    },
    details: {
      title: "Annotation {number} \xB7 page {page}",
      onPlan: "Text on the plan: \u201C{text}\u201D",
      resolve: "Resolve",
      reopen: "Reopen",
      edit: "Edit"
    },
    new: {
      title: "New annotation \xB7 page {page}",
      add: "Add the annotation"
    },
    fields: {
      label: {
        name: "Text shown on the plan",
        required: "Write the text to show on the plan.",
        tooLong: "This text is longer than 500 characters."
      },
      comment: {
        name: "Comment",
        hint: "Explain what needs correcting or checking.",
        required: "Write a comment.",
        tooLong: "This comment is longer than 2,000 characters."
      }
    },
    thread: {
      title: "Discussion",
      loadFailed: "The replies could not be loaded.",
      empty: "No replies yet.",
      reply: "Reply",
      replyLabel: "Your reply",
      send: "Send"
    },
    delete: {
      title: "Delete annotation {number} (page {page})?",
      body: "\u201C{comment}\u201D and its replies will be deleted."
    },
    errors: {
      generic: "The action did not go through. Try again in a moment.",
      ANNOTATION_RESOLVED: "This annotation is resolved: reopen it to edit it.",
      VERSION_NOT_AVAILABLE: "This version cannot be viewed yet, so it cannot be annotated.",
      PAGE_OUT_OF_RANGE: "This page does not exist in the document.",
      FORBIDDEN: "You are not allowed to do this on this annotation.",
      NOT_FOUND: "This annotation no longer exists. The list has been refreshed.",
      stale: "Someone else changed this annotation. It has been reloaded: repeat your action if needed."
    }
  },
  cad: {
    toolbar: {
      label: "Drawing tools",
      showLayers: "Show layers",
      hideLayers: "Hide layers",
      zoomIn: "Zoom in",
      zoomOut: "Zoom out",
      zoomValue: "Zoom: {percent}%",
      fit: "Fit to window",
      measure: "Measure a distance",
      clearMeasure: "Clear the measurement"
    },
    viewport: "Drawing area: {title}",
    drawing: "Drawing: {title}",
    truncated: "Partial preview: the drawing is too large to be shown in full.",
    keyboardHelp: "Shortcuts: the arrow keys move the drawing, plus and minus zoom, 0 fits the drawing to the window. With the Measure tool, the arrow keys move the crosshair, Enter places a point (two points give the distance) and Escape clears the measurement.",
    layers: {
      region: "Drawing layers",
      title: "Layers ({visible} of {total} shown)",
      close: "Close",
      showAll: "Show all",
      hideAll: "Hide all",
      none: "This drawing has no layers.",
      list: "List of layers",
      unnamed: "(unnamed)",
      shapes: "Shapes: {count}"
    },
    measure: {
      first: "Click the first point, or move the crosshair with the arrow keys and press Enter.",
      second: "Click the second point.",
      distance: "Distance:",
      unitless: "units"
    }
  },
  compare: {
    open: "Compare",
    menu: "Compare with another version",
    menuItem: "With revision {index} \xB7 {date}",
    exit: "Leave the comparison",
    invalid: "Choose two different versions of this document to compare them.",
    olderPicker: "Older version",
    newerPicker: "Newer version",
    toolbar: "Comparison tools",
    modes: {
      label: "Comparison mode",
      side: "Side by side",
      overlay: "Overlay"
    },
    region: "Comparison: {title}",
    older: "older",
    newer: "newer",
    caption: "Revision {index} ({kind})",
    page: {
      missing: "This version has no page {page}.",
      failed: "Page {page} could not be shown."
    },
    differencesOnly: "Differences only",
    overlay: {
      caption: "Overlay of revisions {older} and {newer}",
      alt: "Differences between revision {older} and revision {newer}, page {page}",
      computing: "Computing the differences\u2026",
      failed: "The comparison could not be computed for this page. Use the side by side mode.",
      none: "No visible difference between the two revisions on this page.",
      changed: "Visible differences: {percent}% of the ink on this page has changed.",
      onlyIn: "Page {page} exists only in revision {index}."
    },
    legend: {
      title: "Overlay legend",
      older: "Only in revision {index}",
      newer: "Only in revision {index}",
      both: "In both",
      olderStyle: "orange, hatched",
      newerStyle: "blue, dotted",
      bothStyle: "grey, solid"
    },
    states: {
      loading: "Loading revision {index}\u2026",
      preparing: "Preparing the preview of revision {index}\u2026",
      none: {
        title: "Revision {index} cannot be compared",
        body: "Only PDFs and images can be compared visually."
      },
      failed: {
        title: "Revision {index} could not be loaded",
        body: "Try again in a moment."
      },
      unavailable: {
        title: "Revision {index} cannot be opened yet",
        body: "It can be compared once its checks are finished."
      }
    }
  }
};

// locales/fr/viewer.json
var viewer_default3 = {
  page: {
    back: "Retour aux fichiers",
    loading: "Chargement du document\u2026",
    loadFailedTitle: "Impossible d'ouvrir ce document",
    loadFailedBody: "R\xE9essayez dans un instant. Si le probl\xE8me persiste, contactez un responsable du projet.",
    notFoundTitle: "Document introuvable",
    notFoundBody: "Ce document n'existe pas ou vous n'y avez pas acc\xE8s.",
    noSpaceTitle: "L'espace de fichiers n'est pas encore pr\xEAt",
    noSpaceBody: "Les documents de ce projet seront disponibles d\xE8s que son espace interne aura \xE9t\xE9 cr\xE9\xE9.",
    noVersionTitle: "Ce document n'a pas encore de version consultable",
    noVersionBody: "Une version appara\xEEtra ici d\xE8s que son analyse sera termin\xE9e."
  },
  header: {
    version: "Version du document",
    versionOption: "Indice {index} \xB7 {date}",
    versionOptionCurrent: "Indice {index} \xB7 {date} (version actuelle)",
    noIndex: "\u2014"
  },
  download: {
    button: "T\xE9l\xE9charger",
    busy: "Pr\xE9paration du t\xE9l\xE9chargement\u2026",
    preparing: "Pr\xE9paration d'une copie \xE0 votre nom\u2026",
    denied: "Le t\xE9l\xE9chargement est d\xE9sactiv\xE9 dans cet espace\xA0: vous pouvez consulter ce document, pas le t\xE9l\xE9charger.",
    failed: "Le t\xE9l\xE9chargement n'a pas pu d\xE9marrer. R\xE9essayez dans un instant."
  },
  watermark: {
    note: "Cet aper\xE7u porte un filigrane \xE0 votre nom, avec celui de votre organisation et la date."
  },
  states: {
    loadingPreview: "Chargement de l'aper\xE7u\u2026",
    preparing: {
      title: "Pr\xE9paration de l'aper\xE7u\u2026",
      body: "Le fichier est converti pour l'affichage. Cela prend en g\xE9n\xE9ral quelques secondes, la page se met \xE0 jour toute seule."
    },
    preparingWatermark: {
      title: "Pr\xE9paration d'une copie \xE0 votre nom\u2026",
      body: "Cette copie porte votre nom, celui de votre organisation et la date. Elle s'affichera d\xE8s qu'elle sera pr\xEAte."
    },
    none: {
      title: "Aucun aper\xE7u pour ce type de fichier",
      body: "T\xE9l\xE9chargez le fichier pour l'ouvrir avec une application adapt\xE9e.",
      bodyNoDownload: "Ce type de fichier ne peut pas \xEAtre affich\xE9 ici, et le t\xE9l\xE9chargement n'est pas autoris\xE9 dans cet espace."
    },
    failed: {
      title: "L'aper\xE7u n'a pas pu \xEAtre g\xE9n\xE9r\xE9",
      body: "Le fichier est peut-\xEAtre endommag\xE9. T\xE9l\xE9chargez-le pour l'ouvrir ailleurs, ou envoyez une nouvelle version.",
      bodyNoDownload: "Le fichier est peut-\xEAtre endommag\xE9. Envoyez une nouvelle version, ou contactez un responsable du projet."
    },
    unavailable: {
      uploading: {
        title: "Ce fichier est en cours d'envoi",
        body: "Il sera consultable d\xE8s que l'envoi et l'analyse antivirus seront termin\xE9s."
      },
      scanning: {
        title: "Ce fichier est en cours de v\xE9rification",
        body: "Il sera consultable d\xE8s que l'analyse antivirus sera termin\xE9e."
      },
      rejected: {
        title: "Ce fichier a \xE9t\xE9 refus\xE9",
        body: "Il n'a pas pass\xE9 les contr\xF4les de s\xE9curit\xE9 et ne peut pas \xEAtre ouvert."
      }
    },
    previewFailed: {
      title: "Impossible de charger l'aper\xE7u",
      body: "R\xE9essayez dans un instant. Si le probl\xE8me persiste, contactez un responsable du projet."
    },
    pdfFailed: {
      title: "Impossible d'afficher ce PDF",
      body: "La connexion a \xE9t\xE9 interrompue ou le fichier est endommag\xE9. R\xE9essayez, ou t\xE9l\xE9chargez-le."
    },
    pdfPassword: {
      title: "Ce PDF est prot\xE9g\xE9 par un mot de passe",
      body: "Il ne peut pas \xEAtre affich\xE9 ici. T\xE9l\xE9chargez-le pour l'ouvrir avec son mot de passe."
    },
    imageFailed: {
      title: "Impossible d'afficher cette image",
      body: "La connexion a \xE9t\xE9 interrompue ou le fichier est endommag\xE9. R\xE9essayez, ou t\xE9l\xE9chargez-le."
    },
    cadInvalid: {
      title: "Ce plan ne peut pas \xEAtre affich\xE9",
      body: "Le fichier d'aper\xE7u est invalide. T\xE9l\xE9chargez le plan d'origine, ou envoyez une nouvelle version."
    },
    cadFailed: {
      title: "Impossible d'afficher ce plan",
      body: "La connexion a \xE9t\xE9 interrompue. R\xE9essayez, ou t\xE9l\xE9chargez le fichier."
    }
  },
  pdf: {
    document: "Document\xA0: {title}",
    keyboardHelp: "Raccourcis\xA0: Page suivante et Page pr\xE9c\xE9dente, ou fl\xE8ches gauche et droite, changent de page. D\xE9but et Fin vont \xE0 la premi\xE8re et \xE0 la derni\xE8re page. Plus et moins zooment. Ctrl + F recherche dans le document.",
    pageFailed: "Cette page n'a pas pu \xEAtre affich\xE9e.",
    pageStatus: "Page {page} sur {total}",
    page: "Page {page} sur {total}",
    toolbar: {
      label: "Outils du document",
      showThumbnails: "Afficher les miniatures",
      hideThumbnails: "Masquer les miniatures",
      previousPage: "Page pr\xE9c\xE9dente",
      nextPage: "Page suivante",
      goToPage: "Aller \xE0 la page",
      of: "sur",
      zoomIn: "Zoom avant",
      zoomOut: "Zoom arri\xE8re",
      zoomValue: "Zoom\xA0: {percent}\xA0%",
      fitWidth: "Ajuster \xE0 la largeur",
      fitPage: "Ajuster \xE0 la page",
      search: "Rechercher dans le document"
    },
    thumbnails: {
      label: "Miniatures des pages",
      page: "Page {page}"
    },
    search: {
      label: "Recherche dans le document",
      input: "Rechercher dans le document",
      placeholder: "Rechercher\u2026",
      previous: "R\xE9sultat pr\xE9c\xE9dent",
      next: "R\xE9sultat suivant",
      close: "Fermer la recherche",
      searching: "Recherche en cours\u2026",
      none: "Aucun r\xE9sultat",
      position: "R\xE9sultat {current} sur {total}"
    }
  },
  image: {
    label: "Image\xA0: {title}",
    toolbar: "Outils de l'image",
    keyboardHelp: "Raccourcis\xA0: les fl\xE8ches d\xE9placent l'image, plus et moins zooment, 0 ajuste l'image \xE0 la fen\xEAtre.",
    zoomIn: "Zoom avant",
    zoomOut: "Zoom arri\xE8re",
    zoomValue: "Zoom\xA0: {percent}\xA0%",
    fit: "Ajuster \xE0 la fen\xEAtre"
  },
  annotations: {
    tools: {
      label: "Outils d'annotation",
      select: "S\xE9lectionner",
      rect: "Rectangle",
      cloud: "Nuage de r\xE9vision",
      arrow: "Fl\xE8che",
      text: "Texte"
    },
    colors: {
      label: "Couleur",
      red: "Rouge",
      orange: "Orange",
      green: "Vert",
      blue: "Bleu",
      black: "Noir"
    },
    list: {
      show: "Afficher la liste des annotations",
      hide: "Masquer la liste des annotations",
      title: "Annotations",
      filterState: "Filtrer par \xE9tat",
      state_all: "Toutes",
      state_open: "Ouvertes",
      state_resolved: "R\xE9solues",
      filterOrg: "Filtrer par organisation",
      orgAll: "Toutes les organisations",
      loading: "Chargement des annotations\u2026",
      loadFailed: "Les annotations n'ont pas pu \xEAtre charg\xE9es.",
      empty: "Aucune annotation sur cette version pour le moment.",
      emptyFiltered: "Aucune annotation ne correspond \xE0 ces filtres.",
      itemNumber: "Annotation {number}",
      itemPage: "Page {page}"
    },
    org: {
      own: "Mon organisation",
      partner: "Organisation partenaire"
    },
    author: {
      partner: "Partenaire"
    },
    state: {
      open: "Ouverte",
      resolved: "R\xE9solue"
    },
    label: "Annotation {number}, page {page}\xA0: {comment}",
    labelResolved: "Annotation {number}, page {page}, r\xE9solue\xA0: {comment}",
    surface: {
      corners: "Zone de dessin de la page {page}, outil\xA0: {tool}. Les fl\xE8ches d\xE9placent le r\xE9ticule (Maj pour aller plus vite), Entr\xE9e pose le premier coin puis le coin oppos\xE9, \xC9chap annule.",
      point: "Zone de dessin de la page {page}, outil\xA0: {tool}. Les fl\xE8ches d\xE9placent le r\xE9ticule, Entr\xE9e place le texte, \xC9chap annule."
    },
    announce: {
      tooSmall: "La forme est trop petite\xA0: tracez une zone plus grande.",
      firstPoint: "Premier point pos\xE9. D\xE9placez le r\xE9ticule vers le coin oppos\xE9, puis appuyez sur Entr\xE9e.",
      cancelled: "Dessin annul\xE9.",
      toolActive: "Outil actif\xA0: {tool}.",
      added: "Annotation ajout\xE9e.",
      deleted: "Annotation supprim\xE9e.",
      updated: "Annotation modifi\xE9e.",
      replied: "R\xE9ponse envoy\xE9e.",
      resolved: "Annotation r\xE9solue.",
      reopened: "Annotation rouverte."
    },
    details: {
      title: "Annotation {number} \xB7 page {page}",
      onPlan: "Texte sur le plan\xA0: \xAB\xA0{text}\xA0\xBB",
      resolve: "R\xE9soudre",
      reopen: "Rouvrir",
      edit: "Modifier"
    },
    new: {
      title: "Nouvelle annotation \xB7 page {page}",
      add: "Ajouter l'annotation"
    },
    fields: {
      label: {
        name: "Texte affich\xE9 sur le plan",
        required: "\xC9crivez le texte \xE0 afficher sur le plan.",
        tooLong: "Ce texte d\xE9passe 500\xA0caract\xE8res."
      },
      comment: {
        name: "Commentaire",
        hint: "Expliquez ce qu'il faut corriger ou v\xE9rifier.",
        required: "\xC9crivez un commentaire.",
        tooLong: "Ce commentaire d\xE9passe 2\xA0000\xA0caract\xE8res."
      }
    },
    thread: {
      title: "\xC9changes",
      loadFailed: "Les r\xE9ponses n'ont pas pu \xEAtre charg\xE9es.",
      empty: "Aucune r\xE9ponse pour le moment.",
      reply: "R\xE9pondre",
      replyLabel: "Votre r\xE9ponse",
      send: "Envoyer"
    },
    delete: {
      title: "Supprimer l'annotation {number} (page {page})\xA0?",
      body: "\xAB\xA0{comment}\xA0\xBB et ses r\xE9ponses seront supprim\xE9es."
    },
    errors: {
      generic: "L'action n'a pas abouti. R\xE9essayez dans un instant.",
      ANNOTATION_RESOLVED: "Cette annotation est r\xE9solue\xA0: rouvrez-la pour la modifier.",
      VERSION_NOT_AVAILABLE: "Cette version n'est pas encore consultable\xA0: elle ne peut pas \xEAtre annot\xE9e.",
      PAGE_OUT_OF_RANGE: "Cette page n'existe pas dans le document.",
      FORBIDDEN: "Vous n'avez pas l'autorisation d'effectuer cette action sur cette annotation.",
      NOT_FOUND: "Cette annotation n'existe plus. La liste a \xE9t\xE9 mise \xE0 jour.",
      stale: "Cette annotation a \xE9t\xE9 modifi\xE9e par quelqu'un d'autre. Elle a \xE9t\xE9 recharg\xE9e\xA0: reprenez votre action si besoin."
    }
  },
  cad: {
    toolbar: {
      label: "Outils du plan",
      showLayers: "Afficher les calques",
      hideLayers: "Masquer les calques",
      zoomIn: "Zoom avant",
      zoomOut: "Zoom arri\xE8re",
      zoomValue: "Zoom\xA0: {percent}\xA0%",
      fit: "Ajuster \xE0 la fen\xEAtre",
      measure: "Mesurer une distance",
      clearMeasure: "Effacer la mesure"
    },
    viewport: "Zone du plan\xA0: {title}",
    drawing: "Dessin\xA0: {title}",
    truncated: "Aper\xE7u partiel\xA0: le dessin est trop grand pour \xEAtre affich\xE9 en entier.",
    keyboardHelp: "Raccourcis\xA0: les fl\xE8ches d\xE9placent le plan, plus et moins zooment, 0 ajuste le plan \xE0 la fen\xEAtre. Avec l'outil Mesurer, les fl\xE8ches d\xE9placent le r\xE9ticule, Entr\xE9e pose un point (deux points donnent la distance), \xC9chap efface la mesure.",
    layers: {
      region: "Calques du plan",
      title: "Calques ({visible} sur {total} affich\xE9s)",
      close: "Fermer",
      showAll: "Tout afficher",
      hideAll: "Tout masquer",
      none: "Ce plan n'a pas de calques.",
      list: "Liste des calques",
      unnamed: "(sans nom)",
      shapes: "\xC9l\xE9ments\xA0: {count}"
    },
    measure: {
      first: "Cliquez sur le premier point, ou placez le r\xE9ticule avec les fl\xE8ches puis appuyez sur Entr\xE9e.",
      second: "Cliquez sur le second point.",
      distance: "Distance\xA0:",
      unitless: "unit\xE9s"
    }
  },
  compare: {
    open: "Comparer",
    menu: "Comparer avec une autre version",
    menuItem: "Avec l'indice {index} \xB7 {date}",
    exit: "Quitter la comparaison",
    invalid: "Choisissez deux versions diff\xE9rentes de ce document pour les comparer.",
    olderPicker: "Version la plus ancienne",
    newerPicker: "Version la plus r\xE9cente",
    toolbar: "Outils de comparaison",
    modes: {
      label: "Mode de comparaison",
      side: "C\xF4te \xE0 c\xF4te",
      overlay: "Superposition"
    },
    region: "Comparaison\xA0: {title}",
    older: "plus ancien",
    newer: "plus r\xE9cent",
    caption: "Indice {index} ({kind})",
    page: {
      missing: "Cette version n'a pas de page {page}.",
      failed: "La page {page} n'a pas pu \xEAtre affich\xE9e."
    },
    differencesOnly: "Diff\xE9rences seulement",
    overlay: {
      caption: "Superposition des indices {older} et {newer}",
      alt: "Diff\xE9rences entre l'indice {older} et l'indice {newer}, page {page}",
      computing: "Calcul des diff\xE9rences\u2026",
      failed: "La comparaison n'a pas pu \xEAtre calcul\xE9e pour cette page. Utilisez le mode c\xF4te \xE0 c\xF4te.",
      none: "Aucune diff\xE9rence visible entre les deux indices sur cette page.",
      changed: "Diff\xE9rences visibles\xA0: {percent}\xA0% de l'encre de cette page a chang\xE9.",
      onlyIn: "La page {page} n'existe que dans l'indice {index}."
    },
    legend: {
      title: "L\xE9gende de la superposition",
      older: "Seulement dans l'indice {index}",
      newer: "Seulement dans l'indice {index}",
      both: "Dans les deux",
      olderStyle: "orange, hachures",
      newerStyle: "bleu, points",
      bothStyle: "gris, plein"
    },
    states: {
      loading: "Chargement de l'indice {index}\u2026",
      preparing: "Pr\xE9paration de l'aper\xE7u de l'indice {index}\u2026",
      none: {
        title: "L'indice {index} ne peut pas \xEAtre compar\xE9",
        body: "Seuls les PDF et les images peuvent \xEAtre compar\xE9s visuellement."
      },
      failed: {
        title: "Impossible de charger l'indice {index}",
        body: "R\xE9essayez dans un instant."
      },
      unavailable: {
        title: "L'indice {index} n'est pas encore consultable",
        body: "Il pourra \xEAtre compar\xE9 d\xE8s que son analyse sera termin\xE9e."
      }
    }
  }
};

// locales/ar/search.json
var search_default = {
  title: "\u0627\u0644\u0628\u062D\u062B",
  input: {
    label: "\u0627\u0644\u0628\u062D\u062B \u0641\u064A \u0627\u0644\u0645\u0624\u0633\u0633\u0629",
    placeholder: "\u0627\u0628\u062D\u062B \u0639\u0646 \u0645\u0634\u0627\u0631\u064A\u0639 \u0623\u0648 \u0645\u0633\u062A\u0646\u062F\u0627\u062A \u0623\u0648 \u0645\u0647\u0627\u0645 \u0623\u0648 \u0639\u0645\u0644\u0627\u0621\u2026"
  },
  kinds: {
    projects: "\u0627\u0644\u0645\u0634\u0627\u0631\u064A\u0639",
    documents: "\u0627\u0644\u0645\u0633\u062A\u0646\u062F\u0627\u062A",
    tasks: "\u0627\u0644\u0645\u0647\u0627\u0645",
    clients: "\u0627\u0644\u0639\u0645\u0644\u0627\u0621",
    messages: "\u0627\u0644\u0631\u0633\u0627\u0626\u0644"
  },
  hit: {
    match: "\u062A\u0637\u0627\u0628\u0642"
  },
  seeMore: {
    projects: "\u0639\u0631\u0636 \u0643\u0644 \u0627\u0644\u0645\u0634\u0627\u0631\u064A\u0639",
    documents: "\u0639\u0631\u0636 \u0643\u0644 \u0627\u0644\u0645\u0633\u062A\u0646\u062F\u0627\u062A",
    tasks: "\u0639\u0631\u0636 \u0643\u0644 \u0627\u0644\u0645\u0647\u0627\u0645",
    clients: "\u0639\u0631\u0636 \u0643\u0644 \u0627\u0644\u0639\u0645\u0644\u0627\u0621",
    messages: "\u0639\u0631\u0636 \u0643\u0644 \u0627\u0644\u0631\u0633\u0627\u0626\u0644"
  },
  seeAll: "\u0639\u0631\u0636 \u0643\u0644 \u0627\u0644\u0646\u062A\u0627\u0626\u062C \u0639\u0646 \xAB{q}\xBB",
  results: {
    label: "\u0646\u062A\u0627\u0626\u062C \u0627\u0644\u0628\u062D\u062B",
    count: "{count, plural, zero {\u0644\u0627 \u062A\u0648\u062C\u062F \u0646\u062A\u0627\u0626\u062C} one {\u0646\u062A\u064A\u062C\u0629 \u0648\u0627\u062D\u062F\u0629} two {\u0646\u062A\u064A\u062C\u062A\u0627\u0646} few {# \u0646\u062A\u0627\u0626\u062C} many {# \u0646\u062A\u064A\u062C\u0629} other {# \u0646\u062A\u064A\u062C\u0629}}"
  },
  states: {
    prompt: "\u0627\u0643\u062A\u0628 \u062D\u0631\u0641\u064A\u0646 \u0639\u0644\u0649 \u0627\u0644\u0623\u0642\u0644 \u0644\u0628\u062F\u0621 \u0627\u0644\u0628\u062D\u062B.",
    tooShort: "\u0627\u0643\u062A\u0628 \u062D\u0631\u0641\u064A\u0646 \u0639\u0644\u0649 \u0627\u0644\u0623\u0642\u0644.",
    loading: "\u062C\u0627\u0631\u064D \u0627\u0644\u0628\u062D\u062B\u2026",
    emptyTitle: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0646\u062A\u0627\u0626\u062C \u0639\u0646 \xAB{q}\xBB",
    emptyBody: "\u062A\u062D\u0642\u0642 \u0645\u0646 \u0627\u0644\u0625\u0645\u0644\u0627\u0621 \u0623\u0648 \u062C\u0631\u0651\u0628 \u0643\u0644\u0645\u0629 \u0623\u062E\u0631\u0649.",
    rateLimited: "\u0639\u0645\u0644\u064A\u0627\u062A \u0628\u062D\u062B \u0643\u062B\u064A\u0631\u0629\u060C \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629 \u0628\u0639\u062F \u0642\u0644\u064A\u0644.",
    failed: "\u062A\u0639\u0630\u0651\u0631 \u0625\u062C\u0631\u0627\u0621 \u0627\u0644\u0628\u062D\u062B. \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629."
  },
  page: {
    title: "\u0646\u062A\u0627\u0626\u062C \u0627\u0644\u0628\u062D\u062B",
    inputLabel: "\u0628\u062D\u062B\u0643",
    scopeLabel: "\u0646\u0648\u0639 \u0627\u0644\u0646\u062A\u0627\u0626\u062C",
    hasMore: "\u062A\u0648\u062C\u062F \u0646\u062A\u0627\u0626\u062C \u0623\u062E\u0631\u0649: \u062D\u062F\u0651\u062F \u0628\u062D\u062B\u0643 \u0623\u0643\u062B\u0631.",
    summary: "\u0646\u062A\u0627\u0626\u062C \u0627\u0644\u0628\u062D\u062B \u0639\u0646 \xAB{q}\xBB"
  },
  scopes: {
    all: "\u0627\u0644\u0643\u0644",
    projects: "\u0627\u0644\u0645\u0634\u0627\u0631\u064A\u0639",
    documents: "\u0627\u0644\u0645\u0633\u062A\u0646\u062F\u0627\u062A",
    tasks: "\u0627\u0644\u0645\u0647\u0627\u0645",
    clients: "\u0627\u0644\u0639\u0645\u0644\u0627\u0621"
  }
};

// locales/en/search.json
var search_default2 = {
  title: "Search",
  input: {
    label: "Search the organisation",
    placeholder: "Search projects, documents, tasks, clients\u2026"
  },
  kinds: {
    projects: "Projects",
    documents: "Documents",
    tasks: "Tasks",
    clients: "Clients",
    messages: "Messages"
  },
  hit: {
    match: "match"
  },
  seeMore: {
    projects: "See all projects",
    documents: "See all documents",
    tasks: "See all tasks",
    clients: "See all clients",
    messages: "See all messages"
  },
  seeAll: "See all results for \u201C{q}\u201D",
  results: {
    label: "Search results",
    count: "{count, plural, one {# result} other {# results}}"
  },
  states: {
    prompt: "Type at least 2 characters to start searching.",
    tooShort: "Type at least 2 characters.",
    loading: "Searching\u2026",
    emptyTitle: "No results for \u201C{q}\u201D",
    emptyBody: "Check the spelling or try another word.",
    rateLimited: "Too many searches, try again in a moment.",
    failed: "The search did not complete. Try again."
  },
  page: {
    title: "Search results",
    inputLabel: "Your search",
    scopeLabel: "Result type",
    hasMore: "More results: refine your search.",
    summary: "Results for \u201C{q}\u201D"
  },
  scopes: {
    all: "All",
    projects: "Projects",
    documents: "Documents",
    tasks: "Tasks",
    clients: "Clients"
  }
};

// locales/fr/search.json
var search_default3 = {
  title: "Recherche",
  input: {
    label: "Rechercher dans l'organisation",
    placeholder: "Rechercher des projets, documents, t\xE2ches, clients\u2026"
  },
  kinds: {
    projects: "Projets",
    documents: "Documents",
    tasks: "T\xE2ches",
    clients: "Clients",
    messages: "Messages"
  },
  hit: {
    match: "correspondance"
  },
  seeMore: {
    projects: "Voir tous les projets",
    documents: "Voir tous les documents",
    tasks: "Voir toutes les t\xE2ches",
    clients: "Voir tous les clients",
    messages: "Voir tous les messages"
  },
  seeAll: "Voir tous les r\xE9sultats pour \xAB\xA0{q}\xA0\xBB",
  results: {
    label: "R\xE9sultats de la recherche",
    count: "{count, plural, one {# r\xE9sultat} other {# r\xE9sultats}}"
  },
  states: {
    prompt: "Saisissez au moins 2 caract\xE8res pour lancer la recherche.",
    tooShort: "Saisissez au moins 2 caract\xE8res.",
    loading: "Recherche en cours\u2026",
    emptyTitle: "Aucun r\xE9sultat pour \xAB\xA0{q}\xA0\xBB",
    emptyBody: "V\xE9rifiez l'orthographe ou essayez un autre mot.",
    rateLimited: "Trop de recherches, r\xE9essayez dans un instant.",
    failed: "La recherche n'a pas abouti. R\xE9essayez."
  },
  page: {
    title: "R\xE9sultats de la recherche",
    inputLabel: "Votre recherche",
    scopeLabel: "Type de r\xE9sultats",
    hasMore: "Plus de r\xE9sultats\xA0: affinez votre recherche.",
    summary: "R\xE9sultats pour \xAB\xA0{q}\xA0\xBB"
  },
  scopes: {
    all: "Tout",
    projects: "Projets",
    documents: "Documents",
    tasks: "T\xE2ches",
    clients: "Clients"
  }
};

// locales/ar/chat.json
var chat_default = {
  title: "\u0627\u0644\u0645\u062D\u0627\u062F\u062B\u0627\u062A",
  list: {
    label: "\u0627\u0644\u0645\u062D\u0627\u062F\u062B\u0627\u062A \u0648\u0627\u0644\u0642\u0646\u0648\u0627\u062A",
    discussions: "\u0627\u0644\u0646\u0642\u0627\u0634\u0627\u062A",
    projects: "\u0627\u0644\u0645\u0634\u0627\u0631\u064A\u0639",
    emptyDiscussions: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0646\u0642\u0627\u0634\u0627\u062A \u062D\u0627\u0644\u064A\u064B\u0627. \u0627\u0628\u062F\u0623 \u0645\u062D\u0627\u062F\u062B\u0629 \u0645\u0639 \u0632\u0645\u064A\u0644.",
    emptyProjects: "\u0623\u0646\u062A \u0644\u0627 \u062A\u0634\u0627\u0631\u0643 \u0641\u064A \u0623\u064A \u0645\u0634\u0631\u0648\u0639.",
    loadFailed: "\u062A\u0639\u0630\u0651\u0631 \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0645\u062D\u0627\u062F\u062B\u0627\u062A. \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629 \u0628\u0639\u062F \u0642\u0644\u064A\u0644.",
    noChannels: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0642\u0646\u0648\u0627\u062A \u0641\u064A \u0647\u0630\u0627 \u0627\u0644\u0645\u0634\u0631\u0648\u0639.",
    unread: "{count, plural, one {\u0631\u0633\u0627\u0644\u0629 \u0648\u0627\u062D\u062F\u0629 \u063A\u064A\u0631 \u0645\u0642\u0631\u0648\u0621\u0629} two {\u0631\u0633\u0627\u0644\u062A\u0627\u0646 \u063A\u064A\u0631 \u0645\u0642\u0631\u0648\u0621\u062A\u064A\u0646} few {# \u0631\u0633\u0627\u0626\u0644 \u063A\u064A\u0631 \u0645\u0642\u0631\u0648\u0621\u0629} many {# \u0631\u0633\u0627\u0644\u0629 \u063A\u064A\u0631 \u0645\u0642\u0631\u0648\u0621\u0629} other {# \u0631\u0633\u0627\u0644\u0629 \u063A\u064A\u0631 \u0645\u0642\u0631\u0648\u0621\u0629}}",
    newConversation: "\u0645\u062D\u0627\u062F\u062B\u0629 \u062C\u062F\u064A\u062F\u0629",
    newChannelIn: "\u0642\u0646\u0627\u0629 \u062C\u062F\u064A\u062F\u0629 \u0641\u064A {project}"
  },
  channel: {
    unknownPerson: "\u0645\u062D\u0627\u062F\u062B\u0629 \u062E\u0627\u0635\u0629",
    unnamed: "\u0642\u0646\u0627\u0629 \u0628\u0644\u0627 \u0627\u0633\u0645"
  },
  conversation: {
    label: "\u0631\u0633\u0627\u0626\u0644 {channel}",
    today: "\u0627\u0644\u064A\u0648\u0645",
    yesterday: "\u0623\u0645\u0633",
    newMessage: "\u0631\u0633\u0627\u0644\u0629 \u062C\u062F\u064A\u062F\u0629 \u0645\u0646 {author}",
    people: "{count, plural, one {\u0634\u062E\u0635 \u0648\u0627\u062D\u062F} two {\u0634\u062E\u0635\u0627\u0646} few {# \u0623\u0634\u062E\u0627\u0635} many {# \u0634\u062E\u0635\u064B\u0627} other {# \u0634\u062E\u0635}}",
    loadFailed: "\u062A\u0639\u0630\u0651\u0631 \u062A\u062D\u0645\u064A\u0644 \u0647\u0630\u0647 \u0627\u0644\u0645\u062D\u0627\u062F\u062B\u0629. \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629.",
    messagesFailed: "\u062A\u0639\u0630\u0651\u0631 \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0631\u0633\u0627\u0626\u0644. \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629.",
    empty: {
      title: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0631\u0633\u0627\u0626\u0644 \u0628\u0639\u062F",
      description: "\u0627\u0643\u062A\u0628 \u0623\u0648\u0644 \u0631\u0633\u0627\u0644\u0629 \u0641\u064A \u0647\u0630\u0647 \u0627\u0644\u0645\u062D\u0627\u062F\u062B\u0629."
    },
    loadingOlder: "\u062C\u0627\u0631\u064D \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0631\u0633\u0627\u0626\u0644 \u0627\u0644\u0633\u0627\u0628\u0642\u0629\u2026",
    jumpToLatest: "\u0623\u062D\u062F\u062B \u0627\u0644\u0631\u0633\u0627\u0626\u0644",
    archivedNotice: "\u0647\u0630\u0647 \u0627\u0644\u0642\u0646\u0627\u0629 \u0645\u0624\u0631\u0634\u0641\u0629: \u064A\u0645\u0643\u0646\u0643 \u0642\u0631\u0627\u0621\u062A\u0647\u0627 \u0644\u0643\u0646 \u0644\u0627 \u064A\u0645\u0643\u0646\u0643 \u0627\u0644\u0643\u062A\u0627\u0628\u0629 \u0641\u064A\u0647\u0627.",
    readOnlyNotice: "\u064A\u0645\u0643\u0646\u0643 \u0642\u0631\u0627\u0621\u0629 \u0647\u0630\u0647 \u0627\u0644\u0645\u062D\u0627\u062F\u062B\u0629 \u0644\u0643\u0646 \u0644\u0627 \u064A\u0645\u0643\u0646\u0643 \u0627\u0644\u0643\u062A\u0627\u0628\u0629 \u0641\u064A\u0647\u0627.",
    unavailable: {
      title: "\u0627\u0644\u0645\u062D\u0627\u062F\u062B\u0629 \u063A\u064A\u0631 \u0645\u0648\u062C\u0648\u062F\u0629",
      description: "\u0647\u0630\u0647 \u0627\u0644\u0645\u062D\u0627\u062F\u062B\u0629 \u0644\u0645 \u062A\u0639\u062F \u0645\u0648\u062C\u0648\u062F\u0629 \u0623\u0648 \u0644\u0627 \u062A\u0645\u0644\u0643 \u0635\u0644\u0627\u062D\u064A\u0629 \u0627\u0644\u0648\u0635\u0648\u0644 \u0625\u0644\u064A\u0647\u0627.",
      back: "\u0627\u0644\u0639\u0648\u062F\u0629 \u0625\u0644\u0649 \u0627\u0644\u0645\u062D\u0627\u062F\u062B\u0627\u062A"
    }
  },
  message: {
    deleted: "\u062A\u0645 \u062D\u0630\u0641 \u0647\u0630\u0647 \u0627\u0644\u0631\u0633\u0627\u0644\u0629.",
    edited: "\u0645\u0639\u062F\u0651\u0644\u0629",
    external: "\u062E\u0627\u0631\u062C\u064A",
    externalFrom: "\u062E\u0627\u0631\u062C\u064A \xB7 {organisation}",
    actions: "\u0625\u062C\u0631\u0627\u0621\u0627\u062A \u0639\u0644\u0649 \u0631\u0633\u0627\u0644\u0629 {author}",
    edit: "\u062A\u0639\u062F\u064A\u0644 \u0627\u0644\u0631\u0633\u0627\u0644\u0629",
    delete: "\u062D\u0630\u0641 \u0627\u0644\u0631\u0633\u0627\u0644\u0629",
    editLabel: "\u062A\u0639\u062F\u064A\u0644 \u0631\u0633\u0627\u0644\u062A\u0643",
    pending: "\u062C\u0627\u0631\u064D \u0627\u0644\u0625\u0631\u0633\u0627\u0644\u2026",
    failed: "\u0644\u0645 \u062A\u064F\u0631\u0633\u0644 \u0627\u0644\u0631\u0633\u0627\u0644\u0629.",
    retry: "\u0625\u0639\u0627\u062F\u0629 \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629",
    restore: "\u0627\u0633\u062A\u0631\u062C\u0627\u0639 \u0627\u0644\u0646\u0635",
    discard: "\u062D\u0630\u0641",
    deleteTitle: "\u062D\u0630\u0641 \u0631\u0633\u0627\u0644\u0629 {author}\u061F",
    deleteBody: "\u0633\u062A\u064F\u0633\u062A\u0628\u062F\u0644 \u0627\u0644\u0631\u0633\u0627\u0644\u0629 \u0628\u0639\u0628\u0627\u0631\u0629 \xAB\u062A\u0645 \u062D\u0630\u0641 \u0647\u0630\u0647 \u0627\u0644\u0631\u0633\u0627\u0644\u0629\xBB \u0644\u0644\u062C\u0645\u064A\u0639. \u0644\u0627 \u064A\u0645\u0643\u0646 \u0627\u0644\u062A\u0631\u0627\u062C\u0639 \u0639\u0646 \u0647\u0630\u0627 \u0627\u0644\u0625\u062C\u0631\u0627\u0621.",
    replyInThread: "\u0627\u0644\u0631\u062F \u0641\u064A \u0633\u0644\u0633\u0644\u0629",
    pinnedBadge: "\u0645\u062B\u0628\u0651\u062A\u0629"
  },
  composer: {
    label: "\u0627\u0643\u062A\u0628 \u0631\u0633\u0627\u0644\u0629",
    placeholder: "\u0627\u0643\u062A\u0628 \u0631\u0633\u0627\u0644\u0629\u2026",
    send: "\u0625\u0631\u0633\u0627\u0644",
    hint: "\u0627\u0636\u063A\u0637 Enter \u0644\u0644\u0625\u0631\u0633\u0627\u0644\u060C \u0648Shift+Enter \u0644\u0633\u0637\u0631 \u062C\u062F\u064A\u062F\u060C \u0648@ \u0644\u0644\u0625\u0634\u0627\u0631\u0629 \u0625\u0644\u0649 \u0634\u062E\u0635.",
    dismiss: "\u0625\u063A\u0644\u0627\u0642",
    restoreBusy: "\u0623\u0631\u0633\u0644 \u0627\u0644\u0631\u0633\u0627\u0644\u0629 \u0642\u064A\u062F \u0627\u0644\u0643\u062A\u0627\u0628\u0629 \u0623\u0648 \u0627\u0645\u0633\u062D\u0647\u0627 \u0623\u0648\u0644\u064B\u0627 \u062B\u0645 \u0627\u0633\u062A\u0631\u062C\u0639 \u0627\u0644\u0646\u0635."
  },
  errors: {
    network: "\u064A\u0628\u062F\u0648 \u0623\u0646 \u0627\u0644\u0627\u062A\u0635\u0627\u0644 \u0645\u0646\u0642\u0637\u0639: \u0644\u0645 \u062A\u064F\u0631\u0633\u0644 \u0627\u0644\u0631\u0633\u0627\u0644\u0629.",
    FORBIDDEN: "\u0644\u064A\u0633\u062A \u0644\u062F\u064A\u0643 \u0635\u0644\u0627\u062D\u064A\u0629 \u0627\u0644\u0643\u062A\u0627\u0628\u0629 \u0641\u064A \u0647\u0630\u0647 \u0627\u0644\u0645\u062D\u0627\u062F\u062B\u0629.",
    NOT_FOUND: "\u0647\u0630\u0647 \u0627\u0644\u0645\u062D\u0627\u062F\u062B\u0629 \u0644\u0645 \u062A\u0639\u062F \u0645\u0648\u062C\u0648\u062F\u0629 \u0623\u0648 \u0644\u0645 \u062A\u0639\u062F \u062A\u0645\u0644\u0643 \u0635\u0644\u0627\u062D\u064A\u0629 \u0627\u0644\u0648\u0635\u0648\u0644 \u0625\u0644\u064A\u0647\u0627.",
    RATE_LIMITED: "\u062A\u0643\u062A\u0628 \u0628\u0633\u0631\u0639\u0629 \u0643\u0628\u064A\u0631\u0629. \u0627\u0646\u062A\u0638\u0631 \u0628\u0636\u0639 \u062B\u0648\u0627\u0646\u064D \u062B\u0645 \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629.",
    CHANNEL_ARCHIVED: "\u0647\u0630\u0647 \u0627\u0644\u0642\u0646\u0627\u0629 \u0645\u0624\u0631\u0634\u0641\u0629. \u064A\u062C\u0628 \u0625\u0639\u0627\u062F\u0629 \u0641\u062A\u062D\u0647\u0627 \u0644\u0644\u0643\u062A\u0627\u0628\u0629 \u0641\u064A\u0647\u0627 \u0645\u0646 \u062C\u062F\u064A\u062F.",
    CHANNEL_NAME_TAKEN: "\u062A\u0648\u062C\u062F \u0647\u0646\u0627 \u0642\u0646\u0627\u0629 \u0628\u0647\u0630\u0627 \u0627\u0644\u0627\u0633\u0645. \u0627\u062E\u062A\u0631 \u0627\u0633\u0645\u064B\u0627 \u0622\u062E\u0631.",
    STALE_VERSION: "\u0639\u062F\u0651\u0644 \u0634\u062E\u0635 \u0622\u062E\u0631 \u0647\u0630\u0647 \u0627\u0644\u0631\u0633\u0627\u0644\u0629. \u0623\u064F\u0639\u064A\u062F \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0645\u062D\u0627\u062F\u062B\u0629: \u062A\u062D\u0642\u0651\u0642 \u062B\u0645 \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629.",
    MESSAGE_EMPTY: "\u0627\u0643\u062A\u0628 \u0631\u0633\u0627\u0644\u0629 \u0623\u0648 \u0623\u0631\u0641\u0642 \u0645\u0644\u0641\u064B\u0627 \u0642\u0628\u0644 \u0627\u0644\u0625\u0631\u0633\u0627\u0644.",
    THREAD_ROOT_INVALID: "\u0644\u0627 \u064A\u0645\u0643\u0646 \u0627\u0644\u0631\u062F \u0639\u0644\u0649 \u0647\u0630\u0647 \u0627\u0644\u0631\u0633\u0627\u0644\u0629: \u0625\u0645\u0627 \u062D\u064F\u0630\u0641\u062A \u0623\u0648 \u0623\u0646\u0647\u0627 \u0631\u062F\u0651 \u0628\u0627\u0644\u0641\u0639\u0644.",
    ATTACHMENT_NOT_FOUND: "\u0623\u062D\u062F \u0627\u0644\u0645\u0644\u0641\u0627\u062A \u0627\u0644\u0645\u0631\u0641\u0642\u0629 \u0644\u0645 \u064A\u0639\u062F \u0645\u0648\u062C\u0648\u062F\u064B\u0627 \u0623\u0648 \u0644\u0627 \u064A\u0645\u0643\u0646\u0643 \u0641\u062A\u062D\u0647.",
    ATTACHMENT_NOT_AVAILABLE: "\u0623\u062D\u062F \u0627\u0644\u0645\u0644\u0641\u0627\u062A \u0627\u0644\u0645\u0631\u0641\u0642\u0629 \u0631\u064F\u0641\u0636 \u0623\u0648 \u0644\u0645 \u064A\u0635\u0644 \u0628\u0639\u062F. \u0623\u0631\u0641\u0642\u0647 \u0645\u0646 \u062C\u062F\u064A\u062F.",
    PIN_LIMIT_REACHED: "\u062A\u0636\u0645 \u0647\u0630\u0647 \u0627\u0644\u0645\u062D\u0627\u062F\u062B\u0629 50 \u0631\u0633\u0627\u0644\u0629 \u0645\u062B\u0628\u0651\u062A\u0629. \u0623\u0644\u063A\u0650 \u062A\u062B\u0628\u064A\u062A \u0631\u0633\u0627\u0644\u0629 \u0642\u0628\u0644 \u0625\u0636\u0627\u0641\u0629 \u0623\u062E\u0631\u0649.",
    MESSAGE_DELETED: "\u062A\u0645 \u062D\u0630\u0641 \u0647\u0630\u0647 \u0627\u0644\u0631\u0633\u0627\u0644\u0629.",
    reaction: "\u062A\u0639\u0630\u0651\u0631 \u062D\u0641\u0638 \u0627\u0644\u062A\u0641\u0627\u0639\u0644. \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629.",
    pin: "\u062A\u0639\u0630\u0651\u0631 \u062A\u063A\u064A\u064A\u0631 \u0627\u0644\u062A\u062B\u0628\u064A\u062A. \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629."
  },
  empty: {
    title: "\u0627\u062E\u062A\u0631 \u0645\u062D\u0627\u062F\u062B\u0629",
    description: "\u0627\u062E\u062A\u0631 \u0645\u062D\u0627\u062F\u062B\u0629 \u0623\u0648 \u0642\u0646\u0627\u0629 \u0645\u0646 \u0627\u0644\u0642\u0627\u0626\u0645\u0629\u060C \u0623\u0648 \u0627\u0628\u062F\u0623 \u0645\u062D\u0627\u062F\u062B\u0629 \u062C\u062F\u064A\u062F\u0629 \u0645\u0639 \u0632\u0645\u064A\u0644."
  },
  newConversation: {
    title: "\u0645\u062D\u0627\u062F\u062B\u0629 \u062C\u062F\u064A\u062F\u0629",
    intro: "\u0627\u062E\u062A\u0631 \u0632\u0645\u064A\u0644\u064B\u0627 \u0644\u0645\u062D\u0627\u062F\u062B\u0629 \u062E\u0627\u0635\u0629\u060C \u0623\u0648 \u0639\u062F\u0629 \u0632\u0645\u0644\u0627\u0621 \u0644\u0625\u0646\u0634\u0627\u0621 \u0645\u062C\u0645\u0648\u0639\u0629.",
    people: "\u0627\u0644\u0623\u0634\u062E\u0627\u0635",
    peopleHint: "\u0634\u062E\u0635 \u0648\u0627\u062D\u062F: \u0645\u062D\u0627\u062F\u062B\u0629 \u062E\u0627\u0635\u0629. \u0639\u062F\u0629 \u0623\u0634\u062E\u0627\u0635: \u0645\u062C\u0645\u0648\u0639\u0629.",
    name: "\u0627\u0633\u0645 \u0627\u0644\u0645\u062C\u0645\u0648\u0639\u0629",
    submit: "\u0625\u0646\u0634\u0627\u0621 \u0627\u0644\u0645\u062D\u0627\u062F\u062B\u0629",
    membersFailed: "\u062A\u0639\u0630\u0651\u0631 \u062A\u062D\u0645\u064A\u0644 \u0623\u0639\u0636\u0627\u0621 \u0645\u0643\u062A\u0628\u0643. \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629.",
    errors: {
      noPeople: "\u0627\u062E\u062A\u0631 \u0634\u062E\u0635\u064B\u0627 \u0648\u0627\u062D\u062F\u064B\u0627 \u0639\u0644\u0649 \u0627\u0644\u0623\u0642\u0644.",
      noName: "\u0623\u0639\u0637\u0650 \u0627\u0644\u0645\u062C\u0645\u0648\u0639\u0629 \u0627\u0633\u0645\u064B\u0627."
    }
  },
  newChannel: {
    title: "\u0642\u0646\u0627\u0629 \u062C\u062F\u064A\u062F\u0629 \u0641\u064A {project}",
    intro: "\u062A\u062C\u0645\u0639 \u0627\u0644\u0642\u0646\u0627\u0629 \u0646\u0642\u0627\u0634\u0627\u062A \u0645\u0648\u0636\u0648\u0639 \u0645\u0646 \u0627\u0644\u0645\u0634\u0631\u0648\u0639.",
    kind: "\u0646\u0648\u0639 \u0627\u0644\u0642\u0646\u0627\u0629",
    kinds: {
      general: "\u0639\u0627\u0645\u0629: \u0638\u0627\u0647\u0631\u0629 \u0644\u062C\u0645\u064A\u0639 \u0623\u0639\u0636\u0627\u0621 \u0627\u0644\u0645\u0634\u0631\u0648\u0639",
      discipline: "\u0627\u062E\u062A\u0635\u0627\u0635: \u0638\u0627\u0647\u0631\u0629 \u0644\u062C\u0645\u064A\u0639 \u0623\u0639\u0636\u0627\u0621 \u0627\u0644\u0645\u0634\u0631\u0648\u0639",
      private: "\u062E\u0627\u0635\u0629: \u0645\u062E\u0635\u0635\u0629 \u0644\u0644\u0623\u0634\u062E\u0627\u0635 \u0627\u0644\u0645\u062E\u062A\u0627\u0631\u064A\u0646"
    },
    name: "\u0627\u0633\u0645 \u0627\u0644\u0642\u0646\u0627\u0629",
    discipline: "\u0627\u0644\u0627\u062E\u062A\u0635\u0627\u0635",
    topic: "\u0627\u0644\u0645\u0648\u0636\u0648\u0639 (\u0627\u062E\u062A\u064A\u0627\u0631\u064A)",
    topicHint: "\u062C\u0645\u0644\u0629 \u062A\u0628\u064A\u0651\u0646 \u0645\u0648\u0636\u0648\u0639 \u0627\u0644\u0642\u0646\u0627\u0629.",
    members: "\u0623\u0639\u0636\u0627\u0621 \u0627\u0644\u0642\u0646\u0627\u0629",
    membersHint: "\u0623\u0646\u062A \u0639\u0636\u0648 \u0641\u064A\u0647\u0627 \u062A\u0644\u0642\u0627\u0626\u064A\u064B\u0627.",
    submit: "\u0625\u0646\u0634\u0627\u0621 \u0627\u0644\u0642\u0646\u0627\u0629",
    errors: {
      noName: "\u0623\u0639\u0637\u0650 \u0627\u0644\u0642\u0646\u0627\u0629 \u0627\u0633\u0645\u064B\u0627."
    }
  },
  reactions: {
    group: "\u0627\u0644\u062A\u0641\u0627\u0639\u0644\u0627\u062A",
    add: "\u0625\u0636\u0627\u0641\u0629 \u062A\u0641\u0627\u0639\u0644",
    pickerLabel: "\u0627\u062E\u062A\u064A\u0627\u0631 \u062A\u0641\u0627\u0639\u0644",
    react: "\u0627\u0644\u062A\u0641\u0627\u0639\u0644 \u0628\u0640 {emoji}",
    summary: "{emoji} {count, plural, one {\u062A\u0641\u0627\u0639\u0644 \u0648\u0627\u062D\u062F} two {\u062A\u0641\u0627\u0639\u0644\u0627\u0646} few {# \u062A\u0641\u0627\u0639\u0644\u0627\u062A} many {# \u062A\u0641\u0627\u0639\u0644\u064B\u0627} other {# \u062A\u0641\u0627\u0639\u0644}}",
    summaryMine: "{emoji} {count, plural, one {\u062A\u0641\u0627\u0639\u0644 \u0648\u0627\u062D\u062F\u060C \u0648\u0647\u0648 \u062A\u0641\u0627\u0639\u0644\u0643} two {\u062A\u0641\u0627\u0639\u0644\u0627\u0646\u060C \u0645\u0646\u0647\u0645\u0627 \u062A\u0641\u0627\u0639\u0644\u0643} few {# \u062A\u0641\u0627\u0639\u0644\u0627\u062A\u060C \u0645\u0646\u0647\u0627 \u062A\u0641\u0627\u0639\u0644\u0643} many {# \u062A\u0641\u0627\u0639\u0644\u064B\u0627\u060C \u0645\u0646\u0647\u0627 \u062A\u0641\u0627\u0639\u0644\u0643} other {# \u062A\u0641\u0627\u0639\u0644\u060C \u0645\u0646\u0647\u0627 \u062A\u0641\u0627\u0639\u0644\u0643}}"
  },
  thread: {
    title: "\u0633\u0644\u0633\u0644\u0629 \u0627\u0644\u0646\u0642\u0627\u0634",
    replies: "{count, plural, one {\u0631\u062F \u0648\u0627\u062D\u062F} two {\u0631\u062F\u0651\u0627\u0646} few {# \u0631\u062F\u0648\u062F} many {# \u0631\u062F\u064B\u0651\u0627} other {# \u0631\u062F}}",
    open: "\u0641\u062A\u062D \u0627\u0644\u0633\u0644\u0633\u0644\u0629: {replies}",
    listLabel: "\u0627\u0644\u0631\u062F\u0648\u062F \u0639\u0644\u0649 \u0631\u0633\u0627\u0644\u0629 {author}",
    empty: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0631\u062F\u0648\u062F \u0628\u0639\u062F. \u0627\u0643\u062A\u0628 \u0623\u0648\u0644 \u0631\u062F.",
    loadFailed: "\u062A\u0639\u0630\u0651\u0631 \u062A\u062D\u0645\u064A\u0644 \u0647\u0630\u0647 \u0627\u0644\u0633\u0644\u0633\u0644\u0629. \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629.",
    repliesFailed: "\u062A\u0639\u0630\u0651\u0631 \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0631\u062F\u0648\u062F. \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629.",
    loadingMore: "\u062C\u0627\u0631\u064D \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0631\u062F\u0648\u062F\u2026",
    rootDeleted: "\u062D\u064F\u0630\u0641\u062A \u0627\u0644\u0631\u0633\u0627\u0644\u0629 \u0627\u0644\u0623\u0635\u0644\u064A\u0629: \u0644\u0645 \u064A\u0639\u062F \u0628\u0627\u0644\u0625\u0645\u0643\u0627\u0646 \u0627\u0644\u0631\u062F \u0639\u0644\u064A\u0647\u0627.",
    composerLabel: "\u0627\u0644\u0631\u062F \u0641\u064A \u0627\u0644\u0633\u0644\u0633\u0644\u0629",
    placeholder: "\u0627\u0643\u062A\u0628 \u0631\u062F\u2026",
    send: "\u0631\u062F"
  },
  pins: {
    pin: "\u062A\u062B\u0628\u064A\u062A \u0627\u0644\u0631\u0633\u0627\u0644\u0629",
    unpin: "\u0625\u0644\u063A\u0627\u0621 \u062A\u062B\u0628\u064A\u062A \u0627\u0644\u0631\u0633\u0627\u0644\u0629",
    open: "\u0627\u0644\u0631\u0633\u0627\u0626\u0644 \u0627\u0644\u0645\u062B\u0628\u0651\u062A\u0629",
    openCount: "\u0627\u0644\u0631\u0633\u0627\u0626\u0644 \u0627\u0644\u0645\u062B\u0628\u0651\u062A\u0629 ({count})",
    title: "\u0627\u0644\u0631\u0633\u0627\u0626\u0644 \u0627\u0644\u0645\u062B\u0628\u0651\u062A\u0629",
    listLabel: "\u0627\u0644\u0631\u0633\u0627\u0626\u0644 \u0627\u0644\u0645\u062B\u0628\u0651\u062A\u0629 \u0641\u064A \u0647\u0630\u0647 \u0627\u0644\u0645\u062D\u0627\u062F\u062B\u0629",
    empty: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0631\u0633\u0627\u0626\u0644 \u0645\u062B\u0628\u0651\u062A\u0629. \u062B\u0628\u0651\u062A \u0631\u0633\u0627\u0644\u0629 \u0645\u0647\u0645\u0629 \u0644\u062A\u062C\u062F\u0647\u0627 \u0647\u0646\u0627.",
    loadFailed: "\u062A\u0639\u0630\u0651\u0631 \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0631\u0633\u0627\u0626\u0644 \u0627\u0644\u0645\u062B\u0628\u0651\u062A\u0629. \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629.",
    show: "\u0639\u0631\u0636 \u0641\u064A \u0627\u0644\u0645\u062D\u0627\u062F\u062B\u0629",
    showLabel: "\u0639\u0631\u0636 \u0631\u0633\u0627\u0644\u0629 {author} \u0641\u064A \u0627\u0644\u0645\u062D\u0627\u062F\u062B\u0629",
    openThread: "\u0641\u062A\u062D \u0627\u0644\u0633\u0644\u0633\u0644\u0629",
    openThreadLabel: "\u0641\u062A\u062D \u0633\u0644\u0633\u0644\u0629 \u0631\u0633\u0627\u0644\u0629 {author}",
    unpinLabel: "\u0625\u0644\u063A\u0627\u0621 \u062A\u062B\u0628\u064A\u062A \u0631\u0633\u0627\u0644\u0629 {author}"
  },
  typing: {
    one: "{name} \u064A\u0643\u062A\u0628\u2026",
    two: "{first} \u0648{second} \u064A\u0643\u062A\u0628\u0627\u0646\u2026",
    several: "\u0639\u062F\u0629 \u0623\u0634\u062E\u0627\u0635 \u064A\u0643\u062A\u0628\u0648\u0646\u2026",
    someone: "\u0634\u062E\u0635 \u0645\u0627 \u064A\u0643\u062A\u0628\u2026"
  },
  attachments: {
    attach: "\u0625\u0631\u0641\u0627\u0642 \u0645\u0644\u0641",
    listLabel: "\u0627\u0644\u0645\u0644\u0641\u0627\u062A \u0627\u0644\u0645\u0631\u0641\u0642\u0629",
    preparing: "\u062C\u0627\u0631\u064D \u062A\u062C\u0647\u064A\u0632 \u0645\u062C\u0644\u062F \u0627\u0644\u0645\u0631\u0641\u0642\u0627\u062A\u2026",
    noUpload: "\u064A\u0645\u0643\u0646\u0643 \u0641\u062A\u062D \u0645\u0644\u0641\u0627\u062A \u0647\u0630\u0647 \u0627\u0644\u0645\u062D\u0627\u062F\u062B\u0629 \u0644\u0643\u0646 \u0644\u0627 \u064A\u0645\u0643\u0646\u0643 \u0625\u0636\u0627\u0641\u0629 \u0645\u0644\u0641\u0627\u062A: \u0644\u064A\u0633\u062A \u0644\u062F\u064A\u0643 \u0635\u0644\u0627\u062D\u064A\u0629 \u0627\u0644\u0643\u062A\u0627\u0628\u0629 \u0641\u064A \u0645\u062C\u0644\u062F \u0627\u0644\u0645\u0631\u0641\u0642\u0627\u062A.",
    folderFailed: "\u062A\u0639\u0630\u0651\u0631 \u062A\u062C\u0647\u064A\u0632 \u0645\u062C\u0644\u062F \u0627\u0644\u0645\u0631\u0641\u0642\u0627\u062A. \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629.",
    waiting: "\u0644\u0627 \u062A\u0632\u0627\u0644 \u0628\u0639\u0636 \u0627\u0644\u0645\u0644\u0641\u0627\u062A \u0642\u064A\u062F \u0627\u0644\u0625\u0631\u0633\u0627\u0644: \u0627\u0646\u062A\u0638\u0631 \u0627\u0646\u062A\u0647\u0627\u0621 \u0625\u0631\u0633\u0627\u0644\u0647\u0627 \u0644\u0625\u0631\u0633\u0627\u0644 \u0627\u0644\u0631\u0633\u0627\u0644\u0629.",
    limit: "\u064A\u0645\u0643\u0646 \u0623\u0646 \u062A\u062D\u062A\u0648\u064A \u0627\u0644\u0631\u0633\u0627\u0644\u0629 \u0639\u0644\u0649 {max} \u0645\u0644\u0641\u0627\u062A \u0643\u062D\u062F \u0623\u0642\u0635\u0649.",
    pendingNames: "\u0627\u0644\u0645\u0644\u0641\u0627\u062A \u0627\u0644\u0645\u0631\u0641\u0642\u0629: {names}"
  },
  card: {
    group: "\u0627\u0644\u0645\u0644\u0641\u0627\u062A \u0627\u0644\u0645\u0631\u0641\u0642\u0629 \u0628\u0631\u0633\u0627\u0644\u0629 {author}",
    noAccess: "\u0644\u064A\u0633\u062A \u0644\u062F\u064A\u0643 \u0635\u0644\u0627\u062D\u064A\u0629 \u0627\u0644\u0648\u0635\u0648\u0644 \u0625\u0644\u0649 \u0647\u0630\u0627 \u0627\u0644\u0645\u0644\u0641",
    noAccessHint: "\u0627\u0644\u0645\u0644\u0641 \u0645\u062D\u0641\u0648\u0638 \u0641\u064A \u0645\u062C\u0644\u062F \u0644\u0627 \u064A\u0645\u0643\u0646\u0643 \u0627\u0644\u0627\u0637\u0644\u0627\u0639 \u0639\u0644\u064A\u0647. \u0627\u0637\u0644\u0628 \u0627\u0644\u0635\u0644\u0627\u062D\u064A\u0629 \u0645\u0646 \u0627\u0644\u0634\u062E\u0635 \u0627\u0644\u0630\u064A \u0623\u0631\u0633\u0644\u0647.",
    status: {
      uploading: "\u062C\u0627\u0631\u064D \u0627\u0644\u0625\u0631\u0633\u0627\u0644",
      scanning: "\u062C\u0627\u0631\u064D \u0627\u0644\u0641\u062D\u0635 \u0628\u0645\u0636\u0627\u062F \u0627\u0644\u0641\u064A\u0631\u0648\u0633\u0627\u062A",
      available: "\u0645\u062A\u0627\u062D",
      rejected: "\u0631\u0641\u0636 \u0627\u0644\u0641\u062D\u0635 \u0628\u0645\u0636\u0627\u062F \u0627\u0644\u0641\u064A\u0631\u0648\u0633\u0627\u062A \u0647\u0630\u0627 \u0627\u0644\u0645\u0644\u0641"
    },
    open: "\u0641\u062A\u062D",
    openLabel: "\u0641\u062A\u062D {name}",
    download: "\u062A\u0646\u0632\u064A\u0644",
    downloadLabel: "\u062A\u0646\u0632\u064A\u0644 {name}",
    preparing: "\u062C\u0627\u0631\u064D \u062A\u062C\u0647\u064A\u0632 \u0627\u0644\u062A\u0646\u0632\u064A\u0644\u2026",
    downloadDenied: "\u062A\u0646\u0632\u064A\u0644 \u0627\u0644\u0645\u0644\u0641\u0627\u062A \u063A\u064A\u0631 \u0645\u0633\u0645\u0648\u062D \u0628\u0647 \u0641\u064A \u0647\u0630\u0647 \u0627\u0644\u0645\u0633\u0627\u062D\u0629.",
    downloadFailed: "\u0641\u0634\u0644 \u0627\u0644\u062A\u0646\u0632\u064A\u0644. \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629."
  }
};

// locales/en/chat.json
var chat_default2 = {
  title: "Conversations",
  list: {
    label: "Conversations and channels",
    discussions: "Discussions",
    projects: "Projects",
    emptyDiscussions: "No discussions yet. Start a conversation with a colleague.",
    emptyProjects: "You are not part of any project.",
    loadFailed: "Could not load the conversations. Try again in a moment.",
    noChannels: "No channels in this project.",
    unread: "{count, plural, one {# unread message} other {# unread messages}}",
    newConversation: "New conversation",
    newChannelIn: "New channel in {project}"
  },
  channel: {
    unknownPerson: "Private conversation",
    unnamed: "Unnamed channel"
  },
  conversation: {
    label: "Messages of {channel}",
    today: "Today",
    yesterday: "Yesterday",
    newMessage: "New message from {author}",
    people: "{count, plural, one {# person} other {# people}}",
    loadFailed: "Could not load this conversation. Try again.",
    messagesFailed: "Could not load the messages. Try again.",
    empty: {
      title: "No messages yet",
      description: "Write the first message of this conversation."
    },
    loadingOlder: "Loading earlier messages\u2026",
    jumpToLatest: "Latest messages",
    archivedNotice: "This channel is archived: you can read it but no longer write in it.",
    readOnlyNotice: "You can read this conversation but not write in it.",
    unavailable: {
      title: "Conversation not found",
      description: "This conversation no longer exists or you do not have access to it.",
      back: "Back to conversations"
    }
  },
  message: {
    deleted: "This message was deleted.",
    edited: "edited",
    external: "External",
    externalFrom: "External \xB7 {organisation}",
    actions: "Actions on the message of {author}",
    edit: "Edit the message",
    delete: "Delete the message",
    editLabel: "Edit your message",
    pending: "Sending\u2026",
    failed: "Message not sent.",
    retry: "Try again",
    restore: "Put the text back",
    discard: "Delete",
    deleteTitle: "Delete the message of {author}?",
    deleteBody: 'The message will be replaced by "This message was deleted" for everyone. This cannot be undone.',
    replyInThread: "Reply in a thread",
    pinnedBadge: "Pinned"
  },
  composer: {
    label: "Write a message",
    placeholder: "Write a message\u2026",
    send: "Send",
    hint: "Enter to send, Shift+Enter for a new line, @ to mention someone.",
    dismiss: "Close",
    restoreBusy: "Send or clear the message you are typing first, then put the text back."
  },
  errors: {
    network: "The connection seems to be down: the message was not sent.",
    FORBIDDEN: "You are not allowed to write in this conversation.",
    NOT_FOUND: "This conversation no longer exists or you no longer have access to it.",
    RATE_LIMITED: "You are writing too fast. Wait a few seconds and try again.",
    CHANNEL_ARCHIVED: "This channel is archived. Reopen it to write in it again.",
    CHANNEL_NAME_TAKEN: "A channel with this name already exists here. Choose another name.",
    STALE_VERSION: "Someone else changed this message. The conversation was reloaded: check it and try again.",
    MESSAGE_EMPTY: "Write a message or attach a file before sending.",
    THREAD_ROOT_INVALID: "This message cannot receive a reply: it was deleted, or it is already a reply.",
    ATTACHMENT_NOT_FOUND: "One of the attached files no longer exists, or you are not allowed to open it.",
    ATTACHMENT_NOT_AVAILABLE: "One of the attached files was refused or has not arrived yet. Attach it again.",
    PIN_LIMIT_REACHED: "This conversation already has 50 pinned messages. Unpin one before adding another.",
    MESSAGE_DELETED: "This message was deleted.",
    reaction: "The reaction could not be saved. Try again.",
    pin: "The pin could not be changed. Try again."
  },
  empty: {
    title: "Choose a conversation",
    description: "Select a conversation or a channel in the list, or start a new conversation with a colleague."
  },
  newConversation: {
    title: "New conversation",
    intro: "Choose one colleague for a private conversation, or several to create a group.",
    people: "People",
    peopleHint: "One person: private conversation. Several people: group.",
    name: "Group name",
    submit: "Create the conversation",
    membersFailed: "Could not load the members of your office. Try again.",
    errors: {
      noPeople: "Choose at least one person.",
      noName: "Give the group a name."
    }
  },
  newChannel: {
    title: "New channel in {project}",
    intro: "A channel gathers the discussions on one topic of the project.",
    kind: "Channel type",
    kinds: {
      general: "General: visible to every member of the project",
      discipline: "Discipline: visible to every member of the project",
      private: "Private: only for the people you choose"
    },
    name: "Channel name",
    discipline: "Discipline",
    topic: "Topic (optional)",
    topicHint: "One sentence saying what the channel is about.",
    members: "Channel members",
    membersHint: "You are a member automatically.",
    submit: "Create the channel",
    errors: {
      noName: "Give the channel a name."
    }
  },
  reactions: {
    group: "Reactions",
    add: "Add a reaction",
    pickerLabel: "Choose a reaction",
    react: "React with {emoji}",
    summary: "{emoji} {count, plural, one {# reaction} other {# reactions}}",
    summaryMine: "{emoji} {count, plural, one {# reaction, yours} other {# reactions, including yours}}"
  },
  thread: {
    title: "Thread",
    replies: "{count, plural, one {# reply} other {# replies}}",
    open: "Open the thread: {replies}",
    listLabel: "Replies to the message from {author}",
    empty: "No replies yet. Write the first one.",
    loadFailed: "Could not load this thread. Try again.",
    repliesFailed: "Could not load the replies. Try again.",
    loadingMore: "Loading replies\u2026",
    rootDeleted: "The original message was deleted: it can no longer be replied to.",
    composerLabel: "Reply in the thread",
    placeholder: "Reply\u2026",
    send: "Reply"
  },
  pins: {
    pin: "Pin the message",
    unpin: "Unpin the message",
    open: "Pinned messages",
    openCount: "Pinned messages ({count})",
    title: "Pinned messages",
    listLabel: "Pinned messages of this conversation",
    empty: "No pinned messages. Pin an important message to find it here.",
    loadFailed: "Could not load the pinned messages. Try again.",
    show: "Show in the conversation",
    showLabel: "Show the message from {author} in the conversation",
    openThread: "Open the thread",
    openThreadLabel: "Open the thread of the message from {author}",
    unpinLabel: "Unpin the message from {author}"
  },
  typing: {
    one: "{name} is typing\u2026",
    two: "{first} and {second} are typing\u2026",
    several: "Several people are typing\u2026",
    someone: "Someone is typing\u2026"
  },
  attachments: {
    attach: "Attach a file",
    listLabel: "Attached files",
    preparing: "Preparing the attachments folder\u2026",
    noUpload: "You can open the files of this conversation but not add any: you do not have write access to the attachments folder.",
    folderFailed: "Could not prepare the attachments folder. Try again.",
    waiting: "Files are still being sent: wait until they are sent to send the message.",
    limit: "A message can hold at most {max} files.",
    pendingNames: "Attached files: {names}"
  },
  card: {
    group: "Files attached to the message from {author}",
    noAccess: "You do not have access to this file",
    noAccessHint: "It is kept in a folder you cannot view. Ask the person who sent it for access.",
    status: {
      uploading: "Sending",
      scanning: "Antivirus check in progress",
      available: "Available",
      rejected: "File refused by the antivirus check"
    },
    open: "Open",
    openLabel: "Open {name}",
    download: "Download",
    downloadLabel: "Download {name}",
    preparing: "Preparing the download\u2026",
    downloadDenied: "Downloading files is not allowed in this space.",
    downloadFailed: "The download failed. Try again."
  }
};

// locales/fr/chat.json
var chat_default3 = {
  title: "Conversations",
  list: {
    label: "Conversations et canaux",
    discussions: "Discussions",
    projects: "Projets",
    emptyDiscussions: "Aucune discussion pour le moment. D\xE9marrez une conversation avec un coll\xE8gue.",
    emptyProjects: "Vous ne participez \xE0 aucun projet.",
    loadFailed: "Impossible de charger les conversations. R\xE9essayez dans un instant.",
    noChannels: "Aucun canal dans ce projet.",
    unread: "{count, plural, one {# message non lu} other {# messages non lus}}",
    newConversation: "Nouvelle conversation",
    newChannelIn: "Nouveau canal dans {project}"
  },
  channel: {
    unknownPerson: "Conversation priv\xE9e",
    unnamed: "Canal sans nom"
  },
  conversation: {
    label: "Messages de {channel}",
    today: "Aujourd'hui",
    yesterday: "Hier",
    newMessage: "Nouveau message de {author}",
    people: "{count, plural, one {# personne} other {# personnes}}",
    loadFailed: "Impossible de charger cette conversation. R\xE9essayez.",
    messagesFailed: "Impossible de charger les messages. R\xE9essayez.",
    empty: {
      title: "Aucun message pour le moment",
      description: "\xC9crivez le premier message de cette conversation."
    },
    loadingOlder: "Chargement des messages pr\xE9c\xE9dents\u2026",
    jumpToLatest: "Derniers messages",
    archivedNotice: "Ce canal est archiv\xE9\xA0: vous pouvez le lire, mais plus y \xE9crire.",
    readOnlyNotice: "Vous pouvez lire cette conversation, mais pas y \xE9crire.",
    unavailable: {
      title: "Conversation introuvable",
      description: "Cette conversation n'existe plus ou vous n'y avez pas acc\xE8s.",
      back: "Retour aux conversations"
    }
  },
  message: {
    deleted: "Ce message a \xE9t\xE9 supprim\xE9.",
    edited: "modifi\xE9",
    external: "Externe",
    externalFrom: "Externe \xB7 {organisation}",
    actions: "Actions sur le message de {author}",
    edit: "Modifier le message",
    delete: "Supprimer le message",
    editLabel: "Modifier votre message",
    pending: "Envoi en cours\u2026",
    failed: "Message non envoy\xE9.",
    retry: "R\xE9essayer",
    restore: "Reprendre le texte",
    discard: "Supprimer",
    deleteTitle: "Supprimer le message de {author}\xA0?",
    deleteBody: "Le message sera remplac\xE9 par \xAB\xA0Ce message a \xE9t\xE9 supprim\xE9\xA0\xBB pour tout le monde. Cette action est d\xE9finitive.",
    replyInThread: "R\xE9pondre dans un fil",
    pinnedBadge: "\xC9pingl\xE9"
  },
  composer: {
    label: "\xC9crire un message",
    placeholder: "\xC9crire un message\u2026",
    send: "Envoyer",
    hint: "Entr\xE9e pour envoyer, Maj+Entr\xE9e pour une nouvelle ligne, @ pour mentionner quelqu'un.",
    dismiss: "Fermer",
    restoreBusy: "Envoyez ou effacez d'abord le message en cours de saisie, puis reprenez le texte."
  },
  errors: {
    network: "La connexion semble interrompue\xA0: le message n'est pas parti.",
    FORBIDDEN: "Vous n'avez pas le droit d'\xE9crire dans cette conversation.",
    NOT_FOUND: "Cette conversation n'existe plus ou vous n'y avez plus acc\xE8s.",
    RATE_LIMITED: "Vous \xE9crivez trop vite. Patientez quelques secondes puis r\xE9essayez.",
    CHANNEL_ARCHIVED: "Ce canal est archiv\xE9. Il faut le rouvrir pour y \xE9crire \xE0 nouveau.",
    CHANNEL_NAME_TAKEN: "Un canal portant ce nom existe d\xE9j\xE0 ici. Choisissez un autre nom.",
    STALE_VERSION: "Ce message a \xE9t\xE9 modifi\xE9 par quelqu'un d'autre. La conversation est recharg\xE9e\xA0: v\xE9rifiez puis recommencez.",
    MESSAGE_EMPTY: "\xC9crivez un message ou joignez un fichier avant d'envoyer.",
    THREAD_ROOT_INVALID: "Ce message ne peut pas recevoir de r\xE9ponse : il a \xE9t\xE9 supprim\xE9, ou c'est d\xE9j\xE0 une r\xE9ponse.",
    ATTACHMENT_NOT_FOUND: "Un des fichiers joints n'existe plus, ou vous n'avez pas le droit de l'ouvrir.",
    ATTACHMENT_NOT_AVAILABLE: "Un des fichiers joints a \xE9t\xE9 refus\xE9 ou n'est pas encore arriv\xE9. Joignez-le de nouveau.",
    PIN_LIMIT_REACHED: "Cette conversation compte d\xE9j\xE0 50 messages \xE9pingl\xE9s. D\xE9s\xE9pinglez-en un avant d'en ajouter.",
    MESSAGE_DELETED: "Ce message a \xE9t\xE9 supprim\xE9.",
    reaction: "La r\xE9action n'a pas pu \xEAtre enregistr\xE9e. R\xE9essayez.",
    pin: "L'\xE9pinglage n'a pas pu \xEAtre modifi\xE9. R\xE9essayez."
  },
  empty: {
    title: "Choisissez une conversation",
    description: "S\xE9lectionnez une conversation ou un canal dans la liste, ou d\xE9marrez une nouvelle conversation avec un coll\xE8gue."
  },
  newConversation: {
    title: "Nouvelle conversation",
    intro: "Choisissez un coll\xE8gue pour une conversation priv\xE9e, ou plusieurs pour cr\xE9er un groupe.",
    people: "Personnes",
    peopleHint: "Une personne\xA0: conversation priv\xE9e. Plusieurs personnes\xA0: groupe.",
    name: "Nom du groupe",
    submit: "Cr\xE9er la conversation",
    membersFailed: "Impossible de charger les membres de votre bureau. R\xE9essayez.",
    errors: {
      noPeople: "Choisissez au moins une personne.",
      noName: "Donnez un nom au groupe."
    }
  },
  newChannel: {
    title: "Nouveau canal dans {project}",
    intro: "Un canal rassemble les \xE9changes d'un sujet du projet.",
    kind: "Type de canal",
    kinds: {
      general: "G\xE9n\xE9ral\xA0: visible par tous les membres du projet",
      discipline: "Discipline\xA0: visible par tous les membres du projet",
      private: "Priv\xE9\xA0: r\xE9serv\xE9 aux personnes choisies"
    },
    name: "Nom du canal",
    discipline: "Discipline",
    topic: "Sujet (facultatif)",
    topicHint: "Une phrase pour dire de quoi parle le canal.",
    members: "Membres du canal",
    membersHint: "Vous en faites partie automatiquement.",
    submit: "Cr\xE9er le canal",
    errors: {
      noName: "Donnez un nom au canal."
    }
  },
  reactions: {
    group: "R\xE9actions",
    add: "Ajouter une r\xE9action",
    pickerLabel: "Choisir une r\xE9action",
    react: "R\xE9agir avec {emoji}",
    summary: "{emoji} {count, plural, one {# r\xE9action} other {# r\xE9actions}}",
    summaryMine: "{emoji} {count, plural, one {# r\xE9action, la v\xF4tre} other {# r\xE9actions, dont la v\xF4tre}}"
  },
  thread: {
    title: "Fil de discussion",
    replies: "{count, plural, one {# r\xE9ponse} other {# r\xE9ponses}}",
    open: "Ouvrir le fil : {replies}",
    listLabel: "R\xE9ponses au message de {author}",
    empty: "Aucune r\xE9ponse pour le moment. \xC9crivez la premi\xE8re.",
    loadFailed: "Impossible de charger ce fil. R\xE9essayez.",
    repliesFailed: "Impossible de charger les r\xE9ponses. R\xE9essayez.",
    loadingMore: "Chargement des r\xE9ponses\u2026",
    rootDeleted: "Le message d'origine a \xE9t\xE9 supprim\xE9 : il n'est plus possible d'y r\xE9pondre.",
    composerLabel: "R\xE9pondre dans le fil",
    placeholder: "R\xE9pondre\u2026",
    send: "R\xE9pondre"
  },
  pins: {
    pin: "\xC9pingler le message",
    unpin: "D\xE9s\xE9pingler le message",
    open: "Messages \xE9pingl\xE9s",
    openCount: "Messages \xE9pingl\xE9s ({count})",
    title: "Messages \xE9pingl\xE9s",
    listLabel: "Messages \xE9pingl\xE9s de cette conversation",
    empty: "Aucun message \xE9pingl\xE9. \xC9pinglez un message important pour le retrouver ici.",
    loadFailed: "Impossible de charger les messages \xE9pingl\xE9s. R\xE9essayez.",
    show: "Afficher dans la conversation",
    showLabel: "Afficher dans la conversation le message de {author}",
    openThread: "Ouvrir le fil",
    openThreadLabel: "Ouvrir le fil du message de {author}",
    unpinLabel: "D\xE9s\xE9pingler le message de {author}"
  },
  typing: {
    one: "{name} est en train d'\xE9crire\u2026",
    two: "{first} et {second} \xE9crivent\u2026",
    several: "Plusieurs personnes \xE9crivent\u2026",
    someone: "Quelqu'un est en train d'\xE9crire\u2026"
  },
  attachments: {
    attach: "Joindre un fichier",
    listLabel: "Fichiers joints",
    preparing: "Pr\xE9paration du dossier des pi\xE8ces jointes\u2026",
    noUpload: "Vous pouvez ouvrir les fichiers de cette conversation, mais pas en ajouter : le dossier des pi\xE8ces jointes ne vous est pas ouvert en \xE9criture.",
    folderFailed: "Impossible de pr\xE9parer le dossier des pi\xE8ces jointes. R\xE9essayez.",
    waiting: "Des fichiers sont encore en cours d'envoi : attendez la fin de l'envoi pour envoyer le message.",
    limit: "Un message peut contenir au plus {max} fichiers.",
    pendingNames: "Fichiers joints : {names}"
  },
  card: {
    group: "Fichiers joints au message de {author}",
    noAccess: "Vous n'avez pas acc\xE8s \xE0 ce fichier",
    noAccessHint: "Il est rang\xE9 dans un dossier que vous ne pouvez pas consulter. Demandez l'acc\xE8s \xE0 la personne qui l'a envoy\xE9.",
    status: {
      uploading: "Envoi en cours",
      scanning: "V\xE9rification antivirus en cours",
      available: "Disponible",
      rejected: "Fichier refus\xE9 par la v\xE9rification antivirus"
    },
    open: "Ouvrir",
    openLabel: "Ouvrir {name}",
    download: "T\xE9l\xE9charger",
    downloadLabel: "T\xE9l\xE9charger {name}",
    preparing: "Pr\xE9paration du t\xE9l\xE9chargement\u2026",
    downloadDenied: "Le t\xE9l\xE9chargement de fichiers n'est pas autoris\xE9 dans cet espace.",
    downloadFailed: "Le t\xE9l\xE9chargement a \xE9chou\xE9. R\xE9essayez."
  }
};

// locales/ar/calendar.json
var calendar_default = {
  title: "\u0627\u0644\u062A\u0642\u0648\u064A\u0645",
  workWeekNote: "\u064A\u0645\u062A\u062F \u0623\u0633\u0628\u0648\u0639 \u0627\u0644\u0639\u0645\u0644 \u0645\u0646 \u0627\u0644\u0625\u062B\u0646\u064A\u0646 \u0625\u0644\u0649 \u0627\u0644\u062C\u0645\u0639\u0629.",
  toolbar: {
    label: "\u0627\u0644\u062A\u0646\u0642\u0644 \u0641\u064A \u0627\u0644\u062A\u0642\u0648\u064A\u0645",
    today: "\u0627\u0644\u064A\u0648\u0645",
    newEvent: "\u062D\u062F\u062B \u062C\u062F\u064A\u062F",
    feeds: "\u0627\u0634\u062A\u0631\u0627\u0643 ICS",
    viewsLabel: "\u0639\u0631\u0636 \u0627\u0644\u062A\u0642\u0648\u064A\u0645",
    views: {
      week: "\u0623\u0633\u0628\u0648\u0639",
      workWeek: "\u0623\u0633\u0628\u0648\u0639 \u0627\u0644\u0639\u0645\u0644",
      month: "\u0634\u0647\u0631",
      agenda: "\u062C\u062F\u0648\u0644 \u0627\u0644\u0623\u0639\u0645\u0627\u0644"
    },
    previous: {
      week: "\u0627\u0644\u0623\u0633\u0628\u0648\u0639 \u0627\u0644\u0633\u0627\u0628\u0642",
      workWeek: "\u0627\u0644\u0623\u0633\u0628\u0648\u0639 \u0627\u0644\u0633\u0627\u0628\u0642",
      month: "\u0627\u0644\u0634\u0647\u0631 \u0627\u0644\u0633\u0627\u0628\u0642",
      agenda: "\u0627\u0644\u0634\u0647\u0631 \u0627\u0644\u0633\u0627\u0628\u0642"
    },
    next: {
      week: "\u0627\u0644\u0623\u0633\u0628\u0648\u0639 \u0627\u0644\u062A\u0627\u0644\u064A",
      workWeek: "\u0627\u0644\u0623\u0633\u0628\u0648\u0639 \u0627\u0644\u062A\u0627\u0644\u064A",
      month: "\u0627\u0644\u0634\u0647\u0631 \u0627\u0644\u062A\u0627\u0644\u064A",
      agenda: "\u0627\u0644\u0634\u0647\u0631 \u0627\u0644\u062A\u0627\u0644\u064A"
    }
  },
  kinds: {
    meeting: "\u0627\u062C\u062A\u0645\u0627\u0639",
    site_visit: "\u0632\u064A\u0627\u0631\u0629 \u0648\u0631\u0634\u0629",
    deadline: "\u0623\u062C\u0644",
    other: "\u0622\u062E\u0631"
  },
  legend: {
    label: "\u0623\u0646\u0648\u0627\u0639 \u0627\u0644\u0623\u062D\u062F\u0627\u062B",
    readOnly: "\u0627\u0644\u0642\u0641\u0644 \u064A\u0634\u064A\u0631 \u0625\u0644\u0649 \u0623\u062C\u0644 \u0644\u0644\u0642\u0631\u0627\u0621\u0629 \u0641\u0642\u0637 (\u0645\u0647\u0645\u0629 \u0623\u0648 \u0645\u0631\u062D\u0644\u0629 \u0623\u0648 \u062A\u0623\u0634\u064A\u0631\u0629)."
  },
  grid: {
    label: "\u0627\u0644\u062A\u0642\u0648\u064A\u0645\u060C {period}",
    allDay: "\u0637\u0648\u0627\u0644 \u0627\u0644\u064A\u0648\u0645",
    dayColumn: "\u0623\u062D\u062F\u0627\u062B \u064A\u0648\u0645 {date}",
    selectDay: "\u0627\u062E\u062A\u064A\u0627\u0631 {date}",
    monthLabel: "\u062A\u0642\u0648\u064A\u0645 \u0627\u0644\u0634\u0647\u0631\u060C {period}",
    monthDayLabel: "{date}\u060C {count, plural, =0 {\u0644\u0627 \u0623\u062D\u062F\u0627\u062B} one {\u062D\u062F\u062B \u0648\u0627\u062D\u062F} two {\u062D\u062F\u062B\u0627\u0646} few {# \u0623\u062D\u062F\u0627\u062B} many {# \u062D\u062F\u062B\u064B\u0627} other {# \u062D\u062F\u062B}}",
    moreEvents: "+{count} \u0623\u062E\u0631\u0649",
    moreEventsLabel: "\u0639\u0631\u0636 \u0627\u0644\u0623\u062D\u062F\u0627\u062B \u0627\u0644\u0640 {count} \u0627\u0644\u0623\u062E\u0631\u0649 \u0644\u064A\u0648\u0645 {date}",
    today: "\u0627\u0644\u064A\u0648\u0645"
  },
  event: {
    allDay: "\u0637\u0648\u0627\u0644 \u0627\u0644\u064A\u0648\u0645",
    readOnly: "\u0644\u0644\u0642\u0631\u0627\u0621\u0629 \u0641\u0642\u0637",
    aria: "{kind}: {title}\u060C {when}",
    ariaReadOnly: "{kind}: {title}\u060C {when}\u060C \u0644\u0644\u0642\u0631\u0627\u0621\u0629 \u0641\u0642\u0637",
    noProject: "\u0641\u0636\u0627\u0621 \u0627\u0644\u0645\u0624\u0633\u0633\u0629"
  },
  agenda: {
    label: "\u062C\u062F\u0648\u0644 \u0627\u0644\u0623\u0639\u0645\u0627\u0644\u060C {period}",
    dayHeading: "{date}",
    today: "\u0627\u0644\u064A\u0648\u0645"
  },
  mini: {
    label: "\u062A\u0642\u0648\u064A\u0645 \u0645\u0635\u063A\u0651\u0631",
    monthLabel: "\u0627\u062E\u062A\u064A\u0627\u0631 \u064A\u0648\u0645\u060C {period}",
    previous: "\u0627\u0644\u0634\u0647\u0631 \u0627\u0644\u0633\u0627\u0628\u0642",
    next: "\u0627\u0644\u0634\u0647\u0631 \u0627\u0644\u062A\u0627\u0644\u064A",
    day: "{date}\u060C {count, plural, =0 {\u0644\u0627 \u0623\u062D\u062F\u0627\u062B} one {\u062D\u062F\u062B \u0648\u0627\u062D\u062F} two {\u062D\u062F\u062B\u0627\u0646} few {# \u0623\u062D\u062F\u0627\u062B} many {# \u062D\u062F\u062B\u064B\u0627} other {# \u062D\u062F\u062B}}",
    dayToday: "{date}\u060C \u0627\u0644\u064A\u0648\u0645\u060C {count, plural, =0 {\u0644\u0627 \u0623\u062D\u062F\u0627\u062B} one {\u062D\u062F\u062B \u0648\u0627\u062D\u062F} two {\u062D\u062F\u062B\u0627\u0646} few {# \u0623\u062D\u062F\u0627\u062B} many {# \u062D\u062F\u062B\u064B\u0627} other {# \u062D\u062F\u062B}}"
  },
  filters: {
    title: "\u0639\u0648\u0627\u0645\u0644 \u0627\u0644\u062A\u0635\u0641\u064A\u0629",
    scope: "\u0627\u0644\u062A\u0642\u0648\u064A\u0645 \u0627\u0644\u0645\u0639\u0631\u0648\u0636",
    scopeOrg: "\u0647\u0630\u0647 \u0627\u0644\u0645\u0624\u0633\u0633\u0629",
    scopeAll: "\u0643\u0644 \u0645\u0624\u0633\u0633\u0627\u062A\u064A",
    kinds: "\u0623\u0646\u0648\u0627\u0639 \u0627\u0644\u0623\u062D\u062F\u0627\u062B",
    project: "\u0627\u0644\u0645\u0634\u0631\u0648\u0639",
    allProjects: "\u0643\u0644 \u0627\u0644\u0645\u0634\u0627\u0631\u064A\u0639",
    reset: "\u0639\u0631\u0636 \u0627\u0644\u0643\u0644"
  },
  states: {
    loadFailedTitle: "\u062A\u0639\u0630\u0651\u0631 \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u062A\u0642\u0648\u064A\u0645",
    loadFailedBody: "\u062A\u062D\u0642\u0642 \u0645\u0646 \u0627\u062A\u0635\u0627\u0644\u0643 \u062B\u0645 \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629.",
    emptyTitle: "\u0644\u0627 \u0623\u062D\u062F\u0627\u062B \u0641\u064A \u0647\u0630\u0647 \u0627\u0644\u0641\u062A\u0631\u0629",
    emptyDescription: "\u0623\u0646\u0634\u0626 \u062D\u062F\u062B\u064B\u0627 \u0623\u0648 \u063A\u064A\u0651\u0631 \u0627\u0644\u0641\u062A\u0631\u0629.",
    truncated: "\u0639\u062F\u062F \u0627\u0644\u0623\u062D\u062F\u0627\u062B \u0623\u0643\u0628\u0631 \u0645\u0645\u0627 \u064A\u0633\u062A\u0637\u064A\u0639 \u0627\u0644\u062A\u0642\u0648\u064A\u0645 \u0639\u0631\u0636\u0647. \u0627\u062E\u062A\u0631 \u0641\u062A\u0631\u0629 \u0623\u0642\u0635\u0631 (\u0623\u0633\u0628\u0648\u0639 \u0623\u0648 \u0634\u0647\u0631) \u0623\u0648 \u0635\u0641\u0650\u0651 \u062D\u0633\u0628 \u0627\u0644\u0645\u0634\u0631\u0648\u0639.",
    loading: "\u062C\u0627\u0631\u064D \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u062A\u0642\u0648\u064A\u0645\u2026",
    emptyReadOnly: "\u063A\u064A\u0651\u0631 \u0627\u0644\u0641\u062A\u0631\u0629 \u0644\u0631\u0624\u064A\u0629 \u0623\u062D\u062F\u0627\u062B \u0623\u062E\u0631\u0649."
  },
  details: {
    when: "\u0627\u0644\u0645\u0648\u0639\u062F",
    where: "\u0627\u0644\u0645\u0643\u0627\u0646",
    project: "\u0627\u0644\u0645\u0634\u0631\u0648\u0639",
    organisation: "\u0627\u0644\u0645\u0624\u0633\u0633\u0629",
    organiser: "\u0627\u0644\u0645\u0646\u0638\u0650\u0651\u0645",
    description: "\u0627\u0644\u0648\u0635\u0641",
    attendees: "\u0627\u0644\u0645\u0634\u0627\u0631\u0643\u0648\u0646",
    noAttendees: "\u0644\u0645 \u062A\u062A\u0645 \u062F\u0639\u0648\u0629 \u0623\u062D\u062F.",
    guest: "\u0636\u064A\u0641 \u062E\u0627\u0631\u062C\u064A",
    close: "\u0625\u063A\u0644\u0627\u0642",
    edit: "\u062A\u0639\u062F\u064A\u0644",
    delete: "\u062D\u0630\u0641",
    join: "\u0627\u0646\u0636\u0645\u0627\u0645",
    loadFailed: "\u062A\u0639\u0630\u0651\u0631 \u0639\u0631\u0636 \u0647\u0630\u0627 \u0627\u0644\u062D\u062F\u062B. \u0644\u0645 \u064A\u0639\u062F \u0645\u0648\u062C\u0648\u062F\u064B\u0627 \u0623\u0648 \u0644\u0645 \u064A\u0639\u062F \u0628\u0625\u0645\u0643\u0627\u0646\u0643 \u0627\u0644\u0648\u0635\u0648\u0644 \u0625\u0644\u064A\u0647.",
    readOnlyTitle: "\u0623\u062C\u0644 \u0644\u0644\u0642\u0631\u0627\u0621\u0629 \u0641\u0642\u0637",
    readOnlyBody: "\u0647\u0630\u0627 \u0627\u0644\u0623\u062C\u0644 \u0622\u062A\u064D \u0645\u0646 \u0645\u0647\u0645\u0629 \u0623\u0648 \u0645\u0631\u062D\u0644\u0629 \u0623\u0648 \u062A\u0623\u0634\u064A\u0631\u0629: \u0639\u062F\u0651\u0644\u0647 \u0645\u0646 \u0645\u0635\u062F\u0631\u0647.",
    openSource: {
      task: "\u0641\u062A\u062D \u0645\u0647\u0627\u0645 \u0627\u0644\u0645\u0634\u0631\u0648\u0639",
      phase: "\u0641\u062A\u062D \u0645\u0631\u0627\u062D\u0644 \u0627\u0644\u0645\u0634\u0631\u0648\u0639",
      approval: "\u0641\u062A\u062D \u062A\u0623\u0634\u064A\u0631\u0627\u062A \u0627\u0644\u0645\u0634\u0631\u0648\u0639"
    },
    responses: {
      accepted: "\u0642\u064E\u0628\u0650\u0644",
      declined: "\u0631\u0641\u0636",
      tentative: "\u0631\u0628\u0645\u0627",
      needs_action: "\u0628\u0644\u0627 \u0631\u062F\u0651"
    },
    rsvp: {
      label: "\u0631\u062F\u0651\u0643",
      accepted: "\u0642\u0628\u0648\u0644",
      tentative: "\u0631\u0628\u0645\u0627",
      declined: "\u0631\u0641\u0636",
      saved: "\u062A\u0645 \u062D\u0641\u0638 \u0631\u062F\u0651\u0643.",
      current: "\u0631\u062F\u0651\u0643 \u0627\u0644\u062D\u0627\u0644\u064A: {response}."
    },
    deleteTitle: "\u062D\u0630\u0641 \u0627\u0644\u062D\u062F\u062B \xAB{title}\xBB\u061F",
    deleteBody: "\u0644\u0646 \u064A\u0638\u0647\u0631 \u0627\u0644\u062D\u062F\u062B \u0628\u0639\u062F \u0627\u0644\u0622\u0646 \u0641\u064A \u062A\u0642\u0648\u064A\u0645 \u0627\u0644\u0645\u062F\u0639\u0648\u064A\u0646. \u0644\u0627 \u064A\u0645\u0643\u0646 \u0627\u0644\u062A\u0631\u0627\u062C\u0639 \u0639\u0646 \u0647\u0630\u0627 \u0627\u0644\u0625\u062C\u0631\u0627\u0621.",
    deleteConfirm: "\u062D\u0630\u0641",
    deleted: "\u062A\u0645 \u062D\u0630\u0641 \u0627\u0644\u062D\u062F\u062B.",
    addOnline: "\u0625\u0636\u0627\u0641\u0629 \u0627\u062C\u062A\u0645\u0627\u0639 \u0639\u0628\u0631 \u0627\u0644\u0625\u0646\u062A\u0631\u0646\u062A",
    onlineAdded: "\u062A\u0645\u062A \u0625\u0636\u0627\u0641\u0629 \u0627\u0644\u0627\u062C\u062A\u0645\u0627\u0639 \u0639\u0628\u0631 \u0627\u0644\u0625\u0646\u062A\u0631\u0646\u062A.",
    meetingLink: "\u0631\u0627\u0628\u0637 \u0627\u0644\u0627\u062C\u062A\u0645\u0627\u0639"
  },
  form: {
    createTitle: "\u062D\u062F\u062B \u062C\u062F\u064A\u062F",
    editTitle: "\u062A\u0639\u062F\u064A\u0644 \u0627\u0644\u062D\u062F\u062B",
    intro: "\u064A\u062A\u0644\u0642\u0649 \u0627\u0644\u0645\u062F\u0639\u0648\u0648\u0646 \u062A\u0630\u0643\u064A\u0631\u064B\u0627 \u0642\u0628\u0644 \u0627\u0644\u0628\u062F\u0621.",
    space: "\u0627\u0644\u0641\u0636\u0627\u0621",
    spaceHint: "\u064A\u0638\u0647\u0631 \u0627\u0644\u062D\u062F\u062B \u0644\u0644\u0623\u0634\u062E\u0627\u0635 \u0627\u0644\u0630\u064A\u0646 \u064A\u0645\u0644\u0643\u0648\u0646 \u062D\u0642 \u0627\u0644\u0648\u0635\u0648\u0644 \u0625\u0644\u0649 \u0647\u0630\u0627 \u0627\u0644\u0641\u0636\u0627\u0621.",
    spaceOrganisation: "\u0641\u0636\u0627\u0621 \u0627\u0644\u0645\u0624\u0633\u0633\u0629",
    spaceProject: "{code} \u2014 {name}",
    noSpaces: "\u0644\u0627 \u064A\u0645\u0643\u0646\u0643 \u0625\u0646\u0634\u0627\u0621 \u0623\u062D\u062F\u0627\u062B \u0641\u064A \u0623\u064A \u0641\u0636\u0627\u0621 \u062D\u0627\u0644\u064A\u064B\u0627. \u0627\u0646\u0636\u0645 \u0625\u0644\u0649 \u0645\u0634\u0631\u0648\u0639 \u0644\u0625\u0646\u0634\u0627\u0621 \u062D\u062F\u062B.",
    kind: "\u0627\u0644\u0646\u0648\u0639",
    title: "\u0627\u0644\u0639\u0646\u0648\u0627\u0646",
    allDay: "\u0637\u0648\u0627\u0644 \u0627\u0644\u064A\u0648\u0645",
    startDate: "\u0627\u0644\u0628\u062F\u0627\u064A\u0629 (\u0627\u0644\u062A\u0627\u0631\u064A\u062E)",
    startTime: "\u0627\u0644\u0628\u062F\u0627\u064A\u0629 (\u0627\u0644\u0633\u0627\u0639\u0629)",
    endDate: "\u0627\u0644\u0646\u0647\u0627\u064A\u0629 (\u0627\u0644\u062A\u0627\u0631\u064A\u062E)",
    endTime: "\u0627\u0644\u0646\u0647\u0627\u064A\u0629 (\u0627\u0644\u0633\u0627\u0639\u0629)",
    lastDay: "\u0627\u0644\u064A\u0648\u0645 \u0627\u0644\u0623\u062E\u064A\u0631",
    firstDay: "\u0627\u0644\u064A\u0648\u0645 \u0627\u0644\u0623\u0648\u0644",
    timeZone: "\u0627\u0644\u0623\u0648\u0642\u0627\u062A \u0628\u062A\u0648\u0642\u064A\u062A \u062A\u0648\u0646\u0633.",
    location: "\u0627\u0644\u0645\u0643\u0627\u0646",
    description: "\u0627\u0644\u0648\u0635\u0641",
    attendees: "\u0627\u0644\u0645\u0634\u0627\u0631\u0643\u0648\u0646",
    attendeesHint: "\u0644\u0627 \u064A\u0645\u0643\u0646 \u062F\u0639\u0648\u0629 \u0625\u0644\u0627 \u0645\u0646 \u064A\u0645\u0644\u0643 \u062D\u0642 \u0627\u0644\u0648\u0635\u0648\u0644 \u0625\u0644\u0649 \u0627\u0644\u0641\u0636\u0627\u0621. \u0623\u0646\u062A \u0645\u062F\u0639\u0648 \u062F\u0627\u0626\u0645\u064B\u0627.",
    submitCreate: "\u0625\u0646\u0634\u0627\u0621 \u0627\u0644\u062D\u062F\u062B",
    submitEdit: "\u062D\u0641\u0638",
    cancel: "\u0625\u0644\u063A\u0627\u0621",
    created: "\u062A\u0645 \u0625\u0646\u0634\u0627\u0621 \u0627\u0644\u062D\u062F\u062B.",
    saved: "\u062A\u0645 \u062D\u0641\u0638 \u0627\u0644\u062D\u062F\u062B.",
    errors: {
      title: "\u0623\u0639\u0637\u0650 \u0627\u0644\u062D\u062F\u062B \u0639\u0646\u0648\u0627\u0646\u064B\u0627.",
      space: "\u0627\u062E\u062A\u0631 \u0627\u0644\u0641\u0636\u0627\u0621 \u0627\u0644\u0630\u064A \u0633\u064A\u064F\u0646\u0634\u0623 \u0641\u064A\u0647 \u0627\u0644\u062D\u062F\u062B.",
      startDate: "\u0623\u062F\u062E\u0644 \u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0628\u062F\u0627\u064A\u0629.",
      endDate: "\u0623\u062F\u062E\u0644 \u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0646\u0647\u0627\u064A\u0629.",
      startTime: "\u0623\u062F\u062E\u0644 \u0633\u0627\u0639\u0629 \u0627\u0644\u0628\u062F\u0627\u064A\u0629.",
      endTime: "\u0623\u062F\u062E\u0644 \u0633\u0627\u0639\u0629 \u0627\u0644\u0646\u0647\u0627\u064A\u0629.",
      endBeforeStart: "\u064A\u062C\u0628 \u0623\u0646 \u062A\u0643\u0648\u0646 \u0627\u0644\u0646\u0647\u0627\u064A\u0629 \u0628\u0639\u062F \u0627\u0644\u0628\u062F\u0627\u064A\u0629.",
      tooLong: "\u0644\u0627 \u062A\u062A\u062C\u0627\u0648\u0632 \u0645\u062F\u0629 \u0627\u0644\u062D\u062F\u062B 31 \u064A\u0648\u0645\u064B\u0627.",
      nothingChanged: "\u0644\u0645 \u064A\u062A\u063A\u064A\u0631 \u0634\u064A\u0621."
    },
    online: "\u0627\u062C\u062A\u0645\u0627\u0639 BatiFlow \u0639\u0628\u0631 \u0627\u0644\u0625\u0646\u062A\u0631\u0646\u062A",
    createdWithMeeting: "\u062A\u0645 \u0625\u0646\u0634\u0627\u0621 \u0627\u0644\u062D\u062F\u062B \u0645\u0639 \u0627\u062C\u062A\u0645\u0627\u0639\u0647 \u0639\u0628\u0631 \u0627\u0644\u0625\u0646\u062A\u0631\u0646\u062A.",
    createdNoMeeting: "\u062A\u0645 \u0625\u0646\u0634\u0627\u0621 \u0627\u0644\u062D\u062F\u062B\u060C \u0644\u0643\u0646 \u062A\u0639\u0630\u0651\u0631 \u0625\u0646\u0634\u0627\u0621 \u0627\u0644\u0627\u062C\u062A\u0645\u0627\u0639 \u0639\u0628\u0631 \u0627\u0644\u0625\u0646\u062A\u0631\u0646\u062A. \u0623\u0636\u0641\u0647 \u0645\u0646 \u0627\u0644\u062D\u062F\u062B."
  },
  feeds: {
    title: "\u0627\u0644\u0627\u0634\u062A\u0631\u0627\u0643 \u0641\u064A \u062A\u0642\u0648\u064A\u0645\u0643 (ICS)",
    intro: "\u0627\u0639\u0631\u0636 \u0623\u062D\u062F\u0627\u062B BatiFlow \u0641\u064A Outlook \u0623\u0648 \u062A\u0642\u0648\u064A\u0645 Google \u0623\u0648 \u062A\u0642\u0648\u064A\u0645 Apple \u0639\u0628\u0631 \u0639\u0646\u0648\u0627\u0646 \u0627\u0634\u062A\u0631\u0627\u0643 \u062E\u0627\u0635.",
    listLabel: "\u062A\u062F\u0641\u0642\u0627\u062A \u0627\u0634\u062A\u0631\u0627\u0643\u0643",
    empty: "\u0644\u064A\u0633 \u0644\u062F\u064A\u0643 \u0623\u064A \u062A\u062F\u0641\u0642 \u0627\u0634\u062A\u0631\u0627\u0643.",
    loadFailed: "\u062A\u0639\u0630\u0651\u0631 \u062A\u062D\u0645\u064A\u0644 \u062A\u062F\u0641\u0642\u0627\u062A\u0643. \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629 \u0628\u0639\u062F \u0642\u0644\u064A\u0644.",
    item: "{label}",
    unnamed: "\u062A\u062F\u0641\u0642 \u0628\u0644\u0627 \u0627\u0633\u0645",
    details: "{organisation} \xB7 {scope} \xB7 \u0623\u064F\u0646\u0634\u0626 \u0641\u064A {date}",
    scopes: {
      visible: "\u0643\u0644 \u0645\u0627 \u062A\u0631\u0627\u0647",
      mine: "\u0645\u0627 \u064A\u062E\u0635\u0651\u0643 \u0641\u0642\u0637"
    },
    revoke: "\u0625\u0644\u063A\u0627\u0621",
    revokeLabel: "\u0625\u0644\u063A\u0627\u0621 \u0627\u0644\u062A\u062F\u0641\u0642 {name}",
    revokeTitle: "\u0625\u0644\u063A\u0627\u0621 \u0627\u0644\u062A\u062F\u0641\u0642 \xAB{name}\xBB\u061F",
    revokeBody: "\u0644\u0646 \u062A\u062A\u0644\u0642\u0649 \u0627\u0644\u062A\u0637\u0628\u064A\u0642\u0627\u062A \u0627\u0644\u0645\u0634\u062A\u0631\u0643\u0629 \u0623\u064A \u062D\u062F\u062B \u0628\u0639\u062F \u0627\u0644\u0622\u0646. \u0644\u0627 \u064A\u0645\u0643\u0646 \u0627\u0644\u062A\u0631\u0627\u062C\u0639 \u0639\u0646 \u0647\u0630\u0627 \u0627\u0644\u0625\u062C\u0631\u0627\u0621: \u0633\u062A\u062D\u062A\u0627\u062C \u0625\u0644\u0649 \u0625\u0646\u0634\u0627\u0621 \u062A\u062F\u0641\u0642 \u062C\u062F\u064A\u062F \u0648\u0627\u0644\u0627\u0634\u062A\u0631\u0627\u0643 \u0641\u064A\u0647 \u0645\u0646 \u062C\u062F\u064A\u062F.",
    revokeConfirm: "\u0625\u0644\u063A\u0627\u0621 \u0627\u0644\u062A\u062F\u0641\u0642",
    revoked: "\u062A\u0645 \u0625\u0644\u063A\u0627\u0621 \u0627\u0644\u062A\u062F\u0641\u0642.",
    newTitle: "\u0625\u0646\u0634\u0627\u0621 \u062A\u062F\u0641\u0642",
    label: "\u0627\u0633\u0645 \u0627\u0644\u062A\u062F\u0641\u0642",
    labelHint: "\u0627\u062E\u062A\u064A\u0627\u0631\u064A\u060C \u0645\u062B\u0644 \xAB\u062A\u0642\u0648\u064A\u0645 \u0647\u0627\u062A\u0641\u064A\xBB.",
    scope: "\u0645\u062D\u062A\u0648\u0649 \u0627\u0644\u062A\u062F\u0641\u0642",
    includeExternal: "\u062A\u0636\u0645\u064A\u0646 \u0623\u062D\u062F\u0627\u062B \u0627\u0644\u0641\u0636\u0627\u0621\u0627\u062A \u0627\u0644\u0645\u0634\u062A\u0631\u0643\u0629 \u0645\u0639 \u0627\u0644\u0634\u0631\u0643\u0627\u0621",
    create: "\u0625\u0646\u0634\u0627\u0621 \u0627\u0644\u062A\u062F\u0641\u0642",
    limit: "\u0628\u0644\u063A\u062A \u0627\u0644\u062D\u062F \u0627\u0644\u0623\u0642\u0635\u0649 \u0644\u0639\u062F\u062F \u0627\u0644\u062A\u062F\u0641\u0642\u0627\u062A ({max}). \u0623\u0644\u063A\u0650 \u062A\u062F\u0641\u0642\u064B\u0627 \u0644\u0625\u0646\u0634\u0627\u0621 \u0622\u062E\u0631.",
    created: {
      title: "\u0639\u0646\u0648\u0627\u0646 \u0627\u0634\u062A\u0631\u0627\u0643\u0643",
      warning: "\u064A\u064F\u0639\u0631\u0636 \u0647\u0630\u0627 \u0627\u0644\u0639\u0646\u0648\u0627\u0646 \u0645\u0631\u0629 \u0648\u0627\u062D\u062F\u0629 \u0641\u0642\u0637. \u0648\u0647\u0648 \u064A\u062A\u064A\u062D \u0627\u0644\u0648\u0635\u0648\u0644 \u0625\u0644\u0649 \u062A\u0642\u0648\u064A\u0645\u0643 \u0645\u062B\u0644 \u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631: \u0627\u0646\u0633\u062E\u0647 \u0627\u0644\u0622\u0646 \u0648\u0644\u0627 \u062A\u0634\u0627\u0631\u0643\u0647.",
      urlLabel: "\u0639\u0646\u0648\u0627\u0646 \u0627\u0644\u0627\u0634\u062A\u0631\u0627\u0643",
      copy: "\u0646\u0633\u062E \u0627\u0644\u0639\u0646\u0648\u0627\u0646",
      copied: "\u062A\u0645 \u0646\u0633\u062E \u0627\u0644\u0639\u0646\u0648\u0627\u0646.",
      copyFailed: "\u062A\u0639\u0630\u0651\u0631 \u0627\u0644\u0646\u0633\u062E: \u062D\u062F\u0651\u062F \u0627\u0644\u0639\u0646\u0648\u0627\u0646 \u0648\u0627\u0646\u0633\u062E\u0647 \u064A\u062F\u0648\u064A\u064B\u0627.",
      done: "\u0644\u0642\u062F \u0646\u0633\u062E\u062A \u0627\u0644\u0639\u0646\u0648\u0627\u0646"
    },
    close: "\u0625\u063A\u0644\u0627\u0642"
  },
  errors: {
    network: "\u062A\u0639\u0630\u0651\u0631 \u0627\u0644\u0648\u0635\u0648\u0644 \u0625\u0644\u0649 \u0627\u0644\u062A\u0642\u0648\u064A\u0645. \u062A\u062D\u0642\u0642 \u0645\u0646 \u0627\u062A\u0635\u0627\u0644\u0643 \u062B\u0645 \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629.",
    NOT_FOUND: "\u0644\u0645 \u064A\u0639\u062F \u0647\u0630\u0627 \u0627\u0644\u062D\u062F\u062B \u0645\u0648\u062C\u0648\u062F\u064B\u0627 \u0623\u0648 \u0644\u0645 \u064A\u0639\u062F \u0628\u0625\u0645\u0643\u0627\u0646\u0643 \u0627\u0644\u0648\u0635\u0648\u0644 \u0625\u0644\u064A\u0647.",
    cannotCreateHere: "\u0644\u0627 \u064A\u0645\u0643\u0646\u0643 \u0625\u0646\u0634\u0627\u0621 \u0623\u062D\u062F\u0627\u062B \u0641\u064A \u0647\u0630\u0627 \u0627\u0644\u0641\u0636\u0627\u0621. \u0627\u062E\u062A\u0631 \u0641\u0636\u0627\u0621\u064B \u064A\u0645\u0643\u0646\u0643 \u0627\u0644\u0645\u0633\u0627\u0647\u0645\u0629 \u0641\u064A\u0647.",
    EVENT_READ_ONLY: "\u0647\u0630\u0627 \u0627\u0644\u0623\u062C\u0644 \u0622\u062A\u064D \u0645\u0646 \u0645\u0647\u0645\u0629 \u0623\u0648 \u0645\u0631\u062D\u0644\u0629 \u0623\u0648 \u062A\u0623\u0634\u064A\u0631\u0629: \u0639\u062F\u0651\u0644\u0647 \u0645\u0646 \u0645\u0635\u062F\u0631\u0647."
  },
  sections: {
    label: "\u0627\u0644\u0639\u0631\u0636",
    calendar: "\u0627\u0644\u062A\u0642\u0648\u064A\u0645",
    meetings: "\u0627\u0644\u0627\u062C\u062A\u0645\u0627\u0639\u0627\u062A"
  },
  spaceTab: {
    openInCalendar: "\u0641\u062A\u062D \u0641\u064A \u0627\u0644\u062A\u0642\u0648\u064A\u0645"
  }
};

// locales/en/calendar.json
var calendar_default2 = {
  title: "Calendar",
  workWeekNote: "The work week runs from Monday to Friday.",
  toolbar: {
    label: "Calendar navigation",
    today: "Today",
    newEvent: "New event",
    feeds: "ICS subscription",
    viewsLabel: "Calendar view",
    views: {
      week: "Week",
      workWeek: "Work week",
      month: "Month",
      agenda: "Agenda"
    },
    previous: {
      week: "Previous week",
      workWeek: "Previous week",
      month: "Previous month",
      agenda: "Previous month"
    },
    next: {
      week: "Next week",
      workWeek: "Next week",
      month: "Next month",
      agenda: "Next month"
    }
  },
  kinds: {
    meeting: "Meeting",
    site_visit: "Site visit",
    deadline: "Deadline",
    other: "Other"
  },
  legend: {
    label: "Event types",
    readOnly: "The padlock marks a read-only deadline (task, phase or approval)."
  },
  grid: {
    label: "Calendar, {period}",
    allDay: "All day",
    dayColumn: "Events on {date}",
    selectDay: "Select {date}",
    monthLabel: "Month calendar, {period}",
    monthDayLabel: "{date}, {count, plural, =0 {no events} one {# event} other {# events}}",
    moreEvents: "+{count} more",
    moreEventsLabel: "Show the {count} other events on {date}",
    today: "today"
  },
  event: {
    allDay: "All day",
    readOnly: "Read-only",
    aria: "{kind}: {title}, {when}",
    ariaReadOnly: "{kind}: {title}, {when}, read-only",
    noProject: "Organisation space"
  },
  agenda: {
    label: "Agenda, {period}",
    dayHeading: "{date}",
    today: "Today"
  },
  mini: {
    label: "Mini calendar",
    monthLabel: "Choose a day, {period}",
    previous: "Previous month",
    next: "Next month",
    day: "{date}, {count, plural, =0 {no events} one {# event} other {# events}}",
    dayToday: "{date}, today, {count, plural, =0 {no events} one {# event} other {# events}}"
  },
  filters: {
    title: "Filters",
    scope: "Calendar shown",
    scopeOrg: "This organisation",
    scopeAll: "All my organisations",
    kinds: "Event types",
    project: "Project",
    allProjects: "All projects",
    reset: "Show everything"
  },
  states: {
    loadFailedTitle: "Could not load the calendar",
    loadFailedBody: "Check your connection and try again.",
    emptyTitle: "No events in this period",
    emptyDescription: "Create an event or change the period.",
    truncated: "There are more events than the calendar can show. Pick a shorter period (week or month) or filter by project.",
    loading: "Loading the calendar\u2026",
    emptyReadOnly: "Change the period to see other events."
  },
  details: {
    when: "When",
    where: "Location",
    project: "Project",
    organisation: "Organisation",
    organiser: "Organiser",
    description: "Description",
    attendees: "Attendees",
    noAttendees: "No one is invited.",
    guest: "External guest",
    close: "Close",
    edit: "Edit",
    delete: "Delete",
    join: "Join",
    loadFailed: "This event cannot be shown. It no longer exists or you no longer have access to it.",
    readOnlyTitle: "Read-only deadline",
    readOnlyBody: "This deadline comes from a task, a phase or an approval: change it at its source.",
    openSource: {
      task: "Open the project's tasks",
      phase: "Open the project's phases",
      approval: "Open the project's approvals"
    },
    responses: {
      accepted: "Accepted",
      declined: "Declined",
      tentative: "Maybe",
      needs_action: "No answer"
    },
    rsvp: {
      label: "Your answer",
      accepted: "Accept",
      tentative: "Maybe",
      declined: "Decline",
      saved: "Your answer has been saved.",
      current: "Your current answer: {response}."
    },
    deleteTitle: 'Delete the event "{title}"?',
    deleteBody: "Invited people will no longer see it in their calendar. This cannot be undone.",
    deleteConfirm: "Delete",
    deleted: "The event has been deleted.",
    addOnline: "Add an online meeting",
    onlineAdded: "Online meeting added.",
    meetingLink: "Meeting link"
  },
  form: {
    createTitle: "New event",
    editTitle: "Edit the event",
    intro: "Invited people get a reminder before it starts.",
    space: "Space",
    spaceHint: "The event is visible to the people who have access to this space.",
    spaceOrganisation: "Organisation space",
    spaceProject: "{code} \u2014 {name}",
    noSpaces: "You cannot create events in any space right now. Join a project to create one.",
    kind: "Type",
    title: "Title",
    allDay: "All day",
    startDate: "Start (date)",
    startTime: "Start (time)",
    endDate: "End (date)",
    endTime: "End (time)",
    lastDay: "Last day",
    firstDay: "First day",
    timeZone: "Times are in Tunis time.",
    location: "Location",
    description: "Description",
    attendees: "Attendees",
    attendeesHint: "Only people who have access to the space can be invited. You are always invited.",
    submitCreate: "Create the event",
    submitEdit: "Save",
    cancel: "Cancel",
    created: "The event has been created.",
    saved: "The event has been saved.",
    errors: {
      title: "Give the event a title.",
      space: "Choose the space where the event is created.",
      startDate: "Enter the start date.",
      endDate: "Enter the end date.",
      startTime: "Enter the start time.",
      endTime: "Enter the end time.",
      endBeforeStart: "The end must be after the start.",
      tooLong: "An event lasts 31 days at most.",
      nothingChanged: "Nothing has changed."
    },
    online: "BatiFlow online meeting",
    createdWithMeeting: "Event created with its online meeting.",
    createdNoMeeting: "Event created, but the online meeting could not be. Add it from the event."
  },
  feeds: {
    title: "Subscribe to your calendar (ICS)",
    intro: "Show your BatiFlow events in Outlook, Google Calendar or Apple Calendar with a private subscription address.",
    listLabel: "Your subscription feeds",
    empty: "You have no subscription feeds.",
    loadFailed: "Could not load your feeds. Try again in a moment.",
    item: "{label}",
    unnamed: "Unnamed feed",
    details: "{organisation} \xB7 {scope} \xB7 created on {date}",
    scopes: {
      visible: "Everything you can see",
      mine: "Only what concerns you"
    },
    revoke: "Revoke",
    revokeLabel: "Revoke the feed {name}",
    revokeTitle: 'Revoke the feed "{name}"?',
    revokeBody: "Subscribed apps will stop receiving events. This cannot be undone: you will need to create a new feed and subscribe again.",
    revokeConfirm: "Revoke",
    revoked: "The feed has been revoked.",
    newTitle: "Create a feed",
    label: "Feed name",
    labelHint: 'Optional, for example "My phone calendar".',
    scope: "What the feed contains",
    includeExternal: "Include events from spaces shared with partners",
    create: "Create the feed",
    limit: "You have reached the maximum number of feeds ({max}). Revoke one to create another.",
    created: {
      title: "Your subscription address",
      warning: "This address is shown only once. It gives access to your calendar, like a password: copy it now and do not share it.",
      urlLabel: "Subscription address",
      copy: "Copy the address",
      copied: "Address copied.",
      copyFailed: "Could not copy: select the address and copy it by hand.",
      done: "I have copied the address"
    },
    close: "Close"
  },
  errors: {
    network: "The calendar cannot be reached. Check your connection and try again.",
    NOT_FOUND: "This event no longer exists or you no longer have access to it.",
    cannotCreateHere: "You cannot create events in this space. Choose a space where you can contribute.",
    EVENT_READ_ONLY: "This deadline comes from a task, a phase or an approval: change it at its source."
  },
  sections: {
    label: "View",
    calendar: "Calendar",
    meetings: "Meetings"
  },
  spaceTab: {
    openInCalendar: "Open in the Calendar"
  }
};

// locales/fr/calendar.json
var calendar_default3 = {
  title: "Calendrier",
  workWeekNote: "La semaine de travail va du lundi au vendredi.",
  toolbar: {
    label: "Navigation du calendrier",
    today: "Aujourd'hui",
    newEvent: "Nouvel \xE9v\xE9nement",
    feeds: "Abonnement ICS",
    viewsLabel: "Affichage du calendrier",
    views: {
      week: "Semaine",
      workWeek: "Semaine de travail",
      month: "Mois",
      agenda: "Agenda"
    },
    previous: {
      week: "Semaine pr\xE9c\xE9dente",
      workWeek: "Semaine pr\xE9c\xE9dente",
      month: "Mois pr\xE9c\xE9dent",
      agenda: "Mois pr\xE9c\xE9dent"
    },
    next: {
      week: "Semaine suivante",
      workWeek: "Semaine suivante",
      month: "Mois suivant",
      agenda: "Mois suivant"
    }
  },
  kinds: {
    meeting: "R\xE9union",
    site_visit: "Visite de chantier",
    deadline: "\xC9ch\xE9ance",
    other: "Autre"
  },
  legend: {
    label: "Types d'\xE9v\xE9nements",
    readOnly: "Le cadenas signale une \xE9ch\xE9ance en lecture seule (t\xE2che, phase ou visa)."
  },
  grid: {
    label: "Calendrier, {period}",
    allDay: "Toute la journ\xE9e",
    dayColumn: "\xC9v\xE9nements du {date}",
    selectDay: "Choisir le {date}",
    monthLabel: "Calendrier du mois, {period}",
    monthDayLabel: "{date}, {count, plural, =0 {aucun \xE9v\xE9nement} one {# \xE9v\xE9nement} other {# \xE9v\xE9nements}}",
    moreEvents: "+{count} autres",
    moreEventsLabel: "Afficher les {count} autres \xE9v\xE9nements du {date}",
    today: "aujourd'hui"
  },
  event: {
    allDay: "Toute la journ\xE9e",
    readOnly: "Lecture seule",
    aria: "{kind}\xA0: {title}, {when}",
    ariaReadOnly: "{kind}\xA0: {title}, {when}, lecture seule",
    noProject: "Espace de l'organisation"
  },
  agenda: {
    label: "Agenda, {period}",
    dayHeading: "{date}",
    today: "Aujourd'hui"
  },
  mini: {
    label: "Mini-calendrier",
    monthLabel: "Choisir un jour, {period}",
    previous: "Mois pr\xE9c\xE9dent",
    next: "Mois suivant",
    day: "{date}, {count, plural, =0 {aucun \xE9v\xE9nement} one {# \xE9v\xE9nement} other {# \xE9v\xE9nements}}",
    dayToday: "{date}, aujourd'hui, {count, plural, =0 {aucun \xE9v\xE9nement} one {# \xE9v\xE9nement} other {# \xE9v\xE9nements}}"
  },
  filters: {
    title: "Filtres",
    scope: "Calendrier affich\xE9",
    scopeOrg: "Cette organisation",
    scopeAll: "Toutes mes organisations",
    kinds: "Types d'\xE9v\xE9nements",
    project: "Projet",
    allProjects: "Tous les projets",
    reset: "Tout afficher"
  },
  states: {
    loadFailedTitle: "Impossible de charger le calendrier",
    loadFailedBody: "V\xE9rifiez votre connexion puis r\xE9essayez.",
    emptyTitle: "Aucun \xE9v\xE9nement sur cette p\xE9riode",
    emptyDescription: "Cr\xE9ez un \xE9v\xE9nement ou changez de p\xE9riode.",
    truncated: "Il y a plus d'\xE9v\xE9nements que le calendrier ne peut en afficher. Choisissez une p\xE9riode plus courte (semaine ou mois) ou filtrez par projet.",
    loading: "Chargement du calendrier\u2026",
    emptyReadOnly: "Changez de p\xE9riode pour voir d\u2019autres \xE9v\xE9nements."
  },
  details: {
    when: "Quand",
    where: "Lieu",
    project: "Projet",
    organisation: "Organisation",
    organiser: "Organisateur",
    description: "Description",
    attendees: "Participants",
    noAttendees: "Aucun participant invit\xE9.",
    guest: "Invit\xE9 externe",
    close: "Fermer",
    edit: "Modifier",
    delete: "Supprimer",
    join: "Rejoindre",
    loadFailed: "Impossible d'afficher cet \xE9v\xE9nement. Il n'existe plus ou vous n'y avez pas acc\xE8s.",
    readOnlyTitle: "\xC9ch\xE9ance en lecture seule",
    readOnlyBody: "Cette \xE9ch\xE9ance vient d'une t\xE2che, d'une phase ou d'un visa\xA0: modifiez-la \xE0 sa source.",
    openSource: {
      task: "Ouvrir les t\xE2ches du projet",
      phase: "Ouvrir les phases du projet",
      approval: "Ouvrir les visas du projet"
    },
    responses: {
      accepted: "A accept\xE9",
      declined: "A refus\xE9",
      tentative: "Peut-\xEAtre",
      needs_action: "Sans r\xE9ponse"
    },
    rsvp: {
      label: "Votre r\xE9ponse",
      accepted: "Accepter",
      tentative: "Peut-\xEAtre",
      declined: "Refuser",
      saved: "Votre r\xE9ponse est enregistr\xE9e.",
      current: "Votre r\xE9ponse actuelle\xA0: {response}."
    },
    deleteTitle: "Supprimer l'\xE9v\xE9nement \xAB\xA0{title}\xA0\xBB\xA0?",
    deleteBody: "Les personnes invit\xE9es ne le verront plus dans leur calendrier. Cette action est d\xE9finitive.",
    deleteConfirm: "Supprimer",
    deleted: "L'\xE9v\xE9nement a \xE9t\xE9 supprim\xE9.",
    addOnline: "Ajouter une r\xE9union en ligne",
    onlineAdded: "R\xE9union en ligne ajout\xE9e.",
    meetingLink: "Lien de la r\xE9union"
  },
  form: {
    createTitle: "Nouvel \xE9v\xE9nement",
    editTitle: "Modifier l'\xE9v\xE9nement",
    intro: "Les personnes invit\xE9es re\xE7oivent un rappel avant le d\xE9but.",
    space: "Espace",
    spaceHint: "L'\xE9v\xE9nement est visible des personnes qui ont acc\xE8s \xE0 cet espace.",
    spaceOrganisation: "Espace de l'organisation",
    spaceProject: "{code} \u2014 {name}",
    noSpaces: "Vous ne pouvez cr\xE9er d'\xE9v\xE9nement dans aucun espace pour le moment. Rejoignez un projet pour en cr\xE9er un.",
    kind: "Type",
    title: "Titre",
    allDay: "Toute la journ\xE9e",
    startDate: "D\xE9but (date)",
    startTime: "D\xE9but (heure)",
    endDate: "Fin (date)",
    endTime: "Fin (heure)",
    lastDay: "Dernier jour",
    firstDay: "Premier jour",
    timeZone: "Heures en temps de Tunis.",
    location: "Lieu",
    description: "Description",
    attendees: "Participants",
    attendeesHint: "Seules les personnes qui ont acc\xE8s \xE0 l'espace peuvent \xEAtre invit\xE9es. Vous \xEAtes toujours invit\xE9.",
    submitCreate: "Cr\xE9er l'\xE9v\xE9nement",
    submitEdit: "Enregistrer",
    cancel: "Annuler",
    created: "L'\xE9v\xE9nement a \xE9t\xE9 cr\xE9\xE9.",
    saved: "L'\xE9v\xE9nement a \xE9t\xE9 enregistr\xE9.",
    errors: {
      title: "Donnez un titre \xE0 l'\xE9v\xE9nement.",
      space: "Choisissez l'espace o\xF9 cr\xE9er l'\xE9v\xE9nement.",
      startDate: "Indiquez la date de d\xE9but.",
      endDate: "Indiquez la date de fin.",
      startTime: "Indiquez l'heure de d\xE9but.",
      endTime: "Indiquez l'heure de fin.",
      endBeforeStart: "La fin doit \xEAtre apr\xE8s le d\xE9but.",
      tooLong: "Un \xE9v\xE9nement dure 31 jours au plus.",
      nothingChanged: "Rien n'a chang\xE9."
    },
    online: "R\xE9union en ligne BatiFlow",
    createdWithMeeting: "\xC9v\xE9nement cr\xE9\xE9 avec sa r\xE9union en ligne.",
    createdNoMeeting: "\xC9v\xE9nement cr\xE9\xE9, mais la r\xE9union en ligne n\u2019a pas pu l\u2019\xEAtre. Ajoutez-la depuis l\u2019\xE9v\xE9nement."
  },
  feeds: {
    title: "Abonnement \xE0 votre calendrier (ICS)",
    intro: "Affichez vos \xE9v\xE9nements BatiFlow dans Outlook, Google Agenda ou Apple Calendrier gr\xE2ce \xE0 une adresse d'abonnement priv\xE9e.",
    listLabel: "Vos flux d'abonnement",
    empty: "Vous n'avez aucun flux d'abonnement.",
    loadFailed: "Impossible de charger vos flux. R\xE9essayez dans un instant.",
    item: "{label}",
    unnamed: "Flux sans nom",
    details: "{organisation} \xB7 {scope} \xB7 cr\xE9\xE9 le {date}",
    scopes: {
      visible: "Tout ce que vous voyez",
      mine: "Seulement ce qui vous concerne"
    },
    revoke: "R\xE9voquer",
    revokeLabel: "R\xE9voquer le flux {name}",
    revokeTitle: "R\xE9voquer le flux \xAB\xA0{name}\xA0\xBB\xA0?",
    revokeBody: "Les applications abonn\xE9es ne recevront plus aucun \xE9v\xE9nement. Cette action est d\xE9finitive\xA0: il faudra cr\xE9er un nouveau flux et le r\xE9abonner.",
    revokeConfirm: "R\xE9voquer",
    revoked: "Le flux a \xE9t\xE9 r\xE9voqu\xE9.",
    newTitle: "Cr\xE9er un flux",
    label: "Nom du flux",
    labelHint: "Facultatif, par exemple \xAB\xA0Agenda de mon t\xE9l\xE9phone\xA0\xBB.",
    scope: "Contenu du flux",
    includeExternal: "Inclure les \xE9v\xE9nements des espaces partag\xE9s avec des partenaires",
    create: "Cr\xE9er le flux",
    limit: "Vous avez atteint le nombre maximal de flux ({max}). R\xE9voquez-en un pour en cr\xE9er un autre.",
    created: {
      title: "Votre adresse d'abonnement",
      warning: "Cette adresse n'est affich\xE9e qu'une seule fois. Elle donne acc\xE8s \xE0 votre calendrier, comme un mot de passe\xA0: copiez-la maintenant et ne la partagez pas.",
      urlLabel: "Adresse d'abonnement",
      copy: "Copier l'adresse",
      copied: "Adresse copi\xE9e.",
      copyFailed: "Copie impossible\xA0: s\xE9lectionnez l'adresse et copiez-la \xE0 la main.",
      done: "J'ai copi\xE9 l'adresse"
    },
    close: "Fermer"
  },
  errors: {
    network: "Le calendrier est injoignable. V\xE9rifiez votre connexion puis r\xE9essayez.",
    NOT_FOUND: "Cet \xE9v\xE9nement n'existe plus ou vous n'y avez plus acc\xE8s.",
    cannotCreateHere: "Vous ne pouvez pas cr\xE9er d'\xE9v\xE9nement dans cet espace. Choisissez un espace o\xF9 vous pouvez contribuer.",
    EVENT_READ_ONLY: "Cette \xE9ch\xE9ance vient d'une t\xE2che, d'une phase ou d'un visa\xA0: modifiez-la \xE0 sa source."
  },
  sections: {
    label: "Affichage",
    calendar: "Calendrier",
    meetings: "R\xE9unions"
  },
  spaceTab: {
    openInCalendar: "Ouvrir dans le Calendrier"
  }
};

// locales/ar/meetings.json
var meetings_default = {
  page: {
    loading: "\u062C\u0627\u0631\u064D \u0641\u062A\u062D \u0627\u0644\u0627\u062C\u062A\u0645\u0627\u0639\u2026",
    back: "\u0631\u062C\u0648\u0639",
    notFound: {
      title: "\u0627\u0644\u0627\u062C\u062A\u0645\u0627\u0639 \u063A\u064A\u0631 \u0645\u0648\u062C\u0648\u062F",
      body: "\u0647\u0630\u0627 \u0627\u0644\u0627\u062C\u062A\u0645\u0627\u0639 \u063A\u064A\u0631 \u0645\u0648\u062C\u0648\u062F \u0623\u0648 \u0644\u0627 \u064A\u0645\u0643\u0646\u0643 \u0627\u0644\u0648\u0635\u0648\u0644 \u0625\u0644\u064A\u0647. \u0627\u0637\u0644\u0628 \u0645\u0646 \u0645\u0646\u0638\u0651\u0645 \u0627\u0644\u0627\u062C\u062A\u0645\u0627\u0639 \u0623\u0646 \u064A\u062F\u0639\u0648\u0643."
    },
    loadFailed: {
      title: "\u062A\u0639\u0630\u0651\u0631 \u0641\u062A\u062D \u0627\u0644\u0627\u062C\u062A\u0645\u0627\u0639",
      body: "\u0641\u0634\u0644 \u0627\u0644\u0627\u062A\u0635\u0627\u0644 \u0628\u0627\u0644\u062E\u0627\u062F\u0645. \u062A\u062D\u0642\u0642 \u0645\u0646 \u0627\u062A\u0635\u0627\u0644\u0643 \u062B\u0645 \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629."
    }
  },
  ended: {
    title: "\u0627\u0646\u062A\u0647\u0649 \u0647\u0630\u0627 \u0627\u0644\u0627\u062C\u062A\u0645\u0627\u0639",
    body: "\u0644\u0645 \u064A\u0639\u062F \u0623\u062D\u062F \u0641\u064A \u0627\u0644\u0642\u0627\u0639\u0629. \u064A\u0645\u0643\u0646\u0643 \u0628\u062F\u0621 \u0627\u062C\u062A\u0645\u0627\u0639 \u062C\u062F\u064A\u062F \u0645\u0646 \u0627\u0644\u0645\u0634\u0631\u0648\u0639 \u0623\u0648 \u0645\u0646 \u0627\u0644\u0645\u062D\u0627\u062F\u062B\u0629.",
    back: "\u0631\u062C\u0648\u0639"
  },
  removed: {
    title: "\u062A\u0645\u062A \u0625\u0632\u0627\u0644\u062A\u0643 \u0645\u0646 \u0627\u0644\u0627\u062C\u062A\u0645\u0627\u0639",
    body: "\u062A\u0645 \u0633\u062D\u0628 \u0648\u0635\u0648\u0644\u0643 \u0625\u0644\u0649 \u0647\u0630\u0627 \u0627\u0644\u0627\u062C\u062A\u0645\u0627\u0639. \u062A\u0648\u0627\u0635\u0644 \u0645\u0639 \u0645\u0646\u0638\u0651\u0645 \u0627\u0644\u0627\u062C\u062A\u0645\u0627\u0639 \u0625\u0646 \u0643\u0627\u0646 \u0630\u0644\u0643 \u062E\u0637\u0623\u064B."
  },
  left: {
    title: "\u063A\u0627\u062F\u0631\u062A \u0627\u0644\u0627\u062C\u062A\u0645\u0627\u0639",
    body: "\u064A\u0633\u062A\u0645\u0631 \u0627\u0644\u0627\u062C\u062A\u0645\u0627\u0639 \u0644\u0644\u0645\u0634\u0627\u0631\u0643\u064A\u0646 \u0627\u0644\u0622\u062E\u0631\u064A\u0646.",
    rejoin: "\u0627\u0644\u0627\u0646\u0636\u0645\u0627\u0645 \u0645\u0646 \u062C\u062F\u064A\u062F",
    leave: "\u0625\u063A\u0644\u0627\u0642"
  },
  call: {
    action: "\u0627\u062A\u0635\u0627\u0644",
    failed: "\u062A\u0639\u0630\u0651\u0631 \u0628\u062F\u0621 \u0627\u0644\u0645\u0643\u0627\u0644\u0645\u0629 \u062D\u0627\u0644\u064A\u064B\u0627. \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629 \u0628\u0639\u062F \u0642\u0644\u064A\u0644.",
    missed: "\u0645\u0643\u0627\u0644\u0645\u0629 \u0641\u0627\u0626\u062A\u0629",
    live: "\u0645\u0643\u0627\u0644\u0645\u0629 \u062C\u0627\u0631\u064A\u0629",
    line: "\u0645\u0643\u0627\u0644\u0645\u0629",
    ringing: "\u062C\u0627\u0631\u064D \u0627\u0644\u0627\u062A\u0635\u0627\u0644\u2026",
    waiting: "\u0641\u064A \u0627\u0646\u062A\u0638\u0627\u0631 \u0627\u0644\u0631\u062F\u2026",
    hangUp: "\u0625\u0646\u0647\u0627\u0621 \u0627\u0644\u0645\u0643\u0627\u0644\u0645\u0629",
    controls: "\u0623\u062F\u0648\u0627\u062A \u0627\u0644\u062A\u062D\u0643\u0645 \u0641\u064A \u0627\u0644\u0645\u0643\u0627\u0644\u0645\u0629",
    selfView: "\u0635\u0648\u0631\u062A\u0643",
    connecting: "\u062C\u0627\u0631\u064D \u0627\u0644\u0627\u062A\u0635\u0627\u0644 \u0628\u0627\u0644\u0645\u0643\u0627\u0644\u0645\u0629\u2026",
    retry: "\u0625\u0639\u0627\u062F\u0629 \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629",
    close: "\u0625\u063A\u0644\u0627\u0642",
    joinLabel: "\u0627\u0644\u0627\u0646\u0636\u0645\u0627\u0645 \u0625\u0644\u0649 \u0627\u0644\u0645\u0643\u0627\u0644\u0645\u0629",
    ended: {
      title: "\u0627\u0646\u062A\u0647\u062A \u0627\u0644\u0645\u0643\u0627\u0644\u0645\u0629",
      body: "\u0627\u0646\u062A\u0647\u062A \u0627\u0644\u0645\u0643\u0627\u0644\u0645\u0629. \u064A\u0645\u0643\u0646\u0643 \u0625\u063A\u0644\u0627\u0642 \u0647\u0630\u0647 \u0627\u0644\u0646\u0627\u0641\u0630\u0629."
    }
  },
  join: {
    action: "\u0627\u0646\u0636\u0645\u0627\u0645"
  },
  start: {
    action: "\u0628\u062F\u0621 \u0627\u062C\u062A\u0645\u0627\u0639",
    title: "\u0628\u062F\u0621 \u0627\u062C\u062A\u0645\u0627\u0639",
    titleLabel: "\u0639\u0646\u0648\u0627\u0646 \u0627\u0644\u0627\u062C\u062A\u0645\u0627\u0639",
    titleInvalid: "\u0623\u062F\u062E\u0644 \u0639\u0646\u0648\u0627\u0646\u064B\u0627 \u0644\u0627 \u064A\u062A\u062C\u0627\u0648\u0632 200 \u062D\u0631\u0641.",
    defaultTitle: "\u0627\u062C\u062A\u0645\u0627\u0639 - {project}",
    cancel: "\u0625\u0644\u063A\u0627\u0621",
    confirm: "\u0628\u062F\u0621",
    failed: "\u062A\u0639\u0630\u0651\u0631 \u0625\u0646\u0634\u0627\u0621 \u0627\u0644\u0627\u062C\u062A\u0645\u0627\u0639. \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629 \u0628\u0639\u062F \u0642\u0644\u064A\u0644.",
    new: "\u0627\u062C\u062A\u0645\u0627\u0639 \u062C\u062F\u064A\u062F",
    channelTitle: "\u0627\u062C\u062A\u0645\u0627\u0639 - {channel}"
  },
  invite: {
    title: "\u062F\u0639\u0648\u0629",
    intro: "\u0623\u062F\u062E\u0644 \u0627\u0644\u0628\u0631\u064A\u062F \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A \u0644\u0644\u0634\u062E\u0635 \u0627\u0644\u0645\u062F\u0639\u0648. \u0633\u064A\u0635\u0644\u0647 \u0628\u0631\u064A\u062F \u064A\u062D\u062A\u0648\u064A \u0639\u0644\u0649 \u0627\u0644\u0631\u0627\u0628\u0637 \u0648\u0639\u0644\u064A\u0647 \u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062F\u062E\u0648\u0644 \u0628\u062D\u0633\u0627\u0628 BatiFlow \u0628\u0647\u0630\u0627 \u0627\u0644\u0639\u0646\u0648\u0627\u0646.",
    emailLabel: "\u0627\u0644\u0628\u0631\u064A\u062F \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A \u0644\u0644\u0636\u064A\u0641",
    emailInvalid: "\u0623\u062F\u062E\u0644 \u0639\u0646\u0648\u0627\u0646 \u0628\u0631\u064A\u062F \u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A \u0635\u0627\u0644\u062D\u064B\u0627.",
    create: "\u0625\u0646\u0634\u0627\u0621 \u0627\u0644\u0631\u0627\u0628\u0637",
    cancel: "\u0625\u0644\u063A\u0627\u0621",
    failed: "\u062A\u0639\u0630\u0651\u0631 \u0625\u0646\u0634\u0627\u0621 \u0627\u0644\u062F\u0639\u0648\u0629. \u062A\u0623\u0643\u062F \u0645\u0646 \u0623\u0646 \u0644\u062F\u064A\u0643 \u0635\u0644\u0627\u062D\u064A\u0629 \u0627\u0644\u062F\u0639\u0648\u0629 \u0625\u0644\u0649 \u0647\u0630\u0627 \u0627\u0644\u0627\u062C\u062A\u0645\u0627\u0639 \u062B\u0645 \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629.",
    created: "\u0623\u064F\u0631\u0633\u0644\u062A \u0627\u0644\u062F\u0639\u0648\u0629 \u0628\u0627\u0644\u0628\u0631\u064A\u062F \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A \u0625\u0644\u0649 {email}. \u064A\u0645\u0643\u0646\u0643 \u0623\u064A\u0636\u064B\u0627 \u0646\u0633\u062E \u0627\u0644\u0631\u0627\u0628\u0637 \u0648\u0625\u0631\u0633\u0627\u0644\u0647 \u0628\u0646\u0641\u0633\u0643:",
    linkLabel: "\u0631\u0627\u0628\u0637 \u0627\u0644\u062F\u0639\u0648\u0629",
    copy: "\u0646\u0633\u062E \u0627\u0644\u0631\u0627\u0628\u0637",
    copied: "\u062A\u0645 \u0646\u0633\u062E \u0627\u0644\u0631\u0627\u0628\u0637.",
    copyFailed: "\u062A\u0639\u0630\u0651\u0631 \u0627\u0644\u0646\u0633\u062E: \u062D\u062F\u0651\u062F \u0627\u0644\u0631\u0627\u0628\u0637 \u0648\u0627\u0646\u0633\u062E\u0647 \u064A\u062F\u0648\u064A\u064B\u0627.",
    warning: "\u064A\u0639\u0645\u0644 \u0647\u0630\u0627 \u0627\u0644\u0631\u0627\u0628\u0637 \u0645\u0631\u0629 \u0648\u0627\u062D\u062F\u0629 \u0641\u0642\u0637 \u0648\u0644\u0645\u062F\u0629 7 \u0623\u064A\u0627\u0645. \u064A\u0638\u0647\u0631 \u0647\u0646\u0627 \u0641\u0642\u0637: \u0627\u0646\u0633\u062E\u0647 \u0627\u0644\u0622\u0646. \u0635\u0627\u0644\u062D \u062D\u062A\u0649",
    done: "\u062A\u0645",
    close: "\u0625\u063A\u0644\u0627\u0642",
    parts: {
      people: "\u0623\u0634\u062E\u0627\u0635",
      email: "\u0639\u0628\u0631 \u0627\u0644\u0628\u0631\u064A\u062F \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A"
    },
    people: {
      intro: "\u0627\u062E\u062A\u0631 \u0623\u0639\u0636\u0627\u0621 \u0645\u0646 \u0645\u0624\u0633\u0633\u062A\u0643. \u064A\u0635\u0644\u0647\u0645 \u0625\u0634\u0639\u0627\u0631 \u0641\u064A BatiFlow \u0648\u064A\u0645\u0643\u0646\u0647\u0645 \u0627\u0644\u0627\u0646\u0636\u0645\u0627\u0645 \u0641\u0648\u0631\u064B\u0627.",
      label: "\u0627\u0644\u0623\u0634\u062E\u0627\u0635 \u0627\u0644\u0645\u062F\u0639\u0648\u0648\u0646",
      none: "\u0627\u062E\u062A\u0631 \u0634\u062E\u0635\u064B\u0627 \u0648\u0627\u062D\u062F\u064B\u0627 \u0639\u0644\u0649 \u0627\u0644\u0623\u0642\u0644.",
      membersFailed: "\u062A\u0639\u0630\u0651\u0631 \u062A\u062D\u0645\u064A\u0644 \u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u0623\u0639\u0636\u0627\u0621. \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629 \u0628\u0639\u062F \u0642\u0644\u064A\u0644.",
      notMember: "\u0647\u0630\u0627 \u0627\u0644\u0634\u062E\u0635 \u0644\u064A\u0633 \u0645\u0646 \u0627\u0644\u0645\u0624\u0633\u0633\u0629. \u0627\u062F\u0639\u064F\u0647 \u0639\u0628\u0631 \u0627\u0644\u0628\u0631\u064A\u062F \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A.",
      forbidden: "\u0644\u064A\u0633 \u0644\u062F\u064A\u0643 \u0635\u0644\u0627\u062D\u064A\u0629 \u0627\u0644\u062F\u0639\u0648\u0629 \u0625\u0644\u0649 \u0647\u0630\u0627 \u0627\u0644\u0627\u062C\u062A\u0645\u0627\u0639. \u0627\u0644\u0645\u0646\u0638\u0651\u0645 \u0648\u0645\u0633\u0624\u0648\u0644\u0648 \u0627\u0644\u0645\u0633\u0627\u062D\u0629 \u0641\u0642\u0637 \u064A\u0633\u062A\u0637\u064A\u0639\u0648\u0646 \u0630\u0644\u0643.",
      failed: "\u062A\u0639\u0630\u0651\u0631 \u0625\u0631\u0633\u0627\u0644 \u0627\u0644\u062F\u0639\u0648\u0627\u062A. \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629 \u0628\u0639\u062F \u0642\u0644\u064A\u0644.",
      done: "{count, plural, one {\u062A\u0645\u062A \u062F\u0639\u0648\u0629 \u0634\u062E\u0635 \u0648\u0627\u062D\u062F.} two {\u062A\u0645\u062A \u062F\u0639\u0648\u0629 \u0634\u062E\u0635\u064A\u0646.} few {\u062A\u0645\u062A \u062F\u0639\u0648\u0629 # \u0623\u0634\u062E\u0627\u0635.} many {\u062A\u0645\u062A \u062F\u0639\u0648\u0629 # \u0634\u062E\u0635\u064B\u0627.} other {\u062A\u0645\u062A \u062F\u0639\u0648\u0629 # \u0634\u062E\u0635.}}",
      already: "\u0647\u0624\u0644\u0627\u0621 \u0627\u0644\u0623\u0634\u062E\u0627\u0635 \u0645\u062F\u0639\u0648\u0651\u0648\u0646 \u0628\u0627\u0644\u0641\u0639\u0644.",
      submit: "\u062F\u0639\u0648\u0629"
    }
  },
  incoming: {
    title: "{name} \u064A\u062A\u0635\u0644 \u0628\u0643",
    body: "\u0645\u0643\u0627\u0644\u0645\u0629 \u0648\u0627\u0631\u062F\u0629",
    accept: "\u0642\u0628\u0648\u0644",
    decline: "\u0631\u0641\u0636"
  },
  prejoin: {
    title: "\u0647\u0644 \u0623\u0646\u062A \u062C\u0627\u0647\u0632 \u0644\u0644\u0627\u0646\u0636\u0645\u0627\u0645\u061F",
    previewLabel: "\u0645\u0639\u0627\u064A\u0646\u0629 \u0627\u0644\u0643\u0627\u0645\u064A\u0631\u0627",
    cameraOff: "\u0627\u0644\u0643\u0627\u0645\u064A\u0631\u0627 \u0645\u062A\u0648\u0642\u0641\u0629",
    microphone: "\u0627\u0644\u0645\u064A\u0643\u0631\u0648\u0641\u0648\u0646",
    camera: "\u0627\u0644\u0643\u0627\u0645\u064A\u0631\u0627",
    cameraDevice: "\u0627\u0644\u0643\u0627\u0645\u064A\u0631\u0627",
    microphoneDevice: "\u0627\u0644\u0645\u064A\u0643\u0631\u0648\u0641\u0648\u0646",
    defaultDevice: "\u0627\u0644\u0627\u0641\u062A\u0631\u0627\u0636\u064A",
    unnamedDevice: "\u0627\u0644\u062C\u0647\u0627\u0632 {index}",
    denied: {
      title: "\u062A\u0645 \u0631\u0641\u0636 \u0627\u0644\u0648\u0635\u0648\u0644 \u0625\u0644\u0649 \u0627\u0644\u0643\u0627\u0645\u064A\u0631\u0627 \u0648\u0627\u0644\u0645\u064A\u0643\u0631\u0648\u0641\u0648\u0646",
      body: "\u064A\u062D\u062A\u0627\u062C BatiFlow \u0625\u0644\u0649 \u0625\u0630\u0646\u0643 \u0644\u0643\u064A \u064A\u0631\u0627\u0643 \u0627\u0644\u0622\u062E\u0631\u0648\u0646 \u0648\u064A\u0633\u0645\u0639\u0648\u0643. \u0627\u0633\u0645\u062D \u0628\u0627\u0644\u0648\u0635\u0648\u0644 \u0645\u0646 \u0625\u0639\u062F\u0627\u062F\u0627\u062A \u0627\u0644\u0645\u062A\u0635\u0641\u062D (\u0627\u0644\u0623\u064A\u0642\u0648\u0646\u0629 \u0628\u062C\u0627\u0646\u0628 \u0627\u0644\u0639\u0646\u0648\u0627\u0646) \u062B\u0645 \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629. \u064A\u0645\u0643\u0646\u0643 \u0623\u064A\u0636\u064B\u0627 \u0627\u0644\u0627\u0646\u0636\u0645\u0627\u0645 \u0628\u062F\u0648\u0646 \u0643\u0627\u0645\u064A\u0631\u0627 \u0623\u0648 \u0645\u064A\u0643\u0631\u0648\u0641\u0648\u0646.",
      retry: "\u0625\u0639\u0627\u062F\u0629 \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629"
    },
    unavailable: "\u0644\u0627 \u064A\u0633\u0645\u062D \u0645\u062A\u0635\u0641\u062D\u0643 \u0628\u0627\u0633\u062A\u062E\u062F\u0627\u0645 \u0627\u0644\u0643\u0627\u0645\u064A\u0631\u0627 \u0648\u0627\u0644\u0645\u064A\u0643\u0631\u0648\u0641\u0648\u0646 \u0641\u064A \u0647\u0630\u0647 \u0627\u0644\u0635\u0641\u062D\u0629. \u064A\u0645\u0643\u0646\u0643 \u0627\u0644\u0627\u0646\u0636\u0645\u0627\u0645 \u0625\u0644\u0649 \u0627\u0644\u0627\u062C\u062A\u0645\u0627\u0639 \u0644\u0644\u0627\u0633\u062A\u0645\u0627\u0639 \u0641\u0642\u0637.",
    missing: "\u0644\u0645 \u064A\u062A\u0645 \u0627\u0644\u0639\u062B\u0648\u0631 \u0639\u0644\u0649 \u0643\u0627\u0645\u064A\u0631\u0627. \u064A\u0645\u0643\u0646\u0643 \u0627\u0644\u0627\u0646\u0636\u0645\u0627\u0645 \u0628\u0627\u0644\u0645\u064A\u0643\u0631\u0648\u0641\u0648\u0646 \u0641\u0642\u0637.",
    inRoom: "\u0641\u064A \u0627\u0644\u0627\u062C\u062A\u0645\u0627\u0639 \u0627\u0644\u0622\u0646",
    nobody: "\u0644\u0627 \u0623\u062D\u062F \u0641\u064A \u0627\u0644\u0627\u062C\u062A\u0645\u0627\u0639 \u0628\u0639\u062F.",
    join: "\u0627\u0646\u0636\u0645\u0627\u0645",
    joining: "\u062C\u0627\u0631\u064D \u0627\u0644\u0627\u062A\u0635\u0627\u0644\u2026",
    micTurnOff: "\u0643\u062A\u0645 \u0627\u0644\u0645\u064A\u0643\u0631\u0648\u0641\u0648\u0646",
    micTurnOn: "\u062A\u0634\u063A\u064A\u0644 \u0627\u0644\u0645\u064A\u0643\u0631\u0648\u0641\u0648\u0646",
    cameraTurnOff: "\u0625\u064A\u0642\u0627\u0641 \u0627\u0644\u0643\u0627\u0645\u064A\u0631\u0627",
    cameraTurnOn: "\u062A\u0634\u063A\u064A\u0644 \u0627\u0644\u0643\u0627\u0645\u064A\u0631\u0627",
    joiningAs: "\u0633\u062A\u0646\u0636\u0645 \u0628\u0627\u0633\u0645 {name}"
  },
  problems: {
    full: {
      title: "\u0627\u0644\u0627\u062C\u062A\u0645\u0627\u0639 \u0645\u0643\u062A\u0645\u0644",
      owner: "\u0628\u0644\u063A \u0647\u0630\u0627 \u0627\u0644\u0627\u062C\u062A\u0645\u0627\u0639 \u0627\u0644\u062D\u062F \u0627\u0644\u0623\u0642\u0635\u0649 \u0644\u0639\u062F\u062F \u0627\u0644\u0645\u0634\u0627\u0631\u0643\u064A\u0646 \u0641\u064A \u0628\u0627\u0642\u062A\u0643. \u0627\u0646\u062A\u0642\u0644 \u0625\u0644\u0649 \u0628\u0627\u0642\u0629 \u0623\u0639\u0644\u0649 \u0644\u0627\u0633\u062A\u0642\u0628\u0627\u0644 \u0645\u0632\u064A\u062F \u0645\u0646 \u0627\u0644\u0623\u0634\u062E\u0627\u0635.",
      member: "\u0628\u0644\u063A \u0647\u0630\u0627 \u0627\u0644\u0627\u062C\u062A\u0645\u0627\u0639 \u0627\u0644\u062D\u062F \u0627\u0644\u0623\u0642\u0635\u0649 \u0644\u0639\u062F\u062F \u0627\u0644\u0645\u0634\u0627\u0631\u0643\u064A\u0646 \u0641\u064A \u0628\u0627\u0642\u0629 \u0645\u0643\u062A\u0628\u0643. \u062A\u0648\u0627\u0635\u0644 \u0645\u0639 \u0645\u0633\u0624\u0648\u0644 \u0627\u0644\u0645\u0643\u062A\u0628."
    },
    ended: {
      title: "\u0627\u0646\u062A\u0647\u0649 \u0627\u0644\u0627\u062C\u062A\u0645\u0627\u0639",
      body: "\u0627\u0646\u062A\u0647\u0649 \u0647\u0630\u0627 \u0627\u0644\u0627\u062C\u062A\u0645\u0627\u0639 \u0648\u0644\u0645 \u064A\u0639\u062F \u0628\u0625\u0645\u0643\u0627\u0646\u0643 \u0627\u0644\u0627\u0646\u0636\u0645\u0627\u0645 \u0625\u0644\u064A\u0647."
    },
    forbidden: {
      title: "\u0627\u0644\u0648\u0635\u0648\u0644 \u0645\u0631\u0641\u0648\u0636",
      body: "\u0644\u064A\u0633 \u0644\u062F\u064A\u0643 \u0635\u0644\u0627\u062D\u064A\u0629 \u0627\u0644\u0627\u0646\u0636\u0645\u0627\u0645 \u0625\u0644\u0649 \u0647\u0630\u0627 \u0627\u0644\u0627\u062C\u062A\u0645\u0627\u0639. \u0627\u0637\u0644\u0628 \u0645\u0646 \u0645\u0646\u0638\u0651\u0645 \u0627\u0644\u0627\u062C\u062A\u0645\u0627\u0639 \u0623\u0646 \u064A\u062F\u0639\u0648\u0643."
    },
    emailMismatch: {
      title: "\u062F\u0639\u0648\u0629 \u0645\u0648\u062C\u0651\u0647\u0629 \u0625\u0644\u0649 \u0639\u0646\u0648\u0627\u0646 \u0622\u062E\u0631",
      body: "\u0623\u064F\u0631\u0633\u0644\u062A \u0647\u0630\u0647 \u0627\u0644\u062F\u0639\u0648\u0629 \u0625\u0644\u0649 \u0639\u0646\u0648\u0627\u0646 \u0628\u0631\u064A\u062F \u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A \u0645\u062E\u062A\u0644\u0641 \u0639\u0646 \u0639\u0646\u0648\u0627\u0646 \u062D\u0633\u0627\u0628\u0643."
    },
    invitationInvalid: {
      title: "\u062F\u0639\u0648\u0629 \u063A\u064A\u0631 \u0635\u0627\u0644\u062D\u0629",
      body: "\u0631\u0627\u0628\u0637 \u0627\u0644\u062F\u0639\u0648\u0629 \u0647\u0630\u0627 \u063A\u064A\u0631 \u0635\u0627\u0644\u062D \u0623\u0648 \u0633\u0628\u0642 \u0627\u0633\u062A\u062E\u062F\u0627\u0645\u0647 \u0623\u0648 \u0627\u0646\u062A\u0647\u062A \u0635\u0644\u0627\u062D\u064A\u062A\u0647. \u0627\u0637\u0644\u0628 \u0631\u0627\u0628\u0637\u064B\u0627 \u062C\u062F\u064A\u062F\u064B\u0627."
    },
    unavailable: {
      title: "\u062A\u0639\u0630\u0651\u0631 \u0627\u0644\u0627\u062A\u0635\u0627\u0644",
      body: "\u062E\u062F\u0645\u0629 \u0627\u0644\u0627\u062C\u062A\u0645\u0627\u0639\u0627\u062A \u0644\u0627 \u062A\u0633\u062A\u062C\u064A\u0628 \u062D\u0627\u0644\u064A\u064B\u0627. \u062A\u062D\u0642\u0642 \u0645\u0646 \u0627\u062A\u0635\u0627\u0644\u0643 \u062B\u0645 \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629."
    },
    other: {
      title: "\u062A\u0639\u0630\u0651\u0631 \u0627\u0644\u0627\u0646\u0636\u0645\u0627\u0645",
      body: "\u062A\u0639\u0630\u0651\u0631 \u0627\u0644\u0627\u0646\u0636\u0645\u0627\u0645 \u0625\u0644\u0649 \u0627\u0644\u0627\u062C\u062A\u0645\u0627\u0639. \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629 \u0628\u0639\u062F \u0642\u0644\u064A\u0644."
    }
  },
  room: {
    you: "{name} (\u0623\u0646\u062A)",
    external: "\u062E\u0627\u0631\u062C\u064A",
    micOff: "\u0627\u0644\u0645\u064A\u0643\u0631\u0648\u0641\u0648\u0646 \u0645\u0643\u062A\u0648\u0645",
    handRaised: "\u0631\u0641\u0639 \u064A\u062F\u0647",
    speaking: "\u064A\u062A\u062D\u062F\u062B",
    videoPaused: "\u0627\u0644\u0641\u064A\u062F\u064A\u0648 \u0645\u062A\u0648\u0642\u0641",
    screenOf: "\u0634\u0627\u0634\u0629 {name}",
    tiles: "\u0627\u0644\u0645\u0634\u0627\u0631\u0643\u0648\u0646",
    stage: "\u0627\u0644\u0645\u062A\u062D\u062F\u062B",
    people: "{count, plural, one {\u0634\u062E\u0635 \u0648\u0627\u062D\u062F} two {\u0634\u062E\u0635\u0627\u0646} few {# \u0623\u0634\u062E\u0627\u0635} many {# \u0634\u062E\u0635\u064B\u0627} other {# \u0634\u062E\u0635}}",
    reconnecting: "\u062C\u0627\u0631\u064D \u0625\u0639\u0627\u062F\u0629 \u0627\u0644\u0627\u062A\u0635\u0627\u0644\u2026",
    layout: "\u0637\u0631\u064A\u0642\u0629 \u0627\u0644\u0639\u0631\u0636",
    layoutGrid: "\u0634\u0628\u0643\u0629",
    layoutSpeaker: "\u0627\u0644\u0645\u062A\u062D\u062F\u062B",
    shortcuts: "\u0627\u062E\u062A\u0635\u0627\u0631\u0627\u062A \u0644\u0648\u062D\u0629 \u0627\u0644\u0645\u0641\u0627\u062A\u064A\u062D",
    lostTrying: "\u0627\u0646\u0642\u0637\u0639 \u0627\u0644\u0627\u062A\u0635\u0627\u0644. \u062C\u0627\u0631\u064D \u0625\u0639\u0627\u062F\u0629 \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629\u2026",
    lostFailed: "\u062A\u0639\u0630\u0651\u0631\u062A \u0627\u0633\u062A\u0639\u0627\u062F\u0629 \u0627\u0644\u0627\u062A\u0635\u0627\u0644. \u062A\u062D\u0642\u0642 \u0645\u0646 \u0634\u0628\u0643\u062A\u0643 \u062B\u0645 \u0623\u0639\u062F \u0627\u0644\u0627\u062A\u0635\u0627\u0644.",
    reconnect: "\u0625\u0639\u0627\u062F\u0629 \u0627\u0644\u0627\u062A\u0635\u0627\u0644",
    reconnectingBanner: "\u062C\u0627\u0631\u064D \u0625\u0639\u0627\u062F\u0629 \u0627\u0644\u0627\u062A\u0635\u0627\u0644\u2026 \u0645\u0627 \u0632\u0644\u062A \u0641\u064A \u0627\u0644\u0627\u062C\u062A\u0645\u0627\u0639.",
    audioOnly: "\u0627\u062A\u0635\u0627\u0644 \u0636\u0639\u064A\u0641: \u062A\u0645 \u0625\u064A\u0642\u0627\u0641 \u0627\u0644\u0641\u064A\u062F\u064A\u0648\u060C \u0627\u0644\u0635\u0648\u062A \u0641\u0642\u0637",
    audioOnlyRetry: "\u0625\u0639\u0627\u062F\u0629 \u062A\u062C\u0631\u0628\u0629 \u0627\u0644\u0641\u064A\u062F\u064A\u0648",
    problems: {
      "media-denied": "\u062A\u0645 \u0631\u0641\u0636 \u0627\u0644\u0648\u0635\u0648\u0644 \u0625\u0644\u0649 \u0627\u0644\u0643\u0627\u0645\u064A\u0631\u0627 \u0623\u0648 \u0627\u0644\u0645\u064A\u0643\u0631\u0648\u0641\u0648\u0646. \u0627\u0633\u0645\u062D \u0628\u0647 \u0645\u0646 \u0625\u0639\u062F\u0627\u062F\u0627\u062A \u0627\u0644\u0645\u062A\u0635\u0641\u062D \u062B\u0645 \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629.",
      "media-missing": "\u0644\u0645 \u064A\u062A\u0645 \u0627\u0644\u0639\u062B\u0648\u0631 \u0639\u0644\u0649 \u0643\u0627\u0645\u064A\u0631\u0627 \u0623\u0648 \u0645\u064A\u0643\u0631\u0648\u0641\u0648\u0646 \u0639\u0644\u0649 \u0647\u0630\u0627 \u0627\u0644\u062C\u0647\u0627\u0632.",
      "media-failed": "\u062A\u0639\u0630\u0651\u0631 \u062A\u0634\u063A\u064A\u0644 \u0627\u0644\u0643\u0627\u0645\u064A\u0631\u0627 \u0623\u0648 \u0627\u0644\u0645\u064A\u0643\u0631\u0648\u0641\u0648\u0646 \u0623\u0648 \u0645\u0634\u0627\u0631\u0643\u0629 \u0627\u0644\u0634\u0627\u0634\u0629. \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629."
    },
    audioBlocked: "\u064A\u0645\u0646\u0639 \u0645\u062A\u0635\u0641\u062D\u0643 \u0627\u0644\u0635\u0648\u062A \u0625\u0644\u0649 \u0623\u0646 \u062A\u062A\u0641\u0627\u0639\u0644 \u0645\u0639 \u0627\u0644\u0635\u0641\u062D\u0629.",
    audioStart: "\u062A\u0634\u063A\u064A\u0644 \u0627\u0644\u0635\u0648\u062A",
    closePanel: "\u0625\u063A\u0644\u0627\u0642 \u0627\u0644\u0644\u0648\u062D\u0629",
    elapsed: "\u0627\u0644\u0645\u062F\u0629",
    resizePanel: "\u062A\u063A\u064A\u064A\u0631 \u062D\u062C\u0645 \u0627\u0644\u0644\u0648\u062D\u0629"
  },
  controls: {
    label: "\u0623\u062F\u0648\u0627\u062A \u0627\u0644\u0627\u062C\u062A\u0645\u0627\u0639",
    mic: "\u0627\u0644\u0645\u064A\u0643\u0631\u0648\u0641\u0648\u0646",
    micHint: "\u062A\u0634\u063A\u064A\u0644 \u0627\u0644\u0645\u064A\u0643\u0631\u0648\u0641\u0648\u0646 \u0623\u0648 \u0643\u062A\u0645\u0647 ({keys})",
    camera: "\u0627\u0644\u0643\u0627\u0645\u064A\u0631\u0627",
    cameraHint: "\u062A\u0634\u063A\u064A\u0644 \u0627\u0644\u0643\u0627\u0645\u064A\u0631\u0627 \u0623\u0648 \u0625\u064A\u0642\u0627\u0641\u0647\u0627 ({keys})",
    share: "\u0645\u0634\u0627\u0631\u0643\u0629 \u0627\u0644\u0634\u0627\u0634\u0629",
    hand: "\u0631\u0641\u0639 \u0627\u0644\u064A\u062F",
    participants: "\u0627\u0644\u0645\u0634\u0627\u0631\u0643\u0648\u0646",
    chat: "\u0627\u0644\u0645\u062D\u0627\u062F\u062B\u0629",
    chatUnread: "\u0627\u0644\u0645\u062D\u0627\u062F\u062B\u0629\u060C {count, plural, one {\u0631\u0633\u0627\u0644\u0629 \u0648\u0627\u062D\u062F\u0629 \u063A\u064A\u0631 \u0645\u0642\u0631\u0648\u0621\u0629} two {\u0631\u0633\u0627\u0644\u062A\u0627\u0646 \u063A\u064A\u0631 \u0645\u0642\u0631\u0648\u0621\u062A\u064A\u0646} few {# \u0631\u0633\u0627\u0626\u0644 \u063A\u064A\u0631 \u0645\u0642\u0631\u0648\u0621\u0629} many {# \u0631\u0633\u0627\u0644\u0629 \u063A\u064A\u0631 \u0645\u0642\u0631\u0648\u0621\u0629} other {# \u0631\u0633\u0627\u0644\u0629 \u063A\u064A\u0631 \u0645\u0642\u0631\u0648\u0621\u0629}}",
    invite: "\u062F\u0639\u0648\u0629",
    leave: "\u0645\u063A\u0627\u062F\u0631\u0629",
    shareStop: "\u0625\u064A\u0642\u0627\u0641 \u0627\u0644\u0645\u0634\u0627\u0631\u0643\u0629"
  },
  participants: {
    label: "{count, plural, one {\u0645\u0634\u0627\u0631\u0643 \u0648\u0627\u062D\u062F} two {\u0645\u0634\u0627\u0631\u0643\u0627\u0646} few {# \u0645\u0634\u0627\u0631\u0643\u064A\u0646} many {# \u0645\u0634\u0627\u0631\u0643\u064B\u0627} other {# \u0645\u0634\u0627\u0631\u0643}}",
    micOn: "\u0627\u0644\u0645\u064A\u0643\u0631\u0648\u0641\u0648\u0646 \u064A\u0639\u0645\u0644",
    cameraOn: "\u0627\u0644\u0643\u0627\u0645\u064A\u0631\u0627 \u062A\u0639\u0645\u0644",
    cameraOff: "\u0627\u0644\u0643\u0627\u0645\u064A\u0631\u0627 \u0645\u062A\u0648\u0642\u0641\u0629"
  },
  chat: {
    notStored: "\u0647\u0630\u0647 \u0627\u0644\u0631\u0633\u0627\u0626\u0644 \u063A\u064A\u0631 \u0645\u062D\u0641\u0648\u0638\u0629. \u062A\u062E\u062A\u0641\u064A \u0639\u0646\u062F \u0627\u0646\u062A\u0647\u0627\u0621 \u0627\u0644\u0627\u062C\u062A\u0645\u0627\u0639.",
    label: "\u0631\u0633\u0627\u0626\u0644 \u0627\u0644\u0627\u062C\u062A\u0645\u0627\u0639",
    empty: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0631\u0633\u0627\u0626\u0644 \u0628\u0639\u062F.",
    sendFailed: "\u0644\u0645 \u062A\u064F\u0631\u0633\u0644 \u0627\u0644\u0631\u0633\u0627\u0644\u0629. \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629.",
    input: "\u0627\u0643\u062A\u0628 \u0631\u0633\u0627\u0644\u0629",
    placeholder: "\u0627\u0643\u062A\u0628 \u0631\u0633\u0627\u0644\u0629",
    send: "\u0625\u0631\u0633\u0627\u0644",
    hint: "Enter \u0644\u0644\u0625\u0631\u0633\u0627\u0644\u060C Shift+Enter \u0644\u0633\u0637\u0631 \u062C\u062F\u064A\u062F."
  },
  announce: {
    handRaised: "{name} \u0631\u0641\u0639 \u064A\u062F\u0647.",
    joined: "{name} \u0627\u0646\u0636\u0645\u0651 \u0625\u0644\u0649 \u0627\u0644\u0627\u062C\u062A\u0645\u0627\u0639.",
    left: "{name} \u063A\u0627\u062F\u0631 \u0627\u0644\u0627\u062C\u062A\u0645\u0627\u0639."
  },
  guest: {
    opening: "\u062C\u0627\u0631\u064D \u0641\u062A\u062D \u0627\u0644\u062F\u0639\u0648\u0629\u2026",
    loading: "\u062C\u0627\u0631\u064D \u0627\u0644\u062A\u062D\u0642\u0642 \u0645\u0646 \u0627\u0644\u062F\u0639\u0648\u0629\u2026",
    toHome: "\u0627\u0644\u0627\u0646\u062A\u0642\u0627\u0644 \u0625\u0644\u0649 \u0627\u0644\u0635\u0641\u062D\u0629 \u0627\u0644\u0631\u0626\u064A\u0633\u064A\u0629",
    invitedBy: "\u062F\u0639\u0648\u0629 \u0645\u0646 {organization}",
    missing: {
      title: "\u0631\u0627\u0628\u0637 \u0627\u0644\u062F\u0639\u0648\u0629 \u063A\u064A\u0631 \u0645\u0648\u062C\u0648\u062F",
      body: "\u0627\u0641\u062A\u062D \u0627\u0644\u0631\u0627\u0628\u0637 \u0627\u0644\u0630\u064A \u0648\u0635\u0644\u0643 \u0645\u0631\u0629 \u0623\u062E\u0631\u0649 \u0644\u0644\u0627\u0646\u0636\u0645\u0627\u0645 \u0625\u0644\u0649 \u0627\u0644\u0627\u062C\u062A\u0645\u0627\u0639. \u0648\u0625\u0630\u0627 \u0627\u0633\u062A\u0645\u0631\u062A \u0627\u0644\u0645\u0634\u0643\u0644\u0629 \u0641\u0627\u0637\u0644\u0628 \u062F\u0639\u0648\u0629 \u062C\u062F\u064A\u062F\u0629."
    },
    invalid: {
      title: "\u062F\u0639\u0648\u0629 \u063A\u064A\u0631 \u0635\u0627\u0644\u062D\u0629",
      body: "\u0631\u0627\u0628\u0637 \u0627\u0644\u062F\u0639\u0648\u0629 \u0647\u0630\u0627 \u063A\u064A\u0631 \u0635\u0627\u0644\u062D \u0623\u0648 \u0633\u0628\u0642 \u0627\u0633\u062A\u062E\u062F\u0627\u0645\u0647 \u0623\u0648 \u0627\u0646\u062A\u0647\u062A \u0635\u0644\u0627\u062D\u064A\u062A\u0647. \u0627\u0637\u0644\u0628 \u0631\u0627\u0628\u0637\u064B\u0627 \u062C\u062F\u064A\u062F\u064B\u0627 \u0645\u0646 \u0627\u0644\u0634\u062E\u0635 \u0627\u0644\u0630\u064A \u062F\u0639\u0627\u0643."
    },
    unavailable: {
      title: "\u0627\u0644\u062F\u0639\u0648\u0629 \u063A\u064A\u0631 \u0645\u062A\u0627\u062D\u0629",
      body: "\u062A\u0639\u0630\u0651\u0631 \u0627\u0644\u062A\u062D\u0642\u0642 \u0645\u0646 \u0627\u0644\u062F\u0639\u0648\u0629 \u062D\u0627\u0644\u064A\u064B\u0627. \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629 \u0628\u0639\u062F \u0642\u0644\u064A\u0644."
    },
    mismatch: {
      title: "\u062F\u0639\u0648\u0629 \u0645\u0648\u062C\u0651\u0647\u0629 \u0625\u0644\u0649 \u0639\u0646\u0648\u0627\u0646 \u0622\u062E\u0631",
      body: "\u0623\u064F\u0631\u0633\u0644\u062A \u0647\u0630\u0647 \u0627\u0644\u062F\u0639\u0648\u0629 \u0625\u0644\u0649 \u0639\u0646\u0648\u0627\u0646 \u0628\u0631\u064A\u062F \u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A \u0645\u062E\u062A\u0644\u0641 \u0639\u0646 \u0639\u0646\u0648\u0627\u0646 \u062D\u0633\u0627\u0628\u0643\u060C \u0644\u0630\u0644\u0643 \u0644\u0627 \u064A\u0645\u0643\u0646\u0643 \u0627\u0644\u0627\u0646\u0636\u0645\u0627\u0645 \u0625\u0644\u0649 \u0627\u0644\u0627\u062C\u062A\u0645\u0627\u0639 \u0628\u0647\u0630\u0627 \u0627\u0644\u062D\u0633\u0627\u0628.",
      next: "\u0633\u062C\u0651\u0644 \u0627\u0644\u062E\u0631\u0648\u062C \u062B\u0645 \u0633\u062C\u0651\u0644 \u0627\u0644\u062F\u062E\u0648\u0644 \u0645\u0646 \u062C\u062F\u064A\u062F \u0628\u062D\u0633\u0627\u0628 \u0627\u0644\u0639\u0646\u0648\u0627\u0646 \u0627\u0644\u0645\u062F\u0639\u0648\u060C \u0623\u0648 \u0627\u0637\u0644\u0628 \u062F\u0639\u0648\u0629 \u062C\u062F\u064A\u062F\u0629 \u0645\u0646 \u0627\u0644\u0634\u062E\u0635 \u0627\u0644\u0630\u064A \u062F\u0639\u0627\u0643."
    },
    signOutFailed: "\u0641\u0634\u0644 \u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062E\u0631\u0648\u062C. \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629 \u0628\u0639\u062F \u0642\u0644\u064A\u0644."
  },
  duration: {
    minutes: "{count} \u062F",
    hoursMinutes: "{hours} \u0633 {minutes}"
  },
  status: {
    live: "\u062C\u0627\u0631\u064A\u0629",
    scheduled: "\u0645\u062C\u062F\u0648\u0644\u0629",
    ended: "\u0645\u0646\u062A\u0647\u064A\u0629"
  },
  minutes: {
    draftNumber: "\u0645\u062D\u0636\u0631",
    open: "\u0641\u062A\u062D \u0627\u0644\u0645\u062D\u0636\u0631 {number}",
    write: "\u062A\u062D\u0631\u064A\u0631 \u0627\u0644\u0645\u062D\u0636\u0631",
    prompt: "\u064A\u0645\u0643\u0646\u0643 \u0627\u0644\u0622\u0646 \u062A\u062D\u0631\u064A\u0631 \u0645\u062D\u0636\u0631 \u0647\u0630\u0627 \u0627\u0644\u0627\u062C\u062A\u0645\u0627\u0639.",
    title: "\u0627\u0644\u0645\u062D\u0636\u0631",
    status: {
      draft: "\u0645\u0633\u0648\u062F\u0629",
      published: "\u0645\u0646\u0634\u0648\u0631"
    },
    template: {
      coordination: "\u0627\u062C\u062A\u0645\u0627\u0639 \u062A\u0646\u0633\u064A\u0642",
      moa: "\u0627\u062C\u062A\u0645\u0627\u0639 \u0645\u0639 \u0635\u0627\u062D\u0628 \u0627\u0644\u0645\u0634\u0631\u0648\u0639",
      site_meeting: "\u0627\u062C\u062A\u0645\u0627\u0639 \u0645\u0648\u0642\u0639",
      site_visit: "\u0632\u064A\u0627\u0631\u0629 \u0645\u0648\u0642\u0639"
    },
    language: {
      fr: "\u0627\u0644\u0641\u0631\u0646\u0633\u064A\u0629",
      ar: "\u0627\u0644\u0639\u0631\u0628\u064A\u0629",
      en: "\u0627\u0644\u0625\u0646\u062C\u0644\u064A\u0632\u064A\u0629"
    },
    kind: {
      point: {
        title: "\u0627\u0644\u0646\u0642\u0627\u0637 \u0627\u0644\u0645\u0637\u0631\u0648\u062D\u0629",
        none: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0646\u0642\u0627\u0637 \u0628\u0639\u062F.",
        item: "\u0627\u0644\u0646\u0642\u0637\u0629 {number}",
        add: "\u0625\u0636\u0627\u0641\u0629 \u0646\u0642\u0637\u0629"
      },
      decision: {
        title: "\u0627\u0644\u0642\u0631\u0627\u0631\u0627\u062A",
        none: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0642\u0631\u0627\u0631\u0627\u062A \u0628\u0639\u062F.",
        item: "\u0627\u0644\u0642\u0631\u0627\u0631 {number}",
        add: "\u0625\u0636\u0627\u0641\u0629 \u0642\u0631\u0627\u0631"
      },
      action: {
        title: "\u0627\u0644\u0625\u062C\u0631\u0627\u0621\u0627\u062A",
        none: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0625\u062C\u0631\u0627\u0621\u0627\u062A \u0628\u0639\u062F.",
        item: "\u0627\u0644\u0625\u062C\u0631\u0627\u0621 {number}",
        add: "\u0625\u0636\u0627\u0641\u0629 \u0625\u062C\u0631\u0627\u0621"
      }
    },
    doc: {
      label: "\u0627\u0644\u0645\u062D\u0636\u0631",
      attendees: "\u0627\u0644\u0645\u0634\u0627\u0631\u0643\u0648\u0646",
      noAttendees: "\u0644\u0645 \u064A\u064F\u0633\u062C\u064E\u0651\u0644 \u0623\u064A \u0645\u0634\u0627\u0631\u0643.",
      present: "\u0627\u0644\u062D\u0627\u0636\u0631\u0648\u0646:",
      absent: "\u0627\u0644\u063A\u0627\u0626\u0628\u0648\u0646:",
      nobody: "\u0644\u0627 \u0623\u062D\u062F",
      separator: "\u060C ",
      assignee: "\u0627\u0644\u0645\u0633\u0624\u0648\u0644:",
      unassigned: "\u064A\u064F\u062D\u062F\u064E\u0651\u062F \u0644\u0627\u062D\u0642\u064B\u0627",
      due: "\u0627\u0644\u0623\u062C\u0644:",
      carried: "\u0645\u0631\u062D\u064E\u0651\u0644 \u0645\u0646 {number}"
    },
    editor: {
      info: "\u0627\u0644\u0645\u0639\u0644\u0648\u0645\u0627\u062A",
      title: "\u0627\u0644\u0639\u0646\u0648\u0627\u0646",
      titleRequired: "\u0623\u0639\u0637\u0650 \u0627\u0644\u0645\u062D\u0636\u0631 \u0639\u0646\u0648\u0627\u0646\u064B\u0627.",
      template: "\u0627\u0644\u0646\u0645\u0648\u0630\u062C",
      language: "\u0644\u063A\u0629 \u0627\u0644\u0645\u062D\u0636\u0631",
      date: "\u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0627\u062C\u062A\u0645\u0627\u0639",
      dateRequired: "\u0623\u062F\u062E\u0644 \u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0627\u062C\u062A\u0645\u0627\u0639.",
      time: "\u0627\u0644\u0648\u0642\u062A",
      timeRequired: "\u0623\u062F\u062E\u0644 \u0627\u0644\u0648\u0642\u062A\u060C \u0645\u062B\u0644 09:30.",
      timeZone: "\u0627\u0644\u062A\u0627\u0631\u064A\u062E \u0648\u0627\u0644\u0648\u0642\u062A \u0628\u062A\u0648\u0642\u064A\u062A \u062A\u0648\u0646\u0633.",
      location: "\u0627\u0644\u0645\u0643\u0627\u0646",
      attendees: "\u0627\u0644\u0645\u0634\u0627\u0631\u0643\u0648\u0646",
      noAttendees: "\u0644\u0627 \u064A\u0648\u062C\u062F \u0645\u0634\u0627\u0631\u0643\u0648\u0646 \u0628\u0639\u062F.",
      nameRequired: "\u0627\u0644\u0627\u0633\u0645 \u0645\u0637\u0644\u0648\u0628.",
      present: "\u062D\u0627\u0636\u0631",
      absent: "\u063A\u0627\u0626\u0628",
      presenceOf: "\u062D\u0636\u0648\u0631 {name}",
      removeAttendee: "\u0625\u0632\u0627\u0644\u0629 {name} \u0645\u0646 \u0627\u0644\u0645\u0634\u0627\u0631\u0643\u064A\u0646",
      attendeeName: "\u0625\u0636\u0627\u0641\u0629 \u0645\u0634\u0627\u0631\u0643 (\u0627\u0644\u0627\u0633\u0645)",
      attendeeOrganization: "\u0627\u0644\u0634\u0631\u0643\u0629 \u0623\u0648 \u0627\u0644\u062C\u0647\u0629",
      addAttendee: "\u0625\u0636\u0627\u0641\u0629",
      itemRequired: "\u0627\u0643\u062A\u0628 \u0627\u0644\u0646\u0635 \u0642\u0628\u0644 \u0627\u0644\u062D\u0641\u0638.",
      assignee: "\u0627\u0644\u0645\u0633\u0624\u0648\u0644",
      noAssignee: "\u0644\u0627 \u0623\u062D\u062F \u062D\u0627\u0644\u064A\u064B\u0627",
      assigneeNotMember: "\u0644\u0645 \u064A\u0639\u062F \u0647\u0630\u0627 \u0627\u0644\u0634\u062E\u0635 \u0639\u0636\u0648\u064B\u0627 \u0641\u064A \u0627\u0644\u0645\u0634\u0631\u0648\u0639: \u0627\u062E\u062A\u0631 \u0645\u0633\u0624\u0648\u0644\u064B\u0627 \u0622\u062E\u0631.",
      itemInvalid: "\u062A\u0639\u0630\u0651\u0631 \u062D\u0641\u0638 \u0647\u0630\u0627 \u0627\u0644\u0646\u0635\u060C \u062A\u062D\u0642\u0651\u0642 \u0645\u0646\u0647.",
      itemsInvalid: "\u062A\u0639\u0630\u0651\u0631 \u062D\u0641\u0638 \u0628\u0639\u0636 \u0627\u0644\u0628\u0646\u0648\u062F. \u062A\u062D\u0642\u0651\u0642 \u0645\u0646\u0647\u0627 \u062B\u0645 \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629.",
      dueDate: "\u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0627\u0633\u062A\u062D\u0642\u0627\u0642",
      moveUp: "\u062A\u062D\u0631\u064A\u0643 \u0644\u0644\u0623\u0639\u0644\u0649: {item}",
      moveDown: "\u062A\u062D\u0631\u064A\u0643 \u0644\u0644\u0623\u0633\u0641\u0644: {item}",
      removeItem: "\u062D\u0630\u0641: {item}",
      remove: "\u062D\u0630\u0641",
      unsaved: "\u062A\u063A\u064A\u064A\u0631\u0627\u062A \u063A\u064A\u0631 \u0645\u062D\u0641\u0648\u0638\u0629",
      saved: "\u062A\u0645 \u062D\u0641\u0638 \u0643\u0644 \u0634\u064A\u0621",
      savedNotice: "\u062A\u0645 \u062D\u0641\u0638 \u0627\u0644\u0645\u0633\u0648\u062F\u0629.",
      save: "\u062D\u0641\u0638",
      saving: "\u062C\u0627\u0631\u064D \u0627\u0644\u062D\u0641\u0638\u2026",
      preview: "\u0645\u0639\u0627\u064A\u0646\u0629",
      backToEdit: "\u0627\u0644\u0639\u0648\u062F\u0629 \u0625\u0644\u0649 \u0627\u0644\u062A\u062D\u0631\u064A\u0631",
      publish: "\u0646\u0634\u0631",
      saveFailed: "\u062A\u0639\u0630\u0651\u0631 \u062D\u0641\u0638 \u0627\u0644\u0645\u0633\u0648\u062F\u0629. \u0646\u0635\u0651\u0643 \u0645\u062D\u0641\u0648\u0638 \u0639\u0644\u0649 \u0627\u0644\u0634\u0627\u0634\u0629: \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629.",
      forbidden: "\u0644\u064A\u0633 \u0644\u062F\u064A\u0643 \u0627\u0644\u062D\u0642 \u0641\u064A \u062A\u0639\u062F\u064A\u0644 \u0647\u0630\u0627 \u0627\u0644\u0645\u062D\u0636\u0631.",
      alreadyPublished: "\u062A\u0645 \u0646\u0634\u0631 \u0647\u0630\u0627 \u0627\u0644\u0645\u062D\u0636\u0631 \u0644\u0644\u062A\u0648: \u0644\u0645 \u064A\u0639\u062F \u0645\u0646 \u0627\u0644\u0645\u0645\u0643\u0646 \u062A\u0639\u062F\u064A\u0644\u0647.",
      fixFirst: "\u0623\u0643\u0645\u0644 \u0627\u0644\u062D\u0642\u0648\u0644 \u0627\u0644\u0645\u0634\u0627\u0631 \u0625\u0644\u064A\u0647\u0627 \u0642\u0628\u0644 \u0627\u0644\u062D\u0641\u0638.",
      conflictTitle: "\u0639\u062F\u0651\u0644 \u0634\u062E\u0635 \u0622\u062E\u0631 \u0647\u0630\u0627 \u0627\u0644\u0645\u062D\u0636\u0631.",
      conflictBody: "\u0646\u0635\u0651\u0643 \u0645\u062D\u0641\u0648\u0638 \u0639\u0644\u0649 \u0627\u0644\u0634\u0627\u0634\u0629. \u0627\u062D\u0641\u0638 \u0646\u0633\u062E\u062A\u0643 \u0644\u062A\u062D\u0644\u0651 \u0645\u062D\u0644 \u0646\u0633\u062E\u0629 \u0627\u0644\u0634\u062E\u0635 \u0627\u0644\u0622\u062E\u0631\u060C \u0623\u0648 \u0623\u0639\u062F \u062A\u062D\u0645\u064A\u0644 \u0622\u062E\u0631 \u0646\u0633\u062E\u0629 (\u0633\u062A\u064F\u0641\u0642\u062F \u062A\u063A\u064A\u064A\u0631\u0627\u062A\u0643 \u063A\u064A\u0631 \u0627\u0644\u0645\u062D\u0641\u0648\u0638\u0629).",
      conflictKeep: "\u062D\u0641\u0638 \u0646\u0633\u062E\u062A\u064A",
      conflictReload: "\u0625\u0639\u0627\u062F\u0629 \u062A\u062D\u0645\u064A\u0644 \u0622\u062E\u0631 \u0646\u0633\u062E\u0629"
    },
    publish: {
      title: "\u0646\u0634\u0631 \xAB{title}\xBB\u061F",
      number: "\u064A\u062D\u0635\u0644 \u0627\u0644\u0645\u062D\u0636\u0631 \u0639\u0644\u0649 \u0631\u0642\u0645\u0647 \u0627\u0644\u0646\u0647\u0627\u0626\u064A (PV-NNN) \u0628\u062D\u0633\u0628 \u062A\u0631\u062A\u064A\u0628 \u0627\u0644\u0645\u0634\u0631\u0648\u0639.",
      tasks: "{count, plural, =0 {\u0644\u0646 \u064A\u062A\u062D\u0648\u0651\u0644 \u0623\u064A \u0625\u062C\u0631\u0627\u0621 \u0625\u0644\u0649 \u0645\u0647\u0645\u0629.} one {\u064A\u062A\u062D\u0648\u0651\u0644 \u0627\u0644\u0625\u062C\u0631\u0627\u0621 \u0625\u0644\u0649 \u0645\u0647\u0645\u0629 \u0641\u064A \u0627\u0644\u0645\u0634\u0631\u0648\u0639.} two {\u064A\u062A\u062D\u0648\u0651\u0644 \u0627\u0644\u0625\u062C\u0631\u0627\u0621\u0627\u0646 \u0625\u0644\u0649 \u0645\u0647\u0645\u062A\u064A\u0646 \u0641\u064A \u0627\u0644\u0645\u0634\u0631\u0648\u0639.} few {\u062A\u062A\u062D\u0648\u0651\u0644 # \u0625\u062C\u0631\u0627\u0621\u0627\u062A \u0625\u0644\u0649 \u0645\u0647\u0627\u0645 \u0641\u064A \u0627\u0644\u0645\u0634\u0631\u0648\u0639.} many {\u062A\u062A\u062D\u0648\u0651\u0644 # \u0625\u062C\u0631\u0627\u0621\u064B \u0625\u0644\u0649 \u0645\u0647\u0627\u0645 \u0641\u064A \u0627\u0644\u0645\u0634\u0631\u0648\u0639.} other {\u062A\u062A\u062D\u0648\u0651\u0644 # \u0625\u062C\u0631\u0627\u0621 \u0625\u0644\u0649 \u0645\u0647\u0627\u0645 \u0641\u064A \u0627\u0644\u0645\u0634\u0631\u0648\u0639.}}",
      final: "\u0644\u0646 \u064A\u0645\u0643\u0646 \u062A\u0639\u062F\u064A\u0644\u0647 \u0628\u0639\u062F \u0630\u0644\u0643\u060C \u0648\u0633\u064A\u064F\u0628\u0644\u064E\u0651\u063A \u0627\u0644\u0645\u0634\u0627\u0631\u0643\u0648\u0646.",
      confirm: "\u0646\u0634\u0631",
      cancel: "\u0625\u0644\u063A\u0627\u0621"
    },
    view: {
      pdf: "\u062A\u0646\u0632\u064A\u0644 \u0645\u0644\u0641 PDF",
      pdfOpening: "\u062C\u0627\u0631\u064D \u0641\u062A\u062D \u0627\u0644\u0645\u0644\u0641\u2026",
      pdfRetry: "\u0625\u0639\u0627\u062F\u0629 \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629",
      pdfPreparing: "\u0645\u0644\u0641 PDF \u0642\u064A\u062F \u0627\u0644\u0625\u0639\u062F\u0627\u062F. \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629 \u0628\u0639\u062F \u0644\u062D\u0638\u0627\u062A.",
      pdfFailed: "\u062A\u0639\u0630\u0651\u0631 \u0641\u062A\u062D \u0645\u0644\u0641 PDF. \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629 \u0628\u0639\u062F \u0644\u062D\u0638\u0627\u062A.",
      openTask: "\u0639\u0631\u0636 \u0627\u0644\u0645\u0647\u0645\u0629",
      meeting: "\u0639\u0631\u0636 \u0627\u0644\u0627\u062C\u062A\u0645\u0627\u0639"
    },
    page: {
      back: "\u0631\u062C\u0648\u0639",
      notFound: "\u0627\u0644\u0645\u062D\u0636\u0631 \u063A\u064A\u0631 \u0645\u0648\u062C\u0648\u062F",
      notFoundBody: "\u0647\u0630\u0627 \u0627\u0644\u0645\u062D\u0636\u0631 \u063A\u064A\u0631 \u0645\u0648\u062C\u0648\u062F \u0623\u0648 \u0644\u064A\u0633 \u0644\u062F\u064A\u0643 \u062D\u0642 \u0627\u0644\u0648\u0635\u0648\u0644 \u0625\u0644\u064A\u0647.",
      loadFailed: "\u062A\u0639\u0630\u0651\u0631 \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0645\u062D\u0636\u0631",
      loadFailedBody: "\u062A\u062D\u0642\u0651\u0642 \u0645\u0646 \u0627\u062A\u0635\u0627\u0644\u0643 \u062B\u0645 \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629."
    },
    create: {
      title: "\u0645\u062D\u0636\u0631 \u062C\u062F\u064A\u062F",
      intro: "\u0627\u062E\u062A\u0631 \u0646\u0645\u0648\u0630\u062C \u0627\u0644\u0645\u062D\u0636\u0631 \u0648\u0644\u063A\u062A\u0647. \u064A\u064F\u0636\u0627\u0641 \u0627\u0644\u0645\u0634\u0627\u0631\u0643\u0648\u0646 \u0641\u064A \u0627\u0644\u0627\u062C\u062A\u0645\u0627\u0639 \u062A\u0644\u0642\u0627\u0626\u064A\u064B\u0627.",
      submit: "\u0625\u0646\u0634\u0627\u0621 \u0627\u0644\u0645\u0633\u0648\u062F\u0629",
      creating: "\u062C\u0627\u0631\u064D \u0625\u0646\u0634\u0627\u0621 \u0627\u0644\u0645\u0633\u0648\u062F\u0629\u2026",
      cancel: "\u0625\u0644\u063A\u0627\u0621",
      notForCalls: "\u0627\u0644\u0645\u0643\u0627\u0644\u0645\u0629 \u0627\u0644\u0628\u0633\u064A\u0637\u0629 \u0644\u064A\u0633 \u0644\u0647\u0627 \u0645\u062D\u0636\u0631.",
      forbidden: "\u0644\u064A\u0633 \u0644\u062F\u064A\u0643 \u0627\u0644\u062D\u0642 \u0641\u064A \u062A\u062D\u0631\u064A\u0631 \u0645\u062D\u0636\u0631 \u0647\u0630\u0627 \u0627\u0644\u0627\u062C\u062A\u0645\u0627\u0639.",
      failed: "\u062A\u0639\u0630\u0651\u0631 \u0625\u0646\u0634\u0627\u0621 \u0627\u0644\u0645\u0633\u0648\u062F\u0629. \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629 \u0628\u0639\u062F \u0644\u062D\u0638\u0627\u062A.",
      missingTitle: "\u064A\u062C\u0628 \u062A\u062D\u062F\u064A\u062F \u0627\u0644\u0627\u062C\u062A\u0645\u0627\u0639",
      missingBody: "\u0627\u0641\u062A\u062D \u0627\u0644\u0645\u062D\u0636\u0631 \u0645\u0646 \u0627\u062C\u062A\u0645\u0627\u0639 \u0645\u0646\u062A\u0647\u064D \u0623\u0648 \u0645\u0646 \u062D\u062F\u062B \u0641\u064A \u0627\u0644\u062A\u0642\u0648\u064A\u0645."
    },
    list: {
      title: "\u0627\u0644\u0645\u062D\u0627\u0636\u0631",
      loadFailed: "\u062A\u0639\u0630\u0651\u0631 \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0645\u062D\u0627\u0636\u0631. \u062A\u062D\u0642\u0651\u0642 \u0645\u0646 \u0627\u062A\u0635\u0627\u0644\u0643 \u062B\u0645 \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629.",
      actions: "{count, plural, =0 {\u0644\u0627 \u0625\u062C\u0631\u0627\u0621\u0627\u062A} one {\u0625\u062C\u0631\u0627\u0621 \u0648\u0627\u062D\u062F} two {\u0625\u062C\u0631\u0627\u0621\u0627\u0646} few {# \u0625\u062C\u0631\u0627\u0621\u0627\u062A} many {# \u0625\u062C\u0631\u0627\u0621\u064B} other {# \u0625\u062C\u0631\u0627\u0621}}"
    }
  },
  card: {
    separator: "\u060C ",
    with: "\u0645\u0639 {names}",
    withMore: "\u0645\u0639 {names} \u0648{count} \u0622\u062E\u0631\u064A\u0646",
    host: "\u064A\u0646\u0638\u0651\u0645\u0647 {name}",
    startedAt: "\u0628\u062F\u0623 \u0641\u064A",
    scheduledFor: "\u0645\u0642\u0631\u0651\u0631 \u0641\u064A",
    present: "{count, plural, =0 {\u0644\u0627 \u0623\u062D\u062F \u0641\u064A \u0627\u0644\u0642\u0627\u0639\u0629} one {\u0634\u062E\u0635 \u0648\u0627\u062D\u062F \u0641\u064A \u0627\u0644\u0642\u0627\u0639\u0629} two {\u0634\u062E\u0635\u0627\u0646 \u0641\u064A \u0627\u0644\u0642\u0627\u0639\u0629} few {# \u0623\u0634\u062E\u0627\u0635 \u0641\u064A \u0627\u0644\u0642\u0627\u0639\u0629} many {# \u0634\u062E\u0635\u064B\u0627 \u0641\u064A \u0627\u0644\u0642\u0627\u0639\u0629} other {# \u0634\u062E\u0635 \u0641\u064A \u0627\u0644\u0642\u0627\u0639\u0629}}",
    joinLabel: "\u0627\u0644\u0627\u0646\u0636\u0645\u0627\u0645 \u0625\u0644\u0649 \u0627\u0644\u0627\u062C\u062A\u0645\u0627\u0639 {title}"
  },
  sections: {
    live: "\u062C\u0627\u0631\u064A\u0629 \u0627\u0644\u0622\u0646",
    scheduled: "\u0627\u0644\u0642\u0627\u062F\u0645\u0629",
    ended: "\u0627\u0644\u0633\u0627\u0628\u0642\u0629"
  },
  list: {
    loadFailed: "\u062A\u0639\u0630\u0651\u0631 \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0627\u062C\u062A\u0645\u0627\u0639\u0627\u062A. \u062A\u062D\u0642\u0651\u0642 \u0645\u0646 \u0627\u062A\u0635\u0627\u0644\u0643 \u062B\u0645 \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629.",
    retry: "\u0625\u0639\u0627\u062F\u0629 \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629",
    empty: {
      title: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0627\u062C\u062A\u0645\u0627\u0639\u0627\u062A \u0628\u0639\u062F",
      withAction: "\u0627\u0628\u062F\u0623 \u0627\u062C\u062A\u0645\u0627\u0639\u064B\u0627 \u0644\u0644\u062A\u062D\u062F\u062B \u0645\u0628\u0627\u0634\u0631\u0629 \u0645\u0639 \u0627\u0644\u0641\u0631\u064A\u0642.",
      readOnly: "\u0633\u062A\u0638\u0647\u0631 \u0627\u062C\u062A\u0645\u0627\u0639\u0627\u062A \u0647\u0630\u0647 \u0627\u0644\u0645\u0633\u0627\u062D\u0629 \u0647\u0646\u0627 \u0639\u0646\u062F \u062A\u0646\u0638\u064A\u0645\u0647\u0627."
    }
  },
  returnBar: {
    label: "\u0627\u062C\u062A\u0645\u0627\u0639 \u062C\u0627\u0631\u064D",
    text: "\u0627\u062C\u062A\u0645\u0627\u0639 \u062C\u0627\u0631\u064D: {title}",
    back: "\u0627\u0644\u0639\u0648\u062F\u0629 \u0625\u0644\u0649 \u0627\u0644\u0627\u062C\u062A\u0645\u0627\u0639",
    leave: "\u0625\u062E\u0641\u0627\u0621"
  }
};

// locales/en/meetings.json
var meetings_default2 = {
  page: {
    loading: "Opening the meeting\u2026",
    back: "Back",
    notFound: {
      title: "Meeting not found",
      body: "This meeting does not exist or you do not have access to it. Ask the organiser to invite you."
    },
    loadFailed: {
      title: "Could not open the meeting",
      body: "The connection to the server failed. Check your connection and try again."
    }
  },
  ended: {
    title: "This meeting has ended",
    body: "Nobody is in the room any more. You can start a new meeting from the project or the conversation.",
    back: "Back"
  },
  removed: {
    title: "You were removed from the meeting",
    body: "Your access to this meeting was withdrawn. Contact the organiser if this is a mistake."
  },
  left: {
    title: "You left the meeting",
    body: "The meeting goes on for the other participants.",
    rejoin: "Rejoin",
    leave: "Close"
  },
  call: {
    action: "Call",
    failed: "Could not start the call right now. Try again in a moment.",
    missed: "Missed call",
    live: "Call in progress",
    line: "Call",
    ringing: "Calling\u2026",
    waiting: "Waiting for an answer\u2026",
    hangUp: "Hang up",
    controls: "Call controls",
    selfView: "Your video",
    connecting: "Connecting to the call\u2026",
    retry: "Try again",
    close: "Close",
    joinLabel: "Join the call",
    ended: {
      title: "Call ended",
      body: "The call has ended. You can close this window."
    }
  },
  join: {
    action: "Join"
  },
  start: {
    action: "Start a meeting",
    title: "Start a meeting",
    titleLabel: "Meeting title",
    titleInvalid: "Enter a title of 200 characters or fewer.",
    defaultTitle: "Meeting - {project}",
    cancel: "Cancel",
    confirm: "Start",
    failed: "Could not create the meeting. Try again in a moment.",
    new: "New meeting",
    channelTitle: "Meeting - {channel}"
  },
  invite: {
    title: "Invite",
    intro: "Enter the e-mail address of the person to invite. They receive an e-mail with the link and must sign in with a BatiFlow account using that address.",
    emailLabel: "Guest's email address",
    emailInvalid: "Enter a valid email address.",
    create: "Create the link",
    cancel: "Cancel",
    failed: "Could not create the invitation. Check that you are allowed to invite to this meeting, then try again.",
    created: "Invitation e-mailed to {email}. You can also copy the link and send it yourself:",
    linkLabel: "Invitation link",
    copy: "Copy link",
    copied: "Link copied.",
    copyFailed: "Could not copy: select the link and copy it by hand.",
    warning: "This link works only once and for 7 days. It is shown only here: copy it now. Valid until",
    done: "Done",
    close: "Close",
    parts: {
      people: "People",
      email: "By e-mail"
    },
    people: {
      intro: "Pick members of your organisation. They get a notification in BatiFlow and can join right away.",
      label: "People to invite",
      none: "Pick at least one person.",
      membersFailed: "The member list could not be loaded. Try again in a moment.",
      notMember: "This person is not part of the organisation. Invite them by e-mail.",
      forbidden: "You are not allowed to invite to this meeting. Only the organiser and the space managers can.",
      failed: "The invitations could not be sent. Try again in a moment.",
      done: "{count, plural, one {# person invited.} other {# people invited.}}",
      already: "These people are already invited.",
      submit: "Invite"
    }
  },
  incoming: {
    title: "{name} is calling you",
    body: "Incoming call",
    accept: "Accept",
    decline: "Decline"
  },
  prejoin: {
    title: "Ready to join?",
    previewLabel: "Preview of your camera",
    cameraOff: "Camera off",
    microphone: "Microphone",
    camera: "Camera",
    cameraDevice: "Camera",
    microphoneDevice: "Microphone",
    defaultDevice: "Default",
    unnamedDevice: "Device {index}",
    denied: {
      title: "Camera and microphone access denied",
      body: "BatiFlow needs your permission to see and hear you. Allow access in your browser settings (the icon next to the address), then try again. You can also join without camera or microphone.",
      retry: "Try again"
    },
    unavailable: "Your browser does not allow the camera and microphone on this page. You can join the meeting as a listener.",
    missing: "No camera was found. You can join with the microphone only.",
    inRoom: "In the meeting now",
    nobody: "Nobody is in the meeting yet.",
    join: "Join",
    joining: "Connecting\u2026",
    micTurnOff: "Mute the microphone",
    micTurnOn: "Turn the microphone on",
    cameraTurnOff: "Turn the camera off",
    cameraTurnOn: "Turn the camera on",
    joiningAs: "You are joining as {name}"
  },
  problems: {
    full: {
      title: "Meeting full",
      owner: "This meeting has reached the maximum number of participants of your plan. Upgrade your plan to welcome more people.",
      member: "This meeting has reached the maximum number of participants of your office's plan. Contact your administrator."
    },
    ended: {
      title: "Meeting ended",
      body: "This meeting has ended: you can no longer join it."
    },
    forbidden: {
      title: "Access denied",
      body: "You are not allowed to join this meeting. Ask the organiser to invite you."
    },
    emailMismatch: {
      title: "Invitation for another address",
      body: "This invitation was sent to a different email address than the one of your account."
    },
    invitationInvalid: {
      title: "Invalid invitation",
      body: "This invitation link is not valid, was already used or has expired. Ask for a new one."
    },
    unavailable: {
      title: "Cannot connect",
      body: "The meeting service is not answering right now. Check your connection and try again."
    },
    other: {
      title: "Could not join",
      body: "The meeting could not be joined. Try again in a moment."
    }
  },
  room: {
    you: "{name} (you)",
    external: "External",
    micOff: "microphone off",
    handRaised: "raised a hand",
    speaking: "Speaking",
    videoPaused: "video off",
    screenOf: "{name}'s screen",
    tiles: "Participants",
    stage: "Speaker",
    people: "{count, plural, one {# person} other {# people}}",
    reconnecting: "Reconnecting\u2026",
    layout: "Layout",
    layoutGrid: "Grid",
    layoutSpeaker: "Speaker",
    shortcuts: "Keyboard shortcuts",
    lostTrying: "Connection lost. Trying again\u2026",
    lostFailed: "Could not restore the connection. Check your network, then reconnect.",
    reconnect: "Reconnect",
    reconnectingBanner: "Reconnecting\u2026 You are still in the meeting.",
    audioOnly: "Weak connection: video turned off, audio only",
    audioOnlyRetry: "Try video again",
    problems: {
      "media-denied": "Access to the camera or microphone is denied. Allow it in your browser settings, then try again.",
      "media-missing": "No camera or microphone was found on this device.",
      "media-failed": "The camera, microphone or screen sharing could not start. Try again."
    },
    audioBlocked: "Your browser blocks sound until you interact with the page.",
    audioStart: "Turn on sound",
    closePanel: "Close panel",
    elapsed: "Duration",
    resizePanel: "Resize the panel"
  },
  controls: {
    label: "Meeting controls",
    mic: "Microphone",
    micHint: "Turn the microphone on or off ({keys})",
    camera: "Camera",
    cameraHint: "Turn the camera on or off ({keys})",
    share: "Share screen",
    hand: "Raise hand",
    participants: "Participants",
    chat: "Chat",
    chatUnread: "Chat, {count, plural, one {# unread message} other {# unread messages}}",
    invite: "Invite",
    leave: "Leave",
    shareStop: "Stop sharing"
  },
  participants: {
    label: "{count, plural, one {# participant} other {# participants}}",
    micOn: "microphone on",
    cameraOn: "camera on",
    cameraOff: "camera off"
  },
  chat: {
    notStored: "These messages are not saved. They disappear when the meeting ends.",
    label: "Meeting messages",
    empty: "No messages yet.",
    sendFailed: "The message was not sent. Try again.",
    input: "Write a message",
    placeholder: "Write a message",
    send: "Send",
    hint: "Enter to send, Shift+Enter for a new line."
  },
  announce: {
    handRaised: "{name} raised a hand.",
    joined: "{name} joined the meeting.",
    left: "{name} left the meeting."
  },
  guest: {
    opening: "Opening the invitation\u2026",
    loading: "Checking the invitation\u2026",
    toHome: "Go to the home page",
    invitedBy: "Invitation from {organization}",
    missing: {
      title: "Invitation link not found",
      body: "Open the link you received again to join the meeting. If the problem continues, ask for a new invitation."
    },
    invalid: {
      title: "Invalid invitation",
      body: "This invitation link is not valid, was already used or has expired. Ask the person who invited you for a new one."
    },
    unavailable: {
      title: "Invitation unavailable",
      body: "The invitation could not be checked right now. Try again in a moment."
    },
    mismatch: {
      title: "Invitation for another address",
      body: "This invitation was sent to a different email address than the one of your account, so you cannot join the meeting with this account.",
      next: "Sign out, then sign in again with the account of the invited address, or ask the person who invited you for a new invitation."
    },
    signOutFailed: "Signing out failed. Try again in a moment."
  },
  duration: {
    minutes: "{count} min",
    hoursMinutes: "{hours} h {minutes}"
  },
  status: {
    live: "Live",
    scheduled: "Scheduled",
    ended: "Ended"
  },
  minutes: {
    draftNumber: "Minutes",
    open: "Open the minutes {number}",
    write: "Write the minutes",
    prompt: "You can now write the minutes of this meeting.",
    title: "Minutes",
    status: {
      draft: "Draft",
      published: "Published"
    },
    template: {
      coordination: "Coordination meeting",
      moa: "Client (project owner) meeting",
      site_meeting: "Site meeting",
      site_visit: "Site visit"
    },
    language: {
      fr: "French",
      ar: "Arabic",
      en: "English"
    },
    kind: {
      point: {
        title: "Points discussed",
        none: "No points yet.",
        item: "Point {number}",
        add: "Add a point"
      },
      decision: {
        title: "Decisions",
        none: "No decisions yet.",
        item: "Decision {number}",
        add: "Add a decision"
      },
      action: {
        title: "Actions",
        none: "No actions yet.",
        item: "Action {number}",
        add: "Add an action"
      }
    },
    doc: {
      label: "Minutes",
      attendees: "Attendees",
      noAttendees: "No attendees noted.",
      present: "Present:",
      absent: "Absent:",
      nobody: "nobody",
      separator: ", ",
      assignee: "Assigned to:",
      unassigned: "to be assigned",
      due: "Due:",
      carried: "Carried over from {number}"
    },
    editor: {
      info: "Details",
      title: "Title",
      titleRequired: "Give the minutes a title.",
      template: "Template",
      language: "Language of the minutes",
      date: "Meeting date",
      dateRequired: "Enter the date of the meeting.",
      time: "Time",
      timeRequired: "Enter the time, for example 09:30.",
      timeZone: "Date and time in Tunis.",
      location: "Place",
      attendees: "Attendees",
      noAttendees: "No attendees yet.",
      nameRequired: "The name is required.",
      present: "Present",
      absent: "Absent",
      presenceOf: "Attendance of {name}",
      removeAttendee: "Remove {name} from the attendees",
      attendeeName: "Add an attendee (name)",
      attendeeOrganization: "Company or organisation",
      addAttendee: "Add",
      itemRequired: "Write the text before saving.",
      assignee: "Assigned to",
      noAssignee: "Nobody yet",
      assigneeNotMember: "This person is no longer a member of the project: choose another person.",
      itemInvalid: "This text could not be saved, please check it.",
      itemsInvalid: "Some items could not be saved. Check them and try again.",
      dueDate: "Due date",
      moveUp: "Move up: {item}",
      moveDown: "Move down: {item}",
      removeItem: "Delete: {item}",
      remove: "Delete",
      unsaved: "Unsaved changes",
      saved: "Everything is saved",
      savedNotice: "The draft is saved.",
      save: "Save",
      saving: "Saving\u2026",
      preview: "Preview",
      backToEdit: "Back to editing",
      publish: "Publish",
      saveFailed: "The draft could not be saved. Your text is kept: try again.",
      forbidden: "You are not allowed to change these minutes.",
      alreadyPublished: "These minutes have just been published: they can no longer be changed.",
      fixFirst: "Complete the highlighted fields before saving.",
      conflictTitle: "Someone changed these minutes.",
      conflictBody: "Your text is kept. Save your version to replace the other person\u2019s, or reload the latest version (your unsaved changes will be lost).",
      conflictKeep: "Save my version",
      conflictReload: "Reload the latest version"
    },
    publish: {
      title: "Publish \u201C{title}\u201D?",
      number: "The minutes get their final number (PV-NNN) in the order of the project.",
      tasks: "{count, plural, =0 {No action becomes a task.} one {The action becomes a task of the project.} other {The # actions become tasks of the project.}}",
      final: "They can no longer be changed, and the attendees will be told.",
      confirm: "Publish",
      cancel: "Cancel"
    },
    view: {
      pdf: "Download the PDF",
      pdfOpening: "Opening the PDF\u2026",
      pdfRetry: "Try again",
      pdfPreparing: "The PDF is being prepared. Try again in a moment.",
      pdfFailed: "The PDF could not be opened. Try again in a moment.",
      openTask: "View the task",
      meeting: "View the meeting"
    },
    page: {
      back: "Back",
      notFound: "Minutes not found",
      notFoundBody: "These minutes do not exist, or you do not have access to them.",
      loadFailed: "The minutes could not be loaded",
      loadFailedBody: "Check your connection and try again."
    },
    create: {
      title: "New minutes",
      intro: "Choose the template and the language of the minutes. The people who attended the meeting are added automatically.",
      submit: "Create the draft",
      creating: "Creating the draft\u2026",
      cancel: "Cancel",
      notForCalls: "A simple call has no minutes.",
      forbidden: "You are not allowed to write the minutes of this meeting.",
      failed: "The draft could not be created. Try again in a moment.",
      missingTitle: "Meeting needed",
      missingBody: "Open the minutes from a finished meeting or from a calendar event."
    },
    list: {
      title: "Minutes",
      loadFailed: "Minutes could not be loaded. Check your connection and try again.",
      actions: "{count, plural, =0 {no actions} one {# action} other {# actions}}"
    }
  },
  card: {
    separator: ", ",
    with: "With {names}",
    withMore: "With {names} and {count} more",
    host: "Hosted by {name}",
    startedAt: "Started",
    scheduledFor: "Planned for",
    present: "{count, plural, =0 {Nobody is in the room} one {# person in the room} other {# people in the room}}",
    joinLabel: "Join the meeting {title}"
  },
  sections: {
    live: "Live now",
    scheduled: "Upcoming",
    ended: "Past"
  },
  list: {
    loadFailed: "Meetings could not be loaded. Check your connection and try again.",
    retry: "Try again",
    empty: {
      title: "No meetings yet",
      withAction: "Start a meeting to talk live with the team.",
      readOnly: "Meetings of this space will appear here once they are organised."
    }
  },
  returnBar: {
    label: "Meeting in progress",
    text: "A meeting is in progress: {title}",
    back: "Back to the meeting",
    leave: "Dismiss"
  }
};

// locales/fr/meetings.json
var meetings_default3 = {
  page: {
    loading: "Ouverture de la r\xE9union\u2026",
    back: "Retour",
    notFound: {
      title: "R\xE9union introuvable",
      body: "Cette r\xE9union n'existe pas ou vous n'y avez pas acc\xE8s. Demandez \xE0 la personne qui l'organise de vous inviter."
    },
    loadFailed: {
      title: "Impossible d'ouvrir la r\xE9union",
      body: "La connexion au serveur a \xE9chou\xE9. V\xE9rifiez votre connexion puis r\xE9essayez."
    }
  },
  ended: {
    title: "Cette r\xE9union est termin\xE9e",
    body: "Plus personne n'est dans la salle. Vous pouvez en d\xE9marrer une nouvelle depuis le projet ou la conversation.",
    back: "Retour"
  },
  removed: {
    title: "Vous avez \xE9t\xE9 retir\xE9 de la r\xE9union",
    body: "Votre acc\xE8s \xE0 cette r\xE9union a \xE9t\xE9 retir\xE9. Contactez la personne qui l'organise si c'est une erreur."
  },
  left: {
    title: "Vous avez quitt\xE9 la r\xE9union",
    body: "La r\xE9union continue pour les autres participants.",
    rejoin: "Rejoindre \xE0 nouveau",
    leave: "Fermer"
  },
  call: {
    action: "Appeler",
    failed: "Impossible de d\xE9marrer l'appel pour le moment. R\xE9essayez dans un instant.",
    missed: "Appel manqu\xE9",
    live: "Appel en cours",
    line: "Appel",
    ringing: "Appel en cours\u2026",
    waiting: "En attente de r\xE9ponse\u2026",
    hangUp: "Raccrocher",
    controls: "Commandes de l'appel",
    selfView: "Votre image",
    connecting: "Connexion \xE0 l'appel\u2026",
    retry: "R\xE9essayer",
    close: "Fermer",
    joinLabel: "Rejoindre l'appel",
    ended: {
      title: "Appel termin\xE9",
      body: "L'appel est termin\xE9. Vous pouvez fermer cette fen\xEAtre."
    }
  },
  join: {
    action: "Rejoindre"
  },
  start: {
    action: "D\xE9marrer une r\xE9union",
    title: "D\xE9marrer une r\xE9union",
    titleLabel: "Titre de la r\xE9union",
    titleInvalid: "Saisissez un titre de 200 caract\xE8res au plus.",
    defaultTitle: "R\xE9union - {project}",
    cancel: "Annuler",
    confirm: "D\xE9marrer",
    failed: "Impossible de cr\xE9er la r\xE9union. R\xE9essayez dans un instant.",
    new: "Nouvelle r\xE9union",
    channelTitle: "R\xE9union - {channel}"
  },
  invite: {
    title: "Inviter",
    intro: "Saisissez l\u2019adresse e-mail de la personne \xE0 inviter. Elle re\xE7oit un e-mail avec le lien et devra se connecter avec un compte BatiFlow utilisant cette adresse.",
    emailLabel: "Adresse e-mail de l'invit\xE9",
    emailInvalid: "Saisissez une adresse e-mail valide.",
    create: "Cr\xE9er le lien",
    cancel: "Annuler",
    failed: "Impossible de cr\xE9er l'invitation. V\xE9rifiez que vous avez le droit d'inviter \xE0 cette r\xE9union, puis r\xE9essayez.",
    created: "Invitation envoy\xE9e par e-mail \xE0 {email}. Vous pouvez aussi copier le lien et l\u2019envoyer vous-m\xEAme\xA0:",
    linkLabel: "Lien d'invitation",
    copy: "Copier le lien",
    copied: "Lien copi\xE9.",
    copyFailed: "Copie impossible : s\xE9lectionnez le lien et copiez-le \xE0 la main.",
    warning: "Ce lien ne fonctionne qu'une seule fois et pendant 7 jours. Il n'est affich\xE9 qu'ici : copiez-le maintenant. Valable jusqu'au",
    done: "Termin\xE9",
    close: "Fermer",
    parts: {
      people: "Personnes",
      email: "Par e-mail"
    },
    people: {
      intro: "Choisissez des membres de votre organisation. Ils re\xE7oivent une notification dans BatiFlow et peuvent rejoindre aussit\xF4t.",
      label: "Personnes \xE0 inviter",
      none: "Choisissez au moins une personne.",
      membersFailed: "Impossible de charger la liste des membres. R\xE9essayez dans un instant.",
      notMember: "Cette personne ne fait pas partie de l\u2019organisation. Invitez-la par e-mail.",
      forbidden: "Vous n\u2019avez pas le droit d\u2019inviter \xE0 cette r\xE9union. Seuls l\u2019organisateur et les responsables de l\u2019espace le peuvent.",
      failed: "Impossible d\u2019envoyer les invitations. R\xE9essayez dans un instant.",
      done: "{count, plural, one {# personne invit\xE9e.} other {# personnes invit\xE9es.}}",
      already: "Ces personnes sont d\xE9j\xE0 invit\xE9es.",
      submit: "Inviter"
    }
  },
  incoming: {
    title: "{name} vous appelle",
    body: "Appel entrant",
    accept: "Accepter",
    decline: "Refuser"
  },
  prejoin: {
    title: "Pr\xEAt \xE0 rejoindre ?",
    previewLabel: "Aper\xE7u de votre cam\xE9ra",
    cameraOff: "Cam\xE9ra d\xE9sactiv\xE9e",
    microphone: "Microphone",
    camera: "Cam\xE9ra",
    cameraDevice: "Cam\xE9ra",
    microphoneDevice: "Microphone",
    defaultDevice: "Par d\xE9faut",
    unnamedDevice: "Appareil {index}",
    denied: {
      title: "Acc\xE8s \xE0 la cam\xE9ra et au micro refus\xE9",
      body: "BatiFlow a besoin de votre autorisation pour vous voir et vous entendre. Autorisez l'acc\xE8s dans les r\xE9glages de votre navigateur (ic\xF4ne \xE0 gauche de l'adresse), puis r\xE9essayez. Vous pouvez aussi rejoindre sans cam\xE9ra ni micro.",
      retry: "R\xE9essayer"
    },
    unavailable: "Votre navigateur ne permet pas d'utiliser la cam\xE9ra et le micro sur cette page. Vous pouvez rejoindre la r\xE9union en \xE9coute seule.",
    missing: "Aucune cam\xE9ra n'a \xE9t\xE9 trouv\xE9e. Vous pouvez rejoindre avec le micro seulement.",
    inRoom: "Dans la r\xE9union maintenant",
    nobody: "Personne n'est encore dans la r\xE9union.",
    join: "Rejoindre",
    joining: "Connexion\u2026",
    micTurnOff: "Couper le micro",
    micTurnOn: "Activer le micro",
    cameraTurnOff: "Couper la cam\xE9ra",
    cameraTurnOn: "Activer la cam\xE9ra",
    joiningAs: "Vous rejoignez en tant que {name}"
  },
  problems: {
    full: {
      title: "R\xE9union compl\xE8te",
      owner: "Cette r\xE9union a atteint le nombre maximal de participants de votre offre. Passez \xE0 une offre sup\xE9rieure pour accueillir plus de monde.",
      member: "Cette r\xE9union a atteint le nombre maximal de participants de l'offre de votre bureau. Contactez votre administrateur."
    },
    ended: {
      title: "R\xE9union termin\xE9e",
      body: "Cette r\xE9union est termin\xE9e : vous ne pouvez plus la rejoindre."
    },
    forbidden: {
      title: "Acc\xE8s refus\xE9",
      body: "Vous n'avez pas le droit de rejoindre cette r\xE9union. Demandez \xE0 la personne qui l'organise de vous inviter."
    },
    emailMismatch: {
      title: "Invitation destin\xE9e \xE0 une autre adresse",
      body: "Cette invitation a \xE9t\xE9 envoy\xE9e \xE0 une autre adresse e-mail que celle de votre compte."
    },
    invitationInvalid: {
      title: "Invitation invalide",
      body: "Ce lien d'invitation n'est pas valide, a d\xE9j\xE0 \xE9t\xE9 utilis\xE9 ou a expir\xE9. Demandez-en un nouveau."
    },
    unavailable: {
      title: "Connexion impossible",
      body: "Le service de r\xE9union ne r\xE9pond pas pour le moment. V\xE9rifiez votre connexion puis r\xE9essayez."
    },
    other: {
      title: "Impossible de rejoindre",
      body: "La r\xE9union n'a pas pu \xEAtre rejointe. R\xE9essayez dans un instant."
    }
  },
  room: {
    you: "{name} (vous)",
    external: "Externe",
    micOff: "micro coup\xE9",
    handRaised: "a lev\xE9 la main",
    speaking: "En train de parler",
    videoPaused: "vid\xE9o d\xE9sactiv\xE9e",
    screenOf: "\xC9cran de {name}",
    tiles: "Participants",
    stage: "Intervenant",
    people: "{count, plural, one {# personne} other {# personnes}}",
    reconnecting: "Reconnexion\u2026",
    layout: "Disposition",
    layoutGrid: "Grille",
    layoutSpeaker: "Orateur",
    shortcuts: "Raccourcis clavier",
    lostTrying: "Connexion perdue. Nouvelle tentative en cours\u2026",
    lostFailed: "Impossible de r\xE9tablir la connexion. V\xE9rifiez votre r\xE9seau puis reconnectez-vous.",
    reconnect: "Se reconnecter",
    reconnectingBanner: "Reconnexion en cours\u2026 Vous \xEAtes toujours dans la r\xE9union.",
    audioOnly: "Connexion faible : vid\xE9o d\xE9sactiv\xE9e, audio seulement",
    audioOnlyRetry: "R\xE9essayer la vid\xE9o",
    problems: {
      "media-denied": "L'acc\xE8s \xE0 la cam\xE9ra ou au micro est refus\xE9. Autorisez-le dans les r\xE9glages de votre navigateur, puis r\xE9essayez.",
      "media-missing": "Aucune cam\xE9ra ou aucun micro n'a \xE9t\xE9 trouv\xE9 sur cet appareil.",
      "media-failed": "La cam\xE9ra, le micro ou le partage d'\xE9cran n'a pas pu d\xE9marrer. R\xE9essayez."
    },
    audioBlocked: "Votre navigateur bloque le son tant que vous n'avez pas interagi avec la page.",
    audioStart: "Activer le son",
    closePanel: "Fermer le panneau",
    elapsed: "Dur\xE9e",
    resizePanel: "Redimensionner le panneau"
  },
  controls: {
    label: "Commandes de la r\xE9union",
    mic: "Microphone",
    micHint: "Activer ou couper le micro ({keys})",
    camera: "Cam\xE9ra",
    cameraHint: "Activer ou couper la cam\xE9ra ({keys})",
    share: "Partager l'\xE9cran",
    hand: "Lever la main",
    participants: "Participants",
    chat: "Conversation",
    chatUnread: "Conversation, {count, plural, one {# message non lu} other {# messages non lus}}",
    invite: "Inviter",
    leave: "Quitter",
    shareStop: "Arr\xEAter le partage"
  },
  participants: {
    label: "{count, plural, one {# participant} other {# participants}}",
    micOn: "micro activ\xE9",
    cameraOn: "cam\xE9ra activ\xE9e",
    cameraOff: "cam\xE9ra coup\xE9e"
  },
  chat: {
    notStored: "Ces messages ne sont pas enregistr\xE9s. Ils disparaissent \xE0 la fin de la r\xE9union.",
    label: "Messages de la r\xE9union",
    empty: "Aucun message pour le moment.",
    sendFailed: "Le message n'a pas \xE9t\xE9 envoy\xE9. R\xE9essayez.",
    input: "\xC9crire un message",
    placeholder: "\xC9crire un message",
    send: "Envoyer",
    hint: "Entr\xE9e pour envoyer, Maj+Entr\xE9e pour une nouvelle ligne."
  },
  announce: {
    handRaised: "{name} a lev\xE9 la main.",
    joined: "{name} a rejoint la r\xE9union.",
    left: "{name} a quitt\xE9 la r\xE9union."
  },
  guest: {
    opening: "Ouverture de l'invitation\u2026",
    loading: "V\xE9rification de l'invitation\u2026",
    toHome: "Aller \xE0 l'accueil",
    invitedBy: "Invitation de {organization}",
    missing: {
      title: "Lien d'invitation introuvable",
      body: "Ouvrez de nouveau le lien re\xE7u pour rejoindre la r\xE9union. Si le probl\xE8me continue, demandez une nouvelle invitation."
    },
    invalid: {
      title: "Invitation invalide",
      body: "Ce lien d'invitation n'est pas valide, a d\xE9j\xE0 \xE9t\xE9 utilis\xE9 ou a expir\xE9. Demandez-en un nouveau \xE0 la personne qui vous a invit\xE9."
    },
    unavailable: {
      title: "Invitation indisponible",
      body: "L'invitation n'a pas pu \xEAtre v\xE9rifi\xE9e pour le moment. R\xE9essayez dans un instant."
    },
    mismatch: {
      title: "Invitation destin\xE9e \xE0 une autre adresse",
      body: "Cette invitation a \xE9t\xE9 envoy\xE9e \xE0 une autre adresse e-mail que celle de votre compte. Vous ne pouvez donc pas rejoindre la r\xE9union avec ce compte.",
      next: "D\xE9connectez-vous puis reconnectez-vous avec le compte de l'adresse invit\xE9e, ou demandez une nouvelle invitation \xE0 la personne qui vous a invit\xE9."
    },
    signOutFailed: "La d\xE9connexion a \xE9chou\xE9. R\xE9essayez dans un instant."
  },
  duration: {
    minutes: "{count} min",
    hoursMinutes: "{hours} h {minutes}"
  },
  status: {
    live: "En cours",
    scheduled: "Pr\xE9vue",
    ended: "Termin\xE9e"
  },
  minutes: {
    draftNumber: "PV",
    open: "Ouvrir le proc\xE8s-verbal {number}",
    write: "R\xE9diger le proc\xE8s-verbal",
    prompt: "Vous pouvez maintenant r\xE9diger le proc\xE8s-verbal de cette r\xE9union.",
    title: "Proc\xE8s-verbal",
    status: {
      draft: "Brouillon",
      published: "Publi\xE9"
    },
    template: {
      coordination: "R\xE9union de coordination",
      moa: "R\xE9union avec la ma\xEEtrise d\u2019ouvrage",
      site_meeting: "R\xE9union de chantier",
      site_visit: "Visite de chantier"
    },
    language: {
      fr: "Fran\xE7ais",
      ar: "Arabe",
      en: "Anglais"
    },
    kind: {
      point: {
        title: "Points abord\xE9s",
        none: "Aucun point pour le moment.",
        item: "Point {number}",
        add: "Ajouter un point"
      },
      decision: {
        title: "D\xE9cisions",
        none: "Aucune d\xE9cision pour le moment.",
        item: "D\xE9cision {number}",
        add: "Ajouter une d\xE9cision"
      },
      action: {
        title: "Actions",
        none: "Aucune action pour le moment.",
        item: "Action {number}",
        add: "Ajouter une action"
      }
    },
    doc: {
      label: "Proc\xE8s-verbal",
      attendees: "Participants",
      noAttendees: "Aucun participant not\xE9.",
      present: "{count, plural, one {Pr\xE9sent\xA0:} other {Pr\xE9sents\xA0:}}",
      absent: "{count, plural, one {Absent\xA0:} other {Absents\xA0:}}",
      nobody: "personne",
      separator: ", ",
      assignee: "Responsable\xA0:",
      unassigned: "\xE0 d\xE9signer",
      due: "\xC9ch\xE9ance\xA0:",
      carried: "Report\xE9 du {number}"
    },
    editor: {
      info: "Informations",
      title: "Titre",
      titleRequired: "Donnez un titre au proc\xE8s-verbal.",
      template: "Mod\xE8le",
      language: "Langue du proc\xE8s-verbal",
      date: "Date de la r\xE9union",
      dateRequired: "Indiquez la date de la r\xE9union.",
      time: "Heure",
      timeRequired: "Indiquez l\u2019heure, par exemple 09:30.",
      timeZone: "Date et heure de Tunis.",
      location: "Lieu",
      attendees: "Participants",
      noAttendees: "Aucun participant pour le moment.",
      nameRequired: "Le nom est obligatoire.",
      present: "Pr\xE9sent",
      absent: "Absent",
      presenceOf: "Pr\xE9sence de {name}",
      removeAttendee: "Retirer {name} des participants",
      attendeeName: "Ajouter un participant (nom)",
      attendeeOrganization: "Soci\xE9t\xE9 ou organisme",
      addAttendee: "Ajouter",
      itemRequired: "\xC9crivez le texte avant d\u2019enregistrer.",
      assignee: "Responsable",
      noAssignee: "Personne pour le moment",
      assigneeNotMember: "Cette personne n\u2019est plus membre du projet : choisissez un autre responsable.",
      itemInvalid: "Ce texte n\u2019a pas pu \xEAtre enregistr\xE9, v\xE9rifiez-le.",
      itemsInvalid: "Certains points n\u2019ont pas pu \xEAtre enregistr\xE9s. V\xE9rifiez-les puis r\xE9essayez.",
      dueDate: "\xC9ch\xE9ance",
      moveUp: "Monter\xA0: {item}",
      moveDown: "Descendre\xA0: {item}",
      removeItem: "Supprimer\xA0: {item}",
      remove: "Supprimer",
      unsaved: "Modifications non enregistr\xE9es",
      saved: "Tout est enregistr\xE9",
      savedNotice: "Le brouillon est enregistr\xE9.",
      save: "Enregistrer",
      saving: "Enregistrement\u2026",
      preview: "Aper\xE7u",
      backToEdit: "Revenir \xE0 la r\xE9daction",
      publish: "Publier",
      saveFailed: "Le brouillon n\u2019a pas pu \xEAtre enregistr\xE9. Votre texte est conserv\xE9\xA0: r\xE9essayez.",
      forbidden: "Vous n\u2019avez pas le droit de modifier ce proc\xE8s-verbal.",
      alreadyPublished: "Ce proc\xE8s-verbal vient d\u2019\xEAtre publi\xE9\xA0: il ne peut plus \xEAtre modifi\xE9.",
      fixFirst: "Compl\xE9tez les champs signal\xE9s avant d\u2019enregistrer.",
      conflictTitle: "Quelqu\u2019un a modifi\xE9 ce proc\xE8s-verbal.",
      conflictBody: "Votre texte est conserv\xE9. Enregistrez votre version pour remplacer celle de l\u2019autre personne, ou rechargez la derni\xE8re version (vos changements non enregistr\xE9s seront perdus).",
      conflictKeep: "Enregistrer ma version",
      conflictReload: "Recharger la derni\xE8re version"
    },
    publish: {
      title: "Publier \xAB\xA0{title}\xA0\xBB\xA0?",
      number: "Le proc\xE8s-verbal re\xE7oit son num\xE9ro d\xE9finitif (PV-NNN) dans l\u2019ordre du projet.",
      tasks: "{count, plural, =0 {Aucune action ne devient une t\xE2che.} one {L\u2019action devient une t\xE2che du projet.} other {Les # actions deviennent des t\xE2ches du projet.}}",
      final: "Il ne pourra plus \xEAtre modifi\xE9, et les participants en seront inform\xE9s.",
      confirm: "Publier",
      cancel: "Annuler"
    },
    view: {
      pdf: "T\xE9l\xE9charger le PDF",
      pdfOpening: "Ouverture du PDF\u2026",
      pdfRetry: "R\xE9essayer",
      pdfPreparing: "Le PDF est en cours de pr\xE9paration. R\xE9essayez dans un instant.",
      pdfFailed: "Le PDF n\u2019a pas pu \xEAtre ouvert. R\xE9essayez dans un instant.",
      openTask: "Voir la t\xE2che",
      meeting: "Voir la r\xE9union"
    },
    page: {
      back: "Retour",
      notFound: "Proc\xE8s-verbal introuvable",
      notFoundBody: "Ce proc\xE8s-verbal n\u2019existe pas, ou vous n\u2019y avez pas acc\xE8s.",
      loadFailed: "Impossible de charger le proc\xE8s-verbal",
      loadFailedBody: "V\xE9rifiez votre connexion puis r\xE9essayez."
    },
    create: {
      title: "Nouveau proc\xE8s-verbal",
      intro: "Choisissez le mod\xE8le et la langue du proc\xE8s-verbal. Les participants de la r\xE9union sont repris automatiquement.",
      submit: "Cr\xE9er le brouillon",
      creating: "Cr\xE9ation du brouillon\u2026",
      cancel: "Annuler",
      notForCalls: "Un simple appel n\u2019a pas de proc\xE8s-verbal.",
      forbidden: "Vous n\u2019avez pas le droit de r\xE9diger un proc\xE8s-verbal pour cette r\xE9union.",
      failed: "Le brouillon n\u2019a pas pu \xEAtre cr\xE9\xE9. R\xE9essayez dans un instant.",
      missingTitle: "R\xE9union \xE0 indiquer",
      missingBody: "Ouvrez le proc\xE8s-verbal depuis une r\xE9union termin\xE9e ou depuis un \xE9v\xE9nement du calendrier."
    },
    list: {
      title: "Proc\xE8s-verbaux",
      loadFailed: "Impossible de charger les proc\xE8s-verbaux. V\xE9rifiez votre connexion puis r\xE9essayez.",
      actions: "{count, plural, =0 {aucune action} one {# action} other {# actions}}"
    }
  },
  card: {
    separator: ", ",
    with: "Avec {names}",
    withMore: "Avec {names} et {count} autre(s)",
    host: "Organis\xE9e par {name}",
    startedAt: "Commenc\xE9e le",
    scheduledFor: "Pr\xE9vue le",
    present: "{count, plural, =0 {Personne n\u2019est dans la salle} one {# personne dans la salle} other {# personnes dans la salle}}",
    joinLabel: "Rejoindre la r\xE9union {title}"
  },
  sections: {
    live: "En cours",
    scheduled: "\xC0 venir",
    ended: "Pass\xE9es"
  },
  list: {
    loadFailed: "Impossible de charger les r\xE9unions. V\xE9rifiez votre connexion puis r\xE9essayez.",
    retry: "R\xE9essayer",
    empty: {
      title: "Aucune r\xE9union pour le moment",
      withAction: "D\xE9marrez une r\xE9union pour \xE9changer en direct avec l\u2019\xE9quipe.",
      readOnly: "Les r\xE9unions de cet espace appara\xEEtront ici d\xE8s qu\u2019elles seront organis\xE9es."
    }
  },
  returnBar: {
    label: "R\xE9union en cours",
    text: "Une r\xE9union est en cours\xA0: {title}",
    back: "Revenir \xE0 la r\xE9union",
    leave: "Quitter"
  }
};

// locales/ar/notifications.json
var notifications_default = {
  bell: {
    title: "\u0627\u0644\u0625\u0634\u0639\u0627\u0631\u0627\u062A",
    close: "\u0625\u063A\u0644\u0627\u0642 \u0627\u0644\u0625\u0634\u0639\u0627\u0631\u0627\u062A",
    listLabel: "\u0622\u062E\u0631 \u0627\u0644\u0625\u0634\u0639\u0627\u0631\u0627\u062A",
    markAllRead: "\u062A\u0639\u0644\u064A\u0645 \u0627\u0644\u0643\u0644 \u0643\u0645\u0642\u0631\u0648\u0621",
    viewAll: "\u0639\u0631\u0636 \u0643\u0644 \u0627\u0644\u0646\u0634\u0627\u0637",
    loadFailedTitle: "\u062A\u0639\u0630\u0631 \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0625\u0634\u0639\u0627\u0631\u0627\u062A",
    loadFailedBody: "\u062A\u062D\u0642\u0642 \u0645\u0646 \u0627\u062A\u0635\u0627\u0644\u0643 \u062B\u0645 \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629.",
    empty: {
      title: "\u0644\u0627 \u0634\u064A\u0621 \u062C\u062F\u064A\u062F",
      description: "\u0633\u062A\u0638\u0647\u0631 \u0647\u0646\u0627 \u0627\u0644\u0625\u0634\u0627\u0631\u0627\u062A \u0625\u0644\u064A\u0643 \u0648\u0627\u0644\u0645\u0647\u0627\u0645 \u0627\u0644\u0645\u0633\u0646\u062F\u0629 \u0625\u0644\u064A\u0643 \u0648\u0627\u0644\u062A\u0630\u0643\u064A\u0631\u0627\u062A."
    }
  },
  item: {
    unread: "\u063A\u064A\u0631 \u0645\u0642\u0631\u0648\u0621",
    markRead: "\u062A\u0639\u0644\u064A\u0645 \u0643\u0645\u0642\u0631\u0648\u0621",
    markReadFor: "\u062A\u0639\u0644\u064A\u0645 \u0643\u0645\u0642\u0631\u0648\u0621: {summary}",
    markReadFailed: "\u062A\u0639\u0630\u0631 \u062A\u0639\u0644\u064A\u0645 \u0627\u0644\u0625\u0634\u0639\u0627\u0631 \u0643\u0645\u0642\u0631\u0648\u0621. \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629.",
    markAllReadFailed: "\u062A\u0639\u0630\u0631 \u062A\u0639\u0644\u064A\u0645 \u0627\u0644\u0625\u0634\u0639\u0627\u0631\u0627\u062A \u0643\u0645\u0642\u0631\u0648\u0621\u0629. \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629.",
    opened: "\u0641\u062A\u062D: {summary}",
    decide: "\u0627\u0644\u0628\u062A\u0651",
    decideFor: "\u0627\u0644\u0628\u062A\u0651: {summary}"
  },
  sentences: {
    task_assigned: "\u0623\u0633\u0646\u062F \u0625\u0644\u064A\u0643 {actor} \u0627\u0644\u0645\u0647\u0645\u0629 \xAB{task}\xBB",
    mention: "\u0623\u0634\u0627\u0631 \u0625\u0644\u064A\u0643 {actor} \u0641\u064A \u0627\u0644\u0645\u0647\u0645\u0629 \xAB{subject}\xBB",
    mention_message: "\u0623\u0634\u0627\u0631 \u0625\u0644\u064A\u0643 {actor} \u0641\u064A \u0627\u0644\u0645\u062D\u0627\u062F\u062B\u0629 \xAB{channel}\xBB",
    generic: "{type}",
    genericWithSubject: "{type}: {subject}",
    task_d7: "\u0645\u0648\u0639\u062F \u0627\u0633\u062A\u062D\u0642\u0627\u0642 \u0627\u0644\u0645\u0647\u0645\u0629 \xAB{task}\xBB \u0628\u0639\u062F 7 \u0623\u064A\u0627\u0645 ({date})",
    task_d2: "\u0645\u0648\u0639\u062F \u0627\u0633\u062A\u062D\u0642\u0627\u0642 \u0627\u0644\u0645\u0647\u0645\u0629 \xAB{task}\xBB \u0628\u0639\u062F \u064A\u0648\u0645\u064A\u0646 ({date})",
    task_d0: "\u0645\u0648\u0639\u062F \u0627\u0633\u062A\u062D\u0642\u0627\u0642 \u0627\u0644\u0645\u0647\u0645\u0629 \xAB{task}\xBB \u0627\u0644\u064A\u0648\u0645",
    task_overdue: "\u0627\u0644\u0645\u0647\u0645\u0629 \xAB{task}\xBB \u0645\u062A\u0623\u062E\u0631\u0629 (\u0643\u0627\u0646 \u0627\u0644\u0627\u0633\u062A\u062D\u0642\u0627\u0642 \u0641\u064A {date})",
    phase_d7: "\u062A\u0646\u062A\u0647\u064A \u0627\u0644\u0645\u0631\u062D\u0644\u0629 \xAB{phase}\xBB \u0628\u0639\u062F 7 \u0623\u064A\u0627\u0645 ({date})",
    phase_d2: "\u062A\u0646\u062A\u0647\u064A \u0627\u0644\u0645\u0631\u062D\u0644\u0629 \xAB{phase}\xBB \u0628\u0639\u062F \u064A\u0648\u0645\u064A\u0646 ({date})",
    phase_d0: "\u062A\u0646\u062A\u0647\u064A \u0627\u0644\u0645\u0631\u062D\u0644\u0629 \xAB{phase}\xBB \u0627\u0644\u064A\u0648\u0645",
    phase_overdue: "\u0627\u0644\u0645\u0631\u062D\u0644\u0629 \xAB{phase}\xBB \u0645\u062A\u0623\u062E\u0631\u0629 (\u0627\u0644\u0646\u0647\u0627\u064A\u0629 \u0627\u0644\u0645\u0642\u0631\u0631\u0629 \u0641\u064A {date})",
    storage_quota: "\u062A\u0645 \u0627\u0633\u062A\u062E\u062F\u0627\u0645 {percent}\u066A \u0645\u0646 \u0645\u0633\u0627\u062D\u0629 \u062A\u062E\u0632\u064A\u0646 \u0645\u0624\u0633\u0633\u062A\u0643",
    approval_requested: "\u064A\u0637\u0644\u0628 {actor} \u062A\u0623\u0634\u064A\u0631\u062A\u0643 \u0639\u0644\u0649 \xAB{document}\xBB",
    approval_decided_approved: "\u062A\u0645 \u0627\u0644\u062A\u0623\u0634\u064A\u0631 \u0639\u0644\u0649 \u0648\u062B\u064A\u0642\u062A\u0643 \xAB{document}\xBB (VSO) \u0645\u0646 {actor}",
    approval_decided_approved_with_comments: "\u062A\u0645 \u0627\u0644\u062A\u0623\u0634\u064A\u0631 \u0639\u0644\u0649 \u0648\u062B\u064A\u0642\u062A\u0643 \xAB{document}\xBB \u0645\u0639 \u0645\u0644\u0627\u062D\u0638\u0627\u062A (VAO) \u0645\u0646 {actor}",
    approval_decided_rejected: "\u0631\u0641\u0636 {actor} \u0648\u062B\u064A\u0642\u062A\u0643 \xAB{document}\xBB (REF)",
    approval_d7: "\u062A\u0623\u0634\u064A\u0631\u062A\u0643 \u0639\u0644\u0649 \xAB{document}\xBB \u0645\u0646\u062A\u0638\u0631\u0629 \u0628\u0639\u062F 7 \u0623\u064A\u0627\u0645 ({date})",
    approval_d2: "\u062A\u0623\u0634\u064A\u0631\u062A\u0643 \u0639\u0644\u0649 \xAB{document}\xBB \u0645\u0646\u062A\u0638\u0631\u0629 \u0628\u0639\u062F \u064A\u0648\u0645\u064A\u0646 ({date})",
    approval_d0: "\u062A\u0623\u0634\u064A\u0631\u062A\u0643 \u0639\u0644\u0649 \xAB{document}\xBB \u0645\u0646\u062A\u0638\u0631\u0629 \u0627\u0644\u064A\u0648\u0645",
    approval_overdue: "\u062A\u0623\u0634\u064A\u0631\u062A\u0643 \u0639\u0644\u0649 \xAB{document}\xBB \u0645\u062A\u0623\u062E\u0631\u0629 (\u0643\u0627\u0646 \u0627\u0644\u0623\u062C\u0644 \u0641\u064A {date})",
    event_start_30m: "\u064A\u0628\u062F\u0623 \u0627\u0644\u062D\u062F\u062B \xAB{event}\xBB \u0628\u0639\u062F 30 \u062F\u0642\u064A\u0642\u0629 ({when})",
    event_start_1d: "\u0627\u0644\u062D\u062F\u062B \xAB{event}\xBB \u063A\u062F\u064B\u0627 ({when})",
    partnership_request: "\u064A\u062F\u0639\u0648 {actor} {partner} \u0644\u0644\u0627\u0646\u0636\u0645\u0627\u0645 \u0625\u0644\u0649 \u0627\u0644\u0641\u0636\u0627\u0621 \xAB{space}\xBB",
    space_invited: "\u064A\u062F\u0639\u0648\u0643 {actor} \u0644\u0644\u0627\u0646\u0636\u0645\u0627\u0645 \u0625\u0644\u0649 \u0627\u0644\u0641\u0636\u0627\u0621 \xAB{space}\xBB",
    space_approval_requested: "\u064A\u0637\u0644\u0628 {actor} \u0645\u0648\u0627\u0641\u0642\u062A\u0643 \u0639\u0644\u0649 \u062F\u0639\u0648\u0629 \u0625\u0644\u0649 \u0627\u0644\u0641\u0636\u0627\u0621 \xAB{space}\xBB",
    space_approval_reminder: "\u062A\u0630\u0643\u064A\u0631: \u062F\u0639\u0648\u0629 \u0625\u0644\u0649 \u0627\u0644\u0641\u0636\u0627\u0621 \xAB{space}\xBB \u0645\u0627 \u0632\u0627\u0644\u062A \u0628\u0627\u0646\u062A\u0638\u0627\u0631 \u0645\u0648\u0627\u0641\u0642\u062A\u0643",
    space_partner_accepted: "\u0642\u0628\u0644\u062A {who} \u0627\u0644\u062F\u0639\u0648\u0629 \u0625\u0644\u0649 \u0627\u0644\u0641\u0636\u0627\u0621 \xAB{space}\xBB",
    space_member_joined: "\u0627\u0646\u0636\u0645 {who} \u0625\u0644\u0649 \u0627\u0644\u0641\u0636\u0627\u0621 \xAB{space}\xBB",
    space_declined: "\u0631\u0641\u0636 {who} \u0627\u0644\u062F\u0639\u0648\u0629 \u0625\u0644\u0649 \u0627\u0644\u0641\u0636\u0627\u0621 \xAB{space}\xBB",
    access_revoked_revoked: "\u062A\u0645 \u0633\u062D\u0628 \u0648\u0635\u0648\u0644\u0643 \u0625\u0644\u0649 \u0627\u0644\u0641\u0636\u0627\u0621 \xAB{space}\xBB",
    access_revoked_expired: "\u0627\u0646\u062A\u0647\u062A \u0635\u0644\u0627\u062D\u064A\u0629 \u0648\u0635\u0648\u0644\u0643 \u0625\u0644\u0649 \u0627\u0644\u0641\u0636\u0627\u0621 \xAB{space}\xBB",
    access_revoked_partner_removed: "\u0644\u0645 \u062A\u0639\u062F \u0645\u0624\u0633\u0633\u062A\u0643 \u062C\u0632\u0621\u0627\u064B \u0645\u0646 \u0627\u0644\u0641\u0636\u0627\u0621 \xAB{space}\xBB: \u062A\u0645 \u0633\u062D\u0628 \u0648\u0635\u0648\u0644\u0643",
    access_revoked_space_closed: "\u062A\u0645 \u0625\u063A\u0644\u0627\u0642 \u0627\u0644\u0641\u0636\u0627\u0621 \xAB{space}\xBB",
    subscription_due_soon: "\u064A\u0646\u062A\u0647\u064A \u0627\u0634\u062A\u0631\u0627\u0643\u0643\u0645 \u0641\u064A BatiFlow \u064A\u0648\u0645 {date}: \u0633\u062F\u0651\u062F\u0648\u0627 \u0641\u0627\u062A\u0648\u0631\u0629 \u0627\u0644\u062A\u062C\u062F\u064A\u062F",
    subscription_due_today: "\u064A\u0646\u062A\u0647\u064A \u0627\u0634\u062A\u0631\u0627\u0643\u0643\u0645 \u0641\u064A BatiFlow \u0627\u0644\u064A\u0648\u0645 ({date})",
    subscription_overdue: "\u0627\u0634\u062A\u0631\u0627\u0643\u0643\u0645 \u0641\u064A BatiFlow \u063A\u064A\u0631 \u0645\u0633\u062F\u064E\u0651\u062F \u0645\u0646\u0630 {date}",
    subscription_read_only: "\u0627\u0634\u062A\u0631\u0627\u0643 \u063A\u064A\u0631 \u0645\u0633\u062F\u064E\u0651\u062F: \u0645\u0643\u062A\u0628\u0643\u0645 \u0641\u064A \u0648\u0636\u0639 \u0627\u0644\u0642\u0631\u0627\u0621\u0629 \u0641\u0642\u0637",
    subscription_suspended: "\u0627\u0634\u062A\u0631\u0627\u0643 \u063A\u064A\u0631 \u0645\u0633\u062F\u064E\u0651\u062F: \u0645\u0643\u062A\u0628\u0643\u0645 \u0645\u0639\u0644\u064E\u0651\u0642. \u0635\u062F\u0651\u0631\u0648\u0627 \u0628\u064A\u0627\u0646\u0627\u062A\u0643\u0645 \u0623\u0648 \u0633\u062F\u0651\u062F\u0648\u0627 \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629",
    subscription_deletion_scheduled: "\u062A\u0645\u062A \u0628\u0631\u0645\u062C\u0629 \u062D\u0630\u0641 \u0628\u064A\u0627\u0646\u0627\u062A \u0645\u0643\u062A\u0628\u0643\u0645",
    subscription_trial_expired: "\u0627\u0646\u062A\u0647\u062A \u0627\u0644\u0641\u062A\u0631\u0629 \u0627\u0644\u062A\u062C\u0631\u064A\u0628\u064A\u0629 \u0627\u0644\u0645\u062C\u0627\u0646\u064A\u0629: \u0627\u062E\u062A\u0627\u0631\u0648\u0627 \u0628\u0627\u0642\u0629 \u0644\u0644\u0645\u0648\u0627\u0635\u0644\u0629",
    subscription_cancelled: "\u062A\u0645 \u0625\u0644\u063A\u0627\u0621 \u0627\u0634\u062A\u0631\u0627\u0643\u0643\u0645: \u0645\u0643\u062A\u0628\u0643\u0645 \u0641\u064A \u0648\u0636\u0639 \u0627\u0644\u0642\u0631\u0627\u0621\u0629 \u0641\u0642\u0637",
    data_export_ready: "\u0646\u0633\u062E\u0629 \u0628\u064A\u0627\u0646\u0627\u062A \u0645\u0624\u0633\u0633\u062A\u0643 \u062C\u0627\u0647\u0632\u0629: \u0646\u0632\u0651\u0644\u0647\u0627 \u062E\u0644\u0627\u0644 7 \u0623\u064A\u0627\u0645",
    data_export_failed: "\u0641\u0634\u0644 \u062A\u0635\u062F\u064A\u0631 \u0628\u064A\u0627\u0646\u0627\u062A \u0645\u0624\u0633\u0633\u062A\u0643: \u0627\u0637\u0644\u0628 \u0646\u0633\u062E\u0629 \u062C\u062F\u064A\u062F\u0629",
    organization_deletion_scheduled: "\u062D\u0630\u0641 \u0645\u0624\u0633\u0633\u062A\u0643 \u0645\u0628\u0631\u0645\u062C \u0628\u062A\u0627\u0631\u064A\u062E {date}: \u0635\u062F\u0651\u0631 \u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A \u0627\u0644\u062A\u064A \u062A\u062D\u062A\u0627\u062C\u0647\u0627",
    organization_deletion_cancelled: "\u0623\u064F\u0644\u063A\u064A \u062D\u0630\u0641 \u0645\u0624\u0633\u0633\u062A\u0643",
    meeting_started: "\u0628\u062F\u0623 {actor} \u0627\u0644\u0627\u062C\u062A\u0645\u0627\u0639 \xAB{meeting}\xBB",
    meeting_started_anonymous: "\u0628\u062F\u0623 \u0627\u0644\u0627\u062C\u062A\u0645\u0627\u0639 \xAB{meeting}\xBB",
    meeting_invited: "\u062F\u0639\u0627\u0643 {actor} \u0625\u0644\u0649 \u0627\u0644\u0627\u062C\u062A\u0645\u0627\u0639 \xAB{meeting}\xBB",
    meeting_invited_anonymous: "\u062A\u0645\u062A \u062F\u0639\u0648\u062A\u0643 \u0625\u0644\u0649 \u0627\u0644\u0627\u062C\u062A\u0645\u0627\u0639 \xAB{meeting}\xBB",
    call_missed: "\u0645\u0643\u0627\u0644\u0645\u0629 \u0641\u0627\u0626\u062A\u0629 \u0645\u0646 {caller}",
    minutes_published: "\u062A\u0645 \u0646\u0634\u0631 {number} \u0644\u0644\u0627\u062C\u062A\u0645\u0627\u0639 \xAB{meeting}\xBB",
    timesheet_reminder: "\u0644\u0627 \u062A\u0646\u0633\u064E \u062A\u0633\u0644\u064A\u0645 \u062C\u062F\u0648\u0644 \u0648\u0642\u062A\u0643 \u0644\u0623\u0633\u0628\u0648\u0639 {date}",
    phase_deadline_warning: "\u0627\u0642\u062A\u0631\u0628\u062A \u0627\u0644\u0645\u0631\u062D\u0644\u0629 \xAB{phase}\xBB \u0645\u0646 \u0627\u0644\u0645\u0634\u0631\u0648\u0639 \xAB{project}\xBB \u0645\u0646 \u0623\u062C\u0644\u0647\u0627 \u0627\u0644\u062A\u0639\u0627\u0642\u062F\u064A ({date})",
    phase_deadline_overdue: "\u062A\u062C\u0627\u0648\u0632\u062A \u0627\u0644\u0645\u0631\u062D\u0644\u0629 \xAB{phase}\xBB \u0645\u0646 \u0627\u0644\u0645\u0634\u0631\u0648\u0639 \xAB{project}\xBB \u0623\u062C\u0644\u0647\u0627 \u0627\u0644\u062A\u0639\u0627\u0642\u062F\u064A \u0628\u062A\u0627\u0631\u064A\u062E {date} \u0628\u0645\u0642\u062F\u0627\u0631 {days} \u064A\u0648\u0645",
    vault_expiring: "\u062A\u0646\u062A\u0647\u064A \u0635\u0644\u0627\u062D\u064A\u0629 \u0648\u062B\u064A\u0642\u0629 \u0627\u0644\u062E\u0632\u0646\u0629 \xAB{document}\xBB \u0628\u062A\u0627\u0631\u064A\u062E {date}",
    time_budget: "\u0627\u0633\u062A\u0647\u0644\u0643\u062A \u0627\u0644\u0645\u0631\u062D\u0644\u0629 {phase} \u0645\u0646 \u0627\u0644\u0645\u0634\u0631\u0648\u0639 {project} \u200F{percent} % \u0645\u0646 \u0645\u064A\u0632\u0627\u0646\u064A\u062A\u0647\u0627 \u0627\u0644\u0632\u0645\u0646\u064A\u0629",
    signature_requested: "\u064A\u0637\u0644\u0628 \u0645\u0646\u0643 {requester} \u062A\u0648\u0642\u064A\u0639 \xAB{title}\xBB",
    signature_update: "\u062A\u063A\u064A\u0651\u0631 \u0637\u0644\u0628 \u0627\u0644\u062A\u0648\u0642\u064A\u0639 \xAB{title}\xBB",
    signature_update_completed: "\u0648\u0642\u0651\u0639 \u062C\u0645\u064A\u0639 \u0627\u0644\u0645\u0648\u0642\u0651\u0639\u064A\u0646 \xAB{title}\xBB",
    signature_update_declined: "\u0631\u0641\u0636 {signer} \u062A\u0648\u0642\u064A\u0639 \xAB{title}\xBB"
  },
  types: {
    mention: "\u0625\u0634\u0627\u0631\u0629 \u0625\u0644\u064A\u0643",
    reply: "\u0631\u062F \u0639\u0644\u0649 \u062A\u0639\u0644\u064A\u0642\u0643",
    task_assigned: "\u0645\u0647\u0645\u0629 \u0645\u0633\u0646\u062F\u0629 \u0625\u0644\u064A\u0643",
    task_due: "\u0627\u0642\u062A\u0631\u0627\u0628 \u0645\u0648\u0639\u062F \u0627\u0633\u062A\u062D\u0642\u0627\u0642 \u0645\u0647\u0645\u0629",
    task_overdue: "\u0645\u0647\u0645\u0629 \u0645\u062A\u0623\u062E\u0631\u0629",
    phase_due: "\u0627\u0642\u062A\u0631\u0627\u0628 \u0645\u0648\u0639\u062F \u0627\u0633\u062A\u062D\u0642\u0627\u0642 \u0645\u0631\u062D\u0644\u0629",
    phase_overdue: "\u0645\u0631\u062D\u0644\u0629 \u0645\u062A\u0623\u062E\u0631\u0629",
    approval_requested: "\u0637\u0644\u0628 \u062A\u0623\u0634\u064A\u0631\u0629",
    approval_decided: "\u0642\u0631\u0627\u0631 \u0628\u0634\u0623\u0646 \u062A\u0623\u0634\u064A\u0631\u0629",
    space_invitation: "\u062F\u0639\u0648\u0629 \u0625\u0644\u0649 \u0641\u0636\u0627\u0621 \u0645\u0634\u062A\u0631\u0643",
    partnership_request: "\u0637\u0644\u0628 \u0634\u0631\u0627\u0643\u0629",
    access_revoked: "\u0633\u062D\u0628 \u0635\u0644\u0627\u062D\u064A\u0629 \u0627\u0644\u0648\u0635\u0648\u0644",
    einvoice_status: "\u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629 \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A\u0629",
    payment_received: "\u062F\u0641\u0639\u0629 \u0645\u0633\u062A\u0644\u0645\u0629",
    plan_limit: "\u062D\u062F \u0627\u0644\u0628\u0627\u0642\u0629",
    unknown: "\u0625\u0634\u0639\u0627\u0631",
    event_reminder: "\u062D\u062F\u062B \u0642\u0627\u062F\u0645",
    quote_accepted: "\u0642\u0628\u0648\u0644 \u0639\u0631\u0636 \u0645\u0627\u0644\u064A",
    invoice_suggested: "\u0641\u0627\u062A\u0648\u0631\u0629 \u0648\u0636\u0639\u064A\u0629 \u0644\u0644\u0625\u0639\u062F\u0627\u062F",
    bond_release_due: "\u0637\u0644\u0628 \u0631\u0641\u0639 \u0627\u0644\u064A\u062F \u0639\u0646 \u0627\u0644\u0636\u0645\u0627\u0646",
    expense_submitted: "\u0645\u0630\u0643\u0631\u0629 \u0645\u0635\u0627\u0631\u064A\u0641 \u0641\u064A \u0627\u0646\u062A\u0638\u0627\u0631 \u0627\u0644\u0645\u0648\u0627\u0641\u0642\u0629",
    expense_decided: "\u0642\u0631\u0627\u0631 \u0628\u0634\u0623\u0646 \u0645\u0630\u0643\u0631\u0629 \u0645\u0635\u0627\u0631\u064A\u0641\u0643",
    subscription_status: "\u0627\u0634\u062A\u0631\u0627\u0643 BatiFlow",
    data_export: "\u062A\u0635\u062F\u064A\u0631 \u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A",
    organization_deletion: "\u062D\u0630\u0641 \u0627\u0644\u0645\u0624\u0633\u0633\u0629",
    meeting_started: "\u0628\u062F\u0623 \u0627\u062C\u062A\u0645\u0627\u0639",
    meeting_invited: "\u062F\u0639\u0648\u0629 \u0625\u0644\u0649 \u0627\u062C\u062A\u0645\u0627\u0639",
    call_missed: "\u0645\u0643\u0627\u0644\u0645\u0629 \u0641\u0627\u0626\u062A\u0629",
    minutes_published: "\u0646\u0634\u0631 \u0645\u062D\u0636\u0631 \u0627\u062C\u062A\u0645\u0627\u0639",
    timesheet_reminder: "\u062C\u062F\u0648\u0644 \u0648\u0642\u062A \u0644\u0644\u062A\u0633\u0644\u064A\u0645",
    phase_deadline: "\u0627\u0644\u0623\u062C\u0644 \u0627\u0644\u062A\u0639\u0627\u0642\u062F\u064A \u0644\u0644\u0645\u0631\u062D\u0644\u0629",
    vault_expiring: "\u0648\u062B\u064A\u0642\u0629 \u0641\u064A \u0627\u0644\u062E\u0632\u0646\u0629 \u064A\u062C\u0628 \u062A\u062C\u062F\u064A\u062F\u0647\u0627",
    time_budget: "\u0627\u0644\u0645\u064A\u0632\u0627\u0646\u064A\u0629 \u0627\u0644\u0632\u0645\u0646\u064A\u0629 \u0644\u0645\u0631\u062D\u0644\u0629",
    signature_requested: "\u0637\u0644\u0628 \u062A\u0648\u0642\u064A\u0639",
    signature_update: "\u0645\u062A\u0627\u0628\u0639\u0629 \u0637\u0644\u0628\u0627\u062A \u0627\u0644\u062A\u0648\u0642\u064A\u0639"
  },
  activity: {
    feedLabel: "\u0633\u062C\u0644 \u0627\u0644\u0646\u0634\u0627\u0637",
    filters: {
      label: "\u062A\u0635\u0641\u064A\u0629 \u0627\u0644\u0646\u0634\u0627\u0637",
      all: "\u0627\u0644\u0643\u0644",
      mentions: "\u0627\u0644\u0625\u0634\u0627\u0631\u0627\u062A",
      assignments: "\u0627\u0644\u0625\u0633\u0646\u0627\u062F\u0627\u062A",
      approvals: "\u0627\u0644\u062A\u0623\u0634\u064A\u0631\u0627\u062A"
    },
    loadMore: "\u0639\u0631\u0636 \u0627\u0644\u0645\u0632\u064A\u062F \u0645\u0646 \u0627\u0644\u0646\u0634\u0627\u0637",
    loadingMore: "\u062C\u0627\u0631\u064D \u0627\u0644\u062A\u062D\u0645\u064A\u0644\u2026",
    loadFailedTitle: "\u062A\u0639\u0630\u0631 \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0646\u0634\u0627\u0637",
    loadFailedBody: "\u062A\u062D\u0642\u0642 \u0645\u0646 \u0627\u062A\u0635\u0627\u0644\u0643 \u062B\u0645 \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629.",
    empty: {
      all: {
        title: "\u0644\u0627 \u062C\u062F\u064A\u062F \u0641\u064A \u0627\u0644\u0648\u0642\u062A \u0627\u0644\u062D\u0627\u0644\u064A",
        description: "\u0633\u062A\u0638\u0647\u0631 \u0647\u0646\u0627 \u0627\u0644\u0625\u0634\u0627\u0631\u0627\u062A \u0625\u0644\u064A\u0643 \u0648\u0627\u0644\u0645\u0647\u0627\u0645 \u0627\u0644\u0645\u0633\u0646\u062F\u0629 \u0625\u0644\u064A\u0643 \u0648\u0637\u0644\u0628\u0627\u062A \u0627\u0644\u062A\u0623\u0634\u064A\u0631\u0629."
      },
      mentions: {
        title: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0625\u0634\u0627\u0631\u0627\u062A",
        description: "\u0633\u062A\u062A\u0644\u0642\u0649 \u0647\u0646\u0627 \u062A\u0646\u0628\u064A\u0647\u064B\u0627 \u0639\u0646\u062F\u0645\u0627 \u064A\u0634\u064A\u0631 \u0625\u0644\u064A\u0643 \u0623\u062D\u062F \u0623\u0648 \u064A\u0631\u062F \u0639\u0644\u0649 \u0623\u062D\u062F \u062A\u0639\u0644\u064A\u0642\u0627\u062A\u0643."
      },
      assignments: {
        title: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0645\u0647\u0627\u0645 \u0645\u0633\u0646\u062F\u0629",
        description: "\u0633\u062A\u0638\u0647\u0631 \u0647\u0646\u0627 \u0627\u0644\u0645\u0647\u0627\u0645 \u0627\u0644\u062A\u064A \u062A\u064F\u0633\u0646\u062F \u0625\u0644\u064A\u0643."
      },
      approvals: {
        title: "\u0644\u0627 \u062A\u0648\u062C\u062F \u062A\u0623\u0634\u064A\u0631\u0627\u062A \u0628\u0639\u062F",
        description: "\u0633\u062A\u0635\u0644 \u0637\u0644\u0628\u0627\u062A \u0627\u0644\u062A\u0623\u0634\u064A\u0631\u0629 \u0648\u0642\u0631\u0627\u0631\u0627\u062A\u0647\u0627 \u0625\u0644\u0649 \u0647\u0646\u0627 \u0645\u0639 \u062A\u0623\u0634\u064A\u0631\u0627\u062A \u0627\u0644\u0648\u062B\u0627\u0626\u0642."
      }
    }
  },
  toast: {
    close: "\u0625\u063A\u0644\u0627\u0642 \u0627\u0644\u0625\u0634\u0639\u0627\u0631"
  }
};

// locales/en/notifications.json
var notifications_default2 = {
  bell: {
    title: "Notifications",
    close: "Close notifications",
    listLabel: "Latest notifications",
    markAllRead: "Mark all as read",
    viewAll: "View all activity",
    loadFailedTitle: "Notifications could not be loaded",
    loadFailedBody: "Check your connection and try again.",
    empty: {
      title: "You're all caught up",
      description: "Your mentions, assignments and reminders will appear here."
    }
  },
  item: {
    unread: "Unread",
    markRead: "Mark as read",
    markReadFor: "Mark as read: {summary}",
    markReadFailed: "The notification could not be marked as read. Try again.",
    markAllReadFailed: "The notifications could not be marked as read. Try again.",
    opened: "Open: {summary}",
    decide: "Decide",
    decideFor: "Decide: {summary}"
  },
  sentences: {
    task_assigned: '{actor} assigned you the task "{task}"',
    mention: '{actor} mentioned you in the task "{subject}"',
    mention_message: '{actor} mentioned you in the conversation "{channel}"',
    generic: "{type}",
    genericWithSubject: "{type}: {subject}",
    task_d7: 'The task "{task}" is due in 7 days ({date})',
    task_d2: 'The task "{task}" is due in 2 days ({date})',
    task_d0: 'The task "{task}" is due today',
    task_overdue: 'The task "{task}" is overdue (due on {date})',
    phase_d7: 'The phase "{phase}" ends in 7 days ({date})',
    phase_d2: 'The phase "{phase}" ends in 2 days ({date})',
    phase_d0: 'The phase "{phase}" ends today',
    phase_overdue: 'The phase "{phase}" is overdue (planned end on {date})',
    storage_quota: "Your organisation's storage is {percent}% full",
    approval_requested: '{actor} asks for your approval on "{document}"',
    approval_decided_approved: 'Your document "{document}" was approved (VSO) by {actor}',
    approval_decided_approved_with_comments: 'Your document "{document}" was approved with comments (VAO) by {actor}',
    approval_decided_rejected: 'Your document "{document}" was refused (REF) by {actor}',
    approval_d7: 'Your approval on "{document}" is expected in 7 days ({date})',
    approval_d2: 'Your approval on "{document}" is expected in 2 days ({date})',
    approval_d0: 'Your approval on "{document}" is expected today',
    approval_overdue: 'Your approval on "{document}" is overdue (due on {date})',
    event_start_30m: 'The event "{event}" starts in 30 minutes ({when})',
    event_start_1d: 'The event "{event}" is tomorrow ({when})',
    partnership_request: '{actor} invites {partner} to join the space "{space}"',
    space_invited: '{actor} invites you to join the space "{space}"',
    space_approval_requested: '{actor} asks for your approval of an invitation to the space "{space}"',
    space_approval_reminder: 'Reminder: an invitation to the space "{space}" is still waiting for your approval',
    space_partner_accepted: '{who} accepted the invitation to the space "{space}"',
    space_member_joined: '{who} joined the space "{space}"',
    space_declined: '{who} declined the invitation to the space "{space}"',
    access_revoked_revoked: 'Your access to the space "{space}" was removed',
    access_revoked_expired: 'Your access to the space "{space}" has expired',
    access_revoked_partner_removed: 'Your organisation is no longer part of the space "{space}": your access is removed',
    access_revoked_space_closed: 'The space "{space}" was closed',
    subscription_due_soon: "Your BatiFlow subscription renews on {date}: pay the renewal invoice",
    subscription_due_today: "Your BatiFlow subscription is due today ({date})",
    subscription_overdue: "Your BatiFlow subscription has been unpaid since {date}",
    subscription_read_only: "Unpaid subscription: your office is read-only",
    subscription_suspended: "Unpaid subscription: your office is suspended. Export your data or pay the invoice",
    subscription_deletion_scheduled: "The deletion of your office\u2019s data is scheduled",
    subscription_trial_expired: "Your free trial has ended: choose a plan to continue",
    subscription_cancelled: "Your subscription is cancelled: your office is read-only",
    data_export_ready: "Your organisation\u2019s data export is ready: download it within 7 days",
    data_export_failed: "Your organisation\u2019s data export failed: ask for a new one",
    organization_deletion_scheduled: "Your organisation\u2019s deletion is scheduled for {date}: export the data you need",
    organization_deletion_cancelled: "Your organisation\u2019s deletion was cancelled",
    meeting_started: "{actor} started the meeting \u201C{meeting}\u201D",
    meeting_started_anonymous: "The meeting \u201C{meeting}\u201D has started",
    meeting_invited: "{actor} invited you to the meeting \u201C{meeting}\u201D",
    meeting_invited_anonymous: "You are invited to the meeting \u201C{meeting}\u201D",
    call_missed: "Missed call from {caller}",
    minutes_published: "{number} published for \u201C{meeting}\u201D",
    timesheet_reminder: "Remember to submit your timesheet for the week of {date}",
    phase_deadline_warning: "The phase \u201C{phase}\u201D of project \u201C{project}\u201D is nearing its contractual deadline ({date})",
    phase_deadline_overdue: "The phase \u201C{phase}\u201D of project \u201C{project}\u201D is {days} day(s) past its contractual deadline of {date}",
    vault_expiring: "The vault document \u201C{document}\u201D expires on {date}",
    time_budget: "Phase {phase} of project {project} has used {percent}% of its time budget",
    signature_requested: "{requester} asks you to sign \u201C{title}\u201D",
    signature_update: "The signature request \u201C{title}\u201D changed",
    signature_update_completed: "\u201C{title}\u201D was signed by every signer",
    signature_update_declined: "{signer} declined to sign \u201C{title}\u201D"
  },
  types: {
    mention: "Mention",
    reply: "Reply to your comment",
    task_assigned: "Task assigned",
    task_due: "Task due soon",
    task_overdue: "Task overdue",
    phase_due: "Phase due soon",
    phase_overdue: "Phase overdue",
    approval_requested: "Approval requested",
    approval_decided: "Approval decided",
    space_invitation: "Invitation to a shared space",
    partnership_request: "Partnership request",
    access_revoked: "Access removed",
    einvoice_status: "Electronic invoice",
    payment_received: "Payment received",
    plan_limit: "Plan limit",
    unknown: "Notification",
    event_reminder: "Upcoming event",
    quote_accepted: "Quote accepted",
    invoice_suggested: "Progress invoice to prepare",
    bond_release_due: "Bond release to request",
    expense_submitted: "Expense to approve",
    expense_decided: "Decision on your expense",
    subscription_status: "BatiFlow subscription",
    data_export: "Data export",
    organization_deletion: "Organisation deletion",
    meeting_started: "Meeting started",
    meeting_invited: "Meeting invitation",
    call_missed: "Missed call",
    minutes_published: "Minutes published",
    timesheet_reminder: "Timesheet to submit",
    phase_deadline: "Phase contractual deadline",
    vault_expiring: "Vault document to renew",
    time_budget: "Phase time budget",
    signature_requested: "Signature request",
    signature_update: "Your signature requests"
  },
  activity: {
    feedLabel: "Activity feed",
    filters: {
      label: "Filter activity",
      all: "All",
      mentions: "Mentions",
      assignments: "Assignments",
      approvals: "Approvals"
    },
    loadMore: "Show more activity",
    loadingMore: "Loading\u2026",
    loadFailedTitle: "Activity could not be loaded",
    loadFailedBody: "Check your connection and try again.",
    empty: {
      all: {
        title: "Nothing new for now",
        description: "Your mentions, assignments and approvals will appear here."
      },
      mentions: {
        title: "No mentions",
        description: "You will be told here when someone mentions you or replies to one of your comments."
      },
      assignments: {
        title: "No assignments",
        description: "Tasks assigned to you will appear here."
      },
      approvals: {
        title: "No approvals yet",
        description: "Approval requests and their decisions will arrive here with document approvals."
      }
    }
  },
  toast: {
    close: "Close the notification"
  }
};

// locales/fr/notifications.json
var notifications_default3 = {
  bell: {
    title: "Notifications",
    close: "Fermer les notifications",
    listLabel: "Derni\xE8res notifications",
    markAllRead: "Tout marquer comme lu",
    viewAll: "Voir toute l'activit\xE9",
    loadFailedTitle: "Impossible de charger les notifications",
    loadFailedBody: "V\xE9rifiez votre connexion puis r\xE9essayez.",
    empty: {
      title: "Vous \xEAtes \xE0 jour",
      description: "Vos mentions, affectations et rappels appara\xEEtront ici."
    }
  },
  item: {
    unread: "Non lu",
    markRead: "Marquer comme lu",
    markReadFor: "Marquer comme lu\xA0: {summary}",
    markReadFailed: "Impossible de marquer la notification comme lue. R\xE9essayez.",
    markAllReadFailed: "Impossible de marquer les notifications comme lues. R\xE9essayez.",
    opened: "Ouvrir\xA0: {summary}",
    decide: "D\xE9cider",
    decideFor: "D\xE9cider\xA0: {summary}"
  },
  sentences: {
    task_assigned: "{actor} vous a assign\xE9 la t\xE2che \xAB\xA0{task}\xA0\xBB",
    mention: "{actor} vous a mentionn\xE9 dans la t\xE2che \xAB\xA0{subject}\xA0\xBB",
    mention_message: "{actor} vous a mentionn\xE9 dans la conversation \xAB\xA0{channel}\xA0\xBB",
    generic: "{type}",
    genericWithSubject: "{type}\xA0: {subject}",
    task_d7: "La t\xE2che \xAB\xA0{task}\xA0\xBB est due dans 7 jours ({date})",
    task_d2: "La t\xE2che \xAB\xA0{task}\xA0\xBB est due dans 2 jours ({date})",
    task_d0: "La t\xE2che \xAB\xA0{task}\xA0\xBB est due aujourd'hui",
    task_overdue: "La t\xE2che \xAB\xA0{task}\xA0\xBB est en retard (\xE9ch\xE9ance le {date})",
    phase_d7: "La phase \xAB\xA0{phase}\xA0\xBB se termine dans 7 jours ({date})",
    phase_d2: "La phase \xAB\xA0{phase}\xA0\xBB se termine dans 2 jours ({date})",
    phase_d0: "La phase \xAB\xA0{phase}\xA0\xBB se termine aujourd'hui",
    phase_overdue: "La phase \xAB\xA0{phase}\xA0\xBB est en retard (fin pr\xE9vue le {date})",
    storage_quota: "Le stockage de votre organisation est utilis\xE9 \xE0 {percent}\xA0%",
    approval_requested: "{actor} vous demande votre visa sur \xAB\xA0{document}\xA0\xBB",
    approval_decided_approved: "Votre document \xAB\xA0{document}\xA0\xBB a \xE9t\xE9 approuv\xE9 (VSO) par {actor}",
    approval_decided_approved_with_comments: "Votre document \xAB\xA0{document}\xA0\xBB a \xE9t\xE9 approuv\xE9 avec observations (VAO) par {actor}",
    approval_decided_rejected: "Votre document \xAB\xA0{document}\xA0\xBB a \xE9t\xE9 refus\xE9 (REF) par {actor}",
    approval_d7: "Votre visa sur \xAB\xA0{document}\xA0\xBB est attendu dans 7 jours ({date})",
    approval_d2: "Votre visa sur \xAB\xA0{document}\xA0\xBB est attendu dans 2 jours ({date})",
    approval_d0: "Votre visa sur \xAB\xA0{document}\xA0\xBB est attendu aujourd'hui",
    approval_overdue: "Votre visa sur \xAB\xA0{document}\xA0\xBB est en retard (\xE9ch\xE9ance le {date})",
    event_start_30m: "L'\xE9v\xE9nement \xAB\xA0{event}\xA0\xBB commence dans 30 minutes ({when})",
    event_start_1d: "L'\xE9v\xE9nement \xAB\xA0{event}\xA0\xBB a lieu demain ({when})",
    partnership_request: "{actor} invite {partner} \xE0 rejoindre l'espace \xAB\xA0{space}\xA0\xBB",
    space_invited: "{actor} vous invite \xE0 rejoindre l'espace \xAB\xA0{space}\xA0\xBB",
    space_approval_requested: "{actor} demande votre approbation pour une invitation \xE0 l'espace \xAB\xA0{space}\xA0\xBB",
    space_approval_reminder: "Rappel\xA0: une invitation \xE0 l'espace \xAB\xA0{space}\xA0\xBB attend toujours votre approbation",
    space_partner_accepted: "{who} a accept\xE9 l'invitation \xE0 l'espace \xAB\xA0{space}\xA0\xBB",
    space_member_joined: "{who} a rejoint l'espace \xAB\xA0{space}\xA0\xBB",
    space_declined: "{who} a d\xE9clin\xE9 l'invitation \xE0 l'espace \xAB\xA0{space}\xA0\xBB",
    access_revoked_revoked: "Votre acc\xE8s \xE0 l'espace \xAB\xA0{space}\xA0\xBB a \xE9t\xE9 retir\xE9",
    access_revoked_expired: "Votre acc\xE8s \xE0 l'espace \xAB\xA0{space}\xA0\xBB a expir\xE9",
    access_revoked_partner_removed: "Votre organisation ne fait plus partie de l'espace \xAB\xA0{space}\xA0\xBB\xA0: votre acc\xE8s est retir\xE9",
    access_revoked_space_closed: "L'espace \xAB\xA0{space}\xA0\xBB a \xE9t\xE9 ferm\xE9",
    subscription_due_soon: "Votre abonnement BatiFlow arrive \xE0 \xE9ch\xE9ance le {date} : r\xE9glez la facture de renouvellement",
    subscription_due_today: "Votre abonnement BatiFlow arrive \xE0 \xE9ch\xE9ance aujourd\u2019hui ({date})",
    subscription_overdue: "Votre abonnement BatiFlow est impay\xE9 depuis le {date}",
    subscription_read_only: "Abonnement impay\xE9 : votre bureau est en lecture seule",
    subscription_suspended: "Abonnement impay\xE9 : votre bureau est suspendu. Exportez vos donn\xE9es ou r\xE9glez la facture",
    subscription_deletion_scheduled: "La suppression des donn\xE9es de votre bureau est programm\xE9e",
    subscription_trial_expired: "Votre essai gratuit est termin\xE9 : choisissez un forfait pour continuer",
    subscription_cancelled: "Votre abonnement est r\xE9sili\xE9 : votre bureau est en lecture seule",
    data_export_ready: "L\u2019export des donn\xE9es de votre organisation est pr\xEAt : t\xE9l\xE9chargez-le dans les 7 jours",
    data_export_failed: "L\u2019export des donn\xE9es de votre organisation a \xE9chou\xE9 : demandez-en un nouveau",
    organization_deletion_scheduled: "La suppression de votre organisation est programm\xE9e le {date} : exportez les donn\xE9es dont vous avez besoin",
    organization_deletion_cancelled: "La suppression de votre organisation a \xE9t\xE9 annul\xE9e",
    meeting_started: "{actor} a d\xE9marr\xE9 la r\xE9union \xAB\xA0{meeting}\xA0\xBB",
    meeting_started_anonymous: "La r\xE9union \xAB\xA0{meeting}\xA0\xBB a d\xE9marr\xE9",
    meeting_invited: "{actor} vous invite \xE0 la r\xE9union \xAB\xA0{meeting}\xA0\xBB",
    meeting_invited_anonymous: "Vous \xEAtes invit\xE9 \xE0 la r\xE9union \xAB\xA0{meeting}\xA0\xBB",
    call_missed: "Appel manqu\xE9 de {caller}",
    minutes_published: "{number} publi\xE9 pour \xAB\xA0{meeting}\xA0\xBB",
    timesheet_reminder: "N\u2019oubliez pas de soumettre votre feuille de temps de la semaine du {date}",
    phase_deadline_warning: "La phase \xAB\xA0{phase}\xA0\xBB du projet \xAB\xA0{project}\xA0\xBB approche de son \xE9ch\xE9ance contractuelle ({date})",
    phase_deadline_overdue: "La phase \xAB\xA0{phase}\xA0\xBB du projet \xAB\xA0{project}\xA0\xBB a d\xE9pass\xE9 son \xE9ch\xE9ance contractuelle du {date} de {days} jour(s)",
    vault_expiring: "Le document \xAB {document} \xBB du coffre-fort expire le {date}",
    time_budget: "La phase {phase} du projet {project} a consomm\xE9 {percent} % de son budget de temps",
    signature_requested: "{requester} vous demande de signer \xAB {title} \xBB",
    signature_update: "La demande de signature \xAB {title} \xBB a chang\xE9",
    signature_update_completed: "\xAB {title} \xBB a \xE9t\xE9 sign\xE9 par tous les signataires",
    signature_update_declined: "{signer} a refus\xE9 de signer \xAB {title} \xBB"
  },
  types: {
    mention: "Mention",
    reply: "R\xE9ponse \xE0 votre commentaire",
    task_assigned: "T\xE2che assign\xE9e",
    task_due: "\xC9ch\xE9ance de t\xE2che proche",
    task_overdue: "T\xE2che en retard",
    phase_due: "\xC9ch\xE9ance de phase proche",
    phase_overdue: "Phase en retard",
    approval_requested: "Visa demand\xE9",
    approval_decided: "Visa rendu",
    space_invitation: "Invitation \xE0 un espace partag\xE9",
    partnership_request: "Demande de partenariat",
    access_revoked: "Acc\xE8s retir\xE9",
    einvoice_status: "Facture \xE9lectronique",
    payment_received: "Paiement re\xE7u",
    plan_limit: "Limite du forfait",
    unknown: "Notification",
    event_reminder: "\xC9v\xE9nement \xE0 venir",
    quote_accepted: "Devis accept\xE9",
    invoice_suggested: "Facture de situation \xE0 pr\xE9parer",
    bond_release_due: "Mainlev\xE9e de caution \xE0 demander",
    expense_submitted: "Note de frais \xE0 approuver",
    expense_decided: "D\xE9cision sur votre note de frais",
    subscription_status: "Abonnement BatiFlow",
    data_export: "Export des donn\xE9es",
    organization_deletion: "Suppression de l\u2019organisation",
    meeting_started: "R\xE9union d\xE9marr\xE9e",
    meeting_invited: "Invitation \xE0 une r\xE9union",
    call_missed: "Appel manqu\xE9",
    minutes_published: "Proc\xE8s-verbal publi\xE9",
    timesheet_reminder: "Feuille de temps \xE0 soumettre",
    phase_deadline: "\xC9ch\xE9ance contractuelle de phase",
    vault_expiring: "Document du coffre-fort \xE0 renouveler",
    time_budget: "Budget de temps d\u2019une phase",
    signature_requested: "Demande de signature",
    signature_update: "Suivi de vos demandes de signature"
  },
  activity: {
    feedLabel: "Fil d'activit\xE9",
    filters: {
      label: "Filtrer l'activit\xE9",
      all: "Tout",
      mentions: "Mentions",
      assignments: "Affectations",
      approvals: "Visas"
    },
    loadMore: "Afficher plus d'activit\xE9",
    loadingMore: "Chargement\u2026",
    loadFailedTitle: "Impossible de charger l'activit\xE9",
    loadFailedBody: "V\xE9rifiez votre connexion puis r\xE9essayez.",
    empty: {
      all: {
        title: "Rien de nouveau pour le moment",
        description: "Vos mentions, affectations et visas appara\xEEtront ici."
      },
      mentions: {
        title: "Aucune mention",
        description: "Vous serez pr\xE9venu ici quand quelqu'un vous mentionne ou r\xE9pond \xE0 l'un de vos commentaires."
      },
      assignments: {
        title: "Aucune affectation",
        description: "Les t\xE2ches qu'on vous assigne appara\xEEtront ici."
      },
      approvals: {
        title: "Aucun visa pour le moment",
        description: "Les demandes de visa et leurs d\xE9cisions arriveront ici avec l'approbation des documents."
      }
    }
  },
  toast: {
    close: "Fermer la notification"
  }
};

// locales/ar/spaces.json
var spaces_default = {
  title: "\u0627\u0644\u0641\u0636\u0627\u0621\u0627\u062A \u0627\u0644\u0645\u0634\u062A\u0631\u0643\u0629",
  intro: "\u0627\u0644\u0641\u0636\u0627\u0621 \u0627\u0644\u0645\u0634\u062A\u0631\u0643 \u064A\u062C\u0645\u0639 \u0623\u0634\u062E\u0627\u0635\u0627\u064B \u0645\u0646 \u0639\u062F\u0629 \u0645\u0624\u0633\u0633\u0627\u062A \u062D\u0648\u0644 \u0645\u0634\u0631\u0648\u0639 \u0623\u0648 \u0645\u0648\u0636\u0648\u0639 \u0645\u0634\u062A\u0631\u0643.",
  tabs: {
    documents: "\u0627\u0644\u0645\u0633\u062A\u0646\u062F\u0627\u062A",
    chat: "\u0627\u0644\u0645\u062D\u0627\u062F\u062B\u0627\u062A",
    calendar: "\u0627\u0644\u062A\u0642\u0648\u064A\u0645",
    meetings: "\u0627\u0644\u0627\u062C\u062A\u0645\u0627\u0639\u0627\u062A",
    people: "\u0627\u0644\u0623\u0634\u062E\u0627\u0635",
    partners: "\u0627\u0644\u0645\u0624\u0633\u0633\u0627\u062A \u0627\u0644\u0634\u0631\u064A\u0643\u0629",
    delegates: "\u0645\u0646\u062F\u0648\u0628\u0648 \u0645\u0624\u0633\u0633\u062A\u064A",
    settings: "\u0627\u0644\u0625\u0639\u062F\u0627\u062F\u0627\u062A",
    audit: "\u0633\u062C\u0644 \u0627\u0644\u062A\u062F\u0642\u064A\u0642",
    synthesis: "\u0627\u0644\u0645\u0644\u062E\u0651\u0635",
    groupement: "\u0627\u0644\u062A\u062C\u0645\u0651\u0639"
  },
  kinds: {
    organization: "\u0641\u0636\u0627\u0621 \u0627\u0644\u0645\u0624\u0633\u0633\u0629",
    internal: "\u0641\u0636\u0627\u0621 \u0645\u0634\u0631\u0648\u0639",
    shared: "\u0641\u0636\u0627\u0621 \u0645\u0634\u062A\u0631\u0643",
    group: "\u0645\u062C\u0645\u0648\u0639\u0629 \u0639\u0645\u0644"
  },
  status: {
    closed: "\u0645\u063A\u0644\u0642"
  },
  via: {
    host_member: "\u0639\u0636\u0648 \u0641\u064A \u0627\u0644\u0645\u0624\u0633\u0633\u0629 \u0627\u0644\u0645\u0633\u062A\u0636\u064A\u0641\u0629",
    partner_delegation: "\u0645\u0641\u0648\u064E\u0651\u0636 \u0645\u0646 \u0645\u0624\u0633\u0633\u062A\u0643",
    direct_invite: "\u062F\u0639\u0648\u0629 \u0634\u062E\u0635\u064A\u0629",
    guest: "\u0636\u064A\u0641",
    partner_admin: "\u0645\u0633\u0624\u0648\u0644 \u0641\u064A \u0645\u0624\u0633\u0633\u062A\u0643 \u0627\u0644\u0634\u0631\u064A\u0643\u0629"
  },
  rights: {
    read: "\u0644\u0644\u0642\u0631\u0627\u0621\u0629 \u0641\u0642\u0637",
    write: "\u0627\u0644\u0642\u0631\u0627\u0621\u0629 \u0648\u0627\u0644\u0643\u062A\u0627\u0628\u0629",
    approve: "\u0627\u0644\u0642\u0631\u0627\u0621\u0629 \u0648\u0627\u0644\u0643\u062A\u0627\u0628\u0629 \u0648\u0627\u0644\u0645\u0635\u0627\u062F\u0642\u0629"
  },
  access: {
    via: "\u0627\u0644\u0648\u0635\u0648\u0644: {via}",
    rights: "\u0627\u0644\u0635\u0644\u0627\u062D\u064A\u0627\u062A: {rights}",
    until: "\u062D\u062A\u0649 {date}",
    noEnd: "\u0628\u062F\u0648\u0646 \u062A\u0627\u0631\u064A\u062E \u0627\u0646\u062A\u0647\u0627\u0621"
  },
  page: {
    hostedBy: "\u062A\u0633\u062A\u0636\u064A\u0641\u0647 {host}",
    summaryLabel: "\u062D\u0648\u0644 \u0627\u0644\u0641\u0636\u0627\u0621",
    closedNotice: "\u0647\u0630\u0627 \u0627\u0644\u0641\u0636\u0627\u0621 \u0645\u063A\u0644\u0642: \u064A\u0645\u0643\u0646 \u0627\u0644\u0627\u0637\u0644\u0627\u0639 \u0639\u0644\u0649 \u0645\u062D\u062A\u0648\u0627\u0647 \u0644\u0644\u0642\u0631\u0627\u0621\u0629 \u0641\u0642\u0637.",
    notFoundTitle: "\u0627\u0644\u0641\u0636\u0627\u0621 \u063A\u064A\u0631 \u0645\u0648\u062C\u0648\u062F",
    notFoundBody: "\u0647\u0630\u0627 \u0627\u0644\u0641\u0636\u0627\u0621 \u063A\u064A\u0631 \u0645\u0648\u062C\u0648\u062F \u0623\u0648 \u0644\u0645 \u064A\u0639\u062F \u0628\u0625\u0645\u0643\u0627\u0646\u0643 \u0627\u0644\u0648\u0635\u0648\u0644 \u0625\u0644\u064A\u0647. \u062A\u062D\u0642\u0642 \u0645\u0646 \u0627\u0644\u0631\u0627\u0628\u0637 \u0623\u0648 \u0627\u0637\u0644\u0628 \u062F\u0639\u0648\u0629 \u062C\u062F\u064A\u062F\u0629 \u0645\u0646 \u0627\u0644\u0645\u0624\u0633\u0633\u0629 \u0627\u0644\u0645\u0633\u062A\u0636\u064A\u0641\u0629.",
    backToList: "\u0639\u0631\u0636 \u0641\u0636\u0627\u0621\u0627\u062A\u064A \u0627\u0644\u0645\u0634\u062A\u0631\u0643\u0629",
    loadFailedTitle: "\u062A\u0639\u0630\u0651\u0631 \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0641\u0636\u0627\u0621",
    loadFailedBody: "\u062A\u062D\u0642\u0642 \u0645\u0646 \u0627\u062A\u0635\u0627\u0644\u0643 \u062B\u0645 \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629.",
    noTabsTitle: "\u0644\u0627 \u0634\u064A\u0621 \u0644\u0639\u0631\u0636\u0647 \u062D\u0627\u0644\u064A\u0627\u064B",
    noTabsBody: "\u0648\u0635\u0648\u0644\u0643 \u0625\u0644\u0649 \u0647\u0630\u0627 \u0627\u0644\u0641\u0636\u0627\u0621 \u0644\u0627 \u064A\u062A\u064A\u062D \u0628\u0639\u062F\u064F \u0623\u064A \u0645\u062D\u062A\u0648\u0649. \u062A\u0648\u0627\u0635\u0644 \u0645\u0639 \u0627\u0644\u0634\u062E\u0635 \u0627\u0644\u0630\u064A \u062F\u0639\u0627\u0643."
  },
  later: {
    calendar: {
      title: "\u062A\u0642\u0648\u064A\u0645 \u0627\u0644\u0641\u0636\u0627\u0621 \u0642\u0627\u062F\u0645 \u0642\u0631\u064A\u0628\u0627\u064B",
      description: "\u0633\u062A\u0638\u0647\u0631 \u0647\u0646\u0627 \u0623\u062D\u062F\u0627\u062B \u0627\u0644\u0641\u0636\u0627\u0621 \u0648\u0645\u0648\u0627\u0639\u064A\u062F\u0647."
    },
    meetings: {
      title: "\u0627\u062C\u062A\u0645\u0627\u0639\u0627\u062A \u0627\u0644\u0641\u0636\u0627\u0621 \u0642\u0627\u062F\u0645\u0629 \u0642\u0631\u064A\u0628\u0627\u064B",
      description: "\u0633\u062A\u062A\u0645\u0643\u0646 \u0645\u0646 \u0628\u062F\u0621 \u0627\u062C\u062A\u0645\u0627\u0639\u0627\u062A \u0627\u0644\u0641\u0636\u0627\u0621 \u0648\u0627\u0644\u0627\u0646\u0636\u0645\u0627\u0645 \u0625\u0644\u064A\u0647\u0627 \u0645\u0646 \u0647\u0646\u0627."
    }
  },
  chat: {
    channelsLabel: "\u0642\u0646\u0648\u0627\u062A \u0627\u0644\u0641\u0636\u0627\u0621",
    channelsHeading: "\u0627\u0644\u0642\u0646\u0648\u0627\u062A",
    loadFailed: "\u062A\u0639\u0630\u0651\u0631 \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0642\u0646\u0648\u0627\u062A. \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629 \u0628\u0639\u062F \u0642\u0644\u064A\u0644.",
    empty: {
      title: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0642\u0646\u0648\u0627\u062A \u0628\u0639\u062F",
      description: "\u0633\u062A\u0638\u0647\u0631 \u0647\u0646\u0627 \u0642\u0646\u0648\u0627\u062A \u0647\u0630\u0627 \u0627\u0644\u0641\u0636\u0627\u0621 \u0639\u0646\u062F \u0625\u0646\u0634\u0627\u0626\u0647\u0627."
    },
    pick: {
      title: "\u0627\u062E\u062A\u0631 \u0642\u0646\u0627\u0629",
      description: "\u062D\u062F\u0651\u062F \u0642\u0646\u0627\u0629 \u0645\u0646 \u0627\u0644\u0642\u0627\u0626\u0645\u0629 \u0644\u0642\u0631\u0627\u0621\u0629 \u0627\u0644\u0631\u0633\u0627\u0626\u0644 \u0648\u0643\u062A\u0627\u0628\u062A\u0647\u0627."
    }
  },
  settings: {
    region: "\u0625\u0639\u062F\u0627\u062F\u0627\u062A \u0627\u0644\u0641\u0636\u0627\u0621",
    general: {
      title: "\u0639\u0627\u0645",
      description: "\u0627\u0644\u0627\u0633\u0645 \u0627\u0644\u0630\u064A \u064A\u0638\u0647\u0631 \u0628\u0647 \u0627\u0644\u0641\u0636\u0627\u0621 \u0644\u062C\u0645\u064A\u0639 \u0627\u0644\u0645\u0634\u0627\u0631\u0643\u064A\u0646 \u0641\u064A\u0647."
    },
    name: {
      label: "\u0627\u0633\u0645 \u0627\u0644\u0641\u0636\u0627\u0621"
    },
    policy: {
      title: "\u0642\u0648\u0627\u0639\u062F \u0627\u0644\u0641\u0636\u0627\u0621",
      description: "\u062A\u0646\u0637\u0628\u0642 \u0647\u0630\u0647 \u0627\u0644\u0642\u0648\u0627\u0639\u062F \u0639\u0644\u0649 \u0643\u0644 \u0639\u0645\u0644\u064A\u0627\u062A \u0627\u0644\u0648\u0635\u0648\u0644 \u0625\u0644\u0649 \u0647\u0630\u0627 \u0627\u0644\u0641\u0636\u0627\u0621\u060C \u0628\u0645\u0627 \u0641\u064A\u0647\u0627 \u0648\u0635\u0648\u0644 \u0627\u0644\u0645\u0624\u0633\u0633\u0627\u062A \u0627\u0644\u0634\u0631\u064A\u0643\u0629 \u0648\u0627\u0644\u0636\u064A\u0648\u0641."
    },
    download: {
      label: "\u0627\u0644\u0633\u0645\u0627\u062D \u0628\u0627\u0644\u062A\u0646\u0632\u064A\u0644",
      hint: "\u0645\u0646 \u062F\u0648\u0646 \u062A\u0646\u0632\u064A\u0644 \u062A\u0628\u0642\u0649 \u0627\u0644\u0645\u0633\u062A\u0646\u062F\u0627\u062A \u0645\u062A\u0627\u062D\u0629 \u0644\u0644\u0645\u0639\u0627\u064A\u0646\u0629."
    },
    watermark: {
      label: "\u0639\u0644\u0627\u0645\u0629 \u0645\u0627\u0626\u064A\u0629 \u0639\u0644\u0649 \u0645\u0644\u0641\u0627\u062A PDF",
      hint: "\u062A\u062D\u062F\u062F \u0627\u0644\u0639\u0644\u0627\u0645\u0629 \u0627\u0644\u0645\u0627\u0626\u064A\u0629 \u0647\u0648\u064A\u0629 \u0627\u0644\u0634\u062E\u0635 \u0627\u0644\u0630\u064A \u064A\u0637\u0651\u0644\u0639 \u0639\u0644\u0649 \u0643\u0644 \u0645\u0644\u0641 PDF."
    },
    print: {
      label: "\u0627\u0644\u0633\u0645\u0627\u062D \u0628\u0627\u0644\u0637\u0628\u0627\u0639\u0629",
      hint: "\u062A\u062A\u0645 \u0627\u0644\u0637\u0628\u0627\u0639\u0629 \u0645\u0646 \u0639\u0627\u0631\u0636 \u0627\u0644\u0645\u0633\u062A\u0646\u062F\u0627\u062A."
    },
    domains: {
      label: "\u0627\u0644\u0646\u0637\u0627\u0642\u0627\u062A \u0627\u0644\u0645\u0633\u0645\u0648\u062D \u0628\u0647\u0627 \u0644\u0644\u0636\u064A\u0648\u0641",
      hint: "\u0623\u062F\u062E\u0644 \u0646\u0637\u0627\u0642\u0627\u064B\u060C \u0645\u062B\u0644 client.tn\u060C \u062B\u0645 \u0627\u0636\u063A\u0637 Enter.",
      empty: "\u0644\u0627 \u064A\u0648\u062C\u062F \u0646\u0637\u0627\u0642: \u064A\u0645\u0643\u0646 \u0644\u0644\u0636\u064A\u0648\u0641 \u0627\u0633\u062A\u062E\u062F\u0627\u0645 \u0623\u064A \u0628\u0631\u064A\u062F \u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A \u062A\u0633\u0645\u062D \u0628\u0647 \u0633\u064A\u0627\u0633\u0629 \u0645\u0624\u0633\u0633\u062A\u0643."
    },
    save: "\u062D\u0641\u0638 \u0627\u0644\u0625\u0639\u062F\u0627\u062F\u0627\u062A",
    saving: "\u062C\u0627\u0631\u064D \u0627\u0644\u062D\u0641\u0638\u2026",
    saved: "\u062A\u0645 \u062D\u0641\u0638 \u0625\u0639\u062F\u0627\u062F\u0627\u062A \u0627\u0644\u0641\u0636\u0627\u0621.",
    noChange: "\u0644\u0627 \u062A\u0648\u062C\u062F \u062A\u0639\u062F\u064A\u0644\u0627\u062A \u0644\u062D\u0641\u0638\u0647\u0627.",
    stepUpNote: "\u064A\u062A\u0637\u0644\u0628 \u0627\u0644\u062D\u0641\u0638 \u062A\u0623\u0643\u064A\u062F \u0647\u0648\u064A\u062A\u0643.",
    failedTitle: "\u0644\u0645 \u064A\u062A\u0645 \u062D\u0641\u0638 \u0627\u0644\u0625\u0639\u062F\u0627\u062F\u0627\u062A",
    closedNotice: "\u0647\u0630\u0627 \u0627\u0644\u0641\u0636\u0627\u0621 \u0645\u063A\u0644\u0642: \u0644\u0645 \u064A\u0639\u062F \u0628\u0627\u0644\u0625\u0645\u0643\u0627\u0646 \u062A\u0639\u062F\u064A\u0644 \u0625\u0639\u062F\u0627\u062F\u0627\u062A\u0647.",
    errors: {
      nameRequired: "\u0623\u062F\u062E\u0644 \u0627\u0633\u0645\u0627\u064B \u0644\u0644\u0641\u0636\u0627\u0621.",
      nameTooLong: "\u0644\u0627 \u064A\u0645\u0643\u0646 \u0623\u0646 \u064A\u062A\u062C\u0627\u0648\u0632 \u0627\u0644\u0627\u0633\u0645 200 \u062D\u0631\u0641.",
      validation: "\u0628\u0639\u0636 \u0627\u0644\u0642\u064A\u0645 \u063A\u064A\u0631 \u0635\u0627\u0644\u062D\u0629. \u062A\u062D\u0642\u0642 \u0645\u0646 \u0627\u0644\u0627\u0633\u0645 \u0648\u0627\u0644\u0646\u0637\u0627\u0642\u0627\u062A \u062B\u0645 \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629.",
      forbidden: "\u0644\u064A\u0633\u062A \u0644\u062F\u064A\u0643 \u0635\u0644\u0627\u062D\u064A\u0629 \u062A\u0639\u062F\u064A\u0644 \u0625\u0639\u062F\u0627\u062F\u0627\u062A \u0647\u0630\u0627 \u0627\u0644\u0641\u0636\u0627\u0621."
    }
  },
  list: {
    ownHeading: "\u0641\u0636\u0627\u0621\u0627\u062A \u0645\u0624\u0633\u0633\u0627\u062A\u064A",
    ownEmptyTitle: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0641\u0636\u0627\u0621\u0627\u062A \u0645\u0634\u062A\u0631\u0643\u0629 \u0641\u064A \u0645\u0624\u0633\u0633\u0627\u062A\u0643",
    ownEmptyBody: "\u0623\u0646\u0634\u0626 \u0641\u0636\u0627\u0621\u064B \u0645\u0634\u062A\u0631\u0643\u0627\u064B \u0644\u0644\u0639\u0645\u0644 \u0645\u0639 \u0627\u0644\u0634\u0631\u0643\u0627\u0621\u060C \u0623\u0648 \u0645\u062C\u0645\u0648\u0639\u0629 \u0639\u0645\u0644 \u0644\u0641\u0631\u0642\u0643.",
    externalHeading: "\u0627\u0644\u0641\u0636\u0627\u0621\u0627\u062A \u0627\u0644\u062E\u0627\u0631\u062C\u064A\u0629",
    externalEmptyTitle: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0641\u0636\u0627\u0621\u0627\u062A \u062E\u0627\u0631\u062C\u064A\u0629",
    externalEmptyBody: "\u0633\u062A\u0638\u0647\u0631 \u0647\u0646\u0627 \u0641\u0636\u0627\u0621\u0627\u062A \u0627\u0644\u0645\u0624\u0633\u0633\u0627\u062A \u0627\u0644\u0623\u062E\u0631\u0649 \u0627\u0644\u062A\u064A \u062A\u0645\u0646\u062D\u0643 \u062D\u0642 \u0627\u0644\u0648\u0635\u0648\u0644.",
    loadFailedTitle: "\u062A\u0639\u0630\u0651\u0631 \u062A\u062D\u0645\u064A\u0644 \u0641\u0636\u0627\u0621\u0627\u062A\u0643",
    loadFailedBody: "\u062A\u062D\u0642\u0642 \u0645\u0646 \u0627\u062A\u0635\u0627\u0644\u0643 \u062B\u0645 \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629.",
    newSpace: "\u0641\u0636\u0627\u0621 \u0645\u0634\u062A\u0631\u0643 \u062C\u062F\u064A\u062F",
    external: "\u062E\u0627\u0631\u062C\u064A"
  },
  create: {
    title: "\u0641\u0636\u0627\u0621 \u0645\u0634\u062A\u0631\u0643 \u062C\u062F\u064A\u062F",
    intro: "\u0633\u062A\u0643\u0648\u0646 \u0645\u0633\u0624\u0648\u0644 \u0627\u0644\u0641\u0636\u0627\u0621. \u064A\u0645\u0643\u0646\u0643 \u0628\u0639\u062F \u0630\u0644\u0643 \u062F\u0639\u0648\u0629 \u0645\u0624\u0633\u0633\u0627\u062A \u0634\u0631\u064A\u0643\u0629 \u0625\u0644\u064A\u0647.",
    kind: {
      label: "\u0646\u0648\u0639 \u0627\u0644\u0641\u0636\u0627\u0621",
      shared: {
        label: "\u0641\u0636\u0627\u0621 \u0645\u0634\u062A\u0631\u0643 \u0644\u0645\u0634\u0631\u0648\u0639",
        hint: "\u0645\u0631\u062A\u0628\u0637 \u0628\u0623\u062D\u062F \u0627\u0644\u0645\u0634\u0627\u0631\u064A\u0639 \u0627\u0644\u062A\u064A \u062A\u062A\u0648\u0644\u0649 \u0625\u062F\u0627\u0631\u062A\u0647\u0627."
      },
      group: {
        label: "\u0645\u062C\u0645\u0648\u0639\u0629 \u0639\u0645\u0644",
        hint: "\u063A\u064A\u0631 \u0645\u0631\u062A\u0628\u0637\u0629 \u0628\u0645\u0634\u0631\u0648\u0639. \u0645\u062E\u0635\u0635\u0629 \u0644\u0644\u0645\u0627\u0644\u0643\u064A\u0646 \u0648\u0627\u0644\u0645\u0633\u0624\u0648\u0644\u064A\u0646."
      }
    },
    project: {
      label: "\u0627\u0644\u0645\u0634\u0631\u0648\u0639",
      placeholder: "\u0627\u062E\u062A\u0631 \u0645\u0634\u0631\u0648\u0639\u0627\u064B",
      none: "\u0644\u0627 \u062A\u062A\u0648\u0644\u0649 \u0625\u062F\u0627\u0631\u0629 \u0623\u064A \u0645\u0634\u0631\u0648\u0639: \u064A\u062C\u0628 \u0623\u0646 \u064A\u0631\u062A\u0628\u0637 \u0627\u0644\u0641\u0636\u0627\u0621 \u0627\u0644\u0645\u0634\u062A\u0631\u0643 \u0628\u0645\u0634\u0631\u0648\u0639 \u062A\u062F\u064A\u0631\u0647."
    },
    name: {
      label: "\u0627\u0633\u0645 \u0627\u0644\u0641\u0636\u0627\u0621"
    },
    submit: "\u0625\u0646\u0634\u0627\u0621 \u0627\u0644\u0641\u0636\u0627\u0621",
    submitting: "\u062C\u0627\u0631\u064D \u0627\u0644\u0625\u0646\u0634\u0627\u0621\u2026",
    created: "\u062A\u0645 \u0625\u0646\u0634\u0627\u0621 \u0627\u0644\u0641\u0636\u0627\u0621 \xAB{name}\xBB.",
    errors: {
      nameRequired: "\u0623\u062F\u062E\u0644 \u0627\u0633\u0645\u0627\u064B \u0644\u0644\u0641\u0636\u0627\u0621.",
      nameTooLong: "\u0644\u0627 \u064A\u0645\u0643\u0646 \u0623\u0646 \u064A\u062A\u062C\u0627\u0648\u0632 \u0627\u0644\u0627\u0633\u0645 200 \u062D\u0631\u0641.",
      projectRequired: "\u0627\u062E\u062A\u0631 \u0627\u0644\u0645\u0634\u0631\u0648\u0639 \u0627\u0644\u0645\u0631\u062A\u0628\u0637 \u0628\u0627\u0644\u0641\u0636\u0627\u0621.",
      forbidden: "\u0644\u064A\u0633\u062A \u0644\u062F\u064A\u0643 \u0635\u0644\u0627\u062D\u064A\u0629 \u0625\u0646\u0634\u0627\u0621 \u0647\u0630\u0627 \u0627\u0644\u0641\u0636\u0627\u0621 \u0641\u064A \u0647\u0630\u0647 \u0627\u0644\u0645\u0624\u0633\u0633\u0629.",
      planLimit: "\u0644\u0627 \u064A\u062A\u064A\u062D \u0627\u0634\u062A\u0631\u0627\u0643\u0643 \u0627\u0633\u062A\u0636\u0627\u0641\u0629 \u0645\u0632\u064A\u062F \u0645\u0646 \u0627\u0644\u0641\u0636\u0627\u0621\u0627\u062A \u0627\u0644\u0645\u0634\u062A\u0631\u0643\u0629. \u062A\u0648\u0627\u0635\u0644 \u0645\u0639 \u0645\u0627\u0644\u0643 \u0627\u0644\u062D\u0633\u0627\u0628 \u0644\u0644\u0627\u0646\u062A\u0642\u0627\u0644 \u0625\u0644\u0649 \u0627\u0634\u062A\u0631\u0627\u0643 \u0623\u0639\u0644\u0649.",
      projectGone: "\u0647\u0630\u0627 \u0627\u0644\u0645\u0634\u0631\u0648\u0639 \u0644\u0645 \u064A\u0639\u062F \u0645\u0648\u062C\u0648\u062F\u0627\u064B \u0623\u0648 \u0644\u0645 \u062A\u0639\u062F \u0645\u0633\u0624\u0648\u0644\u0627\u064B \u0639\u0646\u0647. \u0627\u062E\u062A\u0631 \u0645\u0634\u0631\u0648\u0639\u0627\u064B \u0622\u062E\u0631."
    }
  },
  listPane: {
    title: "\u0627\u0644\u0641\u0636\u0627\u0621\u0627\u062A \u0627\u0644\u0645\u0634\u062A\u0631\u0643\u0629",
    label: "\u0641\u0636\u0627\u0621\u0627\u062A\u064A \u0627\u0644\u0645\u0634\u062A\u0631\u0643\u0629",
    empty: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0641\u0636\u0627\u0621\u0627\u062A \u0645\u0634\u062A\u0631\u0643\u0629 \u0628\u0639\u062F.",
    loadFailed: "\u062A\u0639\u0630\u0651\u0631 \u062A\u062D\u0645\u064A\u0644 \u0641\u0636\u0627\u0621\u0627\u062A\u0643 \u0627\u0644\u0645\u0634\u062A\u0631\u0643\u0629.",
    external: "\u062E\u0627\u0631\u062C\u064A",
    hostedBy: "\u062A\u0633\u062A\u0636\u064A\u0641\u0647 {host}",
    seeAll: "\u0643\u0644 \u0627\u0644\u0641\u0636\u0627\u0621\u0627\u062A \u0627\u0644\u0645\u0634\u062A\u0631\u0643\u0629",
    count: "{count, plural, zero {\u0644\u0627 \u0641\u0636\u0627\u0621\u0627\u062A \u0645\u0634\u062A\u0631\u0643\u0629} one {\u0641\u0636\u0627\u0621 \u0645\u0634\u062A\u0631\u0643 \u0648\u0627\u062D\u062F} two {\u0641\u0636\u0627\u0621\u0627\u0646 \u0645\u0634\u062A\u0631\u0643\u0627\u0646} few {# \u0641\u0636\u0627\u0621\u0627\u062A \u0645\u0634\u062A\u0631\u0643\u0629} many {# \u0641\u0636\u0627\u0621\u064B \u0645\u0634\u062A\u0631\u0643\u064B\u0627} other {# \u0641\u0636\u0627\u0621 \u0645\u0634\u062A\u0631\u0643}}"
  },
  guest: {
    expiry: "\u064A\u0646\u062A\u0647\u064A \u0648\u0635\u0648\u0644\u0643 \u0643\u0636\u064A\u0641 \u0641\u064A {date}.",
    expirySoon: "\u0627\u0637\u0644\u0628 \u0645\u0645\u0646 \u062F\u0639\u0627\u0643 \u062A\u0645\u062F\u064A\u062F\u0647 \u0625\u0646 \u0643\u0646\u062A \u0645\u0627 \u0632\u0644\u062A \u0628\u062D\u0627\u062C\u0629 \u0625\u0644\u064A\u0647."
  },
  sharing: {
    remove: "\u0633\u062D\u0628",
    loadFailedBody: "\u062A\u062D\u0642\u0642 \u0645\u0646 \u0627\u062A\u0635\u0627\u0644\u0643 \u062B\u0645 \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629.",
    errors: {
      forbidden: "\u0644\u064A\u0633 \u0644\u062F\u064A\u0643 \u0635\u0644\u0627\u062D\u064A\u0629 \u062A\u0646\u0641\u064A\u0630 \u0647\u0630\u0627 \u0627\u0644\u0625\u062C\u0631\u0627\u0621 \u0641\u064A \u0647\u0630\u0627 \u0627\u0644\u0641\u0636\u0627\u0621."
    },
    partnerStatus: {
      pending: "\u0628\u0627\u0646\u062A\u0638\u0627\u0631 \u0627\u0644\u0631\u062F",
      active: "\u0646\u0634\u0637\u0629",
      declined: "\u0645\u0631\u0641\u0648\u0636\u0629",
      expired: "\u0645\u0646\u062A\u0647\u064A\u0629",
      revoked: "\u0645\u0633\u062D\u0648\u0628\u0629"
    },
    invitationStatus: {
      pending_approval: "\u0628\u0627\u0646\u062A\u0638\u0627\u0631 \u0645\u0648\u0627\u0641\u0642\u0629 \u0645\u0624\u0633\u0633\u062A\u0647",
      pending: "\u0628\u0627\u0646\u062A\u0638\u0627\u0631 \u0627\u0644\u0631\u062F",
      accepted: "\u0645\u0642\u0628\u0648\u0644\u0629",
      declined: "\u0645\u0631\u0641\u0648\u0636\u0629",
      expired: "\u0645\u0646\u062A\u0647\u064A\u0629",
      revoked: "\u0645\u0644\u063A\u0627\u0629"
    },
    memberVia: {
      host_member: "\u0639\u0636\u0648 \u0641\u064A \u0627\u0644\u0645\u0624\u0633\u0633\u0629 \u0627\u0644\u0645\u0633\u062A\u0636\u064A\u0641\u0629",
      partner_delegation: "\u0645\u0641\u0648\u064E\u0651\u0636 \u0645\u0646 \u0634\u0631\u064A\u0643",
      direct_invite: "\u0645\u062F\u0639\u0648 \u0628\u0627\u0644\u0627\u0633\u0645",
      guest: "\u0636\u064A\u0641"
    },
    rightsOption: {
      label: "\u0627\u0644\u0635\u0644\u0627\u062D\u064A\u0627\u062A",
      read: "\u0627\u0644\u0642\u0631\u0627\u0621\u0629: \u0627\u0644\u0627\u0637\u0644\u0627\u0639 \u0639\u0644\u0649 \u0627\u0644\u0645\u0633\u062A\u0646\u062F\u0627\u062A \u0648\u0627\u0644\u0645\u062D\u0627\u062F\u062B\u0627\u062A",
      write: "\u0627\u0644\u0643\u062A\u0627\u0628\u0629: \u0627\u0644\u0627\u0637\u0644\u0627\u0639 \u0648\u0627\u0644\u0625\u0636\u0627\u0641\u0629 \u0648\u0627\u0644\u062A\u0639\u062F\u064A\u0644",
      approve: "\u0627\u0644\u0643\u062A\u0627\u0628\u0629 \u0648\u0627\u0644\u0645\u0635\u0627\u062F\u0642\u0629: \u0645\u0639 \u0627\u0644\u0645\u0635\u0627\u062F\u0642\u0629 \u0639\u0644\u0649 \u0627\u0644\u0645\u0633\u062A\u0646\u062F\u0627\u062A"
    },
    scope: {
      label: "\u0645\u0627 \u064A\u0634\u0645\u0644\u0647 \u0627\u0644\u0648\u0635\u0648\u0644",
      all: "\u0643\u0644 \u0627\u0644\u0641\u0636\u0627\u0621",
      some: "\u0645\u062C\u0644\u062F\u0627\u062A \u0648\u0642\u0646\u0648\u0627\u062A \u0645\u062E\u062A\u0627\u0631\u0629 \u0641\u0642\u0637",
      foldersLegend: "\u0627\u0644\u0645\u062C\u0644\u062F\u0627\u062A",
      channelsLegend: "\u0627\u0644\u0642\u0646\u0648\u0627\u062A",
      subfoldersHint: "\u0627\u062E\u062A\u064A\u0627\u0631 \u0645\u062C\u0644\u062F \u064A\u0645\u0646\u062D \u0627\u0644\u0648\u0635\u0648\u0644 \u0623\u064A\u0636\u0627\u064B \u0625\u0644\u0649 \u0645\u062C\u0644\u062F\u0627\u062A\u0647 \u0627\u0644\u0641\u0631\u0639\u064A\u0629.",
      noFolders: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0645\u062C\u0644\u062F\u0627\u062A \u0644\u0644\u0627\u062E\u062A\u064A\u0627\u0631 \u062D\u0627\u0644\u064A\u0627\u064B.",
      noChannels: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0642\u0646\u0648\u0627\u062A \u0644\u0644\u0627\u062E\u062A\u064A\u0627\u0631 \u062D\u0627\u0644\u064A\u0627\u064B.",
      foldersFailed: "\u062A\u0639\u0630\u0651\u0631 \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0645\u062C\u0644\u062F\u0627\u062A. \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629 \u0628\u0639\u062F \u0642\u0644\u064A\u0644.",
      channelsFailed: "\u062A\u0639\u0630\u0651\u0631 \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0642\u0646\u0648\u0627\u062A. \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629 \u0628\u0639\u062F \u0642\u0644\u064A\u0644.",
      loading: "\u062C\u0627\u0631\u064D \u0627\u0644\u062A\u062D\u0645\u064A\u0644\u2026",
      unnamedChannel: "\u0642\u0646\u0627\u0629 \u0628\u0644\u0627 \u0627\u0633\u0645",
      expand: "\u0625\u0638\u0647\u0627\u0631 \u0627\u0644\u0645\u062C\u0644\u062F\u0627\u062A \u0627\u0644\u0641\u0631\u0639\u064A\u0629 \u0644\u0640 {name}",
      collapse: "\u0625\u062E\u0641\u0627\u0621 \u0627\u0644\u0645\u062C\u0644\u062F\u0627\u062A \u0627\u0644\u0641\u0631\u0639\u064A\u0629 \u0644\u0640 {name}",
      summaryAll: "\u0643\u0644 \u0627\u0644\u0641\u0636\u0627\u0621",
      summarySome: "\u0627\u0644\u0645\u062C\u0644\u062F\u0627\u062A: {folders} \xB7 \u0627\u0644\u0642\u0646\u0648\u0627\u062A: {channels}",
      errors: {
        empty: "\u0627\u062E\u062A\u0631 \u0645\u062C\u0644\u062F\u0627\u064B \u0623\u0648 \u0642\u0646\u0627\u0629 \u0648\u0627\u062D\u062F\u0629 \u0639\u0644\u0649 \u0627\u0644\u0623\u0642\u0644."
      }
    },
    share: {
      title: "\u0627\u0644\u0645\u0634\u0627\u0631\u0643\u0629 \u0645\u0639 \u0645\u0624\u0633\u0633\u0629",
      intro: "\u0639\u0644\u0649 \u0627\u0644\u0645\u0624\u0633\u0633\u0629 \u0627\u0644\u0645\u062F\u0639\u0648\u0629 \u0623\u0646 \u062A\u0642\u0628\u0644 \u0627\u0644\u062F\u0639\u0648\u0629. \u062B\u0645 \u064A\u062E\u062A\u0627\u0631 \u0645\u0633\u0624\u0648\u0644\u0648\u0647\u0627 \u0645\u0646 \u0628\u064A\u0646 \u0623\u0639\u0636\u0627\u0626\u0647\u0627 \u0645\u0646 \u064A\u0635\u0644 \u0625\u0644\u0649 \u0627\u0644\u0641\u0636\u0627\u0621.",
      taxId: {
        label: "\u0627\u0644\u0645\u0639\u0631\u0651\u0641 \u0627\u0644\u062C\u0628\u0627\u0626\u064A \u0644\u0644\u0645\u0624\u0633\u0633\u0629",
        hint: "\u0623\u062F\u062E\u0644 \u0627\u0644\u0645\u0639\u0631\u0651\u0641 \u0627\u0644\u062C\u0628\u0627\u0626\u064A: \u0633\u064A\u0638\u0647\u0631 \u0628\u0639\u062F\u0647\u0627 \u0627\u0633\u0645 \u0627\u0644\u0645\u0624\u0633\u0633\u0629 \u0627\u0644\u062A\u064A \u0646\u062C\u062F\u0647\u0627 \u0644\u062A\u062A\u062D\u0642\u0642 \u0645\u0646\u0647."
      },
      lookup: {
        loading: "\u062C\u0627\u0631\u064D \u0627\u0644\u0628\u062D\u062B \u0639\u0646 \u0627\u0644\u0645\u0624\u0633\u0633\u0629\u2026",
        found: "\u062A\u0645 \u0627\u0644\u0639\u062B\u0648\u0631 \u0639\u0644\u0649 \u0627\u0644\u0645\u0624\u0633\u0633\u0629: {name}. \u062A\u0623\u0643\u062F \u0645\u0646 \u0623\u0646\u0647\u0627 \u0627\u0644\u0645\u0624\u0633\u0633\u0629 \u0627\u0644\u062A\u064A \u062A\u0631\u064A\u062F \u062F\u0639\u0648\u062A\u0647\u0627.",
        notFound: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0645\u0624\u0633\u0633\u0629 \u0639\u0644\u0649 BatiFlow \u0628\u0647\u0630\u0627 \u0627\u0644\u0645\u0639\u0631\u0651\u0641 \u0627\u0644\u062C\u0628\u0627\u0626\u064A. \u062A\u062D\u0642\u0642 \u0645\u0646\u0647 \u0623\u0648 \u0627\u0637\u0644\u0628 \u0645\u0646 \u0634\u0631\u064A\u0643\u0643 \u0625\u0646\u0634\u0627\u0621 \u062D\u0633\u0627\u0628\u0647.",
        failed: "\u0644\u0645 \u064A\u0646\u062C\u062D \u0627\u0644\u0628\u062D\u062B. \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629 \u0628\u0639\u062F \u0642\u0644\u064A\u0644."
      },
      cap: {
        label: "\u0627\u0644\u062D\u062F \u0627\u0644\u0623\u0642\u0635\u0649 \u0644\u0639\u062F\u062F \u0627\u0644\u0623\u0634\u062E\u0627\u0635",
        hint: "\u0639\u062F\u062F \u0627\u0644\u0623\u0634\u062E\u0627\u0635 \u0627\u0644\u0630\u064A\u0646 \u064A\u0645\u0643\u0646 \u0644\u0647\u0630\u0647 \u0627\u0644\u0645\u0624\u0633\u0633\u0629 \u0625\u0636\u0627\u0641\u062A\u0647\u0645 \u0625\u0644\u0649 \u0627\u0644\u0641\u0636\u0627\u0621 (\u0645\u0646 1 \u0625\u0644\u0649 500)."
      },
      end: {
        label: "\u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0627\u0646\u062A\u0647\u0627\u0621 (\u0627\u062E\u062A\u064A\u0627\u0631\u064A)",
        hint: "\u0627\u062A\u0631\u0643\u0647 \u0641\u0627\u0631\u063A\u0627\u064B: \u064A\u0633\u062A\u0645\u0631 \u0627\u0644\u0648\u0635\u0648\u0644 \u0625\u0644\u0649 \u0623\u0646 \u062A\u0633\u062D\u0628\u0647."
      },
      stepUpNote: "\u0625\u0631\u0633\u0627\u0644 \u0627\u0644\u062F\u0639\u0648\u0629 \u064A\u062A\u0637\u0644\u0628 \u062A\u0623\u0643\u064A\u062F \u0647\u0648\u064A\u062A\u0643.",
      submit: "\u0625\u0631\u0633\u0627\u0644 \u0627\u0644\u062F\u0639\u0648\u0629",
      submitting: "\u062C\u0627\u0631\u064D \u0627\u0644\u0625\u0631\u0633\u0627\u0644\u2026",
      sent: "\u062A\u0645 \u0625\u0631\u0633\u0627\u0644 \u0627\u0644\u062F\u0639\u0648\u0629 \u0625\u0644\u0649 {name}. \u064A\u0628\u062F\u0623 \u0627\u0644\u0648\u0635\u0648\u0644 \u0639\u0646\u062F\u0645\u0627 \u062A\u0642\u0628\u0644\u0647\u0627 \u0627\u0644\u0645\u0624\u0633\u0633\u0629.",
      errors: {
        taxIdRequired: "\u0623\u062F\u062E\u0644 \u0627\u0644\u0645\u0639\u0631\u0651\u0641 \u0627\u0644\u062C\u0628\u0627\u0626\u064A \u0644\u0644\u0645\u0624\u0633\u0633\u0629.",
        notConfirmed: "\u0627\u0646\u062A\u0638\u0631 \u0627\u0644\u0639\u062B\u0648\u0631 \u0639\u0644\u0649 \u0627\u0644\u0645\u0624\u0633\u0633\u0629 \u0623\u0648 \u0635\u062D\u0651\u062D \u0627\u0644\u0645\u0639\u0631\u0651\u0641 \u0627\u0644\u062C\u0628\u0627\u0626\u064A.",
        capInvalid: "\u0623\u062F\u062E\u0644 \u0639\u062F\u062F\u0627\u064B \u0635\u062D\u064A\u062D\u0627\u064B \u0645\u0646 \u0627\u0644\u0623\u0634\u062E\u0627\u0635 \u0628\u064A\u0646 1 \u0648{max}.",
        endPast: "\u0644\u0627 \u064A\u0645\u0643\u0646 \u0623\u0646 \u064A\u0643\u0648\u0646 \u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0627\u0646\u062A\u0647\u0627\u0621 \u0641\u064A \u0627\u0644\u0645\u0627\u0636\u064A.",
        forbidden: "\u0644\u064A\u0633 \u0644\u062F\u064A\u0643 \u0635\u0644\u0627\u062D\u064A\u0629 \u0645\u0634\u0627\u0631\u0643\u0629 \u0647\u0630\u0627 \u0627\u0644\u0641\u0636\u0627\u0621 \u0645\u0639 \u0645\u0624\u0633\u0633\u0629 \u0623\u062E\u0631\u0649."
      },
      directory: {
        open: "\u0627\u0644\u0628\u062D\u062B \u0641\u064A \u0627\u0644\u062F\u0644\u064A\u0644",
        title: "\u062F\u0644\u064A\u0644 \u0627\u0644\u0645\u0643\u0627\u062A\u0628",
        searchLabel: "\u0627\u0633\u0645 \u0627\u0644\u0645\u0643\u062A\u0628",
        results: "\u0645\u0643\u0627\u062A\u0628 \u0627\u0644\u062F\u0644\u064A\u0644",
        empty: "\u0644\u0645 \u064A\u064F\u0639\u062B\u0631 \u0639\u0644\u0649 \u0623\u064A \u0645\u0643\u062A\u0628 \u0641\u064A \u0627\u0644\u062F\u0644\u064A\u0644.",
        loadFailed: "\u062A\u0639\u0630\u0651\u0631 \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u062F\u0644\u064A\u0644. \u0623\u0639\u064A\u062F\u0648\u0627 \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629 \u0628\u0639\u062F \u0642\u0644\u064A\u0644.",
        more: "\u0639\u0631\u0636 \u0627\u0644\u0645\u0632\u064A\u062F",
        choose: "\u0627\u062E\u062A\u064A\u0627\u0631",
        chooseLabel: "\u0627\u062E\u062A\u064A\u0627\u0631 {name}",
        chosen: "\u0627\u0644\u0645\u0643\u062A\u0628 \u0627\u0644\u0645\u062E\u062A\u0627\u0631 \u0645\u0646 \u0627\u0644\u062F\u0644\u064A\u0644: {name}.",
        change: "\u062A\u063A\u064A\u064A\u0631",
        gone: "\u0644\u0645 \u064A\u0639\u062F \u0647\u0630\u0627 \u0627\u0644\u0645\u0643\u062A\u0628 \u0641\u064A \u0627\u0644\u062F\u0644\u064A\u0644. \u0627\u062E\u062A\u0627\u0631\u0648\u0627 \u0645\u0643\u062A\u0628\u064B\u0627 \u0622\u062E\u0631 \u0623\u0648 \u0623\u062F\u062E\u0644\u0648\u0627 \u0645\u0639\u0631\u0651\u0641\u0647 \u0627\u0644\u062C\u0628\u0627\u0626\u064A."
      }
    },
    person: {
      title: "\u062F\u0639\u0648\u0629 \u0634\u062E\u0635",
      intro: "\u0627\u062F\u0639\u064F \u0634\u062E\u0635\u0627\u064B \u0639\u0628\u0631 \u0628\u0631\u064A\u062F\u0647 \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A: \u0634\u062E\u0635\u0627\u064B \u0645\u0633\u0645\u0651\u0649 (\u0645\u0646 \u0645\u0624\u0633\u0633\u0629 \u0623\u062E\u0631\u0649) \u0623\u0648 \u0636\u064A\u0641\u0627\u064B.",
      email: {
        label: "\u0627\u0644\u0628\u0631\u064A\u062F \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A",
        hint: "\u062A\u064F\u0631\u0633\u0644 \u0627\u0644\u062F\u0639\u0648\u0629 \u0625\u0644\u0649 \u0647\u0630\u0627 \u0627\u0644\u0639\u0646\u0648\u0627\u0646. \u0648\u0644\u0627 \u064A\u0638\u0647\u0631 \u0627\u0644\u0639\u0646\u0648\u0627\u0646 \u0623\u0628\u062F\u0627\u064B \u0641\u064A \u0627\u0644\u0631\u0627\u0628\u0637."
      },
      kind: {
        label: "\u0646\u0648\u0639 \u0627\u0644\u062F\u0639\u0648\u0629",
        nominative: "\u0634\u062E\u0635 \u0645\u0633\u0645\u0651\u0649",
        guest: "\u0636\u064A\u0641",
        nominativeHint: "\u0634\u062E\u0635 \u0645\u0646 \u0645\u0624\u0633\u0633\u0629 \u0623\u062E\u0631\u0649\u060C \u0628\u0627\u0644\u0648\u0635\u0648\u0644 \u0648\u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0627\u0646\u062A\u0647\u0627\u0621 \u0627\u0644\u0644\u0630\u064A\u0646 \u062A\u062E\u062A\u0627\u0631\u0647\u0645\u0627. \u0648\u0642\u062F \u062A\u062D\u062A\u0627\u062C \u0645\u0624\u0633\u0633\u062A\u0647 \u0625\u0644\u0649 \u0627\u0644\u0645\u0648\u0627\u0641\u0642\u0629.",
        guestHint: "\u0634\u062E\u0635 \u0628\u0644\u0627 \u062D\u0633\u0627\u0628 \u0639\u0644\u0649 BatiFlow\u060C \u064A\u0642\u062A\u0635\u0631 \u0639\u0644\u0649 \u0645\u062C\u0644\u062F\u0627\u062A \u0623\u0648 \u0642\u0646\u0648\u0627\u062A \u0645\u062E\u062A\u0627\u0631\u0629."
      },
      guestDuration: "\u064A\u062D\u062A\u0641\u0638 \u0627\u0644\u0636\u064A\u0641 \u0628\u0648\u0635\u0648\u0644\u0647 90 \u064A\u0648\u0645\u0627\u064B. \u0648\u064A\u0645\u0643\u0646\u0643 \u0628\u0639\u062F \u0630\u0644\u0643 \u062A\u0645\u062F\u064A\u062F\u0647 90 \u064A\u0648\u0645\u0627\u064B \u0645\u0646 \u062A\u0628\u0648\u064A\u0628 \u0627\u0644\u0623\u0634\u062E\u0627\u0635.",
      end: {
        hint: "\u0627\u062A\u0631\u0643\u0647 \u0641\u0627\u0631\u063A\u0627\u064B: \u064A\u0633\u062A\u0645\u0631 \u0627\u0644\u0648\u0635\u0648\u0644 \u0625\u0644\u0649 \u0623\u0646 \u062A\u0633\u062D\u0628\u0647."
      },
      submit: "\u0625\u0631\u0633\u0627\u0644 \u0627\u0644\u062F\u0639\u0648\u0629",
      submitting: "\u062C\u0627\u0631\u064D \u0627\u0644\u0625\u0631\u0633\u0627\u0644\u2026",
      sent: "\u062A\u0645 \u0625\u0631\u0633\u0627\u0644 \u0627\u0644\u062F\u0639\u0648\u0629 \u0625\u0644\u0649 {email}.",
      sentWaitingApproval: "\u062A\u0645 \u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062F\u0639\u0648\u0629 \u0625\u0644\u0649 {email}. \u0648\u0647\u064A \u0628\u0627\u0646\u062A\u0638\u0627\u0631 \u0645\u0648\u0627\u0641\u0642\u0629 \u0645\u0624\u0633\u0633\u062A\u0647 \u0642\u0628\u0644 \u0625\u0631\u0633\u0627\u0644\u0647\u0627.",
      errors: {
        emailRequired: "\u0623\u062F\u062E\u0644 \u0627\u0644\u0628\u0631\u064A\u062F \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A \u0644\u0644\u0634\u062E\u0635.",
        emailInvalid: "\u0647\u0630\u0627 \u0627\u0644\u0628\u0631\u064A\u062F \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A \u063A\u064A\u0631 \u0635\u0627\u0644\u062D.",
        forbidden: "\u0644\u064A\u0633 \u0644\u062F\u064A\u0643 \u0635\u0644\u0627\u062D\u064A\u0629 \u062F\u0639\u0648\u0629 \u0623\u0634\u062E\u0627\u0635 \u0625\u0644\u0649 \u0647\u0630\u0627 \u0627\u0644\u0641\u0636\u0627\u0621.",
        guestLimit: "\u0628\u0627\u0642\u062A\u0643 \u0644\u0627 \u062A\u0633\u0645\u062D \u0628\u062F\u0639\u0648\u0629 \u0645\u0632\u064A\u062F \u0645\u0646 \u0627\u0644\u0636\u064A\u0648\u0641. \u062A\u0648\u0627\u0635\u0644 \u0645\u0639 \u0645\u0627\u0644\u0643 \u0627\u0644\u062D\u0633\u0627\u0628 \u0644\u0644\u0627\u0646\u062A\u0642\u0627\u0644 \u0625\u0644\u0649 \u0628\u0627\u0642\u0629 \u0623\u0639\u0644\u0649."
      }
    },
    partners: {
      heading: "\u0627\u0644\u0645\u0624\u0633\u0633\u0627\u062A \u0627\u0644\u0634\u0631\u064A\u0643\u0629",
      description: "\u0627\u0644\u0645\u0624\u0633\u0633\u0627\u062A \u0627\u0644\u062A\u064A \u064A\u064F\u0634\u0627\u0631\u064E\u0643 \u0645\u0639\u0647\u0627 \u0647\u0630\u0627 \u0627\u0644\u0641\u0636\u0627\u0621\u060C \u0648\u0645\u0627 \u064A\u0645\u0643\u0646\u0647\u0627 \u0627\u0644\u0648\u0635\u0648\u0644 \u0625\u0644\u064A\u0647 \u0648\u0639\u062F\u062F \u0627\u0644\u0623\u0634\u062E\u0627\u0635 \u0627\u0644\u0630\u064A\u0646 \u0623\u0636\u0627\u0641\u062A\u0647\u0645.",
      share: "\u0627\u0644\u0645\u0634\u0627\u0631\u0643\u0629 \u0645\u0639 \u0645\u0624\u0633\u0633\u0629",
      loadFailedTitle: "\u062A\u0639\u0630\u0651\u0631 \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0634\u0631\u0643\u0627\u0621",
      emptyTitle: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0645\u0624\u0633\u0633\u0629 \u0634\u0631\u064A\u0643\u0629",
      emptyBody: "\u0634\u0627\u0631\u0643 \u0647\u0630\u0627 \u0627\u0644\u0641\u0636\u0627\u0621 \u0645\u0639 \u0645\u0624\u0633\u0633\u0629 \u0623\u062E\u0631\u0649: \u0647\u064A \u0645\u0646 \u064A\u062E\u062A\u0627\u0631 \u0627\u0644\u0623\u0634\u062E\u0627\u0635 \u0627\u0644\u0630\u064A\u0646 \u064A\u0635\u0644\u0648\u0646 \u0625\u0644\u064A\u0647.",
      members: "\u0627\u0644\u0623\u0634\u062E\u0627\u0635: {active}/{cap}",
      removeLabel: "\u0633\u062D\u0628 \u0627\u0644\u0645\u0624\u0633\u0633\u0629 {name} \u0645\u0646 \u0627\u0644\u0641\u0636\u0627\u0621",
      removeTitle: "\u0633\u062D\u0628 {name} \u0645\u0646 \u0627\u0644\u0641\u0636\u0627\u0621\u061F",
      removeBody: "\u064A\u062A\u0648\u0642\u0641 \u0648\u0635\u0648\u0644 \u062C\u0645\u064A\u0639 \u0623\u0634\u062E\u0627\u0635 \u0647\u0630\u0647 \u0627\u0644\u0645\u0624\u0633\u0633\u0629 \u0641\u0648\u0631\u0627\u064B. \u0648\u064A\u0645\u0643\u0646\u0643 \u062F\u0639\u0648\u062A\u0647\u0627 \u0645\u062C\u062F\u062F\u0627\u064B \u0644\u0627\u062D\u0642\u0627\u064B.",
      removed: "\u0644\u0645 \u064A\u0639\u062F \u0644\u062F\u0649 {name} \u0648\u0635\u0648\u0644 \u0625\u0644\u0649 \u0627\u0644\u0641\u0636\u0627\u0621."
    },
    invitations: {
      heading: "\u0627\u0644\u062F\u0639\u0648\u0627\u062A \u0627\u0644\u0645\u0639\u0644\u0651\u0642\u0629",
      description: "\u0627\u0644\u0623\u0634\u062E\u0627\u0635 \u0627\u0644\u0645\u062F\u0639\u0648\u0648\u0646 \u0639\u0628\u0631 \u0627\u0644\u0628\u0631\u064A\u062F \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A \u0627\u0644\u0630\u064A\u0646 \u0644\u0645 \u064A\u0631\u062F\u0651\u0648\u0627 \u0628\u0639\u062F.",
      invite: "\u062F\u0639\u0648\u0629 \u0634\u062E\u0635",
      loadFailedTitle: "\u062A\u0639\u0630\u0651\u0631 \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u062F\u0639\u0648\u0627\u062A",
      emptyTitle: "\u0644\u0627 \u062A\u0648\u062C\u062F \u062F\u0639\u0648\u0627\u062A \u0645\u0639\u0644\u0651\u0642\u0629",
      emptyBody: "\u062A\u0638\u0647\u0631 \u0647\u0646\u0627 \u0627\u0644\u062F\u0639\u0648\u0627\u062A \u0627\u0644\u0645\u0631\u0633\u0644\u0629 \u0625\u0644\u0649 \u0627\u0644\u0623\u0634\u062E\u0627\u0635 \u0625\u0644\u0649 \u0623\u0646 \u064A\u0631\u062F\u0651\u0648\u0627 \u0639\u0644\u064A\u0647\u0627.",
      kind: {
        nominative: "\u0634\u062E\u0635 \u0645\u0633\u0645\u0651\u0649",
        guest: "\u0636\u064A\u0641",
        organization: "\u0645\u0624\u0633\u0633\u0629"
      },
      expires: "\u0644\u0644\u0631\u062F \u0642\u0628\u0644 {date}",
      cancel: "\u0625\u0644\u063A\u0627\u0621",
      cancelLabel: "\u0625\u0644\u063A\u0627\u0621 \u062F\u0639\u0648\u0629 {who}",
      cancelTitle: "\u0625\u0644\u063A\u0627\u0621 \u062F\u0639\u0648\u0629 {who}\u061F",
      cancelBody: "\u0644\u0646 \u064A\u062A\u0645\u0643\u0646 \u0627\u0644\u0634\u062E\u0635 \u0645\u0646 \u0627\u0633\u062A\u0639\u0645\u0627\u0644 \u0627\u0644\u0631\u0627\u0628\u0637 \u0627\u0644\u0630\u064A \u062A\u0644\u0642\u0627\u0647. \u0648\u064A\u0645\u0643\u0646\u0643 \u062F\u0639\u0648\u062A\u0647 \u0645\u0646 \u062C\u062F\u064A\u062F.",
      cancelled: "\u062A\u0645 \u0625\u0644\u063A\u0627\u0621 \u0627\u0644\u062F\u0639\u0648\u0629.",
      cancelConfirm: "\u0625\u0644\u063A\u0627\u0621 \u0627\u0644\u062F\u0639\u0648\u0629"
    },
    people: {
      heading: "\u0627\u0644\u0623\u0634\u062E\u0627\u0635 \u0627\u0644\u0630\u064A\u0646 \u0644\u062F\u064A\u0647\u0645 \u0648\u0635\u0648\u0644",
      description: "\u0643\u0644 \u0645\u0646 \u064A\u0635\u0644 \u0625\u0644\u0649 \u0647\u0630\u0627 \u0627\u0644\u0641\u0636\u0627\u0621\u060C \u0645\u0639 \u0627\u0644\u0645\u0624\u0633\u0633\u0629 \u0627\u0644\u062A\u064A \u064A\u0645\u062B\u0644\u0647\u0627.",
      listLabel: "\u0627\u0644\u0623\u0634\u062E\u0627\u0635 \u0627\u0644\u0630\u064A\u0646 \u0644\u062F\u064A\u0647\u0645 \u0648\u0635\u0648\u0644 \u0625\u0644\u0649 \u0627\u0644\u0641\u0636\u0627\u0621",
      emptyTitle: "\u0644\u0627 \u0623\u062D\u062F \u0622\u062E\u0631 \u0644\u062F\u064A\u0647 \u0648\u0635\u0648\u0644 \u0625\u0644\u0649 \u0647\u0630\u0627 \u0627\u0644\u0641\u0636\u0627\u0621",
      emptyBody: "\u0633\u064A\u0638\u0647\u0631 \u0647\u0646\u0627 \u0623\u0639\u0636\u0627\u0621 \u0627\u0644\u0645\u0624\u0633\u0633\u0629 \u0627\u0644\u0645\u0633\u062A\u0636\u064A\u0641\u0629 \u0648\u0645\u0641\u0648\u064E\u0651\u0636\u0648 \u0627\u0644\u0634\u0631\u0643\u0627\u0621 \u0648\u0627\u0644\u0636\u064A\u0648\u0641.",
      loadFailedTitle: "\u062A\u0639\u0630\u0651\u0631 \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0623\u0634\u062E\u0627\u0635",
      organisation: "\u0627\u0644\u0645\u0624\u0633\u0633\u0629: {name}",
      extend: "\u062A\u0645\u062F\u064A\u062F 90 \u064A\u0648\u0645\u0627\u064B",
      extendLabel: "\u062A\u0645\u062F\u064A\u062F \u0648\u0635\u0648\u0644 {name} 90 \u064A\u0648\u0645\u0627\u064B",
      extended: "\u062A\u0645 \u062A\u0645\u062F\u064A\u062F \u0648\u0635\u0648\u0644 {name} \u062D\u062A\u0649 {date}.",
      removeLabel: "\u0633\u062D\u0628 {name} \u0645\u0646 \u0627\u0644\u0641\u0636\u0627\u0621",
      removeTitle: "\u0633\u062D\u0628 {name} \u0645\u0646 \u0627\u0644\u0641\u0636\u0627\u0621\u061F",
      removeBody: "\u064A\u062A\u0648\u0642\u0641 \u0648\u0635\u0648\u0644 \u0647\u0630\u0627 \u0627\u0644\u0634\u062E\u0635 \u0641\u0648\u0631\u0627\u064B.",
      removed: "\u0644\u0645 \u064A\u0639\u062F \u0644\u062F\u0649 {name} \u0648\u0635\u0648\u0644 \u0625\u0644\u0649 \u0627\u0644\u0641\u0636\u0627\u0621."
    },
    delegates: {
      heading: "\u0625\u062F\u0627\u0631\u0629 \u0645\u0646\u062F\u0648\u0628\u064A \u0645\u0624\u0633\u0633\u062A\u064A",
      description: "\u0623\u0634\u062E\u0627\u0635 \u0645\u0624\u0633\u0633\u062A\u0643 \u0627\u0644\u0630\u064A\u0646 \u064A\u0635\u0644\u0648\u0646 \u0625\u0644\u0649 \u0647\u0630\u0627 \u0627\u0644\u0641\u0636\u0627\u0621. \u0623\u0646\u062A \u062A\u062E\u062A\u0627\u0631 \u0645\u0646 \u064A\u0635\u0644\u060C \u0636\u0645\u0646 \u0645\u0627 \u062A\u0633\u0645\u062D \u0628\u0647 \u0634\u0631\u0627\u0643\u062A\u0643\u0645.",
      usage: "\u0627\u0644\u0623\u0634\u062E\u0627\u0635 \u0627\u0644\u0645\u0636\u0627\u0641\u0648\u0646: {active}/{cap}",
      capReached: "\u0628\u0644\u063A\u062A\u064E \u0627\u0644\u062D\u062F \u0627\u0644\u0623\u0642\u0635\u0649 \u0644\u0639\u062F\u062F \u0627\u0644\u0623\u0634\u062E\u0627\u0635 \u0641\u064A \u0634\u0631\u0627\u0643\u062A\u0643\u0645. \u0627\u0633\u062D\u0628 \u0623\u062D\u062F \u0627\u0644\u0645\u0646\u062F\u0648\u0628\u064A\u0646 \u0623\u0648 \u0627\u0637\u0644\u0628 \u0645\u0646 \u0627\u0644\u0645\u0624\u0633\u0633\u0629 \u0627\u0644\u0645\u0633\u062A\u0636\u064A\u0641\u0629 \u0631\u0641\u0639 \u0627\u0644\u062D\u062F.",
      emptyTitle: "\u0644\u0627 \u064A\u0648\u062C\u062F \u0645\u0646\u062F\u0648\u0628\u0648\u0646 \u0628\u0639\u062F",
      emptyBody: "\u0623\u0636\u0641 \u0623\u0639\u0636\u0627\u0621 \u0645\u0646 \u0645\u0624\u0633\u0633\u062A\u0643 \u0644\u064A\u0635\u0644\u0648\u0627 \u0625\u0644\u0649 \u0627\u0644\u0641\u0636\u0627\u0621.",
      add: {
        open: "\u0625\u0636\u0627\u0641\u0629 \u0639\u0636\u0648",
        title: "\u0625\u0636\u0627\u0641\u0629 \u0639\u0636\u0648",
        intro: "\u0627\u0644\u0623\u0634\u062E\u0627\u0635 \u0627\u0644\u0645\u0636\u0627\u0641\u0648\u0646: {active}/{cap}. \u0644\u0646 \u064A\u062D\u0635\u0644\u0648\u0627 \u0623\u0628\u062F\u0627\u064B \u0639\u0644\u0649 \u0623\u0643\u062B\u0631 \u0645\u0645\u0627 \u062A\u0633\u0645\u062D \u0628\u0647 \u0634\u0631\u0627\u0643\u062A\u0643\u0645.",
        people: "\u0623\u0639\u0636\u0627\u0621 \u0645\u0624\u0633\u0633\u062A\u0643",
        peopleHint: "\u064A\u0635\u0644 \u0627\u0644\u0623\u0634\u062E\u0627\u0635 \u0627\u0644\u0630\u064A\u0646 \u062A\u062E\u062A\u0627\u0631\u0647\u0645 \u0625\u0644\u0649 \u0641\u0636\u0627\u0621 {name} \u062F\u0648\u0646 \u0623\u0646 \u064A\u0631\u0648\u0627 \u0628\u0642\u064A\u0629 \u0634\u0624\u0648\u0646 \u062A\u0644\u0643 \u0627\u0644\u0645\u0624\u0633\u0633\u0629.",
        submit: "\u0645\u0646\u062D \u0627\u0644\u0648\u0635\u0648\u0644",
        submitting: "\u062C\u0627\u0631\u064D \u0627\u0644\u0625\u0636\u0627\u0641\u0629\u2026",
        done: "\u0623\u0635\u0628\u062D \u0644\u0644\u0623\u0634\u062E\u0627\u0635 \u0627\u0644\u0630\u064A\u0646 \u0627\u062E\u062A\u0631\u062A\u0647\u0645 \u0648\u0635\u0648\u0644 \u0625\u0644\u0649 \u0627\u0644\u0641\u0636\u0627\u0621.",
        errors: {
          peopleRequired: "\u0627\u062E\u062A\u0631 \u0634\u062E\u0635\u0627\u064B \u0648\u0627\u062D\u062F\u0627\u064B \u0639\u0644\u0649 \u0627\u0644\u0623\u0642\u0644.",
          overCap: "\u0644\u0627 \u064A\u0645\u0643\u0646\u0643 \u0625\u0636\u0627\u0641\u0629 \u0623\u0643\u062B\u0631 \u0645\u0646 {remaining} \u0634\u062E\u0635(\u0623\u0634\u062E\u0627\u0635) \u0622\u062E\u0631\u064A\u0646: \u0647\u0630\u0627 \u062D\u062F \u0634\u0631\u0627\u0643\u062A\u0643\u0645.",
          forbidden: "\u0644\u064A\u0633 \u0644\u062F\u064A\u0643 \u0635\u0644\u0627\u062D\u064A\u0629 \u0625\u0636\u0627\u0641\u0629 \u0623\u0634\u062E\u0627\u0635 \u0625\u0644\u0649 \u0647\u0630\u0627 \u0627\u0644\u0641\u0636\u0627\u0621."
        }
      },
      leave: {
        heading: "\u0645\u063A\u0627\u062F\u0631\u0629 \u0627\u0644\u0641\u0636\u0627\u0621",
        description: "\u0623\u0646\u0647\u0650 \u0627\u0644\u0634\u0631\u0627\u0643\u0629 \u0645\u0646 \u062C\u0627\u0646\u0628\u0643: \u064A\u0641\u0642\u062F \u0643\u0644 \u0623\u0634\u062E\u0627\u0635 \u0645\u0624\u0633\u0633\u062A\u0643 \u0648\u0635\u0648\u0644\u0647\u0645.",
        button: "\u0645\u063A\u0627\u062F\u0631\u0629 \u0627\u0644\u0641\u0636\u0627\u0621",
        title: "\u0645\u063A\u0627\u062F\u0631\u0629 \u0627\u0644\u0641\u0636\u0627\u0621 {name}\u061F",
        body: "\u0633\u064A\u0641\u0642\u062F \u0643\u0644 \u0623\u0634\u062E\u0627\u0635 \u0645\u0624\u0633\u0633\u062A\u0643 \u0627\u0644\u0648\u0635\u0648\u0644 \u0625\u0644\u0649 \u0647\u0630\u0627 \u0627\u0644\u0641\u0636\u0627\u0621 \u0641\u0648\u0631\u0627\u064B. \u0648\u0644\u0644\u0639\u0648\u062F\u0629\u060C \u0633\u062A\u062D\u062A\u0627\u062C {host} \u0625\u0644\u0649 \u062F\u0639\u0648\u062A\u0643\u0645 \u0645\u0646 \u062C\u062F\u064A\u062F.",
        done: "\u063A\u0627\u062F\u0631\u062A\u064E \u0627\u0644\u0641\u0636\u0627\u0621."
      }
    },
    audit: {
      heading: "\u0633\u062C\u0644 \u0627\u0644\u062A\u062F\u0642\u064A\u0642",
      description: "\u0645\u0646 \u0641\u0639\u0644 \u0645\u0627\u0630\u0627 \u0641\u064A \u0647\u0630\u0627 \u0627\u0644\u0641\u0636\u0627\u0621 \u0648\u0645\u062A\u0649. \u062A\u0631\u0649 \u0627\u0644\u0645\u0624\u0633\u0633\u0629 \u0627\u0644\u0645\u0633\u062A\u0636\u064A\u0641\u0629 \u0643\u0644 \u0634\u064A\u0621\u060C \u0623\u0645\u0627 \u0627\u0644\u0634\u0631\u064A\u0643 \u0641\u064A\u0631\u0649 \u0645\u0627 \u064A\u062E\u0635 \u0645\u0624\u0633\u0633\u062A\u0647 \u0641\u0642\u0637.",
      emptyTitle: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0623\u062D\u062F\u0627\u062B \u0628\u0639\u062F",
      emptyBody: "\u0633\u062A\u0638\u0647\u0631 \u0647\u0646\u0627 \u0627\u0644\u062F\u0639\u0648\u0627\u062A \u0648\u0639\u0645\u0644\u064A\u0627\u062A \u0645\u0646\u062D \u0627\u0644\u0648\u0635\u0648\u0644 \u0648\u0633\u062D\u0628\u0647.",
      loadFailedTitle: "\u062A\u0639\u0630\u0651\u0631 \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0633\u062C\u0644",
      columns: {
        date: "\u0627\u0644\u062A\u0627\u0631\u064A\u062E",
        actor: "\u0627\u0644\u0634\u062E\u0635",
        action: "\u0627\u0644\u0625\u062C\u0631\u0627\u0621",
        organisation: "\u0627\u0644\u0645\u0624\u0633\u0633\u0629 \u0627\u0644\u0645\u0639\u0646\u064A\u0629"
      },
      otherOrganisation: "\u0645\u0624\u0633\u0633\u0629 \u0623\u062E\u0631\u0649",
      system: "\u0627\u0644\u0646\u0638\u0627\u0645",
      none: "\u2014",
      actions: {
        created: "\u062A\u0645 \u0625\u0646\u0634\u0627\u0621 \u0627\u0644\u0641\u0636\u0627\u0621",
        updated: "\u062A\u0645 \u062A\u0639\u062F\u064A\u0644 \u0625\u0639\u062F\u0627\u062F\u0627\u062A \u0627\u0644\u0641\u0636\u0627\u0621",
        closed: "\u062A\u0645 \u0625\u063A\u0644\u0627\u0642 \u0627\u0644\u0641\u0636\u0627\u0621",
        partner_invited: "\u062A\u0645\u062A \u062F\u0639\u0648\u0629 \u0645\u0624\u0633\u0633\u0629 \u0634\u0631\u064A\u0643\u0629",
        partner_accepted: "\u062A\u0645 \u0642\u0628\u0648\u0644 \u062F\u0639\u0648\u0629 \u0627\u0644\u0634\u0631\u0627\u0643\u0629",
        partner_declined: "\u062A\u0645 \u0631\u0641\u0636 \u062F\u0639\u0648\u0629 \u0627\u0644\u0634\u0631\u0627\u0643\u0629",
        partner_revoked: "\u062A\u0645 \u0633\u062D\u0628 \u0645\u0624\u0633\u0633\u0629 \u0634\u0631\u064A\u0643\u0629",
        partner_expired: "\u0627\u0646\u062A\u0647\u062A \u0627\u0644\u0634\u0631\u0627\u0643\u0629",
        member_delegated: "\u062A\u0645\u062A \u0625\u0636\u0627\u0641\u0629 \u0634\u062E\u0635 \u0645\u0646 \u0642\u0628\u0644 \u0634\u0631\u064A\u0643",
        member_joined: "\u0627\u0646\u0636\u0645 \u0634\u062E\u0635 \u0625\u0644\u0649 \u0627\u0644\u0641\u0636\u0627\u0621",
        member_revoked: "\u062A\u0645 \u0633\u062D\u0628 \u0648\u0635\u0648\u0644 \u0634\u062E\u0635",
        member_expired: "\u0627\u0646\u062A\u0647\u0649 \u0648\u0635\u0648\u0644 \u0634\u062E\u0635",
        member_extended: "\u062A\u0645 \u062A\u0645\u062F\u064A\u062F \u0648\u0635\u0648\u0644 \u0636\u064A\u0641",
        invitation_created: "\u062A\u0645 \u0625\u0631\u0633\u0627\u0644 \u062F\u0639\u0648\u0629 \u0625\u0644\u0649 \u0634\u062E\u0635",
        invitation_declined: "\u062A\u0645 \u0631\u0641\u0636 \u062F\u0639\u0648\u0629",
        invitation_revoked: "\u062A\u0645 \u0625\u0644\u063A\u0627\u0621 \u062F\u0639\u0648\u0629",
        approval_decided: "\u0642\u0631\u0627\u0631 \u0628\u0634\u0623\u0646 \u0637\u0644\u0628 \u0645\u0648\u0627\u0641\u0642\u0629",
        other: "\u0625\u062C\u0631\u0627\u0621 \u0622\u062E\u0631 ({action})",
        directory_updated: "\u062A\u063A\u064A\u064A\u0631 \u0627\u0644\u0638\u0647\u0648\u0631 \u0641\u064A \u0627\u0644\u062F\u0644\u064A\u0644",
        contact_received: "\u0631\u0633\u0627\u0644\u0629 \u0648\u0627\u0631\u062F\u0629 \u0645\u0646 \u0627\u0644\u062F\u0644\u064A\u0644"
      },
      more: "\u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0645\u0632\u064A\u062F",
      loading: "\u062C\u0627\u0631\u064D \u0627\u0644\u062A\u062D\u0645\u064A\u0644\u2026"
    },
    close: {
      title: "\u0625\u063A\u0644\u0627\u0642 \u0627\u0644\u0641\u0636\u0627\u0621",
      description: "\u0623\u0646\u0647\u0650 \u0643\u0644 \u0639\u0645\u0644\u064A\u0627\u062A \u0627\u0644\u0648\u0635\u0648\u0644 \u0645\u0646 \u0627\u0644\u062E\u0627\u0631\u062C. \u062A\u0628\u0642\u0649 \u0645\u0624\u0633\u0633\u062A\u0643 \u0642\u0627\u062F\u0631\u0629 \u0639\u0644\u0649 \u0642\u0631\u0627\u0621\u0629 \u0627\u0644\u0641\u0636\u0627\u0621.",
      button: "\u0625\u063A\u0644\u0627\u0642 \u0627\u0644\u0641\u0636\u0627\u0621",
      confirmTitle: "\u0625\u063A\u0644\u0627\u0642 \u0627\u0644\u0641\u0636\u0627\u0621 {name}\u061F",
      confirmIntro: "\u0647\u0630\u0627 \u0627\u0644\u0625\u062C\u0631\u0627\u0621 \u0646\u0647\u0627\u0626\u064A:",
      effects: {
        access: "\u062A\u0641\u0642\u062F \u0643\u0644 \u0627\u0644\u0645\u0624\u0633\u0633\u0627\u062A \u0627\u0644\u0634\u0631\u064A\u0643\u0629 \u0648\u0645\u0646\u062F\u0648\u0628\u0648\u0647\u0627 \u0648\u0627\u0644\u0623\u0634\u062E\u0627\u0635 \u0627\u0644\u0645\u0633\u0645\u0651\u0648\u0646 \u0648\u0627\u0644\u0636\u064A\u0648\u0641 \u0648\u0635\u0648\u0644\u0647\u0645 \u0641\u0648\u0631\u0627\u064B.",
        readOnly: "\u064A\u0635\u0628\u062D \u0627\u0644\u0641\u0636\u0627\u0621 \u0623\u0631\u0634\u064A\u0641\u0627\u064B \u0644\u0644\u0642\u0631\u0627\u0621\u0629 \u0641\u0642\u0637 \u0644\u0645\u0624\u0633\u0633\u062A\u0643: \u0644\u0627 \u0625\u0636\u0627\u0641\u0629 \u0648\u0644\u0627 \u062A\u0639\u062F\u064A\u0644 \u0628\u0639\u062F \u0630\u0644\u0643.",
        export: "\u0644\u0627 \u064A\u0633\u062A\u0637\u064A\u0639 \u0627\u0644\u0634\u0631\u0643\u0627\u0621 \u0628\u0639\u062F\u064F \u0627\u0633\u062A\u0631\u062C\u0627\u0639 \u0645\u0644\u0641\u0627\u062A\u0647\u0645 \u0627\u0644\u062E\u0627\u0635\u0629: \u0647\u0630\u0647 \u0627\u0644\u0645\u064A\u0632\u0629 \u0633\u062A\u062A\u0648\u0641\u0631 \u0641\u064A \u0625\u0635\u062F\u0627\u0631 \u0644\u0627\u062D\u0642."
      },
      confirm: "\u0625\u063A\u0644\u0627\u0642 \u0627\u0644\u0641\u0636\u0627\u0621",
      done: "\u062A\u0645 \u0625\u063A\u0644\u0627\u0642 \u0627\u0644\u0641\u0636\u0627\u0621. \u0627\u0646\u062A\u0647\u062A \u0643\u0644 \u0639\u0645\u0644\u064A\u0627\u062A \u0627\u0644\u0648\u0635\u0648\u0644 \u0645\u0646 \u0627\u0644\u062E\u0627\u0631\u062C.",
      errors: {
        forbidden: "\u0627\u0644\u0645\u0627\u0644\u0643 \u0648\u0627\u0644\u0645\u0633\u0624\u0648\u0644\u0648\u0646 \u0648\u062D\u062F\u0647\u0645 \u064A\u0633\u062A\u0637\u064A\u0639\u0648\u0646 \u0625\u063A\u0644\u0627\u0642 \u0641\u0636\u0627\u0621."
      },
      stepUpNote: "\u064A\u062A\u0637\u0644\u0651\u0628 \u0625\u063A\u0644\u0627\u0642 \u0627\u0644\u0641\u0636\u0627\u0621 \u062A\u0623\u0643\u064A\u062F \u0647\u0648\u064A\u062A\u0643."
    },
    answers: {
      accept: "\u0642\u0628\u0648\u0644",
      decline: "\u0631\u0641\u0636",
      acceptLabel: "\u0642\u0628\u0648\u0644 \u0627\u0644\u062F\u0639\u0648\u0629 \u0625\u0644\u0649 \u0627\u0644\u0641\u0636\u0627\u0621 {space}",
      declineLabel: "\u0631\u0641\u0636 \u0627\u0644\u062F\u0639\u0648\u0629 \u0625\u0644\u0649 \u0627\u0644\u0641\u0636\u0627\u0621 {space}",
      declineTitle: "\u0631\u0641\u0636 \u0627\u0644\u062F\u0639\u0648\u0629 \u0625\u0644\u0649 \u0627\u0644\u0641\u0636\u0627\u0621 {space}\u061F",
      declineBody: "\u0644\u0646 \u064A\u0643\u0648\u0646 \u0644\u0643 \u0648\u0635\u0648\u0644 \u0625\u0644\u0649 \u0647\u0630\u0627 \u0627\u0644\u0641\u0636\u0627\u0621. \u0648\u064A\u0645\u0643\u0646 \u0644\u0644\u0645\u0624\u0633\u0633\u0629 \u0627\u0644\u0645\u0633\u062A\u0636\u064A\u0641\u0629 \u062F\u0639\u0648\u062A\u0643 \u0645\u0646 \u062C\u062F\u064A\u062F.",
      declinePartnershipBody: "\u0644\u0646 \u062A\u0646\u0636\u0645 \u0645\u0624\u0633\u0633\u062A\u0643 \u0625\u0644\u0649 \u0647\u0630\u0627 \u0627\u0644\u0641\u0636\u0627\u0621. \u0648\u064A\u0645\u0643\u0646 \u0644\u0644\u0645\u0624\u0633\u0633\u0629 \u0627\u0644\u0645\u0633\u062A\u0636\u064A\u0641\u0629 \u062F\u0639\u0648\u062A\u0647\u0627 \u0645\u0646 \u062C\u062F\u064A\u062F.",
      accepted: "\u0627\u0646\u0636\u0645\u0645\u062A \u0625\u0644\u0649 \u0627\u0644\u0641\u0636\u0627\u0621 {space}.",
      partnershipAccepted: "\u0623\u0635\u0628\u062D\u062A \u0645\u0624\u0633\u0633\u062A\u0643 \u0634\u0631\u064A\u0643\u0629 \u0641\u064A \u0627\u0644\u0641\u0636\u0627\u0621 {space}. \u0627\u062E\u062A\u0631 \u0627\u0644\u0622\u0646 \u0627\u0644\u0623\u0634\u062E\u0627\u0635 \u0627\u0644\u0630\u064A\u0646 \u064A\u0635\u0644\u0648\u0646 \u0625\u0644\u064A\u0647.",
      declined: "\u062A\u0645 \u0631\u0641\u0636 \u0627\u0644\u062F\u0639\u0648\u0629 \u0625\u0644\u0649 \u0627\u0644\u0641\u0636\u0627\u0621 {space}."
    },
    incoming: {
      title: "\u0627\u0644\u062F\u0639\u0648\u0627\u062A \u0625\u0644\u0649 \u0627\u0644\u0641\u0636\u0627\u0621\u0627\u062A",
      intro: "\u0627\u0644\u062F\u0639\u0648\u0627\u062A \u0627\u0644\u062A\u064A \u062A\u0646\u062A\u0638\u0631 \u0631\u062F\u0651\u0643: \u0627\u0644\u0645\u0648\u062C\u0651\u0647\u0629 \u0625\u0644\u064A\u0643 \u0623\u0648 \u0625\u0644\u0649 \u0645\u0624\u0633\u0633\u0629 \u062A\u062F\u064A\u0631\u0647\u0627.",
      loadFailedTitle: "\u062A\u0639\u0630\u0651\u0631 \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u062F\u0639\u0648\u0627\u062A",
      emptyTitle: "\u0644\u0627 \u062A\u0648\u062C\u062F \u062F\u0639\u0648\u0627\u062A \u0645\u0639\u0644\u0651\u0642\u0629",
      emptyBody: "\u0639\u0646\u062F\u0645\u0627 \u062A\u064F\u062F\u0639\u0649 \u0625\u0644\u0649 \u0641\u0636\u0627\u0621 \u0645\u0634\u062A\u0631\u0643\u060C \u062A\u0638\u0647\u0631 \u0627\u0644\u062F\u0639\u0648\u0629 \u0647\u0646\u0627.",
      seeSpaces: "\u0639\u0631\u0636 \u0641\u0636\u0627\u0621\u0627\u062A\u064A \u0627\u0644\u0645\u0634\u062A\u0631\u0643\u0629",
      sentence: {
        organization: "\u0627\u0644\u0645\u0624\u0633\u0633\u0629 {organisation} \u0645\u062F\u0639\u0648\u0629 \u0644\u062A\u0635\u0628\u062D \u0634\u0631\u064A\u0643\u0629 \u0641\u064A \u0627\u0644\u0641\u0636\u0627\u0621 {space} \u0627\u0644\u0630\u064A \u062A\u0633\u062A\u0636\u064A\u0641\u0647 {host}.",
        nominative: "\u064A\u062F\u0639\u0648\u0643 {who} \u0625\u0644\u0649 \u0627\u0644\u0627\u0646\u0636\u0645\u0627\u0645 \u0625\u0644\u0649 \u0627\u0644\u0641\u0636\u0627\u0621 {space} \u0627\u0644\u0630\u064A \u062A\u0633\u062A\u0636\u064A\u0641\u0647 {host}.",
        guest: "\u064A\u062F\u0639\u0648\u0643 {who} \u0643\u0636\u064A\u0641 \u0625\u0644\u0649 \u0627\u0644\u0641\u0636\u0627\u0621 {space} \u0627\u0644\u0630\u064A \u062A\u0633\u062A\u0636\u064A\u0641\u0647 {host}.",
        nominativeNoName: "\u0623\u0646\u062A \u0645\u062F\u0639\u0648 \u0625\u0644\u0649 \u0627\u0644\u0627\u0646\u0636\u0645\u0627\u0645 \u0625\u0644\u0649 \u0627\u0644\u0641\u0636\u0627\u0621 {space} \u0627\u0644\u0630\u064A \u062A\u0633\u062A\u0636\u064A\u0641\u0647 {host}.",
        guestNoName: "\u0623\u0646\u062A \u0645\u062F\u0639\u0648 \u0643\u0636\u064A\u0641 \u0625\u0644\u0649 \u0627\u0644\u0641\u0636\u0627\u0621 {space} \u0627\u0644\u0630\u064A \u062A\u0633\u062A\u0636\u064A\u0641\u0647 {host}."
      },
      kind: {
        organization: "\u0637\u0644\u0628 \u0634\u0631\u0627\u0643\u0629",
        nominative: "\u062F\u0639\u0648\u0629 \u0634\u062E\u0635\u064A\u0629",
        guest: "\u0636\u064A\u0641"
      },
      memberCap: "\u062D\u062A\u0649 {cap} \u0623\u0634\u062E\u0627\u0635",
      answerBefore: "\u0644\u0644\u0631\u062F \u0642\u0628\u0644 {date}",
      waiting: "{count, plural, zero {\u0644\u0627 \u062A\u0648\u062C\u062F \u062F\u0639\u0648\u0627\u062A \u062A\u0646\u062A\u0638\u0631 \u0631\u062F\u0651\u0643.} one {\u062F\u0639\u0648\u0629 \u0648\u0627\u062D\u062F\u0629 \u062A\u0646\u062A\u0638\u0631 \u0631\u062F\u0651\u0643.} two {\u062F\u0639\u0648\u062A\u0627\u0646 \u062A\u0646\u062A\u0638\u0631\u0627\u0646 \u0631\u062F\u0651\u0643.} few {# \u062F\u0639\u0648\u0627\u062A \u062A\u0646\u062A\u0638\u0631 \u0631\u062F\u0651\u0643.} many {# \u062F\u0639\u0648\u0629 \u062A\u0646\u062A\u0638\u0631 \u0631\u062F\u0651\u0643.} other {# \u062F\u0639\u0648\u0629 \u062A\u0646\u062A\u0638\u0631 \u0631\u062F\u0651\u0643.}}",
      seeInvitations: "\u0639\u0631\u0636 \u0627\u0644\u062F\u0639\u0648\u0627\u062A"
    },
    partnerships: {
      title: "\u0627\u0644\u0634\u0631\u0627\u0643\u0627\u062A",
      intro: "\u0641\u0636\u0627\u0621\u0627\u062A \u0627\u0644\u0645\u0624\u0633\u0633\u0627\u062A \u0627\u0644\u0623\u062E\u0631\u0649 \u0627\u0644\u062A\u064A \u062A\u064F\u062F\u0639\u0649 \u0625\u0644\u064A\u0647\u0627 \u0645\u0624\u0633\u0633\u062A\u0643 \u0623\u0648 \u062A\u0634\u0627\u0631\u0643 \u0641\u064A\u0647\u0627.",
      loadFailedTitle: "\u062A\u0639\u0630\u0651\u0631 \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0634\u0631\u0627\u0643\u0627\u062A",
      emptyTitle: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0634\u0631\u0627\u0643\u0627\u062A",
      emptyBody: "\u0639\u0646\u062F\u0645\u0627 \u062A\u062F\u0639\u0648\u0643 \u0645\u0624\u0633\u0633\u0629 \u0623\u062E\u0631\u0649 \u0625\u0644\u0649 \u0645\u0634\u0627\u0631\u0643\u0629 \u0641\u0636\u0627\u0621\u060C \u064A\u0638\u0647\u0631 \u0627\u0644\u0637\u0644\u0628 \u0647\u0646\u0627.",
      requestsHeading: "\u0637\u0644\u0628\u0627\u062A \u0627\u0644\u0634\u0631\u0627\u0643\u0629",
      requestsDescription: "\u0627\u0642\u0628\u0644 \u0644\u062A\u0646\u0636\u0645 \u0645\u0624\u0633\u0633\u062A\u0643 \u0625\u0644\u0649 \u0627\u0644\u0641\u0636\u0627\u0621\u061B \u062B\u0645 \u062A\u062E\u062A\u0627\u0631 \u0645\u0646 \u064A\u0635\u0644 \u0625\u0644\u064A\u0647.",
      noRequests: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0637\u0644\u0628\u0627\u062A \u0645\u0639\u0644\u0651\u0642\u0629.",
      activeHeading: "\u0627\u0644\u0634\u0631\u0627\u0643\u0627\u062A \u0627\u0644\u0646\u0634\u0637\u0629",
      activeDescription: "\u0627\u0644\u0641\u0636\u0627\u0621\u0627\u062A \u0627\u0644\u062A\u064A \u062A\u0634\u0627\u0631\u0643 \u0641\u064A\u0647\u0627 \u0645\u0624\u0633\u0633\u062A\u0643. \u0627\u0641\u062A\u062D \u0623\u062D\u062F\u0647\u0627 \u0644\u0625\u062F\u0627\u0631\u0629 \u0645\u0646\u062F\u0648\u0628\u064A \u0645\u0624\u0633\u0633\u062A\u0643.",
      noActive: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0634\u0631\u0627\u0643\u0627\u062A \u0646\u0634\u0637\u0629.",
      endedHeading: "\u0627\u0644\u0634\u0631\u0627\u0643\u0627\u062A \u0627\u0644\u0645\u0646\u062A\u0647\u064A\u0629",
      space: "\u0627\u0644\u0641\u0636\u0627\u0621: {space}",
      capUsage: "\u0627\u0644\u0623\u0634\u062E\u0627\u0635: {active}/{cap}",
      manage: "\u0625\u062F\u0627\u0631\u0629 \u0645\u0646\u062F\u0648\u0628\u064A \u0645\u0624\u0633\u0633\u062A\u064A",
      manageLabel: "\u0625\u062F\u0627\u0631\u0629 \u0645\u0646\u062F\u0648\u0628\u064A \u0645\u0624\u0633\u0633\u062A\u064A \u0641\u064A \u0627\u0644\u0641\u0636\u0627\u0621 {space}"
    },
    approvals: {
      title: "\u0627\u0644\u0645\u0648\u0627\u0641\u0642\u0629 \u0639\u0644\u0649 \u0627\u0644\u0648\u0635\u0648\u0644 \u0627\u0644\u062E\u0627\u0631\u062C\u064A",
      intro: "\u0639\u0636\u0648 \u0641\u064A \u0645\u0624\u0633\u0633\u062A\u0643 \u0645\u062F\u0639\u0648 \u0625\u0644\u0649 \u0641\u0636\u0627\u0621 \u0645\u0624\u0633\u0633\u0629 \u0623\u062E\u0631\u0649. \u062A\u0634\u062A\u0631\u0637 \u0633\u064A\u0627\u0633\u062A\u0643\u0645 \u0645\u0648\u0627\u0641\u0642\u0629 \u0645\u0633\u0624\u0648\u0644 \u0642\u0628\u0644 \u0623\u0646 \u064A\u0646\u0636\u0645.",
      deniedTitle: "\u0644\u0627 \u064A\u0645\u0643\u0646\u0643 \u0627\u062A\u062E\u0627\u0630 \u0627\u0644\u0642\u0631\u0627\u0631 \u0647\u0646\u0627",
      deniedBody: "\u064A\u0631\u0649 \u0647\u0630\u0647 \u0627\u0644\u0637\u0644\u0628\u0627\u062A \u0641\u0642\u0637 \u0627\u0644\u0645\u0633\u0624\u0648\u0644\u0648\u0646 \u0627\u0644\u0645\u062E\u0648\u064E\u0651\u0644\u0648\u0646 \u0628\u0627\u0644\u0645\u0648\u0627\u0641\u0642\u0629 \u0639\u0644\u0649 \u0627\u0644\u0648\u0635\u0648\u0644 \u0627\u0644\u062E\u0627\u0631\u062C\u064A.",
      loadFailedTitle: "\u062A\u0639\u0630\u0651\u0631 \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0637\u0644\u0628\u0627\u062A",
      emptyTitle: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0637\u0644\u0628\u0627\u062A \u0644\u0644\u0645\u0648\u0627\u0641\u0642\u0629",
      emptyBody: "\u0639\u0646\u062F\u0645\u0627 \u064A\u064F\u062F\u0639\u0649 \u0639\u0636\u0648 \u0641\u064A \u0645\u0624\u0633\u0633\u062A\u0643 \u0625\u0644\u0649 \u0641\u0636\u0627\u0621 \u0645\u0624\u0633\u0633\u0629 \u0623\u062E\u0631\u0649\u060C \u064A\u0638\u0647\u0631 \u0627\u0644\u0637\u0644\u0628 \u0647\u0646\u0627.",
      kind: {
        nominative: "\u062F\u0639\u0648\u0629 \u0634\u062E\u0635\u064A\u0629",
        guest: "\u0636\u064A\u0641",
        organization: "\u0645\u0624\u0633\u0633\u0629"
      },
      email: "\u0627\u0644\u0628\u0631\u064A\u062F \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A: {email}",
      space: "\u0627\u0644\u0641\u0636\u0627\u0621 {space} \u0627\u0644\u0630\u064A \u062A\u0633\u062A\u0636\u064A\u0641\u0647 {host}",
      invitedBy: "\u062F\u0639\u0627\u0647 {name}",
      requestedOn: "\u0637\u064F\u0644\u0628 \u0641\u064A {date}",
      answerBefore: "\u0644\u0644\u0645\u0639\u0627\u0644\u062C\u0629 \u0642\u0628\u0644 {date}",
      approve: "\u0645\u0648\u0627\u0641\u0642\u0629",
      approveLabel: "\u0627\u0644\u0645\u0648\u0627\u0641\u0642\u0629 \u0639\u0644\u0649 \u0648\u0635\u0648\u0644 {who}",
      refuse: "\u0631\u0641\u0636",
      refuseLabel: "\u0631\u0641\u0636 \u0648\u0635\u0648\u0644 {who}",
      refuseTitle: "\u0631\u0641\u0636 \u0648\u0635\u0648\u0644 {who}\u061F",
      refuseBody: "\u0644\u0646 \u064A\u0646\u0636\u0645 \u0627\u0644\u0634\u062E\u0635 \u0625\u0644\u0649 \u0641\u0636\u0627\u0621 {host}. \u0648\u064A\u0645\u0643\u0646 \u0644\u0644\u0645\u0624\u0633\u0633\u0629 \u0627\u0644\u0645\u0633\u062A\u0636\u064A\u0641\u0629 \u062F\u0639\u0648\u062A\u0647 \u0645\u0646 \u062C\u062F\u064A\u062F.",
      approved: "\u062A\u0645\u062A \u0627\u0644\u0645\u0648\u0627\u0641\u0642\u0629 \u0639\u0644\u0649 \u0648\u0635\u0648\u0644 {email}.",
      refused: "\u062A\u0645 \u0631\u0641\u0636 \u0627\u0644\u0648\u0635\u0648\u0644."
    }
  },
  meetings: {
    externalIntro: "\u0627\u062C\u062A\u0645\u0627\u0639\u0627\u062A \u064A\u0646\u0638\u0651\u0645\u0647\u0627 {host}. \u0627\u0646\u0636\u0645 \u0625\u0644\u064A\u0647\u0627 \u0628\u0646\u0642\u0631\u0629 \u0648\u0627\u062D\u062F\u0629 \u0623\u062B\u0646\u0627\u0621 \u0627\u0646\u0639\u0642\u0627\u062F\u0647\u0627."
  },
  synthesis: {
    ownNotice: "\u0644\u0627 \u062A\u0631\u0648\u0646 \u0647\u0646\u0627 \u0625\u0644\u0627 \u0645\u0627 \u064A\u0646\u062A\u062C\u0647 \u0645\u0643\u062A\u0628\u0643\u0645 \u0641\u064A \u0647\u0630\u0647 \u0627\u0644\u0645\u0633\u0627\u062D\u0629. \u0623\u0645\u0651\u0627 \u0627\u0644\u0645\u0643\u062A\u0628 \u0627\u0644\u0631\u0626\u064A\u0633\u064A \u0641\u064A\u0631\u0649 \u062C\u0645\u064A\u0639 \u0627\u0644\u0645\u0643\u0627\u062A\u0628.",
    loadFailedTitle: "\u062A\u0639\u0630\u0651\u0631 \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0645\u0644\u062E\u0651\u0635",
    loadFailedBody: "\u062A\u062D\u0642\u0651\u0642\u0648\u0627 \u0645\u0646 \u0627\u062A\u0635\u0627\u0644\u0643\u0645 \u062B\u0645 \u0623\u0639\u064A\u062F\u0648\u0627 \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629.",
    noProjectTitle: "\u0647\u0630\u0647 \u0627\u0644\u0645\u0633\u0627\u062D\u0629 \u063A\u064A\u0631 \u0645\u0631\u062A\u0628\u0637\u0629 \u0628\u0645\u0634\u0631\u0648\u0639",
    noProjectBody: "\u064A\u0639\u062A\u0645\u062F \u0627\u0644\u0645\u0644\u062E\u0651\u0635 \u0648\u0627\u0644\u0645\u0635\u0641\u0648\u0641\u0629 \u0639\u0644\u0649 \u0645\u062E\u0631\u062C\u0627\u062A \u0645\u0634\u0631\u0648\u0639 \u0645\u0627. \u0648\u0633\u064A\u0638\u0647\u0631\u0627\u0646 \u0628\u0645\u062C\u0631\u0651\u062F \u0631\u0628\u0637 \u0627\u0644\u0645\u0633\u0627\u062D\u0629 \u0628\u0645\u0634\u0631\u0648\u0639.",
    unknownOffice: "\u0645\u0643\u062A\u0628 \u063A\u064A\u0631 \u0645\u0639\u0631\u0648\u0641",
    roles: {
      host: "\u0627\u0644\u0645\u0643\u062A\u0628 \u0627\u0644\u0631\u0626\u064A\u0633\u064A",
      partner: "\u0645\u0643\u062A\u0628 \u0634\u0631\u064A\u0643"
    },
    kpis: {
      label: "\u0623\u0647\u0645\u0651 \u0627\u0644\u0623\u0631\u0642\u0627\u0645",
      deliverables: "\u0627\u0644\u0645\u062E\u0631\u062C\u0627\u062A",
      deliverablesAll: "\u062C\u0645\u064A\u0639 \u0627\u0644\u0645\u0643\u0627\u062A\u0628 \u0645\u0639\u064B\u0627",
      deliverablesOwn: "\u0627\u0644\u0645\u0633\u0646\u062F\u0629 \u0625\u0644\u0649 \u0645\u0643\u062A\u0628\u0643\u0645",
      done: "\u0627\u0644\u0645\u0646\u062C\u0632\u0629",
      doneCaption: "\u0645\u0639\u062A\u0645\u062F\u0629 \u0623\u0648 \u0645\u0631\u0633\u0644\u0629",
      overdue: "\u0627\u0644\u0645\u062A\u0623\u062E\u0631\u0629",
      overdueCaption: "\u062A\u062C\u0627\u0648\u0632\u062A \u0627\u0644\u0623\u062C\u0644 \u0648\u0644\u0645 \u062A\u064F\u0639\u062A\u0645\u062F \u0628\u0639\u062F",
      approvals: "\u0627\u0644\u062A\u0623\u0634\u064A\u0631\u0627\u062A \u0627\u0644\u062C\u0627\u0631\u064A\u0629",
      approvalsCaption: "\u062F\u0648\u0631\u0627\u062A \u062A\u0623\u0634\u064A\u0631 \u0645\u0641\u062A\u0648\u062D\u0629",
      lateApprovals: "\u0627\u0644\u062A\u0623\u0634\u064A\u0631\u0627\u062A \u0627\u0644\u0645\u062A\u0623\u062E\u0631\u0629",
      lateApprovalsCaption: "\u062A\u062C\u0627\u0648\u0632\u062A \u0623\u062C\u0644 \u0627\u0644\u062A\u0623\u0634\u064A\u0631"
    },
    offices: {
      title: "\u0627\u0644\u062A\u0642\u062F\u0651\u0645 \u062D\u0633\u0628 \u0627\u0644\u0645\u0643\u062A\u0628",
      progress: "\u0645\u062E\u0631\u062C\u0627\u062A {office} \u062D\u0633\u0628 \u0627\u0644\u062D\u0627\u0644\u0629",
      none: "\u0644\u0645 \u062A\u064F\u0633\u0646\u062F \u0623\u064A \u0645\u062E\u0631\u062C\u0627\u062A \u0625\u0644\u0649 \u0647\u0630\u0627 \u0627\u0644\u0645\u0643\u062A\u0628 \u0628\u0639\u062F.",
      onTime: "\u0644\u0627 \u0634\u064A\u0621 \u0645\u062A\u0623\u062E\u0651\u0631",
      overdue: "{count, plural, zero {\u0644\u0627 \u0645\u062E\u0631\u062C\u0627\u062A \u0645\u062A\u0623\u062E\u0631\u0629} one {\u0645\u062E\u0631\u062C \u0648\u0627\u062D\u062F \u0645\u062A\u0623\u062E\u0631} two {\u0645\u062E\u0631\u062C\u0627\u0646 \u0645\u062A\u0623\u062E\u0631\u0627\u0646} few {# \u0645\u062E\u0631\u062C\u0627\u062A \u0645\u062A\u0623\u062E\u0631\u0629} many {# \u0645\u062E\u0631\u062C\u064B\u0627 \u0645\u062A\u0623\u062E\u0631\u064B\u0627} other {# \u0645\u062E\u0631\u062C \u0645\u062A\u0623\u062E\u0631}}",
      lateApprovals: "{count, plural, zero {\u0644\u0627 \u062A\u0623\u0634\u064A\u0631\u0627\u062A \u0645\u062A\u0623\u062E\u0631\u0629} one {\u062A\u0623\u0634\u064A\u0631\u0629 \u0648\u0627\u062D\u062F\u0629 \u0645\u062A\u0623\u062E\u0631\u0629} two {\u062A\u0623\u0634\u064A\u0631\u062A\u0627\u0646 \u0645\u062A\u0623\u062E\u0631\u062A\u0627\u0646} few {# \u062A\u0623\u0634\u064A\u0631\u0627\u062A \u0645\u062A\u0623\u062E\u0631\u0629} many {# \u062A\u0623\u0634\u064A\u0631\u0629 \u0645\u062A\u0623\u062E\u0631\u0629} other {# \u062A\u0623\u0634\u064A\u0631\u0629 \u0645\u062A\u0623\u062E\u0631\u0629}}",
      approvalsInProgress: "{count, plural, zero {\u0644\u0627 \u062A\u0623\u0634\u064A\u0631\u0627\u062A \u062C\u0627\u0631\u064A\u0629} one {\u062A\u0623\u0634\u064A\u0631\u0629 \u0648\u0627\u062D\u062F\u0629 \u062C\u0627\u0631\u064A\u0629} two {\u062A\u0623\u0634\u064A\u0631\u062A\u0627\u0646 \u062C\u0627\u0631\u064A\u062A\u0627\u0646} few {# \u062A\u0623\u0634\u064A\u0631\u0627\u062A \u062C\u0627\u0631\u064A\u0629} many {# \u062A\u0623\u0634\u064A\u0631\u0629 \u062C\u0627\u0631\u064A\u0629} other {# \u062A\u0623\u0634\u064A\u0631\u0629 \u062C\u0627\u0631\u064A\u0629}}",
      rejected: "{count, plural, zero {\u0644\u0627 \u062A\u0623\u0634\u064A\u0631\u0627\u062A \u0645\u0631\u0641\u0648\u0636\u0629} one {\u062A\u0623\u0634\u064A\u0631\u0629 \u0648\u0627\u062D\u062F\u0629 \u0645\u0631\u0641\u0648\u0636\u0629} two {\u062A\u0623\u0634\u064A\u0631\u062A\u0627\u0646 \u0645\u0631\u0641\u0648\u0636\u062A\u0627\u0646} few {# \u062A\u0623\u0634\u064A\u0631\u0627\u062A \u0645\u0631\u0641\u0648\u0636\u0629} many {# \u062A\u0623\u0634\u064A\u0631\u0629 \u0645\u0631\u0641\u0648\u0636\u0629} other {# \u062A\u0623\u0634\u064A\u0631\u0629 \u0645\u0631\u0641\u0648\u0636\u0629}}",
      total: "{count, plural, zero {\u0644\u0627 \u0645\u062E\u0631\u062C\u0627\u062A} one {\u0645\u062E\u0631\u062C \u0648\u0627\u062D\u062F} two {\u0645\u062E\u0631\u062C\u0627\u0646} few {# \u0645\u062E\u0631\u062C\u0627\u062A} many {# \u0645\u062E\u0631\u062C\u064B\u0627} other {# \u0645\u062E\u0631\u062C}}"
    },
    legend: {
      toProduce: "\u0642\u064A\u062F \u0627\u0644\u0625\u0639\u062F\u0627\u062F",
      inProgress: "\u062C\u0627\u0631\u064A\u0629",
      inReview: "\u0642\u064A\u062F \u0627\u0644\u0645\u0631\u0627\u062C\u0639\u0629",
      done: "\u0645\u0646\u062C\u0632\u0629 (\u0645\u0639\u062A\u0645\u062F\u0629 \u0623\u0648 \u0645\u0631\u0633\u0644\u0629)"
    },
    late: {
      title: "\u0627\u0644\u0645\u062A\u0623\u062E\u0651\u0631",
      none: "\u0644\u0627 \u0634\u064A\u0621 \u0645\u062A\u0623\u062E\u0651\u0631: \u0627\u0644\u0645\u062E\u0631\u062C\u0627\u062A \u0648\u0627\u0644\u062A\u0623\u0634\u064A\u0631\u0627\u062A \u0641\u064A \u0622\u062C\u0627\u0644\u0647\u0627.",
      deliverables: "\u0645\u062E\u0631\u062C\u0627\u062A \u0645\u062A\u0623\u062E\u0631\u0629",
      approvals: "\u062A\u0623\u0634\u064A\u0631\u0627\u062A \u0645\u062A\u0623\u062E\u0631\u0629",
      columns: {
        title: "\u0627\u0644\u0645\u062E\u0631\u062C",
        phase: "\u0627\u0644\u0645\u0631\u062D\u0644\u0629",
        discipline: "\u0627\u0644\u0627\u062E\u062A\u0635\u0627\u0635",
        due: "\u0627\u0644\u0623\u062C\u0644",
        office: "\u0627\u0644\u0645\u0643\u062A\u0628",
        document: "\u0627\u0644\u0648\u062B\u064A\u0642\u0629"
      },
      noDiscipline: "\u0628\u062F\u0648\u0646 \u0627\u062E\u062A\u0635\u0627\u0635"
    },
    matrix: {
      title: "\u0645\u0646 \u064A\u0646\u062A\u062C \u0645\u0627\u0630\u0627",
      introEdit: "\u0627\u062E\u062A\u0627\u0631\u0648\u0627 \u0627\u0644\u0645\u0643\u062A\u0628 \u0627\u0644\u0645\u0633\u0624\u0648\u0644 \u0639\u0646 \u0643\u0644 \u062D\u0635\u0651\u0629 (\u0627\u062E\u062A\u0635\u0627\u0635). \u064A\u062A\u0628\u0639 \u0627\u0644\u0645\u062E\u0631\u062C \u062D\u0635\u0651\u062A\u0647 \u0645\u0627 \u0644\u0645 \u062A\u064F\u0633\u0646\u062F\u0648\u0647 \u0625\u0644\u0649 \u0645\u0643\u062A\u0628 \u0622\u062E\u0631. \u062A\u064F\u0637\u0628\u064E\u0651\u0642 \u0627\u0644\u062A\u063A\u064A\u064A\u0631\u0627\u062A \u0639\u0646\u062F \u0627\u0644\u062D\u0641\u0638.",
      introRead: "\u0627\u0644\u0645\u0643\u062A\u0628 \u0627\u0644\u0645\u0633\u0624\u0648\u0644 \u0639\u0646 \u0643\u0644 \u062D\u0635\u0651\u0629 \u0648\u0643\u0644 \u0645\u062E\u0631\u062C\u060C \u0643\u0645\u0627 \u062D\u062F\u0651\u062F\u0647 \u0627\u0644\u0645\u0643\u062A\u0628 \u0627\u0644\u0631\u0626\u064A\u0633\u064A.",
      introOwn: "\u0645\u062E\u0631\u062C\u0627\u062A\u0643\u0645 \u0645\u0631\u062A\u0651\u0628\u0629 \u062D\u0633\u0628 \u0627\u0644\u062D\u0635\u0651\u0629.",
      tableLabel: "\u0627\u0644\u0645\u0633\u0624\u0648\u0644\u064A\u0627\u062A \u062D\u0633\u0628 \u0627\u0644\u062D\u0635\u0651\u0629 \u0648\u0627\u0644\u0645\u062E\u0631\u062C",
      scrollLabel: "\u062C\u062F\u0648\u0644 \u0627\u0644\u0645\u0633\u0624\u0648\u0644\u064A\u0627\u062A\u060C \u0642\u0627\u0628\u0644 \u0644\u0644\u062A\u0645\u0631\u064A\u0631 \u0623\u0641\u0642\u064A\u064B\u0627",
      columns: {
        item: "\u0627\u0644\u062D\u0635\u0635 \u0648\u0627\u0644\u0645\u062E\u0631\u062C\u0627\u062A",
        phase: "\u0627\u0644\u0645\u0631\u062D\u0644\u0629",
        status: "\u0627\u0644\u062D\u0627\u0644\u0629",
        due: "\u0627\u0644\u0623\u062C\u0644",
        office: "\u0627\u0644\u0645\u0643\u062A\u0628 \u0627\u0644\u0645\u0633\u0624\u0648\u0644",
        origin: "\u0627\u0644\u0645\u0635\u062F\u0631"
      },
      lot: "\u062D\u0635\u0651\u0629",
      noDiscipline: "\u0628\u062F\u0648\u0646 \u0627\u062E\u062A\u0635\u0627\u0635",
      count: "{count, plural, zero {\u0644\u0627 \u0645\u062E\u0631\u062C\u0627\u062A} one {\u0645\u062E\u0631\u062C \u0648\u0627\u062D\u062F} two {\u0645\u062E\u0631\u062C\u0627\u0646} few {# \u0645\u062E\u0631\u062C\u0627\u062A} many {# \u0645\u062E\u0631\u062C\u064B\u0627} other {# \u0645\u062E\u0631\u062C}}",
      noDue: "\u0628\u062F\u0648\u0646 \u0623\u062C\u0644",
      overdue: "\u0645\u062A\u0623\u062E\u0631",
      statuses: {
        to_produce: "\u0642\u064A\u062F \u0627\u0644\u0625\u0639\u062F\u0627\u062F",
        in_progress: "\u062C\u0627\u0631\u064D",
        in_review: "\u0642\u064A\u062F \u0627\u0644\u0645\u0631\u0627\u062C\u0639\u0629",
        approved: "\u0645\u0639\u062A\u0645\u062F",
        transmitted: "\u0645\u064F\u0631\u0633\u064E\u0644"
      },
      origin: {
        deliverable: "\u0645\u064F\u0633\u0646\u062F \u0625\u0644\u0649 \u0627\u0644\u0645\u062E\u0631\u062C",
        discipline: "\u062D\u0633\u0628 \u0627\u0644\u062D\u0635\u0651\u0629",
        host: "\u0627\u0644\u0645\u0643\u062A\u0628 \u0627\u0644\u0631\u0626\u064A\u0633\u064A \u0627\u0641\u062A\u0631\u0627\u0636\u064A\u064B\u0627",
        lot: "\u0645\u064F\u0633\u0646\u062F \u0625\u0644\u0649 \u0627\u0644\u062D\u0635\u0651\u0629"
      },
      followLot: "\u062D\u0633\u0628 \u0627\u0644\u062D\u0635\u0651\u0629",
      followHost: "\u0627\u0644\u0645\u0643\u062A\u0628 \u0627\u0644\u0631\u0626\u064A\u0633\u064A \u0627\u0641\u062A\u0631\u0627\u0636\u064A\u064B\u0627",
      hostOffice: "{name} (\u0627\u0644\u0645\u0643\u062A\u0628 \u0627\u0644\u0631\u0626\u064A\u0633\u064A)",
      selectLot: "\u0627\u0644\u0645\u0643\u062A\u0628 \u0627\u0644\u0645\u0633\u0624\u0648\u0644 \u0639\u0646 \u062D\u0635\u0651\u0629 {discipline}",
      selectDeliverable: "\u0627\u0644\u0645\u0643\u062A\u0628 \u0627\u0644\u0645\u0633\u0624\u0648\u0644 \u0639\u0646 \u0627\u0644\u0645\u062E\u0631\u062C {title}",
      save: "\u062D\u0641\u0638 \u0627\u0644\u0645\u0635\u0641\u0648\u0641\u0629",
      saving: "\u062C\u0627\u0631\u064D \u0627\u0644\u062D\u0641\u0638\u2026",
      discard: "\u0625\u0644\u063A\u0627\u0621 \u0627\u0644\u062A\u063A\u064A\u064A\u0631\u0627\u062A",
      pending: "{count, plural, zero {\u0644\u0627 \u062A\u063A\u064A\u064A\u0631\u0627\u062A \u063A\u064A\u0631 \u0645\u062D\u0641\u0648\u0638\u0629} one {\u062A\u063A\u064A\u064A\u0631 \u0648\u0627\u062D\u062F \u063A\u064A\u0631 \u0645\u062D\u0641\u0648\u0638} two {\u062A\u063A\u064A\u064A\u0631\u0627\u0646 \u063A\u064A\u0631 \u0645\u062D\u0641\u0648\u0638\u064A\u0646} few {# \u062A\u063A\u064A\u064A\u0631\u0627\u062A \u063A\u064A\u0631 \u0645\u062D\u0641\u0648\u0638\u0629} many {# \u062A\u063A\u064A\u064A\u0631\u064B\u0627 \u063A\u064A\u0631 \u0645\u062D\u0641\u0648\u0638} other {# \u062A\u063A\u064A\u064A\u0631 \u063A\u064A\u0631 \u0645\u062D\u0641\u0648\u0638}}",
      saved: "\u062A\u0645 \u062D\u0641\u0638 \u0645\u0635\u0641\u0648\u0641\u0629 \u0627\u0644\u0645\u0633\u0624\u0648\u0644\u064A\u0627\u062A.",
      errors: {
        notAnOffice: "\u0627\u062E\u062A\u0627\u0631\u0648\u0627 \u0627\u0644\u0645\u0643\u062A\u0628 \u0627\u0644\u0631\u0626\u064A\u0633\u064A \u0623\u0648 \u0645\u0643\u062A\u0628\u064B\u0627 \u0634\u0631\u064A\u0643\u064B\u0627 \u0646\u0634\u0637\u064B\u0627 \u0641\u064A \u0647\u0630\u0647 \u0627\u0644\u0645\u0633\u0627\u062D\u0629.",
        unknownDeliverable: "\u0644\u0645 \u064A\u0639\u062F \u0623\u062D\u062F \u0627\u0644\u0645\u062E\u0631\u062C\u0627\u062A \u062A\u0627\u0628\u0639\u064B\u0627 \u0644\u0645\u0634\u0631\u0648\u0639 \u0647\u0630\u0647 \u0627\u0644\u0645\u0633\u0627\u062D\u0629. \u0623\u064F\u0639\u064A\u062F \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0645\u0635\u0641\u0648\u0641\u0629: \u0623\u0639\u064A\u062F\u0648\u0627 \u0625\u062C\u0631\u0627\u0621 \u062A\u063A\u064A\u064A\u0631\u0627\u062A\u0643\u0645.",
        forbidden: "\u064A\u0645\u0643\u0646 \u0644\u0645\u0633\u0624\u0648\u0644\u064A \u0627\u0644\u0645\u0643\u062A\u0628 \u0627\u0644\u0631\u0626\u064A\u0633\u064A \u0641\u0642\u0637 \u062A\u0639\u062F\u064A\u0644 \u0627\u0644\u0645\u0635\u0641\u0648\u0641\u0629."
      },
      emptyTitle: "\u0644\u0627 \u0645\u062E\u0631\u062C\u0627\u062A \u0628\u0639\u062F",
      emptyBody: "\u062A\u064F\u0636\u0627\u0641 \u0627\u0644\u0645\u062E\u0631\u062C\u0627\u062A \u0641\u064A \u062A\u0628\u0648\u064A\u0628 \xAB\u0627\u0644\u0645\u062E\u0631\u062C\u0627\u062A\xBB \u0627\u0644\u062E\u0627\u0635 \u0628\u0627\u0644\u0645\u0634\u0631\u0648\u0639. \u0648\u062D\u0627\u0644\u0645\u0627 \u062A\u0648\u062C\u062F \u0645\u062E\u0631\u062C\u0627\u062A \u0633\u062A\u0631\u0648\u0646 \u0647\u0646\u0627 \u0645\u0646 \u064A\u0646\u062A\u062C\u0647\u0627 \u0648\u0623\u064A\u0646 \u0628\u0644\u063A \u0627\u0644\u0639\u0645\u0644.",
      emptyBodyOwn: "\u0644\u0645 \u062A\u064F\u0633\u0646\u062F \u0623\u064A \u0645\u062E\u0631\u062C\u0627\u062A \u0625\u0644\u0649 \u0645\u0643\u062A\u0628\u0643\u0645 \u0628\u0639\u062F. \u064A\u0648\u0632\u0651\u0639\u0647\u0627 \u0627\u0644\u0645\u0643\u062A\u0628 \u0627\u0644\u0631\u0626\u064A\u0633\u064A \u0628\u064A\u0646 \u0627\u0644\u0645\u0643\u0627\u062A\u0628."
    }
  },
  groupement: {
    loadFailedTitle: "\u062A\u0639\u0630\u0651\u0631 \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u062A\u062C\u0645\u0651\u0639",
    loadFailedBody: "\u062A\u062D\u0642\u0651\u0642\u0648\u0627 \u0645\u0646 \u0627\u0644\u0627\u062A\u0635\u0627\u0644 \u062B\u0645 \u0623\u0639\u064A\u062F\u0648\u0627 \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629.",
    noProjectTitle: "\u0647\u0630\u0627 \u0627\u0644\u0641\u0636\u0627\u0621 \u063A\u064A\u0631 \u0645\u0631\u062A\u0628\u0637 \u0628\u0645\u0634\u0631\u0648\u0639",
    noProjectBody: "\u064A\u0648\u0632\u0651\u0639 \u0627\u0644\u062A\u062C\u0645\u0651\u0639 \u0627\u0644\u0623\u062A\u0639\u0627\u0628 \u062D\u0633\u0628 \u0645\u0631\u0627\u062D\u0644 \u0627\u0644\u0645\u0634\u0631\u0648\u0639. \u0633\u064A\u062A\u0648\u0641\u0651\u0631 \u062D\u0627\u0644\u0645\u0627 \u064A\u064F\u0631\u0628\u0637 \u0627\u0644\u0641\u0636\u0627\u0621 \u0628\u0645\u0634\u0631\u0648\u0639.",
    emptyHostTitle: "\u0644\u0627 \u064A\u0648\u062C\u062F \u062A\u062C\u0645\u0651\u0639 \u0628\u0639\u062F",
    emptyHostBody: "\u062D\u062F\u0651\u062F\u0648\u0627 \u0643\u064A\u0641 \u062A\u064F\u0642\u0633\u064E\u0651\u0645 \u0627\u0644\u0623\u062A\u0639\u0627\u0628\u060C \u0645\u0631\u062D\u0644\u0629\u064B \u0645\u0631\u062D\u0644\u0629\u060C \u0628\u064A\u0646 \u0645\u0643\u062A\u0628\u0643\u0645 (\u0627\u0644\u0645\u0643\u062A\u0628 \u0627\u0644\u0631\u0626\u064A\u0633\u064A) \u0648\u0627\u0644\u0645\u0643\u0627\u062A\u0628 \u0627\u0644\u0645\u0634\u0627\u0631\u0643\u0629.",
    emptyOtherTitle: "\u0644\u0645 \u064A\u064F\u062D\u062F\u064E\u0651\u062F \u0627\u0644\u062A\u062C\u0645\u0651\u0639 \u0628\u0639\u062F",
    emptyOtherBody: "\u0644\u0645 \u064A\u0646\u0634\u0626 \u0627\u0644\u0645\u0643\u062A\u0628 \u0627\u0644\u0631\u0626\u064A\u0633\u064A \u062A\u062C\u0645\u0651\u0639 \u0647\u0630\u0627 \u0627\u0644\u0641\u0636\u0627\u0621 \u0628\u0639\u062F. \u0633\u062A\u062C\u062F\u0648\u0646 \u0647\u0646\u0627 \u062D\u0635\u0651\u062A\u0643\u0645 \u0645\u0646 \u0627\u0644\u0623\u062A\u0639\u0627\u0628 \u062D\u0627\u0644\u0645\u0627 \u064A\u0641\u0639\u0644 \u0630\u0644\u0643.",
    create: "\u0625\u0646\u0634\u0627\u0621 \u0627\u0644\u062A\u062C\u0645\u0651\u0639",
    edit: "\u062A\u0639\u062F\u064A\u0644 \u0627\u0644\u062A\u062C\u0645\u0651\u0639",
    recordPayment: "\u062A\u0633\u062C\u064A\u0644 \u062F\u0641\u0639\u0629",
    notices: {
      coContractor: "\u062A\u0648\u0632\u064A\u0639 \u0627\u0644\u0623\u062A\u0639\u0627\u0628 \u0645\u0631\u0626\u064A \u0644\u0645\u0643\u0627\u062A\u0628 \u0627\u0644\u062A\u062C\u0645\u0651\u0639 \u0648\u062D\u062F\u0647\u0627. \u0644\u0627 \u062A\u0631\u0648\u0646 \u0625\u0644\u0627 \u0627\u0644\u0645\u0628\u0627\u0644\u063A \u0627\u0644\u0645\u062D\u0648\u064E\u0651\u0644\u0629 \u0625\u0644\u0649 \u0645\u0643\u062A\u0628\u0643\u0645\u060C \u062F\u0648\u0646 \u0645\u0628\u0627\u0644\u063A \u0627\u0644\u0645\u0643\u0627\u062A\u0628 \u0627\u0644\u0623\u062E\u0631\u0649.",
      readOnly: "\u064A\u0645\u0643\u0646\u0643\u0645 \u0627\u0644\u0627\u0637\u0644\u0627\u0639 \u0639\u0644\u0649 \u0627\u0644\u062A\u062C\u0645\u0651\u0639 \u062F\u0648\u0646 \u062A\u0639\u062F\u064A\u0644\u0647."
    },
    roles: {
      lead: "\u0627\u0644\u0645\u0643\u062A\u0628 \u0627\u0644\u0631\u0626\u064A\u0633\u064A",
      co_contractor: "\u0645\u0643\u062A\u0628 \u0645\u0634\u0627\u0631\u0643"
    },
    billingModes: {
      lead_only: "\u0641\u0627\u062A\u0648\u0631\u0629 \u0648\u0627\u062D\u062F\u0629 \u0639\u0628\u0631 \u0627\u0644\u0645\u0643\u062A\u0628 \u0627\u0644\u0631\u0626\u064A\u0633\u064A",
      separate: "\u0641\u0648\u0627\u062A\u064A\u0631 \u0645\u0646\u0641\u0635\u0644\u0629"
    },
    kpis: {
      label: "\u0623\u0647\u0645\u0651 \u0623\u0631\u0642\u0627\u0645 \u0627\u0644\u062A\u062C\u0645\u0651\u0639",
      fees: "\u0625\u062C\u0645\u0627\u0644\u064A \u0627\u0644\u0623\u062A\u0639\u0627\u0628",
      feesCaption: "\u0627\u0644\u0645\u062A\u0651\u0641\u0642 \u0639\u0644\u064A\u0647\u0627 \u0645\u0639 \u0635\u0627\u062D\u0628 \u0627\u0644\u0645\u0634\u0631\u0648\u0639",
      feesUnknown: "\u063A\u064A\u0631 \u0645\u062D\u062F\u0651\u062F\u0629",
      feesUnknownCaption: "\u064A\u062A\u0639\u0630\u0651\u0631 \u0627\u062D\u062A\u0633\u0627\u0628 \u0627\u0644\u0645\u0628\u0644\u063A \u0627\u0644\u0645\u0633\u062A\u062D\u0642 \u0644\u0643\u0644 \u0645\u0643\u062A\u0628",
      received: "\u0627\u0644\u0645\u0642\u0628\u0648\u0636 \u0645\u0646 \u0635\u0627\u062D\u0628 \u0627\u0644\u0645\u0634\u0631\u0648\u0639",
      receivedCaption: "\u0627\u0644\u062F\u0641\u0639\u0627\u062A \u0627\u0644\u0645\u0633\u062C\u064E\u0651\u0644\u0629",
      redistributed: "\u0627\u0644\u0645\u062D\u0648\u064E\u0651\u0644 \u0625\u0644\u0649 \u0627\u0644\u0645\u0643\u0627\u062A\u0628 \u0627\u0644\u0645\u0634\u0627\u0631\u0643\u0629",
      redistributedOwn: "\u0627\u0644\u0645\u062D\u0648\u064E\u0651\u0644 \u0625\u0644\u0649 \u0645\u0643\u062A\u0628\u0643\u0645",
      redistributedCaption: "\u0645\u0628\u0627\u0644\u063A \u0633\u0628\u0642 \u0623\u0646 \u062F\u0641\u0639\u0647\u0627 \u0627\u0644\u0645\u0643\u062A\u0628 \u0627\u0644\u0631\u0626\u064A\u0633\u064A",
      billing: "\u0627\u0644\u0641\u0648\u062A\u0631\u0629",
      billingCaption: {
        lead_only: "\u0627\u0644\u0645\u0643\u062A\u0628 \u0627\u0644\u0631\u0626\u064A\u0633\u064A \u064A\u0641\u0648\u062A\u0631 \u0635\u0627\u062D\u0628 \u0627\u0644\u0645\u0634\u0631\u0648\u0639 \u0646\u064A\u0627\u0628\u0629 \u0639\u0646 \u0627\u0644\u062C\u0645\u064A\u0639",
        separate: "\u0643\u0644 \u0645\u0643\u062A\u0628 \u064A\u0641\u0648\u062A\u0631 \u062D\u0635\u0651\u062A\u0647"
      }
    },
    members: {
      title: "\u0645\u0643\u0627\u062A\u0628 \u0627\u0644\u062A\u062C\u0645\u0651\u0639",
      hidden: "\u0645\u0628\u0627\u0644\u063A \u0647\u0630\u0627 \u0627\u0644\u0645\u0643\u062A\u0628 \u063A\u064A\u0631 \u0645\u0639\u0631\u0648\u0636\u0629 \u0644\u0643\u0645.",
      due: "\u0627\u0644\u0623\u062A\u0639\u0627\u0628 \u0627\u0644\u0645\u0633\u062A\u062D\u0642\u0629",
      notComputed: "\u063A\u064A\u0631 \u0645\u062D\u062A\u0633\u0628\u0629",
      redistributed: "\u0627\u0644\u0645\u062D\u0648\u064E\u0651\u0644",
      leadKeeps: "\u064A\u062D\u062A\u0641\u0638 \u0627\u0644\u0645\u0643\u062A\u0628 \u0627\u0644\u0631\u0626\u064A\u0633\u064A \u0628\u062D\u0635\u0651\u062A\u0647: \u0644\u0627 \u064A\u064F\u062D\u0648\u064E\u0651\u0644 \u0625\u0644\u064A\u0647 \u0634\u064A\u0621.",
      progress: "\u062D\u064F\u0648\u0650\u0651\u0644 {redistributed} \u0645\u0646 \u0623\u0635\u0644 {due} \u0645\u0633\u062A\u062D\u0642\u0629",
      overpaid: "\u0623\u0643\u062B\u0631 \u0645\u0646 \u0627\u0644\u0645\u0633\u062A\u062D\u0642",
      settled: "\u0645\u0633\u062F\u064E\u0651\u062F \u0628\u0627\u0644\u0643\u0627\u0645\u0644",
      needFees: "\u0623\u062F\u062E\u0644\u0648\u0627 \u0625\u062C\u0645\u0627\u0644\u064A \u0627\u0644\u0623\u062A\u0639\u0627\u0628 \u0644\u0627\u062D\u062A\u0633\u0627\u0628 \u0627\u0644\u0645\u0628\u0644\u063A \u0627\u0644\u0645\u0633\u062A\u062D\u0642."
    },
    shares: {
      title: "\u062A\u0648\u0632\u064A\u0639 \u0627\u0644\u0623\u062A\u0639\u0627\u0628 \u062D\u0633\u0628 \u0627\u0644\u0645\u0631\u062D\u0644\u0629",
      intro: "\u062D\u0635\u0651\u0629 \u0643\u0644 \u0645\u0643\u062A\u0628 \u0645\u0646 \u0623\u062A\u0639\u0627\u0628 \u0643\u0644 \u0645\u0631\u062D\u0644\u0629.",
      noPhases: "\u0644\u0627 \u0645\u0631\u0627\u062D\u0644 \u0641\u064A \u0627\u0644\u0645\u0634\u0631\u0648\u0639 \u0628\u0639\u062F.",
      scrollLabel: "\u062C\u062F\u0648\u0644 \u062A\u0648\u0632\u064A\u0639 \u0627\u0644\u0623\u062A\u0639\u0627\u0628\u060C \u0642\u0627\u0628\u0644 \u0644\u0644\u062A\u0645\u0631\u064A\u0631 \u0623\u0641\u0642\u064A\u064B\u0627",
      tableLabel: "\u062D\u0635\u0635 \u0627\u0644\u0645\u0643\u0627\u062A\u0628 \u062D\u0633\u0628 \u0627\u0644\u0645\u0631\u062D\u0644\u0629",
      phase: "\u0627\u0644\u0645\u0631\u062D\u0644\u0629",
      total: "\u0627\u0644\u0645\u062C\u0645\u0648\u0639",
      none: "\u2014",
      complete: "\u0645\u0643\u062A\u0645\u0644",
      over: "\u064A\u062A\u062C\u0627\u0648\u0632 100 %",
      empty: "\u063A\u064A\u0631 \u0645\u0648\u0632\u064E\u0651\u0639\u0629",
      partial: "\u0628\u0642\u064A {rest} \u062F\u0648\u0646 \u062A\u0648\u0632\u064A\u0639"
    },
    payments: {
      title: "\u0627\u0644\u062F\u0641\u0639\u0627\u062A",
      empty: "\u0644\u0627 \u062A\u0648\u062C\u062F \u062F\u0641\u0639\u0627\u062A \u0645\u0633\u062C\u064E\u0651\u0644\u0629 \u0628\u0639\u062F.",
      scrollLabel: "\u062C\u062F\u0648\u0644 \u0627\u0644\u062F\u0641\u0639\u0627\u062A\u060C \u0642\u0627\u0628\u0644 \u0644\u0644\u062A\u0645\u0631\u064A\u0631 \u0623\u0641\u0642\u064A\u064B\u0627",
      tableLabel: "\u062F\u0641\u0639\u0627\u062A \u0627\u0644\u062A\u062C\u0645\u0651\u0639",
      columns: {
        date: "\u0627\u0644\u062A\u0627\u0631\u064A\u062E",
        kind: "\u0627\u0644\u0646\u0648\u0639",
        phase: "\u0627\u0644\u0645\u0631\u062D\u0644\u0629",
        amount: "\u0627\u0644\u0645\u0628\u0644\u063A",
        reference: "\u0627\u0644\u0645\u0631\u062C\u0639",
        actions: "\u0625\u062C\u0631\u0627\u0621\u0627\u062A"
      },
      received: "\u0645\u0642\u0628\u0648\u0636\u0629 \u0645\u0646 \u0635\u0627\u062D\u0628 \u0627\u0644\u0645\u0634\u0631\u0648\u0639",
      redistributed: "\u0645\u062D\u0648\u064E\u0651\u0644\u0629 \u0625\u0644\u0649 {office}",
      allPhases: "\u0643\u0644 \u0627\u0644\u0645\u0631\u0627\u062D\u0644",
      noReference: "\u0628\u062F\u0648\u0646 \u0645\u0631\u062C\u0639",
      deleteLabel: "\u062D\u0630\u0641 \u062F\u0641\u0639\u0629 {date} \u0628\u0645\u0628\u0644\u063A {amount}",
      deleteTitle: "\u062D\u0630\u0641 \u0647\u0630\u0647 \u0627\u0644\u062F\u0641\u0639\u0629\u061F",
      deleteBody: "\u0633\u062A\u064F\u0633\u062D\u0628 \u062F\u0641\u0639\u0629 {amount} \u0628\u062A\u0627\u0631\u064A\u062E {date} \u0645\u0646 \u0627\u0644\u062A\u062C\u0645\u0651\u0639\u060C \u0648\u0633\u064A\u064F\u0639\u0627\u062F \u0627\u062D\u062A\u0633\u0627\u0628 \u0627\u0644\u0645\u0628\u0627\u0644\u063A \u0627\u0644\u0645\u062D\u0648\u064E\u0651\u0644\u0629.",
      deleted: "\u062A\u0645 \u062D\u0630\u0641 \u0627\u0644\u062F\u0641\u0639\u0629."
    },
    paymentDialog: {
      title: "\u062A\u0633\u062C\u064A\u0644 \u062F\u0641\u0639\u0629",
      intro: "\u0633\u062C\u0651\u0644\u0648\u0627 \u062F\u0641\u0639\u0629 \u0642\u0628\u0636\u0647\u0627 \u0627\u0644\u0645\u0643\u062A\u0628 \u0627\u0644\u0631\u0626\u064A\u0633\u064A \u0645\u0646 \u0635\u0627\u062D\u0628 \u0627\u0644\u0645\u0634\u0631\u0648\u0639\u060C \u0623\u0648 \u0645\u0628\u0644\u063A\u064B\u0627 \u062D\u0648\u0651\u0644\u0647 \u0625\u0644\u0649 \u0645\u0643\u062A\u0628 \u0645\u0634\u0627\u0631\u0643.",
      kind: "\u0646\u0648\u0639 \u0627\u0644\u062F\u0641\u0639\u0629",
      kinds: {
        received: "\u0645\u0642\u0628\u0648\u0636\u0629 \u0645\u0646 \u0635\u0627\u062D\u0628 \u0627\u0644\u0645\u0634\u0631\u0648\u0639",
        redistributed: "\u0645\u062D\u0648\u064E\u0651\u0644\u0629 \u0625\u0644\u0649 \u0645\u0643\u062A\u0628 \u0645\u0634\u0627\u0631\u0643"
      },
      member: "\u0627\u0644\u0645\u0643\u062A\u0628 \u0627\u0644\u0645\u0634\u0627\u0631\u0643",
      pickMember: "\u0627\u062E\u062A\u0627\u0631\u0648\u0627 \u0645\u0643\u062A\u0628\u064B\u0627",
      phase: "\u0627\u0644\u0645\u0631\u062D\u0644\u0629 (\u0627\u062E\u062A\u064A\u0627\u0631\u064A)",
      amount: "\u0627\u0644\u0645\u0628\u0644\u063A",
      paidOn: "\u062A\u0627\u0631\u064A\u062E \u0627\u0644\u062F\u0641\u0639",
      reference: "\u0627\u0644\u0645\u0631\u062C\u0639 (\u062A\u062D\u0648\u064A\u0644\u060C \u0634\u064A\u0643\u2026)",
      note: "\u0645\u0644\u0627\u062D\u0638\u0629 (\u0627\u062E\u062A\u064A\u0627\u0631\u064A)",
      submit: "\u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062F\u0641\u0639\u0629",
      submitting: "\u062C\u0627\u0631\u064D \u0627\u0644\u062A\u0633\u062C\u064A\u0644\u2026",
      saved: "\u062A\u0645 \u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062F\u0641\u0639\u0629.",
      errors: {
        memberRequired: "\u0627\u062E\u062A\u0627\u0631\u0648\u0627 \u0627\u0644\u0645\u0643\u062A\u0628 \u0627\u0644\u0645\u0634\u0627\u0631\u0643 \u0627\u0644\u0645\u0639\u0646\u064A.",
        amountRequired: "\u0623\u062F\u062E\u0644\u0648\u0627 \u0645\u0628\u0644\u063A\u064B\u0627 \u0623\u0643\u0628\u0631 \u0645\u0646 \u0627\u0644\u0635\u0641\u0631.",
        dateRequired: "\u062D\u062F\u0651\u062F\u0648\u0627 \u062A\u0627\u0631\u064A\u062E \u0627\u0644\u062F\u0641\u0639."
      }
    },
    editor: {
      createTitle: "\u0625\u0646\u0634\u0627\u0621 \u0627\u0644\u062A\u062C\u0645\u0651\u0639",
      editTitle: "\u062A\u0639\u062F\u064A\u0644 \u0627\u0644\u062A\u062C\u0645\u0651\u0639",
      intro: "\u0627\u062E\u062A\u0627\u0631\u0648\u0627 \u0637\u0631\u064A\u0642\u0629 \u0627\u0644\u0641\u0648\u062A\u0631\u0629 \u0648\u0627\u0644\u0645\u0643\u0627\u062A\u0628 \u0627\u0644\u0645\u0634\u0627\u0631\u0643\u0629\u060C \u062B\u0645 \u0648\u0632\u0651\u0639\u0648\u0627 \u0623\u062A\u0639\u0627\u0628 \u0643\u0644 \u0645\u0631\u062D\u0644\u0629 \u0628\u0627\u0644\u0646\u0633\u0628\u0629 \u0627\u0644\u0645\u0626\u0648\u064A\u0629. \u0641\u064A \u0627\u0644\u0645\u0631\u062D\u0644\u0629 \u0627\u0644\u0648\u0627\u062D\u062F\u0629 \u0644\u0627 \u064A\u062A\u062C\u0627\u0648\u0632 \u0645\u062C\u0645\u0648\u0639 \u0627\u0644\u062D\u0635\u0635 100 %.",
      billing: "\u0637\u0631\u064A\u0642\u0629 \u0627\u0644\u0641\u0648\u062A\u0631\u0629",
      fees: "\u0625\u062C\u0645\u0627\u0644\u064A \u0627\u0644\u0623\u062A\u0639\u0627\u0628 (\u0627\u062E\u062A\u064A\u0627\u0631\u064A)",
      feesHint: "\u0628\u062F\u0648\u0646 \u0647\u0630\u0627 \u0627\u0644\u0645\u0628\u0644\u063A \u0644\u0627 \u064A\u064F\u062D\u062A\u0633\u0628 \u0627\u0644\u0645\u0633\u062A\u062D\u0642 \u0644\u0643\u0644 \u0645\u0643\u062A\u0628.",
      coContractors: "\u0627\u0644\u0645\u0643\u0627\u062A\u0628 \u0627\u0644\u0645\u0634\u0627\u0631\u0643\u0629",
      coContractorsHint: "\u0627\u0644\u0645\u0643\u0627\u062A\u0628 \u0627\u0644\u0634\u0631\u064A\u0643\u0629 \u0627\u0644\u0646\u0634\u0637\u0629 \u0641\u064A \u0647\u0630\u0627 \u0627\u0644\u0641\u0636\u0627\u0621.",
      noPartners: "\u0644\u0627 \u064A\u0648\u062C\u062F \u0645\u0643\u062A\u0628 \u0634\u0631\u064A\u0643 \u0646\u0634\u0637. \u0627\u062F\u0639\u0648\u0627 \u0645\u0643\u0627\u062A\u0628 \u0623\u0648\u0644\u064B\u0627 \u0645\u0646 \u062A\u0628\u0648\u064A\u0628 \xAB\u0627\u0644\u0645\u0624\u0633\u0633\u0627\u062A \u0627\u0644\u0634\u0631\u064A\u0643\u0629\xBB.",
      needOne: "\u0627\u062E\u062A\u0627\u0631\u0648\u0627 \u0645\u0643\u062A\u0628\u064B\u0627 \u0645\u0634\u0627\u0631\u0643\u064B\u0627 \u0648\u0627\u062D\u062F\u064B\u0627 \u0639\u0644\u0649 \u0627\u0644\u0623\u0642\u0644.",
      shares: "\u0627\u0644\u062D\u0635\u0635 \u062D\u0633\u0628 \u0627\u0644\u0645\u0631\u062D\u0644\u0629 (\u0628\u0627\u0644\u0646\u0633\u0628\u0629 \u0627\u0644\u0645\u0626\u0648\u064A\u0629)",
      sharesHint: "\u0641\u064A \u0643\u0644 \u0645\u0631\u062D\u0644\u0629 \u0644\u0627 \u064A\u062A\u062C\u0627\u0648\u0632 \u0627\u0644\u0645\u062C\u0645\u0648\u0639 100 %. \u0648\u0645\u0627 \u0628\u0642\u064A \u064A\u0638\u0644 \u0628\u0628\u0633\u0627\u0637\u0629 \u063A\u064A\u0631 \u0645\u0648\u0632\u064E\u0651\u0639.",
      noPhases: "\u0644\u0627 \u0645\u0631\u0627\u062D\u0644 \u0641\u064A \u0627\u0644\u0645\u0634\u0631\u0648\u0639 \u0628\u0639\u062F: \u0623\u0636\u064A\u0641\u0648\u0627 \u0645\u0631\u0627\u062D\u0644 \u0644\u062A\u0648\u0632\u064A\u0639 \u0627\u0644\u0623\u062A\u0639\u0627\u0628.",
      pickFirst: "\u0627\u062E\u062A\u0627\u0631\u0648\u0627 \u0627\u0644\u0645\u0643\u0627\u062A\u0628 \u0627\u0644\u0645\u0634\u0627\u0631\u0643\u0629 \u0623\u0648\u0644\u064B\u0627 \u0644\u062A\u0648\u0632\u064A\u0639 \u0627\u0644\u062D\u0635\u0635.",
      sharesScroll: "\u062C\u062F\u0648\u0644 \u0625\u062F\u062E\u0627\u0644 \u0627\u0644\u062D\u0635\u0635\u060C \u0642\u0627\u0628\u0644 \u0644\u0644\u062A\u0645\u0631\u064A\u0631 \u0623\u0641\u0642\u064A\u064B\u0627",
      sharesTable: "\u062D\u0635\u0635 \u0627\u0644\u0645\u0643\u0627\u062A\u0628 \u062D\u0633\u0628 \u0627\u0644\u0645\u0631\u062D\u0644\u0629",
      shareLabel: "\u062D\u0635\u0651\u0629 {office} \u0641\u064A \u0645\u0631\u062D\u0644\u0629 {phase}\u060C \u0628\u0627\u0644\u0646\u0633\u0628\u0629 \u0627\u0644\u0645\u0626\u0648\u064A\u0629",
      percentSuffix: "%",
      errors: {
        exceeds: "\u0627\u0644\u0645\u0631\u062D\u0644\u0629 \xAB{phase}\xBB: \u0627\u0644\u0645\u062C\u0645\u0648\u0639 {total}\u060C \u0648\u0644\u0627 \u064A\u062C\u0648\u0632 \u0623\u0646 \u064A\u062A\u062C\u0627\u0648\u0632 100 %.",
        invalid: "\u0623\u062F\u062E\u0644\u0648\u0627 \u0631\u0642\u0645\u064B\u0627 \u0628\u064A\u0646 0 \u0648100\u060C \u0628\u062E\u0627\u0646\u062A\u064A\u0646 \u0639\u0634\u0631\u064A\u062A\u064A\u0646 \u0639\u0644\u0649 \u0627\u0644\u0623\u0643\u062B\u0631."
      },
      submit: "\u062D\u0641\u0638 \u0627\u0644\u062A\u062C\u0645\u0651\u0639",
      submitting: "\u062C\u0627\u0631\u064D \u0627\u0644\u062D\u0641\u0638\u2026",
      saved: "\u062A\u0645 \u062D\u0641\u0638 \u0627\u0644\u062A\u062C\u0645\u0651\u0639.",
      created: "\u062A\u0645 \u0625\u0646\u0634\u0627\u0621 \u0627\u0644\u062A\u062C\u0645\u0651\u0639.",
      loadFailed: "\u062A\u0639\u0630\u0651\u0631 \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0645\u0643\u0627\u062A\u0628 \u0648\u0627\u0644\u0645\u0631\u0627\u062D\u0644. \u0623\u0639\u064A\u062F\u0648\u0627 \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629 \u0628\u0639\u062F \u0642\u0644\u064A\u0644."
    },
    errors: {
      sharesExceed: "\u0645\u062C\u0645\u0648\u0639 \u062D\u0635\u0635 \u0625\u062D\u062F\u0649 \u0627\u0644\u0645\u0631\u0627\u062D\u0644 \u064A\u062A\u062C\u0627\u0648\u0632 100 %. \u0635\u062D\u0651\u062D\u0648\u0627 \u0627\u0644\u062D\u0635\u0635 \u062B\u0645 \u0623\u0639\u064A\u062F\u0648\u0627 \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629.",
      stale: "\u062A\u063A\u064A\u0651\u0631 \u0627\u0644\u062A\u062C\u0645\u0651\u0639 \u0641\u064A \u0627\u0644\u0623\u062B\u0646\u0627\u0621. \u0623\u064F\u0639\u064A\u062F \u062A\u062D\u0645\u064A\u0644\u0647: \u0643\u0631\u0651\u0631\u0648\u0627 \u062A\u0639\u062F\u064A\u0644\u0627\u062A\u0643\u0645.",
      forbidden: "\u0627\u0644\u0645\u0633\u0624\u0648\u0644\u0648\u0646 \u0639\u0646 \u0639\u0642\u0648\u062F \u0627\u0644\u0645\u0643\u062A\u0628 \u0627\u0644\u0631\u0626\u064A\u0633\u064A \u0648\u062D\u062F\u0647\u0645 \u064A\u0645\u0643\u0646\u0647\u0645 \u062A\u0639\u062F\u064A\u0644 \u0627\u0644\u062A\u062C\u0645\u0651\u0639.",
      notAPartner: "\u0623\u062D\u062F \u0627\u0644\u0645\u0643\u0627\u062A\u0628 \u0627\u0644\u0645\u062E\u062A\u0627\u0631\u0629 \u0644\u0645 \u064A\u0639\u062F \u0634\u0631\u064A\u0643\u064B\u0627 \u0646\u0634\u0637\u064B\u0627 \u0641\u064A \u0647\u0630\u0627 \u0627\u0644\u0641\u0636\u0627\u0621. \u062D\u062F\u0651\u062B\u0648\u0627 \u0627\u0644\u0642\u0627\u0626\u0645\u0629.",
      notAMember: "\u0623\u064F\u0633\u0646\u062F\u062A \u062D\u0635\u0651\u0629 \u0625\u0644\u0649 \u0645\u0643\u062A\u0628 \u0644\u064A\u0633 \u0645\u0646 \u0627\u0644\u062A\u062C\u0645\u0651\u0639.",
      unknownPhase: "\u0625\u062D\u062F\u0649 \u0627\u0644\u0645\u0631\u0627\u062D\u0644 \u0644\u0645 \u062A\u0639\u062F \u0645\u0648\u062C\u0648\u062F\u0629 \u0641\u064A \u0627\u0644\u0645\u0634\u0631\u0648\u0639. \u0623\u0639\u064A\u062F\u0648\u0627 \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0635\u0641\u062D\u0629.",
      memberHasPayments: "\u0644\u0627 \u064A\u0645\u0643\u0646 \u0633\u062D\u0628 \u0645\u0643\u062A\u0628 \u0645\u0634\u0627\u0631\u0643 \u0627\u0633\u062A\u0644\u0645 \u062F\u0641\u0639\u0627\u062A \u0645\u0646 \u0627\u0644\u062A\u062C\u0645\u0651\u0639.",
      notACoContractor: "\u0644\u0645 \u064A\u0639\u062F \u0647\u0630\u0627 \u0627\u0644\u0645\u0643\u062A\u0628 \u0645\u0634\u0627\u0631\u0643\u064B\u0627 \u0641\u064A \u0627\u0644\u062A\u062C\u0645\u0651\u0639. \u062D\u062F\u0651\u062B\u0648\u0627 \u0627\u0644\u062A\u062C\u0645\u0651\u0639 \u0623\u0648\u0644\u064B\u0627."
    }
  },
  exitExport: {
    title: "\u0627\u0644\u0641\u0636\u0627\u0621\u0627\u062A \u0627\u0644\u0645\u063A\u0644\u0642\u0629",
    intro: "\u0643\u0646\u062A\u0645 \u0634\u0631\u064A\u0643\u064B\u0627 \u0641\u064A \u0647\u0630\u0647 \u0627\u0644\u0641\u0636\u0627\u0621\u0627\u062A. \u062E\u0644\u0627\u0644 30 \u064A\u0648\u0645\u064B\u0627 \u0645\u0646 \u0625\u063A\u0644\u0627\u0642\u0647\u0627\u060C \u064A\u0645\u0643\u0646\u0643\u0645 \u0627\u0633\u062A\u0631\u062C\u0627\u0639 \u0645\u0627 \u0623\u0648\u062F\u0639\u062A\u0645\u0648\u0647 \u0645\u0646 \u0645\u0644\u0641\u0627\u062A.",
    zipContent: "\u064A\u0636\u0645 \u0645\u0644\u0641 ZIP \u0627\u0644\u0645\u0644\u0641\u0627\u062A \u0627\u0644\u062A\u064A \u0623\u0648\u062F\u0639\u0647\u0627 \u0645\u0643\u062A\u0628\u0643\u0645 \u0641\u0642\u0637\u060C \u0648\u0645\u062F\u062E\u0644\u0627\u062A \u0633\u062C\u0644\u0651 \u0627\u0644\u0641\u0636\u0627\u0621 \u0627\u0644\u062A\u064A \u062A\u062E\u0635\u0651\u0643\u0645.",
    loadFailedTitle: "\u062A\u0639\u0630\u0651\u0631 \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0641\u0636\u0627\u0621\u0627\u062A \u0627\u0644\u0645\u063A\u0644\u0642\u0629",
    hostedBy: "\u064A\u0633\u062A\u0636\u064A\u0641\u0647 {host}",
    closedOn: "\u0623\u064F\u063A\u0644\u0642 \u0641\u064A {date}",
    until: "\u0627\u0644\u062A\u0635\u062F\u064A\u0631 \u0645\u0645\u0643\u0646 \u062D\u062A\u0649 {date}",
    noFiles: "\u0644\u0627 \u0645\u0644\u0641\u0627\u062A \u0623\u0648\u062F\u0639\u0647\u0627 \u0645\u0643\u062A\u0628\u0643\u0645",
    files: "{count, plural, zero {\u0644\u0627 \u0645\u0644\u0641\u0627\u062A} one {\u0645\u0644\u0641 \u0648\u0627\u062D\u062F} two {\u0645\u0644\u0641\u0627\u0646} few {# \u0645\u0644\u0641\u0627\u062A} many {# \u0645\u0644\u0641\u064B\u0627} other {# \u0645\u0644\u0641}} \xB7 {size}",
    request: "\u062A\u0635\u062F\u064A\u0631 \u0645\u0644\u0641\u0627\u062A\u064A",
    forSpace: "{action}: {space}",
    download: "\u062A\u0646\u0632\u064A\u0644 \u0645\u0644\u0641 ZIP",
    readyUntil: "\u0645\u062A\u0627\u062D \u062D\u062A\u0649 {date}",
    working: "\u062C\u0627\u0631\u064D \u0627\u0644\u0625\u0639\u062F\u0627\u062F\u2026",
    failed: "\u062A\u0639\u0630\u0651\u0631 \u0625\u0639\u062F\u0627\u062F \u0627\u0644\u062A\u0635\u062F\u064A\u0631",
    retry: "\u0625\u0639\u0627\u062F\u0629 \u0645\u062D\u0627\u0648\u0644\u0629 \u0627\u0644\u062A\u0635\u062F\u064A\u0631",
    expired: "\u0627\u0646\u062A\u0647\u062A \u0635\u0644\u0627\u062D\u064A\u0629 \u0622\u062E\u0631 \u0645\u0644\u0641 ZIP",
    again: "\u0637\u0644\u0628 \u062A\u0635\u062F\u064A\u0631 \u062C\u062F\u064A\u062F",
    late: "\u0627\u0646\u0642\u0636\u062A \u0645\u0647\u0644\u0629 \u0627\u0644\u062A\u0635\u062F\u064A\u0631",
    requested: "\u0637\u0644\u0628 \u0627\u0644\u062A\u0635\u062F\u064A\u0631 \u0642\u064A\u062F \u0627\u0644\u0625\u0639\u062F\u0627\u062F.",
    errors: {
      request: "\u062A\u0639\u0630\u0651\u0631 \u0637\u0644\u0628 \u0627\u0644\u062A\u0635\u062F\u064A\u0631. \u0623\u0639\u064A\u062F\u0648\u0627 \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629 \u0628\u0639\u062F \u0642\u0644\u064A\u0644.",
      download: "\u062A\u0639\u0630\u0651\u0631 \u0625\u0646\u0634\u0627\u0621 \u0631\u0627\u0628\u0637 \u0627\u0644\u062A\u0646\u0632\u064A\u0644. \u0623\u0639\u064A\u062F\u0648\u0627 \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629.",
      notReady: "\u0645\u0644\u0641 ZIP \u0644\u064A\u0633 \u062C\u0627\u0647\u0632\u064B\u0627 \u0628\u0639\u062F.",
      forbidden: "\u0627\u0644\u0645\u0627\u0644\u0643\u0648\u0646 \u0648\u0627\u0644\u0645\u0633\u0624\u0648\u0644\u0648\u0646 \u0648\u062D\u062F\u0647\u0645 \u064A\u0645\u0643\u0646\u0647\u0645 \u0637\u0644\u0628 \u0627\u0644\u062A\u0635\u062F\u064A\u0631.",
      unavailable: "\u0644\u0645 \u064A\u0639\u062F \u0627\u0644\u062A\u0635\u062F\u064A\u0631 \u0645\u0645\u0643\u0646\u064B\u0627: \u0627\u0646\u0642\u0636\u062A \u0645\u0647\u0644\u0629 30 \u064A\u0648\u0645\u064B\u0627 \u0628\u0639\u062F \u0625\u063A\u0644\u0627\u0642 \u0627\u0644\u0641\u0636\u0627\u0621."
    }
  }
};

// locales/en/spaces.json
var spaces_default2 = {
  title: "Shared spaces",
  intro: "A shared space brings together people from several organisations around a project or a common topic.",
  tabs: {
    documents: "Documents",
    chat: "Conversations",
    calendar: "Calendar",
    meetings: "Meetings",
    people: "People",
    partners: "Partner organisations",
    delegates: "My delegates",
    settings: "Settings",
    audit: "Audit log",
    synthesis: "Synthesis",
    groupement: "Groupement"
  },
  kinds: {
    organization: "Organisation space",
    internal: "Project space",
    shared: "Shared space",
    group: "Working group"
  },
  status: {
    closed: "Closed"
  },
  via: {
    host_member: "Member of the host organisation",
    partner_delegation: "Delegated by your organisation",
    direct_invite: "Named invitation",
    guest: "Guest",
    partner_admin: "Administrator of your partner organisation"
  },
  rights: {
    read: "Read only",
    write: "Read and write",
    approve: "Read, write and approve"
  },
  access: {
    via: "Access: {via}",
    rights: "Rights: {rights}",
    until: "Until {date}",
    noEnd: "No end date"
  },
  page: {
    hostedBy: "Hosted by {host}",
    summaryLabel: "About the space",
    closedNotice: "This space is closed: its content can still be read, but not changed.",
    notFoundTitle: "Space not found",
    notFoundBody: "This space does not exist, or you no longer have access to it. Check the link, or ask the organisation that hosts it for a new invitation.",
    backToList: "See my shared spaces",
    loadFailedTitle: "The space could not be loaded",
    loadFailedBody: "Check your connection and try again.",
    noTabsTitle: "Nothing to show yet",
    noTabsBody: "Your access to this space does not include any content yet. Contact the person who invited you."
  },
  later: {
    calendar: {
      title: "The space calendar is coming soon",
      description: "The space's events and appointments will appear here."
    },
    meetings: {
      title: "Space meetings are coming soon",
      description: "You will be able to start and join the space's meetings here."
    }
  },
  chat: {
    channelsLabel: "Space channels",
    channelsHeading: "Channels",
    loadFailed: "The channels could not be loaded. Try again in a moment.",
    empty: {
      title: "No channels yet",
      description: "The channels of this space will appear here once there are some."
    },
    pick: {
      title: "Choose a channel",
      description: "Select a channel in the list to read and write messages."
    }
  },
  settings: {
    region: "Space settings",
    general: {
      title: "General",
      description: "The name under which the space appears to all its participants."
    },
    name: {
      label: "Space name"
    },
    policy: {
      title: "Space rules",
      description: "These rules apply to every access to this space, including those of partner organisations and guests."
    },
    download: {
      label: "Allow downloads",
      hint: "Without downloads, documents can still be viewed as a preview."
    },
    watermark: {
      label: "Watermark on PDFs",
      hint: "A watermark identifies the person who views each PDF."
    },
    print: {
      label: "Allow printing",
      hint: "Printing is done from the document viewer."
    },
    domains: {
      label: "Domains allowed for guests",
      hint: "Enter a domain, for example client.tn, then press Enter.",
      empty: "No domain: guests can come from any email address that your organisation's policy allows."
    },
    save: "Save settings",
    saving: "Saving\u2026",
    saved: "The space settings are saved.",
    noChange: "There is nothing to save.",
    stepUpNote: "Saving asks you to confirm your identity.",
    failedTitle: "The settings were not saved",
    closedNotice: "This space is closed: its settings can no longer be changed.",
    errors: {
      nameRequired: "Enter a name for the space.",
      nameTooLong: "The name cannot be longer than 200 characters.",
      validation: "Some values are not valid. Check the name and the domains, then try again.",
      forbidden: "You are not allowed to change the settings of this space."
    }
  },
  list: {
    ownHeading: "Spaces of my organisations",
    ownEmptyTitle: "No shared spaces in your organisations",
    ownEmptyBody: "Create a shared space to work with partners, or a working group for your teams.",
    externalHeading: "External spaces",
    externalEmptyTitle: "No external spaces",
    externalEmptyBody: "Spaces of other organisations that give you access will appear here.",
    loadFailedTitle: "Your spaces could not be loaded",
    loadFailedBody: "Check your connection and try again.",
    newSpace: "New shared space",
    external: "External"
  },
  create: {
    title: "New shared space",
    intro: "You will be the manager of the space. You can then invite partner organisations to it.",
    kind: {
      label: "Type of space",
      shared: {
        label: "Shared space of a project",
        hint: "Linked to one of the projects you manage."
      },
      group: {
        label: "Working group",
        hint: "Not linked to a project. Reserved for owners and administrators."
      }
    },
    project: {
      label: "Project",
      placeholder: "Choose a project",
      none: "You do not manage any project: a shared space must be linked to a project you manage."
    },
    name: {
      label: "Space name"
    },
    submit: "Create the space",
    submitting: "Creating\u2026",
    created: 'The space "{name}" has been created.',
    errors: {
      nameRequired: "Enter a name for the space.",
      nameTooLong: "The name cannot be longer than 200 characters.",
      projectRequired: "Choose the project the space is linked to.",
      forbidden: "You are not allowed to create this space in this organisation.",
      planLimit: "Your plan does not allow hosting more shared spaces. Contact the account owner to move to a higher plan.",
      projectGone: "This project no longer exists, or you no longer manage it. Choose another one."
    }
  },
  listPane: {
    title: "Shared spaces",
    label: "My shared spaces",
    empty: "No shared spaces yet.",
    loadFailed: "Your shared spaces could not be loaded.",
    external: "External",
    hostedBy: "Hosted by {host}",
    seeAll: "All shared spaces",
    count: "{count, plural, one {# shared space} other {# shared spaces}}"
  },
  guest: {
    expiry: "Your guest access ends on {date}.",
    expirySoon: "Ask the person who invited you to extend it if you still need it."
  },
  sharing: {
    remove: "Remove",
    loadFailedBody: "Check your connection and try again.",
    errors: {
      forbidden: "You are not allowed to do this in this space."
    },
    partnerStatus: {
      pending: "Waiting for an answer",
      active: "Active",
      declined: "Declined",
      expired: "Expired",
      revoked: "Removed"
    },
    invitationStatus: {
      pending_approval: "Waiting for approval from their organisation",
      pending: "Waiting for an answer",
      accepted: "Accepted",
      declined: "Declined",
      expired: "Expired",
      revoked: "Cancelled"
    },
    memberVia: {
      host_member: "Host member",
      partner_delegation: "Partner delegate",
      direct_invite: "Named guest",
      guest: "Guest"
    },
    rightsOption: {
      label: "Rights",
      read: "Read: view documents and conversations",
      write: "Write: view, add and edit",
      approve: "Write and approve: also approve documents"
    },
    scope: {
      label: "What the access covers",
      all: "The whole space",
      some: "Only chosen folders and channels",
      foldersLegend: "Folders",
      channelsLegend: "Channels",
      subfoldersHint: "A chosen folder also gives access to its subfolders.",
      noFolders: "No folder to choose from yet.",
      noChannels: "No channel to choose from yet.",
      foldersFailed: "The folders could not be loaded. Try again in a moment.",
      channelsFailed: "The channels could not be loaded. Try again in a moment.",
      loading: "Loading\u2026",
      unnamedChannel: "Unnamed channel",
      expand: "Show the subfolders of {name}",
      collapse: "Hide the subfolders of {name}",
      summaryAll: "The whole space",
      summarySome: "Folders: {folders} \xB7 Channels: {channels}",
      errors: {
        empty: "Choose at least one folder or channel."
      }
    },
    share: {
      title: "Share with an organisation",
      intro: "The invited organisation must accept. Its administrators then choose which of their members reach the space.",
      taxId: {
        label: "The organisation's tax ID",
        hint: "Enter the tax ID: the name of the organisation we find is then shown for you to check."
      },
      lookup: {
        loading: "Looking for the organisation\u2026",
        found: "Organisation found: {name}. Check that it is the one you want to invite.",
        notFound: "No BatiFlow organisation matches this tax ID. Check it, or ask your partner to create their account.",
        failed: "The search did not work. Try again in a moment."
      },
      cap: {
        label: "Maximum number of people",
        hint: "How many people this organisation may add to the space (1 to 500)."
      },
      end: {
        label: "End date (optional)",
        hint: "Leave empty: the access lasts until you remove it."
      },
      stepUpNote: "Sending the invitation asks you to confirm your identity.",
      submit: "Send the invitation",
      submitting: "Sending\u2026",
      sent: "Invitation sent to {name}. Access starts when the organisation accepts it.",
      errors: {
        taxIdRequired: "Enter the organisation's tax ID.",
        notConfirmed: "Wait until the organisation is found, or correct the tax ID.",
        capInvalid: "Enter a whole number of people between 1 and {max}.",
        endPast: "The end date cannot be in the past.",
        forbidden: "You are not allowed to share this space with another organisation."
      },
      directory: {
        open: "Search the directory",
        title: "Office directory",
        searchLabel: "Office name",
        results: "Offices in the directory",
        empty: "No office found in the directory.",
        loadFailed: "The directory could not be loaded. Try again in a moment.",
        more: "Show more",
        choose: "Choose",
        chooseLabel: "Choose {name}",
        chosen: "Office chosen in the directory: {name}.",
        change: "Change",
        gone: "This office is no longer in the directory. Choose another one or enter its tax id."
      }
    },
    person: {
      title: "Invite a person",
      intro: "Invite someone by e-mail address: a named person (from another organisation) or a guest.",
      email: {
        label: "E-mail address",
        hint: "The invitation is sent to this address. The address never appears in the link."
      },
      kind: {
        label: "Type of invitation",
        nominative: "Named person",
        guest: "Guest",
        nominativeHint: "A person from another organisation, with the access and end date you choose. Their organisation may have to approve.",
        guestHint: "A person without a BatiFlow account, limited to chosen folders or channels."
      },
      guestDuration: "A guest keeps their access for 90 days. You can then extend it by 90 days from the People tab.",
      end: {
        hint: "Leave empty: the access lasts until you remove it."
      },
      submit: "Send the invitation",
      submitting: "Sending\u2026",
      sent: "Invitation sent to {email}.",
      sentWaitingApproval: "Invitation saved for {email}. It waits for their organisation's approval before it is sent.",
      errors: {
        emailRequired: "Enter the person's e-mail address.",
        emailInvalid: "This e-mail address is not valid.",
        forbidden: "You are not allowed to invite people to this space.",
        guestLimit: "Your plan does not allow inviting more guests. Ask the account owner to move to a higher plan."
      }
    },
    partners: {
      heading: "Partner organisations",
      description: "The organisations this space is shared with, what they can reach and how many people they added.",
      share: "Share with an organisation",
      loadFailedTitle: "The partners could not be loaded",
      emptyTitle: "No partner organisation",
      emptyBody: "Share this space with another organisation: it chooses the people who access it.",
      members: "People: {active}/{cap}",
      removeLabel: "Remove the organisation {name} from the space",
      removeTitle: "Remove {name} from the space?",
      removeBody: "Everyone from this organisation loses access immediately. You can invite it again later.",
      removed: "{name} no longer has access to the space."
    },
    invitations: {
      heading: "Pending invitations",
      description: "People invited by e-mail who have not answered yet.",
      invite: "Invite a person",
      loadFailedTitle: "The invitations could not be loaded",
      emptyTitle: "No pending invitation",
      emptyBody: "Invitations sent to people appear here until they answer.",
      kind: {
        nominative: "Named person",
        guest: "Guest",
        organization: "Organisation"
      },
      expires: "To answer before {date}",
      cancel: "Cancel",
      cancelLabel: "Cancel the invitation of {who}",
      cancelTitle: "Cancel the invitation of {who}?",
      cancelBody: "The person can no longer use the link they received. You can invite them again.",
      cancelled: "The invitation is cancelled.",
      cancelConfirm: "Cancel the invitation"
    },
    people: {
      heading: "People with access",
      description: "Everyone who reaches this space, with the organisation they are here for.",
      listLabel: "People with access to the space",
      emptyTitle: "Nobody else has access to this space",
      emptyBody: "Host members, partner delegates and guests will appear here.",
      loadFailedTitle: "The people could not be loaded",
      organisation: "Organisation: {name}",
      extend: "Extend by 90 days",
      extendLabel: "Extend the access of {name} by 90 days",
      extended: "The access of {name} is extended until {date}.",
      removeLabel: "Remove {name} from the space",
      removeTitle: "Remove {name} from the space?",
      removeBody: "This person loses access immediately.",
      removed: "{name} no longer has access to the space."
    },
    delegates: {
      heading: "Manage my delegates",
      description: "The people of your organisation who reach this space. You choose who, within what your partnership allows.",
      usage: "People added: {active}/{cap}",
      capReached: "You have reached the maximum number of people of your partnership. Remove a delegate, or ask the host organisation to raise the limit.",
      emptyTitle: "No delegate yet",
      emptyBody: "Add members of your organisation so they can reach the space.",
      add: {
        open: "Add a member",
        title: "Add a member",
        intro: "People added: {active}/{cap}. They never get more than your partnership allows.",
        people: "Members of your organisation",
        peopleHint: "The people you choose reach the space of {name}, without seeing the rest of that organisation.",
        submit: "Give access",
        submitting: "Adding\u2026",
        done: "The people you chose now have access to the space.",
        errors: {
          peopleRequired: "Choose at least one person.",
          overCap: "You can only add {remaining} more person(s): the limit of your partnership.",
          forbidden: "You are not allowed to add people to this space."
        }
      },
      leave: {
        heading: "Leave the space",
        description: "End the partnership from your side: everyone in your organisation loses access.",
        button: "Leave the space",
        title: "Leave the space {name}?",
        body: "Everyone in your organisation will lose access to this space immediately. To come back, {host} will have to invite you again.",
        done: "You have left the space."
      }
    },
    audit: {
      heading: "Audit log",
      description: "Who did what in this space, and when. The host sees everything; a partner only sees what concerns its organisation.",
      emptyTitle: "No event yet",
      emptyBody: "Invitations, access and removals will appear here.",
      loadFailedTitle: "The log could not be loaded",
      columns: {
        date: "Date",
        actor: "Person",
        action: "Action",
        organisation: "Organisation concerned"
      },
      otherOrganisation: "Another organisation",
      system: "System",
      none: "\u2014",
      actions: {
        created: "Space created",
        updated: "Space settings changed",
        closed: "Space closed",
        partner_invited: "Partner organisation invited",
        partner_accepted: "Partnership invitation accepted",
        partner_declined: "Partnership invitation declined",
        partner_revoked: "Partner organisation removed",
        partner_expired: "Partnership expired",
        member_delegated: "Person added by a partner",
        member_joined: "Person joined the space",
        member_revoked: "A person's access removed",
        member_expired: "A person's access expired",
        member_extended: "A guest's access extended",
        invitation_created: "Invitation sent to a person",
        invitation_declined: "Invitation declined",
        invitation_revoked: "Invitation cancelled",
        approval_decided: "Decision on an approval request",
        other: "Other action ({action})",
        directory_updated: "Directory visibility changed",
        contact_received: "Message received from the directory"
      },
      more: "Load more",
      loading: "Loading\u2026"
    },
    close: {
      title: "Close the space",
      description: "End all outside access. Your organisation can still read the space.",
      button: "Close the space",
      confirmTitle: "Close the space {name}?",
      confirmIntro: "This cannot be undone:",
      effects: {
        access: "All partner organisations, their delegates, named people and guests lose access immediately.",
        readOnly: "The space becomes a read-only archive for your organisation: nothing can be added or changed.",
        export: "Partners cannot yet retrieve their own files: that feature comes in a later version."
      },
      confirm: "Close the space",
      done: "The space is closed. All outside access has ended.",
      errors: {
        forbidden: "Only the owner and the administrators can close a space."
      },
      stepUpNote: "Closing asks you to confirm your identity."
    },
    answers: {
      accept: "Accept",
      decline: "Decline",
      acceptLabel: "Accept the invitation to the space {space}",
      declineLabel: "Decline the invitation to the space {space}",
      declineTitle: "Decline the invitation to the space {space}?",
      declineBody: "You will not have access to this space. The host can invite you again.",
      declinePartnershipBody: "Your organisation will not join this space. The host can invite it again.",
      accepted: "You joined the space {space}.",
      partnershipAccepted: "Your organisation is now a partner of the space {space}. Now choose the people who reach it.",
      declined: "The invitation to the space {space} is declined."
    },
    incoming: {
      title: "Invitations to spaces",
      intro: "The invitations waiting for your answer: to you, or to an organisation you administer.",
      loadFailedTitle: "The invitations could not be loaded",
      emptyTitle: "No pending invitation",
      emptyBody: "When you are invited to a shared space, the invitation appears here.",
      seeSpaces: "See my shared spaces",
      sentence: {
        organization: "The organisation {organisation} is invited to become a partner of the space {space}, hosted by {host}.",
        nominative: "{who} invites you to join the space {space}, hosted by {host}.",
        guest: "{who} invites you as a guest to the space {space}, hosted by {host}.",
        nominativeNoName: "You are invited to join the space {space}, hosted by {host}.",
        guestNoName: "You are invited as a guest to the space {space}, hosted by {host}."
      },
      kind: {
        organization: "Partnership request",
        nominative: "Named invitation",
        guest: "Guest"
      },
      memberCap: "Up to {cap} people",
      answerBefore: "To answer before {date}",
      waiting: "{count, plural, one {# invitation is waiting for your answer.} other {# invitations are waiting for your answer.}}",
      seeInvitations: "See the invitations"
    },
    partnerships: {
      title: "Partnerships",
      intro: "The spaces of other organisations that your organisation is invited to or takes part in.",
      loadFailedTitle: "The partnerships could not be loaded",
      emptyTitle: "No partnership",
      emptyBody: "When another organisation invites you to share a space, the request appears here.",
      requestsHeading: "Partnership requests",
      requestsDescription: "Accept for your organisation to join the space; you then choose who reaches it.",
      noRequests: "No pending request.",
      activeHeading: "Active partnerships",
      activeDescription: "The spaces your organisation takes part in. Open one to manage your delegates.",
      noActive: "No active partnership.",
      endedHeading: "Ended partnerships",
      space: "Space: {space}",
      capUsage: "People: {active}/{cap}",
      manage: "Manage my delegates",
      manageLabel: "Manage my delegates in the space {space}"
    },
    approvals: {
      title: "External access approvals",
      intro: "A member of your organisation is invited to the space of another organisation. Your policy asks for an administrator's agreement before they can join.",
      deniedTitle: "You cannot decide here",
      deniedBody: "Only administrators allowed to approve external access see these requests.",
      loadFailedTitle: "The requests could not be loaded",
      emptyTitle: "No request to approve",
      emptyBody: "When a member of your organisation is invited to another organisation's space, the request appears here.",
      kind: {
        nominative: "Named invitation",
        guest: "Guest",
        organization: "Organisation"
      },
      email: "E-mail address: {email}",
      space: "Space {space}, hosted by {host}",
      invitedBy: "Invited by {name}",
      requestedOn: "Requested on {date}",
      answerBefore: "To handle before {date}",
      approve: "Approve",
      approveLabel: "Approve the access of {who}",
      refuse: "Refuse",
      refuseLabel: "Refuse the access of {who}",
      refuseTitle: "Refuse the access of {who}?",
      refuseBody: "The person will not join the space of {host}. The host can invite them again.",
      approved: "The access of {email} is approved.",
      refused: "The access is refused."
    }
  },
  meetings: {
    externalIntro: "Meetings hosted by {host}. Join them with one click while they are live."
  },
  synthesis: {
    ownNotice: "You only see what your office produces in this space. The lead office sees every office.",
    loadFailedTitle: "Could not load the synthesis",
    loadFailedBody: "Check your connection and try again.",
    noProjectTitle: "This space is not linked to a project",
    noProjectBody: "The synthesis and the matrix rely on the deliverables of a project. They will appear once the space is linked to a project.",
    unknownOffice: "Unknown office",
    roles: {
      host: "Lead office",
      partner: "Partner office"
    },
    kpis: {
      label: "Key figures",
      deliverables: "Deliverables",
      deliverablesAll: "All offices together",
      deliverablesOwn: "Assigned to your office",
      done: "Done",
      doneCaption: "Approved or transmitted",
      overdue: "Overdue",
      overdueCaption: "Past the due date, not approved yet",
      approvals: "Approvals in progress",
      approvalsCaption: "Open approval circuits",
      lateApprovals: "Late approvals",
      lateApprovalsCaption: "Approval due date passed"
    },
    offices: {
      title: "Progress by office",
      progress: "Deliverables of {office} by status",
      none: "No deliverable is assigned to this office yet.",
      onTime: "Nothing late",
      overdue: "{count, plural, one {# overdue deliverable} other {# overdue deliverables}}",
      lateApprovals: "{count, plural, one {# late approval} other {# late approvals}}",
      approvalsInProgress: "{count, plural, one {# approval in progress} other {# approvals in progress}}",
      rejected: "{count, plural, one {# rejected approval} other {# rejected approvals}}",
      total: "{count, plural, one {# deliverable} other {# deliverables}}"
    },
    legend: {
      toProduce: "To produce",
      inProgress: "In progress",
      inReview: "In review",
      done: "Done (approved or transmitted)"
    },
    late: {
      title: "Late",
      none: "Nothing is late: deliverables and approvals are on time.",
      deliverables: "Overdue deliverables",
      approvals: "Late approvals",
      columns: {
        title: "Deliverable",
        phase: "Phase",
        discipline: "Discipline",
        due: "Due date",
        office: "Office",
        document: "Document"
      },
      noDiscipline: "No discipline"
    },
    matrix: {
      title: "Who produces what",
      introEdit: "Choose the office responsible for each lot (discipline). A deliverable follows its lot unless you assign it to another office. Changes apply when you save.",
      introRead: "The office responsible for each lot and each deliverable, as set by the lead office.",
      introOwn: "Your deliverables, grouped by lot.",
      tableLabel: "Responsibilities by lot and by deliverable",
      scrollLabel: "Responsibilities table, scrolls horizontally",
      columns: {
        item: "Lots and deliverables",
        phase: "Phase",
        status: "Status",
        due: "Due date",
        office: "Responsible office",
        origin: "Source"
      },
      lot: "Lot",
      noDiscipline: "No discipline",
      count: "{count, plural, =0 {no deliverable} one {# deliverable} other {# deliverables}}",
      noDue: "No due date",
      overdue: "Overdue",
      statuses: {
        to_produce: "To produce",
        in_progress: "In progress",
        in_review: "In review",
        approved: "Approved",
        transmitted: "Transmitted"
      },
      origin: {
        deliverable: "Set on the deliverable",
        discipline: "From the lot",
        host: "Lead office by default",
        lot: "Set on the lot"
      },
      followLot: "Follow the lot",
      followHost: "Lead office by default",
      hostOffice: "{name} (lead office)",
      selectLot: "Office responsible for the {discipline} lot",
      selectDeliverable: "Office responsible for the deliverable {title}",
      save: "Save the matrix",
      saving: "Saving\u2026",
      discard: "Discard changes",
      pending: "{count, plural, one {# unsaved change} other {# unsaved changes}}",
      saved: "The responsibility matrix is saved.",
      errors: {
        notAnOffice: "Choose the lead office or an active partner office of this space.",
        unknownDeliverable: "One of the deliverables no longer belongs to the project of this space. The matrix was reloaded: make your changes again.",
        forbidden: "Only the managers of the lead office can change the matrix."
      },
      emptyTitle: "No deliverables yet",
      emptyBody: "Deliverables are added in the project's Deliverables tab. Once there are some, you will see here who produces them and how far along they are.",
      emptyBodyOwn: "No deliverable is assigned to your office yet. The lead office shares them out between the offices."
    }
  },
  groupement: {
    loadFailedTitle: "Could not load the groupement",
    loadFailedBody: "Check your connection and try again.",
    noProjectTitle: "This space is not linked to a project",
    noProjectBody: "The groupement shares the fees by phase of the project. It will be available once the space is linked to a project.",
    emptyHostTitle: "No groupement yet",
    emptyHostBody: "Describe how the fees are shared, phase by phase, between your office (the lead) and the co-contractor offices.",
    emptyOtherTitle: "The groupement is not set up yet",
    emptyOtherBody: "The lead office has not created the groupement of this space yet. You will see your share of the fees here as soon as it does.",
    create: "Create the groupement",
    edit: "Edit the groupement",
    recordPayment: "Record a payment",
    notices: {
      coContractor: "The fee split is visible only to the offices of the groupement. You only see the sums reversed to your office, not those of the other offices.",
      readOnly: "You can view the groupement but not change it."
    },
    roles: {
      lead: "Lead",
      co_contractor: "Co-contractor"
    },
    billingModes: {
      lead_only: "Single lead invoice",
      separate: "Separate invoices"
    },
    kpis: {
      label: "Groupement key figures",
      fees: "Total fees",
      feesCaption: "Agreed with the client",
      feesUnknown: "Not entered",
      feesUnknownCaption: "The sum due to each office cannot be calculated",
      received: "Received from the client",
      receivedCaption: "Payments recorded",
      redistributed: "Reversed to co-contractors",
      redistributedOwn: "Reversed to your office",
      redistributedCaption: "Sums the lead has already paid",
      billing: "Invoicing",
      billingCaption: {
        lead_only: "The lead invoices the client for everyone",
        separate: "Each office invoices its own share"
      }
    },
    members: {
      title: "Offices of the groupement",
      hidden: "The amounts of this office are not shared with you.",
      due: "Fees due",
      notComputed: "Not calculated",
      redistributed: "Reversed",
      leadKeeps: "The lead keeps its share: nothing is reversed to it.",
      progress: "{redistributed} reversed out of {due} due",
      overpaid: "More than due",
      settled: "Settled",
      needFees: "Enter the total fees to calculate the sum due."
    },
    shares: {
      title: "Fee split by phase",
      intro: "Each office's share of the fees of each phase.",
      noPhases: "The project has no phase yet.",
      scrollLabel: "Fee split table, scrolls sideways",
      tableLabel: "Office shares by phase",
      phase: "Phase",
      total: "Total",
      none: "\u2014",
      complete: "Complete",
      over: "Over 100%",
      empty: "Not shared out",
      partial: "{rest} not shared out"
    },
    payments: {
      title: "Payments",
      empty: "No payment recorded yet.",
      scrollLabel: "Payments table, scrolls sideways",
      tableLabel: "Groupement payments",
      columns: {
        date: "Date",
        kind: "Type",
        phase: "Phase",
        amount: "Amount",
        reference: "Reference",
        actions: "Actions"
      },
      received: "Received from the client",
      redistributed: "Reversed to {office}",
      allPhases: "All phases",
      noReference: "No reference",
      deleteLabel: "Delete the payment of {date} for {amount}",
      deleteTitle: "Delete this payment?",
      deleteBody: "The payment of {amount} on {date} will be removed from the groupement and the reversed sums will be recalculated.",
      deleted: "The payment is deleted."
    },
    paymentDialog: {
      title: "Record a payment",
      intro: "Note a payment the lead received from the client, or a sum reversed to a co-contractor.",
      kind: "Type of payment",
      kinds: {
        received: "Received from the client",
        redistributed: "Reversed to a co-contractor"
      },
      member: "Co-contractor",
      pickMember: "Choose an office",
      phase: "Phase (optional)",
      amount: "Amount",
      paidOn: "Payment date",
      reference: "Reference (transfer, cheque\u2026)",
      note: "Note (optional)",
      submit: "Record the payment",
      submitting: "Saving\u2026",
      saved: "The payment is recorded.",
      errors: {
        memberRequired: "Choose the co-contractor concerned.",
        amountRequired: "Enter an amount greater than zero.",
        dateRequired: "Enter the payment date."
      }
    },
    editor: {
      createTitle: "Create the groupement",
      editTitle: "Edit the groupement",
      intro: "Choose the invoicing mode and the co-contractors, then share the fees of each phase as percentages. For one phase, the shares cannot add up to more than 100%.",
      billing: "Invoicing mode",
      fees: "Total fees (optional)",
      feesHint: "Without this amount, the sum due to each office is not calculated.",
      coContractors: "Co-contractors",
      coContractorsHint: "The active partner offices of this space.",
      noPartners: 'No active partner office. First invite offices from the "Partner organisations" tab.',
      needOne: "Choose at least one co-contractor.",
      shares: "Shares by phase (%)",
      sharesHint: "For each phase, the total cannot exceed 100%. Whatever is left is simply not shared out.",
      noPhases: "The project has no phase yet: add some to share the fees.",
      pickFirst: "Choose the co-contractors first to share the fees.",
      sharesScroll: "Share entry table, scrolls sideways",
      sharesTable: "Office shares by phase",
      shareLabel: "Share of {office} for the phase {phase}, as a percentage",
      percentSuffix: "%",
      errors: {
        exceeds: 'Phase "{phase}": the total is {total}, it cannot exceed 100%.',
        invalid: "Enter a number between 0 and 100, with at most two decimals."
      },
      submit: "Save the groupement",
      submitting: "Saving\u2026",
      saved: "The groupement is saved.",
      created: "The groupement is created.",
      loadFailed: "Could not load the offices and the phases. Try again in a moment."
    },
    errors: {
      sharesExceed: "The shares of a phase add up to more than 100%. Correct them and try again.",
      stale: "The groupement was changed in the meantime. It has been reloaded: redo your changes.",
      forbidden: "Only the lead office's contract managers can change the groupement.",
      notAPartner: "One of the chosen offices is no longer an active partner of this space. Refresh the list.",
      notAMember: "A share is given to an office that is not part of the groupement.",
      unknownPhase: "One of the phases no longer exists in the project. Reload the page.",
      memberHasPayments: "A co-contractor that has received payments cannot be removed from the groupement.",
      notACoContractor: "This office is no longer a co-contractor of the groupement. Update the groupement first."
    }
  },
  exitExport: {
    title: "Closed spaces",
    intro: "You were a partner in these spaces. For 30 days after they close, you can take back your own uploads.",
    zipContent: "The ZIP only contains the files your office uploaded and the entries of the space's journal that concern it.",
    loadFailedTitle: "Could not load the closed spaces",
    hostedBy: "Hosted by {host}",
    closedOn: "Closed on {date}",
    until: "Export possible until {date}",
    noFiles: "No uploads from your office",
    files: "{count, plural, one {# file} other {# files}} \xB7 {size}",
    request: "Export my uploads",
    forSpace: "{action}: {space}",
    download: "Download the ZIP",
    readyUntil: "Available until {date}",
    working: "Preparing\u2026",
    failed: "The export could not be built",
    retry: "Try the export again",
    expired: "The last ZIP has expired",
    again: "Ask for a new export",
    late: "The export deadline has passed",
    requested: "Your export is being prepared.",
    errors: {
      request: "Could not ask for the export. Try again in a moment.",
      download: "Could not create the download link. Try again.",
      notReady: "The ZIP is not ready yet.",
      forbidden: "Only owners and administrators can ask for the export.",
      unavailable: "The export is no longer possible: the 30 days after the space closed are over."
    }
  }
};

// locales/fr/spaces.json
var spaces_default3 = {
  title: "Espaces partag\xE9s",
  intro: "Un espace partag\xE9 r\xE9unit des personnes de plusieurs organisations autour d'un projet ou d'un sujet commun.",
  tabs: {
    documents: "Documents",
    chat: "Conversations",
    calendar: "Calendrier",
    meetings: "R\xE9unions",
    people: "Personnes",
    partners: "Organisations partenaires",
    delegates: "Mes d\xE9l\xE9gu\xE9s",
    settings: "Param\xE8tres",
    audit: "Journal d'audit",
    synthesis: "Synth\xE8se",
    groupement: "Groupement"
  },
  kinds: {
    organization: "Espace de l'organisation",
    internal: "Espace de projet",
    shared: "Espace partag\xE9",
    group: "Groupe de travail"
  },
  status: {
    closed: "Ferm\xE9"
  },
  via: {
    host_member: "Membre de l'organisation h\xF4te",
    partner_delegation: "D\xE9l\xE9gu\xE9 par votre organisation",
    direct_invite: "Invitation nominative",
    guest: "Invit\xE9",
    partner_admin: "Administrateur de votre organisation partenaire"
  },
  rights: {
    read: "Lecture seule",
    write: "Lecture et \xE9criture",
    approve: "Lecture, \xE9criture et visa"
  },
  access: {
    via: "Acc\xE8s\xA0: {via}",
    rights: "Droits\xA0: {rights}",
    until: "Jusqu'au {date}",
    noEnd: "Sans date de fin"
  },
  page: {
    hostedBy: "H\xE9berg\xE9 par {host}",
    summaryLabel: "\xC0 propos de l'espace",
    closedNotice: "Cet espace est ferm\xE9\xA0: son contenu reste consultable en lecture seule.",
    notFoundTitle: "Espace introuvable",
    notFoundBody: "Cet espace n'existe pas ou vous n'y avez plus acc\xE8s. V\xE9rifiez le lien, ou demandez une nouvelle invitation \xE0 l'organisation qui l'h\xE9berge.",
    backToList: "Voir mes espaces partag\xE9s",
    loadFailedTitle: "Impossible de charger l'espace",
    loadFailedBody: "V\xE9rifiez votre connexion puis r\xE9essayez.",
    noTabsTitle: "Rien \xE0 afficher pour le moment",
    noTabsBody: "Votre acc\xE8s \xE0 cet espace ne donne encore acc\xE8s \xE0 aucun contenu. Contactez la personne qui vous a invit\xE9."
  },
  later: {
    calendar: {
      title: "Le calendrier de l'espace arrive bient\xF4t",
      description: "Les \xE9v\xE9nements et les rendez-vous de l'espace s'afficheront ici."
    },
    meetings: {
      title: "Les r\xE9unions de l'espace arrivent bient\xF4t",
      description: "Vous pourrez y lancer et rejoindre les r\xE9unions de l'espace."
    }
  },
  chat: {
    channelsLabel: "Canaux de l'espace",
    channelsHeading: "Canaux",
    loadFailed: "Impossible de charger les canaux. R\xE9essayez dans un instant.",
    empty: {
      title: "Aucun canal pour le moment",
      description: "Les canaux de cet espace, lorsqu'il y en aura, appara\xEEtront ici."
    },
    pick: {
      title: "Choisissez un canal",
      description: "S\xE9lectionnez un canal dans la liste pour lire et \xE9crire des messages."
    }
  },
  settings: {
    region: "Param\xE8tres de l'espace",
    general: {
      title: "G\xE9n\xE9ral",
      description: "Le nom sous lequel l'espace appara\xEEt pour tous ses participants."
    },
    name: {
      label: "Nom de l'espace"
    },
    policy: {
      title: "R\xE8gles de l'espace",
      description: "Ces r\xE8gles s'appliquent \xE0 tous les acc\xE8s \xE0 cet espace, y compris ceux des organisations partenaires et des invit\xE9s."
    },
    download: {
      label: "Autoriser le t\xE9l\xE9chargement",
      hint: "Sans t\xE9l\xE9chargement, les documents restent consultables en aper\xE7u."
    },
    watermark: {
      label: "Filigrane sur les PDF",
      hint: "Un filigrane identifie la personne qui consulte chaque PDF."
    },
    print: {
      label: "Autoriser l'impression",
      hint: "L'impression se fait depuis la visionneuse de documents."
    },
    domains: {
      label: "Domaines autoris\xE9s pour les invit\xE9s",
      hint: "Saisissez un domaine, par exemple client.tn, puis appuyez sur Entr\xE9e.",
      empty: "Aucun domaine\xA0: les invit\xE9s peuvent venir de toute adresse e-mail que la politique de votre organisation autorise."
    },
    save: "Enregistrer les param\xE8tres",
    saving: "Enregistrement\u2026",
    saved: "Les param\xE8tres de l'espace sont enregistr\xE9s.",
    noChange: "Aucune modification \xE0 enregistrer.",
    stepUpNote: "L'enregistrement demande de confirmer votre identit\xE9.",
    failedTitle: "Les param\xE8tres n'ont pas \xE9t\xE9 enregistr\xE9s",
    closedNotice: "Cet espace est ferm\xE9\xA0: ses param\xE8tres ne peuvent plus \xEAtre modifi\xE9s.",
    errors: {
      nameRequired: "Saisissez un nom pour l'espace.",
      nameTooLong: "Le nom ne peut pas d\xE9passer 200 caract\xE8res.",
      validation: "Certaines valeurs ne sont pas valides. V\xE9rifiez le nom et les domaines, puis r\xE9essayez.",
      forbidden: "Vous n'avez pas le droit de modifier les param\xE8tres de cet espace."
    }
  },
  list: {
    ownHeading: "Espaces de mes organisations",
    ownEmptyTitle: "Aucun espace partag\xE9 dans vos organisations",
    ownEmptyBody: "Cr\xE9ez un espace partag\xE9 pour travailler avec des partenaires, ou un groupe de travail pour vos \xE9quipes.",
    externalHeading: "Espaces externes",
    externalEmptyTitle: "Aucun espace externe",
    externalEmptyBody: "Les espaces d'autres organisations auxquels on vous donne acc\xE8s appara\xEEtront ici.",
    loadFailedTitle: "Impossible de charger vos espaces",
    loadFailedBody: "V\xE9rifiez votre connexion puis r\xE9essayez.",
    newSpace: "Nouvel espace partag\xE9",
    external: "Externe"
  },
  create: {
    title: "Nouvel espace partag\xE9",
    intro: "Vous serez le responsable de l'espace. Vous pourrez ensuite y inviter des organisations partenaires.",
    kind: {
      label: "Type d'espace",
      shared: {
        label: "Espace partag\xE9 d'un projet",
        hint: "Li\xE9 \xE0 l'un des projets dont vous \xEAtes responsable."
      },
      group: {
        label: "Groupe de travail",
        hint: "Sans projet associ\xE9. R\xE9serv\xE9 aux propri\xE9taires et aux administrateurs."
      }
    },
    project: {
      label: "Projet",
      placeholder: "Choisissez un projet",
      none: "Vous n'\xEAtes responsable d'aucun projet\xA0: un espace partag\xE9 doit \xEAtre li\xE9 \xE0 un projet que vous g\xE9rez."
    },
    name: {
      label: "Nom de l'espace"
    },
    submit: "Cr\xE9er l'espace",
    submitting: "Cr\xE9ation\u2026",
    created: "L'espace \xAB\xA0{name}\xA0\xBB est cr\xE9\xE9.",
    errors: {
      nameRequired: "Saisissez un nom pour l'espace.",
      nameTooLong: "Le nom ne peut pas d\xE9passer 200 caract\xE8res.",
      projectRequired: "Choisissez le projet auquel l'espace est li\xE9.",
      forbidden: "Vous n'avez pas le droit de cr\xE9er cet espace dans cette organisation.",
      planLimit: "Votre offre ne permet pas d'h\xE9berger davantage d'espaces partag\xE9s. Contactez le propri\xE9taire du compte pour passer \xE0 une offre sup\xE9rieure.",
      projectGone: "Ce projet n'existe plus ou vous n'en \xEAtes plus responsable. Choisissez-en un autre."
    }
  },
  listPane: {
    title: "Espaces partag\xE9s",
    label: "Mes espaces partag\xE9s",
    empty: "Aucun espace partag\xE9 pour le moment.",
    loadFailed: "Vos espaces partag\xE9s n'ont pas pu \xEAtre charg\xE9s.",
    external: "Externe",
    hostedBy: "H\xE9berg\xE9 par {host}",
    seeAll: "Tous les espaces partag\xE9s",
    count: "{count, plural, one {# espace partag\xE9} other {# espaces partag\xE9s}}"
  },
  guest: {
    expiry: "Votre acc\xE8s invit\xE9 se termine le {date}.",
    expirySoon: "Demandez \xE0 la personne qui vous a invit\xE9 de le prolonger si vous en avez encore besoin."
  },
  sharing: {
    remove: "Retirer",
    loadFailedBody: "V\xE9rifiez votre connexion puis r\xE9essayez.",
    errors: {
      forbidden: "Vous n'avez pas le droit d'effectuer cette action dans cet espace."
    },
    partnerStatus: {
      pending: "En attente de r\xE9ponse",
      active: "Actif",
      declined: "Refus\xE9",
      expired: "Expir\xE9",
      revoked: "Retir\xE9"
    },
    invitationStatus: {
      pending_approval: "En attente de l'approbation de son organisation",
      pending: "En attente de r\xE9ponse",
      accepted: "Accept\xE9e",
      declined: "Refus\xE9e",
      expired: "Expir\xE9e",
      revoked: "Annul\xE9e"
    },
    memberVia: {
      host_member: "Membre de l'h\xF4te",
      partner_delegation: "D\xE9l\xE9gu\xE9 partenaire",
      direct_invite: "Invit\xE9 nomm\xE9",
      guest: "Invit\xE9"
    },
    rightsOption: {
      label: "Droits",
      read: "Lecture : consulter les documents et les conversations",
      write: "\xC9criture : consulter, ajouter et modifier",
      approve: "\xC9criture et visa : en plus, viser les documents"
    },
    scope: {
      label: "Ce que l'acc\xE8s couvre",
      all: "Tout l'espace",
      some: "Seulement des dossiers et des canaux choisis",
      foldersLegend: "Dossiers",
      channelsLegend: "Canaux",
      subfoldersHint: "Un dossier choisi donne aussi acc\xE8s \xE0 ses sous-dossiers.",
      noFolders: "Aucun dossier \xE0 choisir pour le moment.",
      noChannels: "Aucun canal \xE0 choisir pour le moment.",
      foldersFailed: "Impossible de charger les dossiers. R\xE9essayez dans un instant.",
      channelsFailed: "Impossible de charger les canaux. R\xE9essayez dans un instant.",
      loading: "Chargement\u2026",
      unnamedChannel: "Canal sans nom",
      expand: "Afficher les sous-dossiers de {name}",
      collapse: "Masquer les sous-dossiers de {name}",
      summaryAll: "Tout l'espace",
      summarySome: "Dossiers : {folders} \xB7 Canaux : {channels}",
      errors: {
        empty: "Choisissez au moins un dossier ou un canal."
      }
    },
    share: {
      title: "Partager avec une organisation",
      intro: "L'organisation invit\xE9e devra accepter. Ses administrateurs choisiront ensuite qui, parmi ses membres, acc\xE8de \xE0 l'espace.",
      taxId: {
        label: "Matricule fiscal de l'organisation",
        hint: "Saisissez le matricule fiscal : le nom de l'organisation trouv\xE9e s'affiche ensuite pour que vous le v\xE9rifiiez."
      },
      lookup: {
        loading: "Recherche de l'organisation\u2026",
        found: "Organisation trouv\xE9e : {name}. V\xE9rifiez que c'est bien celle que vous voulez inviter.",
        notFound: "Aucune organisation BatiFlow ne correspond \xE0 ce matricule fiscal. V\xE9rifiez-le, ou demandez \xE0 votre partenaire de cr\xE9er son compte.",
        failed: "La recherche n'a pas abouti. R\xE9essayez dans un instant."
      },
      cap: {
        label: "Nombre maximum de personnes",
        hint: "Combien de personnes cette organisation peut ajouter \xE0 l'espace (de 1 \xE0 500)."
      },
      end: {
        label: "Date de fin (facultatif)",
        hint: "Laissez vide : l'acc\xE8s dure jusqu'\xE0 ce que vous le retiriez."
      },
      stepUpNote: "L'envoi de l'invitation demande de confirmer votre identit\xE9.",
      submit: "Envoyer l'invitation",
      submitting: "Envoi\u2026",
      sent: "Invitation envoy\xE9e \xE0 {name}. L'acc\xE8s commence quand l'organisation l'accepte.",
      errors: {
        taxIdRequired: "Saisissez le matricule fiscal de l'organisation.",
        notConfirmed: "Attendez que l'organisation soit trouv\xE9e, ou corrigez le matricule fiscal.",
        capInvalid: "Indiquez un nombre entier de personnes entre 1 et {max}.",
        endPast: "La date de fin ne peut pas \xEAtre dans le pass\xE9.",
        forbidden: "Vous n'avez pas le droit de partager cet espace avec une autre organisation."
      },
      directory: {
        open: "Chercher dans l'annuaire",
        title: "Annuaire des bureaux",
        searchLabel: "Nom du bureau",
        results: "Bureaux de l'annuaire",
        empty: "Aucun bureau trouv\xE9 dans l'annuaire.",
        loadFailed: "L'annuaire n'a pas pu \xEAtre charg\xE9. R\xE9essayez dans un instant.",
        more: "Afficher plus",
        choose: "Choisir",
        chooseLabel: "Choisir {name}",
        chosen: "Bureau choisi dans l'annuaire\xA0: {name}.",
        change: "Changer",
        gone: "Ce bureau n'est plus dans l'annuaire. Choisissez-en un autre ou saisissez son matricule fiscal."
      }
    },
    person: {
      title: "Inviter une personne",
      intro: "Invitez quelqu'un par son adresse e-mail : une personne nomm\xE9e (d'une autre organisation) ou un invit\xE9.",
      email: {
        label: "Adresse e-mail",
        hint: "L'invitation est envoy\xE9e \xE0 cette adresse. L'adresse n'appara\xEEt jamais dans le lien."
      },
      kind: {
        label: "Type d'invitation",
        nominative: "Personne nomm\xE9e",
        guest: "Invit\xE9",
        nominativeHint: "Une personne d'une autre organisation, avec l'acc\xE8s et la date de fin que vous choisissez. Son organisation peut devoir l'approuver.",
        guestHint: "Une personne sans compte BatiFlow, limit\xE9e \xE0 des dossiers ou des canaux choisis."
      },
      guestDuration: "Un invit\xE9 garde son acc\xE8s 90 jours. Vous pouvez ensuite le prolonger de 90 jours depuis l'onglet Personnes.",
      end: {
        hint: "Laissez vide : l'acc\xE8s dure jusqu'\xE0 ce que vous le retiriez."
      },
      submit: "Envoyer l'invitation",
      submitting: "Envoi\u2026",
      sent: "Invitation envoy\xE9e \xE0 {email}.",
      sentWaitingApproval: "Invitation enregistr\xE9e pour {email}. Elle attend l'approbation de son organisation avant d'\xEAtre envoy\xE9e.",
      errors: {
        emailRequired: "Saisissez l'adresse e-mail de la personne.",
        emailInvalid: "Cette adresse e-mail n'est pas valide.",
        forbidden: "Vous n'avez pas le droit d'inviter des personnes dans cet espace.",
        guestLimit: "Votre offre ne permet pas d'inviter davantage de personnes comme invit\xE9s. Contactez le propri\xE9taire du compte pour passer \xE0 une offre sup\xE9rieure."
      }
    },
    partners: {
      heading: "Organisations partenaires",
      description: "Les organisations avec lesquelles cet espace est partag\xE9, ce qu'elles peuvent atteindre et combien de personnes elles y ont ajout\xE9.",
      share: "Partager avec une organisation",
      loadFailedTitle: "Impossible de charger les partenaires",
      emptyTitle: "Aucune organisation partenaire",
      emptyBody: "Partagez cet espace avec une autre organisation : elle choisira elle-m\xEAme les personnes qui y acc\xE8dent.",
      members: "Personnes : {active}/{cap}",
      removeLabel: "Retirer l'organisation {name} de l'espace",
      removeTitle: "Retirer {name} de l'espace ?",
      removeBody: "Tous les acc\xE8s des personnes de cette organisation prennent fin imm\xE9diatement. Vous pourrez la r\xE9inviter plus tard.",
      removed: "{name} n'a plus acc\xE8s \xE0 l'espace."
    },
    invitations: {
      heading: "Invitations en attente",
      description: "Les personnes invit\xE9es par e-mail qui n'ont pas encore r\xE9pondu.",
      invite: "Inviter une personne",
      loadFailedTitle: "Impossible de charger les invitations",
      emptyTitle: "Aucune invitation en attente",
      emptyBody: "Les invitations envoy\xE9es \xE0 des personnes apparaissent ici jusqu'\xE0 leur r\xE9ponse.",
      kind: {
        nominative: "Personne nomm\xE9e",
        guest: "Invit\xE9",
        organization: "Organisation"
      },
      expires: "\xC0 r\xE9pondre avant le {date}",
      cancel: "Annuler",
      cancelLabel: "Annuler l'invitation de {who}",
      cancelTitle: "Annuler l'invitation de {who} ?",
      cancelBody: "La personne ne pourra plus utiliser le lien re\xE7u. Vous pourrez l'inviter de nouveau.",
      cancelled: "L'invitation est annul\xE9e.",
      cancelConfirm: "Annuler l'invitation"
    },
    people: {
      heading: "Personnes ayant acc\xE8s",
      description: "Toutes les personnes qui acc\xE8dent \xE0 cet espace, avec l'organisation au nom de laquelle elles y sont.",
      listLabel: "Personnes ayant acc\xE8s \xE0 l'espace",
      emptyTitle: "Personne d'autre n'a acc\xE8s \xE0 cet espace",
      emptyBody: "Les membres de l'h\xF4te, les d\xE9l\xE9gu\xE9s des partenaires et les invit\xE9s appara\xEEtront ici.",
      loadFailedTitle: "Impossible de charger les personnes",
      organisation: "Organisation : {name}",
      extend: "Prolonger de 90 jours",
      extendLabel: "Prolonger de 90 jours l'acc\xE8s de {name}",
      extended: "L'acc\xE8s de {name} est prolong\xE9 jusqu'au {date}.",
      removeLabel: "Retirer {name} de l'espace",
      removeTitle: "Retirer {name} de l'espace ?",
      removeBody: "L'acc\xE8s de cette personne prend fin imm\xE9diatement.",
      removed: "{name} n'a plus acc\xE8s \xE0 l'espace."
    },
    delegates: {
      heading: "G\xE9rer mes d\xE9l\xE9gu\xE9s",
      description: "Les personnes de votre organisation qui acc\xE8dent \xE0 cet espace. Vous choisissez qui, dans ce que votre partenariat permet.",
      usage: "Personnes ajout\xE9es : {active}/{cap}",
      capReached: "Vous avez atteint le nombre maximum de personnes de votre partenariat. Retirez un d\xE9l\xE9gu\xE9, ou demandez \xE0 l'organisation h\xF4te d'augmenter la limite.",
      emptyTitle: "Aucun d\xE9l\xE9gu\xE9 pour le moment",
      emptyBody: "Ajoutez des membres de votre organisation pour qu'ils acc\xE8dent \xE0 l'espace.",
      add: {
        open: "Ajouter un membre",
        title: "Ajouter un membre",
        intro: "Personnes ajout\xE9es : {active}/{cap}. Elles n'auront jamais plus que ce que votre partenariat permet.",
        people: "Membres de votre organisation",
        peopleHint: "Les personnes choisies acc\xE8dent \xE0 l'espace de {name}, sans voir le reste de cette organisation.",
        submit: "Donner l'acc\xE8s",
        submitting: "Ajout\u2026",
        done: "Les personnes choisies ont maintenant acc\xE8s \xE0 l'espace.",
        errors: {
          peopleRequired: "Choisissez au moins une personne.",
          overCap: "Vous ne pouvez plus ajouter que {remaining} personne(s) : limite de votre partenariat.",
          forbidden: "Vous n'avez pas le droit d'ajouter des personnes \xE0 cet espace."
        }
      },
      leave: {
        heading: "Quitter l'espace",
        description: "Mettez fin au partenariat de votre c\xF4t\xE9 : toutes les personnes de votre organisation perdent leur acc\xE8s.",
        button: "Quitter l'espace",
        title: "Quitter l'espace {name} ?",
        body: "Toutes les personnes de votre organisation perdront imm\xE9diatement l'acc\xE8s \xE0 cet espace. Pour revenir, {host} devra vous inviter de nouveau.",
        done: "Vous avez quitt\xE9 l'espace."
      }
    },
    audit: {
      heading: "Journal d'audit",
      description: "Qui a fait quoi dans cet espace, et quand. L'h\xF4te voit tout ; un partenaire ne voit que ce qui concerne son organisation.",
      emptyTitle: "Aucun \xE9v\xE9nement pour le moment",
      emptyBody: "Les invitations, les acc\xE8s et les retraits appara\xEEtront ici.",
      loadFailedTitle: "Impossible de charger le journal",
      columns: {
        date: "Date",
        actor: "Personne",
        action: "Action",
        organisation: "Organisation concern\xE9e"
      },
      otherOrganisation: "Autre organisation",
      system: "Syst\xE8me",
      none: "\u2014",
      actions: {
        created: "Espace cr\xE9\xE9",
        updated: "Param\xE8tres de l'espace modifi\xE9s",
        closed: "Espace ferm\xE9",
        partner_invited: "Organisation partenaire invit\xE9e",
        partner_accepted: "Invitation de partenariat accept\xE9e",
        partner_declined: "Invitation de partenariat refus\xE9e",
        partner_revoked: "Organisation partenaire retir\xE9e",
        partner_expired: "Partenariat expir\xE9",
        member_delegated: "Personne ajout\xE9e par un partenaire",
        member_joined: "Personne arriv\xE9e dans l'espace",
        member_revoked: "Acc\xE8s d'une personne retir\xE9",
        member_expired: "Acc\xE8s d'une personne expir\xE9",
        member_extended: "Acc\xE8s d'un invit\xE9 prolong\xE9",
        invitation_created: "Invitation envoy\xE9e \xE0 une personne",
        invitation_declined: "Invitation refus\xE9e",
        invitation_revoked: "Invitation annul\xE9e",
        approval_decided: "D\xE9cision sur une demande d'approbation",
        other: "Autre action ({action})",
        directory_updated: "Visibilit\xE9 dans l'annuaire modifi\xE9e",
        contact_received: "Message re\xE7u depuis l'annuaire"
      },
      more: "Charger plus",
      loading: "Chargement\u2026"
    },
    close: {
      title: "Fermer l'espace",
      description: "Mettez fin \xE0 tous les acc\xE8s ext\xE9rieurs. L'espace reste consultable en lecture seule par votre organisation.",
      button: "Fermer l'espace",
      confirmTitle: "Fermer l'espace {name} ?",
      confirmIntro: "Cette action est d\xE9finitive :",
      effects: {
        access: "Toutes les organisations partenaires, leurs d\xE9l\xE9gu\xE9s, les personnes nomm\xE9es et les invit\xE9s perdent imm\xE9diatement leur acc\xE8s.",
        readOnly: "L'espace devient une archive en lecture seule pour votre organisation : plus aucun ajout ni aucune modification.",
        export: "Les partenaires ne pourront pas encore r\xE9cup\xE9rer leurs propres fichiers : cette fonction arrive dans une prochaine version."
      },
      confirm: "Fermer l'espace",
      done: "L'espace est ferm\xE9. Tous les acc\xE8s ext\xE9rieurs ont pris fin.",
      errors: {
        forbidden: "Seuls le propri\xE9taire et les administrateurs peuvent fermer un espace."
      },
      stepUpNote: "La fermeture demande de confirmer votre identit\xE9."
    },
    answers: {
      accept: "Accepter",
      decline: "Refuser",
      acceptLabel: "Accepter l'invitation \xE0 l'espace {space}",
      declineLabel: "Refuser l'invitation \xE0 l'espace {space}",
      declineTitle: "Refuser l'invitation \xE0 l'espace {space} ?",
      declineBody: "Vous n'aurez pas acc\xE8s \xE0 cet espace. L'h\xF4te pourra vous inviter de nouveau.",
      declinePartnershipBody: "Votre organisation ne rejoindra pas cet espace. L'h\xF4te pourra l'inviter de nouveau.",
      accepted: "Vous avez rejoint l'espace {space}.",
      partnershipAccepted: "Votre organisation est partenaire de l'espace {space}. Choisissez maintenant les personnes qui y acc\xE8dent.",
      declined: "L'invitation \xE0 l'espace {space} est refus\xE9e."
    },
    incoming: {
      title: "Invitations \xE0 des espaces",
      intro: "Les invitations qui attendent votre r\xE9ponse : \xE0 vous-m\xEAme, ou \xE0 une organisation que vous administrez.",
      loadFailedTitle: "Impossible de charger les invitations",
      emptyTitle: "Aucune invitation en attente",
      emptyBody: "Quand on vous invite \xE0 un espace partag\xE9, l'invitation appara\xEEt ici.",
      seeSpaces: "Voir mes espaces partag\xE9s",
      sentence: {
        organization: "L'organisation {organisation} est invit\xE9e \xE0 devenir partenaire de l'espace {space}, h\xE9berg\xE9 par {host}.",
        nominative: "{who} vous invite \xE0 rejoindre l'espace {space}, h\xE9berg\xE9 par {host}.",
        guest: "{who} vous invite comme invit\xE9 dans l'espace {space}, h\xE9berg\xE9 par {host}.",
        nominativeNoName: "Vous \xEAtes invit\xE9 \xE0 rejoindre l'espace {space}, h\xE9berg\xE9 par {host}.",
        guestNoName: "Vous \xEAtes invit\xE9 comme invit\xE9 dans l'espace {space}, h\xE9berg\xE9 par {host}."
      },
      kind: {
        organization: "Demande de partenariat",
        nominative: "Invitation nominative",
        guest: "Invit\xE9"
      },
      memberCap: "Jusqu'\xE0 {cap} personnes",
      answerBefore: "\xC0 r\xE9pondre avant le {date}",
      waiting: "{count, plural, one {# invitation attend votre r\xE9ponse.} other {# invitations attendent votre r\xE9ponse.}}",
      seeInvitations: "Voir les invitations"
    },
    partnerships: {
      title: "Partenariats",
      intro: "Les espaces d'autres organisations auxquels votre organisation est invit\xE9e ou participe.",
      loadFailedTitle: "Impossible de charger les partenariats",
      emptyTitle: "Aucun partenariat",
      emptyBody: "Quand une autre organisation vous invite \xE0 partager un espace, la demande appara\xEEt ici.",
      requestsHeading: "Demandes de partenariat",
      requestsDescription: "Acceptez pour que votre organisation rejoigne l'espace ; vous choisirez ensuite qui y acc\xE8de.",
      noRequests: "Aucune demande en attente.",
      activeHeading: "Partenariats actifs",
      activeDescription: "Les espaces auxquels votre organisation participe. Ouvrez-en un pour g\xE9rer vos d\xE9l\xE9gu\xE9s.",
      noActive: "Aucun partenariat actif.",
      endedHeading: "Partenariats termin\xE9s",
      space: "Espace : {space}",
      capUsage: "Personnes : {active}/{cap}",
      manage: "G\xE9rer mes d\xE9l\xE9gu\xE9s",
      manageLabel: "G\xE9rer mes d\xE9l\xE9gu\xE9s dans l'espace {space}"
    },
    approvals: {
      title: "Approbations d'acc\xE8s externe",
      intro: "Un membre de votre organisation est invit\xE9 dans l'espace d'une autre organisation. Votre politique demande l'accord d'un administrateur avant qu'il puisse le rejoindre.",
      deniedTitle: "Vous ne pouvez pas d\xE9cider ici",
      deniedBody: "Seuls les administrateurs autoris\xE9s \xE0 approuver les acc\xE8s externes voient ces demandes.",
      loadFailedTitle: "Impossible de charger les demandes",
      emptyTitle: "Aucune demande \xE0 approuver",
      emptyBody: "Quand un membre de votre organisation est invit\xE9 dans l'espace d'une autre organisation, la demande appara\xEEt ici.",
      kind: {
        nominative: "Invitation nominative",
        guest: "Invit\xE9",
        organization: "Organisation"
      },
      email: "Adresse e-mail : {email}",
      space: "Espace {space}, h\xE9berg\xE9 par {host}",
      invitedBy: "Invit\xE9 par {name}",
      requestedOn: "Demand\xE9 le {date}",
      answerBefore: "\xC0 traiter avant le {date}",
      approve: "Approuver",
      approveLabel: "Approuver l'acc\xE8s de {who}",
      refuse: "Refuser",
      refuseLabel: "Refuser l'acc\xE8s de {who}",
      refuseTitle: "Refuser l'acc\xE8s de {who} ?",
      refuseBody: "La personne ne rejoindra pas l'espace de {host}. L'h\xF4te pourra l'inviter de nouveau.",
      approved: "L'acc\xE8s de {email} est approuv\xE9.",
      refused: "L'acc\xE8s est refus\xE9."
    }
  },
  meetings: {
    externalIntro: "R\xE9unions organis\xE9es par {host}. Rejoignez-les d\u2019un clic lorsqu\u2019elles sont en cours."
  },
  synthesis: {
    ownNotice: "Vous ne voyez ici que ce que votre bureau produit dans cet espace. Le mandataire voit l'ensemble des bureaux.",
    loadFailedTitle: "Impossible de charger la synth\xE8se",
    loadFailedBody: "V\xE9rifiez votre connexion puis r\xE9essayez.",
    noProjectTitle: "Cet espace n'est pas li\xE9 \xE0 un projet",
    noProjectBody: "La synth\xE8se et la matrice se fondent sur les livrables d'un projet. Elles appara\xEEtront d\xE8s que l'espace sera li\xE9 \xE0 un projet.",
    unknownOffice: "Bureau inconnu",
    roles: {
      host: "Mandataire",
      partner: "Bureau partenaire"
    },
    kpis: {
      label: "Chiffres cl\xE9s",
      deliverables: "Livrables",
      deliverablesAll: "Tous les bureaux confondus",
      deliverablesOwn: "Confi\xE9s \xE0 votre bureau",
      done: "Termin\xE9s",
      doneCaption: "Approuv\xE9s ou transmis",
      overdue: "En retard",
      overdueCaption: "\xC9ch\xE9ance d\xE9pass\xE9e, pas encore approuv\xE9s",
      approvals: "Visas en cours",
      approvalsCaption: "Circuits de visa ouverts",
      lateApprovals: "Visas en retard",
      lateApprovalsCaption: "\xC9ch\xE9ance du visa d\xE9pass\xE9e"
    },
    offices: {
      title: "Avancement par bureau",
      progress: "Livrables de {office} par statut",
      none: "Aucun livrable n'est confi\xE9 \xE0 ce bureau pour le moment.",
      onTime: "Rien en retard",
      overdue: "{count, plural, one {# livrable en retard} other {# livrables en retard}}",
      lateApprovals: "{count, plural, one {# visa en retard} other {# visas en retard}}",
      approvalsInProgress: "{count, plural, one {# visa en cours} other {# visas en cours}}",
      rejected: "{count, plural, one {# visa refus\xE9} other {# visas refus\xE9s}}",
      total: "{count, plural, one {# livrable} other {# livrables}}"
    },
    legend: {
      toProduce: "\xC0 produire",
      inProgress: "En cours",
      inReview: "En revue",
      done: "Termin\xE9s (approuv\xE9s ou transmis)"
    },
    late: {
      title: "En retard",
      none: "Aucun retard : les livrables et les visas sont dans les temps.",
      deliverables: "Livrables en retard",
      approvals: "Visas en retard",
      columns: {
        title: "Livrable",
        phase: "Phase",
        discipline: "Discipline",
        due: "\xC9ch\xE9ance",
        office: "Bureau",
        document: "Document"
      },
      noDiscipline: "Sans discipline"
    },
    matrix: {
      title: "Qui produit quoi",
      introEdit: "Choisissez le bureau responsable de chaque lot (discipline). Un livrable suit son lot, sauf si vous le confiez \xE0 un autre bureau. Les changements s'appliquent quand vous enregistrez.",
      introRead: "Le bureau responsable de chaque lot et de chaque livrable, tel que le mandataire l'a fix\xE9.",
      introOwn: "Vos livrables, rang\xE9s par lot.",
      tableLabel: "Responsabilit\xE9s par lot et par livrable",
      scrollLabel: "Tableau des responsabilit\xE9s, d\xE9filement horizontal",
      columns: {
        item: "Lot et livrables",
        phase: "Phase",
        status: "Statut",
        due: "\xC9ch\xE9ance",
        office: "Bureau responsable",
        origin: "Origine"
      },
      lot: "Lot",
      noDiscipline: "Sans discipline",
      count: "{count, plural, =0 {aucun livrable} one {# livrable} other {# livrables}}",
      noDue: "Sans \xE9ch\xE9ance",
      overdue: "En retard",
      statuses: {
        to_produce: "\xC0 produire",
        in_progress: "En cours",
        in_review: "En revue",
        approved: "Approuv\xE9",
        transmitted: "Transmis"
      },
      origin: {
        deliverable: "Attribu\xE9 au livrable",
        discipline: "Selon le lot",
        host: "Mandataire par d\xE9faut",
        lot: "Attribu\xE9 au lot"
      },
      followLot: "Selon le lot",
      followHost: "Mandataire par d\xE9faut",
      hostOffice: "{name} (mandataire)",
      selectLot: "Bureau responsable du lot {discipline}",
      selectDeliverable: "Bureau responsable du livrable {title}",
      save: "Enregistrer la matrice",
      saving: "Enregistrement\u2026",
      discard: "Annuler les changements",
      pending: "{count, plural, one {# changement non enregistr\xE9} other {# changements non enregistr\xE9s}}",
      saved: "La matrice des responsabilit\xE9s est enregistr\xE9e.",
      errors: {
        notAnOffice: "Choisissez le mandataire ou un bureau partenaire actif de cet espace.",
        unknownDeliverable: "Un des livrables n'appartient plus au projet de cet espace. La matrice a \xE9t\xE9 recharg\xE9e : refaites vos changements.",
        forbidden: "Seuls les responsables du bureau mandataire peuvent modifier la matrice."
      },
      emptyTitle: "Aucun livrable pour le moment",
      emptyBody: "Les livrables s'ajoutent dans l'onglet Livrables du projet. D\xE8s qu'il y en a, vous verrez ici qui les produit et o\xF9 ils en sont.",
      emptyBodyOwn: "Aucun livrable n'est confi\xE9 \xE0 votre bureau pour le moment. Le mandataire les r\xE9partit entre les bureaux."
    }
  },
  groupement: {
    loadFailedTitle: "Impossible de charger le groupement",
    loadFailedBody: "V\xE9rifiez votre connexion puis r\xE9essayez.",
    noProjectTitle: "Cet espace n'est pas li\xE9 \xE0 un projet",
    noProjectBody: "Le groupement r\xE9partit les honoraires par phase du projet. Il sera disponible d\xE8s que l'espace sera li\xE9 \xE0 un projet.",
    emptyHostTitle: "Aucun groupement pour le moment",
    emptyHostBody: "D\xE9crivez comment les honoraires sont r\xE9partis, phase par phase, entre votre bureau (le mandataire) et les bureaux co-traitants.",
    emptyOtherTitle: "Le groupement n'est pas encore d\xE9fini",
    emptyOtherBody: "Le bureau mandataire n'a pas encore cr\xE9\xE9 le groupement de cet espace. Vous y verrez votre part des honoraires d\xE8s qu'il l'aura fait.",
    create: "Cr\xE9er le groupement",
    edit: "Modifier le groupement",
    recordPayment: "Enregistrer un paiement",
    notices: {
      coContractor: "La r\xE9partition des honoraires n'est visible que par les bureaux du groupement. Vous ne voyez que les sommes revers\xE9es \xE0 votre bureau, pas celles des autres bureaux.",
      readOnly: "Vous pouvez consulter le groupement, mais pas le modifier."
    },
    roles: {
      lead: "Mandataire",
      co_contractor: "Co-traitant"
    },
    billingModes: {
      lead_only: "Mandataire unique",
      separate: "Factures s\xE9par\xE9es"
    },
    kpis: {
      label: "Chiffres cl\xE9s du groupement",
      fees: "Honoraires totaux",
      feesCaption: "Convenus avec le ma\xEEtre d'ouvrage",
      feesUnknown: "Non renseign\xE9s",
      feesUnknownCaption: "La somme due \xE0 chaque bureau ne peut pas \xEAtre calcul\xE9e",
      received: "Re\xE7u du ma\xEEtre d'ouvrage",
      receivedCaption: "Paiements enregistr\xE9s",
      redistributed: "Revers\xE9 aux co-traitants",
      redistributedOwn: "Revers\xE9 \xE0 votre bureau",
      redistributedCaption: "Sommes d\xE9j\xE0 pay\xE9es par le mandataire",
      billing: "Facturation",
      billingCaption: {
        lead_only: "Le mandataire facture le ma\xEEtre d'ouvrage pour tous",
        separate: "Chaque bureau facture sa part"
      }
    },
    members: {
      title: "Bureaux du groupement",
      hidden: "Les montants de ce bureau ne vous sont pas communiqu\xE9s.",
      due: "Honoraires dus",
      notComputed: "Non calcul\xE9s",
      redistributed: "Revers\xE9",
      leadKeeps: "Le mandataire garde sa part : rien ne lui est revers\xE9.",
      progress: "{redistributed} revers\xE9s sur {due} dus",
      overpaid: "Plus que pr\xE9vu",
      settled: "Sold\xE9",
      needFees: "Renseignez les honoraires totaux pour calculer la somme due."
    },
    shares: {
      title: "R\xE9partition des honoraires par phase",
      intro: "Part de chaque bureau dans les honoraires de chaque phase.",
      noPhases: "Le projet n'a pas encore de phase.",
      scrollLabel: "Tableau de r\xE9partition des honoraires, d\xE9filement horizontal",
      tableLabel: "Parts des bureaux par phase",
      phase: "Phase",
      total: "Total",
      none: "\u2014",
      complete: "Complet",
      over: "D\xE9passe 100 %",
      empty: "Non r\xE9parti",
      partial: "{rest} non r\xE9parti"
    },
    payments: {
      title: "Paiements",
      empty: "Aucun paiement enregistr\xE9 pour le moment.",
      scrollLabel: "Tableau des paiements, d\xE9filement horizontal",
      tableLabel: "Paiements du groupement",
      columns: {
        date: "Date",
        kind: "Type",
        phase: "Phase",
        amount: "Montant",
        reference: "R\xE9f\xE9rence",
        actions: "Actions"
      },
      received: "Re\xE7u du ma\xEEtre d'ouvrage",
      redistributed: "Revers\xE9 \xE0 {office}",
      allPhases: "Toutes les phases",
      noReference: "Sans r\xE9f\xE9rence",
      deleteLabel: "Supprimer le paiement du {date} de {amount}",
      deleteTitle: "Supprimer ce paiement ?",
      deleteBody: "Le paiement de {amount} du {date} sera retir\xE9 du groupement et les sommes revers\xE9es seront recalcul\xE9es.",
      deleted: "Le paiement est supprim\xE9."
    },
    paymentDialog: {
      title: "Enregistrer un paiement",
      intro: "Notez un paiement re\xE7u du ma\xEEtre d'ouvrage par le mandataire, ou une somme revers\xE9e \xE0 un co-traitant.",
      kind: "Type de paiement",
      kinds: {
        received: "Re\xE7u du ma\xEEtre d'ouvrage",
        redistributed: "Revers\xE9 \xE0 un co-traitant"
      },
      member: "Co-traitant",
      pickMember: "Choisir un bureau",
      phase: "Phase (facultatif)",
      amount: "Montant",
      paidOn: "Date du paiement",
      reference: "R\xE9f\xE9rence (virement, ch\xE8que\u2026)",
      note: "Note (facultatif)",
      submit: "Enregistrer le paiement",
      submitting: "Enregistrement\u2026",
      saved: "Le paiement est enregistr\xE9.",
      errors: {
        memberRequired: "Choisissez le co-traitant concern\xE9.",
        amountRequired: "Saisissez un montant sup\xE9rieur \xE0 z\xE9ro.",
        dateRequired: "Indiquez la date du paiement."
      }
    },
    editor: {
      createTitle: "Cr\xE9er le groupement",
      editTitle: "Modifier le groupement",
      intro: "Choisissez le mode de facturation et les co-traitants, puis r\xE9partissez les honoraires de chaque phase en pourcentage. Pour une m\xEAme phase, le total des parts ne peut pas d\xE9passer 100 %.",
      billing: "Mode de facturation",
      fees: "Honoraires totaux (facultatif)",
      feesHint: "Sans ce montant, la somme due \xE0 chaque bureau n'est pas calcul\xE9e.",
      coContractors: "Co-traitants",
      coContractorsHint: "Les bureaux partenaires actifs de cet espace.",
      noPartners: "Aucun bureau partenaire actif. Invitez d'abord des bureaux depuis l'onglet \xAB Organisations partenaires \xBB.",
      needOne: "Choisissez au moins un co-traitant.",
      shares: "Parts par phase (en %)",
      sharesHint: "Pour chaque phase, le total ne d\xE9passe pas 100 %. Ce qui reste est simplement non r\xE9parti.",
      noPhases: "Le projet n'a pas encore de phase : ajoutez-en pour r\xE9partir les honoraires.",
      pickFirst: "Choisissez d'abord les co-traitants pour r\xE9partir les parts.",
      sharesScroll: "Tableau de saisie des parts, d\xE9filement horizontal",
      sharesTable: "Parts des bureaux par phase",
      shareLabel: "Part de {office} pour la phase {phase}, en pourcentage",
      percentSuffix: "%",
      errors: {
        exceeds: "Phase \xAB {phase} \xBB : le total est de {total}, il ne doit pas d\xE9passer 100 %.",
        invalid: "Saisissez un nombre entre 0 et 100, avec deux d\xE9cimales au plus."
      },
      submit: "Enregistrer le groupement",
      submitting: "Enregistrement\u2026",
      saved: "Le groupement est enregistr\xE9.",
      created: "Le groupement est cr\xE9\xE9.",
      loadFailed: "Impossible de charger les bureaux et les phases. R\xE9essayez dans un instant."
    },
    errors: {
      sharesExceed: "Le total des parts d'une phase d\xE9passe 100 %. Corrigez les parts puis r\xE9essayez.",
      stale: "Le groupement a \xE9t\xE9 modifi\xE9 entre-temps. Il a \xE9t\xE9 recharg\xE9 : refaites vos changements.",
      forbidden: "Seuls les responsables des contrats du bureau mandataire peuvent modifier le groupement.",
      notAPartner: "Un des bureaux choisis n'est plus un partenaire actif de cet espace. Actualisez la liste.",
      notAMember: "Une part est attribu\xE9e \xE0 un bureau qui ne fait pas partie du groupement.",
      unknownPhase: "Une des phases n'existe plus dans le projet. Rechargez la page.",
      memberHasPayments: "Un co-traitant qui a re\xE7u des paiements ne peut pas \xEAtre retir\xE9 du groupement.",
      notACoContractor: "Ce bureau n'est plus co-traitant du groupement. Mettez d'abord le groupement \xE0 jour."
    }
  },
  exitExport: {
    title: "Espaces ferm\xE9s",
    intro: "Vous \xE9tiez partenaire de ces espaces. Pendant 30 jours apr\xE8s leur fermeture, vous pouvez r\xE9cup\xE9rer vos propres d\xE9p\xF4ts.",
    zipContent: "Le ZIP contient uniquement les fichiers d\xE9pos\xE9s par votre bureau et les entr\xE9es du journal de l'espace qui vous concernent.",
    loadFailedTitle: "Impossible de charger les espaces ferm\xE9s",
    hostedBy: "H\xE9berg\xE9 par {host}",
    closedOn: "Ferm\xE9 le {date}",
    until: "Export possible jusqu'au {date}",
    noFiles: "Aucun d\xE9p\xF4t de votre bureau",
    files: "{count, plural, one {# fichier} other {# fichiers}} \xB7 {size}",
    request: "Exporter mes d\xE9p\xF4ts",
    forSpace: "{action} : {space}",
    download: "T\xE9l\xE9charger le ZIP",
    readyUntil: "Disponible jusqu'au {date}",
    working: "Pr\xE9paration en cours\u2026",
    failed: "L'export n'a pas pu \xEAtre pr\xE9par\xE9",
    retry: "R\xE9essayer l'export",
    expired: "Le dernier ZIP a expir\xE9",
    again: "Demander un nouvel export",
    late: "Le d\xE9lai d'export est d\xE9pass\xE9",
    requested: "Votre export est en cours de pr\xE9paration.",
    errors: {
      request: "Impossible de demander l'export. R\xE9essayez dans un instant.",
      download: "Impossible de cr\xE9er le lien de t\xE9l\xE9chargement. R\xE9essayez.",
      notReady: "Le ZIP n'est pas encore pr\xEAt.",
      forbidden: "Seuls les propri\xE9taires et les administrateurs peuvent demander l'export.",
      unavailable: "L'export n'est plus possible : le d\xE9lai de 30 jours apr\xE8s la fermeture de l'espace est d\xE9pass\xE9."
    }
  }
};

// locales/ar/finance.json
var finance_default = {
  nav: {
    title: "\u0627\u0644\u0645\u0627\u0644\u064A\u0629",
    quotes: "\u0627\u0644\u0639\u0631\u0648\u0636 \u0627\u0644\u0645\u0627\u0644\u064A\u0629",
    contracts: "\u0627\u0644\u0639\u0642\u0648\u062F",
    invoices: "\u0627\u0644\u0641\u0648\u0627\u062A\u064A\u0631",
    payments: "\u0627\u0644\u062F\u0641\u0648\u0639\u0627\u062A",
    expenses: "\u0645\u0630\u0643\u0631\u0627\u062A \u0627\u0644\u0645\u0635\u0627\u0631\u064A\u0641",
    suppliers: "\u0627\u0644\u0645\u0632\u0648\u0651\u062F\u0648\u0646",
    supplierInvoices: "\u0641\u0648\u0627\u062A\u064A\u0631 \u0627\u0644\u0645\u0632\u0648\u0651\u062F\u064A\u0646",
    withholding: "\u0627\u0644\u062E\u0635\u0648\u0645\u0627\u062A \u0645\u0646 \u0627\u0644\u0645\u0648\u0631\u062F",
    accounting: "\u0627\u0644\u062A\u0635\u062F\u064A\u0631\u0627\u062A \u0627\u0644\u0645\u062D\u0627\u0633\u0628\u064A\u0629",
    dashboard: "\u0644\u0648\u062D\u0629 \u0627\u0644\u0642\u064A\u0627\u062F\u0629",
    management: "\u0627\u0644\u0642\u064A\u0627\u062F\u0629 \u0648\u0627\u0644\u062A\u0633\u064A\u064A\u0631",
    treasury: "\u0627\u0644\u062E\u0632\u064A\u0646\u0629",
    profitability: "\u0627\u0644\u0645\u0631\u062F\u0648\u062F\u064A\u0629",
    costRates: "\u062A\u0643\u0644\u0641\u0629 \u0627\u0644\u0633\u0627\u0639\u0629",
    einvoicing: "\u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629 \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A\u0629"
  },
  totals: {
    title: "\u0627\u0644\u0645\u062C\u0627\u0645\u064A\u0639",
    subtotalHt: "\u0627\u0644\u0645\u062C\u0645\u0648\u0639 \u062F\u0648\u0646 \u0627\u062D\u062A\u0633\u0627\u0628 \u0627\u0644\u0623\u062F\u0627\u0621\u0627\u062A",
    vat: "\u0627\u0644\u0623\u062F\u0627\u0621 \u0639\u0644\u0649 \u0627\u0644\u0642\u064A\u0645\u0629 \u0627\u0644\u0645\u0636\u0627\u0641\u0629 {rate}",
    stamp: "\u0645\u0639\u0644\u0648\u0645 \u0627\u0644\u0637\u0627\u0628\u0639 \u0627\u0644\u062C\u0628\u0627\u0626\u064A",
    totalTtc: "\u0627\u0644\u0645\u062C\u0645\u0648\u0639 \u0628\u0627\u062D\u062A\u0633\u0627\u0628 \u0643\u0644 \u0627\u0644\u0623\u062F\u0627\u0621\u0627\u062A",
    withholding: "\u0627\u0644\u062E\u0635\u0645 \u0645\u0646 \u0627\u0644\u0645\u0648\u0631\u062F {rate}",
    vatWithholding: "\u0627\u0644\u062E\u0635\u0645 \u0645\u0646 \u0627\u0644\u0645\u0648\u0631\u062F \u0628\u0639\u0646\u0648\u0627\u0646 \u0627\u0644\u0623\u062F\u0627\u0621 \u0639\u0644\u0649 \u0627\u0644\u0642\u064A\u0645\u0629 \u0627\u0644\u0645\u0636\u0627\u0641\u0629 {rate}",
    netPayable: "\u0627\u0644\u0635\u0627\u0641\u064A \u0644\u0644\u062F\u0641\u0639",
    base: "\u0627\u0644\u0623\u0633\u0627\u0633 {amount}",
    amountInWords: "\u0627\u0644\u0645\u0628\u0644\u063A \u0628\u0627\u0644\u0623\u062D\u0631\u0641: {words}",
    rateSource: "\u0645\u0635\u062F\u0631 \u0633\u0639\u0631 \u0627\u0644\u0635\u0631\u0641: {source}.",
    tndEquivalent: "\u0627\u0644\u0642\u064A\u0645\u0629 \u0627\u0644\u0645\u0642\u0627\u0628\u0644\u0629 \u0628\u0627\u0644\u062F\u064A\u0646\u0627\u0631: {amount} (1 {currency} = {rate} \u062F.\u062A)",
    legalRef: "\u0627\u0644\u0645\u0631\u062C\u0639 \u0627\u0644\u0642\u0627\u0646\u0648\u0646\u064A: {ref}",
    toVerify: "\u0642\u0627\u0639\u062F\u0629 \u064A\u062C\u0628 \u0627\u0644\u062A\u062D\u0642\u0642 \u0645\u0646\u0647\u0627",
    toVerifyHint: "\u064A\u062C\u0628 \u0623\u0646 \u064A\u0624\u0643\u062F \u062E\u0628\u064A\u0631 \u0645\u062D\u0627\u0633\u0628 \u0647\u0630\u0647 \u0627\u0644\u0642\u064A\u0645\u0629 \u0642\u0628\u0644 \u0627\u0644\u0627\u0633\u062A\u063A\u0644\u0627\u0644 \u0627\u0644\u0641\u0639\u0644\u064A.",
    vatNoRate: "\u0627\u0644\u0623\u062F\u0627\u0621 \u0639\u0644\u0649 \u0627\u0644\u0642\u064A\u0645\u0629 \u0627\u0644\u0645\u0636\u0627\u0641\u0629",
    withholdingNoRate: "\u0627\u0644\u062E\u0635\u0645 \u0645\u0646 \u0627\u0644\u0645\u0648\u0631\u062F",
    vatWithholdingNoRate: "\u0627\u0644\u062E\u0635\u0645 \u0645\u0646 \u0627\u0644\u0645\u0648\u0631\u062F \u0628\u0639\u0646\u0648\u0627\u0646 \u0627\u0644\u0623\u062F\u0627\u0621 \u0639\u0644\u0649 \u0627\u0644\u0642\u064A\u0645\u0629 \u0627\u0644\u0645\u0636\u0627\u0641\u0629",
    rulesConcerned: "\u0627\u0644\u0642\u0648\u0627\u0639\u062F \u0627\u0644\u0645\u0639\u0646\u064A\u0629: {rules}",
    tndEquivalentNet: "\u0627\u0644\u0635\u0627\u0641\u064A \u0644\u0644\u062F\u0641\u0639 \u0628\u0627\u0644\u062F\u064A\u0646\u0627\u0631: {amount}",
    loading: "\u062C\u0627\u0631\u064D \u0627\u062D\u062A\u0633\u0627\u0628 \u0627\u0644\u0645\u062C\u0627\u0645\u064A\u0639",
    errorTitle: "\u0627\u0644\u0645\u062C\u0627\u0645\u064A\u0639 \u063A\u064A\u0631 \u0645\u062A\u0627\u062D\u0629",
    errorBody: "\u062A\u0639\u0630\u0651\u0631 \u0627\u062D\u062A\u0633\u0627\u0628 \u0627\u0644\u0645\u062C\u0627\u0645\u064A\u0639. \u062A\u062D\u0642\u0642 \u0645\u0646 \u0627\u062A\u0635\u0627\u0644\u0643 \u062B\u0645 \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629.",
    retry: "\u0625\u0639\u0627\u062F\u0629 \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629",
    notes: {
      vat_suspended: "\u0627\u0644\u0623\u062F\u0627\u0621 \u0639\u0644\u0649 \u0627\u0644\u0642\u064A\u0645\u0629 \u0627\u0644\u0645\u0636\u0627\u0641\u0629 \u0645\u0639\u0644\u0651\u0642",
      vat_export: "\u0625\u0639\u0641\u0627\u0621 \u0645\u0646 \u0627\u0644\u0623\u062F\u0627\u0621 \u0639\u0644\u0649 \u0627\u0644\u0642\u064A\u0645\u0629 \u0627\u0644\u0645\u0636\u0627\u0641\u0629 \u0639\u0646\u062F \u0627\u0644\u062A\u0635\u062F\u064A\u0631",
      stamp_exempt_treatment: "\u0645\u0639\u0641\u0649 (\u062A\u0635\u062F\u064A\u0631)",
      stamp_exempt_public_buyer: "\u0645\u0639\u0641\u0649 (\u0645\u0634\u062A\u0631\u064D \u0639\u0645\u0648\u0645\u064A)",
      stamp_not_reversed: "\u0627\u0644\u0637\u0627\u0628\u0639 \u0645\u062D\u0641\u0648\u0638 (\u0641\u0627\u062A\u0648\u0631\u0629 \u062A\u0639\u062F\u064A\u0644\u064A\u0629 \u062C\u0632\u0626\u064A\u0629)",
      not_applicable: "\u0644\u0627 \u064A\u0646\u0637\u0628\u0642",
      below_threshold: "\u062F\u0648\u0646 \u0639\u062A\u0628\u0629 \u0627\u0644\u062A\u0637\u0628\u064A\u0642"
    },
    mention: {
      suspended: "\u0628\u064A\u0639 \u0628\u062A\u0648\u0642\u064A\u0641 \u0627\u0644\u0623\u062F\u0627\u0621 \u0639\u0644\u0649 \u0627\u0644\u0642\u064A\u0645\u0629 \u0627\u0644\u0645\u0636\u0627\u0641\u0629 \u2014 \u0634\u0647\u0627\u062F\u0629 \u0639\u062F\u062F {reference}",
      suspendedNoRef: "\u0628\u064A\u0639 \u0628\u062A\u0648\u0642\u064A\u0641 \u0627\u0644\u0623\u062F\u0627\u0621 \u0639\u0644\u0649 \u0627\u0644\u0642\u064A\u0645\u0629 \u0627\u0644\u0645\u0636\u0627\u0641\u0629",
      export: "\u0625\u0639\u0641\u0627\u0621 \u0645\u0646 \u0627\u0644\u0623\u062F\u0627\u0621 \u0639\u0644\u0649 \u0627\u0644\u0642\u064A\u0645\u0629 \u0627\u0644\u0645\u0636\u0627\u0641\u0629 \u2014 \u0625\u0633\u062F\u0627\u0621 \u062E\u062F\u0645\u0627\u062A \u0644\u0644\u062A\u0635\u062F\u064A\u0631"
    }
  },
  rules: {
    "stamp.exemptPublicBuyers": "\u0625\u0639\u0641\u0627\u0621 \u0627\u0644\u062F\u0648\u0644\u0629 \u0648\u0627\u0644\u0645\u0634\u062A\u0631\u064A\u0646 \u0627\u0644\u0639\u0645\u0648\u0645\u064A\u064A\u0646 \u0645\u0646 \u0645\u0639\u0644\u0648\u0645 \u0627\u0644\u0637\u0627\u0628\u0639",
    "withholding.base": "\u0623\u0633\u0627\u0633 \u0627\u0644\u062E\u0635\u0645 \u0645\u0646 \u0627\u0644\u0645\u0648\u0631\u062F (\u0627\u0644\u0645\u062C\u0645\u0648\u0639 \u062F\u0648\u0646 \u0627\u0644\u0637\u0627\u0628\u0639)",
    "withholding.purchases": "\u0646\u0633\u0628\u0629 \u0627\u0644\u062E\u0635\u0645 \u0639\u0644\u0649 \u0627\u0644\u0645\u0634\u062A\u0631\u064A\u0627\u062A",
    "vatWithholding.thresholdBase": "\u0623\u0633\u0627\u0633 \u0639\u062A\u0628\u0629 \u0627\u0644\u062E\u0635\u0645 \u0645\u0646 \u0627\u0644\u0623\u062F\u0627\u0621 \u0639\u0644\u0649 \u0627\u0644\u0642\u064A\u0645\u0629 \u0627\u0644\u0645\u0636\u0627\u0641\u0629 (\u062F\u0648\u0646 \u0627\u0644\u0637\u0627\u0628\u0639)",
    "contract.retentionBase": "\u0623\u0633\u0627\u0633 \u062D\u062C\u0632 \u0627\u0644\u0636\u0645\u0627\u0646 (\u062F\u0648\u0646 \u0627\u0644\u0623\u062F\u0627\u0621\u0627\u062A)",
    lateInterest: "\u0622\u062C\u0627\u0644 \u062E\u0644\u0627\u0635 \u0627\u0644\u0635\u0641\u0642\u0627\u062A \u0627\u0644\u0639\u0645\u0648\u0645\u064A\u0629 \u0648\u0646\u0633\u0628\u0629 \u0641\u0648\u0627\u0626\u0636 \u0627\u0644\u062A\u0623\u062E\u064A\u0631 (TMM)"
  },
  quotes: {
    status: {
      draft: "\u0645\u0633\u0648\u062F\u0629",
      sent: "\u0645\u064F\u0631\u0633\u064E\u0644",
      accepted: "\u0645\u0642\u0628\u0648\u0644",
      rejected: "\u0645\u0631\u0641\u0648\u0636",
      expired: "\u0645\u0646\u062A\u0647\u064A \u0627\u0644\u0635\u0644\u0627\u062D\u064A\u0629"
    },
    list: {
      caption: "\u0627\u0644\u0639\u0631\u0648\u0636 \u0627\u0644\u0645\u0627\u0644\u064A\u0629",
      new: "\u0639\u0631\u0636 \u0645\u0627\u0644\u064A \u062C\u062F\u064A\u062F",
      columns: {
        number: "\u0627\u0644\u0631\u0642\u0645",
        title: "\u0627\u0644\u0645\u0648\u0636\u0648\u0639",
        client: "\u0627\u0644\u062D\u0631\u064A\u0641",
        status: "\u0627\u0644\u062D\u0627\u0644\u0629",
        totalHt: "\u0627\u0644\u0645\u062C\u0645\u0648\u0639 \u062F\u0648\u0646 \u0627\u062D\u062A\u0633\u0627\u0628 \u0627\u0644\u0623\u062F\u0627\u0621\u0627\u062A",
        totalTtc: "\u0627\u0644\u0645\u062C\u0645\u0648\u0639 \u0628\u0627\u062D\u062A\u0633\u0627\u0628 \u0643\u0644 \u0627\u0644\u0623\u062F\u0627\u0621\u0627\u062A",
        validUntil: "\u0635\u0627\u0644\u062D \u0625\u0644\u0649 \u063A\u0627\u064A\u0629",
        sentAt: "\u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0625\u0631\u0633\u0627\u0644",
        acceptedAt: "\u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0642\u0628\u0648\u0644"
      },
      filters: {
        label: "\u062A\u0635\u0641\u064A\u0629 \u0627\u0644\u0639\u0631\u0648\u0636 \u0627\u0644\u0645\u0627\u0644\u064A\u0629",
        status: "\u0627\u0644\u062D\u0627\u0644\u0629",
        all: "\u0643\u0644 \u0627\u0644\u062D\u0627\u0644\u0627\u062A"
      },
      empty: {
        title: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0639\u0631\u0648\u0636 \u0645\u0627\u0644\u064A\u0629 \u0628\u0639\u062F",
        description: "\u0623\u0646\u0634\u0626 \u0623\u0648\u0644 \u0639\u0631\u0636 \u0645\u0627\u0644\u064A: \u062A\u064F\u062D\u0633\u0628 \u0645\u062C\u0627\u0645\u064A\u0639\u0647 \u0645\u0628\u0627\u0634\u0631\u0629 \u0648\u064A\u064F\u0631\u0633\u0644 \u0625\u0644\u0649 \u0627\u0644\u062D\u0631\u064A\u0641 \u0639\u0628\u0631 \u0631\u0627\u0628\u0637 \u0622\u0645\u0646.",
        descriptionReadOnly: "\u0633\u062A\u0638\u0647\u0631 \u0647\u0646\u0627 \u0627\u0644\u0639\u0631\u0648\u0636 \u0627\u0644\u0645\u0627\u0644\u064A\u0629 \u0627\u0644\u062E\u0627\u0635\u0629 \u0628\u0645\u0643\u062A\u0628\u0643."
      },
      filtered: {
        title: "\u0644\u0627 \u064A\u0648\u062C\u062F \u0639\u0631\u0636 \u0645\u0637\u0627\u0628\u0642",
        description: "\u0644\u0627 \u064A\u0648\u062C\u062F \u0639\u0631\u0636 \u0645\u0627\u0644\u064A \u0628\u0647\u0630\u0647 \u0627\u0644\u062D\u0627\u0644\u0629. \u062C\u0631\u0651\u0628 \u062A\u0635\u0641\u064A\u0629 \u0623\u062E\u0631\u0649."
      },
      clearFilters: "\u0645\u0633\u062D \u0627\u0644\u062A\u0635\u0641\u064A\u0629",
      loadMore: "\u0639\u0631\u0636 \u0627\u0644\u0645\u0632\u064A\u062F \u0645\u0646 \u0627\u0644\u0639\u0631\u0648\u0636",
      loadingMore: "\u062C\u0627\u0631\u064D \u0627\u0644\u062A\u062D\u0645\u064A\u0644\u2026",
      loadFailedTitle: "\u062A\u0639\u0630\u0651\u0631 \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0639\u0631\u0648\u0636 \u0627\u0644\u0645\u0627\u0644\u064A\u0629",
      loadFailedBody: "\u062A\u062D\u0642\u0642 \u0645\u0646 \u0627\u062A\u0635\u0627\u0644\u0643 \u062B\u0645 \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629.",
      none: "\u2014"
    },
    editor: {
      newTitle: "\u0639\u0631\u0636 \u0645\u0627\u0644\u064A \u062C\u062F\u064A\u062F",
      detailTitle: "\u0627\u0644\u0639\u0631\u0636 \u0627\u0644\u0645\u0627\u0644\u064A {number}",
      breadcrumbList: "\u0627\u0644\u0639\u0631\u0648\u0636 \u0627\u0644\u0645\u0627\u0644\u064A\u0629",
      loadFailedTitle: "\u062A\u0639\u0630\u0651\u0631 \u062A\u062D\u0645\u064A\u0644 \u0647\u0630\u0627 \u0627\u0644\u0639\u0631\u0636 \u0627\u0644\u0645\u0627\u0644\u064A",
      loadFailedBody: "\u0647\u0648 \u063A\u064A\u0631 \u0645\u0648\u062C\u0648\u062F \u0623\u0648 \u0644\u0627 \u062A\u0645\u0644\u0643 \u062D\u0642 \u0627\u0644\u0627\u0637\u0644\u0627\u0639 \u0639\u0644\u064A\u0647.",
      readOnlyRights: "\u064A\u0645\u0643\u0646\u0643 \u0627\u0644\u0627\u0637\u0644\u0627\u0639 \u0639\u0644\u0649 \u0647\u0630\u0627 \u0627\u0644\u0639\u0631\u0636 \u0627\u0644\u0645\u0627\u0644\u064A \u0644\u0643\u0646\u0643 \u0644\u0627 \u062A\u0645\u0644\u0643 \u0635\u0644\u0627\u062D\u064A\u0629 \u062A\u0639\u062F\u064A\u0644\u0647.",
      readOnlyStatus: "\u0644\u0645 \u064A\u0639\u062F \u0628\u0627\u0644\u0625\u0645\u0643\u0627\u0646 \u062A\u0639\u062F\u064A\u0644 \u0647\u0630\u0627 \u0627\u0644\u0639\u0631\u0636 \u0627\u0644\u0645\u0627\u0644\u064A.",
      readOnlySent: "\u062A\u0645 \u0625\u0631\u0633\u0627\u0644 \u0647\u0630\u0627 \u0627\u0644\u0639\u0631\u0636 \u0627\u0644\u0645\u0627\u0644\u064A \u0625\u0644\u0649 \u0627\u0644\u062D\u0631\u064A\u0641. \u0644\u062A\u0639\u062F\u064A\u0644\u0647 \u0633\u064A\u0639\u0648\u062F \u0625\u0644\u0649 \u062D\u0627\u0644\u0629 \u0645\u0633\u0648\u062F\u0629 \u0648\u064A\u062A\u0648\u0642\u0641 \u0627\u0644\u0631\u0627\u0628\u0637 \u0627\u0644\u0630\u064A \u0623\u064F\u0631\u0633\u0644 \u0639\u0646 \u0627\u0644\u0639\u0645\u0644.",
      editingSent: "\u0623\u0646\u062A \u062A\u0639\u062F\u0651\u0644 \u0639\u0631\u0636\u064B\u0627 \u0645\u064F\u0631\u0633\u064E\u0644\u064B\u0627: \u0639\u0646\u062F \u0627\u0644\u062D\u0641\u0638 \u064A\u0639\u0648\u062F \u0625\u0644\u0649 \u062D\u0627\u0644\u0629 \u0645\u0633\u0648\u062F\u0629 \u0648\u064A\u062A\u0648\u0642\u0641 \u0627\u0644\u0631\u0627\u0628\u0637 \u0627\u0644\u0645\u0631\u0633\u0644 \u0625\u0644\u0649 \u0627\u0644\u062D\u0631\u064A\u0641 \u0639\u0646 \u0627\u0644\u0639\u0645\u0644. \u0633\u062A\u062D\u062A\u0627\u062C \u0625\u0644\u0649 \u0625\u0639\u0627\u062F\u0629 \u0625\u0631\u0633\u0627\u0644\u0647."
    },
    sections: {
      general: "\u0645\u0639\u0644\u0648\u0645\u0627\u062A \u0639\u0627\u0645\u0629",
      calculator: "\u0627\u062D\u062A\u0633\u0627\u0628 \u0627\u0644\u0623\u062A\u0639\u0627\u0628",
      lines: "\u0628\u0646\u0648\u062F \u0627\u0644\u0639\u0631\u0636 \u0627\u0644\u0645\u0627\u0644\u064A",
      notes: "\u0645\u0644\u0627\u062D\u0638\u0627\u062A",
      history: "\u0645\u062A\u0627\u0628\u0639\u0629 \u0627\u0644\u0639\u0631\u0636 \u0627\u0644\u0645\u0627\u0644\u064A"
    },
    fields: {
      client: {
        label: "\u0627\u0644\u062D\u0631\u064A\u0641",
        placeholder: "\u0627\u062E\u062A\u0631 \u062D\u0631\u064A\u0641\u064B\u0627",
        hint: "\u0635\u0627\u062D\u0628 \u0627\u0644\u0645\u0634\u0631\u0648\u0639 \u0627\u0644\u0630\u064A \u064A\u0648\u062C\u064E\u0651\u0647 \u0625\u0644\u064A\u0647 \u0627\u0644\u0639\u0631\u0636 \u0627\u0644\u0645\u0627\u0644\u064A."
      },
      project: {
        label: "\u0627\u0644\u0645\u0634\u0631\u0648\u0639",
        none: "\u0628\u0644\u0627 \u0645\u0634\u0631\u0648\u0639 (\u062D\u0627\u0644\u064A\u064B\u0627)",
        current: "\u0627\u0644\u0645\u0634\u0631\u0648\u0639 \u0627\u0644\u0645\u0631\u062A\u0628\u0637 \u062D\u0627\u0644\u064A\u064B\u0627"
      },
      title: {
        label: "\u0645\u0648\u0636\u0648\u0639 \u0627\u0644\u0639\u0631\u0636 \u0627\u0644\u0645\u0627\u0644\u064A",
        hint: "\u0645\u062B\u0627\u0644: \u0645\u0647\u0645\u0629 \u0625\u0634\u0631\u0627\u0641 \u0648\u062A\u0635\u0645\u064A\u0645\u060C \u0641\u064A\u0644\u0627 \u0645\u0646 \u0637\u0627\u0628\u0642\u064A\u0646."
      },
      language: {
        label: "\u0644\u063A\u0629 \u0645\u0644\u0641 PDF",
        hint: "\u0644\u063A\u0629 \u0627\u0644\u0648\u062B\u064A\u0642\u0629 \u0627\u0644\u0645\u0631\u0633\u0644\u0629 \u0625\u0644\u0649 \u0627\u0644\u062D\u0631\u064A\u0641.",
        fr: "\u0627\u0644\u0641\u0631\u0646\u0633\u064A\u0629",
        ar: "\u0627\u0644\u0639\u0631\u0628\u064A\u0629",
        bilingual: "\u062B\u0646\u0627\u0626\u064A \u0627\u0644\u0644\u063A\u0629 (\u0627\u0644\u0641\u0631\u0646\u0633\u064A\u0629 \u0648\u0627\u0644\u0639\u0631\u0628\u064A\u0629)"
      },
      validUntil: {
        label: "\u0635\u0627\u0644\u062D \u0625\u0644\u0649 \u063A\u0627\u064A\u0629",
        hint: "\u0628\u0639\u062F \u0647\u0630\u0627 \u0627\u0644\u062A\u0627\u0631\u064A\u062E \u0644\u0627 \u064A\u0645\u0643\u0646 \u0644\u0644\u062D\u0631\u064A\u0641 \u0642\u0628\u0648\u0644 \u0627\u0644\u0639\u0631\u0636."
      },
      currency: {
        label: "\u0627\u0644\u0639\u0645\u0644\u0629"
      },
      exchangeRate: {
        label: "\u0633\u0639\u0631 \u0627\u0644\u0635\u0631\u0641 (\u0628\u0627\u0644\u062F\u064A\u0646\u0627\u0631 \u0644\u0643\u0644 \u0648\u062D\u062F\u0629)",
        hint: "\u0645\u062B\u0627\u0644: 3.350 \u0644\u0643\u0644 1 \u064A\u0648\u0631\u0648. \u062A\u064F\u0639\u0637\u0649 \u0627\u0644\u0645\u062C\u0627\u0645\u064A\u0639 \u0623\u064A\u0636\u064B\u0627 \u0628\u0627\u0644\u062F\u064A\u0646\u0627\u0631."
      },
      feeMode: {
        label: "\u0637\u0631\u064A\u0642\u0629 \u0627\u0644\u0627\u062D\u062A\u0633\u0627\u0628",
        lump_sum: "\u0645\u0628\u0644\u063A \u062C\u0632\u0627\u0641\u064A \u0645\u0648\u0632\u064E\u0651\u0639 \u062D\u0633\u0628 \u0627\u0644\u0645\u0631\u0627\u062D\u0644",
        percentage_of_works: "\u0646\u0633\u0628\u0629 \u0645\u0646 \u0643\u0644\u0641\u0629 \u0627\u0644\u0623\u0634\u063A\u0627\u0644",
        time_based: "\u062D\u0633\u0628 \u0627\u0644\u0648\u0642\u062A \u0627\u0644\u0645\u0633\u062A\u063A\u0631\u064E\u0642",
        mixed: "\u0645\u062E\u062A\u0644\u0637 (\u0628\u0646\u0648\u062F \u062A\u064F\u062F\u062E\u064E\u0644 \u064A\u062F\u0648\u064A\u064B\u0627)"
      },
      notes: {
        label: "\u0645\u0644\u0627\u062D\u0638\u0627\u062A \u0644\u0644\u062D\u0631\u064A\u0641",
        hint: "\u0634\u0631\u0648\u0637 \u062E\u0627\u0635\u0629\u060C \u0641\u0631\u0636\u064A\u0627\u062A\u060C \u0627\u0633\u062A\u062B\u0646\u0627\u0621\u0627\u062A."
      }
    },
    errors: {
      clientRequired: "\u0627\u062E\u062A\u0631 \u062D\u0631\u064A\u0641\u064B\u0627.",
      titleRequired: "\u0623\u0639\u0637\u0650 \u0627\u0644\u0639\u0631\u0636 \u0627\u0644\u0645\u0627\u0644\u064A \u0645\u0648\u0636\u0648\u0639\u064B\u0627.",
      validUntilRequired: "\u0623\u062F\u062E\u0644 \u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0635\u0644\u0627\u062D\u064A\u0629.",
      rateRequired: "\u0623\u062F\u062E\u0644 \u0633\u0639\u0631 \u0627\u0644\u0635\u0631\u0641.",
      rateInvalid: "\u0623\u062F\u062E\u0644 \u0633\u0639\u0631\u064B\u0627 \u0645\u0648\u062C\u0628\u064B\u0627 \u0628\u0633\u062A \u062E\u0627\u0646\u0627\u062A \u0639\u0634\u0631\u064A\u0629 \u0639\u0644\u0649 \u0627\u0644\u0623\u0643\u062B\u0631\u060C \u0645\u062B\u0627\u0644: 3.350.",
      linesRequired: "\u0623\u0636\u0641 \u0628\u0646\u062F\u064B\u0627 \u0648\u0627\u062D\u062F\u064B\u0627 \u0639\u0644\u0649 \u0627\u0644\u0623\u0642\u0644 \u0625\u0644\u0649 \u0627\u0644\u0639\u0631\u0636 \u0627\u0644\u0645\u0627\u0644\u064A.",
      descriptionRequired: "\u0635\u0650\u0641 \u0647\u0630\u0627 \u0627\u0644\u0628\u0646\u062F.",
      priceRequired: "\u0623\u062F\u062E\u0644 \u0633\u0639\u0631 \u0627\u0644\u0648\u062D\u062F\u0629.",
      quantityInvalid: "\u0623\u062F\u062E\u0644 \u0643\u0645\u064A\u0629 \u0645\u0648\u062C\u0628\u0629 \u0628\u062B\u0644\u0627\u062B \u062E\u0627\u0646\u0627\u062A \u0639\u0634\u0631\u064A\u0629 \u0639\u0644\u0649 \u0627\u0644\u0623\u0643\u062B\u0631.",
      validityInPast: "\u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0635\u0644\u0627\u062D\u064A\u0629 \u0642\u062F \u0645\u0636\u0649.",
      staleTitle: "\u0642\u0627\u0645 \u0634\u062E\u0635 \u0622\u062E\u0631 \u0628\u062A\u0639\u062F\u064A\u0644 \u0647\u0630\u0627 \u0627\u0644\u0639\u0631\u0636 \u0627\u0644\u0645\u0627\u0644\u064A",
      staleBody: "\u062D\u0641\u0638 \u0634\u062E\u0635 \u0622\u062E\u0631 \u0647\u0630\u0627 \u0627\u0644\u0639\u0631\u0636 \u0627\u0644\u0645\u0627\u0644\u064A \u0623\u062B\u0646\u0627\u0621 \u062A\u0639\u062F\u064A\u0644\u0643 \u0644\u0647. \u0623\u0639\u062F \u062A\u062D\u0645\u064A\u0644\u0647 \u0644\u0644\u0627\u0637\u0644\u0627\u0639 \u0639\u0644\u0649 \u0622\u062E\u0631 \u0646\u0633\u062E\u0629 \u062B\u0645 \u0623\u0639\u062F \u062A\u0637\u0628\u064A\u0642 \u062A\u0639\u062F\u064A\u0644\u0627\u062A\u0643.",
      reload: "\u0625\u0639\u0627\u062F\u0629 \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0639\u0631\u0636 \u0627\u0644\u0645\u0627\u0644\u064A",
      saveFailed: "\u062A\u0639\u0630\u0651\u0631 \u062D\u0641\u0638 \u0627\u0644\u0639\u0631\u0636 \u0627\u0644\u0645\u0627\u0644\u064A"
    },
    save: {
      action: "\u062D\u0641\u0638",
      saving: "\u062C\u0627\u0631\u064D \u0627\u0644\u062D\u0641\u0638\u2026",
      created: "\u062A\u0645 \u0625\u0646\u0634\u0627\u0621 \u0627\u0644\u0639\u0631\u0636 \u0627\u0644\u0645\u0627\u0644\u064A {number}.",
      saved: "\u062A\u0645 \u062D\u0641\u0638 \u0627\u0644\u0639\u0631\u0636 \u0627\u0644\u0645\u0627\u0644\u064A {number}."
    },
    guard: {
      title: "\u0627\u0644\u0645\u063A\u0627\u062F\u0631\u0629 \u062F\u0648\u0646 \u062D\u0641\u0638\u061F",
      body: "\u0633\u062A\u0636\u064A\u0639 \u062A\u0639\u062F\u064A\u0644\u0627\u062A\u0643 \u0639\u0644\u0649 \u0647\u0630\u0627 \u0627\u0644\u0639\u0631\u0636 \u0627\u0644\u0645\u0627\u0644\u064A.",
      leave: "\u0645\u063A\u0627\u062F\u0631\u0629",
      stay: "\u0627\u0644\u0628\u0642\u0627\u0621 \u0641\u064A \u0627\u0644\u0639\u0631\u0636 \u0627\u0644\u0645\u0627\u0644\u064A"
    },
    lines: {
      noPhase: "\u0628\u0646\u0648\u062F \u0623\u062E\u0631\u0649",
      phaseSubtotal: "\u0627\u0644\u0645\u062C\u0645\u0648\u0639 \u0627\u0644\u0641\u0631\u0639\u064A \u062F\u0648\u0646 \u0627\u062D\u062A\u0633\u0627\u0628 \u0627\u0644\u0623\u062F\u0627\u0621\u0627\u062A {amount}",
      description: "\u0627\u0644\u0648\u0635\u0641",
      phase: "\u0627\u0644\u0645\u0631\u062D\u0644\u0629",
      noPhaseOption: "\u0628\u0644\u0627 \u0645\u0631\u062D\u0644\u0629",
      quantity: "\u0627\u0644\u0643\u0645\u064A\u0629",
      unitPrice: "\u0633\u0639\u0631 \u0627\u0644\u0648\u062D\u062F\u0629 \u062F\u0648\u0646 \u0627\u062D\u062A\u0633\u0627\u0628 \u0627\u0644\u0623\u062F\u0627\u0621\u0627\u062A",
      vat: "\u0627\u0644\u0623\u062F\u0627\u0621 \u0639\u0644\u0649 \u0627\u0644\u0642\u064A\u0645\u0629 \u0627\u0644\u0645\u0636\u0627\u0641\u0629",
      amount: "\u0627\u0644\u0645\u0628\u0644\u063A \u062F\u0648\u0646 \u0627\u062D\u062A\u0633\u0627\u0628 \u0627\u0644\u0623\u062F\u0627\u0621\u0627\u062A",
      add: "\u0625\u0636\u0627\u0641\u0629 \u0628\u0646\u062F",
      addToPhase: "\u0625\u0636\u0627\u0641\u0629 \u0628\u0646\u062F \u0625\u0644\u0649 \u0647\u0630\u0647 \u0627\u0644\u0645\u0631\u062D\u0644\u0629",
      remove: "\u062D\u0630\u0641 \u0627\u0644\u0628\u0646\u062F {number}",
      lineNumber: "\u0627\u0644\u0628\u0646\u062F {number}",
      totalHt: "\u0645\u062C\u0645\u0648\u0639 \u0627\u0644\u0628\u0646\u0648\u062F \u062F\u0648\u0646 \u0627\u062D\u062A\u0633\u0627\u0628 \u0627\u0644\u0623\u062F\u0627\u0621\u0627\u062A",
      empty: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0628\u0646\u0648\u062F \u0628\u0639\u062F. \u0627\u0633\u062A\u0639\u0645\u0644 \u0627\u062D\u062A\u0633\u0627\u0628 \u0627\u0644\u0623\u062A\u0639\u0627\u0628 \u0623\u0648 \u0623\u0636\u0641 \u0628\u0646\u062F\u064B\u0627.",
      readOnlyCaption: "\u0628\u0646\u0648\u062F \u0627\u0644\u0639\u0631\u0636 \u0627\u0644\u0645\u0627\u0644\u064A"
    },
    calculator: {
      intro: "\u064A\u0642\u062A\u0631\u062D \u0627\u0644\u0627\u062D\u062A\u0633\u0627\u0628 \u0628\u0646\u0648\u062F\u064B\u0627 \u064A\u0645\u0643\u0646\u0643 \u062A\u0639\u062F\u064A\u0644\u0647\u0627 \u0628\u0639\u062F \u0630\u0644\u0643: \u0644\u0627 \u064A\u064F\u0637\u0628\u064E\u0651\u0642 \u0623\u064A \u0634\u064A\u0621 \u062F\u0648\u0646 \u0645\u0648\u0627\u0641\u0642\u062A\u0643.",
      mixedHint: "\u0641\u064A \u0647\u0630\u0647 \u0627\u0644\u0637\u0631\u064A\u0642\u0629 \u062A\u064F\u062F\u062E\u0644 \u0627\u0644\u0628\u0646\u0648\u062F \u064A\u062F\u0648\u064A\u064B\u0627. \u0648\u064A\u0645\u0643\u0646\u0643 \u0627\u0644\u0627\u0633\u062A\u0639\u0627\u0646\u0629 \u0628\u0637\u0631\u0642 \u0627\u0644\u0627\u062D\u062A\u0633\u0627\u0628 \u0627\u0644\u0623\u062E\u0631\u0649.",
      propose: "\u0627\u0642\u062A\u0631\u0627\u062D \u0627\u0644\u0628\u0646\u0648\u062F",
      proposed: "\u062A\u0645 \u0627\u0642\u062A\u0631\u0627\u062D \u0627\u0644\u0628\u0646\u0648\u062F. \u0631\u0627\u062C\u0639\u0647\u0627 \u0648\u0639\u062F\u0651\u0644\u0647\u0627 \u0639\u0646\u062F \u0627\u0644\u062D\u0627\u062C\u0629.",
      replaceTitle: "\u0627\u0633\u062A\u0628\u062F\u0627\u0644 \u0627\u0644\u0628\u0646\u0648\u062F \u0627\u0644\u062D\u0627\u0644\u064A\u0629\u061F",
      replaceBody: "\u0633\u062A\u062D\u0644\u0651 \u0627\u0644\u0628\u0646\u0648\u062F \u0627\u0644\u0645\u0642\u062A\u0631\u062D\u0629 \u0645\u062D\u0644 \u0628\u0646\u0648\u062F \u0627\u0644\u0639\u0631\u0636 \u0627\u0644\u0645\u0627\u0644\u064A. \u064A\u0645\u0643\u0646\u0643 \u062A\u0639\u062F\u064A\u0644\u0647\u0627 \u0628\u0639\u062F \u0630\u0644\u0643.",
      replaceConfirm: "\u0627\u0633\u062A\u0628\u062F\u0627\u0644 \u0627\u0644\u0628\u0646\u0648\u062F",
      lumpTotal: "\u0627\u0644\u0623\u062A\u0639\u0627\u0628 \u0627\u0644\u062C\u0632\u0627\u0641\u064A\u0629 \u062F\u0648\u0646 \u0627\u062D\u062A\u0633\u0627\u0628 \u0627\u0644\u0623\u062F\u0627\u0621\u0627\u062A",
      worksCost: "\u0627\u0644\u0643\u0644\u0641\u0629 \u0627\u0644\u062A\u0642\u062F\u064A\u0631\u064A\u0629 \u0644\u0644\u0623\u0634\u063A\u0627\u0644 \u062F\u0648\u0646 \u0627\u062D\u062A\u0633\u0627\u0628 \u0627\u0644\u0623\u062F\u0627\u0621\u0627\u062A",
      fee: "\u0627\u0644\u0623\u062A\u0639\u0627\u0628 \u0627\u0644\u0645\u062D\u062A\u0633\u0628\u0629 \u062F\u0648\u0646 \u0627\u062D\u062A\u0633\u0627\u0628 \u0627\u0644\u0623\u062F\u0627\u0621\u0627\u062A",
      rate: {
        label: "\u0646\u0633\u0628\u0629 \u0627\u0644\u0623\u062A\u0639\u0627\u0628 (%)",
        hint: "\u0645\u062B\u0627\u0644: 6 \u0623\u0648 4.5."
      },
      rateInvalid: "\u0623\u062F\u062E\u0644 \u0646\u0633\u0628\u0629 \u0645\u0626\u0648\u064A\u0629 \u0628\u064A\u0646 0 \u0648100\u060C \u0645\u062B\u0627\u0644: 4.5.",
      scale: {
        label: "\u062C\u062F\u0648\u0644 \u0645\u0631\u062C\u0639\u064A",
        none: "\u0628\u0644\u0627 \u062C\u062F\u0648\u0644 (\u0646\u0633\u0628\u0629 \u0645\u064F\u062F\u062E\u064E\u0644\u0629)",
        hint: "\u064A\u0639\u0637\u064A \u0627\u0644\u062C\u062F\u0648\u0644 \u0627\u0642\u062A\u0631\u0627\u062D\u064B\u0627 \u0645\u0639 \u0645\u0635\u062F\u0631\u0647: \u0644\u0627 \u064A\u064F\u0637\u0628\u064E\u0651\u0642 \u0623\u0628\u062F\u064B\u0627 \u062F\u0648\u0646 \u0645\u0648\u0627\u0641\u0642\u062A\u0643.",
        suggestion: "\u0627\u0642\u062A\u0631\u0627\u062D \u0627\u0644\u062C\u062F\u0648\u0644 \xAB{name}\xBB: {amount}",
        apply: "\u0627\u0639\u062A\u0645\u0627\u062F \u0647\u0630\u0627 \u0627\u0644\u0627\u0642\u062A\u0631\u0627\u062D",
        source: {
          decree_78_71: "\u0627\u0644\u0623\u0645\u0631 \u0639\u062F\u062F 78-71",
          oat: "\u0647\u064A\u0626\u0629 \u0627\u0644\u0645\u0647\u0646\u062F\u0633\u064A\u0646 \u0627\u0644\u0645\u0639\u0645\u0627\u0631\u064A\u064A\u0646 \u0628\u062A\u0648\u0646\u0633",
          oit_2026: "\u0647\u064A\u0626\u0629 \u0627\u0644\u0645\u0647\u0646\u062F\u0633\u064A\u0646 \u0627\u0644\u062A\u0648\u0646\u0633\u064A\u064A\u0646",
          custom: "\u062C\u062F\u0648\u0644 \u0645\u0643\u062A\u0628\u0643"
        },
        sourceLine: "\u0627\u0644\u0645\u0635\u062F\u0631: {source}\u060C \u0633\u0627\u0631\u064A \u0627\u0644\u0645\u0641\u0639\u0648\u0644 \u0645\u0646\u0630 {date}",
        legalRef: "\u0627\u0644\u0645\u0631\u062C\u0639: {ref}",
        belowMinimum: "\u0647\u0630\u0647 \u0627\u0644\u0623\u062A\u0639\u0627\u0628 \u0623\u0642\u0644 \u0645\u0646 \u0627\u0644\u062D\u062F \u0627\u0644\u0623\u062F\u0646\u0649 \u0644\u0644\u062C\u062F\u0648\u0644 \xAB{name}\xBB ({amount}). \u064A\u0645\u0643\u0646\u0643 \u0627\u0644\u0625\u0628\u0642\u0627\u0621 \u0639\u0644\u064A\u0647\u0627\u060C \u0641\u0647\u0630\u0627 \u0645\u062C\u0631\u062F \u062A\u0646\u0628\u064A\u0647."
      },
      shares: {
        title: "\u0627\u0644\u062A\u0648\u0632\u064A\u0639 \u062D\u0633\u0628 \u0627\u0644\u0645\u0631\u0627\u062D\u0644",
        hint: "\u064A\u062C\u0628 \u0623\u0646 \u064A\u0628\u0644\u063A \u0645\u062C\u0645\u0648\u0639 \u0627\u0644\u062D\u0635\u0635 100%.",
        phase: "\u0627\u0644\u0645\u0631\u062D\u0644\u0629",
        share: "\u0627\u0644\u062D\u0635\u0629 (%)",
        add: "\u0625\u0636\u0627\u0641\u0629 \u0645\u0631\u062D\u0644\u0629",
        remove: "\u0625\u0632\u0627\u0644\u0629 \u0627\u0644\u0645\u0631\u062D\u0644\u0629 {phase}",
        loadTemplate: "\u0627\u0639\u062A\u0645\u0627\u062F \u062A\u0648\u0632\u064A\u0639 \u0646\u0648\u0639 \u0645\u0647\u0645\u0629",
        loadNone: "\u0627\u062E\u062A\u0631 \u0646\u0648\u0639 \u0645\u0647\u0645\u0629",
        total: "\u0645\u062C\u0645\u0648\u0639 \u0627\u0644\u062D\u0635\u0635: {total}",
        notHundred: "\u0645\u062C\u0645\u0648\u0639 \u0627\u0644\u062D\u0635\u0635 {total} \u0628\u062F\u0644 100%.",
        invalid: "\u0623\u062F\u062E\u0644 \u0646\u0633\u0628\u0629 \u0645\u0626\u0648\u064A\u0629\u060C \u0645\u062B\u0627\u0644: 12.5.",
        empty: "\u0623\u0636\u0641 \u0645\u0631\u062D\u0644\u0629 \u0648\u0627\u062D\u062F\u0629 \u0639\u0644\u0649 \u0627\u0644\u0623\u0642\u0644."
      },
      time: {
        title: "\u0627\u0644\u0648\u0642\u062A \u0627\u0644\u0645\u0633\u062A\u063A\u0631\u064E\u0642",
        description: "\u0627\u0644\u062A\u062F\u062E\u0644",
        quantity: "\u0633\u0627\u0639\u0627\u062A \u0623\u0648 \u0623\u064A\u0627\u0645",
        unitRate: "\u0633\u0639\u0631 \u0627\u0644\u0648\u062D\u062F\u0629 \u062F\u0648\u0646 \u0627\u062D\u062A\u0633\u0627\u0628 \u0627\u0644\u0623\u062F\u0627\u0621\u0627\u062A",
        add: "\u0625\u0636\u0627\u0641\u0629 \u062A\u062F\u062E\u0644",
        remove: "\u0625\u0632\u0627\u0644\u0629 \u0627\u0644\u062A\u062F\u062E\u0644 {number}",
        total: "\u0645\u062C\u0645\u0648\u0639 \u0627\u0644\u0648\u0642\u062A \u0627\u0644\u0645\u0633\u062A\u063A\u0631\u064E\u0642: {amount}",
        empty: "\u0623\u0636\u0641 \u062A\u062F\u062E\u0644\u064B\u0627 \u0648\u0627\u062D\u062F\u064B\u0627 \u0639\u0644\u0649 \u0627\u0644\u0623\u0642\u0644."
      }
    },
    totals: {
      needClient: "\u0627\u062E\u062A\u0631 \u062D\u0631\u064A\u0641\u064B\u0627 \u0644\u0627\u062D\u062A\u0633\u0627\u0628 \u0627\u0644\u0645\u062C\u0627\u0645\u064A\u0639 (\u0627\u0644\u0623\u062F\u0627\u0621 \u0639\u0644\u0649 \u0627\u0644\u0642\u064A\u0645\u0629 \u0627\u0644\u0645\u0636\u0627\u0641\u0629\u060C \u0627\u0644\u0637\u0627\u0628\u0639\u060C \u0627\u0644\u062E\u0635\u0645 \u0645\u0646 \u0627\u0644\u0645\u0648\u0631\u062F).",
      needRate: "\u0623\u062F\u062E\u0644 \u0633\u0639\u0631 \u0627\u0644\u0635\u0631\u0641 \u0644\u0627\u062D\u062A\u0633\u0627\u0628 \u0627\u0644\u0645\u062C\u0627\u0645\u064A\u0639.",
      needLines: "\u0623\u0643\u0645\u0644 \u0627\u0644\u0628\u0646\u0648\u062F (\u0627\u0644\u0643\u0645\u064A\u0629 \u0648\u0627\u0644\u0633\u0639\u0631) \u0644\u0627\u062D\u062A\u0633\u0627\u0628 \u0627\u0644\u0645\u062C\u0627\u0645\u064A\u0639.",
      noRight: "\u0627\u0644\u0645\u062C\u0627\u0645\u064A\u0639 \u0627\u0644\u0645\u0641\u0635\u0651\u0644\u0629 \u063A\u064A\u0631 \u0645\u062A\u0627\u062D\u0629 \u0628\u0635\u0644\u0627\u062D\u064A\u0627\u062A\u0643. \u064A\u0628\u0642\u0649 \u0645\u062C\u0645\u0648\u0639 \u0627\u0644\u0628\u0646\u0648\u062F \u062F\u0648\u0646 \u0627\u062D\u062A\u0633\u0627\u0628 \u0627\u0644\u0623\u062F\u0627\u0621\u0627\u062A \u062F\u0642\u064A\u0642\u064B\u0627.",
      indicative: "\u0645\u062C\u0627\u0645\u064A\u0639 \u062A\u0642\u062F\u064A\u0631\u064A\u0629: \u062A\u0639\u064A\u062F \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629 \u0627\u062D\u062A\u0633\u0627\u0628\u0647\u0627 \u0639\u0646\u062F \u0625\u0635\u062F\u0627\u0631\u0647\u0627."
    },
    actions: {
      label: "\u0625\u062C\u0631\u0627\u0621\u0627\u062A \u0627\u0644\u0639\u0631\u0636 \u0627\u0644\u0645\u0627\u0644\u064A",
      pdf: "\u0639\u0631\u0636 \u0645\u0644\u0641 PDF",
      pdfOpening: "\u062C\u0627\u0631\u064D \u0641\u062A\u062D \u0645\u0644\u0641 PDF\u2026",
      pdfPreparing: "\u0645\u0644\u0641 PDF \u0642\u064A\u062F \u0627\u0644\u0625\u0639\u062F\u0627\u062F. \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629 \u0628\u0639\u062F \u0644\u062D\u0638\u0627\u062A.",
      pdfFailed: "\u062A\u0639\u0630\u0651\u0631 \u0641\u062A\u062D \u0645\u0644\u0641 PDF. \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629 \u0628\u0639\u062F \u0644\u062D\u0638\u0627\u062A.",
      send: "\u0625\u0631\u0633\u0627\u0644",
      resend: "\u0625\u0639\u0627\u062F\u0629 \u0627\u0644\u0625\u0631\u0633\u0627\u0644",
      reject: "\u0631\u0641\u0636\u0647 \u0627\u0644\u062D\u0631\u064A\u0641",
      convert: "\u0625\u0646\u0634\u0627\u0621 \u0627\u0644\u0645\u0634\u0631\u0648\u0639",
      openProject: "\u0641\u062A\u062D \u0627\u0644\u0645\u0634\u0631\u0648\u0639",
      delete: "\u062D\u0630\u0641 \u0627\u0644\u0645\u0633\u0648\u062F\u0629",
      edit: "\u062A\u0639\u062F\u064A\u0644 \u0627\u0644\u0639\u0631\u0636 \u0627\u0644\u0645\u0627\u0644\u064A",
      saveFirst: "\u0627\u062D\u0641\u0638 \u062A\u0639\u062F\u064A\u0644\u0627\u062A\u0643 \u0623\u0648\u0644\u064B\u0627 \u0644\u0627\u0633\u062A\u0639\u0645\u0627\u0644 \u0647\u0630\u0647 \u0627\u0644\u0625\u062C\u0631\u0627\u0621\u0627\u062A."
    },
    history: {
      createdBy: "\u0623\u0646\u0634\u0623\u0647 {name} \u0628\u062A\u0627\u0631\u064A\u062E {date}",
      sent: "\u0623\u0631\u0633\u0644\u0647 {name} \u0628\u062A\u0627\u0631\u064A\u062E {date}",
      linkExpires: "\u0631\u0627\u0628\u0637 \u0627\u0644\u062D\u0631\u064A\u0641 \u0635\u0627\u0644\u062D \u0625\u0644\u0649 \u063A\u0627\u064A\u0629 {date}",
      accepted: "\u0642\u0628\u0644\u0647 {name} \u0628\u062A\u0627\u0631\u064A\u062E {date}",
      rejected: "\u0631\u0641\u0636\u0647 \u0627\u0644\u062D\u0631\u064A\u0641 \u0628\u062A\u0627\u0631\u064A\u062E {date}",
      pdfHash: "\u0628\u0635\u0645\u0629 \u0645\u0644\u0641 PDF \u0627\u0644\u0645\u0642\u0628\u0648\u0644 (SHA-256): {hash}",
      notSent: "\u0644\u0645 \u064A\u064F\u0631\u0633\u064E\u0644 \u0647\u0630\u0627 \u0627\u0644\u0639\u0631\u0636 \u0627\u0644\u0645\u0627\u0644\u064A \u0628\u0639\u062F.",
      pdfReady: "\u0645\u0644\u0641 PDF \u062C\u0627\u0647\u0632",
      pdfNotReady: "\u0645\u0644\u0641 PDF \u0642\u064A\u062F \u0627\u0644\u0625\u0639\u062F\u0627\u062F"
    },
    send: {
      title: "\u0625\u0631\u0633\u0627\u0644 \u0627\u0644\u0639\u0631\u0636 \u0627\u0644\u0645\u0627\u0644\u064A {number}",
      intro: "\u064A\u062A\u0644\u0642\u0649 \u0627\u0644\u062D\u0631\u064A\u0641 \u0631\u0633\u0627\u0644\u0629 \u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A\u0629 \u062A\u062A\u0636\u0645\u0646 \u0631\u0627\u0628\u0637\u064B\u0627 \u0622\u0645\u0646\u064B\u0627 \u0644\u0644\u0627\u0637\u0644\u0627\u0639 \u0639\u0644\u0649 \u0645\u0644\u0641 PDF \u0648\u0642\u0628\u0648\u0644 \u0627\u0644\u0639\u0631\u0636 \u0627\u0644\u0645\u0627\u0644\u064A. \u0627\u0644\u0631\u0627\u0628\u0637 \u0635\u0627\u0644\u062D \u0644\u0645\u062F\u0629 30 \u064A\u0648\u0645\u064B\u0627.",
      resendInfo: "\u0633\u0628\u0642 \u0625\u0631\u0633\u0627\u0644 \u0647\u0630\u0627 \u0627\u0644\u0639\u0631\u0636 \u0627\u0644\u0645\u0627\u0644\u064A: \u0625\u0639\u0627\u062F\u0629 \u0627\u0644\u0625\u0631\u0633\u0627\u0644 \u062A\u0633\u062A\u0628\u062F\u0644 \u0627\u0644\u0631\u0627\u0628\u0637 \u0627\u0644\u0633\u0627\u0628\u0642 \u0627\u0644\u0630\u064A \u064A\u062A\u0648\u0642\u0641 \u0639\u0646 \u0627\u0644\u0639\u0645\u0644.",
      contact: {
        label: "\u0627\u0644\u0645\u0631\u0633\u064E\u0644 \u0625\u0644\u064A\u0647",
        client: "\u0627\u0644\u0628\u0631\u064A\u062F \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A \u0644\u0644\u062D\u0631\u064A\u0641",
        noEmail: "\u0628\u0644\u0627 \u0628\u0631\u064A\u062F \u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A"
      },
      message: {
        label: "\u0631\u0633\u0627\u0644\u0629 \u0644\u0644\u062D\u0631\u064A\u0641 (\u0627\u062E\u062A\u064A\u0627\u0631\u064A\u0629)",
        hint: "\u062A\u064F\u0631\u0633\u0644 \u0647\u0630\u0647 \u0627\u0644\u0631\u0633\u0627\u0644\u0629 \u0645\u0639 \u0627\u0644\u0631\u0627\u0628\u0637 \u0641\u064A \u0627\u0644\u0628\u0631\u064A\u062F \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A."
      },
      submit: "\u0625\u0631\u0633\u0627\u0644 \u0627\u0644\u0639\u0631\u0636 \u0627\u0644\u0645\u0627\u0644\u064A",
      sending: "\u062C\u0627\u0631\u064D \u0627\u0644\u0625\u0631\u0633\u0627\u0644\u2026",
      done: "\u062A\u0645 \u0625\u0631\u0633\u0627\u0644 \u0627\u0644\u0639\u0631\u0636 \u0627\u0644\u0645\u0627\u0644\u064A {number}.",
      noRecipient: "\u0644\u0627 \u0627\u0644\u062D\u0631\u064A\u0641 \u0648\u0644\u0627 \u062C\u0647\u0629 \u0627\u0644\u0627\u062A\u0635\u0627\u0644 \u0647\u0630\u0647 \u0644\u062F\u064A\u0647\u0645\u0627 \u0628\u0631\u064A\u062F \u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A. \u0623\u0636\u0641 \u0628\u0631\u064A\u062F\u064B\u0627 \u0641\u064A \u0635\u0641\u062D\u0629 \u0627\u0644\u062D\u0631\u064A\u0641 \u062B\u0645 \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629.",
      validityInPast: "\u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0635\u0644\u0627\u062D\u064A\u0629 \u0642\u062F \u0645\u0636\u0649: \u063A\u064A\u0651\u0631\u0647 \u0642\u0628\u0644 \u0625\u0631\u0633\u0627\u0644 \u0627\u0644\u0639\u0631\u0636 \u0627\u0644\u0645\u0627\u0644\u064A."
    },
    reject: {
      title: "\u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u0639\u0631\u0636 \u0627\u0644\u0645\u0627\u0644\u064A {number} \u0643\u0645\u0631\u0641\u0648\u0636\u061F",
      body: "\u0631\u0641\u0636 \u0627\u0644\u062D\u0631\u064A\u0641 \u0647\u0630\u0627 \u0627\u0644\u0639\u0631\u0636 \u0627\u0644\u0645\u0627\u0644\u064A. \u0644\u0646 \u064A\u0633\u0645\u062D \u0627\u0644\u0631\u0627\u0628\u0637 \u0627\u0644\u0630\u064A \u062A\u0644\u0642\u0627\u0647 \u0628\u0642\u0628\u0648\u0644\u0647 \u0628\u0639\u062F \u0627\u0644\u0622\u0646.",
      confirm: "\u062A\u0633\u062C\u064A\u0644\u0647 \u0643\u0645\u0631\u0641\u0648\u0636",
      done: "\u062A\u0645 \u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u0639\u0631\u0636 \u0627\u0644\u0645\u0627\u0644\u064A {number} \u0643\u0645\u0631\u0641\u0648\u0636."
    },
    convert: {
      title: "\u0625\u0646\u0634\u0627\u0621 \u0645\u0634\u0631\u0648\u0639 \u0627\u0644\u0639\u0631\u0636 \u0627\u0644\u0645\u0627\u0644\u064A {number}",
      intro: "\u064A\u0633\u062A\u0639\u064A\u062F \u0627\u0644\u0645\u0634\u0631\u0648\u0639 \u0627\u0644\u062D\u0631\u064A\u0641 \u0648\u0627\u0644\u0623\u062A\u0639\u0627\u0628 \u0645\u0646 \u0627\u0644\u0639\u0631\u0636 \u0627\u0644\u0645\u0627\u0644\u064A \u0627\u0644\u0645\u0642\u0628\u0648\u0644. \u0627\u062E\u062A\u0631 \u0646\u0648\u0639 \u0627\u0644\u0645\u0647\u0645\u0629: \u062A\u064F\u0646\u0634\u0623 \u0645\u0631\u0627\u062D\u0644\u0647 \u0648\u0645\u062C\u0644\u062F\u0627\u062A\u0647 \u0627\u0644\u0646\u0645\u0648\u0630\u062C\u064A\u0629.",
      name: "\u0627\u0633\u0645 \u0627\u0644\u0645\u0634\u0631\u0648\u0639",
      nameRequired: "\u0623\u0639\u0637\u0650 \u0627\u0644\u0645\u0634\u0631\u0648\u0639 \u0627\u0633\u0645\u064B\u0627.",
      missionType: "\u0646\u0648\u0639 \u0627\u0644\u0645\u0647\u0645\u0629",
      code: "\u0631\u0645\u0632 \u0627\u0644\u0645\u0634\u0631\u0648\u0639 (\u0627\u062E\u062A\u064A\u0627\u0631\u064A)",
      codeHint: "\u0627\u062A\u0631\u0643\u0647 \u0641\u0627\u0631\u063A\u064B\u0627 \u0644\u064A\u064F\u0648\u0644\u064E\u0651\u062F \u0631\u0645\u0632 \u062A\u0644\u0642\u0627\u0626\u064A\u064B\u0627.",
      submit: "\u0625\u0646\u0634\u0627\u0621 \u0627\u0644\u0645\u0634\u0631\u0648\u0639",
      creating: "\u062C\u0627\u0631\u064D \u0627\u0644\u0625\u0646\u0634\u0627\u0621\u2026",
      done: "\u062A\u0645 \u0625\u0646\u0634\u0627\u0621 \u0627\u0644\u0645\u0634\u0631\u0648\u0639."
    },
    remove: {
      title: "\u062D\u0630\u0641 \u0627\u0644\u0645\u0633\u0648\u062F\u0629 {number}\u061F",
      body: "\u0644\u0645 \u064A\u064F\u0631\u0633\u064E\u0644 \u0647\u0630\u0627 \u0627\u0644\u0639\u0631\u0636 \u0627\u0644\u0645\u0627\u0644\u064A \u0642\u0637: \u0633\u064A\u064F\u062D\u0630\u0641 \u0646\u0647\u0627\u0626\u064A\u064B\u0627.",
      confirm: "\u062D\u0630\u0641",
      done: "\u062A\u0645 \u062D\u0630\u0641 \u0627\u0644\u0645\u0633\u0648\u062F\u0629 {number}."
    },
    editSent: {
      title: "\u062A\u0639\u062F\u064A\u0644 \u0639\u0631\u0636 \u0645\u0627\u0644\u064A \u0645\u064F\u0631\u0633\u064E\u0644\u061F",
      body: "\u064A\u0639\u0648\u062F \u0627\u0644\u0639\u0631\u0636 \u0627\u0644\u0645\u0627\u0644\u064A \u0625\u0644\u0649 \u062D\u0627\u0644\u0629 \u0645\u0633\u0648\u062F\u0629 \u0648\u064A\u062A\u0648\u0642\u0641 \u0627\u0644\u0631\u0627\u0628\u0637 \u0627\u0644\u0645\u0631\u0633\u0644 \u0625\u0644\u0649 \u0627\u0644\u062D\u0631\u064A\u0641 \u0639\u0646 \u0627\u0644\u0639\u0645\u0644. \u0633\u062A\u062D\u062A\u0627\u062C \u0625\u0644\u0649 \u0625\u0631\u0633\u0627\u0644\u0647 \u0645\u0646 \u062C\u062F\u064A\u062F \u0628\u0639\u062F \u062A\u0639\u062F\u064A\u0644\u0627\u062A\u0643.",
      confirm: "\u062A\u0639\u062F\u064A\u0644 \u0627\u0644\u0639\u0631\u0636 \u0627\u0644\u0645\u0627\u0644\u064A"
    }
  },
  contracts: {
    kind: {
      private_agreement: "\u0627\u062A\u0641\u0627\u0642\u064A\u0629 \u062E\u0627\u0635\u0629",
      public_market: "\u0635\u0641\u0642\u0629 \u0639\u0645\u0648\u0645\u064A\u0629"
    },
    list: {
      caption: "\u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u0639\u0642\u0648\u062F",
      new: "\u0639\u0642\u062F \u062C\u062F\u064A\u062F",
      columns: {
        reference: "\u0627\u0644\u0645\u0631\u062C\u0639",
        client: "\u0627\u0644\u062D\u0631\u064A\u0641",
        kind: "\u0627\u0644\u0635\u0646\u0641",
        amount: "\u0627\u0644\u0645\u0628\u0644\u063A \u062F\u0648\u0646 \u0627\u062D\u062A\u0633\u0627\u0628 \u0627\u0644\u0623\u062F\u0627\u0621\u0627\u062A",
        total: "\u0627\u0644\u0645\u062C\u0645\u0648\u0639 \u0645\u0639 \u0627\u0644\u0645\u0644\u0627\u062D\u0642",
        signedOn: "\u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0625\u0645\u0636\u0627\u0621",
        bondReleaseOn: "\u0631\u0641\u0639 \u0627\u0644\u0643\u0641\u0627\u0644\u0629"
      },
      filters: {
        label: "\u0645\u0631\u0634\u062D\u0627\u062A \u0627\u0644\u0639\u0642\u0648\u062F",
        kind: "\u0635\u0646\u0641 \u0627\u0644\u0639\u0642\u062F",
        all: "\u0643\u0644 \u0627\u0644\u0623\u0635\u0646\u0627\u0641"
      },
      empty: {
        title: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0639\u0642\u0648\u062F \u062D\u0627\u0644\u064A\u064B\u0627",
        description: "\u0623\u0646\u0634\u0626 \u0639\u0642\u062F\u064B\u0627 \u0627\u0646\u0637\u0644\u0627\u0642\u064B\u0627 \u0645\u0646 \u0639\u0631\u0636 \u0645\u0627\u0644\u064A \u0645\u0642\u0628\u0648\u0644\u060C \u0623\u0648 \u0623\u062F\u062E\u0644 \u0639\u0642\u062F\u064B\u0627 \u0645\u0628\u0627\u0634\u0631\u0629: \u0627\u0644\u062F\u0641\u0639\u0629 \u0627\u0644\u0645\u0633\u0628\u0642\u0629 \u0648\u0627\u0644\u0627\u062D\u062A\u0641\u0627\u0638 \u0628\u0627\u0644\u0636\u0645\u0627\u0646 \u0648\u0627\u0644\u0643\u0641\u0627\u0644\u0629 \u0648\u062E\u0637\u0627\u064A\u0627 \u0627\u0644\u062A\u0623\u062E\u064A\u0631.",
        descriptionReadOnly: "\u0633\u062A\u0638\u0647\u0631 \u0647\u0646\u0627 \u0639\u0642\u0648\u062F \u0645\u0643\u062A\u0628\u0643."
      },
      filtered: {
        title: "\u0644\u0627 \u064A\u0648\u062C\u062F \u0639\u0642\u062F \u0645\u0637\u0627\u0628\u0642",
        description: "\u0644\u0627 \u064A\u0648\u062C\u062F \u0639\u0642\u062F \u0645\u0646 \u0647\u0630\u0627 \u0627\u0644\u0635\u0646\u0641. \u062C\u0631\u0651\u0628 \u0645\u0631\u0634\u062D\u064B\u0627 \u0622\u062E\u0631."
      },
      clearFilters: "\u0645\u0633\u062D \u0627\u0644\u0645\u0631\u0634\u062D",
      loadMore: "\u0639\u0631\u0636 \u0645\u0632\u064A\u062F \u0645\u0646 \u0627\u0644\u0639\u0642\u0648\u062F",
      loadingMore: "\u062C\u0627\u0631\u064D \u0627\u0644\u062A\u062D\u0645\u064A\u0644\u2026",
      loadFailedTitle: "\u062A\u0639\u0630\u0651\u0631 \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0639\u0642\u0648\u062F",
      loadFailedBody: "\u062A\u062D\u0642\u0642 \u0645\u0646 \u0627\u062A\u0635\u0627\u0644\u0643 \u062B\u0645 \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629.",
      none: "\u2014"
    },
    editor: {
      newTitle: "\u0639\u0642\u062F \u062C\u062F\u064A\u062F",
      detailTitle: "\u0627\u0644\u0639\u0642\u062F {reference}",
      breadcrumbList: "\u0627\u0644\u0639\u0642\u0648\u062F",
      fromQuote: "\u0639\u0642\u062F \u0623\u064F\u0646\u0634\u0626 \u0645\u0646 \u0639\u0631\u0636 \u0645\u0627\u0644\u064A: \u0641\u062A\u062D \u0627\u0644\u0639\u0631\u0636 \u0627\u0644\u0645\u0627\u0644\u064A",
      readOnlyRights: "\u064A\u0645\u0643\u0646\u0643 \u0627\u0644\u0627\u0637\u0644\u0627\u0639 \u0639\u0644\u0649 \u0647\u0630\u0627 \u0627\u0644\u0639\u0642\u062F \u062F\u0648\u0646 \u062A\u0639\u062F\u064A\u0644\u0647.",
      loadFailedTitle: "\u062A\u0639\u0630\u0651\u0631 \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0639\u0642\u062F",
      loadFailedBody: "\u062A\u062D\u0642\u0642 \u0645\u0646 \u0627\u062A\u0635\u0627\u0644\u0643 \u062B\u0645 \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629."
    },
    sections: {
      general: "\u0645\u0639\u0644\u0648\u0645\u0627\u062A \u0639\u0627\u0645\u0629",
      terms: "\u0634\u0631\u0648\u0637 \u0627\u0644\u062F\u0641\u0639",
      amendments: "\u0627\u0644\u0645\u0644\u0627\u062D\u0642",
      progress: "\u0627\u0644\u062A\u0642\u062F\u0651\u0645 \u0627\u0644\u0645\u0641\u0648\u062A\u0631"
    },
    fields: {
      client: {
        label: "\u0627\u0644\u062D\u0631\u064A\u0641",
        placeholder: "\u0627\u062E\u062A\u0631 \u062D\u0631\u064A\u0641\u064B\u0627",
        fixed: "\u0644\u0627 \u064A\u062A\u063A\u064A\u0631 \u062D\u0631\u064A\u0641 \u0627\u0644\u0639\u0642\u062F."
      },
      project: {
        label: "\u0627\u0644\u0645\u0634\u0631\u0648\u0639",
        none: "\u062F\u0648\u0646 \u0645\u0634\u0631\u0648\u0639",
        current: "\u0627\u0644\u0645\u0634\u0631\u0648\u0639 \u0627\u0644\u062D\u0627\u0644\u064A"
      },
      reference: {
        label: "\u0645\u0631\u062C\u0639 \u0627\u0644\u0639\u0642\u062F",
        hint: "\u0631\u0642\u0645 \u0627\u0644\u0635\u0641\u0642\u0629 \u0623\u0648 \u0627\u0644\u0627\u062A\u0641\u0627\u0642\u064A\u0629\u060C \u0648\u0647\u0648 \u0641\u0631\u064A\u062F \u0641\u064A \u0645\u0643\u062A\u0628\u0643."
      },
      kind: {
        label: "\u0627\u0644\u0635\u0646\u0641",
        hint: "\u062A\u0638\u0647\u0631 \u062A\u0646\u0628\u064A\u0647\u0627\u062A \u0641\u064A \u0627\u0644\u0635\u0641\u0642\u0629 \u0627\u0644\u0639\u0645\u0648\u0645\u064A\u0629 \u0625\u0630\u0627 \u062A\u062C\u0627\u0648\u0632\u062A \u0634\u0631\u0648\u0637\u0647\u0627 \u0627\u0644\u062D\u062F\u0648\u062F \u0627\u0644\u0642\u0627\u0646\u0648\u0646\u064A\u0629."
      },
      currency: {
        label: "\u0627\u0644\u0639\u0645\u0644\u0629"
      },
      amount: {
        label: "\u0627\u0644\u0645\u0628\u0644\u063A \u062F\u0648\u0646 \u0627\u062D\u062A\u0633\u0627\u0628 \u0627\u0644\u0623\u062F\u0627\u0621\u0627\u062A",
        hint: "\u0627\u0644\u0645\u0628\u0644\u063A \u0627\u0644\u0645\u0645\u0636\u0649 \u062F\u0648\u0646 \u0627\u062D\u062A\u0633\u0627\u0628 \u0627\u0644\u0645\u0644\u0627\u062D\u0642."
      },
      signedOn: {
        label: "\u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0625\u0645\u0636\u0627\u0621"
      },
      total: {
        label: "\u0627\u0644\u0645\u062C\u0645\u0648\u0639 \u062F\u0648\u0646 \u0627\u062D\u062A\u0633\u0627\u0628 \u0627\u0644\u0623\u062F\u0627\u0621\u0627\u062A \u0645\u0639 \u0627\u0644\u0645\u0644\u0627\u062D\u0642:"
      },
      advance: {
        label: "\u0627\u0644\u062F\u0641\u0639\u0629 \u0627\u0644\u0645\u0633\u0628\u0642\u0629",
        hint: "\u0628\u0646\u0633\u0628\u0629 \u0645\u0627\u0626\u0648\u064A\u0629 \u0645\u0646 \u0627\u0644\u0645\u0628\u0644\u063A\u060C \u0645\u062B\u0627\u0644: 10."
      },
      retention: {
        label: "\u0627\u0644\u0627\u062D\u062A\u0641\u0627\u0638 \u0628\u0627\u0644\u0636\u0645\u0627\u0646",
        hint: "\u064A\u064F\u0642\u062A\u0637\u0639 \u0645\u0646 \u0643\u0644 \u0641\u0627\u062A\u0648\u0631\u0629 \u062A\u0642\u062F\u0651\u0645 \u0627\u0644\u0623\u0634\u063A\u0627\u0644 \u0648\u064A\u064F\u0631\u0641\u0639 \u0628\u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629 \u0627\u0644\u0646\u0647\u0627\u0626\u064A\u0629."
      },
      retentionBase: {
        label: "\u0623\u0633\u0627\u0633 \u0627\u0644\u0627\u062D\u062A\u0641\u0627\u0638 \u0628\u0627\u0644\u0636\u0645\u0627\u0646",
        hint: "\u062F\u0648\u0646 \u0627\u062D\u062A\u0633\u0627\u0628 \u0627\u0644\u0623\u062F\u0627\u0621\u0627\u062A \u0628\u0634\u0643\u0644 \u0627\u0641\u062A\u0631\u0627\u0636\u064A\u061B \u064A\u062C\u0628 \u062A\u0623\u0643\u064A\u062F\u0647 \u0645\u0639 \u0627\u0644\u062E\u0628\u064A\u0631 \u0627\u0644\u0645\u062D\u0627\u0633\u0628.",
        ht: "\u0627\u0644\u0645\u0628\u0644\u063A \u062F\u0648\u0646 \u0627\u062D\u062A\u0633\u0627\u0628 \u0627\u0644\u0623\u062F\u0627\u0621\u0627\u062A",
        ttc: "\u0627\u0644\u0645\u0628\u0644\u063A \u0628\u0627\u062D\u062A\u0633\u0627\u0628 \u0643\u0644 \u0627\u0644\u0623\u062F\u0627\u0621\u0627\u062A"
      },
      bond: {
        label: "\u0627\u0644\u0643\u0641\u0627\u0644\u0629 \u0627\u0644\u0646\u0647\u0627\u0626\u064A\u0629",
        hint: "\u0628\u0646\u0633\u0628\u0629 \u0645\u0627\u0626\u0648\u064A\u0629 \u0645\u0646 \u0627\u0644\u0645\u0628\u0644\u063A."
      },
      bondReleaseOn: {
        label: "\u062A\u0627\u0631\u064A\u062E \u0631\u0641\u0639 \u0627\u0644\u0643\u0641\u0627\u0644\u0629",
        hint: "\u064A\u064F\u0631\u0633\u0644 \u062A\u0630\u0643\u064A\u0631 \u0642\u0628\u0644 7 \u0623\u064A\u0627\u0645 \u0648\u0641\u064A \u0627\u0644\u064A\u0648\u0645 \u0646\u0641\u0633\u0647. \u064A\u062A\u0637\u0644\u0628 \u0648\u062C\u0648\u062F \u0643\u0641\u0627\u0644\u0629."
      },
      penaltyRate: {
        label: "\u062E\u0637\u064A\u0629 \u0627\u0644\u062A\u0623\u062E\u064A\u0631 \u0641\u064A \u0627\u0644\u064A\u0648\u0645",
        hint: "\u0628\u0646\u0633\u0628\u0629 \u0645\u0627\u0626\u0648\u064A\u0629 \u0645\u0646 \u0627\u0644\u0645\u0628\u0644\u063A \u0639\u0646 \u0643\u0644 \u064A\u0648\u0645 \u062A\u0623\u062E\u064A\u0631."
      },
      penaltyCap: {
        label: "\u0633\u0642\u0641 \u0627\u0644\u062E\u0637\u0627\u064A\u0627",
        hint: "\u0628\u0646\u0633\u0628\u0629 \u0645\u0627\u0626\u0648\u064A\u0629 \u0645\u0646 \u0627\u0644\u0645\u0628\u0644\u063A."
      }
    },
    errors: {
      clientRequired: "\u0627\u062E\u062A\u0631 \u062D\u0631\u064A\u0641\u064B\u0627.",
      referenceRequired: "\u0623\u062F\u062E\u0644 \u0645\u0631\u062C\u0639 \u0627\u0644\u0639\u0642\u062F.",
      amountRequired: "\u0623\u062F\u062E\u0644 \u0645\u0628\u0644\u063A \u0627\u0644\u0639\u0642\u062F.",
      rateInvalid: "\u0623\u062F\u062E\u0644 \u0646\u0633\u0628\u0629 \u0645\u0627\u0626\u0648\u064A\u0629 \u0628\u064A\u0646 0 \u0648100 \u0628\u062E\u0627\u0646\u062A\u064A\u0646 \u0639\u0634\u0631\u064A\u062A\u064A\u0646 \u0639\u0644\u0649 \u0627\u0644\u0623\u0643\u062B\u0631\u060C \u0645\u062B\u0627\u0644: 2.5.",
      bondRequired: "\u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0631\u0641\u0639 \u064A\u0641\u062A\u0631\u0636 \u0648\u062C\u0648\u062F \u0643\u0641\u0627\u0644\u0629: \u0623\u062F\u062E\u0644 \u0646\u0633\u0628\u062A\u0647\u0627.",
      totalNegative: "\u0645\u0639 \u0627\u0644\u0645\u0644\u0627\u062D\u0642 \u0633\u064A\u0635\u0628\u062D \u0627\u0644\u0645\u062C\u0645\u0648\u0639 \u062F\u0648\u0646 \u0627\u0644\u0635\u0641\u0631.",
      clientMismatch: "\u0647\u0630\u0627 \u0627\u0644\u062D\u0631\u064A\u0641 \u0644\u0627 \u064A\u0637\u0627\u0628\u0642 \u0627\u0644\u0639\u0642\u062F.",
      projectMismatch: "\u0647\u0630\u0627 \u0627\u0644\u0645\u0634\u0631\u0648\u0639 \u0644\u0627 \u064A\u0639\u0648\u062F \u0625\u0644\u0649 \u062D\u0631\u064A\u0641 \u0627\u0644\u0639\u0642\u062F.",
      documentNotFound: "\u062A\u0639\u0630\u0651\u0631 \u0627\u0644\u0639\u062B\u0648\u0631 \u0639\u0644\u0649 \u0647\u0630\u0647 \u0627\u0644\u0648\u062B\u064A\u0642\u0629: \u0627\u062E\u062A\u0631 \u0648\u062B\u064A\u0642\u0629 \u0623\u062E\u0631\u0649.",
      staleTitle: "\u0642\u0627\u0645 \u0634\u062E\u0635 \u0622\u062E\u0631 \u0628\u062A\u0639\u062F\u064A\u0644 \u0647\u0630\u0627 \u0627\u0644\u0639\u0642\u062F",
      staleBody: "\u062D\u0641\u0638 \u0634\u062E\u0635 \u0622\u062E\u0631 \u0647\u0630\u0627 \u0627\u0644\u0639\u0642\u062F \u0623\u062B\u0646\u0627\u0621 \u062A\u0639\u062F\u064A\u0644\u0643 \u0644\u0647. \u0623\u0639\u062F \u062A\u062D\u0645\u064A\u0644\u0647 \u0644\u0644\u0627\u0637\u0644\u0627\u0639 \u0639\u0644\u0649 \u0622\u062E\u0631 \u0646\u0633\u062E\u0629 \u062B\u0645 \u0623\u0639\u062F \u062A\u0637\u0628\u064A\u0642 \u062A\u0639\u062F\u064A\u0644\u0627\u062A\u0643.",
      reload: "\u0625\u0639\u0627\u062F\u0629 \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0639\u0642\u062F",
      saveFailed: "\u062A\u0639\u0630\u0651\u0631 \u062D\u0641\u0638 \u0627\u0644\u0639\u0642\u062F"
    },
    save: {
      action: "\u062D\u0641\u0638",
      saving: "\u062C\u0627\u0631\u064D \u0627\u0644\u062D\u0641\u0638\u2026",
      created: "\u062A\u0645 \u0625\u0646\u0634\u0627\u0621 \u0627\u0644\u0639\u0642\u062F {reference}.",
      saved: "\u062A\u0645 \u062D\u0641\u0638 \u0627\u0644\u0639\u0642\u062F {reference}."
    },
    guard: {
      title: "\u0627\u0644\u0645\u063A\u0627\u062F\u0631\u0629 \u062F\u0648\u0646 \u062D\u0641\u0638\u061F",
      body: "\u0633\u062A\u0636\u064A\u0639 \u062A\u0639\u062F\u064A\u0644\u0627\u062A\u0643 \u0639\u0644\u0649 \u0647\u0630\u0627 \u0627\u0644\u0639\u0642\u062F.",
      leave: "\u0645\u063A\u0627\u062F\u0631\u0629",
      stay: "\u0627\u0644\u0628\u0642\u0627\u0621 \u0641\u064A \u0627\u0644\u0639\u0642\u062F"
    },
    warnings: {
      title: "\u0634\u0631\u0648\u0637 \u062A\u062A\u062C\u0627\u0648\u0632 \u062D\u062F\u0648\u062F \u0627\u0644\u0635\u0641\u0642\u0629 \u0627\u0644\u0639\u0645\u0648\u0645\u064A\u0629",
      intro: "\u0647\u0630\u0647 \u0627\u0644\u062A\u0646\u0628\u064A\u0647\u0627\u062A \u0644\u0627 \u062A\u0645\u0646\u0639 \u0627\u0644\u062D\u0641\u0638: \u0641\u0642\u062F \u062A\u0646\u0635 \u0627\u0644\u0635\u0641\u0642\u0629 \u0639\u0644\u0649 \u0627\u0633\u062A\u062B\u0646\u0627\u0621.",
      RETENTION_ABOVE_LIMIT: "\u0627\u0644\u0627\u062D\u062A\u0641\u0627\u0638 \u0628\u0627\u0644\u0636\u0645\u0627\u0646 \u0628\u0646\u0633\u0628\u0629 {actual} \u064A\u062A\u062C\u0627\u0648\u0632 \u0627\u0644\u062D\u062F \u0627\u0644\u0623\u0642\u0635\u0649 {limit}.",
      PERFORMANCE_BOND_ABOVE_LIMIT: "\u0627\u0644\u0643\u0641\u0627\u0644\u0629 \u0627\u0644\u0646\u0647\u0627\u0626\u064A\u0629 \u0628\u0646\u0633\u0628\u0629 {actual} \u062A\u062A\u062C\u0627\u0648\u0632 \u0627\u0644\u062D\u062F \u0627\u0644\u0623\u0642\u0635\u0649 {limit}.",
      RETENTION_PLUS_BOND_ABOVE_LIMIT: "\u0627\u0644\u0627\u062D\u062A\u0641\u0627\u0638 \u0628\u0627\u0644\u0636\u0645\u0627\u0646 \u0648\u0627\u0644\u0643\u0641\u0627\u0644\u0629 \u0645\u0639\u064B\u0627 \u0628\u0646\u0633\u0628\u0629 {actual} \u064A\u062A\u062C\u0627\u0648\u0632\u0627\u0646 \u0627\u0644\u062D\u062F \u0627\u0644\u0623\u0642\u0635\u0649 {limit}.",
      PENALTY_CAP_ABOVE_LIMIT: "\u0633\u0642\u0641 \u0627\u0644\u062E\u0637\u0627\u064A\u0627 \u0628\u0646\u0633\u0628\u0629 {actual} \u064A\u062A\u062C\u0627\u0648\u0632 \u0627\u0644\u062D\u062F \u0627\u0644\u0623\u0642\u0635\u0649 {limit}.",
      ADVANCE_ABOVE_LIMIT: "\u0627\u0644\u062F\u0641\u0639\u0629 \u0627\u0644\u0645\u0633\u0628\u0642\u0629 \u0628\u0646\u0633\u0628\u0629 {actual} \u062A\u062A\u062C\u0627\u0648\u0632 \u0627\u0644\u062D\u062F \u0627\u0644\u0623\u0642\u0635\u0649 {limit} \u0641\u064A \u0635\u0641\u0642\u0629 \u062F\u0631\u0627\u0633\u0627\u062A.",
      legalRef: "\u0627\u0644\u0645\u0631\u062C\u0639 \u0627\u0644\u0642\u0627\u0646\u0648\u0646\u064A: {ref}"
    },
    amendments: {
      caption: "\u0645\u0644\u0627\u062D\u0642 \u0627\u0644\u0639\u0642\u062F",
      add: "\u0625\u0636\u0627\u0641\u0629 \u0645\u0644\u062D\u0642",
      total: "\u0627\u0644\u0645\u062C\u0645\u0648\u0639 \u062F\u0648\u0646 \u0627\u062D\u062A\u0633\u0627\u0628 \u0627\u0644\u0623\u062F\u0627\u0621\u0627\u062A \u0645\u0639 \u0627\u0644\u0645\u0644\u0627\u062D\u0642:",
      empty: {
        title: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0645\u0644\u0627\u062D\u0642",
        description: "\u064A\u063A\u064A\u0651\u0631 \u0627\u0644\u0645\u0644\u062D\u0642 \u0645\u0628\u0644\u063A \u0627\u0644\u0639\u0642\u062F\u061B \u0648\u0628\u0639\u062F \u062D\u0641\u0638\u0647 \u0644\u0627 \u064A\u0645\u0643\u0646 \u062A\u0639\u062F\u064A\u0644\u0647."
      },
      saveFirst: "\u0627\u062D\u0641\u0638 \u062A\u0639\u062F\u064A\u0644\u0627\u062A\u0643 \u0623\u0648\u0644\u064B\u0627 \u0644\u0625\u0636\u0627\u0641\u0629 \u0645\u0644\u062D\u0642.",
      added: "\u062A\u0645\u062A \u0625\u0636\u0627\u0641\u0629 \u0627\u0644\u0645\u0644\u062D\u0642.",
      columns: {
        number: "\u0639\u062F\u062F",
        label: "\u0627\u0644\u0645\u0648\u0636\u0648\u0639",
        delta: "\u062A\u063A\u064A\u0651\u0631 \u0627\u0644\u0645\u0628\u0644\u063A",
        signedOn: "\u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0625\u0645\u0636\u0627\u0621",
        document: "\u0627\u0644\u0648\u062B\u064A\u0642\u0629 \u0627\u0644\u0645\u0645\u0636\u0627\u0629"
      },
      dialog: {
        title: "\u0625\u0636\u0627\u0641\u0629 \u0645\u0644\u062D\u0642",
        intro: "\u0627\u0644\u0645\u0644\u062D\u0642 \u0639\u0642\u062F \u0645\u0645\u0636\u0649: \u0628\u0639\u062F \u062D\u0641\u0638\u0647 \u0644\u0627 \u064A\u0645\u0643\u0646 \u062A\u0639\u062F\u064A\u0644\u0647. \u0641\u064A \u062D\u0627\u0644 \u0627\u0644\u062E\u0637\u0623\u060C \u0623\u0636\u0641 \u0645\u0644\u062D\u0642\u064B\u0627 \u062A\u0635\u062D\u064A\u062D\u064A\u064B\u0627.",
        label: "\u0645\u0648\u0636\u0648\u0639 \u0627\u0644\u0645\u0644\u062D\u0642",
        description: "\u0627\u0644\u0648\u0635\u0641 (\u0627\u062E\u062A\u064A\u0627\u0631\u064A)",
        delta: "\u062A\u063A\u064A\u0651\u0631 \u0627\u0644\u0645\u0628\u0644\u063A \u062F\u0648\u0646 \u0627\u062D\u062A\u0633\u0627\u0628 \u0627\u0644\u0623\u062F\u0627\u0621\u0627\u062A",
        deltaHint: "\u0645\u0648\u062C\u0628 \u0644\u0644\u0632\u064A\u0627\u062F\u0629 \u0648\u0633\u0627\u0644\u0628 \u0644\u0644\u062A\u062E\u0641\u064A\u0636 (\u0645\u062B\u0627\u0644: -500).",
        signedOn: "\u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0625\u0645\u0636\u0627\u0621",
        document: "\u0627\u0644\u0648\u062B\u064A\u0642\u0629 \u0627\u0644\u0645\u0645\u0636\u0627\u0629 (\u0625\u062F\u0627\u0631\u0629 \u0627\u0644\u0648\u062B\u0627\u0626\u0642)",
        documentHint: "\u0627\u062E\u062A\u064A\u0627\u0631\u064A: \u0648\u062B\u064A\u0642\u0629 \u0645\u0646 \u0641\u0636\u0627\u0621 \u0627\u0644\u0645\u0634\u0631\u0648\u0639.",
        noProject: "\u0627\u0631\u0628\u0637 \u0627\u0644\u0639\u0642\u062F \u0628\u0645\u0634\u0631\u0648\u0639 \u0644\u062A\u062A\u0645\u0643\u0646 \u0645\u0646 \u0631\u0628\u0637 \u0648\u062B\u064A\u0642\u0629 \u0628\u0647.",
        submit: "\u0625\u0636\u0627\u0641\u0629 \u0627\u0644\u0645\u0644\u062D\u0642",
        adding: "\u062C\u0627\u0631\u064D \u0627\u0644\u0625\u0636\u0627\u0641\u0629\u2026"
      },
      errors: {
        labelRequired: "\u0623\u0639\u0637\u0650 \u0627\u0644\u0645\u0644\u062D\u0642 \u0645\u0648\u0636\u0648\u0639\u064B\u0627.",
        deltaRequired: "\u0623\u062F\u062E\u0644 \u062A\u063A\u064A\u0651\u0631 \u0627\u0644\u0645\u0628\u0644\u063A.",
        signedOnRequired: "\u0623\u062F\u062E\u0644 \u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0625\u0645\u0636\u0627\u0621."
      }
    },
    document: {
      loading: "\u062C\u0627\u0631\u064D \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0648\u062B\u064A\u0642\u0629\u2026",
      restricted: "\u0648\u062B\u064A\u0642\u0629 \u0645\u0631\u062A\u0628\u0637\u0629 (\u0644\u0627 \u064A\u0645\u0643\u0646\u0643 \u0641\u062A\u062D\u0647\u0627)",
      linked: "\u0648\u062B\u064A\u0642\u0629 \u0645\u0631\u062A\u0628\u0637\u0629"
    },
    picker: {
      none: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0648\u062B\u064A\u0642\u0629 \u0645\u0631\u062A\u0628\u0637\u0629",
      choose: "\u0627\u062E\u062A\u064A\u0627\u0631 \u0648\u062B\u064A\u0642\u0629",
      change: "\u062A\u063A\u064A\u064A\u0631",
      remove: "\u0625\u0632\u0627\u0644\u0629",
      label: "\u0627\u062E\u062A\u064A\u0627\u0631 \u0648\u062B\u064A\u0642\u0629 \u0645\u0646 \u0627\u0644\u0645\u0634\u0631\u0648\u0639",
      location: "\u0627\u0644\u0645\u062C\u0644\u062F: {name}",
      root: "\u062C\u0630\u0631 \u0627\u0644\u0645\u0634\u0631\u0648\u0639",
      up: "\u0627\u0644\u0645\u062C\u0644\u062F \u0627\u0644\u0623\u0628",
      folders: "\u0627\u0644\u0645\u062C\u0644\u062F\u0627\u062A \u0627\u0644\u0641\u0631\u0639\u064A\u0629",
      documents: "\u0648\u062B\u0627\u0626\u0642 \u0627\u0644\u0645\u062C\u0644\u062F",
      openFolder: "\u0641\u062A\u062D \u0627\u0644\u0645\u062C\u0644\u062F {name}",
      openFolderFirst: "\u0627\u0641\u062A\u062D \u0645\u062C\u0644\u062F\u064B\u0627 \u0644\u0639\u0631\u0636 \u0648\u062B\u0627\u0626\u0642\u0647.",
      noDocuments: "\u0647\u0630\u0627 \u0627\u0644\u0645\u062C\u0644\u062F \u0644\u0627 \u064A\u062D\u062A\u0648\u064A \u0639\u0644\u0649 \u0648\u062B\u0627\u0626\u0642.",
      loadFailed: "\u062A\u0639\u0630\u0651\u0631 \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0645\u062C\u0644\u062F\u0627\u062A. \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629 \u0628\u0639\u062F \u0644\u062D\u0638\u0627\u062A."
    },
    progress: {
      prepare: "\u0625\u0639\u062F\u0627\u062F \u0641\u0627\u062A\u0648\u0631\u0629 \u062A\u0642\u062F\u0651\u0645 \u0627\u0644\u0623\u0634\u063A\u0627\u0644",
      loading: "\u062C\u0627\u0631\u064D \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u062A\u0642\u062F\u0651\u0645\u2026",
      loadFailed: "\u062A\u0639\u0630\u0651\u0631 \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u062A\u0642\u062F\u0651\u0645.",
      needProject: "\u0627\u0631\u0628\u0637 \u0647\u0630\u0627 \u0627\u0644\u0639\u0642\u062F \u0628\u0645\u0634\u0631\u0648\u0639 \u0644\u062A\u062A\u0628\u0651\u0639 \u062A\u0642\u062F\u0651\u0645\u0647 \u062D\u0633\u0628 \u0627\u0644\u0645\u0631\u0627\u062D\u0644.",
      needTnd: "\u0641\u0648\u0627\u062A\u064A\u0631 \u062A\u0642\u062F\u0651\u0645 \u0627\u0644\u0623\u0634\u063A\u0627\u0644 \u0628\u0627\u0644\u062F\u064A\u0646\u0627\u0631: \u0627\u0644\u062A\u0642\u062F\u0651\u0645 \u063A\u064A\u0631 \u0645\u062A\u0627\u062D \u0644\u0639\u0645\u0644\u0629 \u0623\u062E\u0631\u0649."
    },
    fromQuote: {
      action: "\u0625\u0646\u0634\u0627\u0621 \u0627\u0644\u0639\u0642\u062F",
      creating: "\u062C\u0627\u0631\u064D \u0627\u0644\u0625\u0646\u0634\u0627\u0621\u2026",
      done: "\u062A\u0645 \u0625\u0646\u0634\u0627\u0621 \u0627\u0644\u0639\u0642\u062F \u0627\u0646\u0637\u0644\u0627\u0642\u064B\u0627 \u0645\u0646 \u0627\u0644\u0639\u0631\u0636 \u0627\u0644\u0645\u0627\u0644\u064A."
    },
    projectTab: {
      contract: "\u0627\u0644\u0639\u0642\u062F",
      openContract: "\u0641\u062A\u062D \u0627\u0644\u0639\u0642\u062F",
      empty: {
        title: "\u0644\u0627 \u064A\u0648\u062C\u062F \u0639\u0642\u062F \u0644\u0647\u0630\u0627 \u0627\u0644\u0645\u0634\u0631\u0648\u0639",
        description: "\u0623\u0646\u0634\u0626 \u0627\u0644\u0639\u0642\u062F \u0644\u0645\u062A\u0627\u0628\u0639\u0629 \u0627\u0644\u062F\u0641\u0639\u0629 \u0627\u0644\u0645\u0633\u0628\u0642\u0629 \u0648\u0627\u0644\u0627\u062D\u062A\u0641\u0627\u0638 \u0628\u0627\u0644\u0636\u0645\u0627\u0646 \u0648\u0627\u0644\u0641\u0648\u062A\u0631\u0629 \u062D\u0633\u0628 \u0627\u0644\u0645\u0631\u0627\u062D\u0644.",
        fromQuote: "\u062A\u0645 \u0642\u0628\u0648\u0644 \u0627\u0644\u0639\u0631\u0636 \u0627\u0644\u0645\u0627\u0644\u064A {number}: \u064A\u0623\u062E\u0630 \u0627\u0644\u0639\u0642\u062F \u062D\u0631\u064A\u0641\u0647 \u0648\u0645\u0628\u0644\u063A\u0647.",
        descriptionReadOnly: "\u0633\u064A\u0638\u0647\u0631 \u0647\u0646\u0627 \u0639\u0642\u062F \u0647\u0630\u0627 \u0627\u0644\u0645\u0634\u0631\u0648\u0639.",
        create: "\u0625\u0646\u0634\u0627\u0621 \u0627\u0644\u0639\u0642\u062F",
        createFromQuote: "\u0625\u0646\u0634\u0627\u0621 \u0627\u0644\u0639\u0642\u062F \u0627\u0646\u0637\u0644\u0627\u0642\u064B\u0627 \u0645\u0646 \u0627\u0644\u0639\u0631\u0636 \u0627\u0644\u0645\u0627\u0644\u064A"
      },
      quotesInvoices: "\u0627\u0644\u0639\u0631\u0648\u0636 \u0627\u0644\u0645\u0627\u0644\u064A\u0629 \u0648\u0627\u0644\u0641\u0648\u0627\u062A\u064A\u0631",
      quotes: "\u0627\u0644\u0639\u0631\u0648\u0636 \u0627\u0644\u0645\u0627\u0644\u064A\u0629 \u0644\u0644\u0645\u0634\u0631\u0648\u0639",
      noQuotes: "\u0644\u0627 \u064A\u0648\u062C\u062F \u0639\u0631\u0636 \u0645\u0627\u0644\u064A \u0645\u0631\u062A\u0628\u0637 \u0628\u0647\u0630\u0627 \u0627\u0644\u0645\u0634\u0631\u0648\u0639.",
      allQuotes: "\u0643\u0644 \u0627\u0644\u0639\u0631\u0648\u0636 \u0627\u0644\u0645\u0627\u0644\u064A\u0629",
      allInvoices: "\u0643\u0644 \u0627\u0644\u0641\u0648\u0627\u062A\u064A\u0631",
      noAccessTitle: "\u0627\u0644\u0645\u0627\u0644\u064A\u0629 \u063A\u064A\u0631 \u0645\u062A\u0627\u062D\u0629",
      noAccessBody: "\u0644\u064A\u0633 \u0644\u062F\u064A\u0643 \u062D\u0642 \u0627\u0644\u0627\u0637\u0644\u0627\u0639 \u0639\u0644\u0649 \u0627\u0644\u0645\u0639\u0644\u0648\u0645\u0627\u062A \u0627\u0644\u0645\u0627\u0644\u064A\u0629 \u0644\u0647\u0630\u0627 \u0627\u0644\u0645\u0634\u0631\u0648\u0639."
    }
  },
  progress: {
    title: "\u0641\u0627\u062A\u0648\u0631\u0629 \u062A\u0642\u062F\u0651\u0645 \u0627\u0644\u0623\u0634\u063A\u0627\u0644 \u2014 \u0627\u0644\u0639\u0642\u062F {reference}",
    titleShort: "\u0641\u0627\u062A\u0648\u0631\u0629 \u062A\u0642\u062F\u0651\u0645 \u0627\u0644\u0623\u0634\u063A\u0627\u0644",
    help: "\u0623\u062F\u062E\u0644 \u0627\u0644\u062A\u0642\u062F\u0651\u0645 \u0627\u0644\u062A\u0631\u0627\u0643\u0645\u064A \u0644\u0643\u0644 \u0645\u0631\u062D\u0644\u0629: \u064A\u064F\u062D\u062A\u0633\u0628 \u0645\u0628\u0644\u063A \u0627\u0644\u0641\u062A\u0631\u0629 \u0645\u0628\u0627\u0634\u0631\u0629. \u064A\u064F\u0637\u0628\u0639 \u0627\u0644\u062C\u062F\u0648\u0644 \u0627\u0644\u062A\u0631\u0627\u0643\u0645\u064A \u062D\u0633\u0628 \u0627\u0644\u0645\u0631\u0627\u062D\u0644 \u062A\u0644\u0642\u0627\u0626\u064A\u064B\u0627 \u0639\u0644\u0649 \u0645\u0644\u0641 PDF \u0644\u0644\u0641\u0627\u062A\u0648\u0631\u0629.",
    final: {
      label: "\u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629 \u0627\u0644\u0646\u0647\u0627\u0626\u064A\u0629 \u0639\u0646\u062F \u0627\u0644\u0642\u0628\u0648\u0644 \u0627\u0644\u0646\u0647\u0627\u0626\u064A",
      hint: "\u062A\u0635\u0628\u062D \u0643\u0644 \u0627\u0644\u0645\u0631\u0627\u062D\u0644 100 %\u060C \u0648\u064A\u064F\u0633\u062A\u0631\u062C\u0639 \u0645\u0627 \u062A\u0628\u0642\u0649 \u0645\u0646 \u0627\u0644\u062F\u0641\u0639\u0629 \u0627\u0644\u0645\u0633\u0628\u0642\u0629 \u0648\u064A\u064F\u0631\u0641\u0639 \u0627\u0644\u0627\u062D\u062A\u0641\u0627\u0638 \u0628\u0627\u0644\u0636\u0645\u0627\u0646."
    },
    sections: {
      phases: "\u0627\u0644\u062A\u0642\u062F\u0651\u0645 \u062D\u0633\u0628 \u0627\u0644\u0645\u0631\u0627\u062D\u0644",
      totals: "\u0645\u0628\u0627\u0644\u063A \u0647\u0630\u0647 \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629",
      options: "\u062E\u064A\u0627\u0631\u0627\u062A \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629"
    },
    table: {
      caption: "\u0627\u0644\u062A\u0642\u062F\u0651\u0645 \u0627\u0644\u062A\u0631\u0627\u0643\u0645\u064A \u062D\u0633\u0628 \u0627\u0644\u0645\u0631\u0627\u062D\u0644",
      columns: {
        phase: "\u0627\u0644\u0645\u0631\u062D\u0644\u0629",
        fee: "\u0623\u062A\u0639\u0627\u0628 \u0627\u0644\u0645\u0631\u062D\u0644\u0629",
        previous: "\u0627\u0644\u0645\u0641\u0648\u062A\u0631 \u0633\u0627\u0628\u0642\u064B\u0627",
        cumulative: "\u0627\u0644\u062A\u0631\u0627\u0643\u0645 \u0627\u0644\u062C\u062F\u064A\u062F",
        period: "\u0645\u0628\u0644\u063A \u0627\u0644\u0641\u062A\u0631\u0629"
      },
      cumulativeFor: "\u0627\u0644\u0646\u0633\u0628\u0629 \u0627\u0644\u062A\u0631\u0627\u0643\u0645\u064A\u0629 \u0627\u0644\u062C\u062F\u064A\u062F\u0629 \u0644\u0644\u0645\u0631\u062D\u0644\u0629 {phase}",
      unavailable: "\u0627\u0644\u0645\u0628\u0644\u063A \u063A\u064A\u0631 \u0645\u062A\u0627\u062D"
    },
    totals: {
      work: "\u0623\u0634\u063A\u0627\u0644 \u0627\u0644\u0641\u062A\u0631\u0629 (\u062F\u0648\u0646 \u0627\u062D\u062A\u0633\u0627\u0628 \u0627\u0644\u0623\u062F\u0627\u0621\u0627\u062A)",
      advanceRecovery: "\u0627\u0633\u062A\u0631\u062C\u0627\u0639 \u0627\u0644\u062F\u0641\u0639\u0629 \u0627\u0644\u0645\u0633\u0628\u0642\u0629",
      retention: "\u0627\u0644\u0627\u062D\u062A\u0641\u0627\u0638 \u0628\u0627\u0644\u0636\u0645\u0627\u0646 ({rate})",
      retentionRelease: "\u0631\u0641\u0639 \u0627\u0644\u0627\u062D\u062A\u0641\u0627\u0638 \u0628\u0627\u0644\u0636\u0645\u0627\u0646",
      net: "\u0635\u0627\u0641\u064A \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629 \u062F\u0648\u0646 \u0627\u062D\u062A\u0633\u0627\u0628 \u0627\u0644\u0623\u062F\u0627\u0621\u0627\u062A",
      unavailable: "\u062A\u0639\u0630\u0651\u0631 \u0627\u062D\u062A\u0633\u0627\u0628 \u0627\u0644\u0645\u0628\u0627\u0644\u063A \u062D\u0627\u0644\u064A\u064B\u0627.",
      fixFirst: "\u0635\u062D\u0651\u062D \u0623\u0648\u0644\u064B\u0627 \u0627\u0644\u0646\u0633\u0628 \u0627\u0644\u0645\u0634\u0627\u0631 \u0625\u0644\u064A\u0647\u0627 \u0641\u064A \u0627\u0644\u062C\u062F\u0648\u0644.",
      taxesHint: "\u062A\u064F\u062D\u062A\u0633\u0628 \u0627\u0644\u0623\u062F\u0627\u0621\u0627\u062A \u0639\u0644\u0649 \u0627\u0644\u0642\u064A\u0645\u0629 \u0627\u0644\u0645\u0636\u0627\u0641\u0629 \u0648\u0645\u0639\u0644\u0648\u0645 \u0627\u0644\u0637\u0627\u0628\u0639 \u0648\u0627\u0644\u062E\u0635\u0645 \u0645\u0646 \u0627\u0644\u0645\u0648\u0631\u062F \u0639\u0644\u0649 \u0645\u0633\u0648\u062F\u0629 \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629 \u0627\u0644\u062A\u064A \u062A\u064F\u0641\u062A\u062D \u0628\u0639\u062F \u0627\u0644\u062D\u0641\u0638."
    },
    lines: {
      advanceRecovery: "\u0627\u0633\u062A\u0631\u062C\u0627\u0639 \u0627\u0644\u062F\u0641\u0639\u0629 \u0627\u0644\u0645\u0633\u0628\u0642\u0629",
      retention: "\u0627\u0644\u0627\u062D\u062A\u0641\u0627\u0638 \u0628\u0627\u0644\u0636\u0645\u0627\u0646",
      retentionRelease: "\u0631\u0641\u0639 \u0627\u0644\u0627\u062D\u062A\u0641\u0627\u0638 \u0628\u0627\u0644\u0636\u0645\u0627\u0646"
    },
    options: {
      language: {
        label: "\u0644\u063A\u0629 \u0645\u0644\u0641 PDF",
        hint: "\u0644\u063A\u0629 \u0627\u0644\u0648\u062B\u064A\u0642\u0629 \u0627\u0644\u0645\u0631\u0633\u0644\u0629 \u0625\u0644\u0649 \u0627\u0644\u062D\u0631\u064A\u0641."
      },
      dueDate: {
        label: "\u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0627\u0633\u062A\u062D\u0642\u0627\u0642",
        hint: "\u0627\u062E\u062A\u064A\u0627\u0631\u064A: \u0648\u0625\u0644\u0627 \u0641\u062A\u064F\u0637\u0628\u0651\u0642 \u0634\u0631\u0648\u0637 \u0627\u0644\u062F\u0641\u0639 \u0627\u0644\u062E\u0627\u0635\u0629 \u0628\u0627\u0644\u062D\u0631\u064A\u0641."
      },
      notes: {
        label: "\u0645\u0644\u0627\u062D\u0638\u0627\u062A"
      }
    },
    submit: "\u0625\u0646\u0634\u0627\u0621 \u0645\u0633\u0648\u062F\u0629 \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629",
    submitting: "\u062C\u0627\u0631\u064D \u0627\u0644\u0625\u0646\u0634\u0627\u0621\u2026",
    created: "\u062A\u0645 \u0625\u0646\u0634\u0627\u0621 \u0645\u0633\u0648\u062F\u0629 \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629.",
    readOnlyRights: "\u064A\u0645\u0643\u0646\u0643 \u0627\u0644\u0627\u0637\u0644\u0627\u0639 \u0639\u0644\u0649 \u0627\u0644\u062A\u0642\u062F\u0651\u0645 \u062F\u0648\u0646 \u0625\u0646\u0634\u0627\u0621 \u0641\u0627\u062A\u0648\u0631\u0629.",
    loadFailedTitle: "\u062A\u0639\u0630\u0651\u0631 \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u062A\u0642\u062F\u0651\u0645",
    loadFailedBody: "\u062A\u062D\u0642\u0642 \u0645\u0646 \u0627\u062A\u0635\u0627\u0644\u0643 \u062B\u0645 \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629.",
    blocked: {
      closedTitle: "\u0627\u0644\u0639\u0642\u062F \u0645\u063A\u0644\u0642",
      closedBody: "\u062A\u0645 \u0625\u0635\u062F\u0627\u0631 \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629 \u0627\u0644\u0646\u0647\u0627\u0626\u064A\u0629: \u0644\u0627 \u062A\u0648\u062C\u062F \u0641\u0627\u062A\u0648\u0631\u0629 \u062A\u0642\u062F\u0651\u0645 \u0623\u062E\u0631\u0649 \u0644\u0625\u0639\u062F\u0627\u062F\u0647\u0627.",
      sharesTitle: "\u062D\u0635\u0635 \u0623\u062A\u0639\u0627\u0628 \u0627\u0644\u0645\u0631\u0627\u062D\u0644 \u0644\u0627 \u062A\u0633\u0627\u0648\u064A 100 %",
      sharesBody: "\u064A\u062C\u0628 \u0623\u0646 \u064A\u0628\u0644\u063A \u0645\u062C\u0645\u0648\u0639 \u062D\u0635\u0635 \u0623\u062A\u0639\u0627\u0628 \u0645\u0631\u0627\u062D\u0644 \u0627\u0644\u0645\u0634\u0631\u0648\u0639 100 % \u0644\u062A\u0648\u0632\u064A\u0639 \u0645\u0628\u0644\u063A \u0627\u0644\u0639\u0642\u062F. \u0645\u062C\u0645\u0648\u0639\u0647\u0627 \u062D\u0627\u0644\u064A\u064B\u0627 {total}.",
      sharesLink: "\u0641\u062A\u062D \u0645\u0631\u0627\u062D\u0644 \u0627\u0644\u0645\u0634\u0631\u0648\u0639"
    },
    summary: {
      caption: "\u0627\u0644\u062A\u0642\u062F\u0651\u0645 \u0627\u0644\u0645\u0641\u0648\u062A\u0631 \u062D\u0633\u0628 \u0627\u0644\u0645\u0631\u0627\u062D\u0644",
      total: "\u0645\u062C\u0645\u0648\u0639 \u0627\u0644\u0639\u0642\u062F (\u062F\u0648\u0646 \u0627\u062D\u062A\u0633\u0627\u0628 \u0627\u0644\u0623\u062F\u0627\u0621\u0627\u062A)",
      advance: "\u0627\u0644\u062F\u0641\u0639\u0629 \u0627\u0644\u0645\u0633\u0628\u0642\u0629",
      advanceRecovered: "\u0627\u0644\u062F\u0641\u0639\u0629 \u0627\u0644\u0645\u0633\u0628\u0642\u0629 \u0627\u0644\u0645\u0633\u062A\u0631\u062C\u0639\u0629",
      retentionHeld: "\u0627\u0644\u0627\u062D\u062A\u0641\u0627\u0638 \u0628\u0627\u0644\u0636\u0645\u0627\u0646 \u0627\u0644\u0645\u0642\u062A\u0637\u0639 ({rate})",
      columns: {
        phase: "\u0627\u0644\u0645\u0631\u062D\u0644\u0629",
        status: "\u0627\u0644\u062D\u0627\u0644\u0629",
        fee: "\u0627\u0644\u0623\u062A\u0639\u0627\u0628",
        invoicedBp: "\u0627\u0644\u0645\u0641\u0648\u062A\u0631 (\u062A\u0631\u0627\u0643\u0645\u064A)",
        invoiced: "\u0627\u0644\u0645\u0628\u0644\u063A \u0627\u0644\u0645\u0641\u0648\u062A\u0631"
      }
    },
    errors: {
      below: "\u0639\u0644\u0649 \u0627\u0644\u0623\u0642\u0644 {previous}\u060C \u0648\u0647\u0648 \u0627\u0644\u0645\u0641\u0648\u062A\u0631 \u0633\u0627\u0628\u0642\u064B\u0627.",
      invalid: "\u0623\u062F\u062E\u0644 \u0646\u0633\u0628\u0629 \u0645\u0627\u0626\u0648\u064A\u0629 \u0645\u0646 0 \u0625\u0644\u0649 100 \u0628\u062E\u0627\u0646\u062A\u064A\u0646 \u0639\u0634\u0631\u064A\u062A\u064A\u0646 \u0639\u0644\u0649 \u0627\u0644\u0623\u0643\u062B\u0631.",
      failedTitle: "\u062A\u0639\u0630\u0651\u0631 \u0625\u0646\u0634\u0627\u0621 \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629",
      CUMULATIVE_BELOW_PREVIOUS: "\u0644\u0627 \u064A\u0645\u0643\u0646 \u0623\u0646 \u064A\u0643\u0648\u0646 \u062A\u0631\u0627\u0643\u0645 \u0645\u0631\u062D\u0644\u0629 \u0623\u0642\u0644 \u0645\u0645\u0627 \u062A\u0645\u062A \u0641\u0648\u062A\u0631\u062A\u0647 \u0633\u0627\u0628\u0642\u064B\u0627.",
      CUMULATIVE_OUT_OF_RANGE: "\u064A\u062C\u0628 \u0623\u0646 \u064A\u0643\u0648\u0646 \u062A\u0631\u0627\u0643\u0645 \u0627\u0644\u0645\u0631\u062D\u0644\u0629 \u0628\u064A\u0646 0 \u0648100 %.",
      PHASE_SHARES_NOT_100: "\u064A\u062C\u0628 \u0623\u0646 \u064A\u0628\u0644\u063A \u0645\u062C\u0645\u0648\u0639 \u062D\u0635\u0635 \u0623\u062A\u0639\u0627\u0628 \u0645\u0631\u0627\u062D\u0644 \u0627\u0644\u0645\u0634\u0631\u0648\u0639 100 %. \u0635\u062D\u0651\u062D\u0647\u0627 \u0641\u064A \u062A\u0628\u0648\u064A\u0628 \u0627\u0644\u0645\u0631\u0627\u062D\u0644 \u0628\u0627\u0644\u0645\u0634\u0631\u0648\u0639.",
      PROGRESS_DRAFT_EXISTS: "\u062A\u0648\u062C\u062F \u0641\u0627\u062A\u0648\u0631\u0629 \u062A\u0642\u062F\u0651\u0645 \u0644\u0647\u0630\u0627 \u0627\u0644\u0639\u0642\u062F \u0645\u0627 \u0632\u0627\u0644\u062A \u0645\u0633\u0648\u062F\u0629. \u0627\u062D\u0630\u0641\u0647\u0627 \u0623\u0648 \u0623\u0635\u062F\u0631\u0647\u0627 \u0642\u0628\u0644 \u0625\u0646\u0634\u0627\u0621 \u0623\u062E\u0631\u0649.",
      CONTRACT_CLOSED: "\u062A\u0645 \u0625\u0635\u062F\u0627\u0631 \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629 \u0627\u0644\u0646\u0647\u0627\u0626\u064A\u0629 \u0644\u0647\u0630\u0627 \u0627\u0644\u0639\u0642\u062F \u0645\u0646 \u0642\u0628\u0644.",
      NOTHING_TO_INVOICE: "\u0644\u0645 \u062A\u062A\u0642\u062F\u0645 \u0623\u064A \u0645\u0631\u062D\u0644\u0629 \u0645\u0646\u0630 \u0622\u062E\u0631 \u0641\u0627\u062A\u0648\u0631\u0629: \u0644\u0627 \u0634\u064A\u0621 \u0644\u0644\u0641\u0648\u062A\u0631\u0629.",
      CONTRACT_CURRENCY: "\u0641\u0648\u0627\u062A\u064A\u0631 \u062A\u0642\u062F\u0651\u0645 \u0627\u0644\u0623\u0634\u063A\u0627\u0644 \u0628\u0627\u0644\u062F\u064A\u0646\u0627\u0631 \u0627\u0644\u062A\u0648\u0646\u0633\u064A.",
      CONTRACT_WITHOUT_PROJECT: "\u0627\u0631\u0628\u0637 \u0647\u0630\u0627 \u0627\u0644\u0639\u0642\u062F \u0628\u0645\u0634\u0631\u0648\u0639 \u0623\u0648\u0644\u064B\u0627.",
      PHASE_NOT_IN_PROJECT: "\u0645\u0631\u062D\u0644\u0629 \u0644\u0627 \u062A\u0639\u0648\u062F \u0625\u0644\u0649 \u0645\u0634\u0631\u0648\u0639 \u0647\u0630\u0627 \u0627\u0644\u0639\u0642\u062F. \u0623\u0639\u062F \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0635\u0641\u062D\u0629.",
      FINAL_NEEDS_100: "\u062A\u064F\u063A\u0644\u0642 \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629 \u0627\u0644\u0646\u0647\u0627\u0626\u064A\u0629 \u0643\u0644 \u0627\u0644\u0645\u0631\u0627\u062D\u0644 \u0639\u0646\u062F 100 %.",
      CONTRACT_TOTAL_INVALID: "\u064A\u062C\u0628 \u0623\u0646 \u064A\u0643\u0648\u0646 \u0645\u0628\u0644\u063A \u0627\u0644\u0639\u0642\u062F \u0623\u0643\u0628\u0631 \u0645\u0646 \u0627\u0644\u0635\u0641\u0631."
    }
  },
  publicQuote: {
    language: "\u0627\u0644\u0644\u063A\u0629",
    brand: "\u0639\u0631\u0636 \u0645\u0646 {organization}",
    number: "\u0627\u0644\u0639\u0631\u0636 \u0627\u0644\u0645\u0627\u0644\u064A {number}",
    client: "\u0625\u0644\u0649: {client}",
    validUntil: "\u0635\u0627\u0644\u062D \u0625\u0644\u0649 \u063A\u0627\u064A\u0629 {date}",
    linesTitle: "\u062A\u0641\u0635\u064A\u0644 \u0627\u0644\u062E\u062F\u0645\u0627\u062A",
    linesCaption: "\u062E\u062F\u0645\u0627\u062A \u0627\u0644\u0639\u0631\u0636 \u0627\u0644\u0645\u0627\u0644\u064A",
    description: "\u0627\u0644\u062E\u062F\u0645\u0629",
    amount: "\u0627\u0644\u0645\u0628\u0644\u063A \u062F\u0648\u0646 \u0627\u062D\u062A\u0633\u0627\u0628 \u0627\u0644\u0623\u062F\u0627\u0621\u0627\u062A",
    pdf: {
      title: "\u0648\u062B\u064A\u0642\u0629 \u0627\u0644\u0639\u0631\u0636 \u0627\u0644\u0645\u0627\u0644\u064A",
      open: "\u0641\u062A\u062D \u0645\u0644\u0641 PDF",
      opening: "\u062C\u0627\u0631\u064D \u0627\u0644\u0641\u062A\u062D\u2026",
      preparing: "\u0645\u0644\u0641 PDF \u0642\u064A\u062F \u0627\u0644\u0625\u0639\u062F\u0627\u062F. \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629 \u0628\u0639\u062F \u062B\u0648\u0627\u0646\u064D.",
      failed: "\u062A\u0639\u0630\u0651\u0631 \u0641\u062A\u062D \u0645\u0644\u0641 PDF. \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629 \u0628\u0639\u062F \u0644\u062D\u0638\u0627\u062A."
    },
    accept: {
      title: "\u0642\u0628\u0648\u0644 \u0647\u0630\u0627 \u0627\u0644\u0639\u0631\u0636 \u0627\u0644\u0645\u0627\u0644\u064A",
      intro: "\u0644\u0644\u0642\u0628\u0648\u0644\u060C \u0627\u0643\u062A\u0628 \u0627\u0633\u0645\u0643 \u0627\u0644\u0643\u0627\u0645\u0644 \u0648\u0636\u0639 \u0639\u0644\u0627\u0645\u0629 \u0641\u064A \u0627\u0644\u062E\u0627\u0646\u0629. \u064A\u064F\u0633\u062C\u064E\u0651\u0644 \u0642\u0628\u0648\u0644\u0643 \u0645\u0639 \u0627\u0644\u062A\u0627\u0631\u064A\u062E \u0648\u0627\u0644\u0648\u0642\u062A \u0648\u0627\u0644\u0648\u062B\u064A\u0642\u0629 \u0627\u0644\u062A\u064A \u0627\u0637\u0644\u0639\u062A \u0639\u0644\u064A\u0647\u0627.",
      fullName: {
        label: "\u0627\u0644\u0627\u0633\u0645 \u0648\u0627\u0644\u0644\u0642\u0628",
        hint: "\u0643\u0645\u0627 \u064A\u0638\u0647\u0631 \u0641\u064A \u0648\u062B\u0627\u0626\u0642\u0643 \u0627\u0644\u0631\u0633\u0645\u064A\u0629."
      },
      fullNameInvalid: "\u0627\u0643\u062A\u0628 \u0627\u0633\u0645\u0643 \u0627\u0644\u0643\u0627\u0645\u0644 (3 \u0623\u062D\u0631\u0641 \u0639\u0644\u0649 \u0627\u0644\u0623\u0642\u0644).",
      consent: "\u0623\u0642\u0628\u0644 \u0647\u0630\u0627 \u0627\u0644\u0639\u0631\u0636 \u0627\u0644\u0645\u0627\u0644\u064A \u0648\u0634\u0631\u0648\u0637\u0647\u060C \u0648\u0623\u0624\u0643\u062F \u0623\u0646 \u0644\u064A \u0635\u0644\u0627\u062D\u064A\u0629 \u0625\u0644\u0632\u0627\u0645 {client}.",
      submit: "\u0642\u0628\u0648\u0644 \u0627\u0644\u0639\u0631\u0636 \u0627\u0644\u0645\u0627\u0644\u064A",
      submitting: "\u062C\u0627\u0631\u064D \u0627\u0644\u062A\u0633\u062C\u064A\u0644\u2026",
      failedTitle: "\u062A\u0639\u0630\u0651\u0631 \u062A\u0633\u062C\u064A\u0644 \u0642\u0628\u0648\u0644\u0643"
    },
    confirmation: {
      title: "\u0634\u0643\u0631\u064B\u0627\u060C \u062A\u0645 \u0642\u0628\u0648\u0644 \u0627\u0644\u0639\u0631\u0636 \u0627\u0644\u0645\u0627\u0644\u064A",
      body: "\u0642\u0628\u0644 {name} \u0627\u0644\u0639\u0631\u0636 \u0627\u0644\u0645\u0627\u0644\u064A {number} \u0628\u062A\u0627\u0631\u064A\u062E {date}. \u062A\u0645 \u0625\u0639\u0644\u0627\u0645 \u0627\u0644\u0645\u0643\u062A\u0628 \u0648\u0633\u064A\u062A\u0635\u0644 \u0628\u0643 \u0644\u0645\u062A\u0627\u0628\u0639\u0629 \u0627\u0644\u0625\u062C\u0631\u0627\u0621\u0627\u062A.",
      bodyPast: "\u062A\u0645 \u0642\u0628\u0648\u0644 \u0647\u0630\u0627 \u0627\u0644\u0639\u0631\u0636 \u0627\u0644\u0645\u0627\u0644\u064A \u0645\u0646 {name} \u0628\u062A\u0627\u0631\u064A\u062E {date}.",
      titlePast: "\u062A\u0645 \u0642\u0628\u0648\u0644 \u0647\u0630\u0627 \u0627\u0644\u0639\u0631\u0636 \u0627\u0644\u0645\u0627\u0644\u064A"
    },
    states: {
      rejectedTitle: "\u062A\u0645 \u0631\u0641\u0636 \u0647\u0630\u0627 \u0627\u0644\u0639\u0631\u0636 \u0627\u0644\u0645\u0627\u0644\u064A",
      rejectedBody: "\u0644\u0645 \u064A\u0639\u062F \u0647\u0630\u0627 \u0627\u0644\u0639\u0631\u0636 \u0627\u0644\u0645\u0627\u0644\u064A \u0645\u062A\u0627\u062D\u064B\u0627. \u0627\u062A\u0635\u0644 \u0628\u0627\u0644\u0645\u0643\u062A\u0628 \u0625\u0646 \u0631\u063A\u0628\u062A \u0641\u064A \u0639\u0631\u0636 \u062C\u062F\u064A\u062F.",
      expiredTitle: "\u0644\u0645 \u064A\u0639\u062F \u0647\u0630\u0627 \u0627\u0644\u0639\u0631\u0636 \u0627\u0644\u0645\u0627\u0644\u064A \u0635\u0627\u0644\u062D\u064B\u0627",
      expiredBody: "\u0627\u0646\u0642\u0636\u0649 \u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0635\u0644\u0627\u062D\u064A\u0629. \u0627\u0637\u0644\u0628 \u0645\u0646 \u0627\u0644\u0645\u0643\u062A\u0628 \u0639\u0631\u0636\u064B\u0627 \u062C\u062F\u064A\u062F\u064B\u0627.",
      notFoundTitle: "\u0647\u0630\u0627 \u0627\u0644\u0631\u0627\u0628\u0637 \u063A\u064A\u0631 \u0635\u0627\u0644\u062D",
      notFoundBody: "\u0627\u0644\u0631\u0627\u0628\u0637 \u0646\u0627\u0642\u0635 \u0623\u0648 \u0644\u0645 \u064A\u0639\u062F \u0645\u0648\u062C\u0648\u062F\u064B\u0627. \u0627\u0633\u062A\u0639\u0645\u0644 \u0627\u0644\u0631\u0627\u0628\u0637 \u0627\u0644\u0648\u0627\u0631\u062F \u0641\u064A \u0627\u0644\u0628\u0631\u064A\u062F \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A \u0627\u0644\u0630\u064A \u062A\u0644\u0642\u064A\u062A\u0647 \u0623\u0648 \u0627\u062A\u0635\u0644 \u0628\u0627\u0644\u0645\u0643\u062A\u0628.",
      loadFailedTitle: "\u062A\u0639\u0630\u0651\u0631 \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0639\u0631\u0636 \u0627\u0644\u0645\u0627\u0644\u064A",
      loadFailedBody: "\u062A\u062D\u0642\u0642 \u0645\u0646 \u0627\u062A\u0635\u0627\u0644\u0643 \u062B\u0645 \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629.",
      loading: "\u062C\u0627\u0631\u064D \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0639\u0631\u0636 \u0627\u0644\u0645\u0627\u0644\u064A\u2026"
    }
  },
  invoices: {
    status: {
      draft: "\u0645\u0633\u0648\u062F\u0629",
      issued: "\u0635\u0627\u062F\u0631\u0629",
      credited: "\u0645\u0644\u063A\u0627\u0629 \u0628\u0641\u0627\u062A\u0648\u0631\u0629 \u062A\u0639\u062F\u064A\u0644\u064A\u0629"
    },
    ttn: {
      not_required: "\u063A\u064A\u0631 \u0645\u0637\u0644\u0648\u0628\u0629",
      pending: "\u0642\u064A\u062F \u0627\u0644\u0627\u0646\u062A\u0638\u0627\u0631",
      submitted: "\u0645\u064F\u0631\u0633\u064E\u0644\u0629",
      submitted_manually: "\u0645\u064F\u0631\u0633\u064E\u0644\u0629 \u064A\u062F\u0648\u064A\u064B\u0627",
      accepted: "\u0645\u0642\u0628\u0648\u0644\u0629",
      rejected: "\u0645\u0631\u0641\u0648\u0636\u0629"
    },
    paymentStatus: {
      unpaid: "\u063A\u064A\u0631 \u0645\u062F\u0641\u0648\u0639\u0629",
      partially_paid: "\u0645\u062F\u0641\u0648\u0639\u0629 \u062C\u0632\u0626\u064A\u064B\u0627",
      paid: "\u0645\u062F\u0641\u0648\u0639\u0629"
    },
    kind: {
      advance: "\u0641\u0627\u062A\u0648\u0631\u0629 \u0633\u0644\u0641\u0629",
      deposit: "\u0641\u0627\u062A\u0648\u0631\u0629 \u062A\u0633\u0628\u0642\u0629",
      progress: "\u0641\u0627\u062A\u0648\u0631\u0629 \u0645\u0631\u062D\u0644\u064A\u0629",
      final: "\u0641\u0627\u062A\u0648\u0631\u0629 \u0646\u0647\u0627\u0626\u064A\u0629",
      credit_note: "\u0641\u0627\u062A\u0648\u0631\u0629 \u062A\u0639\u062F\u064A\u0644\u064A\u0629"
    },
    list: {
      caption: "\u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u0641\u0648\u0627\u062A\u064A\u0631",
      new: "\u0641\u0627\u062A\u0648\u0631\u0629 \u062C\u062F\u064A\u062F\u0629",
      draftNumber: "\u0645\u0633\u0648\u062F\u0629",
      columns: {
        number: "\u0627\u0644\u0631\u0642\u0645",
        client: "\u0627\u0644\u062D\u0631\u064A\u0641",
        kind: "\u0627\u0644\u0646\u0648\u0639",
        status: "\u0627\u0644\u062D\u0627\u0644\u0629",
        ttn: "\u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629 \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A\u0629 (TTN)",
        payment: "\u0627\u0644\u062F\u0641\u0639",
        totalTtc: "\u0627\u0644\u0645\u062C\u0645\u0648\u0639 \u0628\u0627\u062D\u062A\u0633\u0627\u0628 \u0643\u0644 \u0627\u0644\u0623\u062F\u0627\u0621\u0627\u062A",
        netPayable: "\u0627\u0644\u0635\u0627\u0641\u064A \u0644\u0644\u062F\u0641\u0639",
        issueDate: "\u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0625\u0635\u062F\u0627\u0631",
        dueDate: "\u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0627\u0633\u062A\u062D\u0642\u0627\u0642"
      },
      filters: {
        label: "\u0645\u0631\u0634\u062D\u0627\u062A \u0627\u0644\u0641\u0648\u0627\u062A\u064A\u0631",
        status: "\u0627\u0644\u062D\u0627\u0644\u0629",
        payment: "\u0627\u0644\u062F\u0641\u0639",
        kind: "\u0627\u0644\u0646\u0648\u0639",
        allStatuses: "\u0643\u0644 \u0627\u0644\u062D\u0627\u0644\u0627\u062A",
        allPayments: "\u0643\u0644 \u062D\u0627\u0644\u0627\u062A \u0627\u0644\u062F\u0641\u0639",
        allKinds: "\u0643\u0644 \u0627\u0644\u0623\u0646\u0648\u0627\u0639"
      },
      empty: {
        title: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0641\u0648\u0627\u062A\u064A\u0631 \u0628\u0639\u062F",
        description: "\u0623\u0646\u0634\u0626 \u0623\u0648\u0644 \u0641\u0627\u062A\u0648\u0631\u0629: \u062A\u064F\u062D\u062A\u0633\u0628 \u0645\u0628\u0627\u0634\u0631\u0629 \u0648\u062A\u062D\u0635\u0644 \u0639\u0644\u0649 \u0631\u0642\u0645\u0647\u0627 \u0627\u0644\u0646\u0647\u0627\u0626\u064A \u0639\u0646\u062F \u0627\u0644\u0625\u0635\u062F\u0627\u0631.",
        descriptionReadOnly: "\u0633\u062A\u0638\u0647\u0631 \u0647\u0646\u0627 \u0641\u0648\u0627\u062A\u064A\u0631 \u0645\u0643\u062A\u0628\u0643."
      },
      filtered: {
        title: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0641\u0627\u062A\u0648\u0631\u0629 \u0645\u0637\u0627\u0628\u0642\u0629",
        description: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0641\u0627\u062A\u0648\u0631\u0629 \u062A\u0633\u062A\u062C\u064A\u0628 \u0644\u0647\u0630\u0647 \u0627\u0644\u0645\u0631\u0634\u062D\u0627\u062A. \u062C\u0631\u0651\u0628 \u0645\u0631\u0634\u062D\u0627\u062A \u0623\u062E\u0631\u0649."
      },
      clearFilters: "\u0645\u0633\u062D \u0627\u0644\u0645\u0631\u0634\u062D\u0627\u062A",
      loadMore: "\u0639\u0631\u0636 \u0627\u0644\u0645\u0632\u064A\u062F \u0645\u0646 \u0627\u0644\u0641\u0648\u0627\u062A\u064A\u0631",
      loadingMore: "\u062C\u0627\u0631\u064D \u0627\u0644\u062A\u062D\u0645\u064A\u0644\u2026",
      loadFailedTitle: "\u062A\u0639\u0630\u0651\u0631 \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0641\u0648\u0627\u062A\u064A\u0631",
      loadFailedBody: "\u062A\u062D\u0642\u0642 \u0645\u0646 \u0627\u062A\u0635\u0627\u0644\u0643 \u062B\u0645 \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629.",
      none: "\u2014"
    },
    editor: {
      newTitle: "\u0641\u0627\u062A\u0648\u0631\u0629 \u062C\u062F\u064A\u062F\u0629",
      draftTitle: "\u0641\u0627\u062A\u0648\u0631\u0629 \u0641\u064A \u0635\u064A\u063A\u0629 \u0645\u0633\u0648\u062F\u0629",
      detailTitle: "\u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629 {number}",
      creditNoteTitle: "\u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629 \u0627\u0644\u062A\u0639\u062F\u064A\u0644\u064A\u0629 {number}",
      breadcrumbList: "\u0627\u0644\u0641\u0648\u0627\u062A\u064A\u0631",
      loadFailedTitle: "\u062A\u0639\u0630\u0651\u0631 \u062A\u062D\u0645\u064A\u0644 \u0647\u0630\u0647 \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629",
      loadFailedBody: "\u0625\u0645\u0627 \u0623\u0646\u0647\u0627 \u063A\u064A\u0631 \u0645\u0648\u062C\u0648\u062F\u0629 \u0623\u0648 \u0644\u064A\u0633 \u0644\u062F\u064A\u0643 \u062D\u0642 \u0627\u0644\u0627\u0637\u0644\u0627\u0639 \u0639\u0644\u064A\u0647\u0627.",
      readOnlyRights: "\u064A\u0645\u0643\u0646\u0643 \u0627\u0644\u0627\u0637\u0644\u0627\u0639 \u0639\u0644\u0649 \u0647\u0630\u0647 \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629 \u0644\u0643\u0646 \u0644\u064A\u0633 \u0644\u062F\u064A\u0643 \u062D\u0642 \u062A\u0639\u062F\u064A\u0644\u0647\u0627.",
      readOnlyIssued: "\u0647\u0630\u0647 \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629 \u0635\u0627\u062F\u0631\u0629: \u0644\u0627 \u064A\u0645\u0643\u0646 \u062A\u0639\u062F\u064A\u0644\u0647\u0627 \u0623\u0628\u062F\u064B\u0627. \u0644\u062A\u0635\u062D\u064A\u062D\u0647\u0627\u060C \u0623\u0635\u062F\u0631 \u0641\u0627\u062A\u0648\u0631\u0629 \u062A\u0639\u062F\u064A\u0644\u064A\u0629.",
      readOnlyCreditNote: "\u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629 \u0627\u0644\u062A\u0639\u062F\u064A\u0644\u064A\u0629 \u0627\u0644\u0635\u0627\u062F\u0631\u0629 \u0646\u0647\u0627\u0626\u064A\u0629: \u0644\u0627 \u064A\u0645\u0643\u0646 \u062A\u0639\u062F\u064A\u0644\u0647\u0627.",
      linesLocked: "\u0628\u0646\u0648\u062F \u0647\u0630\u0647 \u0627\u0644\u0645\u0633\u0648\u062F\u0629 \u0622\u062A\u064A\u0629 \u0645\u0646 \u0643\u0634\u0641 \u0627\u0644\u0625\u0646\u062C\u0627\u0632 (\u0627\u0644\u0633\u0644\u0641\u0627\u062A \u0648\u0627\u0644\u0627\u0642\u062A\u0637\u0627\u0639\u0627\u062A). \u0644\u062A\u063A\u064A\u064A\u0631\u0647\u0627\u060C \u0627\u062D\u0630\u0641 \u0627\u0644\u0645\u0633\u0648\u062F\u0629 \u062B\u0645 \u0623\u0646\u0634\u0626\u0647\u0627 \u0645\u0646 \u062C\u062F\u064A\u062F\u061B \u0623\u0645\u0627 \u0628\u0642\u064A\u0629 \u0627\u0644\u062D\u0642\u0648\u0644 \u0641\u064A\u0645\u0643\u0646 \u062A\u0639\u062F\u064A\u0644\u0647\u0627."
    },
    sections: {
      general: "\u0645\u0639\u0644\u0648\u0645\u0627\u062A \u0639\u0627\u0645\u0629",
      lines: "\u0628\u0646\u0648\u062F \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629",
      attachments: "\u0627\u0644\u0645\u0631\u0641\u0642\u0627\u062A",
      notes: "\u0645\u0644\u0627\u062D\u0638\u0627\u062A",
      history: "\u0645\u062A\u0627\u0628\u0639\u0629 \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629"
    },
    fields: {
      kind: {
        label: "\u0646\u0648\u0639 \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629",
        hint: "\u0633\u0644\u0641\u0629 \u0623\u0648 \u062A\u0633\u0628\u0642\u0629 \u0623\u0648 \u0643\u0634\u0641 \u0625\u0646\u062C\u0627\u0632 \u0623\u0648 \u0641\u0627\u062A\u0648\u0631\u0629 \u0646\u0647\u0627\u0626\u064A\u0629."
      },
      client: {
        label: "\u0627\u0644\u062D\u0631\u064A\u0641",
        placeholder: "\u0627\u062E\u062A\u0631 \u062D\u0631\u064A\u0641\u064B\u0627",
        hint: "\u0635\u0627\u062D\u0628 \u0627\u0644\u0645\u0634\u0631\u0648\u0639 \u0627\u0644\u0645\u0637\u0644\u0648\u0628 \u0641\u0648\u062A\u0631\u062A\u0647."
      },
      project: {
        label: "\u0627\u0644\u0645\u0634\u0631\u0648\u0639",
        none: "\u0628\u0644\u0627 \u0645\u0634\u0631\u0648\u0639",
        current: "\u0627\u0644\u0645\u0634\u0631\u0648\u0639 \u0627\u0644\u062D\u0627\u0644\u064A",
        hint: "\u064A\u062A\u064A\u062D \u062A\u0631\u062A\u064A\u0628 \u0627\u0644\u0628\u0646\u0648\u062F \u062D\u0633\u0628 \u0627\u0644\u0645\u0631\u0627\u062D\u0644."
      },
      series: {
        label: "\u0633\u0644\u0633\u0644\u0629 \u0627\u0644\u062A\u0631\u0642\u064A\u0645",
        hint: "\u064A\u064F\u0633\u0646\u062F \u0627\u0644\u0631\u0642\u0645 \u0639\u0646\u062F \u0625\u0635\u062F\u0627\u0631 \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629\u060C \u062F\u0648\u0646 \u0623\u064A \u0641\u0631\u0627\u063A.",
        default: "\u0627\u0644\u0633\u0644\u0633\u0644\u0629 \u0627\u0644\u0627\u0641\u062A\u0631\u0627\u0636\u064A\u0629"
      },
      language: {
        label: "\u0644\u063A\u0629 \u0645\u0644\u0641 PDF",
        hint: "\u0644\u063A\u0629 \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629 \u0627\u0644\u0645\u0637\u0628\u0648\u0639\u0629.",
        fr: "\u0627\u0644\u0641\u0631\u0646\u0633\u064A\u0629",
        ar: "\u0627\u0644\u0639\u0631\u0628\u064A\u0629",
        bilingual: "\u062B\u0646\u0627\u0626\u064A \u0627\u0644\u0644\u063A\u0629 (\u0627\u0644\u0641\u0631\u0646\u0633\u064A\u0629 \u0648\u0627\u0644\u0639\u0631\u0628\u064A\u0629)"
      },
      currency: {
        label: "\u0627\u0644\u0639\u0645\u0644\u0629"
      },
      exchangeRate: {
        label: "\u0633\u0639\u0631 \u0627\u0644\u0635\u0631\u0641 (\u062F\u064A\u0646\u0627\u0631 \u062A\u0648\u0646\u0633\u064A \u0645\u0642\u0627\u0628\u0644 \u0648\u062D\u062F\u0629 \u0648\u0627\u062D\u062F\u0629)",
        hint: "\u0645\u062B\u0627\u0644: 3.350 \u0645\u0642\u0627\u0628\u0644 1 \u0623\u0648\u0631\u0648. \u062A\u064F\u0639\u0637\u0649 \u0627\u0644\u0645\u062C\u0627\u0645\u064A\u0639 \u0623\u064A\u0636\u064B\u0627 \u0628\u0627\u0644\u062F\u064A\u0646\u0627\u0631."
      },
      exchangeRateSource: {
        label: "\u0645\u0635\u062F\u0631 \u0633\u0639\u0631 \u0627\u0644\u0635\u0631\u0641",
        hint: "\u0627\u062E\u062A\u064A\u0627\u0631\u064A: \u0645\u0635\u062F\u0631 \u0627\u0644\u0633\u0639\u0631\u060C \u064A\u064F\u0637\u0628\u0639 \u0645\u0639\u0647 \u0641\u064A \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629.",
        placeholder: "\u0627\u0644\u0628\u0646\u0643 \u0627\u0644\u0645\u0631\u0643\u0632\u064A \u0627\u0644\u062A\u0648\u0646\u0633\u064A\u060C \u0633\u0639\u0631 30/10/2026"
      },
      vatTreatment: {
        label: "\u0646\u0638\u0627\u0645 \u0627\u0644\u0623\u062F\u0627\u0621 \u0639\u0644\u0649 \u0627\u0644\u0642\u064A\u0645\u0629 \u0627\u0644\u0645\u0636\u0627\u0641\u0629",
        hint: "\u0639\u0646\u062F \u0639\u062F\u0645 \u0627\u0644\u0627\u062E\u062A\u064A\u0627\u0631\u060C \u064A\u064F\u0637\u0628\u064E\u0651\u0642 \u0646\u0638\u0627\u0645 \u0627\u0644\u062D\u0631\u064A\u0641.",
        auto: "\u062D\u0633\u0628 \u0627\u0644\u062D\u0631\u064A\u0641",
        standard: "\u0623\u062F\u0627\u0621 \u0639\u0627\u062F\u064A",
        suspended: "\u0623\u062F\u0627\u0621 \u0645\u0639\u0644\u0651\u0642",
        export: "\u062A\u0635\u062F\u064A\u0631 (\u0645\u0639\u0641\u0649)"
      },
      treatmentRef: {
        label: "\u0645\u0631\u062C\u0639 \u0627\u0644\u0646\u0638\u0627\u0645",
        hint: "\u0625\u062C\u0628\u0627\u0631\u064A \u0639\u0646\u062F \u062A\u0639\u0644\u064A\u0642 \u0627\u0644\u0623\u062F\u0627\u0621: \u0631\u0642\u0645 \u0627\u0644\u0634\u0647\u0627\u062F\u0629 \u0623\u0648 \u0627\u0644\u0642\u0631\u0627\u0631."
      },
      dueDate: {
        label: "\u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0627\u0633\u062A\u062D\u0642\u0627\u0642",
        hint: "\u062F\u0648\u0646 \u062A\u0627\u0631\u064A\u062E\u060C \u062A\u064F\u0637\u0628\u064E\u0651\u0642 \u0622\u062C\u0627\u0644 \u0627\u0644\u062F\u0641\u0639 \u0627\u0644\u062E\u0627\u0635\u0629 \u0628\u0627\u0644\u062D\u0631\u064A\u0641 \u0639\u0646\u062F \u0627\u0644\u0625\u0635\u062F\u0627\u0631."
      },
      notes: {
        label: "\u0645\u0644\u0627\u062D\u0638\u0627\u062A \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629",
        hint: "\u062A\u064F\u0637\u0628\u0639 \u0639\u0644\u0649 \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629 (\u0634\u0631\u0648\u0637\u060C \u0628\u064A\u0627\u0646 \u062E\u0627\u0635)."
      },
      issueDate: "\u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0625\u0635\u062F\u0627\u0631",
      ruleSet: "\u0627\u0644\u0642\u0648\u0627\u0639\u062F \u0627\u0644\u062C\u0628\u0627\u0626\u064A\u0629 \u0627\u0644\u0645\u0637\u0628\u064E\u0651\u0642\u0629"
    },
    lines: {
      noPhase: "\u0628\u0646\u0648\u062F \u0623\u062E\u0631\u0649",
      phaseSubtotal: "\u0627\u0644\u0645\u062C\u0645\u0648\u0639 \u0627\u0644\u0641\u0631\u0639\u064A \u062F\u0648\u0646 \u0627\u062D\u062A\u0633\u0627\u0628 \u0627\u0644\u0623\u062F\u0627\u0621\u0627\u062A {amount}",
      description: "\u0627\u0644\u0648\u0635\u0641",
      phase: "\u0627\u0644\u0645\u0631\u062D\u0644\u0629",
      noPhaseOption: "\u0628\u0644\u0627 \u0645\u0631\u062D\u0644\u0629",
      quantity: "\u0627\u0644\u0643\u0645\u064A\u0629",
      unitPrice: "\u0633\u0639\u0631 \u0627\u0644\u0648\u062D\u062F\u0629 \u062F\u0648\u0646 \u0627\u062D\u062A\u0633\u0627\u0628 \u0627\u0644\u0623\u062F\u0627\u0621\u0627\u062A",
      vat: "\u0627\u0644\u0623\u062F\u0627\u0621 \u0639\u0644\u0649 \u0627\u0644\u0642\u064A\u0645\u0629 \u0627\u0644\u0645\u0636\u0627\u0641\u0629",
      amount: "\u0627\u0644\u0645\u0628\u0644\u063A \u062F\u0648\u0646 \u0627\u062D\u062A\u0633\u0627\u0628 \u0627\u0644\u0623\u062F\u0627\u0621\u0627\u062A",
      add: "\u0625\u0636\u0627\u0641\u0629 \u0628\u0646\u062F",
      addToPhase: "\u0625\u0636\u0627\u0641\u0629 \u0628\u0646\u062F \u0625\u0644\u0649 \u0647\u0630\u0647 \u0627\u0644\u0645\u0631\u062D\u0644\u0629",
      remove: "\u062D\u0630\u0641 \u0627\u0644\u0628\u0646\u062F {number}",
      lineNumber: "\u0627\u0644\u0628\u0646\u062F {number}",
      totalHt: "\u0645\u062C\u0645\u0648\u0639 \u0627\u0644\u0628\u0646\u0648\u062F \u062F\u0648\u0646 \u0627\u062D\u062A\u0633\u0627\u0628 \u0627\u0644\u0623\u062F\u0627\u0621\u0627\u062A",
      empty: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0628\u0646\u0648\u062F \u0628\u0639\u062F. \u0623\u0636\u0641 \u0628\u0646\u062F\u064B\u0627.",
      readOnlyCaption: "\u0628\u0646\u0648\u062F \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629: {name}",
      roles: {
        service: "\u062E\u062F\u0645\u0629",
        advance_recovery: "\u0627\u0633\u062A\u0631\u062C\u0627\u0639 \u0633\u0644\u0641\u0629",
        retention: "\u0627\u0642\u062A\u0637\u0627\u0639 \u0636\u0645\u0627\u0646",
        retention_release: "\u0625\u0631\u062C\u0627\u0639 \u0627\u0642\u062A\u0637\u0627\u0639 \u0627\u0644\u0636\u0645\u0627\u0646"
      }
    },
    attachments: {
      none: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0645\u0631\u0641\u0642\u0627\u062A.",
      list: "\u0627\u0644\u0645\u0631\u0641\u0642\u0627\u062A",
      remove: "\u0625\u0632\u0627\u0644\u0629 {title}",
      search: "\u0627\u0644\u0628\u062D\u062B \u0639\u0646 \u0648\u062B\u064A\u0642\u0629 \u0644\u0625\u0631\u0641\u0627\u0642\u0647\u0627",
      searchHint: "\u0627\u0643\u062A\u0628 \u062D\u0631\u0641\u064A\u0646 \u0639\u0644\u0649 \u0627\u0644\u0623\u0642\u0644 \u0645\u0646 \u0627\u0644\u0639\u0646\u0648\u0627\u0646 \u0623\u0648 \u0627\u0644\u0631\u0645\u0632\u060C \u0645\u062B\u0644\u064B\u0627 \u0645\u062D\u0636\u0631 \u062A\u0633\u0644\u0651\u0645. \u062A\u064F\u062D\u0641\u0638 \u0627\u0644\u0645\u0631\u0641\u0642\u0627\u062A \u0645\u0639 \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629."
    },
    hints: {
      title: "\u0644\u0625\u0635\u062F\u0627\u0631 \u0647\u0630\u0647 \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629\u060C \u0628\u0642\u064A \u0645\u0627 \u064A\u062C\u0628 \u0627\u0633\u062A\u0643\u0645\u0627\u0644\u0647",
      body: "\u0647\u0630\u0647 \u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A \u0625\u062C\u0628\u0627\u0631\u064A\u0629 \u0641\u064A \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629."
    },
    issue: {
      title: "\u0625\u0635\u062F\u0627\u0631 \u0647\u0630\u0647 \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629\u061F",
      totals: "\u0627\u0644\u0645\u062C\u0645\u0648\u0639 \u0628\u0627\u062D\u062A\u0633\u0627\u0628 \u0643\u0644 \u0627\u0644\u0623\u062F\u0627\u0621\u0627\u062A {ttc}\u060C \u0627\u0644\u0635\u0627\u0641\u064A \u0644\u0644\u062F\u0641\u0639 {net}.",
      never: "\u0644\u0627 \u064A\u0645\u0643\u0646 \u062A\u0639\u062F\u064A\u0644 \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629 \u0627\u0644\u0635\u0627\u062F\u0631\u0629 \u0623\u0628\u062F\u064B\u0627: \u062A\u062D\u0635\u0644 \u0639\u0644\u0649 \u0631\u0642\u0645\u0647\u0627 \u0627\u0644\u0646\u0647\u0627\u0626\u064A \u0648\u062A\u064F\u062C\u0645\u064E\u0651\u062F \u0645\u0628\u0627\u0644\u063A\u0647\u0627. \u0639\u0646\u062F \u0648\u062C\u0648\u062F \u062E\u0637\u0623\u060C \u0633\u062A\u0635\u062F\u0631 \u0641\u0627\u062A\u0648\u0631\u0629 \u062A\u0639\u062F\u064A\u0644\u064A\u0629.",
      identity: "\u0633\u062A\u062D\u062A\u0627\u062C \u0625\u0644\u0649 \u062A\u0623\u0643\u064A\u062F \u0647\u0648\u064A\u062A\u0643 \u0644\u0625\u062A\u0645\u0627\u0645 \u0627\u0644\u0639\u0645\u0644\u064A\u0629.",
      confirm: "\u0625\u0635\u062F\u0627\u0631 \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629",
      done: "\u062A\u0645 \u0625\u0635\u062F\u0627\u0631 \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629 {number}.",
      changedTitle: "\u062A\u063A\u064A\u0651\u0631\u062A \u0627\u0644\u0645\u0628\u0627\u0644\u063A",
      changedBody: "\u062A\u063A\u064A\u0651\u0631\u062A \u0627\u0644\u0642\u0648\u0627\u0639\u062F \u0627\u0644\u062C\u0628\u0627\u0626\u064A\u0629 \u0623\u0648 \u0627\u0644\u062D\u0631\u064A\u0641 \u0645\u0646\u0630 \u0622\u062E\u0631 \u0627\u062D\u062A\u0633\u0627\u0628: \u062A\u0639\u0631\u0636 \u0627\u0644\u0645\u0633\u0648\u062F\u0629 \u0627\u0644\u0622\u0646 \u0627\u0644\u0645\u062C\u0627\u0645\u064A\u0639 \u0627\u0644\u062C\u062F\u064A\u062F\u0629. \u062A\u062D\u0642\u0642 \u0645\u0646\u0647\u0627 \u062B\u0645 \u0623\u0635\u062F\u0631 \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629 \u0645\u0646 \u062C\u062F\u064A\u062F.",
      changedDismiss: "\u0641\u0647\u0645\u062A",
      mentionsTitle: "\u0628\u064A\u0627\u0646\u0627\u062A \u0625\u062C\u0628\u0627\u0631\u064A\u0629 \u0646\u0627\u0642\u0635\u0629",
      mentionsBody: "\u0644\u0627 \u064A\u0645\u0643\u0646 \u0625\u0635\u062F\u0627\u0631 \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629 \u0645\u0627 \u062F\u0627\u0645\u062A \u0647\u0630\u0647 \u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A \u0646\u0627\u0642\u0635\u0629:",
      failedTitle: "\u062A\u0639\u0630\u0651\u0631 \u0625\u0635\u062F\u0627\u0631 \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629"
    },
    creditNote: {
      title: "\u0641\u0627\u062A\u0648\u0631\u0629 \u062A\u0639\u062F\u064A\u0644\u064A\u0629 \u0639\u0644\u0649 \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629 {number}",
      intro: "\u062A\u0644\u063A\u064A \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629 \u0627\u0644\u062A\u0639\u062F\u064A\u0644\u064A\u0629 \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629 \u0643\u0644\u0647\u0627 \u0623\u0648 \u062C\u0632\u0621\u064B\u0627 \u0645\u0646\u0647\u0627 \u062F\u0648\u0646 \u062A\u0639\u062F\u064A\u0644\u0647\u0627. \u062A\u0635\u062F\u0631 \u0641\u0648\u0631\u064B\u0627 \u0628\u0631\u0642\u0645 \u062E\u0627\u0635 \u0628\u0647\u0627.",
      mode: "\u0646\u0637\u0627\u0642 \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629 \u0627\u0644\u062A\u0639\u062F\u064A\u0644\u064A\u0629",
      full: "\u0625\u0644\u063A\u0627\u0621 \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629 \u0643\u0627\u0645\u0644\u0629 (\u0628\u0645\u0627 \u0641\u064A \u0630\u0644\u0643 \u0645\u0639\u0644\u0648\u0645 \u0627\u0644\u0637\u0627\u0628\u0639)",
      byLines: "\u062A\u0639\u062F\u064A\u0644 \u0628\u0639\u0636 \u0627\u0644\u0628\u0646\u0648\u062F",
      fullHint: "\u062A\u0634\u0645\u0644 \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629 \u0627\u0644\u062A\u0639\u062F\u064A\u0644\u064A\u0629 \u0627\u0644\u0645\u062C\u0645\u0648\u0639 \u0628\u0627\u062D\u062A\u0633\u0627\u0628 \u0643\u0644 \u0627\u0644\u0623\u062F\u0627\u0621\u0627\u062A \u0627\u0644\u0628\u0627\u0644\u063A {amount}.",
      linesLabel: "\u0627\u0644\u0628\u0646\u0648\u062F \u0627\u0644\u0645\u0631\u0627\u062F \u062A\u0639\u062F\u064A\u0644\u0647\u0627",
      quantityOf: "\u0627\u0644\u0643\u0645\u064A\u0629 \u0627\u0644\u0645\u0631\u0627\u062F \u062A\u0639\u062F\u064A\u0644\u0647\u0627 \u0644\u0644\u0628\u0646\u062F {description}",
      reason: "\u0633\u0628\u0628 \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629 \u0627\u0644\u062A\u0639\u062F\u064A\u0644\u064A\u0629",
      reasonRequired: "\u0627\u0630\u0643\u0631 \u0633\u0628\u0628 \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629 \u0627\u0644\u062A\u0639\u062F\u064A\u0644\u064A\u0629.",
      pickLines: "\u0627\u062E\u062A\u0631 \u0628\u0646\u062F\u064B\u0627 \u0648\u0627\u062D\u062F\u064B\u0627 \u0639\u0644\u0649 \u0627\u0644\u0623\u0642\u0644.",
      cancel: "\u0625\u0644\u063A\u0627\u0621",
      issue: "\u0625\u0635\u062F\u0627\u0631 \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629 \u0627\u0644\u062A\u0639\u062F\u064A\u0644\u064A\u0629",
      issuing: "\u062C\u0627\u0631\u064D \u0627\u0644\u0625\u0635\u062F\u0627\u0631\u2026",
      done: "\u062A\u0645 \u0625\u0635\u062F\u0627\u0631 \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629 \u0627\u0644\u062A\u0639\u062F\u064A\u0644\u064A\u0629 {number}."
    },
    errors: {
      clientRequired: "\u0627\u062E\u062A\u0631 \u062D\u0631\u064A\u0641\u064B\u0627.",
      rateRequired: "\u0623\u062F\u062E\u0644 \u0633\u0639\u0631 \u0627\u0644\u0635\u0631\u0641.",
      rateInvalid: "\u0623\u062F\u062E\u0644 \u0633\u0639\u0631\u064B\u0627 \u0645\u0648\u062C\u0628\u064B\u0627 \u0628\u0633\u062A \u062E\u0627\u0646\u0627\u062A \u0639\u0634\u0631\u064A\u0629 \u0639\u0644\u0649 \u0627\u0644\u0623\u0643\u062B\u0631\u060C \u0645\u062B\u0627\u0644: 3.350.",
      linesRequired: "\u0623\u0636\u0641 \u0628\u0646\u062F\u064B\u0627 \u0648\u0627\u062D\u062F\u064B\u0627 \u0639\u0644\u0649 \u0627\u0644\u0623\u0642\u0644 \u0625\u0644\u0649 \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629.",
      descriptionRequired: "\u0635\u0650\u0641 \u0647\u0630\u0627 \u0627\u0644\u0628\u0646\u062F.",
      priceRequired: "\u0623\u062F\u062E\u0644 \u0633\u0639\u0631 \u0627\u0644\u0648\u062D\u062F\u0629.",
      quantityInvalid: "\u0623\u062F\u062E\u0644 \u0643\u0645\u064A\u0629 \u0645\u0648\u062C\u0628\u0629 \u0628\u062B\u0644\u0627\u062B \u062E\u0627\u0646\u0627\u062A \u0639\u0634\u0631\u064A\u0629 \u0639\u0644\u0649 \u0627\u0644\u0623\u0643\u062B\u0631.",
      staleTitle: "\u0642\u0627\u0645 \u0634\u062E\u0635 \u0622\u062E\u0631 \u0628\u062A\u0639\u062F\u064A\u0644 \u0647\u0630\u0647 \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629",
      staleBody: "\u062D\u0641\u0638 \u0634\u062E\u0635 \u0622\u062E\u0631 \u0647\u0630\u0647 \u0627\u0644\u0645\u0633\u0648\u062F\u0629 \u0623\u062B\u0646\u0627\u0621 \u062A\u0639\u062F\u064A\u0644\u0643 \u0644\u0647\u0627. \u0623\u0639\u062F \u062A\u062D\u0645\u064A\u0644\u0647\u0627 \u0644\u0644\u0627\u0637\u0644\u0627\u0639 \u0639\u0644\u0649 \u0622\u062E\u0631 \u0646\u0633\u062E\u0629 \u062B\u0645 \u0623\u0639\u062F \u062A\u0637\u0628\u064A\u0642 \u062A\u0639\u062F\u064A\u0644\u0627\u062A\u0643.",
      reload: "\u0625\u0639\u0627\u062F\u0629 \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629",
      saveFailed: "\u062A\u0639\u0630\u0651\u0631 \u062D\u0641\u0638 \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629"
    },
    totals: {
      needClient: "\u0627\u062E\u062A\u0631 \u062D\u0631\u064A\u0641\u064B\u0627 \u0644\u0627\u062D\u062A\u0633\u0627\u0628 \u0627\u0644\u0645\u062C\u0627\u0645\u064A\u0639 (\u0627\u0644\u0623\u062F\u0627\u0621\u060C \u0627\u0644\u0637\u0627\u0628\u0639\u060C \u0627\u0644\u0627\u0642\u062A\u0637\u0627\u0639\u0627\u062A).",
      needRate: "\u0623\u062F\u062E\u0644 \u0633\u0639\u0631 \u0627\u0644\u0635\u0631\u0641 \u0644\u0627\u062D\u062A\u0633\u0627\u0628 \u0627\u0644\u0645\u062C\u0627\u0645\u064A\u0639.",
      needLines: "\u0623\u0643\u0645\u0644 \u0627\u0644\u0628\u0646\u0648\u062F (\u0627\u0644\u0643\u0645\u064A\u0629 \u0648\u0627\u0644\u0633\u0639\u0631) \u0644\u0627\u062D\u062A\u0633\u0627\u0628 \u0627\u0644\u0645\u062C\u0627\u0645\u064A\u0639.",
      noRight: "\u0627\u0644\u0645\u062C\u0627\u0645\u064A\u0639 \u0627\u0644\u0645\u0641\u0635\u0651\u0644\u0629 \u063A\u064A\u0631 \u0645\u062A\u0627\u062D\u0629 \u0628\u062D\u0633\u0628 \u0635\u0644\u0627\u062D\u064A\u0627\u062A\u0643. \u064A\u0628\u0642\u0649 \u0645\u062C\u0645\u0648\u0639 \u0627\u0644\u0628\u0646\u0648\u062F \u062F\u0648\u0646 \u0627\u062D\u062A\u0633\u0627\u0628 \u0627\u0644\u0623\u062F\u0627\u0621\u0627\u062A \u0635\u062D\u064A\u062D\u064B\u0627.",
      indicative: "\u0645\u062C\u0627\u0645\u064A\u0639 \u0625\u0631\u0634\u0627\u062F\u064A\u0629: \u062A\u064F\u0639\u0627\u062F \u062D\u0633\u0627\u0628\u0647\u0627 \u0639\u0646\u062F \u0625\u0635\u062F\u0627\u0631 \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629 \u0648\u0641\u0642 \u0627\u0644\u0642\u0648\u0627\u0639\u062F \u0627\u0644\u062C\u0628\u0627\u0626\u064A\u0629 \u0627\u0644\u0633\u0627\u0631\u064A\u0629 \u0630\u0644\u0643 \u0627\u0644\u064A\u0648\u0645."
    },
    actions: {
      label: "\u0625\u062C\u0631\u0627\u0621\u0627\u062A \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629",
      issue: "\u0625\u0635\u062F\u0627\u0631",
      pdf: "\u0639\u0631\u0636 \u0645\u0644\u0641 PDF",
      pdfOpening: "\u062C\u0627\u0631\u064D \u0641\u062A\u062D \u0645\u0644\u0641 PDF\u2026",
      pdfPreparing: "\u0645\u0644\u0641 PDF \u0642\u064A\u062F \u0627\u0644\u0625\u0639\u062F\u0627\u062F. \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629 \u0628\u0639\u062F \u0644\u062D\u0638\u0627\u062A.",
      pdfFailed: "\u062A\u0639\u0630\u0651\u0631 \u0641\u062A\u062D \u0645\u0644\u0641 PDF. \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629 \u0628\u0639\u062F \u0644\u062D\u0638\u0627\u062A.",
      recordPayment: "\u062A\u0633\u062C\u064A\u0644 \u062F\u0641\u0639\u0629",
      creditNote: "\u0625\u0635\u062F\u0627\u0631 \u0641\u0627\u062A\u0648\u0631\u0629 \u062A\u0639\u062F\u064A\u0644\u064A\u0629",
      delete: "\u062D\u0630\u0641 \u0627\u0644\u0645\u0633\u0648\u062F\u0629",
      saveFirst: "\u0627\u062D\u0641\u0638 \u062A\u0639\u062F\u064A\u0644\u0627\u062A\u0643 \u0623\u0648\u0644\u064B\u0627 \u0644\u0627\u0633\u062A\u0639\u0645\u0627\u0644 \u0647\u0630\u0647 \u0627\u0644\u0625\u062C\u0631\u0627\u0621\u0627\u062A."
    },
    remove: {
      title: "\u062D\u0630\u0641 {number}\u061F",
      body: "\u0633\u062A\u064F\u062D\u0630\u0641 \u0647\u0630\u0647 \u0627\u0644\u0645\u0633\u0648\u062F\u0629 \u0646\u0647\u0627\u0626\u064A\u064B\u0627. \u0644\u0645 \u064A\u064F\u0633\u062A\u0647\u0644\u0643 \u0623\u064A \u0631\u0642\u0645.",
      confirm: "\u062D\u0630\u0641 \u0627\u0644\u0645\u0633\u0648\u062F\u0629",
      done: "\u062A\u0645 \u062D\u0630\u0641 \u0627\u0644\u0645\u0633\u0648\u062F\u0629."
    },
    save: {
      action: "\u062D\u0641\u0638",
      saving: "\u062C\u0627\u0631\u064D \u0627\u0644\u062D\u0641\u0638\u2026",
      created: "\u062A\u0645 \u0625\u0646\u0634\u0627\u0621 \u0645\u0633\u0648\u062F\u0629 \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629.",
      saved: "\u062A\u0645 \u062D\u0641\u0638 \u0645\u0633\u0648\u062F\u0629 \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629."
    },
    guard: {
      title: "\u0627\u0644\u0645\u063A\u0627\u062F\u0631\u0629 \u062F\u0648\u0646 \u062D\u0641\u0638\u061F",
      body: "\u0633\u062A\u0636\u064A\u0639 \u062A\u0639\u062F\u064A\u0644\u0627\u062A\u0643 \u0639\u0644\u0649 \u0647\u0630\u0647 \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629.",
      leave: "\u0645\u063A\u0627\u062F\u0631\u0629",
      stay: "\u0627\u0644\u0628\u0642\u0627\u0621 \u0641\u064A \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629"
    },
    history: {
      statuses: "\u062D\u0627\u0644\u0627\u062A \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629",
      invoice: "\u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629",
      ttn: "\u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629 \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A\u0629 (TTN)",
      payment: "\u0627\u0644\u062F\u0641\u0639",
      createdBy: "\u0623\u0646\u0634\u0623\u0647\u0627 {name} \u0628\u062A\u0627\u0631\u064A\u062E {date}",
      issued: "\u0635\u062F\u0631\u062A \u062A\u062D\u062A \u0627\u0644\u0631\u0642\u0645 {number} \u0628\u062A\u0627\u0631\u064A\u062E {date} \u0639\u0646 {name}",
      notIssued: "\u0644\u0645 \u062A\u0635\u062F\u0631 \u0647\u0630\u0647 \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629 \u0628\u0639\u062F: \u0644\u064A\u0633 \u0644\u0647\u0627 \u0631\u0642\u0645.",
      legalHold: "\u0645\u062D\u0641\u0648\u0638\u0629 \u0642\u0627\u0646\u0648\u0646\u064A\u064B\u0627 \u0625\u0644\u0649 \u063A\u0627\u064A\u0629 {date}",
      creditOf: "\u0641\u0627\u062A\u0648\u0631\u0629 \u062A\u0639\u062F\u064A\u0644\u064A\u0629 \u0639\u0644\u0649 \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629",
      credited: "\u0633\u0628\u0642 \u062A\u0639\u062F\u064A\u0644\u0647\u0627 \u0628\u0641\u0648\u0627\u062A\u064A\u0631 \u062A\u0639\u062F\u064A\u0644\u064A\u0629: {amount}",
      pdfReady: "\u0645\u0644\u0641 PDF \u062C\u0627\u0647\u0632",
      pdfNotReady: "\u0645\u0644\u0641 PDF \u0642\u064A\u062F \u0627\u0644\u0625\u0639\u062F\u0627\u062F",
      paymentLine: "\u062F\u0641\u0639\u0629 \u0628\u062A\u0627\u0631\u064A\u062E {date} ({method}): {amount}",
      paymentLineWithheld: "\u062F\u0641\u0639\u0629 \u0628\u062A\u0627\u0631\u064A\u062E {date} ({method}): {amount}\u060C \u0625\u0636\u0627\u0641\u0629 \u0625\u0644\u0649 {withheld} \u0627\u0642\u062A\u0637\u0639\u0647\u0627 \u0627\u0644\u062D\u0631\u064A\u0641",
      noPayment: "\u0644\u0627 \u062A\u0648\u062C\u062F \u062F\u0641\u0639\u0627\u062A \u0645\u0633\u062C\u0644\u0629."
    },
    mentions: {
      fiscalProfile: "\u0627\u0644\u0645\u0644\u0641 \u0627\u0644\u062C\u0628\u0627\u0626\u064A \u0644\u0645\u0643\u062A\u0628\u0643 \u063A\u064A\u0631 \u0645\u0633\u062A\u0643\u0645\u0644.",
      seller_name: "\u0627\u0644\u0627\u0633\u0645 \u0627\u0644\u0642\u0627\u0646\u0648\u0646\u064A \u0644\u0645\u0643\u062A\u0628\u0643 \u0646\u0627\u0642\u0635.",
      seller_address: "\u0639\u0646\u0648\u0627\u0646 \u0645\u0643\u062A\u0628\u0643 \u0646\u0627\u0642\u0635.",
      seller_taxId: "\u0627\u0644\u0645\u0639\u0631\u0651\u0641 \u0627\u0644\u062C\u0628\u0627\u0626\u064A \u0644\u0645\u0643\u062A\u0628\u0643 \u0646\u0627\u0642\u0635.",
      seller_taxId_invalid: "\u0627\u0644\u0645\u0639\u0631\u0651\u0641 \u0627\u0644\u062C\u0628\u0627\u0626\u064A \u0644\u0645\u0643\u062A\u0628\u0643 \u063A\u064A\u0631 \u0635\u0627\u0644\u062D.",
      client_name: "\u0627\u0633\u0645 \u0627\u0644\u062D\u0631\u064A\u0641 \u0646\u0627\u0642\u0635.",
      client_address: "\u0639\u0646\u0648\u0627\u0646 \u0627\u0644\u062D\u0631\u064A\u0641 \u0646\u0627\u0642\u0635.",
      client_taxId: "\u0627\u0644\u0645\u0639\u0631\u0651\u0641 \u0627\u0644\u062C\u0628\u0627\u0626\u064A \u0644\u0644\u062D\u0631\u064A\u0641 \u0646\u0627\u0642\u0635 (\u0625\u062C\u0628\u0627\u0631\u064A \u0644\u0644\u0634\u0631\u0643\u0629 \u0623\u0648 \u0627\u0644\u0647\u064A\u0643\u0644 \u0627\u0644\u0639\u0645\u0648\u0645\u064A).",
      client_taxId_invalid: "\u0627\u0644\u0645\u0639\u0631\u0651\u0641 \u0627\u0644\u062C\u0628\u0627\u0626\u064A \u0644\u0644\u062D\u0631\u064A\u0641 \u063A\u064A\u0631 \u0635\u0627\u0644\u062D.",
      lines: "\u0644\u064A\u0633 \u0641\u064A \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629 \u0623\u064A \u0628\u0646\u062F.",
      lines_description: "\u0627\u0644\u0628\u0646\u062F {number} \u0628\u0644\u0627 \u0648\u0635\u0641.",
      lines_unitPriceMinor: "\u0627\u0644\u0628\u0646\u062F {number} \u0628\u0644\u0627 \u0633\u0639\u0631 \u0648\u062D\u062F\u0629.",
      lines_quantityMilli: "\u0643\u0645\u064A\u0629 \u0627\u0644\u0628\u0646\u062F {number} \u063A\u064A\u0631 \u0635\u0627\u0644\u062D\u0629.",
      treatmentRef: "\u0645\u0631\u062C\u0639 \u0646\u0638\u0627\u0645 \u0627\u0644\u0623\u062F\u0627\u0621 (\u0634\u0647\u0627\u062F\u0629 \u062A\u0639\u0644\u064A\u0642 \u0627\u0644\u0623\u062F\u0627\u0621) \u0646\u0627\u0642\u0635.",
      issueDate: "\u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0625\u0635\u062F\u0627\u0631 \u0646\u0627\u0642\u0635.",
      number: "\u0631\u0642\u0645 \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629 \u063A\u064A\u0631 \u0635\u0627\u0644\u062D.",
      creditedInvoiceNumber: "\u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629 \u0627\u0644\u0623\u0635\u0644\u064A\u0629 \u0644\u0644\u0641\u0627\u062A\u0648\u0631\u0629 \u0627\u0644\u062A\u0639\u062F\u064A\u0644\u064A\u0629 \u0646\u0627\u0642\u0635\u0629.",
      computation: "\u0644\u0645 \u062A\u064F\u062D\u062A\u0633\u0628 \u0627\u0644\u0645\u062C\u0627\u0645\u064A\u0639.",
      computation_amountInWords: "\u062A\u0639\u0630\u0651\u0631 \u062A\u062D\u0631\u064A\u0631 \u0627\u0644\u0645\u0628\u0644\u063A \u0628\u0627\u0644\u0623\u062D\u0631\u0641.",
      unknown: "\u0628\u064A\u0627\u0646 \u0625\u062C\u0628\u0627\u0631\u064A \u0646\u0627\u0642\u0635 ({path}).",
      fixFiscal: "\u0627\u0633\u062A\u0643\u0645\u0627\u0644 \u0627\u0644\u0645\u0644\u0641 \u0627\u0644\u062C\u0628\u0627\u0626\u064A",
      fixClient: "\u0641\u062A\u062D \u0628\u0637\u0627\u0642\u0629 \u0627\u0644\u062D\u0631\u064A\u0641"
    }
  },
  documents: {
    results: "\u0646\u062A\u0627\u0626\u062C \u0627\u0644\u0628\u062D\u062B",
    add: "\u0625\u0636\u0627\u0641\u0629 {title}",
    addShort: "\u0625\u0636\u0627\u0641\u0629",
    noResult: "\u0644\u0645 \u064A\u064F\u0639\u062B\u0631 \u0639\u0644\u0649 \u0623\u064A \u0648\u062B\u064A\u0642\u0629.",
    searchFailed: "\u0644\u0645 \u064A\u0646\u062C\u062D \u0627\u0644\u0628\u062D\u062B. \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629."
  },
  payments: {
    list: {
      title: "\u0627\u0644\u062F\u0641\u0639\u0627\u062A \u0627\u0644\u0645\u0633\u062A\u0644\u0645\u0629",
      caption: "\u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u062F\u0641\u0639\u0627\u062A \u0627\u0644\u0645\u0633\u062A\u0644\u0645\u0629",
      columns: {
        receivedOn: "\u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0627\u0633\u062A\u0644\u0627\u0645",
        invoice: "\u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629",
        client: "\u0627\u0644\u062D\u0631\u064A\u0641",
        method: "\u0627\u0644\u0637\u0631\u064A\u0642\u0629",
        amount: "\u0627\u0644\u0645\u0628\u0644\u063A \u0627\u0644\u0645\u0633\u062A\u0644\u0645",
        withholding: "\u0627\u0644\u062E\u0635\u0645 \u0645\u0646 \u0627\u0644\u0645\u0648\u0631\u062F",
        vatWithholding: "\u0627\u0644\u062E\u0635\u0645 \u0645\u0646 \u0627\u0644\u0645\u0648\u0631\u062F \u0628\u0639\u0646\u0648\u0627\u0646 \u0627\u0644\u0623\u062F\u0627\u0621 \u0639\u0644\u0649 \u0627\u0644\u0642\u064A\u0645\u0629 \u0627\u0644\u0645\u0636\u0627\u0641\u0629",
        certificate: "\u0634\u0647\u0627\u062F\u0629 \u0627\u0644\u062E\u0635\u0645",
        reference: "\u0627\u0644\u0645\u0631\u062C\u0639"
      },
      certificate: {
        received: "\u0645\u0633\u062A\u0644\u0645\u0629",
        missing: "\u0646\u0627\u0642\u0635\u0629",
        notNeeded: "\u0644\u0627 \u064A\u0646\u0637\u0628\u0642",
        add: "\u0625\u0636\u0627\u0641\u0629"
      },
      empty: {
        title: "\u0644\u0627 \u062A\u0648\u062C\u062F \u062F\u0641\u0639\u0627\u062A \u0628\u0639\u062F",
        description: "\u062A\u064F\u0633\u062C\u064E\u0651\u0644 \u0627\u0644\u062F\u0641\u0639\u0627\u062A \u0627\u0646\u0637\u0644\u0627\u0642\u064B\u0627 \u0645\u0646 \u0641\u0627\u062A\u0648\u0631\u0629 \u0635\u0627\u062F\u0631\u0629: \u0627\u0641\u062A\u062D\u0647\u0627 \u062B\u0645 \u0627\u062E\u062A\u0631 \xAB\u062A\u0633\u062C\u064A\u0644 \u062F\u0641\u0639\u0629\xBB."
      },
      loadMore: "\u0639\u0631\u0636 \u0627\u0644\u0645\u0632\u064A\u062F \u0645\u0646 \u0627\u0644\u062F\u0641\u0639\u0627\u062A",
      loadingMore: "\u062C\u0627\u0631\u064D \u0627\u0644\u062A\u062D\u0645\u064A\u0644\u2026",
      loadFailedTitle: "\u062A\u0639\u0630\u0651\u0631 \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u062F\u0641\u0639\u0627\u062A",
      loadFailedBody: "\u062A\u062D\u0642\u0642 \u0645\u0646 \u0627\u062A\u0635\u0627\u0644\u0643 \u062B\u0645 \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629.",
      none: "\u2014"
    },
    method: {
      transfer: "\u062A\u062D\u0648\u064A\u0644 \u0628\u0646\u0643\u064A",
      cheque: "\u0635\u0643",
      bill: "\u0643\u0645\u0628\u064A\u0627\u0644\u0629",
      cash: "\u0646\u0642\u062F\u064B\u0627",
      online: "\u062F\u0641\u0639 \u0639\u0628\u0631 \u0627\u0644\u0625\u0646\u062A\u0631\u0646\u062A"
    },
    fields: {
      receivedOn: "\u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0627\u0633\u062A\u0644\u0627\u0645",
      method: "\u0637\u0631\u064A\u0642\u0629 \u0627\u0644\u062F\u0641\u0639",
      amount: "\u0627\u0644\u0645\u0628\u0644\u063A \u0627\u0644\u0645\u0633\u062A\u0644\u0645",
      amountHint: "\u0627\u0644\u0645\u0628\u0644\u063A \u0627\u0644\u0645\u0642\u0628\u0648\u0636 \u0641\u0639\u0644\u064A\u064B\u0627 \u0628\u0639\u062F \u0637\u0631\u062D \u0627\u0644\u0627\u0642\u062A\u0637\u0627\u0639\u0627\u062A.",
      withholding: "\u0627\u0644\u062E\u0635\u0645 \u0645\u0646 \u0627\u0644\u0645\u0648\u0631\u062F",
      withholdingHint: "\u0645\u0642\u062A\u0631\u062D \u0628\u062D\u0633\u0628 \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629: \u0645\u0628\u0644\u063A \u0627\u0642\u062A\u0637\u0639\u0647 \u0627\u0644\u062D\u0631\u064A\u0641.",
      withholdingNone: "\u0644\u0627 \u064A\u064F\u0646\u062A\u0638\u0631 \u0623\u064A \u0627\u0642\u062A\u0637\u0627\u0639 \u0639\u0644\u0649 \u0647\u0630\u0647 \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629.",
      vatWithholding: "\u0627\u0644\u062E\u0635\u0645 \u0645\u0646 \u0627\u0644\u0645\u0648\u0631\u062F \u0628\u0639\u0646\u0648\u0627\u0646 \u0627\u0644\u0623\u062F\u0627\u0621 \u0639\u0644\u0649 \u0627\u0644\u0642\u064A\u0645\u0629 \u0627\u0644\u0645\u0636\u0627\u0641\u0629",
      vatWithholdingHint: "\u0627\u0642\u062A\u0637\u0627\u0639 \u0645\u0646 \u0627\u0644\u0623\u062F\u0627\u0621 \u0639\u0644\u0649 \u0627\u0644\u0642\u064A\u0645\u0629 \u0627\u0644\u0645\u0636\u0627\u0641\u0629 \u0623\u062C\u0631\u0627\u0647 \u0627\u0644\u062D\u0631\u064A\u0641 (\u0627\u0644\u0647\u064A\u0627\u0643\u0644 \u0627\u0644\u0639\u0645\u0648\u0645\u064A\u0629).",
      chequeNumber: "\u0631\u0642\u0645 \u0627\u0644\u0635\u0643",
      chequeBank: "\u0627\u0644\u0628\u0646\u0643",
      chequeValidUntil: "\u0627\u0644\u0635\u0643 \u0635\u0627\u0644\u062D \u0625\u0644\u0649 \u063A\u0627\u064A\u0629",
      chequeValidUntilHint: "\u062F\u0648\u0646 \u062A\u0627\u0631\u064A\u062E\u060C \u062A\u064F\u0637\u0628\u064E\u0651\u0642 \u0645\u062F\u0629 \u0627\u0644\u0635\u0644\u0627\u062D\u064A\u0629 \u0641\u064A \u0627\u0644\u0642\u0648\u0627\u0639\u062F \u0627\u0644\u062C\u0628\u0627\u0626\u064A\u0629 (6 \u0623\u0634\u0647\u0631).",
      reference: "\u0645\u0631\u062C\u0639 \u0627\u0644\u062F\u0641\u0639",
      referenceHint: "\u0631\u0642\u0645 \u0627\u0644\u062A\u062D\u0648\u064A\u0644 \u0623\u0648 \u0627\u0644\u0625\u064A\u062F\u0627\u0639\u2026 (\u0627\u062E\u062A\u064A\u0627\u0631\u064A).",
      tejReference: "\u0645\u0631\u062C\u0639 TEJ \u0644\u0634\u0647\u0627\u062F\u0629 \u0627\u0644\u062E\u0635\u0645",
      tejReferenceHint: "\u0627\u062E\u062A\u064A\u0627\u0631\u064A: \u064A\u0645\u0643\u0646\u0643 \u0625\u0636\u0627\u0641\u062A\u0647 \u0644\u0627\u062D\u0642\u064B\u0627.",
      certificateDocument: "\u0634\u0647\u0627\u062F\u0629 \u0627\u0644\u062E\u0635\u0645 (\u0648\u062B\u064A\u0642\u0629)",
      certificateDocumentHint: "\u0627\u062E\u062A\u064A\u0627\u0631\u064A: \u0627\u0628\u062D\u062B \u0639\u0646 \u0627\u0644\u0646\u0633\u062E\u0629 \u0627\u0644\u0645\u0645\u0633\u0648\u062D\u0629 \u0627\u0644\u0645\u0648\u062F\u0639\u0629 \u0641\u064A \u0627\u0644\u0648\u062B\u0627\u0626\u0642.",
      certificateChosen: "\u0627\u0644\u0648\u062B\u064A\u0642\u0629 \u0627\u0644\u0645\u062E\u062A\u0627\u0631\u0629:",
      certificateRemove: "\u0625\u0632\u0627\u0644\u0629 \u0627\u0644\u0648\u062B\u064A\u0642\u0629"
    },
    dialog: {
      title: "\u062A\u0633\u062C\u064A\u0644 \u062F\u0641\u0639\u0629 \u0639\u0644\u0649 \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629 {number}",
      outstanding: "\u0627\u0644\u0645\u062A\u0628\u0642\u064A \u0642\u0628\u0644 \u0647\u0630\u0647 \u0627\u0644\u062F\u0641\u0639\u0629: {amount}.",
      settles: "\u062A\u0633\u062F\u0651\u062F \u0647\u0630\u0647 \u0627\u0644\u062F\u0641\u0639\u0629 {settled} (\u0646\u0642\u062F\u064B\u0627 \u0648\u0627\u0642\u062A\u0637\u0627\u0639\u0627\u062A). \u0627\u0644\u0645\u062A\u0628\u0642\u064A \u0628\u0639\u062F\u0647\u0627: {after}.",
      cancel: "\u0625\u0644\u063A\u0627\u0621",
      save: "\u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062F\u0641\u0639\u0629",
      saving: "\u062C\u0627\u0631\u064D \u0627\u0644\u062D\u0641\u0638\u2026",
      doneTitle: "\u062A\u0645 \u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062F\u0641\u0639\u0629",
      doneBody: "\u064A\u0628\u0642\u0649 {outstanding} \u0644\u0644\u0627\u0633\u062A\u062E\u0644\u0627\u0635.",
      status: {
        unpaid: "\u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629 \u063A\u064A\u0631 \u0645\u062F\u0641\u0648\u0639\u0629.",
        partially_paid: "\u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629 \u0645\u062F\u0641\u0648\u0639\u0629 \u062C\u0632\u0626\u064A\u064B\u0627.",
        paid: "\u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629 \u0645\u062F\u0641\u0648\u0639\u0629."
      },
      close: "\u0625\u063A\u0644\u0627\u0642"
    },
    errors: {
      dateRequired: "\u0623\u062F\u062E\u0644 \u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0627\u0633\u062A\u0644\u0627\u0645.",
      dateInFuture: "\u0644\u0627 \u064A\u0645\u0643\u0646 \u0623\u0646 \u064A\u0643\u0648\u0646 \u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0627\u0633\u062A\u0644\u0627\u0645 \u0641\u064A \u0627\u0644\u0645\u0633\u062A\u0642\u0628\u0644.",
      nothingReceived: "\u0623\u062F\u062E\u0644 \u0645\u0628\u0644\u063A\u064B\u0627 \u0645\u0633\u062A\u0644\u0645\u064B\u0627 \u0623\u0648 \u0645\u0642\u062A\u0637\u0639\u064B\u0627 \u0648\u0627\u062D\u062F\u064B\u0627 \u0639\u0644\u0649 \u0627\u0644\u0623\u0642\u0644.",
      overpayment: "\u062A\u062A\u062C\u0627\u0648\u0632 \u0647\u0630\u0647 \u0627\u0644\u062F\u0641\u0639\u0629 \u0627\u0644\u0645\u0628\u0644\u063A \u0627\u0644\u0645\u062A\u0628\u0642\u064A. \u062E\u0641\u0651\u0636 \u0627\u0644\u0645\u0628\u0627\u0644\u063A.",
      overpaymentServer: "\u062A\u062A\u062C\u0627\u0648\u0632 \u0647\u0630\u0647 \u0627\u0644\u062F\u0641\u0639\u0629 \u0627\u0644\u0645\u0628\u0644\u063A \u0627\u0644\u0645\u062A\u0628\u0642\u064A. \u062A\u0645 \u062A\u062D\u062F\u064A\u062B \u0627\u0644\u0645\u062A\u0628\u0642\u064A: \u062A\u062D\u0642\u0642 \u0645\u0646 \u0627\u0644\u0645\u0628\u0627\u0644\u063A \u062B\u0645 \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629.",
      chequeLimit: "\u064A\u062A\u062C\u0627\u0648\u0632 \u0647\u0630\u0627 \u0627\u0644\u0645\u0628\u0644\u063A \u0627\u0644\u0633\u0642\u0641 \u0627\u0644\u0642\u0627\u0646\u0648\u0646\u064A \u0644\u0644\u062F\u0641\u0639 \u0628\u0627\u0644\u0635\u0643. \u0627\u062E\u062A\u0631 \u0637\u0631\u064A\u0642\u0629 \u0623\u062E\u0631\u0649 \u0623\u0648 \u062C\u0632\u0651\u0626 \u0627\u0644\u062F\u0641\u0639.",
      chequeNumber: "\u0623\u062F\u062E\u0644 \u0631\u0642\u0645 \u0627\u0644\u0635\u0643.",
      chequeBank: "\u0623\u062F\u062E\u0644 \u0628\u0646\u0643 \u0627\u0644\u0635\u0643."
    },
    warnings: {
      cash_not_deductible: "\u0627\u0644\u062F\u0641\u0639 \u0646\u0642\u062F\u064B\u0627 \u0628\u0647\u0630\u0627 \u0627\u0644\u0645\u0628\u0644\u063A \u063A\u064A\u0631 \u0642\u0627\u0628\u0644 \u0644\u0644\u0637\u0631\u062D \u062C\u0628\u0627\u0626\u064A\u064B\u0627 \u0628\u0627\u0644\u0646\u0633\u0628\u0629 \u0625\u0644\u0649 \u062D\u0631\u064A\u0641\u0643 (\u0639\u062A\u0628\u0629 \u0627\u0644\u0642\u0648\u0627\u0639\u062F \u0627\u0644\u062C\u0628\u0627\u0626\u064A\u0629).",
      cheque_expires_soon: "\u0633\u062A\u0646\u062A\u0647\u064A \u0635\u0644\u0627\u062D\u064A\u0629 \u0647\u0630\u0627 \u0627\u0644\u0635\u0643 \u0642\u0631\u064A\u0628\u064B\u0627: \u0642\u062F\u0651\u0645\u0647 \u0625\u0644\u0649 \u0627\u0644\u0628\u0646\u0643 \u0641\u064A \u0623\u0642\u0631\u0628 \u0648\u0642\u062A."
    },
    certificate: {
      title: "\u0634\u0647\u0627\u062F\u0629 \u0627\u0644\u062E\u0635\u0645 \u0644\u0644\u0641\u0627\u062A\u0648\u0631\u0629 {number}",
      needOne: "\u0623\u062F\u062E\u0644 \u0645\u0631\u062C\u0639 TEJ \u0623\u0648 \u0627\u062E\u062A\u0631 \u0627\u0644\u0648\u062B\u064A\u0642\u0629.",
      save: "\u062D\u0641\u0638 \u0627\u0644\u0634\u0647\u0627\u062F\u0629",
      done: "\u062A\u0645 \u062D\u0641\u0638 \u0634\u0647\u0627\u062F\u0629 \u0627\u0644\u062E\u0635\u0645."
    },
    aging: {
      title: "\u062C\u062F\u0648\u0644 \u0623\u0639\u0645\u0627\u0631 \u0627\u0644\u062F\u064A\u0648\u0646",
      hint: "\u0645\u0627 \u0644\u0627 \u064A\u0632\u0627\u0644 \u062D\u0631\u0641\u0627\u0624\u0643 \u0645\u062F\u064A\u0646\u064A\u0646 \u0628\u0647 \u0644\u0643\u060C \u062D\u0633\u0628 \u0645\u062F\u0629 \u0627\u0644\u062A\u0623\u062E\u0631 \u0639\u0646 \u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0627\u0633\u062A\u062D\u0642\u0627\u0642.",
      asOf: "\u0627\u0644\u0648\u0636\u0639\u064A\u0629 \u0628\u062A\u0627\u0631\u064A\u062E {date} (\u0627\u0644\u0645\u0628\u0627\u0644\u063A \u0628\u0627\u0644\u062F\u064A\u0646\u0627\u0631).",
      caption: "\u062C\u062F\u0648\u0644 \u0623\u0639\u0645\u0627\u0631 \u0627\u0644\u062F\u064A\u0648\u0646 \u062D\u0633\u0628 \u0627\u0644\u062D\u0631\u064A\u0641",
      empty: "\u0644\u0627 \u062A\u0648\u062C\u062F \u062F\u064A\u0648\u0646 \u0642\u0627\u0626\u0645\u0629.",
      loadFailed: "\u062A\u0639\u0630\u0651\u0631 \u062A\u062D\u0645\u064A\u0644 \u062C\u062F\u0648\u0644 \u0623\u0639\u0645\u0627\u0631 \u0627\u0644\u062F\u064A\u0648\u0646.",
      total: "\u0627\u0644\u0645\u062C\u0645\u0648\u0639",
      columns: {
        client: "\u0627\u0644\u062D\u0631\u064A\u0641",
        invoices: "\u0627\u0644\u0641\u0648\u0627\u062A\u064A\u0631",
        current: "\u0644\u0645 \u064A\u062D\u0644 \u0623\u062C\u0644\u0647",
        d0_30: "\u0645\u0646 0 \u0625\u0644\u0649 30 \u064A\u0648\u0645\u064B\u0627",
        d31_60: "\u0645\u0646 31 \u0625\u0644\u0649 60 \u064A\u0648\u0645\u064B\u0627",
        d61_90: "\u0645\u0646 61 \u0625\u0644\u0649 90 \u064A\u0648\u0645\u064B\u0627",
        over90: "\u0623\u0643\u062B\u0631 \u0645\u0646 90 \u064A\u0648\u0645\u064B\u0627",
        total: "\u0645\u062C\u0645\u0648\u0639 \u0627\u0644\u0645\u0633\u062A\u062D\u0642"
      }
    },
    reminders: {
      title: "\u062A\u0630\u0643\u064A\u0631 \u0627\u0644\u062D\u0631\u0641\u0627\u0621",
      hint: "\u064A\u064F\u0631\u0633\u064E\u0644 \u0628\u0631\u064A\u062F \u062A\u0630\u0643\u064A\u0631 \u0625\u0644\u0649 \u0627\u0644\u062D\u0631\u064A\u0641 \u0639\u0646\u062F \u062A\u0623\u062E\u0631 \u0627\u0644\u062F\u0641\u0639\u060C \u0641\u064A \u0627\u0644\u0623\u064A\u0627\u0645 \u0627\u0644\u062A\u064A \u062A\u062E\u062A\u0627\u0631\u0647\u0627 \u0628\u0639\u062F \u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0627\u0633\u062A\u062D\u0642\u0627\u0642.",
      enabled: "\u0625\u0631\u0633\u0627\u0644 \u062A\u0630\u0643\u064A\u0631\u0627\u062A \u062A\u0644\u0642\u0627\u0626\u064A\u0629",
      days: "\u0623\u064A\u0627\u0645 \u0627\u0644\u062A\u0630\u0643\u064A\u0631 \u0628\u0639\u062F \u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0627\u0633\u062A\u062D\u0642\u0627\u0642",
      daysHint: "\u062D\u062A\u0649 5 \u0623\u064A\u0627\u0645\u060C \u0645\u0646 \u0627\u0644\u0623\u0635\u063A\u0631 \u0625\u0644\u0649 \u0627\u0644\u0623\u0643\u0628\u0631\u060C \u0645\u0641\u0635\u0648\u0644\u0629 \u0628\u0641\u0648\u0627\u0635\u0644 (\u0645\u062B\u0627\u0644: \u20667, 15, 30\u2069).",
      save: "\u062D\u0641\u0638 \u0627\u0644\u062A\u0630\u0643\u064A\u0631\u0627\u062A",
      saving: "\u062C\u0627\u0631\u064D \u0627\u0644\u062D\u0641\u0638\u2026",
      saved: "\u062A\u0645 \u062D\u0641\u0638 \u0625\u0639\u062F\u0627\u062F\u0627\u062A \u0627\u0644\u062A\u0630\u0643\u064A\u0631.",
      readOnly: "\u0644\u0627 \u064A\u0645\u0643\u0646 \u0644\u063A\u064A\u0631 \u0627\u0644\u0645\u0633\u0624\u0648\u0644 \u062A\u0639\u062F\u064A\u0644 \u0647\u0630\u0647 \u0627\u0644\u0625\u0639\u062F\u0627\u062F\u0627\u062A.",
      stale: "\u0642\u0627\u0645 \u0634\u062E\u0635 \u0622\u062E\u0631 \u0628\u062A\u0639\u062F\u064A\u0644 \u0647\u0630\u0647 \u0627\u0644\u0625\u0639\u062F\u0627\u062F\u0627\u062A. \u0623\u0639\u062F \u062A\u062D\u0645\u064A\u0644\u0647\u0627 \u062B\u0645 \u062D\u0627\u0648\u0644 \u0645\u0646 \u062C\u062F\u064A\u062F.",
      reload: "\u0625\u0639\u0627\u062F\u0629 \u0627\u0644\u062A\u062D\u0645\u064A\u0644",
      loadFailed: "\u062A\u0639\u0630\u0651\u0631 \u062A\u062D\u0645\u064A\u0644 \u0625\u0639\u062F\u0627\u062F\u0627\u062A \u0627\u0644\u062A\u0630\u0643\u064A\u0631.",
      loading: "\u062C\u0627\u0631\u064D \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0625\u0639\u062F\u0627\u062F\u0627\u062A\u2026",
      errors: {
        invalid: "\u0623\u062F\u062E\u0644 \u0623\u0639\u062F\u0627\u062F\u064B\u0627 \u0635\u062D\u064A\u062D\u0629 \u0645\u0646 \u0627\u0644\u0623\u064A\u0627\u0645 \u0628\u064A\u0646 1 \u0648365\u060C \u0645\u0641\u0635\u0648\u0644\u0629 \u0628\u0641\u0648\u0627\u0635\u0644.",
        order: "\u0623\u062F\u062E\u0644 \u0627\u0644\u0623\u064A\u0627\u0645 \u0645\u0646 \u0627\u0644\u0623\u0635\u063A\u0631 \u0625\u0644\u0649 \u0627\u0644\u0623\u0643\u0628\u0631 \u0648\u062F\u0648\u0646 \u062A\u0643\u0631\u0627\u0631.",
        many: "\u062E\u0645\u0633\u0629 \u0623\u064A\u0627\u0645 \u062A\u0630\u0643\u064A\u0631 \u0639\u0644\u0649 \u0627\u0644\u0623\u0643\u062B\u0631."
      }
    }
  },
  expenses: {
    tabs: {
      label: "\u0627\u0644\u062A\u0646\u0642\u0644 \u0628\u064A\u0646 \u0645\u0630\u0643\u0631\u0627\u062A \u0627\u0644\u0645\u0635\u0627\u0631\u064A\u0641",
      mine: "\u0645\u0630\u0643\u0631\u0627\u062A \u0645\u0635\u0627\u0631\u064A\u0641\u064A",
      approvals: "\u0628\u0627\u0646\u062A\u0638\u0627\u0631 \u0627\u0644\u0645\u0648\u0627\u0641\u0642\u0629"
    },
    category: {
      transport: "\u0627\u0644\u0646\u0642\u0644",
      fuel: "\u0627\u0644\u0648\u0642\u0648\u062F",
      accommodation: "\u0627\u0644\u0625\u0642\u0627\u0645\u0629",
      meals: "\u0627\u0644\u0625\u0637\u0639\u0627\u0645",
      supplies: "\u0627\u0644\u0644\u0648\u0627\u0632\u0645",
      printing: "\u0627\u0644\u0637\u0628\u0627\u0639\u0629 \u0648\u0627\u0644\u0646\u0633\u062E",
      software: "\u0627\u0644\u0628\u0631\u0645\u062C\u064A\u0627\u062A \u0648\u0627\u0644\u0627\u0634\u062A\u0631\u0627\u0643\u0627\u062A",
      telecom: "\u0627\u0644\u0627\u062A\u0635\u0627\u0644\u0627\u062A",
      training: "\u0627\u0644\u062A\u0643\u0648\u064A\u0646",
      permit_fees: "\u0645\u0639\u0627\u0644\u064A\u0645 \u0627\u0644\u0631\u062E\u0635 \u0648\u0627\u0644\u0623\u062A\u0627\u0648\u0627\u062A",
      other: "\u0623\u062E\u0631\u0649"
    },
    status: {
      submitted: "\u0642\u064A\u062F \u0627\u0644\u0627\u0646\u062A\u0638\u0627\u0631",
      approved: "\u062A\u0645\u062A \u0627\u0644\u0645\u0648\u0627\u0641\u0642\u0629",
      rejected: "\u0645\u0631\u0641\u0648\u0636\u0629",
      reimbursed: "\u062A\u0645 \u0627\u0644\u062A\u0639\u0648\u064A\u0636"
    },
    mine: {
      title: "\u0645\u0630\u0643\u0631\u0627\u062A \u0645\u0635\u0627\u0631\u064A\u0641\u064A",
      listLabel: "\u0642\u0627\u0626\u0645\u0629 \u0645\u0630\u0643\u0631\u0627\u062A \u0645\u0635\u0627\u0631\u064A\u0641\u064A",
      new: "\u0645\u0630\u0643\u0631\u0629 \u0645\u0635\u0627\u0631\u064A\u0641 \u062C\u062F\u064A\u062F\u0629",
      resubmit: "\u0625\u0639\u0627\u062F\u0629 \u0627\u0644\u0625\u0631\u0633\u0627\u0644",
      filters: {
        label: "\u0639\u0648\u0627\u0645\u0644 \u0627\u0644\u062A\u0635\u0641\u064A\u0629",
        status: "\u0627\u0644\u062D\u0627\u0644\u0629",
        all: "\u0643\u0644 \u0627\u0644\u062D\u0627\u0644\u0627\u062A"
      },
      empty: {
        title: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0645\u0630\u0643\u0631\u0627\u062A \u0645\u0635\u0627\u0631\u064A\u0641",
        description: "\u0635\u0648\u0651\u0631 \u0648\u062B\u064A\u0642\u0629 \u0627\u0644\u0625\u062B\u0628\u0627\u062A \u062B\u0645 \u0635\u0631\u0651\u062D \u0628\u0627\u0644\u0645\u0635\u0631\u0648\u0641: \u064A\u0631\u0627\u062C\u0639\u0647 \u0645\u0633\u0624\u0648\u0644 \u0627\u0644\u0645\u0648\u0627\u0641\u0642\u0629 \u0642\u0628\u0644 \u062A\u0639\u0648\u064A\u0636\u0647."
      },
      filtered: {
        title: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0645\u0630\u0643\u0631\u0627\u062A \u0645\u0635\u0627\u0631\u064A\u0641 \u0628\u0647\u0630\u0647 \u0627\u0644\u062D\u0627\u0644\u0629",
        description: "\u0627\u062E\u062A\u0631 \u062D\u0627\u0644\u0629 \u0623\u062E\u0631\u0649 \u0644\u0639\u0631\u0636 \u0645\u0630\u0643\u0631\u0627\u062A \u0645\u0635\u0627\u0631\u064A\u0641\u0643.",
        clear: "\u0639\u0631\u0636 \u0643\u0644 \u0645\u0630\u0643\u0631\u0627\u062A \u0645\u0635\u0627\u0631\u064A\u0641\u064A"
      },
      loadFailedTitle: "\u062A\u0639\u0630\u0651\u0631 \u062A\u062D\u0645\u064A\u0644 \u0645\u0630\u0643\u0631\u0627\u062A \u0645\u0635\u0627\u0631\u064A\u0641\u0643",
      loadFailedBody: "\u062A\u062D\u0642\u0642 \u0645\u0646 \u0627\u062A\u0635\u0627\u0644\u0643 \u062B\u0645 \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629.",
      loadMore: "\u0639\u0631\u0636 \u0627\u0644\u0645\u0632\u064A\u062F \u0645\u0646 \u0645\u0630\u0643\u0631\u0627\u062A \u0627\u0644\u0645\u0635\u0627\u0631\u064A\u0641",
      loadingMore: "\u062C\u0627\u0631\u064D \u0627\u0644\u062A\u062D\u0645\u064A\u0644\u2026",
      submitted: "\u062A\u0645 \u0625\u0631\u0633\u0627\u0644 \u0645\u0630\u0643\u0631\u0629 \u0645\u0635\u0627\u0631\u064A\u0641\u0643 \u0625\u0644\u0649 \u0627\u0644\u0645\u0633\u0624\u0648\u0644\u064A\u0646 \u0639\u0646 \u0627\u0644\u0645\u0648\u0627\u0641\u0642\u0629.",
      dismiss: "\u0625\u063A\u0644\u0627\u0642 \u0647\u0630\u0647 \u0627\u0644\u0631\u0633\u0627\u0644\u0629"
    },
    card: {
      total: "\u0627\u0644\u0645\u062C\u0645\u0648\u0639 \u0628\u0627\u062D\u062A\u0633\u0627\u0628 \u0627\u0644\u0623\u062F\u0627\u0621\u0627\u062A",
      amounts: "\u062F\u0648\u0646 \u0627\u062D\u062A\u0633\u0627\u0628 \u0627\u0644\u0623\u062F\u0627\u0621\u0627\u062A {ht}\u060C \u0627\u0644\u0623\u062F\u0627\u0621 \u0639\u0644\u0649 \u0627\u0644\u0642\u064A\u0645\u0629 \u0627\u0644\u0645\u0636\u0627\u0641\u0629 {vat}",
      vatDeductible: "\u0627\u0644\u0623\u062F\u0627\u0621 \u0642\u0627\u0628\u0644 \u0644\u0644\u0637\u0631\u062D",
      vatNotDeductible: "\u0627\u0644\u0623\u062F\u0627\u0621 \u063A\u064A\u0631 \u0642\u0627\u0628\u0644 \u0644\u0644\u0637\u0631\u062D",
      spentOn: "\u0645\u0635\u0631\u0648\u0641 \u0628\u062A\u0627\u0631\u064A\u062E {date}",
      submittedBy: "\u0635\u0631\u0651\u062D \u0628\u0647\u0627 {name}",
      noProject: "\u062F\u0648\u0646 \u0645\u0634\u0631\u0648\u0639",
      receiptOpen: "\u0639\u0631\u0636 \u0648\u062B\u064A\u0642\u0629 \u0627\u0644\u0625\u062B\u0628\u0627\u062A",
      receiptOpening: "\u062C\u0627\u0631\u064D \u0627\u0644\u0641\u062A\u062D\u2026",
      receiptChecking: "\u0648\u062B\u064A\u0642\u0629 \u0627\u0644\u0625\u062B\u0628\u0627\u062A \u0642\u064A\u062F \u0627\u0644\u0641\u062D\u0635",
      receiptOpenFailed: "\u062A\u0639\u0630\u0651\u0631 \u0641\u062A\u062D \u0648\u062B\u064A\u0642\u0629 \u0627\u0644\u0625\u062B\u0628\u0627\u062A. \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629 \u0628\u0639\u062F \u0644\u062D\u0638\u0627\u062A.",
      decision: {
        approved: "\u0648\u0627\u0641\u0642 \u0639\u0644\u064A\u0647\u0627 {name} \u0628\u062A\u0627\u0631\u064A\u062E {date}",
        rejected: "\u0631\u0641\u0636\u0647\u0627 {name} \u0628\u062A\u0627\u0631\u064A\u062E {date}",
        reason: "\u0627\u0644\u0633\u0628\u0628: {reason}",
        reimbursed: "\u062A\u0645 \u062A\u0639\u0648\u064A\u0636\u0647\u0627 \u0628\u062A\u0627\u0631\u064A\u062E {date}"
      }
    },
    form: {
      title: "\u0645\u0630\u0643\u0631\u0629 \u0645\u0635\u0627\u0631\u064A\u0641 \u062C\u062F\u064A\u062F\u0629",
      resubmitTitle: "\u0625\u0639\u0627\u062F\u0629 \u0625\u0631\u0633\u0627\u0644 \u0645\u0630\u0643\u0631\u0629 \u0627\u0644\u0645\u0635\u0627\u0631\u064A\u0641",
      intro: "\u0623\u0631\u0641\u0642 \u0648\u062B\u064A\u0642\u0629 \u0627\u0644\u0625\u062B\u0628\u0627\u062A (\u0635\u0648\u0631\u0629 \u0623\u0648 \u0645\u0644\u0641 PDF) \u062B\u0645 \u0623\u062F\u062E\u0644 \u0628\u064A\u0627\u0646\u0627\u062A \u0627\u0644\u0645\u0635\u0631\u0648\u0641.",
      resubmitIntro: "\u062A\u0645 \u0631\u0641\u0636 \u0647\u0630\u0647 \u0627\u0644\u0645\u0630\u0643\u0631\u0629. \u0648\u062B\u064A\u0642\u0629 \u0627\u0644\u0625\u062B\u0628\u0627\u062A \u0627\u0644\u0623\u0635\u0644\u064A\u0629 \u0645\u062D\u0641\u0648\u0638\u0629: \u0635\u062D\u0651\u062D \u0645\u0627 \u064A\u0644\u0632\u0645 \u062B\u0645 \u0623\u0639\u062F \u0625\u0631\u0633\u0627\u0644\u0647\u0627.",
      receipt: {
        legend: "\u0648\u062B\u064A\u0642\u0629 \u0627\u0644\u0625\u062B\u0628\u0627\u062A",
        help: "\u0635\u0648\u0631\u0629 \u0648\u0627\u0636\u062D\u0629 \u0644\u0644\u0648\u0635\u0644 \u0623\u0648 \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629\u060C \u0623\u0648 \u0645\u0644\u0641 PDF. \u064A\u0645\u0643\u0646 \u0644\u0644\u0645\u0633\u0624\u0648\u0644 \u0639\u0646 \u0627\u0644\u0645\u0648\u0627\u0641\u0642\u0629 \u0641\u062A\u062D\u0647\u0627 \u0628\u0639\u062F \u0627\u0646\u062A\u0647\u0627\u0621 \u0627\u0644\u0641\u062D\u0635 \u0628\u0645\u0636\u0627\u062F \u0627\u0644\u0641\u064A\u0631\u0648\u0633\u0627\u062A.",
        takePhoto: "\u0627\u0644\u062A\u0642\u0627\u0637 \u0635\u0648\u0631\u0629",
        chooseFile: "\u0627\u062E\u062A\u064A\u0627\u0631 \u0645\u0644\u0641",
        preparing: "\u062C\u0627\u0631\u064D \u062A\u062D\u0636\u064A\u0631 \u0627\u0644\u0625\u0631\u0633\u0627\u0644\u2026",
        kept: "\u0648\u062B\u064A\u0642\u0629 \u0627\u0644\u0625\u062B\u0628\u0627\u062A \u0627\u0644\u0645\u062D\u0641\u0648\u0638\u0629: {name}",
        keptNoName: "\u0648\u062B\u064A\u0642\u0629 \u0625\u062B\u0628\u0627\u062A \u0627\u0644\u0645\u0630\u0643\u0631\u0629 \u0627\u0644\u0645\u0631\u0641\u0648\u0636\u0629 \u0645\u062D\u0641\u0648\u0638\u0629.",
        change: "\u062A\u063A\u064A\u064A\u0631 \u0648\u062B\u064A\u0642\u0629 \u0627\u0644\u0625\u062B\u0628\u0627\u062A",
        required: "\u0623\u0631\u0641\u0642 \u0648\u062B\u064A\u0642\u0629 \u0625\u062B\u0628\u0627\u062A \u0627\u0644\u0645\u0635\u0631\u0648\u0641.",
        pending: "\u0627\u0646\u062A\u0638\u0631 \u0627\u0646\u062A\u0647\u0627\u0621 \u0625\u0631\u0633\u0627\u0644 \u0648\u062B\u064A\u0642\u0629 \u0627\u0644\u0625\u062B\u0628\u0627\u062A.",
        refused: "\u0644\u0645 \u062A\u064F\u0642\u0628\u0644 \u0648\u062B\u064A\u0642\u0629 \u0627\u0644\u0625\u062B\u0628\u0627\u062A \u0647\u0630\u0647. \u0627\u062E\u062A\u0631 \u0645\u0644\u0641\u064B\u0627 \u0622\u062E\u0631.",
        folderFailed: "\u062A\u0639\u0630\u0651\u0631 \u062A\u062D\u0636\u064A\u0631 \u0645\u062C\u0644\u062F \u0648\u062B\u0627\u0626\u0642 \u0627\u0644\u0625\u062B\u0628\u0627\u062A \u0627\u0644\u062E\u0627\u0635 \u0628\u0643. \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629 \u0628\u0639\u062F \u0644\u062D\u0638\u0627\u062A."
      },
      fields: {
        category: "\u0627\u0644\u0635\u0646\u0641",
        categoryPlaceholder: "\u0627\u062E\u062A\u0631 \u0635\u0646\u0641\u064B\u0627",
        label: "\u0645\u0648\u0636\u0648\u0639 \u0627\u0644\u0645\u0635\u0631\u0648\u0641",
        labelHint: "\u0645\u062B\u0627\u0644: \u0645\u0639\u0644\u0648\u0645 \u0627\u0644\u0637\u0631\u064A\u0642 \u0627\u0644\u0633\u064A\u0627\u0631\u0629\u060C \u0634\u0631\u0627\u0621 \u062D\u0628\u0631 \u0627\u0644\u0637\u0627\u0628\u0639\u0629.",
        spentOn: "\u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0645\u0635\u0631\u0648\u0641",
        project: "\u0627\u0644\u0645\u0634\u0631\u0648\u0639",
        projectHint: "\u0627\u062E\u062A\u064A\u0627\u0631\u064A: \u062A\u064F\u0642\u062A\u0631\u062D \u0645\u0634\u0627\u0631\u064A\u0639\u0643 \u0641\u0642\u0637.",
        noProject: "\u062F\u0648\u0646 \u0645\u0634\u0631\u0648\u0639",
        vatRate: "\u0646\u0633\u0628\u0629 \u0627\u0644\u0623\u062F\u0627\u0621 \u0639\u0644\u0649 \u0627\u0644\u0642\u064A\u0645\u0629 \u0627\u0644\u0645\u0636\u0627\u0641\u0629",
        ttc: "\u0627\u0644\u0645\u062C\u0645\u0648\u0639 \u0628\u0627\u062D\u062A\u0633\u0627\u0628 \u0627\u0644\u0623\u062F\u0627\u0621\u0627\u062A",
        ttcHint: "\u0627\u0644\u0645\u0628\u0644\u063A \u0627\u0644\u062C\u0645\u0644\u064A \u0627\u0644\u0645\u062F\u0641\u0648\u0639 \u0643\u0645\u0627 \u064A\u0638\u0647\u0631 \u0641\u064A \u0648\u062B\u064A\u0642\u0629 \u0627\u0644\u0625\u062B\u0628\u0627\u062A.",
        ht: "\u0627\u0644\u0645\u0628\u0644\u063A \u062F\u0648\u0646 \u0627\u062D\u062A\u0633\u0627\u0628 \u0627\u0644\u0623\u062F\u0627\u0621\u0627\u062A",
        vat: "\u0627\u0644\u0623\u062F\u0627\u0621 \u0639\u0644\u0649 \u0627\u0644\u0642\u064A\u0645\u0629 \u0627\u0644\u0645\u0636\u0627\u0641\u0629",
        vatHint: "\u0645\u062D\u0633\u0648\u0628 \u0628\u0627\u0644\u0646\u0633\u0628\u0629 \u0627\u0644\u0645\u062E\u062A\u0627\u0631\u0629: \u0635\u062D\u0651\u062D\u0647 \u0625\u0630\u0627 \u0643\u0627\u0646\u062A \u0648\u062B\u064A\u0642\u0629 \u0627\u0644\u0625\u062B\u0628\u0627\u062A \u062A\u0630\u0643\u0631 \u062E\u0644\u0627\u0641 \u0630\u0644\u0643.",
        vatDeductible: "\u0627\u0644\u0623\u062F\u0627\u0621 \u0639\u0644\u0649 \u0627\u0644\u0642\u064A\u0645\u0629 \u0627\u0644\u0645\u0636\u0627\u0641\u0629 \u0641\u064A \u0648\u062B\u064A\u0642\u0629 \u0627\u0644\u0625\u062B\u0628\u0627\u062A \u0647\u0630\u0647 \u0642\u0627\u0628\u0644 \u0644\u0644\u0637\u0631\u062D"
      },
      amounts: {
        legend: "\u0627\u0644\u0645\u0628\u0627\u0644\u063A",
        summary: "\u062F\u0648\u0646 \u0627\u062D\u062A\u0633\u0627\u0628 \u0627\u0644\u0623\u062F\u0627\u0621\u0627\u062A {ht} + \u0627\u0644\u0623\u062F\u0627\u0621 {vat} = \u0627\u0644\u0645\u062C\u0645\u0648\u0639 {ttc}"
      },
      errors: {
        category: "\u0627\u062E\u062A\u0631 \u0635\u0646\u0641\u064B\u0627.",
        label: "\u0627\u0630\u0643\u0631 \u0645\u0648\u0636\u0648\u0639 \u0627\u0644\u0645\u0635\u0631\u0648\u0641.",
        spentOn: "\u0623\u062F\u062E\u0644 \u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0645\u0635\u0631\u0648\u0641.",
        spentInFuture: "\u0644\u0627 \u064A\u0645\u0643\u0646 \u0623\u0646 \u064A\u0643\u0648\u0646 \u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0645\u0635\u0631\u0648\u0641 \u0641\u064A \u0627\u0644\u0645\u0633\u062A\u0642\u0628\u0644.",
        ttc: "\u0623\u062F\u062E\u0644 \u0627\u0644\u0645\u062C\u0645\u0648\u0639 \u0628\u0627\u062D\u062A\u0633\u0627\u0628 \u0627\u0644\u0623\u062F\u0627\u0621\u0627\u062A \u0639\u0644\u0649 \u0623\u0646 \u064A\u0643\u0648\u0646 \u0623\u0643\u0628\u0631 \u0645\u0646 \u0635\u0641\u0631.",
        vatTooHigh: "\u0644\u0627 \u064A\u0645\u0643\u0646 \u0623\u0646 \u064A\u062A\u062C\u0627\u0648\u0632 \u0627\u0644\u0623\u062F\u0627\u0621 \u0627\u0644\u0645\u062C\u0645\u0648\u0639 \u0628\u0627\u062D\u062A\u0633\u0627\u0628 \u0627\u0644\u0623\u062F\u0627\u0621\u0627\u062A.",
        mismatch: "\u064A\u062C\u0628 \u0623\u0646 \u064A\u0633\u0627\u0648\u064A \u0627\u0644\u0645\u0628\u0644\u063A \u062F\u0648\u0646 \u0627\u062D\u062A\u0633\u0627\u0628 \u0627\u0644\u0623\u062F\u0627\u0621\u0627\u062A \u0632\u0627\u0626\u062F \u0627\u0644\u0623\u062F\u0627\u0621 \u0627\u0644\u0645\u062C\u0645\u0648\u0639 \u0628\u0627\u062D\u062A\u0633\u0627\u0628 \u0627\u0644\u0623\u062F\u0627\u0621\u0627\u062A.",
        RECEIPT_NOT_FOUND: "\u062A\u0639\u0630\u0651\u0631 \u0627\u0644\u0639\u062B\u0648\u0631 \u0639\u0644\u0649 \u0648\u062B\u064A\u0642\u0629 \u0627\u0644\u0625\u062B\u0628\u0627\u062A \u0647\u0630\u0647. \u0623\u0631\u0641\u0642\u0647\u0627 \u0645\u0646 \u062C\u062F\u064A\u062F \u062B\u0645 \u0623\u0631\u0633\u0644 \u0627\u0644\u0645\u0630\u0643\u0631\u0629.",
        RECEIPT_TYPE_NOT_ALLOWED: "\u064A\u062C\u0628 \u0623\u0646 \u062A\u0643\u0648\u0646 \u0648\u062B\u064A\u0642\u0629 \u0627\u0644\u0625\u062B\u0628\u0627\u062A \u0635\u0648\u0631\u0629 \u0623\u0648 \u0645\u0644\u0641 PDF.",
        RECEIPT_REJECTED: "\u0631\u0641\u0636 \u0641\u062D\u0635 \u0645\u0636\u0627\u062F \u0627\u0644\u0641\u064A\u0631\u0648\u0633\u0627\u062A \u0648\u062B\u064A\u0642\u0629 \u0627\u0644\u0625\u062B\u0628\u0627\u062A \u0647\u0630\u0647. \u0627\u062E\u062A\u0631 \u0645\u0644\u0641\u064B\u0627 \u0622\u062E\u0631.",
        RECEIPT_ALREADY_USED: "\u0648\u062B\u064A\u0642\u0629 \u0627\u0644\u0625\u062B\u0628\u0627\u062A \u0647\u0630\u0647 \u0645\u0633\u062A\u0639\u0645\u0644\u0629 \u0641\u064A \u0645\u0630\u0643\u0631\u0629 \u0645\u0635\u0627\u0631\u064A\u0641 \u0623\u062E\u0631\u0649.",
        PROJECT_NOT_FOUND: "\u0647\u0630\u0627 \u0627\u0644\u0645\u0634\u0631\u0648\u0639 \u063A\u064A\u0631 \u0645\u0648\u062C\u0648\u062F \u0623\u0648 \u0644\u0633\u062A \u0639\u0636\u0648\u064B\u0627 \u0641\u064A\u0647.",
        notAllowed: "\u0645\u062C\u0644\u062F \u0648\u062B\u0627\u0626\u0642 \u0627\u0644\u0625\u062B\u0628\u0627\u062A \u0627\u0644\u062E\u0627\u0635 \u0628\u0643 \u063A\u064A\u0631 \u0645\u062A\u0627\u062D \u062D\u0627\u0644\u064A\u064B\u0627."
      },
      submit: "\u0625\u0631\u0633\u0627\u0644 \u0645\u0630\u0643\u0631\u0629 \u0627\u0644\u0645\u0635\u0627\u0631\u064A\u0641",
      submitting: "\u062C\u0627\u0631\u064D \u0627\u0644\u0625\u0631\u0633\u0627\u0644\u2026",
      cancel: "\u0625\u0644\u063A\u0627\u0621"
    },
    approvals: {
      title: "\u0645\u0630\u0643\u0631\u0627\u062A \u0627\u0644\u0645\u0635\u0627\u0631\u064A\u0641 \u0627\u0644\u0645\u0637\u0644\u0648\u0628 \u0645\u0639\u0627\u0644\u062C\u062A\u0647\u0627",
      listLabel: "\u0642\u0627\u0626\u0645\u0629 \u0645\u0630\u0643\u0631\u0627\u062A \u0627\u0644\u0645\u0635\u0627\u0631\u064A\u0641",
      hint: "\u0648\u0627\u0641\u0642 \u0639\u0644\u0649 \u0645\u0630\u0643\u0631\u0627\u062A \u0627\u0644\u0645\u0635\u0627\u0631\u064A\u0641 \u0627\u0644\u0645\u0639\u0644\u0651\u0642\u0629 \u0623\u0648 \u0627\u0631\u0641\u0636\u0647\u0627\u060C \u062B\u0645 \u0639\u0644\u0651\u0645\u0647\u0627 \u0639\u0644\u0649 \u0623\u0646\u0647\u0627 \u0645\u0639\u0648\u064E\u0651\u0636\u0629 \u0628\u0639\u062F \u0625\u062C\u0631\u0627\u0621 \u0627\u0644\u062F\u0641\u0639.",
      scopeProjects: "\u062A\u0634\u0627\u0647\u062F \u0645\u0630\u0643\u0631\u0627\u062A \u0645\u0635\u0627\u0631\u064A\u0641 \u0645\u0634\u0627\u0631\u064A\u0639\u0643.",
      filters: {
        label: "\u0639\u0648\u0627\u0645\u0644 \u0627\u0644\u062A\u0635\u0641\u064A\u0629",
        status: "\u0627\u0644\u062D\u0627\u0644\u0629",
        all: "\u0643\u0644 \u0627\u0644\u062D\u0627\u0644\u0627\u062A"
      },
      empty: {
        title: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0645\u0630\u0643\u0631\u0627\u062A \u0645\u0635\u0627\u0631\u064A\u0641 \u0644\u0644\u0645\u0639\u0627\u0644\u062C\u0629",
        description: "\u0633\u062A\u0638\u0647\u0631 \u0647\u0646\u0627 \u0645\u0630\u0643\u0631\u0627\u062A \u0627\u0644\u0645\u0635\u0627\u0631\u064A\u0641 \u0627\u0644\u062A\u064A \u064A\u0635\u0631\u0651\u062D \u0628\u0647\u0627 \u0641\u0631\u064A\u0642\u0643."
      },
      filtered: {
        title: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0645\u0630\u0643\u0631\u0627\u062A \u0645\u0635\u0627\u0631\u064A\u0641 \u0628\u0647\u0630\u0647 \u0627\u0644\u062D\u0627\u0644\u0629",
        description: "\u0627\u062E\u062A\u0631 \u062D\u0627\u0644\u0629 \u0623\u062E\u0631\u0649 \u0644\u0639\u0631\u0636 \u0645\u0630\u0643\u0631\u0627\u062A \u0627\u0644\u0645\u0635\u0627\u0631\u064A\u0641.",
        clear: "\u0639\u0631\u0636 \u0643\u0644 \u0627\u0644\u062D\u0627\u0644\u0627\u062A"
      },
      loadFailedTitle: "\u062A\u0639\u0630\u0651\u0631 \u062A\u062D\u0645\u064A\u0644 \u0645\u0630\u0643\u0631\u0627\u062A \u0627\u0644\u0645\u0635\u0627\u0631\u064A\u0641",
      loadFailedBody: "\u062A\u062D\u0642\u0642 \u0645\u0646 \u0627\u062A\u0635\u0627\u0644\u0643 \u062B\u0645 \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629.",
      loadMore: "\u0639\u0631\u0636 \u0627\u0644\u0645\u0632\u064A\u062F \u0645\u0646 \u0645\u0630\u0643\u0631\u0627\u062A \u0627\u0644\u0645\u0635\u0627\u0631\u064A\u0641",
      loadingMore: "\u062C\u0627\u0631\u064D \u0627\u0644\u062A\u062D\u0645\u064A\u0644\u2026",
      approve: "\u0627\u0644\u0645\u0648\u0627\u0641\u0642\u0629",
      reject: "\u0627\u0644\u0631\u0641\u0636",
      reimbursed: "\u062A\u0639\u0644\u064A\u0645\u0647\u0627 \u0643\u0645\u0639\u0648\u064E\u0651\u0636\u0629",
      busy: "\u062C\u0627\u0631\u064D \u0627\u0644\u0645\u0639\u0627\u0644\u062C\u0629\u2026",
      ownHint: "\u0644\u0627 \u064A\u0645\u0643\u0646\u0643 \u0627\u0644\u0628\u062A\u0651 \u0641\u064A \u0645\u0630\u0643\u0631\u0629 \u0645\u0635\u0627\u0631\u064A\u0641\u0643 \u0627\u0644\u062E\u0627\u0635\u0629: \u064A\u062C\u0628 \u0623\u0646 \u064A\u062A\u0648\u0644\u0649 \u0630\u0644\u0643 \u0645\u0633\u0624\u0648\u0644 \u0645\u0648\u0627\u0641\u0642\u0629 \u0622\u062E\u0631.",
      staleHint: "\u062A\u063A\u064A\u0651\u0631\u062A \u0645\u0630\u0643\u0631\u0629 \u0627\u0644\u0645\u0635\u0627\u0631\u064A\u0641 \u0647\u0630\u0647. \u062A\u0645 \u062A\u062D\u062F\u064A\u062B \u0627\u0644\u0642\u0627\u0626\u0645\u0629: \u0631\u0627\u062C\u0639\u0647\u0627 \u062B\u0645 \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629.",
      done: {
        approved: "\u062A\u0645\u062A \u0627\u0644\u0645\u0648\u0627\u0641\u0642\u0629 \u0639\u0644\u0649 \u0645\u0630\u0643\u0631\u0629 \u0627\u0644\u0645\u0635\u0627\u0631\u064A\u0641 \xAB{label}\xBB.",
        rejected: "\u062A\u0645 \u0631\u0641\u0636 \u0645\u0630\u0643\u0631\u0629 \u0627\u0644\u0645\u0635\u0627\u0631\u064A\u0641 \xAB{label}\xBB: \u062A\u0645 \u0625\u0639\u0644\u0627\u0645 {name}.",
        reimbursed: "\u062A\u0645 \u062A\u0639\u0644\u064A\u0645 \u0645\u0630\u0643\u0631\u0629 \u0627\u0644\u0645\u0635\u0627\u0631\u064A\u0641 \xAB{label}\xBB \u0643\u0645\u0639\u0648\u064E\u0651\u0636\u0629."
      },
      rejectDialog: {
        title: "\u0631\u0641\u0636 \u0645\u0630\u0643\u0631\u0629 \u0627\u0644\u0645\u0635\u0627\u0631\u064A\u0641 \xAB{label}\xBB",
        body: "\u064A\u064F\u0631\u0633\u0644 \u0627\u0644\u0633\u0628\u0628 \u0625\u0644\u0649 {name} \u0627\u0644\u0630\u064A \u064A\u0645\u0643\u0646\u0647 \u062A\u0635\u062D\u064A\u062D \u0627\u0644\u0645\u0630\u0643\u0631\u0629 \u0648\u0625\u0639\u0627\u062F\u0629 \u0625\u0631\u0633\u0627\u0644\u0647\u0627.",
        reason: "\u0633\u0628\u0628 \u0627\u0644\u0631\u0641\u0636",
        reasonHint: "500 \u062D\u0631\u0641 \u0639\u0644\u0649 \u0627\u0644\u0623\u0643\u062B\u0631.",
        reasonRequired: "\u0627\u0630\u0643\u0631 \u0633\u0628\u0628 \u0627\u0644\u0631\u0641\u0636.",
        confirm: "\u0631\u0641\u0636 \u0645\u0630\u0643\u0631\u0629 \u0627\u0644\u0645\u0635\u0627\u0631\u064A\u0641",
        cancel: "\u0625\u0644\u063A\u0627\u0621"
      },
      reimburseDialog: {
        title: "\u062A\u0639\u0644\u064A\u0645 \xAB{label}\xBB \u0643\u0645\u0639\u0648\u064E\u0651\u0636\u0629",
        body: "\u0647\u0644 \u062A\u0624\u0643\u062F \u0623\u0646\u0647 \u062A\u0645 \u062A\u0639\u0648\u064A\u0636 {name} \u0628\u0645\u0628\u0644\u063A {amount}\u061F \u0644\u0627 \u064A\u0645\u0643\u0646 \u0627\u0644\u062A\u0631\u0627\u062C\u0639 \u0639\u0646 \u0647\u0630\u0627 \u0627\u0644\u0625\u062C\u0631\u0627\u0621.",
        confirm: "\u062A\u0623\u0643\u064A\u062F \u0627\u0644\u062A\u0639\u0648\u064A\u0636",
        cancel: "\u0625\u0644\u063A\u0627\u0621"
      }
    }
  },
  dashboard: {
    title: "\u0627\u0644\u0623\u0631\u0642\u0627\u0645 \u0627\u0644\u0623\u0633\u0627\u0633\u064A\u0629",
    asOf: "\u0627\u0644\u0648\u0636\u0639\u064A\u0629 \u0625\u0644\u0649 \u063A\u0627\u064A\u0629 {date}. \u0627\u0644\u0645\u0628\u0627\u0644\u063A \u0628\u0627\u0644\u062F\u064A\u0646\u0627\u0631 \u0627\u0644\u062A\u0648\u0646\u0633\u064A\u061B \u0644\u0627 \u062A\u064F\u062D\u062A\u0633\u0628 \u0627\u0644\u0641\u0648\u0627\u062A\u064A\u0631 \u0628\u0627\u0644\u0639\u0645\u0644\u0627\u062A \u0627\u0644\u0623\u062C\u0646\u0628\u064A\u0629.",
    scopeProjects: "\u062A\u0634\u0645\u0644 \u0647\u0630\u0647 \u0627\u0644\u0623\u0631\u0642\u0627\u0645 \u0641\u0648\u0627\u062A\u064A\u0631 \u0645\u0634\u0627\u0631\u064A\u0639\u0643 \u0641\u0642\u0637.",
    loadFailedTitle: "\u062A\u0639\u0630\u0651\u0631 \u062A\u062D\u0645\u064A\u0644 \u0644\u0648\u062D\u0629 \u0627\u0644\u0642\u064A\u0627\u062F\u0629",
    loadFailedBody: "\u062A\u062D\u0642\u0642 \u0645\u0646 \u0627\u062A\u0635\u0627\u0644\u0643 \u062B\u0645 \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629.",
    kpi: {
      groupLabel: "\u0627\u0644\u0645\u0624\u0634\u0631\u0627\u062A \u0627\u0644\u0623\u0633\u0627\u0633\u064A\u0629",
      monthInvoiced: {
        label: "\u0627\u0644\u0645\u0641\u0648\u062A\u0631 \u0647\u0630\u0627 \u0627\u0644\u0634\u0647\u0631",
        detail: "{ht} \u062F\u0648\u0646 \u0627\u062D\u062A\u0633\u0627\u0628 \u0627\u0644\u0623\u062F\u0627\u0621\u0627\u062A\u060C \u0627\u0644\u0623\u062F\u0627\u0621 {vat}"
      },
      monthCollected: {
        label: "\u0627\u0644\u0645\u0642\u0628\u0648\u0636 \u0647\u0630\u0627 \u0627\u0644\u0634\u0647\u0631",
        detail: "\u0627\u0644\u0645\u0628\u0627\u0644\u063A \u0627\u0644\u0645\u062E\u0635\u0648\u0645\u0629 \u0645\u0646 \u0642\u0628\u0644 \u062D\u0631\u0641\u0627\u0626\u0643: {amount}"
      },
      yearInvoiced: {
        label: "\u0627\u0644\u0645\u0641\u0648\u062A\u0631 \u0633\u0646\u0629 {year}",
        detail: "{ht} \u062F\u0648\u0646 \u0627\u062D\u062A\u0633\u0627\u0628 \u0627\u0644\u0623\u062F\u0627\u0621\u0627\u062A"
      },
      yearCollected: {
        label: "\u0627\u0644\u0645\u0642\u0628\u0648\u0636 \u0633\u0646\u0629 {year}",
        detail: "\u0627\u0644\u0645\u0628\u0627\u0644\u063A \u0627\u0644\u0645\u062E\u0635\u0648\u0645\u0629 \u0645\u0646 \u0642\u0628\u0644 \u062D\u0631\u0641\u0627\u0626\u0643: {amount}"
      },
      outstanding: {
        label: "\u0627\u0644\u0645\u062A\u0628\u0642\u064A \u0639\u0644\u0649 \u0627\u0644\u062D\u0631\u0641\u0627\u0621",
        detail: "{count, plural, =0 {\u0644\u0627 \u062A\u0648\u062C\u062F \u0641\u0648\u0627\u062A\u064A\u0631 \u0641\u064A \u0627\u0644\u0627\u0646\u062A\u0638\u0627\u0631} one {\u0641\u0627\u062A\u0648\u0631\u0629 \u0648\u0627\u062D\u062F\u0629 \u0641\u064A \u0627\u0644\u0627\u0646\u062A\u0638\u0627\u0631} two {\u0641\u0627\u062A\u0648\u0631\u062A\u0627\u0646 \u0641\u064A \u0627\u0644\u0627\u0646\u062A\u0638\u0627\u0631} few {# \u0641\u0648\u0627\u062A\u064A\u0631 \u0641\u064A \u0627\u0644\u0627\u0646\u062A\u0638\u0627\u0631} many {# \u0641\u0627\u062A\u0648\u0631\u0629 \u0641\u064A \u0627\u0644\u0627\u0646\u062A\u0638\u0627\u0631} other {# \u0641\u0627\u062A\u0648\u0631\u0629 \u0641\u064A \u0627\u0644\u0627\u0646\u062A\u0638\u0627\u0631}}"
      },
      overdue: {
        label: "\u0645\u0646\u0647 \u0627\u0644\u0645\u062A\u0623\u062E\u0631",
        detail: "{count, plural, =0 {\u0644\u0627 \u062A\u0648\u062C\u062F \u0641\u0648\u0627\u062A\u064A\u0631 \u0645\u062A\u0623\u062E\u0631\u0629} one {\u0641\u0627\u062A\u0648\u0631\u0629 \u0648\u0627\u062D\u062F\u0629 \u0645\u062A\u0623\u062E\u0631\u0629} two {\u0641\u0627\u062A\u0648\u0631\u062A\u0627\u0646 \u0645\u062A\u0623\u062E\u0631\u062A\u0627\u0646} few {# \u0641\u0648\u0627\u062A\u064A\u0631 \u0645\u062A\u0623\u062E\u0631\u0629} many {# \u0641\u0627\u062A\u0648\u0631\u0629 \u0645\u062A\u0623\u062E\u0631\u0629} other {# \u0641\u0627\u062A\u0648\u0631\u0629 \u0645\u062A\u0623\u062E\u0631\u0629}}",
        flag: "\u064A\u062A\u0637\u0644\u0628 \u062A\u0630\u0643\u064A\u0631\u064B\u0627",
        none: "\u0645\u062D\u064A\u0651\u0646"
      },
      withholdings: {
        label: "\u0627\u0644\u062E\u0635\u0648\u0645\u0627\u062A \u0627\u0644\u0645\u0637\u0644\u0648\u0628 \u0627\u0633\u062A\u0631\u062C\u0627\u0639\u0647\u0627",
        detail: "{count, plural, =0 {\u0644\u0627 \u062A\u0648\u062C\u062F \u0634\u0647\u0627\u0626\u062F \u062E\u0635\u0645 \u0646\u0627\u0642\u0635\u0629} one {\u062F\u0641\u0639\u0629 \u0648\u0627\u062D\u062F\u0629 \u062F\u0648\u0646 \u0634\u0647\u0627\u062F\u0629 \u062E\u0635\u0645} two {\u062F\u0641\u0639\u062A\u0627\u0646 \u062F\u0648\u0646 \u0634\u0647\u0627\u062F\u0629 \u062E\u0635\u0645} few {# \u062F\u0641\u0639\u0627\u062A \u062F\u0648\u0646 \u0634\u0647\u0627\u062F\u0629 \u062E\u0635\u0645} many {# \u062F\u0641\u0639\u0629 \u062F\u0648\u0646 \u0634\u0647\u0627\u062F\u0629 \u062E\u0635\u0645} other {# \u062F\u0641\u0639\u0629 \u062F\u0648\u0646 \u0634\u0647\u0627\u062F\u0629 \u062E\u0635\u0645}}"
      },
      vat: {
        label: "\u0627\u0644\u0623\u062F\u0627\u0621 \u0627\u0644\u0645\u0641\u0648\u062A\u0631 \u0647\u0630\u0627 \u0627\u0644\u0634\u0647\u0631",
        detail: "\u0639\u0644\u0649 \u0627\u0644\u0641\u0648\u0627\u062A\u064A\u0631 \u0627\u0644\u0635\u0627\u062F\u0631\u0629 \u0641\u064A {month}"
      }
    },
    chart: {
      title: "\u0627\u0644\u0645\u0641\u0648\u062A\u0631 \u0648\u0627\u0644\u0645\u0642\u0628\u0648\u0636 \u0639\u0644\u0649 \u0645\u062F\u0649 12 \u0634\u0647\u0631\u064B\u0627",
      description: "\u0627\u0644\u0645\u0628\u0627\u0644\u063A \u0627\u0644\u0645\u0641\u0648\u062A\u0631\u0629 \u0628\u0627\u062D\u062A\u0633\u0627\u0628 \u0627\u0644\u0623\u062F\u0627\u0621\u0627\u062A \u0648\u0627\u0644\u0645\u0628\u0627\u0644\u063A \u0627\u0644\u0645\u0642\u0628\u0648\u0636\u0629\u060C \u0634\u0647\u0631\u064B\u0627 \u0628\u0634\u0647\u0631.",
      ariaLabel: "\u0631\u0633\u0645 \u0628\u064A\u0627\u0646\u064A \u0628\u0627\u0644\u0623\u0639\u0645\u062F\u0629 \u0644\u0644\u0645\u0628\u0627\u0644\u063A \u0627\u0644\u0645\u0641\u0648\u062A\u0631\u0629 \u0648\u0627\u0644\u0645\u0642\u0628\u0648\u0636\u0629 \u0645\u0646 {from} \u0625\u0644\u0649 {to}. \u0627\u0644\u0645\u0628\u0627\u0644\u063A \u0627\u0644\u062F\u0642\u064A\u0642\u0629 \u0641\u064A \u062C\u062F\u0648\u0644 \u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A.",
      invoiced: "\u0627\u0644\u0645\u0641\u0648\u062A\u0631 (\u0628\u0627\u062D\u062A\u0633\u0627\u0628 \u0627\u0644\u0623\u062F\u0627\u0621\u0627\u062A)",
      collected: "\u0627\u0644\u0645\u0642\u0628\u0648\u0636",
      axisUnit: "\u0627\u0644\u0645\u0628\u0627\u0644\u063A \u0628\u0627\u0644\u062F\u064A\u0646\u0627\u0631",
      tickThousand: "{value} \u0623\u0644\u0641",
      tickMillion: "{value} \u0645",
      tooltipTitle: "{month}"
    },
    table: {
      show: "\u0639\u0631\u0636 \u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A",
      hide: "\u0625\u062E\u0641\u0627\u0621 \u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A",
      caption: "\u0627\u0644\u0645\u0641\u0648\u062A\u0631 \u0648\u0627\u0644\u0645\u0642\u0628\u0648\u0636 \u0634\u0647\u0631\u064A\u064B\u0627 \u0628\u0627\u0644\u062F\u064A\u0646\u0627\u0631",
      month: "\u0627\u0644\u0634\u0647\u0631",
      invoiced: "\u0627\u0644\u0645\u0641\u0648\u062A\u0631 (\u0628\u0627\u062D\u062A\u0633\u0627\u0628 \u0627\u0644\u0623\u062F\u0627\u0621\u0627\u062A)",
      collected: "\u0627\u0644\u0645\u0642\u0628\u0648\u0636",
      total: "\u0627\u0644\u0645\u062C\u0645\u0648\u0639 \u0639\u0644\u0649 12 \u0634\u0647\u0631\u064B\u0627"
    }
  },
  einvoicing: {
    chip: {
      details: "\u062A\u0641\u0627\u0635\u064A\u0644 \u0627\u0644\u0625\u0631\u0633\u0627\u0644 \u0625\u0644\u0649 TTN",
      attempt: "\u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629 \u0631\u0642\u0645 {n}: {status}\u060C \u0628\u062A\u0627\u0631\u064A\u062E {date}."
    },
    kind: {
      seal: "\u0627\u0644\u062E\u062A\u0645 \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A",
      test: "\u0634\u0647\u0627\u062F\u0629 \u0627\u062E\u062A\u0628\u0627\u0631",
      digigo: "DigiGO (\u062A\u0648\u0642\u064A\u0639 \u0639\u0646 \u0628\u064F\u0639\u062F)"
    },
    panel: {
      title: "\u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629 \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A\u0629 (El Fatoora)",
      loading: "\u062C\u0627\u0631\u064D \u062A\u062D\u0645\u064A\u0644 \u0645\u062A\u0627\u0628\u0639\u0629 El Fatoora\u2026",
      loadFailed: "\u062A\u0639\u0630\u0651\u0631 \u062A\u062D\u0645\u064A\u0644 \u0645\u062A\u0627\u0628\u0639\u0629 \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629 \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A\u0629.",
      noAttempt: "\u0644\u0627 \u064A\u0648\u062C\u062F \u0625\u0631\u0633\u0627\u0644 \u0625\u0644\u0649 TTN \u062D\u062A\u0649 \u0627\u0644\u0622\u0646.",
      attempts: "\u0639\u0645\u0644\u064A\u0627\u062A \u0627\u0644\u0625\u0631\u0633\u0627\u0644 \u0625\u0644\u0649 TTN",
      attempt: "\u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629 \u0631\u0642\u0645 {n}",
      status: {
        awaiting_signature: "\u0641\u064A \u0627\u0646\u062A\u0638\u0627\u0631 \u0627\u0644\u062A\u0648\u0642\u064A\u0639",
        signed: "\u0645\u0648\u0642\u0651\u0639\u0629",
        submitted: "\u0645\u064F\u0631\u0633\u064E\u0644\u0629 \u0625\u0644\u0649 TTN",
        accepted: "\u0645\u0642\u0628\u0648\u0644\u0629",
        rejected: "\u0645\u0631\u0641\u0648\u0636\u0629",
        failed: "\u0641\u0634\u0644",
        manual: "\u0645\u0648\u062F\u0639\u0629 \u064A\u062F\u0648\u064A\u064B\u0627"
      },
      dates: "\u0623\u064F\u0646\u0634\u0626\u062A \u0628\u062A\u0627\u0631\u064A\u062E {created}\u060C \u0648\u0622\u062E\u0631 \u0645\u0631\u062D\u0644\u0629 \u0628\u062A\u0627\u0631\u064A\u062E {last}.",
      requestedBy: "\u0628\u0637\u0644\u0628 \u0645\u0646 {name}.",
      reference: "\u0645\u0631\u062C\u0639 TTN: {reference}",
      manualReference: "\u0627\u0644\u0645\u0631\u062C\u0639 \u0627\u0644\u0645\u062F\u062E\u0644 \u064A\u062F\u0648\u064A\u064B\u0627: {reference}",
      rejection: {
        reason: "\u0633\u0628\u0628 \u0627\u0644\u0631\u0641\u0636 \u0643\u0645\u0627 \u0630\u0643\u0631\u0647 TTN: \xAB{reason}\xBB (\u0627\u0644\u0631\u0645\u0632 {code}).",
        kind: {
          technical: "\u0631\u0641\u0636 \u062A\u0642\u0646\u064A (\u0627\u0644\u062A\u0648\u0642\u064A\u0639 \u0623\u0648 \u0635\u064A\u063A\u0629 \u0627\u0644\u0645\u0644\u0641).",
          content: "\u0631\u0641\u0636 \u064A\u062A\u0639\u0644\u0642 \u0628\u0627\u0644\u0645\u062D\u062A\u0648\u0649 (\u0645\u0639\u0637\u064A\u0627\u062A \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629)."
        }
      },
      failure: {
        detail: "\u062A\u0641\u0635\u064A\u0644 \u062A\u0642\u0646\u064A: {detail}",
        NO_CREDENTIAL: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0634\u0647\u0627\u062F\u0629 \u062A\u0648\u0642\u064A\u0639 \u0646\u0634\u0637\u0629: \u062A\u0639\u0630\u0651\u0631 \u062A\u0648\u0642\u064A\u0639 \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629.",
        CREDENTIAL_EXPIRED: "\u0627\u0646\u062A\u0647\u062A \u0635\u0644\u0627\u062D\u064A\u0629 \u0634\u0647\u0627\u062F\u0629 \u0627\u0644\u062A\u0648\u0642\u064A\u0639: \u062A\u0639\u0630\u0651\u0631 \u062A\u0648\u0642\u064A\u0639 \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629.",
        TEIF_INVALID: "\u0645\u0644\u0641 TEIF \u0627\u0644\u0645\u064F\u0646\u0634\u0623 \u063A\u064A\u0631 \u0635\u0627\u0644\u062D: \u0644\u0645 \u062A\u064F\u0631\u0633\u064E\u0644 \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629.",
        SIGNING_FAILED: "\u0641\u0634\u0644 \u062A\u0648\u0642\u064A\u0639 \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629.",
        TTN_UNREACHABLE: "\u062E\u062F\u0645\u0629 TTN \u063A\u064A\u0631 \u0645\u062A\u0627\u062D\u0629 \u062D\u0627\u0644\u064A\u064B\u0627.",
        TTN_REFUSED: "\u0631\u0641\u0636 TTN \u0627\u0633\u062A\u0644\u0627\u0645 \u0627\u0644\u0645\u0644\u0641.",
        TTN_NO_ANSWER: "\u0644\u0645 \u064A\u0631\u062F TTN \u0641\u064A \u0627\u0644\u0623\u062C\u0644 \u0627\u0644\u0645\u062D\u062F\u062F."
      },
      manageCredentials: "\u0625\u062F\u0627\u0631\u0629 \u0634\u0647\u0627\u062F\u0627\u062A \u0627\u0644\u062A\u0648\u0642\u064A\u0639",
      wait: {
        title: "\u0642\u064A\u062F \u0627\u0644\u0645\u0639\u0627\u0644\u062C\u0629 \u0644\u062F\u0649 TTN",
        body: "\u0644\u0627 \u064A\u0644\u0632\u0645 \u0623\u064A \u0625\u062C\u0631\u0627\u0621: \u062A\u062A\u062D\u062F\u0651\u062B \u0647\u0630\u0647 \u0627\u0644\u0635\u0641\u062D\u0629 \u062A\u0644\u0642\u0627\u0626\u064A\u064B\u0627 \u0628\u0645\u062C\u0631\u062F \u0631\u062F\u0651 TTN."
      },
      resubmit: {
        rejectedTitle: "\u0631\u0641\u0636 TTN \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629",
        failedTitle: "\u0641\u0634\u0644 \u0627\u0644\u0625\u0631\u0633\u0627\u0644 \u0625\u0644\u0649 TTN",
        body: "\u0639\u0627\u0644\u062C \u0633\u0628\u0628 \u0627\u0644\u0645\u0634\u0643\u0644 \u062B\u0645 \u0623\u0639\u062F \u0625\u0631\u0633\u0627\u0644 \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629: \u064A\u064F\u0631\u0633\u064E\u0644 \u0627\u0644\u0631\u0642\u0645 \u0646\u0641\u0633\u0647 \u0645\u0646 \u062C\u062F\u064A\u062F \u0648\u0644\u0627 \u062A\u062A\u063A\u064A\u0631 \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629 \u0630\u0627\u062A\u0647\u0627.",
        action: "\u0627\u0644\u062A\u0635\u062D\u064A\u062D \u062B\u0645 \u0625\u0639\u0627\u062F\u0629 \u0627\u0644\u0625\u0631\u0633\u0627\u0644",
        sending: "\u062C\u0627\u0631\u064D \u0627\u0644\u0625\u0631\u0633\u0627\u0644\u2026",
        done: "\u0623\u064F\u0639\u064A\u062F \u0625\u0631\u0633\u0627\u0644 \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629 \u0625\u0644\u0649 TTN \u0628\u0627\u0644\u0631\u0642\u0645 \u0646\u0641\u0633\u0647."
      },
      creditNote: {
        title: "\u0631\u0641\u0636 TTN \u0645\u062D\u062A\u0648\u0649 \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629",
        body: "\u0644\u0627 \u064A\u0645\u0643\u0646 \u062A\u0639\u062F\u064A\u0644 \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629 \u0627\u0644\u0635\u0627\u062F\u0631\u0629: \u0644\u0627 \u064A\u0645\u0643\u0646 \u0625\u0639\u0627\u062F\u0629 \u0627\u0633\u062A\u0639\u0645\u0627\u0644 \u0631\u0642\u0645\u0647\u0627 \u0628\u0645\u062D\u062A\u0648\u0649 \u0645\u0635\u062D\u064E\u0651\u062D.",
        steps: "\u0623\u0635\u062F\u0631 \u0623\u0648\u0644\u064B\u0627 \u0641\u0627\u062A\u0648\u0631\u0629 \u062A\u0639\u062F\u064A\u0644\u064A\u0629 \u062A\u0644\u063A\u064A \u0647\u0630\u0647 \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629\u060C \u062B\u0645 \u0623\u0646\u0634\u0626 \u0641\u0627\u062A\u0648\u0631\u0629 \u062C\u062F\u064A\u062F\u0629 \u0628\u0627\u0644\u0645\u0639\u0637\u064A\u0627\u062A \u0627\u0644\u0645\u0635\u062D\u064E\u0651\u062D\u0629.",
        action: "\u0625\u0635\u062F\u0627\u0631 \u0641\u0627\u062A\u0648\u0631\u0629 \u062A\u0639\u062F\u064A\u0644\u064A\u0629"
      },
      accepted: {
        title: "\u0642\u0628\u0644 TTN \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629",
        pdf: "\u064A\u062D\u0645\u0644 \u0645\u0644\u0641 PDF \u0644\u0644\u0641\u0627\u062A\u0648\u0631\u0629 \u0627\u0644\u0622\u0646 \u0645\u0631\u062C\u0639 TTN \u0648\u0631\u0645\u0632 QR."
      },
      manualDone: {
        title: "\u0623\u064F\u0648\u062F\u0639\u062A \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629 \u064A\u062F\u0648\u064A\u064B\u0627 \u0639\u0644\u0649 \u0628\u0648\u0627\u0628\u0629 TTN"
      },
      awaitingSignature: {
        title: "\u0641\u064A \u0627\u0646\u062A\u0638\u0627\u0631 \u062A\u0648\u0642\u064A\u0639\u0643 \u0639\u0628\u0631 DigiGO",
        body: "\u0647\u0630\u0647 \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629 \u062C\u0627\u0647\u0632\u0629: \u0633\u062A\u0646\u0637\u0644\u0642 \u0625\u0644\u0649 TTN \u0628\u0645\u062C\u0631\u062F \u062A\u0648\u0642\u064A\u0639 \u0645\u062C\u0645\u0648\u0639\u0629 \u0627\u0644\u0641\u0648\u0627\u062A\u064A\u0631 \u0639\u0628\u0631 DigiGO.",
        link: "\u062A\u0648\u0642\u064A\u0639 \u0627\u0644\u0645\u062C\u0645\u0648\u0639\u0629 \u0641\u064A \u0635\u0641\u062D\u0629 \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629 \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A\u0629"
      }
    },
    manual: {
      title: "\u062A\u0639\u0630\u0651\u0631 \u0627\u0644\u0625\u0631\u0633\u0627\u0644 \u0627\u0644\u0622\u0644\u064A: \u0627\u0644\u0625\u064A\u062F\u0627\u0639 \u0627\u0644\u064A\u062F\u0648\u064A",
      intro: "\u0641\u064A \u0627\u0646\u062A\u0638\u0627\u0631 \u0630\u0644\u0643\u060C \u064A\u0645\u0643\u0646\u0643\u0645 \u0625\u064A\u062F\u0627\u0639 \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629 \u0628\u0623\u0646\u0641\u0633\u0643\u0645 \u0639\u0644\u0649 \u0628\u0648\u0627\u0628\u0629 TTN.",
      step1: "\u0646\u0632\u0651\u0644\u0648\u0627 \u0645\u0644\u0641 TEIF \u0627\u0644\u062E\u0627\u0635 \u0628\u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629.",
      step2: "\u0623\u0648\u062F\u0639\u0648\u0647 \u0639\u0644\u0649 \u0628\u0648\u0627\u0628\u0629 El Fatoora \u0627\u0644\u062A\u0627\u0628\u0639\u0629 \u0644\u0640 TTN.",
      step3: "\u0633\u062C\u0651\u0644\u0648\u0627 \u0623\u062F\u0646\u0627\u0647 \u0627\u0644\u0645\u0631\u062C\u0639 \u0627\u0644\u0630\u064A \u064A\u0645\u0646\u062D\u0647 \u0644\u0643\u0645 TTN.",
      download: "\u062A\u0646\u0632\u064A\u0644 \u0645\u0644\u0641 TEIF",
      preparing: "\u062C\u0627\u0631\u064D \u062A\u062C\u0647\u064A\u0632 \u0627\u0644\u0645\u0644\u0641\u2026",
      signed: "\u0627\u0644\u0645\u0644\u0641 \u0645\u0648\u0642\u064E\u0651\u0639 \u0628\u0634\u0647\u0627\u062F\u0629 \u0645\u0643\u062A\u0628\u0643\u0645.",
      unsigned: "\u0627\u0644\u0645\u0644\u0641 \u063A\u064A\u0631 \u0645\u0648\u0642\u064E\u0651\u0639: \u062A\u0639\u0630\u0651\u0631 \u0627\u0633\u062A\u0639\u0645\u0627\u0644 \u0623\u064A \u0634\u0647\u0627\u062F\u0629\u060C \u0648\u0633\u062A\u0648\u0642\u0651\u0639\u0647 \u0628\u0648\u0627\u0628\u0629 TTN \u0639\u0646\u062F \u0627\u0644\u0625\u064A\u062F\u0627\u0639.",
      reference: "\u0645\u0631\u062C\u0639 TTN",
      referenceHint: "\u0645\u0646 3 \u0625\u0644\u0649 100 \u062D\u0631\u0641: \u062D\u0631\u0648\u0641 \u0648\u0623\u0631\u0642\u0627\u0645 \u0648\u0645\u0633\u0627\u0641\u0627\u062A \u0648 . _ / -",
      save: "\u062D\u0641\u0638 \u0627\u0644\u0645\u0631\u062C\u0639",
      saving: "\u062C\u0627\u0631\u064D \u0627\u0644\u062D\u0641\u0638\u2026",
      done: "\u062A\u0645 \u062D\u0641\u0638 \u0645\u0631\u062C\u0639 TTN.",
      errors: {
        required: "\u0623\u062F\u062E\u0644 \u0627\u0644\u0645\u0631\u062C\u0639 \u0627\u0644\u0630\u064A \u0645\u0646\u062D\u0647 TTN.",
        tooShort: "\u064A\u062C\u0628 \u0623\u0646 \u064A\u062A\u0643\u0648\u0646 \u0627\u0644\u0645\u0631\u062C\u0639 \u0645\u0646 3 \u0623\u062D\u0631\u0641 \u0639\u0644\u0649 \u0627\u0644\u0623\u0642\u0644.",
        format: "\u0627\u0633\u062A\u0639\u0645\u0644 \u0641\u0642\u0637 \u0627\u0644\u062D\u0631\u0648\u0641 \u0648\u0627\u0644\u0623\u0631\u0642\u0627\u0645 \u0648\u0627\u0644\u0645\u0633\u0627\u0641\u0627\u062A \u0648 . _ / - (100 \u062D\u0631\u0641 \u0639\u0644\u0649 \u0627\u0644\u0623\u0643\u062B\u0631)."
      }
    },
    mode: {
      title: "\u0646\u0645\u0637 \u0627\u0644\u0641\u0648\u062A\u0631\u0629 \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A\u0629",
      hint: "\u0627\u062E\u062A\u0631 \u0645\u0627 \u0625\u0630\u0627 \u0643\u0627\u0646\u062A \u0627\u0644\u0641\u0648\u0627\u062A\u064A\u0631 \u0627\u0644\u0635\u0627\u062F\u0631\u0629 \u0639\u0646 \u0645\u0643\u062A\u0628\u0643\u0645 \u062A\u064F\u0631\u0633\u064E\u0644 \u0625\u0644\u0649 TTN (El Fatoora). \u064A\u064F\u0637\u0644\u0628 \u062A\u0623\u0643\u064A\u062F \u0627\u0644\u0647\u0648\u064A\u0629 \u0644\u062D\u0641\u0638 \u0627\u0644\u062A\u063A\u064A\u064A\u0631.",
      label: "\u0627\u0644\u0646\u0645\u0637",
      options: {
        required: {
          name: "\u0625\u062C\u0628\u0627\u0631\u064A",
          help: "\u062A\u064F\u0648\u0642\u064E\u0651\u0639 \u0643\u0644 \u0641\u0627\u062A\u0648\u0631\u0629 \u0635\u0627\u062F\u0631\u0629 \u062B\u0645 \u062A\u064F\u0631\u0633\u064E\u0644 \u0625\u0644\u0649 TTN. \u0627\u062E\u062A\u0631 \u0647\u0630\u0627 \u0627\u0644\u0646\u0645\u0637 \u0625\u0630\u0627 \u0643\u0627\u0646 \u0627\u0644\u0642\u0627\u0646\u0648\u0646 \u0623\u0648 \u062D\u0631\u0641\u0627\u0624\u0643 \u064A\u0634\u062A\u0631\u0637\u0648\u0646 \u0630\u0644\u0643."
        },
        optional: {
          name: "\u0627\u062E\u062A\u064A\u0627\u0631\u064A",
          help: "\u062A\u064F\u0631\u0633\u064E\u0644 \u0627\u0644\u0641\u0648\u0627\u062A\u064A\u0631 \u0625\u0644\u0649 TTN \u0639\u0646\u062F\u0645\u0627 \u064A\u0645\u0644\u0643 \u0645\u0643\u062A\u0628\u0643\u0645 \u0634\u0647\u0627\u062F\u0629 \u062A\u0648\u0642\u064A\u0639 \u0646\u0634\u0637\u0629\u060C \u0648\u0628\u062F\u0648\u0646\u0647\u0627 \u062A\u064F\u0635\u062F\u064E\u0631 \u0627\u0644\u0641\u0648\u0627\u062A\u064A\u0631 \u062F\u0648\u0646 \u0625\u0631\u0633\u0627\u0644."
        },
        disabled: {
          name: "\u0645\u0639\u0637\u0651\u0644",
          help: "\u0644\u0627 \u062A\u064F\u0631\u0633\u064E\u0644 \u0623\u064A \u0641\u0627\u062A\u0648\u0631\u0629 \u0625\u0644\u0649 TTN. \u062A\u062D\u062A\u0641\u0638 \u0627\u0644\u0641\u0648\u0627\u062A\u064A\u0631 \u0627\u0644\u0645\u0631\u0633\u064E\u0644\u0629 \u0633\u0627\u0628\u0642\u064B\u0627 \u0628\u062D\u0627\u0644\u062A\u0647\u0627."
        }
      },
      save: "\u062D\u0641\u0638 \u0627\u0644\u0646\u0645\u0637",
      saving: "\u062C\u0627\u0631\u064D \u0627\u0644\u062D\u0641\u0638\u2026",
      saved: "\u062A\u0645 \u062D\u0641\u0638 \u0646\u0645\u0637 \u0627\u0644\u0641\u0648\u062A\u0631\u0629 \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A\u0629.",
      stale: "\u0639\u062F\u0651\u0644 \u0634\u062E\u0635 \u0622\u062E\u0631 \u0647\u0630\u0627 \u0627\u0644\u0625\u0639\u062F\u0627\u062F. \u0623\u0639\u062F \u062A\u062D\u0645\u064A\u0644\u0647 \u062B\u0645 \u062D\u0627\u0648\u0644 \u0645\u062C\u062F\u062F\u064B\u0627.",
      reload: "\u0625\u0639\u0627\u062F\u0629 \u0627\u0644\u062A\u062D\u0645\u064A\u0644",
      loadFailed: "\u062A\u0639\u0630\u0651\u0631 \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0625\u0639\u062F\u0627\u062F.",
      loading: "\u062C\u0627\u0631\u064D \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0625\u0639\u062F\u0627\u062F\u2026"
    },
    credentials: {
      title: "\u0634\u0647\u0627\u062F\u0627\u062A \u0627\u0644\u062A\u0648\u0642\u064A\u0639",
      hint: "\u062A\u064F\u0648\u0642\u064E\u0651\u0639 \u0627\u0644\u0641\u0648\u0627\u062A\u064A\u0631 \u0628\u0627\u0644\u0634\u0647\u0627\u062F\u0629 \u0627\u0644\u0646\u0634\u0637\u0629 \u0644\u0645\u0643\u062A\u0628\u0643\u0645 \u0642\u0628\u0644 \u0625\u0631\u0633\u0627\u0644\u0647\u0627 \u0625\u0644\u0649 TTN. \u0644\u0627 \u062A\u064F\u0639\u0631\u064E\u0636 \u0627\u0644\u0645\u0641\u0627\u062A\u064A\u062D \u0627\u0644\u062E\u0627\u0635\u0629 \u0648\u0644\u0627 \u064A\u0645\u0643\u0646 \u062A\u0646\u0632\u064A\u0644\u0647\u0627 \u0623\u0628\u062F\u064B\u0627.",
      add: "\u0625\u0636\u0627\u0641\u0629 \u0634\u0647\u0627\u062F\u0629",
      list: "\u0634\u0647\u0627\u062F\u0627\u062A \u0627\u0644\u062A\u0648\u0642\u064A\u0639",
      loading: "\u062C\u0627\u0631\u064D \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0634\u0647\u0627\u062F\u0627\u062A\u2026",
      loadFailed: "\u062A\u0639\u0630\u0651\u0631 \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0634\u0647\u0627\u062F\u0627\u062A.",
      empty: {
        title: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0634\u0647\u0627\u062F\u0629: \u0644\u0627 \u064A\u0645\u0643\u0646 \u062A\u0648\u0642\u064A\u0639 \u0627\u0644\u0641\u0648\u0627\u062A\u064A\u0631",
        description: "\u0623\u0636\u0641 \u0634\u0647\u0627\u062F\u0629 \u0627\u0644\u062E\u062A\u0645 \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A \u0644\u0645\u0643\u062A\u0628\u0643\u0645 \u062D\u062A\u0649 \u062A\u062A\u0645\u0643\u0646\u0648\u0627 \u0645\u0646 \u0625\u0631\u0633\u0627\u0644 \u0641\u0648\u0627\u062A\u064A\u0631\u0643\u0645 \u0625\u0644\u0649 TTN."
      },
      state: {
        active: "\u0646\u0634\u0637\u0629",
        expired: "\u0645\u0646\u062A\u0647\u064A\u0629 \u0627\u0644\u0635\u0644\u0627\u062D\u064A\u0629",
        replaced: "\u0645\u0633\u062A\u0628\u062F\u064E\u0644\u0629",
        revoked: "\u0645\u064F\u0644\u063A\u0627\u0629"
      },
      expiringSoon: "\u062A\u0646\u062A\u0647\u064A \u0642\u0631\u064A\u0628\u064B\u0627",
      expiringTitle: "\u0633\u062A\u0646\u062A\u0647\u064A \u0635\u0644\u0627\u062D\u064A\u0629 \u0634\u0647\u0627\u062F\u062A\u0643\u0645 \u0627\u0644\u0646\u0634\u0637\u0629 \u0642\u0631\u064A\u0628\u064B\u0627",
      expiringBody: "\u0647\u064A \u0635\u0627\u0644\u062D\u0629 \u0625\u0644\u0649 \u063A\u0627\u064A\u0629 {date}. \u0623\u0636\u0641 \u0634\u0647\u0627\u062F\u0629 \u062C\u062F\u064A\u062F\u0629 \u0642\u0628\u0644 \u0647\u0630\u0627 \u0627\u0644\u062A\u0627\u0631\u064A\u062E \u062D\u062A\u0649 \u0644\u0627 \u064A\u062A\u0648\u0642\u0641 \u0625\u0631\u0633\u0627\u0644 \u0627\u0644\u0641\u0648\u0627\u062A\u064A\u0631.",
      kind: "\u0627\u0644\u0646\u0648\u0639",
      label: "\u0627\u0644\u062A\u0633\u0645\u064A\u0629",
      validity: "\u0627\u0644\u0635\u0644\u0627\u062D\u064A\u0629",
      validityRange: "\u0645\u0646 {from} \u0625\u0644\u0649 {to}",
      issuer: "\u0627\u0644\u062C\u0647\u0629 \u0627\u0644\u0645\u064F\u0635\u062F\u0650\u0631\u0629",
      fingerprint: "\u0627\u0644\u0628\u0635\u0645\u0629 SHA-256",
      addedBy: "\u0623\u064F\u0636\u064A\u0641\u062A",
      addedByValue: "\u0645\u0646 {name} \u0628\u062A\u0627\u0631\u064A\u062E {date}",
      revoke: "\u0625\u0644\u063A\u0627\u0621 \u0627\u0644\u0634\u0647\u0627\u062F\u0629",
      revokeTitle: "\u0625\u0644\u063A\u0627\u0621 \u0627\u0644\u0634\u0647\u0627\u062F\u0629 {name}\u061F",
      revokeBody: "\u0644\u0646 \u062A\u064F\u0648\u0642\u064E\u0651\u0639 \u0627\u0644\u0641\u0648\u0627\u062A\u064A\u0631 \u0628\u0647\u0630\u0647 \u0627\u0644\u0634\u0647\u0627\u062F\u0629 \u0628\u0639\u062F \u0627\u0644\u0622\u0646 \u0648\u0644\u0627 \u064A\u0645\u0643\u0646 \u0625\u0639\u0627\u062F\u0629 \u062A\u0641\u0639\u064A\u0644\u0647\u0627. \u0644\u0627 \u062A\u062A\u063A\u064A\u0631 \u0627\u0644\u0641\u0648\u0627\u062A\u064A\u0631 \u0627\u0644\u062A\u064A \u0642\u0628\u0644\u0647\u0627 TTN \u0633\u0627\u0628\u0642\u064B\u0627. \u0623\u0636\u0641 \u0634\u0647\u0627\u062F\u0629 \u0623\u062E\u0631\u0649 \u0644\u0627\u0633\u062A\u0626\u0646\u0627\u0641 \u0627\u0644\u0625\u0631\u0633\u0627\u0644.",
      revokeConfirm: "\u0625\u0644\u063A\u0627\u0621 \u0627\u0644\u0634\u0647\u0627\u062F\u0629",
      revoked: "\u062A\u0645 \u0625\u0644\u063A\u0627\u0621 \u0627\u0644\u0634\u0647\u0627\u062F\u0629.",
      stale: "\u0639\u064F\u062F\u0651\u0644\u062A \u0647\u0630\u0647 \u0627\u0644\u0634\u0647\u0627\u062F\u0629 \u0641\u064A \u0627\u0644\u0623\u062B\u0646\u0627\u0621. \u0623\u064F\u0639\u064A\u062F \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0642\u0627\u0626\u0645\u0629."
    },
    add: {
      title: "\u0625\u0636\u0627\u0641\u0629 \u0634\u0647\u0627\u062F\u0629 \u062A\u0648\u0642\u064A\u0639",
      intro: "\u0627\u062E\u062A\u0631 \u0634\u0647\u0627\u062F\u0629 \u0645\u0643\u062A\u0628\u0643\u0645 \u0648\u0645\u0641\u062A\u0627\u062D\u0647\u0627 \u0627\u0644\u062E\u0627\u0635. \u062A\u064F\u0642\u0631\u0623 \u0627\u0644\u0645\u0644\u0641\u0627\u062A \u0641\u064A \u0645\u062A\u0635\u0641\u062D\u0643\u0645 \u062B\u0645 \u062A\u064F\u0631\u0633\u064E\u0644 \u0645\u0631\u0629 \u0648\u0627\u062D\u062F\u0629 \u0641\u0642\u0637.",
      kind: "\u0646\u0648\u0639 \u0627\u0644\u0634\u0647\u0627\u062F\u0629",
      label: "\u0627\u0644\u062A\u0633\u0645\u064A\u0629 (\u0627\u062E\u062A\u064A\u0627\u0631\u064A\u0629)",
      labelHint: "\u0627\u0633\u0645 \u064A\u0633\u0647\u0651\u0644 \u0627\u0644\u062A\u0639\u0631\u0641 \u0639\u0644\u064A\u0647\u0627\u060C \u0645\u062B\u0644 \xAB\u062E\u062A\u0645 2026\xBB.",
      certificate: "\u0627\u0644\u0634\u0647\u0627\u062F\u0629 (\u0645\u0644\u0641 pem. \u0623\u0648 crt. \u0623\u0648 cer.)",
      certificateHint: "\u0627\u0644\u0634\u0647\u0627\u062F\u0629 \u0627\u0644\u0639\u0645\u0648\u0645\u064A\u0629 \u0628\u0635\u064A\u063A\u0629 PEM.",
      privateKey: "\u0627\u0644\u0645\u0641\u062A\u0627\u062D \u0627\u0644\u062E\u0627\u0635 (\u0645\u0644\u0641 pem. \u0623\u0648 key.)",
      privateKeyHint: "\u0627\u0644\u0645\u0641\u062A\u0627\u062D \u0627\u0644\u062E\u0627\u0635 \u0628\u0635\u064A\u063A\u0629 PEM (PKCS#8). 20 \u0643\u064A\u0644\u0648\u0628\u0627\u064A\u062A \u0639\u0644\u0649 \u0627\u0644\u0623\u0643\u062B\u0631.",
      never: "\u064A\u064F\u0634\u0641\u064E\u0651\u0631 \u0627\u0644\u0645\u0641\u062A\u0627\u062D \u0627\u0644\u062E\u0627\u0635 \u0642\u0628\u0644 \u062D\u0641\u0638\u0647 \u0648\u0644\u0627 \u064A\u0645\u0643\u0646 \u0639\u0631\u0636\u0647 \u0623\u0648 \u062A\u0646\u0632\u064A\u0644\u0647 \u0645\u062C\u062F\u062F\u064B\u0627 \u0623\u0628\u062F\u064B\u0627. \u0642\u062F \u064A\u064F\u0637\u0644\u0628 \u0645\u0646\u0643\u0645 \u062A\u0623\u0643\u064A\u062F \u0627\u0644\u0647\u0648\u064A\u0629: \u0639\u0646\u062F\u0647\u0627 \u0633\u062A\u062E\u062A\u0627\u0631\u0648\u0646 \u0627\u0644\u0645\u0644\u0641\u064A\u0646 \u0645\u0646 \u062C\u062F\u064A\u062F.",
      cancel: "\u0625\u0644\u063A\u0627\u0621",
      save: "\u0625\u0636\u0627\u0641\u0629 \u0627\u0644\u0634\u0647\u0627\u062F\u0629",
      saving: "\u062C\u0627\u0631\u064D \u0627\u0644\u0625\u0636\u0627\u0641\u0629\u2026",
      done: "\u0623\u064F\u0636\u064A\u0641\u062A \u0627\u0644\u0634\u0647\u0627\u062F\u0629 \u0648\u0647\u064A \u0646\u0634\u0637\u0629 \u0627\u0644\u0622\u0646.",
      errors: {
        required: "\u0627\u062E\u062A\u0631 \u0645\u0644\u0641\u064B\u0627.",
        file: {
          tooBig: "\u062D\u062C\u0645 \u0647\u0630\u0627 \u0627\u0644\u0645\u0644\u0641 \u0643\u0628\u064A\u0631 \u062C\u062F\u064B\u0627 (20 \u0643\u064A\u0644\u0648\u0628\u0627\u064A\u062A \u0639\u0644\u0649 \u0627\u0644\u0623\u0643\u062B\u0631).",
          unreadable: "\u062A\u0639\u0630\u0651\u0631\u062A \u0642\u0631\u0627\u0621\u0629 \u0647\u0630\u0627 \u0627\u0644\u0645\u0644\u0641. \u0627\u062E\u062A\u0631\u0652\u0647 \u0645\u0646 \u062C\u062F\u064A\u062F.",
          notPem: "\u0647\u0630\u0627 \u0627\u0644\u0645\u0644\u0641 \u0644\u064A\u0633 \u0628\u0635\u064A\u063A\u0629 PEM: \u0627\u062E\u062A\u0631 \u0645\u0644\u0641\u064B\u0627 \u0646\u0635\u064A\u064B\u0627 \u064A\u0628\u062F\u0623 \u0628\u0627\u0644\u0633\u0637\u0631 \xAB-----BEGIN\xBB."
        },
        certificatePem: {
          SIGNING_CREDENTIAL_INVALID: "\u0647\u0630\u0627 \u0627\u0644\u0645\u0644\u0641 \u0644\u064A\u0633 \u0634\u0647\u0627\u062F\u0629 X.509 \u0635\u0627\u0644\u062D\u0629 \u0628\u0635\u064A\u063A\u0629 PEM.",
          SIGNING_CREDENTIAL_EXPIRED: "\u0627\u0646\u062A\u0647\u062A \u0635\u0644\u0627\u062D\u064A\u0629 \u0647\u0630\u0647 \u0627\u0644\u0634\u0647\u0627\u062F\u0629. \u0627\u062E\u062A\u0631 \u0634\u0647\u0627\u062F\u0629 \u0644\u0627 \u062A\u0632\u0627\u0644 \u0635\u0627\u0644\u062D\u0629."
        },
        privateKeyPem: {
          SIGNING_CREDENTIAL_INVALID: "\u0647\u0630\u0627 \u0627\u0644\u0645\u0644\u0641 \u0644\u064A\u0633 \u0645\u0641\u062A\u0627\u062D\u064B\u0627 \u062E\u0627\u0635\u064B\u0627 \u0635\u0627\u0644\u062D\u064B\u0627 \u0628\u0635\u064A\u063A\u0629 PEM (PKCS#8).",
          SIGNING_KEY_MISMATCH: "\u0647\u0630\u0627 \u0627\u0644\u0645\u0641\u062A\u0627\u062D \u0627\u0644\u062E\u0627\u0635 \u0644\u0627 \u064A\u0637\u0627\u0628\u0642 \u0627\u0644\u0634\u0647\u0627\u062F\u0629. \u0627\u062E\u062A\u0631 \u0627\u0644\u0645\u0641\u062A\u0627\u062D \u0627\u0644\u0630\u064A \u0623\u064F\u0646\u0634\u0626 \u0645\u0639\u0647\u0627."
        },
        generic: "\u0647\u0630\u0627 \u0627\u0644\u0645\u0644\u0641 \u063A\u064A\u0631 \u0645\u0642\u0628\u0648\u0644. \u062A\u062D\u0642\u0642 \u0645\u0646\u0647 \u062B\u0645 \u062D\u0627\u0648\u0644 \u0645\u062C\u062F\u062F\u064B\u0627.",
        kind: "\u0646\u0648\u0639 \u0627\u0644\u0634\u0647\u0627\u062F\u0629 \u0647\u0630\u0627 \u063A\u064A\u0631 \u0645\u0642\u0628\u0648\u0644. \u0627\u062E\u062A\u0631 \u0646\u0648\u0639\u064B\u0627 \u0622\u062E\u0631."
      }
    }
  }
};

// locales/en/finance.json
var finance_default2 = {
  nav: {
    title: "Finance",
    quotes: "Quotes",
    contracts: "Contracts",
    invoices: "Invoices",
    payments: "Payments",
    expenses: "Expenses",
    suppliers: "Suppliers",
    supplierInvoices: "Supplier invoices",
    withholding: "Withholding",
    accounting: "Accounting exports",
    dashboard: "Dashboard",
    management: "Management",
    treasury: "Cash flow",
    profitability: "Profitability",
    costRates: "Cost rates",
    einvoicing: "Electronic invoice"
  },
  totals: {
    title: "Totals",
    subtotalHt: "Subtotal excl. VAT",
    vat: "VAT {rate}",
    stamp: "Stamp duty",
    totalTtc: "Total incl. taxes",
    withholding: "Withholding tax {rate}",
    vatWithholding: "VAT withholding {rate}",
    netPayable: "Net payable",
    base: "Base {amount}",
    amountInWords: "Amount in words: {words}",
    rateSource: "Rate source: {source}.",
    tndEquivalent: "Equivalent in dinars: {amount} (1 {currency} = {rate} TND)",
    legalRef: "Legal reference: {ref}",
    toVerify: "Rule to verify",
    toVerifyHint: "A chartered accountant must confirm this value before production.",
    vatNoRate: "VAT",
    withholdingNoRate: "Withholding tax",
    vatWithholdingNoRate: "VAT withholding",
    rulesConcerned: "Rules concerned: {rules}",
    tndEquivalentNet: "Net payable in dinars: {amount}",
    loading: "Calculating totals",
    errorTitle: "Totals unavailable",
    errorBody: "The totals could not be calculated. Check your connection and try again.",
    retry: "Try again",
    notes: {
      vat_suspended: "VAT suspended",
      vat_export: "VAT exemption for export",
      stamp_exempt_treatment: "Exempt (export)",
      stamp_exempt_public_buyer: "Exempt (public buyer)",
      stamp_not_reversed: "Stamp kept (partial credit note)",
      not_applicable: "Not applicable",
      below_threshold: "Below the threshold"
    },
    mention: {
      suspended: "Sale under VAT suspension \u2014 certificate no. {reference}",
      suspendedNoRef: "Sale under VAT suspension",
      export: "VAT exemption \u2014 export of services"
    }
  },
  rules: {
    "stamp.exemptPublicBuyers": "Stamp duty exemption for the State and public buyers",
    "withholding.base": "Withholding base (total excluding the stamp)",
    "withholding.purchases": "Withholding rate on purchases",
    "vatWithholding.thresholdBase": "VAT-withholding threshold base (excluding the stamp)",
    "contract.retentionBase": "Retention base (excluding VAT)",
    lateInterest: "Public-market payment deadlines and late-interest rate (TMM)"
  },
  quotes: {
    status: {
      draft: "Draft",
      sent: "Sent",
      accepted: "Accepted",
      rejected: "Declined",
      expired: "Expired"
    },
    list: {
      caption: "Quotes",
      new: "New quote",
      columns: {
        number: "Number",
        title: "Subject",
        client: "Client",
        status: "Status",
        totalHt: "Total excl. VAT",
        totalTtc: "Total incl. VAT",
        validUntil: "Valid until",
        sentAt: "Sent on",
        acceptedAt: "Accepted on"
      },
      filters: {
        label: "Quote filters",
        status: "Status",
        all: "All statuses"
      },
      empty: {
        title: "No quotes yet",
        description: "Create your first quote: it is calculated live and sent to the client through a secure link.",
        descriptionReadOnly: "Your office\u2019s quotes will appear here."
      },
      filtered: {
        title: "No quote matches",
        description: "No quote has this status. Try another filter."
      },
      clearFilters: "Clear the filter",
      loadMore: "Show more quotes",
      loadingMore: "Loading\u2026",
      loadFailedTitle: "The quotes could not be loaded",
      loadFailedBody: "Check your connection and try again.",
      none: "\u2014"
    },
    editor: {
      newTitle: "New quote",
      detailTitle: "Quote {number}",
      breadcrumbList: "Quotes",
      loadFailedTitle: "This quote could not be loaded",
      loadFailedBody: "It does not exist or you do not have access to it.",
      readOnlyRights: "You can view this quote, but you are not allowed to change it.",
      readOnlyStatus: "This quote can no longer be changed.",
      readOnlySent: "This quote was sent to the client. To change it, it goes back to draft and the link that was sent stops working.",
      editingSent: "You are editing a sent quote: when you save, it goes back to draft and the link sent to the client stops working. You will need to send it again."
    },
    sections: {
      general: "General information",
      calculator: "Fee calculation",
      lines: "Quote lines",
      notes: "Notes",
      history: "Quote history"
    },
    fields: {
      client: {
        label: "Client",
        placeholder: "Choose a client",
        hint: "The project owner the quote is addressed to."
      },
      project: {
        label: "Project",
        none: "No project (for now)",
        current: "Project already linked"
      },
      title: {
        label: "Quote subject",
        hint: "For example: design supervision, two-storey villa."
      },
      language: {
        label: "PDF language",
        hint: "The language of the document sent to the client.",
        fr: "French",
        ar: "Arabic",
        bilingual: "Bilingual (French and Arabic)"
      },
      validUntil: {
        label: "Valid until",
        hint: "After this date the client can no longer accept."
      },
      currency: {
        label: "Currency"
      },
      exchangeRate: {
        label: "Exchange rate (TND for 1 unit)",
        hint: "For example 3.350 for 1 EUR. Totals are also given in dinars."
      },
      feeMode: {
        label: "Calculation mode",
        lump_sum: "Lump sum split by phase",
        percentage_of_works: "Percentage of the works cost",
        time_based: "Time spent",
        mixed: "Mixed (lines entered by hand)"
      },
      notes: {
        label: "Notes for the client",
        hint: "Special conditions, assumptions, exclusions."
      }
    },
    errors: {
      clientRequired: "Choose a client.",
      titleRequired: "Give the quote a subject.",
      validUntilRequired: "Enter the validity date.",
      rateRequired: "Enter the exchange rate.",
      rateInvalid: "Enter a positive rate with at most 6 decimals, for example 3.350.",
      linesRequired: "Add at least one line to the quote.",
      descriptionRequired: "Describe this line.",
      priceRequired: "Enter the unit price.",
      quantityInvalid: "Enter a positive quantity with at most 3 decimals.",
      validityInPast: "The validity date has already passed.",
      staleTitle: "Someone changed this quote",
      staleBody: "Another person saved this quote while you were editing it. Reload it to see its latest version, then apply your changes again.",
      reload: "Reload the quote",
      saveFailed: "The quote could not be saved"
    },
    save: {
      action: "Save",
      saving: "Saving\u2026",
      created: "Quote {number} was created.",
      saved: "Quote {number} was saved."
    },
    guard: {
      title: "Leave without saving?",
      body: "Your changes to this quote will be lost.",
      leave: "Leave",
      stay: "Stay on the quote"
    },
    lines: {
      noPhase: "Other lines",
      phaseSubtotal: "Subtotal excl. VAT {amount}",
      description: "Description",
      phase: "Phase",
      noPhaseOption: "No phase",
      quantity: "Quantity",
      unitPrice: "Unit price excl. VAT",
      vat: "VAT",
      amount: "Amount excl. VAT",
      add: "Add a line",
      addToPhase: "Add a line to this phase",
      remove: "Delete line {number}",
      lineNumber: "Line {number}",
      totalHt: "Total of the lines excl. VAT",
      empty: "No lines yet. Use the fee calculation or add a line.",
      readOnlyCaption: "Quote lines"
    },
    calculator: {
      intro: "The calculation proposes lines that you can still edit: nothing is applied without your approval.",
      mixedHint: "In this mode you enter the lines by hand. You can also use the other calculation modes to help.",
      propose: "Propose the lines",
      proposed: "The lines were proposed. Check them and edit them if needed.",
      replaceTitle: "Replace the current lines?",
      replaceBody: "The proposed lines will replace those of the quote. You can still edit them.",
      replaceConfirm: "Replace the lines",
      lumpTotal: "Lump-sum fee excl. VAT",
      worksCost: "Estimated works cost excl. VAT",
      fee: "Calculated fee excl. VAT",
      rate: {
        label: "Fee rate (%)",
        hint: "For example 6 or 4.5."
      },
      rateInvalid: "Enter a percentage between 0 and 100, for example 4.5.",
      scale: {
        label: "Reference scale",
        none: "No scale (entered rate)",
        hint: "A scale gives a suggestion with its source: it is never applied without your approval.",
        suggestion: "Suggestion from the scale \u201C{name}\u201D: {amount}",
        apply: "Use this suggestion",
        source: {
          decree_78_71: "Decree 78-71",
          oat: "Tunisian Order of Architects",
          oit_2026: "Tunisian Order of Engineers",
          custom: "Your office\u2019s scale"
        },
        sourceLine: "Source: {source}, in force since {date}",
        legalRef: "Reference: {ref}",
        belowMinimum: "This fee is below the minimum of the scale \u201C{name}\u201D ({amount}). You can keep it: this is only a warning."
      },
      shares: {
        title: "Split by phase",
        hint: "The shares must total 100%.",
        phase: "Phase",
        share: "Share (%)",
        add: "Add a phase",
        remove: "Remove the phase {phase}",
        loadTemplate: "Use the split of a mission type",
        loadNone: "Choose a mission type",
        total: "Total of the shares: {total}",
        notHundred: "The shares total {total} instead of 100%.",
        invalid: "Enter a percentage, for example 12.5.",
        empty: "Add at least one phase."
      },
      time: {
        title: "Time spent",
        description: "Task",
        quantity: "Hours or days",
        unitRate: "Unit rate excl. VAT",
        add: "Add a task",
        remove: "Remove task {number}",
        total: "Total time spent: {amount}",
        empty: "Add at least one task."
      }
    },
    totals: {
      needClient: "Choose a client to calculate the totals (VAT, stamp, withholdings).",
      needRate: "Enter the exchange rate to calculate the totals.",
      needLines: "Complete the lines (quantity and price) to calculate the totals.",
      noRight: "The detailed totals are not available with your permissions. The total of the lines excl. VAT remains exact.",
      indicative: "Indicative totals: the invoice recalculates them when it is issued."
    },
    actions: {
      label: "Quote actions",
      pdf: "View the PDF",
      pdfOpening: "Opening the PDF\u2026",
      pdfPreparing: "The PDF is being prepared. Try again in a moment.",
      pdfFailed: "The PDF could not be opened. Try again in a moment.",
      send: "Send",
      resend: "Send again",
      reject: "Declined by the client",
      convert: "Create the project",
      openProject: "Open the project",
      delete: "Delete the draft",
      edit: "Edit the quote",
      saveFirst: "Save your changes first to use these actions."
    },
    history: {
      createdBy: "Created on {date} by {name}",
      sent: "Sent on {date} by {name}",
      linkExpires: "The client\u2019s link is valid until {date}",
      accepted: "Accepted on {date} by {name}",
      rejected: "Declined by the client on {date}",
      pdfHash: "Fingerprint of the accepted PDF (SHA-256): {hash}",
      notSent: "This quote has not been sent yet.",
      pdfReady: "PDF ready",
      pdfNotReady: "PDF being prepared"
    },
    send: {
      title: "Send quote {number}",
      intro: "The client receives an email with a secure link to view the PDF and accept the quote. The link is valid for 30 days.",
      resendInfo: "This quote was already sent: sending it again replaces the previous link, which stops working.",
      contact: {
        label: "Recipient",
        client: "The client\u2019s email address",
        noEmail: "no email"
      },
      message: {
        label: "Message for the client (optional)",
        hint: "This message goes with the link in the email."
      },
      submit: "Send the quote",
      sending: "Sending\u2026",
      done: "Quote {number} was sent.",
      noRecipient: "Neither the client nor this contact has an email address. Add one on the client\u2019s page, then try again.",
      validityInPast: "The validity date has passed: change it before sending the quote."
    },
    reject: {
      title: "Mark quote {number} as declined?",
      body: "The client declined this quote. The link they received will no longer let them accept it.",
      confirm: "Mark as declined",
      done: "Quote {number} is marked as declined."
    },
    convert: {
      title: "Create the project of quote {number}",
      intro: "The project takes over the client and the fees of the accepted quote. Choose the mission type: its standard phases and folders are created.",
      name: "Project name",
      nameRequired: "Give the project a name.",
      missionType: "Mission type",
      code: "Project code (optional)",
      codeHint: "Leave empty to have a code generated.",
      submit: "Create the project",
      creating: "Creating\u2026",
      done: "The project was created."
    },
    remove: {
      title: "Delete draft {number}?",
      body: "This quote was never sent: it will be deleted permanently.",
      confirm: "Delete",
      done: "Draft {number} was deleted."
    },
    editSent: {
      title: "Edit a sent quote?",
      body: "The quote goes back to draft and the link sent to the client stops working. You will need to send it again after your changes.",
      confirm: "Edit the quote"
    }
  },
  contracts: {
    kind: {
      private_agreement: "Private agreement",
      public_market: "Public market"
    },
    list: {
      caption: "List of contracts",
      new: "New contract",
      columns: {
        reference: "Reference",
        client: "Client",
        kind: "Kind",
        amount: "Amount excl. VAT",
        total: "Total with amendments",
        signedOn: "Signed on",
        bondReleaseOn: "Bond release"
      },
      filters: {
        label: "Contract filters",
        kind: "Kind of contract",
        all: "All kinds"
      },
      empty: {
        title: "No contracts yet",
        description: "Create a contract from an accepted quote, or enter one directly: advance, retention, performance bond and penalties.",
        descriptionReadOnly: "Your office\u2019s contracts will appear here."
      },
      filtered: {
        title: "No contract matches",
        description: "No contract is of this kind. Try another filter."
      },
      clearFilters: "Clear the filter",
      loadMore: "Show more contracts",
      loadingMore: "Loading\u2026",
      loadFailedTitle: "The contracts could not be loaded",
      loadFailedBody: "Check your connection and try again.",
      none: "\u2014"
    },
    editor: {
      newTitle: "New contract",
      detailTitle: "Contract {reference}",
      breadcrumbList: "Contracts",
      fromQuote: "Contract created from a quote: open the quote",
      readOnlyRights: "You can view this contract but not change it.",
      loadFailedTitle: "The contract could not be loaded",
      loadFailedBody: "Check your connection and try again."
    },
    sections: {
      general: "General information",
      terms: "Payment terms",
      amendments: "Amendments",
      progress: "Invoiced progress"
    },
    fields: {
      client: {
        label: "Client",
        placeholder: "Choose a client",
        fixed: "The client of a contract does not change."
      },
      project: {
        label: "Project",
        none: "No project",
        current: "Current project"
      },
      reference: {
        label: "Contract reference",
        hint: "The market or agreement number, unique in your office."
      },
      kind: {
        label: "Kind",
        hint: "A public market shows warnings when its terms go above the regulatory limits."
      },
      currency: {
        label: "Currency"
      },
      amount: {
        label: "Amount excl. VAT",
        hint: "The signed amount, amendments excluded."
      },
      signedOn: {
        label: "Signature date"
      },
      total: {
        label: "Total excl. VAT with amendments:"
      },
      advance: {
        label: "Advance",
        hint: "As a percentage of the amount, for example 10."
      },
      retention: {
        label: "Retention",
        hint: "Withheld on each progress invoice and released by the final invoice."
      },
      retentionBase: {
        label: "Retention base",
        hint: "Excluding taxes by default; to confirm with your chartered accountant.",
        ht: "Amount excluding taxes",
        ttc: "Amount including taxes"
      },
      bond: {
        label: "Performance bond",
        hint: "As a percentage of the amount."
      },
      bondReleaseOn: {
        label: "Bond release date",
        hint: "A reminder is sent 7 days before and on the day. Needs a performance bond."
      },
      penaltyRate: {
        label: "Late penalty per day",
        hint: "As a percentage of the amount, per day of delay."
      },
      penaltyCap: {
        label: "Penalty ceiling",
        hint: "As a percentage of the amount."
      }
    },
    errors: {
      clientRequired: "Choose a client.",
      referenceRequired: "Enter the contract reference.",
      amountRequired: "Enter the contract amount.",
      rateInvalid: "Enter a percentage between 0 and 100 with at most 2 decimals, for example 2.5.",
      bondRequired: "A release date needs a performance bond: enter its percentage.",
      totalNegative: "With the amendments, the total would fall below zero.",
      clientMismatch: "This client does not match the contract.",
      projectMismatch: "This project does not belong to the contract\u2019s client.",
      documentNotFound: "This document cannot be found: choose another one.",
      staleTitle: "Someone else changed this contract",
      staleBody: "Another person saved this contract while you were editing it. Reload it to see its latest version, then apply your changes again.",
      reload: "Reload the contract",
      saveFailed: "The contract could not be saved"
    },
    save: {
      action: "Save",
      saving: "Saving\u2026",
      created: "Contract {reference} was created.",
      saved: "Contract {reference} was saved."
    },
    guard: {
      title: "Leave without saving?",
      body: "Your changes to this contract will be lost.",
      leave: "Leave",
      stay: "Stay on the contract"
    },
    warnings: {
      title: "Terms above the limits of a public market",
      intro: "These warnings do not block saving: the market may provide for a derogation.",
      RETENTION_ABOVE_LIMIT: "Retention of {actual}, above the limit of {limit}.",
      PERFORMANCE_BOND_ABOVE_LIMIT: "Performance bond of {actual}, above the limit of {limit}.",
      RETENTION_PLUS_BOND_ABOVE_LIMIT: "Retention and performance bond together make {actual}, above the limit of {limit}.",
      PENALTY_CAP_ABOVE_LIMIT: "Penalty ceiling of {actual}, above the limit of {limit}.",
      ADVANCE_ABOVE_LIMIT: "Advance of {actual}, above the limit of {limit} for a studies market.",
      legalRef: "Reference: {ref}"
    },
    amendments: {
      caption: "Amendments of the contract",
      add: "Add an amendment",
      total: "Total excl. VAT with amendments:",
      empty: {
        title: "No amendments",
        description: "An amendment changes the contract amount; once saved, it can no longer be changed."
      },
      saveFirst: "Save your changes first to add an amendment.",
      added: "The amendment was added.",
      columns: {
        number: "No.",
        label: "Subject",
        delta: "Change of amount",
        signedOn: "Signed on",
        document: "Signed document"
      },
      dialog: {
        title: "Add an amendment",
        intro: "An amendment is a signed act: once saved, it is not edited any more. If it is wrong, add a corrective amendment.",
        label: "Subject of the amendment",
        description: "Description (optional)",
        delta: "Change of the amount excl. VAT",
        deltaHint: "Positive for an increase, negative for a reduction (for example -500).",
        signedOn: "Signature date",
        document: "Signed document (documents)",
        documentHint: "Optional: a document of the project\u2019s space.",
        noProject: "Link the contract to a project to attach a document.",
        submit: "Add the amendment",
        adding: "Adding\u2026"
      },
      errors: {
        labelRequired: "Give the amendment a subject.",
        deltaRequired: "Enter the change of amount.",
        signedOnRequired: "Enter the signature date."
      }
    },
    document: {
      loading: "Loading the document\u2026",
      restricted: "Linked document (you cannot open it)",
      linked: "Linked document"
    },
    picker: {
      none: "No document linked",
      choose: "Choose a document",
      change: "Change",
      remove: "Remove",
      label: "Choose a document of the project",
      location: "Folder: {name}",
      root: "Project root",
      up: "Parent folder",
      folders: "Subfolders",
      documents: "Documents of the folder",
      openFolder: "Open the folder {name}",
      openFolderFirst: "Open a folder to see its documents.",
      noDocuments: "This folder holds no documents.",
      loadFailed: "The folders could not be loaded. Try again in a moment."
    },
    progress: {
      prepare: "Prepare a progress invoice",
      loading: "Loading the progress\u2026",
      loadFailed: "The progress could not be loaded.",
      needProject: "Link this contract to a project to follow its progress by phase.",
      needTnd: "Progress invoices are in dinars: the progress is not available for another currency."
    },
    fromQuote: {
      action: "Create the contract",
      creating: "Creating\u2026",
      done: "The contract was created from the quote."
    },
    projectTab: {
      contract: "Contract",
      openContract: "Open the contract",
      empty: {
        title: "No contract for this project",
        description: "Create the contract to follow the advance, the retention and the billing by phase.",
        fromQuote: "Quote {number} was accepted: the contract takes its client and its amount.",
        descriptionReadOnly: "The contract of this project will appear here.",
        create: "Create the contract",
        createFromQuote: "Create the contract from the quote"
      },
      quotesInvoices: "Quotes and invoices",
      quotes: "Quotes of the project",
      noQuotes: "No quote is linked to this project.",
      allQuotes: "All quotes",
      allInvoices: "All invoices",
      noAccessTitle: "Finance not available",
      noAccessBody: "You do not have access to the financial information of this project."
    }
  },
  progress: {
    title: "Progress invoice \u2014 contract {reference}",
    titleShort: "Progress invoice",
    help: "For each phase, enter the cumulative progress: the amount of the period is computed live. The cumulative summary by phase is printed automatically on the invoice PDF.",
    final: {
      label: "Final invoice at final reception",
      hint: "Every phase goes to 100 %, the rest of the advance is recovered and the retention is released."
    },
    sections: {
      phases: "Progress by phase",
      totals: "Amounts of this invoice",
      options: "Invoice options"
    },
    table: {
      caption: "Cumulative progress by phase",
      columns: {
        phase: "Phase",
        fee: "Fee of the phase",
        previous: "Already invoiced",
        cumulative: "New cumulative",
        period: "Amount of the period"
      },
      cumulativeFor: "New cumulative percentage for the phase {phase}",
      unavailable: "Amount not available"
    },
    totals: {
      work: "Work of the period (excl. VAT)",
      advanceRecovery: "Advance recovery",
      retention: "Retention ({rate})",
      retentionRelease: "Retention release",
      net: "Net excl. VAT of the invoice",
      unavailable: "The amounts cannot be computed at the moment.",
      fixFirst: "First correct the percentages flagged in the table.",
      taxesHint: "VAT, stamp duty and withholdings are computed on the draft invoice, which opens after saving."
    },
    lines: {
      advanceRecovery: "Advance recovery",
      retention: "Retention",
      retentionRelease: "Retention release"
    },
    options: {
      language: {
        label: "PDF language",
        hint: "The language of the document sent to the client."
      },
      dueDate: {
        label: "Due date",
        hint: "Optional: otherwise the client\u2019s payment terms apply."
      },
      notes: {
        label: "Notes"
      }
    },
    submit: "Create the draft invoice",
    submitting: "Creating\u2026",
    created: "The draft invoice was created.",
    readOnlyRights: "You can view the progress but not create an invoice.",
    loadFailedTitle: "The progress could not be loaded",
    loadFailedBody: "Check your connection and try again.",
    blocked: {
      closedTitle: "Contract closed",
      closedBody: "The final invoice was issued: there is no progress invoice left to prepare.",
      sharesTitle: "The fee shares of the phases do not total 100 %",
      sharesBody: "The fee shares of the project\u2019s phases must total 100 % to split the contract amount. They currently total {total}.",
      sharesLink: "Open the project\u2019s phases"
    },
    summary: {
      caption: "Invoiced progress by phase",
      total: "Contract total (excl. VAT)",
      advance: "Advance",
      advanceRecovered: "Advance already recovered",
      retentionHeld: "Retention already withheld ({rate})",
      columns: {
        phase: "Phase",
        status: "Status",
        fee: "Fee",
        invoicedBp: "Invoiced (cumulative)",
        invoiced: "Amount invoiced"
      }
    },
    errors: {
      below: "At least {previous}, already invoiced.",
      invalid: "Enter a percentage from 0 to 100 with at most 2 decimals.",
      failedTitle: "The invoice could not be created",
      CUMULATIVE_BELOW_PREVIOUS: "The cumulative progress of a phase cannot be lower than what was already invoiced.",
      CUMULATIVE_OUT_OF_RANGE: "The cumulative progress of a phase must be between 0 and 100 %.",
      PHASE_SHARES_NOT_100: "The fee shares of the project\u2019s phases must total 100 %. Correct them in the project\u2019s Phases tab.",
      PROGRESS_DRAFT_EXISTS: "A progress invoice of this contract is still a draft. Delete it or issue it before creating another.",
      CONTRACT_CLOSED: "The final invoice of this contract was already issued.",
      NOTHING_TO_INVOICE: "No phase moved since the last invoice: there is nothing to invoice.",
      CONTRACT_CURRENCY: "Progress invoices are in Tunisian dinars.",
      CONTRACT_WITHOUT_PROJECT: "First link this contract to a project.",
      PHASE_NOT_IN_PROJECT: "A phase does not belong to this contract\u2019s project. Reload the page.",
      FINAL_NEEDS_100: "The final invoice closes every phase at 100 %.",
      CONTRACT_TOTAL_INVALID: "The contract amount must be above zero."
    }
  },
  publicQuote: {
    language: "Language",
    brand: "Proposal from {organization}",
    number: "Quote {number}",
    client: "For: {client}",
    validUntil: "Valid until {date}",
    linesTitle: "Services in detail",
    linesCaption: "Services of the quote",
    description: "Service",
    amount: "Amount excl. VAT",
    pdf: {
      title: "Quote document",
      open: "Open the PDF",
      opening: "Opening\u2026",
      preparing: "The PDF is being prepared. Try again in a few seconds.",
      failed: "The PDF could not be opened. Try again in a moment."
    },
    accept: {
      title: "Accept this quote",
      intro: "To accept, type your full name and tick the box. Your acceptance is recorded with the date, the time and the document you viewed.",
      fullName: {
        label: "Full name",
        hint: "As it appears on your official documents."
      },
      fullNameInvalid: "Enter your full name (at least 3 characters).",
      consent: "I accept this quote and its conditions, and I confirm that I am entitled to commit {client}.",
      submit: "Accept the quote",
      submitting: "Saving\u2026",
      failedTitle: "Your acceptance could not be recorded"
    },
    confirmation: {
      title: "Thank you, the quote is accepted",
      body: "{name} accepted quote {number} on {date}. The office has been informed and will contact you about the next steps.",
      bodyPast: "This quote was accepted by {name} on {date}.",
      titlePast: "This quote is accepted"
    },
    states: {
      rejectedTitle: "This quote was declined",
      rejectedBody: "This quote is no longer available. Contact the office if you would like a new proposal.",
      expiredTitle: "This quote is no longer valid",
      expiredBody: "The validity date has passed. Ask the office for a new proposal.",
      notFoundTitle: "This link is not valid",
      notFoundBody: "The link is incomplete or no longer exists. Use the link in the email you received, or contact the office.",
      loadFailedTitle: "The quote could not be loaded",
      loadFailedBody: "Check your connection and try again.",
      loading: "Loading the quote\u2026"
    }
  },
  invoices: {
    status: {
      draft: "Draft",
      issued: "Issued",
      credited: "Cancelled by credit note"
    },
    ttn: {
      not_required: "Not required",
      pending: "Pending",
      submitted: "Submitted",
      submitted_manually: "Submitted manually",
      accepted: "Accepted",
      rejected: "Rejected"
    },
    paymentStatus: {
      unpaid: "Unpaid",
      partially_paid: "Partially paid",
      paid: "Paid"
    },
    kind: {
      advance: "Advance invoice",
      deposit: "Deposit invoice",
      progress: "Progress invoice",
      final: "Final invoice",
      credit_note: "Credit note"
    },
    list: {
      caption: "List of invoices",
      new: "New invoice",
      draftNumber: "Draft",
      columns: {
        number: "Number",
        client: "Client",
        kind: "Type",
        status: "Status",
        ttn: "E-invoice (TTN)",
        payment: "Payment",
        totalTtc: "Total incl. taxes",
        netPayable: "Net payable",
        issueDate: "Issued on",
        dueDate: "Due date"
      },
      filters: {
        label: "Invoice filters",
        status: "Status",
        payment: "Payment",
        kind: "Type",
        allStatuses: "All statuses",
        allPayments: "All payments",
        allKinds: "All types"
      },
      empty: {
        title: "No invoices yet",
        description: "Create your first invoice: it is computed live and gets its final number when issued.",
        descriptionReadOnly: "Your office\u2019s invoices will appear here."
      },
      filtered: {
        title: "No invoice matches",
        description: "No invoice fits these filters. Try different ones."
      },
      clearFilters: "Clear filters",
      loadMore: "Show more invoices",
      loadingMore: "Loading\u2026",
      loadFailedTitle: "The invoices could not be loaded",
      loadFailedBody: "Check your connection and try again.",
      none: "\u2014"
    },
    editor: {
      newTitle: "New invoice",
      draftTitle: "Draft invoice",
      detailTitle: "Invoice {number}",
      creditNoteTitle: "Credit note {number}",
      breadcrumbList: "Invoices",
      loadFailedTitle: "This invoice could not be loaded",
      loadFailedBody: "It does not exist or you do not have access to it.",
      readOnlyRights: "You can view this invoice, but you are not allowed to change it.",
      readOnlyIssued: "This invoice is issued: it can never be changed again. To correct it, issue a credit note.",
      readOnlyCreditNote: "An issued credit note is final: it can no longer be changed.",
      linesLocked: "The lines of this draft come from the progress statement (advances and retentions). To change them, delete the draft and build it again; the other fields can still be edited."
    },
    sections: {
      general: "General information",
      lines: "Invoice lines",
      attachments: "Attachments",
      notes: "Notes",
      history: "Invoice history"
    },
    fields: {
      kind: {
        label: "Invoice type",
        hint: "Advance, deposit, progress statement or final invoice."
      },
      client: {
        label: "Client",
        placeholder: "Choose a client",
        hint: "The project owner to invoice."
      },
      project: {
        label: "Project",
        none: "No project",
        current: "Current project",
        hint: "Lets you group the lines by phase."
      },
      series: {
        label: "Numbering series",
        hint: "The number is assigned when the invoice is issued, with no gaps.",
        default: "Default series"
      },
      language: {
        label: "PDF language",
        hint: "The language of the printed invoice.",
        fr: "French",
        ar: "Arabic",
        bilingual: "Bilingual (French and Arabic)"
      },
      currency: {
        label: "Currency"
      },
      exchangeRate: {
        label: "Exchange rate (TND for 1 unit)",
        hint: "For example 3.350 for 1 EUR. Totals are also given in dinars."
      },
      exchangeRateSource: {
        label: "Rate source",
        hint: "Optional: where the rate comes from, printed with it on the invoice.",
        placeholder: "Central Bank of Tunisia, rate of 30/10/2026"
      },
      vatTreatment: {
        label: "VAT treatment",
        hint: "If you choose nothing, the client\u2019s VAT regime applies.",
        auto: "According to the client",
        standard: "Standard VAT",
        suspended: "VAT suspended",
        export: "Export (exempt)"
      },
      treatmentRef: {
        label: "Treatment reference",
        hint: "Required for suspended VAT: the number of the certificate or decision."
      },
      dueDate: {
        label: "Due date",
        hint: "Without a date, the client\u2019s payment terms apply when the invoice is issued."
      },
      notes: {
        label: "Invoice notes",
        hint: "Printed on the invoice (terms, special mention)."
      },
      issueDate: "Issue date",
      ruleSet: "Tax rule set applied"
    },
    lines: {
      noPhase: "Other lines",
      phaseSubtotal: "Subtotal excl. VAT {amount}",
      description: "Description",
      phase: "Phase",
      noPhaseOption: "No phase",
      quantity: "Quantity",
      unitPrice: "Unit price excl. VAT",
      vat: "VAT",
      amount: "Amount excl. VAT",
      add: "Add a line",
      addToPhase: "Add a line to this phase",
      remove: "Remove line {number}",
      lineNumber: "Line {number}",
      totalHt: "Total of the lines excl. VAT",
      empty: "No lines yet. Add a line.",
      readOnlyCaption: "Invoice lines: {name}",
      roles: {
        service: "Service",
        advance_recovery: "Advance recovery",
        retention: "Retention",
        retention_release: "Retention release"
      }
    },
    attachments: {
      none: "No attachments.",
      list: "Attachments",
      remove: "Remove {title}",
      search: "Search for a document to attach",
      searchHint: "Type at least 2 characters of the title or code, for example a reception report. Attachments are kept with the invoice."
    },
    hints: {
      title: "To issue this invoice, you still need to complete",
      body: "These mentions are mandatory on an invoice."
    },
    issue: {
      title: "Issue this invoice?",
      totals: "Total incl. taxes {ttc}, net payable {net}.",
      never: "An issued invoice can never be changed: it gets its final number and its amounts are frozen. If there is a mistake, you will issue a credit note.",
      identity: "You will have to confirm your identity to finish.",
      confirm: "Issue the invoice",
      done: "Invoice {number} has been issued.",
      changedTitle: "The totals changed",
      changedBody: "The tax rule set or the client changed since the last computation: the draft now shows the new totals. Review them, then issue the invoice again.",
      changedDismiss: "Got it",
      mentionsTitle: "Mandatory mentions are missing",
      mentionsBody: "The invoice cannot be issued while these mentions are missing:",
      failedTitle: "The invoice could not be issued"
    },
    creditNote: {
      title: "Credit note on invoice {number}",
      intro: "A credit note cancels all or part of the invoice without changing it. It is issued immediately, with its own number.",
      mode: "Scope of the credit note",
      full: "Cancel the whole invoice (stamp included)",
      byLines: "Credit some lines",
      fullHint: "The credit note covers the total of {amount} incl. taxes.",
      linesLabel: "Lines to credit",
      quantityOf: "Quantity to credit for {description}",
      reason: "Reason for the credit note",
      reasonRequired: "Give the reason for the credit note.",
      pickLines: "Choose at least one line to credit.",
      cancel: "Cancel",
      issue: "Issue the credit note",
      issuing: "Issuing\u2026",
      done: "Credit note {number} has been issued."
    },
    errors: {
      clientRequired: "Choose a client.",
      rateRequired: "Enter the exchange rate.",
      rateInvalid: "Enter a positive rate with at most 6 decimals, for example 3.350.",
      linesRequired: "Add at least one line to the invoice.",
      descriptionRequired: "Describe this line.",
      priceRequired: "Enter the unit price.",
      quantityInvalid: "Enter a positive quantity with at most 3 decimals.",
      staleTitle: "Someone else changed this invoice",
      staleBody: "Another person saved this draft while you were editing it. Reload it to see its latest version, then apply your changes again.",
      reload: "Reload the invoice",
      saveFailed: "The invoice could not be saved"
    },
    totals: {
      needClient: "Choose a client to compute the totals (VAT, stamp, withholdings).",
      needRate: "Enter the exchange rate to compute the totals.",
      needLines: "Complete the lines (quantity and price) to compute the totals.",
      noRight: "Detailed totals are not available with your rights. The total of the lines excl. VAT remains exact.",
      indicative: "Indicative totals: they are recomputed when the invoice is issued, with the tax rule set in force that day."
    },
    actions: {
      label: "Invoice actions",
      issue: "Issue",
      pdf: "View the PDF",
      pdfOpening: "Opening the PDF\u2026",
      pdfPreparing: "The PDF is being prepared. Try again in a moment.",
      pdfFailed: "The PDF could not be opened. Try again in a moment.",
      recordPayment: "Record a payment",
      creditNote: "Issue a credit note",
      delete: "Delete the draft",
      saveFirst: "Save your changes first to use these actions."
    },
    remove: {
      title: "Delete {number}?",
      body: "This draft will be deleted permanently. No number has been used.",
      confirm: "Delete the draft",
      done: "The draft has been deleted."
    },
    save: {
      action: "Save",
      saving: "Saving\u2026",
      created: "The draft invoice has been created.",
      saved: "The draft invoice has been saved."
    },
    guard: {
      title: "Leave without saving?",
      body: "Your changes to this invoice will be lost.",
      leave: "Leave",
      stay: "Stay on the invoice"
    },
    history: {
      statuses: "Invoice states",
      invoice: "Invoice",
      ttn: "E-invoice (TTN)",
      payment: "Payment",
      createdBy: "Created on {date} by {name}",
      issued: "Issued as number {number} on {date} by {name}",
      notIssued: "This invoice is not issued yet: it has no number.",
      legalHold: "Kept under legal hold until {date}",
      creditOf: "Credit note on invoice",
      credited: "Already credited by credit notes: {amount}",
      pdfReady: "PDF ready",
      pdfNotReady: "PDF being prepared",
      paymentLine: "Payment of {date} ({method}): {amount}",
      paymentLineWithheld: "Payment of {date} ({method}): {amount}, plus {withheld} withheld by the client",
      noPayment: "No payment recorded."
    },
    mentions: {
      fiscalProfile: "Your office\u2019s fiscal profile is not filled in.",
      seller_name: "The legal name of your office is missing.",
      seller_address: "The address of your office is missing.",
      seller_taxId: "The tax id of your office is missing.",
      seller_taxId_invalid: "The tax id of your office is not valid.",
      client_name: "The client\u2019s name is missing.",
      client_address: "The client\u2019s address is missing.",
      client_taxId: "The client\u2019s tax id is missing (mandatory for a company or a public entity).",
      client_taxId_invalid: "The client\u2019s tax id is not valid.",
      lines: "The invoice has no lines.",
      lines_description: "Line {number} has no description.",
      lines_unitPriceMinor: "Line {number} has no unit price.",
      lines_quantityMilli: "The quantity of line {number} is not valid.",
      treatmentRef: "The VAT treatment reference (suspension certificate) is missing.",
      issueDate: "The issue date is missing.",
      number: "The invoice number is not valid.",
      creditedInvoiceNumber: "The original invoice of the credit note is missing.",
      computation: "The totals have not been computed.",
      computation_amountInWords: "The amount in words could not be produced.",
      unknown: "A mandatory mention is missing ({path}).",
      fixFiscal: "Complete the fiscal profile",
      fixClient: "Open the client\u2019s page"
    }
  },
  documents: {
    results: "Search results",
    add: "Add {title}",
    addShort: "Add",
    noResult: "No document found.",
    searchFailed: "The search failed. Try again."
  },
  payments: {
    list: {
      title: "Payments received",
      caption: "List of payments received",
      columns: {
        receivedOn: "Received on",
        invoice: "Invoice",
        client: "Client",
        method: "Method",
        amount: "Amount received",
        withholding: "Withholding",
        vatWithholding: "VAT withholding",
        certificate: "Withholding certificate",
        reference: "Reference"
      },
      certificate: {
        received: "Received",
        missing: "Missing",
        notNeeded: "Not applicable",
        add: "Add"
      },
      empty: {
        title: "No payments yet",
        description: "Payments are recorded from an issued invoice: open it, then choose \u201CRecord a payment\u201D."
      },
      loadMore: "Show more payments",
      loadingMore: "Loading\u2026",
      loadFailedTitle: "The payments could not be loaded",
      loadFailedBody: "Check your connection and try again.",
      none: "\u2014"
    },
    method: {
      transfer: "Bank transfer",
      cheque: "Cheque",
      bill: "Bill of exchange",
      cash: "Cash",
      online: "Online payment"
    },
    fields: {
      receivedOn: "Date received",
      method: "Payment method",
      amount: "Amount received",
      amountHint: "The amount actually collected, net of withholdings.",
      withholding: "Withholding tax",
      withholdingHint: "Proposed from the invoice: tax withheld by the client.",
      withholdingNone: "No withholding is expected on this invoice.",
      vatWithholding: "VAT withholding",
      vatWithholdingHint: "VAT withheld by the client (public entities).",
      chequeNumber: "Cheque number",
      chequeBank: "Bank",
      chequeValidUntil: "Cheque valid until",
      chequeValidUntilHint: "Without a date, the validity of the tax rule set applies (6 months).",
      reference: "Payment reference",
      referenceHint: "Transfer or deposit number\u2026 (optional).",
      tejReference: "TEJ reference of the withholding certificate",
      tejReferenceHint: "Optional: you can add it later.",
      certificateDocument: "Withholding certificate (document)",
      certificateDocumentHint: "Optional: search for the scan stored in the documents.",
      certificateChosen: "Document chosen:",
      certificateRemove: "Remove the document"
    },
    dialog: {
      title: "Record a payment on {number}",
      outstanding: "Still due before this payment: {amount}.",
      settles: "This payment settles {settled} (cash and withholdings). Still due afterwards: {after}.",
      cancel: "Cancel",
      save: "Record the payment",
      saving: "Saving\u2026",
      doneTitle: "Payment recorded",
      doneBody: "{outstanding} is still to be collected.",
      status: {
        unpaid: "The invoice is unpaid.",
        partially_paid: "The invoice is partially paid.",
        paid: "The invoice is paid."
      },
      close: "Close"
    },
    errors: {
      dateRequired: "Enter the date received.",
      dateInFuture: "The date received cannot be in the future.",
      nothingReceived: "Enter at least one amount received or withheld.",
      overpayment: "This payment exceeds the amount still due. Reduce the amounts.",
      overpaymentServer: "This payment exceeds the amount still due. What is due has been refreshed: check the amounts, then try again.",
      chequeLimit: "This amount exceeds the legal ceiling for a cheque payment. Choose another method or split the payment.",
      chequeNumber: "Enter the cheque number.",
      chequeBank: "Enter the cheque\u2019s bank."
    },
    warnings: {
      cash_not_deductible: "A cash payment of this amount is not tax-deductible for your client (threshold of the tax rule set).",
      cheque_expires_soon: "This cheque is about to expire: present it to the bank soon."
    },
    certificate: {
      title: "Withholding certificate for {number}",
      needOne: "Enter the TEJ reference or choose the document.",
      save: "Save the certificate",
      done: "The withholding certificate has been saved."
    },
    aging: {
      title: "Aged receivables",
      hint: "What your clients still owe you, by how late they are.",
      asOf: "Position on {date} (amounts in dinars).",
      caption: "Aged receivables by client",
      empty: "No outstanding receivables.",
      loadFailed: "The aged balance could not be loaded.",
      total: "Total",
      columns: {
        client: "Client",
        invoices: "Invoices",
        current: "Not yet due",
        d0_30: "0 to 30 days",
        d31_60: "31 to 60 days",
        d61_90: "61 to 90 days",
        over90: "Over 90 days",
        total: "Total due"
      }
    },
    reminders: {
      title: "Client reminders",
      hint: "A reminder email is sent to the client when a payment is late, on the days you choose after the due date.",
      enabled: "Send automatic reminders",
      days: "Reminder days after the due date",
      daysHint: "Up to 5 days, from smallest to largest, separated by commas (for example 7, 15, 30).",
      save: "Save the reminders",
      saving: "Saving\u2026",
      saved: "The reminder settings have been saved.",
      readOnly: "Only an administrator can change these settings.",
      stale: "Someone else changed these settings. Reload them, then try again.",
      reload: "Reload",
      loadFailed: "The reminder settings could not be loaded.",
      loading: "Loading the settings\u2026",
      errors: {
        invalid: "Enter whole numbers of days between 1 and 365, separated by commas.",
        order: "Enter the days from smallest to largest, with no duplicates.",
        many: "At most five reminder days."
      }
    }
  },
  expenses: {
    tabs: {
      label: "Expense report navigation",
      mine: "My expenses",
      approvals: "To approve"
    },
    category: {
      transport: "Transport",
      fuel: "Fuel",
      accommodation: "Accommodation",
      meals: "Meals",
      supplies: "Supplies",
      printing: "Printing and copying",
      software: "Software and subscriptions",
      telecom: "Telecommunications",
      training: "Training",
      permit_fees: "Permit fees and charges",
      other: "Other"
    },
    status: {
      submitted: "Pending",
      approved: "Approved",
      rejected: "Rejected",
      reimbursed: "Reimbursed"
    },
    mine: {
      title: "My expenses",
      listLabel: "List of my expenses",
      new: "New expense",
      resubmit: "Submit again",
      filters: {
        label: "Filters",
        status: "Status",
        all: "All statuses"
      },
      empty: {
        title: "No expenses yet",
        description: "Take a photo of your receipt, then declare the expense: an approver reviews it before it is reimbursed."
      },
      filtered: {
        title: "No expenses with this status",
        description: "Choose another status to see your expenses.",
        clear: "Show all my expenses"
      },
      loadFailedTitle: "Your expenses could not be loaded",
      loadFailedBody: "Check your connection and try again.",
      loadMore: "Show more expenses",
      loadingMore: "Loading\u2026",
      submitted: "Your expense was sent to your approvers.",
      dismiss: "Close this message"
    },
    card: {
      total: "Total incl. VAT",
      amounts: "Excl. VAT {ht}, VAT {vat}",
      vatDeductible: "VAT deductible",
      vatNotDeductible: "VAT not deductible",
      spentOn: "Spent on {date}",
      submittedBy: "Declared by {name}",
      noProject: "No project",
      receiptOpen: "View receipt",
      receiptOpening: "Opening\u2026",
      receiptChecking: "Receipt being checked",
      receiptOpenFailed: "The receipt could not be opened. Try again in a moment.",
      decision: {
        approved: "Approved by {name} on {date}",
        rejected: "Rejected by {name} on {date}",
        reason: "Reason: {reason}",
        reimbursed: "Reimbursed on {date}"
      }
    },
    form: {
      title: "New expense",
      resubmitTitle: "Submit the expense again",
      intro: "Attach the receipt (photo or PDF), then fill in the expense.",
      resubmitIntro: "This expense was rejected. The original receipt is kept: correct what needs fixing and send it again.",
      receipt: {
        legend: "Receipt",
        help: "A clear photo of the ticket or invoice, or a PDF. Your approver can open it once the antivirus check is finished.",
        takePhoto: "Take a photo",
        chooseFile: "Choose a file",
        preparing: "Preparing the upload\u2026",
        kept: "Receipt kept: {name}",
        keptNoName: "The receipt of the rejected expense is kept.",
        change: "Change receipt",
        required: "Attach the receipt of the expense.",
        pending: "Wait until the receipt has finished uploading.",
        refused: "This receipt was not accepted. Choose another file.",
        folderFailed: "Your receipt folder could not be prepared. Try again in a moment."
      },
      fields: {
        category: "Category",
        categoryPlaceholder: "Choose a category",
        label: "What it was for",
        labelHint: "For example: motorway toll, toner purchase.",
        spentOn: "Date of the expense",
        project: "Project",
        projectHint: "Optional: only your projects are offered.",
        noProject: "No project",
        vatRate: "VAT rate",
        ttc: "Total incl. VAT",
        ttcHint: "The total amount paid, as shown on the receipt.",
        ht: "Amount excl. VAT",
        vat: "VAT",
        vatHint: "Calculated with the chosen rate: correct it if the receipt says otherwise.",
        vatDeductible: "The VAT on this receipt is deductible"
      },
      amounts: {
        legend: "Amounts",
        summary: "Excl. VAT {ht} + VAT {vat} = total {ttc}"
      },
      errors: {
        category: "Choose a category.",
        label: "Say what the expense was for.",
        spentOn: "Enter the date of the expense.",
        spentInFuture: "The date of the expense cannot be in the future.",
        ttc: "Enter the total including VAT, above zero.",
        vatTooHigh: "The VAT cannot exceed the total including VAT.",
        mismatch: "The amount excluding VAT plus the VAT must equal the total including VAT.",
        RECEIPT_NOT_FOUND: "This receipt cannot be found. Attach it again, then send the expense.",
        RECEIPT_TYPE_NOT_ALLOWED: "The receipt must be an image or a PDF.",
        RECEIPT_REJECTED: "This receipt was refused by the antivirus check. Choose another file.",
        RECEIPT_ALREADY_USED: "This receipt is already used by another expense.",
        PROJECT_NOT_FOUND: "This project does not exist or you are not a member of it.",
        notAllowed: "Your receipt folder is not available right now."
      },
      submit: "Send the expense",
      submitting: "Sending\u2026",
      cancel: "Cancel"
    },
    approvals: {
      title: "Expenses to review",
      listLabel: "List of expenses",
      hint: "Approve or reject pending expenses, then mark them as reimbursed once the payment is made.",
      scopeProjects: "You see the expenses of your projects.",
      filters: {
        label: "Filters",
        status: "Status",
        all: "All statuses"
      },
      empty: {
        title: "No expenses to review",
        description: "Expenses declared by your team will appear here."
      },
      filtered: {
        title: "No expenses with this status",
        description: "Choose another status to see the expenses.",
        clear: "Show all statuses"
      },
      loadFailedTitle: "The expenses could not be loaded",
      loadFailedBody: "Check your connection and try again.",
      loadMore: "Show more expenses",
      loadingMore: "Loading\u2026",
      approve: "Approve",
      reject: "Reject",
      reimbursed: "Mark as reimbursed",
      busy: "Working\u2026",
      ownHint: "You cannot decide on your own expense: another approver must handle it.",
      staleHint: "This expense has changed. The list was refreshed: check it and try again.",
      done: {
        approved: "The expense \u201C{label}\u201D is approved.",
        rejected: "The expense \u201C{label}\u201D is rejected: {name} is informed.",
        reimbursed: "The expense \u201C{label}\u201D is marked as reimbursed."
      },
      rejectDialog: {
        title: "Reject the expense \u201C{label}\u201D",
        body: "The reason is sent to {name}, who can correct the expense and submit it again.",
        reason: "Reason for rejecting",
        reasonHint: "500 characters at most.",
        reasonRequired: "Give the reason for rejecting.",
        confirm: "Reject the expense",
        cancel: "Cancel"
      },
      reimburseDialog: {
        title: "Mark \u201C{label}\u201D as reimbursed",
        body: "Do you confirm that {amount} was reimbursed to {name}? This cannot be undone.",
        confirm: "Confirm reimbursement",
        cancel: "Cancel"
      }
    }
  },
  dashboard: {
    title: "Key figures",
    asOf: "As of {date}. Amounts in Tunisian dinars (TND); foreign-currency invoices are not counted.",
    scopeProjects: "These figures cover only the invoices of your projects.",
    loadFailedTitle: "The dashboard could not be loaded",
    loadFailedBody: "Check your connection and try again.",
    kpi: {
      groupLabel: "Key indicators",
      monthInvoiced: {
        label: "Invoiced this month",
        detail: "{ht} excl. VAT, VAT {vat}"
      },
      monthCollected: {
        label: "Collected this month",
        detail: "Withheld by your clients: {amount}"
      },
      yearInvoiced: {
        label: "Invoiced in {year}",
        detail: "{ht} excl. VAT"
      },
      yearCollected: {
        label: "Collected in {year}",
        detail: "Withheld by your clients: {amount}"
      },
      outstanding: {
        label: "Still owed by clients",
        detail: "{count, plural, =0 {No invoices waiting} one {# invoice waiting} other {# invoices waiting}}"
      },
      overdue: {
        label: "Of which overdue",
        detail: "{count, plural, =0 {No overdue invoices} one {# overdue invoice} other {# overdue invoices}}",
        flag: "To chase",
        none: "Up to date"
      },
      withholdings: {
        label: "Withholdings to recover",
        detail: "{count, plural, =0 {No missing withholding certificates} one {# payment without a withholding certificate} other {# payments without a withholding certificate}}"
      },
      vat: {
        label: "VAT invoiced this month",
        detail: "On the invoices issued in {month}"
      }
    },
    chart: {
      title: "Invoiced and collected over 12 months",
      description: "Amounts invoiced (incl. VAT) and money collected, month by month.",
      ariaLabel: "Bar chart of the amounts invoiced and collected from {from} to {to}. The exact amounts are in the data table.",
      invoiced: "Invoiced (incl. VAT)",
      collected: "Collected",
      axisUnit: "Amounts in TND",
      tickThousand: "{value}k",
      tickMillion: "{value}M",
      tooltipTitle: "{month}"
    },
    table: {
      show: "View the data",
      hide: "Hide the data",
      caption: "Invoiced and collected per month, in TND",
      month: "Month",
      invoiced: "Invoiced (incl. VAT)",
      collected: "Collected",
      total: "Total over 12 months"
    }
  },
  einvoicing: {
    chip: {
      details: "Details of the sending to TTN",
      attempt: "Attempt no. {n}: {status}, on {date}."
    },
    kind: {
      seal: "Electronic seal",
      test: "Test certificate",
      digigo: "DigiGO (remote signature)"
    },
    panel: {
      title: "Electronic invoice (El Fatoora)",
      loading: "Loading the El Fatoora follow-up\u2026",
      loadFailed: "The electronic invoice follow-up could not be loaded.",
      noAttempt: "Nothing has been sent to TTN yet.",
      attempts: "Sendings to TTN",
      attempt: "Attempt no. {n}",
      status: {
        awaiting_signature: "Awaiting signature",
        signed: "Signed",
        submitted: "Sent to TTN",
        accepted: "Accepted",
        rejected: "Rejected",
        failed: "Failed",
        manual: "Filed manually"
      },
      dates: "Created on {created}, last step on {last}.",
      requestedBy: "Requested by {name}.",
      reference: "TTN reference: {reference}",
      manualReference: "Reference typed by hand: {reference}",
      rejection: {
        reason: "Reason given by TTN: \u201C{reason}\u201D (code {code}).",
        kind: {
          technical: "Technical rejection (signature or file format).",
          content: "Content rejection (the invoice\u2019s information)."
        }
      },
      failure: {
        detail: "Technical detail: {detail}",
        NO_CREDENTIAL: "No signing certificate is active: the invoice could not be signed.",
        CREDENTIAL_EXPIRED: "The signing certificate has expired: the invoice could not be signed.",
        TEIF_INVALID: "The generated TEIF file is not valid: the invoice was not sent.",
        SIGNING_FAILED: "Signing the invoice failed.",
        TTN_UNREACHABLE: "TTN\u2019s service cannot be reached at the moment.",
        TTN_REFUSED: "TTN refused the file.",
        TTN_NO_ANSWER: "TTN did not answer within the expected time."
      },
      manageCredentials: "Manage signing certificates",
      wait: {
        title: "Being processed by TTN",
        body: "Nothing to do: this page updates by itself as soon as TTN answers."
      },
      resubmit: {
        rejectedTitle: "TTN rejected the invoice",
        failedTitle: "Sending to TTN failed",
        body: "Fix the cause of the problem, then send the invoice again: the same number is sent once more, the invoice itself is not changed.",
        action: "Fix, then send again",
        sending: "Sending\u2026",
        done: "The invoice was sent to TTN again with the same number."
      },
      creditNote: {
        title: "TTN refuses the content of the invoice",
        body: "An issued invoice can no longer be changed: its number cannot be reused with corrected content.",
        steps: "First issue a credit note that cancels this invoice, then create a new invoice with the corrected information.",
        action: "Issue a credit note"
      },
      accepted: {
        title: "Invoice accepted by TTN",
        pdf: "The invoice\u2019s PDF now carries the TTN reference and the QR code."
      },
      manualDone: {
        title: "Invoice filed manually on the TTN portal"
      },
      awaitingSignature: {
        title: "Waiting for your DigiGO signature",
        body: "This invoice is ready: it will go to TTN as soon as the batch of invoices is signed with DigiGO.",
        link: "Sign the batch on the E-invoicing page"
      }
    },
    manual: {
      title: "Automatic sending is not possible: manual filing",
      intro: "Meanwhile, you can file the invoice yourself on TTN\u2019s portal.",
      step1: "Download the invoice\u2019s TEIF file.",
      step2: "File it on TTN\u2019s El Fatoora portal.",
      step3: "Write down below the reference TTN gives you.",
      download: "Download the TEIF",
      preparing: "Preparing the file\u2026",
      signed: "The file is signed with your office\u2019s certificate.",
      unsigned: "The file is not signed: no certificate could be used, TTN\u2019s portal will sign it when you file it.",
      reference: "TTN reference",
      referenceHint: "3 to 100 characters: letters, digits, spaces and . _ / -",
      save: "Save the reference",
      saving: "Saving\u2026",
      done: "The TTN reference was saved.",
      errors: {
        required: "Type the reference TTN gave you.",
        tooShort: "The reference must have at least 3 characters.",
        format: "Use only letters, digits, spaces and . _ / - (100 characters at most)."
      }
    },
    mode: {
      title: "Electronic invoicing mode",
      hint: "Choose whether the invoices issued by your office are sent to TTN (El Fatoora). An identity check is asked to save the change.",
      label: "Mode",
      options: {
        required: {
          name: "Required",
          help: "Every issued invoice is signed, then sent to TTN. Choose this if the law or your clients require it."
        },
        optional: {
          name: "Optional",
          help: "Invoices are sent to TTN when your office has an active signing certificate; without one, they are issued without being sent."
        },
        disabled: {
          name: "Disabled",
          help: "No invoice is sent to TTN. Invoices already sent keep their status."
        }
      },
      save: "Save the mode",
      saving: "Saving\u2026",
      saved: "The electronic invoicing mode was saved.",
      stale: "Someone changed this setting. Reload it, then try again.",
      reload: "Reload",
      loadFailed: "The setting could not be loaded.",
      loading: "Loading the setting\u2026"
    },
    credentials: {
      title: "Signing certificates",
      hint: "Invoices are signed with your office\u2019s active certificate before they are sent to TTN. The private key is never shown and can never be downloaded.",
      add: "Add a certificate",
      list: "Signing certificates",
      loading: "Loading the certificates\u2026",
      loadFailed: "The certificates could not be loaded.",
      empty: {
        title: "No certificate: invoices cannot be signed",
        description: "Add your office\u2019s electronic seal certificate to be able to send your invoices to TTN."
      },
      state: {
        active: "Active",
        expired: "Expired",
        replaced: "Replaced",
        revoked: "Revoked"
      },
      expiringSoon: "Expires soon",
      expiringTitle: "Your active certificate expires soon",
      expiringBody: "It is valid until {date}. Add a new certificate before then so that sending invoices is not blocked.",
      kind: "Type",
      label: "Label",
      validity: "Validity",
      validityRange: "From {from} to {to}",
      issuer: "Issuer",
      fingerprint: "SHA-256 fingerprint",
      addedBy: "Added",
      addedByValue: "By {name} on {date}",
      revoke: "Revoke",
      revokeTitle: "Revoke the certificate {name}?",
      revokeBody: "Invoices will no longer be signed with this certificate and it cannot be reactivated. Invoices already accepted by TTN are not changed. Add another certificate to resume sending.",
      revokeConfirm: "Revoke the certificate",
      revoked: "The certificate was revoked.",
      stale: "This certificate was changed in the meantime. The list was reloaded."
    },
    add: {
      title: "Add a signing certificate",
      intro: "Choose your office\u2019s certificate and its private key. The files are read in your browser, then sent only once.",
      kind: "Certificate type",
      label: "Label (optional)",
      labelHint: "A name to recognise it, for example \u201CSeal 2026\u201D.",
      certificate: "Certificate (.pem, .crt or .cer file)",
      certificateHint: "The public certificate, in PEM format.",
      privateKey: "Private key (.pem or .key file)",
      privateKeyHint: "The private key in PEM format (PKCS#8). 20 KB at most.",
      never: "The private key is encrypted before it is saved and can never be shown or downloaded again. An identity check may be asked: you will then choose the files again.",
      cancel: "Cancel",
      save: "Add the certificate",
      saving: "Adding\u2026",
      done: "The certificate was added and is now active.",
      errors: {
        required: "Choose a file.",
        file: {
          tooBig: "This file is too large (20 KB at most).",
          unreadable: "This file could not be read. Choose it again.",
          notPem: "This file is not in PEM format: choose a text file that starts with \u201C-----BEGIN\u201D."
        },
        certificatePem: {
          SIGNING_CREDENTIAL_INVALID: "This file is not a valid X.509 certificate in PEM format.",
          SIGNING_CREDENTIAL_EXPIRED: "This certificate has expired. Choose a certificate that is still valid."
        },
        privateKeyPem: {
          SIGNING_CREDENTIAL_INVALID: "This file is not a valid private key in PEM format (PKCS#8).",
          SIGNING_KEY_MISMATCH: "This private key does not match the certificate. Choose the key generated with it."
        },
        generic: "This file is not accepted. Check it, then try again.",
        kind: "This certificate type is not accepted. Choose another type."
      }
    }
  }
};

// locales/fr/finance.json
var finance_default3 = {
  nav: {
    title: "Finance",
    quotes: "Devis",
    contracts: "Contrats",
    invoices: "Factures",
    payments: "Paiements",
    expenses: "Notes de frais",
    suppliers: "Fournisseurs",
    supplierInvoices: "Factures fournisseurs",
    withholding: "Retenues",
    accounting: "Exports comptables",
    dashboard: "Tableau de bord",
    management: "Pilotage",
    treasury: "Tr\xE9sorerie",
    profitability: "Rentabilit\xE9",
    costRates: "Taux de co\xFBt",
    einvoicing: "Facture \xE9lectronique"
  },
  totals: {
    title: "Totaux",
    subtotalHt: "Total HT",
    vat: "TVA {rate}",
    stamp: "Droit de timbre",
    totalTtc: "Total TTC",
    withholding: "Retenue \xE0 la source {rate}",
    vatWithholding: "Retenue \xE0 la source sur la TVA {rate}",
    netPayable: "Net \xE0 payer",
    base: "Base {amount}",
    amountInWords: "Montant en lettres : {words}",
    rateSource: "Source du taux : {source}.",
    tndEquivalent: "Contre-valeur en dinars : {amount} (1 {currency} = {rate} TND)",
    legalRef: "R\xE9f\xE9rence l\xE9gale : {ref}",
    toVerify: "R\xE8gle \xE0 v\xE9rifier",
    toVerifyHint: "Cette valeur doit \xEAtre confirm\xE9e par un expert-comptable avant la mise en production.",
    vatNoRate: "TVA",
    withholdingNoRate: "Retenue \xE0 la source",
    vatWithholdingNoRate: "Retenue \xE0 la source sur la TVA",
    rulesConcerned: "R\xE8gles concern\xE9es\xA0: {rules}",
    tndEquivalentNet: "Net \xE0 payer en dinars\xA0: {amount}",
    loading: "Calcul des totaux en cours",
    errorTitle: "Totaux indisponibles",
    errorBody: "Les totaux n\u2019ont pas pu \xEAtre calcul\xE9s. V\xE9rifiez votre connexion puis r\xE9essayez.",
    retry: "R\xE9essayer",
    notes: {
      vat_suspended: "TVA en suspension",
      vat_export: "Exon\xE9ration de TVA \xE0 l\u2019export",
      stamp_exempt_treatment: "Exon\xE9r\xE9 (export)",
      stamp_exempt_public_buyer: "Exon\xE9r\xE9 (acheteur public)",
      stamp_not_reversed: "Timbre conserv\xE9 (avoir partiel)",
      not_applicable: "Non applicable",
      below_threshold: "Sous le seuil d\u2019application"
    },
    mention: {
      suspended: "Vente en suspension de TVA \u2014 attestation n\xB0 {reference}",
      suspendedNoRef: "Vente en suspension de TVA",
      export: "Exon\xE9ration de TVA \u2014 prestation de services \xE0 l\u2019export"
    }
  },
  rules: {
    "stamp.exemptPublicBuyers": "Exon\xE9ration du droit de timbre pour l\u2019\xC9tat et les acheteurs publics",
    "withholding.base": "Base de la retenue \xE0 la source (TTC hors timbre)",
    "withholding.purchases": "Taux de retenue sur les achats",
    "vatWithholding.thresholdBase": "Base du seuil de retenue sur la TVA (TTC hors timbre)",
    "contract.retentionBase": "Base de la retenue de garantie (HT)",
    lateInterest: "D\xE9lais de paiement des march\xE9s publics et taux des int\xE9r\xEAts moratoires (TMM)"
  },
  quotes: {
    status: {
      draft: "Brouillon",
      sent: "Envoy\xE9",
      accepted: "Accept\xE9",
      rejected: "Refus\xE9",
      expired: "Expir\xE9"
    },
    list: {
      caption: "Liste des devis",
      new: "Nouveau devis",
      columns: {
        number: "Num\xE9ro",
        title: "Objet",
        client: "Client",
        status: "Statut",
        totalHt: "Total HT",
        totalTtc: "Total TTC",
        validUntil: "Valable jusqu\u2019au",
        sentAt: "Envoy\xE9 le",
        acceptedAt: "Accept\xE9 le"
      },
      filters: {
        label: "Filtres des devis",
        status: "Statut",
        all: "Tous les statuts"
      },
      empty: {
        title: "Aucun devis pour le moment",
        description: "Cr\xE9ez votre premier devis\xA0: il se calcule en direct et s\u2019envoie au client par un lien s\xE9curis\xE9.",
        descriptionReadOnly: "Les devis de votre bureau appara\xEEtront ici."
      },
      filtered: {
        title: "Aucun devis ne correspond",
        description: "Aucun devis n\u2019a ce statut. Essayez un autre filtre."
      },
      clearFilters: "Effacer le filtre",
      loadMore: "Afficher plus de devis",
      loadingMore: "Chargement\u2026",
      loadFailedTitle: "Les devis n\u2019ont pas pu \xEAtre charg\xE9s",
      loadFailedBody: "V\xE9rifiez votre connexion puis r\xE9essayez.",
      none: "\u2014"
    },
    editor: {
      newTitle: "Nouveau devis",
      detailTitle: "Devis {number}",
      breadcrumbList: "Devis",
      loadFailedTitle: "Ce devis n\u2019a pas pu \xEAtre charg\xE9",
      loadFailedBody: "Il n\u2019existe pas ou vous n\u2019y avez pas acc\xE8s.",
      readOnlyRights: "Vous pouvez consulter ce devis, mais vous n\u2019avez pas le droit de le modifier.",
      readOnlyStatus: "Ce devis ne peut plus \xEAtre modifi\xE9.",
      readOnlySent: "Ce devis a \xE9t\xE9 envoy\xE9 au client. Pour le modifier, il repasse en brouillon et le lien envoy\xE9 cesse de fonctionner.",
      editingSent: "Vous modifiez un devis envoy\xE9\xA0: en enregistrant, il repasse en brouillon et le lien envoy\xE9 au client cesse de fonctionner. Il faudra le renvoyer."
    },
    sections: {
      general: "Informations g\xE9n\xE9rales",
      calculator: "Calcul des honoraires",
      lines: "Lignes du devis",
      notes: "Notes",
      history: "Suivi du devis"
    },
    fields: {
      client: {
        label: "Client",
        placeholder: "Choisir un client",
        hint: "Le ma\xEEtre d\u2019ouvrage destinataire du devis."
      },
      project: {
        label: "Projet",
        none: "Aucun projet (pour le moment)",
        current: "Projet d\xE9j\xE0 li\xE9"
      },
      title: {
        label: "Objet du devis",
        hint: "Par exemple\xA0: Mission de ma\xEEtrise d\u2019\u0153uvre, villa R+1."
      },
      language: {
        label: "Langue du PDF",
        hint: "La langue du document envoy\xE9 au client.",
        fr: "Fran\xE7ais",
        ar: "Arabe",
        bilingual: "Bilingue (fran\xE7ais et arabe)"
      },
      validUntil: {
        label: "Valable jusqu\u2019au",
        hint: "Apr\xE8s cette date, le client ne peut plus accepter."
      },
      currency: {
        label: "Devise"
      },
      exchangeRate: {
        label: "Taux de change (TND pour 1 unit\xE9)",
        hint: "Par exemple 3,350 pour 1 EUR. Les totaux sont aussi donn\xE9s en dinars."
      },
      feeMode: {
        label: "Mode de calcul",
        lump_sum: "Forfait r\xE9parti par phase",
        percentage_of_works: "Pourcentage du co\xFBt des travaux",
        time_based: "Au temps pass\xE9",
        mixed: "Mixte (lignes saisies \xE0 la main)"
      },
      notes: {
        label: "Notes pour le client",
        hint: "Conditions particuli\xE8res, hypoth\xE8ses, exclusions."
      }
    },
    errors: {
      clientRequired: "Choisissez un client.",
      titleRequired: "Donnez un objet au devis.",
      validUntilRequired: "Indiquez la date de validit\xE9.",
      rateRequired: "Indiquez le taux de change.",
      rateInvalid: "\xC9crivez un taux positif avec au plus 6 d\xE9cimales, par exemple 3,350.",
      linesRequired: "Ajoutez au moins une ligne au devis.",
      descriptionRequired: "D\xE9crivez cette ligne.",
      priceRequired: "Indiquez le prix unitaire.",
      quantityInvalid: "\xC9crivez une quantit\xE9 positive avec au plus 3 d\xE9cimales.",
      validityInPast: "La date de validit\xE9 est d\xE9j\xE0 pass\xE9e.",
      staleTitle: "Quelqu\u2019un a modifi\xE9 ce devis",
      staleBody: "Une autre personne a enregistr\xE9 ce devis pendant que vous le modifiiez. Rechargez-le pour voir sa derni\xE8re version, puis appliquez de nouveau vos changements.",
      reload: "Recharger le devis",
      saveFailed: "Le devis n\u2019a pas pu \xEAtre enregistr\xE9"
    },
    save: {
      action: "Enregistrer",
      saving: "Enregistrement\u2026",
      created: "Le devis {number} a \xE9t\xE9 cr\xE9\xE9.",
      saved: "Le devis {number} a \xE9t\xE9 enregistr\xE9."
    },
    guard: {
      title: "Quitter sans enregistrer\xA0?",
      body: "Vos modifications de ce devis seront perdues.",
      leave: "Quitter",
      stay: "Rester sur le devis"
    },
    lines: {
      noPhase: "Autres lignes",
      phaseSubtotal: "Sous-total HT {amount}",
      description: "Description",
      phase: "Phase",
      noPhaseOption: "Aucune phase",
      quantity: "Quantit\xE9",
      unitPrice: "Prix unitaire HT",
      vat: "TVA",
      amount: "Montant HT",
      add: "Ajouter une ligne",
      addToPhase: "Ajouter une ligne \xE0 cette phase",
      remove: "Supprimer la ligne {number}",
      lineNumber: "Ligne {number}",
      totalHt: "Total HT des lignes",
      empty: "Aucune ligne pour le moment. Utilisez le calcul des honoraires ou ajoutez une ligne.",
      readOnlyCaption: "Lignes du devis"
    },
    calculator: {
      intro: "Le calcul propose des lignes que vous pouvez encore modifier\xA0: rien n\u2019est appliqu\xE9 sans votre accord.",
      mixedHint: "Dans ce mode, vous saisissez les lignes \xE0 la main. Vous pouvez aussi vous aider des autres modes de calcul.",
      propose: "Proposer les lignes",
      proposed: "Les lignes ont \xE9t\xE9 propos\xE9es. V\xE9rifiez-les puis modifiez-les si besoin.",
      replaceTitle: "Remplacer les lignes actuelles\xA0?",
      replaceBody: "Les lignes propos\xE9es remplaceront celles du devis. Vous pourrez encore les modifier.",
      replaceConfirm: "Remplacer les lignes",
      lumpTotal: "Honoraires forfaitaires HT",
      worksCost: "Co\xFBt estim\xE9 des travaux HT",
      fee: "Honoraires calcul\xE9s HT",
      rate: {
        label: "Taux d\u2019honoraires (%)",
        hint: "Par exemple 6 ou 4,5."
      },
      rateInvalid: "\xC9crivez un pourcentage entre 0 et 100, par exemple 4,5.",
      scale: {
        label: "Bar\xE8me de r\xE9f\xE9rence",
        none: "Aucun bar\xE8me (taux saisi)",
        hint: "Un bar\xE8me donne une suggestion avec sa source\xA0: il n\u2019est jamais appliqu\xE9 sans votre accord.",
        suggestion: "Suggestion du bar\xE8me \xAB\xA0{name}\xA0\xBB\xA0: {amount}",
        apply: "Utiliser cette suggestion",
        source: {
          decree_78_71: "D\xE9cret 78-71",
          oat: "Ordre des architectes de Tunisie",
          oit_2026: "Ordre des ing\xE9nieurs tunisiens",
          custom: "Bar\xE8me de votre bureau"
        },
        sourceLine: "Source\xA0: {source}, en vigueur depuis le {date}",
        legalRef: "R\xE9f\xE9rence\xA0: {ref}",
        belowMinimum: "Ces honoraires sont inf\xE9rieurs au minimum du bar\xE8me \xAB\xA0{name}\xA0\xBB ({amount}). Vous pouvez les garder, c\u2019est un simple avertissement."
      },
      shares: {
        title: "R\xE9partition par phase",
        hint: "Les parts doivent totaliser 100 %.",
        phase: "Phase",
        share: "Part (%)",
        add: "Ajouter une phase",
        remove: "Retirer la phase {phase}",
        loadTemplate: "Reprendre la r\xE9partition d\u2019un type de mission",
        loadNone: "Choisir un type de mission",
        total: "Total des parts\xA0: {total}",
        notHundred: "Les parts totalisent {total} au lieu de 100 %.",
        invalid: "\xC9crivez un pourcentage, par exemple 12,5.",
        empty: "Ajoutez au moins une phase."
      },
      time: {
        title: "Temps pass\xE9",
        description: "Intervention",
        quantity: "Heures ou jours",
        unitRate: "Tarif unitaire HT",
        add: "Ajouter une intervention",
        remove: "Retirer l\u2019intervention {number}",
        total: "Total au temps pass\xE9\xA0: {amount}",
        empty: "Ajoutez au moins une intervention."
      }
    },
    totals: {
      needClient: "Choisissez un client pour calculer les totaux (TVA, timbre, retenues).",
      needRate: "Indiquez le taux de change pour calculer les totaux.",
      needLines: "Compl\xE9tez les lignes (quantit\xE9 et prix) pour calculer les totaux.",
      noRight: "Les totaux d\xE9taill\xE9s ne sont pas disponibles avec vos droits. Le total HT des lignes reste exact.",
      indicative: "Totaux indicatifs\xA0: la facture les recalcule au moment de son \xE9mission."
    },
    actions: {
      label: "Actions sur le devis",
      pdf: "Voir le PDF",
      pdfOpening: "Ouverture du PDF\u2026",
      pdfPreparing: "Le PDF est en cours de pr\xE9paration. R\xE9essayez dans un instant.",
      pdfFailed: "Le PDF n\u2019a pas pu \xEAtre ouvert. R\xE9essayez dans un instant.",
      send: "Envoyer",
      resend: "Renvoyer",
      reject: "Refus\xE9 par le client",
      convert: "Cr\xE9er le projet",
      openProject: "Ouvrir le projet",
      delete: "Supprimer le brouillon",
      edit: "Modifier le devis",
      saveFirst: "Enregistrez d\u2019abord vos modifications pour utiliser ces actions."
    },
    history: {
      createdBy: "Cr\xE9\xE9 le {date} par {name}",
      sent: "Envoy\xE9 le {date} par {name}",
      linkExpires: "Le lien du client est valable jusqu\u2019au {date}",
      accepted: "Accept\xE9 le {date} par {name}",
      rejected: "Refus\xE9 par le client le {date}",
      pdfHash: "Empreinte du PDF accept\xE9 (SHA-256)\xA0: {hash}",
      notSent: "Ce devis n\u2019a pas encore \xE9t\xE9 envoy\xE9.",
      pdfReady: "PDF pr\xEAt",
      pdfNotReady: "PDF en pr\xE9paration"
    },
    send: {
      title: "Envoyer le devis {number}",
      intro: "Le client re\xE7oit un e-mail avec un lien s\xE9curis\xE9 pour consulter le PDF et accepter le devis. Le lien est valable 30 jours.",
      resendInfo: "Ce devis a d\xE9j\xE0 \xE9t\xE9 envoy\xE9\xA0: renvoyer remplace le lien pr\xE9c\xE9dent, qui cesse de fonctionner.",
      contact: {
        label: "Destinataire",
        client: "Adresse e-mail du client",
        noEmail: "pas d\u2019e-mail"
      },
      message: {
        label: "Message pour le client (facultatif)",
        hint: "Ce message accompagne le lien dans l\u2019e-mail."
      },
      submit: "Envoyer le devis",
      sending: "Envoi\u2026",
      done: "Le devis {number} a \xE9t\xE9 envoy\xE9.",
      noRecipient: "Ni le client ni ce contact n\u2019a d\u2019adresse e-mail. Ajoutez-en une dans la fiche du client, puis r\xE9essayez.",
      validityInPast: "La date de validit\xE9 est pass\xE9e\xA0: changez-la avant d\u2019envoyer le devis."
    },
    reject: {
      title: "Marquer le devis {number} comme refus\xE9\xA0?",
      body: "Le client a refus\xE9 ce devis. Le lien qu\u2019il a re\xE7u ne permettra plus de l\u2019accepter.",
      confirm: "Marquer comme refus\xE9",
      done: "Le devis {number} est marqu\xE9 comme refus\xE9."
    },
    convert: {
      title: "Cr\xE9er le projet du devis {number}",
      intro: "Le projet reprend le client et les honoraires du devis accept\xE9. Choisissez le type de mission\xA0: ses phases et dossiers types sont cr\xE9\xE9s.",
      name: "Nom du projet",
      nameRequired: "Donnez un nom au projet.",
      missionType: "Type de mission",
      code: "Code du projet (facultatif)",
      codeHint: "Laissez vide pour qu\u2019un code soit g\xE9n\xE9r\xE9.",
      submit: "Cr\xE9er le projet",
      creating: "Cr\xE9ation\u2026",
      done: "Le projet a \xE9t\xE9 cr\xE9\xE9."
    },
    remove: {
      title: "Supprimer le brouillon {number}\xA0?",
      body: "Ce devis n\u2019a jamais \xE9t\xE9 envoy\xE9\xA0: il sera supprim\xE9 d\xE9finitivement.",
      confirm: "Supprimer",
      done: "Le brouillon {number} a \xE9t\xE9 supprim\xE9."
    },
    editSent: {
      title: "Modifier un devis envoy\xE9\xA0?",
      body: "Le devis repasse en brouillon et le lien envoy\xE9 au client cesse de fonctionner. Vous devrez le renvoyer apr\xE8s vos modifications.",
      confirm: "Modifier le devis"
    }
  },
  contracts: {
    kind: {
      private_agreement: "Contrat priv\xE9",
      public_market: "March\xE9 public"
    },
    list: {
      caption: "Liste des contrats",
      new: "Nouveau contrat",
      columns: {
        reference: "R\xE9f\xE9rence",
        client: "Client",
        kind: "Nature",
        amount: "Montant HT",
        total: "Total avec avenants",
        signedOn: "Sign\xE9 le",
        bondReleaseOn: "Lev\xE9e du cautionnement"
      },
      filters: {
        label: "Filtres des contrats",
        kind: "Nature du contrat",
        all: "Toutes les natures"
      },
      empty: {
        title: "Aucun contrat pour le moment",
        description: "Cr\xE9ez un contrat \xE0 partir d\u2019un devis accept\xE9, ou saisissez-en un directement\xA0: avance, retenue, cautionnement et p\xE9nalit\xE9s.",
        descriptionReadOnly: "Les contrats de votre bureau appara\xEEtront ici."
      },
      filtered: {
        title: "Aucun contrat ne correspond",
        description: "Aucun contrat n\u2019a cette nature. Essayez un autre filtre."
      },
      clearFilters: "Effacer le filtre",
      loadMore: "Afficher plus de contrats",
      loadingMore: "Chargement\u2026",
      loadFailedTitle: "Les contrats n\u2019ont pas pu \xEAtre charg\xE9s",
      loadFailedBody: "V\xE9rifiez votre connexion puis r\xE9essayez.",
      none: "\u2014"
    },
    editor: {
      newTitle: "Nouveau contrat",
      detailTitle: "Contrat {reference}",
      breadcrumbList: "Contrats",
      fromQuote: "Contrat cr\xE9\xE9 \xE0 partir d\u2019un devis\xA0: ouvrir le devis",
      readOnlyRights: "Vous pouvez consulter ce contrat, mais pas le modifier.",
      loadFailedTitle: "Le contrat n\u2019a pas pu \xEAtre charg\xE9",
      loadFailedBody: "V\xE9rifiez votre connexion puis r\xE9essayez."
    },
    sections: {
      general: "Informations g\xE9n\xE9rales",
      terms: "Conditions de paiement",
      amendments: "Avenants",
      progress: "Avancement factur\xE9"
    },
    fields: {
      client: {
        label: "Client",
        placeholder: "Choisir un client",
        fixed: "Le client d\u2019un contrat ne change pas."
      },
      project: {
        label: "Projet",
        none: "Aucun projet",
        current: "Projet actuel"
      },
      reference: {
        label: "R\xE9f\xE9rence du contrat",
        hint: "Le num\xE9ro du march\xE9 ou de la convention, unique dans votre bureau."
      },
      kind: {
        label: "Nature",
        hint: "Un march\xE9 public affiche des avertissements si les conditions d\xE9passent les limites r\xE9glementaires."
      },
      currency: {
        label: "Devise"
      },
      amount: {
        label: "Montant HT",
        hint: "Le montant sign\xE9, avenants exclus."
      },
      signedOn: {
        label: "Date de signature"
      },
      total: {
        label: "Total HT avec avenants\xA0:"
      },
      advance: {
        label: "Avance",
        hint: "En pourcentage du montant, par exemple 10."
      },
      retention: {
        label: "Retenue de garantie",
        hint: "Retenue sur chaque facture de situation, lib\xE9r\xE9e par la facture finale."
      },
      retentionBase: {
        label: "Base de la retenue",
        hint: "Hors taxes par d\xE9faut\xA0; \xE0 confirmer avec votre expert-comptable.",
        ht: "Montant hors taxes",
        ttc: "Montant toutes taxes comprises"
      },
      bond: {
        label: "Cautionnement d\xE9finitif",
        hint: "En pourcentage du montant."
      },
      bondReleaseOn: {
        label: "Date de lev\xE9e du cautionnement",
        hint: "Un rappel est envoy\xE9 7 jours avant et le jour m\xEAme. N\xE9cessite un cautionnement."
      },
      penaltyRate: {
        label: "P\xE9nalit\xE9 de retard par jour",
        hint: "En pourcentage du montant, par jour de retard."
      },
      penaltyCap: {
        label: "Plafond des p\xE9nalit\xE9s",
        hint: "En pourcentage du montant."
      }
    },
    errors: {
      clientRequired: "Choisissez un client.",
      referenceRequired: "Indiquez la r\xE9f\xE9rence du contrat.",
      amountRequired: "Indiquez le montant du contrat.",
      rateInvalid: "\xC9crivez un pourcentage entre 0 et 100, avec au plus 2 d\xE9cimales, par exemple 2,5.",
      bondRequired: "Une date de lev\xE9e suppose un cautionnement\xA0: indiquez son pourcentage.",
      totalNegative: "Avec les avenants, le total passerait sous z\xE9ro.",
      clientMismatch: "Ce client ne correspond pas au contrat.",
      projectMismatch: "Ce projet n\u2019appartient pas au client du contrat.",
      documentNotFound: "Ce document est introuvable\xA0: choisissez-en un autre.",
      staleTitle: "Quelqu\u2019un a modifi\xE9 ce contrat",
      staleBody: "Une autre personne a enregistr\xE9 ce contrat pendant que vous le modifiiez. Rechargez-le pour voir sa derni\xE8re version, puis appliquez de nouveau vos changements.",
      reload: "Recharger le contrat",
      saveFailed: "Le contrat n\u2019a pas pu \xEAtre enregistr\xE9"
    },
    save: {
      action: "Enregistrer",
      saving: "Enregistrement\u2026",
      created: "Le contrat {reference} a \xE9t\xE9 cr\xE9\xE9.",
      saved: "Le contrat {reference} a \xE9t\xE9 enregistr\xE9."
    },
    guard: {
      title: "Quitter sans enregistrer\xA0?",
      body: "Vos modifications de ce contrat seront perdues.",
      leave: "Quitter",
      stay: "Rester sur le contrat"
    },
    warnings: {
      title: "Conditions au-dessus des limites d\u2019un march\xE9 public",
      intro: "Ces avertissements ne bloquent pas l\u2019enregistrement\xA0: le march\xE9 peut pr\xE9voir une d\xE9rogation.",
      RETENTION_ABOVE_LIMIT: "Retenue de garantie de {actual}, au-dessus de la limite de {limit}.",
      PERFORMANCE_BOND_ABOVE_LIMIT: "Cautionnement d\xE9finitif de {actual}, au-dessus de la limite de {limit}.",
      RETENTION_PLUS_BOND_ABOVE_LIMIT: "Retenue de garantie et cautionnement cumul\xE9s de {actual}, au-dessus de la limite de {limit}.",
      PENALTY_CAP_ABOVE_LIMIT: "Plafond des p\xE9nalit\xE9s de {actual}, au-dessus de la limite de {limit}.",
      ADVANCE_ABOVE_LIMIT: "Avance de {actual}, au-dessus de la limite de {limit} pour un march\xE9 d\u2019\xE9tudes.",
      legalRef: "R\xE9f\xE9rence\xA0: {ref}"
    },
    amendments: {
      caption: "Avenants du contrat",
      add: "Ajouter un avenant",
      total: "Total HT avec avenants\xA0:",
      empty: {
        title: "Aucun avenant",
        description: "Un avenant modifie le montant du contrat\xA0; une fois enregistr\xE9, il ne peut plus \xEAtre modifi\xE9."
      },
      saveFirst: "Enregistrez d\u2019abord vos modifications pour ajouter un avenant.",
      added: "L\u2019avenant a \xE9t\xE9 ajout\xE9.",
      columns: {
        number: "N\xB0",
        label: "Objet",
        delta: "Variation du montant",
        signedOn: "Sign\xE9 le",
        document: "Document sign\xE9"
      },
      dialog: {
        title: "Ajouter un avenant",
        intro: "Un avenant est un acte sign\xE9\xA0: une fois enregistr\xE9, il ne se modifie plus. En cas d\u2019erreur, ajoutez un avenant correctif.",
        label: "Objet de l\u2019avenant",
        description: "Description (facultatif)",
        delta: "Variation du montant HT",
        deltaHint: "Positive pour une augmentation, n\xE9gative pour une r\xE9duction (par exemple -500).",
        signedOn: "Date de signature",
        document: "Document sign\xE9 (GED)",
        documentHint: "Facultatif\xA0: un document de l\u2019espace du projet.",
        noProject: "Rattachez le contrat \xE0 un projet pour lier un document de la GED.",
        submit: "Ajouter l\u2019avenant",
        adding: "Ajout\u2026"
      },
      errors: {
        labelRequired: "Donnez un objet \xE0 l\u2019avenant.",
        deltaRequired: "Indiquez la variation du montant.",
        signedOnRequired: "Indiquez la date de signature."
      }
    },
    document: {
      loading: "Chargement du document\u2026",
      restricted: "Document li\xE9 (vous n\u2019y avez pas acc\xE8s)",
      linked: "Document li\xE9"
    },
    picker: {
      none: "Aucun document li\xE9",
      choose: "Choisir un document",
      change: "Changer",
      remove: "Retirer",
      label: "Choisir un document du projet",
      location: "Dossier\xA0: {name}",
      root: "Racine du projet",
      up: "Dossier parent",
      folders: "Sous-dossiers",
      documents: "Documents du dossier",
      openFolder: "Ouvrir le dossier {name}",
      openFolderFirst: "Ouvrez un dossier pour voir ses documents.",
      noDocuments: "Ce dossier ne contient aucun document.",
      loadFailed: "Les dossiers n\u2019ont pas pu \xEAtre charg\xE9s. R\xE9essayez dans un instant."
    },
    progress: {
      prepare: "Pr\xE9parer une facture de situation",
      loading: "Chargement de l\u2019avancement\u2026",
      loadFailed: "L\u2019avancement n\u2019a pas pu \xEAtre charg\xE9.",
      needProject: "Rattachez ce contrat \xE0 un projet pour suivre son avancement par phase.",
      needTnd: "Les factures de situation se font en dinars\xA0: l\u2019avancement n\u2019est pas disponible pour une autre devise."
    },
    fromQuote: {
      action: "Cr\xE9er le contrat",
      creating: "Cr\xE9ation\u2026",
      done: "Le contrat a \xE9t\xE9 cr\xE9\xE9 \xE0 partir du devis."
    },
    projectTab: {
      contract: "Contrat",
      openContract: "Ouvrir le contrat",
      empty: {
        title: "Aucun contrat pour ce projet",
        description: "Cr\xE9ez le contrat pour suivre l\u2019avance, la retenue et la facturation par phase.",
        fromQuote: "Le devis {number} a \xE9t\xE9 accept\xE9\xA0: le contrat reprend son client et son montant.",
        descriptionReadOnly: "Le contrat de ce projet appara\xEEtra ici.",
        create: "Cr\xE9er le contrat",
        createFromQuote: "Cr\xE9er le contrat \xE0 partir du devis"
      },
      quotesInvoices: "Devis et factures",
      quotes: "Devis du projet",
      noQuotes: "Aucun devis n\u2019est li\xE9 \xE0 ce projet.",
      allQuotes: "Tous les devis",
      allInvoices: "Toutes les factures",
      noAccessTitle: "Finance non disponible",
      noAccessBody: "Vous n\u2019avez pas acc\xE8s aux informations financi\xE8res de ce projet."
    }
  },
  progress: {
    title: "Facture de situation \u2014 contrat {reference}",
    titleShort: "Facture de situation",
    help: "Pour chaque phase, indiquez l\u2019avancement cumul\xE9\xA0: le montant de la p\xE9riode est calcul\xE9 en direct. Le r\xE9capitulatif cumul\xE9 par phase est imprim\xE9 automatiquement sur le PDF de la facture.",
    final: {
      label: "Facture finale \xE0 la r\xE9ception d\xE9finitive",
      hint: "Toutes les phases passent \xE0 100 %, le reste de l\u2019avance est r\xE9cup\xE9r\xE9 et la retenue de garantie est lib\xE9r\xE9e."
    },
    sections: {
      phases: "Avancement par phase",
      totals: "Montants de cette facture",
      options: "Options de la facture"
    },
    table: {
      caption: "Avancement cumul\xE9 par phase",
      columns: {
        phase: "Phase",
        fee: "Honoraires de la phase",
        previous: "D\xE9j\xE0 factur\xE9",
        cumulative: "Nouveau cumul",
        period: "Montant de la p\xE9riode"
      },
      cumulativeFor: "Nouveau cumul en pourcentage pour la phase {phase}",
      unavailable: "Montant indisponible"
    },
    totals: {
      work: "Travaux de la p\xE9riode (HT)",
      advanceRecovery: "R\xE9cup\xE9ration de l\u2019avance",
      retention: "Retenue de garantie ({rate})",
      retentionRelease: "Lib\xE9ration de la retenue de garantie",
      net: "Net HT de la facture",
      unavailable: "Les montants ne peuvent pas \xEAtre calcul\xE9s pour le moment.",
      fixFirst: "Corrigez d\u2019abord les pourcentages signal\xE9s dans le tableau.",
      taxesHint: "La TVA, le timbre et les retenues \xE0 la source sont calcul\xE9s sur la facture brouillon, qui s\u2019ouvre apr\xE8s l\u2019enregistrement."
    },
    lines: {
      advanceRecovery: "R\xE9cup\xE9ration de l\u2019avance",
      retention: "Retenue de garantie",
      retentionRelease: "Lib\xE9ration de la retenue de garantie"
    },
    options: {
      language: {
        label: "Langue du PDF",
        hint: "La langue du document envoy\xE9 au client."
      },
      dueDate: {
        label: "Date d\u2019\xE9ch\xE9ance",
        hint: "Facultatif\xA0: sinon, les conditions de paiement du client s\u2019appliquent."
      },
      notes: {
        label: "Notes"
      }
    },
    submit: "Cr\xE9er la facture brouillon",
    submitting: "Cr\xE9ation\u2026",
    created: "La facture brouillon a \xE9t\xE9 cr\xE9\xE9e.",
    readOnlyRights: "Vous pouvez consulter l\u2019avancement, mais pas cr\xE9er de facture.",
    loadFailedTitle: "L\u2019avancement n\u2019a pas pu \xEAtre charg\xE9",
    loadFailedBody: "V\xE9rifiez votre connexion puis r\xE9essayez.",
    blocked: {
      closedTitle: "Contrat clos",
      closedBody: "La facture finale a \xE9t\xE9 \xE9mise\xA0: il n\u2019y a plus de facture de situation \xE0 pr\xE9parer.",
      sharesTitle: "Les parts d\u2019honoraires des phases ne font pas 100 %",
      sharesBody: "Les parts d\u2019honoraires des phases du projet doivent totaliser 100 % pour r\xE9partir le montant du contrat. Elles totalisent aujourd\u2019hui {total}.",
      sharesLink: "Ouvrir les phases du projet"
    },
    summary: {
      caption: "Avancement factur\xE9 par phase",
      total: "Total du contrat (HT)",
      advance: "Avance",
      advanceRecovered: "Avance d\xE9j\xE0 r\xE9cup\xE9r\xE9e",
      retentionHeld: "Retenue de garantie d\xE9j\xE0 op\xE9r\xE9e ({rate})",
      columns: {
        phase: "Phase",
        status: "Statut",
        fee: "Honoraires",
        invoicedBp: "Factur\xE9 (cumul)",
        invoiced: "Montant factur\xE9"
      }
    },
    errors: {
      below: "Au moins {previous}, d\xE9j\xE0 factur\xE9.",
      invalid: "\xC9crivez un pourcentage de 0 \xE0 100, avec au plus 2 d\xE9cimales.",
      failedTitle: "La facture n\u2019a pas pu \xEAtre cr\xE9\xE9e",
      CUMULATIVE_BELOW_PREVIOUS: "Le cumul d\u2019une phase ne peut pas \xEAtre inf\xE9rieur \xE0 l\u2019avancement d\xE9j\xE0 factur\xE9.",
      CUMULATIVE_OUT_OF_RANGE: "Le cumul d\u2019une phase doit \xEAtre compris entre 0 et 100 %.",
      PHASE_SHARES_NOT_100: "Les parts d\u2019honoraires des phases du projet doivent totaliser 100 %. Corrigez-les dans l\u2019onglet Phases du projet.",
      PROGRESS_DRAFT_EXISTS: "Une facture de situation de ce contrat est encore en brouillon. Supprimez-la ou \xE9mettez-la avant d\u2019en cr\xE9er une autre.",
      CONTRACT_CLOSED: "La facture finale de ce contrat a d\xE9j\xE0 \xE9t\xE9 \xE9mise.",
      NOTHING_TO_INVOICE: "Aucune phase n\u2019a avanc\xE9 depuis la derni\xE8re facture\xA0: il n\u2019y a rien \xE0 facturer.",
      CONTRACT_CURRENCY: "Les factures de situation se font en dinars tunisiens.",
      CONTRACT_WITHOUT_PROJECT: "Rattachez d\u2019abord ce contrat \xE0 un projet.",
      PHASE_NOT_IN_PROJECT: "Une phase n\u2019appartient pas au projet de ce contrat. Rechargez la page.",
      FINAL_NEEDS_100: "La facture finale cl\xF4t toutes les phases \xE0 100 %.",
      CONTRACT_TOTAL_INVALID: "Le montant du contrat doit \xEAtre sup\xE9rieur \xE0 z\xE9ro."
    }
  },
  publicQuote: {
    language: "Langue",
    brand: "Proposition de {organization}",
    number: "Devis {number}",
    client: "Pour\xA0: {client}",
    validUntil: "Valable jusqu\u2019au {date}",
    linesTitle: "D\xE9tail des prestations",
    linesCaption: "Prestations du devis",
    description: "Prestation",
    amount: "Montant HT",
    pdf: {
      title: "Document du devis",
      open: "Ouvrir le PDF",
      opening: "Ouverture\u2026",
      preparing: "Le PDF est en cours de pr\xE9paration. R\xE9essayez dans quelques secondes.",
      failed: "Le PDF n\u2019a pas pu \xEAtre ouvert. R\xE9essayez dans un instant."
    },
    accept: {
      title: "Accepter ce devis",
      intro: "Pour accepter, \xE9crivez votre nom complet et cochez la case. Votre acceptation est enregistr\xE9e avec la date, l\u2019heure et le document que vous avez consult\xE9.",
      fullName: {
        label: "Nom et pr\xE9nom",
        hint: "Tel qu\u2019il appara\xEEt sur vos documents officiels."
      },
      fullNameInvalid: "\xC9crivez votre nom complet (au moins 3 caract\xE8res).",
      consent: "J\u2019accepte ce devis et ses conditions, et je confirme avoir le pouvoir d\u2019engager {client}.",
      submit: "Accepter le devis",
      submitting: "Enregistrement\u2026",
      failedTitle: "L\u2019acceptation n\u2019a pas pu \xEAtre enregistr\xE9e"
    },
    confirmation: {
      title: "Merci, le devis est accept\xE9",
      body: "{name} a accept\xE9 le devis {number} le {date}. Le bureau en a \xE9t\xE9 inform\xE9 et vous contactera pour la suite.",
      bodyPast: "Ce devis a \xE9t\xE9 accept\xE9 par {name} le {date}.",
      titlePast: "Ce devis est accept\xE9"
    },
    states: {
      rejectedTitle: "Ce devis a \xE9t\xE9 refus\xE9",
      rejectedBody: "Ce devis n\u2019est plus disponible. Contactez le bureau si vous souhaitez une nouvelle proposition.",
      expiredTitle: "Ce devis n\u2019est plus valable",
      expiredBody: "La date de validit\xE9 est d\xE9pass\xE9e. Demandez une nouvelle proposition au bureau.",
      notFoundTitle: "Ce lien n\u2019est pas valide",
      notFoundBody: "Le lien est incomplet ou n\u2019existe plus. Utilisez le lien de l\u2019e-mail que vous avez re\xE7u, ou contactez le bureau.",
      loadFailedTitle: "Le devis n\u2019a pas pu \xEAtre charg\xE9",
      loadFailedBody: "V\xE9rifiez votre connexion puis r\xE9essayez.",
      loading: "Chargement du devis\u2026"
    }
  },
  invoices: {
    status: {
      draft: "Brouillon",
      issued: "\xC9mise",
      credited: "Annul\xE9e par avoir"
    },
    ttn: {
      not_required: "Non requise",
      pending: "En attente",
      submitted: "Transmise",
      submitted_manually: "Transmise manuellement",
      accepted: "Accept\xE9e",
      rejected: "Rejet\xE9e"
    },
    paymentStatus: {
      unpaid: "Impay\xE9e",
      partially_paid: "Partiellement pay\xE9e",
      paid: "Pay\xE9e"
    },
    kind: {
      advance: "Facture d\u2019avance",
      deposit: "Facture d\u2019acompte",
      progress: "Facture de situation",
      final: "Facture finale",
      credit_note: "Avoir"
    },
    list: {
      caption: "Liste des factures",
      new: "Nouvelle facture",
      draftNumber: "Brouillon",
      columns: {
        number: "Num\xE9ro",
        client: "Client",
        kind: "Type",
        status: "Statut",
        ttn: "E-facture (TTN)",
        payment: "Paiement",
        totalTtc: "Total TTC",
        netPayable: "Net \xE0 payer",
        issueDate: "\xC9mise le",
        dueDate: "\xC9ch\xE9ance"
      },
      filters: {
        label: "Filtres des factures",
        status: "Statut",
        payment: "Paiement",
        kind: "Type",
        allStatuses: "Tous les statuts",
        allPayments: "Tous les paiements",
        allKinds: "Tous les types"
      },
      empty: {
        title: "Aucune facture pour le moment",
        description: "Cr\xE9ez votre premi\xE8re facture\xA0: elle se calcule en direct et re\xE7oit son num\xE9ro d\xE9finitif \xE0 l\u2019\xE9mission.",
        descriptionReadOnly: "Les factures de votre bureau appara\xEEtront ici."
      },
      filtered: {
        title: "Aucune facture ne correspond",
        description: "Aucune facture ne r\xE9pond \xE0 ces filtres. Essayez-en d\u2019autres."
      },
      clearFilters: "Effacer les filtres",
      loadMore: "Afficher plus de factures",
      loadingMore: "Chargement\u2026",
      loadFailedTitle: "Les factures n\u2019ont pas pu \xEAtre charg\xE9es",
      loadFailedBody: "V\xE9rifiez votre connexion puis r\xE9essayez.",
      none: "\u2014"
    },
    editor: {
      newTitle: "Nouvelle facture",
      draftTitle: "Facture en brouillon",
      detailTitle: "Facture {number}",
      creditNoteTitle: "Avoir {number}",
      breadcrumbList: "Factures",
      loadFailedTitle: "Cette facture n\u2019a pas pu \xEAtre charg\xE9e",
      loadFailedBody: "Elle n\u2019existe pas ou vous n\u2019y avez pas acc\xE8s.",
      readOnlyRights: "Vous pouvez consulter cette facture, mais vous n\u2019avez pas le droit de la modifier.",
      readOnlyIssued: "Cette facture est \xE9mise\xA0: elle ne peut plus jamais \xEAtre modifi\xE9e. Pour la corriger, \xE9mettez un avoir.",
      readOnlyCreditNote: "Un avoir \xE9mis est d\xE9finitif\xA0: il ne peut plus \xEAtre modifi\xE9.",
      linesLocked: "Les lignes de ce brouillon viennent du d\xE9compte de situation (avances et retenues). Pour les changer, supprimez le brouillon puis construisez-le de nouveau\xA0; les autres champs restent modifiables."
    },
    sections: {
      general: "Informations g\xE9n\xE9rales",
      lines: "Lignes de la facture",
      attachments: "Pi\xE8ces jointes",
      notes: "Notes",
      history: "Suivi de la facture"
    },
    fields: {
      kind: {
        label: "Type de facture",
        hint: "Avance, acompte, situation de travaux ou facture finale."
      },
      client: {
        label: "Client",
        placeholder: "Choisir un client",
        hint: "Le ma\xEEtre d\u2019ouvrage \xE0 facturer."
      },
      project: {
        label: "Projet",
        none: "Aucun projet",
        current: "Projet actuel",
        hint: "Permet de ranger les lignes par phase."
      },
      series: {
        label: "S\xE9rie de num\xE9rotation",
        hint: "Le num\xE9ro est attribu\xE9 \xE0 l\u2019\xE9mission, sans trou.",
        default: "S\xE9rie par d\xE9faut"
      },
      language: {
        label: "Langue du PDF",
        hint: "La langue de la facture imprim\xE9e.",
        fr: "Fran\xE7ais",
        ar: "Arabe",
        bilingual: "Bilingue (fran\xE7ais et arabe)"
      },
      currency: {
        label: "Devise"
      },
      exchangeRate: {
        label: "Taux de change (TND pour 1 unit\xE9)",
        hint: "Par exemple 3,350 pour 1 EUR. Les totaux sont aussi donn\xE9s en dinars."
      },
      exchangeRateSource: {
        label: "Source du taux",
        hint: "Facultatif : d\u2019o\xF9 vient le taux, imprim\xE9 avec lui sur la facture.",
        placeholder: "Banque Centrale de Tunisie, cours du 30/10/2026"
      },
      vatTreatment: {
        label: "R\xE9gime de TVA",
        hint: "Sans choix, le r\xE9gime du client s\u2019applique.",
        auto: "Selon le client",
        standard: "TVA normale",
        suspended: "TVA en suspension",
        export: "Exportation (exon\xE9r\xE9e)"
      },
      treatmentRef: {
        label: "R\xE9f\xE9rence du r\xE9gime",
        hint: "Obligatoire pour une TVA en suspension\xA0: num\xE9ro de l\u2019attestation ou de la d\xE9cision."
      },
      dueDate: {
        label: "Date d\u2019\xE9ch\xE9ance",
        hint: "Sans date, le d\xE9lai de paiement du client s\u2019applique \xE0 l\u2019\xE9mission."
      },
      notes: {
        label: "Notes sur la facture",
        hint: "Imprim\xE9es sur la facture (conditions, mention particuli\xE8re)."
      },
      issueDate: "Date d\u2019\xE9mission",
      ruleSet: "Bar\xE8me fiscal appliqu\xE9"
    },
    lines: {
      noPhase: "Autres lignes",
      phaseSubtotal: "Sous-total HT {amount}",
      description: "Description",
      phase: "Phase",
      noPhaseOption: "Aucune phase",
      quantity: "Quantit\xE9",
      unitPrice: "Prix unitaire HT",
      vat: "TVA",
      amount: "Montant HT",
      add: "Ajouter une ligne",
      addToPhase: "Ajouter une ligne \xE0 cette phase",
      remove: "Supprimer la ligne {number}",
      lineNumber: "Ligne {number}",
      totalHt: "Total HT des lignes",
      empty: "Aucune ligne pour le moment. Ajoutez une ligne.",
      readOnlyCaption: "Lignes de la facture\xA0: {name}",
      roles: {
        service: "Prestation",
        advance_recovery: "R\xE9cup\xE9ration d\u2019avance",
        retention: "Retenue de garantie",
        retention_release: "Restitution de retenue"
      }
    },
    attachments: {
      none: "Aucune pi\xE8ce jointe.",
      list: "Pi\xE8ces jointes",
      remove: "Retirer {title}",
      search: "Rechercher un document \xE0 joindre",
      searchHint: "Tapez au moins 2 caract\xE8res du titre ou du code, par exemple un proc\xE8s-verbal de r\xE9ception. Les pi\xE8ces jointes sont conserv\xE9es avec la facture."
    },
    hints: {
      title: "Pour \xE9mettre cette facture, il reste \xE0 compl\xE9ter",
      body: "Ces mentions sont obligatoires sur une facture."
    },
    issue: {
      title: "\xC9mettre cette facture\xA0?",
      totals: "Total TTC {ttc}, net \xE0 payer {net}.",
      never: "Une facture \xE9mise ne peut jamais \xEAtre modifi\xE9e\xA0: elle re\xE7oit son num\xE9ro d\xE9finitif et ses montants sont fig\xE9s. En cas d\u2019erreur, vous \xE9mettrez un avoir.",
      identity: "Vous devrez confirmer votre identit\xE9 pour terminer.",
      confirm: "\xC9mettre la facture",
      done: "La facture {number} a \xE9t\xE9 \xE9mise.",
      changedTitle: "Les montants ont chang\xE9",
      changedBody: "Le bar\xE8me fiscal ou le client a chang\xE9 depuis le dernier calcul\xA0: le brouillon affiche maintenant les nouveaux totaux. V\xE9rifiez-les puis \xE9mettez de nouveau la facture.",
      changedDismiss: "Compris",
      mentionsTitle: "Mentions obligatoires manquantes",
      mentionsBody: "La facture ne peut pas \xEAtre \xE9mise tant que ces mentions manquent\xA0:",
      failedTitle: "La facture n\u2019a pas pu \xEAtre \xE9mise"
    },
    creditNote: {
      title: "Avoir sur la facture {number}",
      intro: "Un avoir annule tout ou partie de la facture sans la modifier. Il est \xE9mis tout de suite, avec son propre num\xE9ro.",
      mode: "\xC9tendue de l\u2019avoir",
      full: "Annuler la facture enti\xE8re (timbre compris)",
      byLines: "Cr\xE9diter certaines lignes",
      fullHint: "L\u2019avoir porte sur le total TTC de {amount}.",
      linesLabel: "Lignes \xE0 cr\xE9diter",
      quantityOf: "Quantit\xE9 \xE0 cr\xE9diter pour {description}",
      reason: "Motif de l\u2019avoir",
      reasonRequired: "Indiquez le motif de l\u2019avoir.",
      pickLines: "Choisissez au moins une ligne \xE0 cr\xE9diter.",
      cancel: "Annuler",
      issue: "\xC9mettre l\u2019avoir",
      issuing: "\xC9mission\u2026",
      done: "L\u2019avoir {number} a \xE9t\xE9 \xE9mis."
    },
    errors: {
      clientRequired: "Choisissez un client.",
      rateRequired: "Indiquez le taux de change.",
      rateInvalid: "\xC9crivez un taux positif avec au plus 6 d\xE9cimales, par exemple 3,350.",
      linesRequired: "Ajoutez au moins une ligne \xE0 la facture.",
      descriptionRequired: "D\xE9crivez cette ligne.",
      priceRequired: "Indiquez le prix unitaire.",
      quantityInvalid: "\xC9crivez une quantit\xE9 positive avec au plus 3 d\xE9cimales.",
      staleTitle: "Quelqu\u2019un a modifi\xE9 cette facture",
      staleBody: "Une autre personne a enregistr\xE9 ce brouillon pendant que vous le modifiiez. Rechargez-le pour voir sa derni\xE8re version, puis appliquez de nouveau vos changements.",
      reload: "Recharger la facture",
      saveFailed: "La facture n\u2019a pas pu \xEAtre enregistr\xE9e"
    },
    totals: {
      needClient: "Choisissez un client pour calculer les totaux (TVA, timbre, retenues).",
      needRate: "Indiquez le taux de change pour calculer les totaux.",
      needLines: "Compl\xE9tez les lignes (quantit\xE9 et prix) pour calculer les totaux.",
      noRight: "Les totaux d\xE9taill\xE9s ne sont pas disponibles avec vos droits. Le total HT des lignes reste exact.",
      indicative: "Totaux indicatifs\xA0: ils sont recalcul\xE9s \xE0 l\u2019\xE9mission avec le bar\xE8me fiscal en vigueur ce jour-l\xE0."
    },
    actions: {
      label: "Actions sur la facture",
      issue: "\xC9mettre",
      pdf: "Voir le PDF",
      pdfOpening: "Ouverture du PDF\u2026",
      pdfPreparing: "Le PDF est en cours de pr\xE9paration. R\xE9essayez dans un instant.",
      pdfFailed: "Le PDF n\u2019a pas pu \xEAtre ouvert. R\xE9essayez dans un instant.",
      recordPayment: "Enregistrer un paiement",
      creditNote: "\xC9mettre un avoir",
      delete: "Supprimer le brouillon",
      saveFirst: "Enregistrez d\u2019abord vos modifications pour utiliser ces actions."
    },
    remove: {
      title: "Supprimer {number}\xA0?",
      body: "Ce brouillon sera supprim\xE9 d\xE9finitivement. Aucun num\xE9ro n\u2019a \xE9t\xE9 consomm\xE9.",
      confirm: "Supprimer le brouillon",
      done: "Le brouillon a \xE9t\xE9 supprim\xE9."
    },
    save: {
      action: "Enregistrer",
      saving: "Enregistrement\u2026",
      created: "Le brouillon de facture a \xE9t\xE9 cr\xE9\xE9.",
      saved: "Le brouillon de facture a \xE9t\xE9 enregistr\xE9."
    },
    guard: {
      title: "Quitter sans enregistrer\xA0?",
      body: "Vos modifications de cette facture seront perdues.",
      leave: "Quitter",
      stay: "Rester sur la facture"
    },
    history: {
      statuses: "\xC9tats de la facture",
      invoice: "Facture",
      ttn: "E-facture (TTN)",
      payment: "Paiement",
      createdBy: "Cr\xE9\xE9e le {date} par {name}",
      issued: "\xC9mise sous le num\xE9ro {number} le {date} par {name}",
      notIssued: "Cette facture n\u2019est pas encore \xE9mise\xA0: elle n\u2019a pas de num\xE9ro.",
      legalHold: "Conserv\xE9e \xE0 titre l\xE9gal jusqu\u2019au {date}",
      creditOf: "Avoir sur la facture",
      credited: "D\xE9j\xE0 cr\xE9dit\xE9 par des avoirs\xA0: {amount}",
      pdfReady: "PDF pr\xEAt",
      pdfNotReady: "PDF en pr\xE9paration",
      paymentLine: "Paiement du {date} ({method})\xA0: {amount}",
      paymentLineWithheld: "Paiement du {date} ({method})\xA0: {amount}, plus {withheld} retenus par le client",
      noPayment: "Aucun paiement enregistr\xE9."
    },
    mentions: {
      fiscalProfile: "Le profil fiscal de votre bureau n\u2019est pas renseign\xE9.",
      seller_name: "Le nom l\xE9gal de votre bureau manque.",
      seller_address: "L\u2019adresse de votre bureau manque.",
      seller_taxId: "L\u2019identifiant fiscal de votre bureau manque.",
      seller_taxId_invalid: "L\u2019identifiant fiscal de votre bureau n\u2019est pas valide.",
      client_name: "Le nom du client manque.",
      client_address: "L\u2019adresse du client manque.",
      client_taxId: "L\u2019identifiant fiscal du client manque (obligatoire pour une soci\xE9t\xE9 ou un organisme public).",
      client_taxId_invalid: "L\u2019identifiant fiscal du client n\u2019est pas valide.",
      lines: "La facture n\u2019a aucune ligne.",
      lines_description: "La ligne {number} n\u2019a pas de description.",
      lines_unitPriceMinor: "La ligne {number} n\u2019a pas de prix unitaire.",
      lines_quantityMilli: "La quantit\xE9 de la ligne {number} n\u2019est pas valide.",
      treatmentRef: "La r\xE9f\xE9rence du r\xE9gime de TVA (attestation de suspension) manque.",
      issueDate: "La date d\u2019\xE9mission manque.",
      number: "Le num\xE9ro de la facture n\u2019est pas valide.",
      creditedInvoiceNumber: "La facture d\u2019origine de l\u2019avoir manque.",
      computation: "Les totaux ne sont pas calcul\xE9s.",
      computation_amountInWords: "Le montant en lettres n\u2019a pas pu \xEAtre \xE9tabli.",
      unknown: "Une mention obligatoire manque ({path}).",
      fixFiscal: "Compl\xE9ter le profil fiscal",
      fixClient: "Ouvrir la fiche du client"
    }
  },
  documents: {
    results: "R\xE9sultats de la recherche",
    add: "Ajouter {title}",
    addShort: "Ajouter",
    noResult: "Aucun document trouv\xE9.",
    searchFailed: "La recherche n\u2019a pas abouti. R\xE9essayez."
  },
  payments: {
    list: {
      title: "Paiements re\xE7us",
      caption: "Liste des paiements re\xE7us",
      columns: {
        receivedOn: "Re\xE7u le",
        invoice: "Facture",
        client: "Client",
        method: "Mode",
        amount: "Montant re\xE7u",
        withholding: "RAS",
        vatWithholding: "RAS TVA",
        certificate: "Certificat de retenue",
        reference: "R\xE9f\xE9rence"
      },
      certificate: {
        received: "Re\xE7u",
        missing: "Manquant",
        notNeeded: "Sans objet",
        add: "Ajouter"
      },
      empty: {
        title: "Aucun paiement pour le moment",
        description: "Les paiements s\u2019enregistrent depuis une facture \xE9mise\xA0: ouvrez-la puis choisissez \xAB\xA0Enregistrer un paiement\xA0\xBB."
      },
      loadMore: "Afficher plus de paiements",
      loadingMore: "Chargement\u2026",
      loadFailedTitle: "Les paiements n\u2019ont pas pu \xEAtre charg\xE9s",
      loadFailedBody: "V\xE9rifiez votre connexion puis r\xE9essayez.",
      none: "\u2014"
    },
    method: {
      transfer: "Virement",
      cheque: "Ch\xE8que",
      bill: "Effet de commerce",
      cash: "Esp\xE8ces",
      online: "Paiement en ligne"
    },
    fields: {
      receivedOn: "Date de r\xE9ception",
      method: "Mode de paiement",
      amount: "Montant re\xE7u",
      amountHint: "Le montant r\xE9ellement encaiss\xE9, net des retenues.",
      withholding: "Retenue \xE0 la source (RAS)",
      withholdingHint: "Propos\xE9e d\u2019apr\xE8s la facture\xA0: retenue pr\xE9lev\xE9e par le client.",
      withholdingNone: "Aucune retenue n\u2019est pr\xE9vue sur cette facture.",
      vatWithholding: "RAS sur la TVA",
      vatWithholdingHint: "Retenue de TVA pr\xE9lev\xE9e par le client (organismes publics).",
      chequeNumber: "Num\xE9ro du ch\xE8que",
      chequeBank: "Banque",
      chequeValidUntil: "Ch\xE8que valable jusqu\u2019au",
      chequeValidUntilHint: "Sans date, la validit\xE9 du bar\xE8me fiscal s\u2019applique (6 mois).",
      reference: "R\xE9f\xE9rence du paiement",
      referenceHint: "Num\xE9ro de virement, de remise\u2026 (facultatif).",
      tejReference: "R\xE9f\xE9rence TEJ du certificat de retenue",
      tejReferenceHint: "Facultatif\xA0: vous pourrez l\u2019ajouter plus tard.",
      certificateDocument: "Certificat de retenue (document)",
      certificateDocumentHint: "Facultatif\xA0: recherchez le scan d\xE9pos\xE9 dans les documents.",
      certificateChosen: "Document choisi\xA0:",
      certificateRemove: "Retirer le document"
    },
    dialog: {
      title: "Enregistrer un paiement sur {number}",
      outstanding: "Reste d\xFB avant ce paiement\xA0: {amount}.",
      settles: "Ce paiement r\xE8gle {settled} (esp\xE8ces et retenues). Reste d\xFB apr\xE8s\xA0: {after}.",
      cancel: "Annuler",
      save: "Enregistrer le paiement",
      saving: "Enregistrement\u2026",
      doneTitle: "Paiement enregistr\xE9",
      doneBody: "Il reste {outstanding} \xE0 encaisser.",
      status: {
        unpaid: "La facture est impay\xE9e.",
        partially_paid: "La facture est partiellement pay\xE9e.",
        paid: "La facture est pay\xE9e."
      },
      close: "Fermer"
    },
    errors: {
      dateRequired: "Indiquez la date de r\xE9ception.",
      dateInFuture: "La date de r\xE9ception ne peut pas \xEAtre dans le futur.",
      nothingReceived: "Indiquez au moins un montant re\xE7u ou retenu.",
      overpayment: "Ce paiement d\xE9passe le montant restant d\xFB. R\xE9duisez les montants.",
      overpaymentServer: "Ce paiement d\xE9passe le montant restant d\xFB. Le reste d\xFB a \xE9t\xE9 actualis\xE9\xA0: v\xE9rifiez les montants puis r\xE9essayez.",
      chequeLimit: "Ce montant d\xE9passe le plafond l\xE9gal du paiement par ch\xE8que. Choisissez un autre mode ou fractionnez le paiement.",
      chequeNumber: "Indiquez le num\xE9ro du ch\xE8que.",
      chequeBank: "Indiquez la banque du ch\xE8que."
    },
    warnings: {
      cash_not_deductible: "Un paiement en esp\xE8ces de ce montant n\u2019est pas d\xE9ductible fiscalement pour votre client (seuil du bar\xE8me fiscal).",
      cheque_expires_soon: "Ce ch\xE8que arrive bient\xF4t \xE0 expiration\xA0: pr\xE9sentez-le rapidement \xE0 la banque."
    },
    certificate: {
      title: "Certificat de retenue pour {number}",
      needOne: "Indiquez la r\xE9f\xE9rence TEJ ou choisissez le document.",
      save: "Enregistrer le certificat",
      done: "Le certificat de retenue a \xE9t\xE9 enregistr\xE9."
    },
    aging: {
      title: "Balance \xE2g\xE9e des cr\xE9ances",
      hint: "Ce que vos clients vous doivent encore, selon le retard sur l\u2019\xE9ch\xE9ance.",
      asOf: "Situation au {date} (montants en dinars).",
      caption: "Balance \xE2g\xE9e des cr\xE9ances par client",
      empty: "Aucune cr\xE9ance en cours.",
      loadFailed: "La balance \xE2g\xE9e n\u2019a pas pu \xEAtre charg\xE9e.",
      total: "Total",
      columns: {
        client: "Client",
        invoices: "Factures",
        current: "Non \xE9chu",
        d0_30: "0 \xE0 30 jours",
        d31_60: "31 \xE0 60 jours",
        d61_90: "61 \xE0 90 jours",
        over90: "Plus de 90 jours",
        total: "Total d\xFB"
      }
    },
    reminders: {
      title: "Relances des clients",
      hint: "Un e-mail de relance est envoy\xE9 au client en cas de retard de paiement, aux jours choisis apr\xE8s l\u2019\xE9ch\xE9ance.",
      enabled: "Envoyer des relances automatiques",
      days: "Jours de relance apr\xE8s l\u2019\xE9ch\xE9ance",
      daysHint: "Jusqu\u2019\xE0 5 jours, du plus petit au plus grand, s\xE9par\xE9s par des virgules (par exemple 7, 15, 30).",
      save: "Enregistrer les relances",
      saving: "Enregistrement\u2026",
      saved: "Les param\xE8tres de relance ont \xE9t\xE9 enregistr\xE9s.",
      readOnly: "Seul un administrateur peut modifier ces param\xE8tres.",
      stale: "Quelqu\u2019un a modifi\xE9 ces param\xE8tres. Rechargez-les puis recommencez.",
      reload: "Recharger",
      loadFailed: "Les param\xE8tres de relance n\u2019ont pas pu \xEAtre charg\xE9s.",
      loading: "Chargement des param\xE8tres\u2026",
      errors: {
        invalid: "\xC9crivez des nombres de jours entiers entre 1 et 365, s\xE9par\xE9s par des virgules.",
        order: "\xC9crivez les jours du plus petit au plus grand, sans doublon.",
        many: "Cinq jours de relance au maximum."
      }
    }
  },
  expenses: {
    tabs: {
      label: "Navigation des notes de frais",
      mine: "Mes notes de frais",
      approvals: "\xC0 approuver"
    },
    category: {
      transport: "Transport",
      fuel: "Carburant",
      accommodation: "H\xE9bergement",
      meals: "Restauration",
      supplies: "Fournitures",
      printing: "Impression et reprographie",
      software: "Logiciels et abonnements",
      telecom: "T\xE9l\xE9communications",
      training: "Formation",
      permit_fees: "Frais de permis et redevances",
      other: "Autre"
    },
    status: {
      submitted: "En attente",
      approved: "Approuv\xE9e",
      rejected: "Refus\xE9e",
      reimbursed: "Rembours\xE9e"
    },
    mine: {
      title: "Mes notes de frais",
      listLabel: "Liste de mes notes de frais",
      new: "Nouvelle note de frais",
      resubmit: "Soumettre \xE0 nouveau",
      filters: {
        label: "Filtres",
        status: "Statut",
        all: "Tous les statuts"
      },
      empty: {
        title: "Aucune note de frais",
        description: "Photographiez votre justificatif puis d\xE9clarez la d\xE9pense\xA0: un approbateur la validera avant son remboursement."
      },
      filtered: {
        title: "Aucune note de frais avec ce statut",
        description: "Choisissez un autre statut pour voir vos notes de frais.",
        clear: "Afficher toutes mes notes de frais"
      },
      loadFailedTitle: "Vos notes de frais n\u2019ont pas pu \xEAtre charg\xE9es",
      loadFailedBody: "V\xE9rifiez votre connexion puis r\xE9essayez.",
      loadMore: "Afficher plus de notes de frais",
      loadingMore: "Chargement\u2026",
      submitted: "Votre note de frais a \xE9t\xE9 envoy\xE9e \xE0 vos approbateurs.",
      dismiss: "Fermer ce message"
    },
    card: {
      total: "Total TTC",
      amounts: "HT {ht}, TVA {vat}",
      vatDeductible: "TVA d\xE9ductible",
      vatNotDeductible: "TVA non d\xE9ductible",
      spentOn: "D\xE9pense du {date}",
      submittedBy: "D\xE9clar\xE9e par {name}",
      noProject: "Sans projet",
      receiptOpen: "Voir le justificatif",
      receiptOpening: "Ouverture\u2026",
      receiptChecking: "Justificatif en cours de v\xE9rification",
      receiptOpenFailed: "Le justificatif n\u2019a pas pu \xEAtre ouvert. R\xE9essayez dans un instant.",
      decision: {
        approved: "Approuv\xE9e par {name} le {date}",
        rejected: "Refus\xE9e par {name} le {date}",
        reason: "Motif\xA0: {reason}",
        reimbursed: "Rembours\xE9e le {date}"
      }
    },
    form: {
      title: "Nouvelle note de frais",
      resubmitTitle: "Soumettre \xE0 nouveau la note de frais",
      intro: "Joignez le justificatif (photo ou PDF), puis renseignez la d\xE9pense.",
      resubmitIntro: "La note a \xE9t\xE9 refus\xE9e. Le justificatif d\u2019origine est conserv\xE9\xA0: corrigez ce qui doit l\u2019\xEAtre puis renvoyez-la.",
      receipt: {
        legend: "Justificatif",
        help: "Une photo nette du ticket ou de la facture, ou un PDF. Votre approbateur pourra l\u2019ouvrir une fois la v\xE9rification antivirus termin\xE9e.",
        takePhoto: "Prendre une photo",
        chooseFile: "Choisir un fichier",
        preparing: "Pr\xE9paration de l\u2019envoi\u2026",
        kept: "Justificatif conserv\xE9\xA0: {name}",
        keptNoName: "Le justificatif de la note refus\xE9e est conserv\xE9.",
        change: "Changer de justificatif",
        required: "Joignez le justificatif de la d\xE9pense.",
        pending: "Attendez la fin de l\u2019envoi du justificatif.",
        refused: "Ce justificatif n\u2019a pas \xE9t\xE9 accept\xE9. Choisissez un autre fichier.",
        folderFailed: "Votre dossier de justificatifs n\u2019a pas pu \xEAtre pr\xE9par\xE9. R\xE9essayez dans un instant."
      },
      fields: {
        category: "Cat\xE9gorie",
        categoryPlaceholder: "Choisir une cat\xE9gorie",
        label: "Objet de la d\xE9pense",
        labelHint: "Par exemple\xA0: p\xE9age autoroute, achat de toner.",
        spentOn: "Date de la d\xE9pense",
        project: "Projet",
        projectHint: "Facultatif\xA0: seuls vos projets sont propos\xE9s.",
        noProject: "Aucun projet",
        vatRate: "Taux de TVA",
        ttc: "Total TTC",
        ttcHint: "Le montant total pay\xE9, tel qu\u2019il figure sur le justificatif.",
        ht: "Montant HT",
        vat: "TVA",
        vatHint: "Calcul\xE9e avec le taux choisi\xA0: corrigez-la si le justificatif indique autre chose.",
        vatDeductible: "La TVA de ce justificatif est d\xE9ductible"
      },
      amounts: {
        legend: "Montants",
        summary: "HT {ht} + TVA {vat} = TTC {ttc}"
      },
      errors: {
        category: "Choisissez une cat\xE9gorie.",
        label: "Indiquez l\u2019objet de la d\xE9pense.",
        spentOn: "Indiquez la date de la d\xE9pense.",
        spentInFuture: "La date de la d\xE9pense ne peut pas \xEAtre dans le futur.",
        ttc: "Indiquez le total TTC, sup\xE9rieur \xE0 z\xE9ro.",
        vatTooHigh: "La TVA ne peut pas d\xE9passer le total TTC.",
        mismatch: "Le montant HT plus la TVA doit \xEAtre \xE9gal au total TTC.",
        RECEIPT_NOT_FOUND: "Ce justificatif est introuvable. Joignez-le de nouveau puis renvoyez la note.",
        RECEIPT_TYPE_NOT_ALLOWED: "Le justificatif doit \xEAtre une image ou un PDF.",
        RECEIPT_REJECTED: "Ce justificatif a \xE9t\xE9 refus\xE9 par la v\xE9rification antivirus. Choisissez un autre fichier.",
        RECEIPT_ALREADY_USED: "Ce justificatif est d\xE9j\xE0 utilis\xE9 par une autre note de frais.",
        PROJECT_NOT_FOUND: "Ce projet n\u2019existe pas ou vous n\u2019en faites pas partie.",
        notAllowed: "Votre dossier de justificatifs n\u2019est pas accessible pour le moment."
      },
      submit: "Envoyer la note de frais",
      submitting: "Envoi\u2026",
      cancel: "Annuler"
    },
    approvals: {
      title: "Notes de frais \xE0 traiter",
      listLabel: "Liste des notes de frais",
      hint: "Approuvez ou refusez les notes de frais en attente, puis marquez-les comme rembours\xE9es une fois le paiement effectu\xE9.",
      scopeProjects: "Vous voyez les notes de frais de vos projets.",
      filters: {
        label: "Filtres",
        status: "Statut",
        all: "Tous les statuts"
      },
      empty: {
        title: "Aucune note de frais \xE0 traiter",
        description: "Les notes de frais d\xE9clar\xE9es par votre \xE9quipe appara\xEEtront ici."
      },
      filtered: {
        title: "Aucune note de frais avec ce statut",
        description: "Choisissez un autre statut pour voir les notes de frais.",
        clear: "Afficher tous les statuts"
      },
      loadFailedTitle: "Les notes de frais n\u2019ont pas pu \xEAtre charg\xE9es",
      loadFailedBody: "V\xE9rifiez votre connexion puis r\xE9essayez.",
      loadMore: "Afficher plus de notes de frais",
      loadingMore: "Chargement\u2026",
      approve: "Approuver",
      reject: "Refuser",
      reimbursed: "Marquer comme rembours\xE9e",
      busy: "Traitement\u2026",
      ownHint: "Vous ne pouvez pas d\xE9cider de votre propre note de frais\xA0: un autre approbateur doit s\u2019en charger.",
      staleHint: "Cette note de frais a chang\xE9. La liste a \xE9t\xE9 actualis\xE9e\xA0: v\xE9rifiez-la puis r\xE9essayez.",
      done: {
        approved: "La note de frais \xAB\xA0{label}\xA0\xBB est approuv\xE9e.",
        rejected: "La note de frais \xAB\xA0{label}\xA0\xBB est refus\xE9e\xA0: {name} en est inform\xE9.",
        reimbursed: "La note de frais \xAB\xA0{label}\xA0\xBB est marqu\xE9e comme rembours\xE9e."
      },
      rejectDialog: {
        title: "Refuser la note de frais \xAB\xA0{label}\xA0\xBB",
        body: "Le motif est communiqu\xE9 \xE0 {name}, qui pourra corriger la note et la soumettre \xE0 nouveau.",
        reason: "Motif du refus",
        reasonHint: "500 caract\xE8res au maximum.",
        reasonRequired: "Indiquez le motif du refus.",
        confirm: "Refuser la note de frais",
        cancel: "Annuler"
      },
      reimburseDialog: {
        title: "Marquer \xAB\xA0{label}\xA0\xBB comme rembours\xE9e",
        body: "Confirmez-vous que {amount} a \xE9t\xE9 rembours\xE9 \xE0 {name}\xA0? Cette action est d\xE9finitive.",
        confirm: "Confirmer le remboursement",
        cancel: "Annuler"
      }
    }
  },
  dashboard: {
    title: "Chiffres cl\xE9s",
    asOf: "Situation au {date}. Montants en dinars tunisiens (TND)\xA0; les factures en devises ne sont pas compt\xE9es.",
    scopeProjects: "Ces chiffres couvrent uniquement les factures de vos projets.",
    loadFailedTitle: "Le tableau de bord n\u2019a pas pu \xEAtre charg\xE9",
    loadFailedBody: "V\xE9rifiez votre connexion puis r\xE9essayez.",
    kpi: {
      groupLabel: "Indicateurs cl\xE9s",
      monthInvoiced: {
        label: "Factur\xE9 ce mois-ci",
        detail: "{ht} HT, TVA {vat}"
      },
      monthCollected: {
        label: "Encaiss\xE9 ce mois-ci",
        detail: "Retenues appliqu\xE9es par vos clients\xA0: {amount}"
      },
      yearInvoiced: {
        label: "Factur\xE9 en {year}",
        detail: "{ht} HT"
      },
      yearCollected: {
        label: "Encaiss\xE9 en {year}",
        detail: "Retenues appliqu\xE9es par vos clients\xA0: {amount}"
      },
      outstanding: {
        label: "Restant d\xFB par les clients",
        detail: "{count, plural, =0 {Aucune facture en attente} one {# facture en attente} other {# factures en attente}}"
      },
      overdue: {
        label: "Dont en retard",
        detail: "{count, plural, =0 {Aucune facture en retard} one {# facture en retard} other {# factures en retard}}",
        flag: "\xC0 relancer",
        none: "\xC0 jour"
      },
      withholdings: {
        label: "Retenues \xE0 r\xE9cup\xE9rer",
        detail: "{count, plural, =0 {Aucun certificat de retenue manquant} one {# paiement sans certificat de retenue} other {# paiements sans certificat de retenue}}"
      },
      vat: {
        label: "TVA factur\xE9e ce mois-ci",
        detail: "Sur les factures \xE9mises en {month}"
      }
    },
    chart: {
      title: "Factur\xE9 et encaiss\xE9 sur 12 mois",
      description: "Montants TTC factur\xE9s et sommes encaiss\xE9es, mois par mois.",
      ariaLabel: "Histogramme du factur\xE9 et de l\u2019encaiss\xE9 de {from} \xE0 {to}. Les montants exacts figurent dans le tableau des donn\xE9es.",
      invoiced: "Factur\xE9 (TTC)",
      collected: "Encaiss\xE9",
      axisUnit: "Montants en TND",
      tickThousand: "{value} k",
      tickMillion: "{value} M",
      tooltipTitle: "{month}"
    },
    table: {
      show: "Voir les donn\xE9es",
      hide: "Masquer les donn\xE9es",
      caption: "Factur\xE9 et encaiss\xE9 par mois, en TND",
      month: "Mois",
      invoiced: "Factur\xE9 (TTC)",
      collected: "Encaiss\xE9",
      total: "Total sur 12 mois"
    }
  },
  einvoicing: {
    chip: {
      details: "D\xE9tails de l\u2019envoi \xE0 TTN",
      attempt: "Tentative n\xB0 {n}\xA0: {status}, le {date}."
    },
    kind: {
      seal: "Cachet \xE9lectronique",
      test: "Certificat de test",
      digigo: "DigiGO (signature \xE0 distance)"
    },
    panel: {
      title: "Facture \xE9lectronique (El Fatoora)",
      loading: "Chargement du suivi El Fatoora\u2026",
      loadFailed: "Le suivi de la facture \xE9lectronique n\u2019a pas pu \xEAtre charg\xE9.",
      noAttempt: "Aucun envoi \xE0 TTN pour le moment.",
      attempts: "Envois \xE0 TTN",
      attempt: "Tentative n\xB0 {n}",
      status: {
        awaiting_signature: "En attente de signature",
        signed: "Sign\xE9e",
        submitted: "Envoy\xE9e \xE0 TTN",
        accepted: "Accept\xE9e",
        rejected: "Rejet\xE9e",
        failed: "\xC9chec",
        manual: "D\xE9pos\xE9e manuellement"
      },
      dates: "Cr\xE9\xE9e le {created}, derni\xE8re \xE9tape le {last}.",
      requestedBy: "Demand\xE9e par {name}.",
      reference: "R\xE9f\xE9rence TTN\xA0: {reference}",
      manualReference: "R\xE9f\xE9rence saisie \xE0 la main\xA0: {reference}",
      rejection: {
        reason: "Motif donn\xE9 par TTN\xA0: \xAB\xA0{reason}\xA0\xBB (code {code}).",
        kind: {
          technical: "Rejet technique (signature ou format du fichier).",
          content: "Rejet de contenu (les informations de la facture)."
        }
      },
      failure: {
        detail: "D\xE9tail technique\xA0: {detail}",
        NO_CREDENTIAL: "Aucun certificat de signature n\u2019est actif\xA0: la facture n\u2019a pas pu \xEAtre sign\xE9e.",
        CREDENTIAL_EXPIRED: "Le certificat de signature a expir\xE9\xA0: la facture n\u2019a pas pu \xEAtre sign\xE9e.",
        TEIF_INVALID: "Le fichier TEIF g\xE9n\xE9r\xE9 n\u2019est pas valide\xA0: la facture n\u2019a pas \xE9t\xE9 envoy\xE9e.",
        SIGNING_FAILED: "La signature de la facture a \xE9chou\xE9.",
        TTN_UNREACHABLE: "Le service de TTN est injoignable pour le moment.",
        TTN_REFUSED: "TTN a refus\xE9 l\u2019envoi du fichier.",
        TTN_NO_ANSWER: "TTN n\u2019a pas r\xE9pondu dans le d\xE9lai pr\xE9vu."
      },
      manageCredentials: "G\xE9rer les certificats de signature",
      wait: {
        title: "En cours de traitement par TTN",
        body: "Aucune action n\u2019est n\xE9cessaire\xA0: cette page se met \xE0 jour toute seule d\xE8s que TTN r\xE9pond."
      },
      resubmit: {
        rejectedTitle: "TTN a rejet\xE9 la facture",
        failedTitle: "L\u2019envoi \xE0 TTN a \xE9chou\xE9",
        body: "Corrigez la cause du probl\xE8me, puis renvoyez la facture\xA0: le m\xEAme num\xE9ro est envoy\xE9 de nouveau, la facture elle-m\xEAme n\u2019est pas modifi\xE9e.",
        action: "Corriger puis renvoyer",
        sending: "Envoi en cours\u2026",
        done: "La facture a \xE9t\xE9 renvoy\xE9e \xE0 TTN avec le m\xEAme num\xE9ro."
      },
      creditNote: {
        title: "TTN refuse le contenu de la facture",
        body: "Une facture \xE9mise ne peut plus \xEAtre modifi\xE9e\xA0: son num\xE9ro ne peut pas \xEAtre r\xE9utilis\xE9 avec un contenu corrig\xE9.",
        steps: "\xC9mettez d\u2019abord un avoir qui annule cette facture, puis cr\xE9ez une nouvelle facture avec les informations corrig\xE9es.",
        action: "\xC9mettre un avoir"
      },
      accepted: {
        title: "Facture accept\xE9e par TTN",
        pdf: "Le PDF de la facture porte maintenant la r\xE9f\xE9rence TTN et le code QR."
      },
      manualDone: {
        title: "Facture d\xE9pos\xE9e manuellement sur le portail TTN"
      },
      awaitingSignature: {
        title: "En attente de votre signature DigiGO",
        body: "Cette facture est pr\xEAte\xA0: elle partira vers TTN d\xE8s que le lot de factures sera sign\xE9 avec DigiGO.",
        link: "Signer le lot sur la page Facture \xE9lectronique"
      }
    },
    manual: {
      title: "Envoi automatique impossible\xA0: d\xE9p\xF4t manuel",
      intro: "En attendant, vous pouvez d\xE9poser la facture vous-m\xEAme sur le portail de TTN.",
      step1: "T\xE9l\xE9chargez le fichier TEIF de la facture.",
      step2: "D\xE9posez-le sur le portail El Fatoora de TTN.",
      step3: "Notez ci-dessous la r\xE9f\xE9rence que TTN vous donne.",
      download: "T\xE9l\xE9charger le TEIF",
      preparing: "Pr\xE9paration du fichier\u2026",
      signed: "Le fichier est sign\xE9 avec le certificat de votre bureau.",
      unsigned: "Le fichier n\u2019est pas sign\xE9\xA0: aucun certificat n\u2019a pu \xEAtre utilis\xE9, le portail de TTN le signera au d\xE9p\xF4t.",
      reference: "R\xE9f\xE9rence TTN",
      referenceHint: "De 3 \xE0 100 caract\xE8res\xA0: lettres, chiffres, espaces et . _ / -",
      save: "Enregistrer la r\xE9f\xE9rence",
      saving: "Enregistrement\u2026",
      done: "La r\xE9f\xE9rence TTN a \xE9t\xE9 enregistr\xE9e.",
      errors: {
        required: "Saisissez la r\xE9f\xE9rence donn\xE9e par TTN.",
        tooShort: "La r\xE9f\xE9rence doit comporter au moins 3 caract\xE8res.",
        format: "Utilisez seulement des lettres, des chiffres, des espaces et . _ / - (100 caract\xE8res au maximum)."
      }
    },
    mode: {
      title: "Mode de facturation \xE9lectronique",
      hint: "Choisissez si les factures \xE9mises par votre bureau sont envoy\xE9es \xE0 TTN (El Fatoora). Une confirmation d\u2019identit\xE9 est demand\xE9e pour enregistrer le changement.",
      label: "Mode",
      options: {
        required: {
          name: "Obligatoire",
          help: "Chaque facture \xE9mise est sign\xE9e puis envoy\xE9e \xE0 TTN. \xC0 choisir si la loi ou vos clients l\u2019exigent."
        },
        optional: {
          name: "Facultative",
          help: "Les factures sont envoy\xE9es \xE0 TTN lorsque votre bureau a un certificat de signature actif\xA0; sans certificat, elles sont \xE9mises sans envoi."
        },
        disabled: {
          name: "D\xE9sactiv\xE9e",
          help: "Aucune facture n\u2019est envoy\xE9e \xE0 TTN. Les factures d\xE9j\xE0 envoy\xE9es gardent leur statut."
        }
      },
      save: "Enregistrer le mode",
      saving: "Enregistrement\u2026",
      saved: "Le mode de facturation \xE9lectronique a \xE9t\xE9 enregistr\xE9.",
      stale: "Quelqu\u2019un a modifi\xE9 ce r\xE9glage. Rechargez-le puis recommencez.",
      reload: "Recharger",
      loadFailed: "Le r\xE9glage n\u2019a pas pu \xEAtre charg\xE9.",
      loading: "Chargement du r\xE9glage\u2026"
    },
    credentials: {
      title: "Certificats de signature",
      hint: "Les factures sont sign\xE9es avec le certificat actif de votre bureau avant d\u2019\xEAtre envoy\xE9es \xE0 TTN. La cl\xE9 priv\xE9e n\u2019est jamais affich\xE9e ni t\xE9l\xE9chargeable.",
      add: "Ajouter un certificat",
      list: "Certificats de signature",
      loading: "Chargement des certificats\u2026",
      loadFailed: "Les certificats n\u2019ont pas pu \xEAtre charg\xE9s.",
      empty: {
        title: "Aucun certificat\xA0: les factures ne peuvent pas \xEAtre sign\xE9es",
        description: "Ajoutez le certificat de cachet \xE9lectronique de votre bureau pour pouvoir envoyer vos factures \xE0 TTN."
      },
      state: {
        active: "Actif",
        expired: "Expir\xE9",
        replaced: "Remplac\xE9",
        revoked: "R\xE9voqu\xE9"
      },
      expiringSoon: "Expire bient\xF4t",
      expiringTitle: "Votre certificat actif expire bient\xF4t",
      expiringBody: "Il est valable jusqu\u2019au {date}. Ajoutez un nouveau certificat avant cette date pour ne pas bloquer l\u2019envoi des factures.",
      kind: "Type",
      label: "Libell\xE9",
      validity: "Validit\xE9",
      validityRange: "Du {from} au {to}",
      issuer: "\xC9metteur",
      fingerprint: "Empreinte SHA-256",
      addedBy: "Ajout\xE9",
      addedByValue: "Par {name} le {date}",
      revoke: "R\xE9voquer",
      revokeTitle: "R\xE9voquer le certificat {name}\xA0?",
      revokeBody: "Les factures ne seront plus sign\xE9es avec ce certificat et il ne pourra plus \xEAtre r\xE9activ\xE9. Les factures d\xE9j\xE0 accept\xE9es par TTN ne sont pas modifi\xE9es. Ajoutez un autre certificat pour reprendre l\u2019envoi.",
      revokeConfirm: "R\xE9voquer le certificat",
      revoked: "Le certificat a \xE9t\xE9 r\xE9voqu\xE9.",
      stale: "Ce certificat a \xE9t\xE9 modifi\xE9 entre-temps. La liste a \xE9t\xE9 recharg\xE9e."
    },
    add: {
      title: "Ajouter un certificat de signature",
      intro: "Choisissez le certificat de votre bureau et sa cl\xE9 priv\xE9e. Les fichiers sont lus dans votre navigateur puis envoy\xE9s une seule fois.",
      kind: "Type de certificat",
      label: "Libell\xE9 (facultatif)",
      labelHint: "Un nom pour le reconna\xEEtre, par exemple \xAB\xA0Cachet 2026\xA0\xBB.",
      certificate: "Certificat (fichier .pem, .crt ou .cer)",
      certificateHint: "Le certificat public, au format PEM.",
      privateKey: "Cl\xE9 priv\xE9e (fichier .pem ou .key)",
      privateKeyHint: "La cl\xE9 priv\xE9e au format PEM (PKCS#8). 20 Ko au maximum.",
      never: "La cl\xE9 priv\xE9e est chiffr\xE9e avant d\u2019\xEAtre enregistr\xE9e et ne pourra plus jamais \xEAtre affich\xE9e ni t\xE9l\xE9charg\xE9e. Une confirmation d\u2019identit\xE9 peut vous \xEAtre demand\xE9e\xA0: vous devrez alors choisir de nouveau les fichiers.",
      cancel: "Annuler",
      save: "Ajouter le certificat",
      saving: "Ajout en cours\u2026",
      done: "Le certificat a \xE9t\xE9 ajout\xE9 et il est maintenant actif.",
      errors: {
        required: "Choisissez un fichier.",
        file: {
          tooBig: "Ce fichier est trop volumineux (20 Ko au maximum).",
          unreadable: "Ce fichier n\u2019a pas pu \xEAtre lu. Choisissez-le de nouveau.",
          notPem: "Ce fichier n\u2019est pas au format PEM\xA0: choisissez un fichier texte qui commence par \xAB\xA0-----BEGIN\xA0\xBB."
        },
        certificatePem: {
          SIGNING_CREDENTIAL_INVALID: "Ce fichier n\u2019est pas un certificat X.509 valide au format PEM.",
          SIGNING_CREDENTIAL_EXPIRED: "Ce certificat est expir\xE9. Choisissez un certificat encore valable."
        },
        privateKeyPem: {
          SIGNING_CREDENTIAL_INVALID: "Ce fichier n\u2019est pas une cl\xE9 priv\xE9e valide au format PEM (PKCS#8).",
          SIGNING_KEY_MISMATCH: "Cette cl\xE9 priv\xE9e ne correspond pas au certificat. Choisissez la cl\xE9 g\xE9n\xE9r\xE9e avec lui."
        },
        generic: "Ce fichier n\u2019est pas accept\xE9. V\xE9rifiez-le puis r\xE9essayez.",
        kind: "Ce type de certificat n\u2019est pas accept\xE9. Choisissez un autre type."
      }
    }
  }
};

// locales/ar/planning.json
var planning_default = {
  tab: "\u0627\u0644\u062A\u062E\u0637\u064A\u0637",
  title: "\u062A\u062E\u0637\u064A\u0637 \u0627\u0644\u0645\u0634\u0631\u0648\u0639",
  upgrade: {
    title: "\u0645\u062E\u0637\u0637 \u063A\u0627\u0646\u062A \u063A\u064A\u0631 \u0645\u0634\u0645\u0648\u0644 \u0641\u064A \u0627\u0634\u062A\u0631\u0627\u0643\u0643",
    body: "\u0627\u0646\u062A\u0642\u0644 \u0625\u0644\u0649 \u0627\u0634\u062A\u0631\u0627\u0643 \u0623\u0639\u0644\u0649 \u0644\u062C\u062F\u0648\u0644\u0629 \u0627\u0644\u0645\u0647\u0627\u0645 \u0639\u0644\u0649 \u062E\u0637 \u0632\u0645\u0646\u064A \u0648\u0645\u062A\u0627\u0628\u0639\u0629 \u0627\u0644\u0645\u0633\u0627\u0631 \u0627\u0644\u062D\u0631\u062C \u0648\u0627\u0644\u0622\u062C\u0627\u0644 \u0627\u0644\u062A\u0639\u0627\u0642\u062F\u064A\u0629."
  },
  loadFailedTitle: "\u062A\u0639\u0630\u0651\u0631 \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u062A\u062E\u0637\u064A\u0637",
  loadFailedBody: "\u062A\u062D\u0642\u0642 \u0645\u0646 \u0627\u062A\u0635\u0627\u0644\u0643 \u062B\u0645 \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629.",
  empty: {
    title: "\u0644\u0627 \u0634\u064A\u0621 \u0644\u0644\u062A\u062E\u0637\u064A\u0637 \u062D\u062A\u0649 \u0627\u0644\u0622\u0646",
    description: "\u0623\u0636\u0641 \u0645\u0631\u0627\u062D\u0644 \u0648\u0645\u0647\u0627\u0645 \u0628\u062A\u0648\u0627\u0631\u064A\u062E\u0647\u0627: \u0633\u062A\u0638\u0647\u0631 \u0647\u0646\u0627 \u0639\u0644\u0649 \u0627\u0644\u062E\u0637 \u0627\u0644\u0632\u0645\u0646\u064A."
  },
  noDates: {
    title: "\u0644\u0627 \u062A\u0648\u062C\u062F \u062A\u0648\u0627\u0631\u064A\u062E \u0644\u0644\u0639\u0631\u0636",
    description: "\u062D\u062F\u0651\u062F \u062A\u0627\u0631\u064A\u062E \u0627\u0633\u062A\u062D\u0642\u0627\u0642 \u0644\u0644\u0645\u0647\u0627\u0645 \u0623\u0648 \u062A\u0648\u0627\u0631\u064A\u062E \u0644\u0644\u0645\u0631\u0627\u062D\u0644 \u0644\u0639\u0631\u0636\u0647\u0627 \u0639\u0644\u0649 \u0627\u0644\u062E\u0637 \u0627\u0644\u0632\u0645\u0646\u064A."
  },
  finish: "\u0646\u0647\u0627\u064A\u0629 \u0627\u0644\u0645\u0634\u0631\u0648\u0639 \u0627\u0644\u0645\u062A\u0648\u0642\u0639\u0629: {date}",
  finishUnknown: "\u0646\u0647\u0627\u064A\u0629 \u0627\u0644\u0645\u0634\u0631\u0648\u0639 \u0627\u0644\u0645\u062A\u0648\u0642\u0639\u0629: \u063A\u064A\u0631 \u0645\u062D\u0633\u0648\u0628\u0629 (\u0644\u0627 \u062A\u0648\u062C\u062F \u0645\u0647\u0645\u0629 \u0645\u0624\u0631\u062E\u0629)",
  critical: {
    label: "\u0627\u0644\u0645\u0633\u0627\u0631 \u0627\u0644\u062D\u0631\u062C",
    summary: "{count, plural, one {\u0627\u0644\u0645\u0633\u0627\u0631 \u0627\u0644\u062D\u0631\u062C: \u0645\u0647\u0645\u0629 \u0648\u0627\u062D\u062F\u0629} two {\u0627\u0644\u0645\u0633\u0627\u0631 \u0627\u0644\u062D\u0631\u062C: \u0645\u0647\u0645\u062A\u0627\u0646} few {\u0627\u0644\u0645\u0633\u0627\u0631 \u0627\u0644\u062D\u0631\u062C: # \u0645\u0647\u0627\u0645} many {\u0627\u0644\u0645\u0633\u0627\u0631 \u0627\u0644\u062D\u0631\u062C: # \u0645\u0647\u0645\u0629} other {\u0627\u0644\u0645\u0633\u0627\u0631 \u0627\u0644\u062D\u0631\u062C: # \u0645\u0647\u0645\u0629}}",
    help: "\u0644\u0627 \u064A\u0645\u0643\u0646 \u0644\u0645\u0647\u0627\u0645 \u0627\u0644\u0645\u0633\u0627\u0631 \u0627\u0644\u062D\u0631\u062C \u0623\u0646 \u062A\u062A\u0623\u062E\u0631 \u062F\u0648\u0646 \u062A\u0623\u062E\u064A\u0631 \u0646\u0647\u0627\u064A\u0629 \u0627\u0644\u0645\u0634\u0631\u0648\u0639."
  },
  slack: "{count, plural, one {\u0627\u0644\u0647\u0627\u0645\u0634: \u064A\u0648\u0645 \u0648\u0627\u062D\u062F} two {\u0627\u0644\u0647\u0627\u0645\u0634: \u064A\u0648\u0645\u0627\u0646} few {\u0627\u0644\u0647\u0627\u0645\u0634: # \u0623\u064A\u0627\u0645} many {\u0627\u0644\u0647\u0627\u0645\u0634: # \u064A\u0648\u0645\u064B\u0627} other {\u0627\u0644\u0647\u0627\u0645\u0634: # \u064A\u0648\u0645}}",
  truncated: "\u064A\u0639\u0631\u0636 \u0627\u0644\u062A\u062E\u0637\u064A\u0637 \u0623\u0648\u0644 1000 \u0645\u0647\u0645\u0629 \u0641\u0642\u0637 \u0645\u0646 \u0627\u0644\u0645\u0634\u0631\u0648\u0639.",
  zoom: {
    label: "\u0627\u0644\u0645\u0642\u064A\u0627\u0633",
    day: "\u064A\u0648\u0645",
    week: "\u0623\u0633\u0628\u0648\u0639"
  },
  chart: {
    label: "\u0645\u062E\u0637\u0637 \u063A\u0627\u0646\u062A \u0644\u0644\u0645\u0634\u0631\u0648\u0639",
    labels: "\u0627\u0644\u0645\u0631\u0627\u062D\u0644 \u0648\u0627\u0644\u0645\u0647\u0627\u0645",
    hintEdit: "\u0644\u0646\u0642\u0644 \u0645\u0647\u0645\u0629: \u0636\u0639 \u0627\u0644\u062A\u0631\u0643\u064A\u0632 \u0639\u0644\u0649 \u0634\u0631\u064A\u0637\u0647\u0627 \u062B\u0645 \u0627\u0633\u062A\u0639\u0645\u0644 \u0627\u0644\u0633\u0647\u0645\u064A\u0646 \u0627\u0644\u0623\u064A\u0645\u0646 \u0648\u0627\u0644\u0623\u064A\u0633\u0631 (\u064A\u0648\u0645\u064B\u0627 \u0628\u064A\u0648\u0645)\u060C \u0648Shift + \u0633\u0647\u0645 \u0644\u062A\u063A\u064A\u064A\u0631 \u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0627\u0633\u062A\u062D\u0642\u0627\u0642\u060C \u0648Enter \u0644\u0644\u062A\u0623\u0643\u064A\u062F \u0648Escape \u0644\u0644\u0625\u0644\u063A\u0627\u0621. \u064A\u0645\u0643\u0646\u0643 \u0623\u064A\u0636\u064B\u0627 \u0633\u062D\u0628 \u0627\u0644\u0634\u0631\u064A\u0637.",
    hintReadOnly: "\u064A\u0645\u0643\u0646\u0643 \u0627\u0644\u0627\u0637\u0644\u0627\u0639 \u0639\u0644\u0649 \u0627\u0644\u062A\u062E\u0637\u064A\u0637\u061B \u0627\u0644\u0645\u0633\u0627\u0647\u0645\u0648\u0646 \u0641\u064A \u0627\u0644\u0645\u0634\u0631\u0648\u0639 \u0641\u0642\u0637 \u064A\u0645\u0643\u0646\u0647\u0645 \u0646\u0642\u0644 \u0627\u0644\u0645\u0647\u0627\u0645.",
    today: "\u0627\u0644\u064A\u0648\u0645",
    milestone: "\u0645\u0639\u0644\u0645",
    phase: "\u0627\u0644\u0645\u0631\u062D\u0644\u0629 {name}",
    noPhase: "\u0628\u062F\u0648\u0646 \u0645\u0631\u062D\u0644\u0629",
    timeline: "\u0627\u0644\u062E\u0637 \u0627\u0644\u0632\u0645\u0646\u064A"
  },
  bar: {
    task: "{title}\u060C \u0645\u0646 {start} \u0625\u0644\u0649 {end}\u060C {criticality}",
    milestone: "{title}\u060C \u0645\u0639\u0644\u0645 \u0628\u062A\u0627\u0631\u064A\u062E {date}\u060C {criticality}",
    dependsOn: "\u062A\u0646\u062A\u0638\u0631: {names}"
  },
  phase: {
    planned: "\u0645\u062E\u0637\u0637\u0629 \u0645\u0646 {start} \u0625\u0644\u0649 {end}",
    notPlanned: "\u062A\u0648\u0627\u0631\u064A\u062E \u063A\u064A\u0631 \u0645\u062E\u0637\u0637\u0629",
    actual: "\u0627\u0644\u0641\u0639\u0644\u064A \u0645\u0646 {start} \u0625\u0644\u0649 {end}",
    actualOngoing: "\u0627\u0644\u0641\u0639\u0644\u064A \u0645\u0646\u0630 {start}",
    deadline: "\u0627\u0644\u0623\u062C\u0644 \u0627\u0644\u062A\u0639\u0627\u0642\u062F\u064A: {date}",
    usedWarning: "\u062A\u0646\u0628\u064A\u0647: \u0628\u0644\u063A 80 % \u0645\u0646 \u0627\u0644\u0623\u062C\u0644",
    usedOverdue: "{count, plural, one {\u062A\u062C\u0627\u0648\u0632 \u0627\u0644\u0623\u062C\u0644: \u062A\u0623\u062E\u0631 \u064A\u0648\u0645 \u0648\u0627\u062D\u062F} two {\u062A\u062C\u0627\u0648\u0632 \u0627\u0644\u0623\u062C\u0644: \u062A\u0623\u062E\u0631 \u064A\u0648\u0645\u064A\u0646} few {\u062A\u062C\u0627\u0648\u0632 \u0627\u0644\u0623\u062C\u0644: \u062A\u0623\u062E\u0631 # \u0623\u064A\u0627\u0645} many {\u062A\u062C\u0627\u0648\u0632 \u0627\u0644\u0623\u062C\u0644: \u062A\u0623\u062E\u0631 # \u064A\u0648\u0645\u064B\u0627} other {\u062A\u062C\u0627\u0648\u0632 \u0627\u0644\u0623\u062C\u0644: \u062A\u0623\u062E\u0631 # \u064A\u0648\u0645}}"
  },
  undated: {
    title: "\u0628\u062F\u0648\u0646 \u062A\u0648\u0627\u0631\u064A\u062E",
    description: "\u0644\u064A\u0633 \u0644\u0647\u0630\u0647 \u0627\u0644\u0645\u0647\u0627\u0645 \u062A\u0627\u0631\u064A\u062E \u0627\u0633\u062A\u062D\u0642\u0627\u0642: \u0641\u0647\u064A \u063A\u064A\u0631 \u0645\u0648\u062C\u0648\u062F\u0629 \u0639\u0644\u0649 \u0627\u0644\u062E\u0637 \u0627\u0644\u0632\u0645\u0646\u064A.",
    none: "\u062C\u0645\u064A\u0639 \u0627\u0644\u0645\u0647\u0627\u0645 \u0644\u0647\u0627 \u062A\u0648\u0627\u0631\u064A\u062E.",
    edit: "\u062D\u062F\u0651\u062F \u062A\u0627\u0631\u064A\u062E \u0627\u0633\u062A\u062D\u0642\u0627\u0642\u0647\u0627 \u0641\u064A \u062A\u0628\u0648\u064A\u0628 \u0627\u0644\u0645\u0647\u0627\u0645."
  },
  move: {
    announce: "{title}: \u0645\u0646 {start} \u0625\u0644\u0649 {end}. Enter \u0644\u0644\u062A\u0623\u0643\u064A\u062F \u0648Escape \u0644\u0644\u0625\u0644\u063A\u0627\u0621.",
    announceMilestone: "{title}: \u0645\u0639\u0644\u0645 \u0628\u062A\u0627\u0631\u064A\u062E {date}. Enter \u0644\u0644\u062A\u0623\u0643\u064A\u062F \u0648Escape \u0644\u0644\u0625\u0644\u063A\u0627\u0621.",
    cancelled: "\u0623\u064F\u0644\u063A\u064A \u0627\u0644\u0646\u0642\u0644.",
    saved: "\u0623\u064F\u0639\u064A\u062F\u062A \u062C\u062F\u0648\u0644\u0629 \u0627\u0644\u0645\u0647\u0645\u0629 \xAB{title}\xBB.",
    stale: "\u0639\u062F\u0651\u0644 \u0634\u062E\u0635 \u0622\u062E\u0631 \u0647\u0630\u0647 \u0627\u0644\u0645\u0647\u0645\u0629 \u0641\u064A \u0647\u0630\u0647 \u0627\u0644\u0623\u062B\u0646\u0627\u0621. \u062A\u0645 \u062A\u062D\u062F\u064A\u062B \u0627\u0644\u062A\u062E\u0637\u064A\u0637: \u0623\u0639\u062F \u0646\u0642\u0644\u0647\u0627.",
    startsAfterDue: "\u0644\u0627 \u064A\u0645\u0643\u0646 \u0623\u0646 \u064A\u0643\u0648\u0646 \u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0628\u062F\u0627\u064A\u0629 \u0628\u0639\u062F \u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0627\u0633\u062A\u062D\u0642\u0627\u0642.",
    failed: "\u062A\u0639\u0630\u0651\u0631 \u0646\u0642\u0644 \u0627\u0644\u0645\u0647\u0645\u0629. \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629."
  },
  deadlines: {
    title: "\u0627\u0644\u0622\u062C\u0627\u0644 \u0627\u0644\u062A\u0639\u0627\u0642\u062F\u064A\u0629",
    intro: "\u064A\u064F\u062D\u0633\u0628 \u0623\u062C\u0644 \u0643\u0644 \u0645\u0631\u062D\u0644\u0629 \u0627\u0646\u0637\u0644\u0627\u0642\u064B\u0627 \u0645\u0646 \u0623\u0648\u0627\u0645\u0631 \u0627\u0644\u062E\u062F\u0645\u0629 \u0627\u0644\u062E\u0627\u0635\u0629 \u0628\u0647\u0627: \u0627\u0644\u0628\u062F\u0621 \u0648\u0627\u0644\u0625\u064A\u0642\u0627\u0641 \u0648\u0627\u0644\u0627\u0633\u062A\u0626\u0646\u0627\u0641.",
    none: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0645\u0631\u0627\u062D\u0644 \u0641\u064A \u0647\u0630\u0627 \u0627\u0644\u0645\u0634\u0631\u0648\u0639."
  },
  deadline: {
    title: "\u0627\u0644\u0623\u062C\u0644 \u0627\u0644\u062A\u0639\u0627\u0642\u062F\u064A",
    panelLabel: "\u0627\u0644\u0623\u062C\u0644 \u0627\u0644\u062A\u0639\u0627\u0642\u062F\u064A \u0644\u0644\u0645\u0631\u062D\u0644\u0629 {name}",
    noDuration: "\u0627\u0644\u0645\u062F\u0629 \u0627\u0644\u062A\u0639\u0627\u0642\u062F\u064A\u0629 \u063A\u064A\u0631 \u0645\u062D\u062F\u062F\u0629. \u0623\u062F\u062E\u0644\u0647\u0627 \u0641\u064A \u062A\u0628\u0648\u064A\u0628 \u0627\u0644\u0645\u0631\u0627\u062D\u0644 \u0644\u0645\u062A\u0627\u0628\u0639\u0629 \u0627\u0644\u0623\u062C\u0644.",
    duration: "\u0627\u0644\u0645\u062F\u0629 \u0627\u0644\u062A\u0639\u0627\u0642\u062F\u064A\u0629",
    days: "{count, plural, one {\u064A\u0648\u0645 \u0648\u0627\u062D\u062F} two {\u064A\u0648\u0645\u0627\u0646} few {# \u0623\u064A\u0627\u0645} many {# \u064A\u0648\u0645\u064B\u0627} other {# \u064A\u0648\u0645}}",
    startedOn: "\u0628\u062F\u0627\u064A\u0629 \u0627\u0644\u0623\u0634\u063A\u0627\u0644",
    notStarted: "\u0644\u0627 \u064A\u0648\u062C\u062F \u0623\u0645\u0631 \u062E\u062F\u0645\u0629 \u0644\u0644\u0628\u062F\u0621 \u0628\u0639\u062F",
    deadline: "\u0627\u0644\u0623\u062C\u0644",
    stoppedDays: "\u0623\u064A\u0627\u0645 \u0627\u0644\u062A\u0648\u0642\u0641",
    stoppedNow: "\u0627\u0644\u0623\u0634\u063A\u0627\u0644 \u0645\u062A\u0648\u0642\u0641\u0629: \u0627\u0644\u0623\u062C\u0644 \u0645\u0639\u0644\u0651\u0642.",
    progress: "\u0627\u0644\u0623\u062C\u0644 \u0627\u0644\u0645\u0633\u062A\u0647\u0644\u0643",
    used: "{percent} \u0645\u0646 \u0627\u0644\u0623\u062C\u0644 \u0645\u0633\u062A\u0647\u0644\u0643",
    stateNone: "\u0636\u0645\u0646 \u0627\u0644\u0623\u062C\u0644",
    stateWarning: "\u062A\u0646\u0628\u064A\u0647: \u0628\u0644\u063A 80 % \u0645\u0646 \u0627\u0644\u0623\u062C\u0644",
    stateOverdue: "\u062A\u062C\u0627\u0648\u0632 \u0627\u0644\u0623\u062C\u0644",
    daysLate: "{count, plural, one {\u062A\u0623\u062E\u0631 \u064A\u0648\u0645 \u0648\u0627\u062D\u062F} two {\u062A\u0623\u062E\u0631 \u064A\u0648\u0645\u064A\u0646} few {\u062A\u0623\u062E\u0631 # \u0623\u064A\u0627\u0645} many {\u062A\u0623\u062E\u0631 # \u064A\u0648\u0645\u064B\u0627} other {\u062A\u0623\u062E\u0631 # \u064A\u0648\u0645}}",
    penalty: "\u0627\u0644\u063A\u0631\u0627\u0645\u0627\u062A \u0627\u0644\u0645\u0642\u062F\u0651\u0631\u0629: {amount}",
    penaltyCapped: "\u0627\u0644\u063A\u0631\u0627\u0645\u0627\u062A \u0627\u0644\u0645\u0642\u062F\u0651\u0631\u0629: {amount} (\u0628\u0644\u063A\u062A \u0627\u0644\u0633\u0642\u0641)",
    penaltyHint: "\u062A\u0642\u062F\u064A\u0631 \u0625\u0631\u0634\u0627\u062F\u064A \u062D\u0633\u0628 \u0628\u0646\u062F \u0627\u0644\u0639\u0642\u062F."
  },
  orders: {
    title: "\u0623\u0648\u0627\u0645\u0631 \u0627\u0644\u062E\u062F\u0645\u0629",
    empty: "\u0644\u0627 \u064A\u0648\u062C\u062F \u0623\u0645\u0631 \u062E\u062F\u0645\u0629 \u0644\u0647\u0630\u0647 \u0627\u0644\u0645\u0631\u062D\u0644\u0629.",
    add: "\u062A\u0633\u062C\u064A\u0644 \u0623\u0645\u0631 \u062E\u062F\u0645\u0629",
    listLabel: "\u0623\u0648\u0627\u0645\u0631 \u0627\u0644\u062E\u062F\u0645\u0629 \u0644\u0644\u0645\u0631\u062D\u0644\u0629 {name}",
    kind: {
      start: "\u0628\u062F\u0621",
      stop: "\u0625\u064A\u0642\u0627\u0641",
      resume: "\u0627\u0633\u062A\u0626\u0646\u0627\u0641"
    },
    effectiveOn: "\u0633\u0627\u0631\u064A \u0641\u064A {date}",
    by: "\u0633\u062C\u0651\u0644\u0647 {name}",
    document: "\u0627\u0644\u0645\u0633\u062A\u0646\u062F",
    documentUnknown: "\u0645\u0633\u062A\u0646\u062F \u0645\u0631\u0641\u0642",
    cancelledBadge: "\u0645\u0644\u063A\u0649",
    cancel: "\u0625\u0644\u063A\u0627\u0621",
    cancelAria: "\u0625\u0644\u063A\u0627\u0621 \u0623\u0645\u0631 \u0627\u0644\u062E\u062F\u0645\u0629 {reference}",
    cancelTitle: "\u0625\u0644\u063A\u0627\u0621 \u0623\u0645\u0631 \u0627\u0644\u062E\u062F\u0645\u0629 \u0647\u0630\u0627\u061F",
    cancelBody: "\u0633\u064A\u064F\u0644\u063A\u0649 \u0627\u0644\u0623\u0645\u0631 \xAB{reference}\xBB ({kind}) \u0648\u0633\u064A\u064F\u0639\u0627\u062F \u062D\u0633\u0627\u0628 \u0623\u062C\u0644 \u0627\u0644\u0645\u0631\u062D\u0644\u0629.",
    cancelConfirm: "\u0625\u0644\u063A\u0627\u0621 \u0627\u0644\u0623\u0645\u0631",
    cancelKeep: "\u0627\u0644\u0625\u0628\u0642\u0627\u0621 \u0639\u0644\u064A\u0647",
    cancelDone: "\u0623\u064F\u0644\u063A\u064A \u0623\u0645\u0631 \u0627\u0644\u062E\u062F\u0645\u0629 \xAB{reference}\xBB.",
    recorded: "\u0633\u064F\u062C\u0651\u0644 \u0623\u0645\u0631 \u0627\u0644\u062E\u062F\u0645\u0629 \xAB{reference}\xBB.",
    dialog: {
      title: "\u062A\u0633\u062C\u064A\u0644 \u0623\u0645\u0631 \u062E\u062F\u0645\u0629",
      phase: "\u0627\u0644\u0645\u0631\u062D\u0644\u0629: {name}",
      kind: "\u0646\u0648\u0639 \u0627\u0644\u0623\u0645\u0631",
      reference: "\u0645\u0631\u062C\u0639 \u0627\u0644\u0623\u0645\u0631",
      referenceHint: "\u0627\u0644\u0631\u0642\u0645 \u0623\u0648 \u0627\u0644\u0645\u0631\u062C\u0639 \u0627\u0644\u0645\u0643\u062A\u0648\u0628 \u0639\u0644\u0649 \u0627\u0644\u0623\u0645\u0631 \u0627\u0644\u0645\u0648\u0642\u0651\u0639.",
      effectiveOn: "\u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0633\u0631\u064A\u0627\u0646",
      document: "\u0627\u0628\u062D\u062B \u0639\u0646 \u0627\u0644\u0623\u0645\u0631 \u0627\u0644\u0645\u0648\u0642\u0651\u0639 \u0641\u064A \u0627\u0644\u0645\u0633\u062A\u0646\u062F\u0627\u062A (\u0627\u062E\u062A\u064A\u0627\u0631\u064A)",
      documentHint: "\u0627\u0643\u062A\u0628 \u062D\u0631\u0641\u064A\u0646 \u0639\u0644\u0649 \u0627\u0644\u0623\u0642\u0644 \u0645\u0646 \u0639\u0646\u0648\u0627\u0646 \u0627\u0644\u0645\u0633\u062A\u0646\u062F \u0623\u0648 \u0631\u0645\u0632\u0647.",
      documentChosen: "\u0627\u0644\u0645\u0633\u062A\u0646\u062F \u0627\u0644\u0645\u0631\u062A\u0628\u0637: {title}",
      documentRemove: "\u0625\u0632\u0627\u0644\u0629 \u0627\u0644\u0645\u0633\u062A\u0646\u062F",
      note: "\u0645\u0644\u0627\u062D\u0638\u0629 (\u0627\u062E\u062A\u064A\u0627\u0631\u064A)",
      submit: "\u062A\u0633\u062C\u064A\u0644",
      saving: "\u062C\u0627\u0631\u064D \u0627\u0644\u062D\u0641\u0638\u2026"
    },
    errors: {
      referenceRequired: "\u0623\u062F\u062E\u0644 \u0645\u0631\u062C\u0639 \u0627\u0644\u0623\u0645\u0631.",
      referenceTooLong: "\u0644\u0627 \u064A\u0645\u0643\u0646 \u0623\u0646 \u064A\u062A\u062C\u0627\u0648\u0632 \u0627\u0644\u0645\u0631\u062C\u0639 60 \u062D\u0631\u0641\u064B\u0627.",
      dateRequired: "\u0623\u062F\u062E\u0644 \u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0633\u0631\u064A\u0627\u0646.",
      noteTooLong: "\u0644\u0627 \u064A\u0645\u0643\u0646 \u0623\u0646 \u062A\u062A\u062C\u0627\u0648\u0632 \u0627\u0644\u0645\u0644\u0627\u062D\u0638\u0629 1000 \u062D\u0631\u0641.",
      ORDER_START_FIRST: "\u0627\u0628\u062F\u0623 \u0628\u0623\u0645\u0631 \u0628\u062F\u0621: \u0644\u0627 \u064A\u0645\u0643\u0646 \u0623\u0646 \u064A\u0623\u062A\u064A \u0627\u0644\u0625\u064A\u0642\u0627\u0641 \u0623\u0648 \u0627\u0644\u0627\u0633\u062A\u0626\u0646\u0627\u0641 \u0625\u0644\u0627 \u0628\u0639\u062F\u0647.",
      ORDER_ALREADY_STARTED: "\u0628\u062F\u0623\u062A \u0647\u0630\u0647 \u0627\u0644\u0645\u0631\u062D\u0644\u0629 \u0628\u0627\u0644\u0641\u0639\u0644. \u0633\u062C\u0651\u0644 \u0623\u0645\u0631 \u0625\u064A\u0642\u0627\u0641 \u0628\u062F\u0644\u064B\u0627 \u0645\u0646 \u0630\u0644\u0643.",
      ORDER_NOT_RUNNING: "\u0623\u0634\u063A\u0627\u0644 \u0647\u0630\u0647 \u0627\u0644\u0645\u0631\u062D\u0644\u0629 \u0644\u064A\u0633\u062A \u062C\u0627\u0631\u064A\u0629: \u0644\u0627 \u0634\u064A\u0621 \u0644\u0625\u064A\u0642\u0627\u0641\u0647. \u0633\u062C\u0651\u0644 \u0623\u0648\u0644\u064B\u0627 \u0623\u0645\u0631 \u0628\u062F\u0621 \u0623\u0648 \u0627\u0633\u062A\u0626\u0646\u0627\u0641.",
      ORDER_NOT_STOPPED: "\u0623\u0634\u063A\u0627\u0644 \u0647\u0630\u0647 \u0627\u0644\u0645\u0631\u062D\u0644\u0629 \u0644\u064A\u0633\u062A \u0645\u062A\u0648\u0642\u0641\u0629: \u0644\u0627 \u0634\u064A\u0621 \u0644\u0627\u0633\u062A\u0626\u0646\u0627\u0641\u0647.",
      ORDER_BEFORE_PREVIOUS: "\u0644\u0627 \u064A\u0645\u0643\u0646 \u0623\u0646 \u064A\u0633\u0628\u0642 \u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0633\u0631\u064A\u0627\u0646 \u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0623\u0645\u0631 \u0627\u0644\u0633\u0627\u0628\u0642 \u0644\u0647\u0630\u0647 \u0627\u0644\u0645\u0631\u062D\u0644\u0629.",
      ORDER_NOT_LAST: "\u0644\u0627 \u064A\u0645\u0643\u0646 \u0625\u0644\u063A\u0627\u0621 \u0625\u0644\u0627 \u0622\u062E\u0631 \u0623\u0645\u0631 \u062E\u062F\u0645\u0629 \u0641\u064A \u0627\u0644\u0645\u0631\u062D\u0644\u0629. \u062D\u062F\u0651\u062B \u0627\u0644\u0642\u0627\u0626\u0645\u0629."
    }
  },
  phaseField: {
    contractDays: "\u0627\u0644\u0645\u062F\u0629 \u0627\u0644\u062A\u0639\u0627\u0642\u062F\u064A\u0629 (\u0628\u0627\u0644\u0623\u064A\u0627\u0645)",
    contractDaysHint: "\u0639\u062F\u062F \u0627\u0644\u0623\u064A\u0627\u0645 \u0627\u0644\u062A\u0642\u0648\u064A\u0645\u064A\u0629 \u0627\u0644\u062A\u064A \u064A\u0645\u0646\u062D\u0647\u0627 \u0627\u0644\u0639\u0642\u062F \u0644\u0647\u0630\u0647 \u0627\u0644\u0645\u0631\u062D\u0644\u0629. \u0627\u062A\u0631\u0643\u0647 \u0641\u0627\u0631\u063A\u064B\u0627 \u0625\u0646 \u0644\u0645 \u064A\u0643\u0646 \u0647\u0646\u0627\u0643 \u0623\u062C\u0644."
  }
};

// locales/en/planning.json
var planning_default2 = {
  tab: "Planning",
  title: "Project planning",
  upgrade: {
    title: "The Gantt chart is not included in your plan",
    body: "Upgrade your plan to schedule tasks on a time line and follow the critical path and the contractual deadlines."
  },
  loadFailedTitle: "The planning could not be loaded",
  loadFailedBody: "Check your connection and try again.",
  empty: {
    title: "Nothing to plan yet",
    description: "Add phases and tasks with dates: they will appear here on the time line."
  },
  noDates: {
    title: "No dates to show",
    description: "Give your tasks a due date or your phases dates to see them on the time line."
  },
  finish: "Planned project finish: {date}",
  finishUnknown: "Planned project finish: not calculated (no dated task)",
  critical: {
    label: "Critical path",
    summary: "{count, plural, one {Critical path: # task} other {Critical path: # tasks}}",
    help: "Tasks on the critical path cannot slip without pushing back the end of the project."
  },
  slack: "{count, plural, one {Slack: # day} other {Slack: # days}}",
  truncated: "The planning shows only the first 1,000 tasks of the project.",
  zoom: {
    label: "Scale",
    day: "Day",
    week: "Week"
  },
  chart: {
    label: "Project Gantt chart",
    labels: "Phases and tasks",
    hintEdit: "To move a task: focus its bar, then use the left and right arrow keys (one day at a time), Shift + arrow to change the due date, Enter to confirm and Escape to cancel. You can also drag the bar.",
    hintReadOnly: "You can view the planning; only project contributors can move tasks.",
    today: "Today",
    milestone: "Milestone",
    phase: "Phase {name}",
    noPhase: "No phase",
    timeline: "Time line"
  },
  bar: {
    task: "{title}, from {start} to {end}, {criticality}",
    milestone: "{title}, milestone on {date}, {criticality}",
    dependsOn: "waits for: {names}"
  },
  phase: {
    planned: "Planned {start} to {end}",
    notPlanned: "Dates not planned",
    actual: "Actual {start} to {end}",
    actualOngoing: "Actual since {start}",
    deadline: "Contractual deadline: {date}",
    usedWarning: "Warning: 80% of the time reached",
    usedOverdue: "{count, plural, one {Deadline passed: # day late} other {Deadline passed: # days late}}"
  },
  undated: {
    title: "No dates",
    description: "These tasks have no due date: they are not on the time line.",
    none: "Every task has a date.",
    edit: "Set their due date in the Tasks tab."
  },
  move: {
    announce: "{title}: from {start} to {end}. Enter to confirm, Escape to cancel.",
    announceMilestone: "{title}: milestone on {date}. Enter to confirm, Escape to cancel.",
    cancelled: "Move cancelled.",
    saved: 'The task "{title}" has been rescheduled.',
    stale: "Someone changed this task in the meantime. The planning has been refreshed: move it again.",
    startsAfterDue: "The start date cannot be after the due date.",
    failed: "The task could not be moved. Try again."
  },
  deadlines: {
    title: "Contractual deadlines",
    intro: "The deadline of each phase is calculated from its service orders: start, stop and resume.",
    none: "This project has no phase."
  },
  deadline: {
    title: "Contractual deadline",
    panelLabel: "Contractual deadline of the phase {name}",
    noDuration: "The contractual duration is not set. Enter it in the Phases tab to follow the deadline.",
    duration: "Contractual duration",
    days: "{count, plural, one {# day} other {# days}}",
    startedOn: "Works start",
    notStarted: "No start service order yet",
    deadline: "Deadline",
    stoppedDays: "Days stopped",
    stoppedNow: "Works stopped: the deadline is suspended.",
    progress: "Time used",
    used: "{percent} of the time used",
    stateNone: "On time",
    stateWarning: "Warning: 80% of the time is reached",
    stateOverdue: "Deadline passed",
    daysLate: "{count, plural, one {# day late} other {# days late}}",
    penalty: "Estimated penalties: {amount}",
    penaltyCapped: "Estimated penalties: {amount} (capped)",
    penaltyHint: "Indicative estimate based on the contract clause."
  },
  orders: {
    title: "Service orders",
    empty: "No service order for this phase.",
    add: "Record a service order",
    listLabel: "Service orders of the phase {name}",
    kind: {
      start: "Start",
      stop: "Stop",
      resume: "Resume"
    },
    effectiveOn: "Effective {date}",
    by: "Entered by {name}",
    document: "Document",
    documentUnknown: "Attached document",
    cancelledBadge: "Cancelled",
    cancel: "Cancel",
    cancelAria: "Cancel service order {reference}",
    cancelTitle: "Cancel this service order?",
    cancelBody: 'The order "{reference}" ({kind}) will be cancelled and the deadline of the phase recalculated.',
    cancelConfirm: "Cancel the order",
    cancelKeep: "Keep it",
    cancelDone: 'The service order "{reference}" is cancelled.',
    recorded: 'The service order "{reference}" is recorded.',
    dialog: {
      title: "Record a service order",
      phase: "Phase: {name}",
      kind: "Order type",
      reference: "Order reference",
      referenceHint: "The number or reference written on the signed order.",
      effectiveOn: "Effective date",
      document: "Find the signed order in the documents (optional)",
      documentHint: "Type at least two letters of the document title or code.",
      documentChosen: "Linked document: {title}",
      documentRemove: "Remove the document",
      note: "Note (optional)",
      submit: "Record",
      saving: "Saving\u2026"
    },
    errors: {
      referenceRequired: "Enter the order reference.",
      referenceTooLong: "The reference cannot exceed 60 characters.",
      dateRequired: "Enter the effective date.",
      noteTooLong: "The note cannot exceed 1,000 characters.",
      ORDER_START_FIRST: "Start with a start order: a stop or a resume can only come after it.",
      ORDER_ALREADY_STARTED: "This phase has already started. Record a stop order instead.",
      ORDER_NOT_RUNNING: "Works on this phase are not running: there is nothing to stop. Record a start or a resume first.",
      ORDER_NOT_STOPPED: "Works on this phase are not stopped: there is nothing to resume.",
      ORDER_BEFORE_PREVIOUS: "The effective date cannot be before the date of the previous order of this phase.",
      ORDER_NOT_LAST: "Only the latest service order of a phase can be cancelled. Refresh the list."
    }
  },
  phaseField: {
    contractDays: "Contractual duration (days)",
    contractDaysHint: "Number of calendar days the contract grants for this phase. Leave empty if there is none."
  }
};

// locales/fr/planning.json
var planning_default3 = {
  tab: "Planning",
  title: "Planning du projet",
  upgrade: {
    title: "Le diagramme de Gantt n\u2019est pas inclus dans votre offre",
    body: "Passez \xE0 une offre sup\xE9rieure pour planifier les t\xE2ches sur une ligne de temps, suivre le chemin critique et les d\xE9lais contractuels."
  },
  loadFailedTitle: "Le planning n\u2019a pas pu \xEAtre charg\xE9",
  loadFailedBody: "V\xE9rifiez votre connexion puis r\xE9essayez.",
  empty: {
    title: "Rien \xE0 planifier pour le moment",
    description: "Ajoutez des phases et des t\xE2ches avec des dates\xA0: elles appara\xEEtront ici sur la ligne de temps."
  },
  noDates: {
    title: "Aucune date \xE0 afficher",
    description: "Donnez une \xE9ch\xE9ance \xE0 vos t\xE2ches ou des dates \xE0 vos phases pour les voir sur la ligne de temps."
  },
  finish: "Fin pr\xE9vue du projet\xA0: {date}",
  finishUnknown: "Fin pr\xE9vue du projet\xA0: non calcul\xE9e (aucune t\xE2che dat\xE9e)",
  critical: {
    label: "Chemin critique",
    summary: "{count, plural, one {Chemin critique\xA0: # t\xE2che} other {Chemin critique\xA0: # t\xE2ches}}",
    help: "Les t\xE2ches du chemin critique ne peuvent pas glisser sans repousser la fin du projet."
  },
  slack: "{count, plural, one {Marge\xA0: # jour} other {Marge\xA0: # jours}}",
  truncated: "Le planning montre seulement les 1 000 premi\xE8res t\xE2ches du projet.",
  zoom: {
    label: "\xC9chelle",
    day: "Jour",
    week: "Semaine"
  },
  chart: {
    label: "Diagramme de Gantt du projet",
    labels: "Phases et t\xE2ches",
    hintEdit: "Pour d\xE9placer une t\xE2che\xA0: placez-vous sur sa barre, puis utilisez les fl\xE8ches gauche et droite (un jour \xE0 la fois), Maj + fl\xE8che pour changer l\u2019\xE9ch\xE9ance, Entr\xE9e pour valider et \xC9chap pour annuler. Vous pouvez aussi faire glisser la barre.",
    hintReadOnly: "Vous pouvez consulter le planning\xA0; seuls les contributeurs du projet peuvent d\xE9placer les t\xE2ches.",
    today: "Aujourd\u2019hui",
    milestone: "Jalon",
    phase: "Phase {name}",
    noPhase: "Sans phase",
    timeline: "Ligne de temps"
  },
  bar: {
    task: "{title}, du {start} au {end}, {criticality}",
    milestone: "{title}, jalon au {date}, {criticality}",
    dependsOn: "attend\xA0: {names}"
  },
  phase: {
    planned: "Pr\xE9vue du {start} au {end}",
    notPlanned: "Dates non planifi\xE9es",
    actual: "R\xE9el du {start} au {end}",
    actualOngoing: "R\xE9el depuis le {start}",
    deadline: "\xC9ch\xE9ance contractuelle\xA0: {date}",
    usedWarning: "Alerte\xA0: 80\xA0% du d\xE9lai atteint",
    usedOverdue: "{count, plural, one {D\xE9lai d\xE9pass\xE9\xA0: # jour de retard} other {D\xE9lai d\xE9pass\xE9\xA0: # jours de retard}}"
  },
  undated: {
    title: "Sans dates",
    description: "Ces t\xE2ches n\u2019ont pas d\u2019\xE9ch\xE9ance\xA0: elles ne sont pas sur la ligne de temps.",
    none: "Toutes les t\xE2ches ont une date.",
    edit: "Renseignez leur \xE9ch\xE9ance dans l\u2019onglet T\xE2ches."
  },
  move: {
    announce: "{title}\xA0: du {start} au {end}. Entr\xE9e pour valider, \xC9chap pour annuler.",
    announceMilestone: "{title}\xA0: jalon au {date}. Entr\xE9e pour valider, \xC9chap pour annuler.",
    cancelled: "D\xE9placement annul\xE9.",
    saved: "La t\xE2che \xAB\xA0{title}\xA0\xBB est replanifi\xE9e.",
    stale: "Quelqu\u2019un a modifi\xE9 cette t\xE2che entre-temps. Le planning a \xE9t\xE9 actualis\xE9\xA0: refaites votre d\xE9placement.",
    startsAfterDue: "La date de d\xE9but ne peut pas suivre l\u2019\xE9ch\xE9ance.",
    failed: "La t\xE2che n\u2019a pas pu \xEAtre d\xE9plac\xE9e. R\xE9essayez."
  },
  deadlines: {
    title: "D\xE9lais contractuels",
    intro: "Le d\xE9lai de chaque phase se calcule \xE0 partir de ses ordres de service\xA0: d\xE9marrage, arr\xEAt et reprise.",
    none: "Aucune phase dans ce projet."
  },
  deadline: {
    title: "D\xE9lai contractuel",
    panelLabel: "D\xE9lai contractuel de la phase {name}",
    noDuration: "La dur\xE9e contractuelle n\u2019est pas renseign\xE9e. Indiquez-la dans l\u2019onglet Phases pour suivre le d\xE9lai.",
    duration: "Dur\xE9e contractuelle",
    days: "{count, plural, one {# jour} other {# jours}}",
    startedOn: "D\xE9but des travaux",
    notStarted: "Pas encore d\u2019ordre de service de d\xE9marrage",
    deadline: "\xC9ch\xE9ance",
    stoppedDays: "Jours d\u2019arr\xEAt",
    stoppedNow: "Chantier \xE0 l\u2019arr\xEAt\xA0: le d\xE9lai est suspendu.",
    progress: "D\xE9lai utilis\xE9",
    used: "{percent} du d\xE9lai utilis\xE9",
    stateNone: "Dans les d\xE9lais",
    stateWarning: "Alerte\xA0: 80\xA0% du d\xE9lai est atteint",
    stateOverdue: "D\xE9lai d\xE9pass\xE9",
    daysLate: "{count, plural, one {# jour de retard} other {# jours de retard}}",
    penalty: "P\xE9nalit\xE9s estim\xE9es\xA0: {amount}",
    penaltyCapped: "P\xE9nalit\xE9s estim\xE9es\xA0: {amount} (plafonn\xE9es)",
    penaltyHint: "Estimation indicative selon la clause du contrat."
  },
  orders: {
    title: "Ordres de service",
    empty: "Aucun ordre de service pour cette phase.",
    add: "Enregistrer un ordre de service",
    listLabel: "Ordres de service de la phase {name}",
    kind: {
      start: "D\xE9marrage",
      stop: "Arr\xEAt",
      resume: "Reprise"
    },
    effectiveOn: "Effet le {date}",
    by: "Saisi par {name}",
    document: "Document",
    documentUnknown: "Document joint",
    cancelledBadge: "Annul\xE9",
    cancel: "Annuler",
    cancelAria: "Annuler l\u2019ordre de service {reference}",
    cancelTitle: "Annuler cet ordre de service\xA0?",
    cancelBody: "L\u2019ordre \xAB\xA0{reference}\xA0\xBB ({kind}) sera annul\xE9 et le d\xE9lai de la phase sera recalcul\xE9.",
    cancelConfirm: "Annuler l\u2019ordre",
    cancelKeep: "Conserver",
    cancelDone: "L\u2019ordre de service \xAB\xA0{reference}\xA0\xBB est annul\xE9.",
    recorded: "L\u2019ordre de service \xAB\xA0{reference}\xA0\xBB est enregistr\xE9.",
    dialog: {
      title: "Enregistrer un ordre de service",
      phase: "Phase\xA0: {name}",
      kind: "Type d\u2019ordre",
      reference: "R\xE9f\xE9rence de l\u2019ordre",
      referenceHint: "Le num\xE9ro ou la r\xE9f\xE9rence figurant sur l\u2019ordre sign\xE9.",
      effectiveOn: "Date d\u2019effet",
      document: "Rechercher l\u2019ordre sign\xE9 dans les documents (facultatif)",
      documentHint: "Tapez au moins deux lettres du titre ou du code du document.",
      documentChosen: "Document li\xE9\xA0: {title}",
      documentRemove: "Retirer le document",
      note: "Note (facultatif)",
      submit: "Enregistrer",
      saving: "Enregistrement\u2026"
    },
    errors: {
      referenceRequired: "Saisissez la r\xE9f\xE9rence de l\u2019ordre.",
      referenceTooLong: "La r\xE9f\xE9rence ne peut pas d\xE9passer 60 caract\xE8res.",
      dateRequired: "Indiquez la date d\u2019effet.",
      noteTooLong: "La note ne peut pas d\xE9passer 1 000 caract\xE8res.",
      ORDER_START_FIRST: "Commencez par un ordre de d\xE9marrage\xA0: un arr\xEAt ou une reprise ne peut venir qu\u2019apr\xE8s.",
      ORDER_ALREADY_STARTED: "Cette phase a d\xE9j\xE0 d\xE9marr\xE9. Enregistrez plut\xF4t un ordre d\u2019arr\xEAt.",
      ORDER_NOT_RUNNING: "Le chantier de cette phase n\u2019est pas en cours\xA0: il n\u2019y a rien \xE0 arr\xEAter. Enregistrez d\u2019abord un d\xE9marrage ou une reprise.",
      ORDER_NOT_STOPPED: "Le chantier de cette phase n\u2019est pas \xE0 l\u2019arr\xEAt\xA0: il n\u2019y a rien \xE0 reprendre.",
      ORDER_BEFORE_PREVIOUS: "La date d\u2019effet ne peut pas pr\xE9c\xE9der celle de l\u2019ordre pr\xE9c\xE9dent de cette phase.",
      ORDER_NOT_LAST: "Seul le dernier ordre de service d\u2019une phase peut \xEAtre annul\xE9. Actualisez la liste."
    }
  },
  phaseField: {
    contractDays: "Dur\xE9e contractuelle (jours)",
    contractDaysHint: "Nombre de jours calendaires accord\xE9s par le contrat pour cette phase. Laissez vide s\u2019il n\u2019y en a pas."
  }
};

// locales/ar/field.json
var field_default = {
  disclaimer: "\u0644\u0644\u062A\u0630\u0643\u064A\u0631 \u0641\u0642\u0637\u060C \u0648\u0644\u064A\u0633 \u0631\u0623\u064A\u064B\u0627 \u0642\u0627\u0646\u0648\u0646\u064A\u064B\u0627.",
  errors: {
    CHECKLIST_ARCHIVED: "\u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u062A\u062D\u0642\u0642 \u0647\u0630\u0647 \u0645\u0624\u0631\u0634\u0641\u0629: \u0644\u0645 \u064A\u0639\u062F \u0628\u0627\u0644\u0625\u0645\u0643\u0627\u0646 \u062A\u0639\u062F\u064A\u0644 \u0628\u0646\u0648\u062F\u0647\u0627.",
    CHECKLIST_TEMPLATE_RETIRED: "\u062A\u0645 \u0627\u0633\u062A\u0628\u062F\u0627\u0644 \u0647\u0630\u0647 \u0627\u0644\u0646\u0633\u062E\u0629 \u0645\u0646 \u0627\u0644\u0646\u0645\u0648\u0630\u062C \u0623\u0648 \u0633\u062D\u0628\u0647\u0627. \u0623\u0639\u062F \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0642\u0627\u0626\u0645\u0629 \u0648\u0627\u062E\u062A\u0631 \u0627\u0644\u0646\u0633\u062E\u0629 \u0627\u0644\u062D\u0627\u0644\u064A\u0629.",
    CHECKLIST_TEMPLATE_KEY_TAKEN: "\u064A\u0648\u062C\u062F \u0646\u0645\u0648\u0630\u062C \u0628\u0647\u0630\u0627 \u0627\u0644\u0627\u0633\u0645 \u0641\u064A \u0645\u0643\u062A\u0628\u0643\u0645. \u0627\u062E\u062A\u0627\u0631\u0648\u0627 \u0627\u0633\u0645\u064B\u0627 \u0622\u062E\u0631 \u0623\u0648 \u0639\u062F\u0651\u0644\u0648\u0627 \u0630\u0644\u0643 \u0627\u0644\u0646\u0645\u0648\u0630\u062C.",
    PROJECT_ARCHIVED: "\u0647\u0630\u0627 \u0627\u0644\u0645\u0634\u0631\u0648\u0639 \u0645\u0624\u0631\u0634\u0641: \u0647\u0648 \u0644\u0644\u0642\u0631\u0627\u0621\u0629 \u0641\u0642\u0637 \u0625\u0644\u0649 \u0623\u0646 \u062A\u062A\u0645 \u0627\u0633\u062A\u0639\u0627\u062F\u062A\u0647."
  },
  register: {
    title: "\u0633\u062C\u0644 \u0627\u0644\u0645\u062E\u0637\u0637\u0627\u062A",
    intro: "\u0645\u062E\u0637\u0637\u0627\u062A \u0627\u0644\u0645\u0634\u0631\u0648\u0639 \u0645\u0639 \u0641\u0647\u0631\u0633\u0647\u0627 \u0627\u0644\u0633\u0627\u0631\u064A \u0648\u062D\u0627\u0644\u0629 \u0627\u0644\u0645\u0635\u0627\u062F\u0642\u0629 \u0648\u0639\u0645\u0644\u064A\u0627\u062A \u0627\u0644\u0625\u0631\u0633\u0627\u0644. \u0644\u0627 \u062A\u0631\u0648\u0646 \u0625\u0644\u0627 \u0627\u0644\u0645\u062C\u0644\u062F\u0627\u062A \u0627\u0644\u062A\u064A \u064A\u062D\u0642 \u0644\u0643\u0645 \u0627\u0644\u0627\u0637\u0644\u0627\u0639 \u0639\u0644\u064A\u0647\u0627.",
    caption: "\u0633\u062C\u0644 \u0645\u062E\u0637\u0637\u0627\u062A \u0627\u0644\u0645\u0634\u0631\u0648\u0639",
    filters: {
      label: "\u0645\u0631\u0634\u062D\u0627\u062A \u0627\u0644\u0633\u062C\u0644",
      docType: "\u0627\u0644\u0645\u0633\u062A\u0646\u062F\u0627\u062A",
      drawing: "\u0627\u0644\u0645\u062E\u0637\u0637\u0627\u062A \u0641\u0642\u0637",
      all: "\u0643\u0644 \u0627\u0644\u0645\u0633\u062A\u0646\u062F\u0627\u062A",
      discipline: "\u0627\u0644\u0627\u062E\u062A\u0635\u0627\u0635",
      allDisciplines: "\u0643\u0644 \u0627\u0644\u0627\u062E\u062A\u0635\u0627\u0635\u0627\u062A",
      phase: "\u0627\u0644\u0645\u0631\u062D\u0644\u0629",
      allPhases: "\u0643\u0644 \u0627\u0644\u0645\u0631\u0627\u062D\u0644"
    },
    columns: {
      history: "\u0633\u062C\u0644 \u0627\u0644\u062A\u0648\u0632\u064A\u0639",
      code: "\u0627\u0644\u0631\u0645\u0632",
      title: "\u0627\u0644\u0639\u0646\u0648\u0627\u0646",
      scale: "\u0627\u0644\u0645\u0642\u064A\u0627\u0633",
      index: "\u0627\u0644\u0641\u0647\u0631\u0633",
      indexDate: "\u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0641\u0647\u0631\u0633",
      status: "\u0627\u0644\u0645\u0635\u0627\u062F\u0642\u0629",
      lastTransmittal: "\u0622\u062E\u0631 \u0625\u0631\u0633\u0627\u0644"
    },
    status: {
      in_progress: "\u0642\u064A\u062F \u0627\u0644\u0645\u0635\u0627\u062F\u0642\u0629",
      approved: "\u0645\u0635\u0627\u062F\u064E\u0642 \u0639\u0644\u064A\u0647",
      approved_with_comments: "\u0645\u0635\u0627\u062F\u064E\u0642 \u0639\u0644\u064A\u0647 \u0645\u0639 \u0645\u0644\u0627\u062D\u0638\u0627\u062A",
      rejected: "\u0645\u0631\u0641\u0648\u0636",
      none: "\u062F\u0648\u0646 \u0645\u0635\u0627\u062F\u0642\u0629"
    },
    noCode: "\u062F\u0648\u0646 \u0631\u0645\u0632",
    none: "\u063A\u064A\u0631 \u0645\u062D\u062F\u062F",
    neverSent: "\u0644\u0645 \u064A\u064F\u0631\u0633\u0644 \u0642\u0637",
    transmittal: "\u0628\u0637\u0627\u0642\u0629 \u0627\u0644\u0625\u0631\u0633\u0627\u0644 {number}",
    history: {
      show: "\u0639\u0631\u0636 \u0633\u062C\u0644 \u062A\u0648\u0632\u064A\u0639 {name}",
      hide: "\u0625\u062E\u0641\u0627\u0621 \u0633\u062C\u0644 \u062A\u0648\u0632\u064A\u0639 {name}",
      title: "\u0633\u062C\u0644 \u062A\u0648\u0632\u064A\u0639 {name}",
      empty: "\u0644\u0645 \u064A\u062A\u0645 \u062A\u0648\u0632\u064A\u0639 \u0647\u0630\u0627 \u0627\u0644\u0645\u0633\u062A\u0646\u062F \u0628\u0639\u062F.",
      atIndex: "\u0627\u0644\u0641\u0647\u0631\u0633"
    },
    count: "{count, plural, zero {\u0644\u0627 \u0645\u0633\u062A\u0646\u062F\u0627\u062A} one {\u0645\u0633\u062A\u0646\u062F \u0648\u0627\u062D\u062F} two {\u0645\u0633\u062A\u0646\u062F\u0627\u0646} few {# \u0645\u0633\u062A\u0646\u062F\u0627\u062A} many {# \u0645\u0633\u062A\u0646\u062F\u064B\u0627} other {# \u0645\u0633\u062A\u0646\u062F}}",
    truncated: "\u0627\u0644\u0633\u062C\u0644 \u0623\u0637\u0648\u0644 \u0645\u0646 \u0623\u0646 \u064A\u064F\u0639\u0631\u0636 \u0643\u0627\u0645\u0644\u064B\u0627. \u0636\u064A\u0651\u0642\u0648\u0627 \u0627\u0644\u0645\u0631\u0634\u062D\u0627\u062A \u0644\u0631\u0624\u064A\u0629 \u0628\u0642\u064A\u0629 \u0627\u0644\u0645\u0633\u062A\u0646\u062F\u0627\u062A\u060C \u0623\u0648 \u0635\u062F\u0651\u0631\u0648\u0647.",
    empty: {
      title: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0645\u062E\u0637\u0637\u0627\u062A \u0641\u064A \u0627\u0644\u0633\u062C\u0644",
      body: "\u062A\u0638\u0647\u0631 \u0627\u0644\u0645\u062E\u0637\u0637\u0627\u062A \u0647\u0646\u0627 \u0628\u0645\u062C\u0631\u062F \u0625\u064A\u062F\u0627\u0639 \u0646\u0633\u062E\u0629 \u0641\u064A \u0623\u062D\u062F \u0645\u062C\u0644\u062F\u0627\u062A \u0627\u0644\u0645\u0634\u0631\u0648\u0639.",
      filteredTitle: "\u0644\u0627 \u064A\u0648\u062C\u062F \u0645\u0633\u062A\u0646\u062F \u0645\u0637\u0627\u0628\u0642",
      filteredBody: "\u063A\u064A\u0651\u0631\u0648\u0627 \u0623\u062D\u062F \u0627\u0644\u0645\u0631\u0634\u062D\u0627\u062A \u0623\u0648 \u0623\u0632\u064A\u0644\u0648\u0647 \u0644\u0631\u0624\u064A\u0629 \u0645\u0633\u062A\u0646\u062F\u0627\u062A \u0623\u062E\u0631\u0649."
    },
    loadFailedTitle: "\u062A\u0639\u0630\u0631 \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0633\u062C\u0644",
    loadFailedBody: "\u062A\u062D\u0642\u0642\u0648\u0627 \u0645\u0646 \u0627\u062A\u0635\u0627\u0644\u0643\u0645 \u062B\u0645 \u0623\u0639\u064A\u062F\u0648\u0627 \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629.",
    upgrade: {
      title: "\u0633\u062C\u0644 \u0627\u0644\u0645\u062E\u0637\u0637\u0627\u062A \u063A\u064A\u0631 \u0645\u0634\u0645\u0648\u0644 \u0641\u064A \u0639\u0631\u0636\u0643\u0645",
      bodyOwner: "\u0627\u0646\u062A\u0642\u0644\u0648\u0627 \u0625\u0644\u0649 \u0639\u0631\u0636 \u0623\u0639\u0644\u0649 \u0644\u062A\u062D\u062F\u064A\u062B \u0633\u062C\u0644 \u0627\u0644\u0645\u062E\u0637\u0637\u0627\u062A \u062A\u0644\u0642\u0627\u0626\u064A\u064B\u0627 \u0648\u062A\u0635\u062F\u064A\u0631\u0647 \u0628\u0635\u064A\u063A\u0629 PDF \u0623\u0648 Excel.",
      bodyMember: "\u0633\u062C\u0644 \u0627\u0644\u0645\u062E\u0637\u0637\u0627\u062A \u063A\u064A\u0631 \u0645\u0634\u0645\u0648\u0644 \u0641\u064A \u0639\u0631\u0636 \u0645\u0643\u062A\u0628\u0643\u0645. \u062A\u0648\u0627\u0635\u0644\u0648\u0627 \u0645\u0639 \u0645\u0633\u0624\u0648\u0644 \u0627\u0644\u0645\u0643\u062A\u0628 \u0644\u0644\u0627\u0646\u062A\u0642\u0627\u0644 \u0625\u0644\u0649 \u0639\u0631\u0636 \u0623\u0639\u0644\u0649.",
      action: "\u0639\u0631\u0636 \u0627\u0644\u0639\u0631\u0648\u0636"
    }
  },
  export: {
    menu: "\u062A\u0635\u062F\u064A\u0631",
    menuLabel: "\u062A\u0635\u062F\u064A\u0631 \u0633\u062C\u0644 \u0627\u0644\u0645\u062E\u0637\u0637\u0627\u062A",
    options: {
      pdf_fr: "PDF (\u0628\u0627\u0644\u0641\u0631\u0646\u0633\u064A\u0629)",
      pdf_ar: "PDF (\u0628\u0627\u0644\u0639\u0631\u0628\u064A\u0629)",
      xlsx_fr: "Excel (\u0628\u0627\u0644\u0641\u0631\u0646\u0633\u064A\u0629)",
      xlsx_ar: "Excel (\u0628\u0627\u0644\u0639\u0631\u0628\u064A\u0629)",
      xlsx_en: "Excel (\u0628\u0627\u0644\u0625\u0646\u062C\u0644\u064A\u0632\u064A\u0629)"
    },
    pending: "\u062C\u0627\u0631\u064D \u062A\u062C\u0647\u064A\u0632 \u0627\u0644\u062A\u0635\u062F\u064A\u0631. \u064A\u0645\u0643\u0646\u0643\u0645 \u0645\u062A\u0627\u0628\u0639\u0629 \u0627\u0644\u0639\u0645\u0644.",
    ready: "\u0627\u0644\u062A\u0635\u062F\u064A\u0631 \u062C\u0627\u0647\u0632.",
    download: "\u062A\u0646\u0632\u064A\u0644 {fileName}",
    downloadGeneric: "\u062A\u0646\u0632\u064A\u0644 \u0627\u0644\u0645\u0644\u0641",
    failed: "\u062A\u0639\u0630\u0631 \u062A\u062C\u0647\u064A\u0632 \u0627\u0644\u062A\u0635\u062F\u064A\u0631. \u0623\u0639\u064A\u062F\u0648\u0627 \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629 \u0628\u0639\u062F \u0642\u0644\u064A\u0644.",
    slow: "\u064A\u0633\u062A\u063A\u0631\u0642 \u0627\u0644\u062A\u0635\u062F\u064A\u0631 \u0648\u0642\u062A\u064B\u0627 \u0623\u0637\u0648\u0644 \u0645\u0646 \u0627\u0644\u0645\u062A\u0648\u0642\u0639. \u064A\u0645\u0643\u0646\u0643\u0645 \u0627\u0644\u062A\u062D\u0642\u0642 \u0645\u062C\u062F\u062F\u064B\u0627 \u0628\u0639\u062F \u0642\u0644\u064A\u0644.",
    checkAgain: "\u0627\u0644\u062A\u062D\u0642\u0642 \u0645\u062C\u062F\u062F\u064B\u0627",
    rateLimited: "\u0637\u0644\u0628\u062A\u0645 \u0639\u062F\u0629 \u0639\u0645\u0644\u064A\u0627\u062A \u062A\u0635\u062F\u064A\u0631 \u0641\u064A \u0648\u0642\u062A \u0642\u0635\u064A\u0631. \u0627\u0646\u062A\u0638\u0631\u0648\u0627 \u062F\u0642\u064A\u0642\u0629 \u062B\u0645 \u0623\u0639\u064A\u062F\u0648\u0627 \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629."
  },
  checklists: {
    title: "\u0642\u0648\u0627\u0626\u0645 \u0627\u0644\u062A\u062D\u0642\u0642 \u0627\u0644\u062A\u0646\u0638\u064A\u0645\u064A\u0629",
    intro: "\u062A\u0627\u0628\u0639\u0648\u0627 \u0645\u0637\u0627\u0628\u0642\u0629 \u0627\u0644\u0645\u0634\u0631\u0648\u0639 \u0628\u0646\u062F\u064B\u0627 \u0628\u0646\u062F\u064B\u0627 \u0645\u0639 \u0642\u0648\u0627\u0626\u0645 \u0627\u0644\u062A\u062D\u0642\u0642 \u0627\u0644\u062E\u0627\u0635\u0629 \u0628BatiFlow \u0648\u0642\u0648\u0627\u0626\u0645 \u0645\u0643\u062A\u0628\u0643\u0645.",
    listLabel: "\u0642\u0648\u0627\u0626\u0645 \u062A\u062D\u0642\u0642 \u0627\u0644\u0645\u0634\u0631\u0648\u0639",
    legalRef: "\u0627\u0644\u0645\u0631\u062C\u0639 \u0627\u0644\u0642\u0627\u0646\u0648\u0646\u064A:",
    updatedOn: "\u0622\u062E\u0631 \u062A\u062D\u062F\u064A\u062B \u0641\u064A",
    templateVersion: "\u0646\u0633\u062E\u0629 \u0627\u0644\u0646\u0645\u0648\u0630\u062C {version}",
    completed: "\u0645\u0643\u062A\u0645\u0644\u0629",
    archived: "\u0645\u0624\u0631\u0634\u0641\u0629",
    completedNote: "\u062A\u0645\u062A \u0645\u0639\u0627\u0644\u062C\u0629 \u0643\u0644 \u0627\u0644\u0628\u0646\u0648\u062F: \u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u062A\u062D\u0642\u0642 \u0645\u0643\u062A\u0645\u0644\u0629.",
    viewOnly: "\u064A\u0645\u0643\u0646\u0643\u0645 \u0627\u0644\u0627\u0637\u0644\u0627\u0639 \u0639\u0644\u0649 \u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u062A\u062D\u0642\u0642 \u0647\u0630\u0647 \u062F\u0648\u0646 \u062A\u0639\u062F\u064A\u0644\u0647\u0627.",
    progress: "\u062A\u0645\u062A \u0645\u0639\u0627\u0644\u062C\u0629 {handled} \u0645\u0646 {total} \u0628\u0646\u062F\u064B\u0627",
    progressDetail: "{done} \u0645\u0646\u062C\u0632\u0629\u060C {na} \u063A\u064A\u0631 \u0645\u0639\u0646\u064A\u0629\u060C {todo} \u0645\u062A\u0628\u0642\u064A\u0629",
    progressBar: "\u062A\u0642\u062F\u0645 {name}",
    stale: "\u0639\u062F\u0651\u0644 \u0634\u062E\u0635 \u0622\u062E\u0631 \u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u062A\u062D\u0642\u0642 \u0647\u0630\u0647 \u0641\u064A \u0627\u0644\u0648\u0642\u062A \u0646\u0641\u0633\u0647. \u062A\u0645\u062A \u0625\u0639\u0627\u062F\u0629 \u062A\u062D\u0645\u064A\u0644\u0647\u0627 \u0644\u0644\u062A\u0648: \u062A\u062D\u0642\u0642\u0648\u0627 \u0645\u0646 \u062D\u0627\u0644\u062A\u0647\u0627 \u062B\u0645 \u0623\u0639\u064A\u062F\u0648\u0627 \u062A\u063A\u064A\u064A\u0631\u0643\u0645.",
    loadFailedTitle: "\u062A\u0639\u0630\u0631 \u062A\u062D\u0645\u064A\u0644 \u0642\u0648\u0627\u0626\u0645 \u0627\u0644\u062A\u062D\u0642\u0642",
    loadFailedBody: "\u062A\u062D\u0642\u0642\u0648\u0627 \u0645\u0646 \u0627\u062A\u0635\u0627\u0644\u0643\u0645 \u062B\u0645 \u0623\u0639\u064A\u062F\u0648\u0627 \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629.",
    empty: {
      title: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0642\u0627\u0626\u0645\u0629 \u062A\u062D\u0642\u0642 \u0644\u0647\u0630\u0627 \u0627\u0644\u0645\u0634\u0631\u0648\u0639",
      body: "\u0623\u0646\u0634\u0626\u0648\u0627 \u0642\u0627\u0626\u0645\u0629 \u062A\u062D\u0642\u0642 \u0627\u0646\u0637\u0644\u0627\u0642\u064B\u0627 \u0645\u0646 \u0646\u0645\u0648\u0630\u062C (\u0631\u062E\u0635\u0629 \u0627\u0644\u0628\u0646\u0627\u0621\u060C \u0627\u0644\u0633\u0644\u0627\u0645\u0629 \u0645\u0646 \u0627\u0644\u062D\u0631\u0627\u0626\u0642\u060C \u0633\u0647\u0648\u0644\u0629 \u0627\u0644\u0648\u0644\u0648\u062C\u2026) \u0644\u0645\u062A\u0627\u0628\u0639\u0629 \u0645\u0637\u0627\u0628\u0642\u0629 \u0627\u0644\u0645\u0634\u0631\u0648\u0639.",
      bodyNoRights: "\u0644\u0645 \u062A\u064F\u0646\u0634\u0623 \u0623\u064A \u0642\u0627\u0626\u0645\u0629 \u062A\u062D\u0642\u0642 \u0644\u0647\u0630\u0627 \u0627\u0644\u0645\u0634\u0631\u0648\u0639 \u0628\u0639\u062F."
    },
    new: {
      action: "\u0642\u0627\u0626\u0645\u0629 \u062A\u062D\u0642\u0642 \u062C\u062F\u064A\u062F\u0629",
      title: "\u0642\u0627\u0626\u0645\u0629 \u062A\u062D\u0642\u0642 \u062C\u062F\u064A\u062F\u0629",
      intro: "\u0627\u062E\u062A\u0627\u0631\u0648\u0627 \u0646\u0645\u0648\u0630\u062C\u064B\u0627. \u064A\u062D\u0635\u0644 \u0627\u0644\u0645\u0634\u0631\u0648\u0639 \u0639\u0644\u0649 \u0646\u0633\u062E\u0629 \u0645\u0646\u0647: \u0625\u0630\u0627 \u062A\u063A\u064A\u0651\u0631 \u0627\u0644\u0646\u0645\u0648\u0630\u062C \u0644\u0627\u062D\u0642\u064B\u0627 \u0641\u0644\u0646 \u062A\u062A\u063A\u064A\u0631 \u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u062A\u062D\u0642\u0642 \u0647\u0630\u0647.",
      templates: "\u0646\u0645\u0627\u0630\u062C \u0642\u0648\u0627\u0626\u0645 \u0627\u0644\u062A\u062D\u0642\u0642",
      choose: "\u0627\u062E\u062A\u0627\u0631\u0648\u0627 \u0646\u0645\u0648\u0630\u062C\u064B\u0627 \u0644\u0644\u0645\u062A\u0627\u0628\u0639\u0629.",
      none: "\u0644\u0627 \u064A\u062A\u0648\u0641\u0631 \u0623\u064A \u0646\u0645\u0648\u0630\u062C \u062D\u0627\u0644\u064A\u064B\u0627.",
      loadFailed: "\u062A\u0639\u0630\u0631 \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0646\u0645\u0627\u0630\u062C.",
      create: "\u0625\u0646\u0634\u0627\u0621 \u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u062A\u062D\u0642\u0642",
      creating: "\u062C\u0627\u0631\u064D \u0627\u0644\u0625\u0646\u0634\u0627\u0621\u2026",
      done: "\u062A\u0645 \u0625\u0646\u0634\u0627\u0621 \u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u062A\u062D\u0642\u0642 {name}."
    },
    items: {
      listLabel: "\u0628\u0646\u0648\u062F \u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u062A\u062D\u0642\u0642 {name}",
      stateOf: "\u062D\u0627\u0644\u0629 \u0627\u0644\u0628\u0646\u062F: {label}",
      states: {
        todo: "\u0644\u0644\u0625\u0646\u062C\u0627\u0632",
        done: "\u0645\u0646\u062C\u0632",
        not_applicable: "\u063A\u064A\u0631 \u0645\u0639\u0646\u064A"
      },
      doneBy: "\u0623\u0646\u062C\u0632\u0647 {name} \u0641\u064A",
      note: "\u0645\u0644\u0627\u062D\u0638\u0629: {note}",
      noteLabel: "\u0645\u0644\u0627\u062D\u0638\u0629 \u0639\u0644\u0649 \u0627\u0644\u0628\u0646\u062F: {label}",
      noteSave: "\u062D\u0641\u0638 \u0627\u0644\u0645\u0644\u0627\u062D\u0638\u0629",
      addNote: "\u0625\u0636\u0627\u0641\u0629 \u0645\u0644\u0627\u062D\u0638\u0629",
      editNote: "\u062A\u0639\u062F\u064A\u0644 \u0627\u0644\u0645\u0644\u0627\u062D\u0638\u0629",
      addNoteOf: "\u0625\u0636\u0627\u0641\u0629 \u0645\u0644\u0627\u062D\u0638\u0629 \u0625\u0644\u0649 \u0627\u0644\u0628\u0646\u062F: {label}",
      editNoteOf: "\u062A\u0639\u062F\u064A\u0644 \u0645\u0644\u0627\u062D\u0638\u0629 \u0627\u0644\u0628\u0646\u062F: {label}"
    },
    archive: {
      action: "\u0623\u0631\u0634\u0641\u0629",
      title: "\u0623\u0631\u0634\u0641\u0629 {name}\u061F",
      body: "\u062A\u0635\u0628\u062D \u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u062A\u062D\u0642\u0642 \u0627\u0644\u0645\u0624\u0631\u0634\u0641\u0629 \u0644\u0644\u0642\u0631\u0627\u0621\u0629 \u0641\u0642\u0637: \u0644\u0646 \u064A\u0645\u0643\u0646 \u062A\u0639\u062F\u064A\u0644 \u0628\u0646\u0648\u062F\u0647\u0627 \u0628\u0639\u062F \u0630\u0644\u0643.",
      confirm: "\u0623\u0631\u0634\u0641\u0629",
      done: "\u062A\u0645\u062A \u0623\u0631\u0634\u0641\u0629 \u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u062A\u062D\u0642\u0642 {name}.",
      readOnly: "\u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u062A\u062D\u0642\u0642 \u0647\u0630\u0647 \u0645\u0624\u0631\u0634\u0641\u0629: \u0647\u064A \u0644\u0644\u0642\u0631\u0627\u0621\u0629 \u0641\u0642\u0637."
    }
  },
  templates: {
    title: "\u0642\u0648\u0627\u0626\u0645 \u0627\u0644\u062A\u062D\u0642\u0642",
    intro: "\u0646\u0645\u0627\u0630\u062C BatiFlow \u0644\u0644\u0642\u0631\u0627\u0621\u0629 \u0641\u0642\u0637: \u0627\u0646\u0633\u062E\u0648\u0627 \u0623\u062D\u062F\u0647\u0627 \u0644\u0645\u0644\u0627\u0621\u0645\u062A\u0647 \u0645\u0639 \u0645\u0643\u062A\u0628\u0643\u0645\u060C \u0623\u0648 \u0623\u0646\u0634\u0626\u0648\u0627 \u0646\u0645\u0648\u0630\u062C\u0643\u0645 \u0627\u0644\u062E\u0627\u0635. \u0643\u0644 \u062A\u0639\u062F\u064A\u0644 \u064A\u0646\u0634\u0626 \u0646\u0633\u062E\u0629 \u062C\u062F\u064A\u062F\u0629\u060C \u0648\u062A\u062D\u062A\u0641\u0638 \u0642\u0648\u0627\u0626\u0645 \u0627\u0644\u062A\u062D\u0642\u0642 \u0627\u0644\u0645\u0646\u0634\u0623\u0629 \u0633\u0627\u0628\u0642\u064B\u0627 \u0641\u064A \u0627\u0644\u0645\u0634\u0627\u0631\u064A\u0639 \u0628\u0646\u0633\u062E\u062A\u0647\u0627.",
    new: "\u0646\u0645\u0648\u0630\u062C \u062C\u062F\u064A\u062F",
    caption: "\u0646\u0645\u0627\u0630\u062C \u0642\u0648\u0627\u0626\u0645 \u0627\u0644\u062A\u062D\u0642\u0642",
    columns: {
      name: "\u0627\u0644\u0646\u0645\u0648\u0630\u062C",
      legalRef: "\u0627\u0644\u0645\u0631\u062C\u0639 \u0627\u0644\u0642\u0627\u0646\u0648\u0646\u064A",
      updatedOn: "\u0622\u062E\u0631 \u062A\u062D\u062F\u064A\u062B \u0641\u064A",
      items: "\u0627\u0644\u0628\u0646\u0648\u062F",
      actions: "\u0627\u0644\u0625\u062C\u0631\u0627\u0621\u0627\u062A"
    },
    origin: {
      system: "BatiFlow",
      org: "\u0645\u0643\u062A\u0628\u0643\u0645"
    },
    version: "\u0627\u0644\u0646\u0633\u062E\u0629 {version}",
    itemsCount: "{count, plural, one {\u0628\u0646\u062F \u0648\u0627\u062D\u062F} two {\u0628\u0646\u062F\u0627\u0646} few {# \u0628\u0646\u0648\u062F} many {# \u0628\u0646\u062F\u064B\u0627} other {# \u0628\u0646\u062F}}",
    systemReadOnly: "\u0646\u0645\u0648\u0630\u062C BatiFlow\u060C \u0644\u0644\u0642\u0631\u0627\u0621\u0629 \u0641\u0642\u0637",
    actions: {
      copy: "\u0646\u0633\u062E",
      copyOf: "\u0646\u0633\u062E \u0627\u0644\u0646\u0645\u0648\u0630\u062C {name}",
      edit: "\u062A\u0639\u062F\u064A\u0644",
      editOf: "\u062A\u0639\u062F\u064A\u0644 \u0627\u0644\u0646\u0645\u0648\u0630\u062C {name}",
      retire: "\u0633\u062D\u0628",
      retireOf: "\u0633\u062D\u0628 \u0627\u0644\u0646\u0645\u0648\u0630\u062C {name}"
    },
    loadFailed: "\u062A\u0639\u0630\u0631 \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0646\u0645\u0627\u0630\u062C.",
    empty: {
      title: "\u0644\u0627 \u064A\u0648\u062C\u062F \u0646\u0645\u0648\u0630\u062C \u0644\u0642\u0648\u0627\u0626\u0645 \u0627\u0644\u062A\u062D\u0642\u0642",
      body: "\u0623\u0646\u0634\u0626\u0648\u0627 \u0646\u0645\u0648\u0630\u062C\u064B\u0627 \u0644\u064A\u0633\u062A\u0639\u0645\u0644\u0647 \u0641\u0631\u064A\u0642\u0643\u0645 \u0641\u064A \u0627\u0644\u0645\u0634\u0627\u0631\u064A\u0639."
    },
    copy: {
      formLabel: "\u0646\u0633\u062E \u0646\u0645\u0648\u0630\u062C",
      title: "\u0646\u0633\u062E {name}",
      intro: "\u0627\u0644\u0646\u0633\u062E\u0629 \u0645\u0644\u0643 \u0644\u0645\u0643\u062A\u0628\u0643\u0645: \u064A\u0645\u0643\u0646\u0643\u0645 \u062A\u0639\u062F\u064A\u0644\u0647\u0627 \u0628\u0639\u062F \u0630\u0644\u0643.",
      name: "\u0627\u0633\u0645 \u0627\u0644\u0646\u0633\u062E\u0629 (\u0628\u0627\u0644\u0641\u0631\u0646\u0633\u064A\u0629)",
      suffix: "{name} (\u0646\u0633\u062E\u0629)",
      save: "\u0625\u0646\u0634\u0627\u0621 \u0627\u0644\u0646\u0633\u062E\u0629",
      done: "\u062A\u0645 \u0625\u0646\u0634\u0627\u0621 \u0627\u0644\u0646\u0645\u0648\u0630\u062C {name}."
    },
    editor: {
      formLabel: "\u0646\u0645\u0648\u0630\u062C \u0642\u0627\u0626\u0645\u0629 \u062A\u062D\u0642\u0642",
      newTitle: "\u0646\u0645\u0648\u0630\u062C \u0642\u0627\u0626\u0645\u0629 \u062A\u062D\u0642\u0642 \u062C\u062F\u064A\u062F",
      editTitle: "\u062A\u0639\u062F\u064A\u0644 {name}",
      newNote: "\u064A\u0645\u0643\u0646 \u0628\u0639\u062F \u0630\u0644\u0643 \u0627\u0633\u062A\u0639\u0645\u0627\u0644 \u0627\u0644\u0646\u0645\u0648\u0630\u062C \u0641\u064A \u0645\u0634\u0627\u0631\u064A\u0639 \u0645\u0643\u062A\u0628\u0643\u0645.",
      versionNote: "\u0627\u0644\u062D\u0641\u0638 \u064A\u0646\u0634\u0626 \u0646\u0633\u062E\u0629 \u062C\u062F\u064A\u062F\u0629 \u0645\u0646 \u0627\u0644\u0646\u0645\u0648\u0630\u062C. \u062A\u062D\u062A\u0641\u0638 \u0642\u0648\u0627\u0626\u0645 \u0627\u0644\u062A\u062D\u0642\u0642 \u0627\u0644\u0645\u0646\u0634\u0623\u0629 \u0633\u0627\u0628\u0642\u064B\u0627 \u0628\u0646\u0633\u062E\u062A\u0647\u0627.",
      nameFr: "\u0627\u0644\u0627\u0633\u0645 (\u0628\u0627\u0644\u0641\u0631\u0646\u0633\u064A\u0629)",
      nameAr: "\u0627\u0644\u0627\u0633\u0645 (\u0628\u0627\u0644\u0639\u0631\u0628\u064A\u0629)",
      nameEn: "\u0627\u0644\u0627\u0633\u0645 (\u0628\u0627\u0644\u0625\u0646\u062C\u0644\u064A\u0632\u064A\u0629)",
      legalRef: "\u0627\u0644\u0645\u0631\u062C\u0639 \u0627\u0644\u0642\u0627\u0646\u0648\u0646\u064A",
      legalRefHint: "\u0627\u0644\u0642\u0627\u0646\u0648\u0646 \u0623\u0648 \u0627\u0644\u0623\u0645\u0631 \u0623\u0648 \u0627\u0644\u0645\u0639\u064A\u0627\u0631 \u0627\u0644\u0630\u064A \u062A\u0633\u062A\u0646\u062F \u0625\u0644\u064A\u0647 \u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u062A\u062D\u0642\u0642.",
      updatedOn: "\u0622\u062E\u0631 \u062A\u062D\u062F\u064A\u062B \u0641\u064A",
      updatedOnHint: "\u062A\u0627\u0631\u064A\u062E \u0622\u062E\u0631 \u062A\u062D\u0642\u0642 \u0644\u0643\u0645 \u0645\u0646 \u0627\u0644\u0645\u0631\u062C\u0639 \u0627\u0644\u0642\u0627\u0646\u0648\u0646\u064A.",
      items: "\u0627\u0644\u0628\u0646\u0648\u062F \u0627\u0644\u0645\u0637\u0644\u0648\u0628 \u0627\u0644\u062A\u062D\u0642\u0642 \u0645\u0646\u0647\u0627",
      itemN: "\u0627\u0644\u0628\u0646\u062F {n}",
      itemFr: "\u0646\u0635 \u0627\u0644\u0628\u0646\u062F (\u0628\u0627\u0644\u0641\u0631\u0646\u0633\u064A\u0629)",
      itemAr: "\u0646\u0635 \u0627\u0644\u0628\u0646\u062F (\u0628\u0627\u0644\u0639\u0631\u0628\u064A\u0629)",
      itemEn: "\u0646\u0635 \u0627\u0644\u0628\u0646\u062F (\u0628\u0627\u0644\u0625\u0646\u062C\u0644\u064A\u0632\u064A\u0629)",
      itemHint: "\u062A\u0648\u0636\u064A\u062D (\u0627\u062E\u062A\u064A\u0627\u0631\u064A\u060C \u0628\u0627\u0644\u0641\u0631\u0646\u0633\u064A\u0629)",
      moveUp: "\u0631\u0641\u0639 \u0627\u0644\u0628\u0646\u062F {n}",
      moveDown: "\u062E\u0641\u0636 \u0627\u0644\u0628\u0646\u062F {n}",
      removeItem: "\u062D\u0630\u0641 \u0627\u0644\u0628\u0646\u062F {n}",
      addItem: "\u0625\u0636\u0627\u0641\u0629 \u0628\u0646\u062F",
      save: "\u062D\u0641\u0638 \u0627\u0644\u0646\u0645\u0648\u0630\u062C",
      saveVersion: "\u062D\u0641\u0638 \u0646\u0633\u062E\u0629 \u062C\u062F\u064A\u062F\u0629",
      saving: "\u062C\u0627\u0631\u064D \u0627\u0644\u062D\u0641\u0638\u2026",
      created: "\u062A\u0645 \u0625\u0646\u0634\u0627\u0621 \u0627\u0644\u0646\u0645\u0648\u0630\u062C {name}.",
      updated: "\u0623\u0635\u0628\u062D\u062A \u0644\u0644\u0646\u0645\u0648\u0630\u062C {name} \u0646\u0633\u062E\u0629 \u062C\u062F\u064A\u062F\u0629."
    },
    errors: {
      required: "\u0647\u0630\u0627 \u0627\u0644\u062D\u0642\u0644 \u0625\u0644\u0632\u0627\u0645\u064A.",
      date: "\u0623\u062F\u062E\u0644\u0648\u0627 \u062A\u0627\u0631\u064A\u062E\u064B\u0627 \u0635\u062D\u064A\u062D\u064B\u0627.",
      noItems: "\u0623\u0636\u064A\u0641\u0648\u0627 \u0628\u0646\u062F\u064B\u0627 \u0648\u0627\u062D\u062F\u064B\u0627 \u0639\u0644\u0649 \u0627\u0644\u0623\u0642\u0644.",
      summary: "{count, plural, one {\u064A\u062C\u0628 \u062A\u0635\u062D\u064A\u062D \u062D\u0642\u0644 \u0648\u0627\u062D\u062F.} two {\u064A\u062C\u0628 \u062A\u0635\u062D\u064A\u062D \u062D\u0642\u0644\u064A\u0646.} few {\u064A\u062C\u0628 \u062A\u0635\u062D\u064A\u062D # \u062D\u0642\u0648\u0644.} many {\u064A\u062C\u0628 \u062A\u0635\u062D\u064A\u062D # \u062D\u0642\u0644\u064B\u0627.} other {\u064A\u062C\u0628 \u062A\u0635\u062D\u064A\u062D # \u062D\u0642\u0644.}}"
    },
    retire: {
      title: "\u0633\u062D\u0628 {name}\u061F",
      body: "\u0644\u0646 \u064A\u064F\u0642\u062A\u0631\u062D \u0627\u0644\u0646\u0645\u0648\u0630\u062C \u0644\u0642\u0648\u0627\u0626\u0645 \u062A\u062D\u0642\u0642 \u062C\u062F\u064A\u062F\u0629. \u0623\u0645\u0627 \u0627\u0644\u0642\u0648\u0627\u0626\u0645 \u0627\u0644\u0645\u0648\u062C\u0648\u062F\u0629 \u0641\u064A \u0627\u0644\u0645\u0634\u0627\u0631\u064A\u0639 \u0641\u0644\u0627 \u062A\u062A\u063A\u064A\u0631.",
      confirm: "\u0633\u062D\u0628",
      done: "\u062A\u0645 \u0633\u062D\u0628 \u0627\u0644\u0646\u0645\u0648\u0630\u062C {name}."
    }
  }
};

// locales/en/field.json
var field_default2 = {
  disclaimer: "A memory aid, not legal advice.",
  errors: {
    CHECKLIST_ARCHIVED: "This checklist is archived: its items can no longer be changed.",
    CHECKLIST_TEMPLATE_RETIRED: "This template version was replaced or retired. Reload the list and choose the current version.",
    CHECKLIST_TEMPLATE_KEY_TAKEN: "A template with this name already exists in your office. Choose another name or edit that template.",
    PROJECT_ARCHIVED: "This project is archived: it is read-only until it is restored."
  },
  register: {
    title: "Drawing register",
    intro: "The project's drawings with their current index, approval status and transmittals. You only see the folders you have access to.",
    caption: "Drawing register of the project",
    filters: {
      label: "Register filters",
      docType: "Documents",
      drawing: "Drawings only",
      all: "All documents",
      discipline: "Discipline",
      allDisciplines: "All disciplines",
      phase: "Phase",
      allPhases: "All phases"
    },
    columns: {
      history: "Diffusion history",
      code: "Code",
      title: "Title",
      scale: "Scale",
      index: "Index",
      indexDate: "Index date",
      status: "Approval",
      lastTransmittal: "Last transmittal"
    },
    status: {
      in_progress: "In approval",
      approved: "Approved",
      approved_with_comments: "Approved with comments",
      rejected: "Rejected",
      none: "No approval"
    },
    noCode: "No code",
    none: "Not set",
    neverSent: "Never sent",
    transmittal: "Transmittal {number}",
    history: {
      show: "Show the diffusion history of {name}",
      hide: "Hide the diffusion history of {name}",
      title: "Diffusion history of {name}",
      empty: "This document has not been sent yet.",
      atIndex: "index"
    },
    count: "{count, plural, one {# document} other {# documents}}",
    truncated: "The register is too long to show in full. Narrow the filters to see the other documents, or export it.",
    empty: {
      title: "No drawings in the register",
      body: "Drawings appear here as soon as a version is uploaded to a folder of the project.",
      filteredTitle: "No document matches",
      filteredBody: "Change or remove a filter to see other documents."
    },
    loadFailedTitle: "The register could not be loaded",
    loadFailedBody: "Check your connection and try again.",
    upgrade: {
      title: "The drawing register is not included in your plan",
      bodyOwner: "Upgrade to a higher plan to keep the drawing register up to date automatically and export it as PDF or Excel.",
      bodyMember: "The drawing register is not included in your office's plan. Contact your office administrator to upgrade to a higher plan.",
      action: "See the plans"
    }
  },
  export: {
    menu: "Export",
    menuLabel: "Export the drawing register",
    options: {
      pdf_fr: "PDF (French)",
      pdf_ar: "PDF (Arabic)",
      xlsx_fr: "Excel (French)",
      xlsx_ar: "Excel (Arabic)",
      xlsx_en: "Excel (English)"
    },
    pending: "Your export is being prepared. You can keep working.",
    ready: "Your export is ready.",
    download: "Download {fileName}",
    downloadGeneric: "Download the file",
    failed: "The export could not be prepared. Try again in a moment.",
    slow: "The export is taking longer than expected. You can check again in a moment.",
    checkAgain: "Check again",
    rateLimited: "You asked for several exports in a short time. Wait a minute, then try again."
  },
  checklists: {
    title: "Regulatory checklists",
    intro: "Follow the project's compliance point by point with BatiFlow's checklists and your office's own.",
    listLabel: "Project checklists",
    legalRef: "Legal reference:",
    updatedOn: "Updated on",
    templateVersion: "Template version {version}",
    completed: "Completed",
    archived: "Archived",
    completedNote: "Every item is dealt with: the checklist is complete.",
    viewOnly: "You can read this checklist but not change it.",
    progress: "{handled} of {total} items dealt with",
    progressDetail: "{done} done, {na} not applicable, {todo} to do",
    progressBar: "Progress of {name}",
    stale: "Someone else changed this checklist at the same time. It has just been reloaded: check its state, then make your change again.",
    loadFailedTitle: "The checklists could not be loaded",
    loadFailedBody: "Check your connection and try again.",
    empty: {
      title: "No checklist for this project",
      body: "Create a checklist from a template (building permit, fire safety, accessibility\u2026) to follow the project's compliance.",
      bodyNoRights: "No checklist has been created for this project yet."
    },
    new: {
      action: "New checklist",
      title: "New checklist",
      intro: "Choose a template. The project gets a copy: if the template changes later, this checklist does not.",
      templates: "Checklist templates",
      choose: "Choose a template to continue.",
      none: "No template is available at the moment.",
      loadFailed: "The templates could not be loaded.",
      create: "Create the checklist",
      creating: "Creating\u2026",
      done: "The checklist {name} has been created."
    },
    items: {
      listLabel: "Items of the checklist {name}",
      stateOf: "State of the item: {label}",
      states: {
        todo: "To do",
        done: "Done",
        not_applicable: "Not applicable"
      },
      doneBy: "Done by {name} on",
      note: "Note: {note}",
      noteLabel: "Note on the item: {label}",
      noteSave: "Save the note",
      addNote: "Add a note",
      editNote: "Edit the note",
      addNoteOf: "Add a note to the item: {label}",
      editNoteOf: "Edit the note of the item: {label}"
    },
    archive: {
      action: "Archive",
      title: "Archive {name}?",
      body: "An archived checklist becomes read-only: its items can no longer be changed.",
      confirm: "Archive",
      done: "The checklist {name} is archived.",
      readOnly: "This checklist is archived: it is read-only."
    }
  },
  templates: {
    title: "Checklists",
    intro: "BatiFlow's templates are read-only: copy one to adapt it to your office, or create your own. Each change makes a new version; checklists already created in projects keep theirs.",
    new: "New template",
    caption: "Checklist templates",
    columns: {
      name: "Template",
      legalRef: "Legal reference",
      updatedOn: "Updated on",
      items: "Items",
      actions: "Actions"
    },
    origin: {
      system: "BatiFlow",
      org: "Your office"
    },
    version: "Version {version}",
    itemsCount: "{count, plural, one {# item} other {# items}}",
    systemReadOnly: "BatiFlow template, read-only",
    actions: {
      copy: "Copy",
      copyOf: "Copy the template {name}",
      edit: "Edit",
      editOf: "Edit the template {name}",
      retire: "Retire",
      retireOf: "Retire the template {name}"
    },
    loadFailed: "The templates could not be loaded.",
    empty: {
      title: "No checklist template",
      body: "Create a template so your team can use it in projects."
    },
    copy: {
      formLabel: "Copy a template",
      title: "Copy {name}",
      intro: "The copy belongs to your office: you can edit it afterwards.",
      name: "Name of the copy (French)",
      suffix: "{name} (copy)",
      save: "Create the copy",
      done: "The template {name} has been created."
    },
    editor: {
      formLabel: "Checklist template",
      newTitle: "New checklist template",
      editTitle: "Edit {name}",
      newNote: "The template can then be used in your office's projects.",
      versionNote: "Saving makes a new version of the template. Checklists already created keep their version.",
      nameFr: "Name (French)",
      nameAr: "Name (Arabic)",
      nameEn: "Name (English)",
      legalRef: "Legal reference",
      legalRefHint: "The law, decree or standard the checklist is based on.",
      updatedOn: "Updated on",
      updatedOnHint: "The date you last checked the legal reference.",
      items: "Items to check",
      itemN: "Item {n}",
      itemFr: "Item text (French)",
      itemAr: "Item text (Arabic)",
      itemEn: "Item text (English)",
      itemHint: "Detail (optional, French)",
      moveUp: "Move item {n} up",
      moveDown: "Move item {n} down",
      removeItem: "Remove item {n}",
      addItem: "Add an item",
      save: "Save the template",
      saveVersion: "Save a new version",
      saving: "Saving\u2026",
      created: "The template {name} has been created.",
      updated: "The template {name} has a new version."
    },
    errors: {
      required: "This field is required.",
      date: "Enter a valid date.",
      noItems: "Add at least one item.",
      summary: "{count, plural, one {# field needs fixing.} other {# fields need fixing.}}"
    },
    retire: {
      title: "Retire {name}?",
      body: "The template will no longer be offered for new checklists. Those already in projects do not change.",
      confirm: "Retire",
      done: "The template {name} is retired."
    }
  }
};

// locales/fr/field.json
var field_default3 = {
  disclaimer: "Aide-m\xE9moire, pas un avis juridique.",
  errors: {
    CHECKLIST_ARCHIVED: "Cette check-list est archiv\xE9e : ses points ne peuvent plus \xEAtre modifi\xE9s.",
    CHECKLIST_TEMPLATE_RETIRED: "Cette version du mod\xE8le a \xE9t\xE9 remplac\xE9e ou retir\xE9e. Rechargez la liste et choisissez la version actuelle.",
    CHECKLIST_TEMPLATE_KEY_TAKEN: "Un mod\xE8le portant ce nom existe d\xE9j\xE0 dans votre bureau. Choisissez un autre nom ou modifiez ce mod\xE8le.",
    PROJECT_ARCHIVED: "Ce projet est archiv\xE9 : il est en lecture seule tant qu\u2019il n\u2019est pas restaur\xE9."
  },
  register: {
    title: "Registre des plans",
    intro: "La liste des plans du projet avec leur indice en vigueur, leur \xE9tat de visa et leurs envois. Vous ne voyez que les dossiers auxquels vous avez acc\xE8s.",
    caption: "Registre des plans du projet",
    filters: {
      label: "Filtres du registre",
      docType: "Documents",
      drawing: "Plans uniquement",
      all: "Tous les documents",
      discipline: "Discipline",
      allDisciplines: "Toutes les disciplines",
      phase: "Phase",
      allPhases: "Toutes les phases"
    },
    columns: {
      history: "Historique de diffusion",
      code: "Code",
      title: "Titre",
      scale: "\xC9chelle",
      index: "Indice",
      indexDate: "Date de l\u2019indice",
      status: "Visa",
      lastTransmittal: "Dernier envoi"
    },
    status: {
      in_progress: "En cours de visa",
      approved: "Approuv\xE9",
      approved_with_comments: "Approuv\xE9 avec observations",
      rejected: "Refus\xE9",
      none: "Sans visa"
    },
    noCode: "Sans code",
    none: "Non renseign\xE9",
    neverSent: "Jamais envoy\xE9",
    transmittal: "Bordereau {number}",
    history: {
      show: "Afficher l\u2019historique de diffusion de {name}",
      hide: "Masquer l\u2019historique de diffusion de {name}",
      title: "Historique de diffusion de {name}",
      empty: "Ce document n\u2019a pas encore \xE9t\xE9 diffus\xE9.",
      atIndex: "indice"
    },
    count: "{count, plural, one {# document} other {# documents}}",
    truncated: "Le registre est trop long pour \xEAtre affich\xE9 en entier. Affinez les filtres pour voir les autres documents, ou exportez-le.",
    empty: {
      title: "Aucun plan dans le registre",
      body: "Les plans apparaissent ici d\xE8s qu\u2019une version est d\xE9pos\xE9e dans un dossier du projet.",
      filteredTitle: "Aucun document ne correspond",
      filteredBody: "Changez ou retirez un filtre pour voir d\u2019autres documents."
    },
    loadFailedTitle: "Le registre n\u2019a pas pu \xEAtre charg\xE9",
    loadFailedBody: "V\xE9rifiez votre connexion puis r\xE9essayez.",
    upgrade: {
      title: "Le registre des plans n\u2019est pas inclus dans votre offre",
      bodyOwner: "Passez \xE0 une offre sup\xE9rieure pour tenir le registre des plans \xE0 jour automatiquement et l\u2019exporter en PDF ou en Excel.",
      bodyMember: "Le registre des plans n\u2019est pas inclus dans l\u2019offre de votre bureau. Contactez l\u2019administrateur de votre bureau pour passer \xE0 une offre sup\xE9rieure.",
      action: "Voir les offres"
    }
  },
  export: {
    menu: "Exporter",
    menuLabel: "Exporter le registre des plans",
    options: {
      pdf_fr: "PDF (fran\xE7ais)",
      pdf_ar: "PDF (arabe)",
      xlsx_fr: "Excel (fran\xE7ais)",
      xlsx_ar: "Excel (arabe)",
      xlsx_en: "Excel (anglais)"
    },
    pending: "Pr\xE9paration de l\u2019export en cours. Vous pouvez continuer \xE0 travailler.",
    ready: "Votre export est pr\xEAt.",
    download: "T\xE9l\xE9charger {fileName}",
    downloadGeneric: "T\xE9l\xE9charger le fichier",
    failed: "L\u2019export n\u2019a pas pu \xEAtre pr\xE9par\xE9. R\xE9essayez dans un instant.",
    slow: "L\u2019export prend plus de temps que pr\xE9vu. Vous pouvez v\xE9rifier \xE0 nouveau dans un moment.",
    checkAgain: "V\xE9rifier \xE0 nouveau",
    rateLimited: "Vous avez demand\xE9 plusieurs exports en peu de temps. Patientez une minute, puis r\xE9essayez."
  },
  checklists: {
    title: "Check-lists r\xE9glementaires",
    intro: "Suivez la conformit\xE9 du projet point par point avec les check-lists de BatiFlow et celles de votre bureau.",
    listLabel: "Check-lists du projet",
    legalRef: "R\xE9f\xE9rence l\xE9gale :",
    updatedOn: "Mis \xE0 jour le",
    templateVersion: "Version {version} du mod\xE8le",
    completed: "Termin\xE9e",
    archived: "Archiv\xE9e",
    completedNote: "Tous les points sont trait\xE9s : la check-list est termin\xE9e.",
    viewOnly: "Vous pouvez consulter cette check-list, mais pas la modifier.",
    progress: "{handled} sur {total} points trait\xE9s",
    progressDetail: "{done, plural, one {# fait} other {# faits}}, {na} sans objet, {todo} \xE0 faire",
    progressBar: "Avancement de {name}",
    stale: "Cette check-list a \xE9t\xE9 modifi\xE9e par quelqu\u2019un d\u2019autre en m\xEAme temps. Elle vient d\u2019\xEAtre recharg\xE9e : v\xE9rifiez son \xE9tat, puis recommencez votre changement.",
    loadFailedTitle: "Les check-lists n\u2019ont pas pu \xEAtre charg\xE9es",
    loadFailedBody: "V\xE9rifiez votre connexion puis r\xE9essayez.",
    empty: {
      title: "Aucune check-list pour ce projet",
      body: "Cr\xE9ez une check-list \xE0 partir d\u2019un mod\xE8le (permis de construire, s\xE9curit\xE9 incendie, accessibilit\xE9\u2026) pour suivre la conformit\xE9 du projet.",
      bodyNoRights: "Aucune check-list n\u2019a encore \xE9t\xE9 cr\xE9\xE9e pour ce projet."
    },
    new: {
      action: "Nouvelle check-list",
      title: "Nouvelle check-list",
      intro: "Choisissez un mod\xE8le. Le projet en re\xE7oit une copie : si le mod\xE8le change plus tard, cette check-list ne change pas.",
      templates: "Mod\xE8les de check-list",
      choose: "Choisissez un mod\xE8le pour continuer.",
      none: "Aucun mod\xE8le n\u2019est disponible pour le moment.",
      loadFailed: "Les mod\xE8les n\u2019ont pas pu \xEAtre charg\xE9s.",
      create: "Cr\xE9er la check-list",
      creating: "Cr\xE9ation\u2026",
      done: "La check-list {name} a \xE9t\xE9 cr\xE9\xE9e."
    },
    items: {
      listLabel: "Points de la check-list {name}",
      stateOf: "\xC9tat du point : {label}",
      states: {
        todo: "\xC0 faire",
        done: "Fait",
        not_applicable: "Sans objet"
      },
      doneBy: "Fait par {name}, le",
      note: "Note : {note}",
      noteLabel: "Note sur le point : {label}",
      noteSave: "Enregistrer la note",
      addNote: "Ajouter une note",
      editNote: "Modifier la note",
      addNoteOf: "Ajouter une note au point : {label}",
      editNoteOf: "Modifier la note du point : {label}"
    },
    archive: {
      action: "Archiver",
      title: "Archiver {name} ?",
      body: "Une check-list archiv\xE9e devient en lecture seule : ses points ne pourront plus \xEAtre modifi\xE9s.",
      confirm: "Archiver",
      done: "La check-list {name} est archiv\xE9e.",
      readOnly: "Cette check-list est archiv\xE9e : elle est en lecture seule."
    }
  },
  templates: {
    title: "Check-lists",
    intro: "Les mod\xE8les de BatiFlow sont en lecture seule : copiez-en un pour l\u2019adapter \xE0 votre bureau, ou cr\xE9ez le v\xF4tre. Chaque modification cr\xE9e une nouvelle version ; les check-lists d\xE9j\xE0 cr\xE9\xE9es dans les projets gardent leur version.",
    new: "Nouveau mod\xE8le",
    caption: "Mod\xE8les de check-list",
    columns: {
      name: "Mod\xE8le",
      legalRef: "R\xE9f\xE9rence l\xE9gale",
      updatedOn: "Mis \xE0 jour le",
      items: "Points",
      actions: "Actions"
    },
    origin: {
      system: "BatiFlow",
      org: "Votre bureau"
    },
    version: "Version {version}",
    itemsCount: "{count, plural, one {# point} other {# points}}",
    systemReadOnly: "Mod\xE8le BatiFlow, en lecture seule",
    actions: {
      copy: "Copier",
      copyOf: "Copier le mod\xE8le {name}",
      edit: "Modifier",
      editOf: "Modifier le mod\xE8le {name}",
      retire: "Retirer",
      retireOf: "Retirer le mod\xE8le {name}"
    },
    loadFailed: "Les mod\xE8les n\u2019ont pas pu \xEAtre charg\xE9s.",
    empty: {
      title: "Aucun mod\xE8le de check-list",
      body: "Cr\xE9ez un mod\xE8le pour que votre \xE9quipe puisse l\u2019utiliser dans les projets."
    },
    copy: {
      formLabel: "Copier un mod\xE8le",
      title: "Copier {name}",
      intro: "La copie appartient \xE0 votre bureau : vous pourrez ensuite la modifier.",
      name: "Nom de la copie (fran\xE7ais)",
      suffix: "{name} (copie)",
      save: "Cr\xE9er la copie",
      done: "Le mod\xE8le {name} a \xE9t\xE9 cr\xE9\xE9."
    },
    editor: {
      formLabel: "Mod\xE8le de check-list",
      newTitle: "Nouveau mod\xE8le de check-list",
      editTitle: "Modifier {name}",
      newNote: "Le mod\xE8le pourra ensuite \xEAtre utilis\xE9 dans les projets de votre bureau.",
      versionNote: "Enregistrer cr\xE9e une nouvelle version du mod\xE8le. Les check-lists d\xE9j\xE0 cr\xE9\xE9es gardent leur version.",
      nameFr: "Nom (fran\xE7ais)",
      nameAr: "Nom (arabe)",
      nameEn: "Nom (anglais)",
      legalRef: "R\xE9f\xE9rence l\xE9gale",
      legalRefHint: "Le texte de loi, le d\xE9cret ou la norme sur lesquels s\u2019appuie la check-list.",
      updatedOn: "Mis \xE0 jour le",
      updatedOnHint: "La date \xE0 laquelle vous avez v\xE9rifi\xE9 la r\xE9f\xE9rence l\xE9gale.",
      items: "Points \xE0 v\xE9rifier",
      itemN: "Point {n}",
      itemFr: "Texte du point (fran\xE7ais)",
      itemAr: "Texte du point (arabe)",
      itemEn: "Texte du point (anglais)",
      itemHint: "Pr\xE9cision (facultatif, fran\xE7ais)",
      moveUp: "Monter le point {n}",
      moveDown: "Descendre le point {n}",
      removeItem: "Supprimer le point {n}",
      addItem: "Ajouter un point",
      save: "Enregistrer le mod\xE8le",
      saveVersion: "Enregistrer une nouvelle version",
      saving: "Enregistrement\u2026",
      created: "Le mod\xE8le {name} a \xE9t\xE9 cr\xE9\xE9.",
      updated: "Le mod\xE8le {name} a une nouvelle version."
    },
    errors: {
      required: "Ce champ est obligatoire.",
      date: "Saisissez une date valide.",
      noItems: "Ajoutez au moins un point.",
      summary: "{count, plural, one {# champ est \xE0 corriger.} other {# champs sont \xE0 corriger.}}"
    },
    retire: {
      title: "Retirer {name} ?",
      body: "Le mod\xE8le ne sera plus propos\xE9 pour de nouvelles check-lists. Celles qui existent d\xE9j\xE0 dans les projets ne changent pas.",
      confirm: "Retirer",
      done: "Le mod\xE8le {name} est retir\xE9."
    }
  }
};

// locales/ar/transmittals.json
var transmittals_default = {
  title: "\u0628\u0637\u0627\u0642\u0627\u062A \u0627\u0644\u0625\u0631\u0633\u0627\u0644",
  open: "\u0628\u0637\u0627\u0642\u0627\u062A \u0627\u0644\u0625\u0631\u0633\u0627\u0644",
  send: {
    action: "\u0625\u0631\u0633\u0627\u0644 \u0645\u0639 \u0628\u0637\u0627\u0642\u0629 \u0625\u0631\u0633\u0627\u0644",
    title: "\u0625\u0631\u0633\u0627\u0644 \u0645\u0639 \u0628\u0637\u0627\u0642\u0629 \u0625\u0631\u0633\u0627\u0644",
    intro: "\u064A\u062A\u0644\u0642\u0649 \u0627\u0644\u0645\u0633\u062A\u0644\u0645\u0648\u0646 \u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u0648\u062B\u0627\u0626\u0642 \u0623\u062F\u0646\u0627\u0647 \u0645\u0639 \u0645\u0624\u0634\u0631\u0647\u0627 \u0627\u0644\u062D\u0627\u0644\u064A. \u064A\u064F\u062D\u062A\u0641\u0638 \u0628\u0633\u062C\u0644 \u0644\u0643\u0644 \u0639\u0645\u0644\u064A\u0629 \u0625\u0631\u0633\u0627\u0644 \u0648\u0644\u0643\u0644 \u0625\u0634\u0639\u0627\u0631 \u0628\u0627\u0644\u0627\u0633\u062A\u0644\u0627\u0645.",
    subject: {
      label: "\u0627\u0644\u0645\u0648\u0636\u0648\u0639",
      hint: "\u064A\u0638\u0647\u0631 \u0641\u064A \u0623\u0639\u0644\u0649 \u0628\u0637\u0627\u0642\u0629 \u0627\u0644\u0625\u0631\u0633\u0627\u0644\u060C \u0645\u062B\u0644 \xAB\u0645\u062E\u0637\u0637\u0627\u062A \u062A\u0646\u0641\u064A\u0630 \u0627\u0644\u0623\u0634\u063A\u0627\u0644 \u0627\u0644\u0643\u0628\u0631\u0649\xBB.",
      required: "\u0627\u0643\u062A\u0628 \u0645\u0648\u0636\u0648\u0639 \u0628\u0637\u0627\u0642\u0629 \u0627\u0644\u0625\u0631\u0633\u0627\u0644."
    },
    message: {
      label: "\u0627\u0644\u0631\u0633\u0627\u0644\u0629",
      hint: "\u0627\u062E\u062A\u064A\u0627\u0631\u064A. \u062A\u0638\u0647\u0631 \u0639\u0644\u0649 \u0628\u0637\u0627\u0642\u0629 \u0627\u0644\u0625\u0631\u0633\u0627\u0644."
    },
    language: {
      label: "\u0644\u063A\u0629 \u0628\u0637\u0627\u0642\u0629 \u0627\u0644\u0625\u0631\u0633\u0627\u0644",
      fr: "\u0627\u0644\u0641\u0631\u0646\u0633\u064A\u0629",
      ar: "\u0627\u0644\u0639\u0631\u0628\u064A\u0629"
    },
    submit: "\u0625\u0631\u0633\u0627\u0644 \u0628\u0637\u0627\u0642\u0629 \u0627\u0644\u0625\u0631\u0633\u0627\u0644",
    sending: "\u062C\u0627\u0631\u064D \u0627\u0644\u0625\u0631\u0633\u0627\u0644\u2026",
    sent: "\u062A\u0645 \u0625\u0631\u0633\u0627\u0644 \u0628\u0637\u0627\u0642\u0629 \u0627\u0644\u0625\u0631\u0633\u0627\u0644 {number}",
    formInvalid: "\u0623\u0643\u0645\u0644 \u0627\u0644\u062D\u0642\u0648\u0644 \u0627\u0644\u0645\u0634\u0627\u0631 \u0625\u0644\u064A\u0647\u0627 \u0642\u0628\u0644 \u0625\u0631\u0633\u0627\u0644 \u0628\u0637\u0627\u0642\u0629 \u0627\u0644\u0625\u0631\u0633\u0627\u0644."
  },
  documents: {
    title: "{count, plural, one {\u0627\u0644\u0648\u062B\u064A\u0642\u0629 \u0627\u0644\u0645\u0631\u0641\u0642\u0629 (#)} two {\u0627\u0644\u0648\u062B\u064A\u0642\u062A\u0627\u0646 \u0627\u0644\u0645\u0631\u0641\u0642\u062A\u0627\u0646 (#)} few {\u0627\u0644\u0648\u062B\u0627\u0626\u0642 \u0627\u0644\u0645\u0631\u0641\u0642\u0629 (#)} many {\u0627\u0644\u0648\u062B\u0627\u0626\u0642 \u0627\u0644\u0645\u0631\u0641\u0642\u0629 (#)} other {\u0627\u0644\u0648\u062B\u0627\u0626\u0642 \u0627\u0644\u0645\u0631\u0641\u0642\u0629 (#)}}",
    listLabel: "\u0648\u062B\u0627\u0626\u0642 \u0628\u0637\u0627\u0642\u0629 \u0627\u0644\u0625\u0631\u0633\u0627\u0644",
    index: "\u0627\u0644\u0645\u0624\u0634\u0631 {index}",
    noIndex: "\u0628\u0644\u0627 \u0645\u0624\u0634\u0631",
    noCode: "\u0628\u0644\u0627 \u0631\u0645\u0632",
    unavailable: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0646\u0633\u062E\u0629 \u0645\u062A\u0627\u062D\u0629",
    unavailableNote: "{count, plural, one {\u0644\u064A\u0633\u062A \u0644\u0648\u062B\u064A\u0642\u0629 \u0648\u0627\u062D\u062F\u0629 \u0646\u0633\u062E\u0629 \u0645\u062A\u0627\u062D\u0629 \u0628\u0639\u062F (\u0642\u064A\u062F \u0627\u0644\u0641\u062D\u0635 \u0623\u0648 \u0631\u064F\u0641\u0636\u062A \u0627\u0644\u0646\u0633\u062E\u0629): \u0644\u0646 \u062A\u064F\u062F\u0631\u062C \u0641\u064A \u0628\u0637\u0627\u0642\u0629 \u0627\u0644\u0625\u0631\u0633\u0627\u0644.} two {\u0644\u064A\u0633\u062A \u0644\u0648\u062B\u064A\u0642\u062A\u064A\u0646 \u0646\u0633\u062E\u0629 \u0645\u062A\u0627\u062D\u0629 \u0628\u0639\u062F (\u0642\u064A\u062F \u0627\u0644\u0641\u062D\u0635 \u0623\u0648 \u0631\u064F\u0641\u0636\u062A \u0627\u0644\u0646\u0633\u062E\u0629): \u0644\u0646 \u062A\u064F\u062F\u0631\u062C\u0627 \u0641\u064A \u0628\u0637\u0627\u0642\u0629 \u0627\u0644\u0625\u0631\u0633\u0627\u0644.} few {\u0644\u064A\u0633\u062A \u0644\u0640 # \u0648\u062B\u0627\u0626\u0642 \u0646\u0633\u062E\u0629 \u0645\u062A\u0627\u062D\u0629 \u0628\u0639\u062F (\u0642\u064A\u062F \u0627\u0644\u0641\u062D\u0635 \u0623\u0648 \u0631\u064F\u0641\u0636\u062A \u0627\u0644\u0646\u0633\u062E\u0629): \u0644\u0646 \u062A\u064F\u062F\u0631\u062C \u0641\u064A \u0628\u0637\u0627\u0642\u0629 \u0627\u0644\u0625\u0631\u0633\u0627\u0644.} many {\u0644\u064A\u0633\u062A \u0644\u0640 # \u0648\u062B\u064A\u0642\u0629 \u0646\u0633\u062E\u0629 \u0645\u062A\u0627\u062D\u0629 \u0628\u0639\u062F (\u0642\u064A\u062F \u0627\u0644\u0641\u062D\u0635 \u0623\u0648 \u0631\u064F\u0641\u0636\u062A \u0627\u0644\u0646\u0633\u062E\u0629): \u0644\u0646 \u062A\u064F\u062F\u0631\u062C \u0641\u064A \u0628\u0637\u0627\u0642\u0629 \u0627\u0644\u0625\u0631\u0633\u0627\u0644.} other {\u0644\u064A\u0633\u062A \u0644\u0640 # \u0648\u062B\u064A\u0642\u0629 \u0646\u0633\u062E\u0629 \u0645\u062A\u0627\u062D\u0629 \u0628\u0639\u062F (\u0642\u064A\u062F \u0627\u0644\u0641\u062D\u0635 \u0623\u0648 \u0631\u064F\u0641\u0636\u062A \u0627\u0644\u0646\u0633\u062E\u0629): \u0644\u0646 \u062A\u064F\u062F\u0631\u062C \u0641\u064A \u0628\u0637\u0627\u0642\u0629 \u0627\u0644\u0625\u0631\u0633\u0627\u0644.}}",
    newerChecking: "\u0646\u0633\u062E\u0629 \u0623\u062D\u062F\u062B \u0642\u064A\u062F \u0627\u0644\u0641\u062D\u0635: \u0627\u0644\u0645\u0624\u0634\u0631 \u0627\u0644\u0645\u064F\u0631\u0633\u064E\u0644 \u0647\u0648 {index}.",
    noneSendable: "\u0644\u064A\u0633\u062A \u0644\u0623\u064A \u0645\u0646 \u0627\u0644\u0648\u062B\u0627\u0626\u0642 \u0627\u0644\u0645\u062E\u062A\u0627\u0631\u0629 \u0646\u0633\u062E\u0629 \u0645\u062A\u0627\u062D\u0629: \u0644\u0627 \u0634\u064A\u0621 \u064A\u064F\u0631\u0633\u064E\u0644 \u0641\u064A \u0627\u0644\u0648\u0642\u062A \u0627\u0644\u062D\u0627\u0644\u064A.",
    tooMany: "\u062A\u062A\u0633\u0639 \u0628\u0637\u0627\u0642\u0629 \u0627\u0644\u0625\u0631\u0633\u0627\u0644 \u0644\u0640 {max} \u0648\u062B\u064A\u0642\u0629 \u0639\u0644\u0649 \u0627\u0644\u0623\u0643\u062B\u0631. \u0623\u0632\u0644 \u0628\u0639\u0636 \u0627\u0644\u0648\u062B\u0627\u0626\u0642 \u0645\u0646 \u0627\u0644\u062A\u062D\u062F\u064A\u062F."
  },
  recipients: {
    title: "\u0627\u0644\u0645\u0633\u062A\u0644\u0645\u0648\u0646",
    people: {
      label: "\u0623\u0634\u062E\u0627\u0635 \u0647\u0630\u0647 \u0627\u0644\u0645\u0633\u0627\u062D\u0629",
      hint: "\u064A\u0624\u0643\u062F\u0648\u0646 \u0627\u0644\u0627\u0633\u062A\u0644\u0627\u0645 \u062F\u0627\u062E\u0644 BatiFlow.",
      loadFailed: "\u062A\u0639\u0630\u0651\u0631 \u062A\u062D\u0645\u064A\u0644 \u0642\u0627\u0626\u0645\u0629 \u0623\u0634\u062E\u0627\u0635 \u0627\u0644\u0645\u0633\u0627\u062D\u0629. \u0645\u0627 \u0632\u0627\u0644 \u0628\u0625\u0645\u0643\u0627\u0646\u0643 \u0625\u0636\u0627\u0641\u0629 \u0639\u0646\u0627\u0648\u064A\u0646 \u0628\u0631\u064A\u062F \u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A."
    },
    email: {
      title: "\u0639\u0646\u0627\u0648\u064A\u0646 \u0627\u0644\u0628\u0631\u064A\u062F \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A",
      hint: "\u064A\u062A\u0644\u0642\u0649 \u0643\u0644 \u0639\u0646\u0648\u0627\u0646 \u0631\u0627\u0628\u0637\u064B\u0627 \u0622\u0645\u0646\u064B\u0627 \u0635\u0627\u0644\u062D\u064B\u0627 \u0644\u0645\u062F\u0629 {days} \u064A\u0648\u0645\u064B\u0627\u060C \u0645\u0639 \u0646\u0633\u062E \u062A\u062D\u0645\u0644 \u0639\u0644\u0627\u0645\u0629 \u0645\u0627\u0626\u064A\u0629 \u0628\u0627\u0633\u0645\u0647. \u0644\u0627 \u062D\u0627\u062C\u0629 \u0625\u0644\u0649 \u062D\u0633\u0627\u0628.",
      address: "\u0639\u0646\u0648\u0627\u0646 \u0627\u0644\u0628\u0631\u064A\u062F \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A",
      name: "\u0627\u0644\u0627\u0633\u0645 (\u0627\u062E\u062A\u064A\u0627\u0631\u064A)",
      add: "\u0625\u0636\u0627\u0641\u0629 \u0627\u0644\u0639\u0646\u0648\u0627\u0646",
      invalid: "\u0639\u0646\u0648\u0627\u0646 \u0627\u0644\u0628\u0631\u064A\u062F \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A \u0647\u0630\u0627 \u063A\u064A\u0631 \u0635\u0627\u0644\u062D.",
      duplicate: "\u0647\u0630\u0627 \u0627\u0644\u0639\u0646\u0648\u0627\u0646 \u0645\u0648\u062C\u0648\u062F \u0641\u064A \u0627\u0644\u0642\u0627\u0626\u0645\u0629.",
      remove: "\u0625\u0632\u0627\u0644\u0629 {name}",
      listLabel: "\u0639\u0646\u0627\u0648\u064A\u0646 \u0627\u0644\u0628\u0631\u064A\u062F \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A \u0627\u0644\u0645\u0636\u0627\u0641\u0629"
    },
    none: "\u0623\u0636\u0641 \u0645\u0633\u062A\u0644\u0645\u064B\u0627 \u0648\u0627\u062D\u062F\u064B\u0627 \u0639\u0644\u0649 \u0627\u0644\u0623\u0642\u0644.",
    tooMany: "\u062A\u062A\u0633\u0639 \u0628\u0637\u0627\u0642\u0629 \u0627\u0644\u0625\u0631\u0633\u0627\u0644 \u0644\u0640 {max} \u0645\u0633\u062A\u0644\u0645\u064B\u0627 \u0639\u0644\u0649 \u0627\u0644\u0623\u0643\u062B\u0631."
  },
  errors: {
    failedTitle: "\u062A\u0639\u0630\u0651\u0631 \u0627\u0644\u0625\u0631\u0633\u0627\u0644",
    recipient: {
      RECIPIENT_CANNOT_ENTER: "{name} \u0644\u0627 \u064A\u0645\u0644\u0643 \u062D\u0642 \u0627\u0644\u062F\u062E\u0648\u0644 \u0625\u0644\u0649 \u0647\u0630\u0647 \u0627\u0644\u0645\u0633\u0627\u062D\u0629. \u0623\u0632\u0644 \u0647\u0630\u0627 \u0627\u0644\u0634\u062E\u0635 \u0623\u0648 \u0627\u062F\u0639\u064F\u0647 \u0625\u0644\u0649 \u0627\u0644\u0645\u0633\u0627\u062D\u0629 \u0623\u0648\u0644\u064B\u0627.",
      RECIPIENT_DOMAIN_NOT_ALLOWED: "\u0627\u0644\u0639\u0646\u0648\u0627\u0646 {name} \u0644\u064A\u0633 \u0645\u0646 \u0646\u0637\u0627\u0642 \u0645\u0633\u0645\u0648\u062D \u0628\u0647 \u0644\u0636\u064A\u0648\u0641 \u0647\u0630\u0647 \u0627\u0644\u0645\u0633\u0627\u062D\u0629. \u062A\u064F\u0636\u0628\u0637 \u0627\u0644\u0646\u0637\u0627\u0642\u0627\u062A \u0627\u0644\u0645\u0633\u0645\u0648\u062D \u0628\u0647\u0627 \u0641\u064A \u0625\u0639\u062F\u0627\u062F\u0627\u062A \u0627\u0644\u0645\u0633\u0627\u062D\u0629.",
      RECIPIENT_DUPLICATE: "{name} \u0645\u0630\u0643\u0648\u0631 \u0645\u0631\u062A\u064A\u0646 \u0641\u064A \u0627\u0644\u0642\u0627\u0626\u0645\u0629.",
      other: "\u062A\u062A\u0639\u0630\u0651\u0631 \u0625\u0636\u0627\u0641\u0629 \u0627\u0644\u0645\u0633\u062A\u0644\u0645 {name}."
    },
    version: {
      VERSION_NOT_AVAILABLE: "\u0644\u064A\u0633\u062A \u0644\u0640 \xAB{name}\xBB \u0646\u0633\u062E\u0629 \u0645\u062A\u0627\u062D\u0629: \u0647\u064A \u0642\u064A\u062F \u0627\u0644\u0641\u062D\u0635 \u0623\u0648 \u0631\u064F\u0641\u0636\u062A \u0627\u0644\u0646\u0633\u062E\u0629.",
      VERSION_NOT_FOUND: "\u0644\u0645 \u062A\u0639\u062F \xAB{name}\xBB \u0645\u0648\u062C\u0648\u062F\u0629 \u0641\u064A \u0647\u0630\u0647 \u0627\u0644\u0645\u0633\u0627\u062D\u0629. \u0623\u0639\u062F \u062A\u062D\u0645\u064A\u0644 \u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u0648\u062B\u0627\u0626\u0642.",
      other: "\u062A\u062A\u0639\u0630\u0651\u0631 \u0625\u0631\u0633\u0627\u0644 \xAB{name}\xBB."
    },
    validation: "\u062A\u0639\u0630\u0651\u0631 \u0625\u0631\u0633\u0627\u0644 \u0628\u0637\u0627\u0642\u0629 \u0627\u0644\u0625\u0631\u0633\u0627\u0644: \u062A\u062D\u0642\u0642 \u0645\u0646 \u0627\u0644\u062D\u0642\u0648\u0644 \u062B\u0645 \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629.",
    forbidden: "\u0644\u0627 \u064A\u0633\u062A\u0637\u064A\u0639 \u0625\u0631\u0633\u0627\u0644 \u0628\u0637\u0627\u0642\u0629 \u0625\u0631\u0633\u0627\u0644 \u0625\u0644\u0627 \u0645\u0633\u0624\u0648\u0644\u0648 \u0627\u0644\u0645\u0633\u0627\u062D\u0629.",
    conflict: "\u0639\u0645\u0644\u064A\u0629 \u0627\u0644\u0625\u0631\u0633\u0627\u0644 \u0647\u0630\u0647 \u0642\u064A\u062F \u0627\u0644\u0645\u0639\u0627\u0644\u062C\u0629 \u0628\u0627\u0644\u0641\u0639\u0644. \u0627\u0646\u062A\u0638\u0631 \u0642\u0644\u064A\u0644\u064B\u0627 \u0648\u0631\u0627\u062C\u0639 \u0642\u0627\u0626\u0645\u0629 \u0628\u0637\u0627\u0642\u0627\u062A \u0627\u0644\u0625\u0631\u0633\u0627\u0644 \u0642\u0628\u0644 \u0627\u0644\u0625\u0631\u0633\u0627\u0644 \u0645\u0646 \u062C\u062F\u064A\u062F.",
    generic: "\u062A\u0639\u0630\u0651\u0631 \u0625\u0631\u0633\u0627\u0644 \u0628\u0637\u0627\u0642\u0629 \u0627\u0644\u0625\u0631\u0633\u0627\u0644. \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629 \u0628\u0639\u062F \u0642\u0644\u064A\u0644."
  },
  list: {
    region: "\u0628\u0637\u0627\u0642\u0627\u062A \u0627\u0644\u0625\u0631\u0633\u0627\u0644",
    title: "\u0628\u0637\u0627\u0642\u0627\u062A \u0627\u0644\u0625\u0631\u0633\u0627\u0644",
    intro: "\u0643\u0644 \u0639\u0645\u0644\u064A\u0629 \u0625\u0631\u0633\u0627\u0644 \u0648\u062B\u0627\u0626\u0642 \u0645\u0646 \u0647\u0630\u0647 \u0627\u0644\u0645\u0633\u0627\u062D\u0629\u060C \u0645\u0639 \u0625\u0634\u0639\u0627\u0631\u0627\u062A \u0627\u0644\u0627\u0633\u062A\u0644\u0627\u0645 \u0645\u0646 \u0627\u0644\u0645\u0633\u062A\u0644\u0645\u064A\u0646.",
    caption: "\u0628\u0637\u0627\u0642\u0627\u062A \u0625\u0631\u0633\u0627\u0644 \u0627\u0644\u0645\u0633\u0627\u062D\u0629",
    back: "\u0627\u0644\u0639\u0648\u062F\u0629 \u0625\u0644\u0649 \u0627\u0644\u0645\u062C\u0644\u062F\u0627\u062A",
    columns: {
      number: "\u0627\u0644\u0631\u0642\u0645",
      subject: "\u0627\u0644\u0645\u0648\u0636\u0648\u0639",
      date: "\u0627\u0644\u062A\u0627\u0631\u064A\u062E",
      sent: "\u0627\u0644\u0625\u0631\u0633\u0627\u0644 (\u0627\u0644\u062A\u0627\u0631\u064A\u062E\u060C \u0627\u0644\u0645\u0631\u0633\u0644)",
      sender: "\u0623\u0631\u0633\u0644\u0647\u0627",
      documents: "\u0627\u0644\u0648\u062B\u0627\u0626\u0642",
      acknowledged: "\u0625\u0634\u0639\u0627\u0631\u0627\u062A \u0627\u0644\u0627\u0633\u062A\u0644\u0627\u0645"
    },
    unknownSender: "\u0634\u062E\u0635 \u063A\u064A\u0631 \u0645\u0639\u0631\u0648\u0641",
    empty: {
      title: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0628\u0637\u0627\u0642\u0629 \u0625\u0631\u0633\u0627\u0644 \u0628\u0639\u062F",
      descriptionManage: "\u062D\u062F\u0651\u062F \u0648\u062B\u0627\u0626\u0642 \u0641\u064A \u0645\u062C\u0644\u062F\u060C \u062B\u0645 \u0627\u062E\u062A\u0631 \xAB\u0625\u0631\u0633\u0627\u0644 \u0645\u0639 \u0628\u0637\u0627\u0642\u0629 \u0625\u0631\u0633\u0627\u0644\xBB.",
      descriptionRead: "\u0633\u062A\u0638\u0647\u0631 \u0647\u0646\u0627 \u0628\u0637\u0627\u0642\u0627\u062A \u0627\u0644\u0625\u0631\u0633\u0627\u0644 \u0627\u0644\u0645\u064F\u0631\u0633\u064E\u0644\u0629 \u0645\u0646 \u0647\u0630\u0647 \u0627\u0644\u0645\u0633\u0627\u062D\u0629."
    },
    loadFailed: "\u062A\u0639\u0630\u0651\u0631 \u062A\u062D\u0645\u064A\u0644 \u0642\u0627\u0626\u0645\u0629 \u0628\u0637\u0627\u0642\u0627\u062A \u0627\u0644\u0625\u0631\u0633\u0627\u0644.",
    moreFailed: "\u062A\u0639\u0630\u0651\u0631 \u062A\u062D\u0645\u064A\u0644 \u0628\u0642\u064A\u0629 \u0627\u0644\u0642\u0627\u0626\u0645\u0629.",
    shown: "{count, plural, one {\u0639\u064F\u0631\u0636\u062A \u0628\u0637\u0627\u0642\u0629 \u0625\u0631\u0633\u0627\u0644 \u0648\u0627\u062D\u062F\u0629} two {\u0639\u064F\u0631\u0636\u062A \u0628\u0637\u0627\u0642\u062A\u0627 \u0625\u0631\u0633\u0627\u0644} few {\u0639\u064F\u0631\u0636\u062A # \u0628\u0637\u0627\u0642\u0627\u062A \u0625\u0631\u0633\u0627\u0644} many {\u0639\u064F\u0631\u0636\u062A # \u0628\u0637\u0627\u0642\u0629 \u0625\u0631\u0633\u0627\u0644} other {\u0639\u064F\u0631\u0636\u062A # \u0628\u0637\u0627\u0642\u0629 \u0625\u0631\u0633\u0627\u0644}}",
    more: "\u0639\u0631\u0636 \u0627\u0644\u0645\u0632\u064A\u062F",
    loadingMore: "\u062C\u0627\u0631\u064D \u0627\u0644\u062A\u062D\u0645\u064A\u0644\u2026"
  },
  ack: {
    summary: "\u062A\u0645 \u062A\u0623\u0643\u064A\u062F \u0627\u0633\u062A\u0644\u0627\u0645 {acknowledged} \u0645\u0646 {total}",
    complete: "\u0623\u0643\u0651\u062F \u062C\u0645\u064A\u0639 \u0627\u0644\u0645\u0633\u062A\u0644\u0645\u064A\u0646 \u0627\u0644\u0627\u0633\u062A\u0644\u0627\u0645",
    pending: "\u0641\u064A \u0627\u0646\u062A\u0638\u0627\u0631 \u062A\u0623\u0643\u064A\u062F \u0627\u0644\u0627\u0633\u062A\u0644\u0627\u0645"
  },
  detail: {
    title: "\u0628\u0637\u0627\u0642\u0629 \u0627\u0644\u0625\u0631\u0633\u0627\u0644 {number}",
    close: "\u0625\u063A\u0644\u0627\u0642 \u0628\u0637\u0627\u0642\u0629 \u0627\u0644\u0625\u0631\u0633\u0627\u0644",
    sentBy: "\u0623\u064F\u0631\u0633\u0644\u062A \u0641\u064A {date} \u0628\u0648\u0627\u0633\u0637\u0629 {name}",
    sentAt: "\u0623\u064F\u0631\u0633\u0644\u062A \u0641\u064A {date}",
    message: "\u0627\u0644\u0631\u0633\u0627\u0644\u0629",
    items: "{count, plural, one {\u0627\u0644\u0648\u062B\u064A\u0642\u0629 (#)} two {\u0627\u0644\u0648\u062B\u064A\u0642\u062A\u0627\u0646 (#)} few {\u0627\u0644\u0648\u062B\u0627\u0626\u0642 (#)} many {\u0627\u0644\u0648\u062B\u0627\u0626\u0642 (#)} other {\u0627\u0644\u0648\u062B\u0627\u0626\u0642 (#)}}",
    itemsLabel: "\u0648\u062B\u0627\u0626\u0642 \u0628\u0637\u0627\u0642\u0629 \u0627\u0644\u0625\u0631\u0633\u0627\u0644",
    recipients: "{count, plural, one {\u0627\u0644\u0645\u0633\u062A\u0644\u0645 (#)} two {\u0627\u0644\u0645\u0633\u062A\u0644\u0645\u0627\u0646 (#)} few {\u0627\u0644\u0645\u0633\u062A\u0644\u0645\u0648\u0646 (#)} many {\u0627\u0644\u0645\u0633\u062A\u0644\u0645\u0648\u0646 (#)} other {\u0627\u0644\u0645\u0633\u062A\u0644\u0645\u0648\u0646 (#)}}",
    recipientsLabel: "\u0645\u0633\u062A\u0644\u0645\u0648 \u0628\u0637\u0627\u0642\u0629 \u0627\u0644\u0625\u0631\u0633\u0627\u0644",
    externalRecipient: "\u0645\u0633\u062A\u0644\u0645 \u062E\u0627\u0631\u062C\u064A",
    channel: {
      user: "\u062F\u0627\u062E\u0644 BatiFlow",
      email: "\u0639\u0628\u0631 \u0631\u0627\u0628\u0637 \u0622\u0645\u0646"
    },
    status: {
      acknowledged: "\u062A\u0645 \u062A\u0623\u0643\u064A\u062F \u0627\u0644\u0627\u0633\u062A\u0644\u0627\u0645 \u0641\u064A {date}",
      acknowledgedVia: {
        app: "\u062F\u0627\u062E\u0644 BatiFlow",
        link: "\u0639\u0628\u0631 \u0627\u0644\u0631\u0627\u0628\u0637"
      },
      waiting: "\u0641\u064A \u0627\u0646\u062A\u0638\u0627\u0631 \u062A\u0623\u0643\u064A\u062F \u0627\u0644\u0627\u0633\u062A\u0644\u0627\u0645",
      viewed: "\u0627\u0637\u0651\u0644\u0639 \u0641\u064A {date}",
      emailed: "\u0623\u064F\u0631\u0633\u0644 \u0627\u0644\u0628\u0631\u064A\u062F \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A \u0641\u064A {date}"
    },
    pdf: {
      open: "\u0641\u062A\u062D \u0645\u0644\u0641 PDF",
      opening: "\u062C\u0627\u0631\u064D \u0627\u0644\u0641\u062A\u062D\u2026",
      preparing: "\u0645\u0644\u0641 PDF \u0644\u0628\u0637\u0627\u0642\u0629 \u0627\u0644\u0625\u0631\u0633\u0627\u0644 \u0642\u064A\u062F \u0627\u0644\u0625\u0639\u062F\u0627\u062F. \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629 \u0628\u0639\u062F \u0628\u0636\u0639 \u062B\u0648\u0627\u0646\u064D.",
      failed: "\u062A\u0639\u0630\u0651\u0631 \u0641\u062A\u062D \u0645\u0644\u0641 PDF. \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629 \u0628\u0639\u062F \u0642\u0644\u064A\u0644."
    },
    ack: {
      action: "\u062A\u0623\u0643\u064A\u062F \u0627\u0644\u0627\u0633\u062A\u0644\u0627\u0645",
      sending: "\u062C\u0627\u0631\u064D \u0627\u0644\u0625\u0631\u0633\u0627\u0644\u2026",
      hint: "\u0623\u0646\u062A \u0645\u0646 \u0645\u0633\u062A\u0644\u0645\u064A \u0628\u0637\u0627\u0642\u0629 \u0627\u0644\u0625\u0631\u0633\u0627\u0644 \u0647\u0630\u0647: \u0623\u0643\u0651\u062F \u0623\u0646\u0643 \u062A\u0633\u0644\u0651\u0645\u062A \u0647\u0630\u0647 \u0627\u0644\u0648\u062B\u0627\u0626\u0642.",
      done: "\u062A\u0645 \u062A\u0623\u0643\u064A\u062F \u0627\u0633\u062A\u0644\u0627\u0645 \u0628\u0637\u0627\u0642\u0629 \u0627\u0644\u0625\u0631\u0633\u0627\u0644 {number}.",
      failed: "\u062A\u0639\u0630\u0651\u0631 \u062A\u0633\u062C\u064A\u0644 \u062A\u0623\u0643\u064A\u062F \u0627\u0644\u0627\u0633\u062A\u0644\u0627\u0645. \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629 \u0628\u0639\u062F \u0642\u0644\u064A\u0644.",
      mine: "\u0623\u0643\u0651\u062F\u062A \u0627\u0644\u0627\u0633\u062A\u0644\u0627\u0645 \u0641\u064A {date}."
    },
    loadFailed: "\u062A\u0639\u0630\u0651\u0631 \u062A\u062D\u0645\u064A\u0644 \u0628\u0637\u0627\u0642\u0629 \u0627\u0644\u0625\u0631\u0633\u0627\u0644 \u0647\u0630\u0647.",
    notFound: "\u0628\u0637\u0627\u0642\u0629 \u0627\u0644\u0625\u0631\u0633\u0627\u0644 \u0647\u0630\u0647 \u063A\u064A\u0631 \u0645\u0648\u062C\u0648\u062F\u0629 \u0623\u0648 \u0644\u0645 \u062A\u0639\u062F \u0645\u062A\u0627\u062D\u0629."
  },
  diffusion: {
    title: "\u0633\u062C\u0644 \u0627\u0644\u062A\u0648\u0632\u064A\u0639",
    send: "\u0625\u0631\u0633\u0627\u0644 \u0647\u0630\u0647 \u0627\u0644\u0648\u062B\u064A\u0642\u0629",
    listLabel: "\u0628\u0637\u0627\u0642\u0627\u062A \u0627\u0644\u0625\u0631\u0633\u0627\u0644 \u0627\u0644\u062A\u064A \u062D\u0645\u0644\u062A \u0647\u0630\u0647 \u0627\u0644\u0648\u062B\u064A\u0642\u0629",
    empty: "\u0644\u0645 \u062A\u064F\u0631\u0633\u064E\u0644 \u0647\u0630\u0647 \u0627\u0644\u0648\u062B\u064A\u0642\u0629 \u0641\u064A \u0623\u064A \u0628\u0637\u0627\u0642\u0629 \u0625\u0631\u0633\u0627\u0644 \u0628\u0639\u062F. \u0633\u062A\u0638\u0647\u0631 \u0647\u0646\u0627 \u0643\u0644 \u0639\u0645\u0644\u064A\u0629 \u0625\u0631\u0633\u0627\u0644 \u0645\u0639 \u0625\u0634\u0639\u0627\u0631\u0627\u062A \u0627\u0644\u0627\u0633\u062A\u0644\u0627\u0645.",
    sentIndex: "\u0627\u0644\u0645\u0624\u0634\u0631 \u0627\u0644\u0645\u064F\u0631\u0633\u064E\u0644: {index}",
    recipients: "{count, plural, one {\u0645\u0633\u062A\u0644\u0645 \u0648\u0627\u062D\u062F} two {\u0645\u0633\u062A\u0644\u0645\u0627\u0646} few {# \u0645\u0633\u062A\u0644\u0645\u064A\u0646} many {# \u0645\u0633\u062A\u0644\u0645\u064B\u0627} other {# \u0645\u0633\u062A\u0644\u0645}}",
    open: "\u0639\u0631\u0636 \u0628\u0637\u0627\u0642\u0629 \u0627\u0644\u0625\u0631\u0633\u0627\u0644 {number}",
    loadFailed: "\u062A\u0639\u0630\u0651\u0631 \u062A\u062D\u0645\u064A\u0644 \u0633\u062C\u0644 \u0627\u0644\u062A\u0648\u0632\u064A\u0639."
  },
  public: {
    brand: "\u0628\u0637\u0627\u0642\u0629 \u0625\u0631\u0633\u0627\u0644 \u0645\u0646 {organization}",
    language: "\u0627\u0644\u0644\u063A\u0629",
    number: "\u0628\u0637\u0627\u0642\u0629 \u0627\u0644\u0625\u0631\u0633\u0627\u0644 {number}",
    sentOn: "\u0623\u0631\u0633\u0644\u062A\u0647\u0627 {organization} \u0641\u064A {date}",
    messageTitle: "\u0631\u0633\u0627\u0644\u0629 \u0627\u0644\u0645\u064F\u0631\u0633\u0650\u0644",
    itemsTitle: "\u0627\u0644\u0648\u062B\u0627\u0626\u0642",
    itemsCaption: "\u0648\u062B\u0627\u0626\u0642 \u0628\u0637\u0627\u0642\u0629 \u0627\u0644\u0625\u0631\u0633\u0627\u0644",
    columns: {
      code: "\u0627\u0644\u0631\u0645\u0632",
      title: "\u0627\u0644\u0639\u0646\u0648\u0627\u0646",
      index: "\u0627\u0644\u0645\u0624\u0634\u0631",
      actions: "\u0627\u0644\u0625\u062C\u0631\u0627\u0621\u0627\u062A"
    },
    noCode: "\u0628\u0644\u0627 \u0631\u0645\u0632",
    noIndex: "\u0628\u0644\u0627 \u0645\u0624\u0634\u0631",
    preview: "\u0645\u0639\u0627\u064A\u0646\u0629",
    previewLabel: "\u0645\u0639\u0627\u064A\u0646\u0629 {name}",
    download: "\u062A\u0646\u0632\u064A\u0644",
    downloadLabel: "\u062A\u0646\u0632\u064A\u0644 {name}",
    watermark: "\u062A\u062D\u0645\u0644 \u0643\u0644 \u0646\u0633\u062E\u0629 \u0639\u0644\u0627\u0645\u0629 \u0645\u0627\u0626\u064A\u0629 \u0628\u0627\u0633\u0645\u0643 \u0648\u0647\u064A \u0645\u062E\u0635\u0635\u0629 \u0644\u0627\u0633\u062A\u0639\u0645\u0627\u0644\u0643 \u0648\u062D\u062F\u0643.",
    preparing: "\u0646\u0633\u062E\u0629 \xAB{name}\xBB \u0642\u064A\u062F \u0627\u0644\u0625\u0639\u062F\u0627\u062F \u0628\u0627\u0633\u0645\u0643. \u0644\u062D\u0638\u0629 \u0645\u0646 \u0641\u0636\u0644\u0643\u2026",
    stillPreparing: "\u0646\u0633\u062E\u0629 \xAB{name}\xBB \u0645\u0627 \u0632\u0627\u0644\u062A \u0642\u064A\u062F \u0627\u0644\u0625\u0639\u062F\u0627\u062F. \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629 \u0628\u0639\u062F \u0644\u062D\u0638\u0627\u062A.",
    ready: "\u0646\u0633\u062E\u0629 \xAB{name}\xBB \u062C\u0627\u0647\u0632\u0629. \u062A\u0628\u0642\u0649 \u0645\u062A\u0627\u062D\u0629 \u0644\u0645\u062F\u0629 \u062F\u0642\u064A\u0642\u0629.",
    openCopy: "\u0641\u062A\u062D \u0627\u0644\u0646\u0633\u062E\u0629",
    downloadsOff: "\u0639\u0637\u0651\u0644 \u0627\u0644\u0645\u064F\u0631\u0633\u0650\u0644 \u062A\u0646\u0632\u064A\u0644 \u0647\u0630\u0647 \u0627\u0644\u0648\u062B\u0627\u0626\u0642. \u064A\u0645\u0643\u0646\u0643 \u0627\u0644\u0627\u0637\u0644\u0627\u0639 \u0639\u0644\u064A\u0647\u0627 \u0639\u0628\u0631 \u0627\u0644\u0625\u0646\u062A\u0631\u0646\u062A \u0628\u0648\u0627\u0633\u0637\u0629 \xAB\u0645\u0639\u0627\u064A\u0646\u0629\xBB.",
    noPreview: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0645\u0639\u0627\u064A\u0646\u0629 \u0639\u0628\u0631 \u0627\u0644\u0625\u0646\u062A\u0631\u0646\u062A \u0644\u0647\u0630\u0627 \u0627\u0644\u0646\u0648\u0639 \u0645\u0646 \u0627\u0644\u0645\u0644\u0641\u0627\u062A. \u0627\u0633\u062A\u0639\u0645\u0644 \xAB\u062A\u0646\u0632\u064A\u0644\xBB.",
    itemFailed: "\u062A\u0639\u0630\u0651\u0631 \u0641\u062A\u062D \xAB{name}\xBB. \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629 \u0628\u0639\u062F \u0642\u0644\u064A\u0644.",
    ack: {
      title: "\u062A\u0623\u0643\u064A\u062F \u0627\u0644\u0627\u0633\u062A\u0644\u0627\u0645",
      intro: "\u0623\u0643\u0651\u062F \u0623\u0646\u0643 \u062A\u0633\u0644\u0651\u0645\u062A \u0648\u062B\u0627\u0626\u0642 \u0628\u0637\u0627\u0642\u0629 \u0627\u0644\u0625\u0631\u0633\u0627\u0644 \u0647\u0630\u0647. \u0633\u064A\u064F\u0628\u0644\u064E\u0651\u063A \u0627\u0644\u0645\u064F\u0631\u0633\u0650\u0644 \u0628\u0630\u0644\u0643.",
      action: "\u062A\u0623\u0643\u064A\u062F \u0627\u0644\u0627\u0633\u062A\u0644\u0627\u0645",
      sending: "\u062C\u0627\u0631\u064D \u0627\u0644\u0625\u0631\u0633\u0627\u0644\u2026",
      failedTitle: "\u0644\u0645 \u064A\u064F\u0633\u062C\u064E\u0651\u0644 \u0627\u0644\u062A\u0623\u0643\u064A\u062F",
      failed: "\u062A\u0639\u0630\u0651\u0631 \u062A\u0633\u062C\u064A\u0644 \u062A\u0623\u0643\u064A\u062F \u0627\u0644\u0627\u0633\u062A\u0644\u0627\u0645. \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629 \u0628\u0639\u062F \u0642\u0644\u064A\u0644.",
      doneTitle: "\u062A\u0645 \u062A\u0623\u0643\u064A\u062F \u0627\u0644\u0627\u0633\u062A\u0644\u0627\u0645",
      done: "\u062A\u0645 \u062A\u0623\u0643\u064A\u062F \u0627\u0644\u0627\u0633\u062A\u0644\u0627\u0645 \u0641\u064A {date}. \u0623\u064F\u0628\u0644\u063A \u0627\u0644\u0645\u064F\u0631\u0633\u0650\u0644 \u0628\u0630\u0644\u0643.",
      justDone: "\u0634\u0643\u0631\u064B\u0627! \u0633\u064F\u062C\u0651\u0644 \u062A\u0623\u0643\u064A\u062F \u0627\u0633\u062A\u0644\u0627\u0645\u0643 \u0644\u0628\u0637\u0627\u0642\u0629 \u0627\u0644\u0625\u0631\u0633\u0627\u0644 {number} \u0641\u064A {date}."
    },
    states: {
      loading: "\u062C\u0627\u0631\u064D \u062A\u062D\u0645\u064A\u0644 \u0628\u0637\u0627\u0642\u0629 \u0627\u0644\u0625\u0631\u0633\u0627\u0644",
      notFoundTitle: "\u0644\u0645 \u064A\u0639\u062F \u0647\u0630\u0627 \u0627\u0644\u0631\u0627\u0628\u0637 \u0635\u0627\u0644\u062D\u064B\u0627",
      notFoundBody: "\u0627\u0644\u0631\u0627\u0628\u0637 \u063A\u064A\u0631 \u0635\u062D\u064A\u062D \u0623\u0648 \u0627\u0646\u062A\u0647\u062A \u0635\u0644\u0627\u062D\u064A\u062A\u0647 (\u064A\u0628\u0642\u0649 \u0635\u0627\u0644\u062D\u064B\u0627 30 \u064A\u0648\u0645\u064B\u0627). \u0627\u0637\u0644\u0628 \u0645\u0646 \u0627\u0644\u0645\u0643\u062A\u0628 \u0627\u0644\u0630\u064A \u0623\u0631\u0633\u0644\u0647 \u0625\u0644\u064A\u0643 \u0623\u0646 \u064A\u0631\u0633\u0644 \u0644\u0643 \u0628\u0637\u0627\u0642\u0629 \u0627\u0644\u0625\u0631\u0633\u0627\u0644 \u0645\u0646 \u062C\u062F\u064A\u062F.",
      loadFailedTitle: "\u062A\u0639\u0630\u0651\u0631 \u062A\u062D\u0645\u064A\u0644 \u0628\u0637\u0627\u0642\u0629 \u0627\u0644\u0625\u0631\u0633\u0627\u0644",
      loadFailedBody: "\u062A\u062D\u0642\u0642 \u0645\u0646 \u0627\u062A\u0635\u0627\u0644\u0643 \u062B\u0645 \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629."
    }
  }
};

// locales/en/transmittals.json
var transmittals_default2 = {
  title: "Transmittals",
  open: "Transmittals",
  send: {
    action: "Send with a transmittal",
    title: "Send with a transmittal",
    intro: "Recipients get the list of documents below with their current index. Every sending and every acknowledgement is kept on record.",
    subject: {
      label: "Subject",
      hint: "It heads the transmittal, for example \u201CStructural works execution drawings\u201D.",
      required: "Enter the subject of the transmittal."
    },
    message: {
      label: "Message",
      hint: "Optional. It appears on the transmittal."
    },
    language: {
      label: "Transmittal language",
      fr: "French",
      ar: "Arabic"
    },
    submit: "Send the transmittal",
    sending: "Sending\u2026",
    sent: "Transmittal {number} sent",
    formInvalid: "Complete the highlighted fields before sending the transmittal."
  },
  documents: {
    title: "{count, plural, one {Attached document (#)} other {Attached documents (#)}}",
    listLabel: "Documents of the transmittal",
    index: "Index {index}",
    noIndex: "No index",
    noCode: "No code",
    unavailable: "No version available",
    unavailableNote: "{count, plural, one {# document has no available version yet (being checked, or the version was refused): it will not be included in the transmittal.} other {# documents have no available version yet (being checked, or the version was refused): they will not be included in the transmittal.}}",
    newerChecking: "A newer version is being checked: index {index} is the one that will be sent.",
    noneSendable: "None of the chosen documents has an available version: there is nothing to send for now.",
    tooMany: "A transmittal holds {max} documents at most. Remove some documents from the selection."
  },
  recipients: {
    title: "Recipients",
    people: {
      label: "People of this space",
      hint: "They acknowledge receipt in BatiFlow.",
      loadFailed: "The list of people of the space could not be loaded. You can still add e-mail addresses."
    },
    email: {
      title: "E-mail addresses",
      hint: "Each address gets a secure link valid for {days} days, with copies watermarked in its name. No account is needed.",
      address: "E-mail address",
      name: "Name (optional)",
      add: "Add the address",
      invalid: "This e-mail address is not valid.",
      duplicate: "This address is already in the list.",
      remove: "Remove {name}",
      listLabel: "E-mail addresses added"
    },
    none: "Add at least one recipient.",
    tooMany: "A transmittal has {max} recipients at most."
  },
  errors: {
    failedTitle: "Could not send",
    recipient: {
      RECIPIENT_CANNOT_ENTER: "{name} has no access to this space. Remove this person or invite them to the space first.",
      RECIPIENT_DOMAIN_NOT_ALLOWED: "The address {name} is not in a domain allowed for guests of this space. Allowed domains are set in the space settings.",
      RECIPIENT_DUPLICATE: "{name} appears twice in the list.",
      other: "The recipient {name} cannot be added."
    },
    version: {
      VERSION_NOT_AVAILABLE: "\u201C{name}\u201D has no available version: it is being checked, or the version was refused.",
      VERSION_NOT_FOUND: "\u201C{name}\u201D no longer exists in this space. Reload the document list.",
      other: "\u201C{name}\u201D cannot be sent."
    },
    validation: "The transmittal could not be sent: check the fields and try again.",
    forbidden: "Only the managers of the space can send a transmittal.",
    conflict: "This sending is already being processed. Wait a moment and check the list of transmittals before sending again.",
    generic: "The transmittal could not be sent. Try again in a moment."
  },
  list: {
    region: "Transmittals",
    title: "Transmittals",
    intro: "Every sending of documents from this space, with the recipients\u2019 acknowledgements.",
    caption: "Transmittals of the space",
    back: "Back to folders",
    columns: {
      number: "No.",
      subject: "Subject",
      date: "Date",
      sent: "Sent (date, by)",
      sender: "Sent by",
      documents: "Documents",
      acknowledged: "Acknowledgements"
    },
    unknownSender: "Unknown person",
    empty: {
      title: "No transmittal yet",
      descriptionManage: "Select documents in a folder, then choose \u201CSend with a transmittal\u201D.",
      descriptionRead: "Transmittals sent from this space will appear here."
    },
    loadFailed: "The list of transmittals could not be loaded.",
    moreFailed: "The rest of the list could not be loaded.",
    shown: "{count, plural, one {# transmittal shown} other {# transmittals shown}}",
    more: "Show more",
    loadingMore: "Loading\u2026"
  },
  ack: {
    summary: "{acknowledged} of {total} acknowledged",
    complete: "Every recipient has acknowledged receipt",
    pending: "Waiting for acknowledgement"
  },
  detail: {
    title: "Transmittal {number}",
    close: "Close the transmittal",
    sentBy: "Sent on {date} by {name}",
    sentAt: "Sent on {date}",
    message: "Message",
    items: "{count, plural, one {Document (#)} other {Documents (#)}}",
    itemsLabel: "Documents of the transmittal",
    recipients: "{count, plural, one {Recipient (#)} other {Recipients (#)}}",
    recipientsLabel: "Recipients of the transmittal",
    externalRecipient: "External recipient",
    channel: {
      user: "In BatiFlow",
      email: "By secure link"
    },
    status: {
      acknowledged: "Receipt confirmed on {date}",
      acknowledgedVia: {
        app: "in BatiFlow",
        link: "by the link"
      },
      waiting: "Waiting for acknowledgement",
      viewed: "Viewed on {date}",
      emailed: "E-mail sent on {date}"
    },
    pdf: {
      open: "Open the PDF",
      opening: "Opening\u2026",
      preparing: "The transmittal PDF is being prepared. Try again in a few seconds.",
      failed: "The PDF could not be opened. Try again in a moment."
    },
    ack: {
      action: "Acknowledge receipt",
      sending: "Sending\u2026",
      hint: "You are a recipient of this transmittal: confirm that you received these documents.",
      done: "Receipt of transmittal {number} confirmed.",
      failed: "Your acknowledgement could not be recorded. Try again in a moment.",
      mine: "You confirmed receipt on {date}."
    },
    loadFailed: "This transmittal could not be loaded.",
    notFound: "This transmittal does not exist or is no longer accessible."
  },
  diffusion: {
    title: "Distribution history",
    send: "Send this document",
    listLabel: "Transmittals that carried this document",
    empty: "This document has not been sent in any transmittal yet. Each sending will appear here with its acknowledgements.",
    sentIndex: "Index sent: {index}",
    recipients: "{count, plural, one {# recipient} other {# recipients}}",
    open: "View transmittal {number}",
    loadFailed: "The distribution history could not be loaded."
  },
  public: {
    brand: "Transmittal from {organization}",
    language: "Language",
    number: "Transmittal {number}",
    sentOn: "Sent by {organization} on {date}",
    messageTitle: "Message from the sender",
    itemsTitle: "Documents",
    itemsCaption: "Documents of the transmittal",
    columns: {
      code: "Code",
      title: "Title",
      index: "Index",
      actions: "Actions"
    },
    noCode: "No code",
    noIndex: "No index",
    preview: "Preview",
    previewLabel: "Preview {name}",
    download: "Download",
    downloadLabel: "Download {name}",
    watermark: "Every copy carries a watermark in your name and is for your use only.",
    preparing: "The copy of \u201C{name}\u201D is being prepared in your name. One moment\u2026",
    stillPreparing: "The copy of \u201C{name}\u201D is still being prepared. Try again in a few moments.",
    ready: "The copy of \u201C{name}\u201D is ready. It stays available for one minute.",
    openCopy: "Open the copy",
    downloadsOff: "The sender has turned off downloads for these documents. You can read them online with \u201CPreview\u201D.",
    noPreview: "This type of file has no online preview. Use \u201CDownload\u201D.",
    itemFailed: "\u201C{name}\u201D could not be opened. Try again in a moment.",
    ack: {
      title: "Acknowledge receipt",
      intro: "Confirm that you received the documents of this transmittal. The sender will be told.",
      action: "Acknowledge receipt",
      sending: "Sending\u2026",
      failedTitle: "Acknowledgement not recorded",
      failed: "Your acknowledgement could not be recorded. Try again in a moment.",
      doneTitle: "Receipt confirmed",
      done: "Receipt confirmed on {date}. The sender has been told.",
      justDone: "Thank you! Your acknowledgement of transmittal {number} is recorded, on {date}."
    },
    states: {
      loading: "Loading the transmittal",
      notFoundTitle: "This link is no longer valid",
      notFoundBody: "The link is incorrect or has expired (it stays valid for 30 days). Ask the office that sent it to send you the transmittal again.",
      loadFailedTitle: "The transmittal could not be loaded",
      loadFailedBody: "Check your connection and try again."
    }
  }
};

// locales/fr/transmittals.json
var transmittals_default3 = {
  title: "Bordereaux d\u2019envoi",
  open: "Bordereaux",
  send: {
    action: "Envoyer avec un bordereau",
    title: "Envoyer avec un bordereau",
    intro: "Les destinataires re\xE7oivent la liste des documents ci-dessous avec leur indice actuel. Chaque envoi et chaque accus\xE9 de r\xE9ception sont conserv\xE9s.",
    subject: {
      label: "Objet",
      hint: "Il figure en t\xEAte du bordereau, par exemple \xAB \xA0Plans d\u2019ex\xE9cution du gros \u0153uvre\xA0 \xBB.",
      required: "Indiquez l\u2019objet du bordereau."
    },
    message: {
      label: "Message",
      hint: "Facultatif. Il figure sur le bordereau."
    },
    language: {
      label: "Langue du bordereau",
      fr: "Fran\xE7ais",
      ar: "Arabe"
    },
    submit: "Envoyer le bordereau",
    sending: "Envoi en cours\u2026",
    sent: "Bordereau {number} envoy\xE9",
    formInvalid: "Compl\xE9tez les champs signal\xE9s avant d\u2019envoyer le bordereau."
  },
  documents: {
    title: "{count, plural, one {Document joint (#)} other {Documents joints (#)}}",
    listLabel: "Documents du bordereau",
    index: "Indice {index}",
    noIndex: "Sans indice",
    noCode: "Sans code",
    unavailable: "Pas de version disponible",
    unavailableNote: "{count, plural, one {# document n\u2019a pas encore de version disponible (contr\xF4le en cours ou version refus\xE9e)\xA0: il ne sera pas inclus dans le bordereau.} other {# documents n\u2019ont pas encore de version disponible (contr\xF4le en cours ou version refus\xE9e)\xA0: ils ne seront pas inclus dans le bordereau.}}",
    newerChecking: "Une version plus r\xE9cente est en cours de contr\xF4le\xA0: c\u2019est l\u2019indice {index} qui sera envoy\xE9.",
    noneSendable: "Aucun des documents choisis n\u2019a de version disponible\xA0: il n\u2019y a rien \xE0 envoyer pour le moment.",
    tooMany: "Un bordereau contient {max} documents au plus. Retirez des documents de la s\xE9lection."
  },
  recipients: {
    title: "Destinataires",
    people: {
      label: "Personnes de cet espace",
      hint: "Elles accusent r\xE9ception dans BatiFlow.",
      loadFailed: "La liste des personnes de l\u2019espace n\u2019a pas pu \xEAtre charg\xE9e. Vous pouvez tout de m\xEAme ajouter des adresses e-mail."
    },
    email: {
      title: "Adresses e-mail",
      hint: "Chaque adresse re\xE7oit un lien s\xE9curis\xE9 valable {days} jours, avec des copies filigran\xE9es \xE0 son nom. Aucun compte n\u2019est n\xE9cessaire.",
      address: "Adresse e-mail",
      name: "Nom (facultatif)",
      add: "Ajouter l\u2019adresse",
      invalid: "Cette adresse e-mail n\u2019est pas valide.",
      duplicate: "Cette adresse est d\xE9j\xE0 dans la liste.",
      remove: "Retirer {name}",
      listLabel: "Adresses e-mail ajout\xE9es"
    },
    none: "Ajoutez au moins un destinataire.",
    tooMany: "Un bordereau compte {max} destinataires au plus."
  },
  errors: {
    failedTitle: "Envoi impossible",
    recipient: {
      RECIPIENT_CANNOT_ENTER: "{name} n\u2019a pas acc\xE8s \xE0 cet espace. Retirez cette personne ou invitez-la d\u2019abord dans l\u2019espace.",
      RECIPIENT_DOMAIN_NOT_ALLOWED: "L\u2019adresse {name} n\u2019appartient pas \xE0 un domaine autoris\xE9 pour les invit\xE9s de cet espace. Les domaines autoris\xE9s se r\xE8glent dans les param\xE8tres de l\u2019espace.",
      RECIPIENT_DUPLICATE: "{name} figure deux fois dans la liste.",
      other: "Le destinataire {name} ne peut pas \xEAtre ajout\xE9."
    },
    version: {
      VERSION_NOT_AVAILABLE: "\xAB \xA0{name}\xA0 \xBB n\u2019a pas de version disponible\xA0: le contr\xF4le est en cours ou la version a \xE9t\xE9 refus\xE9e.",
      VERSION_NOT_FOUND: "\xAB \xA0{name}\xA0 \xBB n\u2019existe plus dans cet espace. Rechargez la liste des documents.",
      other: "\xAB \xA0{name}\xA0 \xBB ne peut pas \xEAtre envoy\xE9."
    },
    validation: "Le bordereau n\u2019a pas pu \xEAtre envoy\xE9\xA0: v\xE9rifiez les champs puis r\xE9essayez.",
    forbidden: "Seuls les responsables de l\u2019espace peuvent envoyer un bordereau.",
    conflict: "Cet envoi est d\xE9j\xE0 en cours de traitement. Patientez un instant et consultez la liste des bordereaux avant de renvoyer.",
    generic: "Le bordereau n\u2019a pas pu \xEAtre envoy\xE9. R\xE9essayez dans un instant."
  },
  list: {
    region: "Bordereaux d\u2019envoi",
    title: "Bordereaux d\u2019envoi",
    intro: "Chaque envoi de documents depuis cet espace, avec les accus\xE9s de r\xE9ception des destinataires.",
    caption: "Bordereaux d\u2019envoi de l\u2019espace",
    back: "Retour aux dossiers",
    columns: {
      number: "N\xB0",
      subject: "Objet",
      date: "Date",
      sent: "Envoi (date, par)",
      sender: "Envoy\xE9 par",
      documents: "Documents",
      acknowledged: "Accus\xE9s de r\xE9ception"
    },
    unknownSender: "Personne inconnue",
    empty: {
      title: "Aucun bordereau pour l\u2019instant",
      descriptionManage: "S\xE9lectionnez des documents dans un dossier, puis choisissez \xAB \xA0Envoyer avec un bordereau\xA0 \xBB.",
      descriptionRead: "Les bordereaux envoy\xE9s depuis cet espace appara\xEEtront ici."
    },
    loadFailed: "La liste des bordereaux n\u2019a pas pu \xEAtre charg\xE9e.",
    moreFailed: "La suite de la liste n\u2019a pas pu \xEAtre charg\xE9e.",
    shown: "{count, plural, one {# bordereau affich\xE9} other {# bordereaux affich\xE9s}}",
    more: "Afficher la suite",
    loadingMore: "Chargement\u2026"
  },
  ack: {
    summary: "{acknowledged, plural, one {# accus\xE9} other {# accus\xE9s}} sur {total}",
    complete: "Tous les destinataires ont accus\xE9 r\xE9ception",
    pending: "En attente d\u2019accus\xE9 de r\xE9ception"
  },
  detail: {
    title: "Bordereau {number}",
    close: "Fermer le bordereau",
    sentBy: "Envoy\xE9 le {date} par {name}",
    sentAt: "Envoy\xE9 le {date}",
    message: "Message",
    items: "{count, plural, one {Document (#)} other {Documents (#)}}",
    itemsLabel: "Documents du bordereau",
    recipients: "{count, plural, one {Destinataire (#)} other {Destinataires (#)}}",
    recipientsLabel: "Destinataires du bordereau",
    externalRecipient: "Destinataire externe",
    channel: {
      user: "Dans BatiFlow",
      email: "Par lien s\xE9curis\xE9"
    },
    status: {
      acknowledged: "R\xE9ception confirm\xE9e le {date}",
      acknowledgedVia: {
        app: "dans BatiFlow",
        link: "par le lien"
      },
      waiting: "En attente d\u2019accus\xE9 de r\xE9ception",
      viewed: "Consult\xE9 le {date}",
      emailed: "E-mail envoy\xE9 le {date}"
    },
    pdf: {
      open: "Ouvrir le PDF",
      opening: "Ouverture\u2026",
      preparing: "Le bordereau PDF est en cours de pr\xE9paration. R\xE9essayez dans quelques secondes.",
      failed: "Le PDF n\u2019a pas pu \xEAtre ouvert. R\xE9essayez dans un instant."
    },
    ack: {
      action: "Accuser r\xE9ception",
      sending: "Envoi\u2026",
      hint: "Vous \xEAtes destinataire de ce bordereau\xA0: confirmez que vous avez bien re\xE7u ces documents.",
      done: "R\xE9ception du bordereau {number} confirm\xE9e.",
      failed: "Votre accus\xE9 de r\xE9ception n\u2019a pas pu \xEAtre enregistr\xE9. R\xE9essayez dans un instant.",
      mine: "Vous avez confirm\xE9 la r\xE9ception le {date}."
    },
    loadFailed: "Ce bordereau n\u2019a pas pu \xEAtre charg\xE9.",
    notFound: "Ce bordereau n\u2019existe pas ou n\u2019est plus accessible."
  },
  diffusion: {
    title: "Historique de diffusion",
    send: "Envoyer ce document",
    listLabel: "Bordereaux qui ont transmis ce document",
    empty: "Ce document n\u2019a encore \xE9t\xE9 envoy\xE9 dans aucun bordereau. Chaque envoi appara\xEEtra ici avec les accus\xE9s de r\xE9ception.",
    sentIndex: "Indice envoy\xE9\xA0: {index}",
    recipients: "{count, plural, one {# destinataire} other {# destinataires}}",
    open: "Voir le bordereau {number}",
    loadFailed: "L\u2019historique de diffusion n\u2019a pas pu \xEAtre charg\xE9."
  },
  public: {
    brand: "Bordereau d\u2019envoi de {organization}",
    language: "Langue",
    number: "Bordereau {number}",
    sentOn: "Envoy\xE9 par {organization} le {date}",
    messageTitle: "Message de l\u2019exp\xE9diteur",
    itemsTitle: "Documents",
    itemsCaption: "Documents du bordereau",
    columns: {
      code: "Code",
      title: "Titre",
      index: "Indice",
      actions: "Actions"
    },
    noCode: "Sans code",
    noIndex: "Sans indice",
    preview: "Aper\xE7u",
    previewLabel: "Aper\xE7u de {name}",
    download: "T\xE9l\xE9charger",
    downloadLabel: "T\xE9l\xE9charger {name}",
    watermark: "Chaque copie porte un filigrane \xE0 votre nom et reste r\xE9serv\xE9e \xE0 votre usage.",
    preparing: "La copie de \xAB \xA0{name}\xA0 \xBB est en cours de pr\xE9paration \xE0 votre nom. Un instant\u2026",
    stillPreparing: "La copie de \xAB \xA0{name}\xA0 \xBB est toujours en pr\xE9paration. R\xE9essayez dans quelques instants.",
    ready: "La copie de \xAB \xA0{name}\xA0 \xBB est pr\xEAte. Elle reste accessible une minute.",
    openCopy: "Ouvrir la copie",
    downloadsOff: "L\u2019exp\xE9diteur a d\xE9sactiv\xE9 le t\xE9l\xE9chargement de ces documents. Vous pouvez les consulter en ligne avec \xAB \xA0Aper\xE7u\xA0 \xBB.",
    noPreview: "Ce type de fichier n\u2019a pas d\u2019aper\xE7u en ligne. Utilisez \xAB \xA0T\xE9l\xE9charger\xA0 \xBB.",
    itemFailed: "\xAB \xA0{name}\xA0 \xBB n\u2019a pas pu \xEAtre ouvert. R\xE9essayez dans un instant.",
    ack: {
      title: "Accuser r\xE9ception",
      intro: "Confirmez que vous avez bien re\xE7u les documents de ce bordereau. L\u2019exp\xE9diteur en sera inform\xE9.",
      action: "Accuser r\xE9ception",
      sending: "Envoi\u2026",
      failedTitle: "Accus\xE9 non enregistr\xE9",
      failed: "Votre accus\xE9 de r\xE9ception n\u2019a pas pu \xEAtre enregistr\xE9. R\xE9essayez dans un instant.",
      doneTitle: "R\xE9ception confirm\xE9e",
      done: "R\xE9ception confirm\xE9e le {date}. L\u2019exp\xE9diteur en a \xE9t\xE9 inform\xE9.",
      justDone: "Merci\xA0! Votre accus\xE9 de r\xE9ception du bordereau {number} est enregistr\xE9, le {date}."
    },
    states: {
      loading: "Chargement du bordereau",
      notFoundTitle: "Ce lien n\u2019est plus valide",
      notFoundBody: "Le lien est incorrect ou a expir\xE9 (il reste valable 30 jours). Demandez au bureau qui vous l\u2019a envoy\xE9 de vous transmettre \xE0 nouveau le bordereau.",
      loadFailedTitle: "Le bordereau n\u2019a pas pu \xEAtre charg\xE9",
      loadFailedBody: "V\xE9rifiez votre connexion puis r\xE9essayez."
    }
  }
};

// locales/ar/shareLinks.json
var shareLinks_default = {
  action: {
    open: "\u0627\u0644\u0645\u0634\u0627\u0631\u0643\u0629 \u0628\u0631\u0627\u0628\u0637",
    openFor: "\u0645\u0634\u0627\u0631\u0643\u0629 \xAB{name}\xBB \u0628\u0631\u0627\u0628\u0637"
  },
  section: {
    title: "\u0631\u0648\u0627\u0628\u0637 \u0627\u0644\u0645\u0634\u0627\u0631\u0643\u0629",
    empty: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0631\u0648\u0627\u0628\u0637 \u0645\u0634\u0627\u0631\u0643\u0629 \u0644\u0647\u0630\u0647 \u0627\u0644\u0648\u062B\u064A\u0642\u0629."
  },
  list: {
    label: "\u0631\u0648\u0627\u0628\u0637 \u0627\u0644\u0645\u0634\u0627\u0631\u0643\u0629",
    emptyFolder: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0631\u0648\u0627\u0628\u0637 \u0645\u0634\u0627\u0631\u0643\u0629 \u0644\u0647\u0630\u0627 \u0627\u0644\u0645\u062C\u0644\u062F.",
    loadFailed: "\u062A\u0639\u0630\u0651\u0631 \u062A\u062D\u0645\u064A\u0644 \u0631\u0648\u0627\u0628\u0637 \u0627\u0644\u0645\u0634\u0627\u0631\u0643\u0629.",
    unnamed: "\u0631\u0627\u0628\u0637 \u0628\u0644\u0627 \u0627\u0633\u0645",
    revoke: "\u0625\u0644\u063A\u0627\u0621",
    revokeFor: "\u0625\u0644\u063A\u0627\u0621 \u0627\u0644\u0631\u0627\u0628\u0637 {name}",
    folder: "\u0627\u0644\u0645\u062C\u0644\u062F: {name}",
    document: "\u0627\u0644\u0648\u062B\u064A\u0642\u0629: {name}",
    expiresOn: "\u064A\u0646\u062A\u0647\u064A \u0641\u064A {date}",
    expiredOn: "\u0627\u0646\u062A\u0647\u0649 \u0641\u064A {date}",
    revokedOn: "\u0623\u064F\u0644\u063A\u064A \u0641\u064A {date}",
    downloadsUnlimited: "\u0639\u0645\u0644\u064A\u0627\u062A \u0627\u0644\u062A\u0646\u0632\u064A\u0644: {used}",
    downloadsLimited: "\u0639\u0645\u0644\u064A\u0627\u062A \u0627\u0644\u062A\u0646\u0632\u064A\u0644: {used} \u0645\u0646 {max}",
    downloadsOff: "\u0627\u0644\u062A\u0646\u0632\u064A\u0644 \u063A\u064A\u0631 \u0645\u0633\u0645\u0648\u062D",
    lastAccess: "\u0622\u062E\u0631 \u0641\u062A\u062D \u0641\u064A {date}",
    neverOpened: "\u0644\u0645 \u064A\u064F\u0641\u062A\u062D \u0642\u0637",
    password: "\u0645\u062D\u0645\u064A \u0628\u0643\u0644\u0645\u0629 \u0645\u0631\u0648\u0631",
    watermark: "\u0639\u0644\u0627\u0645\u0629 \u0645\u0627\u0626\u064A\u0629",
    createdBy: "\u0623\u0646\u0634\u0623\u0647 {name}"
  },
  status: {
    active: "\u0646\u0634\u0637",
    exhausted: "\u0627\u0633\u062A\u064F\u0646\u0641\u062F\u062A \u0639\u0645\u0644\u064A\u0627\u062A \u0627\u0644\u062A\u0646\u0632\u064A\u0644",
    expired: "\u0645\u0646\u062A\u0647\u064A \u0627\u0644\u0635\u0644\u0627\u062D\u064A\u0629",
    revoked: "\u0645\u064F\u0644\u063A\u0649"
  },
  revoke: {
    title: "\u0625\u0644\u063A\u0627\u0621 \u0627\u0644\u0631\u0627\u0628\u0637 \xAB{name}\xBB\u061F",
    body: "\u064A\u062A\u0648\u0642\u0641 \u0627\u0644\u0631\u0627\u0628\u0637 \u0639\u0646 \u0627\u0644\u0639\u0645\u0644 \u0641\u0648\u0631\u064B\u0627: \u0644\u0646 \u064A\u062A\u0645\u0643\u0646 \u0627\u0644\u0630\u064A\u0646 \u0627\u0633\u062A\u0644\u0645\u0648\u0647 \u0645\u0646 \u0641\u062A\u062D \u0623\u064A \u0634\u064A\u0621. \u0647\u0630\u0627 \u0627\u0644\u0625\u062C\u0631\u0627\u0621 \u0646\u0647\u0627\u0626\u064A.",
    confirm: "\u0625\u0644\u063A\u0627\u0621 \u0627\u0644\u0631\u0627\u0628\u0637",
    done: "\u062A\u0645 \u0625\u0644\u063A\u0627\u0621 \u0627\u0644\u0631\u0627\u0628\u0637.",
    failed: "\u062A\u0639\u0630\u0651\u0631 \u0625\u0644\u063A\u0627\u0621 \u0627\u0644\u0631\u0627\u0628\u0637. \u062D\u0627\u0648\u0644 \u0645\u0631\u0629 \u0623\u062E\u0631\u0649."
  },
  dialog: {
    title: "\u0645\u0634\u0627\u0631\u0643\u0629 \xAB{name}\xBB \u0628\u0631\u0627\u0628\u0637",
    introDocument: "\u064A\u0633\u062A\u0637\u064A\u0639 \u0643\u0644 \u0645\u0646 \u064A\u0633\u062A\u0644\u0645 \u0627\u0644\u0631\u0627\u0628\u0637 \u0627\u0644\u0627\u0637\u0644\u0627\u0639 \u0639\u0644\u0649 \u0647\u0630\u0647 \u0627\u0644\u0648\u062B\u064A\u0642\u0629 \u062F\u0648\u0646 \u062D\u0633\u0627\u0628 \u0641\u064A BatiFlow \u062D\u062A\u0649 \u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0627\u0646\u062A\u0647\u0627\u0621. \u064A\u0645\u0643\u0646\u0643 \u0625\u0644\u063A\u0627\u0621 \u0627\u0644\u0631\u0627\u0628\u0637 \u0641\u064A \u0623\u064A \u0648\u0642\u062A.",
    introFolder: "\u064A\u0633\u062A\u0637\u064A\u0639 \u0643\u0644 \u0645\u0646 \u064A\u0633\u062A\u0644\u0645 \u0627\u0644\u0631\u0627\u0628\u0637 \u0627\u0644\u0627\u0637\u0644\u0627\u0639 \u0639\u0644\u0649 \u0648\u062B\u0627\u0626\u0642 \u0647\u0630\u0627 \u0627\u0644\u0645\u062C\u0644\u062F \u062F\u0648\u0646 \u062D\u0633\u0627\u0628 \u0641\u064A BatiFlow \u062D\u062A\u0649 \u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0627\u0646\u062A\u0647\u0627\u0621. \u064A\u0645\u0643\u0646\u0643 \u0625\u0644\u063A\u0627\u0621 \u0627\u0644\u0631\u0627\u0628\u0637 \u0641\u064A \u0623\u064A \u0648\u0642\u062A.",
    failedTitle: "\u0644\u0645 \u064A\u064F\u0646\u0634\u0623 \u0627\u0644\u0631\u0627\u0628\u0637",
    policyFailed: "\u062A\u0639\u0630\u0651\u0631\u062A \u0642\u0631\u0627\u0621\u0629 \u0642\u0648\u0627\u0639\u062F \u0627\u0644\u0645\u0633\u0627\u062D\u0629. \u062D\u0627\u0648\u0644 \u0645\u0631\u0629 \u0623\u062E\u0631\u0649.",
    existing: "\u0627\u0644\u0631\u0648\u0627\u0628\u0637 \u0627\u0644\u062D\u0627\u0644\u064A\u0629",
    creating: "\u062C\u0627\u0631\u064D \u0627\u0644\u0625\u0646\u0634\u0627\u0621\u2026",
    submit: "\u0625\u0646\u0634\u0627\u0621 \u0627\u0644\u0631\u0627\u0628\u0637",
    linksOff: {
      title: "\u0631\u0648\u0627\u0628\u0637 \u0627\u0644\u0645\u0634\u0627\u0631\u0643\u0629 \u0645\u0639\u0637\u0651\u0644\u0629",
      body: "\u0639\u0637\u0651\u0644\u0647\u0627 \u0645\u0633\u0624\u0648\u0644 \u0627\u0644\u0645\u0633\u0627\u062D\u0629 \u0641\u064A \u0625\u0639\u062F\u0627\u062F\u0627\u062A \u0627\u0644\u0645\u0633\u0627\u062D\u0629. \u0623\u0639\u062F \u062A\u0641\u0639\u064A\u0644\u0647\u0627 \u0644\u0625\u0646\u0634\u0627\u0621 \u0631\u0627\u0628\u0637."
    },
    label: {
      label: "\u0627\u0633\u0645 \u0627\u0644\u0631\u0627\u0628\u0637 (\u0627\u062E\u062A\u064A\u0627\u0631\u064A)",
      hint: "\u064A\u0633\u0627\u0639\u062F\u0643 \u0639\u0644\u0649 \u0625\u064A\u062C\u0627\u062F \u0627\u0644\u0631\u0627\u0628\u0637 \u0648\u064A\u0638\u0647\u0631 \u0639\u0644\u0627\u0645\u0629 \u0645\u0627\u0626\u064A\u0629 \u0639\u0644\u0649 \u0627\u0644\u0646\u0633\u062E\u060C \u0645\u062B\u0644 \xAB\u062A\u0623\u0634\u064A\u0631\u0629 \u0645\u0643\u062A\u0628 \u0627\u0644\u0645\u0631\u0627\u0642\u0628\u0629\xBB.",
      invalid: "\u0644\u0627 \u064A\u0645\u0643\u0646 \u0623\u0646 \u064A\u062A\u062C\u0627\u0648\u0632 \u0627\u0644\u0627\u0633\u0645 120 \u062D\u0631\u0641\u064B\u0627."
    },
    days: {
      label: "\u0645\u062F\u0629 \u0627\u0644\u0635\u0644\u0627\u062D\u064A\u0629 (\u0628\u0627\u0644\u0623\u064A\u0627\u0645)",
      hint: "\u0645\u0646 \u064A\u0648\u0645 \u0648\u0627\u062D\u062F \u0625\u0644\u0649 {max} \u064A\u0648\u0645\u064B\u0627. \u064A\u062A\u0648\u0642\u0641 \u0627\u0644\u0631\u0627\u0628\u0637 \u062A\u0644\u0642\u0627\u0626\u064A\u064B\u0627 \u0641\u064A \u0646\u0647\u0627\u064A\u062A\u0647\u0627.",
      invalid: "\u0623\u062F\u062E\u0644 \u0639\u062F\u062F\u064B\u0627 \u0635\u062D\u064A\u062D\u064B\u0627 \u0645\u0646 \u0627\u0644\u0623\u064A\u0627\u0645 \u0628\u064A\u0646 1 \u0648{max}.",
      until: "\u0633\u064A\u0646\u062A\u0647\u064A \u0627\u0644\u0631\u0627\u0628\u0637 \u0641\u064A {date}."
    },
    password: {
      label: "\u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631 (\u0627\u062E\u062A\u064A\u0627\u0631\u064A)",
      hint: "\u0645\u0646 {min} \u0625\u0644\u0649 {max} \u062D\u0631\u0641\u064B\u0627. \u0623\u0628\u0644\u063A\u0647\u0627 \u0628\u0642\u0646\u0627\u0629 \u063A\u064A\u0631 \u0642\u0646\u0627\u0629 \u0627\u0644\u0631\u0627\u0628\u0637.",
      invalid: "\u064A\u062C\u0628 \u0623\u0646 \u062A\u062A\u0631\u0627\u0648\u062D \u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631 \u0628\u064A\u0646 {min} \u0648{max} \u062D\u0631\u0641\u064B\u0627.",
      show: "\u0625\u0638\u0647\u0627\u0631 \u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631",
      hide: "\u0625\u062E\u0641\u0627\u0621 \u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631"
    },
    watermark: {
      label: "\u0639\u0644\u0627\u0645\u0629 \u0645\u0627\u0626\u064A\u0629 \u0639\u0644\u0649 \u0627\u0644\u0646\u0633\u062E",
      hint: "\u062A\u062D\u0645\u0644 \u0643\u0644 \u0635\u0641\u062D\u0629 \u0645\u0639\u0631\u0648\u0636\u0629 \u0623\u0648 \u0645\u0646\u0632\u0651\u0644\u0629 \u0627\u0633\u0645 \u0627\u0644\u0631\u0627\u0628\u0637 \u0643\u0639\u0644\u0627\u0645\u0629 \u0645\u0627\u0626\u064A\u0629.",
      locked: "\u062A\u0641\u0631\u0636\u0647\u0627 \u0627\u0644\u0645\u0633\u0627\u062D\u0629: \u062A\u062D\u0645\u0644 \u062C\u0645\u064A\u0639 \u0627\u0644\u0646\u0633\u062E \u0639\u0644\u0627\u0645\u0629 \u0645\u0627\u0626\u064A\u0629."
    },
    download: {
      label: "\u0627\u0644\u0633\u0645\u0627\u062D \u0628\u0627\u0644\u062A\u0646\u0632\u064A\u0644",
      hint: "\u064A\u0633\u062A\u0637\u064A\u0639 \u0627\u0644\u0634\u062E\u0635 \u062D\u0641\u0638 \u0646\u0633\u062E\u0629 \u0645\u0646 \u0627\u0644\u0645\u0644\u0641. \u0648\u0625\u0644\u0627 \u0641\u064A\u0645\u0643\u0646\u0647 \u0627\u0644\u0627\u0637\u0644\u0627\u0639 \u0639\u0644\u064A\u0647 \u0641\u0642\u0637.",
      locked: "\u0627\u0644\u062A\u0646\u0632\u064A\u0644 \u0645\u0639\u0637\u0651\u0644 \u0641\u064A \u0647\u0630\u0647 \u0627\u0644\u0645\u0633\u0627\u062D\u0629: \u0644\u0627 \u064A\u0645\u0643\u0646 \u0644\u0644\u0631\u0627\u0628\u0637 \u0623\u0646 \u064A\u0633\u0645\u062D \u0628\u0647."
    },
    max: {
      label: "\u0627\u0644\u062D\u062F \u0627\u0644\u0623\u0642\u0635\u0649 \u0644\u0639\u0645\u0644\u064A\u0627\u062A \u0627\u0644\u062A\u0646\u0632\u064A\u0644 (\u0627\u062E\u062A\u064A\u0627\u0631\u064A)",
      hint: "\u0627\u062A\u0631\u0643\u0647 \u0641\u0627\u0631\u063A\u064B\u0627 \u0644\u0639\u062F\u0645 \u0627\u0644\u062A\u062D\u062F\u064A\u062F. \u0639\u0646\u062F \u0628\u0644\u0648\u063A\u0647 \u064A\u0628\u0642\u0649 \u0627\u0644\u0631\u0627\u0628\u0637 \u0644\u0644\u0627\u0637\u0644\u0627\u0639 \u0644\u0643\u0646\u0647 \u0644\u0627 \u064A\u0633\u0645\u062D \u0628\u0627\u0644\u062A\u0646\u0632\u064A\u0644.",
      invalid: "\u0623\u062F\u062E\u0644 \u0639\u062F\u062F\u064B\u0627 \u0635\u062D\u064A\u062D\u064B\u0627 \u0628\u064A\u0646 1 \u0648{max}."
    },
    errors: {
      linksOff: "\u0631\u0648\u0627\u0628\u0637 \u0627\u0644\u0645\u0634\u0627\u0631\u0643\u0629 \u0645\u0639\u0637\u0651\u0644\u0629 \u0641\u064A \u0647\u0630\u0647 \u0627\u0644\u0645\u0633\u0627\u062D\u0629.",
      policy: "\u0627\u0644\u062A\u0646\u0632\u064A\u0644 \u0645\u0639\u0637\u0651\u0644 \u0641\u064A \u0647\u0630\u0647 \u0627\u0644\u0645\u0633\u0627\u062D\u0629: \u0639\u0637\u0651\u0644 \xAB\u0627\u0644\u0633\u0645\u0627\u062D \u0628\u0627\u0644\u062A\u0646\u0632\u064A\u0644\xBB \u062B\u0645 \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629.",
      forbidden: "\u0644\u064A\u0633 \u0644\u062F\u064A\u0643 \u0627\u0644\u062D\u0642 \u0641\u064A \u0645\u0634\u0627\u0631\u0643\u0629 \u0647\u0630\u0627 \u0627\u0644\u0639\u0646\u0635\u0631 \u0628\u0631\u0627\u0628\u0637.",
      notFound: "\u0647\u0630\u0627 \u0627\u0644\u0639\u0646\u0635\u0631 \u0644\u0645 \u064A\u0639\u062F \u0645\u0648\u062C\u0648\u062F\u064B\u0627 \u0623\u0648 \u0644\u0645 \u064A\u0639\u062F \u0628\u0625\u0645\u0643\u0627\u0646\u0643 \u0645\u0634\u0627\u0631\u0643\u062A\u0647."
    }
  },
  created: {
    warningTitle: "\u0627\u0646\u0633\u062E \u0627\u0644\u0631\u0627\u0628\u0637 \u0627\u0644\u0622\u0646",
    warning: "\u0644\u0646 \u064A\u064F\u0639\u0631\u0636 \u0647\u0630\u0627 \u0627\u0644\u0631\u0627\u0628\u0637 \u0645\u0631\u0629 \u0623\u062E\u0631\u0649 \u0628\u0639\u062F \u0625\u063A\u0644\u0627\u0642 \u0647\u0630\u0647 \u0627\u0644\u0646\u0627\u0641\u0630\u0629. \u0625\u0646 \u0641\u0642\u062F\u062A\u0647 \u0641\u0623\u0644\u063A\u0650\u0647 \u0648\u0623\u0646\u0634\u0626 \u0631\u0627\u0628\u0637\u064B\u0627 \u062C\u062F\u064A\u062F\u064B\u0627.",
    urlLabel: "\u0639\u0646\u0648\u0627\u0646 \u0627\u0644\u0631\u0627\u0628\u0637",
    copy: "\u0646\u0633\u062E \u0627\u0644\u0631\u0627\u0628\u0637",
    copied: "\u062A\u0645 \u0646\u0633\u062E \u0627\u0644\u0631\u0627\u0628\u0637 \u0625\u0644\u0649 \u0627\u0644\u062D\u0627\u0641\u0638\u0629.",
    copyFailed: "\u062A\u0639\u0630\u0651\u0631 \u0627\u0644\u0646\u0633\u062E \u0627\u0644\u062A\u0644\u0642\u0627\u0626\u064A: \u0627\u0644\u0631\u0627\u0628\u0637 \u0645\u062D\u062F\u062F\u060C \u0627\u0646\u0633\u062E\u0647 \u0628\u0627\u0644\u0636\u063A\u0637 \u0639\u0644\u0649 Ctrl+C.",
    until: "\u064A\u0646\u062A\u0647\u064A \u0647\u0630\u0627 \u0627\u0644\u0631\u0627\u0628\u0637 \u0641\u064A {date}.",
    passwordNote: "\u0648\u0647\u0648 \u0645\u062D\u0645\u064A \u0628\u0643\u0644\u0645\u0629 \u0645\u0631\u0648\u0631: \u0623\u0628\u0644\u063A\u0647\u0627 \u0628\u0634\u0643\u0644 \u0645\u0646\u0641\u0635\u0644.",
    done: "\u0625\u0646\u0647\u0627\u0621"
  },
  space: {
    open: "\u0631\u0648\u0627\u0628\u0637 \u0627\u0644\u0645\u0634\u0627\u0631\u0643\u0629",
    title: "\u0631\u0648\u0627\u0628\u0637 \u0627\u0644\u0645\u0634\u0627\u0631\u0643\u0629 \u0641\u064A \u0627\u0644\u0645\u0633\u0627\u062D\u0629",
    intro: "\u062C\u0645\u064A\u0639 \u0627\u0644\u0631\u0648\u0627\u0628\u0637 \u0627\u0644\u0645\u0646\u0634\u0623\u0629 \u0644\u0647\u0630\u0647 \u0627\u0644\u0645\u0633\u0627\u062D\u0629\u060C \u0628\u0645\u0627 \u0641\u064A\u0647\u0627 \u0627\u0644\u0645\u0646\u062A\u0647\u064A\u0629 \u0648\u0627\u0644\u0645\u064F\u0644\u063A\u0627\u0629.",
    listLabel: "\u0631\u0648\u0627\u0628\u0637 \u0627\u0644\u0645\u0634\u0627\u0631\u0643\u0629 \u0641\u064A \u0627\u0644\u0645\u0633\u0627\u062D\u0629",
    empty: "\u0644\u0645 \u064A\u064F\u0646\u0634\u0623 \u0623\u064A \u0631\u0627\u0628\u0637 \u0645\u0634\u0627\u0631\u0643\u0629 \u0641\u064A \u0647\u0630\u0647 \u0627\u0644\u0645\u0633\u0627\u062D\u0629."
  },
  policy: {
    locked: "\u0628\u0627\u0642\u062A\u0643 \u0644\u0627 \u062A\u062A\u0636\u0645\u0646 \u062D\u0645\u0627\u064A\u0629 \u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A: \u064A\u0645\u0643\u0646\u0643 \u0631\u0641\u0639 \u0642\u064A\u062F \u0645\u0648\u062C\u0648\u062F \u0644\u0643\u0646 \u0644\u0627 \u064A\u0645\u0643\u0646\u0643 \u0625\u0636\u0627\u0641\u0629 \u0642\u064A\u062F \u062C\u062F\u064A\u062F.",
    links: {
      label: "\u0627\u0644\u0633\u0645\u0627\u062D \u0628\u0631\u0648\u0627\u0628\u0637 \u0627\u0644\u0645\u0634\u0627\u0631\u0643\u0629",
      hint: "\u064A\u0633\u062A\u0637\u064A\u0639 \u0627\u0644\u0645\u0633\u0624\u0648\u0644\u0648\u0646 \u0625\u0646\u0634\u0627\u0621 \u0631\u0648\u0627\u0628\u0637 \u0644\u0623\u0634\u062E\u0627\u0635 \u0628\u0644\u0627 \u062D\u0633\u0627\u0628. \u0625\u0630\u0627 \u0639\u064F\u0637\u0651\u0644 \u0641\u0644\u0627 \u064A\u0645\u0643\u0646 \u0625\u0646\u0634\u0627\u0621 \u0623\u064A \u0631\u0627\u0628\u0637 \u0648\u062A\u062A\u0648\u0642\u0641 \u0627\u0644\u0631\u0648\u0627\u0628\u0637 \u0627\u0644\u0645\u0648\u062C\u0648\u062F\u0629 \u0639\u0646 \u0627\u0644\u0639\u0645\u0644."
    },
    upgrade: {
      title: "\u0645\u064A\u0632\u0629 \u063A\u064A\u0631 \u0645\u0634\u0645\u0648\u0644\u0629 \u0641\u064A \u0628\u0627\u0642\u062A\u0643",
      bodyOwner: "\u062A\u0634\u062F\u064A\u062F \u0642\u0648\u0627\u0639\u062F \u0627\u0644\u0645\u0633\u0627\u062D\u0629 (\u0627\u0644\u062A\u0646\u0632\u064A\u0644 \u0648\u0627\u0644\u0639\u0644\u0627\u0645\u0629 \u0627\u0644\u0645\u0627\u0626\u064A\u0629 \u0648\u0627\u0644\u0637\u0628\u0627\u0639\u0629 \u0648\u0631\u0648\u0627\u0628\u0637 \u0627\u0644\u0645\u0634\u0627\u0631\u0643\u0629) \u062C\u0632\u0621 \u0645\u0646 \u062D\u0645\u0627\u064A\u0629 \u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A \u0627\u0644\u0645\u062E\u0635\u0635\u0629 \u0644\u0628\u0627\u0642\u062A\u064A Business \u0648Enterprise.",
      bodyMember: "\u062A\u0634\u062F\u064A\u062F \u0642\u0648\u0627\u0639\u062F \u0627\u0644\u0645\u0633\u0627\u062D\u0629 \u062C\u0632\u0621 \u0645\u0646 \u062D\u0645\u0627\u064A\u0629 \u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A \u0627\u0644\u0645\u062E\u0635\u0635\u0629 \u0644\u0628\u0627\u0642\u062A\u064A Business \u0648Enterprise. \u062A\u0648\u0627\u0635\u0644 \u0645\u0639 \u0645\u0633\u0624\u0648\u0644 \u0645\u0624\u0633\u0633\u062A\u0643 \u0644\u062A\u063A\u064A\u064A\u0631 \u0627\u0644\u0628\u0627\u0642\u0629."
    }
  },
  public: {
    brand: "\u0645\u0634\u0627\u0631\u0643\u0629 \u0645\u0646 {organization}",
    language: "\u0627\u0644\u0644\u063A\u0629",
    defaultTitle: "\u0648\u062B\u0627\u0626\u0642 \u0645\u0634\u0627\u0631\u0643\u0629",
    defaultStamp: "\u0631\u0627\u0628\u0637 \u0645\u0634\u0627\u0631\u0643\u0629",
    sharedBy: "\u0634\u0627\u0631\u0643\u062A\u0647\u0627 {organization}",
    expiresOn: "\u0645\u062A\u0627\u062D \u062D\u062A\u0649 {date}",
    print: "\u0637\u0628\u0627\u0639\u0629",
    watermarkNote: "\u062A\u062D\u0645\u0644 \u0627\u0644\u0646\u0633\u062E \u0627\u0644\u0645\u0639\u0631\u0648\u0636\u0629 \u0648\u0627\u0644\u0645\u0646\u0632\u0651\u0644\u0629 \u0639\u0644\u0627\u0645\u0629 \u0645\u0627\u0626\u064A\u0629 \u0628\u0627\u0633\u0645 \u0647\u0630\u0627 \u0627\u0644\u0631\u0627\u0628\u0637.",
    noDownloadNote: "\u0627\u0644\u062A\u0646\u0632\u064A\u0644 \u063A\u064A\u0631 \u0645\u0633\u0645\u0648\u062D \u0644\u0647\u0630\u0627 \u0627\u0644\u0631\u0627\u0628\u0637: \u062A\u064F\u0639\u0631\u0636 \u0627\u0644\u0648\u062B\u064A\u0642\u0629 \u0639\u0644\u0649 \u0627\u0644\u0634\u0627\u0634\u0629 \u0641\u0642\u0637.",
    states: {
      loading: "\u062C\u0627\u0631\u064D \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0631\u0627\u0628\u0637",
      notFoundTitle: "\u0647\u0630\u0627 \u0627\u0644\u0631\u0627\u0628\u0637 \u0644\u0645 \u064A\u0639\u062F \u0635\u0627\u0644\u062D\u064B\u0627",
      notFoundBody: "\u0627\u0637\u0644\u0628 \u0631\u0627\u0628\u0637\u064B\u0627 \u062C\u062F\u064A\u062F\u064B\u0627 \u0645\u0646 \u0627\u0644\u0634\u062E\u0635 \u0627\u0644\u0630\u064A \u0623\u0631\u0633\u0644\u0647 \u0625\u0644\u064A\u0643.",
      loadFailedTitle: "\u062A\u0639\u0630\u0651\u0631 \u0641\u062A\u062D \u0627\u0644\u0631\u0627\u0628\u0637",
      loadFailedBody: "\u062A\u062D\u0642\u0642 \u0645\u0646 \u0627\u062A\u0635\u0627\u0644\u0643 \u062B\u0645 \u062D\u0627\u0648\u0644 \u0645\u0631\u0629 \u0623\u062E\u0631\u0649."
    },
    password: {
      title: "\u0647\u0630\u0627 \u0627\u0644\u0631\u0627\u0628\u0637 \u0645\u062D\u0645\u064A \u0628\u0643\u0644\u0645\u0629 \u0645\u0631\u0648\u0631",
      intro: "\u0623\u062F\u062E\u0644 \u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631 \u0627\u0644\u062A\u064A \u0623\u0628\u0644\u063A\u0643 \u0628\u0647\u0627 \u0627\u0644\u0634\u062E\u0635 \u0627\u0644\u0630\u064A \u0623\u0631\u0633\u0644 \u0625\u0644\u064A\u0643 \u0627\u0644\u0631\u0627\u0628\u0637.",
      expired: "\u0627\u0646\u062A\u0647\u062A \u0635\u0644\u0627\u062D\u064A\u0629 \u0648\u0635\u0648\u0644\u0643. \u0623\u062F\u062E\u0644 \u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631 \u0645\u0646 \u062C\u062F\u064A\u062F.",
      label: "\u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631",
      show: "\u0625\u0638\u0647\u0627\u0631 \u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631",
      hide: "\u0625\u062E\u0641\u0627\u0621 \u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631",
      required: "\u0623\u062F\u062E\u0644 \u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631.",
      submit: "\u0641\u062A\u062D",
      checking: "\u062C\u0627\u0631\u064D \u0627\u0644\u062A\u062D\u0642\u0642\u2026",
      wrong: "{count, plural, one {\u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631 \u063A\u064A\u0631 \u0635\u062D\u064A\u062D\u0629 \u2014 \u0628\u0642\u064A\u062A \u0645\u062D\u0627\u0648\u0644\u0629 \u0648\u0627\u062D\u062F\u0629} two {\u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631 \u063A\u064A\u0631 \u0635\u062D\u064A\u062D\u0629 \u2014 \u0628\u0642\u064A\u062A \u0645\u062D\u0627\u0648\u0644\u062A\u0627\u0646} few {\u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631 \u063A\u064A\u0631 \u0635\u062D\u064A\u062D\u0629 \u2014 \u0628\u0642\u064A\u062A # \u0645\u062D\u0627\u0648\u0644\u0627\u062A} many {\u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631 \u063A\u064A\u0631 \u0635\u062D\u064A\u062D\u0629 \u2014 \u0628\u0642\u064A\u062A # \u0645\u062D\u0627\u0648\u0644\u0629} other {\u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631 \u063A\u064A\u0631 \u0635\u062D\u064A\u062D\u0629 \u2014 \u0628\u0642\u064A\u062A # \u0645\u062D\u0627\u0648\u0644\u0629}}",
      locked: "{minutes, plural, one {\u0645\u062D\u0627\u0648\u0644\u0627\u062A \u0643\u062B\u064A\u0631\u0629\u060C \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629 \u0628\u0639\u062F \u062F\u0642\u064A\u0642\u0629 \u0648\u0627\u062D\u062F\u0629.} two {\u0645\u062D\u0627\u0648\u0644\u0627\u062A \u0643\u062B\u064A\u0631\u0629\u060C \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629 \u0628\u0639\u062F \u062F\u0642\u064A\u0642\u062A\u064A\u0646.} few {\u0645\u062D\u0627\u0648\u0644\u0627\u062A \u0643\u062B\u064A\u0631\u0629\u060C \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629 \u0628\u0639\u062F # \u062F\u0642\u0627\u0626\u0642.} many {\u0645\u062D\u0627\u0648\u0644\u0627\u062A \u0643\u062B\u064A\u0631\u0629\u060C \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629 \u0628\u0639\u062F # \u062F\u0642\u064A\u0642\u0629.} other {\u0645\u062D\u0627\u0648\u0644\u0627\u062A \u0643\u062B\u064A\u0631\u0629\u060C \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629 \u0628\u0639\u062F # \u062F\u0642\u064A\u0642\u0629.}}",
      failed: "\u062A\u0639\u0630\u0651\u0631 \u0627\u0644\u062A\u062D\u0642\u0642 \u0645\u0646 \u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631. \u062D\u0627\u0648\u0644 \u0645\u0631\u0629 \u0623\u062E\u0631\u0649."
    },
    documents: {
      title: "{count, plural, one {\u0627\u0644\u0648\u062B\u064A\u0642\u0629 \u0627\u0644\u0645\u0634\u0627\u0631\u0643\u0629 (#)} two {\u0627\u0644\u0648\u062B\u064A\u0642\u062A\u0627\u0646 \u0627\u0644\u0645\u0634\u0627\u0631\u0643\u062A\u0627\u0646 (#)} few {\u0627\u0644\u0648\u062B\u0627\u0626\u0642 \u0627\u0644\u0645\u0634\u0627\u0631\u0643\u0629 (#)} many {\u0627\u0644\u0648\u062B\u0627\u0626\u0642 \u0627\u0644\u0645\u0634\u0627\u0631\u0643\u0629 (#)} other {\u0627\u0644\u0648\u062B\u0627\u0626\u0642 \u0627\u0644\u0645\u0634\u0627\u0631\u0643\u0629 (#)}}",
      listLabel: "\u0627\u0644\u0648\u062B\u0627\u0626\u0642 \u0627\u0644\u0645\u0634\u0627\u0631\u0643\u0629",
      viewerLabel: "\u0627\u0644\u0648\u062B\u064A\u0642\u0629 \u0627\u0644\u0645\u0641\u062A\u0648\u062D\u0629: {name}",
      index: "\u0627\u0644\u0645\u0624\u0634\u0631 {index}",
      empty: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0648\u062B\u0627\u0626\u0642 \u0644\u0644\u0639\u0631\u0636 \u0641\u064A \u0627\u0644\u0648\u0642\u062A \u0627\u0644\u062D\u0627\u0644\u064A."
    },
    download: {
      action: "\u062A\u0646\u0632\u064A\u0644",
      label: "\u062A\u0646\u0632\u064A\u0644 {name}",
      left: "{count, plural, one {\u0628\u0642\u064A \u062A\u0646\u0632\u064A\u0644 \u0648\u0627\u062D\u062F.} two {\u0628\u0642\u064A \u062A\u0646\u0632\u064A\u0644\u0627\u0646.} few {\u0628\u0642\u064A\u062A # \u0639\u0645\u0644\u064A\u0627\u062A \u062A\u0646\u0632\u064A\u0644.} many {\u0628\u0642\u064A\u062A # \u0639\u0645\u0644\u064A\u0629 \u062A\u0646\u0632\u064A\u0644.} other {\u0628\u0642\u064A\u062A # \u0639\u0645\u0644\u064A\u0629 \u062A\u0646\u0632\u064A\u0644.}}",
      preparing: "\u062C\u0627\u0631\u064D \u062A\u062D\u0636\u064A\u0631 \u0627\u0644\u062A\u0646\u0632\u064A\u0644\u2026",
      preparingWatermark: "\u062C\u0627\u0631\u064D \u062A\u062D\u0636\u064A\u0631 \u0646\u0633\u062E\u0629 \u0628\u0639\u0644\u0627\u0645\u0629 \u0645\u0627\u0626\u064A\u0629\u2026",
      started: "\u0628\u062F\u0623 \u0627\u0644\u062A\u0646\u0632\u064A\u0644.",
      openCopy: "\u0625\u0646 \u0644\u0645 \u064A\u0628\u062F\u0623 \u0641\u0627\u0641\u062A\u062D \u0627\u0644\u0646\u0633\u062E\u0629.",
      still: "\u0627\u0644\u0646\u0633\u062E\u0629 \u0644\u064A\u0633\u062A \u062C\u0627\u0647\u0632\u0629 \u0628\u0639\u062F. \u062D\u0627\u0648\u0644 \u0645\u0631\u0629 \u0623\u062E\u0631\u0649 \u0628\u0639\u062F \u0642\u0644\u064A\u0644.",
      notAllowed: "\u0627\u0644\u062A\u0646\u0632\u064A\u0644 \u063A\u064A\u0631 \u0645\u0633\u0645\u0648\u062D \u0644\u0647\u0630\u0627 \u0627\u0644\u0631\u0627\u0628\u0637.",
      limit: "\u062A\u0645 \u0628\u0644\u0648\u063A \u0639\u062F\u062F \u0639\u0645\u0644\u064A\u0627\u062A \u0627\u0644\u062A\u0646\u0632\u064A\u0644 \u0627\u0644\u0645\u0633\u0645\u0648\u062D \u0628\u0647\u0627.",
      failed: "\u0641\u0634\u0644 \u0627\u0644\u062A\u0646\u0632\u064A\u0644. \u062D\u0627\u0648\u0644 \u0645\u0631\u0629 \u0623\u062E\u0631\u0649."
    },
    preview: {
      loading: "\u062C\u0627\u0631\u064D \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0645\u0639\u0627\u064A\u0646\u0629",
      preparing: "\u062C\u0627\u0631\u064D \u062A\u062D\u0636\u064A\u0631 \u0627\u0644\u0645\u0639\u0627\u064A\u0646\u0629\u2026",
      preparingWatermark: "\u062C\u0627\u0631\u064D \u062A\u062D\u0636\u064A\u0631 \u0646\u0633\u062E\u0629 \u0628\u0639\u0644\u0627\u0645\u0629 \u0645\u0627\u0626\u064A\u0629\u2026",
      failedTitle: "\u062A\u0639\u0630\u0651\u0631 \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0645\u0639\u0627\u064A\u0646\u0629",
      failedBody: "\u062A\u062D\u0642\u0642 \u0645\u0646 \u0627\u062A\u0635\u0627\u0644\u0643 \u062B\u0645 \u062D\u0627\u0648\u0644 \u0645\u0631\u0629 \u0623\u062E\u0631\u0649.",
      noneTitle: "\u0627\u0644\u0645\u0639\u0627\u064A\u0646\u0629 \u063A\u064A\u0631 \u0645\u062A\u0627\u062D\u0629",
      noneBody: "\u0644\u0627 \u064A\u0645\u0643\u0646 \u0639\u0631\u0636 \u0647\u0630\u0627 \u0627\u0644\u0646\u0648\u0639 \u0645\u0646 \u0627\u0644\u0645\u0644\u0641\u0627\u062A \u0639\u0644\u0649 \u0627\u0644\u0625\u0646\u062A\u0631\u0646\u062A.",
      goneTitle: "\u0644\u0645 \u062A\u0639\u062F \u0647\u0630\u0647 \u0627\u0644\u0648\u062B\u064A\u0642\u0629 \u0645\u062A\u0627\u062D\u0629",
      goneBody: "\u0631\u0628\u0645\u0627 \u0627\u0646\u062A\u0647\u062A \u0635\u0644\u0627\u062D\u064A\u0629 \u0648\u0635\u0648\u0644\u0643 \u0623\u0648 \u0623\u064F\u0644\u063A\u064A \u0627\u0644\u0631\u0627\u0628\u0637.",
      reload: "\u062A\u062D\u062F\u064A\u062B",
      cadTitle: "\u0627\u0644\u0645\u0639\u0627\u064A\u0646\u0629 \u063A\u064A\u0631 \u0645\u062A\u0627\u062D\u0629",
      cadBody: "\u062A\u0639\u0630\u0651\u0631 \u0639\u0631\u0636 \u0647\u0630\u0627 \u0627\u0644\u0645\u062E\u0637\u0637. \u062D\u0627\u0648\u0644 \u0645\u0631\u0629 \u0623\u062E\u0631\u0649 \u0628\u0639\u062F \u0642\u0644\u064A\u0644."
    }
  }
};

// locales/en/shareLinks.json
var shareLinks_default2 = {
  action: {
    open: "Share by link",
    openFor: "Share \u201C{name}\u201D by link"
  },
  section: {
    title: "Share links",
    empty: "There are no share links for this document."
  },
  list: {
    label: "Share links",
    emptyFolder: "There are no share links for this folder.",
    loadFailed: "The share links could not be loaded.",
    unnamed: "Unnamed link",
    revoke: "Revoke",
    revokeFor: "Revoke the link {name}",
    folder: "Folder: {name}",
    document: "Document: {name}",
    expiresOn: "Expires on {date}",
    expiredOn: "Expired on {date}",
    revokedOn: "Revoked on {date}",
    downloadsUnlimited: "Downloads: {used}",
    downloadsLimited: "Downloads: {used} of {max}",
    downloadsOff: "Downloads not allowed",
    lastAccess: "Last opened on {date}",
    neverOpened: "Never opened",
    password: "Password protected",
    watermark: "Watermark",
    createdBy: "Created by {name}"
  },
  status: {
    active: "Active",
    exhausted: "Downloads used up",
    expired: "Expired",
    revoked: "Revoked"
  },
  revoke: {
    title: "Revoke the link \u201C{name}\u201D?",
    body: "The link stops working immediately: the people who received it will no longer be able to open anything. This cannot be undone.",
    confirm: "Revoke the link",
    done: "The link is revoked.",
    failed: "The link could not be revoked. Try again."
  },
  dialog: {
    title: "Share \u201C{name}\u201D by link",
    introDocument: "Anyone who receives the link can view this document without a BatiFlow account, until the expiry date. You can revoke the link at any time.",
    introFolder: "Anyone who receives the link can view the documents of this folder without a BatiFlow account, until the expiry date. You can revoke the link at any time.",
    failedTitle: "The link was not created",
    policyFailed: "The space rules could not be read. Try again.",
    existing: "Existing links",
    creating: "Creating\u2026",
    submit: "Create the link",
    linksOff: {
      title: "Share links are turned off",
      body: "A space manager turned them off in the space settings. Turn them on again to create a link."
    },
    label: {
      label: "Link name (optional)",
      hint: "It helps you find the link and appears as a watermark on the copies, for example \u201CInspection office approval\u201D.",
      invalid: "The name cannot exceed 120 characters."
    },
    days: {
      label: "Validity (days)",
      hint: "From 1 to {max} days. The link stops by itself at the end.",
      invalid: "Enter a whole number of days between 1 and {max}.",
      until: "The link will expire on {date}."
    },
    password: {
      label: "Password (optional)",
      hint: "{min} to {max} characters. Give it through a channel other than the link.",
      invalid: "The password must be between {min} and {max} characters.",
      show: "Show the password",
      hide: "Hide the password"
    },
    watermark: {
      label: "Watermark on copies",
      hint: "Every page shown or downloaded carries the link\u2019s name as a watermark.",
      locked: "Required by the space: all copies carry a watermark."
    },
    download: {
      label: "Allow downloads",
      hint: "The person can save a copy of the file. Otherwise they can only view it.",
      locked: "Downloads are turned off in this space: the link cannot allow them."
    },
    max: {
      label: "Maximum number of downloads (optional)",
      hint: "Leave empty for no limit. Once reached, the link can still be viewed but no longer allows downloads.",
      invalid: "Enter a whole number between 1 and {max}."
    },
    errors: {
      linksOff: "Share links are turned off in this space.",
      policy: "Downloads are turned off in this space: turn off \u201CAllow downloads\u201D and try again.",
      forbidden: "You are not allowed to share this item by link.",
      notFound: "This item no longer exists or you can no longer share it."
    }
  },
  created: {
    warningTitle: "Copy the link now",
    warning: "This link will not be shown again once this window is closed. If you lose it, revoke it and create a new one.",
    urlLabel: "Link address",
    copy: "Copy the link",
    copied: "Link copied to the clipboard.",
    copyFailed: "Automatic copy is not possible: the link is selected, copy it with Ctrl+C.",
    until: "This link expires on {date}.",
    passwordNote: "It is password protected: give the password separately.",
    done: "Done"
  },
  space: {
    open: "Share links",
    title: "Share links of the space",
    intro: "Every link created for this space, including those that expired or were revoked.",
    listLabel: "Share links of the space",
    empty: "No share link has been created in this space."
  },
  policy: {
    locked: "Your plan does not include data protection: you can lift an existing restriction, but not add one.",
    links: {
      label: "Allow share links",
      hint: "Managers can create links for people without an account. When off, no link can be created and existing ones stop working."
    },
    upgrade: {
      title: "Feature not included in your plan",
      bodyOwner: "Tightening the space rules (downloads, watermark, printing, share links) is part of data protection, available on the Business and Enterprise plans.",
      bodyMember: "Tightening the space rules is part of data protection, available on the Business and Enterprise plans. Contact your organisation\u2019s administrator to change the plan."
    }
  },
  public: {
    brand: "Shared by {organization}",
    language: "Language",
    defaultTitle: "Shared documents",
    defaultStamp: "Share link",
    sharedBy: "Shared by {organization}",
    expiresOn: "Available until {date}",
    print: "Print",
    watermarkNote: "Copies shown and downloaded carry a watermark with this link\u2019s identity.",
    noDownloadNote: "Downloads are not allowed for this link: the document can be viewed on screen.",
    states: {
      loading: "Loading the link",
      notFoundTitle: "This link is no longer valid",
      notFoundBody: "Ask the person who sent it to you for a new link.",
      loadFailedTitle: "The link could not be opened",
      loadFailedBody: "Check your connection, then try again."
    },
    password: {
      title: "This link is password protected",
      intro: "Enter the password the person who sent you the link gave you.",
      expired: "Your access has expired. Enter the password again.",
      label: "Password",
      show: "Show the password",
      hide: "Hide the password",
      required: "Enter the password.",
      submit: "Open",
      checking: "Checking\u2026",
      wrong: "{count, plural, one {Wrong password \u2014 # attempt left} other {Wrong password \u2014 # attempts left}}",
      locked: "{minutes, plural, one {Too many attempts, try again in # minute.} other {Too many attempts, try again in # minutes.}}",
      failed: "The password could not be checked. Try again."
    },
    documents: {
      title: "{count, plural, one {Shared document (#)} other {Shared documents (#)}}",
      listLabel: "Shared documents",
      viewerLabel: "Open document: {name}",
      index: "Revision {index}",
      empty: "There are no documents to show right now."
    },
    download: {
      action: "Download",
      label: "Download {name}",
      left: "{count, plural, one {# download left.} other {# downloads left.}}",
      preparing: "Preparing the download\u2026",
      preparingWatermark: "Preparing a watermarked copy\u2026",
      started: "The download has started.",
      openCopy: "If it does not start, open the copy.",
      still: "The copy is not ready yet. Try again in a moment.",
      notAllowed: "Downloads are not allowed for this link.",
      limit: "The number of allowed downloads has been reached.",
      failed: "The download failed. Try again."
    },
    preview: {
      loading: "Loading the preview",
      preparing: "Preparing the preview\u2026",
      preparingWatermark: "Preparing a watermarked copy\u2026",
      failedTitle: "The preview could not be loaded",
      failedBody: "Check your connection, then try again.",
      noneTitle: "Preview not available",
      noneBody: "This type of file cannot be shown online.",
      goneTitle: "This document is no longer available",
      goneBody: "Your access may have expired or the link was revoked.",
      reload: "Refresh",
      cadTitle: "Preview not available",
      cadBody: "This drawing could not be shown. Try again in a moment."
    }
  }
};

// locales/fr/shareLinks.json
var shareLinks_default3 = {
  action: {
    open: "Partager par lien",
    openFor: "Partager \xAB {name} \xBB par lien"
  },
  section: {
    title: "Liens de partage",
    empty: "Aucun lien de partage pour ce document."
  },
  list: {
    label: "Liens de partage",
    emptyFolder: "Aucun lien de partage pour ce dossier.",
    loadFailed: "Les liens de partage n\u2019ont pas pu \xEAtre charg\xE9s.",
    unnamed: "Lien sans nom",
    revoke: "R\xE9voquer",
    revokeFor: "R\xE9voquer le lien {name}",
    folder: "Dossier : {name}",
    document: "Document : {name}",
    expiresOn: "Expire le {date}",
    expiredOn: "A expir\xE9 le {date}",
    revokedOn: "R\xE9voqu\xE9 le {date}",
    downloadsUnlimited: "T\xE9l\xE9chargements : {used}",
    downloadsLimited: "T\xE9l\xE9chargements : {used} sur {max}",
    downloadsOff: "T\xE9l\xE9chargement non autoris\xE9",
    lastAccess: "Dernier acc\xE8s le {date}",
    neverOpened: "Jamais ouvert",
    password: "Prot\xE9g\xE9 par mot de passe",
    watermark: "Filigrane",
    createdBy: "Cr\xE9\xE9 par {name}"
  },
  status: {
    active: "Actif",
    exhausted: "T\xE9l\xE9chargements \xE9puis\xE9s",
    expired: "Expir\xE9",
    revoked: "R\xE9voqu\xE9"
  },
  revoke: {
    title: "R\xE9voquer le lien \xAB {name} \xBB ?",
    body: "Le lien cesse de fonctionner imm\xE9diatement : les personnes qui l\u2019ont re\xE7u ne pourront plus rien ouvrir. Cette action est d\xE9finitive.",
    confirm: "R\xE9voquer le lien",
    done: "Le lien est r\xE9voqu\xE9.",
    failed: "Le lien n\u2019a pas pu \xEAtre r\xE9voqu\xE9. R\xE9essayez."
  },
  dialog: {
    title: "Partager \xAB {name} \xBB par lien",
    introDocument: "Toute personne qui re\xE7oit le lien peut consulter ce document sans compte BatiFlow, jusqu\u2019\xE0 la date d\u2019expiration. Vous pouvez r\xE9voquer le lien \xE0 tout moment.",
    introFolder: "Toute personne qui re\xE7oit le lien peut consulter les documents de ce dossier sans compte BatiFlow, jusqu\u2019\xE0 la date d\u2019expiration. Vous pouvez r\xE9voquer le lien \xE0 tout moment.",
    failedTitle: "Le lien n\u2019a pas \xE9t\xE9 cr\xE9\xE9",
    policyFailed: "Les r\xE8gles de l\u2019espace n\u2019ont pas pu \xEAtre lues. R\xE9essayez.",
    existing: "Liens existants",
    creating: "Cr\xE9ation en cours\u2026",
    submit: "Cr\xE9er le lien",
    linksOff: {
      title: "Les liens de partage sont d\xE9sactiv\xE9s",
      body: "Un responsable de l\u2019espace les a d\xE9sactiv\xE9s dans les param\xE8tres de l\u2019espace. R\xE9activez-les pour cr\xE9er un lien."
    },
    label: {
      label: "Nom du lien (facultatif)",
      hint: "Il vous aide \xE0 retrouver le lien et figure en filigrane sur les copies, par exemple \xAB Visa bureau de contr\xF4le \xBB.",
      invalid: "Le nom ne peut pas d\xE9passer 120 caract\xE8res."
    },
    days: {
      label: "Dur\xE9e de validit\xE9 (jours)",
      hint: "De 1 \xE0 {max} jours. Le lien s\u2019arr\xEAte tout seul \xE0 la fin.",
      invalid: "Indiquez un nombre entier de jours entre 1 et {max}.",
      until: "Le lien expirera le {date}."
    },
    password: {
      label: "Mot de passe (facultatif)",
      hint: "De {min} \xE0 {max} caract\xE8res. Communiquez-le par un autre canal que le lien.",
      invalid: "Le mot de passe doit compter entre {min} et {max} caract\xE8res.",
      show: "Afficher le mot de passe",
      hide: "Masquer le mot de passe"
    },
    watermark: {
      label: "Filigrane sur les copies",
      hint: "Chaque page affich\xE9e ou t\xE9l\xE9charg\xE9e porte le nom du lien en filigrane.",
      locked: "Impos\xE9 par l\u2019espace : toutes les copies portent un filigrane."
    },
    download: {
      label: "Autoriser le t\xE9l\xE9chargement",
      hint: "La personne peut enregistrer une copie du fichier. Sinon, elle ne peut que le consulter.",
      locked: "Le t\xE9l\xE9chargement est d\xE9sactiv\xE9 dans cet espace : le lien ne peut pas l\u2019autoriser."
    },
    max: {
      label: "Nombre maximal de t\xE9l\xE9chargements (facultatif)",
      hint: "Laissez vide pour ne pas limiter. Une fois atteint, le lien reste consultable mais ne permet plus de t\xE9l\xE9charger.",
      invalid: "Indiquez un nombre entier entre 1 et {max}."
    },
    errors: {
      linksOff: "Les liens de partage sont d\xE9sactiv\xE9s dans cet espace.",
      policy: "Le t\xE9l\xE9chargement est d\xE9sactiv\xE9 dans cet espace : d\xE9sactivez \xAB Autoriser le t\xE9l\xE9chargement \xBB puis recommencez.",
      forbidden: "Vous n\u2019avez pas le droit de partager cet \xE9l\xE9ment par lien.",
      notFound: "Cet \xE9l\xE9ment n\u2019existe plus ou vous ne pouvez plus le partager."
    }
  },
  created: {
    warningTitle: "Copiez le lien maintenant",
    warning: "Ce lien ne sera plus affich\xE9 une fois cette fen\xEAtre ferm\xE9e. Si vous le perdez, r\xE9voquez-le et cr\xE9ez-en un nouveau.",
    urlLabel: "Adresse du lien",
    copy: "Copier le lien",
    copied: "Lien copi\xE9 dans le presse-papiers.",
    copyFailed: "La copie automatique est impossible : le lien est s\xE9lectionn\xE9, copiez-le avec Ctrl+C.",
    until: "Ce lien expire le {date}.",
    passwordNote: "Il est prot\xE9g\xE9 par un mot de passe : transmettez-le s\xE9par\xE9ment.",
    done: "Terminer"
  },
  space: {
    open: "Liens de partage",
    title: "Liens de partage de l\u2019espace",
    intro: "Tous les liens cr\xE9\xE9s pour cet espace, y compris ceux qui ont expir\xE9 ou \xE9t\xE9 r\xE9voqu\xE9s.",
    listLabel: "Liens de partage de l\u2019espace",
    empty: "Aucun lien de partage n\u2019a \xE9t\xE9 cr\xE9\xE9 dans cet espace."
  },
  policy: {
    locked: "Votre offre n\u2019inclut pas la protection des donn\xE9es : vous pouvez lever une restriction existante, mais pas en ajouter.",
    links: {
      label: "Autoriser les liens de partage",
      hint: "Les responsables peuvent cr\xE9er des liens pour des personnes sans compte. D\xE9sactiv\xE9, aucun lien ne peut \xEAtre cr\xE9\xE9 et ceux qui existent cessent de fonctionner."
    },
    upgrade: {
      title: "Fonction non incluse dans votre offre",
      bodyOwner: "Renforcer les r\xE8gles de l\u2019espace (t\xE9l\xE9chargement, filigrane, impression, liens de partage) fait partie de la protection des donn\xE9es, r\xE9serv\xE9e aux offres Business et Enterprise.",
      bodyMember: "Renforcer les r\xE8gles de l\u2019espace fait partie de la protection des donn\xE9es, r\xE9serv\xE9e aux offres Business et Enterprise. Contactez l\u2019administrateur de votre organisation pour changer d\u2019offre."
    }
  },
  public: {
    brand: "Partage de {organization}",
    language: "Langue",
    defaultTitle: "Documents partag\xE9s",
    defaultStamp: "Lien de partage",
    sharedBy: "Partag\xE9 par {organization}",
    expiresOn: "Disponible jusqu\u2019au {date}",
    print: "Imprimer",
    watermarkNote: "Les copies affich\xE9es et t\xE9l\xE9charg\xE9es portent un filigrane \xE0 l\u2019identit\xE9 de ce lien.",
    noDownloadNote: "Le t\xE9l\xE9chargement n\u2019est pas autoris\xE9 pour ce lien : le document se consulte \xE0 l\u2019\xE9cran.",
    states: {
      loading: "Chargement du lien",
      notFoundTitle: "Ce lien n\u2019est plus valide",
      notFoundBody: "Demandez un nouveau lien \xE0 la personne qui vous l\u2019a envoy\xE9.",
      loadFailedTitle: "Le lien n\u2019a pas pu \xEAtre ouvert",
      loadFailedBody: "V\xE9rifiez votre connexion, puis r\xE9essayez."
    },
    password: {
      title: "Ce lien est prot\xE9g\xE9 par un mot de passe",
      intro: "Saisissez le mot de passe que la personne qui vous a envoy\xE9 le lien vous a communiqu\xE9.",
      expired: "Votre acc\xE8s a expir\xE9. Saisissez de nouveau le mot de passe.",
      label: "Mot de passe",
      show: "Afficher le mot de passe",
      hide: "Masquer le mot de passe",
      required: "Saisissez le mot de passe.",
      submit: "Ouvrir",
      checking: "V\xE9rification\u2026",
      wrong: "{count, plural, one {Mot de passe incorrect \u2014 encore # essai} other {Mot de passe incorrect \u2014 encore # essais}}",
      locked: "{minutes, plural, one {Trop d\u2019essais, r\xE9essayez dans # minute.} other {Trop d\u2019essais, r\xE9essayez dans # minutes.}}",
      failed: "Le mot de passe n\u2019a pas pu \xEAtre v\xE9rifi\xE9. R\xE9essayez."
    },
    documents: {
      title: "{count, plural, one {Document partag\xE9 (#)} other {Documents partag\xE9s (#)}}",
      listLabel: "Documents partag\xE9s",
      viewerLabel: "Document ouvert : {name}",
      index: "Indice {index}",
      empty: "Il n\u2019y a aucun document \xE0 afficher pour le moment."
    },
    download: {
      action: "T\xE9l\xE9charger",
      label: "T\xE9l\xE9charger {name}",
      left: "{count, plural, one {Il reste # t\xE9l\xE9chargement.} other {Il reste # t\xE9l\xE9chargements.}}",
      preparing: "Pr\xE9paration du t\xE9l\xE9chargement\u2026",
      preparingWatermark: "Pr\xE9paration d\u2019une copie filigran\xE9e\u2026",
      started: "Le t\xE9l\xE9chargement a d\xE9marr\xE9.",
      openCopy: "S\u2019il ne d\xE9marre pas, ouvrez la copie.",
      still: "La copie n\u2019est pas encore pr\xEAte. R\xE9essayez dans un instant.",
      notAllowed: "Le t\xE9l\xE9chargement n\u2019est pas autoris\xE9 pour ce lien.",
      limit: "Le nombre de t\xE9l\xE9chargements autoris\xE9s est atteint.",
      failed: "Le t\xE9l\xE9chargement a \xE9chou\xE9. R\xE9essayez."
    },
    preview: {
      loading: "Chargement de l\u2019aper\xE7u",
      preparing: "Pr\xE9paration de l\u2019aper\xE7u\u2026",
      preparingWatermark: "Pr\xE9paration d\u2019une copie filigran\xE9e\u2026",
      failedTitle: "L\u2019aper\xE7u n\u2019a pas pu \xEAtre charg\xE9",
      failedBody: "V\xE9rifiez votre connexion, puis r\xE9essayez.",
      noneTitle: "Aper\xE7u non disponible",
      noneBody: "Ce type de fichier ne peut pas \xEAtre affich\xE9 en ligne.",
      goneTitle: "Ce document n\u2019est plus accessible",
      goneBody: "Votre acc\xE8s a peut-\xEAtre expir\xE9 ou le lien a \xE9t\xE9 r\xE9voqu\xE9.",
      reload: "Actualiser",
      cadTitle: "Aper\xE7u non disponible",
      cadBody: "Ce plan n\u2019a pas pu \xEAtre affich\xE9. R\xE9essayez dans un instant."
    }
  }
};

// locales/ar/backoffice.json
var backoffice_default = {
  header: {
    tag: "\u0627\u0644\u0625\u062F\u0627\u0631\u0629 \u0627\u0644\u0645\u0631\u0643\u0632\u064A\u0629",
    sessionHint: "\u0627\u0644\u062C\u0644\u0633\u0629 \u0645\u062D\u0645\u064A\u0629 \u0628\u0640 WebAuthn: \u064A\u0637\u0644\u0628 \u0643\u0644 \u062A\u0639\u062F\u064A\u0644 \u062A\u0623\u0643\u064A\u062F \u0647\u0648\u064A\u062A\u0643.",
    language: "\u0627\u0644\u0644\u063A\u0629",
    accountMenu: "\u0642\u0627\u0626\u0645\u0629 \u062D\u0633\u0627\u0628 {name}",
    signOut: "\u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062E\u0631\u0648\u062C"
  },
  nav: {
    organizations: "\u0627\u0644\u0645\u0624\u0633\u0633\u0627\u062A",
    "break-glass": "\u0627\u0644\u062F\u0639\u0645",
    jobs: "\u0627\u0644\u0645\u0647\u0627\u0645 \u0627\u0644\u0641\u0627\u0634\u0644\u0629",
    security: "\u0627\u0644\u0623\u0645\u0627\u0646",
    audit: "\u0627\u0644\u0633\u062C\u0644",
    plans: "\u0627\u0644\u0628\u0627\u0642\u0627\u062A",
    deletions: "\u0639\u0645\u0644\u064A\u0627\u062A \u0627\u0644\u062D\u0630\u0641"
  },
  common: {
    none: "\u2014",
    cancel: "\u0625\u0644\u063A\u0627\u0621",
    busy: "\u062C\u0627\u0631\u064D \u0627\u0644\u062A\u0646\u0641\u064A\u0630",
    loadMore: "\u0639\u0631\u0636 \u0627\u0644\u0645\u0632\u064A\u062F",
    loadingMore: "\u062C\u0627\u0631\u064D \u0627\u0644\u062A\u062D\u0645\u064A\u0644\u2026",
    duration: {
      minutes: "{minutes} \u062F",
      hours: "{hours} \u0633",
      hoursMinutes: "{hours} \u0633 {minutes} \u062F"
    },
    to: "\u0625\u0644\u0649"
  },
  session: {
    loading: "\u062C\u0627\u0631\u064D \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0625\u062F\u0627\u0631\u0629 \u0627\u0644\u0645\u0631\u0643\u0632\u064A\u0629\u2026",
    redirecting: "\u062C\u0627\u0631\u064D \u0627\u0644\u062A\u062D\u0648\u064A\u0644 \u0625\u0644\u0649 \u0635\u0641\u062D\u0629 \u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062F\u062E\u0648\u0644\u2026"
  },
  unavailable: {
    title: "\u062E\u062F\u0645\u0629 \u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062F\u062E\u0648\u0644 \u063A\u064A\u0631 \u0645\u062A\u0627\u062D\u0629",
    body: "\u0644\u0627 \u064A\u0645\u0643\u0646\u0646\u0627 \u0627\u0644\u062A\u062D\u0642\u0642 \u0645\u0646 \u062C\u0644\u0633\u062A\u0643 \u062D\u0627\u0644\u064A\u064B\u0627. \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629 \u0628\u0639\u062F \u0642\u0644\u064A\u0644\u060C \u0648\u0625\u0630\u0627 \u0627\u0633\u062A\u0645\u0631\u062A \u0627\u0644\u0645\u0634\u0643\u0644\u0629 \u0641\u062A\u0648\u0627\u0635\u0644 \u0645\u0639 \u0627\u0644\u0641\u0631\u064A\u0642 \u0627\u0644\u062A\u0642\u0646\u064A."
  },
  signedOut: {
    title: "\u062A\u0645 \u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062E\u0631\u0648\u062C",
    body: "\u0623\u064F\u063A\u0644\u0642\u062A \u062C\u0644\u0633\u062A\u0643 \u0641\u064A \u0627\u0644\u0625\u062F\u0627\u0631\u0629 \u0627\u0644\u0645\u0631\u0643\u0632\u064A\u0629 \u0644\u0640 BatiFlow \u0639\u0644\u0649 \u0647\u0630\u0627 \u0627\u0644\u062C\u0647\u0627\u0632. \u0644\u0645\u062A\u0627\u0628\u0639\u0629 \u0627\u0644\u0639\u0645\u0644\u060C \u0633\u062C\u0651\u0644 \u0627\u0644\u062F\u062E\u0648\u0644 \u0645\u0646 \u062C\u062F\u064A\u062F \u0628\u0645\u0641\u062A\u0627\u062D \u0627\u0644\u0623\u0645\u0627\u0646 \u0627\u0644\u062E\u0627\u0635 \u0628\u0643.",
    signIn: "\u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062F\u062E\u0648\u0644 \u0645\u0646 \u062C\u062F\u064A\u062F",
    reasons: {
      login_failed: {
        title: "\u0644\u0645 \u064A\u0643\u062A\u0645\u0644 \u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062F\u062E\u0648\u0644",
        body: "\u0627\u0646\u0642\u0637\u0639 \u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062F\u062E\u0648\u0644 \u0623\u0648 \u0627\u0646\u062A\u0647\u062A \u0645\u0647\u0644\u062A\u0647. \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629\u061B \u0648\u0625\u0630\u0627 \u0627\u0633\u062A\u0645\u0631\u0651\u062A \u0627\u0644\u0645\u0634\u0643\u0644\u0629 \u0641\u062A\u0648\u0627\u0635\u0644 \u0645\u0639 \u0627\u0644\u0641\u0631\u064A\u0642 \u0627\u0644\u062A\u0642\u0646\u064A."
      },
      cancelled: {
        title: "\u0623\u064F\u0644\u063A\u064A \u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062F\u062E\u0648\u0644",
        body: "\u0623\u0644\u063A\u064A\u062A \u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062F\u062E\u0648\u0644. \u064A\u0645\u0643\u0646\u0643 \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629 \u0645\u0646 \u062C\u062F\u064A\u062F \u0641\u064A \u0623\u064A \u0648\u0642\u062A."
      },
      not_platform_admin: {
        title: "\u062D\u0633\u0627\u0628 \u063A\u064A\u0631 \u0645\u0635\u0631\u0651\u062D \u0644\u0647",
        body: "\u0647\u0630\u0627 \u0627\u0644\u062D\u0633\u0627\u0628 \u0644\u064A\u0633 \u0645\u0633\u0624\u0648\u0644\u064B\u0627 \u0639\u0646 \u0627\u0644\u0645\u0646\u0635\u0629. \u0627\u0644\u062F\u062E\u0648\u0644 \u0625\u0644\u0649 \u0627\u0644\u0625\u062F\u0627\u0631\u0629 \u0627\u0644\u0645\u0631\u0643\u0632\u064A\u0629 \u0645\u062E\u0635\u0651\u0635 \u0644\u0641\u0631\u064A\u0642 BatiFlow. \u0625\u0630\u0627 \u0643\u0646\u062A \u062A\u0639\u062A\u0642\u062F \u0623\u0646 \u0641\u064A \u0627\u0644\u0623\u0645\u0631 \u062E\u0637\u0623\u064B\u060C \u0641\u0627\u0637\u0644\u0628 \u0645\u0646 \u0623\u062D\u062F \u0627\u0644\u0645\u0633\u0624\u0648\u0644\u064A\u0646 \u0627\u0644\u062A\u062D\u0642\u0642 \u0645\u0646 \u062F\u0648\u0631\u0643."
      },
      webauthn_required: {
        title: "\u0645\u0641\u062A\u0627\u062D \u0627\u0644\u0623\u0645\u0627\u0646 \u0645\u0637\u0644\u0648\u0628",
        body: "\u062A\u0634\u062A\u0631\u0637 \u0627\u0644\u0625\u062F\u0627\u0631\u0629 \u0627\u0644\u0645\u0631\u0643\u0632\u064A\u0629 \u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062F\u062E\u0648\u0644 \u0628\u0645\u0641\u062A\u0627\u062D \u0623\u0645\u0627\u0646 \u0623\u0648 \u0628\u0627\u0644\u0628\u0635\u0645\u0629 \u0627\u0644\u062D\u064A\u0648\u064A\u0629 (WebAuthn). \u0633\u062C\u0651\u0644 \u0627\u0644\u062F\u062E\u0648\u0644 \u0645\u0646 \u062C\u062F\u064A\u062F \u0648\u0627\u062E\u062A\u0631 \u0647\u0630\u0647 \u0627\u0644\u0637\u0631\u064A\u0642\u0629\u061B \u0641\u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631 \u0648\u062D\u062F\u0647\u0627 \u0644\u0627 \u062A\u0643\u0641\u064A."
      },
      step_up_failed: {
        title: "\u0644\u0645 \u064A\u062A\u0645 \u062A\u0623\u0643\u064A\u062F \u0627\u0644\u0647\u0648\u064A\u0629",
        body: "\u062A\u0639\u0630\u0651\u0631 \u062A\u0623\u0643\u064A\u062F \u0647\u0648\u064A\u062A\u0643 \u0628\u0645\u0641\u062A\u0627\u062D \u0627\u0644\u0623\u0645\u0627\u0646. \u0644\u0645 \u064A\u064F\u063A\u064A\u064E\u0651\u0631 \u0623\u064A\u0651 \u0634\u064A\u0621. \u0633\u062C\u0651\u0644 \u0627\u0644\u062F\u062E\u0648\u0644 \u0645\u0646 \u062C\u062F\u064A\u062F \u062B\u0645 \u0623\u0639\u062F \u0627\u0644\u0625\u062C\u0631\u0627\u0621."
      }
    }
  },
  stepUp: {
    reason: "\u064A\u0639\u062F\u0651\u0644 \u0647\u0630\u0627 \u0627\u0644\u0625\u062C\u0631\u0627\u0621 \u0628\u064A\u0627\u0646\u0627\u062A \u0627\u0644\u0645\u0646\u0635\u0629\u060C \u0644\u0630\u0644\u0643 \u064A\u0637\u0644\u0628 \u062A\u0623\u0643\u064A\u062F \u0647\u0648\u064A\u062A\u0643 \u0628\u0645\u0641\u062A\u0627\u062D \u0627\u0644\u0623\u0645\u0627\u0646 (WebAuthn). \u0633\u062A\u0639\u0648\u062F \u0628\u0639\u062F\u0647\u0627 \u0625\u0644\u0649 \u0647\u0630\u0647 \u0627\u0644\u0635\u0641\u062D\u0629 \u0648\u0633\u064A\u064F\u0646\u0641\u064E\u0651\u0630 \u0627\u0644\u0625\u062C\u0631\u0627\u0621."
  },
  pendingAction: {
    replayed: "\u062A\u0645\u0651: \u0646\u064F\u0641\u0651\u0630 \u0625\u062C\u0631\u0627\u0624\u0643 \u0628\u0639\u062F \u062A\u0623\u0643\u064A\u062F \u0647\u0648\u064A\u062A\u0643.",
    failed: "\u062A\u0645\u0651 \u062A\u0623\u0643\u064A\u062F \u0647\u0648\u064A\u062A\u0643\u060C \u0644\u0643\u0646 \u0627\u0644\u0625\u062C\u0631\u0627\u0621 \u0644\u0645 \u064A\u0643\u062A\u0645\u0644. \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629."
  },
  signOut: {
    title: "\u0644\u0645 \u064A\u0643\u062A\u0645\u0644 \u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062E\u0631\u0648\u062C",
    failed: "\u062A\u0639\u0630\u0651\u0631 \u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062E\u0631\u0648\u062C. \u0623\u063A\u0644\u0642 \u0645\u062A\u0635\u0641\u062D\u0643 \u0644\u0625\u0646\u0647\u0627\u0621 \u0627\u0644\u062C\u0644\u0633\u0629 \u0628\u0623\u0645\u0627\u0646.",
    close: "\u0625\u063A\u0644\u0627\u0642"
  },
  error: {
    title: "\u062D\u062F\u062B\u062A \u0645\u0634\u0643\u0644\u0629",
    body: "\u062A\u0639\u0630\u0651\u0631 \u0639\u0631\u0636 \u0647\u0630\u0647 \u0627\u0644\u0635\u0641\u062D\u0629. \u0623\u0639\u062F \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0635\u0641\u062D\u0629\u060C \u0648\u0625\u0630\u0627 \u0627\u0633\u062A\u0645\u0631\u062A \u0627\u0644\u0645\u0634\u0643\u0644\u0629 \u0641\u0623\u0631\u0633\u0644 \u0627\u0644\u062A\u0641\u0627\u0635\u064A\u0644 \u0627\u0644\u062A\u0642\u0646\u064A\u0629 \u0625\u0644\u0649 \u0627\u0644\u0641\u0631\u064A\u0642 \u0627\u0644\u062A\u0642\u0646\u064A.",
    reload: "\u0625\u0639\u0627\u062F\u0629 \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0635\u0641\u062D\u0629",
    details: "\u0627\u0644\u062A\u0641\u0627\u0635\u064A\u0644 \u0627\u0644\u062A\u0642\u0646\u064A\u0629",
    noTrace: "\u063A\u064A\u0631 \u0645\u062A\u0648\u0641\u0631",
    release: "\u0627\u0644\u0625\u0635\u062F\u0627\u0631: {release}",
    copied: "\u062A\u0645 \u0646\u0633\u062E \u0627\u0644\u062A\u0641\u0627\u0635\u064A\u0644 \u0625\u0644\u0649 \u0627\u0644\u062D\u0627\u0641\u0638\u0629.",
    copyFailed: "\u062A\u0639\u0630\u0651\u0631 \u0627\u0644\u0646\u0633\u062E. \u062D\u062F\u0651\u062F \u0627\u0644\u0646\u0635 \u0623\u0639\u0644\u0627\u0647 \u0644\u0646\u0633\u062E\u0647 \u064A\u062F\u0648\u064A\u064B\u0627."
  },
  notFound: {
    title: "\u0647\u0630\u0647 \u0627\u0644\u0635\u0641\u062D\u0629 \u063A\u064A\u0631 \u0645\u0648\u062C\u0648\u062F\u0629",
    body: "\u0631\u0628\u0645\u0627 \u064A\u0643\u0648\u0646 \u0627\u0644\u0631\u0627\u0628\u0637 \u0642\u062F\u064A\u0645\u064B\u0627 \u0623\u0648 \u0628\u0647 \u062E\u0637\u0623 \u0641\u064A \u0627\u0644\u0643\u062A\u0627\u0628\u0629. \u0639\u062F \u0625\u0644\u0649 \u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u0645\u0624\u0633\u0633\u0627\u062A \u0644\u0644\u0645\u062A\u0627\u0628\u0639\u0629.",
    home: "\u0627\u0644\u0639\u0648\u062F\u0629 \u0625\u0644\u0649 \u0627\u0644\u0645\u0624\u0633\u0633\u0627\u062A"
  },
  status: {
    organization: {
      trial: "\u062A\u062C\u0631\u064A\u0628\u064A",
      active: "\u0646\u0634\u0637",
      read_only: "\u0642\u0631\u0627\u0621\u0629 \u0641\u0642\u0637",
      suspended: "\u0645\u0648\u0642\u0648\u0641",
      closed: "\u0645\u064F\u063A\u0644\u064E\u0642",
      deleted: "\u0645\u062D\u0630\u0648\u0641"
    },
    subscription: {
      trialing: "\u0641\u062A\u0631\u0629 \u062A\u062C\u0631\u064A\u0628\u064A\u0629",
      active: "\u0646\u0634\u0637",
      past_due: "\u062F\u0641\u0639\u0629 \u0645\u062A\u0623\u062E\u0631\u0629",
      read_only: "\u0642\u0631\u0627\u0621\u0629 \u0641\u0642\u0637",
      suspended: "\u0645\u0648\u0642\u0648\u0641",
      paused: "\u0645\u062A\u0648\u0642\u0641 \u0645\u0624\u0642\u062A\u064B\u0627",
      cancelled: "\u0645\u0644\u063A\u0649"
    }
  },
  orgs: {
    title: "\u0627\u0644\u0645\u0624\u0633\u0633\u0627\u062A",
    tableCaption: "\u0627\u0644\u0645\u0624\u0633\u0633\u0627\u062A \u0627\u0644\u0639\u0645\u064A\u0644\u0629 \u0644\u0640 BatiFlow",
    loadFailedTitle: "\u062A\u0639\u0630\u0651\u0631 \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0645\u0624\u0633\u0633\u0627\u062A",
    loadFailedBody: "\u062A\u0639\u0630\u0651\u0631 \u062C\u0644\u0628 \u0627\u0644\u0642\u0627\u0626\u0645\u0629. \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629 \u0628\u0639\u062F \u0642\u0644\u064A\u0644.",
    columns: {
      name: "\u0627\u0644\u0627\u0633\u0645 \u0627\u0644\u0642\u0627\u0646\u0648\u0646\u064A",
      taxId: "\u0627\u0644\u0645\u0639\u0631\u0651\u0641 \u0627\u0644\u062C\u0628\u0627\u0626\u064A",
      status: "\u0627\u0644\u062D\u0627\u0644\u0629",
      plan: "\u0627\u0644\u0628\u0627\u0642\u0629",
      subscription: "\u0627\u0644\u0627\u0634\u062A\u0631\u0627\u0643",
      members: "\u0627\u0644\u0623\u0639\u0636\u0627\u0621",
      storage: "\u0627\u0644\u062A\u062E\u0632\u064A\u0646",
      dueAt: "\u0627\u0644\u0627\u0633\u062A\u062D\u0642\u0627\u0642 \u0627\u0644\u0642\u0627\u062F\u0645"
    },
    filters: {
      label: "\u0627\u0644\u0628\u062D\u062B \u0641\u064A \u0627\u0644\u0645\u0624\u0633\u0633\u0627\u062A \u0648\u062A\u0635\u0641\u064A\u062A\u0647\u0627",
      search: "\u0627\u0644\u0628\u062D\u062B \u0639\u0646 \u0645\u0624\u0633\u0633\u0629",
      searchPlaceholder: "\u0627\u0644\u0627\u0633\u0645 \u0623\u0648 \u0627\u0644\u0645\u0639\u0631\u0651\u0641 \u0627\u0644\u062C\u0628\u0627\u0626\u064A",
      status: "\u0627\u0644\u062A\u0635\u0641\u064A\u0629 \u062D\u0633\u0628 \u0627\u0644\u062D\u0627\u0644\u0629",
      allStatuses: "\u0643\u0644 \u0627\u0644\u062D\u0627\u0644\u0627\u062A",
      clear: "\u0645\u0633\u062D \u0639\u0648\u0627\u0645\u0644 \u0627\u0644\u062A\u0635\u0641\u064A\u0629"
    },
    empty: {
      title: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0645\u0624\u0633\u0633\u0627\u062A",
      description: "\u0633\u062A\u0638\u0647\u0631 \u0627\u0644\u0645\u0624\u0633\u0633\u0627\u062A \u0647\u0646\u0627 \u0628\u0645\u062C\u0631\u062F \u0623\u0646 \u064A\u0646\u0634\u0626 \u0645\u0643\u062A\u0628 \u062F\u0631\u0627\u0633\u0627\u062A \u062D\u0633\u0627\u0628\u0647.",
      filteredTitle: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0646\u062A\u0627\u0626\u062C",
      filteredDescription: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0645\u0624\u0633\u0633\u0629 \u062A\u0637\u0627\u0628\u0642 \u0647\u0630\u0627 \u0627\u0644\u0628\u062D\u062B. \u062A\u062D\u0642\u0642 \u0645\u0646 \u0627\u0644\u0643\u062A\u0627\u0628\u0629 \u0623\u0648 \u0627\u0645\u0633\u062D \u0639\u0648\u0627\u0645\u0644 \u0627\u0644\u062A\u0635\u0641\u064A\u0629."
    },
    detail: {
      loading: "\u062C\u0627\u0631\u064D \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0645\u0624\u0633\u0633\u0629\u2026",
      loadFailedTitle: "\u062A\u0639\u0630\u0651\u0631 \u062A\u062D\u0645\u064A\u0644 \u0647\u0630\u0647 \u0627\u0644\u0645\u0624\u0633\u0633\u0629",
      loadFailedBody: "\u062A\u0639\u0630\u0651\u0631 \u062C\u0644\u0628 \u0627\u0644\u0645\u0639\u0644\u0648\u0645\u0627\u062A. \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629 \u0628\u0639\u062F \u0642\u0644\u064A\u0644.",
      notFoundTitle: "\u0627\u0644\u0645\u0624\u0633\u0633\u0629 \u063A\u064A\u0631 \u0645\u0648\u062C\u0648\u062F\u0629",
      notFoundDescription: "\u0647\u0630\u0647 \u0627\u0644\u0645\u0624\u0633\u0633\u0629 \u063A\u064A\u0631 \u0645\u0648\u062C\u0648\u062F\u0629 \u0623\u0648 \u0623\u0646 \u0627\u0644\u0631\u0627\u0628\u0637 \u063A\u064A\u0631 \u0635\u062D\u064A\u062D.",
      backToList: "\u0627\u0644\u0639\u0648\u062F\u0629 \u0625\u0644\u0649 \u0627\u0644\u0645\u0624\u0633\u0633\u0627\u062A",
      requestAccess: "\u0637\u0644\u0628 \u0648\u0635\u0648\u0644 \u0627\u0644\u062F\u0639\u0645",
      changeStatus: "\u062A\u063A\u064A\u064A\u0631 \u0627\u0644\u062D\u0627\u0644\u0629",
      summary: "\u0627\u0644\u0645\u0644\u062E\u0635",
      legalName: "\u0627\u0644\u0627\u0633\u0645 \u0627\u0644\u0642\u0627\u0646\u0648\u0646\u064A",
      tradeName: "\u0627\u0644\u0627\u0633\u0645 \u0627\u0644\u062A\u062C\u0627\u0631\u064A",
      governorate: "\u0627\u0644\u0648\u0644\u0627\u064A\u0629",
      createdAt: "\u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0625\u0646\u0634\u0627\u0621",
      owners: "\u0627\u0644\u0645\u0627\u0644\u0643\u0648\u0646",
      subscription: "\u0627\u0644\u0627\u0634\u062A\u0631\u0627\u0643",
      noSubscription: "\u0644\u064A\u0633 \u0644\u0647\u0630\u0647 \u0627\u0644\u0645\u0624\u0633\u0633\u0629 \u0627\u0634\u062A\u0631\u0627\u0643.",
      cycle: "\u062F\u0648\u0631\u0629 \u0627\u0644\u0641\u0648\u062A\u0631\u0629",
      cycles: {
        monthly: "\u0634\u0647\u0631\u064A",
        annual: "\u0633\u0646\u0648\u064A"
      },
      extraSeats: "\u0627\u0644\u0645\u0642\u0627\u0639\u062F \u0627\u0644\u0625\u0636\u0627\u0641\u064A\u0629",
      period: "\u0627\u0644\u0641\u062A\u0631\u0629 \u0627\u0644\u062D\u0627\u0644\u064A\u0629",
      trialEndsAt: "\u0646\u0647\u0627\u064A\u0629 \u0627\u0644\u0641\u062A\u0631\u0629 \u0627\u0644\u062A\u062C\u0631\u064A\u0628\u064A\u0629",
      cancelAt: "\u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0625\u0644\u063A\u0627\u0621 \u0627\u0644\u0645\u0642\u0631\u0631",
      pausedUntil: "\u0645\u062A\u0648\u0642\u0641 \u0645\u0624\u0642\u062A\u064B\u0627 \u062D\u062A\u0649",
      paymentMethod: "\u0648\u0633\u064A\u0644\u0629 \u0627\u0644\u062F\u0641\u0639",
      paymentMethods: {
        card: "\u0628\u0637\u0627\u0642\u0629 \u0645\u0635\u0631\u0641\u064A\u0629",
        bank_transfer: "\u062A\u062D\u0648\u064A\u0644 \u0645\u0635\u0631\u0641\u064A",
        cheque: "\u0634\u064A\u0643",
        online: "\u0627\u0644\u062F\u0641\u0639 \u0639\u0628\u0631 \u0627\u0644\u0625\u0646\u062A\u0631\u0646\u062A",
        transfer: "\u062A\u062D\u0648\u064A\u0644 \u0628\u0646\u0643\u064A"
      },
      usage: "\u0627\u0644\u0627\u0633\u062A\u062E\u062F\u0627\u0645",
      seatsUsed: "\u0627\u0644\u0645\u0642\u0627\u0639\u062F \u0627\u0644\u0645\u0633\u062A\u062E\u062F\u0645\u0629",
      seatsBillable: "\u0627\u0644\u0645\u0642\u0627\u0639\u062F \u0627\u0644\u0642\u0627\u0628\u0644\u0629 \u0644\u0644\u0641\u0648\u062A\u0631\u0629",
      unlimited: "\u063A\u064A\u0631 \u0645\u062D\u062F\u0648\u062F",
      monthMetric: "\u0647\u0630\u0627 \u0627\u0644\u0634\u0647\u0631: {metric}",
      metrics: {
        storage_bytes: "\u0627\u0644\u062A\u062E\u0632\u064A\u0646 \u0627\u0644\u0645\u0633\u062C\u064E\u0651\u0644",
        meeting_participant_minutes: "\u062F\u0642\u0627\u0626\u0642 \u0645\u0634\u0627\u0631\u0643\u0629 \u0627\u0644\u0645\u0634\u0627\u0631\u0643\u064A\u0646 \u0641\u064A \u0627\u0644\u0627\u062C\u062A\u0645\u0627\u0639\u0627\u062A",
        ttn_submissions: "\u0627\u0644\u0625\u0631\u0633\u0627\u0644\u0627\u062A \u0625\u0644\u0649 TTN"
      },
      deletion: {
        scheduled: "\u0627\u0644\u062D\u0630\u0641 \u0645\u062C\u062F\u0648\u0644",
        done: "\u062D\u064F\u0630\u0641\u062A \u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A",
        cancelled: "\u0623\u064F\u0644\u063A\u064A \u0627\u0644\u062D\u0630\u0641",
        body: "\u0627\u0644\u0633\u0628\u0628: {reason}. \u0627\u0644\u0645\u0648\u0639\u062F \u0627\u0644\u0645\u0642\u0631\u0631:",
        running: "\u0627\u0644\u062D\u0630\u0641 \u062C\u0627\u0631\u064D"
      },
      invoices: {
        title: "\u0641\u0648\u0627\u062A\u064A\u0631 \u0627\u0644\u0627\u0634\u062A\u0631\u0627\u0643",
        description: "\u0627\u0644\u0641\u0648\u0627\u062A\u064A\u0631 \u0627\u0644\u062A\u064A \u0623\u0635\u062F\u0631\u062A\u0647\u0627 BatiFlow \u0644\u0647\u0630\u0647 \u0627\u0644\u0645\u0624\u0633\u0633\u0629. \u064A\u0645\u0643\u0646 \u062A\u0633\u0648\u064A\u0629 \u0627\u0644\u0641\u0648\u0627\u062A\u064A\u0631 \u0627\u0644\u0645\u0641\u062A\u0648\u062D\u0629 \u0628\u062A\u062D\u0648\u064A\u0644 \u0645\u0635\u0631\u0641\u064A \u0623\u0648 \u0628\u0634\u064A\u0643.",
        caption: "\u0641\u0648\u0627\u062A\u064A\u0631 \u0627\u0634\u062A\u0631\u0627\u0643 \u0627\u0644\u0645\u0624\u0633\u0633\u0629",
        number: "\u0627\u0644\u0631\u0642\u0645",
        purpose: "\u0627\u0644\u063A\u0631\u0636",
        issueDate: "\u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0625\u0635\u062F\u0627\u0631",
        dueDate: "\u0627\u0644\u0633\u062F\u0627\u062F \u0642\u0628\u0644",
        total: "\u0627\u0644\u0625\u062C\u0645\u0627\u0644\u064A \u0634\u0627\u0645\u0644 \u0627\u0644\u0636\u0631\u064A\u0628\u0629",
        status: "\u0627\u0644\u062D\u0627\u0644\u0629",
        actions: "\u0627\u0644\u0625\u062C\u0631\u0627\u0621\u0627\u062A",
        confirmPayment: "\u062A\u0623\u0643\u064A\u062F \u062F\u0641\u0639\u0629",
        confirmFor: "\u062A\u0623\u0643\u064A\u062F \u062F\u0641\u0639 \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629 {number}",
        emptyTitle: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0641\u0648\u0627\u062A\u064A\u0631",
        emptyDescription: "\u0644\u0645 \u062A\u064F\u0635\u062F\u064E\u0631 \u0623\u064A \u0641\u0627\u062A\u0648\u0631\u0629 \u0627\u0634\u062A\u0631\u0627\u0643 \u0644\u0647\u0630\u0647 \u0627\u0644\u0645\u0624\u0633\u0633\u0629.",
        purposes: {
          start: "\u0628\u062F\u0627\u064A\u0629 \u0627\u0644\u0627\u0634\u062A\u0631\u0627\u0643",
          upgrade: "\u062A\u063A\u064A\u064A\u0631 \u0627\u0644\u0628\u0627\u0642\u0629",
          restart: "\u0625\u0639\u0627\u062F\u0629 \u0627\u0644\u062A\u0634\u063A\u064A\u0644",
          renewal: "\u0627\u0644\u062A\u062C\u062F\u064A\u062F",
          resume: "\u0627\u0644\u0627\u0633\u062A\u0626\u0646\u0627\u0641 \u0628\u0639\u062F \u0627\u0644\u0625\u064A\u0642\u0627\u0641 \u0627\u0644\u0645\u0624\u0642\u062A"
        },
        statuses: {
          open: "\u0644\u0644\u0633\u062F\u0627\u062F",
          paid: "\u0645\u0633\u062F\u064E\u0651\u062F\u0629",
          void: "\u0645\u0644\u063A\u0627\u0629"
        }
      },
      dunning: {
        title: "\u062A\u0630\u0643\u064A\u0631\u0627\u062A \u0627\u0644\u062F\u0641\u0639",
        description: "\u0645\u0631\u0627\u062D\u0644 \u0627\u0644\u062A\u0630\u0643\u064A\u0631 \u0627\u0644\u0645\u0633\u062C\u064E\u0651\u0644\u0629 \u0644\u0647\u0630\u0647 \u0627\u0644\u0645\u0624\u0633\u0633\u0629 \u062D\u062A\u0649 \u0627\u0644\u0622\u0646.",
        empty: "\u0644\u0627 \u062A\u0648\u062C\u062F \u062A\u0630\u0643\u064A\u0631\u0627\u062A \u0645\u0633\u062C\u064E\u0651\u0644\u0629.",
        due: "\u0627\u0644\u0627\u0633\u062A\u062D\u0642\u0627\u0642:",
        recorded: "\u0633\u064F\u062C\u0651\u0644 \u0641\u064A",
        stages: {
          reminder: "\u062A\u0630\u0643\u064A\u0631 \u0628\u0627\u0644\u0627\u0633\u062A\u062D\u0642\u0627\u0642 (D{day})",
          read_only: "\u0627\u0644\u062A\u062D\u0648\u064A\u0644 \u0625\u0644\u0649 \u0627\u0644\u0642\u0631\u0627\u0621\u0629 \u0641\u0642\u0637",
          suspended: "\u0625\u064A\u0642\u0627\u0641 \u0627\u0644\u062D\u0633\u0627\u0628",
          deletion_scheduled: "\u062C\u062F\u0648\u0644\u0629 \u062D\u0630\u0641 \u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A"
        }
      }
    },
    deletions: "\u0639\u0645\u0644\u064A\u0627\u062A \u0627\u0644\u062D\u0630\u0641"
  },
  payment: {
    title: "\u062A\u0623\u0643\u064A\u062F \u062F\u0641\u0639\u0629",
    invoice: "\u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629",
    method: "\u0648\u0633\u064A\u0644\u0629 \u0627\u0644\u062F\u0641\u0639 \u0627\u0644\u0645\u0633\u062A\u0644\u0645\u0629",
    methods: {
      transfer: "\u062A\u062D\u0648\u064A\u0644 \u0645\u0635\u0631\u0641\u064A",
      cheque: "\u0634\u064A\u0643"
    },
    receivedOn: "\u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0627\u0633\u062A\u0644\u0627\u0645",
    reference: "\u0627\u0644\u0645\u0631\u062C\u0639",
    referenceHint: "\u0645\u0631\u062C\u0639 \u0627\u0644\u062A\u062D\u0648\u064A\u0644 \u0623\u0648 \u0631\u0642\u0645 \u0625\u064A\u0635\u0627\u0644 \u0627\u0644\u0625\u064A\u062F\u0627\u0639\u060C \u0644\u062A\u0633\u0647\u064A\u0644 \u0627\u0644\u0639\u062B\u0648\u0631 \u0639\u0644\u0649 \u0627\u0644\u062F\u0641\u0639\u0629.",
    chequeNumber: "\u0631\u0642\u0645 \u0627\u0644\u0634\u064A\u0643",
    chequeBank: "\u0628\u0646\u0643 \u0627\u0644\u0634\u064A\u0643",
    submit: "\u062A\u0623\u0643\u064A\u062F \u0627\u0644\u062F\u0641\u0639\u0629",
    done: "\u0633\u064F\u062C\u0651\u0644\u062A \u0627\u0644\u062F\u0641\u0639\u0629 {number}: {amount}. \u062A\u0645\u0651\u062A \u062A\u0633\u0648\u064A\u0629 \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629.",
    errors: {
      dateRequired: "\u0623\u062F\u062E\u0644 \u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0627\u0633\u062A\u0644\u0627\u0645.",
      dateFuture: "\u0644\u0627 \u064A\u0645\u0643\u0646 \u0623\u0646 \u064A\u0643\u0648\u0646 \u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0627\u0633\u062A\u0644\u0627\u0645 \u0641\u064A \u0627\u0644\u0645\u0633\u062A\u0642\u0628\u0644.",
      referenceRequired: "\u0623\u062F\u062E\u0644 \u0645\u0631\u062C\u0639 \u0627\u0644\u062F\u0641\u0639\u0629.",
      chequeNumberRequired: "\u0623\u062F\u062E\u0644 \u0631\u0642\u0645 \u0627\u0644\u0634\u064A\u0643.",
      chequeBankRequired: "\u0623\u062F\u062E\u0644 \u0628\u0646\u0643 \u0627\u0644\u0634\u064A\u0643."
    }
  },
  override: {
    title: "\u062A\u063A\u064A\u064A\u0631 \u062D\u0627\u0644\u0629 \u0627\u0644\u0627\u0634\u062A\u0631\u0627\u0643",
    explanation: "\u0623\u0646\u062A \u062A\u063A\u064A\u0651\u0631 \u062D\u0627\u0644\u0629 \u0627\u0644\u0627\u0634\u062A\u0631\u0627\u0643 \u064A\u062F\u0648\u064A\u064B\u0627 (\u0644\u0641\u062A\u0629 \u062A\u062C\u0627\u0631\u064A\u0629\u060C \u0646\u0632\u0627\u0639). \u064A\u062A\u0628\u0639 \u0648\u0635\u0648\u0644 \u0627\u0644\u0645\u0624\u0633\u0633\u0629 \u0647\u0630\u0647 \u0627\u0644\u062D\u0627\u0644\u0629. \u064A\u064F\u0633\u062C\u064E\u0651\u0644 \u0627\u0644\u062A\u063A\u064A\u064A\u0631 \u0641\u064A \u0633\u062C\u0644 \u0627\u0644\u0645\u0646\u0635\u0629 \u0645\u0639 \u0627\u0644\u0633\u0628\u0628 \u0627\u0644\u0630\u064A \u062A\u0630\u0643\u0631\u0647.",
    status: "\u0627\u0644\u062D\u0627\u0644\u0629 \u0627\u0644\u062C\u062F\u064A\u062F\u0629",
    currentMarker: "\u0627\u0644\u062D\u0627\u0644\u064A\u0629",
    effects: {
      trialing: "\u062A\u0639\u0648\u062F \u0627\u0644\u0645\u0624\u0633\u0633\u0629 \u0625\u0644\u0649 \u0641\u062A\u0631\u062A\u0647\u0627 \u0627\u0644\u062A\u062C\u0631\u064A\u0628\u064A\u0629 \u0648\u062A\u0633\u062A\u0639\u064A\u062F \u0627\u0644\u0648\u0635\u0648\u0644 \u0627\u0644\u0643\u0627\u0645\u0644.",
      active: "\u062A\u0633\u062A\u0639\u064A\u062F \u0627\u0644\u0645\u0624\u0633\u0633\u0629 \u0627\u0644\u0648\u0635\u0648\u0644 \u0627\u0644\u0643\u0627\u0645\u0644.",
      past_due: "\u062A\u062D\u062A\u0641\u0638 \u0627\u0644\u0645\u0624\u0633\u0633\u0629 \u0628\u0627\u0644\u0648\u0635\u0648\u0644 \u0627\u0644\u0643\u0627\u0645\u0644\u060C \u0648\u064A\u064F\u0634\u0627\u0631 \u0625\u0644\u0649 \u0648\u062C\u0648\u062F \u062F\u0641\u0639\u0629 \u0645\u062A\u0623\u062E\u0631\u0629.",
      read_only: "\u0644\u0627 \u062A\u0633\u062A\u0637\u064A\u0639 \u0627\u0644\u0645\u0624\u0633\u0633\u0629 \u0633\u0648\u0649 \u0627\u0644\u0627\u0637\u0644\u0627\u0639 \u0639\u0644\u0649 \u0628\u064A\u0627\u0646\u0627\u062A\u0647\u0627: \u0644\u0627 \u0625\u0646\u0634\u0627\u0621 \u0648\u0644\u0627 \u062A\u0639\u062F\u064A\u0644.",
      suspended: "\u0644\u0627 \u062A\u0633\u062A\u0637\u064A\u0639 \u0627\u0644\u0645\u0624\u0633\u0633\u0629 \u0627\u0644\u0648\u0635\u0648\u0644 \u0625\u0644\u0649 \u0628\u064A\u0627\u0646\u0627\u062A\u0647\u0627 \u0625\u0644\u0649 \u0623\u0646 \u062A\u064F\u0633\u062A\u0639\u0627\u062F \u0627\u0644\u062D\u0627\u0644\u0629.",
      paused: "\u064A\u064F\u0639\u0644\u064E\u0651\u0645 \u0627\u0644\u0627\u0634\u062A\u0631\u0627\u0643 \u0628\u0623\u0646\u0647 \u0645\u062A\u0648\u0642\u0641 \u0645\u0624\u0642\u062A\u064B\u0627 \u0648\u062A\u0635\u0628\u062D \u0627\u0644\u0645\u0624\u0633\u0633\u0629 \u0644\u0644\u0642\u0631\u0627\u0621\u0629 \u0641\u0642\u0637.",
      cancelled: "\u064A\u064F\u0639\u0644\u064E\u0651\u0645 \u0627\u0644\u0627\u0634\u062A\u0631\u0627\u0643 \u0628\u0623\u0646\u0647 \u0645\u0644\u063A\u0649 \u0648\u062A\u0635\u0628\u062D \u0627\u0644\u0645\u0624\u0633\u0633\u0629 \u0644\u0644\u0642\u0631\u0627\u0621\u0629 \u0641\u0642\u0637."
    },
    restrictiveWarning: "\u062A\u0642\u064A\u0651\u062F \u0647\u0630\u0647 \u0627\u0644\u062D\u0627\u0644\u0629 \u0648\u0635\u0648\u0644 \u0627\u0644\u0645\u0624\u0633\u0633\u0629: \u0633\u064A\u0644\u0627\u062D\u0638 \u0623\u0639\u0636\u0627\u0624\u0647\u0627 \u0630\u0644\u0643 \u0641\u0648\u0631\u064B\u0627.",
    reason: "\u0627\u0644\u0633\u0628\u0628",
    reasonHint: "{min} \u0623\u062D\u0631\u0641 \u0639\u0644\u0649 \u0627\u0644\u0623\u0642\u0644. \u064A\u064F\u062D\u0641\u0638 \u0647\u0630\u0627 \u0627\u0644\u0633\u0628\u0628 \u0641\u064A \u0627\u0644\u0633\u062C\u0644.",
    reasonTooShort: "\u064A\u062C\u0628 \u0623\u0644\u0627 \u064A\u0642\u0644 \u0627\u0644\u0633\u0628\u0628 \u0639\u0646 {min} \u0623\u062D\u0631\u0641.",
    submit: "\u062A\u0637\u0628\u064A\u0642 \u0627\u0644\u062D\u0627\u0644\u0629",
    confirmTitle: "\u062A\u0639\u062F\u064A\u0644 \u0648\u0635\u0648\u0644 {name}\u061F",
    confirmBody: {
      suspended: "\u0633\u062A\u064F\u0648\u0642\u064E\u0641 \u0627\u0644\u0645\u0624\u0633\u0633\u0629: \u0644\u0646 \u064A\u062A\u0645\u0643\u0646 \u0623\u0639\u0636\u0627\u0624\u0647\u0627 \u0645\u0646 \u0627\u0644\u0648\u0635\u0648\u0644 \u0625\u0644\u0649 \u0628\u064A\u0627\u0646\u0627\u062A\u0647\u0645. \u064A\u0645\u0643\u0646\u0643 \u0627\u0633\u062A\u0639\u0627\u062F\u0629 \u0627\u0644\u062D\u0627\u0644\u0629 \u0644\u0627\u062D\u0642\u064B\u0627.",
      cancelled: "\u0633\u064A\u064F\u0639\u0644\u064E\u0651\u0645 \u0627\u0644\u0627\u0634\u062A\u0631\u0627\u0643 \u0628\u0623\u0646\u0647 \u0645\u0644\u063A\u0649 \u0648\u0633\u062A\u0635\u0628\u062D \u0627\u0644\u0645\u0624\u0633\u0633\u0629 \u0644\u0644\u0642\u0631\u0627\u0621\u0629 \u0641\u0642\u0637. \u064A\u0645\u0643\u0646\u0643 \u0627\u0633\u062A\u0639\u0627\u062F\u0629 \u0627\u0644\u062D\u0627\u0644\u0629 \u0644\u0627\u062D\u0642\u064B\u0627."
    },
    confirm: "\u0646\u0639\u0645\u060C \u0637\u0628\u0651\u0642",
    done: "\u0637\u064F\u0628\u0651\u0642\u062A \u0627\u0644\u062D\u0627\u0644\u0629: {status}.",
    stale: "\u0639\u064F\u062F\u0651\u0644 \u0627\u0644\u0627\u0634\u062A\u0631\u0627\u0643 \u0641\u064A \u0647\u0630\u0647 \u0627\u0644\u0623\u062B\u0646\u0627\u0621. \u062D\u064F\u062F\u0651\u062B\u062A \u0627\u0644\u0635\u0641\u062D\u0629 \u0644\u0644\u062A\u0648: \u062A\u062D\u0642\u0642 \u0645\u0646 \u0627\u0644\u062D\u0627\u0644\u0629 \u062B\u0645 \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629.",
    noTrial: "\u0644\u064A\u0633 \u0644\u0647\u0630\u0627 \u0627\u0644\u0627\u0634\u062A\u0631\u0627\u0643 \u0641\u062A\u0631\u0629 \u062A\u062C\u0631\u064A\u0628\u064A\u0629: \u0627\u062E\u062A\u0631 \u062D\u0627\u0644\u0629 \u0623\u062E\u0631\u0649."
  },
  breakGlass: {
    title: "\u0648\u0635\u0648\u0644 \u0627\u0644\u062F\u0639\u0645 (break-glass)",
    intro: "\u0648\u0635\u0648\u0644 \u0627\u0644\u062F\u0639\u0645 \u0645\u0624\u0642\u062A \u0648\u0644\u0644\u0642\u0631\u0627\u0621\u0629 \u0641\u0642\u0637. \u064A\u0637\u0644\u0628\u0647 \u0645\u0633\u0624\u0648\u0644 \u0648\u064A\u0648\u0627\u0641\u0642 \u0639\u0644\u064A\u0647 \u0645\u0633\u0624\u0648\u0644 \u0622\u062E\u0631.",
    newRequest: "\u0637\u0644\u0628 \u062C\u062F\u064A\u062F",
    tableCaption: "\u0637\u0644\u0628\u0627\u062A \u0648\u0635\u0648\u0644 \u0627\u0644\u062F\u0639\u0645",
    loadFailedTitle: "\u062A\u0639\u0630\u0651\u0631 \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0637\u0644\u0628\u0627\u062A",
    loadFailedBody: "\u062A\u0639\u0630\u0651\u0631 \u062C\u0644\u0628 \u0627\u0644\u0642\u0627\u0626\u0645\u0629. \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629 \u0628\u0639\u062F \u0642\u0644\u064A\u0644.",
    filters: {
      label: "\u062A\u0635\u0641\u064A\u0629 \u0627\u0644\u0637\u0644\u0628\u0627\u062A",
      status: "\u0627\u0644\u062A\u0635\u0641\u064A\u0629 \u062D\u0633\u0628 \u0627\u0644\u062D\u0627\u0644\u0629",
      allStatuses: "\u0643\u0644 \u0627\u0644\u062D\u0627\u0644\u0627\u062A"
    },
    empty: {
      title: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0637\u0644\u0628\u0627\u062A",
      description: "\u0633\u062A\u0638\u0647\u0631 \u0637\u0644\u0628\u0627\u062A \u0648\u0635\u0648\u0644 \u0627\u0644\u062F\u0639\u0645 \u0647\u0646\u0627.",
      filteredTitle: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0637\u0644\u0628\u0627\u062A \u0628\u0647\u0630\u0647 \u0627\u0644\u062D\u0627\u0644\u0629",
      filteredDescription: "\u0627\u062E\u062A\u0631 \u062D\u0627\u0644\u0629 \u0623\u062E\u0631\u0649 \u0644\u0639\u0631\u0636 \u0637\u0644\u0628\u0627\u062A \u0623\u062E\u0631\u0649."
    },
    status: {
      pending: "\u0642\u064A\u062F \u0627\u0644\u0627\u0646\u062A\u0638\u0627\u0631",
      active: "\u0646\u0634\u0637",
      rejected: "\u0645\u0631\u0641\u0648\u0636",
      cancelled: "\u0645\u0644\u063A\u0649",
      expired: "\u0645\u0646\u062A\u0647\u064A",
      revoked: "\u0645\u0633\u062D\u0648\u0628"
    },
    bases: {
      owner_consent: "\u0645\u0648\u0627\u0641\u0642\u0629 \u0627\u0644\u0645\u0627\u0644\u0643",
      legal_requisition: "\u0623\u0645\u0631 \u0642\u0627\u0646\u0648\u0646\u064A"
    },
    columns: {
      organization: "\u0627\u0644\u0645\u0624\u0633\u0633\u0629",
      ticket: "\u0627\u0644\u062A\u0630\u0643\u0631\u0629 \u0648\u0627\u0644\u0633\u0628\u0628",
      basis: "\u0627\u0644\u0623\u0633\u0627\u0633",
      duration: "\u0627\u0644\u0645\u062F\u0629",
      requested: "\u0637\u0644\u0628\u0647",
      decided: "\u0642\u0631\u0651\u0631 \u0641\u064A\u0647",
      window: "\u0646\u0627\u0641\u0630\u0629 \u0627\u0644\u0648\u0635\u0648\u0644",
      status: "\u0627\u0644\u062D\u0627\u0644\u0629",
      actions: "\u0627\u0644\u0625\u062C\u0631\u0627\u0621\u0627\u062A"
    },
    remaining: "\u0627\u0644\u0648\u0642\u062A \u0627\u0644\u0645\u062A\u0628\u0642\u064A:",
    actions: {
      approve: "\u0645\u0648\u0627\u0641\u0642\u0629",
      reject: "\u0631\u0641\u0636",
      cancel: "\u0625\u0644\u063A\u0627\u0621 \u0627\u0644\u0637\u0644\u0628",
      revoke: "\u0633\u062D\u0628 \u0627\u0644\u0648\u0635\u0648\u0644"
    },
    blocked: {
      requester: "\u064A\u062C\u0628 \u0623\u0646 \u064A\u0628\u062A\u0651 \u0645\u0633\u0624\u0648\u0644 \u0622\u062E\u0631 \u0641\u064A \u0647\u0630\u0627 \u0627\u0644\u0637\u0644\u0628: \u0623\u0646\u062A \u0635\u0627\u062D\u0628\u0647.",
      noSupportIdentity: "\u062D\u0633\u0627\u0628 \u0627\u0644\u062F\u0639\u0645 \u0627\u0644\u062E\u0627\u0635 \u0628\u0643 \u063A\u064A\u0631 \u0645\u0631\u062A\u0628\u0637 \u0628\u0639\u062F: \u0627\u0637\u0644\u0628 \u0645\u0646 \u0623\u062D\u062F \u0627\u0644\u0645\u0633\u0624\u0648\u0644\u064A\u0646 \u0625\u0639\u062F\u0627\u062F\u0647."
    },
    request: {
      title: "\u0637\u0644\u0628 \u062C\u062F\u064A\u062F \u0644\u0648\u0635\u0648\u0644 \u0627\u0644\u062F\u0639\u0645",
      rulesIntro: "\u0642\u0628\u0644 \u0627\u0644\u0645\u062A\u0627\u0628\u0639\u0629:",
      rules: {
        readOnly: "\u0627\u0644\u0648\u0635\u0648\u0644 \u0644\u0644\u0642\u0631\u0627\u0621\u0629 \u0641\u0642\u0637: \u0644\u0627 \u064A\u0645\u0643\u0646 \u062A\u0639\u062F\u064A\u0644 \u0623\u064A \u0634\u064A\u0621.",
        secondAdmin: "\u064A\u062C\u0628 \u0623\u0646 \u064A\u0648\u0627\u0641\u0642 \u0645\u0633\u0624\u0648\u0644 \u062B\u0627\u0646\u064D \u0639\u0644\u0649 \u0627\u0644\u0637\u0644\u0628.",
        maxFourHours: "\u064A\u062F\u0648\u0645 \u0627\u0644\u0648\u0635\u0648\u0644 4 \u0633\u0627\u0639\u0627\u062A \u0643\u062D\u062F\u064D\u0651 \u0623\u0642\u0635\u0649 \u062B\u0645 \u064A\u0646\u062A\u0647\u064A \u0645\u0646 \u062A\u0644\u0642\u0627\u0621 \u0646\u0641\u0633\u0647.",
        audited: "\u064A\u064F\u0633\u062C\u064E\u0651\u0644 \u0627\u0644\u0648\u0635\u0648\u0644 \u0641\u064A \u0633\u062C\u0644 \u0627\u0644\u062A\u062F\u0642\u064A\u0642 \u0627\u0644\u062E\u0627\u0635 \u0628\u0627\u0644\u0645\u0624\u0633\u0633\u0629\u060C \u0648\u0628\u0625\u0645\u0643\u0627\u0646 \u0645\u0627\u0644\u0643\u064A\u0647\u0627 \u0627\u0644\u0627\u0637\u0644\u0627\u0639 \u0639\u0644\u064A\u0647."
      },
      organization: "\u0627\u0644\u0645\u0624\u0633\u0633\u0629",
      organizationHint: "\u0627\u0628\u062D\u062B \u0628\u0627\u0644\u0627\u0633\u0645 \u0623\u0648 \u0628\u0627\u0644\u0645\u0639\u0631\u0651\u0641 \u0627\u0644\u062C\u0628\u0627\u0626\u064A (\u062D\u0631\u0641\u0627\u0646 \u0639\u0644\u0649 \u0627\u0644\u0623\u0642\u0644).",
      organizationSearch: "\u0627\u0644\u0628\u062D\u062B \u0639\u0646 \u0627\u0644\u0645\u0624\u0633\u0633\u0629 \u0627\u0644\u0645\u0639\u0646\u064A\u0629",
      organizationResults: "\u0627\u0644\u0645\u0624\u0633\u0633\u0627\u062A \u0627\u0644\u062A\u064A \u0648\u064F\u062C\u062F\u062A",
      noOrganization: "\u0644\u0645 \u062A\u064F\u0648\u062C\u062F \u0623\u064A \u0645\u0624\u0633\u0633\u0629.",
      changeOrganization: "\u062A\u063A\u064A\u064A\u0631 \u0627\u0644\u0645\u0624\u0633\u0633\u0629",
      ticket: "\u0645\u0631\u062C\u0639 \u0627\u0644\u062A\u0630\u0643\u0631\u0629",
      ticketHint: "\u062A\u0630\u0643\u0631\u0629 \u0627\u0644\u062F\u0639\u0645 \u0627\u0644\u062A\u064A \u062A\u0628\u0631\u0651\u0631 \u0647\u0630\u0627 \u0627\u0644\u0648\u0635\u0648\u0644.",
      reason: "\u0627\u0644\u0633\u0628\u0628",
      reasonHint: "{min} \u0623\u062D\u0631\u0641 \u0639\u0644\u0649 \u0627\u0644\u0623\u0642\u0644: \u0627\u0634\u0631\u062D \u0645\u0627 \u062A\u062D\u062A\u0627\u062C \u0625\u0644\u0649 \u0627\u0644\u062A\u062D\u0642\u0642 \u0645\u0646\u0647.",
      basis: "\u0623\u0633\u0627\u0633 \u0627\u0644\u0637\u0644\u0628",
      basisRef: "\u0645\u0631\u062C\u0639 \u0627\u0644\u0623\u0633\u0627\u0633",
      basisRefHint: {
        owner_consent: "\u0645\u0643\u0627\u0646 \u062D\u0641\u0638 \u0645\u0648\u0627\u0641\u0642\u0629 \u0627\u0644\u0645\u0627\u0644\u0643 (\u062A\u0630\u0643\u0631\u0629\u060C \u0628\u0631\u064A\u062F \u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A \u0645\u0624\u0631\u0634\u0641\u2026).",
        legal_requisition: "\u0645\u0643\u0627\u0646 \u062D\u0641\u0638 \u0627\u0644\u0623\u0645\u0631 \u0627\u0644\u0642\u0627\u0646\u0648\u0646\u064A (\u0631\u0642\u0645 \u0627\u0644\u0645\u0644\u0641\u060C \u0648\u062B\u064A\u0642\u0629 \u0645\u0624\u0631\u0634\u0641\u0629\u2026)."
      },
      duration: "\u0627\u0644\u0645\u062F\u0629 (\u0628\u0627\u0644\u062F\u0642\u0627\u0626\u0642)",
      durationHint: "\u0628\u064A\u0646 {min} \u0648{max} \u062F\u0642\u064A\u0642\u0629.",
      submit: "\u0625\u0631\u0633\u0627\u0644 \u0627\u0644\u0637\u0644\u0628",
      done: "\u0623\u064F\u0631\u0633\u0644 \u0627\u0644\u0637\u0644\u0628 \u0627\u0644\u062E\u0627\u0635 \u0628\u0640 {name}. \u064A\u062C\u0628 \u0623\u0646 \u064A\u0648\u0627\u0641\u0642 \u0639\u0644\u064A\u0647 \u0645\u0633\u0624\u0648\u0644 \u0622\u062E\u0631.",
      errors: {
        organizationRequired: "\u0627\u062E\u062A\u0631 \u0627\u0644\u0645\u0624\u0633\u0633\u0629 \u0627\u0644\u0645\u0639\u0646\u064A\u0629.",
        ticketRequired: "\u0623\u062F\u062E\u0644 \u0645\u0631\u062C\u0639 \u0627\u0644\u062A\u0630\u0643\u0631\u0629.",
        reasonTooShort: "\u064A\u062C\u0628 \u0623\u0644\u0627 \u064A\u0642\u0644 \u0627\u0644\u0633\u0628\u0628 \u0639\u0646 {min} \u0623\u062D\u0631\u0641.",
        basisRefRequired: "\u0623\u062F\u062E\u0644 \u0645\u0643\u0627\u0646 \u062D\u0641\u0638 \u0627\u0644\u0623\u0633\u0627\u0633.",
        durationRange: "\u064A\u062C\u0628 \u0623\u0646 \u062A\u0643\u0648\u0646 \u0627\u0644\u0645\u062F\u0629 \u0639\u062F\u062F\u064B\u0627 \u0635\u062D\u064A\u062D\u064B\u0627 \u0645\u0646 \u0627\u0644\u062F\u0642\u0627\u0626\u0642 \u0628\u064A\u0646 {min} \u0648{max}."
      }
    },
    approve: {
      title: "\u0627\u0644\u0645\u0648\u0627\u0641\u0642\u0629 \u0639\u0644\u0649 \u0627\u0644\u0648\u0635\u0648\u0644 \u0625\u0644\u0649 {name}\u061F",
      body: "\u0633\u062A\u062D\u0635\u0644 \u0641\u0648\u0631\u064B\u0627 \u0639\u0644\u0649 \u0648\u0635\u0648\u0644 \u0644\u0644\u0642\u0631\u0627\u0621\u0629 \u0641\u0642\u0637 \u0625\u0644\u0649 \u0647\u0630\u0647 \u0627\u0644\u0645\u0624\u0633\u0633\u0629 \u0639\u0628\u0631 \u062D\u0633\u0627\u0628 \u0627\u0644\u062F\u0639\u0645 \u0627\u0644\u062E\u0627\u0635 \u0628\u0643\u060C \u0637\u0648\u0627\u0644 \u0627\u0644\u0645\u062F\u0629 \u0627\u0644\u0645\u0637\u0644\u0648\u0628\u0629 (4 \u0633\u0627\u0639\u0627\u062A \u0643\u062D\u062F\u064D\u0651 \u0623\u0642\u0635\u0649). \u0633\u064A\u064F\u0633\u062C\u064E\u0651\u0644 \u0627\u0644\u0648\u0635\u0648\u0644 \u0641\u064A \u0633\u062C\u0644 \u0627\u0644\u062A\u062F\u0642\u064A\u0642 \u0627\u0644\u062E\u0627\u0635 \u0628\u0627\u0644\u0645\u0624\u0633\u0633\u0629.",
      confirm: "\u0627\u0644\u0645\u0648\u0627\u0641\u0642\u0629 \u0639\u0644\u0649 \u0627\u0644\u0648\u0635\u0648\u0644",
      done: "\u062A\u0645\u062A \u0627\u0644\u0645\u0648\u0627\u0641\u0642\u0629 \u0639\u0644\u0649 \u0627\u0644\u0648\u0635\u0648\u0644. \u0633\u064A\u0646\u062A\u0647\u064A \u062A\u0644\u0642\u0627\u0626\u064A\u064B\u0627."
    },
    reject: {
      title: "\u0631\u0641\u0636 \u0627\u0644\u0637\u0644\u0628 \u0627\u0644\u062E\u0627\u0635 \u0628\u0640 {name}",
      reason: "\u0633\u0628\u0628 \u0627\u0644\u0631\u0641\u0636",
      reasonHint: "{min} \u0623\u062D\u0631\u0641 \u0639\u0644\u0649 \u0627\u0644\u0623\u0642\u0644. \u064A\u064F\u062D\u0641\u0638 \u0647\u0630\u0627 \u0627\u0644\u0633\u0628\u0628 \u0641\u064A \u0627\u0644\u0633\u062C\u0644.",
      reasonTooShort: "\u064A\u062C\u0628 \u0623\u0644\u0627 \u064A\u0642\u0644 \u0627\u0644\u0633\u0628\u0628 \u0639\u0646 {min} \u0623\u062D\u0631\u0641.",
      submit: "\u0631\u0641\u0636 \u0627\u0644\u0637\u0644\u0628",
      done: "\u0631\u064F\u0641\u0636 \u0627\u0644\u0637\u0644\u0628."
    },
    cancel: {
      title: "\u0625\u0644\u063A\u0627\u0621 \u0637\u0644\u0628\u0643 \u0627\u0644\u062E\u0627\u0635 \u0628\u0640 {name}\u061F",
      body: "\u0633\u064A\u064F\u0633\u062D\u0628 \u0627\u0644\u0637\u0644\u0628: \u0644\u0646 \u064A\u062A\u0645\u0643\u0646 \u0623\u062D\u062F \u0645\u0646 \u0627\u0644\u0645\u0648\u0627\u0641\u0642\u0629 \u0639\u0644\u064A\u0647.",
      confirm: "\u0625\u0644\u063A\u0627\u0621 \u0627\u0644\u0637\u0644\u0628",
      keep: "\u0627\u0644\u0625\u0628\u0642\u0627\u0621 \u0639\u0644\u0649 \u0627\u0644\u0637\u0644\u0628",
      done: "\u0623\u064F\u0644\u063A\u064A \u0627\u0644\u0637\u0644\u0628."
    },
    revoke: {
      title: "\u0633\u062D\u0628 \u0627\u0644\u0648\u0635\u0648\u0644 \u0625\u0644\u0649 {name}\u061F",
      body: "\u0633\u064A\u0646\u062A\u0647\u064A \u0648\u0635\u0648\u0644 \u0627\u0644\u062F\u0639\u0645 \u0641\u0648\u0631\u064B\u0627. \u0648\u0644\u0644\u0639\u0648\u062F\u0629 \u0625\u0644\u064A\u0647 \u0633\u062A\u062D\u062A\u0627\u062C \u0625\u0644\u0649 \u0637\u0644\u0628 \u062C\u062F\u064A\u062F \u062A\u062A\u0645 \u0627\u0644\u0645\u0648\u0627\u0641\u0642\u0629 \u0639\u0644\u064A\u0647.",
      confirm: "\u0633\u062D\u0628 \u0627\u0644\u0648\u0635\u0648\u0644",
      keep: "\u0627\u0644\u0625\u0628\u0642\u0627\u0621 \u0639\u0644\u0649 \u0627\u0644\u0648\u0635\u0648\u0644",
      done: "\u0633\u064F\u062D\u0628 \u0627\u0644\u0648\u0635\u0648\u0644."
    }
  },
  jobs: {
    title: "\u0627\u0644\u0645\u0647\u0627\u0645 \u0627\u0644\u0641\u0627\u0634\u0644\u0629",
    tableCaption: "\u0645\u0647\u0627\u0645 \u0627\u0644\u062E\u0644\u0641\u064A\u0629 \u0627\u0644\u062A\u064A \u0641\u0634\u0644\u062A \u0641\u064A \u0643\u0644 \u0645\u062D\u0627\u0648\u0644\u0627\u062A\u0647\u0627",
    loadFailedTitle: "\u062A\u0639\u0630\u0651\u0631 \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0645\u0647\u0627\u0645 \u0627\u0644\u0641\u0627\u0634\u0644\u0629",
    loadFailedBody: "\u062A\u0639\u0630\u0651\u0631 \u062C\u0644\u0628 \u0627\u0644\u0642\u0627\u0626\u0645\u0629. \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629 \u0628\u0639\u062F \u0642\u0644\u064A\u0644.",
    columns: {
      failedAt: "\u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0641\u0634\u0644",
      queue: "\u0627\u0644\u0637\u0627\u0628\u0648\u0631",
      eventType: "\u0646\u0648\u0639 \u0627\u0644\u062D\u062F\u062B",
      tenantId: "\u0627\u0644\u0645\u0624\u0633\u0633\u0629",
      attempts: "\u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0627\u062A",
      error: "\u0627\u0644\u062E\u0637\u0623",
      actions: "\u0627\u0644\u0625\u062C\u0631\u0627\u0621\u0627\u062A"
    },
    empty: {
      title: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0645\u0647\u0627\u0645 \u0641\u0627\u0634\u0644\u0629",
      description: "\u0627\u0646\u062A\u0647\u062A \u062C\u0645\u064A\u0639 \u0645\u0647\u0627\u0645 \u0627\u0644\u062E\u0644\u0641\u064A\u0629 \u0628\u0634\u0643\u0644 \u0637\u0628\u064A\u0639\u064A."
    },
    retry: "\u0625\u0639\u0627\u062F\u0629 \u0627\u0644\u062A\u0634\u063A\u064A\u0644",
    retryFor: "\u0625\u0639\u0627\u062F\u0629 \u062A\u0634\u063A\u064A\u0644 \u0645\u0647\u0645\u0629 {event} \u0641\u064A \u0637\u0627\u0628\u0648\u0631 {queue}",
    retryTitle: "\u0625\u0639\u0627\u062F\u0629 \u062A\u0634\u063A\u064A\u0644 \u0647\u0630\u0647 \u0627\u0644\u0645\u0647\u0645\u0629\u061F",
    retryBody: "\u0633\u062A\u064F\u0639\u0627\u062F \u0627\u0644\u0645\u0647\u0645\u0629 \xAB{event}\xBB \u0625\u0644\u0649 \u0637\u0627\u0628\u0648\u0631\u0647\u0627 \u0648\u062A\u064F\u0646\u0641\u064E\u0651\u0630 \u0645\u0646 \u062C\u062F\u064A\u062F.",
    retried: "\u0623\u064F\u0639\u064A\u062F \u062A\u0634\u063A\u064A\u0644 \u0627\u0644\u0645\u0647\u0645\u0629.",
    discard: "\u062D\u0630\u0641",
    discardFor: "\u062D\u0630\u0641 \u0645\u0647\u0645\u0629 {event} \u0645\u0646 \u0637\u0627\u0628\u0648\u0631 {queue}",
    discardTitle: "\u062D\u0630\u0641 \u0647\u0630\u0647 \u0627\u0644\u0645\u0647\u0645\u0629\u061F",
    discardBody: "\u0633\u062A\u064F\u0646\u0633\u0649 \u0627\u0644\u0645\u0647\u0645\u0629 \xAB{event}\xBB \u0646\u0647\u0627\u0626\u064A\u064B\u0627: \u0644\u0646 \u062A\u064F\u0646\u0641\u064E\u0651\u0630 \u0623\u0628\u062F\u064B\u0627.",
    discarded: "\u062D\u064F\u0630\u0641\u062A \u0627\u0644\u0645\u0647\u0645\u0629."
  },
  security: {
    title: "\u0627\u0644\u0623\u0645\u0627\u0646",
    window: "\u0627\u0644\u0641\u062A\u0631\u0629 \u0627\u0644\u0645\u0639\u0631\u0648\u0636\u0629",
    windowOption: "{days, plural, one {\u0622\u062E\u0631 \u064A\u0648\u0645} two {\u0622\u062E\u0631 \u064A\u0648\u0645\u064A\u0646} few {\u0622\u062E\u0631 # \u0623\u064A\u0627\u0645} many {\u0622\u062E\u0631 # \u064A\u0648\u0645\u064B\u0627} other {\u0622\u062E\u0631 # \u064A\u0648\u0645}}",
    period: "\u0645\u0646",
    loadFailedTitle: "\u062A\u0639\u0630\u0651\u0631 \u062A\u062D\u0645\u064A\u0644 \u0645\u0624\u0634\u0631\u0627\u062A \u0627\u0644\u0623\u0645\u0627\u0646",
    loadFailedBody: "\u062A\u0639\u0630\u0651\u0631 \u062C\u0644\u0628 \u0627\u0644\u0623\u0631\u0642\u0627\u0645. \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629 \u0628\u0639\u062F \u0642\u0644\u064A\u0644.",
    actions: {
      auth_login_failed: "\u0625\u062E\u0641\u0627\u0642\u0627\u062A \u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062F\u062E\u0648\u0644",
      auth_step_up_failed: "\u0625\u062E\u0641\u0627\u0642\u0627\u062A \u062A\u0623\u0643\u064A\u062F \u0627\u0644\u0647\u0648\u064A\u0629",
      auth_session_flagged: "\u0627\u0644\u062C\u0644\u0633\u0627\u062A \u0627\u0644\u0645\u064F\u0628\u0644\u064E\u0651\u063A \u0639\u0646\u0647\u0627",
      auth_session_revoked: "\u0627\u0644\u062C\u0644\u0633\u0627\u062A \u0627\u0644\u0645\u0633\u062D\u0648\u0628\u0629"
    },
    realms: {
      batiflow: "\u0627\u0644\u0639\u0645\u0644\u0627\u0621",
      "batiflow-platform": "\u0627\u0644\u0645\u0646\u0635\u0629"
    },
    empty: {
      title: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0625\u062E\u0641\u0627\u0642\u0627\u062A",
      description: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0625\u062E\u0641\u0627\u0642\u0627\u062A \u0623\u0645\u0646\u064A\u0629 \u0641\u064A \u0627\u0644\u0641\u062A\u0631\u0629 \u0627\u0644\u0645\u062D\u062F\u062F\u0629."
    },
    failures: {
      title: "\u0627\u0644\u0625\u062E\u0641\u0627\u0642\u0627\u062A \u062D\u0633\u0628 \u0627\u0644\u0646\u0648\u0639",
      description: "\u0639\u0645\u0644\u064A\u0627\u062A \u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062F\u062E\u0648\u0644 \u0648\u062A\u0623\u0643\u064A\u062F \u0627\u0644\u0647\u0648\u064A\u0629 \u0627\u0644\u0645\u0631\u0641\u0648\u0636\u0629 \u062E\u0644\u0627\u0644 \u0627\u0644\u0641\u062A\u0631\u0629.",
      caption: "\u0627\u0644\u0625\u062E\u0641\u0627\u0642\u0627\u062A \u0627\u0644\u0623\u0645\u0646\u064A\u0629 \u062D\u0633\u0628 \u0627\u0644\u0646\u0648\u0639",
      action: "\u0627\u0644\u0646\u0648\u0639",
      realm: "\u0627\u0644\u0645\u062C\u0627\u0644",
      count: "\u0627\u0644\u0625\u062E\u0641\u0627\u0642\u0627\u062A"
    },
    perDay: {
      title: "\u0627\u0644\u0625\u062E\u0641\u0627\u0642\u0627\u062A \u062D\u0633\u0628 \u0627\u0644\u064A\u0648\u0645",
      description: "\u0639\u062F\u062F \u0627\u0644\u0625\u062E\u0641\u0627\u0642\u0627\u062A \u0641\u064A \u0643\u0644 \u064A\u0648\u0645 \u0645\u0646 \u0623\u064A\u0627\u0645 \u0627\u0644\u0641\u062A\u0631\u0629.",
      empty: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0628\u064A\u0627\u0646\u0627\u062A \u0644\u0644\u0641\u062A\u0631\u0629.",
      showTable: "\u0627\u0644\u0639\u0631\u0636 \u0641\u064A \u062C\u062F\u0648\u0644",
      chartLabel: "\u0627\u0644\u0625\u062E\u0641\u0627\u0642\u0627\u062A \u0627\u0644\u064A\u0648\u0645\u064A\u0629 \u062E\u0644\u0627\u0644 \u0627\u0644\u0641\u062A\u0631\u0629 \u0627\u0644\u0645\u062D\u062F\u062F\u0629\u060C \u0648\u0623\u0639\u0644\u0627\u0647\u0627 {max} \u0641\u064A \u064A\u0648\u0645 \u0648\u0627\u062D\u062F.",
      peak: "\u0627\u0644\u0623\u0639\u0644\u0649: {max}",
      caption: "\u0627\u0644\u0625\u062E\u0641\u0627\u0642\u0627\u062A \u062D\u0633\u0628 \u0627\u0644\u064A\u0648\u0645",
      day: "\u0627\u0644\u064A\u0648\u0645",
      failures: "\u0627\u0644\u0625\u062E\u0641\u0627\u0642\u0627\u062A"
    },
    subjects: {
      title: "\u0623\u0643\u062B\u0631 \u0627\u0644\u062D\u0633\u0627\u0628\u0627\u062A \u062A\u0623\u062B\u0631\u064B\u0627",
      description: "\u0645\u0639\u0631\u0651\u0641\u0627\u062A \u0627\u0644\u062D\u0633\u0627\u0628\u0627\u062A \u0627\u0644\u0623\u0643\u062B\u0631 \u0625\u062E\u0641\u0627\u0642\u064B\u0627 (\u062F\u0648\u0646 \u0623\u064A \u0628\u064A\u0627\u0646\u0627\u062A \u0634\u062E\u0635\u064A\u0629).",
      caption: "\u0627\u0644\u062D\u0633\u0627\u0628\u0627\u062A \u0627\u0644\u0623\u0643\u062B\u0631 \u0625\u062E\u0641\u0627\u0642\u064B\u0627",
      empty: "\u0644\u0627 \u064A\u0648\u062C\u062F \u062D\u0633\u0627\u0628 \u064A\u0633\u062A\u0648\u062C\u0628 \u0627\u0644\u062A\u0646\u0628\u064A\u0647.",
      subject: "\u0645\u0639\u0631\u0651\u0641 \u0627\u0644\u062D\u0633\u0627\u0628",
      failures: "\u0627\u0644\u0625\u062E\u0641\u0627\u0642\u0627\u062A"
    }
  },
  audit: {
    title: "\u0633\u062C\u0644 \u0627\u0644\u0645\u0646\u0635\u0629",
    tableCaption: "\u0625\u062C\u0631\u0627\u0621\u0627\u062A \u0645\u0633\u0624\u0648\u0644\u064A \u0627\u0644\u0645\u0646\u0635\u0629",
    loadFailedTitle: "\u062A\u0639\u0630\u0651\u0631 \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0633\u062C\u0644",
    loadFailedBody: "\u062A\u0639\u0630\u0651\u0631 \u062C\u0644\u0628 \u0627\u0644\u0633\u062C\u0644. \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629 \u0628\u0639\u062F \u0642\u0644\u064A\u0644.",
    columns: {
      when: "\u0627\u0644\u062A\u0627\u0631\u064A\u062E \u0648\u0627\u0644\u0648\u0642\u062A",
      admin: "\u0627\u0644\u0645\u0633\u0624\u0648\u0644",
      action: "\u0627\u0644\u0625\u062C\u0631\u0627\u0621",
      organization: "\u0627\u0644\u0645\u0624\u0633\u0633\u0629",
      reason: "\u0627\u0644\u0633\u0628\u0628"
    },
    empty: {
      title: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0625\u062C\u0631\u0627\u0621\u0627\u062A \u0645\u0633\u062C\u064E\u0651\u0644\u0629",
      description: "\u0633\u062A\u0638\u0647\u0631 \u0625\u062C\u0631\u0627\u0621\u0627\u062A \u0627\u0644\u0645\u0633\u0624\u0648\u0644\u064A\u0646 \u0647\u0646\u0627."
    },
    actions: {
      signed_in: "\u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062F\u062E\u0648\u0644 \u0625\u0644\u0649 \u0627\u0644\u0625\u062F\u0627\u0631\u0629 \u0627\u0644\u0645\u0631\u0643\u0632\u064A\u0629",
      organization_viewed: "\u0627\u0644\u0627\u0637\u0644\u0627\u0639 \u0639\u0644\u0649 \u0645\u0624\u0633\u0633\u0629",
      subscription_overridden: "\u062A\u063A\u064A\u064A\u0631 \u062D\u0627\u0644\u0629 \u0627\u0644\u0627\u0634\u062A\u0631\u0627\u0643",
      payment_confirmed: "\u062A\u0623\u0643\u064A\u062F \u062F\u0641\u0639\u0629",
      job_retried: "\u0625\u0639\u0627\u062F\u0629 \u062A\u0634\u063A\u064A\u0644 \u0645\u0647\u0645\u0629",
      job_discarded: "\u062D\u0630\u0641 \u0645\u0647\u0645\u0629",
      break_glass_requested: "\u0637\u0644\u0628 \u0648\u0635\u0648\u0644 \u0627\u0644\u062F\u0639\u0645",
      break_glass_approved: "\u0627\u0644\u0645\u0648\u0627\u0641\u0642\u0629 \u0639\u0644\u0649 \u0648\u0635\u0648\u0644 \u0627\u0644\u062F\u0639\u0645",
      break_glass_rejected: "\u0631\u0641\u0636 \u0648\u0635\u0648\u0644 \u0627\u0644\u062F\u0639\u0645",
      break_glass_cancelled: "\u0625\u0644\u063A\u0627\u0621 \u0637\u0644\u0628 \u0648\u0635\u0648\u0644 \u0627\u0644\u062F\u0639\u0645",
      break_glass_revoked: "\u0633\u062D\u0628 \u0648\u0635\u0648\u0644 \u0627\u0644\u062F\u0639\u0645",
      unknown: "\u0625\u062C\u0631\u0627\u0621 \u0622\u062E\u0631"
    }
  },
  plans: {
    title: "\u0627\u0644\u0628\u0627\u0642\u0627\u062A",
    readOnlyNote: "\u0647\u0630\u0627 \u0627\u0644\u062F\u0644\u064A\u0644 \u0644\u0644\u0642\u0631\u0627\u0621\u0629 \u0641\u0642\u0637. \u062A\u064F\u0639\u062F\u064E\u0651\u0644 \u0623\u0633\u0639\u0627\u0631 \u0627\u0644\u0628\u0627\u0642\u0627\u062A \u0648\u062D\u062F\u0648\u062F\u0647\u0627 \u0639\u0628\u0631 \u0645\u0644\u0641\u0627\u062A \u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A (seeds) \u0648\u0644\u064A\u0633 \u0645\u0646 \u0627\u0644\u0625\u062F\u0627\u0631\u0629 \u0627\u0644\u0645\u0631\u0643\u0632\u064A\u0629.",
    compare: "\u0645\u0642\u0627\u0631\u0646\u0629 \u0627\u0644\u0628\u0627\u0642\u0627\u062A",
    taxNote: "\u0627\u0644\u0623\u0633\u0639\u0627\u0631 \u062F\u0648\u0646 \u0627\u062D\u062A\u0633\u0627\u0628 \u0627\u0644\u0636\u0631\u064A\u0628\u0629. \u0627\u0644\u0645\u0628\u0627\u0644\u063A \u0628\u0627\u0644\u062F\u064A\u0646\u0627\u0631 \u0627\u0644\u062A\u0648\u0646\u0633\u064A (TND).",
    caption: "\u062F\u0644\u064A\u0644 \u0628\u0627\u0642\u0627\u062A BatiFlow",
    loadFailedTitle: "\u062A\u0639\u0630\u0651\u0631 \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0628\u0627\u0642\u0627\u062A",
    loadFailedBody: "\u062A\u0639\u0630\u0651\u0631 \u062C\u0644\u0628 \u0627\u0644\u062F\u0644\u064A\u0644. \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629 \u0628\u0639\u062F \u0642\u0644\u064A\u0644.",
    names: {
      solo: "Solo",
      starter: "Starter",
      pro: "Pro",
      business: "Business",
      enterprise: "Enterprise"
    },
    monthly: "\u0627\u0644\u0633\u0639\u0631 \u0627\u0644\u0634\u0647\u0631\u064A (\u062F\u0648\u0646 \u0636\u0631\u064A\u0628\u0629)",
    annual: "\u0627\u0644\u0633\u0639\u0631 \u0627\u0644\u0633\u0646\u0648\u064A (\u062F\u0648\u0646 \u0636\u0631\u064A\u0628\u0629)",
    extraSeat: "\u0645\u0642\u0639\u062F \u0625\u0636\u0627\u0641\u064A (\u0634\u0647\u0631\u064A\u064B\u0627)",
    seats: "\u0627\u0644\u0645\u0642\u0627\u0639\u062F \u0627\u0644\u0645\u0634\u0645\u0648\u0644\u0629",
    storage: "\u0627\u0644\u062A\u062E\u0632\u064A\u0646 \u0627\u0644\u0645\u0634\u0645\u0648\u0644",
    hostedSpaces: "\u0627\u0644\u0645\u0633\u0627\u062D\u0627\u062A \u0627\u0644\u0645\u0634\u062A\u0631\u0643\u0629 \u0627\u0644\u0645\u0633\u062A\u0636\u0627\u0641\u0629",
    meetingParticipants: "\u0627\u0644\u0645\u0634\u0627\u0631\u0643\u0648\u0646 \u0641\u064A \u0643\u0644 \u0627\u062C\u062A\u0645\u0627\u0639",
    unlimited: "\u063A\u064A\u0631 \u0645\u062D\u062F\u0648\u062F",
    byContract: "\u062D\u0633\u0628 \u0627\u0644\u0639\u0642\u062F",
    onQuote: "\u062D\u0633\u0628 \u0639\u0631\u0636 \u0627\u0644\u0633\u0639\u0631",
    notOffered: "\u063A\u064A\u0631 \u0645\u062A\u0627\u062D"
  },
  reasonDialog: {
    reason: "\u0627\u0644\u0633\u0628\u0628",
    reasonHint: "{min} \u0623\u062D\u0631\u0641 \u0639\u0644\u0649 \u0627\u0644\u0623\u0642\u0644. \u064A\u064F\u062D\u0641\u0638 \u0627\u0644\u0633\u0628\u0628 \u0641\u064A \u0633\u062C\u0644 \u0627\u0644\u0645\u0646\u0635\u0629.",
    reasonTooShort: "\u0627\u0634\u0631\u062D \u0627\u0644\u0633\u0628\u0628 \u0641\u064A {min} \u0623\u062D\u0631\u0641 \u0639\u0644\u0649 \u0627\u0644\u0623\u0642\u0644.",
    ticket: "\u0645\u0631\u062C\u0639 \u062A\u0630\u0643\u0631\u0629 \u0627\u0644\u062F\u0639\u0645",
    ticketHint: "\u0627\u0644\u062A\u0630\u0643\u0631\u0629 \u0627\u0644\u062A\u064A \u062A\u0628\u0631\u0631 \u0647\u0630\u0627 \u0627\u0644\u0625\u062C\u0631\u0627\u0621 (\u0645\u062B\u0644\u0627\u064B SUP-2026-1042).",
    ticketRequired: "\u0623\u062F\u062E\u0644 \u0645\u0631\u062C\u0639 \u0627\u0644\u062A\u0630\u0643\u0631\u0629.",
    confirmationMismatch: "\u0627\u0644\u0646\u0635 \u0627\u0644\u0645\u064F\u062F\u062E\u0644 \u063A\u064A\u0631 \u0645\u0637\u0627\u0628\u0642. \u0627\u0646\u0633\u062E\u0647 \u0643\u0645\u0627 \u0647\u0648."
  },
  members: {
    title: "\u0627\u0644\u0623\u0639\u0636\u0627\u0621",
    description: "\u0623\u0634\u062E\u0627\u0635 \u0627\u0644\u0645\u0624\u0633\u0633\u0629 (\u0627\u0644\u0647\u0648\u064A\u0629 \u0648\u0627\u0644\u062F\u0648\u0631 \u0648\u0627\u0644\u062D\u0627\u0644\u0629\u061B \u062F\u0648\u0646 \u0623\u064A \u0645\u062D\u062A\u0648\u0649). \u064A\u062A\u0637\u0644\u0628 \u0643\u0644 \u0625\u062C\u0631\u0627\u0621 \u0633\u0628\u0628\u064B\u0627 \u0648\u062A\u0623\u0643\u064A\u062F \u0647\u0648\u064A\u062A\u0643\u060C \u0648\u064A\u0638\u0647\u0631 \u0623\u064A\u0636\u064B\u0627 \u0641\u064A \u0633\u062C\u0644 \u062A\u062F\u0642\u064A\u0642 \u0627\u0644\u0645\u0624\u0633\u0633\u0629.",
    filter: "\u062A\u0635\u0641\u064A\u0629 \u0627\u0644\u0623\u0639\u0636\u0627\u0621 \u062D\u0633\u0628 \u0627\u0644\u062D\u0627\u0644\u0629",
    allStatuses: "\u0643\u0644 \u0627\u0644\u062D\u0627\u0644\u0627\u062A",
    caption: "\u0623\u0639\u0636\u0627\u0621 \u0627\u0644\u0645\u0624\u0633\u0633\u0629",
    emptyTitle: "\u0644\u0627 \u064A\u0648\u062C\u062F \u0623\u0639\u0636\u0627\u0621",
    emptyDescription: "\u0644\u0627 \u064A\u0648\u062C\u062F \u0639\u0636\u0648 \u064A\u0637\u0627\u0628\u0642 \u0647\u0630\u0627 \u0627\u0644\u062A\u0635\u0641\u064A\u0629.",
    loadFailedTitle: "\u062A\u0639\u0630\u0651\u0631 \u0639\u0631\u0636 \u0627\u0644\u0623\u0639\u0636\u0627\u0621",
    loadFailedBody: "\u062A\u0639\u0630\u0651\u0631 \u062A\u062D\u0645\u064A\u0644 \u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u0623\u0639\u0636\u0627\u0621. \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629.",
    actionsFor: "\u0625\u062C\u0631\u0627\u0621\u0627\u062A \u0644\u0640 {name}",
    columns: {
      person: "\u0627\u0644\u0634\u062E\u0635",
      role: "\u0627\u0644\u062F\u0648\u0631",
      status: "\u0627\u0644\u062D\u0627\u0644\u0629",
      joined: "\u0627\u0644\u0627\u0646\u0636\u0645\u0627\u0645",
      actions: "\u0627\u0644\u0625\u062C\u0631\u0627\u0621\u0627\u062A"
    },
    status: {
      active: "\u0646\u0634\u0637",
      suspended: "\u0645\u0639\u0644\u0651\u0642",
      invited: "\u0645\u062F\u0639\u0648",
      deactivated: "\u0623\u064F\u0632\u064A\u0644"
    },
    actions: {
      suspend: "\u062A\u0639\u0644\u064A\u0642",
      reactivate: "\u0625\u0639\u0627\u062F\u0629 \u0627\u0644\u062A\u0641\u0639\u064A\u0644",
      remove: "\u0625\u0632\u0627\u0644\u0629 \u0645\u0646 \u0627\u0644\u0645\u0624\u0633\u0633\u0629"
    },
    suspend: {
      title: "\u062A\u0639\u0644\u064A\u0642 {name}\u061F",
      body: "\u064A\u0641\u0642\u062F \u0627\u0644\u0634\u062E\u0635 \u0641\u0648\u0631\u064B\u0627 \u0627\u0644\u0648\u0635\u0648\u0644 \u0625\u0644\u0649 \u0647\u0630\u0647 \u0627\u0644\u0645\u0624\u0633\u0633\u0629 \u0648\u0625\u0644\u0649 \u0641\u0636\u0627\u0621\u0627\u062A\u0647\u0627 \u0627\u0644\u0645\u0634\u062A\u0631\u0643\u0629. \u0644\u0627 \u064A\u064F\u062D\u0630\u0641 \u0634\u064A\u0621: \u064A\u0645\u0643\u0646\u0643 \u0625\u0639\u0627\u062F\u0629 \u062A\u0641\u0639\u064A\u0644\u0647.",
      confirm: "\u062A\u0639\u0644\u064A\u0642",
      done: "\u062A\u0645 \u062A\u0639\u0644\u064A\u0642 {name}."
    },
    reactivate: {
      title: "\u0625\u0639\u0627\u062F\u0629 \u062A\u0641\u0639\u064A\u0644 {name}\u061F",
      body: "\u064A\u0633\u062A\u0639\u064A\u062F \u0627\u0644\u0634\u062E\u0635 \u0641\u0648\u0631\u064B\u0627 \u0648\u0635\u0648\u0644\u0647 \u0648\u0635\u0644\u0627\u062D\u064A\u0627\u062A\u0647 \u0641\u064A \u0647\u0630\u0647 \u0627\u0644\u0645\u0624\u0633\u0633\u0629.",
      confirm: "\u0625\u0639\u0627\u062F\u0629 \u0627\u0644\u062A\u0641\u0639\u064A\u0644",
      done: "\u062A\u0645\u062A \u0625\u0639\u0627\u062F\u0629 \u062A\u0641\u0639\u064A\u0644 {name}."
    },
    remove: {
      title: "\u0625\u0632\u0627\u0644\u0629 {name} \u0645\u0646 \u0627\u0644\u0645\u0624\u0633\u0633\u0629\u061F",
      body: "\u064A\u064F\u0646\u0642\u0644 \u0645\u0627 \u064A\u0645\u0644\u0643\u0647 \u0627\u0644\u0634\u062E\u0635 (\u0645\u0647\u0627\u0645\u060C \u0645\u0633\u062A\u0646\u062F\u0627\u062A\u2026) \u0625\u0644\u0649 \u0645\u0627\u0644\u0643 \u0627\u0644\u0645\u0624\u0633\u0633\u0629 \u0648\u062A\u064F\u0633\u062D\u0628 \u0643\u0644 \u0635\u0644\u0627\u062D\u064A\u0627\u062A\u0647 \u0641\u064A\u0647\u0627. \u064A\u0628\u0642\u0649 \u062D\u0633\u0627\u0628\u0647 \u0646\u0634\u0637\u064B\u0627 \u0641\u064A \u0623\u0645\u0627\u0643\u0646 \u0623\u062E\u0631\u0649. \u0644\u0627 \u064A\u0645\u0643\u0646 \u0625\u0632\u0627\u0644\u0629 \u0627\u0644\u0645\u0627\u0644\u0643 \u0645\u0646 \u0647\u0646\u0627.",
      confirm: "\u0625\u0632\u0627\u0644\u0629",
      done: "\u062A\u0645\u062A \u0625\u0632\u0627\u0644\u0629 {name} \u0645\u0646 \u0627\u0644\u0645\u0624\u0633\u0633\u0629."
    }
  },
  accounts: {
    title: "\u0627\u0644\u062D\u0633\u0627\u0628",
    summary: "\u0627\u0644\u062D\u0633\u0627\u0628",
    email: "\u0627\u0644\u0628\u0631\u064A\u062F \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A",
    status: "\u062D\u0627\u0644\u0629 \u0627\u0644\u062D\u0633\u0627\u0628",
    active: "\u0646\u0634\u0637",
    locked: "\u0645\u0642\u0641\u0644",
    deleted: "\u0645\u062D\u0630\u0648\u0641",
    kind: "\u0627\u0644\u0646\u0648\u0639",
    guest: "\u0636\u064A\u0641 (\u062E\u0627\u0631\u062C\u064A)",
    member: "\u0639\u0636\u0648",
    lastSeen: "\u0622\u062E\u0631 \u0646\u0634\u0627\u0637",
    created: "\u0623\u064F\u0646\u0634\u0626 \u0641\u064A",
    memberships: "\u0627\u0644\u0645\u0624\u0633\u0633\u0627\u062A",
    membershipsHint: "\u0627\u0644\u0645\u0624\u0633\u0633\u0627\u062A \u0627\u0644\u062A\u064A \u064A\u0646\u062A\u0645\u064A \u0625\u0644\u064A\u0647\u0627 \u0647\u0630\u0627 \u0627\u0644\u062D\u0633\u0627\u0628\u060C \u0648\u062D\u0627\u0644\u062A\u0647 \u0641\u064A \u0643\u0644 \u0645\u0646\u0647\u0627.",
    membershipsCaption: "\u0645\u0624\u0633\u0633\u0627\u062A \u0627\u0644\u062D\u0633\u0627\u0628",
    noMemberships: "\u0644\u0627 \u064A\u0646\u062A\u0645\u064A \u0647\u0630\u0627 \u0627\u0644\u062D\u0633\u0627\u0628 \u0625\u0644\u0649 \u0623\u064A \u0645\u0624\u0633\u0633\u0629.",
    lockedTitle: "\u0627\u0644\u062D\u0633\u0627\u0628 \u0645\u0642\u0641\u0644",
    lockedBody: "\u0644\u0645 \u064A\u0639\u062F \u0628\u0625\u0645\u0643\u0627\u0646 \u0627\u0644\u0634\u062E\u0635 \u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062F\u062E\u0648\u0644 \u0625\u0644\u0649 BatiFlow \u0648\u0623\u064F\u063A\u0644\u0642\u062A \u0643\u0644 \u062C\u0644\u0633\u0627\u062A\u0647.",
    notFoundTitle: "\u0627\u0644\u062D\u0633\u0627\u0628 \u063A\u064A\u0631 \u0645\u0648\u062C\u0648\u062F",
    notFoundBody: "\u0647\u0630\u0627 \u0627\u0644\u062D\u0633\u0627\u0628 \u063A\u064A\u0631 \u0645\u0648\u062C\u0648\u062F \u0623\u0648 \u062A\u0645 \u062D\u0630\u0641\u0647.",
    loadFailedTitle: "\u062A\u0639\u0630\u0651\u0631 \u0639\u0631\u0636 \u0627\u0644\u062D\u0633\u0627\u0628",
    loadFailedBody: "\u062A\u0639\u0630\u0651\u0631 \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u062D\u0633\u0627\u0628. \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629.",
    columns: {
      organization: "\u0627\u0644\u0645\u0624\u0633\u0633\u0629",
      organizationStatus: "\u062D\u0627\u0644\u0629 \u0627\u0644\u0645\u0624\u0633\u0633\u0629"
    },
    lock: {
      action: "\u0642\u0641\u0644 \u0627\u0644\u062D\u0633\u0627\u0628",
      title: "\u0642\u0641\u0644 \u062D\u0633\u0627\u0628 {name}\u061F",
      body: "\u0644\u0646 \u064A\u062A\u0645\u0643\u0646 \u0627\u0644\u0634\u062E\u0635 \u0645\u0646 \u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062F\u062E\u0648\u0644 \u0641\u064A \u0623\u064A \u0645\u0624\u0633\u0633\u0629\u060C \u0648\u062A\u064F\u063A\u0644\u0642 \u0643\u0644 \u062C\u0644\u0633\u0627\u062A\u0647 \u0641\u0648\u0631\u064B\u0627. \u0644\u0627 \u064A\u064F\u062D\u0630\u0641 \u0634\u064A\u0621: \u064A\u0645\u0643\u0646\u0643 \u0641\u062A\u062D \u0627\u0644\u062D\u0633\u0627\u0628 \u0644\u0627\u062D\u0642\u064B\u0627.",
      confirm: "\u0642\u0641\u0644",
      done: "\u062A\u0645 \u0642\u0641\u0644 \u0627\u0644\u062D\u0633\u0627\u0628."
    },
    unlock: {
      action: "\u0641\u062A\u062D \u0627\u0644\u062D\u0633\u0627\u0628",
      title: "\u0641\u062A\u062D \u062D\u0633\u0627\u0628 {name}\u061F",
      body: "\u0633\u064A\u062A\u0645\u0643\u0646 \u0627\u0644\u0634\u062E\u0635 \u0645\u0646 \u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062F\u062E\u0648\u0644 \u0645\u062C\u062F\u062F\u064B\u0627\u060C \u0628\u0627\u0644\u0635\u0644\u0627\u062D\u064A\u0627\u062A \u0627\u0644\u062A\u064A \u0643\u0627\u0646\u062A \u0644\u062F\u064A\u0647.",
      confirm: "\u0641\u062A\u062D",
      done: "\u062A\u0645 \u0641\u062A\u062D \u0627\u0644\u062D\u0633\u0627\u0628."
    },
    delete: {
      title: "\u062D\u0630\u0641 \u0627\u0644\u062D\u0633\u0627\u0628",
      description: "\u0646\u0647\u0627\u0626\u064A: \u064A\u063A\u0627\u062F\u0631 \u0627\u0644\u0634\u062E\u0635 \u0643\u0644 \u0645\u0624\u0633\u0633\u0627\u062A\u0647 \u0648\u0641\u0636\u0627\u0621\u0627\u062A\u0647 \u0627\u0644\u0645\u0634\u062A\u0631\u0643\u0629\u060C \u0648\u062A\u064F\u0645\u062D\u0649 \u0628\u064A\u0627\u0646\u0627\u062A\u0647 \u0627\u0644\u0634\u062E\u0635\u064A\u0629 \u0648\u064A\u064F\u062D\u0630\u0641 \u062D\u0633\u0627\u0628 \u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062F\u062E\u0648\u0644.",
      action: "\u062D\u0630\u0641 \u0627\u0644\u062D\u0633\u0627\u0628",
      dialogTitle: "\u062D\u0630\u0641 \u062D\u0633\u0627\u0628 {name} \u0646\u0647\u0627\u0626\u064A\u064B\u0627\u061F",
      body: "\u064A\u064F\u0646\u0642\u0644 \u0645\u0627 \u064A\u0645\u0644\u0643\u0647 \u0627\u0644\u0634\u062E\u0635 \u0625\u0644\u0649 \u0645\u0627\u0644\u0643 \u0643\u0644 \u0645\u0624\u0633\u0633\u0629. \u064A\u0628\u0642\u0649 \u0627\u0644\u0645\u062D\u062A\u0648\u0649 \u0627\u0644\u0630\u064A \u0623\u0646\u0634\u0623\u0647 \u0641\u064A \u0627\u0644\u0645\u0624\u0633\u0633\u0627\u062A \u0628\u0627\u0633\u0645 \xAB\u062D\u0633\u0627\u0628 \u0645\u062D\u0630\u0648\u0641\xBB. \u0644\u0627 \u064A\u0645\u0643\u0646 \u0627\u0644\u062A\u0631\u0627\u062C\u0639 \u0639\u0646 \u0647\u0630\u0627 \u0627\u0644\u0625\u062C\u0631\u0627\u0621.",
      confirm: "\u062D\u0630\u0641 \u0646\u0647\u0627\u0626\u064A",
      confirmLabel: "\u0627\u0644\u0628\u0631\u064A\u062F \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A \u0644\u0644\u062D\u0633\u0627\u0628",
      confirmHint: "\u0627\u0646\u0633\u062E {email} \u0644\u0644\u062A\u0623\u0643\u064A\u062F.",
      done: "\u062A\u0645 \u062D\u0630\u0641 \u0627\u0644\u062D\u0633\u0627\u0628.",
      blocked: {
        owner: "\u0647\u0630\u0627 \u0627\u0644\u062D\u0633\u0627\u0628 \u0645\u0627\u0644\u0643 \u0644\u0645\u0624\u0633\u0633\u0629: \u0627\u0646\u0642\u0644 \u0627\u0644\u0645\u0644\u0643\u064A\u0629 \u0623\u0648\u0644\u0627\u064B \u0623\u0648 \u0627\u062D\u0630\u0641 \u0627\u0644\u0645\u0624\u0633\u0633\u0629.",
        support_identity: "\u064A\u064F\u0633\u062A\u0639\u0645\u0644 \u0647\u0630\u0627 \u0627\u0644\u062D\u0633\u0627\u0628 \u0643\u0647\u0648\u064A\u0629 \u062F\u0639\u0645 \u0644\u0645\u0633\u0624\u0648\u0644 \u0641\u064A \u0627\u0644\u0645\u0646\u0635\u0629: \u0623\u0632\u0644 \u0647\u0630\u0627 \u0627\u0644\u0631\u0628\u0637 \u0623\u0648\u0644\u0627\u064B."
      }
    }
  },
  deletions: {
    title: "\u062D\u0630\u0641 \u0627\u0644\u0645\u0624\u0633\u0633\u0627\u062A",
    intro: "\u062D\u0630\u0641 \u0645\u0624\u0633\u0633\u0629 \u064A\u0645\u062D\u0648 \u0643\u0644 \u0628\u064A\u0627\u0646\u0627\u062A\u0647\u0627. \u064A\u0637\u0644\u0628\u0647 \u0645\u0633\u0624\u0648\u0644 (\u0641\u062A\u064F\u0639\u0644\u0651\u0642 \u0627\u0644\u0645\u0624\u0633\u0633\u0629 \u0641\u0648\u0631\u064B\u0627)\u060C \u0648\u064A\u0648\u0627\u0641\u0642 \u0639\u0644\u064A\u0647 \u0645\u0633\u0624\u0648\u0644 \u0622\u062E\u0631 \u0623\u0648 \u064A\u0631\u0641\u0636\u0647.",
    caption: "\u0637\u0644\u0628\u0627\u062A \u062D\u0630\u0641 \u0627\u0644\u0645\u0624\u0633\u0633\u0627\u062A",
    emptyTitle: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0637\u0644\u0628\u0627\u062A",
    emptyDescription: "\u0644\u0627 \u064A\u0648\u062C\u062F \u0637\u0644\u0628 \u062D\u0630\u0641 \u064A\u0637\u0627\u0628\u0642 \u0647\u0630\u0627 \u0627\u0644\u062A\u0635\u0641\u064A\u0629.",
    loadFailedTitle: "\u062A\u0639\u0630\u0651\u0631 \u0639\u0631\u0636 \u0627\u0644\u0637\u0644\u0628\u0627\u062A",
    loadFailedBody: "\u062A\u0639\u0630\u0651\u0631 \u062A\u062D\u0645\u064A\u0644 \u0637\u0644\u0628\u0627\u062A \u0627\u0644\u062D\u0630\u0641. \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629.",
    withdrawn: "\u0633\u062D\u0628\u0647 \u0635\u0627\u062D\u0628 \u0627\u0644\u0637\u0644\u0628",
    ownRequest: "\u0623\u0646\u062A \u0645\u0646 \u0642\u062F\u0651\u0645 \u0647\u0630\u0627 \u0627\u0644\u0637\u0644\u0628: \u064A\u062C\u0628 \u0623\u0646 \u064A\u0642\u0631\u0631 \u0645\u0633\u0624\u0648\u0644 \u0622\u062E\u0631.",
    filters: {
      label: "\u062A\u0635\u0641\u064A\u0629 \u0627\u0644\u0637\u0644\u0628\u0627\u062A",
      status: "\u0627\u0644\u062A\u0635\u0641\u064A\u0629 \u062D\u0633\u0628 \u0627\u0644\u062D\u0627\u0644\u0629",
      all: "\u0643\u0644 \u0627\u0644\u0637\u0644\u0628\u0627\u062A"
    },
    columns: {
      organization: "\u0627\u0644\u0645\u0624\u0633\u0633\u0629",
      ticket: "\u0627\u0644\u062A\u0630\u0643\u0631\u0629 \u0648\u0627\u0644\u0633\u0628\u0628",
      requested: "\u0642\u062F\u0651\u0645\u0647",
      decided: "\u0627\u0644\u0642\u0631\u0627\u0631",
      status: "\u0627\u0644\u062D\u0627\u0644\u0629",
      actions: "\u0627\u0644\u0625\u062C\u0631\u0627\u0621\u0627\u062A"
    },
    status: {
      pending: "\u0642\u064A\u062F \u0627\u0644\u0627\u0646\u062A\u0638\u0627\u0631",
      approved: "\u0645\u0642\u0628\u0648\u0644",
      rejected: "\u0645\u0631\u0641\u0648\u0636",
      cancelled: "\u0645\u0633\u062D\u0648\u0628"
    },
    execution: {
      scheduled: "\u0627\u0644\u062D\u0630\u0641 \u0641\u064A \u0627\u0646\u062A\u0638\u0627\u0631 \u0627\u0644\u062A\u0646\u0641\u064A\u0630",
      running: "\u0627\u0644\u062D\u0630\u0641 \u062C\u0627\u0631\u064D",
      cancelled: "\u0623\u064F\u0644\u063A\u064A \u0627\u0644\u062D\u0630\u0641",
      done: "\u062D\u064F\u0630\u0641\u062A \u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A"
    },
    actions: {
      approve: "\u0645\u0648\u0627\u0641\u0642\u0629",
      reject: "\u0631\u0641\u0636",
      cancel: "\u0633\u062D\u0628"
    },
    approve: {
      title: "\u062D\u0630\u0641 \xAB{name}\xBB \u0648\u0643\u0644 \u0628\u064A\u0627\u0646\u0627\u062A\u0647\u0627\u061F",
      body: "\u0633\u062A\u064F\u062D\u0630\u0641 \u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A \u0648\u0627\u0644\u0645\u0644\u0641\u0627\u062A \u0648\u0627\u0644\u0635\u0644\u0627\u062D\u064A\u0627\u062A \u0648\u0627\u0644\u062D\u0633\u0627\u0628\u0627\u062A \u0627\u0644\u062A\u064A \u0644\u0627 \u062A\u0646\u062A\u0645\u064A \u0625\u0644\u0627 \u0625\u0644\u0649 \u0647\u0630\u0647 \u0627\u0644\u0645\u0624\u0633\u0633\u0629 \u062E\u0644\u0627\u0644 \u062F\u0642\u0627\u0626\u0642. \u0633\u062A\u064F\u0635\u062F\u0631 \u0634\u0647\u0627\u062F\u0629 \u062D\u0630\u0641. \u0644\u0627 \u064A\u0645\u0643\u0646 \u0627\u0644\u062A\u0631\u0627\u062C\u0639 \u0639\u0646 \u0647\u0630\u0627 \u0627\u0644\u0625\u062C\u0631\u0627\u0621.",
      confirm: "\u0627\u0644\u0645\u0648\u0627\u0641\u0642\u0629 \u0639\u0644\u0649 \u0627\u0644\u062D\u0630\u0641",
      done: "\u062A\u0645\u062A \u0627\u0644\u0645\u0648\u0627\u0641\u0642\u0629 \u0639\u0644\u0649 \u0627\u0644\u062D\u0630\u0641: \u064A\u064F\u0646\u0641\u064E\u0651\u0630 \u0627\u0644\u0622\u0646."
    },
    reject: {
      title: "\u0631\u0641\u0636 \u062D\u0630\u0641 \xAB{name}\xBB\u061F",
      body: "\u062A\u0633\u062A\u0639\u064A\u062F \u0627\u0644\u0645\u0624\u0633\u0633\u0629 \u0627\u0644\u062D\u0627\u0644\u0629 \u0627\u0644\u062A\u064A \u0643\u0627\u0646\u062A \u0639\u0644\u064A\u0647\u0627 \u0642\u0628\u0644 \u0627\u0644\u0637\u0644\u0628.",
      confirm: "\u0631\u0641\u0636",
      done: "\u0631\u064F\u0641\u0636 \u0627\u0644\u0637\u0644\u0628: \u0627\u0633\u062A\u0639\u0627\u062F\u062A \u0627\u0644\u0645\u0624\u0633\u0633\u0629 \u062D\u0627\u0644\u062A\u0647\u0627."
    },
    cancel: {
      title: "\u0633\u062D\u0628 \u0637\u0644\u0628\u0643 \u0628\u062E\u0635\u0648\u0635 \xAB{name}\xBB\u061F",
      body: "\u062A\u0633\u062A\u0639\u064A\u062F \u0627\u0644\u0645\u0624\u0633\u0633\u0629 \u0627\u0644\u062D\u0627\u0644\u0629 \u0627\u0644\u062A\u064A \u0643\u0627\u0646\u062A \u0639\u0644\u064A\u0647\u0627 \u0642\u0628\u0644 \u0627\u0644\u0637\u0644\u0628.",
      confirm: "\u0633\u062D\u0628 \u0627\u0644\u0637\u0644\u0628",
      keep: "\u0627\u0644\u0625\u0628\u0642\u0627\u0621 \u0639\u0644\u0649 \u0627\u0644\u0637\u0644\u0628",
      done: "\u062A\u0645 \u0633\u062D\u0628 \u0627\u0644\u0637\u0644\u0628."
    },
    zone: {
      title: "\u062D\u0630\u0641 \u0627\u0644\u0645\u0624\u0633\u0633\u0629",
      description: "\u0646\u0647\u0627\u0626\u064A\u060C \u0648\u064A\u0642\u0631\u0631\u0647 \u0645\u0633\u0624\u0648\u0644\u0627\u0646 \u0627\u062B\u0646\u0627\u0646.",
      pendingTitle: "\u0637\u064F\u0644\u0628 \u0627\u0644\u062D\u0630\u0641",
      pendingBody: "\u0637\u0644\u0628\u0647 {name} \u0641\u064A",
      openRequests: "\u0639\u0631\u0636 \u0637\u0644\u0628\u0627\u062A \u0627\u0644\u062D\u0630\u0641",
      request: "\u0637\u0644\u0628 \u0627\u0644\u062D\u0630\u0641",
      what: {
        data: "\u062A\u064F\u0645\u062D\u0649 \u0643\u0644 \u0628\u064A\u0627\u0646\u0627\u062A \u0627\u0644\u0645\u0624\u0633\u0633\u0629 \u0648\u0645\u0644\u0641\u0627\u062A\u0647\u0627.",
        accounts: "\u062A\u064F\u062D\u0630\u0641 \u0627\u0644\u062D\u0633\u0627\u0628\u0627\u062A \u0627\u0644\u062A\u064A \u0644\u0627 \u062A\u0646\u062A\u0645\u064A \u0625\u0644\u0627 \u0625\u0644\u064A\u0647\u0627\u061B \u0648\u062A\u0628\u0642\u0649 \u0627\u0644\u0623\u062E\u0631\u0649.",
        suspended: "\u0645\u0646\u0630 \u062A\u0642\u062F\u064A\u0645 \u0627\u0644\u0637\u0644\u0628\u060C \u062A\u064F\u0639\u0644\u0651\u0642 \u0627\u0644\u0645\u0624\u0633\u0633\u0629 (\u0642\u0631\u0627\u0621\u0629 \u0641\u0642\u0637 \u0644\u0623\u0639\u0636\u0627\u0626\u0647\u0627).",
        fourEyes: "\u064A\u062C\u0628 \u0623\u0646 \u064A\u0648\u0627\u0641\u0642 \u0645\u0633\u0624\u0648\u0644 \u0622\u062E\u0631\u061B \u0648\u064A\u0645\u0643\u0646\u0643 \u0633\u062D\u0628 \u0637\u0644\u0628\u0643 \u0625\u0644\u0649 \u0630\u0644\u0643 \u0627\u0644\u062D\u064A\u0646."
      }
    },
    request: {
      title: "\u0637\u0644\u0628 \u062D\u0630\u0641 \xAB{name}\xBB",
      body: "\u0633\u062A\u064F\u0639\u0644\u0651\u0642 \u0627\u0644\u0645\u0624\u0633\u0633\u0629 \u0641\u0648\u0631\u064B\u0627. \u0644\u0646 \u062A\u064F\u062D\u0630\u0641 \u0628\u064A\u0627\u0646\u0627\u062A\u0647\u0627 \u0625\u0644\u0627 \u0628\u0639\u062F \u0645\u0648\u0627\u0641\u0642\u0629 \u0645\u0633\u0624\u0648\u0644 \u0622\u062E\u0631.",
      confirm: "\u0637\u0644\u0628 \u0627\u0644\u062D\u0630\u0641",
      confirmLabel: "\u0627\u0644\u0627\u0633\u0645 \u0627\u0644\u0642\u0627\u0646\u0648\u0646\u064A \u0644\u0644\u0645\u0624\u0633\u0633\u0629",
      confirmHint: "\u0627\u0646\u0633\u062E {name} \u0644\u0644\u062A\u0623\u0643\u064A\u062F.",
      done: "\u0623\u064F\u0631\u0633\u0644 \u0627\u0644\u0637\u0644\u0628: \u064A\u062C\u0628 \u0623\u0646 \u064A\u0648\u0627\u0641\u0642 \u0639\u0644\u064A\u0647 \u0645\u0633\u0624\u0648\u0644 \u0622\u062E\u0631."
    }
  }
};

// locales/en/backoffice.json
var backoffice_default2 = {
  header: {
    tag: "Back-office",
    sessionHint: "Session protected by WebAuthn: every change asks you to confirm your identity.",
    language: "Language",
    accountMenu: "Account menu of {name}",
    signOut: "Sign out"
  },
  nav: {
    organizations: "Organisations",
    "break-glass": "Support",
    jobs: "Failed jobs",
    security: "Security",
    audit: "Audit log",
    plans: "Plans",
    deletions: "Deletions"
  },
  common: {
    none: "\u2014",
    cancel: "Cancel",
    busy: "Working",
    loadMore: "Load more",
    loadingMore: "Loading\u2026",
    duration: {
      minutes: "{minutes} min",
      hours: "{hours} h",
      hoursMinutes: "{hours} h {minutes} min"
    },
    to: "to"
  },
  session: {
    loading: "Loading the back-office\u2026",
    redirecting: "Redirecting to the sign-in page\u2026"
  },
  unavailable: {
    title: "The sign-in service is not available",
    body: "We cannot check your session right now. Try again in a moment; if the problem continues, contact the technical team."
  },
  signedOut: {
    title: "You are signed out",
    body: "Your BatiFlow back-office session is closed on this device. To continue, sign in again with your security key.",
    signIn: "Sign in again",
    reasons: {
      login_failed: {
        title: "Sign-in did not complete",
        body: "The sign-in was interrupted or took too long. Try again; if the problem continues, contact the technical team."
      },
      cancelled: {
        title: "Sign-in cancelled",
        body: "You cancelled the sign-in. You can start again whenever you like."
      },
      not_platform_admin: {
        title: "Account not allowed",
        body: "This account is not a platform administrator. Access to the back-office is reserved for the BatiFlow team. If you think this is a mistake, ask an administrator to check your role."
      },
      webauthn_required: {
        title: "Security key required",
        body: "The back-office requires signing in with a security key or biometrics (WebAuthn). Sign in again and choose that method; a password alone is not enough."
      },
      step_up_failed: {
        title: "Identity not confirmed",
        body: "We could not confirm your identity with your security key. Nothing was changed. Sign in again, then repeat the action."
      }
    }
  },
  stepUp: {
    reason: "This action changes platform data, so it asks you to confirm your identity with your security key (WebAuthn). You will then come back to this page and the action will be carried out."
  },
  pendingAction: {
    replayed: "Done: your action was carried out after you confirmed your identity.",
    failed: "Your identity is confirmed, but the action did not go through. Please do it again."
  },
  signOut: {
    title: "Sign-out incomplete",
    failed: "Sign-out did not complete. Close your browser to end the session safely.",
    close: "Close"
  },
  error: {
    title: "Something went wrong",
    body: "This page could not be displayed. Reload the page; if the problem continues, send the technical details to the technical team.",
    reload: "Reload the page",
    details: "Technical details",
    noTrace: "not available",
    release: "Version: {release}",
    copied: "Details copied to the clipboard.",
    copyFailed: "Copy failed. Select the text above to copy it by hand."
  },
  notFound: {
    title: "This page does not exist",
    body: "The link may be old or mistyped. Go back to the organisation list to continue.",
    home: "Back to organisations"
  },
  status: {
    organization: {
      trial: "Trial",
      active: "Active",
      read_only: "Read-only",
      suspended: "Suspended",
      closed: "Closed",
      deleted: "Deleted"
    },
    subscription: {
      trialing: "Trial period",
      active: "Active",
      past_due: "Payment overdue",
      read_only: "Read-only",
      suspended: "Suspended",
      paused: "Paused",
      cancelled: "Cancelled"
    }
  },
  orgs: {
    title: "Organisations",
    tableCaption: "BatiFlow customer organisations",
    loadFailedTitle: "Could not load the organisations",
    loadFailedBody: "The list could not be retrieved. Try again in a moment.",
    columns: {
      name: "Legal name",
      taxId: "Tax ID",
      status: "Status",
      plan: "Plan",
      subscription: "Subscription",
      members: "Members",
      storage: "Storage",
      dueAt: "Next due date"
    },
    filters: {
      label: "Search and filter organisations",
      search: "Search organisations",
      searchPlaceholder: "Name or tax ID",
      status: "Filter by status",
      allStatuses: "All statuses",
      clear: "Clear filters"
    },
    empty: {
      title: "No organisations",
      description: "Organisations will appear here as soon as a design office creates its account.",
      filteredTitle: "No results",
      filteredDescription: "No organisation matches this search. Check the spelling or clear the filters."
    },
    detail: {
      loading: "Loading the organisation\u2026",
      loadFailedTitle: "Could not load this organisation",
      loadFailedBody: "The information could not be retrieved. Try again in a moment.",
      notFoundTitle: "Organisation not found",
      notFoundDescription: "This organisation does not exist or the link is wrong.",
      backToList: "Back to organisations",
      requestAccess: "Request support access",
      changeStatus: "Change the status",
      summary: "Summary",
      legalName: "Legal name",
      tradeName: "Trade name",
      governorate: "Governorate",
      createdAt: "Created on",
      owners: "Owners",
      subscription: "Subscription",
      noSubscription: "This organisation has no subscription.",
      cycle: "Billing cycle",
      cycles: {
        monthly: "Monthly",
        annual: "Annual"
      },
      extraSeats: "Extra seats",
      period: "Current period",
      trialEndsAt: "Trial ends",
      cancelAt: "Cancels on",
      pausedUntil: "Paused until",
      paymentMethod: "Payment method",
      paymentMethods: {
        card: "Bank card",
        bank_transfer: "Bank transfer",
        cheque: "Cheque",
        online: "Online payment",
        transfer: "Bank transfer"
      },
      usage: "Usage",
      seatsUsed: "Seats used",
      seatsBillable: "Billable seats",
      unlimited: "Unlimited",
      monthMetric: "This month: {metric}",
      metrics: {
        storage_bytes: "recorded storage",
        meeting_participant_minutes: "meeting participant minutes",
        ttn_submissions: "TTN submissions"
      },
      deletion: {
        scheduled: "Deletion scheduled",
        done: "Data deleted",
        cancelled: "Deletion cancelled",
        body: "Reason: {reason}. Scheduled for:",
        running: "Deletion in progress"
      },
      invoices: {
        title: "Subscription invoices",
        description: "The invoices BatiFlow issued to this organisation. Open invoices can be settled by bank transfer or cheque.",
        caption: "Subscription invoices of the organisation",
        number: "Number",
        purpose: "Purpose",
        issueDate: "Issued on",
        dueDate: "Due by",
        total: "Total incl. tax",
        status: "Status",
        actions: "Actions",
        confirmPayment: "Confirm a payment",
        confirmFor: "Confirm the payment of invoice {number}",
        emptyTitle: "No invoices",
        emptyDescription: "No subscription invoice has been issued for this organisation.",
        purposes: {
          start: "Subscription start",
          upgrade: "Plan change",
          restart: "Restart",
          renewal: "Renewal",
          resume: "Resume after pause"
        },
        statuses: {
          open: "To pay",
          paid: "Paid",
          void: "Cancelled"
        }
      },
      dunning: {
        title: "Payment reminders",
        description: "The reminder stages already recorded for this organisation.",
        empty: "No reminders recorded.",
        due: "Due:",
        recorded: "Recorded on",
        stages: {
          reminder: "Due-date reminder (D{day})",
          read_only: "Switched to read-only",
          suspended: "Account suspended",
          deletion_scheduled: "Data deletion scheduled"
        }
      }
    },
    deletions: "Deletions"
  },
  payment: {
    title: "Confirm a payment",
    invoice: "Invoice",
    method: "Payment received by",
    methods: {
      transfer: "Bank transfer",
      cheque: "Cheque"
    },
    receivedOn: "Received on",
    reference: "Reference",
    referenceHint: "The transfer reference or the deposit slip number, to find the payment later.",
    chequeNumber: "Cheque number",
    chequeBank: "Cheque bank",
    submit: "Confirm the payment",
    done: "Payment {number} recorded: {amount}. The invoice is settled.",
    errors: {
      dateRequired: "Enter the date of receipt.",
      dateFuture: "The date of receipt cannot be in the future.",
      referenceRequired: "Enter the payment reference.",
      chequeNumberRequired: "Enter the cheque number.",
      chequeBankRequired: "Enter the cheque bank."
    }
  },
  override: {
    title: "Change the subscription status",
    explanation: "You are changing the subscription status by hand (goodwill gesture, dispute). The organisation's access follows this status. The change is recorded in the platform log with your reason.",
    status: "New status",
    currentMarker: "current",
    effects: {
      trialing: "The organisation goes back to its trial period and gets full access again.",
      active: "The organisation gets full access again.",
      past_due: "The organisation keeps full access; an overdue payment is flagged.",
      read_only: "The organisation can only view its data: nothing can be created or changed.",
      suspended: "The organisation cannot reach its data until the status is restored.",
      paused: "The subscription is marked as paused and the organisation becomes read-only.",
      cancelled: "The subscription is marked as cancelled and the organisation becomes read-only."
    },
    restrictiveWarning: "This status limits the organisation's access: its members will notice right away.",
    reason: "Reason",
    reasonHint: "At least {min} characters. This reason is kept in the log.",
    reasonTooShort: "The reason must be at least {min} characters long.",
    submit: "Apply the status",
    confirmTitle: "Change the access of {name}?",
    confirmBody: {
      suspended: "The organisation will be suspended: its members will no longer reach their data. You can restore the status later.",
      cancelled: "The subscription will be marked as cancelled and the organisation will become read-only. You can restore the status later."
    },
    confirm: "Yes, apply",
    done: "Status applied: {status}.",
    stale: "The subscription was changed in the meantime. The page has just been refreshed: check the status, then try again.",
    noTrial: "This subscription has no trial period: choose another status."
  },
  breakGlass: {
    title: "Support access (break-glass)",
    intro: "Support access is temporary and read-only. One administrator requests it and another approves it.",
    newRequest: "New request",
    tableCaption: "Support access requests",
    loadFailedTitle: "Could not load the requests",
    loadFailedBody: "The list could not be retrieved. Try again in a moment.",
    filters: {
      label: "Filter the requests",
      status: "Filter by state",
      allStatuses: "All states"
    },
    empty: {
      title: "No requests",
      description: "Support access requests will appear here.",
      filteredTitle: "No requests in this state",
      filteredDescription: "Choose another state to see other requests."
    },
    status: {
      pending: "Pending",
      active: "Active",
      rejected: "Rejected",
      cancelled: "Cancelled",
      expired: "Expired",
      revoked: "Revoked"
    },
    bases: {
      owner_consent: "Owner consent",
      legal_requisition: "Legal requisition"
    },
    columns: {
      organization: "Organisation",
      ticket: "Ticket and reason",
      basis: "Basis",
      duration: "Duration",
      requested: "Requested by",
      decided: "Decided by",
      window: "Access window",
      status: "State",
      actions: "Actions"
    },
    remaining: "Time left:",
    actions: {
      approve: "Approve",
      reject: "Reject",
      cancel: "Cancel the request",
      revoke: "Revoke"
    },
    blocked: {
      requester: "Another administrator must decide on this request: you made it.",
      noSupportIdentity: "Your support account is not linked yet: ask an administrator to set it up."
    },
    request: {
      title: "New support access request",
      rulesIntro: "Before you continue:",
      rules: {
        readOnly: "The access is read-only: nothing can be changed.",
        secondAdmin: "A second administrator must approve the request.",
        maxFourHours: "The access lasts 4 hours at most, then ends by itself.",
        audited: "The access is recorded in the organisation's own audit log, which its owners can read."
      },
      organization: "Organisation",
      organizationHint: "Search by name or tax ID (at least 2 characters).",
      organizationSearch: "Search for the organisation",
      organizationResults: "Organisations found",
      noOrganization: "No organisation found.",
      changeOrganization: "Change organisation",
      ticket: "Ticket reference",
      ticketHint: "The support ticket that justifies this access.",
      reason: "Reason",
      reasonHint: "At least {min} characters: explain what you need to check.",
      basis: "Basis of the request",
      basisRef: "Basis reference",
      basisRefHint: {
        owner_consent: "Where the owner's consent is kept (ticket, archived email\u2026).",
        legal_requisition: "Where the requisition is kept (case number, archived document\u2026)."
      },
      duration: "Duration (minutes)",
      durationHint: "Between {min} and {max} minutes.",
      submit: "Send the request",
      done: "Request sent for {name}. Another administrator must approve it.",
      errors: {
        organizationRequired: "Choose the organisation concerned.",
        ticketRequired: "Enter the ticket reference.",
        reasonTooShort: "The reason must be at least {min} characters long.",
        basisRefRequired: "Enter where the basis is kept.",
        durationRange: "The duration must be a whole number of minutes between {min} and {max}."
      }
    },
    approve: {
      title: "Approve access to {name}?",
      body: "You will get read-only access to this organisation right away, through your support account, for the requested duration (4 hours at most). The access will be recorded in the organisation's audit log.",
      confirm: "Approve the access",
      done: "Access approved. It will end automatically."
    },
    reject: {
      title: "Reject the request for {name}",
      reason: "Reason for rejecting",
      reasonHint: "At least {min} characters. This reason is kept in the log.",
      reasonTooShort: "The reason must be at least {min} characters long.",
      submit: "Reject the request",
      done: "Request rejected."
    },
    cancel: {
      title: "Cancel your request for {name}?",
      body: "The request will be withdrawn: nobody will be able to approve it.",
      confirm: "Cancel the request",
      keep: "Keep the request",
      done: "Request cancelled."
    },
    revoke: {
      title: "Revoke access to {name}?",
      body: "The support access will end immediately. Getting back in will need a new approved request.",
      confirm: "Revoke the access",
      keep: "Keep the access",
      done: "Access revoked."
    }
  },
  jobs: {
    title: "Failed jobs",
    tableCaption: "Background jobs that failed all their attempts",
    loadFailedTitle: "Could not load the failed jobs",
    loadFailedBody: "The list could not be retrieved. Try again in a moment.",
    columns: {
      failedAt: "Failed on",
      queue: "Queue",
      eventType: "Event type",
      tenantId: "Organisation",
      attempts: "Attempts",
      error: "Error",
      actions: "Actions"
    },
    empty: {
      title: "No failed jobs",
      description: "All background jobs finished normally."
    },
    retry: "Retry",
    retryFor: "Retry the {event} job of the {queue} queue",
    retryTitle: "Retry this job?",
    retryBody: "The job \u201C{event}\u201D will be put back in its queue and run again.",
    retried: "Job retried.",
    discard: "Discard",
    discardFor: "Discard the {event} job of the {queue} queue",
    discardTitle: "Discard this job?",
    discardBody: "The job \u201C{event}\u201D will be forgotten for good: it will never run.",
    discarded: "Job discarded."
  },
  security: {
    title: "Security",
    window: "Period shown",
    windowOption: "Last {days, plural, one {day} other {# days}}",
    period: "From",
    loadFailedTitle: "Could not load the security signals",
    loadFailedBody: "The figures could not be retrieved. Try again in a moment.",
    actions: {
      auth_login_failed: "Sign-in failures",
      auth_step_up_failed: "Identity confirmation failures",
      auth_session_flagged: "Flagged sessions",
      auth_session_revoked: "Revoked sessions"
    },
    realms: {
      batiflow: "Customers",
      "batiflow-platform": "Platform"
    },
    empty: {
      title: "No failures",
      description: "No security failures in the last {days} days."
    },
    failures: {
      title: "Failures by type",
      description: "Sign-ins and identity confirmations refused during the period.",
      caption: "Security failures by type",
      action: "Type",
      realm: "Area",
      count: "Failures"
    },
    perDay: {
      title: "Failures per day",
      description: "The number of failures on each day of the period.",
      empty: "No data for the period.",
      showTable: "Show as a table",
      chartLabel: "Failures per day over {days} days, at most {max} in one day.",
      peak: "Peak: {max}",
      caption: "Failures per day",
      day: "Day",
      failures: "Failures"
    },
    subjects: {
      title: "Most affected accounts",
      description: "Identifiers of the accounts with the most failures (no personal data).",
      caption: "Accounts with the most failures",
      empty: "No account to flag.",
      subject: "Account identifier",
      failures: "Failures"
    }
  },
  audit: {
    title: "Platform audit log",
    tableCaption: "Actions of the platform administrators",
    loadFailedTitle: "Could not load the log",
    loadFailedBody: "The log could not be retrieved. Try again in a moment.",
    columns: {
      when: "Date and time",
      admin: "Administrator",
      action: "Action",
      organization: "Organisation",
      reason: "Reason"
    },
    empty: {
      title: "No actions recorded",
      description: "Administrator actions will appear here."
    },
    actions: {
      signed_in: "Signed in to the back-office",
      organization_viewed: "Organisation viewed",
      subscription_overridden: "Subscription status changed",
      payment_confirmed: "Payment confirmed",
      job_retried: "Job retried",
      job_discarded: "Job discarded",
      break_glass_requested: "Support access requested",
      break_glass_approved: "Support access approved",
      break_glass_rejected: "Support access rejected",
      break_glass_cancelled: "Support access request cancelled",
      break_glass_revoked: "Support access revoked",
      unknown: "Other action"
    }
  },
  plans: {
    title: "Plans",
    readOnlyNote: "This catalogue is read-only. Plan prices and limits are changed through the data files (seeds), not from the back-office.",
    compare: "Compare the plans",
    taxNote: "Prices exclude tax. Amounts in Tunisian dinars (TND).",
    caption: "BatiFlow plan catalogue",
    loadFailedTitle: "Could not load the plans",
    loadFailedBody: "The catalogue could not be retrieved. Try again in a moment.",
    names: {
      solo: "Solo",
      starter: "Starter",
      pro: "Pro",
      business: "Business",
      enterprise: "Enterprise"
    },
    monthly: "Monthly price (excl. tax)",
    annual: "Annual price (excl. tax)",
    extraSeat: "Extra seat (per month)",
    seats: "Included seats",
    storage: "Included storage",
    hostedSpaces: "Hosted shared spaces",
    meetingParticipants: "Participants per meeting",
    unlimited: "Unlimited",
    byContract: "By contract",
    onQuote: "On quote",
    notOffered: "Not offered"
  },
  reasonDialog: {
    reason: "Reason",
    reasonHint: "At least {min} characters. The reason is kept in the platform log.",
    reasonTooShort: "Explain the reason in at least {min} characters.",
    ticket: "Support ticket reference",
    ticketHint: "The ticket behind this action (for example SUP-2026-1042).",
    ticketRequired: "Enter the ticket reference.",
    confirmationMismatch: "The text does not match. Type it exactly."
  },
  members: {
    title: "Members",
    description: "The organisation\u2019s people (identity, role and state; no content). Every action needs a reason and confirming it\u2019s you, and also shows in the organisation\u2019s audit log.",
    filter: "Filter members by state",
    allStatuses: "All states",
    caption: "Members of the organisation",
    emptyTitle: "No members",
    emptyDescription: "No member matches this filter.",
    loadFailedTitle: "Cannot show the members",
    loadFailedBody: "The member list could not be loaded. Try again.",
    actionsFor: "Actions for {name}",
    columns: {
      person: "Person",
      role: "Role",
      status: "State",
      joined: "Joined",
      actions: "Actions"
    },
    status: {
      active: "Active",
      suspended: "Suspended",
      invited: "Invited",
      deactivated: "Removed"
    },
    actions: {
      suspend: "Suspend",
      reactivate: "Reactivate",
      remove: "Remove from the organisation"
    },
    suspend: {
      title: "Suspend {name}?",
      body: "The person loses access to this organisation and its shared spaces at once. Nothing is deleted: you can reactivate them.",
      confirm: "Suspend",
      done: "{name} is suspended."
    },
    reactivate: {
      title: "Reactivate {name}?",
      body: "The person gets back their access and rights in this organisation at once.",
      confirm: "Reactivate",
      done: "{name} is reactivated."
    },
    remove: {
      title: "Remove {name} from the organisation?",
      body: "What the person owns (tasks, documents\u2026) goes to the organisation\u2019s owner and all their rights there end. Their account stays active elsewhere. The owner cannot be removed here.",
      confirm: "Remove",
      done: "{name} was removed from the organisation."
    }
  },
  accounts: {
    title: "Account",
    summary: "Account",
    email: "E-mail address",
    status: "Account state",
    active: "Active",
    locked: "Locked",
    deleted: "Deleted",
    kind: "Type",
    guest: "Guest (external)",
    member: "Member",
    lastSeen: "Last activity",
    created: "Created on",
    memberships: "Organisations",
    membershipsHint: "The organisations this account belongs to, and its state in each.",
    membershipsCaption: "Organisations of the account",
    noMemberships: "This account belongs to no organisation.",
    lockedTitle: "Account locked",
    lockedBody: "The person can no longer sign in to BatiFlow and all their sessions were ended.",
    notFoundTitle: "Account not found",
    notFoundBody: "This account does not exist or was deleted.",
    loadFailedTitle: "Cannot show the account",
    loadFailedBody: "The account could not be loaded. Try again.",
    columns: {
      organization: "Organisation",
      organizationStatus: "Organisation state"
    },
    lock: {
      action: "Lock the account",
      title: "Lock {name}\u2019s account?",
      body: "The person can no longer sign in, in any organisation, and all their sessions end at once. Nothing is deleted: you can unlock the account.",
      confirm: "Lock",
      done: "The account is locked."
    },
    unlock: {
      action: "Unlock the account",
      title: "Unlock {name}\u2019s account?",
      body: "The person can sign in again, with the access they had.",
      confirm: "Unlock",
      done: "The account is unlocked."
    },
    delete: {
      title: "Delete the account",
      description: "Final: the person leaves all their organisations and shared spaces, their personal data is erased and their sign-in account is deleted.",
      action: "Delete the account",
      dialogTitle: "Delete {name}\u2019s account for good?",
      body: "What the person owns goes to each organisation\u2019s owner. The content they created stays in the organisations, signed \u201CDeleted account\u201D. This cannot be undone.",
      confirm: "Delete for good",
      confirmLabel: "E-mail address of the account",
      confirmHint: "Type {email} to confirm.",
      done: "The account was deleted.",
      blocked: {
        owner: "This account owns an organisation: transfer the ownership first, or delete the organisation.",
        support_identity: "This account is a platform administrator\u2019s support identity: remove that link first."
      }
    }
  },
  deletions: {
    title: "Organisation deletions",
    intro: "Deleting an organisation erases all its data. One administrator asks for it (the organisation is suspended at once), another administrator approves or rejects it.",
    caption: "Organisation deletion requests",
    emptyTitle: "No requests",
    emptyDescription: "No deletion request matches this filter.",
    loadFailedTitle: "Cannot show the requests",
    loadFailedBody: "The deletion requests could not be loaded. Try again.",
    withdrawn: "Withdrawn by the requester",
    ownRequest: "You made this request: another administrator must decide.",
    filters: {
      label: "Request filters",
      status: "Filter by state",
      all: "All requests"
    },
    columns: {
      organization: "Organisation",
      ticket: "Ticket and reason",
      requested: "Requested by",
      decided: "Decision",
      status: "State",
      actions: "Actions"
    },
    status: {
      pending: "Pending",
      approved: "Approved",
      rejected: "Rejected",
      cancelled: "Withdrawn"
    },
    execution: {
      scheduled: "Deletion waiting to run",
      running: "Deletion in progress",
      cancelled: "Deletion cancelled",
      done: "Data deleted"
    },
    actions: {
      approve: "Approve",
      reject: "Reject",
      cancel: "Withdraw"
    },
    approve: {
      title: "Delete \u201C{name}\u201D and all its data?",
      body: "The data, files, rights and the accounts that belong only to this organisation will be deleted within minutes. A deletion certificate will be produced. This cannot be undone.",
      confirm: "Approve the deletion",
      done: "Deletion approved: it runs now."
    },
    reject: {
      title: "Reject the deletion of \u201C{name}\u201D?",
      body: "The organisation gets back the state it had before the request.",
      confirm: "Reject",
      done: "Request rejected: the organisation gets back its state."
    },
    cancel: {
      title: "Withdraw your request for \u201C{name}\u201D?",
      body: "The organisation gets back the state it had before the request.",
      confirm: "Withdraw the request",
      keep: "Keep the request",
      done: "Request withdrawn."
    },
    zone: {
      title: "Delete the organisation",
      description: "Final, and decided by two administrators.",
      pendingTitle: "Deletion requested",
      pendingBody: "Requested by {name} on",
      openRequests: "See the deletion requests",
      request: "Request the deletion",
      what: {
        data: "All the organisation\u2019s data and files are erased.",
        accounts: "Accounts that belong only to it are deleted; the others stay.",
        suspended: "From the request on, the organisation is suspended (read-only for its members).",
        fourEyes: "Another administrator must approve; you can withdraw your request until then."
      }
    },
    request: {
      title: "Request the deletion of \u201C{name}\u201D",
      body: "The organisation is suspended at once. Its data is deleted only once another administrator approves.",
      confirm: "Request the deletion",
      confirmLabel: "Legal name of the organisation",
      confirmHint: "Type {name} to confirm.",
      done: "Request sent: another administrator must approve it."
    }
  }
};

// locales/fr/backoffice.json
var backoffice_default3 = {
  header: {
    tag: "Back-office",
    sessionHint: "Session prot\xE9g\xE9e par WebAuthn : chaque modification demande de confirmer votre identit\xE9.",
    language: "Langue",
    accountMenu: "Menu du compte de {name}",
    signOut: "Se d\xE9connecter"
  },
  nav: {
    organizations: "Organisations",
    "break-glass": "Support",
    jobs: "Jobs en \xE9chec",
    security: "S\xE9curit\xE9",
    audit: "Journal",
    plans: "Forfaits",
    deletions: "Suppressions"
  },
  common: {
    none: "\u2014",
    cancel: "Annuler",
    busy: "Traitement en cours",
    loadMore: "Charger plus",
    loadingMore: "Chargement\u2026",
    duration: {
      minutes: "{minutes} min",
      hours: "{hours} h",
      hoursMinutes: "{hours} h {minutes} min"
    },
    to: "au"
  },
  session: {
    loading: "Chargement du back-office\u2026",
    redirecting: "Redirection vers la page de connexion\u2026"
  },
  unavailable: {
    title: "Le service de connexion n'est pas disponible",
    body: "Nous n'arrivons pas \xE0 v\xE9rifier votre session pour le moment. R\xE9essayez dans un instant ; si le probl\xE8me continue, contactez l'\xE9quipe technique."
  },
  signedOut: {
    title: "D\xE9connexion r\xE9ussie",
    body: "Votre session du back-office BatiFlow est ferm\xE9e sur cet appareil. Pour continuer, reconnectez-vous avec votre cl\xE9 de s\xE9curit\xE9.",
    signIn: "Se reconnecter",
    reasons: {
      login_failed: {
        title: "La connexion n'a pas abouti",
        body: "La connexion a \xE9t\xE9 interrompue ou a expir\xE9. R\xE9essayez ; si le probl\xE8me continue, contactez l'\xE9quipe technique."
      },
      cancelled: {
        title: "Connexion annul\xE9e",
        body: "Vous avez annul\xE9 la connexion. Vous pouvez recommencer quand vous voulez."
      },
      not_platform_admin: {
        title: "Compte non autoris\xE9",
        body: "Ce compte n'est pas administrateur de la plateforme. L'acc\xE8s au back-office est r\xE9serv\xE9 \xE0 l'\xE9quipe BatiFlow. Si vous pensez qu'il s'agit d'une erreur, demandez \xE0 un administrateur de v\xE9rifier votre r\xF4le."
      },
      webauthn_required: {
        title: "Cl\xE9 de s\xE9curit\xE9 requise",
        body: "Le back-office exige une connexion avec une cl\xE9 de s\xE9curit\xE9 ou une biom\xE9trie (WebAuthn). Reconnectez-vous en choisissant ce moyen ; un mot de passe seul ne suffit pas."
      },
      step_up_failed: {
        title: "Identit\xE9 non confirm\xE9e",
        body: "Nous n'avons pas pu confirmer votre identit\xE9 avec votre cl\xE9 de s\xE9curit\xE9. Rien n'a \xE9t\xE9 modifi\xE9. Reconnectez-vous puis recommencez l'action."
      }
    }
  },
  stepUp: {
    reason: "Cette action modifie des donn\xE9es de la plateforme : elle demande de confirmer votre identit\xE9 avec votre cl\xE9 de s\xE9curit\xE9 (WebAuthn). Vous reviendrez ensuite sur cette page et l'action sera effectu\xE9e."
  },
  pendingAction: {
    replayed: "C'est fait : votre action a \xE9t\xE9 effectu\xE9e apr\xE8s la confirmation de votre identit\xE9.",
    failed: "Votre identit\xE9 est confirm\xE9e, mais l'action n'a pas abouti. Recommencez-la."
  },
  signOut: {
    title: "D\xE9connexion incompl\xE8te",
    failed: "La d\xE9connexion n'a pas abouti. Fermez votre navigateur pour terminer la session en toute s\xE9curit\xE9.",
    close: "Fermer"
  },
  error: {
    title: "Un probl\xE8me est survenu",
    body: "Cette page n'a pas pu s'afficher. Rechargez la page ; si le probl\xE8me continue, transmettez les d\xE9tails techniques \xE0 l'\xE9quipe technique.",
    reload: "Recharger la page",
    details: "D\xE9tails techniques",
    noTrace: "non disponible",
    release: "Version : {release}",
    copied: "D\xE9tails copi\xE9s dans le presse-papiers.",
    copyFailed: "Copie impossible. S\xE9lectionnez le texte ci-dessus pour le copier \xE0 la main."
  },
  notFound: {
    title: "Cette page n'existe pas",
    body: "Le lien est peut-\xEAtre ancien ou mal saisi. Revenez \xE0 la liste des organisations pour continuer.",
    home: "Retour aux organisations"
  },
  status: {
    organization: {
      trial: "Essai",
      active: "Actif",
      read_only: "Lecture seule",
      suspended: "Suspendu",
      closed: "Cl\xF4tur\xE9",
      deleted: "Supprim\xE9"
    },
    subscription: {
      trialing: "P\xE9riode d'essai",
      active: "Actif",
      past_due: "Paiement en retard",
      read_only: "Lecture seule",
      suspended: "Suspendu",
      paused: "En pause",
      cancelled: "R\xE9sili\xE9"
    }
  },
  orgs: {
    title: "Organisations",
    tableCaption: "Organisations clientes de BatiFlow",
    loadFailedTitle: "Impossible de charger les organisations",
    loadFailedBody: "La liste n'a pas pu \xEAtre r\xE9cup\xE9r\xE9e. R\xE9essayez dans un instant.",
    columns: {
      name: "Raison sociale",
      taxId: "Matricule fiscal",
      status: "Statut",
      plan: "Forfait",
      subscription: "Abonnement",
      members: "Membres",
      storage: "Stockage",
      dueAt: "Prochaine \xE9ch\xE9ance"
    },
    filters: {
      label: "Rechercher et filtrer les organisations",
      search: "Rechercher une organisation",
      searchPlaceholder: "Nom ou matricule fiscal",
      status: "Filtrer par statut",
      allStatuses: "Tous les statuts",
      clear: "Effacer les filtres"
    },
    empty: {
      title: "Aucune organisation",
      description: "Les organisations appara\xEEtront ici d\xE8s qu'un bureau d'\xE9tudes aura cr\xE9\xE9 son compte.",
      filteredTitle: "Aucun r\xE9sultat",
      filteredDescription: "Aucune organisation ne correspond \xE0 cette recherche. V\xE9rifiez l'orthographe ou effacez les filtres."
    },
    detail: {
      loading: "Chargement de l'organisation\u2026",
      loadFailedTitle: "Impossible de charger cette organisation",
      loadFailedBody: "Les informations n'ont pas pu \xEAtre r\xE9cup\xE9r\xE9es. R\xE9essayez dans un instant.",
      notFoundTitle: "Organisation introuvable",
      notFoundDescription: "Cette organisation n'existe pas ou le lien est incorrect.",
      backToList: "Retour aux organisations",
      requestAccess: "Demander un acc\xE8s support",
      changeStatus: "Changer le statut",
      summary: "R\xE9sum\xE9",
      legalName: "Raison sociale",
      tradeName: "Nom commercial",
      governorate: "Gouvernorat",
      createdAt: "Cr\xE9\xE9e le",
      owners: "Propri\xE9taires",
      subscription: "Abonnement",
      noSubscription: "Cette organisation n'a pas d'abonnement.",
      cycle: "Cycle de facturation",
      cycles: {
        monthly: "Mensuel",
        annual: "Annuel"
      },
      extraSeats: "Si\xE8ges suppl\xE9mentaires",
      period: "P\xE9riode en cours",
      trialEndsAt: "Fin de l'essai",
      cancelAt: "R\xE9siliation pr\xE9vue le",
      pausedUntil: "En pause jusqu'au",
      paymentMethod: "Moyen de paiement",
      paymentMethods: {
        card: "Carte bancaire",
        bank_transfer: "Virement bancaire",
        cheque: "Ch\xE8que",
        online: "Paiement en ligne",
        transfer: "Virement bancaire"
      },
      usage: "Utilisation",
      seatsUsed: "Si\xE8ges utilis\xE9s",
      seatsBillable: "Si\xE8ges facturables",
      unlimited: "Illimit\xE9",
      monthMetric: "Ce mois-ci : {metric}",
      metrics: {
        storage_bytes: "stockage enregistr\xE9",
        meeting_participant_minutes: "minutes de participation aux r\xE9unions",
        ttn_submissions: "envois \xE0 TTN"
      },
      deletion: {
        scheduled: "Suppression programm\xE9e",
        done: "Donn\xE9es supprim\xE9es",
        cancelled: "Suppression annul\xE9e",
        body: "Motif : {reason}. Date pr\xE9vue :",
        running: "Suppression en cours"
      },
      invoices: {
        title: "Factures d'abonnement",
        description: "Les factures \xE9mises par BatiFlow \xE0 cette organisation. Les factures ouvertes peuvent \xEAtre r\xE9gl\xE9es par virement ou par ch\xE8que.",
        caption: "Factures d'abonnement de l'organisation",
        number: "Num\xE9ro",
        purpose: "Objet",
        issueDate: "\xC9mise le",
        dueDate: "\xC0 payer avant le",
        total: "Total TTC",
        status: "\xC9tat",
        actions: "Actions",
        confirmPayment: "Confirmer un paiement",
        confirmFor: "Confirmer le paiement de la facture {number}",
        emptyTitle: "Aucune facture",
        emptyDescription: "Aucune facture d'abonnement n'a \xE9t\xE9 \xE9mise pour cette organisation.",
        purposes: {
          start: "D\xE9but d'abonnement",
          upgrade: "Changement de forfait",
          restart: "Red\xE9marrage",
          renewal: "Renouvellement",
          resume: "Reprise apr\xE8s pause"
        },
        statuses: {
          open: "\xC0 payer",
          paid: "Pay\xE9e",
          void: "Annul\xE9e"
        }
      },
      dunning: {
        title: "Relances de paiement",
        description: "Les \xE9tapes de relance d\xE9j\xE0 enregistr\xE9es pour cette organisation.",
        empty: "Aucune relance enregistr\xE9e.",
        due: "\xC9ch\xE9ance :",
        recorded: "Enregistr\xE9e le",
        stages: {
          reminder: "Rappel d'\xE9ch\xE9ance (J{day})",
          read_only: "Passage en lecture seule",
          suspended: "Suspension du compte",
          deletion_scheduled: "Suppression des donn\xE9es programm\xE9e"
        }
      }
    },
    deletions: "Suppressions"
  },
  payment: {
    title: "Confirmer un paiement",
    invoice: "Facture",
    method: "Moyen de paiement re\xE7u",
    methods: {
      transfer: "Virement bancaire",
      cheque: "Ch\xE8que"
    },
    receivedOn: "Re\xE7u le",
    reference: "R\xE9f\xE9rence",
    referenceHint: "R\xE9f\xE9rence du virement ou du bordereau de remise, pour retrouver le paiement.",
    chequeNumber: "Num\xE9ro du ch\xE8que",
    chequeBank: "Banque du ch\xE8que",
    submit: "Confirmer le paiement",
    done: "Paiement {number} enregistr\xE9 : {amount}. La facture est r\xE9gl\xE9e.",
    errors: {
      dateRequired: "Indiquez la date de r\xE9ception.",
      dateFuture: "La date de r\xE9ception ne peut pas \xEAtre dans le futur.",
      referenceRequired: "Indiquez la r\xE9f\xE9rence du paiement.",
      chequeNumberRequired: "Indiquez le num\xE9ro du ch\xE8que.",
      chequeBankRequired: "Indiquez la banque du ch\xE8que."
    }
  },
  override: {
    title: "Changer le statut de l'abonnement",
    explanation: "Vous changez le statut de l'abonnement \xE0 la main (geste commercial, litige). L'acc\xE8s de l'organisation suit ce statut. Le changement est enregistr\xE9 dans le journal de la plateforme avec votre motif.",
    status: "Nouveau statut",
    currentMarker: "actuel",
    effects: {
      trialing: "L'organisation repasse en p\xE9riode d'essai et retrouve l'acc\xE8s complet.",
      active: "L'organisation retrouve l'acc\xE8s complet.",
      past_due: "L'organisation garde l'acc\xE8s complet ; un paiement en retard est signal\xE9.",
      read_only: "L'organisation ne peut plus que consulter ses donn\xE9es : aucune cr\xE9ation ni modification.",
      suspended: "L'organisation n'a plus acc\xE8s \xE0 ses donn\xE9es tant que le statut n'est pas r\xE9tabli.",
      paused: "L'abonnement est marqu\xE9 en pause et l'organisation passe en lecture seule.",
      cancelled: "L'abonnement est marqu\xE9 r\xE9sili\xE9 et l'organisation passe en lecture seule."
    },
    restrictiveWarning: "Ce statut limite l'acc\xE8s de l'organisation : ses membres le verront tout de suite.",
    reason: "Motif",
    reasonHint: "Au moins {min} caract\xE8res. Ce motif est conserv\xE9 dans le journal.",
    reasonTooShort: "Le motif doit contenir au moins {min} caract\xE8res.",
    submit: "Appliquer le statut",
    confirmTitle: "Modifier l'acc\xE8s de {name} ?",
    confirmBody: {
      suspended: "L'organisation sera suspendue : ses membres n'auront plus acc\xE8s \xE0 leurs donn\xE9es. Vous pourrez r\xE9tablir le statut plus tard.",
      cancelled: "L'abonnement sera marqu\xE9 r\xE9sili\xE9 et l'organisation passera en lecture seule. Vous pourrez r\xE9tablir le statut plus tard."
    },
    confirm: "Oui, appliquer",
    done: "Statut appliqu\xE9 : {status}.",
    stale: "L'abonnement a \xE9t\xE9 modifi\xE9 entre-temps. La page vient d'\xEAtre actualis\xE9e : v\xE9rifiez le statut puis recommencez.",
    noTrial: "Cet abonnement n'a pas de p\xE9riode d'essai : choisissez un autre statut."
  },
  breakGlass: {
    title: "Acc\xE8s support (break-glass)",
    intro: "Un acc\xE8s support est temporaire et en lecture seule. Il est demand\xE9 par un administrateur et approuv\xE9 par un autre.",
    newRequest: "Nouvelle demande",
    tableCaption: "Demandes d'acc\xE8s support",
    loadFailedTitle: "Impossible de charger les demandes",
    loadFailedBody: "La liste n'a pas pu \xEAtre r\xE9cup\xE9r\xE9e. R\xE9essayez dans un instant.",
    filters: {
      label: "Filtrer les demandes",
      status: "Filtrer par \xE9tat",
      allStatuses: "Tous les \xE9tats"
    },
    empty: {
      title: "Aucune demande",
      description: "Les demandes d'acc\xE8s support appara\xEEtront ici.",
      filteredTitle: "Aucune demande dans cet \xE9tat",
      filteredDescription: "Choisissez un autre \xE9tat pour voir d'autres demandes."
    },
    status: {
      pending: "En attente",
      active: "Active",
      rejected: "Refus\xE9e",
      cancelled: "Annul\xE9e",
      expired: "Expir\xE9e",
      revoked: "R\xE9voqu\xE9e"
    },
    bases: {
      owner_consent: "Accord du propri\xE9taire",
      legal_requisition: "R\xE9quisition l\xE9gale"
    },
    columns: {
      organization: "Organisation",
      ticket: "Ticket et motif",
      basis: "Fondement",
      duration: "Dur\xE9e",
      requested: "Demand\xE9e par",
      decided: "D\xE9cid\xE9e par",
      window: "Fen\xEAtre d'acc\xE8s",
      status: "\xC9tat",
      actions: "Actions"
    },
    remaining: "Temps restant :",
    actions: {
      approve: "Approuver",
      reject: "Refuser",
      cancel: "Annuler la demande",
      revoke: "R\xE9voquer"
    },
    blocked: {
      requester: "Un autre administrateur doit d\xE9cider de cette demande : vous en \xEAtes l'auteur.",
      noSupportIdentity: "Votre compte support n'est pas encore reli\xE9 : demandez \xE0 un administrateur de le configurer."
    },
    request: {
      title: "Nouvelle demande d'acc\xE8s support",
      rulesIntro: "Avant de continuer :",
      rules: {
        readOnly: "L'acc\xE8s est en lecture seule : rien ne peut \xEAtre modifi\xE9.",
        secondAdmin: "Un second administrateur doit approuver la demande.",
        maxFourHours: "L'acc\xE8s dure 4 heures au maximum, puis il prend fin tout seul.",
        audited: "L'acc\xE8s est enregistr\xE9 dans le journal d'audit de l'organisation, que ses propri\xE9taires peuvent consulter."
      },
      organization: "Organisation",
      organizationHint: "Cherchez par nom ou matricule fiscal (2 caract\xE8res au minimum).",
      organizationSearch: "Rechercher l'organisation concern\xE9e",
      organizationResults: "Organisations trouv\xE9es",
      noOrganization: "Aucune organisation trouv\xE9e.",
      changeOrganization: "Changer d'organisation",
      ticket: "R\xE9f\xE9rence du ticket",
      ticketHint: "Le ticket de support qui justifie cet acc\xE8s.",
      reason: "Motif",
      reasonHint: "Au moins {min} caract\xE8res : expliquez ce que vous devez v\xE9rifier.",
      basis: "Fondement de la demande",
      basisRef: "R\xE9f\xE9rence du fondement",
      basisRefHint: {
        owner_consent: "O\xF9 l'accord du propri\xE9taire est conserv\xE9 (ticket, e-mail archiv\xE9\u2026).",
        legal_requisition: "O\xF9 la r\xE9quisition est conserv\xE9e (num\xE9ro de dossier, document archiv\xE9\u2026)."
      },
      duration: "Dur\xE9e (en minutes)",
      durationHint: "Entre {min} et {max} minutes.",
      submit: "Envoyer la demande",
      done: "Demande envoy\xE9e pour {name}. Un autre administrateur doit l'approuver.",
      errors: {
        organizationRequired: "Choisissez l'organisation concern\xE9e.",
        ticketRequired: "Indiquez la r\xE9f\xE9rence du ticket.",
        reasonTooShort: "Le motif doit contenir au moins {min} caract\xE8res.",
        basisRefRequired: "Indiquez o\xF9 le fondement est conserv\xE9.",
        durationRange: "La dur\xE9e doit \xEAtre un nombre entier de minutes, entre {min} et {max}."
      }
    },
    approve: {
      title: "Approuver l'acc\xE8s \xE0 {name} ?",
      body: "Vous obtiendrez tout de suite un acc\xE8s en lecture seule \xE0 cette organisation, avec votre compte support, pour la dur\xE9e demand\xE9e (4 heures au maximum). L'acc\xE8s sera inscrit dans le journal d'audit de l'organisation.",
      confirm: "Approuver l'acc\xE8s",
      done: "Acc\xE8s approuv\xE9. Il prendra fin automatiquement."
    },
    reject: {
      title: "Refuser la demande pour {name}",
      reason: "Motif du refus",
      reasonHint: "Au moins {min} caract\xE8res. Ce motif est conserv\xE9 dans le journal.",
      reasonTooShort: "Le motif doit contenir au moins {min} caract\xE8res.",
      submit: "Refuser la demande",
      done: "Demande refus\xE9e."
    },
    cancel: {
      title: "Annuler votre demande pour {name} ?",
      body: "La demande sera retir\xE9e : personne ne pourra l'approuver.",
      confirm: "Annuler la demande",
      keep: "Conserver la demande",
      done: "Demande annul\xE9e."
    },
    revoke: {
      title: "R\xE9voquer l'acc\xE8s \xE0 {name} ?",
      body: "L'acc\xE8s support prendra fin imm\xE9diatement. Pour y revenir, il faudra une nouvelle demande approuv\xE9e.",
      confirm: "R\xE9voquer l'acc\xE8s",
      keep: "Garder l'acc\xE8s",
      done: "Acc\xE8s r\xE9voqu\xE9."
    }
  },
  jobs: {
    title: "Jobs en \xE9chec",
    tableCaption: "T\xE2ches de fond en \xE9chec apr\xE8s toutes leurs tentatives",
    loadFailedTitle: "Impossible de charger les jobs en \xE9chec",
    loadFailedBody: "La liste n'a pas pu \xEAtre r\xE9cup\xE9r\xE9e. R\xE9essayez dans un instant.",
    columns: {
      failedAt: "\xC9chec le",
      queue: "File",
      eventType: "Type d'\xE9v\xE9nement",
      tenantId: "Organisation",
      attempts: "Tentatives",
      error: "Erreur",
      actions: "Actions"
    },
    empty: {
      title: "Aucun job en \xE9chec",
      description: "Toutes les t\xE2ches de fond se sont termin\xE9es normalement."
    },
    retry: "Relancer",
    retryFor: "Relancer le job {event} de la file {queue}",
    retryTitle: "Relancer ce job ?",
    retryBody: "Le job \xAB {event} \xBB sera remis dans sa file et ex\xE9cut\xE9 \xE0 nouveau.",
    retried: "Job relanc\xE9.",
    discard: "Supprimer",
    discardFor: "Supprimer le job {event} de la file {queue}",
    discardTitle: "Supprimer ce job ?",
    discardBody: "Le job \xAB {event} \xBB sera oubli\xE9 d\xE9finitivement : il ne sera jamais ex\xE9cut\xE9.",
    discarded: "Job supprim\xE9."
  },
  security: {
    title: "S\xE9curit\xE9",
    window: "P\xE9riode observ\xE9e",
    windowOption: "{days, plural, one {Dernier jour} other {# derniers jours}}",
    period: "Du",
    loadFailedTitle: "Impossible de charger les signaux de s\xE9curit\xE9",
    loadFailedBody: "Les chiffres n'ont pas pu \xEAtre r\xE9cup\xE9r\xE9s. R\xE9essayez dans un instant.",
    actions: {
      auth_login_failed: "\xC9checs de connexion",
      auth_step_up_failed: "\xC9checs de confirmation d'identit\xE9",
      auth_session_flagged: "Sessions signal\xE9es",
      auth_session_revoked: "Sessions r\xE9voqu\xE9es"
    },
    realms: {
      batiflow: "Clients",
      "batiflow-platform": "Plateforme"
    },
    empty: {
      title: "Aucun \xE9chec",
      description: "Aucun \xE9chec de s\xE9curit\xE9 sur les {days} derniers jours."
    },
    failures: {
      title: "\xC9checs par type",
      description: "Connexions et confirmations d'identit\xE9 refus\xE9es sur la p\xE9riode.",
      caption: "\xC9checs de s\xE9curit\xE9 par type",
      action: "Type",
      realm: "Espace",
      count: "\xC9checs"
    },
    perDay: {
      title: "\xC9checs par jour",
      description: "Le nombre d'\xE9checs chaque jour de la p\xE9riode.",
      empty: "Aucune donn\xE9e sur la p\xE9riode.",
      showTable: "Afficher sous forme de tableau",
      chartLabel: "\xC9checs par jour sur {days} jours, au plus {max} en une journ\xE9e.",
      peak: "Maximum : {max}",
      caption: "\xC9checs par jour",
      day: "Jour",
      failures: "\xC9checs"
    },
    subjects: {
      title: "Comptes les plus touch\xE9s",
      description: "Identifiants des comptes avec le plus d'\xE9checs (aucune donn\xE9e personnelle).",
      caption: "Comptes avec le plus d'\xE9checs",
      empty: "Aucun compte \xE0 signaler.",
      subject: "Identifiant du compte",
      failures: "\xC9checs"
    }
  },
  audit: {
    title: "Journal de la plateforme",
    tableCaption: "Actions des administrateurs de la plateforme",
    loadFailedTitle: "Impossible de charger le journal",
    loadFailedBody: "Le journal n'a pas pu \xEAtre r\xE9cup\xE9r\xE9. R\xE9essayez dans un instant.",
    columns: {
      when: "Date et heure",
      admin: "Administrateur",
      action: "Action",
      organization: "Organisation",
      reason: "Motif"
    },
    empty: {
      title: "Aucune action enregistr\xE9e",
      description: "Les actions des administrateurs appara\xEEtront ici."
    },
    actions: {
      signed_in: "Connexion au back-office",
      organization_viewed: "Consultation d'une organisation",
      subscription_overridden: "Statut d'abonnement modifi\xE9",
      payment_confirmed: "Paiement confirm\xE9",
      job_retried: "Job relanc\xE9",
      job_discarded: "Job supprim\xE9",
      break_glass_requested: "Acc\xE8s support demand\xE9",
      break_glass_approved: "Acc\xE8s support approuv\xE9",
      break_glass_rejected: "Acc\xE8s support refus\xE9",
      break_glass_cancelled: "Demande d'acc\xE8s support annul\xE9e",
      break_glass_revoked: "Acc\xE8s support r\xE9voqu\xE9",
      unknown: "Autre action"
    }
  },
  plans: {
    title: "Forfaits",
    readOnlyNote: "Ce catalogue est en lecture seule. Les prix et les limites des forfaits se modifient par les fichiers de donn\xE9es (seeds), pas depuis le back-office.",
    compare: "Comparer les forfaits",
    taxNote: "Prix hors taxes. Montants en dinars tunisiens (TND).",
    caption: "Catalogue des forfaits BatiFlow",
    loadFailedTitle: "Impossible de charger les forfaits",
    loadFailedBody: "Le catalogue n'a pas pu \xEAtre r\xE9cup\xE9r\xE9. R\xE9essayez dans un instant.",
    names: {
      solo: "Solo",
      starter: "Starter",
      pro: "Pro",
      business: "Business",
      enterprise: "Enterprise"
    },
    monthly: "Prix mensuel (HT)",
    annual: "Prix annuel (HT)",
    extraSeat: "Si\xE8ge suppl\xE9mentaire (par mois)",
    seats: "Si\xE8ges inclus",
    storage: "Stockage inclus",
    hostedSpaces: "Espaces partag\xE9s h\xE9berg\xE9s",
    meetingParticipants: "Participants par r\xE9union",
    unlimited: "Illimit\xE9",
    byContract: "Selon contrat",
    onQuote: "Sur devis",
    notOffered: "Non propos\xE9"
  },
  reasonDialog: {
    reason: "Motif",
    reasonHint: "Au moins {min} caract\xE8res. Le motif est conserv\xE9 dans le journal de la plateforme.",
    reasonTooShort: "Expliquez le motif en {min} caract\xE8res au moins.",
    ticket: "R\xE9f\xE9rence du ticket de support",
    ticketHint: "Le ticket qui justifie cette action (par exemple SUP-2026-1042).",
    ticketRequired: "Indiquez la r\xE9f\xE9rence du ticket.",
    confirmationMismatch: "Le texte saisi ne correspond pas. Recopiez-le exactement."
  },
  members: {
    title: "Membres",
    description: "Les personnes de l\u2019organisation (identit\xE9, r\xF4le et \xE9tat ; aucun contenu). Chaque action demande un motif et confirmer votre identit\xE9, et appara\xEEt aussi dans le journal d\u2019audit de l\u2019organisation.",
    filter: "Filtrer les membres par \xE9tat",
    allStatuses: "Tous les \xE9tats",
    caption: "Membres de l\u2019organisation",
    emptyTitle: "Aucun membre",
    emptyDescription: "Aucun membre ne correspond \xE0 ce filtre.",
    loadFailedTitle: "Impossible d\u2019afficher les membres",
    loadFailedBody: "La liste des membres n\u2019a pas pu \xEAtre charg\xE9e. R\xE9essayez.",
    actionsFor: "Actions pour {name}",
    columns: {
      person: "Personne",
      role: "R\xF4le",
      status: "\xC9tat",
      joined: "Arriv\xE9e",
      actions: "Actions"
    },
    status: {
      active: "Actif",
      suspended: "Suspendu",
      invited: "Invit\xE9",
      deactivated: "Retir\xE9"
    },
    actions: {
      suspend: "Suspendre",
      reactivate: "R\xE9activer",
      remove: "Retirer de l\u2019organisation"
    },
    suspend: {
      title: "Suspendre {name} ?",
      body: "La personne perd aussit\xF4t l\u2019acc\xE8s \xE0 cette organisation et \xE0 ses espaces partag\xE9s. Rien n\u2019est supprim\xE9 : vous pourrez la r\xE9activer.",
      confirm: "Suspendre",
      done: "{name} est suspendu(e)."
    },
    reactivate: {
      title: "R\xE9activer {name} ?",
      body: "La personne retrouve aussit\xF4t son acc\xE8s et ses droits dans cette organisation.",
      confirm: "R\xE9activer",
      done: "{name} est r\xE9activ\xE9(e)."
    },
    remove: {
      title: "Retirer {name} de l\u2019organisation ?",
      body: "Ce que la personne poss\xE8de (t\xE2ches, documents\u2026) est confi\xE9 au propri\xE9taire de l\u2019organisation et tous ses droits y sont retir\xE9s. Son compte reste actif ailleurs. Le propri\xE9taire ne peut pas \xEAtre retir\xE9 ici.",
      confirm: "Retirer",
      done: "{name} a \xE9t\xE9 retir\xE9(e) de l\u2019organisation."
    }
  },
  accounts: {
    title: "Compte",
    summary: "Compte",
    email: "Adresse e-mail",
    status: "\xC9tat du compte",
    active: "Actif",
    locked: "Verrouill\xE9",
    deleted: "Supprim\xE9",
    kind: "Type",
    guest: "Invit\xE9 (externe)",
    member: "Membre",
    lastSeen: "Derni\xE8re activit\xE9",
    created: "Cr\xE9\xE9 le",
    memberships: "Organisations",
    membershipsHint: "Les organisations auxquelles appartient ce compte, et son \xE9tat dans chacune.",
    membershipsCaption: "Organisations du compte",
    noMemberships: "Ce compte n\u2019appartient \xE0 aucune organisation.",
    lockedTitle: "Compte verrouill\xE9",
    lockedBody: "La personne ne peut plus se connecter \xE0 BatiFlow et toutes ses sessions ont \xE9t\xE9 ferm\xE9es.",
    notFoundTitle: "Compte introuvable",
    notFoundBody: "Ce compte n\u2019existe pas ou a \xE9t\xE9 supprim\xE9.",
    loadFailedTitle: "Impossible d\u2019afficher le compte",
    loadFailedBody: "Le compte n\u2019a pas pu \xEAtre charg\xE9. R\xE9essayez.",
    columns: {
      organization: "Organisation",
      organizationStatus: "\xC9tat de l\u2019organisation"
    },
    lock: {
      action: "Verrouiller le compte",
      title: "Verrouiller le compte de {name} ?",
      body: "La personne ne pourra plus se connecter, dans aucune organisation, et toutes ses sessions sont ferm\xE9es tout de suite. Rien n\u2019est supprim\xE9 : vous pourrez d\xE9verrouiller le compte.",
      confirm: "Verrouiller",
      done: "Le compte est verrouill\xE9."
    },
    unlock: {
      action: "D\xE9verrouiller le compte",
      title: "D\xE9verrouiller le compte de {name} ?",
      body: "La personne pourra de nouveau se connecter, avec les acc\xE8s qu\u2019elle avait.",
      confirm: "D\xE9verrouiller",
      done: "Le compte est d\xE9verrouill\xE9."
    },
    delete: {
      title: "Supprimer le compte",
      description: "D\xE9finitif : la personne quitte toutes ses organisations et tous ses espaces partag\xE9s, ses donn\xE9es personnelles sont effac\xE9es et son compte de connexion est supprim\xE9.",
      action: "Supprimer le compte",
      dialogTitle: "Supprimer d\xE9finitivement le compte de {name} ?",
      body: "Ce que la personne poss\xE8de est confi\xE9 au propri\xE9taire de chaque organisation. Les contenus qu\u2019elle a cr\xE9\xE9s restent dans les organisations, sign\xE9s \xAB Compte supprim\xE9 \xBB. Cette action ne peut pas \xEAtre annul\xE9e.",
      confirm: "Supprimer d\xE9finitivement",
      confirmLabel: "Adresse e-mail du compte",
      confirmHint: "Recopiez {email} pour confirmer.",
      done: "Le compte a \xE9t\xE9 supprim\xE9.",
      blocked: {
        owner: "Ce compte est propri\xE9taire d\u2019une organisation : il faut d\u2019abord transf\xE9rer la propri\xE9t\xE9, ou supprimer l\u2019organisation.",
        support_identity: "Ce compte sert d\u2019identit\xE9 de support \xE0 un administrateur de la plateforme : retirez d\u2019abord ce lien."
      }
    }
  },
  deletions: {
    title: "Suppressions d\u2019organisations",
    intro: "Supprimer une organisation efface toutes ses donn\xE9es. Un administrateur la demande (l\u2019organisation est aussit\xF4t suspendue), un autre administrateur l\u2019approuve ou la refuse.",
    caption: "Demandes de suppression d\u2019organisations",
    emptyTitle: "Aucune demande",
    emptyDescription: "Aucune demande de suppression ne correspond \xE0 ce filtre.",
    loadFailedTitle: "Impossible d\u2019afficher les demandes",
    loadFailedBody: "Les demandes de suppression n\u2019ont pas pu \xEAtre charg\xE9es. R\xE9essayez.",
    withdrawn: "Retir\xE9e par le demandeur",
    ownRequest: "Vous avez fait cette demande : un autre administrateur doit d\xE9cider.",
    filters: {
      label: "Filtres des demandes",
      status: "Filtrer par \xE9tat",
      all: "Toutes les demandes"
    },
    columns: {
      organization: "Organisation",
      ticket: "Ticket et motif",
      requested: "Demand\xE9e par",
      decided: "D\xE9cision",
      status: "\xC9tat",
      actions: "Actions"
    },
    status: {
      pending: "En attente",
      approved: "Approuv\xE9e",
      rejected: "Refus\xE9e",
      cancelled: "Retir\xE9e"
    },
    execution: {
      scheduled: "Suppression en attente du traitement",
      running: "Suppression en cours",
      cancelled: "Suppression annul\xE9e",
      done: "Donn\xE9es supprim\xE9es"
    },
    actions: {
      approve: "Approuver",
      reject: "Refuser",
      cancel: "Retirer"
    },
    approve: {
      title: "Supprimer \xAB {name} \xBB et toutes ses donn\xE9es ?",
      body: "Les donn\xE9es, les fichiers, les droits et les comptes qui n\u2019appartiennent qu\u2019\xE0 cette organisation seront supprim\xE9s dans les minutes qui viennent. Un certificat de suppression sera produit. Cette action ne peut pas \xEAtre annul\xE9e.",
      confirm: "Approuver la suppression",
      done: "Suppression approuv\xE9e : elle s\u2019ex\xE9cute maintenant."
    },
    reject: {
      title: "Refuser la suppression de \xAB {name} \xBB ?",
      body: "L\u2019organisation retrouve l\u2019\xE9tat qu\u2019elle avait avant la demande.",
      confirm: "Refuser",
      done: "Demande refus\xE9e : l\u2019organisation retrouve son \xE9tat."
    },
    cancel: {
      title: "Retirer votre demande pour \xAB {name} \xBB ?",
      body: "L\u2019organisation retrouve l\u2019\xE9tat qu\u2019elle avait avant la demande.",
      confirm: "Retirer la demande",
      keep: "Garder la demande",
      done: "Demande retir\xE9e."
    },
    zone: {
      title: "Supprimer l\u2019organisation",
      description: "D\xE9finitif, et d\xE9cid\xE9 par deux administrateurs.",
      pendingTitle: "Suppression demand\xE9e",
      pendingBody: "Demand\xE9e par {name}, le",
      openRequests: "Voir les demandes de suppression",
      request: "Demander la suppression",
      what: {
        data: "Toutes les donn\xE9es et tous les fichiers de l\u2019organisation sont effac\xE9s.",
        accounts: "Les comptes qui n\u2019appartiennent qu\u2019\xE0 elle sont supprim\xE9s ; les autres restent.",
        suspended: "D\xE8s la demande, l\u2019organisation est suspendue (lecture seule pour ses membres).",
        fourEyes: "Un autre administrateur doit approuver ; vous pouvez retirer votre demande d\u2019ici l\xE0."
      }
    },
    request: {
      title: "Demander la suppression de \xAB {name} \xBB",
      body: "L\u2019organisation sera suspendue tout de suite. Ses donn\xE9es ne seront supprim\xE9es que lorsqu\u2019un autre administrateur aura approuv\xE9.",
      confirm: "Demander la suppression",
      confirmLabel: "Raison sociale de l\u2019organisation",
      confirmHint: "Recopiez {name} pour confirmer.",
      done: "Demande envoy\xE9e : un autre administrateur doit l\u2019approuver."
    }
  }
};

// locales/ar/observations.json
var observations_default = {
  kinds: {
    observation: "\u0645\u0644\u0627\u062D\u0638\u0629",
    reserve: "\u062A\u062D\u0641\u0651\u0638"
  },
  statuses: {
    open: "\u0645\u0641\u062A\u0648\u062D",
    liftedReserve: "\u0645\u0631\u0641\u0648\u0639",
    dealtWith: "\u062A\u0645\u062A \u0627\u0644\u0645\u0639\u0627\u0644\u062C\u0629"
  },
  noDueDate: "\u0628\u0644\u0627 \u0623\u062C\u0644",
  overdue: "\u0645\u062A\u0623\u062E\u0631",
  page: "\u0627\u0644\u0635\u0641\u062D\u0629 {page}",
  planLinkLabel: "\u0641\u062A\u062D \u0627\u0644\u0645\u062E\u0637\u0637 {plan} \u0641\u064A \u0627\u0644\u0635\u0641\u062D\u0629 {page} ({number})",
  photoAlt: "\u0635\u0648\u0631\u0629: {name}",
  openPhotoLabel: "\u0641\u062A\u062D \u0627\u0644\u0635\u0648\u0631\u0629 {name}",
  photos: {
    keptLabel: "\u0627\u0644\u0635\u0648\u0631 \u0627\u0644\u0645\u0631\u0641\u0642\u0629 \u0633\u0627\u0628\u0642\u064B\u0627",
    removeLabel: "\u0625\u0632\u0627\u0644\u0629 \u0627\u0644\u0635\u0648\u0631\u0629 {name}",
    input: "\u0627\u062E\u062A\u064A\u0627\u0631 \u0635\u0648\u0631",
    add: "\u0625\u0636\u0627\u0641\u0629 \u0635\u0648\u0631",
    preparing: "\u062C\u0627\u0631\u064D \u062A\u062C\u0647\u064A\u0632 \u0627\u0644\u0645\u062C\u0644\u062F\u2026",
    full: "\u0627\u0644\u062D\u062F \u0627\u0644\u0623\u0642\u0635\u0649 {max} \u0635\u0648\u0631.",
    folderFailed: "\u062A\u0639\u0630\u0651\u0631 \u062A\u062C\u0647\u064A\u0632 \u0645\u062C\u0644\u062F \xABPhotos de chantier\xBB. \u062A\u062D\u0642\u0642 \u0645\u0646 \u0627\u062A\u0635\u0627\u0644\u0643 \u062B\u0645 \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629."
  },
  tab: {
    title: "\u0627\u0644\u0645\u0644\u0627\u062D\u0638\u0627\u062A \u0648\u0627\u0644\u062A\u062D\u0641\u0651\u0638\u0627\u062A",
    new: "\u0645\u0644\u0627\u062D\u0638\u0629 \u062C\u062F\u064A\u062F\u0629",
    intro: "\u0627\u0644\u0645\u0644\u0627\u062D\u0638\u0627\u062A \u0648\u0627\u0644\u062A\u062D\u0641\u0651\u0638\u0627\u062A \u0627\u0644\u0645\u0633\u062C\u064E\u0651\u0644\u0629 \u0641\u064A \u0627\u0644\u0648\u0631\u0634\u0629: \u0645\u0643\u0627\u0646\u0647\u0627\u060C \u0648\u0645\u0646 \u064A\u0639\u0627\u0644\u062C\u0647\u0627\u060C \u0648\u0641\u064A \u0623\u064A \u0623\u062C\u0644. \u0644\u0627 \u064A\u064F\u0631\u0641\u0639 \u0627\u0644\u062A\u062D\u0641\u0651\u0638 \u0625\u0644\u0627 \u0628\u0635\u0648\u0631\u0629 \u0625\u062B\u0628\u0627\u062A\u060C \u0648\u064A\u0633\u0631\u062F \u0645\u062D\u0636\u0631 \u0627\u0644\u0627\u0633\u062A\u0644\u0627\u0645 \u0627\u0644\u062A\u062D\u0641\u0651\u0638\u0627\u062A \u0627\u0644\u062A\u064A \u0645\u0627 \u0632\u0627\u0644\u062A \u0645\u0641\u062A\u0648\u062D\u0629.",
    loadFailedTitle: "\u062A\u0639\u0630\u0651\u0631 \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0645\u0644\u0627\u062D\u0638\u0627\u062A",
    loadFailedBody: "\u062A\u062D\u0642\u0642 \u0645\u0646 \u0627\u062A\u0635\u0627\u0644\u0643 \u062B\u0645 \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629.",
    empty: {
      title: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0645\u0644\u0627\u062D\u0638\u0627\u062A \u0628\u0639\u062F",
      body: "\u0633\u062C\u0651\u0644 \u0645\u0644\u0627\u062D\u0638\u0629 \u0623\u0648 \u062A\u062D\u0641\u0651\u0638\u064B\u0627 \u0644\u0627\u062D\u0638\u062A\u0647 \u0641\u064A \u0627\u0644\u0648\u0631\u0634\u0629. \u0644\u062A\u062B\u0628\u064A\u062A\u0647 \u0639\u0644\u0649 \u0645\u062E\u0637\u0637\u060C \u0627\u0641\u062A\u062D \u0627\u0644\u0645\u062E\u0637\u0637 \u0645\u0646 \u0627\u0644\u0645\u0644\u0641\u0627\u062A \u0648\u0627\u0633\u062A\u0639\u0645\u0644 \u0623\u062F\u0627\u0629 \u0627\u0644\u0645\u0644\u0627\u062D\u0638\u0629.",
      bodyNoRights: "\u0644\u0645 \u062A\u064F\u0633\u062C\u064E\u0651\u0644 \u0623\u064A \u0645\u0644\u0627\u062D\u0638\u0629 \u0639\u0644\u0649 \u0647\u0630\u0627 \u0627\u0644\u0645\u0634\u0631\u0648\u0639 \u0628\u0639\u062F.",
      filteredTitle: "\u0644\u0627 \u0646\u062A\u0627\u0626\u062C",
      filteredBody: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0645\u0644\u0627\u062D\u0638\u0629 \u062A\u0637\u0627\u0628\u0642 \u0647\u0630\u0647 \u0627\u0644\u0645\u0631\u0634\u062D\u0627\u062A.",
      clear: "\u0645\u0633\u062D \u0627\u0644\u0645\u0631\u0634\u062D\u0627\u062A"
    }
  },
  filters: {
    label: "\u0645\u0631\u0634\u062D\u0627\u062A \u0627\u0644\u0645\u0644\u0627\u062D\u0638\u0627\u062A",
    search: "\u0627\u0644\u0628\u062D\u062B \u0641\u064A \u0627\u0644\u0645\u0644\u0627\u062D\u0638\u0627\u062A",
    searchPlaceholder: "\u0628\u062D\u062B",
    kind: "\u062A\u0635\u0641\u064A\u0629 \u062D\u0633\u0628 \u0627\u0644\u0646\u0648\u0639",
    allKinds: "\u0643\u0644 \u0627\u0644\u0623\u0646\u0648\u0627\u0639",
    status: "\u062A\u0635\u0641\u064A\u0629 \u062D\u0633\u0628 \u0627\u0644\u062D\u0627\u0644\u0629",
    allStatuses: "\u0643\u0644 \u0627\u0644\u062D\u0627\u0644\u0627\u062A",
    statuses: {
      open: "\u0627\u0644\u0645\u0641\u062A\u0648\u062D\u0629",
      resolved: "\u0627\u0644\u0645\u0631\u0641\u0648\u0639\u0629 \u0623\u0648 \u0627\u0644\u0645\u0639\u0627\u0644\u064E\u062C\u0629"
    },
    lot: "\u062A\u0635\u0641\u064A\u0629 \u062D\u0633\u0628 \u0627\u0644\u062D\u0635\u0629",
    lotPlaceholder: "\u0627\u0644\u062D\u0635\u0629 (\u0627\u0644\u0627\u0633\u0645 \u0627\u0644\u062F\u0642\u064A\u0642)",
    overdue: "\u0627\u0644\u0645\u062A\u0623\u062E\u0631\u0629"
  },
  table: {
    scrollLabel: "\u0627\u0644\u0645\u0644\u0627\u062D\u0638\u0627\u062A \u0648\u0627\u0644\u062A\u062D\u0641\u0651\u0638\u0627\u062A (\u062A\u0645\u0631\u064A\u0631 \u0623\u0641\u0642\u064A)",
    label: "\u0645\u0644\u0627\u062D\u0638\u0627\u062A \u0627\u0644\u0645\u0634\u0631\u0648\u0639 \u0648\u062A\u062D\u0641\u0651\u0638\u0627\u062A\u0647",
    columns: {
      number: "\u0627\u0644\u0631\u0642\u0645",
      status: "\u0627\u0644\u062D\u0627\u0644\u0629",
      description: "\u0627\u0644\u0648\u0635\u0641",
      kind: "\u0627\u0644\u0646\u0648\u0639",
      lot: "\u0627\u0644\u062D\u0635\u0629",
      contractor: "\u0627\u0644\u0645\u0642\u0627\u0648\u0644",
      dueOn: "\u0627\u0644\u0623\u062C\u0644",
      plan: "\u0627\u0644\u0645\u062E\u0637\u0637",
      photos: "\u0627\u0644\u0635\u0648\u0631"
    },
    openLabel: "\u0641\u062A\u062D {number}: {description}",
    none: "\u063A\u064A\u0631 \u0645\u062D\u062F\u062F",
    photosUnit: "\u0635\u0648\u0631",
    truncated: "\u062A\u064F\u0639\u0631\u0636 \u0623\u062D\u062F\u062B 200 \u0645\u0644\u0627\u062D\u0638\u0629. \u0627\u0633\u062A\u0639\u0645\u0644 \u0627\u0644\u0645\u0631\u0634\u062D\u0627\u062A \u0644\u0639\u0631\u0636 \u0627\u0644\u0628\u0642\u064A\u0629."
  },
  form: {
    createTitle: "\u0645\u0644\u0627\u062D\u0638\u0629 \u062C\u062F\u064A\u062F\u0629",
    editTitle: "\u062A\u0639\u062F\u064A\u0644 \u0627\u0644\u0645\u0644\u0627\u062D\u0638\u0629",
    kind: "\u0627\u0644\u0646\u0648\u0639",
    description: "\u0627\u0644\u0648\u0635\u0641",
    descriptionHint: "\u0645\u0627 \u0644\u0648\u062D\u0638\u060C \u0641\u064A \u0628\u0636\u0639 \u0643\u0644\u0645\u0627\u062A.",
    descriptionHintReserve: "\u0627\u0644\u0639\u064A\u0628 \u0627\u0644\u0648\u0627\u062C\u0628 \u0625\u0635\u0644\u0627\u062D\u0647\u060C \u0641\u064A \u0628\u0636\u0639 \u0643\u0644\u0645\u0627\u062A: \u0633\u064A\u0638\u0647\u0631 \u0641\u064A \u0645\u062D\u0636\u0631 \u0627\u0644\u0627\u0633\u062A\u0644\u0627\u0645.",
    lot: "\u0627\u0644\u062D\u0635\u0629",
    lotHint: "\u0645\u062B\u0627\u0644: \u0627\u0644\u0623\u0634\u063A\u0627\u0644 \u0627\u0644\u0643\u0628\u0631\u0649.",
    contractor: "\u0627\u0644\u0645\u0642\u0627\u0648\u0644",
    dueOn: "\u064A\u064F\u0639\u0627\u0644\u064E\u062C \u0642\u0628\u0644",
    photos: "\u0627\u0644\u0635\u0648\u0631",
    photosHint: "\u062D\u062A\u0649 10 \u0635\u0648\u0631 \u0645\u0646 \u0627\u0644\u0648\u0631\u0634\u0629 (JPEG \u0623\u0648 PNG \u0623\u0648 WebP \u0623\u0648 HEIC).",
    placed: "\u0645\u062B\u0628\u064E\u0651\u062A\u0629 \u0639\u0644\u0649 {plan}\u060C \u0627\u0644\u0635\u0641\u062D\u0629 {page}.",
    removePoint: "\u0625\u0632\u0627\u0644\u0629 \u0627\u0644\u0646\u0642\u0637\u0629",
    photosBusy: "\u0645\u0627 \u0632\u0627\u0644\u062A \u0628\u0639\u0636 \u0627\u0644\u0635\u0648\u0631 \u0642\u064A\u062F \u0627\u0644\u0625\u0631\u0633\u0627\u0644. \u0627\u0646\u062A\u0638\u0631 \u062B\u0648\u0627\u0646\u064A\u064E \u062B\u0645 \u0627\u062D\u0641\u0638.",
    saving: "\u062C\u0627\u0631\u064D \u0627\u0644\u062D\u0641\u0638\u2026",
    create: "\u062D\u0641\u0638",
    save: "\u062D\u0641\u0638 \u0627\u0644\u062A\u0639\u062F\u064A\u0644\u0627\u062A",
    created: "\u062A\u0645 \u062D\u0641\u0638 {number}.",
    updated: "\u062A\u0645 \u062A\u062D\u062F\u064A\u062B {number}.",
    errors: {
      descriptionRequired: "\u0635\u0650\u0641 \u0645\u0627 \u0644\u0648\u062D\u0638.",
      descriptionTooLong: "\u0644\u0627 \u064A\u0645\u0643\u0646 \u0623\u0646 \u064A\u062A\u062C\u0627\u0648\u0632 \u0627\u0644\u0648\u0635\u0641 {max} \u062D\u0631\u0641\u064B\u0627.",
      tooLong: "\u0644\u0627 \u064A\u0645\u0643\u0646 \u0623\u0646 \u064A\u062A\u062C\u0627\u0648\u0632 \u0647\u0630\u0627 \u0627\u0644\u062D\u0642\u0644 {max} \u062D\u0631\u0641\u064B\u0627."
    }
  },
  resolve: {
    titleReserve: "\u0631\u0641\u0639 \u0627\u0644\u062A\u062D\u0641\u0651\u0638 {number}",
    titleObservation: "\u0648\u0633\u0645 {number} \u0628\u0623\u0646\u0647\u0627 \u0645\u0639\u0627\u0644\u064E\u062C\u0629",
    introReserve: "\u064A\u064F\u0631\u0641\u0639 \u0627\u0644\u062A\u062D\u0641\u0651\u0638 \u0628\u0635\u0648\u0631\u0629 \u0648\u0627\u062D\u062F\u0629 \u0639\u0644\u0649 \u0627\u0644\u0623\u0642\u0644 \u062A\u064F\u062B\u0628\u062A \u0625\u0635\u0644\u0627\u062D \u0627\u0644\u0639\u064A\u0628. \u062B\u0645 \u064A\u062E\u0631\u062C \u0645\u0646 \u0642\u0627\u0626\u0645\u0629 \u0645\u062D\u0636\u0631 \u0627\u0644\u0627\u0633\u062A\u0644\u0627\u0645.",
    introObservation: "\u0623\u0636\u0641 \u0635\u0648\u0631\u0629 \u0623\u0648 \u0645\u0644\u0627\u062D\u0638\u0629 \u0625\u0646 \u0643\u0627\u0646 \u0630\u0644\u0643 \u064A\u0641\u064A\u062F \u0641\u064A \u062D\u0641\u0638 \u0623\u062B\u0631 \u0627\u0644\u0645\u0639\u0627\u0644\u062C\u0629.",
    photosRequired: "\u0635\u0648\u0631 \u0627\u0644\u0625\u062B\u0628\u0627\u062A (\u0625\u0644\u0632\u0627\u0645\u064A)",
    photos: "\u0627\u0644\u0635\u0648\u0631 (\u0627\u062E\u062A\u064A\u0627\u0631\u064A)",
    photosHint: "\u0635\u0648\u0651\u0631 \u0627\u0644\u0639\u064A\u0628 \u0628\u0639\u062F \u0625\u0635\u0644\u0627\u062D\u0647.",
    note: "\u0645\u0644\u0627\u062D\u0638\u0629 (\u0627\u062E\u062A\u064A\u0627\u0631\u064A)",
    evidenceRequired: "\u0623\u0636\u0641 \u0635\u0648\u0631\u0629 \u0648\u0627\u062D\u062F\u0629 \u0639\u0644\u0649 \u0627\u0644\u0623\u0642\u0644 \u062A\u064F\u062B\u0628\u062A \u0631\u0641\u0639 \u0627\u0644\u062A\u062D\u0641\u0651\u0638.",
    saving: "\u062C\u0627\u0631\u064D \u0627\u0644\u062D\u0641\u0638\u2026",
    submitReserve: "\u0631\u0641\u0639 \u0627\u0644\u062A\u062D\u0641\u0651\u0638",
    submitObservation: "\u0648\u0633\u0645 \u0628\u0623\u0646\u0647\u0627 \u0645\u0639\u0627\u0644\u064E\u062C\u0629",
    doneReserve: "\u062A\u0645 \u0631\u0641\u0639 \u0627\u0644\u062A\u062D\u0641\u0651\u0638 {number}.",
    doneObservation: "\u062A\u0645\u062A \u0645\u0639\u0627\u0644\u062C\u0629 \u0627\u0644\u0645\u0644\u0627\u062D\u0638\u0629 {number}."
  },
  reopen: {
    title: "\u0625\u0639\u0627\u062F\u0629 \u0641\u062A\u062D {number}",
    intro: "\u064A\u064F\u062D\u0641\u0638 \u0627\u0644\u0633\u0628\u0628 \u0641\u064A \u0633\u062C\u0644\u0651 \u0627\u0644\u0645\u0634\u0631\u0648\u0639.",
    reason: "\u0627\u0644\u0633\u0628\u0628",
    reasonRequired: "\u0627\u0630\u0643\u0631 \u0633\u0628\u0628 \u0625\u0639\u0627\u062F\u0629 \u0627\u0644\u0641\u062A\u062D.",
    saving: "\u062C\u0627\u0631\u064D \u0625\u0639\u0627\u062F\u0629 \u0627\u0644\u0641\u062A\u062D\u2026",
    submit: "\u0625\u0639\u0627\u062F\u0629 \u0627\u0644\u0641\u062A\u062D",
    done: "\u0623\u064F\u0639\u064A\u062F \u0641\u062A\u062D {number}."
  },
  drawer: {
    title: {
      observation: "\u0627\u0644\u0645\u0644\u0627\u062D\u0638\u0629 {number}",
      reserve: "\u0627\u0644\u062A\u062D\u0641\u0651\u0638 {number}"
    },
    titleLoading: "\u0645\u0644\u0627\u062D\u0638\u0629",
    readOnly: "\u064A\u0645\u0643\u0646\u0643 \u0627\u0644\u0627\u0637\u0644\u0627\u0639 \u0639\u0644\u0649 \u0647\u0630\u0647 \u0627\u0644\u0645\u0644\u0627\u062D\u0638\u0629 \u062F\u0648\u0646 \u062A\u0639\u062F\u064A\u0644\u0647\u0627.",
    lot: "\u0627\u0644\u062D\u0635\u0629",
    contractor: "\u0627\u0644\u0645\u0642\u0627\u0648\u0644",
    dueOn: "\u0627\u0644\u0623\u062C\u0644",
    plan: "\u0627\u0644\u0645\u062E\u0637\u0637",
    noPlan: "\u063A\u064A\u0631 \u0645\u062B\u0628\u064E\u0651\u062A\u0629 \u0639\u0644\u0649 \u0645\u062E\u0637\u0637",
    none: "\u063A\u064A\u0631 \u0645\u062D\u062F\u062F",
    createdBy: "\u0633\u062C\u0651\u0644\u0647\u0627",
    photos: "\u0627\u0644\u0635\u0648\u0631 ({count})",
    noPhotos: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0635\u0648\u0631",
    liftedTitle: "\u062A\u062D\u0641\u0651\u0638 \u0645\u0631\u0641\u0648\u0639",
    dealtTitle: "\u0645\u0644\u0627\u062D\u0638\u0629 \u0645\u0639\u0627\u0644\u064E\u062C\u0629",
    resolvedBy: "\u0628\u0648\u0627\u0633\u0637\u0629 {name}",
    lift: "\u0631\u0641\u0639 \u0627\u0644\u062A\u062D\u0641\u0651\u0638",
    deal: "\u0648\u0633\u0645 \u0628\u0623\u0646\u0647\u0627 \u0645\u0639\u0627\u0644\u064E\u062C\u0629",
    reopen: "\u0625\u0639\u0627\u062F\u0629 \u0627\u0644\u0641\u062A\u062D",
    edit: "\u062A\u0639\u062F\u064A\u0644",
    delete: "\u062D\u0630\u0641",
    notFoundTitle: "\u0627\u0644\u0645\u0644\u0627\u062D\u0638\u0629 \u063A\u064A\u0631 \u0645\u0648\u062C\u0648\u062F\u0629",
    notFoundBody: "\u062D\u064F\u0630\u0641\u062A \u0623\u0648 \u0644\u0645 \u064A\u0639\u062F \u0628\u0625\u0645\u0643\u0627\u0646\u0643 \u0627\u0644\u0648\u0635\u0648\u0644 \u0625\u0644\u064A\u0647\u0627.",
    loadFailedTitle: "\u062A\u0639\u0630\u0651\u0631 \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0645\u0644\u0627\u062D\u0638\u0629",
    loadFailedBody: "\u062A\u062D\u0642\u0642 \u0645\u0646 \u0627\u062A\u0635\u0627\u0644\u0643 \u062B\u0645 \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629."
  },
  delete: {
    title: "\u062D\u0630\u0641 {number}\u061F",
    body: "\u0633\u062A\u064F\u062D\u0630\u0641 \u0647\u0630\u0647 \u0627\u0644\u0645\u0644\u0627\u062D\u0638\u0629: {description}",
    done: "\u062A\u0645 \u062D\u0630\u0641 {number}."
  },
  errors: {
    OBSERVATION_ID_TAKEN: "\u0647\u0630\u0627 \u0627\u0644\u0645\u0639\u0631\u0651\u0641 \u0645\u0633\u062A\u0639\u0645\u0644 \u0641\u064A \u0645\u0644\u0627\u062D\u0638\u0629 \u0623\u062E\u0631\u0649. \u0623\u063A\u0644\u0642 \u0627\u0644\u0646\u0627\u0641\u0630\u0629 \u0648\u0627\u0628\u062F\u0623 \u0645\u0646 \u062C\u062F\u064A\u062F.",
    OBSERVATION_ANCHOR_INVALID: "\u0644\u0627 \u064A\u0645\u0643\u0646 \u0627\u0633\u062A\u0639\u0645\u0627\u0644 \u0647\u0630\u0627 \u0627\u0644\u0645\u062E\u0637\u0637 \u0623\u0648 \u0647\u0630\u0647 \u0627\u0644\u0635\u0641\u062D\u0629 \u0623\u0648 \u0647\u0630\u0647 \u0627\u0644\u0646\u0642\u0637\u0629. \u0627\u062E\u062A\u0631 \u0645\u062E\u0637\u0637\u064B\u0627 \u0645\u0646 \u0647\u0630\u0627 \u0627\u0644\u0645\u0634\u0631\u0648\u0639 \u064A\u0645\u0643\u0646\u0643 \u0641\u062A\u062D\u0647.",
    OBSERVATION_PHOTO_INVALID: "\u0644\u0627 \u064A\u0645\u0643\u0646 \u0627\u0633\u062A\u0639\u0645\u0627\u0644 \u0635\u0648\u0631\u0629: \u064A\u062C\u0628 \u0623\u0646 \u062A\u0643\u0648\u0646 \u0635\u0648\u0631\u0629 \u0645\u0646 \u0647\u0630\u0627 \u0627\u0644\u0645\u0634\u0631\u0648\u0639 \u064A\u0645\u0643\u0646\u0643 \u0641\u062A\u062D\u0647\u0627.",
    OBSERVATION_NOT_OPEN: "\u0647\u0630\u0647 \u0627\u0644\u0645\u0644\u0627\u062D\u0638\u0629 \u0645\u0631\u0641\u0648\u0639\u0629 \u0623\u0648 \u0645\u0639\u0627\u0644\u064E\u062C\u0629. \u0623\u0639\u062F \u0641\u062A\u062D\u0647\u0627 \u0642\u0628\u0644 \u062A\u0639\u062F\u064A\u0644\u0647\u0627.",
    OBSERVATION_NOT_RESOLVED: "\u0647\u0630\u0647 \u0627\u0644\u0645\u0644\u0627\u062D\u0638\u0629 \u063A\u064A\u0631 \u0645\u0631\u0641\u0648\u0639\u0629: \u0644\u0627 \u0634\u064A\u0621 \u0644\u0625\u0639\u0627\u062F\u0629 \u0641\u062A\u062D\u0647.",
    OBSERVATION_IN_REPORT: "\u064A\u0633\u0631\u062F \u0645\u062D\u0636\u0631 \u0627\u0633\u062A\u0644\u0627\u0645 \u0647\u0630\u0647 \u0627\u0644\u0645\u0644\u0627\u062D\u0638\u0629 \u0641\u062A\u062D\u062A\u0641\u0638 \u0628\u0631\u0642\u0645\u0647\u0627. \u0627\u0631\u0641\u0639\u0647\u0627 \u0628\u062F\u0644 \u062D\u0630\u0641\u0647\u0627.",
    RECEPTION_REPORT_NOT_READY: "\u0645\u0644\u0641 PDF \u0644\u0647\u0630\u0627 \u0627\u0644\u0645\u062D\u0636\u0631 \u0642\u064A\u062F \u0627\u0644\u062A\u062C\u0647\u064A\u0632. \u0633\u064A\u0643\u0648\u0646 \u0645\u062A\u0627\u062D\u064B\u0627 \u0628\u0639\u062F \u0644\u062D\u0638\u0627\u062A.",
    PROJECT_ARCHIVED: "\u0647\u0630\u0627 \u0627\u0644\u0645\u0634\u0631\u0648\u0639 \u0645\u0624\u0631\u0634\u0641: \u0647\u0648 \u0644\u0644\u0642\u0631\u0627\u0621\u0629 \u0641\u0642\u0637 \u0625\u0644\u0649 \u0623\u0646 \u062A\u062A\u0645 \u0627\u0633\u062A\u0639\u0627\u062F\u062A\u0647.",
    RESERVE_EVIDENCE_REQUIRED: "\u0623\u0636\u0641 \u0635\u0648\u0631\u0629 \u0648\u0627\u062D\u062F\u0629 \u0639\u0644\u0649 \u0627\u0644\u0623\u0642\u0644 \u062A\u064F\u062B\u0628\u062A \u0631\u0641\u0639 \u0627\u0644\u062A\u062D\u0641\u0651\u0638.",
    deleteForbidden: "\u0644\u0627 \u064A\u062D\u0630\u0641 \u0627\u0644\u0645\u0644\u0627\u062D\u0638\u0629 \u0625\u0644\u0627 \u0645\u0646 \u0633\u062C\u0651\u0644\u0647\u0627 \u0623\u0648 \u0645\u0633\u0624\u0648\u0644 \u0639\u0646 \u0627\u0644\u0645\u0634\u0631\u0648\u0639."
  },
  report: {
    action: "\u0625\u0639\u062F\u0627\u062F \u0645\u062D\u0636\u0631 \u0627\u0644\u0627\u0633\u062A\u0644\u0627\u0645",
    title: "\u0625\u0639\u062F\u0627\u062F \u0645\u062D\u0636\u0631 \u0627\u0644\u0627\u0633\u062A\u0644\u0627\u0645",
    intro: "\u064A\u0633\u0631\u062F \u0627\u0644\u0645\u062D\u0636\u0631 \u0627\u0644\u062A\u062D\u0641\u0651\u0638\u0627\u062A \u0627\u0644\u0645\u0641\u062A\u0648\u062D\u0629 \u0644\u062D\u0638\u0629 \u0625\u0639\u062F\u0627\u062F\u0647\u060C \u0648\u0644\u0627 \u064A\u062A\u063A\u064A\u0651\u0631 \u0628\u0639\u062F \u0630\u0644\u0643. \u0625\u0646 \u0631\u064F\u0641\u0639 \u062A\u062D\u0641\u0651\u0638 \u0644\u0627\u062D\u0642\u064B\u0627 \u0641\u0623\u0639\u062F\u0651 \u0645\u062D\u0636\u0631\u064B\u0627 \u062C\u062F\u064A\u062F\u064B\u0627.",
    counting: "\u062C\u0627\u0631\u064D \u0639\u062F\u0651 \u0627\u0644\u062A\u062D\u0641\u0651\u0638\u0627\u062A \u0627\u0644\u0645\u0641\u062A\u0648\u062D\u0629\u2026",
    count: "\u0627\u0644\u062A\u062D\u0641\u0651\u0638\u0627\u062A \u0627\u0644\u0645\u0641\u062A\u0648\u062D\u0629 \u0627\u0644\u0645\u062F\u0631\u062C\u0629 \u0641\u064A \u0627\u0644\u0645\u062D\u0636\u0631: {number}",
    countMore: "\u0627\u0644\u062A\u062D\u0641\u0651\u0638\u0627\u062A \u0627\u0644\u0645\u0641\u062A\u0648\u062D\u0629 \u0627\u0644\u0645\u062F\u0631\u062C\u0629 \u0641\u064A \u0627\u0644\u0645\u062D\u0636\u0631: {number} \u0623\u0648 \u0623\u0643\u062B\u0631",
    countFailed: "\u0639\u062F\u062F \u0627\u0644\u062A\u062D\u0641\u0651\u0638\u0627\u062A \u0627\u0644\u0645\u0641\u062A\u0648\u062D\u0629 \u063A\u064A\u0631 \u0645\u062A\u0627\u062D. \u0633\u064A\u0633\u0631\u062F\u0647\u0627 \u0627\u0644\u0645\u062D\u0636\u0631 \u0645\u0639 \u0630\u0644\u0643.",
    heldOn: "\u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0627\u0633\u062A\u0644\u0627\u0645",
    dateRequired: "\u0623\u062F\u062E\u0644 \u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0627\u0633\u062A\u0644\u0627\u0645.",
    location: "\u0627\u0644\u0645\u0643\u0627\u0646",
    language: "\u0644\u063A\u0629 \u0627\u0644\u0645\u062D\u0636\u0631",
    languageHint: "\u0627\u0644\u0644\u063A\u0629 \u0627\u0644\u062A\u064A \u064A\u064F\u062D\u0631\u064E\u0651\u0631 \u0628\u0647\u0627 \u0645\u0644\u0641 PDF.",
    languages: {
      fr: "\u0627\u0644\u0641\u0631\u0646\u0633\u064A\u0629",
      ar: "\u0627\u0644\u0639\u0631\u0628\u064A\u0629",
      en: "\u0627\u0644\u0625\u0646\u062C\u0644\u064A\u0632\u064A\u0629"
    },
    notes: "\u0645\u0644\u0627\u062D\u0638\u0627\u062A",
    creating: "\u062C\u0627\u0631\u064D \u0627\u0644\u0625\u0646\u0634\u0627\u0621\u2026",
    create: "\u0625\u0639\u062F\u0627\u062F \u0627\u0644\u0645\u062D\u0636\u0631",
    created: "\u0627\u0644\u0645\u062D\u0636\u0631 {number} \u0642\u064A\u062F \u0627\u0644\u062A\u062C\u0647\u064A\u0632."
  },
  reports: {
    title: "\u0645\u062D\u0627\u0636\u0631 \u0627\u0644\u0627\u0633\u062A\u0644\u0627\u0645",
    intro: "\u0627\u0644\u0645\u062D\u0627\u0636\u0631 \u0627\u0644\u0645\u0639\u062F\u0651\u0629 \u0644\u0647\u0630\u0627 \u0627\u0644\u0645\u0634\u0631\u0648\u0639\u060C \u0645\u0639 \u0627\u0644\u062A\u062D\u0641\u0651\u0638\u0627\u062A \u0627\u0644\u062A\u064A \u0643\u0627\u0646\u062A \u0645\u0641\u062A\u0648\u062D\u0629 \u0641\u064A \u0643\u0644 \u062A\u0627\u0631\u064A\u062E.",
    pendingNotice: "\u0645\u062D\u0636\u0631 \u0642\u064A\u062F \u0627\u0644\u062A\u062C\u0647\u064A\u0632: \u062A\u062A\u062D\u062F\u0651\u062B \u0627\u0644\u0642\u0627\u0626\u0645\u0629 \u062A\u0644\u0642\u0627\u0626\u064A\u064B\u0627.",
    loadFailed: "\u062A\u0639\u0630\u0651\u0631 \u062A\u062D\u0645\u064A\u0644 \u0645\u062D\u0627\u0636\u0631 \u0627\u0644\u0627\u0633\u062A\u0644\u0627\u0645. \u062A\u062D\u0642\u0642 \u0645\u0646 \u0627\u062A\u0635\u0627\u0644\u0643 \u062B\u0645 \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629.",
    empty: {
      title: "\u0644\u0627 \u064A\u0648\u062C\u062F \u0645\u062D\u0636\u0631 \u0627\u0633\u062A\u0644\u0627\u0645 \u0628\u0639\u062F",
      body: "\u0639\u0646\u062F\u0645\u0627 \u064A\u0642\u062A\u0631\u0628 \u0627\u0644\u0627\u0633\u062A\u0644\u0627\u0645\u060C \u0623\u0639\u062F\u0651 \u0645\u062D\u0636\u0631\u064B\u0627: \u064A\u0633\u0631\u062F \u0627\u0644\u062A\u062D\u0641\u0651\u0638\u0627\u062A \u0627\u0644\u062A\u064A \u0645\u0627 \u0632\u0627\u0644\u062A \u0645\u0641\u062A\u0648\u062D\u0629.",
      bodyNoRights: "\u0644\u0627 \u064A\u0639\u062F\u0651 \u0645\u062D\u0636\u0631 \u0627\u0644\u0627\u0633\u062A\u0644\u0627\u0645 \u0625\u0644\u0627 \u0645\u0633\u0624\u0648\u0644 \u0639\u0646 \u0627\u0644\u0645\u0634\u0631\u0648\u0639."
    },
    scrollLabel: "\u0645\u062D\u0627\u0636\u0631 \u0627\u0644\u0627\u0633\u062A\u0644\u0627\u0645 (\u062A\u0645\u0631\u064A\u0631 \u0623\u0641\u0642\u064A)",
    tableLabel: "\u0645\u062D\u0627\u0636\u0631 \u0627\u0633\u062A\u0644\u0627\u0645 \u0627\u0644\u0645\u0634\u0631\u0648\u0639",
    columns: {
      number: "\u0627\u0644\u0645\u062D\u0636\u0631",
      pdf: "\u0627\u0644\u0648\u062B\u064A\u0642\u0629",
      heldOn: "\u0627\u0644\u0627\u0633\u062A\u0644\u0627\u0645 \u0628\u062A\u0627\u0631\u064A\u062E",
      reserves: "\u0627\u0644\u062A\u062D\u0641\u0651\u0638\u0627\u062A",
      location: "\u0627\u0644\u0645\u0643\u0627\u0646",
      language: "\u0627\u0644\u0644\u063A\u0629",
      actions: "\u0627\u0644\u0625\u062C\u0631\u0627\u0621\u0627\u062A"
    },
    pdf: {
      ready: "PDF \u062C\u0627\u0647\u0632",
      pending: "\u0642\u064A\u062F \u0627\u0644\u062A\u062C\u0647\u064A\u0632"
    },
    noLocation: "\u063A\u064A\u0631 \u0645\u062D\u062F\u062F",
    download: "\u062A\u0646\u0632\u064A\u0644",
    downloadLabel: "\u062A\u0646\u0632\u064A\u0644 \u0645\u0644\u0641 PDF \u0644\u0644\u0645\u062D\u0636\u0631 {number}",
    notReadyLabel: "\u0645\u0644\u0641 PDF \u0644\u0644\u0645\u062D\u0636\u0631 {number} \u0642\u064A\u062F \u0627\u0644\u062A\u062C\u0647\u064A\u0632"
  },
  viewerTool: {
    label: "\u0645\u0644\u0627\u062D\u0638\u0629",
    announce: {
      active: "\u0623\u062F\u0627\u0629 \u0627\u0644\u0645\u0644\u0627\u062D\u0638\u0629 \u0645\u0641\u0639\u0651\u0644\u0629. \u0627\u0646\u0642\u0631 \u0639\u0644\u0649 \u0627\u0644\u0645\u062E\u0637\u0637\u060C \u0623\u0648 \u0627\u0633\u062A\u0639\u0645\u0644 \u0627\u0644\u0623\u0633\u0647\u0645 \u062B\u0645 Enter \u0644\u0648\u0636\u0639 \u0627\u0644\u0646\u0642\u0637\u0629.",
      placed: "\u0648\u064F\u0636\u0639\u062A {number} \u0639\u0644\u0649 \u0627\u0644\u0645\u062E\u0637\u0637."
    },
    marker: "{kind} {number}: {description}\u060C {status}",
    surface: "\u0627\u0644\u0635\u0641\u062D\u0629 {page}: \u0648\u0636\u0639 \u0645\u0644\u0627\u062D\u0638\u0629. \u0627\u0646\u0642\u0631\u060C \u0623\u0648 \u062D\u0631\u0651\u0643 \u0627\u0644\u0645\u0624\u0634\u0631 \u0628\u0627\u0644\u0623\u0633\u0647\u0645 (Shift \u0644\u0644\u062A\u0633\u0631\u064A\u0639) \u062B\u0645 \u0627\u0636\u063A\u0637 Enter. Escape \u0644\u0644\u062E\u0631\u0648\u062C."
  }
};

// locales/en/observations.json
var observations_default2 = {
  kinds: {
    observation: "Observation",
    reserve: "Snag"
  },
  statuses: {
    open: "Open",
    liftedReserve: "Lifted",
    dealtWith: "Dealt with"
  },
  noDueDate: "No due date",
  overdue: "Overdue",
  page: "page {page}",
  planLinkLabel: "Open plan {plan} at page {page} ({number})",
  photoAlt: "Photo: {name}",
  openPhotoLabel: "Open photo {name}",
  photos: {
    keptLabel: "Photos already attached",
    removeLabel: "Remove photo {name}",
    input: "Choose photos",
    add: "Add photos",
    preparing: "Preparing the folder\u2026",
    full: "At most {max} photos.",
    folderFailed: 'The "Photos de chantier" folder could not be prepared. Check your connection and try again.'
  },
  tab: {
    title: "Observations and snags",
    new: "New observation",
    intro: "The remarks and snags noted on site: where they are, who must deal with them, by when. A snag is lifted only with an evidence photo; the reception report lists the snags still open.",
    loadFailedTitle: "The observations could not be loaded",
    loadFailedBody: "Check your connection and try again.",
    empty: {
      title: "No observation yet",
      body: "Note a remark or a snag found on site. To pin it on a plan, open the plan in Files and use the Observation tool.",
      bodyNoRights: "No observation has been noted on this project yet.",
      filteredTitle: "No result",
      filteredBody: "No observation matches these filters.",
      clear: "Clear filters"
    }
  },
  filters: {
    label: "Observation filters",
    search: "Search observations",
    searchPlaceholder: "Search",
    kind: "Filter by type",
    allKinds: "All types",
    status: "Filter by status",
    allStatuses: "All statuses",
    statuses: {
      open: "Open",
      resolved: "Lifted or dealt with"
    },
    lot: "Filter by lot",
    lotPlaceholder: "Lot (exact name)",
    overdue: "Overdue"
  },
  table: {
    scrollLabel: "Observations and snags (horizontal scroll)",
    label: "Observations and snags of the project",
    columns: {
      number: "No.",
      status: "Status",
      description: "Description",
      kind: "Type",
      lot: "Lot",
      contractor: "Contractor",
      dueOn: "Due date",
      plan: "Plan",
      photos: "Photos"
    },
    openLabel: "Open {number}: {description}",
    none: "Not set",
    photosUnit: "photo(s)",
    truncated: "The 200 most recent observations are shown. Narrow down with the filters to see the others."
  },
  form: {
    createTitle: "New observation",
    editTitle: "Edit observation",
    kind: "Type",
    description: "Description",
    descriptionHint: "What was noticed, in a few words.",
    descriptionHintReserve: "The defect to fix, in a few words: it appears in the reception report.",
    lot: "Lot",
    lotHint: "For example Structural works.",
    contractor: "Contractor",
    dueOn: "To be dealt with by",
    photos: "Photos",
    photosHint: "Up to 10 site photos (JPEG, PNG, WebP or HEIC).",
    placed: "Pinned on {plan}, page {page}.",
    removePoint: "Remove the point",
    photosBusy: "Some photos are still being sent. Wait a few seconds, then save.",
    saving: "Saving\u2026",
    create: "Save",
    save: "Save changes",
    created: "{number} is saved.",
    updated: "{number} is updated.",
    errors: {
      descriptionRequired: "Describe what was noticed.",
      descriptionTooLong: "The description cannot exceed {max} characters.",
      tooLong: "This field cannot exceed {max} characters."
    }
  },
  resolve: {
    titleReserve: "Lift snag {number}",
    titleObservation: "Mark {number} as dealt with",
    introReserve: "A snag is lifted with at least one photo showing that the defect is fixed. It then leaves the reception report list.",
    introObservation: "Add a photo or a note if it helps to keep a trace of the treatment.",
    photosRequired: "Evidence photos (required)",
    photos: "Photos (optional)",
    photosHint: "Photograph the corrected defect.",
    note: "Note (optional)",
    evidenceRequired: "Add at least one photo showing that the snag is lifted.",
    saving: "Saving\u2026",
    submitReserve: "Lift the snag",
    submitObservation: "Mark as dealt with",
    doneReserve: "Snag {number} is lifted.",
    doneObservation: "Observation {number} is dealt with."
  },
  reopen: {
    title: "Reopen {number}",
    intro: "The reason is kept in the project log.",
    reason: "Reason",
    reasonRequired: "Say why you are reopening it.",
    saving: "Reopening\u2026",
    submit: "Reopen",
    done: "{number} is reopened."
  },
  drawer: {
    title: {
      observation: "Observation {number}",
      reserve: "Snag {number}"
    },
    titleLoading: "Observation",
    readOnly: "You can view this observation but not change it.",
    lot: "Lot",
    contractor: "Contractor",
    dueOn: "Due date",
    plan: "Plan",
    noPlan: "Not pinned on a plan",
    none: "Not set",
    createdBy: "Noted by",
    photos: "Photos ({count})",
    noPhotos: "No photo",
    liftedTitle: "Snag lifted",
    dealtTitle: "Observation dealt with",
    resolvedBy: "By {name}",
    lift: "Lift the snag",
    deal: "Mark as dealt with",
    reopen: "Reopen",
    edit: "Edit",
    delete: "Delete",
    notFoundTitle: "Observation not found",
    notFoundBody: "It was deleted or you no longer have access to it.",
    loadFailedTitle: "The observation could not be loaded",
    loadFailedBody: "Check your connection and try again."
  },
  delete: {
    title: "Delete {number}?",
    body: "This observation will be deleted: {description}",
    done: "{number} is deleted."
  },
  errors: {
    OBSERVATION_ID_TAKEN: "This identifier is already used by another observation. Close the window and start again.",
    OBSERVATION_ANCHOR_INVALID: "This plan, page or point cannot be used. Choose a plan of this project that you can open.",
    OBSERVATION_PHOTO_INVALID: "A photo cannot be used: it must be an image of this project that you can open.",
    OBSERVATION_NOT_OPEN: "This observation is lifted or dealt with. Reopen it before changing it.",
    OBSERVATION_NOT_RESOLVED: "This observation is not lifted: there is nothing to reopen.",
    OBSERVATION_IN_REPORT: "A reception report lists this observation: it keeps its number. Lift it instead of deleting it.",
    RECEPTION_REPORT_NOT_READY: "The PDF of this report is being prepared. It will be available in a moment.",
    PROJECT_ARCHIVED: "This project is archived: it is read-only until it is restored.",
    RESERVE_EVIDENCE_REQUIRED: "Add at least one photo showing that the snag is lifted.",
    deleteForbidden: "Only the author of the observation or a project manager can delete it."
  },
  report: {
    action: "Make the reception report",
    title: "Make the reception report",
    intro: "The report lists the snags still open at the moment you make it. It is not changed afterwards; if a snag is lifted later, make a new report.",
    counting: "Counting the open snags\u2026",
    count: "Open snags listed in the report: {number}",
    countMore: "Open snags listed in the report: {number} or more",
    countFailed: "The number of open snags is unavailable. The report will list them all the same.",
    heldOn: "Date of the reception",
    dateRequired: "Enter the date of the reception.",
    location: "Place",
    language: "Report language",
    languageHint: "The language the PDF is written in.",
    languages: {
      fr: "French",
      ar: "Arabic",
      en: "English"
    },
    notes: "Remarks",
    creating: "Creating\u2026",
    create: "Make the report",
    created: "Report {number} is being prepared."
  },
  reports: {
    title: "Reception reports",
    intro: "The reports made for this project, with the snags that were open on each date.",
    pendingNotice: "A report is being prepared: the list updates by itself.",
    loadFailed: "The reception reports could not be loaded. Check your connection and try again.",
    empty: {
      title: "No reception report yet",
      body: "When the reception comes closer, make a report: it lists the snags still open.",
      bodyNoRights: "Only a project manager can make a reception report."
    },
    scrollLabel: "Reception reports (horizontal scroll)",
    tableLabel: "Reception reports of the project",
    columns: {
      number: "Report",
      pdf: "Document",
      heldOn: "Reception on",
      reserves: "Snags",
      location: "Place",
      language: "Language",
      actions: "Actions"
    },
    pdf: {
      ready: "PDF ready",
      pending: "Being prepared"
    },
    noLocation: "Not set",
    download: "Download",
    downloadLabel: "Download the PDF of report {number}",
    notReadyLabel: "The PDF of report {number} is being prepared"
  },
  viewerTool: {
    label: "Observation",
    announce: {
      active: "Observation tool on. Click the plan, or use the arrow keys then Enter to place the point.",
      placed: "{number} is placed on the plan."
    },
    marker: "{kind} {number}: {description}, {status}",
    surface: "Page {page}: place an observation. Click, or move the crosshair with the arrow keys (Shift to go faster) and press Enter. Escape to leave."
  }
};

// locales/fr/observations.json
var observations_default3 = {
  kinds: {
    observation: "Observation",
    reserve: "R\xE9serve"
  },
  statuses: {
    open: "Ouverte",
    liftedReserve: "Lev\xE9e",
    dealtWith: "Trait\xE9e"
  },
  noDueDate: "Sans \xE9ch\xE9ance",
  overdue: "En retard",
  page: "page {page}",
  planLinkLabel: "Ouvrir le plan {plan} \xE0 la page {page} ({number})",
  photoAlt: "Photo\xA0: {name}",
  openPhotoLabel: "Ouvrir la photo {name}",
  photos: {
    keptLabel: "Photos d\xE9j\xE0 jointes",
    removeLabel: "Retirer la photo {name}",
    input: "Choisir des photos",
    add: "Ajouter des photos",
    preparing: "Pr\xE9paration du dossier\u2026",
    full: "Maximum {max} photos.",
    folderFailed: "Le dossier \xAB\xA0Photos de chantier\xA0\xBB n'a pas pu \xEAtre pr\xE9par\xE9. V\xE9rifiez votre connexion puis r\xE9essayez."
  },
  tab: {
    title: "Observations et r\xE9serves",
    new: "Nouvelle observation",
    intro: "Les remarques et les r\xE9serves relev\xE9es sur le chantier\xA0: o\xF9 elles sont, qui doit les traiter, pour quand. Une r\xE9serve n'est lev\xE9e qu'avec une photo de preuve\xA0; le PV de r\xE9ception liste les r\xE9serves encore ouvertes.",
    loadFailedTitle: "Les observations n'ont pas pu \xEAtre charg\xE9es",
    loadFailedBody: "V\xE9rifiez votre connexion puis r\xE9essayez.",
    empty: {
      title: "Aucune observation pour l'instant",
      body: "Notez une remarque ou une r\xE9serve relev\xE9e sur le chantier. Pour la placer sur un plan, ouvrez le plan dans Fichiers et utilisez l'outil Observation.",
      bodyNoRights: "Aucune observation n'a encore \xE9t\xE9 not\xE9e sur ce projet.",
      filteredTitle: "Aucun r\xE9sultat",
      filteredBody: "Aucune observation ne correspond \xE0 ces filtres.",
      clear: "Effacer les filtres"
    }
  },
  filters: {
    label: "Filtres des observations",
    search: "Rechercher dans les observations",
    searchPlaceholder: "Rechercher",
    kind: "Filtrer par type",
    allKinds: "Tous les types",
    status: "Filtrer par \xE9tat",
    allStatuses: "Tous les \xE9tats",
    statuses: {
      open: "Ouvertes",
      resolved: "Lev\xE9es ou trait\xE9es"
    },
    lot: "Filtrer par lot",
    lotPlaceholder: "Lot (nom exact)",
    overdue: "En retard"
  },
  table: {
    scrollLabel: "Observations et r\xE9serves (d\xE9filement horizontal)",
    label: "Observations et r\xE9serves du projet",
    columns: {
      number: "N\xB0",
      status: "\xC9tat",
      description: "Description",
      kind: "Type",
      lot: "Lot",
      contractor: "Entreprise",
      dueOn: "\xC9ch\xE9ance",
      plan: "Plan",
      photos: "Photos"
    },
    openLabel: "Ouvrir {number}\xA0: {description}",
    none: "Non renseign\xE9",
    photosUnit: "photo(s)",
    truncated: "Les 200 observations les plus r\xE9centes sont affich\xE9es. Affinez avec les filtres pour voir les autres."
  },
  form: {
    createTitle: "Nouvelle observation",
    editTitle: "Modifier l'observation",
    kind: "Type",
    description: "Description",
    descriptionHint: "Ce qui a \xE9t\xE9 constat\xE9, en quelques mots.",
    descriptionHintReserve: "Le d\xE9faut \xE0 corriger, en quelques mots\xA0: il figurera dans le PV de r\xE9ception.",
    lot: "Lot",
    lotHint: "Par exemple Gros \u0153uvre.",
    contractor: "Entreprise",
    dueOn: "\xC0 traiter avant le",
    photos: "Photos",
    photosHint: "Jusqu'\xE0 10 photos de chantier (JPEG, PNG, WebP ou HEIC).",
    placed: "Plac\xE9e sur {plan}, page {page}.",
    removePoint: "Retirer le point",
    photosBusy: "Des photos sont encore en cours d'envoi. Patientez quelques secondes puis enregistrez.",
    saving: "Enregistrement\u2026",
    create: "Enregistrer",
    save: "Enregistrer les modifications",
    created: "{number} est enregistr\xE9e.",
    updated: "{number} est mise \xE0 jour.",
    errors: {
      descriptionRequired: "D\xE9crivez ce qui a \xE9t\xE9 constat\xE9.",
      descriptionTooLong: "La description ne peut pas d\xE9passer {max} caract\xE8res.",
      tooLong: "Ce champ ne peut pas d\xE9passer {max} caract\xE8res."
    }
  },
  resolve: {
    titleReserve: "Lever la r\xE9serve {number}",
    titleObservation: "Marquer {number} comme trait\xE9e",
    introReserve: "Une r\xE9serve est lev\xE9e avec au moins une photo qui montre que le d\xE9faut est corrig\xE9. Elle sort alors de la liste du PV de r\xE9ception.",
    introObservation: "Ajoutez une photo ou une note si cela aide \xE0 garder la trace du traitement.",
    photosRequired: "Photos de preuve (obligatoire)",
    photos: "Photos (facultatif)",
    photosHint: "Photographiez le d\xE9faut corrig\xE9.",
    note: "Note (facultatif)",
    evidenceRequired: "Ajoutez au moins une photo qui montre que la r\xE9serve est lev\xE9e.",
    saving: "Enregistrement\u2026",
    submitReserve: "Lever la r\xE9serve",
    submitObservation: "Marquer comme trait\xE9e",
    doneReserve: "La r\xE9serve {number} est lev\xE9e.",
    doneObservation: "L'observation {number} est trait\xE9e."
  },
  reopen: {
    title: "Rouvrir {number}",
    intro: "La raison est conserv\xE9e dans le journal du projet.",
    reason: "Raison",
    reasonRequired: "Indiquez pourquoi vous la rouvrez.",
    saving: "R\xE9ouverture\u2026",
    submit: "Rouvrir",
    done: "{number} est rouverte."
  },
  drawer: {
    title: {
      observation: "Observation {number}",
      reserve: "R\xE9serve {number}"
    },
    titleLoading: "Observation",
    readOnly: "Vous pouvez consulter cette observation, mais pas la modifier.",
    lot: "Lot",
    contractor: "Entreprise",
    dueOn: "\xC9ch\xE9ance",
    plan: "Plan",
    noPlan: "Pas plac\xE9e sur un plan",
    none: "Non renseign\xE9",
    createdBy: "Not\xE9e par",
    photos: "Photos ({count})",
    noPhotos: "Aucune photo",
    liftedTitle: "R\xE9serve lev\xE9e",
    dealtTitle: "Observation trait\xE9e",
    resolvedBy: "Par {name}",
    lift: "Lever la r\xE9serve",
    deal: "Marquer comme trait\xE9e",
    reopen: "Rouvrir",
    edit: "Modifier",
    delete: "Supprimer",
    notFoundTitle: "Observation introuvable",
    notFoundBody: "Elle a \xE9t\xE9 supprim\xE9e ou vous n'y avez plus acc\xE8s.",
    loadFailedTitle: "L'observation n'a pas pu \xEAtre charg\xE9e",
    loadFailedBody: "V\xE9rifiez votre connexion puis r\xE9essayez."
  },
  delete: {
    title: "Supprimer {number}\xA0?",
    body: "Cette observation sera supprim\xE9e\xA0: {description}",
    done: "{number} est supprim\xE9e."
  },
  errors: {
    OBSERVATION_ID_TAKEN: "Cet identifiant est d\xE9j\xE0 utilis\xE9 par une autre observation. Fermez la fen\xEAtre et recommencez.",
    OBSERVATION_ANCHOR_INVALID: "Ce plan, cette page ou ce point ne peut pas \xEAtre utilis\xE9. Choisissez un plan de ce projet que vous pouvez ouvrir.",
    OBSERVATION_PHOTO_INVALID: "Une photo ne peut pas \xEAtre utilis\xE9e\xA0: ce doit \xEAtre une image de ce projet que vous pouvez ouvrir.",
    OBSERVATION_NOT_OPEN: "Cette observation est lev\xE9e ou trait\xE9e. Rouvrez-la avant de la modifier.",
    OBSERVATION_NOT_RESOLVED: "Cette observation n'est pas lev\xE9e\xA0: il n'y a rien \xE0 rouvrir.",
    OBSERVATION_IN_REPORT: "Un PV de r\xE9ception liste cette observation\xA0: elle garde son num\xE9ro. Levez-la plut\xF4t que de la supprimer.",
    RECEPTION_REPORT_NOT_READY: "Le PDF de ce PV est en pr\xE9paration. Il sera disponible dans quelques instants.",
    PROJECT_ARCHIVED: "Ce projet est archiv\xE9\xA0: il est en lecture seule tant qu'il n'est pas restaur\xE9.",
    RESERVE_EVIDENCE_REQUIRED: "Ajoutez au moins une photo qui montre que la r\xE9serve est lev\xE9e.",
    deleteForbidden: "Seul l'auteur de l'observation ou un responsable du projet peut la supprimer."
  },
  report: {
    action: "\xC9tablir le PV de r\xE9ception",
    title: "\xC9tablir le PV de r\xE9ception",
    intro: "Le PV liste les r\xE9serves encore ouvertes au moment o\xF9 vous l'\xE9tablissez. Il n'est plus modifi\xE9 ensuite\xA0; si une r\xE9serve est lev\xE9e plus tard, \xE9tablissez un nouveau PV.",
    counting: "Comptage des r\xE9serves ouvertes\u2026",
    count: "R\xE9serves ouvertes list\xE9es dans le PV\xA0: {number}",
    countMore: "R\xE9serves ouvertes list\xE9es dans le PV\xA0: {number} ou plus",
    countFailed: "Le nombre de r\xE9serves ouvertes est indisponible. Le PV les listera quand m\xEAme.",
    heldOn: "Date de la r\xE9ception",
    dateRequired: "Indiquez la date de la r\xE9ception.",
    location: "Lieu",
    language: "Langue du PV",
    languageHint: "La langue dans laquelle le PDF est r\xE9dig\xE9.",
    languages: {
      fr: "Fran\xE7ais",
      ar: "Arabe",
      en: "Anglais"
    },
    notes: "Remarques",
    creating: "Cr\xE9ation\u2026",
    create: "\xC9tablir le PV",
    created: "Le PV {number} est en pr\xE9paration."
  },
  reports: {
    title: "PV de r\xE9ception",
    intro: "Les proc\xE8s-verbaux \xE9tablis pour ce projet, avec les r\xE9serves qui \xE9taient ouvertes \xE0 chaque date.",
    pendingNotice: "Un PV est en pr\xE9paration\xA0: la liste se met \xE0 jour toute seule.",
    loadFailed: "Les PV de r\xE9ception n'ont pas pu \xEAtre charg\xE9s. V\xE9rifiez votre connexion puis r\xE9essayez.",
    empty: {
      title: "Aucun PV de r\xE9ception pour l'instant",
      body: "Quand la r\xE9ception approche, \xE9tablissez un PV\xA0: il liste les r\xE9serves encore ouvertes.",
      bodyNoRights: "Seul un responsable du projet peut \xE9tablir un PV de r\xE9ception."
    },
    scrollLabel: "PV de r\xE9ception (d\xE9filement horizontal)",
    tableLabel: "PV de r\xE9ception du projet",
    columns: {
      number: "PV",
      pdf: "Document",
      heldOn: "R\xE9ception du",
      reserves: "R\xE9serves",
      location: "Lieu",
      language: "Langue",
      actions: "Actions"
    },
    pdf: {
      ready: "PDF pr\xEAt",
      pending: "En pr\xE9paration"
    },
    noLocation: "Non renseign\xE9",
    download: "T\xE9l\xE9charger",
    downloadLabel: "T\xE9l\xE9charger le PDF du PV {number}",
    notReadyLabel: "Le PDF du PV {number} est en pr\xE9paration"
  },
  viewerTool: {
    label: "Observation",
    announce: {
      active: "Outil Observation actif. Cliquez sur le plan, ou utilisez les fl\xE8ches puis Entr\xE9e pour placer le point.",
      placed: "{number} est plac\xE9e sur le plan."
    },
    marker: "{kind} {number}\xA0: {description}, {status}",
    surface: "Page {page}\xA0: placer une observation. Cliquez, ou d\xE9placez le viseur avec les fl\xE8ches (Maj pour aller plus vite) et appuyez sur Entr\xE9e. \xC9chap pour quitter."
  }
};

// locales/ar/pdf.json
var pdf_default = {
  common: {
    seller: "\u0627\u0644\u0645\u0643\u062A\u0628",
    client: "\u0627\u0644\u062D\u0631\u064A\u0641",
    taxId: "\u0627\u0644\u0645\u0639\u0631\u0641 \u0627\u0644\u062C\u0628\u0627\u0626\u064A: {value}",
    page: "\u0635\u0641\u062D\u0629",
    date: "\u0627\u0644\u062A\u0627\u0631\u064A\u062E: {date}",
    number: "\u0639\u062F\u062F {number}"
  },
  lines: {
    phase: "\u0627\u0644\u0645\u0631\u062D\u0644\u0629",
    description: "\u0627\u0644\u0628\u064A\u0627\u0646",
    quantity: "\u0627\u0644\u0643\u0645\u064A\u0629",
    unitPrice: "\u0633\u0639\u0631 \u0627\u0644\u0648\u062D\u062F\u0629 \u062F\u0648\u0646 \u0627\u0644\u0623\u062F\u0627\u0621\u0627\u062A",
    vat: "\u0627\u0644\u0623\u062F\u0627\u0621",
    amount: "\u0627\u0644\u0645\u0628\u0644\u063A \u062F\u0648\u0646 \u0627\u0644\u0623\u062F\u0627\u0621\u0627\u062A",
    outsidePhases: "\u062E\u0627\u0631\u062C \u0627\u0644\u0645\u0631\u0627\u062D\u0644"
  },
  quote: {
    title: "\u0639\u0631\u0636 \u0645\u0627\u0644\u064A",
    documentTitle: "\u0639\u0631\u0636 \u0645\u0627\u0644\u064A {number}",
    validUntil: "\u0635\u0627\u0644\u062D \u0625\u0644\u0649 \u063A\u0627\u064A\u0629 {date}",
    subject: "\u0627\u0644\u0645\u0648\u0636\u0648\u0639: {title}",
    notes: "\u0627\u0644\u0634\u0631\u0648\u0637 \u0648\u0627\u0644\u0645\u0644\u0627\u062D\u0638\u0627\u062A",
    indicative: "\u0645\u0628\u0627\u0644\u063A \u062A\u0642\u062F\u064A\u0631\u064A\u0629: \u062A\u0637\u0628\u0651\u0642 \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629 \u0627\u0644\u0642\u0648\u0627\u0639\u062F \u0627\u0644\u062C\u0628\u0627\u0626\u064A\u0629 \u0627\u0644\u0633\u0627\u0631\u064A\u0629 \u0641\u064A \u062A\u0627\u0631\u064A\u062E\u0647\u0627.",
    acceptance: "\u0644\u0644\u0645\u0648\u0627\u0641\u0642\u0629 \u2014 \u064A\u062A\u0645 \u0627\u0644\u0642\u0628\u0648\u0644 \u0639\u0628\u0631 \u0627\u0644\u0625\u0646\u062A\u0631\u0646\u062A \u0628\u0627\u0644\u0631\u0627\u0628\u0637 \u0627\u0644\u0648\u0627\u0631\u062F \u0641\u064A \u0627\u0644\u0628\u0631\u064A\u062F \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A."
  },
  invoice: {
    documentTitle: "{kind} {number}",
    kinds: {
      advance: "\u0641\u0627\u062A\u0648\u0631\u0629 \u062A\u0633\u0628\u0642\u0629",
      deposit: "\u0641\u0627\u062A\u0648\u0631\u0629 \u062F\u0641\u0639\u0629 \u0639\u0644\u0649 \u0627\u0644\u062D\u0633\u0627\u0628",
      progress: "\u0641\u0627\u062A\u0648\u0631\u0629 \u0648\u0636\u0639\u064A\u0629",
      final: "\u0641\u0627\u062A\u0648\u0631\u0629",
      credit_note: "\u0641\u0627\u062A\u0648\u0631\u0629 \u062A\u0639\u062F\u064A\u0644\u064A\u0629"
    },
    dueDate: "\u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0627\u0633\u062A\u062D\u0642\u0627\u0642: {date}",
    credits: "\u0641\u0627\u062A\u0648\u0631\u0629 \u062A\u0639\u062F\u064A\u0644\u064A\u0629 \u0644\u0644\u0641\u0627\u062A\u0648\u0631\u0629 \u0639\u062F\u062F {number} \u0628\u062A\u0627\u0631\u064A\u062E {date}",
    reference: "\u0627\u0644\u0645\u0631\u062C\u0639: {reference}",
    withholdingTitle: "\u0627\u0644\u062E\u0635\u0648\u0645 \u0645\u0646 \u0627\u0644\u0645\u0648\u0631\u062F \u0627\u0644\u062A\u064A \u064A\u062C\u0631\u064A\u0647\u0627 \u0627\u0644\u062D\u0631\u064A\u0641",
    withholdingKind: "\u0627\u0644\u0646\u0648\u0639",
    withholdingBase: "\u0627\u0644\u0623\u0633\u0627\u0633",
    withholdingRate: "\u0627\u0644\u0646\u0633\u0628\u0629",
    withholdingAmount: "\u0627\u0644\u0645\u0628\u0644\u063A",
    withholdingFees: "\u0627\u0644\u062E\u0635\u0645 \u0639\u0644\u0649 \u0627\u0644\u0623\u062A\u0639\u0627\u0628",
    withholdingVat: "\u0627\u0644\u062E\u0635\u0645 \u0639\u0644\u0649 \u0627\u0644\u0623\u062F\u0627\u0621 \u0639\u0644\u0649 \u0627\u0644\u0642\u064A\u0645\u0629 \u0627\u0644\u0645\u0636\u0627\u0641\u0629",
    ttnReference: "\u0645\u0631\u062C\u0639 \u0627\u0644\u0634\u0628\u0643\u0629 \u0627\u0644\u062A\u0648\u0646\u0633\u064A\u0629 \u0644\u0644\u062A\u062C\u0627\u0631\u0629: {reference}",
    ttnQr: "\u0631\u0645\u0632 \u0627\u0644\u0627\u0633\u062A\u062C\u0627\u0628\u0629 \u0627\u0644\u0633\u0631\u064A\u0639\u0629 \u0644\u0644\u0641\u0627\u062A\u0648\u0631\u0629 \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A\u0629",
    ttnPending: "\u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629 \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A\u0629: \u0645\u0631\u062C\u0639 \u0627\u0644\u0634\u0628\u0643\u0629 \u0627\u0644\u062A\u0648\u0646\u0633\u064A\u0629 \u0644\u0644\u062A\u062C\u0627\u0631\u0629 \u0641\u064A \u0627\u0644\u0627\u0646\u062A\u0638\u0627\u0631.",
    bank: "\u0627\u0644\u062E\u0644\u0627\u0635 \u0628\u062A\u062D\u0648\u064A\u0644 \u0628\u0646\u0643\u064A: {bank}"
  },
  progress: {
    advanceRecovery: "\u0627\u0633\u062A\u0631\u062C\u0627\u0639 \u0627\u0644\u062A\u0633\u0628\u0642\u0629",
    retention: "\u062D\u062C\u0632 \u0627\u0644\u0636\u0645\u0627\u0646",
    retentionRelease: "\u0625\u0631\u062C\u0627\u0639 \u062D\u062C\u0632 \u0627\u0644\u0636\u0645\u0627\u0646",
    summaryTitle: "\u0627\u0644\u0643\u0634\u0641 \u0627\u0644\u062A\u0631\u0627\u0643\u0645\u064A \u0644\u0644\u0648\u0636\u0639\u064A\u0629 {number}",
    fee: "\u0623\u062A\u0639\u0627\u0628 \u0627\u0644\u0645\u0631\u062D\u0644\u0629",
    previous: "\u0627\u0644\u062A\u0642\u062F\u0645 \u0627\u0644\u0633\u0627\u0628\u0642",
    cumulative: "\u0627\u0644\u062A\u0642\u062F\u0645 \u0627\u0644\u062A\u0631\u0627\u0643\u0645\u064A",
    cumulativeAmount: "\u0627\u0644\u0645\u0628\u0644\u063A \u0627\u0644\u062A\u0631\u0627\u0643\u0645\u064A",
    thisPeriod: "\u0647\u0630\u0647 \u0627\u0644\u0648\u0636\u0639\u064A\u0629"
  },
  deletionCertificate: {
    title: "\u0634\u0647\u0627\u062F\u0629 \u062D\u0630\u0641 \u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A",
    documentTitle: "\u0634\u0647\u0627\u062F\u0629 \u0627\u0644\u062D\u0630\u0641 {reference}",
    intro: "\u062A\u0634\u0647\u062F BatiFlow \u0628\u0623\u0646\u0647\u0627 \u062D\u0630\u0641\u062A \u0628\u064A\u0627\u0646\u0627\u062A \u0627\u0644\u0645\u0624\u0633\u0633\u0629 {organization} \u0628\u062A\u0627\u0631\u064A\u062E {date}\u060C \u0628\u0646\u0627\u0621\u064B \u0639\u0644\u0649 \u0627\u0644\u0637\u0644\u0628 \u0627\u0644\u0645\u0628\u064A\u0651\u0646 \u0623\u062F\u0646\u0627\u0647.",
    facts: "\u0627\u0644\u0637\u0644\u0628",
    organization: "\u0627\u0644\u0645\u0624\u0633\u0633\u0629",
    taxId: "\u0627\u0644\u0645\u0639\u0631\u0651\u0641 \u0627\u0644\u062C\u0628\u0627\u0626\u064A",
    reference: "\u0627\u0644\u0645\u0631\u062C\u0639",
    reasonLabel: "\u0627\u0644\u0633\u0628\u0628",
    reason: {
      owner_request: "\u0637\u0644\u0628 \u0645\u0627\u0644\u0643 \u0627\u0644\u0645\u0624\u0633\u0633\u0629",
      unpaid: "\u0627\u0634\u062A\u0631\u0627\u0643 \u063A\u064A\u0631 \u0645\u0633\u062F\u064E\u0651\u062F (\u0625\u062C\u0631\u0627\u0621\u0627\u062A \u0627\u0644\u0627\u0633\u062A\u062E\u0644\u0627\u0635)",
      trial_expired: "\u0627\u0646\u062A\u0647\u0627\u0621 \u0627\u0644\u0641\u062A\u0631\u0629 \u0627\u0644\u062A\u062C\u0631\u064A\u0628\u064A\u0629 \u062F\u0648\u0646 \u0627\u0634\u062A\u0631\u0627\u0643",
      cancelled: "\u0625\u0644\u063A\u0627\u0621 \u0627\u0644\u0627\u0634\u062A\u0631\u0627\u0643",
      platform_admin: "\u0642\u0631\u0627\u0631 \u062F\u0639\u0645 BatiFlow (\u0628\u0645\u0648\u0627\u0641\u0642\u0629 \u0645\u0633\u0624\u0648\u0644\u064E\u064A\u0646 \u0627\u062B\u0646\u064A\u0646)"
    },
    requested: "\u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0637\u0644\u0628",
    scheduled: "\u0627\u0644\u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0645\u0642\u0631\u064E\u0651\u0631",
    executed: "\u062A\u0627\u0631\u064A\u062E \u0627\u0644\u062A\u0646\u0641\u064A\u0630",
    removed: "\u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A \u0627\u0644\u0645\u062D\u0630\u0648\u0641\u0629",
    rows: "\u0627\u0644\u0633\u062C\u0644\u0627\u062A \u0627\u0644\u0645\u062D\u0630\u0648\u0641\u0629 (\u0641\u064A {tables} \u062C\u062F\u0648\u0644\u064B\u0627)",
    objects: "\u0627\u0644\u0645\u0644\u0641\u0627\u062A \u0627\u0644\u0645\u062D\u0630\u0648\u0641\u0629 \u0645\u0646 \u0627\u0644\u062A\u062E\u0632\u064A\u0646",
    tuples: "\u0635\u0644\u0627\u062D\u064A\u0627\u062A \u0627\u0644\u0648\u0635\u0648\u0644 \u0627\u0644\u0645\u062D\u0630\u0648\u0641\u0629",
    people: "\u0627\u0644\u062D\u0633\u0627\u0628\u0627\u062A \u0627\u0644\u0634\u062E\u0635\u064A\u0629 \u0627\u0644\u0645\u063A\u0644\u0642\u0629 \u0645\u0639 \u0627\u0644\u0645\u0624\u0633\u0633\u0629",
    kept: "\u0645\u0627 \u064A\u062A\u0645\u0651 \u0627\u0644\u0627\u062D\u062A\u0641\u0627\u0638 \u0628\u0647",
    keptText: "\u0644\u0627 \u064A\u064F\u062D\u062A\u0641\u0638 \u0625\u0644\u0627 \u0628\u0627\u0633\u0645 \u0627\u0644\u0645\u0624\u0633\u0633\u0629 \u0648\u0645\u0639\u0631\u0651\u0641\u0647\u0627 \u0627\u0644\u062C\u0628\u0627\u0626\u064A (\u0644\u0647\u0630\u0647 \u0627\u0644\u0634\u0647\u0627\u062F\u0629 \u0648\u0644\u0644\u0641\u0648\u0627\u062A\u064A\u0631 \u0627\u0644\u062A\u064A \u0623\u0635\u062F\u0631\u062A\u0647\u0627 BatiFlow)\u060C \u0648\u0628\u0647\u0630\u0627 \u0627\u0644\u0637\u0644\u0628\u060C \u0648\u0628\u0633\u062C\u0644\u0651 \u0627\u0644\u062A\u062F\u0642\u064A\u0642 \u0627\u0644\u0630\u064A \u064A\u064F\u062D\u0641\u0638 3 \u0633\u0646\u0648\u0627\u062A \u062B\u0645 \u064A\u064F\u062D\u0630\u0641. \u0648\u062A\u064F\u062D\u0641\u0638 \u062D\u0633\u0627\u0628\u0627\u062A \u0627\u0644\u0623\u0634\u062E\u0627\u0635 \u0627\u0644\u0623\u0639\u0636\u0627\u0621 \u0641\u064A \u0645\u0624\u0633\u0633\u0627\u062A \u0623\u062E\u0631\u0649.",
    footer: "\u0648\u062B\u064A\u0642\u0629 \u0623\u0646\u0634\u0623\u062A\u0647\u0627 BatiFlow \u0622\u0644\u064A\u064B\u0627. \u064A\u0642\u0639 \u062D\u0641\u0638 \u0627\u0644\u0641\u0648\u0627\u062A\u064A\u0631 \u0644\u0645\u062F\u0629 10 \u0633\u0646\u0648\u0627\u062A \u0648\u0641\u0642 \u0627\u0644\u0642\u0627\u0646\u0648\u0646 \u0639\u0644\u0649 \u0639\u0627\u062A\u0642 \u0627\u0644\u0645\u0624\u0633\u0633\u0629\u060C \u0627\u0644\u062A\u064A \u062A\u0633\u0644\u0651\u0645\u062A \u0646\u0633\u062E\u0629 \u0643\u0627\u0645\u0644\u0629 \u0645\u0646 \u0628\u064A\u0627\u0646\u0627\u062A\u0647\u0627 \u0642\u0628\u0644 \u0627\u0644\u062D\u0630\u0641 \u0623\u0648 \u0631\u0641\u0636\u062A\u0647\u0627."
  },
  minutes: {
    heading: "\u0645\u062D\u0636\u0631 \u0627\u0644\u0627\u062C\u062A\u0645\u0627\u0639 {number}",
    documentTitle: "{number} \u2014 {title}",
    template: {
      coordination: "\u0627\u062C\u062A\u0645\u0627\u0639 \u062A\u0646\u0633\u064A\u0642",
      moa: "\u0627\u062C\u062A\u0645\u0627\u0639 \u0645\u0639 \u0635\u0627\u062D\u0628 \u0627\u0644\u0645\u0634\u0631\u0648\u0639",
      site_meeting: "\u0627\u062C\u062A\u0645\u0627\u0639 \u0627\u0644\u062D\u0636\u064A\u0631\u0629",
      site_visit: "\u0632\u064A\u0627\u0631\u0629 \u0627\u0644\u062D\u0636\u064A\u0631\u0629"
    },
    organization: "\u0627\u0644\u0645\u0643\u062A\u0628",
    project: "\u0627\u0644\u0645\u0634\u0631\u0648\u0639",
    heldAt: "\u0627\u0644\u062A\u0627\u0631\u064A\u062E",
    dateTime: "{date} \u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629 {time}",
    location: "\u0627\u0644\u0645\u0643\u0627\u0646",
    attendees: "\u0627\u0644\u0645\u0634\u0627\u0631\u0643\u0648\u0646",
    present: "\u0627\u0644\u062D\u0627\u0636\u0631\u0648\u0646:",
    absent: "\u0627\u0644\u063A\u0627\u0626\u0628\u0648\u0646 \u0623\u0648 \u0627\u0644\u0645\u0639\u062A\u0630\u0631\u0648\u0646:",
    nobody: "\u0644\u0645 \u064A\u064F\u0633\u062C\u064E\u0651\u0644 \u0623\u064A \u0645\u0634\u0627\u0631\u0643.",
    points: "\u0627\u0644\u0646\u0642\u0627\u0637 \u0627\u0644\u0645\u0637\u0631\u0648\u062D\u0629",
    decisions: "\u0627\u0644\u0642\u0631\u0627\u0631\u0627\u062A",
    actions: "\u0627\u0644\u0625\u062C\u0631\u0627\u0621\u0627\u062A",
    action: "\u0627\u0644\u0625\u062C\u0631\u0627\u0621",
    assignee: "\u0627\u0644\u0645\u0633\u0624\u0648\u0644",
    dueDate: "\u0627\u0644\u0623\u062C\u0644",
    carriedFrom: "\u0645\u064F\u0631\u062D\u064E\u0651\u0644 \u0645\u0646 {number}",
    none: "\u0644\u0627 \u0634\u064A\u0621.",
    footer: "\u0646\u0634\u0631\u0647 {by} \u0628\u062A\u0627\u0631\u064A\u062E {date} \u0639\u0644\u0649 BatiFlow."
  },
  register: {
    heading: "\u0633\u062C\u0644 \u0627\u0644\u0645\u062E\u0637\u0637\u0627\u062A",
    documentTitle: "\u0633\u062C\u0644 \u0627\u0644\u0645\u062E\u0637\u0637\u0627\u062A \u2014 {project}",
    organization: "\u0627\u0644\u0645\u0643\u062A\u0628",
    project: "\u0627\u0644\u0645\u0634\u0631\u0648\u0639",
    generatedOn: "\u062D\u064F\u0631\u0650\u0651\u0631 \u0641\u064A {date}",
    scopeDrawing: "\u0627\u0644\u0645\u062E\u0637\u0637\u0627\u062A \u0641\u0642\u0637",
    scopeAll: "\u062C\u0645\u064A\u0639 \u0627\u0644\u0648\u062B\u0627\u0626\u0642",
    count: "{count} \u0648\u062B\u064A\u0642\u0629",
    code: "\u0627\u0644\u0631\u0645\u0632",
    title: "\u0627\u0644\u062A\u0633\u0645\u064A\u0629",
    scale: "\u0627\u0644\u0645\u0642\u064A\u0627\u0633",
    index: "\u0627\u0644\u0645\u0624\u0634\u0631",
    date: "\u0627\u0644\u062A\u0627\u0631\u064A\u062E",
    approval: "\u0627\u0644\u062A\u0623\u0634\u064A\u0631",
    transmittals: "\u0627\u0644\u062A\u0648\u0632\u064A\u0639",
    lastTransmittal: "\u0622\u062E\u0631 \u062A\u0648\u0632\u064A\u0639",
    none: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0648\u062B\u0627\u0626\u0642 \u0641\u064A \u0627\u0644\u0633\u062C\u0644.",
    notApproved: "\u2014",
    transmittal: "\u0631\u0642\u0645 {number} ({index}) {date}",
    more: "+ {count} \u0623\u062E\u0631\u0649",
    footer: "\u0633\u062C\u0644 \u0623\u0646\u0634\u0623\u0647 BatiFlow \u0627\u0646\u0637\u0644\u0627\u0642\u0627 \u0645\u0646 \u0627\u0644\u0648\u062B\u0627\u0626\u0642 \u0627\u0644\u062A\u064A \u064A\u0645\u0643\u0646\u0643 \u0627\u0644\u0627\u0637\u0644\u0627\u0639 \u0639\u0644\u064A\u0647\u0627.",
    status: {
      in_progress: "\u0642\u064A\u062F \u0627\u0644\u062A\u0623\u0634\u064A\u0631",
      approved: "\u0645\u0624\u0634\u064E\u0651\u0631 \u0639\u0644\u064A\u0647 (VSO)",
      approved_with_comments: "\u0645\u0624\u0634\u064E\u0651\u0631 \u0639\u0644\u064A\u0647 \u0645\u0639 \u0645\u0644\u0627\u062D\u0638\u0627\u062A (VAO)",
      rejected: "\u0645\u0631\u0641\u0648\u0636 (REF)"
    }
  },
  transmittal: {
    heading: "\u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u0625\u0631\u0633\u0627\u0644 {number}",
    documentTitle: "{number} \u2014 {title}",
    space: "\u0627\u0644\u0641\u0636\u0627\u0621",
    sentBy: "\u0623\u0631\u0633\u0644\u0647\u0627",
    sentOn: "\u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0625\u0631\u0633\u0627\u0644",
    message: "\u0631\u0633\u0627\u0644\u0629",
    documents: "\u0627\u0644\u0648\u062B\u0627\u0626\u0642 \u0627\u0644\u0645\u0631\u0633\u0644\u0629 ({count})",
    rank: "\u0627\u0644\u0631\u0642\u0645",
    code: "\u0627\u0644\u0631\u0645\u0632",
    title: "\u0627\u0644\u0639\u0646\u0648\u0627\u0646",
    index: "\u0627\u0644\u0645\u0631\u0627\u062C\u0639\u0629",
    recipients: "\u0627\u0644\u0645\u0631\u0633\u064E\u0644 \u0625\u0644\u064A\u0647\u0645",
    external: "\u062E\u0627\u0631\u062C\u064A",
    acknowledgement: "\u062A\u0623\u0643\u064A\u062F \u0627\u0644\u0627\u0633\u062A\u0644\u0627\u0645",
    acknowledgementHint: "\u062A\u064F\u0639\u0627\u062F \u0645\u0648\u0642\u0651\u0639\u0629\u060C \u0623\u0648 \u062A\u064F\u0624\u0643\u064E\u0651\u062F \u0639\u0628\u0631 \u0627\u0644\u0625\u0646\u062A\u0631\u0646\u062A \u0645\u0646 \u0627\u0644\u0631\u0627\u0628\u0637 \u0627\u0644\u0645\u0633\u062A\u0644\u0645.",
    ackName: "\u0627\u0644\u0627\u0633\u0645: \u2026\u2026\u2026\u2026\u2026\u2026\u2026\u2026\u2026\u2026\u2026\u2026\u2026\u2026\u2026\u2026\u2026\u2026",
    ackDate: "\u0627\u0644\u062A\u0627\u0631\u064A\u062E: \u2026\u2026\u2026\u2026\u2026\u2026\u2026\u2026\u2026\u2026\u2026\u2026\u2026\u2026\u2026\u2026\u2026\u2026",
    ackSignature: "\u0627\u0644\u0625\u0645\u0636\u0627\u0621: \u2026\u2026\u2026\u2026\u2026\u2026\u2026\u2026\u2026\u2026\u2026\u2026\u2026\u2026\u2026\u2026\u2026\u2026",
    footer: "\u062A\u064F\u0631\u0633\u0644 \u0627\u0644\u0648\u062B\u0627\u0626\u0642 \u0628\u0627\u0644\u0645\u0631\u0627\u062C\u0639\u0629 \u0627\u0644\u0645\u0628\u064A\u0651\u0646\u0629. \u062D\u064F\u0631\u0651\u0631\u062A \u0639\u0644\u0649 BatiFlow."
  },
  receptionReport: {
    heading: "\u0645\u062D\u0636\u0631 \u0627\u0644\u0627\u0633\u062A\u0644\u0627\u0645 {number}",
    documentTitle: "{number} \u2014 {project}",
    project: "\u0627\u0644\u0645\u0634\u0631\u0648\u0639",
    heldOn: "\u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0627\u0633\u062A\u0644\u0627\u0645",
    location: "\u0627\u0644\u0645\u0643\u0627\u0646",
    notes: "\u0645\u0644\u0627\u062D\u0638\u0627\u062A \u0639\u0627\u0645\u0629",
    reserves: "\u0627\u0644\u062A\u062D\u0641\u0638\u0627\u062A \u0627\u0644\u0648\u0627\u062C\u0628 \u0631\u0641\u0639\u0647\u0627 ({count})",
    number: "\u0627\u0644\u0631\u0642\u0645",
    lot: "\u0627\u0644\u062D\u0635\u0629",
    contractor: "\u0627\u0644\u0645\u0642\u0627\u0648\u0644\u0629",
    description: "\u0627\u0644\u062A\u062D\u0641\u0638",
    dueOn: "\u0623\u062C\u0644 \u0627\u0644\u0631\u0641\u0639",
    plan: "\u0627\u0644\u0645\u062E\u0637\u0637",
    planPage: "{plan}\u060C \u0627\u0644\u0635\u0641\u062D\u0629 {page}",
    noReserve: "\u0644\u0627 \u062A\u0648\u062C\u062F \u062A\u062D\u0641\u0638\u0627\u062A.",
    sign: {
      client: "\u0635\u0627\u062D\u0628 \u0627\u0644\u0645\u0634\u0631\u0648\u0639",
      contractor: "\u0627\u0644\u0645\u0642\u0627\u0648\u0644\u0629",
      office: "\u0645\u0643\u062A\u0628 \u0627\u0644\u062F\u0631\u0627\u0633\u0627\u062A"
    },
    signName: "\u0627\u0644\u0627\u0633\u0645: \u2026\u2026\u2026\u2026\u2026\u2026\u2026\u2026\u2026\u2026\u2026\u2026\u2026\u2026\u2026\u2026\u2026\u2026",
    signDate: "\u0627\u0644\u062A\u0627\u0631\u064A\u062E: \u2026\u2026\u2026\u2026\u2026\u2026\u2026\u2026\u2026\u2026\u2026\u2026\u2026\u2026\u2026\u2026\u2026\u2026",
    signSignature: "\u0627\u0644\u0625\u0645\u0636\u0627\u0621: \u2026\u2026\u2026\u2026\u2026\u2026\u2026\u2026\u2026\u2026\u2026\u2026\u2026\u2026\u2026\u2026\u2026\u2026",
    footer: "\u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u062A\u062D\u0641\u0638\u0627\u062A \u0627\u0644\u0645\u0641\u062A\u0648\u062D\u0629 \u0639\u0646\u062F \u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0627\u0633\u062A\u0644\u0627\u0645\u060C \u062D\u0631\u0651\u0631\u0647\u0627 {by} \u0628\u062A\u0627\u0631\u064A\u062E {date} \u0639\u0644\u0649 BatiFlow."
  },
  signatureEvidence: {
    documentTitle: "\u0634\u0647\u0627\u062F\u0629 \u0625\u062B\u0628\u0627\u062A \u0627\u0644\u062A\u0648\u0642\u064A\u0639 {reference}",
    title: "\u0634\u0647\u0627\u062F\u0629 \u0625\u062B\u0628\u0627\u062A \u0627\u0644\u062A\u0648\u0642\u064A\u0639 \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A",
    intro: "\u062A\u0634\u0647\u062F {organization}\u060C \u0639\u0628\u0631 BatiFlow\u060C \u0628\u0623\u0646 \u0627\u0644\u0648\u062B\u064A\u0642\u0629 \u0627\u0644\u0645\u0628\u064A\u0651\u0646\u0629 \u0623\u062F\u0646\u0627\u0647 \u0648\u064F\u0642\u0651\u0639\u062A \u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A\u064B\u0627 ({level}) \u0645\u0646 \u0642\u0650\u0628\u0644 \u0627\u0644\u0623\u0634\u062E\u0627\u0635 \u0627\u0644\u0645\u0630\u0643\u0648\u0631\u064A\u0646 \u0648\u0641\u064A \u0627\u0644\u062A\u0648\u0627\u0631\u064A\u062E \u0627\u0644\u0645\u0630\u0643\u0648\u0631\u0629.",
    level: {
      simple: "\u062A\u0648\u0642\u064A\u0639 \u0628\u0633\u064A\u0637 \u0628\u0631\u0645\u0632 \u064A\u064F\u0633\u062A\u0639\u0645\u0644 \u0645\u0631\u0629 \u0648\u0627\u062D\u062F\u0629",
      qualified: "\u062A\u0648\u0642\u064A\u0639 \u0645\u0624\u0647\u064E\u0651\u0644 \u0639\u0628\u0631 \u0645\u0646\u0635\u0629 \u0645\u0639\u062A\u0645\u062F\u0629"
    },
    document: "\u0627\u0644\u0648\u062B\u064A\u0642\u0629 \u0627\u0644\u0645\u0648\u0642\u0651\u0639\u0629",
    requestTitle: "\u0627\u0644\u0645\u0648\u0636\u0648\u0639",
    documentName: "\u0627\u0644\u0645\u0644\u0641",
    version: "\u0627\u0644\u0646\u0633\u062E\u0629",
    documentHash: "\u0628\u0635\u0645\u0629 SHA-256 \u0644\u0644\u0645\u0644\u0641",
    reference: "\u0645\u0631\u062C\u0639 \u0627\u0644\u0637\u0644\u0628",
    requestedBy: "\u0637\u0644\u0628\u0647",
    requestedAt: "\u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0637\u0644\u0628",
    completedAt: "\u0648\u0642\u0651\u0639\u0647 \u0627\u0644\u062C\u0645\u064A\u0639 \u0641\u064A",
    signers: "\u0627\u0644\u0645\u0648\u0642\u0651\u0639\u0648\u0646",
    signer: "\u0627\u0644\u0645\u0648\u0642\u0651\u0639",
    email: "\u0627\u0644\u0628\u0631\u064A\u062F \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A",
    signedAt: "\u062A\u0627\u0631\u064A\u062E \u0627\u0644\u062A\u0648\u0642\u064A\u0639",
    method: "\u0627\u0644\u0637\u0631\u064A\u0642\u0629",
    methods: {
      email_code: "\u0631\u0645\u0632 \u064A\u064F\u0633\u062A\u0639\u0645\u0644 \u0645\u0631\u0629 \u0648\u0627\u062D\u062F\u0629 \u0623\u064F\u0631\u0633\u0644 \u0628\u0627\u0644\u0628\u0631\u064A\u062F \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A",
      qualified: "\u0634\u0647\u0627\u062F\u0629 \u0645\u0624\u0647\u064E\u0651\u0644\u0629 (\u0645\u0646\u0635\u0629 \u0645\u0639\u062A\u0645\u062F\u0629)"
    },
    certificate: "\u0627\u0644\u0634\u0647\u0627\u062F\u0629",
    fingerprint: "\u0628\u0635\u0645\u0629 \u0627\u0644\u0634\u0647\u0627\u062F\u0629",
    ip: "\u0639\u0646\u0648\u0627\u0646 IP",
    userAgent: "\u0627\u0644\u0645\u062A\u0635\u0641\u062D",
    integrity: "\u0627\u0644\u0633\u0644\u0627\u0645\u0629",
    evidenceHash: "\u0628\u0635\u0645\u0629 SHA-256 \u0644\u0644\u0625\u062B\u0628\u0627\u062A",
    integrityText: "\u062A\u064F\u062D\u062A\u0633\u0628 \u0628\u0635\u0645\u0629 \u0627\u0644\u0625\u062B\u0628\u0627\u062A \u0639\u0644\u0649 \u0627\u0644\u0633\u062C\u0644\u0651 \u0627\u0644\u0643\u0627\u0645\u0644 \u0644\u0644\u0637\u0644\u0628 (\u0627\u0644\u0648\u062B\u064A\u0642\u0629\u060C \u0627\u0644\u0645\u0648\u0642\u0651\u0639\u0648\u0646\u060C \u0627\u0644\u062A\u0648\u0627\u0631\u064A\u062E\u060C \u0627\u0644\u0639\u0646\u0627\u0648\u064A\u0646). \u0623\u064A \u062A\u063A\u064A\u064A\u0631 \u0641\u064A \u0627\u0644\u0645\u0644\u0641 \u0623\u0648 \u0641\u064A \u0627\u0644\u0625\u062B\u0628\u0627\u062A \u064A\u063A\u064A\u0651\u0631 \u0647\u0630\u0647 \u0627\u0644\u0628\u0635\u0645\u0627\u062A: \u064A\u0639\u064A\u062F \u0627\u0644\u062A\u062D\u0642\u0642 \u0641\u064A BatiFlow \u0627\u062D\u062A\u0633\u0627\u0628\u0647\u0627.",
    footer: "\u0627\u0644\u0623\u0648\u0642\u0627\u062A \u0628\u062A\u0648\u0642\u064A\u062A \u062A\u0648\u0646\u0633 (Africa/Tunis). \u0648\u062B\u064A\u0642\u0629 \u0623\u0646\u0634\u0623\u0647\u0627 BatiFlow."
  }
};

// locales/en/pdf.json
var pdf_default2 = {
  common: {
    seller: "Office",
    client: "Client",
    taxId: "Tax id: {value}",
    page: "Page",
    date: "Date: {date}",
    number: "No. {number}"
  },
  lines: {
    phase: "Phase",
    description: "Description",
    quantity: "Qty",
    unitPrice: "Unit price excl. VAT",
    vat: "VAT",
    amount: "Amount excl. VAT",
    outsidePhases: "Outside the phases"
  },
  quote: {
    title: "Quote",
    documentTitle: "Quote {number}",
    validUntil: "Valid until {date}",
    subject: "Subject: {title}",
    notes: "Terms and notes",
    indicative: "Indicative amounts: the invoice applies the tax rules in force on its date.",
    acceptance: "Approval \u2014 accept online with the link received by email."
  },
  invoice: {
    documentTitle: "{kind} {number}",
    kinds: {
      advance: "Advance invoice",
      deposit: "Deposit invoice",
      progress: "Progress invoice",
      final: "Invoice",
      credit_note: "Credit note"
    },
    dueDate: "Due: {date}",
    credits: "Credit note on invoice no. {number} of {date}",
    reference: "Reference: {reference}",
    withholdingTitle: "Withholdings the client makes",
    withholdingKind: "Kind",
    withholdingBase: "Base",
    withholdingRate: "Rate",
    withholdingAmount: "Amount",
    withholdingFees: "Withholding on fees",
    withholdingVat: "VAT withholding",
    ttnReference: "TTN reference: {reference}",
    ttnQr: "QR code of the electronic invoice",
    ttnPending: "Electronic invoice: TTN reference pending.",
    bank: "Payment by transfer: {bank}"
  },
  progress: {
    advanceRecovery: "Advance recovery",
    retention: "Retention",
    retentionRelease: "Retention release",
    summaryTitle: "Cumulative statement of progress invoice {number}",
    fee: "Phase fee",
    previous: "Previous progress",
    cumulative: "Cumulative progress",
    cumulativeAmount: "Cumulative amount",
    thisPeriod: "This period"
  },
  deletionCertificate: {
    title: "Data deletion certificate",
    documentTitle: "Deletion certificate {reference}",
    intro: "BatiFlow certifies that it deleted the data of the organisation {organization} on {date}, following the request described below.",
    facts: "Request",
    organization: "Organisation",
    taxId: "Tax ID",
    reference: "Reference",
    reasonLabel: "Reason",
    reason: {
      owner_request: "Request of the organisation\u2019s owner",
      unpaid: "Unpaid subscription (collection procedure)",
      trial_expired: "Trial ended without a subscription",
      cancelled: "Subscription cancelled",
      platform_admin: "Decision of BatiFlow support (approved by two administrators)"
    },
    requested: "Requested on",
    scheduled: "Scheduled for",
    executed: "Carried out on",
    removed: "Data deleted",
    rows: "Records deleted (in {tables} tables)",
    objects: "Files deleted from storage",
    tuples: "Access rights deleted",
    people: "Personal accounts closed with the organisation",
    kept: "What is kept",
    keptText: "Only these are kept: the organisation\u2019s name and tax ID (for this certificate and the invoices BatiFlow issued), this request, and the audit log, kept for 3 years and then deleted. Accounts of people who are members of other organisations are kept.",
    footer: "Document generated automatically by BatiFlow. Keeping invoices for 10 years, as the law requires, is the organisation\u2019s duty; it received a complete export of its data before the deletion, or declined it."
  },
  minutes: {
    heading: "Minutes {number}",
    documentTitle: "{number} \u2014 {title}",
    template: {
      coordination: "Coordination meeting",
      moa: "Meeting with the client",
      site_meeting: "Site meeting",
      site_visit: "Site visit"
    },
    organization: "Office",
    project: "Project",
    heldAt: "Date",
    dateTime: "{date} at {time}",
    location: "Place",
    attendees: "Attendees",
    present: "Present:",
    absent: "Absent or excused:",
    nobody: "No attendee recorded.",
    points: "Points discussed",
    decisions: "Decisions",
    actions: "Actions",
    action: "Action",
    assignee: "Owner",
    dueDate: "Due",
    carriedFrom: "carried over from {number}",
    none: "None.",
    footer: "Published by {by} on {date} on BatiFlow."
  },
  register: {
    heading: "Drawing register",
    documentTitle: "Drawing register \u2014 {project}",
    organization: "Office",
    project: "Project",
    generatedOn: "Issued on {date}",
    scopeDrawing: "Drawings only",
    scopeAll: "All documents",
    count: "{count} document(s)",
    code: "Code",
    title: "Title",
    scale: "Scale",
    index: "Index",
    date: "Date",
    approval: "Approval",
    transmittals: "Distribution",
    lastTransmittal: "Last distribution",
    none: "No document in the register.",
    notApproved: "\u2014",
    transmittal: "No. {number} ({index}) {date}",
    more: "+ {count} more",
    footer: "Register generated by BatiFlow from the documents you can view.",
    status: {
      in_progress: "In approval",
      approved: "Approved (VSO)",
      approved_with_comments: "Approved with comments (VAO)",
      rejected: "Refused (REF)"
    }
  },
  transmittal: {
    heading: "Transmittal {number}",
    documentTitle: "{number} \u2014 {title}",
    space: "Space",
    sentBy: "Sent by",
    sentOn: "Date sent",
    message: "Message",
    documents: "Documents transmitted ({count})",
    rank: "No.",
    code: "Code",
    title: "Title",
    index: "Index",
    recipients: "Recipients",
    external: "external",
    acknowledgement: "Acknowledgement of receipt",
    acknowledgementHint: "Return it signed, or confirm online from the link received.",
    ackName: "Name: \u2026\u2026\u2026\u2026\u2026\u2026\u2026\u2026\u2026\u2026\u2026\u2026\u2026\u2026\u2026\u2026\u2026\u2026",
    ackDate: "Date: \u2026\u2026\u2026\u2026\u2026\u2026\u2026\u2026\u2026\u2026\u2026\u2026\u2026\u2026\u2026\u2026\u2026\u2026",
    ackSignature: "Signature: \u2026\u2026\u2026\u2026\u2026\u2026\u2026\u2026\u2026\u2026\u2026\u2026\u2026\u2026\u2026\u2026\u2026\u2026",
    footer: "The documents are sent at the index shown. Issued with BatiFlow."
  },
  receptionReport: {
    heading: "Reception report {number}",
    documentTitle: "{number} \u2014 {project}",
    project: "Project",
    heldOn: "Reception date",
    location: "Place",
    notes: "General remarks",
    reserves: "Reserves to lift ({count})",
    number: "No.",
    lot: "Trade",
    contractor: "Contractor",
    description: "Reserve",
    dueOn: "To lift by",
    plan: "Plan",
    planPage: "{plan}, page {page}",
    noReserve: "No reserve.",
    sign: {
      client: "Client",
      contractor: "Contractor",
      office: "Design office"
    },
    signName: "Name: \u2026\u2026\u2026\u2026\u2026\u2026\u2026\u2026\u2026\u2026\u2026\u2026\u2026\u2026\u2026\u2026\u2026\u2026",
    signDate: "Date: \u2026\u2026\u2026\u2026\u2026\u2026\u2026\u2026\u2026\u2026\u2026\u2026\u2026\u2026\u2026\u2026\u2026\u2026",
    signSignature: "Signature: \u2026\u2026\u2026\u2026\u2026\u2026\u2026\u2026\u2026\u2026\u2026\u2026\u2026\u2026\u2026\u2026\u2026\u2026",
    footer: "List of the reserves open on the reception date, prepared by {by} on {date} with BatiFlow."
  },
  signatureEvidence: {
    documentTitle: "Signature evidence certificate {reference}",
    title: "Electronic signature evidence certificate",
    intro: "{organization} certifies, through BatiFlow, that the document below was signed electronically ({level}) by the people listed, on the dates listed.",
    level: {
      simple: "simple signature with a one-time code",
      qualified: "qualified signature through an approved platform"
    },
    document: "Signed document",
    requestTitle: "Subject",
    documentName: "File",
    version: "Version",
    documentHash: "SHA-256 fingerprint of the file",
    reference: "Request reference",
    requestedBy: "Requested by",
    requestedAt: "Requested on",
    completedAt: "Signed by all on",
    signers: "Signers",
    signer: "Signer",
    email: "Email address",
    signedAt: "Signed on",
    method: "Method",
    methods: {
      email_code: "One-time code sent by email",
      qualified: "Qualified certificate (approved platform)"
    },
    certificate: "Certificate",
    fingerprint: "Certificate fingerprint",
    ip: "IP address",
    userAgent: "Browser",
    integrity: "Integrity",
    evidenceHash: "SHA-256 fingerprint of the evidence",
    integrityText: "The evidence fingerprint is computed over the complete record of the request (document, signers, dates, addresses). Any change to the file or to the evidence changes these fingerprints: the check in BatiFlow computes them again.",
    footer: "Times in Tunis time (Africa/Tunis). Document generated by BatiFlow."
  }
};

// locales/fr/pdf.json
var pdf_default3 = {
  common: {
    seller: "Bureau",
    client: "Client",
    taxId: "Matricule fiscal : {value}",
    page: "Page",
    date: "Date : {date}",
    number: "N\xB0 {number}"
  },
  lines: {
    phase: "Phase",
    description: "D\xE9signation",
    quantity: "Qt\xE9",
    unitPrice: "P.U. HT",
    vat: "TVA",
    amount: "Montant HT",
    outsidePhases: "Hors phases"
  },
  quote: {
    title: "Devis",
    documentTitle: "Devis {number}",
    validUntil: "Valable jusqu\u2019au {date}",
    subject: "Objet : {title}",
    notes: "Conditions et remarques",
    indicative: "Montants indicatifs : la facture appliquera les r\xE8gles fiscales en vigueur \xE0 sa date.",
    acceptance: "Bon pour accord \u2014 \xE0 accepter en ligne avec le lien re\xE7u par courriel."
  },
  invoice: {
    documentTitle: "{kind} {number}",
    kinds: {
      advance: "Facture d\u2019avance",
      deposit: "Facture d\u2019acompte",
      progress: "Facture de situation",
      final: "Facture",
      credit_note: "Avoir"
    },
    dueDate: "\xC9ch\xE9ance : {date}",
    credits: "Avoir sur la facture n\xB0 {number} du {date}",
    reference: "R\xE9f\xE9rence : {reference}",
    withholdingTitle: "Retenues \xE0 la source \xE0 op\xE9rer par le client",
    withholdingKind: "Nature",
    withholdingBase: "Base",
    withholdingRate: "Taux",
    withholdingAmount: "Montant",
    withholdingFees: "Retenue sur honoraires",
    withholdingVat: "Retenue sur la TVA",
    ttnReference: "R\xE9f\xE9rence TTN : {reference}",
    ttnQr: "Code QR de la facture \xE9lectronique",
    ttnPending: "Facture \xE9lectronique : r\xE9f\xE9rence TTN en attente.",
    bank: "R\xE8glement par virement : {bank}"
  },
  progress: {
    advanceRecovery: "Remboursement de l\u2019avance",
    retention: "Retenue de garantie",
    retentionRelease: "Restitution de la retenue de garantie",
    summaryTitle: "D\xE9compte cumul\xE9 de la situation {number}",
    fee: "Honoraires de la phase",
    previous: "Avancement pr\xE9c\xE9dent",
    cumulative: "Avancement cumul\xE9",
    cumulativeAmount: "Montant cumul\xE9",
    thisPeriod: "Cette situation"
  },
  deletionCertificate: {
    title: "Certificat de suppression des donn\xE9es",
    documentTitle: "Certificat de suppression {reference}",
    intro: "BatiFlow certifie avoir supprim\xE9 les donn\xE9es de l\u2019organisation {organization} le {date}, \xE0 la suite de la demande d\xE9crite ci-dessous.",
    facts: "Demande",
    organization: "Organisation",
    taxId: "Matricule fiscal",
    reference: "R\xE9f\xE9rence",
    reasonLabel: "Motif",
    reason: {
      owner_request: "Demande du propri\xE9taire de l\u2019organisation",
      unpaid: "Abonnement impay\xE9 (proc\xE9dure de recouvrement)",
      trial_expired: "P\xE9riode d\u2019essai termin\xE9e sans abonnement",
      cancelled: "Abonnement r\xE9sili\xE9",
      platform_admin: "D\xE9cision du support BatiFlow (valid\xE9e par deux administrateurs)"
    },
    requested: "Demand\xE9e le",
    scheduled: "Pr\xE9vue le",
    executed: "Ex\xE9cut\xE9e le",
    removed: "Donn\xE9es supprim\xE9es",
    rows: "Enregistrements supprim\xE9s (dans {tables} tables)",
    objects: "Fichiers supprim\xE9s du stockage",
    tuples: "Droits d\u2019acc\xE8s supprim\xE9s",
    people: "Comptes personnels ferm\xE9s avec l\u2019organisation",
    kept: "Ce qui est conserv\xE9",
    keptText: "Seuls sont conserv\xE9s : le nom et le matricule fiscal de l\u2019organisation (pour ce certificat et les factures \xE9mises par BatiFlow), la pr\xE9sente demande, et le journal d\u2019audit, conserv\xE9 3 ans puis supprim\xE9. Les comptes des personnes membres d\u2019autres organisations sont conserv\xE9s.",
    footer: "Document g\xE9n\xE9r\xE9 automatiquement par BatiFlow. La conservation l\xE9gale des factures pendant 10 ans incombe \xE0 l\u2019organisation, qui a re\xE7u un export complet de ses donn\xE9es avant la suppression ou l\u2019a refus\xE9."
  },
  minutes: {
    heading: "Proc\xE8s-verbal {number}",
    documentTitle: "{number} \u2014 {title}",
    template: {
      coordination: "R\xE9union de coordination",
      moa: "R\xE9union avec le ma\xEEtre d\u2019ouvrage",
      site_meeting: "R\xE9union de chantier",
      site_visit: "Visite de chantier"
    },
    organization: "Bureau",
    project: "Projet",
    heldAt: "Date",
    dateTime: "{date} \xE0 {time}",
    location: "Lieu",
    attendees: "Participants",
    present: "Pr\xE9sents :",
    absent: "Absents ou excus\xE9s :",
    nobody: "Aucun participant enregistr\xE9.",
    points: "Points abord\xE9s",
    decisions: "D\xE9cisions",
    actions: "Actions",
    action: "Action",
    assignee: "Responsable",
    dueDate: "\xC9ch\xE9ance",
    carriedFrom: "report\xE9e du {number}",
    none: "Aucun.",
    footer: "Publi\xE9 par {by} le {date} sur BatiFlow."
  },
  register: {
    heading: "Registre des plans",
    documentTitle: "Registre des plans \u2014 {project}",
    organization: "Bureau",
    project: "Projet",
    generatedOn: "\xC9tabli le {date}",
    scopeDrawing: "Plans uniquement",
    scopeAll: "Tous les documents",
    count: "{count} document(s)",
    code: "Code",
    title: "D\xE9signation",
    scale: "\xC9chelle",
    index: "Indice",
    date: "Date",
    approval: "Approbation",
    transmittals: "Diffusion",
    lastTransmittal: "Derni\xE8re diffusion",
    none: "Aucun document dans le registre.",
    notApproved: "\u2014",
    transmittal: "N\xB0 {number} ({index}) {date}",
    more: "+ {count} autre(s)",
    footer: "Registre g\xE9n\xE9r\xE9 par BatiFlow \xE0 partir des documents que vous pouvez consulter.",
    status: {
      in_progress: "En approbation",
      approved: "Approuv\xE9 (VSO)",
      approved_with_comments: "Approuv\xE9 avec observations (VAO)",
      rejected: "Refus\xE9 (REF)"
    }
  },
  transmittal: {
    heading: "Bordereau d\u2019envoi {number}",
    documentTitle: "{number} \u2014 {title}",
    space: "Espace",
    sentBy: "Envoy\xE9 par",
    sentOn: "Date d\u2019envoi",
    message: "Message",
    documents: "Documents transmis ({count})",
    rank: "N\xB0",
    code: "Code",
    title: "Titre",
    index: "Indice",
    recipients: "Destinataires",
    external: "externe",
    acknowledgement: "Accus\xE9 de r\xE9ception",
    acknowledgementHint: "\xC0 retourner sign\xE9, ou \xE0 confirmer en ligne depuis le lien re\xE7u.",
    ackName: "Nom : \u2026\u2026\u2026\u2026\u2026\u2026\u2026\u2026\u2026\u2026\u2026\u2026\u2026\u2026\u2026\u2026\u2026\u2026",
    ackDate: "Date : \u2026\u2026\u2026\u2026\u2026\u2026\u2026\u2026\u2026\u2026\u2026\u2026\u2026\u2026\u2026\u2026\u2026\u2026",
    ackSignature: "Signature : \u2026\u2026\u2026\u2026\u2026\u2026\u2026\u2026\u2026\u2026\u2026\u2026\u2026\u2026\u2026\u2026\u2026\u2026",
    footer: "Les documents sont transmis dans l\u2019indice indiqu\xE9. \xC9tabli sur BatiFlow."
  },
  receptionReport: {
    heading: "Proc\xE8s-verbal de r\xE9ception {number}",
    documentTitle: "{number} \u2014 {project}",
    project: "Projet",
    heldOn: "Date de la r\xE9ception",
    location: "Lieu",
    notes: "Observations g\xE9n\xE9rales",
    reserves: "R\xE9serves \xE0 lever ({count})",
    number: "N\xB0",
    lot: "Lot",
    contractor: "Entreprise",
    description: "R\xE9serve",
    dueOn: "\xC0 lever avant le",
    plan: "Plan",
    planPage: "{plan}, page {page}",
    noReserve: "Aucune r\xE9serve.",
    sign: {
      client: "Ma\xEEtre d\u2019ouvrage",
      contractor: "Entreprise",
      office: "Bureau d\u2019\xE9tudes"
    },
    signName: "Nom : \u2026\u2026\u2026\u2026\u2026\u2026\u2026\u2026\u2026\u2026\u2026\u2026\u2026\u2026\u2026\u2026\u2026\u2026",
    signDate: "Date : \u2026\u2026\u2026\u2026\u2026\u2026\u2026\u2026\u2026\u2026\u2026\u2026\u2026\u2026\u2026\u2026\u2026\u2026",
    signSignature: "Signature : \u2026\u2026\u2026\u2026\u2026\u2026\u2026\u2026\u2026\u2026\u2026\u2026\u2026\u2026\u2026\u2026\u2026\u2026",
    footer: "Liste des r\xE9serves ouvertes \xE0 la date de la r\xE9ception, \xE9tablie par {by} le {date} sur BatiFlow."
  },
  signatureEvidence: {
    documentTitle: "Certificat de preuve de signature {reference}",
    title: "Certificat de preuve de signature \xE9lectronique",
    intro: "{organization} atteste, par BatiFlow, que le document ci-dessous a \xE9t\xE9 sign\xE9 \xE9lectroniquement ({level}) par les personnes indiqu\xE9es, aux dates indiqu\xE9es.",
    level: {
      simple: "signature simple avec code \xE0 usage unique",
      qualified: "signature qualifi\xE9e par une plateforme agr\xE9\xE9e"
    },
    document: "Document sign\xE9",
    requestTitle: "Objet",
    documentName: "Fichier",
    version: "Version",
    documentHash: "Empreinte SHA-256 du fichier",
    reference: "R\xE9f\xE9rence de la demande",
    requestedBy: "Demand\xE9e par",
    requestedAt: "Demand\xE9e le",
    completedAt: "Sign\xE9e par tous le",
    signers: "Signataires",
    signer: "Signataire",
    email: "Adresse e-mail",
    signedAt: "Sign\xE9 le",
    method: "M\xE9thode",
    methods: {
      email_code: "Code \xE0 usage unique envoy\xE9 par e-mail",
      qualified: "Certificat qualifi\xE9 (plateforme agr\xE9\xE9e)"
    },
    certificate: "Certificat",
    fingerprint: "Empreinte du certificat",
    ip: "Adresse IP",
    userAgent: "Navigateur",
    integrity: "Int\xE9grit\xE9",
    evidenceHash: "Empreinte SHA-256 de la preuve",
    integrityText: "L\u2019empreinte de la preuve est calcul\xE9e sur l\u2019enregistrement complet de la demande (document, signataires, dates, adresses). Toute modification du fichier ou de la preuve change ces empreintes : la v\xE9rification dans BatiFlow les recalcule.",
    footer: "Heures \xE0 l\u2019heure de Tunis (Africa/Tunis). Document g\xE9n\xE9r\xE9 par BatiFlow."
  }
};

// locales/ar/tenders.json
var tenders_default = {
  title: "\u0637\u0644\u0628\u0627\u062A \u0627\u0644\u0639\u0631\u0648\u0636",
  tabs: {
    pipeline: "\u0645\u0633\u0627\u0631 \u0627\u0644\u0645\u062A\u0627\u0628\u0639\u0629",
    vault: "\u062E\u0632\u0646\u0629 \u0627\u0644\u0648\u062B\u0627\u0626\u0642"
  },
  upgrade: {
    title: "\u0637\u0644\u0628\u0627\u062A \u0627\u0644\u0639\u0631\u0648\u0636 \u063A\u064A\u0631 \u0645\u062A\u0636\u0645\u064E\u0651\u0646\u0629 \u0641\u064A \u0639\u0631\u0636\u0643",
    body: "\u0645\u062A\u0627\u0628\u0639\u0629 \u0637\u0644\u0628\u0627\u062A \u0627\u0644\u0639\u0631\u0648\u0636 \u0648\u062E\u0632\u0646\u0629 \u0627\u0644\u0648\u062B\u0627\u0626\u0642 \u0627\u0644\u0625\u062F\u0627\u0631\u064A\u0629 \u0645\u062A\u0627\u062D\u062A\u0627\u0646 \u0641\u064A \u0627\u0644\u0639\u0631\u0648\u0636 \u0627\u0644\u0623\u0639\u0644\u0649. \u0627\u0637\u0644\u0628 \u0645\u0646 \u0645\u0627\u0644\u0643 \u0627\u0644\u062D\u0633\u0627\u0628 \u062A\u063A\u064A\u064A\u0631 \u0627\u0644\u0639\u0631\u0636 \u0644\u062A\u0641\u0639\u064A\u0644\u0647\u0645\u0627."
  },
  sources: {
    tuneps: "\u2066TUNEPS\u2069",
    press: "\u0627\u0644\u0635\u062D\u0627\u0641\u0629",
    client_site: "\u0645\u0648\u0642\u0639 \u0635\u0627\u062D\u0628 \u0627\u0644\u0645\u0634\u0631\u0648\u0639",
    other: "\u0623\u062E\u0631\u0649"
  },
  statuses: {
    watch: "\u0645\u0631\u0627\u0642\u0628\u0629",
    go: "\u0627\u0644\u0645\u0634\u0627\u0631\u0643\u0629 (\u2066Go\u2069)",
    preparing: "\u0642\u064A\u062F \u0627\u0644\u0625\u0639\u062F\u0627\u062F",
    submitted: "\u062A\u0645 \u0627\u0644\u0625\u064A\u062F\u0627\u0639",
    won: "\u062A\u0645 \u0627\u0644\u0641\u0648\u0632",
    lost: "\u0644\u0645 \u064A\u062A\u0645 \u0627\u0644\u0641\u0648\u0632",
    no_go: "\u0639\u062F\u0645 \u0627\u0644\u0645\u0634\u0627\u0631\u0643\u0629 (\u2066No-go\u2069)"
  },
  kinds: {
    tax_certificate: "\u0634\u0647\u0627\u062F\u0629 \u062C\u0628\u0627\u0626\u064A\u0629",
    cnss_certificate: "\u0634\u0647\u0627\u062F\u0629 \u0627\u0644\u0636\u0645\u0627\u0646 \u0627\u0644\u0627\u062C\u062A\u0645\u0627\u0639\u064A (\u2066CNSS\u2069)",
    rne: "\u0645\u0633\u062A\u062E\u0631\u062C \u0645\u0646 \u0627\u0644\u0633\u062C\u0644 \u0627\u0644\u0648\u0637\u0646\u064A \u0644\u0644\u0645\u0624\u0633\u0633\u0627\u062A (\u2066RNE\u2069)",
    agreement: "\u0627\u0639\u062A\u0645\u0627\u062F \u0645\u0647\u0646\u064A",
    order_registration: "\u0627\u0644\u062A\u0631\u0633\u064A\u0645 \u0628\u0627\u0644\u0647\u064A\u0626\u0629 \u0627\u0644\u0645\u0647\u0646\u064A\u0629",
    insurance: "\u062A\u0623\u0645\u064A\u0646",
    cv: "\u0633\u064A\u0631\u0629 \u0630\u0627\u062A\u064A\u0629",
    reference: "\u0645\u0631\u062C\u0639 \u0645\u0634\u0631\u0648\u0639"
  },
  board: {
    label: "\u0645\u0633\u0627\u0631 \u0637\u0644\u0628\u0627\u062A \u0627\u0644\u0639\u0631\u0648\u0636"
  },
  card: {
    reference: "\u0627\u0644\u0645\u0631\u062C\u0639",
    deadline: "\u0627\u0644\u0623\u062C\u0644:",
    bidBond: "\u0627\u0644\u0636\u0645\u0627\u0646 \u0627\u0644\u0648\u0642\u062A\u064A:",
    requirements: "{count} \u0648\u062B\u0627\u0626\u0642 \u062C\u0627\u0647\u0632\u0629",
    noRequirements: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0648\u062B\u0627\u0626\u0642 \u0645\u062F\u0631\u062C\u0629"
  },
  deadline: {
    none: "\u0628\u062F\u0648\u0646 \u0623\u062C\u0644",
    inDays: "\u0628\u0639\u062F {days} \u064A\u0648\u0645",
    today: "\u0627\u0644\u064A\u0648\u0645",
    late: "\u0645\u062A\u0623\u062E\u0631 \u0628\u0640 {days} \u064A\u0648\u0645"
  },
  pipeline: {
    new: "\u0637\u0644\u0628 \u0639\u0631\u0648\u0636 \u062C\u062F\u064A\u062F",
    filtersLabel: "\u0627\u0644\u0628\u062D\u062B \u0641\u064A \u0637\u0644\u0628\u0627\u062A \u0627\u0644\u0639\u0631\u0648\u0636",
    search: "\u0627\u0644\u0628\u062D\u062B \u0639\u0646 \u0637\u0644\u0628 \u0639\u0631\u0648\u0636",
    searchPlaceholder: "\u0627\u0644\u0639\u0646\u0648\u0627\u0646 \u0623\u0648 \u0635\u0627\u062D\u0628 \u0627\u0644\u0645\u0634\u0631\u0648\u0639 \u0623\u0648 \u0627\u0644\u0645\u0631\u062C\u0639",
    loadFailedTitle: "\u062A\u0639\u0630\u0651\u0631 \u062A\u062D\u0645\u064A\u0644 \u0637\u0644\u0628\u0627\u062A \u0627\u0644\u0639\u0631\u0648\u0636",
    loadFailedBody: "\u062A\u062D\u0642\u0642 \u0645\u0646 \u0627\u062A\u0635\u0627\u0644\u0643 \u062B\u0645 \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629.",
    truncated: "\u062A\u064F\u0639\u0631\u0636 \u0623\u062D\u062F\u062B \u0637\u0644\u0628\u0627\u062A \u0627\u0644\u0639\u0631\u0648\u0636 \u0641\u0642\u0637. \u0627\u0633\u062A\u0639\u0645\u0644 \u0627\u0644\u0628\u062D\u062B \u0644\u0644\u0639\u062B\u0648\u0631 \u0639\u0644\u0649 \u0645\u0644\u0641 \u0623\u0642\u062F\u0645.",
    empty: {
      title: "\u0644\u0627 \u064A\u0648\u062C\u062F \u0637\u0644\u0628 \u0639\u0631\u0648\u0636 \u0642\u064A\u062F \u0627\u0644\u0645\u062A\u0627\u0628\u0639\u0629",
      body: "\u0623\u0636\u0641 \u0627\u0644\u0627\u0633\u062A\u0634\u0627\u0631\u0627\u062A \u0627\u0644\u062A\u064A \u062A\u0644\u0627\u062D\u0638\u0647\u0627 \u0639\u0644\u0649 \u0645\u0646\u0635\u0629 \u062A\u0648\u0646\u064A\u0628\u0633 \u0623\u0648 \u0641\u064A \u0627\u0644\u0635\u062D\u0627\u0641\u0629 \u0623\u0648 \u0639\u0644\u0649 \u0645\u0648\u0642\u0639 \u0635\u0627\u062D\u0628 \u0627\u0644\u0645\u0634\u0631\u0648\u0639: \u062A\u0642\u0631\u0651\u0631 \u0627\u0644\u0645\u0634\u0627\u0631\u0643\u0629 \u0645\u0646 \u0639\u062F\u0645\u0647\u0627\u060C \u062B\u0645 \u062A\u062A\u0627\u0628\u0639 \u0627\u0644\u0625\u0639\u062F\u0627\u062F \u0625\u0644\u0649 \u063A\u0627\u064A\u0629 \u0627\u0644\u0646\u062A\u064A\u062C\u0629.",
      filteredTitle: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0646\u062A\u0627\u0626\u062C",
      filteredBody: "\u0644\u0627 \u064A\u0648\u062C\u062F \u0637\u0644\u0628 \u0639\u0631\u0648\u0636 \u0645\u0637\u0627\u0628\u0642 \u0644\u0647\u0630\u0627 \u0627\u0644\u0628\u062D\u062B.",
      clear: "\u0645\u0633\u062D \u0627\u0644\u0628\u062D\u062B"
    }
  },
  move: {
    notAllowed: "\u064A\u062A\u0639\u0630\u0651\u0631 \u0646\u0642\u0644 \xAB{title}\xBB \u0645\u0646 \xAB{from}\xBB \u0625\u0644\u0649 \xAB{to}\xBB: \u0647\u0630\u0647 \u0627\u0644\u0645\u0631\u062D\u0644\u0629 \u0644\u0627 \u062A\u0644\u064A \u0627\u0644\u0645\u0631\u062D\u0644\u0629 \u0627\u0644\u062D\u0627\u0644\u064A\u0629 \u0641\u064A \u0627\u0644\u0645\u0633\u0627\u0631.",
    done: "\u064A\u0646\u062A\u0642\u0644 \xAB{title}\xBB \u0625\u0644\u0649 \u0645\u0631\u062D\u0644\u0629 \xAB{status}\xBB."
  },
  new: {
    title: "\u0637\u0644\u0628 \u0639\u0631\u0648\u0636 \u062C\u062F\u064A\u062F",
    intro: "\u064A\u0628\u062F\u0623 \u0637\u0644\u0628 \u0627\u0644\u0639\u0631\u0648\u0636 \u0641\u064A \u0645\u0631\u062D\u0644\u0629 \xAB\u0645\u0631\u0627\u0642\u0628\u0629\xBB. \u062A\u0642\u0631\u0651\u0631 \u0628\u0639\u062F\u0647\u0627 \u0627\u0644\u0645\u0634\u0627\u0631\u0643\u0629 \u0623\u0648 \u0639\u062F\u0645\u0647\u0627.",
    submit: "\u0625\u0636\u0627\u0641\u0629",
    saving: "\u062C\u0627\u0631\u064D \u0627\u0644\u0625\u0636\u0627\u0641\u0629\u2026",
    done: "\u062A\u0645\u062A \u0625\u0636\u0627\u0641\u0629 \u0637\u0644\u0628 \u0627\u0644\u0639\u0631\u0648\u0636 \xAB{title}\xBB \u0625\u0644\u0649 \u0627\u0644\u0645\u0631\u0627\u0642\u0628\u0629."
  },
  form: {
    title: {
      label: "\u0627\u0644\u0639\u0646\u0648\u0627\u0646"
    },
    source: {
      label: "\u0627\u0644\u0645\u0635\u062F\u0631"
    },
    reference: {
      label: "\u0645\u0631\u062C\u0639 \u0627\u0644\u0627\u0633\u062A\u0634\u0627\u0631\u0629",
      hint: "\u0631\u0642\u0645 \u0627\u0644\u0625\u0639\u0644\u0627\u0646 \u0643\u0645\u0627 \u064A\u0638\u0647\u0631 \u0639\u0644\u0649 \u0645\u0646\u0635\u0629 \u062A\u0648\u0646\u064A\u0628\u0633 \u0623\u0648 \u0641\u064A \u0627\u0644\u0635\u062D\u0627\u0641\u0629."
    },
    buyer: {
      label: "\u0635\u0627\u062D\u0628 \u0627\u0644\u0645\u0634\u0631\u0648\u0639",
      hint: "\u0627\u0644\u0625\u062F\u0627\u0631\u0629 \u0623\u0648 \u0627\u0644\u0634\u0631\u0643\u0629 \u0627\u0644\u062A\u064A \u0623\u0637\u0644\u0642\u062A \u0627\u0644\u0627\u0633\u062A\u0634\u0627\u0631\u0629."
    },
    client: {
      label: "\u062D\u0631\u064A\u0641 \u0627\u0644\u0645\u0643\u062A\u0628",
      hint: "\u0627\u062E\u062A\u064A\u0627\u0631\u064A. \u0627\u0631\u0628\u0637\u0647 \u0628\u062D\u0631\u064A\u0641 \u0645\u0648\u062C\u0648\u062F: \u0633\u064A\u064F\u0646\u0642\u0644 \u0625\u0644\u0649 \u0627\u0644\u0645\u0634\u0631\u0648\u0639.",
      none: "\u0628\u062F\u0648\u0646 \u062D\u0631\u064A\u0641",
      current: "\u0627\u0644\u062D\u0631\u064A\u0641 \u0627\u0644\u062D\u0627\u0644\u064A"
    },
    deadlineDate: {
      label: "\u0622\u062E\u0631 \u0623\u062C\u0644 \u0644\u062A\u0642\u062F\u064A\u0645 \u0627\u0644\u0639\u0631\u0636",
      hint: "\u0622\u062E\u0631 \u064A\u0648\u0645 \u0644\u0625\u064A\u062F\u0627\u0639 \u0627\u0644\u0639\u0631\u0636."
    },
    deadlineTime: {
      label: "\u0627\u0644\u0633\u0627\u0639\u0629 \u0627\u0644\u0642\u0635\u0648\u0649"
    },
    bidBond: {
      label: "\u0627\u0644\u0636\u0645\u0627\u0646 \u0627\u0644\u0648\u0642\u062A\u064A",
      hint: "\u0627\u0644\u0645\u0628\u0644\u063A \u0628\u0627\u0644\u062F\u064A\u0646\u0627\u0631 (TND) \u0627\u0644\u0645\u0637\u0644\u0648\u0628 \u0645\u0639 \u0627\u0644\u0639\u0631\u0636\u060C \u0625\u0646 \u0648\u064F\u062C\u062F."
    },
    errors: {
      required: "\u0647\u0630\u0627 \u0627\u0644\u062D\u0642\u0644 \u0625\u062C\u0628\u0627\u0631\u064A.",
      tooLong: "\u0647\u0630\u0627 \u0627\u0644\u0646\u0635 \u0637\u0648\u064A\u0644 \u062C\u062F\u064B\u0627 (\u0627\u0644\u062D\u062F \u0627\u0644\u0623\u0642\u0635\u0649 {max} \u062D\u0631\u0641\u064B\u0627).",
      timeNeeded: "\u0623\u062F\u062E\u0644 \u0623\u064A\u0636\u064B\u0627 \u0627\u0644\u0633\u0627\u0639\u0629 \u0627\u0644\u0642\u0635\u0648\u0649.",
      dateNeeded: "\u0623\u062F\u062E\u0644 \u0623\u064A\u0636\u064B\u0627 \u0627\u0644\u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0623\u0642\u0635\u0649.",
      timeInvalid: "\u0623\u062F\u062E\u0644 \u0633\u0627\u0639\u0629 \u0635\u062D\u064A\u062D\u0629\u060C \u0645\u062B\u0644\u064B\u0627 10:00."
    }
  },
  detail: {
    tender: "\u0637\u0644\u0628 \u0639\u0631\u0648\u0636",
    notFoundTitle: "\u062A\u0639\u0630\u0651\u0631 \u0627\u0644\u0639\u062B\u0648\u0631 \u0639\u0644\u0649 \u0637\u0644\u0628 \u0627\u0644\u0639\u0631\u0648\u0636 \u0647\u0630\u0627",
    notFoundBody: "\u0631\u0628\u0645\u0627 \u062A\u0645 \u062D\u0630\u0641\u0647\u060C \u0623\u0648 \u0644\u0627 \u062A\u0645\u0644\u0643 \u0635\u0644\u0627\u062D\u064A\u0629 \u0627\u0644\u0648\u0635\u0648\u0644 \u0625\u0644\u064A\u0647.",
    backToPipeline: "\u0627\u0644\u0639\u0648\u062F\u0629 \u0625\u0644\u0649 \u0627\u0644\u0645\u0633\u0627\u0631",
    loadFailedTitle: "\u062A\u0639\u0630\u0651\u0631 \u062A\u062D\u0645\u064A\u0644 \u0637\u0644\u0628 \u0627\u0644\u0639\u0631\u0648\u0636",
    loadFailedBody: "\u062A\u062D\u0642\u0642 \u0645\u0646 \u0627\u062A\u0635\u0627\u0644\u0643 \u062B\u0645 \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629.",
    delete: "\u062D\u0630\u0641",
    deleteTitle: "\u062D\u0630\u0641 \xAB{title}\xBB\u061F",
    deleteBody: "\u0633\u064A\u062A\u0645 \u062D\u0630\u0641 \u0637\u0644\u0628 \u0627\u0644\u0639\u0631\u0648\u0636 \u0648\u0642\u0627\u0626\u0645\u0629 \u0648\u062B\u0627\u0626\u0642\u0647 \u0646\u0647\u0627\u0626\u064A\u064B\u0627. \u0648\u062B\u0627\u0626\u0642 \u0627\u0644\u062E\u0632\u0646\u0629 \u0644\u0627 \u062A\u062A\u0623\u062B\u0631.",
    deleted: "\u062A\u0645 \u062D\u0630\u0641 \u0637\u0644\u0628 \u0627\u0644\u0639\u0631\u0648\u0636."
  },
  status: {
    title: "\u0627\u0644\u062A\u0642\u062F\u0651\u0645",
    since: "\u0645\u0646\u0630",
    note: "\u0645\u0644\u0627\u062D\u0638\u0629:",
    noteField: {
      label: "\u0645\u0644\u0627\u062D\u0638\u0629 (\u0627\u062E\u062A\u064A\u0627\u0631\u064A\u0629)",
      hint: "\u0645\u062B\u0644\u064B\u0627 \u0633\u0628\u0628 \u0639\u062F\u0645 \u0627\u0644\u0645\u0634\u0627\u0631\u0643\u0629 \u0623\u0648 \u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0625\u064A\u062F\u0627\u0639 \u0623\u0648 \u0646\u062A\u064A\u062C\u0629 \u0641\u062A\u062D \u0627\u0644\u0623\u0638\u0631\u0641\u0629. \u062A\u062D\u0644 \u0645\u062D\u0644 \u0627\u0644\u0645\u0644\u0627\u062D\u0638\u0629 \u0627\u0644\u0633\u0627\u0628\u0642\u0629."
    },
    actionsLabel: "\u0627\u0644\u0645\u0631\u0627\u062D\u0644 \u0627\u0644\u0645\u0645\u0643\u0646\u0629",
    actions: {
      watch: "\u0625\u0639\u0627\u062F\u062A\u0647 \u0625\u0644\u0649 \u0627\u0644\u0645\u0631\u0627\u0642\u0628\u0629",
      go: "\u0642\u0631\u0627\u0631 \u0627\u0644\u0645\u0634\u0627\u0631\u0643\u0629",
      no_go: "\u0639\u062F\u0645 \u0627\u0644\u0645\u0634\u0627\u0631\u0643\u0629",
      preparing: "\u0628\u062F\u0621 \u0627\u0644\u0625\u0639\u062F\u0627\u062F",
      submitted: "\u062A\u0633\u062C\u064A\u0644\u0647 \u0643\u0645\u0648\u062F\u064E\u0639",
      won: "\u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u0641\u0648\u0632 \u0628\u0647",
      lost: "\u062A\u0633\u062C\u064A\u0644\u0647 \u0643\u062E\u0627\u0633\u0631"
    },
    final: {
      won: "\u062A\u0645 \u0627\u0644\u0641\u0648\u0632 \u0628\u0637\u0644\u0628 \u0627\u0644\u0639\u0631\u0648\u0636 \u0647\u0630\u0627: \u0644\u0645 \u062A\u0639\u062F \u0645\u0631\u062D\u0644\u062A\u0647 \u062A\u062A\u063A\u064A\u0631. \u062D\u0648\u0651\u0644\u0647 \u0625\u0644\u0649 \u0645\u0634\u0631\u0648\u0639 \u0644\u0628\u062F\u0621 \u0627\u0644\u0645\u0647\u0645\u0629.",
      lost: "\u0644\u0645 \u064A\u062A\u0645 \u0627\u0644\u0641\u0648\u0632 \u0628\u0637\u0644\u0628 \u0627\u0644\u0639\u0631\u0648\u0636 \u0647\u0630\u0627: \u0644\u0645 \u062A\u0639\u062F \u0645\u0631\u062D\u0644\u062A\u0647 \u062A\u062A\u063A\u064A\u0631."
    }
  },
  project: {
    title: "\u0627\u0644\u0645\u0634\u0631\u0648\u0639",
    converted: "\u062A\u0645 \u062A\u062D\u0648\u064A\u0644 \u0637\u0644\u0628 \u0627\u0644\u0639\u0631\u0648\u0636 \u0647\u0630\u0627 \u0625\u0644\u0649 \u0645\u0634\u0631\u0648\u0639.",
    wonNotConverted: "\u0645\u0628\u0631\u0648\u0643! \u062D\u0648\u0651\u0644 \u0637\u0644\u0628 \u0627\u0644\u0639\u0631\u0648\u0636 \u0625\u0644\u0649 \u0645\u0634\u0631\u0648\u0639 \u0644\u0646\u0642\u0644 \u0639\u0646\u0648\u0627\u0646\u0647 \u0648\u062D\u0631\u064A\u0641\u0647 \u0648\u062A\u0648\u0627\u0631\u064A\u062E\u0647."
  },
  sheet: {
    title: "\u0628\u0637\u0627\u0642\u0629 \u0637\u0644\u0628 \u0627\u0644\u0639\u0631\u0648\u0636",
    save: "\u062D\u0641\u0638 \u0627\u0644\u062A\u0639\u062F\u064A\u0644\u0627\u062A",
    saving: "\u062C\u0627\u0631\u064D \u0627\u0644\u062D\u0641\u0638\u2026",
    saved: "\u062A\u0645 \u062D\u0641\u0638 \u0627\u0644\u0628\u0637\u0627\u0642\u0629.",
    nothingToSave: "\u0644\u0627 \u062A\u0648\u062C\u062F \u062A\u0639\u062F\u064A\u0644\u0627\u062A \u0644\u0644\u062D\u0641\u0638."
  },
  requirements: {
    title: "\u0627\u0644\u0648\u062B\u0627\u0626\u0642 \u0627\u0644\u0645\u0637\u0644\u0648\u0628\u0629",
    progress: "{count} \u062C\u0627\u0647\u0632\u0629",
    listLabel: "\u0627\u0644\u0648\u062B\u0627\u0626\u0642 \u0627\u0644\u0645\u0637\u0644\u0648\u0628\u0629 \u0644\u0637\u0644\u0628 \u0627\u0644\u0639\u0631\u0648\u0636 \u0647\u0630\u0627",
    empty: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0648\u062B\u0627\u0626\u0642 \u0645\u062F\u0631\u062C\u0629. \u0623\u0636\u0641 \u0627\u0644\u0648\u062B\u0627\u0626\u0642 \u0627\u0644\u062A\u064A \u064A\u0637\u0644\u0628\u0647\u0627 \u0627\u0644\u0625\u0639\u0644\u0627\u0646: \u0634\u0647\u0627\u062F\u0627\u062A\u060C \u0645\u0631\u0627\u062C\u0639\u060C \u0633\u064A\u0631 \u0630\u0627\u062A\u064A\u0629\u2026",
    addForm: "\u0625\u0636\u0627\u0641\u0629 \u0648\u062B\u064A\u0642\u0629 \u0645\u0637\u0644\u0648\u0628\u0629",
    addLabel: "\u0648\u062B\u064A\u0642\u0629 \u0645\u0637\u0644\u0648\u0628\u0629 \u062C\u062F\u064A\u062F\u0629",
    addPlaceholder: "\u0645\u062B\u0644\u064B\u0627: \u0634\u0647\u0627\u062F\u0629 \u0641\u064A \u0627\u0644\u0648\u0636\u0639\u064A\u0629 \u0627\u0644\u062C\u0628\u0627\u0626\u064A\u0629",
    add: "\u0625\u0636\u0627\u0641\u0629",
    full: "\u0627\u0644\u0642\u0627\u0626\u0645\u0629 \u0645\u0645\u062A\u0644\u0626\u0629 ({max} \u0648\u062B\u064A\u0642\u0629 \u0643\u062D\u062F \u0623\u0642\u0635\u0649).",
    rename: "\u0625\u0639\u0627\u062F\u0629 \u062A\u0633\u0645\u064A\u0629 \xAB{label}\xBB",
    renameLabel: "\u0627\u0644\u0627\u0633\u0645 \u0627\u0644\u062C\u062F\u064A\u062F \u0644\u0640 \xAB{label}\xBB",
    renameSave: "\u062D\u0641\u0638 \u0627\u0644\u0627\u0633\u0645",
    renameCancel: "\u0625\u0644\u063A\u0627\u0621 \u0625\u0639\u0627\u062F\u0629 \u0627\u0644\u062A\u0633\u0645\u064A\u0629",
    remove: "\u0625\u0632\u0627\u0644\u0629 \xAB{label}\xBB \u0645\u0646 \u0627\u0644\u0642\u0627\u0626\u0645\u0629",
    removeTitle: "\u0625\u0632\u0627\u0644\u0629 \xAB{label}\xBB \u0645\u0646 \u0627\u0644\u0642\u0627\u0626\u0645\u0629\u061F",
    removeBody: "\u064A\u064F\u0632\u0627\u0644 \u0633\u0637\u0631 \u0627\u0644\u0642\u0627\u0626\u0645\u0629 \u0641\u0642\u0637\u061B \u0648\u062B\u064A\u0642\u0629 \u0627\u0644\u062E\u0632\u0646\u0629 \u0644\u0627 \u062A\u064F\u062D\u0630\u0641.",
    removed: "\u062A\u0645\u062A \u0625\u0632\u0627\u0644\u0629 \u0627\u0644\u0648\u062B\u064A\u0642\u0629 \u0645\u0646 \u0627\u0644\u0642\u0627\u0626\u0645\u0629.",
    vaultPicker: "\u0648\u062B\u064A\u0642\u0629 \u0627\u0644\u062E\u0632\u0646\u0629 \u0627\u0644\u062E\u0627\u0635\u0629 \u0628\u0640 \xAB{label}\xBB",
    noVaultDocument: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0648\u062B\u064A\u0642\u0629 \u0645\u0631\u062A\u0628\u0637\u0629 \u0645\u0646 \u0627\u0644\u062E\u0632\u0646\u0629",
    vaultEmpty: "\u0627\u0644\u062E\u0632\u0646\u0629 \u0641\u0627\u0631\u063A\u0629: \u0623\u0636\u0641 \u0625\u0644\u064A\u0647\u0627 \u0634\u0647\u0627\u062F\u0627\u062A\u0643 \u0644\u0631\u0628\u0637\u0647\u0627 \u0647\u0646\u0627."
  },
  convert: {
    button: "\u062A\u062D\u0648\u064A\u0644 \u0625\u0644\u0649 \u0645\u0634\u0631\u0648\u0639",
    title: "\u062A\u062D\u0648\u064A\u0644 \u0625\u0644\u0649 \u0645\u0634\u0631\u0648\u0639",
    intro: "\u064A\u0623\u062E\u0630 \u0627\u0644\u0645\u0634\u0631\u0648\u0639 \u0639\u0646\u0648\u0627\u0646 \u0637\u0644\u0628 \u0627\u0644\u0639\u0631\u0648\u0636 \u0648\u062D\u0631\u064A\u0641\u0647. \u0644\u0627 \u064A\u062A\u0645 \u0647\u0630\u0627 \u0627\u0644\u062A\u062D\u0648\u064A\u0644 \u0625\u0644\u0627 \u0645\u0631\u0629 \u0648\u0627\u062D\u062F\u0629.",
    missionType: {
      label: "\u0646\u0648\u0639 \u0627\u0644\u0645\u0647\u0645\u0629"
    },
    name: {
      label: "\u0627\u0633\u0645 \u0627\u0644\u0645\u0634\u0631\u0648\u0639",
      hint: "\u0627\u0641\u062A\u0631\u0627\u0636\u064A\u064B\u0627\u060C \u0639\u0646\u0648\u0627\u0646 \u0637\u0644\u0628 \u0627\u0644\u0639\u0631\u0648\u0636."
    },
    startsOn: "\u0628\u062F\u0627\u064A\u0629 \u0627\u0644\u0645\u0634\u0631\u0648\u0639",
    endsOn: "\u0627\u0644\u0646\u0647\u0627\u064A\u0629 \u0627\u0644\u0645\u062A\u0648\u0642\u0639\u0629",
    submit: "\u062A\u062D\u0648\u064A\u0644",
    submitting: "\u062C\u0627\u0631\u064D \u0627\u0644\u062A\u062D\u0648\u064A\u0644\u2026",
    done: "\u062A\u0645 \u0625\u0646\u0634\u0627\u0621 \u0627\u0644\u0645\u0634\u0631\u0648\u0639 \xAB{name}\xBB.",
    alreadyDone: "\u062A\u0645 \u062A\u062D\u0648\u064A\u0644 \u0637\u0644\u0628 \u0627\u0644\u0639\u0631\u0648\u0636 \u0647\u0630\u0627 \u0625\u0644\u0649 \u0645\u0634\u0631\u0648\u0639 \u0645\u0646 \u0642\u0628\u0644.",
    doneTitle: "\u062A\u0645 \u0625\u0646\u0634\u0627\u0621 \u0627\u0644\u0645\u0634\u0631\u0648\u0639",
    doneBody: "\u0627\u0644\u0645\u0634\u0631\u0648\u0639 \u062C\u0627\u0647\u0632 \u0628\u0645\u0631\u0627\u062D\u0644\u0647 \u0648\u0645\u062C\u0644\u062F\u0627\u062A\u0647.",
    alreadyBody: "\u062A\u0645 \u062A\u062D\u0648\u064A\u0644 \u0637\u0644\u0628 \u0627\u0644\u0639\u0631\u0648\u0636 \u0647\u0630\u0627 \u0645\u0646 \u0642\u0628\u0644: \u0644\u0645 \u064A\u062A\u0645 \u0625\u0646\u0634\u0627\u0621 \u0645\u0634\u0631\u0648\u0639 \u062B\u0627\u0646\u064D.",
    openProject: "\u0641\u062A\u062D \u0627\u0644\u0645\u0634\u0631\u0648\u0639",
    errors: {
      endBeforeStart: "\u0644\u0627 \u064A\u0645\u0643\u0646 \u0623\u0646 \u062A\u0633\u0628\u0642 \u0627\u0644\u0646\u0647\u0627\u064A\u0629 \u0627\u0644\u0645\u062A\u0648\u0642\u0639\u0629 \u0627\u0644\u0628\u062F\u0627\u064A\u0629.",
      forbidden: "\u062A\u062D\u0648\u064A\u0644 \u0637\u0644\u0628 \u0639\u0631\u0648\u0636 \u0625\u0644\u0649 \u0645\u0634\u0631\u0648\u0639 \u064A\u062A\u0637\u0644\u0628 \u0623\u064A\u0636\u064B\u0627 \u0635\u0644\u0627\u062D\u064A\u0629 \u0625\u0646\u0634\u0627\u0621 \u0627\u0644\u0645\u0634\u0627\u0631\u064A\u0639. \u0627\u0637\u0644\u0628\u0647\u0627 \u0645\u0646 \u0623\u062D\u062F \u0627\u0644\u0645\u0633\u0624\u0648\u0644\u064A\u0646."
    }
  },
  picker: {
    where: "\u0627\u0644\u0645\u062C\u0644\u062F:",
    root: "\u0648\u062B\u0627\u0626\u0642 \u0627\u0644\u0645\u0643\u062A\u0628",
    up: "\u0627\u0644\u0645\u062C\u0644\u062F \u0627\u0644\u0623\u0635\u0644\u064A",
    folder: "\u0645\u062C\u0644\u062F \u0641\u0631\u0639\u064A",
    openFolder: "\u0641\u062A\u062D \u0645\u062C\u0644\u062F\u2026",
    file: "\u0627\u0644\u0645\u0644\u0641",
    pickFile: "\u0627\u062E\u062A\u064A\u0627\u0631 \u0645\u0644\u0641\u2026",
    noFile: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0645\u0644\u0641\u0627\u062A \u0641\u064A \u0647\u0630\u0627 \u0627\u0644\u0645\u062C\u0644\u062F",
    loadFailed: "\u062A\u0639\u0630\u0651\u0631 \u062A\u062D\u0645\u064A\u0644 \u0648\u062B\u0627\u0626\u0642 \u0627\u0644\u0645\u0643\u062A\u0628. \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629 \u0628\u0639\u062F \u0642\u0644\u064A\u0644.",
    noSpace: "\u0641\u0636\u0627\u0621 \u0648\u062B\u0627\u0626\u0642 \u0627\u0644\u0645\u0643\u062A\u0628 \u063A\u064A\u0631 \u0645\u062A\u0627\u062D."
  },
  vault: {
    intro: "\u0627\u0644\u0648\u062B\u0627\u0626\u0642 \u0627\u0644\u0625\u062F\u0627\u0631\u064A\u0629 \u0627\u0644\u062A\u064A \u062A\u0631\u0641\u0642\u0647\u0627 \u0628\u0639\u0631\u0648\u0636\u0643\u060C \u0645\u0639 \u062A\u0627\u0631\u064A\u062E \u0627\u0646\u062A\u0647\u0627\u0621 \u0635\u0644\u0627\u062D\u064A\u062A\u0647\u0627. \u064A\u0635\u0644\u0643 \u062A\u0646\u0628\u064A\u0647 \u0642\u0628\u0644 {days} \u064A\u0648\u0645\u064B\u0627 \u0645\u0646 \u0627\u0646\u062A\u0647\u0627\u0621 \u0627\u0644\u0635\u0644\u0627\u062D\u064A\u0629.",
    add: "\u0625\u0636\u0627\u0641\u0629 \u0648\u062B\u064A\u0642\u0629",
    tableLabel: "\u0648\u062B\u0627\u0626\u0642 \u0627\u0644\u062E\u0632\u0646\u0629",
    scrollLabel: "\u0648\u062B\u0627\u0626\u0642 \u0627\u0644\u062E\u0632\u0646\u0629\u060C \u062C\u062F\u0648\u0644 \u0642\u0627\u0628\u0644 \u0644\u0644\u062A\u0645\u0631\u064A\u0631",
    columns: {
      label: "\u0627\u0644\u0648\u062B\u064A\u0642\u0629",
      kind: "\u0627\u0644\u0646\u0648\u0639",
      file: "\u0627\u0644\u0645\u0644\u0641",
      issuedOn: "\u062A\u0627\u0631\u064A\u062E \u0627\u0644\u062A\u0633\u0644\u064A\u0645",
      expiresOn: "\u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0627\u0646\u062A\u0647\u0627\u0621",
      state: "\u0627\u0644\u062D\u0627\u0644\u0629",
      actions: "\u0627\u0644\u0625\u062C\u0631\u0627\u0621\u0627\u062A"
    },
    noFile: "\u0628\u062F\u0648\u0646 \u0645\u0644\u0641",
    noDate: "\u063A\u064A\u0631 \u0645\u062D\u062F\u062F",
    states: {
      valid: "\u0633\u0627\u0631\u064A\u0629",
      expiring: "\u062A\u0646\u062A\u0647\u064A \u0628\u0639\u062F {days} \u064A\u0648\u0645",
      expiringToday: "\u062A\u0646\u062A\u0647\u064A \u0627\u0644\u064A\u0648\u0645",
      expired: "\u0627\u0646\u062A\u0647\u062A \u0645\u0646\u0630 {days} \u064A\u0648\u0645",
      no_expiry: "\u0628\u062F\u0648\u0646 \u0623\u062C\u0644"
    },
    filters: {
      label: "\u062A\u0635\u0641\u064A\u0629 \u0627\u0644\u0648\u062B\u0627\u0626\u0642",
      kind: "\u0627\u0644\u062A\u0635\u0641\u064A\u0629 \u062D\u0633\u0628 \u0627\u0644\u0646\u0648\u0639",
      state: "\u0627\u0644\u062A\u0635\u0641\u064A\u0629 \u062D\u0633\u0628 \u0627\u0644\u062D\u0627\u0644\u0629",
      allKinds: "\u0643\u0644 \u0627\u0644\u0623\u0646\u0648\u0627\u0639",
      allStates: "\u0643\u0644 \u0627\u0644\u062D\u0627\u0644\u0627\u062A",
      states: {
        valid: "\u0627\u0644\u0633\u0627\u0631\u064A\u0629",
        expiring: "\u0642\u0631\u064A\u0628\u0629 \u0627\u0644\u0627\u0646\u062A\u0647\u0627\u0621",
        expired: "\u0627\u0644\u0645\u0646\u062A\u0647\u064A\u0629",
        no_expiry: "\u0628\u062F\u0648\u0646 \u0623\u062C\u0644"
      }
    },
    editLabel: "\u062A\u0639\u062F\u064A\u0644 \xAB{label}\xBB",
    deleteLabel: "\u062D\u0630\u0641 \xAB{label}\xBB",
    deleteTitle: "\u062D\u0630\u0641 \xAB{label}\xBB\u061F",
    deleteBody: "\u062A\u064F\u0632\u0627\u0644 \u0627\u0644\u0648\u062B\u064A\u0642\u0629 \u0645\u0646 \u0627\u0644\u062E\u0632\u0646\u0629. \u064A\u0628\u0642\u0649 \u0627\u0644\u0645\u0644\u0641 \u0636\u0645\u0646 \u0648\u062B\u0627\u0626\u0642 \u0627\u0644\u0645\u0643\u062A\u0628.",
    deleted: "\u062A\u0645 \u062D\u0630\u0641 \u0627\u0644\u0648\u062B\u064A\u0642\u0629 \u0645\u0646 \u0627\u0644\u062E\u0632\u0646\u0629.",
    loadFailedTitle: "\u062A\u0639\u0630\u0651\u0631 \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u062E\u0632\u0646\u0629",
    loadFailedBody: "\u062A\u062D\u0642\u0642 \u0645\u0646 \u0627\u062A\u0635\u0627\u0644\u0643 \u062B\u0645 \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629.",
    empty: {
      title: "\u062E\u0632\u0646\u062A\u0643 \u0641\u0627\u0631\u063A\u0629",
      body: "\u0627\u062D\u0641\u0638 \u0647\u0646\u0627 \u0627\u0644\u0634\u0647\u0627\u062F\u0627\u062A \u0648\u0627\u0644\u0645\u0633\u062A\u062E\u0631\u062C\u0627\u062A \u0648\u0627\u0644\u062A\u0623\u0645\u064A\u0646\u0627\u062A \u0648\u0627\u0644\u0633\u064A\u0631 \u0627\u0644\u0630\u0627\u062A\u064A\u0629 \u0648\u0627\u0644\u0645\u0631\u0627\u062C\u0639 \u0627\u0644\u062A\u064A \u064A\u0637\u0644\u0628\u0647\u0627 \u0643\u0644 \u0645\u0644\u0641 \u0637\u0644\u0628 \u0639\u0631\u0648\u0636. \u064A\u0646\u0628\u0651\u0647\u0643 BatiFlow \u0642\u0628\u0644 {days} \u064A\u0648\u0645\u064B\u0627 \u0645\u0646 \u0627\u0646\u062A\u0647\u0627\u0621 \u0635\u0644\u0627\u062D\u064A\u0629 \u0643\u0644 \u0648\u062B\u064A\u0642\u0629.",
      filteredTitle: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0648\u062B\u064A\u0642\u0629 \u0645\u0637\u0627\u0628\u0642\u0629",
      filteredBody: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0648\u062B\u064A\u0642\u0629 \u0645\u0637\u0627\u0628\u0642\u0629 \u0644\u0647\u0630\u0647 \u0627\u0644\u0645\u0631\u0634\u062D\u0627\u062A.",
      clear: "\u0645\u0633\u062D \u0627\u0644\u0645\u0631\u0634\u062D\u0627\u062A"
    },
    errors: {
      expiryBeforeIssue: "\u0644\u0627 \u064A\u0645\u0643\u0646 \u0623\u0646 \u064A\u0633\u0628\u0642 \u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0627\u0646\u062A\u0647\u0627\u0621 \u062A\u0627\u0631\u064A\u062E \u0627\u0644\u062A\u0633\u0644\u064A\u0645."
    },
    dialog: {
      addTitle: "\u0625\u0636\u0627\u0641\u0629 \u0648\u062B\u064A\u0642\u0629",
      editTitle: "\u062A\u0639\u062F\u064A\u0644 \u0627\u0644\u0648\u062B\u064A\u0642\u0629",
      kind: "\u0646\u0648\u0639 \u0627\u0644\u0648\u062B\u064A\u0642\u0629",
      label: "\u0627\u0644\u0639\u0646\u0648\u0627\u0646",
      labelHint: "\u0645\u0627 \u0647\u064A \u0627\u0644\u0648\u062B\u064A\u0642\u0629: \u0639\u0646\u0648\u0627\u0646 \u0627\u0644\u0634\u0647\u0627\u062F\u0629\u060C \u0623\u0648 \u0627\u0633\u0645 \u0635\u0627\u062D\u0628 \u0627\u0644\u0633\u064A\u0631\u0629 \u0627\u0644\u0630\u0627\u062A\u064A\u0629\u060C \u0623\u0648 \u0645\u0634\u0631\u0648\u0639 \u0627\u0644\u0645\u0631\u062C\u0639.",
      issuedOn: "\u062A\u0627\u0631\u064A\u062E \u0627\u0644\u062A\u0633\u0644\u064A\u0645",
      expiresOn: "\u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0627\u0646\u062A\u0647\u0627\u0621",
      expiresHint: "\u064A\u064F\u0631\u0633\u0644 \u062A\u0646\u0628\u064A\u0647 \u0642\u0628\u0644 {days} \u064A\u0648\u0645\u064B\u0627.",
      file: "\u0627\u0644\u0645\u0644\u0641",
      noFile: "\u0644\u0627 \u064A\u0648\u062C\u062F \u0645\u0644\u0641 \u0645\u0631\u062A\u0628\u0637",
      fileChosen: "\u062A\u0645 \u0627\u062E\u062A\u064A\u0627\u0631 \u0645\u0644\u0641",
      fileHint: "\u064A\u062C\u0628 \u0623\u0646 \u064A\u0643\u0648\u0646 \u0627\u0644\u0645\u0644\u0641 \u0645\u0648\u062C\u0648\u062F\u064B\u0627 \u0645\u0633\u0628\u0642\u064B\u0627 \u0636\u0645\u0646 \u0648\u062B\u0627\u0626\u0642 \u0645\u0643\u062A\u0628\u0643. \u0627\u0631\u0641\u0639\u0647 \u0623\u0648\u0644\u064B\u0627 \u0641\u064A \u0642\u0633\u0645 \u0627\u0644\u0645\u0644\u0641\u0627\u062A \u062B\u0645 \u0639\u062F \u0644\u0627\u062E\u062A\u064A\u0627\u0631\u0647 \u0647\u0646\u0627.",
      chooseFile: "\u0627\u062E\u062A\u064A\u0627\u0631 \u0645\u0644\u0641",
      changeFile: "\u062A\u063A\u064A\u064A\u0631 \u0627\u0644\u0645\u0644\u0641",
      removeFile: "\u0625\u0632\u0627\u0644\u0629 \u0627\u0644\u0645\u0644\u0641",
      add: "\u0625\u0636\u0627\u0641\u0629 \u0627\u0644\u0648\u062B\u064A\u0642\u0629",
      save: "\u062D\u0641\u0638",
      saving: "\u062C\u0627\u0631\u064D \u0627\u0644\u062D\u0641\u0638\u2026",
      added: "\u062A\u0645\u062A \u0625\u0636\u0627\u0641\u0629 \u0627\u0644\u0648\u062B\u064A\u0642\u0629 \xAB{label}\xBB \u0625\u0644\u0649 \u0627\u0644\u062E\u0632\u0646\u0629.",
      updated: "\u062A\u0645 \u062A\u062D\u062F\u064A\u062B \u0627\u0644\u0648\u062B\u064A\u0642\u0629 \xAB{label}\xBB."
    }
  },
  errors: {
    TENDER_STATUS_TRANSITION: "\u0647\u0630\u0627 \u0627\u0644\u062A\u063A\u064A\u064A\u0631 \u0641\u064A \u0627\u0644\u0645\u0631\u062D\u0644\u0629 \u063A\u064A\u0631 \u0645\u0645\u0643\u0646 \u0627\u0646\u0637\u0644\u0627\u0642\u064B\u0627 \u0645\u0646 \u0627\u0644\u0645\u0631\u062D\u0644\u0629 \u0627\u0644\u062D\u0627\u0644\u064A\u0629 \u0644\u0637\u0644\u0628 \u0627\u0644\u0639\u0631\u0648\u0636. \u0623\u0639\u062F \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0635\u0641\u062D\u0629 \u0644\u0645\u0639\u0631\u0641\u0629 \u0648\u0636\u0639\u0647.",
    TENDER_NOT_DELETABLE: "\u0644\u0627 \u064A\u0645\u0643\u0646 \u062D\u0630\u0641 \u0625\u0644\u0627 \u0637\u0644\u0628 \u0639\u0631\u0648\u0636 \u0641\u064A \u0627\u0644\u0645\u0631\u0627\u0642\u0628\u0629 \u0623\u0648 \u0627\u0644\u0645\u0633\u062A\u0628\u0639\u062F (\u0639\u062F\u0645 \u0627\u0644\u0645\u0634\u0627\u0631\u0643\u0629) \u0623\u0648 \u0627\u0644\u062E\u0627\u0633\u0631\u060C \u0648\u0644\u0645 \u064A\u064F\u062D\u0648\u064E\u0651\u0644 \u0642\u0637 \u0625\u0644\u0649 \u0645\u0634\u0631\u0648\u0639.",
    TENDER_NOT_WON: "\u0644\u0627 \u064A\u0645\u0643\u0646 \u062A\u062D\u0648\u064A\u0644 \u0625\u0644\u0649 \u0645\u0634\u0631\u0648\u0639 \u0625\u0644\u0627 \u0637\u0644\u0628 \u0639\u0631\u0648\u0636 \u062A\u0645 \u0627\u0644\u0641\u0648\u0632 \u0628\u0647.",
    VAULT_DOCUMENT_UNKNOWN: "\u0627\u062E\u062A\u0631 \u0648\u062B\u064A\u0642\u0629 \u0645\u0646 \u062E\u0632\u0646\u062A\u0643.",
    VAULT_DOCUMENT_FILE_INVALID: "\u0627\u062E\u062A\u0631 \u0645\u0644\u0641\u064B\u0627 \u0645\u0646 \u0648\u062B\u0627\u0626\u0642 \u0645\u0643\u062A\u0628\u0643 (\u0627\u0644\u0645\u0644\u0641\u0627\u062A\u060C \u062A\u0628\u0648\u064A\u0628 \u0627\u0644\u0645\u0624\u0633\u0633\u0629).",
    VAULT_DOCUMENT_IN_USE: "\u0647\u0630\u0647 \u0627\u0644\u0648\u062B\u064A\u0642\u0629 \u0645\u0633\u062A\u0639\u0645\u0644\u0629 \u0641\u064A \u0642\u0627\u0626\u0645\u0629 \u0648\u062B\u0627\u0626\u0642 \u0637\u0644\u0628 \u0639\u0631\u0648\u0636: \u0623\u0632\u0644\u0647\u0627 \u0645\u0646 \u062A\u0644\u0643 \u0627\u0644\u0642\u0627\u0626\u0645\u0629 \u0623\u0648\u0644\u064B\u0627 \u062B\u0645 \u0627\u062D\u0630\u0641\u0647\u0627."
  }
};

// locales/en/tenders.json
var tenders_default2 = {
  title: "Tenders",
  tabs: {
    pipeline: "Pipeline",
    vault: "Document vault"
  },
  upgrade: {
    title: "Tenders are not included in your plan",
    body: "Tender tracking and the vault of administrative documents are part of the higher plans. Ask the account owner to change plan to turn them on."
  },
  sources: {
    tuneps: "TUNEPS",
    press: "Press",
    client_site: "Client's website",
    other: "Other"
  },
  statuses: {
    watch: "Watch",
    go: "Go",
    preparing: "Preparing",
    submitted: "Submitted",
    won: "Won",
    lost: "Lost",
    no_go: "No-go"
  },
  kinds: {
    tax_certificate: "Tax certificate",
    cnss_certificate: "CNSS certificate",
    rne: "RNE extract",
    agreement: "Professional approval",
    order_registration: "Order registration",
    insurance: "Insurance",
    cv: "CV",
    reference: "Project reference"
  },
  board: {
    label: "Tender pipeline"
  },
  card: {
    reference: "Ref.",
    deadline: "Deadline:",
    bidBond: "Bid bond:",
    requirements: "{count} documents ready",
    noRequirements: "No documents listed"
  },
  deadline: {
    none: "No deadline",
    inDays: "D-{days}",
    today: "Today",
    late: "{days} d overdue"
  },
  pipeline: {
    new: "New tender",
    filtersLabel: "Search the tenders",
    search: "Search for a tender",
    searchPlaceholder: "Title, contracting authority or reference",
    loadFailedTitle: "Could not load the tenders",
    loadFailedBody: "Check your connection, then try again.",
    truncated: "Only the most recent tenders are shown. Use the search to find an older one.",
    empty: {
      title: "No tender followed yet",
      body: "Add the consultations you notice on TUNEPS, in the press or on a client's website: you decide whether to go for them, then follow the preparation through to the result.",
      filteredTitle: "No results",
      filteredBody: "No tender matches this search.",
      clear: "Clear the search"
    }
  },
  move: {
    notAllowed: 'Cannot move "{title}" from "{from}" to "{to}": that step does not follow the current one in the pipeline.',
    done: '"{title}" moves to "{status}".'
  },
  new: {
    title: "New tender",
    intro: 'The tender starts in "Watch". You then decide whether to go for it (Go) or not (No-go).',
    submit: "Add",
    saving: "Adding\u2026",
    done: 'The tender "{title}" is added to the watch list.'
  },
  form: {
    title: {
      label: "Title"
    },
    source: {
      label: "Source"
    },
    reference: {
      label: "Consultation reference",
      hint: "The notice number, as shown on TUNEPS or in the press."
    },
    buyer: {
      label: "Contracting authority",
      hint: "The administration or company issuing the consultation."
    },
    client: {
      label: "Office's client",
      hint: "Optional. Link it to an existing client: it carries over to the project.",
      none: "No client",
      current: "Current client"
    },
    deadlineDate: {
      label: "Submission deadline",
      hint: "The last day to submit the bid."
    },
    deadlineTime: {
      label: "Deadline time"
    },
    bidBond: {
      label: "Provisional bid bond",
      hint: "Amount in dinars (TND) required with the bid, if any."
    },
    errors: {
      required: "This field is required.",
      tooLong: "This text is too long (maximum {max} characters).",
      timeNeeded: "Also give the deadline time.",
      dateNeeded: "Also give the deadline date.",
      timeInvalid: "Enter a valid time, for example 10:00."
    }
  },
  detail: {
    tender: "Tender",
    notFoundTitle: "This tender cannot be found",
    notFoundBody: "It may have been deleted, or you may not have access to it.",
    backToPipeline: "Back to the pipeline",
    loadFailedTitle: "Could not load the tender",
    loadFailedBody: "Check your connection, then try again.",
    delete: "Delete",
    deleteTitle: 'Delete "{title}"?',
    deleteBody: "The tender and its document list are deleted for good. The documents of the vault are not touched.",
    deleted: "The tender is deleted."
  },
  status: {
    title: "Progress",
    since: "Since",
    note: "Note:",
    noteField: {
      label: "Note (optional)",
      hint: "For example the reason for a no-go, the submission date or the outcome of the bid opening. It replaces the previous note."
    },
    actionsLabel: "Possible steps",
    actions: {
      watch: "Put back on watch",
      go: "Decide to go (Go)",
      no_go: "Do not go (No-go)",
      preparing: "Start the preparation",
      submitted: "Mark as submitted",
      won: "Mark as won",
      lost: "Mark as lost"
    },
    final: {
      won: "This tender is won: its step no longer changes. Convert it into a project to start the assignment.",
      lost: "This tender is lost: its step no longer changes."
    }
  },
  project: {
    title: "Project",
    converted: "This tender has been converted into a project.",
    wonNotConverted: "Won! Convert the tender into a project to carry over its title, client and dates."
  },
  sheet: {
    title: "Tender sheet",
    save: "Save changes",
    saving: "Saving\u2026",
    saved: "The sheet is saved.",
    nothingToSave: "No changes to save."
  },
  requirements: {
    title: "Documents to provide",
    progress: "{count} ready",
    listLabel: "Documents to provide for this tender",
    empty: "No documents listed. Add the documents the notice asks for: certificates, references, CVs\u2026",
    addForm: "Add a document to provide",
    addLabel: "New document to provide",
    addPlaceholder: "For example: tax compliance certificate",
    add: "Add",
    full: "The list is full ({max} documents at most).",
    rename: 'Rename "{label}"',
    renameLabel: 'New name of "{label}"',
    renameSave: "Save the name",
    renameCancel: "Cancel renaming",
    remove: 'Remove "{label}" from the list',
    removeTitle: 'Remove "{label}" from the list?',
    removeBody: "Only the line of the list is removed; the vault document is not deleted.",
    removed: "The document is removed from the list.",
    vaultPicker: 'Vault document for "{label}"',
    noVaultDocument: "No vault document linked",
    vaultEmpty: "The vault is empty: add your certificates to it to link them here."
  },
  convert: {
    button: "Convert to project",
    title: "Convert to project",
    intro: "The project takes the tender's title and client. This conversion can only be done once.",
    missionType: {
      label: "Mission type"
    },
    name: {
      label: "Project name",
      hint: "By default, the tender's title."
    },
    startsOn: "Project start",
    endsOn: "Planned end",
    submit: "Convert",
    submitting: "Converting\u2026",
    done: 'The project "{name}" is created.',
    alreadyDone: "This tender had already been converted into a project.",
    doneTitle: "Project created",
    doneBody: "The project is ready, with its phases and folders.",
    alreadyBody: "This tender had already been converted: no second project was created.",
    openProject: "Open the project",
    errors: {
      endBeforeStart: "The planned end cannot be before the start.",
      forbidden: "Converting a tender into a project also needs the right to create projects. Ask an administrator."
    }
  },
  picker: {
    where: "Folder:",
    root: "Office documents",
    up: "Parent folder",
    folder: "Subfolder",
    openFolder: "Open a folder\u2026",
    file: "File",
    pickFile: "Choose a file\u2026",
    noFile: "No file in this folder",
    loadFailed: "Could not load the office documents. Try again in a moment.",
    noSpace: "The office's document space is not available."
  },
  vault: {
    intro: "The administrative documents you attach to your bids, with their expiry date. An alert is sent {days} days before a document expires.",
    add: "Add a document",
    tableLabel: "Vault documents",
    scrollLabel: "Vault documents, scrolling table",
    columns: {
      label: "Document",
      kind: "Type",
      file: "File",
      issuedOn: "Issued on",
      expiresOn: "Expires on",
      state: "State",
      actions: "Actions"
    },
    noFile: "No file",
    noDate: "Not given",
    states: {
      valid: "Valid",
      expiring: "Expires in {days} d",
      expiringToday: "Expires today",
      expired: "Expired {days} d ago",
      no_expiry: "No expiry"
    },
    filters: {
      label: "Filter the documents",
      kind: "Filter by type",
      state: "Filter by state",
      allKinds: "All types",
      allStates: "All states",
      states: {
        valid: "Valid",
        expiring: "Expiring soon",
        expired: "Expired",
        no_expiry: "No expiry"
      }
    },
    editLabel: 'Edit "{label}"',
    deleteLabel: 'Delete "{label}"',
    deleteTitle: 'Delete "{label}"?',
    deleteBody: "The document is removed from the vault. The file stays in the office's documents.",
    deleted: "The document is deleted from the vault.",
    loadFailedTitle: "Could not load the vault",
    loadFailedBody: "Check your connection, then try again.",
    empty: {
      title: "Your vault is empty",
      body: "Keep here the certificates, extracts, insurance, CVs and references that every bid file asks for. BatiFlow warns you {days} days before each document expires.",
      filteredTitle: "No document matches",
      filteredBody: "No document matches these filters.",
      clear: "Clear the filters"
    },
    errors: {
      expiryBeforeIssue: "The expiry date cannot be before the issue date."
    },
    dialog: {
      addTitle: "Add a document",
      editTitle: "Edit the document",
      kind: "Document type",
      label: "Title",
      labelHint: "What it is: the title of the certificate, the person's name for a CV, the project of a reference.",
      issuedOn: "Issued on",
      expiresOn: "Expires on",
      expiresHint: "An alert goes out {days} days before.",
      file: "File",
      noFile: "No file linked",
      fileChosen: "File chosen",
      fileHint: "The file must already be in your office's documents. Upload it in Files first, then come back to choose it here.",
      chooseFile: "Choose a file",
      changeFile: "Change the file",
      removeFile: "Remove the file",
      add: "Add the document",
      save: "Save",
      saving: "Saving\u2026",
      added: 'The document "{label}" is added to the vault.',
      updated: 'The document "{label}" is updated.'
    }
  },
  errors: {
    TENDER_STATUS_TRANSITION: "This step change is not possible from the tender's current step. Reload the page to see where it stands.",
    TENDER_NOT_DELETABLE: "Only a tender on watch, declined (no-go) or lost, and never converted into a project, can be deleted.",
    TENDER_NOT_WON: "Only a won tender can be converted into a project.",
    VAULT_DOCUMENT_UNKNOWN: "Choose a document of your own vault.",
    VAULT_DOCUMENT_FILE_INVALID: "Choose a file from your office's documents (Files, Organisation tab).",
    VAULT_DOCUMENT_IN_USE: "This document is used by a tender's document list: remove it from that list first, then delete it."
  }
};

// locales/fr/tenders.json
var tenders_default3 = {
  title: "Appels d'offres",
  tabs: {
    pipeline: "Pipeline",
    vault: "Coffre-fort"
  },
  upgrade: {
    title: "Les appels d'offres ne sont pas inclus dans votre offre",
    body: "Le suivi des appels d'offres et le coffre-fort de pi\xE8ces administratives sont r\xE9serv\xE9s aux offres sup\xE9rieures. Demandez au propri\xE9taire du compte de changer d'offre pour les activer."
  },
  sources: {
    tuneps: "TUNEPS",
    press: "Presse",
    client_site: "Site du ma\xEEtre d'ouvrage",
    other: "Autre"
  },
  statuses: {
    watch: "Veille",
    go: "Go",
    preparing: "En pr\xE9paration",
    submitted: "D\xE9pos\xE9",
    won: "Gagn\xE9",
    lost: "Perdu",
    no_go: "No-go"
  },
  kinds: {
    tax_certificate: "Attestation fiscale",
    cnss_certificate: "Attestation CNSS",
    rne: "Extrait du RNE",
    agreement: "Agr\xE9ment",
    order_registration: "Inscription \xE0 l'Ordre",
    insurance: "Assurance",
    cv: "CV",
    reference: "R\xE9f\xE9rence de projet"
  },
  board: {
    label: "Pipeline des appels d'offres"
  },
  card: {
    reference: "R\xE9f.",
    deadline: "\xC9ch\xE9ance\xA0:",
    bidBond: "Caution\xA0:",
    requirements: "{count} pi\xE8ces pr\xEAtes",
    noRequirements: "Aucune pi\xE8ce list\xE9e"
  },
  deadline: {
    none: "Sans \xE9ch\xE9ance",
    inDays: "J-{days}",
    today: "Aujourd'hui",
    late: "En retard de {days} j"
  },
  pipeline: {
    new: "Nouvel appel d'offres",
    filtersLabel: "Rechercher dans les appels d'offres",
    search: "Rechercher un appel d'offres",
    searchPlaceholder: "Intitul\xE9, ma\xEEtre d'ouvrage ou r\xE9f\xE9rence",
    loadFailedTitle: "Impossible de charger les appels d'offres",
    loadFailedBody: "V\xE9rifiez votre connexion, puis r\xE9essayez.",
    truncated: "Seuls les appels d'offres les plus r\xE9cents sont affich\xE9s. Utilisez la recherche pour retrouver un ancien dossier.",
    empty: {
      title: "Aucun appel d'offres suivi",
      body: "Ajoutez les consultations rep\xE9r\xE9es sur TUNEPS, dans la presse ou sur le site d'un ma\xEEtre d'ouvrage\xA0: vous d\xE9ciderez d'y aller ou non, puis vous suivrez la pr\xE9paration jusqu'au r\xE9sultat.",
      filteredTitle: "Aucun r\xE9sultat",
      filteredBody: "Aucun appel d'offres ne correspond \xE0 cette recherche.",
      clear: "Effacer la recherche"
    }
  },
  move: {
    notAllowed: "Impossible de d\xE9placer \xAB\xA0{title}\xA0\xBB de \xAB\xA0{from}\xA0\xBB vers \xAB\xA0{to}\xA0\xBB\xA0: cette \xE9tape ne suit pas l'\xE9tape actuelle dans le pipeline.",
    done: "\xAB\xA0{title}\xA0\xBB passe \xE0 l'\xE9tape \xAB\xA0{status}\xA0\xBB."
  },
  new: {
    title: "Nouvel appel d'offres",
    intro: "L'appel d'offres d\xE9marre en \xAB\xA0Veille\xA0\xBB. Vous d\xE9ciderez ensuite d'y aller (Go) ou non (No-go).",
    submit: "Ajouter",
    saving: "Ajout\u2026",
    done: "L'appel d'offres \xAB\xA0{title}\xA0\xBB est ajout\xE9 \xE0 la veille."
  },
  form: {
    title: {
      label: "Intitul\xE9"
    },
    source: {
      label: "Source"
    },
    reference: {
      label: "R\xE9f\xE9rence de la consultation",
      hint: "Le num\xE9ro de l'avis, tel qu'il figure sur TUNEPS ou dans la presse."
    },
    buyer: {
      label: "Ma\xEEtre d'ouvrage",
      hint: "L'administration ou la soci\xE9t\xE9 qui lance la consultation."
    },
    client: {
      label: "Client du bureau",
      hint: "Facultatif. Rattachez-le \xE0 un client existant\xA0: il sera repris dans le projet.",
      none: "Aucun client",
      current: "Client actuel"
    },
    deadlineDate: {
      label: "Date limite de remise",
      hint: "Le jour limite pour d\xE9poser l'offre."
    },
    deadlineTime: {
      label: "Heure limite"
    },
    bidBond: {
      label: "Caution provisoire",
      hint: "Montant en dinars (TND) exig\xE9 avec l'offre, s'il y en a un."
    },
    errors: {
      required: "Ce champ est obligatoire.",
      tooLong: "Ce texte est trop long (maximum {max} caract\xE8res).",
      timeNeeded: "Indiquez aussi l'heure limite.",
      dateNeeded: "Indiquez aussi la date limite.",
      timeInvalid: "Indiquez une heure valide, par exemple 10:00."
    }
  },
  detail: {
    tender: "Appel d'offres",
    notFoundTitle: "Cet appel d'offres est introuvable",
    notFoundBody: "Il a peut-\xEAtre \xE9t\xE9 supprim\xE9, ou vous n'y avez pas acc\xE8s.",
    backToPipeline: "Retour au pipeline",
    loadFailedTitle: "Impossible de charger l'appel d'offres",
    loadFailedBody: "V\xE9rifiez votre connexion, puis r\xE9essayez.",
    delete: "Supprimer",
    deleteTitle: "Supprimer \xAB\xA0{title}\xA0\xBB\xA0?",
    deleteBody: "L'appel d'offres et sa liste de pi\xE8ces sont supprim\xE9s d\xE9finitivement. Les pi\xE8ces du coffre-fort ne sont pas touch\xE9es.",
    deleted: "L'appel d'offres est supprim\xE9."
  },
  status: {
    title: "Avancement",
    since: "Depuis le",
    note: "Note\xA0:",
    noteField: {
      label: "Note (facultative)",
      hint: "Par exemple le motif d'un no-go, la date de d\xE9p\xF4t ou le r\xE9sultat de l'ouverture des plis. Elle remplace la note pr\xE9c\xE9dente."
    },
    actionsLabel: "\xC9tapes possibles",
    actions: {
      watch: "Remettre en veille",
      go: "D\xE9cider d'y aller (Go)",
      no_go: "Ne pas y aller (No-go)",
      preparing: "Lancer la pr\xE9paration",
      submitted: "Marquer comme d\xE9pos\xE9",
      won: "Marquer comme gagn\xE9",
      lost: "Marquer comme perdu"
    },
    final: {
      won: "Cet appel d'offres est gagn\xE9\xA0: son \xE9tape ne change plus. Convertissez-le en projet pour d\xE9marrer la mission.",
      lost: "Cet appel d'offres est perdu\xA0: son \xE9tape ne change plus."
    }
  },
  project: {
    title: "Projet",
    converted: "Cet appel d'offres a \xE9t\xE9 converti en projet.",
    wonNotConverted: "Gagn\xE9\xA0! Convertissez l'appel d'offres en projet pour reprendre son intitul\xE9, son client et ses dates."
  },
  sheet: {
    title: "Fiche de l'appel d'offres",
    save: "Enregistrer les modifications",
    saving: "Enregistrement\u2026",
    saved: "La fiche est enregistr\xE9e.",
    nothingToSave: "Aucune modification \xE0 enregistrer."
  },
  requirements: {
    title: "Pi\xE8ces \xE0 fournir",
    progress: "{count} pr\xEAtes",
    listLabel: "Pi\xE8ces \xE0 fournir pour cet appel d'offres",
    empty: "Aucune pi\xE8ce list\xE9e. Ajoutez les documents que l'avis exige\xA0: attestations, r\xE9f\xE9rences, CV\u2026",
    addForm: "Ajouter une pi\xE8ce \xE0 fournir",
    addLabel: "Nouvelle pi\xE8ce \xE0 fournir",
    addPlaceholder: "Par exemple\xA0: attestation de r\xE9gularit\xE9 fiscale",
    add: "Ajouter",
    full: "La liste est pleine ({max} pi\xE8ces au maximum).",
    rename: "Renommer \xAB\xA0{label}\xA0\xBB",
    renameLabel: "Nouveau nom de \xAB\xA0{label}\xA0\xBB",
    renameSave: "Enregistrer le nom",
    renameCancel: "Annuler le renommage",
    remove: "Retirer \xAB\xA0{label}\xA0\xBB de la liste",
    removeTitle: "Retirer \xAB\xA0{label}\xA0\xBB de la liste\xA0?",
    removeBody: "Seule la ligne de la liste est retir\xE9e\xA0; le document du coffre-fort n'est pas supprim\xE9.",
    removed: "La pi\xE8ce est retir\xE9e de la liste.",
    vaultPicker: "Pi\xE8ce du coffre-fort pour \xAB\xA0{label}\xA0\xBB",
    noVaultDocument: "Aucune pi\xE8ce du coffre-fort li\xE9e",
    vaultEmpty: "Le coffre-fort est vide\xA0: ajoutez-y vos attestations pour les lier ici."
  },
  convert: {
    button: "Convertir en projet",
    title: "Convertir en projet",
    intro: "Le projet reprend l'intitul\xE9 et le client de l'appel d'offres. Cette conversion ne se fait qu'une fois.",
    missionType: {
      label: "Type de mission"
    },
    name: {
      label: "Nom du projet",
      hint: "Par d\xE9faut, l'intitul\xE9 de l'appel d'offres."
    },
    startsOn: "D\xE9but du projet",
    endsOn: "Fin pr\xE9vue",
    submit: "Convertir",
    submitting: "Conversion\u2026",
    done: "Le projet \xAB\xA0{name}\xA0\xBB est cr\xE9\xE9.",
    alreadyDone: "Cet appel d'offres \xE9tait d\xE9j\xE0 converti en projet.",
    doneTitle: "Projet cr\xE9\xE9",
    doneBody: "Le projet est pr\xEAt, avec ses phases et ses dossiers.",
    alreadyBody: "Cet appel d'offres avait d\xE9j\xE0 \xE9t\xE9 converti\xA0: aucun second projet n'a \xE9t\xE9 cr\xE9\xE9.",
    openProject: "Ouvrir le projet",
    errors: {
      endBeforeStart: "La fin pr\xE9vue ne peut pas pr\xE9c\xE9der le d\xE9but.",
      forbidden: "Convertir un appel d'offres en projet demande aussi le droit de cr\xE9er des projets. Demandez-le \xE0 un administrateur."
    }
  },
  picker: {
    where: "Dossier\xA0:",
    root: "Documents du bureau",
    up: "Dossier parent",
    folder: "Sous-dossier",
    openFolder: "Ouvrir un dossier\u2026",
    file: "Fichier",
    pickFile: "Choisir un fichier\u2026",
    noFile: "Aucun fichier dans ce dossier",
    loadFailed: "Impossible de charger les documents du bureau. R\xE9essayez dans un instant.",
    noSpace: "L'espace de documents du bureau n'est pas disponible."
  },
  vault: {
    intro: "Les pi\xE8ces administratives que vous joignez \xE0 vos offres, avec leur date d'expiration. Une alerte vous est envoy\xE9e {days} jours avant l'expiration.",
    add: "Ajouter une pi\xE8ce",
    tableLabel: "Pi\xE8ces du coffre-fort",
    scrollLabel: "Pi\xE8ces du coffre-fort, tableau d\xE9filant",
    columns: {
      label: "Pi\xE8ce",
      kind: "Type",
      file: "Fichier",
      issuedOn: "D\xE9livr\xE9e le",
      expiresOn: "Expire le",
      state: "\xC9tat",
      actions: "Actions"
    },
    noFile: "Aucun fichier",
    noDate: "Non renseign\xE9e",
    states: {
      valid: "Valide",
      expiring: "Expire dans {days} j",
      expiringToday: "Expire aujourd'hui",
      expired: "Expir\xE9e depuis {days} j",
      no_expiry: "Sans \xE9ch\xE9ance"
    },
    filters: {
      label: "Filtrer les pi\xE8ces",
      kind: "Filtrer par type",
      state: "Filtrer par \xE9tat",
      allKinds: "Tous les types",
      allStates: "Tous les \xE9tats",
      states: {
        valid: "Valides",
        expiring: "Bient\xF4t expir\xE9es",
        expired: "Expir\xE9es",
        no_expiry: "Sans \xE9ch\xE9ance"
      }
    },
    editLabel: "Modifier \xAB\xA0{label}\xA0\xBB",
    deleteLabel: "Supprimer \xAB\xA0{label}\xA0\xBB",
    deleteTitle: "Supprimer \xAB\xA0{label}\xA0\xBB\xA0?",
    deleteBody: "La pi\xE8ce est retir\xE9e du coffre-fort. Le fichier reste dans les documents du bureau.",
    deleted: "La pi\xE8ce est supprim\xE9e du coffre-fort.",
    loadFailedTitle: "Impossible de charger le coffre-fort",
    loadFailedBody: "V\xE9rifiez votre connexion, puis r\xE9essayez.",
    empty: {
      title: "Votre coffre-fort est vide",
      body: "Rangez ici les attestations, extraits, assurances, CV et r\xE9f\xE9rences que chaque dossier d'appel d'offres r\xE9clame. BatiFlow vous pr\xE9vient {days} jours avant l'expiration de chaque pi\xE8ce.",
      filteredTitle: "Aucune pi\xE8ce ne correspond",
      filteredBody: "Aucune pi\xE8ce ne correspond \xE0 ces filtres.",
      clear: "Effacer les filtres"
    },
    errors: {
      expiryBeforeIssue: "La date d'expiration ne peut pas pr\xE9c\xE9der la date de d\xE9livrance."
    },
    dialog: {
      addTitle: "Ajouter une pi\xE8ce",
      editTitle: "Modifier la pi\xE8ce",
      kind: "Type de pi\xE8ce",
      label: "Intitul\xE9",
      labelHint: "Ce que c'est\xA0: le titre de l'attestation, le nom de la personne d'un CV, le projet d'une r\xE9f\xE9rence.",
      issuedOn: "D\xE9livr\xE9e le",
      expiresOn: "Expire le",
      expiresHint: "Une alerte part {days} jours avant.",
      file: "Fichier",
      noFile: "Aucun fichier li\xE9",
      fileChosen: "Fichier choisi",
      fileHint: "Le fichier doit d\xE9j\xE0 se trouver dans les documents de votre bureau. D\xE9posez-le d'abord dans Fichiers, puis revenez le choisir ici.",
      chooseFile: "Choisir un fichier",
      changeFile: "Changer de fichier",
      removeFile: "Retirer le fichier",
      add: "Ajouter la pi\xE8ce",
      save: "Enregistrer",
      saving: "Enregistrement\u2026",
      added: "La pi\xE8ce \xAB\xA0{label}\xA0\xBB est ajout\xE9e au coffre-fort.",
      updated: "La pi\xE8ce \xAB\xA0{label}\xA0\xBB est mise \xE0 jour."
    }
  },
  errors: {
    TENDER_STATUS_TRANSITION: "Ce changement d'\xE9tape n'est pas possible depuis l'\xE9tape actuelle de l'appel d'offres. Rechargez la page pour voir o\xF9 il en est.",
    TENDER_NOT_DELETABLE: "Seul un appel d'offres en veille, \xE9cart\xE9 (no-go) ou perdu, et jamais converti en projet, peut \xEAtre supprim\xE9.",
    TENDER_NOT_WON: "Seul un appel d'offres gagn\xE9 peut \xEAtre converti en projet.",
    VAULT_DOCUMENT_UNKNOWN: "Choisissez une pi\xE8ce de votre coffre-fort.",
    VAULT_DOCUMENT_FILE_INVALID: "Choisissez un fichier parmi les documents de votre bureau (Fichiers, onglet Organisation).",
    VAULT_DOCUMENT_IN_USE: "Cette pi\xE8ce est utilis\xE9e par la liste de pi\xE8ces d'un appel d'offres\xA0: retirez-la d'abord de cette liste, puis supprimez-la."
  }
};

// locales/ar/suppliers.json
var suppliers_default = {
  kinds: {
    company: "\u0634\u0631\u0643\u0629",
    individual: "\u0634\u062E\u0635 \u0637\u0628\u064A\u0639\u064A",
    non_resident: "\u063A\u064A\u0631 \u0645\u0642\u064A\u0645"
  },
  profiles: {
    fees_legal_entity: "\u0623\u062A\u0639\u0627\u0628 \u2014 \u0634\u062E\u0635 \u0645\u0639\u0646\u0648\u064A \u0623\u0648 \u0646\u0638\u0627\u0645 \u0627\u0644\u0631\u0628\u062D \u0627\u0644\u062D\u0642\u064A\u0642\u064A (3%)",
    fees_other: "\u0623\u062A\u0639\u0627\u0628 \u2014 \u062D\u0627\u0644\u0627\u062A \u0623\u062E\u0631\u0649 (10%)",
    fees_non_resident: "\u0623\u062A\u0639\u0627\u0628 \u2014 \u063A\u064A\u0631 \u0645\u0642\u064A\u0645 (15%)",
    purchases: "\u0645\u0634\u062A\u0631\u064A\u0627\u062A (1.5% \u0627\u0628\u062A\u062F\u0627\u0621\u064B \u0645\u0646 1000 \u062F\u064A\u0646\u0627\u0631 \u0628\u0627\u062D\u062A\u0633\u0627\u0628 \u0627\u0644\u0623\u062F\u0627\u0621\u0627\u062A)",
    none: "\u062F\u0648\u0646 \u062E\u0635\u0645 \u0645\u0646 \u0627\u0644\u0645\u0648\u0631\u062F"
  },
  methods: {
    transfer: "\u062A\u062D\u0648\u064A\u0644 \u0628\u0646\u0643\u064A",
    cheque: "\u0635\u0643",
    bill: "\u0643\u0645\u0628\u064A\u0627\u0644\u0629",
    cash: "\u0646\u0642\u062F\u064B\u0627",
    online: "\u062F\u0641\u0639 \u0639\u0628\u0631 \u0627\u0644\u0625\u0646\u062A\u0631\u0646\u062A"
  },
  invoiceStatus: {
    open: "\u0645\u0641\u062A\u0648\u062D\u0629",
    partially_paid: "\u0645\u062F\u0641\u0648\u0639\u0629 \u062C\u0632\u0626\u064A\u064B\u0627",
    paid: "\u0645\u062F\u0641\u0648\u0639\u0629",
    cancelled: "\u0645\u0644\u063A\u0627\u0629",
    overdue: "\u0645\u062A\u0623\u062E\u0631\u0629"
  },
  toVerify: {
    badge: "\u064A\u062C\u0628 \u0623\u0646 \u064A\u062A\u062D\u0642\u0642 \u0645\u0646\u0647\u0627 \u0627\u0644\u062E\u0628\u064A\u0631 \u0627\u0644\u0645\u062D\u0627\u0633\u0628",
    rules: "\u064A\u062C\u0628 \u0623\u0646 \u064A\u0624\u0643\u062F \u0627\u0644\u062E\u0628\u064A\u0631 \u0627\u0644\u0645\u062D\u0627\u0633\u0628 \u0647\u0630\u0647 \u0627\u0644\u0642\u064A\u0645\u0629 \u0642\u0628\u0644 \u0627\u0639\u062A\u0628\u0627\u0631\u0647\u0627 \u0646\u0647\u0627\u0626\u064A\u0629. \u0627\u0644\u0642\u0648\u0627\u0639\u062F \u0627\u0644\u0645\u0639\u0646\u064A\u0629: {rules}."
  },
  month: {
    previous: "\u0627\u0644\u0634\u0647\u0631 \u0627\u0644\u0633\u0627\u0628\u0642",
    next: "\u0627\u0644\u0634\u0647\u0631 \u0627\u0644\u0645\u0648\u0627\u0644\u064A"
  },
  suppliers: {
    intro: "\u0645\u0632\u0648\u0651\u062F\u0648\u0643 \u0648\u0627\u0644\u0645\u062A\u0639\u0627\u0642\u062F\u0648\u0646 \u0645\u0639\u0643 \u0645\u0646 \u0627\u0644\u0628\u0627\u0637\u0646. \u064A\u062D\u062F\u0651\u062F \u0646\u0638\u0627\u0645 \u0627\u0644\u062E\u0635\u0645 \u0645\u0646 \u0627\u0644\u0645\u0648\u0631\u062F \u0627\u0644\u062E\u0627\u0635 \u0628\u0643\u0644 \u0645\u0632\u0648\u0651\u062F \u0627\u0644\u0627\u0642\u062A\u0637\u0627\u0639 \u0627\u0644\u0630\u064A \u064A\u064F\u062C\u0631\u0649 \u0639\u0646\u062F \u0627\u0644\u062F\u0641\u0639 \u0644\u0647.",
    new: "\u0645\u0632\u0648\u0651\u062F \u062C\u062F\u064A\u062F",
    tableLabel: "\u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u0645\u0632\u0648\u0651\u062F\u064A\u0646",
    noTaxId: "\u063A\u064A\u0631 \u0645\u0630\u0643\u0648\u0631",
    activeState: "\u0646\u0634\u0637",
    archivedChip: "\u0645\u0624\u0631\u0634\u0641",
    columns: {
      name: "\u0627\u0644\u0627\u0633\u0645",
      kind: "\u0627\u0644\u0646\u0648\u0639",
      taxId: "\u0627\u0644\u0645\u0639\u0631\u0651\u0641 \u0627\u0644\u062C\u0628\u0627\u0626\u064A",
      profile: "\u0627\u0644\u062E\u0635\u0645 \u0645\u0646 \u0627\u0644\u0645\u0648\u0631\u062F",
      balance: "\u0627\u0644\u0645\u062A\u0628\u0642\u064A \u0644\u0644\u062F\u0641\u0639",
      state: "\u0627\u0644\u062D\u0627\u0644\u0629",
      actions: "\u0627\u0644\u0625\u062C\u0631\u0627\u0621\u0627\u062A"
    },
    filters: {
      label: "\u062A\u0635\u0641\u064A\u0629 \u0627\u0644\u0645\u0632\u0648\u0651\u062F\u064A\u0646",
      search: "\u0627\u0644\u0628\u062D\u062B \u0639\u0646 \u0645\u0632\u0648\u0651\u062F",
      searchPlaceholder: "\u0627\u0644\u0627\u0633\u0645 \u0623\u0648 \u0627\u0644\u0645\u0639\u0631\u0651\u0641 \u0627\u0644\u062C\u0628\u0627\u0626\u064A",
      state: "\u062D\u0627\u0644\u0629 \u0627\u0644\u0645\u0632\u0648\u0651\u062F\u064A\u0646",
      active: "\u0627\u0644\u0645\u0632\u0648\u0651\u062F\u0648\u0646 \u0627\u0644\u0646\u0634\u0637\u0648\u0646",
      archived: "\u0627\u0644\u0645\u0632\u0648\u0651\u062F\u0648\u0646 \u0627\u0644\u0645\u0624\u0631\u0634\u0641\u0648\u0646"
    },
    empty: {
      title: "\u0644\u0627 \u064A\u0648\u062C\u062F \u0645\u0632\u0648\u0651\u062F\u0648\u0646 \u0628\u0639\u062F",
      body: "\u0623\u0636\u0641 \u0645\u0632\u0648\u0651\u062F\u064A\u0643 \u0648\u0627\u0644\u0645\u062A\u0639\u0627\u0642\u062F\u064A\u0646 \u0645\u0639\u0643 \u0645\u0646 \u0627\u0644\u0628\u0627\u0637\u0646 \u0644\u062A\u0633\u062C\u064A\u0644 \u0641\u0648\u0627\u062A\u064A\u0631\u0647\u0645 \u0648\u0625\u062C\u0631\u0627\u0621 \u0627\u0644\u062E\u0635\u0645 \u0645\u0646 \u0627\u0644\u0645\u0648\u0631\u062F.",
      filteredTitle: "\u0644\u0627 \u064A\u0648\u062C\u062F \u0645\u0632\u0648\u0651\u062F \u0645\u0637\u0627\u0628\u0642",
      filteredBody: "\u062C\u0631\u0651\u0628 \u0627\u0633\u0645\u064B\u0627 \u0623\u0648 \u0645\u0639\u0631\u0651\u0641\u064B\u0627 \u062C\u0628\u0627\u0626\u064A\u064B\u0627 \u0622\u062E\u0631\u060C \u0623\u0648 \u0627\u0631\u062C\u0639 \u0625\u0644\u0649 \u0627\u0644\u0645\u0632\u0648\u0651\u062F\u064A\u0646 \u0627\u0644\u0646\u0634\u0637\u064A\u0646.",
      clear: "\u0645\u0633\u062D \u0639\u0648\u0627\u0645\u0644 \u0627\u0644\u062A\u0635\u0641\u064A\u0629"
    },
    loadFailedTitle: "\u0627\u0644\u0645\u0632\u0648\u0651\u062F\u0648\u0646 \u063A\u064A\u0631 \u0645\u062A\u0627\u062D\u064A\u0646",
    loadFailedBody: "\u062A\u0639\u0630\u0651\u0631 \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0642\u0627\u0626\u0645\u0629. \u062A\u062D\u0642\u0651\u0642 \u0645\u0646 \u0627\u062A\u0635\u0627\u0644\u0643 \u062B\u0645 \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629.",
    loadMore: "\u0639\u0631\u0636 \u0627\u0644\u0645\u0632\u064A\u062F \u0645\u0646 \u0627\u0644\u0645\u0632\u0648\u0651\u062F\u064A\u0646",
    loadingMore: "\u062C\u0627\u0631\u064D \u0627\u0644\u062A\u062D\u0645\u064A\u0644\u2026",
    editLabel: "\u062A\u0639\u062F\u064A\u0644 {name}",
    archiveLabel: "\u0623\u0631\u0634\u0641\u0629 {name}",
    restoreLabel: "\u0627\u0633\u062A\u0639\u0627\u062F\u0629 {name}",
    archiveTitle: "\u0623\u0631\u0634\u0641\u0629 {name}\u061F",
    archiveBody: "\u0644\u0646 \u064A\u062A\u0645\u0643\u0651\u0646 \u0647\u0630\u0627 \u0627\u0644\u0645\u0632\u0648\u0651\u062F \u0645\u0646 \u0627\u0633\u062A\u0642\u0628\u0627\u0644 \u0641\u0627\u062A\u0648\u0631\u0629 \u062C\u062F\u064A\u062F\u0629. \u062A\u0628\u0642\u0649 \u0641\u0648\u0627\u062A\u064A\u0631\u0647 \u0648\u0634\u0647\u0627\u062F\u0627\u062A\u0647 \u0645\u062A\u0627\u062D\u0629 \u0644\u0644\u0627\u0637\u0644\u0627\u0639 \u0648\u064A\u0645\u0643\u0646\u0643 \u0627\u0633\u062A\u0639\u0627\u062F\u062A\u0647 \u0641\u064A \u0623\u064A \u0648\u0642\u062A.",
    archiveConfirm: "\u0623\u0631\u0634\u0641\u0629",
    archivedDone: "\u062A\u0645\u062A \u0623\u0631\u0634\u0641\u0629 {name}.",
    restoredDone: "\u0623\u0635\u0628\u062D {name} \u0646\u0634\u0637\u064B\u0627 \u0645\u0646 \u062C\u062F\u064A\u062F."
  },
  supplier: {
    createTitle: "\u0645\u0632\u0648\u0651\u062F \u062C\u062F\u064A\u062F",
    editTitle: "\u062A\u0639\u062F\u064A\u0644 \u0627\u0644\u0645\u0632\u0648\u0651\u062F",
    name: "\u0627\u0644\u0627\u0633\u0645 \u0623\u0648 \u0627\u0644\u062A\u0633\u0645\u064A\u0629 \u0627\u0644\u0627\u062C\u062A\u0645\u0627\u0639\u064A\u0629",
    kind: "\u0646\u0648\u0639 \u0627\u0644\u0645\u0632\u0648\u0651\u062F",
    taxId: "\u0627\u0644\u0645\u0639\u0631\u0651\u0641 \u0627\u0644\u062C\u0628\u0627\u0626\u064A",
    taxIdHint: "\u0625\u062C\u0628\u0627\u0631\u064A \u0628\u0627\u0644\u0646\u0633\u0628\u0629 \u0625\u0644\u0649 \u0645\u0632\u0648\u0651\u062F \u0645\u0642\u064A\u0645 \u0641\u064A \u062A\u0648\u0646\u0633.",
    taxIdHintNonResident: "\u0627\u062E\u062A\u064A\u0627\u0631\u064A \u0628\u0627\u0644\u0646\u0633\u0628\u0629 \u0625\u0644\u0649 \u063A\u064A\u0631 \u0627\u0644\u0645\u0642\u064A\u0645.",
    profile: "\u0627\u0644\u062E\u0635\u0645 \u0645\u0646 \u0627\u0644\u0645\u0648\u0631\u062F",
    profileHint: "\u0627\u0644\u0646\u0633\u0628 \u0625\u0631\u0634\u0627\u062F\u064A\u0629: \u062A\u062D\u062A\u0633\u0628 BatiFlow \u0627\u0644\u062E\u0635\u0645 \u0627\u0644\u062F\u0642\u064A\u0642 \u0648\u0641\u0642 \u0627\u0644\u0642\u0648\u0627\u0639\u062F \u0627\u0644\u062C\u0628\u0627\u0626\u064A\u0629 \u0627\u0644\u0633\u0627\u0631\u064A\u0629 \u0641\u064A \u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629.",
    email: "\u0627\u0644\u0628\u0631\u064A\u062F \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A",
    phone: "\u0627\u0644\u0647\u0627\u062A\u0641",
    address: "\u0627\u0644\u0639\u0646\u0648\u0627\u0646",
    bankTitle: "\u0627\u0644\u0645\u0639\u0637\u064A\u0627\u062A \u0627\u0644\u0628\u0646\u0643\u064A\u0629",
    bankHint: "\u0627\u062E\u062A\u064A\u0627\u0631\u064A. \u0645\u0639\u0631\u0651\u0641 \u0627\u0644\u062D\u0633\u0627\u0628 \u0627\u0644\u0628\u0646\u0643\u064A (20 \u0631\u0642\u0645\u064B\u0627) \u0623\u0648 \u0631\u0642\u0645 \u0627\u0644\u062D\u0633\u0627\u0628 \u0627\u0644\u062F\u0648\u0644\u064A IBAN \u0628\u0627\u0644\u0646\u0633\u0628\u0629 \u0625\u0644\u0649 \u0645\u0632\u0648\u0651\u062F \u0641\u064A \u0627\u0644\u062E\u0627\u0631\u062C. \u064A\u062A\u0645 \u062A\u0634\u0641\u064A\u0631\u0647 \u0648\u0625\u062E\u0641\u0627\u0624\u0647 \u0639\u0644\u0649 \u0627\u0644\u0634\u0627\u0634\u0629.",
    bankName: "\u0627\u0644\u0628\u0646\u0643",
    account: "\u0645\u0639\u0631\u0651\u0641 \u0627\u0644\u062D\u0633\u0627\u0628 \u0623\u0648 IBAN",
    accountHint: "\u062A\u064F\u0647\u0645\u0644 \u0627\u0644\u0641\u0631\u0627\u063A\u0627\u062A.",
    bankReplace: "\u0627\u0633\u062A\u0628\u062F\u0627\u0644 \u0627\u0644\u0645\u0639\u0637\u064A\u0627\u062A",
    bankRemove: "\u062D\u0630\u0641 \u0627\u0644\u0645\u0639\u0637\u064A\u0627\u062A",
    bankKeep: "\u0627\u0644\u0625\u0628\u0642\u0627\u0621 \u0639\u0644\u0649 \u0627\u0644\u0645\u0639\u0637\u064A\u0627\u062A \u0627\u0644\u062D\u0627\u0644\u064A\u0629",
    bankWillRemove: "\u0633\u064A\u062A\u0645 \u062D\u0630\u0641 \u0627\u0644\u0645\u0639\u0637\u064A\u0627\u062A \u0627\u0644\u0628\u0646\u0643\u064A\u0629 \u0639\u0646\u062F \u0627\u0644\u062D\u0641\u0638.",
    save: "\u062D\u0641\u0638",
    saving: "\u062C\u0627\u0631\u064D \u0627\u0644\u062D\u0641\u0638\u2026",
    created: "\u062A\u0645\u062A \u0625\u0636\u0627\u0641\u0629 \u0627\u0644\u0645\u0632\u0648\u0651\u062F {name}.",
    updated: "\u062A\u0645 \u062A\u062D\u062F\u064A\u062B \u0627\u0644\u0645\u0632\u0648\u0651\u062F {name}.",
    errors: {
      name: "\u0623\u062F\u062E\u0644 \u0627\u0633\u0645 \u0627\u0644\u0645\u0632\u0648\u0651\u062F.",
      taxId: "\u0623\u062F\u062E\u0644 \u0627\u0644\u0645\u0639\u0631\u0651\u0641 \u0627\u0644\u062C\u0628\u0627\u0626\u064A \u0644\u0644\u0645\u0632\u0648\u0651\u062F (\u0627\u062E\u062A\u064A\u0627\u0631\u064A \u0641\u0642\u0637 \u0628\u0627\u0644\u0646\u0633\u0628\u0629 \u0625\u0644\u0649 \u063A\u064A\u0631 \u0627\u0644\u0645\u0642\u064A\u0645).",
      email: "\u0639\u0646\u0648\u0627\u0646 \u0627\u0644\u0628\u0631\u064A\u062F \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A \u0647\u0630\u0627 \u063A\u064A\u0631 \u0635\u0627\u0644\u062D.",
      phone: "\u0631\u0642\u0645 \u0627\u0644\u0647\u0627\u062A\u0641 \u0647\u0630\u0627 \u0642\u0635\u064A\u0631 \u062C\u062F\u064B\u0627.",
      bankName: "\u0623\u062F\u062E\u0644 \u0627\u0633\u0645 \u0627\u0644\u0628\u0646\u0643.",
      account: "\u064A\u062A\u0643\u0648\u0651\u0646 \u0645\u0639\u0631\u0651\u0641 \u0627\u0644\u062D\u0633\u0627\u0628 \u0627\u0644\u0628\u0646\u0643\u064A \u0645\u0646 20 \u0631\u0642\u0645\u064B\u0627\u060C \u0648\u064A\u0628\u062F\u0623 \u0631\u0642\u0645 IBAN \u0628\u062D\u0631\u0641\u064A\u0646 \u062B\u0645 \u0631\u0642\u0645\u064A\u0646."
    }
  },
  bank: {
    account: "\u0627\u0644\u062D\u0633\u0627\u0628 / IBAN",
    show: "\u0625\u0638\u0647\u0627\u0631",
    hide: "\u0625\u062E\u0641\u0627\u0621",
    loading: "\u062C\u0627\u0631\u064D \u0627\u0644\u062A\u062D\u0645\u064A\u0644\u2026",
    stepUp: "\u0623\u0643\u0651\u062F \u0647\u0648\u064A\u062A\u0643 \u0641\u064A \u0627\u0644\u0646\u0627\u0641\u0630\u0629 \u0627\u0644\u062A\u064A \u062A\u0638\u0647\u0631\u060C \u062B\u0645 \u0627\u062E\u062A\u0631 \xAB\u0625\u0638\u0647\u0627\u0631\xBB \u0645\u0646 \u062C\u062F\u064A\u062F."
  },
  invoices: {
    intro: "\u0627\u0644\u0641\u0648\u0627\u062A\u064A\u0631 \u0627\u0644\u0648\u0627\u0631\u062F\u0629 \u0645\u0646 \u0645\u0632\u0648\u0651\u062F\u064A\u0643 \u0648\u0627\u0644\u0645\u062A\u0639\u0627\u0642\u062F\u064A\u0646 \u0645\u0639\u0643 \u0645\u0646 \u0627\u0644\u0628\u0627\u0637\u0646. \u064A\u064F\u062D\u062A\u0633\u0628 \u0627\u0644\u062E\u0635\u0645 \u0645\u0646 \u0627\u0644\u0645\u0648\u0631\u062F \u0639\u0646\u062F \u0627\u0644\u062A\u0633\u062C\u064A\u0644 \u0648\u064A\u064F\u062C\u0631\u0649 \u0639\u0646\u062F \u0643\u0644 \u062F\u0641\u0639\u0629.",
    record: "\u062A\u0633\u062C\u064A\u0644 \u0641\u0627\u062A\u0648\u0631\u0629",
    tableLabel: "\u0642\u0627\u0626\u0645\u0629 \u0641\u0648\u0627\u062A\u064A\u0631 \u0627\u0644\u0645\u0632\u0648\u0651\u062F\u064A\u0646",
    none: "\u2014",
    openLabel: "\u0641\u062A\u062D \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629 {number}",
    columns: {
      number: "\u0627\u0644\u0631\u0642\u0645",
      supplier: "\u0627\u0644\u0645\u0632\u0648\u0651\u062F",
      invoiceDate: "\u0627\u0644\u062A\u0627\u0631\u064A\u062E",
      dueDate: "\u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0627\u0633\u062A\u062D\u0642\u0627\u0642",
      ttc: "\u0627\u0644\u0645\u062C\u0645\u0648\u0639 \u0628\u0627\u062D\u062A\u0633\u0627\u0628 \u0627\u0644\u0623\u062F\u0627\u0621\u0627\u062A",
      withholding: "\u0627\u0644\u062E\u0635\u0645",
      remaining: "\u0627\u0644\u0645\u062A\u0628\u0642\u064A \u0644\u0644\u062A\u0633\u0648\u064A\u0629",
      status: "\u0627\u0644\u062D\u0627\u0644\u0629"
    },
    filters: {
      label: "\u062A\u0635\u0641\u064A\u0629 \u0641\u0648\u0627\u062A\u064A\u0631 \u0627\u0644\u0645\u0632\u0648\u0651\u062F\u064A\u0646",
      supplier: "\u0627\u0644\u0645\u0632\u0648\u0651\u062F",
      allSuppliers: "\u0643\u0644 \u0627\u0644\u0645\u0632\u0648\u0651\u062F\u064A\u0646",
      status: "\u062D\u0627\u0644\u0629 \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629",
      allStatuses: "\u0643\u0644 \u0627\u0644\u062D\u0627\u0644\u0627\u062A",
      month: "\u0634\u0647\u0631 \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629",
      allMonths: "\u0643\u0644 \u0627\u0644\u0623\u0634\u0647\u0631",
      project: "\u0627\u0644\u0645\u0634\u0631\u0648\u0639",
      allProjects: "\u0643\u0644 \u0627\u0644\u0645\u0634\u0627\u0631\u064A\u0639",
      overdue: "\u0627\u0644\u0645\u062A\u0623\u062E\u0631\u0629 \u0641\u0642\u0637"
    },
    empty: {
      title: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0641\u0648\u0627\u062A\u064A\u0631 \u0645\u0632\u0648\u0651\u062F\u064A\u0646",
      body: "\u0633\u062C\u0651\u0644 \u0641\u0627\u062A\u0648\u0631\u0629 \u0648\u0627\u0631\u062F\u0629 \u0644\u0627\u062D\u062A\u0633\u0627\u0628 \u0627\u0644\u062E\u0635\u0645 \u0645\u0646 \u0627\u0644\u0645\u0648\u0631\u062F \u0648\u0645\u062A\u0627\u0628\u0639\u0629 \u0627\u0644\u0645\u062A\u0628\u0642\u064A \u0644\u0644\u062F\u0641\u0639.",
      filteredTitle: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0641\u0627\u062A\u0648\u0631\u0629 \u0645\u0637\u0627\u0628\u0642\u0629",
      filteredBody: "\u063A\u064A\u0651\u0631 \u0639\u0648\u0627\u0645\u0644 \u0627\u0644\u062A\u0635\u0641\u064A\u0629 \u0644\u0639\u0631\u0636 \u0641\u0648\u0627\u062A\u064A\u0631 \u0623\u062E\u0631\u0649.",
      clear: "\u0645\u0633\u062D \u0639\u0648\u0627\u0645\u0644 \u0627\u0644\u062A\u0635\u0641\u064A\u0629"
    },
    loadFailedTitle: "\u0627\u0644\u0641\u0648\u0627\u062A\u064A\u0631 \u063A\u064A\u0631 \u0645\u062A\u0627\u062D\u0629",
    loadFailedBody: "\u062A\u0639\u0630\u0651\u0631 \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0642\u0627\u0626\u0645\u0629. \u062A\u062D\u0642\u0651\u0642 \u0645\u0646 \u0627\u062A\u0635\u0627\u0644\u0643 \u062B\u0645 \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629.",
    loadMore: "\u0639\u0631\u0636 \u0627\u0644\u0645\u0632\u064A\u062F \u0645\u0646 \u0627\u0644\u0641\u0648\u0627\u062A\u064A\u0631",
    loadingMore: "\u062C\u0627\u0631\u064D \u0627\u0644\u062A\u062D\u0645\u064A\u0644\u2026"
  },
  invoice: {
    createTitle: "\u062A\u0633\u062C\u064A\u0644 \u0641\u0627\u062A\u0648\u0631\u0629 \u0645\u0632\u0648\u0651\u062F",
    editTitle: "\u062A\u0639\u062F\u064A\u0644 \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629 {number}",
    editHint: "\u0644\u0627 \u062A\u062A\u063A\u064A\u0651\u0631 \u0627\u0644\u0645\u0628\u0627\u0644\u063A \u0628\u0639\u062F \u0627\u0644\u062A\u0633\u062C\u064A\u0644. \u0641\u064A \u062D\u0627\u0644 \u0648\u062C\u0648\u062F \u062E\u0637\u0623\u060C \u0623\u0644\u063A\u0650 \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629 \u0645\u0627 \u062F\u0627\u0645\u062A \u062F\u0648\u0646 \u062F\u0641\u0639\u0627\u062A \u062B\u0645 \u0633\u062C\u0651\u0644\u0647\u0627 \u0645\u0646 \u062C\u062F\u064A\u062F.",
    supplier: "\u0627\u0644\u0645\u0632\u0648\u0651\u062F",
    pickSupplier: "\u0627\u062E\u062A\u064A\u0627\u0631 \u0645\u0632\u0648\u0651\u062F",
    loadingSuppliers: "\u062C\u0627\u0631\u064D \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0645\u0632\u0648\u0651\u062F\u064A\u0646\u2026",
    number: "\u0631\u0642\u0645 \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629",
    invoiceDate: "\u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629",
    dueDate: "\u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0627\u0633\u062A\u062D\u0642\u0627\u0642",
    description: "\u0627\u0644\u0648\u0635\u0641",
    ht: "\u0627\u0644\u0645\u0628\u0644\u063A \u062F\u0648\u0646 \u0627\u062D\u062A\u0633\u0627\u0628 \u0627\u0644\u0623\u062F\u0627\u0621\u0627\u062A",
    vat: "\u0627\u0644\u0623\u062F\u0627\u0621 \u0639\u0644\u0649 \u0627\u0644\u0642\u064A\u0645\u0629 \u0627\u0644\u0645\u0636\u0627\u0641\u0629",
    stamp: "\u0645\u0639\u0644\u0648\u0645 \u0627\u0644\u0637\u0627\u0628\u0639 \u0627\u0644\u062C\u0628\u0627\u0626\u064A",
    ttc: "\u0627\u0644\u0645\u062C\u0645\u0648\u0639 \u0628\u0627\u062D\u062A\u0633\u0627\u0628 \u0627\u0644\u0623\u062F\u0627\u0621\u0627\u062A",
    ttcHint: "\u064A\u062C\u0628 \u0623\u0646 \u064A\u0633\u0627\u0648\u064A \u0627\u0644\u0645\u0628\u0644\u063A \u062F\u0648\u0646 \u0627\u0644\u0623\u062F\u0627\u0621\u0627\u062A + \u0627\u0644\u0623\u062F\u0627\u0621 \u0639\u0644\u0649 \u0627\u0644\u0642\u064A\u0645\u0629 \u0627\u0644\u0645\u0636\u0627\u0641\u0629 + \u0627\u0644\u0637\u0627\u0628\u0639\u060C \u0623\u064A {sum}.",
    vatDeductible: "\u0627\u0644\u0623\u062F\u0627\u0621 \u0639\u0644\u0649 \u0627\u0644\u0642\u064A\u0645\u0629 \u0627\u0644\u0645\u0636\u0627\u0641\u0629 \u0642\u0627\u0628\u0644 \u0644\u0644\u0637\u0631\u062D",
    vatDeductibleShort: "\u0627\u0644\u0623\u062F\u0627\u0621 \u0639\u0644\u0649 \u0627\u0644\u0642\u064A\u0645\u0629 \u0627\u0644\u0645\u0636\u0627\u0641\u0629 \u0642\u0627\u0628\u0644 \u0644\u0644\u0637\u0631\u062D",
    project: "\u0627\u0644\u0645\u0634\u0631\u0648\u0639",
    projectHint: "\u0627\u062E\u062A\u064A\u0627\u0631\u064A. \u064A\u064F\u062D\u0645\u064E\u0651\u0644 \u0627\u0644\u0643\u0644\u0641\u0629 \u0639\u0644\u0649 \u0627\u0644\u0645\u0634\u0631\u0648\u0639.",
    noProject: "\u062F\u0648\u0646 \u0645\u0634\u0631\u0648\u0639",
    scan: "\u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629 \u0627\u0644\u0645\u0645\u0633\u0648\u062D\u0629 \u0636\u0648\u0626\u064A\u064B\u0627",
    scanHint: "\u0627\u062E\u062A\u064A\u0627\u0631\u064A. \u0627\u0628\u062D\u062B \u0639\u0646 \u0648\u062B\u064A\u0642\u0629 \u0633\u0628\u0642 \u0625\u064A\u062F\u0627\u0639\u0647\u0627 \u0641\u064A \u0627\u0644\u0645\u0644\u0641\u0627\u062A (\u062D\u0631\u0641\u0627\u0646 \u0639\u0644\u0649 \u0627\u0644\u0623\u0642\u0644).",
    scanChosen: "\u0627\u0644\u0648\u062B\u064A\u0642\u0629 \u0627\u0644\u0645\u062E\u062A\u0627\u0631\u0629:",
    scanKept: "\u0627\u0644\u0648\u062B\u064A\u0642\u0629 \u0645\u0631\u0641\u0642\u0629 \u0633\u0627\u0628\u0642\u064B\u0627",
    scanRemove: "\u0625\u0632\u0627\u0644\u0629 \u0627\u0644\u0648\u062B\u064A\u0642\u0629",
    record: "\u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629",
    save: "\u062D\u0641\u0638",
    saving: "\u062C\u0627\u0631\u064D \u0627\u0644\u062D\u0641\u0638\u2026",
    recorded: "\u062A\u0645 \u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629 {number}. \u0627\u0644\u062E\u0635\u0645 \u0645\u0646 \u0627\u0644\u0645\u0648\u0631\u062F \u0627\u0644\u0645\u062D\u062A\u0633\u0628: {amount}.",
    updated: "\u062A\u0645 \u062A\u062D\u062F\u064A\u062B \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629 {number}.",
    errors: {
      supplier: "\u0627\u062E\u062A\u0631 \u0627\u0644\u0645\u0632\u0648\u0651\u062F.",
      number: "\u0623\u062F\u062E\u0644 \u0631\u0642\u0645 \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629.",
      invoiceDate: "\u0623\u062F\u062E\u0644 \u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629.",
      dueDate: "\u0644\u0627 \u064A\u0645\u0643\u0646 \u0623\u0646 \u064A\u0633\u0628\u0642 \u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0627\u0633\u062A\u062D\u0642\u0627\u0642 \u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629.",
      ht: "\u0623\u062F\u062E\u0644 \u0627\u0644\u0645\u0628\u0644\u063A \u062F\u0648\u0646 \u0627\u062D\u062A\u0633\u0627\u0628 \u0627\u0644\u0623\u062F\u0627\u0621\u0627\u062A.",
      ttcPositive: "\u064A\u062C\u0628 \u0623\u0646 \u064A\u0643\u0648\u0646 \u0627\u0644\u0645\u062C\u0645\u0648\u0639 \u0628\u0627\u062D\u062A\u0633\u0627\u0628 \u0627\u0644\u0623\u062F\u0627\u0621\u0627\u062A \u0623\u0643\u0628\u0631 \u0645\u0646 \u0627\u0644\u0635\u0641\u0631.",
      ttcSum: "\u064A\u062C\u0628 \u0623\u0646 \u064A\u0633\u0627\u0648\u064A \u0627\u0644\u0645\u062C\u0645\u0648\u0639 \u0628\u0627\u062D\u062A\u0633\u0627\u0628 \u0627\u0644\u0623\u062F\u0627\u0621\u0627\u062A \u0627\u0644\u0645\u0628\u0644\u063A \u062F\u0648\u0646 \u0627\u0644\u0623\u062F\u0627\u0621\u0627\u062A + \u0627\u0644\u0623\u062F\u0627\u0621 \u0639\u0644\u0649 \u0627\u0644\u0642\u064A\u0645\u0629 \u0627\u0644\u0645\u0636\u0627\u0641\u0629 + \u0627\u0644\u0637\u0627\u0628\u0639\u060C \u0623\u064A {sum}."
    }
  },
  payment: {
    title: "\u062A\u0633\u062C\u064A\u0644 \u062F\u0641\u0639\u0629 \u2014 \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629 {number}",
    remaining: "\u0627\u0644\u0645\u062A\u0628\u0642\u064A \u0644\u0644\u062A\u0633\u0648\u064A\u0629 (\u0628\u0627\u062D\u062A\u0633\u0627\u0628 \u0627\u0644\u0623\u062F\u0627\u0621\u0627\u062A): {amount}",
    paidOn: "\u062A\u0627\u0631\u064A\u062E \u0627\u0644\u062F\u0641\u0639",
    method: "\u0637\u0631\u064A\u0642\u0629 \u0627\u0644\u062F\u0641\u0639",
    gross: "\u0627\u0644\u062C\u0632\u0621 \u0627\u0644\u0645\u0633\u0648\u0651\u0649 \u0645\u0646 \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629 (\u0628\u0627\u062D\u062A\u0633\u0627\u0628 \u0627\u0644\u0623\u062F\u0627\u0621\u0627\u062A)",
    grossHint: "\u064A\u0634\u0645\u0644 \u0627\u0644\u062E\u0635\u0645 \u0645\u0646 \u0627\u0644\u0645\u0648\u0631\u062F. \u0627\u0641\u062A\u0631\u0627\u0636\u064A\u064B\u0627: \u0643\u0627\u0645\u0644 \u0627\u0644\u0645\u062A\u0628\u0642\u064A \u0644\u0644\u062A\u0633\u0648\u064A\u0629.",
    reference: "\u0627\u0644\u0645\u0631\u062C\u0639",
    referenceHint: "\u0627\u062E\u062A\u064A\u0627\u0631\u064A: \u0631\u0642\u0645 \u0627\u0644\u062A\u062D\u0648\u064A\u0644 \u0623\u0648 \u0627\u0644\u0635\u0643\u2026",
    previewLoading: "\u062C\u0627\u0631\u064D \u0627\u062D\u062A\u0633\u0627\u0628 \u0627\u0644\u062E\u0635\u0645\u2026",
    previewFailed: "\u062A\u0639\u0630\u0651\u0631 \u0627\u062D\u062A\u0633\u0627\u0628 \u0627\u0644\u062E\u0635\u0645 \u0645\u0633\u0628\u0642\u064B\u0627. \u064A\u0645\u0643\u0646\u0643 \u0627\u0644\u062D\u0641\u0638: \u0633\u064A\u064F\u062D\u062A\u0633\u0628 \u0639\u0646\u062F \u0627\u0644\u062D\u0641\u0638.",
    previewLine: "\u0627\u0644\u062E\u0635\u0645: {withheld} \u2014 \u0627\u0644\u0635\u0627\u0641\u064A \u0644\u0644\u062F\u0641\u0639: {net}",
    settles: "\u0647\u0630\u0647 \u0627\u0644\u062F\u0641\u0639\u0629 \u062A\u0633\u0648\u0651\u064A \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629 \u0628\u0627\u0644\u0643\u0627\u0645\u0644.",
    save: "\u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062F\u0641\u0639\u0629",
    saving: "\u062C\u0627\u0631\u064D \u0627\u0644\u062D\u0641\u0638\u2026",
    done: "\u062A\u0645 \u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062F\u0641\u0639\u0629 \u0639\u0644\u0649 \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629 {number}. \u0627\u0644\u0645\u062A\u0628\u0642\u064A \u0644\u0644\u062A\u0633\u0648\u064A\u0629: {remaining}.",
    errors: {
      paidOn: "\u0623\u062F\u062E\u0644 \u062A\u0627\u0631\u064A\u062E \u0627\u0644\u062F\u0641\u0639.",
      future: "\u0644\u0627 \u064A\u0645\u0643\u0646 \u0623\u0646 \u064A\u0643\u0648\u0646 \u062A\u0627\u0631\u064A\u062E \u0627\u0644\u062F\u0641\u0639 \u0641\u064A \u0627\u0644\u0645\u0633\u062A\u0642\u0628\u0644.",
      grossPositive: "\u064A\u062C\u0628 \u0623\u0646 \u064A\u0643\u0648\u0646 \u0627\u0644\u0645\u0628\u0644\u063A \u0627\u0644\u0645\u0633\u0648\u0651\u0649 \u0623\u0643\u0628\u0631 \u0645\u0646 \u0627\u0644\u0635\u0641\u0631.",
      exceeds: "\u0647\u0630\u0627 \u0627\u0644\u0645\u0628\u0644\u063A \u064A\u062A\u062C\u0627\u0648\u0632 \u0627\u0644\u0645\u062A\u0628\u0642\u064A \u0644\u0644\u062A\u0633\u0648\u064A\u0629 ({remaining})."
    }
  },
  drawer: {
    title: "\u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629 {number}",
    titleLoading: "\u0641\u0627\u062A\u0648\u0631\u0629 \u0645\u0632\u0648\u0651\u062F",
    loadFailed: "\u062A\u0639\u0630\u0651\u0631 \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629. \u062A\u062D\u0642\u0651\u0642 \u0645\u0646 \u0627\u062A\u0635\u0627\u0644\u0643 \u062B\u0645 \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629.",
    notFound: "\u0647\u0630\u0647 \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629 \u0644\u0645 \u062A\u0639\u062F \u0645\u0648\u062C\u0648\u062F\u0629 \u0623\u0648 \u0644\u0627 \u064A\u0645\u0643\u0646\u0643 \u0627\u0644\u0627\u0637\u0644\u0627\u0639 \u0639\u0644\u064A\u0647\u0627.",
    pay: "\u062A\u0633\u062C\u064A\u0644 \u062F\u0641\u0639\u0629",
    edit: "\u062A\u0639\u062F\u064A\u0644",
    cancelInvoice: "\u0625\u0644\u063A\u0627\u0621 \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629",
    cancelInvoiceTitle: "\u0625\u0644\u063A\u0627\u0621 \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629 {number}\u061F",
    cancelInvoiceBody: "\u0633\u062A\u064F\u0639\u062A\u0628\u0631 \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629 \u0645\u0644\u063A\u0627\u0629 \u0648\u0644\u0646 \u064A\u0628\u0642\u0649 \u0639\u0644\u064A\u0647\u0627 \u062E\u0635\u0645 \u0645\u0646 \u0627\u0644\u0645\u0648\u0631\u062F. \u0644\u0627 \u064A\u0645\u0643\u0646 \u0630\u0644\u0643 \u0625\u0644\u0627 \u0645\u0627 \u062F\u0627\u0645\u062A \u062F\u0648\u0646 \u0623\u064A \u062F\u0641\u0639\u0629.",
    cancelInvoiceConfirm: "\u0625\u0644\u063A\u0627\u0621 \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629",
    cancelInvoiceDone: "\u062A\u0645 \u0625\u0644\u063A\u0627\u0621 \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629 {number}.",
    keep: "\u0639\u062F\u0645 \u0627\u0644\u0625\u0644\u063A\u0627\u0621",
    yes: "\u0646\u0639\u0645",
    no: "\u0644\u0627",
    scan: "\u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629 \u0627\u0644\u0645\u0645\u0633\u0648\u062D\u0629 \u0636\u0648\u0626\u064A\u064B\u0627",
    scanAttached: "\u0645\u0631\u0641\u0642\u0629",
    amounts: "\u0627\u0644\u0645\u0628\u0627\u0644\u063A",
    withholding: "\u0627\u0644\u062E\u0635\u0645 \u0645\u0646 \u0627\u0644\u0645\u0648\u0631\u062F",
    profile: "\u0627\u0644\u0646\u0638\u0627\u0645",
    rate: "\u0627\u0644\u0646\u0633\u0628\u0629",
    base: "\u0623\u0633\u0627\u0633 \u0627\u0644\u0627\u062D\u062A\u0633\u0627\u0628",
    withholdingAmount: "\u0627\u0644\u062E\u0635\u0645",
    ruleSet: "\u0627\u0644\u0642\u0648\u0627\u0639\u062F \u0627\u0644\u0645\u0637\u0628\u0651\u0642\u0629",
    netPayable: "\u0627\u0644\u0635\u0627\u0641\u064A \u0627\u0644\u0645\u0633\u062A\u062D\u0642 \u0644\u0644\u0645\u0632\u0648\u0651\u062F",
    withholdingNote: "\u062A\u062D\u062A\u0633\u0628\u0647 BatiFlow \u0641\u064A \u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629 \u062B\u0645 \u064A\u064F\u062B\u0628\u064E\u0651\u062A. \u062A\u0642\u062A\u0637\u0639 \u0643\u0644 \u062F\u0641\u0639\u0629 \u062D\u0635\u062A\u0647\u0627 \u0648\u062A\u064F\u0635\u062F\u0631 \u0634\u0647\u0627\u062F\u0629 \u062E\u0635\u0645.",
    payments: "\u0627\u0644\u062F\u0641\u0639\u0627\u062A ({count})",
    paymentsLabel: "\u062F\u0641\u0639\u0627\u062A \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629",
    noPayments: "\u0644\u0627 \u062A\u0648\u062C\u062F \u062F\u0641\u0639\u0627\u062A \u0645\u0633\u062C\u0651\u0644\u0629.",
    paid: "\u0627\u0644\u0645\u0633\u0648\u0651\u0649 \u0625\u0644\u0649 \u062D\u062F \u0627\u0644\u0622\u0646 (\u0628\u0627\u062D\u062A\u0633\u0627\u0628 \u0627\u0644\u0623\u062F\u0627\u0621\u0627\u062A)",
    remaining: "\u0627\u0644\u0645\u062A\u0628\u0642\u064A \u0644\u0644\u062A\u0633\u0648\u064A\u0629 (\u0628\u0627\u062D\u062A\u0633\u0627\u0628 \u0627\u0644\u0623\u062F\u0627\u0621\u0627\u062A)",
    paymentGross: "\u0627\u0644\u0645\u0633\u0648\u0651\u0649:",
    paymentWithheld: "\u0627\u0644\u0645\u0642\u062A\u0637\u0639:",
    paymentNet: "\u0627\u0644\u0635\u0627\u0641\u064A \u0627\u0644\u0645\u062F\u0641\u0648\u0639:",
    reference: "\u0627\u0644\u0645\u0631\u062C\u0639:",
    certificate: "\u0634\u0647\u0627\u062F\u0629 \u0627\u0644\u062E\u0635\u0645 \u2014 \u0627\u0644\u0641\u062A\u0631\u0629 {period}\u060C \u0627\u0644\u0645\u0642\u062A\u0637\u0639 {amount}",
    noCertificate: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0634\u0647\u0627\u062F\u0629: \u0644\u0645 \u064A\u064F\u0642\u062A\u0637\u0639 \u0634\u064A\u0621 \u0645\u0646 \u0647\u0630\u0647 \u0627\u0644\u062F\u0641\u0639\u0629.",
    exported: "\u062A\u0645 \u062A\u0635\u062F\u064A\u0631\u0647\u0627 \u0625\u0644\u0649 TEJ",
    notExported: "\u0644\u0645 \u062A\u064F\u0635\u062F\u064E\u0651\u0631 \u0628\u0639\u062F",
    exportedLocked: "\u0644\u0645 \u064A\u0639\u062F \u0628\u0627\u0644\u0625\u0645\u0643\u0627\u0646 \u0625\u0644\u063A\u0627\u0621 \u0647\u0630\u0647 \u0627\u0644\u062F\u0641\u0639\u0629: \u062A\u0645 \u062A\u0635\u062F\u064A\u0631 \u0634\u0647\u0627\u062F\u062A\u0647\u0627 \u0625\u0644\u0649 TEJ.",
    cancelPayment: "\u0625\u0644\u063A\u0627\u0621",
    cancelPaymentLabel: "\u0625\u0644\u063A\u0627\u0621 \u062F\u0641\u0639\u0629 {date}",
    cancelPaymentTitle: "\u0625\u0644\u063A\u0627\u0621 \u062F\u0641\u0639\u0629 {date}\u061F",
    cancelPaymentBody: "\u0633\u062A\u064F\u0644\u063A\u0649 \u0627\u0644\u062F\u0641\u0639\u0629 \u0648\u0634\u0647\u0627\u062F\u0629 \u0627\u0644\u062E\u0635\u0645 \u0627\u0644\u0645\u0631\u062A\u0628\u0637\u0629 \u0628\u0647\u0627\u060C \u0648\u064A\u0639\u0648\u062F \u0627\u0644\u0645\u0628\u0644\u063A \u0645\u0633\u062A\u062D\u0642 \u0627\u0644\u062F\u0641\u0639.",
    cancelPaymentConfirm: "\u0625\u0644\u063A\u0627\u0621 \u0627\u0644\u062F\u0641\u0639\u0629",
    cancelPaymentDone: "\u062A\u0645 \u0625\u0644\u063A\u0627\u0621 \u062F\u0641\u0639\u0629 {date}."
  },
  withholding: {
    intro: "\u062E\u0635\u0648\u0645\u0627\u062A \u0627\u0644\u0634\u0647\u0631 \u0627\u0644\u062E\u0627\u0635\u0629 \u0628\u0627\u0644\u062A\u0635\u0631\u064A\u062D: \u0645\u0627 \u062A\u0642\u062A\u0637\u0639\u0647 \u0645\u0646 \u0645\u0632\u0648\u0651\u062F\u064A\u0643 \u0648\u0645\u0627 \u064A\u0642\u062A\u0637\u0639\u0647 \u062D\u0631\u0641\u0627\u0624\u0643 \u0645\u0646\u0643.",
    month: "\u0634\u0647\u0631 \u0627\u0644\u062A\u0635\u0631\u064A\u062D",
    loadFailedTitle: "\u0627\u0644\u062E\u0635\u0648\u0645\u0627\u062A \u063A\u064A\u0631 \u0645\u062A\u0627\u062D\u0629",
    loadFailedBody: "\u062A\u0639\u0630\u0651\u0631 \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0645\u0644\u062E\u0651\u0635. \u062A\u062D\u0642\u0651\u0642 \u0645\u0646 \u0627\u062A\u0635\u0627\u0644\u0643 \u062B\u0645 \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629.",
    issued: {
      title: "\u0627\u0644\u0645\u0642\u062A\u0637\u0639 \u0645\u0646 \u0645\u0632\u0648\u0651\u062F\u064A\u0643",
      intro: "\u0633\u0637\u0631 \u0644\u0643\u0644 \u0646\u0633\u0628\u0629\u060C \u062D\u0633\u0628 \u062F\u0641\u0639\u0627\u062A \u0627\u0644\u0634\u0647\u0631.",
      none: "\u0644\u0645 \u064A\u064F\u062C\u0631\u064E \u0623\u064A \u0627\u0642\u062A\u0637\u0627\u0639 \u0647\u0630\u0627 \u0627\u0644\u0634\u0647\u0631.",
      tableLabel: "\u0627\u0644\u0627\u0642\u062A\u0637\u0627\u0639\u0627\u062A \u0627\u0644\u0645\u064F\u062C\u0631\u0627\u0629 \u062D\u0633\u0628 \u0627\u0644\u0646\u0633\u0628\u0629",
      columns: {
        rate: "\u0627\u0644\u0646\u0633\u0628\u0629",
        count: "\u0627\u0644\u0634\u0647\u0627\u062F\u0627\u062A",
        base: "\u0627\u0644\u0623\u0633\u0627\u0633",
        amount: "\u0627\u0644\u062E\u0635\u0645"
      },
      total: "\u0627\u0644\u0645\u062C\u0645\u0648\u0639",
      exportState: "\u0627\u0644\u0645\u0635\u062F\u064E\u0651\u0631\u0629 \u0625\u0644\u0649 TEJ: {exported} \u2014 \u0627\u0644\u0645\u062A\u0628\u0642\u064A\u0629 \u0644\u0644\u062A\u0635\u062F\u064A\u0631: {pending}"
    },
    received: {
      title: "\u0627\u0644\u0645\u0642\u062A\u0637\u0639 \u0645\u0646 \u0642\u0628\u0644 \u062D\u0631\u0641\u0627\u0626\u0643",
      intro: "\u0627\u0644\u062E\u0635\u0645 \u0645\u0646 \u0627\u0644\u0645\u0648\u0631\u062F \u0648\u0627\u0644\u062E\u0635\u0645 \u0645\u0646 \u0627\u0644\u0623\u062F\u0627\u0621 \u0639\u0644\u0649 \u0627\u0644\u0642\u064A\u0645\u0629 \u0627\u0644\u0645\u0636\u0627\u0641\u0629 \u0627\u0644\u0645\u0642\u062A\u0637\u0639\u0627\u0646 \u0645\u0646 \u0627\u0644\u062F\u0641\u0639\u0627\u062A \u0627\u0644\u062A\u064A \u062A\u0644\u0642\u064A\u062A\u0647\u0627 \u0647\u0630\u0627 \u0627\u0644\u0634\u0647\u0631.",
      payments: "\u0627\u0644\u062F\u0641\u0639\u0627\u062A \u0627\u0644\u0645\u062A\u0644\u0642\u0627\u0629",
      ras: "\u0627\u0644\u062E\u0635\u0645 \u0645\u0646 \u0627\u0644\u0645\u0648\u0631\u062F",
      rasVat: "\u0627\u0644\u062E\u0635\u0645 \u0645\u0646 \u0627\u0644\u0645\u0648\u0631\u062F \u0628\u0639\u0646\u0648\u0627\u0646 \u0627\u0644\u0623\u062F\u0627\u0621 \u0639\u0644\u0649 \u0627\u0644\u0642\u064A\u0645\u0629 \u0627\u0644\u0645\u0636\u0627\u0641\u0629",
      certificates: "\u0627\u0644\u0634\u0647\u0627\u062F\u0627\u062A \u0627\u0644\u0645\u0631\u0641\u0642\u0629"
    },
    exports: {
      title: "\u0639\u0645\u0644\u064A\u0627\u062A \u0627\u0644\u062A\u0635\u062F\u064A\u0631 \u0625\u0644\u0649 TEJ",
      intro: "\u064A\u0636\u0645\u0651 \u062A\u0635\u062F\u064A\u0631 \u0627\u0644\u0634\u0647\u0631 \u0634\u0647\u0627\u062F\u0627\u062A \u0627\u0644\u062E\u0635\u0645 \u0627\u0644\u062A\u064A \u0644\u0645 \u062A\u064F\u0635\u062F\u064E\u0651\u0631 \u0628\u0639\u062F. \u0644\u0627 \u062A\u064F\u0635\u062F\u064E\u0651\u0631 \u0643\u0644 \u0634\u0647\u0627\u062F\u0629 \u0625\u0644\u0627 \u0645\u0631\u0629 \u0648\u0627\u062D\u062F\u0629.",
      generate: "\u0625\u0646\u0634\u0627\u0621 \u062A\u0635\u062F\u064A\u0631 TEJ \u0644\u0644\u0634\u0647\u0631",
      generating: "\u062C\u0627\u0631\u064D \u0627\u0644\u0625\u0646\u0634\u0627\u0621\u2026",
      nothing: "\u0644\u0627 \u0634\u064A\u0621 \u0644\u0644\u062A\u0635\u062F\u064A\u0631 \u0641\u064A {period}: \u0644\u0645 \u064A\u064F\u062C\u0631\u064E \u0623\u064A \u0627\u0642\u062A\u0637\u0627\u0639 \u0623\u0648 \u0633\u0628\u0642 \u062A\u0635\u062F\u064A\u0631 \u0643\u0644 \u0627\u0644\u0634\u0647\u0627\u062F\u0627\u062A.",
      created: "\u062A\u0645 \u0625\u0646\u0634\u0627\u0621 \u062A\u0635\u062F\u064A\u0631 TEJ \u0644\u0634\u0647\u0631 {period}: {count} \u0634\u0647\u0627\u062F\u0629\u060C \u0627\u0644\u0645\u0642\u062A\u0637\u0639 {total}.",
      tableLabel: "\u0633\u062C\u0644\u0651 \u0639\u0645\u0644\u064A\u0627\u062A \u0627\u0644\u062A\u0635\u062F\u064A\u0631 \u0625\u0644\u0649 TEJ",
      columns: {
        period: "\u0627\u0644\u0641\u062A\u0631\u0629",
        format: "\u0627\u0644\u0635\u064A\u063A\u0629",
        count: "\u0627\u0644\u0634\u0647\u0627\u062F\u0627\u062A",
        total: "\u0645\u062C\u0645\u0648\u0639 \u0627\u0644\u0645\u0642\u062A\u0637\u0639",
        author: "\u0623\u0646\u0634\u0623\u0647",
        date: "\u0627\u0644\u062A\u0627\u0631\u064A\u062E",
        file: "\u0627\u0644\u0645\u0644\u0641"
      },
      formatToVerify: "\u0635\u064A\u063A\u0629 \u064A\u062C\u0628 \u062A\u0623\u0643\u064A\u062F\u0647\u0627 \u0645\u0639 \u0627\u0644\u062E\u0628\u064A\u0631 \u0627\u0644\u0645\u062D\u0627\u0633\u0628",
      download: "\u062A\u0646\u0632\u064A\u0644",
      downloadLabel: "\u062A\u0646\u0632\u064A\u0644 \u062A\u0635\u062F\u064A\u0631 TEJ \u0644\u0634\u0647\u0631 {period}",
      empty: {
        title: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0639\u0645\u0644\u064A\u0627\u062A \u062A\u0635\u062F\u064A\u0631 \u0628\u0639\u062F",
        body: "\u0633\u062A\u0638\u0647\u0631 \u0647\u0646\u0627 \u0639\u0645\u0644\u064A\u0627\u062A \u0627\u0644\u062A\u0635\u062F\u064A\u0631 \u0627\u0644\u0645\u0646\u0634\u0623\u0629 \u0645\u0639 \u0645\u0644\u0641\u0627\u062A\u0647\u0627."
      },
      loadFailedTitle: "\u0627\u0644\u0633\u062C\u0644\u0651 \u063A\u064A\u0631 \u0645\u062A\u0627\u062D",
      loadFailedBody: "\u062A\u0639\u0630\u0651\u0631 \u062A\u062D\u0645\u064A\u0644 \u0642\u0627\u0626\u0645\u0629 \u0639\u0645\u0644\u064A\u0627\u062A \u0627\u0644\u062A\u0635\u062F\u064A\u0631. \u062A\u062D\u0642\u0651\u0642 \u0645\u0646 \u0627\u062A\u0635\u0627\u0644\u0643 \u062B\u0645 \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629."
    }
  },
  errors: {
    SUPPLIER_TAX_ID_TAKEN: "\u064A\u0648\u062C\u062F \u0645\u0632\u0648\u0651\u062F \u0622\u062E\u0631 \u0641\u064A \u0645\u0643\u062A\u0628\u0643 \u064A\u062D\u0645\u0644 \u0647\u0630\u0627 \u0627\u0644\u0645\u0639\u0631\u0651\u0641 \u0627\u0644\u062C\u0628\u0627\u0626\u064A.",
    SUPPLIER_ARCHIVED: "\u0647\u0630\u0627 \u0627\u0644\u0645\u0632\u0648\u0651\u062F \u0645\u0624\u0631\u0634\u0641: \u0627\u0633\u062A\u0639\u062F\u0647 \u0642\u0628\u0644 \u062A\u0633\u062C\u064A\u0644 \u0641\u0627\u062A\u0648\u0631\u0629 \u062C\u062F\u064A\u062F\u0629.",
    SUPPLIER_INVOICE_NUMBER_TAKEN: "\u0644\u062F\u0649 \u0647\u0630\u0627 \u0627\u0644\u0645\u0632\u0648\u0651\u062F \u0641\u0627\u062A\u0648\u0631\u0629 \u062A\u062D\u0645\u0644 \u0647\u0630\u0627 \u0627\u0644\u0631\u0642\u0645 \u0645\u0646 \u0642\u0628\u0644.",
    SUPPLIER_INVOICE_NOT_PAYABLE: "\u0647\u0630\u0647 \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629 \u0645\u0644\u063A\u0627\u0629 \u0623\u0648 \u0645\u062F\u0641\u0648\u0639\u0629 \u0628\u0627\u0644\u0643\u0627\u0645\u0644: \u0644\u0627 \u064A\u0645\u0643\u0646 \u062A\u0633\u062C\u064A\u0644 \u062F\u0641\u0639\u0629 \u0639\u0644\u064A\u0647\u0627.",
    SUPPLIER_INVOICE_HAS_PAYMENTS: "\u062A\u0644\u0642\u0651\u062A \u0647\u0630\u0647 \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629 \u062F\u0641\u0639\u0627\u062A: \u0623\u0644\u063A\u0650 \u062F\u0641\u0639\u0627\u062A\u0647\u0627 \u0623\u0648\u0644\u064B\u0627.",
    SUPPLIER_PAYMENT_EXCEEDS: "\u0647\u0630\u0647 \u0627\u0644\u062F\u0641\u0639\u0629 \u062A\u062A\u062C\u0627\u0648\u0632 \u0627\u0644\u0645\u062A\u0628\u0642\u064A \u0644\u0644\u062A\u0633\u0648\u064A\u0629. \u062A\u0645 \u062A\u062D\u062F\u064A\u062B \u0627\u0644\u0645\u0628\u0627\u0644\u063A: \u0631\u0627\u062C\u0639\u0647\u0627 \u062B\u0645 \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629.",
    SUPPLIER_PAYMENT_EXPORTED: "\u0644\u0627 \u064A\u0645\u0643\u0646 \u0625\u0644\u063A\u0627\u0621 \u0647\u0630\u0647 \u0627\u0644\u062F\u0641\u0639\u0629: \u062A\u0645 \u062A\u0635\u062F\u064A\u0631 \u0634\u0647\u0627\u062F\u0629 \u0627\u0644\u062E\u0635\u0645 \u0627\u0644\u062E\u0627\u0635\u0629 \u0628\u0647\u0627 \u0625\u0644\u0649 TEJ.",
    SUPPLIER_DOCUMENT_INVALID: "\u0647\u0630\u0647 \u0627\u0644\u0648\u062B\u064A\u0642\u0629 \u063A\u064A\u0631 \u0645\u062A\u0627\u062D\u0629. \u0627\u062E\u062A\u0631 \u0648\u062B\u064A\u0642\u0629 \u0645\u0646 \u0648\u062B\u0627\u0626\u0642 \u0645\u0643\u062A\u0628\u0643 \u064A\u0645\u0643\u0646\u0643 \u0627\u0644\u0627\u0637\u0644\u0627\u0639 \u0639\u0644\u064A\u0647\u0627.",
    TEJ_NOTHING_TO_EXPORT: "\u0644\u0627 \u0634\u064A\u0621 \u0644\u0644\u062A\u0635\u062F\u064A\u0631 \u0641\u064A \u0647\u0630\u0627 \u0627\u0644\u0634\u0647\u0631: \u0644\u0645 \u064A\u064F\u062C\u0631\u064E \u0623\u064A \u0627\u0642\u062A\u0637\u0627\u0639 \u0623\u0648 \u0633\u0628\u0642 \u062A\u0635\u062F\u064A\u0631 \u0643\u0644 \u0627\u0644\u0634\u0647\u0627\u062F\u0627\u062A.",
    PERIOD_CLOSED: "\u0647\u0630\u0647 \u0627\u0644\u0641\u062A\u0631\u0629 \u0627\u0644\u0645\u062D\u0627\u0633\u0628\u064A\u0629 \u0645\u063A\u0644\u0642\u0629: \u0644\u0645 \u062A\u0639\u062F \u0627\u0644\u0639\u0645\u0644\u064A\u0629 \u0645\u0645\u0643\u0646\u0629 \u0641\u064A \u0647\u0630\u0627 \u0627\u0644\u0634\u0647\u0631."
  }
};

// locales/en/suppliers.json
var suppliers_default2 = {
  kinds: {
    company: "Company",
    individual: "Individual",
    non_resident: "Non-resident"
  },
  profiles: {
    fees_legal_entity: "Fees \u2014 legal entity or real tax regime (3%)",
    fees_other: "Fees \u2014 others (10%)",
    fees_non_resident: "Fees \u2014 non-resident (15%)",
    purchases: "Purchases (1.5% from 1,000 TND incl. VAT)",
    none: "No withholding"
  },
  methods: {
    transfer: "Bank transfer",
    cheque: "Cheque",
    bill: "Bill of exchange",
    cash: "Cash",
    online: "Online payment"
  },
  invoiceStatus: {
    open: "Open",
    partially_paid: "Partially paid",
    paid: "Paid",
    cancelled: "Cancelled",
    overdue: "Overdue"
  },
  toVerify: {
    badge: "To be verified by the accountant",
    rules: "This value must be confirmed by the accountant before it is considered final. Rules concerned: {rules}."
  },
  month: {
    previous: "Previous month",
    next: "Next month"
  },
  suppliers: {
    intro: "Your suppliers and subcontractors. Their withholding profile decides the withholding operated when you pay them.",
    new: "New supplier",
    tableLabel: "List of suppliers",
    noTaxId: "Not provided",
    activeState: "Active",
    archivedChip: "Archived",
    columns: {
      name: "Name",
      kind: "Type",
      taxId: "Tax ID",
      profile: "Withholding",
      balance: "Left to pay",
      state: "Status",
      actions: "Actions"
    },
    filters: {
      label: "Filter suppliers",
      search: "Search for a supplier",
      searchPlaceholder: "Name or tax ID",
      state: "Supplier status",
      active: "Active suppliers",
      archived: "Archived suppliers"
    },
    empty: {
      title: "No suppliers yet",
      body: "Add your suppliers and subcontractors to record their invoices and withhold tax at source.",
      filteredTitle: "No supplier matches",
      filteredBody: "Try another name or tax ID, or go back to the active suppliers.",
      clear: "Clear filters"
    },
    loadFailedTitle: "Suppliers unavailable",
    loadFailedBody: "The list could not be loaded. Check your connection and try again.",
    loadMore: "Show more suppliers",
    loadingMore: "Loading\u2026",
    editLabel: "Edit {name}",
    archiveLabel: "Archive {name}",
    restoreLabel: "Restore {name}",
    archiveTitle: "Archive {name}?",
    archiveBody: "This supplier will no longer be able to receive a new invoice. Its invoices and certificates stay available and you can restore it at any time.",
    archiveConfirm: "Archive",
    archivedDone: "{name} is archived.",
    restoredDone: "{name} is active again."
  },
  supplier: {
    createTitle: "New supplier",
    editTitle: "Edit supplier",
    name: "Name or company name",
    kind: "Type of supplier",
    taxId: "Tax ID",
    taxIdHint: "Required for a supplier established in Tunisia.",
    taxIdHintNonResident: "Optional for a non-resident.",
    profile: "Withholding at source",
    profileHint: "Percentages are indicative: BatiFlow computes the exact withholding from the tax rules in force on the invoice date.",
    email: "Email",
    phone: "Phone",
    address: "Address",
    bankTitle: "Bank details",
    bankHint: "Optional. The RIB (20 digits) or, for a supplier abroad, the IBAN. It is encrypted and masked on screen.",
    bankName: "Bank",
    account: "RIB or IBAN",
    accountHint: "Spaces are ignored.",
    bankReplace: "Replace the details",
    bankRemove: "Remove the details",
    bankKeep: "Keep the current details",
    bankWillRemove: "The bank details will be removed when you save.",
    save: "Save",
    saving: "Saving\u2026",
    created: "Supplier {name} is added.",
    updated: "Supplier {name} is updated.",
    errors: {
      name: "Enter the supplier's name.",
      taxId: "Enter the supplier's tax ID (optional only for a non-resident).",
      email: "This email address is not valid.",
      phone: "This phone number is too short.",
      bankName: "Enter the bank's name.",
      account: "A RIB has 20 digits; an IBAN starts with two letters and two digits."
    }
  },
  bank: {
    account: "RIB / IBAN",
    show: "Show",
    hide: "Hide",
    loading: "Loading\u2026",
    stepUp: "Confirm your identity in the window that opens, then choose \u201CShow\u201D again."
  },
  invoices: {
    intro: "The invoices received from your suppliers and subcontractors. The withholding is computed when you record the invoice and operated at each payment.",
    record: "Record an invoice",
    tableLabel: "List of supplier invoices",
    none: "\u2014",
    openLabel: "Open invoice {number}",
    columns: {
      number: "Number",
      supplier: "Supplier",
      invoiceDate: "Date",
      dueDate: "Due date",
      ttc: "Total incl. VAT",
      withholding: "Withholding",
      remaining: "Left to settle",
      status: "Status"
    },
    filters: {
      label: "Filter supplier invoices",
      supplier: "Supplier",
      allSuppliers: "All suppliers",
      status: "Invoice status",
      allStatuses: "All statuses",
      month: "Invoice month",
      allMonths: "All months",
      project: "Project",
      allProjects: "All projects",
      overdue: "Overdue only"
    },
    empty: {
      title: "No supplier invoices",
      body: "Record a received invoice to compute the withholding and follow what is left to pay.",
      filteredTitle: "No invoice matches",
      filteredBody: "Change the filters to see other invoices.",
      clear: "Clear filters"
    },
    loadFailedTitle: "Invoices unavailable",
    loadFailedBody: "The list could not be loaded. Check your connection and try again.",
    loadMore: "Show more invoices",
    loadingMore: "Loading\u2026"
  },
  invoice: {
    createTitle: "Record a supplier invoice",
    editTitle: "Edit invoice {number}",
    editHint: "The amounts cannot change after recording. If there is a mistake, cancel the invoice while it has no payment, then record it again.",
    supplier: "Supplier",
    pickSupplier: "Choose a supplier",
    loadingSuppliers: "Loading suppliers\u2026",
    number: "Invoice number",
    invoiceDate: "Invoice date",
    dueDate: "Due date",
    description: "Description",
    ht: "Amount excl. VAT",
    vat: "VAT",
    stamp: "Stamp duty",
    ttc: "Total incl. VAT",
    ttcHint: "Must equal excl. VAT + VAT + stamp, that is {sum}.",
    vatDeductible: "VAT deductible",
    vatDeductibleShort: "VAT deductible",
    project: "Project",
    projectHint: "Optional. Charges the cost to the project.",
    noProject: "No project",
    scan: "Scanned invoice",
    scanHint: "Optional. Search for a document already uploaded in Files (at least 2 characters).",
    scanChosen: "Scan chosen:",
    scanKept: "scan already attached",
    scanRemove: "Remove the scan",
    record: "Record the invoice",
    save: "Save",
    saving: "Saving\u2026",
    recorded: "Invoice {number} is recorded. Withholding computed: {amount}.",
    updated: "Invoice {number} is updated.",
    errors: {
      supplier: "Choose the supplier.",
      number: "Enter the invoice number.",
      invoiceDate: "Enter the invoice date.",
      dueDate: "The due date cannot be before the invoice date.",
      ht: "Enter the amount excl. VAT.",
      ttcPositive: "The total incl. VAT must be greater than zero.",
      ttcSum: "The total incl. VAT must equal excl. VAT + VAT + stamp, that is {sum}."
    }
  },
  payment: {
    title: "Record a payment \u2014 invoice {number}",
    remaining: "Left to settle (incl. VAT): {amount}",
    paidOn: "Payment date",
    method: "Payment method",
    gross: "Part of the invoice settled (incl. VAT)",
    grossHint: "Withholding included. By default, the whole amount left to settle.",
    reference: "Reference",
    referenceHint: "Optional: transfer or cheque number\u2026",
    previewLoading: "Computing the withholding\u2026",
    previewFailed: "The withholding could not be computed in advance. You can still save: it will be computed when you save.",
    previewLine: "Withholding: {withheld} \u2014 Net to pay: {net}",
    settles: "This payment settles the invoice.",
    save: "Record the payment",
    saving: "Saving\u2026",
    done: "Payment recorded on invoice {number}. Left to settle: {remaining}.",
    errors: {
      paidOn: "Enter the payment date.",
      future: "The payment date cannot be in the future.",
      grossPositive: "The amount settled must be greater than zero.",
      exceeds: "This amount exceeds what is left to settle ({remaining})."
    }
  },
  drawer: {
    title: "Invoice {number}",
    titleLoading: "Supplier invoice",
    loadFailed: "The invoice could not be loaded. Check your connection and try again.",
    notFound: "This invoice no longer exists or you do not have access to it.",
    pay: "Record a payment",
    edit: "Edit",
    cancelInvoice: "Cancel the invoice",
    cancelInvoiceTitle: "Cancel invoice {number}?",
    cancelInvoiceBody: "The invoice will be marked as cancelled and will have no withholding to operate. This is only possible while no payment has been recorded.",
    cancelInvoiceConfirm: "Cancel the invoice",
    cancelInvoiceDone: "Invoice {number} is cancelled.",
    keep: "Do not cancel",
    yes: "Yes",
    no: "No",
    scan: "Scanned invoice",
    scanAttached: "Attached",
    amounts: "Amounts",
    withholding: "Withholding at source",
    profile: "Profile",
    rate: "Rate",
    base: "Basis of calculation",
    withholdingAmount: "Withholding",
    ruleSet: "Rules applied",
    netPayable: "Net to pay the supplier",
    withholdingNote: "Computed by BatiFlow on the invoice date, then frozen. Each payment withholds its share and issues a withholding certificate.",
    payments: "Payments ({count})",
    paymentsLabel: "Payments of the invoice",
    noPayments: "No payment recorded.",
    paid: "Already settled (incl. VAT)",
    remaining: "Left to settle (incl. VAT)",
    paymentGross: "Settled:",
    paymentWithheld: "Withheld:",
    paymentNet: "Net paid:",
    reference: "Reference:",
    certificate: "Withholding certificate \u2014 period {period}, withheld {amount}",
    noCertificate: "No certificate: nothing was withheld on this payment.",
    exported: "Exported to TEJ",
    notExported: "Not exported yet",
    exportedLocked: "This payment can no longer be cancelled: its certificate was exported to TEJ.",
    cancelPayment: "Cancel",
    cancelPaymentLabel: "Cancel the payment of {date}",
    cancelPaymentTitle: "Cancel the payment of {date}?",
    cancelPaymentBody: "The payment and its withholding certificate will be cancelled. The amount becomes payable again.",
    cancelPaymentConfirm: "Cancel the payment",
    cancelPaymentDone: "The payment of {date} is cancelled."
  },
  withholding: {
    intro: "The month's withholding for the declaration: what you withhold from your suppliers and what your clients withhold from you.",
    month: "Declaration month",
    loadFailedTitle: "Withholding unavailable",
    loadFailedBody: "The summary could not be loaded. Check your connection and try again.",
    issued: {
      title: "Withheld from your suppliers",
      intro: "One line per rate, from the month's payments.",
      none: "No withholding was operated this month.",
      tableLabel: "Withholding operated, by rate",
      columns: {
        rate: "Rate",
        count: "Certificates",
        base: "Basis",
        amount: "Withholding"
      },
      total: "Total",
      exportState: "Exported to TEJ: {exported} \u2014 To export: {pending}"
    },
    received: {
      title: "Withheld by your clients",
      intro: "Withholding at source and VAT withholding deducted from the payments you received this month.",
      payments: "Payments received",
      ras: "Withholding at source",
      rasVat: "VAT withholding at source",
      certificates: "Certificates attached"
    },
    exports: {
      title: "TEJ exports",
      intro: "The month's export contains the withholding certificates not exported yet. Each certificate is exported only once.",
      generate: "Generate the month's TEJ export",
      generating: "Generating\u2026",
      nothing: "Nothing to export for {period}: no withholding was operated, or all certificates were already exported.",
      created: "TEJ export for {period} generated: {count} certificate(s), {total} withheld.",
      tableLabel: "History of TEJ exports",
      columns: {
        period: "Period",
        format: "Format",
        count: "Certificates",
        total: "Total withheld",
        author: "Generated by",
        date: "Date",
        file: "File"
      },
      formatToVerify: "Format to be confirmed with the accountant",
      download: "Download",
      downloadLabel: "Download the TEJ export of {period}",
      empty: {
        title: "No export yet",
        body: "Generated exports will appear here with their file."
      },
      loadFailedTitle: "History unavailable",
      loadFailedBody: "The list of exports could not be loaded. Check your connection and try again."
    }
  },
  errors: {
    SUPPLIER_TAX_ID_TAKEN: "Another supplier of your office already has this tax ID.",
    SUPPLIER_ARCHIVED: "This supplier is archived: restore it before recording a new invoice.",
    SUPPLIER_INVOICE_NUMBER_TAKEN: "This supplier already has an invoice with this number.",
    SUPPLIER_INVOICE_NOT_PAYABLE: "This invoice is cancelled or already fully paid: no payment can be recorded on it.",
    SUPPLIER_INVOICE_HAS_PAYMENTS: "This invoice already has payments: cancel its payments first.",
    SUPPLIER_PAYMENT_EXCEEDS: "This payment exceeds what is left to settle. The amounts were refreshed: check them and try again.",
    SUPPLIER_PAYMENT_EXPORTED: "This payment cannot be cancelled: its withholding certificate was already exported to TEJ.",
    SUPPLIER_DOCUMENT_INVALID: "This document is not available. Choose a document of your office that you can access.",
    TEJ_NOTHING_TO_EXPORT: "Nothing to export for this month: no withholding was operated, or all certificates were already exported.",
    PERIOD_CLOSED: "This accounting period is closed: the operation is no longer possible for this month."
  }
};

// locales/fr/suppliers.json
var suppliers_default3 = {
  kinds: {
    company: "Soci\xE9t\xE9",
    individual: "Personne physique",
    non_resident: "Non-r\xE9sident"
  },
  profiles: {
    fees_legal_entity: "Honoraires \u2014 personne morale ou r\xE9gime r\xE9el (3 %)",
    fees_other: "Honoraires \u2014 autres (10 %)",
    fees_non_resident: "Honoraires \u2014 non-r\xE9sident (15 %)",
    purchases: "Achats (1,5 % \xE0 partir de 1 000 TND TTC)",
    none: "Aucune retenue"
  },
  methods: {
    transfer: "Virement",
    cheque: "Ch\xE8que",
    bill: "Effet de commerce",
    cash: "Esp\xE8ces",
    online: "Paiement en ligne"
  },
  invoiceStatus: {
    open: "Ouverte",
    partially_paid: "Partiellement pay\xE9e",
    paid: "Pay\xE9e",
    cancelled: "Annul\xE9e",
    overdue: "En retard"
  },
  toVerify: {
    badge: "\xC0 v\xE9rifier par l\u2019expert-comptable",
    rules: "Cette valeur doit \xEAtre confirm\xE9e par l\u2019expert-comptable avant d\u2019\xEAtre consid\xE9r\xE9e comme d\xE9finitive. R\xE8gles concern\xE9es : {rules}."
  },
  month: {
    previous: "Mois pr\xE9c\xE9dent",
    next: "Mois suivant"
  },
  suppliers: {
    intro: "Vos fournisseurs et sous-traitants. Leur profil de retenue \xE0 la source d\xE9cide de la retenue op\xE9r\xE9e lorsque vous les payez.",
    new: "Nouveau fournisseur",
    tableLabel: "Liste des fournisseurs",
    noTaxId: "Non renseign\xE9",
    activeState: "Actif",
    archivedChip: "Archiv\xE9",
    columns: {
      name: "Nom",
      kind: "Type",
      taxId: "Matricule fiscal",
      profile: "Retenue \xE0 la source",
      balance: "Reste \xE0 payer",
      state: "\xC9tat",
      actions: "Actions"
    },
    filters: {
      label: "Filtrer les fournisseurs",
      search: "Rechercher un fournisseur",
      searchPlaceholder: "Nom ou matricule fiscal",
      state: "\xC9tat des fournisseurs",
      active: "Fournisseurs actifs",
      archived: "Fournisseurs archiv\xE9s"
    },
    empty: {
      title: "Aucun fournisseur pour le moment",
      body: "Ajoutez vos fournisseurs et sous-traitants pour enregistrer leurs factures et op\xE9rer la retenue \xE0 la source.",
      filteredTitle: "Aucun fournisseur ne correspond",
      filteredBody: "Essayez un autre nom ou matricule, ou revenez aux fournisseurs actifs.",
      clear: "Effacer les filtres"
    },
    loadFailedTitle: "Fournisseurs indisponibles",
    loadFailedBody: "La liste n\u2019a pas pu \xEAtre charg\xE9e. V\xE9rifiez votre connexion puis r\xE9essayez.",
    loadMore: "Afficher plus de fournisseurs",
    loadingMore: "Chargement\u2026",
    editLabel: "Modifier {name}",
    archiveLabel: "Archiver {name}",
    restoreLabel: "Restaurer {name}",
    archiveTitle: "Archiver {name}\xA0?",
    archiveBody: "Ce fournisseur ne pourra plus recevoir de nouvelle facture. Ses factures et certificats restent consultables et vous pourrez le restaurer \xE0 tout moment.",
    archiveConfirm: "Archiver",
    archivedDone: "{name} est archiv\xE9.",
    restoredDone: "{name} est de nouveau actif."
  },
  supplier: {
    createTitle: "Nouveau fournisseur",
    editTitle: "Modifier le fournisseur",
    name: "Nom ou raison sociale",
    kind: "Type de fournisseur",
    taxId: "Matricule fiscal",
    taxIdHint: "Obligatoire pour un fournisseur \xE9tabli en Tunisie.",
    taxIdHintNonResident: "Facultatif pour un non-r\xE9sident.",
    profile: "Retenue \xE0 la source",
    profileHint: "Les pourcentages sont indicatifs\xA0: la retenue exacte est calcul\xE9e par BatiFlow selon les r\xE8gles fiscales en vigueur \xE0 la date de la facture.",
    email: "E-mail",
    phone: "T\xE9l\xE9phone",
    address: "Adresse",
    bankTitle: "Coordonn\xE9es bancaires",
    bankHint: "Facultatif. Le RIB (20 chiffres) ou, pour un fournisseur \xE0 l\u2019\xE9tranger, l\u2019IBAN. Il est chiffr\xE9 et masqu\xE9 \xE0 l\u2019\xE9cran.",
    bankName: "Banque",
    account: "RIB ou IBAN",
    accountHint: "Les espaces sont ignor\xE9s.",
    bankReplace: "Remplacer les coordonn\xE9es",
    bankRemove: "Supprimer les coordonn\xE9es",
    bankKeep: "Conserver les coordonn\xE9es actuelles",
    bankWillRemove: "Les coordonn\xE9es bancaires seront supprim\xE9es \xE0 l\u2019enregistrement.",
    save: "Enregistrer",
    saving: "Enregistrement\u2026",
    created: "Le fournisseur {name} est ajout\xE9.",
    updated: "Le fournisseur {name} est mis \xE0 jour.",
    errors: {
      name: "Indiquez le nom du fournisseur.",
      taxId: "Indiquez le matricule fiscal du fournisseur (facultatif seulement pour un non-r\xE9sident).",
      email: "Cette adresse e-mail n\u2019est pas valide.",
      phone: "Ce num\xE9ro de t\xE9l\xE9phone est trop court.",
      bankName: "Indiquez le nom de la banque.",
      account: "Un RIB comporte 20 chiffres\xA0; un IBAN commence par deux lettres et deux chiffres."
    }
  },
  bank: {
    account: "RIB / IBAN",
    show: "Afficher",
    hide: "Masquer",
    loading: "Chargement\u2026",
    stepUp: "Confirmez votre identit\xE9 dans la fen\xEAtre qui s\u2019ouvre, puis choisissez de nouveau \xAB\xA0Afficher\xA0\xBB."
  },
  invoices: {
    intro: "Les factures re\xE7ues de vos fournisseurs et sous-traitants. La retenue \xE0 la source est calcul\xE9e \xE0 l\u2019enregistrement et op\xE9r\xE9e \xE0 chaque paiement.",
    record: "Enregistrer une facture",
    tableLabel: "Liste des factures fournisseurs",
    none: "\u2014",
    openLabel: "Ouvrir la facture {number}",
    columns: {
      number: "Num\xE9ro",
      supplier: "Fournisseur",
      invoiceDate: "Date",
      dueDate: "\xC9ch\xE9ance",
      ttc: "Total TTC",
      withholding: "Retenue",
      remaining: "Reste \xE0 r\xE9gler",
      status: "\xC9tat"
    },
    filters: {
      label: "Filtrer les factures fournisseurs",
      supplier: "Fournisseur",
      allSuppliers: "Tous les fournisseurs",
      status: "\xC9tat de la facture",
      allStatuses: "Tous les \xE9tats",
      month: "Mois de la facture",
      allMonths: "Tous les mois",
      project: "Projet",
      allProjects: "Tous les projets",
      overdue: "En retard seulement"
    },
    empty: {
      title: "Aucune facture fournisseur",
      body: "Enregistrez une facture re\xE7ue pour calculer la retenue \xE0 la source et suivre ce qu\u2019il reste \xE0 payer.",
      filteredTitle: "Aucune facture ne correspond",
      filteredBody: "Modifiez les filtres pour voir d\u2019autres factures.",
      clear: "Effacer les filtres"
    },
    loadFailedTitle: "Factures indisponibles",
    loadFailedBody: "La liste n\u2019a pas pu \xEAtre charg\xE9e. V\xE9rifiez votre connexion puis r\xE9essayez.",
    loadMore: "Afficher plus de factures",
    loadingMore: "Chargement\u2026"
  },
  invoice: {
    createTitle: "Enregistrer une facture fournisseur",
    editTitle: "Modifier la facture {number}",
    editHint: "Les montants ne changent plus apr\xE8s l\u2019enregistrement. En cas d\u2019erreur, annulez la facture tant qu\u2019elle n\u2019a re\xE7u aucun paiement, puis enregistrez-la de nouveau.",
    supplier: "Fournisseur",
    pickSupplier: "Choisir un fournisseur",
    loadingSuppliers: "Chargement des fournisseurs\u2026",
    number: "Num\xE9ro de la facture",
    invoiceDate: "Date de la facture",
    dueDate: "\xC9ch\xE9ance",
    description: "Description",
    ht: "Montant HT",
    vat: "TVA",
    stamp: "Droit de timbre",
    ttc: "Total TTC",
    ttcHint: "Doit \xEAtre \xE9gal \xE0 HT + TVA + timbre, soit {sum}.",
    vatDeductible: "TVA d\xE9ductible",
    vatDeductibleShort: "TVA d\xE9ductible",
    project: "Projet",
    projectHint: "Facultatif. Rattache le co\xFBt au projet.",
    noProject: "Aucun projet",
    scan: "Facture scann\xE9e",
    scanHint: "Facultatif. Recherchez un document d\xE9j\xE0 d\xE9pos\xE9 dans Fichiers (au moins 2 caract\xE8res).",
    scanChosen: "Scan choisi\xA0:",
    scanKept: "scan d\xE9j\xE0 joint",
    scanRemove: "Retirer le scan",
    record: "Enregistrer la facture",
    save: "Enregistrer",
    saving: "Enregistrement\u2026",
    recorded: "La facture {number} est enregistr\xE9e. Retenue \xE0 la source calcul\xE9e\xA0: {amount}.",
    updated: "La facture {number} est mise \xE0 jour.",
    errors: {
      supplier: "Choisissez le fournisseur.",
      number: "Indiquez le num\xE9ro de la facture.",
      invoiceDate: "Indiquez la date de la facture.",
      dueDate: "L\u2019\xE9ch\xE9ance ne peut pas pr\xE9c\xE9der la date de la facture.",
      ht: "Indiquez le montant HT.",
      ttcPositive: "Le total TTC doit \xEAtre sup\xE9rieur \xE0 z\xE9ro.",
      ttcSum: "Le total TTC doit \xEAtre \xE9gal \xE0 HT + TVA + timbre, soit {sum}."
    }
  },
  payment: {
    title: "Enregistrer un paiement \u2014 facture {number}",
    remaining: "Reste \xE0 r\xE9gler (TTC)\xA0: {amount}",
    paidOn: "Date du paiement",
    method: "Mode de paiement",
    gross: "Part de la facture r\xE9gl\xE9e (TTC)",
    grossHint: "Retenue \xE0 la source incluse. Par d\xE9faut, tout le reste \xE0 r\xE9gler.",
    reference: "R\xE9f\xE9rence",
    referenceHint: "Facultatif\xA0: num\xE9ro de virement, de ch\xE8que\u2026",
    previewLoading: "Calcul de la retenue\u2026",
    previewFailed: "La retenue n\u2019a pas pu \xEAtre calcul\xE9e \xE0 l\u2019avance. Vous pouvez enregistrer\xA0: elle sera calcul\xE9e \xE0 l\u2019enregistrement.",
    previewLine: "Retenue\xA0: {withheld} \u2014 Net \xE0 verser\xA0: {net}",
    settles: "Ce paiement solde la facture.",
    save: "Enregistrer le paiement",
    saving: "Enregistrement\u2026",
    done: "Paiement enregistr\xE9 sur la facture {number}. Reste \xE0 r\xE9gler\xA0: {remaining}.",
    errors: {
      paidOn: "Indiquez la date du paiement.",
      future: "La date du paiement ne peut pas \xEAtre dans le futur.",
      grossPositive: "Le montant r\xE9gl\xE9 doit \xEAtre sup\xE9rieur \xE0 z\xE9ro.",
      exceeds: "Ce montant d\xE9passe le reste \xE0 r\xE9gler ({remaining})."
    }
  },
  drawer: {
    title: "Facture {number}",
    titleLoading: "Facture fournisseur",
    loadFailed: "La facture n\u2019a pas pu \xEAtre charg\xE9e. V\xE9rifiez votre connexion puis r\xE9essayez.",
    notFound: "Cette facture n\u2019existe plus ou vous n\u2019y avez pas acc\xE8s.",
    pay: "Enregistrer un paiement",
    edit: "Modifier",
    cancelInvoice: "Annuler la facture",
    cancelInvoiceTitle: "Annuler la facture {number}\xA0?",
    cancelInvoiceBody: "La facture sera marqu\xE9e comme annul\xE9e et n\u2019aura plus de retenue \xE0 op\xE9rer. Cette action n\u2019est possible que tant qu\u2019aucun paiement n\u2019a \xE9t\xE9 enregistr\xE9.",
    cancelInvoiceConfirm: "Annuler la facture",
    cancelInvoiceDone: "La facture {number} est annul\xE9e.",
    keep: "Ne pas annuler",
    yes: "Oui",
    no: "Non",
    scan: "Facture scann\xE9e",
    scanAttached: "Jointe",
    amounts: "Montants",
    withholding: "Retenue \xE0 la source",
    profile: "Profil",
    rate: "Taux",
    base: "Base de calcul",
    withholdingAmount: "Retenue",
    ruleSet: "R\xE8gles appliqu\xE9es",
    netPayable: "Net \xE0 verser au fournisseur",
    withholdingNote: "Calcul\xE9e par BatiFlow \xE0 la date de la facture, puis fig\xE9e. Chaque paiement en retient sa part et \xE9met un certificat de retenue.",
    payments: "Paiements ({count})",
    paymentsLabel: "Paiements de la facture",
    noPayments: "Aucun paiement enregistr\xE9.",
    paid: "D\xE9j\xE0 r\xE9gl\xE9 (TTC)",
    remaining: "Reste \xE0 r\xE9gler (TTC)",
    paymentGross: "R\xE9gl\xE9\xA0:",
    paymentWithheld: "Retenue\xA0:",
    paymentNet: "Net vers\xE9\xA0:",
    reference: "R\xE9f\xE9rence\xA0:",
    certificate: "Certificat de retenue \u2014 p\xE9riode {period}, retenue {amount}",
    noCertificate: "Pas de certificat\xA0: aucune retenue sur ce paiement.",
    exported: "Export\xE9 vers TEJ",
    notExported: "Pas encore export\xE9",
    exportedLocked: "Ce paiement ne peut plus \xEAtre annul\xE9\xA0: son certificat a \xE9t\xE9 export\xE9 vers TEJ.",
    cancelPayment: "Annuler",
    cancelPaymentLabel: "Annuler le paiement du {date}",
    cancelPaymentTitle: "Annuler le paiement du {date}\xA0?",
    cancelPaymentBody: "Le paiement et son certificat de retenue seront annul\xE9s. Le montant redevient \xE0 r\xE9gler.",
    cancelPaymentConfirm: "Annuler le paiement",
    cancelPaymentDone: "Le paiement du {date} est annul\xE9."
  },
  withholding: {
    intro: "Les retenues du mois pour la d\xE9claration\xA0: celles que vous op\xE9rez sur vos fournisseurs et celles que vos clients op\xE8rent sur vous.",
    month: "Mois de la d\xE9claration",
    loadFailedTitle: "Retenues indisponibles",
    loadFailedBody: "Le r\xE9capitulatif n\u2019a pas pu \xEAtre charg\xE9. V\xE9rifiez votre connexion puis r\xE9essayez.",
    issued: {
      title: "Retenues op\xE9r\xE9es sur vos fournisseurs",
      intro: "Une ligne par taux, d\u2019apr\xE8s les paiements du mois.",
      none: "Aucune retenue n\u2019a \xE9t\xE9 op\xE9r\xE9e ce mois-ci.",
      tableLabel: "Retenues op\xE9r\xE9es par taux",
      columns: {
        rate: "Taux",
        count: "Certificats",
        base: "Base",
        amount: "Retenue"
      },
      total: "Total",
      exportState: "Export\xE9s vers TEJ\xA0: {exported} \u2014 \xC0 exporter\xA0: {pending}"
    },
    received: {
      title: "Retenues op\xE9r\xE9es par vos clients",
      intro: "Retenues \xE0 la source et retenues sur la TVA d\xE9duites des paiements que vous avez re\xE7us ce mois-ci.",
      payments: "Paiements re\xE7us",
      ras: "Retenue \xE0 la source",
      rasVat: "Retenue \xE0 la source sur la TVA",
      certificates: "Certificats joints"
    },
    exports: {
      title: "Exports TEJ",
      intro: "L\u2019export du mois contient les certificats de retenue qui n\u2019ont pas encore \xE9t\xE9 export\xE9s. Chaque certificat n\u2019est export\xE9 qu\u2019une fois.",
      generate: "G\xE9n\xE9rer l\u2019export TEJ du mois",
      generating: "G\xE9n\xE9ration\u2026",
      nothing: "Rien \xE0 exporter pour {period}\xA0: aucune retenue n\u2019a \xE9t\xE9 op\xE9r\xE9e, ou tous les certificats ont d\xE9j\xE0 \xE9t\xE9 export\xE9s.",
      created: "Export TEJ de {period} g\xE9n\xE9r\xE9\xA0: {count} certificat(s), {total} retenus.",
      tableLabel: "Historique des exports TEJ",
      columns: {
        period: "P\xE9riode",
        format: "Format",
        count: "Certificats",
        total: "Total retenu",
        author: "G\xE9n\xE9r\xE9 par",
        date: "Date",
        file: "Fichier"
      },
      formatToVerify: "Format \xE0 confirmer avec l\u2019expert-comptable",
      download: "T\xE9l\xE9charger",
      downloadLabel: "T\xE9l\xE9charger l\u2019export TEJ de {period}",
      empty: {
        title: "Aucun export pour le moment",
        body: "Les exports g\xE9n\xE9r\xE9s appara\xEEtront ici avec leur fichier."
      },
      loadFailedTitle: "Historique indisponible",
      loadFailedBody: "La liste des exports n\u2019a pas pu \xEAtre charg\xE9e. V\xE9rifiez votre connexion puis r\xE9essayez."
    }
  },
  errors: {
    SUPPLIER_TAX_ID_TAKEN: "Un autre fournisseur de votre bureau porte d\xE9j\xE0 ce matricule fiscal.",
    SUPPLIER_ARCHIVED: "Ce fournisseur est archiv\xE9\xA0: restaurez-le avant d\u2019enregistrer une nouvelle facture.",
    SUPPLIER_INVOICE_NUMBER_TAKEN: "Ce fournisseur a d\xE9j\xE0 une facture avec ce num\xE9ro.",
    SUPPLIER_INVOICE_NOT_PAYABLE: "Cette facture est annul\xE9e ou d\xE9j\xE0 enti\xE8rement pay\xE9e\xA0: aucun paiement ne peut y \xEAtre enregistr\xE9.",
    SUPPLIER_INVOICE_HAS_PAYMENTS: "Cette facture a d\xE9j\xE0 re\xE7u des paiements\xA0: annulez d\u2019abord ses paiements.",
    SUPPLIER_PAYMENT_EXCEEDS: "Ce paiement d\xE9passe le reste \xE0 r\xE9gler. Les montants ont \xE9t\xE9 actualis\xE9s\xA0: v\xE9rifiez-les puis r\xE9essayez.",
    SUPPLIER_PAYMENT_EXPORTED: "Ce paiement ne peut pas \xEAtre annul\xE9\xA0: son certificat de retenue a d\xE9j\xE0 \xE9t\xE9 export\xE9 vers TEJ.",
    SUPPLIER_DOCUMENT_INVALID: "Ce document n\u2019est pas disponible. Choisissez un document de votre bureau auquel vous avez acc\xE8s.",
    TEJ_NOTHING_TO_EXPORT: "Rien \xE0 exporter pour ce mois\xA0: aucune retenue n\u2019a \xE9t\xE9 op\xE9r\xE9e, ou tous les certificats ont d\xE9j\xE0 \xE9t\xE9 export\xE9s.",
    PERIOD_CLOSED: "Cette p\xE9riode comptable est cl\xF4tur\xE9e\xA0: l\u2019op\xE9ration n\u2019est plus possible sur ce mois."
  }
};

// locales/ar/profitability.json
var profitability_default = {
  errors: {
    COST_RATE_DATE_TAKEN: "\u0644\u0647\u0630\u0627 \u0627\u0644\u0634\u062E\u0635 \u062A\u0643\u0644\u0641\u0629 \u0633\u0627\u0639\u0629 \u0645\u062D\u062F\u062F\u0629 \u0645\u0646\u0630 \u0647\u0630\u0627 \u0627\u0644\u062A\u0627\u0631\u064A\u062E. \u0627\u062E\u062A\u0631 \u062A\u0627\u0631\u064A\u062E\u064B\u0627 \u0622\u062E\u0631 \u0623\u0648 \u0627\u062D\u0630\u0641 \u0627\u0644\u062A\u0643\u0644\u0641\u0629 \u0627\u0644\u0642\u062F\u064A\u0645\u0629."
  },
  upgrade: {
    title: "\u0645\u062A\u0627\u0628\u0639\u0629 \u0627\u0644\u0645\u0631\u062F\u0648\u062F\u064A\u0629 \u063A\u064A\u0631 \u0645\u0634\u0645\u0648\u0644\u0629 \u0641\u064A \u0628\u0627\u0642\u062A\u0643\u0645",
    bodyOwner: "\u0627\u0646\u062A\u0642\u0644 \u0625\u0644\u0649 \u0628\u0627\u0642\u0629 \u062A\u0634\u0645\u0644 \u0645\u062A\u0627\u0628\u0639\u0629 \u0627\u0644\u0645\u0631\u062F\u0648\u062F\u064A\u0629 \u0644\u0645\u062A\u0627\u0628\u0639\u0629 \u0647\u0648\u0627\u0645\u0634 \u0645\u0634\u0627\u0631\u064A\u0639\u0643\u0645 \u0648\u062A\u0643\u0627\u0644\u064A\u0641\u0647\u0627 \u0648\u0645\u064A\u0632\u0627\u0646\u064A\u0627\u062A\u0647\u0627 \u0627\u0644\u0632\u0645\u0646\u064A\u0629.",
    bodyMember: "\u0645\u062A\u0627\u0628\u0639\u0629 \u0627\u0644\u0645\u0631\u062F\u0648\u062F\u064A\u0629 \u063A\u064A\u0631 \u0645\u0634\u0645\u0648\u0644\u0629 \u0641\u064A \u0628\u0627\u0642\u0629 \u0645\u0643\u062A\u0628\u0643\u0645. \u0627\u0637\u0644\u0628 \u0645\u0646 \u0645\u0627\u0644\u0643 \u0627\u0644\u062D\u0633\u0627\u0628 \u062A\u0631\u0642\u064A\u062A\u0647\u0627.",
    action: "\u0639\u0631\u0636 \u0627\u0644\u0628\u0627\u0642\u0627\u062A"
  },
  states: {
    positive: "\u0647\u0627\u0645\u0634 \u0625\u064A\u062C\u0627\u0628\u064A",
    negative: "\u0647\u0627\u0645\u0634 \u0633\u0644\u0628\u064A",
    zero: "\u0647\u0627\u0645\u0634 \u0645\u0639\u062F\u0648\u0645"
  },
  duration: {
    hours: "{hours} \u0633"
  },
  modes: {
    invoiced: "\u062A\u064F\u062D\u062A\u0633\u0628 \u0627\u0644\u0625\u064A\u0631\u0627\u062F\u0627\u062A \u0645\u0646 \u0627\u0644\u0641\u0648\u0627\u062A\u064A\u0631 \u0627\u0644\u0635\u0627\u062F\u0631\u0629 (\u062F\u0648\u0646 \u0627\u062D\u062A\u0633\u0627\u0628 \u0627\u0644\u0623\u062F\u0627\u0621\u0627\u062A).",
    completion: "\u062A\u064F\u0639\u062A\u0645\u062F \u0627\u0644\u0625\u064A\u0631\u0627\u062F\u0627\u062A \u062D\u0633\u0628 \u062A\u0642\u062F\u0651\u0645 \u0643\u0644 \u0645\u0631\u062D\u0644\u0629."
  },
  project: {
    noAccessTitle: "\u0627\u0644\u0645\u0631\u062F\u0648\u062F\u064A\u0629 \u063A\u064A\u0631 \u0645\u062A\u0627\u062D\u0629",
    noAccessBody: "\u0644\u064A\u0633 \u0644\u062F\u064A\u0643 \u0635\u0644\u0627\u062D\u064A\u0629 \u0627\u0644\u0627\u0637\u0644\u0627\u0639 \u0639\u0644\u0649 \u0645\u0631\u062F\u0648\u062F\u064A\u0629 \u0647\u0630\u0627 \u0627\u0644\u0645\u0634\u0631\u0648\u0639.",
    loadFailedTitle: "\u062A\u0639\u0630\u0651\u0631 \u0639\u0631\u0636 \u0645\u0631\u062F\u0648\u062F\u064A\u0629 \u0627\u0644\u0645\u0634\u0631\u0648\u0639",
    loadFailedBody: "\u062A\u0639\u0630\u0651\u0631 \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0623\u0631\u0642\u0627\u0645. \u0628\u064A\u0627\u0646\u0627\u062A\u0643 \u063A\u064A\u0631 \u0645\u0641\u0642\u0648\u062F\u0629. \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629\u061B \u0648\u0625\u0646 \u0627\u0633\u062A\u0645\u0631\u062A \u0627\u0644\u0645\u0634\u0643\u0644\u0629 \u0641\u0627\u062A\u0635\u0644 \u0628\u0627\u0644\u062F\u0639\u0645.",
    summary: {
      title: "\u0627\u0644\u062E\u0644\u0627\u0635\u0629",
      label: "\u0627\u0644\u0623\u0631\u0642\u0627\u0645 \u0627\u0644\u0623\u0633\u0627\u0633\u064A\u0629 \u0644\u0645\u0631\u062F\u0648\u062F\u064A\u0629 \u0627\u0644\u0645\u0634\u0631\u0648\u0639",
      revenue: "\u0627\u0644\u0625\u064A\u0631\u0627\u062F\u0627\u062A \u0627\u0644\u0645\u062D\u062A\u0633\u0628\u0629",
      invoicedHt: "\u0627\u0644\u0645\u0641\u0648\u062A\u0631 \u062F\u0648\u0646 \u0627\u062D\u062A\u0633\u0627\u0628 \u0627\u0644\u0623\u062F\u0627\u0621\u0627\u062A",
      collected: "\u0627\u0644\u0645\u062D\u0635\u064E\u0651\u0644 (\u0627\u0644\u062F\u0641\u0648\u0639\u0627\u062A \u0648\u0627\u0644\u062E\u0635\u0648\u0645\u0627\u062A)",
      recognised: "\u0627\u0644\u0645\u0639\u062A\u0645\u062F \u062D\u0633\u0628 \u0627\u0644\u062A\u0642\u062F\u0651\u0645",
      timeCost: "\u062A\u0643\u0644\u0641\u0629 \u0627\u0644\u0648\u0642\u062A",
      expenses: "\u0627\u0644\u0645\u0635\u0627\u0631\u064A\u0641 \u0627\u0644\u0645\u0639\u062A\u0645\u062F\u0629",
      subcontracting: "\u0627\u0644\u0645\u0646\u0627\u0648\u0644\u0629",
      cost: "\u0627\u0644\u062A\u0643\u0644\u0641\u0629 \u0627\u0644\u062C\u0645\u0644\u064A\u0629",
      margin: "\u0627\u0644\u0647\u0627\u0645\u0634",
      marginRate: "\u0646\u0633\u0628\u0629 \u0627\u0644\u0647\u0627\u0645\u0634",
      noMarginRate: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0625\u064A\u0631\u0627\u062F\u0627\u062A",
      time: "\u0627\u0644\u0648\u0642\u062A \u0627\u0644\u0645\u0646\u062C\u0632",
      timePending: "\u0645\u0646\u0647\u0627 {hours} \u0641\u064A \u0627\u0646\u062A\u0638\u0627\u0631 \u0627\u0644\u0645\u0648\u0627\u0641\u0642\u0629",
      unrated: "{hours} \u0645\u0646 \u0627\u0644\u0648\u0642\u062A \u063A\u064A\u0631 \u0645\u062D\u062A\u0633\u0628\u0629 \u0627\u0644\u062A\u0643\u0644\u0641\u0629: \u0644\u0645 \u062A\u064F\u062D\u062F\u064E\u0651\u062F \u062A\u0643\u0644\u0641\u0629 \u0633\u0627\u0639\u0629 \u0644\u0644\u0623\u0634\u062E\u0627\u0635 \u0627\u0644\u0645\u0639\u0646\u064A\u064A\u0646 \u0641\u064A \u0647\u0630\u0647 \u0627\u0644\u062A\u0648\u0627\u0631\u064A\u062E."
    },
    chart: {
      title: "\u0627\u0644\u0625\u064A\u0631\u0627\u062F\u0627\u062A \u0648\u062A\u0643\u0644\u0641\u0629 \u0627\u0644\u0648\u0642\u062A \u062D\u0633\u0628 \u0627\u0644\u0645\u0631\u062D\u0644\u0629",
      intro: "\u064A\u0642\u0627\u0631\u0646 \u0627\u0644\u0631\u0633\u0645\u060C \u0645\u0631\u062D\u0644\u0629\u064B \u0628\u0645\u0631\u062D\u0644\u0629\u060C \u0628\u064A\u0646 \u0627\u0644\u0625\u064A\u0631\u0627\u062F\u0627\u062A \u0627\u0644\u0645\u062D\u062A\u0633\u0628\u0629 \u0648\u062A\u0643\u0644\u0641\u0629 \u0627\u0644\u0648\u0642\u062A \u0627\u0644\u0645\u0646\u062C\u0632. \u0627\u0644\u0645\u0635\u0627\u0631\u064A\u0641 \u0648\u0627\u0644\u0645\u0646\u0627\u0648\u0644\u0629 \u062A\u064F\u062D\u062A\u0633\u0628 \u0639\u0644\u0649 \u0645\u0633\u062A\u0648\u0649 \u0627\u0644\u0645\u0634\u0631\u0648\u0639.",
      label: "\u0631\u0633\u0645 \u0628\u064A\u0627\u0646\u064A \u0628\u0627\u0644\u0623\u0639\u0645\u062F\u0629 \u0644\u0644\u0625\u064A\u0631\u0627\u062F\u0627\u062A \u0648\u062A\u0643\u0644\u0641\u0629 \u0627\u0644\u0648\u0642\u062A \u062D\u0633\u0628 \u0627\u0644\u0645\u0631\u062D\u0644\u0629\u060C \u0628\u0627\u0644\u062F\u064A\u0646\u0627\u0631. \u0627\u0644\u0623\u0631\u0642\u0627\u0645 \u0646\u0641\u0633\u0647\u0627 \u0641\u064A \u0627\u0644\u062C\u062F\u0648\u0644 \u0627\u0644\u0645\u0648\u0627\u0644\u064A.",
      revenue: "\u0627\u0644\u0625\u064A\u0631\u0627\u062F\u0627\u062A",
      timeCost: "\u062A\u0643\u0644\u0641\u0629 \u0627\u0644\u0648\u0642\u062A",
      unassigned: "\u062E\u0627\u0631\u062C \u0627\u0644\u0645\u0631\u0627\u062D\u0644"
    },
    table: {
      caption: "\u0627\u0644\u0625\u064A\u0631\u0627\u062F\u0627\u062A \u0648\u062A\u0643\u0644\u0641\u0629 \u0627\u0644\u0648\u0642\u062A \u062D\u0633\u0628 \u0627\u0644\u0645\u0631\u062D\u0644\u0629\u060C \u0628\u0627\u0644\u062F\u064A\u0646\u0627\u0631 \u0627\u0644\u062A\u0648\u0646\u0633\u064A",
      phase: "\u0627\u0644\u0645\u0631\u062D\u0644\u0629",
      revenue: "\u0627\u0644\u0625\u064A\u0631\u0627\u062F\u0627\u062A",
      timeCost: "\u062A\u0643\u0644\u0641\u0629 \u0627\u0644\u0648\u0642\u062A",
      completion: "\u0627\u0644\u062A\u0642\u062F\u0651\u0645",
      total: "\u0627\u0644\u0645\u062C\u0645\u0648\u0639",
      unassigned: "\u062E\u0627\u0631\u062C \u0627\u0644\u0645\u0631\u0627\u062D\u0644 (\u0641\u0648\u0627\u062A\u064A\u0631 \u0628\u0644\u0627 \u0645\u0631\u062D\u0644\u0629\u060C \u0648\u0642\u062A \u0628\u0644\u0627 \u0645\u0631\u062D\u0644\u0629)",
      none: "\u2014"
    },
    budget: {
      title: "\u0627\u0644\u0645\u064A\u0632\u0627\u0646\u064A\u0629 \u0627\u0644\u0632\u0645\u0646\u064A\u0629 \u062D\u0633\u0628 \u0627\u0644\u0645\u0631\u062D\u0644\u0629",
      intro: "\u062A\u064F\u062D\u062F\u064E\u0651\u062F \u0627\u0644\u0645\u064A\u0632\u0627\u0646\u064A\u0629 \u0627\u0644\u0632\u0645\u0646\u064A\u0629 \u0641\u064A \u0644\u0648\u062D\u0629 \u0643\u0644 \u0645\u0631\u062D\u0644\u0629. \u064A\u0638\u0647\u0631 \u062A\u0646\u0628\u064A\u0647 \u0639\u0646\u062F \u0627\u0633\u062A\u0647\u0644\u0627\u0643 80% \u0645\u0646 \u0627\u0644\u0645\u064A\u0632\u0627\u0646\u064A\u0629.",
      caption: "\u0627\u0644\u0648\u0642\u062A \u0627\u0644\u0645\u0646\u062C\u0632 \u0648\u0627\u0644\u0645\u064A\u0632\u0627\u0646\u064A\u0629 \u0627\u0644\u0632\u0645\u0646\u064A\u0629 \u062D\u0633\u0628 \u0627\u0644\u0645\u0631\u062D\u0644\u0629",
      phase: "\u0627\u0644\u0645\u0631\u062D\u0644\u0629",
      spent: "\u0627\u0644\u0648\u0642\u062A \u0627\u0644\u0645\u0646\u062C\u0632",
      budget: "\u0627\u0644\u0645\u064A\u0632\u0627\u0646\u064A\u0629",
      consumption: "\u0627\u0644\u0645\u0633\u062A\u0647\u0644\u0643",
      noBudget: "\u0628\u0644\u0627 \u0645\u064A\u0632\u0627\u0646\u064A\u0629",
      pending: "\u0645\u0646\u0647\u0627 {hours} \u0644\u0644\u0645\u0648\u0627\u0641\u0642\u0629",
      progress: "\u0627\u0644\u0645\u064A\u0632\u0627\u0646\u064A\u0629 \u0627\u0644\u0632\u0645\u0646\u064A\u0629 \u0627\u0644\u0645\u0633\u062A\u0647\u0644\u0643\u0629 \u0644\u0644\u0645\u0631\u062D\u0644\u0629 {phase}",
      ok: "\u0636\u0645\u0646 \u0627\u0644\u0645\u064A\u0632\u0627\u0646\u064A\u0629",
      alert: "\u062A\u0646\u0628\u064A\u0647: \u0628\u0644\u063A \u0627\u0633\u062A\u0647\u0644\u0627\u0643 \u0627\u0644\u0645\u064A\u0632\u0627\u0646\u064A\u0629 80%",
      exceeded: "\u062A\u062C\u0627\u0648\u0632 \u0627\u0644\u0645\u064A\u0632\u0627\u0646\u064A\u0629",
      totalLabel: "\u0648\u0642\u062A \u0627\u0644\u0645\u0634\u0631\u0648\u0639"
    }
  },
  overview: {
    intro: "\u0647\u0627\u0645\u0634 \u0643\u0644 \u0645\u0634\u0631\u0648\u0639: \u0627\u0644\u0625\u064A\u0631\u0627\u062F\u0627\u062A \u0627\u0644\u0645\u062D\u062A\u0633\u0628\u0629 \u0645\u0637\u0631\u0648\u062D\u064B\u0627 \u0645\u0646\u0647\u0627 \u0627\u0644\u062A\u0643\u0627\u0644\u064A\u0641 (\u0627\u0644\u0648\u0642\u062A \u0648\u0627\u0644\u0645\u0635\u0627\u0631\u064A\u0641 \u0627\u0644\u0645\u0639\u062A\u0645\u062F\u0629 \u0648\u0627\u0644\u0645\u0646\u0627\u0648\u0644\u0629).",
    scopeLabel: "\u0627\u0644\u0645\u0634\u0627\u0631\u064A\u0639 \u0627\u0644\u0645\u0639\u0631\u0648\u0636\u0629",
    scope: {
      active: "\u0627\u0644\u0645\u0634\u0627\u0631\u064A\u0639 \u0627\u0644\u062C\u0627\u0631\u064A\u0629",
      all: "\u0643\u0644 \u0627\u0644\u0645\u0634\u0627\u0631\u064A\u0639"
    },
    loadFailedTitle: "\u062A\u0639\u0630\u0651\u0631 \u0639\u0631\u0636 \u0627\u0644\u0645\u0631\u062F\u0648\u062F\u064A\u0629",
    loadFailedBody: "\u062A\u0639\u0630\u0651\u0631 \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0623\u0631\u0642\u0627\u0645. \u0628\u064A\u0627\u0646\u0627\u062A\u0643 \u063A\u064A\u0631 \u0645\u0641\u0642\u0648\u062F\u0629. \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629\u061B \u0648\u0625\u0646 \u0627\u0633\u062A\u0645\u0631\u062A \u0627\u0644\u0645\u0634\u0643\u0644\u0629 \u0641\u0627\u062A\u0635\u0644 \u0628\u0627\u0644\u062F\u0639\u0645.",
    totals: {
      label: "\u0645\u062C\u0627\u0645\u064A\u0639 \u0627\u0644\u0645\u0624\u0633\u0633\u0629",
      revenue: "\u0627\u0644\u0625\u064A\u0631\u0627\u062F\u0627\u062A \u0627\u0644\u0645\u062D\u062A\u0633\u0628\u0629",
      cost: "\u0627\u0644\u062A\u0643\u0627\u0644\u064A\u0641",
      margin: "\u0627\u0644\u0647\u0627\u0645\u0634",
      marginRate: "\u0646\u0633\u0628\u0629 \u0627\u0644\u0647\u0627\u0645\u0634"
    },
    chart: {
      title: "\u0627\u0644\u0625\u064A\u0631\u0627\u062F\u0627\u062A \u0648\u0627\u0644\u062A\u0643\u0627\u0644\u064A\u0641 \u062D\u0633\u0628 \u0627\u0644\u0645\u0634\u0631\u0648\u0639",
      label: "\u0631\u0633\u0645 \u0628\u064A\u0627\u0646\u064A \u0628\u0627\u0644\u0623\u0639\u0645\u062F\u0629 \u0644\u0644\u0625\u064A\u0631\u0627\u062F\u0627\u062A \u0648\u0627\u0644\u062A\u0643\u0627\u0644\u064A\u0641 \u062D\u0633\u0628 \u0627\u0644\u0645\u0634\u0631\u0648\u0639\u060C \u0628\u0627\u0644\u062F\u064A\u0646\u0627\u0631. \u0627\u0644\u0623\u0631\u0642\u0627\u0645 \u0646\u0641\u0633\u0647\u0627 \u0641\u064A \u0627\u0644\u062C\u062F\u0648\u0644 \u0627\u0644\u0645\u0648\u0627\u0644\u064A.",
      limited: "\u064A\u0639\u0631\u0636 \u0627\u0644\u0631\u0633\u0645 {count} \u0645\u0634\u0627\u0631\u064A\u0639 \u0627\u0644\u0623\u0639\u0644\u0649 \u0625\u064A\u0631\u0627\u062F\u064B\u0627\u061B \u0648\u0643\u0644 \u0627\u0644\u0645\u0634\u0627\u0631\u064A\u0639 \u0645\u0648\u062C\u0648\u062F\u0629 \u0641\u064A \u0627\u0644\u062C\u062F\u0648\u0644.",
      revenue: "\u0627\u0644\u0625\u064A\u0631\u0627\u062F\u0627\u062A",
      cost: "\u0627\u0644\u062A\u0643\u0627\u0644\u064A\u0641"
    },
    table: {
      caption: "\u0627\u0644\u0645\u0631\u062F\u0648\u062F\u064A\u0629 \u062D\u0633\u0628 \u0627\u0644\u0645\u0634\u0631\u0648\u0639\u060C \u0628\u0627\u0644\u062F\u064A\u0646\u0627\u0631 \u0627\u0644\u062A\u0648\u0646\u0633\u064A",
      project: "\u0627\u0644\u0645\u0634\u0631\u0648\u0639",
      status: "\u0627\u0644\u062D\u0627\u0644\u0629",
      revenue: "\u0627\u0644\u0625\u064A\u0631\u0627\u062F\u0627\u062A",
      cost: "\u0627\u0644\u062A\u0643\u0627\u0644\u064A\u0641",
      margin: "\u0627\u0644\u0647\u0627\u0645\u0634",
      marginRate: "\u0646\u0633\u0628\u0629 \u0627\u0644\u0647\u0627\u0645\u0634",
      budget: "\u0627\u0644\u0645\u064A\u0632\u0627\u0646\u064A\u0629 \u0627\u0644\u0632\u0645\u0646\u064A\u0629",
      noBudget: "\u0628\u0644\u0627 \u0645\u064A\u0632\u0627\u0646\u064A\u0629",
      alert: "\u062A\u0646\u0628\u064A\u0647 \u0639\u0646\u062F 80%",
      withinBudget: "\u0636\u0645\u0646 \u0627\u0644\u0645\u064A\u0632\u0627\u0646\u064A\u0629",
      total: "\u0627\u0644\u0645\u062C\u0645\u0648\u0639"
    },
    empty: {
      title: "\u0644\u0627 \u064A\u0648\u062C\u062F \u0645\u0634\u0631\u0648\u0639 \u0644\u0644\u0639\u0631\u0636",
      body: "\u0628\u0645\u062C\u0631\u062F \u0623\u0646 \u064A\u0643\u0648\u0646 \u0644\u0645\u0634\u0631\u0648\u0639 \u0641\u0648\u0627\u062A\u064A\u0631 \u0623\u0648 \u0648\u0642\u062A \u0645\u0633\u062C\u064E\u0651\u0644\u060C \u064A\u0638\u0647\u0631 \u0647\u0627\u0645\u0634\u0647 \u0647\u0646\u0627."
    }
  },
  rates: {
    intro: "\u062A\u0643\u0644\u0641\u0629 \u0627\u0644\u0633\u0627\u0639\u0629 \u0647\u064A \u0627\u0644\u0643\u0644\u0641\u0629 \u0627\u0644\u0633\u0627\u0639\u064A\u0629 \u0627\u0644\u062C\u0645\u0644\u064A\u0629 \u0644\u0634\u062E\u0635 (\u0627\u0644\u0623\u062C\u0631 \u0648\u0627\u0644\u0623\u0639\u0628\u0627\u0621 \u0648\u0627\u0644\u0645\u0635\u0627\u0631\u064A\u0641 \u0627\u0644\u0639\u0627\u0645\u0629) \u0627\u0628\u062A\u062F\u0627\u0621\u064B \u0645\u0646 \u062A\u0627\u0631\u064A\u062E \u0645\u0639\u064A\u0651\u0646. \u062A\u064F\u0633\u062A\u0639\u0645\u0644 \u0644\u062A\u0642\u064A\u064A\u0645 \u0627\u0644\u0648\u0642\u062A \u0627\u0644\u0645\u0646\u062C\u0632 \u0641\u064A \u0627\u0644\u0645\u0634\u0627\u0631\u064A\u0639.",
    sensitive: "\u0647\u0630\u0647 \u0627\u0644\u062A\u0643\u0627\u0644\u064A\u0641 \u062A\u0643\u0634\u0641 \u0627\u0644\u0623\u062C\u0648\u0631: \u0644\u0627 \u062A\u0638\u0647\u0631 \u0625\u0644\u0627 \u0641\u064A \u0647\u0630\u0647 \u0627\u0644\u0635\u0641\u062D\u0629 \u0648\u0644\u0627 \u064A\u0637\u0651\u0644\u0639 \u0639\u0644\u064A\u0647\u0627 \u0631\u0624\u0633\u0627\u0621 \u0627\u0644\u0645\u0634\u0627\u0631\u064A\u0639 \u0623\u0628\u062F\u064B\u0627.",
    add: "\u0625\u0636\u0627\u0641\u0629 \u062A\u0643\u0644\u0641\u0629",
    tableLabel: "\u062A\u0643\u0644\u0641\u0629 \u0627\u0644\u0633\u0627\u0639\u0629 \u0644\u0643\u0644 \u0634\u062E\u0635",
    columns: {
      person: "\u0627\u0644\u0634\u062E\u0635",
      from: "\u0627\u0628\u062A\u062F\u0627\u0621\u064B \u0645\u0646",
      rate: "\u062A\u0643\u0644\u0641\u0629 \u0627\u0644\u0633\u0627\u0639\u0629",
      state: "\u0627\u0644\u0648\u0636\u0639\u064A\u0629",
      actions: "\u0627\u0644\u0625\u062C\u0631\u0627\u0621\u0627\u062A"
    },
    perHour: "{amount} / \u0633",
    current: "\u0633\u0627\u0631\u064A\u0629",
    past: "\u0645\u064F\u0633\u062A\u0628\u062F\u0644\u0629",
    future: "\u0642\u0627\u062F\u0645\u0629",
    delete: "\u062D\u0630\u0641",
    deleteLabel: "\u062D\u0630\u0641 \u062A\u0643\u0644\u0641\u0629 \u0633\u0627\u0639\u0629 {name} \u0627\u0628\u062A\u062F\u0627\u0621\u064B \u0645\u0646 {date}",
    deleteTitle: "\u062D\u0630\u0641 \u062A\u0643\u0644\u0641\u0629 \u0633\u0627\u0639\u0629 {name} \u0627\u0628\u062A\u062F\u0627\u0621\u064B \u0645\u0646 {date}\u061F",
    deleteBody: "\u0633\u064A\u064F\u0642\u064A\u064E\u0651\u0645 \u0627\u0644\u0648\u0642\u062A \u0627\u0644\u0645\u0633\u062C\u064E\u0651\u0644 \u0645\u0646\u0630 \u0647\u0630\u0627 \u0627\u0644\u062A\u0627\u0631\u064A\u062E \u0628\u0627\u0644\u062A\u0643\u0644\u0641\u0629 \u0627\u0644\u0633\u0627\u0628\u0642\u0629\u060C \u0623\u0648 \u0644\u0646 \u064A\u064F\u0642\u064A\u064E\u0651\u0645 \u0625\u0646 \u0644\u0645 \u062A\u0648\u062C\u062F. \u064A\u064F\u0633\u062C\u064E\u0651\u0644 \u0627\u0644\u062D\u0630\u0641 \u0641\u064A \u0633\u062C\u0644 \u0627\u0644\u062A\u062F\u0642\u064A\u0642.",
    deleteConfirm: "\u062D\u0630\u0641 \u0627\u0644\u062A\u0643\u0644\u0641\u0629",
    deleted: "\u062A\u0645 \u062D\u0630\u0641 \u0627\u0644\u062A\u0643\u0644\u0641\u0629.",
    created: "\u062A\u0645 \u062A\u0633\u062C\u064A\u0644 \u062A\u0643\u0644\u0641\u0629 \u0633\u0627\u0639\u0629 {name}.",
    stepUp: "\u0623\u0643\u0651\u062F \u0647\u0648\u064A\u062A\u0643 \u0644\u062A\u0639\u062F\u064A\u0644 \u062A\u0643\u0627\u0644\u064A\u0641 \u0627\u0644\u0633\u0627\u0639\u0629.",
    loadFailedTitle: "\u062A\u0639\u0630\u0651\u0631 \u0639\u0631\u0636 \u062A\u0643\u0627\u0644\u064A\u0641 \u0627\u0644\u0633\u0627\u0639\u0629",
    loadFailedBody: "\u062A\u0639\u0630\u0651\u0631 \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u062A\u0643\u0627\u0644\u064A\u0641. \u0628\u064A\u0627\u0646\u0627\u062A\u0643 \u063A\u064A\u0631 \u0645\u0641\u0642\u0648\u062F\u0629. \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629\u061B \u0648\u0625\u0646 \u0627\u0633\u062A\u0645\u0631\u062A \u0627\u0644\u0645\u0634\u0643\u0644\u0629 \u0641\u0627\u062A\u0635\u0644 \u0628\u0627\u0644\u062F\u0639\u0645.",
    empty: {
      title: "\u0644\u0627 \u062A\u0648\u062C\u062F \u062A\u0643\u0644\u0641\u0629 \u0633\u0627\u0639\u0629 \u0645\u062D\u062F\u062F\u0629",
      body: "\u0623\u0636\u0641 \u062A\u0643\u0644\u0641\u0629 \u0644\u0643\u0644 \u0634\u062E\u0635 \u064A\u062C\u0628 \u062A\u0642\u064A\u064A\u0645 \u0648\u0642\u062A\u0647 \u0641\u064A \u0627\u0644\u0645\u0631\u062F\u0648\u062F\u064A\u0629."
    },
    withoutRate: {
      title: "\u0628\u062F\u0648\u0646 \u062A\u0643\u0644\u0641\u0629 \u0633\u0627\u0639\u0629",
      body: "\u0648\u0642\u062A \u0647\u0624\u0644\u0627\u0621 \u0627\u0644\u0623\u0634\u062E\u0627\u0635 \u063A\u064A\u0631 \u0645\u064F\u0642\u064A\u064E\u0651\u0645 \u0641\u064A \u0627\u0644\u0645\u0631\u062F\u0648\u062F\u064A\u0629: {names}."
    },
    dialog: {
      title: "\u0625\u0636\u0627\u0641\u0629 \u062A\u0643\u0644\u0641\u0629 \u0633\u0627\u0639\u0629",
      person: "\u0627\u0644\u0634\u062E\u0635",
      personPlaceholder: "\u0627\u062E\u062A\u0631 \u0634\u062E\u0635\u064B\u0627",
      from: "\u0627\u0628\u062A\u062F\u0627\u0621\u064B \u0645\u0646",
      rate: "\u0627\u0644\u0643\u0644\u0641\u0629 \u0627\u0644\u0633\u0627\u0639\u064A\u0629 \u0627\u0644\u062C\u0645\u0644\u064A\u0629",
      rateHint: "\u0628\u0627\u0644\u062F\u064A\u0646\u0627\u0631 \u0641\u064A \u0627\u0644\u0633\u0627\u0639\u0629\u060C \u0628\u062B\u0644\u0627\u062B \u062E\u0627\u0646\u0627\u062A \u0639\u0634\u0631\u064A\u0629 \u0639\u0644\u0649 \u0627\u0644\u0623\u0643\u062B\u0631. \u062A\u0646\u0637\u0628\u0642 \u0639\u0644\u0649 \u0627\u0644\u0648\u0642\u062A \u0627\u0644\u0645\u0646\u062C\u0632 \u0627\u0628\u062A\u062F\u0627\u0621\u064B \u0645\u0646 \u0647\u0630\u0627 \u0627\u0644\u062A\u0627\u0631\u064A\u062E.",
      save: "\u062D\u0641\u0638 \u0627\u0644\u062A\u0643\u0644\u0641\u0629",
      saving: "\u062C\u0627\u0631\u064D \u0627\u0644\u062D\u0641\u0638\u2026",
      noPeople: "\u0644\u0627 \u064A\u0648\u062C\u062F \u0634\u062E\u0635 \u0646\u0634\u0637 \u0645\u062A\u0627\u062D.",
      errors: {
        person: "\u0627\u062E\u062A\u0631 \u0634\u062E\u0635\u064B\u0627.",
        from: "\u0623\u062F\u062E\u0644 \u0627\u0644\u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0630\u064A \u062A\u0646\u0637\u0628\u0642 \u0645\u0646\u0647 \u0627\u0644\u062A\u0643\u0644\u0641\u0629.",
        rate: "\u0623\u062F\u062E\u0644 \u062A\u0643\u0644\u0641\u0629 \u0633\u0627\u0639\u0629 \u0623\u0643\u0628\u0631 \u0645\u0646 \u0627\u0644\u0635\u0641\u0631."
      }
    }
  },
  recognition: {
    title: "\u0627\u0639\u062A\u0645\u0627\u062F \u0627\u0644\u0625\u064A\u0631\u0627\u062F\u0627\u062A",
    hint: "\u0627\u062E\u062A\u0631 \u0627\u0644\u0637\u0631\u064A\u0642\u0629 \u0627\u0644\u062A\u064A \u062A\u062D\u062A\u0633\u0628 \u0628\u0647\u0627 \u0645\u0631\u062F\u0648\u062F\u064A\u0629 \u0645\u0634\u0627\u0631\u064A\u0639\u0643\u0645 \u0627\u0644\u0625\u064A\u0631\u0627\u062F\u0627\u062A.",
    optionsLabel: "\u0637\u0631\u064A\u0642\u0629 \u0627\u0639\u062A\u0645\u0627\u062F \u0627\u0644\u0625\u064A\u0631\u0627\u062F\u0627\u062A",
    invoiced: "\u0639\u0646\u062F \u0627\u0644\u062A\u0641\u0648\u064A\u062A\u0631",
    invoicedHint: "\u0627\u0644\u0625\u064A\u0631\u0627\u062F\u0627\u062A \u0647\u064A \u0645\u0628\u0644\u063A \u0627\u0644\u0641\u0648\u0627\u062A\u064A\u0631 \u0627\u0644\u0635\u0627\u062F\u0631\u0629 \u062F\u0648\u0646 \u0627\u062D\u062A\u0633\u0627\u0628 \u0627\u0644\u0623\u062F\u0627\u0621\u0627\u062A. \u0647\u0630\u0627 \u0647\u0648 \u0627\u0644\u062E\u064A\u0627\u0631 \u0627\u0644\u0627\u0641\u062A\u0631\u0627\u0636\u064A \u0648\u0627\u0644\u0623\u0633\u0647\u0644 \u0645\u0637\u0627\u0628\u0642\u0629\u064B \u0645\u0639 \u0627\u0644\u0645\u062D\u0627\u0633\u0628\u0629.",
    completion: "\u062D\u0633\u0628 \u0627\u0644\u062A\u0642\u062F\u0651\u0645",
    completionHint: "\u062A\u062A\u0628\u0639 \u0625\u064A\u0631\u0627\u062F\u0627\u062A \u0643\u0644 \u0645\u0631\u062D\u0644\u0629 \u062A\u0642\u062F\u0651\u0645\u0647\u0627: \u0623\u062A\u0639\u0627\u0628 \u0627\u0644\u0645\u0631\u062D\u0644\u0629 \u0645\u0636\u0631\u0648\u0628\u0629 \u0641\u064A \u0646\u0633\u0628\u0629 \u062A\u0642\u062F\u0651\u0645\u0647\u0627. \u0644\u0627 \u064A\u0639\u0648\u062F \u0627\u0644\u0647\u0627\u0645\u0634 \u0645\u0631\u062A\u0628\u0637\u064B\u0627 \u0628\u0648\u062A\u064A\u0631\u0629 \u0627\u0644\u062A\u0641\u0648\u064A\u062A\u0631.",
    save: "\u062D\u0641\u0638",
    saving: "\u062C\u0627\u0631\u064D \u0627\u0644\u062D\u0641\u0638\u2026",
    saved: "\u062A\u0645 \u062D\u0641\u0638 \u0637\u0631\u064A\u0642\u0629 \u0627\u0644\u0627\u0639\u062A\u0645\u0627\u062F.",
    readOnly: "\u0644\u0627 \u064A\u0645\u0643\u0646 \u062A\u063A\u064A\u064A\u0631 \u0647\u0630\u0627 \u0627\u0644\u0627\u062E\u062A\u064A\u0627\u0631 \u0625\u0644\u0627 \u0644\u0644\u0645\u0633\u0624\u0648\u0644\u064A\u0646 \u0627\u0644\u0645\u062E\u0648\u0651\u0644\u064A\u0646 \u0628\u062A\u0639\u062F\u064A\u0644 \u0627\u0644\u0625\u0639\u062F\u0627\u062F\u0627\u062A \u0627\u0644\u062C\u0628\u0627\u0626\u064A\u0629.",
    stale: "\u0639\u062F\u0651\u0644 \u0634\u062E\u0635 \u0622\u062E\u0631 \u0647\u0630\u0647 \u0627\u0644\u0625\u0639\u062F\u0627\u062F\u0627\u062A. \u0623\u0639\u062F \u062A\u062D\u0645\u064A\u0644\u0647\u0627 \u062B\u0645 \u062D\u0627\u0648\u0644 \u0645\u0646 \u062C\u062F\u064A\u062F.",
    reload: "\u0625\u0639\u0627\u062F\u0629 \u0627\u0644\u062A\u062D\u0645\u064A\u0644",
    loading: "\u062C\u0627\u0631\u064D \u0627\u0644\u062A\u062D\u0645\u064A\u0644\u2026",
    loadFailed: "\u062A\u0639\u0630\u0651\u0631 \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0625\u0639\u062F\u0627\u062F\u0627\u062A."
  }
};

// locales/en/profitability.json
var profitability_default2 = {
  errors: {
    COST_RATE_DATE_TAKEN: "This person already has a cost rate from that date. Pick another date or delete the old rate."
  },
  upgrade: {
    title: "Profitability tracking is not included in your plan",
    bodyOwner: "Move to a plan that includes profitability tracking to follow the margins, costs and time budgets of your projects.",
    bodyMember: "Profitability tracking is not included in your office\u2019s plan. Ask the account owner to upgrade it.",
    action: "See plans"
  },
  states: {
    positive: "Positive margin",
    negative: "Negative margin",
    zero: "Zero margin"
  },
  duration: {
    hours: "{hours} h"
  },
  modes: {
    invoiced: "Revenue counts the invoices issued (excluding tax).",
    completion: "Revenue is recognised as each phase progresses."
  },
  project: {
    noAccessTitle: "Profitability not available",
    noAccessBody: "You do not have access to this project\u2019s profitability figures.",
    loadFailedTitle: "Cannot show the project\u2019s profitability",
    loadFailedBody: "The figures could not be loaded. Your data is not lost. Try again; if the problem continues, contact support.",
    summary: {
      title: "Summary",
      label: "Key figures of the project\u2019s profitability",
      revenue: "Revenue counted",
      invoicedHt: "Invoiced excl. tax",
      collected: "Collected (payments and withholdings)",
      recognised: "Recognised at completion",
      timeCost: "Cost of time",
      expenses: "Approved expenses",
      subcontracting: "Subcontracting",
      cost: "Total cost",
      margin: "Margin",
      marginRate: "Margin rate",
      noMarginRate: "No revenue",
      time: "Time spent",
      timePending: "of which {hours} waiting for approval",
      unrated: "{hours} of time is not costed: no cost rate is set for the people concerned on those dates."
    },
    chart: {
      title: "Revenue and cost of time per phase",
      intro: "The chart compares, phase by phase, the revenue counted and the cost of the time spent. Expenses and subcontracting are counted at project level.",
      label: "Bar chart of revenue and cost of time per phase, in dinars. The same figures are in the table below.",
      revenue: "Revenue",
      timeCost: "Cost of time",
      unassigned: "No phase"
    },
    table: {
      caption: "Revenue and cost of time per phase, in TND",
      phase: "Phase",
      revenue: "Revenue",
      timeCost: "Cost of time",
      completion: "Completion",
      total: "Total",
      unassigned: "No phase (invoices without a phase, time without a phase)",
      none: "\u2014"
    },
    budget: {
      title: "Time budget per phase",
      intro: "The time budget is set in each phase\u2019s panel. An alert appears as soon as 80% of the budget is used.",
      caption: "Time spent and time budget per phase",
      phase: "Phase",
      spent: "Time spent",
      budget: "Budget",
      consumption: "Used",
      noBudget: "No budget",
      pending: "of which {hours} to approve",
      progress: "Time budget used for phase {phase}",
      ok: "Within budget",
      alert: "Alert: 80% of the budget reached",
      exceeded: "Budget exceeded",
      totalLabel: "Project time"
    }
  },
  overview: {
    intro: "The margin of each project: the revenue counted minus the costs (time, approved expenses and subcontracting).",
    scopeLabel: "Projects to show",
    scope: {
      active: "Ongoing projects",
      all: "All projects"
    },
    loadFailedTitle: "Cannot show profitability",
    loadFailedBody: "The figures could not be loaded. Your data is not lost. Try again; if the problem continues, contact support.",
    totals: {
      label: "Organisation totals",
      revenue: "Revenue counted",
      cost: "Costs",
      margin: "Margin",
      marginRate: "Margin rate"
    },
    chart: {
      title: "Revenue and costs per project",
      label: "Bar chart of revenue and costs per project, in dinars. The same figures are in the table below.",
      limited: "The chart shows the {count} projects with the highest revenue; every project is in the table.",
      revenue: "Revenue",
      cost: "Costs"
    },
    table: {
      caption: "Profitability per project, in TND",
      project: "Project",
      status: "Status",
      revenue: "Revenue",
      cost: "Costs",
      margin: "Margin",
      marginRate: "Margin rate",
      budget: "Time budget",
      noBudget: "No budget",
      alert: "Alert at 80%",
      withinBudget: "Within budget",
      total: "Total"
    },
    empty: {
      title: "No project to show",
      body: "As soon as a project has invoices or logged time, its margin appears here."
    }
  },
  rates: {
    intro: "The cost rate is a person\u2019s loaded hourly cost (salary, charges and overheads) from a date. It is used to value the time spent on projects.",
    sensitive: "These rates reveal salaries: they are shown on this page only and never to project managers.",
    add: "Add a rate",
    tableLabel: "Cost rates per person",
    columns: {
      person: "Person",
      from: "From",
      rate: "Hourly cost",
      state: "Situation",
      actions: "Actions"
    },
    perHour: "{amount} / h",
    current: "In force",
    past: "Replaced",
    future: "Upcoming",
    delete: "Delete",
    deleteLabel: "Delete {name}\u2019s rate from {date}",
    deleteTitle: "Delete {name}\u2019s rate from {date}?",
    deleteBody: "Time logged from this date will be valued with the previous rate, or no longer valued if there is none. The deletion is recorded in the audit log.",
    deleteConfirm: "Delete the rate",
    deleted: "The rate has been deleted.",
    created: "{name}\u2019s rate is saved.",
    stepUp: "Confirm your identity to change cost rates.",
    loadFailedTitle: "Cannot show the cost rates",
    loadFailedBody: "The rates could not be loaded. Your data is not lost. Try again; if the problem continues, contact support.",
    empty: {
      title: "No cost rates",
      body: "Add a rate for each person whose time should be valued in profitability."
    },
    withoutRate: {
      title: "Without a cost rate",
      body: "These people\u2019s time is not valued in profitability: {names}."
    },
    dialog: {
      title: "Add a cost rate",
      person: "Person",
      personPlaceholder: "Choose a person",
      from: "From",
      rate: "Loaded hourly cost",
      rateHint: "In dinars per hour, with up to three decimals. It applies to time worked from this date.",
      save: "Save the rate",
      saving: "Saving\u2026",
      noPeople: "No active person is available.",
      errors: {
        person: "Choose a person.",
        from: "Enter the date from which the rate applies.",
        rate: "Enter an hourly cost above zero."
      }
    }
  },
  recognition: {
    title: "Revenue recognition",
    hint: "Choose how your projects\u2019 profitability counts revenue.",
    optionsLabel: "How revenue is recognised",
    invoiced: "When invoiced",
    invoicedHint: "Revenue is the amount excluding tax of the invoices issued. This is the default and the easiest to match with the accounts.",
    completion: "At completion",
    completionHint: "Each phase\u2019s revenue follows its progress: the phase fees multiplied by its completion rate. The margin no longer depends on the invoicing pace.",
    save: "Save",
    saving: "Saving\u2026",
    saved: "The recognition mode is saved.",
    readOnly: "Only administrators allowed to change the tax settings can change this choice.",
    stale: "These settings were changed by someone else. Reload them and try again.",
    reload: "Reload",
    loading: "Loading\u2026",
    loadFailed: "The settings could not be loaded."
  }
};

// locales/fr/profitability.json
var profitability_default3 = {
  errors: {
    COST_RATE_DATE_TAKEN: "Cette personne a d\xE9j\xE0 un taux de co\xFBt \xE0 cette date. Choisissez une autre date ou supprimez l\u2019ancien taux."
  },
  upgrade: {
    title: "Le suivi de rentabilit\xE9 n\u2019est pas inclus dans votre offre",
    bodyOwner: "Passez \xE0 une offre qui inclut le suivi de rentabilit\xE9 pour suivre les marges, les co\xFBts et les budgets de temps de vos projets.",
    bodyMember: "Le suivi de rentabilit\xE9 n\u2019est pas inclus dans l\u2019offre de votre bureau. Demandez au propri\xE9taire du compte de la faire \xE9voluer.",
    action: "Voir les offres"
  },
  states: {
    positive: "Marge positive",
    negative: "Marge n\xE9gative",
    zero: "Marge nulle"
  },
  duration: {
    hours: "{hours}\xA0h"
  },
  modes: {
    invoiced: "Le chiffre d\u2019affaires compte les factures \xE9mises (hors taxes).",
    completion: "Le chiffre d\u2019affaires est reconnu \xE0 l\u2019avancement de chaque phase."
  },
  project: {
    noAccessTitle: "Rentabilit\xE9 non disponible",
    noAccessBody: "Vous n\u2019avez pas acc\xE8s aux informations de rentabilit\xE9 de ce projet.",
    loadFailedTitle: "Impossible d\u2019afficher la rentabilit\xE9 du projet",
    loadFailedBody: "Les chiffres n\u2019ont pas pu \xEAtre charg\xE9s. Vos donn\xE9es ne sont pas perdues. R\xE9essayez\xA0; si le probl\xE8me continue, contactez le support.",
    summary: {
      title: "Synth\xE8se",
      label: "Chiffres cl\xE9s de la rentabilit\xE9 du projet",
      revenue: "Chiffre d\u2019affaires retenu",
      invoicedHt: "Factur\xE9 HT",
      collected: "Encaiss\xE9 (paiements et retenues)",
      recognised: "Reconnu \xE0 l\u2019avancement",
      timeCost: "Co\xFBt du temps",
      expenses: "Frais approuv\xE9s",
      subcontracting: "Sous-traitance",
      cost: "Co\xFBt total",
      margin: "Marge",
      marginRate: "Taux de marge",
      noMarginRate: "Pas de chiffre d\u2019affaires",
      time: "Temps pass\xE9",
      timePending: "dont {hours} en attente d\u2019approbation",
      unrated: "{hours} de temps ne sont pas valoris\xE9es\xA0: aucun taux de co\xFBt n\u2019est d\xE9fini pour les personnes concern\xE9es \xE0 ces dates."
    },
    chart: {
      title: "Revenu et co\xFBt du temps par phase",
      intro: "Le graphique compare, phase par phase, le chiffre d\u2019affaires retenu et le co\xFBt du temps pass\xE9. Les frais et la sous-traitance sont compt\xE9s au niveau du projet.",
      label: "Histogramme du revenu et du co\xFBt du temps par phase, en dinars. Les m\xEAmes chiffres sont dans le tableau qui suit.",
      revenue: "Revenu",
      timeCost: "Co\xFBt du temps",
      unassigned: "Hors phase"
    },
    table: {
      caption: "Revenu et co\xFBt du temps par phase, en TND",
      phase: "Phase",
      revenue: "Revenu",
      timeCost: "Co\xFBt du temps",
      completion: "Avancement",
      total: "Total",
      unassigned: "Hors phase (factures sans phase, temps sans phase)",
      none: "\u2014"
    },
    budget: {
      title: "Budget de temps par phase",
      intro: "Le budget de temps se r\xE8gle dans le panneau de chaque phase. Une alerte appara\xEEt d\xE8s que 80\xA0% du budget sont consomm\xE9s.",
      caption: "Temps pass\xE9 et budget de temps par phase",
      phase: "Phase",
      spent: "Temps pass\xE9",
      budget: "Budget",
      consumption: "Consommation",
      noBudget: "Pas de budget",
      pending: "dont {hours} \xE0 approuver",
      progress: "Budget de temps consomm\xE9 de la phase {phase}",
      ok: "Dans le budget",
      alert: "Alerte\xA0: 80\xA0% du budget atteints",
      exceeded: "Budget d\xE9pass\xE9",
      totalLabel: "Temps du projet"
    }
  },
  overview: {
    intro: "La marge de chaque projet\xA0: le chiffre d\u2019affaires retenu moins les co\xFBts (temps, frais approuv\xE9s et sous-traitance).",
    scopeLabel: "Projets \xE0 afficher",
    scope: {
      active: "Projets en cours",
      all: "Tous les projets"
    },
    loadFailedTitle: "Impossible d\u2019afficher la rentabilit\xE9",
    loadFailedBody: "Les chiffres n\u2019ont pas pu \xEAtre charg\xE9s. Vos donn\xE9es ne sont pas perdues. R\xE9essayez\xA0; si le probl\xE8me continue, contactez le support.",
    totals: {
      label: "Totaux de l\u2019organisation",
      revenue: "Chiffre d\u2019affaires retenu",
      cost: "Co\xFBts",
      margin: "Marge",
      marginRate: "Taux de marge"
    },
    chart: {
      title: "Revenu et co\xFBts par projet",
      label: "Histogramme du revenu et des co\xFBts par projet, en dinars. Les m\xEAmes chiffres sont dans le tableau qui suit.",
      limited: "Le graphique montre les {count} projets au revenu le plus \xE9lev\xE9\xA0; tous les projets figurent dans le tableau.",
      revenue: "Revenu",
      cost: "Co\xFBts"
    },
    table: {
      caption: "Rentabilit\xE9 par projet, en TND",
      project: "Projet",
      status: "Statut",
      revenue: "Revenu",
      cost: "Co\xFBts",
      margin: "Marge",
      marginRate: "Taux de marge",
      budget: "Budget de temps",
      noBudget: "Pas de budget",
      alert: "Alerte \xE0 80\xA0%",
      withinBudget: "Dans le budget",
      total: "Total"
    },
    empty: {
      title: "Aucun projet \xE0 afficher",
      body: "D\xE8s qu\u2019un projet a des factures ou du temps saisi, sa marge appara\xEEt ici."
    }
  },
  rates: {
    intro: "Le taux de co\xFBt est le co\xFBt horaire charg\xE9 d\u2019une personne (salaire, charges et frais g\xE9n\xE9raux) \xE0 partir d\u2019une date. Il sert \xE0 valoriser le temps pass\xE9 sur les projets.",
    sensitive: "Ces taux r\xE9v\xE8lent des salaires\xA0: ils ne sont visibles que sur cette page et jamais par les chefs de projet.",
    add: "Ajouter un taux",
    tableLabel: "Taux de co\xFBt par personne",
    columns: {
      person: "Personne",
      from: "\xC0 partir du",
      rate: "Co\xFBt horaire",
      state: "Situation",
      actions: "Actions"
    },
    perHour: "{amount}\xA0/\xA0h",
    current: "En vigueur",
    past: "Remplac\xE9",
    future: "\xC0 venir",
    delete: "Supprimer",
    deleteLabel: "Supprimer le taux de {name} \xE0 partir du {date}",
    deleteTitle: "Supprimer le taux de {name} \xE0 partir du {date}\xA0?",
    deleteBody: "Le temps saisi \xE0 partir de cette date sera valoris\xE9 avec le taux pr\xE9c\xE9dent, ou ne sera plus valoris\xE9 s\u2019il n\u2019y en a pas. La suppression est enregistr\xE9e dans le journal d\u2019audit.",
    deleteConfirm: "Supprimer le taux",
    deleted: "Le taux a \xE9t\xE9 supprim\xE9.",
    created: "Le taux de {name} est enregistr\xE9.",
    stepUp: "Confirmez votre identit\xE9 pour modifier les taux de co\xFBt.",
    loadFailedTitle: "Impossible d\u2019afficher les taux de co\xFBt",
    loadFailedBody: "Les taux n\u2019ont pas pu \xEAtre charg\xE9s. Vos donn\xE9es ne sont pas perdues. R\xE9essayez\xA0; si le probl\xE8me continue, contactez le support.",
    empty: {
      title: "Aucun taux de co\xFBt",
      body: "Ajoutez un taux pour chaque personne dont le temps doit \xEAtre valoris\xE9 dans la rentabilit\xE9."
    },
    withoutRate: {
      title: "Sans taux de co\xFBt",
      body: "Le temps de ces personnes n\u2019est pas valoris\xE9 dans la rentabilit\xE9\xA0: {names}."
    },
    dialog: {
      title: "Ajouter un taux de co\xFBt",
      person: "Personne",
      personPlaceholder: "Choisir une personne",
      from: "\xC0 partir du",
      rate: "Co\xFBt horaire charg\xE9",
      rateHint: "En dinars par heure, avec trois d\xE9cimales au plus. Il s\u2019applique au temps travaill\xE9 \xE0 partir de cette date.",
      save: "Enregistrer le taux",
      saving: "Enregistrement\u2026",
      noPeople: "Aucune personne active n\u2019est disponible.",
      errors: {
        person: "Choisissez une personne.",
        from: "Indiquez la date \xE0 partir de laquelle le taux s\u2019applique.",
        rate: "Indiquez un co\xFBt horaire sup\xE9rieur \xE0 z\xE9ro."
      }
    }
  },
  recognition: {
    title: "Comptabilisation du chiffre d\u2019affaires",
    hint: "Choisissez comment la rentabilit\xE9 de vos projets compte le chiffre d\u2019affaires.",
    optionsLabel: "Mode de comptabilisation du chiffre d\u2019affaires",
    invoiced: "\xC0 la facturation",
    invoicedHint: "Le chiffre d\u2019affaires est le montant hors taxes des factures \xE9mises. C\u2019est le choix par d\xE9faut, le plus simple \xE0 rapprocher de la comptabilit\xE9.",
    completion: "\xC0 l\u2019avancement",
    completionHint: "Le chiffre d\u2019affaires de chaque phase suit son avancement\xA0: les honoraires de la phase multipli\xE9s par son taux d\u2019avancement. La marge ne d\xE9pend plus du rythme de facturation.",
    save: "Enregistrer",
    saving: "Enregistrement\u2026",
    saved: "Le mode de comptabilisation est enregistr\xE9.",
    readOnly: "Seuls les administrateurs habilit\xE9s \xE0 modifier les param\xE8tres fiscaux peuvent changer ce choix.",
    stale: "Ces param\xE8tres ont \xE9t\xE9 modifi\xE9s par quelqu\u2019un d\u2019autre. Rechargez-les puis recommencez.",
    reload: "Recharger",
    loading: "Chargement\u2026",
    loadFailed: "Les param\xE8tres n\u2019ont pas pu \xEAtre charg\xE9s."
  }
};

// locales/ar/accounting.json
var accounting_default = {
  page: {
    intro: "\u062D\u0636\u0651\u0631 \u0627\u0644\u0645\u0644\u0641\u0627\u062A \u0627\u0644\u062A\u064A \u064A\u0633\u062A\u0648\u0631\u062F\u0647\u0627 \u062E\u0628\u064A\u0631\u0643 \u0627\u0644\u0645\u062D\u0627\u0633\u0628 \u0641\u064A \u0628\u0631\u0646\u0627\u0645\u062C\u0647\u060C \u0648\u0627\u062E\u062A\u0645 \u0627\u0644\u0623\u0634\u0647\u0631 \u0627\u0644\u0645\u0646\u062A\u0647\u064A\u0629\u060C \u0648\u062D\u062F\u0651\u062F \u0627\u0644\u062D\u0633\u0627\u0628\u0627\u062A \u0627\u0644\u062A\u064A \u062A\u0633\u062A\u0639\u0645\u0644\u0647\u0627 \u0627\u0644\u064A\u0648\u0645\u064A\u0627\u062A.",
    tabsLabel: "\u0623\u0642\u0633\u0627\u0645 \u0627\u0644\u0635\u0641\u062D\u0629",
    tabs: {
      exports: "\u0627\u0644\u062A\u0635\u062F\u064A\u0631\u0627\u062A",
      periods: "\u0627\u0644\u0623\u0634\u0647\u0631 \u0627\u0644\u0645\u062E\u062A\u0648\u0645\u0629",
      accounts: "\u0627\u0644\u062D\u0633\u0627\u0628\u0627\u062A"
    }
  },
  journals: {
    sales: "\u064A\u0648\u0645\u064A\u0629 \u0627\u0644\u0645\u0628\u064A\u0639\u0627\u062A",
    purchases: "\u064A\u0648\u0645\u064A\u0629 \u0627\u0644\u0645\u0634\u062A\u0631\u064A\u0627\u062A",
    treasury: "\u064A\u0648\u0645\u064A\u0629 \u0627\u0644\u062E\u0632\u064A\u0646\u0629",
    vat_summary: "\u0645\u0644\u062E\u0635 \u0627\u0644\u0623\u062F\u0627\u0621 \u0639\u0644\u0649 \u0627\u0644\u0642\u064A\u0645\u0629 \u0627\u0644\u0645\u0636\u0627\u0641\u0629",
    withholding_summary: "\u0645\u0644\u062E\u0635 \u0627\u0644\u0627\u0642\u062A\u0637\u0627\u0639\u0627\u062A"
  },
  presets: {
    generic: "\u0639\u0627\u0645",
    sage100: "Sage 100",
    ciel: "Ciel"
  },
  formats: {
    csv: "CSV",
    xlsx: "XLSX"
  },
  status: {
    pending: "\u0642\u064A\u062F \u0627\u0644\u0625\u0639\u062F\u0627\u062F",
    ready: "\u062C\u0627\u0647\u0632",
    failed: "\u0641\u0634\u0644"
  },
  totals: {
    debitMinor: "\u0645\u062C\u0645\u0648\u0639 \u0627\u0644\u0645\u062F\u064A\u0646",
    creditMinor: "\u0645\u062C\u0645\u0648\u0639 \u0627\u0644\u062F\u0627\u0626\u0646",
    htMinor: "\u0627\u0644\u0645\u062C\u0645\u0648\u0639 \u062F\u0648\u0646 \u0627\u062D\u062A\u0633\u0627\u0628 \u0627\u0644\u0623\u062F\u0627\u0621",
    vatMinor: "\u0627\u0644\u0623\u062F\u0627\u0621 \u0639\u0644\u0649 \u0627\u0644\u0642\u064A\u0645\u0629 \u0627\u0644\u0645\u0636\u0627\u0641\u0629",
    stampMinor: "\u0645\u0639\u0644\u0648\u0645 \u0627\u0644\u0637\u0627\u0628\u0639",
    ttcMinor: "\u0627\u0644\u0645\u062C\u0645\u0648\u0639 \u0628\u0639\u062F \u0627\u062D\u062A\u0633\u0627\u0628 \u0627\u0644\u0623\u062F\u0627\u0621",
    rasMinor: "\u0627\u0644\u0627\u0642\u062A\u0637\u0627\u0639 \u0645\u0646 \u0627\u0644\u0645\u0648\u0631\u062F",
    rasTvaMinor: "\u0627\u0642\u062A\u0637\u0627\u0639 \u0627\u0644\u0623\u062F\u0627\u0621 \u0639\u0644\u0649 \u0627\u0644\u0642\u064A\u0645\u0629 \u0627\u0644\u0645\u0636\u0627\u0641\u0629",
    vatDeductibleMinor: "\u0627\u0644\u0623\u062F\u0627\u0621 \u0627\u0644\u0642\u0627\u0628\u0644 \u0644\u0644\u0637\u0631\u062D",
    receivedMinor: "\u0627\u0644\u0645\u0642\u0628\u0648\u0636\u0627\u062A",
    paidMinor: "\u0627\u0644\u0645\u062F\u0641\u0648\u0639\u0627\u062A",
    withheldByClientsMinor: "\u0627\u0642\u062A\u0637\u0627\u0639\u0627\u062A \u0627\u0644\u062D\u0631\u0641\u0627\u0621",
    withheldFromSuppliersMinor: "\u0627\u0642\u062A\u0637\u0627\u0639\u0627\u062A \u0645\u0646 \u0627\u0644\u0645\u0632\u0648\u062F\u064A\u0646",
    collectedMinor: "\u0627\u0644\u0623\u062F\u0627\u0621 \u0627\u0644\u0645\u0633\u062A\u062E\u0644\u0635",
    deductibleMinor: "\u0627\u0644\u0623\u062F\u0627\u0621 \u0627\u0644\u0642\u0627\u0628\u0644 \u0644\u0644\u0637\u0631\u062D",
    balanceMinor: "\u0627\u0644\u0623\u062F\u0627\u0621 \u0627\u0644\u0648\u0627\u062C\u0628 \u062F\u0641\u0639\u0647",
    issuedMinor: "\u0627\u0644\u0627\u0642\u062A\u0637\u0627\u0639\u0627\u062A \u0627\u0644\u0645\u0646\u062C\u0632\u0629"
  },
  new: {
    title: "\u062A\u0635\u062F\u064A\u0631 \u062C\u062F\u064A\u062F",
    intro: "\u0627\u062E\u062A\u0631 \u0627\u0644\u064A\u0648\u0645\u064A\u0629 \u0648\u0627\u0644\u0635\u064A\u063A\u0629 \u0627\u0644\u062A\u064A \u064A\u0642\u0631\u0624\u0647\u0627 \u0628\u0631\u0646\u0627\u0645\u062C \u0645\u062D\u0627\u0633\u0628\u0643 \u0648\u0627\u0644\u0623\u0634\u0647\u0631 \u0627\u0644\u0645\u0631\u0627\u062F \u062A\u0635\u062F\u064A\u0631\u0647\u0627. \u064A\u0643\u0648\u0646 \u0627\u0644\u0645\u0644\u0641 \u062C\u0627\u0647\u0632\u0627 \u0641\u064A \u062B\u0648\u0627\u0646\u064D.",
    journal: "\u0627\u0644\u064A\u0648\u0645\u064A\u0629",
    preset: "\u0627\u0644\u0646\u0645\u0648\u0630\u062C",
    presetHint: "\u0639\u0627\u0645\u060C \u0623\u0648 \u0646\u0645\u0648\u0630\u062C \u0627\u0644\u0627\u0633\u062A\u064A\u0631\u0627\u062F \u0627\u0644\u062E\u0627\u0635 \u0628\u0628\u0631\u0646\u0627\u0645\u062C Sage 100 \u0623\u0648 Ciel (\u0642\u064A\u0648\u062F \u0645\u062A\u0648\u0627\u0632\u0646\u0629).",
    presetLocked: "\u0627\u0644\u0645\u0644\u062E\u0635\u0627\u062A \u0644\u0627 \u062A\u062A\u0648\u0641\u0631 \u0625\u0644\u0627 \u0628\u0627\u0644\u0646\u0645\u0648\u0630\u062C \u0627\u0644\u0639\u0627\u0645: \u064A\u0642\u062A\u0631\u062D Sage 100 \u0648Ciel \u0644\u0644\u0645\u0628\u064A\u0639\u0627\u062A \u0648\u0627\u0644\u0645\u0634\u062A\u0631\u064A\u0627\u062A \u0648\u0627\u0644\u062E\u0632\u064A\u0646\u0629 \u0641\u0642\u0637.",
    format: "\u0635\u064A\u063A\u0629 \u0627\u0644\u0645\u0644\u0641",
    from: "\u0645\u0646 \u0634\u0647\u0631",
    to: "\u0625\u0644\u0649 \u0634\u0647\u0631",
    rangeHint: "12 \u0634\u0647\u0631\u0627 \u0639\u0644\u0649 \u0627\u0644\u0623\u0643\u062B\u0631 \u0641\u064A \u0643\u0644 \u0645\u0631\u0629.",
    submit: "\u0628\u062F\u0621 \u0627\u0644\u062A\u0635\u062F\u064A\u0631",
    submitting: "\u062C\u0627\u0631\u064D \u0627\u0644\u0637\u0644\u0628\u2026",
    created: "\u062A\u0645 \u0637\u0644\u0628 \u0627\u0644\u062A\u0635\u062F\u064A\u0631: \u0633\u064A\u0643\u0648\u0646 \u0627\u0644\u0645\u0644\u0641 \u062C\u0627\u0647\u0632\u0627 \u0628\u0639\u062F \u062B\u0648\u0627\u0646\u064D.",
    openTitle: "\u0628\u0639\u0636 \u0627\u0644\u0623\u0634\u0647\u0631 \u0644\u0645 \u062A\u064F\u062E\u062A\u0645 \u0628\u0639\u062F",
    openBody: "\u0642\u062F \u062A\u062A\u063A\u064A\u0631 \u0623\u0631\u0642\u0627\u0645 \u0647\u0630\u0627 \u0627\u0644\u062A\u0635\u062F\u064A\u0631: \u0627\u0644\u0623\u0634\u0647\u0631 {months} \u063A\u064A\u0631 \u0645\u062E\u062A\u0648\u0645\u0629. \u0627\u062E\u062A\u0645 \u0627\u0644\u0623\u0634\u0647\u0631 \u0627\u0644\u0645\u0646\u062A\u0647\u064A\u0629 \u0644\u062A\u062B\u0628\u064A\u062A \u0623\u0631\u0642\u0627\u0645\u0647\u0627.",
    errors: {
      rangeInverted: "\u064A\u062C\u0628 \u0623\u0646 \u064A\u0643\u0648\u0646 \u0634\u0647\u0631 \u0627\u0644\u0646\u0647\u0627\u064A\u0629 \u0647\u0648 \u0634\u0647\u0631 \u0627\u0644\u0628\u062F\u0627\u064A\u0629 \u0646\u0641\u0633\u0647 \u0623\u0648 \u0634\u0647\u0631\u0627 \u0628\u0639\u062F\u0647.",
      rangeTooLong: "\u064A\u063A\u0637\u064A \u0627\u0644\u062A\u0635\u062F\u064A\u0631 {max} \u0634\u0647\u0631\u0627 \u0639\u0644\u0649 \u0627\u0644\u0623\u0643\u062B\u0631. \u0642\u0644\u0651\u0635 \u0627\u0644\u0641\u062A\u0631\u0629.",
      presetSummary: "\u0627\u0644\u0645\u0644\u062E\u0635\u0627\u062A \u0644\u0627 \u062A\u062A\u0648\u0641\u0631 \u0625\u0644\u0627 \u0628\u0627\u0644\u0646\u0645\u0648\u0630\u062C \u0627\u0644\u0639\u0627\u0645."
    }
  },
  history: {
    title: "\u0633\u062C\u0644 \u0627\u0644\u062A\u0635\u062F\u064A\u0631\u0627\u062A",
    intro: "\u062A\u0628\u0642\u0649 \u0627\u0644\u0645\u0644\u0641\u0627\u062A \u0645\u062A\u0627\u062D\u0629 \u0647\u0646\u0627. \u0631\u0627\u0628\u0637 \u0627\u0644\u062A\u062D\u0645\u064A\u0644 \u0645\u0624\u0642\u062A: \u064A\u064F\u0637\u0644\u0628 \u0639\u0646\u062F \u0627\u0644\u0646\u0642\u0631.",
    tableLabel: "\u0633\u062C\u0644 \u0627\u0644\u062A\u0635\u062F\u064A\u0631\u0627\u062A \u0627\u0644\u0645\u062D\u0627\u0633\u0628\u064A\u0629",
    refresh: "\u062A\u062D\u062F\u064A\u062B",
    building: "\u062C\u0627\u0631\u064D \u0627\u0644\u0625\u0639\u062F\u0627\u062F\u2026 \u062A\u062A\u062D\u062F\u062B \u0627\u0644\u0642\u0627\u0626\u0645\u0629 \u062A\u0644\u0642\u0627\u0626\u064A\u0627.",
    slowTitle: "\u0627\u0644\u0625\u0639\u062F\u0627\u062F \u064A\u0633\u062A\u063A\u0631\u0642 \u0623\u0637\u0648\u0644 \u0645\u0646 \u0627\u0644\u0645\u062A\u0648\u0642\u0639",
    slowBody: "\u0644\u0645 \u062A\u0639\u062F \u0627\u0644\u0642\u0627\u0626\u0645\u0629 \u062A\u062A\u062D\u062F\u062B \u062A\u0644\u0642\u0627\u0626\u064A\u0627. \u062D\u062F\u0651\u062B\u0647\u0627 \u0628\u0639\u062F \u0642\u0644\u064A\u0644\u061B \u0627\u0644\u062A\u0635\u062F\u064A\u0631 \u0627\u0644\u0630\u064A \u0644\u0627 \u064A\u0643\u062A\u0645\u0644 \u064A\u0635\u0628\u062D \u0641\u0627\u0634\u0644\u0627 \u0648\u064A\u0645\u0643\u0646 \u0625\u0639\u0627\u062F\u0629 \u0637\u0644\u0628\u0647.",
    loadFailedTitle: "\u062A\u0639\u0630\u0631 \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u062A\u0635\u062F\u064A\u0631\u0627\u062A",
    loadFailedBody: "\u062A\u0639\u0630\u0631\u062A \u0642\u0631\u0627\u0621\u0629 \u0627\u0644\u0633\u062C\u0644. \u062D\u0627\u0648\u0644 \u0645\u062C\u062F\u062F\u0627 \u0628\u0639\u062F \u0642\u0644\u064A\u0644.",
    columns: {
      journal: "\u0627\u0644\u064A\u0648\u0645\u064A\u0629",
      period: "\u0627\u0644\u0641\u062A\u0631\u0629",
      status: "\u0627\u0644\u062D\u0627\u0644\u0629",
      rows: "\u0627\u0644\u0623\u0633\u0637\u0631",
      totals: "\u0627\u0644\u0645\u062C\u0627\u0645\u064A\u0639",
      created: "\u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0637\u0644\u0628",
      file: "\u0627\u0644\u0645\u0644\u0641"
    },
    layoutFormat: "{layout} \xB7 {format}",
    range: "\u0645\u0646 {from} \u0625\u0644\u0649 {to}",
    openChip: "\u0623\u0631\u0642\u0627\u0645 \u0645\u0624\u0642\u062A\u0629",
    openMonths: "\u0623\u0634\u0647\u0631 \u063A\u064A\u0631 \u0645\u062E\u062A\u0648\u0645\u0629: {months}. \u0642\u062F \u062A\u062A\u063A\u064A\u0631 \u0627\u0644\u0623\u0631\u0642\u0627\u0645.",
    failedHint: "\u062A\u0639\u0630\u0631 \u0625\u0639\u062F\u0627\u062F \u0627\u0644\u0645\u0644\u0641. \u0627\u0628\u062F\u0623 \u062A\u0635\u062F\u064A\u0631\u0627 \u062C\u062F\u064A\u062F\u0627.",
    noTotals: "\u0644\u0627 \u0645\u062C\u0627\u0645\u064A\u0639",
    downloading: "\u062C\u0627\u0631\u064D \u0627\u0644\u062A\u062D\u0645\u064A\u0644\u2026",
    download: "\u062A\u062D\u0645\u064A\u0644",
    downloadLabel: "\u062A\u062D\u0645\u064A\u0644 \u062A\u0635\u062F\u064A\u0631 {journal}\u060C {period}",
    empty: {
      title: "\u0644\u0627 \u062A\u0648\u062C\u062F \u062A\u0635\u062F\u064A\u0631\u0627\u062A \u0628\u0639\u062F",
      body: "\u0633\u062A\u0638\u0647\u0631 \u0647\u0646\u0627 \u0627\u0644\u0645\u0644\u0641\u0627\u062A \u0627\u0644\u062A\u064A \u062A\u0639\u062F\u0651\u0647\u0627\u060C \u0645\u0639 \u0645\u062C\u0627\u0645\u064A\u0639\u0647\u0627 \u0644\u0645\u0637\u0627\u0628\u0642\u062A\u0647\u0627 \u0645\u0639 \u0648\u062B\u0627\u0626\u0642\u0643."
    }
  },
  periods: {
    intro: "\u062E\u062A\u0645 \u0627\u0644\u0634\u0647\u0631 \u064A\u062B\u0628\u0651\u062A \u0623\u0631\u0642\u0627\u0645\u0647: \u0628\u0639\u062F \u0627\u0644\u062E\u062A\u0645 \u0644\u0627 \u064A\u0645\u0643\u0646 \u0625\u0646\u0634\u0627\u0621 \u0623\u064A \u0648\u062B\u064A\u0642\u0629 \u0645\u0627\u0644\u064A\u0629 \u0645\u0624\u0631\u062E\u0629 \u0641\u064A \u0647\u0630\u0627 \u0627\u0644\u0634\u0647\u0631 \u0648\u0644\u0627 \u062A\u0639\u062F\u064A\u0644\u0647\u0627 \u0648\u0644\u0627 \u0625\u0644\u063A\u0627\u0624\u0647\u0627. \u062A\u064F\u062C\u0631\u0649 \u0627\u0644\u062A\u0635\u062D\u064A\u062D\u0627\u062A \u0641\u064A \u0634\u0647\u0631 \u0645\u0641\u062A\u0648\u062D \u0639\u0628\u0631 \u0625\u0634\u0639\u0627\u0631 \u062F\u0627\u0626\u0646.",
    close: {
      title: "\u062E\u062A\u0645 \u0634\u0647\u0631",
      month: "\u0627\u0644\u0634\u0647\u0631 \u0627\u0644\u0645\u0631\u0627\u062F \u062E\u062A\u0645\u0647",
      button: "\u062E\u062A\u0645 \u0627\u0644\u0634\u0647\u0631",
      confirmTitle: "\u062E\u062A\u0645 {month}\u061F",
      confirmBody: "\u0628\u0639\u062F \u062E\u062A\u0645 \u0647\u0630\u0627 \u0627\u0644\u0634\u0647\u0631 \u0633\u062A\u064F\u0631\u0641\u0636 \u0647\u0630\u0647 \u0627\u0644\u0639\u0645\u0644\u064A\u0627\u062A \u0644\u0623\u064A \u062A\u0627\u0631\u064A\u062E \u0641\u064A\u0647:",
      blocks: {
        invoices: "\u0625\u0635\u062F\u0627\u0631 \u0627\u0644\u0641\u0648\u0627\u062A\u064A\u0631 \u0648\u0627\u0644\u0625\u0634\u0639\u0627\u0631\u0627\u062A \u0627\u0644\u062F\u0627\u0626\u0646\u0629\u061B",
        payments: "\u062A\u0633\u062C\u064A\u0644 \u0645\u0642\u0628\u0648\u0636\u0627\u062A \u0627\u0644\u062D\u0631\u0641\u0627\u0621 \u0623\u0648 \u0625\u0644\u063A\u0627\u0624\u0647\u0627\u061B",
        expenses: "\u0645\u0635\u0627\u0631\u064A\u0641 \u0627\u0644\u0645\u0648\u0638\u0641\u064A\u0646\u061B",
        supplier: "\u0641\u0648\u0627\u062A\u064A\u0631 \u0627\u0644\u0645\u0632\u0648\u062F\u064A\u0646 \u0648\u0645\u062F\u0641\u0648\u0639\u0627\u062A\u0647\u0645."
      },
      confirmAfter: "\u0644\u0627 \u064A\u0645\u0643\u0646 \u0625\u0639\u0627\u062F\u0629 \u0641\u062A\u062D \u0627\u0644\u0634\u0647\u0631 \u0625\u0644\u0627 \u0644\u0634\u062E\u0635 \u0645\u062E\u0648\u0651\u0644 \u0628\u062A\u0639\u062F\u064A\u0644 \u0627\u0644\u0625\u0639\u062F\u0627\u062F\u0627\u062A \u0627\u0644\u062C\u0628\u0627\u0626\u064A\u0629\u060C \u0628\u0639\u062F \u0627\u0644\u062A\u062D\u0642\u0642 \u0645\u0646 \u0647\u0648\u064A\u062A\u0647.",
      currentMonth: "\u0647\u0630\u0627 \u0647\u0648 \u0627\u0644\u0634\u0647\u0631 \u0627\u0644\u062C\u0627\u0631\u064A: \u0644\u0646 \u064A\u0645\u0643\u0646 \u062A\u0623\u0631\u064A\u062E \u0623\u064A \u0648\u062B\u064A\u0642\u0629 \u0641\u064A\u0647 \u0645\u0627 \u062F\u0627\u0645 \u0645\u062E\u062A\u0648\u0645\u0627.",
      confirmButton: "\u062E\u062A\u0645",
      done: "\u062A\u0645 \u062E\u062A\u0645 {month}."
    },
    list: {
      title: "\u0627\u0644\u0623\u0634\u0647\u0631 \u0627\u0644\u0645\u062E\u062A\u0648\u0645\u0629"
    },
    tableLabel: "\u0627\u0644\u0623\u0634\u0647\u0631 \u0627\u0644\u0645\u062E\u062A\u0648\u0645\u0629",
    columns: {
      month: "\u0627\u0644\u0634\u0647\u0631",
      by: "\u062E\u062A\u0645\u0647",
      at: "\u062A\u0627\u0631\u064A\u062E \u0627\u0644\u062E\u062A\u0645",
      actions: "\u0625\u062C\u0631\u0627\u0621"
    },
    empty: {
      title: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0623\u0634\u0647\u0631 \u0645\u062E\u062A\u0648\u0645\u0629",
      body: "\u0639\u0646\u062F\u0645\u0627 \u064A\u0646\u062A\u0647\u064A \u0634\u0647\u0631 \u0645\u062D\u0627\u0633\u0628\u064A\u060C \u0627\u062E\u062A\u0645\u0647 \u0644\u062A\u062A\u0648\u0642\u0641 \u0623\u0631\u0642\u0627\u0645\u0647 \u0639\u0646 \u0627\u0644\u062A\u063A\u064A\u0651\u0631."
    },
    reopen: {
      button: "\u0625\u0639\u0627\u062F\u0629 \u0641\u062A\u062D",
      label: "\u0625\u0639\u0627\u062F\u0629 \u0641\u062A\u062D {month}",
      confirmTitle: "\u0625\u0639\u0627\u062F\u0629 \u0641\u062A\u062D {month}\u061F",
      confirmBody: "\u0633\u062A\u0635\u0628\u062D \u0627\u0644\u0648\u062B\u0627\u0626\u0642 \u0627\u0644\u0645\u0627\u0644\u064A\u0629 \u0644\u0647\u0630\u0627 \u0627\u0644\u0634\u0647\u0631 \u0642\u0627\u0628\u0644\u0629 \u0645\u0646 \u062C\u062F\u064A\u062F \u0644\u0644\u0625\u0646\u0634\u0627\u0621 \u0623\u0648 \u0627\u0644\u062A\u0639\u062F\u064A\u0644 \u0623\u0648 \u0627\u0644\u0625\u0644\u063A\u0627\u0621\u060C \u0648\u0642\u062F \u0644\u0627 \u062A\u0637\u0627\u0628\u0642 \u0627\u0644\u062A\u0635\u062F\u064A\u0631\u0627\u062A \u0627\u0644\u0645\u0646\u062C\u0632\u0629 \u0627\u0644\u0623\u0631\u0642\u0627\u0645 \u0627\u0644\u062C\u062F\u064A\u062F\u0629. \u064A\u064F\u0633\u062C\u064E\u0651\u0644 \u0627\u0644\u0625\u062C\u0631\u0627\u0621 \u0641\u064A \u0633\u062C\u0644 \u0627\u0644\u062A\u062F\u0642\u064A\u0642.",
      confirmButton: "\u0625\u0639\u0627\u062F\u0629 \u0641\u062A\u062D \u0627\u0644\u0634\u0647\u0631",
      done: "\u062A\u0645\u062A \u0625\u0639\u0627\u062F\u0629 \u0641\u062A\u062D {month}.",
      stepUp: "\u0623\u0643\u0651\u062F \u0647\u0648\u064A\u062A\u0643 \u0644\u0625\u0639\u0627\u062F\u0629 \u0641\u062A\u062D \u0634\u0647\u0631: \u0633\u064A\u062A\u0645 \u062A\u0648\u062C\u064A\u0647\u0643 \u062B\u0645 \u064A\u064F\u0633\u062A\u0623\u0646\u0641 \u0627\u0644\u0625\u062C\u0631\u0627\u0621."
    },
    loadFailedTitle: "\u062A\u0639\u0630\u0631 \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0623\u0634\u0647\u0631 \u0627\u0644\u0645\u062E\u062A\u0648\u0645\u0629",
    loadFailedBody: "\u062A\u0639\u0630\u0631\u062A \u0642\u0631\u0627\u0621\u0629 \u0627\u0644\u0642\u0627\u0626\u0645\u0629. \u062D\u0627\u0648\u0644 \u0645\u062C\u062F\u062F\u0627 \u0628\u0639\u062F \u0642\u0644\u064A\u0644."
  },
  accounts: {
    title: "\u062D\u0633\u0627\u0628\u0627\u062A \u0627\u0644\u064A\u0648\u0645\u064A\u0627\u062A",
    intro: "\u0631\u0642\u0645 \u0627\u0644\u062D\u0633\u0627\u0628 \u0627\u0644\u0630\u064A \u064A\u064F\u0631\u062D\u064E\u0651\u0644 \u0625\u0644\u064A\u0647 \u0643\u0644 \u0633\u0637\u0631 \u0645\u0646 \u0627\u0644\u064A\u0648\u0645\u064A\u0627\u062A\u060C \u0643\u0645\u0627 \u064A\u0645\u0633\u0643\u0647 \u0645\u062D\u0627\u0633\u0628\u0643 \u0641\u064A \u0645\u062E\u0637\u0637\u0647 \u0627\u0644\u0645\u062D\u0627\u0633\u0628\u064A. \u064A\u062A\u0643\u0648\u0646 \u0631\u0642\u0645 \u0627\u0644\u062D\u0633\u0627\u0628 \u0645\u0646 2 \u0625\u0644\u0649 12 \u0631\u0642\u0645\u0627.",
    defaultsTitle: "\u062D\u0633\u0627\u0628\u0627\u062A \u0627\u0641\u062A\u0631\u0627\u0636\u064A\u0629 \u062A\u062D\u062A\u0627\u062C \u0625\u0644\u0649 \u062A\u0623\u0643\u064A\u062F",
    defaultsBody: "\u0647\u0630\u0647 \u062D\u0633\u0627\u0628\u0627\u062A \u0627\u0644\u0645\u062E\u0637\u0637 \u0627\u0644\u0645\u062D\u0627\u0633\u0628\u064A \u0627\u0644\u062A\u0648\u0646\u0633\u064A\u060C \u062A\u064F\u0642\u062A\u0631\u062D \u0645\u0627 \u062F\u0645\u062A \u0644\u0645 \u062A\u062D\u0641\u0638 \u062D\u0633\u0627\u0628\u0627\u062A\u0643. \u0627\u0637\u0644\u0628 \u0645\u0646 \u062E\u0628\u064A\u0631\u0643 \u0627\u0644\u0645\u062D\u0627\u0633\u0628 \u062A\u0623\u0643\u064A\u062F\u0647\u0627 \u062B\u0645 \u0627\u062D\u0641\u0638\u0647\u0627.",
    groups: {
      third: "\u0627\u0644\u0623\u0637\u0631\u0627\u0641 \u0627\u0644\u0623\u062E\u0631\u0649",
      results: "\u0627\u0644\u0645\u062F\u0627\u062E\u064A\u0644 \u0648\u0627\u0644\u0645\u0635\u0627\u0631\u064A\u0641",
      vat: "\u0627\u0644\u0623\u062F\u0627\u0621 \u0639\u0644\u0649 \u0627\u0644\u0642\u064A\u0645\u0629 \u0627\u0644\u0645\u0636\u0627\u0641\u0629 \u0648\u0627\u0644\u0637\u0627\u0628\u0639",
      withholding: "\u0627\u0644\u0627\u0642\u062A\u0637\u0627\u0639\u0627\u062A \u0645\u0646 \u0627\u0644\u0645\u0648\u0631\u062F",
      treasury: "\u0627\u0644\u062E\u0632\u064A\u0646\u0629"
    },
    fields: {
      clients: {
        label: "\u0627\u0644\u062D\u0631\u0641\u0627\u0621",
        hint: "\u0627\u0644\u0645\u0628\u0627\u0644\u063A \u0627\u0644\u0645\u0633\u062A\u062D\u0642\u0629 \u0639\u0644\u0649 \u0627\u0644\u062D\u0631\u0641\u0627\u0621."
      },
      suppliers: {
        label: "\u0627\u0644\u0645\u0632\u0648\u062F\u0648\u0646",
        hint: "\u0627\u0644\u0645\u0628\u0627\u0644\u063A \u0627\u0644\u0645\u0633\u062A\u062D\u0642\u0629 \u0644\u0644\u0645\u0632\u0648\u062F\u064A\u0646."
      },
      sales: {
        label: "\u0627\u0644\u0645\u0628\u064A\u0639\u0627\u062A",
        hint: "\u0645\u062F\u0627\u062E\u064A\u0644 \u0627\u0644\u0641\u0648\u0627\u062A\u064A\u0631 \u0627\u0644\u0635\u0627\u062F\u0631\u0629."
      },
      purchases: {
        label: "\u0627\u0644\u0645\u0634\u062A\u0631\u064A\u0627\u062A",
        hint: "\u0645\u0635\u0627\u0631\u064A\u0641 \u0641\u0648\u0627\u062A\u064A\u0631 \u0627\u0644\u0645\u0632\u0648\u062F\u064A\u0646."
      },
      vatCollected: {
        label: "\u0627\u0644\u0623\u062F\u0627\u0621 \u0627\u0644\u0645\u0633\u062A\u062E\u0644\u0635",
        hint: "\u0627\u0644\u0623\u062F\u0627\u0621 \u0639\u0644\u0649 \u0627\u0644\u0642\u064A\u0645\u0629 \u0627\u0644\u0645\u0636\u0627\u0641\u0629 \u0644\u0644\u0641\u0648\u0627\u062A\u064A\u0631 \u0627\u0644\u0635\u0627\u062F\u0631\u0629."
      },
      vatDeductible: {
        label: "\u0627\u0644\u0623\u062F\u0627\u0621 \u0627\u0644\u0642\u0627\u0628\u0644 \u0644\u0644\u0637\u0631\u062D",
        hint: "\u0627\u0644\u0623\u062F\u0627\u0621 \u0627\u0644\u0642\u0627\u0628\u0644 \u0644\u0644\u0627\u0633\u062A\u0631\u062C\u0627\u0639 \u0639\u0644\u0649 \u0627\u0644\u0645\u0634\u062A\u0631\u064A\u0627\u062A."
      },
      stamp: {
        label: "\u0645\u0639\u0644\u0648\u0645 \u0627\u0644\u0637\u0627\u0628\u0639",
        hint: "\u0627\u0644\u0637\u0627\u0628\u0639 \u0627\u0644\u062C\u0628\u0627\u0626\u064A \u0644\u0644\u0641\u0648\u0627\u062A\u064A\u0631."
      },
      withholdingReceivable: {
        label: "\u0627\u0644\u0627\u0642\u062A\u0637\u0627\u0639\u0627\u062A \u0627\u0644\u0645\u0633\u0644\u0651\u0637\u0629 \u0639\u0644\u064A\u0643",
        hint: "\u0627\u0644\u0627\u0642\u062A\u0637\u0627\u0639 \u0645\u0646 \u0627\u0644\u0645\u0648\u0631\u062F \u0648\u0627\u0642\u062A\u0637\u0627\u0639 \u0627\u0644\u0623\u062F\u0627\u0621 \u0639\u0644\u0649 \u0627\u0644\u0642\u064A\u0645\u0629 \u0627\u0644\u0645\u0636\u0627\u0641\u0629 \u0627\u0644\u0630\u064A \u064A\u062C\u0631\u064A\u0647 \u062D\u0631\u0641\u0627\u0624\u0643: \u062F\u064A\u0646 \u0644\u0643 \u0639\u0644\u0649 \u0627\u0644\u062F\u0648\u0644\u0629."
      },
      withholdingPayable: {
        label: "\u0627\u0644\u0627\u0642\u062A\u0637\u0627\u0639\u0627\u062A \u0627\u0644\u062A\u064A \u062A\u062C\u0631\u064A\u0647\u0627",
        hint: "\u0627\u0644\u0627\u0642\u062A\u0637\u0627\u0639 \u0645\u0646 \u0627\u0644\u0645\u0648\u0631\u062F \u0627\u0644\u0630\u064A \u062A\u062C\u0631\u064A\u0647 \u0639\u0644\u0649 \u0645\u0632\u0648\u062F\u064A\u0643: \u062F\u064A\u0646 \u0639\u0644\u064A\u0643 \u0644\u0644\u062F\u0648\u0644\u0629."
      },
      bank: {
        label: "\u0627\u0644\u0628\u0646\u0643",
        hint: "\u0627\u0644\u0645\u0642\u0628\u0648\u0636\u0627\u062A \u0648\u0627\u0644\u0645\u062F\u0641\u0648\u0639\u0627\u062A \u0639\u0628\u0631 \u0627\u0644\u0628\u0646\u0643."
      },
      cash: {
        label: "\u0627\u0644\u0635\u0646\u062F\u0648\u0642",
        hint: "\u0627\u0644\u0645\u0642\u0628\u0648\u0636\u0627\u062A \u0648\u0627\u0644\u0645\u062F\u0641\u0648\u0639\u0627\u062A \u0646\u0642\u062F\u0627."
      }
    },
    save: "\u062D\u0641\u0638 \u0627\u0644\u062D\u0633\u0627\u0628\u0627\u062A",
    saving: "\u062C\u0627\u0631\u064D \u0627\u0644\u062D\u0641\u0638\u2026",
    saved: "\u062A\u0645 \u062D\u0641\u0638 \u0627\u0644\u062D\u0633\u0627\u0628\u0627\u062A.",
    useDefaults: "\u0627\u0633\u062A\u0631\u062C\u0627\u0639 \u0627\u0644\u062D\u0633\u0627\u0628\u0627\u062A \u0627\u0644\u0627\u0641\u062A\u0631\u0627\u0636\u064A\u0629",
    staleTitle: "\u062A\u063A\u064A\u0651\u0631\u062A \u0627\u0644\u062D\u0633\u0627\u0628\u0627\u062A \u0641\u064A \u0627\u0644\u0623\u062B\u0646\u0627\u0621",
    staleBody: "\u0639\u062F\u0651\u0644 \u0634\u062E\u0635 \u0622\u062E\u0631 \u0647\u0630\u0647 \u0627\u0644\u062D\u0633\u0627\u0628\u0627\u062A. \u0623\u0639\u062F \u062A\u062D\u0645\u064A\u0644\u0647\u0627 \u0644\u0631\u0624\u064A\u0629 \u0622\u062E\u0631 \u0646\u0633\u062E\u0629 \u062B\u0645 \u0643\u0631\u0651\u0631 \u062A\u063A\u064A\u064A\u0631\u0627\u062A\u0643.",
    reload: "\u0625\u0639\u0627\u062F\u0629 \u0627\u0644\u062A\u062D\u0645\u064A\u0644",
    loadFailedTitle: "\u062A\u0639\u0630\u0631 \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u062D\u0633\u0627\u0628\u0627\u062A",
    loadFailedBody: "\u062A\u0639\u0630\u0631\u062A \u0642\u0631\u0627\u0621\u0629 \u0627\u0644\u062D\u0633\u0627\u0628\u0627\u062A. \u062D\u0627\u0648\u0644 \u0645\u062C\u062F\u062F\u0627 \u0628\u0639\u062F \u0642\u0644\u064A\u0644.",
    errors: {
      required: "\u0623\u062F\u062E\u0644 \u0631\u0642\u0645 \u0627\u0644\u062D\u0633\u0627\u0628.",
      invalid: "\u064A\u062A\u0643\u0648\u0646 \u0631\u0642\u0645 \u0627\u0644\u062D\u0633\u0627\u0628 \u0645\u0646 2 \u0625\u0644\u0649 12 \u0631\u0642\u0645\u0627\u060C \u062F\u0648\u0646 \u0641\u0631\u0627\u063A\u0627\u062A \u0648\u0644\u0627 \u062D\u0631\u0648\u0641."
    }
  },
  tmm: {
    title: "\u0627\u0644\u0645\u0639\u062F\u0644 \u0627\u0644\u0634\u0647\u0631\u064A \u0644\u0644\u0633\u0648\u0642 \u0627\u0644\u0646\u0642\u062F\u064A\u0629 (TMM)",
    intro: "\u0646\u0633\u0628\u0629 \u0644\u0643\u0644 \u0634\u0647\u0631\u060C \u062A\u064F\u0633\u062A\u0639\u0645\u0644 \u0644\u062A\u0642\u062F\u064A\u0631 \u0641\u0648\u0627\u0626\u0636 \u0627\u0644\u062A\u0623\u062E\u064A\u0631 \u0639\u0644\u0649 \u0641\u0648\u0627\u062A\u064A\u0631 \u062D\u0631\u0641\u0627\u0626\u0643 \u0627\u0644\u0639\u0645\u0648\u0645\u064A\u064A\u0646. \u0627\u0644\u0634\u0647\u0631 \u0627\u0644\u0630\u064A \u0644\u0627 \u0646\u0633\u0628\u0629 \u0644\u0647 \u064A\u0623\u062E\u0630 \u0622\u062E\u0631 \u0646\u0633\u0628\u0629 \u0645\u0639\u0631\u0648\u0641\u0629.",
    add: "\u0625\u0636\u0627\u0641\u0629 \u0646\u0633\u0628\u0629",
    tableLabel: "\u0646\u0633\u0628 \u0627\u0644\u0633\u0648\u0642 \u0627\u0644\u0646\u0642\u062F\u064A\u0629 \u062D\u0633\u0628 \u0627\u0644\u0634\u0647\u0631",
    columns: {
      month: "\u0627\u0644\u0634\u0647\u0631",
      rate: "\u0627\u0644\u0646\u0633\u0628\u0629",
      by: "\u0623\u062F\u062E\u0644\u0647\u0627",
      at: "\u0622\u062E\u0631 \u062A\u062D\u062F\u064A\u062B",
      actions: "\u0625\u062C\u0631\u0627\u0621\u0627\u062A"
    },
    empty: {
      title: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0646\u0633\u0628 TMM",
      body: "\u0623\u0636\u0641 \u0646\u0633\u0628\u0629 \u0643\u0644 \u0634\u0647\u0631 \u0644\u062A\u0642\u062F\u064A\u0631 \u0641\u0648\u0627\u0626\u0636 \u0627\u0644\u062A\u0623\u062E\u064A\u0631. \u062F\u0648\u0646 \u0646\u0633\u0628\u0629 \u064A\u0628\u0642\u0649 \u0627\u0644\u062A\u0642\u062F\u064A\u0631 \u063A\u064A\u0631 \u0643\u0627\u0645\u0644."
    },
    editLabel: "\u062A\u0639\u062F\u064A\u0644 \u0646\u0633\u0628\u0629 {month}",
    deleteLabel: "\u062D\u0630\u0641 \u0646\u0633\u0628\u0629 {month}",
    deleteTitle: "\u062D\u0630\u0641 \u0646\u0633\u0628\u0629 {month}\u061F",
    deleteBody: "\u0633\u062A\u0633\u062A\u0639\u0645\u0644 \u062A\u0642\u062F\u064A\u0631\u0627\u062A \u0627\u0644\u0641\u0648\u0627\u0626\u0636 \u0644\u0647\u0630\u0627 \u0627\u0644\u0634\u0647\u0631 \u0622\u062E\u0631 \u0646\u0633\u0628\u0629 \u0645\u0639\u0631\u0648\u0641\u0629 \u0642\u0628\u0644\u0647\u060C \u0623\u0648 \u062A\u0643\u0648\u0646 \u063A\u064A\u0631 \u0643\u0627\u0645\u0644\u0629 \u0625\u0646 \u0644\u0645 \u062A\u0648\u062C\u062F.",
    deleteConfirm: "\u062D\u0630\u0641",
    deleted: "\u062A\u0645 \u062D\u0630\u0641 \u0627\u0644\u0646\u0633\u0628\u0629.",
    saved: "\u062A\u0645 \u062D\u0641\u0638 \u0646\u0633\u0628\u0629 {month}.",
    dialog: {
      title: "\u0625\u0636\u0627\u0641\u0629 \u0646\u0633\u0628\u0629 TMM",
      editTitle: "\u062A\u0639\u062F\u064A\u0644 \u0646\u0633\u0628\u0629 TMM",
      month: "\u0627\u0644\u0634\u0647\u0631",
      monthPlaceholder: "\u0627\u062E\u062A\u0631 \u0634\u0647\u0631\u0627",
      rate: "\u0627\u0644\u0646\u0633\u0628\u0629 \u0627\u0644\u0634\u0647\u0631\u064A\u0629",
      rateHint: "\u0628\u0627\u0644\u0645\u0627\u0626\u0629 \u0645\u0639 \u0631\u0642\u0645\u064A\u0646 \u0639\u0634\u0631\u064A\u064A\u0646 \u0639\u0644\u0649 \u0627\u0644\u0623\u0643\u062B\u0631: 7.49 \u0644\u0644\u0646\u0633\u0628\u0629 7.49 \u0628\u0627\u0644\u0645\u0627\u0626\u0629.",
      save: "\u062D\u0641\u0638",
      saving: "\u062C\u0627\u0631\u064D \u0627\u0644\u062D\u0641\u0638\u2026"
    },
    errors: {
      periodRequired: "\u0627\u062E\u062A\u0631 \u0634\u0647\u0631 \u0627\u0644\u0646\u0633\u0628\u0629.",
      rateRequired: "\u0623\u062F\u062E\u0644 \u0627\u0644\u0646\u0633\u0628\u0629.",
      rateInvalid: "\u0623\u062F\u062E\u0644 \u0646\u0633\u0628\u0629 \u0645\u0626\u0648\u064A\u0629 \u0628\u064A\u0646 0 \u064850 \u0645\u0639 \u0631\u0642\u0645\u064A\u0646 \u0639\u0634\u0631\u064A\u064A\u0646 \u0639\u0644\u0649 \u0627\u0644\u0623\u0643\u062B\u0631 (\u0645\u062B\u0644\u0627 7.49)."
    },
    loadFailedTitle: "\u062A\u0639\u0630\u0631 \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0646\u0633\u0628",
    loadFailedBody: "\u062A\u0639\u0630\u0631\u062A \u0642\u0631\u0627\u0621\u0629 \u0627\u0644\u0646\u0633\u0628. \u062D\u0627\u0648\u0644 \u0645\u062C\u062F\u062F\u0627 \u0628\u0639\u062F \u0642\u0644\u064A\u0644."
  },
  lateInterest: {
    title: "\u0641\u0648\u0627\u0626\u0636 \u0627\u0644\u062A\u0623\u062E\u064A\u0631 (\u062A\u0642\u062F\u064A\u0631)",
    notice: "\u062A\u0642\u062F\u064A\u0631 \u0625\u0631\u0634\u0627\u062F\u064A \u0644\u062A\u0630\u0643\u064A\u0631\u0643: \u0644\u064A\u0633 \u0645\u0628\u0644\u063A\u0627 \u0645\u0641\u0648\u062A\u0631\u0627 \u0648\u0644\u0627 \u064A\u0638\u0647\u0631 \u0641\u064A \u0623\u064A \u0648\u062B\u064A\u0642\u0629.",
    loading: "\u062C\u0627\u0631\u064D \u0627\u062D\u062A\u0633\u0627\u0628 \u0627\u0644\u062A\u0642\u062F\u064A\u0631\u2026",
    deadline: "\u0622\u062E\u0631 \u064A\u0648\u0645 \u062F\u0648\u0646 \u0641\u0648\u0627\u0626\u0636",
    daysLate: "\u0623\u064A\u0627\u0645 \u0627\u0644\u062A\u0623\u062E\u064A\u0631",
    outstanding: "\u0627\u0644\u0645\u062A\u0628\u0642\u064A \u0627\u0644\u0645\u0633\u062A\u062D\u0642",
    interest: "\u0627\u0644\u0641\u0648\u0627\u0626\u0636 \u0627\u0644\u0645\u0642\u062F\u0651\u0631\u0629",
    asOf: "\u0627\u0644\u0648\u0636\u0639\u064A\u0629 \u0628\u062A\u0627\u0631\u064A\u062E",
    none: "\u063A\u064A\u0631 \u0645\u062D\u062F\u062F",
    notLate: "\u0644\u0645 \u064A\u062A\u062C\u0627\u0648\u0632 \u0623\u062C\u0644 \u0627\u0644\u062F\u0641\u0639: \u0644\u0627 \u0641\u0648\u0627\u0626\u0636 \u0625\u0644\u0649 \u062D\u062F \u0627\u0644\u064A\u0648\u0645.",
    paid: "\u0647\u0630\u0647 \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629 \u0645\u0633\u062F\u062F\u0629: \u0644\u0627 \u0641\u0648\u0627\u0626\u0636 \u0644\u062A\u0642\u062F\u064A\u0631\u0647\u0627.",
    incompleteTitle: "\u062A\u0642\u062F\u064A\u0631 \u063A\u064A\u0631 \u0643\u0627\u0645\u0644",
    incompleteBody: "\u0646\u0633\u0628\u0629 TMM \u0644\u0623\u062D\u062F \u0623\u0634\u0647\u0631 \u0627\u0644\u062A\u0623\u062E\u064A\u0631 \u063A\u064A\u0631 \u0645\u0648\u062C\u0648\u062F\u0629\u060C \u0644\u0630\u0644\u0643 \u0644\u0645 \u062A\u064F\u062D\u062A\u0633\u0628 \u0641\u0648\u0627\u0626\u0636 \u0630\u0644\u0643 \u0627\u0644\u0634\u0647\u0631.",
    incompleteLink: "\u0625\u062F\u062E\u0627\u0644 \u0646\u0633\u0628 TMM",
    tableLabel: "\u0627\u0644\u0641\u0648\u0627\u0626\u0636 \u0627\u0644\u0645\u0642\u062F\u0651\u0631\u0629 \u0634\u0647\u0631\u0627 \u0628\u0634\u0647\u0631",
    columns: {
      period: "\u0627\u0644\u0641\u062A\u0631\u0629",
      days: "\u0627\u0644\u0623\u064A\u0627\u0645",
      tmm: "\u0646\u0633\u0628\u0629 TMM",
      interest: "\u0627\u0644\u0641\u0648\u0627\u0626\u0636"
    },
    range: "\u0645\u0646 {from} \u0625\u0644\u0649 {to}",
    noRate: "\u0627\u0644\u0646\u0633\u0628\u0629 \u063A\u064A\u0631 \u0645\u0648\u062C\u0648\u062F\u0629",
    carried: "\u0646\u0633\u0628\u0629 \u0627\u0644\u0634\u0647\u0631 \u0627\u0644\u0633\u0627\u0628\u0642",
    total: "\u0627\u0644\u0645\u062C\u0645\u0648\u0639 \u0627\u0644\u0645\u0642\u062F\u0651\u0631",
    basis: "\u0623\u0633\u0627\u0633 \u0627\u0644\u0627\u062D\u062A\u0633\u0627\u0628: \u0623\u062C\u0644 {days} \u064A\u0648\u0645\u0627 \u0628\u0639\u062F \u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629\u060C \u062B\u0645 \u0641\u0648\u0627\u0626\u0636 \u0628\u0646\u0633\u0628\u0629 TMM \u0645\u0636\u0627\u0641\u0627 \u0625\u0644\u064A\u0647\u0627 {spread} \u0639\u0644\u0649 \u0623\u0633\u0627\u0633 {dayCount} \u064A\u0648\u0645\u0627 \u0641\u064A \u0627\u0644\u0633\u0646\u0629.",
    basisTmm: "\u0623\u0633\u0627\u0633 \u0627\u0644\u0627\u062D\u062A\u0633\u0627\u0628: \u0623\u062C\u0644 {days} \u064A\u0648\u0645\u064B\u0627 \u0628\u0639\u062F \u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629\u060C \u062B\u0645 \u0641\u0648\u0627\u0626\u0636 \u0628\u0646\u0633\u0628\u0629 TMM \u0639\u0644\u0649 \u0623\u0633\u0627\u0633 {dayCount} \u064A\u0648\u0645\u064B\u0627 \u0641\u064A \u0627\u0644\u0633\u0646\u0629.",
    loadFailedTitle: "\u0627\u0644\u062A\u0642\u062F\u064A\u0631 \u063A\u064A\u0631 \u0645\u062A\u0627\u062D",
    loadFailedBody: "\u062A\u0639\u0630\u0631 \u062A\u0642\u062F\u064A\u0631 \u0641\u0648\u0627\u0626\u0636 \u0627\u0644\u062A\u0623\u062E\u064A\u0631. \u062D\u0627\u0648\u0644 \u0645\u062C\u062F\u062F\u0627 \u0628\u0639\u062F \u0642\u0644\u064A\u0644."
  }
};

// locales/en/accounting.json
var accounting_default2 = {
  page: {
    intro: "Prepare the files your accountant imports into their software, close finished months and set the accounts the journals use.",
    tabsLabel: "Parts of the page",
    tabs: {
      exports: "Exports",
      periods: "Closed months",
      accounts: "Accounts"
    }
  },
  journals: {
    sales: "Sales journal",
    purchases: "Purchases journal",
    treasury: "Treasury journal",
    vat_summary: "VAT summary",
    withholding_summary: "Withholding summary"
  },
  presets: {
    generic: "Generic",
    sage100: "Sage 100",
    ciel: "Ciel"
  },
  formats: {
    csv: "CSV",
    xlsx: "XLSX"
  },
  status: {
    pending: "Being prepared",
    ready: "Ready",
    failed: "Failed"
  },
  totals: {
    debitMinor: "Total debit",
    creditMinor: "Total credit",
    htMinor: "Total excl. VAT",
    vatMinor: "VAT",
    stampMinor: "Stamp duty",
    ttcMinor: "Total incl. VAT",
    rasMinor: "Withholding tax",
    rasTvaMinor: "VAT withholding",
    vatDeductibleMinor: "Deductible VAT",
    receivedMinor: "Received",
    paidMinor: "Paid out",
    withheldByClientsMinor: "Withheld by clients",
    withheldFromSuppliersMinor: "Withheld from suppliers",
    collectedMinor: "VAT collected",
    deductibleMinor: "Deductible VAT",
    balanceMinor: "VAT payable",
    issuedMinor: "Withholding operated"
  },
  new: {
    title: "New export",
    intro: "Choose the journal, the format your accountant's software reads and the months to export. The file is ready in a few seconds.",
    journal: "Journal",
    preset: "Layout",
    presetHint: "Generic, or the import layout of Sage 100 or Ciel (balanced entries).",
    presetLocked: "Summaries exist in the generic layout only: Sage 100 and Ciel are offered for sales, purchases and treasury.",
    format: "File format",
    from: "From month",
    to: "To month",
    rangeHint: "At most 12 months at a time.",
    submit: "Start the export",
    submitting: "Requesting\u2026",
    created: "Export requested: the file will be ready in a few seconds.",
    openTitle: "Some months are not closed yet",
    openBody: "The figures of this export may still change: {months} are not closed. Close finished months to freeze their figures.",
    errors: {
      rangeInverted: "The end month must be the same month as the start, or later.",
      rangeTooLong: "An export covers {max} months at most. Shorten the period.",
      presetSummary: "Summaries exist in the generic layout only."
    }
  },
  history: {
    title: "Export history",
    intro: "Files stay available here. The download link is temporary: it is requested when you click.",
    tableLabel: "Accounting export history",
    refresh: "Refresh",
    building: "Preparing\u2026 the list updates by itself.",
    slowTitle: "Preparation is taking longer than expected",
    slowBody: "The list no longer updates by itself. Refresh it in a moment; an export that does not finish is marked failed and can be started again.",
    loadFailedTitle: "Could not load the exports",
    loadFailedBody: "The history could not be read. Try again in a moment.",
    columns: {
      journal: "Journal",
      period: "Period",
      status: "Status",
      rows: "Rows",
      totals: "Totals",
      created: "Requested",
      file: "File"
    },
    layoutFormat: "{layout} \xB7 {format}",
    range: "{from} to {to}",
    openChip: "Provisional figures",
    openMonths: "Months not closed: {months}. The figures may still change.",
    failedHint: "The file could not be prepared. Start a new export.",
    noTotals: "No totals",
    downloading: "Downloading\u2026",
    download: "Download",
    downloadLabel: "Download the {journal} export, {period}",
    empty: {
      title: "No exports yet",
      body: "The files you prepare will appear here, with totals to check against your documents."
    }
  },
  periods: {
    intro: "Closing a month freezes its figures: once closed, no finance document dated in that month can be created, changed or cancelled. Corrections go to an open month, through a credit note.",
    close: {
      title: "Close a month",
      month: "Month to close",
      button: "Close the month",
      confirmTitle: "Close {month}?",
      confirmBody: "Once this month is closed, these operations will be refused for any date in it:",
      blocks: {
        invoices: "issuing invoices and credit notes;",
        payments: "recording or cancelling client payments;",
        expenses: "expense claims;",
        supplier: "supplier invoices and payments."
      },
      confirmAfter: "Only someone allowed to change the fiscal settings can reopen the month, after an identity check.",
      currentMonth: "This is the current month: no document can be dated in it while it stays closed.",
      confirmButton: "Close",
      done: "{month} is closed."
    },
    list: {
      title: "Closed months"
    },
    tableLabel: "Closed months",
    columns: {
      month: "Month",
      by: "Closed by",
      at: "Closed on",
      actions: "Action"
    },
    empty: {
      title: "No closed months",
      body: "When an accounting month is finished, close it so its figures stop moving."
    },
    reopen: {
      button: "Reopen",
      label: "Reopen {month}",
      confirmTitle: "Reopen {month}?",
      confirmBody: "Finance documents of this month can be created, changed or cancelled again, and exports already made may no longer match the figures. The action is recorded in the audit log.",
      confirmButton: "Reopen the month",
      done: "{month} is open again.",
      stepUp: "Confirm your identity to reopen a month: you will be redirected, then the action resumes."
    },
    loadFailedTitle: "Could not load the closed months",
    loadFailedBody: "The list could not be read. Try again in a moment."
  },
  accounts: {
    title: "Journal accounts",
    intro: "The account number each journal line posts to, as your accountant keeps it in their chart of accounts. Account numbers have 2 to 12 digits.",
    defaultsTitle: "Default accounts, to be confirmed",
    defaultsBody: "These are the accounts of the Tunisian chart of accounts, offered until you save your own. Have your accountant confirm them, then save.",
    groups: {
      third: "Third parties",
      results: "Income and expenses",
      vat: "VAT and stamp",
      withholding: "Withholding tax",
      treasury: "Treasury"
    },
    fields: {
      clients: {
        label: "Clients",
        hint: "Amounts owed by clients."
      },
      suppliers: {
        label: "Suppliers",
        hint: "Amounts owed to suppliers."
      },
      sales: {
        label: "Sales",
        hint: "Income of issued invoices."
      },
      purchases: {
        label: "Purchases",
        hint: "Expenses of supplier invoices."
      },
      vatCollected: {
        label: "VAT collected",
        hint: "VAT of issued invoices."
      },
      vatDeductible: {
        label: "Deductible VAT",
        hint: "Recoverable VAT on purchases."
      },
      stamp: {
        label: "Stamp duty",
        hint: "Fiscal stamp of invoices."
      },
      withholdingReceivable: {
        label: "Withholding suffered",
        hint: "Withholding tax and VAT withholding operated by your clients: a receivable on the State."
      },
      withholdingPayable: {
        label: "Withholding operated",
        hint: "Withholding tax operated on your suppliers: owed to the State."
      },
      bank: {
        label: "Bank",
        hint: "Receipts and payments through the bank."
      },
      cash: {
        label: "Cash",
        hint: "Cash receipts and payments."
      }
    },
    save: "Save the accounts",
    saving: "Saving\u2026",
    saved: "Accounts saved.",
    useDefaults: "Restore the default accounts",
    staleTitle: "The accounts changed in the meantime",
    staleBody: "Someone else changed these accounts. Reload them to see the latest version, then redo your changes.",
    reload: "Reload",
    loadFailedTitle: "Could not load the accounts",
    loadFailedBody: "The accounts could not be read. Try again in a moment.",
    errors: {
      required: "Enter an account number.",
      invalid: "An account number has 2 to 12 digits, with no spaces or letters."
    }
  },
  tmm: {
    title: "Money-market average rate (TMM)",
    intro: "One rate per month, used to estimate late-payment interest on your public clients' invoices. A month without a rate takes the last known rate.",
    add: "Add a rate",
    tableLabel: "Money-market rates by month",
    columns: {
      month: "Month",
      rate: "Rate",
      by: "Entered by",
      at: "Updated",
      actions: "Actions"
    },
    empty: {
      title: "No TMM rates",
      body: "Add each month's rate to estimate late-payment interest. Without a rate, the estimate is incomplete."
    },
    editLabel: "Edit the rate of {month}",
    deleteLabel: "Delete the rate of {month}",
    deleteTitle: "Delete the rate of {month}?",
    deleteBody: "Interest estimates for this month will use the last known rate before it, or be incomplete if there is none.",
    deleteConfirm: "Delete",
    deleted: "Rate deleted.",
    saved: "Rate of {month} saved.",
    dialog: {
      title: "Add a TMM rate",
      editTitle: "Edit the TMM rate",
      month: "Month",
      monthPlaceholder: "Choose a month",
      rate: "Monthly rate",
      rateHint: "As a percentage with at most two decimals: 7.49 for 7.49%.",
      save: "Save",
      saving: "Saving\u2026"
    },
    errors: {
      periodRequired: "Choose the month of the rate.",
      rateRequired: "Enter the rate.",
      rateInvalid: "Enter a percentage between 0 and 50 with at most two decimals (for example 7.49)."
    },
    loadFailedTitle: "Could not load the rates",
    loadFailedBody: "The rates could not be read. Try again in a moment."
  },
  lateInterest: {
    title: "Late-payment interest (estimate)",
    notice: "An indicative estimate for your reminder: it is not an amount invoiced and appears on no document.",
    loading: "Computing the estimate\u2026",
    deadline: "Last day without interest",
    daysLate: "Days late",
    outstanding: "Still owed",
    interest: "Estimated interest",
    asOf: "As of",
    none: "Not determined",
    notLate: "The payment deadline has not passed: no interest to date.",
    paid: "This invoice is settled: there is no interest to estimate.",
    incompleteTitle: "Incomplete estimate",
    incompleteBody: "The TMM rate of one of the late months is missing, so that interest is not counted.",
    incompleteLink: "Enter the TMM rates",
    tableLabel: "Estimated interest month by month",
    columns: {
      period: "Period",
      days: "Days",
      tmm: "TMM rate",
      interest: "Interest"
    },
    range: "{from} to {to}",
    noRate: "Rate missing",
    carried: "Previous month's rate",
    total: "Estimated total",
    basis: "Basis: a {days}-day period after the invoice date, then interest at the TMM plus {spread} over {dayCount} days a year.",
    basisTmm: "Basis: a deadline of {days} days after the invoice date, then interest at the TMM on {dayCount} days a year.",
    loadFailedTitle: "Estimate unavailable",
    loadFailedBody: "The late-payment interest could not be estimated. Try again in a moment."
  }
};

// locales/fr/accounting.json
var accounting_default3 = {
  page: {
    intro: "Pr\xE9parez les fichiers que votre expert-comptable importe dans son logiciel, cl\xF4turez les mois termin\xE9s et r\xE9glez les comptes utilis\xE9s par les journaux.",
    tabsLabel: "Parties de la page",
    tabs: {
      exports: "Exports",
      periods: "Mois cl\xF4tur\xE9s",
      accounts: "Comptes"
    }
  },
  journals: {
    sales: "Journal des ventes",
    purchases: "Journal des achats",
    treasury: "Journal de tr\xE9sorerie",
    vat_summary: "R\xE9capitulatif de TVA",
    withholding_summary: "R\xE9capitulatif des retenues"
  },
  presets: {
    generic: "G\xE9n\xE9rique",
    sage100: "Sage 100",
    ciel: "Ciel"
  },
  formats: {
    csv: "CSV",
    xlsx: "XLSX"
  },
  status: {
    pending: "En pr\xE9paration",
    ready: "Pr\xEAt",
    failed: "\xC9chec"
  },
  totals: {
    debitMinor: "Total d\xE9bit",
    creditMinor: "Total cr\xE9dit",
    htMinor: "Total HT",
    vatMinor: "TVA",
    stampMinor: "Droit de timbre",
    ttcMinor: "Total TTC",
    rasMinor: "Retenues \xE0 la source",
    rasTvaMinor: "Retenues de TVA",
    vatDeductibleMinor: "TVA d\xE9ductible",
    receivedMinor: "Encaiss\xE9",
    paidMinor: "D\xE9caiss\xE9",
    withheldByClientsMinor: "Retenu par les clients",
    withheldFromSuppliersMinor: "Retenu aux fournisseurs",
    collectedMinor: "TVA collect\xE9e",
    deductibleMinor: "TVA d\xE9ductible",
    balanceMinor: "TVA \xE0 payer",
    issuedMinor: "Retenues op\xE9r\xE9es"
  },
  new: {
    title: "Nouvel export",
    intro: "Choisissez le journal, le format lu par le logiciel de votre comptable et les mois \xE0 exporter. Le fichier est pr\xE9par\xE9 en quelques secondes.",
    journal: "Journal",
    preset: "Mod\xE8le",
    presetHint: "G\xE9n\xE9rique, ou le mod\xE8le d\u2019import de Sage 100 ou de Ciel (\xE9critures \xE9quilibr\xE9es).",
    presetLocked: "Les r\xE9capitulatifs n\u2019existent qu\u2019en mod\xE8le g\xE9n\xE9rique : Sage 100 et Ciel ne sont propos\xE9s que pour les ventes, les achats et la tr\xE9sorerie.",
    format: "Format du fichier",
    from: "Du mois",
    to: "Au mois",
    rangeHint: "12 mois au plus \xE0 la fois.",
    submit: "Lancer l\u2019export",
    submitting: "Demande en cours\u2026",
    created: "Export demand\xE9 : le fichier sera pr\xEAt dans quelques secondes.",
    openTitle: "Des mois ne sont pas encore cl\xF4tur\xE9s",
    openBody: "Les chiffres de cet export peuvent encore changer : {months} ne sont pas cl\xF4tur\xE9s. Cl\xF4turez les mois termin\xE9s pour figer leurs chiffres.",
    errors: {
      rangeInverted: "Le mois de fin doit \xEAtre le m\xEAme mois ou un mois apr\xE8s celui de d\xE9but.",
      rangeTooLong: "Un export couvre {max} mois au plus. R\xE9duisez la p\xE9riode.",
      presetSummary: "Les r\xE9capitulatifs n\u2019existent qu\u2019en mod\xE8le g\xE9n\xE9rique."
    }
  },
  history: {
    title: "Historique des exports",
    intro: "Les fichiers restent disponibles ici. Le lien de t\xE9l\xE9chargement est temporaire : il est demand\xE9 au moment du clic.",
    tableLabel: "Historique des exports comptables",
    refresh: "Actualiser",
    building: "Pr\xE9paration en cours\u2026 la liste se met \xE0 jour toute seule.",
    slowTitle: "La pr\xE9paration prend plus de temps que pr\xE9vu",
    slowBody: "La liste ne se met plus \xE0 jour toute seule. Actualisez-la dans un instant ; un export qui n\u2019aboutit pas passe en \xE9chec et peut \xEAtre relanc\xE9.",
    loadFailedTitle: "Impossible de charger les exports",
    loadFailedBody: "L\u2019historique n\u2019a pas pu \xEAtre lu. R\xE9essayez dans un instant.",
    columns: {
      journal: "Journal",
      period: "P\xE9riode",
      status: "\xC9tat",
      rows: "Lignes",
      totals: "Totaux",
      created: "Demand\xE9",
      file: "Fichier"
    },
    layoutFormat: "{layout} \xB7 {format}",
    range: "{from} \xE0 {to}",
    openChip: "Chiffres provisoires",
    openMonths: "Mois non cl\xF4tur\xE9s : {months}. Les chiffres peuvent encore changer.",
    failedHint: "Le fichier n\u2019a pas pu \xEAtre pr\xE9par\xE9. Lancez un nouvel export.",
    noTotals: "Aucun total",
    downloading: "T\xE9l\xE9chargement\u2026",
    download: "T\xE9l\xE9charger",
    downloadLabel: "T\xE9l\xE9charger l\u2019export {journal}, {period}",
    empty: {
      title: "Aucun export pour le moment",
      body: "Les fichiers que vous pr\xE9parez appara\xEEtront ici, avec leurs totaux \xE0 rapprocher de vos documents."
    }
  },
  periods: {
    intro: "Cl\xF4turer un mois fige ses chiffres : une fois le mois cl\xF4tur\xE9, plus aucun document financier dat\xE9 de ce mois ne peut \xEAtre cr\xE9\xE9, modifi\xE9 ni annul\xE9. Les corrections se font dans un mois ouvert, par un avoir.",
    close: {
      title: "Cl\xF4turer un mois",
      month: "Mois \xE0 cl\xF4turer",
      button: "Cl\xF4turer le mois",
      confirmTitle: "Cl\xF4turer {month} ?",
      confirmBody: "Une fois ce mois cl\xF4tur\xE9, ces op\xE9rations seront refus\xE9es pour toute date de ce mois :",
      blocks: {
        invoices: "l\u2019\xE9mission de factures et d\u2019avoirs ;",
        payments: "l\u2019enregistrement ou l\u2019annulation d\u2019encaissements clients ;",
        expenses: "les notes de frais ;",
        supplier: "les factures et paiements fournisseurs."
      },
      confirmAfter: "Seule une personne autoris\xE9e \xE0 modifier la fiscalit\xE9 pourra rouvrir le mois, apr\xE8s une v\xE9rification d\u2019identit\xE9.",
      currentMonth: "C\u2019est le mois en cours : plus aucun document ne pourra y \xEAtre dat\xE9 tant qu\u2019il restera cl\xF4tur\xE9.",
      confirmButton: "Cl\xF4turer",
      done: "{month} est cl\xF4tur\xE9."
    },
    list: {
      title: "Mois cl\xF4tur\xE9s"
    },
    tableLabel: "Mois cl\xF4tur\xE9s",
    columns: {
      month: "Mois",
      by: "Cl\xF4tur\xE9 par",
      at: "Cl\xF4tur\xE9 le",
      actions: "Action"
    },
    empty: {
      title: "Aucun mois cl\xF4tur\xE9",
      body: "Quand un mois comptable est termin\xE9, cl\xF4turez-le pour que ses chiffres ne bougent plus."
    },
    reopen: {
      button: "Rouvrir",
      label: "Rouvrir {month}",
      confirmTitle: "Rouvrir {month} ?",
      confirmBody: "Les documents financiers de ce mois pourront de nouveau \xEAtre cr\xE9\xE9s, modifi\xE9s ou annul\xE9s, et les exports d\xE9j\xE0 faits ne correspondront plus forc\xE9ment aux chiffres. L\u2019action est enregistr\xE9e dans le journal d\u2019audit.",
      confirmButton: "Rouvrir le mois",
      done: "{month} est de nouveau ouvert.",
      stepUp: "Confirmez votre identit\xE9 pour rouvrir un mois : vous allez \xEAtre redirig\xE9, puis l\u2019action sera reprise."
    },
    loadFailedTitle: "Impossible de charger les mois cl\xF4tur\xE9s",
    loadFailedBody: "La liste n\u2019a pas pu \xEAtre lue. R\xE9essayez dans un instant."
  },
  accounts: {
    title: "Comptes des journaux",
    intro: "Num\xE9ro du compte utilis\xE9 par chaque ligne des journaux, tel que votre comptable le tient dans son plan comptable. Les num\xE9ros comptent de 2 \xE0 12 chiffres.",
    defaultsTitle: "Comptes par d\xE9faut, \xE0 confirmer",
    defaultsBody: "Ces comptes sont ceux du plan comptable tunisien, propos\xE9s tant que vous n\u2019avez rien enregistr\xE9. Faites-les confirmer par votre expert-comptable, puis enregistrez-les.",
    groups: {
      third: "Tiers",
      results: "Produits et charges",
      vat: "TVA et timbre",
      withholding: "Retenues \xE0 la source",
      treasury: "Tr\xE9sorerie"
    },
    fields: {
      clients: {
        label: "Clients",
        hint: "Cr\xE9ances sur les clients."
      },
      suppliers: {
        label: "Fournisseurs",
        hint: "Dettes envers les fournisseurs."
      },
      sales: {
        label: "Ventes",
        hint: "Produits des factures \xE9mises."
      },
      purchases: {
        label: "Achats",
        hint: "Charges des factures fournisseurs."
      },
      vatCollected: {
        label: "TVA collect\xE9e",
        hint: "TVA des factures \xE9mises."
      },
      vatDeductible: {
        label: "TVA d\xE9ductible",
        hint: "TVA r\xE9cup\xE9rable sur les achats."
      },
      stamp: {
        label: "Droit de timbre",
        hint: "Timbre fiscal des factures."
      },
      withholdingReceivable: {
        label: "Retenues subies",
        hint: "Retenue \xE0 la source et retenue de TVA op\xE9r\xE9es par vos clients : cr\xE9ance sur l\u2019\xC9tat."
      },
      withholdingPayable: {
        label: "Retenues op\xE9r\xE9es",
        hint: "Retenue \xE0 la source op\xE9r\xE9e sur vos fournisseurs : dette envers l\u2019\xC9tat."
      },
      bank: {
        label: "Banque",
        hint: "Encaissements et paiements par banque."
      },
      cash: {
        label: "Caisse",
        hint: "Encaissements et paiements en esp\xE8ces."
      }
    },
    save: "Enregistrer les comptes",
    saving: "Enregistrement\u2026",
    saved: "Comptes enregistr\xE9s.",
    useDefaults: "Remettre les comptes par d\xE9faut",
    staleTitle: "Les comptes ont chang\xE9 entre-temps",
    staleBody: "Quelqu\u2019un d\u2019autre a modifi\xE9 ces comptes. Rechargez-les pour voir la derni\xE8re version, puis refaites vos changements.",
    reload: "Recharger",
    loadFailedTitle: "Impossible de charger les comptes",
    loadFailedBody: "Les comptes n\u2019ont pas pu \xEAtre lus. R\xE9essayez dans un instant.",
    errors: {
      required: "Renseignez un num\xE9ro de compte.",
      invalid: "Un num\xE9ro de compte comporte de 2 \xE0 12 chiffres, sans espace ni lettre."
    }
  },
  tmm: {
    title: "Taux moyen du march\xE9 mon\xE9taire (TMM)",
    intro: "Un taux par mois, utilis\xE9 pour estimer les int\xE9r\xEAts moratoires des factures de vos clients publics. Un mois sans taux reprend le dernier taux connu.",
    add: "Ajouter un taux",
    tableLabel: "Taux du march\xE9 mon\xE9taire par mois",
    columns: {
      month: "Mois",
      rate: "Taux",
      by: "Saisi par",
      at: "Mis \xE0 jour",
      actions: "Actions"
    },
    empty: {
      title: "Aucun taux TMM",
      body: "Ajoutez le taux de chaque mois pour estimer les int\xE9r\xEAts moratoires. Sans taux, l\u2019estimation est incompl\xE8te."
    },
    editLabel: "Modifier le taux de {month}",
    deleteLabel: "Supprimer le taux de {month}",
    deleteTitle: "Supprimer le taux de {month} ?",
    deleteBody: "Les estimations d\u2019int\xE9r\xEAts de ce mois reprendront le dernier taux connu avant lui, ou seront incompl\xE8tes s\u2019il n\u2019y en a pas.",
    deleteConfirm: "Supprimer",
    deleted: "Taux supprim\xE9.",
    saved: "Taux de {month} enregistr\xE9.",
    dialog: {
      title: "Ajouter un taux TMM",
      editTitle: "Modifier le taux TMM",
      month: "Mois",
      monthPlaceholder: "Choisir un mois",
      rate: "Taux mensuel",
      rateHint: "En pourcentage, avec deux d\xE9cimales au plus : 7,49 pour 7,49 %.",
      save: "Enregistrer",
      saving: "Enregistrement\u2026"
    },
    errors: {
      periodRequired: "Choisissez le mois du taux.",
      rateRequired: "Saisissez le taux.",
      rateInvalid: "Saisissez un pourcentage entre 0 et 50, avec deux d\xE9cimales au plus (par exemple 7,49)."
    },
    loadFailedTitle: "Impossible de charger les taux",
    loadFailedBody: "Les taux n\u2019ont pas pu \xEAtre lus. R\xE9essayez dans un instant."
  },
  lateInterest: {
    title: "Int\xE9r\xEAts moratoires (estimation)",
    notice: "Estimation indicative pour votre relance : ce n\u2019est pas un montant factur\xE9 et il n\u2019appara\xEEt sur aucun document.",
    loading: "Calcul de l\u2019estimation\u2026",
    deadline: "Dernier jour sans int\xE9r\xEAt",
    daysLate: "Jours de retard",
    outstanding: "Reste d\xFB",
    interest: "Int\xE9r\xEAts estim\xE9s",
    asOf: "Situation au",
    none: "Non d\xE9termin\xE9",
    notLate: "Le d\xE9lai de paiement n\u2019est pas d\xE9pass\xE9 : aucun int\xE9r\xEAt \xE0 ce jour.",
    paid: "Cette facture est sold\xE9e : il n\u2019y a aucun int\xE9r\xEAt \xE0 estimer.",
    incompleteTitle: "Estimation incompl\xE8te",
    incompleteBody: "Il manque le taux TMM d\u2019un des mois de retard, ces int\xE9r\xEAts ne sont pas compt\xE9s.",
    incompleteLink: "Saisir les taux TMM",
    tableLabel: "Int\xE9r\xEAts estim\xE9s mois par mois",
    columns: {
      period: "P\xE9riode",
      days: "Jours",
      tmm: "Taux TMM",
      interest: "Int\xE9r\xEAts"
    },
    range: "{from} au {to}",
    noRate: "Taux manquant",
    carried: "Taux du mois pr\xE9c\xE9dent",
    total: "Total estim\xE9",
    basis: "Base de calcul : d\xE9lai de {days} jours apr\xE8s la date de la facture, puis int\xE9r\xEAts au TMM major\xE9 de {spread} sur {dayCount} jours par an.",
    basisTmm: "Base de calcul : d\xE9lai de {days} jours apr\xE8s la date de la facture, puis int\xE9r\xEAts au TMM sur {dayCount} jours par an.",
    loadFailedTitle: "Estimation indisponible",
    loadFailedBody: "Les int\xE9r\xEAts moratoires n\u2019ont pas pu \xEAtre estim\xE9s. R\xE9essayez dans un instant."
  }
};

// locales/ar/management.json
var management_default = {
  common: {
    asOf: "\u0627\u0644\u0648\u0636\u0639\u064A\u0629 \u0625\u0644\u0649 \u063A\u0627\u064A\u0629 {date}. \u0627\u0644\u0645\u0628\u0627\u0644\u063A \u0628\u0627\u0644\u062F\u064A\u0646\u0627\u0631 \u0627\u0644\u062A\u0648\u0646\u0633\u064A\u061B \u0644\u0627 \u062A\u064F\u062D\u062A\u0633\u0628 \u0627\u0644\u0641\u0648\u0627\u062A\u064A\u0631 \u0628\u0627\u0644\u0639\u0645\u0644\u0627\u062A \u0627\u0644\u0623\u062C\u0646\u0628\u064A\u0629.",
    scopeProjects: "\u062A\u0634\u0645\u0644 \u0647\u0630\u0647 \u0627\u0644\u0623\u0631\u0642\u0627\u0645 \u0645\u0634\u0627\u0631\u064A\u0639\u0643 \u0641\u0642\u0637\u060C \u0648\u0644\u064A\u0633 \u0627\u0644\u0645\u0643\u062A\u0628 \u0628\u0623\u0643\u0645\u0644\u0647.",
    loadFailedTitle: "\u062A\u0639\u0630\u0651\u0631 \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0623\u0631\u0642\u0627\u0645",
    loadFailedBody: "\u0628\u064A\u0627\u0646\u0627\u062A\u0643 \u0645\u062D\u0641\u0648\u0638\u0629. \u062A\u062D\u0642\u0642 \u0645\u0646 \u0627\u062A\u0635\u0627\u0644\u0643 \u062B\u0645 \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629\u061B \u0648\u0625\u0646 \u0627\u0633\u062A\u0645\u0631\u062A \u0627\u0644\u0645\u0634\u0643\u0644\u0629 \u0641\u062A\u0648\u0627\u0635\u0644 \u0645\u0639 \u0627\u0644\u062F\u0639\u0645.",
    exportPdf: "\u062A\u0635\u062F\u064A\u0631 \u0628\u0635\u064A\u063A\u0629 PDF",
    exportPdfHint: "\u064A\u0641\u062A\u062D \u0646\u0627\u0641\u0630\u0629 \u0627\u0644\u0637\u0628\u0627\u0639\u0629 \u0641\u064A \u0645\u062A\u0635\u0641\u062D\u0643: \u0627\u062E\u062A\u0631 \xAB\u062D\u0641\u0638 \u0628\u0635\u064A\u063A\u0629 PDF\xBB.",
    invoices: "{count, plural, =0 {\u0644\u0627 \u062A\u0648\u062C\u062F \u0641\u0648\u0627\u062A\u064A\u0631} one {\u0641\u0627\u062A\u0648\u0631\u0629 \u0648\u0627\u062D\u062F\u0629} two {\u0641\u0627\u062A\u0648\u0631\u062A\u0627\u0646} few {# \u0641\u0648\u0627\u062A\u064A\u0631} many {# \u0641\u0627\u062A\u0648\u0631\u0629} other {# \u0641\u0627\u062A\u0648\u0631\u0629}}",
    total: "\u0627\u0644\u0645\u062C\u0645\u0648\u0639"
  },
  upgrade: {
    title: "\u0644\u0648\u062D\u0627\u062A \u0627\u0644\u0642\u064A\u0627\u062F\u0629 \u0627\u0644\u0625\u062F\u0627\u0631\u064A\u0629 \u063A\u064A\u0631 \u0645\u0634\u0645\u0648\u0644\u0629 \u0641\u064A \u0639\u0631\u0636\u0643",
    bodyOwner: "\u0627\u0646\u062A\u0642\u0644 \u0625\u0644\u0649 \u0639\u0631\u0636 \u064A\u0634\u0645\u0644 \u0644\u0648\u062D\u0627\u062A \u0627\u0644\u0642\u064A\u0627\u062F\u0629 \u0644\u0645\u062A\u0627\u0628\u0639\u0629 \u0631\u0642\u0645 \u0627\u0644\u0645\u0639\u0627\u0645\u0644\u0627\u062A \u0648\u0627\u0644\u062F\u064A\u0648\u0646 \u0648\u0627\u0644\u062E\u0632\u064A\u0646\u0629 \u0648\u0646\u0633\u0628\u0629 \u0627\u0634\u062A\u063A\u0627\u0644 \u0645\u0643\u062A\u0628\u0643.",
    bodyMember: "\u0644\u0648\u062D\u0627\u062A \u0627\u0644\u0642\u064A\u0627\u062F\u0629 \u0627\u0644\u0625\u062F\u0627\u0631\u064A\u0629 \u063A\u064A\u0631 \u0645\u0634\u0645\u0648\u0644\u0629 \u0641\u064A \u0639\u0631\u0636 \u0645\u0643\u062A\u0628\u0643. \u0627\u0637\u0644\u0628 \u0645\u0646 \u0645\u0627\u0644\u0643 \u0627\u0644\u062D\u0633\u0627\u0628 \u062A\u0631\u0642\u064A\u0629 \u0627\u0644\u0639\u0631\u0636.",
    action: "\u0639\u0631\u0636 \u0627\u0644\u0639\u0631\u0648\u0636"
  },
  dashboard: {
    intro: "\u0627\u0644\u0623\u0631\u0642\u0627\u0645 \u0627\u0644\u0623\u0633\u0627\u0633\u064A\u0629 \u0644\u0645\u0643\u062A\u0628\u0643: \u0627\u0644\u0641\u0648\u062A\u0631\u0629 \u0648\u0627\u0644\u062F\u064A\u0648\u0646 \u0648\u0627\u0644\u0647\u0648\u0627\u0645\u0634 \u0648\u0646\u0633\u0628\u0629 \u0627\u0644\u0627\u0634\u062A\u063A\u0627\u0644 \u0648\u0627\u0644\u0645\u062E\u0631\u062C\u0627\u062A \u0627\u0644\u0645\u062A\u0623\u062E\u0631\u0629 \u0648\u0637\u0644\u0628\u0627\u062A \u0627\u0644\u0639\u0631\u0648\u0636 \u0627\u0644\u062C\u0627\u0631\u064A\u0629.",
    revenue: {
      title: "\u0631\u0642\u0645 \u0627\u0644\u0645\u0639\u0627\u0645\u0644\u0627\u062A",
      hint: "\u0645\u0628\u0627\u0644\u063A \u0627\u0644\u0641\u0648\u0627\u062A\u064A\u0631 \u0645\u0639 \u0627\u062D\u062A\u0633\u0627\u0628 \u0627\u0644\u0623\u062F\u0627\u0621\u0627\u062A \u0648\u0627\u0644\u0645\u0628\u0627\u0644\u063A \u0627\u0644\u0645\u0642\u0628\u0648\u0636\u0629. \u062A\u064F\u0637\u0631\u062D \u0627\u0644\u0625\u0634\u0639\u0627\u0631\u0627\u062A \u0627\u0644\u062F\u0627\u0626\u0646\u0629 \u0645\u0646 \u0627\u0644\u0645\u0628\u0627\u0644\u063A \u0627\u0644\u0645\u0641\u0648\u062A\u0631\u0629.",
      groupLabel: "\u0627\u0644\u0645\u0641\u0648\u062A\u0631 \u0648\u0627\u0644\u0645\u0642\u0628\u0648\u0636",
      monthInvoiced: "\u0627\u0644\u0645\u0641\u0648\u062A\u0631 \u0647\u0630\u0627 \u0627\u0644\u0634\u0647\u0631",
      monthCollected: "\u0627\u0644\u0645\u0642\u0628\u0648\u0636 \u0647\u0630\u0627 \u0627\u0644\u0634\u0647\u0631",
      yearInvoiced: "\u0627\u0644\u0645\u0641\u0648\u062A\u0631 \u0645\u0646\u0630 \u0628\u062F\u0627\u064A\u0629 \u0627\u0644\u0633\u0646\u0629",
      yearCollected: "\u0627\u0644\u0645\u0642\u0628\u0648\u0636 \u0645\u0646\u0630 \u0628\u062F\u0627\u064A\u0629 \u0627\u0644\u0633\u0646\u0629",
      htDetail: "{amount} \u062F\u0648\u0646 \u0627\u062D\u062A\u0633\u0627\u0628 \u0627\u0644\u0623\u062F\u0627\u0621\u0627\u062A",
      chartTitle: "\u0627\u0644\u0645\u0641\u0648\u062A\u0631 \u0648\u0627\u0644\u0645\u0642\u0628\u0648\u0636 \u0639\u0644\u0649 \u0645\u062F\u0649 12 \u0634\u0647\u0631\u064B\u0627",
      chartLabel: "\u0631\u0633\u0645 \u0628\u064A\u0627\u0646\u064A \u0628\u0627\u0644\u0623\u0639\u0645\u062F\u0629 \u0644\u0644\u0645\u0641\u0648\u062A\u0631 \u0648\u0627\u0644\u0645\u0642\u0628\u0648\u0636 \u0645\u0646 {from} \u0625\u0644\u0649 {to}. \u0627\u0644\u0645\u0628\u0627\u0644\u063A \u0627\u0644\u062F\u0642\u064A\u0642\u0629 \u0641\u064A \u0627\u0644\u062C\u062F\u0648\u0644 \u0627\u0644\u0645\u0648\u0627\u0644\u064A.",
      invoiced: "\u0627\u0644\u0645\u0641\u0648\u062A\u0631 (\u0645\u0639 \u0627\u0644\u0623\u062F\u0627\u0621\u0627\u062A)",
      collected: "\u0627\u0644\u0645\u0642\u0628\u0648\u0636",
      tableCaption: "\u0627\u0644\u0645\u0641\u0648\u062A\u0631 \u0648\u0627\u0644\u0645\u0642\u0628\u0648\u0636 \u062D\u0633\u0628 \u0627\u0644\u0634\u0647\u0631\u060C \u0628\u0627\u0644\u062F\u064A\u0646\u0627\u0631 \u0627\u0644\u062A\u0648\u0646\u0633\u064A",
      month: "\u0627\u0644\u0634\u0647\u0631"
    },
    receivables: {
      title: "\u0627\u0644\u062F\u064A\u0648\u0646 \u062D\u0633\u0628 \u0627\u0644\u0642\u0650\u062F\u0645",
      hint: "\u0645\u0627 \u0644\u0627 \u064A\u0632\u0627\u0644 \u062D\u0631\u0641\u0627\u0624\u0643 \u0645\u062F\u064A\u0646\u064A\u0646 \u0628\u0647 \u0644\u0643\u060C \u062D\u0633\u0628 \u0639\u062F\u062F \u0627\u0644\u0623\u064A\u0627\u0645 \u0628\u0639\u062F \u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0627\u0633\u062A\u062D\u0642\u0627\u0642.",
      summary: "\u0627\u0644\u0645\u062C\u0645\u0648\u0639 \u0627\u0644\u0645\u0633\u062A\u062D\u0642: {amount}\u060C \u0645\u0646 {invoices}.",
      none: "\u0644\u0627 \u062A\u0648\u062C\u062F \u062F\u064A\u0648\u0646 \u062C\u0627\u0631\u064A\u0629: \u062C\u0645\u064A\u0639 \u062D\u0631\u0641\u0627\u0626\u0643 \u0641\u064A \u062D\u0627\u0644\u0629 \u0633\u062F\u0627\u062F.",
      chartLabel: "\u0631\u0633\u0645 \u0628\u064A\u0627\u0646\u064A \u0628\u0627\u0644\u0623\u0639\u0645\u062F\u0629 \u0644\u0644\u062F\u064A\u0648\u0646 \u062D\u0633\u0628 \u0627\u0644\u0642\u0650\u062F\u0645. \u0627\u0644\u0645\u0628\u0627\u0644\u063A \u0627\u0644\u062F\u0642\u064A\u0642\u0629 \u0641\u064A \u0627\u0644\u062C\u062F\u0648\u0644 \u0627\u0644\u0645\u0648\u0627\u0644\u064A.",
      amount: "\u0627\u0644\u0645\u0628\u0644\u063A \u0627\u0644\u0645\u0633\u062A\u062D\u0642",
      agingCaption: "\u0627\u0644\u062F\u064A\u0648\u0646 \u062D\u0633\u0628 \u0627\u0644\u0642\u0650\u062F\u0645\u060C \u0628\u0627\u0644\u062F\u064A\u0646\u0627\u0631 \u0627\u0644\u062A\u0648\u0646\u0633\u064A",
      bucket: "\u0627\u0644\u0642\u0650\u062F\u0645",
      buckets: {
        current: "\u063A\u064A\u0631 \u0645\u0633\u062A\u062D\u0642",
        d0_30: "\u0645\u0646 0 \u0625\u0644\u0649 30 \u064A\u0648\u0645\u064B\u0627",
        d31_60: "\u0645\u0646 31 \u0625\u0644\u0649 60 \u064A\u0648\u0645\u064B\u0627",
        d61_90: "\u0645\u0646 61 \u0625\u0644\u0649 90 \u064A\u0648\u0645\u064B\u0627",
        over90: "\u0623\u0643\u062B\u0631 \u0645\u0646 90 \u064A\u0648\u0645\u064B\u0627"
      },
      bucketsShort: {
        current: "\u063A\u064A\u0631 \u0645\u0633\u062A\u062D\u0642",
        d0_30: "0-30 \u064A",
        d31_60: "31-60 \u064A",
        d61_90: "61-90 \u064A",
        over90: "+90 \u064A"
      },
      debtorsTitle: "\u0623\u0643\u0628\u0631 \u0627\u0644\u0645\u062F\u064A\u0646\u064A\u0646",
      debtorsCaption: "\u0627\u0644\u062D\u0631\u0641\u0627\u0621 \u0627\u0644\u062E\u0645\u0633\u0629 \u0627\u0644\u0623\u0643\u062B\u0631 \u062F\u064E\u064A\u0646\u064B\u0627\u060C \u062D\u0633\u0628 \u0627\u0644\u0642\u0650\u062F\u0645\u060C \u0628\u0627\u0644\u062F\u064A\u0646\u0627\u0631 \u0627\u0644\u062A\u0648\u0646\u0633\u064A",
      client: "\u0627\u0644\u062D\u0631\u064A\u0641",
      invoicesColumn: "\u0627\u0644\u0641\u0648\u0627\u062A\u064A\u0631",
      totalDue: "\u0627\u0644\u0645\u062C\u0645\u0648\u0639 \u0627\u0644\u0645\u0633\u062A\u062D\u0642"
    },
    margin: {
      title: "\u0627\u0644\u0647\u0627\u0645\u0634 \u062D\u0633\u0628 \u0627\u0644\u0645\u0634\u0631\u0648\u0639",
      hint: "\u0627\u0644\u0645\u0634\u0627\u0631\u064A\u0639 \u0627\u0644\u0623\u0639\u0644\u0649 \u0631\u0642\u0645 \u0645\u0639\u0627\u0645\u0644\u0627\u062A. \u062A\u062C\u0645\u0639 \u0627\u0644\u0643\u0644\u0641\u0629 \u0627\u0644\u0648\u0642\u062A \u0627\u0644\u0645\u0642\u0636\u064A \u0648\u0645\u0635\u0627\u0631\u064A\u0641 \u0627\u0644\u062A\u0646\u0642\u0644 \u0648\u0627\u0644\u0645\u0646\u0627\u0648\u0644\u0629\u060C \u0644\u0643\u0644 \u0645\u0634\u0631\u0648\u0639.",
      modeInvoiced: "\u064A\u064F\u062D\u062A\u0633\u0628 \u0631\u0642\u0645 \u0627\u0644\u0645\u0639\u0627\u0645\u0644\u0627\u062A \u0645\u0646 \u0627\u0644\u0641\u0648\u0627\u062A\u064A\u0631 \u0627\u0644\u0635\u0627\u062F\u0631\u0629 (\u062F\u0648\u0646 \u0627\u062D\u062A\u0633\u0627\u0628 \u0627\u0644\u0623\u062F\u0627\u0621\u0627\u062A).",
      modeCompletion: "\u064A\u064F\u0639\u062A\u0645\u062F \u0631\u0642\u0645 \u0627\u0644\u0645\u0639\u0627\u0645\u0644\u0627\u062A \u062D\u0633\u0628 \u062A\u0642\u062F\u0651\u0645 \u0643\u0644 \u0645\u0631\u062D\u0644\u0629.",
      projectsCount: "{count, plural, =0 {\u0644\u0627 \u062A\u0648\u062C\u062F \u0645\u0634\u0627\u0631\u064A\u0639 \u0646\u0634\u0637\u0629} one {\u0645\u0634\u0631\u0648\u0639 \u0646\u0634\u0637 \u0648\u0627\u062D\u062F \u0645\u062D\u062A\u0633\u0628 \u0641\u064A \u0627\u0644\u0645\u062C\u0627\u0645\u064A\u0639} two {\u0645\u0634\u0631\u0648\u0639\u0627\u0646 \u0646\u0634\u0637\u0627\u0646 \u0645\u062D\u062A\u0633\u0628\u0627\u0646 \u0641\u064A \u0627\u0644\u0645\u062C\u0627\u0645\u064A\u0639} few {# \u0645\u0634\u0627\u0631\u064A\u0639 \u0646\u0634\u0637\u0629 \u0645\u062D\u062A\u0633\u0628\u0629 \u0641\u064A \u0627\u0644\u0645\u062C\u0627\u0645\u064A\u0639} many {# \u0645\u0634\u0631\u0648\u0639\u064B\u0627 \u0646\u0634\u0637\u064B\u0627 \u0645\u062D\u062A\u0633\u0628\u064B\u0627 \u0641\u064A \u0627\u0644\u0645\u062C\u0627\u0645\u064A\u0639} other {# \u0645\u0634\u0631\u0648\u0639 \u0646\u0634\u0637 \u0645\u062D\u062A\u0633\u0628 \u0641\u064A \u0627\u0644\u0645\u062C\u0627\u0645\u064A\u0639}}",
      unavailable: "\u0645\u062A\u0627\u0628\u0639\u0629 \u0627\u0644\u0645\u0631\u062F\u0648\u062F\u064A\u0629 \u063A\u064A\u0631 \u0645\u0634\u0645\u0648\u0644\u0629 \u0641\u064A \u0639\u0631\u0636\u0643\u060C \u0644\u0630\u0644\u0643 \u0644\u0627 \u062A\u0638\u0647\u0631 \u0627\u0644\u0647\u0648\u0627\u0645\u0634 \u0647\u0646\u0627.",
      empty: "\u0644\u0627 \u064A\u0648\u062C\u062F \u0645\u0634\u0631\u0648\u0639 \u0644\u0647 \u0631\u0642\u0645 \u0645\u0639\u0627\u0645\u0644\u0627\u062A \u0625\u0644\u0649 \u062D\u062F \u0627\u0644\u0622\u0646.",
      caption: "\u0647\u0627\u0645\u0634 \u0627\u0644\u0645\u0634\u0627\u0631\u064A\u0639 \u0627\u0644\u0623\u0639\u0644\u0649 \u0631\u0642\u0645 \u0645\u0639\u0627\u0645\u0644\u0627\u062A\u060C \u0628\u0627\u0644\u062F\u064A\u0646\u0627\u0631 \u0627\u0644\u062A\u0648\u0646\u0633\u064A",
      project: "\u0627\u0644\u0645\u0634\u0631\u0648\u0639",
      revenue: "\u0631\u0642\u0645 \u0627\u0644\u0645\u0639\u0627\u0645\u0644\u0627\u062A",
      cost: "\u0627\u0644\u0643\u0644\u0641\u0629",
      margin: "\u0627\u0644\u0647\u0627\u0645\u0634",
      rate: "\u0646\u0633\u0628\u0629 \u0627\u0644\u0647\u0627\u0645\u0634",
      noRate: "\u062F\u0648\u0646 \u0631\u0642\u0645 \u0645\u0639\u0627\u0645\u0644\u0627\u062A",
      total: "\u0627\u0644\u0645\u062C\u0645\u0648\u0639"
    },
    occupancy: {
      title: "\u0646\u0633\u0628\u0629 \u0627\u0644\u0627\u0634\u062A\u063A\u0627\u0644",
      hint: "\u0627\u0644\u0648\u0642\u062A \u0627\u0644\u0645\u0642\u062F\u064E\u0651\u0645 \u0648\u0627\u0644\u0645\u0635\u0627\u062F\u064E\u0642 \u0639\u0644\u064A\u0647 \u0645\u0646\u0630 \u0628\u062F\u0627\u064A\u0629 \u0627\u0644\u0634\u0647\u0631 \u0645\u0642\u0627\u0631\u0646\u0629 \u0628\u0637\u0627\u0642\u0629 \u0627\u0644\u0641\u0631\u064A\u0642 (\u062F\u0648\u0646 \u0639\u0637\u0644 \u0646\u0647\u0627\u064A\u0629 \u0627\u0644\u0623\u0633\u0628\u0648\u0639 \u0648\u0627\u0644\u0623\u0639\u064A\u0627\u062F \u0648\u0627\u0644\u0625\u062C\u0627\u0632\u0627\u062A).",
      scopeProjects: "\u0627\u0644\u0648\u0642\u062A \u0627\u0644\u0645\u0642\u0636\u064A \u0641\u064A \u0645\u0634\u0627\u0631\u064A\u0639\u0643 \u0645\u0642\u0627\u0631\u0646\u0629 \u0628\u0637\u0627\u0642\u0629 \u0623\u0639\u0636\u0627\u0621 \u0647\u0630\u0647 \u0627\u0644\u0645\u0634\u0627\u0631\u064A\u0639.",
      label: "\u0646\u0633\u0628\u0629 \u0627\u0644\u0627\u0634\u062A\u063A\u0627\u0644 \u0641\u064A {month}",
      worked: "\u0633\u0627\u0639\u0627\u062A \u0627\u0644\u0639\u0645\u0644",
      capacity: "\u0627\u0644\u0637\u0627\u0642\u0629",
      people: "\u0627\u0644\u0623\u0634\u062E\u0627\u0635 \u0627\u0644\u0645\u062D\u062A\u0633\u0628\u0648\u0646",
      noCapacity: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0637\u0627\u0642\u0629 \u0645\u0628\u0631\u0645\u062C\u0629 \u0647\u0630\u0627 \u0627\u0644\u0634\u0647\u0631: \u0644\u0627 \u064A\u0645\u0643\u0646 \u0627\u062D\u062A\u0633\u0627\u0628 \u0627\u0644\u0646\u0633\u0628\u0629.",
      hours: "{hours} \u0633"
    },
    late: {
      title: "\u0627\u0644\u0645\u062E\u0631\u062C\u0627\u062A \u0627\u0644\u0645\u062A\u0623\u062E\u0631\u0629",
      hint: "\u0627\u0644\u0645\u062E\u0631\u062C\u0627\u062A \u0627\u0644\u062A\u064A \u062A\u062C\u0627\u0648\u0632\u062A \u062A\u0627\u0631\u064A\u062E\u0647\u0627 \u0627\u0644\u0645\u0642\u0631\u0631 \u0648\u0644\u0645 \u062A\u062A\u0645 \u0627\u0644\u0645\u0635\u0627\u062F\u0642\u0629 \u0639\u0644\u064A\u0647\u0627 \u0628\u0639\u062F.",
      count: "{count, plural, =0 {\u0644\u0627 \u062A\u0648\u062C\u062F \u0645\u062E\u0631\u062C\u0627\u062A \u0645\u062A\u0623\u062E\u0631\u0629} one {\u0645\u062E\u0631\u062C \u0648\u0627\u062D\u062F \u0645\u062A\u0623\u062E\u0631} two {\u0645\u062E\u0631\u062C\u0627\u0646 \u0645\u062A\u0623\u062E\u0631\u0627\u0646} few {# \u0645\u062E\u0631\u062C\u0627\u062A \u0645\u062A\u0623\u062E\u0631\u0629} many {# \u0645\u062E\u0631\u062C\u064B\u0627 \u0645\u062A\u0623\u062E\u0631\u064B\u0627} other {# \u0645\u062E\u0631\u062C \u0645\u062A\u0623\u062E\u0631}}",
      showing: "\u062A\u064F\u0639\u0631\u0636 {shown} \u0627\u0644\u0623\u0642\u062F\u0645.",
      none: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0645\u062E\u0631\u062C\u0627\u062A \u0645\u062A\u0623\u062E\u0631\u0629: \u0643\u0644 \u0634\u064A\u0621 \u0641\u064A \u0645\u0648\u0639\u062F\u0647.",
      caption: "\u0627\u0644\u0645\u062E\u0631\u062C\u0627\u062A \u0627\u0644\u0645\u062A\u0623\u062E\u0631\u0629\u060C \u0645\u0646 \u0627\u0644\u0623\u0642\u062F\u0645 \u0625\u0644\u0649 \u0627\u0644\u0623\u062D\u062F\u062B",
      deliverable: "\u0627\u0644\u0645\u062E\u0631\u062C",
      project: "\u0627\u0644\u0645\u0634\u0631\u0648\u0639",
      dueOn: "\u0627\u0644\u0645\u0648\u0639\u062F \u0627\u0644\u0645\u0642\u0631\u0631",
      daysLate: "\u0627\u0644\u062A\u0623\u062E\u064A\u0631",
      days: "{count, plural, one {\u064A\u0648\u0645 \u0648\u0627\u062D\u062F \u062A\u0623\u062E\u064A\u0631} two {\u064A\u0648\u0645\u0627\u0646 \u062A\u0623\u062E\u064A\u0631} few {# \u0623\u064A\u0627\u0645 \u062A\u0623\u062E\u064A\u0631} many {# \u064A\u0648\u0645\u064B\u0627 \u062A\u0623\u062E\u064A\u0631} other {# \u064A\u0648\u0645 \u062A\u0623\u062E\u064A\u0631}}"
    },
    tenders: {
      title: "\u0637\u0644\u0628\u0627\u062A \u0627\u0644\u0639\u0631\u0648\u0636 \u0627\u0644\u062C\u0627\u0631\u064A\u0629",
      hint: "\u0637\u0644\u0628\u0627\u062A \u0627\u0644\u0639\u0631\u0648\u0636 \u0627\u0644\u062A\u064A \u0644\u0627 \u062A\u0632\u0627\u0644 \u0645\u0641\u062A\u0648\u062D\u0629\u060C \u062D\u0633\u0628 \u0627\u0644\u0645\u0631\u062D\u0644\u0629. \u0644\u064A\u0633 \u0644\u0637\u0644\u0628 \u0627\u0644\u0639\u0631\u0648\u0636 \u0645\u0628\u0644\u063A \u062A\u0642\u062F\u064A\u0631\u064A: \u064A\u064F\u062A\u0627\u0628\u064E\u0639 \u0627\u0644\u0636\u0645\u0627\u0646 \u0627\u0644\u0648\u0642\u062A\u064A \u0641\u0642\u0637.",
      count: "{count, plural, =0 {\u0644\u0627 \u062A\u0648\u062C\u062F \u0637\u0644\u0628\u0627\u062A \u0639\u0631\u0648\u0636 \u0645\u0641\u062A\u0648\u062D\u0629} one {\u0637\u0644\u0628 \u0639\u0631\u0648\u0636 \u0645\u0641\u062A\u0648\u062D \u0648\u0627\u062D\u062F} two {\u0637\u0644\u0628\u0627 \u0639\u0631\u0648\u0636 \u0645\u0641\u062A\u0648\u062D\u0627\u0646} few {# \u0637\u0644\u0628\u0627\u062A \u0639\u0631\u0648\u0636 \u0645\u0641\u062A\u0648\u062D\u0629} many {# \u0637\u0644\u0628 \u0639\u0631\u0648\u0636 \u0645\u0641\u062A\u0648\u062D\u064B\u0627} other {# \u0637\u0644\u0628 \u0639\u0631\u0648\u0636 \u0645\u0641\u062A\u0648\u062D}}",
      bond: "\u0645\u062C\u0645\u0648\u0639 \u0627\u0644\u0636\u0645\u0627\u0646 \u0627\u0644\u0648\u0642\u062A\u064A: {amount}",
      unavailable: "\u0644\u0627 \u062A\u064F\u0639\u0631\u0636 \u0637\u0644\u0628\u0627\u062A \u0627\u0644\u0639\u0631\u0648\u0636: \u0625\u0645\u0627 \u0623\u0646\u0647\u0627 \u063A\u064A\u0631 \u0645\u0634\u0645\u0648\u0644\u0629 \u0641\u064A \u0639\u0631\u0636\u0643 \u0623\u0648 \u0644\u064A\u0633 \u0644\u0643 \u062D\u0642 \u0627\u0644\u0627\u0637\u0644\u0627\u0639 \u0639\u0644\u064A\u0647\u0627.",
      empty: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0637\u0644\u0628\u0627\u062A \u0639\u0631\u0648\u0636 \u0645\u0641\u062A\u0648\u062D\u0629 \u062D\u0627\u0644\u064A\u064B\u0627.",
      caption: "\u0637\u0644\u0628\u0627\u062A \u0627\u0644\u0639\u0631\u0648\u0636 \u0627\u0644\u0645\u0641\u062A\u0648\u062D\u0629 \u062D\u0633\u0628 \u0627\u0644\u0645\u0631\u062D\u0644\u0629\u060C \u0628\u0627\u0644\u062F\u064A\u0646\u0627\u0631 \u0627\u0644\u062A\u0648\u0646\u0633\u064A",
      stage: "\u0627\u0644\u0645\u0631\u062D\u0644\u0629",
      countColumn: "\u0637\u0644\u0628\u0627\u062A \u0627\u0644\u0639\u0631\u0648\u0636",
      bondColumn: "\u0627\u0644\u0636\u0645\u0627\u0646 \u0627\u0644\u0648\u0642\u062A\u064A",
      stages: {
        watch: "\u0645\u0631\u0627\u0642\u0628\u0629",
        go: "\u0627\u0644\u0645\u0634\u0627\u0631\u0643\u0629",
        preparing: "\u0642\u064A\u062F \u0627\u0644\u0625\u0639\u062F\u0627\u062F",
        submitted: "\u062A\u0645 \u0627\u0644\u0625\u064A\u062F\u0627\u0639"
      }
    }
  },
  treasury: {
    intro: "\u0627\u0644\u0645\u0642\u0628\u0648\u0636\u0627\u062A \u0627\u0644\u0645\u0646\u062A\u0638\u0631\u0629 \u0639\u0644\u0649 \u0645\u062F\u0649 90 \u064A\u0648\u0645\u064B\u0627 \u0627\u0646\u0637\u0644\u0627\u0642\u064B\u0627 \u0645\u0646 \u062A\u0648\u0627\u0631\u064A\u062E \u0627\u0633\u062A\u062D\u0642\u0627\u0642 \u0641\u0648\u0627\u062A\u064A\u0631\u0643\u060C \u0648\u062A\u0627\u0631\u064A\u062E \u0627\u0644\u062F\u0641\u0639 \u0644\u062F\u0649 \u0643\u0644 \u062D\u0631\u064A\u0641\u060C \u0648\u0627\u0644\u0641\u0648\u0627\u062A\u064A\u0631 \u0627\u0644\u062A\u064A \u0644\u0645 \u062A\u0635\u062F\u0631 \u0628\u0639\u062F.",
    range: "\u0627\u0644\u062A\u0648\u0642\u0639\u0627\u062A \u0645\u0646 {from} \u0625\u0644\u0649 {to}. \u0627\u0644\u0645\u0628\u0627\u0644\u063A \u0628\u0627\u0644\u062F\u064A\u0646\u0627\u0631 \u0627\u0644\u062A\u0648\u0646\u0633\u064A\u061B \u0644\u0627 \u062A\u064F\u062D\u062A\u0633\u0628 \u0627\u0644\u0641\u0648\u0627\u062A\u064A\u0631 \u0628\u0627\u0644\u0639\u0645\u0644\u0627\u062A \u0627\u0644\u0623\u062C\u0646\u0628\u064A\u0629.",
    emptyTitle: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0641\u0648\u0627\u062A\u064A\u0631 \u0644\u0644\u0642\u0628\u0636",
    emptyBody: "\u0628\u0645\u062C\u0631\u062F \u0648\u062C\u0648\u062F \u0641\u0648\u0627\u062A\u064A\u0631 \u0635\u0627\u062F\u0631\u0629 \u063A\u064A\u0631 \u0645\u062F\u0641\u0648\u0639\u0629\u060C \u0633\u062A\u0638\u0647\u0631 \u0647\u0646\u0627 \u0627\u0644\u0645\u0642\u0628\u0648\u0636\u0627\u062A \u0627\u0644\u0645\u0646\u062A\u0638\u0631\u0629.",
    figures: {
      title: "\u0627\u0644\u0623\u0631\u0642\u0627\u0645 \u0627\u0644\u0623\u0633\u0627\u0633\u064A\u0629",
      outstanding: "\u0627\u0644\u0645\u062A\u0628\u0642\u064A \u0644\u0644\u0642\u0628\u0636",
      outstandingDetail: "{count, plural, =0 {\u0644\u0627 \u062A\u0648\u062C\u062F \u0641\u0648\u0627\u062A\u064A\u0631 \u0645\u0641\u062A\u0648\u062D\u0629} one {\u0641\u0627\u062A\u0648\u0631\u0629 \u0645\u0641\u062A\u0648\u062D\u0629 \u0648\u0627\u062D\u062F\u0629} two {\u0641\u0627\u062A\u0648\u0631\u062A\u0627\u0646 \u0645\u0641\u062A\u0648\u062D\u062A\u0627\u0646} few {# \u0641\u0648\u0627\u062A\u064A\u0631 \u0645\u0641\u062A\u0648\u062D\u0629} many {# \u0641\u0627\u062A\u0648\u0631\u0629 \u0645\u0641\u062A\u0648\u062D\u0629} other {# \u0641\u0627\u062A\u0648\u0631\u0629 \u0645\u0641\u062A\u0648\u062D\u0629}}",
      expected90: "\u0627\u0644\u0645\u0646\u062A\u0638\u0631 \u062E\u0644\u0627\u0644 90 \u064A\u0648\u0645\u064B\u0627",
      expected90Detail: "\u062D\u0633\u0628 \u0639\u0627\u062F\u0627\u062A \u0627\u0644\u062F\u0641\u0639 \u0644\u062F\u0649 \u0643\u0644 \u062D\u0631\u064A\u0641\u060C \u0628\u0645\u0627 \u0641\u064A \u0630\u0644\u0643 \u0627\u0644\u062A\u0623\u062E\u064A\u0631.",
      contractual90: "\u0627\u0644\u0645\u0633\u062A\u062D\u0642 \u062E\u0644\u0627\u0644 90 \u064A\u0648\u0645\u064B\u0627",
      contractual90Detail: "\u062D\u0633\u0628 \u062A\u0648\u0627\u0631\u064A\u062E \u0627\u0633\u062A\u062D\u0642\u0627\u0642 \u0627\u0644\u0641\u0648\u0627\u062A\u064A\u0631.",
      overdue: "\u0627\u0644\u0645\u0633\u062A\u062D\u0642 \u0641\u0639\u0644\u064B\u0627",
      overdueDetail: "\u0645\u0628\u0644\u063A \u0627\u0646\u0642\u0636\u0649 \u062A\u0627\u0631\u064A\u062E \u0627\u0633\u062A\u062D\u0642\u0627\u0642\u0647 (\u062D\u0633\u0628 \u062A\u0648\u0627\u0631\u064A\u062E \u0627\u0644\u0627\u0633\u062A\u062D\u0642\u0627\u0642).",
      later: "\u0628\u0639\u062F 90 \u064A\u0648\u0645\u064B\u0627",
      laterDetail: "\u0645\u0628\u0644\u063A \u0645\u0646\u062A\u0638\u0631 \u0628\u0639\u062F \u0646\u0647\u0627\u064A\u0629 \u0627\u0644\u0641\u062A\u0631\u0629 (\u062D\u0633\u0628 \u0639\u0627\u062F\u0627\u062A \u0627\u0644\u062F\u0641\u0639)."
    },
    forecast: {
      title: "\u0627\u0644\u0645\u0642\u0628\u0648\u0636\u0627\u062A \u0627\u0644\u0645\u0646\u062A\u0638\u0631\u0629 \u0639\u0644\u0649 \u0645\u062F\u0649 90 \u064A\u0648\u0645\u064B\u0627",
      hint: "\u0627\u0644\u0645\u0628\u0644\u063A \u0627\u0644\u0645\u062A\u0648\u0642\u0639 \u0647\u0648 \u0645\u0627 \u0644\u0627 \u064A\u0632\u0627\u0644 \u0627\u0644\u062D\u0631\u0641\u0627\u0621 \u0645\u062F\u064A\u0646\u064A\u0646 \u0628\u0647\u060C \u0628\u0639\u062F \u0637\u0631\u062D \u0627\u0644\u0627\u0642\u062A\u0637\u0627\u0639\u0627\u062A \u0645\u0646 \u0627\u0644\u0645\u0648\u0631\u062F \u0627\u0644\u0645\u062A\u0628\u0642\u064A\u0629. \u0627\u0644\u0645\u0628\u0644\u063A \xAB\u0627\u0644\u062A\u0639\u0627\u0642\u062F\u064A\xBB \u064A\u062A\u0628\u0639 \u062A\u0627\u0631\u064A\u062E \u0627\u0633\u062A\u062D\u0642\u0627\u0642 \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629\u061B \u0623\u0645\u0627 \xAB\u0627\u0644\u0645\u0646\u062A\u0638\u0631\xBB \u0641\u064A\u0636\u064A\u0641 \u0645\u062A\u0648\u0633\u0637 \u062A\u0623\u062E\u0631 \u0627\u0644\u062D\u0631\u064A\u0641 \u0641\u064A \u0627\u0644\u062F\u0641\u0639 \u0639\u0646\u062F\u0645\u0627 \u064A\u062A\u0623\u062E\u0631.",
      chartLabel: "\u0631\u0633\u0645 \u0628\u064A\u0627\u0646\u064A \u0628\u0627\u0644\u0623\u0639\u0645\u062F\u0629 \u0644\u0644\u0645\u0642\u0628\u0648\u0636\u0627\u062A \u0627\u0644\u062A\u0639\u0627\u0642\u062F\u064A\u0629 \u0648\u0627\u0644\u0645\u0646\u062A\u0638\u0631\u0629 \u0645\u0646 \u0627\u0644\u064A\u0648\u0645 \u0625\u0644\u0649 90 \u064A\u0648\u0645\u064B\u0627\u060C \u062D\u0633\u0628 \u0627\u0644\u0623\u0633\u0628\u0648\u0639. \u0627\u0644\u0645\u0628\u0627\u0644\u063A \u0627\u0644\u062F\u0642\u064A\u0642\u0629 \u0641\u064A \u0627\u0644\u062C\u062F\u0648\u0644 \u0627\u0644\u0645\u0648\u0627\u0644\u064A.",
      contractual: "\u062A\u0639\u0627\u0642\u062F\u064A (\u0627\u0644\u0627\u0633\u062A\u062D\u0642\u0627\u0642)",
      expected: "\u0645\u0646\u062A\u0638\u0631 (\u0645\u0639 \u0645\u062A\u0648\u0633\u0637 \u0627\u0644\u062A\u0623\u062E\u064A\u0631)",
      caption: "\u0627\u0644\u0645\u0642\u0628\u0648\u0636\u0627\u062A \u062D\u0633\u0628 \u0627\u0644\u0641\u062A\u0631\u0629\u060C \u0628\u0627\u0644\u062F\u064A\u0646\u0627\u0631 \u0627\u0644\u062A\u0648\u0646\u0633\u064A",
      period: "\u0627\u0644\u0641\u062A\u0631\u0629",
      invoicesContractual: "\u0627\u0644\u0641\u0648\u0627\u062A\u064A\u0631 (\u062A\u0639\u0627\u0642\u062F\u064A)",
      invoicesExpected: "\u0627\u0644\u0641\u0648\u0627\u062A\u064A\u0631 (\u0645\u0646\u062A\u0638\u0631)",
      overdue: "\u0627\u0644\u0645\u0633\u062A\u062D\u0642 \u0641\u0639\u0644\u064B\u0627",
      overdueShort: "\u0645\u0633\u062A\u062D\u0642",
      later: "\u0628\u0639\u062F 90 \u064A\u0648\u0645\u064B\u0627",
      laterShort: "\u0644\u0627\u062D\u0642\u064B\u0627",
      week: "\u0627\u0644\u0623\u0633\u0628\u0648\u0639 {number}",
      weekShort: "\u0623{number}",
      weekRange: "\u0645\u0646 {from} \u0625\u0644\u0649 {to}",
      total: "\u0627\u0644\u0645\u062C\u0645\u0648\u0639"
    },
    clients: {
      title: "\u062A\u0627\u0631\u064A\u062E \u0627\u0644\u062F\u0641\u0639 \u062D\u0633\u0628 \u0627\u0644\u062D\u0631\u064A\u0641",
      hint: "\u062E\u0644\u0627\u0644 \u0627\u0644\u0623\u0634\u0647\u0631 \u0627\u0644\u064012 \u0627\u0644\u0623\u062E\u064A\u0631\u0629: \u0627\u0644\u0641\u0648\u0627\u062A\u064A\u0631 \u0627\u0644\u0645\u0633\u062F\u064E\u0651\u062F\u0629 \u0628\u0627\u0644\u0643\u0627\u0645\u0644 \u0648\u0645\u062A\u0648\u0633\u0637 \u0627\u0644\u0645\u062F\u0629 \u0628\u064A\u0646 \u0627\u0644\u0627\u0633\u062A\u062D\u0642\u0627\u0642 \u0648\u0627\u0644\u062A\u0633\u062F\u064A\u062F\u060C \u0645\u0631\u062C\u064E\u0651\u062D\u064B\u0627 \u0628\u0627\u0644\u0645\u0628\u0627\u0644\u063A.",
      empty: "\u0644\u0627 \u064A\u0648\u062C\u062F \u062A\u0627\u0631\u064A\u062E \u062F\u0641\u0639 \u0625\u0644\u0649 \u062D\u062F \u0627\u0644\u0622\u0646.",
      caption: "\u062A\u0627\u0631\u064A\u062E \u0627\u0644\u062F\u0641\u0639 \u062D\u0633\u0628 \u0627\u0644\u062D\u0631\u064A\u0641\u060C \u0628\u0627\u0644\u062F\u064A\u0646\u0627\u0631 \u0627\u0644\u062A\u0648\u0646\u0633\u064A",
      client: "\u0627\u0644\u062D\u0631\u064A\u0641",
      paidInvoices: "\u0627\u0644\u0641\u0648\u0627\u062A\u064A\u0631 \u0627\u0644\u0645\u062F\u0641\u0648\u0639\u0629",
      paid: "\u0627\u0644\u0645\u0628\u0644\u063A \u0627\u0644\u0645\u062F\u0641\u0648\u0639",
      delay: "\u0645\u062A\u0648\u0633\u0637 \u0645\u062F\u0629 \u0627\u0644\u062F\u0641\u0639",
      outstanding: "\u0627\u0644\u0645\u062A\u0628\u0642\u064A",
      openInvoices: "\u0627\u0644\u0641\u0648\u0627\u062A\u064A\u0631 \u0627\u0644\u0645\u0641\u062A\u0648\u062D\u0629",
      late: "{count, plural, one {\u064A\u0648\u0645 \u0648\u0627\u062D\u062F \u062A\u0623\u062E\u064A\u0631} two {\u064A\u0648\u0645\u0627\u0646 \u062A\u0623\u062E\u064A\u0631} few {# \u0623\u064A\u0627\u0645 \u062A\u0623\u062E\u064A\u0631} many {# \u064A\u0648\u0645\u064B\u0627 \u062A\u0623\u062E\u064A\u0631} other {# \u064A\u0648\u0645 \u062A\u0623\u062E\u064A\u0631}}",
      early: "{count, plural, one {\u064A\u0648\u0645 \u0648\u0627\u062D\u062F \u0642\u0628\u0644 \u0627\u0644\u0645\u0648\u0639\u062F} two {\u064A\u0648\u0645\u0627\u0646 \u0642\u0628\u0644 \u0627\u0644\u0645\u0648\u0639\u062F} few {# \u0623\u064A\u0627\u0645 \u0642\u0628\u0644 \u0627\u0644\u0645\u0648\u0639\u062F} many {# \u064A\u0648\u0645\u064B\u0627 \u0642\u0628\u0644 \u0627\u0644\u0645\u0648\u0639\u062F} other {# \u064A\u0648\u0645 \u0642\u0628\u0644 \u0627\u0644\u0645\u0648\u0639\u062F}}",
      onTime: "\u062F\u064F\u0641\u0639 \u0641\u064A \u0627\u0644\u0645\u0648\u0639\u062F",
      noHistory: "\u0644\u0627 \u064A\u0648\u062C\u062F \u062A\u0627\u0631\u064A\u062E"
    },
    planned: {
      title: "\u0627\u0644\u0641\u0648\u0627\u062A\u064A\u0631 \u0627\u0644\u0645\u0632\u0645\u0639 \u0625\u0635\u062F\u0627\u0631\u0647\u0627 \u062D\u0633\u0628 \u0627\u0644\u0645\u0631\u0627\u062D\u0644",
      hint: "\u0627\u0644\u0645\u0631\u0627\u062D\u0644 \u0627\u0644\u062A\u064A \u062A\u0646\u062A\u0647\u064A \u062E\u0644\u0627\u0644 90 \u064A\u0648\u0645\u064B\u0627 \u0648\u0644\u0645 \u062A\u064F\u0641\u0648\u062A\u0631 \u0623\u062A\u0639\u0627\u0628\u0647\u0627 \u0643\u0627\u0645\u0644\u0629 \u0628\u0639\u062F. \u0645\u0628\u0627\u0644\u063A \u062A\u0642\u062F\u064A\u0631\u064A\u0629 \u062F\u0648\u0646 \u0627\u062D\u062A\u0633\u0627\u0628 \u0627\u0644\u0623\u062F\u0627\u0621\u0627\u062A\u060C \u062E\u0627\u0631\u062C \u0627\u0644\u0645\u0642\u0628\u0648\u0636\u0627\u062A \u0623\u0639\u0644\u0627\u0647: \u0644\u064A\u0633\u062A \u0641\u0648\u0627\u062A\u064A\u0631 \u0628\u0639\u062F.",
      summary: "{count, plural, =0 {\u0644\u0627 \u062A\u0648\u062C\u062F \u0641\u0648\u0627\u062A\u064A\u0631 \u0644\u0644\u0625\u0635\u062F\u0627\u0631} one {\u0641\u0627\u062A\u0648\u0631\u0629 \u0648\u0627\u062D\u062F\u0629 \u0644\u0644\u0625\u0635\u062F\u0627\u0631} two {\u0641\u0627\u062A\u0648\u0631\u062A\u0627\u0646 \u0644\u0644\u0625\u0635\u062F\u0627\u0631} few {# \u0641\u0648\u0627\u062A\u064A\u0631 \u0644\u0644\u0625\u0635\u062F\u0627\u0631} many {# \u0641\u0627\u062A\u0648\u0631\u0629 \u0644\u0644\u0625\u0635\u062F\u0627\u0631} other {# \u0641\u0627\u062A\u0648\u0631\u0629 \u0644\u0644\u0625\u0635\u062F\u0627\u0631}}\u060C \u0623\u064A {amount} \u062F\u0648\u0646 \u0627\u062D\u062A\u0633\u0627\u0628 \u0627\u0644\u0623\u062F\u0627\u0621\u0627\u062A.",
      showing: "\u062A\u064F\u0639\u0631\u0636 {shown} \u0645\u0631\u0627\u062D\u0644 \u0627\u0644\u0623\u0642\u0631\u0628.",
      empty: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0641\u0648\u0627\u062A\u064A\u0631 \u0644\u0644\u0625\u0635\u062F\u0627\u0631 \u062E\u0644\u0627\u0644 \u0627\u0644\u064090 \u064A\u0648\u0645\u064B\u0627 \u0627\u0644\u0642\u0627\u062F\u0645\u0629.",
      caption: "\u0627\u0644\u0641\u0648\u0627\u062A\u064A\u0631 \u0627\u0644\u0645\u0632\u0645\u0639 \u0625\u0635\u062F\u0627\u0631\u0647\u0627 \u062D\u0633\u0628 \u0627\u0644\u0645\u0631\u0627\u062D\u0644\u060C \u0628\u0627\u0644\u062F\u064A\u0646\u0627\u0631 \u0627\u0644\u062A\u0648\u0646\u0633\u064A \u062F\u0648\u0646 \u0627\u062D\u062A\u0633\u0627\u0628 \u0627\u0644\u0623\u062F\u0627\u0621\u0627\u062A",
      project: "\u0627\u0644\u0645\u0634\u0631\u0648\u0639",
      phase: "\u0627\u0644\u0645\u0631\u062D\u0644\u0629",
      plannedEnd: "\u0627\u0644\u0646\u0647\u0627\u064A\u0629 \u0627\u0644\u0645\u0642\u0631\u0631\u0629",
      amount: "\u0627\u0644\u0645\u0628\u0644\u063A \u0627\u0644\u062A\u0642\u062F\u064A\u0631\u064A \u062F\u0648\u0646 \u0627\u062D\u062A\u0633\u0627\u0628 \u0627\u0644\u0623\u062F\u0627\u0621\u0627\u062A"
    }
  }
};

// locales/en/management.json
var management_default2 = {
  common: {
    asOf: "Position at {date}. Amounts in Tunisian dinars (TND); foreign-currency invoices are not counted.",
    scopeProjects: "These figures cover your projects only, not the whole office.",
    loadFailedTitle: "The figures could not be loaded",
    loadFailedBody: "Your data is safe. Check your connection and try again; if the problem continues, contact support.",
    exportPdf: "Export to PDF",
    exportPdfHint: `Opens your browser's print window: choose "Save as PDF".`,
    invoices: "{count, plural, =0 {No invoices} one {# invoice} other {# invoices}}",
    total: "Total"
  },
  upgrade: {
    title: "Management dashboards are not included in your plan",
    bodyOwner: "Switch to a plan that includes dashboards to follow your office's revenue, receivables, cash flow and occupancy.",
    bodyMember: "Management dashboards are not included in your office's plan. Ask the account owner to upgrade it.",
    action: "See plans"
  },
  dashboard: {
    intro: "Your office's key figures: invoicing, receivables, margins, occupancy, late deliverables and open tenders.",
    revenue: {
      title: "Revenue",
      hint: "Invoiced amounts including VAT and money collected. Credit notes are deducted from the invoiced amounts.",
      groupLabel: "Invoiced and collected",
      monthInvoiced: "Invoiced this month",
      monthCollected: "Collected this month",
      yearInvoiced: "Invoiced year to date",
      yearCollected: "Collected year to date",
      htDetail: "{amount} excl. VAT",
      chartTitle: "Invoiced and collected over 12 months",
      chartLabel: "Bar chart of invoiced and collected amounts from {from} to {to}. The exact amounts are in the table below.",
      invoiced: "Invoiced (incl. VAT)",
      collected: "Collected",
      tableCaption: "Invoiced and collected by month, in TND",
      month: "Month"
    },
    receivables: {
      title: "Receivables by age",
      hint: "What your clients still owe you, by the number of days after the due date.",
      summary: "Total owed: {amount}, across {invoices}.",
      none: "No outstanding receivables: all your clients are up to date.",
      chartLabel: "Bar chart of receivables by age. The exact amounts are in the table below.",
      amount: "Amount owed",
      agingCaption: "Receivables by age, in TND",
      bucket: "Age",
      buckets: {
        current: "Not yet due",
        d0_30: "0 to 30 days",
        d31_60: "31 to 60 days",
        d61_90: "61 to 90 days",
        over90: "Over 90 days"
      },
      bucketsShort: {
        current: "Not due",
        d0_30: "0-30 d",
        d31_60: "31-60 d",
        d61_90: "61-90 d",
        over90: "90+ d"
      },
      debtorsTitle: "Biggest debtors",
      debtorsCaption: "The five clients who owe the most, by age, in TND",
      client: "Client",
      invoicesColumn: "Invoices",
      totalDue: "Total owed"
    },
    margin: {
      title: "Margin by project",
      hint: "The projects with the most revenue. Costs add up time spent, expense claims and subcontracting, per project.",
      modeInvoiced: "Revenue counts issued invoices (excluding VAT).",
      modeCompletion: "Revenue is recognised at the completion of each phase.",
      projectsCount: "{count, plural, =0 {No active projects} one {# active project counted in the totals} other {# active projects counted in the totals}}",
      unavailable: "Profitability tracking is not included in your plan, so margins are not shown here.",
      empty: "No project has any revenue yet.",
      caption: "Margin of the projects with the most revenue, in TND",
      project: "Project",
      revenue: "Revenue",
      cost: "Costs",
      margin: "Margin",
      rate: "Margin rate",
      noRate: "No revenue",
      total: "Total"
    },
    occupancy: {
      title: "Occupancy rate",
      hint: "Submitted and approved time since the start of the month, over the team's capacity (excluding weekends, public holidays and leave).",
      scopeProjects: "Time spent on your projects, over the capacity of those projects' members.",
      label: "Occupancy rate for {month}",
      worked: "Hours worked",
      capacity: "Capacity",
      people: "People counted",
      noCapacity: "No planned capacity this month: the rate cannot be calculated.",
      hours: "{hours} h"
    },
    late: {
      title: "Late deliverables",
      hint: "Deliverables past their due date that are not yet approved.",
      count: "{count, plural, =0 {No late deliverables} one {# late deliverable} other {# late deliverables}}",
      showing: "The {shown} oldest are listed.",
      none: "No late deliverables: everything is on time.",
      caption: "Late deliverables, oldest first",
      deliverable: "Deliverable",
      project: "Project",
      dueOn: "Due on",
      daysLate: "Delay",
      days: "{count, plural, one {# day late} other {# days late}}"
    },
    tenders: {
      title: "Open tenders",
      hint: "Tenders that are still open, by stage. A tender has no estimated amount: only the bid bond is tracked.",
      count: "{count, plural, =0 {No open tenders} one {# open tender} other {# open tenders}}",
      bond: "Total bid bond: {amount}",
      unavailable: "Tenders are not shown: they are not included in your plan, or you do not have permission to view them.",
      empty: "No open tenders at the moment.",
      caption: "Open tenders by stage, in TND",
      stage: "Stage",
      countColumn: "Tenders",
      bondColumn: "Bid bond",
      stages: {
        watch: "Watch",
        go: "Go",
        preparing: "Preparing",
        submitted: "Submitted"
      }
    }
  },
  treasury: {
    intro: "Cash expected over 90 days from your invoices' due dates, each client's payment history and the invoices still to be issued.",
    range: "Forecast from {from} to {to}. Amounts in Tunisian dinars (TND); foreign-currency invoices are not counted.",
    emptyTitle: "No invoices to collect",
    emptyBody: "As soon as issued invoices remain unpaid, the expected cash-in appears here.",
    figures: {
      title: "Key figures",
      outstanding: "Still to collect",
      outstandingDetail: "{count, plural, =0 {No open invoices} one {# open invoice} other {# open invoices}}",
      expected90: "Expected within 90 days",
      expected90Detail: "Based on each client's payment habits, delays included.",
      contractual90: "Due within 90 days",
      contractual90Detail: "Based on the invoices' due dates.",
      overdue: "Already overdue",
      overdueDetail: "Amount whose due date has passed (based on due dates).",
      later: "Beyond 90 days",
      laterDetail: "Amount expected after the end of the period (based on payment habits)."
    },
    forecast: {
      title: "Cash expected over 90 days",
      hint: `The forecast amount is what clients still have to pay, minus the withholdings they will still keep. The "contractual" amount follows the invoice's due date; the "expected" amount adds the client's average payment delay when they pay late.`,
      chartLabel: "Bar chart of contractual and expected cash-in, from today to 90 days, by week. The exact amounts are in the table below.",
      contractual: "Contractual (due date)",
      expected: "Expected (with average delay)",
      caption: "Cash-in by period, in TND",
      period: "Period",
      invoicesContractual: "Invoices (contractual)",
      invoicesExpected: "Invoices (expected)",
      overdue: "Already overdue",
      overdueShort: "Overdue",
      later: "Beyond 90 days",
      laterShort: "Later",
      week: "Week {number}",
      weekShort: "W{number}",
      weekRange: "from {from} to {to}",
      total: "Total"
    },
    clients: {
      title: "Payment history by client",
      hint: "Over the last 12 months: fully settled invoices and the average time between the due date and settlement, weighted by amount.",
      empty: "No payment history yet.",
      caption: "Payment history by client, in TND",
      client: "Client",
      paidInvoices: "Invoices paid",
      paid: "Amount paid",
      delay: "Average payment time",
      outstanding: "Still owed",
      openInvoices: "Open invoices",
      late: "{count, plural, one {# day late} other {# days late}}",
      early: "{count, plural, one {# day early} other {# days early}}",
      onTime: "Paid on the due date",
      noHistory: "No history"
    },
    planned: {
      title: "Invoices to issue from phases",
      hint: "Phases ending within 90 days whose fees are not yet fully invoiced. Estimated amounts excluding VAT, outside the cash-in above: they are not invoices yet.",
      summary: "{count, plural, =0 {No invoices to issue} one {# invoice to issue} other {# invoices to issue}}, i.e. {amount} excl. VAT.",
      showing: "The {shown} nearest phases are listed.",
      empty: "No invoices to issue in the next 90 days.",
      caption: "Invoices to issue from phases, in TND excluding VAT",
      project: "Project",
      phase: "Phase",
      plannedEnd: "Planned end",
      amount: "Estimated amount excl. VAT"
    }
  }
};

// locales/fr/management.json
var management_default3 = {
  common: {
    asOf: "Situation au {date}. Montants en dinars tunisiens (TND) ; les factures en devises ne sont pas compt\xE9es.",
    scopeProjects: "Ces chiffres couvrent uniquement vos projets, pas l\u2019ensemble du bureau.",
    loadFailedTitle: "Les chiffres n\u2019ont pas pu \xEAtre charg\xE9s",
    loadFailedBody: "Vos donn\xE9es ne sont pas perdues. V\xE9rifiez votre connexion puis r\xE9essayez ; si le probl\xE8me continue, contactez le support.",
    exportPdf: "Exporter en PDF",
    exportPdfHint: "Ouvre la fen\xEAtre d\u2019impression de votre navigateur : choisissez \xAB Enregistrer au format PDF \xBB.",
    invoices: "{count, plural, =0 {Aucune facture} one {# facture} other {# factures}}",
    total: "Total"
  },
  upgrade: {
    title: "Les tableaux de bord de pilotage ne sont pas inclus dans votre offre",
    bodyOwner: "Passez \xE0 une offre qui inclut les tableaux de bord pour suivre le chiffre d\u2019affaires, les cr\xE9ances, la tr\xE9sorerie et l\u2019occupation de votre bureau.",
    bodyMember: "Les tableaux de bord de pilotage ne sont pas inclus dans l\u2019offre de votre bureau. Demandez au propri\xE9taire du compte de la faire \xE9voluer.",
    action: "Voir les offres"
  },
  dashboard: {
    intro: "Les chiffres cl\xE9s de votre bureau : facturation, cr\xE9ances, marges, occupation, livrables en retard et appels d\u2019offres en cours.",
    revenue: {
      title: "Chiffre d\u2019affaires",
      hint: "Montants TTC factur\xE9s et sommes encaiss\xE9es. Les avoirs sont d\xE9duits des montants factur\xE9s.",
      groupLabel: "Factur\xE9 et encaiss\xE9",
      monthInvoiced: "Factur\xE9 ce mois-ci",
      monthCollected: "Encaiss\xE9 ce mois-ci",
      yearInvoiced: "Factur\xE9 depuis le d\xE9but de l\u2019ann\xE9e",
      yearCollected: "Encaiss\xE9 depuis le d\xE9but de l\u2019ann\xE9e",
      htDetail: "{amount} HT",
      chartTitle: "Factur\xE9 et encaiss\xE9 sur 12 mois",
      chartLabel: "Histogramme du factur\xE9 et de l\u2019encaiss\xE9 de {from} \xE0 {to}. Les montants exacts figurent dans le tableau qui suit.",
      invoiced: "Factur\xE9 (TTC)",
      collected: "Encaiss\xE9",
      tableCaption: "Factur\xE9 et encaiss\xE9 par mois, en TND",
      month: "Mois"
    },
    receivables: {
      title: "Cr\xE9ances par anciennet\xE9",
      hint: "Ce que vos clients vous doivent encore, selon le nombre de jours apr\xE8s l\u2019\xE9ch\xE9ance.",
      summary: "Total d\xFB : {amount}, sur {invoices}.",
      none: "Aucune cr\xE9ance en cours : tous vos clients sont \xE0 jour.",
      chartLabel: "Histogramme des cr\xE9ances par anciennet\xE9. Les montants exacts figurent dans le tableau qui suit.",
      amount: "Montant d\xFB",
      agingCaption: "Cr\xE9ances par anciennet\xE9, en TND",
      bucket: "Anciennet\xE9",
      buckets: {
        current: "Non \xE9chu",
        d0_30: "0 \xE0 30 jours",
        d31_60: "31 \xE0 60 jours",
        d61_90: "61 \xE0 90 jours",
        over90: "Plus de 90 jours"
      },
      bucketsShort: {
        current: "Non \xE9chu",
        d0_30: "0-30 j",
        d31_60: "31-60 j",
        d61_90: "61-90 j",
        over90: "+90 j"
      },
      debtorsTitle: "Principaux d\xE9biteurs",
      debtorsCaption: "Les cinq clients qui doivent le plus, par anciennet\xE9, en TND",
      client: "Client",
      invoicesColumn: "Factures",
      totalDue: "Total d\xFB"
    },
    margin: {
      title: "Marge par projet",
      hint: "Les projets qui ont le plus de chiffre d\u2019affaires. Les co\xFBts r\xE9unissent le temps pass\xE9, les notes de frais et la sous-traitance, par projet.",
      modeInvoiced: "Le chiffre d\u2019affaires compte les factures \xE9mises (hors taxes).",
      modeCompletion: "Le chiffre d\u2019affaires est reconnu \xE0 l\u2019avancement de chaque phase.",
      projectsCount: "{count, plural, =0 {Aucun projet actif} one {# projet actif compt\xE9 dans les totaux} other {# projets actifs compt\xE9s dans les totaux}}",
      unavailable: "Le suivi de rentabilit\xE9 n\u2019est pas inclus dans votre offre : les marges ne sont donc pas affich\xE9es ici.",
      empty: "Aucun projet avec du chiffre d\u2019affaires pour le moment.",
      caption: "Marge des projets qui ont le plus de chiffre d\u2019affaires, en TND",
      project: "Projet",
      revenue: "Chiffre d\u2019affaires",
      cost: "Co\xFBts",
      margin: "Marge",
      rate: "Taux de marge",
      noRate: "Sans chiffre d\u2019affaires",
      total: "Total"
    },
    occupancy: {
      title: "Taux d\u2019occupation",
      hint: "Temps soumis et approuv\xE9 depuis le d\xE9but du mois, rapport\xE9 \xE0 la capacit\xE9 de l\u2019\xE9quipe (hors week-ends, jours f\xE9ri\xE9s et cong\xE9s).",
      scopeProjects: "Temps pass\xE9 sur vos projets, rapport\xE9 \xE0 la capacit\xE9 des membres de ces projets.",
      label: "Taux d\u2019occupation de {month}",
      worked: "Heures travaill\xE9es",
      capacity: "Capacit\xE9",
      people: "Personnes compt\xE9es",
      noCapacity: "Aucune capacit\xE9 planifi\xE9e ce mois-ci : le taux ne peut pas \xEAtre calcul\xE9.",
      hours: "{hours} h"
    },
    late: {
      title: "Livrables en retard",
      hint: "Livrables dont la date pr\xE9vue est d\xE9pass\xE9e et qui ne sont pas encore approuv\xE9s.",
      count: "{count, plural, =0 {Aucun livrable en retard} one {# livrable en retard} other {# livrables en retard}}",
      showing: "Les {shown} plus anciens sont list\xE9s.",
      none: "Aucun livrable en retard : tout est dans les temps.",
      caption: "Livrables en retard, du plus ancien au plus r\xE9cent",
      deliverable: "Livrable",
      project: "Projet",
      dueOn: "Pr\xE9vu le",
      daysLate: "Retard",
      days: "{count, plural, one {# jour de retard} other {# jours de retard}}"
    },
    tenders: {
      title: "Appels d\u2019offres en cours",
      hint: "Appels d\u2019offres encore ouverts, par \xE9tape. Un appel d\u2019offres n\u2019a pas de montant estim\xE9 : seul le cautionnement provisoire est suivi.",
      count: "{count, plural, =0 {Aucun appel d\u2019offres ouvert} one {# appel d\u2019offres ouvert} other {# appels d\u2019offres ouverts}}",
      bond: "Cautionnement total : {amount}",
      unavailable: "Les appels d\u2019offres ne sont pas affich\xE9s : ils ne sont pas inclus dans votre offre, ou vous n\u2019avez pas le droit de les consulter.",
      empty: "Aucun appel d\u2019offres ouvert pour le moment.",
      caption: "Appels d\u2019offres ouverts par \xE9tape, en TND",
      stage: "\xC9tape",
      countColumn: "Appels d\u2019offres",
      bondColumn: "Cautionnement provisoire",
      stages: {
        watch: "Veille",
        go: "Go",
        preparing: "En pr\xE9paration",
        submitted: "D\xE9pos\xE9"
      }
    }
  },
  treasury: {
    intro: "Les encaissements attendus sur 90 jours \xE0 partir des \xE9ch\xE9ances de vos factures, l\u2019historique de paiement de chaque client et les factures qu\u2019il reste \xE0 \xE9mettre.",
    range: "Pr\xE9vision du {from} au {to}. Montants en dinars tunisiens (TND) ; les factures en devises ne sont pas compt\xE9es.",
    emptyTitle: "Aucune facture \xE0 encaisser",
    emptyBody: "D\xE8s que des factures \xE9mises restent \xE0 payer, les encaissements attendus appara\xEEtront ici.",
    figures: {
      title: "Chiffres cl\xE9s",
      outstanding: "Reste \xE0 encaisser",
      outstandingDetail: "{count, plural, =0 {Aucune facture ouverte} one {# facture ouverte} other {# factures ouvertes}}",
      expected90: "Attendu sous 90 jours",
      expected90Detail: "Selon les habitudes de paiement de chaque client, retards compris.",
      contractual90: "D\xFB sous 90 jours",
      contractual90Detail: "Selon les \xE9ch\xE9ances des factures.",
      overdue: "D\xE9j\xE0 \xE9chu",
      overdueDetail: "Montant dont l\u2019\xE9ch\xE9ance est pass\xE9e (selon les \xE9ch\xE9ances).",
      later: "Au-del\xE0 de 90 jours",
      laterDetail: "Montant attendu apr\xE8s la fin de la p\xE9riode (selon les habitudes de paiement)."
    },
    forecast: {
      title: "Encaissements attendus sur 90 jours",
      hint: "Le montant pr\xE9vu est ce que les clients doivent encore payer, retenues \xE0 la source restantes d\xE9duites. Le montant \xAB contractuel \xBB suit l\u2019\xE9ch\xE9ance de la facture ; le montant \xAB attendu \xBB ajoute le retard moyen de paiement du client, quand il paie en retard.",
      chartLabel: "Histogramme des encaissements contractuels et attendus, d\u2019aujourd\u2019hui \xE0 90 jours, par semaine. Les montants exacts figurent dans le tableau qui suit.",
      contractual: "Contractuel (\xE9ch\xE9ance)",
      expected: "Attendu (avec le retard moyen)",
      caption: "Encaissements par p\xE9riode, en TND",
      period: "P\xE9riode",
      invoicesContractual: "Factures (contractuel)",
      invoicesExpected: "Factures (attendu)",
      overdue: "D\xE9j\xE0 \xE9chu",
      overdueShort: "\xC9chu",
      later: "Au-del\xE0 de 90 jours",
      laterShort: "Plus tard",
      week: "Semaine {number}",
      weekShort: "S{number}",
      weekRange: "du {from} au {to}",
      total: "Total"
    },
    clients: {
      title: "Historique de paiement par client",
      hint: "Sur les 12 derniers mois : les factures enti\xE8rement r\xE9gl\xE9es et le d\xE9lai moyen entre l\u2019\xE9ch\xE9ance et le r\xE8glement, pond\xE9r\xE9 par les montants.",
      empty: "Aucun historique de paiement pour le moment.",
      caption: "Historique de paiement par client, en TND",
      client: "Client",
      paidInvoices: "Factures pay\xE9es",
      paid: "Montant pay\xE9",
      delay: "D\xE9lai de paiement moyen",
      outstanding: "Reste d\xFB",
      openInvoices: "Factures ouvertes",
      late: "{count, plural, one {# jour de retard} other {# jours de retard}}",
      early: "{count, plural, one {# jour d\u2019avance} other {# jours d\u2019avance}}",
      onTime: "Pay\xE9 \xE0 l\u2019\xE9ch\xE9ance",
      noHistory: "Pas d\u2019historique"
    },
    planned: {
      title: "Factures \xE0 \xE9mettre selon les phases",
      hint: "Phases qui se terminent dans les 90 jours et dont les honoraires ne sont pas encore enti\xE8rement factur\xE9s. Montants estim\xE9s hors taxes, en dehors des encaissements ci-dessus : ce ne sont pas encore des factures.",
      summary: "{count, plural, =0 {Aucune facture \xE0 \xE9mettre} one {# facture \xE0 \xE9mettre} other {# factures \xE0 \xE9mettre}}, soit {amount} HT.",
      showing: "Les {shown} phases les plus proches sont list\xE9es.",
      empty: "Aucune facture \xE0 \xE9mettre dans les 90 prochains jours.",
      caption: "Factures \xE0 \xE9mettre selon les phases, en TND hors taxes",
      project: "Projet",
      phase: "Phase",
      plannedEnd: "Fin pr\xE9vue",
      amount: "Montant estim\xE9 HT"
    }
  }
};

// locales/ar/signatures.json
var signatures_default = {
  title: "\u0627\u0644\u062A\u0648\u0642\u064A\u0639\u0627\u062A",
  tabs: {
    label: "\u0635\u0646\u0627\u062F\u064A\u0642 \u0627\u0644\u062A\u0648\u0642\u064A\u0639",
    to_sign: "\u0644\u0644\u062A\u0648\u0642\u064A\u0639",
    sent: "\u0627\u0644\u0645\u0631\u0633\u064E\u0644\u0629"
  },
  filter: {
    label: "\u0627\u0644\u062D\u0627\u0644\u0629",
    all: "\u0643\u0644 \u0627\u0644\u062D\u0627\u0644\u0627\u062A"
  },
  statuses: {
    pending: "\u0642\u064A\u062F \u0627\u0644\u0627\u0646\u062A\u0638\u0627\u0631",
    completed: "\u0645\u0648\u0642\u064E\u0651\u0639",
    declined: "\u0645\u0631\u0641\u0648\u0636",
    cancelled: "\u0645\u0644\u063A\u0649",
    expired: "\u0645\u0646\u062A\u0647\u064A \u0627\u0644\u0635\u0644\u0627\u062D\u064A\u0629"
  },
  signerStatuses: {
    pending: "\u0644\u0644\u062A\u0648\u0642\u064A\u0639",
    signed: "\u0648\u0642\u0651\u0639",
    declined: "\u0631\u0641\u0636"
  },
  levels: {
    simple: "\u062A\u0648\u0642\u064A\u0639 \u0628\u0633\u064A\u0637",
    qualified: "\u062A\u0648\u0642\u064A\u0639 \u0645\u0624\u0647\u064E\u0651\u0644",
    help: {
      simple: "\u064A\u0624\u0643\u062F \u0631\u0645\u0632 \u064A\u064F\u0633\u062A\u0639\u0645\u0644 \u0645\u0631\u0629 \u0648\u0627\u062D\u062F\u0629 \u0648\u064A\u064F\u0631\u0633\u0644 \u0628\u0627\u0644\u0628\u0631\u064A\u062F \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A \u0647\u0648\u064A\u0629 \u0627\u0644\u0645\u0648\u0642\u0650\u0651\u0639. \u0648\u062A\u064F\u062D\u0641\u0638 \u0627\u0644\u0623\u062F\u0644\u0629 (\u0645\u0646 \u0648\u0642\u0651\u0639 \u0648\u0645\u062A\u0649 \u0648\u0623\u064A \u0645\u0644\u0641) \u0641\u064A \u0634\u0647\u0627\u062F\u0629 \u0625\u062B\u0628\u0627\u062A.",
      qualified: "\u064A\u062A\u0645 \u0627\u0644\u062A\u0648\u0642\u064A\u0639 \u0639\u0628\u0631 \u0645\u0646\u0635\u0629 \u0645\u0648\u062B\u0648\u0642\u0629 \u0645\u0639\u062A\u0645\u062F\u0629 \u0628\u0634\u0647\u0627\u062F\u0629 \u0627\u0644\u0645\u0648\u0642\u0650\u0651\u0639. \u0648\u0647\u0648 \u0627\u0644\u0623\u0639\u0644\u0649 \u0642\u064A\u0645\u0629\u060C \u0644\u0643\u0646\u0647 \u064A\u0639\u062A\u0645\u062F \u0639\u0644\u0649 \u062E\u062F\u0645\u0629 \u0627\u0644\u0645\u0646\u0635\u0629."
    }
  },
  hash: {
    copy: "\u0646\u0633\u062E \u0628\u0635\u0645\u0629 SHA-256 \u200F{hash}",
    copied: "\u062A\u0645 \u0646\u0633\u062E \u0627\u0644\u0628\u0635\u0645\u0629.",
    copyFailed: "\u062A\u0639\u0630\u0651\u0631 \u0646\u0633\u062E \u0627\u0644\u0628\u0635\u0645\u0629. \u062D\u062F\u0651\u062F\u0647\u0627 \u064A\u062F\u0648\u064A\u0627."
  },
  list: {
    label: {
      to_sign: "\u0627\u0644\u0637\u0644\u0628\u0627\u062A \u0627\u0644\u0645\u0637\u0644\u0648\u0628 \u062A\u0648\u0642\u064A\u0639\u0647\u0627",
      sent: "\u0627\u0644\u0637\u0644\u0628\u0627\u062A \u0627\u0644\u0645\u0631\u0633\u064E\u0644\u0629"
    },
    loadFailedTitle: "\u062A\u0639\u0630\u0651\u0631 \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0637\u0644\u0628\u0627\u062A",
    loadFailedBody: "\u062A\u062D\u0642\u0642 \u0645\u0646 \u0627\u062A\u0635\u0627\u0644\u0643 \u062B\u0645 \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629.",
    document: "\u0627\u0644\u0648\u062B\u064A\u0642\u0629: {name}",
    by: "\u0637\u0644\u0628 \u0645\u0646 {name}",
    expiresOn: "\u062A\u0646\u062A\u0647\u064A \u0641\u064A {date}",
    expiredOn: "\u0627\u0646\u062A\u0647\u062A \u0641\u064A {date}",
    completedOn: "\u0627\u0643\u062A\u0645\u0644\u062A \u0641\u064A {date}",
    createdOn: "\u0623\u064F\u0646\u0634\u0626\u062A \u0641\u064A {date}",
    yourTurn: "\u062D\u0627\u0646 \u062F\u0648\u0631\u0643 \u0644\u0644\u062A\u0648\u0642\u064A\u0639",
    progress: "{signed} / {total} \u0648\u0642\u0651\u0639\u0648\u0627",
    empty: {
      filteredTitle: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0637\u0644\u0628\u0627\u062A \u0628\u0647\u0630\u0647 \u0627\u0644\u062D\u0627\u0644\u0629",
      filteredBody: "\u0644\u0627 \u064A\u0648\u062C\u062F \u0641\u064A \u0647\u0630\u0627 \u0627\u0644\u0635\u0646\u062F\u0648\u0642 \u0623\u064A \u0637\u0644\u0628 \u0628\u062D\u0627\u0644\u0629 \xAB{status}\xBB.",
      clear: "\u0639\u0631\u0636 \u0643\u0644 \u0627\u0644\u062D\u0627\u0644\u0627\u062A",
      to_sign: {
        title: "\u0644\u0627 \u0634\u064A\u0621 \u0644\u0644\u062A\u0648\u0642\u064A\u0639 \u062D\u0627\u0644\u064A\u0627",
        body: "\u0633\u062A\u0638\u0647\u0631 \u0647\u0646\u0627 \u0627\u0644\u0637\u0644\u0628\u0627\u062A \u0627\u0644\u062A\u064A \u062A\u0646\u062A\u0638\u0631 \u062A\u0648\u0642\u064A\u0639\u0643."
      },
      sent: {
        title: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0637\u0644\u0628\u0627\u062A \u0645\u0631\u0633\u064E\u0644\u0629",
        body: "\u0644\u0637\u0644\u0628 \u062A\u0648\u0642\u064A\u0639 \u0648\u062B\u064A\u0642\u0629\u060C \u0627\u0641\u062A\u062D\u0647\u0627 \u0641\u064A \u0627\u0644\u0645\u0644\u0641\u0627\u062A \u062B\u0645 \u0627\u062E\u062A\u0631 \xAB\u0637\u0644\u0628 \u062A\u0648\u0642\u064A\u0639\xBB."
      }
    }
  },
  request: {
    crumb: "\u0637\u0644\u0628",
    back: "\u0627\u0644\u0639\u0648\u062F\u0629 \u0625\u0644\u0649 \u0627\u0644\u062A\u0648\u0642\u064A\u0639\u0627\u062A",
    notFoundTitle: "\u0627\u0644\u0637\u0644\u0628 \u063A\u064A\u0631 \u0645\u0648\u062C\u0648\u062F",
    notFoundBody: "\u0647\u0630\u0627 \u0627\u0644\u0637\u0644\u0628 \u063A\u064A\u0631 \u0645\u0648\u062C\u0648\u062F \u0623\u0648 \u0644\u0627 \u064A\u062E\u0635\u0651\u0643.",
    loadFailedTitle: "\u062A\u0639\u0630\u0651\u0631 \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0637\u0644\u0628",
    loadFailedBody: "\u062A\u062D\u0642\u0642 \u0645\u0646 \u0627\u062A\u0635\u0627\u0644\u0643 \u062B\u0645 \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629."
  },
  facts: {
    title: "\u0627\u0644\u0648\u062B\u064A\u0642\u0629 \u0627\u0644\u0645\u0637\u0644\u0648\u0628 \u062A\u0648\u0642\u064A\u0639\u0647\u0627",
    titleSigned: "\u0627\u0644\u0648\u062B\u064A\u0642\u0629 \u0627\u0644\u0645\u0648\u0642\u0651\u0639\u0629",
    document: "\u0627\u0644\u0648\u062B\u064A\u0642\u0629",
    revision: "\u0627\u0644\u0645\u0631\u0627\u062C\u0639\u0629 {revision}",
    noRevision: "\u0628\u062F\u0648\u0646 \u0645\u0631\u0627\u062C\u0639\u0629",
    requester: "\u0637\u0644\u0628 \u0645\u0646",
    level: "\u0645\u0633\u062A\u0648\u0649 \u0627\u0644\u062A\u0648\u0642\u064A\u0639",
    created: "\u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0625\u0646\u0634\u0627\u0621",
    expires: "\u0635\u0627\u0644\u062D \u062D\u062A\u0649",
    completed: "\u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0627\u0643\u062A\u0645\u0627\u0644",
    sha256: "\u0628\u0635\u0645\u0629 SHA-256 \u0644\u0644\u0645\u0644\u0641",
    sha256Help: "\u062A\u062D\u062F\u0651\u062F \u0627\u0644\u0628\u0635\u0645\u0629 \u0627\u0644\u0645\u0644\u0641 \u0627\u0644\u0645\u0648\u0642\u064E\u0651\u0639 \u0628\u062F\u0642\u0629: \u0625\u0630\u0627 \u062A\u063A\u064A\u0651\u0631 \u0627\u0644\u0645\u0644\u0641 \u062A\u062A\u063A\u064A\u0651\u0631 \u0627\u0644\u0628\u0635\u0645\u0629.",
    message: "\u0631\u0633\u0627\u0644\u0629 \u0635\u0627\u062D\u0628 \u0627\u0644\u0637\u0644\u0628"
  },
  signers: {
    title: "\u0627\u0644\u0645\u0648\u0642\u0650\u0651\u0639\u0648\u0646",
    list: "\u0645\u0648\u0642\u0650\u0651\u0639\u0648 \u0627\u0644\u0637\u0644\u0628",
    you: "\u0623\u0646\u062A",
    signedOn: "\u0648\u0642\u0651\u0639 \u0641\u064A {date}.",
    declinedOn: "\u0631\u0641\u0636 \u0641\u064A {date}.",
    reason: "\u0627\u0644\u0633\u0628\u0628: {reason}",
    certificate: "\u0627\u0644\u0634\u0647\u0627\u062F\u0629: {subject}"
  },
  state: {
    completed: "\u0648\u0642\u0651\u0639 \u062C\u0645\u064A\u0639 \u0627\u0644\u0645\u0648\u0642\u0650\u0651\u0639\u064A\u0646 \u0641\u064A {date}. \u0634\u0647\u0627\u062F\u0629 \u0627\u0644\u0625\u062B\u0628\u0627\u062A \u0623\u062F\u0646\u0627\u0647.",
    declined: "\u0631\u0641\u0636 {name} \u0627\u0644\u062A\u0648\u0642\u064A\u0639: \u0627\u0646\u062A\u0647\u0649 \u0627\u0644\u0637\u0644\u0628. \u0627\u0644\u0633\u0628\u0628 \u0645\u0630\u0643\u0648\u0631 \u0641\u064A \u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u0645\u0648\u0642\u0650\u0651\u0639\u064A\u0646. \u0644\u0625\u0639\u0627\u062F\u0629 \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629\u060C \u0642\u062F\u0651\u0645 \u0637\u0644\u0628\u0627 \u062C\u062F\u064A\u062F\u0627 \u0645\u0646 \u0627\u0644\u0648\u062B\u064A\u0642\u0629.",
    cancelled: "\u0623\u0644\u063A\u0649 {name} \u0647\u0630\u0627 \u0627\u0644\u0637\u0644\u0628: \u0644\u0645 \u064A\u0639\u062F \u0628\u0625\u0645\u0643\u0627\u0646 \u0623\u062D\u062F \u062A\u0648\u0642\u064A\u0639\u0647.",
    expired: "\u0627\u0646\u062A\u0647\u062A \u0635\u0644\u0627\u062D\u064A\u0629 \u0647\u0630\u0627 \u0627\u0644\u0637\u0644\u0628 \u0641\u064A {date}: \u0644\u0645 \u064A\u0639\u062F \u0628\u0627\u0644\u0625\u0645\u0643\u0627\u0646 \u062A\u0648\u0642\u064A\u0639\u0647. \u0627\u0637\u0644\u0628 \u0645\u0646 \u0635\u0627\u062D\u0628\u0647 \u062A\u0642\u062F\u064A\u0645 \u0637\u0644\u0628 \u062C\u062F\u064A\u062F.",
    expiredRequester: "\u0627\u0646\u062A\u0647\u062A \u0635\u0644\u0627\u062D\u064A\u0629 \u0647\u0630\u0627 \u0627\u0644\u0637\u0644\u0628 \u0641\u064A {date}: \u0644\u0645 \u064A\u0639\u062F \u0628\u0627\u0644\u0625\u0645\u0643\u0627\u0646 \u062A\u0648\u0642\u064A\u0639\u0647. \u0642\u062F\u0651\u0645 \u0637\u0644\u0628\u0627 \u062C\u062F\u064A\u062F\u0627 \u0645\u0646 \u0627\u0644\u0648\u062B\u064A\u0642\u0629.",
    youSigned: "{count, plural, =0 {\u0644\u0642\u062F \u0648\u0642\u0651\u0639\u062A.} one {\u0644\u0642\u062F \u0648\u0642\u0651\u0639\u062A. \u0628\u0642\u064A \u0645\u0648\u0642\u0650\u0651\u0639 \u0648\u0627\u062D\u062F.} two {\u0644\u0642\u062F \u0648\u0642\u0651\u0639\u062A. \u0628\u0642\u064A \u0645\u0648\u0642\u0650\u0651\u0639\u0627\u0646.} few {\u0644\u0642\u062F \u0648\u0642\u0651\u0639\u062A. \u0628\u0642\u064A # \u0645\u0648\u0642\u0650\u0651\u0639\u064A\u0646.} many {\u0644\u0642\u062F \u0648\u0642\u0651\u0639\u062A. \u0628\u0642\u064A # \u0645\u0648\u0642\u0650\u0651\u0639\u0627.} other {\u0644\u0642\u062F \u0648\u0642\u0651\u0639\u062A. \u0628\u0642\u064A # \u0645\u0648\u0642\u0650\u0651\u0639.}}",
    yourTurn: "\u0647\u0630\u0647 \u0627\u0644\u0648\u062B\u064A\u0642\u0629 \u062A\u0646\u062A\u0638\u0631 \u062A\u0648\u0642\u064A\u0639\u0643 \u062D\u062A\u0649 {date}.",
    waiting: "{count, plural, =0 {\u0644\u0627 \u064A\u064F\u0646\u062A\u0638\u0631 \u0623\u064A \u062A\u0648\u0642\u064A\u0639.} one {\u0641\u064A \u0627\u0646\u062A\u0638\u0627\u0631 \u0645\u0648\u0642\u0650\u0651\u0639 \u0648\u0627\u062D\u062F \u062D\u062A\u0649 {date}.} two {\u0641\u064A \u0627\u0646\u062A\u0638\u0627\u0631 \u0645\u0648\u0642\u0650\u0651\u0639\u064A\u0646 \u062D\u062A\u0649 {date}.} few {\u0641\u064A \u0627\u0646\u062A\u0638\u0627\u0631 # \u0645\u0648\u0642\u0650\u0651\u0639\u064A\u0646 \u062D\u062A\u0649 {date}.} many {\u0641\u064A \u0627\u0646\u062A\u0638\u0627\u0631 # \u0645\u0648\u0642\u0650\u0651\u0639\u0627 \u062D\u062A\u0649 {date}.} other {\u0641\u064A \u0627\u0646\u062A\u0638\u0627\u0631 # \u0645\u0648\u0642\u0650\u0651\u0639 \u062D\u062A\u0649 {date}.}}"
  },
  sign: {
    title: "\u062A\u0648\u0642\u064A\u0639\u0643",
    intro: "\u0644\u0644\u062A\u0648\u0642\u064A\u0639\u060C \u0627\u062D\u0635\u0644 \u0623\u0648\u0644\u0627 \u0639\u0644\u0649 \u0631\u0645\u0632 \u064A\u064F\u0633\u062A\u0639\u0645\u0644 \u0645\u0631\u0629 \u0648\u0627\u062D\u062F\u0629 \u062B\u0645 \u0623\u062F\u062E\u0644\u0647. \u064A\u064F\u0633\u062C\u064E\u0651\u0644 \u0639\u0646\u0648\u0627\u0646 IP \u0648\u0627\u0644\u0645\u062A\u0635\u0641\u062D \u0643\u062F\u0644\u064A\u0644.",
    receive: "\u0627\u0644\u062D\u0635\u0648\u0644 \u0639\u0644\u0649 \u0631\u0645\u0632",
    sending: "\u062C\u0627\u0631\u064D \u0625\u0631\u0633\u0627\u0644 \u0627\u0644\u0631\u0645\u0632\u2026",
    sentTo: "\u0623\u064F\u0631\u0633\u0644 \u0631\u0645\u0632 \u0645\u0646 6 \u0623\u0631\u0642\u0627\u0645 \u0625\u0644\u0649 {address} ({channel}). \u0647\u0648 \u0635\u0627\u0644\u062D \u062D\u062A\u0649 {time}.",
    sentEarlier: "\u0623\u064F\u0631\u0633\u0644 \u0625\u0644\u064A\u0643 \u0631\u0645\u0632 \u0641\u064A {time}. \u0623\u062F\u062E\u0644\u0647 \u0623\u062F\u0646\u0627\u0647 \u0623\u0648 \u0627\u0637\u0644\u0628 \u0631\u0645\u0632\u0627 \u062C\u062F\u064A\u062F\u0627.",
    channels: {
      email: "\u0628\u0627\u0644\u0628\u0631\u064A\u062F \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A",
      sms: "\u0628\u0631\u0633\u0627\u0644\u0629 \u0646\u0635\u064A\u0629",
      app: "\u0641\u064A \u062A\u0637\u0628\u064A\u0642 \u0627\u0644\u062A\u0648\u0642\u064A\u0639"
    },
    codeLabel: "\u0631\u0645\u0632 \u0645\u0646 6 \u0623\u0631\u0642\u0627\u0645",
    codeHint: "\u0623\u062F\u062E\u0644 \u0627\u0644\u0631\u0645\u0632 \u0627\u0644\u0645\u0633\u062A\u0644\u0645 \u0628\u062F\u0648\u0646 \u0641\u0631\u0627\u063A\u0627\u062A.",
    submit: "\u062A\u0648\u0642\u064A\u0639",
    signing: "\u062C\u0627\u0631\u064D \u0627\u0644\u062A\u0648\u0642\u064A\u0639\u2026",
    resend: "\u0625\u0639\u0627\u062F\u0629 \u0625\u0631\u0633\u0627\u0644 \u0627\u0644\u0631\u0645\u0632",
    resendIn: "\u064A\u0645\u0643\u0646 \u0637\u0644\u0628 \u0631\u0645\u0632 \u062C\u062F\u064A\u062F \u0628\u0639\u062F {seconds} \u062B\u0627\u0646\u064A\u0629",
    resendWait: "\u064A\u0645\u0643\u0646\u0643 \u0637\u0644\u0628 \u0631\u0645\u0632 \u062C\u062F\u064A\u062F \u0628\u0639\u062F \u062F\u0642\u064A\u0642\u0629.",
    resendReady: "\u064A\u0645\u0643\u0646\u0643 \u0627\u0644\u0622\u0646 \u0637\u0644\u0628 \u0631\u0645\u0632 \u062C\u062F\u064A\u062F.",
    decline: "\u0631\u0641\u0636 \u0627\u0644\u062A\u0648\u0642\u064A\u0639",
    signed: "\u062A\u0645 \u062A\u0633\u062C\u064A\u0644 \u062A\u0648\u0642\u064A\u0639\u0643.",
    errors: {
      codeFormat: "\u0623\u062F\u062E\u0644 \u0623\u0631\u0642\u0627\u0645 \u0627\u0644\u0631\u0645\u0632 \u0627\u0644\u0633\u062A\u0629."
    }
  },
  decline: {
    title: "\u0631\u0641\u0636 \u062A\u0648\u0642\u064A\u0639 \xAB{title}\xBB",
    intro: "\u0633\u064A\u062A\u0645 \u0625\u0639\u0644\u0627\u0645 \u0635\u0627\u062D\u0628 \u0627\u0644\u0637\u0644\u0628. \u0627\u0634\u0631\u062D \u0644\u0647 \u0633\u0628\u0628 \u0627\u0644\u0631\u0641\u0636: \u0633\u064A\u0646\u062A\u0647\u064A \u0627\u0644\u0637\u0644\u0628 \u0644\u062C\u0645\u064A\u0639 \u0627\u0644\u0645\u0648\u0642\u0650\u0651\u0639\u064A\u0646.",
    reasonLabel: "\u0633\u0628\u0628 \u0627\u0644\u0631\u0641\u0636",
    reasonHint: "{max} \u062D\u0631\u0641 \u0639\u0644\u0649 \u0627\u0644\u0623\u0643\u062B\u0631.",
    reasonRequired: "\u0627\u0630\u0643\u0631 \u0633\u0628\u0628 \u0627\u0644\u0631\u0641\u0636.",
    confirm: "\u0631\u0641\u0636 \u0627\u0644\u062A\u0648\u0642\u064A\u0639",
    sending: "\u062C\u0627\u0631\u064D \u0627\u0644\u0625\u0631\u0633\u0627\u0644\u2026",
    done: "\u062A\u0645 \u062A\u0633\u062C\u064A\u0644 \u0631\u0641\u0636\u0643."
  },
  cancel: {
    action: "\u0625\u0644\u063A\u0627\u0621 \u0627\u0644\u0637\u0644\u0628",
    title: "\u0647\u0644 \u062A\u0631\u064A\u062F \u0625\u0644\u063A\u0627\u0621 \u0627\u0644\u0637\u0644\u0628 \xAB{title}\xBB\u061F",
    body: "\u0644\u0646 \u064A\u062A\u0645\u0643\u0646 \u0627\u0644\u0645\u0648\u0642\u0650\u0651\u0639\u0648\u0646 \u0645\u0646 \u0627\u0644\u062A\u0648\u0642\u064A\u0639 \u0628\u0639\u062F \u0627\u0644\u0622\u0646. \u062A\u0628\u0642\u0649 \u0627\u0644\u062A\u0648\u0642\u064A\u0639\u0627\u062A \u0627\u0644\u0645\u0642\u062F\u064E\u0651\u0645\u0629 \u0645\u0633\u062C\u064E\u0651\u0644\u0629.",
    confirm: "\u0625\u0644\u063A\u0627\u0621 \u0627\u0644\u0637\u0644\u0628",
    keep: "\u0627\u0644\u0625\u0628\u0642\u0627\u0621 \u0639\u0644\u0649 \u0627\u0644\u0637\u0644\u0628",
    done: "\u062A\u0645 \u0625\u0644\u063A\u0627\u0621 \u0627\u0644\u0637\u0644\u0628."
  },
  evidence: {
    title: "\u0625\u062B\u0628\u0627\u062A \u0627\u0644\u062A\u0648\u0642\u064A\u0639",
    intro: "\u062A\u0644\u062E\u0651\u0635 \u0634\u0647\u0627\u062F\u0629 \u0627\u0644\u0625\u062B\u0628\u0627\u062A \u0645\u0646 \u0648\u0642\u0651\u0639 \u0648\u0645\u062A\u0649 \u0648\u0628\u0623\u064A \u0628\u0635\u0645\u0629 \u0644\u0644\u0645\u0644\u0641 \u0648\u0645\u0646 \u0623\u064A \u0639\u0646\u0648\u0627\u0646 IP \u0648\u0628\u0623\u064A \u0645\u062A\u0635\u0641\u062D.",
    preparing: "\u062C\u0627\u0631\u064D \u0625\u0639\u062F\u0627\u062F \u0634\u0647\u0627\u062F\u0629 \u0627\u0644\u0625\u062B\u0628\u0627\u062A\u2026",
    slow: "\u0625\u0639\u062F\u0627\u062F \u0627\u0644\u0634\u0647\u0627\u062F\u0629 \u064A\u0633\u062A\u063A\u0631\u0642 \u0648\u0642\u062A\u0627 \u0623\u0637\u0648\u0644 \u0645\u0646 \u0627\u0644\u0645\u062A\u0648\u0642\u0639. \u062D\u062F\u0651\u062B \u0627\u0644\u0635\u0641\u062D\u0629 \u0628\u0639\u062F \u0644\u062D\u0638\u0627\u062A.",
    refresh: "\u062A\u062D\u062F\u064A\u062B",
    failed: "\u062A\u0639\u0630\u0651\u0631 \u0625\u0646\u062A\u0627\u062C \u0634\u0647\u0627\u062F\u0629 \u0627\u0644\u0625\u062B\u0628\u0627\u062A. \u0627\u062A\u0635\u0644 \u0628\u0645\u0633\u0624\u0648\u0644 \u0645\u0643\u062A\u0628\u0643.",
    download: "\u062A\u0646\u0632\u064A\u0644 \u0634\u0647\u0627\u062F\u0629 \u0627\u0644\u0625\u062B\u0628\u0627\u062A",
    started: "\u0628\u062F\u0623 \u062A\u0646\u0632\u064A\u0644 \u0627\u0644\u0634\u0647\u0627\u062F\u0629."
  },
  verify: {
    action: "\u0627\u0644\u062A\u062D\u0642\u0642 \u0645\u0646 \u0627\u0644\u0633\u0644\u0627\u0645\u0629",
    running: "\u062C\u0627\u0631\u064D \u0627\u0644\u062A\u062D\u0642\u0642\u2026",
    title: "\u0646\u062A\u064A\u062C\u0629 \u0627\u0644\u062A\u062D\u0642\u0642",
    checkedAt: "\u062A\u0645 \u0627\u0644\u062A\u062D\u0642\u0642 \u0641\u064A {date}.",
    states: {
      ok: "\u0645\u0637\u0627\u0628\u0642",
      ko: "\u062E\u0644\u0644",
      unknown: "\u062A\u0639\u0630\u0651\u0631 \u0627\u0644\u062A\u062D\u0642\u0642"
    },
    document: {
      ok: "\u0627\u0644\u0645\u0644\u0641 \u0633\u0644\u064A\u0645: \u0647\u0648 \u0646\u0641\u0633\u0647 \u0627\u0644\u0645\u0644\u0641 \u0627\u0644\u0630\u064A \u062A\u0645 \u062A\u0648\u0642\u064A\u0639\u0647.",
      ko: "\u062A\u063A\u064A\u0651\u0631 \u0627\u0644\u0645\u0644\u0641 \u0645\u0646\u0630 \u0627\u0644\u062A\u0648\u0642\u064A\u0639: \u0644\u0645 \u064A\u0639\u062F \u0645\u0637\u0627\u0628\u0642\u0627 \u0644\u0644\u0645\u0644\u0641 \u0627\u0644\u0630\u064A \u062A\u0645 \u062A\u0648\u0642\u064A\u0639\u0647."
    },
    evidence: {
      ok: "\u0645\u0644\u0641 \u0627\u0644\u0625\u062B\u0628\u0627\u062A \u0633\u0644\u064A\u0645.",
      ko: "\u062A\u0645 \u062A\u0639\u062F\u064A\u0644 \u0645\u0644\u0641 \u0627\u0644\u0625\u062B\u0628\u0627\u062A \u0645\u0646\u0630 \u0627\u0644\u062A\u0648\u0642\u064A\u0639."
    },
    signature: {
      ok: "\u0627\u0644\u062A\u0648\u0642\u064A\u0639 \u0627\u0644\u0645\u0624\u0647\u064E\u0651\u0644 \u0644\u0640 {name} \u0635\u0627\u0644\u062D.",
      ko: "\u0627\u0644\u062A\u0648\u0642\u064A\u0639 \u0627\u0644\u0645\u0624\u0647\u064E\u0651\u0644 \u0644\u0640 {name} \u063A\u064A\u0631 \u0635\u0627\u0644\u062D.",
      unknown: "\u062A\u0639\u0630\u0651\u0631 \u0627\u0644\u062A\u062D\u0642\u0642 \u0645\u0646 \u0627\u0644\u062A\u0648\u0642\u064A\u0639 \u0627\u0644\u0645\u0624\u0647\u064E\u0651\u0644 \u0644\u0640 {name}."
    }
  },
  section: {
    region: "\u0627\u0644\u062A\u0648\u0642\u064A\u0639 \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A",
    title: "\u0627\u0644\u062A\u0648\u0642\u064A\u0639",
    hint: "\u0627\u0637\u0644\u0628 \u0645\u0646 \u0623\u0639\u0636\u0627\u0621 \u0645\u0643\u062A\u0628\u0643 \u062A\u0648\u0642\u064A\u0639 \u0647\u0630\u0647 \u0627\u0644\u0646\u0633\u062E\u0629 \u0645\u0646 \u0627\u0644\u0648\u062B\u064A\u0642\u0629.",
    notReady: "\u0627\u0644\u0645\u0644\u0641 \u0642\u064A\u062F \u0627\u0644\u062A\u062D\u0642\u0642: \u0633\u064A\u0635\u0628\u062D \u0627\u0644\u062A\u0648\u0642\u064A\u0639 \u0645\u0645\u0643\u0646\u0627 \u0628\u0645\u062C\u0631\u062F \u062A\u0648\u0641\u0631\u0647."
  },
  create: {
    action: "\u0637\u0644\u0628 \u062A\u0648\u0642\u064A\u0639",
    title: "\u0637\u0644\u0628 \u062A\u0648\u0642\u064A\u0639: {title}",
    intro: "\u062A\u064F\u0631\u0633\u0644 \u0627\u0644\u0646\u0633\u062E\u0629 \u0627\u0644\u062D\u0627\u0644\u064A\u0629 \u0645\u0646 \u0627\u0644\u0648\u062B\u064A\u0642\u0629 \u0625\u0644\u0649 \u0627\u0644\u0645\u0648\u0642\u0650\u0651\u0639\u064A\u0646. \u062A\u064F\u062B\u0628\u064E\u0651\u062A \u0628\u0635\u0645\u062A\u0647\u0627 \u0627\u0644\u0622\u0646: \u0644\u0646 \u064A\u0634\u0645\u0644 \u0647\u0630\u0627 \u0627\u0644\u062A\u0648\u0642\u064A\u0639 \u0623\u064A \u0646\u0633\u062E\u0629 \u062C\u062F\u064A\u062F\u0629.",
    titleLabel: "\u0639\u0646\u0648\u0627\u0646 \u0627\u0644\u0637\u0644\u0628",
    messageLabel: "\u0631\u0633\u0627\u0644\u0629 \u0625\u0644\u0649 \u0627\u0644\u0645\u0648\u0642\u0650\u0651\u0639\u064A\u0646",
    messageHint: "\u0627\u062E\u062A\u064A\u0627\u0631\u064A\u0629. 1000 \u062D\u0631\u0641 \u0639\u0644\u0649 \u0627\u0644\u0623\u0643\u062B\u0631.",
    signersLabel: "\u0627\u0644\u0645\u0648\u0642\u0650\u0651\u0639\u0648\u0646",
    signersHint: "\u0627\u062E\u062A\u0631 \u0645\u0646 1 \u0625\u0644\u0649 {max} \u0645\u0646 \u0623\u0639\u0636\u0627\u0621 \u0645\u0643\u062A\u0628\u0643 \u0645\u0645\u0646 \u064A\u0645\u0643\u0646\u0647\u0645 \u0642\u0631\u0627\u0621\u0629 \u0647\u0630\u0647 \u0627\u0644\u0648\u062B\u064A\u0642\u0629.",
    membersFailed: "\u062A\u0639\u0630\u0651\u0631 \u062A\u062D\u0645\u064A\u0644 \u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u0623\u0639\u0636\u0627\u0621. \u0623\u063A\u0644\u0642 \u0647\u0630\u0647 \u0627\u0644\u0646\u0627\u0641\u0630\u0629 \u062B\u0645 \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629.",
    levelLabel: "\u0645\u0633\u062A\u0648\u0649 \u0627\u0644\u062A\u0648\u0642\u064A\u0639",
    validityLabel: "\u0645\u062F\u0629 \u0627\u0644\u0635\u0644\u0627\u062D\u064A\u0629 (\u0628\u0627\u0644\u0623\u064A\u0627\u0645)",
    validityHint: "\u0645\u0646 1 \u0625\u0644\u0649 {max} \u064A\u0648\u0645\u0627. \u0628\u0639\u062F \u0647\u0630\u0647 \u0627\u0644\u0645\u062F\u0629 \u064A\u0646\u062A\u0647\u064A \u0627\u0644\u0637\u0644\u0628.",
    send: "\u0625\u0631\u0633\u0627\u0644 \u0627\u0644\u0637\u0644\u0628",
    sending: "\u062C\u0627\u0631\u064D \u0627\u0644\u0625\u0631\u0633\u0627\u0644\u2026",
    done: "\u062A\u0645 \u0625\u0631\u0633\u0627\u0644 \u0637\u0644\u0628 \u0627\u0644\u062A\u0648\u0642\u064A\u0639.",
    errors: {
      titleRequired: "\u0623\u0639\u0637\u0650 \u0627\u0644\u0637\u0644\u0628 \u0639\u0646\u0648\u0627\u0646\u0627.",
      signersRequired: "\u0627\u062E\u062A\u0631 \u0645\u0648\u0642\u0650\u0651\u0639\u0627 \u0648\u0627\u062D\u062F\u0627 \u0639\u0644\u0649 \u0627\u0644\u0623\u0642\u0644.",
      signersTooMany: "\u064A\u0636\u0645 \u0627\u0644\u0637\u0644\u0628 {max} \u0645\u0648\u0642\u0650\u0651\u0639\u064A\u0646 \u0639\u0644\u0649 \u0627\u0644\u0623\u0643\u062B\u0631.",
      days: "\u062D\u062F\u0651\u062F \u0645\u062F\u0629 \u0635\u0644\u0627\u062D\u064A\u0629 \u0645\u0646 1 \u0625\u0644\u0649 {max} \u064A\u0648\u0645\u0627."
    }
  },
  digigo: {
    title: "\u062A\u0648\u0642\u064A\u0639 \u0627\u0644\u0641\u0648\u0627\u062A\u064A\u0631 \u0639\u0628\u0631 DigiGO",
    pending: "{count, plural, one {\u0641\u0627\u062A\u0648\u0631\u0629 \u0648\u0627\u062D\u062F\u0629 \u062A\u0646\u062A\u0638\u0631 \u062A\u0648\u0642\u064A\u0639\u0643 \u0639\u0628\u0631 DigiGO} two {\u0641\u0627\u062A\u0648\u0631\u062A\u0627\u0646 \u062A\u0646\u062A\u0638\u0631\u0627\u0646 \u062A\u0648\u0642\u064A\u0639\u0643 \u0639\u0628\u0631 DigiGO} few {# \u0641\u0648\u0627\u062A\u064A\u0631 \u062A\u0646\u062A\u0638\u0631 \u062A\u0648\u0642\u064A\u0639\u0643 \u0639\u0628\u0631 DigiGO} many {# \u0641\u0627\u062A\u0648\u0631\u0629 \u062A\u0646\u062A\u0638\u0631 \u062A\u0648\u0642\u064A\u0639\u0643 \u0639\u0628\u0631 DigiGO} other {# \u0641\u0627\u062A\u0648\u0631\u0629 \u062A\u0646\u062A\u0638\u0631 \u062A\u0648\u0642\u064A\u0639\u0643 \u0639\u0628\u0631 DigiGO}}",
    hint: "\u064A\u0631\u0633\u0644 DigiGO \u0631\u0645\u0632 \u062A\u0623\u0643\u064A\u062F \u0648\u0627\u062D\u062F\u0627 \u0644\u0644\u0645\u062C\u0645\u0648\u0639\u0629 \u0643\u0644\u0647\u0627. \u0648\u0628\u0639\u062F \u0627\u0644\u062A\u0648\u0642\u064A\u0639 \u062A\u0646\u0637\u0644\u0642 \u0627\u0644\u0641\u0648\u0627\u062A\u064A\u0631 \u0625\u0644\u0649 TTN.",
    listLabel: "\u0627\u0644\u0641\u0648\u0627\u062A\u064A\u0631 \u0627\u0644\u062A\u064A \u062A\u0646\u062A\u0638\u0631 \u062A\u0648\u0642\u064A\u0639 DigiGO",
    invoice: "\u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629 {number}",
    attempt: "\u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629 {attempt}",
    action: "\u062A\u0648\u0642\u064A\u0639 \u0627\u0644\u0645\u062C\u0645\u0648\u0639\u0629",
    starting: "\u062C\u0627\u0631\u064D \u0625\u0631\u0633\u0627\u0644 \u0627\u0644\u0631\u0645\u0632\u2026",
    stepUp: "\u0623\u0643\u0651\u062F \u0647\u0648\u064A\u062A\u0643 \u0644\u062A\u0648\u0642\u064A\u0639 \u0627\u0644\u0645\u062C\u0645\u0648\u0639\u0629: \u0633\u062A\u064F\u0641\u062A\u062D \u0646\u0627\u0641\u0630\u0629. \u0639\u064F\u062F \u0628\u0639\u062F \u0630\u0644\u0643 \u0625\u0644\u0649 \u0647\u0646\u0627 \u0648\u0627\u0636\u063A\u0637 \u0645\u0646 \u062C\u062F\u064A\u062F \u0639\u0644\u0649 \xAB\u062A\u0648\u0642\u064A\u0639 \u0627\u0644\u0645\u062C\u0645\u0648\u0639\u0629\xBB: \u064A\u0628\u0642\u0649 \u0627\u0644\u0631\u0645\u0632 \u0627\u0644\u0645\u064F\u0631\u0633\u064E\u0644 \u0635\u0627\u0644\u062D\u064B\u0627.",
    done: "{count, plural, one {\u062A\u0645 \u062A\u0648\u0642\u064A\u0639 \u0641\u0627\u062A\u0648\u0631\u0629 \u0648\u0627\u062D\u062F\u0629: \u0648\u0647\u064A \u0641\u064A \u0637\u0631\u064A\u0642\u0647\u0627 \u0625\u0644\u0649 TTN.} two {\u062A\u0645 \u062A\u0648\u0642\u064A\u0639 \u0641\u0627\u062A\u0648\u0631\u062A\u064A\u0646: \u0648\u0647\u0645\u0627 \u0641\u064A \u0637\u0631\u064A\u0642\u0647\u0645\u0627 \u0625\u0644\u0649 TTN.} few {\u062A\u0645 \u062A\u0648\u0642\u064A\u0639 # \u0641\u0648\u0627\u062A\u064A\u0631: \u0648\u0647\u064A \u0641\u064A \u0637\u0631\u064A\u0642\u0647\u0627 \u0625\u0644\u0649 TTN.} many {\u062A\u0645 \u062A\u0648\u0642\u064A\u0639 # \u0641\u0627\u062A\u0648\u0631\u0629: \u0648\u0647\u064A \u0641\u064A \u0637\u0631\u064A\u0642\u0647\u0627 \u0625\u0644\u0649 TTN.} other {\u062A\u0645 \u062A\u0648\u0642\u064A\u0639 # \u0641\u0627\u062A\u0648\u0631\u0629: \u0648\u0647\u064A \u0641\u064A \u0637\u0631\u064A\u0642\u0647\u0627 \u0625\u0644\u0649 TTN.}}",
    none: "\u0634\u0647\u0627\u062F\u062A\u0643 \u0627\u0644\u0641\u0639\u0651\u0627\u0644\u0629 \u062D\u0633\u0627\u0628 DigiGO: \u0644\u0627 \u062A\u0648\u062C\u062F \u0641\u0627\u062A\u0648\u0631\u0629 \u062A\u0646\u062A\u0638\u0631 \u0627\u0644\u062A\u0648\u0642\u064A\u0639 \u062D\u0627\u0644\u064A\u0627.",
    dialog: {
      title: "\u062A\u0623\u0643\u064A\u062F \u062A\u0648\u0642\u064A\u0639 \u0627\u0644\u0645\u062C\u0645\u0648\u0639\u0629",
      sentTo: "{count, plural, one {\u0623\u064F\u0631\u0633\u0644 \u0631\u0645\u0632 \u0645\u0646 6 \u0623\u0631\u0642\u0627\u0645 \u0625\u0644\u0649 {address} ({channel}) \u0644\u062A\u0648\u0642\u064A\u0639 \u0641\u0627\u062A\u0648\u0631\u0629 \u0648\u0627\u062D\u062F\u0629.} two {\u0623\u064F\u0631\u0633\u0644 \u0631\u0645\u0632 \u0645\u0646 6 \u0623\u0631\u0642\u0627\u0645 \u0625\u0644\u0649 {address} ({channel}) \u0644\u062A\u0648\u0642\u064A\u0639 \u0641\u0627\u062A\u0648\u0631\u062A\u064A\u0646.} few {\u0623\u064F\u0631\u0633\u0644 \u0631\u0645\u0632 \u0645\u0646 6 \u0623\u0631\u0642\u0627\u0645 \u0625\u0644\u0649 {address} ({channel}) \u0644\u062A\u0648\u0642\u064A\u0639 # \u0641\u0648\u0627\u062A\u064A\u0631.} many {\u0623\u064F\u0631\u0633\u0644 \u0631\u0645\u0632 \u0645\u0646 6 \u0623\u0631\u0642\u0627\u0645 \u0625\u0644\u0649 {address} ({channel}) \u0644\u062A\u0648\u0642\u064A\u0639 # \u0641\u0627\u062A\u0648\u0631\u0629.} other {\u0623\u064F\u0631\u0633\u0644 \u0631\u0645\u0632 \u0645\u0646 6 \u0623\u0631\u0642\u0627\u0645 \u0625\u0644\u0649 {address} ({channel}) \u0644\u062A\u0648\u0642\u064A\u0639 # \u0641\u0627\u062A\u0648\u0631\u0629.}} \u0647\u0648 \u0635\u0627\u0644\u062D \u062D\u062A\u0649 {time}.",
      startAgain: "\u0644\u0645 \u064A\u0639\u062F \u0647\u0630\u0627 \u0627\u0644\u0631\u0645\u0632 \u0635\u0627\u0644\u062D\u0627. \u0623\u063A\u0644\u0642 \u0647\u0630\u0647 \u0627\u0644\u0646\u0627\u0641\u0630\u0629 \u062B\u0645 \u0623\u0639\u062F \u062A\u0634\u063A\u064A\u0644 \xAB\u062A\u0648\u0642\u064A\u0639 \u0627\u0644\u0645\u062C\u0645\u0648\u0639\u0629\xBB.",
      close: "\u0625\u063A\u0644\u0627\u0642",
      confirm: "\u062A\u0623\u0643\u064A\u062F \u0627\u0644\u062A\u0648\u0642\u064A\u0639",
      confirming: "\u062C\u0627\u0631\u064D \u0627\u0644\u062A\u0648\u0642\u064A\u0639\u2026"
    }
  }
};

// locales/en/signatures.json
var signatures_default2 = {
  title: "Signatures",
  tabs: {
    label: "Signature boxes",
    to_sign: "To sign",
    sent: "Sent"
  },
  filter: {
    label: "Status",
    all: "All statuses"
  },
  statuses: {
    pending: "Pending",
    completed: "Signed",
    declined: "Declined",
    cancelled: "Cancelled",
    expired: "Expired"
  },
  signerStatuses: {
    pending: "To sign",
    signed: "Signed",
    declined: "Declined"
  },
  levels: {
    simple: "Simple signature",
    qualified: "Qualified signature",
    help: {
      simple: "A one-time code sent by email confirms the signer's identity. The proof (who, when, which file) is kept in an evidence certificate.",
      qualified: "The signature is made by an approved trust platform with the signer's certificate. It carries the highest value but depends on the platform's service."
    }
  },
  hash: {
    copy: "Copy SHA-256 hash {hash}",
    copied: "Hash copied.",
    copyFailed: "The hash could not be copied. Select it by hand."
  },
  list: {
    label: {
      to_sign: "Requests to sign",
      sent: "Requests sent"
    },
    loadFailedTitle: "The requests could not be loaded",
    loadFailedBody: "Check your connection and try again.",
    document: "Document: {name}",
    by: "Requested by {name}",
    expiresOn: "Expires on {date}",
    expiredOn: "Expired on {date}",
    completedOn: "Completed on {date}",
    createdOn: "Created on {date}",
    yourTurn: "Your turn to sign",
    progress: "{signed} / {total} signed",
    empty: {
      filteredTitle: "No request with this status",
      filteredBody: 'No request in this box has the status "{status}".',
      clear: "Show all statuses",
      to_sign: {
        title: "Nothing to sign right now",
        body: "Requests waiting for your signature will appear here."
      },
      sent: {
        title: "No request sent",
        body: 'To have a document signed, open it in Files and choose "Request a signature".'
      }
    }
  },
  request: {
    crumb: "Request",
    back: "Back to signatures",
    notFoundTitle: "Request not found",
    notFoundBody: "This request does not exist, or it does not concern you.",
    loadFailedTitle: "The request could not be loaded",
    loadFailedBody: "Check your connection and try again."
  },
  facts: {
    title: "The document to sign",
    titleSigned: "The signed document",
    document: "Document",
    revision: "revision {revision}",
    noRevision: "no revision",
    requester: "Requested by",
    level: "Signature level",
    created: "Created on",
    expires: "Valid until",
    completed: "Completed on",
    sha256: "SHA-256 hash of the file",
    sha256Help: "The hash identifies the exact file being signed: if the file changes, the hash changes.",
    message: "Requester's message"
  },
  signers: {
    title: "Signers",
    list: "Signers of the request",
    you: "you",
    signedOn: "Signed on {date}.",
    declinedOn: "Declined on {date}.",
    reason: "Reason: {reason}",
    certificate: "Certificate: {subject}"
  },
  state: {
    completed: "Every signer has signed, on {date}. The evidence certificate is below.",
    declined: "{name} declined to sign: the request is over. The reason is in the list of signers. To try again, make a new request from the document.",
    cancelled: "{name} cancelled this request: nobody can sign it any more.",
    expired: "This request expired on {date}: it can no longer be signed. Ask its author to make a new one.",
    expiredRequester: "This request expired on {date}: it can no longer be signed. Make a new request from the document.",
    youSigned: "{count, plural, =0 {You have signed.} one {You have signed. # signer is left.} other {You have signed. # signers are left.}}",
    yourTurn: "This document is waiting for your signature, until {date}.",
    waiting: "{count, plural, =0 {No signature is expected.} one {Waiting for # signer, until {date}.} other {Waiting for # signers, until {date}.}}"
  },
  sign: {
    title: "Your signature",
    intro: "To sign, first receive a one-time code, then enter it. Your IP address and browser are recorded as evidence.",
    receive: "Receive a code",
    sending: "Sending the code\u2026",
    sentTo: "A 6-digit code was sent to {address} ({channel}). It is valid until {time}.",
    sentEarlier: "A code was sent to you on {time}. Enter it below, or ask for a new one.",
    channels: {
      email: "by email",
      sms: "by SMS",
      app: "in the signing app"
    },
    codeLabel: "6-digit code",
    codeHint: "Enter the code you received, without spaces.",
    submit: "Sign",
    signing: "Signing\u2026",
    resend: "Send the code again",
    resendIn: "A new code can be asked for in {seconds} s",
    resendWait: "You can ask for a new code in one minute.",
    resendReady: "You can ask for a new code now.",
    decline: "Decline to sign",
    signed: "Your signature is recorded.",
    errors: {
      codeFormat: "Enter the 6 digits of the code."
    }
  },
  decline: {
    title: 'Decline to sign "{title}"',
    intro: "The requester will be told. Explain why you decline: the request will be over for every signer.",
    reasonLabel: "Reason for declining",
    reasonHint: "{max} characters at most.",
    reasonRequired: "Give the reason for declining.",
    confirm: "Decline to sign",
    sending: "Sending\u2026",
    done: "Your refusal is recorded."
  },
  cancel: {
    action: "Cancel the request",
    title: 'Cancel the request "{title}"?',
    body: "Signers will no longer be able to sign. Signatures already given stay on record.",
    confirm: "Cancel the request",
    keep: "Keep the request",
    done: "The request is cancelled."
  },
  evidence: {
    title: "Proof of the signature",
    intro: "The evidence certificate summarises who signed, when, with which hash of the file, from which IP address and browser.",
    preparing: "The evidence certificate is being prepared\u2026",
    slow: "Preparing the certificate takes longer than expected. Refresh in a moment.",
    refresh: "Refresh",
    failed: "The evidence certificate could not be produced. Contact your office administrator.",
    download: "Download the evidence certificate",
    started: "The certificate download has started."
  },
  verify: {
    action: "Check integrity",
    running: "Checking\u2026",
    title: "Result of the check",
    checkedAt: "Checked on {date}.",
    states: {
      ok: "Valid",
      ko: "Problem",
      unknown: "Not verifiable"
    },
    document: {
      ok: "The file is intact: it is identical to the one that was signed.",
      ko: "The file has changed since the signature: it is no longer identical to the one that was signed."
    },
    evidence: {
      ok: "The evidence record is intact.",
      ko: "The evidence record has been modified since the signature."
    },
    signature: {
      ok: "The qualified signature of {name} is valid.",
      ko: "The qualified signature of {name} is not valid.",
      unknown: "The qualified signature of {name} could not be checked."
    }
  },
  section: {
    region: "Electronic signature",
    title: "Signature",
    hint: "Have members of your office sign this version of the document.",
    notReady: "The file is still being checked: signing will be possible once it is available."
  },
  create: {
    action: "Request a signature",
    title: "Request a signature: {title}",
    intro: "The current version of the document is sent to the signers. Its hash is fixed now: a later version will not be covered by this signature.",
    titleLabel: "Request title",
    messageLabel: "Message to the signers",
    messageHint: "Optional. 1,000 characters at most.",
    signersLabel: "Signers",
    signersHint: "Choose 1 to {max} members of your office who can read this document.",
    membersFailed: "The list of members could not be loaded. Close this window and try again.",
    levelLabel: "Signature level",
    validityLabel: "Validity (in days)",
    validityHint: "From 1 to {max} days. After that the request expires.",
    send: "Send the request",
    sending: "Sending\u2026",
    done: "The signature request is sent.",
    errors: {
      titleRequired: "Give the request a title.",
      signersRequired: "Choose at least one signer.",
      signersTooMany: "A request has {max} signers at most.",
      days: "Give a validity of 1 to {max} days."
    }
  },
  digigo: {
    title: "DigiGO signing of invoices",
    pending: "{count, plural, one {# invoice is waiting for your DigiGO signature} other {# invoices are waiting for your DigiGO signature}}",
    hint: "DigiGO sends a single confirmation code for the whole batch. Once signed, the invoices go to TTN.",
    listLabel: "Invoices waiting for a DigiGO signature",
    invoice: "Invoice {number}",
    attempt: "attempt {attempt}",
    action: "Sign the batch",
    starting: "Sending the code\u2026",
    stepUp: "Confirm your identity to sign the batch: a window opens. Then come back here and press \u201CSign the batch\u201D again: the code already sent stays valid.",
    done: "{count, plural, one {# invoice signed: it is on its way to TTN.} other {# invoices signed: they are on their way to TTN.}}",
    none: "Your active certificate is a DigiGO account: no invoice is waiting for a signature right now.",
    dialog: {
      title: "Confirm the batch signature",
      sentTo: "{count, plural, one {A 6-digit code was sent to {address} ({channel}) to sign # invoice.} other {A 6-digit code was sent to {address} ({channel}) to sign # invoices.}} It is valid until {time}.",
      startAgain: 'This code can no longer be used. Close this window and start "Sign the batch" again.',
      close: "Close",
      confirm: "Confirm the signature",
      confirming: "Signing\u2026"
    }
  }
};

// locales/fr/signatures.json
var signatures_default3 = {
  title: "Signatures",
  tabs: {
    label: "Bo\xEEtes de signature",
    to_sign: "\xC0 signer",
    sent: "Envoy\xE9es"
  },
  filter: {
    label: "Statut",
    all: "Tous les statuts"
  },
  statuses: {
    pending: "En attente",
    completed: "Sign\xE9e",
    declined: "Refus\xE9e",
    cancelled: "Annul\xE9e",
    expired: "Expir\xE9e"
  },
  signerStatuses: {
    pending: "\xC0 signer",
    signed: "A sign\xE9",
    declined: "A refus\xE9"
  },
  levels: {
    simple: "Signature simple",
    qualified: "Signature qualifi\xE9e",
    help: {
      simple: "Un code \xE0 usage unique envoy\xE9 par e-mail confirme l\u2019identit\xE9 du signataire. La preuve (qui, quand, quel fichier) est conserv\xE9e dans un certificat de preuve.",
      qualified: "La signature est r\xE9alis\xE9e par une plateforme de confiance agr\xE9\xE9e, avec le certificat du signataire. Elle a la valeur la plus \xE9lev\xE9e, mais d\xE9pend du service de la plateforme."
    }
  },
  hash: {
    copy: "Copier l\u2019empreinte SHA-256 {hash}",
    copied: "Empreinte copi\xE9e.",
    copyFailed: "L\u2019empreinte n\u2019a pas pu \xEAtre copi\xE9e. S\xE9lectionnez-la \xE0 la main."
  },
  list: {
    label: {
      to_sign: "Demandes \xE0 signer",
      sent: "Demandes envoy\xE9es"
    },
    loadFailedTitle: "Les demandes n\u2019ont pas pu \xEAtre charg\xE9es",
    loadFailedBody: "V\xE9rifiez votre connexion puis r\xE9essayez.",
    document: "Document\xA0: {name}",
    by: "Demand\xE9e par {name}",
    expiresOn: "Expire le {date}",
    expiredOn: "Expir\xE9e le {date}",
    completedOn: "Termin\xE9e le {date}",
    createdOn: "Cr\xE9\xE9e le {date}",
    yourTurn: "\xC0 vous de signer",
    progress: "{signed} / {total} sign\xE9s",
    empty: {
      filteredTitle: "Aucune demande avec ce statut",
      filteredBody: "Aucune demande n\u2019a le statut \xAB\xA0{status}\xA0\xBB dans cette bo\xEEte.",
      clear: "Voir tous les statuts",
      to_sign: {
        title: "Rien \xE0 signer pour le moment",
        body: "Les demandes qui attendent votre signature appara\xEEtront ici."
      },
      sent: {
        title: "Aucune demande envoy\xE9e",
        body: "Pour faire signer un document, ouvrez-le dans les fichiers puis choisissez \xAB\xA0Demander une signature\xA0\xBB."
      }
    }
  },
  request: {
    crumb: "Demande",
    back: "Retour aux signatures",
    notFoundTitle: "Demande introuvable",
    notFoundBody: "Cette demande n\u2019existe pas, ou elle ne vous concerne pas.",
    loadFailedTitle: "La demande n\u2019a pas pu \xEAtre charg\xE9e",
    loadFailedBody: "V\xE9rifiez votre connexion puis r\xE9essayez."
  },
  facts: {
    title: "Le document \xE0 signer",
    titleSigned: "Le document sign\xE9",
    document: "Document",
    revision: "indice {revision}",
    noRevision: "sans indice",
    requester: "Demand\xE9e par",
    level: "Niveau de signature",
    created: "Cr\xE9\xE9e le",
    expires: "Valable jusqu\u2019au",
    completed: "Termin\xE9e le",
    sha256: "Empreinte SHA-256 du fichier",
    sha256Help: "L\u2019empreinte identifie le fichier exact qui est sign\xE9\xA0: si le fichier change, l\u2019empreinte change.",
    message: "Message du demandeur"
  },
  signers: {
    title: "Signataires",
    list: "Signataires de la demande",
    you: "vous",
    signedOn: "A sign\xE9 le {date}.",
    declinedOn: "A refus\xE9 le {date}.",
    reason: "Motif\xA0: {reason}",
    certificate: "Certificat\xA0: {subject}"
  },
  state: {
    completed: "Tous les signataires ont sign\xE9, le {date}. Le certificat de preuve est ci-dessous.",
    declined: "{name} a refus\xE9 de signer\xA0: la demande est termin\xE9e. Le motif est indiqu\xE9 dans la liste des signataires. Pour relancer, faites une nouvelle demande depuis le document.",
    cancelled: "{name} a annul\xE9 cette demande\xA0: plus personne ne peut la signer.",
    expired: "Cette demande a expir\xE9 le {date}\xA0: elle ne peut plus \xEAtre sign\xE9e. Demandez \xE0 son auteur d\u2019en faire une nouvelle.",
    expiredRequester: "Cette demande a expir\xE9 le {date}\xA0: elle ne peut plus \xEAtre sign\xE9e. Faites une nouvelle demande depuis le document.",
    youSigned: "{count, plural, =0 {Vous avez sign\xE9.} one {Vous avez sign\xE9. Il reste # signataire.} other {Vous avez sign\xE9. Il reste # signataires.}}",
    yourTurn: "Ce document attend votre signature, jusqu\u2019au {date}.",
    waiting: "{count, plural, =0 {Aucune signature n\u2019est attendue.} one {En attente de # signataire, jusqu\u2019au {date}.} other {En attente de # signataires, jusqu\u2019au {date}.}}"
  },
  sign: {
    title: "Votre signature",
    intro: "Pour signer, recevez d\u2019abord un code \xE0 usage unique, puis saisissez-le. Votre adresse IP et votre navigateur sont enregistr\xE9s comme preuve.",
    receive: "Recevoir un code",
    sending: "Envoi du code\u2026",
    sentTo: "Un code \xE0 6 chiffres a \xE9t\xE9 envoy\xE9 \xE0 {address} ({channel}). Il est valable jusqu\u2019au {time}.",
    sentEarlier: "Un code vous a \xE9t\xE9 envoy\xE9 le {time}. Saisissez-le ci-dessous, ou demandez-en un nouveau.",
    channels: {
      email: "par e-mail",
      sms: "par SMS",
      app: "dans l\u2019application de signature"
    },
    codeLabel: "Code \xE0 6 chiffres",
    codeHint: "Saisissez le code re\xE7u, sans espace.",
    submit: "Signer",
    signing: "Signature en cours\u2026",
    resend: "Renvoyer le code",
    resendIn: "Nouveau code possible dans {seconds} s",
    resendWait: "Vous pourrez demander un nouveau code dans une minute.",
    resendReady: "Vous pouvez demander un nouveau code.",
    decline: "Refuser de signer",
    signed: "Votre signature est enregistr\xE9e.",
    errors: {
      codeFormat: "Saisissez les 6 chiffres du code."
    }
  },
  decline: {
    title: "Refuser de signer \xAB\xA0{title}\xA0\xBB",
    intro: "Le demandeur sera pr\xE9venu. Expliquez-lui pourquoi vous refusez\xA0: la demande sera termin\xE9e pour tous les signataires.",
    reasonLabel: "Motif du refus",
    reasonHint: "{max} caract\xE8res au plus.",
    reasonRequired: "Indiquez le motif du refus.",
    confirm: "Refuser de signer",
    sending: "Envoi\u2026",
    done: "Votre refus est enregistr\xE9."
  },
  cancel: {
    action: "Annuler la demande",
    title: "Annuler la demande \xAB\xA0{title}\xA0\xBB\xA0?",
    body: "Les signataires ne pourront plus signer. Les signatures d\xE9j\xE0 donn\xE9es restent consign\xE9es.",
    confirm: "Annuler la demande",
    keep: "Garder la demande",
    done: "La demande est annul\xE9e."
  },
  evidence: {
    title: "Preuve de la signature",
    intro: "Le certificat de preuve r\xE9sume qui a sign\xE9, quand, avec quelle empreinte du fichier, depuis quelle adresse IP et quel navigateur.",
    preparing: "Le certificat de preuve est en cours de pr\xE9paration\u2026",
    slow: "La pr\xE9paration du certificat prend plus de temps que pr\xE9vu. Actualisez dans un instant.",
    refresh: "Actualiser",
    failed: "Le certificat de preuve n\u2019a pas pu \xEAtre produit. Contactez l\u2019administrateur de votre bureau.",
    download: "T\xE9l\xE9charger le certificat de preuve",
    started: "Le t\xE9l\xE9chargement du certificat est lanc\xE9."
  },
  verify: {
    action: "V\xE9rifier l\u2019int\xE9grit\xE9",
    running: "V\xE9rification en cours\u2026",
    title: "R\xE9sultat de la v\xE9rification",
    checkedAt: "V\xE9rifi\xE9 le {date}.",
    states: {
      ok: "Conforme",
      ko: "Anomalie",
      unknown: "Non v\xE9rifiable"
    },
    document: {
      ok: "Le fichier est intact\xA0: il est identique \xE0 celui qui a \xE9t\xE9 sign\xE9.",
      ko: "Le fichier a chang\xE9 depuis la signature\xA0: il n\u2019est plus identique \xE0 celui qui a \xE9t\xE9 sign\xE9."
    },
    evidence: {
      ok: "Le dossier de preuve est intact.",
      ko: "Le dossier de preuve a \xE9t\xE9 modifi\xE9 depuis la signature."
    },
    signature: {
      ok: "La signature qualifi\xE9e de {name} est valide.",
      ko: "La signature qualifi\xE9e de {name} n\u2019est pas valide.",
      unknown: "La signature qualifi\xE9e de {name} n\u2019a pas pu \xEAtre v\xE9rifi\xE9e."
    }
  },
  section: {
    region: "Signature \xE9lectronique",
    title: "Signature",
    hint: "Faites signer cette version du document par des membres de votre bureau.",
    notReady: "Le fichier est encore en cours de v\xE9rification\xA0: la signature sera possible d\xE8s qu\u2019il sera disponible."
  },
  create: {
    action: "Demander une signature",
    title: "Demander une signature\xA0: {title}",
    intro: "La version actuelle du document est envoy\xE9e aux signataires. Son empreinte est fix\xE9e maintenant\xA0: une nouvelle version ne sera pas couverte par cette signature.",
    titleLabel: "Titre de la demande",
    messageLabel: "Message pour les signataires",
    messageHint: "Facultatif. 1 000 caract\xE8res au plus.",
    signersLabel: "Signataires",
    signersHint: "Choisissez de 1 \xE0 {max} membres de votre bureau qui peuvent lire ce document.",
    membersFailed: "La liste des membres n\u2019a pas pu \xEAtre charg\xE9e. Fermez cette fen\xEAtre puis r\xE9essayez.",
    levelLabel: "Niveau de signature",
    validityLabel: "Validit\xE9 (en jours)",
    validityHint: "De 1 \xE0 {max} jours. Pass\xE9 ce d\xE9lai, la demande expire.",
    send: "Envoyer la demande",
    sending: "Envoi\u2026",
    done: "La demande de signature est envoy\xE9e.",
    errors: {
      titleRequired: "Donnez un titre \xE0 la demande.",
      signersRequired: "Choisissez au moins un signataire.",
      signersTooMany: "Une demande compte {max} signataires au plus.",
      days: "Indiquez une validit\xE9 de 1 \xE0 {max} jours."
    }
  },
  digigo: {
    title: "Signature DigiGO des factures",
    pending: "{count, plural, one {# facture attend votre signature DigiGO} other {# factures attendent votre signature DigiGO}}",
    hint: "DigiGO envoie un seul code de confirmation pour tout le lot. Une fois sign\xE9es, les factures partent vers TTN.",
    listLabel: "Factures en attente de signature DigiGO",
    invoice: "Facture {number}",
    attempt: "tentative {attempt}",
    action: "Signer le lot",
    starting: "Envoi du code\u2026",
    stepUp: "Confirmez votre identit\xE9 pour signer le lot : une fen\xEAtre s\u2019ouvre. Revenez ensuite ici et appuyez de nouveau sur \xAB Signer le lot \xBB : le code d\xE9j\xE0 envoy\xE9 reste valable.",
    done: "{count, plural, one {# facture sign\xE9e\xA0: elle part vers TTN.} other {# factures sign\xE9es\xA0: elles partent vers TTN.}}",
    none: "Votre certificat actif est un compte DigiGO\xA0: aucune facture n\u2019attend de signature pour le moment.",
    dialog: {
      title: "Confirmer la signature du lot",
      sentTo: "{count, plural, one {Un code \xE0 6 chiffres a \xE9t\xE9 envoy\xE9 \xE0 {address} ({channel}) pour signer # facture.} other {Un code \xE0 6 chiffres a \xE9t\xE9 envoy\xE9 \xE0 {address} ({channel}) pour signer # factures.}} Il est valable jusqu\u2019au {time}.",
      startAgain: "Ce code ne peut plus servir. Fermez cette fen\xEAtre puis relancez \xAB\xA0Signer le lot\xA0\xBB.",
      close: "Fermer",
      confirm: "Confirmer la signature",
      confirming: "Signature en cours\u2026"
    }
  }
};

// locales/ar/guide.json
var guide_default = {
  drawer: {
    title: "\u062F\u0644\u064A\u0644 \u0627\u0644\u0635\u0641\u062D\u0629",
    close: "\u0625\u063A\u0644\u0627\u0642 \u0627\u0644\u062F\u0644\u064A\u0644",
    loading: "\u062C\u0627\u0631\u064D \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u062F\u0644\u064A\u0644\u2026",
    missing: "\u0644\u0627 \u064A\u0648\u062C\u062F \u0628\u0639\u062F \u062F\u0644\u064A\u0644 \u0645\u0641\u0635\u0651\u0644 \u0644\u0647\u0630\u0647 \u0627\u0644\u0635\u0641\u062D\u0629\u061B \u0625\u0644\u064A\u0643 \u0627\u0644\u062F\u0644\u064A\u0644 \u0627\u0644\u0639\u0627\u0645 \u0644\u0640\u2066BatiFlow\u2069.",
    purpose: "\u0627\u0644\u063A\u0631\u0636 \u0645\u0646 \u0647\u0630\u0647 \u0627\u0644\u0635\u0641\u062D\u0629",
    search: "\u0627\u0644\u0628\u062D\u062B \u0641\u064A \u0647\u0630\u0627 \u0627\u0644\u062F\u0644\u064A\u0644",
    stats: "\u0627\u0644\u0623\u0642\u0633\u0627\u0645: {sections} \xB7 \u0627\u0644\u0639\u0646\u0627\u0635\u0631: {items}",
    results: "{count, plural, zero {\u0644\u0627 \u062A\u0648\u062C\u062F \u0646\u062A\u0627\u0626\u062C} one {\u0646\u062A\u064A\u062C\u0629 \u0648\u0627\u062D\u062F\u0629} two {\u0646\u062A\u064A\u062C\u062A\u0627\u0646} few {# \u0646\u062A\u0627\u0626\u062C} many {# \u0646\u062A\u064A\u062C\u0629} other {# \u0646\u062A\u064A\u062C\u0629}}",
    contents: "\u0641\u064A \u0647\u0630\u0647 \u0627\u0644\u0635\u0641\u062D\u0629",
    count: "{count, plural, zero {\u0644\u0627 \u0639\u0646\u0627\u0635\u0631} one {\u0639\u0646\u0635\u0631 \u0648\u0627\u062D\u062F} two {\u0639\u0646\u0635\u0631\u0627\u0646} few {# \u0639\u0646\u0627\u0635\u0631} many {# \u0639\u0646\u0635\u0631\u064B\u0627} other {# \u0639\u0646\u0635\u0631}}",
    columnTerm: "\u0627\u0644\u0639\u0646\u0635\u0631",
    columnText: "\u0645\u0627 \u064A\u062C\u0628 \u0645\u0639\u0631\u0641\u062A\u0647",
    noResults: "\u0644\u0627 \u064A\u0648\u062C\u062F \u0641\u064A \u0627\u0644\u062F\u0644\u064A\u0644 \u0645\u0627 \u064A\u0637\u0627\u0628\u0642 \u0628\u062D\u062B\u0643.",
    clearSearch: "\u0645\u0633\u062D \u0627\u0644\u0628\u062D\u062B",
    escKey: "Esc",
    escHint: "\u0644\u0625\u063A\u0644\u0627\u0642 \u0627\u0644\u062F\u0644\u064A\u0644"
  },
  pages: {
    projects: {
      title: "\u0627\u0644\u0645\u0634\u0627\u0631\u064A\u0639",
      intro: "\u0642\u0627\u0626\u0645\u0629 \u0643\u0644 \u0645\u0634\u0627\u0631\u064A\u0639 \u0627\u0644\u0645\u0643\u062A\u0628. \u062A\u0633\u062A\u0639\u0645\u0644\u0647\u0627 \u0644\u0644\u0639\u062B\u0648\u0631 \u0639\u0644\u0649 \u0645\u0634\u0631\u0648\u0639 \u0648\u0645\u0639\u0631\u0641\u0629 \u0645\u062F\u0649 \u062A\u0642\u062F\u0651\u0645\u0647\u060C \u0648\u0625\u0646\u0634\u0627\u0621 \u0645\u0634\u0631\u0648\u0639 \u062C\u062F\u064A\u062F \u0625\u0646 \u0643\u0646\u062A \u0645\u062E\u0648\u0651\u0644\u064B\u0627 \u0628\u0630\u0644\u0643.",
      sections: {
        header: {
          title: "\u0627\u0644\u0645\u0634\u0627\u0631\u064A\u0639",
          items: {
            newProject: {
              term: "\u0645\u0634\u0631\u0648\u0639 \u062C\u062F\u064A\u062F",
              text: "\u0632\u0631 \u0641\u064A \u0623\u0639\u0644\u0649 \u0627\u0644\u0635\u0641\u062D\u0629 \u064A\u0638\u0647\u0631 \u0641\u0642\u0637 \u0644\u0645\u0646 \u0644\u0647 \u062D\u0642 \u0625\u0646\u0634\u0627\u0621 \u0645\u0634\u0631\u0648\u0639. \u064A\u0641\u062A\u062D \u0646\u0627\u0641\u0630\u0629 \u0627\u0644\u0625\u0646\u0634\u0627\u0621. \u0648\u064A\u0643\u0648\u0646 \u0645\u0639\u0637\u0651\u0644\u064B\u0627 \u0625\u0630\u0627 \u0643\u0627\u0646 \u062D\u0633\u0627\u0628 \u0627\u0644\u0645\u0643\u062A\u0628 \u0644\u0644\u0642\u0631\u0627\u0621\u0629 \u0641\u0642\u0637."
            },
            grid: {
              term: "\u0634\u0628\u0643\u0629",
              text: "\u064A\u0639\u0631\u0636 \u0627\u0644\u0645\u0634\u0627\u0631\u064A\u0639 \u0641\u064A \u0628\u0637\u0627\u0642\u0627\u062A: \u0628\u0637\u0627\u0642\u0629 \u0644\u0643\u0644 \u0645\u0634\u0631\u0648\u0639\u060C \u0641\u064A\u0647\u0627 \u0627\u0633\u0645\u0647 \u0648\u062D\u0627\u0644\u062A\u0647 \u0648\u0631\u0645\u0632\u0647 \u0648\u062D\u0631\u064A\u0641\u0647 \u0648\u062A\u0642\u062F\u0651\u0645 \u0645\u0631\u0627\u062D\u0644\u0647."
            },
            list: {
              term: "\u0642\u0627\u0626\u0645\u0629",
              text: "\u064A\u0639\u0631\u0636 \u0627\u0644\u0645\u0634\u0627\u0631\u064A\u0639 \u0641\u064A \u062C\u062F\u0648\u0644\u060C \u0628\u0633\u0637\u0631 \u0644\u0643\u0644 \u0645\u0634\u0631\u0648\u0639. \u064A\u064F\u062D\u0641\u0638 \u0627\u062E\u062A\u064A\u0627\u0631\u0643 \u0641\u064A \u0639\u0646\u0648\u0627\u0646 \u0627\u0644\u0635\u0641\u062D\u0629."
            },
            loadMore: {
              term: "\u0639\u0631\u0636 \u0627\u0644\u0645\u0632\u064A\u062F \u0645\u0646 \u0627\u0644\u0645\u0634\u0627\u0631\u064A\u0639",
              text: "\u064A\u0638\u0647\u0631 \u062A\u062D\u062A \u0627\u0644\u0642\u0627\u0626\u0645\u0629 \u0639\u0646\u062F\u0645\u0627 \u062A\u0628\u0642\u0649 \u0645\u0634\u0627\u0631\u064A\u0639 \u0644\u0645 \u062A\u064F\u0639\u0631\u0636 \u0628\u0639\u062F. \u064A\u062A\u062D\u0648\u0651\u0644 \u0627\u0644\u0646\u0635 \u0625\u0644\u0649 \xAB\u062C\u0627\u0631\u064D \u0627\u0644\u062A\u062D\u0645\u064A\u0644\u2026\xBB \u0623\u062B\u0646\u0627\u0621 \u0648\u0635\u0648\u0644 \u0627\u0644\u0628\u0642\u064A\u0629."
            }
          }
        },
        filters: {
          title: "\u062A\u0635\u0641\u064A\u0629 \u0627\u0644\u0645\u0634\u0627\u0631\u064A\u0639",
          items: {
            search: {
              term: "\u0627\u0644\u0628\u062D\u062B \u0639\u0646 \u0645\u0634\u0631\u0648\u0639",
              text: "\u0627\u0643\u062A\u0628 \u062C\u0632\u0621\u064B\u0627 \u0645\u0646 \u0627\u0633\u0645 \u0627\u0644\u0645\u0634\u0631\u0648\u0639 \u0623\u0648 \u0631\u0645\u0632\u0647. \u062A\u062A\u062D\u062F\u0651\u062B \u0627\u0644\u0642\u0627\u0626\u0645\u0629 \u0628\u0645\u062C\u0631\u062F \u0623\u0646 \u062A\u062A\u0648\u0642\u0641 \u0639\u0646 \u0627\u0644\u0643\u062A\u0627\u0628\u0629."
            },
            status: {
              term: "\u0627\u0644\u062A\u0635\u0641\u064A\u0629 \u062D\u0633\u0628 \u0627\u0644\u062D\u0627\u0644\u0629",
              text: "\u064A\u064F\u0628\u0642\u064A \u0641\u0642\u0637 \u0627\u0644\u0645\u0634\u0627\u0631\u064A\u0639 \u0630\u0627\u062A \u062D\u0627\u0644\u0629 \u0648\u0627\u062D\u062F\u0629: \u0645\u0633\u0648\u062F\u0629 \u0623\u0648 \u062C\u0627\u0631\u064D \u0623\u0648 \u0645\u062A\u0648\u0642\u0641 \u0645\u0624\u0642\u062A\u064B\u0627 \u0623\u0648 \u0645\u063A\u0644\u0642 \u0623\u0648 \u0645\u0624\u0631\u0634\u0641. \u0627\u062E\u062A\u0631 \xAB\u0643\u0644 \u0627\u0644\u062D\u0627\u0644\u0627\u062A\xBB \u0644\u0631\u0624\u064A\u0629 \u0643\u0644 \u0634\u064A\u0621 \u0645\u0646 \u062C\u062F\u064A\u062F."
            },
            missionType: {
              term: "\u0627\u0644\u062A\u0635\u0641\u064A\u0629 \u062D\u0633\u0628 \u0646\u0648\u0639 \u0627\u0644\u0645\u0647\u0645\u0629",
              text: "\u064A\u064F\u0628\u0642\u064A \u0641\u0642\u0637 \u0627\u0644\u0645\u0634\u0627\u0631\u064A\u0639 \u0645\u0646 \u0646\u0648\u0639 \u0645\u0647\u0645\u0629 \u0648\u0627\u062D\u062F\u060C \u0645\u062B\u0644 \xAB\u0641\u064A\u0644\u0627 \u0641\u0631\u062F\u064A\u0629\xBB. \u0627\u062E\u062A\u0631 \xAB\u0643\u0644 \u0623\u0646\u0648\u0627\u0639 \u0627\u0644\u0645\u0647\u0627\u0645\xBB \u0644\u0631\u0624\u064A\u0629 \u0643\u0644 \u0634\u064A\u0621 \u0645\u0646 \u062C\u062F\u064A\u062F."
            },
            client: {
              term: "\u0627\u0644\u062A\u0635\u0641\u064A\u0629 \u062D\u0633\u0628 \u0627\u0644\u062D\u0631\u064A\u0641",
              text: "\u064A\u064F\u0628\u0642\u064A \u0641\u0642\u0637 \u0645\u0634\u0627\u0631\u064A\u0639 \u062D\u0631\u064A\u0641 \u0648\u0627\u062D\u062F. \u062A\u0639\u0631\u0636 \u0627\u0644\u0642\u0627\u0626\u0645\u0629 \u062D\u0631\u0641\u0627\u0621 \u0627\u0644\u0645\u0643\u062A\u0628\u060C \u0648\u064A\u0632\u064A\u0644 \xAB\u0643\u0644 \u0627\u0644\u062D\u0631\u0641\u0627\u0621\xBB \u0627\u0644\u062A\u0635\u0641\u064A\u0629."
            },
            mine: {
              term: "\u0645\u0634\u0627\u0631\u064A\u0639\u064A \u0641\u0642\u0637",
              text: "\u0645\u0641\u062A\u0627\u062D \u064A\u064F\u0628\u0642\u064A \u0641\u0642\u0637 \u0627\u0644\u0645\u0634\u0627\u0631\u064A\u0639 \u0627\u0644\u062A\u064A \u0623\u0646\u062A \u0639\u0636\u0648 \u0641\u064A\u0647\u0627."
            },
            clear: {
              term: "\u0645\u0633\u062D \u0627\u0644\u062A\u0635\u0641\u064A\u0627\u062A",
              text: "\u064A\u0638\u0647\u0631 \u0639\u0646\u062F\u0645\u0627 \u0644\u0627 \u064A\u0637\u0627\u0628\u0642 \u0623\u064A \u0645\u0634\u0631\u0648\u0639: \u064A\u0632\u064A\u0644 \u0627\u0644\u0628\u062D\u062B \u0648\u0643\u0644 \u0627\u0644\u062A\u0635\u0641\u064A\u0627\u062A \u062F\u0641\u0639\u0629 \u0648\u0627\u062D\u062F\u0629."
            }
          }
        },
        projectsList: {
          title: "\u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u0645\u0634\u0627\u0631\u064A\u0639",
          items: {
            name: {
              term: "\u0627\u0644\u0645\u0634\u0631\u0648\u0639",
              text: "\u0627\u0633\u0645 \u0627\u0644\u0645\u0634\u0631\u0648\u0639. \u0627\u0646\u0642\u0631 \u0639\u0644\u064A\u0647 \u0644\u0641\u062A\u062D \u0627\u0644\u0645\u0634\u0631\u0648\u0639 (\u064A\u064F\u0641\u062A\u062D \u062A\u0628\u0648\u064A\u0628 \u0627\u0644\u0645\u0646\u0634\u0648\u0631\u0627\u062A \u0623\u0648\u0644\u064B\u0627)."
            },
            code: {
              term: "\u0627\u0644\u0631\u0645\u0632",
              text: "\u0631\u0645\u0632 \u0627\u0644\u0645\u0634\u0631\u0648\u0639\u060C \u0645\u062B\u0644 \u20662026-014\u2069. \u064A\u064F\u0642\u0631\u0623 \u062F\u0627\u0626\u0645\u064B\u0627 \u0645\u0646 \u0627\u0644\u064A\u0633\u0627\u0631 \u0625\u0644\u0649 \u0627\u0644\u064A\u0645\u064A\u0646."
            },
            client: {
              term: "\u0627\u0644\u062D\u0631\u064A\u0641",
              text: "\u0627\u0644\u062D\u0631\u064A\u0641 (\u0635\u0627\u062D\u0628 \u0627\u0644\u0645\u0634\u0631\u0648\u0639: \u0627\u0644\u0634\u062E\u0635 \u0623\u0648 \u0627\u0644\u062C\u0647\u0629 \u0627\u0644\u062A\u064A \u064A\u064F\u0646\u062C\u0632 \u0627\u0644\u0645\u0634\u0631\u0648\u0639 \u0645\u0646 \u0623\u062C\u0644\u0647\u0627). \u062A\u0638\u0647\u0631 \u0639\u0628\u0627\u0631\u0629 \xAB\u0628\u062F\u0648\u0646 \u062D\u0631\u064A\u0641\xBB \u0625\u0646 \u0644\u0645 \u064A\u064F\u062E\u062A\u0631 \u0628\u0639\u062F."
            },
            missionType: {
              term: "\u0646\u0648\u0639 \u0627\u0644\u0645\u0647\u0645\u0629",
              text: "\u0646\u0648\u0639 \u0645\u0647\u0645\u0629 \u0627\u0644\u0645\u0634\u0631\u0648\u0639 (\u0645\u0628\u0646\u0649 \u0639\u0645\u0648\u0645\u064A\u060C \u0641\u064A\u0644\u0627\u060C \u062E\u0628\u0631\u0629 \u0641\u0646\u064A\u0629\u2026). \u0641\u064A \u0627\u0644\u0634\u0628\u0643\u0629 \u064A\u0623\u062A\u064A \u0628\u0639\u062F \u0627\u0644\u0631\u0645\u0632 \u0641\u064A \u0627\u0644\u0633\u0637\u0631 \u0646\u0641\u0633\u0647."
            },
            status: {
              term: "\u0627\u0644\u062D\u0627\u0644\u0629",
              text: "\u0634\u0627\u0631\u0629 \u0645\u0644\u0648\u0646\u0629 \u062A\u0628\u064A\u0651\u0646 \u0648\u0636\u0639 \u0627\u0644\u0645\u0634\u0631\u0648\u0639: \u0645\u0633\u0648\u062F\u0629 \u0623\u0648 \u062C\u0627\u0631\u064D \u0623\u0648 \u0645\u062A\u0648\u0642\u0641 \u0645\u0624\u0642\u062A\u064B\u0627 \u0623\u0648 \u0645\u063A\u0644\u0642 \u0623\u0648 \u0645\u0624\u0631\u0634\u0641."
            },
            phase: {
              term: "\u0627\u0644\u0645\u0631\u0627\u062D\u0644",
              text: "\u062A\u0642\u062F\u0651\u0645 \u0627\u0644\u0645\u0631\u0627\u062D\u0644: \xAB\u0627\u0644\u0645\u0631\u0627\u062D\u0644 \u0627\u0644\u0645\u063A\u0644\u0642\u0629: \u20662 / 7\u2069\xBB \u0648\u0627\u0644\u0645\u0631\u062D\u0644\u0629 \u0627\u0644\u062D\u0627\u0644\u064A\u0629. \u062A\u0636\u064A\u0641 \u0627\u0644\u0634\u0628\u0643\u0629 \u0634\u0631\u064A\u0637 \u062A\u0642\u062F\u0651\u0645. \u062A\u0638\u0647\u0631 \xAB\u0644\u0627 \u062A\u0648\u062C\u062F \u0645\u0631\u0627\u062D\u0644\xBB \u0625\u0646 \u0644\u0645 \u062A\u0648\u062C\u062F \u0645\u0631\u0627\u062D\u0644 \u0628\u0639\u062F\u060C \u0648\xAB\u0643\u0644 \u0627\u0644\u0645\u0631\u0627\u062D\u0644 \u0645\u063A\u0644\u0642\u0629\xBB \u0639\u0646\u062F \u0627\u0646\u062A\u0647\u0627\u0621 \u0643\u0644 \u0634\u064A\u0621."
            }
          }
        },
        statuses: {
          title: "\u062D\u0627\u0644\u0627\u062A \u0627\u0644\u0645\u0634\u0631\u0648\u0639",
          items: {
            draft: {
              term: "\u0645\u0633\u0648\u062F\u0629",
              text: "\u0627\u0644\u0645\u0634\u0631\u0648\u0639 \u0642\u064A\u062F \u0627\u0644\u0625\u0639\u062F\u0627\u062F: \u0644\u0645 \u064A\u0646\u0637\u0644\u0642 \u0628\u0639\u062F."
            },
            active: {
              term: "\u062C\u0627\u0631\u064D",
              text: "\u0627\u0644\u0645\u0634\u0631\u0648\u0639 \u062C\u0627\u0631\u064D."
            },
            onHold: {
              term: "\u0645\u062A\u0648\u0642\u0641 \u0645\u0624\u0642\u062A\u064B\u0627",
              text: "\u0627\u0644\u0645\u0634\u0631\u0648\u0639 \u0645\u062A\u0648\u0642\u0641 \u0645\u0624\u0642\u062A\u064B\u0627 \u0648\u064A\u0645\u0643\u0646\u0647 \u0627\u0644\u0627\u0633\u062A\u0626\u0646\u0627\u0641."
            },
            closed: {
              term: "\u0645\u063A\u0644\u0642",
              text: "\u0627\u0646\u062A\u0647\u062A \u0627\u0644\u0645\u0647\u0645\u0629. \u064A\u0645\u0643\u0646 \u0625\u0639\u0627\u062F\u0629 \u0641\u062A\u062D \u0627\u0644\u0645\u0634\u0631\u0648\u0639 \u0639\u0646\u062F \u0627\u0644\u062D\u0627\u062C\u0629."
            },
            archived: {
              term: "\u0645\u0624\u0631\u0634\u0641",
              text: "\u0627\u0644\u0645\u0634\u0631\u0648\u0639 \u0645\u062D\u0641\u0648\u0638 \u0641\u064A \u0627\u0644\u0623\u0631\u0634\u064A\u0641: \u0644\u0627 \u064A\u0638\u0647\u0631 \u0641\u064A \u0627\u0644\u0642\u0648\u0627\u0626\u0645 \u0625\u0644\u0627 \u0628\u062A\u0635\u0641\u064A\u0629 \xAB\u0645\u0624\u0631\u0634\u0641\xBB."
            }
          }
        },
        missionTypes: {
          title: "\u0623\u0646\u0648\u0627\u0639 \u0627\u0644\u0645\u0647\u0627\u0645",
          items: {
            publicBuilding: {
              term: "\u0645\u0628\u0646\u0649 \u0639\u0645\u0648\u0645\u064A",
              text: "\u0645\u062F\u0631\u0633\u0629 \u0623\u0648 \u0628\u0644\u062F\u064A\u0629 \u0623\u0648 \u0645\u0633\u062A\u0648\u0635\u0641 \u0623\u0648 \u0623\u064A \u0645\u0628\u0646\u0649 \u0622\u062E\u0631 \u064A\u064F\u0646\u062C\u0632 \u0644\u0641\u0627\u0626\u062F\u0629 \u062C\u0647\u0629 \u0639\u0645\u0648\u0645\u064A\u0629."
            },
            collectiveHousing: {
              term: "\u0633\u0643\u0646 \u062C\u0645\u0627\u0639\u064A",
              text: "\u0639\u0645\u0627\u0631\u0629 \u0623\u0648 \u0625\u0642\u0627\u0645\u0629 \u062A\u0636\u0645 \u0639\u062F\u0629 \u0645\u0633\u0627\u0643\u0646."
            },
            villa: {
              term: "\u0641\u064A\u0644\u0627 \u0641\u0631\u062F\u064A\u0629",
              text: "\u0645\u0646\u0632\u0644 \u064A\u064F\u0628\u0646\u0649 \u0644\u0639\u0627\u0626\u0644\u0629 \u0648\u0627\u062D\u062F\u0629."
            },
            industrial: {
              term: "\u0645\u0628\u0646\u0649 \u0635\u0646\u0627\u0639\u064A",
              text: "\u0645\u0635\u0646\u0639 \u0623\u0648 \u0645\u062E\u0632\u0646 \u0623\u0648 \u0648\u0631\u0634\u0629."
            },
            facility: {
              term: "\u062A\u062C\u0647\u064A\u0632",
              text: "\u062A\u062C\u0647\u064A\u0632 \u062C\u0645\u0627\u0639\u064A\u060C \u0645\u062B\u0644 \u0627\u0644\u062A\u062C\u0647\u064A\u0632\u0627\u062A \u0627\u0644\u0631\u064A\u0627\u0636\u064A\u0629 \u0623\u0648 \u0627\u0644\u062B\u0642\u0627\u0641\u064A\u0629 \u0623\u0648 \u0627\u0644\u0635\u062D\u064A\u0629."
            },
            subdivisionVrd: {
              term: "\u062A\u0642\u0633\u064A\u0645 \u0639\u0642\u0627\u0631\u064A \u0648\u0637\u0631\u0642 \u0648\u0634\u0628\u0643\u0627\u062A \u0645\u062E\u062A\u0644\u0641\u0629 (\u2066VRD\u2069)",
              text: "\u062A\u0642\u0633\u064A\u0645 \u0623\u0631\u0636 \u0625\u0644\u0649 \u0645\u0642\u0627\u0633\u0645\u060C \u0645\u0639 \u0627\u0644\u0637\u0631\u0642 \u0648\u0627\u0644\u0634\u0628\u0643\u0627\u062A \u0627\u0644\u0645\u062E\u062A\u0644\u0641\u0629 (\u2066VRD\u2069: \u0627\u0644\u0637\u0631\u0642\u0627\u062A \u0648\u0627\u0644\u0645\u0627\u0621 \u0648\u0627\u0644\u062A\u0637\u0647\u064A\u0631 \u0648\u0627\u0644\u0643\u0647\u0631\u0628\u0627\u0621)."
            },
            expertise: {
              term: "\u062E\u0628\u0631\u0629 \u0641\u0646\u064A\u0629",
              text: "\u0645\u0647\u0645\u0629 \u0625\u0628\u062F\u0627\u0621 \u0631\u0623\u064A \u0641\u0646\u064A\u060C \u062F\u0648\u0646 \u062A\u0635\u0645\u064A\u0645 \u0645\u0628\u0646\u0649 \u062C\u062F\u064A\u062F."
            }
          }
        },
        newDialog: {
          title: "\u0645\u0634\u0631\u0648\u0639 \u062C\u062F\u064A\u062F",
          items: {
            missionType: {
              term: "\u0646\u0648\u0639 \u0627\u0644\u0645\u0647\u0645\u0629",
              text: "\u062D\u0642\u0644 \u0625\u0644\u0632\u0627\u0645\u064A. \u0627\u062E\u062A\u0631\u0647 \u0623\u0648\u0644\u064B\u0627: \u064A\u0646\u0637\u0644\u0642 \u0627\u0644\u0645\u0634\u0631\u0648\u0639 \u0628\u0627\u0644\u0645\u0631\u0627\u062D\u0644 \u0648\u0627\u0644\u0645\u062C\u0644\u062F\u0627\u062A \u0648\u0627\u0644\u0645\u0647\u0627\u0645 \u0627\u0644\u0645\u0639\u062A\u0627\u062F\u0629 \u0644\u0647\u0630\u0627 \u0627\u0644\u0646\u0648\u0639."
            },
            template: {
              term: "\u0645\u062D\u062A\u0648\u0649 \u0647\u0630\u0627 \u0627\u0644\u0646\u0645\u0648\u0630\u062C",
              text: "\u0645\u0639\u0627\u064A\u0646\u0629 \u062A\u062D\u062A \u0646\u0648\u0639 \u0627\u0644\u0645\u0647\u0645\u0629: \u0627\u0644\u0645\u0631\u0627\u062D\u0644 \u0628\u0627\u0644\u062A\u0631\u062A\u064A\u0628 (\u0645\u0639 \u062D\u0635\u0629 \u0627\u0644\u0623\u062A\u0639\u0627\u0628 \u0627\u0644\u0625\u0631\u0634\u0627\u062F\u064A\u0629 \u0625\u0646 \u0643\u0627\u0646 \u064A\u062D\u0642 \u0644\u0643 \u0631\u0624\u064A\u062A\u0647\u0627)\u060C \u062B\u0645 \u0639\u062F\u062F \u0627\u0644\u0645\u062C\u0644\u062F\u0627\u062A \u0627\u0644\u062A\u064A \u0633\u062A\u064F\u0646\u0634\u0623 \u0648\u0645\u0647\u0627\u0645 \u0627\u0644\u0627\u0646\u0637\u0644\u0627\u0642 \u0648\u0642\u0646\u0648\u0627\u062A \u0627\u0644\u0646\u0642\u0627\u0634. \u0625\u0646 \u062A\u0639\u0630\u0651\u0631 \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0645\u0639\u0627\u064A\u0646\u0629 \u064A\u0645\u0643\u0646\u0643 \u0645\u0639 \u0630\u0644\u0643 \u0625\u0646\u0634\u0627\u0621 \u0627\u0644\u0645\u0634\u0631\u0648\u0639."
            },
            name: {
              term: "\u0627\u0633\u0645 \u0627\u0644\u0645\u0634\u0631\u0648\u0639",
              text: "\u062D\u0642\u0644 \u0625\u0644\u0632\u0627\u0645\u064A\u060C 200 \u062D\u0631\u0641 \u0639\u0644\u0649 \u0627\u0644\u0623\u0643\u062B\u0631. \u0645\u062B\u0627\u0644: \xAB\u0627\u0644\u0645\u0639\u0647\u062F \u0627\u0644\u0646\u0645\u0648\u0630\u062C\u064A \u0628\u0627\u0644\u0642\u064A\u0631\u0648\u0627\u0646\xBB."
            },
            code: {
              term: "\u0631\u0645\u0632 \u0627\u0644\u0645\u0634\u0631\u0648\u0639",
              text: "\u0627\u062E\u062A\u064A\u0627\u0631\u064A\u060C 30 \u062D\u0631\u0641\u064B\u0627 \u0639\u0644\u0649 \u0627\u0644\u0623\u0643\u062B\u0631 (\u062D\u0631\u0648\u0641 \u0648\u0623\u0631\u0642\u0627\u0645 \u0648\u0627\u0644\u0631\u0645\u0648\u0632 . _ / -). \u0625\u0646 \u062A\u064F\u0631\u0643 \u0641\u0627\u0631\u063A\u064B\u0627 \u064A\u064F\u0648\u0644\u064E\u0651\u062F \u0631\u0645\u0632 \u062A\u0644\u0642\u0627\u0626\u064A\u064B\u0627\u060C \u0645\u062B\u0644 \u20662026-014\u2069. \u064A\u064F\u0631\u0641\u0636 \u0631\u0645\u0632 \u064A\u0633\u062A\u0639\u0645\u0644\u0647 \u0645\u0634\u0631\u0648\u0639 \u0622\u062E\u0631."
            },
            client: {
              term: "\u0627\u0644\u062D\u0631\u064A\u0641 (\u0635\u0627\u062D\u0628 \u0627\u0644\u0645\u0634\u0631\u0648\u0639)",
              text: "\u0627\u062E\u062A\u064A\u0627\u0631\u064A: \u0627\u062E\u062A\u0631 \u062D\u0631\u064A\u0641\u064B\u0627 \u0645\u0646 \u0627\u0644\u0645\u0643\u062A\u0628\u060C \u0623\u0648 \xAB\u0644\u0627 \u062D\u0631\u064A\u0641 \u062D\u0627\u0644\u064A\u064B\u0627\xBB. \u064A\u0645\u0643\u0646\u0643 \u0625\u0636\u0627\u0641\u062A\u0647 \u0644\u0627\u062D\u0642\u064B\u0627."
            },
            governorate: {
              term: "\u0627\u0644\u0648\u0644\u0627\u064A\u0629",
              text: "\u0627\u062E\u062A\u064A\u0627\u0631\u064A: \u0627\u0644\u0648\u0644\u0627\u064A\u0629 \u0627\u0644\u062A\u064A \u064A\u0642\u0639 \u0641\u064A\u0647\u0627 \u0627\u0644\u0645\u0634\u0631\u0648\u0639. \xAB\u063A\u064A\u0631 \u0645\u062D\u062F\u062F\u0629\xBB \u0627\u0641\u062A\u0631\u0627\u0636\u064A\u064B\u0627."
            },
            startsOn: {
              term: "\u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0627\u0646\u0637\u0644\u0627\u0642",
              text: "\u0627\u062E\u062A\u064A\u0627\u0631\u064A. \u0645\u0639 \u062A\u062D\u062F\u064A\u062F \u062A\u0627\u0631\u064A\u062E\u060C \u062A\u062D\u0635\u0644 \u0643\u0644 \u0645\u0631\u062D\u0644\u0629 \u0639\u0644\u0649 \u062A\u0648\u0627\u0631\u064A\u062E \u0625\u0631\u0634\u0627\u062F\u064A\u0629\u060C \u0627\u0644\u0648\u0627\u062D\u062F\u0629 \u0628\u0639\u062F \u0627\u0644\u0623\u062E\u0631\u0649."
            },
            submit: {
              term: "\u0625\u0646\u0634\u0627\u0621 \u0627\u0644\u0645\u0634\u0631\u0648\u0639",
              text: "\u064A\u0646\u0634\u0626 \u0627\u0644\u0645\u0634\u0631\u0648\u0639 \u0648\u064A\u0641\u062A\u062D \u0635\u0641\u062D\u062A\u0647 \u0645\u0628\u0627\u0634\u0631\u0629. \u064A\u063A\u0644\u0642 \xAB\u0625\u0644\u063A\u0627\u0621\xBB \u0627\u0644\u0646\u0627\u0641\u0630\u0629 \u062F\u0648\u0646 \u0625\u0646\u0634\u0627\u0621 \u0634\u064A\u0621. \u062A\u064F\u0634\u0627\u0631 \u0627\u0644\u062D\u0642\u0648\u0644 \u0627\u0644\u0625\u0644\u0632\u0627\u0645\u064A\u0629 \u0627\u0644\u0646\u0627\u0642\u0635\u0629 \u0628\u0627\u0644\u0644\u0648\u0646 \u0627\u0644\u0623\u062D\u0645\u0631."
            }
          }
        },
        leftPane: {
          title: "\u0645\u0634\u0627\u0631\u064A\u0639\u064A",
          items: {
            myProjects: {
              term: "\u0645\u0634\u0627\u0631\u064A\u0639\u064A",
              text: "\u064A\u0639\u0631\u0636 \u0627\u0644\u0634\u0631\u064A\u0637 \u0627\u0644\u062C\u0627\u0646\u0628\u064A \u0627\u0644\u0645\u0634\u0627\u0631\u064A\u0639 \u0627\u0644\u062A\u064A \u062A\u0634\u0627\u0631\u0643 \u0641\u064A\u0647\u0627 \u0645\u0639 \u0631\u0645\u0632 \u0643\u0644 \u0645\u0646\u0647\u0627. \u0627\u0646\u0642\u0631 \u0639\u0644\u0649 \u0627\u0633\u0645 \u0644\u0641\u062A\u062D \u0627\u0644\u0645\u0634\u0631\u0648\u0639\u061B \u0648\u064A\u064F\u0645\u064A\u064E\u0651\u0632 \u0627\u0644\u0645\u0634\u0631\u0648\u0639 \u0627\u0644\u0645\u0641\u062A\u0648\u062D. \u0625\u0646 \u0644\u0645 \u062A\u0643\u0646 \u0641\u064A \u0623\u064A \u0645\u0634\u0631\u0648\u0639 \u062A\u0642\u0631\u0623 \xAB\u0644\u0627 \u062A\u0634\u0627\u0631\u0643 \u0641\u064A \u0623\u064A \u0645\u0634\u0631\u0648\u0639 \u062D\u0627\u0644\u064A\u064B\u0627\xBB."
            },
            seeAll: {
              term: "\u0643\u0644 \u0627\u0644\u0645\u0634\u0627\u0631\u064A\u0639",
              text: "\u0631\u0627\u0628\u0637 \u062A\u062D\u062A \u0627\u0644\u0642\u0627\u0626\u0645\u0629 \u064A\u0639\u064A\u062F\u0643 \u0625\u0644\u0649 \u0647\u0630\u0647 \u0627\u0644\u0635\u0641\u062D\u0629."
            },
            sharedSpaces: {
              term: "\u0627\u0644\u0641\u0636\u0627\u0621\u0627\u062A \u0627\u0644\u0645\u0634\u062A\u0631\u0643\u0629",
              text: "\u062A\u062D\u062A\u0647 \u0641\u0636\u0627\u0621\u0627\u062A\u0643 \u0627\u0644\u0645\u0634\u062A\u0631\u0643\u0629 \u0645\u0639 \u0645\u0624\u0633\u0633\u0627\u062A \u0623\u062E\u0631\u0649\u061B \u0648\u064A\u062D\u0645\u0644 \u0641\u0636\u0627\u0621 \u0645\u0624\u0633\u0633\u0629 \u0623\u062E\u0631\u0649 \u0639\u0628\u0627\u0631\u0629 \xAB\u062A\u0633\u062A\u0636\u064A\u0641\u0647 \u2026\xBB. \u064A\u0639\u0631\u0636\u0647\u0627 \u0631\u0627\u0628\u0637 \xAB\u0643\u0644 \u0627\u0644\u0641\u0636\u0627\u0621\u0627\u062A \u0627\u0644\u0645\u0634\u062A\u0631\u0643\u0629\xBB \u0643\u0644\u0647\u0627."
            }
          }
        },
        empty: {
          title: "\u0631\u0633\u0627\u0626\u0644 \u0627\u0644\u062D\u0627\u0644\u0629",
          items: {
            none: {
              term: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0645\u0634\u0627\u0631\u064A\u0639 \u0628\u0639\u062F",
              text: "\u062A\u0638\u0647\u0631 \u0639\u0646\u062F\u0645\u0627 \u0644\u0627 \u064A\u0645\u0644\u0643 \u0627\u0644\u0645\u0643\u062A\u0628 \u0623\u064A \u0645\u0634\u0631\u0648\u0639 \u0628\u0639\u062F. \u0625\u0646 \u0643\u0627\u0646 \u0628\u0625\u0645\u0643\u0627\u0646\u0643 \u0625\u0646\u0634\u0627\u0621 \u0645\u0634\u0627\u0631\u064A\u0639 \u064A\u064F\u0639\u0631\u0636 \u0632\u0631 \xAB\u0645\u0634\u0631\u0648\u0639 \u062C\u062F\u064A\u062F\xBB\u061B \u0648\u0625\u0644\u0627 \u0641\u0627\u0637\u0644\u0628 \u0645\u0646 \u0645\u0633\u0624\u0648\u0644 \u0625\u0636\u0627\u0641\u062A\u0643 \u0625\u0644\u0649 \u0645\u0634\u0631\u0648\u0639."
            },
            noMatch: {
              term: "\u0644\u0627 \u064A\u0648\u062C\u062F \u0645\u0634\u0631\u0648\u0639 \u0645\u0637\u0627\u0628\u0642",
              text: "\u062A\u0638\u0647\u0631 \u0639\u0646\u062F\u0645\u0627 \u0644\u0627 \u064A\u062C\u062F \u0627\u0644\u0628\u062D\u062B \u0623\u0648 \u0627\u0644\u062A\u0635\u0641\u064A\u0627\u062A \u0634\u064A\u0626\u064B\u0627. \u062C\u0631\u0651\u0628 \u0627\u0633\u0645\u064B\u0627 \u0622\u062E\u0631 \u0623\u0648 \u062D\u0627\u0644\u0629 \u0623\u062E\u0631\u0649\u060C \u0623\u0648 \u0627\u0633\u062A\u0639\u0645\u0644 \xAB\u0645\u0633\u062D \u0627\u0644\u062A\u0635\u0641\u064A\u0627\u062A\xBB."
            },
            loadFailed: {
              term: "\u062A\u0639\u0630\u0651\u0631 \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0645\u0634\u0627\u0631\u064A\u0639",
              text: "\u0631\u0633\u0627\u0644\u0629 \u062D\u0645\u0631\u0627\u0621 \u0639\u0646\u062F \u0648\u062C\u0648\u062F \u0645\u0634\u0643\u0644\u0629 \u0641\u064A \u0627\u0644\u0627\u062A\u0635\u0627\u0644. \u062A\u062D\u0642\u0642 \u0645\u0646 \u0627\u062A\u0635\u0627\u0644\u0643 \u062B\u0645 \u0627\u0646\u0642\u0631 \u0639\u0644\u0649 \xAB\u0625\u0639\u0627\u062F\u0629 \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629\xBB."
            }
          }
        }
      }
    },
    project: {
      posts: {
        title: "\u0627\u0644\u0645\u0646\u0634\u0648\u0631\u0627\u062A",
        intro: "\u062A\u0628\u0648\u064A\u0628 \u0645\u0631\u0627\u0633\u0644\u0627\u062A \u0627\u0644\u0645\u0634\u0631\u0648\u0639. \u0641\u064A \u0627\u0644\u0648\u0642\u062A \u0627\u0644\u062D\u0627\u0644\u064A \u064A\u0643\u062A\u0641\u064A \u0628\u0627\u0644\u0625\u0639\u0644\u0627\u0646 \u0639\u0645\u0651\u0627 \u0633\u064A\u062D\u062A\u0648\u064A\u0647: \u0646\u0642\u0627\u0634\u0627\u062A \u062D\u0633\u0628 \u0627\u0644\u0627\u062E\u062A\u0635\u0627\u0635.",
        sections: {
          summary: {
            title: "\u0645\u0644\u062E\u0635 \u0627\u0644\u0645\u0634\u0631\u0648\u0639",
            items: {
              breadcrumb: {
                term: "\u0627\u0644\u0645\u0634\u0627\u0631\u064A\u0639",
                text: "\u0645\u0633\u0627\u0631 \u0627\u0644\u062A\u0646\u0642\u0644 \u0641\u064A \u0623\u0639\u0644\u0649 \u0627\u0644\u0635\u0641\u062D\u0629. \u0627\u0646\u0642\u0631 \u0639\u0644\u0649 \xAB\u0627\u0644\u0645\u0634\u0627\u0631\u064A\u0639\xBB \u0644\u0644\u0639\u0648\u062F\u0629 \u0625\u0644\u0649 \u0627\u0644\u0642\u0627\u0626\u0645\u0629\u061B \u0648\u0628\u062C\u0627\u0646\u0628\u0647 \u062A\u0631\u0649 \u0627\u0633\u0645 \u0627\u0644\u0645\u0634\u0631\u0648\u0639 \u0627\u0644\u0645\u0641\u062A\u0648\u062D."
              },
              meeting: {
                term: "\u0628\u062F\u0621 \u0627\u062C\u062A\u0645\u0627\u0639",
                text: "\u0632\u0631 \u0641\u064A \u0623\u0639\u0644\u0649 \u0627\u0644\u0635\u0641\u062D\u0629 \u0644\u0623\u0639\u0636\u0627\u0621 \u0627\u0644\u0645\u0634\u0631\u0648\u0639 \u0627\u0644\u0642\u0627\u062F\u0631\u064A\u0646 \u0639\u0644\u0649 \u0627\u0644\u0645\u0633\u0627\u0647\u0645\u0629. \u064A\u0637\u0644\u0628 \u0639\u0646\u0648\u0627\u0646 \u0627\u0644\u0627\u062C\u062A\u0645\u0627\u0639 \u062B\u0645 \u064A\u0641\u062A\u062D \u0642\u0627\u0639\u0629 \u0627\u0644\u0627\u062C\u062A\u0645\u0627\u0639."
              },
              code: {
                term: "\u0627\u0644\u0631\u0645\u0632",
                text: "\u0631\u0645\u0632 \u0627\u0644\u0645\u0634\u0631\u0648\u0639\u060C \u064A\u064F\u0633\u062A\u0639\u0645\u0644 \u0641\u064A \u0648\u062B\u0627\u0626\u0642\u0647 \u0648\u0641\u0648\u0627\u062A\u064A\u0631\u0647."
              },
              client: {
                term: "\u0627\u0644\u062D\u0631\u064A\u0641",
                text: "\u062D\u0631\u064A\u0641 \u0627\u0644\u0645\u0634\u0631\u0648\u0639 (\u0635\u0627\u062D\u0628 \u0627\u0644\u0645\u0634\u0631\u0648\u0639)\u060C \u0623\u0648 \xAB\u0628\u062F\u0648\u0646 \u062D\u0631\u064A\u0641\xBB \u0625\u0646 \u0644\u0645 \u064A\u064F\u062F\u062E\u064E\u0644 \u0628\u0639\u062F."
              },
              status: {
                term: "\u0627\u0644\u062D\u0627\u0644\u0629",
                text: "\u0634\u0627\u0631\u0629 \u062A\u0628\u064A\u0651\u0646 \u062D\u0627\u0644\u0629 \u0627\u0644\u0645\u0634\u0631\u0648\u0639: \u0645\u0633\u0648\u062F\u0629 \u0623\u0648 \u062C\u0627\u0631\u064D \u0623\u0648 \u0645\u062A\u0648\u0642\u0641 \u0645\u0624\u0642\u062A\u064B\u0627 \u0623\u0648 \u0645\u063A\u0644\u0642 \u0623\u0648 \u0645\u0624\u0631\u0634\u0641. \u062A\u064F\u063A\u064A\u064E\u0651\u0631 \u0641\u064A \u062A\u0628\u0648\u064A\u0628 \u0627\u0644\u0625\u0639\u062F\u0627\u062F\u0627\u062A."
              },
              progress: {
                term: "\u0627\u0644\u0645\u0631\u0627\u062D\u0644 \u0627\u0644\u0645\u063A\u0644\u0642\u0629: \u20662 / 7\u2069",
                text: "\u0634\u0631\u064A\u0637 \u062A\u0642\u062F\u0651\u0645 \u0648\u0639\u062F\u062F \u0627\u0644\u0645\u0631\u0627\u062D\u0644 \u0627\u0644\u0645\u063A\u0644\u0642\u0629\u060C \u0645\u0639 \u0627\u0644\u0645\u0631\u062D\u0644\u0629 \u0627\u0644\u062D\u0627\u0644\u064A\u0629. \u0639\u0646\u062F \u0627\u0646\u062A\u0647\u0627\u0621 \u0643\u0644 \u0634\u064A\u0621 \u062A\u0642\u0631\u0623 \xAB\u0643\u0644 \u0627\u0644\u0645\u0631\u0627\u062D\u0644 \u0645\u063A\u0644\u0642\u0629\xBB."
              },
              tabs: {
                term: "\u0627\u0644\u0645\u0646\u0634\u0648\u0631\u0627\u062A\u060C \u0627\u0644\u0645\u0644\u0641\u0627\u062A\u060C \u0627\u0644\u0645\u0647\u0627\u0645\u060C \u0627\u0644\u0645\u0631\u0627\u062D\u0644\u060C \u0627\u0644\u0645\u062E\u0631\u062C\u0627\u062A\u060C \u0627\u0644\u062A\u0623\u0634\u064A\u0631\u0627\u062A\u060C \u0627\u0644\u0631\u0632\u0646\u0627\u0645\u0629\u060C \u0627\u0644\u0645\u0627\u0644\u064A\u0629\u060C \u0627\u0644\u0625\u0639\u062F\u0627\u062F\u0627\u062A",
                text: "\u062A\u0628\u0648\u064A\u0628\u0627\u062A \u0627\u0644\u0645\u0634\u0631\u0648\u0639. \u064A\u064F\u062D\u0641\u0638 \u0627\u0644\u062A\u0628\u0648\u064A\u0628 \u0627\u0644\u0645\u0641\u062A\u0648\u062D \u0641\u064A \u0639\u0646\u0648\u0627\u0646 \u0627\u0644\u0635\u0641\u062D\u0629. \u0644\u0627 \u064A\u0638\u0647\u0631 \u062A\u0628\u0648\u064A\u0628 \u0627\u0644\u0645\u0627\u0644\u064A\u0629 \u0625\u0644\u0627 \u0644\u0645\u0646 \u064A\u0645\u0644\u0643 \u062D\u0642 \u0627\u0644\u0627\u0637\u0644\u0627\u0639 \u0639\u0644\u0649 \u0627\u0644\u0639\u0631\u0648\u0636 \u0627\u0644\u0645\u0627\u0644\u064A\u0629 \u0623\u0648 \u0627\u0644\u0641\u0648\u0627\u062A\u064A\u0631 \u0623\u0648 \u0627\u0644\u0639\u0642\u0648\u062F."
              },
              notFound: {
                term: "\u0627\u0644\u0645\u0634\u0631\u0648\u0639 \u063A\u064A\u0631 \u0645\u0648\u062C\u0648\u062F",
                text: "\u062A\u0638\u0647\u0631 \u0625\u0630\u0627 \u0643\u0627\u0646 \u0627\u0644\u0645\u0634\u0631\u0648\u0639 \u063A\u064A\u0631 \u0645\u0648\u062C\u0648\u062F \u0623\u0648 \u0644\u0645 \u062A\u0643\u0646 \u0639\u0636\u0648\u064B\u0627 \u0641\u064A\u0647\u061B \u0648\u064A\u0639\u064A\u062F\u0643 \u0632\u0631 \xAB\u0627\u0644\u0639\u0648\u062F\u0629 \u0625\u0644\u0649 \u0627\u0644\u0645\u0634\u0627\u0631\u064A\u0639\xBB \u0625\u0644\u0649 \u0627\u0644\u0642\u0627\u0626\u0645\u0629. \u0639\u0646\u062F \u0645\u0634\u0643\u0644\u0629 \u0641\u064A \u0627\u0644\u0627\u062A\u0635\u0627\u0644 \u062A\u0639\u0631\u0636 \xAB\u062A\u0639\u0630\u0651\u0631 \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0645\u0634\u0631\u0648\u0639\xBB \u0632\u0631 \xAB\u0625\u0639\u0627\u062F\u0629 \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629\xBB."
              }
            }
          },
          meeting: {
            title: "\u0628\u062F\u0621 \u0627\u062C\u062A\u0645\u0627\u0639",
            items: {
              titleField: {
                term: "\u0639\u0646\u0648\u0627\u0646 \u0627\u0644\u0627\u062C\u062A\u0645\u0627\u0639",
                text: "\u062D\u0642\u0644 \u0625\u0644\u0632\u0627\u0645\u064A\u060C 200 \u062D\u0631\u0641 \u0639\u0644\u0649 \u0627\u0644\u0623\u0643\u062B\u0631. \u064A\u0623\u062A\u064A \u0645\u0639\u0628\u0651\u0623\u064B \u0645\u0633\u0628\u0642\u064B\u0627 \u0628\u0639\u0628\u0627\u0631\u0629 \xAB\u0627\u062C\u062A\u0645\u0627\u0639 -\xBB \u0645\u062A\u0628\u0648\u0639\u0629 \u0628\u0627\u0633\u0645 \u0627\u0644\u0645\u0634\u0631\u0648\u0639."
              },
              start: {
                term: "\u0628\u062F\u0621",
                text: "\u064A\u0646\u0634\u0626 \u0627\u0644\u0627\u062C\u062A\u0645\u0627\u0639 \u0648\u064A\u0623\u062E\u0630\u0643 \u0625\u0644\u0649 \u0642\u0627\u0639\u062A\u0647. \u064A\u0645\u0643\u0646 \u0644\u0623\u0639\u0636\u0627\u0621 \u0627\u0644\u0645\u0634\u0631\u0648\u0639 \u0627\u0644\u0627\u0646\u0636\u0645\u0627\u0645 \u0625\u0644\u064A\u0647."
              },
              cancel: {
                term: "\u0625\u0644\u063A\u0627\u0621",
                text: "\u064A\u063A\u0644\u0642 \u0627\u0644\u0646\u0627\u0641\u0630\u0629 \u062F\u0648\u0646 \u0625\u0646\u0634\u0627\u0621 \u0627\u062C\u062A\u0645\u0627\u0639."
              }
            }
          },
          placeholder: {
            title: "\u0633\u062A\u0638\u0647\u0631 \u0647\u0646\u0627 \u0645\u0631\u0627\u0633\u0644\u0627\u062A \u0627\u0644\u0645\u0634\u0631\u0648\u0639",
            items: {
              message: {
                term: "\u0633\u062A\u0638\u0647\u0631 \u0647\u0646\u0627 \u0645\u0631\u0627\u0633\u0644\u0627\u062A \u0627\u0644\u0645\u0634\u0631\u0648\u0639",
                text: "\u0631\u0633\u0627\u0644\u0629 \u062A\u0638\u0647\u0631 \u0641\u064A \u0648\u0633\u0637 \u0627\u0644\u062A\u0628\u0648\u064A\u0628: \u0646\u0642\u0627\u0634\u0627\u062A \u0627\u0644\u0645\u0634\u0631\u0648\u0639 \u063A\u064A\u0631 \u0645\u062A\u0627\u062D\u0629 \u0628\u0639\u062F \u0641\u064A \u0647\u0630\u0627 \u0627\u0644\u062A\u0628\u0648\u064A\u0628."
              },
              channels: {
                term: "\u0642\u0646\u0648\u0627\u062A \u0627\u0644\u0646\u0642\u0627\u0634 \u062D\u0633\u0628 \u0627\u0644\u0627\u062E\u062A\u0635\u0627\u0635",
                text: "\u0623\u064F\u0639\u0644\u0646 \u0639\u0646\u0647\u0627 \u062D\u0633\u0628 \u0627\u0644\u0627\u062E\u062A\u0635\u0627\u0635 (\u0647\u0646\u062F\u0633\u0629 \u0645\u0639\u0645\u0627\u0631\u064A\u0629\u060C \u0647\u064A\u0627\u0643\u0644\u060C \u0637\u0631\u0642\u0627\u062A \u0648\u0634\u0628\u0643\u0627\u062A\u2026): \u0633\u062A\u0638\u0647\u0631 \u0645\u0646\u0634\u0648\u0631\u0627\u062A\u0647\u0627 \u0641\u064A \u0647\u0630\u0627 \u0627\u0644\u062A\u0628\u0648\u064A\u0628."
              }
            }
          }
        }
      },
      files: {
        title: "\u0627\u0644\u0645\u0644\u0641\u0627\u062A",
        intro: "\u0643\u0644 \u0648\u062B\u0627\u0626\u0642 \u0627\u0644\u0645\u0634\u0631\u0648\u0639\u060C \u0645\u0635\u0646\u0651\u0641\u0629 \u0641\u064A \u0645\u062C\u0644\u062F\u0627\u062A. \u062A\u0636\u064A\u0641 \u0627\u0644\u0645\u0644\u0641\u0627\u062A \u0648\u062A\u062C\u062F \u0627\u0644\u0648\u062B\u064A\u0642\u0629 \u0648\u062A\u062A\u0627\u0628\u0639 \u0646\u0633\u062E\u0647\u0627 \u0648\u062A\u0637\u0644\u0628 \u062A\u0623\u0634\u064A\u0631\u062A\u0647\u0627.",
        sections: {
          summary: {
            title: "\u0645\u0644\u062E\u0635 \u0627\u0644\u0645\u0634\u0631\u0648\u0639",
            items: {
              breadcrumb: {
                term: "\u0627\u0644\u0645\u0634\u0627\u0631\u064A\u0639",
                text: "\u0645\u0633\u0627\u0631 \u0627\u0644\u062A\u0646\u0642\u0644 \u0641\u064A \u0623\u0639\u0644\u0649 \u0627\u0644\u0635\u0641\u062D\u0629. \u0627\u0646\u0642\u0631 \u0639\u0644\u0649 \xAB\u0627\u0644\u0645\u0634\u0627\u0631\u064A\u0639\xBB \u0644\u0644\u0639\u0648\u062F\u0629 \u0625\u0644\u0649 \u0627\u0644\u0642\u0627\u0626\u0645\u0629\u061B \u0648\u0628\u062C\u0627\u0646\u0628\u0647 \u062A\u0631\u0649 \u0627\u0633\u0645 \u0627\u0644\u0645\u0634\u0631\u0648\u0639 \u0627\u0644\u0645\u0641\u062A\u0648\u062D."
              },
              meeting: {
                term: "\u0628\u062F\u0621 \u0627\u062C\u062A\u0645\u0627\u0639",
                text: "\u0632\u0631 \u0641\u064A \u0623\u0639\u0644\u0649 \u0627\u0644\u0635\u0641\u062D\u0629 \u0644\u0623\u0639\u0636\u0627\u0621 \u0627\u0644\u0645\u0634\u0631\u0648\u0639 \u0627\u0644\u0642\u0627\u062F\u0631\u064A\u0646 \u0639\u0644\u0649 \u0627\u0644\u0645\u0633\u0627\u0647\u0645\u0629. \u064A\u0637\u0644\u0628 \u0639\u0646\u0648\u0627\u0646 \u0627\u0644\u0627\u062C\u062A\u0645\u0627\u0639 \u062B\u0645 \u064A\u0641\u062A\u062D \u0642\u0627\u0639\u0629 \u0627\u0644\u0627\u062C\u062A\u0645\u0627\u0639."
              },
              code: {
                term: "\u0627\u0644\u0631\u0645\u0632",
                text: "\u0631\u0645\u0632 \u0627\u0644\u0645\u0634\u0631\u0648\u0639\u060C \u064A\u064F\u0633\u062A\u0639\u0645\u0644 \u0641\u064A \u0648\u062B\u0627\u0626\u0642\u0647 \u0648\u0641\u0648\u0627\u062A\u064A\u0631\u0647."
              },
              client: {
                term: "\u0627\u0644\u062D\u0631\u064A\u0641",
                text: "\u062D\u0631\u064A\u0641 \u0627\u0644\u0645\u0634\u0631\u0648\u0639 (\u0635\u0627\u062D\u0628 \u0627\u0644\u0645\u0634\u0631\u0648\u0639)\u060C \u0623\u0648 \xAB\u0628\u062F\u0648\u0646 \u062D\u0631\u064A\u0641\xBB \u0625\u0646 \u0644\u0645 \u064A\u064F\u062F\u062E\u064E\u0644 \u0628\u0639\u062F."
              },
              status: {
                term: "\u0627\u0644\u062D\u0627\u0644\u0629",
                text: "\u0634\u0627\u0631\u0629 \u062A\u0628\u064A\u0651\u0646 \u062D\u0627\u0644\u0629 \u0627\u0644\u0645\u0634\u0631\u0648\u0639: \u0645\u0633\u0648\u062F\u0629 \u0623\u0648 \u062C\u0627\u0631\u064D \u0623\u0648 \u0645\u062A\u0648\u0642\u0641 \u0645\u0624\u0642\u062A\u064B\u0627 \u0623\u0648 \u0645\u063A\u0644\u0642 \u0623\u0648 \u0645\u0624\u0631\u0634\u0641."
              },
              progress: {
                term: "\u0627\u0644\u0645\u0631\u0627\u062D\u0644 \u0627\u0644\u0645\u063A\u0644\u0642\u0629: \u20662 / 7\u2069",
                text: "\u0634\u0631\u064A\u0637 \u062A\u0642\u062F\u0651\u0645 \u0648\u0639\u062F\u062F \u0627\u0644\u0645\u0631\u0627\u062D\u0644 \u0627\u0644\u0645\u063A\u0644\u0642\u0629\u060C \u0645\u0639 \u0627\u0644\u0645\u0631\u062D\u0644\u0629 \u0627\u0644\u062D\u0627\u0644\u064A\u0629."
              },
              tabs: {
                term: "\u0627\u0644\u0645\u0646\u0634\u0648\u0631\u0627\u062A\u060C \u0627\u0644\u0645\u0644\u0641\u0627\u062A\u060C \u0627\u0644\u0645\u0647\u0627\u0645\u060C \u0627\u0644\u0645\u0631\u0627\u062D\u0644\u060C \u0627\u0644\u0645\u062E\u0631\u062C\u0627\u062A\u060C \u0627\u0644\u062A\u0623\u0634\u064A\u0631\u0627\u062A\u060C \u0627\u0644\u0631\u0632\u0646\u0627\u0645\u0629\u060C \u0627\u0644\u0645\u0627\u0644\u064A\u0629\u060C \u0627\u0644\u0625\u0639\u062F\u0627\u062F\u0627\u062A",
                text: "\u062A\u0628\u0648\u064A\u0628\u0627\u062A \u0627\u0644\u0645\u0634\u0631\u0648\u0639. \u0623\u0646\u062A \u0627\u0644\u0622\u0646 \u0641\u064A \xAB\u0627\u0644\u0645\u0644\u0641\u0627\u062A\xBB."
              },
              noSpace: {
                term: "\u0645\u0633\u0627\u062D\u0629 \u0627\u0644\u0645\u0644\u0641\u0627\u062A \u0644\u064A\u0633\u062A \u062C\u0627\u0647\u0632\u0629 \u0628\u0639\u062F",
                text: "\u062A\u0638\u0647\u0631 \u0625\u0630\u0627 \u0644\u0645 \u062A\u064F\u0646\u0634\u0623 \u0628\u0639\u062F \u0627\u0644\u0645\u0633\u0627\u062D\u0629 \u0627\u0644\u062F\u0627\u062E\u0644\u064A\u0629 \u0644\u0644\u0645\u0634\u0631\u0648\u0639. \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629 \u0628\u0639\u062F \u0642\u0644\u064A\u0644 \u0623\u0648 \u062A\u0648\u0627\u0635\u0644 \u0645\u0639 \u0623\u062D\u062F \u0645\u0633\u0624\u0648\u0644\u064A \u0627\u0644\u0645\u0634\u0631\u0648\u0639."
              }
            }
          },
          folders: {
            title: "\u0645\u062C\u0644\u062F\u0627\u062A \u0627\u0644\u0645\u0634\u0631\u0648\u0639",
            items: {
              tree: {
                term: "\u0645\u062C\u0644\u062F\u0627\u062A \u0627\u0644\u0645\u0634\u0631\u0648\u0639",
                text: "\u0634\u062C\u0631\u0629 \u0627\u0644\u0645\u062C\u0644\u062F\u0627\u062A \u0639\u0644\u0649 \u0627\u0644\u062C\u0627\u0646\u0628. \xAB\u0643\u0644 \u0627\u0644\u0645\u062C\u0644\u062F\u0627\u062A\xBB \u0647\u0648 \u062C\u0630\u0631 \u0627\u0644\u0645\u0634\u0631\u0648\u0639\u061B \u0627\u0646\u0642\u0631 \u0639\u0644\u0649 \u0645\u062C\u0644\u062F \u0644\u0641\u062A\u062D\u0647."
              },
              path: {
                term: "\u0645\u0633\u0627\u0631 \u0627\u0644\u0645\u062C\u0644\u062F",
                text: "\u0645\u0633\u0627\u0631 \u0627\u0644\u0645\u062C\u0644\u062F \u0627\u0644\u0645\u0641\u062A\u0648\u062D \u0641\u064A \u0623\u0639\u0644\u0649 \u0627\u0644\u0645\u062D\u062A\u0648\u0649. \u0627\u0646\u0642\u0631 \u0639\u0644\u0649 \u0645\u0633\u062A\u0648\u0649 \u0644\u0644\u0635\u0639\u0648\u062F \u0625\u0644\u064A\u0647. \u064A\u0638\u0647\u0631 \u0627\u0644\u0645\u062C\u0644\u062F \u0627\u0644\u0630\u064A \u0644\u0627 \u064A\u0645\u0643\u0646\u0643 \u0627\u0644\u0648\u0635\u0648\u0644 \u0625\u0644\u064A\u0647 \u0639\u0644\u0649 \u0634\u0643\u0644 \xAB\u2026\xBB."
              },
              subfolders: {
                term: "\u0627\u0644\u0645\u062C\u0644\u062F\u0627\u062A \u0627\u0644\u0641\u0631\u0639\u064A\u0629",
                text: "\u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u0645\u062C\u0644\u062F\u0627\u062A \u0627\u0644\u0645\u0648\u062C\u0648\u062F\u0629 \u062F\u0627\u062E\u0644 \u0627\u0644\u0645\u062C\u0644\u062F \u0627\u0644\u0645\u0641\u062A\u0648\u062D. \u0627\u0646\u0642\u0631 \u0639\u0644\u0649 \u0623\u062D\u062F\u0647\u0627 \u0644\u0641\u062A\u062D\u0647."
              },
              newFolder: {
                term: "\u0645\u062C\u0644\u062F \u062C\u062F\u064A\u062F",
                text: "\u064A\u0646\u0634\u0626 \u0645\u062C\u0644\u062F\u064B\u0627 \u062F\u0627\u062E\u0644 \u0627\u0644\u0645\u062C\u0644\u062F \u0627\u0644\u0645\u0641\u062A\u0648\u062D (\u0623\u0648 \u0641\u064A \u0627\u0644\u062C\u0630\u0631). \u0644\u0644\u0623\u0634\u062E\u0627\u0635 \u0627\u0644\u0642\u0627\u062F\u0631\u064A\u0646 \u0639\u0644\u0649 \u0627\u0644\u0643\u062A\u0627\u0628\u0629 \u0641\u064A \u0630\u0644\u0643 \u0627\u0644\u0645\u0643\u0627\u0646\u061B \u0648\u0641\u064A \u0627\u0644\u062C\u0630\u0631 \u0644\u0645\u0633\u0624\u0648\u0644\u064A \u0627\u0644\u0645\u0634\u0631\u0648\u0639 \u0641\u0642\u0637."
              },
              customRights: {
                term: "\u0635\u0644\u0627\u062D\u064A\u0627\u062A \u0645\u062E\u0635\u0651\u0635\u0629",
                text: "\u0634\u0627\u0631\u0629 \u0628\u0642\u0641\u0644: \u0644\u0647\u0630\u0627 \u0627\u0644\u0645\u062C\u0644\u062F \u0642\u0627\u0626\u0645\u062A\u0647 \u0627\u0644\u062E\u0627\u0635\u0629 \u0628\u0627\u0644\u0623\u0634\u062E\u0627\u0635 \u0627\u0644\u0645\u0633\u0645\u0648\u062D \u0644\u0647\u0645\u060C \u062A\u062E\u062A\u0644\u0641 \u0639\u0646 \u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u0645\u062C\u0644\u062F \u0627\u0644\u0623\u0635\u0644\u064A \u0623\u0648 \u0627\u0644\u0645\u0634\u0631\u0648\u0639."
              },
              more: {
                term: "\u0625\u062C\u0631\u0627\u0621\u0627\u062A \u0623\u062E\u0631\u0649",
                text: "\u0632\u0631 \xAB\u2026\xBB \u0627\u0644\u062E\u0627\u0635 \u0628\u0645\u062C\u0644\u062F\u060C \u0644\u0645\u0633\u0624\u0648\u0644\u064A\u0647. \u064A\u0642\u062A\u0631\u062D \u0625\u0639\u0627\u062F\u0629 \u0627\u0644\u062A\u0633\u0645\u064A\u0629\u2026 \u0648\u0627\u0644\u0646\u0642\u0644\u2026 \u0648\u0627\u0644\u0635\u0644\u0627\u062D\u064A\u0627\u062A\u2026 \u0648\u0627\u0644\u062D\u0630\u0641."
              },
              trash: {
                term: "\u0633\u0644\u0629 \u0627\u0644\u0645\u062D\u0630\u0648\u0641\u0627\u062A",
                text: "\u0632\u0631 \u062A\u062D\u062A \u0627\u0644\u0634\u062C\u0631\u0629: \u064A\u0639\u0631\u0636 \u0627\u0644\u0645\u062C\u0644\u062F\u0627\u062A \u0648\u0627\u0644\u0648\u062B\u0627\u0626\u0642 \u0627\u0644\u0645\u062D\u0630\u0648\u0641\u0629 \u0628\u062F\u0644 \u0627\u0644\u0645\u0644\u0641\u0627\u062A. \u0627\u0646\u0642\u0631 \u0645\u0631\u0629 \u0623\u062E\u0631\u0649\u060C \u0623\u0648 \u0639\u0644\u0649 \xAB\u0627\u0644\u0639\u0648\u062F\u0629 \u0625\u0644\u0649 \u0627\u0644\u0645\u0644\u0641\u0627\u062A\xBB\u060C \u0644\u0644\u0631\u062C\u0648\u0639."
              },
              empty: {
                term: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0645\u062C\u0644\u062F\u0627\u062A \u0628\u0639\u062F",
                text: "\u062A\u0638\u0647\u0631 \u0639\u0646\u062F\u0645\u0627 \u0644\u0627 \u064A\u062D\u062A\u0648\u064A \u0627\u0644\u0645\u0634\u0631\u0648\u0639 \u0639\u0644\u0649 \u0623\u064A \u0645\u062C\u0644\u062F. \u064A\u0645\u0643\u0646 \u0644\u0623\u062D\u062F \u0627\u0644\u0645\u0633\u0624\u0648\u0644\u064A\u0646 \u0625\u0646\u0634\u0627\u0621 \u0623\u0648\u0644 \u0645\u062C\u0644\u062F \u0623\u0648 \u0645\u0646\u062D\u0643 \u062D\u0642 \u0627\u0644\u0648\u0635\u0648\u0644. \u0641\u064A \u0645\u062C\u0644\u062F \u0628\u0644\u0627 \u0645\u062C\u0644\u062F\u0627\u062A \u0641\u0631\u0639\u064A\u0629 \u062A\u0642\u0631\u0623 \xAB\u0644\u0627 \u064A\u062D\u062A\u0648\u064A \u0647\u0630\u0627 \u0627\u0644\u0645\u062C\u0644\u062F \u0639\u0644\u0649 \u0645\u062C\u0644\u062F\u0627\u062A \u0641\u0631\u0639\u064A\u0629 \u0628\u0639\u062F\xBB."
              }
            }
          },
          upload: {
            title: "\u0625\u0636\u0627\u0641\u0629 \u0627\u0644\u0645\u0644\u0641\u0627\u062A",
            items: {
              zone: {
                term: "\u0627\u0633\u062D\u0628 \u0627\u0644\u0645\u0644\u0641\u0627\u062A \u0623\u0648 \u0627\u0644\u0645\u062C\u0644\u062F\u0627\u062A \u0648\u0623\u0641\u0644\u062A\u0647\u0627 \u0647\u0646\u0627",
                text: "\u0645\u0646\u0637\u0642\u0629 \u062A\u0638\u0647\u0631 \u0641\u064A \u0645\u062C\u0644\u062F \u064A\u0645\u0643\u0646\u0643 \u0627\u0644\u0643\u062A\u0627\u0628\u0629 \u0641\u064A\u0647. \u0623\u0641\u0644\u062A \u0627\u0644\u0645\u0644\u0641\u0627\u062A \u0639\u0644\u064A\u0647\u0627: \u062A\u0638\u0647\u0631 \u0639\u0628\u0627\u0631\u0629 \xAB\u0623\u0641\u0644\u0650\u062A \u0644\u0625\u0636\u0627\u0641\u062A\u0647\u0627 \u0625\u0644\u0649 \u0647\u0630\u0627 \u0627\u0644\u0645\u062C\u0644\u062F\xBB \u0623\u062B\u0646\u0627\u0621 \u0627\u0644\u0633\u062D\u0628. \u062A\u064F\u0636\u0627\u0641 \u0645\u0644\u0641\u0627\u062A \u0627\u0644\u0645\u062C\u0644\u062F \u0627\u0644\u0630\u064A \u062A\u064F\u0641\u0644\u062A\u0647 \u0645\u0628\u0627\u0634\u0631\u0629\u064B \u0625\u0644\u0649 \u0627\u0644\u0645\u062C\u0644\u062F \u0627\u0644\u0645\u0641\u062A\u0648\u062D."
              },
              addFiles: {
                term: "\u0625\u0636\u0627\u0641\u0629 \u0645\u0644\u0641\u0627\u062A",
                text: "\u064A\u0641\u062A\u062D \u0646\u0627\u0641\u0630\u0629 \u0627\u062E\u062A\u064A\u0627\u0631 \u0627\u0644\u0645\u0644\u0641\u0627\u062A \u0645\u0646 \u062D\u0627\u0633\u0648\u0628\u0643. \u0627\u0644\u062D\u062F \u0627\u0644\u0623\u0642\u0635\u0649 \u0644\u062D\u062C\u0645 \u0627\u0644\u0645\u0644\u0641 \u0645\u0630\u0643\u0648\u0631 \u062A\u062D\u062A \u0627\u0644\u0645\u0646\u0637\u0642\u0629."
              },
              addFolder: {
                term: "\u0625\u0636\u0627\u0641\u0629 \u0645\u062C\u0644\u062F",
                text: "\u064A\u0636\u064A\u0641 \u0643\u0644 \u0645\u062D\u062A\u0648\u0649 \u0645\u062C\u0644\u062F \u0645\u0646 \u062D\u0627\u0633\u0648\u0628\u0643."
              },
              progress: {
                term: "\u0627\u0644\u0645\u0644\u0641\u0627\u062A \u0642\u064A\u062F \u0627\u0644\u0625\u0636\u0627\u0641\u0629",
                text: "\u0642\u0627\u0626\u0645\u0629 \u0639\u0645\u0644\u064A\u0627\u062A \u0627\u0644\u0625\u0631\u0633\u0627\u0644\u060C \u0645\u0639 \u0634\u0631\u064A\u0637 \u062A\u0642\u062F\u0651\u0645: \u062C\u0627\u0631\u064D \u0627\u0644\u0625\u0631\u0633\u0627\u0644 \u0623\u0648 \u062C\u0627\u0631\u064D \u0627\u0644\u0641\u062D\u0635 \u0628\u062D\u062B\u064B\u0627 \u0639\u0646 \u0627\u0644\u0641\u064A\u0631\u0648\u0633\u0627\u062A \u0623\u0648 \u0623\u064F\u0636\u064A\u0641 \u0625\u0644\u0649 \u0627\u0644\u0645\u062C\u0644\u062F \u0623\u0648 \u0645\u0631\u0641\u0648\u0636 \u0623\u0648 \u0641\u0634\u0644 \u0627\u0644\u0625\u0631\u0633\u0627\u0644. \u064A\u064F\u0630\u0643\u0631 \u0633\u0628\u0628 \u0648\u0627\u0636\u062D \u0639\u0646\u062F \u0631\u0641\u0636 \u0645\u0644\u0641\u060C \u0645\u062B\u0644 \u0646\u0648\u0639 \u0645\u0644\u0641 \u063A\u064A\u0631 \u0645\u0642\u0628\u0648\u0644 \u0623\u0648 \u0645\u0644\u0641 \u0641\u0627\u0631\u063A."
              },
              controls: {
                term: "\u0625\u0644\u063A\u0627\u0621\u060C \u0625\u0632\u0627\u0644\u0629\u060C \u0625\u0639\u0627\u062F\u0629 \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629",
                text: "\xAB\u0625\u0644\u063A\u0627\u0621\xBB \u064A\u0648\u0642\u0641 \u0625\u0631\u0633\u0627\u0644\u064B\u0627 \u062C\u0627\u0631\u064A\u064B\u0627\u060C \u0648\xAB\u0625\u0632\u0627\u0644\u0629\xBB \u064A\u062D\u0630\u0641 \u0633\u0637\u0631\u064B\u0627 \u0645\u0646\u062A\u0647\u064A\u064B\u0627 \u0645\u0646 \u0627\u0644\u0642\u0627\u0626\u0645\u0629\u060C \u0648\u0632\u0631 \u0625\u0639\u0627\u062F\u0629 \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629 \u064A\u0639\u064A\u062F \u0625\u0631\u0633\u0627\u0644\u064B\u0627 \u0641\u0627\u0634\u0644\u064B\u0627."
              },
              infoDialog: {
                term: "\u0645\u0639\u0644\u0648\u0645\u0627\u062A \u0627\u0644\u0648\u062B\u064A\u0642\u0629",
                text: "\u0646\u0627\u0641\u0630\u0629 \u062A\u064F\u0641\u062A\u062D \u0628\u0639\u062F \u0627\u062E\u062A\u064A\u0627\u0631 \u0627\u0644\u0645\u0644\u0641\u0627\u062A: \u0627\u0644\u062A\u062E\u0635\u0635 \u0648\u0627\u0644\u0645\u0631\u062D\u0644\u0629 \u0648\u0646\u0648\u0639 \u0627\u0644\u0648\u062B\u064A\u0642\u0629 \u0648\u0627\u0644\u0645\u0646\u0637\u0642\u0629 \u0648\u0627\u0644\u0645\u0642\u064A\u0627\u0633 \u0648\u0639\u0646\u0648\u0627\u0646 \u0643\u0644 \u0648\u062B\u064A\u0642\u0629. \u062A\u064F\u0633\u062A\u062E\u062F\u0645 \u0644\u062A\u0635\u0646\u064A\u0641 \u0627\u0644\u0648\u062B\u064A\u0642\u0629 \u0648\u062A\u0643\u0648\u064A\u0646 \u0631\u0645\u0632\u0647\u0627\u061B \u0648\u064A\u0645\u0643\u0646\u0643 \u062A\u0639\u062F\u064A\u0644\u0647\u0627 \u0644\u0627\u062D\u0642\u064B\u0627."
              },
              skip: {
                term: "\u0625\u0636\u0627\u0641\u0629 \u0628\u062F\u0648\u0646 \u0645\u0639\u0644\u0648\u0645\u0627\u062A",
                text: "\u064A\u0636\u064A\u0641 \u0627\u0644\u0645\u0644\u0641\u0627\u062A \u062F\u0648\u0646 \u0645\u0644\u0621 \u0647\u0630\u0647 \u0627\u0644\u0645\u0639\u0644\u0648\u0645\u0627\u062A. \u064A\u064F\u0633\u0646\u064E\u062F \u0631\u0645\u0632 \u0627\u0644\u0648\u062B\u064A\u0642\u0629 \u0644\u0627\u062D\u0642\u064B\u0627 \u0639\u0646\u062F \u062A\u062D\u062F\u064A\u062F\u0647\u0627. \u0627\u0644\u0632\u0631 \u0627\u0644\u0622\u062E\u0631 \u0627\u0633\u0645\u0647 \xAB\u0625\u0636\u0627\u0641\u0629 \u0627\u0644\u0648\u062B\u064A\u0642\u0629\xBB \u0623\u0648 \xAB\u0625\u0636\u0627\u0641\u0629 \u20663\u2069 \u0648\u062B\u0627\u0626\u0642\xBB."
              },
              codePreview: {
                term: "\u0627\u0644\u0631\u0645\u0632 \u0627\u0644\u0645\u062A\u0648\u0642\u0639",
                text: "\u0627\u0644\u0631\u0645\u0632 \u0627\u0644\u0630\u064A \u0633\u062A\u062D\u0635\u0644 \u0639\u0644\u064A\u0647 \u0627\u0644\u0648\u062B\u064A\u0642\u0629. \u064A\u064F\u0633\u062A\u0628\u062F\u0644 \u2066###\u2069 \u0628\u0627\u0644\u0631\u0642\u0645 \u0627\u0644\u062A\u0633\u0644\u0633\u0644\u064A \u0627\u0644\u0630\u064A \u064A\u064F\u0633\u0646\u064E\u062F \u0639\u0646\u062F \u0625\u0636\u0627\u0641\u0629 \u0627\u0644\u0645\u0644\u0641."
              }
            }
          },
          documents: {
            title: "\u0627\u0644\u0648\u062B\u0627\u0626\u0642",
            items: {
              search: {
                term: "\u0627\u0644\u0628\u062D\u062B \u0641\u064A \u0627\u0644\u0648\u062B\u0627\u0626\u0642",
                text: "\u0627\u0643\u062A\u0628 \u062C\u0632\u0621\u064B\u0627 \u0645\u0646 \u0627\u0644\u0631\u0645\u0632 \u0623\u0648 \u0627\u0644\u0639\u0646\u0648\u0627\u0646\u061B \u062A\u062A\u062D\u062F\u0651\u062B \u0627\u0644\u0642\u0627\u0626\u0645\u0629 \u0628\u0645\u062C\u0631\u062F \u0623\u0646 \u062A\u062A\u0648\u0642\u0641 \u0639\u0646 \u0627\u0644\u0643\u062A\u0627\u0628\u0629."
              },
              filters: {
                term: "\u0627\u0644\u062A\u062E\u0635\u0635\u060C \u0627\u0644\u0645\u0631\u062D\u0644\u0629\u060C \u0646\u0648\u0639 \u0627\u0644\u0648\u062B\u064A\u0642\u0629",
                text: "\u062B\u0644\u0627\u062B \u062A\u0635\u0641\u064A\u0627\u062A \u0639\u0644\u0649 \u0634\u0643\u0644 \u0623\u0632\u0631\u0627\u0631. \u062A\u0642\u062A\u0631\u062D \u0643\u0644 \u0648\u0627\u062D\u062F\u0629 \xAB\u0627\u0644\u0643\u0644\xBB \u0623\u0648 \u0642\u064A\u0645\u0629\u060C \u0648\u062A\u0639\u0631\u0636 \u0627\u062E\u062A\u064A\u0627\u0631\u0643 \u062F\u0627\u062E\u0644 \u0627\u0644\u0632\u0631."
              },
              clear: {
                term: "\u0645\u0633\u062D \u0639\u0648\u0627\u0645\u0644 \u0627\u0644\u062A\u0635\u0641\u064A\u0629",
                text: "\u064A\u0632\u064A\u0644 \u0627\u0644\u0628\u062D\u062B \u0648\u0627\u0644\u062A\u0635\u0641\u064A\u0627\u062A. \u0625\u0646 \u0644\u0645 \u064A\u0637\u0627\u0628\u0642 \u0634\u064A\u0621\u060C \u062A\u0639\u0631\u0636 \xAB\u0644\u0627 \u062A\u0648\u062C\u062F \u0648\u062B\u064A\u0642\u0629 \u0645\u0637\u0627\u0628\u0642\u0629\xBB \u0627\u0644\u0632\u0631 \u0646\u0641\u0633\u0647."
              },
              select: {
                term: "\u062A\u062D\u062F\u064A\u062F",
                text: "\u062E\u0627\u0646\u0627\u062A \u0627\u062E\u062A\u064A\u0627\u0631 \u0623\u0645\u0627\u0645 \u0643\u0644 \u0633\u0637\u0631\u061B \u0648\u062E\u0627\u0646\u0629 \u0627\u0644\u0639\u0646\u0648\u0627\u0646 \u062A\u062D\u062F\u0651\u062F \u0643\u0644 \u0627\u0644\u0648\u062B\u0627\u0626\u0642 \u0627\u0644\u0645\u0639\u0631\u0648\u0636\u0629. \u064A\u0638\u0647\u0631 \u0634\u0631\u064A\u0637 \u0625\u062C\u0631\u0627\u0621\u0627\u062A \u0645\u0639 \xAB\u20662\u2069 \u0648\u062B\u064A\u0642\u062A\u0627\u0646 \u0645\u062D\u062F\u062F\u062A\u0627\u0646\xBB."
              },
              move: {
                term: "\u0646\u0642\u0644 \u0625\u0644\u0649\u2026",
                text: "\u064A\u0646\u0642\u0644 \u0627\u0644\u0648\u062B\u0627\u0626\u0642 \u0627\u0644\u0645\u062D\u062F\u062F\u0629 \u0625\u0644\u0649 \u0645\u062C\u0644\u062F \u0622\u062E\u0631: \u0627\u0641\u062A\u062D \u0627\u0644\u0645\u062C\u0644\u062F \u0627\u0644\u0648\u062C\u0647\u0629 \u062B\u0645 \xAB\u0646\u0642\u0644 \u0625\u0644\u0649 \u0647\u0646\u0627\xBB. \u0644\u0627 \u064A\u0645\u0643\u0646 \u0623\u0646 \u062A\u0628\u0642\u0649 \u0627\u0644\u0648\u062B\u0627\u0626\u0642 \u0641\u064A \u062C\u0630\u0631 \u0627\u0644\u0645\u0634\u0631\u0648\u0639."
              },
              delete: {
                term: "\u062D\u0630\u0641",
                text: "\u064A\u0646\u0642\u0644 \u0627\u0644\u0648\u062B\u0627\u0626\u0642 \u0627\u0644\u0645\u062D\u062F\u062F\u0629 \u0625\u0644\u0649 \u0633\u0644\u0629 \u0627\u0644\u0645\u062D\u0630\u0648\u0641\u0627\u062A \u0628\u0639\u062F \u0627\u0644\u062A\u0623\u0643\u064A\u062F. \u0644\u0627 \u064A\u0638\u0647\u0631 \u0647\u0630\u0627\u0646 \u0627\u0644\u0632\u0631\u0627\u0646 \u0625\u0644\u0627 \u0625\u0630\u0627 \u0643\u0627\u0646 \u0644\u0643 \u062D\u0642 \u0627\u0644\u062A\u0635\u0631\u0641 \u0641\u064A \u0643\u0644 \u0627\u0644\u0648\u062B\u0627\u0626\u0642 \u0627\u0644\u0645\u062E\u062A\u0627\u0631\u0629."
              },
              clearSelection: {
                term: "\u0625\u0644\u063A\u0627\u0621 \u0627\u0644\u062A\u062D\u062F\u064A\u062F",
                text: "\u064A\u0632\u064A\u0644 \u0627\u0644\u062A\u062D\u062F\u064A\u062F."
              },
              count: {
                term: "\u0639\u0631\u0636 \u0627\u0644\u0645\u0632\u064A\u062F \u0645\u0646 \u0627\u0644\u0648\u062B\u0627\u0626\u0642",
                text: "\u062A\u062D\u062A \u0627\u0644\u0642\u0627\u0626\u0645\u0629: \xAB\u206620\u2069 \u0648\u062B\u064A\u0642\u0629 \u0645\u0639\u0631\u0648\u0636\u0629\xBB\u060C \u0648\u0647\u0630\u0627 \u0627\u0644\u0632\u0631 \u0639\u0646\u062F \u0648\u062C\u0648\u062F \u0648\u062B\u0627\u0626\u0642 \u0623\u062E\u0631\u0649. \u062A\u0638\u0647\u0631 \xAB\u0644\u0627 \u062A\u0648\u062C\u062F \u0648\u062B\u0627\u0626\u0642 \u0628\u0639\u062F\xBB \u0641\u064A \u0645\u062C\u0644\u062F \u0641\u0627\u0631\u063A."
              }
            }
          },
          columns: {
            title: "\u0623\u0639\u0645\u062F\u0629 \u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u0648\u062B\u0627\u0626\u0642",
            items: {
              code: {
                term: "\u0627\u0644\u0631\u0645\u0632",
                text: "\u0631\u0645\u0632 \u0627\u0644\u0648\u062B\u064A\u0642\u0629. \u0627\u0646\u0642\u0631 \u0639\u0644\u0649 \u0627\u0644\u0639\u0646\u0648\u0627\u0646 \u0644\u0644\u0641\u0631\u0632. \u062A\u0639\u0646\u064A \xAB\u0645\u0639\u0644\u0648\u0645\u0627\u062A \u0646\u0627\u0642\u0635\u0629\xBB \u0623\u0646 \u0627\u0644\u0631\u0645\u0632 \u0644\u0645 \u064A\u064F\u0633\u0646\u064E\u062F \u0628\u0639\u062F."
              },
              title: {
                term: "\u0627\u0644\u0639\u0646\u0648\u0627\u0646",
                text: "\u0639\u0646\u0648\u0627\u0646 \u0627\u0644\u0648\u062B\u064A\u0642\u0629. \u0627\u0646\u0642\u0631 \u0639\u0644\u064A\u0647 \u0644\u0641\u062A\u062D \u0644\u0648\u062D\u0629 \u062A\u0641\u0627\u0635\u064A\u0644\u0647\u0627. \u064A\u062A\u064A\u062D \u0627\u0644\u0639\u0646\u0648\u0627\u0646 \u0627\u0644\u0641\u0631\u0632."
              },
              index: {
                term: "\u0627\u0644\u0645\u0624\u0634\u0631",
                text: "\u062D\u0631\u0641 \u0646\u0633\u062E\u0629 \u0627\u0644\u0645\u062E\u0637\u0637 \u0623\u0648 \u0627\u0644\u0648\u062B\u064A\u0642\u0629 (\u2066A\u2069 \u0648\u2066B\u2069 \u0648\u2066C\u2069\u2026). \u064A\u062A\u063A\u064A\u0651\u0631 \u0645\u0639 \u0643\u0644 \u0646\u0633\u062E\u0629 \u062C\u062F\u064A\u062F\u0629."
              },
              disciplinePhase: {
                term: "\u0627\u0644\u062A\u062E\u0635\u0635 \u0648\u0627\u0644\u0645\u0631\u062D\u0644\u0629",
                text: "\u0627\u0644\u062A\u062E\u0635\u0635 (\u0627\u0644\u0639\u0645\u0627\u0631\u0629\u060C \u0627\u0644\u0647\u064A\u0627\u0643\u0644\u060C \u0627\u0644\u0637\u0631\u0642 \u0648\u0627\u0644\u0634\u0628\u0643\u0627\u062A \u0627\u0644\u0645\u062E\u062A\u0644\u0641\u0629\u060C \u0627\u0644\u0645\u0648\u0627\u0626\u0639\u060C \u0627\u0644\u0643\u0647\u0631\u0628\u0627\u0621\u060C \u0627\u0644\u0637\u0648\u0628\u0648\u063A\u0631\u0627\u0641\u064A\u0627\u060C \u0627\u0644\u062C\u064A\u0648\u062A\u0642\u0646\u064A\u0629\u060C \u0627\u0644\u062A\u0646\u0633\u064A\u0642 \u0648\u0627\u0644\u0645\u062A\u0627\u0628\u0639\u0629) \u0648\u0645\u0631\u062D\u0644\u0629 \u0627\u0644\u0645\u0634\u0631\u0648\u0639 \u0627\u0644\u062A\u064A \u062A\u0631\u062A\u0628\u0637 \u0628\u0647\u0627 \u0627\u0644\u0648\u062B\u064A\u0642\u0629."
              },
              status: {
                term: "\u0627\u0644\u062D\u0627\u0644\u0629",
                text: "\u062D\u0627\u0644\u0629 \u0627\u0644\u0645\u0644\u0641: \u062C\u0627\u0631\u064D \u0627\u0644\u0625\u0631\u0633\u0627\u0644 \u0623\u0648 \u0641\u062D\u0635 \u0645\u0636\u0627\u062F \u0627\u0644\u0641\u064A\u0631\u0648\u0633\u0627\u062A \u0623\u0648 \u0645\u062A\u0627\u062D \u0623\u0648 \u0645\u0631\u0641\u0648\u0636."
              },
              approval: {
                term: "\u0627\u0644\u062A\u0623\u0634\u064A\u0631",
                text: "\u0634\u0627\u0631\u0629 \xAB\u0642\u064A\u062F \u0627\u0644\u062A\u0623\u0634\u064A\u0631\xBB \u0639\u0646\u062F\u0645\u0627 \u064A\u0643\u0648\u0646 \u0645\u0633\u0627\u0631 \u062A\u0623\u0634\u064A\u0631 \u062C\u0627\u0631\u064A\u064B\u0627 \u0639\u0644\u0649 \u0627\u0644\u0648\u062B\u064A\u0642\u0629."
              },
              modified: {
                term: "\u062A\u0627\u0631\u064A\u062E \u0627\u0644\u062A\u0639\u062F\u064A\u0644",
                text: "\u062A\u0627\u0631\u064A\u062E \u0622\u062E\u0631 \u062A\u0639\u062F\u064A\u0644. \u064A\u062A\u064A\u062D \u0627\u0644\u0639\u0646\u0648\u0627\u0646 \u0627\u0644\u0641\u0631\u0632\u061B \u0648\u0627\u0641\u062A\u0631\u0627\u0636\u064A\u064B\u0627 \u0627\u0644\u0623\u062D\u062F\u062B \u0623\u0648\u0644\u064B\u0627."
              },
              author: {
                term: "\u0627\u0644\u0645\u0624\u0633\u0633\u0629 \u0627\u0644\u0645\u064F\u0646\u0634\u0650\u0626\u0629",
                text: "\u0627\u0644\u0645\u0624\u0633\u0633\u0629 \u0627\u0644\u062A\u064A \u0623\u0636\u0627\u0641\u062A \u0627\u0644\u0648\u062B\u064A\u0642\u0629\u060C \u0623\u0648 \xAB\u0634\u0631\u064A\u0643\xBB \u0644\u0645\u0624\u0633\u0633\u0629 \u0634\u0631\u064A\u0643\u0629."
              }
            }
          },
          panel: {
            title: "\u0627\u0644\u0648\u062B\u064A\u0642\u0629",
            items: {
              open: {
                term: "\u0641\u062A\u062D",
                text: "\u064A\u0641\u062A\u062D \u0627\u0644\u0648\u062B\u064A\u0642\u0629 \u0641\u064A \u0627\u0644\u0639\u0627\u0631\u0636."
              },
              edit: {
                term: "\u062A\u0639\u062F\u064A\u0644",
                text: "\u064A\u062A\u064A\u062D \u062A\u063A\u064A\u064A\u0631 \u0627\u0644\u0639\u0646\u0648\u0627\u0646 \u0648\u0627\u0644\u062A\u062E\u0635\u0635 \u0648\u0627\u0644\u0645\u0631\u062D\u0644\u0629 \u0648\u0627\u0644\u0646\u0648\u0639 \u0648\u0627\u0644\u0645\u0646\u0637\u0642\u0629 \u0648\u0627\u0644\u0645\u0642\u064A\u0627\u0633\u060C \u0644\u0645\u0646 \u064A\u0645\u0643\u0646\u0647 \u062A\u0639\u062F\u064A\u0644 \u0627\u0644\u0648\u062B\u064A\u0642\u0629."
              },
              details: {
                term: "\u0627\u0644\u062A\u0641\u0627\u0635\u064A\u0644",
                text: "\u0627\u0644\u0644\u0648\u062D\u0629 \u0627\u0644\u062C\u0627\u0646\u0628\u064A\u0629: \u0627\u0644\u0631\u0645\u0632 \u0648\u0627\u0644\u0639\u0646\u0648\u0627\u0646 \u0648\u0627\u0644\u0645\u0624\u0634\u0631 \u0648\u0627\u0644\u062A\u062E\u0635\u0635 \u0648\u0627\u0644\u0645\u0631\u062D\u0644\u0629 \u0648\u0627\u0644\u0646\u0648\u0639 \u0648\u0627\u0644\u0645\u0646\u0637\u0642\u0629 \u0648\u0627\u0644\u0645\u0642\u064A\u0627\u0633 \u0648\u0627\u0644\u062D\u0627\u0644\u0629 \u0648\u0627\u0644\u0645\u0624\u0633\u0633\u0629 \u0627\u0644\u0645\u064F\u0646\u0634\u0650\u0626\u0629 \u0648\u062A\u0627\u0631\u064A\u062E \u0627\u0644\u062A\u0639\u062F\u064A\u0644."
              },
              locked: {
                term: "\u0647\u0630\u0647 \u0627\u0644\u0648\u062B\u064A\u0642\u0629 \u0641\u064A \u0645\u0633\u0627\u0631 \u0645\u0648\u0627\u0641\u0642\u0629 \u062C\u0627\u0631\u064D",
                text: "\u0631\u0633\u0627\u0644\u0629 \u0625\u0639\u0644\u0627\u0645\u064A\u0629: \u0645\u0627 \u062F\u0627\u0645 \u0645\u0633\u0627\u0631 \u0627\u0644\u062A\u0623\u0634\u064A\u0631 \u0644\u0645 \u064A\u0646\u062A\u0647\u0650 \u0623\u0648 \u064A\u064F\u0644\u063A\u064E\u060C \u0644\u0627 \u064A\u0645\u0643\u0646 \u0625\u0636\u0627\u0641\u0629 \u0646\u0633\u062E\u0629 \u062C\u062F\u064A\u062F\u0629 \u0644\u0644\u0648\u062B\u064A\u0642\u0629."
              },
              deliverables: {
                term: "\u0627\u0644\u0645\u062E\u0631\u062C\u0627\u062A \u0627\u0644\u0645\u0631\u062A\u0628\u0637\u0629",
                text: "\u0645\u062E\u0631\u062C\u0627\u062A \u0627\u0644\u0645\u0634\u0631\u0648\u0639 \u0627\u0644\u062A\u064A \u062A\u0631\u062A\u0628\u0637 \u0628\u0647\u0627 \u0647\u0630\u0647 \u0627\u0644\u0648\u062B\u064A\u0642\u0629\u060C \u0623\u0648 \xAB\u0644\u0627 \u0645\u062E\u0631\u062C\u0627\u062A \u0645\u0631\u062A\u0628\u0637\u0629\xBB."
              },
              versions: {
                term: "\u0627\u0644\u0646\u0633\u062E \u0648\u0646\u0633\u062E\u0629 \u062C\u062F\u064A\u062F\u0629",
                text: "\u0627\u0644\u0633\u062C\u0644 \u0645\u0646 \u0627\u0644\u0623\u062D\u062F\u062B \u0625\u0644\u0649 \u0627\u0644\u0623\u0642\u062F\u0645: \u0627\u0644\u0645\u0624\u0634\u0631 \u0648\xAB\u0627\u0644\u0646\u0633\u062E\u0629 \u0627\u0644\u062D\u0627\u0644\u064A\u0629\xBB \u0648\u0627\u0644\u0645\u0624\u0644\u0641 \u0648\u0627\u0644\u062A\u0627\u0631\u064A\u062E \u0648\u0627\u0644\u0631\u0645\u0632 \u0648\u0628\u0635\u0645\u0629 \u2066SHA-256\u2069 (\u062A\u0648\u0642\u064A\u0639 \u064A\u062B\u0628\u062A \u0623\u0646 \u0627\u0644\u0645\u0644\u0641 \u0644\u0645 \u064A\u062A\u063A\u064A\u0651\u0631\u060C \u0648\u064A\u064F\u0646\u0633\u062E \u0628\u0646\u0642\u0631\u0629). \u064A\u0636\u064A\u0641 \u0632\u0631 \xAB\u0646\u0633\u062E\u0629 \u062C\u062F\u064A\u062F\u0629\xBB \u0645\u0644\u0641\u064B\u0627 \u0643\u0646\u0633\u062E\u0629 \u062A\u0627\u0644\u064A\u0629 \u0628\u0627\u0644\u0645\u0624\u0634\u0631 \u0627\u0644\u062A\u0627\u0644\u064A\u061B \u0648\u062A\u062A\u0627\u0628\u0639 \u0627\u0644\u0625\u0631\u0633\u0627\u0644 \u062A\u062D\u062A \u0645\u0646\u0637\u0642\u0629 \u0625\u0636\u0627\u0641\u0629 \u0627\u0644\u0645\u0644\u0641\u0627\u062A."
              },
              restore: {
                term: "\u0627\u0633\u062A\u0639\u0627\u062F\u0629",
                text: "\u064A\u0639\u064A\u062F \u0646\u0633\u062E\u0629 \u0642\u062F\u064A\u0645\u0629 \u0625\u0644\u0649 \u0627\u0644\u062E\u062F\u0645\u0629 \u0628\u0625\u0636\u0627\u0641\u062A\u0647\u0627 \u0643\u0646\u0633\u062E\u0629 \u062C\u062F\u064A\u062F\u0629. \u0627\u0644\u0633\u0628\u0628 \u0625\u0644\u0632\u0627\u0645\u064A (3 \u0623\u062D\u0631\u0641 \u0639\u0644\u0649 \u0627\u0644\u0623\u0642\u0644)\u061B \u0648\u064A\u064F\u062D\u062A\u0641\u0638 \u0628\u0627\u0644\u0633\u062C\u0644 \u0643\u0627\u0645\u0644\u064B\u0627."
              },
              approval: {
                term: "\u0637\u0644\u0628 \u062A\u0623\u0634\u064A\u0631\u0629",
                text: "\u0641\u064A \u062E\u0627\u0646\u0629 \xAB\u0627\u0644\u062A\u0623\u0634\u064A\u0631\xBB. \u062A\u0642\u062A\u0631\u062D \u0627\u0644\u0646\u0627\u0641\u0630\u0629 \u0627\u0633\u062A\u0639\u0645\u0627\u0644 \u0646\u0645\u0648\u0630\u062C \u0645\u0646 \u0627\u0644\u0645\u0643\u062A\u0628 \u0623\u0648 \u062A\u0631\u0643\u064A\u0628 \u0627\u0644\u062E\u0637\u0648\u0627\u062A \u0628\u0646\u0641\u0633\u0643 (\u0627\u0644\u0645\u0631\u0627\u062C\u0639\u0648\u0646\u060C \u0628\u0627\u0644\u062A\u0631\u062A\u064A\u0628 \u0623\u0648 \u0628\u0627\u0644\u062A\u0648\u0627\u0632\u064A)\u060C \u0645\u0639 \u0623\u062C\u0644 \u0627\u062E\u062A\u064A\u0627\u0631\u064A\u060C \u062B\u0645 \xAB\u0625\u0631\u0633\u0627\u0644 \u0627\u0644\u0637\u0644\u0628\xBB. \u0623\u062B\u0646\u0627\u0621 \u0627\u0644\u0645\u0633\u0627\u0631 \u062A\u0643\u0648\u0646 \u0627\u0644\u0648\u062B\u064A\u0642\u0629 \u0645\u0642\u0641\u0644\u0629."
              }
            }
          },
          dialogs: {
            title: "\u0646\u0648\u0627\u0641\u0630 \u0627\u0644\u0645\u062C\u0644\u062F\u0627\u062A \u0648\u0627\u0644\u0648\u062B\u0627\u0626\u0642",
            items: {
              newFolder: {
                term: "\u0645\u062C\u0644\u062F \u062C\u062F\u064A\u062F",
                text: "\u064A\u0637\u0644\u0628 \u0627\u0633\u0645 \u0627\u0644\u0645\u062C\u0644\u062F (200 \u062D\u0631\u0641 \u0639\u0644\u0649 \u0627\u0644\u0623\u0643\u062B\u0631\u060C \u062F\u0648\u0646 \u0634\u0631\u0637\u0629 \u0645\u0627\u0626\u0644\u0629) \u062B\u0645 \xAB\u0625\u0646\u0634\u0627\u0621\xBB. \u062A\u0628\u064A\u0651\u0646 \u0627\u0644\u0646\u0627\u0641\u0630\u0629 \u0627\u0644\u0645\u0643\u0627\u0646: \xAB\u0641\u064A \u062C\u0630\u0631 \u0627\u0644\u0645\u0634\u0631\u0648\u0639\xBB \u0623\u0648 \xAB\u0641\u064A: \u2026\xBB."
              },
              rename: {
                term: "\u0625\u0639\u0627\u062F\u0629 \u062A\u0633\u0645\u064A\u0629 \u0627\u0644\u0645\u062C\u0644\u062F",
                text: "\u064A\u0637\u0644\u0628 \u0627\u0644\u0627\u0633\u0645 \u0627\u0644\u062C\u062F\u064A\u062F \u062B\u0645 \xAB\u0625\u0639\u0627\u062F\u0629 \u0627\u0644\u062A\u0633\u0645\u064A\u0629\xBB. \u0644\u0627 \u064A\u0645\u0643\u0646 \u0644\u0645\u062C\u0644\u062F\u064A\u0646 \u0623\u0646 \u064A\u062D\u0645\u0644\u0627 \u0627\u0644\u0627\u0633\u0645 \u0646\u0641\u0633\u0647 \u0641\u064A \u0627\u0644\u0645\u0643\u0627\u0646 \u0646\u0641\u0633\u0647."
              },
              move: {
                term: "\u0627\u0644\u0646\u0642\u0644 \u0625\u0644\u0649 \u0647\u0646\u0627",
                text: "\u0644\u0646\u0642\u0644 \u0645\u062C\u0644\u062F: \u0627\u0641\u062A\u062D \u0627\u0644\u0645\u062C\u0644\u062F \u0627\u0644\u0648\u062C\u0647\u0629\u060C \u0645\u0639 \xAB\u0627\u0644\u0635\u0639\u0648\u062F \u0645\u0633\u062A\u0648\u0649 \u0648\u0627\u062D\u062F\u064B\u0627\xBB \u0639\u0646\u062F \u0627\u0644\u062D\u0627\u062C\u0629\u060C \u062B\u0645 \u0627\u0646\u0642\u0631 \u0639\u0644\u0649 \u0647\u0630\u0627 \u0627\u0644\u0632\u0631. \u0644\u0627 \u064A\u0645\u0643\u0646 \u0646\u0642\u0644 \u0645\u062C\u0644\u062F \u062F\u0627\u062E\u0644 \u0623\u062D\u062F \u0645\u062C\u0644\u062F\u0627\u062A\u0647 \u0627\u0644\u0641\u0631\u0639\u064A\u0629."
              },
              permissions: {
                term: "\u0627\u0644\u0635\u0644\u0627\u062D\u064A\u0627\u062A",
                text: "\u0627\u062E\u062A\u0631 \u0648\u0631\u0627\u062B\u0629 \u0635\u0644\u0627\u062D\u064A\u0627\u062A \u0627\u0644\u0645\u062C\u0644\u062F \u0627\u0644\u0623\u0635\u0644\u064A (\u0623\u0648 \u0627\u0644\u0645\u0634\u0631\u0648\u0639)\u060C \u0623\u0648 \u0623\u062F\u0631\u062C \u0628\u0646\u0641\u0633\u0643 \u0627\u0644\u0623\u0634\u062E\u0627\u0635 \u0627\u0644\u0645\u0633\u0645\u0648\u062D \u0644\u0647\u0645. \u0643\u0644 \u0648\u0627\u062D\u062F \u0645\u0646\u0647\u0645 \u0642\u0627\u0631\u0626 \u0623\u0648 \u0645\u062D\u0631\u0651\u0631. \xAB\u0625\u0636\u0627\u0641\u0629 \u062C\u0645\u064A\u0639 \u0623\u0639\u0636\u0627\u0621 \u0627\u0644\u0645\u0643\u062A\u0628\xBB \u062A\u0645\u0646\u062D \u0627\u0644\u0648\u0635\u0648\u0644 \u0644\u0644\u062C\u0645\u064A\u0639."
              },
              deleteFolder: {
                term: "\u062D\u0630\u0641 \u0627\u0644\u0645\u062C\u0644\u062F",
                text: "\u0628\u0639\u062F \u0627\u0644\u062A\u0623\u0643\u064A\u062F \u064A\u0646\u062A\u0642\u0644 \u0627\u0644\u0645\u062C\u0644\u062F \u0648\u0645\u062C\u0644\u062F\u0627\u062A\u0647 \u0627\u0644\u0641\u0631\u0639\u064A\u0629 \u0625\u0644\u0649 \u0633\u0644\u0629 \u0627\u0644\u0645\u062D\u0630\u0648\u0641\u0627\u062A. \u0644\u0627 \u064A\u0645\u0643\u0646 \u062D\u0630\u0641 \u0645\u062C\u0644\u062F \u064A\u062D\u062A\u0648\u064A \u0639\u0644\u0649 \u0648\u062B\u064A\u0642\u0629 \u064A\u062C\u0628 \u0627\u0644\u0627\u062D\u062A\u0641\u0627\u0638 \u0628\u0647\u0627 (\u0627\u0644\u062A\u0632\u0627\u0645 \u0642\u0627\u0646\u0648\u0646\u064A)."
              },
              deleteDocuments: {
                term: "\u062D\u0630\u0641 \u0648\u062B\u0627\u0626\u0642",
                text: "\u062A\u0623\u0643\u064A\u062F \u0642\u0628\u0644 \u0646\u0642\u0644 \u0627\u0644\u0648\u062B\u0627\u0626\u0642 \u0627\u0644\u0645\u062E\u062A\u0627\u0631\u0629 \u0625\u0644\u0649 \u0633\u0644\u0629 \u0627\u0644\u0645\u062D\u0630\u0648\u0641\u0627\u062A\u061B \u0648\u062A\u0639\u0631\u0636 \u0627\u0644\u0646\u0627\u0641\u0630\u0629 \u0623\u0633\u0645\u0627\u0621\u0647\u0627."
              },
              moveDocuments: {
                term: "\u0646\u0642\u0644 \u0627\u0644\u0648\u062B\u064A\u0642\u0629",
                text: "\u0627\u0644\u0645\u0628\u062F\u0623 \u0646\u0641\u0633\u0647 \u0643\u0645\u0627 \u0644\u0644\u0645\u062C\u0644\u062F: \u0627\u0641\u062A\u062D \u0627\u0644\u0645\u062C\u0644\u062F \u0627\u0644\u0648\u062C\u0647\u0629 \u062B\u0645 \xAB\u0646\u0642\u0644 \u0625\u0644\u0649 \u0647\u0646\u0627\xBB."
              },
              newVersionDialog: {
                term: "\u0627\u0644\u0645\u0644\u0641",
                text: "\u0641\u064A \u0646\u0627\u0641\u0630\u0629 \xAB\u0646\u0633\u062E\u0629 \u062C\u062F\u064A\u062F\u0629\xBB: \u0627\u062E\u062A\u0631 \u0627\u0644\u0645\u0644\u0641 \u062B\u0645 \xAB\u0625\u0636\u0627\u0641\u0629 \u0627\u0644\u0646\u0633\u062E\u0629\xBB."
              }
            }
          },
          trash: {
            title: "\u0633\u0644\u0629 \u0627\u0644\u0645\u062D\u0630\u0648\u0641\u0627\u062A",
            items: {
              intro: {
                term: "\u0633\u0644\u0629 \u0627\u0644\u0645\u062D\u0630\u0648\u0641\u0627\u062A",
                text: "\u062A\u0628\u0642\u0649 \u0627\u0644\u0645\u062C\u0644\u062F\u0627\u062A \u0648\u0627\u0644\u0648\u062B\u0627\u0626\u0642 \u0627\u0644\u0645\u062D\u0630\u0648\u0641\u0629 \u0641\u064A\u0647\u0627 \u0639\u062F\u062F\u064B\u0627 \u0645\u0646 \u0627\u0644\u0623\u064A\u0627\u0645 \u062B\u0645 \u062A\u064F\u0645\u0633\u062D \u0646\u0647\u0627\u0626\u064A\u064B\u0627. \u064A\u0631\u0649 \u0627\u0644\u0645\u0633\u0624\u0648\u0644\u0648\u0646 \u0643\u0644 \u0634\u064A\u0621\u060C \u0648\u064A\u0631\u0649 \u0627\u0644\u0622\u062E\u0631\u0648\u0646 \u0645\u0627 \u062D\u0630\u0641\u0648\u0647 \u0647\u0645 \u0641\u0642\u0637."
              },
              back: {
                term: "\u0627\u0644\u0639\u0648\u062F\u0629 \u0625\u0644\u0649 \u0627\u0644\u0645\u0644\u0641\u0627\u062A",
                text: "\u064A\u063A\u0644\u0642 \u0633\u0644\u0629 \u0627\u0644\u0645\u062D\u0630\u0648\u0641\u0627\u062A \u0648\u064A\u0639\u064A\u062F \u0641\u062A\u062D \u0645\u062C\u0644\u062F\u0627\u062A\u0643."
              },
              line: {
                term: "\u0627\u0644\u0639\u0646\u0627\u0635\u0631 \u0627\u0644\u0645\u062D\u0630\u0648\u0641\u0629",
                text: "\u064A\u0628\u064A\u0651\u0646 \u0643\u0644 \u0633\u0637\u0631 \u0645\u0646 \u062D\u0630\u0641\u0647 \u0648\u0645\u062A\u0649\u060C \u0648\u0645\u062D\u062A\u0648\u0649 \u0627\u0644\u0645\u062C\u0644\u062F\u060C \u0648\u062A\u0627\u0631\u064A\u062E \u0645\u0633\u062D\u0647 \u0646\u0647\u0627\u0626\u064A\u064B\u0627."
              },
              restore: {
                term: "\u0627\u0633\u062A\u0639\u0627\u062F\u0629",
                text: "\u064A\u0639\u064A\u062F \u0627\u0644\u0639\u0646\u0635\u0631 \u0625\u0644\u0649 \u0645\u0643\u0627\u0646\u0647. \u0625\u0646 \u0643\u0627\u0646 \u0627\u0644\u0645\u062C\u0644\u062F \u0627\u0644\u0630\u064A \u0643\u0627\u0646 \u064A\u062D\u062A\u0648\u064A\u0647 \u0641\u064A \u0633\u0644\u0629 \u0627\u0644\u0645\u062D\u0630\u0648\u0641\u0627\u062A \u0623\u064A\u0636\u064B\u0627 \u0641\u0627\u0633\u062A\u0639\u062F \u0647\u0630\u0627 \u0627\u0644\u0645\u062C\u0644\u062F \u0623\u0648\u0644\u064B\u0627."
              },
              purge: {
                term: "\u062D\u0630\u0641 \u0646\u0647\u0627\u0626\u064A",
                text: "\u064A\u0645\u0633\u062D \u0627\u0644\u0639\u0646\u0635\u0631 \u0645\u0639 \u0643\u0644 \u0646\u0633\u062E\u0647 \u0648\u0645\u0644\u0641\u0627\u062A\u0647\u060C \u0628\u0639\u062F \u0627\u0644\u062A\u0623\u0643\u064A\u062F. \u0644\u0627 \u064A\u0645\u0643\u0646 \u0627\u0644\u062A\u0631\u0627\u062C\u0639 \u0639\u0646 \u0647\u0630\u0627 \u0627\u0644\u0625\u062C\u0631\u0627\u0621."
              },
              empty: {
                term: "\u0633\u0644\u0629 \u0627\u0644\u0645\u062D\u0630\u0648\u0641\u0627\u062A \u0641\u0627\u0631\u063A\u0629",
                text: "\u062A\u0638\u0647\u0631 \u0639\u0646\u062F\u0645\u0627 \u0644\u0645 \u064A\u064F\u062D\u0630\u0641 \u0634\u064A\u0621 \u062D\u062F\u064A\u062B\u064B\u0627."
              }
            }
          }
        }
      },
      tasks: {
        title: "\u0627\u0644\u0645\u0647\u0627\u0645",
        intro: "\u0627\u0644\u0639\u0645\u0644 \u0627\u0644\u0645\u0637\u0644\u0648\u0628 \u0641\u064A \u0627\u0644\u0645\u0634\u0631\u0648\u0639: \u062A\u0646\u0634\u0626 \u0645\u0647\u0627\u0645\u064B\u0627 \u0648\u062A\u0633\u0646\u062F\u0647\u0627 \u0625\u0644\u0649 \u0623\u0634\u062E\u0627\u0635 \u0648\u062A\u062A\u0627\u0628\u0639 \u062A\u0642\u062F\u0651\u0645\u0647\u0627 \u0641\u064A \u0642\u0627\u0626\u0645\u0629 \u0623\u0648 \u0641\u064A \u0644\u0648\u062D\u0629.",
        sections: {
          summary: {
            title: "\u0645\u0644\u062E\u0635 \u0627\u0644\u0645\u0634\u0631\u0648\u0639",
            items: {
              breadcrumb: {
                term: "\u0627\u0644\u0645\u0634\u0627\u0631\u064A\u0639",
                text: "\u0645\u0633\u0627\u0631 \u0627\u0644\u062A\u0646\u0642\u0644 \u0641\u064A \u0623\u0639\u0644\u0649 \u0627\u0644\u0635\u0641\u062D\u0629. \u0627\u0646\u0642\u0631 \u0639\u0644\u0649 \xAB\u0627\u0644\u0645\u0634\u0627\u0631\u064A\u0639\xBB \u0644\u0644\u0639\u0648\u062F\u0629 \u0625\u0644\u0649 \u0627\u0644\u0642\u0627\u0626\u0645\u0629\u061B \u0648\u0628\u062C\u0627\u0646\u0628\u0647 \u062A\u0631\u0649 \u0627\u0633\u0645 \u0627\u0644\u0645\u0634\u0631\u0648\u0639 \u0627\u0644\u0645\u0641\u062A\u0648\u062D."
              },
              meeting: {
                term: "\u0628\u062F\u0621 \u0627\u062C\u062A\u0645\u0627\u0639",
                text: "\u0632\u0631 \u0641\u064A \u0623\u0639\u0644\u0649 \u0627\u0644\u0635\u0641\u062D\u0629 \u0644\u0623\u0639\u0636\u0627\u0621 \u0627\u0644\u0645\u0634\u0631\u0648\u0639 \u0627\u0644\u0642\u0627\u062F\u0631\u064A\u0646 \u0639\u0644\u0649 \u0627\u0644\u0645\u0633\u0627\u0647\u0645\u0629. \u064A\u0637\u0644\u0628 \u0639\u0646\u0648\u0627\u0646 \u0627\u0644\u0627\u062C\u062A\u0645\u0627\u0639 \u062B\u0645 \u064A\u0641\u062A\u062D \u0642\u0627\u0639\u0629 \u0627\u0644\u0627\u062C\u062A\u0645\u0627\u0639."
              },
              code: {
                term: "\u0627\u0644\u0631\u0645\u0632",
                text: "\u0631\u0645\u0632 \u0627\u0644\u0645\u0634\u0631\u0648\u0639\u060C \u064A\u064F\u0633\u062A\u0639\u0645\u0644 \u0641\u064A \u0648\u062B\u0627\u0626\u0642\u0647 \u0648\u0641\u0648\u0627\u062A\u064A\u0631\u0647."
              },
              client: {
                term: "\u0627\u0644\u062D\u0631\u064A\u0641",
                text: "\u062D\u0631\u064A\u0641 \u0627\u0644\u0645\u0634\u0631\u0648\u0639 (\u0635\u0627\u062D\u0628 \u0627\u0644\u0645\u0634\u0631\u0648\u0639)\u060C \u0623\u0648 \xAB\u0628\u062F\u0648\u0646 \u062D\u0631\u064A\u0641\xBB \u0625\u0646 \u0644\u0645 \u064A\u064F\u062F\u062E\u064E\u0644 \u0628\u0639\u062F."
              },
              status: {
                term: "\u0627\u0644\u062D\u0627\u0644\u0629",
                text: "\u0634\u0627\u0631\u0629 \u062A\u0628\u064A\u0651\u0646 \u062D\u0627\u0644\u0629 \u0627\u0644\u0645\u0634\u0631\u0648\u0639: \u0645\u0633\u0648\u062F\u0629 \u0623\u0648 \u062C\u0627\u0631\u064D \u0623\u0648 \u0645\u062A\u0648\u0642\u0641 \u0645\u0624\u0642\u062A\u064B\u0627 \u0623\u0648 \u0645\u063A\u0644\u0642 \u0623\u0648 \u0645\u0624\u0631\u0634\u0641."
              },
              progress: {
                term: "\u0627\u0644\u0645\u0631\u0627\u062D\u0644 \u0627\u0644\u0645\u063A\u0644\u0642\u0629: \u20662 / 7\u2069",
                text: "\u0634\u0631\u064A\u0637 \u062A\u0642\u062F\u0651\u0645 \u0648\u0639\u062F\u062F \u0627\u0644\u0645\u0631\u0627\u062D\u0644 \u0627\u0644\u0645\u063A\u0644\u0642\u0629\u060C \u0645\u0639 \u0627\u0644\u0645\u0631\u062D\u0644\u0629 \u0627\u0644\u062D\u0627\u0644\u064A\u0629."
              },
              tabs: {
                term: "\u0627\u0644\u0645\u0646\u0634\u0648\u0631\u0627\u062A\u060C \u0627\u0644\u0645\u0644\u0641\u0627\u062A\u060C \u0627\u0644\u0645\u0647\u0627\u0645\u060C \u0627\u0644\u0645\u0631\u0627\u062D\u0644\u060C \u0627\u0644\u0645\u062E\u0631\u062C\u0627\u062A\u060C \u0627\u0644\u062A\u0623\u0634\u064A\u0631\u0627\u062A\u060C \u0627\u0644\u0631\u0632\u0646\u0627\u0645\u0629\u060C \u0627\u0644\u0645\u0627\u0644\u064A\u0629\u060C \u0627\u0644\u0625\u0639\u062F\u0627\u062F\u0627\u062A",
                text: "\u062A\u0628\u0648\u064A\u0628\u0627\u062A \u0627\u0644\u0645\u0634\u0631\u0648\u0639. \u0623\u0646\u062A \u0627\u0644\u0622\u0646 \u0641\u064A \xAB\u0627\u0644\u0645\u0647\u0627\u0645\xBB."
              }
            }
          },
          toolbar: {
            title: "\u0639\u0631\u0636 \u0627\u0644\u0645\u0647\u0627\u0645",
            items: {
              list: {
                term: "\u0642\u0627\u0626\u0645\u0629",
                text: "\u0627\u0644\u0645\u0647\u0627\u0645 \u0641\u064A \u062C\u062F\u0648\u0644\u060C \u0628\u0633\u0637\u0631 \u0644\u0643\u0644 \u0645\u0647\u0645\u0629. \u0647\u0630\u0627 \u0647\u0648 \u0627\u0644\u0639\u0631\u0636 \u0627\u0644\u0627\u0641\u062A\u0631\u0627\u0636\u064A."
              },
              board: {
                term: "\u0644\u0648\u062D\u0629",
                text: "\u0627\u0644\u0645\u0647\u0627\u0645 \u0641\u064A \u0623\u0639\u0645\u062F\u0629\u060C \u0639\u0645\u0648\u062F \u0644\u0643\u0644 \u062D\u0627\u0644\u0629 (\u0639\u0644\u0649 \u0637\u0631\u064A\u0642\u0629 \u0644\u0648\u062D\u0629 \u2066Kanban\u2069). \u0627\u0633\u062D\u0628 \u0628\u0637\u0627\u0642\u0629 \u0645\u0646 \u0639\u0645\u0648\u062F \u0625\u0644\u0649 \u0622\u062E\u0631 \u0644\u062A\u063A\u064A\u064A\u0631 \u062D\u0627\u0644\u062A\u0647\u0627\u061B \u0648\u0625\u0646 \u0641\u0634\u0644 \u0627\u0644\u0646\u0642\u0644 \u062A\u0639\u0648\u062F \u0627\u0644\u0628\u0637\u0627\u0642\u0629 \u0625\u0644\u0649 \u0645\u0643\u0627\u0646\u0647\u0627."
              },
              newTask: {
                term: "\u0645\u0647\u0645\u0629 \u062C\u062F\u064A\u062F\u0629",
                text: "\u064A\u0641\u062A\u062D \u0646\u0627\u0641\u0630\u0629 \u0627\u0644\u0625\u0646\u0634\u0627\u0621. \u0644\u0623\u0639\u0636\u0627\u0621 \u0627\u0644\u0645\u0634\u0631\u0648\u0639 \u0627\u0644\u0642\u0627\u062F\u0631\u064A\u0646 \u0639\u0644\u0649 \u0627\u0644\u0645\u0633\u0627\u0647\u0645\u0629 \u0641\u0642\u0637\u061B \u0623\u0645\u0627 \u0627\u0644\u0622\u062E\u0631\u0648\u0646 \u0641\u064A\u0637\u0651\u0644\u0639\u0648\u0646 \u0641\u0642\u0637."
              },
              loadMore: {
                term: "\u0639\u0631\u0636 \u0627\u0644\u0645\u0632\u064A\u062F \u0645\u0646 \u0627\u0644\u0645\u0647\u0627\u0645",
                text: "\u064A\u0638\u0647\u0631 \u062A\u062D\u062A \u0627\u0644\u0642\u0627\u0626\u0645\u0629 \u0639\u0646\u062F\u0645\u0627 \u062A\u0628\u0642\u0649 \u0645\u0647\u0627\u0645 \u0644\u0645 \u062A\u064F\u0639\u0631\u0636 \u0628\u0639\u062F."
              }
            }
          },
          filters: {
            title: "\u062A\u0635\u0641\u064A\u0629 \u0627\u0644\u0645\u0647\u0627\u0645",
            items: {
              search: {
                term: "\u0627\u0644\u0628\u062D\u062B \u0639\u0646 \u0645\u0647\u0645\u0629",
                text: "\u0627\u0643\u062A\u0628 \u062C\u0632\u0621\u064B\u0627 \u0645\u0646 \u0627\u0644\u0639\u0646\u0648\u0627\u0646. \u062A\u062A\u062D\u062F\u0651\u062B \u0627\u0644\u0642\u0627\u0626\u0645\u0629 \u0628\u0645\u062C\u0631\u062F \u0623\u0646 \u062A\u062A\u0648\u0642\u0641 \u0639\u0646 \u0627\u0644\u0643\u062A\u0627\u0628\u0629."
              },
              assignee: {
                term: "\u0627\u0644\u0645\u0633\u0624\u0648\u0644",
                text: "\u064A\u064F\u0628\u0642\u064A \u0641\u0642\u0637 \u0627\u0644\u0645\u0647\u0627\u0645 \u0627\u0644\u0645\u0633\u0646\u062F\u0629 \u0625\u0644\u0649 \u0634\u062E\u0635 \u0648\u0627\u062D\u062F. \u064A\u0632\u064A\u0644 \xAB\u0643\u0644 \u0627\u0644\u0645\u0633\u0624\u0648\u0644\u064A\u0646\xBB \u0627\u0644\u062A\u0635\u0641\u064A\u0629."
              },
              status: {
                term: "\u0627\u0644\u062D\u0627\u0644\u0629",
                text: "\u064A\u064F\u0628\u0642\u064A \u0641\u0642\u0637 \u0627\u0644\u0645\u0647\u0627\u0645 \u0644\u0644\u0625\u0646\u062C\u0627\u0632 \u0623\u0648 \u0642\u064A\u062F \u0627\u0644\u062A\u0646\u0641\u064A\u0630 \u0623\u0648 \u0645\u062A\u0648\u0642\u0641\u0629 \u0623\u0648 \u0645\u0646\u062C\u0632\u0629."
              },
              discipline: {
                term: "\u0627\u0644\u0627\u062E\u062A\u0635\u0627\u0635",
                text: "\u064A\u064F\u0628\u0642\u064A \u0641\u0642\u0637 \u0645\u0647\u0627\u0645 \u0627\u062E\u062A\u0635\u0627\u0635 \u0648\u0627\u062D\u062F (\u0627\u0644\u0639\u0645\u0627\u0631\u0629\u060C \u0627\u0644\u0647\u064A\u0627\u0643\u0644\u060C \u0627\u0644\u0637\u0631\u0642 \u0648\u0627\u0644\u0634\u0628\u0643\u0627\u062A \u0627\u0644\u0645\u062E\u062A\u0644\u0641\u0629\u2026)."
              },
              phase: {
                term: "\u0627\u0644\u0645\u0631\u062D\u0644\u0629",
                text: "\u064A\u064F\u0628\u0642\u064A \u0641\u0642\u0637 \u0627\u0644\u0645\u0647\u0627\u0645 \u0627\u0644\u0645\u0631\u062A\u0628\u0637\u0629 \u0628\u0645\u0631\u062D\u0644\u0629 \u0645\u0646 \u0627\u0644\u0645\u0634\u0631\u0648\u0639."
              },
              dueBefore: {
                term: "\u0627\u0644\u0627\u0633\u062A\u062D\u0642\u0627\u0642 \u0642\u0628\u0644",
                text: "\u0627\u062E\u062A\u0631 \u062A\u0627\u0631\u064A\u062E\u064B\u0627 \u0644\u0631\u0624\u064A\u0629 \u0627\u0644\u0645\u0647\u0627\u0645 \u0627\u0644\u0645\u0633\u062A\u062D\u0642\u0629 \u0642\u0628\u0644 \u0630\u0644\u0643 \u0627\u0644\u064A\u0648\u0645 \u0641\u0642\u0637."
              },
              clear: {
                term: "\u0645\u0633\u062D \u0639\u0648\u0627\u0645\u0644 \u0627\u0644\u062A\u0635\u0641\u064A\u0629",
                text: "\u064A\u0632\u064A\u0644 \u0643\u0644 \u0627\u0644\u062A\u0635\u0641\u064A\u0627\u062A \u062F\u0641\u0639\u0629 \u0648\u0627\u062D\u062F\u0629."
              }
            }
          },
          list: {
            title: "\u0645\u0647\u0627\u0645 \u0627\u0644\u0645\u0634\u0631\u0648\u0639",
            items: {
              title: {
                term: "\u0627\u0644\u0645\u0647\u0645\u0629",
                text: "\u0639\u0646\u0648\u0627\u0646 \u0627\u0644\u0645\u0647\u0645\u0629. \u0627\u0646\u0642\u0631 \u0639\u0644\u064A\u0647 \u0644\u0641\u062A\u062D \u0644\u0648\u062D\u0629 \u062A\u0641\u0627\u0635\u064A\u0644\u0647\u0627 \u0639\u0644\u0649 \u0627\u0644\u062C\u0627\u0646\u0628."
              },
              status: {
                term: "\u0627\u0644\u062D\u0627\u0644\u0629",
                text: "\u0644\u0644\u0625\u0646\u062C\u0627\u0632 \u0623\u0648 \u0642\u064A\u062F \u0627\u0644\u062A\u0646\u0641\u064A\u0630 \u0623\u0648 \u0645\u062A\u0648\u0642\u0641\u0629 \u0623\u0648 \u0645\u0646\u062C\u0632\u0629."
              },
              priority: {
                term: "\u0627\u0644\u0623\u0648\u0644\u0648\u064A\u0629",
                text: "\u0645\u0646\u062E\u0641\u0636\u0629 \u0623\u0648 \u0639\u0627\u062F\u064A\u0629 \u0623\u0648 \u0639\u0627\u0644\u064A\u0629 \u0623\u0648 \u0639\u0627\u062C\u0644\u0629."
              },
              assignees: {
                term: "\u0627\u0644\u0645\u0633\u0624\u0648\u0644\u0648\u0646",
                text: "\u0627\u0644\u0623\u0634\u062E\u0627\u0635 \u0627\u0644\u0645\u0643\u0644\u0641\u0648\u0646 \u0628\u0627\u0644\u0645\u0647\u0645\u0629\u060C \u0623\u0648 \xAB\u0644\u0627 \u0623\u062D\u062F\xBB."
              },
              phaseDiscipline: {
                term: "\u0627\u0644\u0645\u0631\u062D\u0644\u0629 \u0648\u0627\u0644\u0627\u062E\u062A\u0635\u0627\u0635",
                text: "\u0645\u0631\u062D\u0644\u0629 \u0627\u0644\u0645\u0634\u0631\u0648\u0639 \u0648\u0627\u062E\u062A\u0635\u0627\u0635 \u0627\u0644\u0645\u0647\u0645\u0629\u060C \u0623\u0648 \xAB\u0628\u062F\u0648\u0646 \u0645\u0631\u062D\u0644\u0629\xBB \u0648\xAB\u0628\u062F\u0648\u0646 \u0627\u062E\u062A\u0635\u0627\u0635\xBB."
              },
              due: {
                term: "\u0627\u0644\u0627\u0633\u062A\u062D\u0642\u0627\u0642",
                text: "\u0627\u0644\u0645\u0648\u0639\u062F \u0627\u0644\u0623\u0642\u0635\u0649\u060C \u0623\u0648 \xAB\u0628\u062F\u0648\u0646 \u0645\u0648\u0639\u062F\xBB. \u062A\u0638\u0647\u0631 \u0639\u0628\u0627\u0631\u0629 \xAB\u0645\u062A\u0623\u062E\u0631\u0629\xBB \u0639\u0646\u062F\u0645\u0627 \u064A\u0645\u0631\u0651 \u0627\u0644\u062A\u0627\u0631\u064A\u062E."
              },
              checklist: {
                term: "\u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u0645\u0631\u0627\u062C\u0639\u0629",
                text: "\u062A\u0642\u062F\u0651\u0645 \u0627\u0644\u0646\u0642\u0627\u0637 \u0627\u0644\u0635\u063A\u064A\u0631\u0629 \u0627\u0644\u062A\u064A \u062A\u064F\u0624\u0634\u064E\u0651\u0631 \u0641\u064A \u0627\u0644\u0645\u0647\u0645\u0629\u060C \u0645\u062B\u0644 \xAB\u20662\u2069 \u0645\u0646 \u20665\u2069 \u0645\u0646\u062C\u0632\u0629\xBB\u060C \u0623\u0648 \xAB\u0644\u0627 \u062A\u0648\u062C\u062F\xBB."
              }
            }
          },
          board: {
            title: "\u0644\u0648\u062D\u0629 \u0627\u0644\u0645\u0647\u0627\u0645",
            items: {
              todo: {
                term: "\u0644\u0644\u0625\u0646\u062C\u0627\u0632",
                text: "\u0627\u0644\u0645\u0647\u0627\u0645 \u0627\u0644\u062A\u064A \u0644\u0645 \u062A\u0628\u062F\u0623 \u0628\u0639\u062F."
              },
              inProgress: {
                term: "\u0642\u064A\u062F \u0627\u0644\u062A\u0646\u0641\u064A\u0630",
                text: "\u0627\u0644\u0645\u0647\u0627\u0645 \u0627\u0644\u062A\u064A \u064A\u0639\u0645\u0644 \u0639\u0644\u064A\u0647\u0627 \u0623\u062D\u062F\u0647\u0645."
              },
              blocked: {
                term: "\u0645\u062A\u0648\u0642\u0641\u0629",
                text: "\u0627\u0644\u0645\u0647\u0627\u0645 \u0627\u0644\u062A\u064A \u062A\u0646\u062A\u0638\u0631 \u0634\u064A\u0626\u064B\u0627 \u0644\u062A\u062A\u0642\u062F\u0651\u0645."
              },
              done: {
                term: "\u0645\u0646\u062C\u0632\u0629",
                text: "\u0627\u0644\u0645\u0647\u0627\u0645 \u0627\u0644\u0645\u0646\u062A\u0647\u064A\u0629."
              },
              card: {
                term: "\u0627\u0644\u0628\u0637\u0627\u0642\u0629",
                text: "\u062A\u0639\u0631\u0636 \u0643\u0644 \u0628\u0637\u0627\u0642\u0629 \u0627\u0644\u0639\u0646\u0648\u0627\u0646 \u0648\u0627\u0644\u0645\u0633\u0624\u0648\u0644\u064A\u0646 \u0648\u0627\u0644\u0645\u0648\u0639\u062F \u0648\u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u0645\u0631\u0627\u062C\u0639\u0629. \u0627\u0646\u0642\u0631 \u0639\u0644\u064A\u0647\u0627 \u0644\u0641\u062A\u062D \u0627\u0644\u0645\u0647\u0645\u0629."
              }
            }
          },
          newDialog: {
            title: "\u0645\u0647\u0645\u0629 \u062C\u062F\u064A\u062F\u0629",
            items: {
              title: {
                term: "\u0627\u0644\u0639\u0646\u0648\u0627\u0646",
                text: "\u062D\u0642\u0644 \u0625\u0644\u0632\u0627\u0645\u064A\u060C 200 \u062D\u0631\u0641 \u0639\u0644\u0649 \u0627\u0644\u0623\u0643\u062B\u0631."
              },
              phase: {
                term: "\u0627\u0644\u0645\u0631\u062D\u0644\u0629",
                text: "\u0627\u062E\u062A\u064A\u0627\u0631\u064A: \u064A\u0631\u0628\u0637 \u0627\u0644\u0645\u0647\u0645\u0629 \u0628\u0645\u0631\u062D\u0644\u0629 \u0645\u0646 \u0627\u0644\u0645\u0634\u0631\u0648\u0639 (\xAB\u0628\u062F\u0648\u0646 \u0645\u0631\u062D\u0644\u0629\xBB \u0627\u0641\u062A\u0631\u0627\u0636\u064A\u064B\u0627)."
              },
              discipline: {
                term: "\u0627\u0644\u0627\u062E\u062A\u0635\u0627\u0635",
                text: "\u0627\u062E\u062A\u064A\u0627\u0631\u064A (\xAB\u0628\u062F\u0648\u0646 \u0627\u062E\u062A\u0635\u0627\u0635\xBB \u0627\u0641\u062A\u0631\u0627\u0636\u064A\u064B\u0627)."
              },
              priority: {
                term: "\u0627\u0644\u0623\u0648\u0644\u0648\u064A\u0629",
                text: "\u0645\u0646\u062E\u0641\u0636\u0629 \u0623\u0648 \u0639\u0627\u062F\u064A\u0629 \u0623\u0648 \u0639\u0627\u0644\u064A\u0629 \u0623\u0648 \u0639\u0627\u062C\u0644\u0629."
              },
              due: {
                term: "\u0627\u0644\u0627\u0633\u062A\u062D\u0642\u0627\u0642",
                text: "\u0627\u062E\u062A\u064A\u0627\u0631\u064A: \u0627\u0644\u0645\u0648\u0639\u062F \u0627\u0644\u0623\u0642\u0635\u0649."
              },
              assignees: {
                term: "\u0627\u0644\u0645\u0633\u0624\u0648\u0644\u0648\u0646",
                text: "\u0627\u062E\u062A\u064A\u0627\u0631\u064A: \u0627\u062E\u062A\u0631 \u0634\u062E\u0635\u064B\u0627 \u0623\u0648 \u0623\u0643\u062B\u0631 \u0645\u0646 \u0623\u0639\u0636\u0627\u0621 \u0627\u0644\u0645\u0634\u0631\u0648\u0639."
              },
              parent: {
                term: "\u0627\u0644\u0645\u0647\u0645\u0629 \u0627\u0644\u0623\u0635\u0644\u064A\u0629",
                text: "\u0627\u062E\u062A\u0631 \u0645\u0647\u0645\u0629 \u0644\u0625\u0646\u0634\u0627\u0621 \u0645\u0647\u0645\u0629 \u0641\u0631\u0639\u064A\u0629. \u0644\u0627 \u064A\u0645\u0643\u0646 \u0623\u0646 \u062A\u062D\u062A\u0648\u064A \u0627\u0644\u0645\u0647\u0645\u0629 \u0627\u0644\u0641\u0631\u0639\u064A\u0629 \u0639\u0644\u0649 \u0645\u0647\u0627\u0645 \u0641\u0631\u0639\u064A\u0629. \xAB\u0628\u062F\u0648\u0646 (\u0645\u0647\u0645\u0629 \u0631\u0626\u064A\u0633\u064A\u0629)\xBB \u0627\u0641\u062A\u0631\u0627\u0636\u064A\u064B\u0627."
              },
              submit: {
                term: "\u0625\u0646\u0634\u0627\u0621 \u0627\u0644\u0645\u0647\u0645\u0629",
                text: "\u064A\u0646\u0634\u0626 \u0627\u0644\u0645\u0647\u0645\u0629. \u064A\u063A\u0644\u0642 \xAB\u0625\u0644\u063A\u0627\u0621\xBB \u0627\u0644\u0646\u0627\u0641\u0630\u0629."
              }
            }
          },
          panel: {
            title: "\u0645\u0647\u0645\u0629",
            items: {
              fields: {
                term: "\u0627\u0644\u0639\u0646\u0648\u0627\u0646\u060C \u0627\u0644\u062D\u0627\u0644\u0629\u060C \u0627\u0644\u0623\u0648\u0644\u0648\u064A\u0629\u060C \u0627\u0644\u0645\u0631\u062D\u0644\u0629\u060C \u0627\u0644\u0627\u062E\u062A\u0635\u0627\u0635\u060C \u0627\u0644\u0627\u0633\u062A\u062D\u0642\u0627\u0642\u060C \u0627\u0644\u0645\u0633\u0624\u0648\u0644\u0648\u0646",
                text: "\u0645\u0639\u0644\u0648\u0645\u0627\u062A \u0627\u0644\u0645\u0647\u0645\u0629\u060C \u064A\u0639\u062F\u0651\u0644\u0647\u0627 \u0627\u0644\u0623\u0639\u0636\u0627\u0621 \u0627\u0644\u0642\u0627\u062F\u0631\u0648\u0646 \u0639\u0644\u0649 \u0627\u0644\u0645\u0633\u0627\u0647\u0645\u0629. \u0623\u0645\u0627 \u0627\u0644\u0622\u062E\u0631\u0648\u0646 \u0641\u064A\u0642\u0631\u0624\u0648\u0646 \u0641\u0642\u0637: \xAB\u064A\u0645\u0643\u0646\u0643 \u0627\u0644\u0627\u0637\u0644\u0627\u0639 \u0639\u0644\u0649 \u0647\u0630\u0647 \u0627\u0644\u0645\u0647\u0645\u0629 \u062F\u0648\u0646 \u062A\u0639\u062F\u064A\u0644\u0647\u0627\xBB."
              },
              description: {
                term: "\u0627\u0644\u0648\u0635\u0641",
                text: "\u0627\u0644\u0646\u0635 \u0627\u0644\u0645\u0641\u0635\u0651\u0644 \u0644\u0644\u0645\u0647\u0645\u0629. \xAB\u062A\u0639\u062F\u064A\u0644 \u0627\u0644\u0648\u0635\u0641\xBB \u064A\u0641\u062A\u062D \u0645\u062D\u0631\u0631\u064B\u0627\u061B \u0648\u0625\u0646 \u063A\u0627\u062F\u0631\u062A \u062F\u0648\u0646 \u062D\u0641\u0638 \u062A\u0637\u0644\u0628 \u0645\u0646\u0643 \u0646\u0627\u0641\u0630\u0629 \u0627\u0644\u062A\u0623\u0643\u064A\u062F."
              },
              checklist: {
                term: "\u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u0645\u0631\u0627\u062C\u0639\u0629",
                text: "\u0646\u0642\u0627\u0637 \u0635\u063A\u064A\u0631\u0629 \u062A\u064F\u0624\u0634\u064E\u0651\u0631: \u0623\u0636\u0641 \u0639\u0646\u0635\u0631\u064B\u0627 \u0623\u0648 \u063A\u064A\u0651\u0631 \u0627\u0633\u0645\u0647 \u0623\u0648 \u0627\u062D\u0630\u0641\u0647."
              },
              dependencies: {
                term: "\u0627\u0644\u062A\u0628\u0639\u064A\u0627\u062A",
                text: "\u0627\u0644\u0645\u0647\u0627\u0645 \u0627\u0644\u062A\u064A \u064A\u062C\u0628 \u0625\u0646\u0647\u0627\u0624\u0647\u0627 \u0642\u0628\u0644 \u0647\u0630\u0647 \u0627\u0644\u0645\u0647\u0645\u0629. \u062A\u064F\u0631\u0641\u0636 \u0627\u0644\u062A\u0628\u0639\u064A\u0629 \u0627\u0644\u062A\u064A \u062A\u0646\u0634\u0626 \u062D\u0644\u0642\u0629 \u0645\u063A\u0644\u0642\u0629."
              },
              subtasks: {
                term: "\u0627\u0644\u0645\u0647\u0627\u0645 \u0627\u0644\u0641\u0631\u0639\u064A\u0629",
                text: "\u0627\u0644\u0645\u0647\u0627\u0645 \u0627\u0644\u062A\u0627\u0628\u0639\u0629 \u0644\u0647\u0630\u0647 \u0627\u0644\u0645\u0647\u0645\u0629\u061B \u0623\u0636\u0641 \u0645\u0646\u0647\u0627 \u0628\u0640\xAB\u0625\u0636\u0627\u0641\u0629 \u0645\u0647\u0645\u0629 \u0641\u0631\u0639\u064A\u0629\xBB."
              },
              comments: {
                term: "\u0627\u0644\u062A\u0639\u0644\u064A\u0642\u0627\u062A",
                text: "\u0627\u0644\u0646\u0642\u0627\u0634\u0627\u062A \u062D\u0648\u0644 \u0627\u0644\u0645\u0647\u0645\u0629. \u0627\u0643\u062A\u0628 @ \u0644\u0644\u0625\u0634\u0627\u0631\u0629 \u0625\u0644\u0649 \u0623\u062D\u062F \u0623\u0639\u0636\u0627\u0621 \u0627\u0644\u0645\u0634\u0631\u0648\u0639\u061B \u0648\xAB\u0646\u0634\u0631 \u0627\u0644\u062A\u0639\u0644\u064A\u0642\xBB \u064A\u0631\u0633\u0644\u0647. \u064A\u0645\u0643\u0646\u0643 \u062A\u0639\u062F\u064A\u0644 \u062A\u0639\u0644\u064A\u0642\u0643 \u0623\u0648 \u062D\u0630\u0641\u0647."
              },
              delete: {
                term: "\u062D\u0630\u0641 \u0627\u0644\u0645\u0647\u0645\u0629",
                text: "\u064A\u062D\u0630\u0641 \u0627\u0644\u0645\u0647\u0645\u0629 \u0645\u0639 \u0642\u0627\u0626\u0645\u0629 \u0645\u0631\u0627\u062C\u0639\u062A\u0647\u0627 \u0648\u0645\u0647\u0627\u0645\u0647\u0627 \u0627\u0644\u0641\u0631\u0639\u064A\u0629 \u0648\u062A\u0639\u0644\u064A\u0642\u0627\u062A\u0647\u0627\u060C \u0628\u0639\u062F \u0627\u0644\u062A\u0623\u0643\u064A\u062F."
              },
              notFound: {
                term: "\u0627\u0644\u0645\u0647\u0645\u0629 \u063A\u064A\u0631 \u0645\u0648\u062C\u0648\u062F\u0629",
                text: "\u062A\u0638\u0647\u0631 \u0625\u0630\u0627 \u062D\u064F\u0630\u0641\u062A \u0627\u0644\u0645\u0647\u0645\u0629 \u0623\u0648 \u0644\u0645 \u064A\u0639\u062F \u0628\u0625\u0645\u0643\u0627\u0646\u0643 \u0627\u0644\u0648\u0635\u0648\u0644 \u0625\u0644\u064A\u0647\u0627."
              }
            }
          },
          empty: {
            title: "\u0631\u0633\u0627\u0626\u0644 \u0627\u0644\u062D\u0627\u0644\u0629",
            items: {
              none: {
                term: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0645\u0647\u0627\u0645 \u0628\u0639\u062F",
                text: "\u062A\u0638\u0647\u0631 \u0639\u0646\u062F\u0645\u0627 \u0644\u0627 \u062A\u0643\u0648\u0646 \u0641\u064A \u0627\u0644\u0645\u0634\u0631\u0648\u0639 \u0645\u0647\u0627\u0645. \u064A\u062D\u0635\u0644 \u0627\u0644\u0623\u0639\u0636\u0627\u0621 \u0627\u0644\u0642\u0627\u062F\u0631\u0648\u0646 \u0639\u0644\u0649 \u0627\u0644\u0645\u0633\u0627\u0647\u0645\u0629 \u0639\u0644\u0649 \u0632\u0631 \xAB\u0645\u0647\u0645\u0629 \u062C\u062F\u064A\u062F\u0629\xBB."
              },
              noMatch: {
                term: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0645\u0647\u0645\u0629 \u0645\u0637\u0627\u0628\u0642\u0629",
                text: "\u062A\u0638\u0647\u0631 \u0639\u0646\u062F\u0645\u0627 \u0644\u0627 \u062A\u062C\u062F \u0627\u0644\u062A\u0635\u0641\u064A\u0627\u062A \u0634\u064A\u0626\u064B\u0627: \u0639\u062F\u0651\u0644\u0647\u0627 \u0623\u0648 \u0627\u0645\u0633\u062D\u0647\u0627."
              },
              loadFailed: {
                term: "\u062A\u0639\u0630\u0631 \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0645\u0647\u0627\u0645",
                text: "\u0631\u0633\u0627\u0644\u0629 \u062D\u0645\u0631\u0627\u0621 \u0639\u0646\u062F \u0645\u0634\u0643\u0644\u0629 \u0641\u064A \u0627\u0644\u0627\u062A\u0635\u0627\u0644: \u062A\u062D\u0642\u0642 \u0645\u0646\u0647 \u062B\u0645 \u0627\u0646\u0642\u0631 \u0639\u0644\u0649 \xAB\u0625\u0639\u0627\u062F\u0629 \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629\xBB."
              }
            }
          }
        }
      },
      phases: {
        title: "\u0627\u0644\u0645\u0631\u0627\u062D\u0644",
        intro: "\u0633\u064A\u0631 \u0627\u0644\u0645\u0647\u0645\u0629 \u0645\u0646 \u0627\u0644\u0645\u062E\u0637\u0637 \u0627\u0644\u0623\u0648\u0644\u064A \u0625\u0644\u0649 \u0627\u0644\u0627\u0633\u062A\u0644\u0627\u0645: \u0627\u0644\u062A\u0648\u0627\u0631\u064A\u062E \u0627\u0644\u0645\u0628\u0631\u0645\u062C\u0629 \u0648\u0627\u0644\u0641\u0639\u0644\u064A\u0629 \u0648\u0627\u0644\u062A\u0623\u062E\u064A\u0631\u0627\u062A \u0648\u062D\u0635\u0629 \u0643\u0644 \u0645\u0631\u062D\u0644\u0629 \u0645\u0646 \u0627\u0644\u0623\u062A\u0639\u0627\u0628. \u064A\u0639\u062F\u0651\u0644\u0647\u0627 \u0645\u0633\u0624\u0648\u0644\u0648 \u0627\u0644\u0645\u0634\u0631\u0648\u0639 \u0648\u064A\u0637\u0651\u0644\u0639 \u0639\u0644\u064A\u0647\u0627 \u0627\u0644\u0622\u062E\u0631\u0648\u0646.",
        sections: {
          summary: {
            title: "\u0645\u0644\u062E\u0635 \u0627\u0644\u0645\u0634\u0631\u0648\u0639",
            items: {
              breadcrumb: {
                term: "\u0627\u0644\u0645\u0634\u0627\u0631\u064A\u0639",
                text: "\u0645\u0633\u0627\u0631 \u0627\u0644\u062A\u0646\u0642\u0644 \u0641\u064A \u0623\u0639\u0644\u0649 \u0627\u0644\u0635\u0641\u062D\u0629. \u0627\u0646\u0642\u0631 \u0639\u0644\u0649 \xAB\u0627\u0644\u0645\u0634\u0627\u0631\u064A\u0639\xBB \u0644\u0644\u0639\u0648\u062F\u0629 \u0625\u0644\u0649 \u0627\u0644\u0642\u0627\u0626\u0645\u0629\u061B \u0648\u0628\u062C\u0627\u0646\u0628\u0647 \u062A\u0631\u0649 \u0627\u0633\u0645 \u0627\u0644\u0645\u0634\u0631\u0648\u0639 \u0627\u0644\u0645\u0641\u062A\u0648\u062D."
              },
              meeting: {
                term: "\u0628\u062F\u0621 \u0627\u062C\u062A\u0645\u0627\u0639",
                text: "\u0632\u0631 \u0641\u064A \u0623\u0639\u0644\u0649 \u0627\u0644\u0635\u0641\u062D\u0629 \u0644\u0623\u0639\u0636\u0627\u0621 \u0627\u0644\u0645\u0634\u0631\u0648\u0639 \u0627\u0644\u0642\u0627\u062F\u0631\u064A\u0646 \u0639\u0644\u0649 \u0627\u0644\u0645\u0633\u0627\u0647\u0645\u0629. \u064A\u0637\u0644\u0628 \u0639\u0646\u0648\u0627\u0646 \u0627\u0644\u0627\u062C\u062A\u0645\u0627\u0639 \u062B\u0645 \u064A\u0641\u062A\u062D \u0642\u0627\u0639\u0629 \u0627\u0644\u0627\u062C\u062A\u0645\u0627\u0639."
              },
              code: {
                term: "\u0627\u0644\u0631\u0645\u0632",
                text: "\u0631\u0645\u0632 \u0627\u0644\u0645\u0634\u0631\u0648\u0639\u060C \u064A\u064F\u0633\u062A\u0639\u0645\u0644 \u0641\u064A \u0648\u062B\u0627\u0626\u0642\u0647 \u0648\u0641\u0648\u0627\u062A\u064A\u0631\u0647."
              },
              client: {
                term: "\u0627\u0644\u062D\u0631\u064A\u0641",
                text: "\u062D\u0631\u064A\u0641 \u0627\u0644\u0645\u0634\u0631\u0648\u0639 (\u0635\u0627\u062D\u0628 \u0627\u0644\u0645\u0634\u0631\u0648\u0639)\u060C \u0623\u0648 \xAB\u0628\u062F\u0648\u0646 \u062D\u0631\u064A\u0641\xBB \u0625\u0646 \u0644\u0645 \u064A\u064F\u062F\u062E\u064E\u0644 \u0628\u0639\u062F."
              },
              status: {
                term: "\u0627\u0644\u062D\u0627\u0644\u0629",
                text: "\u0634\u0627\u0631\u0629 \u062A\u0628\u064A\u0651\u0646 \u062D\u0627\u0644\u0629 \u0627\u0644\u0645\u0634\u0631\u0648\u0639: \u0645\u0633\u0648\u062F\u0629 \u0623\u0648 \u062C\u0627\u0631\u064D \u0623\u0648 \u0645\u062A\u0648\u0642\u0641 \u0645\u0624\u0642\u062A\u064B\u0627 \u0623\u0648 \u0645\u063A\u0644\u0642 \u0623\u0648 \u0645\u0624\u0631\u0634\u0641."
              },
              progress: {
                term: "\u0627\u0644\u0645\u0631\u0627\u062D\u0644 \u0627\u0644\u0645\u063A\u0644\u0642\u0629: \u20662 / 7\u2069",
                text: "\u0634\u0631\u064A\u0637 \u062A\u0642\u062F\u0651\u0645 \u0648\u0639\u062F\u062F \u0627\u0644\u0645\u0631\u0627\u062D\u0644 \u0627\u0644\u0645\u063A\u0644\u0642\u0629\u060C \u0645\u0639 \u0627\u0644\u0645\u0631\u062D\u0644\u0629 \u0627\u0644\u062D\u0627\u0644\u064A\u0629."
              },
              tabs: {
                term: "\u0627\u0644\u0645\u0646\u0634\u0648\u0631\u0627\u062A\u060C \u0627\u0644\u0645\u0644\u0641\u0627\u062A\u060C \u0627\u0644\u0645\u0647\u0627\u0645\u060C \u0627\u0644\u0645\u0631\u0627\u062D\u0644\u060C \u0627\u0644\u0645\u062E\u0631\u062C\u0627\u062A\u060C \u0627\u0644\u062A\u0623\u0634\u064A\u0631\u0627\u062A\u060C \u0627\u0644\u0631\u0632\u0646\u0627\u0645\u0629\u060C \u0627\u0644\u0645\u0627\u0644\u064A\u0629\u060C \u0627\u0644\u0625\u0639\u062F\u0627\u062F\u0627\u062A",
                text: "\u062A\u0628\u0648\u064A\u0628\u0627\u062A \u0627\u0644\u0645\u0634\u0631\u0648\u0639. \u0623\u0646\u062A \u0627\u0644\u0622\u0646 \u0641\u064A \xAB\u0627\u0644\u0645\u0631\u0627\u062D\u0644\xBB."
              }
            }
          },
          overview: {
            title: "\u0627\u0644\u0645\u0631\u0627\u062D\u0644",
            items: {
              add: {
                term: "\u0625\u0636\u0627\u0641\u0629 \u0645\u0631\u062D\u0644\u0629",
                text: "\u0632\u0631 \u0645\u062E\u0635\u0635 \u0644\u0645\u0633\u0624\u0648\u0644\u064A \u0627\u0644\u0645\u0634\u0631\u0648\u0639. \u064A\u0641\u062A\u062D \u0646\u0627\u0641\u0630\u0629 \u0627\u0644\u0625\u0636\u0627\u0641\u0629."
              },
              readOnly: {
                term: "\u064A\u0645\u0643\u0646 \u0644\u0645\u0633\u0624\u0648\u0644\u064A \u0627\u0644\u0645\u0634\u0631\u0648\u0639 \u0648\u062D\u062F\u0647\u0645 \u062A\u0639\u062F\u064A\u0644 \u0627\u0644\u0645\u0631\u0627\u062D\u0644.",
                text: "\u0631\u0633\u0627\u0644\u0629 \u0632\u0631\u0642\u0627\u0621 \u062A\u0638\u0647\u0631 \u0644\u0644\u0623\u0639\u0636\u0627\u0621 \u0627\u0644\u0622\u062E\u0631\u064A\u0646\u060C \u0648\u0647\u0645 \u064A\u0637\u0651\u0644\u0639\u0648\u0646 \u0641\u0642\u0637."
              },
              timeline: {
                term: "\u0627\u0644\u062C\u062F\u0648\u0644 \u0627\u0644\u0632\u0645\u0646\u064A \u0644\u0645\u0631\u0627\u062D\u0644 \u0627\u0644\u0645\u0634\u0631\u0648\u0639",
                text: "\u0631\u0633\u0645 \u0644\u0644\u0645\u0631\u0627\u062D\u0644 \u0645\u0639 \u062A\u0648\u0627\u0631\u064A\u062E\u0647\u0627 \u0627\u0644\u0645\u0628\u0631\u0645\u062C\u0629 \u0648\u0627\u0644\u0641\u0639\u0644\u064A\u0629 \u0648\u0639\u0644\u0627\u0645\u0629 \u0644\u0644\u064A\u0648\u0645. \u0627\u0646\u0642\u0631 \u0639\u0644\u0649 \u0645\u0631\u062D\u0644\u0629 \u0644\u0641\u062A\u062D \u0644\u0648\u062D\u062A\u0647\u0627."
              },
              total: {
                term: "\u0645\u062C\u0645\u0648\u0639 \u062D\u0635\u0635 \u0627\u0644\u0623\u062A\u0639\u0627\u0628 \u062D\u0633\u0628 \u0627\u0644\u0645\u0631\u062D\u0644\u0629",
                text: "\u062A\u062D\u062A \u0627\u0644\u062C\u062F\u0648\u0644\u060C \u0644\u0645\u0646 \u064A\u062D\u0642 \u0644\u0647 \u0631\u0624\u064A\u0629 \u0627\u0644\u0623\u062A\u0639\u0627\u0628: \u0645\u062C\u0645\u0648\u0639 \u062D\u0635\u0635 \u0627\u0644\u0645\u0631\u0627\u062D\u0644."
              },
              warning: {
                term: "\u062D\u0635\u0635 \u0627\u0644\u0623\u062A\u0639\u0627\u0628 \u062A\u062D\u062A\u0627\u062C \u0625\u0644\u0649 \u0645\u0631\u0627\u062C\u0639\u0629",
                text: "\u0631\u0633\u0627\u0644\u0629 \u0628\u0631\u062A\u0642\u0627\u0644\u064A\u0629 \u0639\u0646\u062F\u0645\u0627 \u0644\u0627 \u064A\u0643\u0648\u0646 \u0627\u0644\u0645\u062C\u0645\u0648\u0639 \u2066100%\u2069. \u0647\u0630\u0627 \u0644\u0627 \u064A\u0645\u0646\u0639 \u0627\u0644\u0639\u0645\u0644: \u0639\u062F\u0651\u0644\u0647\u0627 \u0645\u062A\u0649 \u0634\u0626\u062A."
              },
              empty: {
                term: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0645\u0631\u0627\u062D\u0644 \u0641\u064A \u0647\u0630\u0627 \u0627\u0644\u0645\u0634\u0631\u0648\u0639 \u0628\u0639\u062F",
                text: "\u062A\u0638\u0647\u0631 \u0639\u0646\u062F\u0645\u0627 \u0644\u0627 \u062A\u0648\u062C\u062F \u0623\u064A \u0645\u0631\u062D\u0644\u0629. \u064A\u0645\u0643\u0646 \u0644\u0623\u062D\u062F \u0627\u0644\u0645\u0633\u0624\u0648\u0644\u064A\u0646 \u0625\u0636\u0627\u0641\u0629 \u0623\u0648\u0644 \u0645\u0631\u062D\u0644\u0629\u061B \u0623\u0645\u0627 \u0627\u0644\u0622\u062E\u0631\u0648\u0646 \u0641\u064A\u0646\u062A\u0638\u0631\u0648\u0646 \u0625\u0636\u0627\u0641\u062A\u0647\u0627."
              },
              loadFailed: {
                term: "\u062A\u0639\u0630\u0651\u0631 \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0645\u0631\u0627\u062D\u0644",
                text: "\u0631\u0633\u0627\u0644\u0629 \u062D\u0645\u0631\u0627\u0621 \u0639\u0646\u062F \u0645\u0634\u0643\u0644\u0629 \u0641\u064A \u0627\u0644\u0627\u062A\u0635\u0627\u0644: \u062A\u062D\u0642\u0642 \u0645\u0646\u0647 \u062B\u0645 \xAB\u0625\u0639\u0627\u062F\u0629 \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629\xBB."
              }
            }
          },
          table: {
            title: "\u0645\u0631\u0627\u062D\u0644 \u0627\u0644\u0645\u0634\u0631\u0648\u0639",
            items: {
              order: {
                term: "\u0627\u0644\u0631\u0642\u0645",
                text: "\u0631\u0642\u0645 \u062A\u0631\u062A\u064A\u0628 \u0627\u0644\u0645\u0631\u062D\u0644\u0629."
              },
              phase: {
                term: "\u0627\u0644\u0645\u0631\u062D\u0644\u0629",
                text: "\u0627\u0633\u0645 \u0627\u0644\u0645\u0631\u062D\u0644\u0629: \u2066ESQ\u2069 (\u0627\u0644\u0645\u062E\u0637\u0637 \u0627\u0644\u0623\u0648\u0644\u064A)\u060C \u2066APS\u2069 (\u0627\u0644\u062F\u0631\u0627\u0633\u0629 \u0627\u0644\u0623\u0648\u0644\u064A\u0629 \u0627\u0644\u0645\u0648\u062C\u0632\u0629)\u060C \u2066APD\u2069 (\u0627\u0644\u062F\u0631\u0627\u0633\u0629 \u0627\u0644\u0623\u0648\u0644\u064A\u0629 \u0627\u0644\u0645\u0641\u0635\u0644\u0629)\u060C \u2066PRO\u2069 (\u062F\u0631\u0627\u0633\u0629 \u0627\u0644\u0645\u0634\u0631\u0648\u0639)\u060C \u2066DCE\u2069 (\u0645\u0644\u0641 \u0637\u0644\u0628 \u0627\u0644\u0639\u0631\u0648\u0636 \u0644\u0644\u0645\u0642\u0627\u0648\u0644\u064A\u0646)\u060C \u2066ACT\u2069 (\u0627\u0644\u0645\u0633\u0627\u0639\u062F\u0629 \u0639\u0644\u0649 \u0625\u0628\u0631\u0627\u0645 \u0639\u0642\u0648\u062F \u0627\u0644\u0623\u0634\u063A\u0627\u0644)\u060C \u2066DET\u2069 (\u0627\u0644\u0625\u0634\u0631\u0627\u0641 \u0639\u0644\u0649 \u062A\u0646\u0641\u064A\u0630 \u0627\u0644\u0623\u0634\u063A\u0627\u0644)\u060C \u2066AOR\u2069 (\u0627\u0644\u0645\u0633\u0627\u0639\u062F\u0629 \u0639\u0644\u0649 \u0627\u0644\u0642\u0628\u0648\u0644)\u060C \u0623\u0648 \u0645\u0631\u062D\u0644\u0629 \u0645\u062E\u0635\u0651\u0635\u0629."
              },
              dates: {
                term: "\u0627\u0644\u0645\u062E\u0637\u0637 \u0648\u0627\u0644\u0641\u0639\u0644\u064A",
                text: "\u062A\u0627\u0631\u064A\u062E\u0627 \u0627\u0644\u0628\u062F\u0627\u064A\u0629 \u0648\u0627\u0644\u0646\u0647\u0627\u064A\u0629 \u0627\u0644\u0645\u062E\u0637\u0637\u0627\u0646\u060C \u062B\u0645 \u0627\u0644\u062A\u0627\u0631\u064A\u062E\u0627\u0646 \u0627\u0644\u0645\u0633\u062C\u0651\u0644\u0627\u0646 \u0641\u0639\u0644\u064A\u064B\u0627 (\u0634\u0631\u0637\u0629 \u0639\u0646\u062F\u0645\u0627 \u064A\u0643\u0648\u0646\u0627\u0646 \u0645\u062C\u0647\u0648\u0644\u064A\u0646)."
              },
              status: {
                term: "\u0627\u0644\u062D\u0627\u0644\u0629",
                text: "\u0644\u0645 \u062A\u0628\u062F\u0623 \u0623\u0648 \u0642\u064A\u062F \u0627\u0644\u062A\u0646\u0641\u064A\u0630 \u0623\u0648 \u0642\u064A\u062F \u0627\u0644\u0645\u0631\u0627\u062C\u0639\u0629 \u0623\u0648 \u0645\u063A\u0644\u0642\u0629."
              },
              schedule: {
                term: "\u0627\u0644\u0623\u062C\u0644",
                text: "\u064A\u0628\u064A\u0651\u0646 \u0625\u0646 \u0643\u0627\u0646\u062A \u0627\u0644\u0645\u0631\u062D\u0644\u0629 \u062A\u062D\u062A\u0631\u0645 \u062A\u0648\u0627\u0631\u064A\u062E\u0647\u0627\u060C \u0645\u062B\u0644 \xAB\u0636\u0645\u0646 \u0627\u0644\u0622\u062C\u0627\u0644\xBB \u0623\u0648 \xAB\u0645\u062A\u0623\u062E\u0631\u0629 \u0628\u0640 \u20665\u2069 \u0623\u064A\u0627\u0645\xBB."
              },
              share: {
                term: "\u0627\u0644\u0623\u062A\u0639\u0627\u0628",
                text: "\u062D\u0635\u0629 \u0627\u0644\u0645\u0631\u062D\u0644\u0629 \u0645\u0646 \u0627\u0644\u0623\u062A\u0639\u0627\u0628 \u0628\u0627\u0644\u0646\u0633\u0628\u0629 \u0627\u0644\u0645\u0626\u0648\u064A\u0629. \u0644\u0627 \u064A\u0638\u0647\u0631 \u0647\u0630\u0627 \u0627\u0644\u0639\u0645\u0648\u062F \u0625\u0644\u0627 \u0644\u0645\u0646 \u064A\u062D\u0642 \u0644\u0647 \u0631\u0624\u064A\u0629 \u0627\u0644\u0623\u062A\u0639\u0627\u0628."
              },
              actions: {
                term: "\u0627\u0644\u0625\u062C\u0631\u0627\u0621\u0627\u062A",
                text: "\u062A\u062D\u0631\u064A\u0643 \u0645\u0631\u062D\u0644\u0629 \u0625\u0644\u0649 \u0627\u0644\u0623\u0639\u0644\u0649 \u0623\u0648 \u0627\u0644\u0623\u0633\u0641\u0644 \u0644\u062A\u063A\u064A\u064A\u0631 \u0627\u0644\u062A\u0631\u062A\u064A\u0628\u060C \u062B\u0645 \u062A\u0639\u062F\u064A\u0644 (\u0623\u0648 \u0639\u0631\u0636 \u0644\u0645\u0631\u062D\u0644\u0629 \u0645\u063A\u0644\u0642\u0629 \u0623\u0648 \u0625\u0646 \u0644\u0645 \u062A\u0643\u0646 \u0645\u0633\u0624\u0648\u0644\u064B\u0627) \u0648\u0625\u063A\u0644\u0627\u0642 \u0627\u0644\u0645\u0631\u062D\u0644\u0629. \u062A\u062D\u0645\u0644 \u0647\u0630\u0647 \u0627\u0644\u0623\u0632\u0631\u0627\u0631 \u0627\u0633\u0645 \u0627\u0644\u0645\u0631\u062D\u0644\u0629 \u0644\u0642\u0627\u0631\u0626\u0627\u062A \u0627\u0644\u0634\u0627\u0634\u0629."
              }
            }
          },
          statuses: {
            title: "\u0627\u0644\u062D\u0627\u0644\u0627\u062A \u0648\u0627\u0644\u0622\u062C\u0627\u0644",
            items: {
              notStarted: {
                term: "\u0644\u0645 \u062A\u0628\u062F\u0623",
                text: "\u0644\u0645 \u062A\u0628\u062F\u0623 \u0627\u0644\u0645\u0631\u062D\u0644\u0629."
              },
              inProgress: {
                term: "\u0642\u064A\u062F \u0627\u0644\u062A\u0646\u0641\u064A\u0630",
                text: "\u0627\u0644\u0645\u0631\u062D\u0644\u0629 \u062C\u0627\u0631\u064A\u0629."
              },
              inReview: {
                term: "\u0642\u064A\u062F \u0627\u0644\u0645\u0631\u0627\u062C\u0639\u0629",
                text: "\u0627\u0646\u062A\u0647\u0649 \u0627\u0644\u0639\u0645\u0644 \u0648\u0647\u0648 \u0642\u064A\u062F \u0627\u0644\u0645\u0631\u0627\u062C\u0639\u0629 \u0642\u0628\u0644 \u0627\u0644\u0625\u063A\u0644\u0627\u0642."
              },
              closed: {
                term: "\u0645\u063A\u0644\u0642\u0629",
                text: "\u0627\u0646\u062A\u0647\u062A \u0627\u0644\u0645\u0631\u062D\u0644\u0629 \u0648\u0644\u0645 \u064A\u0639\u062F \u062A\u0639\u062F\u064A\u0644\u0647\u0627 \u0645\u0645\u0643\u0646\u064B\u0627."
              },
              onTrack: {
                term: "\u0636\u0645\u0646 \u0627\u0644\u0622\u062C\u0627\u0644",
                text: "\u062A\u062D\u062A\u0631\u0645 \u0627\u0644\u0645\u0631\u062D\u0644\u0629 \u062A\u0648\u0627\u0631\u064A\u062E\u0647\u0627 \u0627\u0644\u0645\u0628\u0631\u0645\u062C\u0629. \u062A\u0639\u0646\u064A \xAB\u063A\u064A\u0631 \u0645\u0628\u0631\u0645\u062C\u0629\xBB \u0623\u0646\u0647 \u0644\u0627 \u062A\u0648\u062C\u062F \u0623\u064A \u062A\u0648\u0627\u0631\u064A\u062E \u0645\u0628\u0631\u0645\u062C\u0629."
              },
              lateStart: {
                term: "\u0628\u062F\u0627\u064A\u0629 \u0645\u062A\u0623\u062E\u0631\u0629 \u0628\u0640 \u20663\u2069 \u0623\u064A\u0627\u0645",
                text: "\u0645\u0631\u0651 \u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0628\u062F\u0627\u064A\u0629 \u0627\u0644\u0645\u0628\u0631\u0645\u062C \u0628\u064A\u0646\u0645\u0627 \u0644\u0645 \u062A\u0628\u062F\u0623 \u0627\u0644\u0645\u0631\u062D\u0644\u0629: \u064A\u064F\u0630\u0643\u0631 \u0639\u062F\u062F \u0623\u064A\u0627\u0645 \u0627\u0644\u062A\u0623\u062E\u064A\u0631."
              },
              overdue: {
                term: "\u0645\u062A\u0623\u062E\u0631\u0629 \u0628\u0640 \u20663\u2069 \u0623\u064A\u0627\u0645",
                text: "\u0645\u0631\u0651 \u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0646\u0647\u0627\u064A\u0629 \u0627\u0644\u0645\u0628\u0631\u0645\u062C \u0628\u064A\u0646\u0645\u0627 \u0644\u0645 \u062A\u0646\u062A\u0647\u0650 \u0627\u0644\u0645\u0631\u062D\u0644\u0629."
              },
              done: {
                term: "\u0623\u064F\u0646\u062C\u0632\u062A \u0636\u0645\u0646 \u0627\u0644\u0622\u062C\u0627\u0644",
                text: "\u0627\u0646\u062A\u0647\u062A \u0627\u0644\u0645\u0631\u062D\u0644\u0629 \u0641\u064A \u0627\u0644\u0648\u0642\u062A \u0627\u0644\u0645\u0646\u0627\u0633\u0628. \u0623\u0645\u0627 \xAB\u0623\u064F\u0646\u062C\u0632\u062A \u0628\u062A\u0623\u062E\u0631 \u20663\u2069 \u0623\u064A\u0627\u0645\xBB \u0641\u062A\u0642\u0648\u0644 \u0627\u0644\u0639\u0643\u0633."
              }
            }
          },
          panel: {
            title: "\u062A\u0641\u0627\u0635\u064A\u0644 \u0627\u0644\u0645\u0631\u062D\u0644\u0629",
            items: {
              name: {
                term: "\u0627\u0633\u0645 \u0627\u0644\u0645\u0631\u062D\u0644\u0629",
                text: "\u0627\u0644\u0645\u0631\u0627\u062D\u0644 \u0627\u0644\u0645\u062E\u0635\u0651\u0635\u0629 \u0648\u062D\u062F\u0647\u0627 \u0644\u0647\u0627 \u0627\u0633\u0645 \u064A\u064F\u062F\u062E\u064E\u0644 (120 \u062D\u0631\u0641\u064B\u0627 \u0639\u0644\u0649 \u0627\u0644\u0623\u0643\u062B\u0631)."
              },
              status: {
                term: "\u0627\u0644\u062D\u0627\u0644\u0629",
                text: "\u062A\u062A\u0628\u0639 \u0627\u0644\u0645\u0631\u062D\u0644\u0629 \u0627\u0644\u062A\u0631\u062A\u064A\u0628: \u0644\u0645 \u062A\u0628\u062F\u0623\u060C \u0642\u064A\u062F \u0627\u0644\u062A\u0646\u0641\u064A\u0630\u060C \u0642\u064A\u062F \u0627\u0644\u0645\u0631\u0627\u062C\u0639\u0629. \u0644\u0644\u0627\u0646\u062A\u0647\u0627\u0621 \u0645\u0646\u0647\u0627 \u0627\u0633\u062A\u0639\u0645\u0644 \xAB\u0625\u063A\u0644\u0627\u0642 \u0627\u0644\u0645\u0631\u062D\u0644\u0629\u2026\xBB."
              },
              dates: {
                term: "\u0627\u0644\u0628\u062F\u0627\u064A\u0629 \u0627\u0644\u0645\u062E\u0637\u0637\u0629\u060C \u0627\u0644\u0646\u0647\u0627\u064A\u0629 \u0627\u0644\u0645\u062E\u0637\u0637\u0629\u060C \u0627\u0644\u0628\u062F\u0627\u064A\u0629 \u0627\u0644\u0641\u0639\u0644\u064A\u0629\u060C \u0627\u0644\u0646\u0647\u0627\u064A\u0629 \u0627\u0644\u0641\u0639\u0644\u064A\u0629",
                text: "\u0623\u0631\u0628\u0639\u0629 \u062A\u0648\u0627\u0631\u064A\u062E. \u0644\u0627 \u064A\u0645\u0643\u0646 \u0623\u0646 \u062A\u0633\u0628\u0642 \u0627\u0644\u0646\u0647\u0627\u064A\u0629 \u0627\u0644\u0628\u062F\u0627\u064A\u0629 \u0627\u0644\u0645\u0642\u0627\u0628\u0644\u0629 \u0644\u0647\u0627."
              },
              share: {
                term: "\u062D\u0635\u0629 \u0627\u0644\u0623\u062A\u0639\u0627\u0628",
                text: "\u0646\u0633\u0628\u0629 \u0645\u0626\u0648\u064A\u0629 \u0645\u0646 \u0627\u0644\u0623\u062A\u0639\u0627\u0628\u060C \u0645\u062B\u0644 \u206612.5\u2069 (\u0628\u064A\u0646 \u20660\u2069 \u0648\u2066100\u2069\u060C \u0628\u062E\u0627\u0646\u062A\u064A\u0646 \u0639\u0634\u0631\u064A\u062A\u064A\u0646 \u0639\u0644\u0649 \u0627\u0644\u0623\u0643\u062B\u0631). \u062A\u0638\u0647\u0631 \u0641\u0642\u0637 \u0644\u0645\u0646 \u0644\u0647 \u062D\u0642 \u0631\u0624\u064A\u0629 \u0627\u0644\u0623\u062A\u0639\u0627\u0628."
              },
              save: {
                term: "\u062D\u0641\u0638",
                text: "\u064A\u062D\u0641\u0638 \u0627\u0644\u062A\u0639\u062F\u064A\u0644\u0627\u062A\u061B \u0648\u064A\u0643\u0648\u0646 \u0645\u0639\u0637\u0651\u0644\u064B\u0627 \u0645\u0627 \u062F\u0627\u0645 \u0644\u0645 \u064A\u062A\u063A\u064A\u0651\u0631 \u0634\u064A\u0621. \u0625\u0646 \u0639\u062F\u0651\u0644 \u0634\u062E\u0635 \u0622\u062E\u0631 \u0627\u0644\u0645\u0631\u062D\u0644\u0629 \u0641\u064A \u0627\u0644\u0623\u062B\u0646\u0627\u0621\u060C \u062A\u064F\u0639\u0627\u062F \u062A\u062D\u0645\u064A\u0644\u0647\u0627 \u0648\u062A\u0637\u0628\u0651\u0642 \u062A\u063A\u064A\u064A\u0631\u0643 \u0645\u0646 \u062C\u062F\u064A\u062F."
              },
              readOnly: {
                term: "\u0647\u0630\u0647 \u0627\u0644\u0645\u0631\u062D\u0644\u0629 \u0645\u063A\u0644\u0642\u0629",
                text: "\u0628\u0627\u0644\u0646\u0633\u0628\u0629 \u0644\u0645\u0631\u062D\u0644\u0629 \u0645\u063A\u0644\u0642\u0629 \u0623\u0648 \u0644\u0642\u0627\u0631\u0626 \u0641\u0642\u0637\u060C \u062A\u0639\u0631\u0636 \u0627\u0644\u0644\u0648\u062D\u0629 \u0627\u0644\u0645\u0639\u0644\u0648\u0645\u0627\u062A \u062F\u0648\u0646 \u062A\u0639\u062F\u064A\u0644: \u0627\u0644\u062D\u0627\u0644\u0629 \u0648\u0627\u0644\u062A\u0648\u0627\u0631\u064A\u062E \u0648\u0627\u0644\u0623\u062A\u0639\u0627\u0628 \u0648\u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0625\u063A\u0644\u0627\u0642 \u0648\u0627\u0633\u062A\u062B\u0646\u0627\u0621 \u0627\u0644\u0625\u063A\u0644\u0627\u0642."
              }
            }
          },
          addDialog: {
            title: "\u0625\u0636\u0627\u0641\u0629 \u0645\u0631\u062D\u0644\u0629",
            items: {
              type: {
                term: "\u0646\u0648\u0639 \u0627\u0644\u0645\u0631\u062D\u0644\u0629",
                text: "\u062D\u0642\u0644 \u0625\u0644\u0632\u0627\u0645\u064A. \u0644\u0627 \u064A\u0645\u0644\u0643 \u0627\u0644\u0645\u0634\u0631\u0648\u0639 \u0625\u0644\u0627 \u0645\u0631\u062D\u0644\u0629 \u0648\u0627\u062D\u062F\u0629 \u0645\u0646 \u0643\u0644 \u0646\u0648\u0639\u061B \u0627\u062E\u062A\u0631 \xAB\u0645\u0631\u062D\u0644\u0629 \u0645\u062E\u0635\u0651\u0635\u0629\xBB \u0644\u0625\u0636\u0627\u0641\u0629 \u0645\u0631\u062D\u0644\u0629 \u0623\u062E\u0631\u0649."
              },
              name: {
                term: "\u0627\u0633\u0645 \u0627\u0644\u0645\u0631\u062D\u0644\u0629",
                text: "\u0644\u0645\u0631\u062D\u0644\u0629 \u0645\u062E\u0635\u0651\u0635\u0629: \u0627\u0633\u0645 \u0627\u0644\u0645\u0631\u062D\u0644\u0629 \u0643\u0645\u0627 \u0633\u064A\u0638\u0647\u0631 \u0641\u064A \u0627\u0644\u0645\u0634\u0631\u0648\u0639."
              },
              planned: {
                term: "\u0627\u0644\u0628\u062F\u0627\u064A\u0629 \u0627\u0644\u0645\u062E\u0637\u0637\u0629\u060C \u0627\u0644\u0646\u0647\u0627\u064A\u0629 \u0627\u0644\u0645\u062E\u0637\u0637\u0629",
                text: "\u0627\u062E\u062A\u064A\u0627\u0631\u064A."
              },
              share: {
                term: "\u062D\u0635\u0629 \u0627\u0644\u0623\u062A\u0639\u0627\u0628",
                text: "\u0627\u062E\u062A\u064A\u0627\u0631\u064A\u060C \u0628\u0646\u0633\u0628\u0629 \u0645\u0626\u0648\u064A\u0629. \u062A\u0638\u0647\u0631 \u0641\u0642\u0637 \u0644\u0645\u0646 \u0644\u0647 \u062D\u0642 \u0631\u0624\u064A\u0629 \u0627\u0644\u0623\u062A\u0639\u0627\u0628."
              },
              after: {
                term: "\u0625\u062F\u0631\u0627\u062C\u0647\u0627 \u0628\u0639\u062F",
                text: "\u0627\u062E\u062A\u0631 \u0627\u0644\u0645\u0631\u062D\u0644\u0629 \u0627\u0644\u062A\u064A \u062A\u064F\u0648\u0636\u0639 \u0628\u0639\u062F\u0647\u0627 \u0627\u0644\u0645\u0631\u062D\u0644\u0629 \u0627\u0644\u062C\u062F\u064A\u062F\u0629\u060C \u0623\u0648 \xAB\u0641\u064A \u0646\u0647\u0627\u064A\u0629 \u0627\u0644\u0645\u0634\u0631\u0648\u0639\xBB."
              },
              submit: {
                term: "\u0625\u0636\u0627\u0641\u0629 \u0627\u0644\u0645\u0631\u062D\u0644\u0629",
                text: "\u064A\u0636\u064A\u0641 \u0627\u0644\u0645\u0631\u062D\u0644\u0629. \u064A\u063A\u0644\u0642 \xAB\u0625\u0644\u063A\u0627\u0621\xBB \u0627\u0644\u0646\u0627\u0641\u0630\u0629."
              }
            }
          },
          closeDialog: {
            title: "\u0625\u063A\u0644\u0627\u0642 \u0627\u0644\u0645\u0631\u062D\u0644\u0629",
            items: {
              rule: {
                term: "\u0625\u063A\u0644\u0627\u0642 \u0627\u0644\u0645\u0631\u062D\u0644\u0629 \u2026\u061F",
                text: "\u062A\u064F\u063A\u0644\u0642 \u0627\u0644\u0645\u0631\u062D\u0644\u0629 \u0639\u0646\u062F\u0645\u0627 \u062A\u0643\u0648\u0646 \u062C\u0645\u064A\u0639 \u0645\u062E\u0631\u062C\u0627\u062A\u0647\u0627 \u0645\u0639\u062A\u0645\u062F\u0629 \u0623\u0648 \u0645\u064F\u0631\u0633\u064E\u0644\u0629. \u0648\u0625\u0644\u0627 \u064A\u0645\u0643\u0646\u0643 \u0625\u063A\u0644\u0627\u0642\u0647\u0627 \u0628\u0627\u0633\u062A\u062B\u0646\u0627\u0621 \u0645\u0628\u0631\u064E\u0651\u0631 \u0643\u062A\u0627\u0628\u064A\u064B\u0627."
              },
              unfinished: {
                term: "\u0627\u0644\u0645\u062E\u0631\u062C\u0627\u062A \u0627\u0644\u0645\u0639\u0644\u0651\u0642\u0629",
                text: "\u0639\u062F\u062F \u0645\u062E\u0631\u062C\u0627\u062A \u0627\u0644\u0645\u0631\u062D\u0644\u0629 \u063A\u064A\u0631 \u0627\u0644\u0645\u0639\u062A\u0645\u062F\u0629 \u0648\u063A\u064A\u0631 \u0627\u0644\u0645\u064F\u0631\u0633\u064E\u0644\u0629. \u0625\u0646 \u0644\u0645 \u064A\u0648\u062C\u062F \u0623\u064A \u0645\u0646\u0647\u0627 \u064A\u0643\u0648\u0646 \u0627\u0644\u0625\u063A\u0644\u0627\u0642 \u0645\u0628\u0627\u0634\u0631\u064B\u0627."
              },
              waiver: {
                term: "\u0633\u0628\u0628 \u0627\u0644\u0627\u0633\u062A\u062B\u0646\u0627\u0621",
                text: "\u0646\u0635 \u0625\u0644\u0632\u0627\u0645\u064A\u060C \u0645\u0639 \u0639\u062F\u0651\u0627\u062F \u0644\u0644\u0623\u062D\u0631\u0641 (\u064A\u064F\u0637\u0644\u0628 \u062D\u062F \u0623\u062F\u0646\u0649). \u064A\u064F\u062D\u0641\u0638 \u0641\u064A \u0633\u062C\u0644 \u0627\u0644\u0645\u0634\u0631\u0648\u0639."
              },
              confirm: {
                term: "\u0625\u063A\u0644\u0627\u0642 \u0627\u0644\u0645\u0631\u062D\u0644\u0629",
                text: "\u064A\u0635\u0628\u062D \u0627\u0644\u0632\u0631 \xAB\u0627\u0644\u0625\u063A\u0644\u0627\u0642 \u0645\u0639 \u0627\u0633\u062A\u062B\u0646\u0627\u0621\xBB \u0639\u0646\u062F\u0645\u0627 \u064A\u0644\u0632\u0645 \u0627\u0633\u062A\u062B\u0646\u0627\u0621. \u0625\u0646 \u062A\u063A\u064A\u0651\u0631\u062A \u0627\u0644\u0645\u062E\u0631\u062C\u0627\u062A \u0648\u0627\u0644\u0646\u0627\u0641\u0630\u0629 \u0645\u0641\u062A\u0648\u062D\u0629\u060C \u062A\u0646\u0628\u0651\u0647\u0643 \u0631\u0633\u0627\u0644\u0629."
              }
            }
          }
        }
      },
      deliverables: {
        title: "\u0627\u0644\u0645\u062E\u0631\u062C\u0627\u062A",
        intro: "\u0627\u0644\u0648\u062B\u0627\u0626\u0642 \u0627\u0644\u062A\u064A \u064A\u062C\u0628 \u0639\u0644\u0649 \u0627\u0644\u0645\u0643\u062A\u0628 \u062A\u0633\u0644\u064A\u0645\u0647\u0627 \u0644\u0644\u062D\u0631\u064A\u0641\u060C \u0645\u0631\u062A\u0628\u0629 \u062D\u0633\u0628 \u0627\u0644\u0645\u0631\u062D\u0644\u0629\u060C \u0645\u0639 \u062A\u0642\u062F\u0651\u0645\u0647\u0627. \u064A\u0639\u062F\u0651\u0644\u0647\u0627 \u0645\u0633\u0624\u0648\u0644\u0648 \u0627\u0644\u0645\u0634\u0631\u0648\u0639 \u0648\u064A\u0637\u0651\u0644\u0639 \u0639\u0644\u064A\u0647\u0627 \u0627\u0644\u0622\u062E\u0631\u0648\u0646.",
        sections: {
          summary: {
            title: "\u0645\u0644\u062E\u0635 \u0627\u0644\u0645\u0634\u0631\u0648\u0639",
            items: {
              breadcrumb: {
                term: "\u0627\u0644\u0645\u0634\u0627\u0631\u064A\u0639",
                text: "\u0645\u0633\u0627\u0631 \u0627\u0644\u062A\u0646\u0642\u0644 \u0641\u064A \u0623\u0639\u0644\u0649 \u0627\u0644\u0635\u0641\u062D\u0629. \u0627\u0646\u0642\u0631 \u0639\u0644\u0649 \xAB\u0627\u0644\u0645\u0634\u0627\u0631\u064A\u0639\xBB \u0644\u0644\u0639\u0648\u062F\u0629 \u0625\u0644\u0649 \u0627\u0644\u0642\u0627\u0626\u0645\u0629\u061B \u0648\u0628\u062C\u0627\u0646\u0628\u0647 \u062A\u0631\u0649 \u0627\u0633\u0645 \u0627\u0644\u0645\u0634\u0631\u0648\u0639 \u0627\u0644\u0645\u0641\u062A\u0648\u062D."
              },
              meeting: {
                term: "\u0628\u062F\u0621 \u0627\u062C\u062A\u0645\u0627\u0639",
                text: "\u0632\u0631 \u0641\u064A \u0623\u0639\u0644\u0649 \u0627\u0644\u0635\u0641\u062D\u0629 \u0644\u0623\u0639\u0636\u0627\u0621 \u0627\u0644\u0645\u0634\u0631\u0648\u0639 \u0627\u0644\u0642\u0627\u062F\u0631\u064A\u0646 \u0639\u0644\u0649 \u0627\u0644\u0645\u0633\u0627\u0647\u0645\u0629. \u064A\u0637\u0644\u0628 \u0639\u0646\u0648\u0627\u0646 \u0627\u0644\u0627\u062C\u062A\u0645\u0627\u0639 \u062B\u0645 \u064A\u0641\u062A\u062D \u0642\u0627\u0639\u0629 \u0627\u0644\u0627\u062C\u062A\u0645\u0627\u0639."
              },
              code: {
                term: "\u0627\u0644\u0631\u0645\u0632",
                text: "\u0631\u0645\u0632 \u0627\u0644\u0645\u0634\u0631\u0648\u0639\u060C \u064A\u064F\u0633\u062A\u0639\u0645\u0644 \u0641\u064A \u0648\u062B\u0627\u0626\u0642\u0647 \u0648\u0641\u0648\u0627\u062A\u064A\u0631\u0647."
              },
              client: {
                term: "\u0627\u0644\u062D\u0631\u064A\u0641",
                text: "\u062D\u0631\u064A\u0641 \u0627\u0644\u0645\u0634\u0631\u0648\u0639 (\u0635\u0627\u062D\u0628 \u0627\u0644\u0645\u0634\u0631\u0648\u0639)\u060C \u0623\u0648 \xAB\u0628\u062F\u0648\u0646 \u062D\u0631\u064A\u0641\xBB \u0625\u0646 \u0644\u0645 \u064A\u064F\u062F\u062E\u064E\u0644 \u0628\u0639\u062F."
              },
              status: {
                term: "\u0627\u0644\u062D\u0627\u0644\u0629",
                text: "\u0634\u0627\u0631\u0629 \u062A\u0628\u064A\u0651\u0646 \u062D\u0627\u0644\u0629 \u0627\u0644\u0645\u0634\u0631\u0648\u0639: \u0645\u0633\u0648\u062F\u0629 \u0623\u0648 \u062C\u0627\u0631\u064D \u0623\u0648 \u0645\u062A\u0648\u0642\u0641 \u0645\u0624\u0642\u062A\u064B\u0627 \u0623\u0648 \u0645\u063A\u0644\u0642 \u0623\u0648 \u0645\u0624\u0631\u0634\u0641."
              },
              progress: {
                term: "\u0627\u0644\u0645\u0631\u0627\u062D\u0644 \u0627\u0644\u0645\u063A\u0644\u0642\u0629: \u20662 / 7\u2069",
                text: "\u0634\u0631\u064A\u0637 \u062A\u0642\u062F\u0651\u0645 \u0648\u0639\u062F\u062F \u0627\u0644\u0645\u0631\u0627\u062D\u0644 \u0627\u0644\u0645\u063A\u0644\u0642\u0629\u060C \u0645\u0639 \u0627\u0644\u0645\u0631\u062D\u0644\u0629 \u0627\u0644\u062D\u0627\u0644\u064A\u0629."
              },
              tabs: {
                term: "\u0627\u0644\u0645\u0646\u0634\u0648\u0631\u0627\u062A\u060C \u0627\u0644\u0645\u0644\u0641\u0627\u062A\u060C \u0627\u0644\u0645\u0647\u0627\u0645\u060C \u0627\u0644\u0645\u0631\u0627\u062D\u0644\u060C \u0627\u0644\u0645\u062E\u0631\u062C\u0627\u062A\u060C \u0627\u0644\u062A\u0623\u0634\u064A\u0631\u0627\u062A\u060C \u0627\u0644\u0631\u0632\u0646\u0627\u0645\u0629\u060C \u0627\u0644\u0645\u0627\u0644\u064A\u0629\u060C \u0627\u0644\u0625\u0639\u062F\u0627\u062F\u0627\u062A",
                text: "\u062A\u0628\u0648\u064A\u0628\u0627\u062A \u0627\u0644\u0645\u0634\u0631\u0648\u0639. \u0623\u0646\u062A \u0627\u0644\u0622\u0646 \u0641\u064A \xAB\u0627\u0644\u0645\u062E\u0631\u062C\u0627\u062A\xBB."
              }
            }
          },
          overview: {
            title: "\u0627\u0644\u0645\u062E\u0631\u062C\u0627\u062A",
            items: {
              add: {
                term: "\u0625\u0636\u0627\u0641\u0629 \u0645\u062E\u0631\u062C",
                text: "\u0632\u0631 \u0645\u062E\u0635\u0635 \u0644\u0645\u0633\u0624\u0648\u0644\u064A \u0627\u0644\u0645\u0634\u0631\u0648\u0639\u060C \u064A\u064F\u0639\u0631\u0636 \u0645\u0627 \u062F\u0627\u0645\u062A \u0647\u0646\u0627\u0643 \u0645\u0631\u062D\u0644\u0629 \u0645\u0641\u062A\u0648\u062D\u0629."
              },
              readOnly: {
                term: "\u064A\u0645\u0643\u0646 \u0644\u0645\u0633\u0624\u0648\u0644\u064A \u0627\u0644\u0645\u0634\u0631\u0648\u0639 \u0648\u062D\u062F\u0647\u0645 \u062A\u0639\u062F\u064A\u0644 \u0627\u0644\u0645\u062E\u0631\u062C\u0627\u062A.",
                text: "\u0631\u0633\u0627\u0644\u0629 \u0632\u0631\u0642\u0627\u0621 \u062A\u0638\u0647\u0631 \u0644\u0644\u0623\u0639\u0636\u0627\u0621 \u0627\u0644\u0622\u062E\u0631\u064A\u0646\u060C \u0648\u0647\u0645 \u064A\u0637\u0651\u0644\u0639\u0648\u0646 \u0641\u0642\u0637."
              },
              phaseBlock: {
                term: "\u062E\u0627\u0646\u0629 \u0644\u0643\u0644 \u0645\u0631\u062D\u0644\u0629",
                text: "\u0644\u0643\u0644 \u0645\u0631\u062D\u0644\u0629 \u0639\u0646\u0648\u0627\u0646\u0647\u0627 \u0648\u0634\u0627\u0631\u0629 \u062D\u0627\u0644\u062A\u0647\u0627 \u0648\u062C\u062F\u0648\u0644\u0647\u0627. \u0648\u062A\u062D\u062A\u0647\u0627 \xAB\u20663\u2069 \u0645\u0646 \u20665\u2069 \u0645\u0639\u062A\u0645\u062F \u0623\u0648 \u0645\u064F\u0631\u0633\u064E\u0644\xBB \u064A\u0628\u064A\u0651\u0646 \u0627\u0644\u062A\u0642\u062F\u0651\u0645."
              },
              closePhase: {
                term: "\u0625\u063A\u0644\u0627\u0642 \u0627\u0644\u0645\u0631\u062D\u0644\u0629",
                text: "\u0632\u0631 \u0627\u0644\u0645\u0633\u0624\u0648\u0644\u064A\u0646 \u0639\u0644\u0649 \u0645\u0631\u062D\u0644\u0629 \u0645\u0627 \u0632\u0627\u0644\u062A \u0645\u0641\u062A\u0648\u062D\u0629. \u064A\u0641\u062A\u062D \u0646\u0627\u0641\u0630\u0629 \u0627\u0644\u0625\u063A\u0644\u0627\u0642 (\u0627\u0646\u0638\u0631 \u062A\u0628\u0648\u064A\u0628 \u0627\u0644\u0645\u0631\u0627\u062D\u0644)."
              },
              closed: {
                term: "\u062A\u0627\u0631\u064A\u062E \u0625\u063A\u0644\u0627\u0642 \u0627\u0644\u0645\u0631\u062D\u0644\u0629:",
                text: "\u0644\u0645\u0631\u062D\u0644\u0629 \u0645\u063A\u0644\u0642\u0629: \u0627\u0644\u062A\u0627\u0631\u064A\u062E\u060C \u0648\u0627\u0644\u0627\u0633\u062A\u062B\u0646\u0627\u0621 \u0625\u0646 \u0623\u064F\u063A\u0644\u0642\u062A \u062F\u0648\u0646 \u0623\u0646 \u064A\u064F\u0639\u062A\u0645\u062F \u0643\u0644 \u0634\u064A\u0621."
              },
              phaseEmpty: {
                term: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0645\u062E\u0631\u062C\u0627\u062A \u0641\u064A \u0647\u0630\u0647 \u0627\u0644\u0645\u0631\u062D\u0644\u0629.",
                text: "\u062A\u0638\u0647\u0631 \u0639\u0646\u062F\u0645\u0627 \u0644\u0627 \u064A\u0643\u0648\u0646 \u0641\u064A \u0627\u0644\u0645\u0631\u062D\u0644\u0629 \u0623\u064A \u0645\u062E\u0631\u062C \u0628\u0639\u062F."
              },
              empty: {
                term: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0645\u0631\u0627\u062D\u0644 \u0641\u064A \u0647\u0630\u0627 \u0627\u0644\u0645\u0634\u0631\u0648\u0639 \u0628\u0639\u062F",
                text: "\u062A\u064F\u0631\u062A\u064E\u0651\u0628 \u0627\u0644\u0645\u062E\u0631\u062C\u0627\u062A \u062D\u0633\u0628 \u0627\u0644\u0645\u0631\u062D\u0644\u0629: \u0633\u062A\u0638\u0647\u0631 \u0628\u0645\u062C\u0631\u062F \u0625\u0636\u0627\u0641\u0629 \u0645\u0631\u0627\u062D\u0644 \u0627\u0644\u0645\u0634\u0631\u0648\u0639."
              }
            }
          },
          table: {
            title: "\u062C\u062F\u0648\u0644 \u0645\u062E\u0631\u062C\u0627\u062A \u0645\u0631\u062D\u0644\u0629",
            items: {
              title: {
                term: "\u0627\u0644\u0645\u062E\u0631\u062C",
                text: "\u0639\u0646\u0648\u0627\u0646 \u0627\u0644\u0645\u062E\u0631\u062C."
              },
              type: {
                term: "\u0627\u0644\u0646\u0648\u0639",
                text: "\u0646\u0648\u0639 \u0627\u0644\u0648\u062B\u064A\u0642\u0629 \u0627\u0644\u0645\u0646\u062A\u0638\u0631\u0629 (\u0645\u062E\u0637\u0637\u060C \u0645\u0630\u0643\u0631\u0629 \u062D\u0633\u0627\u0628\u0627\u062A\u060C \u062A\u0642\u0631\u064A\u0631\u2026)."
              },
              discipline: {
                term: "\u0627\u0644\u0627\u062E\u062A\u0635\u0627\u0635",
                text: "\u0627\u0644\u0627\u062E\u062A\u0635\u0627\u0635 \u0627\u0644\u0645\u0639\u0646\u064A (\u0627\u0644\u0639\u0645\u0627\u0631\u0629\u060C \u0627\u0644\u0647\u064A\u0627\u0643\u0644\u060C \u0627\u0644\u0637\u0631\u0642 \u0648\u0627\u0644\u0634\u0628\u0643\u0627\u062A \u0627\u0644\u0645\u062E\u062A\u0644\u0641\u0629\u2026)\u060C \u0623\u0648 \u0634\u0631\u0637\u0629."
              },
              status: {
                term: "\u0627\u0644\u062D\u0627\u0644\u0629",
                text: "\u062D\u0627\u0644\u0629 \u0627\u0644\u0645\u062E\u0631\u062C: \u0644\u0644\u0625\u0646\u062C\u0627\u0632 \u0623\u0648 \u0642\u064A\u062F \u0627\u0644\u0625\u0646\u062C\u0627\u0632 \u0623\u0648 \u0642\u064A\u062F \u0627\u0644\u0645\u0631\u0627\u062C\u0639\u0629 \u0623\u0648 \u0645\u0639\u062A\u0645\u062F \u0623\u0648 \u0645\u064F\u0631\u0633\u064E\u0644."
              },
              due: {
                term: "\u0627\u0644\u0623\u062C\u0644",
                text: "\u062A\u0627\u0631\u064A\u062E \u0627\u0644\u062A\u0633\u0644\u064A\u0645 \u0627\u0644\u0645\u0628\u0631\u0645\u062C\u060C \u0623\u0648 \u0634\u0631\u0637\u0629."
              },
              actions: {
                term: "\u0627\u0644\u0625\u062C\u0631\u0627\u0621\u0627\u062A",
                text: "\u0639\u0645\u0648\u062F \u0627\u0644\u0645\u0633\u0624\u0648\u0644\u064A\u0646: \u064A\u0641\u062A\u062D \u0642\u0644\u0645 \xAB\u062A\u0639\u062F\u064A\u0644 \u0627\u0644\u0645\u062E\u0631\u062C\xBB \u0646\u0627\u0641\u0630\u0629 \u0627\u0644\u062A\u0639\u062F\u064A\u0644. \u0648\u0644\u0627 \u064A\u064F\u0639\u0631\u0636 \u0644\u0644\u0645\u0631\u0627\u062D\u0644 \u0627\u0644\u0645\u063A\u0644\u0642\u0629."
              }
            }
          },
          types: {
            title: "\u0623\u0646\u0648\u0627\u0639 \u0627\u0644\u0645\u062E\u0631\u062C\u0627\u062A",
            items: {
              drawing: {
                term: "\u0645\u062E\u0637\u0637",
                text: "\u0645\u062E\u0637\u0637 \u0623\u0648 \u0631\u0633\u0645."
              },
              calculationNote: {
                term: "\u0645\u0630\u0643\u0631\u0629 \u062D\u0633\u0627\u0628\u0627\u062A",
                text: "\u0627\u0644\u0648\u062B\u064A\u0642\u0629 \u0627\u0644\u062A\u064A \u062A\u0628\u0631\u0651\u0631 \u062D\u0633\u0627\u0628\u0627\u062A \u0627\u0644\u0623\u0628\u0639\u0627\u062F."
              },
              report: {
                term: "\u062A\u0642\u0631\u064A\u0631",
                text: "\u062A\u0642\u0631\u064A\u0631 \u062F\u0631\u0627\u0633\u0629 \u0623\u0648 \u0632\u064A\u0627\u0631\u0629."
              },
              specification: {
                term: "\u0643\u0631\u0627\u0633 \u0634\u0631\u0648\u0637",
                text: "\u0627\u0644\u0648\u062B\u064A\u0642\u0629 \u0627\u0644\u062A\u064A \u062A\u0635\u0641 \u0645\u0627 \u064A\u062C\u0628 \u0625\u0646\u062C\u0627\u0632\u0647 \u0648\u0643\u064A\u0641\u064A\u062A\u0647."
              },
              billOfQuantities: {
                term: "\u062C\u062F\u0648\u0644 \u0627\u0644\u0643\u0645\u064A\u0627\u062A",
                text: "\u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u0623\u0634\u063A\u0627\u0644 \u0645\u0639 \u0643\u0645\u064A\u0627\u062A\u0647\u0627."
              },
              estimate: {
                term: "\u062A\u0642\u062F\u064A\u0631 \u0627\u0644\u0643\u0644\u0641\u0629",
                text: "\u062A\u0642\u062F\u064A\u0631 \u0643\u0644\u0641\u0629 \u0627\u0644\u0623\u0634\u063A\u0627\u0644."
              },
              other: {
                term: "\u0623\u062E\u0631\u0649",
                text: "\u0623\u064A \u0645\u062E\u0631\u062C \u0644\u0627 \u064A\u0646\u062A\u0645\u064A \u0625\u0644\u0649 \u0627\u0644\u0623\u0646\u0648\u0627\u0639 \u0627\u0644\u0633\u0627\u0628\u0642\u0629."
              }
            }
          },
          statuses: {
            title: "\u062D\u0627\u0644\u0627\u062A \u0627\u0644\u0645\u062E\u0631\u062C",
            items: {
              toProduce: {
                term: "\u0644\u0644\u0625\u0646\u062C\u0627\u0632",
                text: "\u0644\u0645 \u064A\u0628\u062F\u0623 \u0627\u0644\u0645\u062E\u0631\u062C."
              },
              inProgress: {
                term: "\u0642\u064A\u062F \u0627\u0644\u0625\u0646\u062C\u0627\u0632",
                text: "\u0627\u0644\u0645\u062E\u0631\u062C \u0642\u064A\u062F \u0627\u0644\u0625\u0646\u062C\u0627\u0632."
              },
              inReview: {
                term: "\u0642\u064A\u062F \u0627\u0644\u0645\u0631\u0627\u062C\u0639\u0629",
                text: "\u0627\u0644\u0645\u062E\u0631\u062C \u0642\u064A\u062F \u0627\u0644\u0645\u0631\u0627\u062C\u0639\u0629."
              },
              approved: {
                term: "\u0645\u0639\u062A\u0645\u062F",
                text: "\u0627\u0644\u0645\u062E\u0631\u062C \u0645\u0635\u0627\u062F\u0642 \u0639\u0644\u064A\u0647. \u064A\u064F\u062D\u062A\u0633\u0628 \u0644\u0644\u062A\u0645\u0643\u0651\u0646 \u0645\u0646 \u0625\u063A\u0644\u0627\u0642 \u0627\u0644\u0645\u0631\u062D\u0644\u0629."
              },
              transmitted: {
                term: "\u0645\u064F\u0631\u0633\u064E\u0644",
                text: "\u0633\u064F\u0644\u0651\u0645 \u0627\u0644\u0645\u062E\u0631\u062C \u0644\u0644\u062D\u0631\u064A\u0641. \u064A\u064F\u062D\u062A\u0633\u0628 \u0647\u0648 \u0623\u064A\u0636\u064B\u0627 \u0644\u0625\u063A\u0644\u0627\u0642 \u0627\u0644\u0645\u0631\u062D\u0644\u0629."
              }
            }
          },
          dialog: {
            title: "\u0625\u0636\u0627\u0641\u0629 \u0645\u062E\u0631\u062C \u0623\u0648 \u062A\u0639\u062F\u064A\u0644\u0647",
            items: {
              title: {
                term: "\u0639\u0646\u0648\u0627\u0646 \u0627\u0644\u0645\u062E\u0631\u062C",
                text: "\u062D\u0642\u0644 \u0625\u0644\u0632\u0627\u0645\u064A\u060C 200 \u062D\u0631\u0641 \u0639\u0644\u0649 \u0627\u0644\u0623\u0643\u062B\u0631."
              },
              phase: {
                term: "\u0627\u0644\u0645\u0631\u062D\u0644\u0629",
                text: "\u062D\u0642\u0644 \u0625\u0644\u0632\u0627\u0645\u064A: \u0627\u062E\u062A\u0631 \u0645\u0631\u062D\u0644\u0629 \u0645\u0627 \u0632\u0627\u0644\u062A \u0645\u0641\u062A\u0648\u062D\u0629 \u0645\u0646 \u0627\u0644\u0645\u0634\u0631\u0648\u0639."
              },
              type: {
                term: "\u0627\u0644\u0646\u0648\u0639",
                text: "\u0645\u062E\u0637\u0637 \u0623\u0648 \u0645\u0630\u0643\u0631\u0629 \u062D\u0633\u0627\u0628\u0627\u062A \u0623\u0648 \u062A\u0642\u0631\u064A\u0631 \u0623\u0648 \u0643\u0631\u0627\u0633 \u0634\u0631\u0648\u0637 \u0623\u0648 \u062C\u062F\u0648\u0644 \u0627\u0644\u0643\u0645\u064A\u0627\u062A \u0623\u0648 \u062A\u0642\u062F\u064A\u0631 \u0627\u0644\u0643\u0644\u0641\u0629 \u0623\u0648 \u0623\u062E\u0631\u0649."
              },
              discipline: {
                term: "\u0627\u0644\u0627\u062E\u062A\u0635\u0627\u0635",
                text: "\u0627\u062E\u062A\u064A\u0627\u0631\u064A: \u0627\u0644\u0639\u0645\u0627\u0631\u0629 \u0623\u0648 \u0627\u0644\u0647\u064A\u0627\u0643\u0644 \u0623\u0648 \u0627\u0644\u0637\u0631\u0642 \u0648\u0627\u0644\u0634\u0628\u0643\u0627\u062A \u0627\u0644\u0645\u062E\u062A\u0644\u0641\u0629 \u0623\u0648 \u0627\u0644\u0645\u0648\u0627\u0626\u0639 \u0623\u0648 \u0627\u0644\u0643\u0647\u0631\u0628\u0627\u0621 \u0623\u0648 \u0627\u0644\u0637\u0648\u0628\u0648\u063A\u0631\u0627\u0641\u064A\u0627 \u0623\u0648 \u0627\u0644\u062C\u064A\u0648\u062A\u0642\u0646\u064A\u0629 \u0623\u0648 \u0627\u0644\u062A\u0646\u0633\u064A\u0642 \u0648\u0627\u0644\u0645\u062A\u0627\u0628\u0639\u0629. \xAB\u0628\u062F\u0648\u0646 \u0627\u062E\u062A\u0635\u0627\u0635\xBB \u0627\u0641\u062A\u0631\u0627\u0636\u064A\u064B\u0627."
              },
              due: {
                term: "\u0627\u0644\u0623\u062C\u0644",
                text: "\u0627\u062E\u062A\u064A\u0627\u0631\u064A: \u062A\u0627\u0631\u064A\u062E \u0627\u0644\u062A\u0633\u0644\u064A\u0645."
              },
              status: {
                term: "\u0627\u0644\u062D\u0627\u0644\u0629",
                text: "\u062A\u064F\u0639\u0631\u0636 \u0641\u0642\u0637 \u0639\u0646\u062F \u062A\u0639\u062F\u064A\u0644 \u0645\u062E\u0631\u062C \u0645\u0648\u062C\u0648\u062F."
              },
              save: {
                term: "\u062D\u0641\u0638",
                text: "\u064A\u062D\u0641\u0638 \u0627\u0644\u0645\u062E\u0631\u062C. \u0625\u0646 \u0639\u062F\u0651\u0644\u0647 \u0634\u062E\u0635 \u0622\u062E\u0631 \u0641\u064A \u0627\u0644\u0623\u062B\u0646\u0627\u0621 \u064A\u064F\u0639\u0627\u062F \u062A\u062D\u0645\u064A\u0644\u0647 \u0648\u062A\u0637\u0628\u0651\u0642 \u062A\u063A\u064A\u064A\u0631\u0643 \u0645\u0646 \u062C\u062F\u064A\u062F. \u064A\u063A\u0644\u0642 \xAB\u0625\u0644\u063A\u0627\u0621\xBB \u0627\u0644\u0646\u0627\u0641\u0630\u0629."
              }
            }
          }
        }
      },
      approvals: {
        title: "\u0627\u0644\u062A\u0623\u0634\u064A\u0631\u0627\u062A",
        intro: "\u0645\u062A\u0627\u0628\u0639\u0629 \u0645\u0633\u0627\u0631\u0627\u062A \u0627\u0644\u062A\u0623\u0634\u064A\u0631 \u0641\u064A \u0627\u0644\u0645\u0634\u0631\u0648\u0639: \u0627\u0644\u0648\u062B\u0627\u0626\u0642 \u0627\u0644\u0645\u0631\u0633\u0644\u0629 \u0625\u0644\u0649 \u0627\u0644\u0645\u0631\u0627\u062C\u0639\u064A\u0646 \u0644\u0644\u0645\u0635\u0627\u062F\u0642\u0629\u060C \u0648\u0648\u0636\u0639 \u0643\u0644 \u0645\u0646\u0647\u0627\u060C \u0648\u062A\u0644\u0643 \u0627\u0644\u062A\u064A \u062A\u0646\u062A\u0638\u0631 \u0631\u0623\u064A\u0643.",
        sections: {
          summary: {
            title: "\u0645\u0644\u062E\u0635 \u0627\u0644\u0645\u0634\u0631\u0648\u0639",
            items: {
              breadcrumb: {
                term: "\u0627\u0644\u0645\u0634\u0627\u0631\u064A\u0639",
                text: "\u0645\u0633\u0627\u0631 \u0627\u0644\u062A\u0646\u0642\u0644 \u0641\u064A \u0623\u0639\u0644\u0649 \u0627\u0644\u0635\u0641\u062D\u0629. \u0627\u0646\u0642\u0631 \u0639\u0644\u0649 \xAB\u0627\u0644\u0645\u0634\u0627\u0631\u064A\u0639\xBB \u0644\u0644\u0639\u0648\u062F\u0629 \u0625\u0644\u0649 \u0627\u0644\u0642\u0627\u0626\u0645\u0629\u061B \u0648\u0628\u062C\u0627\u0646\u0628\u0647 \u062A\u0631\u0649 \u0627\u0633\u0645 \u0627\u0644\u0645\u0634\u0631\u0648\u0639 \u0627\u0644\u0645\u0641\u062A\u0648\u062D."
              },
              meeting: {
                term: "\u0628\u062F\u0621 \u0627\u062C\u062A\u0645\u0627\u0639",
                text: "\u0632\u0631 \u0641\u064A \u0623\u0639\u0644\u0649 \u0627\u0644\u0635\u0641\u062D\u0629 \u0644\u0623\u0639\u0636\u0627\u0621 \u0627\u0644\u0645\u0634\u0631\u0648\u0639 \u0627\u0644\u0642\u0627\u062F\u0631\u064A\u0646 \u0639\u0644\u0649 \u0627\u0644\u0645\u0633\u0627\u0647\u0645\u0629. \u064A\u0637\u0644\u0628 \u0639\u0646\u0648\u0627\u0646 \u0627\u0644\u0627\u062C\u062A\u0645\u0627\u0639 \u062B\u0645 \u064A\u0641\u062A\u062D \u0642\u0627\u0639\u0629 \u0627\u0644\u0627\u062C\u062A\u0645\u0627\u0639."
              },
              code: {
                term: "\u0627\u0644\u0631\u0645\u0632",
                text: "\u0631\u0645\u0632 \u0627\u0644\u0645\u0634\u0631\u0648\u0639\u060C \u064A\u064F\u0633\u062A\u0639\u0645\u0644 \u0641\u064A \u0648\u062B\u0627\u0626\u0642\u0647 \u0648\u0641\u0648\u0627\u062A\u064A\u0631\u0647."
              },
              client: {
                term: "\u0627\u0644\u062D\u0631\u064A\u0641",
                text: "\u062D\u0631\u064A\u0641 \u0627\u0644\u0645\u0634\u0631\u0648\u0639 (\u0635\u0627\u062D\u0628 \u0627\u0644\u0645\u0634\u0631\u0648\u0639)\u060C \u0623\u0648 \xAB\u0628\u062F\u0648\u0646 \u062D\u0631\u064A\u0641\xBB \u0625\u0646 \u0644\u0645 \u064A\u064F\u062F\u062E\u064E\u0644 \u0628\u0639\u062F."
              },
              status: {
                term: "\u0627\u0644\u062D\u0627\u0644\u0629",
                text: "\u0634\u0627\u0631\u0629 \u062A\u0628\u064A\u0651\u0646 \u062D\u0627\u0644\u0629 \u0627\u0644\u0645\u0634\u0631\u0648\u0639: \u0645\u0633\u0648\u062F\u0629 \u0623\u0648 \u062C\u0627\u0631\u064D \u0623\u0648 \u0645\u062A\u0648\u0642\u0641 \u0645\u0624\u0642\u062A\u064B\u0627 \u0623\u0648 \u0645\u063A\u0644\u0642 \u0623\u0648 \u0645\u0624\u0631\u0634\u0641."
              },
              progress: {
                term: "\u0627\u0644\u0645\u0631\u0627\u062D\u0644 \u0627\u0644\u0645\u063A\u0644\u0642\u0629: \u20662 / 7\u2069",
                text: "\u0634\u0631\u064A\u0637 \u062A\u0642\u062F\u0651\u0645 \u0648\u0639\u062F\u062F \u0627\u0644\u0645\u0631\u0627\u062D\u0644 \u0627\u0644\u0645\u063A\u0644\u0642\u0629\u060C \u0645\u0639 \u0627\u0644\u0645\u0631\u062D\u0644\u0629 \u0627\u0644\u062D\u0627\u0644\u064A\u0629."
              },
              tabs: {
                term: "\u0627\u0644\u0645\u0646\u0634\u0648\u0631\u0627\u062A\u060C \u0627\u0644\u0645\u0644\u0641\u0627\u062A\u060C \u0627\u0644\u0645\u0647\u0627\u0645\u060C \u0627\u0644\u0645\u0631\u0627\u062D\u0644\u060C \u0627\u0644\u0645\u062E\u0631\u062C\u0627\u062A\u060C \u0627\u0644\u062A\u0623\u0634\u064A\u0631\u0627\u062A\u060C \u0627\u0644\u0631\u0632\u0646\u0627\u0645\u0629\u060C \u0627\u0644\u0645\u0627\u0644\u064A\u0629\u060C \u0627\u0644\u0625\u0639\u062F\u0627\u062F\u0627\u062A",
                text: "\u062A\u0628\u0648\u064A\u0628\u0627\u062A \u0627\u0644\u0645\u0634\u0631\u0648\u0639. \u0623\u0646\u062A \u0627\u0644\u0622\u0646 \u0641\u064A \xAB\u0627\u0644\u062A\u0623\u0634\u064A\u0631\u0627\u062A\xBB."
              },
              noSpace: {
                term: "\u0645\u0633\u0627\u0631\u0627\u062A \u0627\u0644\u062A\u0623\u0634\u064A\u0631 \u063A\u064A\u0631 \u0645\u062A\u0627\u062D\u0629 \u0628\u0639\u062F",
                text: "\u062A\u0638\u0647\u0631 \u0625\u0630\u0627 \u0644\u0645 \u062A\u0643\u0646 \u0645\u0633\u0627\u062D\u0629 \u0645\u0644\u0641\u0627\u062A \u0627\u0644\u0645\u0634\u0631\u0648\u0639 \u062C\u0627\u0647\u0632\u0629 \u0628\u0639\u062F."
              }
            }
          },
          filters: {
            title: "\u062A\u0635\u0641\u064A\u0629 \u0645\u0633\u0627\u0631\u0627\u062A \u0627\u0644\u062A\u0623\u0634\u064A\u0631",
            items: {
              all: {
                term: "\u0627\u0644\u0643\u0644",
                text: "\u0643\u0644 \u0645\u0633\u0627\u0631\u0627\u062A \u0627\u0644\u0645\u0634\u0631\u0648\u0639."
              },
              inProgress: {
                term: "\u0642\u064A\u062F \u0627\u0644\u062A\u0623\u0634\u064A\u0631",
                text: "\u0627\u0644\u0645\u0633\u0627\u0631\u0627\u062A \u0627\u0644\u062A\u064A \u0645\u0627 \u0632\u0627\u0644\u062A \u0645\u0641\u062A\u0648\u062D\u0629\u060C \u062D\u064A\u062B \u064A\u062C\u0628 \u0639\u0644\u0649 \u0627\u0644\u0645\u0631\u0627\u062C\u0639\u064A\u0646 \u0625\u0628\u062F\u0627\u0621 \u0631\u0623\u064A\u0647\u0645."
              },
              approved: {
                term: "\u0645\u0624\u0634\u064E\u0651\u0631 \u0639\u0644\u064A\u0647\u0627",
                text: "\u0627\u0644\u0645\u0633\u0627\u0631\u0627\u062A \u0627\u0644\u062A\u064A \u0627\u0646\u062A\u0647\u062A \u0628\u0631\u0623\u064A \u0645\u0648\u0627\u0641\u0642 \u062F\u0648\u0646 \u062A\u062D\u0641\u0638 (\u2066VSO\u2069)."
              },
              approvedWithComments: {
                term: "\u0645\u0624\u0634\u064E\u0651\u0631 \u0639\u0644\u064A\u0647\u0627 \u0645\u0639 \u0645\u0644\u0627\u062D\u0638\u0627\u062A",
                text: "\u0627\u0644\u0645\u0633\u0627\u0631\u0627\u062A \u0627\u0644\u062A\u064A \u0627\u0646\u062A\u0647\u062A \u0628\u0631\u0623\u064A \u0645\u0648\u0627\u0641\u0642 \u0645\u0639 \u0645\u0644\u0627\u062D\u0638\u0627\u062A (\u2066VAO\u2069)."
              },
              rejected: {
                term: "\u0645\u0631\u0641\u0648\u0636\u0629",
                text: "\u0627\u0644\u0645\u0633\u0627\u0631\u0627\u062A \u0627\u0644\u062A\u064A \u0623\u0648\u0642\u0641\u0647\u0627 \u0631\u0641\u0636 (\u2066REF\u2069): \u064A\u062C\u0628 \u062A\u0635\u062D\u064A\u062D \u0627\u0644\u0648\u062B\u064A\u0642\u0629."
              },
              cancelled: {
                term: "\u0645\u0644\u063A\u0627\u0629",
                text: "\u0627\u0644\u0645\u0633\u0627\u0631\u0627\u062A \u0627\u0644\u062A\u064A \u0623\u0648\u0642\u0641\u0647\u0627 \u0645\u0646 \u0637\u0644\u0628\u0647\u0627."
              },
              toDecide: {
                term: "\u0645\u0627 \u0639\u0644\u064A\u0651 \u0627\u0644\u0628\u062A\u0651 \u0641\u064A\u0647",
                text: "\u0632\u0631 \u064A\u064F\u062F\u0645\u062C \u0645\u0639 \u0627\u0644\u0623\u0632\u0631\u0627\u0631 \u0627\u0644\u0623\u062E\u0631\u0649: \u064A\u064F\u0628\u0642\u064A \u0641\u0642\u0637 \u0627\u0644\u0645\u0633\u0627\u0631\u0627\u062A \u0627\u0644\u062A\u064A \u062A\u0646\u062A\u0638\u0631 \u0631\u0623\u064A\u0643 \u0627\u0644\u0622\u0646."
              }
            }
          },
          table: {
            title: "\u0645\u0633\u0627\u0631\u0627\u062A \u0627\u0644\u062A\u0623\u0634\u064A\u0631 \u0641\u064A \u0627\u0644\u0645\u0634\u0631\u0648\u0639",
            items: {
              document: {
                term: "\u0627\u0644\u0648\u062B\u064A\u0642\u0629",
                text: "\u0631\u0645\u0632 \u0627\u0644\u0648\u062B\u064A\u0642\u0629 \u0648\u0639\u0646\u0648\u0627\u0646\u0647\u0627. \u0627\u0646\u0642\u0631 \u0639\u0644\u064A\u0647\u0627 \u0644\u0641\u062A\u062D\u0647\u0627 \u0641\u064A \u0627\u0644\u0639\u0627\u0631\u0636."
              },
              index: {
                term: "\u0627\u0644\u0645\u0624\u0634\u0631",
                text: "\u062D\u0631\u0641 \u0646\u0633\u062E\u0629 \u0627\u0644\u0648\u062B\u064A\u0642\u0629 \u0627\u0644\u0645\u0639\u0631\u0648\u0636\u0629 \u0644\u0644\u062A\u0623\u0634\u064A\u0631 (\u2066A\u2069 \u0648\u2066B\u2069 \u0648\u2066C\u2069\u2026)."
              },
              status: {
                term: "\u0627\u0644\u062D\u0627\u0644\u0629",
                text: "\u0642\u064A\u062F \u0627\u0644\u062A\u0623\u0634\u064A\u0631 \u0623\u0648 \u0645\u0624\u0634\u064E\u0651\u0631 \u0639\u0644\u064A\u0647 (\u2066VSO\u2069) \u0623\u0648 \u0645\u0624\u0634\u064E\u0651\u0631 \u0639\u0644\u064A\u0647 \u0645\u0639 \u0645\u0644\u0627\u062D\u0638\u0627\u062A (\u2066VAO\u2069) \u0623\u0648 \u0645\u0631\u0641\u0648\u0636 (\u2066REF\u2069) \u0623\u0648 \u0645\u0644\u063A\u0649."
              },
              step: {
                term: "\u0627\u0644\u062E\u0637\u0648\u0629 \u0627\u0644\u062D\u0627\u0644\u064A\u0629",
                text: "\u0645\u062B\u0644 \xAB\u0627\u0644\u062E\u0637\u0648\u0629 \u20662\u2069 \u0645\u0646 \u20663\u2069\xBB \u0645\u0627 \u062F\u0627\u0645 \u0627\u0644\u0645\u0633\u0627\u0631 \u0645\u0641\u062A\u0648\u062D\u064B\u0627\u061B \u0648\u0625\u0644\u0627 \u0634\u0631\u0637\u0629."
              },
              initiator: {
                term: "\u0637\u0644\u0628\u0647",
                text: "\u0627\u0644\u0634\u062E\u0635 \u0627\u0644\u0630\u064A \u0637\u0644\u0628 \u0627\u0644\u062A\u0623\u0634\u064A\u0631\u0629."
              },
              dates: {
                term: "\u0627\u0644\u062A\u0648\u0627\u0631\u064A\u062E",
                text: "\u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0637\u0644\u0628\u060C \u062B\u0645 \u062A\u0627\u0631\u064A\u062E \u0627\u0646\u062A\u0647\u0627\u0621 \u0627\u0644\u0645\u0633\u0627\u0631 \u0623\u0648 \u0623\u062C\u0644\u0647."
              },
              actions: {
                term: "\u0627\u0644\u0625\u062C\u0631\u0627\u0621\u0627\u062A",
                text: "\xAB\u0639\u0631\u0636 \u0627\u0644\u0645\u0633\u0627\u0631\xBB \u0644\u0644\u062C\u0645\u064A\u0639. \u0648\u0644\u0627 \u064A\u0638\u0647\u0631 \xAB\u0625\u0628\u062F\u0627\u0621 \u0631\u0623\u064A\u064A\xBB \u0625\u0644\u0627 \u0639\u0646\u062F\u0645\u0627 \u064A\u062D\u064A\u0646 \u062F\u0648\u0631\u0643 \u0644\u0644\u0628\u062A\u0651."
              }
            }
          },
          details: {
            title: "\u0645\u0633\u0627\u0631 \u0627\u0644\u062A\u0623\u0634\u064A\u0631 \u0639\u0644\u0649 \u0648\u062B\u064A\u0642\u0629",
            items: {
              header: {
                term: "\u0637\u0644\u0628\u0647 \u2026 \u0641\u064A",
                text: "\u0631\u0623\u0633 \u0627\u0644\u0646\u0627\u0641\u0630\u0629: \u0627\u0644\u062D\u0627\u0644\u0629 \u0648\u0627\u0644\u0645\u0624\u0634\u0631 \u0648\u0645\u0646 \u0637\u0644\u0628 \u0627\u0644\u062A\u0623\u0634\u064A\u0631\u0629 \u0648\u0645\u062A\u0649\u060C \u062B\u0645 \u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0627\u0646\u062A\u0647\u0627\u0621 \u0623\u0648 \u0627\u0644\u0623\u062C\u0644."
              },
              step: {
                term: "\u0627\u0644\u062E\u0637\u0648\u0629",
                text: "\u062A\u0628\u064A\u0651\u0646 \u0643\u0644 \u062E\u0637\u0648\u0629 \u0646\u0645\u0637\u0647\u0627\u060C \u0628\u0627\u0644\u062A\u0631\u062A\u064A\u0628 (\u0643\u0644 \u0645\u0631\u0627\u062C\u0639 \u0628\u062F\u0648\u0631\u0647) \u0623\u0648 \u0628\u0627\u0644\u062A\u0648\u0627\u0632\u064A (\u0627\u0644\u062C\u0645\u064A\u0639 \u0641\u064A \u0648\u0642\u062A \u0648\u0627\u062D\u062F)\u060C \u0648\xAB\u0627\u0644\u062E\u0637\u0648\u0629 \u0627\u0644\u062D\u0627\u0644\u064A\u0629\xBB \u0644\u0644\u0645\u0641\u062A\u0648\u062D\u0629 \u0645\u0646\u0647\u0627. \u0623\u0645\u0627 \u0627\u0644\u062E\u0637\u0648\u0627\u062A \u0627\u0644\u062A\u0627\u0644\u064A\u0629 \u0641\u0647\u064A \xAB\u0642\u0627\u062F\u0645\u0629\xBB."
              },
              reviewers: {
                term: "\u0627\u0644\u0645\u0631\u0627\u062C\u0639\u0648\u0646",
                text: "\u0644\u0643\u0644 \u0648\u0627\u062D\u062F \u0645\u0646\u0647\u0645: \u062D\u0627\u0646 \u062F\u0648\u0631\u0647 \u0644\u0644\u0628\u062A\u0651\u060C \u0623\u0648 \u0641\u064A \u0627\u0646\u062A\u0638\u0627\u0631 \u0631\u0623\u064A\u0647\u060C \u0623\u0648 \u0644\u0645 \u064A\u064F\u0637\u0644\u0628 \u0645\u0646\u0647 \u0627\u0644\u0631\u0623\u064A \u0628\u0639\u062F\u060C \u0623\u0648 \u0627\u0644\u0642\u0631\u0627\u0631 \u0627\u0644\u0630\u064A \u0627\u062A\u062E\u0630\u0647. \u062A\u0634\u064A\u0631 \xAB(\u0623\u0646\u062A)\xBB \u0625\u0644\u0649 \u0627\u0633\u0645\u0643."
              },
              cancel: {
                term: "\u0625\u0644\u063A\u0627\u0621 \u0627\u0644\u0645\u0633\u0627\u0631",
                text: "\u0644\u0645\u0646 \u0637\u0644\u0628 \u0627\u0644\u062A\u0623\u0634\u064A\u0631\u0629: \u064A\u0648\u0642\u0641 \u0627\u0644\u0645\u0633\u0627\u0631 \u0628\u0639\u062F \u0627\u0644\u062A\u0623\u0643\u064A\u062F. \u062A\u0642\u0628\u0644 \u0627\u0644\u0648\u062B\u064A\u0642\u0629 \u0646\u0633\u062E\u0629 \u062C\u062F\u064A\u062F\u0629 \u0645\u0646 \u062C\u062F\u064A\u062F\u061B \u0648\u062A\u0628\u0642\u0649 \u0627\u0644\u0622\u0631\u0627\u0621 \u0627\u0644\u0645\u064F\u0639\u0637\u0627\u0629 \u0641\u064A \u0627\u0644\u0633\u062C\u0644."
              }
            }
          },
          decision: {
            title: "\u0631\u0623\u064A\u0643 \u0641\u064A \u0648\u062B\u064A\u0642\u0629",
            items: {
              vso: {
                term: "\u2066VSO\u2069 \u2014 \u0645\u0624\u0634\u064E\u0651\u0631 \u0628\u062F\u0648\u0646 \u0645\u0644\u0627\u062D\u0638\u0627\u062A",
                text: "\u062A\u0648\u0627\u0641\u0642 \u0639\u0644\u0649 \u0627\u0644\u0648\u062B\u064A\u0642\u0629 \u0643\u0645\u0627 \u0647\u064A. \u0627\u0644\u0645\u0644\u0627\u062D\u0638\u0629 \u0627\u062E\u062A\u064A\u0627\u0631\u064A\u0629."
              },
              vao: {
                term: "\u2066VAO\u2069 \u2014 \u0645\u0624\u0634\u064E\u0651\u0631 \u0645\u0639 \u0645\u0644\u0627\u062D\u0638\u0627\u062A",
                text: "\u062A\u0648\u0627\u0641\u0642 \u0639\u0644\u0649 \u0627\u0644\u0648\u062B\u064A\u0642\u0629 \u0628\u0634\u0631\u0637 \u0645\u0631\u0627\u0639\u0627\u0629 \u0645\u0644\u0627\u062D\u0638\u0627\u062A\u0643. \u0627\u0644\u0645\u0644\u0627\u062D\u0638\u0629 \u0625\u0644\u0632\u0627\u0645\u064A\u0629."
              },
              ref: {
                term: "\u2066REF\u2069 \u2014 \u0645\u0631\u0641\u0648\u0636",
                text: "\u062A\u0631\u0641\u0636 \u0647\u0630\u0647 \u0627\u0644\u0646\u0633\u062E\u0629: \u064A\u062A\u0648\u0642\u0641 \u0627\u0644\u0645\u0633\u0627\u0631 \u0648\u064A\u062C\u0628 \u062A\u0635\u062D\u064A\u062D \u0627\u0644\u0648\u062B\u064A\u0642\u0629. \u0627\u0644\u0645\u0644\u0627\u062D\u0638\u0629 \u0625\u0644\u0632\u0627\u0645\u064A\u0629."
              },
              comment: {
                term: "\u0627\u0644\u0645\u0644\u0627\u062D\u0638\u0629",
                text: "\u062A\u0639\u0644\u064A\u0642\u0643. \u0641\u064A \u062D\u0627\u0644\u0629 \u2066VAO\u2069 \u0623\u0648 \u2066REF\u2069 \u0647\u0648 \u0625\u0644\u0632\u0627\u0645\u064A\u060C \u0645\u0627 \u0644\u0645 \u062A\u064F\u0631\u0641\u0642 \u0623\u062D\u062F \u062A\u0639\u0644\u064A\u0642\u0627\u062A\u0643 \u0627\u0644\u062A\u0648\u0636\u064A\u062D\u064A\u0629."
              },
              annotations: {
                term: "\u0625\u0631\u0641\u0627\u0642 \u062A\u0639\u0644\u064A\u0642\u0627\u062A\u064A \u0627\u0644\u062A\u0648\u0636\u064A\u062D\u064A\u0629",
                text: "\u062E\u0627\u0646\u0627\u062A \u0627\u062E\u062A\u064A\u0627\u0631: \u0627\u0644\u062A\u0639\u0644\u064A\u0642\u0627\u062A \u0627\u0644\u062A\u0648\u0636\u064A\u062D\u064A\u0629 \u0627\u0644\u062A\u064A \u0623\u0636\u0641\u062A\u0647\u0627 \u0639\u0644\u0649 \u0627\u0644\u0648\u062B\u064A\u0642\u0629 \u0648\u062A\u0631\u0628\u0637\u0647\u0627 \u0628\u0631\u0623\u064A\u0643."
              },
              send: {
                term: "\u0625\u0631\u0633\u0627\u0644 \u0631\u0623\u064A\u064A",
                text: "\u0631\u0623\u064A\u0643 \u0646\u0647\u0627\u0626\u064A: \u0644\u0646 \u062A\u0633\u062A\u0637\u064A\u0639 \u062A\u0639\u062F\u064A\u0644\u0647 \u0628\u0639\u062F \u0625\u0631\u0633\u0627\u0644\u0647."
              }
            }
          },
          empty: {
            title: "\u0631\u0633\u0627\u0626\u0644 \u0627\u0644\u062D\u0627\u0644\u0629",
            items: {
              none: {
                term: "\u0644\u0627 \u0645\u0633\u0627\u0631\u0627\u062A \u062A\u0623\u0634\u064A\u0631",
                text: "\u0627\u0641\u062A\u062D \u0648\u062B\u064A\u0642\u0629 \u0641\u064A \u062A\u0628\u0648\u064A\u0628 \u0627\u0644\u0645\u0644\u0641\u0627\u062A \u0648\u0627\u0637\u0644\u0628 \u062A\u0623\u0634\u064A\u0631\u062A\u0647\u0627: \u0633\u064A\u0638\u0647\u0631 \u0627\u0644\u0645\u0633\u0627\u0631 \u0647\u0646\u0627."
              },
              noMatch: {
                term: "\u0644\u0627 \u0645\u0633\u0627\u0631 \u0645\u0637\u0627\u0628\u0642",
                text: "\u0627\u062E\u062A\u0631 \u062D\u0627\u0644\u0629 \u0623\u062E\u0631\u0649 \u0644\u0639\u0631\u0636 \u0628\u0642\u064A\u0629 \u0627\u0644\u0645\u0633\u0627\u0631\u0627\u062A."
              },
              nothingToDecide: {
                term: "\u0644\u0627 \u0634\u064A\u0621 \u0644\u0644\u0628\u062A\u0651 \u0641\u064A\u0647 \u062D\u0627\u0644\u064A\u064B\u0627",
                text: "\u0633\u062A\u0638\u0647\u0631 \u0647\u0646\u0627 \u0627\u0644\u0645\u0633\u0627\u0631\u0627\u062A \u0627\u0644\u062A\u064A \u062A\u0646\u062A\u0638\u0631 \u0631\u0623\u064A\u0643."
              },
              loadFailed: {
                term: "\u062A\u0639\u0630\u0651\u0631 \u0639\u0631\u0636 \u0645\u0633\u0627\u0631\u0627\u062A \u0627\u0644\u062A\u0623\u0634\u064A\u0631",
                text: "\u0631\u0633\u0627\u0644\u0629 \u062D\u0645\u0631\u0627\u0621: \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629 \u0628\u0632\u0631 \xAB\u0625\u0639\u0627\u062F\u0629 \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629\xBB\u061B \u0648\u0625\u0646 \u0627\u0633\u062A\u0645\u0631\u062A \u0627\u0644\u0645\u0634\u0643\u0644\u0629 \u0641\u062A\u0648\u0627\u0635\u0644 \u0645\u0639 \u0627\u0644\u062F\u0639\u0645."
              }
            }
          }
        }
      },
      calendar: {
        title: "\u0627\u0644\u0631\u0632\u0646\u0627\u0645\u0629",
        intro: "\u062A\u0628\u0648\u064A\u0628 \u0627\u062C\u062A\u0645\u0627\u0639\u0627\u062A \u0627\u0644\u0645\u0634\u0631\u0648\u0639 \u0648\u0632\u064A\u0627\u0631\u0627\u062A \u0627\u0644\u0648\u0631\u0634\u0629 \u0648\u0627\u0644\u0622\u062C\u0627\u0644. \u0641\u064A \u0627\u0644\u0648\u0642\u062A \u0627\u0644\u062D\u0627\u0644\u064A \u064A\u0643\u062A\u0641\u064A \u0628\u0627\u0644\u0625\u0639\u0644\u0627\u0646 \u0639\u0645\u0651\u0627 \u0633\u064A\u062D\u062A\u0648\u064A\u0647.",
        sections: {
          summary: {
            title: "\u0645\u0644\u062E\u0635 \u0627\u0644\u0645\u0634\u0631\u0648\u0639",
            items: {
              breadcrumb: {
                term: "\u0627\u0644\u0645\u0634\u0627\u0631\u064A\u0639",
                text: "\u0645\u0633\u0627\u0631 \u0627\u0644\u062A\u0646\u0642\u0644 \u0641\u064A \u0623\u0639\u0644\u0649 \u0627\u0644\u0635\u0641\u062D\u0629. \u0627\u0646\u0642\u0631 \u0639\u0644\u0649 \xAB\u0627\u0644\u0645\u0634\u0627\u0631\u064A\u0639\xBB \u0644\u0644\u0639\u0648\u062F\u0629 \u0625\u0644\u0649 \u0627\u0644\u0642\u0627\u0626\u0645\u0629\u061B \u0648\u0628\u062C\u0627\u0646\u0628\u0647 \u062A\u0631\u0649 \u0627\u0633\u0645 \u0627\u0644\u0645\u0634\u0631\u0648\u0639 \u0627\u0644\u0645\u0641\u062A\u0648\u062D."
              },
              meeting: {
                term: "\u0628\u062F\u0621 \u0627\u062C\u062A\u0645\u0627\u0639",
                text: "\u0632\u0631 \u0641\u064A \u0623\u0639\u0644\u0649 \u0627\u0644\u0635\u0641\u062D\u0629 \u0644\u0623\u0639\u0636\u0627\u0621 \u0627\u0644\u0645\u0634\u0631\u0648\u0639 \u0627\u0644\u0642\u0627\u062F\u0631\u064A\u0646 \u0639\u0644\u0649 \u0627\u0644\u0645\u0633\u0627\u0647\u0645\u0629. \u064A\u0637\u0644\u0628 \u0639\u0646\u0648\u0627\u0646 \u0627\u0644\u0627\u062C\u062A\u0645\u0627\u0639 \u062B\u0645 \u064A\u0641\u062A\u062D \u0642\u0627\u0639\u0629 \u0627\u0644\u0627\u062C\u062A\u0645\u0627\u0639."
              },
              code: {
                term: "\u0627\u0644\u0631\u0645\u0632",
                text: "\u0631\u0645\u0632 \u0627\u0644\u0645\u0634\u0631\u0648\u0639\u060C \u064A\u064F\u0633\u062A\u0639\u0645\u0644 \u0641\u064A \u0648\u062B\u0627\u0626\u0642\u0647 \u0648\u0641\u0648\u0627\u062A\u064A\u0631\u0647."
              },
              client: {
                term: "\u0627\u0644\u062D\u0631\u064A\u0641",
                text: "\u062D\u0631\u064A\u0641 \u0627\u0644\u0645\u0634\u0631\u0648\u0639 (\u0635\u0627\u062D\u0628 \u0627\u0644\u0645\u0634\u0631\u0648\u0639)\u060C \u0623\u0648 \xAB\u0628\u062F\u0648\u0646 \u062D\u0631\u064A\u0641\xBB \u0625\u0646 \u0644\u0645 \u064A\u064F\u062F\u062E\u064E\u0644 \u0628\u0639\u062F."
              },
              status: {
                term: "\u0627\u0644\u062D\u0627\u0644\u0629",
                text: "\u0634\u0627\u0631\u0629 \u062A\u0628\u064A\u0651\u0646 \u062D\u0627\u0644\u0629 \u0627\u0644\u0645\u0634\u0631\u0648\u0639: \u0645\u0633\u0648\u062F\u0629 \u0623\u0648 \u062C\u0627\u0631\u064D \u0623\u0648 \u0645\u062A\u0648\u0642\u0641 \u0645\u0624\u0642\u062A\u064B\u0627 \u0623\u0648 \u0645\u063A\u0644\u0642 \u0623\u0648 \u0645\u0624\u0631\u0634\u0641."
              },
              progress: {
                term: "\u0627\u0644\u0645\u0631\u0627\u062D\u0644 \u0627\u0644\u0645\u063A\u0644\u0642\u0629: \u20662 / 7\u2069",
                text: "\u0634\u0631\u064A\u0637 \u062A\u0642\u062F\u0651\u0645 \u0648\u0639\u062F\u062F \u0627\u0644\u0645\u0631\u0627\u062D\u0644 \u0627\u0644\u0645\u063A\u0644\u0642\u0629\u060C \u0645\u0639 \u0627\u0644\u0645\u0631\u062D\u0644\u0629 \u0627\u0644\u062D\u0627\u0644\u064A\u0629."
              },
              tabs: {
                term: "\u0627\u0644\u0645\u0646\u0634\u0648\u0631\u0627\u062A\u060C \u0627\u0644\u0645\u0644\u0641\u0627\u062A\u060C \u0627\u0644\u0645\u0647\u0627\u0645\u060C \u0627\u0644\u0645\u0631\u0627\u062D\u0644\u060C \u0627\u0644\u0645\u062E\u0631\u062C\u0627\u062A\u060C \u0627\u0644\u062A\u0623\u0634\u064A\u0631\u0627\u062A\u060C \u0627\u0644\u0631\u0632\u0646\u0627\u0645\u0629\u060C \u0627\u0644\u0645\u0627\u0644\u064A\u0629\u060C \u0627\u0644\u0625\u0639\u062F\u0627\u062F\u0627\u062A",
                text: "\u062A\u0628\u0648\u064A\u0628\u0627\u062A \u0627\u0644\u0645\u0634\u0631\u0648\u0639. \u0623\u0646\u062A \u0627\u0644\u0622\u0646 \u0641\u064A \xAB\u0627\u0644\u0631\u0632\u0646\u0627\u0645\u0629\xBB."
              }
            }
          },
          meeting: {
            title: "\u0628\u062F\u0621 \u0627\u062C\u062A\u0645\u0627\u0639",
            items: {
              titleField: {
                term: "\u0639\u0646\u0648\u0627\u0646 \u0627\u0644\u0627\u062C\u062A\u0645\u0627\u0639",
                text: "\u062D\u0642\u0644 \u0625\u0644\u0632\u0627\u0645\u064A\u060C 200 \u062D\u0631\u0641 \u0639\u0644\u0649 \u0627\u0644\u0623\u0643\u062B\u0631. \u064A\u0623\u062A\u064A \u0645\u0639\u0628\u0651\u0623\u064B \u0645\u0633\u0628\u0642\u064B\u0627 \u0628\u0639\u0628\u0627\u0631\u0629 \xAB\u0627\u062C\u062A\u0645\u0627\u0639 -\xBB \u0645\u062A\u0628\u0648\u0639\u0629 \u0628\u0627\u0633\u0645 \u0627\u0644\u0645\u0634\u0631\u0648\u0639."
              },
              start: {
                term: "\u0628\u062F\u0621",
                text: "\u064A\u0646\u0634\u0626 \u0627\u0644\u0627\u062C\u062A\u0645\u0627\u0639 \u0648\u064A\u0623\u062E\u0630\u0643 \u0625\u0644\u0649 \u0642\u0627\u0639\u062A\u0647. \u064A\u0645\u0643\u0646 \u0644\u0623\u0639\u0636\u0627\u0621 \u0627\u0644\u0645\u0634\u0631\u0648\u0639 \u0627\u0644\u0627\u0646\u0636\u0645\u0627\u0645 \u0625\u0644\u064A\u0647."
              },
              cancel: {
                term: "\u0625\u0644\u063A\u0627\u0621",
                text: "\u064A\u063A\u0644\u0642 \u0627\u0644\u0646\u0627\u0641\u0630\u0629 \u062F\u0648\u0646 \u0625\u0646\u0634\u0627\u0621 \u0627\u062C\u062A\u0645\u0627\u0639."
              }
            }
          },
          placeholder: {
            title: "\u0633\u062A\u0638\u0647\u0631 \u0647\u0646\u0627 \u0631\u0632\u0646\u0627\u0645\u0629 \u0627\u0644\u0645\u0634\u0631\u0648\u0639",
            items: {
              message: {
                term: "\u0633\u062A\u0638\u0647\u0631 \u0647\u0646\u0627 \u0631\u0632\u0646\u0627\u0645\u0629 \u0627\u0644\u0645\u0634\u0631\u0648\u0639",
                text: "\u0631\u0633\u0627\u0644\u0629 \u062A\u0638\u0647\u0631 \u0641\u064A \u0648\u0633\u0637 \u0627\u0644\u062A\u0628\u0648\u064A\u0628: \u0631\u0632\u0646\u0627\u0645\u0629 \u0627\u0644\u0645\u0634\u0631\u0648\u0639 \u063A\u064A\u0631 \u0645\u062A\u0627\u062D\u0629 \u0628\u0639\u062F \u0641\u064A \u0647\u0630\u0627 \u0627\u0644\u062A\u0628\u0648\u064A\u0628."
              },
              content: {
                term: "\u0627\u0644\u0627\u062C\u062A\u0645\u0627\u0639\u0627\u062A \u0648\u0632\u064A\u0627\u0631\u0627\u062A \u0627\u0644\u0648\u0631\u0634\u0629 \u0648\u0627\u0644\u0622\u062C\u0627\u0644",
                text: "\u0647\u0630\u0647 \u0647\u064A \u0627\u0644\u0639\u0646\u0627\u0635\u0631 \u0627\u0644\u0645\u0639\u0644\u0646 \u0639\u0646\u0647\u0627: \u0633\u062A\u0638\u0647\u0631 \u0641\u064A \u0647\u0630\u0627 \u0627\u0644\u062A\u0628\u0648\u064A\u0628."
              }
            }
          }
        }
      },
      finance: {
        title: "\u0627\u0644\u0645\u0627\u0644\u064A\u0629",
        intro: "\u0627\u0644\u0648\u0636\u0639 \u0627\u0644\u0645\u0627\u0644\u064A \u0644\u0644\u0645\u0634\u0631\u0648\u0639: \u0639\u0642\u062F\u0647 \u0648\u0627\u0644\u062A\u0642\u062F\u0651\u0645 \u0627\u0644\u0645\u0641\u0648\u062A\u0631 \u062D\u0633\u0628 \u0627\u0644\u0645\u0631\u0627\u062D\u0644 \u0648\u0639\u0631\u0648\u0636\u0647 \u0627\u0644\u0645\u0627\u0644\u064A\u0629 \u0648\u0641\u0648\u0627\u062A\u064A\u0631\u0647. \u0644\u0627 \u064A\u0638\u0647\u0631 \u0627\u0644\u062A\u0628\u0648\u064A\u0628 \u0625\u0644\u0627 \u0644\u0645\u0646 \u064A\u0645\u0644\u0643 \u062D\u0642 \u0627\u0644\u0627\u0637\u0644\u0627\u0639 \u0639\u0644\u0649 \u0627\u0644\u0639\u0631\u0648\u0636 \u0627\u0644\u0645\u0627\u0644\u064A\u0629 \u0623\u0648 \u0627\u0644\u0641\u0648\u0627\u062A\u064A\u0631 \u0623\u0648 \u0627\u0644\u0639\u0642\u0648\u062F.",
        sections: {
          summary: {
            title: "\u0645\u0644\u062E\u0635 \u0627\u0644\u0645\u0634\u0631\u0648\u0639",
            items: {
              breadcrumb: {
                term: "\u0627\u0644\u0645\u0634\u0627\u0631\u064A\u0639",
                text: "\u0645\u0633\u0627\u0631 \u0627\u0644\u062A\u0646\u0642\u0644 \u0641\u064A \u0623\u0639\u0644\u0649 \u0627\u0644\u0635\u0641\u062D\u0629. \u0627\u0646\u0642\u0631 \u0639\u0644\u0649 \xAB\u0627\u0644\u0645\u0634\u0627\u0631\u064A\u0639\xBB \u0644\u0644\u0639\u0648\u062F\u0629 \u0625\u0644\u0649 \u0627\u0644\u0642\u0627\u0626\u0645\u0629\u061B \u0648\u0628\u062C\u0627\u0646\u0628\u0647 \u062A\u0631\u0649 \u0627\u0633\u0645 \u0627\u0644\u0645\u0634\u0631\u0648\u0639 \u0627\u0644\u0645\u0641\u062A\u0648\u062D."
              },
              meeting: {
                term: "\u0628\u062F\u0621 \u0627\u062C\u062A\u0645\u0627\u0639",
                text: "\u0632\u0631 \u0641\u064A \u0623\u0639\u0644\u0649 \u0627\u0644\u0635\u0641\u062D\u0629 \u0644\u0623\u0639\u0636\u0627\u0621 \u0627\u0644\u0645\u0634\u0631\u0648\u0639 \u0627\u0644\u0642\u0627\u062F\u0631\u064A\u0646 \u0639\u0644\u0649 \u0627\u0644\u0645\u0633\u0627\u0647\u0645\u0629. \u064A\u0637\u0644\u0628 \u0639\u0646\u0648\u0627\u0646 \u0627\u0644\u0627\u062C\u062A\u0645\u0627\u0639 \u062B\u0645 \u064A\u0641\u062A\u062D \u0642\u0627\u0639\u0629 \u0627\u0644\u0627\u062C\u062A\u0645\u0627\u0639."
              },
              code: {
                term: "\u0627\u0644\u0631\u0645\u0632",
                text: "\u0631\u0645\u0632 \u0627\u0644\u0645\u0634\u0631\u0648\u0639\u060C \u064A\u064F\u0633\u062A\u0639\u0645\u0644 \u0641\u064A \u0648\u062B\u0627\u0626\u0642\u0647 \u0648\u0641\u0648\u0627\u062A\u064A\u0631\u0647."
              },
              client: {
                term: "\u0627\u0644\u062D\u0631\u064A\u0641",
                text: "\u062D\u0631\u064A\u0641 \u0627\u0644\u0645\u0634\u0631\u0648\u0639 (\u0635\u0627\u062D\u0628 \u0627\u0644\u0645\u0634\u0631\u0648\u0639)\u060C \u0623\u0648 \xAB\u0628\u062F\u0648\u0646 \u062D\u0631\u064A\u0641\xBB \u0625\u0646 \u0644\u0645 \u064A\u064F\u062F\u062E\u064E\u0644 \u0628\u0639\u062F."
              },
              status: {
                term: "\u0627\u0644\u062D\u0627\u0644\u0629",
                text: "\u0634\u0627\u0631\u0629 \u062A\u0628\u064A\u0651\u0646 \u062D\u0627\u0644\u0629 \u0627\u0644\u0645\u0634\u0631\u0648\u0639: \u0645\u0633\u0648\u062F\u0629 \u0623\u0648 \u062C\u0627\u0631\u064D \u0623\u0648 \u0645\u062A\u0648\u0642\u0641 \u0645\u0624\u0642\u062A\u064B\u0627 \u0623\u0648 \u0645\u063A\u0644\u0642 \u0623\u0648 \u0645\u0624\u0631\u0634\u0641."
              },
              progress: {
                term: "\u0627\u0644\u0645\u0631\u0627\u062D\u0644 \u0627\u0644\u0645\u063A\u0644\u0642\u0629: \u20662 / 7\u2069",
                text: "\u0634\u0631\u064A\u0637 \u062A\u0642\u062F\u0651\u0645 \u0648\u0639\u062F\u062F \u0627\u0644\u0645\u0631\u0627\u062D\u0644 \u0627\u0644\u0645\u063A\u0644\u0642\u0629\u060C \u0645\u0639 \u0627\u0644\u0645\u0631\u062D\u0644\u0629 \u0627\u0644\u062D\u0627\u0644\u064A\u0629."
              },
              tabs: {
                term: "\u0627\u0644\u0645\u0646\u0634\u0648\u0631\u0627\u062A\u060C \u0627\u0644\u0645\u0644\u0641\u0627\u062A\u060C \u0627\u0644\u0645\u0647\u0627\u0645\u060C \u0627\u0644\u0645\u0631\u0627\u062D\u0644\u060C \u0627\u0644\u0645\u062E\u0631\u062C\u0627\u062A\u060C \u0627\u0644\u062A\u0623\u0634\u064A\u0631\u0627\u062A\u060C \u0627\u0644\u0631\u0632\u0646\u0627\u0645\u0629\u060C \u0627\u0644\u0645\u0627\u0644\u064A\u0629\u060C \u0627\u0644\u0625\u0639\u062F\u0627\u062F\u0627\u062A",
                text: "\u062A\u0628\u0648\u064A\u0628\u0627\u062A \u0627\u0644\u0645\u0634\u0631\u0648\u0639. \u0623\u0646\u062A \u0627\u0644\u0622\u0646 \u0641\u064A \xAB\u0627\u0644\u0645\u0627\u0644\u064A\u0629\xBB."
              }
            }
          },
          contract: {
            title: "\u0627\u0644\u0639\u0642\u062F",
            items: {
              reference: {
                term: "\u0645\u0631\u062C\u0639 \u0627\u0644\u0639\u0642\u062F",
                text: "\u0645\u0631\u062C\u0639 \u0639\u0642\u062F \u0627\u0644\u0645\u0634\u0631\u0648\u0639. \u0627\u0646\u0642\u0631 \u0639\u0644\u064A\u0647 \u0644\u0641\u062A\u062D \u0627\u0644\u0639\u0642\u062F."
              },
              client: {
                term: "\u0627\u0644\u062D\u0631\u064A\u0641",
                text: "\u062D\u0631\u064A\u0641 \u0627\u0644\u0639\u0642\u062F."
              },
              kind: {
                term: "\u0627\u0644\u0635\u0646\u0641",
                text: "\u0627\u062A\u0641\u0627\u0642\u064A\u0629 \u062E\u0627\u0635\u0629\u060C \u0623\u0648 \u0635\u0641\u0642\u0629 \u0639\u0645\u0648\u0645\u064A\u0629."
              },
              total: {
                term: "\u0627\u0644\u0645\u062C\u0645\u0648\u0639 \u062F\u0648\u0646 \u0627\u062D\u062A\u0633\u0627\u0628 \u0627\u0644\u0623\u062F\u0627\u0621\u0627\u062A \u0645\u0639 \u0627\u0644\u0645\u0644\u0627\u062D\u0642:",
                text: "\u0645\u0628\u0644\u063A \u0627\u0644\u0639\u0642\u062F \u062F\u0648\u0646 \u0627\u062D\u062A\u0633\u0627\u0628 \u0627\u0644\u0623\u062F\u0627\u0621\u0627\u062A\u060C \u0645\u0639 \u0627\u0644\u0645\u0644\u0627\u062D\u0642 (\u0627\u0644\u062A\u0639\u062F\u064A\u0644\u0627\u062A \u0627\u0644\u0645\u0648\u0642\u0651\u0639\u0629 \u0644\u0627\u062D\u0642\u064B\u0627). \u0645\u062B\u0627\u0644: \u206611,544.000 TND\u2069."
              },
              open: {
                term: "\u0641\u062A\u062D \u0627\u0644\u0639\u0642\u062F",
                text: "\u0631\u0627\u0628\u0637 \u0625\u0644\u0649 \u0635\u0641\u062D\u0629 \u0627\u0644\u0639\u0642\u062F."
              },
              prepare: {
                term: "\u0625\u0639\u062F\u0627\u062F \u0641\u0627\u062A\u0648\u0631\u0629 \u062A\u0642\u062F\u0651\u0645 \u0627\u0644\u0623\u0634\u063A\u0627\u0644",
                text: "\u0631\u0627\u0628\u0637 \u0644\u0645\u0646 \u064A\u0645\u0643\u0646\u0647 \u0625\u0646\u0634\u0627\u0621 \u0627\u0644\u0641\u0648\u0627\u062A\u064A\u0631\u060C \u0639\u0646\u062F\u0645\u0627 \u064A\u0643\u0648\u0646 \u0627\u0644\u0639\u0642\u062F \u0628\u0627\u0644\u062F\u064A\u0646\u0627\u0631 (\u2066TND\u2069). \u062A\u0641\u0648\u062A\u0631 \u0641\u0627\u062A\u0648\u0631\u0629 \u062A\u0642\u062F\u0651\u0645 \u0627\u0644\u0623\u0634\u063A\u0627\u0644 \u062A\u0642\u062F\u0651\u0645 \u0627\u0644\u0623\u0634\u063A\u0627\u0644 \u0623\u0648 \u0627\u0644\u062F\u0631\u0627\u0633\u0627\u062A \u0641\u064A \u062A\u0627\u0631\u064A\u062E \u0645\u0639\u064A\u0651\u0646."
              }
            }
          },
          noContract: {
            title: "\u0644\u0627 \u064A\u0648\u062C\u062F \u0639\u0642\u062F \u0644\u0647\u0630\u0627 \u0627\u0644\u0645\u0634\u0631\u0648\u0639",
            items: {
              message: {
                term: "\u0644\u0627 \u064A\u0648\u062C\u062F \u0639\u0642\u062F \u0644\u0647\u0630\u0627 \u0627\u0644\u0645\u0634\u0631\u0648\u0639",
                text: "\u062A\u0638\u0647\u0631 \u0639\u0646\u062F\u0645\u0627 \u0644\u0627 \u064A\u0643\u0648\u0646 \u0644\u0644\u0645\u0634\u0631\u0648\u0639 \u0639\u0642\u062F \u0628\u0639\u062F. \u0623\u0645\u0627 \u0645\u0646 \u0644\u0627 \u064A\u062F\u064A\u0631 \u0627\u0644\u0639\u0642\u0648\u062F \u0641\u064A\u0642\u0631\u0623 \u0641\u0642\u0637 \u0623\u0646 \u0639\u0642\u062F \u0627\u0644\u0645\u0634\u0631\u0648\u0639 \u0633\u064A\u0638\u0647\u0631 \u0647\u0646\u0627."
              },
              create: {
                term: "\u0625\u0646\u0634\u0627\u0621 \u0627\u0644\u0639\u0642\u062F",
                text: "\u0644\u0645\u0646 \u064A\u062F\u064A\u0631 \u0627\u0644\u0639\u0642\u0648\u062F: \u064A\u0641\u062A\u062D \u0646\u0645\u0648\u0630\u062C \u0639\u0642\u062F \u062C\u062F\u064A\u062F \u0645\u0631\u062A\u0628\u0637 \u0628\u0647\u0630\u0627 \u0627\u0644\u0645\u0634\u0631\u0648\u0639. \u064A\u062A\u064A\u062D \u0628\u0639\u062F\u0647\u0627 \u0645\u062A\u0627\u0628\u0639\u0629 \u0627\u0644\u062F\u0641\u0639\u0629 \u0627\u0644\u0645\u0633\u0628\u0642\u0629 \u0648\u0627\u0644\u0627\u062D\u062A\u0641\u0627\u0638 \u0628\u0627\u0644\u0636\u0645\u0627\u0646 \u0648\u0627\u0644\u0641\u0648\u062A\u0631\u0629 \u062D\u0633\u0628 \u0627\u0644\u0645\u0631\u0627\u062D\u0644."
              },
              fromQuote: {
                term: "\u0625\u0646\u0634\u0627\u0621 \u0627\u0644\u0639\u0642\u062F \u0627\u0646\u0637\u0644\u0627\u0642\u064B\u0627 \u0645\u0646 \u0627\u0644\u0639\u0631\u0636 \u0627\u0644\u0645\u0627\u0644\u064A",
                text: "\u064A\u064F\u0639\u0631\u0636 \u0639\u0646\u062F\u0645\u0627 \u064A\u064F\u0642\u0628\u0644 \u0639\u0631\u0636 \u0645\u0627\u0644\u064A \u0644\u0644\u0645\u0634\u0631\u0648\u0639: \u064A\u0623\u062E\u0630 \u0627\u0644\u0639\u0642\u062F \u062D\u0631\u064A\u0641 \u0627\u0644\u0639\u0631\u0636 \u0648\u0645\u0628\u0644\u063A\u0647."
              }
            }
          },
          progress: {
            title: "\u0627\u0644\u062A\u0642\u062F\u0651\u0645 \u0627\u0644\u0645\u0641\u0648\u062A\u0631",
            items: {
              total: {
                term: "\u0645\u062C\u0645\u0648\u0639 \u0627\u0644\u0639\u0642\u062F (\u062F\u0648\u0646 \u0627\u062D\u062A\u0633\u0627\u0628 \u0627\u0644\u0623\u062F\u0627\u0621\u0627\u062A)",
                text: "\u0645\u0628\u0644\u063A \u0627\u0644\u0639\u0642\u062F \u062F\u0648\u0646 \u0627\u062D\u062A\u0633\u0627\u0628 \u0627\u0644\u0623\u062F\u0627\u0621\u0627\u062A."
              },
              advance: {
                term: "\u0627\u0644\u062F\u0641\u0639\u0629 \u0627\u0644\u0645\u0633\u0628\u0642\u0629",
                text: "\u0627\u0644\u062F\u0641\u0639\u0629 \u0627\u0644\u0645\u0633\u0628\u0642\u0629 \u0627\u0644\u062A\u064A \u062F\u0641\u0639\u0647\u0627 \u0627\u0644\u062D\u0631\u064A\u0641."
              },
              advanceRecovered: {
                term: "\u0627\u0644\u062F\u0641\u0639\u0629 \u0627\u0644\u0645\u0633\u0628\u0642\u0629 \u0627\u0644\u0645\u0633\u062A\u0631\u062C\u0639\u0629",
                text: "\u062C\u0632\u0621 \u0627\u0644\u062F\u0641\u0639\u0629 \u0627\u0644\u0645\u0633\u0628\u0642\u0629 \u0627\u0644\u0630\u064A \u0633\u0628\u0642 \u062E\u0635\u0645\u0647 \u0645\u0646 \u0627\u0644\u0641\u0648\u0627\u062A\u064A\u0631."
              },
              retention: {
                term: "\u0627\u0644\u0627\u062D\u062A\u0641\u0627\u0638 \u0628\u0627\u0644\u0636\u0645\u0627\u0646 \u0627\u0644\u0645\u0642\u062A\u0637\u0639",
                text: "\u0627\u0644\u0645\u0628\u0644\u063A \u0627\u0644\u0630\u064A \u0627\u062D\u062A\u0641\u0638 \u0628\u0647 \u0627\u0644\u062D\u0631\u064A\u0641 \u0643\u0636\u0645\u0627\u0646\u060C \u0645\u0639 \u0646\u0633\u0628\u062A\u0647 \u0628\u064A\u0646 \u0642\u0648\u0633\u064A\u0646."
              },
              phases: {
                term: "\u0627\u0644\u0645\u0631\u062D\u0644\u0629\u060C \u0627\u0644\u062D\u0627\u0644\u0629\u060C \u0627\u0644\u0623\u062A\u0639\u0627\u0628\u060C \u0627\u0644\u0645\u0641\u0648\u062A\u0631 (\u062A\u0631\u0627\u0643\u0645\u064A)\u060C \u0627\u0644\u0645\u0628\u0644\u063A \u0627\u0644\u0645\u0641\u0648\u062A\u0631",
                text: "\u062C\u062F\u0648\u0644 \u062D\u0633\u0628 \u0627\u0644\u0645\u0631\u062D\u0644\u0629: \u062D\u0627\u0644\u062A\u0647\u0627 \u0648\u0623\u062A\u0639\u0627\u0628\u0647\u0627 \u0648\u0627\u0644\u0646\u0633\u0628\u0629 \u0627\u0644\u062A\u0631\u0627\u0643\u0645\u064A\u0629 \u0627\u0644\u0645\u0641\u0648\u062A\u0631\u0629 \u0633\u0627\u0628\u0642\u064B\u0627 \u0648\u0627\u0644\u0645\u0628\u0644\u063A \u0627\u0644\u0645\u0641\u0648\u062A\u0631. \u0644\u0627 \u064A\u0638\u0647\u0631 \u0647\u0630\u0627 \u0627\u0644\u0642\u0633\u0645 \u0625\u0644\u0627 \u0644\u0645\u0646 \u064A\u0637\u0651\u0644\u0639 \u0639\u0644\u0649 \u0627\u0644\u0641\u0648\u0627\u062A\u064A\u0631\u060C \u0648\u0644\u0639\u0642\u062F \u0628\u0627\u0644\u062F\u064A\u0646\u0627\u0631."
              }
            }
          },
          quotes: {
            title: "\u0627\u0644\u0639\u0631\u0648\u0636 \u0627\u0644\u0645\u0627\u0644\u064A\u0629 \u0648\u0627\u0644\u0641\u0648\u0627\u062A\u064A\u0631",
            items: {
              list: {
                term: "\u0627\u0644\u0639\u0631\u0648\u0636 \u0627\u0644\u0645\u0627\u0644\u064A\u0629 \u0644\u0644\u0645\u0634\u0631\u0648\u0639",
                text: "\u062D\u062A\u0649 \u062E\u0645\u0633\u0629 \u0639\u0631\u0648\u0636 \u0645\u0627\u0644\u064A\u0629 \u0644\u0644\u0645\u0634\u0631\u0648\u0639: \u0627\u0644\u0631\u0642\u0645 (\u0631\u0627\u0628\u0637) \u0648\u0627\u0644\u0639\u0646\u0648\u0627\u0646 \u0648\u0627\u0644\u062D\u0627\u0644\u0629 (\u0645\u0633\u0648\u062F\u0629 \u0623\u0648 \u0645\u064F\u0631\u0633\u064E\u0644 \u0623\u0648 \u0645\u0642\u0628\u0648\u0644 \u0623\u0648 \u0645\u0631\u0641\u0648\u0636 \u0623\u0648 \u0645\u0646\u062A\u0647\u064A \u0627\u0644\u0635\u0644\u0627\u062D\u064A\u0629) \u0648\u0627\u0644\u0645\u0628\u0644\u063A \u062F\u0648\u0646 \u0627\u062D\u062A\u0633\u0627\u0628 \u0627\u0644\u0623\u062F\u0627\u0621\u0627\u062A."
              },
              none: {
                term: "\u0644\u0627 \u064A\u0648\u062C\u062F \u0639\u0631\u0636 \u0645\u0627\u0644\u064A \u0645\u0631\u062A\u0628\u0637 \u0628\u0647\u0630\u0627 \u0627\u0644\u0645\u0634\u0631\u0648\u0639.",
                text: "\u062A\u0638\u0647\u0631 \u0639\u0646\u062F\u0645\u0627 \u0644\u0627 \u064A\u0643\u0648\u0646 \u0644\u0644\u0645\u0634\u0631\u0648\u0639 \u0639\u0631\u0636 \u0645\u0627\u0644\u064A."
              },
              allQuotes: {
                term: "\u0643\u0644 \u0627\u0644\u0639\u0631\u0648\u0636 \u0627\u0644\u0645\u0627\u0644\u064A\u0629",
                text: "\u0631\u0627\u0628\u0637 \u0625\u0644\u0649 \u0642\u0627\u0626\u0645\u0629 \u0643\u0644 \u0627\u0644\u0639\u0631\u0648\u0636 \u0627\u0644\u0645\u0627\u0644\u064A\u0629 \u0644\u0644\u0645\u0643\u062A\u0628."
              },
              allInvoices: {
                term: "\u0643\u0644 \u0627\u0644\u0641\u0648\u0627\u062A\u064A\u0631",
                text: "\u0631\u0627\u0628\u0637 \u0625\u0644\u0649 \u0642\u0627\u0626\u0645\u0629 \u0643\u0644 \u0641\u0648\u0627\u062A\u064A\u0631 \u0627\u0644\u0645\u0643\u062A\u0628."
              }
            }
          },
          access: {
            title: "\u062D\u0642\u0648\u0642 \u0627\u0644\u0627\u0637\u0644\u0627\u0639",
            items: {
              noAccess: {
                term: "\u0627\u0644\u0645\u0627\u0644\u064A\u0629 \u063A\u064A\u0631 \u0645\u062A\u0627\u062D\u0629",
                text: "\u062A\u0638\u0647\u0631 \u0625\u0630\u0627 \u0644\u0645 \u064A\u0643\u0646 \u0644\u062F\u064A\u0643 \u062D\u0642 \u0627\u0644\u0627\u0637\u0644\u0627\u0639 \u0639\u0644\u0649 \u0627\u0644\u0645\u0639\u0644\u0648\u0645\u0627\u062A \u0627\u0644\u0645\u0627\u0644\u064A\u0629 \u0644\u0647\u0630\u0627 \u0627\u0644\u0645\u0634\u0631\u0648\u0639."
              },
              visibility: {
                term: "\u0645\u0627 \u062A\u0631\u0627\u0647",
                text: "\u062A\u062A\u0648\u0642\u0641 \u0643\u0644 \u062E\u0627\u0646\u0629 \u0639\u0644\u0649 \u062D\u0642\u0648\u0642\u0643: \u0627\u0644\u0639\u0642\u062F \u0648\u0627\u0644\u062A\u0642\u062F\u0651\u0645 \u0627\u0644\u0645\u0641\u0648\u062A\u0631 \u062B\u0645 \u0627\u0644\u0639\u0631\u0648\u0636 \u0627\u0644\u0645\u0627\u0644\u064A\u0629 \u0648\u0627\u0644\u0641\u0648\u0627\u062A\u064A\u0631 \u0644\u0627 \u062A\u0638\u0647\u0631 \u0625\u0644\u0627 \u0625\u0630\u0627 \u0643\u0627\u0646 \u0644\u0643 \u062D\u0642 \u0627\u0644\u0627\u0637\u0644\u0627\u0639 \u0639\u0644\u064A\u0647\u0627."
              }
            }
          }
        }
      },
      settings: {
        title: "\u0627\u0644\u0625\u0639\u062F\u0627\u062F\u0627\u062A",
        intro: "\u0627\u0644\u0645\u0639\u0644\u0648\u0645\u0627\u062A \u0627\u0644\u0639\u0627\u0645\u0629 \u0644\u0644\u0645\u0634\u0631\u0648\u0639 \u0648\u0623\u0639\u0636\u0627\u0624\u0647. \u064A\u0639\u062F\u0651\u0644\u0647\u0627 \u0645\u0633\u0624\u0648\u0644\u0648 \u0627\u0644\u0645\u0634\u0631\u0648\u0639 \u0648\u064A\u0637\u0651\u0644\u0639 \u0639\u0644\u064A\u0647\u0627 \u0627\u0644\u0622\u062E\u0631\u0648\u0646.",
        sections: {
          summary: {
            title: "\u0645\u0644\u062E\u0635 \u0627\u0644\u0645\u0634\u0631\u0648\u0639",
            items: {
              breadcrumb: {
                term: "\u0627\u0644\u0645\u0634\u0627\u0631\u064A\u0639",
                text: "\u0645\u0633\u0627\u0631 \u0627\u0644\u062A\u0646\u0642\u0644 \u0641\u064A \u0623\u0639\u0644\u0649 \u0627\u0644\u0635\u0641\u062D\u0629. \u0627\u0646\u0642\u0631 \u0639\u0644\u0649 \xAB\u0627\u0644\u0645\u0634\u0627\u0631\u064A\u0639\xBB \u0644\u0644\u0639\u0648\u062F\u0629 \u0625\u0644\u0649 \u0627\u0644\u0642\u0627\u0626\u0645\u0629\u061B \u0648\u0628\u062C\u0627\u0646\u0628\u0647 \u062A\u0631\u0649 \u0627\u0633\u0645 \u0627\u0644\u0645\u0634\u0631\u0648\u0639 \u0627\u0644\u0645\u0641\u062A\u0648\u062D."
              },
              meeting: {
                term: "\u0628\u062F\u0621 \u0627\u062C\u062A\u0645\u0627\u0639",
                text: "\u0632\u0631 \u0641\u064A \u0623\u0639\u0644\u0649 \u0627\u0644\u0635\u0641\u062D\u0629 \u0644\u0623\u0639\u0636\u0627\u0621 \u0627\u0644\u0645\u0634\u0631\u0648\u0639 \u0627\u0644\u0642\u0627\u062F\u0631\u064A\u0646 \u0639\u0644\u0649 \u0627\u0644\u0645\u0633\u0627\u0647\u0645\u0629. \u064A\u0637\u0644\u0628 \u0639\u0646\u0648\u0627\u0646 \u0627\u0644\u0627\u062C\u062A\u0645\u0627\u0639 \u062B\u0645 \u064A\u0641\u062A\u062D \u0642\u0627\u0639\u0629 \u0627\u0644\u0627\u062C\u062A\u0645\u0627\u0639."
              },
              code: {
                term: "\u0627\u0644\u0631\u0645\u0632",
                text: "\u0631\u0645\u0632 \u0627\u0644\u0645\u0634\u0631\u0648\u0639\u060C \u064A\u064F\u0633\u062A\u0639\u0645\u0644 \u0641\u064A \u0648\u062B\u0627\u0626\u0642\u0647 \u0648\u0641\u0648\u0627\u062A\u064A\u0631\u0647."
              },
              client: {
                term: "\u0627\u0644\u062D\u0631\u064A\u0641",
                text: "\u062D\u0631\u064A\u0641 \u0627\u0644\u0645\u0634\u0631\u0648\u0639 (\u0635\u0627\u062D\u0628 \u0627\u0644\u0645\u0634\u0631\u0648\u0639)\u060C \u0623\u0648 \xAB\u0628\u062F\u0648\u0646 \u062D\u0631\u064A\u0641\xBB \u0625\u0646 \u0644\u0645 \u064A\u064F\u062F\u062E\u064E\u0644 \u0628\u0639\u062F."
              },
              status: {
                term: "\u0627\u0644\u062D\u0627\u0644\u0629",
                text: "\u0634\u0627\u0631\u0629 \u062A\u0628\u064A\u0651\u0646 \u062D\u0627\u0644\u0629 \u0627\u0644\u0645\u0634\u0631\u0648\u0639. \u062A\u064F\u063A\u064A\u064E\u0651\u0631 \u0623\u0633\u0641\u0644 \u0627\u0644\u0635\u0641\u062D\u0629\u060C \u0641\u064A \xAB\u062D\u0627\u0644\u0629 \u0627\u0644\u0645\u0634\u0631\u0648\u0639\xBB."
              },
              progress: {
                term: "\u0627\u0644\u0645\u0631\u0627\u062D\u0644 \u0627\u0644\u0645\u063A\u0644\u0642\u0629: \u20662 / 7\u2069",
                text: "\u0634\u0631\u064A\u0637 \u062A\u0642\u062F\u0651\u0645 \u0648\u0639\u062F\u062F \u0627\u0644\u0645\u0631\u0627\u062D\u0644 \u0627\u0644\u0645\u063A\u0644\u0642\u0629\u060C \u0645\u0639 \u0627\u0644\u0645\u0631\u062D\u0644\u0629 \u0627\u0644\u062D\u0627\u0644\u064A\u0629."
              },
              tabs: {
                term: "\u0627\u0644\u0645\u0646\u0634\u0648\u0631\u0627\u062A\u060C \u0627\u0644\u0645\u0644\u0641\u0627\u062A\u060C \u0627\u0644\u0645\u0647\u0627\u0645\u060C \u0627\u0644\u0645\u0631\u0627\u062D\u0644\u060C \u0627\u0644\u0645\u062E\u0631\u062C\u0627\u062A\u060C \u0627\u0644\u062A\u0623\u0634\u064A\u0631\u0627\u062A\u060C \u0627\u0644\u0631\u0632\u0646\u0627\u0645\u0629\u060C \u0627\u0644\u0645\u0627\u0644\u064A\u0629\u060C \u0627\u0644\u0625\u0639\u062F\u0627\u062F\u0627\u062A",
                text: "\u062A\u0628\u0648\u064A\u0628\u0627\u062A \u0627\u0644\u0645\u0634\u0631\u0648\u0639. \u0623\u0646\u062A \u0627\u0644\u0622\u0646 \u0641\u064A \xAB\u0627\u0644\u0625\u0639\u062F\u0627\u062F\u0627\u062A\xBB."
              }
            }
          },
          general: {
            title: "\u0645\u0639\u0644\u0648\u0645\u0627\u062A \u0639\u0627\u0645\u0629",
            items: {
              readOnly: {
                term: "\u0644\u0627 \u064A\u0645\u0643\u0646 \u0644\u063A\u064A\u0631 \u0645\u0633\u0624\u0648\u0644\u064A \u0627\u0644\u0645\u0634\u0631\u0648\u0639 \u062A\u0639\u062F\u064A\u0644 \u0647\u0630\u0647 \u0627\u0644\u0645\u0639\u0644\u0648\u0645\u0627\u062A.",
                text: "\u0631\u0633\u0627\u0644\u0629 \u0632\u0631\u0642\u0627\u0621 \u062A\u0638\u0647\u0631 \u0644\u0644\u0623\u0639\u0636\u0627\u0621 \u0627\u0644\u0622\u062E\u0631\u064A\u0646: \u064A\u0631\u0648\u0646 \u0627\u0644\u0642\u064A\u0645 \u0646\u0635\u064B\u0651\u0627 \u062F\u0648\u0646 \u0625\u0645\u0643\u0627\u0646\u064A\u0629 \u062A\u063A\u064A\u064A\u0631\u0647\u0627."
              },
              missionType: {
                term: "\u0646\u0648\u0639 \u0627\u0644\u0645\u0647\u0645\u0629",
                text: "\u0646\u0648\u0639 \u0627\u0644\u0645\u0647\u0645\u0629 \u0627\u0644\u0645\u062E\u062A\u0627\u0631 \u0639\u0646\u062F \u0627\u0644\u0625\u0646\u0634\u0627\u0621. \u064A\u0645\u0643\u0646 \u0642\u0631\u0627\u0621\u062A\u0647 \u0648\u0644\u0627 \u064A\u0645\u0643\u0646 \u062A\u063A\u064A\u064A\u0631\u0647."
              },
              name: {
                term: "\u0627\u0633\u0645 \u0627\u0644\u0645\u0634\u0631\u0648\u0639",
                text: "\u062D\u0642\u0644 \u0625\u0644\u0632\u0627\u0645\u064A\u060C 200 \u062D\u0631\u0641 \u0639\u0644\u0649 \u0627\u0644\u0623\u0643\u062B\u0631."
              },
              code: {
                term: "\u0631\u0645\u0632 \u0627\u0644\u0645\u0634\u0631\u0648\u0639",
                text: "\u062D\u0642\u0644 \u0625\u0644\u0632\u0627\u0645\u064A\u060C 30 \u062D\u0631\u0641\u064B\u0627 \u0639\u0644\u0649 \u0627\u0644\u0623\u0643\u062B\u0631 (\u062D\u0631\u0648\u0641 \u0648\u0623\u0631\u0642\u0627\u0645 \u0648\u0627\u0644\u0631\u0645\u0648\u0632 . _ / -). \u064A\u064F\u0633\u062A\u0639\u0645\u0644 \u0641\u064A \u0648\u062B\u0627\u0626\u0642 \u0627\u0644\u0645\u0634\u0631\u0648\u0639 \u0648\u0641\u0648\u0627\u062A\u064A\u0631\u0647. \u064A\u064F\u0631\u0641\u0636 \u0631\u0645\u0632 \u064A\u0633\u062A\u0639\u0645\u0644\u0647 \u0645\u0634\u0631\u0648\u0639 \u0622\u062E\u0631."
              },
              client: {
                term: "\u0627\u0644\u062D\u0631\u064A\u0641 (\u0635\u0627\u062D\u0628 \u0627\u0644\u0645\u0634\u0631\u0648\u0639)",
                text: "\u0627\u062E\u062A\u0631 \u062D\u0631\u064A\u0641\u064B\u0627 \u0646\u0634\u0637\u064B\u0627 \u0645\u0646 \u0627\u0644\u0645\u0643\u062A\u0628\u060C \u0623\u0648 \xAB\u0628\u062F\u0648\u0646 \u062D\u0631\u064A\u0641\xBB."
              }
            }
          },
          status: {
            title: "\u062D\u0627\u0644\u0629 \u0627\u0644\u0645\u0634\u0631\u0648\u0639",
            items: {
              status: {
                term: "\u0627\u0644\u062D\u0627\u0644\u0629",
                text: "\u0644\u0627 \u062A\u0642\u062A\u0631\u062D \u0627\u0644\u0642\u0627\u0626\u0645\u0629 \u0625\u0644\u0627 \u0627\u0644\u062A\u063A\u064A\u064A\u0631\u0627\u062A \u0627\u0644\u0645\u0645\u0643\u0646\u0629 \u0627\u0646\u0637\u0644\u0627\u0642\u064B\u0627 \u0645\u0646 \u0627\u0644\u062D\u0627\u0644\u0629 \u0627\u0644\u062D\u0627\u0644\u064A\u0629. \u064A\u0634\u0631\u062D \u0627\u0644\u0646\u0635 \u062A\u062D\u062A \u0627\u0644\u062D\u0642\u0644 \u0627\u0644\u062D\u0627\u0644\u0629 \u0627\u0644\u0645\u062E\u062A\u0627\u0631\u0629."
              },
              draft: {
                term: "\u0645\u0633\u0648\u062F\u0629",
                text: "\u0627\u0644\u0645\u0634\u0631\u0648\u0639 \u0642\u064A\u062F \u0627\u0644\u0625\u0639\u062F\u0627\u062F: \u0644\u0645 \u064A\u0646\u0637\u0644\u0642 \u0628\u0639\u062F."
              },
              active: {
                term: "\u062C\u0627\u0631\u064D",
                text: "\u0627\u0644\u0645\u0634\u0631\u0648\u0639 \u062C\u0627\u0631\u064D."
              },
              onHold: {
                term: "\u0645\u062A\u0648\u0642\u0641 \u0645\u0624\u0642\u062A\u064B\u0627",
                text: "\u0627\u0644\u0645\u0634\u0631\u0648\u0639 \u0645\u062A\u0648\u0642\u0641 \u0645\u0624\u0642\u062A\u064B\u0627 \u0648\u064A\u0645\u0643\u0646\u0647 \u0627\u0644\u0627\u0633\u062A\u0626\u0646\u0627\u0641."
              },
              closed: {
                term: "\u0645\u063A\u0644\u0642",
                text: "\u0627\u0646\u062A\u0647\u062A \u0627\u0644\u0645\u0647\u0645\u0629. \u064A\u0645\u0643\u0646 \u0625\u0639\u0627\u062F\u0629 \u0641\u062A\u062D \u0627\u0644\u0645\u0634\u0631\u0648\u0639 \u0639\u0646\u062F \u0627\u0644\u062D\u0627\u062C\u0629."
              },
              archived: {
                term: "\u0645\u0624\u0631\u0634\u0641",
                text: "\u0627\u0644\u0645\u0634\u0631\u0648\u0639 \u0645\u062D\u0641\u0648\u0638 \u0641\u064A \u0627\u0644\u0623\u0631\u0634\u064A\u0641: \u0644\u0627 \u064A\u0638\u0647\u0631 \u0641\u064A \u0627\u0644\u0642\u0648\u0627\u0626\u0645 \u0625\u0644\u0627 \u0628\u062A\u0635\u0641\u064A\u0629 \xAB\u0645\u0624\u0631\u0634\u0641\xBB."
              }
            }
          },
          place: {
            title: "\u0627\u0644\u0645\u0648\u0642\u0639 \u0648\u0627\u0644\u062A\u0648\u0627\u0631\u064A\u062E",
            items: {
              governorate: {
                term: "\u0627\u0644\u0648\u0644\u0627\u064A\u0629",
                text: "\u0648\u0644\u0627\u064A\u0629 \u0627\u0644\u0645\u0634\u0631\u0648\u0639\u060C \u0623\u0648 \xAB\u063A\u064A\u0631 \u0645\u062D\u062F\u062F\u0629\xBB."
              },
              delegation: {
                term: "\u0627\u0644\u0645\u0639\u062A\u0645\u062F\u064A\u0629",
                text: "\u0627\u0644\u0645\u0639\u062A\u0645\u062F\u064A\u0629 (\u062A\u0642\u0633\u064A\u0645 \u0625\u062F\u0627\u0631\u064A \u062F\u0627\u062E\u0644 \u0627\u0644\u0648\u0644\u0627\u064A\u0629)\u060C 100 \u062D\u0631\u0641 \u0639\u0644\u0649 \u0627\u0644\u0623\u0643\u062B\u0631."
              },
              startsOn: {
                term: "\u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0627\u0646\u0637\u0644\u0627\u0642",
                text: "\u062A\u0627\u0631\u064A\u062E \u0628\u062F\u0627\u064A\u0629 \u0627\u0644\u0645\u0634\u0631\u0648\u0639."
              },
              endsOn: {
                term: "\u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0627\u0646\u062A\u0647\u0627\u0621 \u0627\u0644\u0645\u0628\u0631\u0645\u062C",
                text: "\u0644\u0627 \u064A\u0645\u0643\u0646 \u0623\u0646 \u064A\u0633\u0628\u0642 \u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0627\u0646\u0637\u0644\u0627\u0642."
              }
            }
          },
          estimate: {
            title: "\u0627\u0644\u0645\u0633\u0627\u062D\u0629 \u0648\u0627\u0644\u062A\u0642\u062F\u064A\u0631 \u0648\u0627\u0644\u0623\u062A\u0639\u0627\u0628",
            items: {
              surface: {
                term: "\u0627\u0644\u0645\u0633\u0627\u062D\u0629 (\u0645\xB2)",
                text: "\u0627\u0644\u0645\u0633\u0627\u062D\u0629 \u0627\u0644\u062C\u0645\u0644\u064A\u0629 \u0644\u0644\u0645\u0634\u0631\u0648\u0639 \u0628\u0627\u0644\u0645\u062A\u0631 \u0627\u0644\u0645\u0631\u0628\u0639: \u0639\u062F\u062F \u0635\u062D\u064A\u062D \u0644\u0627 \u064A\u0642\u0644 \u0639\u0646 \u20661\u2069."
              },
              worksCost: {
                term: "\u062A\u0642\u062F\u064A\u0631 \u0643\u0644\u0641\u0629 \u0627\u0644\u0623\u0634\u063A\u0627\u0644",
                text: "\u0627\u0644\u0643\u0644\u0641\u0629 \u0627\u0644\u0645\u0642\u062F\u0651\u0631\u0629 \u0644\u0644\u0623\u0634\u063A\u0627\u0644 \u0628\u0627\u0644\u062F\u064A\u0646\u0627\u0631 (\u2066TND\u2069)."
              },
              feeMode: {
                term: "\u0637\u0631\u064A\u0642\u0629 \u0627\u062D\u062A\u0633\u0627\u0628 \u0627\u0644\u0623\u062A\u0639\u0627\u0628",
                text: "\u0645\u0628\u0644\u063A \u062C\u0632\u0627\u0641\u064A \u0623\u0648 \u0646\u0633\u0628\u0629 \u0645\u0646 \u0643\u0644\u0641\u0629 \u0627\u0644\u0623\u0634\u063A\u0627\u0644 \u0623\u0648 \u062D\u0633\u0628 \u0627\u0644\u0648\u0642\u062A \u0627\u0644\u0645\u0633\u062A\u063A\u0631\u0642. \u0644\u0627 \u062A\u0638\u0647\u0631 \u062E\u0627\u0646\u0629 \xAB\u0627\u0644\u0623\u062A\u0639\u0627\u0628\xBB \u0647\u0630\u0647 \u0625\u0644\u0627 \u0644\u0645\u0646 \u064A\u062D\u0642 \u0644\u0647 \u0631\u0624\u064A\u0629 \u0627\u0644\u0623\u062A\u0639\u0627\u0628."
              },
              feeAmount: {
                term: "\u0645\u0628\u0644\u063A \u0627\u0644\u0623\u062A\u0639\u0627\u0628",
                text: "\u0645\u0628\u0644\u063A \u0627\u0644\u0623\u062A\u0639\u0627\u0628 \u0628\u0627\u0644\u062F\u064A\u0646\u0627\u0631 (\u2066TND\u2069)."
              }
            }
          },
          references: {
            title: "\u0627\u0644\u0645\u0631\u0627\u062C\u0639",
            items: {
              contractRef: {
                term: "\u0645\u0631\u062C\u0639 \u0627\u0644\u0639\u0642\u062F",
                text: "\u0645\u0631\u062C\u0639 \u0627\u0644\u0639\u0642\u062F \u0627\u0644\u0645\u0628\u0631\u0645 \u0645\u0639 \u0627\u0644\u062D\u0631\u064A\u0641\u060C 100 \u062D\u0631\u0641 \u0639\u0644\u0649 \u0627\u0644\u0623\u0643\u062B\u0631."
              },
              tunepsRef: {
                term: "\u0645\u0631\u062C\u0639 \u2066TUNEPS\u2069",
                text: "\u0645\u0631\u062C\u0639 \u0637\u0644\u0628 \u0627\u0644\u0639\u0631\u0648\u0636 \u0641\u064A \u0645\u0646\u0638\u0648\u0645\u0629 \u2066TUNEPS\u2069 (\u0627\u0644\u0645\u0646\u0638\u0648\u0645\u0629 \u0627\u0644\u0648\u0637\u0646\u064A\u0629 \u0644\u0644\u0634\u0631\u0627\u0621 \u0627\u0644\u0639\u0645\u0648\u0645\u064A)\u060C \u0625\u0646 \u0643\u0627\u0646\u062A \u0627\u0644\u0635\u0641\u0642\u0629 \u0639\u0645\u0648\u0645\u064A\u0629."
              },
              save: {
                term: "\u062D\u0641\u0638 \u0627\u0644\u062A\u0639\u062F\u064A\u0644\u0627\u062A",
                text: "\u064A\u062D\u0641\u0638 \u062A\u063A\u064A\u064A\u0631\u0627\u062A\u0643. \u064A\u0643\u0648\u0646 \u0627\u0644\u0632\u0631 \u0645\u0639\u0637\u0651\u0644\u064B\u0627 \u0645\u0627 \u062F\u0627\u0645 \u0644\u0645 \u064A\u062A\u063A\u064A\u0651\u0631 \u0634\u064A\u0621. \u0625\u0646 \u0639\u062F\u0651\u0644 \u0634\u062E\u0635 \u0622\u062E\u0631 \u0627\u0644\u0645\u0634\u0631\u0648\u0639 \u0641\u064A \u0627\u0644\u0623\u062B\u0646\u0627\u0621 \u064A\u064F\u0639\u0627\u062F \u062A\u062D\u0645\u064A\u0644\u0647: \u062A\u062D\u0642\u0642 \u0645\u0646 \u0627\u0644\u0642\u064A\u0645 \u062B\u0645 \u0637\u0628\u0651\u0642 \u062A\u0639\u062F\u064A\u0644\u0627\u062A\u0643 \u0645\u0646 \u062C\u062F\u064A\u062F."
              },
              reset: {
                term: "\u0625\u0644\u063A\u0627\u0621 \u0627\u0644\u062A\u0639\u062F\u064A\u0644\u0627\u062A",
                text: "\u064A\u0639\u064A\u062F \u0643\u0644 \u0627\u0644\u0642\u064A\u0645 \u0643\u0645\u0627 \u0643\u0627\u0646\u062A \u0639\u0646\u062F \u0641\u062A\u062D \u0627\u0644\u0635\u0641\u062D\u0629."
              }
            }
          },
          members: {
            title: "\u0623\u0639\u0636\u0627\u0621 \u0627\u0644\u0645\u0634\u0631\u0648\u0639",
            items: {
              intro: {
                term: "\u0623\u0639\u0636\u0627\u0621 \u0627\u0644\u0645\u0634\u0631\u0648\u0639",
                text: "\u064A\u0637\u0651\u0644\u0639 \u0627\u0644\u0623\u0639\u0636\u0627\u0621 \u0639\u0644\u0649 \u0627\u0644\u0645\u0634\u0631\u0648\u0639 \u0648\u064A\u0633\u0627\u0647\u0645\u0648\u0646 \u0641\u064A\u0647\u061B \u0648\u064A\u062A\u0648\u0644\u0649 \u0627\u0644\u0645\u0633\u0624\u0648\u0644\u0648\u0646 \u0625\u0639\u062F\u0627\u062F\u0627\u062A\u0647. \u064A\u0644\u0632\u0645 \u0645\u0633\u0624\u0648\u0644 \u0648\u0627\u062D\u062F \u0639\u0644\u0649 \u0627\u0644\u0623\u0642\u0644."
              },
              name: {
                term: "\u0627\u0644\u0627\u0633\u0645",
                text: "\u0627\u0633\u0645 \u0643\u0644 \u0634\u062E\u0635\u061B \u0648\u062A\u0634\u064A\u0631 \xAB(\u0623\u0646\u062A)\xBB \u0625\u0644\u0649 \u0627\u0633\u0645\u0643."
              },
              role: {
                term: "\u0627\u0644\u062F\u0648\u0631",
                text: "\u0645\u0633\u0624\u0648\u0644 \u0623\u0648 \u0639\u0636\u0648. \u064A\u0645\u0643\u0646 \u0644\u0644\u0645\u0633\u0624\u0648\u0644\u064A\u0646 \u062A\u063A\u064A\u064A\u0631 \u0627\u0644\u062F\u0648\u0631 \u0645\u0646 \u0627\u0644\u0642\u0627\u0626\u0645\u0629."
              },
              remove: {
                term: "\u0625\u0632\u0627\u0644\u0629",
                text: "\u0639\u0645\u0648\u062F \xAB\u0627\u0644\u0625\u062C\u0631\u0627\u0621\u0627\u062A\xBB\u060C \u0644\u0644\u0645\u0633\u0624\u0648\u0644\u064A\u0646: \u064A\u0632\u064A\u0644 \u0627\u0644\u0634\u062E\u0635 \u0645\u0646 \u0627\u0644\u0642\u0627\u0626\u0645\u0629 (\u0644\u0627 \u064A\u064F\u0637\u0628\u064E\u0651\u0642 \u0627\u0644\u062A\u063A\u064A\u064A\u0631 \u0625\u0644\u0627 \u0639\u0646\u062F \u0627\u0644\u062D\u0641\u0638)."
              },
              add: {
                term: "\u0625\u0636\u0627\u0641\u0629 \u0634\u062E\u0635 \u0645\u0646 \u0627\u0644\u0645\u0643\u062A\u0628",
                text: "\u0627\u062E\u062A\u0631 \u0634\u062E\u0635\u064B\u0627 \u0645\u0646 \u0642\u0627\u0626\u0645\u0629 \xAB\u0627\u062E\u062A\u0631 \u0634\u062E\u0635\u064B\u0627\xBB \u062B\u0645 \xAB\u0625\u0636\u0627\u0641\u0629\xBB. \u0625\u0646 \u0643\u0627\u0646 \u0627\u0644\u062C\u0645\u064A\u0639 \u0623\u0639\u0636\u0627\u0621 \u0641\u064A \u0627\u0644\u0645\u0634\u0631\u0648\u0639 \u0628\u0627\u0644\u0641\u0639\u0644 \u062A\u0642\u0648\u0644 \u0631\u0633\u0627\u0644\u0629 \u0630\u0644\u0643."
              },
              save: {
                term: "\u062D\u0641\u0638 \u0627\u0644\u0623\u0639\u0636\u0627\u0621",
                text: "\u064A\u0637\u0628\u0651\u0642 \u062A\u063A\u064A\u064A\u0631\u0627\u062A \u0627\u0644\u0642\u0627\u0626\u0645\u0629. \u064A\u062A\u062E\u0644\u0649 \xAB\u0625\u0644\u063A\u0627\u0621 \u0627\u0644\u062A\u0639\u062F\u064A\u0644\u0627\u062A\xBB \u0639\u0646\u0647\u0627."
              },
              lastManager: {
                term: "\u064A\u062C\u0628 \u0623\u0646 \u064A\u0628\u0642\u0649 \u0641\u064A \u0627\u0644\u0645\u0634\u0631\u0648\u0639 \u0645\u0633\u0624\u0648\u0644 \u0648\u0627\u062D\u062F \u0639\u0644\u0649 \u0627\u0644\u0623\u0642\u0644",
                text: "\u062A\u062D\u0630\u064A\u0631 \u0628\u0631\u062A\u0642\u0627\u0644\u064A \u0639\u0646\u062F\u0645\u0627 \u0644\u0627 \u064A\u0628\u0642\u0649 \u0623\u064A \u0645\u0633\u0624\u0648\u0644: \u0639\u064A\u0651\u0646 \u0645\u0633\u0624\u0648\u0644\u064B\u0627 \u0622\u062E\u0631 \u0642\u0628\u0644 \u0627\u0644\u062D\u0641\u0638."
              }
            }
          }
        }
      },
      overview: {
        title: "\u0646\u0638\u0631\u0629 \u0639\u0627\u0645\u0629 \u0639\u0644\u0649 \u0627\u0644\u0645\u0634\u0631\u0648\u0639",
        intro: "\u064A\u0641\u062A\u062D \u0641\u0636\u0627\u0621 \u0627\u0644\u0645\u0634\u0631\u0648\u0639 \u0627\u0644\u0645\u0634\u0631\u0648\u0639 \u0628\u0645\u0644\u0621 \u0627\u0644\u0634\u0627\u0634\u0629 \u0641\u064A \u0639\u0644\u0627\u0645\u0629 \u062A\u0628\u0648\u064A\u0628 \u062E\u0627\u0635\u0629 \u0628\u0647 \u0641\u064A \u0627\u0644\u0645\u062A\u0635\u0641\u062D. \u062A\u0644\u062E\u0635 \u0627\u0644\u0646\u0638\u0631\u0629 \u0627\u0644\u0639\u0627\u0645\u0629 \u062D\u0627\u0644\u0629 \u0627\u0644\u0645\u0634\u0631\u0648\u0639: \u0627\u0644\u062A\u0642\u062F\u0645 \u0648\u0627\u0644\u0645\u0647\u0627\u0645 \u0648\u0627\u0644\u0645\u0648\u0627\u0639\u064A\u062F \u0648\u0627\u0644\u0645\u0631\u0627\u062D\u0644 \u0648\u0627\u0644\u0628\u0637\u0627\u0642\u0629 \u0648\u0627\u0644\u0641\u0631\u064A\u0642.",
        sections: {
          navigation: {
            title: "\u0627\u0644\u062A\u0646\u0642\u0644 \u0641\u064A \u0641\u0636\u0627\u0621 \u0627\u0644\u0645\u0634\u0631\u0648\u0639",
            items: {
              open: {
                term: "\u0641\u0636\u0627\u0621 \u0627\u0644\u0645\u0634\u0631\u0648\u0639",
                text: "\u0632\u0631 \u0641\u064A \u0623\u0639\u0644\u0649 \u0635\u0641\u062D\u0629 \u0627\u0644\u0645\u0634\u0631\u0648\u0639. \u064A\u0641\u062A\u062D \u0627\u0644\u0645\u0634\u0631\u0648\u0639 \u0646\u0641\u0633\u0647 \u0628\u0645\u0644\u0621 \u0627\u0644\u0634\u0627\u0634\u0629 \u0641\u064A \u0639\u0644\u0627\u0645\u0629 \u062A\u0628\u0648\u064A\u0628 \u062C\u062F\u064A\u062F\u0629\u060C \u0639\u0644\u0649 \u0627\u0644\u0642\u0633\u0645 \u0627\u0644\u0645\u0639\u0631\u0648\u0636."
              },
              sections: {
                term: "\u0627\u0644\u0623\u0642\u0633\u0627\u0645",
                text: "\u064A\u0639\u0631\u0636 \u0627\u0644\u0639\u0645\u0648\u062F \u0627\u0644\u062C\u0627\u0646\u0628\u064A \u0623\u0642\u0633\u0627\u0645 \u0627\u0644\u0645\u0634\u0631\u0648\u0639 \u0641\u064A \u0645\u062C\u0645\u0648\u0639\u0627\u062A: \u0627\u0644\u0642\u064A\u0627\u062F\u0629 \u0648\u0627\u0644\u0648\u062B\u0627\u0626\u0642 \u0648\u0627\u0644\u062A\u0639\u0627\u0648\u0646 \u0648\u0627\u0644\u0625\u062F\u0627\u0631\u0629. \u0639\u0644\u0649 \u0627\u0644\u0634\u0627\u0634\u0629 \u0627\u0644\u0635\u063A\u064A\u0631\u0629\u060C \u0627\u0641\u062A\u062D\u0647 \u0628\u0632\u0631 \u0627\u0644\u0642\u0627\u0626\u0645\u0629 \u0628\u062C\u0627\u0646\u0628 \u0627\u0644\u0639\u0646\u0648\u0627\u0646."
              },
              back: {
                term: "\u0627\u0644\u0639\u0648\u062F\u0629 \u0625\u0644\u0649 \u0627\u0644\u0639\u0631\u0636 \u0627\u0644\u0639\u0627\u062F\u064A",
                text: "\u0631\u0627\u0628\u0637 \u0641\u064A \u0623\u0633\u0641\u0644 \u0627\u0644\u0639\u0645\u0648\u062F: \u064A\u0639\u064A\u062F \u0641\u062A\u062D \u0627\u0644\u0645\u0634\u0631\u0648\u0639 \u0628\u062A\u0628\u0648\u064A\u0628\u0627\u062A\u0647 \u0641\u064A \u0627\u0644\u062A\u0637\u0628\u064A\u0642 \u0627\u0644\u0645\u0639\u062A\u0627\u062F."
              }
            }
          },
          kpis: {
            title: "\u0627\u0644\u0623\u0631\u0642\u0627\u0645 \u0627\u0644\u0631\u0626\u064A\u0633\u064A\u0629",
            items: {
              phases: {
                term: "\u0627\u0644\u0645\u0631\u0627\u062D\u0644 \u0627\u0644\u0645\u063A\u0644\u0642\u0629",
                text: "\u0639\u062F\u062F \u0627\u0644\u0645\u0631\u0627\u062D\u0644 \u0627\u0644\u0645\u063A\u0644\u0642\u0629 \u0645\u0646 \u0627\u0644\u0645\u062C\u0645\u0648\u0639\u060C \u0645\u0639 \u0634\u0631\u064A\u0637 \u062A\u0642\u062F\u0645 \u0648\u0627\u0644\u0645\u0631\u062D\u0644\u0629 \u0627\u0644\u062C\u0627\u0631\u064A\u0629."
              },
              open: {
                term: "\u0627\u0644\u0645\u0647\u0627\u0645 \u0627\u0644\u0645\u0641\u062A\u0648\u062D\u0629",
                text: "\u0627\u0644\u0645\u0647\u0627\u0645 \u063A\u064A\u0631 \u0627\u0644\u0645\u0646\u062A\u0647\u064A\u0629\u060C \u0645\u0639 \u0639\u062F\u062F \u0627\u0644\u0645\u0647\u0627\u0645 \xAB\u0642\u064A\u062F \u0627\u0644\u0625\u0646\u062C\u0627\u0632\xBB \u0648\xAB\u0645\u062A\u0648\u0642\u0641\u0629\xBB."
              },
              late: {
                term: "\u0627\u0644\u0645\u0647\u0627\u0645 \u0627\u0644\u0645\u062A\u0623\u062E\u0631\u0629",
                text: "\u0627\u0644\u0645\u0647\u0627\u0645 \u063A\u064A\u0631 \u0627\u0644\u0645\u0646\u062A\u0647\u064A\u0629 \u0627\u0644\u062A\u064A \u062A\u062C\u0627\u0648\u0632\u062A \u0645\u0648\u0639\u062F\u0647\u0627. \u062A\u062A\u062D\u0648\u0644 \u0627\u0644\u0628\u0637\u0627\u0642\u0629 \u0625\u0644\u0649 \u0627\u0644\u0623\u062D\u0645\u0631 \u0628\u0645\u062C\u0631\u062F \u0648\u062C\u0648\u062F \u0645\u0647\u0645\u0629 \u0648\u0627\u062D\u062F\u0629."
              },
              team: {
                term: "\u0623\u0639\u0636\u0627\u0621 \u0627\u0644\u0641\u0631\u064A\u0642",
                text: "\u0639\u062F\u062F \u0623\u0639\u0636\u0627\u0621 \u0627\u0644\u0645\u0634\u0631\u0648\u0639 \u0648\u0645\u0633\u0624\u0648\u0644\u064A\u0647. \u0643\u0644 \u0628\u0637\u0627\u0642\u0629 \u062A\u0641\u062A\u062D \u0627\u0644\u0642\u0633\u0645 \u0627\u0644\u0645\u0642\u0627\u0628\u0644."
              }
            }
          },
          lists: {
            title: "\u0627\u0644\u0645\u0648\u0627\u0639\u064A\u062F \u0648\u0627\u0644\u062D\u0627\u0644\u0627\u062A \u0648\u0627\u0644\u0645\u0631\u0627\u062D\u0644",
            items: {
              deadlines: {
                term: "\u0627\u0644\u0645\u0648\u0627\u0639\u064A\u062F \u0627\u0644\u0642\u0627\u062F\u0645\u0629",
                text: "\u0627\u0644\u0645\u0647\u0627\u0645 \u0627\u0644\u0645\u0641\u062A\u0648\u062D\u0629 \u0627\u0644\u0633\u062A \u0627\u0644\u062A\u0627\u0644\u064A\u0629 \u062D\u0633\u0628 \u0627\u0644\u0645\u0648\u0639\u062F\u060C \u0645\u0639 \u062D\u0627\u0644\u062A\u0647\u0627 \u0648\u0623\u0648\u0644\u0648\u064A\u062A\u0647\u0627. \u0627\u0646\u0642\u0631 \u0639\u0644\u0649 \u0645\u0647\u0645\u0629 \u0644\u0641\u062A\u062D\u0647\u0627 \u0641\u064A \u0642\u0633\u0645 \u0627\u0644\u0645\u0647\u0627\u0645."
              },
              status: {
                term: "\u0627\u0644\u0645\u0647\u0627\u0645 \u062D\u0633\u0628 \u0627\u0644\u062D\u0627\u0644\u0629",
                text: "\u0634\u0631\u064A\u0637 \u062A\u0648\u0632\u064A\u0639 \u0648\u062C\u062F\u0648\u0644: \u0639\u062F\u062F \u0648\u0646\u0633\u0628\u0629 \u0627\u0644\u0645\u0647\u0627\u0645 \u062D\u0633\u0628 \u0627\u0644\u062D\u0627\u0644\u0629."
              },
              phases: {
                term: "\u0645\u0631\u0627\u062D\u0644 \u0627\u0644\u0645\u0634\u0631\u0648\u0639",
                text: "\u0627\u0644\u0645\u0631\u0627\u062D\u0644 \u0639\u0644\u0649 \u062E\u0637 \u0632\u0645\u0646\u064A\u060C \u0645\u0639 \u0627\u0644\u062A\u0648\u0627\u0631\u064A\u062E \u0627\u0644\u0645\u062E\u0637\u0637\u0629 \u0648\u0627\u0644\u0641\u0639\u0644\u064A\u0629 \u0648\u0623\u064A \u062A\u0623\u062E\u064A\u0631."
              }
            }
          },
          sheet: {
            title: "\u0627\u0644\u0628\u0637\u0627\u0642\u0629 \u0648\u0627\u0644\u0641\u0631\u064A\u0642",
            items: {
              facts: {
                term: "\u0628\u0637\u0627\u0642\u0629 \u0627\u0644\u0645\u0634\u0631\u0648\u0639",
                text: "\u0627\u0644\u0639\u0645\u064A\u0644 \u0648\u0646\u0648\u0639 \u0627\u0644\u0645\u0647\u0645\u0629 \u0648\u0627\u0644\u0645\u0648\u0642\u0639 \u0648\u0627\u0644\u0645\u0633\u0627\u062D\u0629 \u0648\u062A\u0642\u062F\u064A\u0631 \u0643\u0644\u0641\u0629 \u0627\u0644\u0623\u0634\u063A\u0627\u0644 \u0648\u0627\u0644\u062A\u0648\u0627\u0631\u064A\u062E \u0648\u0627\u0644\u0645\u0631\u0627\u062C\u0639. \xAB\u062A\u0639\u062F\u064A\u0644\xBB \u064A\u0641\u062A\u062D \u0627\u0644\u0625\u0639\u062F\u0627\u062F\u0627\u062A."
              },
              members: {
                term: "\u0641\u0631\u064A\u0642 \u0627\u0644\u0645\u0634\u0631\u0648\u0639",
                text: "\u0627\u0644\u0623\u0639\u0636\u0627\u0621 \u0648\u062F\u0648\u0631\u0647\u0645 (\u0645\u0633\u0624\u0648\u0644 \u0623\u0648 \u0639\u0636\u0648). \xAB\u0625\u062F\u0627\u0631\u0629 \u0627\u0644\u0623\u0639\u0636\u0627\u0621\xBB \u064A\u0641\u062A\u062D \u0627\u0644\u0625\u0639\u062F\u0627\u062F\u0627\u062A."
              }
            }
          }
        }
      }
    },
    spaceApprovals: {
      title: "\u0627\u0644\u0645\u0648\u0627\u0641\u0642\u0629 \u0639\u0644\u0649 \u0627\u0644\u0648\u0635\u0648\u0644 \u0627\u0644\u062E\u0627\u0631\u062C\u064A",
      intro: "\u0627\u0644\u0637\u0644\u0628\u0627\u062A \u0627\u0644\u0645\u0637\u0644\u0648\u0628 \u0627\u0644\u0628\u062A\u0651 \u0641\u064A\u0647\u0627 \u0639\u0646\u062F\u0645\u0627 \u064A\u064F\u062F\u0639\u0649 \u0639\u0636\u0648 \u0641\u064A \u0645\u0624\u0633\u0633\u062A\u0643 \u0625\u0644\u0649 \u0641\u0636\u0627\u0621 \u0645\u0624\u0633\u0633\u0629 \u0623\u062E\u0631\u0649. \u062A\u0634\u062A\u0631\u0637 \u0633\u064A\u0627\u0633\u062A\u0643\u0645 \u0645\u0648\u0627\u0641\u0642\u0629 \u0645\u0633\u0624\u0648\u0644 \u0642\u0628\u0644 \u0623\u0646 \u064A\u0646\u0636\u0645.",
      sections: {
        purpose: {
          title: "\u0627\u0644\u0645\u0648\u0627\u0641\u0642\u0629 \u0639\u0644\u0649 \u0627\u0644\u0648\u0635\u0648\u0644 \u0627\u0644\u062E\u0627\u0631\u062C\u064A",
          items: {
            intro: {
              term: "\u0644\u0645\u0627\u0630\u0627 \u0647\u0630\u0647 \u0627\u0644\u0635\u0641\u062D\u0629",
              text: "\u064A\u064F\u062F\u0639\u0649 \u0639\u0636\u0648 \u0641\u064A \u0645\u0624\u0633\u0633\u062A\u0643 \u0625\u0644\u0649 \u0641\u0636\u0627\u0621 \u0645\u0624\u0633\u0633\u0629 \u0623\u062E\u0631\u0649 (\u0627\u0644\u0645\u0624\u0633\u0633\u0629 \u0627\u0644\u0645\u0633\u062A\u0636\u064A\u0641\u0629). \u0645\u0627 \u062F\u0627\u0645 \u0645\u0633\u0624\u0648\u0644 \u0644\u0645 \u064A\u0648\u0627\u0641\u0642 \u0641\u0644\u0627 \u064A\u0645\u0643\u0646\u0647 \u0627\u0644\u062F\u062E\u0648\u0644 \u0625\u0644\u064A\u0647."
            },
            denied: {
              term: "\u0644\u0627 \u064A\u0645\u0643\u0646\u0643 \u0627\u062A\u062E\u0627\u0630 \u0627\u0644\u0642\u0631\u0627\u0631 \u0647\u0646\u0627",
              text: "\u0631\u0633\u0627\u0644\u0629 \u062A\u0638\u0647\u0631 \u0644\u0645\u0646 \u0644\u064A\u0633 \u0644\u0647 \u062D\u0642 \u0627\u0644\u0645\u0648\u0627\u0641\u0642\u0629 \u0639\u0644\u0649 \u0627\u0644\u0648\u0635\u0648\u0644 \u0627\u0644\u062E\u0627\u0631\u062C\u064A: \u0644\u0627 \u064A\u0631\u0649 \u0647\u0630\u0647 \u0627\u0644\u0637\u0644\u0628\u0627\u062A \u0625\u0644\u0627 \u0627\u0644\u0645\u0633\u0624\u0648\u0644\u0648\u0646 \u0627\u0644\u0645\u062E\u0648\u064E\u0651\u0644\u0648\u0646."
            }
          }
        },
        requests: {
          title: "\u0637\u0644\u0628\u0627\u062A \u0644\u0644\u0645\u0648\u0627\u0641\u0642\u0629",
          items: {
            person: {
              term: "\u0627\u0633\u0645 \u0627\u0644\u0634\u062E\u0635",
              text: "\u0627\u0644\u0634\u062E\u0635 \u0627\u0644\u0645\u062F\u0639\u0648\u060C \u0623\u0648 \u0628\u0631\u064A\u062F\u0647 \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A \u0625\u0646 \u0644\u0645 \u064A\u0643\u0646 \u0627\u0633\u0645\u0647 \u0645\u0639\u0631\u0648\u0641\u064B\u0627."
            },
            kind: {
              term: "\u062F\u0639\u0648\u0629 \u0634\u062E\u0635\u064A\u0629\u060C \u0636\u064A\u0641\u060C \u0645\u0624\u0633\u0633\u0629",
              text: "\u062A\u0628\u064A\u0651\u0646 \u0627\u0644\u0634\u0627\u0631\u0629 \u0627\u0644\u0628\u0631\u062A\u0642\u0627\u0644\u064A\u0629 \u0646\u0648\u0639 \u0627\u0644\u0637\u0644\u0628: \u062F\u0639\u0648\u0629 \u0625\u0644\u0649 \u0634\u062E\u0635 \u0645\u0639\u064A\u0651\u0646\u060C \u0623\u0648 \u0636\u064A\u0641 \u0645\u0646 \u062E\u0627\u0631\u062C \u0627\u0644\u0645\u0624\u0633\u0633\u0629\u060C \u0623\u0648 \u0645\u0624\u0633\u0633\u0629."
            },
            email: {
              term: "\u0627\u0644\u0628\u0631\u064A\u062F \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A",
              text: "\u0639\u0646\u0648\u0627\u0646 \u0627\u0644\u0634\u062E\u0635 \u0627\u0644\u0645\u062F\u0639\u0648."
            },
            space: {
              term: "\u0627\u0644\u0641\u0636\u0627\u0621 \u2026 \u0627\u0644\u0630\u064A \u062A\u0633\u062A\u0636\u064A\u0641\u0647 \u2026",
              text: "\u0627\u0633\u0645 \u0627\u0644\u0641\u0636\u0627\u0621 \u0627\u0644\u0645\u0634\u062A\u0631\u0643 \u0648\u0627\u0644\u0645\u0624\u0633\u0633\u0629 \u0627\u0644\u062A\u064A \u062A\u0633\u062A\u0636\u064A\u0641\u0647."
            },
            rights: {
              term: "\u0627\u0644\u0635\u0644\u0627\u062D\u064A\u0627\u062A",
              text: "\u0645\u0627 \u0633\u064A\u062A\u0645\u0643\u0651\u0646 \u0627\u0644\u0634\u062E\u0635 \u0645\u0646 \u0641\u0639\u0644\u0647: \u0644\u0644\u0642\u0631\u0627\u0621\u0629 \u0641\u0642\u0637\u060C \u0623\u0648 \u0627\u0644\u0642\u0631\u0627\u0621\u0629 \u0648\u0627\u0644\u0643\u062A\u0627\u0628\u0629\u060C \u0623\u0648 \u0627\u0644\u0642\u0631\u0627\u0621\u0629 \u0648\u0627\u0644\u0643\u062A\u0627\u0628\u0629 \u0648\u0627\u0644\u0645\u0635\u0627\u062F\u0642\u0629."
            },
            invitedBy: {
              term: "\u062F\u0639\u0627\u0647",
              text: "\u0627\u0644\u0634\u062E\u0635 \u0627\u0644\u0630\u064A \u0623\u0631\u0633\u0644 \u0627\u0644\u062F\u0639\u0648\u0629\u060C \u0639\u0646\u062F\u0645\u0627 \u064A\u0643\u0648\u0646 \u0645\u0639\u0631\u0648\u0641\u064B\u0627."
            },
            requestedOn: {
              term: "\u0637\u064F\u0644\u0628 \u0641\u064A",
              text: "\u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0637\u0644\u0628."
            },
            answerBefore: {
              term: "\u0644\u0644\u0645\u0639\u0627\u0644\u062C\u0629 \u0642\u0628\u0644",
              text: "\u0627\u0644\u0623\u062C\u0644 \u0627\u0644\u0623\u0642\u0635\u0649 \u0644\u0644\u0631\u062F."
            }
          }
        },
        answers: {
          title: "\u0627\u0644\u0631\u062F \u0639\u0644\u0649 \u0637\u0644\u0628",
          items: {
            approve: {
              term: "\u0645\u0648\u0627\u0641\u0642\u0629",
              text: "\u064A\u0633\u0645\u062D \u0644\u0644\u0634\u062E\u0635 \u0628\u0627\u0644\u0627\u0646\u0636\u0645\u0627\u0645 \u0625\u0644\u0649 \u0627\u0644\u0641\u0636\u0627\u0621. \u0648\u062A\u064F\u0628\u0644\u064E\u0651\u063A \u0627\u0644\u0645\u0624\u0633\u0633\u0629 \u0627\u0644\u0645\u0633\u062A\u0636\u064A\u0641\u0629 \u0628\u0630\u0644\u0643."
            },
            refuse: {
              term: "\u0631\u0641\u0636",
              text: "\u064A\u0641\u062A\u062D \u0646\u0627\u0641\u0630\u0629 \u062A\u0623\u0643\u064A\u062F: \xAB\u0631\u0641\u0636 \u0648\u0635\u0648\u0644 \u2026\u061F\xBB. \u0644\u0646 \u064A\u0646\u0636\u0645 \u0627\u0644\u0634\u062E\u0635 \u0625\u0644\u0649 \u0627\u0644\u0641\u0636\u0627\u0621\u060C \u0648\u064A\u0645\u0643\u0646 \u0644\u0644\u0645\u0624\u0633\u0633\u0629 \u0627\u0644\u0645\u0633\u062A\u0636\u064A\u0641\u0629 \u062F\u0639\u0648\u062A\u0647 \u0645\u0646 \u062C\u062F\u064A\u062F."
            }
          }
        },
        states: {
          title: "\u0631\u0633\u0627\u0626\u0644 \u0627\u0644\u062D\u0627\u0644\u0629",
          items: {
            empty: {
              term: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0637\u0644\u0628\u0627\u062A \u0644\u0644\u0645\u0648\u0627\u0641\u0642\u0629",
              text: "\u062A\u0638\u0647\u0631 \u0639\u0646\u062F\u0645\u0627 \u0644\u0627 \u064A\u0646\u062A\u0638\u0631 \u0623\u064A \u0637\u0644\u0628. \u064A\u0638\u0647\u0631 \u0627\u0644\u0637\u0644\u0628 \u0627\u0644\u062C\u062F\u064A\u062F \u0647\u0646\u0627 \u0628\u0645\u062C\u0631\u062F \u062F\u0639\u0648\u0629 \u0639\u0636\u0648 \u0625\u0644\u0649 \u0641\u0636\u0627\u0621 \u0645\u0624\u0633\u0633\u0629 \u0623\u062E\u0631\u0649."
            },
            loadFailed: {
              term: "\u062A\u0639\u0630\u0651\u0631 \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0637\u0644\u0628\u0627\u062A",
              text: "\u0631\u0633\u0627\u0644\u0629 \u062D\u0645\u0631\u0627\u0621 \u0639\u0646\u062F \u0645\u0634\u0643\u0644\u0629 \u0641\u064A \u0627\u0644\u0627\u062A\u0635\u0627\u0644: \u062A\u062D\u0642\u0642 \u0645\u0646\u0647 \u062B\u0645 \u0627\u0646\u0642\u0631 \u0639\u0644\u0649 \xAB\u0625\u0639\u0627\u062F\u0629 \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629\xBB."
            }
          }
        }
      }
    },
    partnerships: {
      title: "\u0627\u0644\u0634\u0631\u0627\u0643\u0627\u062A",
      intro: "\u0641\u0636\u0627\u0621\u0627\u062A \u0627\u0644\u0645\u0624\u0633\u0633\u0627\u062A \u0627\u0644\u0623\u062E\u0631\u0649 \u0627\u0644\u062A\u064A \u062A\u064F\u062F\u0639\u0649 \u0625\u0644\u064A\u0647\u0627 \u0645\u0624\u0633\u0633\u062A\u0643 \u0623\u0648 \u062A\u0634\u0627\u0631\u0643 \u0641\u064A\u0647\u0627. \u0647\u0630\u0647 \u0627\u0644\u0635\u0641\u062D\u0629 \u0645\u062E\u0635\u0635\u0629 \u0644\u0644\u0645\u0627\u0644\u0643\u064A\u0646 \u0648\u0627\u0644\u0645\u0633\u0624\u0648\u0644\u064A\u0646.",
      sections: {
        requests: {
          title: "\u0637\u0644\u0628\u0627\u062A \u0627\u0644\u0634\u0631\u0627\u0643\u0629",
          items: {
            description: {
              term: "\u0627\u0642\u0628\u0644 \u0644\u062A\u0646\u0636\u0645 \u0645\u0624\u0633\u0633\u062A\u0643 \u0625\u0644\u0649 \u0627\u0644\u0641\u0636\u0627\u0621",
              text: "\u0628\u0639\u062F \u0642\u0628\u0648\u0644 \u0627\u0644\u0637\u0644\u0628 \u062A\u062E\u062A\u0627\u0631 \u0645\u0646 \u064A\u0635\u0644 \u0625\u0644\u0649 \u0627\u0644\u0641\u0636\u0627\u0621 \u0645\u0646 \u0623\u0634\u062E\u0627\u0635 \u0645\u0624\u0633\u0633\u062A\u0643."
            },
            host: {
              term: "\u0627\u0644\u0645\u0624\u0633\u0633\u0629 \u0627\u0644\u0645\u0633\u062A\u0636\u064A\u0641\u0629",
              text: "\u064A\u0639\u0631\u0636 \u0643\u0644 \u0633\u0637\u0631 \u0634\u0639\u0627\u0631 \u0627\u0644\u0645\u0624\u0633\u0633\u0629 \u0627\u0644\u062A\u064A \u062A\u0633\u062A\u0636\u064A\u0641 \u0627\u0644\u0641\u0636\u0627\u0621 \u0648\u0627\u0633\u0645\u0647\u0627\u060C \u0645\u0639 \u0634\u0627\u0631\u0629 \xAB\u0628\u0627\u0646\u062A\u0638\u0627\u0631 \u0627\u0644\u0631\u062F\xBB."
            },
            accept: {
              term: "\u0642\u0628\u0648\u0644",
              text: "\u062A\u0635\u0628\u062D \u0645\u0624\u0633\u0633\u062A\u0643 \u0634\u0631\u064A\u0643\u0629 \u0641\u064A \u0627\u0644\u0641\u0636\u0627\u0621."
            },
            decline: {
              term: "\u0631\u0641\u0636",
              text: "\u064A\u0641\u062A\u062D \u062A\u0623\u0643\u064A\u062F\u064B\u0627 \xAB\u0631\u0641\u0636 \u0627\u0644\u062F\u0639\u0648\u0629 \u0625\u0644\u0649 \u0627\u0644\u0641\u0636\u0627\u0621 \u2026\u061F\xBB. \u0644\u0646 \u062A\u0646\u0636\u0645 \u0645\u0624\u0633\u0633\u062A\u0643 \u0625\u0644\u0649 \u0627\u0644\u0641\u0636\u0627\u0621\u060C \u0648\u064A\u0645\u0643\u0646 \u0644\u0644\u0645\u0624\u0633\u0633\u0629 \u0627\u0644\u0645\u0633\u062A\u0636\u064A\u0641\u0629 \u062F\u0639\u0648\u062A\u0647\u0627 \u0645\u0646 \u062C\u062F\u064A\u062F."
            },
            none: {
              term: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0637\u0644\u0628\u0627\u062A \u0645\u0639\u0644\u0651\u0642\u0629.",
              text: "\u062A\u0638\u0647\u0631 \u0639\u0646\u062F\u0645\u0627 \u0644\u0627 \u064A\u0648\u062C\u062F \u0645\u0627 \u064A\u0633\u062A\u062F\u0639\u064A \u0627\u0644\u0631\u062F."
            }
          }
        },
        active: {
          title: "\u0627\u0644\u0634\u0631\u0627\u0643\u0627\u062A \u0627\u0644\u0646\u0634\u0637\u0629",
          items: {
            description: {
              term: "\u0627\u0644\u0634\u0631\u0627\u0643\u0627\u062A \u0627\u0644\u0646\u0634\u0637\u0629",
              text: "\u0627\u0644\u0641\u0636\u0627\u0621\u0627\u062A \u0627\u0644\u062A\u064A \u062A\u0634\u0627\u0631\u0643 \u0641\u064A\u0647\u0627 \u0645\u0624\u0633\u0633\u062A\u0643. \u0627\u0641\u062A\u062D \u0623\u062D\u062F\u0647\u0627 \u0644\u0625\u062F\u0627\u0631\u0629 \u0645\u0646\u062F\u0648\u0628\u064A \u0645\u0624\u0633\u0633\u062A\u0643."
            },
            status: {
              term: "\u0646\u0634\u0637\u0629",
              text: "\u0634\u0627\u0631\u0629 \u062E\u0636\u0631\u0627\u0621: \u0627\u0644\u0634\u0631\u0627\u0643\u0629 \u0642\u0627\u0626\u0645\u0629."
            },
            manage: {
              term: "\u0625\u062F\u0627\u0631\u0629 \u0645\u0646\u062F\u0648\u0628\u064A \u0645\u0624\u0633\u0633\u062A\u064A",
              text: "\u064A\u0641\u062A\u062D \u0627\u0644\u0641\u0636\u0627\u0621 \u0639\u0644\u0649 \u062A\u0628\u0648\u064A\u0628 \u0627\u0644\u0645\u0646\u062F\u0648\u0628\u064A\u0646: \u0623\u0634\u062E\u0627\u0635 \u0645\u0624\u0633\u0633\u062A\u0643 \u0627\u0644\u0630\u064A\u0646 \u0644\u0647\u0645 \u062D\u0642 \u0627\u0644\u0648\u0635\u0648\u0644 \u0625\u0644\u064A\u0647."
            },
            none: {
              term: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0634\u0631\u0627\u0643\u0627\u062A \u0646\u0634\u0637\u0629.",
              text: "\u062A\u0638\u0647\u0631 \u0639\u0646\u062F\u0645\u0627 \u0644\u0627 \u064A\u0643\u0648\u0646 \u0623\u064A \u0641\u0636\u0627\u0621 \u0646\u0634\u0637\u064B\u0627."
            }
          }
        },
        ended: {
          title: "\u0627\u0644\u0634\u0631\u0627\u0643\u0627\u062A \u0627\u0644\u0645\u0646\u062A\u0647\u064A\u0629",
          items: {
            declined: {
              term: "\u0645\u0631\u0641\u0648\u0636\u0629",
              text: "\u0631\u0641\u0636\u062A \u0627\u0644\u062F\u0639\u0648\u0629."
            },
            expired: {
              term: "\u0645\u0646\u062A\u0647\u064A\u0629",
              text: "\u0628\u0644\u063A\u062A \u0627\u0644\u0634\u0631\u0627\u0643\u0629 \u062A\u0627\u0631\u064A\u062E \u0646\u0647\u0627\u064A\u062A\u0647\u0627."
            },
            revoked: {
              term: "\u0645\u0633\u062D\u0648\u0628\u0629",
              text: "\u0633\u062D\u0628\u062A \u0627\u0644\u0645\u0624\u0633\u0633\u0629 \u0627\u0644\u0645\u0633\u062A\u0636\u064A\u0641\u0629 \u0645\u0624\u0633\u0633\u062A\u0643 \u0645\u0646 \u0627\u0644\u0641\u0636\u0627\u0621."
            },
            visibility: {
              term: "\u0627\u0644\u0634\u0631\u0627\u0643\u0627\u062A \u0627\u0644\u0645\u0646\u062A\u0647\u064A\u0629",
              text: "\u0644\u0627 \u062A\u0638\u0647\u0631 \u0647\u0630\u0647 \u0627\u0644\u062E\u0627\u0646\u0629 \u0625\u0644\u0627 \u0625\u0630\u0627 \u0648\u064F\u062C\u062F\u062A \u0634\u0631\u0627\u0643\u0629 \u0645\u0646\u062A\u0647\u064A\u0629 \u0648\u0627\u062D\u062F\u0629 \u0639\u0644\u0649 \u0627\u0644\u0623\u0642\u0644\u061B \u0648\u0647\u064A \u0644\u0644\u0642\u0631\u0627\u0621\u0629 \u0641\u0642\u0637."
            }
          }
        },
        details: {
          title: "\u062A\u0641\u0627\u0635\u064A\u0644 \u0633\u0637\u0631",
          items: {
            space: {
              term: "\u0627\u0644\u0641\u0636\u0627\u0621",
              text: "\u0627\u0633\u0645 \u0627\u0644\u0641\u0636\u0627\u0621 \u0627\u0644\u0645\u0634\u062A\u0631\u0643."
            },
            scope: {
              term: "\u0643\u0644 \u0627\u0644\u0641\u0636\u0627\u0621",
              text: "\u0645\u0627 \u062A\u0634\u0645\u0644\u0647 \u0627\u0644\u0634\u0631\u0627\u0643\u0629: \xAB\u0643\u0644 \u0627\u0644\u0641\u0636\u0627\u0621\xBB \u0623\u0648 \xAB\u0627\u0644\u0645\u062C\u0644\u062F\u0627\u062A: \u20662\u2069 \xB7 \u0627\u0644\u0642\u0646\u0648\u0627\u062A: \u20661\u2069\xBB \u0639\u0646\u062F\u0645\u0627 \u0644\u0627 \u062A\u064F\u0641\u062A\u062D \u0625\u0644\u0627 \u0628\u0639\u0636 \u0627\u0644\u0645\u062C\u0644\u062F\u0627\u062A \u0648\u0627\u0644\u0642\u0646\u0648\u0627\u062A."
            },
            rights: {
              term: "\u0627\u0644\u0635\u0644\u0627\u062D\u064A\u0627\u062A",
              text: "\u0644\u0644\u0642\u0631\u0627\u0621\u0629 \u0641\u0642\u0637\u060C \u0623\u0648 \u0627\u0644\u0642\u0631\u0627\u0621\u0629 \u0648\u0627\u0644\u0643\u062A\u0627\u0628\u0629\u060C \u0623\u0648 \u0627\u0644\u0642\u0631\u0627\u0621\u0629 \u0648\u0627\u0644\u0643\u062A\u0627\u0628\u0629 \u0648\u0627\u0644\u0645\u0635\u0627\u062F\u0642\u0629."
            },
            people: {
              term: "\u0627\u0644\u0623\u0634\u062E\u0627\u0635",
              text: "\u0639\u062F\u062F \u0623\u0634\u062E\u0627\u0635 \u0645\u0624\u0633\u0633\u062A\u0643 \u0627\u0644\u0630\u064A\u0646 \u0644\u0647\u0645 \u062D\u0642 \u0627\u0644\u0648\u0635\u0648\u0644 \u0645\u0646 \u0627\u0644\u062D\u062F \u0627\u0644\u0623\u0642\u0635\u0649 \u0627\u0644\u0645\u0633\u0645\u0648\u062D\u060C \u0645\u062B\u0644 \xAB\u20663/10\u2069\xBB."
            },
            until: {
              term: "\u062D\u062A\u0649",
              text: "\u062A\u0627\u0631\u064A\u062E \u0646\u0647\u0627\u064A\u0629 \u0627\u0644\u0634\u0631\u0627\u0643\u0629\u060C \u0623\u0648 \xAB\u0628\u062F\u0648\u0646 \u062A\u0627\u0631\u064A\u062E \u0627\u0646\u062A\u0647\u0627\u0621\xBB."
            }
          }
        },
        states: {
          title: "\u0631\u0633\u0627\u0626\u0644 \u0627\u0644\u062D\u0627\u0644\u0629",
          items: {
            empty: {
              term: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0634\u0631\u0627\u0643\u0627\u062A",
              text: "\u062A\u0638\u0647\u0631 \u0639\u0646\u062F\u0645\u0627 \u0644\u0627 \u062A\u0643\u0648\u0646 \u0623\u064A \u0645\u0624\u0633\u0633\u0629 \u0642\u062F \u062F\u0639\u062A\u0643 \u0628\u0639\u062F. \u064A\u0638\u0647\u0631 \u0627\u0644\u0637\u0644\u0628 \u0647\u0646\u0627 \u0628\u0645\u062C\u0631\u062F \u0623\u0646 \u062A\u062F\u0639\u0648\u0643 \u0645\u0624\u0633\u0633\u0629 \u0623\u062E\u0631\u0649 \u0625\u0644\u0649 \u0645\u0634\u0627\u0631\u0643\u0629 \u0641\u0636\u0627\u0621."
            },
            loadFailed: {
              term: "\u062A\u0639\u0630\u0651\u0631 \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0634\u0631\u0627\u0643\u0627\u062A",
              text: "\u0631\u0633\u0627\u0644\u0629 \u062D\u0645\u0631\u0627\u0621 \u0639\u0646\u062F \u0645\u0634\u0643\u0644\u0629 \u0641\u064A \u0627\u0644\u0627\u062A\u0635\u0627\u0644: \u062A\u062D\u0642\u0642 \u0645\u0646\u0647 \u062B\u0645 \u0627\u0646\u0642\u0631 \u0639\u0644\u0649 \xAB\u0625\u0639\u0627\u062F\u0629 \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629\xBB."
            }
          }
        }
      }
    },
    home: {
      title: "\u0627\u0644\u062A\u0646\u0642\u0644 \u0641\u064A \u2066BatiFlow\u2069",
      intro: "\u064A\u0634\u0631\u062D \u0647\u0630\u0627 \u0627\u0644\u062F\u0644\u064A\u0644 \u0627\u0644\u0625\u0637\u0627\u0631 \u0627\u0644\u0630\u064A \u064A\u062D\u064A\u0637 \u0628\u0643\u0644 \u0635\u0641\u062D\u0627\u062A \u2066BatiFlow\u2069: \u0634\u0631\u064A\u0637 \u0627\u0644\u062A\u0637\u0628\u064A\u0642\u0627\u062A \u0648\u0627\u0644\u0631\u0623\u0633 \u0648\u0627\u0644\u0625\u0634\u0639\u0627\u0631\u0627\u062A \u0648\u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u062D\u0633\u0627\u0628 \u0648\u0627\u0644\u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u064A\u0633\u0631\u0649 \u0648\u0627\u0644\u0644\u0648\u062D\u0629 \u0627\u0644\u064A\u0645\u0646\u0649 \u0648\u0627\u062E\u062A\u0635\u0627\u0631\u0627\u062A \u0644\u0648\u062D\u0629 \u0627\u0644\u0645\u0641\u0627\u062A\u064A\u062D.",
      sections: {
        appBar: {
          title: "\u0627\u0644\u062A\u0637\u0628\u064A\u0642\u0627\u062A",
          items: {
            activity: {
              term: "\u0627\u0644\u0646\u0634\u0627\u0637",
              text: "\u0625\u0634\u0639\u0627\u0631\u0627\u062A\u0643: \u0627\u0644\u0625\u0634\u0627\u0631\u0627\u062A \u0625\u0644\u064A\u0643 \u0648\u0627\u0644\u0645\u0647\u0627\u0645 \u0627\u0644\u0645\u0633\u0646\u062F\u0629 \u0625\u0644\u064A\u0643 \u0648\u0637\u0644\u0628\u0627\u062A \u0627\u0644\u062A\u0623\u0634\u064A\u0631\u0629. \u0627\u0644\u0627\u062E\u062A\u0635\u0627\u0631: \u2066Alt+1\u2069."
            },
            chat: {
              term: "\u0627\u0644\u0645\u062D\u0627\u062F\u062B\u0629",
              text: "\u0627\u0644\u0646\u0642\u0627\u0634\u0627\u062A \u0645\u0639 \u0632\u0645\u0644\u0627\u0626\u0643 \u0648\u0642\u0646\u0648\u0627\u062A \u0645\u0634\u0627\u0631\u064A\u0639\u0643. \u0627\u0644\u0627\u062E\u062A\u0635\u0627\u0631: \u2066Alt+2\u2069."
            },
            projects: {
              term: "\u0627\u0644\u0645\u0634\u0627\u0631\u064A\u0639",
              text: "\u0642\u0627\u0626\u0645\u0629 \u0645\u0634\u0627\u0631\u064A\u0639\u0643 \u0648\u0645\u062A\u0627\u0628\u0639\u062A\u0647\u0627. \u0627\u0644\u0627\u062E\u062A\u0635\u0627\u0631: \u2066Alt+3\u2069."
            },
            calendar: {
              term: "\u0627\u0644\u062A\u0642\u0648\u064A\u0645",
              text: "\u0627\u062C\u062A\u0645\u0627\u0639\u0627\u062A\u0643 \u0648\u0632\u064A\u0627\u0631\u0627\u062A \u0627\u0644\u0648\u0631\u0634\u0627\u062A \u0648\u0622\u062C\u0627\u0644\u0643. \u0627\u0644\u0627\u062E\u062A\u0635\u0627\u0631: \u2066Alt+4\u2069."
            },
            files: {
              term: "\u0627\u0644\u0645\u0644\u0641\u0627\u062A",
              text: "\u0642\u0633\u0645 \u0645\u0644\u0641\u0627\u062A \u0627\u0644\u0645\u0624\u0633\u0633\u0629. \u0627\u0644\u0627\u062E\u062A\u0635\u0627\u0631: \u2066Alt+5\u2069."
            },
            finance: {
              term: "\u0627\u0644\u0645\u0627\u0644\u064A\u0629",
              text: "\u0627\u0644\u0639\u0631\u0648\u0636 \u0627\u0644\u0645\u0627\u0644\u064A\u0629 \u0648\u0627\u0644\u0641\u0648\u0627\u062A\u064A\u0631 \u0648\u0627\u0644\u0645\u062A\u0627\u0628\u0639\u0629 \u0627\u0644\u0645\u0627\u0644\u064A\u0629. \u0627\u0644\u0627\u062E\u062A\u0635\u0627\u0631: \u2066Alt+6\u2069."
            },
            more: {
              term: "\u0627\u0644\u0645\u0632\u064A\u062F",
              text: "\u0627\u0644\u062D\u0631\u0641\u0627\u0621 \u0648\u0627\u0644\u0634\u0631\u0627\u0643\u0627\u062A \u0648\u0625\u062F\u0627\u0631\u0629 \u0645\u0643\u062A\u0628\u0643. \u0627\u0644\u0627\u062E\u062A\u0635\u0627\u0631: \u2066Alt+7\u2069."
            },
            phone: {
              term: "\u0639\u0644\u0649 \u0627\u0644\u0647\u0627\u062A\u0641 \u0648\u0627\u0644\u0634\u0627\u0634\u0627\u062A \u0627\u0644\u0635\u063A\u064A\u0631\u0629",
              text: "\u0639\u0644\u0649 \u0627\u0644\u0647\u0627\u062A\u0641 \u064A\u0646\u062A\u0642\u0644 \u0627\u0644\u0634\u0631\u064A\u0637 \u0625\u0644\u0649 \u0623\u0633\u0641\u0644 \u0627\u0644\u0634\u0627\u0634\u0629 \u0648\u0644\u0627 \u064A\u062D\u062A\u0641\u0638 \u0625\u0644\u0627 \u0628\u0640 \u0627\u0644\u0646\u0634\u0627\u0637 \u0648\u0627\u0644\u0645\u062D\u0627\u062F\u062B\u0629 \u0648\u0627\u0644\u0645\u0634\u0627\u0631\u064A\u0639 \u0648\u0627\u0644\u062A\u0642\u0648\u064A\u0645 \u0648\u0627\u0644\u0645\u0632\u064A\u062F. \u0639\u0644\u0649 \u0627\u0644\u0644\u0648\u062D\u0629 \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A\u0629 \u062A\u0638\u0647\u0631 \u0627\u0644\u0623\u064A\u0642\u0648\u0646\u0627\u062A \u0641\u0642\u0637. \u064A\u064F\u0645\u064A\u064E\u0651\u0632 \u0627\u0644\u062A\u0637\u0628\u064A\u0642 \u0627\u0644\u0645\u0641\u062A\u0648\u062D \u0628\u062E\u0637 \u0645\u0644\u0648\u0651\u0646\u060C \u0648\u064A\u0634\u064A\u0631 \u0639\u062F\u0651\u0627\u062F \u0625\u0644\u0649 \u0627\u0644\u0645\u0633\u062A\u062C\u062F\u0627\u062A."
            }
          }
        },
        header: {
          title: "\u0627\u0644\u0631\u0623\u0633",
          items: {
            logo: {
              term: "\u0634\u0639\u0627\u0631 \u2066BatiFlow\u2069",
              text: "\u0627\u0633\u0645 \u0627\u0644\u0645\u0646\u062A\u062C \u0641\u064A \u0623\u0639\u0644\u0649 \u0627\u0644\u0634\u0627\u0634\u0629 \u0645\u0646 \u062C\u0647\u0629 \u0627\u0644\u064A\u0633\u0627\u0631\u060C \u062D\u062A\u0649 \u0641\u064A \u0627\u0644\u0639\u0631\u0628\u064A\u0629."
            },
            search: {
              term: "\u0627\u0628\u062D\u062B \u0641\u064A \u0627\u0644\u0645\u0634\u0627\u0631\u064A\u0639 \u0648\u0627\u0644\u0645\u0644\u0641\u0627\u062A \u0648\u0627\u0644\u0631\u0633\u0627\u0626\u0644\u2026",
              text: "\u064A\u0641\u062A\u062D \u0627\u0644\u0628\u062D\u062B \u0627\u0644\u0633\u0631\u064A\u0639 \u0641\u064A \u0643\u0627\u0645\u0644 \u0627\u0644\u0645\u0624\u0633\u0633\u0629. \u064A\u0645\u0643\u0646\u0643 \u0623\u064A\u0636\u064B\u0627 \u0627\u0644\u0636\u063A\u0637 \u0639\u0644\u0649 \u2066Ctrl+K\u2069 \u0623\u0648 \u0639\u0644\u0649 \u0627\u0644\u0645\u0641\u062A\u0627\u062D \u2066/\u2069. \u0639\u0644\u0649 \u0627\u0644\u0647\u0627\u062A\u0641 \u064A\u0635\u0628\u062D \u0639\u062F\u0633\u0629 \u0635\u063A\u064A\u0631\u0629 (\u0641\u062A\u062D \u0627\u0644\u0628\u062D\u062B)."
            },
            orgSwitcher: {
              term: "\u062A\u063A\u064A\u064A\u0631 \u0627\u0644\u0645\u0624\u0633\u0633\u0629",
              text: "\u064A\u0639\u0631\u0636 \u0627\u0633\u0645 \u0627\u0644\u0645\u0624\u0633\u0633\u0629 \u0627\u0644\u0646\u0634\u0637\u0629. \u0625\u0630\u0627 \u0643\u0646\u062A \u062A\u0646\u062A\u0645\u064A \u0625\u0644\u0649 \u0639\u062F\u0629 \u0645\u0643\u0627\u062A\u0628 \u0641\u0627\u062E\u062A\u0631 \u0623\u062D\u062F\u0647\u0627 \u0645\u0646 \u0627\u0644\u0642\u0627\u0626\u0645\u0629: \u0633\u062A\u0635\u0644 \u0625\u0644\u0649 \u0635\u0641\u062D\u0629 \u0627\u0644\u0646\u0634\u0627\u0637 \u0627\u0644\u062E\u0627\u0635\u0629 \u0628\u0647."
            },
            externalSpaces: {
              term: "\u0627\u0644\u0641\u0636\u0627\u0621\u0627\u062A \u0627\u0644\u062E\u0627\u0631\u062C\u064A\u0629",
              text: "\u0641\u064A \u0627\u0644\u0642\u0627\u0626\u0645\u0629 \u0646\u0641\u0633\u0647\u0627: \u0627\u0644\u0641\u0636\u0627\u0621\u0627\u062A \u0627\u0644\u062A\u064A \u062A\u0634\u0627\u0631\u0643\u0647\u0627 \u0645\u0639\u0643 \u0645\u0624\u0633\u0633\u0627\u062A \u0623\u062E\u0631\u0649. \u064A\u0634\u064A\u0631 \u0627\u0644\u0631\u0642\u0645 \u0628\u064A\u0646 \u0627\u0644\u0642\u0648\u0633\u064A\u0646 \u0625\u0644\u0649 \u0639\u062F\u062F\u0647\u0627."
            },
            notifications: {
              term: "\u0627\u0644\u0625\u0634\u0639\u0627\u0631\u0627\u062A",
              text: "\u0627\u0644\u062C\u0631\u0633. \u064A\u0634\u064A\u0631 \u0639\u062F\u0651\u0627\u062F \u0625\u0644\u0649 \u0639\u062F\u062F \u0627\u0644\u0625\u0634\u0639\u0627\u0631\u0627\u062A \u063A\u064A\u0631 \u0627\u0644\u0645\u0642\u0631\u0648\u0621\u0629 (\u206699+\u2069 \u0628\u0639\u062F \u0630\u0644\u0643). \u0627\u0646\u0642\u0631 \u0639\u0644\u064A\u0647 \u0644\u0641\u062A\u062D \u0622\u062E\u0631 \u0627\u0644\u0625\u0634\u0639\u0627\u0631\u0627\u062A."
            },
            account: {
              term: "\u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u062D\u0633\u0627\u0628",
              text: "\u0635\u0648\u0631\u062A\u0643 \u0623\u0648 \u0627\u0644\u062D\u0631\u0641\u0627\u0646 \u0627\u0644\u0623\u0648\u0644\u0627\u0646 \u0645\u0646 \u0627\u0633\u0645\u0643\u060C \u0645\u0639 \u0646\u0642\u0637\u0629 \u0645\u0644\u0648\u0651\u0646\u0629 \u062A\u062F\u0644 \u0639\u0644\u0649 \u062D\u0627\u0644\u062A\u0643. \u062A\u0641\u062A\u062D \u0627\u0644\u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u0645\u0648\u0635\u0648\u0641\u0629 \u0623\u062F\u0646\u0627\u0647."
            }
          }
        },
        bell: {
          title: "\u0627\u0644\u0625\u0634\u0639\u0627\u0631\u0627\u062A (\u0627\u0644\u062C\u0631\u0633)",
          items: {
            count: {
              term: "\u0622\u062E\u0631 \u0627\u0644\u0625\u0634\u0639\u0627\u0631\u0627\u062A",
              text: "\u0644\u0643\u0644 \u0633\u0637\u0631 \u0623\u064A\u0642\u0648\u0646\u0629 \u062D\u0633\u0628 \u0627\u0644\u0646\u0648\u0639 \u0648\u062C\u0645\u0644\u0629 \u0648\u062A\u0627\u0631\u064A\u062E \u0646\u0633\u0628\u064A \u0648\u0645\u0635\u062F\u0631 \u0627\u0644\u0625\u0634\u0639\u0627\u0631 (\u0627\u0644\u0645\u0624\u0633\u0633\u0629 \u0648\u0631\u0645\u0632 \u0627\u0644\u0645\u0634\u0631\u0648\u0639 \u0648\u0627\u0633\u0645\u0647). \u0627\u0644\u0646\u0642\u0631 \u064A\u0641\u062A\u062D \u0627\u0644\u0639\u0646\u0635\u0631 \u0627\u0644\u0645\u0639\u0646\u064A \u0648\u064A\u0639\u0644\u0651\u0645 \u0627\u0644\u0625\u0634\u0639\u0627\u0631 \u0643\u0645\u0642\u0631\u0648\u0621."
            },
            unread: {
              term: "\u063A\u064A\u0631 \u0645\u0642\u0631\u0648\u0621",
              text: "\u064A\u064F\u0643\u062A\u0628 \u0627\u0644\u0625\u0634\u0639\u0627\u0631 \u063A\u064A\u0631 \u0627\u0644\u0645\u0642\u0631\u0648\u0621 \u0628\u062E\u0637 \u063A\u0644\u064A\u0638 \u0648\u0623\u0645\u0627\u0645\u0647 \u0646\u0642\u0637\u0629 \u0635\u063A\u064A\u0631\u0629."
            },
            markRead: {
              term: "\u062A\u0639\u0644\u064A\u0645 \u0643\u0645\u0642\u0631\u0648\u0621",
              text: "\u0639\u0644\u0627\u0645\u0629 \u0627\u0644\u0635\u062D \u0639\u0644\u0649 \u064A\u0633\u0627\u0631 \u0627\u0644\u0625\u0634\u0639\u0627\u0631 \u063A\u064A\u0631 \u0627\u0644\u0645\u0642\u0631\u0648\u0621 \u062A\u0639\u0644\u0651\u0645\u0647 \u0643\u0645\u0642\u0631\u0648\u0621 \u062F\u0648\u0646 \u0641\u062A\u062D\u0647."
            },
            decide: {
              term: "\u0627\u0644\u0628\u062A\u0651",
              text: "\u064A\u0638\u0647\u0631 \u0639\u0644\u0649 \u0637\u0644\u0628 \u062A\u0623\u0634\u064A\u0631\u0629 \u0641\u064A \u0645\u0624\u0633\u0633\u062A\u0643 \u0627\u0644\u0646\u0634\u0637\u0629. \u064A\u0641\u062A\u062D \u0646\u0627\u0641\u0630\u0629 \u0644\u062A\u062A\u062E\u0630 \u0642\u0631\u0627\u0631\u0643 \u0641\u0648\u0631\u064B\u0627."
            },
            markAllRead: {
              term: "\u062A\u0639\u0644\u064A\u0645 \u0627\u0644\u0643\u0644 \u0643\u0645\u0642\u0631\u0648\u0621",
              text: "\u064A\u0639\u0644\u0651\u0645 \u0643\u0644 \u0627\u0644\u0625\u0634\u0639\u0627\u0631\u0627\u062A \u0643\u0645\u0642\u0631\u0648\u0621\u0629 \u0628\u0646\u0642\u0631\u0629 \u0648\u0627\u062D\u062F\u0629."
            },
            viewAll: {
              term: "\u0639\u0631\u0636 \u0643\u0644 \u0627\u0644\u0646\u0634\u0627\u0637",
              text: "\u064A\u0641\u062A\u062D \u0635\u0641\u062D\u0629 \u0627\u0644\u0646\u0634\u0627\u0637 \u0628\u0633\u062C\u0644\u0647\u0627 \u0627\u0644\u0643\u0627\u0645\u0644 \u0648\u0639\u0648\u0627\u0645\u0644 \u0627\u0644\u062A\u0635\u0641\u064A\u0629."
            },
            empty: {
              term: "\u0644\u0627 \u0634\u064A\u0621 \u062C\u062F\u064A\u062F",
              text: "\u0631\u0633\u0627\u0644\u0629 \u062A\u0638\u0647\u0631 \u0639\u0646\u062F \u0639\u062F\u0645 \u0648\u062C\u0648\u062F \u0623\u064A \u0625\u0634\u0639\u0627\u0631. \u0633\u062A\u0638\u0647\u0631 \u0647\u0646\u0627 \u0627\u0644\u0625\u0634\u0627\u0631\u0627\u062A \u0625\u0644\u064A\u0643 \u0648\u0627\u0644\u0645\u0647\u0627\u0645 \u0627\u0644\u0645\u0633\u0646\u062F\u0629 \u0625\u0644\u064A\u0643 \u0648\u0627\u0644\u062A\u0630\u0643\u064A\u0631\u0627\u062A."
            },
            loadFailed: {
              term: "\u062A\u0639\u0630\u0631 \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0625\u0634\u0639\u0627\u0631\u0627\u062A",
              text: "\u062A\u062D\u0642\u0642 \u0645\u0646 \u0627\u062A\u0635\u0627\u0644\u0643 \u062B\u0645 \u0627\u0633\u062A\u0639\u0645\u0644 \xAB\u0625\u0639\u0627\u062F\u0629 \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629\xBB."
            }
          }
        },
        account: {
          title: "\u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u062D\u0633\u0627\u0628",
          items: {
            status: {
              term: "\u0627\u0644\u062D\u0627\u0644\u0629",
              text: "\u0627\u062E\u062A\u0631 \u0645\u062A\u0627\u062D \u0623\u0648 \u0645\u0634\u063A\u0648\u0644 \u0623\u0648 \u0641\u064A \u0627\u0644\u062D\u0636\u064A\u0631\u0629 \u0623\u0648 \u063A\u0627\u0626\u0628: \u064A\u0631\u0627\u0647\u0627 \u0632\u0645\u0644\u0627\u0624\u0643 \u0628\u062C\u0627\u0646\u0628 \u0627\u0633\u0645\u0643. \u062A\u0638\u0647\u0631 \xAB\u0641\u064A \u0627\u062C\u062A\u0645\u0627\u0639\xBB \u062A\u0644\u0642\u0627\u0626\u064A\u064B\u0627 \u0623\u062B\u0646\u0627\u0621 \u0627\u0644\u0645\u0643\u0627\u0644\u0645\u0629\u060C \u0648\xAB\u063A\u064A\u0631 \u0645\u062A\u0635\u0644\xBB \u0639\u0646\u062F\u0645\u0627 \u0644\u0627 \u062A\u0643\u0648\u0646 \u0645\u062A\u0635\u0644\u064B\u0627. \u0644\u0627 \u064A\u0645\u0643\u0646 \u062A\u063A\u064A\u064A\u0631 \u0627\u0644\u062D\u0627\u0644\u0629 \u0625\u0644\u0627 \u0625\u0630\u0627 \u0643\u0627\u0646 \u0627\u0644\u0627\u062A\u0635\u0627\u0644 \u0627\u0644\u0645\u0628\u0627\u0634\u0631 \u0646\u0634\u0637\u064B\u0627."
            },
            profile: {
              term: "\u0645\u0644\u0641\u064A \u0627\u0644\u0634\u062E\u0635\u064A",
              text: "\u064A\u0641\u062A\u062D \u0645\u0644\u0641\u0643 \u0627\u0644\u0634\u062E\u0635\u064A."
            },
            security: {
              term: "\u0623\u0645\u0627\u0646 \u0627\u0644\u062D\u0633\u0627\u0628",
              text: "\u064A\u0641\u062A\u062D \u0635\u0641\u062D\u0629 \u0623\u0645\u0627\u0646 \u062D\u0633\u0627\u0628\u0643."
            },
            language: {
              term: "\u0627\u0644\u0644\u063A\u0629",
              text: "\u0627\u062E\u062A\u0631 \u2066Fran\xE7ais\u2069 \u0623\u0648 \u0627\u0644\u0639\u0631\u0628\u064A\u0629 \u0623\u0648 \u2066English\u2069. \u064A\u062A\u063A\u064A\u0631 \u0627\u0644\u062A\u0637\u0628\u064A\u0642 \u0643\u0644\u0647 \u0641\u0648\u0631\u064B\u0627\u060C \u0648\u062A\u064F\u0643\u062A\u0628 \u0627\u0644\u0639\u0631\u0628\u064A\u0629 \u0645\u0646 \u0627\u0644\u064A\u0645\u064A\u0646 \u0625\u0644\u0649 \u0627\u0644\u064A\u0633\u0627\u0631."
            },
            theme: {
              term: "\u0627\u0644\u0645\u0638\u0647\u0631",
              text: "\u062D\u0633\u0628 \u0625\u0639\u062F\u0627\u062F\u0627\u062A \u0627\u0644\u062C\u0647\u0627\u0632 \u0623\u0648 \u0641\u0627\u062A\u062D \u0623\u0648 \u062F\u0627\u0643\u0646 \u0623\u0648 \u062A\u0628\u0627\u064A\u0646 \u0639\u0627\u0644\u064D (\u0644\u0631\u0624\u064A\u0629 \u0627\u0644\u062D\u062F\u0648\u062F \u0648\u0627\u0644\u0623\u0644\u0648\u0627\u0646 \u0628\u0648\u0636\u0648\u062D \u0623\u0643\u0628\u0631)."
            },
            signOut: {
              term: "\u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062E\u0631\u0648\u062C",
              text: "\u064A\u0646\u0647\u064A \u062C\u0644\u0633\u062A\u0643."
            },
            signOutFailed: {
              term: "\u0644\u0645 \u064A\u0643\u062A\u0645\u0644 \u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062E\u0631\u0648\u062C",
              text: "\u0625\u0630\u0627 \u062A\u0639\u0630\u0651\u0631 \u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062E\u0631\u0648\u062C \u062A\u0637\u0644\u0628 \u0645\u0646\u0643 \u0647\u0630\u0647 \u0627\u0644\u0646\u0627\u0641\u0630\u0629 \u0625\u063A\u0644\u0627\u0642 \u0645\u062A\u0635\u0641\u062D\u0643 \u0644\u0625\u0646\u0647\u0627\u0621 \u0627\u0644\u062C\u0644\u0633\u0629 \u0628\u0623\u0645\u0627\u0646. \u0632\u0631 \xAB\u0625\u063A\u0644\u0627\u0642\xBB \u064A\u063A\u0644\u0642\u0647\u0627."
            }
          }
        },
        panes: {
          title: "\u0627\u0644\u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u064A\u0633\u0631\u0649 \u0648\u0627\u0644\u0644\u0648\u062D\u0629 \u0627\u0644\u064A\u0645\u0646\u0649 \u0648\u0627\u0644\u0634\u0631\u0627\u0626\u0637",
          items: {
            list: {
              term: "\u0627\u0644\u0642\u0627\u0626\u0645\u0629",
              text: "\u0644\u0628\u0639\u0636 \u0627\u0644\u062A\u0637\u0628\u064A\u0642\u0627\u062A (\u0627\u0644\u0645\u0634\u0627\u0631\u064A\u0639 \u0648\u0627\u0644\u0645\u062D\u0627\u062F\u062B\u0629 \u0648\u0627\u0644\u062A\u0642\u0648\u064A\u0645) \u0642\u0627\u0626\u0645\u0629 \u0639\u0644\u0649 \u0627\u0644\u062C\u0627\u0646\u0628. \u0627\u0644\u0632\u0631 \xAB\u0625\u062E\u0641\u0627\u0621 \u0627\u0644\u0642\u0627\u0626\u0645\u0629\xBB \u064A\u0637\u0648\u064A\u0647\u0627 \u0648\xAB\u0625\u0638\u0647\u0627\u0631 \u0627\u0644\u0642\u0627\u0626\u0645\u0629\xBB \u064A\u0639\u064A\u062F \u0641\u062A\u062D\u0647\u0627 (\u2066Alt+L\u2069). \u0639\u0644\u0649 \u0627\u0644\u0634\u0627\u0634\u0627\u062A \u0627\u0644\u0645\u062A\u0648\u0633\u0637\u0629 \u0623\u0648 \u0627\u0644\u0635\u063A\u064A\u0631\u0629 \u062A\u064F\u0641\u062A\u062D \u0641\u0648\u0642 \u0627\u0644\u0635\u0641\u062D\u0629 \u0628\u0627\u0644\u0632\u0631 \xAB\u0641\u062A\u062D \u0627\u0644\u0642\u0627\u0626\u0645\u0629\xBB."
            },
            resize: {
              term: "\u062A\u063A\u064A\u064A\u0631 \u062D\u062C\u0645 \u0627\u0644\u0642\u0627\u0626\u0645\u0629",
              text: "\u0627\u0633\u062D\u0628 \u062D\u0627\u0641\u0629 \u0627\u0644\u0642\u0627\u0626\u0645\u0629 \u0628\u0627\u0644\u0641\u0623\u0631\u0629\u060C \u0623\u0648 \u0636\u0639 \u0627\u0644\u062A\u0631\u0643\u064A\u0632 \u0639\u0644\u064A\u0647\u0627 \u0648\u0627\u0633\u062A\u0639\u0645\u0644 \u0633\u0647\u0645\u064A \u0627\u0644\u064A\u0645\u064A\u0646 \u0648\u0627\u0644\u064A\u0633\u0627\u0631 \u0641\u064A \u0644\u0648\u062D\u0629 \u0627\u0644\u0645\u0641\u0627\u062A\u064A\u062D."
            },
            rightPanel: {
              term: "\u0625\u063A\u0644\u0627\u0642 \u0627\u0644\u0644\u0648\u062D\u0629",
              text: "\u062A\u0639\u0631\u0636 \u0627\u0644\u0644\u0648\u062D\u0629 \u0627\u0644\u062C\u0627\u0646\u0628\u064A\u0629 \u062A\u0641\u0635\u064A\u0644\u064B\u0627 (\u0633\u0644\u0633\u0644\u0629 \u0646\u0642\u0627\u0634 \u0623\u0648 \u0631\u0633\u0627\u0626\u0644 \u0645\u062B\u0628\u0651\u062A\u0629\u2026). \u0632\u0631 \u0627\u0644\u0625\u063A\u0644\u0627\u0642 \u0623\u0648 \u0627\u0644\u0645\u0641\u062A\u0627\u062D \u2066Esc\u2069 \u064A\u063A\u0644\u0642\u0647\u0627."
            },
            subscriptionBanner: {
              term: "\u0634\u0631\u064A\u0637 \u0627\u0644\u0627\u0634\u062A\u0631\u0627\u0643",
              text: "\u064A\u0638\u0647\u0631 \u0634\u0631\u064A\u0637 \u0641\u0648\u0642 \u0627\u0644\u0635\u0641\u062D\u0629 \u0641\u0642\u0637 \u0639\u0646\u062F\u0645\u0627 \u064A\u062A\u0637\u0644\u0628 \u0627\u0644\u0627\u0634\u062A\u0631\u0627\u0643 \u0627\u0646\u062A\u0628\u0627\u0647\u0643 (\u062A\u062C\u0631\u0628\u0629 \u062A\u0648\u0634\u0643 \u0639\u0644\u0649 \u0627\u0644\u0627\u0646\u062A\u0647\u0627\u0621 \u0623\u0648 \u0641\u0627\u062A\u0648\u0631\u0629 \u063A\u064A\u0631 \u0645\u0633\u062F\u0651\u062F\u0629 \u0623\u0648 \u0648\u0636\u0639 \u0627\u0644\u0642\u0631\u0627\u0621\u0629 \u0641\u0642\u0637\u2026). \u0632\u0631 \u0645\u062B\u0644 \xAB\u0639\u0631\u0636 \u0627\u0644\u0627\u0634\u062A\u0631\u0627\u0643\xBB \u0623\u0648 \xAB\u0633\u062F\u0627\u062F \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629\xBB \u064A\u0642\u0648\u062F\u0643 \u0625\u0644\u0649 \u0627\u0644\u0625\u062C\u0631\u0627\u0621 \u0627\u0644\u0645\u0637\u0644\u0648\u0628."
            },
            skipLink: {
              term: "\u0627\u0644\u0627\u0646\u062A\u0642\u0627\u0644 \u0625\u0644\u0649 \u0627\u0644\u0645\u062D\u062A\u0648\u0649 \u0627\u0644\u0631\u0626\u064A\u0633\u064A",
              text: "\u0631\u0627\u0628\u0637 \u0645\u062E\u0641\u064A \u064A\u0638\u0647\u0631 \u0639\u0646\u062F \u0627\u0644\u0636\u063A\u0637 \u0639\u0644\u0649 \u2066Tab\u2069 \u0641\u0648\u0631 \u062F\u062E\u0648\u0644 \u0627\u0644\u0635\u0641\u062D\u0629. \u064A\u062A\u064A\u062D \u0644\u0644\u0648\u062D\u0629 \u0627\u0644\u0645\u0641\u0627\u062A\u064A\u062D \u0627\u0644\u0642\u0641\u0632 \u0645\u0628\u0627\u0634\u0631\u0629 \u0625\u0644\u0649 \u0627\u0644\u0645\u062D\u062A\u0648\u0649."
            }
          }
        },
        shortcuts: {
          title: "\u0627\u062E\u062A\u0635\u0627\u0631\u0627\u062A \u0644\u0648\u062D\u0629 \u0627\u0644\u0645\u0641\u0627\u062A\u064A\u062D",
          items: {
            search: {
              term: "\u0627\u0644\u0628\u062D\u062B",
              text: "\u2066Ctrl+K\u2069 \u0623\u0648 \u0627\u0644\u0645\u0641\u062A\u0627\u062D \u2066/\u2069 \u064A\u0641\u062A\u062D \u0627\u0644\u0628\u062D\u062B \u0627\u0644\u0633\u0631\u064A\u0639."
            },
            apps: {
              term: "\u0627\u0644\u0627\u0646\u062A\u0642\u0627\u0644 \u0625\u0644\u0649 \u062A\u0637\u0628\u064A\u0642",
              text: "\u0645\u0646 \u2066Alt+1\u2069 \u0625\u0644\u0649 \u2066Alt+7\u2069 \u0628\u0627\u0644\u062A\u0631\u062A\u064A\u0628: \u0627\u0644\u0646\u0634\u0627\u0637 \u0648\u0627\u0644\u0645\u062D\u0627\u062F\u062B\u0629 \u0648\u0627\u0644\u0645\u0634\u0627\u0631\u064A\u0639 \u0648\u0627\u0644\u062A\u0642\u0648\u064A\u0645 \u0648\u0627\u0644\u0645\u0644\u0641\u0627\u062A \u0648\u0627\u0644\u0645\u0627\u0644\u064A\u0629 \u0648\u0627\u0644\u0645\u0632\u064A\u062F."
            },
            list: {
              term: "\u0625\u0638\u0647\u0627\u0631 \u0627\u0644\u0642\u0627\u0626\u0645\u0629 \u0623\u0648 \u0625\u062E\u0641\u0627\u0624\u0647\u0627",
              text: "\u2066Alt+L\u2069 \u064A\u0637\u0648\u064A \u0627\u0644\u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u062C\u0627\u0646\u0628\u064A\u0629 \u0623\u0648 \u064A\u0639\u064A\u062F \u0641\u062A\u062D\u0647\u0627."
            },
            close: {
              term: "\u0625\u063A\u0644\u0627\u0642 \u0627\u0644\u0644\u0648\u062D\u0629 \u0623\u0648 \u0645\u0631\u0628\u0639 \u0627\u0644\u062D\u0648\u0627\u0631",
              text: "\u0627\u0644\u0645\u0641\u062A\u0627\u062D \u2066Esc\u2069 \u064A\u063A\u0644\u0642 \u0627\u0644\u0644\u0648\u062D\u0629 \u0627\u0644\u062C\u0627\u0646\u0628\u064A\u0629 \u0623\u0648 \u0627\u0644\u0646\u0627\u0641\u0630\u0629 \u0627\u0644\u0645\u0641\u062A\u0648\u062D\u0629."
            },
            typing: {
              term: "\u0623\u062B\u0646\u0627\u0621 \u0627\u0644\u0643\u062A\u0627\u0628\u0629",
              text: "\u0644\u0627 \u062A\u0639\u0645\u0644 \u0627\u0644\u0627\u062E\u062A\u0635\u0627\u0631\u0627\u062A \u0623\u062B\u0646\u0627\u0621 \u0627\u0644\u0643\u062A\u0627\u0628\u0629 \u0641\u064A \u062D\u0642\u0644 \u0646\u0635\u064A \u062D\u062A\u0649 \u0644\u0627 \u062A\u0632\u0639\u062C\u0643."
            }
          }
        }
      }
    },
    activity: {
      title: "\u0627\u0644\u0646\u0634\u0627\u0637",
      intro: "\u0633\u062C\u0644 \u0643\u0644 \u0645\u0627 \u064A\u062E\u0635\u0643 \u0641\u064A \u0627\u0644\u0645\u0624\u0633\u0633\u0629: \u0627\u0644\u0625\u0634\u0627\u0631\u0627\u062A \u0625\u0644\u064A\u0643 \u0648\u0627\u0644\u0645\u0647\u0627\u0645 \u0627\u0644\u0645\u0633\u0646\u062F\u0629 \u0625\u0644\u064A\u0643 \u0648\u0637\u0644\u0628\u0627\u062A \u0627\u0644\u062A\u0623\u0634\u064A\u0631\u0629 \u0648\u0642\u0631\u0627\u0631\u0627\u062A\u0647\u0627. \u064A\u0631\u0649 \u0643\u0644 \u0639\u0636\u0648 \u0633\u062C\u0644\u0647 \u0627\u0644\u062E\u0627\u0635.",
      sections: {
        header: {
          title: "\u0631\u0623\u0633 \u0627\u0644\u0635\u0641\u062D\u0629",
          items: {
            title: {
              term: "\u0627\u0644\u0646\u0634\u0627\u0637",
              text: "\u0627\u0633\u0645 \u0627\u0644\u0635\u0641\u062D\u0629."
            },
            markAllRead: {
              term: "\u062A\u0639\u0644\u064A\u0645 \u0627\u0644\u0643\u0644 \u0643\u0645\u0642\u0631\u0648\u0621",
              text: "\u064A\u0639\u0644\u0651\u0645 \u0643\u0644 \u0625\u0634\u0639\u0627\u0631\u0627\u062A \u0627\u0644\u0645\u0624\u0633\u0633\u0629 \u0643\u0645\u0642\u0631\u0648\u0621\u0629. \u064A\u0643\u0648\u0646 \u0627\u0644\u0632\u0631 \u0628\u0627\u0647\u062A\u064B\u0627 \u0639\u0646\u062F\u0645\u0627 \u0644\u0627 \u064A\u0648\u062C\u062F \u0634\u064A\u0621 \u063A\u064A\u0631 \u0645\u0642\u0631\u0648\u0621."
            }
          }
        },
        filters: {
          title: "\u062A\u0635\u0641\u064A\u0629 \u0627\u0644\u0646\u0634\u0627\u0637",
          items: {
            all: {
              term: "\u0627\u0644\u0643\u0644",
              text: "\u0643\u0644 \u0627\u0644\u0625\u0634\u0639\u0627\u0631\u0627\u062A\u060C \u0628\u0645\u0627 \u0641\u064A\u0647\u0627 \u062A\u0630\u0643\u064A\u0631\u0627\u062A \u0627\u0644\u0622\u062C\u0627\u0644 \u0648\u0627\u0644\u0631\u0633\u0627\u0626\u0644 \u0627\u0644\u0645\u062A\u0639\u0644\u0642\u0629 \u0628\u0627\u0644\u0627\u0634\u062A\u0631\u0627\u0643."
            },
            mentions: {
              term: "\u0627\u0644\u0625\u0634\u0627\u0631\u0627\u062A",
              text: "\u0627\u0644\u0645\u0631\u0627\u062A \u0627\u0644\u062A\u064A \u064A\u0634\u064A\u0631 \u0641\u064A\u0647\u0627 \u0625\u0644\u064A\u0643 \u0623\u062D\u062F \u0641\u064A \u0631\u0633\u0627\u0644\u0629 \u0623\u0648 \u0645\u0647\u0645\u0629\u060C \u0623\u0648 \u064A\u0631\u062F \u0639\u0644\u0649 \u0623\u062D\u062F \u062A\u0639\u0644\u064A\u0642\u0627\u062A\u0643."
            },
            assignments: {
              term: "\u0627\u0644\u0625\u0633\u0646\u0627\u062F\u0627\u062A",
              text: "\u0627\u0644\u0645\u0647\u0627\u0645 \u0627\u0644\u062A\u064A \u062A\u064F\u0633\u0646\u062F \u0625\u0644\u064A\u0643."
            },
            approvals: {
              term: "\u0627\u0644\u062A\u0623\u0634\u064A\u0631\u0627\u062A",
              text: "\u0637\u0644\u0628\u0627\u062A \u0627\u0644\u062A\u0623\u0634\u064A\u0631\u0629 (\u0627\u0644\u0645\u0648\u0627\u0641\u0642\u0629 \u0639\u0644\u0649 \u0648\u062B\u064A\u0642\u0629) \u0648\u0627\u0644\u0642\u0631\u0627\u0631\u0627\u062A \u0627\u0644\u0635\u0627\u062F\u0631\u0629 \u0628\u0634\u0623\u0646 \u0648\u062B\u0627\u0626\u0642\u0643. \u0642\u062F \u062A\u0643\u0648\u0646 \u0627\u0644\u062A\u0623\u0634\u064A\u0631\u0629 \u2066VSO\u2069 (\u0645\u0648\u0627\u0641\u0642 \u0639\u0644\u064A\u0647\u0627) \u0623\u0648 \u2066VAO\u2069 (\u0645\u0648\u0627\u0641\u0642 \u0639\u0644\u064A\u0647\u0627 \u0645\u0639 \u0645\u0644\u0627\u062D\u0638\u0627\u062A) \u0623\u0648 \u2066REF\u2069 (\u0645\u0631\u0641\u0648\u0636\u0629)."
            },
            address: {
              term: "\u0627\u0644\u062A\u0635\u0641\u064A\u0629 \u0645\u062D\u0641\u0648\u0638\u0629 \u0641\u064A \u0627\u0644\u0639\u0646\u0648\u0627\u0646",
              text: "\u062A\u064F\u0643\u062A\u0628 \u0627\u0644\u062A\u0635\u0641\u064A\u0629 \u0627\u0644\u0645\u062E\u062A\u0627\u0631\u0629 \u0641\u064A \u0639\u0646\u0648\u0627\u0646 \u0627\u0644\u0635\u0641\u062D\u0629: \u064A\u0645\u0643\u0646\u0643 \u0646\u0633\u062E\u0647 \u0644\u0645\u0634\u0627\u0631\u0643\u0629 \u0627\u0644\u0639\u0631\u0636\u060C \u0648\u062A\u0628\u0642\u0649 \u0628\u0639\u062F \u0625\u0639\u0627\u062F\u0629 \u0627\u0644\u062A\u062D\u0645\u064A\u0644."
            }
          }
        },
        setup: {
          title: "\u0623\u0643\u0645\u0644 \u0625\u0639\u062F\u0627\u062F \u0645\u0643\u062A\u0628\u0643",
          items: {
            card: {
              term: "\u0628\u0637\u0627\u0642\u0629 \u0627\u0644\u0625\u0639\u062F\u0627\u062F",
              text: "\u062B\u0644\u0627\u062B \u062E\u0637\u0648\u0627\u062A \u0623\u0648\u0644\u0649 \u0644\u0644\u0628\u062F\u0621 \u0639\u0644\u0649 \u0623\u0641\u0636\u0644 \u0648\u062C\u0647 \u0645\u0639 \u2066BatiFlow\u2069. \u0644\u0627 \u062A\u0638\u0647\u0631 \u0625\u0644\u0627 \u0641\u064A \u0639\u0644\u0627\u0645\u0629 \u0627\u0644\u062A\u0628\u0648\u064A\u0628 \xAB\u0627\u0644\u0643\u0644\xBB\u060C \u0644\u0644\u0645\u0627\u0644\u0643\u064A\u0646 \u0648\u0627\u0644\u0645\u0633\u0624\u0648\u0644\u064A\u0646 \u0648\u0644\u0645\u0646 \u064A\u0645\u0644\u0643 \u062D\u0642 \u062F\u0639\u0648\u0629 \u0627\u0644\u0623\u0639\u0636\u0627\u0621."
            },
            invite: {
              term: "\u0627\u062F\u0639\u064F \u0641\u0631\u064A\u0642\u0643",
              text: "\u0627\u0644\u0631\u0627\u0628\u0637 \xAB\u062F\u0639\u0648\u0629\xBB \u064A\u0642\u0648\u062F \u0625\u0644\u0649 \u0625\u0636\u0627\u0641\u0629 \u0627\u0644\u0645\u0647\u0646\u062F\u0633\u064A\u0646 \u0648\u0627\u0644\u0631\u0633\u0651\u0627\u0645\u064A\u0646 \u0648\u0628\u0642\u064A\u0629 \u0627\u0644\u0645\u062A\u0639\u0627\u0648\u0646\u064A\u0646."
            },
            clients: {
              term: "\u0623\u0636\u0641 \u062D\u0631\u064A\u0641\u064B\u0627",
              text: "\u0627\u0644\u0631\u0627\u0628\u0637 \xAB\u0625\u0636\u0627\u0641\u0629 \u062D\u0631\u064A\u0641\xBB \u064A\u0642\u0648\u062F \u0625\u0644\u0649 \u062A\u0633\u062C\u064A\u0644 \u0623\u0635\u062D\u0627\u0628 \u0645\u0634\u0627\u0631\u064A\u0639\u0643 (\u062D\u0631\u0641\u0627\u0626\u0643) \u0644\u062A\u062C\u062F\u0647\u0645 \u0641\u064A \u0645\u0634\u0627\u0631\u064A\u0639\u0643."
            },
            project: {
              term: "\u0623\u0646\u0634\u0626 \u0645\u0634\u0631\u0648\u0639\u064B\u0627",
              text: "\u0627\u0644\u0631\u0627\u0628\u0637 \xAB\u0625\u0646\u0634\u0627\u0621 \u0645\u0634\u0631\u0648\u0639\xBB \u064A\u0642\u0648\u062F \u0625\u0644\u0649 \u0628\u062F\u0621 \u0645\u0644\u0641 \u062F\u0631\u0627\u0633\u062A\u0643 \u0627\u0644\u0623\u0648\u0644."
            },
            dismiss: {
              term: "\u0625\u062E\u0641\u0627\u0621",
              text: "\u064A\u062E\u0641\u064A \u0627\u0644\u0628\u0637\u0627\u0642\u0629. \u064A\u064F\u062D\u0641\u0638 \u0627\u062E\u062A\u064A\u0627\u0631\u0643 \u0644\u0647\u0630\u0647 \u0627\u0644\u0645\u0624\u0633\u0633\u0629 \u0639\u0644\u0649 \u0647\u0630\u0627 \u0627\u0644\u062C\u0647\u0627\u0632."
            }
          }
        },
        feed: {
          title: "\u0633\u062C\u0644 \u0627\u0644\u0646\u0634\u0627\u0637",
          items: {
            row: {
              term: "\u0625\u0634\u0639\u0627\u0631",
              text: "\u0623\u064A\u0642\u0648\u0646\u0629 \u062D\u0633\u0628 \u0627\u0644\u0646\u0648\u0639 \u0648\u062C\u0645\u0644\u0629 \u0648\u062A\u0627\u0631\u064A\u062E \u0646\u0633\u0628\u064A\u060C \u062B\u0645 \u0627\u0644\u0645\u0624\u0633\u0633\u0629 \u0648\u0627\u0644\u0645\u0634\u0631\u0648\u0639 \u0627\u0644\u0645\u0639\u0646\u064A\u0627\u0646. \u0627\u0644\u0646\u0642\u0631 \u0639\u0644\u064A\u0647 \u064A\u0641\u062A\u062D \u0627\u0644\u0639\u0646\u0635\u0631 \u0648\u064A\u0639\u0644\u0651\u0645\u0647 \u0643\u0645\u0642\u0631\u0648\u0621."
            },
            unread: {
              term: "\u063A\u064A\u0631 \u0645\u0642\u0631\u0648\u0621",
              text: "\u062A\u064F\u0643\u062A\u0628 \u0627\u0644\u0625\u0634\u0639\u0627\u0631\u0627\u062A \u063A\u064A\u0631 \u0627\u0644\u0645\u0642\u0631\u0648\u0621\u0629 \u0628\u062E\u0637 \u063A\u0644\u064A\u0638 \u0648\u0623\u0645\u0627\u0645\u0647\u0627 \u0646\u0642\u0637\u0629 \u0635\u063A\u064A\u0631\u0629."
            },
            markRead: {
              term: "\u062A\u0639\u0644\u064A\u0645 \u0643\u0645\u0642\u0631\u0648\u0621",
              text: "\u0639\u0644\u0627\u0645\u0629 \u0627\u0644\u0635\u062D \u0639\u0644\u0649 \u0627\u0644\u062C\u0627\u0646\u0628 \u062A\u0639\u0644\u0651\u0645 \u0625\u0634\u0639\u0627\u0631\u064B\u0627 \u0648\u0627\u062D\u062F\u064B\u0627 \u0643\u0645\u0642\u0631\u0648\u0621 \u062F\u0648\u0646 \u0641\u062A\u062D\u0647."
            },
            decide: {
              term: "\u0627\u0644\u0628\u062A\u0651",
              text: "\u0639\u0644\u0649 \u0637\u0644\u0628 \u062A\u0623\u0634\u064A\u0631\u0629: \u064A\u0641\u062A\u062D \u0646\u0627\u0641\u0630\u0629 \u0644\u062A\u062A\u062E\u0630 \u0642\u0631\u0627\u0631\u0643 \u062F\u0648\u0646 \u0645\u063A\u0627\u062F\u0631\u0629 \u0627\u0644\u0635\u0641\u062D\u0629."
            },
            loadMore: {
              term: "\u0639\u0631\u0636 \u0627\u0644\u0645\u0632\u064A\u062F \u0645\u0646 \u0627\u0644\u0646\u0634\u0627\u0637",
              text: "\u064A\u062D\u0645\u0651\u0644 \u0627\u0644\u0625\u0634\u0639\u0627\u0631\u0627\u062A \u0627\u0644\u0623\u0642\u062F\u0645. \u0644\u0627 \u064A\u0638\u0647\u0631 \u0627\u0644\u0632\u0631 \u0625\u0644\u0627 \u0625\u0630\u0627 \u0628\u0642\u064A \u0627\u0644\u0645\u0632\u064A\u062F."
            }
          }
        },
        states: {
          title: "\u0639\u0646\u062F\u0645\u0627 \u062A\u0643\u0648\u0646 \u0627\u0644\u0642\u0627\u0626\u0645\u0629 \u0641\u0627\u0631\u063A\u0629 \u0623\u0648 \u0644\u0627 \u062A\u064F\u062D\u0645\u064E\u0651\u0644",
          items: {
            emptyAll: {
              term: "\u0644\u0627 \u062C\u062F\u064A\u062F \u0641\u064A \u0627\u0644\u0648\u0642\u062A \u0627\u0644\u062D\u0627\u0644\u064A",
              text: "\u0639\u0644\u0627\u0645\u0629 \u0627\u0644\u062A\u0628\u0648\u064A\u0628 \xAB\u0627\u0644\u0643\u0644\xBB \u0641\u0627\u0631\u063A\u0629: \u0633\u062A\u0638\u0647\u0631 \u0647\u0646\u0627 \u0627\u0644\u0625\u0634\u0627\u0631\u0627\u062A \u0625\u0644\u064A\u0643 \u0648\u0627\u0644\u0645\u0647\u0627\u0645 \u0627\u0644\u0645\u0633\u0646\u062F\u0629 \u0625\u0644\u064A\u0643 \u0648\u0637\u0644\u0628\u0627\u062A \u0627\u0644\u062A\u0623\u0634\u064A\u0631\u0629."
            },
            emptyMentions: {
              term: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0625\u0634\u0627\u0631\u0627\u062A",
              text: "\u0633\u062A\u062A\u0644\u0642\u0649 \u0647\u0646\u0627 \u062A\u0646\u0628\u064A\u0647\u064B\u0627 \u0639\u0646\u062F\u0645\u0627 \u064A\u0634\u064A\u0631 \u0625\u0644\u064A\u0643 \u0623\u062D\u062F \u0623\u0648 \u064A\u0631\u062F \u0639\u0644\u0649 \u0623\u062D\u062F \u062A\u0639\u0644\u064A\u0642\u0627\u062A\u0643."
            },
            emptyAssignments: {
              term: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0645\u0647\u0627\u0645 \u0645\u0633\u0646\u062F\u0629",
              text: "\u0633\u062A\u0638\u0647\u0631 \u0647\u0646\u0627 \u0627\u0644\u0645\u0647\u0627\u0645 \u0627\u0644\u062A\u064A \u062A\u064F\u0633\u0646\u062F \u0625\u0644\u064A\u0643."
            },
            emptyApprovals: {
              term: "\u0644\u0627 \u062A\u0648\u062C\u062F \u062A\u0623\u0634\u064A\u0631\u0627\u062A \u0628\u0639\u062F",
              text: "\u0633\u062A\u0635\u0644 \u0637\u0644\u0628\u0627\u062A \u0627\u0644\u062A\u0623\u0634\u064A\u0631\u0629 \u0648\u0642\u0631\u0627\u0631\u0627\u062A\u0647\u0627 \u0625\u0644\u0649 \u0647\u0646\u0627 \u0645\u0639 \u062A\u0623\u0634\u064A\u0631\u0627\u062A \u0627\u0644\u0648\u062B\u0627\u0626\u0642."
            },
            loadFailed: {
              term: "\u062A\u0639\u0630\u0631 \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0646\u0634\u0627\u0637",
              text: "\u062A\u062D\u0642\u0642 \u0645\u0646 \u0627\u062A\u0635\u0627\u0644\u0643 \u062B\u0645 \u0627\u0646\u0642\u0631 \u0639\u0644\u0649 \xAB\u0625\u0639\u0627\u062F\u0629 \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629\xBB."
            }
          }
        }
      }
    },
    chat: {
      title: "\u0627\u0644\u0645\u062D\u0627\u062F\u062B\u0627\u062A",
      intro: "\u0627\u0644\u0645\u0631\u0627\u0633\u0644\u0629 \u0641\u064A \u2066BatiFlow\u2069: \u0646\u0642\u0627\u0634\u0627\u062A \u062E\u0627\u0635\u0629 \u0623\u0648 \u062C\u0645\u0627\u0639\u064A\u0629 \u0645\u0639 \u0632\u0645\u0644\u0627\u0626\u0643\u060C \u0648\u0642\u0646\u0648\u0627\u062A \u0645\u0631\u062A\u0628\u0637\u0629 \u0628\u0645\u0634\u0627\u0631\u064A\u0639\u0643. \u0627\u0644\u0645\u062D\u0627\u062F\u062B\u0627\u062A \u0641\u064A \u0627\u0644\u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u062C\u0627\u0646\u0628\u064A\u0629\u060C \u0648\u0627\u0644\u0645\u062D\u0627\u062F\u062B\u0629 \u0627\u0644\u0645\u0641\u062A\u0648\u062D\u0629 \u062A\u0634\u063A\u0644 \u0628\u0642\u064A\u0629 \u0627\u0644\u0634\u0627\u0634\u0629.",
      sections: {
        listPane: {
          title: "\u0627\u0644\u0645\u062D\u0627\u062F\u062B\u0627\u062A \u0648\u0627\u0644\u0642\u0646\u0648\u0627\u062A (\u0627\u0644\u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u062C\u0627\u0646\u0628\u064A\u0629)",
          items: {
            newConversation: {
              term: "\u0645\u062D\u0627\u062F\u062B\u0629 \u062C\u062F\u064A\u062F\u0629",
              text: "\u0627\u0644\u0632\u0631 \u0641\u064A \u0623\u0639\u0644\u0649 \u0627\u0644\u0642\u0627\u0626\u0645\u0629 \u064A\u0641\u062A\u062D \u0646\u0627\u0641\u0630\u0629 \u0644\u0644\u0643\u062A\u0627\u0628\u0629 \u0625\u0644\u0649 \u0632\u0645\u064A\u0644 \u0623\u0648 \u0644\u0625\u0646\u0634\u0627\u0621 \u0645\u062C\u0645\u0648\u0639\u0629."
            },
            discussions: {
              term: "\u0627\u0644\u0646\u0642\u0627\u0634\u0627\u062A",
              text: "\u0645\u062D\u0627\u062F\u062B\u0627\u062A\u0643 \u0627\u0644\u062E\u0627\u0635\u0629 (\u0634\u062E\u0635 \u0648\u0627\u062D\u062F) \u0648\u0645\u062C\u0645\u0648\u0639\u0627\u062A\u0643 (\u0639\u062F\u0629 \u0623\u0634\u062E\u0627\u0635). \u062A\u062D\u0645\u0644 \u0627\u0644\u0645\u062D\u0627\u062F\u062B\u0629 \u0627\u0644\u062E\u0627\u0635\u0629 \u0627\u0633\u0645 \u0627\u0644\u0634\u062E\u0635 \u0627\u0644\u0622\u062E\u0631."
            },
            projects: {
              term: "\u0627\u0644\u0645\u0634\u0627\u0631\u064A\u0639",
              text: "\u0645\u0634\u0627\u0631\u064A\u0639\u0643\u060C \u062A\u064F\u0648\u0633\u064E\u0651\u0639 \u0623\u0648 \u062A\u064F\u0637\u0648\u0649 \u0628\u0646\u0642\u0631\u0629. \u062A\u062D\u062A \u0643\u0644 \u0645\u0634\u0631\u0648\u0639: \u0642\u0646\u0648\u0627\u062A\u0647\u060C \u0623\u064A \u0633\u0644\u0633\u0644\u0629 \u0646\u0642\u0627\u0634 \u0644\u0643\u0644 \u0645\u0648\u0636\u0648\u0639."
            },
            unread: {
              term: "\u0639\u062F\u0651\u0627\u062F \u0627\u0644\u0631\u0633\u0627\u0626\u0644 \u063A\u064A\u0631 \u0627\u0644\u0645\u0642\u0631\u0648\u0621\u0629",
              text: "\u0631\u0642\u0645 \u0635\u063A\u064A\u0631 \u0628\u062C\u0627\u0646\u0628 \u0645\u062D\u0627\u062F\u062B\u0629 \u0623\u0648 \u0642\u0646\u0627\u0629 \u064A\u0628\u064A\u0651\u0646 \u0639\u062F\u062F \u0627\u0644\u0631\u0633\u0627\u0626\u0644 \u0627\u0644\u062A\u064A \u0644\u0645 \u062A\u0642\u0631\u0623\u0647\u0627."
            },
            newChannel: {
              term: "\u0642\u0646\u0627\u0629 \u062C\u062F\u064A\u062F\u0629 \u0641\u064A \u0627\u0644\u0645\u0634\u0631\u0648\u0639",
              text: "\u0627\u0644\u0632\u0631 \u0628\u062C\u0627\u0646\u0628 \u0627\u0633\u0645 \u0645\u0634\u0631\u0648\u0639 \u064A\u0641\u062A\u062D \u0625\u0646\u0634\u0627\u0621 \u0642\u0646\u0627\u0629. \u0644\u0627 \u064A\u0638\u0647\u0631 \u0625\u0644\u0627 \u0644\u0645\u0646 \u064A\u062F\u064A\u0631 \u0647\u0630\u0627 \u0627\u0644\u0645\u0634\u0631\u0648\u0639."
            },
            emptyDiscussions: {
              term: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0646\u0642\u0627\u0634\u0627\u062A \u062D\u0627\u0644\u064A\u064B\u0627",
              text: "\u0627\u0628\u062F\u0623 \u0645\u062D\u0627\u062F\u062B\u0629 \u0645\u0639 \u0632\u0645\u064A\u0644."
            },
            emptyProjects: {
              term: "\u0623\u0646\u062A \u0644\u0627 \u062A\u0634\u0627\u0631\u0643 \u0641\u064A \u0623\u064A \u0645\u0634\u0631\u0648\u0639",
              text: "\u064A\u0628\u0642\u0649 \u0642\u0633\u0645 \u0627\u0644\u0645\u0634\u0627\u0631\u064A\u0639 \u0641\u0627\u0631\u063A\u064B\u0627 \u0645\u0627 \u062F\u0645\u062A \u063A\u064A\u0631 \u0645\u0636\u0627\u0641 \u0625\u0644\u0649 \u0645\u0634\u0631\u0648\u0639."
            },
            noChannels: {
              term: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0642\u0646\u0648\u0627\u062A \u0641\u064A \u0647\u0630\u0627 \u0627\u0644\u0645\u0634\u0631\u0648\u0639",
              text: "\u0644\u064A\u0633 \u0644\u0644\u0645\u0634\u0631\u0648\u0639 \u0642\u0646\u0627\u0629 \u0628\u0639\u062F. \u064A\u0645\u0643\u0646 \u0644\u0645\u062F\u064A\u0631\u064A \u0627\u0644\u0645\u0634\u0631\u0648\u0639 \u0625\u0646\u0634\u0627\u0621 \u0648\u0627\u062D\u062F\u0629."
            }
          }
        },
        start: {
          title: "\u0627\u062E\u062A\u0631 \u0645\u062D\u0627\u062F\u062B\u0629",
          items: {
            emptyState: {
              term: "\u0627\u062E\u062A\u0631 \u0645\u062D\u0627\u062F\u062B\u0629",
              text: "\u0634\u0627\u0634\u0629 \u0627\u0644\u0628\u062F\u0627\u064A\u0629 \u0639\u0646\u062F\u0645\u0627 \u0644\u0627 \u062A\u0643\u0648\u0646 \u0623\u064A \u0645\u062D\u0627\u062F\u062B\u0629 \u0645\u0641\u062A\u0648\u062D\u0629: \u0627\u062E\u062A\u0631 \u0645\u062D\u0627\u062F\u062B\u0629 \u0623\u0648 \u0642\u0646\u0627\u0629 \u0645\u0646 \u0627\u0644\u0642\u0627\u0626\u0645\u0629."
            },
            newConversation: {
              term: "\u0645\u062D\u0627\u062F\u062B\u0629 \u062C\u062F\u064A\u062F\u0629",
              text: "\u0632\u0631 \u0647\u0630\u0647 \u0627\u0644\u0634\u0627\u0634\u0629 \u064A\u0641\u062A\u062D \u0627\u0644\u0646\u0627\u0641\u0630\u0629 \u0646\u0641\u0633\u0647\u0627 \u0627\u0644\u062A\u064A \u064A\u0641\u062A\u062D\u0647\u0627 \u0632\u0631 \u0627\u0644\u0642\u0627\u0626\u0645\u0629."
            }
          }
        },
        conversation: {
          title: "\u0645\u062D\u0627\u062F\u062B\u0629",
          items: {
            header: {
              term: "\u0627\u0644\u0627\u0633\u0645 \u0648\u0627\u0644\u0645\u0648\u0636\u0648\u0639",
              text: "\u0641\u064A \u0627\u0644\u0623\u0639\u0644\u0649: \u0627\u0633\u0645 \u0627\u0644\u0642\u0646\u0627\u0629 \u0623\u0648 \u0627\u0644\u0634\u062E\u0635. \u062A\u062D\u062A\u0647 \u0645\u0648\u0636\u0648\u0639 \u0627\u0644\u0642\u0646\u0627\u0629\u060C \u0623\u0648 \u0639\u062F\u062F \u0623\u0634\u062E\u0627\u0635 \u0627\u0644\u0645\u062C\u0645\u0648\u0639\u0629."
            },
            call: {
              term: "\u0627\u062A\u0635\u0627\u0644",
              text: "\u064A\u0628\u062F\u0623 \u0645\u0643\u0627\u0644\u0645\u0629 \u0641\u064A \u0627\u0644\u0645\u062D\u0627\u062F\u062B\u0629 \u0648\u064A\u0641\u062A\u062D \u0627\u0644\u0642\u0627\u0639\u0629\u061B \u064A\u064F\u062A\u0635\u0644 \u0628\u0627\u0644\u0623\u0639\u0636\u0627\u0621. \u0645\u062A\u0627\u062D \u0641\u064A \u0627\u0644\u0645\u062D\u0627\u062F\u062B\u0627\u062A \u0627\u0644\u062E\u0627\u0635\u0629 \u0648\u0627\u0644\u0645\u062C\u0645\u0648\u0639\u0627\u062A \u0648\u0627\u0644\u0642\u0646\u0648\u0627\u062A \u0627\u0644\u062E\u0627\u0635\u0629."
            },
            pins: {
              term: "\u0627\u0644\u0631\u0633\u0627\u0626\u0644 \u0627\u0644\u0645\u062B\u0628\u0651\u062A\u0629",
              text: "\u064A\u0641\u062A\u062D \u0639\u0644\u0649 \u0627\u0644\u062C\u0627\u0646\u0628 \u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u0631\u0633\u0627\u0626\u0644 \u0627\u0644\u0645\u0647\u0645\u0629 \u0627\u0644\u0645\u062B\u0628\u0651\u062A\u0629 \u0641\u064A \u0647\u0630\u0647 \u0627\u0644\u0645\u062D\u0627\u062F\u062B\u0629. \u0627\u0644\u0631\u0642\u0645 \u0628\u064A\u0646 \u0627\u0644\u0642\u0648\u0633\u064A\u0646 \u0647\u0648 \u0639\u062F\u062F\u0647\u0627."
            },
            dates: {
              term: "\u0627\u0644\u064A\u0648\u0645\u060C \u0623\u0645\u0633",
              text: "\u062A\u064F\u062C\u0645\u064E\u0651\u0639 \u0627\u0644\u0631\u0633\u0627\u0626\u0644 \u062D\u0633\u0628 \u0627\u0644\u064A\u0648\u0645. \u0627\u0644\u0623\u062D\u062F\u062B \u0641\u064A \u0627\u0644\u0623\u0633\u0641\u0644\u060C \u0648\u062A\u0635\u0644 \u0631\u0633\u0627\u0626\u0644 \u0627\u0644\u0632\u0645\u0644\u0627\u0621 \u0627\u0644\u062C\u062F\u064A\u062F\u0629 \u062A\u0628\u0627\u0639\u064B\u0627."
            },
            latest: {
              term: "\u0623\u062D\u062F\u062B \u0627\u0644\u0631\u0633\u0627\u0626\u0644",
              text: "\u0632\u0631 \u064A\u0638\u0647\u0631 \u0639\u0646\u062F\u0645\u0627 \u062A\u0635\u0639\u062F \u0641\u064A \u0627\u0644\u0645\u062D\u0627\u062F\u062B\u0629: \u064A\u0639\u064A\u062F\u0643 \u0625\u0644\u0649 \u0627\u0644\u0623\u0633\u0641\u0644. \u0648\u0641\u064A \u0627\u0644\u0623\u0639\u0644\u0649 \u062A\u0638\u0647\u0631 \xAB\u062C\u0627\u0631\u064D \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0631\u0633\u0627\u0626\u0644 \u0627\u0644\u0633\u0627\u0628\u0642\u0629\u2026\xBB \u0623\u062B\u0646\u0627\u0621 \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0633\u062C\u0644."
            },
            notice: {
              term: "\u0642\u0646\u0627\u0629 \u0645\u0624\u0631\u0634\u0641\u0629\u060C \u0642\u0631\u0627\u0621\u0629 \u0641\u0642\u0637",
              text: "\u0625\u0630\u0627 \u0643\u0627\u0646\u062A \u0627\u0644\u0642\u0646\u0627\u0629 \u0645\u0624\u0631\u0634\u0641\u0629 \u062A\u0642\u0648\u0644 \u0631\u0633\u0627\u0644\u0629 \u0625\u0646\u0647 \u064A\u0645\u0643\u0646\u0643 \u0642\u0631\u0627\u0621\u062A\u0647\u0627 \u0644\u0643\u0646 \u0644\u0627 \u064A\u0645\u0643\u0646\u0643 \u0627\u0644\u0643\u062A\u0627\u0628\u0629 \u0641\u064A\u0647\u0627. \u0648\u0643\u0630\u0644\u0643 \u0625\u0630\u0627 \u0644\u0645 \u064A\u0643\u0646 \u0644\u0643 \u062D\u0642 \u0627\u0644\u0643\u062A\u0627\u0628\u0629: \u062A\u064F\u0633\u062A\u0628\u062F\u0644 \u062E\u0627\u0646\u0629 \u0627\u0644\u0643\u062A\u0627\u0628\u0629 \u0628\u0647\u0630\u0647 \u0627\u0644\u062C\u0645\u0644\u0629."
            },
            empty: {
              term: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0631\u0633\u0627\u0626\u0644 \u0628\u0639\u062F",
              text: "\u0645\u062D\u0627\u062F\u062B\u0629 \u0641\u0627\u0631\u063A\u0629: \u0627\u0643\u062A\u0628 \u0623\u0648\u0644 \u0631\u0633\u0627\u0644\u0629."
            },
            unavailable: {
              term: "\u0627\u0644\u0645\u062D\u0627\u062F\u062B\u0629 \u063A\u064A\u0631 \u0645\u0648\u062C\u0648\u062F\u0629",
              text: "\u0627\u0644\u0645\u062D\u0627\u062F\u062B\u0629 \u0644\u0645 \u062A\u0639\u062F \u0645\u0648\u062C\u0648\u062F\u0629 \u0623\u0648 \u0644\u0627 \u062A\u0645\u0644\u0643 \u0635\u0644\u0627\u062D\u064A\u0629 \u0627\u0644\u0648\u0635\u0648\u0644 \u0625\u0644\u064A\u0647\u0627. \u0627\u0644\u0632\u0631 \xAB\u0627\u0644\u0639\u0648\u062F\u0629 \u0625\u0644\u0649 \u0627\u0644\u0645\u062D\u0627\u062F\u062B\u0627\u062A\xBB \u064A\u0639\u064A\u062F\u0643 \u0625\u0644\u0649 \u0634\u0627\u0634\u0629 \u0627\u0644\u0628\u062F\u0627\u064A\u0629."
            }
          }
        },
        messages: {
          title: "\u0631\u0633\u0627\u0644\u0629",
          items: {
            author: {
              term: "\u0627\u0644\u0643\u0627\u062A\u0628 \u0648\u0627\u0644\u0648\u0642\u062A",
              text: "\u062A\u0639\u0631\u0636 \u0643\u0644 \u0631\u0633\u0627\u0644\u0629 \u0627\u0644\u0634\u062E\u0635 \u0627\u0644\u0630\u064A \u0643\u062A\u0628\u0647\u0627 \u0648\u0648\u0642\u062A\u0647\u0627 \u0648\u0646\u0635\u0647\u0627."
            },
            external: {
              term: "\u062E\u0627\u0631\u062C\u064A",
              text: "\u062A\u0634\u064A\u0631 \u0627\u0644\u0648\u0633\u0645\u0629 \xAB\u062E\u0627\u0631\u062C\u064A \xB7\xBB \u0645\u062A\u0628\u0648\u0639\u0629 \u0628\u0627\u0633\u0645 \u0627\u0644\u0645\u0624\u0633\u0633\u0629 \u0625\u0644\u0649 \u0634\u062E\u0635 \u0645\u0646 \u0645\u0624\u0633\u0633\u0629 \u0623\u062E\u0631\u0649 \u0645\u062F\u0639\u0648 \u0625\u0644\u0649 \u0641\u0636\u0627\u0621 \u0645\u0634\u062A\u0631\u0643."
            },
            edited: {
              term: "\u0645\u0639\u062F\u0651\u0644\u0629",
              text: "\u0635\u062D\u0651\u062D \u0643\u0627\u062A\u0628\u0647\u0627 \u0627\u0644\u0631\u0633\u0627\u0644\u0629 \u0628\u0639\u062F \u0625\u0631\u0633\u0627\u0644\u0647\u0627."
            },
            pinned: {
              term: "\u0645\u062B\u0628\u0651\u062A\u0629",
              text: "\u0648\u0633\u0645\u0629 \u0639\u0644\u0649 \u0631\u0633\u0627\u0644\u0629 \u0645\u062B\u0628\u0651\u062A\u0629 \u0641\u064A \u0627\u0644\u0645\u062D\u0627\u062F\u062B\u0629."
            },
            deleted: {
              term: "\u062A\u0645 \u062D\u0630\u0641 \u0647\u0630\u0647 \u0627\u0644\u0631\u0633\u0627\u0644\u0629.",
              text: "\u062C\u0645\u0644\u0629 \u062A\u062D\u0644 \u0645\u062D\u0644 \u0631\u0633\u0627\u0644\u0629 \u0645\u062D\u0630\u0648\u0641\u0629\u060C \u0644\u0644\u062C\u0645\u064A\u0639."
            },
            reactions: {
              term: "\u0627\u0644\u062A\u0641\u0627\u0639\u0644\u0627\u062A",
              text: "\u062A\u062D\u062A \u0627\u0644\u0631\u0633\u0627\u0644\u0629\u060C \u0634\u0627\u0631\u0629 \u0644\u0643\u0644 \u0631\u0645\u0632 \u062A\u0639\u0628\u064A\u0631\u064A \u0645\u0639 \u0639\u062F\u062F\u0647. \u0627\u0636\u063A\u0637 \u0639\u0644\u0649 \u0634\u0627\u0631\u0629 \u0644\u0625\u0636\u0627\u0641\u0629 \u062A\u0641\u0627\u0639\u0644\u0643 \u0623\u0648 \u0633\u062D\u0628\u0647\u061B \u062A\u064F\u0628\u0631\u064E\u0632 \u0627\u0644\u0634\u0627\u0631\u0629 \u0639\u0646\u062F\u0645\u0627 \u064A\u0643\u0648\u0646 \u0627\u0644\u062A\u0641\u0627\u0639\u0644 \u062A\u0641\u0627\u0639\u0644\u0643."
            },
            thread: {
              term: "\u0627\u0644\u0631\u062F\u0648\u062F",
              text: "\u0631\u0627\u0628\u0637 \u0645\u0646 \u0646\u0648\u0639 \xAB\u0631\u062F\u0651\u0627\u0646\xBB \u062A\u062D\u062A \u0627\u0644\u0631\u0633\u0627\u0644\u0629 \u064A\u0641\u062A\u062D \u0633\u0644\u0633\u0644\u0629 \u0646\u0642\u0627\u0634\u0647\u0627 \u0639\u0644\u0649 \u0627\u0644\u062C\u0627\u0646\u0628."
            },
            sendStatus: {
              term: "\u062C\u0627\u0631\u064D \u0627\u0644\u0625\u0631\u0633\u0627\u0644\u2026",
              text: "\u0623\u062B\u0646\u0627\u0621 \u0627\u0644\u0625\u0631\u0633\u0627\u0644 \u062A\u0643\u0648\u0646 \u0627\u0644\u0631\u0633\u0627\u0644\u0629 \u0628\u0627\u0647\u062A\u0629. \u0625\u0630\u0627 \u0627\u0646\u0642\u0637\u0639 \u0627\u0644\u0627\u062A\u0635\u0627\u0644 \u062A\u0638\u0647\u0631 \xAB\u0644\u0645 \u062A\u064F\u0631\u0633\u0644 \u0627\u0644\u0631\u0633\u0627\u0644\u0629.\xBB \u0645\u0639 \u062B\u0644\u0627\u062B\u0629 \u0623\u0632\u0631\u0627\u0631: \xAB\u0625\u0639\u0627\u062F\u0629 \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629\xBB \u0648\xAB\u0627\u0633\u062A\u0631\u062C\u0627\u0639 \u0627\u0644\u0646\u0635\xBB (\u064A\u0639\u064A\u062F \u0627\u0644\u0646\u0635 \u0625\u0644\u0649 \u062E\u0627\u0646\u0629 \u0627\u0644\u0643\u062A\u0627\u0628\u0629) \u0648\xAB\u062D\u0630\u0641\xBB."
            }
          }
        },
        messageActions: {
          title: "\u0625\u062C\u0631\u0627\u0621\u0627\u062A \u0639\u0644\u0649 \u0631\u0633\u0627\u0644\u0629",
          items: {
            react: {
              term: "\u0625\u0636\u0627\u0641\u0629 \u062A\u0641\u0627\u0639\u0644",
              text: "\u064A\u0641\u062A\u062D \u062B\u0645\u0627\u0646\u064A\u0629 \u0631\u0645\u0648\u0632 \u062A\u0639\u0628\u064A\u0631\u064A\u0629 \u0644\u0644\u0627\u062E\u062A\u064A\u0627\u0631: \u0625\u0628\u0647\u0627\u0645 \u0645\u0631\u0641\u0648\u0639 \u0648\u0639\u0644\u0627\u0645\u0629 \u0635\u062D \u062E\u0636\u0631\u0627\u0621 \u0648\u0642\u0644\u0628 \u0648\u0636\u062D\u0643 \u0648\u062F\u0647\u0634\u0629 \u0648\u064A\u062F\u0627\u0646 \u0645\u062A\u0634\u0627\u0628\u0643\u062A\u0627\u0646 \u0648\u0639\u064A\u0646\u0627\u0646 \u0648\u0627\u062D\u062A\u0641\u0627\u0644."
            },
            reply: {
              term: "\u0627\u0644\u0631\u062F \u0641\u064A \u0633\u0644\u0633\u0644\u0629",
              text: "\u064A\u0641\u062A\u062D \u0633\u0644\u0633\u0644\u0629 \u0627\u0644\u0631\u0633\u0627\u0644\u0629 \u0639\u0644\u0649 \u0627\u0644\u062C\u0627\u0646\u0628 \u0644\u0644\u0631\u062F \u0639\u0644\u064A\u0647\u0627 \u062F\u0648\u0646 \u0625\u0632\u0639\u0627\u062C \u0627\u0644\u0645\u062D\u0627\u062F\u062B\u0629."
            },
            pin: {
              term: "\u062A\u062B\u0628\u064A\u062A \u0627\u0644\u0631\u0633\u0627\u0644\u0629",
              text: "\u064A\u064F\u0628\u0642\u064A \u0627\u0644\u0631\u0633\u0627\u0644\u0629 \u0628\u0627\u0631\u0632\u0629 \u0641\u064A \xAB\u0627\u0644\u0631\u0633\u0627\u0626\u0644 \u0627\u0644\u0645\u062B\u0628\u0651\u062A\u0629\xBB. \u064A\u0635\u0628\u062D \u0627\u0644\u0632\u0631 \u0646\u0641\u0633\u0647 \xAB\u0625\u0644\u063A\u0627\u0621 \u062A\u062B\u0628\u064A\u062A \u0627\u0644\u0631\u0633\u0627\u0644\u0629\xBB. \u064A\u0644\u0632\u0645 \u0623\u0646 \u064A\u0643\u0648\u0646 \u0644\u0643 \u062D\u0642 \u0627\u0644\u0643\u062A\u0627\u0628\u0629. \u062A\u0636\u0645 \u0627\u0644\u0645\u062D\u0627\u062F\u062B\u0629 50 \u0631\u0633\u0627\u0644\u0629 \u0645\u062B\u0628\u0651\u062A\u0629 \u0643\u062D\u062F \u0623\u0642\u0635\u0649."
            },
            edit: {
              term: "\u062A\u0639\u062F\u064A\u0644 \u0627\u0644\u0631\u0633\u0627\u0644\u0629",
              text: "\u0645\u062E\u0635\u0635 \u0644\u0643\u0627\u062A\u0628 \u0627\u0644\u0631\u0633\u0627\u0644\u0629. \u064A\u0635\u0628\u062D \u0627\u0644\u0646\u0635 \u0642\u0627\u0628\u0644\u064B\u0627 \u0644\u0644\u062A\u0639\u062F\u064A\u0644 \u0641\u064A \u0645\u0643\u0627\u0646\u0647."
            },
            delete: {
              term: "\u062D\u0630\u0641 \u0627\u0644\u0631\u0633\u0627\u0644\u0629",
              text: "\u0644\u0643\u0627\u062A\u0628\u0647\u0627\u060C \u0623\u0648 \u0644\u0644\u0645\u0634\u0631\u0641\u064A\u0646 \u0639\u0644\u0649 \u0623\u064A \u0631\u0633\u0627\u0644\u0629."
            },
            deleteDialog: {
              term: "\u062D\u0630\u0641 \u0631\u0633\u0627\u0644\u0629\u2026\u061F",
              text: "\u0646\u0627\u0641\u0630\u0629 \u062A\u0623\u0643\u064A\u062F: \u062A\u064F\u0633\u062A\u0628\u062F\u0644 \u0627\u0644\u0631\u0633\u0627\u0644\u0629 \u0628\u0639\u0628\u0627\u0631\u0629 \xAB\u062A\u0645 \u062D\u0630\u0641 \u0647\u0630\u0647 \u0627\u0644\u0631\u0633\u0627\u0644\u0629\xBB \u0644\u0644\u062C\u0645\u064A\u0639\u060C \u0648\u0644\u0627 \u064A\u0645\u0643\u0646 \u0627\u0644\u062A\u0631\u0627\u062C\u0639."
            }
          }
        },
        composer: {
          title: "\u0643\u062A\u0627\u0628\u0629 \u0631\u0633\u0627\u0644\u0629",
          items: {
            field: {
              term: "\u0627\u0643\u062A\u0628 \u0631\u0633\u0627\u0644\u0629",
              text: "\u062E\u0627\u0646\u0629 \u0627\u0644\u0643\u062A\u0627\u0628\u0629 \u0623\u0633\u0641\u0644 \u0627\u0644\u0645\u062D\u0627\u062F\u062B\u0629. \u062A\u0642\u0628\u0644 \u0627\u0644\u062A\u0646\u0633\u064A\u0642 \u0648\u0627\u0644\u0625\u0634\u0627\u0631\u0627\u062A: \u0627\u0643\u062A\u0628 \u2066@\u2069 \u062B\u0645 \u0627\u0633\u0645 \u0627\u0644\u0634\u062E\u0635 \u0644\u0644\u0625\u0634\u0627\u0631\u0629 \u0625\u0644\u064A\u0647."
            },
            hint: {
              term: "\u0645\u0633\u0627\u0639\u062F\u0629 \u0627\u0644\u0643\u062A\u0627\u0628\u0629",
              text: "\u2066Enter\u2069 \u0644\u0644\u0625\u0631\u0633\u0627\u0644\u060C \u0648\u2066Shift+Enter\u2069 \u0644\u0633\u0637\u0631 \u062C\u062F\u064A\u062F\u060C \u0648\u2066@\u2069 \u0644\u0644\u0625\u0634\u0627\u0631\u0629 \u0625\u0644\u0649 \u0634\u062E\u0635."
            },
            send: {
              term: "\u0625\u0631\u0633\u0627\u0644",
              text: "\u064A\u0631\u0633\u0644 \u0627\u0644\u0631\u0633\u0627\u0644\u0629. \u064A\u0644\u0632\u0645 \u0646\u0635 \u0623\u0648 \u0645\u0644\u0641 \u0645\u0631\u0641\u0642 \u0648\u0627\u062D\u062F \u0639\u0644\u0649 \u0627\u0644\u0623\u0642\u0644."
            },
            attach: {
              term: "\u0625\u0631\u0641\u0627\u0642 \u0645\u0644\u0641",
              text: "\u0627\u062E\u062A\u0631 \u0645\u0644\u0641\u064B\u0627 \u0623\u0648 \u0639\u062F\u0629 \u0645\u0644\u0641\u0627\u062A \u0645\u0646 \u062C\u0647\u0627\u0632\u0643. \u064A\u0645\u0643\u0646 \u0623\u0646 \u062A\u062D\u062A\u0648\u064A \u0627\u0644\u0631\u0633\u0627\u0644\u0629 \u0639\u0644\u0649 10 \u0645\u0644\u0641\u0627\u062A \u0643\u062D\u062F \u0623\u0642\u0635\u0649."
            },
            attachNotices: {
              term: "\u0631\u0633\u0627\u0626\u0644 \u062D\u0648\u0644 \u0627\u0644\u0645\u0631\u0641\u0642\u0627\u062A",
              text: "\u0625\u0630\u0627 \u0644\u0645 \u064A\u0643\u0646 \u0644\u0643 \u062D\u0642 \u0625\u0636\u0627\u0641\u0629 \u0645\u0644\u0641\u0627\u062A \u062A\u062E\u0628\u0631\u0643 \u0631\u0633\u0627\u0644\u0629 \u0628\u0630\u0644\u0643. \u0648\u0645\u0627 \u062F\u0627\u0645\u062A \u0645\u0644\u0641\u0627\u062A \u0642\u064A\u062F \u0627\u0644\u0625\u0631\u0633\u0627\u0644 \u064A\u062C\u0628 \u0627\u0644\u0627\u0646\u062A\u0638\u0627\u0631 \u0642\u0628\u0644 \u0625\u0631\u0633\u0627\u0644 \u0627\u0644\u0631\u0633\u0627\u0644\u0629."
            },
            cards: {
              term: "\u0627\u0644\u0645\u0644\u0641\u0627\u062A \u0627\u0644\u0645\u0631\u0641\u0642\u0629",
              text: "\u064A\u0635\u0628\u062D \u0643\u0644 \u0645\u0644\u0641 \u0628\u0637\u0627\u0642\u0629 \u062A\u062D\u062A \u0627\u0644\u0631\u0633\u0627\u0644\u0629 \u0645\u0639 \u062D\u0627\u0644\u062A\u0647: \xAB\u062C\u0627\u0631\u064D \u0627\u0644\u0625\u0631\u0633\u0627\u0644\xBB \u0623\u0648 \xAB\u062C\u0627\u0631\u064D \u0627\u0644\u0641\u062D\u0635 \u0628\u0645\u0636\u0627\u062F \u0627\u0644\u0641\u064A\u0631\u0648\u0633\u0627\u062A\xBB \u0623\u0648 \xAB\u0645\u062A\u0627\u062D\xBB \u0623\u0648 \xAB\u0631\u0641\u0636 \u0627\u0644\u0641\u062D\u0635 \u0628\u0645\u0636\u0627\u062F \u0627\u0644\u0641\u064A\u0631\u0648\u0633\u0627\u062A \u0647\u0630\u0627 \u0627\u0644\u0645\u0644\u0641\xBB."
            },
            cardActions: {
              term: "\u0641\u062A\u062D\u060C \u062A\u0646\u0632\u064A\u0644",
              text: "\xAB\u0641\u062A\u062D\xBB \u064A\u0639\u0631\u0636 \u0627\u0644\u0645\u0644\u0641. \xAB\u062A\u0646\u0632\u064A\u0644\xBB \u064A\u0623\u062E\u0630 \u0646\u0633\u062E\u0629 \u0645\u0646\u0647\u060C \u0625\u0644\u0627 \u0625\u0630\u0627 \u0643\u0627\u0646 \u0627\u0644\u062A\u0646\u0632\u064A\u0644 \u0645\u0645\u0646\u0648\u0639\u064B\u0627 \u0641\u064A \u0647\u0630\u0647 \u0627\u0644\u0645\u0633\u0627\u062D\u0629. \u0625\u0630\u0627 \u0644\u0645 \u064A\u0643\u0646 \u0644\u0643 \u062D\u0642 \u0627\u0644\u0648\u0635\u0648\u0644 \u0625\u0644\u0649 \u0627\u0644\u0645\u062C\u0644\u062F \u062A\u0642\u0648\u0644 \u0627\u0644\u0628\u0637\u0627\u0642\u0629 \xAB\u0644\u064A\u0633\u062A \u0644\u062F\u064A\u0643 \u0635\u0644\u0627\u062D\u064A\u0629 \u0627\u0644\u0648\u0635\u0648\u0644 \u0625\u0644\u0649 \u0647\u0630\u0627 \u0627\u0644\u0645\u0644\u0641\xBB: \u0627\u0637\u0644\u0628 \u0627\u0644\u0635\u0644\u0627\u062D\u064A\u0629 \u0645\u0646 \u0627\u0644\u0634\u062E\u0635 \u0627\u0644\u0630\u064A \u0623\u0631\u0633\u0644\u0647."
            },
            typing: {
              term: "\u064A\u0643\u062A\u0628\u2026",
              text: "\u0641\u0648\u0642 \u062E\u0627\u0646\u0629 \u0627\u0644\u0643\u062A\u0627\u0628\u0629\u060C \u0633\u0637\u0631 \u064A\u0628\u064A\u0651\u0646 \u0645\u0646 \u064A\u0643\u062A\u0628 \u0627\u0644\u0622\u0646."
            }
          }
        },
        panels: {
          title: "\u0627\u0644\u0644\u0648\u062D\u0629 \u0627\u0644\u062C\u0627\u0646\u0628\u064A\u0629: \u0627\u0644\u0633\u0644\u0633\u0644\u0629 \u0648\u0627\u0644\u0631\u0633\u0627\u0626\u0644 \u0627\u0644\u0645\u062B\u0628\u0651\u062A\u0629",
          items: {
            thread: {
              term: "\u0633\u0644\u0633\u0644\u0629 \u0627\u0644\u0646\u0642\u0627\u0634",
              text: "\u0627\u0644\u0631\u0633\u0627\u0644\u0629 \u0627\u0644\u0623\u0635\u0644\u064A\u0629 \u062B\u0645 \u0627\u0644\u0631\u062F\u0648\u062F \u0627\u0644\u0645\u0631\u062A\u0628\u0637\u0629 \u0628\u0647\u0627 \u0645\u0639 \u0639\u062F\u062F\u0647\u0627. \u0625\u0646 \u0644\u0645 \u064A\u0648\u062C\u062F \u0631\u062F: \xAB\u0644\u0627 \u062A\u0648\u062C\u062F \u0631\u062F\u0648\u062F \u0628\u0639\u062F. \u0627\u0643\u062A\u0628 \u0623\u0648\u0644 \u0631\u062F.\xBB"
            },
            threadReply: {
              term: "\u0627\u0644\u0631\u062F \u0641\u064A \u0627\u0644\u0633\u0644\u0633\u0644\u0629",
              text: "\u062E\u0627\u0646\u0629 \u0627\u0644\u0643\u062A\u0627\u0628\u0629 \u0627\u0644\u062E\u0627\u0635\u0629 \u0628\u0627\u0644\u0633\u0644\u0633\u0644\u0629 \u0645\u0639 \u0632\u0631 \xAB\u0631\u062F\xBB."
            },
            rootDeleted: {
              term: "\u062D\u064F\u0630\u0641\u062A \u0627\u0644\u0631\u0633\u0627\u0644\u0629 \u0627\u0644\u0623\u0635\u0644\u064A\u0629",
              text: "\u064A\u0645\u0643\u0646 \u0625\u0639\u0627\u062F\u0629 \u0642\u0631\u0627\u0621\u0629 \u0627\u0644\u0633\u0644\u0633\u0644\u0629 \u0644\u0643\u0646 \u0644\u0645 \u064A\u0639\u062F \u0628\u0627\u0644\u0625\u0645\u0643\u0627\u0646 \u0627\u0644\u0631\u062F \u0641\u064A\u0647\u0627."
            },
            pins: {
              term: "\u0627\u0644\u0631\u0633\u0627\u0626\u0644 \u0627\u0644\u0645\u062B\u0628\u0651\u062A\u0629",
              text: "\u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u0631\u0633\u0627\u0626\u0644 \u0627\u0644\u0645\u062B\u0628\u0651\u062A\u0629 \u0641\u064A \u0627\u0644\u0645\u062D\u0627\u062F\u062B\u0629. \u0648\u0639\u0646\u062F\u0645\u0627 \u062A\u0643\u0648\u0646 \u0641\u0627\u0631\u063A\u0629 \u062A\u0642\u062A\u0631\u062D \u062A\u062B\u0628\u064A\u062A \u0631\u0633\u0627\u0644\u0629 \u0645\u0647\u0645\u0629."
            },
            pinShow: {
              term: "\u0639\u0631\u0636 \u0641\u064A \u0627\u0644\u0645\u062D\u0627\u062F\u062B\u0629",
              text: "\u064A\u0645\u0631\u0651\u0631 \u0627\u0644\u0645\u062D\u0627\u062F\u062B\u0629 \u0625\u0644\u0649 \u0627\u0644\u0631\u0633\u0627\u0644\u0629 \u0627\u0644\u0645\u062B\u0628\u0651\u062A\u0629 \u0648\u064A\u0628\u0631\u0632\u0647\u0627."
            },
            pinThread: {
              term: "\u0641\u062A\u062D \u0627\u0644\u0633\u0644\u0633\u0644\u0629",
              text: "\u064A\u0641\u062A\u062D \u0633\u0644\u0633\u0644\u0629 \u0646\u0642\u0627\u0634 \u0627\u0644\u0631\u0633\u0627\u0644\u0629 \u0627\u0644\u0645\u062B\u0628\u0651\u062A\u0629."
            },
            pinUnpin: {
              term: "\u0625\u0644\u063A\u0627\u0621 \u062A\u062B\u0628\u064A\u062A \u0627\u0644\u0631\u0633\u0627\u0644\u0629",
              text: "\u064A\u0632\u064A\u0644 \u0627\u0644\u0631\u0633\u0627\u0644\u0629 \u0645\u0646 \u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u0645\u062B\u0628\u0651\u062A\u0629."
            },
            close: {
              term: "\u0625\u063A\u0644\u0627\u0642 \u0627\u0644\u0644\u0648\u062D\u0629",
              text: "\u064A\u063A\u0644\u0642 \u0627\u0644\u0644\u0648\u062D\u0629 \u0627\u0644\u062C\u0627\u0646\u0628\u064A\u0629 (\u0648\u0627\u0644\u0645\u0641\u062A\u0627\u062D \u2066Esc\u2069 \u0643\u0630\u0644\u0643)."
            }
          }
        },
        dialogs: {
          title: "\u0645\u062D\u0627\u062F\u062B\u0629 \u062C\u062F\u064A\u062F\u0629 \u0648\u0642\u0646\u0627\u0629 \u062C\u062F\u064A\u062F\u0629",
          items: {
            people: {
              term: "\u0627\u0644\u0623\u0634\u062E\u0627\u0635",
              text: "\u0645\u062D\u0627\u062F\u062B\u0629 \u062C\u062F\u064A\u062F\u0629: \u0627\u062E\u062A\u0631 \u0632\u0645\u064A\u0644\u064B\u0627 \u0644\u0645\u062D\u0627\u062F\u062B\u0629 \u062E\u0627\u0635\u0629\u060C \u0648\u0639\u062F\u0629 \u0632\u0645\u0644\u0627\u0621 \u0644\u0645\u062C\u0645\u0648\u0639\u0629. \u0627\u0644\u0627\u062E\u062A\u064A\u0627\u0631 \u0625\u0644\u0632\u0627\u0645\u064A."
            },
            groupName: {
              term: "\u0627\u0633\u0645 \u0627\u0644\u0645\u062C\u0645\u0648\u0639\u0629",
              text: "\u0645\u0637\u0644\u0648\u0628 \u0644\u0644\u0645\u062C\u0645\u0648\u0639\u0629 \u0641\u0642\u0637 (\u0639\u062F\u0629 \u0623\u0634\u062E\u0627\u0635). \u0627\u0644\u0632\u0631 \xAB\u0625\u0646\u0634\u0627\u0621 \u0627\u0644\u0645\u062D\u0627\u062F\u062B\u0629\xBB \u064A\u0646\u0647\u064A \u0627\u0644\u0639\u0645\u0644\u064A\u0629."
            },
            kind: {
              term: "\u0646\u0648\u0639 \u0627\u0644\u0642\u0646\u0627\u0629",
              text: "\u0639\u0627\u0645\u0629 \u0623\u0648 \u0627\u062E\u062A\u0635\u0627\u0635: \u0638\u0627\u0647\u0631\u0629 \u0644\u062C\u0645\u064A\u0639 \u0623\u0639\u0636\u0627\u0621 \u0627\u0644\u0645\u0634\u0631\u0648\u0639. \u062E\u0627\u0635\u0629: \u0645\u062E\u0635\u0635\u0629 \u0644\u0644\u0623\u0634\u062E\u0627\u0635 \u0627\u0644\u0645\u062E\u062A\u0627\u0631\u064A\u0646."
            },
            channelName: {
              term: "\u0627\u0633\u0645 \u0627\u0644\u0642\u0646\u0627\u0629",
              text: "\u0625\u0644\u0632\u0627\u0645\u064A. \u0644\u0627 \u064A\u0645\u0643\u0646 \u0623\u0646 \u062A\u0648\u062C\u062F \u0642\u0646\u0627\u062A\u0627\u0646 \u0628\u0627\u0644\u0627\u0633\u0645 \u0646\u0641\u0633\u0647 \u0641\u064A \u0627\u0644\u0645\u0634\u0631\u0648\u0639."
            },
            discipline: {
              term: "\u0627\u0644\u0627\u062E\u062A\u0635\u0627\u0635",
              text: "\u0645\u0637\u0644\u0648\u0628 \u0644\u0642\u0646\u0627\u0629 \u0627\u062E\u062A\u0635\u0627\u0635: \u0627\u0644\u0639\u0645\u0627\u0631\u0629 \u0623\u0648 \u0627\u0644\u0647\u064A\u0627\u0643\u0644 \u0623\u0648 \u0627\u0644\u0637\u0631\u0642 \u0648\u0627\u0644\u0634\u0628\u0643\u0627\u062A \u0627\u0644\u0645\u062E\u062A\u0644\u0641\u0629 (\u2066VRD\u2069) \u0623\u0648 \u0627\u0644\u0645\u0648\u0627\u0626\u0639 \u0623\u0648 \u0627\u0644\u0643\u0647\u0631\u0628\u0627\u0621 \u0623\u0648 \u0627\u0644\u0637\u0648\u0628\u0648\u063A\u0631\u0627\u0641\u064A\u0627 \u0623\u0648 \u0627\u0644\u062C\u064A\u0648\u062A\u0642\u0646\u064A\u0629 \u0623\u0648 \u0627\u0644\u062A\u0646\u0633\u064A\u0642 \u0648\u0627\u0644\u0645\u062A\u0627\u0628\u0639\u0629 (\u2066OPC\u2069)."
            },
            topic: {
              term: "\u0627\u0644\u0645\u0648\u0636\u0648\u0639 (\u0627\u062E\u062A\u064A\u0627\u0631\u064A)",
              text: "\u062C\u0645\u0644\u0629 \u062A\u0628\u064A\u0651\u0646 \u0645\u0648\u0636\u0648\u0639 \u0627\u0644\u0642\u0646\u0627\u0629."
            },
            members: {
              term: "\u0623\u0639\u0636\u0627\u0621 \u0627\u0644\u0642\u0646\u0627\u0629",
              text: "\u0641\u064A \u0627\u0644\u0642\u0646\u0627\u0629 \u0627\u0644\u062E\u0627\u0635\u0629\u060C \u0627\u0644\u0623\u0634\u062E\u0627\u0635 \u0627\u0644\u0630\u064A\u0646 \u0633\u064A\u0635\u0644\u0648\u0646 \u0625\u0644\u064A\u0647\u0627. \u0623\u0646\u062A \u0639\u0636\u0648 \u0641\u064A\u0647\u0627 \u062A\u0644\u0642\u0627\u0626\u064A\u064B\u0627."
            },
            submit: {
              term: "\u0625\u0646\u0634\u0627\u0621 \u0627\u0644\u0642\u0646\u0627\u0629",
              text: "\u064A\u0646\u0634\u0626 \u0627\u0644\u0642\u0646\u0627\u0629. \xAB\u0625\u0644\u063A\u0627\u0621\xBB \u064A\u063A\u0644\u0642 \u0627\u0644\u0646\u0627\u0641\u0630\u0629 \u062F\u0648\u0646 \u0625\u0646\u0634\u0627\u0621 \u0634\u064A\u0621."
            }
          }
        }
      }
    },
    calendar: {
      title: "\u0627\u0644\u062A\u0642\u0648\u064A\u0645",
      intro: "\u0623\u062D\u062F\u0627\u062B\u0643: \u0627\u0644\u0627\u062C\u062A\u0645\u0627\u0639\u0627\u062A \u0648\u0632\u064A\u0627\u0631\u0627\u062A \u0627\u0644\u0648\u0631\u0634\u0627\u062A \u0648\u0622\u062C\u0627\u0644 \u0643\u0644 \u0645\u0634\u0627\u0631\u064A\u0639\u0643\u060C \u0641\u064A \u0623\u0631\u0628\u0639\u0629 \u0623\u0646\u0645\u0627\u0637 \u0639\u0631\u0636. \u0627\u0644\u062A\u0642\u0648\u064A\u0645 \u0627\u0644\u0645\u0635\u063A\u0651\u0631 \u0648\u0639\u0648\u0627\u0645\u0644 \u0627\u0644\u062A\u0635\u0641\u064A\u0629 \u0641\u064A \u0627\u0644\u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u062C\u0627\u0646\u0628\u064A\u0629.",
      sections: {
        header: {
          title: "\u0631\u0623\u0633 \u0627\u0644\u0635\u0641\u062D\u0629",
          items: {
            feeds: {
              term: "\u0627\u0634\u062A\u0631\u0627\u0643 \u2066ICS\u2069",
              text: "\u064A\u0641\u062A\u062D \u0646\u0627\u0641\u0630\u0629 \u0644\u0639\u0631\u0636 \u062A\u0642\u0648\u064A\u0645 \u2066BatiFlow\u2069 \u0641\u064A \u2066Outlook\u2069 \u0623\u0648 \u062A\u0642\u0648\u064A\u0645 \u2066Google\u2069 \u0623\u0648 \u062A\u0642\u0648\u064A\u0645 \u2066Apple\u2069."
            },
            newEvent: {
              term: "\u062D\u062F\u062B \u062C\u062F\u064A\u062F",
              text: "\u064A\u0641\u062A\u062D \u0646\u0645\u0648\u0630\u062C \u0625\u0646\u0634\u0627\u0621 \u062D\u062F\u062B\u060C \u0641\u064A \u0627\u0644\u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0645\u0639\u0631\u0648\u0636."
            }
          }
        },
        toolbar: {
          title: "\u0627\u0644\u062A\u0646\u0642\u0644 \u0641\u064A \u0627\u0644\u062A\u0642\u0648\u064A\u0645",
          items: {
            today: {
              term: "\u0627\u0644\u064A\u0648\u0645",
              text: "\u064A\u0639\u0648\u062F \u0625\u0644\u0649 \u062A\u0627\u0631\u064A\u062E \u0627\u0644\u064A\u0648\u0645."
            },
            arrows: {
              term: "\u0627\u0644\u0623\u0633\u0628\u0648\u0639 \u0627\u0644\u0633\u0627\u0628\u0642\u060C \u0627\u0644\u0623\u0633\u0628\u0648\u0639 \u0627\u0644\u062A\u0627\u0644\u064A",
              text: "\u064A\u062A\u0642\u062F\u0645 \u0627\u0644\u0633\u0647\u0645\u0627\u0646 \u0623\u0648 \u064A\u062A\u0631\u0627\u062C\u0639\u0627\u0646 \u0628\u0623\u0633\u0628\u0648\u0639\u060C \u0623\u0648 \u0628\u0634\u0647\u0631 \u0641\u064A \u0639\u0631\u0636\u064A \u0627\u0644\u0634\u0647\u0631 \u0648\u062C\u062F\u0648\u0644 \u0627\u0644\u0623\u0639\u0645\u0627\u0644."
            },
            period: {
              term: "\u0627\u0644\u0641\u062A\u0631\u0629 \u0627\u0644\u0645\u0639\u0631\u0648\u0636\u0629",
              text: "\u0627\u0644\u0639\u0646\u0648\u0627\u0646 \u0628\u062C\u0627\u0646\u0628 \u0627\u0644\u0633\u0647\u0645\u064A\u0646 \u064A\u0628\u064A\u0651\u0646 \u0627\u0644\u0623\u0633\u0628\u0648\u0639 \u0623\u0648 \u0627\u0644\u0634\u0647\u0631 \u0627\u0644\u062C\u0627\u0631\u064A \u0639\u0631\u0636\u0647."
            },
            week: {
              term: "\u0623\u0633\u0628\u0648\u0639",
              text: "\u0633\u0628\u0639\u0629 \u0623\u064A\u0627\u0645 \u0641\u064A \u0623\u0639\u0645\u062F\u0629\u060C \u0645\u0639 \u0627\u0644\u0633\u0627\u0639\u0627\u062A \u0639\u0644\u0649 \u0627\u0644\u062C\u0627\u0646\u0628."
            },
            workWeek: {
              term: "\u0623\u0633\u0628\u0648\u0639 \u0627\u0644\u0639\u0645\u0644",
              text: "\u0645\u062B\u0644 \u0639\u0631\u0636 \u0627\u0644\u0623\u0633\u0628\u0648\u0639\u060C \u0644\u0643\u0646 \u0645\u0646 \u0627\u0644\u0625\u062B\u0646\u064A\u0646 \u0625\u0644\u0649 \u0627\u0644\u062C\u0645\u0639\u0629 \u0641\u0642\u0637."
            },
            month: {
              term: "\u0634\u0647\u0631",
              text: "\u0634\u0628\u0643\u0629 \u0627\u0644\u0634\u0647\u0631. \u0627\u062E\u062A\u0631 \u064A\u0648\u0645\u064B\u0627 \u0644\u0631\u0624\u064A\u062A\u0647 \u0628\u0627\u0644\u062A\u0641\u0635\u064A\u0644."
            },
            agenda: {
              term: "\u062C\u062F\u0648\u0644 \u0627\u0644\u0623\u0639\u0645\u0627\u0644",
              text: "\u0642\u0627\u0626\u0645\u0629 \u0628\u0623\u062D\u062F\u0627\u062B\u0643 \u064A\u0648\u0645\u064B\u0627 \u0628\u064A\u0648\u0645\u060C \u0645\u0639 \u0627\u0644\u0633\u0627\u0639\u0629 \u0623\u0648 \xAB\u0637\u0648\u0627\u0644 \u0627\u0644\u064A\u0648\u0645\xBB."
            }
          }
        },
        legend: {
          title: "\u0623\u0646\u0648\u0627\u0639 \u0627\u0644\u0623\u062D\u062F\u0627\u062B",
          items: {
            meeting: {
              term: "\u0627\u062C\u062A\u0645\u0627\u0639",
              text: "\u0623\u064A\u0642\u0648\u0646\u0629 \u0623\u0634\u062E\u0627\u0635\u060C \u0644\u0648\u0646 \u0623\u0632\u0631\u0642."
            },
            siteVisit: {
              term: "\u0632\u064A\u0627\u0631\u0629 \u0648\u0631\u0634\u0629",
              text: "\u0623\u064A\u0642\u0648\u0646\u0629 \u0628\u0646\u0627\u064A\u0629\u060C \u0644\u0648\u0646 \u0623\u062E\u0636\u0631."
            },
            deadline: {
              term: "\u0623\u062C\u0644",
              text: "\u0623\u064A\u0642\u0648\u0646\u0629 \u0631\u0627\u064A\u0629\u060C \u0644\u0648\u0646 \u0623\u0635\u0641\u0631."
            },
            other: {
              term: "\u0622\u062E\u0631",
              text: "\u0623\u064A\u0642\u0648\u0646\u0629 \u062A\u0642\u0648\u064A\u0645\u060C \u0644\u0648\u0646 \u0628\u0646\u0641\u0633\u062C\u064A."
            },
            readOnly: {
              term: "\u0627\u0644\u0642\u0641\u0644",
              text: "\u0627\u0644\u0642\u0641\u0644 \u064A\u0634\u064A\u0631 \u0625\u0644\u0649 \u0623\u062C\u0644 \u0644\u0644\u0642\u0631\u0627\u0621\u0629 \u0641\u0642\u0637 (\u0645\u0647\u0645\u0629 \u0623\u0648 \u0645\u0631\u062D\u0644\u0629 \u0623\u0648 \u062A\u0623\u0634\u064A\u0631\u0629): \u0644\u0627 \u064A\u064F\u0639\u062F\u064E\u0651\u0644 \u0625\u0644\u0627 \u0645\u0646 \u0645\u0635\u062F\u0631\u0647. \u0644\u0643\u0644 \u0646\u0648\u0639 \u0623\u064A\u0636\u064B\u0627 \u0627\u0633\u0645 \u0645\u0643\u062A\u0648\u0628\u060C \u0641\u0627\u0644\u0644\u0648\u0646 \u0644\u0627 \u064A\u0643\u0648\u0646 \u0648\u062D\u062F\u0647 \u0623\u0628\u062F\u064B\u0627."
            }
          }
        },
        grid: {
          title: "\u0627\u0644\u0634\u0628\u0643\u0629 \u0648\u062C\u062F\u0648\u0644 \u0627\u0644\u0623\u0639\u0645\u0627\u0644",
          items: {
            allDay: {
              term: "\u0637\u0648\u0627\u0644 \u0627\u0644\u064A\u0648\u0645",
              text: "\u0633\u0637\u0631 \u0641\u064A \u0623\u0639\u0644\u0649 \u0639\u0631\u0648\u0636 \u0627\u0644\u0623\u0633\u0628\u0648\u0639: \u0627\u0644\u0623\u062D\u062F\u0627\u062B \u0627\u0644\u062A\u064A \u0628\u0644\u0627 \u0633\u0627\u0639\u0629."
            },
            event: {
              term: "\u062D\u062F\u062B",
              text: "\u0634\u0627\u0631\u0629 \u0628\u0639\u0646\u0648\u0627\u0646\u0647 \u0648\u0633\u0627\u0639\u062A\u0647. \u0627\u0646\u0642\u0631 \u0639\u0644\u064A\u0647\u0627 \u0644\u0641\u062A\u062D \u062A\u0641\u0627\u0635\u064A\u0644\u0647."
            },
            more: {
              term: "+3 \u0623\u062E\u0631\u0649",
              text: "\u0641\u064A \u0639\u0631\u0636 \u0627\u0644\u0634\u0647\u0631\u060C \u0639\u0646\u062F\u0645\u0627 \u064A\u062D\u062A\u0648\u064A \u064A\u0648\u0645 \u0639\u0644\u0649 \u0623\u062D\u062F\u0627\u062B \u0643\u062B\u064A\u0631\u0629: \u0627\u0646\u0642\u0631 \u0644\u0631\u0624\u064A\u062A\u0647\u0627 \u0643\u0644\u0647\u0627."
            },
            today: {
              term: "\u0627\u0644\u064A\u0648\u0645",
              text: "\u064A\u064F\u0628\u0631\u064E\u0632 \u064A\u0648\u0645 \u0627\u0644\u064A\u0648\u0645 \u0641\u064A \u0627\u0644\u0634\u0628\u0643\u0627\u062A \u0648\u0641\u064A \u062C\u062F\u0648\u0644 \u0627\u0644\u0623\u0639\u0645\u0627\u0644."
            },
            empty: {
              term: "\u0644\u0627 \u0623\u062D\u062F\u0627\u062B \u0641\u064A \u0647\u0630\u0647 \u0627\u0644\u0641\u062A\u0631\u0629",
              text: "\u0641\u064A \u062C\u062F\u0648\u0644 \u0627\u0644\u0623\u0639\u0645\u0627\u0644: \u0623\u0646\u0634\u0626 \u062D\u062F\u062B\u064B\u0627 \u0623\u0648 \u063A\u064A\u0651\u0631 \u0627\u0644\u0641\u062A\u0631\u0629."
            },
            truncated: {
              term: "\u0639\u062F\u062F \u0627\u0644\u0623\u062D\u062F\u0627\u062B \u0623\u0643\u0628\u0631 \u0645\u0645\u0627 \u064A\u0633\u062A\u0637\u064A\u0639 \u0627\u0644\u062A\u0642\u0648\u064A\u0645 \u0639\u0631\u0636\u0647",
              text: "\u0627\u062E\u062A\u0631 \u0641\u062A\u0631\u0629 \u0623\u0642\u0635\u0631 (\u0623\u0633\u0628\u0648\u0639 \u0623\u0648 \u0634\u0647\u0631) \u0623\u0648 \u0635\u0641\u0650\u0651 \u062D\u0633\u0628 \u0627\u0644\u0645\u0634\u0631\u0648\u0639."
            },
            loadFailed: {
              term: "\u062A\u0639\u0630\u0651\u0631 \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u062A\u0642\u0648\u064A\u0645",
              text: "\u062A\u062D\u0642\u0642 \u0645\u0646 \u0627\u062A\u0635\u0627\u0644\u0643 \u062B\u0645 \u0627\u0646\u0642\u0631 \u0639\u0644\u0649 \xAB\u0625\u0639\u0627\u062F\u0629 \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629\xBB."
            }
          }
        },
        listPane: {
          title: "\u0627\u0644\u062A\u0642\u0648\u064A\u0645 \u0627\u0644\u0645\u0635\u063A\u0651\u0631 \u0648\u0639\u0648\u0627\u0645\u0644 \u0627\u0644\u062A\u0635\u0641\u064A\u0629 (\u0627\u0644\u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u062C\u0627\u0646\u0628\u064A\u0629)",
          items: {
            mini: {
              term: "\u062A\u0642\u0648\u064A\u0645 \u0645\u0635\u063A\u0651\u0631",
              text: "\u0634\u0647\u0631 \u0635\u063A\u064A\u0631 \u0644\u0627\u062E\u062A\u064A\u0627\u0631 \u064A\u0648\u0645. \u062A\u064F\u0645\u064A\u064E\u0651\u0632 \u0627\u0644\u0623\u064A\u0627\u0645 \u0627\u0644\u062A\u064A \u0641\u064A\u0647\u0627 \u0623\u062D\u062F\u0627\u062B."
            },
            scope: {
              term: "\u0627\u0644\u062A\u0642\u0648\u064A\u0645 \u0627\u0644\u0645\u0639\u0631\u0648\u0636",
              text: "\xAB\u0647\u0630\u0647 \u0627\u0644\u0645\u0624\u0633\u0633\u0629\xBB \u0623\u0648 \xAB\u0643\u0644 \u0645\u0624\u0633\u0633\u0627\u062A\u064A\xBB. \u0644\u0627 \u064A\u0638\u0647\u0631 \u0647\u0630\u0627 \u0627\u0644\u0627\u062E\u062A\u064A\u0627\u0631 \u0625\u0644\u0627 \u0625\u0630\u0627 \u0643\u0646\u062A \u062A\u0646\u062A\u0645\u064A \u0625\u0644\u0649 \u0639\u062F\u0629 \u0645\u0624\u0633\u0633\u0627\u062A."
            },
            kinds: {
              term: "\u0623\u0646\u0648\u0627\u0639 \u0627\u0644\u0623\u062D\u062F\u0627\u062B",
              text: "\u062E\u0627\u0646\u0627\u062A \u0627\u062C\u062A\u0645\u0627\u0639 \u0648\u0632\u064A\u0627\u0631\u0629 \u0648\u0631\u0634\u0629 \u0648\u0623\u062C\u0644 \u0648\u0622\u062E\u0631: \u0623\u0644\u063A\u0650 \u062A\u062D\u062F\u064A\u062F \u0646\u0648\u0639 \u0644\u0625\u062E\u0641\u0627\u0626\u0647."
            },
            project: {
              term: "\u0627\u0644\u0645\u0634\u0631\u0648\u0639",
              text: "\u0642\u0627\u0626\u0645\u0629 \u0644\u0639\u0631\u0636 \u0623\u062D\u062F\u0627\u062B \u0645\u0634\u0631\u0648\u0639 \u0648\u0627\u062D\u062F \u0641\u0642\u0637. \xAB\u0643\u0644 \u0627\u0644\u0645\u0634\u0627\u0631\u064A\u0639\xBB \u062A\u0632\u064A\u0644 \u0627\u0644\u062A\u0635\u0641\u064A\u0629. \u0644\u0627 \u062A\u0638\u0647\u0631 \u0625\u0644\u0627 \u0639\u0646\u062F\u0645\u0627 \u062A\u0643\u0648\u0646 \u0644\u0645\u0634\u0627\u0631\u064A\u0639 \u0623\u062D\u062F\u0627\u062B."
            },
            reset: {
              term: "\u0639\u0631\u0636 \u0627\u0644\u0643\u0644",
              text: "\u064A\u0632\u064A\u0644 \u0643\u0644 \u0639\u0648\u0627\u0645\u0644 \u0627\u0644\u062A\u0635\u0641\u064A\u0629 \u0628\u0646\u0642\u0631\u0629. \u0644\u0627 \u064A\u0638\u0647\u0631 \u0627\u0644\u0632\u0631 \u0625\u0644\u0627 \u0639\u0646\u062F\u0645\u0627 \u062A\u0643\u0648\u0646 \u062A\u0635\u0641\u064A\u0629 \u0646\u0634\u0637\u0629."
            }
          }
        },
        details: {
          title: "\u062A\u0641\u0627\u0635\u064A\u0644 \u062D\u062F\u062B",
          items: {
            whenWhere: {
              term: "\u0627\u0644\u0645\u0648\u0639\u062F\u060C \u0627\u0644\u0645\u0643\u0627\u0646",
              text: "\u062A\u0627\u0631\u064A\u062E \u0627\u0644\u062D\u062F\u062B \u0648\u0633\u0627\u0639\u062A\u0647\u060C \u0648\u0645\u0643\u0627\u0646\u0647 \u0625\u0646 \u0643\u0627\u0646 \u0645\u0630\u0643\u0648\u0631\u064B\u0627."
            },
            projectOrg: {
              term: "\u0627\u0644\u0645\u0634\u0631\u0648\u0639\u060C \u0627\u0644\u0645\u0624\u0633\u0633\u0629",
              text: "\u0627\u0644\u0645\u0634\u0631\u0648\u0639 \u0623\u0648 \u0641\u0636\u0627\u0621 \u0627\u0644\u0645\u0624\u0633\u0633\u0629 \u0627\u0644\u0630\u064A \u064A\u0646\u062A\u0645\u064A \u0625\u0644\u064A\u0647 \u0627\u0644\u062D\u062F\u062B."
            },
            organiser: {
              term: "\u0627\u0644\u0645\u0646\u0638\u0650\u0651\u0645",
              text: "\u0627\u0644\u0634\u062E\u0635 \u0627\u0644\u0630\u064A \u0623\u0646\u0634\u0623 \u0627\u0644\u062D\u062F\u062B."
            },
            attendees: {
              term: "\u0627\u0644\u0645\u0634\u0627\u0631\u0643\u0648\u0646",
              text: "\u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u0645\u062F\u0639\u0648\u064A\u0646 \u0645\u0639 \u0631\u062F\u0648\u062F\u0647\u0645: \u0642\u064E\u0628\u0650\u0644 \u0623\u0648 \u0631\u0641\u0636 \u0623\u0648 \u0631\u0628\u0645\u0627 \u0623\u0648 \u0628\u0644\u0627 \u0631\u062F\u0651. \xAB\u0636\u064A\u0641 \u062E\u0627\u0631\u062C\u064A\xBB \u0647\u0648 \u0634\u062E\u0635 \u0645\u0646 \u062E\u0627\u0631\u062C \u2066BatiFlow\u2069."
            },
            rsvp: {
              term: "\u0631\u062F\u0651\u0643",
              text: "\u0625\u0630\u0627 \u0643\u0646\u062A \u0645\u062F\u0639\u0648\u064B\u0627: \u0642\u0628\u0648\u0644 \u0623\u0648 \u0631\u0628\u0645\u0627 \u0623\u0648 \u0631\u0641\u0636. \u064A\u064F\u0630\u0643\u064E\u0651\u0631 \u0628\u0631\u062F\u0651\u0643 \u0627\u0644\u062D\u0627\u0644\u064A \u062A\u062D\u062A\u0647\u0627."
            },
            join: {
              term: "\u0627\u0646\u0636\u0645\u0627\u0645",
              text: "\u064A\u0641\u062A\u062D \u0642\u0627\u0639\u0629 \u0627\u0644\u0627\u062C\u062A\u0645\u0627\u0639 \u0639\u0628\u0631 \u0627\u0644\u0625\u0646\u062A\u0631\u0646\u062A. \u0644\u0627 \u064A\u0638\u0647\u0631 \u0627\u0644\u0632\u0631 \u0625\u0644\u0627 \u0644\u0644\u0623\u062D\u062F\u0627\u062B \u0627\u0644\u062A\u064A \u0644\u0647\u0627 \u0627\u062C\u062A\u0645\u0627\u0639."
            },
            editDelete: {
              term: "\u062A\u0639\u062F\u064A\u0644\u060C \u062D\u0630\u0641",
              text: "\u0644\u0645\u0646 \u064A\u0645\u0644\u0643 \u062D\u0642 \u062A\u0639\u062F\u064A\u0644 \u0627\u0644\u062D\u062F\u062B. \u064A\u0637\u0644\u0628 \u0627\u0644\u062D\u0630\u0641 \u062A\u0623\u0643\u064A\u062F\u064B\u0627 \u0648\u0644\u0627 \u0631\u062C\u0639\u0629 \u0641\u064A\u0647: \u0644\u0646 \u064A\u0631\u0649 \u0627\u0644\u0645\u062F\u0639\u0648\u0648\u0646 \u0627\u0644\u062D\u062F\u062B \u0628\u0639\u062F \u0627\u0644\u0622\u0646."
            },
            readOnly: {
              term: "\u0623\u062C\u0644 \u0644\u0644\u0642\u0631\u0627\u0621\u0629 \u0641\u0642\u0637",
              text: "\u0644\u0623\u062C\u0644 \u0622\u062A\u064D \u0645\u0646 \u0645\u0647\u0645\u0629 \u0623\u0648 \u0645\u0631\u062D\u0644\u0629 \u0623\u0648 \u062A\u0623\u0634\u064A\u0631\u0629: \u0631\u0627\u0628\u0637 \u0645\u062B\u0644 \xAB\u0641\u062A\u062D \u0645\u0647\u0627\u0645 \u0627\u0644\u0645\u0634\u0631\u0648\u0639\xBB \u064A\u0642\u0648\u062F \u0625\u0644\u0649 \u0645\u0635\u062F\u0631\u0647 \u062D\u064A\u062B \u064A\u064F\u0639\u062F\u064E\u0651\u0644."
            }
          }
        },
        eventDialog: {
          title: "\u062D\u062F\u062B \u062C\u062F\u064A\u062F \u0648\u062A\u0639\u062F\u064A\u0644 \u0627\u0644\u062D\u062F\u062B",
          items: {
            space: {
              term: "\u0627\u0644\u0641\u0636\u0627\u0621",
              text: "\u0625\u0644\u0632\u0627\u0645\u064A \u0639\u0646\u062F \u0627\u0644\u0625\u0646\u0634\u0627\u0621: \u0627\u0644\u0645\u0624\u0633\u0633\u0629 (\u0627\u0644\u0645\u0627\u0644\u0643\u0648\u0646 \u0648\u0627\u0644\u0645\u0633\u0624\u0648\u0644\u0648\u0646) \u0623\u0648 \u0645\u0634\u0631\u0648\u0639 \u064A\u0645\u0643\u0646\u0643 \u0627\u0644\u0645\u0633\u0627\u0647\u0645\u0629 \u0641\u064A\u0647. \u064A\u0638\u0647\u0631 \u0627\u0644\u062D\u062F\u062B \u0644\u0644\u0623\u0634\u062E\u0627\u0635 \u0627\u0644\u0630\u064A\u0646 \u064A\u0645\u0644\u0643\u0648\u0646 \u062D\u0642 \u0627\u0644\u0648\u0635\u0648\u0644 \u0625\u0644\u0649 \u0647\u0630\u0627 \u0627\u0644\u0641\u0636\u0627\u0621."
            },
            title: {
              term: "\u0627\u0644\u0639\u0646\u0648\u0627\u0646",
              text: "\u0625\u0644\u0632\u0627\u0645\u064A: \u0623\u0639\u0637\u0650 \u0627\u0644\u062D\u062F\u062B \u0639\u0646\u0648\u0627\u0646\u064B\u0627."
            },
            kind: {
              term: "\u0627\u0644\u0646\u0648\u0639",
              text: "\u0627\u062C\u062A\u0645\u0627\u0639 \u0623\u0648 \u0632\u064A\u0627\u0631\u0629 \u0648\u0631\u0634\u0629 \u0623\u0648 \u0623\u062C\u0644 \u0623\u0648 \u0622\u062E\u0631."
            },
            allDay: {
              term: "\u0637\u0648\u0627\u0644 \u0627\u0644\u064A\u0648\u0645",
              text: "\u0645\u0641\u062A\u0627\u062D \u062A\u0628\u062F\u064A\u0644: \u0628\u0644\u0627 \u0633\u0627\u0639\u0627\u062A\u060C \u0645\u0639 \xAB\u0627\u0644\u064A\u0648\u0645 \u0627\u0644\u0623\u0648\u0644\xBB \u0648\xAB\u0627\u0644\u064A\u0648\u0645 \u0627\u0644\u0623\u062E\u064A\u0631\xBB \u0641\u0642\u0637."
            },
            dates: {
              term: "\u0627\u0644\u0628\u062F\u0627\u064A\u0629\u060C \u0627\u0644\u0646\u0647\u0627\u064A\u0629",
              text: "\u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0628\u062F\u0627\u064A\u0629 \u0648\u0627\u0644\u0646\u0647\u0627\u064A\u0629 \u0648\u0633\u0627\u0639\u062A\u0647\u0645\u0627\u060C \u0628\u062A\u0648\u0642\u064A\u062A \u062A\u0648\u0646\u0633. \u064A\u062C\u0628 \u0623\u0646 \u062A\u0643\u0648\u0646 \u0627\u0644\u0646\u0647\u0627\u064A\u0629 \u0628\u0639\u062F \u0627\u0644\u0628\u062F\u0627\u064A\u0629\u060C \u0648\u0644\u0627 \u062A\u062A\u062C\u0627\u0648\u0632 \u0645\u062F\u0629 \u0627\u0644\u062D\u062F\u062B 31 \u064A\u0648\u0645\u064B\u0627."
            },
            locationDescription: {
              term: "\u0627\u0644\u0645\u0643\u0627\u0646\u060C \u0627\u0644\u0648\u0635\u0641",
              text: "\u062D\u0642\u0644\u0627\u0646 \u062D\u0631\u0627\u0646 \u0648\u0627\u062E\u062A\u064A\u0627\u0631\u064A\u0627\u0646: \u0645\u0643\u0627\u0646 \u0627\u0644\u062D\u062F\u062B \u0648\u0645\u0627 \u064A\u062C\u0628 \u0645\u0639\u0631\u0641\u062A\u0647."
            },
            attendees: {
              term: "\u0627\u0644\u0645\u0634\u0627\u0631\u0643\u0648\u0646",
              text: "\u0627\u062E\u062A\u0631 \u0627\u0644\u0623\u0634\u062E\u0627\u0635 \u0627\u0644\u0645\u0631\u0627\u062F \u062F\u0639\u0648\u062A\u0647\u0645. \u0644\u0627 \u064A\u0645\u0643\u0646 \u062F\u0639\u0648\u0629 \u0625\u0644\u0627 \u0645\u0646 \u064A\u0645\u0644\u0643 \u062D\u0642 \u0627\u0644\u0648\u0635\u0648\u0644 \u0625\u0644\u0649 \u0627\u0644\u0641\u0636\u0627\u0621\u060C \u0648\u0623\u0646\u062A \u0645\u062F\u0639\u0648 \u062F\u0627\u0626\u0645\u064B\u0627. \u064A\u062A\u0644\u0642\u0649 \u0627\u0644\u0645\u062F\u0639\u0648\u0648\u0646 \u062A\u0630\u0643\u064A\u0631\u064B\u0627 \u0642\u0628\u0644 \u0627\u0644\u0628\u062F\u0621."
            },
            submit: {
              term: "\u0625\u0646\u0634\u0627\u0621 \u0627\u0644\u062D\u062F\u062B\u060C \u062D\u0641\u0638",
              text: "\u064A\u0635\u0627\u062F\u0642 \u0639\u0644\u0649 \u0627\u0644\u0646\u0645\u0648\u0630\u062C. \xAB\u0625\u0644\u063A\u0627\u0621\xBB \u064A\u063A\u0644\u0642 \u0627\u0644\u0646\u0627\u0641\u0630\u0629. \u062A\u0628\u064A\u0651\u0646 \u0631\u0633\u0627\u0644\u0629 \u062E\u0637\u0623 \u0645\u0627 \u064A\u062C\u0628 \u062A\u0635\u062D\u064A\u062D\u0647. \u0625\u0646 \u0644\u0645 \u064A\u0643\u0646 \u0644\u062F\u064A\u0643 \u0641\u0636\u0627\u0621 \u062A\u0633\u0627\u0647\u0645 \u0641\u064A\u0647 \u0641\u0627\u0646\u0636\u0645 \u0623\u0648\u0644\u064B\u0627 \u0625\u0644\u0649 \u0645\u0634\u0631\u0648\u0639."
            }
          }
        },
        feeds: {
          title: "\u0627\u0644\u0627\u0634\u062A\u0631\u0627\u0643 \u0641\u064A \u062A\u0642\u0648\u064A\u0645\u0643 (\u2066ICS\u2069)",
          items: {
            list: {
              term: "\u062A\u062F\u0641\u0642\u0627\u062A \u0627\u0634\u062A\u0631\u0627\u0643\u0643",
              text: "\u064A\u0639\u0631\u0636 \u0643\u0644 \u062A\u062F\u0641\u0642 \u0627\u0633\u0645\u0647 \u0648\u0627\u0644\u0645\u0624\u0633\u0633\u0629 \u0648\u0645\u062D\u062A\u0648\u0627\u0647 \u0648\u062A\u0627\u0631\u064A\u062E \u0625\u0646\u0634\u0627\u0626\u0647."
            },
            revoke: {
              term: "\u0625\u0644\u063A\u0627\u0621",
              text: "\u064A\u0642\u0637\u0639 \u0627\u0644\u062A\u062F\u0641\u0642. \u0644\u0627 \u062A\u062A\u0644\u0642\u0649 \u0627\u0644\u062A\u0637\u0628\u064A\u0642\u0627\u062A \u0627\u0644\u0645\u0634\u062A\u0631\u0643\u0629 \u0634\u064A\u0626\u064B\u0627 \u0628\u0639\u062F \u0630\u0644\u0643\u060C \u0648\u0644\u0627 \u0631\u062C\u0639\u0629 \u0641\u064A\u0647: \u0633\u062A\u062D\u062A\u0627\u062C \u0625\u0644\u0649 \u0625\u0646\u0634\u0627\u0621 \u062A\u062F\u0641\u0642 \u062C\u062F\u064A\u062F."
            },
            label: {
              term: "\u0627\u0633\u0645 \u0627\u0644\u062A\u062F\u0641\u0642",
              text: "\u0627\u062E\u062A\u064A\u0627\u0631\u064A\u060C \u0645\u062B\u0644 \xAB\u062A\u0642\u0648\u064A\u0645 \u0647\u0627\u062A\u0641\u064A\xBB."
            },
            scope: {
              term: "\u0645\u062D\u062A\u0648\u0649 \u0627\u0644\u062A\u062F\u0641\u0642",
              text: "\xAB\u0643\u0644 \u0645\u0627 \u062A\u0631\u0627\u0647\xBB \u0623\u0648 \xAB\u0645\u0627 \u064A\u062E\u0635\u0651\u0643 \u0641\u0642\u0637\xBB."
            },
            includeExternal: {
              term: "\u062A\u0636\u0645\u064A\u0646 \u0623\u062D\u062F\u0627\u062B \u0627\u0644\u0641\u0636\u0627\u0621\u0627\u062A \u0627\u0644\u0645\u0634\u062A\u0631\u0643\u0629 \u0645\u0639 \u0627\u0644\u0634\u0631\u0643\u0627\u0621",
              text: "\u062E\u0627\u0646\u0629 \u0627\u062E\u062A\u064A\u0627\u0631 \u0644\u0625\u0636\u0627\u0641\u0629 \u0623\u062D\u062F\u0627\u062B \u0627\u0644\u0641\u0636\u0627\u0621\u0627\u062A \u0627\u0644\u0645\u0634\u062A\u0631\u0643\u0629 \u0645\u0639 \u0645\u0624\u0633\u0633\u0627\u062A \u0623\u062E\u0631\u0649."
            },
            create: {
              term: "\u0625\u0646\u0634\u0627\u0621 \u0627\u0644\u062A\u062F\u0641\u0642",
              text: "\u064A\u0646\u0634\u0626 \u0627\u0644\u062A\u062F\u0641\u0642 \u0648\u064A\u0639\u0631\u0636 \u0639\u0646\u0648\u0627\u0646 \u0627\u0634\u062A\u0631\u0627\u0643\u0647."
            },
            address: {
              term: "\u0639\u0646\u0648\u0627\u0646 \u0627\u0634\u062A\u0631\u0627\u0643\u0643",
              text: "\u064A\u064F\u0639\u0631\u0636 \u0645\u0631\u0629 \u0648\u0627\u062D\u062F\u0629 \u0641\u0642\u0637: \u0648\u0647\u0648 \u064A\u062A\u064A\u062D \u0627\u0644\u0648\u0635\u0648\u0644 \u0625\u0644\u0649 \u062A\u0642\u0648\u064A\u0645\u0643 \u0645\u062B\u0644 \u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631. \u0627\u0646\u0633\u062E\u0647 \u0628\u0640 \xAB\u0646\u0633\u062E \u0627\u0644\u0639\u0646\u0648\u0627\u0646\xBB \u062B\u0645 \u0627\u0646\u0642\u0631 \u0639\u0644\u0649 \xAB\u0644\u0642\u062F \u0646\u0633\u062E\u062A \u0627\u0644\u0639\u0646\u0648\u0627\u0646\xBB."
            },
            limit: {
              term: "\u0627\u0644\u062D\u062F \u0627\u0644\u0623\u0642\u0635\u0649 \u0644\u0639\u062F\u062F \u0627\u0644\u062A\u062F\u0641\u0642\u0627\u062A",
              text: "\u0639\u0646\u062F \u0628\u0644\u0648\u063A \u0627\u0644\u062D\u062F\u060C \u0623\u0644\u063A\u0650 \u062A\u062F\u0641\u0642\u064B\u0627 \u0644\u0625\u0646\u0634\u0627\u0621 \u0622\u062E\u0631."
            }
          }
        }
      }
    },
    files: {
      title: "\u0627\u0644\u0645\u0644\u0641\u0627\u062A",
      intro: "\u0645\u0644\u0641\u0627\u062A \u0627\u0644\u0645\u0624\u0633\u0633\u0629 \u0641\u064A \u0645\u0643\u0627\u0646 \u0648\u0627\u062D\u062F: \u0622\u062E\u0631 \u0645\u0627 \u0639\u064F\u062F\u0651\u0644\u060C \u0648\u0645\u062C\u0644\u062F\u0627\u062A \u0627\u0644\u0645\u0624\u0633\u0633\u0629\u060C \u0648\u0627\u0644\u0641\u0636\u0627\u0621\u0627\u062A \u0627\u0644\u062A\u064A \u062A\u0634\u0627\u0631\u0643\u0647\u0627 \u0645\u0639\u0643 \u0645\u0624\u0633\u0633\u0627\u062A \u0623\u062E\u0631\u0649\u060C \u0648\u0627\u0644\u0628\u062D\u062B. \u0644\u0627 \u062A\u0631\u0649 \u0625\u0644\u0627 \u0645\u0627 \u064A\u062D\u0642 \u0644\u0643 \u0641\u062A\u062D\u0647.",
      sections: {
        page: {
          title: "\u0627\u0644\u0635\u0641\u062D\u0629",
          items: {
            title: {
              term: "\u0627\u0644\u0645\u0644\u0641\u0627\u062A",
              text: "\u0627\u0633\u0645 \u0627\u0644\u0635\u0641\u062D\u0629 \u0641\u064A \u0627\u0644\u0623\u0639\u0644\u0649. \u064A\u064F\u0641\u062A\u062D \u0627\u0644\u062A\u0637\u0628\u064A\u0642 \u0623\u064A\u0636\u064B\u0627 \u0628\u0640 Alt+5."
            },
            tabs: {
              term: "\u0627\u0644\u0623\u0644\u0633\u0646\u0629",
              text: "\u0627\u0644\u0623\u062D\u062F\u062B\u060C \u0627\u0644\u0645\u0624\u0633\u0633\u0629\u060C \u0645\u0634\u062A\u0631\u0643\u0629 \u0645\u0639\u064A\u060C \u0648\u0628\u062D\u062B. \u064A\u0628\u0642\u0649 \u0627\u0644\u0644\u0633\u0627\u0646 \u0627\u0644\u0645\u0641\u062A\u0648\u062D \u0641\u064A \u0639\u0646\u0648\u0627\u0646 \u0627\u0644\u0635\u0641\u062D\u0629."
            }
          }
        },
        recent: {
          title: "\u0627\u0644\u0623\u062D\u062F\u062B",
          items: {
            list: {
              term: "\u0627\u0644\u0645\u0644\u0641\u0627\u062A \u0627\u0644\u0623\u062D\u062F\u062B",
              text: "\u0627\u0644\u0648\u062B\u0627\u0626\u0642 \u0627\u0644\u0645\u0636\u0627\u0641\u0629 \u0623\u0648 \u0627\u0644\u0645\u0639\u062F\u0651\u0644\u0629 \u0645\u0624\u062E\u0631\u064B\u0627 \u0641\u064A \u0627\u0644\u0645\u062C\u0644\u062F\u0627\u062A \u0627\u0644\u062A\u064A \u064A\u0645\u0643\u0646\u0643 \u0642\u0631\u0627\u0621\u062A\u0647\u0627\u060C \u0645\u0646 \u0627\u0644\u0623\u062D\u062F\u062B \u0625\u0644\u0649 \u0627\u0644\u0623\u0642\u062F\u0645."
            },
            line: {
              term: "\u0633\u0637\u0631",
              text: "\u0627\u0644\u0639\u0646\u0648\u0627\u0646 \u0648\u0627\u0644\u0631\u0645\u0632 \u0648\u0627\u0644\u0645\u0634\u0631\u0648\u0639 \u0623\u0648 \u0627\u0644\u0641\u0636\u0627\u0621 \u0648\u0627\u0644\u0645\u062C\u0644\u062F \u0648\u0645\u0646\u0630 \u0645\u062A\u0649 \u062A\u063A\u064A\u0651\u0631. \u0627\u0646\u0642\u0631 \u0644\u0641\u062A\u062D \u0627\u0644\u0648\u062B\u064A\u0642\u0629."
            }
          }
        },
        organisation: {
          title: "\u0627\u0644\u0645\u0624\u0633\u0633\u0629",
          items: {
            folders: {
              term: "\u0645\u062C\u0644\u062F\u0627\u062A \u0627\u0644\u0645\u0624\u0633\u0633\u0629",
              text: "\u0627\u0644\u0648\u062B\u0627\u0626\u0642 \u0627\u0644\u062A\u064A \u0644\u0627 \u062A\u0646\u062A\u0645\u064A \u0625\u0644\u0649 \u0623\u064A \u0645\u0634\u0631\u0648\u0639. \u0644\u0627 \u062A\u0638\u0647\u0631 \u0627\u0644\u0645\u062C\u0644\u062F\u0627\u062A \u0627\u0644\u062D\u0633\u0627\u0633\u0629 (\u0645\u0630\u0643\u0631\u0627\u062A \u0627\u0644\u0645\u0635\u0627\u0631\u064A\u0641\u060C \u0627\u0644\u062E\u0632\u0646\u0629) \u0625\u0644\u0627 \u0644\u0644\u0623\u0634\u062E\u0627\u0635 \u0627\u0644\u0645\u0623\u0630\u0648\u0646 \u0644\u0647\u0645."
            }
          }
        },
        shared: {
          title: "\u0645\u0634\u062A\u0631\u0643\u0629 \u0645\u0639\u064A",
          items: {
            spaces: {
              term: "\u0641\u0636\u0627\u0621\u0627\u062A \u0645\u0624\u0633\u0633\u0627\u062A \u0623\u062E\u0631\u0649",
              text: "\u0627\u0644\u0641\u0636\u0627\u0621\u0627\u062A \u0627\u0644\u062A\u064A \u062F\u0639\u062A\u0643 \u0625\u0644\u064A\u0647\u0627 \u0645\u0624\u0633\u0633\u0629 \u0623\u062E\u0631\u0649. \u0627\u0646\u0642\u0631 \u0644\u0641\u062A\u062D \u0627\u0644\u0641\u0636\u0627\u0621 \u0648\u0648\u062B\u0627\u0626\u0642\u0647."
            }
          }
        },
        search: {
          title: "\u0628\u062D\u062B",
          items: {
            field: {
              term: "\u0627\u0644\u0628\u062D\u062B \u0639\u0646 \u0645\u0644\u0641",
              text: "\u0627\u0643\u062A\u0628 \u062D\u0631\u0641\u064A\u0646 \u0639\u0644\u0649 \u0627\u0644\u0623\u0642\u0644 \u0645\u0646 \u0627\u0644\u0639\u0646\u0648\u0627\u0646 \u0623\u0648 \u0627\u0644\u0631\u0645\u0632. \u0644\u0627 \u064A\u064F\u0639\u062B\u0631 \u0625\u0644\u0627 \u0639\u0644\u0649 \u0627\u0644\u0648\u062B\u0627\u0626\u0642 \u0627\u0644\u062A\u064A \u064A\u0645\u0643\u0646\u0643 \u0641\u062A\u062D\u0647\u0627."
            }
          }
        }
      }
    },
    document: {
      title: "\u0627\u0644\u0645\u0633\u062A\u0646\u062F",
      intro: "\u0642\u0627\u0631\u0626 \u0648\u062B\u064A\u0642\u0629 \u0645\u0634\u0631\u0648\u0639: \u062A\u0642\u0631\u0623 \u0641\u064A\u0647 \u0645\u0644\u0641 \u2066PDF\u2069 \u0623\u0648 \u0635\u0648\u0631\u0629\u060C \u0648\u062A\u063A\u064A\u0651\u0631 \u0627\u0644\u0646\u0633\u062E\u0629\u060C \u0648\u062A\u0646\u0632\u0651\u0644\u060C \u0648\u062A\u0636\u064A\u0641 \u062A\u0639\u0644\u064A\u0642\u0627\u062A \u062A\u0648\u0636\u064A\u062D\u064A\u0629 \u0628\u062D\u0633\u0628 \u0635\u0644\u0627\u062D\u064A\u0627\u062A\u0643.",
      sections: {
        header: {
          title: "\u0631\u0623\u0633 \u0627\u0644\u0645\u0633\u062A\u0646\u062F",
          items: {
            back: {
              term: "\u0627\u0644\u0639\u0648\u062F\u0629 \u0625\u0644\u0649 \u0627\u0644\u0645\u0644\u0641\u0627\u062A",
              text: "\u064A\u0639\u0648\u062F \u0625\u0644\u0649 \u0639\u0644\u0627\u0645\u0629 \u0627\u0644\u062A\u0628\u0648\u064A\u0628 \xAB\u0627\u0644\u0645\u0644\u0641\u0627\u062A\xBB \u0641\u064A \u0627\u0644\u0645\u0634\u0631\u0648\u0639."
            },
            title: {
              term: "\u0627\u0644\u0631\u0645\u0632 \u0648\u0627\u0644\u0639\u0646\u0648\u0627\u0646",
              text: "\u0631\u0645\u0632 \u0627\u0644\u0645\u0633\u062A\u0646\u062F (\u064A\u064F\u0643\u062A\u0628 \u062F\u0627\u0626\u0645\u064B\u0627 \u0645\u0646 \u0627\u0644\u064A\u0633\u0627\u0631 \u0625\u0644\u0649 \u0627\u0644\u064A\u0645\u064A\u0646) \u0645\u062A\u0628\u0648\u0639\u064B\u0627 \u0628\u0639\u0646\u0648\u0627\u0646\u0647."
            },
            version: {
              term: "\u0646\u0633\u062E\u0629 \u0627\u0644\u0645\u0633\u062A\u0646\u062F",
              text: "\u0642\u0627\u0626\u0645\u0629 \u0644\u0627\u062E\u062A\u064A\u0627\u0631 \u0627\u0644\u0646\u0633\u062E\u0629 \u0627\u0644\u0645\u0631\u0627\u062F \u0642\u0631\u0627\u0621\u062A\u0647\u0627. \u064A\u0639\u0631\u0636 \u0643\u0644 \u0633\u0637\u0631 \xAB\u0627\u0644\u0645\u0631\u0627\u062C\u0639\u0629\xBB (\u062D\u0631\u0641 \u0646\u0633\u062E\u0629 \u0627\u0644\u0645\u062E\u0637\u0637: \u2066A\u2069 \u0623\u0648 \u2066B\u2069 \u0623\u0648 \u2066C\u2069\u2026) \u062B\u0645 \u0627\u0644\u062A\u0627\u0631\u064A\u062E. \u062A\u062D\u0645\u0644 \u0627\u0644\u0646\u0633\u062E\u0629 \u0627\u0644\u062C\u0627\u0631\u064A\u0629 \u0639\u0628\u0627\u0631\u0629 \xAB(\u0627\u0644\u0646\u0633\u062E\u0629 \u0627\u0644\u062D\u0627\u0644\u064A\u0629)\xBB. \u064A\u064F\u062D\u0641\u0638 \u0627\u0644\u0627\u062E\u062A\u064A\u0627\u0631 \u0641\u064A \u0627\u0644\u0639\u0646\u0648\u0627\u0646."
            },
            download: {
              term: "\u062A\u0646\u0632\u064A\u0644",
              text: "\u064A\u0623\u062E\u0630 \u0646\u0633\u062E\u0629 \u0645\u0646 \u0627\u0644\u0646\u0633\u062E\u0629 \u0627\u0644\u0645\u0639\u0631\u0648\u0636\u0629. \u064A\u0643\u0648\u0646 \u0627\u0644\u0632\u0631 \u0628\u0627\u0647\u062A\u064B\u0627 \u0623\u062B\u0646\u0627\u0621 \u0627\u0644\u062A\u062C\u0647\u064A\u0632."
            },
            downloadStatus: {
              term: "\u062C\u0627\u0631\u064D \u062A\u062C\u0647\u064A\u0632 \u0646\u0633\u062E\u0629 \u0628\u0627\u0633\u0645\u0643\u2026",
              text: "\u0631\u0633\u0627\u0644\u0629 \u0623\u062B\u0646\u0627\u0621 \u0627\u0644\u062A\u062C\u0647\u064A\u0632. \u0642\u062F \u064A\u0643\u0648\u0646 \u0627\u0644\u062A\u0646\u0632\u064A\u0644 \u0645\u0639\u0637\u0651\u0644\u064B\u0627 \u0641\u064A \u0647\u0630\u0647 \u0627\u0644\u0645\u0633\u0627\u062D\u0629: \u064A\u0645\u0643\u0646\u0643 \u062D\u064A\u0646\u0626\u0630 \u0642\u0631\u0627\u0621\u0629 \u0627\u0644\u0645\u0633\u062A\u0646\u062F \u062F\u0648\u0646 \u062A\u0646\u0632\u064A\u0644\u0647. \u0648\u0625\u0646 \u0644\u0645 \u064A\u0628\u062F\u0623 \u0627\u0644\u062A\u0646\u0632\u064A\u0644 \u062A\u062F\u0639\u0648\u0643 \u0631\u0633\u0627\u0644\u0629 \u062E\u0637\u0623 \u0625\u0644\u0649 \u0625\u0639\u0627\u062F\u0629 \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629."
            }
          }
        },
        pdfTools: {
          title: "\u0623\u062F\u0648\u0627\u062A \u0627\u0644\u0645\u0633\u062A\u0646\u062F (\u2066PDF\u2069)",
          items: {
            thumbnails: {
              term: "\u0625\u0638\u0647\u0627\u0631 \u0627\u0644\u0635\u0648\u0631 \u0627\u0644\u0645\u0635\u063A\u0651\u0631\u0629",
              text: "\u064A\u064F\u0638\u0647\u0631 \u0623\u0648 \u064A\u062E\u0641\u064A \u0639\u0645\u0648\u062F \u0627\u0644\u0635\u0648\u0631 \u0627\u0644\u0635\u063A\u064A\u0631\u0629 \u0644\u0644\u0635\u0641\u062D\u0627\u062A \u0639\u0644\u0649 \u0627\u0644\u062C\u0627\u0646\u0628. \u0627\u0646\u0642\u0631 \u0639\u0644\u0649 \u0635\u0648\u0631\u0629 \u0645\u0635\u063A\u0651\u0631\u0629 \u0644\u0644\u0627\u0646\u062A\u0642\u0627\u0644 \u0625\u0644\u0649 \u0627\u0644\u0635\u0641\u062D\u0629."
            },
            pages: {
              term: "\u0627\u0644\u0635\u0641\u062D\u0629 \u0627\u0644\u0633\u0627\u0628\u0642\u0629\u060C \u0627\u0644\u0635\u0641\u062D\u0629 \u0627\u0644\u062A\u0627\u0644\u064A\u0629",
              text: "\u0633\u0647\u0645\u0627 \u0627\u0644\u0634\u0631\u064A\u0637 \u064A\u063A\u064A\u0651\u0631\u0627\u0646 \u0627\u0644\u0635\u0641\u062D\u0629."
            },
            goToPage: {
              term: "\u0627\u0644\u0627\u0646\u062A\u0642\u0627\u0644 \u0625\u0644\u0649 \u0627\u0644\u0635\u0641\u062D\u0629",
              text: "\u0627\u0643\u062A\u0628 \u0631\u0642\u0645\u064B\u0627 \u062B\u0645 \u0627\u0636\u063A\u0637 \u2066Enter\u2069. \u0628\u062C\u0627\u0646\u0628\u0647: \xAB\u0645\u0646\xBB \u0645\u062A\u0628\u0648\u0639\u0629 \u0628\u0639\u062F\u062F \u0627\u0644\u0635\u0641\u062D\u0627\u062A \u0627\u0644\u0625\u062C\u0645\u0627\u0644\u064A."
            },
            zoom: {
              term: "\u062A\u0643\u0628\u064A\u0631\u060C \u062A\u0635\u063A\u064A\u0631",
              text: "\u064A\u0643\u0628\u0651\u0631\u0627\u0646 \u0627\u0644\u0635\u0641\u062D\u0629 \u0623\u0648 \u064A\u0635\u063A\u0651\u0631\u0627\u0646\u0647\u0627. \u062A\u0638\u0647\u0631 \u0627\u0644\u0646\u0633\u0628\u0629 \u0627\u0644\u0645\u0626\u0648\u064A\u0629 \u0628\u064A\u0646 \u0627\u0644\u0632\u0631\u064A\u0646."
            },
            fit: {
              term: "\u0645\u0644\u0627\u0621\u0645\u0629 \u0627\u0644\u0639\u0631\u0636\u060C \u0645\u0644\u0627\u0621\u0645\u0629 \u0627\u0644\u0635\u0641\u062D\u0629",
              text: "\u064A\u0643\u064A\u0651\u0641\u0627\u0646 \u062D\u062C\u0645 \u0627\u0644\u0635\u0641\u062D\u0629 \u0645\u0639 \u0627\u0644\u0646\u0627\u0641\u0630\u0629: \u0628\u0627\u0644\u0639\u0631\u0636 \u0623\u0648 \u0628\u0627\u0644\u0627\u0631\u062A\u0641\u0627\u0639."
            },
            search: {
              term: "\u0627\u0644\u0628\u062D\u062B \u0641\u064A \u0627\u0644\u0645\u0633\u062A\u0646\u062F",
              text: "\u064A\u0641\u062A\u062D \u0634\u0631\u064A\u0637 \u0627\u0644\u0628\u062D\u062B. \u0648\u2066Ctrl+F\u2069 \u064A\u0641\u0639\u0644 \u0627\u0644\u0634\u064A\u0621 \u0646\u0641\u0633\u0647."
            },
            keys: {
              term: "\u0627\u0644\u0627\u062E\u062A\u0635\u0627\u0631\u0627\u062A",
              text: "\xAB\u0627\u0644\u0635\u0641\u062D\u0629 \u0627\u0644\u062A\u0627\u0644\u064A\u0629\xBB \u0648\xAB\u0627\u0644\u0635\u0641\u062D\u0629 \u0627\u0644\u0633\u0627\u0628\u0642\u0629\xBB (\u0623\u0648 \u0627\u0644\u0633\u0647\u0645\u0627\u0646 \u0627\u0644\u0623\u064A\u0645\u0646 \u0648\u0627\u0644\u0623\u064A\u0633\u0631) \u062A\u063A\u064A\u0651\u0631 \u0627\u0644\u0635\u0641\u062D\u0629. \u2066Home\u2069 \u0648\u2066End\u2069 \u064A\u0630\u0647\u0628\u0627\u0646 \u0625\u0644\u0649 \u0627\u0644\u0635\u0641\u062D\u0629 \u0627\u0644\u0623\u0648\u0644\u0649 \u0648\u0627\u0644\u0623\u062E\u064A\u0631\u0629. \u0639\u0644\u0627\u0645\u062A\u0627 + \u0648 \u2212 \u0644\u0644\u062A\u0643\u0628\u064A\u0631 \u0648\u0627\u0644\u062A\u0635\u063A\u064A\u0631."
            },
            watermark: {
              term: "\u0627\u0644\u0639\u0644\u0627\u0645\u0629 \u0627\u0644\u0645\u0627\u0626\u064A\u0629",
              text: "\u0642\u062F \u062A\u062D\u0645\u0644 \u0627\u0644\u0645\u0639\u0627\u064A\u0646\u0629 \u0639\u0644\u0627\u0645\u0629 \u0645\u0627\u0626\u064A\u0629 \u0628\u0627\u0633\u0645\u0643 \u0648\u0627\u0633\u0645 \u0645\u0624\u0633\u0633\u062A\u0643 \u0648\u0627\u0644\u062A\u0627\u0631\u064A\u062E. \u064A\u0630\u0643\u0651\u0631 \u0628\u0630\u0644\u0643 \u0634\u0631\u064A\u0637."
            }
          }
        },
        search: {
          title: "\u0627\u0644\u0628\u062D\u062B \u0641\u064A \u0627\u0644\u0645\u0633\u062A\u0646\u062F",
          items: {
            field: {
              term: "\u0628\u062D\u062B\u2026",
              text: "\u0627\u0643\u062A\u0628 \u0643\u0644\u0645\u0629: \u062A\u064F\u0638\u0644\u064E\u0651\u0644 \u0627\u0644\u0646\u062A\u0627\u0626\u062C \u0641\u064A \u0627\u0644\u0635\u0641\u062D\u0627\u062A."
            },
            result: {
              term: "\u0627\u0644\u0646\u062A\u064A\u062C\u0629 \u0627\u0644\u0633\u0627\u0628\u0642\u0629\u060C \u0627\u0644\u0646\u062A\u064A\u062C\u0629 \u0627\u0644\u062A\u0627\u0644\u064A\u0629",
              text: "\u064A\u0646\u062A\u0642\u0644\u0627\u0646 \u0645\u0646 \u0646\u062A\u064A\u062C\u0629 \u0625\u0644\u0649 \u0623\u062E\u0631\u0649. \u064A\u0638\u0647\u0631 \u0627\u0644\u0645\u0648\u0636\u0639 \u0628\u0635\u064A\u063A\u0629 \xAB\u0627\u0644\u0646\u062A\u064A\u062C\u0629 2 \u0645\u0646 5\xBB."
            },
            state: {
              term: "\u062C\u0627\u0631\u064D \u0627\u0644\u0628\u062D\u062B\u2026\u060C \u0644\u0627 \u062A\u0648\u062C\u062F \u0646\u062A\u0627\u0626\u062C",
              text: "\u0631\u0633\u0627\u0626\u0644 \u062D\u0627\u0644\u0629 \u0623\u062B\u0646\u0627\u0621 \u0627\u0644\u0628\u062D\u062B \u0623\u0648 \u0628\u0639\u062F\u0647."
            },
            close: {
              term: "\u0625\u063A\u0644\u0627\u0642 \u0627\u0644\u0628\u062D\u062B",
              text: "\u064A\u062E\u0641\u064A \u0634\u0631\u064A\u0637 \u0627\u0644\u0628\u062D\u062B."
            }
          }
        },
        imageTools: {
          title: "\u0623\u062F\u0648\u0627\u062A \u0627\u0644\u0635\u0648\u0631\u0629",
          items: {
            zoom: {
              term: "\u062A\u0643\u0628\u064A\u0631\u060C \u062A\u0635\u063A\u064A\u0631",
              text: "\u064A\u0643\u0628\u0651\u0631\u0627\u0646 \u0627\u0644\u0635\u0648\u0631\u0629 \u0623\u0648 \u064A\u0635\u063A\u0651\u0631\u0627\u0646\u0647\u0627. \u062A\u0638\u0647\u0631 \u0627\u0644\u0646\u0633\u0628\u0629 \u0627\u0644\u0645\u0626\u0648\u064A\u0629 \u0628\u064A\u0646 \u0627\u0644\u0632\u0631\u064A\u0646."
            },
            fit: {
              term: "\u0645\u0644\u0627\u0621\u0645\u0629 \u0627\u0644\u0646\u0627\u0641\u0630\u0629",
              text: "\u064A\u0639\u064A\u062F \u0627\u0644\u0635\u0648\u0631\u0629 \u0625\u0644\u0649 \u062D\u062C\u0645 \u0627\u0644\u0646\u0627\u0641\u0630\u0629 (\u0627\u0644\u0645\u0641\u062A\u0627\u062D 0)."
            },
            keys: {
              term: "\u0627\u0644\u0627\u062E\u062A\u0635\u0627\u0631\u0627\u062A",
              text: "\u0627\u0644\u0623\u0633\u0647\u0645 \u062A\u062D\u0631\u0651\u0643 \u0627\u0644\u0635\u0648\u0631\u0629\u060C \u0648\u0639\u0644\u0627\u0645\u062A\u0627 + \u0648 \u2212 \u0644\u0644\u062A\u0643\u0628\u064A\u0631 \u0648\u0627\u0644\u062A\u0635\u063A\u064A\u0631."
            }
          }
        },
        annotationTools: {
          title: "\u0623\u062F\u0648\u0627\u062A \u0627\u0644\u062A\u0639\u0644\u064A\u0642 \u0627\u0644\u062A\u0648\u0636\u064A\u062D\u064A",
          items: {
            tools: {
              term: "\u0623\u062F\u0648\u0627\u062A \u0627\u0644\u062A\u0639\u0644\u064A\u0642 \u0627\u0644\u062A\u0648\u0636\u064A\u062D\u064A",
              text: "\u062A\u062D\u062F\u064A\u062F \u0648\u0645\u0633\u062A\u0637\u064A\u0644 \u0648\u0633\u062D\u0627\u0628\u0629 \u0645\u0631\u0627\u062C\u0639\u0629 (\u0644\u0625\u062D\u0627\u0637\u0629 \u0645\u0646\u0637\u0642\u0629 \u062A\u0644\u0632\u0645 \u0645\u0631\u0627\u062C\u0639\u062A\u0647\u0627) \u0648\u0633\u0647\u0645 \u0648\u0646\u0635. \u0644\u0627 \u062A\u0638\u0647\u0631 \u0625\u0644\u0627 \u0625\u0630\u0627 \u0643\u0627\u0646 \u0644\u0643 \u062D\u0642 \u0627\u0644\u062A\u0639\u0644\u064A\u0642."
            },
            colors: {
              term: "\u0627\u0644\u0644\u0648\u0646",
              text: "\u0623\u062D\u0645\u0631 \u0623\u0648 \u0628\u0631\u062A\u0642\u0627\u0644\u064A \u0623\u0648 \u0623\u062E\u0636\u0631 \u0623\u0648 \u0623\u0632\u0631\u0642 \u0623\u0648 \u0623\u0633\u0648\u062F\u060C \u0644\u0644\u0631\u0633\u0645 \u0627\u0644\u0642\u0627\u062F\u0645."
            },
            draw: {
              term: "\u0627\u0644\u0631\u0633\u0645 \u0639\u0644\u0649 \u0627\u0644\u0635\u0641\u062D\u0629",
              text: "\u0628\u0627\u0644\u0641\u0623\u0631\u0629 \u0627\u0631\u0633\u0645 \u0627\u0644\u0634\u0643\u0644. \u0648\u0628\u0644\u0648\u062D\u0629 \u0627\u0644\u0645\u0641\u0627\u062A\u064A\u062D \u062A\u062D\u0631\u0651\u0643 \u0627\u0644\u0623\u0633\u0647\u0645 \u0645\u0624\u0634\u0631\u064B\u0627\u060C \u0648\u2066Enter\u2069 \u064A\u0636\u0639 \u0627\u0644\u0632\u0627\u0648\u064A\u0629 \u0627\u0644\u0623\u0648\u0644\u0649 \u062B\u0645 \u0627\u0644\u0632\u0627\u0648\u064A\u0629 \u0627\u0644\u0645\u0642\u0627\u0628\u0644\u0629\u060C \u0648\u2066Esc\u2069 \u064A\u0644\u063A\u064A."
            },
            list: {
              term: "\u0625\u0638\u0647\u0627\u0631 \u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u062A\u0639\u0644\u064A\u0642\u0627\u062A \u0627\u0644\u062A\u0648\u0636\u064A\u062D\u064A\u0629",
              text: "\u064A\u0641\u062A\u062D \u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u062A\u0639\u0644\u064A\u0642\u0627\u062A \u0627\u0644\u062A\u0648\u0636\u064A\u062D\u064A\u0629 \u0644\u0644\u0646\u0633\u062E\u0629 \u0627\u0644\u0645\u0639\u0631\u0648\u0636\u0629 \u0623\u0648 \u064A\u063A\u0644\u0642\u0647\u0627."
            }
          }
        },
        annotationPanel: {
          title: "\u0627\u0644\u062A\u0639\u0644\u064A\u0642\u0627\u062A \u0627\u0644\u062A\u0648\u0636\u064A\u062D\u064A\u0629 (\u0627\u0644\u0642\u0627\u0626\u0645\u0629 \u0648\u0627\u0644\u062A\u0641\u0627\u0635\u064A\u0644)",
          items: {
            filters: {
              term: "\u062A\u0635\u0641\u064A\u0629 \u062D\u0633\u0628 \u0627\u0644\u062D\u0627\u0644\u0629\u060C \u062A\u0635\u0641\u064A\u0629 \u062D\u0633\u0628 \u0627\u0644\u0645\u0624\u0633\u0633\u0629",
              text: "\u0627\u0644\u062D\u0627\u0644\u0629: \u0627\u0644\u0643\u0644 \u0623\u0648 \u0627\u0644\u0645\u0641\u062A\u0648\u062D\u0629 \u0623\u0648 \u0627\u0644\u0645\u062D\u0644\u0648\u0644\u0629. \u0627\u0644\u0645\u0624\u0633\u0633\u0629: \u0643\u0644\u0647\u0627 \u0623\u0648 \u0648\u0627\u062D\u062F\u0629\u060C \u0639\u0646\u062F\u0645\u0627 \u064A\u0639\u0644\u0651\u0642 \u0634\u0631\u0643\u0627\u0621 \u0623\u064A\u0636\u064B\u0627."
            },
            item: {
              term: "\u0627\u0644\u062A\u0639\u0644\u064A\u0642 \u0627\u0644\u062A\u0648\u0636\u064A\u062D\u064A 1 \xB7 \u0627\u0644\u0635\u0641\u062D\u0629 3",
              text: "\u064A\u0639\u0637\u064A \u0643\u0644 \u0633\u0637\u0631 \u0631\u0642\u0645 \u0627\u0644\u062A\u0639\u0644\u064A\u0642 \u0648\u0635\u0641\u062D\u062A\u0647 \u0648\u062D\u0627\u0644\u062A\u0647 (\u0645\u0641\u062A\u0648\u062D \u0623\u0648 \u0645\u062D\u0644\u0648\u0644) \u0648\u0645\u0624\u0633\u0633\u0629 \u0643\u0627\u062A\u0628\u0647: \u0645\u0624\u0633\u0633\u062A\u064A \u0623\u0648 \u0645\u0624\u0633\u0633\u0629 \u0634\u0631\u064A\u0643\u0629."
            },
            empty: {
              term: "\u0644\u0627 \u062A\u0648\u062C\u062F \u062A\u0639\u0644\u064A\u0642\u0627\u062A \u062A\u0648\u0636\u064A\u062D\u064A\u0629 \u0639\u0644\u0649 \u0647\u0630\u0647 \u0627\u0644\u0646\u0633\u062E\u0629 \u0628\u0639\u062F",
              text: "\u0627\u0644\u0642\u0627\u0626\u0645\u0629 \u0641\u0627\u0631\u063A\u0629\u060C \u0623\u0648 \u0644\u0627 \u064A\u0648\u062C\u062F \u062A\u0639\u0644\u064A\u0642 \u064A\u0637\u0627\u0628\u0642 \u0627\u0644\u062A\u0635\u0641\u064A\u0629."
            },
            new: {
              term: "\u062A\u0639\u0644\u064A\u0642 \u062A\u0648\u0636\u064A\u062D\u064A \u062C\u062F\u064A\u062F",
              text: "\u0628\u0639\u062F \u0627\u0644\u0631\u0633\u0645: \xAB\u0627\u0644\u062A\u0639\u0644\u064A\u0642\xBB (\u0625\u0644\u0632\u0627\u0645\u064A\u060C 2000 \u062D\u0631\u0641 \u0643\u062D\u062F \u0623\u0642\u0635\u0649) \u064A\u0634\u0631\u062D \u0645\u0627 \u064A\u062C\u0628 \u062A\u0635\u062D\u064A\u062D\u0647. \u0648\u0644\u0644\u0646\u0635: \xAB\u0627\u0644\u0646\u0635 \u0627\u0644\u0645\u0639\u0631\u0648\u0636 \u0639\u0644\u0649 \u0627\u0644\u0645\u062E\u0637\u0637\xBB (500 \u062D\u0631\u0641 \u0643\u062D\u062F \u0623\u0642\u0635\u0649). \xAB\u0625\u0636\u0627\u0641\u0629 \u0627\u0644\u062A\u0639\u0644\u064A\u0642 \u0627\u0644\u062A\u0648\u0636\u064A\u062D\u064A\xBB \u064A\u0635\u0627\u062F\u0642."
            },
            details: {
              term: "\u062A\u0641\u0627\u0635\u064A\u0644 \u062A\u0639\u0644\u064A\u0642 \u062A\u0648\u0636\u064A\u062D\u064A",
              text: "\u0627\u0644\u062A\u0639\u0644\u064A\u0642 \u0648\u0643\u0627\u062A\u0628\u0647 \u0648\u062A\u0627\u0631\u064A\u062E\u0647. \u0623\u0632\u0631\u0627\u0631 \xAB\u062D\u0644\u0651\xBB (\u0623\u0648 \xAB\u0625\u0639\u0627\u062F\u0629 \u0641\u062A\u062D\xBB) \u0648\xAB\u062A\u0639\u062F\u064A\u0644\xBB (\u063A\u064A\u0631 \u0645\u0645\u0643\u0646 \u0628\u0639\u062F \u0627\u0644\u062D\u0644) \u0648\xAB\u062D\u0630\u0641\xBB\u060C \u0628\u062D\u0633\u0628 \u0635\u0644\u0627\u062D\u064A\u0627\u062A\u0643."
            },
            thread: {
              term: "\u0627\u0644\u0646\u0642\u0627\u0634",
              text: "\u0627\u0644\u0631\u062F\u0648\u062F \u0639\u0644\u0649 \u0627\u0644\u062A\u0639\u0644\u064A\u0642. \xAB\u0631\u062F\u0651\xBB \u064A\u0641\u062A\u062D \u062D\u0642\u0644\u064B\u0627 \u0648\xAB\u0625\u0631\u0633\u0627\u0644\xBB \u064A\u0646\u0634\u0631. \u064A\u0644\u0632\u0645 \u0623\u0646 \u064A\u0643\u0648\u0646 \u0644\u0643 \u062D\u0642 \u0627\u0644\u062A\u0639\u0644\u064A\u0642."
            }
          }
        },
        states: {
          title: "\u0631\u0633\u0627\u0626\u0644 \u062D\u0627\u0644\u0629 \u0627\u0644\u0645\u0639\u0627\u064A\u0646\u0629",
          items: {
            preparing: {
              term: "\u062C\u0627\u0631\u064D \u062A\u062C\u0647\u064A\u0632 \u0627\u0644\u0645\u0639\u0627\u064A\u0646\u0629\u2026",
              text: "\u064A\u062C\u0631\u064A \u062A\u062D\u0648\u064A\u0644 \u0627\u0644\u0645\u0644\u0641 \u0644\u0644\u0639\u0631\u0636\u060C \u0639\u0627\u062F\u0629\u064B \u0641\u064A \u0628\u0636\u0639 \u062B\u0648\u0627\u0646\u064D. \u062A\u062A\u062D\u062F\u0651\u062B \u0627\u0644\u0635\u0641\u062D\u0629 \u062A\u0644\u0642\u0627\u0626\u064A\u064B\u0627."
            },
            unavailable: {
              term: "\u0647\u0630\u0627 \u0627\u0644\u0645\u0644\u0641 \u0642\u064A\u062F \u0627\u0644\u0631\u0641\u0639 \u0623\u0648 \u0627\u0644\u0641\u062D\u0635",
              text: "\u0633\u064A\u0635\u0628\u062D \u0642\u0627\u0628\u0644\u064B\u0627 \u0644\u0644\u0642\u0631\u0627\u0621\u0629 \u0628\u0639\u062F \u0627\u0646\u062A\u0647\u0627\u0621 \u0627\u0644\u0631\u0641\u0639 \u0648\u0641\u062D\u0635 \u0627\u0644\u0641\u064A\u0631\u0648\u0633\u0627\u062A. \u0648\u0625\u0646 \u0631\u064F\u0641\u0636 \u0641\u0644\u0627 \u064A\u0645\u0643\u0646 \u0641\u062A\u062D\u0647."
            },
            none: {
              term: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0645\u0639\u0627\u064A\u0646\u0629 \u0644\u0647\u0630\u0627 \u0627\u0644\u0646\u0648\u0639 \u0645\u0646 \u0627\u0644\u0645\u0644\u0641\u0627\u062A",
              text: "\u0646\u0632\u0651\u0644 \u0627\u0644\u0645\u0644\u0641 \u0644\u0641\u062A\u062D\u0647 \u0628\u062A\u0637\u0628\u064A\u0642 \u0622\u062E\u0631."
            },
            failed: {
              term: "\u062A\u0639\u0630\u0651\u0631 \u0625\u0646\u0634\u0627\u0621 \u0627\u0644\u0645\u0639\u0627\u064A\u0646\u0629",
              text: "\u0631\u0628\u0645\u0627 \u064A\u0643\u0648\u0646 \u0627\u0644\u0645\u0644\u0641 \u062A\u0627\u0644\u0641\u064B\u0627: \u0646\u0632\u0651\u0644\u0647 \u0623\u0648 \u0623\u0631\u0633\u0644 \u0646\u0633\u062E\u0629 \u062C\u062F\u064A\u062F\u0629."
            },
            password: {
              term: "\u0645\u0644\u0641 \u2066PDF\u2069 \u0647\u0630\u0627 \u0645\u062D\u0645\u064A \u0628\u0643\u0644\u0645\u0629 \u0645\u0631\u0648\u0631",
              text: "\u0644\u0627 \u064A\u0645\u0643\u0646 \u0639\u0631\u0636\u0647 \u0647\u0646\u0627: \u0646\u0632\u0651\u0644\u0647 \u0644\u0641\u062A\u062D\u0647."
            },
            noVersion: {
              term: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0628\u0639\u062F \u0646\u0633\u062E\u0629 \u064A\u0645\u0643\u0646 \u0639\u0631\u0636\u0647\u0627 \u0644\u0647\u0630\u0627 \u0627\u0644\u0645\u0633\u062A\u0646\u062F",
              text: "\u0633\u062A\u0638\u0647\u0631 \u0646\u0633\u062E\u0629 \u0628\u0645\u062C\u0631\u062F \u0627\u0646\u062A\u0647\u0627\u0621 \u0641\u062D\u0635\u0647\u0627."
            },
            notFound: {
              term: "\u0627\u0644\u0645\u0633\u062A\u0646\u062F \u063A\u064A\u0631 \u0645\u0648\u062C\u0648\u062F",
              text: "\u063A\u064A\u0631 \u0645\u0648\u062C\u0648\u062F \u0623\u0648 \u0644\u064A\u0633\u062A \u0644\u0643 \u0635\u0644\u0627\u062D\u064A\u0629 \u0627\u0644\u0648\u0635\u0648\u0644 \u0625\u0644\u064A\u0647. \u0627\u0644\u0632\u0631 \xAB\u0627\u0644\u0639\u0648\u062F\u0629 \u0625\u0644\u0649 \u0627\u0644\u0645\u0644\u0641\u0627\u062A\xBB \u064A\u0639\u064A\u062F\u0643 \u0625\u0644\u0649 \u0627\u0644\u0645\u0634\u0631\u0648\u0639."
            },
            noSpace: {
              term: "\u0645\u0633\u0627\u062D\u0629 \u0627\u0644\u0645\u0644\u0641\u0627\u062A \u063A\u064A\u0631 \u062C\u0627\u0647\u0632\u0629 \u0628\u0639\u062F",
              text: "\u0633\u062A\u062A\u0648\u0641\u0631 \u0627\u0644\u0645\u0633\u062A\u0646\u062F\u0627\u062A \u0628\u0645\u062C\u0631\u062F \u0625\u0646\u0634\u0627\u0621 \u0627\u0644\u0645\u0633\u0627\u062D\u0629 \u0627\u0644\u062F\u0627\u062E\u0644\u064A\u0629 \u0644\u0644\u0645\u0634\u0631\u0648\u0639."
            }
          }
        }
      }
    },
    search: {
      title: "\u0646\u062A\u0627\u0626\u062C \u0627\u0644\u0628\u062D\u062B",
      intro: "\u0643\u0644 \u0646\u062A\u0627\u0626\u062C \u0627\u0644\u0628\u062D\u062B \u0641\u064A \u0627\u0644\u0645\u0624\u0633\u0633\u0629: \u0627\u0644\u0645\u0634\u0627\u0631\u064A\u0639 \u0648\u0627\u0644\u0645\u0633\u062A\u0646\u062F\u0627\u062A \u0648\u0627\u0644\u0645\u0647\u0627\u0645 \u0648\u0627\u0644\u0639\u0645\u0644\u0627\u0621 \u0648\u0627\u0644\u0631\u0633\u0627\u0626\u0644. \u062A\u0635\u0644 \u0625\u0644\u064A\u0647\u0627 \u0645\u0646 \u0627\u0644\u0628\u062D\u062B \u0641\u064A \u0627\u0644\u0631\u0623\u0633.",
      sections: {
        page: {
          title: "\u0635\u0641\u062D\u0629 \u0627\u0644\u0646\u062A\u0627\u0626\u062C",
          items: {
            field: {
              term: "\u0628\u062D\u062B\u0643",
              text: "\u0627\u0643\u062A\u0628 \u062D\u0631\u0641\u064A\u0646 \u0639\u0644\u0649 \u0627\u0644\u0623\u0642\u0644. \u062A\u062A\u062D\u062F\u0651\u062B \u0627\u0644\u0635\u0641\u062D\u0629 \u0639\u0646\u062F\u0645\u0627 \u062A\u062A\u0648\u0642\u0641 \u0642\u0644\u064A\u0644\u064B\u0627\u060C \u0648\u064A\u064F\u062D\u0641\u0638 \u0627\u0644\u0628\u062D\u062B \u0641\u064A \u0627\u0644\u0639\u0646\u0648\u0627\u0646."
            },
            scope: {
              term: "\u0646\u0648\u0639 \u0627\u0644\u0646\u062A\u0627\u0626\u062C",
              text: "\u0634\u0627\u0631\u0627\u062A \u0627\u0644\u0643\u0644 \u0648\u0627\u0644\u0645\u0634\u0627\u0631\u064A\u0639 \u0648\u0627\u0644\u0645\u0633\u062A\u0646\u062F\u0627\u062A \u0648\u0627\u0644\u0645\u0647\u0627\u0645 \u0648\u0627\u0644\u0639\u0645\u0644\u0627\u0621 \u0644\u0644\u0627\u062D\u062A\u0641\u0627\u0638 \u0628\u0646\u0648\u0639 \u0648\u0627\u062D\u062F \u0641\u0642\u0637. \u062A\u0643\u0648\u0646 \u0627\u0644\u0634\u0627\u0631\u0629 \u0627\u0644\u0645\u062E\u062A\u0627\u0631\u0629 \u062F\u0627\u0643\u0646\u0629."
            },
            count: {
              term: "\u0639\u062F\u062F \u0627\u0644\u0646\u062A\u0627\u0626\u062C",
              text: "\u0645\u062B\u0644 \xAB5 \u0646\u062A\u0627\u0626\u062C\xBB."
            },
            hasMore: {
              term: "\u062A\u0648\u062C\u062F \u0646\u062A\u0627\u0626\u062C \u0623\u062E\u0631\u0649: \u062D\u062F\u0651\u062F \u0628\u062D\u062B\u0643 \u0623\u0643\u062B\u0631.",
              text: "\u064A\u0639\u0631\u0636 \u0643\u0644 \u0646\u0648\u0639 20 \u0646\u062A\u064A\u062C\u0629 \u0643\u062D\u062F \u0623\u0642\u0635\u0649. \u0625\u0646 \u0648\u064F\u062C\u062F \u0627\u0644\u0645\u0632\u064A\u062F \u0641\u062F\u0642\u0651\u0642 \u0628\u062D\u062B\u0643."
            }
          }
        },
        flyout: {
          title: "\u0627\u0644\u0628\u062D\u062B \u0627\u0644\u0633\u0631\u064A\u0639 \u0641\u064A \u0627\u0644\u0631\u0623\u0633",
          items: {
            open: {
              term: "\u0627\u0628\u062D\u062B \u0641\u064A \u0627\u0644\u0645\u0634\u0627\u0631\u064A\u0639 \u0648\u0627\u0644\u0645\u0644\u0641\u0627\u062A \u0648\u0627\u0644\u0631\u0633\u0627\u0626\u0644\u2026",
              text: "\u062D\u0642\u0644 \u0627\u0644\u0631\u0623\u0633 (\u0623\u0648 \u2066Ctrl+K\u2069 \u0623\u0648 \u2066/\u2069) \u064A\u0641\u062A\u062D \u0646\u0627\u0641\u0630\u0629 \u0628\u062D\u062B \u0641\u064A \u0627\u0644\u0645\u0624\u0633\u0633\u0629."
            },
            field: {
              term: "\u0627\u0644\u0628\u062D\u062B \u0641\u064A \u0627\u0644\u0645\u0624\u0633\u0633\u0629",
              text: "\u062D\u0642\u0644 \u0647\u0630\u0647 \u0627\u0644\u0646\u0627\u0641\u0630\u0629. \u062A\u0639\u0631\u0636 \u0628\u0639\u0636 \u0627\u0644\u0646\u062A\u0627\u0626\u062C \u0644\u0643\u0644 \u0646\u0648\u0639."
            },
            more: {
              term: "\u0639\u0631\u0636 \u0643\u0644 \u0627\u0644\u0645\u0634\u0627\u0631\u064A\u0639 \u0648\u0627\u0644\u0645\u0633\u062A\u0646\u062F\u0627\u062A \u0648\u0627\u0644\u0645\u0647\u0627\u0645\u2026",
              text: "\u0627\u0644\u0633\u0637\u0631 \u0627\u0644\u0623\u062E\u064A\u0631 \u0645\u0646 \u0643\u0644 \u0646\u0648\u0639 \u064A\u0641\u062A\u062D \u0635\u0641\u062D\u0629 \u0627\u0644\u0646\u062A\u0627\u0626\u062C \u0627\u0644\u0645\u0642\u062A\u0635\u0631\u0629 \u0639\u0644\u0649 \u0647\u0630\u0627 \u0627\u0644\u0646\u0648\u0639."
            },
            all: {
              term: "\u0639\u0631\u0636 \u0643\u0644 \u0627\u0644\u0646\u062A\u0627\u0626\u062C \u0639\u0646\u2026",
              text: "\u064A\u0641\u062A\u062D \u0647\u0630\u0647 \u0627\u0644\u0635\u0641\u062D\u0629 \u0628\u0643\u0644 \u0646\u062A\u0627\u0626\u062C \u0628\u062D\u062B\u0643."
            },
            close: {
              term: "\u2066Esc\u2069",
              text: "\u064A\u063A\u0644\u0642 \u0627\u0644\u0646\u0627\u0641\u0630\u0629."
            }
          }
        },
        results: {
          title: "\u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u0646\u062A\u0627\u0626\u062C",
          items: {
            groups: {
              term: "\u0627\u0644\u0645\u0634\u0627\u0631\u064A\u0639 \u0648\u0627\u0644\u0645\u0633\u062A\u0646\u062F\u0627\u062A \u0648\u0627\u0644\u0645\u0647\u0627\u0645 \u0648\u0627\u0644\u0639\u0645\u0644\u0627\u0621 \u0648\u0627\u0644\u0631\u0633\u0627\u0626\u0644",
              text: "\u062A\u064F\u0631\u062A\u064E\u0651\u0628 \u0627\u0644\u0646\u062A\u0627\u0626\u062C \u062D\u0633\u0628 \u0627\u0644\u0646\u0648\u0639\u060C \u0628\u0647\u0630\u0627 \u0627\u0644\u062A\u0631\u062A\u064A\u0628."
            },
            hit: {
              term: "\u0633\u0637\u0631 \u0646\u062A\u064A\u062C\u0629",
              text: "\u0623\u064A\u0642\u0648\u0646\u0629 \u062D\u0633\u0628 \u0627\u0644\u0646\u0648\u0639\u060C \u062B\u0645 \u0627\u0644\u0639\u0646\u0648\u0627\u0646 \u0645\u0639 \u0627\u0644\u0643\u0644\u0645\u0627\u062A \u0627\u0644\u0645\u0648\u062C\u0648\u062F\u0629 \u0628\u062E\u0637 \u063A\u0644\u064A\u0638 \u0639\u0644\u0649 \u062E\u0644\u0641\u064A\u0629 \u0645\u0644\u0648\u0651\u0646\u0629. \u064A\u0638\u0647\u0631 \u0628\u062C\u0627\u0646\u0628\u0647 \u0631\u0645\u0632 (\u0644\u0644\u0645\u0634\u0631\u0648\u0639 \u0623\u0648 \u0627\u0644\u0645\u0633\u062A\u0646\u062F)\u060C \u0648\u0627\u0633\u0645 \u0627\u0644\u0642\u0646\u0627\u0629 \u0628\u0627\u0644\u0646\u0633\u0628\u0629 \u0625\u0644\u0649 \u0631\u0633\u0627\u0644\u0629."
            },
            open: {
              term: "\u0641\u062A\u062D \u0646\u062A\u064A\u062C\u0629",
              text: "\u0627\u0646\u0642\u0631 \u0623\u0648 \u0627\u0636\u063A\u0637 \u2066Enter\u2069: \u064A\u064F\u0641\u062A\u062D \u0627\u0644\u0645\u0634\u0631\u0648\u0639 \u0623\u0648 \u0627\u0644\u062D\u0631\u064A\u0641\u060C \u0648\u0627\u0644\u0645\u0633\u062A\u0646\u062F \u0641\u064A \u0627\u0644\u0642\u0627\u0631\u0626\u060C \u0648\u0627\u0644\u0645\u0647\u0645\u0629 \u0641\u064A \u0645\u0647\u0627\u0645 \u0645\u0634\u0631\u0648\u0639\u0647\u0627\u060C \u0648\u0627\u0644\u0631\u0633\u0627\u0644\u0629 \u0641\u064A \u0645\u062D\u0627\u062F\u062B\u062A\u0647\u0627."
            },
            keyboard: {
              term: "\u0628\u0644\u0648\u062D\u0629 \u0627\u0644\u0645\u0641\u0627\u062A\u064A\u062D",
              text: "\u0627\u0644\u0633\u0647\u0645\u0627\u0646 \u0644\u0623\u0639\u0644\u0649 \u0648\u0644\u0623\u0633\u0641\u0644 \u064A\u062A\u0646\u0642\u0644\u0627\u0646 \u0628\u064A\u0646 \u0627\u0644\u0646\u062A\u0627\u0626\u062C \u062F\u0648\u0646 \u0645\u063A\u0627\u062F\u0631\u0629 \u062D\u0642\u0644 \u0627\u0644\u0643\u062A\u0627\u0628\u0629\u060C \u0648\u2066Enter\u2069 \u064A\u0641\u062A\u062D \u0627\u0644\u0646\u062A\u064A\u062C\u0629 \u0627\u0644\u0645\u062D\u062F\u0651\u062F\u0629."
            }
          }
        },
        states: {
          title: "\u062D\u0627\u0644\u0627\u062A \u0627\u0644\u0628\u062D\u062B",
          items: {
            prompt: {
              term: "\u0627\u0643\u062A\u0628 \u062D\u0631\u0641\u064A\u0646 \u0639\u0644\u0649 \u0627\u0644\u0623\u0642\u0644 \u0644\u0628\u062F\u0621 \u0627\u0644\u0628\u062D\u062B.",
              text: "\u0631\u0633\u0627\u0644\u0629 \u0645\u0627 \u062F\u0627\u0645 \u0644\u0645 \u064A\u064F\u0643\u062A\u0628 \u0634\u064A\u0621. \u0648\u062A\u0638\u0647\u0631 \xAB\u0627\u0643\u062A\u0628 \u062D\u0631\u0641\u064A\u0646 \u0639\u0644\u0649 \u0627\u0644\u0623\u0642\u0644.\xBB \u0625\u0630\u0627 \u0643\u0627\u0646 \u0627\u0644\u0646\u0635 \u0642\u0635\u064A\u0631\u064B\u0627 \u062C\u062F\u064B\u0627."
            },
            loading: {
              term: "\u062C\u0627\u0631\u064D \u0627\u0644\u0628\u062D\u062B\u2026",
              text: "\u064A\u062F\u0648\u0631 \u0645\u0624\u0634\u0631 \u0623\u062B\u0646\u0627\u0621 \u0627\u0644\u062A\u062D\u0645\u064A\u0644."
            },
            empty: {
              term: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0646\u062A\u0627\u0626\u062C \u0639\u0646\u2026",
              text: "\u062A\u062D\u0642\u0642 \u0645\u0646 \u0627\u0644\u0625\u0645\u0644\u0627\u0621 \u0623\u0648 \u062C\u0631\u0651\u0628 \u0643\u0644\u0645\u0629 \u0623\u062E\u0631\u0649."
            },
            error: {
              term: "\u0639\u0645\u0644\u064A\u0627\u062A \u0628\u062D\u062B \u0643\u062B\u064A\u0631\u0629\u060C \u062A\u0639\u0630\u0651\u0631 \u0625\u062C\u0631\u0627\u0621 \u0627\u0644\u0628\u062D\u062B",
              text: "\u0641\u064A \u0627\u0644\u062D\u0627\u0644\u0629 \u0627\u0644\u0623\u0648\u0644\u0649 \u0627\u0646\u062A\u0638\u0631 \u0642\u0644\u064A\u0644\u064B\u0627: \u0639\u062F\u062F \u0639\u0645\u0644\u064A\u0627\u062A \u0627\u0644\u0628\u062D\u062B \u0641\u064A \u0627\u0644\u062F\u0642\u064A\u0642\u0629 \u0645\u062D\u062F\u0648\u062F. \u0648\u0641\u064A \u0627\u0644\u062D\u0627\u0644\u062A\u064A\u0646 \u064A\u0639\u064A\u062F \u0627\u0644\u0632\u0631 \xAB\u0625\u0639\u0627\u062F\u0629 \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629\xBB \u0627\u0644\u0628\u062D\u062B."
            }
          }
        }
      }
    },
    more: {
      title: "\u0627\u0644\u0645\u0632\u064A\u062F",
      intro: "\u0627\u062E\u062A\u0635\u0627\u0631\u0627\u062A \u0625\u0644\u0649 \u0628\u0642\u064A\u0629 \u2066BatiFlow\u2069: \u0627\u0644\u062D\u0631\u0641\u0627\u0621 \u0648\u0627\u0644\u0634\u0631\u0627\u0643\u0627\u062A \u0648\u0625\u062F\u0627\u0631\u0629 \u0627\u0644\u0645\u0643\u062A\u0628. \u0644\u0627 \u064A\u0638\u0647\u0631 \u0643\u0644 \u0648\u0627\u062D\u062F \u0645\u0646\u0647\u0627 \u0625\u0644\u0627 \u0625\u0630\u0627 \u0643\u0627\u0646 \u0644\u0643 \u062D\u0642 \u0641\u064A\u0647.",
      sections: {
        header: {
          title: "\u0627\u0644\u0635\u0641\u062D\u0629",
          items: {
            title: {
              term: "\u0627\u0644\u0645\u0632\u064A\u062F",
              text: "\u0627\u0633\u0645 \u0627\u0644\u0635\u0641\u062D\u0629. \u064A\u064F\u0641\u062A\u062D \u0627\u0644\u062A\u0637\u0628\u064A\u0642 \u0623\u064A\u0636\u064B\u0627 \u0628\u0640 \u2066Alt+7\u2069."
            },
            cards: {
              term: "\u0627\u0644\u0628\u0637\u0627\u0642\u0627\u062A",
              text: "\u0643\u0644 \u0628\u0637\u0627\u0642\u0629 \u0631\u0627\u0628\u0637: \u0627\u0646\u0642\u0631 \u0639\u0644\u064A\u0647\u0627 \u0644\u0641\u062A\u062D \u0627\u0644\u0635\u0641\u062D\u0629. \u0648\u0625\u0646 \u0644\u0645 \u064A\u0643\u0646 \u0644\u0643 \u062D\u0642 \u0641\u064A \u0623\u064A \u0645\u0646\u0647\u0627 \u0641\u0644\u0627 \u062A\u0639\u0631\u0636 \u0627\u0644\u0635\u0641\u062D\u0629 \u0625\u0644\u0627 \u0627\u0644\u0631\u0633\u0627\u0644\u0629 \u0627\u0644\u0633\u0641\u0644\u064A\u0629."
            }
          }
        },
        cards: {
          title: "\u0627\u0644\u0628\u0637\u0627\u0642\u0627\u062A",
          items: {
            clients: {
              term: "\u0627\u0644\u062D\u0631\u0641\u0627\u0621",
              text: "\u0623\u0635\u062D\u0627\u0628 \u0627\u0644\u0645\u0634\u0627\u0631\u064A\u0639: \u0627\u0644\u0645\u0644\u0641 \u0627\u0644\u062C\u0628\u0627\u0626\u064A \u0648\u062C\u0647\u0627\u062A \u0627\u0644\u0627\u062A\u0635\u0627\u0644 \u0648\u0627\u0644\u0639\u0646\u0627\u0648\u064A\u0646. \u0644\u0645\u0646 \u064A\u0645\u0643\u0646\u0647 \u0627\u0644\u0627\u0637\u0644\u0627\u0639 \u0639\u0644\u0649 \u0627\u0644\u062D\u0631\u0641\u0627\u0621."
            },
            partnerships: {
              term: "\u0627\u0644\u0634\u0631\u0627\u0643\u0627\u062A",
              text: "\u0637\u0644\u0628\u0627\u062A \u0627\u0644\u0634\u0631\u0627\u0643\u0629 \u0627\u0644\u0648\u0627\u0631\u062F\u0629 \u0648\u0641\u0636\u0627\u0621\u0627\u062A \u0627\u0644\u0645\u0624\u0633\u0633\u0627\u062A \u0627\u0644\u0623\u062E\u0631\u0649 \u0627\u0644\u062A\u064A \u062A\u062F\u064A\u0631 \u0641\u064A\u0647\u0627 \u0645\u0646\u062F\u0648\u0628\u064A \u0645\u0624\u0633\u0633\u062A\u0643. \u0644\u0644\u0645\u0627\u0644\u0643\u064A\u0646 \u0648\u0627\u0644\u0645\u0633\u0624\u0648\u0644\u064A\u0646 \u0641\u0642\u0637."
            },
            approvals: {
              term: "\u0627\u0644\u0645\u0648\u0627\u0641\u0642\u0629 \u0639\u0644\u0649 \u0627\u0644\u0648\u0635\u0648\u0644 \u0627\u0644\u062E\u0627\u0631\u062C\u064A",
              text: "\u0627\u0645\u0646\u062D \u0623\u0648 \u0627\u0631\u0641\u0636 \u0648\u0635\u0648\u0644 \u0639\u0636\u0648 \u0625\u0644\u0649 \u0641\u0636\u0627\u0621 \u0645\u0624\u0633\u0633\u0629 \u0623\u062E\u0631\u0649. \u0644\u0645\u0646 \u064A\u0645\u0644\u0643 \u062D\u0642 \u0627\u0644\u0645\u0648\u0627\u0641\u0642\u0629 \u0647\u0630\u0627."
            },
            admin: {
              term: "\u0627\u0644\u0625\u062F\u0627\u0631\u0629",
              text: "\u0623\u0639\u0636\u0627\u0621 \u0645\u0643\u062A\u0628\u0643 \u0648\u062F\u0639\u0648\u0627\u062A\u0647\u0645 \u0648\u0623\u062F\u0648\u0627\u0631\u0647\u0645 \u0648\u0635\u0644\u0627\u062D\u064A\u0627\u062A\u0647\u0645. \u062A\u0638\u0647\u0631 \u0625\u0630\u0627 \u0643\u0627\u0646 \u0628\u0625\u0645\u0643\u0627\u0646\u0643 \u0641\u062A\u062D \u0635\u0641\u062D\u0629 \u0625\u062F\u0627\u0631\u0629 \u0648\u0627\u062D\u062F\u0629 \u0639\u0644\u0649 \u0627\u0644\u0623\u0642\u0644."
            }
          }
        },
        note: {
          title: "\u0627\u0644\u0631\u0633\u0627\u0644\u0629 \u0627\u0644\u0633\u0641\u0644\u064A\u0629",
          items: {
            soon: {
              term: "\u0633\u062A\u0623\u062A\u064A \u0623\u0642\u0633\u0627\u0645 \u0623\u062E\u0631\u0649",
              text: "\u062C\u0645\u0644\u0629 \u0641\u064A \u0623\u0633\u0641\u0644 \u0627\u0644\u0635\u0641\u062D\u0629: \u0633\u062A\u062A\u0648\u0641\u0631 \u0623\u0642\u0633\u0627\u0645 \u0623\u062E\u0631\u0649 (\u0627\u0644\u062D\u0631\u0641\u0627\u0621\u060C \u0637\u0644\u0628\u0627\u062A \u0627\u0644\u0639\u0631\u0648\u0636\u2026) \u0641\u064A \u0625\u0635\u062F\u0627\u0631\u0627\u062A \u0642\u0627\u062F\u0645\u0629 \u0645\u0646 \u2066BatiFlow\u2069."
            },
            empty: {
              term: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0628\u0637\u0627\u0642\u0629",
              text: "\u0625\u0646 \u0644\u0645 \u062A\u0638\u0647\u0631 \u0623\u064A \u0628\u0637\u0627\u0642\u0629 \u0641\u0644\u0623\u0646 \u062F\u0648\u0631\u0643 \u0644\u0627 \u064A\u0641\u062A\u062D \u0623\u064A\u064B\u0651\u0627 \u0645\u0646 \u0647\u0630\u0647 \u0627\u0644\u0635\u0641\u062D\u0627\u062A: \u0627\u0637\u0644\u0628 \u0645\u0646 \u0645\u0633\u0624\u0648\u0644 \u0641\u064A \u0645\u0643\u062A\u0628\u0643."
            }
          }
        }
      }
    },
    spaces: {
      title: "\u0627\u0644\u0641\u0636\u0627\u0621\u0627\u062A \u0627\u0644\u0645\u0634\u062A\u0631\u0643\u0629",
      intro: "\u062A\u0639\u0631\u0636 \u0647\u0630\u0647 \u0627\u0644\u0635\u0641\u062D\u0629 \u0627\u0644\u0641\u0636\u0627\u0621\u0627\u062A \u0627\u0644\u0645\u0634\u062A\u0631\u0643\u0629 \u0627\u0644\u062A\u064A \u064A\u0645\u0643\u0646\u0643 \u0627\u0644\u0648\u0635\u0648\u0644 \u0625\u0644\u064A\u0647\u0627: \u0641\u0636\u0627\u0621\u0627\u062A \u0645\u0624\u0633\u0633\u0627\u062A\u0643 \u0648\u0641\u0636\u0627\u0621\u0627\u062A \u0645\u0624\u0633\u0633\u0627\u062A \u0623\u062E\u0631\u0649 \u0641\u062A\u062D\u062A \u0644\u0643 \u0623\u0628\u0648\u0627\u0628\u0647\u0627. \u064A\u062C\u0645\u0639 \u0627\u0644\u0641\u0636\u0627\u0621 \u0627\u0644\u0645\u0634\u062A\u0631\u0643 \u0623\u0634\u062E\u0627\u0635\u0627\u064B \u0645\u0646 \u0639\u062F\u0629 \u0645\u0624\u0633\u0633\u0627\u062A \u062D\u0648\u0644 \u0645\u0634\u0631\u0648\u0639 \u0623\u0648 \u0645\u0648\u0636\u0648\u0639 \u0645\u0634\u062A\u0631\u0643.",
      sections: {
        header: {
          title: "\u0631\u0623\u0633 \u0627\u0644\u0635\u0641\u062D\u0629",
          items: {
            title: {
              term: "\u0627\u0644\u0641\u0636\u0627\u0621\u0627\u062A \u0627\u0644\u0645\u0634\u062A\u0631\u0643\u0629",
              text: "\u0639\u0646\u0648\u0627\u0646 \u0627\u0644\u0635\u0641\u062D\u0629\u060C \u062A\u0644\u064A\u0647 \u062C\u0645\u0644\u0629 \u0642\u0635\u064A\u0631\u0629 \u062A\u0630\u0643\u0651\u0631\u0643 \u0628\u0645\u0639\u0646\u0649 \u0627\u0644\u0641\u0636\u0627\u0621 \u0627\u0644\u0645\u0634\u062A\u0631\u0643."
            },
            newSpace: {
              term: "\u0641\u0636\u0627\u0621 \u0645\u0634\u062A\u0631\u0643 \u062C\u062F\u064A\u062F",
              text: "\u064A\u0641\u062A\u062D \u0646\u0627\u0641\u0630\u0629 \u0625\u0646\u0634\u0627\u0621 \u0641\u0636\u0627\u0621. \u0644\u0627 \u064A\u0638\u0647\u0631 \u0647\u0630\u0627 \u0627\u0644\u0632\u0631 \u0625\u0644\u0627 \u0625\u0630\u0627 \u0643\u0627\u0646 \u062F\u0648\u0631\u0643 \u064A\u062A\u064A\u062D \u0644\u0643 \u0625\u0646\u0634\u0627\u0621 \u0641\u0636\u0627\u0621\u0627\u062A \u0641\u064A \u0627\u0644\u0645\u0624\u0633\u0633\u0629 \u0627\u0644\u0646\u0634\u0637\u0629."
            },
            waiting: {
              term: "\u0639\u0631\u0636 \u0627\u0644\u062F\u0639\u0648\u0627\u062A",
              text: "\u0634\u0631\u064A\u0637 \u0623\u0632\u0631\u0642 \u0644\u0627 \u064A\u0638\u0647\u0631 \u0625\u0644\u0627 \u0639\u0646\u062F\u0645\u0627 \u062A\u0646\u062A\u0638\u0631 \u062F\u0639\u0648\u0627\u062A \u0631\u062F\u0651\u0643. \u064A\u0641\u062A\u062D \u0627\u0644\u0631\u0627\u0628\u0637 \u0635\u0641\u062D\u0629 \xAB\u0627\u0644\u062F\u0639\u0648\u0627\u062A \u0625\u0644\u0649 \u0627\u0644\u0641\u0636\u0627\u0621\u0627\u062A\xBB."
            }
          }
        },
        ownList: {
          title: "\u0641\u0636\u0627\u0621\u0627\u062A \u0645\u0624\u0633\u0633\u0627\u062A\u064A",
          items: {
            list: {
              term: "\u0641\u0636\u0627\u0621\u0627\u062A \u0645\u0624\u0633\u0633\u0627\u062A\u064A",
              text: "\u0627\u0644\u0641\u0636\u0627\u0621\u0627\u062A \u0627\u0644\u062A\u064A \u062A\u0633\u062A\u0636\u064A\u0641\u0647\u0627 \u0645\u0624\u0633\u0633\u0627\u062A\u0643: \u0641\u0636\u0627\u0621\u0627\u062A \u0627\u0644\u0645\u0634\u0627\u0631\u064A\u0639 \u0648\u0627\u0644\u0641\u0636\u0627\u0621\u0627\u062A \u0627\u0644\u0645\u0634\u062A\u0631\u0643\u0629 \u0648\u0645\u062C\u0645\u0648\u0639\u0627\u062A \u0627\u0644\u0639\u0645\u0644. \u0627\u0646\u0642\u0631 \u0639\u0644\u0649 \u0633\u0637\u0631 \u0644\u0641\u062A\u062D \u0627\u0644\u0641\u0636\u0627\u0621."
            },
            empty: {
              term: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0641\u0636\u0627\u0621\u0627\u062A \u0645\u0634\u062A\u0631\u0643\u0629 \u0641\u064A \u0645\u0624\u0633\u0633\u0627\u062A\u0643",
              text: "\u0631\u0633\u0627\u0644\u0629 \u062A\u0638\u0647\u0631 \u0645\u0627 \u062F\u0627\u0645 \u0644\u0627 \u064A\u0648\u062C\u062F \u0623\u064A \u0641\u0636\u0627\u0621. \u062A\u0642\u062A\u0631\u062D \u0627\u0644\u0632\u0631 \xAB\u0641\u0636\u0627\u0621 \u0645\u0634\u062A\u0631\u0643 \u062C\u062F\u064A\u062F\xBB \u0625\u0630\u0627 \u0643\u0627\u0646\u062A \u0644\u062F\u064A\u0643 \u0635\u0644\u0627\u062D\u064A\u0629 \u0625\u0646\u0634\u0627\u0621 \u0641\u0636\u0627\u0621."
            }
          }
        },
        externalList: {
          title: "\u0627\u0644\u0641\u0636\u0627\u0621\u0627\u062A \u0627\u0644\u062E\u0627\u0631\u062C\u064A\u0629",
          items: {
            list: {
              term: "\u0627\u0644\u0641\u0636\u0627\u0621\u0627\u062A \u0627\u0644\u062E\u0627\u0631\u062C\u064A\u0629",
              text: "\u0641\u0636\u0627\u0621\u0627\u062A \u0645\u0624\u0633\u0633\u0627\u062A \u0623\u062E\u0631\u0649 \u0645\u0646\u062D\u062A\u0643 \u062D\u0642 \u0627\u0644\u0648\u0635\u0648\u0644 (\u0634\u0631\u064A\u0643 \u0623\u0648 \u062D\u0631\u064A\u0641 \u0623\u0648 \u0636\u064A\u0641). \u064A\u062D\u0645\u0644 \u0643\u0644 \u0633\u0637\u0631 \u0634\u0627\u0631\u0629 \xAB\u062E\u0627\u0631\u062C\u064A\xBB."
            },
            empty: {
              term: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0641\u0636\u0627\u0621\u0627\u062A \u062E\u0627\u0631\u062C\u064A\u0629",
              text: "\u0631\u0633\u0627\u0644\u0629 \u062A\u0638\u0647\u0631 \u0645\u0627 \u062F\u0627\u0645\u062A \u0623\u064A \u0645\u0624\u0633\u0633\u0629 \u0623\u062E\u0631\u0649 \u0644\u0645 \u062A\u0641\u062A\u062D \u0644\u0643 \u0641\u0636\u0627\u0621\u064B."
            },
            loadFailed: {
              term: "\u062A\u0639\u0630\u0651\u0631 \u062A\u062D\u0645\u064A\u0644 \u0641\u0636\u0627\u0621\u0627\u062A\u0643",
              text: "\u0631\u0633\u0627\u0644\u0629 \u062D\u0645\u0631\u0627\u0621 \u062A\u0638\u0647\u0631 \u0625\u0630\u0627 \u0644\u0645 \u062A\u064F\u062D\u0645\u064E\u0651\u0644 \u0627\u0644\u0642\u0627\u0626\u0645\u0629. \u062A\u062D\u0642\u0642 \u0645\u0646 \u0627\u062A\u0635\u0627\u0644\u0643 \u062B\u0645 \u0627\u0633\u062A\u062E\u062F\u0645 \u0627\u0644\u0632\u0631 \xAB\u0625\u0639\u0627\u062F\u0629 \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629\xBB."
            }
          }
        },
        row: {
          title: "\u0633\u0637\u0631 \u0641\u0636\u0627\u0621",
          items: {
            name: {
              term: "\u0627\u0633\u0645 \u0627\u0644\u0641\u0636\u0627\u0621",
              text: "\u0627\u0633\u0645 \u0627\u0644\u0641\u0636\u0627\u0621\u060C \u0645\u0639 \u0634\u0639\u0627\u0631 \u0627\u0644\u0645\u0624\u0633\u0633\u0629 \u0627\u0644\u062A\u064A \u062A\u0633\u062A\u0636\u064A\u0641\u0647. \u0627\u0644\u0633\u0637\u0631 \u0643\u0644\u0647 \u0631\u0627\u0628\u0637 \u064A\u0641\u062A\u062D \u0627\u0644\u0641\u0636\u0627\u0621."
            },
            kind: {
              term: "\u0646\u0648\u0639 \u0627\u0644\u0641\u0636\u0627\u0621",
              text: "\u0641\u0636\u0627\u0621 \u0627\u0644\u0645\u0624\u0633\u0633\u0629\u060C \u0623\u0648 \u0641\u0636\u0627\u0621 \u0645\u0634\u0631\u0648\u0639\u060C \u0623\u0648 \u0641\u0636\u0627\u0621 \u0645\u0634\u062A\u0631\u0643 (\u0645\u0631\u062A\u0628\u0637 \u0628\u0645\u0634\u0631\u0648\u0639 \u0648\u0645\u0641\u062A\u0648\u062D \u0644\u0644\u0634\u0631\u0643\u0627\u0621)\u060C \u0623\u0648 \u0645\u062C\u0645\u0648\u0639\u0629 \u0639\u0645\u0644 (\u0628\u0644\u0627 \u0645\u0634\u0631\u0648\u0639\u060C \u0644\u0641\u0631\u0642\u0643)."
            },
            host: {
              term: "\u062A\u0633\u062A\u0636\u064A\u0641\u0647 \u2026",
              text: "\u0627\u0633\u0645 \u0627\u0644\u0645\u0624\u0633\u0633\u0629 \u0627\u0644\u062A\u064A \u062A\u0633\u062A\u0636\u064A\u0641 \u0627\u0644\u0641\u0636\u0627\u0621 \u0648\u062A\u0636\u0639 \u0642\u0648\u0627\u0639\u062F\u0647."
            },
            access: {
              term: "\u0627\u0644\u0648\u0635\u0648\u0644: \u2026",
              text: "\u0644\u0644\u0641\u0636\u0627\u0621 \u0627\u0644\u062E\u0627\u0631\u062C\u064A \u0641\u0642\u0637: \u0643\u064A\u0641 \u062F\u062E\u0644\u062A (\u0645\u062B\u0644\u0627\u064B \xAB\u062F\u0639\u0648\u0629 \u0634\u062E\u0635\u064A\u0629\xBB \u0623\u0648 \xAB\u0636\u064A\u0641\xBB)\u060C \u0648\u0635\u0644\u0627\u062D\u064A\u0627\u062A\u0643 (\xAB\u0644\u0644\u0642\u0631\u0627\u0621\u0629 \u0641\u0642\u0637\xBB \u0623\u0648 \xAB\u0627\u0644\u0642\u0631\u0627\u0621\u0629 \u0648\u0627\u0644\u0643\u062A\u0627\u0628\u0629\xBB \u0623\u0648 \xAB\u0627\u0644\u0642\u0631\u0627\u0621\u0629 \u0648\u0627\u0644\u0643\u062A\u0627\u0628\u0629 \u0648\u0627\u0644\u0645\u0635\u0627\u062F\u0642\u0629\xBB)\u060C \u0648\u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0627\u0646\u062A\u0647\u0627\u0621 \u0623\u0648 \xAB\u0628\u062F\u0648\u0646 \u062A\u0627\u0631\u064A\u062E \u0627\u0646\u062A\u0647\u0627\u0621\xBB."
            },
            external: {
              term: "\u062E\u0627\u0631\u062C\u064A",
              text: "\u0634\u0627\u0631\u0629 \u062A\u062F\u0644\u0651 \u0639\u0644\u0649 \u0641\u0636\u0627\u0621 \u062A\u0633\u062A\u0636\u064A\u0641\u0647 \u0645\u0624\u0633\u0633\u0629 \u063A\u064A\u0631 \u0645\u0624\u0633\u0633\u0627\u062A\u0643."
            },
            closed: {
              term: "\u0645\u063A\u0644\u0642",
              text: "\u0634\u0627\u0631\u0629 \u0628\u0642\u0641\u0644: \u0627\u0644\u0641\u0636\u0627\u0621 \u0645\u063A\u0644\u0642\u060C \u0648\u064A\u0628\u0642\u0649 \u0645\u062D\u062A\u0648\u0627\u0647 \u0645\u062A\u0627\u062D\u0627\u064B \u0644\u0644\u0642\u0631\u0627\u0621\u0629 \u0641\u0642\u0637."
            }
          }
        },
        newDialog: {
          title: "\u0646\u0627\u0641\u0630\u0629 \xAB\u0641\u0636\u0627\u0621 \u0645\u0634\u062A\u0631\u0643 \u062C\u062F\u064A\u062F\xBB",
          items: {
            intro: {
              term: "\u0641\u0636\u0627\u0621 \u0645\u0634\u062A\u0631\u0643 \u062C\u062F\u064A\u062F",
              text: "\u0633\u062A\u0643\u0648\u0646 \u0645\u0633\u0624\u0648\u0644 \u0627\u0644\u0641\u0636\u0627\u0621. \u064A\u0645\u0643\u0646\u0643 \u0628\u0639\u062F \u0630\u0644\u0643 \u062F\u0639\u0648\u0629 \u0645\u0624\u0633\u0633\u0627\u062A \u0634\u0631\u064A\u0643\u0629 \u0625\u0644\u064A\u0647."
            },
            kind: {
              term: "\u0646\u0648\u0639 \u0627\u0644\u0641\u0636\u0627\u0621",
              text: "\xAB\u0641\u0636\u0627\u0621 \u0645\u0634\u062A\u0631\u0643 \u0644\u0645\u0634\u0631\u0648\u0639\xBB \u0645\u0631\u062A\u0628\u0637 \u0628\u0623\u062D\u062F \u0627\u0644\u0645\u0634\u0627\u0631\u064A\u0639 \u0627\u0644\u062A\u064A \u062A\u062A\u0648\u0644\u0649 \u0625\u062F\u0627\u0631\u062A\u0647\u0627. \xAB\u0645\u062C\u0645\u0648\u0639\u0629 \u0639\u0645\u0644\xBB \u0628\u0644\u0627 \u0645\u0634\u0631\u0648\u0639: \u0647\u0630\u0627 \u0627\u0644\u062E\u064A\u0627\u0631 \u0645\u062E\u0635\u0635 \u0644\u0644\u0645\u0627\u0644\u0643\u064A\u0646 \u0648\u0627\u0644\u0645\u0633\u0624\u0648\u0644\u064A\u0646."
            },
            project: {
              term: "\u0627\u0644\u0645\u0634\u0631\u0648\u0639",
              text: "\u0627\u0644\u0645\u0634\u0627\u0631\u064A\u0639 \u0627\u0644\u062A\u064A \u062A\u062F\u064A\u0631\u0647\u0627 (\u0627\u0644\u0631\u0645\u0632 \u0648\u0627\u0644\u0627\u0633\u0645). \u0627\u062E\u062A\u0631 \u0627\u0644\u0645\u0634\u0631\u0648\u0639 \u0627\u0644\u0645\u0631\u062A\u0628\u0637 \u0628\u0627\u0644\u0641\u0636\u0627\u0621. \u0625\u0630\u0627 \u0644\u0645 \u062A\u0643\u0646 \u062A\u062F\u064A\u0631 \u0623\u064A \u0645\u0634\u0631\u0648\u0639\u060C \u062A\u0634\u0631\u062D \u0644\u0643 \u0631\u0633\u0627\u0644\u0629 \u0632\u0631\u0642\u0627\u0621 \u0630\u0644\u0643."
            },
            name: {
              term: "\u0627\u0633\u0645 \u0627\u0644\u0641\u0636\u0627\u0621",
              text: "\u0625\u0644\u0632\u0627\u0645\u064A\u060C 200 \u062D\u0631\u0641 \u0639\u0644\u0649 \u0627\u0644\u0623\u0643\u062B\u0631. \u0647\u0648 \u0627\u0644\u0627\u0633\u0645 \u0627\u0644\u0630\u064A \u0633\u064A\u0631\u0627\u0647 \u0643\u0644 \u0627\u0644\u0645\u0634\u0627\u0631\u0643\u064A\u0646."
            },
            submit: {
              term: "\u0625\u0646\u0634\u0627\u0621 \u0627\u0644\u0641\u0636\u0627\u0621",
              text: "\u064A\u0646\u0634\u0626 \u0627\u0644\u0641\u0636\u0627\u0621 \u0648\u064A\u0641\u062A\u062D\u0647 \u0641\u0648\u0631\u0627\u064B. \u0627\u0644\u0632\u0631 \xAB\u0625\u0644\u063A\u0627\u0621\xBB \u064A\u063A\u0644\u0642 \u0627\u0644\u0646\u0627\u0641\u0630\u0629 \u062F\u0648\u0646 \u0625\u0646\u0634\u0627\u0621 \u0634\u064A\u0621."
            },
            planLimit: {
              term: "\u0644\u0627 \u064A\u062A\u064A\u062D \u0627\u0634\u062A\u0631\u0627\u0643\u0643 \u0627\u0633\u062A\u0636\u0627\u0641\u0629 \u0645\u0632\u064A\u062F \u0645\u0646 \u0627\u0644\u0641\u0636\u0627\u0621\u0627\u062A \u0627\u0644\u0645\u0634\u062A\u0631\u0643\u0629",
              text: "\u0631\u0633\u0627\u0644\u0629 \u062A\u0638\u0647\u0631 \u0639\u0646\u062F\u0645\u0627 \u064A\u0628\u0644\u063A \u0627\u0634\u062A\u0631\u0627\u0643\u0643 \u062D\u062F\u0651\u0647 \u0645\u0646 \u0627\u0644\u0641\u0636\u0627\u0621\u0627\u062A. \u062A\u0648\u0627\u0635\u0644 \u0645\u0639 \u0645\u0627\u0644\u0643 \u0627\u0644\u062D\u0633\u0627\u0628 \u0644\u0644\u0627\u0646\u062A\u0642\u0627\u0644 \u0625\u0644\u0649 \u0627\u0634\u062A\u0631\u0627\u0643 \u0623\u0639\u0644\u0649."
            }
          }
        }
      }
    },
    spaceInvitations: {
      title: "\u0627\u0644\u062F\u0639\u0648\u0627\u062A \u0625\u0644\u0649 \u0627\u0644\u0641\u0636\u0627\u0621\u0627\u062A",
      intro: "\u062A\u062C\u0645\u0639 \u0647\u0630\u0647 \u0627\u0644\u0635\u0641\u062D\u0629 \u0627\u0644\u062F\u0639\u0648\u0627\u062A \u0627\u0644\u062A\u064A \u062A\u0646\u062A\u0638\u0631 \u0631\u062F\u0651\u0643: \u0627\u0644\u0645\u0648\u062C\u0651\u0647\u0629 \u0625\u0644\u064A\u0643 \u0648\u0637\u0644\u0628\u0627\u062A \u0627\u0644\u0634\u0631\u0627\u0643\u0629 \u0627\u0644\u0645\u0648\u062C\u0651\u0647\u0629 \u0625\u0644\u0649 \u0645\u0624\u0633\u0633\u0629 \u062A\u062F\u064A\u0631\u0647\u0627. \u0631\u0633\u0627\u0626\u0644 \u0627\u0644\u062F\u0639\u0648\u0629 \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A\u0629 \u062A\u0642\u0648\u062F \u0625\u0644\u0649 \u0647\u0646\u0627.",
      sections: {
        header: {
          title: "\u0631\u0623\u0633 \u0627\u0644\u0635\u0641\u062D\u0629",
          items: {
            title: {
              term: "\u0627\u0644\u062F\u0639\u0648\u0627\u062A \u0625\u0644\u0649 \u0627\u0644\u0641\u0636\u0627\u0621\u0627\u062A",
              text: "\u0639\u0646\u0648\u0627\u0646 \u0627\u0644\u0635\u0641\u062D\u0629\u060C \u062A\u0644\u064A\u0647 \u062C\u0645\u0644\u0629 \u062A\u0628\u064A\u0651\u0646 \u0645\u0627 \u062A\u0631\u0627\u0647: \u0627\u0644\u062F\u0639\u0648\u0627\u062A \u0627\u0644\u062A\u064A \u062A\u0646\u062A\u0638\u0631 \u0631\u062F\u0651\u0643\u060C \u0627\u0644\u0645\u0648\u062C\u0651\u0647\u0629 \u0625\u0644\u064A\u0643 \u0623\u0648 \u0625\u0644\u0649 \u0645\u0624\u0633\u0633\u0629 \u062A\u062F\u064A\u0631\u0647\u0627."
            }
          }
        },
        card: {
          title: "\u062F\u0639\u0648\u0629",
          items: {
            sentence: {
              term: "\u062C\u0645\u0644\u0629 \u0627\u0644\u062F\u0639\u0648\u0629",
              text: "\u062A\u0642\u0648\u0644 \u0645\u0646 \u064A\u062F\u0639\u0648\u0643\u060C \u0648\u0625\u0644\u0649 \u0623\u064A \u0641\u0636\u0627\u0621\u060C \u0648\u0623\u064A \u0645\u0624\u0633\u0633\u0629 \u062A\u0633\u062A\u0636\u064A\u0641\u0647. \u064A\u0638\u0647\u0631 \u0634\u0639\u0627\u0631 \u0627\u0644\u0645\u0624\u0633\u0633\u0629 \u0627\u0644\u0645\u0633\u062A\u0636\u064A\u0641\u0629 \u0639\u0644\u0649 \u0627\u0644\u062C\u0627\u0646\u0628."
            },
            kind: {
              term: "\u0637\u0644\u0628 \u0634\u0631\u0627\u0643\u0629",
              text: "\u0634\u0627\u0631\u0629 \u0646\u0648\u0639 \u0627\u0644\u062F\u0639\u0648\u0629: \xAB\u0637\u0644\u0628 \u0634\u0631\u0627\u0643\u0629\xBB (\u0644\u0645\u0624\u0633\u0633\u062A\u0643) \u0623\u0648 \xAB\u062F\u0639\u0648\u0629 \u0634\u062E\u0635\u064A\u0629\xBB (\u0644\u0643) \u0623\u0648 \xAB\u0636\u064A\u0641\xBB (\u0648\u0635\u0648\u0644 \u0645\u062D\u062F\u0648\u062F \u0648\u0645\u0624\u0642\u062A)."
            },
            scope: {
              term: "\u0643\u0644 \u0627\u0644\u0641\u0636\u0627\u0621",
              text: "\u0645\u0627 \u064A\u0634\u0645\u0644\u0647 \u0627\u0644\u0648\u0635\u0648\u0644: \u0643\u0644 \u0627\u0644\u0641\u0636\u0627\u0621\u060C \u0623\u0648 \xAB\u0627\u0644\u0645\u062C\u0644\u062F\u0627\u062A: 2 \xB7 \u0627\u0644\u0642\u0646\u0648\u0627\u062A: 1\xBB \u0639\u0646\u062F\u0645\u0627 \u064A\u0642\u062A\u0635\u0631 \u0627\u0644\u0648\u0635\u0648\u0644 \u0639\u0644\u0649 \u0645\u062C\u0644\u062F\u0627\u062A \u0648\u0642\u0646\u0648\u0627\u062A \u0645\u062E\u062A\u0627\u0631\u0629."
            },
            rights: {
              term: "\u0627\u0644\u0635\u0644\u0627\u062D\u064A\u0627\u062A: \u2026",
              text: "\u0645\u0627 \u0633\u064A\u0645\u0643\u0646\u0643 \u0641\u0639\u0644\u0647: \xAB\u0644\u0644\u0642\u0631\u0627\u0621\u0629 \u0641\u0642\u0637\xBB \u0623\u0648 \xAB\u0627\u0644\u0642\u0631\u0627\u0621\u0629 \u0648\u0627\u0644\u0643\u062A\u0627\u0628\u0629\xBB \u0623\u0648 \xAB\u0627\u0644\u0642\u0631\u0627\u0621\u0629 \u0648\u0627\u0644\u0643\u062A\u0627\u0628\u0629 \u0648\u0627\u0644\u0645\u0635\u0627\u062F\u0642\u0629\xBB."
            },
            memberCap: {
              term: "\u062D\u062A\u0649 \u2026 \u0623\u0634\u062E\u0627\u0635",
              text: "\u0641\u064A \u0637\u0644\u0628 \u0627\u0644\u0634\u0631\u0627\u0643\u0629: \u0627\u0644\u062D\u062F \u0627\u0644\u0623\u0642\u0635\u0649 \u0644\u0639\u062F\u062F \u0627\u0644\u0623\u0634\u062E\u0627\u0635 \u0627\u0644\u0630\u064A\u0646 \u064A\u0645\u0643\u0646 \u0644\u0645\u0624\u0633\u0633\u062A\u0643 \u0625\u0636\u0627\u0641\u062A\u0647\u0645 \u0625\u0644\u0649 \u0627\u0644\u0641\u0636\u0627\u0621."
            },
            dates: {
              term: "\u0644\u0644\u0631\u062F \u0642\u0628\u0644 \u2026",
              text: "\u0622\u062E\u0631 \u0623\u062C\u0644 \u0644\u0644\u0631\u062F. \u0648\u0639\u0646\u062F\u0645\u0627 \u064A\u0638\u0647\u0631 \xAB\u062D\u062A\u0649 \u2026\xBB \u0641\u0647\u0648 \u062A\u0627\u0631\u064A\u062E \u0627\u0646\u062A\u0647\u0627\u0621 \u0627\u0644\u0648\u0635\u0648\u0644."
            }
          }
        },
        answers: {
          title: "\u0627\u0644\u0631\u062F \u0639\u0644\u0649 \u062F\u0639\u0648\u0629",
          items: {
            accept: {
              term: "\u0642\u0628\u0648\u0644",
              text: "\u0641\u064A \u062F\u0639\u0648\u0629 \u0645\u0648\u062C\u0651\u0647\u0629 \u0625\u0644\u064A\u0643: \u062A\u0646\u0636\u0645 \u0625\u0644\u0649 \u0627\u0644\u0641\u0636\u0627\u0621 \u0641\u064A\u064F\u0641\u062A\u062D. \u0641\u064A \u0637\u0644\u0628 \u0634\u0631\u0627\u0643\u0629: \u062A\u0635\u0628\u062D \u0645\u0624\u0633\u0633\u062A\u0643 \u0634\u0631\u064A\u0643\u0629\u060C \u062B\u0645 \u062A\u062E\u062A\u0627\u0631 \u0627\u0644\u0623\u0634\u062E\u0627\u0635 \u0627\u0644\u0630\u064A\u0646 \u064A\u0635\u0644\u0648\u0646 \u0625\u0644\u064A\u0647."
            },
            decline: {
              term: "\u0631\u0641\u0636",
              text: "\u064A\u0641\u062A\u062D \u0646\u0627\u0641\u0630\u0629 \u062A\u0623\u0643\u064A\u062F. \u064A\u0645\u0643\u0646 \u0644\u0644\u0645\u0624\u0633\u0633\u0629 \u0627\u0644\u0645\u0633\u062A\u0636\u064A\u0641\u0629 \u0623\u0646 \u062A\u062F\u0639\u0648\u0643 \u0645\u0646 \u062C\u062F\u064A\u062F \u0644\u0627\u062D\u0642\u0627\u064B."
            },
            declineDialog: {
              term: "\u0631\u0641\u0636 \u0627\u0644\u062F\u0639\u0648\u0629 \u0625\u0644\u0649 \u0627\u0644\u0641\u0636\u0627\u0621 \u2026 \u061F",
              text: "\u0623\u0643\u0651\u062F \u0628\u0627\u0644\u0636\u063A\u0637 \u0639\u0644\u0649 \xAB\u0631\u0641\u0636\xBB \u0623\u0648 \u0627\u0631\u062C\u0639 \u0628\u0627\u0644\u0636\u063A\u0637 \u0639\u0644\u0649 \xAB\u0625\u0644\u063A\u0627\u0621\xBB. \u062B\u0645 \u062A\u0624\u0643\u062F \u0631\u0633\u0627\u0644\u0629 \u0623\u0646 \u0627\u0644\u062F\u0639\u0648\u0629 \u0631\u064F\u0641\u0636\u062A."
            }
          }
        },
        states: {
          title: "\u0639\u0646\u062F\u0645\u0627 \u0644\u0627 \u064A\u0648\u062C\u062F \u0634\u064A\u0621 \u0644\u0639\u0631\u0636\u0647",
          items: {
            empty: {
              term: "\u0644\u0627 \u062A\u0648\u062C\u062F \u062F\u0639\u0648\u0627\u062A \u0645\u0639\u0644\u0651\u0642\u0629",
              text: "\u0631\u0633\u0627\u0644\u0629 \u062A\u0638\u0647\u0631 \u0639\u0646\u062F\u0645\u0627 \u0644\u0627 \u062A\u0646\u062A\u0638\u0631 \u0623\u064A \u062F\u0639\u0648\u0629 \u0631\u062F\u0651\u0643. \u0627\u0644\u0632\u0631 \xAB\u0639\u0631\u0636 \u0641\u0636\u0627\u0621\u0627\u062A\u064A \u0627\u0644\u0645\u0634\u062A\u0631\u0643\u0629\xBB \u064A\u0642\u0648\u062F \u0625\u0644\u0649 \u0642\u0627\u0626\u0645\u0629 \u0641\u0636\u0627\u0621\u0627\u062A\u0643."
            },
            loadFailed: {
              term: "\u062A\u0639\u0630\u0651\u0631 \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u062F\u0639\u0648\u0627\u062A",
              text: "\u0631\u0633\u0627\u0644\u0629 \u062D\u0645\u0631\u0627\u0621 \u062A\u0638\u0647\u0631 \u0625\u0630\u0627 \u0644\u0645 \u062A\u064F\u062D\u0645\u064E\u0651\u0644 \u0627\u0644\u0642\u0627\u0626\u0645\u0629. \u0627\u0633\u062A\u062E\u062F\u0645 \xAB\u0625\u0639\u0627\u062F\u0629 \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629\xBB \u0628\u0639\u062F \u0627\u0644\u062A\u062D\u0642\u0642 \u0645\u0646 \u0627\u062A\u0635\u0627\u0644\u0643."
            }
          }
        }
      }
    },
    space: {
      documents: {
        title: "\u0627\u0644\u0645\u0633\u062A\u0646\u062F\u0627\u062A",
        intro: "\u062A\u0628\u0648\u064A\u0628 \u0627\u0644\u0645\u0633\u062A\u0646\u062F\u0627\u062A \u0641\u064A \u0641\u0636\u0627\u0621 \u0645\u0634\u062A\u0631\u0643: \u0645\u062C\u0644\u062F\u0627\u062A \u0627\u0644\u0641\u0636\u0627\u0621 \u0648\u0627\u0644\u0645\u0644\u0641\u0627\u062A \u0627\u0644\u062A\u064A \u062A\u062D\u062A\u0648\u064A\u0647\u0627 \u0648\u0646\u0633\u062E\u0647\u0627. \u064A\u064F\u0633\u062A\u0639\u0645\u0644 \u0644\u0625\u064A\u062F\u0627\u0639 \u0627\u0644\u0648\u062B\u0627\u0626\u0642 \u0627\u0644\u062A\u064A \u062A\u062A\u0628\u0627\u062F\u0644\u0647\u0627 \u0627\u0644\u0645\u0624\u0633\u0633\u0629 \u0627\u0644\u0645\u0633\u062A\u0636\u064A\u0641\u0629 \u0648\u0634\u0631\u0643\u0627\u0624\u0647\u0627 \u0648\u062A\u0635\u0646\u064A\u0641\u0647\u0627 \u0648\u0627\u0644\u0627\u0637\u0644\u0627\u0639 \u0639\u0644\u064A\u0647\u0627.",
        sections: {
          frame: {
            title: "\u0625\u0637\u0627\u0631 \u0627\u0644\u0641\u0636\u0627\u0621",
            items: {
              banner: {
                term: "\u0641\u0636\u0627\u0621 \u062E\u0627\u0631\u062C\u064A \u062A\u0633\u062A\u0636\u064A\u0641\u0647 \u2026",
                text: "\u0634\u0631\u064A\u0637 \u062F\u0627\u0626\u0645 \u064A\u0638\u0647\u0631 \u0639\u0646\u062F\u0645\u0627 \u064A\u062E\u0635 \u0627\u0644\u0641\u0636\u0627\u0621 \u0645\u0624\u0633\u0633\u0629 \u0623\u062E\u0631\u0649: \u064A\u0630\u0643\u0651\u0631\u0643 \u0628\u0623\u0646 \u0645\u062D\u062A\u0648\u0627\u0647 \u064A\u062E\u0636\u0639 \u0644\u0642\u0648\u0627\u0639\u062F \u062A\u0644\u0643 \u0627\u0644\u0645\u0624\u0633\u0633\u0629."
              },
              summary: {
                term: "\u062A\u0633\u062A\u0636\u064A\u0641\u0647 \u2026",
                text: "\u0634\u0631\u064A\u0637 \u062A\u062D\u062A \u0627\u0644\u0639\u0646\u0648\u0627\u0646: \u0627\u0644\u0645\u0624\u0633\u0633\u0629 \u0627\u0644\u062A\u064A \u062A\u0633\u062A\u0636\u064A\u0641 \u0627\u0644\u0641\u0636\u0627\u0621 \u0648\u0646\u0648\u0639\u0647 (\u0645\u062B\u0644\u0627\u064B \xAB\u0641\u0636\u0627\u0621 \u0645\u0634\u062A\u0631\u0643\xBB \u0623\u0648 \xAB\u0645\u062C\u0645\u0648\u0639\u0629 \u0639\u0645\u0644\xBB) \u0648\u0634\u0627\u0631\u0629 \xAB\u0645\u063A\u0644\u0642\xBB \u0639\u0646\u062F\u0645\u0627 \u064A\u0643\u0648\u0646 \u0627\u0644\u0641\u0636\u0627\u0621 \u0645\u063A\u0644\u0642\u0627\u064B\u060C \u0648\u0641\u064A \u0627\u0644\u0641\u0636\u0627\u0621 \u0627\u0644\u062E\u0627\u0631\u062C\u064A \u0648\u0635\u0648\u0644\u0643: \u0643\u064A\u0641 \u062F\u062E\u0644\u062A \u0648\u0635\u0644\u0627\u062D\u064A\u0627\u062A\u0643 \u0648\u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0627\u0646\u062A\u0647\u0627\u0621."
              },
              guestNotice: {
                term: "\u064A\u0646\u062A\u0647\u064A \u0648\u0635\u0648\u0644\u0643 \u0643\u0636\u064A\u0641 \u0641\u064A \u2026",
                text: "\u0634\u0631\u064A\u0637 \u0645\u062E\u0635\u0635 \u0644\u0644\u0636\u064A\u0648\u0641: \u064A\u0639\u0637\u064A \u062A\u0627\u0631\u064A\u062E \u0627\u0646\u062A\u0647\u0627\u0621 \u0648\u0635\u0648\u0644\u0643. \u064A\u062A\u062D\u0648\u0644 \u0625\u0644\u0649 \u062A\u062D\u0630\u064A\u0631 \u062E\u0644\u0627\u0644 \u0622\u062E\u0631 14 \u064A\u0648\u0645\u0627\u064B: \u0627\u0637\u0644\u0628 \u0639\u0646\u062F\u0626\u0630 \u0645\u0646 \u0627\u0644\u0634\u062E\u0635 \u0627\u0644\u0630\u064A \u062F\u0639\u0627\u0643 \u062A\u0645\u062F\u064A\u062F\u0647."
              },
              tabs: {
                term: "\u0639\u0644\u0627\u0645\u0627\u062A \u0627\u0644\u062A\u0628\u0648\u064A\u0628",
                text: "\u0634\u0631\u064A\u0637 \u062A\u0628\u0648\u064A\u0628\u0627\u062A \u0627\u0644\u0641\u0636\u0627\u0621. \u0644\u0627 \u062A\u0638\u0647\u0631 \u0625\u0644\u0627 \u0627\u0644\u062A\u0628\u0648\u064A\u0628\u0627\u062A \u0627\u0644\u062A\u064A \u064A\u062A\u064A\u062D \u0644\u0643 \u0648\u0635\u0648\u0644\u0643 \u0641\u062A\u062D\u0647\u0627. \u0645\u0633\u0627\u0631 \u0627\u0644\u062A\u0646\u0642\u0644 \u0641\u064A \u0627\u0644\u0623\u0639\u0644\u0649 (\xAB\u0627\u0644\u0641\u0636\u0627\u0621\u0627\u062A \u0627\u0644\u0645\u0634\u062A\u0631\u0643\u0629\xBB) \u064A\u0639\u064A\u062F\u0643 \u0625\u0644\u0649 \u0642\u0627\u0626\u0645\u0629 \u0641\u0636\u0627\u0621\u0627\u062A\u0643."
              },
              unavailable: {
                term: "\u0627\u0644\u0641\u0636\u0627\u0621 \u063A\u064A\u0631 \u0645\u0648\u062C\u0648\u062F",
                text: "\u062A\u0638\u0647\u0631 \u0625\u0630\u0627 \u0644\u0645 \u064A\u0643\u0646 \u0627\u0644\u0641\u0636\u0627\u0621 \u0645\u0648\u062C\u0648\u062F\u0627\u064B \u0623\u0648 \u0644\u0645 \u064A\u0639\u062F \u0648\u0635\u0648\u0644\u0643 \u0625\u0644\u064A\u0647 \u0645\u0645\u0643\u0646\u0627\u064B: \u0627\u0637\u0644\u0628 \u062F\u0639\u0648\u0629 \u062C\u062F\u064A\u062F\u0629. \xAB\u062A\u0639\u0630\u0651\u0631 \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0641\u0636\u0627\u0621\xBB \u062A\u062F\u0644\u0651 \u0639\u0644\u0649 \u0645\u0634\u0643\u0644\u0629 \u0627\u062A\u0635\u0627\u0644 (\u0632\u0631 \xAB\u0625\u0639\u0627\u062F\u0629 \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629\xBB)\u060C \u0648\xAB\u0644\u0627 \u0634\u064A\u0621 \u0644\u0639\u0631\u0636\u0647 \u062D\u0627\u0644\u064A\u0627\u064B\xBB \u0639\u0644\u0649 \u0648\u0635\u0648\u0644 \u0644\u0627 \u064A\u062A\u064A\u062D \u0628\u0639\u062F\u064F \u0623\u064A \u0645\u062D\u062A\u0648\u0649."
              }
            }
          },
          folders: {
            title: "\u0627\u0644\u0645\u062C\u0644\u062F\u0627\u062A",
            items: {
              tree: {
                term: "\u0645\u062C\u0644\u062F\u0627\u062A \u0627\u0644\u0645\u0634\u0631\u0648\u0639",
                text: "\u0634\u062C\u0631\u0629 \u0627\u0644\u0645\u062C\u0644\u062F\u0627\u062A \u0639\u0644\u0649 \u0627\u0644\u062C\u0627\u0646\u0628. \xAB\u0643\u0644 \u0627\u0644\u0645\u062C\u0644\u062F\u0627\u062A\xBB \u0647\u0648 \u0627\u0644\u062C\u0630\u0631. \u0627\u0646\u0642\u0631 \u0639\u0644\u0649 \u0645\u062C\u0644\u062F \u0644\u0641\u062A\u062D\u0647\u060C \u0648\u062A\u0646\u0641\u062A\u062D \u0627\u0644\u0645\u062C\u0644\u062F\u0627\u062A \u0627\u0644\u0641\u0631\u0639\u064A\u0629 \u062A\u062F\u0631\u064A\u062C\u064A\u0627\u064B."
              },
              breadcrumb: {
                term: "\u0645\u0633\u0627\u0631 \u0627\u0644\u0645\u062C\u0644\u062F",
                text: "\u0627\u0644\u0645\u062C\u0644\u062F\u0627\u062A \u0627\u0644\u062A\u064A \u062A\u0642\u0648\u062F \u0625\u0644\u0649 \u0627\u0644\u0645\u062C\u0644\u062F \u0627\u0644\u0645\u0641\u062A\u0648\u062D\u061B \u0627\u0646\u0642\u0631 \u0639\u0644\u0649 \u0623\u062D\u062F\u0647\u0627 \u0644\u0644\u0639\u0648\u062F\u0629 \u0625\u0644\u064A\u0647. \u062A\u062D\u0644\u0651 \xAB\u2026\xBB \u0645\u062D\u0644 \u0645\u062C\u0644\u062F \u0644\u0627 \u064A\u0645\u0643\u0646\u0643 \u0627\u0644\u0648\u0635\u0648\u0644 \u0625\u0644\u064A\u0647."
              },
              customRights: {
                term: "\u0635\u0644\u0627\u062D\u064A\u0627\u062A \u0645\u062E\u0635\u0651\u0635\u0629",
                text: "\u0634\u0627\u0631\u0629 \u0628\u0642\u0641\u0644: \u0644\u0647\u0630\u0627 \u0627\u0644\u0645\u062C\u0644\u062F \u0642\u0648\u0627\u0639\u062F \u0648\u0635\u0648\u0644 \u062E\u0627\u0635\u0629 \u0628\u0647\u060C \u062A\u062E\u062A\u0644\u0641 \u0639\u0646 \u0642\u0648\u0627\u0639\u062F \u0627\u0644\u0641\u0636\u0627\u0621."
              },
              newFolder: {
                term: "\u0645\u062C\u0644\u062F \u062C\u062F\u064A\u062F",
                text: "\u064A\u0646\u0634\u0626 \u0645\u062C\u0644\u062F\u0627\u064B \u062F\u0627\u062E\u0644 \u0627\u0644\u0645\u062C\u0644\u062F \u0627\u0644\u0645\u0641\u062A\u0648\u062D (\u0623\u0648 \u0641\u064A \u0627\u0644\u062C\u0630\u0631). \u0644\u0627 \u064A\u0638\u0647\u0631 \u0625\u0644\u0627 \u0625\u0630\u0627 \u0643\u0627\u0646\u062A \u0644\u0643 \u0635\u0644\u0627\u062D\u064A\u0629 \u0627\u0644\u0643\u062A\u0627\u0628\u0629 \u0647\u0646\u0627\u0643."
              },
              menu: {
                term: "\u0625\u062C\u0631\u0627\u0621\u0627\u062A \u0623\u062E\u0631\u0649",
                text: "\u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u0646\u0642\u0627\u0637 \u0627\u0644\u062B\u0644\u0627\u062B \u0644\u0645\u0633\u0624\u0648\u0644\u064A \u0627\u0644\u0645\u062C\u0644\u062F: \xAB\u0625\u0639\u0627\u062F\u0629 \u0627\u0644\u062A\u0633\u0645\u064A\u0629\u2026\xBB \u0648\xAB\u0646\u0642\u0644\u2026\xBB \u0648\xAB\u0627\u0644\u0635\u0644\u0627\u062D\u064A\u0627\u062A\u2026\xBB (\u063A\u064A\u0631 \u0645\u062A\u0627\u062D\u0629 \u0641\u064A \u0641\u0636\u0627\u0621 \u0645\u0624\u0633\u0633\u0629 \u0623\u062E\u0631\u0649) \u0648\xAB\u062D\u0630\u0641\xBB. \u064A\u0631\u0633\u0644 \u0627\u0644\u062D\u0630\u0641 \u0627\u0644\u0645\u062C\u0644\u062F \u0625\u0644\u0649 \u0633\u0644\u0629 \u0627\u0644\u0645\u062D\u0630\u0648\u0641\u0627\u062A."
              },
              empty: {
                term: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0645\u062C\u0644\u062F\u0627\u062A \u0628\u0639\u062F",
                text: "\u0631\u0633\u0627\u0644\u0629 \u062A\u0638\u0647\u0631 \u0639\u0646\u062F\u0645\u0627 \u0644\u0627 \u064A\u0643\u0648\u0646 \u0641\u064A \u0627\u0644\u0641\u0636\u0627\u0621 \u0628\u0639\u062F \u0623\u064A \u0645\u062C\u0644\u062F \u0645\u0631\u0626\u064A \u0644\u0643. \u062A\u0642\u062A\u0631\u062D \xAB\u0645\u062C\u0644\u062F \u062C\u062F\u064A\u062F\xBB \u0625\u0630\u0627 \u0643\u0627\u0646 \u0628\u0625\u0645\u0643\u0627\u0646\u0643 \u0625\u0646\u0634\u0627\u0621 \u0645\u062C\u0644\u062F\u060C \u0648\u0625\u0644\u0627 \u0641\u0627\u0637\u0644\u0628 \u0645\u0646 \u0623\u062D\u062F \u0627\u0644\u0645\u0633\u0624\u0648\u0644\u064A\u0646. \u0648\u0641\u064A \u0645\u062C\u0644\u062F \u0641\u0627\u0631\u063A \u062A\u0624\u0643\u062F \xAB\u0644\u0627 \u062A\u0648\u062C\u062F \u0645\u062C\u0644\u062F\u0627\u062A \u0641\u0631\u0639\u064A\u0629\xBB \u0630\u0644\u0643."
              }
            }
          },
          upload: {
            title: "\u0625\u0636\u0627\u0641\u0629 \u0627\u0644\u0645\u0644\u0641\u0627\u062A",
            items: {
              zone: {
                term: "\u0627\u0633\u062D\u0628 \u0627\u0644\u0645\u0644\u0641\u0627\u062A \u0623\u0648 \u0627\u0644\u0645\u062C\u0644\u062F\u0627\u062A \u0648\u0623\u0641\u0644\u062A\u0647\u0627 \u0647\u0646\u0627",
                text: "\u0645\u0646\u0637\u0642\u0629 \u0627\u0644\u0625\u0636\u0627\u0641\u0629\u060C \u0638\u0627\u0647\u0631\u0629 \u0641\u064A \u0645\u062C\u0644\u062F \u064A\u0645\u0643\u0646\u0643 \u0627\u0644\u0643\u062A\u0627\u0628\u0629 \u0641\u064A\u0647. \u0623\u0641\u0644\u062A \u0641\u064A\u0647\u0627 \u0645\u0644\u0641\u0627\u062A \u0623\u0648 \u0645\u062C\u0644\u062F\u0627\u064B \u0643\u0627\u0645\u0644\u0627\u064B: \u064A\u064F\u0636\u0627\u0641 \u0643\u0644 \u0634\u064A\u0621 \u0625\u0644\u0649 \u0627\u0644\u0645\u062C\u0644\u062F \u0627\u0644\u0645\u0641\u062A\u0648\u062D. \u0627\u0644\u062D\u062F \u0627\u0644\u0623\u0642\u0635\u0649 \u0644\u062D\u062C\u0645 \u0627\u0644\u0645\u0644\u0641 \u0645\u0643\u062A\u0648\u0628 \u062A\u062D\u062A \u0627\u0644\u0639\u0646\u0648\u0627\u0646."
              },
              buttons: {
                term: "\u0625\u0636\u0627\u0641\u0629 \u0645\u0644\u0641\u0627\u062A",
                text: "\u064A\u0641\u062A\u062D \u0646\u0627\u0641\u0630\u0629 \u0627\u062E\u062A\u064A\u0627\u0631 \u0627\u0644\u0645\u0644\u0641\u0627\u062A \u0645\u0646 \u062D\u0627\u0633\u0648\u0628\u0643. \xAB\u0625\u0636\u0627\u0641\u0629 \u0645\u062C\u0644\u062F\xBB \u064A\u0641\u0639\u0644 \u0627\u0644\u0634\u064A\u0621 \u0646\u0641\u0633\u0647 \u0644\u0645\u062C\u0644\u062F \u0643\u0627\u0645\u0644. \u064A\u062A\u0639\u0637\u0644 \u0627\u0644\u0632\u0631\u0627\u0646 \u0625\u0630\u0627 \u0643\u0627\u0646 \u062D\u0633\u0627\u0628 \u0627\u0644\u0645\u0624\u0633\u0633\u0629 \u0627\u0644\u0645\u0633\u062A\u0636\u064A\u0641\u0629 \u0644\u0644\u0642\u0631\u0627\u0621\u0629 \u0641\u0642\u0637."
              },
              infoDialog: {
                term: "\u0645\u0639\u0644\u0648\u0645\u0627\u062A \u0627\u0644\u0648\u062B\u064A\u0642\u0629",
                text: "\u0646\u0627\u0641\u0630\u0629 \u062A\u064F\u0641\u062A\u062D \u0642\u0628\u0644 \u0627\u0644\u0625\u0631\u0633\u0627\u0644: \u0627\u0644\u062A\u062E\u0635\u0635 \u0648\u0627\u0644\u0645\u0631\u062D\u0644\u0629 \u0648\u0646\u0648\u0639 \u0627\u0644\u0648\u062B\u064A\u0642\u0629 \u0648\u0627\u0644\u0645\u0646\u0637\u0642\u0629 \u0648\u0627\u0644\u0645\u0642\u064A\u0627\u0633 \u0648\u0639\u0646\u0648\u0627\u0646 \u0643\u0644 \u0648\u062B\u064A\u0642\u0629. \u062A\u064F\u0633\u062A\u062E\u062F\u0645 \u0647\u0630\u0647 \u0627\u0644\u0645\u0639\u0644\u0648\u0645\u0627\u062A \u0644\u062A\u0635\u0646\u064A\u0641 \u0627\u0644\u0648\u062B\u064A\u0642\u0629 \u0648\u062A\u0643\u0648\u064A\u0646 \u0631\u0645\u0632\u0647\u0627 (\xAB\u0627\u0644\u0631\u0645\u0632 \u0627\u0644\u0645\u062A\u0648\u0642\u0639\xBB)."
              },
              skip: {
                term: "\u0625\u0636\u0627\u0641\u0629 \u0628\u062F\u0648\u0646 \u0645\u0639\u0644\u0648\u0645\u0627\u062A",
                text: "\u064A\u0631\u0633\u0644 \u0627\u0644\u0645\u0644\u0641\u0627\u062A \u062F\u0648\u0646 \u0645\u0644\u0621 \u0627\u0644\u0646\u0627\u0641\u0630\u0629. \u064A\u0645\u0643\u0646\u0643 \u0627\u0633\u062A\u0643\u0645\u0627\u0644 \u0627\u0644\u0645\u0639\u0644\u0648\u0645\u0627\u062A \u0644\u0627\u062D\u0642\u0627\u064B."
              },
              statuses: {
                term: "\u062C\u0627\u0631\u064D \u0627\u0644\u0625\u0631\u0633\u0627\u0644",
                text: "\u0644\u0643\u0644 \u0645\u0644\u0641 \u0633\u0637\u0631\u0647 \u0645\u0639 \u062A\u0642\u062F\u0651\u0645\u0647\u060C \u062B\u0645 \u0646\u062A\u064A\u062C\u062A\u0647: \xAB\u062C\u0627\u0631\u064D \u0627\u0644\u0641\u062D\u0635 \u0628\u062D\u062B\u064B\u0627 \u0639\u0646 \u0627\u0644\u0641\u064A\u0631\u0648\u0633\u0627\u062A\xBB \u0623\u0648 \xAB\u0623\u064F\u0636\u064A\u0641 \u0625\u0644\u0649 \u0627\u0644\u0645\u062C\u0644\u062F\xBB \u0623\u0648 \xAB\u0645\u0631\u0641\u0648\u0636\xBB (\u0645\u0639 \u0627\u0644\u0633\u0628\u0628) \u0623\u0648 \xAB\u0641\u0634\u0644 \u0627\u0644\u0625\u0631\u0633\u0627\u0644\xBB."
              },
              rowButtons: {
                term: "\u0625\u0644\u063A\u0627\u0621",
                text: "\u0639\u0644\u0649 \u0633\u0637\u0631 \u0627\u0644\u0625\u0631\u0633\u0627\u0644: \xAB\u0625\u0644\u063A\u0627\u0621\xBB \u064A\u0648\u0642\u0641 \u0627\u0644\u0625\u0631\u0633\u0627\u0644\u060C \u0648\xAB\u0625\u0639\u0627\u062F\u0629 \u0645\u062D\u0627\u0648\u0644\u0629\xBB \u062A\u0639\u064A\u062F\u0647 \u0628\u0639\u062F \u0627\u0644\u0641\u0634\u0644\u060C \u0648\xAB\u0625\u0632\u0627\u0644\u0629\xBB \u062A\u0645\u062D\u0648 \u0627\u0644\u0633\u0637\u0631 \u0645\u0646 \u0627\u0644\u0642\u0627\u0626\u0645\u0629."
              }
            }
          },
          list: {
            title: "\u0648\u062B\u0627\u0626\u0642 \u0627\u0644\u0645\u062C\u0644\u062F",
            items: {
              search: {
                term: "\u0627\u0644\u0628\u062D\u062B \u0641\u064A \u0627\u0644\u0648\u062B\u0627\u0626\u0642",
                text: "\u062D\u0642\u0644 \u0627\u0644\u0628\u062D\u062B (\xAB\u0627\u0644\u0631\u0645\u0632 \u0623\u0648 \u0627\u0644\u0639\u0646\u0648\u0627\u0646\xBB). \u062A\u062A\u062D\u062F\u062B \u0627\u0644\u0642\u0627\u0626\u0645\u0629 \u0639\u0646\u062F\u0645\u0627 \u062A\u062A\u0648\u0642\u0641 \u0639\u0646 \u0627\u0644\u0643\u062A\u0627\u0628\u0629."
              },
              filters: {
                term: "\u0627\u0644\u062A\u062E\u0635\u0635",
                text: "\u062B\u0644\u0627\u062B \u0634\u0627\u0631\u0627\u062A \u062A\u0635\u0641\u064A\u0629: \u0627\u0644\u062A\u062E\u0635\u0635 \u0648\u0627\u0644\u0645\u0631\u062D\u0644\u0629 \u0648\u0646\u0648\u0639 \u0627\u0644\u0648\u062B\u064A\u0642\u0629. \u0627\u062E\u062A\u0631 \u0642\u064A\u0645\u0629 \u0645\u0646 \u0627\u0644\u0642\u0627\u0626\u0645\u0629\u061B \xAB\u0627\u0644\u0643\u0644\xBB \u064A\u0632\u064A\u0644 \u0627\u0644\u062A\u0635\u0641\u064A\u0629\u060C \u0648\xAB\u0645\u0633\u062D \u0639\u0648\u0627\u0645\u0644 \u0627\u0644\u062A\u0635\u0641\u064A\u0629\xBB \u064A\u0632\u064A\u0644\u0647\u0627 \u062C\u0645\u064A\u0639\u0627\u064B."
              },
              columns: {
                term: "\u0627\u0644\u0631\u0645\u0632\u060C \u0627\u0644\u0639\u0646\u0648\u0627\u0646\u060C \u0627\u0644\u0645\u0624\u0634\u0631\u2026",
                text: "\u0623\u0639\u0645\u062F\u0629 \u0627\u0644\u062C\u062F\u0648\u0644: \u0627\u0644\u0631\u0645\u0632 \u0648\u0627\u0644\u0639\u0646\u0648\u0627\u0646 \u0648\u0627\u0644\u0645\u0624\u0634\u0631 (\u062D\u0631\u0641 \u0646\u0633\u062E\u0629 \u0627\u0644\u0648\u062B\u064A\u0642\u0629: \u2066A\u2069 \u0648\u2066B\u2069 \u0648\u2066C\u2069\u2026) \u0648\u0627\u0644\u062A\u062E\u0635\u0635 \u0648\u0627\u0644\u0645\u0631\u062D\u0644\u0629 \u0648\u0627\u0644\u062D\u0627\u0644\u0629 \u0648\u0627\u0644\u062A\u0623\u0634\u064A\u0631 \u0648\u062A\u0627\u0631\u064A\u062E \u0627\u0644\u062A\u0639\u062F\u064A\u0644 \u0648\u0627\u0644\u0645\u0624\u0633\u0633\u0629 \u0627\u0644\u0645\u064F\u0646\u0634\u0650\u0626\u0629 (\xAB\u0634\u0631\u064A\u0643\xBB \u0625\u0630\u0627 \u0644\u0645 \u062A\u0643\u0646 \u0645\u0624\u0633\u0633\u062A\u0643). \u064A\u0645\u0643\u0646 \u062A\u0631\u062A\u064A\u0628 \u0627\u0644\u0631\u0645\u0632 \u0648\u0627\u0644\u0639\u0646\u0648\u0627\u0646 \u0648\u062A\u0627\u0631\u064A\u062E \u0627\u0644\u062A\u0639\u062F\u064A\u0644 \u0628\u0627\u0644\u0646\u0642\u0631 \u0639\u0644\u0649 \u0631\u0623\u0633 \u0627\u0644\u0639\u0645\u0648\u062F."
              },
              selection: {
                term: "\u0625\u0644\u063A\u0627\u0621 \u0627\u0644\u062A\u062D\u062F\u064A\u062F",
                text: "\u062D\u062F\u0651\u062F \u0633\u0637\u0648\u0631\u0627\u064B \u0644\u064A\u0638\u0647\u0631 \u0634\u0631\u064A\u0637 \u0627\u0644\u062A\u062D\u062F\u064A\u062F: \u0639\u062F\u062F \u0627\u0644\u0648\u062B\u0627\u0626\u0642 \u0627\u0644\u0645\u062E\u062A\u0627\u0631\u0629 \u0648\xAB\u0646\u0642\u0644 \u0625\u0644\u0649\u2026\xBB \u0648\xAB\u062D\u0630\u0641\xBB (\u0641\u0642\u0637 \u0625\u0630\u0627 \u0643\u0627\u0646 \u0645\u0633\u0645\u0648\u062D\u0627\u064B \u0644\u0643 \u0628\u0630\u0644\u0643 \u0639\u0644\u0649 \u0643\u0644 \u0648\u062B\u064A\u0642\u0629) \u0648\xAB\u0625\u0644\u063A\u0627\u0621 \u0627\u0644\u062A\u062D\u062F\u064A\u062F\xBB."
              },
              more: {
                term: "\u0639\u0631\u0636 \u0627\u0644\u0645\u0632\u064A\u062F \u0645\u0646 \u0627\u0644\u0648\u062B\u0627\u0626\u0642",
                text: "\u062A\u064F\u0639\u0631\u0636 \u0627\u0644\u0642\u0627\u0626\u0645\u0629 \u0635\u0641\u062D\u0629 \u0635\u0641\u062D\u0629. \u064A\u062D\u0645\u0651\u0644 \u0647\u0630\u0627 \u0627\u0644\u0632\u0631 \u0627\u0644\u0635\u0641\u062D\u0629 \u0627\u0644\u062A\u0627\u0644\u064A\u0629\u060C \u0648\u0639\u062F\u062F \u0627\u0644\u0648\u062B\u0627\u0626\u0642 \u0627\u0644\u0645\u0639\u0631\u0648\u0636\u0629 \u0645\u0643\u062A\u0648\u0628 \u0628\u062C\u0627\u0646\u0628\u0647."
              },
              empty: {
                term: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0648\u062B\u0627\u0626\u0642 \u0628\u0639\u062F",
                text: "\u0631\u0633\u0627\u0644\u0629 \u0627\u0644\u0645\u062C\u0644\u062F \u0627\u0644\u0641\u0627\u0631\u063A. \u062A\u062F\u0639\u0648\u0643 \u0625\u0644\u0649 \u0625\u0641\u0644\u0627\u062A \u0645\u0644\u0641\u0627\u062A\u060C \u0623\u0648 \u062A\u0642\u0648\u0644 \u0625\u0646 \u0627\u0644\u0648\u062B\u0627\u0626\u0642 \u0633\u062A\u0638\u0647\u0631 \u0647\u0646\u0627 \u0625\u0630\u0627 \u0643\u0627\u0646 \u0628\u0625\u0645\u0643\u0627\u0646\u0643 \u0627\u0644\u0642\u0631\u0627\u0621\u0629 \u0641\u0642\u0637. \u062A\u0638\u0647\u0631 \xAB\u0644\u0627 \u062A\u0648\u062C\u062F \u0648\u062B\u064A\u0642\u0629 \u0645\u0637\u0627\u0628\u0642\u0629\xBB \u0639\u0646\u062F\u0645\u0627 \u0644\u0627 \u062A\u062C\u062F \u0627\u0644\u062A\u0635\u0641\u064A\u0629 \u0634\u064A\u0626\u0627\u064B."
              }
            }
          },
          statuses: {
            title: "\u062D\u0627\u0644\u0627\u062A \u0627\u0644\u0648\u062B\u064A\u0642\u0629",
            items: {
              uploading: {
                term: "\u062C\u0627\u0631\u064D \u0627\u0644\u0625\u0631\u0633\u0627\u0644",
                text: "\u0627\u0644\u0645\u0644\u0641 \u0641\u064A \u0637\u0631\u064A\u0642\u0647 \u0625\u0644\u0649 \u0627\u0644\u062E\u0627\u062F\u0645."
              },
              scanning: {
                term: "\u0641\u062D\u0635 \u0645\u0636\u0627\u062F \u0627\u0644\u0641\u064A\u0631\u0648\u0633\u0627\u062A",
                text: "\u064A\u0641\u062D\u0635 \u0645\u0636\u0627\u062F \u0627\u0644\u0641\u064A\u0631\u0648\u0633\u0627\u062A \u0627\u0644\u0645\u0644\u0641. \u064A\u0635\u0628\u062D \u0645\u062A\u0627\u062D\u0627\u064B \u0644\u0644\u0627\u0637\u0644\u0627\u0639 \u0628\u0639\u062F \u0627\u0646\u062A\u0647\u0627\u0621 \u0627\u0644\u0641\u062D\u0635."
              },
              available: {
                term: "\u0645\u062A\u0627\u062D",
                text: "\u062A\u0645 \u0641\u062D\u0635 \u0627\u0644\u0645\u0644\u0641: \u064A\u0645\u0643\u0646\u0643 \u0641\u062A\u062D\u0647."
              },
              rejected: {
                term: "\u0645\u0631\u0641\u0648\u0636",
                text: "\u0631\u064F\u0641\u0636 \u0627\u0644\u0645\u0644\u0641 (\u0641\u064A\u0631\u0648\u0633 \u0623\u0648 \u0646\u0648\u0639 \u063A\u064A\u0631 \u0645\u0642\u0628\u0648\u0644 \u0623\u0648 \u062D\u062C\u0645\u2026). \u0627\u0644\u0633\u0628\u0628 \u0645\u0643\u062A\u0648\u0628 \u0641\u064A \u0633\u062C\u0644 \u0627\u0644\u0646\u0633\u062E."
              },
              inApproval: {
                term: "\u0642\u064A\u062F \u0627\u0644\u062A\u0623\u0634\u064A\u0631",
                text: "\u0641\u064A \u0639\u0645\u0648\u062F \xAB\u0627\u0644\u062A\u0623\u0634\u064A\u0631\xBB: \u064A\u062C\u0631\u064A \u0645\u0633\u0627\u0631 \u062A\u0623\u0634\u064A\u0631. \u0648\u0645\u0627 \u062F\u0627\u0645 \u0644\u0645 \u064A\u0646\u062A\u0647\u0650\u060C \u0644\u0627 \u064A\u0645\u0643\u0646 \u0625\u0636\u0627\u0641\u0629 \u0646\u0633\u062E\u0629 \u062C\u062F\u064A\u062F\u0629 \u0625\u0644\u0649 \u0627\u0644\u0648\u062B\u064A\u0642\u0629."
              }
            }
          },
          panel: {
            title: "\u0644\u0648\u062D\u0629 \u0627\u0644\u0648\u062B\u064A\u0642\u0629",
            items: {
              open: {
                term: "\u0641\u062A\u062D",
                text: "\u0627\u0646\u0642\u0631 \u0639\u0644\u0649 \u0633\u0637\u0631 \u0644\u0641\u062A\u062D \u0627\u0644\u0644\u0648\u062D\u0629 \u0639\u0644\u0649 \u0627\u0644\u062C\u0627\u0646\u0628 (\u064A\u063A\u0644\u0642\u0647\u0627 \u0645\u0641\u062A\u0627\u062D \u2066Esc\u2069). \xAB\u0641\u062A\u062D\xBB \u064A\u0639\u0631\u0636 \u0627\u0644\u0648\u062B\u064A\u0642\u0629 \u0641\u064A \u0639\u0627\u0631\u0636 \u0627\u0644\u0645\u0633\u062A\u0646\u062F\u0627\u062A\u061B \u0647\u0630\u0627 \u0627\u0644\u0632\u0631 \u063A\u064A\u0631 \u0645\u0648\u062C\u0648\u062F \u0641\u064A \u0641\u0636\u0627\u0621 \u0645\u0624\u0633\u0633\u0629 \u0623\u062E\u0631\u0649."
              },
              details: {
                term: "\u0627\u0644\u062A\u0641\u0627\u0635\u064A\u0644",
                text: "\u0627\u0644\u0631\u0645\u0632 (\u0644\u0644\u0642\u0631\u0627\u0621\u0629 \u0641\u0642\u0637) \u0648\u0627\u0644\u0639\u0646\u0648\u0627\u0646 \u0648\u0627\u0644\u0645\u0624\u0634\u0631 \u0648\u0627\u0644\u062A\u062E\u0635\u0635 \u0648\u0627\u0644\u0645\u0631\u062D\u0644\u0629 \u0648\u0646\u0648\u0639 \u0627\u0644\u0648\u062B\u064A\u0642\u0629 \u0648\u0627\u0644\u0645\u0646\u0637\u0642\u0629 \u0648\u0627\u0644\u0645\u0642\u064A\u0627\u0633 \u0648\u0627\u0644\u062D\u0627\u0644\u0629 \u0648\u0627\u0644\u0645\u0624\u0633\u0633\u0629 \u0627\u0644\u0645\u064F\u0646\u0634\u0650\u0626\u0629 \u0648\u062A\u0627\u0631\u064A\u062E \u0627\u0644\u062A\u0639\u062F\u064A\u0644 \u0648\u0627\u0644\u0645\u062E\u0631\u062C\u0627\u062A \u0627\u0644\u0645\u0631\u062A\u0628\u0637\u0629. \u0631\u0633\u0627\u0644\u0629 \u0632\u0631\u0642\u0627\u0621 \u062A\u0628\u064A\u0651\u0646 \u0645\u0627 \u064A\u0646\u0642\u0635 \u0644\u0625\u0633\u0646\u0627\u062F \u0627\u0644\u0631\u0645\u0632."
              },
              edit: {
                term: "\u062A\u0639\u062F\u064A\u0644",
                text: "\u064A\u0641\u062A\u062D \u0646\u0645\u0648\u0630\u062C \u062A\u0639\u062F\u064A\u0644 \u0627\u0644\u0639\u0646\u0648\u0627\u0646 \u0648\u0627\u0644\u0645\u0639\u0644\u0648\u0645\u0627\u062A. \u0644\u0627 \u064A\u0638\u0647\u0631 \u0625\u0644\u0627 \u0625\u0630\u0627 \u0643\u0627\u0646\u062A \u0644\u0643 \u0635\u0644\u0627\u062D\u064A\u0629 \u062A\u0639\u062F\u064A\u0644 \u0647\u0630\u0647 \u0627\u0644\u0648\u062B\u064A\u0642\u0629."
              },
              approval: {
                term: "\u0627\u0644\u062A\u0623\u0634\u064A\u0631",
                text: "\u0645\u0633\u0627\u0631\u0627\u062A \u062A\u0623\u0634\u064A\u0631 \u0627\u0644\u0648\u062B\u064A\u0642\u0629 \u0645\u0639 \u062E\u0637\u0648\u0627\u062A\u0647\u0627. \xAB\u0637\u0644\u0628 \u062A\u0623\u0634\u064A\u0631\u0629\xBB \u064A\u0637\u0644\u0642 \u0645\u0633\u0627\u0631\u0627\u064B: \u0648\u0647\u0648 \u063A\u064A\u0631 \u0645\u0648\u062C\u0648\u062F \u0641\u064A \u0641\u0636\u0627\u0621 \u0645\u0624\u0633\u0633\u0629 \u0623\u062E\u0631\u0649. \u2066VSO\u2069 \u062A\u0639\u0646\u064A \u0645\u0624\u0634\u064E\u0651\u0631 \u0628\u062F\u0648\u0646 \u0645\u0644\u0627\u062D\u0638\u0627\u062A\u060C \u0648\u2066VAO\u2069 \u0645\u0624\u0634\u064E\u0651\u0631 \u0645\u0639 \u0645\u0644\u0627\u062D\u0638\u0627\u062A\u060C \u0648\u2066REF\u2069 \u0645\u0631\u0641\u0648\u0636."
              },
              versions: {
                term: "\u0627\u0644\u0646\u0633\u062E",
                text: "\u0627\u0644\u0633\u062C\u0644 \u0645\u0646 \u0627\u0644\u0623\u062D\u062F\u062B \u0625\u0644\u0649 \u0627\u0644\u0623\u0642\u062F\u0645: \u0627\u0644\u0645\u0624\u0634\u0631 \u0648\u0627\u0644\u0633\u0628\u0628 \u0648\u0627\u0644\u0645\u0624\u0644\u0641 \u0648\u0627\u0644\u0645\u0624\u0633\u0633\u0629 \u0648\u0627\u0644\u062A\u0627\u0631\u064A\u062E \u0648\u0627\u0644\u0631\u0645\u0632 \u0648\u0628\u0635\u0645\u0629 \u2066SHA-256\u2069 (\u0632\u0631 \u0627\u0644\u0646\u0633\u062E \u064A\u0646\u0633\u062E\u0647\u0627 \u0643\u0627\u0645\u0644\u0629). \xAB\u0627\u0644\u0646\u0633\u062E\u0629 \u0627\u0644\u062D\u0627\u0644\u064A\u0629\xBB \u062A\u062F\u0644 \u0639\u0644\u0649 \u0627\u0644\u0623\u062D\u062F\u062B."
              },
              versionButtons: {
                term: "\u0646\u0633\u062E\u0629 \u062C\u062F\u064A\u062F\u0629",
                text: "\u064A\u0636\u064A\u0641 \u0645\u0644\u0641\u0627\u064B \u0643\u0646\u0633\u062E\u0629 \u062C\u062F\u064A\u062F\u0629 \u0628\u0627\u0644\u0645\u0624\u0634\u0631 \u0627\u0644\u062A\u0627\u0644\u064A. \xAB\u0627\u0633\u062A\u0639\u0627\u062F\u0629\xBB \u062A\u0636\u064A\u0641 \u0646\u0633\u062E\u0629 \u0642\u062F\u064A\u0645\u0629 \u0643\u0646\u0633\u062E\u0629 \u062C\u062F\u064A\u062F\u0629: \u0644\u0627 \u0634\u064A\u0621 \u064A\u064F\u0645\u062D\u0649. \u0643\u0644\u0627\u0647\u0645\u0627 \u064A\u0637\u0644\u0628 \u0633\u0628\u0628\u0627\u064B\u060C \u0648\u0644\u0627 \u064A\u0638\u0647\u0631\u0627\u0646 \u0623\u062B\u0646\u0627\u0621 \u062C\u0631\u064A\u0627\u0646 \u062A\u0623\u0634\u064A\u0631."
              }
            }
          },
          trash: {
            title: "\u0633\u0644\u0629 \u0627\u0644\u0645\u062D\u0630\u0648\u0641\u0627\u062A",
            items: {
              open: {
                term: "\u0633\u0644\u0629 \u0627\u0644\u0645\u062D\u0630\u0648\u0641\u0627\u062A",
                text: "\u0632\u0631 \u062A\u062D\u062A \u0634\u062C\u0631\u0629 \u0627\u0644\u0645\u062C\u0644\u062F\u0627\u062A: \u064A\u0633\u062A\u0628\u062F\u0644 \u0627\u0644\u0642\u0627\u0626\u0645\u0629 \u0628\u0633\u0644\u0629 \u0627\u0644\u0645\u062D\u0630\u0648\u0641\u0627\u062A. \xAB\u0627\u0644\u0639\u0648\u062F\u0629 \u0625\u0644\u0649 \u0627\u0644\u0645\u0644\u0641\u0627\u062A\xBB \u064A\u0639\u064A\u062F\u0643 \u0625\u0644\u0649 \u0627\u0644\u0645\u062C\u0644\u062F\u0627\u062A."
              },
              intro: {
                term: "\u0627\u0644\u0639\u0646\u0627\u0635\u0631 \u0627\u0644\u0645\u062D\u0630\u0648\u0641\u0629",
                text: "\u062A\u0628\u0642\u0649 \u0627\u0644\u0645\u062C\u0644\u062F\u0627\u062A \u0648\u0627\u0644\u0648\u062B\u0627\u0626\u0642 \u0627\u0644\u0645\u062D\u0630\u0648\u0641\u0629 \u0647\u0646\u0627\u0643 \u0639\u062F\u062F\u0627\u064B \u0645\u0646 \u0627\u0644\u0623\u064A\u0627\u0645 \u0645\u0643\u062A\u0648\u0628\u0627\u064B \u0641\u064A \u0623\u0639\u0644\u0649 \u0627\u0644\u0635\u0641\u062D\u0629 \u062B\u0645 \u062A\u064F\u0645\u0633\u062D \u0646\u0647\u0627\u0626\u064A\u0627\u064B. \u064A\u0631\u0649 \u0627\u0644\u0645\u0633\u0624\u0648\u0644\u0648\u0646 \u0643\u0644 \u0634\u064A\u0621\u060C \u0648\u064A\u0631\u0649 \u0627\u0644\u0622\u062E\u0631\u0648\u0646 \u0645\u0627 \u062D\u0630\u0641\u0648\u0647 \u0647\u0645 \u0641\u0642\u0637."
              },
              restore: {
                term: "\u0627\u0633\u062A\u0639\u0627\u062F\u0629",
                text: "\u064A\u0639\u064A\u062F \u0627\u0644\u0639\u0646\u0635\u0631 \u0625\u0644\u0649 \u0645\u0643\u0627\u0646\u0647. \u0625\u0630\u0627 \u0643\u0627\u0646 \u0645\u062C\u0644\u062F\u0647 \u0627\u0644\u0623\u0635\u0644\u064A \u0641\u064A \u0633\u0644\u0629 \u0627\u0644\u0645\u062D\u0630\u0648\u0641\u0627\u062A \u0623\u064A\u0636\u0627\u064B\u060C \u0641\u0627\u0633\u062A\u0639\u062F \u0630\u0644\u0643 \u0627\u0644\u0645\u062C\u0644\u062F \u0623\u0648\u0644\u0627\u064B."
              },
              purge: {
                term: "\u062D\u0630\u0641 \u0646\u0647\u0627\u0626\u064A",
                text: "\u064A\u0645\u0633\u062D \u0627\u0644\u0639\u0646\u0635\u0631 \u0648\u0646\u0633\u062E\u0647 \u0648\u0645\u0644\u0641\u0627\u062A\u0647 \u0628\u0639\u062F \u0627\u0644\u062A\u0623\u0643\u064A\u062F. \u0644\u0627 \u064A\u0645\u0643\u0646 \u0627\u0644\u062A\u0631\u0627\u062C\u0639 \u0639\u0646 \u0647\u0630\u0627 \u0627\u0644\u0625\u062C\u0631\u0627\u0621."
              },
              empty: {
                term: "\u0633\u0644\u0629 \u0627\u0644\u0645\u062D\u0630\u0648\u0641\u0627\u062A \u0641\u0627\u0631\u063A\u0629",
                text: "\u0631\u0633\u0627\u0644\u0629 \u062A\u0638\u0647\u0631 \u0639\u0646\u062F\u0645\u0627 \u0644\u0645 \u064A\u064F\u062D\u0630\u0641 \u0634\u064A\u0621."
              }
            }
          }
        }
      },
      chat: {
        title: "\u0627\u0644\u0645\u062D\u0627\u062F\u062B\u0627\u062A",
        intro: "\u062A\u0628\u0648\u064A\u0628 \u0627\u0644\u0645\u062D\u0627\u062F\u062B\u0627\u062A \u0641\u064A \u0641\u0636\u0627\u0621 \u0645\u0634\u062A\u0631\u0643: \u0642\u0646\u0648\u0627\u062A \u0627\u0644\u0641\u0636\u0627\u0621 \u0648\u0631\u0633\u0627\u0626\u0644\u0647\u0627. \u064A\u064F\u0633\u062A\u0639\u0645\u0644 \u0644\u0644\u062A\u0648\u0627\u0635\u0644 \u0645\u0639 \u0623\u0634\u062E\u0627\u0635 \u0627\u0644\u0645\u0624\u0633\u0633\u0629 \u0627\u0644\u0645\u0633\u062A\u0636\u064A\u0641\u0629 \u0648\u0627\u0644\u0645\u0624\u0633\u0633\u0627\u062A \u0627\u0644\u0634\u0631\u064A\u0643\u0629.",
        sections: {
          frame: {
            title: "\u0625\u0637\u0627\u0631 \u0627\u0644\u0641\u0636\u0627\u0621",
            items: {
              banner: {
                term: "\u0641\u0636\u0627\u0621 \u062E\u0627\u0631\u062C\u064A \u062A\u0633\u062A\u0636\u064A\u0641\u0647 \u2026",
                text: "\u0634\u0631\u064A\u0637 \u062F\u0627\u0626\u0645 \u064A\u0638\u0647\u0631 \u0639\u0646\u062F\u0645\u0627 \u064A\u062E\u0635 \u0627\u0644\u0641\u0636\u0627\u0621 \u0645\u0624\u0633\u0633\u0629 \u0623\u062E\u0631\u0649: \u064A\u0630\u0643\u0651\u0631\u0643 \u0628\u0623\u0646 \u0645\u062D\u062A\u0648\u0627\u0647 \u064A\u062E\u0636\u0639 \u0644\u0642\u0648\u0627\u0639\u062F \u062A\u0644\u0643 \u0627\u0644\u0645\u0624\u0633\u0633\u0629."
              },
              summary: {
                term: "\u062A\u0633\u062A\u0636\u064A\u0641\u0647 \u2026",
                text: "\u0634\u0631\u064A\u0637 \u062A\u062D\u062A \u0627\u0644\u0639\u0646\u0648\u0627\u0646: \u0627\u0644\u0645\u0624\u0633\u0633\u0629 \u0627\u0644\u062A\u064A \u062A\u0633\u062A\u0636\u064A\u0641 \u0627\u0644\u0641\u0636\u0627\u0621 \u0648\u0646\u0648\u0639\u0647 \u0648\u0634\u0627\u0631\u0629 \xAB\u0645\u063A\u0644\u0642\xBB \u0639\u0646\u062F\u0645\u0627 \u064A\u0643\u0648\u0646 \u0627\u0644\u0641\u0636\u0627\u0621 \u0645\u063A\u0644\u0642\u0627\u064B\u060C \u0648\u0641\u064A \u0627\u0644\u0641\u0636\u0627\u0621 \u0627\u0644\u062E\u0627\u0631\u062C\u064A \u0648\u0635\u0648\u0644\u0643: \u0643\u064A\u0641 \u062F\u062E\u0644\u062A \u0648\u0635\u0644\u0627\u062D\u064A\u0627\u062A\u0643 \u0648\u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0627\u0646\u062A\u0647\u0627\u0621."
              },
              guestNotice: {
                term: "\u064A\u0646\u062A\u0647\u064A \u0648\u0635\u0648\u0644\u0643 \u0643\u0636\u064A\u0641 \u0641\u064A \u2026",
                text: "\u0634\u0631\u064A\u0637 \u0645\u062E\u0635\u0635 \u0644\u0644\u0636\u064A\u0648\u0641: \u064A\u0639\u0637\u064A \u062A\u0627\u0631\u064A\u062E \u0627\u0646\u062A\u0647\u0627\u0621 \u0648\u0635\u0648\u0644\u0643. \u064A\u062A\u062D\u0648\u0644 \u0625\u0644\u0649 \u062A\u062D\u0630\u064A\u0631 \u062E\u0644\u0627\u0644 \u0622\u062E\u0631 14 \u064A\u0648\u0645\u0627\u064B."
              },
              tabs: {
                term: "\u0639\u0644\u0627\u0645\u0627\u062A \u0627\u0644\u062A\u0628\u0648\u064A\u0628",
                text: "\u0634\u0631\u064A\u0637 \u062A\u0628\u0648\u064A\u0628\u0627\u062A \u0627\u0644\u0641\u0636\u0627\u0621. \u0623\u0646\u062A \u0641\u064A \u062A\u0628\u0648\u064A\u0628 \xAB\u0627\u0644\u0645\u062D\u0627\u062F\u062B\u0627\u062A\xBB\u061B \u0644\u0627 \u062A\u0638\u0647\u0631 \u0625\u0644\u0627 \u0627\u0644\u062A\u0628\u0648\u064A\u0628\u0627\u062A \u0627\u0644\u062A\u064A \u064A\u062A\u064A\u062D \u0644\u0643 \u0648\u0635\u0648\u0644\u0643 \u0641\u062A\u062D\u0647\u0627."
              }
            }
          },
          channels: {
            title: "\u0627\u0644\u0642\u0646\u0648\u0627\u062A",
            items: {
              list: {
                term: "\u0627\u0644\u0642\u0646\u0648\u0627\u062A",
                text: "\u0642\u0627\u0626\u0645\u0629 \u0642\u0646\u0648\u0627\u062A \u0627\u0644\u0641\u0636\u0627\u0621 \u0627\u0644\u062A\u064A \u064A\u0645\u0643\u0646\u0643 \u0631\u0624\u064A\u062A\u0647\u0627\u060C \u0639\u0644\u0649 \u0627\u0644\u062C\u0627\u0646\u0628. \u0627\u0646\u0642\u0631 \u0639\u0644\u0649 \u0642\u0646\u0627\u0629 \u0644\u0642\u0631\u0627\u0621\u0629 \u0631\u0633\u0627\u0626\u0644\u0647\u0627\u061B \u0648\u062A\u064F\u0628\u0631\u0632 \u0627\u0644\u0642\u0646\u0627\u0629 \u0627\u0644\u0645\u0641\u062A\u0648\u062D\u0629."
              },
              unread: {
                term: "\u0631\u0633\u0627\u0626\u0644 \u063A\u064A\u0631 \u0645\u0642\u0631\u0648\u0621\u0629",
                text: "\u062A\u0638\u0647\u0631 \u0634\u0627\u0631\u0629 \u0628\u0631\u0642\u0645 \u0628\u062C\u0627\u0646\u0628 \u0642\u0646\u0627\u0629 \u0641\u064A\u0647\u0627 \u0631\u0633\u0627\u0626\u0644 \u0644\u0645 \u062A\u0642\u0631\u0623\u0647\u0627\u060C \u0648\u064A\u0635\u064A\u0631 \u0627\u0633\u0645\u0647\u0627 \u0628\u062E\u0637 \u0639\u0631\u064A\u0636."
              },
              empty: {
                term: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0642\u0646\u0648\u0627\u062A \u0628\u0639\u062F",
                text: "\u0631\u0633\u0627\u0644\u0629 \u062A\u0638\u0647\u0631 \u0645\u0627 \u062F\u0627\u0645 \u0627\u0644\u0641\u0636\u0627\u0621 \u0628\u0644\u0627 \u0623\u064A \u0642\u0646\u0627\u0629 \u0645\u0631\u0626\u064A\u0629 \u0644\u0643."
              },
              pick: {
                term: "\u0627\u062E\u062A\u0631 \u0642\u0646\u0627\u0629",
                text: "\u062A\u062F\u0639\u0648\u0643 \u0625\u0644\u0649 \u062A\u062D\u062F\u064A\u062F \u0642\u0646\u0627\u0629 \u0645\u0646 \u0627\u0644\u0642\u0627\u0626\u0645\u0629 \u0644\u0642\u0631\u0627\u0621\u0629 \u0627\u0644\u0631\u0633\u0627\u0626\u0644 \u0648\u0643\u062A\u0627\u0628\u062A\u0647\u0627."
              },
              loadFailed: {
                term: "\u062A\u0639\u0630\u0651\u0631 \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0642\u0646\u0648\u0627\u062A",
                text: "\u062A\u0638\u0647\u0631 \u0625\u0630\u0627 \u0644\u0645 \u062A\u064F\u062D\u0645\u064E\u0651\u0644 \u0627\u0644\u0642\u0627\u0626\u0645\u0629. \u0627\u0633\u062A\u062E\u062F\u0645 \xAB\u0625\u0639\u0627\u062F\u0629 \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629\xBB \u0628\u0639\u062F \u0642\u0644\u064A\u0644."
              }
            }
          },
          conversation: {
            title: "\u0627\u0644\u0645\u062D\u0627\u062F\u062B\u0629",
            items: {
              title: {
                term: "\u0627\u0633\u0645 \u0627\u0644\u0642\u0646\u0627\u0629",
                text: "\u0627\u0633\u0645 \u0627\u0644\u0642\u0646\u0627\u0629 \u0627\u0644\u0645\u0641\u062A\u0648\u062D\u0629\u060C \u0648\u062A\u062D\u062A\u0647 \u0645\u0648\u0636\u0648\u0639\u0647\u0627 \u0625\u0646 \u0643\u0627\u0646 \u0644\u0647\u0627 \u0645\u0648\u0636\u0648\u0639."
              },
              pins: {
                term: "\u0627\u0644\u0631\u0633\u0627\u0626\u0644 \u0627\u0644\u0645\u062B\u0628\u0651\u062A\u0629",
                text: "\u064A\u0641\u062A\u062D \u0644\u0648\u062D\u0629 \u0627\u0644\u0631\u0633\u0627\u0626\u0644 \u0627\u0644\u0645\u062B\u0628\u0651\u062A\u0629 \u0641\u064A \u0627\u0644\u0642\u0646\u0627\u0629. \u0627\u0644\u0631\u0642\u0645 \u0628\u064A\u0646 \u0627\u0644\u0642\u0648\u0633\u064A\u0646 \u0647\u0648 \u0639\u062F\u062F \u0627\u0644\u0631\u0633\u0627\u0626\u0644 \u0627\u0644\u0645\u062B\u0628\u0651\u062A\u0629."
              },
              messages: {
                term: "\u0627\u0644\u0631\u0633\u0627\u0626\u0644",
                text: "\u0627\u0644\u0631\u0633\u0627\u0626\u0644\u060C \u0648\u0627\u0644\u0623\u062D\u062F\u062B \u0641\u064A \u0627\u0644\u0623\u0633\u0641\u0644\u060C \u0645\u0641\u0635\u0648\u0644\u0629 \u062D\u0633\u0628 \u0627\u0644\u064A\u0648\u0645 (\xAB\u0627\u0644\u064A\u0648\u0645\xBB \u0623\u0648 \xAB\u0623\u0645\u0633\xBB \u0623\u0648 \u0627\u0644\u062A\u0627\u0631\u064A\u062E). \u062A\u0639\u0631\u0636 \u0643\u0644 \u0631\u0633\u0627\u0644\u0629 \u0643\u0627\u062A\u0628\u0647\u0627 \u0648\u0627\u0644\u0648\u0642\u062A\u060C \u0648\xAB\u0645\u0639\u062F\u0651\u0644\u0629\xBB \u0625\u0646 \u0635\u064F\u062D\u062D\u062A. \u062A\u064F\u0633\u062A\u0628\u062F\u0644 \u0627\u0644\u0631\u0633\u0627\u0644\u0629 \u0627\u0644\u0645\u062D\u0630\u0648\u0641\u0629 \u0628\u0639\u0628\u0627\u0631\u0629 \xAB\u062A\u0645 \u062D\u0630\u0641 \u0647\u0630\u0647 \u0627\u0644\u0631\u0633\u0627\u0644\u0629\xBB."
              },
              external: {
                term: "\u062E\u0627\u0631\u062C\u064A \xB7 \u2026",
                text: "\u0634\u0627\u0631\u0629 \u0635\u0641\u0631\u0627\u0621 \u0628\u062C\u0627\u0646\u0628 \u0627\u0633\u0645 \u0634\u062E\u0635 \u0645\u0646 \u0645\u0624\u0633\u0633\u0629 \u0623\u062E\u0631\u0649\u060C \u0645\u0639 \u0627\u0633\u0645 \u062A\u0644\u0643 \u0627\u0644\u0645\u0624\u0633\u0633\u0629."
              },
              pinned: {
                term: "\u0645\u062B\u0628\u0651\u062A\u0629",
                text: "\u062A\u062F\u0644 \u0639\u0644\u0649 \u0631\u0633\u0627\u0644\u0629 \u0645\u062B\u0628\u0651\u062A\u0629: \u062A\u062C\u062F\u0647\u0627 \u0623\u064A\u0636\u0627\u064B \u0641\u064A \xAB\u0627\u0644\u0631\u0633\u0627\u0626\u0644 \u0627\u0644\u0645\u062B\u0628\u0651\u062A\u0629\xBB."
              },
              jump: {
                term: "\u0623\u062D\u062F\u062B \u0627\u0644\u0631\u0633\u0627\u0626\u0644",
                text: "\u0632\u0631 \u064A\u0638\u0647\u0631 \u0639\u0646\u062F\u0645\u0627 \u062A\u0635\u0639\u062F \u0641\u064A \u0627\u0644\u0645\u062D\u0627\u062F\u062B\u0629: \u064A\u0639\u064A\u062F\u0643 \u0625\u0644\u0649 \u0627\u0644\u0623\u0633\u0641\u0644. \u062A\u0638\u0647\u0631 \xAB\u062C\u0627\u0631\u064D \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0631\u0633\u0627\u0626\u0644 \u0627\u0644\u0633\u0627\u0628\u0642\u0629\u2026\xBB \u0623\u062B\u0646\u0627\u0621 \u0648\u0635\u0648\u0644 \u0627\u0644\u0631\u0633\u0627\u0626\u0644 \u0627\u0644\u0642\u062F\u064A\u0645\u0629."
              },
              empty: {
                term: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0631\u0633\u0627\u0626\u0644 \u0628\u0639\u062F",
                text: "\u0631\u0633\u0627\u0644\u0629 \u0627\u0644\u0642\u0646\u0627\u0629 \u0627\u0644\u0641\u0627\u0631\u063A\u0629. \u0627\u0643\u062A\u0628 \u0623\u0648\u0644 \u0631\u0633\u0627\u0644\u0629 \u0625\u0630\u0627 \u0643\u0627\u0646\u062A \u0644\u0643 \u0635\u0644\u0627\u062D\u064A\u0629 \u0627\u0644\u0643\u062A\u0627\u0628\u0629."
              }
            }
          },
          actions: {
            title: "\u0625\u062C\u0631\u0627\u0621\u0627\u062A \u0639\u0644\u0649 \u0631\u0633\u0627\u0644\u0629",
            items: {
              toolbar: {
                term: "\u0625\u062C\u0631\u0627\u0621\u0627\u062A \u0639\u0644\u0649 \u0631\u0633\u0627\u0644\u0629 \u2026",
                text: "\u064A\u0638\u0647\u0631 \u0634\u0631\u064A\u0637 \u0635\u063A\u064A\u0631 \u0639\u0646\u062F \u062A\u0645\u0631\u064A\u0631 \u0627\u0644\u0645\u0624\u0634\u0631 \u0641\u0648\u0642 \u0631\u0633\u0627\u0644\u0629 (\u0638\u0627\u0647\u0631 \u062F\u0627\u0626\u0645\u0627\u064B \u0639\u0644\u0649 \u0627\u0644\u0647\u0627\u062A\u0641): \u062A\u0641\u0627\u0639\u0644 \u0648\u0627\u0644\u0631\u062F \u0641\u064A \u0633\u0644\u0633\u0644\u0629 \u0648\u0627\u0644\u062A\u062B\u0628\u064A\u062A \u0648\u0627\u0644\u062A\u0639\u062F\u064A\u0644 \u0648\u0627\u0644\u062D\u0630\u0641."
              },
              react: {
                term: "\u0625\u0636\u0627\u0641\u0629 \u062A\u0641\u0627\u0639\u0644",
                text: "\u064A\u0636\u064A\u0641 \u0631\u0645\u0632\u0627\u064B \u062A\u0639\u0628\u064A\u0631\u064A\u0627\u064B \u062A\u062D\u062A \u0627\u0644\u0631\u0633\u0627\u0644\u0629 \u0644\u062A\u062A\u0641\u0627\u0639\u0644 \u062F\u0648\u0646 \u0643\u062A\u0627\u0628\u0629 \u0631\u062F."
              },
              thread: {
                term: "\u0627\u0644\u0631\u062F \u0641\u064A \u0633\u0644\u0633\u0644\u0629",
                text: "\u064A\u0641\u062A\u062D \u0633\u0644\u0633\u0644\u0629 \u0627\u0644\u0631\u0633\u0627\u0644\u0629 \u0641\u064A \u0644\u0648\u062D\u0629 \u0639\u0644\u0649 \u0627\u0644\u062C\u0627\u0646\u0628\u060C \u0644\u062A\u0631\u062F \u062F\u0648\u0646 \u0625\u062B\u0642\u0627\u0644 \u0627\u0644\u0642\u0646\u0627\u0629. \u063A\u064A\u0631 \u0645\u062A\u0627\u062D \u0644\u0636\u064A\u0641 \u0628\u0644\u0627 \u0645\u0624\u0633\u0633\u0629."
              },
              pin: {
                term: "\u062A\u062B\u0628\u064A\u062A \u0627\u0644\u0631\u0633\u0627\u0644\u0629",
                text: "\u064A\u062B\u0628\u0651\u062A \u0627\u0644\u0631\u0633\u0627\u0644\u0629 \u0644\u062A\u062C\u062F\u0647\u0627 \u0641\u064A \xAB\u0627\u0644\u0631\u0633\u0627\u0626\u0644 \u0627\u0644\u0645\u062B\u0628\u0651\u062A\u0629\xBB. \u064A\u0635\u064A\u0631 \u0627\u0644\u0632\u0631 \u0646\u0641\u0633\u0647 \xAB\u0625\u0644\u063A\u0627\u0621 \u062A\u062B\u0628\u064A\u062A \u0627\u0644\u0631\u0633\u0627\u0644\u0629\xBB. \u062A\u0636\u0645 \u0627\u0644\u0642\u0646\u0627\u0629 50 \u0631\u0633\u0627\u0644\u0629 \u0645\u062B\u0628\u0651\u062A\u0629 \u0639\u0644\u0649 \u0627\u0644\u0623\u0643\u062B\u0631. \u063A\u064A\u0631 \u0645\u062A\u0627\u062D \u0641\u064A \u0642\u0646\u0627\u0629 \u0644\u0644\u0642\u0631\u0627\u0621\u0629 \u0641\u0642\u0637."
              },
              editDelete: {
                term: "\u062A\u0639\u062F\u064A\u0644 \u0627\u0644\u0631\u0633\u0627\u0644\u0629",
                text: "\u064A\u0645\u0643\u0646\u0643 \u062A\u0639\u062F\u064A\u0644 \u0631\u0633\u0627\u0626\u0644\u0643 \u0623\u0646\u062A. \xAB\u062D\u0630\u0641 \u0627\u0644\u0631\u0633\u0627\u0644\u0629\xBB \u0645\u062A\u0627\u062D \u0644\u0631\u0633\u0627\u0626\u0644\u0643\u060C \u0648\u0644\u0644\u0645\u0634\u0631\u0641\u064A\u0646 \u0644\u0631\u0633\u0627\u0626\u0644 \u0627\u0644\u0622\u062E\u0631\u064A\u0646: \u064A\u0637\u0644\u0628 \u062A\u0623\u0643\u064A\u062F\u0627\u064B \u0648\u0627\u0644\u062D\u0630\u0641 \u0646\u0647\u0627\u0626\u064A."
              },
              sending: {
                term: "\u0644\u0645 \u062A\u064F\u0631\u0633\u0644 \u0627\u0644\u0631\u0633\u0627\u0644\u0629.",
                text: "\u062A\u0639\u0631\u0636 \u0627\u0644\u0631\u0633\u0627\u0644\u0629 \u0642\u064A\u062F \u0627\u0644\u0625\u0631\u0633\u0627\u0644 \xAB\u062C\u0627\u0631\u064D \u0627\u0644\u0625\u0631\u0633\u0627\u0644\u2026\xBB. \u0625\u0646 \u0641\u0634\u0644\u062A: \xAB\u0625\u0639\u0627\u062F\u0629 \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629\xBB \u062A\u0631\u0633\u0644\u0647\u0627 \u0645\u0646 \u062C\u062F\u064A\u062F\u060C \u0648\xAB\u0627\u0633\u062A\u0631\u062C\u0627\u0639 \u0627\u0644\u0646\u0635\xBB \u064A\u0639\u064A\u062F\u0647\u0627 \u0625\u0644\u0649 \u062E\u0627\u0646\u0629 \u0627\u0644\u0643\u062A\u0627\u0628\u0629\u060C \u0648\xAB\u062D\u0630\u0641\xBB \u064A\u062A\u062E\u0644\u0649 \u0639\u0646\u0647\u0627."
              }
            }
          },
          composer: {
            title: "\u0643\u062A\u0627\u0628\u0629 \u0631\u0633\u0627\u0644\u0629",
            items: {
              box: {
                term: "\u0627\u0643\u062A\u0628 \u0631\u0633\u0627\u0644\u0629",
                text: "\u062E\u0627\u0646\u0629 \u0627\u0644\u0643\u062A\u0627\u0628\u0629 \u0641\u064A \u0627\u0644\u0623\u0633\u0641\u0644. \u0645\u0641\u062A\u0627\u062D \u2066Enter\u2069 \u064A\u0631\u0633\u0644 \u0627\u0644\u0631\u0633\u0627\u0644\u0629\u060C \u0648\u2066Shift+Enter\u2069 \u064A\u0628\u062F\u0623 \u0633\u0637\u0631\u0627\u064B \u062C\u062F\u064A\u062F\u0627\u064B\u060C \u0648\u2066@\u2069 \u062A\u062A\u064A\u062D \u0627\u0644\u0625\u0634\u0627\u0631\u0629 \u0625\u0644\u0649 \u0634\u062E\u0635. \u064A\u064F\u062D\u0641\u0638 \u0627\u0644\u0646\u0635 \u063A\u064A\u0631 \u0627\u0644\u0645\u0631\u0633\u0644 \u0625\u0630\u0627 \u0627\u0646\u062A\u0642\u0644\u062A \u0625\u0644\u0649 \u0642\u0646\u0627\u0629 \u0623\u062E\u0631\u0649."
              },
              attach: {
                term: "\u0625\u0631\u0641\u0627\u0642 \u0645\u0644\u0641",
                text: "\u064A\u0631\u0641\u0642 \u0645\u0644\u0641\u0627\u064B \u0623\u0648 \u0623\u0643\u062B\u0631 \u0628\u0627\u0644\u0631\u0633\u0627\u0644\u0629. \u062A\u064F\u0631\u0633\u0644 \u0625\u0644\u0649 \u0645\u062C\u0644\u062F \u0645\u0631\u0641\u0642\u0627\u062A \u0627\u0644\u0642\u0646\u0627\u0629\u061B \u0627\u0646\u062A\u0638\u0631 \u0627\u0646\u062A\u0647\u0627\u0621 \u0625\u0631\u0633\u0627\u0644\u0647\u0627 \u0642\u0628\u0644 \u0625\u0631\u0633\u0627\u0644 \u0627\u0644\u0631\u0633\u0627\u0644\u0629."
              },
              send: {
                term: "\u0625\u0631\u0633\u0627\u0644",
                text: "\u064A\u0631\u0633\u0644 \u0627\u0644\u0631\u0633\u0627\u0644\u0629. \u064A\u0643\u0648\u0646 \u0645\u0639\u0637\u0644\u0627\u064B \u0645\u0627 \u062F\u0627\u0645\u062A \u0627\u0644\u062E\u0627\u0646\u0629 \u0641\u0627\u0631\u063A\u0629."
              },
              typing: {
                term: "\u0634\u062E\u0635 \u0645\u0627 \u064A\u0643\u062A\u0628\u2026",
                text: "\u0633\u0637\u0631 \u0641\u0648\u0642 \u062E\u0627\u0646\u0629 \u0627\u0644\u0643\u062A\u0627\u0628\u0629 \u064A\u0642\u0648\u0644 \u0645\u0646 \u064A\u0643\u062A\u0628."
              },
              blocked: {
                term: "\u0647\u0630\u0647 \u0627\u0644\u0642\u0646\u0627\u0629 \u0645\u0624\u0631\u0634\u0641\u0629: \u064A\u0645\u0643\u0646\u0643 \u0642\u0631\u0627\u0621\u062A\u0647\u0627 \u0644\u0643\u0646 \u0644\u0627 \u064A\u0645\u0643\u0646\u0643 \u0627\u0644\u0643\u062A\u0627\u0628\u0629 \u0641\u064A\u0647\u0627.",
                text: "\u064A\u062D\u0644\u0651 \u0645\u062D\u0644 \u062E\u0627\u0646\u0629 \u0627\u0644\u0643\u062A\u0627\u0628\u0629 \u0639\u0646\u062F\u0645\u0627 \u062A\u0643\u0648\u0646 \u0627\u0644\u0642\u0646\u0627\u0629 \u0645\u0624\u0631\u0634\u0641\u0629. \u062A\u0638\u0647\u0631 \xAB\u064A\u0645\u0643\u0646\u0643 \u0642\u0631\u0627\u0621\u0629 \u0647\u0630\u0647 \u0627\u0644\u0645\u062D\u0627\u062F\u062B\u0629 \u0644\u0643\u0646 \u0644\u0627 \u064A\u0645\u0643\u0646\u0643 \u0627\u0644\u0643\u062A\u0627\u0628\u0629 \u0641\u064A\u0647\u0627\xBB \u0639\u0646\u062F\u0645\u0627 \u064A\u0643\u0648\u0646 \u0648\u0635\u0648\u0644\u0643 \u0644\u0644\u0642\u0631\u0627\u0621\u0629 \u0641\u0642\u0637."
              }
            }
          },
          attachments: {
            title: "\u0627\u0644\u0645\u0644\u0641\u0627\u062A \u0627\u0644\u0645\u0631\u0641\u0642\u0629 \u0648\u0627\u0644\u0644\u0648\u062D\u0627\u062A",
            items: {
              cards: {
                term: "\u0627\u0644\u0645\u0644\u0641\u0627\u062A \u0627\u0644\u0645\u0631\u0641\u0642\u0629 \u0628\u0631\u0633\u0627\u0644\u0629 \u2026",
                text: "\u062A\u062D\u062A \u0627\u0644\u0631\u0633\u0627\u0644\u0629 \u0628\u0637\u0627\u0642\u0629 \u0644\u0643\u0644 \u0645\u0644\u0641 \u0645\u0639 \u062D\u0627\u0644\u062A\u0647 (\xAB\u062C\u0627\u0631\u064D \u0627\u0644\u0625\u0631\u0633\u0627\u0644\xBB \u0623\u0648 \xAB\u062C\u0627\u0631\u064D \u0627\u0644\u0641\u062D\u0635 \u0628\u0645\u0636\u0627\u062F \u0627\u0644\u0641\u064A\u0631\u0648\u0633\u0627\u062A\xBB \u0623\u0648 \xAB\u0645\u062A\u0627\u062D\xBB \u0623\u0648 \u0645\u0631\u0641\u0648\u0636)."
              },
              openDownload: {
                term: "\u062A\u0646\u0632\u064A\u0644",
                text: "\xAB\u0641\u062A\u062D\xBB \u064A\u0639\u0631\u0636 \u0627\u0644\u0645\u0644\u0641 \u0648\xAB\u062A\u0646\u0632\u064A\u0644\xBB \u064A\u062D\u0641\u0638\u0647 \u0639\u0644\u0649 \u062D\u0627\u0633\u0648\u0628\u0643. \u0625\u0630\u0627 \u0643\u0627\u0646 \u0627\u0644\u0641\u0636\u0627\u0621 \u064A\u0645\u0646\u0639 \u0627\u0644\u062A\u0646\u0632\u064A\u0644\u060C \u062A\u0642\u0648\u0644 \u0631\u0633\u0627\u0644\u0629 \u0630\u0644\u0643."
              },
              noAccess: {
                term: "\u0644\u064A\u0633\u062A \u0644\u062F\u064A\u0643 \u0635\u0644\u0627\u062D\u064A\u0629 \u0627\u0644\u0648\u0635\u0648\u0644 \u0625\u0644\u0649 \u0647\u0630\u0627 \u0627\u0644\u0645\u0644\u0641",
                text: "\u0627\u0644\u0645\u0644\u0641 \u0645\u062D\u0641\u0648\u0638 \u0641\u064A \u0645\u062C\u0644\u062F \u0644\u0627 \u064A\u0645\u0643\u0646\u0643 \u0627\u0644\u0627\u0637\u0644\u0627\u0639 \u0639\u0644\u064A\u0647. \u0627\u0637\u0644\u0628 \u0627\u0644\u0635\u0644\u0627\u062D\u064A\u0629 \u0645\u0646 \u0627\u0644\u0634\u062E\u0635 \u0627\u0644\u0630\u064A \u0623\u0631\u0633\u0644\u0647."
              },
              threadPanel: {
                term: "\u0633\u0644\u0633\u0644\u0629 \u0627\u0644\u0646\u0642\u0627\u0634",
                text: "\u0644\u0648\u062D\u0629 \u0639\u0644\u0649 \u0627\u0644\u062C\u0627\u0646\u0628: \u0627\u0644\u0631\u0633\u0627\u0644\u0629 \u0627\u0644\u0623\u0635\u0644\u064A\u0629 \u0648\u0631\u062F\u0648\u062F\u0647\u0627 \u0648\u062E\u0627\u0646\u0629 \xAB\u0627\u0644\u0631\u062F \u0641\u064A \u0627\u0644\u0633\u0644\u0633\u0644\u0629\xBB \u0645\u0639 \u0627\u0644\u0632\u0631 \xAB\u0631\u062F\xBB."
              },
              pinsPanel: {
                term: "\u0627\u0644\u0631\u0633\u0627\u0626\u0644 \u0627\u0644\u0645\u062B\u0628\u0651\u062A\u0629",
                text: "\u0644\u0648\u062D\u0629 \u0639\u0644\u0649 \u0627\u0644\u062C\u0627\u0646\u0628: \u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u0631\u0633\u0627\u0626\u0644 \u0627\u0644\u0645\u062B\u0628\u0651\u062A\u0629 \u0645\u0639 \xAB\u0639\u0631\u0636 \u0641\u064A \u0627\u0644\u0645\u062D\u0627\u062F\u062B\u0629\xBB \u0648\xAB\u0641\u062A\u062D \u0627\u0644\u0633\u0644\u0633\u0644\u0629\xBB \u0648\xAB\u0625\u0644\u063A\u0627\u0621 \u062A\u062B\u0628\u064A\u062A \u0627\u0644\u0631\u0633\u0627\u0644\u0629\xBB."
              }
            }
          }
        }
      },
      calendar: {
        title: "\u0627\u0644\u062A\u0642\u0648\u064A\u0645",
        intro: "\u062A\u0628\u0648\u064A\u0628 \u0627\u0644\u062A\u0642\u0648\u064A\u0645 \u0641\u064A \u0641\u0636\u0627\u0621 \u0645\u0634\u062A\u0631\u0643. \u0647\u0648 \u0645\u0639\u0644\u0646 \u0644\u0643\u0646\u0647 \u063A\u064A\u0631 \u0645\u062A\u0627\u062D \u0628\u0639\u062F: \u062A\u0639\u0631\u0636 \u0627\u0644\u0635\u0641\u062D\u0629 \u062D\u0627\u0644\u064A\u0627\u064B \u0631\u0633\u0627\u0644\u0629 \xAB\u0642\u0627\u062F\u0645 \u0642\u0631\u064A\u0628\u0627\u064B\xBB.",
        sections: {
          header: {
            title: "\u0631\u0623\u0633 \u0627\u0644\u0641\u0636\u0627\u0621",
            items: {
              banner: {
                term: "\u0641\u0636\u0627\u0621 \u062E\u0627\u0631\u062C\u064A \u062A\u0633\u062A\u0636\u064A\u0641\u0647 \u2026",
                text: "\u0634\u0631\u064A\u0637 \u062F\u0627\u0626\u0645 \u064A\u0638\u0647\u0631 \u0639\u0646\u062F\u0645\u0627 \u064A\u062E\u0635 \u0627\u0644\u0641\u0636\u0627\u0621 \u0645\u0624\u0633\u0633\u0629 \u0623\u062E\u0631\u0649: \u064A\u0630\u0643\u0651\u0631\u0643 \u0628\u0623\u0646 \u0645\u062D\u062A\u0648\u0627\u0647 \u064A\u062E\u0636\u0639 \u0644\u0642\u0648\u0627\u0639\u062F \u062A\u0644\u0643 \u0627\u0644\u0645\u0624\u0633\u0633\u0629."
              },
              summary: {
                term: "\u062A\u0633\u062A\u0636\u064A\u0641\u0647 \u2026",
                text: "\u0634\u0631\u064A\u0637 \u062A\u062D\u062A \u0627\u0644\u0639\u0646\u0648\u0627\u0646: \u0627\u0644\u0645\u0624\u0633\u0633\u0629 \u0627\u0644\u062A\u064A \u062A\u0633\u062A\u0636\u064A\u0641 \u0627\u0644\u0641\u0636\u0627\u0621 \u0648\u0646\u0648\u0639\u0647 \u0648\u0634\u0627\u0631\u0629 \xAB\u0645\u063A\u0644\u0642\xBB \u0639\u0646\u062F\u0645\u0627 \u064A\u0643\u0648\u0646 \u0627\u0644\u0641\u0636\u0627\u0621 \u0645\u063A\u0644\u0642\u0627\u064B\u060C \u0648\u0641\u064A \u0627\u0644\u0641\u0636\u0627\u0621 \u0627\u0644\u062E\u0627\u0631\u062C\u064A \u0648\u0635\u0648\u0644\u0643: \u0643\u064A\u0641 \u062F\u062E\u0644\u062A \u0648\u0635\u0644\u0627\u062D\u064A\u0627\u062A\u0643 \u0648\u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0627\u0646\u062A\u0647\u0627\u0621."
              }
            }
          },
          tabs: {
            title: "\u0639\u0644\u0627\u0645\u0627\u062A \u0627\u0644\u062A\u0628\u0648\u064A\u0628",
            items: {
              tabList: {
                term: "\u0639\u0644\u0627\u0645\u0627\u062A \u0627\u0644\u062A\u0628\u0648\u064A\u0628",
                text: "\u0634\u0631\u064A\u0637 \u062A\u0628\u0648\u064A\u0628\u0627\u062A \u0627\u0644\u0641\u0636\u0627\u0621. \u0644\u0627 \u062A\u0638\u0647\u0631 \u0625\u0644\u0627 \u0627\u0644\u062A\u0628\u0648\u064A\u0628\u0627\u062A \u0627\u0644\u062A\u064A \u064A\u062A\u064A\u062D \u0644\u0643 \u0648\u0635\u0648\u0644\u0643 \u0641\u062A\u062D\u0647\u0627. \u0645\u0633\u0627\u0631 \u0627\u0644\u062A\u0646\u0642\u0644 \u0641\u064A \u0627\u0644\u0623\u0639\u0644\u0649 (\xAB\u0627\u0644\u0641\u0636\u0627\u0621\u0627\u062A \u0627\u0644\u0645\u0634\u062A\u0631\u0643\u0629\xBB) \u064A\u0639\u064A\u062F\u0643 \u0625\u0644\u0649 \u0642\u0627\u0626\u0645\u0629 \u0641\u0636\u0627\u0621\u0627\u062A\u0643."
              },
              thisTab: {
                term: "\u0627\u0644\u062A\u0642\u0648\u064A\u0645",
                text: "\u0627\u0644\u062A\u0628\u0648\u064A\u0628 \u0627\u0644\u0630\u064A \u0623\u0646\u062A \u0641\u064A\u0647. \u0644\u0627 \u064A\u0638\u0647\u0631 \u0625\u0644\u0627 \u0625\u0630\u0627 \u0643\u0627\u0646 \u0648\u0635\u0648\u0644\u0643 \u0625\u0644\u0649 \u0627\u0644\u0641\u0636\u0627\u0621 \u064A\u062A\u064A\u062D\u0647."
              }
            }
          },
          comingSoon: {
            title: "\u0645\u062D\u062A\u0648\u0649 \u0627\u0644\u062A\u0628\u0648\u064A\u0628",
            items: {
              title: {
                term: "\u062A\u0642\u0648\u064A\u0645 \u0627\u0644\u0641\u0636\u0627\u0621 \u0642\u0627\u062F\u0645 \u0642\u0631\u064A\u0628\u0627\u064B",
                text: "\u0639\u0646\u0648\u0627\u0646 \u0627\u0644\u0631\u0633\u0627\u0644\u0629 \u0627\u0644\u0645\u0639\u0631\u0648\u0636\u0629 \u0628\u062F\u0644 \u0627\u0644\u062A\u0642\u0648\u064A\u0645. \u0644\u0627 \u064A\u0648\u062C\u062F \u062D\u0627\u0644\u064A\u0627\u064B \u0645\u0627 \u062A\u0643\u062A\u0628\u0647 \u0623\u0648 \u062A\u0646\u0642\u0631 \u0639\u0644\u064A\u0647 \u0641\u064A \u0647\u0630\u0627 \u0627\u0644\u062A\u0628\u0648\u064A\u0628."
              },
              description: {
                term: "\u0633\u062A\u0638\u0647\u0631 \u0647\u0646\u0627 \u0623\u062D\u062F\u0627\u062B \u0627\u0644\u0641\u0636\u0627\u0621 \u0648\u0645\u0648\u0627\u0639\u064A\u062F\u0647.",
                text: "\u0645\u0627 \u0633\u064A\u062D\u062A\u0648\u064A\u0647 \u0627\u0644\u062A\u0628\u0648\u064A\u0628 \u0645\u0633\u062A\u0642\u0628\u0644\u0627\u064B: \u0623\u062D\u062F\u0627\u062B \u0627\u0644\u0641\u0636\u0627\u0621 \u0648\u0645\u0648\u0627\u0639\u064A\u062F\u0647."
              }
            }
          }
        }
      },
      meetings: {
        title: "\u0627\u0644\u0627\u062C\u062A\u0645\u0627\u0639\u0627\u062A",
        intro: "\u062A\u0628\u0648\u064A\u0628 \u0627\u0644\u0627\u062C\u062A\u0645\u0627\u0639\u0627\u062A \u0641\u064A \u0641\u0636\u0627\u0621 \u0645\u0634\u062A\u0631\u0643. \u0647\u0648 \u0645\u0639\u0644\u0646 \u0644\u0643\u0646\u0647 \u063A\u064A\u0631 \u0645\u062A\u0627\u062D \u0628\u0639\u062F: \u062A\u0639\u0631\u0636 \u0627\u0644\u0635\u0641\u062D\u0629 \u062D\u0627\u0644\u064A\u0627\u064B \u0631\u0633\u0627\u0644\u0629 \xAB\u0642\u0627\u062F\u0645 \u0642\u0631\u064A\u0628\u0627\u064B\xBB.",
        sections: {
          header: {
            title: "\u0631\u0623\u0633 \u0627\u0644\u0641\u0636\u0627\u0621",
            items: {
              banner: {
                term: "\u0641\u0636\u0627\u0621 \u062E\u0627\u0631\u062C\u064A \u062A\u0633\u062A\u0636\u064A\u0641\u0647 \u2026",
                text: "\u0634\u0631\u064A\u0637 \u062F\u0627\u0626\u0645 \u064A\u0638\u0647\u0631 \u0639\u0646\u062F\u0645\u0627 \u064A\u062E\u0635 \u0627\u0644\u0641\u0636\u0627\u0621 \u0645\u0624\u0633\u0633\u0629 \u0623\u062E\u0631\u0649: \u064A\u0630\u0643\u0651\u0631\u0643 \u0628\u0623\u0646 \u0645\u062D\u062A\u0648\u0627\u0647 \u064A\u062E\u0636\u0639 \u0644\u0642\u0648\u0627\u0639\u062F \u062A\u0644\u0643 \u0627\u0644\u0645\u0624\u0633\u0633\u0629."
              },
              summary: {
                term: "\u062A\u0633\u062A\u0636\u064A\u0641\u0647 \u2026",
                text: "\u0634\u0631\u064A\u0637 \u062A\u062D\u062A \u0627\u0644\u0639\u0646\u0648\u0627\u0646: \u0627\u0644\u0645\u0624\u0633\u0633\u0629 \u0627\u0644\u062A\u064A \u062A\u0633\u062A\u0636\u064A\u0641 \u0627\u0644\u0641\u0636\u0627\u0621 \u0648\u0646\u0648\u0639\u0647 \u0648\u0634\u0627\u0631\u0629 \xAB\u0645\u063A\u0644\u0642\xBB \u0639\u0646\u062F\u0645\u0627 \u064A\u0643\u0648\u0646 \u0627\u0644\u0641\u0636\u0627\u0621 \u0645\u063A\u0644\u0642\u0627\u064B\u060C \u0648\u0641\u064A \u0627\u0644\u0641\u0636\u0627\u0621 \u0627\u0644\u062E\u0627\u0631\u062C\u064A \u0648\u0635\u0648\u0644\u0643: \u0643\u064A\u0641 \u062F\u062E\u0644\u062A \u0648\u0635\u0644\u0627\u062D\u064A\u0627\u062A\u0643 \u0648\u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0627\u0646\u062A\u0647\u0627\u0621."
              }
            }
          },
          tabs: {
            title: "\u0639\u0644\u0627\u0645\u0627\u062A \u0627\u0644\u062A\u0628\u0648\u064A\u0628",
            items: {
              tabList: {
                term: "\u0639\u0644\u0627\u0645\u0627\u062A \u0627\u0644\u062A\u0628\u0648\u064A\u0628",
                text: "\u0634\u0631\u064A\u0637 \u062A\u0628\u0648\u064A\u0628\u0627\u062A \u0627\u0644\u0641\u0636\u0627\u0621. \u0644\u0627 \u062A\u0638\u0647\u0631 \u0625\u0644\u0627 \u0627\u0644\u062A\u0628\u0648\u064A\u0628\u0627\u062A \u0627\u0644\u062A\u064A \u064A\u062A\u064A\u062D \u0644\u0643 \u0648\u0635\u0648\u0644\u0643 \u0641\u062A\u062D\u0647\u0627. \u0645\u0633\u0627\u0631 \u0627\u0644\u062A\u0646\u0642\u0644 \u0641\u064A \u0627\u0644\u0623\u0639\u0644\u0649 (\xAB\u0627\u0644\u0641\u0636\u0627\u0621\u0627\u062A \u0627\u0644\u0645\u0634\u062A\u0631\u0643\u0629\xBB) \u064A\u0639\u064A\u062F\u0643 \u0625\u0644\u0649 \u0642\u0627\u0626\u0645\u0629 \u0641\u0636\u0627\u0621\u0627\u062A\u0643."
              },
              thisTab: {
                term: "\u0627\u0644\u0627\u062C\u062A\u0645\u0627\u0639\u0627\u062A",
                text: "\u0627\u0644\u062A\u0628\u0648\u064A\u0628 \u0627\u0644\u0630\u064A \u0623\u0646\u062A \u0641\u064A\u0647. \u0644\u0627 \u064A\u0638\u0647\u0631 \u0625\u0644\u0627 \u0625\u0630\u0627 \u0643\u0627\u0646 \u0648\u0635\u0648\u0644\u0643 \u0625\u0644\u0649 \u0627\u0644\u0641\u0636\u0627\u0621 \u064A\u062A\u064A\u062D\u0647."
              }
            }
          },
          comingSoon: {
            title: "\u0645\u062D\u062A\u0648\u0649 \u0627\u0644\u062A\u0628\u0648\u064A\u0628",
            items: {
              title: {
                term: "\u0627\u062C\u062A\u0645\u0627\u0639\u0627\u062A \u0627\u0644\u0641\u0636\u0627\u0621 \u0642\u0627\u062F\u0645\u0629 \u0642\u0631\u064A\u0628\u0627\u064B",
                text: "\u0639\u0646\u0648\u0627\u0646 \u0627\u0644\u0631\u0633\u0627\u0644\u0629 \u0627\u0644\u0645\u0639\u0631\u0648\u0636\u0629 \u0628\u062F\u0644 \u0627\u0644\u0627\u062C\u062A\u0645\u0627\u0639\u0627\u062A. \u0644\u0627 \u064A\u0648\u062C\u062F \u062D\u0627\u0644\u064A\u0627\u064B \u0645\u0627 \u062A\u0643\u062A\u0628\u0647 \u0623\u0648 \u062A\u0646\u0642\u0631 \u0639\u0644\u064A\u0647 \u0641\u064A \u0647\u0630\u0627 \u0627\u0644\u062A\u0628\u0648\u064A\u0628."
              },
              description: {
                term: "\u0633\u062A\u062A\u0645\u0643\u0646 \u0645\u0646 \u0628\u062F\u0621 \u0627\u062C\u062A\u0645\u0627\u0639\u0627\u062A \u0627\u0644\u0641\u0636\u0627\u0621 \u0648\u0627\u0644\u0627\u0646\u0636\u0645\u0627\u0645 \u0625\u0644\u064A\u0647\u0627 \u0645\u0646 \u0647\u0646\u0627.",
                text: "\u0645\u0627 \u0633\u064A\u062A\u064A\u062D\u0647 \u0627\u0644\u062A\u0628\u0648\u064A\u0628 \u0645\u0633\u062A\u0642\u0628\u0644\u0627\u064B: \u0628\u062F\u0621 \u0627\u062C\u062A\u0645\u0627\u0639 \u0641\u064A \u0627\u0644\u0641\u0636\u0627\u0621 \u0648\u0627\u0644\u0627\u0646\u0636\u0645\u0627\u0645 \u0625\u0644\u0649 \u0627\u0644\u0627\u062C\u062A\u0645\u0627\u0639\u0627\u062A \u0627\u0644\u062C\u0627\u0631\u064A\u0629."
              }
            }
          }
        }
      },
      people: {
        title: "\u0627\u0644\u0623\u0634\u062E\u0627\u0635",
        intro: "\u062A\u0628\u0648\u064A\u0628 \u0627\u0644\u0623\u0634\u062E\u0627\u0635 \u0641\u064A \u0641\u0636\u0627\u0621 \u0645\u0634\u062A\u0631\u0643: \u0643\u0644 \u0645\u0646 \u0644\u062F\u064A\u0647 \u0648\u0635\u0648\u0644 \u0625\u0644\u064A\u0647\u060C \u0645\u0646 \u0627\u0644\u0645\u0624\u0633\u0633\u0629 \u0627\u0644\u0645\u0633\u062A\u0636\u064A\u0641\u0629 \u0648\u0645\u0646 \u0627\u0644\u0645\u0624\u0633\u0633\u0627\u062A \u0627\u0644\u0634\u0631\u064A\u0643\u0629\u060C \u0645\u0639 \u0643\u064A\u0641\u064A\u0629 \u062F\u062E\u0648\u0644 \u0643\u0644 \u0634\u062E\u0635.",
        sections: {
          frame: {
            title: "\u0625\u0637\u0627\u0631 \u0627\u0644\u0641\u0636\u0627\u0621",
            items: {
              banner: {
                term: "\u0641\u0636\u0627\u0621 \u062E\u0627\u0631\u062C\u064A \u062A\u0633\u062A\u0636\u064A\u0641\u0647 \u2026",
                text: "\u0634\u0631\u064A\u0637 \u062F\u0627\u0626\u0645 \u064A\u0638\u0647\u0631 \u0639\u0646\u062F\u0645\u0627 \u064A\u062E\u0635 \u0627\u0644\u0641\u0636\u0627\u0621 \u0645\u0624\u0633\u0633\u0629 \u0623\u062E\u0631\u0649: \u064A\u0630\u0643\u0651\u0631\u0643 \u0628\u0623\u0646 \u0645\u062D\u062A\u0648\u0627\u0647 \u064A\u062E\u0636\u0639 \u0644\u0642\u0648\u0627\u0639\u062F \u062A\u0644\u0643 \u0627\u0644\u0645\u0624\u0633\u0633\u0629."
              },
              summary: {
                term: "\u062A\u0633\u062A\u0636\u064A\u0641\u0647 \u2026",
                text: "\u0634\u0631\u064A\u0637 \u062A\u062D\u062A \u0627\u0644\u0639\u0646\u0648\u0627\u0646: \u0627\u0644\u0645\u0624\u0633\u0633\u0629 \u0627\u0644\u062A\u064A \u062A\u0633\u062A\u0636\u064A\u0641 \u0627\u0644\u0641\u0636\u0627\u0621 \u0648\u0646\u0648\u0639\u0647 \u0648\u0634\u0627\u0631\u0629 \xAB\u0645\u063A\u0644\u0642\xBB \u0639\u0646\u062F\u0645\u0627 \u064A\u0643\u0648\u0646 \u0627\u0644\u0641\u0636\u0627\u0621 \u0645\u063A\u0644\u0642\u0627\u064B\u060C \u0648\u0641\u064A \u0627\u0644\u0641\u0636\u0627\u0621 \u0627\u0644\u062E\u0627\u0631\u062C\u064A \u0648\u0635\u0648\u0644\u0643: \u0643\u064A\u0641 \u062F\u062E\u0644\u062A \u0648\u0635\u0644\u0627\u062D\u064A\u0627\u062A\u0643 \u0648\u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0627\u0646\u062A\u0647\u0627\u0621."
              },
              guestNotice: {
                term: "\u064A\u0646\u062A\u0647\u064A \u0648\u0635\u0648\u0644\u0643 \u0643\u0636\u064A\u0641 \u0641\u064A \u2026",
                text: "\u0634\u0631\u064A\u0637 \u0645\u062E\u0635\u0635 \u0644\u0644\u0636\u064A\u0648\u0641: \u064A\u0639\u0637\u064A \u062A\u0627\u0631\u064A\u062E \u0627\u0646\u062A\u0647\u0627\u0621 \u0648\u0635\u0648\u0644\u0643. \u064A\u062A\u062D\u0648\u0644 \u0625\u0644\u0649 \u062A\u062D\u0630\u064A\u0631 \u062E\u0644\u0627\u0644 \u0622\u062E\u0631 14 \u064A\u0648\u0645\u0627\u064B."
              },
              tabs: {
                term: "\u0639\u0644\u0627\u0645\u0627\u062A \u0627\u0644\u062A\u0628\u0648\u064A\u0628",
                text: "\u0634\u0631\u064A\u0637 \u062A\u0628\u0648\u064A\u0628\u0627\u062A \u0627\u0644\u0641\u0636\u0627\u0621. \u0623\u0646\u062A \u0641\u064A \u062A\u0628\u0648\u064A\u0628 \xAB\u0627\u0644\u0623\u0634\u062E\u0627\u0635\xBB\u061B \u0644\u0627 \u062A\u0638\u0647\u0631 \u0625\u0644\u0627 \u0627\u0644\u062A\u0628\u0648\u064A\u0628\u0627\u062A \u0627\u0644\u062A\u064A \u064A\u062A\u064A\u062D \u0644\u0643 \u0648\u0635\u0648\u0644\u0643 \u0641\u062A\u062D\u0647\u0627."
              }
            }
          },
          list: {
            title: "\u0627\u0644\u0623\u0634\u062E\u0627\u0635 \u0627\u0644\u0630\u064A\u0646 \u0644\u062F\u064A\u0647\u0645 \u0648\u0635\u0648\u0644",
            items: {
              heading: {
                term: "\u0627\u0644\u0623\u0634\u062E\u0627\u0635 \u0627\u0644\u0630\u064A\u0646 \u0644\u062F\u064A\u0647\u0645 \u0648\u0635\u0648\u0644",
                text: "\u0643\u0644 \u0645\u0646 \u064A\u0635\u0644 \u0625\u0644\u0649 \u0627\u0644\u0641\u0636\u0627\u0621\u060C \u0645\u0639 \u0627\u0644\u0645\u0624\u0633\u0633\u0629 \u0627\u0644\u062A\u064A \u064A\u0645\u062B\u0644\u0647\u0627. \u0644\u062F\u0639\u0648\u0629 \u0634\u062E\u0635\u060C \u0627\u0633\u062A\u062E\u062F\u0645 \u062A\u0628\u0648\u064A\u0628 \xAB\u0627\u0644\u0645\u0624\u0633\u0633\u0627\u062A \u0627\u0644\u0634\u0631\u064A\u0643\u0629\xBB."
              },
              name: {
                term: "\u0627\u0633\u0645 \u0627\u0644\u0634\u062E\u0635",
                text: "\u0633\u0637\u0631 \u0644\u0643\u0644 \u0634\u062E\u0635\u060C \u0645\u0639 \u0634\u0627\u0631\u0629 \u062A\u0628\u064A\u0651\u0646 \u0643\u064A\u0641 \u062F\u062E\u0644: \xAB\u0639\u0636\u0648 \u0641\u064A \u0627\u0644\u0645\u0624\u0633\u0633\u0629 \u0627\u0644\u0645\u0633\u062A\u0636\u064A\u0641\u0629\xBB \u0623\u0648 \xAB\u0645\u0641\u0648\u064E\u0651\u0636 \u0645\u0646 \u0634\u0631\u064A\u0643\xBB \u0623\u0648 \xAB\u0645\u062F\u0639\u0648 \u0628\u0627\u0644\u0627\u0633\u0645\xBB \u0623\u0648 \xAB\u0636\u064A\u0641\xBB."
              },
              organisation: {
                term: "\u0627\u0644\u0645\u0624\u0633\u0633\u0629: \u2026",
                text: "\u0627\u0644\u0645\u0624\u0633\u0633\u0629 \u0627\u0644\u062A\u064A \u064A\u0635\u0644 \u0627\u0644\u0634\u062E\u0635 \u0625\u0644\u0649 \u0627\u0644\u0641\u0636\u0627\u0621 \u0628\u0627\u0633\u0645\u0647\u0627."
              },
              scope: {
                term: "\u0643\u0644 \u0627\u0644\u0641\u0636\u0627\u0621",
                text: "\u0645\u0627 \u064A\u0634\u0645\u0644\u0647 \u0648\u0635\u0648\u0644\u0647: \u0643\u0644 \u0627\u0644\u0641\u0636\u0627\u0621\u060C \u0623\u0648 \xAB\u0627\u0644\u0645\u062C\u0644\u062F\u0627\u062A: 2 \xB7 \u0627\u0644\u0642\u0646\u0648\u0627\u062A: 1\xBB \u0639\u0646\u062F\u0645\u0627 \u064A\u0642\u062A\u0635\u0631 \u0639\u0644\u0649 \u0645\u062C\u0644\u062F\u0627\u062A \u0648\u0642\u0646\u0648\u0627\u062A \u0645\u062E\u062A\u0627\u0631\u0629."
              },
              rights: {
                term: "\u0627\u0644\u0635\u0644\u0627\u062D\u064A\u0627\u062A: \u2026",
                text: "\xAB\u0644\u0644\u0642\u0631\u0627\u0621\u0629 \u0641\u0642\u0637\xBB \u0623\u0648 \xAB\u0627\u0644\u0642\u0631\u0627\u0621\u0629 \u0648\u0627\u0644\u0643\u062A\u0627\u0628\u0629\xBB \u0623\u0648 \xAB\u0627\u0644\u0642\u0631\u0627\u0621\u0629 \u0648\u0627\u0644\u0643\u062A\u0627\u0628\u0629 \u0648\u0627\u0644\u0645\u0635\u0627\u062F\u0642\u0629\xBB\u060C \u064A\u0644\u064A\u0647\u0627 \xAB\u062D\u062A\u0649 \u2026\xBB \u0623\u0648 \xAB\u0628\u062F\u0648\u0646 \u062A\u0627\u0631\u064A\u062E \u0627\u0646\u062A\u0647\u0627\u0621\xBB."
              }
            }
          },
          actions: {
            title: "\u0625\u062C\u0631\u0627\u0621\u0627\u062A \u0639\u0644\u0649 \u0634\u062E\u0635",
            items: {
              extend: {
                term: "\u062A\u0645\u062F\u064A\u062F 90 \u064A\u0648\u0645\u0627\u064B",
                text: "\u0644\u0644\u0636\u064A\u0641 \u0641\u0642\u0637\u060C \u0648\u0644\u0645\u0646 \u064A\u062F\u064A\u0631\u0648\u0646 \u0627\u0644\u0641\u0636\u0627\u0621: \u064A\u0624\u062E\u0631 \u0646\u0647\u0627\u064A\u0629 \u0648\u0635\u0648\u0644\u0647 90 \u064A\u0648\u0645\u0627\u064B. \u062A\u0624\u0643\u062F \u0631\u0633\u0627\u0644\u0629 \u0627\u0644\u062A\u0627\u0631\u064A\u062E \u0627\u0644\u062C\u062F\u064A\u062F."
              },
              remove: {
                term: "\u0633\u062D\u0628",
                text: "\u064A\u0633\u062D\u0628 \u0627\u0644\u0634\u062E\u0635 \u0645\u0646 \u0627\u0644\u0641\u0636\u0627\u0621 \u0628\u0639\u062F \u062A\u0623\u0643\u064A\u062F (\xAB\u0633\u062D\u0628 \u2026 \u0645\u0646 \u0627\u0644\u0641\u0636\u0627\u0621\u061F\xBB): \u064A\u062A\u0648\u0642\u0641 \u0648\u0635\u0648\u0644\u0647 \u0641\u0648\u0631\u0627\u064B. \u0644\u0627 \u064A\u0638\u0647\u0631 \u0627\u0644\u0632\u0631 \u0625\u0644\u0627 \u0625\u0630\u0627 \u0643\u0627\u0646\u062A \u0644\u0643 \u0635\u0644\u0627\u062D\u064A\u0629 \u0633\u062D\u0628\u0647\u060C \u0648\u0644\u0627 \u064A\u0638\u0647\u0631 \u0623\u0628\u062F\u0627\u064B \u0641\u064A \u0641\u0636\u0627\u0621 \u0645\u063A\u0644\u0642."
              }
            }
          },
          states: {
            title: "\u0639\u0646\u062F\u0645\u0627 \u0644\u0627 \u064A\u0648\u062C\u062F \u0634\u064A\u0621 \u0644\u0639\u0631\u0636\u0647",
            items: {
              empty: {
                term: "\u0644\u0627 \u0623\u062D\u062F \u0622\u062E\u0631 \u0644\u062F\u064A\u0647 \u0648\u0635\u0648\u0644 \u0625\u0644\u0649 \u0647\u0630\u0627 \u0627\u0644\u0641\u0636\u0627\u0621",
                text: "\u0631\u0633\u0627\u0644\u0629 \u062A\u0638\u0647\u0631 \u0645\u0627 \u062F\u0627\u0645 \u0644\u0645 \u064A\u062F\u062E\u0644 \u0623\u062D\u062F \u0622\u062E\u0631: \u0633\u064A\u0638\u0647\u0631 \u0647\u0646\u0627 \u0623\u0639\u0636\u0627\u0621 \u0627\u0644\u0645\u0624\u0633\u0633\u0629 \u0627\u0644\u0645\u0633\u062A\u0636\u064A\u0641\u0629 \u0648\u0645\u0641\u0648\u064E\u0651\u0636\u0648 \u0627\u0644\u0634\u0631\u0643\u0627\u0621 \u0648\u0627\u0644\u0636\u064A\u0648\u0641."
              },
              loadFailed: {
                term: "\u062A\u0639\u0630\u0651\u0631 \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0623\u0634\u062E\u0627\u0635",
                text: "\u0631\u0633\u0627\u0644\u0629 \u062D\u0645\u0631\u0627\u0621 \u062A\u0638\u0647\u0631 \u0625\u0630\u0627 \u0644\u0645 \u062A\u064F\u062D\u0645\u064E\u0651\u0644 \u0627\u0644\u0642\u0627\u0626\u0645\u0629. \u0627\u0633\u062A\u062E\u062F\u0645 \xAB\u0625\u0639\u0627\u062F\u0629 \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629\xBB \u0628\u0639\u062F \u0627\u0644\u062A\u062D\u0642\u0642 \u0645\u0646 \u0627\u062A\u0635\u0627\u0644\u0643."
              }
            }
          }
        }
      },
      partners: {
        title: "\u0627\u0644\u0645\u0624\u0633\u0633\u0627\u062A \u0627\u0644\u0634\u0631\u064A\u0643\u0629",
        intro: "\u062A\u0628\u0648\u064A\u0628 \u0627\u0644\u0645\u0624\u0633\u0633\u0627\u062A \u0627\u0644\u0634\u0631\u064A\u0643\u0629 \u0641\u064A \u0641\u0636\u0627\u0621 \u0645\u0634\u062A\u0631\u0643\u060C \u0645\u062E\u0635\u0635 \u0644\u0645\u0633\u0624\u0648\u0644\u064A \u0627\u0644\u0645\u0624\u0633\u0633\u0629 \u0627\u0644\u0645\u0633\u062A\u0636\u064A\u0641\u0629. \u064A\u064F\u0633\u062A\u0639\u0645\u0644 \u0644\u0645\u0634\u0627\u0631\u0643\u0629 \u0627\u0644\u0641\u0636\u0627\u0621 \u0645\u0639 \u0645\u0624\u0633\u0633\u0627\u062A \u0623\u062E\u0631\u0649 \u0648\u0644\u062F\u0639\u0648\u0629 \u0623\u0634\u062E\u0627\u0635 \u0648\u0644\u0645\u062A\u0627\u0628\u0639\u0629 \u0627\u0644\u062F\u0639\u0648\u0627\u062A \u0627\u0644\u0645\u0639\u0644\u0651\u0642\u0629.",
        sections: {
          frame: {
            title: "\u0625\u0637\u0627\u0631 \u0627\u0644\u0641\u0636\u0627\u0621",
            items: {
              banner: {
                term: "\u0641\u0636\u0627\u0621 \u062E\u0627\u0631\u062C\u064A \u062A\u0633\u062A\u0636\u064A\u0641\u0647 \u2026",
                text: "\u0634\u0631\u064A\u0637 \u062F\u0627\u0626\u0645 \u064A\u0638\u0647\u0631 \u0639\u0646\u062F\u0645\u0627 \u064A\u062E\u0635 \u0627\u0644\u0641\u0636\u0627\u0621 \u0645\u0624\u0633\u0633\u0629 \u0623\u062E\u0631\u0649: \u064A\u0630\u0643\u0651\u0631\u0643 \u0628\u0623\u0646 \u0645\u062D\u062A\u0648\u0627\u0647 \u064A\u062E\u0636\u0639 \u0644\u0642\u0648\u0627\u0639\u062F \u062A\u0644\u0643 \u0627\u0644\u0645\u0624\u0633\u0633\u0629."
              },
              summary: {
                term: "\u062A\u0633\u062A\u0636\u064A\u0641\u0647 \u2026",
                text: "\u0634\u0631\u064A\u0637 \u062A\u062D\u062A \u0627\u0644\u0639\u0646\u0648\u0627\u0646: \u0627\u0644\u0645\u0624\u0633\u0633\u0629 \u0627\u0644\u062A\u064A \u062A\u0633\u062A\u0636\u064A\u0641 \u0627\u0644\u0641\u0636\u0627\u0621 \u0648\u0646\u0648\u0639\u0647 \u0648\u0634\u0627\u0631\u0629 \xAB\u0645\u063A\u0644\u0642\xBB \u0639\u0646\u062F\u0645\u0627 \u064A\u0643\u0648\u0646 \u0627\u0644\u0641\u0636\u0627\u0621 \u0645\u063A\u0644\u0642\u0627\u064B\u060C \u0648\u0641\u064A \u0627\u0644\u0641\u0636\u0627\u0621 \u0627\u0644\u062E\u0627\u0631\u062C\u064A \u0648\u0635\u0648\u0644\u0643: \u0643\u064A\u0641 \u062F\u062E\u0644\u062A \u0648\u0635\u0644\u0627\u062D\u064A\u0627\u062A\u0643 \u0648\u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0627\u0646\u062A\u0647\u0627\u0621."
              },
              tabs: {
                term: "\u0639\u0644\u0627\u0645\u0627\u062A \u0627\u0644\u062A\u0628\u0648\u064A\u0628",
                text: "\u0634\u0631\u064A\u0637 \u062A\u0628\u0648\u064A\u0628\u0627\u062A \u0627\u0644\u0641\u0636\u0627\u0621. \u0623\u0646\u062A \u0641\u064A \u062A\u0628\u0648\u064A\u0628 \xAB\u0627\u0644\u0645\u0624\u0633\u0633\u0627\u062A \u0627\u0644\u0634\u0631\u064A\u0643\u0629\xBB\u061B \u0644\u0627 \u062A\u0638\u0647\u0631 \u0625\u0644\u0627 \u0627\u0644\u062A\u0628\u0648\u064A\u0628\u0627\u062A \u0627\u0644\u062A\u064A \u064A\u062A\u064A\u062D \u0644\u0643 \u0648\u0635\u0648\u0644\u0643 \u0641\u062A\u062D\u0647\u0627."
              }
            }
          },
          partnersList: {
            title: "\u0627\u0644\u0645\u0624\u0633\u0633\u0627\u062A \u0627\u0644\u0634\u0631\u064A\u0643\u0629",
            items: {
              heading: {
                term: "\u0627\u0644\u0645\u0624\u0633\u0633\u0627\u062A \u0627\u0644\u0634\u0631\u064A\u0643\u0629",
                text: "\u0627\u0644\u0645\u0624\u0633\u0633\u0627\u062A \u0627\u0644\u062A\u064A \u064A\u064F\u0634\u0627\u0631\u064E\u0643 \u0645\u0639\u0647\u0627 \u0627\u0644\u0641\u0636\u0627\u0621\u060C \u0648\u0645\u0627 \u064A\u0645\u0643\u0646\u0647\u0627 \u0627\u0644\u0648\u0635\u0648\u0644 \u0625\u0644\u064A\u0647 \u0648\u0639\u062F\u062F \u0627\u0644\u0623\u0634\u062E\u0627\u0635 \u0627\u0644\u0630\u064A\u0646 \u0623\u0636\u0627\u0641\u062A\u0647\u0645."
              },
              share: {
                term: "\u0627\u0644\u0645\u0634\u0627\u0631\u0643\u0629 \u0645\u0639 \u0645\u0624\u0633\u0633\u0629",
                text: "\u064A\u0641\u062A\u062D \u0646\u0627\u0641\u0630\u0629 \u062F\u0639\u0648\u0629 \u0645\u0624\u0633\u0633\u0629. \u063A\u064A\u0631 \u0645\u062A\u0627\u062D \u0641\u064A \u0641\u0636\u0627\u0621 \u0645\u063A\u0644\u0642."
              },
              status: {
                term: "\u0628\u0627\u0646\u062A\u0638\u0627\u0631 \u0627\u0644\u0631\u062F",
                text: "\u0634\u0627\u0631\u0629 \u062D\u0627\u0644\u0629 \u0627\u0644\u0645\u0624\u0633\u0633\u0629: \xAB\u0628\u0627\u0646\u062A\u0638\u0627\u0631 \u0627\u0644\u0631\u062F\xBB \u0623\u0648 \xAB\u0646\u0634\u0637\u0629\xBB \u0623\u0648 \xAB\u0645\u0631\u0641\u0648\u0636\u0629\xBB \u0623\u0648 \xAB\u0645\u0646\u062A\u0647\u064A\u0629\xBB \u0623\u0648 \xAB\u0645\u0633\u062D\u0648\u0628\u0629\xBB. \u062A\u064F\u0639\u0631\u0636 \u0627\u0644\u0637\u0644\u0628\u0627\u062A \u0627\u0644\u0645\u0639\u0644\u0651\u0642\u0629 \u0623\u0648\u0644\u0627\u064B."
              },
              details: {
                term: "\u0627\u0644\u0623\u0634\u062E\u0627\u0635: \u2066x/y\u2069",
                text: "\u062A\u062D\u062A \u0627\u0644\u0627\u0633\u0645: \u0645\u0627 \u064A\u0645\u0643\u0646 \u0644\u0644\u0645\u0624\u0633\u0633\u0629 \u0627\u0644\u0648\u0635\u0648\u0644 \u0625\u0644\u064A\u0647 (\xAB\u0643\u0644 \u0627\u0644\u0641\u0636\u0627\u0621\xBB \u0623\u0648 \u0645\u062C\u0644\u062F\u0627\u062A \u0648\u0642\u0646\u0648\u0627\u062A \u0645\u062E\u062A\u0627\u0631\u0629) \u0648\u0635\u0644\u0627\u062D\u064A\u0627\u062A\u0647\u0627 \u0648\u0639\u062F\u062F \u0627\u0644\u0623\u0634\u062E\u0627\u0635 \u0627\u0644\u0630\u064A\u0646 \u0623\u0636\u0627\u0641\u062A\u0647\u0645 \u0645\u0646 \u0627\u0644\u062D\u062F \u0627\u0644\u0623\u0642\u0635\u0649 \u0627\u0644\u0645\u0633\u0645\u0648\u062D \u0628\u0647\u060C \u0648\xAB\u062D\u062A\u0649 \u2026\xBB \u0623\u0648 \xAB\u0628\u062F\u0648\u0646 \u062A\u0627\u0631\u064A\u062E \u0627\u0646\u062A\u0647\u0627\u0621\xBB."
              },
              remove: {
                term: "\u0633\u062D\u0628",
                text: "\u064A\u0633\u062D\u0628 \u0627\u0644\u0645\u0624\u0633\u0633\u0629\u060C \u0623\u0648 \u064A\u0633\u062D\u0628 \u0637\u0644\u0628\u0627\u064B \u0644\u0627 \u064A\u0632\u0627\u0644 \u0645\u0639\u0644\u0651\u0642\u0627\u064B\u060C \u0628\u0639\u062F \u062A\u0623\u0643\u064A\u062F. \u064A\u062A\u0648\u0642\u0641 \u0648\u0635\u0648\u0644 \u062C\u0645\u064A\u0639 \u0623\u0634\u062E\u0627\u0635 \u062A\u0644\u0643 \u0627\u0644\u0645\u0624\u0633\u0633\u0629 \u0641\u0648\u0631\u0627\u064B\u061B \u0648\u064A\u0645\u0643\u0646\u0643 \u062F\u0639\u0648\u062A\u0647\u0627 \u0645\u062C\u062F\u062F\u0627\u064B."
              },
              empty: {
                term: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0645\u0624\u0633\u0633\u0629 \u0634\u0631\u064A\u0643\u0629",
                text: "\u0631\u0633\u0627\u0644\u0629 \u062A\u0638\u0647\u0631 \u0645\u0627 \u062F\u0627\u0645 \u0627\u0644\u0641\u0636\u0627\u0621 \u063A\u064A\u0631 \u0645\u0634\u062A\u0631\u0643 \u0645\u0639 \u0623\u062D\u062F. \u0633\u062A\u062E\u062A\u0627\u0631 \u0627\u0644\u0645\u0624\u0633\u0633\u0629 \u0627\u0644\u0645\u062F\u0639\u0648\u0629 \u0628\u0646\u0641\u0633\u0647\u0627 \u0627\u0644\u0623\u0634\u062E\u0627\u0635 \u0627\u0644\u0630\u064A\u0646 \u064A\u0635\u0644\u0648\u0646 \u0625\u0644\u064A\u0647."
              }
            }
          },
          invitations: {
            title: "\u0627\u0644\u062F\u0639\u0648\u0627\u062A \u0627\u0644\u0645\u0639\u0644\u0651\u0642\u0629",
            items: {
              heading: {
                term: "\u0627\u0644\u062F\u0639\u0648\u0627\u062A \u0627\u0644\u0645\u0639\u0644\u0651\u0642\u0629",
                text: "\u0627\u0644\u0623\u0634\u062E\u0627\u0635 \u0627\u0644\u0645\u062F\u0639\u0648\u0648\u0646 \u0639\u0628\u0631 \u0627\u0644\u0628\u0631\u064A\u062F \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A \u0627\u0644\u0630\u064A\u0646 \u0644\u0645 \u064A\u0631\u062F\u0651\u0648\u0627 \u0628\u0639\u062F."
              },
              invite: {
                term: "\u062F\u0639\u0648\u0629 \u0634\u062E\u0635",
                text: "\u064A\u0641\u062A\u062D \u0646\u0627\u0641\u0630\u0629 \u062F\u0639\u0648\u0629 \u0634\u062E\u0635. \u063A\u064A\u0631 \u0645\u062A\u0627\u062D \u0641\u064A \u0641\u0636\u0627\u0621 \u0645\u063A\u0644\u0642."
              },
              row: {
                term: "\u0627\u0644\u0628\u0631\u064A\u062F \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A \u0648\u0627\u0644\u062D\u0627\u0644\u0629",
                text: "\u064A\u0639\u0631\u0636 \u0643\u0644 \u0633\u0637\u0631 \u0627\u0644\u0639\u0646\u0648\u0627\u0646 \u0627\u0644\u0645\u062F\u0639\u0648 \u0648\u0634\u0627\u0631\u0629 \u062D\u0627\u0644\u0629 (\xAB\u0628\u0627\u0646\u062A\u0638\u0627\u0631 \u0627\u0644\u0631\u062F\xBB \u0623\u0648 \xAB\u0628\u0627\u0646\u062A\u0638\u0627\u0631 \u0645\u0648\u0627\u0641\u0642\u0629 \u0645\u0624\u0633\u0633\u062A\u0647\xBB) \u0648\u0646\u0648\u0639 \u0627\u0644\u062F\u0639\u0648\u0629 (\xAB\u0634\u062E\u0635 \u0645\u0633\u0645\u0651\u0649\xBB \u0623\u0648 \xAB\u0636\u064A\u0641\xBB)."
              },
              details: {
                term: "\u0644\u0644\u0631\u062F \u0642\u0628\u0644 \u2026",
                text: "\u0645\u0627 \u064A\u0634\u0645\u0644\u0647 \u0627\u0644\u0648\u0635\u0648\u0644 \u0648\u0627\u0644\u0635\u0644\u0627\u062D\u064A\u0627\u062A \u0648\u0622\u062E\u0631 \u0623\u062C\u0644 \u0644\u0631\u062F \u0627\u0644\u0634\u062E\u0635 \u0627\u0644\u0645\u062F\u0639\u0648."
              },
              cancel: {
                term: "\u0625\u0644\u063A\u0627\u0621",
                text: "\u064A\u0644\u063A\u064A \u0627\u0644\u062F\u0639\u0648\u0629 \u0628\u0639\u062F \u062A\u0623\u0643\u064A\u062F: \u0644\u0646 \u064A\u062A\u0645\u0643\u0646 \u0627\u0644\u0634\u062E\u0635 \u0645\u0646 \u0627\u0633\u062A\u0639\u0645\u0627\u0644 \u0627\u0644\u0631\u0627\u0628\u0637 \u0627\u0644\u0630\u064A \u062A\u0644\u0642\u0627\u0647. \u0648\u064A\u0645\u0643\u0646\u0643 \u062F\u0639\u0648\u062A\u0647 \u0645\u0646 \u062C\u062F\u064A\u062F."
              },
              empty: {
                term: "\u0644\u0627 \u062A\u0648\u062C\u062F \u062F\u0639\u0648\u0627\u062A \u0645\u0639\u0644\u0651\u0642\u0629",
                text: "\u0631\u0633\u0627\u0644\u0629 \u062A\u0638\u0647\u0631 \u0639\u0646\u062F\u0645\u0627 \u0644\u0627 \u062A\u0646\u062A\u0638\u0631 \u0623\u064A \u062F\u0639\u0648\u0629 \u0631\u062F\u0651\u0627\u064B."
              }
            }
          },
          shareDialog: {
            title: "\u0646\u0627\u0641\u0630\u0629 \xAB\u0627\u0644\u0645\u0634\u0627\u0631\u0643\u0629 \u0645\u0639 \u0645\u0624\u0633\u0633\u0629\xBB",
            items: {
              taxId: {
                term: "\u0627\u0644\u0645\u0639\u0631\u0651\u0641 \u0627\u0644\u062C\u0628\u0627\u0626\u064A \u0644\u0644\u0645\u0624\u0633\u0633\u0629",
                text: "\u0623\u062F\u062E\u0644 \u0627\u0644\u0645\u0639\u0631\u0651\u0641 \u0627\u0644\u062C\u0628\u0627\u0626\u064A. \u064A\u0638\u0647\u0631 \u0627\u0633\u0645 \u0627\u0644\u0645\u0624\u0633\u0633\u0629 \u0627\u0644\u062A\u064A \u0646\u062C\u062F\u0647\u0627 \u0644\u062A\u062A\u062D\u0642\u0642 \u0645\u0646 \u0623\u0646\u0647\u0627 \u0627\u0644\u0645\u0637\u0644\u0648\u0628\u0629\u061B \u0648\u0625\u0644\u0627 \u062A\u0642\u0648\u0644 \u0631\u0633\u0627\u0644\u0629 \u0625\u0646\u0647 \u0644\u0627 \u062A\u0648\u062C\u062F \u0645\u0624\u0633\u0633\u0629 \u0639\u0644\u0649 \u2066BatiFlow\u2069 \u0628\u0647\u0630\u0627 \u0627\u0644\u0645\u0639\u0631\u0651\u0641."
              },
              scope: {
                term: "\u0645\u0627 \u064A\u0634\u0645\u0644\u0647 \u0627\u0644\u0648\u0635\u0648\u0644",
                text: "\xAB\u0643\u0644 \u0627\u0644\u0641\u0636\u0627\u0621\xBB \u0623\u0648 \xAB\u0645\u062C\u0644\u062F\u0627\u062A \u0648\u0642\u0646\u0648\u0627\u062A \u0645\u062E\u062A\u0627\u0631\u0629 \u0641\u0642\u0637\xBB: \u062A\u062D\u062F\u062F \u0639\u0646\u062F\u0626\u0630 \u0627\u0644\u0645\u062C\u0644\u062F\u0627\u062A (\u0627\u062E\u062A\u064A\u0627\u0631 \u0645\u062C\u0644\u062F \u064A\u0645\u0646\u062D \u0627\u0644\u0648\u0635\u0648\u0644 \u0623\u064A\u0636\u0627\u064B \u0625\u0644\u0649 \u0645\u062C\u0644\u062F\u0627\u062A\u0647 \u0627\u0644\u0641\u0631\u0639\u064A\u0629) \u0648\u0627\u0644\u0642\u0646\u0648\u0627\u062A."
              },
              rights: {
                term: "\u0627\u0644\u0635\u0644\u0627\u062D\u064A\u0627\u062A",
                text: "\u0627\u0644\u0642\u0631\u0627\u0621\u0629 (\u0627\u0644\u0627\u0637\u0644\u0627\u0639 \u0639\u0644\u0649 \u0627\u0644\u0645\u0633\u062A\u0646\u062F\u0627\u062A \u0648\u0627\u0644\u0645\u062D\u0627\u062F\u062B\u0627\u062A) \u0623\u0648 \u0627\u0644\u0643\u062A\u0627\u0628\u0629 (\u0627\u0644\u0627\u0637\u0644\u0627\u0639 \u0648\u0627\u0644\u0625\u0636\u0627\u0641\u0629 \u0648\u0627\u0644\u062A\u0639\u062F\u064A\u0644) \u0623\u0648 \u0627\u0644\u0643\u062A\u0627\u0628\u0629 \u0648\u0627\u0644\u0645\u0635\u0627\u062F\u0642\u0629 (\u0645\u0639 \u0627\u0644\u0645\u0635\u0627\u062F\u0642\u0629 \u0639\u0644\u0649 \u0627\u0644\u0645\u0633\u062A\u0646\u062F\u0627\u062A)."
              },
              cap: {
                term: "\u0627\u0644\u062D\u062F \u0627\u0644\u0623\u0642\u0635\u0649 \u0644\u0639\u062F\u062F \u0627\u0644\u0623\u0634\u062E\u0627\u0635",
                text: "\u0639\u062F\u062F \u0627\u0644\u0623\u0634\u062E\u0627\u0635 \u0627\u0644\u0630\u064A\u0646 \u064A\u0645\u0643\u0646 \u0644\u0644\u0645\u0624\u0633\u0633\u0629 \u0625\u0636\u0627\u0641\u062A\u0647\u0645 \u0625\u0644\u0649 \u0627\u0644\u0641\u0636\u0627\u0621\u060C \u0645\u0646 1 \u0625\u0644\u0649 500."
              },
              end: {
                term: "\u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0627\u0646\u062A\u0647\u0627\u0621 (\u0627\u062E\u062A\u064A\u0627\u0631\u064A)",
                text: "\u0627\u062A\u0631\u0643\u0647 \u0641\u0627\u0631\u063A\u0627\u064B: \u064A\u0633\u062A\u0645\u0631 \u0627\u0644\u0648\u0635\u0648\u0644 \u0625\u0644\u0649 \u0623\u0646 \u062A\u0633\u062D\u0628\u0647."
              },
              submit: {
                term: "\u0625\u0631\u0633\u0627\u0644 \u0627\u0644\u062F\u0639\u0648\u0629",
                text: "\u064A\u0631\u0633\u0644 \u0627\u0644\u062F\u0639\u0648\u0629. \u0639\u0644\u0649 \u0627\u0644\u0645\u0624\u0633\u0633\u0629 \u0623\u0646 \u062A\u0642\u0628\u0644\u0647\u0627\u060C \u062B\u0645 \u064A\u062E\u062A\u0627\u0631 \u0645\u0633\u0624\u0648\u0644\u0648\u0647\u0627 \u0645\u0646 \u064A\u0635\u0644 \u0625\u0644\u0649 \u0627\u0644\u0641\u0636\u0627\u0621. \u0642\u062F \u064A\u064F\u0637\u0644\u0628 \u0645\u0646\u0643 \u062A\u0623\u0643\u064A\u062F \u0647\u0648\u064A\u062A\u0643 \u0642\u0628\u0644 \u0627\u0644\u0625\u0631\u0633\u0627\u0644."
              }
            }
          },
          inviteDialog: {
            title: "\u0646\u0627\u0641\u0630\u0629 \xAB\u062F\u0639\u0648\u0629 \u0634\u062E\u0635\xBB",
            items: {
              email: {
                term: "\u0627\u0644\u0628\u0631\u064A\u062F \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A",
                text: "\u0639\u0646\u0648\u0627\u0646 \u0627\u0644\u0634\u062E\u0635 \u0627\u0644\u0645\u0631\u0627\u062F \u062F\u0639\u0648\u062A\u0647. \u062A\u064F\u0631\u0633\u0644 \u0627\u0644\u062F\u0639\u0648\u0629 \u0625\u0644\u064A\u0647 \u0648\u0644\u0627 \u064A\u0638\u0647\u0631 \u0627\u0644\u0639\u0646\u0648\u0627\u0646 \u0623\u0628\u062F\u0627\u064B \u0641\u064A \u0627\u0644\u0631\u0627\u0628\u0637."
              },
              kind: {
                term: "\u0646\u0648\u0639 \u0627\u0644\u062F\u0639\u0648\u0629",
                text: "\xAB\u0634\u062E\u0635 \u0645\u0633\u0645\u0651\u0649\xBB: \u0634\u062E\u0635 \u0645\u0646 \u0645\u0624\u0633\u0633\u0629 \u0623\u062E\u0631\u0649\u060C \u0628\u0627\u0644\u0648\u0635\u0648\u0644 \u0648\u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0627\u0646\u062A\u0647\u0627\u0621 \u0627\u0644\u0644\u0630\u064A\u0646 \u062A\u062E\u062A\u0627\u0631\u0647\u0645\u0627\u061B \u0648\u0642\u062F \u062A\u062D\u062A\u0627\u062C \u0645\u0624\u0633\u0633\u062A\u0647 \u0625\u0644\u0649 \u0627\u0644\u0645\u0648\u0627\u0641\u0642\u0629. \xAB\u0636\u064A\u0641\xBB: \u0634\u062E\u0635 \u0628\u0644\u0627 \u062D\u0633\u0627\u0628 \u0639\u0644\u0649 \u2066BatiFlow\u2069\u060C \u064A\u0642\u062A\u0635\u0631 \u0639\u0644\u0649 \u0645\u062C\u0644\u062F\u0627\u062A \u0623\u0648 \u0642\u0646\u0648\u0627\u062A \u0645\u062E\u062A\u0627\u0631\u0629."
              },
              scope: {
                term: "\u0645\u0627 \u064A\u0634\u0645\u0644\u0647 \u0627\u0644\u0648\u0635\u0648\u0644",
                text: "\u0643\u0645\u0627 \u0641\u064A \u0627\u0644\u0645\u0624\u0633\u0633\u0629. \u0644\u0627 \u064A\u062D\u0635\u0644 \u0627\u0644\u0636\u064A\u0641 \u0623\u0628\u062F\u0627\u064B \u0639\u0644\u0649 \xAB\u0643\u0644 \u0627\u0644\u0641\u0636\u0627\u0621\xBB: \u0627\u062E\u062A\u0631 \u0645\u062C\u0644\u062F\u0627\u064B \u0623\u0648 \u0642\u0646\u0627\u0629 \u0639\u0644\u0649 \u0627\u0644\u0623\u0642\u0644."
              },
              rights: {
                term: "\u0627\u0644\u0635\u0644\u0627\u062D\u064A\u0627\u062A",
                text: "\u0627\u0644\u0642\u0631\u0627\u0621\u0629 \u0623\u0648 \u0627\u0644\u0643\u062A\u0627\u0628\u0629 \u0623\u0648 \u0627\u0644\u0643\u062A\u0627\u0628\u0629 \u0648\u0627\u0644\u0645\u0635\u0627\u062F\u0642\u0629\u060C \u0643\u0645\u0627 \u0641\u064A \u0627\u0644\u0645\u0624\u0633\u0633\u0629."
              },
              end: {
                term: "\u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0627\u0646\u062A\u0647\u0627\u0621 (\u0627\u062E\u062A\u064A\u0627\u0631\u064A)",
                text: "\u0644\u0644\u0634\u062E\u0635 \u0627\u0644\u0645\u0633\u0645\u0651\u0649 \u0641\u0642\u0637. \u064A\u062D\u062A\u0641\u0638 \u0627\u0644\u0636\u064A\u0641 \u0628\u0648\u0635\u0648\u0644\u0647 90 \u064A\u0648\u0645\u0627\u064B\u061B \u0648\u064A\u0645\u0643\u0646\u0643 \u0628\u0639\u062F \u0630\u0644\u0643 \u062A\u0645\u062F\u064A\u062F\u0647 90 \u064A\u0648\u0645\u0627\u064B \u0645\u0646 \u062A\u0628\u0648\u064A\u0628 \xAB\u0627\u0644\u0623\u0634\u062E\u0627\u0635\xBB."
              },
              submit: {
                term: "\u0625\u0631\u0633\u0627\u0644 \u0627\u0644\u062F\u0639\u0648\u0629",
                text: "\u064A\u0631\u0633\u0644 \u0627\u0644\u062F\u0639\u0648\u0629\u060C \u0623\u0648 \u064A\u0633\u062C\u0644\u0647\u0627 \u0628\u0627\u0646\u062A\u0638\u0627\u0631 \u0645\u0648\u0627\u0641\u0642\u0629 \u0645\u0624\u0633\u0633\u0629 \u0627\u0644\u0634\u062E\u0635. \u0625\u0630\u0627 \u0644\u0645 \u064A\u0639\u062F \u0627\u0634\u062A\u0631\u0627\u0643\u0643 \u064A\u062A\u064A\u062D \u062F\u0639\u0648\u0629 \u0636\u064A\u0648\u0641\u060C \u062A\u0634\u0631\u062D \u0631\u0633\u0627\u0644\u0629 \u0630\u0644\u0643."
              }
            }
          }
        }
      },
      delegates: {
        title: "\u0645\u0646\u062F\u0648\u0628\u0648 \u0645\u0624\u0633\u0633\u062A\u064A",
        intro: "\u062A\u0628\u0648\u064A\u0628 \u0645\u0646\u062F\u0648\u0628\u0648 \u0645\u0624\u0633\u0633\u062A\u064A \u0641\u064A \u0641\u0636\u0627\u0621 \u0645\u0634\u062A\u0631\u0643\u060C \u0645\u062E\u0635\u0635 \u0644\u0645\u0633\u0624\u0648\u0644 \u0645\u0624\u0633\u0633\u0629 \u0634\u0631\u064A\u0643\u0629. \u064A\u064F\u0633\u062A\u0639\u0645\u0644 \u0644\u0627\u062E\u062A\u064A\u0627\u0631 \u0645\u0646 \u064A\u0635\u0644 \u0625\u0644\u0649 \u0627\u0644\u0641\u0636\u0627\u0621 \u0645\u0646 \u0628\u064A\u0646 \u0623\u0639\u0636\u0627\u0621 \u0645\u0624\u0633\u0633\u062A\u0643\u060C \u0636\u0645\u0646 \u062D\u062F\u0648\u062F \u0634\u0631\u0627\u0643\u062A\u0643\u0645.",
        sections: {
          frame: {
            title: "\u0625\u0637\u0627\u0631 \u0627\u0644\u0641\u0636\u0627\u0621",
            items: {
              banner: {
                term: "\u0641\u0636\u0627\u0621 \u062E\u0627\u0631\u062C\u064A \u062A\u0633\u062A\u0636\u064A\u0641\u0647 \u2026",
                text: "\u0634\u0631\u064A\u0637 \u062F\u0627\u0626\u0645 \u064A\u0638\u0647\u0631 \u0639\u0646\u062F\u0645\u0627 \u064A\u062E\u0635 \u0627\u0644\u0641\u0636\u0627\u0621 \u0645\u0624\u0633\u0633\u0629 \u0623\u062E\u0631\u0649: \u064A\u0630\u0643\u0651\u0631\u0643 \u0628\u0623\u0646 \u0645\u062D\u062A\u0648\u0627\u0647 \u064A\u062E\u0636\u0639 \u0644\u0642\u0648\u0627\u0639\u062F \u062A\u0644\u0643 \u0627\u0644\u0645\u0624\u0633\u0633\u0629."
              },
              summary: {
                term: "\u062A\u0633\u062A\u0636\u064A\u0641\u0647 \u2026",
                text: "\u0634\u0631\u064A\u0637 \u062A\u062D\u062A \u0627\u0644\u0639\u0646\u0648\u0627\u0646: \u0627\u0644\u0645\u0624\u0633\u0633\u0629 \u0627\u0644\u062A\u064A \u062A\u0633\u062A\u0636\u064A\u0641 \u0627\u0644\u0641\u0636\u0627\u0621 \u0648\u0646\u0648\u0639\u0647 \u0648\u0634\u0627\u0631\u0629 \xAB\u0645\u063A\u0644\u0642\xBB \u0639\u0646\u062F\u0645\u0627 \u064A\u0643\u0648\u0646 \u0627\u0644\u0641\u0636\u0627\u0621 \u0645\u063A\u0644\u0642\u0627\u064B\u060C \u0648\u0648\u0635\u0648\u0644\u0643: \u0643\u064A\u0641 \u062F\u062E\u0644\u062A \u0648\u0635\u0644\u0627\u062D\u064A\u0627\u062A\u0643 \u0648\u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0627\u0646\u062A\u0647\u0627\u0621."
              },
              tabs: {
                term: "\u0639\u0644\u0627\u0645\u0627\u062A \u0627\u0644\u062A\u0628\u0648\u064A\u0628",
                text: "\u0634\u0631\u064A\u0637 \u062A\u0628\u0648\u064A\u0628\u0627\u062A \u0627\u0644\u0641\u0636\u0627\u0621. \u0623\u0646\u062A \u0641\u064A \u062A\u0628\u0648\u064A\u0628 \xAB\u0645\u0646\u062F\u0648\u0628\u0648 \u0645\u0624\u0633\u0633\u062A\u064A\xBB\u061B \u0644\u0627 \u062A\u0638\u0647\u0631 \u0625\u0644\u0627 \u0627\u0644\u062A\u0628\u0648\u064A\u0628\u0627\u062A \u0627\u0644\u062A\u064A \u064A\u062A\u064A\u062D \u0644\u0643 \u0648\u0635\u0648\u0644\u0643 \u0641\u062A\u062D\u0647\u0627."
              }
            }
          },
          list: {
            title: "\u0625\u062F\u0627\u0631\u0629 \u0645\u0646\u062F\u0648\u0628\u064A \u0645\u0624\u0633\u0633\u062A\u064A",
            items: {
              heading: {
                term: "\u0625\u062F\u0627\u0631\u0629 \u0645\u0646\u062F\u0648\u0628\u064A \u0645\u0624\u0633\u0633\u062A\u064A",
                text: "\u0623\u0634\u062E\u0627\u0635 \u0645\u0624\u0633\u0633\u062A\u0643 \u0627\u0644\u0630\u064A\u0646 \u064A\u0635\u0644\u0648\u0646 \u0625\u0644\u0649 \u0647\u0630\u0627 \u0627\u0644\u0641\u0636\u0627\u0621. \u0623\u0646\u062A \u062A\u062E\u062A\u0627\u0631 \u0645\u0646 \u064A\u0635\u0644\u060C \u0636\u0645\u0646 \u0645\u0627 \u062A\u0633\u0645\u062D \u0628\u0647 \u0634\u0631\u0627\u0643\u062A\u0643\u0645."
              },
              usage: {
                term: "\u0627\u0644\u0623\u0634\u062E\u0627\u0635 \u0627\u0644\u0645\u0636\u0627\u0641\u0648\u0646: \u2066x/y\u2069",
                text: "\u0639\u062F\u062F \u0627\u0644\u0623\u0634\u062E\u0627\u0635 \u0627\u0644\u0630\u064A\u0646 \u0623\u0636\u0641\u062A\u0647\u0645 \u0645\u0646 \u0627\u0644\u062D\u062F \u0627\u0644\u0623\u0642\u0635\u0649 \u0627\u0644\u0630\u064A \u062A\u062D\u062F\u062F\u0647 \u0634\u0631\u0627\u0643\u062A\u0643\u0645."
              },
              capReached: {
                term: "\u0628\u0644\u063A\u062A\u064E \u0627\u0644\u062D\u062F \u0627\u0644\u0623\u0642\u0635\u0649 \u0644\u0639\u062F\u062F \u0627\u0644\u0623\u0634\u062E\u0627\u0635 \u0641\u064A \u0634\u0631\u0627\u0643\u062A\u0643\u0645",
                text: "\u062A\u062D\u0630\u064A\u0631 \u064A\u0638\u0647\u0631 \u0639\u0646\u062F \u0628\u0644\u0648\u063A \u0627\u0644\u062D\u062F \u0627\u0644\u0623\u0642\u0635\u0649. \u0627\u0633\u062D\u0628 \u0623\u062D\u062F \u0627\u0644\u0645\u0646\u062F\u0648\u0628\u064A\u0646 \u0623\u0648 \u0627\u0637\u0644\u0628 \u0645\u0646 \u0627\u0644\u0645\u0624\u0633\u0633\u0629 \u0627\u0644\u0645\u0633\u062A\u0636\u064A\u0641\u0629 \u0631\u0641\u0639 \u0627\u0644\u062D\u062F."
              },
              add: {
                term: "\u0625\u0636\u0627\u0641\u0629 \u0639\u0636\u0648",
                text: "\u064A\u0641\u062A\u062D \u0646\u0627\u0641\u0630\u0629 \u0625\u0636\u0627\u0641\u0629 \u0623\u0634\u062E\u0627\u0635. \u064A\u062E\u062A\u0641\u064A \u0627\u0644\u0632\u0631 \u0625\u0630\u0627 \u0644\u0645 \u062A\u0643\u0646 \u0627\u0644\u0634\u0631\u0627\u0643\u0629 \u0646\u0634\u0637\u0629 \u0623\u0648 \u0628\u0644\u063A \u0627\u0644\u0639\u062F\u062F \u0627\u0644\u062D\u062F \u0627\u0644\u0623\u0642\u0635\u0649 \u0623\u0648 \u0643\u0627\u0646 \u0627\u0644\u0641\u0636\u0627\u0621 \u0645\u063A\u0644\u0642\u0627\u064B."
              },
              row: {
                term: "\u0627\u0633\u0645 \u0627\u0644\u0645\u0646\u062F\u0648\u0628",
                text: "\u0633\u0637\u0631 \u0644\u0643\u0644 \u0634\u062E\u0635: \u0627\u0633\u0645\u0647 \u0648\u0634\u0627\u0631\u0629 \u062A\u0628\u064A\u0651\u0646 \u0643\u064A\u0641 \u062F\u062E\u0644 \u0648\u0645\u0627 \u064A\u0634\u0645\u0644\u0647 \u0648\u0635\u0648\u0644\u0647 \u0648\u0635\u0644\u0627\u062D\u064A\u0627\u062A\u0647 \u0648\u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0627\u0646\u062A\u0647\u0627\u0621."
              },
              remove: {
                term: "\u0633\u062D\u0628",
                text: "\u064A\u0633\u062D\u0628 \u0627\u0644\u0645\u0646\u062F\u0648\u0628 \u0628\u0639\u062F \u062A\u0623\u0643\u064A\u062F: \u064A\u062A\u0648\u0642\u0641 \u0648\u0635\u0648\u0644\u0647 \u0641\u0648\u0631\u0627\u064B. \u0644\u0627 \u064A\u0638\u0647\u0631 \u0627\u0644\u0632\u0631 \u0625\u0644\u0627 \u0625\u0630\u0627 \u0643\u0627\u0646\u062A \u0644\u0643 \u0635\u0644\u0627\u062D\u064A\u0629 \u0633\u062D\u0628\u0647."
              },
              empty: {
                term: "\u0644\u0627 \u064A\u0648\u062C\u062F \u0645\u0646\u062F\u0648\u0628\u0648\u0646 \u0628\u0639\u062F",
                text: "\u0631\u0633\u0627\u0644\u0629 \u062A\u0638\u0647\u0631 \u0645\u0627 \u062F\u0645\u062A \u0644\u0645 \u062A\u0636\u0641 \u0623\u062D\u062F\u0627\u064B. \u062A\u062F\u0639\u0648\u0643 \u0625\u0644\u0649 \u0625\u0636\u0627\u0641\u0629 \u0623\u0639\u0636\u0627\u0621 \u0645\u0646 \u0645\u0624\u0633\u0633\u062A\u0643."
              }
            }
          },
          addDialog: {
            title: "\u0646\u0627\u0641\u0630\u0629 \xAB\u0625\u0636\u0627\u0641\u0629 \u0639\u0636\u0648\xBB",
            items: {
              people: {
                term: "\u0623\u0639\u0636\u0627\u0621 \u0645\u0624\u0633\u0633\u062A\u0643",
                text: "\u0627\u062E\u062A\u0631 \u0634\u062E\u0635\u0627\u064B \u0623\u0648 \u0623\u0643\u062B\u0631 \u0645\u0646 \u0645\u0624\u0633\u0633\u062A\u0643. \u064A\u0635\u0644\u0648\u0646 \u0625\u0644\u0649 \u0641\u0636\u0627\u0621 \u0627\u0644\u0645\u0624\u0633\u0633\u0629 \u0627\u0644\u0645\u0633\u062A\u0636\u064A\u0641\u0629 \u062F\u0648\u0646 \u0623\u0646 \u064A\u0631\u0648\u0627 \u0628\u0642\u064A\u0629 \u0634\u0624\u0648\u0646 \u062A\u0644\u0643 \u0627\u0644\u0645\u0624\u0633\u0633\u0629."
              },
              scope: {
                term: "\u0645\u0627 \u064A\u0634\u0645\u0644\u0647 \u0627\u0644\u0648\u0635\u0648\u0644",
                text: "\u0636\u0645\u0646 \u062D\u062F\u0648\u062F \u0634\u0631\u0627\u0643\u062A\u0643\u0645: \xAB\u0643\u0644 \u0627\u0644\u0641\u0636\u0627\u0621\xBB \u0641\u0642\u0637 \u0625\u0630\u0627 \u0643\u0627\u0646\u062A \u0627\u0644\u0634\u0631\u0627\u0643\u0629 \u062A\u0633\u0645\u062D \u0628\u0630\u0644\u0643\u060C \u0648\u0625\u0644\u0627 \u0645\u062C\u0644\u062F\u0627\u062A \u0648\u0642\u0646\u0648\u0627\u062A \u0645\u0646 \u0628\u064A\u0646 \u0627\u0644\u0645\u062A\u0627\u062D\u0629 \u0644\u0643."
              },
              rights: {
                term: "\u0627\u0644\u0635\u0644\u0627\u062D\u064A\u0627\u062A",
                text: "\u0627\u0644\u0635\u0644\u0627\u062D\u064A\u0627\u062A \u0627\u0644\u0645\u0639\u0631\u0648\u0636\u0629 \u0644\u0627 \u062A\u062A\u062C\u0627\u0648\u0632 \u0623\u0628\u062F\u0627\u064B \u0635\u0644\u0627\u062D\u064A\u0627\u062A \u0634\u0631\u0627\u0643\u062A\u0643\u0645."
              },
              submit: {
                term: "\u0645\u0646\u062D \u0627\u0644\u0648\u0635\u0648\u0644",
                text: "\u064A\u0636\u064A\u0641 \u0627\u0644\u0623\u0634\u062E\u0627\u0635 \u0627\u0644\u0645\u062E\u062A\u0627\u0631\u064A\u0646. \u0644\u0627 \u064A\u0645\u0643\u0646\u0643 \u0625\u0636\u0627\u0641\u0629 \u0623\u0643\u062B\u0631 \u0645\u0646 \u0627\u0644\u0639\u062F\u062F \u0627\u0644\u0645\u062A\u0628\u0642\u064A \u0627\u0644\u0645\u0633\u0645\u0648\u062D \u0628\u0647."
              }
            }
          },
          leave: {
            title: "\u0645\u063A\u0627\u062F\u0631\u0629 \u0627\u0644\u0641\u0636\u0627\u0621",
            items: {
              heading: {
                term: "\u0645\u063A\u0627\u062F\u0631\u0629 \u0627\u0644\u0641\u0636\u0627\u0621",
                text: "\u064A\u0646\u0647\u064A \u0627\u0644\u0634\u0631\u0627\u0643\u0629 \u0645\u0646 \u062C\u0627\u0646\u0628\u0643: \u064A\u0641\u0642\u062F \u0643\u0644 \u0623\u0634\u062E\u0627\u0635 \u0645\u0624\u0633\u0633\u062A\u0643 \u0648\u0635\u0648\u0644\u0647\u0645. \u0644\u0627 \u064A\u0638\u0647\u0631 \u0647\u0630\u0627 \u0627\u0644\u0642\u0633\u0645 \u0641\u064A \u0641\u0636\u0627\u0621 \u0645\u063A\u0644\u0642."
              },
              button: {
                term: "\u0645\u063A\u0627\u062F\u0631\u0629 \u0627\u0644\u0641\u0636\u0627\u0621",
                text: "\u064A\u0641\u062A\u062D \u0646\u0627\u0641\u0630\u0629 \u062A\u0623\u0643\u064A\u062F. \u0648\u0644\u0644\u0639\u0648\u062F\u0629\u060C \u0633\u062A\u062D\u062A\u0627\u062C \u0627\u0644\u0645\u0624\u0633\u0633\u0629 \u0627\u0644\u0645\u0633\u062A\u0636\u064A\u0641\u0629 \u0625\u0644\u0649 \u062F\u0639\u0648\u062A\u0643\u0645 \u0645\u0646 \u062C\u062F\u064A\u062F."
              }
            }
          }
        }
      },
      settings: {
        title: "\u0627\u0644\u0625\u0639\u062F\u0627\u062F\u0627\u062A",
        intro: "\u062A\u0628\u0648\u064A\u0628 \u0627\u0644\u0625\u0639\u062F\u0627\u062F\u0627\u062A \u0641\u064A \u0641\u0636\u0627\u0621 \u0645\u0634\u062A\u0631\u0643\u060C \u0645\u062E\u0635\u0635 \u0644\u0645\u0633\u0624\u0648\u0644\u064A \u0627\u0644\u0645\u0624\u0633\u0633\u0629 \u0627\u0644\u0645\u0633\u062A\u0636\u064A\u0641\u0629. \u064A\u064F\u0633\u062A\u0639\u0645\u0644 \u0644\u0625\u0639\u0627\u062F\u0629 \u062A\u0633\u0645\u064A\u0629 \u0627\u0644\u0641\u0636\u0627\u0621 \u0648\u062A\u062D\u062F\u064A\u062F \u0642\u0648\u0627\u0639\u062F\u0647\u060C \u0648\u0644\u0625\u063A\u0644\u0627\u0642\u0647 \u0628\u0627\u0644\u0646\u0633\u0628\u0629 \u0644\u0644\u0645\u0627\u0644\u0643\u064A\u0646 \u0648\u0627\u0644\u0645\u0633\u0624\u0648\u0644\u064A\u0646.",
        sections: {
          frame: {
            title: "\u0625\u0637\u0627\u0631 \u0627\u0644\u0641\u0636\u0627\u0621",
            items: {
              banner: {
                term: "\u0641\u0636\u0627\u0621 \u062E\u0627\u0631\u062C\u064A \u062A\u0633\u062A\u0636\u064A\u0641\u0647 \u2026",
                text: "\u0634\u0631\u064A\u0637 \u062F\u0627\u0626\u0645 \u064A\u0638\u0647\u0631 \u0639\u0646\u062F\u0645\u0627 \u064A\u062E\u0635 \u0627\u0644\u0641\u0636\u0627\u0621 \u0645\u0624\u0633\u0633\u0629 \u0623\u062E\u0631\u0649: \u064A\u0630\u0643\u0651\u0631\u0643 \u0628\u0623\u0646 \u0645\u062D\u062A\u0648\u0627\u0647 \u064A\u062E\u0636\u0639 \u0644\u0642\u0648\u0627\u0639\u062F \u062A\u0644\u0643 \u0627\u0644\u0645\u0624\u0633\u0633\u0629."
              },
              summary: {
                term: "\u062A\u0633\u062A\u0636\u064A\u0641\u0647 \u2026",
                text: "\u0634\u0631\u064A\u0637 \u062A\u062D\u062A \u0627\u0644\u0639\u0646\u0648\u0627\u0646: \u0627\u0644\u0645\u0624\u0633\u0633\u0629 \u0627\u0644\u062A\u064A \u062A\u0633\u062A\u0636\u064A\u0641 \u0627\u0644\u0641\u0636\u0627\u0621 \u0648\u0646\u0648\u0639\u0647 \u0648\u0634\u0627\u0631\u0629 \xAB\u0645\u063A\u0644\u0642\xBB \u0639\u0646\u062F\u0645\u0627 \u064A\u0643\u0648\u0646 \u0627\u0644\u0641\u0636\u0627\u0621 \u0645\u063A\u0644\u0642\u0627\u064B\u060C \u0648\u0641\u064A \u0627\u0644\u0641\u0636\u0627\u0621 \u0627\u0644\u062E\u0627\u0631\u062C\u064A \u0648\u0635\u0648\u0644\u0643: \u0643\u064A\u0641 \u062F\u062E\u0644\u062A \u0648\u0635\u0644\u0627\u062D\u064A\u0627\u062A\u0643 \u0648\u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0627\u0646\u062A\u0647\u0627\u0621."
              },
              tabs: {
                term: "\u0639\u0644\u0627\u0645\u0627\u062A \u0627\u0644\u062A\u0628\u0648\u064A\u0628",
                text: "\u0634\u0631\u064A\u0637 \u062A\u0628\u0648\u064A\u0628\u0627\u062A \u0627\u0644\u0641\u0636\u0627\u0621. \u0623\u0646\u062A \u0641\u064A \u062A\u0628\u0648\u064A\u0628 \xAB\u0627\u0644\u0625\u0639\u062F\u0627\u062F\u0627\u062A\xBB\u061B \u0644\u0627 \u062A\u0638\u0647\u0631 \u0625\u0644\u0627 \u0627\u0644\u062A\u0628\u0648\u064A\u0628\u0627\u062A \u0627\u0644\u062A\u064A \u064A\u062A\u064A\u062D \u0644\u0643 \u0648\u0635\u0648\u0644\u0643 \u0641\u062A\u062D\u0647\u0627."
              }
            }
          },
          general: {
            title: "\u0639\u0627\u0645",
            items: {
              name: {
                term: "\u0627\u0633\u0645 \u0627\u0644\u0641\u0636\u0627\u0621",
                text: "\u0627\u0644\u0627\u0633\u0645 \u0627\u0644\u0630\u064A \u064A\u0638\u0647\u0631 \u0628\u0647 \u0627\u0644\u0641\u0636\u0627\u0621 \u0644\u062C\u0645\u064A\u0639 \u0627\u0644\u0645\u0634\u0627\u0631\u0643\u064A\u0646 \u0641\u064A\u0647. \u0625\u0644\u0632\u0627\u0645\u064A\u060C 200 \u062D\u0631\u0641 \u0639\u0644\u0649 \u0627\u0644\u0623\u0643\u062B\u0631."
              },
              closedNotice: {
                term: "\u0647\u0630\u0627 \u0627\u0644\u0641\u0636\u0627\u0621 \u0645\u063A\u0644\u0642: \u0644\u0645 \u064A\u0639\u062F \u0628\u0627\u0644\u0625\u0645\u0643\u0627\u0646 \u062A\u0639\u062F\u064A\u0644 \u0625\u0639\u062F\u0627\u062F\u0627\u062A\u0647.",
                text: "\u062A\u062D\u0630\u064A\u0631 \u0623\u0635\u0641\u0631 \u064A\u0638\u0647\u0631 \u0641\u064A \u0627\u0644\u0623\u0639\u0644\u0649 \u0639\u0646\u062F\u0645\u0627 \u064A\u0643\u0648\u0646 \u0627\u0644\u0641\u0636\u0627\u0621 \u0645\u063A\u0644\u0642\u0627\u064B: \u062A\u0635\u0628\u062D \u0643\u0644 \u0627\u0644\u062D\u0642\u0648\u0644 \u0645\u0639\u0637\u0644\u0629 \u0648\u0644\u0627 \u064A\u0648\u062C\u062F \u0632\u0631 \u062D\u0641\u0638."
              }
            }
          },
          policy: {
            title: "\u0642\u0648\u0627\u0639\u062F \u0627\u0644\u0641\u0636\u0627\u0621",
            items: {
              intro: {
                term: "\u0642\u0648\u0627\u0639\u062F \u0627\u0644\u0641\u0636\u0627\u0621",
                text: "\u062A\u0646\u0637\u0628\u0642 \u0647\u0630\u0647 \u0627\u0644\u0642\u0648\u0627\u0639\u062F \u0639\u0644\u0649 \u0643\u0644 \u0639\u0645\u0644\u064A\u0627\u062A \u0627\u0644\u0648\u0635\u0648\u0644 \u0625\u0644\u0649 \u0627\u0644\u0641\u0636\u0627\u0621\u060C \u0628\u0645\u0627 \u0641\u064A\u0647\u0627 \u0648\u0635\u0648\u0644 \u0627\u0644\u0645\u0624\u0633\u0633\u0627\u062A \u0627\u0644\u0634\u0631\u064A\u0643\u0629 \u0648\u0627\u0644\u0636\u064A\u0648\u0641."
              },
              download: {
                term: "\u0627\u0644\u0633\u0645\u0627\u062D \u0628\u0627\u0644\u062A\u0646\u0632\u064A\u0644",
                text: "\u0645\u0641\u062A\u0627\u062D \u062A\u0628\u062F\u064A\u0644. \u0645\u0646 \u062F\u0648\u0646 \u062A\u0646\u0632\u064A\u0644 \u062A\u0628\u0642\u0649 \u0627\u0644\u0645\u0633\u062A\u0646\u062F\u0627\u062A \u0645\u062A\u0627\u062D\u0629 \u0644\u0644\u0645\u0639\u0627\u064A\u0646\u0629."
              },
              watermark: {
                term: "\u0639\u0644\u0627\u0645\u0629 \u0645\u0627\u0626\u064A\u0629 \u0639\u0644\u0649 \u0645\u0644\u0641\u0627\u062A \u2066PDF\u2069",
                text: "\u0645\u0641\u062A\u0627\u062D \u062A\u0628\u062F\u064A\u0644. \u062A\u062D\u062F\u062F \u0627\u0644\u0639\u0644\u0627\u0645\u0629 \u0627\u0644\u0645\u0627\u0626\u064A\u0629 \u0647\u0648\u064A\u0629 \u0627\u0644\u0634\u062E\u0635 \u0627\u0644\u0630\u064A \u064A\u0637\u0651\u0644\u0639 \u0639\u0644\u0649 \u0643\u0644 \u0645\u0644\u0641 \u2066PDF\u2069."
              },
              print: {
                term: "\u0627\u0644\u0633\u0645\u0627\u062D \u0628\u0627\u0644\u0637\u0628\u0627\u0639\u0629",
                text: "\u0645\u0641\u062A\u0627\u062D \u062A\u0628\u062F\u064A\u0644. \u062A\u062A\u0645 \u0627\u0644\u0637\u0628\u0627\u0639\u0629 \u0645\u0646 \u0639\u0627\u0631\u0636 \u0627\u0644\u0645\u0633\u062A\u0646\u062F\u0627\u062A."
              },
              domains: {
                term: "\u0627\u0644\u0646\u0637\u0627\u0642\u0627\u062A \u0627\u0644\u0645\u0633\u0645\u0648\u062D \u0628\u0647\u0627 \u0644\u0644\u0636\u064A\u0648\u0641",
                text: "\u0623\u062F\u062E\u0644 \u0646\u0637\u0627\u0642\u0627\u064B\u060C \u0645\u062B\u0644 \u2066client.tn\u2069\u060C \u062B\u0645 \u0627\u0636\u063A\u0637 \u2066Enter\u2069 \u0623\u0648 \xAB\u0625\u0636\u0627\u0641\u0629\xBB: \u064A\u0638\u0647\u0631 \u0641\u064A \u0634\u0627\u0631\u0629 \u062A\u0632\u064A\u0644\u0647\u0627 \u0628\u0639\u0644\u0627\u0645\u0629 \u0627\u0644\u0625\u063A\u0644\u0627\u0642 \u0641\u064A\u0647\u0627. \u0627\u0644\u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u0641\u0627\u0631\u063A\u0629 \u062A\u0639\u0646\u064A \u0623\u0646 \u0628\u0625\u0645\u0643\u0627\u0646 \u0627\u0644\u0636\u064A\u0648\u0641 \u0627\u0633\u062A\u062E\u062F\u0627\u0645 \u0623\u064A \u0628\u0631\u064A\u062F \u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A \u062A\u0633\u0645\u062D \u0628\u0647 \u0633\u064A\u0627\u0633\u0629 \u0645\u0624\u0633\u0633\u062A\u0643."
              }
            }
          },
          save: {
            title: "\u0627\u0644\u062D\u0641\u0638",
            items: {
              save: {
                term: "\u062D\u0641\u0638 \u0627\u0644\u0625\u0639\u062F\u0627\u062F\u0627\u062A",
                text: "\u064A\u062D\u0641\u0638 \u0645\u0627 \u062A\u063A\u064A\u0651\u0631. \u0625\u0630\u0627 \u0644\u0645 \u064A\u062A\u063A\u064A\u0631 \u0634\u064A\u0621 \u062A\u0638\u0647\u0631 \u0627\u0644\u0631\u0633\u0627\u0644\u0629 \xAB\u0644\u0627 \u062A\u0648\u062C\u062F \u062A\u0639\u062F\u064A\u0644\u0627\u062A \u0644\u062D\u0641\u0638\u0647\u0627\xBB. \u0642\u062F \u064A\u064F\u0637\u0644\u0628 \u0645\u0646\u0643 \u062A\u0623\u0643\u064A\u062F \u0647\u0648\u064A\u062A\u0643 \u0642\u0628\u0644 \u0627\u0644\u062D\u0641\u0638."
              },
              failed: {
                term: "\u0644\u0645 \u064A\u062A\u0645 \u062D\u0641\u0638 \u0627\u0644\u0625\u0639\u062F\u0627\u062F\u0627\u062A",
                text: "\u0631\u0633\u0627\u0644\u0629 \u062D\u0645\u0631\u0627\u0621 \u062A\u0634\u0631\u062D \u0627\u0644\u0633\u0628\u0628 \u0628\u0644\u063A\u0629 \u0628\u0633\u064A\u0637\u0629: \u0627\u0633\u0645 \u0646\u0627\u0642\u0635 \u0623\u0648 \u0637\u0648\u064A\u0644 \u062C\u062F\u0627\u064B \u0623\u0648 \u0642\u064A\u0645\u0629 \u063A\u064A\u0631 \u0635\u0627\u0644\u062D\u0629 \u0623\u0648 \u0635\u0644\u0627\u062D\u064A\u0629 \u063A\u064A\u0631 \u0643\u0627\u0641\u064A\u0629."
              }
            }
          },
          close: {
            title: "\u0625\u063A\u0644\u0627\u0642 \u0627\u0644\u0641\u0636\u0627\u0621",
            items: {
              section: {
                term: "\u0625\u063A\u0644\u0627\u0642 \u0627\u0644\u0641\u0636\u0627\u0621",
                text: "\u0642\u0633\u0645 \u0645\u062E\u0635\u0635 \u0644\u0645\u0627\u0644\u0643\u064A \u0627\u0644\u0645\u0624\u0633\u0633\u0629 \u0627\u0644\u0645\u0633\u062A\u0636\u064A\u0641\u0629 \u0648\u0645\u0633\u0624\u0648\u0644\u064A\u0647\u0627\u060C \u0648\u0644\u0627 \u064A\u0638\u0647\u0631 \u0625\u0630\u0627 \u0643\u0627\u0646 \u0627\u0644\u0641\u0636\u0627\u0621 \u0645\u063A\u0644\u0642\u0627\u064B. \u064A\u0646\u0647\u064A \u0643\u0644 \u0639\u0645\u0644\u064A\u0627\u062A \u0627\u0644\u0648\u0635\u0648\u0644 \u0645\u0646 \u0627\u0644\u062E\u0627\u0631\u062C \u0648\u062A\u0628\u0642\u0649 \u0645\u0624\u0633\u0633\u062A\u0643 \u0642\u0627\u062F\u0631\u0629 \u0639\u0644\u0649 \u0642\u0631\u0627\u0621\u0629 \u0627\u0644\u0641\u0636\u0627\u0621."
              },
              button: {
                term: "\u0625\u063A\u0644\u0627\u0642 \u0627\u0644\u0641\u0636\u0627\u0621",
                text: "\u064A\u0641\u062A\u062D \u0646\u0627\u0641\u0630\u0629 \u062A\u0623\u0643\u064A\u062F. \u0642\u062F \u064A\u064F\u0637\u0644\u0628 \u0645\u0646\u0643 \u062A\u0623\u0643\u064A\u062F \u0647\u0648\u064A\u062A\u0643 \u0642\u0628\u0644 \u0627\u0644\u0625\u063A\u0644\u0627\u0642."
              },
              effects: {
                term: "\u0647\u0630\u0627 \u0627\u0644\u0625\u062C\u0631\u0627\u0621 \u0646\u0647\u0627\u0626\u064A",
                text: "\u064A\u0639\u062F\u0651\u062F \u0627\u0644\u062A\u0623\u0643\u064A\u062F \u0627\u0644\u0622\u062B\u0627\u0631: \u062A\u0641\u0642\u062F \u0643\u0644 \u0627\u0644\u0645\u0624\u0633\u0633\u0627\u062A \u0627\u0644\u0634\u0631\u064A\u0643\u0629 \u0648\u0645\u0646\u062F\u0648\u0628\u0648\u0647\u0627 \u0648\u0627\u0644\u0623\u0634\u062E\u0627\u0635 \u0627\u0644\u0645\u0633\u0645\u0651\u0648\u0646 \u0648\u0627\u0644\u0636\u064A\u0648\u0641 \u0648\u0635\u0648\u0644\u0647\u0645\u060C \u0648\u064A\u0635\u0628\u062D \u0627\u0644\u0641\u0636\u0627\u0621 \u0623\u0631\u0634\u064A\u0641\u0627\u064B \u0644\u0644\u0642\u0631\u0627\u0621\u0629 \u0641\u0642\u0637\u060C \u0648\u0644\u0627 \u064A\u0633\u062A\u0637\u064A\u0639 \u0627\u0644\u0634\u0631\u0643\u0627\u0621 \u0628\u0639\u062F\u064F \u0627\u0633\u062A\u0631\u062C\u0627\u0639 \u0645\u0644\u0641\u0627\u062A\u0647\u0645 \u0627\u0644\u062E\u0627\u0635\u0629."
              },
              cancel: {
                term: "\u0625\u0644\u063A\u0627\u0621",
                text: "\u064A\u063A\u0644\u0642 \u0646\u0627\u0641\u0630\u0629 \u0627\u0644\u062A\u0623\u0643\u064A\u062F \u062F\u0648\u0646 \u062A\u063A\u064A\u064A\u0631 \u0634\u064A\u0621. \xAB\u0625\u063A\u0644\u0627\u0642 \u0627\u0644\u0641\u0636\u0627\u0621\xBB \u062F\u0627\u062E\u0644 \u0646\u0627\u0641\u0630\u0629 \u0627\u0644\u062A\u0623\u0643\u064A\u062F \u064A\u0646\u0641\u0651\u0630 \u0627\u0644\u0625\u063A\u0644\u0627\u0642."
              }
            }
          }
        }
      },
      audit: {
        title: "\u0633\u062C\u0644 \u0627\u0644\u062A\u062F\u0642\u064A\u0642",
        intro: "\u062A\u0628\u0648\u064A\u0628 \u0633\u062C\u0644 \u0627\u0644\u062A\u062F\u0642\u064A\u0642 \u0641\u064A \u0641\u0636\u0627\u0621 \u0645\u0634\u062A\u0631\u0643: \u0645\u0646 \u0641\u0639\u0644 \u0645\u0627\u0630\u0627 \u0641\u064A \u0627\u0644\u0641\u0636\u0627\u0621 \u0648\u0645\u062A\u0649. \u062A\u0631\u0649 \u0627\u0644\u0645\u0624\u0633\u0633\u0629 \u0627\u0644\u0645\u0633\u062A\u0636\u064A\u0641\u0629 \u0643\u0644 \u0634\u064A\u0621\u060C \u0623\u0645\u0627 \u0627\u0644\u0634\u0631\u064A\u0643 \u0641\u064A\u0631\u0649 \u0645\u0627 \u064A\u062E\u0635 \u0645\u0624\u0633\u0633\u062A\u0647 \u0641\u0642\u0637.",
        sections: {
          frame: {
            title: "\u0625\u0637\u0627\u0631 \u0627\u0644\u0641\u0636\u0627\u0621",
            items: {
              banner: {
                term: "\u0641\u0636\u0627\u0621 \u062E\u0627\u0631\u062C\u064A \u062A\u0633\u062A\u0636\u064A\u0641\u0647 \u2026",
                text: "\u0634\u0631\u064A\u0637 \u062F\u0627\u0626\u0645 \u064A\u0638\u0647\u0631 \u0639\u0646\u062F\u0645\u0627 \u064A\u062E\u0635 \u0627\u0644\u0641\u0636\u0627\u0621 \u0645\u0624\u0633\u0633\u0629 \u0623\u062E\u0631\u0649: \u064A\u0630\u0643\u0651\u0631\u0643 \u0628\u0623\u0646 \u0645\u062D\u062A\u0648\u0627\u0647 \u064A\u062E\u0636\u0639 \u0644\u0642\u0648\u0627\u0639\u062F \u062A\u0644\u0643 \u0627\u0644\u0645\u0624\u0633\u0633\u0629."
              },
              summary: {
                term: "\u062A\u0633\u062A\u0636\u064A\u0641\u0647 \u2026",
                text: "\u0634\u0631\u064A\u0637 \u062A\u062D\u062A \u0627\u0644\u0639\u0646\u0648\u0627\u0646: \u0627\u0644\u0645\u0624\u0633\u0633\u0629 \u0627\u0644\u062A\u064A \u062A\u0633\u062A\u0636\u064A\u0641 \u0627\u0644\u0641\u0636\u0627\u0621 \u0648\u0646\u0648\u0639\u0647 \u0648\u0634\u0627\u0631\u0629 \xAB\u0645\u063A\u0644\u0642\xBB \u0639\u0646\u062F\u0645\u0627 \u064A\u0643\u0648\u0646 \u0627\u0644\u0641\u0636\u0627\u0621 \u0645\u063A\u0644\u0642\u0627\u064B\u060C \u0648\u0641\u064A \u0627\u0644\u0641\u0636\u0627\u0621 \u0627\u0644\u062E\u0627\u0631\u062C\u064A \u0648\u0635\u0648\u0644\u0643: \u0643\u064A\u0641 \u062F\u062E\u0644\u062A \u0648\u0635\u0644\u0627\u062D\u064A\u0627\u062A\u0643 \u0648\u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0627\u0646\u062A\u0647\u0627\u0621."
              },
              tabs: {
                term: "\u0639\u0644\u0627\u0645\u0627\u062A \u0627\u0644\u062A\u0628\u0648\u064A\u0628",
                text: "\u0634\u0631\u064A\u0637 \u062A\u0628\u0648\u064A\u0628\u0627\u062A \u0627\u0644\u0641\u0636\u0627\u0621. \u0623\u0646\u062A \u0641\u064A \u062A\u0628\u0648\u064A\u0628 \xAB\u0633\u062C\u0644 \u0627\u0644\u062A\u062F\u0642\u064A\u0642\xBB\u061B \u0644\u0627 \u062A\u0638\u0647\u0631 \u0625\u0644\u0627 \u0627\u0644\u062A\u0628\u0648\u064A\u0628\u0627\u062A \u0627\u0644\u062A\u064A \u064A\u062A\u064A\u062D \u0644\u0643 \u0648\u0635\u0648\u0644\u0643 \u0641\u062A\u062D\u0647\u0627."
              }
            }
          },
          log: {
            title: "\u0633\u062C\u0644 \u0627\u0644\u062A\u062F\u0642\u064A\u0642",
            items: {
              heading: {
                term: "\u0633\u062C\u0644 \u0627\u0644\u062A\u062F\u0642\u064A\u0642",
                text: "\u062C\u062F\u0648\u0644 \u0623\u062D\u062F\u0627\u062B \u0627\u0644\u0641\u0636\u0627\u0621\u060C \u0645\u0646 \u0627\u0644\u0623\u062D\u062F\u062B \u0625\u0644\u0649 \u0627\u0644\u0623\u0642\u062F\u0645. \u064A\u062D\u0641\u0638 \u0623\u062B\u0631 \u0627\u0644\u062F\u0639\u0648\u0627\u062A \u0648\u0639\u0645\u0644\u064A\u0627\u062A \u0645\u0646\u062D \u0627\u0644\u0648\u0635\u0648\u0644 \u0648\u0633\u062D\u0628\u0647."
              },
              date: {
                term: "\u0627\u0644\u062A\u0627\u0631\u064A\u062E",
                text: "\u064A\u0648\u0645 \u0627\u0644\u062D\u062F\u062B \u0648\u0633\u0627\u0639\u062A\u0647."
              },
              actor: {
                term: "\u0627\u0644\u0634\u062E\u0635",
                text: "\u0645\u0646 \u0642\u0627\u0645 \u0628\u0627\u0644\u0625\u062C\u0631\u0627\u0621. \xAB\u0627\u0644\u0646\u0638\u0627\u0645\xBB \u064A\u062F\u0644 \u0639\u0644\u0649 \u0625\u062C\u0631\u0627\u0621 \u062A\u0644\u0642\u0627\u0626\u064A\u060C \u0645\u062B\u0644 \u0627\u0646\u062A\u0647\u0627\u0621 \u0648\u0635\u0648\u0644."
              },
              action: {
                term: "\u0627\u0644\u0625\u062C\u0631\u0627\u0621",
                text: "\u0645\u0627 \u062D\u062F\u062B\u060C \u0628\u0643\u0644\u0645\u0627\u062A \u0648\u0627\u0636\u062D\u0629 (\u0627\u0646\u0638\u0631 \u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u0625\u062C\u0631\u0627\u0621\u0627\u062A \u0623\u062F\u0646\u0627\u0647)."
              },
              organisation: {
                term: "\u0627\u0644\u0645\u0624\u0633\u0633\u0629 \u0627\u0644\u0645\u0639\u0646\u064A\u0629",
                text: "\u0627\u0644\u0645\u0624\u0633\u0633\u0629 \u0627\u0644\u0634\u0631\u064A\u0643\u0629 \u0627\u0644\u062A\u064A \u064A\u062E\u0635\u0647\u0627 \u0627\u0644\u062D\u062F\u062B. \xAB\u2014\xBB \u062A\u0639\u0646\u064A \u0623\u0646\u0647 \u0644\u0627 \u062A\u0648\u062C\u062F \u0645\u0624\u0633\u0633\u0629 \u0645\u0639\u0646\u064A\u0629\u060C \u0648\xAB\u0645\u0624\u0633\u0633\u0629 \u0623\u062E\u0631\u0649\xBB \u062A\u0639\u0646\u064A \u0645\u0624\u0633\u0633\u0629 \u0644\u0627 \u062A\u062F\u064A\u0631\u0647\u0627."
              }
            }
          },
          actions: {
            title: "\u0627\u0644\u0625\u062C\u0631\u0627\u0621\u0627\u062A \u0627\u0644\u062A\u064A \u064A\u0645\u0643\u0646\u0643 \u0631\u0624\u064A\u062A\u0647\u0627",
            items: {
              space: {
                term: "\u062A\u0645 \u0625\u0646\u0634\u0627\u0621 \u0627\u0644\u0641\u0636\u0627\u0621",
                text: "\u062D\u064A\u0627\u0629 \u0627\u0644\u0641\u0636\u0627\u0621: \xAB\u062A\u0645 \u0625\u0646\u0634\u0627\u0621 \u0627\u0644\u0641\u0636\u0627\u0621\xBB \u0648\xAB\u062A\u0645 \u062A\u0639\u062F\u064A\u0644 \u0625\u0639\u062F\u0627\u062F\u0627\u062A \u0627\u0644\u0641\u0636\u0627\u0621\xBB \u0648\xAB\u062A\u0645 \u0625\u063A\u0644\u0627\u0642 \u0627\u0644\u0641\u0636\u0627\u0621\xBB."
              },
              partners: {
                term: "\u062A\u0645\u062A \u062F\u0639\u0648\u0629 \u0645\u0624\u0633\u0633\u0629 \u0634\u0631\u064A\u0643\u0629",
                text: "\u0627\u0644\u0634\u0631\u0627\u0643\u0627\u062A: \xAB\u062A\u0645\u062A \u062F\u0639\u0648\u0629 \u0645\u0624\u0633\u0633\u0629 \u0634\u0631\u064A\u0643\u0629\xBB \u0648\xAB\u062A\u0645 \u0642\u0628\u0648\u0644 \u062F\u0639\u0648\u0629 \u0627\u0644\u0634\u0631\u0627\u0643\u0629\xBB \u0648\xAB\u062A\u0645 \u0631\u0641\u0636 \u062F\u0639\u0648\u0629 \u0627\u0644\u0634\u0631\u0627\u0643\u0629\xBB \u0648\xAB\u062A\u0645 \u0633\u062D\u0628 \u0645\u0624\u0633\u0633\u0629 \u0634\u0631\u064A\u0643\u0629\xBB \u0648\xAB\u0627\u0646\u062A\u0647\u062A \u0627\u0644\u0634\u0631\u0627\u0643\u0629\xBB."
              },
              members: {
                term: "\u0627\u0646\u0636\u0645 \u0634\u062E\u0635 \u0625\u0644\u0649 \u0627\u0644\u0641\u0636\u0627\u0621",
                text: "\u0648\u0635\u0648\u0644 \u0627\u0644\u0623\u0634\u062E\u0627\u0635: \xAB\u062A\u0645\u062A \u0625\u0636\u0627\u0641\u0629 \u0634\u062E\u0635 \u0645\u0646 \u0642\u0628\u0644 \u0634\u0631\u064A\u0643\xBB \u0648\xAB\u0627\u0646\u0636\u0645 \u0634\u062E\u0635 \u0625\u0644\u0649 \u0627\u0644\u0641\u0636\u0627\u0621\xBB \u0648\xAB\u062A\u0645 \u0633\u062D\u0628 \u0648\u0635\u0648\u0644 \u0634\u062E\u0635\xBB \u0648\xAB\u0627\u0646\u062A\u0647\u0649 \u0648\u0635\u0648\u0644 \u0634\u062E\u0635\xBB \u0648\xAB\u062A\u0645 \u062A\u0645\u062F\u064A\u062F \u0648\u0635\u0648\u0644 \u0636\u064A\u0641\xBB."
              },
              invitations: {
                term: "\u062A\u0645 \u0625\u0631\u0633\u0627\u0644 \u062F\u0639\u0648\u0629 \u0625\u0644\u0649 \u0634\u062E\u0635",
                text: "\u0627\u0644\u062F\u0639\u0648\u0627\u062A: \xAB\u062A\u0645 \u0625\u0631\u0633\u0627\u0644 \u062F\u0639\u0648\u0629 \u0625\u0644\u0649 \u0634\u062E\u0635\xBB \u0648\xAB\u062A\u0645 \u0631\u0641\u0636 \u062F\u0639\u0648\u0629\xBB \u0648\xAB\u062A\u0645 \u0625\u0644\u063A\u0627\u0621 \u062F\u0639\u0648\u0629\xBB \u0648\xAB\u0642\u0631\u0627\u0631 \u0628\u0634\u0623\u0646 \u0637\u0644\u0628 \u0645\u0648\u0627\u0641\u0642\u0629\xBB."
              },
              other: {
                term: "\u0625\u062C\u0631\u0627\u0621 \u0622\u062E\u0631",
                text: "\u0625\u062C\u0631\u0627\u0621 \u0644\u064A\u0633 \u0644\u0647 \u0628\u0639\u062F\u064F \u062A\u0633\u0645\u064A\u0629 \u0648\u0627\u0636\u062D\u0629: \u064A\u0638\u0647\u0631 \u0627\u0633\u0645\u0647 \u0627\u0644\u062A\u0642\u0646\u064A \u0628\u064A\u0646 \u0642\u0648\u0633\u064A\u0646."
              }
            }
          },
          states: {
            title: "\u0627\u0644\u0635\u0641\u062D\u0627\u062A \u0627\u0644\u062A\u0627\u0644\u064A\u0629 \u0648\u0627\u0644\u062D\u0627\u0644\u0627\u062A",
            items: {
              more: {
                term: "\u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0645\u0632\u064A\u062F",
                text: "\u064A\u062D\u0645\u0651\u0644 \u0627\u0644\u0623\u062D\u062F\u0627\u062B \u0627\u0644\u0623\u0642\u062F\u0645 \u0635\u0641\u062D\u0629 \u0635\u0641\u062D\u0629. \u064A\u0639\u0631\u0636 \u0627\u0644\u0632\u0631 \xAB\u062C\u0627\u0631\u064D \u0627\u0644\u062A\u062D\u0645\u064A\u0644\u2026\xBB \u0623\u062B\u0646\u0627\u0621 \u0627\u0644\u0639\u0645\u0644\u064A\u0629."
              },
              empty: {
                term: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0623\u062D\u062F\u0627\u062B \u0628\u0639\u062F",
                text: "\u0631\u0633\u0627\u0644\u0629 \u062A\u0638\u0647\u0631 \u0645\u0627 \u062F\u0627\u0645 \u0644\u0645 \u064A\u062D\u062F\u062B \u0634\u064A\u0621: \u0633\u062A\u0638\u0647\u0631 \u0647\u0646\u0627 \u0627\u0644\u062F\u0639\u0648\u0627\u062A \u0648\u0639\u0645\u0644\u064A\u0627\u062A \u0645\u0646\u062D \u0627\u0644\u0648\u0635\u0648\u0644 \u0648\u0633\u062D\u0628\u0647."
              },
              loadFailed: {
                term: "\u062A\u0639\u0630\u0651\u0631 \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0633\u062C\u0644",
                text: "\u0631\u0633\u0627\u0644\u0629 \u062D\u0645\u0631\u0627\u0621 \u062A\u0638\u0647\u0631 \u0625\u0630\u0627 \u0644\u0645 \u064A\u064F\u062D\u0645\u064E\u0651\u0644 \u0627\u0644\u0633\u062C\u0644. \u0627\u0633\u062A\u062E\u062F\u0645 \xAB\u0625\u0639\u0627\u062F\u0629 \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629\xBB \u0628\u0639\u062F \u0627\u0644\u062A\u062D\u0642\u0642 \u0645\u0646 \u0627\u062A\u0635\u0627\u0644\u0643."
              }
            }
          }
        }
      }
    },
    admin: {
      members: {
        title: "\u0627\u0644\u0623\u0639\u0636\u0627\u0621",
        intro: "\u062A\u0639\u0631\u0636 \u0647\u0630\u0647 \u0627\u0644\u0635\u0641\u062D\u0629 \u0623\u0634\u062E\u0627\u0635 \u0645\u0643\u062A\u0628\u0643 \u0645\u0639 \u062F\u0648\u0631 \u0643\u0644 \u0645\u0646\u0647\u0645 \u0648\u062D\u0627\u0644\u062A\u0647. \u0648\u0645\u0646\u0647\u0627 \u064A\u062F\u0639\u0648 \u0627\u0644\u0645\u0627\u0644\u0643 \u0648\u0627\u0644\u0645\u0634\u0631\u0641\u0648\u0646 \u0627\u0644\u0632\u0645\u0644\u0627\u0621 \u0648\u064A\u062F\u064A\u0631\u0648\u0646 \u0635\u0644\u0627\u062D\u064A\u0627\u062A \u0648\u0635\u0648\u0644\u0647\u0645.",
        sections: {
          header: {
            title: "\u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u0625\u062F\u0627\u0631\u0629 \u0648\u0631\u0623\u0633 \u0627\u0644\u0635\u0641\u062D\u0629",
            items: {
              adminNav: {
                term: "\u0627\u0644\u0625\u062F\u0627\u0631\u0629",
                text: "\u062A\u062C\u0645\u0639 \u0627\u0644\u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u062C\u0627\u0646\u0628\u064A\u0629 \u0635\u0641\u062D\u0627\u062A \u0625\u062F\u0627\u0631\u0629 \u0645\u0624\u0633\u0633\u062A\u0643 (\u0635\u0641\u0651 \u0645\u0646 \u0627\u0644\u0631\u0648\u0627\u0628\u0637 \u0641\u0648\u0642 \u0627\u0644\u0635\u0641\u062D\u0629 \u0639\u0644\u0649 \u0627\u0644\u0634\u0627\u0634\u0627\u062A \u0627\u0644\u0635\u063A\u064A\u0631\u0629). \u0648\u0644\u0627 \u062A\u0639\u0631\u0636 \u0625\u0644\u0627 \u0627\u0644\u0635\u0641\u062D\u0627\u062A \u0627\u0644\u062A\u064A \u064A\u0633\u0645\u062D \u0644\u0643 \u062F\u0648\u0631\u0643 \u0628\u0641\u062A\u062D\u0647\u0627."
              },
              invite: {
                term: "\u062F\u0639\u0648\u0629",
                text: "\u064A\u0641\u062A\u062D \u0646\u0627\u0641\u0630\u0629 \u062F\u0639\u0648\u0629 \u0634\u062E\u0635 \u0625\u0644\u0649 \u0645\u0643\u062A\u0628\u0643. \u0644\u0627 \u064A\u0638\u0647\u0631 \u0627\u0644\u0632\u0631 \u0625\u0644\u0627 \u0625\u0630\u0627 \u0643\u0627\u0646 \u062F\u0648\u0631\u0643 \u064A\u0633\u0645\u062D \u0628\u0627\u0644\u062F\u0639\u0648\u0629. \u0648\u064A\u0643\u0648\u0646 \u0645\u0639\u062A\u0651\u0645\u064B\u0627 \u0645\u0639 \u0634\u0631\u062D \u0639\u0646\u062F\u0645\u0627 \u064A\u0643\u0648\u0646 \u0627\u0644\u0645\u0643\u062A\u0628 \u0641\u064A \u0648\u0636\u0639 \u0627\u0644\u0642\u0631\u0627\u0621\u0629 \u0641\u0642\u0637."
              },
              seats: {
                term: "\u0645\u0642\u0627\u0639\u062F \u0645\u0633\u062A\u0639\u0645\u0644\u0629",
                text: "\u0639\u062F\u0651\u0627\u062F \u0641\u0648\u0642 \u0627\u0644\u0642\u0627\u0626\u0645\u0629\u060C \u0645\u062B\u0644 \xAB3 / 5\xBB: \u0627\u0644\u0645\u0642\u0627\u0639\u062F \u0627\u0644\u0645\u0633\u062A\u0639\u0645\u0644\u0629 \u0645\u0646 \u0627\u0644\u0645\u0642\u0627\u0639\u062F \u0627\u0644\u0645\u0634\u0645\u0648\u0644\u0629 \u0641\u064A \u0639\u0631\u0636\u0643 (\u0645\u0642\u0639\u062F \u0648\u0627\u062D\u062F \u0644\u0643\u0644 \u0634\u062E\u0635 \u0641\u064A \u0627\u0644\u0645\u0643\u062A\u0628). \u0648\u0625\u0646 \u0644\u0645 \u064A\u0643\u0646 \u0647\u0646\u0627\u0643 \u062D\u062F\u0651 \u0641\u064A\u0638\u0647\u0631 \xAB\u0645\u0642\u0627\u0639\u062F \u0645\u0633\u062A\u0639\u0645\u0644\u0629 (\u062F\u0648\u0646 \u062D\u062F\u0651 \u0623\u0642\u0635\u0649)\xBB."
              }
            }
          },
          ownerBanner: {
            title: "\u0646\u0642\u0644 \u0627\u0644\u0645\u0644\u0643\u064A\u0629 \u0642\u064A\u062F \u0627\u0644\u062A\u0646\u0641\u064A\u0630",
            items: {
              pending: {
                term: "\u0646\u0642\u0644 \u0627\u0644\u0645\u0644\u0643\u064A\u0629 \u0642\u064A\u062F \u0627\u0644\u062A\u0646\u0641\u064A\u0630",
                text: "\u0634\u0631\u064A\u0637 \u062E\u0627\u0635 \u0628\u0627\u0644\u0645\u0627\u0644\u0643: \u064A\u0628\u064A\u0651\u0646 \u0645\u0646 \u064A\u0646\u062A\u0638\u0631 \u0631\u062F\u0651\u0647 \u0648\u0625\u0644\u0649 \u0645\u062A\u0649 (\xAB\u064A\u0646\u062A\u0647\u064A \u0641\u064A\xBB). \u0648\u0639\u0644\u0649 \u0627\u0644\u0634\u062E\u0635 \u0627\u0644\u0645\u062E\u062A\u0627\u0631 \u0623\u0646 \u064A\u0642\u0628\u0644 \u0644\u064A\u0635\u0628\u062D \u0627\u0644\u0645\u0627\u0644\u0643."
              },
              cancel: {
                term: "\u0625\u0644\u063A\u0627\u0621 \u0627\u0644\u0646\u0642\u0644",
                text: "\u064A\u0633\u062D\u0628 \u0627\u0644\u0627\u0642\u062A\u0631\u0627\u062D \u0645\u0627 \u062F\u0627\u0645 \u0627\u0644\u0634\u062E\u0635 \u0644\u0645 \u064A\u0631\u062F\u0651."
              },
              offer: {
                term: "\u2026 \u064A\u0631\u064A\u062F \u062A\u0639\u064A\u064A\u0646\u0643 \u0645\u0627\u0644\u0643\u064B\u0627",
                text: "\u0634\u0631\u064A\u0637 \u062E\u0627\u0635 \u0628\u0627\u0644\u0645\u0634\u0631\u0641 \u0627\u0644\u0645\u062E\u062A\u0627\u0631: \u064A\u0634\u0631\u062D \u0645\u0627 \u0633\u062A\u062A\u0648\u0644\u0627\u0647 (\u0627\u0644\u0641\u0648\u062A\u0631\u0629 \u0648\u062D\u0630\u0641 \u0627\u0644\u0645\u0624\u0633\u0633\u0629 \u0648\u0646\u0642\u0644 \u0645\u0644\u0643\u064A\u062A\u0647\u0627)."
              },
              accept: {
                term: "\u0642\u0628\u0648\u0644",
                text: "\u064A\u0641\u062A\u062D \u062A\u0623\u0643\u064A\u062F \xAB\u0623\u0635\u0628\u062D \u0627\u0644\u0645\u0627\u0644\u0643\xBB. \u064A\u062C\u0628 \u0623\u0646 \u062A\u0624\u0643\u062F \u0647\u0648\u064A\u062A\u0643\u060C \u062B\u0645 \u062A\u0635\u0628\u062D \u0623\u0646\u062A \u0627\u0644\u0645\u0627\u0644\u0643 \u0648\u064A\u0635\u0628\u062D \u0627\u0644\u0645\u0627\u0644\u0643 \u0627\u0644\u0633\u0627\u0628\u0642 \u0645\u0634\u0631\u0641\u064B\u0627."
              },
              decline: {
                term: "\u0631\u0641\u0636",
                text: "\u064A\u0631\u0641\u0636 \u0627\u0644\u0627\u0642\u062A\u0631\u0627\u062D \u0648\u0644\u0627 \u064A\u062A\u063A\u064A\u0651\u0631 \u0634\u064A\u0621 \u0641\u064A \u0627\u0644\u0623\u062F\u0648\u0627\u0631."
              }
            }
          },
          filters: {
            title: "\u062A\u0635\u0641\u064A\u0629 \u0627\u0644\u0623\u0639\u0636\u0627\u0621",
            items: {
              search: {
                term: "\u0627\u0644\u0628\u062D\u062B \u0639\u0646 \u0639\u0636\u0648",
                text: "\u062D\u0642\u0644 \u0628\u062D\u062B (\xAB\u0627\u0644\u0627\u0633\u0645 \u0623\u0648 \u0639\u0646\u0648\u0627\u0646 \u0627\u0644\u0628\u0631\u064A\u062F \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A\xBB). \u062A\u0636\u064A\u0642 \u0627\u0644\u0642\u0627\u0626\u0645\u0629 \u0623\u062B\u0646\u0627\u0621 \u0627\u0644\u0643\u062A\u0627\u0628\u0629."
              },
              role: {
                term: "\u0627\u0644\u062A\u0635\u0641\u064A\u0629 \u062D\u0633\u0628 \u0627\u0644\u062F\u0648\u0631",
                text: "\u0627\u062E\u062A\u0631 \u062F\u0648\u0631\u064B\u0627 \u0644\u062A\u0631\u0649 \u0627\u0644\u0623\u0634\u062E\u0627\u0635 \u0627\u0644\u0630\u064A\u0646 \u064A\u0645\u0644\u0643\u0648\u0646\u0647 \u0641\u0642\u0637\u060C \u0623\u0648 \xAB\u0643\u0644 \u0627\u0644\u0623\u062F\u0648\u0627\u0631\xBB \u0644\u0639\u0631\u0636 \u0627\u0644\u062C\u0645\u064A\u0639."
              },
              status: {
                term: "\u0627\u0644\u062A\u0635\u0641\u064A\u0629 \u062D\u0633\u0628 \u0627\u0644\u062D\u0627\u0644\u0629",
                text: "\u0627\u062E\u062A\u0631 \u0646\u0634\u0637 \u0623\u0648 \u0645\u062F\u0639\u0648 \u0623\u0648 \u0645\u0639\u0637\u0651\u0644\u060C \u0623\u0648 \xAB\u0643\u0644 \u0627\u0644\u062D\u0627\u0644\u0627\u062A\xBB \u0644\u0639\u0631\u0636 \u0627\u0644\u062C\u0645\u064A\u0639."
              },
              clear: {
                term: "\u0645\u0633\u062D \u0639\u0648\u0627\u0645\u0644 \u0627\u0644\u062A\u0635\u0641\u064A\u0629",
                text: "\u064A\u0639\u064A\u062F \u0627\u0644\u0628\u062D\u062B \u0648\u0639\u0648\u0627\u0645\u0644 \u0627\u0644\u062A\u0635\u0641\u064A\u0629 \u0625\u0644\u0649 \u0648\u0636\u0639\u0647\u0627 \u0627\u0644\u0623\u0648\u0644. \u0648\u064A\u0638\u0647\u0631 \u0647\u0630\u0627 \u0627\u0644\u0632\u0631 \u0623\u064A\u0636\u064B\u0627 \u0639\u0646\u062F\u0645\u0627 \u0644\u0627 \u064A\u0637\u0627\u0628\u0642 \u0623\u064A \u0639\u0636\u0648."
              }
            }
          },
          table: {
            title: "\u0623\u0639\u0636\u0627\u0621 \u0627\u0644\u0645\u0624\u0633\u0633\u0629",
            items: {
              name: {
                term: "\u0627\u0644\u0627\u0633\u0645",
                text: "\u0627\u0633\u0645 \u0627\u0644\u0634\u062E\u0635 \u0645\u0639 \u0635\u0648\u0631\u062A\u0647 \u0623\u0648 \u0627\u0644\u062D\u0631\u0641\u064A\u0646 \u0627\u0644\u0623\u0648\u0644\u064A\u0646 \u0645\u0646 \u0627\u0633\u0645\u0647. \u0648\u062A\u062D\u0645\u0644 \u0633\u0637\u0631\u0643 \u0623\u0646\u062A \u0639\u0628\u0627\u0631\u0629 \xAB(\u0623\u0646\u062A)\xBB."
              },
              email: {
                term: "\u0627\u0644\u0628\u0631\u064A\u062F \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A",
                text: "\u0639\u0646\u0648\u0627\u0646 \u0627\u0644\u0628\u0631\u064A\u062F \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A \u0627\u0644\u0630\u064A \u064A\u062F\u062E\u0644 \u0628\u0647 \u0627\u0644\u0634\u062E\u0635."
              },
              role: {
                term: "\u0627\u0644\u062F\u0648\u0631",
                text: "\u0645\u0627 \u064A\u0645\u0643\u0646 \u0644\u0644\u0634\u062E\u0635 \u0641\u0639\u0644\u0647 \u0641\u064A \u0627\u0644\u0645\u0643\u062A\u0628 (\u0631\u0627\u062C\u0639 \xAB\u0627\u0644\u0623\u062F\u0648\u0627\u0631 \u0648\u0627\u0644\u0635\u0644\u0627\u062D\u064A\u0627\u062A\xBB). \u0648\u062A\u064F\u0634\u0631\u062D \u0627\u0644\u0623\u062F\u0648\u0627\u0631 \u0623\u062F\u0646\u0627\u0647."
              },
              status: {
                term: "\u0627\u0644\u062D\u0627\u0644\u0629",
                text: "\u0646\u0634\u0637: \u0627\u0644\u0634\u062E\u0635 \u064A\u0639\u0645\u0644 \u0641\u064A \u0627\u0644\u0645\u0643\u062A\u0628. \u0645\u062F\u0639\u0648: \u0644\u0645 \u064A\u0642\u0628\u0644 \u0627\u0644\u062F\u0639\u0648\u0629 \u0628\u0639\u062F. \u0645\u0639\u0637\u0651\u0644: \u0648\u0635\u0648\u0644\u0647 \u0645\u0642\u0637\u0648\u0639 \u0644\u0643\u0646 \u0648\u062B\u0627\u0626\u0642\u0647 \u062A\u0628\u0642\u0649."
              },
              joined: {
                term: "\u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0627\u0646\u0636\u0645\u0627\u0645",
                text: "\u062A\u0627\u0631\u064A\u062E \u0627\u0646\u0636\u0645\u0627\u0645 \u0627\u0644\u0634\u062E\u0635 \u0625\u0644\u0649 \u0627\u0644\u0645\u0643\u062A\u0628. \u0648\u062A\u0638\u0647\u0631 \u0634\u0631\u0637\u0629 (\u2014) \u0645\u0627 \u062F\u0627\u0645 \u0644\u0645 \u064A\u0646\u0636\u0645 \u0628\u0639\u062F."
              },
              actions: {
                term: "\u0627\u0644\u0625\u062C\u0631\u0627\u0621\u0627\u062A",
                text: "\u064A\u0641\u062A\u062D \u0627\u0644\u0632\u0631 \xAB\u2026\xBB \u0641\u064A \u0622\u062E\u0631 \u0627\u0644\u0633\u0637\u0631 \u0642\u0627\u0626\u0645\u0629: \u062A\u063A\u064A\u064A\u0631 \u0627\u0644\u062F\u0648\u0631\u060C \u0646\u0642\u0644 \u0627\u0644\u0645\u0644\u0643\u064A\u0629\u060C \u062A\u0639\u0637\u064A\u0644. \u0644\u0627 \u062A\u064F\u0639\u0631\u0636 \u0625\u0644\u0627 \u0627\u0644\u0625\u062C\u0631\u0627\u0621\u0627\u062A \u0627\u0644\u062A\u064A \u064A\u0633\u0645\u062D \u0628\u0647\u0627 \u062F\u0648\u0631\u0643\u060C \u0648\u0625\u0646 \u0644\u0645 \u064A\u0643\u0646 \u0647\u0646\u0627\u0643 \u0625\u062C\u0631\u0627\u0621 \u0645\u0645\u0643\u0646 \u0641\u0644\u0627 \u064A\u0638\u0647\u0631 \u0627\u0644\u0632\u0631."
              },
              loadMore: {
                term: "\u0639\u0631\u0636 \u0627\u0644\u0645\u0632\u064A\u062F \u0645\u0646 \u0627\u0644\u0623\u0639\u0636\u0627\u0621",
                text: "\u064A\u062D\u0645\u0651\u0644 \u0628\u0642\u064A\u0629 \u0627\u0644\u0642\u0627\u0626\u0645\u0629 \u0639\u0646\u062F\u0645\u0627 \u064A\u0643\u0648\u0646 \u0639\u062F\u062F \u0627\u0644\u0623\u0639\u0636\u0627\u0621 \u0643\u0628\u064A\u0631\u064B\u0627."
              },
              empty: {
                term: "\u0644\u0627 \u064A\u0648\u062C\u062F \u0623\u0639\u0636\u0627\u0621 \u0628\u0639\u062F",
                text: "\u0631\u0633\u0627\u0644\u0629 \u0627\u0644\u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u0641\u0627\u0631\u063A\u0629: \u0627\u062F\u0639\u064F \u0641\u0631\u064A\u0642\u0643. \u0648\u0645\u0639 \u062A\u0641\u0639\u064A\u0644 \u0639\u0648\u0627\u0645\u0644 \u0627\u0644\u062A\u0635\u0641\u064A\u0629 \u062A\u0635\u0628\u062D \xAB\u0644\u0627 \u064A\u0648\u062C\u062F \u0639\u0636\u0648 \u0645\u0637\u0627\u0628\u0642\xBB. \u0648\u0625\u0646 \u062A\u0639\u0630\u0651\u0631 \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0642\u0627\u0626\u0645\u0629 \u062A\u0638\u0647\u0631 \xAB\u062A\u0639\u0630\u0651\u0631 \u0639\u0631\u0636 \u0627\u0644\u0623\u0639\u0636\u0627\u0621\xBB \u0645\u0639 \u0632\u0631 \xAB\u0625\u0639\u0627\u062F\u0629 \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629\xBB."
              }
            }
          },
          roles: {
            title: "\u0627\u0644\u0623\u062F\u0648\u0627\u0631 \u0627\u0644\u0645\u062A\u0627\u062D\u0629",
            items: {
              owner: {
                term: "\u0645\u0627\u0644\u0643",
                text: "\u0627\u0644\u0645\u0633\u0624\u0648\u0644 \u0627\u0644\u0623\u0648\u0644 \u0639\u0646 \u0627\u0644\u0645\u0643\u062A\u0628: \u0627\u0644\u0641\u0648\u062A\u0631\u0629 \u0648\u062D\u0630\u0641 \u0627\u0644\u0645\u0624\u0633\u0633\u0629 \u0648\u0646\u0642\u0644 \u0627\u0644\u0645\u0644\u0643\u064A\u0629. \u0644\u0627 \u064A\u064F\u0645\u0646\u062D \u0628\u0640\xAB\u062A\u063A\u064A\u064A\u0631 \u0627\u0644\u062F\u0648\u0631\xBB \u0628\u0644 \u064A\u0646\u062A\u0642\u0644 \u0639\u0628\u0631 \u0646\u0642\u0644 \u0627\u0644\u0645\u0644\u0643\u064A\u0629."
              },
              admin: {
                term: "\u0645\u0634\u0631\u0641",
                text: "\u064A\u062F\u064A\u0631 \u0627\u0644\u0623\u0639\u0636\u0627\u0621 \u0648\u0627\u0644\u0625\u0639\u062F\u0627\u062F\u0627\u062A \u0648\u0627\u0644\u0645\u0627\u0644\u064A\u0629 \u0648\u0643\u0644 \u0645\u0634\u0627\u0631\u064A\u0639 \u0627\u0644\u0645\u0643\u062A\u0628."
              },
              projectManager: {
                term: "\u0631\u0626\u064A\u0633 \u0645\u0634\u0631\u0648\u0639",
                text: "\u064A\u0646\u0634\u0626 \u0645\u0634\u0627\u0631\u064A\u0639\u0647 \u0648\u064A\u062F\u064A\u0631\u0647\u0627 \u0648\u064A\u062A\u0627\u0628\u0639 \u0627\u0644\u0623\u062A\u0639\u0627\u0628 \u0648\u0623\u0648\u0642\u0627\u062A \u0627\u0644\u0639\u0645\u0644 \u0648\u0628\u064A\u0627\u0646\u0627\u062A \u0627\u0644\u0645\u0635\u0627\u0631\u064A\u0641."
              },
              engineer: {
                term: "\u0645\u0647\u0646\u062F\u0633 \u0623\u0648 \u0645\u0639\u0645\u0627\u0631\u064A",
                text: "\u064A\u0634\u0627\u0631\u0643 \u0641\u064A \u0627\u0644\u0645\u0634\u0627\u0631\u064A\u0639 \u0627\u0644\u062A\u064A \u062A\u0636\u064A\u0641\u0647 \u0625\u0644\u064A\u0647\u0627: \u0627\u0644\u0648\u062B\u0627\u0626\u0642 \u0648\u0627\u0644\u0645\u0647\u0627\u0645 \u0648\u0627\u0644\u0645\u062D\u0627\u062F\u062B\u0627\u062A."
              },
              draftsman: {
                term: "\u0631\u0633\u0651\u0627\u0645",
                text: "\u064A\u0639\u062F\u0651 \u0627\u0644\u0645\u062E\u0637\u0637\u0627\u062A \u0648\u064A\u0631\u0641\u0639\u0647\u0627 \u0641\u064A \u0627\u0644\u0645\u0634\u0627\u0631\u064A\u0639 \u0627\u0644\u062A\u064A \u062A\u0636\u064A\u0641\u0647 \u0625\u0644\u064A\u0647\u0627."
              },
              accountant: {
                term: "\u0645\u062D\u0627\u0633\u0628",
                text: "\u064A\u062F\u064A\u0631 \u0639\u0631\u0648\u0636 \u0627\u0644\u0623\u0633\u0639\u0627\u0631 \u0648\u0627\u0644\u0641\u0648\u0627\u062A\u064A\u0631 \u0648\u0627\u0644\u0645\u062F\u0641\u0648\u0639\u0627\u062A \u0648\u0627\u0644\u0634\u0624\u0648\u0646 \u0627\u0644\u062C\u0628\u0627\u0626\u064A\u0629 \u0644\u0644\u0645\u0643\u062A\u0628."
              }
            }
          },
          invitations: {
            title: "\u0627\u0644\u062F\u0639\u0648\u0627\u062A \u0627\u0644\u0645\u0639\u0644\u0651\u0642\u0629",
            items: {
              tab: {
                term: "\u0627\u0644\u062F\u0639\u0648\u0627\u062A \u0627\u0644\u0645\u0639\u0644\u0651\u0642\u0629",
                text: "\u0639\u0644\u0627\u0645\u0629 \u062A\u0628\u0648\u064A\u0628 \u0628\u062C\u0627\u0646\u0628 \xAB\u0627\u0644\u0623\u0639\u0636\u0627\u0621\xBB\u060C \u0644\u0627 \u062A\u0638\u0647\u0631 \u0625\u0644\u0627 \u0625\u0630\u0627 \u0643\u0627\u0646 \u0628\u0625\u0645\u0643\u0627\u0646\u0643 \u0627\u0644\u062F\u0639\u0648\u0629. \u062A\u0633\u0631\u062F \u0627\u0644\u0623\u0634\u062E\u0627\u0635 \u0627\u0644\u0645\u062F\u0639\u0648\u064A\u0646 \u0627\u0644\u0630\u064A\u0646 \u0644\u0645 \u064A\u0642\u0628\u0644\u0648\u0627 \u0628\u0639\u062F."
              },
              email: {
                term: "\u0627\u0644\u0628\u0631\u064A\u062F \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A",
                text: "\u0627\u0644\u0639\u0646\u0648\u0627\u0646 \u0627\u0644\u0630\u064A \u0623\u064F\u0631\u0633\u0644\u062A \u0625\u0644\u064A\u0647 \u0627\u0644\u062F\u0639\u0648\u0629."
              },
              role: {
                term: "\u0627\u0644\u062F\u0648\u0631",
                text: "\u0627\u0644\u062F\u0648\u0631 \u0627\u0644\u0630\u064A \u0633\u064A\u0643\u0648\u0646 \u0644\u0644\u0634\u062E\u0635 \u0639\u0646\u062F \u0627\u0646\u0636\u0645\u0627\u0645\u0647 \u0625\u0644\u0649 \u0627\u0644\u0645\u0643\u062A\u0628."
              },
              invitedBy: {
                term: "\u062A\u0645\u062A \u0627\u0644\u062F\u0639\u0648\u0629 \u0645\u0646",
                text: "\u0627\u0644\u0639\u0636\u0648 \u0627\u0644\u0630\u064A \u0623\u0631\u0633\u0644 \u0627\u0644\u062F\u0639\u0648\u0629."
              },
              expires: {
                term: "\u062A\u0646\u062A\u0647\u064A \u0641\u064A",
                text: "\u0622\u062E\u0631 \u0645\u0648\u0639\u062F \u0644\u0644\u0642\u0628\u0648\u0644 (7 \u0623\u064A\u0627\u0645 \u0628\u0639\u062F \u0627\u0644\u0625\u0631\u0633\u0627\u0644). \u0648\u062A\u0638\u0647\u0631 \u0634\u0627\u0631\u0629 \xAB\u0645\u0646\u062A\u0647\u064A\u0629 \u0627\u0644\u0635\u0644\u0627\u062D\u064A\u0629\xBB \u0639\u0646\u062F\u0645\u0627 \u064A\u0645\u0631\u0651 \u0647\u0630\u0627 \u0627\u0644\u0645\u0648\u0639\u062F."
              },
              resend: {
                term: "\u0625\u0639\u0627\u062F\u0629 \u0627\u0644\u0625\u0631\u0633\u0627\u0644",
                text: "\u064A\u0631\u0633\u0644 \u0631\u0633\u0627\u0644\u0629 \u0627\u0644\u062F\u0639\u0648\u0629 \u0625\u0644\u0649 \u0647\u0630\u0627 \u0627\u0644\u0639\u0646\u0648\u0627\u0646 \u0645\u0646 \u062C\u062F\u064A\u062F."
              },
              revoke: {
                term: "\u0625\u0644\u063A\u0627\u0621",
                text: "\u0628\u0639\u062F \u0627\u0644\u062A\u0623\u0643\u064A\u062F \u064A\u062A\u0648\u0642\u0641 \u0627\u0644\u0631\u0627\u0628\u0637 \u0627\u0644\u0630\u064A \u0648\u0635\u0644 \u0628\u0627\u0644\u0628\u0631\u064A\u062F \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A \u0639\u0646 \u0627\u0644\u0639\u0645\u0644. \u0648\u064A\u0645\u0643\u0646\u0643 \u062F\u0639\u0648\u0629 \u0627\u0644\u0634\u062E\u0635 \u0645\u0646 \u062C\u062F\u064A\u062F."
              },
              empty: {
                term: "\u0644\u0627 \u062A\u0648\u062C\u062F \u062F\u0639\u0648\u0627\u062A \u0645\u0639\u0644\u0651\u0642\u0629",
                text: "\u0631\u0633\u0627\u0644\u0629 \u062A\u0638\u0647\u0631 \u0639\u0646\u062F\u0645\u0627 \u064A\u0643\u0648\u0646 \u0627\u0644\u062C\u0645\u064A\u0639 \u0642\u062F \u0642\u0628\u0644\u0648\u0627. \u0648\u064A\u064F\u0639\u0631\u0636 \u0641\u064A\u0647\u0627 \u0632\u0631 \xAB\u062F\u0639\u0648\u0629\xBB."
              }
            }
          },
          inviteDialog: {
            title: "\u062F\u0639\u0648\u0629 \u0639\u0636\u0648",
            items: {
              email: {
                term: "\u0627\u0644\u0628\u0631\u064A\u062F \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A",
                text: "\u0625\u0644\u0632\u0627\u0645\u064A. \u0639\u0646\u0648\u0627\u0646 \u0627\u0644\u0634\u062E\u0635 \u0627\u0644\u0645\u0631\u0627\u062F \u062F\u0639\u0648\u062A\u0647. \u064A\u062A\u0644\u0642\u0649 \u0631\u0633\u0627\u0644\u0629 \u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A\u0629 \u062A\u062A\u0636\u0645\u0646 \u0631\u0627\u0628\u0637\u064B\u0627 \u0644\u0644\u0627\u0646\u0636\u0645\u0627\u0645 \u0625\u0644\u0649 \u0645\u0643\u062A\u0628\u0643\u060C \u0635\u0627\u0644\u062D\u064B\u0627 \u0644\u0645\u062F\u0629 7 \u0623\u064A\u0627\u0645."
              },
              role: {
                term: "\u0627\u0644\u062F\u0648\u0631",
                text: "\u0625\u0644\u0632\u0627\u0645\u064A. \u0627\u062E\u062A\u0631 \u0645\u0634\u0631\u0641 \u0623\u0648 \u0631\u0626\u064A\u0633 \u0645\u0634\u0631\u0648\u0639 \u0623\u0648 \u0645\u0647\u0646\u062F\u0633 \u0623\u0648 \u0645\u0639\u0645\u0627\u0631\u064A \u0623\u0648 \u0631\u0633\u0651\u0627\u0645 \u0623\u0648 \u0645\u062D\u0627\u0633\u0628. \u0648\u062A\u0635\u0641 \u062C\u0645\u0644\u0629 \u062A\u062D\u062A \u0627\u0644\u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u062F\u0648\u0631 \u0627\u0644\u0645\u062E\u062A\u0627\u0631."
              },
              locale: {
                term: "\u0644\u063A\u0629 \u0627\u0644\u0631\u0633\u0627\u0644\u0629",
                text: "\u0627\u0644\u0644\u063A\u0629 \u0627\u0644\u062A\u064A \u062A\u064F\u0643\u062A\u0628 \u0628\u0647\u0627 \u0627\u0644\u062F\u0639\u0648\u0629: \u2066Fran\u2069\xE7\u2066ais\u2069 \u0623\u0648 \u0627\u0644\u0639\u0631\u0628\u064A\u0629 \u0623\u0648 \u2066English\u2069."
              },
              submit: {
                term: "\u0625\u0631\u0633\u0627\u0644 \u0627\u0644\u062F\u0639\u0648\u0629",
                text: "\u064A\u0631\u0633\u0644 \u0627\u0644\u0631\u0633\u0627\u0644\u0629 \u062B\u0645 \u062A\u0624\u0643\u062F \u0631\u0633\u0627\u0644\u0629 \u0623\u0646\u0647\u0627 \u0623\u064F\u0631\u0633\u0644\u062A. \u0648\u0625\u0646 \u0643\u0627\u0646 \u0627\u0644\u0639\u0646\u0648\u0627\u0646 \u0641\u0627\u0631\u063A\u064B\u0627 \u0623\u0648 \u063A\u064A\u0631 \u0635\u062D\u064A\u062D \u0641\u064A\u0638\u0647\u0631 \u062E\u0637\u0623 \u062A\u062D\u062A \u0627\u0644\u062D\u0642\u0644."
              },
              alreadyMember: {
                term: "\u0647\u0630\u0627 \u0627\u0644\u0639\u0646\u0648\u0627\u0646 \u064A\u062E\u0635\u0651 \u0639\u0636\u0648\u064B\u0627 \u0641\u064A \u0645\u0643\u062A\u0628\u0643 \u0628\u0627\u0644\u0641\u0639\u0644.",
                text: "\u0631\u0633\u0627\u0644\u0629 \u062A\u062D\u062A \u062D\u0642\u0644 \u0627\u0644\u0628\u0631\u064A\u062F \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A: \u0627\u0644\u0634\u062E\u0635 \u0645\u0648\u062C\u0648\u062F \u0641\u064A \u0627\u0644\u0642\u0627\u0626\u0645\u0629\u060C \u0641\u0644\u0627 \u062D\u0627\u062C\u0629 \u0625\u0644\u0649 \u062F\u0639\u0648\u062A\u0647."
              },
              resendExisting: {
                term: "\u0625\u0639\u0627\u062F\u0629 \u0625\u0631\u0633\u0627\u0644 \u0627\u0644\u062F\u0639\u0648\u0629",
                text: "\u0639\u0646\u062F\u0645\u0627 \u062A\u0648\u062C\u062F \u062F\u0639\u0648\u0629 \u0645\u0639\u0644\u0651\u0642\u0629 \u0644\u0647\u0630\u0627 \u0627\u0644\u0639\u0646\u0648\u0627\u0646\u060C \u064A\u0639\u064A\u062F \u0647\u0630\u0627 \u0627\u0644\u0632\u0631 \u0625\u0631\u0633\u0627\u0644\u0647\u0627 \u0628\u062F\u0644 \u0625\u0646\u0634\u0627\u0621 \u062F\u0639\u0648\u0629 \u062B\u0627\u0646\u064A\u0629."
              },
              seatsFull: {
                term: "\u062C\u0645\u064A\u0639 \u0645\u0642\u0627\u0639\u062F \u0639\u0631\u0636\u0643 \u0645\u0633\u062A\u0639\u0645\u0644\u0629",
                text: "\u0631\u0633\u0627\u0644\u0629 \u062A\u0638\u0647\u0631 \u0639\u0646\u062F\u0645\u0627 \u064A\u0643\u0648\u0646 \u0627\u0644\u0639\u0631\u0636 \u0645\u0643\u062A\u0645\u0644\u064B\u0627. \u064A\u064F\u0631\u0634\u064E\u062F \u0627\u0644\u0645\u0627\u0644\u0643 \u0625\u0644\u0649 \u0625\u0636\u0627\u0641\u0629 \u0645\u0642\u0639\u062F \u0623\u0648 \u062A\u063A\u064A\u064A\u0631 \u0627\u0644\u0639\u0631\u0636\u060C \u0648\u064A\u064F\u0637\u0644\u0628 \u0645\u0646 \u0627\u0644\u0623\u0639\u0636\u0627\u0621 \u0627\u0644\u0622\u062E\u0631\u064A\u0646 \u0645\u0631\u0627\u062C\u0639\u062A\u0647."
              },
              cancel: {
                term: "\u0625\u0644\u063A\u0627\u0621",
                text: "\u064A\u063A\u0644\u0642 \u0627\u0644\u0646\u0627\u0641\u0630\u0629 \u062F\u0648\u0646 \u0625\u0631\u0633\u0627\u0644 \u0623\u064A \u0634\u064A\u0621."
              }
            }
          },
          memberDialogs: {
            title: "\u0646\u0648\u0627\u0641\u0630 \u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u0625\u062C\u0631\u0627\u0621\u0627\u062A",
            items: {
              changeRole: {
                term: "\u062A\u063A\u064A\u064A\u0631 \u0627\u0644\u062F\u0648\u0631",
                text: "\u0627\u062E\u062A\u0631 \xAB\u0627\u0644\u062F\u0648\u0631 \u0627\u0644\u062C\u062F\u064A\u062F\xBB. \u0644\u0627 \u064A\u064F\u0639\u0631\u0636 \u0627\u0644\u062F\u0648\u0631 \u0627\u0644\u062D\u0627\u0644\u064A \u0648\u0644\u0627 \u064A\u0645\u0643\u0646 \u062A\u0639\u064A\u064A\u0646 \u0645\u0627\u0644\u0643 \u0647\u0646\u0627. \u0648\u0642\u062F \u064A\u064F\u0637\u0644\u0628 \u062A\u0623\u0643\u064A\u062F \u0627\u0644\u0647\u0648\u064A\u0629 \u0642\u0628\u0644 \u062A\u0637\u0628\u064A\u0642 \u0627\u0644\u062A\u063A\u064A\u064A\u0631."
              },
              deactivate: {
                term: "\u062A\u0639\u0637\u064A\u0644",
                text: "\u0645\u0639\u0627\u0644\u062C \u0645\u0646 \u062B\u0644\u0627\u062B \u062E\u0637\u0648\u0627\u062A. \u0623\u0648\u0644\u064B\u0627 \u0645\u0644\u062E\u0635: \u064A\u0646\u0642\u0637\u0639 \u0627\u0644\u0648\u0635\u0648\u0644 \u0641\u0648\u0631\u064B\u0627 \u0639\u0644\u0649 \u062C\u0645\u064A\u0639 \u0627\u0644\u0623\u062C\u0647\u0632\u0629\u060C \u0648\u062A\u0628\u0642\u0649 \u0627\u0644\u0648\u062B\u0627\u0626\u0642 \u0648\u0627\u0644\u0631\u0633\u0627\u0626\u0644 \u0648\u0627\u0644\u0645\u0647\u0627\u0645 \u0641\u064A \u0645\u0643\u0627\u0646\u0647\u0627 \u0628\u0627\u0633\u0645 \u0627\u0644\u0634\u062E\u0635\u060C \u0648\u064A\u064F\u062D\u0631\u064E\u0651\u0631 \u0627\u0644\u0645\u0642\u0639\u062F \u0641\u064A \u0641\u062A\u0631\u0629 \u0627\u0644\u0641\u0648\u062A\u0631\u0629 \u0627\u0644\u0645\u0642\u0628\u0644\u0629."
              },
              defaultSuccessor: {
                term: "\u0627\u0644\u0645\u0633\u062A\u0644\u0645 \u0627\u0644\u0627\u0641\u062A\u0631\u0627\u0636\u064A",
                text: "\u0627\u0644\u062E\u0637\u0648\u0629 \u0627\u0644\u062B\u0627\u0646\u064A\u0629: \u0625\u0646 \u0648\u064F\u062C\u062F\u062A \u0639\u0646\u0627\u0635\u0631 \u064A\u062C\u0628 \u0625\u0633\u0646\u0627\u062F\u0647\u0627 \u0641\u0627\u062E\u062A\u0631 \u0645\u0646 \u064A\u062A\u0648\u0644\u0627\u0647\u0627\u060C \u0648\u0627\u062D\u062F\u064B\u0627 \u0648\u0627\u062D\u062F\u064B\u0627 (\xAB\u0627\u0633\u062A\u062E\u062F\u0627\u0645 \u0627\u0644\u0645\u0633\u062A\u0644\u0645 \u0627\u0644\u0627\u0641\u062A\u0631\u0627\u0636\u064A\xBB) \u0623\u0648 \u062C\u0645\u064A\u0639\u0647\u0627 \u062F\u0641\u0639\u0629 \u0648\u0627\u062D\u062F\u0629 \u0628\u0627\u0644\u0645\u0633\u062A\u0644\u0645 \u0627\u0644\u0627\u0641\u062A\u0631\u0627\u0636\u064A. \u0648\u0625\u0646 \u0644\u0645 \u062A\u0648\u062C\u062F \u0639\u0646\u0627\u0635\u0631 \u0641\u062A\u0634\u064A\u0631 \u0627\u0644\u062E\u0637\u0648\u0629 \u0625\u0644\u0649 \u0630\u0644\u0643."
              },
              confirmDeactivate: {
                term: "\u062A\u0639\u0637\u064A\u0644 \u2026\u061F",
                text: "\u0627\u0644\u062E\u0637\u0648\u0629 \u0627\u0644\u0623\u062E\u064A\u0631\u0629: \u0627\u0644\u062A\u0623\u0643\u064A\u062F. \u064A\u0641\u0642\u062F \u0627\u0644\u0634\u062E\u0635 \u0627\u0644\u0648\u0635\u0648\u0644 \u0641\u0648\u0631\u064B\u0627 \u0648\u064A\u064F\u0630\u0643\u064E\u0651\u0631 \u0628\u0639\u062F\u062F \u0627\u0644\u0639\u0646\u0627\u0635\u0631 \u0627\u0644\u0645\u0646\u0642\u0648\u0644\u0629. \u0648\u0642\u062F \u064A\u064F\u0637\u0644\u0628 \u062A\u0623\u0643\u064A\u062F \u0627\u0644\u0647\u0648\u064A\u0629."
              },
              transfer: {
                term: "\u0646\u0642\u0644 \u0627\u0644\u0645\u0644\u0643\u064A\u0629",
                text: "\u062E\u0627\u0635 \u0628\u0627\u0644\u0645\u0627\u0644\u0643 \u0648\u064A\u0643\u0648\u0646 \u0625\u0644\u0649 \u0645\u0634\u0631\u0641. \u064A\u0631\u0633\u0644 \xAB\u0625\u0631\u0633\u0627\u0644 \u0627\u0644\u0627\u0642\u062A\u0631\u0627\u062D\xBB \u0627\u0644\u0637\u0644\u0628 \u0627\u0644\u0630\u064A \u0639\u0644\u064A\u0647 \u0642\u0628\u0648\u0644\u0647 (\u0631\u0627\u062C\u0639 \u0627\u0644\u0634\u0631\u064A\u0637 \u0641\u064A \u0627\u0644\u0623\u0639\u0644\u0649). \u0648\u064A\u0645\u0643\u0646\u0643 \u0625\u0644\u063A\u0627\u0624\u0647 \u0645\u0627 \u062F\u0627\u0645 \u0644\u0645 \u064A\u0631\u062F\u0651."
              }
            }
          }
        }
      },
      roles: {
        title: "\u0627\u0644\u0623\u062F\u0648\u0627\u0631 \u0648\u0627\u0644\u0635\u0644\u0627\u062D\u064A\u0627\u062A",
        intro: "\u062A\u0639\u0631\u0636 \u0647\u0630\u0647 \u0627\u0644\u0635\u0641\u062D\u0629 \u0641\u064A \u062C\u062F\u0648\u0644 \u0645\u0627 \u064A\u0645\u0643\u0646 \u0644\u0643\u0644 \u062F\u0648\u0631 \u0641\u0639\u0644\u0647 \u0641\u064A \u0645\u0643\u062A\u0628\u0643. \u0648\u062A\u0633\u0627\u0639\u062F\u0643 \u0639\u0644\u0649 \u0627\u062E\u062A\u064A\u0627\u0631 \u0627\u0644\u062F\u0648\u0631 \u0627\u0644\u0645\u0646\u0627\u0633\u0628 \u0639\u0646\u062F \u062F\u0639\u0648\u0629 \u0634\u062E\u0635.",
        sections: {
          header: {
            title: "\u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u0625\u062F\u0627\u0631\u0629 \u0648\u0631\u0623\u0633 \u0627\u0644\u0635\u0641\u062D\u0629",
            items: {
              adminNav: {
                term: "\u0627\u0644\u0625\u062F\u0627\u0631\u0629",
                text: "\u062A\u062C\u0645\u0639 \u0627\u0644\u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u062C\u0627\u0646\u0628\u064A\u0629 \u0635\u0641\u062D\u0627\u062A \u0625\u062F\u0627\u0631\u0629 \u0645\u0624\u0633\u0633\u062A\u0643 (\u0635\u0641\u0651 \u0645\u0646 \u0627\u0644\u0631\u0648\u0627\u0628\u0637 \u0641\u0648\u0642 \u0627\u0644\u0635\u0641\u062D\u0629 \u0639\u0644\u0649 \u0627\u0644\u0634\u0627\u0634\u0627\u062A \u0627\u0644\u0635\u063A\u064A\u0631\u0629). \u0648\u0644\u0627 \u062A\u0639\u0631\u0636 \u0625\u0644\u0627 \u0627\u0644\u0635\u0641\u062D\u0627\u062A \u0627\u0644\u062A\u064A \u064A\u0633\u0645\u062D \u0644\u0643 \u062F\u0648\u0631\u0643 \u0628\u0641\u062A\u062D\u0647\u0627."
              },
              readOnly: {
                term: "\u0627\u0644\u0623\u062F\u0648\u0627\u0631 \u0648\u0627\u0644\u0635\u0644\u0627\u062D\u064A\u0627\u062A",
                text: "\u0627\u0644\u0623\u062F\u0648\u0627\u0631 \u0627\u0644\u0633\u062A\u0629 \u064A\u062D\u062F\u0651\u062F\u0647\u0627 \u2066BatiFlow\u2069\u060C \u0648\u0647\u0630\u0627 \u0627\u0644\u062C\u062F\u0648\u0644 \u0644\u0644\u0642\u0631\u0627\u0621\u0629 \u0641\u0642\u0637 \u0648\u0644\u0627 \u064A\u0645\u0643\u0646 \u062A\u0639\u062F\u064A\u0644 \u0623\u064A \u0634\u064A\u0621 \u0641\u064A\u0647."
              },
              scroll: {
                term: "\u062C\u062F\u0648\u0644 \u0627\u0644\u0635\u0644\u0627\u062D\u064A\u0627\u062A \u062D\u0633\u0628 \u0627\u0644\u062F\u0648\u0631 (\u064A\u0645\u0643\u0646 \u062A\u0645\u0631\u064A\u0631\u0647 \u0623\u0641\u0642\u064A\u064B\u0627)",
                text: "\u0639\u0644\u0649 \u0627\u0644\u0634\u0627\u0634\u0629 \u0627\u0644\u0635\u063A\u064A\u0631\u0629 \u064A\u064F\u0645\u0631\u064E\u0651\u0631 \u0627\u0644\u062C\u062F\u0648\u0644 \u062C\u0627\u0646\u0628\u064A\u064B\u0627 \u0648\u064A\u0628\u0642\u0649 \u0639\u0645\u0648\u062F \u0627\u0644\u0635\u0644\u0627\u062D\u064A\u0627\u062A \u0638\u0627\u0647\u0631\u064B\u0627. \u0648\u062A\u064F\u0642\u0631\u0623 \u0643\u0644 \u062E\u0627\u0646\u0629 \u0623\u064A\u0636\u064B\u0627 \u0628\u0627\u0644\u0643\u0644\u0645\u0627\u062A \u0628\u0648\u0627\u0633\u0637\u0629 \u0642\u0627\u0631\u0626 \u0627\u0644\u0634\u0627\u0634\u0629."
              }
            }
          },
          legend: {
            title: "\u062F\u0644\u064A\u0644 \u0631\u0645\u0648\u0632 \u0627\u0644\u062C\u062F\u0648\u0644",
            items: {
              yes: {
                term: "\u0645\u0645\u0646\u0648\u062D\u0629",
                text: "\u0639\u0644\u0627\u0645\u0629 \u0635\u062D: \u0627\u0644\u062F\u0648\u0631 \u064A\u0645\u0644\u0643 \u0647\u0630\u0647 \u0627\u0644\u0635\u0644\u0627\u062D\u064A\u0629."
              },
              project: {
                term: "\u0645\u0645\u0646\u0648\u062D\u0629 \u0641\u064A \u0645\u0634\u0627\u0631\u064A\u0639\u0647 \u0627\u0644\u062E\u0627\u0635\u0629 \u0641\u0642\u0637",
                text: "\u0627\u0644\u062D\u0631\u0641 \u2066P\u2069: \u064A\u0645\u0644\u0643 \u0627\u0644\u062F\u0648\u0631 \u0627\u0644\u0635\u0644\u0627\u062D\u064A\u0629 \u0641\u064A \u0627\u0644\u0645\u0634\u0627\u0631\u064A\u0639 \u0627\u0644\u062A\u064A \u064A\u062A\u0648\u0644\u0627\u0647\u0627 \u0641\u0642\u0637."
              },
              delegable: {
                term: "\u063A\u064A\u0631 \u0645\u0645\u0646\u0648\u062D\u0629 \u0627\u0641\u062A\u0631\u0627\u0636\u064A\u064B\u0627\u060C \u0648\u064A\u0645\u0643\u0646 \u0644\u0644\u0645\u0627\u0644\u0643 \u062A\u0641\u0648\u064A\u0636\u0647\u0627",
                text: "\u0627\u0644\u062D\u0631\u0641 \u2066D\u2069: \u0644\u0627 \u064A\u0645\u0644\u0643\u0647\u0627 \u0627\u0644\u0645\u0634\u0631\u0641 \u062A\u0644\u0642\u0627\u0626\u064A\u064B\u0627\u060C \u0644\u0643\u0646 \u064A\u0645\u0643\u0646 \u0644\u0644\u0645\u0627\u0644\u0643 \u0623\u0646 \u064A\u0645\u0646\u062D\u0647 \u0625\u064A\u0627\u0647\u0627."
              },
              no: {
                term: "\u063A\u064A\u0631 \u0645\u0645\u0646\u0648\u062D\u0629",
                text: "\u0634\u0631\u0637\u0629: \u0627\u0644\u062F\u0648\u0631 \u0644\u0627 \u064A\u0645\u0644\u0643 \u0647\u0630\u0647 \u0627\u0644\u0635\u0644\u0627\u062D\u064A\u0629."
              }
            }
          },
          table: {
            title: "\u0627\u0644\u0635\u0644\u0627\u062D\u064A\u0627\u062A \u0627\u0644\u0645\u0645\u0646\u0648\u062D\u0629 \u0644\u0643\u0644 \u062F\u0648\u0631",
            items: {
              permission: {
                term: "\u0627\u0644\u0635\u0644\u0627\u062D\u064A\u0629",
                text: "\u0627\u0644\u0639\u0645\u0648\u062F \u0627\u0644\u0623\u064A\u0633\u0631: \u0645\u0627 \u064A\u0645\u0643\u0646 \u0641\u0639\u0644\u0647\u060C \u0645\u062B\u0644 \xAB\u062A\u0639\u062F\u064A\u0644 \u0645\u0644\u0641 \u0627\u0644\u0645\u0643\u062A\u0628\xBB \u0623\u0648 \xAB\u062F\u0639\u0648\u0629 \u0623\u0639\u0636\u0627\u0621\xBB."
              },
              roleColumns: {
                term: "\u0645\u0627\u0644\u0643\u060C \u0645\u0634\u0631\u0641\u060C \u0631\u0626\u064A\u0633 \u0645\u0634\u0631\u0648\u0639\u060C \u0645\u0647\u0646\u062F\u0633 \u0623\u0648 \u0645\u0639\u0645\u0627\u0631\u064A\u060C \u0631\u0633\u0651\u0627\u0645\u060C \u0645\u062D\u0627\u0633\u0628",
                text: "\u0639\u0645\u0648\u062F \u0644\u0643\u0644 \u062F\u0648\u0631. \u0627\u0642\u0631\u0623 \u0633\u0637\u0631 \u0627\u0644\u0635\u0644\u0627\u062D\u064A\u0629 \u0645\u0646 \u062C\u0627\u0646\u0628 \u0625\u0644\u0649 \u0622\u062E\u0631 \u0644\u062A\u0639\u0631\u0641 \u0623\u064A \u0627\u0644\u0623\u062F\u0648\u0627\u0631 \u062A\u0645\u0644\u0643\u0647\u0627."
              }
            }
          },
          areas: {
            title: "\u0645\u062C\u0645\u0648\u0639\u0627\u062A \u0627\u0644\u0635\u0644\u0627\u062D\u064A\u0627\u062A",
            items: {
              organization: {
                term: "\u0627\u0644\u0645\u0624\u0633\u0633\u0629",
                text: "\u0645\u0644\u0641 \u0627\u0644\u0645\u0643\u062A\u0628 \u0648\u0627\u0644\u0645\u0644\u0641 \u0627\u0644\u062C\u0628\u0627\u0626\u064A \u0648\u0627\u0644\u0633\u064A\u0627\u0633\u0627\u062A \u0648\u062D\u0630\u0641 \u0627\u0644\u0645\u0624\u0633\u0633\u0629 \u0648\u0646\u0642\u0644 \u0627\u0644\u0645\u0644\u0643\u064A\u0629 \u0648\u062A\u0635\u062F\u064A\u0631 \u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A."
              },
              billing: {
                term: "\u0627\u0644\u0627\u0634\u062A\u0631\u0627\u0643",
                text: "\u0627\u0644\u0627\u0637\u0644\u0627\u0639 \u0639\u0644\u0649 \u0627\u0644\u0627\u0634\u062A\u0631\u0627\u0643 \u0648\u0641\u0648\u0627\u062A\u064A\u0631 \u2066BatiFlow\u2069 \u0648\u0625\u062F\u0627\u0631\u0629 \u0627\u0644\u0627\u0634\u062A\u0631\u0627\u0643 \u0648\u0627\u0644\u0645\u0642\u0627\u0639\u062F."
              },
              members: {
                term: "\u0627\u0644\u0623\u0639\u0636\u0627\u0621 \u0648\u0627\u0644\u0623\u062F\u0648\u0627\u0631",
                text: "\u0639\u0631\u0636 \u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u0623\u0639\u0636\u0627\u0621 \u0648\u0627\u0644\u062F\u0639\u0648\u0629 \u0648\u062A\u063A\u064A\u064A\u0631 \u0627\u0644\u062F\u0648\u0631 \u0648\u0627\u0644\u062A\u0639\u0637\u064A\u0644 \u0648\u0625\u062F\u0627\u0631\u0629 \u0627\u0644\u0623\u062F\u0648\u0627\u0631."
              },
              audit: {
                term: "\u0633\u062C\u0644 \u0627\u0644\u062A\u062F\u0642\u064A\u0642",
                text: "\u0627\u0644\u0627\u0637\u0644\u0627\u0639 \u0639\u0644\u0649 \u0627\u0644\u0633\u062C\u0644 (\u0648\u0646\u0633\u062E\u062A\u0647 \u0627\u0644\u0645\u0627\u0644\u064A\u0629) \u0648\u062A\u0635\u062F\u064A\u0631\u0647 \u0648\u0627\u0644\u062A\u062D\u0642\u0642 \u0645\u0646 \u0633\u0644\u0627\u0645\u062A\u0647."
              },
              clientsProjects: {
                term: "\u0627\u0644\u062D\u0631\u0641\u0627\u0621\u060C \u0627\u0644\u0645\u0634\u0627\u0631\u064A\u0639",
                text: "\u0639\u0631\u0636 \u0627\u0644\u062D\u0631\u0641\u0627\u0621 \u0648\u0625\u0646\u0634\u0627\u0624\u0647\u0645 \u0648\u062A\u0639\u062F\u064A\u0644\u0647\u0645 \u0648\u0623\u0631\u0634\u0641\u062A\u0647\u0645\u060C \u0648\u0625\u0646\u0634\u0627\u0621 \u0627\u0644\u0645\u0634\u0627\u0631\u064A\u0639 \u0648\u0639\u0631\u0636 \u0643\u0644 \u0627\u0644\u0645\u0634\u0627\u0631\u064A\u0639 \u0623\u0648 \u0625\u062F\u0627\u0631\u062A\u0647\u0627\u060C \u0648\u0639\u0631\u0636 \u0627\u0644\u0623\u062A\u0639\u0627\u0628."
              },
              sharing: {
                term: "\u0627\u0644\u0645\u0634\u0627\u0631\u0643\u0629 \u0648\u0627\u0644\u0645\u0633\u0627\u062D\u0627\u062A",
                text: "\u0625\u0646\u0634\u0627\u0621 \u0645\u0633\u0627\u062D\u0627\u062A \u0627\u0644\u062A\u0639\u0627\u0648\u0646 \u0648\u0645\u0634\u0627\u0631\u0643\u062A\u0647\u0627 \u0645\u0639 \u0627\u0644\u0623\u0637\u0631\u0627\u0641 \u0627\u0644\u062E\u0627\u0631\u062C\u064A\u0629 \u0648\u0627\u0644\u0645\u0648\u0627\u0641\u0642\u0629 \u0639\u0644\u0649 \u0648\u0635\u0648\u0644 \u0627\u0644\u0645\u062A\u062F\u062E\u0644\u064A\u0646 \u0627\u0644\u062E\u0627\u0631\u062C\u064A\u064A\u0646 \u0648\u0646\u0634\u0631 \u0627\u0644\u0648\u062B\u0627\u0626\u0642 \u0644\u0644\u062D\u0631\u064A\u0641."
              },
              financeTime: {
                term: "\u0627\u0644\u0645\u0627\u0644\u064A\u0629\u060C \u0627\u0644\u0648\u0642\u062A \u0648\u0627\u0644\u062A\u0643\u0627\u0644\u064A\u0641",
                text: "\u0639\u0631\u0648\u0636 \u0627\u0644\u0623\u0633\u0639\u0627\u0631 \u0648\u0627\u0644\u0639\u0642\u0648\u062F \u0648\u0627\u0644\u0641\u0648\u0627\u062A\u064A\u0631 \u0648\u0627\u0644\u0645\u062F\u0641\u0648\u0639\u0627\u062A \u0648\u0628\u064A\u0627\u0646\u0627\u062A \u0627\u0644\u0645\u0635\u0627\u0631\u064A\u0641 \u0648\u0644\u0648\u062D\u0629 \u0627\u0644\u0642\u064A\u0627\u062F\u0629 \u0627\u0644\u0645\u0627\u0644\u064A\u0629 \u0648\u0627\u0644\u0645\u0632\u0648\u0651\u062F\u0648\u0646\u060C \u0648\u062A\u0633\u062C\u064A\u0644 \u0623\u0648\u0642\u0627\u062A \u0627\u0644\u0639\u0645\u0644 \u0648\u0627\u0644\u0645\u0648\u0627\u0641\u0642\u0629 \u0639\u0644\u064A\u0647\u0627 \u0648\u062A\u0643\u0644\u0641\u0629 \u0627\u0644\u0633\u0627\u0639\u0629 \u0648\u0627\u0644\u0623\u062C\u0648\u0631."
              },
              other: {
                term: "\u0623\u062E\u0631\u0649",
                text: "\u0627\u0644\u0635\u0644\u0627\u062D\u064A\u0627\u062A \u0627\u0644\u062A\u064A \u0644\u0627 \u062A\u062F\u062E\u0644 \u0641\u064A \u0623\u064A \u0645\u062C\u0645\u0648\u0639\u0629\u060C \u0645\u062B\u0644 \u0625\u062F\u0627\u0631\u0629 \u0637\u0644\u0628\u0627\u062A \u0627\u0644\u0639\u0631\u0648\u0636 \u0648\u0642\u0648\u0627\u0626\u0645 \u0627\u0644\u0645\u0631\u0627\u062C\u0639\u0629."
              }
            }
          }
        }
      },
      profile: {
        title: "\u0627\u0644\u0645\u0624\u0633\u0633\u0629",
        intro: "\u062A\u0639\u0631\u0636 \u0647\u0630\u0647 \u0627\u0644\u0635\u0641\u062D\u0629 \u0627\u0644\u0647\u0648\u064A\u0629 \u0627\u0644\u0642\u0627\u0646\u0648\u0646\u064A\u0629 \u0648\u0627\u0644\u0645\u0647\u0646\u064A\u0629 \u0644\u0645\u0643\u062A\u0628 \u062F\u0631\u0627\u0633\u0627\u062A\u0643 \u0645\u0639 \u0634\u0639\u0627\u0631\u0647. \u064A\u0645\u0643\u0646 \u0644\u0643\u0644 \u0627\u0644\u0623\u0639\u0636\u0627\u0621 \u0627\u0644\u0627\u0637\u0644\u0627\u0639 \u0639\u0644\u064A\u0647\u0627\u060C \u0623\u0645\u0627 \u0627\u0644\u062A\u0639\u062F\u064A\u0644 \u0641\u0644\u0644\u0645\u0627\u0644\u0643 \u0648\u0627\u0644\u0645\u0634\u0631\u0641\u064A\u0646.",
        sections: {
          header: {
            title: "\u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u0625\u062F\u0627\u0631\u0629 \u0648\u0627\u0644\u062D\u0641\u0638",
            items: {
              adminNav: {
                term: "\u0627\u0644\u0625\u062F\u0627\u0631\u0629",
                text: "\u062A\u062C\u0645\u0639 \u0627\u0644\u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u062C\u0627\u0646\u0628\u064A\u0629 \u0635\u0641\u062D\u0627\u062A \u0625\u062F\u0627\u0631\u0629 \u0645\u0624\u0633\u0633\u062A\u0643 (\u0635\u0641\u0651 \u0645\u0646 \u0627\u0644\u0631\u0648\u0627\u0628\u0637 \u0641\u0648\u0642 \u0627\u0644\u0635\u0641\u062D\u0629 \u0639\u0644\u0649 \u0627\u0644\u0634\u0627\u0634\u0627\u062A \u0627\u0644\u0635\u063A\u064A\u0631\u0629). \u0648\u0644\u0627 \u062A\u0639\u0631\u0636 \u0625\u0644\u0627 \u0627\u0644\u0635\u0641\u062D\u0627\u062A \u0627\u0644\u062A\u064A \u064A\u0633\u0645\u062D \u0644\u0643 \u062F\u0648\u0631\u0643 \u0628\u0641\u062A\u062D\u0647\u0627."
              },
              readOnlyView: {
                term: "\u0645\u0644\u0641 \u0627\u0644\u0645\u0624\u0633\u0633\u0629",
                text: "\u0645\u0646 \u062F\u0648\u0646 \u0635\u0644\u0627\u062D\u064A\u0629 \u0627\u0644\u062A\u0639\u062F\u064A\u0644 \u062A\u0639\u0631\u0636 \u0627\u0644\u0635\u0641\u062D\u0629 \u0627\u0644\u0645\u0639\u0644\u0648\u0645\u0627\u062A \u0643\u0646\u0635 \u0639\u0627\u062F\u064A\u060C \u0645\u0639 \xAB\u063A\u064A\u0631 \u0645\u0630\u0643\u0648\u0631\xBB \u0644\u0644\u062D\u0642\u0648\u0644 \u0627\u0644\u0641\u0627\u0631\u063A\u0629\u060C \u062A\u062D\u062A \u0639\u0628\u0627\u0631\u0629 \xAB\u0627\u0644\u0645\u0627\u0644\u0643 \u0648\u0627\u0644\u0645\u0634\u0631\u0641\u0648\u0646 \u0648\u062D\u062F\u0647\u0645 \u064A\u0633\u062A\u0637\u064A\u0639\u0648\u0646 \u062A\u0639\u062F\u064A\u0644\u0647\u0627\xBB."
              },
              save: {
                term: "\u062D\u0641\u0638",
                text: "\u064A\u062D\u0641\u0638 \u0645\u0627 \u063A\u064A\u0651\u0631\u062A\u0647 \u0641\u0642\u0637 \u0641\u064A \u0643\u0627\u0645\u0644 \u0627\u0644\u0635\u0641\u062D\u0629 \u0628\u0627\u0633\u062A\u062B\u0646\u0627\u0621 \u0627\u0644\u0634\u0639\u0627\u0631. \u0648\u0625\u0646 \u0644\u0645 \u064A\u0643\u0646 \u0647\u0646\u0627\u0643 \u062C\u062F\u064A\u062F \u062A\u0638\u0647\u0631 \xAB\u0644\u0627 \u064A\u0648\u062C\u062F \u0645\u0627 \u064A\u064F\u062D\u0641\u0638\xBB. \u0648\u0625\u0646 \u0639\u062F\u0651\u0644 \u0634\u062E\u0635 \u0622\u062E\u0631 \u0627\u0644\u0645\u0644\u0641 \u0641\u064A \u0627\u0644\u0623\u062B\u0646\u0627\u0621 \u0641\u0644\u0627 \u062A\u064F\u062D\u0641\u0638 \u062A\u063A\u064A\u064A\u0631\u0627\u062A\u0643 \u0648\u064A\u064F\u0639\u0627\u062F \u062A\u062D\u0645\u064A\u0644 \u0622\u062E\u0631 \u0646\u0633\u062E\u0629."
              }
            }
          },
          identity: {
            title: "\u0647\u0648\u064A\u0629 \u0627\u0644\u0645\u0643\u062A\u0628",
            items: {
              legalName: {
                term: "\u0627\u0644\u0627\u0633\u0645 \u0627\u0644\u0642\u0627\u0646\u0648\u0646\u064A",
                text: "\u0625\u0644\u0632\u0627\u0645\u064A. \u0627\u0644\u0627\u0633\u0645 \u0627\u0644\u0631\u0633\u0645\u064A \u0644\u0645\u0643\u062A\u0628\u0643 \u0643\u0645\u0627 \u0647\u0648 \u0645\u0633\u062C\u0651\u0644 \u0641\u064A \u0627\u0644\u0633\u062C\u0644 \u0627\u0644\u062A\u062C\u0627\u0631\u064A."
              },
              tradeName: {
                term: "\u0627\u0644\u0627\u0633\u0645 \u0627\u0644\u062A\u062C\u0627\u0631\u064A (\u0627\u062E\u062A\u064A\u0627\u0631\u064A)",
                text: "\u0627\u0644\u0627\u0633\u0645 \u0627\u0644\u0630\u064A \u064A\u0639\u0631\u0641\u0643 \u0628\u0647 \u062D\u0631\u0641\u0627\u0624\u0643."
              },
              legalForm: {
                term: "\u0627\u0644\u0634\u0643\u0644 \u0627\u0644\u0642\u0627\u0646\u0648\u0646\u064A",
                text: "\u0625\u0644\u0632\u0627\u0645\u064A. \u0627\u062E\u062A\u0631 \u0645\u0646 \u0627\u0644\u0642\u0627\u0626\u0645\u0629: \u0645\u0624\u0633\u0633\u0629 \u0641\u0631\u062F\u064A\u0629 \u0623\u0648 \u2066SUARL\u2069 \u0623\u0648 \u2066SARL\u2069 \u0623\u0648 \u2066SA\u2069 \u0623\u0648 \u2066SNC\u2069 \u0623\u0648 \u2066SCS\u2069 \u0623\u0648 \u2066GIE\u2069 \u0623\u0648 \u0623\u062E\u0631\u0649."
              },
              taxId: {
                term: "\u0627\u0644\u0645\u0639\u0631\u0651\u0641 \u0627\u0644\u062C\u0628\u0627\u0626\u064A",
                text: "\u0644\u0644\u0642\u0631\u0627\u0621\u0629 \u0641\u0642\u0637: \u0641\u0647\u0648 \u064A\u062D\u062F\u0651\u062F \u0647\u0648\u064A\u0629 \u0645\u0643\u062A\u0628\u0643 \u0648\u0644\u0627 \u064A\u0645\u0643\u0646 \u062A\u063A\u064A\u064A\u0631\u0647 \u0647\u0646\u0627. \u0644\u062A\u0635\u062D\u064A\u062D\u0647 \u062A\u0648\u0627\u0635\u0644 \u0645\u0639 \u062F\u0639\u0645 \u2066BatiFlow\u2069."
              }
            }
          },
          disciplines: {
            title: "\u0627\u0644\u0627\u062E\u062A\u0635\u0627\u0635\u0627\u062A",
            items: {
              officeDisciplines: {
                term: "\u0627\u062E\u062A\u0635\u0627\u0635\u0627\u062A \u0627\u0644\u0645\u0643\u062A\u0628",
                text: "\u062E\u0627\u0646\u0627\u062A \u0644\u0644\u062A\u062D\u062F\u064A\u062F: \u0627\u0644\u0639\u0645\u0627\u0631\u0629\u060C \u0627\u0644\u0647\u064A\u0627\u0643\u0644\u060C \u0627\u0644\u0637\u0631\u0642 \u0648\u0627\u0644\u0634\u0628\u0643\u0627\u062A \u0627\u0644\u0645\u062E\u062A\u0644\u0641\u0629\u060C \u0627\u0644\u0645\u0648\u0627\u0626\u0639\u060C \u0627\u0644\u0643\u0647\u0631\u0628\u0627\u0621\u060C \u0627\u0644\u0637\u0648\u0628\u0648\u063A\u0631\u0627\u0641\u064A\u0627\u060C \u0627\u0644\u062C\u064A\u0648\u062A\u0642\u0646\u064A\u0629\u060C \u0627\u0644\u062A\u0646\u0633\u064A\u0642 \u0648\u0627\u0644\u0645\u062A\u0627\u0628\u0639\u0629. \u064A\u0645\u0643\u0646\u0643 \u0627\u062E\u062A\u064A\u0627\u0631 \u0623\u0643\u062B\u0631 \u0645\u0646 \u0627\u062E\u062A\u0635\u0627\u0635 \u0648\u0644\u0643\u0646 \u064A\u0644\u0632\u0645 \u0648\u0627\u062D\u062F \u0639\u0644\u0649 \u0627\u0644\u0623\u0642\u0644."
              },
              acronyms: {
                term: "\u0627\u0644\u0637\u0631\u0642 \u0648\u0627\u0644\u0634\u0628\u0643\u0627\u062A \u0627\u0644\u0645\u062E\u062A\u0644\u0641\u0629 \u0648\u0627\u0644\u062A\u0646\u0633\u064A\u0642 \u0648\u0627\u0644\u0645\u062A\u0627\u0628\u0639\u0629",
                text: "\u2066VRD\u2069: \u0627\u0644\u0637\u0631\u0642 \u0648\u0627\u0644\u0634\u0628\u0643\u0627\u062A \u0627\u0644\u0645\u062E\u062A\u0644\u0641\u0629 (\u0637\u0631\u0642\u0627\u062A \u0648\u062A\u0637\u0647\u064A\u0631 \u0648\u0634\u0628\u0643\u0627\u062A). \u2066OPC\u2069: \u062C\u062F\u0648\u0644\u0629 \u0627\u0644\u0648\u0631\u0634\u0629 \u0648\u0642\u064A\u0627\u062F\u062A\u0647\u0627 \u0648\u0627\u0644\u062A\u0646\u0633\u064A\u0642 \u0641\u064A\u0647\u0627."
              }
            }
          },
          address: {
            title: "\u0627\u0644\u0639\u0646\u0648\u0627\u0646 \u0648\u0627\u0644\u0648\u0644\u0627\u064A\u0629",
            items: {
              line1: {
                term: "\u0627\u0644\u0639\u0646\u0648\u0627\u0646",
                text: "\u0625\u0644\u0632\u0627\u0645\u064A. \u0639\u0646\u0648\u0627\u0646 \u0645\u0642\u0631\u0651 \u0645\u0643\u062A\u0628\u0643."
              },
              line2: {
                term: "\u062A\u062A\u0645\u0629 \u0627\u0644\u0639\u0646\u0648\u0627\u0646 (\u0627\u062E\u062A\u064A\u0627\u0631\u064A)",
                text: "\u0627\u0644\u0628\u0646\u0627\u064A\u0629 \u0623\u0648 \u0627\u0644\u0637\u0627\u0628\u0642 \u0623\u0648 \u0627\u0644\u062D\u064A... \u0643\u0644 \u0645\u0627 \u064A\u0633\u0627\u0639\u062F \u0639\u0644\u0649 \u0627\u0644\u0648\u0635\u0648\u0644 \u0625\u0644\u0649 \u0627\u0644\u0645\u0643\u062A\u0628."
              },
              city: {
                term: "\u0627\u0644\u0645\u062F\u064A\u0646\u0629",
                text: "\u0625\u0644\u0632\u0627\u0645\u064A."
              },
              postalCode: {
                term: "\u0627\u0644\u0631\u0645\u0632 \u0627\u0644\u0628\u0631\u064A\u062F\u064A",
                text: "\u0625\u0644\u0632\u0627\u0645\u064A\u060C \u0645\u062B\u0644 1002."
              },
              governorate: {
                term: "\u0627\u0644\u0648\u0644\u0627\u064A\u0629",
                text: "\u0625\u0644\u0632\u0627\u0645\u064A. \u0627\u062E\u062A\u0631 \u0645\u0646 \u0642\u0627\u0626\u0645\u0629 \u0648\u0644\u0627\u064A\u0627\u062A \u062A\u0648\u0646\u0633 \u0645\u0631\u062A\u0628\u0629 \u0623\u0628\u062C\u062F\u064A\u064B\u0627."
              }
            }
          },
          references: {
            title: "\u0627\u0644\u0645\u0631\u0627\u062C\u0639 \u0627\u0644\u0645\u0647\u0646\u064A\u0629 \u0648\u0627\u0644\u0644\u063A\u0629",
            items: {
              professionalRegistration: {
                term: "\u0627\u0644\u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u0645\u0647\u0646\u064A (\u0627\u062E\u062A\u064A\u0627\u0631\u064A)",
                text: "\u0645\u062B\u0644\u064B\u0627 \u0631\u0642\u0645 \u0627\u0644\u062A\u0633\u062C\u064A\u0644 \u0644\u062F\u0649 \u0647\u064A\u0626\u0629 \u0627\u0644\u0645\u0647\u0646\u062F\u0633\u064A\u0646 \u0623\u0648 \u0627\u0644\u0645\u0639\u0645\u0627\u0631\u064A\u064A\u0646."
              },
              agreementNumber: {
                term: "\u0631\u0642\u0645 \u0627\u0644\u0627\u0639\u062A\u0645\u0627\u062F (\u0627\u062E\u062A\u064A\u0627\u0631\u064A)",
                text: "\u0631\u0642\u0645 \u0627\u0639\u062A\u0645\u0627\u062F \u0645\u0643\u062A\u0628 \u0627\u0644\u062F\u0631\u0627\u0633\u0627\u062A \u0625\u0646 \u0648\u064F\u062C\u062F."
              },
              defaultLocale: {
                term: "\u0627\u0644\u0644\u063A\u0629 \u0627\u0644\u0627\u0641\u062A\u0631\u0627\u0636\u064A\u0629 \u0644\u0644\u0645\u0624\u0633\u0633\u0629",
                text: "\u2066Fran\u2069\xE7\u2066ais\u2069 \u0623\u0648 \u0627\u0644\u0639\u0631\u0628\u064A\u0629 \u0623\u0648 \u2066English\u2069. \u0648\u062A\u064F\u0633\u062A\u0639\u0645\u0644 \u0641\u064A \u0627\u0644\u0648\u062B\u0627\u0626\u0642 \u0648\u0627\u0644\u0631\u0633\u0627\u0626\u0644 \u0627\u0644\u0645\u0631\u0633\u0644\u0629 \u0628\u0627\u0633\u0645 \u0627\u0644\u0645\u0643\u062A\u0628."
              }
            }
          },
          logo: {
            title: "\u0627\u0644\u0634\u0639\u0627\u0631",
            items: {
              preview: {
                term: "\u0627\u0644\u0634\u0639\u0627\u0631 \u0627\u0644\u062D\u0627\u0644\u064A \u0644\u0644\u0645\u0624\u0633\u0633\u0629",
                text: "\u0645\u0639\u0627\u064A\u0646\u0629 \u0627\u0644\u0634\u0639\u0627\u0631 \u0627\u0644\u0630\u064A \u064A\u0638\u0647\u0631 \u0639\u0644\u0649 \u0648\u062B\u0627\u0626\u0642\u0643 \u0627\u0644\u0631\u0633\u0645\u064A\u0629. \u0648\u0625\u0646 \u0644\u0645 \u064A\u0648\u062C\u062F \u0634\u0639\u0627\u0631 \u062A\u0638\u0647\u0631 \xAB\u0644\u0627 \u064A\u0648\u062C\u062F \u0634\u0639\u0627\u0631 \u0628\u0639\u062F\xBB."
              },
              choose: {
                term: "\u0627\u062E\u062A\u064A\u0627\u0631 \u0635\u0648\u0631\u0629",
                text: "\u0644\u0644\u0645\u0627\u0644\u0643 \u0648\u0627\u0644\u0645\u0634\u0631\u0641\u064A\u0646 \u0641\u0642\u0637. \u0627\u062E\u062A\u0631 \u0645\u0644\u0641\u064B\u0627 \u0628\u0635\u064A\u063A\u0629 \u2066PNG\u2069 \u0623\u0648 \u2066JPEG\u2069 \u0623\u0648 \u2066WebP\u2069 \u0628\u062D\u062C\u0645 2 \u0645\u064A\u063A\u0627\u0628\u0627\u064A\u062A \u0639\u0644\u0649 \u0627\u0644\u0623\u0643\u062B\u0631\u061B \u064A\u064F\u0641\u062D\u0635 \u062B\u0645 \u062A\u0638\u0647\u0631 \xAB\u062C\u0627\u0631\u064D \u062A\u0637\u0628\u064A\u0642 \u0627\u0644\u0634\u0639\u0627\u0631\u2026\xBB \u0642\u0628\u0644 \u0627\u0644\u062A\u062D\u062F\u064A\u062B."
              },
              remove: {
                term: "\u062D\u0630\u0641 \u0627\u0644\u0634\u0639\u0627\u0631",
                text: "\u0644\u0644\u0645\u0627\u0644\u0643 \u0648\u0627\u0644\u0645\u0634\u0631\u0641\u064A\u0646 \u0641\u0642\u0637. \u0644\u0627 \u064A\u0638\u0647\u0631 \u0647\u0630\u0627 \u0627\u0644\u0632\u0631 \u0625\u0644\u0627 \u0625\u0630\u0627 \u0643\u0627\u0646 \u0647\u0646\u0627\u0643 \u0634\u0639\u0627\u0631 \u0628\u0627\u0644\u0641\u0639\u0644."
              },
              logoErrors: {
                term: "\u0631\u0633\u0627\u0626\u0644 \u0623\u062E\u0637\u0627\u0621 \u0627\u0644\u0634\u0639\u0627\u0631",
                text: "\u062A\u0634\u0631\u062D \u0631\u0633\u0627\u0644\u0629 \u0648\u0627\u0636\u062D\u0629 \u0633\u0628\u0628 \u0627\u0644\u0631\u0641\u0636: \u0635\u064A\u063A\u0629 \u063A\u064A\u0631 \u0645\u0642\u0628\u0648\u0644\u0629 \u0623\u0648 \u0635\u0648\u0631\u0629 \u0643\u0628\u064A\u0631\u0629 \u062C\u062F\u064B\u0627 \u0623\u0648 \u0635\u0648\u0631\u0629 \u0645\u0627 \u0632\u0627\u0644\u062A \u0642\u064A\u062F \u0627\u0644\u0641\u062D\u0635 (\u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629 \u0628\u0639\u062F \u0642\u0644\u064A\u0644) \u0623\u0648 \u062A\u0639\u0630\u0651\u0631 \u0627\u0644\u062D\u0641\u0638."
              }
            }
          }
        }
      },
      documents: {
        title: "\u0627\u0644\u0648\u062B\u0627\u0626\u0642",
        intro: "\u062A\u0636\u0628\u0637 \u0647\u0630\u0647 \u0627\u0644\u0635\u0641\u062D\u0629 \u0637\u0631\u064A\u0642\u0629 \u062A\u0633\u0645\u064A\u0629 \u2066BatiFlow\u2069 \u0644\u0648\u062B\u0627\u0626\u0642 \u0645\u0643\u062A\u0628\u0643 (\u0631\u0645\u0632 \u0643\u0644 \u0645\u062E\u0637\u0637 \u0623\u0648 \u0645\u0631\u0627\u0633\u0644\u0629) \u0648\u062A\u0631\u0642\u064A\u0645 \u0646\u0633\u062E\u0647\u0627. \u0648\u062A\u062D\u062A\u0647\u0627 \u062A\u062F\u064A\u0631 \u0646\u0645\u0627\u0630\u062C \u0645\u0633\u0627\u0631\u0627\u062A \u0627\u0644\u062A\u0623\u0634\u064A\u0631 \u0627\u0644\u062E\u0627\u0635\u0629 \u0628\u0641\u0631\u064A\u0642\u0643.",
        sections: {
          header: {
            title: "\u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u0625\u062F\u0627\u0631\u0629 \u0648\u0627\u0644\u062D\u0641\u0638",
            items: {
              adminNav: {
                term: "\u0627\u0644\u0625\u062F\u0627\u0631\u0629",
                text: "\u062A\u062C\u0645\u0639 \u0627\u0644\u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u062C\u0627\u0646\u0628\u064A\u0629 \u0635\u0641\u062D\u0627\u062A \u0625\u062F\u0627\u0631\u0629 \u0645\u0624\u0633\u0633\u062A\u0643 (\u0635\u0641\u0651 \u0645\u0646 \u0627\u0644\u0631\u0648\u0627\u0628\u0637 \u0641\u0648\u0642 \u0627\u0644\u0635\u0641\u062D\u0629 \u0639\u0644\u0649 \u0627\u0644\u0634\u0627\u0634\u0627\u062A \u0627\u0644\u0635\u063A\u064A\u0631\u0629). \u0648\u0644\u0627 \u062A\u0639\u0631\u0636 \u0625\u0644\u0627 \u0627\u0644\u0635\u0641\u062D\u0627\u062A \u0627\u0644\u062A\u064A \u064A\u0633\u0645\u062D \u0644\u0643 \u062F\u0648\u0631\u0643 \u0628\u0641\u062A\u062D\u0647\u0627."
              },
              save: {
                term: "\u062D\u0641\u0638",
                text: "\u0644\u0627 \u064A\u0638\u0647\u0631 \u0625\u0644\u0627 \u0644\u0645\u0646 \u064A\u0645\u0644\u0643 \u0635\u0644\u0627\u062D\u064A\u0629 \u062A\u0639\u062F\u064A\u0644 \u0627\u0644\u0645\u0624\u0633\u0633\u0629. \u0648\u0625\u0646 \u0644\u0645 \u064A\u0643\u0646 \u0647\u0646\u0627\u0643 \u062C\u062F\u064A\u062F \u062A\u0638\u0647\u0631 \xAB\u0644\u0627 \u062A\u0648\u062C\u062F \u062A\u0639\u062F\u064A\u0644\u0627\u062A \u0644\u062D\u0641\u0638\u0647\u0627\xBB. \u0648\u0628\u062C\u0627\u0646\u0628\u0647 \u0645\u0644\u0627\u062D\u0638\u0629 \u062A\u0630\u0643\u0651\u0631 \u0628\u0623\u0646 \u0627\u0644\u0631\u0645\u0648\u0632 \u0627\u0644\u0645\u0633\u0646\u062F\u0629 \u0633\u0627\u0628\u0642\u064B\u0627 \u0644\u0627 \u062A\u062A\u063A\u064A\u0631: \u064A\u0646\u0637\u0628\u0642 \u0627\u0644\u0646\u0645\u0637 \u0627\u0644\u062C\u062F\u064A\u062F \u0639\u0644\u0649 \u0627\u0644\u0648\u062B\u0627\u0626\u0642 \u0627\u0644\u062C\u062F\u064A\u062F\u0629 \u0648\u0639\u0644\u0649 \u0627\u0644\u0648\u062B\u0627\u0626\u0642 \u0627\u0644\u062A\u064A \u062A\u064F\u0639\u062F\u064E\u0651\u0644 \u0645\u0639\u0644\u0648\u0645\u0627\u062A\u0647\u0627."
              },
              readOnly: {
                term: "\u0644\u0627 \u064A\u0645\u0643\u0646 \u062A\u063A\u064A\u064A\u0631 \u0647\u0630\u0647 \u0627\u0644\u0625\u0639\u062F\u0627\u062F\u0627\u062A \u0625\u0644\u0627 \u0644\u0645\u0646 \u064A\u0645\u0644\u0643 \u0635\u0644\u0627\u062D\u064A\u0629 \u062A\u0639\u062F\u064A\u0644 \u0627\u0644\u0645\u0624\u0633\u0633\u0629.",
                text: "\u0628\u0627\u0644\u0646\u0633\u0628\u0629 \u0625\u0644\u0649 \u0628\u0642\u064A\u0629 \u0627\u0644\u0623\u0639\u0636\u0627\u0621\u060C \u064A\u0645\u0643\u0646 \u0642\u0631\u0627\u0621\u0629 \u0627\u0644\u0635\u0641\u062D\u0629 \u0644\u0643\u0646 \u0644\u0627 \u064A\u0645\u0643\u0646 \u062A\u0639\u062F\u064A\u0644\u0647\u0627: \u0627\u0644\u062D\u0642\u0644 \u0648\u0627\u0644\u062E\u064A\u0627\u0631\u0627\u062A \u0645\u0642\u0641\u0644\u0629."
              }
            }
          },
          pattern: {
            title: "\u0646\u0645\u0637 \u0631\u0645\u0632 \u0627\u0644\u0648\u062B\u0627\u0626\u0642",
            items: {
              patternField: {
                term: "\u0627\u0644\u0646\u0645\u0637",
                text: "\u0646\u0645\u0637 \u0631\u0645\u0632 \u0643\u0644 \u0648\u062B\u064A\u0642\u0629: \u064A\u064F\u0633\u062A\u062E\u062F\u0645 \u0644\u062A\u0639\u0631\u064A\u0641\u0647\u0627 \u0639\u0644\u0649 \u0627\u0644\u0645\u062E\u0637\u0637\u0627\u062A \u0648\u0627\u0644\u0645\u0631\u0627\u0633\u0644\u0627\u062A \u0648\u0642\u0648\u0627\u0626\u0645 \u0627\u0644\u0625\u0631\u0633\u0627\u0644. \u0623\u062D\u0631\u0641 \u0644\u0627\u062A\u064A\u0646\u064A\u0629 \u0643\u0628\u064A\u0631\u0629 \u0648\u0623\u0631\u0642\u0627\u0645 \u0648\u0627\u0644\u0631\u0645\u0648\u0632 - _ . \u0641\u0642\u0637\u060C \u0645\u0646 5 \u0625\u0644\u0649 100 \u062D\u0631\u0641\u061B \u0648\u062A\u062A\u062D\u0648\u0644 \u0627\u0644\u0623\u062D\u0631\u0641 \u0627\u0644\u0635\u063A\u064A\u0631\u0629 \u0625\u0644\u0649 \u0643\u0628\u064A\u0631\u0629 \u062A\u0644\u0642\u0627\u0626\u064A\u064B\u0627. \u0627\u0644\u0639\u0646\u0635\u0631\u0627\u0646 \u2066NUM\u2069 \u0648\u2066IDX\u2069\u060C \u0627\u0644\u0645\u0643\u062A\u0648\u0628\u0627\u0646 \u0628\u064A\u0646 \u0623\u0642\u0648\u0627\u0633 \u0645\u0639\u0642\u0648\u0641\u0629\u060C \u0625\u0644\u0632\u0627\u0645\u064A\u0627\u0646."
              },
              example: {
                term: "\u0645\u062B\u0627\u0644 \u0639\u0644\u0649 \u0627\u0644\u0631\u0645\u0632",
                text: "\u0645\u062B\u0627\u0644 \u064A\u064F\u062D\u062A\u0633\u0628 \u0623\u062B\u0646\u0627\u0621 \u0627\u0644\u0643\u062A\u0627\u0628\u0629\u060C \u0644\u0645\u062E\u0637\u0637 \u0647\u064A\u0627\u0643\u0644 \u0641\u064A \u0645\u0631\u062D\u0644\u0629 \u2066APS\u2069\u060C \u0623\u0648\u0644 \u0648\u062B\u064A\u0642\u0629\u060C \u0627\u0644\u0645\u0646\u0637\u0642\u0629 \u2066RDC\u2069. \u0648\u0625\u0646 \u0644\u0645 \u064A\u0643\u0646 \u0627\u0644\u0646\u0645\u0637 \u0635\u0627\u0644\u062D\u064B\u0627 \u0628\u0639\u062F \u062A\u0638\u0647\u0631 \xAB\u0644\u0627 \u0645\u062B\u0627\u0644\xBB."
              },
              problems: {
                term: "\u0631\u0633\u0627\u0626\u0644 \u062A\u062D\u062A \u0627\u0644\u062D\u0642\u0644",
                text: "\u062A\u0634\u0631\u062D \u0627\u0644\u0645\u0634\u0643\u0644\u0629 \u0628\u0648\u0636\u0648\u062D: \u0637\u0648\u0644 \u062E\u0627\u0631\u062C \u0627\u0644\u0646\u0637\u0627\u0642 \u0645\u0646 5 \u0625\u0644\u0649 100 \u062D\u0631\u0641 \u0623\u0648 \u062D\u0631\u0641 \u063A\u064A\u0631 \u0645\u0633\u0645\u0648\u062D \u0623\u0648 \u0639\u0646\u0635\u0631 \u063A\u064A\u0631 \u0645\u0639\u0631\u0648\u0641 \u0628\u064A\u0646 \u0623\u0642\u0648\u0627\u0633 \u0645\u0639\u0642\u0648\u0641\u0629 \u0623\u0648 \u0623\u0642\u0648\u0627\u0633 \u063A\u064A\u0631 \u0645\u062A\u0648\u0627\u0632\u0646\u0629 \u0623\u0648 \u063A\u064A\u0627\u0628 \u2066NUM\u2069 \u0648\u2066IDX\u2069. \u0648\u0642\u062F \u064A\u0631\u0641\u0636 \u0627\u0644\u062E\u0627\u062F\u0645 \u0627\u0644\u0646\u0645\u0637 \u0644\u0644\u0633\u0628\u0628 \u0646\u0641\u0633\u0647."
              }
            }
          },
          elements: {
            title: "\u0639\u0646\u0627\u0635\u0631 \u0627\u0644\u0646\u0645\u0637",
            items: {
              project: {
                term: "\u2066PROJECT\u2069",
                text: "\u0631\u0645\u0632 \u0627\u0644\u0645\u0634\u0631\u0648\u0639."
              },
              phase: {
                term: "\u2066PHASE\u2069",
                text: "\u0645\u0631\u062D\u0644\u0629 \u0627\u0644\u0645\u0634\u0631\u0648\u0639: \u2066ESQ\u2069 \u0648\u2066APS\u2069 \u0648\u2066APD\u2069\u2026"
              },
              disc: {
                term: "\u2066DISC\u2069",
                text: "\u0627\u0644\u062A\u062E\u0635\u0635: \u2066ARC\u2069 \u0648\u2066STR\u2069 \u0648\u2066VRD\u2069\u2026"
              },
              type: {
                term: "\u2066TYPE\u2069",
                text: "\u0646\u0648\u0639 \u0627\u0644\u0648\u062B\u064A\u0642\u0629: \u2066PLN\u2069 \u0648\u2066NDC\u2069 \u0648\u2066RAP\u2069\u2026"
              },
              num: {
                term: "\u2066NUM\u2069",
                text: "\u0627\u0644\u0631\u0642\u0645 \u0627\u0644\u062A\u0633\u0644\u0633\u0644\u064A\u060C \u064A\u064F\u0633\u0646\u0650\u062F\u0647 \u2066BatiFlow\u2069. \u0625\u0644\u0632\u0627\u0645\u064A."
              },
              idx: {
                term: "\u2066IDX\u2069",
                text: "\u0645\u0624\u0634\u0631 \u0627\u0644\u0645\u0631\u0627\u062C\u0639\u0629 (\u2066A\u2069 \u0648\u2066B\u2069\u2026 \u0623\u0648 0 \u06481\u2026). \u0625\u0644\u0632\u0627\u0645\u064A."
              },
              zone: {
                term: "\u2066ZONE\u2069",
                text: "\u0627\u0644\u0645\u0646\u0637\u0642\u0629 \u0623\u0648 \u0627\u0644\u0628\u0646\u0627\u064A\u0629 \u0639\u0646\u062F \u0630\u0643\u0631\u0647\u0627."
              }
            }
          },
          index: {
            title: "\u0646\u0645\u0637 \u0645\u0624\u0634\u0631\u0627\u062A \u0627\u0644\u0645\u0631\u0627\u062C\u0639\u0629",
            items: {
              letters: {
                term: "\u062D\u0631\u0648\u0641: \u2066A\u2069 \u0648\u2066B\u2069 \u0648\u2066C\u2069\u2026",
                text: "\u062A\u062D\u0635\u0644 \u0643\u0644 \u0646\u0633\u062E\u0629 \u062C\u062F\u064A\u062F\u0629 \u0645\u0646 \u0627\u0644\u0648\u062B\u064A\u0642\u0629 \u0639\u0644\u0649 \u062D\u0631\u0641 (\u0645\u0624\u0634\u0631 \u0627\u0644\u0645\u0631\u0627\u062C\u0639\u0629): \u2066A\u2069 \u062B\u0645 \u2066B\u2069 \u062B\u0645 \u2066C\u2069\u2026"
              },
              numbers: {
                term: "\u0623\u0631\u0642\u0627\u0645: 0 \u06481 \u06482\u2026",
                text: "\u062A\u062D\u0635\u0644 \u0643\u0644 \u0646\u0633\u062E\u0629 \u062C\u062F\u064A\u062F\u0629 \u0639\u0644\u0649 \u0631\u0642\u0645: 0 \u062B\u0645 1 \u062B\u0645 2\u2026"
              }
            }
          },
          templates: {
            title: "\u0646\u0645\u0627\u0630\u062C \u0645\u0633\u0627\u0631\u0627\u062A \u0627\u0644\u062A\u0623\u0634\u064A\u0631",
            items: {
              intro: {
                term: "\u0646\u0645\u0627\u0630\u062C \u0645\u0633\u0627\u0631\u0627\u062A \u0627\u0644\u062A\u0623\u0634\u064A\u0631",
                text: "\u0645\u0633\u0627\u0631\u0627\u062A \u062C\u0627\u0647\u0632\u0629 \u064A\u0645\u0643\u0646 \u0644\u0641\u0631\u064A\u0642\u0643 \u0627\u062E\u062A\u064A\u0627\u0631\u0647\u0627 \u0639\u0646\u062F \u0637\u0644\u0628 \u062A\u0623\u0634\u064A\u0631\u0629 (\u0645\u0635\u0627\u062F\u0642\u0629 \u0627\u0644\u0645\u0631\u0627\u062C\u0639\u064A\u0646 \u0639\u0644\u0649 \u0648\u062B\u064A\u0642\u0629). \u0648\u064A\u0639\u0631\u0636 \u0643\u0644 \u0646\u0645\u0648\u0630\u062C \u0641\u064A \u0627\u0644\u0642\u0627\u0626\u0645\u0629 \u0627\u0633\u0645\u0647 \u0648\u062E\u0637\u0648\u0627\u062A\u0647."
              },
              new: {
                term: "\u0646\u0645\u0648\u0630\u062C \u062C\u062F\u064A\u062F",
                text: "\u064A\u0641\u062A\u062D \u0646\u0627\u0641\u0630\u0629 \u0627\u0644\u0625\u0646\u0634\u0627\u0621. \u0644\u0627 \u064A\u0638\u0647\u0631 \u0625\u0644\u0627 \u0644\u0645\u0646 \u064A\u0645\u0644\u0643 \u0635\u0644\u0627\u062D\u064A\u0629 \u062A\u0639\u062F\u064A\u0644 \u0627\u0644\u0645\u0624\u0633\u0633\u0629."
              },
              delete: {
                term: "\u062D\u0630\u0641",
                text: "\u0623\u064A\u0642\u0648\u0646\u0629 \u0633\u0644\u0629 \u0641\u064A \u0622\u062E\u0631 \u0627\u0644\u0633\u0637\u0631 \u0644\u0645\u0646 \u064A\u0633\u062A\u0637\u064A\u0639 \u062A\u0639\u062F\u064A\u0644 \u0627\u0644\u0645\u0624\u0633\u0633\u0629. \u0628\u0639\u062F \u0627\u0644\u062A\u0623\u0643\u064A\u062F \u064A\u062E\u062A\u0641\u064A \u0627\u0644\u0646\u0645\u0648\u0630\u062C\u060C \u0648\u0644\u0627 \u062A\u062A\u063A\u064A\u0631 \u0627\u0644\u0645\u0633\u0627\u0631\u0627\u062A \u0627\u0644\u062A\u064A \u0628\u062F\u0623\u062A \u0628\u0627\u0644\u0641\u0639\u0644."
              },
              empty: {
                term: "\u0644\u0627 \u0646\u0645\u0627\u0630\u062C \u062D\u0627\u0644\u064A\u064B\u0627.",
                text: "\u0631\u0633\u0627\u0644\u0629 \u0627\u0644\u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u0641\u0627\u0631\u063A\u0629: \u064A\u0631\u0643\u0651\u0628 \u0627\u0644\u0641\u0631\u064A\u0642 \u0627\u0644\u062E\u0637\u0648\u0627\u062A \u0639\u0646\u062F\u0626\u0630\u064D \u0639\u0646\u062F \u0643\u0644 \u0637\u0644\u0628."
              },
              readOnlyTemplates: {
                term: "\u0625\u0646\u0634\u0627\u0621 \u0627\u0644\u0646\u0645\u0627\u0630\u062C \u0623\u0648 \u062D\u0630\u0641\u0647\u0627 \u0645\u062E\u0635\u0635 \u0644\u0645\u0646 \u064A\u0645\u0644\u0643 \u0635\u0644\u0627\u062D\u064A\u0629 \u062A\u0639\u062F\u064A\u0644 \u0627\u0644\u0645\u0624\u0633\u0633\u0629.",
                text: "\u064A\u0631\u0649 \u0628\u0642\u064A\u0629 \u0627\u0644\u0623\u0639\u0636\u0627\u0621 \u0627\u0644\u0642\u0627\u0626\u0645\u0629 \u062F\u0648\u0646 \u0623\u0646 \u064A\u0633\u062A\u0637\u064A\u0639\u0648\u0627 \u062A\u063A\u064A\u064A\u0631\u0647\u0627."
              }
            }
          },
          newTemplate: {
            title: "\u0646\u0645\u0648\u0630\u062C \u0645\u0633\u0627\u0631 \u062C\u062F\u064A\u062F",
            items: {
              name: {
                term: "\u0627\u0633\u0645 \u0627\u0644\u0646\u0645\u0648\u0630\u062C",
                text: "\u0625\u0644\u0632\u0627\u0645\u064A\u060C 120 \u062D\u0631\u0641\u064B\u0627 \u0639\u0644\u0649 \u0627\u0644\u0623\u0643\u062B\u0631. \u0648\u0628\u0644\u0627 \u0627\u0633\u0645 \u062A\u0638\u0647\u0631 \xAB\u0623\u0639\u0637\u0650 \u0627\u0644\u0646\u0645\u0648\u0630\u062C \u0627\u0633\u0645\u064B\u0627.\xBB."
              },
              step: {
                term: "\u0627\u0644\u062E\u0637\u0648\u0629",
                text: "\u064A\u062A\u0643\u0648\u0651\u0646 \u0627\u0644\u0645\u0633\u0627\u0631 \u0645\u0646 \u062E\u0637\u0648\u0627\u062A \u0645\u0631\u0642\u0651\u0645\u0629. \u0648\u0644\u0643\u0644 \u062E\u0637\u0648\u0629 \u0646\u0645\u0637: \xAB\u0628\u0627\u0644\u062A\u0631\u062A\u064A\u0628\xBB (\u064A\u064F\u0628\u062F\u064A \u0643\u0644 \u0645\u0631\u0627\u062C\u0639 \u0631\u0623\u064A\u0647 \u0628\u062F\u0648\u0631\u0647) \u0623\u0648 \xAB\u0628\u0627\u0644\u062A\u0648\u0627\u0632\u064A\xBB (\u064A\u0631\u062F \u0627\u0644\u062C\u0645\u064A\u0639 \u0641\u064A \u0648\u0642\u062A \u0648\u0627\u062D\u062F \u0648\u0628\u0623\u064A \u062A\u0631\u062A\u064A\u0628). \u0648\u062A\u062A\u064A\u062D \u0623\u0632\u0631\u0627\u0631 \u0631\u0641\u0639 \u0627\u0644\u062E\u0637\u0648\u0629 \u0623\u0648 \u0625\u0646\u0632\u0627\u0644\u0647\u0627 \u0623\u0648 \u062D\u0630\u0641\u0647\u0627."
              },
              reviewers: {
                term: "\u0645\u0631\u0627\u062C\u0639\u0648 \u0627\u0644\u062E\u0637\u0648\u0629",
                text: "\u0627\u0644\u0623\u0634\u062E\u0627\u0635 \u0627\u0644\u0630\u064A\u0646 \u064A\u064F\u0628\u062F\u0648\u0646 \u0631\u0623\u064A\u0647\u0645. \u0627\u062E\u062A\u0631 \u0634\u062E\u0635\u064B\u0627 \u0645\u0646 \xAB\u0627\u062E\u062A\u0631 \u0634\u062E\u0635\u064B\u0627\xBB \u062B\u0645 \u0627\u0636\u063A\u0637 \xAB\u0625\u0636\u0627\u0641\u0629\xBB\u061B \u0648\u064A\u0645\u0643\u0646\u0643 \u0631\u0641\u0639\u0647 \u0623\u0648 \u0625\u0646\u0632\u0627\u0644\u0647 \u0623\u0648 \u0625\u0632\u0627\u0644\u062A\u0647. \u0648\u0644\u0627 \u062A\u064F\u0642\u0628\u0644 \u062E\u0637\u0648\u0629 \u0628\u0644\u0627 \u0645\u0631\u0627\u062C\u0639."
              },
              addStep: {
                term: "\u0625\u0636\u0627\u0641\u0629 \u062E\u0637\u0648\u0629",
                text: "\u064A\u0636\u064A\u0641 \u062E\u0637\u0648\u0629 \u0641\u064A \u0646\u0647\u0627\u064A\u0629 \u0627\u0644\u0645\u0633\u0627\u0631."
              },
              create: {
                term: "\u0625\u0646\u0634\u0627\u0621 \u0627\u0644\u0646\u0645\u0648\u0630\u062C",
                text: "\u064A\u062D\u0641\u0638 \u0627\u0644\u0646\u0645\u0648\u0630\u062C. \u0648\u0625\u0646 \u0644\u0645 \u064A\u0643\u0646 \u0644\u062E\u0637\u0648\u0629 \u0645\u0627 \u0645\u0631\u0627\u062C\u0639 \u062A\u0638\u0647\u0631 \xAB\u064A\u062C\u0628 \u0623\u0646 \u064A\u0643\u0648\u0646 \u0644\u0643\u0644 \u062E\u0637\u0648\u0629 \u0645\u0631\u0627\u062C\u0639 \u0648\u0627\u062D\u062F \u0639\u0644\u0649 \u0627\u0644\u0623\u0642\u0644.\xBB."
              }
            }
          }
        }
      },
      policies: {
        title: "\u0627\u0644\u0633\u064A\u0627\u0633\u0627\u062A",
        intro: "\u062A\u062D\u062F\u0651\u062F \u0647\u0630\u0647 \u0627\u0644\u0635\u0641\u062D\u0629 \u0637\u0631\u064A\u0642\u0629 \u0645\u0634\u0627\u0631\u0643\u0629 \u0645\u0643\u062A\u0628\u0643 \u0645\u0639 \u0627\u0644\u0623\u0637\u0631\u0627\u0641 \u0627\u0644\u062E\u0627\u0631\u062C\u064A\u0629 \u0648\u0645\u0633\u062A\u0648\u0649 \u062D\u0645\u0627\u064A\u0629 \u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062F\u062E\u0648\u0644. \u0648\u0647\u064A \u0645\u062E\u0635\u0635\u0629 \u0644\u0645\u0646 \u064A\u0633\u062A\u0637\u064A\u0639 \u062A\u0639\u062F\u064A\u0644 \u0627\u0644\u0633\u064A\u0627\u0633\u0627\u062A (\u0639\u0627\u062F\u0629\u064B \u0627\u0644\u0645\u0627\u0644\u0643 \u0648\u0627\u0644\u0645\u0634\u0631\u0641\u0648\u0646).",
        sections: {
          header: {
            title: "\u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u0625\u062F\u0627\u0631\u0629 \u0648\u0627\u0644\u062D\u0641\u0638",
            items: {
              adminNav: {
                term: "\u0627\u0644\u0625\u062F\u0627\u0631\u0629",
                text: "\u062A\u062C\u0645\u0639 \u0627\u0644\u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u062C\u0627\u0646\u0628\u064A\u0629 \u0635\u0641\u062D\u0627\u062A \u0625\u062F\u0627\u0631\u0629 \u0645\u0624\u0633\u0633\u062A\u0643 (\u0635\u0641\u0651 \u0645\u0646 \u0627\u0644\u0631\u0648\u0627\u0628\u0637 \u0641\u0648\u0642 \u0627\u0644\u0635\u0641\u062D\u0629 \u0639\u0644\u0649 \u0627\u0644\u0634\u0627\u0634\u0627\u062A \u0627\u0644\u0635\u063A\u064A\u0631\u0629). \u0648\u0644\u0627 \u062A\u0639\u0631\u0636 \u0625\u0644\u0627 \u0627\u0644\u0635\u0641\u062D\u0627\u062A \u0627\u0644\u062A\u064A \u064A\u0633\u0645\u062D \u0644\u0643 \u062F\u0648\u0631\u0643 \u0628\u0641\u062A\u062D\u0647\u0627."
              },
              save: {
                term: "\u062D\u0641\u0638",
                text: "\u064A\u062D\u0641\u0638 \u0627\u0644\u0633\u064A\u0627\u0633\u0627\u062A \u0627\u0644\u062A\u064A \u063A\u064A\u0651\u0631\u062A\u0647\u0627 \u0641\u0642\u0637. \u0648\u0644\u062D\u0645\u0627\u064A\u062A\u0643 \u064A\u0637\u0644\u0628 \u0645\u0646\u0643 \u062A\u0623\u0643\u064A\u062F \u0647\u0648\u064A\u062A\u0643. \u0648\u0625\u0646 \u0639\u062F\u0651\u0644 \u0634\u062E\u0635 \u0622\u062E\u0631 \u0627\u0644\u0633\u064A\u0627\u0633\u0627\u062A \u0641\u064A \u0627\u0644\u0623\u062B\u0646\u0627\u0621 \u0641\u0644\u0627 \u062A\u064F\u062D\u0641\u0638 \u062A\u063A\u064A\u064A\u0631\u0627\u062A\u0643 \u0648\u064A\u064F\u0639\u0627\u062F \u062A\u062D\u0645\u064A\u0644 \u0622\u062E\u0631 \u0646\u0633\u062E\u0629."
              }
            }
          },
          sharing: {
            title: "\u0627\u0644\u0645\u0634\u0627\u0631\u0643\u0629 \u0645\u0639 \u0627\u0644\u0623\u0637\u0631\u0627\u0641 \u0627\u0644\u062E\u0627\u0631\u062C\u064A\u0629",
            items: {
              requireApproval: {
                term: "\u0645\u0648\u0627\u0641\u0642\u0629 \u0645\u0637\u0644\u0648\u0628\u0629 \u0644\u0644\u0627\u0646\u0636\u0645\u0627\u0645 \u0625\u0644\u0649 \u0641\u0636\u0627\u0621 \u062E\u0627\u0631\u062C\u064A",
                text: "\u0645\u0641\u062A\u0627\u062D \u062A\u0634\u063A\u064A\u0644. \u0639\u0646\u062F \u062A\u0641\u0639\u064A\u0644\u0647 \u0644\u0627 \u064A\u0633\u062A\u0637\u064A\u0639 \u0627\u0644\u0639\u0636\u0648 \u0627\u0644\u0627\u0646\u0636\u0645\u0627\u0645 \u0625\u0644\u0649 \u0641\u0636\u0627\u0621 \u0645\u0624\u0633\u0633\u0629 \u0623\u062E\u0631\u0649 \u0625\u0644\u0627 \u0628\u0639\u062F \u0645\u0648\u0627\u0641\u0642\u0629 \u0623\u062D\u062F \u0627\u0644\u0645\u0634\u0631\u0641\u064A\u0646."
              },
              seeRequests: {
                term: "\u0639\u0631\u0636 \u0627\u0644\u0637\u0644\u0628\u0627\u062A \u0627\u0644\u0645\u0639\u0644\u0651\u0642\u0629",
                text: "\u0631\u0627\u0628\u0637 \u0625\u0644\u0649 \u0627\u0644\u0635\u0641\u062D\u0629 \u0627\u0644\u062A\u064A \u064A\u0642\u0628\u0644 \u0641\u064A\u0647\u0627 \u0627\u0644\u0645\u0634\u0631\u0641\u0648\u0646 \u0637\u0644\u0628\u0627\u062A \u0627\u0644\u0648\u0635\u0648\u0644 \u0623\u0648 \u064A\u0631\u0641\u0636\u0648\u0646\u0647\u0627."
              },
              managersCanShare: {
                term: "\u064A\u0645\u0643\u0646 \u0644\u0631\u0624\u0633\u0627\u0621 \u0627\u0644\u0645\u0634\u0627\u0631\u064A\u0639 \u0627\u0644\u0645\u0634\u0627\u0631\u0643\u0629",
                text: "\u0645\u0641\u062A\u0627\u062D \u062A\u0634\u063A\u064A\u0644. \u0639\u0646\u062F \u062A\u0641\u0639\u064A\u0644\u0647 \u064A\u0633\u062A\u0637\u064A\u0639 \u0631\u0624\u0633\u0627\u0621 \u0627\u0644\u0645\u0634\u0627\u0631\u064A\u0639 \u0641\u062A\u062D \u0641\u0636\u0627\u0621 \u0645\u0634\u0627\u0631\u064A\u0639\u0647\u0645 \u0623\u0645\u0627\u0645 \u0627\u0644\u0634\u0631\u0643\u0627\u0621. \u0648\u0625\u0644\u0627 \u0641\u0627\u0644\u0645\u0627\u0644\u0643 \u0648\u0627\u0644\u0645\u0634\u0631\u0641\u0648\u0646 \u0648\u062D\u062F\u0647\u0645 \u064A\u0633\u062A\u0637\u064A\u0639\u0648\u0646 \u0630\u0644\u0643."
              },
              domains: {
                term: "\u0627\u0644\u0646\u0637\u0627\u0642\u0627\u062A \u0627\u0644\u0645\u0633\u0645\u0648\u062D \u0628\u0647\u0627 \u0644\u0644\u0636\u064A\u0648\u0641",
                text: "\u0627\u0643\u062A\u0628 \u0646\u0637\u0627\u0642\u064B\u0627\u060C \u0645\u062B\u0644 \u2066client.tn\u2069\u060C \u062B\u0645 \u0627\u0636\u063A\u0637 \u2066Enter\u2069 \u0623\u0648 \u0627\u0636\u063A\u0637 \xAB\u0625\u0636\u0627\u0641\u0629\xBB. \u0648\u0644\u0646 \u064A\u062A\u0645\u0643\u0646 \u0627\u0644\u0636\u064A\u0648\u0641 \u0627\u0644\u062E\u0627\u0631\u062C\u064A\u0648\u0646 \u0645\u0646 \u0627\u0644\u0627\u0646\u0636\u0645\u0627\u0645 \u0625\u0644\u0627 \u0645\u0646 \u0647\u0630\u0647 \u0627\u0644\u0646\u0637\u0627\u0642\u0627\u062A. \u0648\u0628\u0644\u0627 \u0646\u0637\u0627\u0642 \u064A\u0645\u0643\u0646\u0647\u0645 \u0627\u0644\u0642\u062F\u0648\u0645 \u0645\u0646 \u0623\u064A \u0639\u0646\u0648\u0627\u0646 \u0628\u0631\u064A\u062F \u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A."
              },
              domainList: {
                term: "\u0627\u0644\u0646\u0637\u0627\u0642\u0627\u062A \u0627\u0644\u0645\u0633\u0645\u0648\u062D \u0628\u0647\u0627",
                text: "\u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u0646\u0637\u0627\u0642\u0627\u062A \u0627\u0644\u0645\u0636\u0627\u0641\u0629 \u0639\u0644\u0649 \u0634\u0643\u0644 \u0634\u0627\u0631\u0627\u062A. \u0648\u064A\u062D\u0630\u0641 \u0632\u0631 \xAB\u0625\u0632\u0627\u0644\u0629\xBB \u0641\u064A \u0627\u0644\u0634\u0627\u0631\u0629 \u0630\u0644\u0643 \u0627\u0644\u0646\u0637\u0627\u0642 (50 \u0646\u0637\u0627\u0642\u064B\u0627 \u0639\u0644\u0649 \u0627\u0644\u0623\u0643\u062B\u0631)."
              },
              domainErrors: {
                term: "\u0631\u0633\u0627\u0626\u0644 \u062A\u062D\u062A \u0627\u0644\u062D\u0642\u0644",
                text: "\u062A\u0646\u0628\u0651\u0647 \u0625\u0644\u0649 \u0646\u0637\u0627\u0642 \u0641\u0627\u0631\u063A \u0623\u0648 \u063A\u064A\u0631 \u0635\u0627\u0644\u062D (\u0627\u0643\u062A\u0628\u0647 \u062F\u0648\u0646 \xAB@\xBB \u0648\u062F\u0648\u0646 \u0645\u0633\u0627\u0641\u0627\u062A) \u0623\u0648 \u0645\u0648\u062C\u0648\u062F \u0641\u064A \u0627\u0644\u0642\u0627\u0626\u0645\u0629 \u0628\u0627\u0644\u0641\u0639\u0644 \u0623\u0648 \u0625\u0644\u0649 \u0642\u0627\u0626\u0645\u0629 \u0637\u0648\u064A\u0644\u0629 \u062C\u062F\u064B\u0627."
              }
            }
          },
          security: {
            title: "\u0623\u0645\u0627\u0646 \u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062F\u062E\u0648\u0644",
            items: {
              sessionHours: {
                term: "\u0623\u0642\u0635\u0649 \u0645\u062F\u0629 \u0644\u0644\u062C\u0644\u0633\u0629",
                text: "\u0642\u0627\u0626\u0645\u0629 \u0645\u0646 \u0633\u0627\u0639\u0629 \u0648\u0627\u062D\u062F\u0629 \u0625\u0644\u0649 12 \u0633\u0627\u0639\u0629\u060C \u0623\u0648 \xAB\u0627\u0644\u0645\u062F\u0629 \u0627\u0644\u0627\u0641\u062A\u0631\u0627\u0636\u064A\u0629 \u0644\u0644\u0645\u0646\u0635\u0629 (12 \u0633\u0627\u0639\u0629)\xBB. \u0648\u0628\u0639\u062F \u0647\u0630\u0647 \u0627\u0644\u0645\u062F\u0629 \u064A\u062C\u0628 \u0639\u0644\u0649 \u0627\u0644\u0639\u0636\u0648 \u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062F\u062E\u0648\u0644 \u0645\u0646 \u062C\u062F\u064A\u062F \u062D\u062A\u0649 \u0644\u0648 \u0643\u0627\u0646 \u0646\u0634\u0637\u064B\u0627."
              },
              mfaForAll: {
                term: "\u0627\u0644\u062A\u062D\u0642\u0642 \u0628\u062E\u0637\u0648\u062A\u064A\u0646 \u0644\u062C\u0645\u064A\u0639 \u0627\u0644\u0623\u0639\u0636\u0627\u0621",
                text: "\u0645\u0641\u062A\u0627\u062D \u062A\u0634\u063A\u064A\u0644. \u0639\u0646\u062F \u062A\u0641\u0639\u064A\u0644\u0647 \u064A\u062C\u0628 \u0639\u0644\u0649 \u0643\u0644 \u0639\u0636\u0648 \u0625\u0639\u062F\u0627\u062F \u062A\u0637\u0628\u064A\u0642 \u0645\u0635\u0627\u062F\u0642\u0629 \u0639\u0646\u062F \u062F\u062E\u0648\u0644\u0647 \u0627\u0644\u062A\u0627\u0644\u064A\u060C \u0648\u0625\u0644\u0627 \u0644\u0646 \u064A\u0633\u062A\u0637\u064A\u0639 \u0627\u0633\u062A\u062E\u062F\u0627\u0645 \u2066BatiFlow\u2069. \u0627\u0644\u0645\u0627\u0644\u0643 \u0648\u0627\u0644\u0645\u0634\u0631\u0641\u0648\u0646 \u0648\u0627\u0644\u0645\u062D\u0627\u0633\u0628\u0648\u0646 \u0645\u0644\u0632\u0645\u0648\u0646 \u0628\u0630\u0644\u0643 \u0623\u0635\u0644\u064B\u0627."
              }
            }
          }
        }
      },
      fiscal: {
        title: "\u0627\u0644\u0645\u0644\u0641 \u0627\u0644\u062C\u0628\u0627\u0626\u064A",
        intro: "\u062A\u062D\u062F\u0651\u062F \u0647\u0630\u0647 \u0627\u0644\u0635\u0641\u062D\u0629 \u0627\u0644\u0642\u0648\u0627\u0639\u062F \u0627\u0644\u062C\u0628\u0627\u0626\u064A\u0629 \u0627\u0644\u0645\u0637\u0628\u0651\u0642\u0629 \u0639\u0644\u0649 \u0641\u0648\u0627\u062A\u064A\u0631\u0643: \u0627\u0644\u0623\u062F\u0627\u0621 \u0639\u0644\u0649 \u0627\u0644\u0642\u064A\u0645\u0629 \u0627\u0644\u0645\u0636\u0627\u0641\u0629 \u0648\u0627\u0644\u0646\u0638\u0627\u0645 \u0627\u0644\u062C\u0628\u0627\u0626\u064A \u0648\u0627\u0644\u062E\u0635\u0645 \u0645\u0646 \u0627\u0644\u0645\u0648\u0631\u062F \u0648\u062A\u0630\u064A\u064A\u0644 \u0627\u0644\u0641\u0648\u0627\u062A\u064A\u0631 \u0648\u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A \u0627\u0644\u0628\u0646\u0643\u064A\u0629. \u0648\u0643\u0644 \u062A\u063A\u064A\u064A\u0631 \u064A\u0646\u0634\u0626 \u0646\u0633\u062E\u0629 \u062C\u062F\u064A\u062F\u0629. \u0648\u062A\u062F\u064A\u0631 \u0627\u0644\u0635\u0641\u062D\u0629 \u0623\u064A\u0636\u064B\u0627 \u062A\u0631\u0642\u064A\u0645 \u0641\u0648\u0627\u062A\u064A\u0631\u0643. \u064A\u0644\u0632\u0645 \u062D\u0642 \u0627\u0644\u0627\u0637\u0644\u0627\u0639 \u0639\u0644\u0649 \u0627\u0644\u0645\u0644\u0641 \u0627\u0644\u062C\u0628\u0627\u0626\u064A\u060C \u0648\u062D\u0642 \u0625\u0636\u0627\u0641\u064A \u0644\u062A\u0639\u062F\u064A\u0644\u0647.",
        sections: {
          header: {
            title: "\u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u0625\u062F\u0627\u0631\u0629 \u0648\u0631\u0623\u0633 \u0627\u0644\u0635\u0641\u062D\u0629",
            items: {
              adminNav: {
                term: "\u0627\u0644\u0625\u062F\u0627\u0631\u0629",
                text: "\u062A\u062C\u0645\u0639 \u0627\u0644\u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u062C\u0627\u0646\u0628\u064A\u0629 \u0635\u0641\u062D\u0627\u062A \u0625\u062F\u0627\u0631\u0629 \u0645\u0624\u0633\u0633\u062A\u0643 (\u0635\u0641\u0651 \u0645\u0646 \u0627\u0644\u0631\u0648\u0627\u0628\u0637 \u0641\u0648\u0642 \u0627\u0644\u0635\u0641\u062D\u0629 \u0639\u0644\u0649 \u0627\u0644\u0634\u0627\u0634\u0627\u062A \u0627\u0644\u0635\u063A\u064A\u0631\u0629). \u0648\u0644\u0627 \u062A\u0639\u0631\u0636 \u0625\u0644\u0627 \u0627\u0644\u0635\u0641\u062D\u0627\u062A \u0627\u0644\u062A\u064A \u064A\u0633\u0645\u062D \u0644\u0643 \u062F\u0648\u0631\u0643 \u0628\u0641\u062A\u062D\u0647\u0627."
              },
              newVersionButton: {
                term: "\u0646\u0633\u062E\u0629 \u062C\u062F\u064A\u062F\u0629",
                text: "\u064A\u0641\u062A\u062D \u0646\u0627\u0641\u0630\u0629 \u0625\u0646\u0634\u0627\u0621 \u0646\u0633\u062E\u0629. \u0644\u0627 \u064A\u0638\u0647\u0631 \u0625\u0644\u0627 \u0644\u0645\u0646 \u064A\u0633\u062A\u0637\u064A\u0639 \u062A\u0639\u062F\u064A\u0644 \u0627\u0644\u0645\u0644\u0641 \u0627\u0644\u062C\u0628\u0627\u0626\u064A. \u062A\u064F\u0633\u062A\u0639\u0627\u062F \u0642\u064A\u0645 \u0627\u0644\u0646\u0633\u062E\u0629 \u0627\u0644\u0633\u0627\u0631\u064A\u0629: \u063A\u064A\u0651\u0631 \u0645\u0627 \u062A\u063A\u064A\u0651\u0631 \u0641\u0642\u0637\u060C \u0648\u062A\u0628\u0642\u0649 \u0627\u0644\u0646\u0633\u062E\u0629 \u0627\u0644\u0633\u0627\u0628\u0642\u0629 \u0645\u062D\u0641\u0648\u0638\u0629."
              },
              empty: {
                term: "\u0644\u0627 \u064A\u0648\u062C\u062F \u0645\u0644\u0641 \u062C\u0628\u0627\u0626\u064A \u0628\u0639\u062F",
                text: "\u0631\u0633\u0627\u0644\u0629 \u0627\u0644\u0628\u062F\u0627\u064A\u0629: \u064A\u062D\u062F\u0651\u062F \u0627\u0644\u0645\u0644\u0641 \u0627\u0644\u062C\u0628\u0627\u0626\u064A \u0627\u0644\u0623\u062F\u0627\u0621 \u0639\u0644\u0649 \u0627\u0644\u0642\u064A\u0645\u0629 \u0627\u0644\u0645\u0636\u0627\u0641\u0629 \u0648\u0627\u0644\u0646\u0638\u0627\u0645 \u0627\u0644\u062C\u0628\u0627\u0626\u064A \u0648\u0627\u0644\u062E\u0635\u0645 \u0645\u0646 \u0627\u0644\u0645\u0648\u0631\u062F \u0648\u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A \u0627\u0644\u0628\u0646\u0643\u064A\u0629 \u0644\u0641\u0648\u0627\u062A\u064A\u0631\u0643. \u0648\u064A\u064F\u0639\u0631\u0636 \u0641\u064A\u0647\u0627 \u0632\u0631 \xAB\u0646\u0633\u062E\u0629 \u062C\u062F\u064A\u062F\u0629\xBB \u0644\u0645\u0646 \u064A\u0633\u062A\u0637\u064A\u0639 \u0625\u0646\u0634\u0627\u0621\u0647\u0627."
              }
            }
          },
          current: {
            title: "\u0627\u0644\u0646\u0633\u062E\u0629 \u0627\u0644\u0633\u0627\u0631\u064A\u0629",
            items: {
              effectiveFrom: {
                term: "\u0633\u0627\u0631\u064A\u0629 \u0645\u0646\u0630",
                text: "\u0627\u0644\u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0630\u064A \u062A\u064F\u0637\u0628\u064E\u0651\u0642 \u0645\u0646\u0647 \u0647\u0630\u0647 \u0627\u0644\u0642\u064A\u0645 \u0639\u0644\u0649 \u0627\u0644\u0641\u0648\u0627\u062A\u064A\u0631 \u0627\u0644\u062C\u062F\u064A\u062F\u0629."
              },
              createdBy: {
                term: "\u0623\u0646\u0634\u0623\u0647\u0627",
                text: "\u0627\u0644\u0639\u0636\u0648 \u0627\u0644\u0630\u064A \u0623\u0646\u0634\u0623 \u0647\u0630\u0647 \u0627\u0644\u0646\u0633\u062E\u0629."
              },
              vat: {
                term: "\u0627\u0644\u0623\u062F\u0627\u0621 \u0639\u0644\u0649 \u0627\u0644\u0642\u064A\u0645\u0629 \u0627\u0644\u0645\u0636\u0627\u0641\u0629",
                text: "\xAB\u062E\u0627\u0636\u0639 \u0644\u0644\u0623\u062F\u0627\u0621 \u0639\u0644\u0649 \u0627\u0644\u0642\u064A\u0645\u0629 \u0627\u0644\u0645\u0636\u0627\u0641\u0629\xBB \u0623\u0648 \xAB\u063A\u064A\u0631 \u062E\u0627\u0636\u0639 \u0644\u0644\u0623\u062F\u0627\u0621 \u0639\u0644\u0649 \u0627\u0644\u0642\u064A\u0645\u0629 \u0627\u0644\u0645\u0636\u0627\u0641\u0629\xBB: \u0623\u064A \u0647\u0644 \u064A\u0637\u0628\u0651\u0642 \u0645\u0643\u062A\u0628\u0643 \u0647\u0630\u0627 \u0627\u0644\u0623\u062F\u0627\u0621 \u0623\u0645 \u0644\u0627."
              },
              regime: {
                term: "\u0627\u0644\u0646\u0638\u0627\u0645 \u0627\u0644\u062C\u0628\u0627\u0626\u064A",
                text: "\u0627\u0644\u0646\u0638\u0627\u0645 \u0627\u0644\u062D\u0642\u064A\u0642\u064A \u0623\u0648 \u0627\u0644\u0646\u0638\u0627\u0645 \u0627\u0644\u062A\u0642\u062F\u064A\u0631\u064A."
              },
              withholding: {
                term: "\u0627\u0644\u0635\u0641\u0629 \u0628\u0627\u0644\u0646\u0633\u0628\u0629 \u0625\u0644\u0649 \u0627\u0644\u062E\u0635\u0645 \u0645\u0646 \u0627\u0644\u0645\u0648\u0631\u062F",
                text: "\u0634\u062E\u0635 \u0645\u0639\u0646\u0648\u064A \u0623\u0648 \u0634\u062E\u0635 \u0637\u0628\u064A\u0639\u064A \u062E\u0627\u0636\u0639 \u0644\u0644\u0646\u0638\u0627\u0645 \u0627\u0644\u062D\u0642\u064A\u0642\u064A \u0623\u0648 \u0623\u062E\u0631\u0649. \u0648\u0647\u064A \u062A\u062D\u062F\u0651\u062F \u0627\u0644\u062E\u0635\u0645 \u0645\u0646 \u0627\u0644\u0645\u0648\u0631\u062F \u0627\u0644\u0645\u0637\u0628\u0651\u0642 \u0639\u0644\u0649 \u0641\u0648\u0627\u062A\u064A\u0631\u0643."
              },
              footer: {
                term: "\u062A\u0630\u064A\u064A\u0644 \u0627\u0644\u0641\u0648\u0627\u062A\u064A\u0631",
                text: "\u0627\u0644\u0646\u0635 \u0627\u0644\u0630\u064A \u064A\u0638\u0647\u0631 \u0623\u0633\u0641\u0644 \u0641\u0648\u0627\u062A\u064A\u0631\u0643 (\u0625\u0634\u0639\u0627\u0631\u0627\u062A \u0642\u0627\u0646\u0648\u0646\u064A\u0629\u060C \u0634\u0631\u0648\u0637 \u0627\u0644\u062F\u0641\u0639\u2026)\u060C \u0623\u0648 \xAB\u0644\u0627 \u0634\u064A\u0621\xBB."
              },
              bank: {
                term: "\u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A \u0627\u0644\u0628\u0646\u0643\u064A\u0629",
                text: "\u0627\u0633\u0645 \u0627\u0644\u0628\u0646\u0643 \u0648\u0627\u0644\u0647\u0648\u064A\u0629 \u0627\u0644\u0628\u0646\u0643\u064A\u0629 (\u2066RIB\u2069) \u0645\u062E\u0641\u064A\u0629 \u062C\u0632\u0626\u064A\u064B\u0627\u060C \u0623\u0648 \xAB\u0644\u0627 \u0634\u064A\u0621\xBB."
              },
              showRib: {
                term: "\u0625\u0638\u0647\u0627\u0631 \u0627\u0644\u0647\u0648\u064A\u0629 \u0627\u0644\u0628\u0646\u0643\u064A\u0629 \u0643\u0627\u0645\u0644\u0629",
                text: "\u0644\u0645\u0646 \u064A\u0633\u062A\u0637\u064A\u0639 \u062A\u0639\u062F\u064A\u0644 \u0627\u0644\u0645\u0644\u0641. \u0628\u0639\u062F \u062A\u0623\u0643\u064A\u062F \u0647\u0648\u064A\u062A\u0643 \u062A\u0638\u0647\u0631 \u0627\u0644\u0647\u0648\u064A\u0629 \u0627\u0644\u0628\u0646\u0643\u064A\u0629 (\u2066RIB\u2069) \u0648\u2066IBAN\u2069 \u0645\u0639 \u0632\u0631 \u0644\u0646\u0633\u062E\u0647\u0627\u061B \u0648\u064A\u062E\u0641\u064A\u0647\u0627 \xAB\u0625\u062E\u0641\u0627\u0621\xBB\u060C \u0648\u062A\u062E\u062A\u0641\u064A \u0645\u0646 \u062A\u0644\u0642\u0627\u0621 \u0646\u0641\u0633\u0647\u0627 \u0628\u0639\u062F \u062F\u0642\u064A\u0642\u0629 \u0648\u0627\u062D\u062F\u0629. \u0648\u064A\u064F\u0633\u062C\u064E\u0651\u0644 \u0643\u0644 \u0627\u0637\u0644\u0627\u0639 \u0641\u064A \u0633\u062C\u0644 \u0627\u0644\u062A\u062F\u0642\u064A\u0642."
              }
            }
          },
          history: {
            title: "\u0633\u062C\u0644 \u0627\u0644\u0646\u0633\u062E",
            items: {
              table: {
                term: "\u0646\u0633\u062E \u0627\u0644\u0645\u0644\u0641 \u0627\u0644\u062C\u0628\u0627\u0626\u064A \u0645\u0646 \u0627\u0644\u0623\u062D\u062F\u062B \u0625\u0644\u0649 \u0627\u0644\u0623\u0642\u062F\u0645",
                text: "\u062C\u062F\u0648\u0644 \u0628\u0633\u0637\u0631 \u0644\u0643\u0644 \u0646\u0633\u062E\u0629 \u0648\u0628\u0627\u0644\u0645\u0639\u0644\u0648\u0645\u0627\u062A \u0646\u0641\u0633\u0647\u0627 \u0623\u0639\u0644\u0627\u0647. \u0648\u0627\u0644\u0646\u0633\u062E\u0629 \u0627\u0644\u062C\u062F\u064A\u062F\u0629 \u0644\u0627 \u062A\u063A\u064A\u0651\u0631 \u0627\u0644\u0642\u062F\u064A\u0645\u0629 \u0623\u0628\u062F\u064B\u0627: \u062A\u062D\u062A\u0641\u0638 \u0627\u0644\u0641\u0648\u0627\u062A\u064A\u0631 \u0627\u0644\u0635\u0627\u062F\u0631\u0629 \u0628\u0627\u0644\u0646\u0633\u062E\u0629 \u0627\u0644\u062A\u064A \u0643\u0627\u0646\u062A \u0633\u0627\u0631\u064A\u0629."
              },
              status: {
                term: "\u0627\u0644\u062D\u0627\u0644\u0629",
                text: "\u0633\u0627\u0631\u064A\u0629: \u0627\u0644\u0646\u0633\u062E\u0629 \u0627\u0644\u0645\u0637\u0628\u0651\u0642\u0629 \u0627\u0644\u064A\u0648\u0645. \u0645\u0628\u0631\u0645\u062C\u0629: \u0633\u062A\u0628\u062F\u0623 \u0641\u064A \u062A\u0627\u0631\u064A\u062E \u0644\u0627\u062D\u0642. \u0633\u0627\u0628\u0642\u0629: \u062A\u0645 \u0627\u0633\u062A\u0628\u062F\u0627\u0644\u0647\u0627."
              },
              rowBank: {
                term: "\u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A \u0627\u0644\u0628\u0646\u0643\u064A\u0629",
                text: "\u0644\u0643\u0644 \u0633\u0637\u0631 \u0639\u0645\u0648\u062F \u0628\u064A\u0627\u0646\u0627\u062A\u0647 \u0627\u0644\u0628\u0646\u0643\u064A\u0629\u060C \u0645\u0639 \u0632\u0631 \xAB\u0625\u0638\u0647\u0627\u0631 \u0627\u0644\u0647\u0648\u064A\u0629 \u0627\u0644\u0628\u0646\u0643\u064A\u0629 \u0643\u0627\u0645\u0644\u0629\xBB \u0646\u0641\u0633\u0647 \u0644\u0645\u0646 \u064A\u062D\u0642 \u0644\u0647 \u0630\u0644\u0643."
              }
            }
          },
          newVersion: {
            title: "\u0646\u0633\u062E\u0629 \u062C\u062F\u064A\u062F\u0629 \u0645\u0646 \u0627\u0644\u0645\u0644\u0641 \u0627\u0644\u062C\u0628\u0627\u0626\u064A",
            items: {
              start: {
                term: "\u0628\u062F\u0627\u064A\u0629 \u0627\u0644\u062A\u0637\u0628\u064A\u0642",
                text: "\u0627\u062E\u062A\u0631 \xAB\u0627\u0644\u0622\u0646\xBB \u0623\u0648 \xAB\u0641\u064A \u062A\u0627\u0631\u064A\u062E \u0644\u0627\u062D\u0642\xBB\u061B \u0648\u0641\u064A \u0647\u0630\u0647 \u0627\u0644\u062D\u0627\u0644\u0629 \u0623\u062F\u062E\u0644 \xAB\u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0628\u062F\u0627\u064A\u0629\xBB \u0627\u0644\u0630\u064A \u0644\u0627 \u064A\u0645\u0643\u0646 \u0623\u0646 \u064A\u0643\u0648\u0646 \u0641\u064A \u0627\u0644\u0645\u0627\u0636\u064A. \u0648\u062A\u0638\u0647\u0631 \u0627\u0644\u0646\u0633\u062E\u0629 \u0627\u0644\u0645\u0628\u0631\u0645\u062C\u0629 \u0628\u062D\u0627\u0644\u0629 \xAB\u0645\u0628\u0631\u0645\u062C\u0629\xBB."
              },
              vat: {
                term: "\u062E\u0627\u0636\u0639 \u0644\u0644\u0623\u062F\u0627\u0621 \u0639\u0644\u0649 \u0627\u0644\u0642\u064A\u0645\u0629 \u0627\u0644\u0645\u0636\u0627\u0641\u0629",
                text: "\u0645\u0641\u062A\u0627\u062D \u062A\u0634\u063A\u064A\u0644: \u0647\u0644 \u064A\u0637\u0628\u0651\u0642 \u0627\u0644\u0645\u0643\u062A\u0628 \u0627\u0644\u0623\u062F\u0627\u0621 \u0639\u0644\u0649 \u0627\u0644\u0642\u064A\u0645\u0629 \u0627\u0644\u0645\u0636\u0627\u0641\u0629 \u0639\u0644\u0649 \u0641\u0648\u0627\u062A\u064A\u0631\u0647 \u0623\u0645 \u0644\u0627."
              },
              regimeChoice: {
                term: "\u0627\u0644\u0646\u0638\u0627\u0645 \u0627\u0644\u062C\u0628\u0627\u0626\u064A",
                text: "\u0642\u0627\u0626\u0645\u0629: \u0627\u0644\u0646\u0638\u0627\u0645 \u0627\u0644\u062D\u0642\u064A\u0642\u064A \u0623\u0648 \u0627\u0644\u0646\u0638\u0627\u0645 \u0627\u0644\u062A\u0642\u062F\u064A\u0631\u064A."
              },
              withholdingChoice: {
                term: "\u0627\u0644\u0635\u0641\u0629 \u0628\u0627\u0644\u0646\u0633\u0628\u0629 \u0625\u0644\u0649 \u0627\u0644\u062E\u0635\u0645 \u0645\u0646 \u0627\u0644\u0645\u0648\u0631\u062F",
                text: "\u0642\u0627\u0626\u0645\u0629: \u0634\u062E\u0635 \u0645\u0639\u0646\u0648\u064A \u0623\u0648 \u0634\u062E\u0635 \u0637\u0628\u064A\u0639\u064A \u062E\u0627\u0636\u0639 \u0644\u0644\u0646\u0638\u0627\u0645 \u0627\u0644\u062D\u0642\u064A\u0642\u064A \u0623\u0648 \u0623\u062E\u0631\u0649."
              },
              footerField: {
                term: "\u062A\u0630\u064A\u064A\u0644 \u0627\u0644\u0641\u0648\u0627\u062A\u064A\u0631",
                text: "\u0645\u0631\u0628\u0639 \u0646\u0635 \u0627\u062E\u062A\u064A\u0627\u0631\u064A \u0644\u0644\u0625\u0634\u0639\u0627\u0631\u0627\u062A \u0627\u0644\u0642\u0627\u0646\u0648\u0646\u064A\u0629 \u0623\u0648 \u0634\u0631\u0648\u0637 \u0627\u0644\u062F\u0641\u0639. \u0648\u062A\u0646\u0628\u0651\u0647 \u0631\u0633\u0627\u0644\u0629 \u0625\u0644\u0649 \u0627\u0644\u0646\u0635 \u0627\u0644\u0637\u0648\u064A\u0644 \u062C\u062F\u064B\u0627."
              },
              bankField: {
                term: "\u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A \u0627\u0644\u0628\u0646\u0643\u064A\u0629 (\u0627\u062E\u062A\u064A\u0627\u0631\u064A)",
                text: "\xAB\u0627\u0633\u0645 \u0627\u0644\u0628\u0646\u0643\xBB \u0648\xAB\u0627\u0644\u0647\u0648\u064A\u0629 \u0627\u0644\u0628\u0646\u0643\u064A\u0629 (\u2066RIB\u2069)\xBB (20 \u0631\u0642\u0645\u064B\u0627\u060C \u062F\u0648\u0646 \u0627\u0644\u0628\u0627\u062F\u0626\u0629 \xAB\u2066TN59\u2069\xBB). \u0644\u0627 \u062A\u064F\u0646\u0642\u0644 \u0645\u0646 \u0627\u0644\u0646\u0633\u062E\u0629 \u0627\u0644\u0633\u0627\u0628\u0642\u0629: \u0623\u062F\u062E\u0644\u0647\u0627 \u0645\u0646 \u062C\u062F\u064A\u062F\u060C \u0623\u0648 \u0627\u062A\u0631\u0643\u0647\u0627 \u0641\u0627\u0631\u063A\u0629 \u0644\u0646\u0633\u062E\u0629 \u062F\u0648\u0646 \u0628\u064A\u0627\u0646\u0627\u062A \u0628\u0646\u0643\u064A\u0629."
              },
              submit: {
                term: "\u0625\u0646\u0634\u0627\u0621 \u0627\u0644\u0646\u0633\u062E\u0629",
                text: "\u064A\u062D\u0641\u0638 \u0627\u0644\u0646\u0633\u062E\u0629. \u0648\u0644\u062D\u0645\u0627\u064A\u062A\u0643 \u064A\u064F\u0637\u0644\u0628 \u0645\u0646\u0643 \u062A\u0623\u0643\u064A\u062F \u0647\u0648\u064A\u062A\u0643. \u062B\u0645 \u062A\u0642\u0648\u0644 \u0631\u0633\u0627\u0644\u0629 \u0625\u0646 \u0643\u0627\u0646\u062A \u0627\u0644\u0646\u0633\u062E\u0629 \u0633\u0627\u0631\u064A\u0629 \u0623\u0648 \u0645\u0628\u0631\u0645\u062C\u0629."
              }
            }
          },
          series: {
            title: "\u0633\u0644\u0627\u0633\u0644 \u062A\u0631\u0642\u064A\u0645 \u0627\u0644\u0641\u0648\u0627\u062A\u064A\u0631",
            items: {
              add: {
                term: "\u0625\u0636\u0627\u0641\u0629 \u0633\u0644\u0633\u0644\u0629",
                text: "\u0644\u0645\u0646 \u064A\u0633\u062A\u0637\u064A\u0639 \u062A\u0639\u062F\u064A\u0644 \u0627\u0644\u0645\u0644\u0641 \u0627\u0644\u062C\u0628\u0627\u0626\u064A. \u0644\u0643\u0644 \u0633\u0644\u0633\u0644\u0629 \u0639\u062F\u0651\u0627\u062F \u062E\u0627\u0635 \u0628\u0647\u0627 \u062F\u0648\u0646 \u0641\u062C\u0648\u0627\u062A\u060C \u0648\u062A\u064F\u0642\u062A\u0631\u062D \u0627\u0644\u0633\u0644\u0633\u0644\u0629 \u0627\u0644\u0627\u0641\u062A\u0631\u0627\u0636\u064A\u0629 \u0639\u0644\u0649 \u0627\u0644\u0641\u0648\u0627\u062A\u064A\u0631 \u0627\u0644\u062C\u062F\u064A\u062F\u0629."
              },
              code: {
                term: "\u0627\u0644\u0631\u0645\u0632",
                text: "\u0627\u0644\u0631\u0645\u0632 \u0627\u0644\u0642\u0635\u064A\u0631 \u0644\u0644\u0633\u0644\u0633\u0644\u0629\u060C \u0645\u062B\u0644 \u2066FAC\u2069."
              },
              prefix: {
                term: "\u0627\u0644\u0628\u0627\u062F\u0626\u0629",
                text: "\u0628\u062F\u0627\u064A\u0629 \u0643\u0644 \u0631\u0642\u0645 \u0641\u0627\u062A\u0648\u0631\u0629 \u0641\u064A \u0627\u0644\u0633\u0644\u0633\u0644\u0629\u060C \u0645\u062B\u0644 \xAB\u2066FAC\u2069-\xBB."
              },
              reset: {
                term: "\u0625\u0639\u0627\u062F\u0629 \u0627\u0644\u062A\u0635\u0641\u064A\u0631",
                text: "\xAB\u0643\u0644 \u0633\u0646\u0629\xBB: \u064A\u0639\u0648\u062F \u0627\u0644\u0639\u062F\u0651\u0627\u062F \u0625\u0644\u0649 1 \u0641\u064A \u0628\u062F\u0627\u064A\u0629 \u0643\u0644 \u0633\u0646\u0629. \xAB\u0623\u0628\u062F\u064B\u0627\xBB: \u064A\u0648\u0627\u0635\u0644 \u0627\u0644\u0639\u062F\u0651 \u062F\u0648\u0646 \u062A\u0648\u0642\u0641."
              },
              default: {
                term: "\u0627\u0644\u0633\u0644\u0633\u0644\u0629 \u0627\u0644\u0627\u0641\u062A\u0631\u0627\u0636\u064A\u0629",
                text: "\u062A\u0634\u064A\u0631 \u0634\u0627\u0631\u0629 \xAB\u0627\u0641\u062A\u0631\u0627\u0636\u064A\u0629\xBB \u0625\u0644\u0649 \u0627\u0644\u0633\u0644\u0633\u0644\u0629 \u0627\u0644\u0645\u0642\u062A\u0631\u062D\u0629 \u0639\u0644\u0649 \u0627\u0644\u0641\u0648\u0627\u062A\u064A\u0631 \u0627\u0644\u062C\u062F\u064A\u062F\u0629. \u0648\u062A\u0648\u062C\u062F \u062F\u0627\u0626\u0645\u064B\u0627 \u0633\u0644\u0633\u0644\u0629 \u0648\u0627\u062D\u062F\u0629 \u0645\u0646\u0647\u0627."
              },
              actions: {
                term: "\u0627\u0644\u0625\u062C\u0631\u0627\u0621\u0627\u062A",
                text: "\u062A\u0642\u062A\u0631\u062D \u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u0633\u0637\u0631 \u062A\u0639\u062F\u064A\u0644 \u0648\u062C\u0639\u0644\u0647\u0627 \u0627\u0641\u062A\u0631\u0627\u0636\u064A\u0629 \u0648\u062D\u0630\u0641\u061B \u0648\u0627\u0644\u0623\u062E\u064A\u0631\u0627\u0646 \u063A\u064A\u0631 \u0645\u062A\u0627\u062D\u064A\u0646 \u0644\u0644\u0633\u0644\u0633\u0644\u0629 \u0627\u0644\u0627\u0641\u062A\u0631\u0627\u0636\u064A\u0629. \u0648\u0644\u0627 \u064A\u0638\u0647\u0631 \u0647\u0630\u0627 \u0627\u0644\u0639\u0645\u0648\u062F \u0625\u0644\u0627 \u0644\u0645\u0646 \u064A\u0633\u062A\u0637\u064A\u0639 \u062A\u0639\u062F\u064A\u0644 \u0627\u0644\u0645\u0644\u0641 \u0627\u0644\u062C\u0628\u0627\u0626\u064A."
              },
              empty: {
                term: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0633\u0644\u0627\u0633\u0644 \u0641\u0648\u0627\u062A\u064A\u0631",
                text: "\u0631\u0633\u0627\u0644\u0629 \u0627\u0644\u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u0641\u0627\u0631\u063A\u0629: \u0623\u0636\u0641 \u0633\u0644\u0633\u0644\u0629 \u0644\u062A\u0631\u0642\u064A\u0645 \u0641\u0648\u0627\u062A\u064A\u0631\u0643."
              }
            }
          },
          seriesDialog: {
            title: "\u0625\u0636\u0627\u0641\u0629 \u0633\u0644\u0633\u0644\u0629 \u0641\u0648\u0627\u062A\u064A\u0631",
            items: {
              codeField: {
                term: "\u0627\u0644\u0631\u0645\u0632",
                text: "\u0645\u0646 1 \u0625\u0644\u0649 10 \u0623\u062D\u0631\u0641 \u0623\u0648 \u0623\u0631\u0642\u0627\u0645\u060C \u062F\u0648\u0646 \u0645\u0633\u0627\u0641\u0627\u062A \u0623\u0648 \u0639\u0644\u0627\u0645\u0627\u062A \u062A\u0634\u0643\u064A\u0644. \u0644\u0627 \u064A\u0645\u0643\u0646 \u062A\u063A\u064A\u064A\u0631\u0647 \u0644\u0627\u062D\u0642\u064B\u0627 \u0644\u0623\u0646 \u0627\u0644\u0623\u0631\u0642\u0627\u0645 \u0627\u0644\u0635\u0627\u062F\u0631\u0629 \u0633\u0627\u0628\u0642\u064B\u0627 \u062A\u0634\u064A\u0631 \u0625\u0644\u064A\u0647. \u0648\u064A\u064F\u0631\u0641\u0636 \u0631\u0645\u0632 \u062A\u0633\u062A\u0639\u0645\u0644\u0647 \u0633\u0644\u0633\u0644\u0629 \u0623\u062E\u0631\u0649."
              },
              prefixField: {
                term: "\u0627\u0644\u0628\u0627\u062F\u0626\u0629",
                text: "\u0625\u0644\u0632\u0627\u0645\u064A\u0629. \u0628\u062F\u0627\u064A\u0629 \u0643\u0644 \u0631\u0642\u0645\u060C \u0645\u062B\u0644 \xAB\u2066FAC\u2069-\xBB."
              },
              resetYearly: {
                term: "\u0625\u0639\u0627\u062F\u0629 \u0627\u0644\u062A\u0631\u0642\u064A\u0645 \u0643\u0644 \u0633\u0646\u0629",
                text: "\u0645\u0641\u062A\u0627\u062D \u062A\u0634\u063A\u064A\u0644: \u064A\u0639\u0648\u062F \u0627\u0644\u0639\u062F\u0651\u0627\u062F \u0625\u0644\u0649 1 \u0641\u064A \u0628\u062F\u0627\u064A\u0629 \u0643\u0644 \u0633\u0646\u0629."
              },
              makeDefault: {
                term: "\u0627\u0644\u0633\u0644\u0633\u0644\u0629 \u0627\u0644\u0627\u0641\u062A\u0631\u0627\u0636\u064A\u0629",
                text: "\u0645\u0641\u062A\u0627\u062D \u062A\u0634\u063A\u064A\u0644 \u064A\u064F\u0639\u0631\u0636 \u0639\u0646\u062F \u0625\u0636\u0627\u0641\u0629 \u0633\u0644\u0633\u0644\u0629 \u0641\u0642\u0637. \u0623\u0645\u0627 \u0644\u0633\u0644\u0633\u0644\u0629 \u0645\u0648\u062C\u0648\u062F\u0629 \u0641\u0627\u0633\u062A\u0639\u0645\u0644 \xAB\u062C\u0639\u0644\u0647\u0627 \u0627\u0641\u062A\u0631\u0627\u0636\u064A\u0629\xBB \u0645\u0646 \u0642\u0627\u0626\u0645\u062A\u0647\u0627."
              },
              delete: {
                term: "\u062D\u0630\u0641",
                text: "\u0628\u0639\u062F \u0627\u0644\u062A\u0623\u0643\u064A\u062F \u0644\u0646 \u062A\u064F\u0642\u062A\u0631\u062D \u0627\u0644\u0633\u0644\u0633\u0644\u0629 \u0628\u0639\u062F \u0627\u0644\u0622\u0646\u060C \u0648\u0644\u0627 \u064A\u0645\u0643\u0646 \u0627\u0644\u062A\u0631\u0627\u062C\u0639. \u0648\u0644\u0627 \u064A\u0645\u0643\u0646 \u062D\u0630\u0641 \u0627\u0644\u0633\u0644\u0633\u0644\u0629 \u0627\u0644\u0627\u0641\u062A\u0631\u0627\u0636\u064A\u0629: \u0627\u062C\u0639\u0644 \u0633\u0644\u0633\u0644\u0629 \u0623\u062E\u0631\u0649 \u0627\u0641\u062A\u0631\u0627\u0636\u064A\u0629 \u0623\u0648\u0644\u064B\u0627."
              }
            }
          }
        }
      },
      audit: {
        title: "\u0633\u062C\u0644 \u0627\u0644\u062A\u062F\u0642\u064A\u0642",
        intro: "\u062A\u062D\u062A\u0641\u0638 \u0647\u0630\u0647 \u0627\u0644\u0635\u0641\u062D\u0629 \u0628\u0623\u062B\u0631 \u0645\u0646 \u0641\u0639\u0644 \u0645\u0627\u0630\u0627 \u0648\u0645\u062A\u0649 \u0641\u064A \u0645\u0643\u062A\u0628\u0643: \u062A\u0633\u062C\u064A\u0644\u0627\u062A \u0627\u0644\u062F\u062E\u0648\u0644 \u0648\u062A\u0639\u062F\u064A\u0644\u0627\u062A \u0627\u0644\u0645\u0644\u0641 \u0648\u0627\u0644\u0641\u0648\u0627\u062A\u064A\u0631 \u0627\u0644\u0635\u0627\u062F\u0631\u0629... \u064A\u0631\u0649 \u0627\u0644\u0645\u0627\u0644\u0643 \u0648\u0627\u0644\u0645\u0634\u0631\u0641\u0648\u0646 \u0643\u0644 \u0634\u064A\u0621\u060C \u0648\u064A\u0631\u0649 \u0627\u0644\u0645\u062D\u0627\u0633\u0628 \u0627\u0644\u0623\u062D\u062F\u0627\u062B \u0627\u0644\u0645\u0627\u0644\u064A\u0629 \u0641\u0642\u0637.",
        sections: {
          header: {
            title: "\u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u0625\u062F\u0627\u0631\u0629 \u0648\u0627\u0644\u0648\u0635\u0648\u0644",
            items: {
              adminNav: {
                term: "\u0627\u0644\u0625\u062F\u0627\u0631\u0629",
                text: "\u062A\u062C\u0645\u0639 \u0627\u0644\u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u062C\u0627\u0646\u0628\u064A\u0629 \u0635\u0641\u062D\u0627\u062A \u0625\u062F\u0627\u0631\u0629 \u0645\u0624\u0633\u0633\u062A\u0643 (\u0635\u0641\u0651 \u0645\u0646 \u0627\u0644\u0631\u0648\u0627\u0628\u0637 \u0641\u0648\u0642 \u0627\u0644\u0635\u0641\u062D\u0629 \u0639\u0644\u0649 \u0627\u0644\u0634\u0627\u0634\u0627\u062A \u0627\u0644\u0635\u063A\u064A\u0631\u0629). \u0648\u0644\u0627 \u062A\u0639\u0631\u0636 \u0625\u0644\u0627 \u0627\u0644\u0635\u0641\u062D\u0627\u062A \u0627\u0644\u062A\u064A \u064A\u0633\u0645\u062D \u0644\u0643 \u062F\u0648\u0631\u0643 \u0628\u0641\u062A\u062D\u0647\u0627."
              },
              financeOnly: {
                term: "\u0628\u0635\u0641\u062A\u0643 \u0645\u062D\u0627\u0633\u0628\u064B\u0627\u060C \u062A\u0631\u0649 \u0627\u0644\u0623\u062D\u062F\u0627\u062B \u0627\u0644\u0645\u0627\u0644\u064A\u0629 \u0641\u0642\u0637",
                text: "\u0631\u0633\u0627\u0644\u0629 \u0645\u0639\u0644\u0648\u0645\u0627\u062A \u062A\u0638\u0647\u0631 \u0644\u0644\u0645\u062D\u0627\u0633\u0628\u064A\u0646: \u0627\u0644\u0641\u0648\u0627\u062A\u064A\u0631 \u0648\u0639\u0631\u0648\u0636 \u0627\u0644\u0623\u0633\u0639\u0627\u0631 \u0648\u0627\u0644\u0639\u0642\u0648\u062F \u0648\u0627\u0644\u0645\u062F\u0641\u0648\u0639\u0627\u062A \u0648\u0627\u0644\u0645\u0635\u0627\u0631\u064A\u0641 \u0648\u0627\u0644\u0625\u0639\u062F\u0627\u062F\u0627\u062A \u0627\u0644\u062C\u0628\u0627\u0626\u064A\u0629. \u0628\u0627\u0642\u064A \u0627\u0644\u0623\u062D\u062F\u0627\u062B \u0645\u062E\u0635\u0635\u0629 \u0644\u0644\u0645\u0627\u0644\u0643 \u0648\u0627\u0644\u0645\u0634\u0631\u0641\u064A\u0646."
              }
            }
          },
          integrity: {
            title: "\u0633\u0644\u0627\u0645\u0629 \u0627\u0644\u0633\u062C\u0644",
            items: {
              intro: {
                term: "\u0633\u0644\u0627\u0645\u0629 \u0627\u0644\u0633\u062C\u0644",
                text: "\u0642\u0633\u0645 \u0645\u062E\u0635\u0635 \u0644\u0644\u0645\u0627\u0644\u0643. \u064A\u0631\u062A\u0628\u0637 \u0643\u0644 \u062D\u062F\u062B \u0628\u0627\u0644\u062D\u062F\u062B \u0627\u0644\u0630\u064A \u064A\u0633\u0628\u0642\u0647 \u0628\u0628\u0635\u0645\u0629\u061B \u0648\u064A\u0639\u064A\u062F \u0627\u0644\u0641\u062D\u0635 \u062D\u0633\u0627\u0628 \u0647\u0630\u0627 \u0627\u0644\u062A\u0633\u0644\u0633\u0644 \u0648\u064A\u064F\u0628\u0644\u063A \u0625\u0646 \u062A\u0645 \u062A\u0639\u062F\u064A\u0644 \u062D\u062F\u062B \u0623\u0648 \u062D\u0630\u0641\u0647 \u0623\u0648 \u0646\u0642\u0644\u0647."
              },
              verify: {
                term: "\u0627\u0644\u062A\u062D\u0642\u0642 \u0645\u0646 \u0627\u0644\u0633\u0644\u0627\u0645\u0629",
                text: "\u064A\u0628\u062F\u0623 \u0627\u0644\u0641\u062D\u0635. \u0648\u0623\u062B\u0646\u0627\u0621 \u0627\u0644\u062D\u0633\u0627\u0628 \u064A\u0639\u0631\u0636 \u0627\u0644\u0632\u0631 \xAB\u062C\u0627\u0631\u064D \u0627\u0644\u062A\u062D\u0642\u0642\u2026\xBB."
              },
              intact: {
                term: "\u0627\u0644\u0633\u062C\u0644 \u0633\u0644\u064A\u0645",
                text: "\u0631\u0633\u0627\u0644\u0629 \u062E\u0636\u0631\u0627\u0621: \u0644\u0645 \u064A\u064F\u0643\u062A\u0634\u0641 \u0623\u064A \u062A\u0639\u062F\u064A\u0644 \u0623\u0648 \u062D\u0630\u0641\u060C \u0645\u0639 \u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0641\u062D\u0635 \u0648\u0648\u0642\u062A\u0647."
              },
              altered: {
                term: "\u062A\u0645 \u0627\u0644\u0639\u0628\u062B \u0628\u0627\u0644\u0633\u062C\u0644",
                text: "\u0631\u0633\u0627\u0644\u0629 \u062D\u0645\u0631\u0627\u0621: \u0627\u0644\u062A\u0633\u0644\u0633\u0644 \u0645\u0646\u0642\u0637\u0639 \u0627\u0628\u062A\u062F\u0627\u0621\u064B \u0645\u0646 \u0631\u0642\u0645 \u062D\u062F\u062B \u0645\u0639\u064A\u0651\u0646\u060C \u0645\u0639 \u0627\u0644\u0633\u0628\u0628 (\u0645\u062D\u062A\u0648\u0649 \u0645\u0639\u062F\u064E\u0651\u0644 \u0623\u0648 \u062D\u062F\u062B \u0645\u0641\u0642\u0648\u062F \u0623\u0648 \u0631\u0627\u0628\u0637 \u0645\u0646\u0642\u0637\u0639). \u0627\u062D\u062A\u0641\u0638 \u0628\u0627\u0644\u0634\u0627\u0634\u0629 \u0648\u062A\u0648\u0627\u0635\u0644 \u0645\u0639 \u062F\u0639\u0645 \u2066BatiFlow\u2069 \u0641\u0648\u0631\u064B\u0627."
              },
              failed: {
                term: "\u0644\u0645 \u064A\u0643\u062A\u0645\u0644 \u0627\u0644\u062A\u062D\u0642\u0642",
                text: "\u062A\u0639\u0630\u0651\u0631 \u0625\u0646\u0647\u0627\u0621 \u0627\u0644\u0641\u062D\u0635\u061B \u0648\u062A\u0634\u0631\u062D \u0627\u0644\u0631\u0633\u0627\u0644\u0629 \u0627\u0644\u0633\u0628\u0628 \u0628\u0648\u0636\u0648\u062D. \u064A\u0645\u0643\u0646\u0643 \u0625\u0639\u0627\u062F\u0629 \u0627\u0644\u062A\u0634\u063A\u064A\u0644."
              }
            }
          },
          filters: {
            title: "\u0639\u0648\u0627\u0645\u0644 \u062A\u0635\u0641\u064A\u0629 \u0627\u0644\u0633\u062C\u0644",
            items: {
              actor: {
                term: "\u0627\u0644\u0645\u0646\u0641\u0651\u0630",
                text: "\u0627\u062E\u062A\u0631 \u0627\u0644\u0634\u062E\u0635 \u0627\u0644\u0630\u064A \u0646\u0641\u0651\u0630 \u0627\u0644\u0625\u062C\u0631\u0627\u0621\u060C \u0623\u0648 \xAB\u0627\u0644\u062C\u0645\u064A\u0639\xBB. \u0648\u0644\u0627 \u064A\u0638\u0647\u0631 \u0647\u0630\u0627 \u0627\u0644\u0641\u0644\u062A\u0631 \u0625\u0644\u0627 \u0625\u0630\u0627 \u0643\u0627\u0646 \u0628\u0625\u0645\u0643\u0627\u0646\u0643 \u0631\u0624\u064A\u0629 \u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u0623\u0639\u0636\u0627\u0621."
              },
              action: {
                term: "\u0646\u0648\u0639 \u0627\u0644\u0625\u062C\u0631\u0627\u0621",
                text: "\u0645\u062C\u0645\u0648\u0639\u0629 \u0625\u062C\u0631\u0627\u0621\u0627\u062A: \u0627\u0644\u0645\u0624\u0633\u0633\u0629 \u0648\u0627\u0644\u0625\u0639\u062F\u0627\u062F\u0627\u062A\u060C \u0627\u0644\u0623\u0639\u0636\u0627\u0621 \u0648\u0627\u0644\u062F\u0639\u0648\u0627\u062A\u060C \u0627\u0644\u0639\u0645\u0644\u0627\u0621\u060C \u0627\u0644\u062F\u062E\u0648\u0644 \u0648\u0627\u0644\u0623\u0645\u0627\u0646\u060C \u0627\u0644\u0641\u0648\u0627\u062A\u064A\u0631\u060C \u0639\u0631\u0648\u0636 \u0627\u0644\u0623\u0633\u0639\u0627\u0631\u060C \u0627\u0644\u0639\u0642\u0648\u062F\u060C \u0627\u0644\u0645\u062F\u0641\u0648\u0639\u0627\u062A\u060C \u0627\u0644\u0645\u0635\u0627\u0631\u064A\u0641. \u0648\u0644\u0627 \u064A\u062D\u0635\u0644 \u0627\u0644\u0645\u062D\u0627\u0633\u0628 \u0625\u0644\u0627 \u0639\u0644\u0649 \u0645\u0627 \u064A\u0645\u0633 \u0627\u0644\u0645\u0627\u0644\u064A\u0629. \u0648\xAB\u0643\u0644 \u0627\u0644\u0625\u062C\u0631\u0627\u0621\u0627\u062A\xBB \u062A\u0639\u0631\u0636 \u0643\u0644 \u0634\u064A\u0621."
              },
              from: {
                term: "\u0645\u0646",
                text: "\u0623\u0648\u0644 \u064A\u0648\u0645 \u064A\u064F\u0639\u0631\u0636 (\u064A\u0648\u0645 \u062A\u0642\u0648\u064A\u0645\u064A \u0628\u062A\u0648\u0642\u064A\u062A \u062A\u0648\u0646\u0633)."
              },
              to: {
                term: "\u0625\u0644\u0649",
                text: "\u0622\u062E\u0631 \u064A\u0648\u0645 \u064A\u064F\u0639\u0631\u0636\u060C \u062D\u062A\u0649 \u0646\u0647\u0627\u064A\u0629 \u0630\u0644\u0643 \u0627\u0644\u064A\u0648\u0645. \u0648\u0644\u0627 \u064A\u0645\u0643\u0646 \u0623\u0646 \u064A\u0633\u0628\u0642 \u062A\u0627\u0631\u064A\u062E \xAB\u0645\u0646\xBB."
              },
              clear: {
                term: "\u0645\u0633\u062D \u0639\u0648\u0627\u0645\u0644 \u0627\u0644\u062A\u0635\u0641\u064A\u0629",
                text: "\u064A\u0638\u0647\u0631 \u0628\u0645\u062C\u0631\u062F \u0627\u062E\u062A\u064A\u0627\u0631 \u0641\u0644\u062A\u0631\u060C \u0648\u064A\u0639\u064A\u062F \u0643\u0644 \u0634\u064A\u0621 \u0625\u0644\u0649 \u0648\u0636\u0639\u0647 \u0627\u0644\u0623\u0648\u0644."
              }
            }
          },
          events: {
            title: "\u0623\u062D\u062F\u0627\u062B \u0633\u062C\u0644 \u0627\u0644\u062A\u062F\u0642\u064A\u0642",
            items: {
              when: {
                term: "\u0627\u0644\u062A\u0627\u0631\u064A\u062E \u0648\u0627\u0644\u0648\u0642\u062A",
                text: "\u0648\u0642\u062A \u062D\u062F\u0648\u062B \u0627\u0644\u0625\u062C\u0631\u0627\u0621. \u0648\u062A\u064F\u0631\u062A\u064E\u0651\u0628 \u0627\u0644\u0623\u062D\u062F\u0627\u062B \u0645\u0646 \u0627\u0644\u0623\u062D\u062F\u062B \u0625\u0644\u0649 \u0627\u0644\u0623\u0642\u062F\u0645."
              },
              actor: {
                term: "\u0627\u0644\u0645\u0646\u0641\u0651\u0630",
                text: "\u0627\u0644\u0634\u062E\u0635 \u0627\u0644\u0630\u064A \u0646\u0641\u0651\u0630 \u0627\u0644\u0625\u062C\u0631\u0627\u0621. \u0648\u0644\u0644\u0625\u062C\u0631\u0627\u0621 \u0627\u0644\u062A\u0644\u0642\u0627\u0626\u064A \xAB\u0646\u0638\u0627\u0645 \u2066BatiFlow\u2069\xBB\u060C \u0648\u0644\u062A\u062F\u062E\u0644 \u0627\u0644\u062F\u0639\u0645 \xAB\u062F\u0639\u0645 \u2066BatiFlow\u2069\xBB."
              },
              action: {
                term: "\u0627\u0644\u0625\u062C\u0631\u0627\u0621",
                text: "\u062C\u0645\u0644\u0629 \u0628\u0633\u064A\u0637\u0629\u060C \u0645\u062B\u0644 \xAB\u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062F\u062E\u0648\u0644\xBB \u0623\u0648 \xAB\u0625\u0635\u062F\u0627\u0631 \u0641\u0627\u062A\u0648\u0631\u0629\xBB\u060C \u0648\u062A\u062D\u062A\u0647\u0627 \u0627\u0644\u0631\u0645\u0632 \u0627\u0644\u062A\u0642\u0646\u064A \u0644\u0644\u0625\u062C\u0631\u0627\u0621."
              },
              resource: {
                term: "\u0627\u0644\u0639\u0646\u0635\u0631 \u0627\u0644\u0645\u0639\u0646\u064A",
                text: "\u0645\u0627 \u0645\u0633\u0651\u0647 \u0627\u0644\u0625\u062C\u0631\u0627\u0621: \u0627\u0644\u0645\u0624\u0633\u0633\u0629 \u0623\u0648 \u0639\u0636\u0648 \u0623\u0648 \u062F\u0639\u0648\u0629 \u0623\u0648 \u0646\u0642\u0644 \u0627\u0644\u0645\u0644\u0643\u064A\u0629 \u0623\u0648 \u0627\u0644\u0645\u0644\u0641 \u0627\u0644\u062C\u0628\u0627\u0626\u064A \u0623\u0648 \u0633\u0644\u0633\u0644\u0629 \u0641\u0648\u0627\u062A\u064A\u0631 \u0623\u0648 \u0639\u0645\u064A\u0644... \u0645\u0639 \u0645\u0639\u0631\u0651\u0641 \u0642\u0635\u064A\u0631 \u062A\u062D\u062A\u0647."
              },
              loadMore: {
                term: "\u0639\u0631\u0636 \u0627\u0644\u0645\u0632\u064A\u062F \u0645\u0646 \u0627\u0644\u0623\u062D\u062F\u0627\u062B",
                text: "\u064A\u062D\u0645\u0651\u0644 \u0628\u0642\u064A\u0629 \u0627\u0644\u0633\u062C\u0644 \u0639\u0646\u062F\u0645\u0627 \u064A\u0643\u0648\u0646 \u0639\u062F\u062F \u0627\u0644\u0623\u062D\u062F\u0627\u062B \u0643\u0628\u064A\u0631\u064B\u0627."
              },
              empty: {
                term: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0623\u062D\u062F\u0627\u062B \u0628\u0639\u062F",
                text: "\u0631\u0633\u0627\u0644\u0629 \u0627\u0644\u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u0641\u0627\u0631\u063A\u0629: \u0633\u062A\u0638\u0647\u0631 \u0647\u0646\u0627 \u0627\u0644\u0625\u062C\u0631\u0627\u0621\u0627\u062A \u0627\u0644\u062D\u0633\u0627\u0633\u0629 \u0644\u0644\u0645\u0643\u062A\u0628 \u0641\u0648\u0631 \u062D\u062F\u0648\u062B\u0647\u0627. \u0648\u0645\u0639 \u062A\u0641\u0639\u064A\u0644 \u0639\u0648\u0627\u0645\u0644 \u0627\u0644\u062A\u0635\u0641\u064A\u0629 \u062A\u0635\u0628\u062D \xAB\u0644\u0627 \u064A\u0648\u062C\u062F \u062D\u062F\u062B \u0645\u0637\u0627\u0628\u0642\xBB (\u062C\u0631\u0651\u0628 \u0639\u0648\u0627\u0645\u0644 \u062A\u0635\u0641\u064A\u0629 \u0623\u062E\u0631\u0649 \u0623\u0648 \u0641\u062A\u0631\u0629 \u0623\u0648\u0633\u0639)."
              },
              loadFailed: {
                term: "\u062A\u0639\u0630\u0651\u0631 \u0639\u0631\u0636 \u0627\u0644\u0633\u062C\u0644",
                text: "\u0631\u0633\u0627\u0644\u0629 \u062E\u0637\u0623 \u0645\u0639 \u0632\u0631 \xAB\u0625\u0639\u0627\u062F\u0629 \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629\xBB \u0639\u0646\u062F\u0645\u0627 \u0644\u0627 \u064A\u064F\u062D\u0645\u064E\u0651\u0644 \u0627\u0644\u0633\u062C\u0644."
              }
            }
          }
        }
      },
      storage: {
        title: "\u0627\u0644\u062A\u062E\u0632\u064A\u0646",
        intro: "\u062A\u0639\u0631\u0636 \u0647\u0630\u0647 \u0627\u0644\u0635\u0641\u062D\u0629 \u0645\u0633\u0627\u062D\u0629 \u0627\u0644\u062A\u062E\u0632\u064A\u0646 \u0627\u0644\u062A\u064A \u062A\u0633\u062A\u0639\u0645\u0644\u0647\u0627 \u0645\u0644\u0641\u0627\u062A\u0643 \u0645\u0642\u0627\u0631\u0646\u0629\u064B \u0628\u0639\u0631\u0636\u0643\u060C \u0645\u0634\u0631\u0648\u0639\u064B\u0627 \u0628\u0645\u0634\u0631\u0648\u0639. \u0648\u0647\u064A \u0645\u062E\u0635\u0635\u0629 \u0644\u0645\u0646 \u064A\u0633\u062A\u0637\u064A\u0639 \u062A\u0639\u062F\u064A\u0644 \u0627\u0644\u0645\u0624\u0633\u0633\u0629.",
        sections: {
          header: {
            title: "\u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u0625\u062F\u0627\u0631\u0629 \u0648\u0627\u0644\u062A\u062D\u0645\u064A\u0644",
            items: {
              adminNav: {
                term: "\u0627\u0644\u0625\u062F\u0627\u0631\u0629",
                text: "\u062A\u062C\u0645\u0639 \u0627\u0644\u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u062C\u0627\u0646\u0628\u064A\u0629 \u0635\u0641\u062D\u0627\u062A \u0625\u062F\u0627\u0631\u0629 \u0645\u0624\u0633\u0633\u062A\u0643 (\u0635\u0641\u0651 \u0645\u0646 \u0627\u0644\u0631\u0648\u0627\u0628\u0637 \u0641\u0648\u0642 \u0627\u0644\u0635\u0641\u062D\u0629 \u0639\u0644\u0649 \u0627\u0644\u0634\u0627\u0634\u0627\u062A \u0627\u0644\u0635\u063A\u064A\u0631\u0629). \u0648\u0644\u0627 \u062A\u0639\u0631\u0636 \u0625\u0644\u0627 \u0627\u0644\u0635\u0641\u062D\u0627\u062A \u0627\u0644\u062A\u064A \u064A\u0633\u0645\u062D \u0644\u0643 \u062F\u0648\u0631\u0643 \u0628\u0641\u062A\u062D\u0647\u0627."
              },
              loadFailed: {
                term: "\u062A\u0639\u0630\u0651\u0631 \u062A\u062D\u0645\u064A\u0644 \u0627\u0633\u062A\u062E\u062F\u0627\u0645 \u0627\u0644\u062A\u062E\u0632\u064A\u0646",
                text: "\u0631\u0633\u0627\u0644\u0629 \u062E\u0637\u0623 \u062A\u0638\u0647\u0631 \u0639\u0646\u062F\u0645\u0627 \u0644\u0627 \u062A\u064F\u062D\u0645\u064E\u0651\u0644 \u0627\u0644\u0623\u0631\u0642\u0627\u0645: \u062A\u062D\u0642\u0642 \u0645\u0646 \u0627\u062A\u0635\u0627\u0644\u0643 \u062B\u0645 \u0627\u0636\u063A\u0637 \xAB\u0625\u0639\u0627\u062F\u0629 \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629\xBB."
              }
            }
          },
          usage: {
            title: "\u0627\u0644\u0645\u0633\u0627\u062D\u0629 \u0627\u0644\u0645\u0633\u062A\u062E\u062F\u0645\u0629",
            items: {
              summary: {
                term: "\u2026 \u0645\u0633\u062A\u062E\u062F\u0645\u0629 \u0645\u0646 \u0623\u0635\u0644 \u2026",
                text: "\u0627\u0644\u0623\u0631\u0642\u0627\u0645 \u0628\u0627\u0644\u0643\u0644\u0645\u0627\u062A: \u0627\u0644\u0645\u0633\u0627\u062D\u0629 \u0627\u0644\u062A\u064A \u062A\u0634\u063A\u0644\u0647\u0627 \u0643\u0644 \u0645\u0644\u0641\u0627\u062A \u0645\u0634\u0627\u0631\u064A\u0639\u0643 \u0628\u0645\u0627 \u0641\u064A\u0647\u0627 \u0627\u0644\u0646\u0633\u062E \u0627\u0644\u0633\u0627\u0628\u0642\u0629 \u0645\u0646 \u0623\u0635\u0644 \u0645\u0633\u0627\u062D\u0629 \u0639\u0631\u0636\u0643. \u0648\u0625\u0646 \u0644\u0645 \u064A\u0648\u062C\u062F \u062D\u062F\u0651 \u0641\u062A\u0642\u0648\u0644 \u0627\u0644\u062C\u0645\u0644\u0629 \xAB\u0644\u0627 \u064A\u062D\u062F\u062F \u0639\u0642\u062F\u0643 \u062D\u062F\u064B\u0627 \u0644\u0644\u0645\u0633\u0627\u062D\u0629\xBB."
              },
              bar: {
                term: "\u0645\u0633\u0627\u062D\u0629 \u0627\u0644\u062A\u062E\u0632\u064A\u0646 \u0627\u0644\u0645\u0633\u062A\u062E\u062F\u0645\u0629",
                text: "\u0634\u0631\u064A\u0637 \u062A\u0642\u062F\u0651\u0645 \u0645\u0639 \u0627\u0644\u0646\u0633\u0628\u0629 \u0627\u0644\u0645\u0643\u062A\u0648\u0628\u0629 \u0628\u062C\u0627\u0646\u0628\u0647 (\xAB\u062A\u0645 \u0627\u0633\u062A\u062E\u062F\u0627\u0645 \u2026 \u0645\u0646 \u0627\u0644\u0645\u0633\u0627\u062D\u0629\xBB). \u064A\u062A\u063A\u064A\u0631 \u0644\u0648\u0646\u0647 \u0645\u0639 \u0627\u0644\u0645\u0633\u062A\u0648\u0649\u060C \u0644\u0643\u0646 \u0627\u0644\u0646\u0633\u0628\u0629 \u0645\u0643\u062A\u0648\u0628\u0629 \u062F\u0627\u0626\u0645\u064B\u0627."
              },
              notes: {
                term: "\u062A\u0646\u0628\u064A\u0647\u0627\u062A",
                text: "\u0639\u0646\u062F \u062A\u062C\u0627\u0648\u0632 80% \u062A\u0646\u0635\u062D\u0643 \u0631\u0633\u0627\u0644\u0629 \u0628\u062D\u0630\u0641 \u0645\u0644\u0641\u0627\u062A \u0623\u0648 \u0634\u0631\u0627\u0621 \u0645\u0633\u0627\u062D\u0629 \u062A\u062E\u0632\u064A\u0646. \u0648\u0639\u0646\u062F\u0645\u0627 \u064A\u0628\u0642\u0649 \u0623\u0642\u0644 \u0645\u0646 5% \u0645\u0646 \u0627\u0644\u0645\u0633\u0627\u062D\u0629 \u062A\u0635\u0628\u062D \u0623\u0643\u062B\u0631 \u0625\u0644\u062D\u0627\u062D\u064B\u0627. \u0648\u0639\u0646\u062F\u0645\u0627 \u062A\u0645\u062A\u0644\u0626 \u0627\u0644\u0645\u0633\u0627\u062D\u0629 \u062A\u064F\u0631\u0641\u0636 \u0627\u0644\u0645\u0644\u0641\u0627\u062A \u0627\u0644\u062C\u062F\u064A\u062F\u0629."
              },
              buy: {
                term: "\u0634\u0631\u0627\u0621 \u0645\u0633\u0627\u062D\u0629 \u062A\u062E\u0632\u064A\u0646",
                text: "\u0632\u0631 \u0645\u0639\u062A\u0651\u0645 \u062D\u0627\u0644\u064A\u064B\u0627: \u0633\u064A\u062A\u0648\u0641\u0631 \u0634\u0631\u0627\u0621 \u0645\u0633\u0627\u062D\u0629 \u0627\u0644\u062A\u062E\u0632\u064A\u0646 \u0645\u0639 \u0627\u0644\u0641\u0648\u062A\u0631\u0629\u060C \u0648\u0647\u064A \u0642\u0627\u062F\u0645\u0629 \u0644\u0627\u062D\u0642\u064B\u0627."
              }
            }
          },
          spaces: {
            title: "\u0627\u0644\u062A\u062E\u0632\u064A\u0646 \u062D\u0633\u0628 \u0627\u0644\u0645\u0634\u0631\u0648\u0639",
            items: {
              name: {
                term: "\u0627\u0644\u0645\u0634\u0631\u0648\u0639 \u0623\u0648 \u0627\u0644\u0645\u0633\u0627\u062D\u0629",
                text: "\u0627\u0633\u0645 \u0627\u0644\u0645\u0634\u0631\u0648\u0639 (\u0623\u0648 \u0627\u0644\u0645\u0633\u0627\u062D\u0629) \u0627\u0644\u0630\u064A \u064A\u062D\u062A\u0648\u064A \u0639\u0644\u0649 \u0645\u0644\u0641\u0627\u062A."
              },
              size: {
                term: "\u0627\u0644\u062D\u062C\u0645",
                text: "\u062D\u062C\u0645 \u0643\u0644 \u0645\u0644\u0641\u0627\u062A \u0647\u0630\u0627 \u0627\u0644\u0645\u0634\u0631\u0648\u0639."
              },
              reconciledAt: {
                term: "\u0622\u062E\u0631 \u0627\u062D\u062A\u0633\u0627\u0628",
                text: "\u0622\u062E\u0631 \u0645\u0631\u0629 \u0623\u064F\u0639\u064A\u062F \u0641\u064A\u0647\u0627 \u0627\u062D\u062A\u0633\u0627\u0628 \u0647\u0630\u0627 \u0627\u0644\u062D\u062C\u0645. \u0648\u062A\u0638\u0647\u0631 \xAB\u0644\u0645 \u064A\u064F\u062D\u062A\u0633\u0628 \u0628\u0639\u062F\xBB \u0644\u0645\u0634\u0631\u0648\u0639 \u062C\u062F\u064A\u062F."
              },
              empty: {
                term: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0645\u0644\u0641\u0627\u062A \u0628\u0639\u062F",
                text: "\u0631\u0633\u0627\u0644\u0629 \u0627\u0644\u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u0641\u0627\u0631\u063A\u0629: \u0633\u064A\u0638\u0647\u0631 \u062D\u062C\u0645 \u0643\u0644 \u0645\u0634\u0631\u0648\u0639 \u0647\u0646\u0627 \u0628\u0645\u062C\u0631\u062F \u0623\u0646 \u064A\u062D\u062A\u0648\u064A \u0639\u0644\u0649 \u0645\u0644\u0641\u0627\u062A."
              }
            }
          },
          files: {
            title: "\u0623\u0643\u0628\u0631 10 \u0645\u0644\u0641\u0627\u062A",
            items: {
              code: {
                term: "\u0627\u0644\u0631\u0645\u0632",
                text: "\u0631\u0645\u0632 \u0627\u0644\u0648\u062B\u064A\u0642\u0629. \u0648\u062A\u0638\u0647\u0631 \xAB\u0628\u062F\u0648\u0646 \u0631\u0645\u0632\xBB \u0644\u0645\u0644\u0641 \u0644\u064A\u0633 \u0644\u0647 \u0631\u0645\u0632."
              },
              title: {
                term: "\u0627\u0644\u0639\u0646\u0648\u0627\u0646",
                text: "\u0639\u0646\u0648\u0627\u0646 \u0627\u0644\u0645\u0644\u0641. \u0648\u062D\u064A\u0646 \u064A\u0643\u0648\u0646 \u0641\u064A \u0645\u0634\u0631\u0648\u0639 \u0641\u0647\u0648 \u0631\u0627\u0628\u0637 \u064A\u0641\u062A\u062D\u0647 \u062F\u0627\u062E\u0644 \u0627\u0644\u0645\u0634\u0631\u0648\u0639."
              },
              size: {
                term: "\u0627\u0644\u062D\u062C\u0645",
                text: "\u0627\u0644\u0645\u0633\u0627\u062D\u0629 \u0627\u0644\u062A\u064A \u064A\u0634\u063A\u0644\u0647\u0627 \u0627\u0644\u0645\u0644\u0641. \u062D\u0630\u0641 \u0645\u0644\u0641 \u063A\u064A\u0631 \u0636\u0631\u0648\u0631\u064A \u0623\u0648 \u0627\u0633\u062A\u0628\u062F\u0627\u0644\u0647 \u064A\u0641\u0631\u0651\u063A \u0645\u0633\u0627\u062D\u0629."
              },
              empty: {
                term: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0645\u0644\u0641\u0627\u062A \u0628\u0639\u062F",
                text: "\u0631\u0633\u0627\u0644\u0629 \u0627\u0644\u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u0641\u0627\u0631\u063A\u0629: \u0633\u062A\u0638\u0647\u0631 \u0647\u0646\u0627 \u0623\u0643\u0628\u0631 \u0627\u0644\u0645\u0644\u0641\u0627\u062A \u062D\u062C\u0645\u064B\u0627."
              }
            }
          }
        }
      },
      data: {
        title: "\u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A \u0648\u0627\u0644\u062D\u0630\u0641",
        intro: "\u062A\u0641\u064A\u062F \u0647\u0630\u0647 \u0627\u0644\u0635\u0641\u062D\u0629 \u0641\u064A \u0627\u0644\u062D\u0635\u0648\u0644 \u0639\u0644\u0649 \u0646\u0633\u062E\u0629 \u0645\u0646 \u0628\u064A\u0627\u0646\u0627\u062A \u0645\u0643\u062A\u0628\u0643 (\u062A\u0635\u062F\u064A\u0631) \u0648\u0641\u064A \u0637\u0644\u0628 \u062D\u0630\u0641 \u0627\u0644\u0645\u0624\u0633\u0633\u0629 \u0623\u0648 \u0625\u0644\u063A\u0627\u0626\u0647 \u0628\u0627\u0644\u0646\u0633\u0628\u0629 \u0625\u0644\u0649 \u0627\u0644\u0645\u0627\u0644\u0643.",
        sections: {
          header: {
            title: "\u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u0625\u062F\u0627\u0631\u0629 \u0648\u0627\u0644\u0648\u0635\u0648\u0644",
            items: {
              adminNav: {
                term: "\u0627\u0644\u0625\u062F\u0627\u0631\u0629",
                text: "\u062A\u062C\u0645\u0639 \u0627\u0644\u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u062C\u0627\u0646\u0628\u064A\u0629 \u0635\u0641\u062D\u0627\u062A \u0625\u062F\u0627\u0631\u0629 \u0645\u0624\u0633\u0633\u062A\u0643 (\u0635\u0641\u0651 \u0645\u0646 \u0627\u0644\u0631\u0648\u0627\u0628\u0637 \u0641\u0648\u0642 \u0627\u0644\u0635\u0641\u062D\u0629 \u0639\u0644\u0649 \u0627\u0644\u0634\u0627\u0634\u0627\u062A \u0627\u0644\u0635\u063A\u064A\u0631\u0629). \u0648\u0644\u0627 \u062A\u0639\u0631\u0636 \u0625\u0644\u0627 \u0627\u0644\u0635\u0641\u062D\u0627\u062A \u0627\u0644\u062A\u064A \u064A\u0633\u0645\u062D \u0644\u0643 \u062F\u0648\u0631\u0643 \u0628\u0641\u062A\u062D\u0647\u0627."
              },
              blocks: {
                term: "\u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A \u0648\u0627\u0644\u062D\u0630\u0641",
                text: "\u0644\u0627 \u064A\u0638\u0647\u0631 \u0643\u0644 \u0642\u0633\u0645 \u0625\u0644\u0627 \u0625\u0630\u0627 \u0643\u0627\u0646 \u062F\u0648\u0631\u0643 \u064A\u0633\u0645\u062D \u0628\u0647: \u0627\u0644\u0646\u0633\u062E\u0629 \u0627\u0644\u0643\u0627\u0645\u0644\u0629 (\u0627\u0644\u0645\u0627\u0644\u0643 \u0648\u0627\u0644\u0645\u0634\u0631\u0641\u0648\u0646) \u0648\u0627\u0644\u0646\u0633\u062E\u0629 \u0627\u0644\u0645\u0627\u0644\u064A\u0629 (\u0627\u0644\u0645\u062D\u0627\u0633\u0628) \u0648\u0627\u0644\u062D\u0630\u0641 (\u0627\u0644\u0645\u0627\u0644\u0643 \u0641\u0642\u0637)."
              }
            }
          },
          export: {
            title: "\u062A\u0635\u062F\u064A\u0631 \u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A",
            items: {
              button: {
                term: "\u062A\u062D\u0636\u064A\u0631 \u0646\u0633\u062E\u0629 \u0643\u0627\u0645\u0644\u0629",
                text: "\u064A\u0628\u062F\u0623 \u062A\u062D\u0636\u064A\u0631 \u0646\u0633\u062E\u0629. \u0648\u0628\u0627\u0644\u0646\u0633\u0628\u0629 \u0625\u0644\u0649 \u0627\u0644\u0645\u062D\u0627\u0633\u0628 \u064A\u0633\u0645\u0649 \u0627\u0644\u0632\u0631 \xAB\u062A\u062D\u0636\u064A\u0631 \u0646\u0633\u062E\u0629 \u0645\u0627\u0644\u064A\u0629\xBB \u0648\u0644\u0627 \u064A\u0634\u0645\u0644 \u0625\u0644\u0627 \u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A \u0627\u0644\u0645\u0627\u0644\u064A\u0629. \u0648\u0642\u062F \u064A\u064F\u0637\u0644\u0628 \u062A\u0623\u0643\u064A\u062F \u0627\u0644\u0647\u0648\u064A\u0629 \u062B\u0645 \u062A\u0642\u0648\u0644 \u0631\u0633\u0627\u0644\u0629 \u0625\u0646 \u0627\u0644\u0646\u0633\u062E\u0629 \u0642\u064A\u062F \u0627\u0644\u0625\u0639\u062F\u0627\u062F."
              },
              contents: {
                term: "\u0645\u062D\u062A\u0648\u0649 \u0627\u0644\u0646\u0633\u062E\u0629",
                text: "\u062A\u062C\u0645\u0639 \u0627\u0644\u0646\u0633\u062E\u0629 \u0627\u0644\u0643\u0627\u0645\u0644\u0629 \u0643\u0644 \u0628\u064A\u0627\u0646\u0627\u062A \u0627\u0644\u0645\u0624\u0633\u0633\u0629 \u0641\u064A \u0645\u0644\u0641 \u0648\u0627\u062D\u062F: \u0643\u0644 \u062C\u062F\u0627\u0648\u0644 \u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A \u0628\u0635\u064A\u063A\u0629 \u2066JSON\u2069 \u0648\u0627\u0644\u0648\u062B\u0627\u0626\u0642 \u0645\u0631\u062A\u0628\u0629 \u0641\u064A \u0645\u062C\u0644\u062F\u0627\u062A\u0647\u0627 \u0648\u0645\u0644\u0641\u0627\u062A \u2066PDF\u2069 \u0627\u0644\u062A\u064A \u064A\u0646\u0634\u0626\u0647\u0627 \u2066BatiFlow\u2069. \u0623\u0645\u0627 \u0627\u0644\u0646\u0633\u062E\u0629 \u0627\u0644\u0645\u0627\u0644\u064A\u0629 \u0641\u0644\u0627 \u062A\u062D\u062A\u0648\u064A \u0625\u0644\u0627 \u0639\u0644\u0649 \u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A \u0627\u0644\u0645\u0627\u0644\u064A\u0629."
              },
              retention: {
                term: "\u0627\u0644\u0627\u062D\u062A\u0641\u0627\u0638 \u0648\u0627\u0644\u0625\u0634\u0639\u0627\u0631",
                text: "\u064A\u064F\u062D\u0641\u0638 \u0645\u0644\u0641 \u2066ZIP\u2069 \u0644\u0645\u062F\u0629 7 \u0623\u064A\u0627\u0645 \u062B\u0645 \u064A\u064F\u062D\u0630\u0641. \u0648\u064A\u062A\u0644\u0642\u0649 \u0645\u0646 \u0637\u0644\u0628 \u0627\u0644\u0646\u0633\u062E\u0629 \u0625\u0634\u0639\u0627\u0631\u064B\u0627 \u0628\u0645\u062C\u0631\u062F \u0623\u0646 \u062A\u0635\u0628\u062D \u062C\u0627\u0647\u0632\u0629."
              }
            }
          },
          exports: {
            title: "\u0646\u0633\u062E \u0628\u064A\u0627\u0646\u0627\u062A \u0627\u0644\u0645\u0624\u0633\u0633\u0629",
            items: {
              requestedAt: {
                term: "\u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0637\u0644\u0628",
                text: "\u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0637\u0644\u0628 \u0648\u0648\u0642\u062A\u0647."
              },
              scope: {
                term: "\u0627\u0644\u0646\u0648\u0639",
                text: "\xAB\u0643\u0627\u0645\u0644\xBB \u0623\u0648 \xAB\u0645\u0627\u0644\u064A\xBB."
              },
              requestedBy: {
                term: "\u0637\u0644\u0628\u0647",
                text: "\u0627\u0644\u0639\u0636\u0648 \u0627\u0644\u0630\u064A \u0637\u0644\u0628 \u0627\u0644\u0646\u0633\u062E\u0629."
              },
              status: {
                term: "\u0627\u0644\u062D\u0627\u0644\u0629",
                text: "\u0641\u064A \u0627\u0644\u0627\u0646\u062A\u0638\u0627\u0631 \u0623\u0648 \u0642\u064A\u062F \u0627\u0644\u0625\u0639\u062F\u0627\u062F \u0623\u0648 \u062C\u0627\u0647\u0632 \u0623\u0648 \u0641\u0634\u0644 \u0623\u0648 \u0645\u0646\u062A\u0647\u064A \u0627\u0644\u0635\u0644\u0627\u062D\u064A\u0629. \u0648\u062A\u064F\u0643\u062A\u0628 \u0627\u0644\u062D\u0627\u0644\u0629 \u062F\u0627\u0626\u0645\u064B\u0627 \u0628\u0627\u0644\u0643\u0644\u0645\u0627\u062A. \u0648\u062A\u062A\u062D\u062F\u062B \u0627\u0644\u0642\u0627\u0626\u0645\u0629 \u062A\u0644\u0642\u0627\u0626\u064A\u064B\u0627 \u0623\u062B\u0646\u0627\u0621 \u0627\u0644\u0625\u0639\u062F\u0627\u062F."
              },
              size: {
                term: "\u0627\u0644\u062D\u062C\u0645",
                text: "\u062D\u062C\u0645 \u0627\u0644\u0645\u0644\u0641 \u0639\u0646\u062F\u0645\u0627 \u064A\u0635\u0628\u062D \u062C\u0627\u0647\u0632\u064B\u0627. \u0648\u062A\u0638\u0647\u0631 \u0634\u0631\u0637\u0629 \u0645\u0627 \u062F\u0627\u0645 \u063A\u064A\u0631 \u0645\u0639\u0631\u0648\u0641."
              },
              expiresAt: {
                term: "\u0645\u062A\u0627\u062D \u062D\u062A\u0649",
                text: "\u0622\u062E\u0631 \u064A\u0648\u0645 \u0644\u062A\u0646\u0632\u064A\u0644 \u0627\u0644\u0646\u0633\u062E\u0629."
              },
              download: {
                term: "\u062A\u0646\u0632\u064A\u0644",
                text: "\u064A\u0646\u0632\u0651\u0644 \u0645\u0644\u0641 \u2066ZIP\u2069. \u0648\u0644\u0627 \u064A\u0638\u0647\u0631 \u0627\u0644\u0632\u0631 \u0625\u0644\u0627 \u0639\u0644\u0649 \u0646\u0633\u062E\u0629 \xAB\u062C\u0627\u0647\u0632\xBB."
              },
              empty: {
                term: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0646\u0633\u062E \u0628\u0639\u062F",
                text: "\u0631\u0633\u0627\u0644\u0629 \u0627\u0644\u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u0641\u0627\u0631\u063A\u0629: \u062D\u0636\u0651\u0631 \u0646\u0633\u062E\u0629 \u0644\u062A\u062D\u0635\u0644 \u0639\u0644\u0649 \u0646\u0633\u062E\u0629 \u0645\u0646 \u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A. \u0648\u0625\u0646 \u0644\u0645 \u062A\u064F\u062D\u0645\u064E\u0651\u0644 \u0627\u0644\u0642\u0627\u0626\u0645\u0629 \u062A\u0638\u0647\u0631 \xAB\u062A\u0639\u0630\u0651\u0631 \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0646\u0633\u062E\xBB \u0645\u0639 \u0632\u0631 \xAB\u0625\u0639\u0627\u062F\u0629 \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629\xBB."
              }
            }
          },
          delete: {
            title: "\u062D\u0630\u0641 \u0627\u0644\u0645\u0624\u0633\u0633\u0629",
            items: {
              points: {
                term: "\u0647\u0630\u0627 \u0627\u0644\u0625\u062C\u0631\u0627\u0621 \u0646\u0647\u0627\u0626\u064A",
                text: "\u0623\u0631\u0628\u0639\u0629 \u062A\u0630\u0643\u064A\u0631\u0627\u062A \u0642\u0628\u0644 \u0627\u0644\u0645\u062A\u0627\u0628\u0639\u0629: \u064A\u062A\u0645 \u0627\u0644\u062D\u0630\u0641 \u0628\u0639\u062F 90 \u064A\u0648\u0645\u064B\u0627 \u0645\u0646 \u0627\u0644\u0637\u0644\u0628 \u0648\u064A\u0645\u0643\u0646 \u0625\u0644\u063A\u0627\u0624\u0647 \u062D\u062A\u0649 \u0630\u0644\u0643 \u0627\u0644\u062A\u0627\u0631\u064A\u062E\u061B \u0648\u0644\u0627 \u064A\u0645\u0643\u0646 \u0627\u0644\u062A\u0631\u0627\u062C\u0639 \u0639\u0646\u0647 (\u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A \u0648\u0627\u0644\u0645\u0644\u0641\u0627\u062A \u0648\u062D\u0633\u0627\u0628\u0627\u062A \u0627\u0644\u0623\u0634\u062E\u0627\u0635 \u0627\u0644\u0630\u064A\u0646 \u0644\u0627 \u064A\u0646\u062A\u0645\u0648\u0646 \u0625\u0644\u0649 \u0645\u0624\u0633\u0633\u0629 \u0623\u062E\u0631\u0649)\u061B \u0648\u064A\u064F\u062D\u062A\u0641\u0638 \u0628\u0627\u0633\u0645 \u0627\u0644\u0645\u0624\u0633\u0633\u0629 \u0648\u0645\u0639\u0631\u0651\u0641\u0647\u0627 \u0627\u0644\u062C\u0628\u0627\u0626\u064A \u0648\u0633\u062C\u0644 \u0627\u0644\u062A\u062F\u0642\u064A\u0642 (3 \u0633\u0646\u0648\u0627\u062A)\u061B \u0648\u062D\u0636\u0651\u0631 \u0646\u0633\u062E\u0629 \u0643\u0627\u0645\u0644\u0629 \u0623\u0648\u0644\u064B\u0627."
              },
              button: {
                term: "\u062D\u0630\u0641 \u0627\u0644\u0645\u0624\u0633\u0633\u0629",
                text: "\u0632\u0631 \u062E\u0627\u0635 \u0628\u0627\u0644\u0645\u0627\u0644\u0643\u061B \u064A\u0641\u062A\u062D \u0646\u0627\u0641\u0630\u0629 \u0627\u0644\u0637\u0644\u0628. \u0648\u0644\u0627 \u064A\u0638\u0647\u0631 \u0625\u0644\u0627 \u0639\u0646\u062F\u0645\u0627 \u0644\u0627 \u064A\u0643\u0648\u0646 \u0647\u0646\u0627\u0643 \u062D\u0630\u0641 \u0645\u0628\u0631\u0645\u062C."
              },
              scheduled: {
                term: "\u0627\u0644\u062D\u0630\u0641 \u0645\u0628\u0631\u0645\u062C \u0628\u062A\u0627\u0631\u064A\u062E \u2026",
                text: "\u0639\u0646\u062F\u0645\u0627 \u064A\u0643\u0648\u0646 \u0647\u0646\u0627\u0643 \u062D\u0630\u0641 \u0645\u0628\u0631\u0645\u062C \u064A\u0639\u0631\u0636 \u0634\u0631\u064A\u0637 \u0627\u0644\u062A\u0627\u0631\u064A\u062E \u0648\u0627\u0644\u0634\u062E\u0635 \u0627\u0644\u0630\u064A \u0637\u0644\u0628\u0647 \u0648\u0627\u0644\u0633\u0628\u0628: \u0637\u0644\u0628 \u0627\u0644\u0645\u0627\u0644\u0643 \u0623\u0648 \u0627\u0634\u062A\u0631\u0627\u0643 \u063A\u064A\u0631 \u0645\u0633\u062F\u064E\u0651\u062F \u0623\u0648 \u0641\u062A\u0631\u0629 \u062A\u062C\u0631\u064A\u0628\u064A\u0629 \u0627\u0646\u062A\u0647\u062A \u062F\u0648\u0646 \u0627\u0634\u062A\u0631\u0627\u0643 \u0623\u0648 \u0627\u0634\u062A\u0631\u0627\u0643 \u0623\u064F\u0644\u063A\u064A."
              },
              cancel: {
                term: "\u0625\u0644\u063A\u0627\u0621 \u0627\u0644\u062D\u0630\u0641",
                text: "\u0628\u0627\u0644\u0646\u0633\u0628\u0629 \u0625\u0644\u0649 \u062D\u0630\u0641 \u0637\u0644\u0628\u0647 \u0627\u0644\u0645\u0627\u0644\u0643: \u064A\u0639\u0631\u0636 \u062A\u0623\u0643\u064A\u062F \xAB\u0647\u0644 \u062A\u0631\u064A\u062F \u0625\u0644\u063A\u0627\u0621 \u062D\u0630\u0641 \u0627\u0644\u0645\u0624\u0633\u0633\u0629\u061F\xBB \u0627\u0644\u062E\u064A\u0627\u0631\u064A\u0646 \xAB\u0646\u0639\u0645\u060C \u0623\u0644\u063A\u0650 \u0627\u0644\u062D\u0630\u0641\xBB \u0623\u0648 \xAB\u0644\u0627\u060C \u0623\u0628\u0642\u0650 \u0627\u0644\u062D\u0630\u0641 \u0645\u0628\u0631\u0645\u062C\u064B\u0627\xBB. \u0648\u062A\u0628\u0642\u0649 \u0627\u0644\u0645\u0624\u0633\u0633\u0629 \u0639\u0646\u062F\u0626\u0630\u064D \u0643\u0645\u0627 \u0647\u064A \u0627\u0644\u064A\u0648\u0645."
              },
              payToStop: {
                term: "\u0627\u0644\u0627\u0646\u062A\u0642\u0627\u0644 \u0625\u0644\u0649 \u0627\u0644\u0627\u0634\u062A\u0631\u0627\u0643",
                text: "\u0628\u0627\u0644\u0646\u0633\u0628\u0629 \u0625\u0644\u0649 \u062D\u0630\u0641 \u0633\u0628\u0628\u0647 \u0627\u0644\u0627\u0634\u062A\u0631\u0627\u0643: \u0633\u062F\u0627\u062F \u0627\u0644\u0627\u0634\u062A\u0631\u0627\u0643 \u064A\u0648\u0642\u0641 \u0627\u0644\u062D\u0630\u0641\u060C \u0648\u064A\u0642\u0648\u062F \u0647\u0630\u0627 \u0627\u0644\u0631\u0627\u0628\u0637 \u0625\u0644\u0649 \u0635\u0641\u062D\u0629 \u0627\u0644\u0627\u0634\u062A\u0631\u0627\u0643."
              },
              running: {
                term: "\u0627\u0644\u062D\u0630\u0641 \u062C\u0627\u0631\u064D",
                text: "\u062A\u062C\u0631\u064A \u0627\u0644\u0622\u0646 \u0625\u0632\u0627\u0644\u0629 \u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A. \u0648\u0644\u0645 \u064A\u0639\u062F \u0628\u0627\u0644\u0625\u0645\u0643\u0627\u0646 \u0625\u064A\u0642\u0627\u0641 \u0627\u0644\u0639\u0645\u0644\u064A\u0629."
              }
            }
          },
          deleteDialog: {
            title: "\u0646\u0627\u0641\u0630\u0629 \u0637\u0644\u0628 \u0627\u0644\u062D\u0630\u0641",
            items: {
              exportState: {
                term: "\u062A\u062A\u0648\u0641\u0631 \u0646\u0633\u062E\u0629 \u0643\u0627\u0645\u0644\u0629 \u0639\u0645\u0631\u0647\u0627 \u0623\u0642\u0644 \u0645\u0646 30 \u064A\u0648\u0645\u064B\u0627",
                text: "\u062A\u0642\u0648\u0644 \u0631\u0633\u0627\u0644\u0629 \u0625\u0646 \u0643\u0627\u0646\u062A \u062A\u0648\u062C\u062F \u0646\u0633\u062E\u0629 \u0643\u0627\u0645\u0644\u0629 \u0639\u0645\u0631\u0647\u0627 \u0623\u0642\u0644 \u0645\u0646 30 \u064A\u0648\u0645\u064B\u0627 (\u062A\u0630\u0643\u0651\u0631 \u062A\u0646\u0632\u064A\u0644\u0647\u0627 \u0642\u0628\u0644 \u0627\u0644\u062D\u0630\u0641) \u0623\u0648 \u0644\u0627 \u062A\u0648\u062C\u062F \u0623\u064A \u0646\u0633\u062E\u0629 (\u062D\u0636\u0651\u0631 \u0646\u0633\u062E\u0629 \u0641\u064A \xAB\u062A\u0635\u062F\u064A\u0631 \u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A\xBB)."
              },
              decline: {
                term: "\u0644\u0627 \u0623\u0631\u063A\u0628 \u0641\u064A \u0646\u0633\u062E\u0629 \u0645\u0646 \u0628\u064A\u0627\u0646\u0627\u062A\u064A",
                text: "\u062E\u0627\u0646\u0629 \u062A\u062D\u062F\u064A\u062F \u062A\u064F\u0639\u0631\u0636 \u0641\u0642\u0637 \u0639\u0646\u062F\u0645\u0627 \u0644\u0627 \u062A\u0648\u062C\u062F \u0646\u0633\u062E\u0629 \u062D\u062F\u064A\u062B\u0629. \u062D\u062F\u0651\u062F\u0647\u0627 \u0644\u0644\u0645\u062A\u0627\u0628\u0639\u0629 \u062F\u0648\u0646 \u0646\u0633\u062E\u0629\u060C \u0648\u0625\u0644\u0627 \u062A\u0637\u0644\u0628 \u0645\u0646\u0643 \u0631\u0633\u0627\u0644\u0629 \u062A\u062D\u0636\u064A\u0631 \u0646\u0633\u062E\u0629."
              },
              confirmName: {
                term: "\u0627\u0643\u062A\u0628 \u0627\u0644\u0627\u0633\u0645 \u0627\u0644\u0642\u0627\u0646\u0648\u0646\u064A \u0644\u0644\u0645\u0624\u0633\u0633\u0629 \u0644\u0644\u062A\u0623\u0643\u064A\u062F",
                text: "\u0625\u0644\u0632\u0627\u0645\u064A. \u0627\u0646\u0633\u062E \u0627\u0644\u0627\u0633\u0645 \u0627\u0644\u0642\u0627\u0646\u0648\u0646\u064A \u0644\u0644\u0645\u0624\u0633\u0633\u0629 \u062A\u0645\u0627\u0645\u064B\u0627 \u0643\u0645\u0627 \u0647\u0648 \u0645\u0643\u062A\u0648\u0628 \u062A\u062D\u062A \u0627\u0644\u062D\u0642\u0644. \u0648\u0625\u0646 \u0627\u062E\u062A\u0644\u0641 \u0627\u0644\u0646\u0635 \u0641\u062A\u0646\u0628\u0651\u0647 \u0631\u0633\u0627\u0644\u0629 \u0625\u0644\u0649 \u0630\u0644\u0643."
              },
              submit: {
                term: "\u0628\u0631\u0645\u062C\u0629 \u0627\u0644\u062D\u0630\u0641",
                text: "\u064A\u0631\u0633\u0644 \u0627\u0644\u0637\u0644\u0628 \u0628\u0639\u062F \u062A\u0623\u0643\u064A\u062F \u0627\u0644\u0647\u0648\u064A\u0629. \u0633\u064A\u062A\u0645 \u0627\u0644\u062D\u0630\u0641 \u0628\u0639\u062F 90 \u064A\u0648\u0645\u064B\u0627\u060C \u0648\u064A\u0645\u0643\u0646\u0643 \u0625\u0644\u063A\u0627\u0624\u0647 \u062D\u062A\u0649 \u0630\u0644\u0643 \u0627\u0644\u062D\u064A\u0646."
              }
            }
          }
        }
      },
      subscription: {
        title: "\u0627\u0644\u0627\u0634\u062A\u0631\u0627\u0643",
        intro: "\u062A\u0639\u0631\u0636 \u0647\u0630\u0647 \u0627\u0644\u0635\u0641\u062D\u0629 \u0627\u0634\u062A\u0631\u0627\u0643 \u0645\u0643\u062A\u0628\u0643 \u0641\u064A \u2066BatiFlow\u2069: \u0627\u0644\u0628\u0627\u0642\u0629 \u0648\u0645\u0627 \u062A\u0633\u062A\u0639\u0645\u0644\u0647 \u0648\u0645\u0642\u0627\u0631\u0646\u0629 \u0627\u0644\u0628\u0627\u0642\u0627\u062A \u0648\u0627\u0644\u0641\u0648\u0627\u062A\u064A\u0631. \u064A\u0631\u0649 \u0641\u0631\u064A\u0642 \u0627\u0644\u0641\u0648\u062A\u0631\u0629 \u0643\u0644 \u0634\u064A\u0621\u060C \u0648\u0644\u0627 \u064A\u0633\u062A\u0637\u064A\u0639 \u062A\u0639\u062F\u064A\u0644 \u0627\u0644\u0627\u0634\u062A\u0631\u0627\u0643 \u0623\u0648 \u0627\u0644\u0633\u062F\u0627\u062F \u0625\u0644\u0627 \u0627\u0644\u0645\u0627\u0644\u0643.",
        sections: {
          header: {
            title: "\u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u0625\u062F\u0627\u0631\u0629 \u0648\u0631\u0623\u0633 \u0627\u0644\u0635\u0641\u062D\u0629",
            items: {
              adminNav: {
                term: "\u0627\u0644\u0625\u062F\u0627\u0631\u0629",
                text: "\u062A\u062C\u0645\u0639 \u0627\u0644\u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u062C\u0627\u0646\u0628\u064A\u0629 \u0635\u0641\u062D\u0627\u062A \u0625\u062F\u0627\u0631\u0629 \u0645\u0624\u0633\u0633\u062A\u0643 (\u0635\u0641\u0651 \u0645\u0646 \u0627\u0644\u0631\u0648\u0627\u0628\u0637 \u0641\u0648\u0642 \u0627\u0644\u0635\u0641\u062D\u0629 \u0639\u0644\u0649 \u0627\u0644\u0634\u0627\u0634\u0627\u062A \u0627\u0644\u0635\u063A\u064A\u0631\u0629). \u0648\u0644\u0627 \u062A\u0639\u0631\u0636 \u0625\u0644\u0627 \u0627\u0644\u0635\u0641\u062D\u0627\u062A \u0627\u0644\u062A\u064A \u064A\u0633\u0645\u062D \u0644\u0643 \u062F\u0648\u0631\u0643 \u0628\u0641\u062A\u062D\u0647\u0627."
              },
              change: {
                term: "\u062A\u0639\u062F\u064A\u0644 \u0627\u0644\u0627\u0634\u062A\u0631\u0627\u0643",
                text: "\u0632\u0631 \u062E\u0627\u0635 \u0628\u0627\u0644\u0645\u0627\u0644\u0643 \u0641\u064A \u0623\u0639\u0644\u0649 \u0627\u0644\u0635\u0641\u062D\u0629: \u064A\u0641\u062A\u062D \u0646\u0627\u0641\u0630\u0629 \u062A\u063A\u064A\u064A\u0631 \u0627\u0644\u0628\u0627\u0642\u0629. \u0648\u0644\u0627 \u064A\u0638\u0647\u0631 \u0645\u0639 \u0628\u0627\u0642\u0629 \u2066Enterprise\u2069."
              },
              readOnlyNote: {
                term: "\u0623\u0646\u062A \u062A\u0637\u0651\u0644\u0639 \u0639\u0644\u0649 \u0627\u0644\u0627\u0634\u062A\u0631\u0627\u0643 \u0644\u0644\u0642\u0631\u0627\u0621\u0629 \u0641\u0642\u0637",
                text: "\u0631\u0633\u0627\u0644\u0629 \u0645\u0639\u0644\u0648\u0645\u0627\u062A \u0644\u0644\u0623\u0639\u0636\u0627\u0621 \u063A\u064A\u0631 \u0627\u0644\u0645\u0627\u0644\u0643\u064A\u0646: \u064A\u0631\u0648\u0646 \u0643\u0644 \u0634\u064A\u0621 \u0644\u0643\u0646\u0647\u0645 \u0644\u0627 \u064A\u0633\u062A\u0637\u064A\u0639\u0648\u0646 \u0627\u0644\u062A\u0639\u062F\u064A\u0644 \u0648\u0644\u0627 \u0627\u0644\u0633\u062F\u0627\u062F."
              },
              enterpriseNote: {
                term: "\u0628\u0627\u0642\u0629 \u2066Enterprise\u2069 \u0627\u0644\u062E\u0627\u0635\u0629 \u0628\u0643 \u062A\u064F\u062F\u0627\u0631 \u0628\u0639\u0642\u062F",
                text: "\u0631\u0633\u0627\u0644\u0629 \u0644\u0645\u0627\u0644\u0643 \u0628\u0627\u0642\u0629 \u2066Enterprise\u2069: \u0644\u062A\u0639\u062F\u064A\u0644\u0647\u0627 \u062A\u0648\u0627\u0635\u0644 \u0645\u0639 \u0627\u0644\u0641\u0631\u064A\u0642 \u0627\u0644\u062A\u062C\u0627\u0631\u064A \u0641\u064A \u2066BatiFlow\u2069."
              }
            }
          },
          plan: {
            title: "\u0628\u0627\u0642\u062A\u0643",
            items: {
              status: {
                term: "\u062D\u0627\u0644\u0629 \u0627\u0644\u0627\u0634\u062A\u0631\u0627\u0643",
                text: "\u0634\u0627\u0631\u0629 \u0641\u064A \u0623\u0639\u0644\u0649 \u0627\u0644\u0628\u0637\u0627\u0642\u0629: \u0641\u062A\u0631\u0629 \u062A\u062C\u0631\u064A\u0628\u064A\u0629 \u0623\u0648 \u0646\u0634\u0637 \u0623\u0648 \u062F\u0641\u0639\u0629 \u0645\u062A\u0623\u062E\u0631\u0629 \u0623\u0648 \u0642\u0631\u0627\u0621\u0629 \u0641\u0642\u0637 (\u064A\u0645\u0643\u0646\u0643 \u0627\u0644\u0627\u0637\u0644\u0627\u0639 \u0648\u0627\u0644\u062A\u0635\u062F\u064A\u0631 \u0648\u0644\u0627 \u064A\u0645\u0643\u0646\u0643 \u0627\u0644\u0625\u0646\u0634\u0627\u0621 \u0623\u0648 \u0627\u0644\u062A\u0639\u062F\u064A\u0644) \u0623\u0648 \u0645\u0648\u0642\u0648\u0641 \u0623\u0648 \u0645\u062A\u0648\u0642\u0641 \u0645\u0624\u0642\u062A\u064B\u0627 \u0623\u0648 \u0645\u0644\u063A\u0649. \u0648\u0623\u062B\u0646\u0627\u0621 \u0627\u0644\u0641\u062A\u0631\u0629 \u0627\u0644\u062A\u062C\u0631\u064A\u0628\u064A\u0629 \u064A\u0639\u0631\u0636 \u0633\u0637\u0631 \xAB\u0646\u0647\u0627\u064A\u0629 \u0627\u0644\u0641\u062A\u0631\u0629 \u0627\u0644\u062A\u062C\u0631\u064A\u0628\u064A\u0629\xBB \u0627\u0644\u062A\u0627\u0631\u064A\u062E."
              },
              plan: {
                term: "\u0627\u0644\u0628\u0627\u0642\u0629",
                text: "\u0639\u0631\u0636\u0643: \u2066Solo\u2069 \u0623\u0648 \u2066Starter\u2069 \u0623\u0648 \u2066Pro\u2069 \u0623\u0648 \u2066Business\u2069 \u0623\u0648 \u2066Enterprise\u2069."
              },
              cycle: {
                term: "\u0627\u0644\u0641\u0648\u062A\u0631\u0629",
                text: "\u0634\u0647\u0631\u064A \u0623\u0648 \u0633\u0646\u0648\u064A. \u0648\u064A\u0643\u0644\u0651\u0641 \u0627\u0644\u0627\u0634\u062A\u0631\u0627\u0643 \u0627\u0644\u0633\u0646\u0648\u064A 10 \u0623\u0634\u0647\u0631 \u0628\u062F\u0644 12."
              },
              period: {
                term: "\u0627\u0644\u0641\u062A\u0631\u0629 \u0627\u0644\u062D\u0627\u0644\u064A\u0629",
                text: "\u062A\u0627\u0631\u064A\u062E\u0627 \u0628\u062F\u0627\u064A\u0629 \u0627\u0644\u0641\u062A\u0631\u0629 \u0627\u0644\u0645\u0641\u0648\u062A\u0631\u0629 \u0648\u0646\u0647\u0627\u064A\u062A\u0647\u0627."
              },
              nextDue: {
                term: "\u0627\u0644\u0627\u0633\u062A\u062D\u0642\u0627\u0642 \u0627\u0644\u0642\u0627\u062F\u0645",
                text: "\u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629 \u0627\u0644\u0642\u0627\u062F\u0645\u0629 \u0627\u0644\u0645\u0637\u0644\u0648\u0628 \u0633\u062F\u0627\u062F\u0647\u0627\u060C \u0623\u0648 \xAB\u0644\u0627 \u064A\u0648\u062C\u062F\xBB."
              },
              price: {
                term: "\u0627\u0644\u0633\u0639\u0631 \u0644\u0643\u0644 \u0641\u062A\u0631\u0629 (\u062F\u0648\u0646 \u0636\u0631\u064A\u0628\u0629)",
                text: "\u0627\u0644\u0633\u0639\u0631 \u062F\u0648\u0646 \u0636\u0631\u064A\u0628\u0629\u060C \xAB\u0634\u0647\u0631\u064A\u064B\u0627\xBB \u0623\u0648 \xAB\u0633\u0646\u0648\u064A\u064B\u0627\xBB. \u0648\xAB\u062D\u0633\u0628 \u0639\u0631\u0636 \u0627\u0644\u0633\u0639\u0631\xBB \u0644\u0628\u0627\u0642\u0629 \u2066Enterprise\u2069."
              },
              extras: {
                term: "\u0627\u0644\u062E\u064A\u0627\u0631\u0627\u062A",
                text: "\u0627\u0644\u0645\u0642\u0627\u0639\u062F \u0627\u0644\u0625\u0636\u0627\u0641\u064A\u0629 \u0648\u0627\u0644\u062A\u062E\u0632\u064A\u0646 \u0627\u0644\u0625\u0636\u0627\u0641\u064A \u0627\u0644\u0644\u0630\u0627\u0646 \u0623\u0636\u0641\u062A\u0647\u0645\u0627\u060C \u0623\u0648 \xAB\u0644\u0627 \u062A\u0648\u062C\u062F \u062E\u064A\u0627\u0631\u0627\u062A\xBB."
              },
              payment: {
                term: "\u0637\u0631\u064A\u0642\u0629 \u0627\u0644\u062F\u0641\u0639",
                text: "\u0628\u0637\u0627\u0642\u0629 \u0645\u0635\u0631\u0641\u064A\u0629 \u0623\u0648 \u062A\u062D\u0648\u064A\u0644 \u0645\u0635\u0631\u0641\u064A \u0623\u0648 \u0634\u064A\u0643 \u0623\u0648 \u0627\u0644\u062F\u0641\u0639 \u0639\u0628\u0631 \u0627\u0644\u0625\u0646\u062A\u0631\u0646\u062A\u061B \u0648\u0625\u0644\u0627 \xAB\u0644\u0645 \u062A\u064F\u062E\u062A\u0631 \u0628\u0639\u062F\xBB. \u0648\u064A\u0624\u0643\u062F \u0641\u0631\u064A\u0642 \u2066BatiFlow\u2069 \u0627\u0633\u062A\u0644\u0627\u0645 \u0627\u0644\u062A\u062D\u0648\u064A\u0644 \u0623\u0648 \u0627\u0644\u0634\u064A\u0643."
              }
            }
          },
          notices: {
            title: "\u0641\u0627\u062A\u0648\u0631\u0629 \u0644\u0644\u0633\u062F\u0627\u062F \u0648\u062A\u063A\u064A\u064A\u0631 \u0645\u0628\u0631\u0645\u062C",
            items: {
              openInvoice: {
                term: "\u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629 \u2026 \u0641\u064A \u0627\u0646\u062A\u0638\u0627\u0631 \u0627\u0644\u0633\u062F\u0627\u062F",
                text: "\u0634\u0631\u064A\u0637 \u0628\u0631\u062A\u0642\u0627\u0644\u064A \u062A\u062D\u062A \u0627\u0644\u0628\u0637\u0627\u0642\u0629 \u0639\u0646\u062F\u0645\u0627 \u062A\u0648\u062C\u062F \u0641\u0627\u062A\u0648\u0631\u0629 \u0645\u0641\u062A\u0648\u062D\u0629\u060C \u0645\u0639 \xAB\u0627\u0644\u0645\u0628\u0644\u063A \u0627\u0644\u0645\u0633\u062A\u062D\u0642\xBB \u0634\u0627\u0645\u0644\u064B\u0627 \u0627\u0644\u0636\u0631\u064A\u0628\u0629."
              },
              pay: {
                term: "\u0633\u062F\u0627\u062F",
                text: "\u064A\u0633\u062F\u0651\u062F \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629 \u0627\u0644\u0645\u0641\u062A\u0648\u062D\u0629. \u062E\u0627\u0635 \u0628\u0627\u0644\u0645\u0627\u0644\u0643."
              },
              pending: {
                term: "\u0647\u0646\u0627\u0643 \u062A\u063A\u064A\u064A\u0631 \u0645\u0628\u0631\u0645\u062C",
                text: "\u0634\u0631\u064A\u0637 \u0623\u0632\u0631\u0642: \u0641\u064A \u062A\u0627\u0631\u064A\u062E \u0645\u0639\u064A\u0651\u0646 \u0633\u064A\u0646\u062A\u0642\u0644 \u0627\u0644\u0627\u0634\u062A\u0631\u0627\u0643 \u0625\u0644\u0649 \u0628\u0627\u0642\u0629 \u0623\u062E\u0631\u0649 \u0623\u0648 \u0633\u064A\u062A\u0648\u0642\u0641 \u0645\u0624\u0642\u062A\u064B\u0627 \u0623\u0648 \u0633\u064A\u064F\u0644\u063A\u0649."
              },
              withdraw: {
                term: "\u0627\u0644\u062A\u0631\u0627\u062C\u0639 \u0639\u0646 \u0647\u0630\u0627 \u0627\u0644\u062A\u063A\u064A\u064A\u0631",
                text: "\u064A\u0633\u062D\u0628 \u0627\u0644\u062A\u063A\u064A\u064A\u0631 \u0627\u0644\u0645\u0628\u0631\u0645\u062C. \u062E\u0627\u0635 \u0628\u0627\u0644\u0645\u0627\u0644\u0643."
              }
            }
          },
          usage: {
            title: "\u0627\u0644\u0627\u0633\u062A\u062E\u062F\u0627\u0645",
            items: {
              seats: {
                term: "\u0627\u0644\u0645\u0642\u0627\u0639\u062F",
                text: "\u0639\u062F\u062F \u0627\u0644\u0623\u0634\u062E\u0627\u0635 \u0641\u064A \u0627\u0644\u0645\u0643\u062A\u0628 \u0645\u0642\u0627\u0631\u0646\u0629\u064B \u0628\u0645\u0642\u0627\u0639\u062F \u0628\u0627\u0642\u062A\u0643."
              },
              storage: {
                term: "\u0627\u0644\u062A\u062E\u0632\u064A\u0646",
                text: "\u0627\u0644\u0645\u0633\u0627\u062D\u0629 \u0627\u0644\u062A\u064A \u062A\u0634\u063A\u0644\u0647\u0627 \u0645\u0644\u0641\u0627\u062A\u0643 \u0645\u0642\u0627\u0631\u0646\u0629\u064B \u0628\u0645\u0633\u0627\u062D\u0629 \u0628\u0627\u0642\u062A\u0643."
              },
              hostedSpaces: {
                term: "\u0627\u0644\u0645\u0633\u0627\u062D\u0627\u062A \u0627\u0644\u0645\u0634\u062A\u0631\u0643\u0629 \u0627\u0644\u0645\u0633\u062A\u0636\u0627\u0641\u0629",
                text: "\u0639\u062F\u062F \u0627\u0644\u0645\u0633\u0627\u062D\u0627\u062A \u0627\u0644\u0645\u0634\u062A\u0631\u0643\u0629 \u0627\u0644\u062A\u064A \u064A\u0633\u062A\u0636\u064A\u0641\u0647\u0627 \u0645\u0643\u062A\u0628\u0643 \u0645\u0642\u0627\u0631\u0646\u0629\u064B \u0628\u062D\u062F\u0651 \u0627\u0644\u0628\u0627\u0642\u0629."
              },
              reading: {
                term: "\u2026 \u0645\u0646 \u2026 \u0648\u0627\u0644\u0646\u0633\u0628\u0629",
                text: "\u064A\u064F\u0643\u062A\u0628 \u0643\u0644 \u0633\u0637\u0631 \u0647\u0643\u0630\u0627 \xAB3 \u0645\u0646 5\xBB \u0645\u0639 \u0646\u0633\u0628\u0629 \u0648\u0634\u0631\u064A\u0637. \u0648\u064A\u062A\u062D\u0648\u0644 \u0627\u0644\u0634\u0631\u064A\u0637 \u0625\u0644\u0649 \u0627\u0644\u0628\u0631\u062A\u0642\u0627\u0644\u064A \u0627\u0628\u062A\u062F\u0627\u0621\u064B \u0645\u0646 80% \u0648\u0625\u0644\u0649 \u0627\u0644\u0623\u062D\u0645\u0631 \u0639\u0646\u062F 100%. \u0648\u0625\u0646 \u0644\u0645 \u064A\u0648\u062C\u062F \u062D\u062F\u0651 \u0641\u064A\u0642\u0648\u0644 \u0627\u0644\u0633\u0637\u0631 \xAB(\u062F\u0648\u0646 \u062D\u062F\u0651 \u0623\u0642\u0635\u0649)\xBB."
              }
            }
          },
          compare: {
            title: "\u0645\u0642\u0627\u0631\u0646\u0629 \u0627\u0644\u0628\u0627\u0642\u0627\u062A",
            items: {
              columns: {
                term: "\u2066Solo\u2069\u060C \u2066Starter\u2069\u060C \u2066Pro\u2069\u060C \u2066Business\u2069\u060C \u2066Enterprise\u2069",
                text: "\u0639\u0645\u0648\u062F \u0644\u0643\u0644 \u0628\u0627\u0642\u0629. \u0648\u064A\u0643\u0648\u0646 \u0639\u0645\u0648\u062F \u0628\u0627\u0642\u062A\u0643 \u0645\u0644\u0648\u0646\u064B\u0627 \u0648\u064A\u062D\u0645\u0644 \u0634\u0627\u0631\u0629 \xAB\u0628\u0627\u0642\u062A\u0643\xBB."
              },
              prices: {
                term: "\u0627\u0644\u0633\u0639\u0631 \u0627\u0644\u0634\u0647\u0631\u064A (\u062F\u0648\u0646 \u0636\u0631\u064A\u0628\u0629)",
                text: "\u0645\u0639 \xAB\u0627\u0644\u0633\u0639\u0631 \u0627\u0644\u0633\u0646\u0648\u064A (\u062F\u0648\u0646 \u0636\u0631\u064A\u0628\u0629)\xBB: \u0627\u0644\u0623\u0633\u0639\u0627\u0631 \u062F\u0648\u0646 \u0636\u0631\u064A\u0628\u0629. \u0648\u064A\u0643\u0644\u0651\u0641 \u0627\u0644\u0627\u0634\u062A\u0631\u0627\u0643 \u0627\u0644\u0633\u0646\u0648\u064A 10 \u0623\u0634\u0647\u0631 \u0628\u062F\u0644 12."
              },
              seats: {
                term: "\u0627\u0644\u0645\u0642\u0627\u0639\u062F \u0627\u0644\u0645\u0634\u0645\u0648\u0644\u0629",
                text: "\u0639\u062F\u062F \u0627\u0644\u0623\u0634\u062E\u0627\u0635 \u0627\u0644\u0645\u0634\u0645\u0648\u0644\u064A\u0646 \u0641\u064A \u0627\u0644\u0628\u0627\u0642\u0629. \u0648\u064A\u0639\u0631\u0636 \u0633\u0637\u0631 \xAB\u0645\u0642\u0639\u062F \u0625\u0636\u0627\u0641\u064A (\u0634\u0647\u0631\u064A\u064B\u0627)\xBB \u0633\u0639\u0631 \u0634\u062E\u0635 \u0625\u0636\u0627\u0641\u064A\u060C \u0623\u0648 \xAB\u063A\u064A\u0631 \u0645\u062A\u0627\u062D\xBB."
              },
              storage: {
                term: "\u0627\u0644\u062A\u062E\u0632\u064A\u0646 \u0627\u0644\u0645\u0634\u0645\u0648\u0644",
                text: "\u0645\u0633\u0627\u062D\u0629 \u0627\u0644\u062A\u062E\u0632\u064A\u0646 \u0627\u0644\u0645\u0634\u0645\u0648\u0644\u0629 \u0641\u064A \u0627\u0644\u0628\u0627\u0642\u0629. \u0648\u064A\u0639\u0631\u0636 \u0633\u0637\u0631 \xAB\u0627\u0644\u0645\u0633\u0627\u062D\u0627\u062A \u0627\u0644\u0645\u0634\u062A\u0631\u0643\u0629 \u0627\u0644\u0645\u0633\u062A\u0636\u0627\u0641\u0629\xBB \u0639\u062F\u062F \u0627\u0644\u0645\u0633\u0627\u062D\u0627\u062A \u0627\u0644\u0645\u0634\u062A\u0631\u0643\u0629 \u0627\u0644\u0645\u0633\u0645\u0648\u062D \u0628\u0647\u0627."
              },
              meeting: {
                term: "\u0627\u0644\u0645\u0634\u0627\u0631\u0643\u0648\u0646 \u0641\u064A \u0643\u0644 \u0627\u062C\u062A\u0645\u0627\u0639",
                text: "\u0639\u062F\u062F \u0627\u0644\u0623\u0634\u062E\u0627\u0635 \u0627\u0644\u0630\u064A\u0646 \u064A\u0645\u0643\u0646\u0647\u0645 \u0627\u0644\u0627\u0646\u0636\u0645\u0627\u0645 \u0625\u0644\u0649 \u0627\u062C\u062A\u0645\u0627\u0639 \u0639\u0628\u0631 \u0627\u0644\u0625\u0646\u062A\u0631\u0646\u062A."
              },
              special: {
                term: "\u063A\u064A\u0631 \u0645\u062D\u062F\u0648\u062F\u060C \u062D\u0633\u0628 \u0627\u0644\u0639\u0642\u062F\u060C \u062D\u0633\u0628 \u0639\u0631\u0636 \u0627\u0644\u0633\u0639\u0631",
                text: "\xAB\u063A\u064A\u0631 \u0645\u062D\u062F\u0648\u062F\xBB: \u0628\u0644\u0627 \u062D\u062F\u0651. \u0648\xAB\u062D\u0633\u0628 \u0627\u0644\u0639\u0642\u062F\xBB \u0648\xAB\u062D\u0633\u0628 \u0639\u0631\u0636 \u0627\u0644\u0633\u0639\u0631\xBB: \u0642\u064A\u0645 \u062A\u064F\u062A\u0641\u0642 \u0645\u0639 \u0627\u0644\u0641\u0631\u064A\u0642 \u0627\u0644\u062A\u062C\u0627\u0631\u064A\u061B \u0648\u062A\u064F\u0628\u0627\u0639 \u0628\u0627\u0642\u0629 \u2066Enterprise\u2069 \u0628\u0639\u0631\u0636 \u0633\u0639\u0631."
              }
            }
          },
          invoices: {
            title: "\u0641\u0648\u0627\u062A\u064A\u0631 \u0627\u0644\u0627\u0634\u062A\u0631\u0627\u0643",
            items: {
              number: {
                term: "\u0627\u0644\u0631\u0642\u0645",
                text: "\u0631\u0642\u0645 \u0641\u0627\u062A\u0648\u0631\u0629 \u2066BatiFlow\u2069."
              },
              purpose: {
                term: "\u0627\u0644\u063A\u0631\u0636",
                text: "\u0633\u0628\u0628 \u0625\u0635\u062F\u0627\u0631 \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629: \u0628\u062F\u0627\u064A\u0629 \u0627\u0644\u0627\u0634\u062A\u0631\u0627\u0643 \u0623\u0648 \u062A\u063A\u064A\u064A\u0631 \u0627\u0644\u0628\u0627\u0642\u0629 \u0623\u0648 \u0625\u0639\u0627\u062F\u0629 \u0627\u0644\u062A\u0634\u063A\u064A\u0644 \u0623\u0648 \u0627\u0644\u062A\u062C\u062F\u064A\u062F \u0623\u0648 \u0627\u0644\u0627\u0633\u062A\u0626\u0646\u0627\u0641 \u0628\u0639\u062F \u0627\u0644\u0625\u064A\u0642\u0627\u0641 \u0627\u0644\u0645\u0624\u0642\u062A."
              },
              dates: {
                term: "\u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0625\u0635\u062F\u0627\u0631",
                text: "\u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0625\u0635\u062F\u0627\u0631. \u0648\u064A\u0639\u0631\u0636 \u0639\u0645\u0648\u062F \xAB\u0627\u0644\u0633\u062F\u0627\u062F \u0642\u0628\u0644\xBB \u0622\u062E\u0631 \u0645\u0648\u0639\u062F \u0644\u0644\u0633\u062F\u0627\u062F."
              },
              total: {
                term: "\u0627\u0644\u0625\u062C\u0645\u0627\u0644\u064A \u0634\u0627\u0645\u0644 \u0627\u0644\u0636\u0631\u064A\u0628\u0629",
                text: "\u0627\u0644\u0645\u0628\u0644\u063A \u0634\u0627\u0645\u0644\u064B\u0627 \u0643\u0644 \u0627\u0644\u0636\u0631\u0627\u0626\u0628."
              },
              status: {
                term: "\u0627\u0644\u062D\u0627\u0644\u0629",
                text: "\u0644\u0644\u0633\u062F\u0627\u062F \u0623\u0648 \u0645\u0633\u062F\u064E\u0651\u062F\u0629 \u0623\u0648 \u0645\u0644\u063A\u0627\u0629."
              },
              pdf: {
                term: "\u2066PDF\u2069",
                text: "\u064A\u0646\u0632\u0651\u0644 \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629 \u0628\u0635\u064A\u063A\u0629 \u2066PDF\u2069. \u0648\u0625\u0646 \u0644\u0645 \u064A\u0643\u0646 \u0627\u0644\u0645\u0644\u0641 \u062C\u0627\u0647\u0632\u064B\u0627 \u0628\u0639\u062F \u0641\u062A\u0637\u0644\u0628 \u0645\u0646\u0643 \u0631\u0633\u0627\u0644\u0629 \u0625\u0639\u0627\u062F\u0629 \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629."
              },
              payInvoice: {
                term: "\u0633\u062F\u0627\u062F",
                text: "\u064A\u0633\u062F\u0651\u062F \u0641\u0627\u062A\u0648\u0631\u0629 \xAB\u0644\u0644\u0633\u062F\u0627\u062F\xBB. \u062E\u0627\u0635 \u0628\u0627\u0644\u0645\u0627\u0644\u0643."
              },
              empty: {
                term: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0641\u0648\u0627\u062A\u064A\u0631 \u0628\u0639\u062F",
                text: "\u0631\u0633\u0627\u0644\u0629 \u0627\u0644\u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u0641\u0627\u0631\u063A\u0629: \u0633\u062A\u0638\u0647\u0631 \u0647\u0646\u0627 \u0641\u0648\u0627\u062A\u064A\u0631 \u0627\u0634\u062A\u0631\u0627\u0643\u0643. \u0648\u0625\u0646 \u0644\u0645 \u062A\u064F\u062D\u0645\u064E\u0651\u0644 \u0627\u0644\u0642\u0627\u0626\u0645\u0629 \u062A\u0638\u0647\u0631 \xAB\u062A\u0639\u0630\u0651\u0631 \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0641\u0648\u0627\u062A\u064A\u0631\xBB \u0645\u0639 \u0632\u0631 \xAB\u0625\u0639\u0627\u062F\u0629 \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629\xBB."
              }
            }
          },
          manage: {
            title: "\u0625\u062F\u0627\u0631\u0629 \u0627\u0644\u0627\u0634\u062A\u0631\u0627\u0643",
            items: {
              renew: {
                term: "\u0627\u0644\u062A\u062C\u062F\u064A\u062F \u0627\u0644\u0622\u0646",
                text: "\u0632\u0631 \xAB\u062A\u062C\u062F\u064A\u062F\xBB: \u064A\u064F\u0635\u062F\u0631 \u0641\u0648\u0631\u064B\u0627 \u0641\u0627\u062A\u0648\u0631\u0629 \u0627\u0644\u0641\u062A\u0631\u0629 \u0627\u0644\u062A\u0627\u0644\u064A\u0629 \u0648\u064A\u0645\u0643\u0646\u0643 \u0633\u062F\u0627\u062F\u0647\u0627 \u0645\u0628\u0627\u0634\u0631\u0629. \u0642\u0633\u0645 \u062E\u0627\u0635 \u0628\u0627\u0644\u0645\u0627\u0644\u0643."
              },
              pause: {
                term: "\u0625\u064A\u0642\u0627\u0641 \u0645\u0624\u0642\u062A",
                text: "\u0627\u062E\u062A\u0631 \xAB\u0645\u062F\u0629 \u0627\u0644\u0625\u064A\u0642\u0627\u0641 \u0627\u0644\u0645\u0624\u0642\u062A\xBB (3 \u0623\u0634\u0647\u0631 \u0641\u064A \u0627\u0644\u0633\u0646\u0629 \u0643\u062D\u062F\u0651 \u0623\u0642\u0635\u0649). \u064A\u0628\u062F\u0623 \u0627\u0644\u0625\u064A\u0642\u0627\u0641 \u0639\u0646\u062F \u0646\u0647\u0627\u064A\u0629 \u0627\u0644\u0641\u062A\u0631\u0629 \u0627\u0644\u062D\u0627\u0644\u064A\u0629 \u0648\u064A\u0643\u0644\u0651\u0641 20% \u0645\u0646 \u0627\u0644\u0633\u0639\u0631. \u0648\u0644\u0627 \u064A\u0645\u0643\u0646 \u0625\u064A\u0642\u0627\u0641 \u0627\u0634\u062A\u0631\u0627\u0643 \u0645\u0624\u0642\u062A\u064B\u0627 \u0625\u0644\u0627 \u0625\u0630\u0627 \u0643\u0627\u0646 \u0646\u0634\u0637\u064B\u0627 \u0648\u0644\u0627 \u064A\u0648\u062C\u062F \u062A\u063A\u064A\u064A\u0631 \u062C\u0627\u0631\u064D."
              },
              resume: {
                term: "\u0627\u0633\u062A\u0626\u0646\u0627\u0641 \u0627\u0644\u0627\u0634\u062A\u0631\u0627\u0643",
                text: "\u064A\u0638\u0647\u0631 \u0639\u0646\u062F\u0645\u0627 \u064A\u0643\u0648\u0646 \u0627\u0644\u0627\u0634\u062A\u0631\u0627\u0643 \u0645\u062A\u0648\u0642\u0641\u064B\u0627 \u0645\u0624\u0642\u062A\u064B\u0627. \u062A\u064F\u0635\u062F\u0631 \u0641\u0627\u062A\u0648\u0631\u0629 (\u0623\u0634\u0647\u0631 \u0627\u0644\u0625\u064A\u0642\u0627\u0641 \u0628\u0646\u0633\u0628\u0629 20% \u0625\u0636\u0627\u0641\u0629\u064B \u0625\u0644\u0649 \u0641\u062A\u0631\u0629 \u062C\u062F\u064A\u062F\u0629) \u0648\u064A\u064F\u0633\u062A\u0623\u0646\u0641 \u0627\u0644\u0627\u0634\u062A\u0631\u0627\u0643 \u0628\u0645\u062C\u0631\u062F \u0633\u062F\u0627\u062F\u0647\u0627."
              },
              cancel: {
                term: "\u0625\u0644\u063A\u0627\u0621 \u0627\u0644\u0627\u0634\u062A\u0631\u0627\u0643",
                text: "\u064A\u0633\u0631\u064A \u0627\u0644\u0625\u0644\u063A\u0627\u0621 \u0639\u0646\u062F \u0646\u0647\u0627\u064A\u0629 \u0627\u0644\u0641\u062A\u0631\u0629 \u0627\u0644\u062D\u0627\u0644\u064A\u0629. \u0628\u0639\u062F\u0647\u0627 \u064A\u062A\u062D\u0648\u0644 \u0627\u0644\u0645\u0643\u062A\u0628 \u0625\u0644\u0649 \u0648\u0636\u0639 \u0627\u0644\u0642\u0631\u0627\u0621\u0629 \u0641\u0642\u0637 \u0644\u0645\u062F\u0629 90 \u064A\u0648\u0645\u064B\u0627 (\u0627\u0644\u0627\u0637\u0644\u0627\u0639 \u0648\u0627\u0644\u062A\u0635\u062F\u064A\u0631) \u062B\u0645 \u062A\u064F\u062D\u0630\u0641 \u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A. \u0648\u0645\u0627 \u062F\u0627\u0645\u062A \u0627\u0644\u0641\u062A\u0631\u0629 \u0644\u0645 \u062A\u0646\u062A\u0647\u0650 \u064A\u0645\u0643\u0646\u0643 \u0627\u0644\u062A\u0631\u0627\u062C\u0639 \u0639\u0646 \u0627\u0644\u0625\u0644\u063A\u0627\u0621."
              }
            }
          },
          changeDialog: {
            title: "\u062A\u0639\u062F\u064A\u0644 \u0627\u0644\u0627\u0634\u062A\u0631\u0627\u0643",
            items: {
              plan: {
                term: "\u0627\u0644\u0628\u0627\u0642\u0629",
                text: "\u0627\u0644\u0628\u0627\u0642\u0629 \u0627\u0644\u062C\u062F\u064A\u062F\u0629. \u0648\u062A\u064F\u0639\u0631\u0636 \u2066Enterprise\u2069 \xAB\u062D\u0633\u0628 \u0639\u0631\u0636 \u0627\u0644\u0633\u0639\u0631\xBB: \u0641\u0647\u064A \u0644\u0627 \u062A\u064F\u0634\u062A\u0631\u0649 \u0639\u0628\u0631 \u0627\u0644\u0625\u0646\u062A\u0631\u0646\u062A."
              },
              cycle: {
                term: "\u0627\u0644\u0641\u0648\u062A\u0631\u0629",
                text: "\u0634\u0647\u0631\u064A \u0623\u0648 \u0633\u0646\u0648\u064A. \u0627\u0644\u0633\u0646\u0648\u064A: \u062A\u062F\u0641\u0639 10 \u0623\u0634\u0647\u0631 \u0645\u0642\u0627\u0628\u0644 12."
              },
              extraSeats: {
                term: "\u0627\u0644\u0645\u0642\u0627\u0639\u062F \u0627\u0644\u0625\u0636\u0627\u0641\u064A\u0629",
                text: "\u0639\u062F\u062F \u0627\u0644\u0623\u0634\u062E\u0627\u0635 \u0627\u0644\u0645\u0631\u0627\u062F \u0625\u0636\u0627\u0641\u062A\u0647\u0645 \u0641\u0648\u0642 \u0627\u0644\u0628\u0627\u0642\u0629. \u0648\u064A\u0643\u0648\u0646 \u0627\u0644\u062D\u0642\u0644 \u0645\u0639\u0637\u0651\u0644\u064B\u0627 \u0639\u0646\u062F\u0645\u0627 \u0644\u0627 \u062A\u062A\u064A\u062D \u0627\u0644\u0628\u0627\u0642\u0629 \u0630\u0644\u0643 (\xAB\u0644\u0627 \u062A\u062A\u064A\u062D \u0647\u0630\u0647 \u0627\u0644\u0628\u0627\u0642\u0629 \u0645\u0642\u0627\u0639\u062F \u0625\u0636\u0627\u0641\u064A\u0629\xBB)."
              },
              addon: {
                term: "\u062A\u062E\u0632\u064A\u0646 \u0625\u0636\u0627\u0641\u064A",
                text: "\u062D\u0642\u0644 \u0643\u0645\u064A\u0629 \u0644\u0643\u0644 \u062D\u0632\u0645\u0629 \u062A\u062E\u0632\u064A\u0646 \u0645\u0639\u0631\u0648\u0636\u0629\u060C \u0644\u0625\u0636\u0627\u0641\u0629 \u0645\u0633\u0627\u062D\u0629 \u0625\u0644\u0649 \u0628\u0627\u0642\u062A\u0643."
              },
              preview: {
                term: "\u0645\u0639\u0627\u064A\u0646\u0629 \u0627\u0644\u0633\u0639\u0631",
                text: "\u064A\u0638\u0647\u0631 \u0627\u0644\u0633\u0639\u0631 \u0642\u0628\u0644 \u062A\u0623\u0643\u064A\u062F \u0623\u064A \u0634\u064A\u0621: \u062C\u062F\u0648\u0644 \u0641\u064A\u0647 \u0627\u0644\u0628\u0646\u062F \u0648\u0627\u0644\u0643\u0645\u064A\u0629 \u0648\u0633\u0639\u0631 \u0627\u0644\u0648\u062D\u062F\u0629 \u0648\u0627\u0644\u0645\u0628\u0644\u063A\u060C \u062B\u0645 \u0627\u0644\u0625\u062C\u0645\u0627\u0644\u064A \u062F\u0648\u0646 \u0636\u0631\u064A\u0628\u0629 \u0648\u0627\u0644\u0625\u062C\u0645\u0627\u0644\u064A \u0634\u0627\u0645\u0644\u064B\u0627 \u0627\u0644\u0636\u0631\u064A\u0628\u0629\u060C \u0648\u062C\u0645\u0644\u0629 \u062A\u0642\u0648\u0644 \u0645\u0627 \u0633\u064A\u062D\u062F\u062B (\u0641\u0627\u062A\u0648\u0631\u0629 \u0641\u0648\u0631\u064B\u0627 \u0623\u0648 \u062A\u0639\u062F\u064A\u0644 \u0639\u0646\u062F \u0646\u0647\u0627\u064A\u0629 \u0627\u0644\u0641\u062A\u0631\u0629 \u0623\u0648 \u0644\u0627 \u062A\u063A\u064A\u064A\u0631)."
              },
              blocked: {
                term: "\u0647\u0630\u0647 \u0627\u0644\u0628\u0627\u0642\u0629 \u0623\u0635\u063A\u0631 \u0645\u0646 \u0627\u0633\u062A\u062E\u062F\u0627\u0645\u0643 \u0627\u0644\u062D\u0627\u0644\u064A",
                text: "\u0631\u0633\u0627\u0644\u0629 \u062A\u0638\u0647\u0631 \u0639\u0646\u062F\u0645\u0627 \u062A\u0633\u062A\u0639\u0645\u0644 \u0623\u0643\u062B\u0631 \u0645\u0645\u0627 \u062A\u062A\u064A\u062D\u0647 \u0627\u0644\u0628\u0627\u0642\u0629 \u0627\u0644\u0645\u062E\u062A\u0627\u0631\u0629: \u062A\u0633\u0631\u062F \u0645\u0627 \u064A\u062C\u0628 \u062A\u0642\u0644\u064A\u0635\u0647 (\u0627\u0644\u0645\u0642\u0627\u0639\u062F \u0623\u0648 \u0627\u0644\u062A\u062E\u0632\u064A\u0646 \u0623\u0648 \u0627\u0644\u0645\u0633\u0627\u062D\u0627\u062A \u0627\u0644\u0645\u0634\u062A\u0631\u0643\u0629 \u0627\u0644\u0645\u0633\u062A\u0636\u0627\u0641\u0629) \u0642\u0628\u0644 \u0623\u0646 \u062A\u062A\u0645\u0643\u0646 \u0645\u0646 \u0627\u062E\u062A\u064A\u0627\u0631\u0647\u0627."
              },
              confirm: {
                term: "\u062A\u0623\u0643\u064A\u062F \u0627\u0644\u062A\u0639\u062F\u064A\u0644",
                text: "\u064A\u0635\u0627\u062F\u0642 \u0639\u0644\u0649 \u0627\u0644\u062A\u0639\u062F\u064A\u0644 \u0628\u0639\u062F \u062A\u0623\u0643\u064A\u062F \u0627\u0644\u0647\u0648\u064A\u0629. \u0648\u0639\u0646\u062F\u0645\u0627 \u062A\u064F\u0635\u062F\u0631 \u0641\u0627\u062A\u0648\u0631\u0629 \u064A\u0633\u0645\u0649 \u0627\u0644\u0632\u0631 \xAB\u0627\u0644\u062A\u0623\u0643\u064A\u062F \u0648\u0627\u0633\u062A\u0644\u0627\u0645 \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629\xBB."
              },
              issued: {
                term: "\u0635\u062F\u0631\u062A \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629 \u2026",
                text: "\u062A\u0639\u0631\u0636 \u0646\u0627\u0641\u0630\u0629 \xAB\u0627\u0644\u0645\u0628\u0644\u063A \u0627\u0644\u0645\u0633\u062A\u062D\u0642\xBB \u0648\u0645\u062A\u0649 \u064A\u0633\u0631\u064A \u0627\u0644\u062A\u0639\u062F\u064A\u0644 (\u0628\u0645\u062C\u0631\u062F \u0633\u062F\u0627\u062F \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629). \u0627\u062E\u062A\u0631 \xAB\u0633\u062F\u0627\u062F\xBB \u0644\u0644\u0633\u062F\u0627\u062F \u0627\u0644\u0622\u0646 \u0623\u0648 \xAB\u0644\u0627\u062D\u0642\u064B\u0627\xBB."
              }
            }
          }
        }
      }
    },
    me: {
      profile: {
        title: "\u0645\u0644\u0641\u064A \u0627\u0644\u0634\u062E\u0635\u064A",
        intro: "\u062A\u062C\u0645\u0639 \u0647\u0630\u0647 \u0627\u0644\u0635\u0641\u062D\u0629 \u0645\u0639\u0644\u0648\u0645\u0627\u062A\u0643 \u0627\u0644\u0634\u062E\u0635\u064A\u0629: \u0627\u0633\u0645\u0643 \u0648\u0644\u063A\u062A\u0643 \u0648\u0645\u0646\u0637\u0642\u062A\u0643 \u0627\u0644\u0632\u0645\u0646\u064A\u0629 \u0648\u0645\u0638\u0647\u0631 \u0627\u0644\u062A\u0637\u0628\u064A\u0642 \u0648\u0627\u0644\u0627\u0637\u0644\u0627\u0639 \u0639\u0644\u0649 \u0628\u064A\u0627\u0646\u0627\u062A\u0643 \u0627\u0644\u0634\u062E\u0635\u064A\u0629. \u0648\u0647\u064A \u062A\u062E\u0635\u0651\u0643 \u0648\u062D\u062F\u0643.",
        sections: {
          header: {
            title: "\u0639\u0644\u0627\u0645\u0627\u062A \u0627\u0644\u062A\u0628\u0648\u064A\u0628 \u0648\u0627\u0644\u0631\u0633\u0627\u0626\u0644",
            items: {
              tabs: {
                term: "\u0627\u0644\u0645\u0644\u0641 \u0627\u0644\u0634\u062E\u0635\u064A\u060C \u0627\u0644\u0623\u0645\u0627\u0646\u060C \u0627\u0644\u0625\u0634\u0639\u0627\u0631\u0627\u062A",
                text: "\u062B\u0644\u0627\u062B \u0639\u0644\u0627\u0645\u0627\u062A \u062A\u0628\u0648\u064A\u0628 \u0641\u064A \u0623\u0639\u0644\u0649 \u0635\u0641\u062D\u0627\u062A \u062D\u0633\u0627\u0628\u0643: \u0627\u0644\u0645\u0644\u0641 \u0627\u0644\u0634\u062E\u0635\u064A \u0648\u0627\u0644\u0623\u0645\u0627\u0646 \u0648\u0627\u0644\u0625\u0634\u0639\u0627\u0631\u0627\u062A. \u0627\u0636\u063A\u0637 \u0639\u0644\u0649 \u0625\u062D\u062F\u0627\u0647\u0627 \u0644\u0644\u0627\u0646\u062A\u0642\u0627\u0644 \u0645\u0646 \u0635\u0641\u062D\u0629 \u0625\u0644\u0649 \u0623\u062E\u0631\u0649."
              },
              messages: {
                term: "\u0631\u0633\u0627\u0626\u0644 \u0627\u0644\u062A\u0623\u0643\u064A\u062F",
                text: "\u0628\u0639\u062F \u0643\u0644 \u062D\u0641\u0638 \u062A\u0624\u0643\u062F \u0631\u0633\u0627\u0644\u0629 \u0642\u0635\u064A\u0631\u0629 \u0630\u0644\u0643\u060C \u0645\u062B\u0644 \xAB\u062A\u0645 \u062D\u0641\u0638 \u0644\u063A\u062A\u0643.\xBB. \u0648\u0625\u0646 \u0641\u0634\u0644 \u0627\u0644\u062D\u0641\u0638 \u062A\u0638\u0647\u0631 \u0631\u0633\u0627\u0644\u0629 \u062E\u0637\u0623 \u0648\u0627\u0636\u062D\u0629 \u0648\u064A\u0639\u0648\u062F \u0627\u0644\u0627\u062E\u062A\u064A\u0627\u0631 \u0627\u0644\u0633\u0627\u0628\u0642."
              }
            }
          },
          identity: {
            title: "\u0627\u0644\u0647\u0648\u064A\u0629",
            items: {
              name: {
                term: "\u0627\u0644\u0627\u0633\u0645 \u0627\u0644\u0645\u0639\u0631\u0648\u0636",
                text: "\u0625\u0644\u0632\u0627\u0645\u064A. \u0627\u0633\u0645\u0643 \u0643\u0645\u0627 \u064A\u0631\u0627\u0647 \u0632\u0645\u0644\u0627\u0624\u0643. \u0648\u0625\u0646 \u062A\u0631\u0643\u062A\u0647 \u0641\u0627\u0631\u063A\u064B\u0627 \u062A\u0638\u0647\u0631 \xAB\u0627\u0643\u062A\u0628 \u0627\u0633\u0645\u0643.\xBB."
              },
              email: {
                term: "\u0639\u0646\u0648\u0627\u0646 \u0627\u0644\u0628\u0631\u064A\u062F \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A",
                text: "\u0644\u0644\u0642\u0631\u0627\u0621\u0629 \u0641\u0642\u0637: \u064A\u064F\u062F\u0627\u0631 \u0645\u0646 \u062D\u0633\u0627\u0628\u0643 \u0641\u064A \u2066BatiFlow\u2069 \u0648\u0644\u0627 \u064A\u0645\u0643\u0646 \u062A\u063A\u064A\u064A\u0631\u0647 \u0647\u0646\u0627."
              },
              save: {
                term: "\u062D\u0641\u0638",
                text: "\u064A\u062D\u0641\u0638 \u0627\u0633\u0645\u0643. \u0648\u062A\u0624\u0643\u062F \u0631\u0633\u0627\u0644\u0629 \u0623\u0646\u0647 \xAB\u062A\u0645 \u062D\u0641\u0638 \u0627\u0633\u0645\u0643.\xBB"
              }
            }
          },
          region: {
            title: "\u0627\u0644\u0644\u063A\u0629 \u0648\u0627\u0644\u0645\u0646\u0637\u0642\u0629",
            items: {
              language: {
                term: "\u0644\u063A\u0629 \u0627\u0644\u0648\u0627\u062C\u0647\u0629",
                text: "\u2066Fran\u2069\xE7\u2066ais\u2069 \u0623\u0648 \u0627\u0644\u0639\u0631\u0628\u064A\u0629 \u0623\u0648 \u2066English\u2069. \u064A\u0633\u0631\u064A \u0627\u0644\u062A\u063A\u064A\u064A\u0631 \u0641\u0648\u0631\u064B\u0627\u060C \u0628\u0645\u0627 \u0641\u064A \u0630\u0644\u0643 \u0627\u062A\u062C\u0627\u0647 \u0627\u0644\u0642\u0631\u0627\u0621\u0629 \u0644\u0644\u063A\u0629 \u0627\u0644\u0639\u0631\u0628\u064A\u0629\u060C \u0648\u064A\u064F\u062D\u0641\u0638 \u0641\u064A \u062D\u0633\u0627\u0628\u0643."
              },
              timeZone: {
                term: "\u0627\u0644\u0645\u0646\u0637\u0642\u0629 \u0627\u0644\u0632\u0645\u0646\u064A\u0629",
                text: "\u062A\u064F\u0639\u0631\u0636 \u062A\u0648\u0627\u0631\u064A\u062E \u0627\u0644\u062A\u0637\u0628\u064A\u0642 \u0648\u0623\u0648\u0642\u0627\u062A\u0647 \u0648\u0641\u0642 \u0647\u0630\u0647 \u0627\u0644\u0645\u0646\u0637\u0642\u0629 \u0627\u0644\u0632\u0645\u0646\u064A\u0629. \u0648\u062A\u062D\u0645\u0644 \u0643\u0644 \u062E\u0627\u0646\u0629 \u0641\u064A \u0627\u0644\u0642\u0627\u0626\u0645\u0629 \u0641\u0627\u0631\u0642\u0647\u0627 \u0639\u0646 \u0627\u0644\u062A\u0648\u0642\u064A\u062A \u0627\u0644\u0639\u0627\u0644\u0645\u064A."
              },
              digits: {
                term: "\u0623\u0631\u0642\u0627\u0645 \u0627\u0644\u0648\u0627\u062C\u0647\u0629 \u0627\u0644\u0639\u0631\u0628\u064A\u0629",
                text: "\u0623\u0631\u0642\u0627\u0645 \u0644\u0627\u062A\u064A\u0646\u064A\u0629 (0123456789) \u0623\u0648 \u0623\u0631\u0642\u0627\u0645 \u0639\u0631\u0628\u064A\u0629 \u0647\u0646\u062F\u064A\u0629 (\u0660\u0661\u0662\u0663\u0664\u0665\u0666\u0667\u0668\u0669). \u0648\u0644\u0627 \u064A\u0646\u0637\u0628\u0642 \u0647\u0630\u0627 \u0627\u0644\u0627\u062E\u062A\u064A\u0627\u0631 \u0625\u0644\u0627 \u0639\u0646\u062F\u0645\u0627 \u062A\u0643\u0648\u0646 \u0627\u0644\u0648\u0627\u062C\u0647\u0629 \u0628\u0627\u0644\u0639\u0631\u0628\u064A\u0629."
              }
            }
          },
          appearance: {
            title: "\u0627\u0644\u0645\u0638\u0647\u0631",
            items: {
              theme: {
                term: "\u0627\u0644\u0633\u0645\u0629",
                text: "\u062D\u0633\u0628 \u0625\u0639\u062F\u0627\u062F\u0627\u062A \u0627\u0644\u062C\u0647\u0627\u0632 (\u062A\u062A\u0628\u0639 \u0625\u0639\u062F\u0627\u062F \u062C\u0647\u0627\u0632\u0643) \u0623\u0648 \u0641\u0627\u062A\u062D \u0623\u0648 \u062F\u0627\u0643\u0646 \u0623\u0648 \u062A\u0628\u0627\u064A\u0646 \u0639\u0627\u0644\u064D (\u0623\u0644\u0648\u0627\u0646 \u0648\u0627\u0636\u062D\u0629 \u062C\u062F\u064B\u0627 \u0648\u0623\u0633\u0647\u0644 \u0641\u064A \u0627\u0644\u0642\u0631\u0627\u0621\u0629)."
              },
              device: {
                term: "\u064A\u0628\u0642\u0649 \u0647\u0630\u0627 \u0627\u0644\u0627\u062E\u062A\u064A\u0627\u0631 \u0639\u0644\u0649 \u0647\u0630\u0627 \u0627\u0644\u062C\u0647\u0627\u0632",
                text: "\u0644\u0627 \u062A\u064F\u062D\u0641\u0638 \u0627\u0644\u0633\u0645\u0629 \u0641\u064A \u062D\u0633\u0627\u0628\u0643: \u0648\u0639\u0644\u0649 \u062C\u0647\u0627\u0632 \u0622\u062E\u0631 \u0623\u0648 \u0645\u062A\u0635\u0641\u062D \u0622\u062E\u0631 \u0633\u062A\u062D\u062A\u0627\u062C \u0625\u0644\u0649 \u0627\u062E\u062A\u064A\u0627\u0631\u0647\u0627 \u0645\u0646 \u062C\u062F\u064A\u062F."
              }
            }
          },
          myData: {
            title: "\u0628\u064A\u0627\u0646\u0627\u062A\u064A \u0627\u0644\u0634\u062E\u0635\u064A\u0629",
            items: {
              law: {
                term: "\u0628\u064A\u0627\u0646\u0627\u062A\u064A \u0627\u0644\u0634\u062E\u0635\u064A\u0629",
                text: "\u064A\u0645\u0646\u062D\u0643 \u0627\u0644\u0642\u0627\u0646\u0648\u0646 \u0627\u0644\u0623\u0633\u0627\u0633\u064A \u0639\u062F\u062F 63 \u0644\u0633\u0646\u0629 2004 \u062D\u0642 \u0627\u0644\u0627\u0637\u0644\u0627\u0639 \u0639\u0644\u0649 \u0628\u064A\u0627\u0646\u0627\u062A\u0643 \u0627\u0644\u0634\u062E\u0635\u064A\u0629 \u0627\u0644\u062A\u064A \u064A\u062D\u062A\u0641\u0638 \u0628\u0647\u0627 \u2066BatiFlow\u2069. \u0648\u064A\u062A\u064A\u062D \u0644\u0643 \u0647\u0630\u0627 \u0627\u0644\u0642\u0633\u0645 \u0627\u0644\u062D\u0635\u0648\u0644 \u0639\u0644\u0649 \u0646\u0633\u062E\u0629 \u0645\u0646\u0647\u0627."
              },
              button: {
                term: "\u062A\u0635\u062F\u064A\u0631 \u0628\u064A\u0627\u0646\u0627\u062A\u064A",
                text: "\u064A\u0628\u062F\u0623 \u062A\u062D\u0636\u064A\u0631 \u0646\u0633\u062E\u0629 \u0645\u0646 \u0628\u064A\u0627\u0646\u0627\u062A\u0643. \u0648\u062A\u0642\u0648\u0644 \u0631\u0633\u0627\u0644\u0629 \u0625\u0646\u0647\u0627 \u0642\u064A\u062F \u0627\u0644\u0625\u0639\u062F\u0627\u062F \u0648\u062A\u062A\u0644\u0642\u0649 \u0625\u0634\u0639\u0627\u0631\u064B\u0627 \u0639\u0646\u062F\u0645\u0627 \u062A\u0635\u0628\u062D \u062C\u0627\u0647\u0632\u0629."
              },
              columns: {
                term: "\u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0637\u0644\u0628\u060C \u0627\u0644\u062D\u062C\u0645\u060C \u0645\u062A\u0627\u062D \u062D\u062A\u0649",
                text: "\u064A\u0639\u0631\u0636 \u062C\u062F\u0648\u0644 \xAB\u0646\u0633\u062E \u0628\u064A\u0627\u0646\u0627\u062A\u064A\xBB \u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0637\u0644\u0628 \u0648\u062D\u062C\u0645 \u0627\u0644\u0645\u0644\u0641 \u0648\u0622\u062E\u0631 \u064A\u0648\u0645 \u0644\u062A\u0646\u0632\u064A\u0644\u0647."
              },
              status: {
                term: "\u0627\u0644\u062D\u0627\u0644\u0629",
                text: "\u0641\u064A \u0627\u0644\u0627\u0646\u062A\u0638\u0627\u0631 \u0623\u0648 \u0642\u064A\u062F \u0627\u0644\u0625\u0639\u062F\u0627\u062F \u0623\u0648 \u062C\u0627\u0647\u0632 \u0623\u0648 \u0641\u0634\u0644 \u0623\u0648 \u0645\u0646\u062A\u0647\u064A \u0627\u0644\u0635\u0644\u0627\u062D\u064A\u0629. \u0648\u062A\u062A\u062D\u062F\u062B \u0627\u0644\u0642\u0627\u0626\u0645\u0629 \u062A\u0644\u0642\u0627\u0626\u064A\u064B\u0627 \u0623\u062B\u0646\u0627\u0621 \u0627\u0644\u0625\u0639\u062F\u0627\u062F."
              },
              download: {
                term: "\u062A\u0646\u0632\u064A\u0644",
                text: "\u064A\u0646\u0632\u0651\u0644 \u0646\u0633\u062E\u062A\u0643. \u0648\u0644\u0627 \u064A\u0638\u0647\u0631 \u0627\u0644\u0632\u0631 \u0625\u0644\u0627 \u0639\u0644\u0649 \u0646\u0633\u062E\u0629 \xAB\u062C\u0627\u0647\u0632\xBB."
              },
              empty: {
                term: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0646\u0633\u062E \u0628\u0639\u062F",
                text: "\u0631\u0633\u0627\u0644\u0629 \u0627\u0644\u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u0641\u0627\u0631\u063A\u0629: \u0627\u0637\u0644\u0628 \u0646\u0633\u062E\u0629 \u0644\u062A\u062D\u0635\u0644 \u0639\u0644\u0649 \u0646\u0633\u062E\u0629 \u0645\u0646 \u0628\u064A\u0627\u0646\u0627\u062A\u0643 \u0627\u0644\u0634\u062E\u0635\u064A\u0629. \u0648\u0625\u0646 \u0644\u0645 \u062A\u064F\u062D\u0645\u064E\u0651\u0644 \u0627\u0644\u0642\u0627\u0626\u0645\u0629 \u062A\u062F\u0639\u0648\u0643 \u0631\u0633\u0627\u0644\u0629 \u0625\u0644\u0649 \u0627\u0644\u062A\u062D\u0642\u0642 \u0645\u0646 \u0627\u062A\u0635\u0627\u0644\u0643."
              }
            }
          }
        }
      },
      security: {
        title: "\u0623\u0645\u0627\u0646 \u0627\u0644\u062D\u0633\u0627\u0628",
        intro: "\u062A\u0633\u0627\u0639\u062F\u0643 \u0647\u0630\u0647 \u0627\u0644\u0635\u0641\u062D\u0629 \u0639\u0644\u0649 \u062D\u0645\u0627\u064A\u0629 \u062D\u0633\u0627\u0628\u0643: \u0627\u0644\u062A\u062D\u0642\u0642 \u0628\u062E\u0637\u0648\u062A\u064A\u0646 \u0648\u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631 \u0648\u0627\u0644\u0623\u062C\u0647\u0632\u0629 \u0627\u0644\u0645\u0633\u062C\u0651\u0644\u0629 \u0627\u0644\u062F\u062E\u0648\u0644. \u0648\u0647\u064A \u062A\u062E\u0635\u0651\u0643 \u0648\u062D\u062F\u0643.",
        sections: {
          header: {
            title: "\u0639\u0644\u0627\u0645\u0627\u062A \u0627\u0644\u062A\u0628\u0648\u064A\u0628 \u0648\u062A\u0646\u0638\u064A\u0645 \u0627\u0644\u0635\u0641\u062D\u0629",
            items: {
              tabs: {
                term: "\u0627\u0644\u0645\u0644\u0641 \u0627\u0644\u0634\u062E\u0635\u064A\u060C \u0627\u0644\u0623\u0645\u0627\u0646\u060C \u0627\u0644\u0625\u0634\u0639\u0627\u0631\u0627\u062A",
                text: "\u062B\u0644\u0627\u062B \u0639\u0644\u0627\u0645\u0627\u062A \u062A\u0628\u0648\u064A\u0628 \u0641\u064A \u0623\u0639\u0644\u0649 \u0635\u0641\u062D\u0627\u062A \u062D\u0633\u0627\u0628\u0643: \u0627\u0644\u0645\u0644\u0641 \u0627\u0644\u0634\u062E\u0635\u064A \u0648\u0627\u0644\u0623\u0645\u0627\u0646 \u0648\u0627\u0644\u0625\u0634\u0639\u0627\u0631\u0627\u062A. \u0627\u0636\u063A\u0637 \u0639\u0644\u0649 \u0625\u062D\u062F\u0627\u0647\u0627 \u0644\u0644\u0627\u0646\u062A\u0642\u0627\u0644 \u0645\u0646 \u0635\u0641\u062D\u0629 \u0625\u0644\u0649 \u0623\u062E\u0631\u0649."
              },
              order: {
                term: "\u0623\u0645\u0627\u0646 \u0627\u0644\u062D\u0633\u0627\u0628",
                text: "\u062A\u064F\u0642\u0631\u0623 \u0627\u0644\u0635\u0641\u062D\u0629 \u0645\u0646 \u0627\u0644\u0623\u0639\u0644\u0649 \u0625\u0644\u0649 \u0627\u0644\u0623\u0633\u0641\u0644: \u0627\u0644\u062A\u062D\u0642\u0642 \u0628\u062E\u0637\u0648\u062A\u064A\u0646 \u062B\u0645 \u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631 \u0648\u062A\u0637\u0628\u064A\u0642 \u0627\u0644\u0645\u0635\u0627\u062F\u0642\u0629 \u062B\u0645 \u0627\u0644\u062C\u0644\u0633\u0627\u062A \u0627\u0644\u0646\u0634\u0637\u0629."
              }
            }
          },
          mfa: {
            title: "\u0627\u0644\u062A\u062D\u0642\u0642 \u0628\u062E\u0637\u0648\u062A\u064A\u0646",
            items: {
              status: {
                term: "\u0645\u0641\u0639\u0651\u0644",
                text: "\u0634\u0627\u0631\u0629 \u062E\u0636\u0631\u0627\u0621: \u062A\u0645 \u062A\u0623\u0643\u064A\u062F \u062C\u0644\u0633\u062A\u0643 \u0627\u0644\u062D\u0627\u0644\u064A\u0629 \u0628\u0639\u0627\u0645\u0644 \u062B\u0627\u0646\u064D (\u0625\u0636\u0627\u0641\u0629 \u0625\u0644\u0649 \u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631\u060C \u0631\u0645\u0632 \u0645\u0646 \u062A\u0637\u0628\u064A\u0642 \u0645\u0635\u0627\u062F\u0642\u0629 \u0623\u0648 \u0645\u0641\u062A\u0627\u062D \u0623\u0645\u0627\u0646). \u0648\u0625\u0644\u0627 \u0641\u062A\u0642\u0648\u0644 \u0627\u0644\u0634\u0627\u0631\u0629 \u0627\u0644\u0628\u0631\u062A\u0642\u0627\u0644\u064A\u0629 \xAB\u063A\u064A\u0631 \u0645\u0641\u0639\u0651\u0644\xBB."
              },
              off: {
                term: "\u063A\u064A\u0631 \u0645\u0641\u0639\u0651\u0644",
                text: "\u064A\u0639\u062A\u0645\u062F \u062A\u0633\u062C\u064A\u0644 \u062F\u062E\u0648\u0644\u0643 \u0639\u0644\u0649 \u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631 \u0648\u062D\u062F\u0647\u0627. \u0648\u064A\u0642\u062A\u0631\u062D \u0646\u0635 \u0625\u0636\u0627\u0641\u0629 \u0631\u0645\u0632 \u0645\u0646 \u0633\u062A\u0629 \u0623\u0631\u0642\u0627\u0645 \u064A\u0642\u062F\u0651\u0645\u0647 \u062A\u0637\u0628\u064A\u0642 \u0645\u0635\u0627\u062F\u0642\u0629 \u0639\u0644\u0649 \u0647\u0627\u062A\u0641\u0643."
              },
              setUp: {
                term: "\u062A\u0641\u0639\u064A\u0644 \u0627\u0644\u062A\u062D\u0642\u0642 \u0628\u062E\u0637\u0648\u062A\u064A\u0646",
                text: "\u0644\u0627 \u064A\u0638\u0647\u0631 \u0625\u0644\u0627 \u0625\u0630\u0627 \u0644\u0645 \u064A\u0643\u0646 \u0645\u0641\u0639\u0651\u0644\u064B\u0627. \u064A\u0642\u0648\u062F\u0643 \u0625\u0644\u0649 \u0625\u0639\u062F\u0627\u062F\u0627\u062A \u062D\u0633\u0627\u0628\u0643 \u0644\u0625\u0639\u062F\u0627\u062F \u062A\u0637\u0628\u064A\u0642 \u0627\u0644\u0645\u0635\u0627\u062F\u0642\u0629\u060C \u062B\u0645 \u062A\u0639\u0648\u062F \u0625\u0644\u0649 \u0647\u0630\u0647 \u0627\u0644\u0635\u0641\u062D\u0629 \u0628\u0639\u062F \u062A\u0633\u062C\u064A\u0644 \u062F\u062E\u0648\u0644 \u062C\u062F\u064A\u062F."
              }
            }
          },
          account: {
            title: "\u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631 \u0648\u062A\u0637\u0628\u064A\u0642 \u0627\u0644\u0645\u0635\u0627\u062F\u0642\u0629",
            items: {
              about: {
                term: "\u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631 \u0648\u062A\u0637\u0628\u064A\u0642 \u0627\u0644\u0645\u0635\u0627\u062F\u0642\u0629",
                text: "\u064A\u0634\u0631\u062D \u0647\u0630\u0627 \u0627\u0644\u0642\u0633\u0645 \u0623\u0646\u0643 \u062A\u063A\u064A\u0651\u0631 \u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631 \u0648\u062A\u0636\u064A\u0641 \u062A\u0637\u0628\u064A\u0642 \u0627\u0644\u0645\u0635\u0627\u062F\u0642\u0629 \u0623\u0648 \u062A\u0632\u064A\u0644\u0647 \u0648\u062A\u062F\u064A\u0631 \u0645\u0641\u0627\u062A\u064A\u062D \u0627\u0644\u0623\u0645\u0627\u0646 \u0645\u0646 \u0625\u0639\u062F\u0627\u062F\u0627\u062A \u062D\u0633\u0627\u0628\u0643 \u0641\u064A \u2066BatiFlow\u2069. \u0648\u0644\u0627 \u064A\u0638\u0647\u0631 \u0625\u0644\u0627 \u0625\u0630\u0627 \u062A\u0648\u0641\u0631 \u0639\u0646\u0648\u0627\u0646 \u0644\u0625\u0639\u062F\u0627\u062F\u0627\u062A \u0627\u0644\u062D\u0633\u0627\u0628."
              },
              open: {
                term: "\u0641\u062A\u062D \u0625\u0639\u062F\u0627\u062F\u0627\u062A \u0627\u0644\u062D\u0633\u0627\u0628",
                text: "\u064A\u0641\u062A\u062D \u0625\u0639\u062F\u0627\u062F\u0627\u062A \u062D\u0633\u0627\u0628\u0643 \u0641\u064A \u2066BatiFlow\u2069 \u0641\u064A \u0627\u0644\u0639\u0644\u0627\u0645\u0629 \u0646\u0641\u0633\u0647\u0627."
              }
            }
          },
          sessions: {
            title: "\u0627\u0644\u062C\u0644\u0633\u0627\u062A \u0627\u0644\u0646\u0634\u0637\u0629",
            items: {
              device: {
                term: "\u062C\u0647\u0627\u0632 \u063A\u064A\u0631 \u0645\u0639\u0631\u0648\u0641",
                text: "\u0643\u0644 \u0633\u0637\u0631 \u062C\u0647\u0627\u0632 \u0645\u0633\u062C\u0651\u0644 \u0627\u0644\u062F\u062E\u0648\u0644 \u0645\u0639 \u0627\u0633\u0645\u0647 (\u0623\u064A\u0642\u0648\u0646\u0629 \u0647\u0627\u062A\u0641 \u0623\u0648 \u062D\u0627\u0633\u0648\u0628). \u0648\u062A\u0638\u0647\u0631 \xAB\u062C\u0647\u0627\u0632 \u063A\u064A\u0631 \u0645\u0639\u0631\u0648\u0641\xBB \u0639\u0646\u062F\u0645\u0627 \u0644\u0627 \u064A\u064F\u0639\u0631\u0641 \u0627\u0633\u0645\u0647. \u0648\u064A\u0623\u062A\u064A \u0627\u0644\u062C\u0647\u0627\u0632 \u0627\u0644\u062D\u0627\u0644\u064A \u0623\u0648\u0644\u064B\u0627."
              },
              thisDevice: {
                term: "\u0647\u0630\u0627 \u0627\u0644\u062C\u0647\u0627\u0632",
                text: "\u0634\u0627\u0631\u0629 \u062A\u0634\u064A\u0631 \u0625\u0644\u0649 \u0627\u0644\u062C\u0647\u0627\u0632 \u0627\u0644\u0630\u064A \u062A\u0633\u062A\u0639\u0645\u0644\u0647 \u0627\u0644\u0622\u0646. \u0648\u0644\u064A\u0633 \u0644\u0647 \u0632\u0631 \u0644\u0625\u0646\u0647\u0627\u0621 \u062C\u0644\u0633\u062A\u0647: \u0644\u0625\u0646\u0647\u0627\u0621 \u0647\u0630\u0647 \u0627\u0644\u062C\u0644\u0633\u0629 \u0627\u0633\u062A\u0639\u0645\u0644 \u0642\u0627\u0626\u0645\u0629 \u062D\u0633\u0627\u0628\u0643."
              },
              flagged: {
                term: "\u062A\u0645 \u0631\u0635\u062F \u062A\u063A\u064A\u064A\u0631",
                text: "\u0634\u0627\u0631\u0629 \u062A\u0646\u0628\u064A\u0647: \u062A\u063A\u064A\u0651\u0631\u062A \u0627\u0644\u0634\u0628\u0643\u0629 \u0623\u0648 \u0627\u0644\u0645\u062A\u0635\u0641\u062D \u0623\u062B\u0646\u0627\u0621 \u0627\u0644\u062C\u0644\u0633\u0629. \u0625\u0646 \u0644\u0645 \u062A\u0643\u0646 \u0623\u0646\u062A \u0645\u0646 \u0641\u0639\u0644 \u0630\u0644\u0643 \u0641\u0623\u0646\u0647\u0650 \u062C\u0644\u0633\u0629 \u0647\u0630\u0627 \u0627\u0644\u062C\u0647\u0627\u0632."
              },
              lastActivity: {
                term: "\u0622\u062E\u0631 \u0646\u0634\u0627\u0637:",
                text: "\u0622\u062E\u0631 \u0645\u0631\u0629 \u0627\u0633\u062A\u064F\u0639\u0645\u0644 \u0641\u064A\u0647\u0627 \u0627\u0644\u062C\u0647\u0627\u0632\u060C \u0628\u0645\u062F\u0629 \u0646\u0633\u0628\u064A\u0629. \u0648\u0628\u062C\u0627\u0646\u0628\u0647\u0627 \xAB\u0627\u0644\u0634\u0628\u0643\u0629:\xBB \u062A\u0639\u0631\u0636 \u0628\u062F\u0627\u064A\u0629 \u0639\u0646\u0648\u0627\u0646 \u0627\u0644\u0634\u0628\u0643\u0629 \u0627\u0644\u0645\u0633\u062A\u0639\u0645\u0644\u0629."
              },
              revoke: {
                term: "\u0625\u0646\u0647\u0627\u0621 \u0627\u0644\u062C\u0644\u0633\u0629",
                text: "\u0639\u0644\u0649 \u062C\u0647\u0627\u0632 \u0622\u062E\u0631: \u0628\u0639\u062F \u0627\u0644\u062A\u0623\u0643\u064A\u062F (\xAB\u0625\u0646\u0647\u0627\u0621 \u0627\u0644\u062C\u0644\u0633\u0629 \u0639\u0644\u0649 \xAB\u2026\xBB\u061F\xBB) \u0633\u064A\u062A\u0639\u064A\u0651\u0646 \u0639\u0644\u0649 \u0647\u0630\u0627 \u0627\u0644\u062C\u0647\u0627\u0632 \u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062F\u062E\u0648\u0644 \u0645\u0646 \u062C\u062F\u064A\u062F \u0644\u0627\u0633\u062A\u0639\u0645\u0627\u0644 \u2066BatiFlow\u2069. \u0648\u0644\u0627 \u062A\u062A\u063A\u064A\u0631 \u0628\u064A\u0627\u0646\u0627\u062A\u0643."
              },
              revokeOthers: {
                term: "\u0625\u0646\u0647\u0627\u0621 \u0627\u0644\u062C\u0644\u0633\u0627\u062A \u0639\u0644\u0649 \u0627\u0644\u0623\u062C\u0647\u0632\u0629 \u0627\u0644\u0623\u062E\u0631\u0649",
                text: "\u0632\u0631 \u0641\u064A \u0623\u0639\u0644\u0649 \u0627\u0644\u0642\u0633\u0645\u060C \u0644\u0627 \u064A\u0638\u0647\u0631 \u0625\u0644\u0627 \u0625\u0630\u0627 \u0643\u0627\u0646\u062A \u0647\u0646\u0627\u0643 \u0623\u062C\u0647\u0632\u0629 \u0623\u062E\u0631\u0649 \u0645\u0633\u062C\u0651\u0644\u0629 \u0627\u0644\u062F\u062E\u0648\u0644. \u0628\u0639\u062F \u0627\u0644\u062A\u0623\u0643\u064A\u062F \u062A\u064F\u0646\u0647\u0649 \u0627\u0644\u062C\u0644\u0633\u0627\u062A \u0639\u0644\u0649 \u0643\u0644 \u0627\u0644\u0623\u062C\u0647\u0632\u0629 \u0627\u0644\u0623\u062E\u0631\u0649 \u0648\u064A\u0628\u0642\u0649 \u0647\u0630\u0627 \u0627\u0644\u062C\u0647\u0627\u0632 \u0645\u0633\u062C\u0651\u0644 \u0627\u0644\u062F\u062E\u0648\u0644."
              },
              noOthers: {
                term: "\u0644\u0627 \u064A\u0648\u062C\u062F \u0623\u064A \u062C\u0647\u0627\u0632 \u0622\u062E\u0631 \u0645\u0633\u062C\u0651\u0644 \u0627\u0644\u062F\u062E\u0648\u0644.",
                text: "\u0631\u0633\u0627\u0644\u0629 \u062A\u0638\u0647\u0631 \u062A\u062D\u062A \u0627\u0644\u0642\u0627\u0626\u0645\u0629 \u0639\u0646\u062F\u0645\u0627 \u062A\u0643\u0648\u0646 \u0645\u0633\u062C\u0651\u0644 \u0627\u0644\u062F\u062E\u0648\u0644 \u0639\u0644\u0649 \u062C\u0647\u0627\u0632 \u0648\u0627\u062D\u062F \u0641\u0642\u0637. \u0648\u0625\u0646 \u0644\u0645 \u062A\u0643\u0646 \u0647\u0646\u0627\u0643 \u062C\u0644\u0633\u0629 \u0644\u0639\u0631\u0636\u0647\u0627 \u062A\u0638\u0647\u0631 \xAB\u0644\u0627 \u062A\u0648\u062C\u062F \u062C\u0644\u0633\u0627\u062A \u0646\u0634\u0637\u0629 \u0644\u0639\u0631\u0636\u0647\u0627.\xBB."
              },
              loadFailed: {
                term: "\u062A\u0639\u0630\u0651\u0631 \u0639\u0631\u0636 \u062C\u0644\u0633\u0627\u062A\u0643",
                text: "\u0631\u0633\u0627\u0644\u0629 \u062E\u0637\u0623 \u0645\u0639 \u0632\u0631 \xAB\u0625\u0639\u0627\u062F\u0629 \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629\xBB \u0639\u0646\u062F\u0645\u0627 \u0644\u0627 \u062A\u064F\u062D\u0645\u064E\u0651\u0644 \u0627\u0644\u0642\u0627\u0626\u0645\u0629. \u0648\u0628\u064A\u0627\u0646\u0627\u062A\u0643 \u0628\u0623\u0645\u0627\u0646."
              }
            }
          }
        }
      },
      notifications: {
        title: "\u0625\u0634\u0639\u0627\u0631\u0627\u062A\u064A",
        intro: "\u062A\u062A\u064A\u062D \u0644\u0643 \u0647\u0630\u0647 \u0627\u0644\u0635\u0641\u062D\u0629 \u0627\u062E\u062A\u064A\u0627\u0631 \u0627\u0644\u0625\u0634\u0639\u0627\u0631\u0627\u062A \u0627\u0644\u062A\u064A \u062A\u062A\u0644\u0642\u0627\u0647\u0627 \u0648\u0623\u064A\u0646: \u062F\u0627\u062E\u0644 \u0627\u0644\u062A\u0637\u0628\u064A\u0642 \u0623\u0648 \u0628\u0627\u0644\u0628\u0631\u064A\u062F \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A. \u0643\u0645\u0627 \u062A\u0636\u0628\u0637 \u0645\u0644\u062E\u0635 \u0627\u0644\u0628\u0631\u064A\u062F \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A \u0648\u0627\u0644\u0633\u0627\u0639\u0627\u062A \u0627\u0644\u062A\u064A \u0644\u0627 \u062A\u0631\u064A\u062F \u0623\u0646 \u062A\u064F\u0632\u0639\u062C \u0641\u064A\u0647\u0627.",
        sections: {
          header: {
            title: "\u0639\u0644\u0627\u0645\u0627\u062A \u0627\u0644\u062A\u0628\u0648\u064A\u0628 \u0648\u0627\u0644\u062A\u062D\u0645\u064A\u0644",
            items: {
              tabs: {
                term: "\u0627\u0644\u0645\u0644\u0641 \u0627\u0644\u0634\u062E\u0635\u064A\u060C \u0627\u0644\u0623\u0645\u0627\u0646\u060C \u0627\u0644\u0625\u0634\u0639\u0627\u0631\u0627\u062A",
                text: "\u062B\u0644\u0627\u062B \u0639\u0644\u0627\u0645\u0627\u062A \u062A\u0628\u0648\u064A\u0628 \u0641\u064A \u0623\u0639\u0644\u0649 \u0635\u0641\u062D\u0627\u062A \u062D\u0633\u0627\u0628\u0643: \u0627\u0644\u0645\u0644\u0641 \u0627\u0644\u0634\u062E\u0635\u064A \u0648\u0627\u0644\u0623\u0645\u0627\u0646 \u0648\u0627\u0644\u0625\u0634\u0639\u0627\u0631\u0627\u062A. \u0627\u0636\u063A\u0637 \u0639\u0644\u0649 \u0625\u062D\u062F\u0627\u0647\u0627 \u0644\u0644\u0627\u0646\u062A\u0642\u0627\u0644 \u0645\u0646 \u0635\u0641\u062D\u0629 \u0625\u0644\u0649 \u0623\u062E\u0631\u0649."
              },
              loadFailed: {
                term: "\u062A\u0639\u0630\u0651\u0631 \u0639\u0631\u0636 \u062A\u0641\u0636\u064A\u0644\u0627\u062A\u0643",
                text: "\u0631\u0633\u0627\u0644\u0629 \u062E\u0637\u0623 \u0645\u0639 \u0632\u0631 \xAB\u0625\u0639\u0627\u062F\u0629 \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629\xBB \u0639\u0646\u062F\u0645\u0627 \u0644\u0627 \u062A\u064F\u062D\u0645\u064E\u0651\u0644 \u062A\u0641\u0636\u064A\u0644\u0627\u062A\u0643."
              }
            }
          },
          matrix: {
            title: "\u0645\u0627\u0630\u0627\u060C \u0648\u0623\u064A\u0646",
            items: {
              notification: {
                term: "\u0627\u0644\u0625\u0634\u0639\u0627\u0631",
                text: "\u0633\u0637\u0631 \u0644\u0643\u0644 \u0646\u0648\u0639 \u0645\u0646 \u0627\u0644\u0625\u0634\u0639\u0627\u0631\u0627\u062A\u060C \u0645\u062B\u0644 \xAB\u062A\u062A\u0645 \u0627\u0644\u0625\u0634\u0627\u0631\u0629 \u0625\u0644\u064A\u0643\xBB \u0623\u0648 \xAB\u0625\u0633\u0646\u0627\u062F \u0645\u0647\u0645\u0629 \u0625\u0644\u064A\u0643\xBB \u0623\u0648 \xAB\u0627\u0633\u062A\u0644\u0627\u0645 \u062F\u0641\u0639\u0629\xBB. \u0648\u062A\u064F\u062C\u0645\u064E\u0651\u0639 \u0627\u0644\u0623\u0633\u0637\u0631 \u062D\u0633\u0628 \u0627\u0644\u0645\u0648\u0636\u0648\u0639."
              },
              groups: {
                term: "\u0627\u0644\u0645\u062D\u0627\u062F\u062B\u0627\u062A\u060C \u0627\u0644\u0645\u0647\u0627\u0645\u060C \u0627\u0644\u062A\u0623\u0634\u064A\u0631\u0627\u062A \u0648\u0627\u0644\u0645\u0648\u0627\u0641\u0642\u0627\u062A\u060C \u0627\u0644\u062A\u0642\u0648\u064A\u0645\u060C \u0627\u0644\u0634\u0631\u0643\u0627\u0621 \u0648\u0627\u0644\u0641\u0636\u0627\u0621\u0627\u062A \u0627\u0644\u062E\u0627\u0631\u062C\u064A\u0629\u060C \u0627\u0644\u0623\u0645\u0627\u0646\u060C \u0627\u0644\u0641\u0648\u062A\u0631\u0629 \u0648\u0627\u0644\u0627\u0634\u062A\u0631\u0627\u0643",
                text: "\u0639\u0646\u0627\u0648\u064A\u0646 \u0627\u0644\u0645\u062C\u0645\u0648\u0639\u0627\u062A \u0627\u0644\u062A\u064A \u062A\u0641\u0635\u0644 \u0628\u064A\u0646 \u0623\u0633\u0637\u0631 \u0627\u0644\u062C\u062F\u0648\u0644."
              },
              inApp: {
                term: "\u062F\u0627\u062E\u0644 \u0627\u0644\u062A\u0637\u0628\u064A\u0642",
                text: "\u062E\u0627\u0646\u0629 \u062A\u062D\u062F\u064A\u062F: \u064A\u0638\u0647\u0631 \u0627\u0644\u0625\u0634\u0639\u0627\u0631 \u062F\u0627\u062E\u0644 \u0627\u0644\u062A\u0637\u0628\u064A\u0642. \u0648\u0628\u0627\u0644\u0646\u0633\u0628\u0629 \u0625\u0644\u0649 \u0628\u0639\u0636 \u062A\u0646\u0628\u064A\u0647\u0627\u062A \u0627\u0644\u0623\u0645\u0627\u0646 \u0627\u0644\u0645\u0647\u0645\u0629 \u062A\u0643\u0648\u0646 \u0627\u0644\u062E\u0627\u0646\u0629 \u0645\u062D\u062F\u062F\u0629 \u0648\u0645\u0642\u0641\u0644\u0629 (\xAB\u064A\u0638\u0644 \u0647\u0630\u0627 \u0627\u0644\u062A\u0646\u0628\u064A\u0647 \u0627\u0644\u0645\u0647\u0645 \u0645\u0641\u0639\u0651\u0644\u064B\u0627 \u062F\u0627\u0626\u0645\u064B\u0627 \u062F\u0627\u062E\u0644 \u0627\u0644\u062A\u0637\u0628\u064A\u0642.\xBB)."
              },
              email: {
                term: "\u0628\u0627\u0644\u0628\u0631\u064A\u062F \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A",
                text: "\u0642\u0627\u0626\u0645\u0629: \u0623\u0628\u062F\u064B\u0627 \u0623\u0648 \u0641\u0648\u0631\u064B\u0627 (\u0631\u0633\u0627\u0644\u0629 \u0628\u0631\u064A\u062F \u0644\u0643\u0644 \u0625\u0634\u0639\u0627\u0631) \u0623\u0648 \u0636\u0645\u0646 \u0627\u0644\u0645\u0644\u062E\u0635 (\u0645\u062C\u0645\u0651\u0639\u0629 \u0645\u0639 \u063A\u064A\u0631\u0647\u0627 \u0641\u064A \u0631\u0633\u0627\u0644\u0629 \u0648\u0627\u062D\u062F\u0629)."
              },
              push: {
                term: "\u0625\u0634\u0639\u0627\u0631 \u0641\u0648\u0631\u064A (\u2066Push\u2069)",
                text: "\u062E\u0627\u0646\u0629 \u0645\u0639\u062A\u0651\u0645\u0629 \u062D\u0627\u0644\u064A\u064B\u0627: \u064A\u062A\u0648\u0641\u0631 \u0647\u0630\u0627 \u0627\u0644\u062E\u064A\u0627\u0631 \u0645\u0639 \u062A\u0637\u0628\u064A\u0642 \u0627\u0644\u0647\u0627\u062A\u0641 (\xAB\u062A\u0637\u0628\u064A\u0642 \u0627\u0644\u0647\u0627\u062A\u0641\u060C \u0642\u0631\u064A\u0628\u064B\u0627\xBB)."
              },
              scroll: {
                term: "\u062C\u062F\u0648\u0644 \u062A\u0641\u0636\u064A\u0644\u0627\u062A \u0627\u0644\u0625\u0634\u0639\u0627\u0631\u0627\u062A",
                text: "\u0639\u0644\u0649 \u0627\u0644\u0634\u0627\u0634\u0629 \u0627\u0644\u0635\u063A\u064A\u0631\u0629 \u064A\u064F\u0645\u0631\u064E\u0651\u0631 \u0627\u0644\u062C\u062F\u0648\u0644 \u062C\u0627\u0646\u0628\u064A\u064B\u0627. \u0648\u0644\u0643\u0644 \u062E\u0627\u0646\u0629 \u0623\u0648 \u0642\u0627\u0626\u0645\u0629 \u0627\u0633\u0645 \u0643\u0627\u0645\u0644 \u0639\u0644\u0649 \u0634\u0643\u0644 \xAB\u0627\u0644\u0646\u0648\u0639: \u0627\u0644\u0642\u0646\u0627\u0629\xBB \u0644\u0642\u0627\u0631\u0626\u0627\u062A \u0627\u0644\u0634\u0627\u0634\u0629."
              }
            }
          },
          digest: {
            title: "\u0645\u0644\u062E\u0635 \u0627\u0644\u0628\u0631\u064A\u062F \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A",
            items: {
              frequency: {
                term: "\u0648\u062A\u064A\u0631\u0629 \u0627\u0644\u0645\u0644\u062E\u0635",
                text: "\u0628\u062F\u0648\u0646 \u0645\u0644\u062E\u0635 \u0623\u0648 \u0643\u0644 \u0633\u0627\u0639\u0629 \u0623\u0648 \u0643\u0644 \u064A\u0648\u0645. \u064A\u062C\u0645\u0639 \u0627\u0644\u0645\u0644\u062E\u0635 \u0627\u0644\u0625\u0634\u0639\u0627\u0631\u0627\u062A \u0627\u0644\u0645\u0636\u0628\u0648\u0637\u0629 \u0639\u0644\u0649 \xAB\u0636\u0645\u0646 \u0627\u0644\u0645\u0644\u062E\u0635\xBB \u0641\u064A \u0631\u0633\u0627\u0644\u0629 \u0628\u0631\u064A\u062F \u0648\u0627\u062D\u062F\u0629\u060C \u0648\u0644\u0627 \u064A\u064F\u0631\u0633\u0644 \u0625\u0644\u0627 \u0625\u0630\u0627 \u0627\u062E\u062A\u0631\u062A \u0648\u062A\u064A\u0631\u0629 \u0644\u0647."
              },
              warning: {
                term: "\u0627\u0644\u0645\u0644\u062E\u0635 \u0645\u0639\u0637\u0651\u0644",
                text: "\u0631\u0633\u0627\u0644\u0629 \u062A\u062D\u0630\u064A\u0631 \u0639\u0646\u062F\u0645\u0627 \u062A\u0643\u0648\u0646 \u0628\u0639\u0636 \u0627\u0644\u0625\u0634\u0639\u0627\u0631\u0627\u062A \u0645\u0636\u0628\u0648\u0637\u0629 \u0639\u0644\u0649 \xAB\u0636\u0645\u0646 \u0627\u0644\u0645\u0644\u062E\u0635\xBB \u0628\u064A\u0646\u0645\u0627 \u0644\u0627 \u064A\u064F\u0631\u0633\u0644 \u0623\u064A \u0645\u0644\u062E\u0635: \u0633\u062A\u0628\u0642\u0649 \u062F\u0627\u062E\u0644 \u0627\u0644\u062A\u0637\u0628\u064A\u0642 \u0641\u0642\u0637. \u0627\u062E\u062A\u0631 \u0648\u062A\u064A\u0631\u0629 \u0644\u062A\u0644\u0642\u064A\u0647\u0627 \u0628\u0627\u0644\u0628\u0631\u064A\u062F \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A."
              }
            }
          },
          quietHours: {
            title: "\u0633\u0627\u0639\u0627\u062A \u0627\u0644\u0647\u062F\u0648\u0621",
            items: {
              enable: {
                term: "\u062A\u0641\u0639\u064A\u0644 \u0633\u0627\u0639\u0627\u062A \u0627\u0644\u0647\u062F\u0648\u0621",
                text: "\u0645\u0641\u062A\u0627\u062D \u062A\u0634\u063A\u064A\u0644. \u062E\u0644\u0627\u0644 \u0647\u0630\u0647 \u0627\u0644\u0633\u0627\u0639\u0627\u062A \u0644\u0627 \u062A\u0635\u0644\u0643 \u0631\u0633\u0627\u0626\u0644 \u0627\u0644\u0625\u0634\u0639\u0627\u0631\u0627\u062A \u0628\u0627\u0644\u0628\u0631\u064A\u062F \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A \u0648\u062A\u0635\u0644\u0643 \u0628\u0639\u062F\u0647\u0627. \u0627\u0644\u0633\u0627\u0639\u0627\u062A \u0648\u0641\u0642 \u0645\u0646\u0637\u0642\u062A\u0643 \u0627\u0644\u0632\u0645\u0646\u064A\u0629. \u0648\u0639\u0646\u062F \u0627\u0644\u062A\u0641\u0639\u064A\u0644 \u062A\u064F\u0642\u062A\u0631\u062D \u0627\u0644\u0641\u062A\u0631\u0629 \u0645\u0646 22:00 \u0625\u0644\u0649 07:00."
              },
              start: {
                term: "\u0627\u0644\u0628\u062F\u0627\u064A\u0629",
                text: "\u0627\u0644\u0648\u0642\u062A \u0627\u0644\u0630\u064A \u062A\u0628\u062F\u0623 \u0641\u064A\u0647 \u0633\u0627\u0639\u0627\u062A \u0627\u0644\u0647\u062F\u0648\u0621. \u0644\u0627 \u064A\u0638\u0647\u0631 \u0625\u0644\u0627 \u0639\u0646\u062F \u062A\u0641\u0639\u064A\u0644\u0647\u0627."
              },
              end: {
                term: "\u0627\u0644\u0646\u0647\u0627\u064A\u0629",
                text: "\u0627\u0644\u0648\u0642\u062A \u0627\u0644\u0630\u064A \u062A\u0646\u062A\u0647\u064A \u0641\u064A\u0647. \u0648\u064A\u062C\u0628 \u0623\u0646 \u062A\u0643\u0648\u0646 \u0627\u0644\u0628\u062F\u0627\u064A\u0629 \u0648\u0627\u0644\u0646\u0647\u0627\u064A\u0629 \u0648\u0642\u062A\u064A\u0646 \u0645\u062E\u062A\u0644\u0641\u064A\u0646 \u0648\u0625\u0644\u0627 \u062A\u0646\u0628\u0651\u0647 \u0631\u0633\u0627\u0644\u0629 \u0625\u0644\u0649 \u0630\u0644\u0643."
              }
            }
          },
          actions: {
            title: "\u0627\u0644\u062D\u0641\u0638 \u0648\u0627\u0644\u0627\u0633\u062A\u0639\u0627\u062F\u0629",
            items: {
              save: {
                term: "\u062D\u0641\u0638",
                text: "\u064A\u062D\u0641\u0638 \u0645\u062C\u0645\u0648\u0639 \u062A\u0641\u0636\u064A\u0644\u0627\u062A\u0643. \u0648\u0625\u0646 \u0644\u0645 \u064A\u0643\u0646 \u0647\u0646\u0627\u0643 \u062C\u062F\u064A\u062F \u062A\u0638\u0647\u0631 \xAB\u0644\u0627 \u064A\u0648\u062C\u062F \u0645\u0627 \u064A\u064F\u062D\u0641\u0638\xBB. \u0648\u0625\u0646 \u062A\u063A\u064A\u0651\u0631\u062A \u062A\u0641\u0636\u064A\u0644\u0627\u062A\u0643 \u0645\u0646 \u0645\u0643\u0627\u0646 \u0622\u062E\u0631 \u0641\u064A \u0627\u0644\u0623\u062B\u0646\u0627\u0621 \u0641\u0644\u0627 \u062A\u064F\u062D\u0641\u0638 \u062A\u063A\u064A\u064A\u0631\u0627\u062A\u0643 \u0648\u064A\u064F\u0639\u0627\u062F \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u062A\u0641\u0636\u064A\u0644\u0627\u062A \u0627\u0644\u062D\u0627\u0644\u064A\u0629."
              },
              reset: {
                term: "\u0627\u0633\u062A\u0639\u0627\u062F\u0629 \u0627\u0644\u0642\u064A\u0645 \u0627\u0644\u0627\u0641\u062A\u0631\u0627\u0636\u064A\u0629",
                text: "\u064A\u0645\u0644\u0623 \u0627\u0644\u0646\u0645\u0648\u0630\u062C \u0628\u0627\u0644\u0642\u064A\u0645 \u0627\u0644\u062A\u064A \u064A\u0642\u062A\u0631\u062D\u0647\u0627 \u2066BatiFlow\u2069. \u0648\u0644\u0627 \u064A\u062A\u063A\u064A\u0651\u0631 \u0634\u064A\u0621 \u062D\u062A\u0649 \u062A\u0636\u063A\u0637 \xAB\u062D\u0641\u0638\xBB."
              },
              failure: {
                term: "\u062A\u0639\u0630\u0651\u0631 \u062D\u0641\u0638 \u0627\u0644\u062A\u0641\u0636\u064A\u0644\u0627\u062A",
                text: "\u0631\u0633\u0627\u0644\u0629 \u062E\u0637\u0623 \u0648\u0627\u0636\u062D\u0629 \u0641\u0648\u0642 \u0627\u0644\u0623\u0632\u0631\u0627\u0631 \u0639\u0646\u062F\u0645\u0627 \u064A\u0641\u0634\u0644 \u0627\u0644\u062D\u0641\u0638. \u0648\u062A\u0628\u0642\u0649 \u0627\u062E\u062A\u064A\u0627\u0631\u0627\u062A\u0643 \u0639\u0644\u0649 \u0627\u0644\u0634\u0627\u0634\u0629."
              }
            }
          }
        }
      }
    },
    finance: {
      quotes: {
        title: "\u0627\u0644\u0639\u0631\u0648\u0636 \u0627\u0644\u0645\u0627\u0644\u064A\u0629",
        intro: "\u0642\u0627\u0626\u0645\u0629 \u0643\u0644 \u0627\u0644\u0639\u0631\u0648\u0636 \u0627\u0644\u0645\u0627\u0644\u064A\u0629 (\u0645\u0642\u062A\u0631\u062D\u0627\u062A \u0627\u0644\u0623\u062A\u0639\u0627\u0628 \u0627\u0644\u0645\u0631\u0633\u0644\u0629 \u0625\u0644\u0649 \u062D\u0631\u0641\u0627\u0626\u0643) \u0627\u0644\u062E\u0627\u0635\u0629 \u0628\u0645\u0643\u062A\u0628\u0643 \u0645\u0639 \u062D\u0627\u0644\u0629 \u0643\u0644 \u0639\u0631\u0636. \u062A\u0633\u062A\u0639\u0645\u0644\u0647\u0627 \u0644\u0644\u0639\u062B\u0648\u0631 \u0639\u0644\u0649 \u0639\u0631\u0636 \u0648\u0645\u062A\u0627\u0628\u0639\u062A\u0647 \u0625\u0644\u0649 \u062D\u064A\u0646 \u0642\u0628\u0648\u0644\u0647 \u0648\u0625\u0646\u0634\u0627\u0621 \u0639\u0631\u0636 \u062C\u062F\u064A\u062F.",
        sections: {
          header: {
            title: "\u0631\u0623\u0633 \u0627\u0644\u0635\u0641\u062D\u0629",
            items: {
              subNav: {
                term: "\u0627\u0644\u0645\u0627\u0644\u064A\u0629",
                text: "\u062A\u0639\u0631\u0636 \u0627\u0644\u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u064A\u0645\u0646\u0649 \u0623\u0642\u0633\u0627\u0645 \u0627\u0644\u0645\u0627\u0644\u064A\u0629: \u0627\u0644\u0639\u0631\u0648\u0636 \u0627\u0644\u0645\u0627\u0644\u064A\u0629 \u0648\u0627\u0644\u0639\u0642\u0648\u062F \u0648\u0627\u0644\u0641\u0648\u0627\u062A\u064A\u0631 \u0648\u0627\u0644\u062F\u0641\u0648\u0639\u0627\u062A \u0648\u0645\u0630\u0643\u0631\u0627\u062A \u0627\u0644\u0645\u0635\u0627\u0631\u064A\u0641 \u0648\u0644\u0648\u062D\u0629 \u0627\u0644\u0642\u064A\u0627\u062F\u0629 \u0648\u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629 \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A\u0629. \u0644\u0627 \u062A\u0631\u0649 \u0625\u0644\u0627 \u0627\u0644\u0623\u0642\u0633\u0627\u0645 \u0627\u0644\u062A\u064A \u062A\u0633\u0645\u062D \u0644\u0643 \u0635\u0644\u0627\u062D\u064A\u0627\u062A\u0643 \u0628\u0641\u062A\u062D\u0647\u0627\u060C \u0648\u0639\u0644\u0649 \u0627\u0644\u0634\u0627\u0634\u0629 \u0627\u0644\u0635\u063A\u064A\u0631\u0629 \u062A\u062A\u062D\u0648\u0644 \u0625\u0644\u0649 \u0635\u0641 \u0645\u0646 \u0627\u0644\u0631\u0648\u0627\u0628\u0637 \u0641\u0648\u0642 \u0627\u0644\u0635\u0641\u062D\u0629."
              },
              newQuote: {
                term: "\u0639\u0631\u0636 \u0645\u0627\u0644\u064A \u062C\u062F\u064A\u062F",
                text: "\u064A\u0641\u062A\u062D \u0639\u0631\u0636\u064B\u0627 \u0645\u0627\u0644\u064A\u064B\u0627 \u0641\u0627\u0631\u063A\u064B\u0627 \u0644\u062A\u0639\u0628\u0626\u062A\u0647. \u0644\u0627 \u064A\u0638\u0647\u0631 \u0647\u0630\u0627 \u0627\u0644\u0632\u0631 \u0625\u0644\u0627 \u0625\u0630\u0627 \u0643\u0646\u062A \u062A\u0645\u0644\u0643 \u0635\u0644\u0627\u062D\u064A\u0629 \u0625\u0646\u0634\u0627\u0621 \u0627\u0644\u0639\u0631\u0648\u0636 \u0627\u0644\u0645\u0627\u0644\u064A\u0629\u060C \u0648\u064A\u0643\u0648\u0646 \u0645\u0639\u0637\u0651\u0644\u064B\u0627 \u0625\u0630\u0627 \u0643\u0627\u0646 \u062D\u0633\u0627\u0628 \u0627\u0644\u0645\u0643\u062A\u0628 \u0644\u0644\u0627\u0637\u0644\u0627\u0639 \u0641\u0642\u0637 (\u062A\u0634\u0631\u062D \u0630\u0644\u0643 \u0646\u0627\u0641\u0630\u0629 \u062A\u0644\u0645\u064A\u062D)."
              }
            }
          },
          filters: {
            title: "\u062A\u0635\u0641\u064A\u0629 \u0627\u0644\u0639\u0631\u0648\u0636 \u0627\u0644\u0645\u0627\u0644\u064A\u0629",
            items: {
              status: {
                term: "\u0627\u0644\u062D\u0627\u0644\u0629",
                text: "\u0642\u0627\u0626\u0645\u0629 \u0645\u0646\u0633\u062F\u0644\u0629 \u0644\u0639\u0631\u0636 \u0627\u0644\u0639\u0631\u0648\u0636 \u0630\u0627\u062A \u062D\u0627\u0644\u0629 \u0648\u0627\u062D\u062F\u0629 \u0641\u0642\u0637: \u0645\u0633\u0648\u062F\u0629 \u0623\u0648 \u0645\u064F\u0631\u0633\u064E\u0644 \u0623\u0648 \u0645\u0642\u0628\u0648\u0644 \u0623\u0648 \u0645\u0631\u0641\u0648\u0636 \u0623\u0648 \u0645\u0646\u062A\u0647\u064A \u0627\u0644\u0635\u0644\u0627\u062D\u064A\u0629. \u062E\u064A\u0627\u0631 \xAB\u0643\u0644 \u0627\u0644\u062D\u0627\u0644\u0627\u062A\xBB \u064A\u0639\u0631\u0636 \u0627\u0644\u062C\u0645\u064A\u0639."
              },
              clear: {
                term: "\u0645\u0633\u062D \u0627\u0644\u062A\u0635\u0641\u064A\u0629",
                text: "\u064A\u0638\u0647\u0631 \u0639\u0646\u062F\u0645\u0627 \u0644\u0627 \u064A\u0637\u0627\u0628\u0642 \u0623\u064A \u0639\u0631\u0636 \u0627\u0644\u062D\u0627\u0644\u0629 \u0627\u0644\u0645\u062E\u062A\u0627\u0631\u0629\u060C \u0648\u064A\u0639\u064A\u062F \u062E\u064A\u0627\u0631 \xAB\u0643\u0644 \u0627\u0644\u062D\u0627\u0644\u0627\u062A\xBB."
              }
            }
          },
          table: {
            title: "\u0627\u0644\u0639\u0631\u0648\u0636 \u0627\u0644\u0645\u0627\u0644\u064A\u0629",
            items: {
              number: {
                term: "\u0627\u0644\u0631\u0642\u0645",
                text: "\u0631\u0642\u0645 \u0627\u0644\u0639\u0631\u0636 \u0627\u0644\u0645\u0627\u0644\u064A. \u0627\u0646\u0642\u0631 \u0639\u0644\u064A\u0647 \u0644\u0641\u062A\u062D \u0627\u0644\u0639\u0631\u0636."
              },
              title: {
                term: "\u0627\u0644\u0645\u0648\u0636\u0648\u0639",
                text: "\u0645\u0627 \u064A\u0642\u062A\u0631\u062D\u0647 \u0627\u0644\u0639\u0631\u0636\u060C \u0645\u062B\u0644 \xAB\u0645\u0647\u0645\u0629 \u0625\u0634\u0631\u0627\u0641 \u0648\u062A\u0635\u0645\u064A\u0645\u060C \u0641\u064A\u0644\u0627 \u0645\u0646 \u0637\u0627\u0628\u0642\u064A\u0646\xBB."
              },
              client: {
                term: "\u0627\u0644\u062D\u0631\u064A\u0641",
                text: "\u0627\u0644\u062D\u0631\u064A\u0641 (\u0635\u0627\u062D\u0628 \u0627\u0644\u0645\u0634\u0631\u0648\u0639) \u0627\u0644\u0630\u064A \u064A\u0648\u062C\u064E\u0651\u0647 \u0625\u0644\u064A\u0647 \u0627\u0644\u0639\u0631\u0636 \u0627\u0644\u0645\u0627\u0644\u064A."
              },
              status: {
                term: "\u0627\u0644\u062D\u0627\u0644\u0629",
                text: "\u0648\u0636\u0639 \u0627\u0644\u0639\u0631\u0636 \u0645\u0643\u062A\u0648\u0628\u064B\u0627 \u0628\u0627\u0644\u062D\u0631\u0648\u0641 \u0648\u0645\u0635\u062D\u0648\u0628\u064B\u0627 \u0628\u0644\u0648\u0646 (\u0627\u0646\u0638\u0631 \xAB\u062D\u0627\u0644\u0627\u062A \u0627\u0644\u0639\u0631\u0636 \u0627\u0644\u0645\u0627\u0644\u064A\xBB)."
              }
            }
          },
          amounts: {
            title: "\u0627\u0644\u0645\u0628\u0627\u0644\u063A \u0648\u0627\u0644\u062A\u0648\u0627\u0631\u064A\u062E",
            items: {
              totalHt: {
                term: "\u0627\u0644\u0645\u062C\u0645\u0648\u0639 \u062F\u0648\u0646 \u0627\u062D\u062A\u0633\u0627\u0628 \u0627\u0644\u0623\u062F\u0627\u0621\u0627\u062A",
                text: "\u0645\u0628\u0644\u063A \u0627\u0644\u0639\u0631\u0636 \u0642\u0628\u0644 \u0627\u0644\u0623\u062F\u0627\u0621\u0627\u062A (\u062F\u0648\u0646 \u0627\u0644\u0623\u062F\u0627\u0621 \u0639\u0644\u0649 \u0627\u0644\u0642\u064A\u0645\u0629 \u0627\u0644\u0645\u0636\u0627\u0641\u0629 \u0648\u0628\u0642\u064A\u0629 \u0627\u0644\u0623\u062F\u0627\u0621\u0627\u062A)."
              },
              totalTtc: {
                term: "\u0627\u0644\u0645\u062C\u0645\u0648\u0639 \u0628\u0627\u062D\u062A\u0633\u0627\u0628 \u0643\u0644 \u0627\u0644\u0623\u062F\u0627\u0621\u0627\u062A",
                text: "\u0627\u0644\u0645\u0628\u0644\u063A \u0628\u0639\u062F \u0627\u062D\u062A\u0633\u0627\u0628 \u0643\u0644 \u0627\u0644\u0623\u062F\u0627\u0621\u0627\u062A. \u064A\u0638\u0647\u0631 \xAB\u2014\xBB \u0645\u0627 \u062F\u0627\u0645 \u0627\u0644\u0645\u062C\u0645\u0648\u0639 \u063A\u064A\u0631 \u0645\u062D\u062A\u0633\u0628."
              },
              validUntil: {
                term: "\u0635\u0627\u0644\u062D \u0625\u0644\u0649 \u063A\u0627\u064A\u0629",
                text: "\u0622\u062E\u0631 \u062A\u0627\u0631\u064A\u062E \u064A\u0645\u0643\u0646 \u0641\u064A\u0647 \u0644\u0644\u062D\u0631\u064A\u0641 \u0623\u0646 \u064A\u0642\u0628\u0644 \u0627\u0644\u0639\u0631\u0636."
              },
              sentAt: {
                term: "\u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0625\u0631\u0633\u0627\u0644",
                text: "\u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0625\u0631\u0633\u0627\u0644 \u0625\u0644\u0649 \u0627\u0644\u062D\u0631\u064A\u0641\u060C \u0648\xAB\u2014\xBB \u0625\u0630\u0627 \u0644\u0645 \u064A\u064F\u0631\u0633\u064E\u0644 \u0627\u0644\u0639\u0631\u0636."
              },
              acceptedAt: {
                term: "\u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0642\u0628\u0648\u0644",
                text: "\u062A\u0627\u0631\u064A\u062E \u0642\u0628\u0648\u0644 \u0627\u0644\u062D\u0631\u064A\u0641\u060C \u0648\xAB\u2014\xBB \u0625\u0630\u0627 \u0644\u0645 \u064A\u0642\u0628\u0644 \u0628\u0639\u062F."
              }
            }
          },
          statuses: {
            title: "\u062D\u0627\u0644\u0627\u062A \u0627\u0644\u0639\u0631\u0636 \u0627\u0644\u0645\u0627\u0644\u064A",
            items: {
              draft: {
                term: "\u0645\u0633\u0648\u062F\u0629",
                text: "\u0627\u0644\u0639\u0631\u0636 \u0642\u064A\u062F \u0627\u0644\u0625\u0639\u062F\u0627\u062F \u0648\u0644\u0645 \u064A\u064F\u0631\u0633\u064E\u0644: \u064A\u0645\u0643\u0646\u0643 \u062A\u0639\u062F\u064A\u0644\u0647 \u0623\u0648 \u062D\u0630\u0641\u0647."
              },
              sent: {
                term: "\u0645\u064F\u0631\u0633\u064E\u0644",
                text: "\u0623\u064F\u0631\u0633\u0644 \u0627\u0644\u0639\u0631\u0636 \u0625\u0644\u0649 \u0627\u0644\u062D\u0631\u064A\u0641 \u0639\u0628\u0631 \u0631\u0627\u0628\u0637 \u0622\u0645\u0646 \u0648\u0647\u0648 \u0641\u064A \u0627\u0646\u062A\u0638\u0627\u0631 \u0631\u062F\u0647."
              },
              accepted: {
                term: "\u0645\u0642\u0628\u0648\u0644",
                text: "\u0642\u0628\u0644 \u0627\u0644\u062D\u0631\u064A\u0641 \u0627\u0644\u0639\u0631\u0636\u061B \u0648\u064A\u0645\u0643\u0646\u0643 \u062A\u062D\u0648\u064A\u0644\u0647 \u0625\u0644\u0649 \u0645\u0634\u0631\u0648\u0639 \u0648\u0639\u0642\u062F."
              },
              rejected: {
                term: "\u0645\u0631\u0641\u0648\u0636",
                text: "\u0633\u064F\u062C\u0651\u0644 \u0627\u0644\u0639\u0631\u0636 \u0639\u0644\u0649 \u0623\u0646\u0647 \u0645\u0631\u0641\u0648\u0636 \u0645\u0646 \u0627\u0644\u062D\u0631\u064A\u0641."
              },
              expired: {
                term: "\u0645\u0646\u062A\u0647\u064A \u0627\u0644\u0635\u0644\u0627\u062D\u064A\u0629",
                text: "\u0627\u0646\u0642\u0636\u0649 \u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0635\u0644\u0627\u062D\u064A\u0629 \u062F\u0648\u0646 \u0623\u0646 \u064A\u0642\u0628\u0644 \u0627\u0644\u062D\u0631\u064A\u0641."
              }
            }
          },
          empty: {
            title: "\u0627\u0644\u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u0641\u0627\u0631\u063A\u0629 \u0648\u0627\u0644\u0623\u062E\u0637\u0627\u0621 \u0648\u0627\u0644\u062A\u062D\u0645\u064A\u0644",
            items: {
              none: {
                term: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0639\u0631\u0648\u0636 \u0645\u0627\u0644\u064A\u0629 \u0628\u0639\u062F",
                text: "\u0631\u0633\u0627\u0644\u0629 \u0627\u0644\u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u0641\u0627\u0631\u063A\u0629. \u0625\u0646 \u0643\u0646\u062A \u062A\u0645\u0644\u0643 \u0635\u0644\u0627\u062D\u064A\u0629 \u0627\u0644\u0625\u0646\u0634\u0627\u0621 \u0641\u0647\u064A \u062A\u0642\u062A\u0631\u062D \xAB\u0639\u0631\u0636 \u0645\u0627\u0644\u064A \u062C\u062F\u064A\u062F\xBB\u060C \u0648\u0625\u0644\u0627 \u0641\u0647\u064A \u062A\u0630\u0643\u0631 \u0623\u0646 \u0627\u0644\u0639\u0631\u0648\u0636 \u0627\u0644\u0645\u0627\u0644\u064A\u0629 \u0627\u0644\u062E\u0627\u0635\u0629 \u0628\u0645\u0643\u062A\u0628\u0643 \u0633\u062A\u0638\u0647\u0631 \u0647\u0646\u0627."
              },
              noMatch: {
                term: "\u0644\u0627 \u064A\u0648\u062C\u062F \u0639\u0631\u0636 \u0645\u0637\u0627\u0628\u0642",
                text: "\u0631\u0633\u0627\u0644\u0629 \u062A\u0638\u0647\u0631 \u0639\u0646\u062F\u0645\u0627 \u0644\u0627 \u062A\u062C\u062F \u0627\u0644\u062A\u0635\u0641\u064A\u0629 \u0634\u064A\u0626\u064B\u0627\u061B \u0648\u0632\u0631 \xAB\u0645\u0633\u062D \u0627\u0644\u062A\u0635\u0641\u064A\u0629\xBB \u064A\u0632\u064A\u0644\u0647\u0627."
              },
              loadMore: {
                term: "\u0639\u0631\u0636 \u0627\u0644\u0645\u0632\u064A\u062F \u0645\u0646 \u0627\u0644\u0639\u0631\u0648\u0636",
                text: "\u064A\u0648\u062C\u062F \u062A\u062D\u062A \u0627\u0644\u0642\u0627\u0626\u0645\u0629 \u0639\u0646\u062F\u0645\u0627 \u062A\u0643\u062B\u0631 \u0627\u0644\u0639\u0631\u0648\u0636: \u064A\u062D\u0645\u0651\u0644 \u0627\u0644\u0639\u0631\u0648\u0636 \u0627\u0644\u062A\u0627\u0644\u064A\u0629."
              },
              loadError: {
                term: "\u062A\u0639\u0630\u0651\u0631 \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0639\u0631\u0648\u0636 \u0627\u0644\u0645\u0627\u0644\u064A\u0629",
                text: "\u0631\u0633\u0627\u0644\u0629 \u062E\u0637\u0623 \u0639\u0646\u062F \u0648\u062C\u0648\u062F \u0645\u0634\u0643\u0644 \u0641\u064A \u0627\u0644\u0627\u062A\u0635\u0627\u0644\u061B \u0648\u0632\u0631 \xAB\u0625\u0639\u0627\u062F\u0629 \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629\xBB \u064A\u0639\u064A\u062F \u0627\u0644\u062A\u062D\u0645\u064A\u0644."
              }
            }
          }
        }
      },
      quote: {
        title: "\u0627\u0644\u0639\u0631\u0636 \u0627\u0644\u0645\u0627\u0644\u064A (\u062C\u062F\u064A\u062F \u0623\u0648 \u0645\u0648\u062C\u0648\u062F)",
        intro: "\u0634\u0627\u0634\u0629 \u0639\u0631\u0636 \u0645\u0627\u0644\u064A \u0648\u0627\u062D\u062F: \u062A\u064F\u0639\u062F\u0651 \u0641\u064A\u0647\u0627 \u0627\u0644\u0645\u0639\u0644\u0648\u0645\u0627\u062A \u0648\u0627\u0644\u0623\u062A\u0639\u0627\u0628 \u0648\u0627\u0644\u0628\u0646\u0648\u062F \u0648\u062A\u0631\u0649 \u0627\u0644\u0645\u062C\u0627\u0645\u064A\u0639 \u062A\u064F\u062D\u062A\u0633\u0628 \u0645\u0628\u0627\u0634\u0631\u0629\u060C \u062B\u0645 \u062A\u0631\u0633\u0644 \u0627\u0644\u0639\u0631\u0636 \u0625\u0644\u0649 \u0627\u0644\u062D\u0631\u064A\u0641. \u064A\u0633\u062A\u0639\u0645\u0644\u0647\u0627 \u0645\u0646 \u064A\u0645\u0644\u0643\u0648\u0646 \u0635\u0644\u0627\u062D\u064A\u0629 \u0625\u0646\u0634\u0627\u0621 \u0627\u0644\u0639\u0631\u0648\u0636 \u0627\u0644\u0645\u0627\u0644\u064A\u0629.",
        sections: {
          header: {
            title: "\u0627\u0644\u0631\u0623\u0633 \u0648\u0627\u0644\u0631\u0633\u0627\u0626\u0644",
            items: {
              subNav: {
                term: "\u0627\u0644\u0645\u0627\u0644\u064A\u0629",
                text: "\u062A\u062A\u064A\u062D \u0644\u0643 \u0627\u0644\u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u064A\u0645\u0646\u0649 \u0627\u0644\u0627\u0646\u062A\u0642\u0627\u0644 \u0625\u0644\u0649 \u0642\u0633\u0645 \u0622\u062E\u0631 \u0645\u0646 \u0627\u0644\u0645\u0627\u0644\u064A\u0629 (\u0627\u0644\u0639\u0631\u0648\u0636 \u0627\u0644\u0645\u0627\u0644\u064A\u0629 \u0648\u0627\u0644\u0639\u0642\u0648\u062F \u0648\u0627\u0644\u0641\u0648\u0627\u062A\u064A\u0631\u2026) \u0628\u062D\u0633\u0628 \u0635\u0644\u0627\u062D\u064A\u0627\u062A\u0643."
              },
              breadcrumb: {
                term: "\u0627\u0644\u0639\u0631\u0648\u0636 \u0627\u0644\u0645\u0627\u0644\u064A\u0629",
                text: "\u0627\u0644\u0631\u0627\u0628\u0637 \u0641\u064A \u0623\u0639\u0644\u0649 \u0627\u0644\u0635\u0641\u062D\u0629 \u064A\u0639\u064A\u062F\u0643 \u0625\u0644\u0649 \u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u0639\u0631\u0648\u0636. \u0648\u0625\u0630\u0627 \u0628\u0642\u064A\u062A \u062A\u0639\u062F\u064A\u0644\u0627\u062A \u063A\u064A\u0631 \u0645\u062D\u0641\u0648\u0638\u0629 \u062A\u0637\u0644\u0628 \u0645\u0646\u0643 \u0646\u0627\u0641\u0630\u0629 \u0627\u0644\u062A\u0623\u0643\u064A\u062F."
              },
              save: {
                term: "\u062D\u0641\u0638",
                text: "\u064A\u062D\u0641\u0638 \u0627\u0644\u0639\u0631\u0636 \u0627\u0644\u0645\u0627\u0644\u064A\u061B \u0648\u0627\u0644\u062D\u0641\u0638 \u0627\u0644\u0623\u0648\u0644 \u064A\u0646\u0634\u0626\u0647 \u0648\u064A\u0645\u0646\u062D\u0647 \u0631\u0642\u0645\u0647. \u0644\u0627 \u064A\u0638\u0647\u0631 \u0625\u0644\u0627 \u0625\u0630\u0627 \u0643\u0646\u062A \u062A\u0633\u062A\u0637\u064A\u0639 \u062A\u0639\u062F\u064A\u0644 \u0647\u0630\u0627 \u0627\u0644\u0639\u0631\u0636."
              },
              notices: {
                term: "\u0634\u0631\u0627\u0626\u0637 \u0627\u0644\u0645\u0639\u0644\u0648\u0645\u0627\u062A",
                text: "\u0641\u0648\u0642 \u0627\u0644\u0646\u0645\u0648\u0630\u062C \u064A\u0634\u0631\u062D \u0634\u0631\u064A\u0637 \u0627\u0644\u0648\u0636\u0639\u064A\u0629: \u0639\u0631\u0636 \u0644\u0644\u0627\u0637\u0644\u0627\u0639 \u0641\u0642\u0637 (\u0628\u0633\u0628\u0628 \u0627\u0644\u0635\u0644\u0627\u062D\u064A\u0627\u062A \u0623\u0648 \u0627\u0644\u062D\u0627\u0644\u0629)\u060C \u0623\u0648 \u0639\u0631\u0636 \u0645\u064F\u0631\u0633\u064E\u0644 \u062A\u0639\u064A\u062F\u0647 \u0625\u0644\u0649 \u0627\u0644\u062A\u0639\u062F\u064A\u0644\u060C \u0623\u0648 \xAB\u0642\u0627\u0645 \u0634\u062E\u0635 \u0622\u062E\u0631 \u0628\u062A\u0639\u062F\u064A\u0644 \u0647\u0630\u0627 \u0627\u0644\u0639\u0631\u0636 \u0627\u0644\u0645\u0627\u0644\u064A\xBB \u0645\u0639 \u0632\u0631 \xAB\u0625\u0639\u0627\u062F\u0629 \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0639\u0631\u0636 \u0627\u0644\u0645\u0627\u0644\u064A\xBB."
              },
              saveFirst: {
                term: "\u0627\u062D\u0641\u0638 \u062A\u0639\u062F\u064A\u0644\u0627\u062A\u0643 \u0623\u0648\u0644\u064B\u0627 \u0644\u0627\u0633\u062A\u0639\u0645\u0627\u0644 \u0647\u0630\u0647 \u0627\u0644\u0625\u062C\u0631\u0627\u0621\u0627\u062A.",
                text: "\u0639\u0628\u0627\u0631\u0629 \u062A\u0638\u0647\u0631 \u0639\u0646\u062F\u0645\u0627 \u064A\u062D\u062A\u0648\u064A \u0627\u0644\u0646\u0645\u0648\u0630\u062C \u0639\u0644\u0649 \u062A\u0639\u062F\u064A\u0644\u0627\u062A \u063A\u064A\u0631 \u0645\u062D\u0641\u0648\u0638\u0629: \u062A\u0646\u062A\u0638\u0631 \u0623\u0632\u0631\u0627\u0631 \u0627\u0644\u0625\u062C\u0631\u0627\u0621\u0627\u062A \u0627\u0644\u062D\u0641\u0638."
              }
            }
          },
          actions: {
            title: "\u0625\u062C\u0631\u0627\u0621\u0627\u062A \u0627\u0644\u0639\u0631\u0636 \u0627\u0644\u0645\u0627\u0644\u064A",
            items: {
              pdf: {
                term: "\u0639\u0631\u0636 \u0645\u0644\u0641 \u2066PDF\u2069",
                text: "\u064A\u0641\u062A\u062D \u0627\u0644\u0639\u0631\u0636 \u0628\u0635\u064A\u063A\u0629 \u2066PDF\u2069 \u0641\u064A \u062A\u0628\u0648\u064A\u0628 \u062C\u062F\u064A\u062F. \u0648\u0625\u0646 \u0643\u0627\u0646 \u0627\u0644\u0645\u0644\u0641 \u0642\u064A\u062F \u0627\u0644\u0625\u0639\u062F\u0627\u062F \u062A\u062F\u0639\u0648\u0643 \u0631\u0633\u0627\u0644\u0629 \u0625\u0644\u0649 \u0625\u0639\u0627\u062F\u0629 \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629 \u0628\u0639\u062F \u0644\u062D\u0638\u0627\u062A."
              },
              send: {
                term: "\u0625\u0631\u0633\u0627\u0644 / \u0625\u0639\u0627\u062F\u0629 \u0627\u0644\u0625\u0631\u0633\u0627\u0644",
                text: "\u064A\u0631\u0633\u0644 \u0627\u0644\u0639\u0631\u0636 \u0625\u0644\u0649 \u0627\u0644\u062D\u0631\u064A\u0641 \u0628\u0627\u0644\u0628\u0631\u064A\u062F \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A \u0645\u0639 \u0631\u0627\u0628\u0637 \u0622\u0645\u0646\u061B \u0648\u064A\u0635\u0628\u062D \u0627\u0644\u0632\u0631 \xAB\u0625\u0639\u0627\u062F\u0629 \u0627\u0644\u0625\u0631\u0633\u0627\u0644\xBB \u0625\u0630\u0627 \u0633\u0628\u0642 \u0625\u0631\u0633\u0627\u0644 \u0627\u0644\u0639\u0631\u0636. \u0645\u062E\u0635\u0635 \u0644\u0645\u0646 \u064A\u0645\u0644\u0643\u0648\u0646 \u0635\u0644\u0627\u062D\u064A\u0629 \u0627\u0644\u0625\u0631\u0633\u0627\u0644."
              },
              reject: {
                term: "\u0631\u0641\u0636\u0647 \u0627\u0644\u062D\u0631\u064A\u0641",
                text: "\u064A\u0633\u062C\u0644 \u0639\u0631\u0636\u064B\u0627 \u0645\u064F\u0631\u0633\u064E\u0644\u064B\u0627 \u0639\u0644\u0649 \u0623\u0646\u0647 \u0645\u0631\u0641\u0648\u0636: \u0644\u0627 \u064A\u0633\u0645\u062D \u0631\u0627\u0628\u0637 \u0627\u0644\u062D\u0631\u064A\u0641 \u0628\u0642\u0628\u0648\u0644\u0647 \u0628\u0639\u062F \u0630\u0644\u0643. \u064A\u064F\u0637\u0644\u0628 \u0645\u0646\u0643 \u0627\u0644\u062A\u0623\u0643\u064A\u062F."
              },
              edit: {
                term: "\u062A\u0639\u062F\u064A\u0644 \u0627\u0644\u0639\u0631\u0636 \u0627\u0644\u0645\u0627\u0644\u064A",
                text: "\u0644\u0639\u0631\u0636 \u0645\u064F\u0631\u0633\u064E\u0644: \u064A\u0639\u064A\u062F\u0647 \u0625\u0644\u0649 \u0645\u0633\u0648\u062F\u0629 \u0644\u062A\u0635\u062D\u064A\u062D\u0647. \u064A\u062A\u0648\u0642\u0641 \u0627\u0644\u0631\u0627\u0628\u0637 \u0627\u0644\u0645\u0631\u0633\u0644 \u0639\u0646 \u0627\u0644\u0639\u0645\u0644 \u0648\u0633\u062A\u062D\u062A\u0627\u062C \u0625\u0644\u0649 \u0625\u0639\u0627\u062F\u0629 \u0625\u0631\u0633\u0627\u0644 \u0627\u0644\u0639\u0631\u0636."
              },
              convert: {
                term: "\u0625\u0646\u0634\u0627\u0621 \u0627\u0644\u0645\u0634\u0631\u0648\u0639",
                text: "\u0641\u064A \u0639\u0631\u0636 \u0645\u0642\u0628\u0648\u0644 \u062F\u0648\u0646 \u0645\u0634\u0631\u0648\u0639: \u064A\u0646\u0634\u0626 \u0627\u0644\u0645\u0634\u0631\u0648\u0639 \u0628\u062D\u0631\u064A\u0641 \u0627\u0644\u0639\u0631\u0636 \u0648\u0623\u062A\u0639\u0627\u0628\u0647. \u062A\u062D\u062A\u0627\u062C \u0623\u064A\u0636\u064B\u0627 \u0625\u0644\u0649 \u0635\u0644\u0627\u062D\u064A\u0629 \u0625\u0646\u0634\u0627\u0621 \u0627\u0644\u0645\u0634\u0627\u0631\u064A\u0639."
              },
              openProject: {
                term: "\u0641\u062A\u062D \u0627\u0644\u0645\u0634\u0631\u0648\u0639",
                text: "\u0641\u064A \u0639\u0631\u0636 \u0645\u0642\u0628\u0648\u0644 \u0645\u0631\u062A\u0628\u0637 \u0628\u0645\u0634\u0631\u0648\u0639: \u064A\u0641\u062A\u062D \u0647\u0630\u0627 \u0627\u0644\u0645\u0634\u0631\u0648\u0639."
              },
              createContract: {
                term: "\u0625\u0646\u0634\u0627\u0621 \u0627\u0644\u0639\u0642\u062F",
                text: "\u0641\u064A \u0639\u0631\u0636 \u0645\u0642\u0628\u0648\u0644: \u064A\u0646\u0634\u0626 \u0627\u0644\u0639\u0642\u062F \u0627\u0646\u0637\u0644\u0627\u0642\u064B\u0627 \u0645\u0646 \u0627\u0644\u0639\u0631\u0636 \u0648\u064A\u0641\u062A\u062D\u0647. \u0645\u062E\u0635\u0635 \u0644\u0645\u0646 \u064A\u062F\u064A\u0631\u0648\u0646 \u0627\u0644\u0639\u0642\u0648\u062F."
              },
              delete: {
                term: "\u062D\u0630\u0641 \u0627\u0644\u0645\u0633\u0648\u062F\u0629",
                text: "\u064A\u062D\u0630\u0641 \u0646\u0647\u0627\u0626\u064A\u064B\u0627 \u0645\u0633\u0648\u062F\u0629 \u0644\u0645 \u062A\u064F\u0631\u0633\u064E\u0644 \u0642\u0637\u060C \u0628\u0639\u062F \u0627\u0644\u062A\u0623\u0643\u064A\u062F."
              }
            }
          },
          general: {
            title: "\u0645\u0639\u0644\u0648\u0645\u0627\u062A \u0639\u0627\u0645\u0629",
            items: {
              client: {
                term: "\u0627\u0644\u062D\u0631\u064A\u0641",
                text: "\u0625\u062C\u0628\u0627\u0631\u064A: \u0635\u0627\u062D\u0628 \u0627\u0644\u0645\u0634\u0631\u0648\u0639 \u0627\u0644\u0630\u064A \u064A\u0648\u062C\u064E\u0651\u0647 \u0625\u0644\u064A\u0647 \u0627\u0644\u0639\u0631\u0636. \u062A\u063A\u064A\u064A\u0631 \u0627\u0644\u062D\u0631\u064A\u0641 \u064A\u0641\u0631\u063A \u0627\u0644\u0645\u0634\u0631\u0648\u0639 \u0627\u0644\u0645\u062E\u062A\u0627\u0631."
              },
              project: {
                term: "\u0627\u0644\u0645\u0634\u0631\u0648\u0639",
                text: "\u0627\u062E\u062A\u064A\u0627\u0631\u064A: \u0645\u0634\u0631\u0648\u0639 \u0645\u0646 \u0645\u0634\u0627\u0631\u064A\u0639 \u0627\u0644\u062D\u0631\u064A\u0641 \u0627\u0644\u0645\u062E\u062A\u0627\u0631\u060C \u0623\u0648 \xAB\u0628\u0644\u0627 \u0645\u0634\u0631\u0648\u0639 (\u062D\u0627\u0644\u064A\u064B\u0627)\xBB\u061B \u0648\u064A\u0645\u0643\u0646\u0643 \u0625\u0646\u0634\u0627\u0621 \u0627\u0644\u0645\u0634\u0631\u0648\u0639 \u0645\u0646 \u0627\u0644\u0639\u0631\u0636 \u0627\u0644\u0645\u0642\u0628\u0648\u0644."
              },
              title: {
                term: "\u0645\u0648\u0636\u0648\u0639 \u0627\u0644\u0639\u0631\u0636 \u0627\u0644\u0645\u0627\u0644\u064A",
                text: "\u0625\u062C\u0628\u0627\u0631\u064A: \u062C\u0645\u0644\u0629 \u0642\u0635\u064A\u0631\u0629 \u062A\u0642\u0648\u0644 \u0645\u0627 \u064A\u0642\u062A\u0631\u062D\u0647 \u0627\u0644\u0639\u0631\u0636\u060C \u0645\u062B\u0644 \xAB\u0645\u0647\u0645\u0629 \u0625\u0634\u0631\u0627\u0641 \u0648\u062A\u0635\u0645\u064A\u0645\u060C \u0641\u064A\u0644\u0627 \u0645\u0646 \u0637\u0627\u0628\u0642\u064A\u0646\xBB."
              },
              language: {
                term: "\u0644\u063A\u0629 \u0645\u0644\u0641 \u2066PDF\u2069",
                text: "\u0644\u063A\u0629 \u0627\u0644\u0648\u062B\u064A\u0642\u0629 \u0627\u0644\u0645\u0631\u0633\u0644\u0629 \u0625\u0644\u0649 \u0627\u0644\u062D\u0631\u064A\u0641: \u0627\u0644\u0641\u0631\u0646\u0633\u064A\u0629 \u0623\u0648 \u0627\u0644\u0639\u0631\u0628\u064A\u0629 \u0623\u0648 \u062B\u0646\u0627\u0626\u064A \u0627\u0644\u0644\u063A\u0629 (\u0627\u0644\u0641\u0631\u0646\u0633\u064A\u0629 \u0648\u0627\u0644\u0639\u0631\u0628\u064A\u0629)."
              },
              validUntil: {
                term: "\u0635\u0627\u0644\u062D \u0625\u0644\u0649 \u063A\u0627\u064A\u0629",
                text: "\u0625\u062C\u0628\u0627\u0631\u064A: \u0628\u0639\u062F \u0647\u0630\u0627 \u0627\u0644\u062A\u0627\u0631\u064A\u062E \u0644\u0627 \u064A\u0645\u0643\u0646 \u0644\u0644\u062D\u0631\u064A\u0641 \u0642\u0628\u0648\u0644 \u0627\u0644\u0639\u0631\u0636. \u064A\u064F\u0631\u0641\u0636 \u062A\u0627\u0631\u064A\u062E \u0633\u0628\u0642 \u0623\u0646 \u0645\u0636\u0649."
              },
              currency: {
                term: "\u0627\u0644\u0639\u0645\u0644\u0629",
                text: "\u0639\u0645\u0644\u0629 \u0627\u0644\u0639\u0631\u0636: \u2066TND\u2069 \u0623\u0648 \u2066EUR\u2069 \u0623\u0648 \u2066USD\u2069."
              },
              exchangeRate: {
                term: "\u0633\u0639\u0631 \u0627\u0644\u0635\u0631\u0641 (\u0628\u0627\u0644\u062F\u064A\u0646\u0627\u0631 \u0644\u0643\u0644 \u0648\u062D\u062F\u0629)",
                text: "\u064A\u0638\u0647\u0631 \u0644\u0639\u0645\u0644\u0629 \u063A\u064A\u0631 \u0627\u0644\u062F\u064A\u0646\u0627\u0631: \u0643\u0645 \u062F\u064A\u0646\u0627\u0631\u064B\u0627 \u062A\u0633\u0627\u0648\u064A \u0648\u062D\u062F\u0629 \u0648\u0627\u062D\u062F\u0629\u060C \u0645\u062B\u0644 3.350 \u0644\u0643\u0644 1 \u064A\u0648\u0631\u0648. \u0648\u062A\u064F\u0639\u0637\u0649 \u0627\u0644\u0645\u062C\u0627\u0645\u064A\u0639 \u062D\u064A\u0646\u0626\u0630 \u0628\u0627\u0644\u062F\u064A\u0646\u0627\u0631 \u0623\u064A\u0636\u064B\u0627."
              }
            }
          },
          calculator: {
            title: "\u0627\u062D\u062A\u0633\u0627\u0628 \u0627\u0644\u0623\u062A\u0639\u0627\u0628",
            items: {
              feeMode: {
                term: "\u0637\u0631\u064A\u0642\u0629 \u0627\u0644\u0627\u062D\u062A\u0633\u0627\u0628",
                text: "\u0643\u064A\u0641 \u062A\u062D\u062A\u0633\u0628 \u0623\u062A\u0639\u0627\u0628\u0643: \u0645\u0628\u0644\u063A \u062C\u0632\u0627\u0641\u064A \u0645\u0648\u0632\u064E\u0651\u0639 \u062D\u0633\u0628 \u0627\u0644\u0645\u0631\u0627\u062D\u0644\u060C \u0623\u0648 \u0646\u0633\u0628\u0629 \u0645\u0646 \u0643\u0644\u0641\u0629 \u0627\u0644\u0623\u0634\u063A\u0627\u0644\u060C \u0623\u0648 \u062D\u0633\u0628 \u0627\u0644\u0648\u0642\u062A \u0627\u0644\u0645\u0633\u062A\u063A\u0631\u064E\u0642\u060C \u0623\u0648 \u0645\u062E\u062A\u0644\u0637 (\u0628\u0646\u0648\u062F \u062A\u064F\u062F\u062E\u064E\u0644 \u064A\u062F\u0648\u064A\u064B\u0627)."
              },
              lumpTotal: {
                term: "\u0627\u0644\u0623\u062A\u0639\u0627\u0628 \u0627\u0644\u062C\u0632\u0627\u0641\u064A\u0629 \u062F\u0648\u0646 \u0627\u062D\u062A\u0633\u0627\u0628 \u0627\u0644\u0623\u062F\u0627\u0621\u0627\u062A",
                text: "\u0641\u064A \u0627\u0644\u0637\u0631\u064A\u0642\u0629 \u0627\u0644\u062C\u0632\u0627\u0641\u064A\u0629: \u0627\u0644\u0645\u0628\u0644\u063A \u0627\u0644\u062C\u0645\u0644\u064A \u0644\u0623\u062A\u0639\u0627\u0628\u0643 \u0642\u0628\u0644 \u0627\u0644\u0623\u062F\u0627\u0621\u0627\u062A."
              },
              worksCost: {
                term: "\u0627\u0644\u0643\u0644\u0641\u0629 \u0627\u0644\u062A\u0642\u062F\u064A\u0631\u064A\u0629 \u0644\u0644\u0623\u0634\u063A\u0627\u0644 \u062F\u0648\u0646 \u0627\u062D\u062A\u0633\u0627\u0628 \u0627\u0644\u0623\u062F\u0627\u0621\u0627\u062A",
                text: "\u0641\u064A \u0637\u0631\u064A\u0642\u0629 \u0627\u0644\u0646\u0633\u0628\u0629: \u0627\u0644\u0643\u0644\u0641\u0629 \u0627\u0644\u062A\u0642\u062F\u064A\u0631\u064A\u0629 \u0644\u0644\u0623\u0634\u063A\u0627\u0644 \u0642\u0628\u0644 \u0627\u0644\u0623\u062F\u0627\u0621\u0627\u062A. \u0648\u064A\u0639\u0631\u0636 \u0633\u0637\u0631 \xAB\u0627\u0644\u0623\u062A\u0639\u0627\u0628 \u0627\u0644\u0645\u062D\u062A\u0633\u0628\u0629 \u062F\u0648\u0646 \u0627\u062D\u062A\u0633\u0627\u0628 \u0627\u0644\u0623\u062F\u0627\u0621\u0627\u062A\xBB \u0627\u0644\u0646\u062A\u064A\u062C\u0629."
              },
              rate: {
                term: "\u0646\u0633\u0628\u0629 \u0627\u0644\u0623\u062A\u0639\u0627\u0628 (%)",
                text: "\u0641\u064A \u0637\u0631\u064A\u0642\u0629 \u0627\u0644\u0646\u0633\u0628\u0629: \u0627\u0644\u0646\u0633\u0628\u0629 \u0627\u0644\u0645\u0637\u0628\u0642\u0629 \u0639\u0644\u0649 \u0643\u0644\u0641\u0629 \u0627\u0644\u0623\u0634\u063A\u0627\u0644\u060C \u0645\u062B\u0644 6 \u0623\u0648 4.5. \u0628\u064A\u0646 0 \u0648100."
              },
              scale: {
                term: "\u062C\u062F\u0648\u0644 \u0645\u0631\u062C\u0639\u064A",
                text: "\u0627\u062E\u062A\u064A\u0627\u0631\u064A: \u064A\u0639\u0637\u064A \u0627\u0644\u062C\u062F\u0648\u0644 (\u0645\u062B\u0644 \u0627\u0644\u0623\u0645\u0631 \u0639\u062F\u062F 78-71 \u0623\u0648 \u062C\u062F\u0648\u0644 \u0645\u0643\u062A\u0628\u0643) \u0627\u0642\u062A\u0631\u0627\u062D\u064B\u0627 \u0645\u0639 \u0645\u0635\u062F\u0631\u0647. \u0644\u0627 \u064A\u064F\u0637\u0628\u064E\u0651\u0642 \u0625\u0644\u0627 \u0625\u0630\u0627 \u0646\u0642\u0631\u062A \u0639\u0644\u0649 \xAB\u0627\u0639\u062A\u0645\u0627\u062F \u0647\u0630\u0627 \u0627\u0644\u0627\u0642\u062A\u0631\u0627\u062D\xBB\u061B \u0648\u064A\u0646\u0628\u0651\u0647 \u062A\u062D\u0630\u064A\u0631 \u0628\u0633\u064A\u0637 \u0625\u0644\u0649 \u0623\u062A\u0639\u0627\u0628 \u062F\u0648\u0646 \u0627\u0644\u062D\u062F \u0627\u0644\u0623\u062F\u0646\u0649."
              },
              shares: {
                term: "\u0627\u0644\u062A\u0648\u0632\u064A\u0639 \u062D\u0633\u0628 \u0627\u0644\u0645\u0631\u0627\u062D\u0644",
                text: "\u0644\u0644\u0637\u0631\u064A\u0642\u062A\u064A\u0646 \u0627\u0644\u062C\u0632\u0627\u0641\u064A\u0629 \u0648\u0627\u0644\u0646\u0633\u0628\u0629: \u0627\u062E\u062A\u0631 \u0627\u0644\u0645\u0631\u0627\u062D\u0644 \u0648\xAB\u0627\u0644\u062D\u0635\u0629 (%)\xBB \u0644\u0643\u0644 \u0645\u0646\u0647\u0627\u060C \u0648\u064A\u062C\u0628 \u0623\u0646 \u064A\u0628\u0644\u063A \u0645\u062C\u0645\u0648\u0639\u0647\u0627 100%. \xAB\u0625\u0636\u0627\u0641\u0629 \u0645\u0631\u062D\u0644\u0629\xBB \u062A\u0636\u064A\u0641 \u0633\u0637\u0631\u064B\u0627\u060C \u0648\xAB\u0627\u0639\u062A\u0645\u0627\u062F \u062A\u0648\u0632\u064A\u0639 \u0646\u0648\u0639 \u0645\u0647\u0645\u0629\xBB \u064A\u0645\u0644\u0623 \u062D\u0635\u0635\u064B\u0627 \u0623\u0648\u0644\u064A\u0629."
              },
              time: {
                term: "\u0627\u0644\u0648\u0642\u062A \u0627\u0644\u0645\u0633\u062A\u063A\u0631\u064E\u0642",
                text: "\u0641\u064A \u0637\u0631\u064A\u0642\u0629 \u0627\u0644\u0648\u0642\u062A \u0627\u0644\u0645\u0633\u062A\u063A\u0631\u064E\u0642: \u0644\u0643\u0644 \xAB\u0627\u0644\u062A\u062F\u062E\u0644\xBB \u0623\u062F\u062E\u0644 \xAB\u0633\u0627\u0639\u0627\u062A \u0623\u0648 \u0623\u064A\u0627\u0645\xBB \u0648\xAB\u0633\u0639\u0631 \u0627\u0644\u0648\u062D\u062F\u0629 \u062F\u0648\u0646 \u0627\u062D\u062A\u0633\u0627\u0628 \u0627\u0644\u0623\u062F\u0627\u0621\u0627\u062A\xBB. \xAB\u0625\u0636\u0627\u0641\u0629 \u062A\u062F\u062E\u0644\xBB \u062A\u0636\u064A\u0641 \u0633\u0637\u0631\u064B\u0627."
              },
              propose: {
                term: "\u0627\u0642\u062A\u0631\u0627\u062D \u0627\u0644\u0628\u0646\u0648\u062F",
                text: "\u064A\u062D\u0648\u0651\u0644 \u0627\u0644\u0627\u062D\u062A\u0633\u0627\u0628 \u0625\u0644\u0649 \u0628\u0646\u0648\u062F \u0644\u0644\u0639\u0631\u0636 \u064A\u0645\u0643\u0646\u0643 \u062A\u0639\u062F\u064A\u0644\u0647\u0627 \u0628\u0639\u062F \u0630\u0644\u0643. \u0648\u0625\u0646 \u0648\u064F\u062C\u062F\u062A \u0628\u0646\u0648\u062F \u0645\u0646 \u0642\u0628\u0644 \u062A\u0637\u0644\u0628 \u0645\u0646\u0643 \u0646\u0627\u0641\u0630\u0629 \xAB\u0627\u0633\u062A\u0628\u062F\u0627\u0644 \u0627\u0644\u0628\u0646\u0648\u062F \u0627\u0644\u062D\u0627\u0644\u064A\u0629\u061F\xBB \u0627\u0644\u062A\u0623\u0643\u064A\u062F."
              }
            }
          },
          lines: {
            title: "\u0628\u0646\u0648\u062F \u0627\u0644\u0639\u0631\u0636 \u0627\u0644\u0645\u0627\u0644\u064A",
            items: {
              description: {
                term: "\u0627\u0644\u0648\u0635\u0641",
                text: "\u0625\u062C\u0628\u0627\u0631\u064A: \u0645\u0627 \u064A\u0641\u0648\u062A\u0631\u0647 \u0627\u0644\u0628\u0646\u062F\u060C \u0641\u064A \u0628\u0636\u0639 \u0643\u0644\u0645\u0627\u062A."
              },
              phase: {
                term: "\u0627\u0644\u0645\u0631\u062D\u0644\u0629",
                text: "\u064A\u0636\u0639 \u0627\u0644\u0628\u0646\u062F \u0641\u064A \u0645\u0631\u062D\u0644\u0629 \u0645\u0646 \u0627\u0644\u0645\u0647\u0645\u0629\u061B \u0648\xAB\u0628\u0644\u0627 \u0645\u0631\u062D\u0644\u0629\xBB \u062A\u0636\u0639\u0647 \u0636\u0645\u0646 \xAB\u0628\u0646\u0648\u062F \u0623\u062E\u0631\u0649\xBB. \u062A\u064F\u062C\u0645\u064E\u0651\u0639 \u0627\u0644\u0628\u0646\u0648\u062F \u062D\u0633\u0628 \u0627\u0644\u0645\u0631\u062D\u0644\u0629 \u0645\u0639 \u0645\u062C\u0645\u0648\u0639 \u0641\u0631\u0639\u064A \u062F\u0648\u0646 \u0627\u062D\u062A\u0633\u0627\u0628 \u0627\u0644\u0623\u062F\u0627\u0621\u0627\u062A."
              },
              quantity: {
                term: "\u0627\u0644\u0643\u0645\u064A\u0629",
                text: "\u0625\u062C\u0628\u0627\u0631\u064A: \u0639\u062F\u062F \u0645\u0648\u062C\u0628 \u0628\u062B\u0644\u0627\u062B \u062E\u0627\u0646\u0627\u062A \u0639\u0634\u0631\u064A\u0629 \u0639\u0644\u0649 \u0627\u0644\u0623\u0643\u062B\u0631."
              },
              unitPrice: {
                term: "\u0633\u0639\u0631 \u0627\u0644\u0648\u062D\u062F\u0629 \u062F\u0648\u0646 \u0627\u062D\u062A\u0633\u0627\u0628 \u0627\u0644\u0623\u062F\u0627\u0621\u0627\u062A",
                text: "\u0625\u062C\u0628\u0627\u0631\u064A: \u0633\u0639\u0631 \u0648\u062D\u062F\u0629 \u0648\u0627\u062D\u062F\u0629 \u0642\u0628\u0644 \u0627\u0644\u0623\u062F\u0627\u0621\u0627\u062A\u060C \u0628\u0639\u0645\u0644\u0629 \u0627\u0644\u0639\u0631\u0636."
              },
              vat: {
                term: "\u0627\u0644\u0623\u062F\u0627\u0621 \u0639\u0644\u0649 \u0627\u0644\u0642\u064A\u0645\u0629 \u0627\u0644\u0645\u0636\u0627\u0641\u0629",
                text: "\u0646\u0633\u0628\u0629 \u0627\u0644\u0623\u062F\u0627\u0621 \u0639\u0644\u0649 \u0627\u0644\u0642\u064A\u0645\u0629 \u0627\u0644\u0645\u0636\u0627\u0641\u0629 \u0644\u0644\u0628\u0646\u062F\u060C \u062A\u064F\u062E\u062A\u0627\u0631 \u0645\u0646 19% \u064813% \u06487% \u06480%."
              },
              amount: {
                term: "\u0627\u0644\u0645\u0628\u0644\u063A \u062F\u0648\u0646 \u0627\u062D\u062A\u0633\u0627\u0628 \u0627\u0644\u0623\u062F\u0627\u0621\u0627\u062A",
                text: "\u064A\u064F\u062D\u062A\u0633\u0628 \u0644\u0643: \u0627\u0644\u0643\u0645\u064A\u0629 \xD7 \u0633\u0639\u0631 \u0627\u0644\u0648\u062D\u062F\u0629. \u0644\u0627 \u064A\u0645\u0643\u0646\u0643 \u062A\u0639\u062F\u064A\u0644\u0647."
              },
              addRemove: {
                term: "\u0625\u0636\u0627\u0641\u0629 \u0628\u0646\u062F",
                text: "\u064A\u0636\u064A\u0641 \u0628\u0646\u062F\u064B\u0627 \u0641\u0627\u0631\u063A\u064B\u0627\u061B \u0648\xAB\u0625\u0636\u0627\u0641\u0629 \u0628\u0646\u062F \u0625\u0644\u0649 \u0647\u0630\u0647 \u0627\u0644\u0645\u0631\u062D\u0644\u0629\xBB \u062A\u0636\u064A\u0641\u0647 \u062F\u0627\u062E\u0644 \u0627\u0644\u0645\u0631\u062D\u0644\u0629 \u0627\u0644\u0645\u0639\u0646\u064A\u0629. \u0648\u0627\u0644\u0632\u0631 \u0630\u0648 \u0627\u0644\u0623\u064A\u0642\u0648\u0646\u0629 \xAB\u062D\u0630\u0641 \u0627\u0644\u0628\u0646\u062F\xBB \u064A\u0632\u064A\u0644 \u0628\u0646\u062F\u064B\u0627."
              },
              total: {
                term: "\u0645\u062C\u0645\u0648\u0639 \u0627\u0644\u0628\u0646\u0648\u062F \u062F\u0648\u0646 \u0627\u062D\u062A\u0633\u0627\u0628 \u0627\u0644\u0623\u062F\u0627\u0621\u0627\u062A",
                text: "\u0645\u062C\u0645\u0648\u0639 \u0627\u0644\u0628\u0646\u0648\u062F \u0642\u0628\u0644 \u0627\u0644\u0623\u062F\u0627\u0621\u0627\u062A\u060C \u0641\u064A \u0623\u0633\u0641\u0644 \u0627\u0644\u0642\u0633\u0645."
              }
            }
          },
          notesTotals: {
            title: "\u0627\u0644\u0645\u0644\u0627\u062D\u0638\u0627\u062A \u0648\u0627\u0644\u0645\u062C\u0627\u0645\u064A\u0639",
            items: {
              notes: {
                term: "\u0645\u0644\u0627\u062D\u0638\u0627\u062A \u0644\u0644\u062D\u0631\u064A\u0641",
                text: "\u0627\u062E\u062A\u064A\u0627\u0631\u064A: \u0634\u0631\u0648\u0637 \u062E\u0627\u0635\u0629 \u0648\u0641\u0631\u0636\u064A\u0627\u062A \u0648\u0627\u0633\u062A\u062B\u0646\u0627\u0621\u0627\u062A. \u064A\u0631\u0627\u0641\u0642 \u0647\u0630\u0627 \u0627\u0644\u0646\u0635 \u0627\u0644\u0639\u0631\u0636."
              },
              totals: {
                term: "\u0627\u0644\u0645\u062C\u0627\u0645\u064A\u0639",
                text: "\u0625\u0637\u0627\u0631 \u0627\u0644\u0645\u062C\u0627\u0645\u064A\u0639 (\u062F\u0648\u0646 \u0627\u0644\u0623\u062F\u0627\u0621\u0627\u062A \u0648\u0627\u0644\u0623\u062F\u0627\u0621 \u0639\u0644\u0649 \u0627\u0644\u0642\u064A\u0645\u0629 \u0627\u0644\u0645\u0636\u0627\u0641\u0629 \u0648\u0627\u0644\u0637\u0627\u0628\u0639 \u0648\u0627\u0644\u0645\u062C\u0645\u0648\u0639 \u0628\u0627\u062D\u062A\u0633\u0627\u0628 \u0627\u0644\u0623\u062F\u0627\u0621\u0627\u062A \u0648\u0627\u0644\u062E\u0635\u0645 \u0645\u0646 \u0627\u0644\u0645\u0648\u0631\u062F \u0648\u0627\u0644\u0635\u0627\u0641\u064A \u0644\u0644\u062F\u0641\u0639) \u064A\u064F\u062D\u062A\u0633\u0628 \u0645\u0628\u0627\u0634\u0631\u0629. \u0648\u0647\u0648 \u062A\u0642\u062F\u064A\u0631\u064A: \u062A\u0639\u064A\u062F \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629 \u0627\u062D\u062A\u0633\u0627\u0628 \u0627\u0644\u0645\u0628\u0627\u0644\u063A \u0639\u0646\u062F \u0625\u0635\u062F\u0627\u0631\u0647\u0627."
              },
              needInfo: {
                term: "\u0627\u062E\u062A\u0631 \u062D\u0631\u064A\u0641\u064B\u0627 \u0644\u0627\u062D\u062A\u0633\u0627\u0628 \u0627\u0644\u0645\u062C\u0627\u0645\u064A\u0639\u2026",
                text: "\u0628\u062F\u0644 \u0627\u0644\u0625\u0637\u0627\u0631 \u062A\u062E\u0628\u0631\u0643 \u062C\u0645\u0644\u0629 \u0628\u0645\u0627 \u064A\u0646\u0642\u0635: \u062D\u0631\u064A\u0641 \u0623\u0648 \u0633\u0639\u0631 \u0627\u0644\u0635\u0631\u0641 (\u0644\u0639\u0645\u0644\u0629 \u0623\u062C\u0646\u0628\u064A\u0629) \u0623\u0648 \u0628\u0646\u0648\u062F \u0645\u0643\u062A\u0645\u0644\u0629 (\u0627\u0644\u0643\u0645\u064A\u0629 \u0648\u0627\u0644\u0633\u0639\u0631)."
              }
            }
          },
          history: {
            title: "\u0645\u062A\u0627\u0628\u0639\u0629 \u0627\u0644\u0639\u0631\u0636 \u0627\u0644\u0645\u0627\u0644\u064A",
            items: {
              status: {
                term: "\u0627\u0644\u062D\u0627\u0644\u0629",
                text: "\u062D\u0627\u0644\u0629 \u0627\u0644\u0639\u0631\u0636 (\u0645\u0633\u0648\u062F\u0629 \u0623\u0648 \u0645\u064F\u0631\u0633\u064E\u0644 \u0623\u0648 \u0645\u0642\u0628\u0648\u0644 \u0623\u0648 \u0645\u0631\u0641\u0648\u0636 \u0623\u0648 \u0645\u0646\u062A\u0647\u064A \u0627\u0644\u0635\u0644\u0627\u062D\u064A\u0629)\u060C \u0641\u064A \u0623\u0648\u0644 \u0627\u0644\u0642\u0627\u0626\u0645\u0629."
              },
              created: {
                term: "\u0623\u0646\u0634\u0623\u0647 \u2026 \u0628\u062A\u0627\u0631\u064A\u062E \u2026",
                text: "\u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0625\u0646\u0634\u0627\u0621 \u0648\u0645\u0646 \u0623\u0646\u0634\u0623 \u0627\u0644\u0639\u0631\u0636."
              },
              sent: {
                term: "\u0623\u0631\u0633\u0644\u0647 \u2026 \u0628\u062A\u0627\u0631\u064A\u062E \u2026",
                text: "\u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0625\u0631\u0633\u0627\u0644 \u0648\u0645\u0646 \u0623\u0631\u0633\u0644\u0647\u061B \u0648\u0625\u0644\u0627 \xAB\u0644\u0645 \u064A\u064F\u0631\u0633\u064E\u0644 \u0647\u0630\u0627 \u0627\u0644\u0639\u0631\u0636 \u0627\u0644\u0645\u0627\u0644\u064A \u0628\u0639\u062F\xBB."
              },
              linkExpires: {
                term: "\u0631\u0627\u0628\u0637 \u0627\u0644\u062D\u0631\u064A\u0641 \u0635\u0627\u0644\u062D \u0625\u0644\u0649 \u063A\u0627\u064A\u0629 \u2026",
                text: "\u0644\u0639\u0631\u0636 \u0645\u064F\u0631\u0633\u064E\u0644: \u0627\u0644\u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0630\u064A \u064A\u0639\u0645\u0644 \u0625\u0644\u0649 \u063A\u0627\u064A\u062A\u0647 \u0627\u0644\u0631\u0627\u0628\u0637 \u0627\u0644\u0630\u064A \u062A\u0644\u0642\u0627\u0647 \u0627\u0644\u062D\u0631\u064A\u0641."
              },
              accepted: {
                term: "\u0642\u0628\u0644\u0647 \u2026 \u0628\u062A\u0627\u0631\u064A\u062E \u2026",
                text: "\u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0642\u0628\u0648\u0644 \u0648\u0627\u0644\u0627\u0633\u0645 \u0627\u0644\u0630\u064A \u0643\u062A\u0628\u0647 \u0627\u0644\u062D\u0631\u064A\u0641."
              },
              pdfHash: {
                term: "\u0628\u0635\u0645\u0629 \u0645\u0644\u0641 \u2066PDF\u2069 \u0627\u0644\u0645\u0642\u0628\u0648\u0644 (\u2066SHA-256\u2069)",
                text: "\u0631\u0645\u0632 \u064A\u062D\u062F\u062F \u0628\u062F\u0642\u0629 \u0645\u0644\u0641 \u2066PDF\u2069 \u0627\u0644\u0630\u064A \u0642\u0628\u0644\u0647 \u0627\u0644\u062D\u0631\u064A\u0641: \u064A\u062B\u0628\u062A \u0623\u0646 \u0627\u0644\u0648\u062B\u064A\u0642\u0629 \u0644\u0645 \u062A\u062A\u063A\u064A\u0631."
              },
              rejected: {
                term: "\u0631\u0641\u0636\u0647 \u0627\u0644\u062D\u0631\u064A\u0641 \u0628\u062A\u0627\u0631\u064A\u062E \u2026",
                text: "\u0627\u0644\u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0630\u064A \u0633\u064F\u062C\u0651\u0644 \u0641\u064A\u0647 \u0627\u0644\u0639\u0631\u0636 \u0639\u0644\u0649 \u0623\u0646\u0647 \u0645\u0631\u0641\u0648\u0636."
              },
              pdfReady: {
                term: "\u0645\u0644\u0641 \u2066PDF\u2069 \u062C\u0627\u0647\u0632 / \u0645\u0644\u0641 \u2066PDF\u2069 \u0642\u064A\u062F \u0627\u0644\u0625\u0639\u062F\u0627\u062F",
                text: "\u064A\u0628\u064A\u0651\u0646 \u0647\u0644 \u0623\u064F\u0646\u0634\u0626 \u0645\u0644\u0641 \u2066PDF\u2069 \u0627\u0644\u062E\u0627\u0635 \u0628\u0627\u0644\u0639\u0631\u0636."
              }
            }
          },
          dialogs: {
            title: "\u0646\u0648\u0627\u0641\u0630 \u0627\u0644\u062A\u0623\u0643\u064A\u062F",
            items: {
              send: {
                term: "\u0625\u0631\u0633\u0627\u0644 \u0627\u0644\u0639\u0631\u0636 \u0627\u0644\u0645\u0627\u0644\u064A",
                text: "\u0646\u0627\u0641\u0630\u0629 \u0627\u0644\u0625\u0631\u0633\u0627\u0644: \u0627\u062E\u062A\u0631 \xAB\u0627\u0644\u0645\u0631\u0633\u064E\u0644 \u0625\u0644\u064A\u0647\xBB (\u0627\u0644\u0628\u0631\u064A\u062F \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A \u0644\u0644\u062D\u0631\u064A\u0641 \u0623\u0648 \u0623\u062D\u062F \u062C\u0647\u0627\u062A \u0627\u062A\u0635\u0627\u0644\u0647) \u0648\xAB\u0631\u0633\u0627\u0644\u0629 \u0644\u0644\u062D\u0631\u064A\u0641 (\u0627\u062E\u062A\u064A\u0627\u0631\u064A\u0629)\xBB \u0625\u0646 \u0634\u0626\u062A. \u0627\u0644\u0631\u0627\u0628\u0637 \u0627\u0644\u0645\u0631\u0633\u0644 \u0635\u0627\u0644\u062D \u0644\u0645\u062F\u0629 30 \u064A\u0648\u0645\u064B\u0627."
              },
              convert: {
                term: "\u0625\u0646\u0634\u0627\u0621 \u0627\u0644\u0645\u0634\u0631\u0648\u0639",
                text: "\u0646\u0627\u0641\u0630\u0629 \u0627\u0644\u0625\u0646\u0634\u0627\u0621: \xAB\u0627\u0633\u0645 \u0627\u0644\u0645\u0634\u0631\u0648\u0639\xBB (\u0625\u062C\u0628\u0627\u0631\u064A) \u0648\xAB\u0646\u0648\u0639 \u0627\u0644\u0645\u0647\u0645\u0629\xBB (\u062A\u064F\u0646\u0634\u0623 \u0645\u0631\u0627\u062D\u0644\u0647 \u0648\u0645\u062C\u0644\u062F\u0627\u062A\u0647 \u0627\u0644\u0646\u0645\u0648\u0630\u062C\u064A\u0629) \u0648\xAB\u0631\u0645\u0632 \u0627\u0644\u0645\u0634\u0631\u0648\u0639 (\u0627\u062E\u062A\u064A\u0627\u0631\u064A)\xBB \u0627\u0644\u0630\u064A \u064A\u064F\u0648\u0644\u064E\u0651\u062F \u062A\u0644\u0642\u0627\u0626\u064A\u064B\u0627 \u0625\u0630\u0627 \u062A\u0631\u0643\u062A\u0647 \u0641\u0627\u0631\u063A\u064B\u0627."
              },
              reject: {
                term: "\u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u0639\u0631\u0636 \u0627\u0644\u0645\u0627\u0644\u064A \u0643\u0645\u0631\u0641\u0648\u0636\u061F",
                text: "\u062A\u0637\u0644\u0628 \u0627\u0644\u062A\u0623\u0643\u064A\u062F \u0642\u0628\u0644 \u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u0639\u0631\u0636 \u0639\u0644\u0649 \u0623\u0646\u0647 \u0645\u0631\u0641\u0648\u0636 \u0645\u0646 \u0627\u0644\u062D\u0631\u064A\u0641."
              },
              remove: {
                term: "\u062D\u0630\u0641 \u0627\u0644\u0645\u0633\u0648\u062F\u0629\u061F",
                text: "\u062A\u0637\u0644\u0628 \u0627\u0644\u062A\u0623\u0643\u064A\u062F \u0642\u0628\u0644 \u0627\u0644\u062D\u0630\u0641 \u0627\u0644\u0646\u0647\u0627\u0626\u064A \u0644\u0645\u0633\u0648\u062F\u0629 \u0644\u0645 \u062A\u064F\u0631\u0633\u064E\u0644 \u0642\u0637."
              },
              editSent: {
                term: "\u062A\u0639\u062F\u064A\u0644 \u0639\u0631\u0636 \u0645\u0627\u0644\u064A \u0645\u064F\u0631\u0633\u064E\u0644\u061F",
                text: "\u062A\u0646\u0628\u0651\u0647 \u0625\u0644\u0649 \u0623\u0646 \u0627\u0644\u0639\u0631\u0636 \u064A\u0639\u0648\u062F \u0625\u0644\u0649 \u0645\u0633\u0648\u062F\u0629 \u0648\u0623\u0646 \u0627\u0644\u0631\u0627\u0628\u0637 \u0627\u0644\u0645\u0631\u0633\u0644 \u064A\u062A\u0648\u0642\u0641 \u0639\u0646 \u0627\u0644\u0639\u0645\u0644\u061B \u0648\u0633\u062A\u062D\u062A\u0627\u062C \u0625\u0644\u0649 \u0625\u0639\u0627\u062F\u0629 \u0625\u0631\u0633\u0627\u0644\u0647."
              },
              leave: {
                term: "\u0627\u0644\u0645\u063A\u0627\u062F\u0631\u0629 \u062F\u0648\u0646 \u062D\u0641\u0638\u061F",
                text: "\u062A\u0638\u0647\u0631 \u0625\u0630\u0627 \u063A\u0627\u062F\u0631\u062A \u0627\u0644\u0634\u0627\u0634\u0629 \u0648\u0641\u064A\u0647\u0627 \u062A\u0639\u062F\u064A\u0644\u0627\u062A \u063A\u064A\u0631 \u0645\u062D\u0641\u0648\u0638\u0629: \xAB\u0645\u063A\u0627\u062F\u0631\u0629\xBB \u062A\u062A\u062E\u0644\u0649 \u0639\u0646\u0647\u0627 \u0648\xAB\u0627\u0644\u0628\u0642\u0627\u0621 \u0641\u064A \u0627\u0644\u0639\u0631\u0636 \u0627\u0644\u0645\u0627\u0644\u064A\xBB \u064A\u062D\u062A\u0641\u0638 \u0628\u0647\u0627."
              }
            }
          }
        }
      },
      contracts: {
        title: "\u0627\u0644\u0639\u0642\u0648\u062F",
        intro: "\u0642\u0627\u0626\u0645\u0629 \u0639\u0642\u0648\u062F \u0645\u0643\u062A\u0628\u0643 (\u0627\u0644\u0627\u062A\u0641\u0627\u0642\u064A\u0627\u062A \u0627\u0644\u062E\u0627\u0635\u0629 \u0648\u0627\u0644\u0635\u0641\u0642\u0627\u062A \u0627\u0644\u0639\u0645\u0648\u0645\u064A\u0629) \u0645\u0639 \u0645\u0628\u0627\u0644\u063A\u0647\u0627 \u0648\u062A\u0648\u0627\u0631\u064A\u062E\u0647\u0627 \u0627\u0644\u0623\u0633\u0627\u0633\u064A\u0629. \u064A\u0633\u062A\u0639\u0645\u0644\u0647\u0627 \u0645\u0646 \u064A\u062A\u0627\u0628\u0639\u0648\u0646 \u0627\u0644\u0627\u0644\u062A\u0632\u0627\u0645\u0627\u062A \u0627\u0644\u0645\u0645\u0636\u0627\u0629 \u0645\u0639 \u0627\u0644\u062D\u0631\u0641\u0627\u0621.",
        sections: {
          header: {
            title: "\u0631\u0623\u0633 \u0627\u0644\u0635\u0641\u062D\u0629",
            items: {
              subNav: {
                term: "\u0627\u0644\u0645\u0627\u0644\u064A\u0629",
                text: "\u062A\u0639\u0631\u0636 \u0627\u0644\u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u064A\u0645\u0646\u0649 \u0623\u0642\u0633\u0627\u0645 \u0627\u0644\u0645\u0627\u0644\u064A\u0629 \u0627\u0644\u062A\u064A \u062A\u0633\u0645\u062D \u0628\u0647\u0627 \u0635\u0644\u0627\u062D\u064A\u0627\u062A\u0643 (\u0627\u0644\u0639\u0631\u0648\u0636 \u0627\u0644\u0645\u0627\u0644\u064A\u0629 \u0648\u0627\u0644\u0639\u0642\u0648\u062F \u0648\u0627\u0644\u0641\u0648\u0627\u062A\u064A\u0631 \u0648\u0627\u0644\u062F\u0641\u0648\u0639\u0627\u062A\u2026)\u060C \u0648\u0639\u0644\u0649 \u0627\u0644\u0634\u0627\u0634\u0629 \u0627\u0644\u0635\u063A\u064A\u0631\u0629 \u062A\u062A\u062D\u0648\u0644 \u0625\u0644\u0649 \u0635\u0641 \u0645\u0646 \u0627\u0644\u0631\u0648\u0627\u0628\u0637."
              },
              newContract: {
                term: "\u0639\u0642\u062F \u062C\u062F\u064A\u062F",
                text: "\u064A\u0641\u062A\u062D \u0639\u0642\u062F\u064B\u0627 \u0641\u0627\u0631\u063A\u064B\u0627. \u0644\u0627 \u064A\u0638\u0647\u0631 \u0625\u0644\u0627 \u0644\u0645\u0646 \u064A\u062F\u064A\u0631\u0648\u0646 \u0627\u0644\u0639\u0642\u0648\u062F."
              }
            }
          },
          filters: {
            title: "\u0645\u0631\u0634\u062D\u0627\u062A \u0627\u0644\u0639\u0642\u0648\u062F",
            items: {
              kind: {
                term: "\u0635\u0646\u0641 \u0627\u0644\u0639\u0642\u062F",
                text: "\u0642\u0627\u0626\u0645\u0629 \u0645\u0646\u0633\u062F\u0644\u0629 \u0644\u0639\u0631\u0636 \u0627\u0644\u0627\u062A\u0641\u0627\u0642\u064A\u0627\u062A \u0627\u0644\u062E\u0627\u0635\u0629 \u0641\u0642\u0637 \u0623\u0648 \u0627\u0644\u0635\u0641\u0642\u0627\u062A \u0627\u0644\u0639\u0645\u0648\u0645\u064A\u0629 \u0641\u0642\u0637\u061B \u0648\xAB\u0643\u0644 \u0627\u0644\u0623\u0635\u0646\u0627\u0641\xBB \u062A\u0639\u0631\u0636 \u0627\u0644\u062C\u0645\u064A\u0639."
              },
              clear: {
                term: "\u0645\u0633\u062D \u0627\u0644\u0645\u0631\u0634\u062D",
                text: "\u064A\u0638\u0647\u0631 \u0639\u0646\u062F\u0645\u0627 \u0644\u0627 \u064A\u0648\u062C\u062F \u0639\u0642\u062F \u0645\u0646 \u0627\u0644\u0635\u0646\u0641 \u0627\u0644\u0645\u062E\u062A\u0627\u0631\u060C \u0648\u064A\u0639\u064A\u062F \xAB\u0643\u0644 \u0627\u0644\u0623\u0635\u0646\u0627\u0641\xBB."
              }
            }
          },
          table: {
            title: "\u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u0639\u0642\u0648\u062F",
            items: {
              reference: {
                term: "\u0627\u0644\u0645\u0631\u062C\u0639",
                text: "\u0631\u0642\u0645 \u0627\u0644\u0635\u0641\u0642\u0629 \u0623\u0648 \u0627\u0644\u0627\u062A\u0641\u0627\u0642\u064A\u0629. \u0627\u0646\u0642\u0631 \u0639\u0644\u064A\u0647 \u0644\u0641\u062A\u062D \u0627\u0644\u0639\u0642\u062F."
              },
              client: {
                term: "\u0627\u0644\u062D\u0631\u064A\u0641",
                text: "\u0627\u0644\u062D\u0631\u064A\u0641 \u0627\u0644\u0630\u064A \u0623\u064F\u0645\u0636\u064A \u0645\u0639\u0647 \u0627\u0644\u0639\u0642\u062F."
              },
              kind: {
                term: "\u0627\u0644\u0635\u0646\u0641",
                text: "\u0627\u062A\u0641\u0627\u0642\u064A\u0629 \u062E\u0627\u0635\u0629 (\u0627\u062A\u0641\u0627\u0642 \u0628\u064A\u0646 \u0637\u0631\u0641\u064A\u0646) \u0623\u0648 \u0635\u0641\u0642\u0629 \u0639\u0645\u0648\u0645\u064A\u0629 (\u0639\u0642\u062F \u0645\u0639 \u0647\u064A\u0643\u0644 \u0639\u0645\u0648\u0645\u064A \u064A\u062E\u0636\u0639 \u0644\u062D\u062F\u0648\u062F \u0642\u0627\u0646\u0648\u0646\u064A\u0629)."
              }
            }
          },
          amounts: {
            title: "\u0627\u0644\u0645\u0628\u0627\u0644\u063A \u0648\u0627\u0644\u062A\u0648\u0627\u0631\u064A\u062E",
            items: {
              amount: {
                term: "\u0627\u0644\u0645\u0628\u0644\u063A \u062F\u0648\u0646 \u0627\u062D\u062A\u0633\u0627\u0628 \u0627\u0644\u0623\u062F\u0627\u0621\u0627\u062A",
                text: "\u0627\u0644\u0645\u0628\u0644\u063A \u0627\u0644\u0645\u0645\u0636\u0649 \u0642\u0628\u0644 \u0627\u0644\u0623\u062F\u0627\u0621\u0627\u062A \u062F\u0648\u0646 \u0627\u062D\u062A\u0633\u0627\u0628 \u0627\u0644\u0645\u0644\u0627\u062D\u0642."
              },
              total: {
                term: "\u0627\u0644\u0645\u062C\u0645\u0648\u0639 \u0645\u0639 \u0627\u0644\u0645\u0644\u0627\u062D\u0642",
                text: "\u0627\u0644\u0645\u0628\u0644\u063A \u062F\u0648\u0646 \u0627\u0644\u0623\u062F\u0627\u0621\u0627\u062A \u0628\u0639\u062F \u0625\u0636\u0627\u0641\u0629 \u0627\u0644\u0645\u0644\u0627\u062D\u0642 (\u0627\u0644\u0645\u0644\u062D\u0642 \u0639\u0642\u062F \u0645\u0645\u0636\u0649 \u064A\u063A\u064A\u0651\u0631 \u0627\u0644\u0645\u0628\u0644\u063A)."
              },
              signedOn: {
                term: "\u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0625\u0645\u0636\u0627\u0621",
                text: "\u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0625\u0645\u0636\u0627\u0621\u060C \u0648\xAB\u2014\xBB \u0625\u0630\u0627 \u0644\u0645 \u064A\u064F\u062F\u062E\u064E\u0644."
              },
              bondReleaseOn: {
                term: "\u0631\u0641\u0639 \u0627\u0644\u0643\u0641\u0627\u0644\u0629",
                text: "\u0627\u0644\u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0645\u0646\u062A\u0638\u0631 \u0644\u0631\u0641\u0639 \u0627\u0644\u0643\u0641\u0627\u0644\u0629 (\u0627\u0644\u0636\u0645\u0627\u0646 \u0627\u0644\u0645\u0648\u062F\u0639 \u0644\u062F\u0649 \u0627\u0644\u0628\u0646\u0643)\u060C \u0648\xAB\u2014\xBB \u0625\u0630\u0627 \u0644\u0645 \u062A\u0648\u062C\u062F \u0643\u0641\u0627\u0644\u0629."
              }
            }
          },
          empty: {
            title: "\u0627\u0644\u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u0641\u0627\u0631\u063A\u0629 \u0648\u0627\u0644\u0623\u062E\u0637\u0627\u0621 \u0648\u0627\u0644\u062A\u062D\u0645\u064A\u0644",
            items: {
              none: {
                term: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0639\u0642\u0648\u062F \u062D\u0627\u0644\u064A\u064B\u0627",
                text: "\u0631\u0633\u0627\u0644\u0629 \u0627\u0644\u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u0641\u0627\u0631\u063A\u0629. \u062A\u0642\u062A\u0631\u062D \xAB\u0639\u0642\u062F \u062C\u062F\u064A\u062F\xBB \u0639\u0644\u0649 \u0645\u0646 \u064A\u062F\u064A\u0631\u0648\u0646 \u0627\u0644\u0639\u0642\u0648\u062F\u060C \u0623\u0645\u0627 \u063A\u064A\u0631\u0647\u0645 \u0641\u064A\u0631\u0648\u0646 \u0623\u0646 \u0639\u0642\u0648\u062F \u0645\u0643\u062A\u0628\u0647\u0645 \u0633\u062A\u0638\u0647\u0631 \u0647\u0646\u0627."
              },
              noMatch: {
                term: "\u0644\u0627 \u064A\u0648\u062C\u062F \u0639\u0642\u062F \u0645\u0637\u0627\u0628\u0642",
                text: "\u0631\u0633\u0627\u0644\u0629 \u062A\u0638\u0647\u0631 \u0639\u0646\u062F\u0645\u0627 \u0644\u0627 \u064A\u062C\u062F \u0627\u0644\u0645\u0631\u0634\u062D \u0634\u064A\u0626\u064B\u0627\u061B \u0648\u0632\u0631 \xAB\u0645\u0633\u062D \u0627\u0644\u0645\u0631\u0634\u062D\xBB \u064A\u0632\u064A\u0644\u0647."
              },
              loadMore: {
                term: "\u0639\u0631\u0636 \u0645\u0632\u064A\u062F \u0645\u0646 \u0627\u0644\u0639\u0642\u0648\u062F",
                text: "\u062A\u062D\u062A \u0627\u0644\u0642\u0627\u0626\u0645\u0629: \u064A\u062D\u0645\u0651\u0644 \u0627\u0644\u0639\u0642\u0648\u062F \u0627\u0644\u062A\u0627\u0644\u064A\u0629."
              },
              loadError: {
                term: "\u062A\u0639\u0630\u0651\u0631 \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0639\u0642\u0648\u062F",
                text: "\u0631\u0633\u0627\u0644\u0629 \u062E\u0637\u0623 \u0639\u0646\u062F \u0648\u062C\u0648\u062F \u0645\u0634\u0643\u0644 \u0641\u064A \u0627\u0644\u0627\u062A\u0635\u0627\u0644\u061B \u0648\xAB\u0625\u0639\u0627\u062F\u0629 \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629\xBB \u062A\u0639\u064A\u062F \u0627\u0644\u062A\u062D\u0645\u064A\u0644."
              }
            }
          }
        }
      },
      contract: {
        title: "\u0627\u0644\u0639\u0642\u062F (\u062C\u062F\u064A\u062F \u0623\u0648 \u0645\u0648\u062C\u0648\u062F)",
        intro: "\u0634\u0627\u0634\u0629 \u0639\u0642\u062F \u0648\u0627\u062D\u062F: \u0627\u0644\u0645\u0639\u0644\u0648\u0645\u0627\u062A \u0627\u0644\u0639\u0627\u0645\u0629 \u0648\u0634\u0631\u0648\u0637 \u0627\u0644\u062F\u0641\u0639 (\u0627\u0644\u062F\u0641\u0639\u0629 \u0627\u0644\u0645\u0633\u0628\u0642\u0629 \u0648\u0627\u0644\u0627\u062D\u062A\u0641\u0627\u0638 \u0628\u0627\u0644\u0636\u0645\u0627\u0646 \u0648\u0627\u0644\u0643\u0641\u0627\u0644\u0629 \u0648\u0627\u0644\u062E\u0637\u0627\u064A\u0627) \u0648\u0627\u0644\u0645\u0644\u0627\u062D\u0642 \u0648\u0627\u0644\u062A\u0642\u062F\u0651\u0645 \u0627\u0644\u0645\u0641\u0648\u062A\u0631. \u064A\u0633\u062A\u0637\u064A\u0639 \u0645\u0646 \u064A\u062F\u064A\u0631\u0648\u0646 \u0627\u0644\u0639\u0642\u0648\u062F \u062A\u0639\u062F\u064A\u0644\u0647\u060C \u0623\u0645\u0627 \u063A\u064A\u0631\u0647\u0645 \u0641\u064A\u0637\u0644\u0639\u0648\u0646 \u0639\u0644\u064A\u0647 \u0641\u0642\u0637.",
        sections: {
          header: {
            title: "\u0627\u0644\u0631\u0623\u0633 \u0648\u0627\u0644\u0631\u0633\u0627\u0626\u0644",
            items: {
              subNav: {
                term: "\u0627\u0644\u0645\u0627\u0644\u064A\u0629",
                text: "\u062A\u062A\u064A\u062D \u0644\u0643 \u0627\u0644\u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u064A\u0645\u0646\u0649 \u0627\u0644\u0627\u0646\u062A\u0642\u0627\u0644 \u0625\u0644\u0649 \u0642\u0633\u0645 \u0622\u062E\u0631 \u0645\u0646 \u0627\u0644\u0645\u0627\u0644\u064A\u0629 \u0628\u062D\u0633\u0628 \u0635\u0644\u0627\u062D\u064A\u0627\u062A\u0643."
              },
              breadcrumb: {
                term: "\u0627\u0644\u0639\u0642\u0648\u062F",
                text: "\u0627\u0644\u0631\u0627\u0628\u0637 \u0641\u064A \u0623\u0639\u0644\u0649 \u0627\u0644\u0635\u0641\u062D\u0629 \u064A\u0639\u064A\u062F\u0643 \u0625\u0644\u0649 \u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u0639\u0642\u0648\u062F\u061B \u0648\u062A\u0637\u0644\u0628 \u0645\u0646\u0643 \u0646\u0627\u0641\u0630\u0629 \u0627\u0644\u062A\u0623\u0643\u064A\u062F \u0625\u0646 \u0628\u0642\u064A\u062A \u062A\u0639\u062F\u064A\u0644\u0627\u062A \u063A\u064A\u0631 \u0645\u062D\u0641\u0648\u0638\u0629 (\xAB\u0627\u0644\u0645\u063A\u0627\u062F\u0631\u0629 \u062F\u0648\u0646 \u062D\u0641\u0638\u061F\xBB)."
              },
              save: {
                term: "\u062D\u0641\u0638",
                text: "\u064A\u062D\u0641\u0638 \u0627\u0644\u0639\u0642\u062F\u061B \u0648\u0627\u0644\u062D\u0641\u0638 \u0627\u0644\u0623\u0648\u0644 \u064A\u0646\u0634\u0626\u0647. \u0644\u0627 \u064A\u0638\u0647\u0631 \u0625\u0644\u0627 \u0644\u0645\u0646 \u064A\u062F\u064A\u0631\u0648\u0646 \u0627\u0644\u0639\u0642\u0648\u062F."
              },
              fromQuote: {
                term: "\u0639\u0642\u062F \u0623\u064F\u0646\u0634\u0626 \u0645\u0646 \u0639\u0631\u0636 \u0645\u0627\u0644\u064A: \u0641\u062A\u062D \u0627\u0644\u0639\u0631\u0636 \u0627\u0644\u0645\u0627\u0644\u064A",
                text: "\u0631\u0627\u0628\u0637 \u064A\u0639\u064A\u062F\u0643 \u0625\u0644\u0649 \u0627\u0644\u0639\u0631\u0636 \u0627\u0644\u0645\u0627\u0644\u064A \u0627\u0644\u0623\u0635\u0644\u064A\u060C \u0644\u0645\u0646 \u064A\u0633\u062A\u0637\u064A\u0639\u0648\u0646 \u0627\u0644\u0627\u0637\u0644\u0627\u0639 \u0639\u0644\u0649 \u0627\u0644\u0639\u0631\u0648\u0636."
              },
              notices: {
                term: "\u0634\u0631\u0627\u0626\u0637 \u0627\u0644\u0645\u0639\u0644\u0648\u0645\u0627\u062A",
                text: "\xAB\u064A\u0645\u0643\u0646\u0643 \u0627\u0644\u0627\u0637\u0644\u0627\u0639 \u0639\u0644\u0649 \u0647\u0630\u0627 \u0627\u0644\u0639\u0642\u062F \u062F\u0648\u0646 \u062A\u0639\u062F\u064A\u0644\u0647\xBB \u0639\u0646\u062F \u0627\u0644\u0627\u0637\u0644\u0627\u0639 \u0641\u0642\u0637\u061B \xAB\u0642\u0627\u0645 \u0634\u062E\u0635 \u0622\u062E\u0631 \u0628\u062A\u0639\u062F\u064A\u0644 \u0647\u0630\u0627 \u0627\u0644\u0639\u0642\u062F\xBB \u0645\u0639 \xAB\u0625\u0639\u0627\u062F\u0629 \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0639\u0642\u062F\xBB\u061B \xAB\u062A\u0639\u0630\u0651\u0631 \u062D\u0641\u0638 \u0627\u0644\u0639\u0642\u062F\xBB \u0639\u0646\u062F \u0641\u0634\u0644 \u0627\u0644\u062D\u0641\u0638."
              }
            }
          },
          general: {
            title: "\u0645\u0639\u0644\u0648\u0645\u0627\u062A \u0639\u0627\u0645\u0629",
            items: {
              client: {
                term: "\u0627\u0644\u062D\u0631\u064A\u0641",
                text: "\u0625\u062C\u0628\u0627\u0631\u064A \u0639\u0646\u062F \u0627\u0644\u0625\u0646\u0634\u0627\u0621. \u0644\u0627 \u064A\u062A\u063A\u064A\u0631 \u062D\u0631\u064A\u0641 \u0627\u0644\u0639\u0642\u062F \u0628\u0639\u062F \u0630\u0644\u0643."
              },
              project: {
                term: "\u0627\u0644\u0645\u0634\u0631\u0648\u0639",
                text: "\u0627\u062E\u062A\u064A\u0627\u0631\u064A: \u0645\u0634\u0631\u0648\u0639 \u0630\u0644\u0643 \u0627\u0644\u062D\u0631\u064A\u0641\u060C \u0623\u0648 \xAB\u062F\u0648\u0646 \u0645\u0634\u0631\u0648\u0639\xBB. \u0648\u0645\u0646 \u062F\u0648\u0646 \u0645\u0634\u0631\u0648\u0639 \u0644\u0627 \u064A\u062A\u0648\u0641\u0631 \u0627\u0644\u062A\u0642\u062F\u0651\u0645 \u062D\u0633\u0628 \u0627\u0644\u0645\u0631\u0627\u062D\u0644."
              },
              reference: {
                term: "\u0645\u0631\u062C\u0639 \u0627\u0644\u0639\u0642\u062F",
                text: "\u0625\u062C\u0628\u0627\u0631\u064A: \u0631\u0642\u0645 \u0627\u0644\u0635\u0641\u0642\u0629 \u0623\u0648 \u0627\u0644\u0627\u062A\u0641\u0627\u0642\u064A\u0629\u060C \u0648\u0647\u0648 \u0641\u0631\u064A\u062F \u0641\u064A \u0645\u0643\u062A\u0628\u0643."
              },
              kind: {
                term: "\u0627\u0644\u0635\u0646\u0641",
                text: "\u0627\u062A\u0641\u0627\u0642\u064A\u0629 \u062E\u0627\u0635\u0629 \u0623\u0648 \u0635\u0641\u0642\u0629 \u0639\u0645\u0648\u0645\u064A\u0629\u061B \u062A\u0638\u0647\u0631 \u062A\u0646\u0628\u064A\u0647\u0627\u062A \u0641\u064A \u0627\u0644\u0635\u0641\u0642\u0629 \u0627\u0644\u0639\u0645\u0648\u0645\u064A\u0629 \u0625\u0630\u0627 \u062A\u062C\u0627\u0648\u0632\u062A \u0634\u0631\u0648\u0637\u0647\u0627 \u0627\u0644\u062D\u062F\u0648\u062F \u0627\u0644\u0642\u0627\u0646\u0648\u0646\u064A\u0629."
              },
              currency: {
                term: "\u0627\u0644\u0639\u0645\u0644\u0629",
                text: "\u0639\u0645\u0644\u0629 \u0627\u0644\u0639\u0642\u062F: \u2066TND\u2069 \u0623\u0648 \u2066EUR\u2069 \u0623\u0648 \u2066USD\u2069."
              },
              amount: {
                term: "\u0627\u0644\u0645\u0628\u0644\u063A \u062F\u0648\u0646 \u0627\u062D\u062A\u0633\u0627\u0628 \u0627\u0644\u0623\u062F\u0627\u0621\u0627\u062A",
                text: "\u0625\u062C\u0628\u0627\u0631\u064A: \u0627\u0644\u0645\u0628\u0644\u063A \u0627\u0644\u0645\u0645\u0636\u0649 \u0642\u0628\u0644 \u0627\u0644\u0623\u062F\u0627\u0621\u0627\u062A \u062F\u0648\u0646 \u0627\u062D\u062A\u0633\u0627\u0628 \u0627\u0644\u0645\u0644\u0627\u062D\u0642."
              },
              signedOn: {
                term: "\u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0625\u0645\u0636\u0627\u0621",
                text: "\u0627\u062E\u062A\u064A\u0627\u0631\u064A: \u062A\u0627\u0631\u064A\u062E \u0625\u0645\u0636\u0627\u0621 \u0627\u0644\u0639\u0642\u062F."
              },
              total: {
                term: "\u0627\u0644\u0645\u062C\u0645\u0648\u0639 \u062F\u0648\u0646 \u0627\u062D\u062A\u0633\u0627\u0628 \u0627\u0644\u0623\u062F\u0627\u0621\u0627\u062A \u0645\u0639 \u0627\u0644\u0645\u0644\u0627\u062D\u0642:",
                text: "\u064A\u0638\u0647\u0631 \u0641\u064A \u0639\u0642\u062F \u0645\u062D\u0641\u0648\u0638: \u0627\u0644\u0645\u0628\u0644\u063A \u0642\u0628\u0644 \u0627\u0644\u0623\u062F\u0627\u0621\u0627\u062A \u0645\u0639 \u0627\u0644\u0645\u0644\u0627\u062D\u0642. \u064A\u064F\u062D\u062A\u0633\u0628 \u0644\u0643."
              }
            }
          },
          terms: {
            title: "\u0634\u0631\u0648\u0637 \u0627\u0644\u062F\u0641\u0639",
            items: {
              advance: {
                term: "\u0627\u0644\u062F\u0641\u0639\u0629 \u0627\u0644\u0645\u0633\u0628\u0642\u0629",
                text: "\u0645\u0628\u0644\u063A \u064A\u064F\u062F\u0641\u0639 \u0641\u064A \u0627\u0644\u0628\u062F\u0627\u064A\u0629\u060C \u0628\u0646\u0633\u0628\u0629 \u0645\u0627\u0626\u0648\u064A\u0629 \u0645\u0646 \u0627\u0644\u0645\u0628\u0644\u063A\u060C \u0645\u062B\u0644 10."
              },
              retention: {
                term: "\u0627\u0644\u0627\u062D\u062A\u0641\u0627\u0638 \u0628\u0627\u0644\u0636\u0645\u0627\u0646",
                text: "\u0646\u0633\u0628\u0629 \u0645\u0627\u0626\u0648\u064A\u0629 \u062A\u064F\u0642\u062A\u0637\u0639 \u0645\u0646 \u0643\u0644 \u0641\u0627\u062A\u0648\u0631\u0629 \u062A\u0642\u062F\u0651\u0645 \u0627\u0644\u0623\u0634\u063A\u0627\u0644 \u0648\u062A\u064F\u0631\u0641\u0639 \u0628\u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629 \u0627\u0644\u0646\u0647\u0627\u0626\u064A\u0629."
              },
              retentionBase: {
                term: "\u0623\u0633\u0627\u0633 \u0627\u0644\u0627\u062D\u062A\u0641\u0627\u0638 \u0628\u0627\u0644\u0636\u0645\u0627\u0646",
                text: "\u0627\u0644\u0645\u0628\u0644\u063A \u0627\u0644\u0630\u064A \u064A\u064F\u062D\u062A\u0633\u0628 \u0639\u0644\u064A\u0647 \u0627\u0644\u0627\u062D\u062A\u0641\u0627\u0638: \u0627\u0644\u0645\u0628\u0644\u063A \u062F\u0648\u0646 \u0627\u062D\u062A\u0633\u0627\u0628 \u0627\u0644\u0623\u062F\u0627\u0621\u0627\u062A (\u0627\u0641\u062A\u0631\u0627\u0636\u064A\u064B\u0627) \u0623\u0648 \u0627\u0644\u0645\u0628\u0644\u063A \u0628\u0627\u062D\u062A\u0633\u0627\u0628 \u0643\u0644 \u0627\u0644\u0623\u062F\u0627\u0621\u0627\u062A. \u064A\u062C\u0628 \u062A\u0623\u0643\u064A\u062F\u0647 \u0645\u0639 \u0627\u0644\u062E\u0628\u064A\u0631 \u0627\u0644\u0645\u062D\u0627\u0633\u0628."
              },
              bond: {
                term: "\u0627\u0644\u0643\u0641\u0627\u0644\u0629 \u0627\u0644\u0646\u0647\u0627\u0626\u064A\u0629",
                text: "\u0636\u0645\u0627\u0646 \u0628\u0646\u0643\u064A \u0645\u0639\u0628\u064E\u0651\u0631 \u0639\u0646\u0647 \u0628\u0646\u0633\u0628\u0629 \u0645\u0627\u0626\u0648\u064A\u0629 \u0645\u0646 \u0627\u0644\u0645\u0628\u0644\u063A."
              },
              bondReleaseOn: {
                term: "\u062A\u0627\u0631\u064A\u062E \u0631\u0641\u0639 \u0627\u0644\u0643\u0641\u0627\u0644\u0629",
                text: "\u064A\u064F\u0631\u0633\u0644 \u062A\u0630\u0643\u064A\u0631 \u0642\u0628\u0644 7 \u0623\u064A\u0627\u0645 \u0648\u0641\u064A \u0627\u0644\u064A\u0648\u0645 \u0646\u0641\u0633\u0647. \u0644\u0627 \u064A\u0643\u0648\u0646 \u0647\u0630\u0627 \u0627\u0644\u062D\u0642\u0644 \u0646\u0634\u0637\u064B\u0627 \u0625\u0644\u0627 \u0625\u0630\u0627 \u0623\u064F\u062F\u062E\u0644\u062A \u0643\u0641\u0627\u0644\u0629."
              },
              penaltyRate: {
                term: "\u062E\u0637\u064A\u0629 \u0627\u0644\u062A\u0623\u062E\u064A\u0631 \u0641\u064A \u0627\u0644\u064A\u0648\u0645",
                text: "\u0628\u0646\u0633\u0628\u0629 \u0645\u0627\u0626\u0648\u064A\u0629 \u0645\u0646 \u0627\u0644\u0645\u0628\u0644\u063A \u0639\u0646 \u0643\u0644 \u064A\u0648\u0645 \u062A\u0623\u062E\u064A\u0631."
              },
              penaltyCap: {
                term: "\u0633\u0642\u0641 \u0627\u0644\u062E\u0637\u0627\u064A\u0627",
                text: "\u0623\u0642\u0635\u0649 \u0645\u0627 \u064A\u0645\u0643\u0646 \u0623\u0646 \u062A\u0628\u0644\u063A\u0647 \u0627\u0644\u062E\u0637\u0627\u064A\u0627\u060C \u0628\u0646\u0633\u0628\u0629 \u0645\u0627\u0626\u0648\u064A\u0629 \u0645\u0646 \u0627\u0644\u0645\u0628\u0644\u063A."
              },
              warnings: {
                term: "\u0634\u0631\u0648\u0637 \u062A\u062A\u062C\u0627\u0648\u0632 \u062D\u062F\u0648\u062F \u0627\u0644\u0635\u0641\u0642\u0629 \u0627\u0644\u0639\u0645\u0648\u0645\u064A\u0629",
                text: "\u0641\u064A \u0627\u0644\u0635\u0641\u0642\u0629 \u0627\u0644\u0639\u0645\u0648\u0645\u064A\u0629 \u064A\u0639\u0631\u0636 \u0634\u0631\u064A\u0637 \u0628\u0631\u062A\u0642\u0627\u0644\u064A \u0627\u0644\u0634\u0631\u0648\u0637 \u0627\u0644\u062A\u064A \u062A\u062A\u062C\u0627\u0648\u0632 \u0627\u0644\u062D\u062F\u0648\u062F \u0645\u0639 \u0627\u0644\u0645\u0631\u062C\u0639 \u0627\u0644\u0642\u0627\u0646\u0648\u0646\u064A. \u0644\u0627 \u064A\u0645\u0646\u0639 \u0627\u0644\u062D\u0641\u0638: \u0641\u0642\u062F \u062A\u0646\u0635 \u0627\u0644\u0635\u0641\u0642\u0629 \u0639\u0644\u0649 \u0627\u0633\u062A\u062B\u0646\u0627\u0621."
              }
            }
          },
          amendments: {
            title: "\u0627\u0644\u0645\u0644\u0627\u062D\u0642",
            items: {
              total: {
                term: "\u0627\u0644\u0645\u062C\u0645\u0648\u0639 \u062F\u0648\u0646 \u0627\u062D\u062A\u0633\u0627\u0628 \u0627\u0644\u0623\u062F\u0627\u0621\u0627\u062A \u0645\u0639 \u0627\u0644\u0645\u0644\u0627\u062D\u0642:",
                text: "\u0645\u0628\u0644\u063A \u0627\u0644\u0639\u0642\u062F \u0628\u0639\u062F \u0625\u0636\u0627\u0641\u0629 \u0643\u0644 \u0627\u0644\u0645\u0644\u0627\u062D\u0642."
              },
              add: {
                term: "\u0625\u0636\u0627\u0641\u0629 \u0645\u0644\u062D\u0642",
                text: "\u064A\u0641\u062A\u062D \u0646\u0627\u0641\u0630\u0629 \u0627\u0644\u0625\u0636\u0627\u0641\u0629. \u0645\u062E\u0635\u0635 \u0644\u0645\u0646 \u064A\u062F\u064A\u0631\u0648\u0646 \u0627\u0644\u0639\u0642\u0648\u062F\u061B \u0648\u064A\u062C\u0628 \u062D\u0641\u0638 \u062A\u0639\u062F\u064A\u0644\u0627\u062A\u0643 \u0623\u0648\u0644\u064B\u0627."
              },
              number: {
                term: "\u0639\u062F\u062F",
                text: "\u0627\u0644\u0631\u0642\u0645 \u0627\u0644\u062A\u0631\u062A\u064A\u0628\u064A \u0644\u0644\u0645\u0644\u062D\u0642."
              },
              label: {
                term: "\u0627\u0644\u0645\u0648\u0636\u0648\u0639",
                text: "\u0645\u0627 \u064A\u063A\u064A\u0651\u0631\u0647 \u0627\u0644\u0645\u0644\u062D\u0642\u060C \u0645\u0639 \u0648\u0635\u0641\u0647 \u0625\u0646 \u0648\u064F\u062C\u062F."
              },
              delta: {
                term: "\u062A\u063A\u064A\u0651\u0631 \u0627\u0644\u0645\u0628\u0644\u063A",
                text: "\u0645\u0642\u062F\u0627\u0631 \u0645\u0627 \u064A\u0632\u064A\u062F\u0647 \u0627\u0644\u0645\u0644\u062D\u0642 \u0623\u0648 \u064A\u062E\u0641\u0636\u0647 \u0645\u0646 \u0645\u0628\u0644\u063A \u0627\u0644\u0639\u0642\u062F."
              },
              signedOn: {
                term: "\u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0625\u0645\u0636\u0627\u0621",
                text: "\u062A\u0627\u0631\u064A\u062E \u0625\u0645\u0636\u0627\u0621 \u0627\u0644\u0645\u0644\u062D\u0642."
              },
              document: {
                term: "\u0627\u0644\u0648\u062B\u064A\u0642\u0629 \u0627\u0644\u0645\u0645\u0636\u0627\u0629",
                text: "\u0627\u0644\u0648\u062B\u064A\u0642\u0629 \u0627\u0644\u0645\u0645\u0636\u0627\u0629 \u0627\u0644\u0645\u0631\u062A\u0628\u0637\u0629 \u0628\u0627\u0644\u0645\u0644\u062D\u0642 (\u0645\u0646 \u0648\u062B\u0627\u0626\u0642 \u0627\u0644\u0645\u0634\u0631\u0648\u0639)\u060C \u0623\u0648 \xAB\u2014\xBB \u0625\u0630\u0627 \u0644\u0645 \u062A\u0648\u062C\u062F."
              },
              empty: {
                term: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0645\u0644\u0627\u062D\u0642",
                text: "\u0631\u0633\u0627\u0644\u0629 \u0627\u0644\u062C\u062F\u0648\u0644 \u0627\u0644\u0641\u0627\u0631\u063A: \u064A\u063A\u064A\u0651\u0631 \u0627\u0644\u0645\u0644\u062D\u0642 \u0645\u0628\u0644\u063A \u0627\u0644\u0639\u0642\u062F\u060C \u0648\u0628\u0639\u062F \u062D\u0641\u0638\u0647 \u0644\u0627 \u064A\u0645\u0643\u0646 \u062A\u0639\u062F\u064A\u0644\u0647."
              }
            }
          },
          amendmentDialog: {
            title: "\u0625\u0636\u0627\u0641\u0629 \u0645\u0644\u062D\u0642",
            items: {
              label: {
                term: "\u0645\u0648\u0636\u0648\u0639 \u0627\u0644\u0645\u0644\u062D\u0642",
                text: "\u0625\u062C\u0628\u0627\u0631\u064A: \u0645\u0627 \u064A\u063A\u064A\u0651\u0631\u0647 \u0627\u0644\u0645\u0644\u062D\u0642."
              },
              description: {
                term: "\u0627\u0644\u0648\u0635\u0641 (\u0627\u062E\u062A\u064A\u0627\u0631\u064A)",
                text: "\u0628\u0639\u0636 \u0627\u0644\u062A\u0648\u0636\u064A\u062D\u0627\u062A \u0644\u062A\u062A\u0630\u0643\u0631 \u0633\u0628\u0628 \u0648\u062C\u0648\u062F \u0627\u0644\u0645\u0644\u062D\u0642."
              },
              delta: {
                term: "\u062A\u063A\u064A\u0651\u0631 \u0627\u0644\u0645\u0628\u0644\u063A \u062F\u0648\u0646 \u0627\u062D\u062A\u0633\u0627\u0628 \u0627\u0644\u0623\u062F\u0627\u0621\u0627\u062A",
                text: "\u0625\u062C\u0628\u0627\u0631\u064A: \u0645\u0648\u062C\u0628 \u0644\u0644\u0632\u064A\u0627\u062F\u0629 \u0648\u0633\u0627\u0644\u0628 \u0644\u0644\u062A\u062E\u0641\u064A\u0636 (\u0645\u062B\u0627\u0644: -500)."
              },
              signedOn: {
                term: "\u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0625\u0645\u0636\u0627\u0621",
                text: "\u0625\u062C\u0628\u0627\u0631\u064A: \u062A\u0627\u0631\u064A\u062E \u0625\u0645\u0636\u0627\u0621 \u0627\u0644\u0645\u0644\u062D\u0642."
              },
              document: {
                term: "\u0627\u0644\u0648\u062B\u064A\u0642\u0629 \u0627\u0644\u0645\u0645\u0636\u0627\u0629 (\u0625\u062F\u0627\u0631\u0629 \u0627\u0644\u0648\u062B\u0627\u0626\u0642)",
                text: "\u0627\u062E\u062A\u064A\u0627\u0631\u064A: \xAB\u0627\u062E\u062A\u064A\u0627\u0631 \u0648\u062B\u064A\u0642\u0629\xBB \u0645\u0646 \u0645\u062C\u0644\u062F\u0627\u062A \u0627\u0644\u0645\u0634\u0631\u0648\u0639 (\u062B\u0645 \xAB\u062A\u063A\u064A\u064A\u0631\xBB \u0623\u0648 \xAB\u0625\u0632\u0627\u0644\u0629\xBB). \u0648\u0625\u0630\u0627 \u0644\u0645 \u064A\u0643\u0646 \u0627\u0644\u0639\u0642\u062F \u0645\u0631\u062A\u0628\u0637\u064B\u0627 \u0628\u0645\u0634\u0631\u0648\u0639 \u064A\u062D\u0644 \u062A\u0630\u0643\u064A\u0631 \u0645\u062D\u0644 \u0647\u0630\u0647 \u0627\u0644\u062E\u0627\u0646\u0629."
              },
              submit: {
                term: "\u0625\u0636\u0627\u0641\u0629 \u0627\u0644\u0645\u0644\u062D\u0642",
                text: "\u064A\u062D\u0641\u0638 \u0627\u0644\u0645\u0644\u062D\u0642. \u0627\u0644\u0645\u0644\u062D\u0642 \u0639\u0642\u062F \u0645\u0645\u0636\u0649: \u0644\u0627 \u064A\u0645\u0643\u0646 \u062A\u0639\u062F\u064A\u0644\u0647 \u0628\u0639\u062F \u0630\u0644\u0643\u061B \u0648\u0641\u064A \u062D\u0627\u0644 \u0627\u0644\u062E\u0637\u0623 \u0623\u0636\u0641 \u0645\u0644\u062D\u0642\u064B\u0627 \u062A\u0635\u062D\u064A\u062D\u064A\u064B\u0627. \xAB\u0625\u0644\u063A\u0627\u0621\xBB \u064A\u063A\u0644\u0642 \u0627\u0644\u0646\u0627\u0641\u0630\u0629."
              }
            }
          },
          progress: {
            title: "\u0627\u0644\u062A\u0642\u062F\u0651\u0645 \u0627\u0644\u0645\u0641\u0648\u062A\u0631",
            items: {
              summary: {
                term: "\u0645\u062C\u0645\u0648\u0639 \u0627\u0644\u0639\u0642\u062F (\u062F\u0648\u0646 \u0627\u062D\u062A\u0633\u0627\u0628 \u0627\u0644\u0623\u062F\u0627\u0621\u0627\u062A)",
                text: "\u0645\u0644\u062E\u0635: \u0645\u062C\u0645\u0648\u0639 \u0627\u0644\u0639\u0642\u062F \u0648\u0627\u0644\u062F\u0641\u0639\u0629 \u0627\u0644\u0645\u0633\u0628\u0642\u0629 \u0648\u0627\u0644\u062F\u0641\u0639\u0629 \u0627\u0644\u0645\u0633\u0628\u0642\u0629 \u0627\u0644\u0645\u0633\u062A\u0631\u062C\u0639\u0629 \u0648\u0627\u0644\u0627\u062D\u062A\u0641\u0627\u0638 \u0628\u0627\u0644\u0636\u0645\u0627\u0646 \u0627\u0644\u0645\u0642\u062A\u0637\u0639."
              },
              phases: {
                term: "\u0627\u0644\u062A\u0642\u062F\u0651\u0645 \u0627\u0644\u0645\u0641\u0648\u062A\u0631 \u062D\u0633\u0628 \u0627\u0644\u0645\u0631\u0627\u062D\u0644",
                text: "\u062C\u062F\u0648\u0644 \u062D\u0633\u0628 \u0627\u0644\u0645\u0631\u062D\u0644\u0629: \u0627\u0644\u0645\u0631\u062D\u0644\u0629 \u0648\u0627\u0644\u062D\u0627\u0644\u0629 \u0648\u0627\u0644\u0623\u062A\u0639\u0627\u0628 \u0648\u0627\u0644\u0645\u0641\u0648\u062A\u0631 (\u062A\u0631\u0627\u0643\u0645\u064A) \u0648\u0627\u0644\u0645\u0628\u0644\u063A \u0627\u0644\u0645\u0641\u0648\u062A\u0631."
              },
              prepare: {
                term: "\u0625\u0639\u062F\u0627\u062F \u0641\u0627\u062A\u0648\u0631\u0629 \u062A\u0642\u062F\u0651\u0645 \u0627\u0644\u0623\u0634\u063A\u0627\u0644",
                text: "\u064A\u0641\u062A\u062D \u0634\u0627\u0634\u0629 \u0641\u0627\u062A\u0648\u0631\u0629 \u062A\u0642\u062F\u0651\u0645 \u0627\u0644\u0623\u0634\u063A\u0627\u0644 (\u0627\u0644\u0641\u0648\u062A\u0631\u0629 \u0628\u062D\u0633\u0628 \u0627\u0644\u062A\u0642\u062F\u0651\u0645). \u0645\u062E\u0635\u0635 \u0644\u0645\u0646 \u064A\u0633\u062A\u0637\u064A\u0639\u0648\u0646 \u0625\u0646\u0634\u0627\u0621 \u0627\u0644\u0641\u0648\u0627\u062A\u064A\u0631\u060C \u0648\u0644\u0639\u0642\u062F \u0645\u0631\u062A\u0628\u0637 \u0628\u0645\u0634\u0631\u0648\u0639 \u0648\u0628\u0639\u0645\u0644\u0629 \u2066TND\u2069 \u0641\u0642\u0637."
              },
              needProject: {
                term: "\u0627\u0631\u0628\u0637 \u0647\u0630\u0627 \u0627\u0644\u0639\u0642\u062F \u0628\u0645\u0634\u0631\u0648\u0639\u2026",
                text: "\u0631\u0633\u0627\u0644\u0629 \u062A\u0638\u0647\u0631 \u0639\u0646\u062F\u0645\u0627 \u0644\u0627 \u064A\u0643\u0648\u0646 \u0644\u0644\u0639\u0642\u062F \u0645\u0634\u0631\u0648\u0639: \u0641\u0627\u0644\u062A\u062A\u0628\u0639 \u062D\u0633\u0628 \u0627\u0644\u0645\u0631\u0627\u062D\u0644 \u064A\u062D\u062A\u0627\u062C \u0625\u0644\u064A\u0647."
              },
              needTnd: {
                term: "\u0641\u0648\u0627\u062A\u064A\u0631 \u062A\u0642\u062F\u0651\u0645 \u0627\u0644\u0623\u0634\u063A\u0627\u0644 \u0628\u0627\u0644\u062F\u064A\u0646\u0627\u0631\u2026",
                text: "\u0631\u0633\u0627\u0644\u0629 \u062A\u0638\u0647\u0631 \u0644\u0639\u0642\u062F \u0628\u0639\u0645\u0644\u0629 \u2066EUR\u2069 \u0623\u0648 \u2066USD\u2069: \u0627\u0644\u062A\u0642\u062F\u0651\u0645 \u063A\u064A\u0631 \u0645\u062A\u0627\u062D."
              }
            }
          }
        }
      },
      progress: {
        title: "\u0641\u0627\u062A\u0648\u0631\u0629 \u062A\u0642\u062F\u0651\u0645 \u0627\u0644\u0623\u0634\u063A\u0627\u0644",
        intro: "\u0627\u0644\u0634\u0627\u0634\u0629 \u0627\u0644\u062A\u064A \u062A\u0639\u062F\u0651 \u0641\u0627\u062A\u0648\u0631\u0629 \u062A\u0642\u062F\u0651\u0645 \u0627\u0644\u0623\u0634\u063A\u0627\u0644: \u0641\u0627\u062A\u0648\u0631\u0629 \u062A\u064F\u0646\u0634\u0623 \u0628\u062D\u0633\u0628 \u062A\u0642\u062F\u0651\u0645 \u0645\u0631\u0627\u062D\u0644 \u0627\u0644\u0645\u0634\u0631\u0648\u0639. \u062A\u062F\u062E\u0644 \u0644\u0643\u0644 \u0645\u0631\u062D\u0644\u0629 \u0627\u0644\u062A\u0642\u062F\u0651\u0645 \u0627\u0644\u0630\u064A \u0628\u0644\u063A\u062A\u0647 \u0648\u064A\u064F\u062D\u062A\u0633\u0628 \u0645\u0628\u0644\u063A \u0627\u0644\u0641\u062A\u0631\u0629 \u062A\u0644\u0642\u0627\u0626\u064A\u064B\u0627.",
        sections: {
          header: {
            title: "\u0627\u0644\u0631\u0623\u0633 \u0648\u0627\u0644\u0631\u0633\u0627\u0626\u0644",
            items: {
              subNav: {
                term: "\u0627\u0644\u0645\u0627\u0644\u064A\u0629",
                text: "\u062A\u0628\u0642\u0649 \u0627\u0644\u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u064A\u0645\u0646\u0649 \u0638\u0627\u0647\u0631\u0629 (\u0645\u0639 \u0625\u0628\u0631\u0627\u0632 \u0642\u0633\u0645 \xAB\u0627\u0644\u0641\u0648\u0627\u062A\u064A\u0631\xBB) \u0648\u062A\u062A\u064A\u062D \u0644\u0643 \u062A\u063A\u064A\u064A\u0631 \u0627\u0644\u0642\u0633\u0645."
              },
              breadcrumb: {
                term: "\u0627\u0644\u0639\u0642\u0648\u062F",
                text: "\u064A\u0639\u064A\u062F\u0643 \u0627\u0644\u0645\u0633\u0627\u0631 \u0625\u0644\u0649 \u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u0639\u0642\u0648\u062F \u062B\u0645 \u0625\u0644\u0649 \u0627\u0644\u0639\u0642\u062F \u0646\u0641\u0633\u0647\u060C \u0644\u0645\u0646 \u064A\u0633\u062A\u0637\u064A\u0639\u0648\u0646 \u0627\u0644\u0627\u0637\u0644\u0627\u0639 \u0639\u0644\u064A\u0647\u0627."
              },
              submit: {
                term: "\u0625\u0646\u0634\u0627\u0621 \u0645\u0633\u0648\u062F\u0629 \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629",
                text: "\u064A\u0646\u0634\u0626 \u0645\u0633\u0648\u062F\u0629 \u0641\u0627\u062A\u0648\u0631\u0629 \u0628\u0646\u062A\u064A\u062C\u0629 \u0627\u0644\u0627\u062D\u062A\u0633\u0627\u0628 \u062B\u0645 \u064A\u0641\u062A\u062D\u0647\u0627. \u0644\u0627 \u064A\u0638\u0647\u0631 \u0625\u0644\u0627 \u0644\u0645\u0646 \u064A\u0633\u062A\u0637\u064A\u0639\u0648\u0646 \u0625\u0646\u0634\u0627\u0621 \u0627\u0644\u0641\u0648\u0627\u062A\u064A\u0631 \u0648\u0639\u0646\u062F\u0645\u0627 \u062A\u0643\u0648\u0646 \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629 \u0645\u0645\u0643\u0646\u0629."
              },
              blocked: {
                term: "\u0627\u0644\u0639\u0642\u062F \u0645\u063A\u0644\u0642 / \u062D\u0635\u0635 \u0623\u062A\u0639\u0627\u0628 \u0627\u0644\u0645\u0631\u0627\u062D\u0644 \u0644\u0627 \u062A\u0633\u0627\u0648\u064A 100 %",
                text: "\xAB\u0627\u0644\u0639\u0642\u062F \u0645\u063A\u0644\u0642\xBB: \u0623\u064F\u0635\u062F\u0631\u062A \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629 \u0627\u0644\u0646\u0647\u0627\u0626\u064A\u0629 \u0648\u0644\u0627 \u0634\u064A\u0621 \u064A\u064F\u0639\u062F\u0651 \u0628\u0639\u062F \u0630\u0644\u0643. \xAB\u062D\u0635\u0635 \u0623\u062A\u0639\u0627\u0628 \u0627\u0644\u0645\u0631\u0627\u062D\u0644 \u0644\u0627 \u062A\u0633\u0627\u0648\u064A 100 %\xBB: \u0635\u062D\u0651\u062D\u0647\u0627 \u0639\u0628\u0631 \u0627\u0644\u0631\u0627\u0628\u0637 \xAB\u0641\u062A\u062D \u0645\u0631\u0627\u062D\u0644 \u0627\u0644\u0645\u0634\u0631\u0648\u0639\xBB."
              },
              errors: {
                term: "\u062A\u0639\u0630\u0651\u0631 \u0625\u0646\u0634\u0627\u0621 \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629",
                text: "\u0631\u0633\u0627\u0644\u0629 \u062A\u0634\u0631\u062D \u0627\u0644\u0633\u0628\u0628\u060C \u0645\u062B\u0644\u064B\u0627 \u0625\u0630\u0627 \u0644\u0645 \u064A\u0643\u0646 \u0647\u0646\u0627\u0643 \u0645\u0627 \u064A\u064F\u0641\u0648\u062A\u0631 \u0645\u0646\u0630 \u0622\u062E\u0631 \u0641\u0627\u062A\u0648\u0631\u0629 \u0623\u0648 \u0625\u0630\u0627 \u0643\u0627\u0646\u062A \u0641\u0627\u062A\u0648\u0631\u0629 \u062A\u0642\u062F\u0651\u0645 \u0645\u0627 \u062A\u0632\u0627\u0644 \u0645\u0633\u0648\u062F\u0629."
              }
            }
          },
          phases: {
            title: "\u0627\u0644\u062A\u0642\u062F\u0651\u0645 \u062D\u0633\u0628 \u0627\u0644\u0645\u0631\u0627\u062D\u0644",
            items: {
              help: {
                term: "\u0627\u0644\u062A\u0642\u062F\u0651\u0645 \u0627\u0644\u062A\u0631\u0627\u0643\u0645\u064A",
                text: "\u0623\u062F\u062E\u0644 \u0644\u0643\u0644 \u0645\u0631\u062D\u0644\u0629 \u0627\u0644\u062A\u0642\u062F\u0651\u0645 \u0627\u0644\u062A\u0631\u0627\u0643\u0645\u064A \u0645\u0646\u0630 \u0627\u0644\u0628\u062F\u0627\u064A\u0629: \u064A\u064F\u062D\u062A\u0633\u0628 \u0645\u0628\u0644\u063A \u0627\u0644\u0641\u062A\u0631\u0629 \u0645\u0628\u0627\u0634\u0631\u0629\u060C \u0648\u064A\u064F\u0637\u0628\u0639 \u0627\u0644\u062C\u062F\u0648\u0644 \u062D\u0633\u0628 \u0627\u0644\u0645\u0631\u0627\u062D\u0644 \u0639\u0644\u0649 \u0645\u0644\u0641 \u2066PDF\u2069."
              },
              final: {
                term: "\u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629 \u0627\u0644\u0646\u0647\u0627\u0626\u064A\u0629 \u0639\u0646\u062F \u0627\u0644\u0642\u0628\u0648\u0644 \u0627\u0644\u0646\u0647\u0627\u0626\u064A",
                text: "\u0645\u0641\u062A\u0627\u062D: \u062A\u0635\u0628\u062D \u0643\u0644 \u0627\u0644\u0645\u0631\u0627\u062D\u0644 100 %\u060C \u0648\u064A\u064F\u0633\u062A\u0631\u062C\u0639 \u0645\u0627 \u062A\u0628\u0642\u0649 \u0645\u0646 \u0627\u0644\u062F\u0641\u0639\u0629 \u0627\u0644\u0645\u0633\u0628\u0642\u0629 \u0648\u064A\u064F\u0631\u0641\u0639 \u0627\u0644\u0627\u062D\u062A\u0641\u0627\u0638 \u0628\u0627\u0644\u0636\u0645\u0627\u0646. \u0648\u062A\u064F\u063A\u0644\u0642 \u062D\u0642\u0648\u0644 \u0627\u0644\u0646\u0633\u0628 \u062D\u064A\u0646\u0626\u0630."
              },
              phase: {
                term: "\u0627\u0644\u0645\u0631\u062D\u0644\u0629",
                text: "\u0627\u0633\u0645 \u0645\u0631\u062D\u0644\u0629 \u0627\u0644\u0645\u0634\u0631\u0648\u0639."
              },
              fee: {
                term: "\u0623\u062A\u0639\u0627\u0628 \u0627\u0644\u0645\u0631\u062D\u0644\u0629",
                text: "\u0627\u0644\u062D\u0635\u0629 \u0645\u0646 \u0645\u0628\u0644\u063A \u0627\u0644\u0639\u0642\u062F \u0627\u0644\u062A\u064A \u062A\u0639\u0648\u062F \u0625\u0644\u0649 \u0647\u0630\u0647 \u0627\u0644\u0645\u0631\u062D\u0644\u0629."
              },
              previous: {
                term: "\u0627\u0644\u0645\u0641\u0648\u062A\u0631 \u0633\u0627\u0628\u0642\u064B\u0627",
                text: "\u0646\u0633\u0628\u0629 \u0627\u0644\u0645\u0631\u062D\u0644\u0629 \u0627\u0644\u062A\u064A \u0641\u064F\u0648\u062A\u0631\u062A \u0645\u0646 \u0642\u0628\u0644 \u0641\u064A \u0641\u0648\u0627\u062A\u064A\u0631 \u062A\u0642\u062F\u0651\u0645 \u0633\u0627\u0628\u0642\u0629."
              },
              cumulative: {
                term: "\u0627\u0644\u062A\u0631\u0627\u0643\u0645 \u0627\u0644\u062C\u062F\u064A\u062F",
                text: "\u0644\u0644\u062A\u0639\u0628\u0626\u0629: \u0627\u0644\u0646\u0633\u0628\u0629 \u0627\u0644\u062A\u0631\u0627\u0643\u0645\u064A\u0629 \u0627\u0644\u062C\u062F\u064A\u062F\u0629 \u0644\u0644\u0645\u0631\u062D\u0644\u0629 (\u0645\u0646 0 \u0625\u0644\u0649 100 \u0628\u062E\u0627\u0646\u062A\u064A\u0646 \u0639\u0634\u0631\u064A\u062A\u064A\u0646 \u0639\u0644\u0649 \u0627\u0644\u0623\u0643\u062B\u0631). \u0644\u0627 \u064A\u0645\u0643\u0646 \u0623\u0646 \u062A\u0642\u0644 \u0639\u0646 \xAB\u0627\u0644\u0645\u0641\u0648\u062A\u0631 \u0633\u0627\u0628\u0642\u064B\u0627\xBB."
              },
              period: {
                term: "\u0645\u0628\u0644\u063A \u0627\u0644\u0641\u062A\u0631\u0629",
                text: "\u064A\u064F\u062D\u062A\u0633\u0628 \u0644\u0643: \u0627\u0644\u0645\u0628\u0644\u063A \u0627\u0644\u0645\u0637\u0644\u0648\u0628 \u0641\u0648\u062A\u0631\u062A\u0647 \u0647\u0630\u0647 \u0627\u0644\u0645\u0631\u0629 \u0644\u0644\u0645\u0631\u062D\u0644\u0629\u061B \u0648\xAB\u2014\xBB \u0625\u0630\u0627 \u062A\u0639\u0630\u0651\u0631 \u0627\u0644\u0627\u062D\u062A\u0633\u0627\u0628."
              }
            }
          },
          totals: {
            title: "\u0645\u0628\u0627\u0644\u063A \u0647\u0630\u0647 \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629",
            items: {
              work: {
                term: "\u0623\u0634\u063A\u0627\u0644 \u0627\u0644\u0641\u062A\u0631\u0629 (\u062F\u0648\u0646 \u0627\u062D\u062A\u0633\u0627\u0628 \u0627\u0644\u0623\u062F\u0627\u0621\u0627\u062A)",
                text: "\u0645\u062C\u0645\u0648\u0639 \u0645\u0628\u0627\u0644\u063A \u0627\u0644\u0641\u062A\u0631\u0629 \u0642\u0628\u0644 \u0627\u0644\u0623\u062F\u0627\u0621\u0627\u062A."
              },
              advanceRecovery: {
                term: "\u0627\u0633\u062A\u0631\u062C\u0627\u0639 \u0627\u0644\u062F\u0641\u0639\u0629 \u0627\u0644\u0645\u0633\u0628\u0642\u0629",
                text: "\u0627\u0644\u062C\u0632\u0621 \u0645\u0646 \u0627\u0644\u062F\u0641\u0639\u0629 \u0627\u0644\u0645\u0633\u0628\u0642\u0629 \u0627\u0644\u0645\u062F\u0641\u0648\u0639\u0629 \u0641\u064A \u0627\u0644\u0628\u062F\u0627\u064A\u0629 \u0627\u0644\u0630\u064A \u064A\u064F\u0633\u062A\u0631\u062C\u0639 \u0641\u064A \u0647\u0630\u0647 \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629."
              },
              retention: {
                term: "\u0627\u0644\u0627\u062D\u062A\u0641\u0627\u0638 \u0628\u0627\u0644\u0636\u0645\u0627\u0646 / \u0631\u0641\u0639 \u0627\u0644\u0627\u062D\u062A\u0641\u0627\u0638 \u0628\u0627\u0644\u0636\u0645\u0627\u0646",
                text: "\u0627\u0644\u0627\u062D\u062A\u0641\u0627\u0638 \u0627\u0644\u0645\u0642\u062A\u0637\u0639 \u0645\u0646 \u0647\u0630\u0647 \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629 (\u0645\u0639 \u0646\u0633\u0628\u062A\u0647)\u061B \u0648\u0641\u064A \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629 \u0627\u0644\u0646\u0647\u0627\u0626\u064A\u0629 \u064A\u062D\u0644 \u0645\u062D\u0644\u0647 \u0631\u0641\u0639 \u0627\u0644\u0627\u062D\u062A\u0641\u0627\u0638."
              },
              net: {
                term: "\u0635\u0627\u0641\u064A \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629 \u062F\u0648\u0646 \u0627\u062D\u062A\u0633\u0627\u0628 \u0627\u0644\u0623\u062F\u0627\u0621\u0627\u062A",
                text: "\u0627\u0644\u0646\u062A\u064A\u062C\u0629: \u0627\u0644\u0623\u0634\u063A\u0627\u0644 \u0646\u0627\u0642\u0635 \u0627\u0633\u062A\u0631\u062C\u0627\u0639 \u0627\u0644\u062F\u0641\u0639\u0629 \u0627\u0644\u0645\u0633\u0628\u0642\u0629 \u0646\u0627\u0642\u0635 \u0627\u0644\u0627\u062D\u062A\u0641\u0627\u0638 (\u0623\u0648 \u0632\u0627\u0626\u062F \u0631\u0641\u0639\u0647)."
              },
              taxesHint: {
                term: "\u0627\u0644\u0623\u062F\u0627\u0621\u0627\u062A \u0648\u0627\u0644\u0637\u0627\u0628\u0639 \u0648\u0627\u0644\u062E\u0635\u0645 \u0645\u0646 \u0627\u0644\u0645\u0648\u0631\u062F",
                text: "\u062A\u064F\u062D\u062A\u0633\u0628 \u0627\u0644\u0623\u062F\u0627\u0621\u0627\u062A \u0639\u0644\u0649 \u0627\u0644\u0642\u064A\u0645\u0629 \u0627\u0644\u0645\u0636\u0627\u0641\u0629 \u0648\u0645\u0639\u0644\u0648\u0645 \u0627\u0644\u0637\u0627\u0628\u0639 \u0648\u0627\u0644\u062E\u0635\u0645 \u0645\u0646 \u0627\u0644\u0645\u0648\u0631\u062F \u0639\u0644\u0649 \u0645\u0633\u0648\u062F\u0629 \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629 \u0627\u0644\u062A\u064A \u062A\u064F\u0641\u062A\u062D \u0628\u0639\u062F \u0627\u0644\u062D\u0641\u0638. \u0648\u0625\u0630\u0627 \u0643\u0627\u0646\u062A \u0646\u0633\u0628\u0629 \u062E\u0627\u0637\u0626\u0629 \u062A\u0637\u0644\u0628 \u0645\u0646\u0643 \u0631\u0633\u0627\u0644\u0629 \u062A\u0635\u062D\u064A\u062D\u0647\u0627 \u0623\u0648\u0644\u064B\u0627."
              }
            }
          },
          options: {
            title: "\u062E\u064A\u0627\u0631\u0627\u062A \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629",
            items: {
              language: {
                term: "\u0644\u063A\u0629 \u0645\u0644\u0641 \u2066PDF\u2069",
                text: "\u0644\u063A\u0629 \u0627\u0644\u0648\u062B\u064A\u0642\u0629 \u0627\u0644\u0645\u0631\u0633\u0644\u0629 \u0625\u0644\u0649 \u0627\u0644\u062D\u0631\u064A\u0641: \u0627\u0644\u0641\u0631\u0646\u0633\u064A\u0629 \u0623\u0648 \u0627\u0644\u0639\u0631\u0628\u064A\u0629 \u0623\u0648 \u062B\u0646\u0627\u0626\u064A \u0627\u0644\u0644\u063A\u0629 (\u0627\u0644\u0641\u0631\u0646\u0633\u064A\u0629 \u0648\u0627\u0644\u0639\u0631\u0628\u064A\u0629)."
              },
              dueDate: {
                term: "\u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0627\u0633\u062A\u062D\u0642\u0627\u0642",
                text: "\u0627\u062E\u062A\u064A\u0627\u0631\u064A: \u062F\u0648\u0646 \u062A\u0627\u0631\u064A\u062E \u062A\u064F\u0637\u0628\u0651\u0642 \u0634\u0631\u0648\u0637 \u0627\u0644\u062F\u0641\u0639 \u0627\u0644\u062E\u0627\u0635\u0629 \u0628\u0627\u0644\u062D\u0631\u064A\u0641."
              },
              notes: {
                term: "\u0645\u0644\u0627\u062D\u0638\u0627\u062A",
                text: "\u0627\u062E\u062A\u064A\u0627\u0631\u064A: \u0646\u0635 \u062D\u0631 \u0644\u0627 \u064A\u062A\u062C\u0627\u0648\u0632 2000 \u062D\u0631\u0641 \u064A\u062E\u0635 \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629."
              }
            }
          }
        }
      },
      invoices: {
        title: "\u0627\u0644\u0641\u0648\u0627\u062A\u064A\u0631",
        intro: "\u0642\u0627\u0626\u0645\u0629 \u0643\u0644 \u0641\u0648\u0627\u062A\u064A\u0631 \u0645\u0643\u062A\u0628\u0643 (\u0627\u0644\u0633\u0644\u0641\u0627\u062A \u0648\u0627\u0644\u062A\u0633\u0628\u0642\u0627\u062A \u0648\u0627\u0644\u0641\u0648\u0627\u062A\u064A\u0631 \u0627\u0644\u0645\u0631\u062D\u0644\u064A\u0629 \u0648\u0627\u0644\u0641\u0648\u0627\u062A\u064A\u0631 \u0627\u0644\u0646\u0647\u0627\u0626\u064A\u0629 \u0648\u0627\u0644\u0641\u0648\u0627\u062A\u064A\u0631 \u0627\u0644\u062A\u0639\u062F\u064A\u0644\u064A\u0629) \u0645\u0639 \u062D\u0627\u0644\u062A\u0647\u0627 \u0648\u0625\u0631\u0633\u0627\u0644\u0647\u0627 \u0643\u0641\u0627\u062A\u0648\u0631\u0629 \u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A\u0629 \u0648\u062F\u0641\u0639\u0647\u0627. \u062A\u0633\u062A\u0639\u0645\u0644\u0647\u0627 \u0644\u0644\u0639\u062B\u0648\u0631 \u0639\u0644\u0649 \u0641\u0627\u062A\u0648\u0631\u0629 \u0648\u0645\u0639\u0631\u0641\u0629 \u0645\u0627 \u0628\u0642\u064A \u0644\u0644\u0627\u0633\u062A\u062E\u0644\u0627\u0635 \u0648\u0625\u0646\u0634\u0627\u0621 \u0641\u0627\u062A\u0648\u0631\u0629 \u062C\u062F\u064A\u062F\u0629.",
        sections: {
          header: {
            title: "\u0631\u0623\u0633 \u0627\u0644\u0635\u0641\u062D\u0629",
            items: {
              subNav: {
                term: "\u0627\u0644\u0645\u0627\u0644\u064A\u0629",
                text: "\u062A\u0639\u0631\u0636 \u0627\u0644\u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u064A\u0645\u0646\u0649 \u0623\u0642\u0633\u0627\u0645 \u0627\u0644\u0645\u0627\u0644\u064A\u0629 \u0627\u0644\u062A\u064A \u062A\u0633\u0645\u062D \u0628\u0647\u0627 \u0635\u0644\u0627\u062D\u064A\u0627\u062A\u0643 (\u0627\u0644\u0639\u0631\u0648\u0636 \u0627\u0644\u0645\u0627\u0644\u064A\u0629 \u0648\u0627\u0644\u0639\u0642\u0648\u062F \u0648\u0627\u0644\u0641\u0648\u0627\u062A\u064A\u0631 \u0648\u0627\u0644\u062F\u0641\u0648\u0639\u0627\u062A\u2026)\u060C \u0648\u0639\u0644\u0649 \u0627\u0644\u0634\u0627\u0634\u0629 \u0627\u0644\u0635\u063A\u064A\u0631\u0629 \u062A\u062A\u062D\u0648\u0644 \u0625\u0644\u0649 \u0635\u0641 \u0645\u0646 \u0627\u0644\u0631\u0648\u0627\u0628\u0637."
              },
              newInvoice: {
                term: "\u0641\u0627\u062A\u0648\u0631\u0629 \u062C\u062F\u064A\u062F\u0629",
                text: "\u064A\u0641\u062A\u062D \u0641\u0627\u062A\u0648\u0631\u0629 \u0641\u0627\u0631\u063A\u0629. \u0644\u0627 \u064A\u0638\u0647\u0631 \u0625\u0644\u0627 \u0625\u0630\u0627 \u0643\u0646\u062A \u062A\u0645\u0644\u0643 \u0635\u0644\u0627\u062D\u064A\u0629 \u0625\u0646\u0634\u0627\u0621 \u0627\u0644\u0641\u0648\u0627\u062A\u064A\u0631\u060C \u0648\u064A\u0643\u0648\u0646 \u0645\u0639\u0637\u0651\u0644\u064B\u0627 \u0625\u0630\u0627 \u0643\u0627\u0646 \u062D\u0633\u0627\u0628 \u0627\u0644\u0645\u0643\u062A\u0628 \u0644\u0644\u0627\u0637\u0644\u0627\u0639 \u0641\u0642\u0637."
              }
            }
          },
          filters: {
            title: "\u0645\u0631\u0634\u062D\u0627\u062A \u0627\u0644\u0641\u0648\u0627\u062A\u064A\u0631",
            items: {
              status: {
                term: "\u0627\u0644\u062D\u0627\u0644\u0629",
                text: "\u064A\u0639\u0631\u0636 \u0641\u0642\u0637 \u0627\u0644\u0641\u0648\u0627\u062A\u064A\u0631 \u0627\u0644\u0645\u0633\u0648\u062F\u0629 \u0623\u0648 \u0627\u0644\u0635\u0627\u062F\u0631\u0629 \u0623\u0648 \u0627\u0644\u0645\u0644\u063A\u0627\u0629 \u0628\u0641\u0627\u062A\u0648\u0631\u0629 \u062A\u0639\u062F\u064A\u0644\u064A\u0629\u061B \u0648\xAB\u0643\u0644 \u0627\u0644\u062D\u0627\u0644\u0627\u062A\xBB \u062A\u0639\u0631\u0636 \u0627\u0644\u062C\u0645\u064A\u0639."
              },
              payment: {
                term: "\u0627\u0644\u062F\u0641\u0639",
                text: "\u064A\u0639\u0631\u0636 \u0641\u0642\u0637 \u0627\u0644\u0641\u0648\u0627\u062A\u064A\u0631 \u063A\u064A\u0631 \u0627\u0644\u0645\u062F\u0641\u0648\u0639\u0629 \u0623\u0648 \u0627\u0644\u0645\u062F\u0641\u0648\u0639\u0629 \u062C\u0632\u0626\u064A\u064B\u0627 \u0623\u0648 \u0627\u0644\u0645\u062F\u0641\u0648\u0639\u0629\u061B \u0648\xAB\u0643\u0644 \u062D\u0627\u0644\u0627\u062A \u0627\u0644\u062F\u0641\u0639\xBB \u062A\u0639\u0631\u0636 \u0627\u0644\u062C\u0645\u064A\u0639."
              },
              kind: {
                term: "\u0627\u0644\u0646\u0648\u0639",
                text: "\u064A\u0639\u0631\u0636 \u0646\u0648\u0639\u064B\u0627 \u0648\u0627\u062D\u062F\u064B\u0627 \u0645\u0646 \u0627\u0644\u0641\u0648\u0627\u062A\u064A\u0631 (\u0633\u0644\u0641\u0629 \u0623\u0648 \u062A\u0633\u0628\u0642\u0629 \u0623\u0648 \u0645\u0631\u062D\u0644\u064A\u0629 \u0623\u0648 \u0646\u0647\u0627\u0626\u064A\u0629 \u0623\u0648 \u062A\u0639\u062F\u064A\u0644\u064A\u0629)\u061B \u0648\xAB\u0643\u0644 \u0627\u0644\u0623\u0646\u0648\u0627\u0639\xBB \u062A\u0639\u0631\u0636 \u0627\u0644\u062C\u0645\u064A\u0639."
              },
              clear: {
                term: "\u0645\u0633\u062D \u0627\u0644\u0645\u0631\u0634\u062D\u0627\u062A",
                text: "\u064A\u0638\u0647\u0631 \u0639\u0646\u062F\u0645\u0627 \u0644\u0627 \u062A\u0633\u062A\u062C\u064A\u0628 \u0623\u064A \u0641\u0627\u062A\u0648\u0631\u0629 \u0644\u0644\u0645\u0631\u0634\u062D\u0627\u062A \u0627\u0644\u0645\u062E\u062A\u0627\u0631\u0629\u061B \u0648\u064A\u0639\u064A\u062F \u0627\u0644\u0645\u0631\u0634\u062D\u0627\u062A \u0627\u0644\u062B\u0644\u0627\u062B\u0629 \u0625\u0644\u0649 \u0648\u0636\u0639\u0647\u0627 \u0627\u0644\u0623\u0648\u0644."
              }
            }
          },
          table: {
            title: "\u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u0641\u0648\u0627\u062A\u064A\u0631",
            items: {
              number: {
                term: "\u0627\u0644\u0631\u0642\u0645",
                text: "\u0627\u0644\u0631\u0642\u0645 \u0627\u0644\u0646\u0647\u0627\u0626\u064A \u0644\u0644\u0641\u0627\u062A\u0648\u0631\u0629\u060C \u064A\u064F\u0645\u0646\u062D \u0639\u0646\u062F \u0627\u0644\u0625\u0635\u062F\u0627\u0631. \u0644\u064A\u0633 \u0644\u0644\u0645\u0633\u0648\u062F\u0629 \u0631\u0642\u0645 \u0628\u0639\u062F: \u062A\u0639\u0631\u0636 \xAB\u0645\u0633\u0648\u062F\u0629\xBB. \u0627\u0646\u0642\u0631 \u0639\u0644\u064A\u0647 \u0644\u0641\u062A\u062D \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629."
              },
              client: {
                term: "\u0627\u0644\u062D\u0631\u064A\u0641",
                text: "\u0627\u0644\u062D\u0631\u064A\u0641 \u0627\u0644\u0630\u064A \u062A\u0648\u062C\u064E\u0651\u0647 \u0625\u0644\u064A\u0647 \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629."
              },
              kind: {
                term: "\u0627\u0644\u0646\u0648\u0639",
                text: "\u0646\u0648\u0639 \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629 (\u0627\u0646\u0638\u0631 \xAB\u0623\u0646\u0648\u0627\u0639 \u0627\u0644\u0641\u0648\u0627\u062A\u064A\u0631\xBB)."
              },
              status: {
                term: "\u0627\u0644\u062D\u0627\u0644\u0629",
                text: "\u062D\u0627\u0644\u0629 \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629 \u0646\u0641\u0633\u0647\u0627 (\u0627\u0646\u0638\u0631 \xAB\u062D\u0627\u0644\u0627\u062A \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629 \u0648\u0627\u0644\u062F\u0641\u0639\xBB)."
              },
              ttn: {
                term: "\u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629 \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A\u0629 (\u2066TTN\u2069)",
                text: "\u0623\u064A\u0646 \u0628\u0644\u063A \u0625\u0631\u0633\u0627\u0644 \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629 \u0625\u0644\u0649 \u2066TTN\u2069\u060C \u0627\u0644\u0645\u0646\u0635\u0629 \u0627\u0644\u0631\u0633\u0645\u064A\u0629 \u0644\u0644\u0641\u0648\u062A\u0631\u0629 \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A\u0629\u061B \u0648\xAB\u2014\xBB \u0644\u0644\u0645\u0633\u0648\u062F\u0629."
              },
              payment: {
                term: "\u0627\u0644\u062F\u0641\u0639",
                text: "\u0647\u0644 \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629 \u0645\u062F\u0641\u0648\u0639\u0629\u061B \u0648\xAB\u2014\xBB \u0644\u0644\u0645\u0633\u0648\u062F\u0629 \u0648\u0644\u0644\u0641\u0627\u062A\u0648\u0631\u0629 \u0627\u0644\u062A\u0639\u062F\u064A\u0644\u064A\u0629."
              }
            }
          },
          amounts: {
            title: "\u0627\u0644\u0645\u0628\u0627\u0644\u063A \u0648\u0627\u0644\u062A\u0648\u0627\u0631\u064A\u062E",
            items: {
              totalTtc: {
                term: "\u0627\u0644\u0645\u062C\u0645\u0648\u0639 \u0628\u0627\u062D\u062A\u0633\u0627\u0628 \u0643\u0644 \u0627\u0644\u0623\u062F\u0627\u0621\u0627\u062A",
                text: "\u0645\u062C\u0645\u0648\u0639 \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629 \u0628\u0639\u062F \u0627\u062D\u062A\u0633\u0627\u0628 \u0643\u0644 \u0627\u0644\u0623\u062F\u0627\u0621\u0627\u062A."
              },
              netPayable: {
                term: "\u0627\u0644\u0635\u0627\u0641\u064A \u0644\u0644\u062F\u0641\u0639",
                text: "\u0645\u0627 \u064A\u062C\u0628 \u0639\u0644\u0649 \u0627\u0644\u062D\u0631\u064A\u0641 \u062F\u0641\u0639\u0647 \u0644\u0643 \u0641\u0639\u0644\u064B\u0627 \u0628\u0639\u062F \u0627\u0644\u0627\u0642\u062A\u0637\u0627\u0639\u0627\u062A \u0625\u0646 \u0648\u064F\u062C\u062F\u062A."
              },
              issueDate: {
                term: "\u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0625\u0635\u062F\u0627\u0631",
                text: "\u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0625\u0635\u062F\u0627\u0631\u061B \u0648\xAB\u2014\xBB \u0644\u0644\u0645\u0633\u0648\u062F\u0629."
              },
              dueDate: {
                term: "\u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0627\u0633\u062A\u062D\u0642\u0627\u0642",
                text: "\u0622\u062E\u0631 \u0623\u062C\u0644 \u0644\u0644\u062F\u0641\u0639\u061B \u0648\xAB\u2014\xBB \u0625\u0630\u0627 \u0644\u0645 \u064A\u064F\u062D\u062F\u064E\u0651\u062F."
              }
            }
          },
          statuses: {
            title: "\u062D\u0627\u0644\u0627\u062A \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629 \u0648\u0627\u0644\u062F\u0641\u0639",
            items: {
              draft: {
                term: "\u0645\u0633\u0648\u062F\u0629",
                text: "\u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629 \u0642\u064A\u062F \u0627\u0644\u0625\u0639\u062F\u0627\u062F: \u0644\u064A\u0633 \u0644\u0647\u0627 \u0631\u0642\u0645 \u0648\u064A\u0645\u0643\u0646 \u062A\u0639\u062F\u064A\u0644\u0647\u0627 \u0623\u0648 \u062D\u0630\u0641\u0647\u0627."
              },
              issued: {
                term: "\u0635\u0627\u062F\u0631\u0629",
                text: "\u0644\u0644\u0641\u0627\u062A\u0648\u0631\u0629 \u0631\u0642\u0645\u0647\u0627 \u0627\u0644\u0646\u0647\u0627\u0626\u064A \u0648\u0644\u0627 \u064A\u0645\u0643\u0646 \u062A\u0639\u062F\u064A\u0644\u0647\u0627 \u0623\u0628\u062F\u064B\u0627\u061B \u0648\u0644\u062A\u0635\u062D\u064A\u062D\u0647\u0627 \u062A\u0635\u062F\u0631 \u0641\u0627\u062A\u0648\u0631\u0629 \u062A\u0639\u062F\u064A\u0644\u064A\u0629."
              },
              credited: {
                term: "\u0645\u0644\u063A\u0627\u0629 \u0628\u0641\u0627\u062A\u0648\u0631\u0629 \u062A\u0639\u062F\u064A\u0644\u064A\u0629",
                text: "\u0623\u0644\u063A\u062A \u0641\u0627\u062A\u0648\u0631\u0629 \u062A\u0639\u062F\u064A\u0644\u064A\u0629 \u0647\u0630\u0647 \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629."
              },
              unpaid: {
                term: "\u063A\u064A\u0631 \u0645\u062F\u0641\u0648\u0639\u0629",
                text: "\u0644\u0645 \u062A\u064F\u0633\u062C\u064E\u0651\u0644 \u0623\u064A \u062F\u0641\u0639\u0629 \u0628\u0639\u062F."
              },
              partiallyPaid: {
                term: "\u0645\u062F\u0641\u0648\u0639\u0629 \u062C\u0632\u0626\u064A\u064B\u0627",
                text: "\u062F\u064F\u0641\u0639 \u062C\u0632\u0621 \u0645\u0646\u0647\u0627 \u0641\u0642\u0637."
              },
              paid: {
                term: "\u0645\u062F\u0641\u0648\u0639\u0629",
                text: "\u0633\u064F\u062F\u0651\u062F\u062A \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629 \u0628\u0627\u0644\u0643\u0627\u0645\u0644."
              }
            }
          },
          ttnStatuses: {
            title: "\u062D\u0627\u0644\u0627\u062A \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629 \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A\u0629 (\u2066TTN\u2069)",
            items: {
              notRequired: {
                term: "\u063A\u064A\u0631 \u0645\u0637\u0644\u0648\u0628\u0629",
                text: "\u0644\u0627 \u062A\u0645\u0631 \u0647\u0630\u0647 \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629 \u0639\u0628\u0631 \u0627\u0644\u0641\u0648\u062A\u0631\u0629 \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A\u0629."
              },
              pending: {
                term: "\u0642\u064A\u062F \u0627\u0644\u0627\u0646\u062A\u0638\u0627\u0631",
                text: "\u0627\u0644\u0625\u0631\u0633\u0627\u0644 \u0625\u0644\u0649 \u2066TTN\u2069 \u0642\u064A\u062F \u0627\u0644\u0625\u0639\u062F\u0627\u062F."
              },
              submitted: {
                term: "\u0645\u064F\u0631\u0633\u064E\u0644\u0629",
                text: "\u0623\u064F\u0631\u0633\u0644\u062A \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629 \u0625\u0644\u0649 \u2066TTN\u2069 \u0627\u0644\u0630\u064A \u0645\u0627 \u0632\u0627\u0644 \u0639\u0644\u064A\u0647 \u0623\u0646 \u064A\u0631\u062F."
              },
              submittedManually: {
                term: "\u0645\u064F\u0631\u0633\u064E\u0644\u0629 \u064A\u062F\u0648\u064A\u064B\u0627",
                text: "\u0623\u0648\u062F\u0639\u062A \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629 \u0628\u0646\u0641\u0633\u0643 \u0639\u0644\u0649 \u0628\u0648\u0627\u0628\u0629 \u2066TTN\u2069."
              },
              accepted: {
                term: "\u0645\u0642\u0628\u0648\u0644\u0629",
                text: "\u0642\u0628\u0644 \u2066TTN\u2069 \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629."
              },
              rejected: {
                term: "\u0645\u0631\u0641\u0648\u0636\u0629",
                text: "\u0631\u0641\u0636 \u2066TTN\u2069 \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629\u061B \u0648\u062A\u0634\u0631\u062D \u0634\u0627\u0634\u0629 \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629 \u0645\u0627 \u064A\u062C\u0628 \u0641\u0639\u0644\u0647."
              }
            }
          },
          kinds: {
            title: "\u0623\u0646\u0648\u0627\u0639 \u0627\u0644\u0641\u0648\u0627\u062A\u064A\u0631",
            items: {
              advance: {
                term: "\u0641\u0627\u062A\u0648\u0631\u0629 \u0633\u0644\u0641\u0629",
                text: "\u0641\u0627\u062A\u0648\u0631\u0629 \u0644\u0645\u0628\u0644\u063A \u064A\u064F\u0637\u0644\u0628 \u0641\u064A \u0628\u062F\u0627\u064A\u0629 \u0627\u0644\u0639\u0642\u062F."
              },
              deposit: {
                term: "\u0641\u0627\u062A\u0648\u0631\u0629 \u062A\u0633\u0628\u0642\u0629",
                text: "\u0641\u0627\u062A\u0648\u0631\u0629 \u0644\u062F\u0641\u0639\u0629 \u062C\u0632\u0626\u064A\u0629 \u062A\u064F\u0637\u0644\u0628 \u0645\u0633\u0628\u0642\u064B\u0627."
              },
              progress: {
                term: "\u0641\u0627\u062A\u0648\u0631\u0629 \u0645\u0631\u062D\u0644\u064A\u0629",
                text: "\u0641\u0627\u062A\u0648\u0631\u0629 \u062A\u064F\u0646\u0634\u0623 \u0628\u062D\u0633\u0628 \u062A\u0642\u062F\u0651\u0645 \u0627\u0644\u0623\u0634\u063A\u0627\u0644 \u0623\u0648 \u0627\u0644\u0645\u0631\u0627\u062D\u0644."
              },
              final: {
                term: "\u0641\u0627\u062A\u0648\u0631\u0629 \u0646\u0647\u0627\u0626\u064A\u0629",
                text: "\u0622\u062E\u0631 \u0641\u0627\u062A\u0648\u0631\u0629 \u0641\u064A \u0627\u0644\u0639\u0642\u062F\u060C \u0639\u0646\u062F \u0627\u0644\u0642\u0628\u0648\u0644 \u0627\u0644\u0646\u0647\u0627\u0626\u064A."
              },
              creditNote: {
                term: "\u0641\u0627\u062A\u0648\u0631\u0629 \u062A\u0639\u062F\u064A\u0644\u064A\u0629",
                text: "\u0648\u062B\u064A\u0642\u0629 \u062A\u0644\u063A\u064A \u0643\u0644 \u0641\u0627\u062A\u0648\u0631\u0629 \u0635\u0627\u062F\u0631\u0629 \u0623\u0648 \u062C\u0632\u0621\u064B\u0627 \u0645\u0646\u0647\u0627."
              }
            }
          },
          empty: {
            title: "\u0627\u0644\u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u0641\u0627\u0631\u063A\u0629 \u0648\u0627\u0644\u0623\u062E\u0637\u0627\u0621 \u0648\u0627\u0644\u062A\u062D\u0645\u064A\u0644",
            items: {
              none: {
                term: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0641\u0648\u0627\u062A\u064A\u0631 \u0628\u0639\u062F",
                text: "\u0631\u0633\u0627\u0644\u0629 \u0627\u0644\u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u0641\u0627\u0631\u063A\u0629. \u062A\u0642\u062A\u0631\u062D \xAB\u0641\u0627\u062A\u0648\u0631\u0629 \u062C\u062F\u064A\u062F\u0629\xBB \u0639\u0644\u0649 \u0645\u0646 \u064A\u0633\u062A\u0637\u064A\u0639\u0648\u0646 \u0627\u0644\u0625\u0646\u0634\u0627\u0621\u060C \u0623\u0645\u0627 \u063A\u064A\u0631\u0647\u0645 \u0641\u064A\u0631\u0648\u0646 \u0623\u0646 \u0641\u0648\u0627\u062A\u064A\u0631 \u0645\u0643\u062A\u0628\u0647\u0645 \u0633\u062A\u0638\u0647\u0631 \u0647\u0646\u0627."
              },
              noMatch: {
                term: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0641\u0627\u062A\u0648\u0631\u0629 \u0645\u0637\u0627\u0628\u0642\u0629",
                text: "\u0631\u0633\u0627\u0644\u0629 \u062A\u0638\u0647\u0631 \u0639\u0646\u062F\u0645\u0627 \u0644\u0627 \u062A\u062C\u062F \u0627\u0644\u0645\u0631\u0634\u062D\u0627\u062A \u0634\u064A\u0626\u064B\u0627\u061B \u0648\xAB\u0645\u0633\u062D \u0627\u0644\u0645\u0631\u0634\u062D\u0627\u062A\xBB \u062A\u0632\u064A\u0644\u0647\u0627."
              },
              loadMore: {
                term: "\u0639\u0631\u0636 \u0627\u0644\u0645\u0632\u064A\u062F \u0645\u0646 \u0627\u0644\u0641\u0648\u0627\u062A\u064A\u0631",
                text: "\u062A\u062D\u062A \u0627\u0644\u0642\u0627\u0626\u0645\u0629: \u064A\u062D\u0645\u0651\u0644 \u0627\u0644\u0641\u0648\u0627\u062A\u064A\u0631 \u0627\u0644\u062A\u0627\u0644\u064A\u0629."
              },
              loadError: {
                term: "\u062A\u0639\u0630\u0651\u0631 \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0641\u0648\u0627\u062A\u064A\u0631",
                text: "\u0631\u0633\u0627\u0644\u0629 \u062E\u0637\u0623 \u0639\u0646\u062F \u0648\u062C\u0648\u062F \u0645\u0634\u0643\u0644 \u0641\u064A \u0627\u0644\u0627\u062A\u0635\u0627\u0644\u061B \u0648\xAB\u0625\u0639\u0627\u062F\u0629 \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629\xBB \u062A\u0639\u064A\u062F \u0627\u0644\u062A\u062D\u0645\u064A\u0644."
              }
            }
          }
        }
      },
      invoice: {
        title: "\u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629 (\u062C\u062F\u064A\u062F\u0629 \u0623\u0648 \u0645\u0648\u062C\u0648\u062F\u0629)",
        intro: "\u0634\u0627\u0634\u0629 \u0641\u0627\u062A\u0648\u0631\u0629 \u0648\u0627\u062D\u062F\u0629: \u062A\u064F\u0639\u062F\u0651 \u0645\u0633\u0648\u062F\u0629 (\u0627\u0644\u062D\u0631\u064A\u0641 \u0648\u0627\u0644\u0628\u0646\u0648\u062F \u0648\u0627\u0644\u0623\u062F\u0627\u0621 \u0639\u0644\u0649 \u0627\u0644\u0642\u064A\u0645\u0629 \u0627\u0644\u0645\u0636\u0627\u0641\u0629) \u0648\u062A\u0631\u0649 \u0627\u0644\u0645\u062C\u0627\u0645\u064A\u0639 \u0645\u0628\u0627\u0634\u0631\u0629 \u062B\u0645 \u062A\u0635\u062F\u0631\u0647\u0627. \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629 \u0627\u0644\u0635\u0627\u062F\u0631\u0629 \u0623\u0648 \u0627\u0644\u062A\u0639\u062F\u064A\u0644\u064A\u0629 \u0644\u0644\u0627\u0637\u0644\u0627\u0639 \u0641\u0642\u0637\u061B \u0648\u0641\u064A\u0647\u0627 \u062A\u062A\u0627\u0628\u0639 \u0627\u0644\u0625\u0631\u0633\u0627\u0644 \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A \u0648\u0627\u0644\u062F\u0641\u0648\u0639\u0627\u062A.",
        sections: {
          header: {
            title: "\u0627\u0644\u0631\u0623\u0633 \u0648\u0627\u0644\u0625\u062C\u0631\u0627\u0621\u0627\u062A",
            items: {
              subNav: {
                term: "\u0627\u0644\u0645\u0627\u0644\u064A\u0629",
                text: "\u062A\u062A\u064A\u062D \u0644\u0643 \u0627\u0644\u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u064A\u0645\u0646\u0649 \u0627\u0644\u0627\u0646\u062A\u0642\u0627\u0644 \u0625\u0644\u0649 \u0642\u0633\u0645 \u0622\u062E\u0631 \u0645\u0646 \u0627\u0644\u0645\u0627\u0644\u064A\u0629 \u0628\u062D\u0633\u0628 \u0635\u0644\u0627\u062D\u064A\u0627\u062A\u0643."
              },
              breadcrumb: {
                term: "\u0627\u0644\u0641\u0648\u0627\u062A\u064A\u0631",
                text: "\u0627\u0644\u0631\u0627\u0628\u0637 \u0641\u064A \u0623\u0639\u0644\u0649 \u0627\u0644\u0635\u0641\u062D\u0629 \u064A\u0639\u064A\u062F\u0643 \u0625\u0644\u0649 \u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u0641\u0648\u0627\u062A\u064A\u0631\u061B \u0648\u062A\u0637\u0644\u0628 \u0645\u0646\u0643 \u0646\u0627\u0641\u0630\u0629 \u0627\u0644\u062A\u0623\u0643\u064A\u062F \u0625\u0646 \u0628\u0642\u064A\u062A \u062A\u0639\u062F\u064A\u0644\u0627\u062A \u063A\u064A\u0631 \u0645\u062D\u0641\u0648\u0638\u0629."
              },
              save: {
                term: "\u062D\u0641\u0638",
                text: "\u064A\u062D\u0641\u0638 \u0627\u0644\u0645\u0633\u0648\u062F\u0629\u061B \u0648\u0627\u0644\u062D\u0641\u0638 \u0627\u0644\u0623\u0648\u0644 \u064A\u0646\u0634\u0626\u0647\u0627. \u0644\u0627 \u064A\u0638\u0647\u0631 \u0625\u0644\u0627 \u0644\u0645\u0633\u0648\u062F\u0629 \u062A\u0633\u062A\u0637\u064A\u0639 \u062A\u0639\u062F\u064A\u0644\u0647\u0627."
              },
              issue: {
                term: "\u0625\u0635\u062F\u0627\u0631",
                text: "\u0641\u064A \u0645\u0633\u0648\u062F\u0629 \u0645\u062D\u0641\u0648\u0638\u0629: \u064A\u0645\u0646\u062D \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629 \u0631\u0642\u0645\u0647\u0627 \u0627\u0644\u0646\u0647\u0627\u0626\u064A. \u0645\u062E\u0635\u0635 \u0644\u0645\u0646 \u064A\u0645\u0644\u0643\u0648\u0646 \u0635\u0644\u0627\u062D\u064A\u0629 \u0627\u0644\u0625\u0635\u062F\u0627\u0631\u061B \u0627\u062D\u0641\u0638 \u062A\u0639\u062F\u064A\u0644\u0627\u062A\u0643 \u0623\u0648\u0644\u064B\u0627."
              },
              pdf: {
                term: "\u0639\u0631\u0636 \u0645\u0644\u0641 \u2066PDF\u2069",
                text: "\u0641\u064A \u0641\u0627\u062A\u0648\u0631\u0629 \u0635\u0627\u062F\u0631\u0629 \u0623\u0648 \u062A\u0639\u062F\u064A\u0644\u064A\u0629: \u064A\u0641\u062A\u062D \u0645\u0644\u0641 \u2066PDF\u2069 \u0641\u064A \u062A\u0628\u0648\u064A\u0628 \u062C\u062F\u064A\u062F\u060C \u0623\u0648 \u064A\u062F\u0639\u0648\u0643 \u0625\u0644\u0649 \u0625\u0639\u0627\u062F\u0629 \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629 \u0625\u0646 \u0643\u0627\u0646 \u0642\u064A\u062F \u0627\u0644\u0625\u0639\u062F\u0627\u062F."
              },
              recordPayment: {
                term: "\u062A\u0633\u062C\u064A\u0644 \u062F\u0641\u0639\u0629",
                text: "\u0641\u064A \u0641\u0627\u062A\u0648\u0631\u0629 \u0635\u0627\u062F\u0631\u0629 \u0644\u0645 \u062A\u064F\u062F\u0641\u0639 \u0628\u0627\u0644\u0643\u0627\u0645\u0644: \u064A\u0641\u062A\u062D \u0646\u0627\u0641\u0630\u0629 \u0627\u0644\u062F\u0641\u0639\u0629 \u0627\u0644\u0645\u0633\u062A\u0644\u0645\u0629. \u0645\u062E\u0635\u0635 \u0644\u0645\u0646 \u064A\u0633\u062A\u0637\u064A\u0639\u0648\u0646 \u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062F\u0641\u0639\u0627\u062A."
              },
              creditNote: {
                term: "\u0625\u0635\u062F\u0627\u0631 \u0641\u0627\u062A\u0648\u0631\u0629 \u062A\u0639\u062F\u064A\u0644\u064A\u0629",
                text: "\u0641\u064A \u0641\u0627\u062A\u0648\u0631\u0629 \u0635\u0627\u062F\u0631\u0629: \u064A\u0641\u062A\u062D \u0646\u0627\u0641\u0630\u0629 \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629 \u0627\u0644\u062A\u0639\u062F\u064A\u0644\u064A\u0629 \u0644\u0625\u0644\u063A\u0627\u0626\u0647\u0627 \u0643\u0644\u064A\u064B\u0627 \u0623\u0648 \u062C\u0632\u0626\u064A\u064B\u0627. \u0645\u062E\u0635\u0635 \u0644\u0645\u0646 \u064A\u0645\u0644\u0643\u0648\u0646 \u0635\u0644\u0627\u062D\u064A\u0629 \u0627\u0644\u0625\u0635\u062F\u0627\u0631."
              },
              delete: {
                term: "\u062D\u0630\u0641 \u0627\u0644\u0645\u0633\u0648\u062F\u0629",
                text: "\u064A\u062D\u0630\u0641 \u0645\u0633\u0648\u062F\u0629 \u0646\u0647\u0627\u0626\u064A\u064B\u0627 \u0628\u0639\u062F \u0627\u0644\u062A\u0623\u0643\u064A\u062F\u061B \u0644\u0645 \u064A\u064F\u0633\u062A\u0647\u0644\u0643 \u0623\u064A \u0631\u0642\u0645."
              }
            }
          },
          messages: {
            title: "\u0627\u0644\u0631\u0633\u0627\u0626\u0644 \u0648\u0627\u0644\u0646\u0648\u0627\u0641\u0630",
            items: {
              readOnly: {
                term: "\u0634\u0631\u0627\u0626\u0637 \u0627\u0644\u0627\u0637\u0644\u0627\u0639 \u0641\u0642\u0637",
                text: "\xAB\u0647\u0630\u0647 \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629 \u0635\u0627\u062F\u0631\u0629: \u0644\u0627 \u064A\u0645\u0643\u0646 \u062A\u0639\u062F\u064A\u0644\u0647\u0627 \u0623\u0628\u062F\u064B\u0627\xBB (\u0645\u0639 \u062F\u0639\u0648\u0629 \u0625\u0644\u0649 \u0625\u0635\u062F\u0627\u0631 \u0641\u0627\u062A\u0648\u0631\u0629 \u062A\u0639\u062F\u064A\u0644\u064A\u0629) \u0623\u0648 \xAB\u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629 \u0627\u0644\u062A\u0639\u062F\u064A\u0644\u064A\u0629 \u0627\u0644\u0635\u0627\u062F\u0631\u0629 \u0646\u0647\u0627\u0626\u064A\u0629\xBB \u0623\u0648 \xAB\u064A\u0645\u0643\u0646\u0643 \u0627\u0644\u0627\u0637\u0644\u0627\u0639 \u0639\u0644\u0649 \u0647\u0630\u0647 \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629 \u0644\u0643\u0646\u2026\xBB \u0625\u0646 \u0644\u0645 \u062A\u0643\u0646 \u0644\u0643 \u0635\u0644\u0627\u062D\u064A\u0629 \u062A\u0639\u062F\u064A\u0644\u0647\u0627."
              },
              linesLocked: {
                term: "\u0628\u0646\u0648\u062F \u0622\u062A\u064A\u0629 \u0645\u0646 \u0643\u0634\u0641 \u0625\u0646\u062C\u0627\u0632",
                text: "\u0641\u064A \u0645\u0633\u0648\u062F\u0629 \u0622\u062A\u064A\u0629 \u0645\u0646 \u0641\u0627\u062A\u0648\u0631\u0629 \u062A\u0642\u062F\u0651\u0645 \u0627\u0644\u0623\u0634\u063A\u0627\u0644 \u062A\u0643\u0648\u0646 \u0627\u0644\u0628\u0646\u0648\u062F (\u0627\u0644\u0633\u0644\u0641\u0627\u062A \u0648\u0627\u0644\u0627\u0642\u062A\u0637\u0627\u0639\u0627\u062A) \u0645\u0642\u0641\u0644\u0629\u061B \u0627\u062D\u0630\u0641 \u0627\u0644\u0645\u0633\u0648\u062F\u0629 \u0648\u0623\u0646\u0634\u0626\u0647\u0627 \u0645\u0646 \u062C\u062F\u064A\u062F \u0644\u062A\u063A\u064A\u064A\u0631\u0647\u0627. \u0623\u0645\u0627 \u0628\u0642\u064A\u0629 \u0627\u0644\u062D\u0642\u0648\u0644 \u0641\u064A\u0645\u0643\u0646 \u062A\u0639\u062F\u064A\u0644\u0647\u0627."
              },
              missing: {
                term: "\u0644\u0625\u0635\u062F\u0627\u0631 \u0647\u0630\u0647 \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629\u060C \u0628\u0642\u064A \u0645\u0627 \u064A\u062C\u0628 \u0627\u0633\u062A\u0643\u0645\u0627\u0644\u0647",
                text: "\u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A \u0627\u0644\u0625\u062C\u0628\u0627\u0631\u064A\u0629 \u0627\u0644\u0646\u0627\u0642\u0635\u0629 (\u0627\u0644\u0645\u0644\u0641 \u0627\u0644\u062C\u0628\u0627\u0626\u064A \u0644\u0644\u0645\u0643\u062A\u0628 \u0648\u0639\u0646\u0648\u0627\u0646 \u0627\u0644\u062D\u0631\u064A\u0641 \u0623\u0648 \u0645\u0639\u0631\u0651\u0641\u0647 \u0627\u0644\u062C\u0628\u0627\u0626\u064A \u0648\u0627\u0644\u0628\u0646\u0648\u062F\u2026). \u0627\u0644\u0631\u0627\u0628\u0637\u0627\u0646 \xAB\u0627\u0633\u062A\u0643\u0645\u0627\u0644 \u0627\u0644\u0645\u0644\u0641 \u0627\u0644\u062C\u0628\u0627\u0626\u064A\xBB \u0648\xAB\u0641\u062A\u062D \u0628\u0637\u0627\u0642\u0629 \u0627\u0644\u062D\u0631\u064A\u0641\xBB \u064A\u0642\u0648\u062F\u0627\u0646 \u0625\u0644\u0649 \u0645\u0643\u0627\u0646 \u0627\u0644\u062A\u0635\u062D\u064A\u062D."
              },
              issueDialog: {
                term: "\u0625\u0635\u062F\u0627\u0631 \u0647\u0630\u0647 \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629\u061F",
                text: "\u062A\u0630\u0643\u0651\u0631 \u0628\u0627\u0644\u0645\u062C\u0645\u0648\u0639 \u0628\u0627\u062D\u062A\u0633\u0627\u0628 \u0643\u0644 \u0627\u0644\u0623\u062F\u0627\u0621\u0627\u062A \u0648\u0627\u0644\u0635\u0627\u0641\u064A \u0644\u0644\u062F\u0641\u0639 \u0648\u062A\u0646\u0628\u0651\u0647 \u0625\u0644\u0649 \u0623\u0646 \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629 \u0627\u0644\u0635\u0627\u062F\u0631\u0629 \u0644\u0627 \u064A\u0645\u0643\u0646 \u062A\u0639\u062F\u064A\u0644\u0647\u0627 \u0623\u0628\u062F\u064B\u0627 (\u0648\u0639\u0646\u062F \u0627\u0644\u062E\u0637\u0623 \u062A\u0635\u062F\u0631 \u0641\u0627\u062A\u0648\u0631\u0629 \u062A\u0639\u062F\u064A\u0644\u064A\u0629) \u0648\u0625\u0644\u0649 \u0623\u0646\u0647 \u0633\u064A\u064F\u0637\u0644\u0628 \u062A\u0623\u0643\u064A\u062F \u0627\u0644\u0647\u0648\u064A\u0629. \xAB\u0625\u0635\u062F\u0627\u0631 \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629\xBB \u064A\u0624\u0643\u062F."
              },
              issueProblems: {
                term: "\u062A\u063A\u064A\u0651\u0631\u062A \u0627\u0644\u0645\u0628\u0627\u0644\u063A / \u0628\u064A\u0627\u0646\u0627\u062A \u0625\u062C\u0628\u0627\u0631\u064A\u0629 \u0646\u0627\u0642\u0635\u0629",
                text: "\u0625\u0630\u0627 \u0631\u064F\u0641\u0636 \u0627\u0644\u0625\u0635\u062F\u0627\u0631: \xAB\u062A\u063A\u064A\u0651\u0631\u062A \u0627\u0644\u0645\u0628\u0627\u0644\u063A\xBB (\u062A\u0639\u0631\u0636 \u0627\u0644\u0645\u0633\u0648\u062F\u0629 \u0627\u0644\u0645\u062C\u0627\u0645\u064A\u0639 \u0627\u0644\u062C\u062F\u064A\u062F\u0629 \u0648\xAB\u0641\u0647\u0645\u062A\xBB \u062A\u063A\u0644\u0642 \u0627\u0644\u0631\u0633\u0627\u0644\u0629) \u0623\u0648 \xAB\u0628\u064A\u0627\u0646\u0627\u062A \u0625\u062C\u0628\u0627\u0631\u064A\u0629 \u0646\u0627\u0642\u0635\u0629\xBB \u0645\u0639 \u0642\u0627\u0626\u0645\u0629 \u0645\u0627 \u064A\u062C\u0628 \u0627\u0633\u062A\u0643\u0645\u0627\u0644\u0647."
              },
              creditMode: {
                term: "\u0646\u0637\u0627\u0642 \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629 \u0627\u0644\u062A\u0639\u062F\u064A\u0644\u064A\u0629",
                text: "\u0641\u064A \u0646\u0627\u0641\u0630\u0629 \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629 \u0627\u0644\u062A\u0639\u062F\u064A\u0644\u064A\u0629: \xAB\u0625\u0644\u063A\u0627\u0621 \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629 \u0643\u0627\u0645\u0644\u0629 (\u0628\u0645\u0627 \u0641\u064A \u0630\u0644\u0643 \u0645\u0639\u0644\u0648\u0645 \u0627\u0644\u0637\u0627\u0628\u0639)\xBB \u0623\u0648 \xAB\u062A\u0639\u062F\u064A\u0644 \u0628\u0639\u0636 \u0627\u0644\u0628\u0646\u0648\u062F\xBB. \u0648\u0641\u064A \u0627\u0644\u062D\u0627\u0644\u0629 \u0627\u0644\u062B\u0627\u0646\u064A\u0629 \u0636\u0639 \u0639\u0644\u0627\u0645\u0629 \u0639\u0644\u0649 \u0643\u0644 \u0628\u0646\u062F \u0645\u0639\u0646\u064A \u0648\u0623\u062F\u062E\u0644 \u0627\u0644\u0643\u0645\u064A\u0629 \u0627\u0644\u0645\u0631\u0627\u062F \u062A\u0639\u062F\u064A\u0644\u0647\u0627."
              },
              creditReason: {
                term: "\u0633\u0628\u0628 \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629 \u0627\u0644\u062A\u0639\u062F\u064A\u0644\u064A\u0629",
                text: "\u0625\u062C\u0628\u0627\u0631\u064A\u060C 500 \u062D\u0631\u0641 \u0639\u0644\u0649 \u0627\u0644\u0623\u0643\u062B\u0631. \xAB\u0625\u0635\u062F\u0627\u0631 \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629 \u0627\u0644\u062A\u0639\u062F\u064A\u0644\u064A\u0629\xBB \u062A\u0646\u0634\u0626\u0647\u0627 \u0641\u0648\u0631\u064B\u0627 \u0628\u0631\u0642\u0645 \u062E\u0627\u0635 \u0628\u0647\u0627\u061B \u0648\xAB\u0625\u0644\u063A\u0627\u0621\xBB \u064A\u063A\u0644\u0642 \u0627\u0644\u0646\u0627\u0641\u0630\u0629."
              },
              stale: {
                term: "\u0642\u0627\u0645 \u0634\u062E\u0635 \u0622\u062E\u0631 \u0628\u062A\u0639\u062F\u064A\u0644 \u0647\u0630\u0647 \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629",
                text: "\u062D\u0641\u0638 \u0645\u0633\u062A\u0639\u0645\u0644 \u0622\u062E\u0631 \u0647\u0630\u0647 \u0627\u0644\u0645\u0633\u0648\u062F\u0629 \u0623\u062B\u0646\u0627\u0621 \u062A\u0639\u062F\u064A\u0644\u0643 \u0644\u0647\u0627: \xAB\u0625\u0639\u0627\u062F\u0629 \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629\xBB \u062A\u0639\u0631\u0636 \u0622\u062E\u0631 \u0646\u0633\u062E\u0629."
              }
            }
          },
          general: {
            title: "\u0645\u0639\u0644\u0648\u0645\u0627\u062A \u0639\u0627\u0645\u0629",
            items: {
              kind: {
                term: "\u0646\u0648\u0639 \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629",
                text: "\u0633\u0644\u0641\u0629 \u0623\u0648 \u062A\u0633\u0628\u0642\u0629 \u0623\u0648 \u0643\u0634\u0641 \u0625\u0646\u062C\u0627\u0632 \u0623\u0648 \u0641\u0627\u062A\u0648\u0631\u0629 \u0646\u0647\u0627\u0626\u064A\u0629 (\u0627\u0646\u0638\u0631 \u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u0641\u0648\u0627\u062A\u064A\u0631 \u0644\u0645\u0639\u0646\u0627\u0647\u0627)."
              },
              client: {
                term: "\u0627\u0644\u062D\u0631\u064A\u0641",
                text: "\u0625\u062C\u0628\u0627\u0631\u064A: \u0635\u0627\u062D\u0628 \u0627\u0644\u0645\u0634\u0631\u0648\u0639 \u0627\u0644\u0645\u0637\u0644\u0648\u0628 \u0641\u0648\u062A\u0631\u062A\u0647. \u062A\u063A\u064A\u064A\u0631 \u0627\u0644\u062D\u0631\u064A\u0641 \u064A\u0641\u0631\u063A \u0627\u0644\u0645\u0634\u0631\u0648\u0639 \u0648\u0645\u0631\u0627\u062D\u0644 \u0627\u0644\u0628\u0646\u0648\u062F."
              },
              project: {
                term: "\u0627\u0644\u0645\u0634\u0631\u0648\u0639",
                text: "\u0627\u062E\u062A\u064A\u0627\u0631\u064A: \u064A\u062A\u064A\u062D \u062A\u0631\u062A\u064A\u0628 \u0627\u0644\u0628\u0646\u0648\u062F \u062D\u0633\u0628 \u0645\u0631\u0627\u062D\u0644 \u0627\u0644\u0645\u0634\u0631\u0648\u0639."
              },
              series: {
                term: "\u0633\u0644\u0633\u0644\u0629 \u0627\u0644\u062A\u0631\u0642\u064A\u0645",
                text: "\u0644\u0627 \u062A\u0638\u0647\u0631 \u0625\u0644\u0627 \u0625\u0630\u0627 \u0643\u0627\u0646 \u0644\u0644\u0645\u0643\u062A\u0628 \u0639\u062F\u0629 \u0633\u0644\u0627\u0633\u0644: \u064A\u064F\u0633\u0646\u062F \u0627\u0644\u0631\u0642\u0645 \u0639\u0646\u062F \u0625\u0635\u062F\u0627\u0631 \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629 \u062F\u0648\u0646 \u0623\u064A \u0641\u0631\u0627\u063A. \u0648\xAB\u0627\u0644\u0633\u0644\u0633\u0644\u0629 \u0627\u0644\u0627\u0641\u062A\u0631\u0627\u0636\u064A\u0629\xBB \u062A\u0646\u0627\u0633\u0628 \u0623\u063A\u0644\u0628 \u0627\u0644\u062D\u0627\u0644\u0627\u062A."
              },
              language: {
                term: "\u0644\u063A\u0629 \u0645\u0644\u0641 \u2066PDF\u2069",
                text: "\u0644\u063A\u0629 \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629 \u0627\u0644\u0645\u0637\u0628\u0648\u0639\u0629: \u0627\u0644\u0641\u0631\u0646\u0633\u064A\u0629 \u0623\u0648 \u0627\u0644\u0639\u0631\u0628\u064A\u0629 \u0623\u0648 \u062B\u0646\u0627\u0626\u064A \u0627\u0644\u0644\u063A\u0629 (\u0627\u0644\u0641\u0631\u0646\u0633\u064A\u0629 \u0648\u0627\u0644\u0639\u0631\u0628\u064A\u0629)."
              },
              currency: {
                term: "\u0627\u0644\u0639\u0645\u0644\u0629 \u0648\u0633\u0639\u0631 \u0627\u0644\u0635\u0631\u0641",
                text: "\u2066TND\u2069 \u0623\u0648 \u2066EUR\u2069 \u0623\u0648 \u2066USD\u2069. \u0648\u0641\u064A \u0627\u0644\u0639\u0645\u0644\u0629 \u0627\u0644\u0623\u062C\u0646\u0628\u064A\u0629 \u064A\u0643\u0648\u0646 \xAB\u0633\u0639\u0631 \u0627\u0644\u0635\u0631\u0641 (\u062F\u064A\u0646\u0627\u0631 \u062A\u0648\u0646\u0633\u064A \u0645\u0642\u0627\u0628\u0644 \u0648\u062D\u062F\u0629 \u0648\u0627\u062D\u062F\u0629)\xBB \u0625\u062C\u0628\u0627\u0631\u064A\u064B\u0627 (\u0645\u062B\u0644 3.350 \u0645\u0642\u0627\u0628\u0644 1 \u0623\u0648\u0631\u0648) \u0648\u062A\u064F\u0639\u0637\u0649 \u0627\u0644\u0645\u062C\u0627\u0645\u064A\u0639 \u0628\u0627\u0644\u062F\u064A\u0646\u0627\u0631 \u0623\u064A\u0636\u064B\u0627."
              },
              vatTreatment: {
                term: "\u0646\u0638\u0627\u0645 \u0627\u0644\u0623\u062F\u0627\u0621 \u0639\u0644\u0649 \u0627\u0644\u0642\u064A\u0645\u0629 \u0627\u0644\u0645\u0636\u0627\u0641\u0629",
                text: "\u062D\u0633\u0628 \u0627\u0644\u062D\u0631\u064A\u0641 (\u0627\u0641\u062A\u0631\u0627\u0636\u064A\u064B\u0627) \u0623\u0648 \u0623\u062F\u0627\u0621 \u0639\u0627\u062F\u064A \u0623\u0648 \u0623\u062F\u0627\u0621 \u0645\u0639\u0644\u0651\u0642 \u0623\u0648 \u062A\u0635\u062F\u064A\u0631 (\u0645\u0639\u0641\u0649). \u0648\u0639\u0646\u062F \u062A\u0639\u0644\u064A\u0642 \u0627\u0644\u0623\u062F\u0627\u0621 \u064A\u0643\u0648\u0646 \xAB\u0645\u0631\u062C\u0639 \u0627\u0644\u0646\u0638\u0627\u0645\xBB (\u0631\u0642\u0645 \u0627\u0644\u0634\u0647\u0627\u062F\u0629) \u0625\u062C\u0628\u0627\u0631\u064A\u064B\u0627."
              },
              dueDate: {
                term: "\u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0627\u0633\u062A\u062D\u0642\u0627\u0642",
                text: "\u0627\u062E\u062A\u064A\u0627\u0631\u064A: \u062F\u0648\u0646 \u062A\u0627\u0631\u064A\u062E \u062A\u064F\u0637\u0628\u064E\u0651\u0642 \u0622\u062C\u0627\u0644 \u0627\u0644\u062F\u0641\u0639 \u0627\u0644\u062E\u0627\u0635\u0629 \u0628\u0627\u0644\u062D\u0631\u064A\u0641 \u0639\u0646\u062F \u0627\u0644\u0625\u0635\u062F\u0627\u0631. \u0648\u0641\u064A \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629 \u0627\u0644\u0635\u0627\u062F\u0631\u0629 \u062A\u0631\u0649 \u0623\u064A\u0636\u064B\u0627 \xAB\u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0625\u0635\u062F\u0627\u0631\xBB \u0648\xAB\u0627\u0644\u0642\u0648\u0627\u0639\u062F \u0627\u0644\u062C\u0628\u0627\u0626\u064A\u0629 \u0627\u0644\u0645\u0637\u0628\u064E\u0651\u0642\u0629\xBB."
              }
            }
          },
          lines: {
            title: "\u0628\u0646\u0648\u062F \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629",
            items: {
              description: {
                term: "\u0627\u0644\u0648\u0635\u0641",
                text: "\u0625\u062C\u0628\u0627\u0631\u064A: \u0645\u0627 \u064A\u0641\u0648\u062A\u0631\u0647 \u0627\u0644\u0628\u0646\u062F."
              },
              phase: {
                term: "\u0627\u0644\u0645\u0631\u062D\u0644\u0629",
                text: "\u062A\u0638\u0647\u0631 \u0639\u0646\u062F \u0627\u062E\u062A\u064A\u0627\u0631 \u0645\u0634\u0631\u0648\u0639: \u062A\u0636\u0639 \u0627\u0644\u0628\u0646\u062F \u0641\u064A \u0645\u0631\u062D\u0644\u0629 \u0645\u0646 \u0627\u0644\u0645\u0634\u0631\u0648\u0639. \u062A\u064F\u062C\u0645\u064E\u0651\u0639 \u0627\u0644\u0628\u0646\u0648\u062F \u062D\u0633\u0628 \u0627\u0644\u0645\u0631\u062D\u0644\u0629 \u0645\u0639 \u0645\u062C\u0645\u0648\u0639 \u0641\u0631\u0639\u064A \u062F\u0648\u0646 \u0627\u062D\u062A\u0633\u0627\u0628 \u0627\u0644\u0623\u062F\u0627\u0621\u0627\u062A."
              },
              quantity: {
                term: "\u0627\u0644\u0643\u0645\u064A\u0629",
                text: "\u0625\u062C\u0628\u0627\u0631\u064A: \u0639\u062F\u062F \u0645\u0648\u062C\u0628 \u0628\u062B\u0644\u0627\u062B \u062E\u0627\u0646\u0627\u062A \u0639\u0634\u0631\u064A\u0629 \u0639\u0644\u0649 \u0627\u0644\u0623\u0643\u062B\u0631."
              },
              unitPrice: {
                term: "\u0633\u0639\u0631 \u0627\u0644\u0648\u062D\u062F\u0629 \u062F\u0648\u0646 \u0627\u062D\u062A\u0633\u0627\u0628 \u0627\u0644\u0623\u062F\u0627\u0621\u0627\u062A",
                text: "\u0625\u062C\u0628\u0627\u0631\u064A: \u0633\u0639\u0631 \u0648\u062D\u062F\u0629 \u0648\u0627\u062D\u062F\u0629 \u0642\u0628\u0644 \u0627\u0644\u0623\u062F\u0627\u0621\u0627\u062A."
              },
              vat: {
                term: "\u0627\u0644\u0623\u062F\u0627\u0621 \u0639\u0644\u0649 \u0627\u0644\u0642\u064A\u0645\u0629 \u0627\u0644\u0645\u0636\u0627\u0641\u0629",
                text: "\u0646\u0633\u0628\u0629 \u0627\u0644\u0623\u062F\u0627\u0621 \u0639\u0644\u0649 \u0627\u0644\u0642\u064A\u0645\u0629 \u0627\u0644\u0645\u0636\u0627\u0641\u0629 \u0644\u0644\u0628\u0646\u062F: 19% \u0623\u0648 13% \u0623\u0648 7% \u0623\u0648 0%."
              },
              amount: {
                term: "\u0627\u0644\u0645\u0628\u0644\u063A \u062F\u0648\u0646 \u0627\u062D\u062A\u0633\u0627\u0628 \u0627\u0644\u0623\u062F\u0627\u0621\u0627\u062A",
                text: "\u064A\u064F\u062D\u062A\u0633\u0628 \u0644\u0643: \u0627\u0644\u0643\u0645\u064A\u0629 \xD7 \u0633\u0639\u0631 \u0627\u0644\u0648\u062D\u062F\u0629."
              },
              addRemove: {
                term: "\u0625\u0636\u0627\u0641\u0629 \u0628\u0646\u062F",
                text: "\u064A\u0636\u064A\u0641 \u0628\u0646\u062F\u064B\u0627 \u0641\u0627\u0631\u063A\u064B\u0627\u061B \u0648\xAB\u0625\u0636\u0627\u0641\u0629 \u0628\u0646\u062F \u0625\u0644\u0649 \u0647\u0630\u0647 \u0627\u0644\u0645\u0631\u062D\u0644\u0629\xBB \u062A\u0636\u064A\u0641\u0647 \u0625\u0644\u0649 \u0627\u0644\u0645\u0631\u062D\u0644\u0629. \u0648\u0627\u0644\u0632\u0631 \u0630\u0648 \u0627\u0644\u0623\u064A\u0642\u0648\u0646\u0629 \xAB\u062D\u0630\u0641 \u0627\u0644\u0628\u0646\u062F\xBB \u064A\u0632\u064A\u0644 \u0628\u0646\u062F\u064B\u0627. \u0648\xAB\u0645\u062C\u0645\u0648\u0639 \u0627\u0644\u0628\u0646\u0648\u062F \u062F\u0648\u0646 \u0627\u062D\u062A\u0633\u0627\u0628 \u0627\u0644\u0623\u062F\u0627\u0621\u0627\u062A\xBB \u064A\u0639\u0637\u064A \u0627\u0644\u0645\u062C\u0645\u0648\u0639."
              },
              roles: {
                term: "\u0646\u0648\u0639 \u0627\u0644\u0628\u0646\u062F",
                text: "\u0641\u064A \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629 \u0627\u0644\u0635\u0627\u062F\u0631\u0629 \u062A\u062A\u0628\u0639 \u0628\u0646\u0648\u062F\u064E \u0643\u0634\u0641 \u0627\u0644\u0625\u0646\u062C\u0627\u0632 \u0643\u0644\u0645\u0629: \u0627\u0633\u062A\u0631\u062C\u0627\u0639 \u0633\u0644\u0641\u0629 \u0623\u0648 \u0627\u0642\u062A\u0637\u0627\u0639 \u0636\u0645\u0627\u0646 \u0623\u0648 \u0625\u0631\u062C\u0627\u0639 \u0627\u0642\u062A\u0637\u0627\u0639 \u0627\u0644\u0636\u0645\u0627\u0646."
              }
            }
          },
          attachmentsNotes: {
            title: "\u0627\u0644\u0645\u0631\u0641\u0642\u0627\u062A \u0648\u0627\u0644\u0645\u0644\u0627\u062D\u0638\u0627\u062A",
            items: {
              attachments: {
                term: "\u0627\u0644\u0645\u0631\u0641\u0642\u0627\u062A",
                text: "\u0627\u0644\u0648\u062B\u0627\u0626\u0642 \u0627\u0644\u0645\u0631\u0641\u0642\u0629 \u0628\u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629 (\u0645\u062B\u0644 \u0645\u062D\u0636\u0631 \u062A\u0633\u0644\u0651\u0645). \u0644\u0625\u0636\u0627\u0641\u0629 \u0648\u062B\u064A\u0642\u0629 \u0627\u0643\u062A\u0628 \u062D\u0631\u0641\u064A\u0646 \u0639\u0644\u0649 \u0627\u0644\u0623\u0642\u0644 \u0645\u0646 \u0627\u0644\u0639\u0646\u0648\u0627\u0646 \u0623\u0648 \u0627\u0644\u0631\u0645\u0632 \u0641\u064A \xAB\u0627\u0644\u0628\u062D\u062B \u0639\u0646 \u0648\u062B\u064A\u0642\u0629 \u0644\u0625\u0631\u0641\u0627\u0642\u0647\u0627\xBB\u061B \u0648\u0632\u0631 \xAB\u0625\u0632\u0627\u0644\u0629\xBB \u064A\u0632\u064A\u0644 \u0645\u0631\u0641\u0642\u064B\u0627. \u062A\u064F\u062D\u0641\u0638 \u0642\u0627\u0646\u0648\u0646\u064A\u064B\u0627 \u0645\u0639 \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629 \u0628\u0639\u062F \u0625\u0635\u062F\u0627\u0631\u0647\u0627."
              },
              notes: {
                term: "\u0645\u0644\u0627\u062D\u0638\u0627\u062A \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629",
                text: "\u0627\u062E\u062A\u064A\u0627\u0631\u064A: \u062A\u064F\u0637\u0628\u0639 \u0639\u0644\u0649 \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629 (\u0634\u0631\u0648\u0637\u060C \u0628\u064A\u0627\u0646 \u062E\u0627\u0635)\u060C 2000 \u062D\u0631\u0641 \u0639\u0644\u0649 \u0627\u0644\u0623\u0643\u062B\u0631."
              }
            }
          },
          totals: {
            title: "\u0627\u0644\u0645\u062C\u0627\u0645\u064A\u0639",
            items: {
              subtotalHt: {
                term: "\u0627\u0644\u0645\u062C\u0645\u0648\u0639 \u062F\u0648\u0646 \u0627\u062D\u062A\u0633\u0627\u0628 \u0627\u0644\u0623\u062F\u0627\u0621\u0627\u062A",
                text: "\u0645\u062C\u0645\u0648\u0639 \u0643\u0644 \u0627\u0644\u0628\u0646\u0648\u062F \u0642\u0628\u0644 \u0627\u0644\u0623\u062F\u0627\u0621\u0627\u062A."
              },
              vat: {
                term: "\u0627\u0644\u0623\u062F\u0627\u0621 \u0639\u0644\u0649 \u0627\u0644\u0642\u064A\u0645\u0629 \u0627\u0644\u0645\u0636\u0627\u0641\u0629 (\u0627\u0644\u0646\u0633\u0628\u0629)",
                text: "\u064A\u064F\u062D\u062A\u0633\u0628 \u0628\u0646\u062F\u064B\u0627 \u0628\u0646\u062F\u064B\u0627 \u0628\u0646\u0633\u0628\u0629 \u0643\u0644 \u0628\u0646\u062F. \u0648\u0642\u062F \u064A\u0643\u0648\u0646 \xAB\u0645\u0639\u0644\u0651\u0642\u064B\u0627\xBB \u0623\u0648 \xAB\u0645\u0639\u0641\u0649 \u0639\u0646\u062F \u0627\u0644\u062A\u0635\u062F\u064A\u0631\xBB \u0628\u062D\u0633\u0628 \u0627\u0644\u0646\u0638\u0627\u0645 \u0627\u0644\u0645\u062E\u062A\u0627\u0631."
              },
              stamp: {
                term: "\u0645\u0639\u0644\u0648\u0645 \u0627\u0644\u0637\u0627\u0628\u0639 \u0627\u0644\u062C\u0628\u0627\u0626\u064A",
                text: "\u0645\u0639\u0644\u0648\u0645 \u0635\u063A\u064A\u0631 \u062B\u0627\u0628\u062A \u064A\u064F\u0636\u0627\u0641 \u0625\u0644\u0649 \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629. \u0648\u0642\u062F \u064A\u0643\u0648\u0646 \xAB\u0645\u0639\u0641\u0649\xBB (\u062A\u0635\u062F\u064A\u0631\u060C \u0645\u0634\u062A\u0631\u064D \u0639\u0645\u0648\u0645\u064A) \u0623\u0648 \u0645\u062D\u0641\u0648\u0638\u064B\u0627 \u0641\u064A \u0641\u0627\u062A\u0648\u0631\u0629 \u062A\u0639\u062F\u064A\u0644\u064A\u0629 \u062C\u0632\u0626\u064A\u0629."
              },
              totalTtc: {
                term: "\u0627\u0644\u0645\u062C\u0645\u0648\u0639 \u0628\u0627\u062D\u062A\u0633\u0627\u0628 \u0643\u0644 \u0627\u0644\u0623\u062F\u0627\u0621\u0627\u062A",
                text: "\u0627\u0644\u0645\u062C\u0645\u0648\u0639 \u0628\u0639\u062F \u0627\u062D\u062A\u0633\u0627\u0628 \u0643\u0644 \u0627\u0644\u0623\u062F\u0627\u0621\u0627\u062A: \u062F\u0648\u0646 \u0627\u0644\u0623\u062F\u0627\u0621\u0627\u062A + \u0627\u0644\u0623\u062F\u0627\u0621 \u0639\u0644\u0649 \u0627\u0644\u0642\u064A\u0645\u0629 \u0627\u0644\u0645\u0636\u0627\u0641\u0629 + \u0627\u0644\u0637\u0627\u0628\u0639. \u0648\u0647\u0648 \u0645\u0628\u0644\u063A \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629."
              },
              withholding: {
                term: "\u0627\u0644\u062E\u0635\u0645 \u0645\u0646 \u0627\u0644\u0645\u0648\u0631\u062F (\u0627\u0644\u0646\u0633\u0628\u0629)",
                text: "\u062C\u0632\u0621 \u0645\u0646 \u0627\u0644\u0645\u062C\u0645\u0648\u0639 \u064A\u062D\u062A\u0641\u0638 \u0628\u0647 \u0628\u0639\u0636 \u0627\u0644\u062D\u0631\u0641\u0627\u0621 (\u0627\u0644\u0647\u064A\u0627\u0643\u0644 \u0627\u0644\u0639\u0645\u0648\u0645\u064A\u0629 \u0648\u0627\u0644\u0634\u0631\u0643\u0627\u062A) \u0644\u064A\u062F\u0641\u0639\u0648\u0647 \u0628\u0623\u0646\u0641\u0633\u0647\u0645 \u0625\u0644\u0649 \u0627\u0644\u0625\u062F\u0627\u0631\u0629 \u0627\u0644\u062C\u0628\u0627\u0626\u064A\u0629. \u064A\u0638\u0647\u0631 \u0637\u0631\u062D\u064B\u0627 \u0648\u0644\u0627 \u064A\u0638\u0647\u0631 \u0625\u0644\u0627 \u0625\u0630\u0627 \u0627\u0646\u0637\u0628\u0642 \u0639\u0644\u0649 \u0647\u0630\u0627 \u0627\u0644\u062D\u0631\u064A\u0641."
              },
              vatWithholding: {
                term: "\u0627\u0644\u062E\u0635\u0645 \u0645\u0646 \u0627\u0644\u0645\u0648\u0631\u062F \u0628\u0639\u0646\u0648\u0627\u0646 \u0627\u0644\u0623\u062F\u0627\u0621 \u0639\u0644\u0649 \u0627\u0644\u0642\u064A\u0645\u0629 \u0627\u0644\u0645\u0636\u0627\u0641\u0629 (\u0627\u0644\u0646\u0633\u0628\u0629)",
                text: "\u062C\u0632\u0621 \u0645\u0646 \u0627\u0644\u0623\u062F\u0627\u0621 \u0639\u0644\u0649 \u0627\u0644\u0642\u064A\u0645\u0629 \u0627\u0644\u0645\u0636\u0627\u0641\u0629 \u064A\u0642\u062A\u0637\u0639\u0647 \u0627\u0644\u062D\u0631\u064A\u0641 \u0644\u064A\u062F\u0641\u0639\u0647 \u0625\u0644\u0649 \u0627\u0644\u062E\u0632\u064A\u0646\u0629 (\u0627\u0644\u0647\u064A\u0627\u0643\u0644 \u0627\u0644\u0639\u0645\u0648\u0645\u064A\u0629). \u0648\u064A\u0638\u0647\u0631 \u0647\u0648 \u0623\u064A\u0636\u064B\u0627 \u0637\u0631\u062D\u064B\u0627."
              },
              netPayable: {
                term: "\u0627\u0644\u0635\u0627\u0641\u064A \u0644\u0644\u062F\u0641\u0639",
                text: "\u0645\u0627 \u064A\u062F\u0641\u0639\u0647 \u0644\u0643 \u0627\u0644\u062D\u0631\u064A\u0641 \u0641\u0639\u0644\u064B\u0627: \u0627\u0644\u0645\u062C\u0645\u0648\u0639 \u0628\u0627\u062D\u062A\u0633\u0627\u0628 \u0627\u0644\u0623\u062F\u0627\u0621\u0627\u062A \u0646\u0627\u0642\u0635 \u0627\u0644\u0627\u0642\u062A\u0637\u0627\u0639\u0627\u062A. \u0645\u062B\u0644\u064B\u0627\u060C \u0644\u0645\u062C\u0645\u0648\u0639 11,544.000 \u2066TND\u2069 \u0648\u0627\u0642\u062A\u0637\u0627\u0639 173.000 \u2066TND\u2069\u060C \u064A\u0643\u0648\u0646 \u0627\u0644\u0635\u0627\u0641\u064A \u0644\u0644\u062F\u0641\u0639 11,371.000 \u2066TND\u2069."
              },
              details: {
                term: "\u0628\u064A\u0627\u0646\u0627\u062A \u062A\u062D\u062A \u0627\u0644\u0625\u0637\u0627\u0631",
                text: "\u062A\u062D\u062A \u0628\u0639\u0636 \u0627\u0644\u0623\u0633\u0637\u0631: \u0623\u0633\u0627\u0633 \u0627\u0644\u0627\u062D\u062A\u0633\u0627\u0628 \u0648\u0627\u0644\u0645\u0631\u062C\u0639 \u0627\u0644\u0642\u0627\u0646\u0648\u0646\u064A \u0648\xAB\u0642\u0627\u0639\u062F\u0629 \u064A\u062C\u0628 \u0627\u0644\u062A\u062D\u0642\u0642 \u0645\u0646\u0647\u0627\xBB (\u0628\u062D\u0633\u0628 \u0627\u0644\u0628\u064A\u0626\u0629). \u0648\u0623\u0633\u0641\u0644 \u0630\u0644\u0643: \u0628\u064A\u0627\u0646 \u062A\u0639\u0644\u064A\u0642 \u0627\u0644\u0623\u062F\u0627\u0621 \u0623\u0648 \u0627\u0644\u062A\u0635\u062F\u064A\u0631 \u0648\xAB\u0627\u0644\u0645\u0628\u0644\u063A \u0628\u0627\u0644\u0623\u062D\u0631\u0641\xBB \u0648\u0644\u0644\u0639\u0645\u0644\u0629 \u0627\u0644\u0623\u062C\u0646\u0628\u064A\u0629 \u0627\u0644\u0642\u064A\u0645\u0629 \u0627\u0644\u0645\u0642\u0627\u0628\u0644\u0629 \u0628\u0627\u0644\u062F\u064A\u0646\u0627\u0631."
              }
            }
          },
          history: {
            title: "\u0645\u062A\u0627\u0628\u0639\u0629 \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629",
            items: {
              statuses: {
                term: "\u062D\u0627\u0644\u0627\u062A \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629",
                text: "\u062B\u0644\u0627\u062B \u0634\u0627\u0631\u0627\u062A: \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629 (\u0645\u0633\u0648\u062F\u0629 \u0623\u0648 \u0635\u0627\u062F\u0631\u0629 \u0623\u0648 \u0645\u0644\u063A\u0627\u0629 \u0628\u0641\u0627\u062A\u0648\u0631\u0629 \u062A\u0639\u062F\u064A\u0644\u064A\u0629) \u0648\u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629 \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A\u0629 (\u2066TTN\u2069) \u0648\u0627\u0644\u062F\u0641\u0639\u060C \u0648\u0627\u0644\u0623\u062E\u064A\u0631\u062A\u0627\u0646 \u0628\u0639\u062F \u0625\u0635\u062F\u0627\u0631 \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629 \u0641\u0642\u0637."
              },
              created: {
                term: "\u0623\u0646\u0634\u0623\u0647\u0627 \u2026 \u0628\u062A\u0627\u0631\u064A\u062E \u2026",
                text: "\u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0625\u0646\u0634\u0627\u0621 \u0648\u0645\u0646 \u0623\u0646\u0634\u0623\u0647\u0627."
              },
              issued: {
                term: "\u0635\u062F\u0631\u062A \u062A\u062D\u062A \u0627\u0644\u0631\u0642\u0645 \u2026 \u0628\u062A\u0627\u0631\u064A\u062E \u2026 \u0639\u0646 \u2026",
                text: "\u0627\u0644\u0631\u0642\u0645 \u0648\u0627\u0644\u062A\u0627\u0631\u064A\u062E \u0648\u0645\u0646 \u0623\u0635\u062F\u0631 \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629\u061B \u0648\u0625\u0644\u0627 \xAB\u0644\u0645 \u062A\u0635\u062F\u0631 \u0647\u0630\u0647 \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629 \u0628\u0639\u062F: \u0644\u064A\u0633 \u0644\u0647\u0627 \u0631\u0642\u0645\xBB."
              },
              legalHold: {
                term: "\u0645\u062D\u0641\u0648\u0638\u0629 \u0642\u0627\u0646\u0648\u0646\u064A\u064B\u0627 \u0625\u0644\u0649 \u063A\u0627\u064A\u0629 \u2026",
                text: "\u0627\u0644\u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0630\u064A \u064A\u062C\u0628 \u062D\u0641\u0638 \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629 \u0648\u0645\u0631\u0641\u0642\u0627\u062A\u0647\u0627 \u0625\u0644\u0649 \u063A\u0627\u064A\u062A\u0647."
              },
              credits: {
                term: "\u0627\u0644\u0641\u0648\u0627\u062A\u064A\u0631 \u0627\u0644\u062A\u0639\u062F\u064A\u0644\u064A\u0629",
                text: "\xAB\u0641\u0627\u062A\u0648\u0631\u0629 \u062A\u0639\u062F\u064A\u0644\u064A\u0629 \u0639\u0644\u0649 \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629\xBB \u0645\u0639 \u0631\u0627\u0628\u0637 \u0625\u0644\u0649 \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629 \u0627\u0644\u0623\u0635\u0644\u064A\u0629\u060C \u0648\xAB\u0633\u0628\u0642 \u062A\u0639\u062F\u064A\u0644\u0647\u0627 \u0628\u0641\u0648\u0627\u062A\u064A\u0631 \u062A\u0639\u062F\u064A\u0644\u064A\u0629\xBB \u0645\u0639 \u0627\u0644\u0645\u0628\u0644\u063A \u0627\u0644\u0645\u0639\u062F\u064E\u0651\u0644."
              },
              pdf: {
                term: "\u0645\u0644\u0641 \u2066PDF\u2069 \u062C\u0627\u0647\u0632 / \u0645\u0644\u0641 \u2066PDF\u2069 \u0642\u064A\u062F \u0627\u0644\u0625\u0639\u062F\u0627\u062F",
                text: "\u064A\u0628\u064A\u0651\u0646 \u0647\u0644 \u0623\u064F\u0646\u0634\u0626 \u0645\u0644\u0641 \u2066PDF\u2069 \u0627\u0644\u062E\u0627\u0635 \u0628\u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629."
              },
              payments: {
                term: "\u062F\u0641\u0639\u0629 \u0628\u062A\u0627\u0631\u064A\u062E \u2026 (\u0627\u0644\u0637\u0631\u064A\u0642\u0629): \u0627\u0644\u0645\u0628\u0644\u063A",
                text: "\u062F\u0641\u0639\u0629 \u0641\u064A \u0643\u0644 \u0633\u0637\u0631 \u0645\u0639 \u0627\u0644\u062A\u0627\u0631\u064A\u062E \u0648\u0627\u0644\u0637\u0631\u064A\u0642\u0629 \u0648\u0627\u0644\u0645\u0628\u0644\u063A\u060C \u0625\u0636\u0627\u0641\u0629 \u0625\u0644\u0649 \u0645\u0627 \u0627\u0642\u062A\u0637\u0639\u0647 \u0627\u0644\u062D\u0631\u064A\u0641. \u0648\u0625\u0646 \u0644\u0645 \u062A\u0648\u062C\u062F: \xAB\u0644\u0627 \u062A\u0648\u062C\u062F \u062F\u0641\u0639\u0627\u062A \u0645\u0633\u062C\u0644\u0629.\xBB \u0645\u062E\u0635\u0635 \u0644\u0645\u0646 \u064A\u0633\u062A\u0637\u064A\u0639\u0648\u0646 \u0627\u0644\u0627\u0637\u0644\u0627\u0639 \u0639\u0644\u0649 \u0627\u0644\u062F\u0641\u0639\u0627\u062A."
              }
            }
          },
          einvoice: {
            title: "\u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629 \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A\u0629 (\u2066El Fatoora\u2069)",
            items: {
              panel: {
                term: "\u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629 \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A\u0629 (\u2066El Fatoora\u2069)",
                text: "\u0644\u0641\u0627\u062A\u0648\u0631\u0629 \u0635\u0627\u062F\u0631\u0629 \u062A\u0645\u0631 \u0639\u0628\u0631 \u0627\u0644\u0641\u0648\u062A\u0631\u0629 \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A\u0629: \u0623\u064A\u0646 \u0628\u0644\u063A \u0627\u0644\u0625\u0631\u0633\u0627\u0644 \u0625\u0644\u0649 \u2066TTN\u2069 \u0648\u0645\u0627 \u064A\u062C\u0628 \u0641\u0639\u0644\u0647 \u0628\u0639\u062F \u0630\u0644\u0643 \u0648\u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0627\u062A. \u062A\u062A\u062D\u062F\u0651\u062B \u0627\u0644\u0635\u0641\u062D\u0629 \u062A\u0644\u0642\u0627\u0626\u064A\u064B\u0627."
              },
              attempts: {
                term: "\u0639\u0645\u0644\u064A\u0627\u062A \u0627\u0644\u0625\u0631\u0633\u0627\u0644 \u0625\u0644\u0649 \u2066TTN\u2069",
                text: "\u0644\u0643\u0644 \u0645\u062D\u0627\u0648\u0644\u0629 \u0631\u0642\u0645\u0647\u0627 \u0648\u062D\u0627\u0644\u062A\u0647\u0627 (\u0645\u0648\u0642\u0651\u0639\u0629 \u0623\u0648 \u0645\u064F\u0631\u0633\u064E\u0644\u0629 \u0625\u0644\u0649 \u2066TTN\u2069 \u0623\u0648 \u0645\u0642\u0628\u0648\u0644\u0629 \u0623\u0648 \u0645\u0631\u0641\u0648\u0636\u0629 \u0623\u0648 \u0641\u0634\u0644 \u0623\u0648 \u0645\u0648\u062F\u0639\u0629 \u064A\u062F\u0648\u064A\u064B\u0627) \u0648\u062A\u0648\u0627\u0631\u064A\u062E\u0647\u0627 \u0648\u0645\u0631\u062C\u0639 \u2066TTN\u2069\u061B \u0648\u0625\u0646 \u0644\u0645 \u062A\u0648\u062C\u062F: \xAB\u0644\u0627 \u064A\u0648\u062C\u062F \u0625\u0631\u0633\u0627\u0644 \u0625\u0644\u0649 \u2066TTN\u2069 \u062D\u062A\u0649 \u0627\u0644\u0622\u0646\xBB."
              },
              wait: {
                term: "\u0642\u064A\u062F \u0627\u0644\u0645\u0639\u0627\u0644\u062C\u0629 \u0644\u062F\u0649 \u2066TTN\u2069",
                text: "\u0644\u0627 \u064A\u0644\u0632\u0645 \u0623\u064A \u0625\u062C\u0631\u0627\u0621: \u062A\u062A\u062D\u062F\u0651\u062B \u0627\u0644\u0635\u0641\u062D\u0629 \u0628\u0645\u062C\u0631\u062F \u0631\u062F\u0651 \u2066TTN\u2069."
              },
              resubmit: {
                term: "\u0627\u0644\u062A\u0635\u062D\u064A\u062D \u062B\u0645 \u0625\u0639\u0627\u062F\u0629 \u0627\u0644\u0625\u0631\u0633\u0627\u0644",
                text: "\u0639\u0646\u062F\u0645\u0627 \u064A\u0631\u0641\u0636 \u2066TTN\u2069 \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629 \u0623\u0648 \u064A\u0641\u0634\u0644 \u0627\u0644\u0625\u0631\u0633\u0627\u0644: \u064A\u064F\u0634\u0631\u062D \u0627\u0644\u0633\u0628\u0628 \u062B\u0645 \u064A\u0639\u064A\u062F \u0647\u0630\u0627 \u0627\u0644\u0632\u0631 \u0625\u0631\u0633\u0627\u0644 \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629 \u0628\u0627\u0644\u0631\u0642\u0645 \u0646\u0641\u0633\u0647 \u062F\u0648\u0646 \u062A\u063A\u064A\u064A\u0631\u0647\u0627. \u0648\u0642\u062F \u064A\u0644\u0632\u0645 \u0623\u062D\u064A\u0627\u0646\u064B\u0627 \u0645\u0639\u0627\u0644\u062C\u0629 \u0634\u0647\u0627\u062F\u0629 \u0623\u0648\u0644\u064B\u0627 (\u0627\u0644\u0631\u0627\u0628\u0637 \xAB\u0625\u062F\u0627\u0631\u0629 \u0634\u0647\u0627\u062F\u0627\u062A \u0627\u0644\u062A\u0648\u0642\u064A\u0639\xBB)."
              },
              creditNoteNeeded: {
                term: "\u0631\u0641\u0636 \u2066TTN\u2069 \u0645\u062D\u062A\u0648\u0649 \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629",
                text: "\u0644\u0627 \u064A\u0645\u0643\u0646 \u0625\u0639\u0627\u062F\u0629 \u0627\u0633\u062A\u0639\u0645\u0627\u0644 \u0631\u0642\u0645 \u0641\u0627\u062A\u0648\u0631\u0629 \u0635\u0627\u062F\u0631\u0629 \u0628\u0645\u062D\u062A\u0648\u0649 \u0645\u0635\u062D\u064E\u0651\u062D: \u064A\u0644\u063A\u064A \u0627\u0644\u0632\u0631 \xAB\u0625\u0635\u062F\u0627\u0631 \u0641\u0627\u062A\u0648\u0631\u0629 \u062A\u0639\u062F\u064A\u0644\u064A\u0629\xBB \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629\u060C \u062B\u0645 \u062A\u0646\u0634\u0626 \u0641\u0627\u062A\u0648\u0631\u0629 \u062C\u062F\u064A\u062F\u0629 \u0645\u0635\u062D\u064E\u0651\u062D\u0629."
              },
              manual: {
                term: "\u062A\u0639\u0630\u0651\u0631 \u0627\u0644\u0625\u0631\u0633\u0627\u0644 \u0627\u0644\u0622\u0644\u064A: \u0627\u0644\u0625\u064A\u062F\u0627\u0639 \u0627\u0644\u064A\u062F\u0648\u064A",
                text: "\u062B\u0644\u0627\u062B \u062E\u0637\u0648\u0627\u062A: \xAB\u062A\u0646\u0632\u064A\u0644 \u0645\u0644\u0641 \u2066TEIF\u2069\xBB (\u0645\u0644\u0641 \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629\u060C \u0645\u0648\u0642\u064E\u0651\u0639\u064B\u0627 \u0623\u0648 \u063A\u064A\u0631 \u0645\u0648\u0642\u064E\u0651\u0639) \u0648\u0625\u064A\u062F\u0627\u0639\u0647 \u0639\u0644\u0649 \u0628\u0648\u0627\u0628\u0629 \u2066El Fatoora\u2069 \u0627\u0644\u062A\u0627\u0628\u0639\u0629 \u0644\u0640\u2066TTN\u2069\u060C \u062B\u0645 \u062A\u0633\u062C\u064A\u0644 \xAB\u0645\u0631\u062C\u0639 \u2066TTN\u2069\xBB \u0627\u0644\u0630\u064A \u062A\u062A\u0644\u0642\u0627\u0647 (\u0645\u0646 3 \u0625\u0644\u0649 100 \u062D\u0631\u0641) \u0648\xAB\u062D\u0641\u0638 \u0627\u0644\u0645\u0631\u062C\u0639\xBB."
              },
              accepted: {
                term: "\u0642\u0628\u0644 \u2066TTN\u2069 \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629",
                text: "\u064A\u062D\u0645\u0644 \u0645\u0644\u0641 \u2066PDF\u2069 \u0644\u0644\u0641\u0627\u062A\u0648\u0631\u0629 \u0627\u0644\u0622\u0646 \u0645\u0631\u062C\u0639 \u2066TTN\u2069 \u0648\u0631\u0645\u0632 \u2066QR\u2069."
              },
              manualDone: {
                term: "\u0623\u064F\u0648\u062F\u0639\u062A \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629 \u064A\u062F\u0648\u064A\u064B\u0627 \u0639\u0644\u0649 \u0628\u0648\u0627\u0628\u0629 \u2066TTN\u2069",
                text: "\u064A\u0624\u0643\u062F \u0627\u0644\u0625\u064A\u062F\u0627\u0639 \u0627\u0644\u064A\u062F\u0648\u064A \u0648\u064A\u0630\u0643\u0651\u0631 \u0628\u0627\u0644\u0645\u0631\u062C\u0639 \u0627\u0644\u0645\u062F\u062E\u0644 \u064A\u062F\u0648\u064A\u064B\u0627."
              }
            }
          }
        }
      },
      payments: {
        title: "\u0627\u0644\u062F\u0641\u0648\u0639\u0627\u062A",
        intro: "\u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u062F\u0641\u0639\u0627\u062A \u0627\u0644\u0645\u0633\u062A\u0644\u0645\u0629 \u0645\u0646 \u062D\u0631\u0641\u0627\u0626\u0643 \u0645\u0639 \u062D\u0627\u0644\u0629 \u0634\u0647\u0627\u062F\u0627\u062A \u0627\u0644\u062E\u0635\u0645 \u0648\u062C\u062F\u0648\u0644 \u0623\u0639\u0645\u0627\u0631 \u0627\u0644\u062F\u064A\u0648\u0646 \u0648\u0625\u0639\u062F\u0627\u062F\u0627\u062A \u0627\u0644\u062A\u0630\u0643\u064A\u0631. \u064A\u0633\u062A\u0639\u0645\u0644\u0647\u0627 \u0645\u0646 \u064A\u062A\u0627\u0628\u0639\u0648\u0646 \u0627\u0644\u0627\u0633\u062A\u062E\u0644\u0627\u0635.",
        sections: {
          header: {
            title: "\u0631\u0623\u0633 \u0627\u0644\u0635\u0641\u062D\u0629",
            items: {
              subNav: {
                term: "\u0627\u0644\u0645\u0627\u0644\u064A\u0629",
                text: "\u062A\u0639\u0631\u0636 \u0627\u0644\u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u064A\u0645\u0646\u0649 \u0623\u0642\u0633\u0627\u0645 \u0627\u0644\u0645\u0627\u0644\u064A\u0629 \u0627\u0644\u062A\u064A \u062A\u0633\u0645\u062D \u0628\u0647\u0627 \u0635\u0644\u0627\u062D\u064A\u0627\u062A\u0643 (\u0627\u0644\u0639\u0631\u0648\u0636 \u0627\u0644\u0645\u0627\u0644\u064A\u0629 \u0648\u0627\u0644\u0639\u0642\u0648\u062F \u0648\u0627\u0644\u0641\u0648\u0627\u062A\u064A\u0631 \u0648\u0627\u0644\u062F\u0641\u0648\u0639\u0627\u062A\u2026)\u060C \u0648\u0639\u0644\u0649 \u0627\u0644\u0634\u0627\u0634\u0629 \u0627\u0644\u0635\u063A\u064A\u0631\u0629 \u062A\u062A\u062D\u0648\u0644 \u0625\u0644\u0649 \u0635\u0641 \u0645\u0646 \u0627\u0644\u0631\u0648\u0627\u0628\u0637."
              },
              recordFrom: {
                term: "\u062A\u0633\u062C\u064A\u0644 \u062F\u0641\u0639\u0629",
                text: "\u0644\u0627 \u064A\u0648\u062C\u062F \u0647\u0646\u0627 \u0632\u0631 \u0625\u0646\u0634\u0627\u0621: \u062A\u064F\u0633\u062C\u064E\u0651\u0644 \u0627\u0644\u062F\u0641\u0639\u0629 \u0627\u0646\u0637\u0644\u0627\u0642\u064B\u0627 \u0645\u0646 \u0641\u0627\u062A\u0648\u0631\u0629 \u0635\u0627\u062F\u0631\u0629 \u0628\u0648\u0627\u0633\u0637\u0629 \xAB\u062A\u0633\u062C\u064A\u0644 \u062F\u0641\u0639\u0629\xBB (\u0627\u0646\u0638\u0631 \u0623\u062F\u0646\u0627\u0647)."
              }
            }
          },
          table: {
            title: "\u0627\u0644\u062F\u0641\u0639\u0627\u062A \u0627\u0644\u0645\u0633\u062A\u0644\u0645\u0629",
            items: {
              receivedOn: {
                term: "\u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0627\u0633\u062A\u0644\u0627\u0645",
                text: "\u062A\u0627\u0631\u064A\u062E \u0627\u0633\u062A\u0644\u0627\u0645 \u0627\u0644\u0645\u0628\u0644\u063A."
              },
              invoice: {
                term: "\u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629",
                text: "\u0631\u0642\u0645 \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629 \u0627\u0644\u0645\u062F\u0641\u0648\u0639\u0629. \u0627\u0646\u0642\u0631 \u0639\u0644\u064A\u0647 \u0644\u0641\u062A\u062D\u0647\u0627."
              },
              client: {
                term: "\u0627\u0644\u062D\u0631\u064A\u0641",
                text: "\u0627\u0644\u062D\u0631\u064A\u0641 \u0627\u0644\u0630\u064A \u062F\u0641\u0639."
              },
              method: {
                term: "\u0627\u0644\u0637\u0631\u064A\u0642\u0629",
                text: "\u0643\u064A\u0641 \u062F\u0641\u0639 \u0627\u0644\u062D\u0631\u064A\u0641 (\u0627\u0646\u0638\u0631 \xAB\u0637\u0631\u0642 \u0627\u0644\u062F\u0641\u0639\xBB)."
              },
              amount: {
                term: "\u0627\u0644\u0645\u0628\u0644\u063A \u0627\u0644\u0645\u0633\u062A\u0644\u0645",
                text: "\u0627\u0644\u0645\u0628\u0644\u063A \u0627\u0644\u0645\u0642\u0628\u0648\u0636 \u0641\u0639\u0644\u064A\u064B\u0627 \u0628\u0639\u062F \u0637\u0631\u062D \u0627\u0644\u0627\u0642\u062A\u0637\u0627\u0639\u0627\u062A."
              },
              empty: {
                term: "\u0644\u0627 \u062A\u0648\u062C\u062F \u062F\u0641\u0639\u0627\u062A \u0628\u0639\u062F",
                text: "\u0631\u0633\u0627\u0644\u0629 \u0627\u0644\u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u0641\u0627\u0631\u063A\u0629: \u062A\u064F\u0633\u062C\u064E\u0651\u0644 \u0627\u0644\u062F\u0641\u0639\u0627\u062A \u0627\u0646\u0637\u0644\u0627\u0642\u064B\u0627 \u0645\u0646 \u0641\u0627\u062A\u0648\u0631\u0629 \u0635\u0627\u062F\u0631\u0629. \xAB\u0639\u0631\u0636 \u0627\u0644\u0645\u0632\u064A\u062F \u0645\u0646 \u0627\u0644\u062F\u0641\u0639\u0627\u062A\xBB \u064A\u062D\u0645\u0651\u0644 \u0627\u0644\u0628\u0627\u0642\u064A\u061B \u0648\u0639\u0646\u062F \u0627\u0644\u062E\u0637\u0623 \u062A\u0639\u064A\u062F \xAB\u0625\u0639\u0627\u062F\u0629 \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629\xBB \u0627\u0644\u062A\u062D\u0645\u064A\u0644."
              }
            }
          },
          withholdings: {
            title: "\u0627\u0644\u062E\u0635\u0645 \u0648\u0634\u0647\u0627\u062F\u0629 \u0627\u0644\u062E\u0635\u0645",
            items: {
              withholding: {
                term: "\u0627\u0644\u062E\u0635\u0645 \u0645\u0646 \u0627\u0644\u0645\u0648\u0631\u062F",
                text: "\u0627\u0644\u062C\u0632\u0621 \u0627\u0644\u0630\u064A \u0627\u062D\u062A\u0641\u0638 \u0628\u0647 \u0627\u0644\u062D\u0631\u064A\u0641 \u0644\u064A\u062F\u0641\u0639\u0647 \u0625\u0644\u0649 \u0627\u0644\u0625\u062F\u0627\u0631\u0629 \u0627\u0644\u062C\u0628\u0627\u0626\u064A\u0629."
              },
              vatWithholding: {
                term: "\u0627\u0644\u062E\u0635\u0645 \u0645\u0646 \u0627\u0644\u0645\u0648\u0631\u062F \u0628\u0639\u0646\u0648\u0627\u0646 \u0627\u0644\u0623\u062F\u0627\u0621 \u0639\u0644\u0649 \u0627\u0644\u0642\u064A\u0645\u0629 \u0627\u0644\u0645\u0636\u0627\u0641\u0629",
                text: "\u0627\u0644\u0627\u0642\u062A\u0637\u0627\u0639 \u0645\u0646 \u0627\u0644\u0623\u062F\u0627\u0621 \u0639\u0644\u0649 \u0627\u0644\u0642\u064A\u0645\u0629 \u0627\u0644\u0645\u0636\u0627\u0641\u0629 \u0627\u0644\u0630\u064A \u0623\u062C\u0631\u0627\u0647 \u0627\u0644\u062D\u0631\u064A\u0641 (\u0627\u0644\u0647\u064A\u0627\u0643\u0644 \u0627\u0644\u0639\u0645\u0648\u0645\u064A\u0629) \u0644\u0641\u0627\u0626\u062F\u0629 \u0627\u0644\u062E\u0632\u064A\u0646\u0629."
              },
              certificate: {
                term: "\u0634\u0647\u0627\u062F\u0629 \u0627\u0644\u062E\u0635\u0645",
                text: "\u0627\u0644\u0648\u062B\u064A\u0642\u0629 \u0627\u0644\u062A\u064A \u064A\u062C\u0628 \u0639\u0644\u0649 \u0627\u0644\u062D\u0631\u064A\u0641 \u062A\u0633\u0644\u064A\u0645\u0647\u0627 \u0644\u0643 \u0639\u0646\u062F\u0645\u0627 \u064A\u0642\u062A\u0637\u0639 \u0645\u0628\u0644\u063A\u064B\u0627. \xAB\u0645\u0633\u062A\u0644\u0645\u0629\xBB (\u0645\u0639 \u0645\u0631\u062C\u0639 \u2066TEJ\u2069) \u0623\u0648 \xAB\u0646\u0627\u0642\u0635\u0629\xBB \u0623\u0648 \xAB\u0644\u0627 \u064A\u0646\u0637\u0628\u0642\xBB \u0625\u0630\u0627 \u0644\u0645 \u064A\u064F\u0642\u062A\u0637\u0639 \u0634\u064A\u0621."
              },
              add: {
                term: "\u0625\u0636\u0627\u0641\u0629",
                text: "\u0628\u062C\u0627\u0646\u0628 \xAB\u0646\u0627\u0642\u0635\u0629\xBB: \u064A\u0641\u062A\u062D \u0646\u0627\u0641\u0630\u0629 \u0625\u0631\u0641\u0627\u0642 \u0627\u0644\u0634\u0647\u0627\u062F\u0629. \u0645\u062E\u0635\u0635 \u0644\u0645\u0646 \u064A\u0633\u062A\u0637\u064A\u0639\u0648\u0646 \u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062F\u0641\u0639\u0627\u062A."
              },
              reference: {
                term: "\u0627\u0644\u0645\u0631\u062C\u0639",
                text: "\u0631\u0642\u0645 \u0627\u0644\u062A\u062D\u0648\u064A\u0644 \u0623\u0648 \u0627\u0644\u0625\u064A\u062F\u0627\u0639\u2026 \u0627\u0644\u0645\u0633\u062C\u0644 \u0645\u0639 \u0627\u0644\u062F\u0641\u0639\u0629\u061B \u0648\xAB\u2014\xBB \u0625\u0630\u0627 \u0644\u0645 \u064A\u0648\u062C\u062F."
              }
            }
          },
          methods: {
            title: "\u0637\u0631\u0642 \u0627\u0644\u062F\u0641\u0639",
            items: {
              transfer: {
                term: "\u062A\u062D\u0648\u064A\u0644 \u0628\u0646\u0643\u064A",
                text: "\u0627\u0644\u062F\u0641\u0639 \u0628\u062A\u062D\u0648\u064A\u0644 \u0628\u0646\u0643\u064A."
              },
              cheque: {
                term: "\u0635\u0643",
                text: "\u0627\u0644\u062F\u0641\u0639 \u0628\u0635\u0643: \u064A\u064F\u0637\u0644\u0628 \u0627\u0644\u0631\u0642\u0645 \u0648\u0627\u0644\u0628\u0646\u0643 \u0648\u0627\u0644\u0635\u0644\u0627\u062D\u064A\u0629."
              },
              bill: {
                term: "\u0643\u0645\u0628\u064A\u0627\u0644\u0629",
                text: "\u0627\u0644\u062F\u0641\u0639 \u0628\u0643\u0645\u0628\u064A\u0627\u0644\u0629."
              },
              cash: {
                term: "\u0646\u0642\u062F\u064B\u0627",
                text: "\u0627\u0644\u062F\u0641\u0639 \u0646\u0642\u062F\u064B\u0627\u061B \u0648\u0642\u062F \u064A\u0646\u0628\u0651\u0647 \u062A\u062D\u0630\u064A\u0631 \u0625\u0644\u0649 \u0623\u0646 \u0645\u0628\u0644\u063A\u064B\u0627 \u0645\u0631\u062A\u0641\u0639\u064B\u0627 \u063A\u064A\u0631 \u0642\u0627\u0628\u0644 \u0644\u0644\u0637\u0631\u062D \u0628\u0627\u0644\u0646\u0633\u0628\u0629 \u0625\u0644\u0649 \u0627\u0644\u062D\u0631\u064A\u0641."
              },
              online: {
                term: "\u062F\u0641\u0639 \u0639\u0628\u0631 \u0627\u0644\u0625\u0646\u062A\u0631\u0646\u062A",
                text: "\u062F\u0641\u0639 \u062A\u0645 \u0639\u0628\u0631 \u0627\u0644\u0625\u0646\u062A\u0631\u0646\u062A."
              }
            }
          },
          certificateDialog: {
            title: "\u0634\u0647\u0627\u062F\u0629 \u0627\u0644\u062E\u0635\u0645",
            items: {
              tej: {
                term: "\u0645\u0631\u062C\u0639 \u2066TEJ\u2069 \u0644\u0634\u0647\u0627\u062F\u0629 \u0627\u0644\u062E\u0635\u0645",
                text: "\u0627\u062E\u062A\u064A\u0627\u0631\u064A: \u0627\u0644\u0645\u0631\u062C\u0639 \u0627\u0644\u0630\u064A \u064A\u0645\u0646\u062D\u0647 \u0646\u0638\u0627\u0645 \u2066TEJ\u2069 \u0644\u0644\u0625\u062F\u0627\u0631\u0629 \u0627\u0644\u062C\u0628\u0627\u0626\u064A\u0629."
              },
              document: {
                term: "\u0634\u0647\u0627\u062F\u0629 \u0627\u0644\u062E\u0635\u0645 (\u0648\u062B\u064A\u0642\u0629)",
                text: "\u0627\u062E\u062A\u064A\u0627\u0631\u064A: \u0627\u0628\u062D\u062B \u0639\u0646 \u0627\u0644\u0646\u0633\u062E\u0629 \u0627\u0644\u0645\u0645\u0633\u0648\u062D\u0629 \u0627\u0644\u0645\u0648\u062F\u0639\u0629 \u0641\u064A \u0627\u0644\u0648\u062B\u0627\u0626\u0642. \u064A\u0644\u0632\u0645 \u0627\u0644\u0645\u0631\u062C\u0639 \u0623\u0648 \u0627\u0644\u0648\u062B\u064A\u0642\u0629 \u0639\u0644\u0649 \u0627\u0644\u0623\u0642\u0644."
              },
              save: {
                term: "\u062D\u0641\u0638 \u0627\u0644\u0634\u0647\u0627\u062F\u0629",
                text: "\u064A\u062D\u0641\u0638 \u0627\u0644\u0634\u0647\u0627\u062F\u0629 \u0639\u0644\u0649 \u0627\u0644\u062F\u0641\u0639\u0629. \xAB\u0625\u0644\u063A\u0627\u0621\xBB \u064A\u063A\u0644\u0642 \u0627\u0644\u0646\u0627\u0641\u0630\u0629."
              }
            }
          },
          recordDialog: {
            title: "\u062A\u0633\u062C\u064A\u0644 \u062F\u0641\u0639\u0629 \u0639\u0644\u0649 \u0641\u0627\u062A\u0648\u0631\u0629",
            items: {
              outstanding: {
                term: "\u0627\u0644\u0645\u062A\u0628\u0642\u064A \u0642\u0628\u0644 \u0647\u0630\u0647 \u0627\u0644\u062F\u0641\u0639\u0629",
                text: "\u0627\u0644\u0645\u0628\u0644\u063A \u0627\u0644\u0630\u064A \u0628\u0642\u064A \u062F\u0641\u0639\u0647 \u0641\u064A \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629. \u0648\u062A\u0628\u064A\u0651\u0646 \u062C\u0645\u0644\u0629 \u062A\u062D\u062A\u0647 \u0645\u0627 \u062A\u0633\u062F\u0651\u062F\u0647 \u0647\u0630\u0647 \u0627\u0644\u062F\u0641\u0639\u0629 \u0648\u0645\u0627 \u064A\u0628\u0642\u0649 \u0628\u0639\u062F\u0647\u0627."
              },
              receivedOn: {
                term: "\u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0627\u0633\u062A\u0644\u0627\u0645",
                text: "\u0625\u062C\u0628\u0627\u0631\u064A: \u062A\u0627\u0631\u064A\u062E \u0648\u0635\u0648\u0644 \u0627\u0644\u062F\u0641\u0639\u0629\u061B \u0648\u0644\u0627 \u064A\u0645\u0643\u0646 \u0623\u0646 \u064A\u0643\u0648\u0646 \u0641\u064A \u0627\u0644\u0645\u0633\u062A\u0642\u0628\u0644."
              },
              method: {
                term: "\u0637\u0631\u064A\u0642\u0629 \u0627\u0644\u062F\u0641\u0639",
                text: "\u062A\u062D\u0648\u064A\u0644 \u0628\u0646\u0643\u064A \u0623\u0648 \u0635\u0643 \u0623\u0648 \u0643\u0645\u0628\u064A\u0627\u0644\u0629 \u0623\u0648 \u0646\u0642\u062F\u064B\u0627 \u0623\u0648 \u062F\u0641\u0639 \u0639\u0628\u0631 \u0627\u0644\u0625\u0646\u062A\u0631\u0646\u062A."
              },
              amounts: {
                term: "\u0627\u0644\u0645\u0628\u0644\u063A \u0627\u0644\u0645\u0633\u062A\u0644\u0645\u060C \u0627\u0644\u062E\u0635\u0645 \u0645\u0646 \u0627\u0644\u0645\u0648\u0631\u062F\u060C \u0627\u0644\u062E\u0635\u0645 \u0628\u0639\u0646\u0648\u0627\u0646 \u0627\u0644\u0623\u062F\u0627\u0621 \u0639\u0644\u0649 \u0627\u0644\u0642\u064A\u0645\u0629 \u0627\u0644\u0645\u0636\u0627\u0641\u0629",
                text: "\u062A\u064F\u0642\u062A\u0631\u062D \u0627\u0644\u0645\u0628\u0627\u0644\u063A \u0628\u062D\u0633\u0628 \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629 \u0648\u064A\u0645\u0643\u0646\u0643 \u062A\u0635\u062D\u064A\u062D\u0647\u0627. \u0648\u0644\u0627 \u064A\u0645\u0643\u0646 \u0623\u0646 \u062A\u062A\u062C\u0627\u0648\u0632 \u0627\u0644\u062F\u0641\u0639\u0629 \u0627\u0644\u0645\u062A\u0628\u0642\u064A."
              },
              cheque: {
                term: "\u0631\u0642\u0645 \u0627\u0644\u0635\u0643\u060C \u0627\u0644\u0628\u0646\u0643\u060C \u0627\u0644\u0635\u0643 \u0635\u0627\u0644\u062D \u0625\u0644\u0649 \u063A\u0627\u064A\u0629",
                text: "\u0644\u0644\u0635\u0643 \u0641\u0642\u0637: \u0627\u0644\u0631\u0642\u0645 \u0648\u0627\u0644\u0628\u0646\u0643 \u0625\u062C\u0628\u0627\u0631\u064A\u0627\u0646\u061B \u0648\u062F\u0648\u0646 \u062A\u0627\u0631\u064A\u062E \u062A\u064F\u0637\u0628\u064E\u0651\u0642 \u0645\u062F\u0629 \u0627\u0644\u0635\u0644\u0627\u062D\u064A\u0629 \u0641\u064A \u0627\u0644\u0642\u0648\u0627\u0639\u062F \u0627\u0644\u062C\u0628\u0627\u0626\u064A\u0629 (6 \u0623\u0634\u0647\u0631)."
              },
              reference: {
                term: "\u0645\u0631\u062C\u0639 \u0627\u0644\u062F\u0641\u0639",
                text: "\u0627\u062E\u062A\u064A\u0627\u0631\u064A: \u0631\u0642\u0645 \u0627\u0644\u062A\u062D\u0648\u064A\u0644 \u0623\u0648 \u0627\u0644\u0625\u064A\u062F\u0627\u0639\u2026"
              },
              certificate: {
                term: "\u0645\u0631\u062C\u0639 \u2066TEJ\u2069 \u0644\u0634\u0647\u0627\u062F\u0629 \u0627\u0644\u062E\u0635\u0645",
                text: "\u0627\u062E\u062A\u064A\u0627\u0631\u064A: \u064A\u0645\u0643\u0646\u0643 \u0623\u064A\u0636\u064B\u0627 \u0625\u0631\u0641\u0627\u0642 \u0648\u062B\u064A\u0642\u0629 \u0627\u0644\u0634\u0647\u0627\u062F\u0629\u061B \u0648\u062A\u0628\u0642\u0649 \u0627\u0644\u0625\u0636\u0627\u0641\u0629 \u0645\u0645\u0643\u0646\u0629 \u0644\u0627\u062D\u0642\u064B\u0627."
              },
              result: {
                term: "\u062A\u0645 \u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062F\u0641\u0639\u0629",
                text: "\u0628\u0639\u062F \u0627\u0644\u062D\u0641\u0638: \u0645\u0627 \u0628\u0642\u064A \u0644\u0644\u0627\u0633\u062A\u062E\u0644\u0627\u0635 \u0648\u062D\u0627\u0644\u0629 \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629 (\u063A\u064A\u0631 \u0645\u062F\u0641\u0648\u0639\u0629 \u0623\u0648 \u0645\u062F\u0641\u0648\u0639\u0629 \u062C\u0632\u0626\u064A\u064B\u0627 \u0623\u0648 \u0645\u062F\u0641\u0648\u0639\u0629) \u0648\u0623\u064A \u062A\u062D\u0630\u064A\u0631\u0627\u062A. \xAB\u0625\u063A\u0644\u0627\u0642\xBB \u064A\u0646\u0647\u064A \u0627\u0644\u0639\u0645\u0644\u064A\u0629."
              }
            }
          },
          aging: {
            title: "\u062C\u062F\u0648\u0644 \u0623\u0639\u0645\u0627\u0631 \u0627\u0644\u062F\u064A\u0648\u0646",
            items: {
              intro: {
                term: "\u0627\u0644\u0648\u0636\u0639\u064A\u0629 \u0628\u062A\u0627\u0631\u064A\u062E \u2026",
                text: "\u0645\u0627 \u0644\u0627 \u064A\u0632\u0627\u0644 \u062D\u0631\u0641\u0627\u0624\u0643 \u0645\u062F\u064A\u0646\u064A\u0646 \u0628\u0647 \u0644\u0643\u060C \u0645\u0635\u0646\u0641\u064B\u0627 \u062D\u0633\u0628 \u0645\u062F\u0629 \u0627\u0644\u062A\u0623\u062E\u0631 \u0639\u0646 \u0627\u0644\u0627\u0633\u062A\u062D\u0642\u0627\u0642\u060C \u0628\u0627\u0644\u062F\u064A\u0646\u0627\u0631. \u0644\u0627 \u064A\u0638\u0647\u0631 \u0625\u0644\u0627 \u0644\u0645\u0646 \u0644\u0647\u0645 \u0635\u0644\u0627\u062D\u064A\u0629 \u0627\u0644\u0627\u0637\u0644\u0627\u0639 \u0639\u0644\u0649 \u0644\u0648\u062D\u0629 \u0627\u0644\u0642\u064A\u0627\u062F\u0629 \u0627\u0644\u0645\u0627\u0644\u064A\u0629."
              },
              client: {
                term: "\u0627\u0644\u062D\u0631\u064A\u0641",
                text: "\u0633\u0637\u0631 \u0644\u0643\u0644 \u062D\u0631\u064A\u0641 \u062B\u0645 \u0633\u0637\u0631 \xAB\u0627\u0644\u0645\u062C\u0645\u0648\u0639\xBB."
              },
              invoices: {
                term: "\u0627\u0644\u0641\u0648\u0627\u062A\u064A\u0631",
                text: "\u0639\u062F\u062F \u0641\u0648\u0627\u062A\u064A\u0631 \u0627\u0644\u062D\u0631\u064A\u0641 \u063A\u064A\u0631 \u0627\u0644\u0645\u0633\u062F\u062F\u0629."
              },
              current: {
                term: "\u0644\u0645 \u064A\u062D\u0644 \u0623\u062C\u0644\u0647",
                text: "\u0627\u0644\u0645\u0628\u0627\u0644\u063A \u0627\u0644\u062A\u064A \u0644\u0645 \u064A\u062D\u0646 \u062A\u0627\u0631\u064A\u062E \u0627\u0633\u062A\u062D\u0642\u0627\u0642\u0647\u0627 \u0628\u0639\u062F."
              },
              late: {
                term: "\u0645\u0646 0 \u0625\u0644\u0649 30 \u064A\u0648\u0645\u064B\u0627\u060C \u0645\u0646 31 \u0625\u0644\u0649 60 \u064A\u0648\u0645\u064B\u0627\u060C \u0645\u0646 61 \u0625\u0644\u0649 90 \u064A\u0648\u0645\u064B\u0627",
                text: "\u0627\u0644\u0645\u0628\u0627\u0644\u063A \u0627\u0644\u0645\u062A\u0623\u062E\u0631\u0629\u060C \u0645\u0635\u0646\u0641\u0629 \u062D\u0633\u0628 \u0645\u062F\u0629 \u0627\u0644\u062A\u0623\u062E\u0631."
              },
              over90: {
                term: "\u0623\u0643\u062B\u0631 \u0645\u0646 90 \u064A\u0648\u0645\u064B\u0627",
                text: "\u0627\u0644\u0645\u0628\u0627\u0644\u063A \u0627\u0644\u0645\u062A\u0623\u062E\u0631\u0629 \u0645\u0646\u0630 \u0623\u0643\u062B\u0631 \u0645\u0646 90 \u064A\u0648\u0645\u064B\u0627."
              },
              total: {
                term: "\u0645\u062C\u0645\u0648\u0639 \u0627\u0644\u0645\u0633\u062A\u062D\u0642",
                text: "\u0645\u062C\u0645\u0648\u0639 \u0645\u0627 \u064A\u062F\u064A\u0646 \u0628\u0647 \u0627\u0644\u062D\u0631\u064A\u0641 \u0644\u0643. \u0648\u0625\u0646 \u0644\u0645 \u064A\u0648\u062C\u062F \u0634\u064A\u0621: \xAB\u0644\u0627 \u062A\u0648\u062C\u062F \u062F\u064A\u0648\u0646 \u0642\u0627\u0626\u0645\u0629.\xBB"
              }
            }
          },
          reminders: {
            title: "\u062A\u0630\u0643\u064A\u0631 \u0627\u0644\u062D\u0631\u0641\u0627\u0621",
            items: {
              enabled: {
                term: "\u0625\u0631\u0633\u0627\u0644 \u062A\u0630\u0643\u064A\u0631\u0627\u062A \u062A\u0644\u0642\u0627\u0626\u064A\u0629",
                text: "\u0645\u0641\u062A\u0627\u062D: \u064A\u064F\u0631\u0633\u064E\u0644 \u0628\u0631\u064A\u062F \u062A\u0630\u0643\u064A\u0631 \u0625\u0644\u0649 \u0627\u0644\u062D\u0631\u064A\u0641 \u0639\u0646\u062F \u062A\u0623\u062E\u0631 \u0627\u0644\u062F\u0641\u0639."
              },
              days: {
                term: "\u0623\u064A\u0627\u0645 \u0627\u0644\u062A\u0630\u0643\u064A\u0631 \u0628\u0639\u062F \u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0627\u0633\u062A\u062D\u0642\u0627\u0642",
                text: "\u062D\u062A\u0649 5 \u0623\u064A\u0627\u0645\u060C \u0645\u0646 \u0627\u0644\u0623\u0635\u063A\u0631 \u0625\u0644\u0649 \u0627\u0644\u0623\u0643\u0628\u0631\u060C \u0645\u0641\u0635\u0648\u0644\u0629 \u0628\u0641\u0648\u0627\u0635\u0644 (\u0645\u062B\u0627\u0644: \u20667, 15, 30\u2069)."
              },
              save: {
                term: "\u062D\u0641\u0638 \u0627\u0644\u062A\u0630\u0643\u064A\u0631\u0627\u062A",
                text: "\u064A\u062D\u0641\u0638 \u0647\u0630\u0647 \u0627\u0644\u0625\u0639\u062F\u0627\u062F\u0627\u062A. \u0645\u062E\u0635\u0635 \u0644\u0645\u0646 \u064A\u062D\u0642 \u0644\u0647\u0645 \u062A\u0639\u062F\u064A\u0644 \u0627\u0644\u0645\u0644\u0641 \u0627\u0644\u062C\u0628\u0627\u0626\u064A\u061B \u0648\u062A\u0642\u0648\u0644 \u0631\u0633\u0627\u0644\u0629 \u0644\u063A\u064A\u0631\u0647\u0645 \u0625\u0646 \u0627\u0644\u0645\u0633\u0624\u0648\u0644 \u0648\u062D\u062F\u0647 \u064A\u0633\u062A\u0637\u064A\u0639 \u062A\u0639\u062F\u064A\u0644\u0647\u0627."
              }
            }
          }
        }
      },
      expenses: {
        title: "\u0645\u0630\u0643\u0631\u0627\u062A \u0627\u0644\u0645\u0635\u0627\u0631\u064A\u0641",
        intro: "\u0645\u0630\u0643\u0631\u0627\u062A \u0645\u0635\u0627\u0631\u064A\u0641\u0643: \u062A\u0635\u0631\u0651\u062D \u0628\u0645\u0635\u0631\u0648\u0641 \u0645\u0639 \u0648\u062B\u064A\u0642\u0629 \u0625\u062B\u0628\u0627\u062A\u0647 (\u0635\u0648\u0631\u0629 \u0623\u0648 \u0645\u0644\u0641 \u2066PDF\u2069) \u062B\u0645 \u064A\u0631\u0627\u062C\u0639\u0647 \u0645\u0633\u0624\u0648\u0644 \u0627\u0644\u0645\u0648\u0627\u0641\u0642\u0629 \u0642\u0628\u0644 \u062A\u0639\u0648\u064A\u0636\u0647. \u064A\u0633\u062A\u0637\u064A\u0639 \u0643\u0644 \u0639\u0636\u0648 \u0627\u0644\u062A\u0635\u0631\u064A\u062D \u0628\u0645\u0635\u0627\u0631\u064A\u0641\u0647.",
        sections: {
          header: {
            title: "\u0627\u0644\u0631\u0623\u0633 \u0648\u0627\u0644\u062A\u0628\u0648\u064A\u0628\u0627\u062A",
            items: {
              subNav: {
                term: "\u0627\u0644\u0645\u0627\u0644\u064A\u0629",
                text: "\u062A\u0639\u0631\u0636 \u0627\u0644\u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u064A\u0645\u0646\u0649 \u0623\u0642\u0633\u0627\u0645 \u0627\u0644\u0645\u0627\u0644\u064A\u0629 \u0627\u0644\u062A\u064A \u062A\u0633\u0645\u062D \u0628\u0647\u0627 \u0635\u0644\u0627\u062D\u064A\u0627\u062A\u0643\u060C \u0648\u0639\u0644\u0649 \u0627\u0644\u0634\u0627\u0634\u0629 \u0627\u0644\u0635\u063A\u064A\u0631\u0629 \u062A\u062A\u062D\u0648\u0644 \u0625\u0644\u0649 \u0635\u0641 \u0645\u0646 \u0627\u0644\u0631\u0648\u0627\u0628\u0637."
              },
              newExpense: {
                term: "\u0645\u0630\u0643\u0631\u0629 \u0645\u0635\u0627\u0631\u064A\u0641 \u062C\u062F\u064A\u062F\u0629",
                text: "\u064A\u0641\u062A\u062D \u0646\u0645\u0648\u0630\u062C \u0627\u0644\u062A\u0635\u0631\u064A\u062D \u0628\u0645\u0635\u0631\u0648\u0641. \u064A\u062E\u062A\u0641\u064A \u0627\u0644\u0632\u0631 \u0645\u0627 \u062F\u0627\u0645 \u0627\u0644\u0646\u0645\u0648\u0630\u062C \u0645\u0641\u062A\u0648\u062D\u064B\u0627."
              },
              tabs: {
                term: "\u0645\u0630\u0643\u0631\u0627\u062A \u0645\u0635\u0627\u0631\u064A\u0641\u064A / \u0628\u0627\u0646\u062A\u0638\u0627\u0631 \u0627\u0644\u0645\u0648\u0627\u0641\u0642\u0629",
                text: "\u062A\u0628\u0648\u064A\u0628\u0627\u0646 \u0644\u0627 \u064A\u0638\u0647\u0631\u0627\u0646 \u0625\u0644\u0627 \u0644\u0645\u0646 \u064A\u0648\u0627\u0641\u0642\u0648\u0646 \u0639\u0644\u0649 \u0645\u0630\u0643\u0631\u0627\u062A \u0627\u0644\u0645\u0635\u0627\u0631\u064A\u0641 \u0623\u0648 \u064A\u0637\u0644\u0639\u0648\u0646 \u0639\u0644\u0649 \u0645\u0630\u0643\u0631\u0627\u062A \u0627\u0644\u062C\u0645\u064A\u0639: \u0645\u0635\u0627\u0631\u064A\u0641\u0643 \u0627\u0644\u062E\u0627\u0635\u0629\u060C \u0648\u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u0645\u0630\u0643\u0631\u0627\u062A \u0627\u0644\u0645\u0637\u0644\u0648\u0628 \u0645\u0639\u0627\u0644\u062C\u062A\u0647\u0627."
              }
            }
          },
          list: {
            title: "\u0645\u0630\u0643\u0631\u0627\u062A \u0645\u0635\u0627\u0631\u064A\u0641\u064A",
            items: {
              status: {
                term: "\u0627\u0644\u062D\u0627\u0644\u0629",
                text: "\u064A\u0639\u0631\u0636 \u0641\u0642\u0637 \u0627\u0644\u0645\u0630\u0643\u0631\u0627\u062A \u0642\u064A\u062F \u0627\u0644\u0627\u0646\u062A\u0638\u0627\u0631 \u0623\u0648 \u0627\u0644\u062A\u064A \u062A\u0645\u062A \u0627\u0644\u0645\u0648\u0627\u0641\u0642\u0629 \u0639\u0644\u064A\u0647\u0627 \u0623\u0648 \u0627\u0644\u0645\u0631\u0641\u0648\u0636\u0629 \u0623\u0648 \u0627\u0644\u062A\u064A \u062A\u0645 \u062A\u0639\u0648\u064A\u0636\u0647\u0627\u061B \u0648\xAB\u0643\u0644 \u0627\u0644\u062D\u0627\u0644\u0627\u062A\xBB \u062A\u0639\u0631\u0636 \u0627\u0644\u062C\u0645\u064A\u0639."
              },
              empty: {
                term: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0645\u0630\u0643\u0631\u0627\u062A \u0645\u0635\u0627\u0631\u064A\u0641",
                text: "\u0631\u0633\u0627\u0644\u0629 \u0627\u0644\u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u0641\u0627\u0631\u063A\u0629: \u0635\u0648\u0651\u0631 \u0648\u062B\u064A\u0642\u0629 \u0627\u0644\u0625\u062B\u0628\u0627\u062A \u062B\u0645 \u0635\u0631\u0651\u062D \u0628\u0627\u0644\u0645\u0635\u0631\u0648\u0641. \u0648\u064A\u064F\u0642\u062A\u0631\u062D \u0632\u0631 \xAB\u0645\u0630\u0643\u0631\u0629 \u0645\u0635\u0627\u0631\u064A\u0641 \u062C\u062F\u064A\u062F\u0629\xBB \u0639\u0644\u0649 \u0645\u0646 \u064A\u0633\u062A\u0637\u064A\u0639\u0648\u0646 \u0627\u0644\u062A\u0635\u0631\u064A\u062D."
              },
              filtered: {
                term: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0645\u0630\u0643\u0631\u0627\u062A \u0645\u0635\u0627\u0631\u064A\u0641 \u0628\u0647\u0630\u0647 \u0627\u0644\u062D\u0627\u0644\u0629",
                text: "\u0631\u0633\u0627\u0644\u0629 \u062A\u0638\u0647\u0631 \u0639\u0646\u062F\u0645\u0627 \u0644\u0627 \u064A\u062C\u062F \u0627\u0644\u0645\u0631\u0634\u062D \u0634\u064A\u0626\u064B\u0627\u061B \u0648\xAB\u0639\u0631\u0636 \u0643\u0644 \u0645\u0630\u0643\u0631\u0627\u062A \u0645\u0635\u0627\u0631\u064A\u0641\u064A\xBB \u062A\u0632\u064A\u0644\u0647."
              },
              loadMore: {
                term: "\u0639\u0631\u0636 \u0627\u0644\u0645\u0632\u064A\u062F \u0645\u0646 \u0645\u0630\u0643\u0631\u0627\u062A \u0627\u0644\u0645\u0635\u0627\u0631\u064A\u0641",
                text: "\u062A\u062D\u062A \u0627\u0644\u0642\u0627\u0626\u0645\u0629: \u064A\u062D\u0645\u0651\u0644 \u0627\u0644\u0628\u0627\u0642\u064A. \u0648\u0639\u0646\u062F \u0627\u0644\u062E\u0637\u0623 \u062A\u0639\u064A\u062F \xAB\u0625\u0639\u0627\u062F\u0629 \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629\xBB \u0627\u0644\u062A\u062D\u0645\u064A\u0644."
              }
            }
          },
          card: {
            title: "\u0645\u0630\u0643\u0631\u0629 \u0645\u0635\u0627\u0631\u064A\u0641",
            items: {
              head: {
                term: "\u0627\u0644\u0645\u0648\u0636\u0648\u0639 \u0648\u0627\u0644\u062D\u0627\u0644\u0629",
                text: "\u0627\u0644\u0639\u0646\u0648\u0627\u0646 \u0647\u0648 \u0633\u0628\u0628 \u0627\u0644\u0645\u0635\u0631\u0648\u0641\u060C \u0645\u0639 \u062D\u0627\u0644\u062A\u0647 \u0645\u0643\u062A\u0648\u0628\u0629 \u0628\u0627\u0644\u062D\u0631\u0648\u0641."
              },
              meta: {
                term: "\u0627\u0644\u0635\u0646\u0641 \u0648\u0627\u0644\u062A\u0627\u0631\u064A\u062E \u0648\u0627\u0644\u0645\u0634\u0631\u0648\u0639",
                text: "\u0627\u0644\u0635\u0646\u0641 \u0648\xAB\u0645\u0635\u0631\u0648\u0641 \u0628\u062A\u0627\u0631\u064A\u062E \u2026\xBB \u0648\u0627\u0644\u0645\u0634\u0631\u0648\u0639 \u0627\u0644\u0645\u0639\u0646\u064A (\u0623\u0648 \xAB\u062F\u0648\u0646 \u0645\u0634\u0631\u0648\u0639\xBB)."
              },
              amounts: {
                term: "\u0627\u0644\u0645\u062C\u0645\u0648\u0639 \u0628\u0627\u062D\u062A\u0633\u0627\u0628 \u0627\u0644\u0623\u062F\u0627\u0621\u0627\u062A",
                text: "\u0627\u0644\u0645\u0628\u0644\u063A \u0627\u0644\u0645\u062F\u0641\u0648\u0639\u060C \u0648\u062A\u062D\u062A\u0647 \u0627\u0644\u062A\u0641\u0635\u064A\u0644 \u062F\u0648\u0646 \u0627\u0644\u0623\u062F\u0627\u0621\u0627\u062A \u0648\u0627\u0644\u0623\u062F\u0627\u0621 \u0639\u0644\u0649 \u0627\u0644\u0642\u064A\u0645\u0629 \u0627\u0644\u0645\u0636\u0627\u0641\u0629\u060C \u0648\u0647\u0644 \u0627\u0644\u0623\u062F\u0627\u0621 \u0642\u0627\u0628\u0644 \u0644\u0644\u0637\u0631\u062D \u0623\u0645 \u0644\u0627."
              },
              decision: {
                term: "\u0627\u0644\u0642\u0631\u0627\u0631",
                text: "\u0645\u0646 \u0648\u0627\u0641\u0642 \u0639\u0644\u0649 \u0627\u0644\u0645\u0630\u0643\u0631\u0629 \u0623\u0648 \u0631\u0641\u0636\u0647\u0627 \u0648\u0645\u062A\u0649\u061B \u0648\u0641\u064A \u062D\u0627\u0644\u0629 \u0627\u0644\u0631\u0641\u0636 \xAB\u0627\u0644\u0633\u0628\u0628\xBB \u0627\u0644\u0630\u064A \u0643\u062A\u0628\u0647 \u0645\u0633\u0624\u0648\u0644 \u0627\u0644\u0645\u0648\u0627\u0641\u0642\u0629\u061B \u0648\u0641\u064A \u062D\u0627\u0644\u0629 \u0627\u0644\u062A\u0639\u0648\u064A\u0636 \u0627\u0644\u062A\u0627\u0631\u064A\u062E."
              },
              receipt: {
                term: "\u0639\u0631\u0636 \u0648\u062B\u064A\u0642\u0629 \u0627\u0644\u0625\u062B\u0628\u0627\u062A",
                text: "\u064A\u0641\u062A\u062D \u0648\u062B\u064A\u0642\u0629 \u0627\u0644\u0625\u062B\u0628\u0627\u062A \u0641\u064A \u062A\u0628\u0648\u064A\u0628 \u062C\u062F\u064A\u062F. \u0648\u0645\u0627 \u062F\u0627\u0645 \u0641\u062D\u0635 \u0645\u0636\u0627\u062F \u0627\u0644\u0641\u064A\u0631\u0648\u0633\u0627\u062A \u0644\u0645 \u064A\u0646\u062A\u0647 \u062A\u0638\u0647\u0631 \u0628\u062F\u0644\u064B\u0627 \u0645\u0646\u0647 \xAB\u0648\u062B\u064A\u0642\u0629 \u0627\u0644\u0625\u062B\u0628\u0627\u062A \u0642\u064A\u062F \u0627\u0644\u0641\u062D\u0635\xBB."
              },
              resubmit: {
                term: "\u0625\u0639\u0627\u062F\u0629 \u0627\u0644\u0625\u0631\u0633\u0627\u0644",
                text: "\u0641\u064A \u0645\u0630\u0643\u0631\u0629 \u0645\u0631\u0641\u0648\u0636\u0629: \u064A\u0639\u064A\u062F \u0641\u062A\u062D \u0627\u0644\u0646\u0645\u0648\u0630\u062C \u0628\u0627\u0644\u0645\u0639\u0644\u0648\u0645\u0627\u062A \u0627\u0644\u0623\u0635\u0644\u064A\u0629 \u0644\u062A\u0635\u062D\u064A\u062D\u0647\u0627 \u0648\u0625\u0639\u0627\u062F\u0629 \u0625\u0631\u0633\u0627\u0644 \u0627\u0644\u0645\u0630\u0643\u0631\u0629."
              }
            }
          },
          statuses: {
            title: "\u062D\u0627\u0644\u0627\u062A \u0645\u0630\u0643\u0631\u0629 \u0627\u0644\u0645\u0635\u0627\u0631\u064A\u0641",
            items: {
              submitted: {
                term: "\u0642\u064A\u062F \u0627\u0644\u0627\u0646\u062A\u0638\u0627\u0631",
                text: "\u0623\u064F\u0631\u0633\u0644\u062A \u0627\u0644\u0645\u0630\u0643\u0631\u0629 \u0625\u0644\u0649 \u0627\u0644\u0645\u0633\u0624\u0648\u0644\u064A\u0646 \u0639\u0646 \u0627\u0644\u0645\u0648\u0627\u0641\u0642\u0629 \u0627\u0644\u0630\u064A\u0646 \u0644\u0645 \u064A\u0628\u062A\u0651\u0648\u0627 \u0641\u064A\u0647\u0627 \u0628\u0639\u062F."
              },
              approved: {
                term: "\u062A\u0645\u062A \u0627\u0644\u0645\u0648\u0627\u0641\u0642\u0629",
                text: "\u0642\u0628\u0644 \u0645\u0633\u0624\u0648\u0644 \u0627\u0644\u0645\u0648\u0627\u0641\u0642\u0629 \u0627\u0644\u0645\u0635\u0631\u0648\u0641\u061B \u0648\u064A\u0628\u0642\u0649 \u062A\u0639\u0648\u064A\u0636\u0647."
              },
              rejected: {
                term: "\u0645\u0631\u0641\u0648\u0636\u0629",
                text: "\u0631\u064F\u0641\u0636 \u0627\u0644\u0645\u0635\u0631\u0648\u0641 \u0645\u0639 \u0630\u0643\u0631 \u0627\u0644\u0633\u0628\u0628\u061B \u0648\u064A\u0645\u0643\u0646\u0643 \u062A\u0635\u062D\u064A\u062D\u0647 \u0648\u0625\u0639\u0627\u062F\u0629 \u0625\u0631\u0633\u0627\u0644\u0647."
              },
              reimbursed: {
                term: "\u062A\u0645 \u0627\u0644\u062A\u0639\u0648\u064A\u0636",
                text: "\u062A\u0645 \u0627\u0644\u062A\u0639\u0648\u064A\u0636."
              }
            }
          },
          formReceipt: {
            title: "\u0645\u0630\u0643\u0631\u0629 \u0645\u0635\u0627\u0631\u064A\u0641 \u062C\u062F\u064A\u062F\u0629: \u0648\u062B\u064A\u0642\u0629 \u0627\u0644\u0625\u062B\u0628\u0627\u062A",
            items: {
              intro: {
                term: "\u0645\u0630\u0643\u0631\u0629 \u0645\u0635\u0627\u0631\u064A\u0641 \u062C\u062F\u064A\u062F\u0629",
                text: "\u064A\u0628\u062F\u0623 \u0627\u0644\u0646\u0645\u0648\u0630\u062C \u0628\u0648\u062B\u064A\u0642\u0629 \u0627\u0644\u0625\u062B\u0628\u0627\u062A. \u0648\u0641\u064A \u0645\u0630\u0643\u0631\u0629 \u0645\u0631\u0641\u0648\u0636\u0629 \u064A\u0633\u0645\u0649 \xAB\u0625\u0639\u0627\u062F\u0629 \u0625\u0631\u0633\u0627\u0644 \u0645\u0630\u0643\u0631\u0629 \u0627\u0644\u0645\u0635\u0627\u0631\u064A\u0641\xBB \u0648\u064A\u062D\u062A\u0641\u0638 \u0628\u0648\u062B\u064A\u0642\u0629 \u0627\u0644\u0625\u062B\u0628\u0627\u062A \u0627\u0644\u0623\u0635\u0644\u064A\u0629."
              },
              takePhoto: {
                term: "\u0627\u0644\u062A\u0642\u0627\u0637 \u0635\u0648\u0631\u0629",
                text: "\u064A\u0641\u062A\u062D \u0643\u0627\u0645\u064A\u0631\u0627 \u0627\u0644\u0647\u0627\u062A\u0641 \u0644\u062A\u0635\u0648\u064A\u0631 \u0627\u0644\u0648\u0635\u0644 \u0623\u0648 \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629."
              },
              chooseFile: {
                term: "\u0627\u062E\u062A\u064A\u0627\u0631 \u0645\u0644\u0641",
                text: "\u064A\u062E\u062A\u0627\u0631 \u0635\u0648\u0631\u0629 \u0623\u0648 \u0645\u0644\u0641 \u2066PDF\u2069 \u0645\u062D\u0641\u0648\u0638\u064B\u0627 \u0645\u0646 \u0642\u0628\u0644. \u0648\u062B\u064A\u0642\u0629 \u0625\u062B\u0628\u0627\u062A \u0648\u0627\u062D\u062F\u0629 \u0644\u0643\u0644 \u0645\u0630\u0643\u0631\u0629."
              },
              upload: {
                term: "\u0625\u0631\u0633\u0627\u0644 \u0648\u062B\u064A\u0642\u0629 \u0627\u0644\u0625\u062B\u0628\u0627\u062A",
                text: "\u064A\u0628\u064A\u0651\u0646 \u0633\u0637\u0631 \u062A\u0642\u062F\u0651\u0645 \u0627\u0644\u0625\u0631\u0633\u0627\u0644 \u062B\u0645 \u0627\u0644\u0641\u062D\u0635 \u0628\u0645\u0636\u0627\u062F \u0627\u0644\u0641\u064A\u0631\u0648\u0633\u0627\u062A. \u0648\u062B\u064A\u0642\u0629 \u0627\u0644\u0625\u062B\u0628\u0627\u062A \u0625\u062C\u0628\u0627\u0631\u064A\u0629\u060C \u0648\u064A\u062C\u0628 \u062A\u0639\u0648\u064A\u0636 \u0627\u0644\u0645\u0644\u0641 \u0627\u0644\u0645\u0631\u0641\u0648\u0636."
              }
            }
          },
          formDetails: {
            title: "\u0645\u0630\u0643\u0631\u0629 \u0645\u0635\u0627\u0631\u064A\u0641 \u062C\u062F\u064A\u062F\u0629: \u0627\u0644\u0645\u0635\u0631\u0648\u0641",
            items: {
              category: {
                term: "\u0627\u0644\u0635\u0646\u0641",
                text: "\u0625\u062C\u0628\u0627\u0631\u064A: \u0627\u0644\u0646\u0642\u0644 \u0623\u0648 \u0627\u0644\u0648\u0642\u0648\u062F \u0623\u0648 \u0627\u0644\u0625\u0642\u0627\u0645\u0629 \u0623\u0648 \u0627\u0644\u0625\u0637\u0639\u0627\u0645 \u0623\u0648 \u0627\u0644\u0644\u0648\u0627\u0632\u0645 \u0623\u0648 \u0627\u0644\u0637\u0628\u0627\u0639\u0629 \u0648\u0627\u0644\u0646\u0633\u062E \u0623\u0648 \u0627\u0644\u0628\u0631\u0645\u062C\u064A\u0627\u062A \u0648\u0627\u0644\u0627\u0634\u062A\u0631\u0627\u0643\u0627\u062A \u0623\u0648 \u0627\u0644\u0627\u062A\u0635\u0627\u0644\u0627\u062A \u0623\u0648 \u0627\u0644\u062A\u0643\u0648\u064A\u0646 \u0623\u0648 \u0645\u0639\u0627\u0644\u064A\u0645 \u0627\u0644\u0631\u062E\u0635 \u0648\u0627\u0644\u0623\u062A\u0627\u0648\u0627\u062A \u0623\u0648 \u0623\u062E\u0631\u0649."
              },
              label: {
                term: "\u0645\u0648\u0636\u0648\u0639 \u0627\u0644\u0645\u0635\u0631\u0648\u0641",
                text: "\u0625\u062C\u0628\u0627\u0631\u064A: \u0633\u0628\u0628 \u0627\u0644\u0625\u0646\u0641\u0627\u0642\u060C \u0645\u062B\u0644 \xAB\u0645\u0639\u0644\u0648\u0645 \u0627\u0644\u0637\u0631\u064A\u0642 \u0627\u0644\u0633\u064A\u0627\u0631\u0629\u060C \u0634\u0631\u0627\u0621 \u062D\u0628\u0631 \u0627\u0644\u0637\u0627\u0628\u0639\u0629\xBB."
              },
              spentOn: {
                term: "\u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0645\u0635\u0631\u0648\u0641",
                text: "\u0625\u062C\u0628\u0627\u0631\u064A: \u0644\u0627 \u064A\u0645\u0643\u0646 \u0623\u0646 \u064A\u0643\u0648\u0646 \u0641\u064A \u0627\u0644\u0645\u0633\u062A\u0642\u0628\u0644."
              },
              project: {
                term: "\u0627\u0644\u0645\u0634\u0631\u0648\u0639",
                text: "\u0627\u062E\u062A\u064A\u0627\u0631\u064A: \u062A\u064F\u0642\u062A\u0631\u062D \u0645\u0634\u0627\u0631\u064A\u0639\u0643 \u0641\u0642\u0637\u061B \u0648\u0625\u0644\u0627 \xAB\u062F\u0648\u0646 \u0645\u0634\u0631\u0648\u0639\xBB."
              }
            }
          },
          formAmounts: {
            title: "\u0645\u0630\u0643\u0631\u0629 \u0645\u0635\u0627\u0631\u064A\u0641 \u062C\u062F\u064A\u062F\u0629: \u0627\u0644\u0645\u0628\u0627\u0644\u063A",
            items: {
              ttc: {
                term: "\u0627\u0644\u0645\u062C\u0645\u0648\u0639 \u0628\u0627\u062D\u062A\u0633\u0627\u0628 \u0627\u0644\u0623\u062F\u0627\u0621\u0627\u062A",
                text: "\u0625\u062C\u0628\u0627\u0631\u064A: \u0627\u0644\u0645\u0628\u0644\u063A \u0627\u0644\u062C\u0645\u0644\u064A \u0627\u0644\u0645\u062F\u0641\u0648\u0639 \u0643\u0645\u0627 \u064A\u0638\u0647\u0631 \u0641\u064A \u0648\u062B\u064A\u0642\u0629 \u0627\u0644\u0625\u062B\u0628\u0627\u062A."
              },
              vatRate: {
                term: "\u0646\u0633\u0628\u0629 \u0627\u0644\u0623\u062F\u0627\u0621 \u0639\u0644\u0649 \u0627\u0644\u0642\u064A\u0645\u0629 \u0627\u0644\u0645\u0636\u0627\u0641\u0629",
                text: "\u062A\u064F\u0633\u062A\u0639\u0645\u0644 \u0627\u0644\u0646\u0633\u0628\u0629 \u0644\u0627\u062D\u062A\u0633\u0627\u0628 \u0627\u0644\u0645\u0628\u0644\u063A \u062F\u0648\u0646 \u0627\u0644\u0623\u062F\u0627\u0621\u0627\u062A \u0648\u0627\u0644\u0623\u062F\u0627\u0621 \u0627\u0646\u0637\u0644\u0627\u0642\u064B\u0627 \u0645\u0646 \u0627\u0644\u0645\u062C\u0645\u0648\u0639."
              },
              ht: {
                term: "\u0627\u0644\u0645\u0628\u0644\u063A \u062F\u0648\u0646 \u0627\u062D\u062A\u0633\u0627\u0628 \u0627\u0644\u0623\u062F\u0627\u0621\u0627\u062A",
                text: "\u0627\u0644\u0645\u0628\u0644\u063A \u0642\u0628\u0644 \u0627\u0644\u0623\u062F\u0627\u0621\u0627\u062A\u060C \u0645\u062D\u062A\u0633\u0628 \u0644\u0643\u0646\u0647 \u0642\u0627\u0628\u0644 \u0644\u0644\u062A\u0639\u062F\u064A\u0644."
              },
              vat: {
                term: "\u0627\u0644\u0623\u062F\u0627\u0621 \u0639\u0644\u0649 \u0627\u0644\u0642\u064A\u0645\u0629 \u0627\u0644\u0645\u0636\u0627\u0641\u0629",
                text: "\u0645\u062D\u0633\u0648\u0628 \u0628\u0627\u0644\u0646\u0633\u0628\u0629 \u0627\u0644\u0645\u062E\u062A\u0627\u0631\u0629: \u0635\u062D\u0651\u062D\u0647 \u0625\u0630\u0627 \u0643\u0627\u0646\u062A \u0648\u062B\u064A\u0642\u0629 \u0627\u0644\u0625\u062B\u0628\u0627\u062A \u062A\u0630\u0643\u0631 \u062E\u0644\u0627\u0641 \u0630\u0644\u0643. \u0648\u064A\u062C\u0628 \u0623\u0646 \u064A\u0633\u0627\u0648\u064A \u0627\u0644\u0645\u0628\u0644\u063A \u062F\u0648\u0646 \u0627\u0644\u0623\u062F\u0627\u0621\u0627\u062A \u0632\u0627\u0626\u062F \u0627\u0644\u0623\u062F\u0627\u0621 \u0627\u0644\u0645\u062C\u0645\u0648\u0639 \u062F\u0627\u0626\u0645\u064B\u0627."
              },
              vatDeductible: {
                term: "\u0627\u0644\u0623\u062F\u0627\u0621 \u0639\u0644\u0649 \u0627\u0644\u0642\u064A\u0645\u0629 \u0627\u0644\u0645\u0636\u0627\u0641\u0629 \u0641\u064A \u0648\u062B\u064A\u0642\u0629 \u0627\u0644\u0625\u062B\u0628\u0627\u062A \u0647\u0630\u0647 \u0642\u0627\u0628\u0644 \u0644\u0644\u0637\u0631\u062D",
                text: "\u062E\u0627\u0646\u0629 \u0627\u062E\u062A\u064A\u0627\u0631: \u062A\u0628\u064A\u0651\u0646 \u0647\u0644 \u064A\u0645\u0643\u0646 \u0644\u0644\u0645\u0643\u062A\u0628 \u0637\u0631\u062D \u0627\u0644\u0623\u062F\u0627\u0621 \u0639\u0644\u0649 \u0627\u0644\u0642\u064A\u0645\u0629 \u0627\u0644\u0645\u0636\u0627\u0641\u0629 \u0644\u0647\u0630\u0627 \u0627\u0644\u0645\u0635\u0631\u0648\u0641."
              },
              submit: {
                term: "\u0625\u0631\u0633\u0627\u0644 \u0645\u0630\u0643\u0631\u0629 \u0627\u0644\u0645\u0635\u0627\u0631\u064A\u0641",
                text: "\u064A\u0631\u0633\u0644 \u0627\u0644\u0645\u0630\u0643\u0631\u0629 \u0625\u0644\u0649 \u0627\u0644\u0645\u0633\u0624\u0648\u0644\u064A\u0646 \u0639\u0646 \u0627\u0644\u0645\u0648\u0627\u0641\u0642\u0629. \xAB\u0625\u0644\u063A\u0627\u0621\xBB \u064A\u063A\u0644\u0642 \u0627\u0644\u0646\u0645\u0648\u0630\u062C \u062F\u0648\u0646 \u0625\u0631\u0633\u0627\u0644. \u0648\u064A\u0638\u0647\u0631 \u0641\u0648\u0642\u0647 \u0645\u0644\u062E\u0635 \xAB\u062F\u0648\u0646 \u0627\u0644\u0623\u062F\u0627\u0621\u0627\u062A + \u0627\u0644\u0623\u062F\u0627\u0621 = \u0627\u0644\u0645\u062C\u0645\u0648\u0639\xBB."
              }
            }
          }
        }
      },
      expenseApprovals: {
        title: "\u0645\u0630\u0643\u0631\u0627\u062A \u0627\u0644\u0645\u0635\u0627\u0631\u064A\u0641 \u0627\u0644\u0645\u0637\u0644\u0648\u0628 \u0645\u0639\u0627\u0644\u062C\u062A\u0647\u0627",
        intro: "\u0642\u0627\u0626\u0645\u0629 \u0645\u0630\u0643\u0631\u0627\u062A \u0645\u0635\u0627\u0631\u064A\u0641 \u0627\u0644\u0641\u0631\u064A\u0642: \u062A\u0648\u0627\u0641\u0642 \u0639\u0644\u0649 \u0627\u0644\u0645\u0630\u0643\u0631\u0627\u062A \u0627\u0644\u0645\u0639\u0644\u0651\u0642\u0629 \u0623\u0648 \u062A\u0631\u0641\u0636\u0647\u0627 \u062B\u0645 \u062A\u0639\u0644\u0651\u0645 \u0627\u0644\u0645\u062F\u0641\u0648\u0639\u0629 \u0645\u0646\u0647\u0627 \u0639\u0644\u0649 \u0623\u0646\u0647\u0627 \u0645\u0639\u0648\u064E\u0651\u0636\u0629. \u0648\u0647\u064A \u0645\u062E\u0635\u0635\u0629 \u0644\u0645\u0646 \u064A\u0648\u0627\u0641\u0642\u0648\u0646 \u0639\u0644\u0649 \u0645\u0630\u0643\u0631\u0627\u062A \u0627\u0644\u0645\u0635\u0627\u0631\u064A\u0641 \u0623\u0648 \u064A\u0637\u0644\u0639\u0648\u0646 \u0639\u0644\u0649 \u0645\u0630\u0643\u0631\u0627\u062A \u0627\u0644\u062C\u0645\u064A\u0639.",
        sections: {
          header: {
            title: "\u0627\u0644\u0631\u0623\u0633 \u0648\u0627\u0644\u062A\u0628\u0648\u064A\u0628\u0627\u062A",
            items: {
              subNav: {
                term: "\u0627\u0644\u0645\u0627\u0644\u064A\u0629",
                text: "\u062A\u0639\u0631\u0636 \u0627\u0644\u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u064A\u0645\u0646\u0649 \u0623\u0642\u0633\u0627\u0645 \u0627\u0644\u0645\u0627\u0644\u064A\u0629 \u0627\u0644\u062A\u064A \u062A\u0633\u0645\u062D \u0628\u0647\u0627 \u0635\u0644\u0627\u062D\u064A\u0627\u062A\u0643\u060C \u0648\u0639\u0644\u0649 \u0627\u0644\u0634\u0627\u0634\u0629 \u0627\u0644\u0635\u063A\u064A\u0631\u0629 \u062A\u062A\u062D\u0648\u0644 \u0625\u0644\u0649 \u0635\u0641 \u0645\u0646 \u0627\u0644\u0631\u0648\u0627\u0628\u0637."
              },
              tabs: {
                term: "\u0645\u0630\u0643\u0631\u0627\u062A \u0645\u0635\u0627\u0631\u064A\u0641\u064A / \u0628\u0627\u0646\u062A\u0638\u0627\u0631 \u0627\u0644\u0645\u0648\u0627\u0641\u0642\u0629",
                text: "\u062A\u0628\u0648\u064A\u0628\u0627\u0646: \u0645\u0635\u0627\u0631\u064A\u0641\u0643 \u0627\u0644\u062E\u0627\u0635\u0629\u060C \u0648\u0647\u0630\u0647 \u0627\u0644\u0642\u0627\u0626\u0645\u0629 \xAB\u0628\u0627\u0646\u062A\u0638\u0627\u0631 \u0627\u0644\u0645\u0648\u0627\u0641\u0642\u0629\xBB."
              },
              hint: {
                term: "\u0645\u0630\u0643\u0631\u0627\u062A \u0627\u0644\u0645\u0635\u0627\u0631\u064A\u0641 \u0627\u0644\u0645\u0637\u0644\u0648\u0628 \u0645\u0639\u0627\u0644\u062C\u062A\u0647\u0627",
                text: "\u0627\u0644\u0639\u0646\u0648\u0627\u0646\u060C \u0648\u062A\u062D\u062A\u0647 \u062A\u0630\u0643\u064A\u0631: \u0648\u0627\u0641\u0642 \u0639\u0644\u0649 \u0645\u0630\u0643\u0631\u0627\u062A \u0627\u0644\u0645\u0635\u0627\u0631\u064A\u0641 \u0627\u0644\u0645\u0639\u0644\u0651\u0642\u0629 \u0623\u0648 \u0627\u0631\u0641\u0636\u0647\u0627\u060C \u062B\u0645 \u0639\u0644\u0651\u0645\u0647\u0627 \u0639\u0644\u0649 \u0623\u0646\u0647\u0627 \u0645\u0639\u0648\u064E\u0651\u0636\u0629 \u0628\u0639\u062F \u0625\u062C\u0631\u0627\u0621 \u0627\u0644\u062F\u0641\u0639."
              },
              scope: {
                term: "\u062A\u0634\u0627\u0647\u062F \u0645\u0630\u0643\u0631\u0627\u062A \u0645\u0635\u0627\u0631\u064A\u0641 \u0645\u0634\u0627\u0631\u064A\u0639\u0643.",
                text: "\u0631\u0633\u0627\u0644\u0629 \u0645\u0639\u0644\u0648\u0645\u0627\u062A \u0644\u0645\u062F\u064A\u0631\u064A \u0627\u0644\u0645\u0634\u0627\u0631\u064A\u0639: \u0644\u0627 \u064A\u0631\u0648\u0646 \u0625\u0644\u0627 \u0645\u0630\u0643\u0631\u0627\u062A \u0645\u0634\u0627\u0631\u064A\u0639\u0647\u0645."
              }
            }
          },
          list: {
            title: "\u0642\u0627\u0626\u0645\u0629 \u0645\u0630\u0643\u0631\u0627\u062A \u0627\u0644\u0645\u0635\u0627\u0631\u064A\u0641",
            items: {
              status: {
                term: "\u0627\u0644\u062D\u0627\u0644\u0629",
                text: "\u062A\u064F\u0641\u062A\u062D \u0627\u0644\u0642\u0627\u0626\u0645\u0629 \u0639\u0644\u0649 \u0627\u0644\u0645\u0630\u0643\u0631\u0627\u062A \xAB\u0642\u064A\u062F \u0627\u0644\u0627\u0646\u062A\u0638\u0627\u0631\xBB\u061B \u063A\u064A\u0651\u0631 \u0627\u0644\u062D\u0627\u0644\u0629 (\u062A\u0645\u062A \u0627\u0644\u0645\u0648\u0627\u0641\u0642\u0629 \u0623\u0648 \u0645\u0631\u0641\u0648\u0636\u0629 \u0623\u0648 \u062A\u0645 \u0627\u0644\u062A\u0639\u0648\u064A\u0636) \u0623\u0648 \u0627\u062E\u062A\u0631 \xAB\u0643\u0644 \u0627\u0644\u062D\u0627\u0644\u0627\u062A\xBB."
              },
              card: {
                term: "\u0645\u0630\u0643\u0631\u0629 \u0645\u0635\u0627\u0631\u064A\u0641",
                text: "\u062A\u0639\u0631\u0636 \u0643\u0644 \u0628\u0637\u0627\u0642\u0629 \u0627\u0644\u0645\u0648\u0636\u0648\u0639 \u0648\u0627\u0644\u062D\u0627\u0644\u0629 \u0648\u0627\u0644\u0635\u0646\u0641 \u0648\u0627\u0644\u062A\u0627\u0631\u064A\u062E \u0648\u0627\u0644\u0645\u0634\u0631\u0648\u0639 \u0648\xAB\u0635\u0631\u0651\u062D \u0628\u0647\u0627 \u2026\xBB \u0648\u0627\u0644\u0645\u062C\u0645\u0648\u0639 \u0628\u0627\u062D\u062A\u0633\u0627\u0628 \u0627\u0644\u0623\u062F\u0627\u0621\u0627\u062A \u0648\u0648\u062B\u064A\u0642\u0629 \u0627\u0644\u0625\u062B\u0628\u0627\u062A (\xAB\u0639\u0631\u0636 \u0648\u062B\u064A\u0642\u0629 \u0627\u0644\u0625\u062B\u0628\u0627\u062A\xBB)."
              },
              empty: {
                term: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0645\u0630\u0643\u0631\u0627\u062A \u0645\u0635\u0627\u0631\u064A\u0641 \u0644\u0644\u0645\u0639\u0627\u0644\u062C\u0629",
                text: "\u0631\u0633\u0627\u0644\u0629 \u0627\u0644\u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u0641\u0627\u0631\u063A\u0629: \u0633\u062A\u0638\u0647\u0631 \u0647\u0646\u0627 \u0645\u0630\u0643\u0631\u0627\u062A \u0627\u0644\u0645\u0635\u0627\u0631\u064A\u0641 \u0627\u0644\u062A\u064A \u064A\u0635\u0631\u0651\u062D \u0628\u0647\u0627 \u0641\u0631\u064A\u0642\u0643. \u0648\u0644\u062D\u0627\u0644\u0629 \u0623\u062E\u0631\u0649 \u062F\u0648\u0646 \u0646\u062A\u064A\u062C\u0629: \xAB\u0639\u0631\u0636 \u0643\u0644 \u0627\u0644\u062D\u0627\u0644\u0627\u062A\xBB."
              },
              loadMore: {
                term: "\u0639\u0631\u0636 \u0627\u0644\u0645\u0632\u064A\u062F \u0645\u0646 \u0645\u0630\u0643\u0631\u0627\u062A \u0627\u0644\u0645\u0635\u0627\u0631\u064A\u0641",
                text: "\u062A\u062D\u062A \u0627\u0644\u0642\u0627\u0626\u0645\u0629: \u064A\u062D\u0645\u0651\u0644 \u0627\u0644\u0628\u0627\u0642\u064A. \u0648\u0639\u0646\u062F \u0627\u0644\u062E\u0637\u0623 \u062A\u0639\u064A\u062F \xAB\u0625\u0639\u0627\u062F\u0629 \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629\xBB \u0627\u0644\u062A\u062D\u0645\u064A\u0644."
              }
            }
          },
          actions: {
            title: "\u0627\u0644\u0628\u062A\u0651 \u0641\u064A \u0645\u0630\u0643\u0631\u0629",
            items: {
              approve: {
                term: "\u0627\u0644\u0645\u0648\u0627\u0641\u0642\u0629",
                text: "\u0641\u064A \u0645\u0630\u0643\u0631\u0629 \u0642\u064A\u062F \u0627\u0644\u0627\u0646\u062A\u0638\u0627\u0631: \u064A\u0642\u0628\u0644 \u0627\u0644\u0645\u0635\u0631\u0648\u0641. \u0645\u062E\u0635\u0635 \u0644\u0645\u0646 \u064A\u062D\u0642 \u0644\u0647\u0645 \u0627\u0644\u0645\u0648\u0627\u0641\u0642\u0629."
              },
              reject: {
                term: "\u0627\u0644\u0631\u0641\u0636",
                text: "\u0641\u064A \u0645\u0630\u0643\u0631\u0629 \u0642\u064A\u062F \u0627\u0644\u0627\u0646\u062A\u0638\u0627\u0631: \u064A\u0641\u062A\u062D \u0646\u0627\u0641\u0630\u0629 \u0627\u0644\u0631\u0641\u0636 \u0627\u0644\u062A\u064A \u064A\u0643\u0648\u0646 \u0641\u064A\u0647\u0627 \u0627\u0644\u0633\u0628\u0628 \u0625\u062C\u0628\u0627\u0631\u064A\u064B\u0627."
              },
              reimbursed: {
                term: "\u062A\u0639\u0644\u064A\u0645\u0647\u0627 \u0643\u0645\u0639\u0648\u064E\u0651\u0636\u0629",
                text: "\u0641\u064A \u0645\u0630\u0643\u0631\u0629 \u062A\u0645\u062A \u0627\u0644\u0645\u0648\u0627\u0641\u0642\u0629 \u0639\u0644\u064A\u0647\u0627: \u064A\u0624\u0643\u062F \u0623\u0646 \u0627\u0644\u0645\u0635\u0631\u0648\u0641 \u0639\u064F\u0648\u0650\u0651\u0636. \u0645\u062E\u0635\u0635 \u0644\u0645\u0633\u0624\u0648\u0644\u064A \u0627\u0644\u0645\u0648\u0627\u0641\u0642\u0629 \u0639\u0644\u0649 \u0645\u0633\u062A\u0648\u0649 \u0627\u0644\u0645\u0643\u062A\u0628 \u0643\u0644\u0647 (\u062F\u0648\u0646 \u0645\u062F\u064A\u0631\u064A \u0627\u0644\u0645\u0634\u0627\u0631\u064A\u0639)."
              },
              own: {
                term: "\u0644\u0627 \u064A\u0645\u0643\u0646\u0643 \u0627\u0644\u0628\u062A\u0651 \u0641\u064A \u0645\u0630\u0643\u0631\u0629 \u0645\u0635\u0627\u0631\u064A\u0641\u0643 \u0627\u0644\u062E\u0627\u0635\u0629\u2026",
                text: "\u0641\u064A \u0645\u0630\u0643\u0631\u062A\u0643 \u0627\u0644\u062E\u0627\u0635\u0629 \u0642\u064A\u062F \u0627\u0644\u0627\u0646\u062A\u0638\u0627\u0631 \u0644\u0627 \u064A\u064F\u0639\u0631\u0636 \u0623\u064A \u0632\u0631: \u064A\u062C\u0628 \u0623\u0646 \u064A\u062A\u0648\u0644\u0649 \u0630\u0644\u0643 \u0645\u0633\u0624\u0648\u0644 \u0645\u0648\u0627\u0641\u0642\u0629 \u0622\u062E\u0631."
              },
              stale: {
                term: "\u062A\u063A\u064A\u0651\u0631\u062A \u0645\u0630\u0643\u0631\u0629 \u0627\u0644\u0645\u0635\u0627\u0631\u064A\u0641 \u0647\u0630\u0647",
                text: "\u0625\u0630\u0627 \u0639\u0627\u0644\u062C\u0647\u0627 \u0634\u062E\u0635 \u0622\u062E\u0631 \u0645\u0646 \u0642\u0628\u0644 \u062A\u064F\u062D\u062F\u064E\u0651\u062B \u0627\u0644\u0642\u0627\u0626\u0645\u0629 \u0648\u062A\u062F\u0639\u0648\u0643 \u0647\u0630\u0647 \u0627\u0644\u0631\u0633\u0627\u0644\u0629 \u0625\u0644\u0649 \u0627\u0644\u062A\u062D\u0642\u0642 \u0642\u0628\u0644 \u0625\u0639\u0627\u062F\u0629 \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629."
              }
            }
          },
          rejectDialog: {
            title: "\u0631\u0641\u0636 \u0645\u0630\u0643\u0631\u0629 \u0627\u0644\u0645\u0635\u0627\u0631\u064A\u0641",
            items: {
              body: {
                term: "\u0631\u0641\u0636 \u0645\u0630\u0643\u0631\u0629 \u0627\u0644\u0645\u0635\u0627\u0631\u064A\u0641 \xAB\u2026\xBB",
                text: "\u064A\u064F\u0631\u0633\u0644 \u0627\u0644\u0633\u0628\u0628 \u0625\u0644\u0649 \u0645\u0646 \u0635\u0631\u0651\u062D \u0628\u0627\u0644\u0645\u0635\u0631\u0648\u0641 \u0627\u0644\u0630\u064A \u064A\u0645\u0643\u0646\u0647 \u062A\u0635\u062D\u064A\u062D \u0627\u0644\u0645\u0630\u0643\u0631\u0629 \u0648\u0625\u0639\u0627\u062F\u0629 \u0625\u0631\u0633\u0627\u0644\u0647\u0627."
              },
              reason: {
                term: "\u0633\u0628\u0628 \u0627\u0644\u0631\u0641\u0636",
                text: "\u0625\u062C\u0628\u0627\u0631\u064A: 500 \u062D\u0631\u0641 \u0639\u0644\u0649 \u0627\u0644\u0623\u0643\u062B\u0631."
              },
              confirm: {
                term: "\u0631\u0641\u0636 \u0645\u0630\u0643\u0631\u0629 \u0627\u0644\u0645\u0635\u0627\u0631\u064A\u0641",
                text: "\u064A\u0624\u0643\u062F \u0627\u0644\u0631\u0641\u0636 \u0648\u064A\u064F\u0639\u0644\u0645 \u0635\u0627\u062D\u0628 \u0627\u0644\u0645\u0630\u0643\u0631\u0629. \xAB\u0625\u0644\u063A\u0627\u0621\xBB \u064A\u063A\u0644\u0642 \u0627\u0644\u0646\u0627\u0641\u0630\u0629."
              }
            }
          },
          reimburseDialog: {
            title: "\u062A\u0639\u0644\u064A\u0645\u0647\u0627 \u0643\u0645\u0639\u0648\u064E\u0651\u0636\u0629",
            items: {
              body: {
                term: "\u062A\u0639\u0644\u064A\u0645 \xAB\u2026\xBB \u0643\u0645\u0639\u0648\u064E\u0651\u0636\u0629",
                text: "\u062A\u0633\u0623\u0644 \u0647\u0644 \u0639\u064F\u0648\u0650\u0651\u0636 \u0627\u0644\u0634\u062E\u0635 \u0641\u0639\u0644\u064B\u0627 \u0628\u0627\u0644\u0645\u0628\u0644\u063A: \u0644\u0627 \u064A\u0645\u0643\u0646 \u0627\u0644\u062A\u0631\u0627\u062C\u0639 \u0639\u0646 \u0647\u0630\u0627 \u0627\u0644\u0625\u062C\u0631\u0627\u0621."
              },
              confirm: {
                term: "\u062A\u0623\u0643\u064A\u062F \u0627\u0644\u062A\u0639\u0648\u064A\u0636",
                text: "\u064A\u0635\u0627\u062F\u0642 \u0639\u0644\u0649 \u0627\u0644\u062A\u0639\u0648\u064A\u0636. \xAB\u0625\u0644\u063A\u0627\u0621\xBB \u064A\u063A\u0644\u0642 \u0627\u0644\u0646\u0627\u0641\u0630\u0629."
              }
            }
          }
        }
      },
      dashboard: {
        title: "\u0644\u0648\u062D\u0629 \u0627\u0644\u0642\u064A\u0627\u062F\u0629",
        intro: "\u0627\u0644\u0623\u0631\u0642\u0627\u0645 \u0627\u0644\u0645\u0627\u0644\u064A\u0629 \u0627\u0644\u0623\u0633\u0627\u0633\u064A\u0629 \u0644\u0645\u0643\u062A\u0628\u0643: \u0645\u0627 \u0641\u064F\u0648\u062A\u0631 \u0648\u0645\u0627 \u0642\u064F\u0628\u0636 \u0648\u0645\u0627 \u0644\u0627 \u064A\u0632\u0627\u0644 \u0627\u0644\u062D\u0631\u0641\u0627\u0621 \u0645\u062F\u064A\u0646\u064A\u0646 \u0628\u0647 \u0648\u0627\u0644\u062E\u0635\u0648\u0645\u0627\u062A \u0627\u0644\u0645\u0637\u0644\u0648\u0628 \u0627\u0633\u062A\u0631\u062C\u0627\u0639\u0647\u0627 \u0648\u0627\u0644\u0623\u062F\u0627\u0621 \u0639\u0644\u0649 \u0627\u0644\u0642\u064A\u0645\u0629 \u0627\u0644\u0645\u0636\u0627\u0641\u0629 \u0644\u0644\u0634\u0647\u0631\u060C \u0645\u0639 \u0631\u0633\u0645 \u0628\u064A\u0627\u0646\u064A \u0639\u0644\u0649 12 \u0634\u0647\u0631\u064B\u0627. \u064A\u0633\u062A\u0639\u0645\u0644\u0647\u0627 \u0645\u0646 \u064A\u062F\u064A\u0631\u0648\u0646 \u0627\u0644\u0633\u064A\u0648\u0644\u0629.",
        sections: {
          header: {
            title: "\u0631\u0623\u0633 \u0627\u0644\u0635\u0641\u062D\u0629",
            items: {
              subNav: {
                term: "\u0627\u0644\u0645\u0627\u0644\u064A\u0629",
                text: "\u062A\u0639\u0631\u0636 \u0627\u0644\u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u064A\u0645\u0646\u0649 \u0623\u0642\u0633\u0627\u0645 \u0627\u0644\u0645\u0627\u0644\u064A\u0629 \u0627\u0644\u062A\u064A \u062A\u0633\u0645\u062D \u0628\u0647\u0627 \u0635\u0644\u0627\u062D\u064A\u0627\u062A\u0643\u060C \u0648\u0639\u0644\u0649 \u0627\u0644\u0634\u0627\u0634\u0629 \u0627\u0644\u0635\u063A\u064A\u0631\u0629 \u062A\u062A\u062D\u0648\u0644 \u0625\u0644\u0649 \u0635\u0641 \u0645\u0646 \u0627\u0644\u0631\u0648\u0627\u0628\u0637."
              },
              asOf: {
                term: "\u0627\u0644\u0648\u0636\u0639\u064A\u0629 \u0625\u0644\u0649 \u063A\u0627\u064A\u0629 \u2026",
                text: "\u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0623\u0631\u0642\u0627\u0645. \u0627\u0644\u0645\u0628\u0627\u0644\u063A \u0628\u0627\u0644\u062F\u064A\u0646\u0627\u0631 \u0627\u0644\u062A\u0648\u0646\u0633\u064A\u061B \u0648\u0644\u0627 \u062A\u064F\u062D\u062A\u0633\u0628 \u0627\u0644\u0641\u0648\u0627\u062A\u064A\u0631 \u0628\u0627\u0644\u0639\u0645\u0644\u0627\u062A \u0627\u0644\u0623\u062C\u0646\u0628\u064A\u0629."
              },
              scope: {
                term: "\u062A\u0634\u0645\u0644 \u0647\u0630\u0647 \u0627\u0644\u0623\u0631\u0642\u0627\u0645 \u0641\u0648\u0627\u062A\u064A\u0631 \u0645\u0634\u0627\u0631\u064A\u0639\u0643 \u0641\u0642\u0637.",
                text: "\u0631\u0633\u0627\u0644\u0629 \u0645\u0639\u0644\u0648\u0645\u0627\u062A \u0644\u0645\u062F\u064A\u0631\u064A \u0627\u0644\u0645\u0634\u0627\u0631\u064A\u0639: \u0644\u0627 \u064A\u0631\u0648\u0646 \u0625\u0644\u0627 \u0645\u0634\u0627\u0631\u064A\u0639\u0647\u0645."
              }
            }
          },
          kpi: {
            title: "\u0627\u0644\u0645\u0624\u0634\u0631\u0627\u062A \u0627\u0644\u0623\u0633\u0627\u0633\u064A\u0629",
            items: {
              monthInvoiced: {
                term: "\u0627\u0644\u0645\u0641\u0648\u062A\u0631 \u0647\u0630\u0627 \u0627\u0644\u0634\u0647\u0631",
                text: "\u0645\u062C\u0645\u0648\u0639 \u0645\u0627 \u0641\u064F\u0648\u062A\u0631 \u0647\u0630\u0627 \u0627\u0644\u0634\u0647\u0631\u060C \u0648\u062A\u062D\u062A\u0647 \u0627\u0644\u0645\u0628\u0644\u063A \u062F\u0648\u0646 \u0627\u0644\u0623\u062F\u0627\u0621\u0627\u062A \u0648\u0627\u0644\u0623\u062F\u0627\u0621 \u0639\u0644\u0649 \u0627\u0644\u0642\u064A\u0645\u0629 \u0627\u0644\u0645\u0636\u0627\u0641\u0629."
              },
              monthCollected: {
                term: "\u0627\u0644\u0645\u0642\u0628\u0648\u0636 \u0647\u0630\u0627 \u0627\u0644\u0634\u0647\u0631",
                text: "\u0627\u0644\u0645\u0628\u0627\u0644\u063A \u0627\u0644\u0645\u0633\u062A\u0644\u0645\u0629 \u0647\u0630\u0627 \u0627\u0644\u0634\u0647\u0631 \u0645\u0639 \u0627\u0644\u0645\u0628\u0627\u0644\u063A \u0627\u0644\u0645\u062E\u0635\u0648\u0645\u0629 \u0645\u0646 \u0642\u0628\u0644 \u062D\u0631\u0641\u0627\u0626\u0643."
              },
              yearInvoiced: {
                term: "\u0627\u0644\u0645\u0641\u0648\u062A\u0631 \u0633\u0646\u0629 (\u0627\u0644\u0633\u0646\u0629)",
                text: "\u0645\u062C\u0645\u0648\u0639 \u0645\u0627 \u0641\u064F\u0648\u062A\u0631 \u0645\u0646\u0630 \u0628\u062F\u0627\u064A\u0629 \u0627\u0644\u0633\u0646\u0629 \u0645\u0639 \u0627\u0644\u0645\u0628\u0644\u063A \u062F\u0648\u0646 \u0627\u0644\u0623\u062F\u0627\u0621\u0627\u062A."
              },
              yearCollected: {
                term: "\u0627\u0644\u0645\u0642\u0628\u0648\u0636 \u0633\u0646\u0629 (\u0627\u0644\u0633\u0646\u0629)",
                text: "\u0627\u0644\u0645\u0628\u0627\u0644\u063A \u0627\u0644\u0645\u0633\u062A\u0644\u0645\u0629 \u0645\u0646\u0630 \u0628\u062F\u0627\u064A\u0629 \u0627\u0644\u0633\u0646\u0629 \u0645\u0639 \u0627\u0644\u0645\u0628\u0627\u0644\u063A \u0627\u0644\u0645\u062E\u0635\u0648\u0645\u0629."
              },
              outstanding: {
                term: "\u0627\u0644\u0645\u062A\u0628\u0642\u064A \u0639\u0644\u0649 \u0627\u0644\u062D\u0631\u0641\u0627\u0621",
                text: "\u0645\u0627 \u0644\u0627 \u064A\u0632\u0627\u0644 \u0639\u0644\u0649 \u0627\u0644\u062D\u0631\u0641\u0627\u0621 \u062F\u0641\u0639\u0647 \u0645\u0639 \u0639\u062F\u062F \u0627\u0644\u0641\u0648\u0627\u062A\u064A\u0631 \u0641\u064A \u0627\u0644\u0627\u0646\u062A\u0638\u0627\u0631."
              },
              overdue: {
                term: "\u0645\u0646\u0647 \u0627\u0644\u0645\u062A\u0623\u062E\u0631",
                text: "\u0627\u0644\u062C\u0632\u0621 \u0645\u0646 \u0627\u0644\u0645\u062A\u0628\u0642\u064A \u0627\u0644\u0630\u064A \u062A\u062C\u0627\u0648\u0632 \u062A\u0627\u0631\u064A\u062E \u0627\u0633\u062A\u062D\u0642\u0627\u0642\u0647. \u0648\u062A\u0642\u0648\u0644\u0647 \u0627\u0644\u0634\u0627\u0631\u0629 \xAB\u064A\u062A\u0637\u0644\u0628 \u062A\u0630\u0643\u064A\u0631\u064B\u0627\xBB (\u0623\u0648 \xAB\u0645\u062D\u064A\u0651\u0646\xBB \u0625\u0630\u0627 \u0644\u0645 \u064A\u062A\u0623\u062E\u0631 \u0634\u064A\u0621) \u0628\u0627\u0644\u062D\u0631\u0648\u0641."
              },
              withholdings: {
                term: "\u0627\u0644\u062E\u0635\u0648\u0645\u0627\u062A \u0627\u0644\u0645\u0637\u0644\u0648\u0628 \u0627\u0633\u062A\u0631\u062C\u0627\u0639\u0647\u0627",
                text: "\u0645\u0628\u0644\u063A \u0627\u0644\u0627\u0642\u062A\u0637\u0627\u0639\u0627\u062A \u0627\u0644\u062A\u064A \u064A\u0646\u0642\u0635\u0647\u0627 \u0634\u0647\u0627\u062F\u0629 \u062E\u0635\u0645\u060C \u0645\u0639 \u0639\u062F\u062F \u0627\u0644\u062F\u0641\u0639\u0627\u062A \u0627\u0644\u0645\u0639\u0646\u064A\u0629."
              },
              vat: {
                term: "\u0627\u0644\u0623\u062F\u0627\u0621 \u0627\u0644\u0645\u0641\u0648\u062A\u0631 \u0647\u0630\u0627 \u0627\u0644\u0634\u0647\u0631",
                text: "\u0627\u0644\u0623\u062F\u0627\u0621 \u0639\u0644\u0649 \u0627\u0644\u0642\u064A\u0645\u0629 \u0627\u0644\u0645\u0636\u0627\u0641\u0629 \u0644\u0644\u0641\u0648\u0627\u062A\u064A\u0631 \u0627\u0644\u0635\u0627\u062F\u0631\u0629 \u062E\u0644\u0627\u0644 \u0627\u0644\u0634\u0647\u0631."
              }
            }
          },
          chart: {
            title: "\u0627\u0644\u0645\u0641\u0648\u062A\u0631 \u0648\u0627\u0644\u0645\u0642\u0628\u0648\u0636 \u0639\u0644\u0649 \u0645\u062F\u0649 12 \u0634\u0647\u0631\u064B\u0627",
            items: {
              bars: {
                term: "\u0627\u0644\u0645\u0641\u0648\u062A\u0631 (\u0628\u0627\u062D\u062A\u0633\u0627\u0628 \u0627\u0644\u0623\u062F\u0627\u0621\u0627\u062A) / \u0627\u0644\u0645\u0642\u0628\u0648\u0636",
                text: "\u0631\u0633\u0645 \u0628\u064A\u0627\u0646\u064A \u0628\u0627\u0644\u0623\u0639\u0645\u062F\u0629: \u0644\u0643\u0644 \u0634\u0647\u0631 \u0639\u0645\u0648\u062F \u0644\u0644\u0645\u0628\u0644\u063A \u0627\u0644\u0645\u0641\u0648\u062A\u0631 \u0628\u0627\u062D\u062A\u0633\u0627\u0628 \u0643\u0644 \u0627\u0644\u0623\u062F\u0627\u0621\u0627\u062A \u0648\u0639\u0645\u0648\u062F \u0644\u0644\u0645\u0628\u0627\u0644\u063A \u0627\u0644\u0645\u0642\u0628\u0648\u0636\u0629."
              },
              tooltip: {
                term: "\u0646\u0627\u0641\u0630\u0629 \u0627\u0644\u062A\u0644\u0645\u064A\u062D",
                text: "\u0639\u0646\u062F \u062A\u0645\u0631\u064A\u0631 \u0627\u0644\u0641\u0623\u0631\u0629 \u0639\u0644\u0649 \u0634\u0647\u0631 \u062A\u0631\u0649 \u0627\u0644\u0645\u0628\u0627\u0644\u063A \u0627\u0644\u062F\u0642\u064A\u0642\u0629."
              },
              rtl: {
                term: "\u0627\u062A\u062C\u0627\u0647 \u0627\u0644\u0642\u0631\u0627\u0621\u0629",
                text: "\u0641\u064A \u0627\u0644\u0639\u0631\u0628\u064A\u0629 \u064A\u0643\u0648\u0646 \u0627\u0644\u0631\u0633\u0645 \u0645\u0639\u0643\u0648\u0633\u064B\u0627: \u0627\u0644\u0634\u0647\u0631 \u0627\u0644\u0623\u0642\u062F\u0645 \u0639\u0644\u0649 \u0627\u0644\u064A\u0645\u064A\u0646."
              }
            }
          },
          table: {
            title: "\u0628\u064A\u0627\u0646\u0627\u062A \u0627\u0644\u0631\u0633\u0645 \u0627\u0644\u0628\u064A\u0627\u0646\u064A",
            items: {
              toggle: {
                term: "\u0639\u0631\u0636 \u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A / \u0625\u062E\u0641\u0627\u0621 \u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A",
                text: "\u064A\u064F\u0638\u0647\u0631 \u0623\u0648 \u064A\u062E\u0641\u064A \u0627\u0644\u062C\u062F\u0648\u0644 \u0627\u0644\u0630\u064A \u064A\u0639\u0637\u064A \u0627\u0644\u0623\u0631\u0642\u0627\u0645 \u0627\u0644\u062F\u0642\u064A\u0642\u0629 \u0644\u0644\u0631\u0633\u0645 \u0627\u0644\u0628\u064A\u0627\u0646\u064A."
              },
              month: {
                term: "\u0627\u0644\u0634\u0647\u0631",
                text: "\u0627\u0644\u0634\u0647\u0631 \u0627\u0644\u0645\u0639\u0646\u064A."
              },
              invoiced: {
                term: "\u0627\u0644\u0645\u0641\u0648\u062A\u0631 (\u0628\u0627\u062D\u062A\u0633\u0627\u0628 \u0627\u0644\u0623\u062F\u0627\u0621\u0627\u062A)",
                text: "\u0627\u0644\u0645\u0628\u0644\u063A \u0627\u0644\u0645\u0641\u0648\u062A\u0631 \u0641\u064A \u0630\u0644\u0643 \u0627\u0644\u0634\u0647\u0631 \u0628\u0627\u062D\u062A\u0633\u0627\u0628 \u0643\u0644 \u0627\u0644\u0623\u062F\u0627\u0621\u0627\u062A."
              },
              collected: {
                term: "\u0627\u0644\u0645\u0642\u0628\u0648\u0636",
                text: "\u0627\u0644\u0645\u0628\u0627\u0644\u063A \u0627\u0644\u0645\u0633\u062A\u0644\u0645\u0629 \u0641\u064A \u0630\u0644\u0643 \u0627\u0644\u0634\u0647\u0631."
              },
              total: {
                term: "\u0627\u0644\u0645\u062C\u0645\u0648\u0639 \u0639\u0644\u0649 12 \u0634\u0647\u0631\u064B\u0627",
                text: "\u064A\u062C\u0645\u0639 \u0627\u0644\u0633\u0637\u0631 \u0627\u0644\u0623\u062E\u064A\u0631 \u0627\u0644\u0623\u0634\u0647\u0631 \u0627\u0644\u0627\u062B\u0646\u064A \u0639\u0634\u0631."
              }
            }
          },
          errors: {
            title: "\u0627\u0644\u0623\u062E\u0637\u0627\u0621 \u0648\u0627\u0644\u062A\u062D\u0645\u064A\u0644",
            items: {
              loadError: {
                term: "\u062A\u0639\u0630\u0651\u0631 \u062A\u062D\u0645\u064A\u0644 \u0644\u0648\u062D\u0629 \u0627\u0644\u0642\u064A\u0627\u062F\u0629",
                text: "\u0631\u0633\u0627\u0644\u0629 \u062E\u0637\u0623 \u0639\u0646\u062F \u0648\u062C\u0648\u062F \u0645\u0634\u0643\u0644 \u0641\u064A \u0627\u0644\u0627\u062A\u0635\u0627\u0644\u061B \u0648\xAB\u0625\u0639\u0627\u062F\u0629 \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629\xBB \u062A\u0639\u064A\u062F \u0627\u0644\u062A\u062D\u0645\u064A\u0644."
              },
              loading: {
                term: "\u0627\u0644\u062A\u062D\u0645\u064A\u0644",
                text: "\u0623\u062B\u0646\u0627\u0621 \u0627\u062D\u062A\u0633\u0627\u0628 \u0627\u0644\u0623\u0631\u0642\u0627\u0645 \u062A\u062D\u0644 \u0623\u0634\u0631\u0637\u0629 \u0631\u0645\u0627\u062F\u064A\u0629 \u0645\u062D\u0644\u0647\u0627."
              }
            }
          }
        }
      },
      einvoicing: {
        title: "\u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629 \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A\u0629",
        intro: "\u0625\u0639\u062F\u0627\u062F \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629 \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A\u0629 \u0644\u0645\u0643\u062A\u0628\u0643: \u0646\u0645\u0637 \u0625\u0631\u0633\u0627\u0644 \u0627\u0644\u0641\u0648\u0627\u062A\u064A\u0631 \u0625\u0644\u0649 \u2066TTN\u2069 (\u2066El Fatoora\u2069) \u0648\u0627\u0644\u0634\u0647\u0627\u062F\u0627\u062A \u0627\u0644\u0645\u0633\u062A\u0639\u0645\u0644\u0629 \u0644\u062A\u0648\u0642\u064A\u0639\u0647\u0627. \u0648\u0647\u0648 \u0645\u062E\u0635\u0635 \u0644\u0645\u0646 \u064A\u062F\u064A\u0631\u0648\u0646 \u0627\u0644\u0641\u0648\u062A\u0631\u0629 \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A\u0629.",
        sections: {
          header: {
            title: "\u0631\u0623\u0633 \u0627\u0644\u0635\u0641\u062D\u0629",
            items: {
              subNav: {
                term: "\u0627\u0644\u0645\u0627\u0644\u064A\u0629",
                text: "\u062A\u0639\u0631\u0636 \u0627\u0644\u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u064A\u0645\u0646\u0649 \u0623\u0642\u0633\u0627\u0645 \u0627\u0644\u0645\u0627\u0644\u064A\u0629 \u0627\u0644\u062A\u064A \u062A\u0633\u0645\u062D \u0628\u0647\u0627 \u0635\u0644\u0627\u062D\u064A\u0627\u062A\u0643\u060C \u0648\u0639\u0644\u0649 \u0627\u0644\u0634\u0627\u0634\u0629 \u0627\u0644\u0635\u063A\u064A\u0631\u0629 \u062A\u062A\u062D\u0648\u0644 \u0625\u0644\u0649 \u0635\u0641 \u0645\u0646 \u0627\u0644\u0631\u0648\u0627\u0628\u0637."
              },
              add: {
                term: "\u0625\u0636\u0627\u0641\u0629 \u0634\u0647\u0627\u062F\u0629",
                text: "\u064A\u0641\u062A\u062D \u0646\u0627\u0641\u0630\u0629 \u0625\u0636\u0627\u0641\u0629 \u0634\u0647\u0627\u062F\u0629 \u062A\u0648\u0642\u064A\u0639."
              }
            }
          },
          mode: {
            title: "\u0646\u0645\u0637 \u0627\u0644\u0641\u0648\u062A\u0631\u0629 \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A\u0629",
            items: {
              mode: {
                term: "\u0627\u0644\u0646\u0645\u0637",
                text: "\u0627\u062E\u062A\u0631 \u0645\u0627 \u0625\u0630\u0627 \u0643\u0627\u0646\u062A \u0627\u0644\u0641\u0648\u0627\u062A\u064A\u0631 \u0627\u0644\u0635\u0627\u062F\u0631\u0629 \u0639\u0646 \u0645\u0643\u062A\u0628\u0643\u0645 \u062A\u064F\u0631\u0633\u064E\u0644 \u0625\u0644\u0649 \u2066TTN\u2069: \u0625\u062C\u0628\u0627\u0631\u064A \u0623\u0648 \u0627\u062E\u062A\u064A\u0627\u0631\u064A \u0623\u0648 \u0645\u0639\u0637\u0651\u0644. \u0648\u062A\u0648\u0635\u0641 \u0627\u0644\u062E\u064A\u0627\u0631\u0627\u062A \u0627\u0644\u062B\u0644\u0627\u062B\u0629 \u062A\u062D\u062A \u0627\u0644\u0642\u0627\u0626\u0645\u0629."
              },
              required: {
                term: "\u0625\u062C\u0628\u0627\u0631\u064A",
                text: "\u062A\u064F\u0648\u0642\u064E\u0651\u0639 \u0643\u0644 \u0641\u0627\u062A\u0648\u0631\u0629 \u0635\u0627\u062F\u0631\u0629 \u062B\u0645 \u062A\u064F\u0631\u0633\u064E\u0644 \u0625\u0644\u0649 \u2066TTN\u2069. \u0627\u062E\u062A\u0631 \u0647\u0630\u0627 \u0627\u0644\u0646\u0645\u0637 \u0625\u0630\u0627 \u0643\u0627\u0646 \u0627\u0644\u0642\u0627\u0646\u0648\u0646 \u0623\u0648 \u062D\u0631\u0641\u0627\u0624\u0643 \u064A\u0634\u062A\u0631\u0637\u0648\u0646 \u0630\u0644\u0643."
              },
              optional: {
                term: "\u0627\u062E\u062A\u064A\u0627\u0631\u064A",
                text: "\u062A\u064F\u0631\u0633\u064E\u0644 \u0627\u0644\u0641\u0648\u0627\u062A\u064A\u0631 \u0625\u0644\u0649 \u2066TTN\u2069 \u0639\u0646\u062F\u0645\u0627 \u064A\u0645\u0644\u0643 \u0645\u0643\u062A\u0628\u0643\u0645 \u0634\u0647\u0627\u062F\u0629 \u062A\u0648\u0642\u064A\u0639 \u0646\u0634\u0637\u0629\u060C \u0648\u0628\u062F\u0648\u0646\u0647\u0627 \u062A\u064F\u0635\u062F\u064E\u0631 \u0627\u0644\u0641\u0648\u0627\u062A\u064A\u0631 \u062F\u0648\u0646 \u0625\u0631\u0633\u0627\u0644."
              },
              disabled: {
                term: "\u0645\u0639\u0637\u0651\u0644",
                text: "\u0644\u0627 \u062A\u064F\u0631\u0633\u064E\u0644 \u0623\u064A \u0641\u0627\u062A\u0648\u0631\u0629 \u0625\u0644\u0649 \u2066TTN\u2069\u061B \u0648\u062A\u062D\u062A\u0641\u0638 \u0627\u0644\u0641\u0648\u0627\u062A\u064A\u0631 \u0627\u0644\u0645\u0631\u0633\u064E\u0644\u0629 \u0633\u0627\u0628\u0642\u064B\u0627 \u0628\u062D\u0627\u0644\u062A\u0647\u0627."
              },
              save: {
                term: "\u062D\u0641\u0638 \u0627\u0644\u0646\u0645\u0637",
                text: "\u064A\u062D\u0641\u0638 \u0627\u0644\u0627\u062E\u062A\u064A\u0627\u0631\u061B \u0648\u064A\u064F\u0637\u0644\u0628 \u062A\u0623\u0643\u064A\u062F \u0627\u0644\u0647\u0648\u064A\u0629. \u064A\u0628\u0642\u0649 \u0627\u0644\u0632\u0631 \u0645\u0639\u0637\u0651\u0644\u064B\u0627 \u0645\u0627 \u062F\u0645\u062A\u0645 \u0644\u0645 \u062A\u063A\u064A\u0651\u0631\u0648\u0627 \u0634\u064A\u0626\u064B\u0627."
              }
            }
          },
          credentials: {
            title: "\u0634\u0647\u0627\u062F\u0627\u062A \u0627\u0644\u062A\u0648\u0642\u064A\u0639",
            items: {
              card: {
                term: "\u0634\u0647\u0627\u062F\u0629",
                text: "\u0628\u0637\u0627\u0642\u0629 \u0644\u0643\u0644 \u0634\u0647\u0627\u062F\u0629: \u0635\u0627\u062D\u0628\u0647\u0627 \u0648\u062D\u0627\u0644\u062A\u0647\u0627 \u062B\u0645 \u0627\u0644\u0646\u0648\u0639 \u0648\u0627\u0644\u062A\u0633\u0645\u064A\u0629 \u0648\u0627\u0644\u0635\u0644\u0627\u062D\u064A\u0629 (\u0645\u0646 \u2026 \u0625\u0644\u0649 \u2026) \u0648\u0627\u0644\u062C\u0647\u0629 \u0627\u0644\u0645\u064F\u0635\u062F\u0650\u0631\u0629 \u0648\u0627\u0644\u0628\u0635\u0645\u0629 \u2066SHA-256\u2069 \u0648\xAB\u0623\u064F\u0636\u064A\u0641\u062A\xBB (\u0645\u0646 \u0648\u0645\u062A\u0649). \u0644\u0627 \u064A\u064F\u0639\u0631\u0636 \u0627\u0644\u0645\u0641\u062A\u0627\u062D \u0627\u0644\u062E\u0627\u0635 \u0623\u0628\u062F\u064B\u0627."
              },
              states: {
                term: "\u0646\u0634\u0637\u0629 / \u0645\u0646\u062A\u0647\u064A\u0629 \u0627\u0644\u0635\u0644\u0627\u062D\u064A\u0629 / \u0645\u0633\u062A\u0628\u062F\u064E\u0644\u0629 / \u0645\u064F\u0644\u063A\u0627\u0629",
                text: "\u062D\u0627\u0644\u0629 \u0627\u0644\u0634\u0647\u0627\u062F\u0629. \u0644\u0627 \u062A\u064F\u0633\u062A\u0639\u0645\u0644 \u0644\u0644\u062A\u0648\u0642\u064A\u0639 \u0625\u0644\u0627 \u0627\u0644\u0634\u0647\u0627\u062F\u0629 \u0627\u0644\u0646\u0634\u0637\u0629\u060C \u0648\u062A\u064F\u0639\u0631\u0636 \u0627\u0644\u0646\u0634\u0637\u0629 \u0623\u0648\u0644\u064B\u0627."
              },
              expiring: {
                term: "\u062A\u0646\u062A\u0647\u064A \u0642\u0631\u064A\u0628\u064B\u0627",
                text: "\u0634\u0627\u0631\u0629 \u062A\u062D\u0630\u064A\u0631 \u0639\u0644\u0649 \u0627\u0644\u0634\u0647\u0627\u062F\u0629 \u0627\u0644\u0646\u0634\u0637\u0629 \u0627\u0644\u062A\u064A \u062A\u0648\u0634\u0643 \u0623\u0646 \u062A\u0646\u062A\u0647\u064A\u060C \u0645\u0639 \u0634\u0631\u064A\u0637 \xAB\u0633\u062A\u0646\u062A\u0647\u064A \u0635\u0644\u0627\u062D\u064A\u0629 \u0634\u0647\u0627\u062F\u062A\u0643\u0645 \u0627\u0644\u0646\u0634\u0637\u0629 \u0642\u0631\u064A\u0628\u064B\u0627\xBB: \u0623\u0636\u0641 \u0634\u0647\u0627\u062F\u0629 \u062C\u062F\u064A\u062F\u0629 \u0642\u0628\u0644 \u0627\u0644\u062A\u0627\u0631\u064A\u062E."
              },
              revoke: {
                term: "\u0625\u0644\u063A\u0627\u0621 \u0627\u0644\u0634\u0647\u0627\u062F\u0629",
                text: "\u0641\u064A \u0627\u0644\u0634\u0647\u0627\u062F\u0629 \u0627\u0644\u0646\u0634\u0637\u0629: \u0628\u0639\u062F \u0627\u0644\u062A\u0623\u0643\u064A\u062F (\xAB\u0625\u0644\u063A\u0627\u0621 \u0627\u0644\u0634\u0647\u0627\u062F\u0629\xBB) \u0644\u0646 \u062A\u064F\u0648\u0642\u064E\u0651\u0639 \u0627\u0644\u0641\u0648\u0627\u062A\u064A\u0631 \u0628\u0647\u0627 \u0648\u0644\u0627 \u064A\u0645\u0643\u0646 \u0625\u0639\u0627\u062F\u0629 \u062A\u0641\u0639\u064A\u0644\u0647\u0627. \u0648\u0644\u0627 \u062A\u062A\u063A\u064A\u0631 \u0627\u0644\u0641\u0648\u0627\u062A\u064A\u0631 \u0627\u0644\u062A\u064A \u0642\u064F\u0628\u0644\u062A \u0645\u0646 \u0642\u0628\u0644."
              },
              empty: {
                term: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0634\u0647\u0627\u062F\u0629: \u0644\u0627 \u064A\u0645\u0643\u0646 \u062A\u0648\u0642\u064A\u0639 \u0627\u0644\u0641\u0648\u0627\u062A\u064A\u0631",
                text: "\u0631\u0633\u0627\u0644\u0629 \u0627\u0644\u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u0641\u0627\u0631\u063A\u0629: \u0623\u0636\u0641 \u0634\u0647\u0627\u062F\u0629 \u0627\u0644\u062E\u062A\u0645 \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A \u0644\u0645\u0643\u062A\u0628\u0643\u0645 \u062D\u062A\u0649 \u062A\u062A\u0645\u0643\u0646\u0648\u0627 \u0645\u0646 \u0625\u0631\u0633\u0627\u0644 \u0641\u0648\u0627\u062A\u064A\u0631\u0643\u0645 \u0625\u0644\u0649 \u2066TTN\u2069."
              }
            }
          },
          addDialog: {
            title: "\u0625\u0636\u0627\u0641\u0629 \u0634\u0647\u0627\u062F\u0629 \u062A\u0648\u0642\u064A\u0639",
            items: {
              kind: {
                term: "\u0646\u0648\u0639 \u0627\u0644\u0634\u0647\u0627\u062F\u0629",
                text: "\u0627\u0644\u062E\u062A\u0645 \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A \u0623\u0648 \u0634\u0647\u0627\u062F\u0629 \u0627\u062E\u062A\u0628\u0627\u0631."
              },
              label: {
                term: "\u0627\u0644\u062A\u0633\u0645\u064A\u0629 (\u0627\u062E\u062A\u064A\u0627\u0631\u064A\u0629)",
                text: "\u0627\u0633\u0645 \u064A\u0633\u0647\u0651\u0644 \u0627\u0644\u062A\u0639\u0631\u0641 \u0639\u0644\u064A\u0647\u0627\u060C \u0645\u062B\u0644 \xAB\u062E\u062A\u0645 2026\xBB."
              },
              certificate: {
                term: "\u0627\u0644\u0634\u0647\u0627\u062F\u0629 (\u0645\u0644\u0641 \u2066.pem\u2069 \u0623\u0648 \u2066.crt\u2069 \u0623\u0648 \u2066.cer\u2069)",
                text: "\u0627\u0644\u0634\u0647\u0627\u062F\u0629 \u0627\u0644\u0639\u0645\u0648\u0645\u064A\u0629 \u0628\u0635\u064A\u063A\u0629 \u2066PEM\u2069\u060C 20 \u0643\u064A\u0644\u0648\u0628\u0627\u064A\u062A \u0639\u0644\u0649 \u0627\u0644\u0623\u0643\u062B\u0631."
              },
              privateKey: {
                term: "\u0627\u0644\u0645\u0641\u062A\u0627\u062D \u0627\u0644\u062E\u0627\u0635 (\u0645\u0644\u0641 \u2066.pem\u2069 \u0623\u0648 \u2066.key\u2069)",
                text: "\u0627\u0644\u0645\u0641\u062A\u0627\u062D \u0627\u0644\u062E\u0627\u0635 \u0628\u0635\u064A\u063A\u0629 \u2066PEM\u2069 (\u2066PKCS#8\u2069)\u060C 20 \u0643\u064A\u0644\u0648\u0628\u0627\u064A\u062A \u0639\u0644\u0649 \u0627\u0644\u0623\u0643\u062B\u0631. \u064A\u064F\u0634\u0641\u064E\u0651\u0631 \u0642\u0628\u0644 \u062D\u0641\u0638\u0647 \u0648\u0644\u0627 \u064A\u0645\u0643\u0646 \u0639\u0631\u0636\u0647 \u0623\u0648 \u062A\u0646\u0632\u064A\u0644\u0647 \u0645\u062C\u062F\u062F\u064B\u0627 \u0623\u0628\u062F\u064B\u0627."
              },
              save: {
                term: "\u0625\u0636\u0627\u0641\u0629 \u0627\u0644\u0634\u0647\u0627\u062F\u0629",
                text: "\u064A\u0636\u064A\u0641 \u0627\u0644\u0634\u0647\u0627\u062F\u0629 \u0627\u0644\u062A\u064A \u062A\u0635\u0628\u062D \u0646\u0634\u0637\u0629. \u062A\u064F\u0642\u0631\u0623 \u0627\u0644\u0645\u0644\u0641\u0627\u062A \u0641\u064A \u0645\u062A\u0635\u0641\u062D\u0643\u0645 \u062B\u0645 \u062A\u064F\u0631\u0633\u064E\u0644 \u0645\u0631\u0629 \u0648\u0627\u062D\u062F\u0629 \u0641\u0642\u0637\u061B \u0648\u0625\u0646 \u0637\u064F\u0644\u0628 \u062A\u0623\u0643\u064A\u062F \u0627\u0644\u0647\u0648\u064A\u0629 \u0641\u0633\u062A\u062E\u062A\u0627\u0631\u0648\u0646 \u0627\u0644\u0645\u0644\u0641\u064A\u0646 \u0645\u0646 \u062C\u062F\u064A\u062F. \xAB\u0625\u0644\u063A\u0627\u0621\xBB \u064A\u063A\u0644\u0642 \u0627\u0644\u0646\u0627\u0641\u0630\u0629."
              }
            }
          }
        }
      }
    },
    clients: {
      title: "\u0627\u0644\u062D\u0631\u0641\u0627\u0621",
      intro: "\u0642\u0627\u0626\u0645\u0629 \u062D\u0631\u0641\u0627\u0621 \u0645\u0643\u062A\u0628\u0643 (\u0623\u0635\u062D\u0627\u0628 \u0627\u0644\u0645\u0634\u0627\u0631\u064A\u0639): \u0627\u0644\u0623\u0634\u062E\u0627\u0635 \u0623\u0648 \u0627\u0644\u0647\u064A\u0627\u0643\u0644 \u0627\u0644\u062A\u064A \u062A\u0646\u062C\u0632 \u0644\u0647\u0627 \u0645\u0634\u0627\u0631\u064A\u0639. \u064A\u064F\u0633\u062A\u0639\u0645\u0644 \u0645\u0644\u0641\u0647\u0645 \u0627\u0644\u062C\u0628\u0627\u0626\u064A \u0628\u0639\u062F \u0630\u0644\u0643 \u0641\u064A \u0627\u0644\u0639\u0631\u0648\u0636 \u0627\u0644\u0645\u0627\u0644\u064A\u0629 \u0648\u0627\u0644\u0641\u0648\u0627\u062A\u064A\u0631.",
      sections: {
        header: {
          title: "\u0631\u0623\u0633 \u0627\u0644\u0635\u0641\u062D\u0629",
          items: {
            newClient: {
              term: "\u062D\u0631\u064A\u0641 \u062C\u062F\u064A\u062F",
              text: "\u064A\u0641\u062A\u062D \u0646\u0627\u0641\u0630\u0629 \u0625\u0646\u0634\u0627\u0621 \u062D\u0631\u064A\u0641. \u0644\u0627 \u064A\u0638\u0647\u0631 \u0625\u0644\u0627 \u0625\u0630\u0627 \u0643\u0646\u062A \u062A\u0645\u0644\u0643 \u0635\u0644\u0627\u062D\u064A\u0629 \u0625\u0646\u0634\u0627\u0621 \u0627\u0644\u062D\u0631\u0641\u0627\u0621\u060C \u0648\u064A\u0643\u0648\u0646 \u0645\u0639\u0637\u0651\u0644\u064B\u0627 \u0625\u0630\u0627 \u0643\u0627\u0646 \u062D\u0633\u0627\u0628 \u0627\u0644\u0645\u0643\u062A\u0628 \u0644\u0644\u0627\u0637\u0644\u0627\u0639 \u0641\u0642\u0637."
            },
            title: {
              term: "\u0627\u0644\u062D\u0631\u0641\u0627\u0621",
              text: "\u0627\u0644\u062D\u0631\u064A\u0641\u060C \u0623\u0648 \u0635\u0627\u062D\u0628 \u0627\u0644\u0645\u0634\u0631\u0648\u0639\u060C \u0647\u0648 \u0627\u0644\u0634\u062E\u0635 \u0623\u0648 \u0627\u0644\u0647\u064A\u0643\u0644 \u0627\u0644\u0630\u064A \u062A\u0646\u062C\u0632 \u0644\u0647 \u0645\u0634\u0631\u0648\u0639\u064B\u0627."
            }
          }
        },
        filters: {
          title: "\u062A\u0635\u0641\u064A\u0629 \u0627\u0644\u062D\u0631\u0641\u0627\u0621",
          items: {
            search: {
              term: "\u0627\u0644\u0628\u062D\u062B \u0639\u0646 \u062D\u0631\u064A\u0641",
              text: "\u0627\u0643\u062A\u0628 \u062C\u0632\u0621\u064B\u0627 \u0645\u0646 \u0627\u0633\u0645 \u0627\u0644\u062D\u0631\u064A\u0641: \u062A\u062A\u0642\u0644\u0635 \u0627\u0644\u0642\u0627\u0626\u0645\u0629 \u0628\u0639\u062F \u0644\u062D\u0638\u0629 \u0642\u0635\u064A\u0631\u0629."
            },
            kind: {
              term: "\u0627\u0644\u062A\u0635\u0641\u064A\u0629 \u062D\u0633\u0628 \u0627\u0644\u0646\u0648\u0639",
              text: "\u064A\u0639\u0631\u0636 \u0646\u0648\u0639\u064B\u0627 \u0648\u0627\u062D\u062F\u064B\u0627 \u0645\u0646 \u0627\u0644\u062D\u0631\u0641\u0627\u0621 (\u0647\u064A\u0643\u0644 \u0639\u0645\u0648\u0645\u064A \u0623\u0648 \u0634\u0631\u0643\u0629 \u062E\u0627\u0635\u0629 \u0623\u0648 \u0634\u062E\u0635 \u0637\u0628\u064A\u0639\u064A \u0623\u0648 \u062D\u0631\u064A\u0641 \u0623\u062C\u0646\u0628\u064A)\u061B \u0648\xAB\u0643\u0644 \u0627\u0644\u0623\u0646\u0648\u0627\u0639\xBB \u062A\u0639\u0631\u0636 \u0627\u0644\u062C\u0645\u064A\u0639."
            },
            archived: {
              term: "\u0639\u0631\u0636 \u0627\u0644\u062D\u0631\u0641\u0627\u0621 \u0627\u0644\u0645\u0624\u0631\u0634\u0641\u064A\u0646 \u0641\u0642\u0637",
              text: "\u0645\u0641\u062A\u0627\u062D: \u064A\u0646\u062A\u0642\u0644 \u0625\u0644\u0649 \u0627\u0644\u062D\u0631\u0641\u0627\u0621 \u0627\u0644\u0645\u0624\u0631\u0634\u0641\u064A\u0646 \u0627\u0644\u0630\u064A\u0646 \u0644\u0627 \u064A\u0638\u0647\u0631\u0648\u0646 \u0641\u064A \u0627\u0644\u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u0639\u0627\u062F\u064A\u0629."
            },
            clear: {
              term: "\u0645\u0633\u062D \u0639\u0648\u0627\u0645\u0644 \u0627\u0644\u062A\u0635\u0641\u064A\u0629",
              text: "\u064A\u0638\u0647\u0631 \u0641\u064A \u0631\u0633\u0627\u0626\u0644 \u0627\u0644\u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u0641\u0627\u0631\u063A\u0629: \u064A\u0639\u064A\u062F \u0627\u0644\u0628\u062D\u062B \u0648\u0627\u0644\u0646\u0648\u0639 \u0648\u0627\u0644\u0645\u0641\u062A\u0627\u062D \u0625\u0644\u0649 \u0648\u0636\u0639\u0647\u0627 \u0627\u0644\u0623\u0648\u0644."
            }
          }
        },
        table: {
          title: "\u062D\u0631\u0641\u0627\u0621 \u0627\u0644\u0645\u0643\u062A\u0628",
          items: {
            name: {
              term: "\u0627\u0644\u0627\u0633\u0645",
              text: "\u0627\u0633\u0645 \u0627\u0644\u062D\u0631\u064A\u0641. \u0627\u0646\u0642\u0631 \u0639\u0644\u064A\u0647 \u0644\u0641\u062A\u062D \u0645\u0644\u0641\u0647\u061B \u0648\u062A\u062F\u0644 \u0627\u0644\u0634\u0627\u0631\u0629 \xAB\u0645\u0624\u0631\u0634\u0641\xBB \u0639\u0644\u0649 \u062D\u0631\u064A\u0641 \u0645\u0624\u0631\u0634\u0641."
            },
            kind: {
              term: "\u0627\u0644\u0646\u0648\u0639",
              text: "\u0647\u064A\u0643\u0644 \u0639\u0645\u0648\u0645\u064A \u0623\u0648 \u0634\u0631\u0643\u0629 \u062E\u0627\u0635\u0629 \u0623\u0648 \u0634\u062E\u0635 \u0637\u0628\u064A\u0639\u064A \u0623\u0648 \u062D\u0631\u064A\u0641 \u0623\u062C\u0646\u0628\u064A."
            },
            taxId: {
              term: "\u0627\u0644\u0645\u0639\u0631\u0651\u0641 \u0627\u0644\u062C\u0628\u0627\u0626\u064A",
              text: "\u0627\u0644\u0645\u0639\u0631\u0651\u0641 \u0627\u0644\u062C\u0628\u0627\u0626\u064A \u0644\u0644\u062D\u0631\u064A\u0641\u061B \u0648\xAB\u2014\xBB \u0625\u0630\u0627 \u0644\u0645 \u064A\u064F\u062F\u062E\u064E\u0644."
            },
            city: {
              term: "\u0627\u0644\u0645\u062F\u064A\u0646\u0629",
              text: "\u0645\u062F\u064A\u0646\u0629 \u0627\u0644\u062D\u0631\u064A\u0641\u060C \u064A\u0644\u064A\u0647\u0627 \u0631\u0645\u0632 \u0627\u0644\u0628\u0644\u062F \u0628\u064A\u0646 \u0642\u0648\u0633\u064A\u0646 \u0625\u0630\u0627 \u0644\u0645 \u064A\u0643\u0646 \u0641\u064A \u062A\u0648\u0646\u0633."
            },
            contact: {
              term: "\u0627\u0644\u0628\u0631\u064A\u062F \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A \u0648\u0627\u0644\u0647\u0627\u062A\u0641",
              text: "\u0627\u0644\u0628\u0631\u064A\u062F \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A \u0648\u0627\u0644\u0647\u0627\u062A\u0641 \u0627\u0644\u062E\u0627\u0635\u0627\u0646 \u0628\u0627\u0644\u062D\u0631\u064A\u0641\u061B \u0648\xAB\u2014\xBB \u0625\u0630\u0627 \u0644\u0645 \u064A\u0648\u062C\u062F\u0627."
            }
          }
        },
        empty: {
          title: "\u0627\u0644\u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u0641\u0627\u0631\u063A\u0629 \u0648\u0627\u0644\u0623\u062E\u0637\u0627\u0621 \u0648\u0627\u0644\u062A\u062D\u0645\u064A\u0644",
          items: {
            none: {
              term: "\u0644\u0627 \u064A\u0648\u062C\u062F \u062D\u0631\u0641\u0627\u0621 \u0628\u0639\u062F",
              text: "\u0631\u0633\u0627\u0644\u0629 \u0627\u0644\u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u0641\u0627\u0631\u063A\u0629. \u062A\u0642\u062A\u0631\u062D \xAB\u062D\u0631\u064A\u0641 \u062C\u062F\u064A\u062F\xBB \u0639\u0644\u0649 \u0645\u0646 \u064A\u0633\u062A\u0637\u064A\u0639\u0648\u0646 \u0627\u0644\u0625\u0646\u0634\u0627\u0621\u061B \u0623\u0645\u0627 \u063A\u064A\u0631\u0647\u0645 \u0641\u064A\u064F\u062F\u0639\u0648\u0646 \u0625\u0644\u0649 \u0637\u0644\u0628 \u0625\u0646\u0634\u0627\u0621 \u062D\u0631\u064A\u0641 \u0645\u0646 \u0645\u0633\u0624\u0648\u0644 \u0623\u0648 \u0645\u062F\u064A\u0631 \u0645\u0634\u0631\u0648\u0639."
            },
            noMatch: {
              term: "\u0644\u0627 \u064A\u0648\u062C\u062F \u062D\u0631\u064A\u0641 \u0645\u0637\u0627\u0628\u0642",
              text: "\u0631\u0633\u0627\u0644\u0629 \u062A\u0638\u0647\u0631 \u0639\u0646\u062F\u0645\u0627 \u0644\u0627 \u064A\u062C\u062F \u0627\u0644\u0628\u062D\u062B \u0623\u0648 \u0627\u0644\u0646\u0648\u0639 \u0634\u064A\u0626\u064B\u0627: \u062C\u0631\u0651\u0628 \u0627\u0633\u0645\u064B\u0627 \u0622\u062E\u0631 \u0623\u0648 \u0646\u0648\u0639\u064B\u0627 \u0622\u062E\u0631."
            },
            archived: {
              term: "\u0644\u0627 \u064A\u0648\u062C\u062F \u062D\u0631\u0641\u0627\u0621 \u0645\u0624\u0631\u0634\u0641\u0648\u0646",
              text: "\u0631\u0633\u0627\u0644\u0629 \u062A\u0638\u0647\u0631 \u0639\u0646\u062F\u0645\u0627 \u064A\u0643\u0648\u0646 \u0645\u0641\u062A\u0627\u062D \u0627\u0644\u062D\u0631\u0641\u0627\u0621 \u0627\u0644\u0645\u0624\u0631\u0634\u0641\u064A\u0646 \u0645\u0641\u0639\u0651\u0644\u064B\u0627 \u0648\u0644\u0627 \u064A\u0648\u062C\u062F \u0623\u064A \u062D\u0631\u064A\u0641 \u0645\u0624\u0631\u0634\u0641."
            },
            loadMore: {
              term: "\u0639\u0631\u0636 \u0627\u0644\u0645\u0632\u064A\u062F \u0645\u0646 \u0627\u0644\u062D\u0631\u0641\u0627\u0621",
              text: "\u062A\u062D\u062A \u0627\u0644\u0642\u0627\u0626\u0645\u0629: \u064A\u062D\u0645\u0651\u0644 \u0627\u0644\u062D\u0631\u0641\u0627\u0621 \u0627\u0644\u062A\u0627\u0644\u064A\u0646."
            },
            loadError: {
              term: "\u062A\u0639\u0630\u0651\u0631 \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u062D\u0631\u0641\u0627\u0621",
              text: "\u0631\u0633\u0627\u0644\u0629 \u062E\u0637\u0623 \u0639\u0646\u062F \u0648\u062C\u0648\u062F \u0645\u0634\u0643\u0644 \u0641\u064A \u0627\u0644\u0627\u062A\u0635\u0627\u0644\u061B \u0648\xAB\u0625\u0639\u0627\u062F\u0629 \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629\xBB \u062A\u0639\u064A\u062F \u0627\u0644\u062A\u062D\u0645\u064A\u0644."
            }
          }
        },
        identity: {
          title: "\u062D\u0631\u064A\u0641 \u062C\u062F\u064A\u062F: \u0627\u0644\u0647\u0648\u064A\u0629",
          items: {
            kind: {
              term: "\u0646\u0648\u0639 \u0627\u0644\u062D\u0631\u064A\u0641",
              text: "\u0625\u062C\u0628\u0627\u0631\u064A\u060C \u0648\u064A\u064F\u062E\u062A\u0627\u0631 \u0623\u0648\u0644\u064B\u0627: \u064A\u062A\u0643\u064A\u0651\u0641 \u0627\u0644\u0646\u0645\u0648\u0630\u062C \u0648\u064A\u0636\u0628\u0637 \u0645\u0633\u0628\u0642\u064B\u0627 \u0627\u0644\u0623\u062F\u0627\u0621 \u0639\u0644\u0649 \u0627\u0644\u0642\u064A\u0645\u0629 \u0627\u0644\u0645\u0636\u0627\u0641\u0629 \u0648\u0627\u0644\u0627\u0642\u062A\u0637\u0627\u0639\u0627\u062A. \u0648\u062A\u0634\u0631\u062D \u062C\u0645\u0644\u0629 \u062A\u062D\u062A \u0627\u0644\u062D\u0642\u0644 \u0643\u0644 \u0646\u0648\u0639."
            },
            name: {
              term: "\u0627\u0644\u0627\u0633\u0645 \u0623\u0648 \u0627\u0644\u062A\u0633\u0645\u064A\u0629 \u0627\u0644\u0627\u062C\u062A\u0645\u0627\u0639\u064A\u0629",
              text: "\u0625\u062C\u0628\u0627\u0631\u064A: \u0627\u0633\u0645 \u0627\u0644\u0634\u062E\u0635 \u0623\u0648 \u0627\u0644\u0634\u0631\u0643\u0629."
            },
            taxId: {
              term: "\u0627\u0644\u0645\u0639\u0631\u0651\u0641 \u0627\u0644\u062C\u0628\u0627\u0626\u064A",
              text: "\u0625\u062C\u0628\u0627\u0631\u064A \u0644\u0644\u0647\u064A\u0643\u0644 \u0627\u0644\u0639\u0645\u0648\u0645\u064A \u0623\u0648 \u0627\u0644\u0634\u0631\u0643\u0629 \u0627\u0644\u062E\u0627\u0635\u0629 (\u0627\u0644\u0635\u064A\u063A\u0629 \u20661234567 A / A / M / 000\u2069) \u0648\u0627\u062E\u062A\u064A\u0627\u0631\u064A \u0644\u0644\u0634\u062E\u0635 \u0627\u0644\u0637\u0628\u064A\u0639\u064A. \u0648\u0644\u0644\u062D\u0631\u064A\u0641 \u0627\u0644\u0623\u062C\u0646\u0628\u064A \u064A\u0635\u0628\u062D \u0627\u0644\u062D\u0642\u0644 \xAB\u0627\u0644\u0645\u0639\u0631\u0651\u0641 \u0627\u0644\u062C\u0628\u0627\u0626\u064A\xBB \u0646\u0635\u064B\u0627 \u062D\u0631\u064B\u0627 \u0644\u0627 \u064A\u062A\u062C\u0627\u0648\u0632 50 \u062D\u0631\u0641\u064B\u0627."
            },
            paymentTerms: {
              term: "\u0623\u062C\u0644 \u0627\u0644\u062F\u0641\u0639 (\u0628\u0627\u0644\u0623\u064A\u0627\u0645)",
              text: "\u0639\u062F\u062F \u0627\u0644\u0623\u064A\u0627\u0645 \u0628\u0639\u062F \u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629\u061B \u0627\u0644\u0642\u064A\u0645\u0629 \u0627\u0644\u0627\u0641\u062A\u0631\u0627\u0636\u064A\u0629 30\u060C \u0628\u064A\u0646 0 \u0648365."
            }
          }
        },
        tax: {
          title: "\u062D\u0631\u064A\u0641 \u062C\u062F\u064A\u062F: \u0627\u0644\u0623\u062F\u0627\u0621 \u0639\u0644\u0649 \u0627\u0644\u0642\u064A\u0645\u0629 \u0627\u0644\u0645\u0636\u0627\u0641\u0629 \u0648\u0627\u0644\u0627\u0642\u062A\u0637\u0627\u0639 \u0645\u0646 \u0627\u0644\u0645\u0635\u062F\u0631",
          items: {
            vatRegime: {
              term: "\u0646\u0638\u0627\u0645 \u0627\u0644\u0623\u062F\u0627\u0621 \u0639\u0644\u0649 \u0627\u0644\u0642\u064A\u0645\u0629 \u0627\u0644\u0645\u0636\u0627\u0641\u0629",
              text: "\u0625\u062C\u0628\u0627\u0631\u064A: \u062E\u0627\u0636\u0639 \u0644\u0644\u0623\u062F\u0627\u0621 \u0639\u0644\u0649 \u0627\u0644\u0642\u064A\u0645\u0629 \u0627\u0644\u0645\u0636\u0627\u0641\u0629 \u0623\u0648 \u0645\u0639\u0641\u0649 \u0645\u0646\u0647 \u0623\u0648 \u0623\u062F\u0627\u0621 \u0645\u0639\u0644\u0651\u0642 \u0623\u0648 \u062A\u0635\u062F\u064A\u0631 (\u062E\u0627\u0631\u062C \u062A\u0648\u0646\u0633). \u0648\u062A\u0634\u0631\u062D \u062C\u0645\u0644\u0629 \u062A\u062D\u062A \u0627\u0644\u062D\u0642\u0644 \u0627\u0644\u0627\u062E\u062A\u064A\u0627\u0631."
            },
            exemptionRef: {
              term: "\u0627\u0644\u0645\u0631\u062C\u0639",
              text: "\u0628\u062D\u0633\u0628 \u0627\u0644\u0646\u0638\u0627\u0645: \xAB\u0645\u0631\u062C\u0639 \u0634\u0647\u0627\u062F\u0629 \u0627\u0644\u0625\u0639\u0641\u0627\u0621\xBB \u0623\u0648 \xAB\u0645\u0631\u062C\u0639 \u0634\u0647\u0627\u062F\u0629 \u0627\u0644\u062A\u0639\u0644\u064A\u0642\xBB (\u0625\u062C\u0628\u0627\u0631\u064A\u0627\u0646) \u0623\u0648 \xAB\u0627\u0644\u0645\u0631\u062C\u0639 (\u0627\u062E\u062A\u064A\u0627\u0631\u064A)\xBB \u0644\u0644\u062A\u0635\u062F\u064A\u0631. \u0627\u0646\u0633\u062E\u0647 \u0643\u0645\u0627 \u064A\u0638\u0647\u0631 \u0641\u064A \u0627\u0644\u0648\u062B\u064A\u0642\u0629."
            },
            exemptionExpiresOn: {
              term: "\u0646\u0647\u0627\u064A\u0629 \u0627\u0644\u0635\u0644\u0627\u062D\u064A\u0629",
              text: "\u0627\u0644\u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0630\u064A \u062A\u0646\u062A\u0647\u064A \u0639\u0646\u062F\u0647 \u0635\u0644\u0627\u062D\u064A\u0629 \u0627\u0644\u0634\u0647\u0627\u062F\u0629: \u0625\u062C\u0628\u0627\u0631\u064A \u0644\u0644\u0625\u0639\u0641\u0627\u0621 \u0648\u0627\u062E\u062A\u064A\u0627\u0631\u064A \u0644\u0644\u062A\u0639\u0644\u064A\u0642."
            },
            withholding: {
              term: "\u0627\u0644\u0627\u0642\u062A\u0637\u0627\u0639 \u0645\u0646 \u0627\u0644\u0645\u0635\u062F\u0631",
              text: "\u0645\u0641\u062A\u0627\u062D: \u0647\u0648 \u062C\u0632\u0621 \u0645\u0646 \u0641\u0627\u062A\u0648\u0631\u062A\u0643 \u064A\u062D\u062A\u0641\u0638 \u0628\u0647 \u0627\u0644\u062D\u0631\u064A\u0641 \u0644\u064A\u062F\u0641\u0639\u0647 \u0625\u0644\u0649 \u0627\u0644\u0625\u062F\u0627\u0631\u0629 \u0627\u0644\u062C\u0628\u0627\u0626\u064A\u0629\u061B \u062A\u062A\u0633\u0644\u0651\u0645 \u0627\u0644\u0628\u0627\u0642\u064A \u0648\u0634\u0647\u0627\u062F\u0629 \u0627\u0642\u062A\u0637\u0627\u0639. \u064A\u0643\u0648\u0646 \u0645\u0641\u0639\u0651\u0644\u064B\u0627 \u0627\u0641\u062A\u0631\u0627\u0636\u064A\u064B\u0627 \u0644\u0644\u0647\u064A\u0627\u0643\u0644 \u0627\u0644\u0639\u0645\u0648\u0645\u064A\u0629 \u0648\u0627\u0644\u0634\u0631\u0643\u0627\u062A."
            },
            withholdingRate: {
              term: "\u0646\u0633\u0628\u0629 \u0627\u0642\u062A\u0637\u0627\u0639 \u062E\u0627\u0635\u0629 (%)",
              text: "\u0644\u0627 \u064A\u0643\u0648\u0646 \u0646\u0634\u0637\u064B\u0627 \u0625\u0644\u0627 \u0625\u0630\u0627 \u0641\u064F\u0639\u0651\u0644 \u0627\u0644\u0627\u0642\u062A\u0637\u0627\u0639: \u0627\u062A\u0631\u0643\u0647 \u0641\u0627\u0631\u063A\u064B\u0627 \u0644\u062A\u0637\u0628\u064A\u0642 \u0627\u0644\u0646\u0633\u0628\u0629 \u0627\u0644\u0642\u0627\u0646\u0648\u0646\u064A\u0629 \u0627\u0644\u062C\u0627\u0631\u064A \u0628\u0647\u0627 \u0627\u0644\u0639\u0645\u0644 \u0623\u0648 \u0623\u062F\u062E\u0644 \u0646\u0633\u0628\u0629 \u0628\u064A\u0646 0 \u0648100."
            },
            vatWithholding: {
              term: "\u0627\u0644\u0627\u0642\u062A\u0637\u0627\u0639 \u0645\u0646 \u0627\u0644\u0645\u0635\u062F\u0631 \u0639\u0644\u0649 \u0627\u0644\u0642\u064A\u0645\u0629 \u0627\u0644\u0645\u0636\u0627\u0641\u0629",
              text: "\u0645\u0641\u062A\u0627\u062D: \u062C\u0632\u0621 \u0645\u0646 \u0627\u0644\u0623\u062F\u0627\u0621 \u0639\u0644\u0649 \u0627\u0644\u0642\u064A\u0645\u0629 \u0627\u0644\u0645\u0636\u0627\u0641\u0629 \u0627\u0644\u0645\u0636\u0645\u0651\u0646 \u0641\u064A \u0641\u0627\u062A\u0648\u0631\u062A\u0643 \u064A\u062D\u062A\u0641\u0638 \u0628\u0647 \u0627\u0644\u062D\u0631\u064A\u0641 \u0644\u064A\u062F\u0641\u0639\u0647 \u0625\u0644\u0649 \u0627\u0644\u062E\u0632\u064A\u0646\u0629\u060C \u0641\u062A\u062A\u0633\u0644\u0651\u0645 \u0627\u0644\u0645\u062A\u0628\u0642\u064A \u0641\u0642\u0637. \u064A\u0643\u0648\u0646 \u0645\u0641\u0639\u0651\u0644\u064B\u0627 \u0627\u0641\u062A\u0631\u0627\u0636\u064A\u064B\u0627 \u0644\u0644\u0647\u064A\u0627\u0643\u0644 \u0627\u0644\u0639\u0645\u0648\u0645\u064A\u0629\u061B \u0648\u0627\u0644\u0646\u0633\u0628\u0629 \u0647\u064A \u0627\u0644\u0645\u062D\u062F\u062F\u0629 \u0628\u0627\u0644\u0642\u0627\u0646\u0648\u0646."
            }
          }
        },
        addressContact: {
          title: "\u062D\u0631\u064A\u0641 \u062C\u062F\u064A\u062F: \u0627\u0644\u0639\u0646\u0648\u0627\u0646 \u0648\u0628\u064A\u0627\u0646\u0627\u062A \u0627\u0644\u0627\u062A\u0635\u0627\u0644",
          items: {
            line1: {
              term: "\u0627\u0644\u0639\u0646\u0648\u0627\u0646",
              text: "\u0625\u062C\u0628\u0627\u0631\u064A: \u0627\u0644\u0634\u0627\u0631\u0639 \u0648\u0627\u0644\u0639\u062F\u062F."
            },
            line2: {
              term: "\u062A\u062A\u0645\u0629 \u0627\u0644\u0639\u0646\u0648\u0627\u0646",
              text: "\u0627\u062E\u062A\u064A\u0627\u0631\u064A: \u0627\u0644\u0639\u0645\u0627\u0631\u0629 \u0623\u0648 \u0627\u0644\u0637\u0627\u0628\u0642 \u0648\u0645\u0627 \u0625\u0644\u0649 \u0630\u0644\u0643."
            },
            cityPostal: {
              term: "\u0627\u0644\u0645\u062F\u064A\u0646\u0629 \u0648\u0627\u0644\u0631\u0645\u0632 \u0627\u0644\u0628\u0631\u064A\u062F\u064A",
              text: "\u0643\u0644\u0627\u0647\u0645\u0627 \u0625\u062C\u0628\u0627\u0631\u064A: \u0627\u0644\u0645\u062F\u064A\u0646\u0629\u060C \u0648\u0627\u0644\u0631\u0645\u0632 \u0627\u0644\u0628\u0631\u064A\u062F\u064A \u0645\u0646 3 \u0625\u0644\u0649 10 \u062E\u0627\u0646\u0627\u062A."
            },
            country: {
              term: "\u0627\u0644\u0628\u0644\u062F (\u0631\u0645\u0632 \u0645\u0646 \u062D\u0631\u0641\u064A\u0646)",
              text: "\u064A\u0638\u0647\u0631 \u0644\u0644\u062D\u0631\u064A\u0641 \u0627\u0644\u0623\u062C\u0646\u0628\u064A: \u0645\u062B\u0644\u064B\u0627 \u2066FR\u2069 \u0644\u0641\u0631\u0646\u0633\u0627 \u0648\u2066IT\u2069 \u0644\u0625\u064A\u0637\u0627\u0644\u064A\u0627."
            },
            email: {
              term: "\u0627\u0644\u0628\u0631\u064A\u062F \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A",
              text: "\u0627\u062E\u062A\u064A\u0627\u0631\u064A: \u064A\u064F\u0633\u062A\u0639\u0645\u0644 \u062E\u0627\u0635\u0629 \u0644\u0625\u0631\u0633\u0627\u0644 \u0627\u0644\u0639\u0631\u0648\u0636 \u0627\u0644\u0645\u0627\u0644\u064A\u0629."
            },
            phone: {
              term: "\u0627\u0644\u0647\u0627\u062A\u0641",
              text: "\u0627\u062E\u062A\u064A\u0627\u0631\u064A\u060C \u0645\u062B\u0644\u064B\u0627 \u2066+216 71 000 000\u2069. \u0627\u0644\u0632\u0631 \xAB\u0625\u0646\u0634\u0627\u0621 \u0627\u0644\u062D\u0631\u064A\u0641\xBB \u064A\u062D\u0641\u0638 \u0627\u0644\u0645\u0644\u0641 \u0648\xAB\u0625\u0644\u063A\u0627\u0621\xBB \u064A\u063A\u0644\u0642 \u0627\u0644\u0646\u0627\u0641\u0630\u0629."
            }
          }
        }
      }
    },
    client: {
      title: "\u0645\u0644\u0641 \u0627\u0644\u062D\u0631\u064A\u0641",
      intro: "\u0645\u0644\u0641 \u062D\u0631\u064A\u0641 \u0648\u0627\u062D\u062F (\u0635\u0627\u062D\u0628 \u0645\u0634\u0631\u0648\u0639): \u0645\u0644\u0641\u0647 \u0627\u0644\u062C\u0628\u0627\u0626\u064A \u0648\u062C\u0647\u0627\u062A \u0627\u062A\u0635\u0627\u0644\u0647 \u0648\u0644\u0627\u062D\u0642\u064B\u0627 \u0645\u0634\u0627\u0631\u064A\u0639\u0647 \u0648\u0641\u0648\u0627\u062A\u064A\u0631\u0647. \u064A\u0645\u0643\u0646\u0643 \u062A\u0639\u062F\u064A\u0644\u0647 \u0623\u0648 \u0623\u0631\u0634\u0641\u062A\u0647 \u0628\u062D\u0633\u0628 \u0635\u0644\u0627\u062D\u064A\u0627\u062A\u0643.",
      sections: {
        header: {
          title: "\u0631\u0623\u0633 \u0627\u0644\u0645\u0644\u0641",
          items: {
            breadcrumb: {
              term: "\u0627\u0644\u062D\u0631\u0641\u0627\u0621",
              text: "\u064A\u0639\u064A\u062F\u0643 \u0627\u0644\u0645\u0633\u0627\u0631 \u0625\u0644\u0649 \u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u062D\u0631\u0641\u0627\u0621\u061B \u0648\u0627\u0644\u0639\u0646\u0635\u0631 \u0627\u0644\u0623\u062E\u064A\u0631 \u0647\u0648 \u0627\u0633\u0645 \u0627\u0644\u062D\u0631\u064A\u0641."
            },
            archive: {
              term: "\u0623\u0631\u0634\u0641\u0629",
              text: "\u0644\u0627 \u064A\u0638\u0647\u0631 \u0625\u0644\u0627 \u0644\u0645\u0646 \u064A\u062D\u0642 \u0644\u0647\u0645 \u0627\u0644\u0623\u0631\u0634\u0641\u0629 \u0648\u0644\u062D\u0631\u064A\u0641 \u063A\u064A\u0631 \u0645\u0624\u0631\u0634\u0641: \u064A\u0641\u062A\u062D \u0646\u0627\u0641\u0630\u0629 \u062A\u0623\u0643\u064A\u062F (\xAB\u0623\u0631\u0634\u0641\u0629 \u0627\u0644\u062D\u0631\u064A\u0641 \u2026\u061F\xBB). \u062A\u0628\u0642\u0649 \u0645\u0634\u0627\u0631\u064A\u0639 \u0627\u0644\u062D\u0631\u064A\u0641 \u0648\u0639\u0631\u0648\u0636\u0647 \u0627\u0644\u0645\u0627\u0644\u064A\u0629 \u0648\u0641\u0648\u0627\u062A\u064A\u0631\u0647 \u0645\u062D\u0641\u0648\u0638\u0629."
            },
            archivedChip: {
              term: "\u0645\u0624\u0631\u0634\u0641",
              text: "\u0634\u0627\u0631\u0629 \u0641\u064A \u0623\u0639\u0644\u0649 \u0645\u0644\u0641 \u062D\u0631\u064A\u0641 \u0645\u0624\u0631\u0634\u0641. \u0648\u064A\u0636\u064A\u0641 \u0634\u0631\u064A\u0637: \xAB\u0647\u0630\u0627 \u0627\u0644\u062D\u0631\u064A\u0641 \u0645\u0624\u0631\u0634\u0641: \u0645\u0644\u0641\u0647 \u0644\u0644\u0627\u0637\u0644\u0627\u0639 \u0641\u0642\u0637\xBB."
            },
            tabs: {
              term: "\u0627\u0644\u0645\u0644\u0641\u060C \u062C\u0647\u0627\u062A \u0627\u0644\u0627\u062A\u0635\u0627\u0644\u060C \u0627\u0644\u0645\u0634\u0627\u0631\u064A\u0639\u060C \u0627\u0644\u0641\u0648\u0627\u062A\u064A\u0631",
              text: "\u0627\u0644\u062A\u0628\u0648\u064A\u0628\u0627\u062A \u0627\u0644\u0623\u0631\u0628\u0639\u0629 \u0644\u0644\u0645\u0644\u0641."
            },
            notFound: {
              term: "\u0627\u0644\u062D\u0631\u064A\u0641 \u063A\u064A\u0631 \u0645\u0648\u062C\u0648\u062F",
              text: "\u0631\u0633\u0627\u0644\u0629 \u062A\u0638\u0647\u0631 \u0625\u0630\u0627 \u0644\u0645 \u064A\u0643\u0646 \u0627\u0644\u062D\u0631\u064A\u0641 \u0645\u0648\u062C\u0648\u062F\u064B\u0627 \u0623\u0648 \u0644\u0645 \u062A\u0643\u0646 \u0644\u0643 \u0635\u0644\u0627\u062D\u064A\u0629 \u0627\u0644\u0627\u0637\u0644\u0627\u0639 \u0639\u0644\u064A\u0647\u061B \u0648\xAB\u0627\u0644\u0639\u0648\u062F\u0629 \u0625\u0644\u0649 \u0627\u0644\u062D\u0631\u0641\u0627\u0621\xBB \u062A\u0631\u062C\u0639\u0643 \u0625\u0644\u0649 \u0627\u0644\u0642\u0627\u0626\u0645\u0629. \u0648\u0639\u0646\u062F \u0645\u0634\u0643\u0644 \u0641\u064A \u0627\u0644\u0627\u062A\u0635\u0627\u0644: \xAB\u062A\u0639\u0630\u0651\u0631 \u062A\u062D\u0645\u064A\u0644 \u0647\u0630\u0627 \u0627\u0644\u062D\u0631\u064A\u0641\xBB."
            }
          }
        },
        profile: {
          title: "\u062A\u0628\u0648\u064A\u0628 \u0627\u0644\u0645\u0644\u0641",
          items: {
            identity: {
              term: "\u0627\u0644\u0647\u0648\u064A\u0629",
              text: "\u0646\u0648\u0639 \u0627\u0644\u062D\u0631\u064A\u0641 \u0648\u0627\u0644\u0627\u0633\u0645 \u0623\u0648 \u0627\u0644\u062A\u0633\u0645\u064A\u0629 \u0627\u0644\u0627\u062C\u062A\u0645\u0627\u0639\u064A\u0629 \u0648\u0627\u0644\u0645\u0639\u0631\u0651\u0641 \u0627\u0644\u062C\u0628\u0627\u0626\u064A \u0648\u0623\u062C\u0644 \u0627\u0644\u062F\u0641\u0639 (\u0628\u0627\u0644\u0623\u064A\u0627\u0645)."
            },
            tax: {
              term: "\u0627\u0644\u0623\u062F\u0627\u0621 \u0639\u0644\u0649 \u0627\u0644\u0642\u064A\u0645\u0629 \u0627\u0644\u0645\u0636\u0627\u0641\u0629 \u0648\u0627\u0644\u0627\u0642\u062A\u0637\u0627\u0639 \u0645\u0646 \u0627\u0644\u0645\u0635\u062F\u0631",
              text: "\u0646\u0638\u0627\u0645 \u0627\u0644\u0623\u062F\u0627\u0621 \u0639\u0644\u0649 \u0627\u0644\u0642\u064A\u0645\u0629 \u0627\u0644\u0645\u0636\u0627\u0641\u0629 \u0648\u0645\u0631\u062C\u0639\u0647 \u0648\u0646\u0647\u0627\u064A\u0629 \u0635\u0644\u0627\u062D\u064A\u062A\u0647 \u0625\u0646 \u0648\u064F\u062C\u062F\u062A\u060C \u062B\u0645 \xAB\u0627\u0644\u0627\u0642\u062A\u0637\u0627\u0639 \u0645\u0646 \u0627\u0644\u0645\u0635\u062F\u0631\xBB (\u0646\u0639\u0645 \u0628\u0627\u0644\u0646\u0633\u0628\u0629 \u0627\u0644\u0642\u0627\u0646\u0648\u0646\u064A\u0629 \u0623\u0648 \u0628\u0646\u0633\u0628\u0629 \u062E\u0627\u0635\u0629\u060C \u0623\u0648 \u0644\u0627) \u0648\xAB\u0627\u0644\u0627\u0642\u062A\u0637\u0627\u0639 \u0645\u0646 \u0627\u0644\u0645\u0635\u062F\u0631 \u0639\u0644\u0649 \u0627\u0644\u0642\u064A\u0645\u0629 \u0627\u0644\u0645\u0636\u0627\u0641\u0629\xBB (\u0646\u0639\u0645 \u0623\u0648 \u0644\u0627)."
            },
            address: {
              term: "\u0627\u0644\u0639\u0646\u0648\u0627\u0646",
              text: "\u0627\u0644\u0639\u0646\u0648\u0627\u0646 \u0648\u0627\u0644\u0628\u0631\u064A\u062F \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A \u0648\u0627\u0644\u0647\u0627\u062A\u0641 \u0648\xAB\u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0625\u0646\u0634\u0627\u0621\xBB (\u062A\u0627\u0631\u064A\u062E \u0625\u0646\u0634\u0627\u0621 \u0627\u0644\u0645\u0644\u0641)."
            },
            edit: {
              term: "\u062A\u0639\u062F\u064A\u0644",
              text: "\u064A\u062D\u0648\u0651\u0644 \u0627\u0644\u0645\u0644\u0641 \u0625\u0644\u0649 \u0648\u0636\u0639 \u0627\u0644\u062A\u0639\u062F\u064A\u0644. \u0644\u0627 \u064A\u0638\u0647\u0631 \u0625\u0644\u0627 \u0625\u0630\u0627 \u0643\u0646\u062A \u062A\u0633\u062A\u0637\u064A\u0639 \u062A\u0639\u062F\u064A\u0644 \u0627\u0644\u062D\u0631\u0641\u0627\u0621 \u0648\u0643\u0627\u0646 \u0627\u0644\u062D\u0631\u064A\u0641 \u063A\u064A\u0631 \u0645\u0624\u0631\u0634\u0641."
            }
          }
        },
        edit: {
          title: "\u062A\u0639\u062F\u064A\u0644 \u0627\u0644\u062D\u0631\u064A\u0641",
          items: {
            fields: {
              term: "\u062D\u0642\u0648\u0644 \u0627\u0644\u0646\u0645\u0648\u0630\u062C",
              text: "\u0647\u064A \u0627\u0644\u062D\u0642\u0648\u0644 \u0646\u0641\u0633\u0647\u0627 \u0627\u0644\u0645\u0633\u062A\u0639\u0645\u0644\u0629 \u0644\u0625\u0646\u0634\u0627\u0621 \u062D\u0631\u064A\u0641: \u0627\u0644\u0647\u0648\u064A\u0629 \u0648\u0627\u0644\u0623\u062F\u0627\u0621 \u0639\u0644\u0649 \u0627\u0644\u0642\u064A\u0645\u0629 \u0627\u0644\u0645\u0636\u0627\u0641\u0629 \u0648\u0627\u0644\u0627\u0642\u062A\u0637\u0627\u0639 \u0648\u0627\u0644\u0639\u0646\u0648\u0627\u0646 \u0648\u0628\u064A\u0627\u0646\u0627\u062A \u0627\u0644\u0627\u062A\u0635\u0627\u0644. \u0648\u064A\u063A\u064A\u0651\u0631 \u0646\u0648\u0639 \u0627\u0644\u062D\u0631\u064A\u0641 \u0627\u0644\u062D\u0642\u0648\u0644 \u0627\u0644\u0645\u0639\u0631\u0648\u0636\u0629."
            },
            save: {
              term: "\u062D\u0641\u0638",
              text: "\u064A\u062D\u0641\u0638 \u0627\u0644\u062A\u063A\u064A\u064A\u0631\u0627\u062A\u061B \u0648\u0625\u0646 \u0644\u0645 \u064A\u062A\u063A\u064A\u0631 \u0634\u064A\u0621 \u064A\u064F\u063A\u0644\u0642 \u0627\u0644\u0646\u0645\u0648\u0630\u062C \u0628\u0628\u0633\u0627\u0637\u0629."
            },
            cancel: {
              term: "\u0625\u0644\u063A\u0627\u0621",
              text: "\u064A\u063A\u0644\u0642 \u0627\u0644\u0646\u0645\u0648\u0630\u062C \u062F\u0648\u0646 \u062D\u0641\u0638 \u0623\u064A \u0634\u064A\u0621."
            },
            stale: {
              term: "\u062A\u0645 \u062A\u0639\u062F\u064A\u0644\u0647 \u0645\u0646 \u0637\u0631\u0641 \u0634\u062E\u0635 \u0622\u062E\u0631",
              text: "\u0625\u0630\u0627 \u0639\u062F\u0651\u0644 \u0634\u062E\u0635 \u0622\u062E\u0631 \u0627\u0644\u0645\u0644\u0641 \u0641\u064A \u0627\u0644\u0648\u0642\u062A \u0646\u0641\u0633\u0647 \u062A\u0630\u0643\u0631 \u0631\u0633\u0627\u0644\u0629 \u0630\u0644\u0643 \u0648\u064A\u064F\u0639\u0627\u062F \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0645\u0644\u0641 \u0648\u064A\u062C\u0628 \u0623\u0646 \u062A\u0637\u0628\u0651\u0642 \u062A\u063A\u064A\u064A\u0631\u0627\u062A\u0643 \u0645\u0646 \u062C\u062F\u064A\u062F."
            }
          }
        },
        contacts: {
          title: "\u062A\u0628\u0648\u064A\u0628 \u062C\u0647\u0627\u062A \u0627\u0644\u0627\u062A\u0635\u0627\u0644",
          items: {
            intro: {
              term: "\u062C\u0647\u0627\u062A \u0627\u0644\u0627\u062A\u0635\u0627\u0644",
              text: "\u0627\u0644\u0623\u0634\u062E\u0627\u0635 \u0627\u0644\u0630\u064A\u0646 \u064A\u0645\u0643\u0646 \u0627\u0644\u0627\u062A\u0635\u0627\u0644 \u0628\u0647\u0645 \u0644\u062F\u0649 \u0647\u0630\u0627 \u0627\u0644\u062D\u0631\u064A\u0641. \u062C\u0647\u0629 \u0627\u062A\u0635\u0627\u0644 \u0648\u0627\u062D\u062F\u0629 \u0641\u0642\u0637 \u0647\u064A \u0627\u0644\u0623\u0633\u0627\u0633\u064A\u0629."
            },
            add: {
              term: "\u0625\u0636\u0627\u0641\u0629 \u062C\u0647\u0629 \u0627\u062A\u0635\u0627\u0644",
              text: "\u064A\u0641\u062A\u062D \u0646\u0627\u0641\u0630\u0629 \u0627\u0644\u0625\u0636\u0627\u0641\u0629. \u0644\u0627 \u064A\u0638\u0647\u0631 \u0625\u0644\u0627 \u0625\u0630\u0627 \u0643\u0646\u062A \u062A\u0633\u062A\u0637\u064A\u0639 \u062A\u0639\u062F\u064A\u0644 \u0627\u0644\u062D\u0631\u064A\u0641 (\u0648\u0625\u0630\u0627 \u0648\u064F\u062C\u062F\u062A \u062C\u0647\u0629 \u0627\u062A\u0635\u0627\u0644 \u0648\u0627\u062D\u062F\u0629 \u0639\u0644\u0649 \u0627\u0644\u0623\u0642\u0644\u061B \u0648\u0625\u0644\u0627 \u0641\u0627\u0644\u0632\u0631 \u0641\u064A \u0631\u0633\u0627\u0644\u0629 \u0627\u0644\u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u0641\u0627\u0631\u063A\u0629)."
            },
            columns: {
              term: "\u0627\u0644\u0627\u0633\u0645\u060C \u0627\u0644\u0648\u0638\u064A\u0641\u0629\u060C \u0627\u0644\u0628\u0631\u064A\u062F \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A\u060C \u0627\u0644\u0647\u0627\u062A\u0641",
              text: "\u0633\u0637\u0631 \u0644\u0643\u0644 \u062C\u0647\u0629 \u0627\u062A\u0635\u0627\u0644. \u062A\u062F\u0644 \u0627\u0644\u0634\u0627\u0631\u0629 \xAB\u0623\u0633\u0627\u0633\u064A\u0629\xBB \u0639\u0644\u0649 \u062C\u0647\u0629 \u0627\u0644\u0627\u062A\u0635\u0627\u0644 \u0627\u0644\u0623\u0633\u0627\u0633\u064A\u0629\u061B \u0648\xAB\u2014\xBB \u062A\u0639\u0646\u064A \u0623\u0646 \u0627\u0644\u0645\u0639\u0644\u0648\u0645\u0629 \u063A\u064A\u0631 \u0645\u0648\u062C\u0648\u062F\u0629."
            },
            actions: {
              term: "\u0627\u0644\u0625\u062C\u0631\u0627\u0621\u0627\u062A",
              text: "\u0627\u0644\u0632\u0631 \u0630\u0648 \u0627\u0644\u0646\u0642\u0627\u0637 \u0627\u0644\u062B\u0644\u0627\u062B \u0641\u064A \u0643\u0644 \u0633\u0637\u0631 \u064A\u0641\u062A\u062D \u0642\u0627\u0626\u0645\u0629: \xAB\u062A\u0639\u062F\u064A\u0644\xBB \u0648\xAB\u062A\u0639\u064A\u064A\u0646 \u0643\u0623\u0633\u0627\u0633\u064A\u0629\xBB (\u0645\u0627 \u0639\u062F\u0627 \u062C\u0647\u0629 \u0627\u0644\u0627\u062A\u0635\u0627\u0644 \u0627\u0644\u0623\u0633\u0627\u0633\u064A\u0629) \u0648\xAB\u062D\u0630\u0641\xBB (\u0628\u0639\u062F \u0627\u0644\u062A\u0623\u0643\u064A\u062F)."
            },
            empty: {
              term: "\u0644\u0627 \u062A\u0648\u062C\u062F \u062C\u0647\u0627\u062A \u0627\u062A\u0635\u0627\u0644",
              text: "\u0631\u0633\u0627\u0644\u0629 \u0627\u0644\u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u0641\u0627\u0631\u063A\u0629: \u0623\u0636\u0641 \u0627\u0644\u0634\u062E\u0635 \u0627\u0644\u0630\u064A \u062A\u0648\u062C\u064E\u0651\u0647 \u0625\u0644\u064A\u0647 \u0639\u0631\u0648\u0636 \u0627\u0644\u0623\u0633\u0639\u0627\u0631 \u0648\u0627\u0644\u0641\u0648\u0627\u062A\u064A\u0631."
            }
          }
        },
        contactDialog: {
          title: "\u062C\u0647\u0629 \u0627\u062A\u0635\u0627\u0644 \u062C\u062F\u064A\u062F\u0629 / \u062A\u0639\u062F\u064A\u0644 \u062C\u0647\u0629 \u0627\u0644\u0627\u062A\u0635\u0627\u0644",
          items: {
            name: {
              term: "\u0627\u0644\u0627\u0633\u0645",
              text: "\u0625\u062C\u0628\u0627\u0631\u064A: \u0627\u0633\u0645 \u0627\u0644\u0634\u062E\u0635."
            },
            role: {
              term: "\u0627\u0644\u0648\u0638\u064A\u0641\u0629",
              text: "\u0627\u062E\u062A\u064A\u0627\u0631\u064A\u060C \u0645\u062B\u0644\u064B\u0627 \u0645\u062F\u064A\u0631 \u0641\u0646\u064A \u0623\u0648 \u0645\u0643\u0644\u0641 \u0628\u0627\u0644\u0645\u0634\u0631\u0648\u0639."
            },
            email: {
              term: "\u0627\u0644\u0628\u0631\u064A\u062F \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A",
              text: "\u0627\u062E\u062A\u064A\u0627\u0631\u064A: \u0647\u0648 \u0627\u0644\u0639\u0646\u0648\u0627\u0646 \u0627\u0644\u0645\u0633\u062A\u0639\u0645\u0644 \u0644\u0625\u0631\u0633\u0627\u0644 \u0639\u0631\u0636 \u0645\u0627\u0644\u064A \u0625\u0644\u0649 \u062C\u0647\u0629 \u0627\u0644\u0627\u062A\u0635\u0627\u0644 \u0647\u0630\u0647."
            },
            phone: {
              term: "\u0627\u0644\u0647\u0627\u062A\u0641",
              text: "\u0627\u062E\u062A\u064A\u0627\u0631\u064A\u060C \u0645\u062B\u0644\u064B\u0627 \u2066+216 71 000 000\u2069."
            },
            primary: {
              term: "\u062C\u0647\u0629 \u0627\u0644\u0627\u062A\u0635\u0627\u0644 \u0627\u0644\u0623\u0633\u0627\u0633\u064A\u0629",
              text: "\u062E\u0627\u0646\u0629 \u0627\u062E\u062A\u064A\u0627\u0631: \u062C\u0647\u0629 \u0627\u062A\u0635\u0627\u0644 \u0623\u0633\u0627\u0633\u064A\u0629 \u0648\u0627\u062D\u062F\u0629 \u0644\u0643\u0644 \u062D\u0631\u064A\u0641\u061B \u0648\u062A\u062D\u062F\u064A\u062F\u0647\u0627 \u064A\u0639\u0648\u0651\u0636 \u0627\u0644\u0633\u0627\u0628\u0642\u0629."
            },
            save: {
              term: "\u062D\u0641\u0638",
              text: "\u064A\u062D\u0641\u0638 \u062C\u0647\u0629 \u0627\u0644\u0627\u062A\u0635\u0627\u0644. \xAB\u0625\u0644\u063A\u0627\u0621\xBB \u064A\u063A\u0644\u0642 \u0627\u0644\u0646\u0627\u0641\u0630\u0629."
            }
          }
        },
        otherTabs: {
          title: "\u062A\u0628\u0648\u064A\u0628\u0627 \u0627\u0644\u0645\u0634\u0627\u0631\u064A\u0639 \u0648\u0627\u0644\u0641\u0648\u0627\u062A\u064A\u0631",
          items: {
            projects: {
              term: "\u0627\u0644\u0645\u0634\u0627\u0631\u064A\u0639",
              text: "\u0641\u064A \u0627\u0644\u0648\u0642\u062A \u0627\u0644\u062D\u0627\u0644\u064A \u064A\u0639\u0644\u0646 \u0647\u0630\u0627 \u0627\u0644\u062A\u0628\u0648\u064A\u0628 \u0623\u0646 \u0645\u0634\u0627\u0631\u064A\u0639 \u0647\u0630\u0627 \u0627\u0644\u062D\u0631\u064A\u0641 \u0633\u062A\u062A\u0648\u0641\u0631 \u0642\u0631\u064A\u0628\u064B\u0627."
            },
            invoices: {
              term: "\u0627\u0644\u0641\u0648\u0627\u062A\u064A\u0631",
              text: "\u0641\u064A \u0627\u0644\u0648\u0642\u062A \u0627\u0644\u062D\u0627\u0644\u064A \u064A\u0639\u0644\u0646 \u0647\u0630\u0627 \u0627\u0644\u062A\u0628\u0648\u064A\u0628 \u0623\u0646 \u0627\u0644\u0639\u0631\u0648\u0636 \u0627\u0644\u0645\u0627\u0644\u064A\u0629 \u0648\u0627\u0644\u0641\u0648\u0627\u062A\u064A\u0631 \u0627\u0644\u062E\u0627\u0635\u0629 \u0628\u0647\u0630\u0627 \u0627\u0644\u062D\u0631\u064A\u0641 \u0633\u062A\u062A\u0648\u0641\u0631 \u0642\u0631\u064A\u0628\u064B\u0627. \u0648\u0641\u064A \u0627\u0644\u0623\u062B\u0646\u0627\u0621 \u062A\u062C\u062F\u0647\u0627 \u0641\u064A \u0642\u0633\u0645 \u0627\u0644\u0645\u0627\u0644\u064A\u0629."
            }
          }
        }
      }
    }
  }
};

// locales/en/guide.json
var guide_default2 = {
  drawer: {
    title: "Page guide",
    close: "Close the guide",
    loading: "Loading the guide\u2026",
    missing: "This page has no detailed guide yet: here is the general BatiFlow guide.",
    purpose: "What this page is for",
    search: "Search this guide",
    stats: "{sections, plural, one {# section} other {# sections}} \xB7 {items, plural, one {# item} other {# items}}",
    results: "{count, plural, =0 {No result} one {# result} other {# results}}",
    contents: "On this page",
    count: "{count, plural, one {# item} other {# items}}",
    columnTerm: "Item",
    columnText: "What to know",
    noResults: "Nothing in the guide matches your search.",
    clearSearch: "Clear the search",
    escKey: "Esc",
    escHint: "to close the guide"
  },
  pages: {
    projects: {
      title: "Projects",
      intro: "The list of all the office's projects. Use it to find a project, see how far along it is and, if you are allowed to, create a new one.",
      sections: {
        header: {
          title: "Projects",
          items: {
            newProject: {
              term: "New project",
              text: "Button at the top right, shown only to people allowed to create a project. It opens the creation window. It is greyed out if the office's account is read-only."
            },
            grid: {
              term: "Grid",
              text: "Shows the projects as cards: one card per project, with its name, status, code, client and phase progress."
            },
            list: {
              term: "List",
              text: "Shows the projects as a table, one row per project. Your choice is kept in the page address."
            },
            loadMore: {
              term: "Show more projects",
              text: 'Appears under the list when more projects are left to show. The text becomes "Loading\u2026" while the rest arrives.'
            }
          }
        },
        filters: {
          title: "Filter projects",
          items: {
            search: {
              term: "Search projects",
              text: "Type part of the project name or code. The list updates as soon as you stop typing."
            },
            status: {
              term: "Filter by status",
              text: 'Keeps only the projects with one status: Draft, In progress, On hold, Closed or Archived. Choose "All statuses" to see everything again.'
            },
            missionType: {
              term: "Filter by mission type",
              text: 'Keeps only the projects of one mission type, for example "Private villa". Choose "All mission types" to see everything again.'
            },
            client: {
              term: "Filter by client",
              text: `Keeps only the projects of one client. The list offers the office's clients; "All clients" removes the filter.`
            },
            mine: {
              term: "My projects only",
              text: "A switch that keeps only the projects you are a member of."
            },
            clear: {
              term: "Clear filters",
              text: "Appears when no project matches: removes the search and all the filters at once."
            }
          }
        },
        projectsList: {
          title: "Project list",
          items: {
            name: {
              term: "Project",
              text: "The project name. Click it to open the project (its Posts tab opens first)."
            },
            code: {
              term: "Code",
              text: "The project code, for example 2026-014. It is always read left to right."
            },
            client: {
              term: "Client",
              text: 'The client (project owner: the person or body the project is carried out for). "No client" if none is chosen yet.'
            },
            missionType: {
              term: "Mission type",
              text: "The project's mission type (public building, villa, expert assessment\u2026). In the grid it follows the code on the same line."
            },
            status: {
              term: "Status",
              text: "A coloured chip that tells where the project stands: Draft, In progress, On hold, Closed or Archived."
            },
            phase: {
              term: "Phases",
              text: 'Phase progress: "Phases closed: 2 / 7" and the current phase. The grid adds a progress bar. "No phases" when there are none yet, "All phases are closed" when everything is done.'
            }
          }
        },
        statuses: {
          title: "Project statuses",
          items: {
            draft: {
              term: "Draft",
              text: "The project is being prepared: it has not started yet."
            },
            active: {
              term: "In progress",
              text: "The project is under way."
            },
            onHold: {
              term: "On hold",
              text: "The project is temporarily suspended; it can resume."
            },
            closed: {
              term: "Closed",
              text: "The mission is finished. The project can be reopened if needed."
            },
            archived: {
              term: "Archived",
              text: 'The project is put away: it no longer shows in lists, except with the "Archived" filter.'
            }
          }
        },
        missionTypes: {
          title: "Mission types",
          items: {
            publicBuilding: {
              term: "Public building",
              text: "A school, town hall, clinic or any other building made for a public body."
            },
            collectiveHousing: {
              term: "Collective housing",
              text: "A block or residence with several homes."
            },
            villa: {
              term: "Private villa",
              text: "A house built for a single family."
            },
            industrial: {
              term: "Industrial building",
              text: "A factory, warehouse or workshop."
            },
            facility: {
              term: "Facility",
              text: "A community facility, for example for sport, culture or health."
            },
            subdivisionVrd: {
              term: "Subdivision and utilities (VRD)",
              text: "Dividing a plot of land into lots, with roads and utilities (VRD: roads, water, drainage, electricity)."
            },
            expertise: {
              term: "Expert assessment",
              text: "A technical opinion mission, without designing a new building."
            }
          }
        },
        newDialog: {
          title: "New project",
          items: {
            missionType: {
              term: "Mission type",
              text: "Required. Choose it first: the project starts with the usual phases, folders and tasks of that type."
            },
            template: {
              term: "What this template contains",
              text: "A preview under the mission type: the phases in order (with their indicative fee share if you may see it), then the number of folders created, starter tasks and discussion channels. If the preview cannot load, you can still create the project."
            },
            name: {
              term: "Project name",
              text: 'Required, 200 characters at most. Example: "Kairouan pilot high school".'
            },
            code: {
              term: "Project code",
              text: "Optional, 30 characters at most (letters, digits and . _ / -). If left empty, a code is generated, for example 2026-014. A code already used by another project is refused."
            },
            client: {
              term: "Client (project owner)",
              text: 'Optional: choose a client of the office, or "No client yet". You can add it later.'
            },
            governorate: {
              term: "Governorate",
              text: 'Optional: the governorate where the project is located. "Not specified" by default.'
            },
            startsOn: {
              term: "Start date",
              text: "Optional. With a date, each phase gets indicative dates, one after the other."
            },
            submit: {
              term: "Create project",
              text: 'Creates the project and opens its page straight away. "Cancel" closes the window without creating anything. Missing required fields are flagged in red.'
            }
          }
        },
        leftPane: {
          title: "My projects",
          items: {
            myProjects: {
              term: "My projects",
              text: 'The left pane lists the projects you take part in, with their code. Click a name to open the project; the open project is highlighted. With no project, you read "You are not on any project yet."'
            },
            seeAll: {
              term: "All projects",
              text: "A link under the list that brings you back to this page."
            },
            sharedSpaces: {
              term: "Shared spaces",
              text: 'Below it, your spaces shared with other organisations; a space of another organisation carries the label "Hosted by \u2026". The "All shared spaces" link lists them all.'
            }
          }
        },
        empty: {
          title: "Status messages",
          items: {
            none: {
              term: "No projects yet",
              text: 'Shown when the office has no project yet. If you can create projects, a "New project" button is offered; otherwise ask a manager to add you to a project.'
            },
            noMatch: {
              term: "No matching projects",
              text: 'Shown when the search or the filters find nothing. Try another name or status, or use "Clear filters".'
            },
            loadFailed: {
              term: "Projects could not be loaded",
              text: 'A red message when there is a connection problem. Check your connection, then click "Try again".'
            }
          }
        }
      }
    },
    project: {
      posts: {
        title: "Posts",
        intro: "The tab for the project's conversations. For now it only announces what it will contain: discussions by discipline.",
        sections: {
          summary: {
            title: "Project summary",
            items: {
              breadcrumb: {
                term: "Projects",
                text: 'The breadcrumb at the top of the page. Click "Projects" to go back to the list; next to it you see the name of the open project.'
              },
              meeting: {
                term: "Start a meeting",
                text: "Button at the top right, for project members who can contribute. It asks for the meeting title, then opens the meeting room."
              },
              code: {
                term: "Code",
                text: "The project code, used on its documents and invoices."
              },
              client: {
                term: "Client",
                text: `The project's client (project owner), or "No client" if not filled in yet.`
              },
              status: {
                term: "Status",
                text: "A chip with the project's state: Draft, In progress, On hold, Closed or Archived. It is changed in the Settings tab."
              },
              progress: {
                term: "Phases closed: 2 / 7",
                text: 'A progress bar and the number of closed phases, with the current phase. When everything is done you read "All phases are closed".'
              },
              tabs: {
                term: "Posts, Files, Tasks, Phases, Deliverables, Approvals, Calendar, Finance, Settings",
                text: "The project's tabs. The open tab is kept in the page address. Finance only appears for people who have access to quotes, invoices or contracts."
              },
              notFound: {
                term: "Project not found",
                text: 'Shown if the project does not exist or you are not a member; the "Back to projects" button takes you back to the list. With a connection problem, "The project could not be loaded" offers "Try again".'
              }
            }
          },
          meeting: {
            title: "Start a meeting",
            items: {
              titleField: {
                term: "Meeting title",
                text: 'Required, 200 characters at most. It is pre-filled with "Meeting - " followed by the project name.'
              },
              start: {
                term: "Start",
                text: "Creates the meeting and takes you to its room. Project members can join it."
              },
              cancel: {
                term: "Cancel",
                text: "Closes the window without creating a meeting."
              }
            }
          },
          placeholder: {
            title: "Project conversations will appear here",
            items: {
              message: {
                term: "Project conversations will appear here",
                text: "Message shown in the middle of the tab: the project's discussions are not yet available in this tab."
              },
              channels: {
                term: "Discussion channels by discipline",
                text: "They are announced by discipline (architecture, structure, utilities\u2026): their posts will appear in this tab."
              }
            }
          }
        }
      },
      files: {
        title: "Files",
        intro: "All the project's documents, filed in folders. You add files, find a document, follow its versions and request its approval.",
        sections: {
          summary: {
            title: "Project summary",
            items: {
              breadcrumb: {
                term: "Projects",
                text: 'The breadcrumb at the top of the page. Click "Projects" to go back to the list; next to it you see the name of the open project.'
              },
              meeting: {
                term: "Start a meeting",
                text: "Button at the top right, for project members who can contribute. It asks for the meeting title, then opens the meeting room."
              },
              code: {
                term: "Code",
                text: "The project code, used on its documents and invoices."
              },
              client: {
                term: "Client",
                text: `The project's client (project owner), or "No client" if not filled in yet.`
              },
              status: {
                term: "Status",
                text: "A chip with the project's state: Draft, In progress, On hold, Closed or Archived."
              },
              progress: {
                term: "Phases closed: 2 / 7",
                text: "A progress bar and the number of closed phases, with the current phase."
              },
              tabs: {
                term: "Posts, Files, Tasks, Phases, Deliverables, Approvals, Calendar, Finance, Settings",
                text: `The project's tabs. You are on "Files".`
              },
              noSpace: {
                term: "The file space is not ready yet",
                text: "Shown if the project's internal space has not been created yet. Try again in a moment or contact a project manager."
              }
            }
          },
          folders: {
            title: "Project folders",
            items: {
              tree: {
                term: "Project folders",
                text: 'The folder tree, on the left. "All folders" is the project root; click a folder to open it.'
              },
              path: {
                term: "Folder path",
                text: 'The path of the open folder, at the top of the content. Click a level to go back up to it. A folder you cannot access appears as "\u2026".'
              },
              subfolders: {
                term: "Subfolders",
                text: "The list of folders inside the open folder. Click one to open it."
              },
              newFolder: {
                term: "New folder",
                text: "Creates a folder inside the open folder (or at the root). Only for people who can write there; at the root, only for project managers."
              },
              customRights: {
                term: "Custom permissions",
                text: "A label with a padlock: this folder has its own list of allowed people, different from its parent folder's or the project's."
              },
              more: {
                term: "More actions",
                text: 'The "\u2026" button of a folder, for its managers. It offers Rename\u2026, Move\u2026, Permissions\u2026 and Delete.'
              },
              trash: {
                term: "Trash",
                text: 'A button under the tree: shows the deleted folders and documents instead of the files. Click again, or "Back to files", to return.'
              },
              empty: {
                term: "No folders yet",
                text: 'Shown when the project has no folder. A manager can create the first one, or give you access. In a folder with no subfolder, you read "This folder has no subfolders yet."'
              }
            }
          },
          upload: {
            title: "Adding files",
            items: {
              zone: {
                term: "Drag and drop files or folders here",
                text: 'An area shown in a folder where you can write. Drop files on it: "Drop to add to this folder" appears while dragging. The files of a dropped folder are added straight into the open folder.'
              },
              addFiles: {
                term: "Add files",
                text: "Opens the file picker of your computer. The maximum size per file is shown under the area."
              },
              addFolder: {
                term: "Add a folder",
                text: "Adds the whole content of a folder from your computer."
              },
              progress: {
                term: "Files being added",
                text: "The list of uploads, with a progress bar: Sending, Virus check in progress, Added to the folder, Refused or Sending failed. A plain reason is given when a file is refused, for example a file type that is not accepted or an empty file."
              },
              controls: {
                term: "Cancel, Remove, Retry",
                text: '"Cancel" stops an upload in progress, "Remove" takes a finished line off the list, and the retry button restarts a failed upload.'
              },
              infoDialog: {
                term: "Document information",
                text: "A window that opens after you choose files: Discipline, Phase, Document type, Zone, Scale and the Title of each document. They file the document and build its code; you can change them later."
              },
              skip: {
                term: "Add without information",
                text: `Adds the files without filling in this information. The document's code is then assigned later, once it is filled in. The other button is called "Add the document" or "Add 3 documents".`
              },
              codePreview: {
                term: "Planned code",
                text: "The code the document will get. The ### signs are replaced by the sequence number, assigned when the file is added."
              }
            }
          },
          documents: {
            title: "Documents",
            items: {
              search: {
                term: "Search documents",
                text: "Type part of the code or title; the list updates as soon as you stop typing."
              },
              filters: {
                term: "Discipline, Phase, Document type",
                text: 'Three filters shaped as buttons. Each offers "All" or a value, and shows your choice in the button.'
              },
              clear: {
                term: "Clear filters",
                text: 'Removes the search and the filters. If nothing matches, "No document matches" offers the same button.'
              },
              select: {
                term: "Select",
                text: 'Check boxes in front of each row; the one in the header selects all displayed documents. An action bar appears with "2 documents selected".'
              },
              move: {
                term: "Move to\u2026",
                text: 'Moves the selected documents to another folder: open the destination folder, then "Move here". Documents cannot stay at the project root.'
              },
              delete: {
                term: "Delete",
                text: "Moves the selected documents to the trash, after confirmation. These two buttons only appear if you may act on all the chosen documents."
              },
              clearSelection: {
                term: "Clear selection",
                text: "Removes the selection."
              },
              count: {
                term: "Show more documents",
                text: 'Under the list: "20 documents shown", and this button when there are more. "No documents yet" is shown in an empty folder.'
              }
            }
          },
          columns: {
            title: "Document list columns",
            items: {
              code: {
                term: "Code",
                text: `The document's code. Click the header to sort. "Information missing" means the code is not assigned yet.`
              },
              title: {
                term: "Title",
                text: "The document's title. Click it to open its details panel. The header lets you sort."
              },
              index: {
                term: "Index",
                text: "The version letter of a drawing or document (A, B, C\u2026). It changes with each new version."
              },
              disciplinePhase: {
                term: "Discipline and Phase",
                text: "The discipline (Architecture, Structure, Roads and utilities (VRD), Fluids (MEP), Electrical, Surveying, Geotechnics, Site coordination (OPC)) and the project phase the document belongs to."
              },
              status: {
                term: "Status",
                text: "The state of the file: Uploading, Antivirus check, Available or Refused."
              },
              approval: {
                term: "Approval",
                text: 'An "In approval" chip when an approval workflow is running on the document.'
              },
              modified: {
                term: "Modified",
                text: "The date of the last change. The header lets you sort; by default, the most recent first."
              },
              author: {
                term: "Author organisation",
                text: 'The organisation that added the document, or "Partner" for a partner organisation.'
              }
            }
          },
          panel: {
            title: "Document",
            items: {
              open: {
                term: "Open",
                text: "Opens the document in the viewer."
              },
              edit: {
                term: "Edit",
                text: "Lets you change the title, discipline, phase, type, zone and scale, for people who can edit the document."
              },
              details: {
                term: "Details",
                text: "The panel on the right: code, title, index, discipline, phase, type, zone, scale, status, author organisation and modification date."
              },
              locked: {
                term: "This document is in an approval workflow",
                text: "An information message: as long as the approval workflow has not ended or been cancelled, the document cannot receive a new version."
              },
              deliverables: {
                term: "Linked deliverables",
                text: 'The project deliverables this document is attached to, or "No linked deliverable".'
              },
              versions: {
                term: "Versions and new version",
                text: 'The history, newest first: index, "Current version", author, date, code and SHA-256 fingerprint (a signature that proves the file has not changed, copied with one click). The "New version" button adds a file as the next version, with the next index; you follow the upload under the file upload area.'
              },
              restore: {
                term: "Restore",
                text: "Puts an older version back in service by adding it as a new version. A reason of at least 3 characters is required; the history is kept."
              },
              approval: {
                term: "Request approval",
                text: 'In the "Approval" block. The window offers to use a template of the office or to build the steps yourself (reviewers, in order or in parallel), with an optional due date, then "Send the request". While the workflow runs, the document is locked.'
              }
            }
          },
          dialogs: {
            title: "Folder and document windows",
            items: {
              newFolder: {
                term: "New folder",
                text: 'Asks for the folder name (200 characters at most, no slash), then "Create". The window states the place: "At the root of the project" or "In: \u2026".'
              },
              rename: {
                term: "Rename the folder",
                text: 'Asks for the new name, then "Rename". Two folders cannot have the same name in the same place.'
              },
              move: {
                term: "Move here",
                text: 'To move a folder: open the destination folder, using "Go up one level" if needed, then click this button. A folder cannot go into one of its own subfolders.'
              },
              permissions: {
                term: "Permissions",
                text: 'Choose to inherit the rights of the parent folder (or of the project), or to list the allowed people yourself. Each is Reader or Editor. "Add all members of the office" gives access to everyone.'
              },
              deleteFolder: {
                term: "Delete the folder",
                text: "After confirmation, the folder and its subfolders go to the trash. A folder that holds a document that must be kept (legal obligation) cannot be deleted."
              },
              deleteDocuments: {
                term: "Delete documents",
                text: "A confirmation before moving the chosen documents to the trash; the window lists their names."
              },
              moveDocuments: {
                term: "Move the document",
                text: 'Same principle as for a folder: open the destination folder, then "Move here".'
              },
              newVersionDialog: {
                term: "File",
                text: 'In the "New version" window: choose the file, then "Add the version".'
              }
            }
          },
          trash: {
            title: "Trash",
            items: {
              intro: {
                term: "Trash",
                text: "Deleted folders and documents stay there for a number of days, then are removed for good. Managers see everything; everyone else sees what they deleted."
              },
              back: {
                term: "Back to files",
                text: "Closes the trash and reopens your folders."
              },
              line: {
                term: "Deleted items",
                text: "Each line says who deleted it and when, what a folder contains, and the date it will be removed for good."
              },
              restore: {
                term: "Restore",
                text: "Puts the item back in its place. If the folder that held it is in the trash too, restore that folder first."
              },
              purge: {
                term: "Delete for good",
                text: "Erases the item with all its versions and files, after confirmation. This cannot be undone."
              },
              empty: {
                term: "The trash is empty",
                text: "Shown when nothing has been deleted recently."
              }
            }
          }
        }
      },
      tasks: {
        title: "Tasks",
        intro: "The work to do on the project: you create tasks, give them to people, and follow their progress as a list or a board.",
        sections: {
          summary: {
            title: "Project summary",
            items: {
              breadcrumb: {
                term: "Projects",
                text: 'The breadcrumb at the top of the page. Click "Projects" to go back to the list; next to it you see the name of the open project.'
              },
              meeting: {
                term: "Start a meeting",
                text: "Button at the top right, for project members who can contribute. It asks for the meeting title, then opens the meeting room."
              },
              code: {
                term: "Code",
                text: "The project code, used on its documents and invoices."
              },
              client: {
                term: "Client",
                text: `The project's client (project owner), or "No client" if not filled in yet.`
              },
              status: {
                term: "Status",
                text: "A chip with the project's state: Draft, In progress, On hold, Closed or Archived."
              },
              progress: {
                term: "Phases closed: 2 / 7",
                text: "A progress bar and the number of closed phases, with the current phase."
              },
              tabs: {
                term: "Posts, Files, Tasks, Phases, Deliverables, Approvals, Calendar, Finance, Settings",
                text: `The project's tabs. You are on "Tasks".`
              }
            }
          },
          toolbar: {
            title: "Task view",
            items: {
              list: {
                term: "List",
                text: "The tasks as a table, one row per task. This is the default view."
              },
              board: {
                term: "Board",
                text: "The tasks in columns, one column per status (like a Kanban board). Drag a card from one column to another to change its status; if the move fails, the card goes back to its place."
              },
              newTask: {
                term: "New task",
                text: "Opens the creation window. Only for members who can contribute to the project; the others can only view."
              },
              loadMore: {
                term: "Show more tasks",
                text: "Appears under the list when more tasks are left to show."
              }
            }
          },
          filters: {
            title: "Task filters",
            items: {
              search: {
                term: "Search for a task",
                text: "Type part of the title. The list updates as soon as you stop typing."
              },
              assignee: {
                term: "Assignee",
                text: 'Keeps only the tasks given to one person. "All assignees" removes the filter.'
              },
              status: {
                term: "Status",
                text: "Keeps only the tasks To do, In progress, Blocked or Done."
              },
              discipline: {
                term: "Discipline",
                text: "Keeps only the tasks of one discipline (Architecture, Structure, Roads and utilities (VRD)\u2026)."
              },
              phase: {
                term: "Phase",
                text: "Keeps only the tasks linked to one phase of the project."
              },
              dueBefore: {
                term: "Due before",
                text: "Choose a date to see only the tasks due before that day."
              },
              clear: {
                term: "Clear filters",
                text: "Removes all the filters at once."
              }
            }
          },
          list: {
            title: "Project tasks",
            items: {
              title: {
                term: "Task",
                text: "The task title. Click it to open its details panel on the right."
              },
              status: {
                term: "Status",
                text: "To do, In progress, Blocked or Done."
              },
              priority: {
                term: "Priority",
                text: "Low, Normal, High or Urgent."
              },
              assignees: {
                term: "Assignees",
                text: 'The people in charge of the task, or "Nobody".'
              },
              phaseDiscipline: {
                term: "Phase and Discipline",
                text: 'The project phase and the discipline of the task, or "No phase" and "No discipline".'
              },
              due: {
                term: "Due",
                text: 'The deadline, or "No due date". The word "overdue" appears when the date has passed.'
              },
              checklist: {
                term: "Checklist",
                text: `The progress of the task's small items to tick, for example "2 of 5 done", or "None".`
              }
            }
          },
          board: {
            title: "Task board",
            items: {
              todo: {
                term: "To do",
                text: "The tasks not started yet."
              },
              inProgress: {
                term: "In progress",
                text: "The tasks someone is working on."
              },
              blocked: {
                term: "Blocked",
                text: "The tasks waiting for something before they can move on."
              },
              done: {
                term: "Done",
                text: "The finished tasks."
              },
              card: {
                term: "Card",
                text: "Each card shows the title, assignees, due date and checklist. Click it to open the task."
              }
            }
          },
          newDialog: {
            title: "New task",
            items: {
              title: {
                term: "Title",
                text: "Required, 200 characters at most."
              },
              phase: {
                term: "Phase",
                text: 'Optional: attaches the task to a phase of the project ("No phase" by default).'
              },
              discipline: {
                term: "Discipline",
                text: 'Optional ("No discipline" by default).'
              },
              priority: {
                term: "Priority",
                text: "Low, Normal, High or Urgent."
              },
              due: {
                term: "Due",
                text: "Optional: the deadline."
              },
              assignees: {
                term: "Assignees",
                text: "Optional: choose one or more people among the project members."
              },
              parent: {
                term: "Parent task",
                text: 'Choose a task to create a subtask. A subtask cannot have subtasks. "None (main task)" by default.'
              },
              submit: {
                term: "Create task",
                text: 'Creates the task. "Cancel" closes the window.'
              }
            }
          },
          panel: {
            title: "Task",
            items: {
              fields: {
                term: "Title, Status, Priority, Phase, Discipline, Due, Assignees",
                text: `The task's information, editable by members who can contribute. The others only read: "You can view this task but not change it".`
              },
              description: {
                term: "Description",
                text: 'The detailed text of the task. "Edit the description" opens an editor; if you leave without saving, a window asks you to confirm.'
              },
              checklist: {
                term: "Checklist",
                text: "Small items to tick: add an item, rename it, delete it."
              },
              dependencies: {
                term: "Dependencies",
                text: "The tasks to finish before this one. A dependency that would create a loop is refused."
              },
              subtasks: {
                term: "Subtasks",
                text: 'The child tasks of this one; add some with "Add a subtask".'
              },
              comments: {
                term: "Comments",
                text: 'The exchanges about the task. Type @ to mention a project member; "Post comment" sends it. You can edit or delete your own.'
              },
              delete: {
                term: "Delete task",
                text: "Deletes the task with its checklist, subtasks and comments, after confirmation."
              },
              notFound: {
                term: "Task not found",
                text: "Shown if the task was deleted or you no longer have access to it."
              }
            }
          },
          empty: {
            title: "Status messages",
            items: {
              none: {
                term: "No tasks yet",
                text: 'Shown when the project has no task. Members who can contribute get a "New task" button.'
              },
              noMatch: {
                term: "No task matches",
                text: "Shown when the filters find nothing: change or clear them."
              },
              loadFailed: {
                term: "The tasks could not be loaded",
                text: 'A red message with a connection problem: check it, then click "Try again".'
              }
            }
          }
        }
      },
      phases: {
        title: "Phases",
        intro: "How the mission unfolds, from sketch to acceptance: planned and actual dates, delays and each phase's share of the fees. Project managers edit them; the others read them.",
        sections: {
          summary: {
            title: "Project summary",
            items: {
              breadcrumb: {
                term: "Projects",
                text: 'The breadcrumb at the top of the page. Click "Projects" to go back to the list; next to it you see the name of the open project.'
              },
              meeting: {
                term: "Start a meeting",
                text: "Button at the top right, for project members who can contribute. It asks for the meeting title, then opens the meeting room."
              },
              code: {
                term: "Code",
                text: "The project code, used on its documents and invoices."
              },
              client: {
                term: "Client",
                text: `The project's client (project owner), or "No client" if not filled in yet.`
              },
              status: {
                term: "Status",
                text: "A chip with the project's state: Draft, In progress, On hold, Closed or Archived."
              },
              progress: {
                term: "Phases closed: 2 / 7",
                text: "A progress bar and the number of closed phases, with the current phase."
              },
              tabs: {
                term: "Posts, Files, Tasks, Phases, Deliverables, Approvals, Calendar, Finance, Settings",
                text: `The project's tabs. You are on "Phases".`
              }
            }
          },
          overview: {
            title: "Phases",
            items: {
              add: {
                term: "Add a phase",
                text: "Button reserved for project managers. It opens the add window."
              },
              readOnly: {
                term: "Only the project's managers can change the phases.",
                text: "A blue message shown to the other members, who can only view."
              },
              timeline: {
                term: "Project phase timeline",
                text: "A diagram of the phases with their planned and actual dates and a marker for today. Click a phase to open its panel."
              },
              total: {
                term: "Total of the fee shares per phase",
                text: "Under the table, for people who may see the fees: the sum of each phase's share."
              },
              warning: {
                term: "Fee shares to check",
                text: "An orange message when the total is not 100%. It does not block anything: adjust them when you wish."
              },
              empty: {
                term: "This project has no phases yet",
                text: "Shown when there is no phase. A manager can add the first one; the others wait for it to be added."
              },
              loadFailed: {
                term: "Could not load the phases",
                text: 'A red message with a connection problem: check it, then "Try again".'
              }
            }
          },
          table: {
            title: "Project phases",
            items: {
              order: {
                term: "No.",
                text: "The phase's order number."
              },
              phase: {
                term: "Phase",
                text: "The phase name: ESQ (sketch design), APS (preliminary design), APD (detailed design), PRO (project design), DCE (tender documents), ACT (assistance with works contracts), DET (works supervision), AOR (assistance with acceptance), or a custom phase."
              },
              dates: {
                term: "Planned and Actual",
                text: "The planned start and end dates, then the ones actually recorded (a dash when unknown)."
              },
              status: {
                term: "Status",
                text: "Not started, In progress, In review or Closed."
              },
              schedule: {
                term: "Timing",
                text: 'Says whether the phase keeps its dates, for example "On track" or "5 days late".'
              },
              share: {
                term: "Fees",
                text: "The phase's share of the fees, as a percentage. This column only appears for people who may see the fees."
              },
              actions: {
                term: "Actions",
                text: "Move up or Move down a phase to change the order, then Edit (or View for a closed phase or if you are not a manager) and Close phase. These buttons carry the phase name for screen readers."
              }
            }
          },
          statuses: {
            title: "Statuses and timing",
            items: {
              notStarted: {
                term: "Not started",
                text: "The phase has not begun."
              },
              inProgress: {
                term: "In progress",
                text: "The phase is under way."
              },
              inReview: {
                term: "In review",
                text: "The work is finished and is being reviewed before closing."
              },
              closed: {
                term: "Closed",
                text: "The phase is finished and can no longer be edited."
              },
              onTrack: {
                term: "On track",
                text: 'The phase keeps its planned dates. "Not scheduled" means no date is planned.'
              },
              lateStart: {
                term: "Start 3 days late",
                text: "The planned start date has passed while the phase has not started: the number of days late is shown."
              },
              overdue: {
                term: "3 days late",
                text: "The planned end date has passed while the phase is not finished."
              },
              done: {
                term: "Done on time",
                text: 'The phase finished in time. "Done 3 days late" says the opposite.'
              }
            }
          },
          panel: {
            title: "Phase details",
            items: {
              name: {
                term: "Phase name",
                text: "Only custom phases have a name to enter (120 characters at most)."
              },
              status: {
                term: "Status",
                text: 'A phase follows the order: not started, in progress, in review. To finish it, use "Close phase\u2026".'
              },
              dates: {
                term: "Planned start, Planned end, Actual start, Actual end",
                text: "Four dates. An end cannot be before its matching start."
              },
              share: {
                term: "Fee share",
                text: "As a percentage of the fees, for example 12.5 (between 0 and 100, two decimals at most). Visible only with the right to see fees."
              },
              save: {
                term: "Save",
                text: "Saves the changes; greyed out while nothing has changed. If someone else changed the phase meanwhile, it is reloaded and you apply your change again."
              },
              readOnly: {
                term: "This phase is closed",
                text: "For a closed phase or a plain reader, the panel shows the information without editing: status, dates, fees, closing date and closing waiver."
              }
            }
          },
          addDialog: {
            title: "Add a phase",
            items: {
              type: {
                term: "Phase type",
                text: 'Required. A project has only one phase of each type; choose "Custom phase" to add another one.'
              },
              name: {
                term: "Phase name",
                text: "For a custom phase: the name as it will appear in the project."
              },
              planned: {
                term: "Planned start, Planned end",
                text: "Optional."
              },
              share: {
                term: "Fee share",
                text: "Optional, as a percentage. Visible only with the right to see fees."
              },
              after: {
                term: "Insert after",
                text: 'Choose the phase after which to place the new one, or "At the end of the project".'
              },
              submit: {
                term: "Add the phase",
                text: 'Adds the phase. "Cancel" closes the window.'
              }
            }
          },
          closeDialog: {
            title: "Close phase",
            items: {
              rule: {
                term: "Close phase \u2026?",
                text: "A phase is closed when all its deliverables are approved or transmitted. Otherwise you can close it with a waiver, explained in writing."
              },
              unfinished: {
                term: "Pending deliverables",
                text: "The number of the phase's deliverables that are neither approved nor transmitted. If there are none, closing is direct."
              },
              waiver: {
                term: "Reason for the waiver",
                text: "Required text, with a character counter (a minimum is asked). It is kept in the project history."
              },
              confirm: {
                term: "Close the phase",
                text: 'The button becomes "Close with a waiver" when a waiver is needed. If the deliverables change while the window is open, a message warns you.'
              }
            }
          }
        }
      },
      deliverables: {
        title: "Deliverables",
        intro: "The documents the office must hand over to the client, grouped by phase, with their progress. Project managers edit them; the others read them.",
        sections: {
          summary: {
            title: "Project summary",
            items: {
              breadcrumb: {
                term: "Projects",
                text: 'The breadcrumb at the top of the page. Click "Projects" to go back to the list; next to it you see the name of the open project.'
              },
              meeting: {
                term: "Start a meeting",
                text: "Button at the top right, for project members who can contribute. It asks for the meeting title, then opens the meeting room."
              },
              code: {
                term: "Code",
                text: "The project code, used on its documents and invoices."
              },
              client: {
                term: "Client",
                text: `The project's client (project owner), or "No client" if not filled in yet.`
              },
              status: {
                term: "Status",
                text: "A chip with the project's state: Draft, In progress, On hold, Closed or Archived."
              },
              progress: {
                term: "Phases closed: 2 / 7",
                text: "A progress bar and the number of closed phases, with the current phase."
              },
              tabs: {
                term: "Posts, Files, Tasks, Phases, Deliverables, Approvals, Calendar, Finance, Settings",
                text: `The project's tabs. You are on "Deliverables".`
              }
            }
          },
          overview: {
            title: "Deliverables",
            items: {
              add: {
                term: "Add a deliverable",
                text: "Button reserved for project managers, offered as long as a phase is still open."
              },
              readOnly: {
                term: "Only the project's managers can change the deliverables.",
                text: "A blue message shown to the other members, who can only view."
              },
              phaseBlock: {
                term: "One block per phase",
                text: 'Each phase has its title, its status chip and its table. Below, "3 of 5 approved or transmitted" shows the progress.'
              },
              closePhase: {
                term: "Close phase",
                text: "A manager's button on a phase that is still open. It opens the closing window (see the Phases tab)."
              },
              closed: {
                term: "Phase closed on",
                text: "For a closed phase: the date, and the waiver if it was closed without everything being approved."
              },
              phaseEmpty: {
                term: "No deliverable in this phase.",
                text: "Shown when a phase has no deliverable yet."
              },
              empty: {
                term: "This project has no phases yet",
                text: "Deliverables are grouped by phase: they will appear once the project's phases have been added."
              }
            }
          },
          table: {
            title: "A phase's deliverables table",
            items: {
              title: {
                term: "Deliverable",
                text: "The deliverable's title."
              },
              type: {
                term: "Type",
                text: "The kind of document expected (drawing, calculation note, report\u2026)."
              },
              discipline: {
                term: "Discipline",
                text: "The discipline concerned (Architecture, Structure, Roads and utilities (VRD)\u2026), or a dash."
              },
              status: {
                term: "Status",
                text: "The deliverable's state: To produce, In progress, In review, Approved or Transmitted."
              },
              due: {
                term: "Due",
                text: "The planned hand-over date, or a dash."
              },
              actions: {
                term: "Actions",
                text: `A managers' column: the pencil "Edit deliverable" opens the edit window. It is not offered for closed phases.`
              }
            }
          },
          types: {
            title: "Deliverable types",
            items: {
              drawing: {
                term: "Drawing",
                text: "A plan or a drawing."
              },
              calculationNote: {
                term: "Calculation note",
                text: "The document that justifies the sizing calculations."
              },
              report: {
                term: "Report",
                text: "A study or visit report."
              },
              specification: {
                term: "Specification",
                text: "The document that describes what must be built and how."
              },
              billOfQuantities: {
                term: "Bill of quantities",
                text: "The list of works with their quantities."
              },
              estimate: {
                term: "Estimate",
                text: "The estimate of the cost of the works."
              },
              other: {
                term: "Other",
                text: "Any deliverable that does not fit the previous types."
              }
            }
          },
          statuses: {
            title: "Deliverable statuses",
            items: {
              toProduce: {
                term: "To produce",
                text: "The deliverable has not been started."
              },
              inProgress: {
                term: "In progress",
                text: "The deliverable is being produced."
              },
              inReview: {
                term: "In review",
                text: "The deliverable is being reviewed."
              },
              approved: {
                term: "Approved",
                text: "The deliverable is validated. It counts towards being able to close the phase."
              },
              transmitted: {
                term: "Transmitted",
                text: "The deliverable was handed over to the client. It also counts towards closing the phase."
              }
            }
          },
          dialog: {
            title: "Add or edit a deliverable",
            items: {
              title: {
                term: "Deliverable title",
                text: "Required, 200 characters at most."
              },
              phase: {
                term: "Phase",
                text: "Required: choose a phase of the project that is still open."
              },
              type: {
                term: "Type",
                text: "Drawing, Calculation note, Report, Specification, Bill of quantities, Estimate or Other."
              },
              discipline: {
                term: "Discipline",
                text: 'Optional: Architecture, Structure, Roads and utilities (VRD), Fluids (MEP), Electrical, Surveying, Geotechnics or Site coordination (OPC). "No discipline" by default.'
              },
              due: {
                term: "Due date",
                text: "Optional: the hand-over date."
              },
              status: {
                term: "Status",
                text: "Offered only when you edit an existing deliverable."
              },
              save: {
                term: "Save",
                text: 'Saves the deliverable. If someone else changed it meanwhile, it is reloaded and you apply your change again. "Cancel" closes the window.'
              }
            }
          }
        }
      },
      approvals: {
        title: "Approvals",
        intro: "The follow-up of the project's approval workflows: the documents sent to reviewers for validation, where they stand, and those waiting for your opinion.",
        sections: {
          summary: {
            title: "Project summary",
            items: {
              breadcrumb: {
                term: "Projects",
                text: 'The breadcrumb at the top of the page. Click "Projects" to go back to the list; next to it you see the name of the open project.'
              },
              meeting: {
                term: "Start a meeting",
                text: "Button at the top right, for project members who can contribute. It asks for the meeting title, then opens the meeting room."
              },
              code: {
                term: "Code",
                text: "The project code, used on its documents and invoices."
              },
              client: {
                term: "Client",
                text: `The project's client (project owner), or "No client" if not filled in yet.`
              },
              status: {
                term: "Status",
                text: "A chip with the project's state: Draft, In progress, On hold, Closed or Archived."
              },
              progress: {
                term: "Phases closed: 2 / 7",
                text: "A progress bar and the number of closed phases, with the current phase."
              },
              tabs: {
                term: "Posts, Files, Tasks, Phases, Deliverables, Approvals, Calendar, Finance, Settings",
                text: `The project's tabs. You are on "Approvals".`
              },
              noSpace: {
                term: "Approval workflows are not available yet",
                text: "Shown if the project's file space is not ready yet."
              }
            }
          },
          filters: {
            title: "Filter approval workflows",
            items: {
              all: {
                term: "All",
                text: "All the project's workflows."
              },
              inProgress: {
                term: "In approval",
                text: "The workflows still open, where reviewers must give their opinion."
              },
              approved: {
                term: "Approved",
                text: "The workflows that ended with a favourable opinion without reservation (VSO)."
              },
              approvedWithComments: {
                term: "Approved with comments",
                text: "The workflows that ended with a favourable opinion with comments (VAO)."
              },
              rejected: {
                term: "Refused",
                text: "The workflows stopped by a refusal (REF): the document must be corrected."
              },
              cancelled: {
                term: "Cancelled",
                text: "The workflows stopped by the person who had requested them."
              },
              toDecide: {
                term: "To decide by me",
                text: "A button that combines with the others: keeps only the workflows waiting for your opinion right now."
              }
            }
          },
          table: {
            title: "The project's approval workflows",
            items: {
              document: {
                term: "Document",
                text: "The document's code and title. Click it to open it in the viewer."
              },
              index: {
                term: "Index",
                text: "The version letter of the document sent for approval (A, B, C\u2026)."
              },
              status: {
                term: "Status",
                text: "In approval, Approved (VSO), Approved with comments (VAO), Refused (REF) or Cancelled."
              },
              step: {
                term: "Current step",
                text: 'For example "Step 2 of 3", while the workflow is open; a dash otherwise.'
              },
              initiator: {
                term: "Requested by",
                text: "The person who requested the approval."
              },
              dates: {
                term: "Dates",
                text: "The request date, then the end date of the workflow or its due date."
              },
              actions: {
                term: "Actions",
                text: '"View the workflow" for everyone. "Give my opinion" only appears when it is your turn to decide.'
              }
            }
          },
          details: {
            title: "A document's approval workflow",
            items: {
              header: {
                term: "Requested by \u2026 on",
                text: "The header of the window: the status, the index, who requested the approval and when, then the end date or the due date."
              },
              step: {
                term: "Step",
                text: 'Each step shows its mode, In order (each reviewer in turn) or In parallel (all at once), and "Current step" for the open one. The following steps are "Upcoming".'
              },
              reviewers: {
                term: "Reviewers",
                text: 'For each one: Their turn to decide, Waiting for their opinion, Not asked yet, or the decision already made. "(you)" marks your name.'
              },
              cancel: {
                term: "Cancel the workflow",
                text: "For the person who requested the approval: stops the workflow, after confirmation. The document accepts a new version again; opinions already given stay in the history."
              }
            }
          },
          decision: {
            title: "Your opinion on a document",
            items: {
              vso: {
                term: "VSO \u2014 Approved",
                text: "You approve the document as it is. The comment is optional."
              },
              vao: {
                term: "VAO \u2014 Approved with comments",
                text: "You approve provided your comments are taken into account. A comment is required."
              },
              ref: {
                term: "REF \u2014 Refused",
                text: "You refuse this version: the workflow stops and the document must be corrected. A comment is required."
              },
              comment: {
                term: "Comment",
                text: "Your comment. For a VAO or a REF it is required, unless you attach one of your annotations."
              },
              annotations: {
                term: "Attach my annotations",
                text: "Check boxes: the annotations you made on the document and link to your opinion."
              },
              send: {
                term: "Send my opinion",
                text: "Your opinion is final: you will not be able to change it once sent."
              }
            }
          },
          empty: {
            title: "Status messages",
            items: {
              none: {
                term: "No approval workflows",
                text: "Open a document in the Files tab and request its approval: the workflow will appear here."
              },
              noMatch: {
                term: "No workflow matches",
                text: "Choose another status to see the other workflows."
              },
              nothingToDecide: {
                term: "Nothing to decide for now",
                text: "Workflows waiting for your opinion will appear here."
              },
              loadFailed: {
                term: "Unable to show the approval workflows",
                text: 'A red message: try again with "Try again"; if the problem continues, contact support.'
              }
            }
          }
        }
      },
      calendar: {
        title: "Calendar",
        intro: "The tab for the project's meetings, site visits and deadlines. For now it only announces what it will contain.",
        sections: {
          summary: {
            title: "Project summary",
            items: {
              breadcrumb: {
                term: "Projects",
                text: 'The breadcrumb at the top of the page. Click "Projects" to go back to the list; next to it you see the name of the open project.'
              },
              meeting: {
                term: "Start a meeting",
                text: "Button at the top right, for project members who can contribute. It asks for the meeting title, then opens the meeting room."
              },
              code: {
                term: "Code",
                text: "The project code, used on its documents and invoices."
              },
              client: {
                term: "Client",
                text: `The project's client (project owner), or "No client" if not filled in yet.`
              },
              status: {
                term: "Status",
                text: "A chip with the project's state: Draft, In progress, On hold, Closed or Archived."
              },
              progress: {
                term: "Phases closed: 2 / 7",
                text: "A progress bar and the number of closed phases, with the current phase."
              },
              tabs: {
                term: "Posts, Files, Tasks, Phases, Deliverables, Approvals, Calendar, Finance, Settings",
                text: `The project's tabs. You are on "Calendar".`
              }
            }
          },
          meeting: {
            title: "Start a meeting",
            items: {
              titleField: {
                term: "Meeting title",
                text: 'Required, 200 characters at most. It is pre-filled with "Meeting - " followed by the project name.'
              },
              start: {
                term: "Start",
                text: "Creates the meeting and takes you to its room. Project members can join it."
              },
              cancel: {
                term: "Cancel",
                text: "Closes the window without creating a meeting."
              }
            }
          },
          placeholder: {
            title: "The project calendar will appear here",
            items: {
              message: {
                term: "The project calendar will appear here",
                text: "Message shown in the middle of the tab: the project calendar is not yet available in this tab."
              },
              content: {
                term: "Meetings, site visits and deadlines",
                text: "These are the announced items: they will appear in this tab."
              }
            }
          }
        }
      },
      finance: {
        title: "Finance",
        intro: "The project's financial view: its contract, the progress invoiced by phase, and its quotes and invoices. The tab is only visible to people who have access to quotes, invoices or contracts.",
        sections: {
          summary: {
            title: "Project summary",
            items: {
              breadcrumb: {
                term: "Projects",
                text: 'The breadcrumb at the top of the page. Click "Projects" to go back to the list; next to it you see the name of the open project.'
              },
              meeting: {
                term: "Start a meeting",
                text: "Button at the top right, for project members who can contribute. It asks for the meeting title, then opens the meeting room."
              },
              code: {
                term: "Code",
                text: "The project code, used on its documents and invoices."
              },
              client: {
                term: "Client",
                text: `The project's client (project owner), or "No client" if not filled in yet.`
              },
              status: {
                term: "Status",
                text: "A chip with the project's state: Draft, In progress, On hold, Closed or Archived."
              },
              progress: {
                term: "Phases closed: 2 / 7",
                text: "A progress bar and the number of closed phases, with the current phase."
              },
              tabs: {
                term: "Posts, Files, Tasks, Phases, Deliverables, Approvals, Calendar, Finance, Settings",
                text: `The project's tabs. You are on "Finance".`
              }
            }
          },
          contract: {
            title: "Contract",
            items: {
              reference: {
                term: "Contract reference",
                text: "The reference of the project's contract. Click it to open the contract."
              },
              client: {
                term: "Client",
                text: "The contract's client."
              },
              kind: {
                term: "Kind",
                text: "Private agreement, or Public market."
              },
              total: {
                term: "Total excl. VAT with amendments:",
                text: "The contract amount excluding tax, including amendments (changes signed afterwards). Example: 11,544.000 TND."
              },
              open: {
                term: "Open the contract",
                text: "A link to the contract page."
              },
              prepare: {
                term: "Prepare a progress invoice",
                text: "A link for people who can create invoices, when the contract is in dinars (TND). A progress invoice bills the progress of the works or studies at a given date."
              }
            }
          },
          noContract: {
            title: "No contract for this project",
            items: {
              message: {
                term: "No contract for this project",
                text: "Shown when the project has no contract yet. People who do not manage contracts only read that the contract will appear here."
              },
              create: {
                term: "Create the contract",
                text: "For people who manage contracts: opens the new contract form, linked to this project. It then lets you follow the advance, the retention and the billing by phase."
              },
              fromQuote: {
                term: "Create the contract from the quote",
                text: "Offered when a quote of the project has been accepted: the contract takes the quote's client and amount."
              }
            }
          },
          progress: {
            title: "Invoiced progress",
            items: {
              total: {
                term: "Contract total (excl. VAT)",
                text: "The contract amount excluding tax."
              },
              advance: {
                term: "Advance",
                text: "The advance paid by the client."
              },
              advanceRecovered: {
                term: "Advance already recovered",
                text: "The part of the advance already deducted from invoices."
              },
              retention: {
                term: "Retention already withheld",
                text: "The amount withheld as a guarantee by the client, with its rate in brackets."
              },
              phases: {
                term: "Phase, Status, Fee, Invoiced (cumulative), Amount invoiced",
                text: "A table by phase: its status, its fee, the cumulative percentage already invoiced and the amount invoiced. This section only appears for people who see invoices, and for a contract in dinars."
              }
            }
          },
          quotes: {
            title: "Quotes and invoices",
            items: {
              list: {
                term: "Quotes of the project",
                text: "Up to five quotes of the project: number (a link), title, status (Draft, Sent, Accepted, Declined or Expired) and amount excluding tax."
              },
              none: {
                term: "No quote is linked to this project.",
                text: "Shown when the project has no quote."
              },
              allQuotes: {
                term: "All quotes",
                text: "A link to the list of all the office's quotes."
              },
              allInvoices: {
                term: "All invoices",
                text: "A link to the list of all the office's invoices."
              }
            }
          },
          access: {
            title: "Access rights",
            items: {
              noAccess: {
                term: "Finance not available",
                text: "Shown if you do not have access to this project's financial information."
              },
              visibility: {
                term: "What you see",
                text: "Each block depends on your rights: the contract, the invoiced progress, then the quotes and invoices only appear if you may read them."
              }
            }
          }
        }
      },
      settings: {
        title: "Settings",
        intro: "The project's general information and its members. Project managers edit them; the others read them.",
        sections: {
          summary: {
            title: "Project summary",
            items: {
              breadcrumb: {
                term: "Projects",
                text: 'The breadcrumb at the top of the page. Click "Projects" to go back to the list; next to it you see the name of the open project.'
              },
              meeting: {
                term: "Start a meeting",
                text: "Button at the top right, for project members who can contribute. It asks for the meeting title, then opens the meeting room."
              },
              code: {
                term: "Code",
                text: "The project code, used on its documents and invoices."
              },
              client: {
                term: "Client",
                text: `The project's client (project owner), or "No client" if not filled in yet.`
              },
              status: {
                term: "Status",
                text: `A chip with the project's state. It is changed further down, in "Project status".`
              },
              progress: {
                term: "Phases closed: 2 / 7",
                text: "A progress bar and the number of closed phases, with the current phase."
              },
              tabs: {
                term: "Posts, Files, Tasks, Phases, Deliverables, Approvals, Calendar, Finance, Settings",
                text: `The project's tabs. You are on "Settings".`
              }
            }
          },
          general: {
            title: "General information",
            items: {
              readOnly: {
                term: "Only the project's managers can change this information.",
                text: "A blue message shown to the other members: they see the values as text and cannot change them."
              },
              missionType: {
                term: "Mission type",
                text: "The mission type chosen at creation. It can be read but not changed."
              },
              name: {
                term: "Project name",
                text: "Required, 200 characters at most."
              },
              code: {
                term: "Project code",
                text: "Required, 30 characters at most (letters, digits and . _ / -). Used on the project's documents and invoices. A code already taken by another project is refused."
              },
              client: {
                term: "Client (project owner)",
                text: 'Choose an active client of the office, or "No client".'
              }
            }
          },
          status: {
            title: "Project status",
            items: {
              status: {
                term: "Status",
                text: "The list only offers the changes possible from the current status. The text under the field explains the chosen status."
              },
              draft: {
                term: "Draft",
                text: "The project is being prepared: it has not started yet."
              },
              active: {
                term: "In progress",
                text: "The project is under way."
              },
              onHold: {
                term: "On hold",
                text: "The project is temporarily suspended; it can resume."
              },
              closed: {
                term: "Closed",
                text: "The mission is finished. The project can be reopened if needed."
              },
              archived: {
                term: "Archived",
                text: 'The project is put away: it no longer shows in lists, except with the "Archived" filter.'
              }
            }
          },
          place: {
            title: "Location and dates",
            items: {
              governorate: {
                term: "Governorate",
                text: `The project's governorate, or "Not specified".`
              },
              delegation: {
                term: "Delegation",
                text: "The delegation (a subdivision of the governorate), 100 characters at most."
              },
              startsOn: {
                term: "Start date",
                text: "The project's start date."
              },
              endsOn: {
                term: "Planned end date",
                text: "It cannot be before the start date."
              }
            }
          },
          estimate: {
            title: "Area, estimate and fees",
            items: {
              surface: {
                term: "Area (m\xB2)",
                text: "Total area of the project, in square metres: a whole number of at least 1."
              },
              worksCost: {
                term: "Works cost estimate",
                text: "The estimated cost of the works, in dinars (TND)."
              },
              feeMode: {
                term: "Fee calculation method",
                text: 'Lump sum, Percentage of the works cost or Time spent. This "Fees" block only appears for people who may see the fees.'
              },
              feeAmount: {
                term: "Fee amount",
                text: "The amount of the fees, in dinars (TND)."
              }
            }
          },
          references: {
            title: "References",
            items: {
              contractRef: {
                term: "Contract reference",
                text: "The reference of the contract signed with the client, 100 characters at most."
              },
              tunepsRef: {
                term: "TUNEPS reference",
                text: "Reference of the tender on TUNEPS (the national public procurement platform), if the contract is public."
              },
              save: {
                term: "Save changes",
                text: "Saves your changes. The button is greyed out while nothing has changed. If someone else changed the project meanwhile, it is reloaded: check the values, then apply your changes again."
              },
              reset: {
                term: "Discard changes",
                text: "Puts all the values back as they were when the page opened."
              }
            }
          },
          members: {
            title: "Project members",
            items: {
              intro: {
                term: "Project members",
                text: "Members see the project and contribute to it; managers handle its settings. At least one manager is required."
              },
              name: {
                term: "Name",
                text: `Each person's name; "(you)" marks yours.`
              },
              role: {
                term: "Role",
                text: "Manager or Member. Managers can change the role in the list."
              },
              remove: {
                term: "Remove",
                text: '"Actions" column, for managers: removes the person from the list (the change is only applied when you save).'
              },
              add: {
                term: "Add a person from the office",
                text: 'Choose a person in the "Choose a person" list, then "Add". If everyone is already on the project, a message says so.'
              },
              save: {
                term: "Save members",
                text: `Applies the list's changes. "Discard changes" drops them.`
              },
              lastManager: {
                term: "The project must keep at least one manager",
                text: "An orange warning when no manager is left: name another one before saving."
              }
            }
          }
        }
      },
      overview: {
        title: "Project overview",
        intro: "The project workspace opens a project full screen, in its own browser tab. The overview sums up the project: progress, tasks, deadlines, phases, sheet and team.",
        sections: {
          navigation: {
            title: "Workspace navigation",
            items: {
              open: {
                term: "Project workspace",
                text: "Button at the top of a project's page. It opens the same project full screen in a new tab, on the section on screen."
              },
              sections: {
                term: "Sections",
                text: "The left column lists the project's sections in groups: Steering, Documents, Collaboration and Management. On a small screen, open it with the menu button next to the title."
              },
              back: {
                term: "Back to the standard view",
                text: "Link at the bottom of the column: it opens the project again with its tabs, in the usual app."
              }
            }
          },
          kpis: {
            title: "Key figures",
            items: {
              phases: {
                term: "Closed phases",
                text: "Closed phases out of the total, with a progress bar and the current phase."
              },
              open: {
                term: "Open tasks",
                text: 'Tasks that are not done, with how many are "In progress" and "Blocked".'
              },
              late: {
                term: "Late tasks",
                text: "Tasks not done whose due date has passed. The card turns red as soon as there is one."
              },
              team: {
                term: "Team members",
                text: "How many members and managers the project has. Each card opens its section."
              }
            }
          },
          lists: {
            title: "Deadlines, statuses and phases",
            items: {
              deadlines: {
                term: "Next deadlines",
                text: "The next six open tasks by due date, with their status and priority. Click a task to open it in the Tasks section."
              },
              status: {
                term: "Tasks by status",
                text: "A breakdown bar and a table: count and share of To do, In progress, Blocked and Done tasks."
              },
              phases: {
                term: "Project phases",
                text: "The phases on a timeline, with their planned and actual dates and any delay."
              }
            }
          },
          sheet: {
            title: "Sheet and team",
            items: {
              facts: {
                term: "Project sheet",
                text: 'Client, mission type, location, surface, works cost estimate, dates and references. "Edit" opens the Settings.'
              },
              members: {
                term: "Project team",
                text: 'The members and their role (Manager or Member). "Manage members" opens the Settings.'
              }
            }
          }
        }
      }
    },
    spaceApprovals: {
      title: "External access approvals",
      intro: "The requests to validate when a member of your organisation is invited to another organisation's space. Your policy asks for an administrator's agreement before they can join.",
      sections: {
        purpose: {
          title: "External access approvals",
          items: {
            intro: {
              term: "Why this page",
              text: "A member of your organisation is invited to another organisation's space (the host). Until an administrator approves, they cannot enter it."
            },
            denied: {
              term: "You cannot decide here",
              text: "A message shown to people who may not approve external access: only authorised administrators see these requests."
            }
          }
        },
        requests: {
          title: "Requests to approve",
          items: {
            person: {
              term: "Person's name",
              text: "The invited person, or their e-mail address if their name is not known."
            },
            kind: {
              term: "Named invitation, Guest, Organisation",
              text: "The orange chip gives the type of request: an invitation to a specific person, an outside guest, or an organisation."
            },
            email: {
              term: "E-mail address",
              text: "The address of the invited person."
            },
            space: {
              term: "Space \u2026 hosted by \u2026",
              text: "The name of the shared space and the organisation that hosts it."
            },
            rights: {
              term: "Rights",
              text: "What the person will be able to do: Read only, Read and write, or Read, write and approve."
            },
            invitedBy: {
              term: "Invited by",
              text: "The person who sent the invitation, when known."
            },
            requestedOn: {
              term: "Requested on",
              text: "The date of the request."
            },
            answerBefore: {
              term: "To handle before",
              text: "The deadline to answer."
            }
          }
        },
        answers: {
          title: "Answering a request",
          items: {
            approve: {
              term: "Approve",
              text: "Allows the person to join the space. The host is informed."
            },
            refuse: {
              term: "Refuse",
              text: 'Opens a confirmation window: "Refuse the access of \u2026?". The person will not join the space, but the host can invite them again.'
            }
          }
        },
        states: {
          title: "Status messages",
          items: {
            empty: {
              term: "No request to approve",
              text: "Shown when no request is waiting. A new request appears here as soon as a member is invited to another organisation's space."
            },
            loadFailed: {
              term: "The requests could not be loaded",
              text: 'A red message with a connection problem: check it, then click "Try again".'
            }
          }
        }
      }
    },
    partnerships: {
      title: "Partnerships",
      intro: "The spaces of other organisations that your organisation is invited to or takes part in. This page is meant for owners and administrators.",
      sections: {
        requests: {
          title: "Partnership requests",
          items: {
            description: {
              term: "Accept for your organisation to join the space",
              text: "Once you accept the request, you then choose who, in your organisation, reaches the space."
            },
            host: {
              term: "Host organisation",
              text: 'Each row shows the logo and name of the organisation hosting the space, with the "Waiting for an answer" chip.'
            },
            accept: {
              term: "Accept",
              text: "Your organisation becomes a partner of the space."
            },
            decline: {
              term: "Decline",
              text: 'Opens a confirmation "Decline the invitation to the space \u2026?". Your organisation does not join the space; the host can invite it again.'
            },
            none: {
              term: "No pending request.",
              text: "Shown when there is nothing to answer."
            }
          }
        },
        active: {
          title: "Active partnerships",
          items: {
            description: {
              term: "Active partnerships",
              text: "The spaces your organisation takes part in. Open one to manage your delegates."
            },
            status: {
              term: "Active",
              text: "A green chip: the partnership is in place."
            },
            manage: {
              term: "Manage my delegates",
              text: "Opens the space on the delegates tab: the people of your organisation who have access to it."
            },
            none: {
              term: "No active partnership.",
              text: "Shown when no space is active."
            }
          }
        },
        ended: {
          title: "Ended partnerships",
          items: {
            declined: {
              term: "Declined",
              text: "You declined the invitation."
            },
            expired: {
              term: "Expired",
              text: "The partnership reached its end date."
            },
            revoked: {
              term: "Removed",
              text: "The host removed your organisation from the space."
            },
            visibility: {
              term: "Ended partnerships",
              text: "This block only appears if there is at least one ended partnership; it is read-only."
            }
          }
        },
        details: {
          title: "Details of a row",
          items: {
            space: {
              term: "Space",
              text: "The name of the shared space."
            },
            scope: {
              term: "The whole space",
              text: 'What the partnership covers: "The whole space" or "Folders: 2 \xB7 Channels: 1" when only some folders and channels are open.'
            },
            rights: {
              term: "Rights",
              text: "Read only, Read and write, or Read, write and approve."
            },
            people: {
              term: "People",
              text: 'The number of people of your organisation who have access, out of the maximum allowed, for example "3/10".'
            },
            until: {
              term: "Until",
              text: `The partnership's end date, or "No end date".`
            }
          }
        },
        states: {
          title: "Status messages",
          items: {
            empty: {
              term: "No partnership",
              text: "Shown when no organisation has invited you yet. The request appears here as soon as another organisation invites you to share a space."
            },
            loadFailed: {
              term: "The partnerships could not be loaded",
              text: 'A red message with a connection problem: check it, then click "Try again".'
            }
          }
        }
      }
    },
    home: {
      title: "Getting around BatiFlow",
      intro: "This guide explains the frame of BatiFlow that surrounds every page: the app bar, the header, notifications, the account menu, the list on the left, the panel on the right and the keyboard shortcuts.",
      sections: {
        appBar: {
          title: "Apps",
          items: {
            activity: {
              term: "Activity",
              text: "Your notifications: mentions, tasks assigned to you, approval requests. Shortcut: Alt+1."
            },
            chat: {
              term: "Chat",
              text: "Discussions with your colleagues and the channels of your projects. Shortcut: Alt+2."
            },
            projects: {
              term: "Projects",
              text: "The list of your projects and their follow-up. Shortcut: Alt+3."
            },
            calendar: {
              term: "Calendar",
              text: "Your meetings, site visits and deadlines. Shortcut: Alt+4."
            },
            files: {
              term: "Files",
              text: "The files section of the organisation. Shortcut: Alt+5."
            },
            finance: {
              term: "Finance",
              text: "Quotes, invoices and financial follow-up. Shortcut: Alt+6."
            },
            more: {
              term: "More",
              text: "Clients, partnerships and the administration of your office. Shortcut: Alt+7."
            },
            phone: {
              term: "On a phone or small screen",
              text: "On a phone the bar moves to the bottom of the screen and keeps only Activity, Chat, Projects, Calendar and More. On a tablet only the icons show. A coloured line marks the open app, and a counter points out what is new."
            }
          }
        },
        header: {
          title: "Header",
          items: {
            logo: {
              term: "BatiFlow logo",
              text: "The product name, at the top left of the screen, in Arabic too."
            },
            search: {
              term: "Search projects, files, messages\u2026",
              text: "Opens the quick search across the whole organisation. You can also press Ctrl+K or the / key. On a phone it is a simple magnifier (Open search)."
            },
            orgSwitcher: {
              term: "Switch organisation",
              text: "Shows the name of the active organisation. If you belong to several offices, pick one in the list: you land on its Activity page."
            },
            externalSpaces: {
              term: "External spaces",
              text: "In the same menu: the spaces that other organisations share with you. The number in brackets tells you how many you have."
            },
            notifications: {
              term: "Notifications",
              text: "The bell. A counter shows the number of unread notifications (99+ beyond that). Click it to open the latest notifications."
            },
            account: {
              term: "Account menu",
              text: "Your photo or your initials, with a coloured dot showing your status. It opens the menu described below."
            }
          }
        },
        bell: {
          title: "Notifications (the bell)",
          items: {
            count: {
              term: "Latest notifications",
              text: "Each line has an icon for its type, a sentence, the relative date and where it comes from (organisation, project code and name). A click opens the item and marks the notification as read."
            },
            unread: {
              term: "Unread",
              text: "An unread notification is written in bold, with a small dot in front."
            },
            markRead: {
              term: "Mark as read",
              text: "The tick on the right of an unread notification marks it as read without opening it."
            },
            decide: {
              term: "Decide",
              text: "Shows on an approval request of your active organisation. Opens the window to give your decision right away."
            },
            markAllRead: {
              term: "Mark all as read",
              text: "Marks every notification as read in one click."
            },
            viewAll: {
              term: "View all activity",
              text: "Opens the Activity page with the full history and the filters."
            },
            empty: {
              term: "You're all caught up",
              text: "Message shown when there is no notification. Your mentions, assignments and reminders will appear here."
            },
            loadFailed: {
              term: "Notifications could not be loaded",
              text: 'Check your connection, then use "Try again".'
            }
          }
        },
        account: {
          title: "Account menu",
          items: {
            status: {
              term: "Status",
              text: 'Pick Available, Busy, On site or Away: your colleagues see it next to your name. "In a meeting" shows by itself during a call, and "Offline" when you are not connected. The status can only be changed while the live connection is active.'
            },
            profile: {
              term: "My profile",
              text: "Opens your personal profile."
            },
            security: {
              term: "Account security",
              text: "Opens the security page of your account."
            },
            language: {
              term: "Language",
              text: "Pick Fran\xE7ais, \u0627\u0644\u0639\u0631\u0628\u064A\u0629 or English. The whole application changes at once, and Arabic is written from right to left."
            },
            theme: {
              term: "Theme",
              text: "Same as the system, Light, Dark or High contrast (to see outlines and colours more clearly)."
            },
            signOut: {
              term: "Sign out",
              text: "Ends your session."
            },
            signOutFailed: {
              term: "Sign-out incomplete",
              text: 'If signing out fails, this window asks you to close your browser to end the session safely. The "Close" button closes it.'
            }
          }
        },
        panes: {
          title: "List on the left, panel on the right and banners",
          items: {
            list: {
              term: "List",
              text: 'Some apps (Projects, Chat, Calendar) have a list on the side. "Hide the list" folds it and "Show the list" opens it again (Alt+L). On a medium or small screen it opens over the page with "Open the list".'
            },
            resize: {
              term: "Resize the list",
              text: "Drag the edge of the list with the mouse, or focus it and use the left and right arrow keys."
            },
            rightPanel: {
              term: "Close the panel",
              text: "The panel on the right shows a detail (thread, pinned messages\u2026). The close button or the Esc key closes it."
            },
            subscriptionBanner: {
              term: "Subscription banner",
              text: 'A banner appears above the page only when the subscription needs your attention (trial ending soon, unpaid invoice, read-only\u2026). A button such as "View the subscription" or "Pay the invoice" takes you to what to do.'
            },
            skipLink: {
              term: "Skip to main content",
              text: "A hidden link that shows when you press Tab on arriving on the page. It lets the keyboard jump straight to the content."
            }
          }
        },
        shortcuts: {
          title: "Keyboard shortcuts",
          items: {
            search: {
              term: "Search",
              text: "Ctrl+K, or the / key, opens the quick search."
            },
            apps: {
              term: "Go to an app",
              text: "Alt+1 to Alt+7 open, in order: Activity, Chat, Projects, Calendar, Files, Finance, More."
            },
            list: {
              term: "Show or hide the list",
              text: "Alt+L folds or reopens the list on the side."
            },
            close: {
              term: "Close the panel or dialog",
              text: "The Esc key closes the panel on the right or the open window."
            },
            typing: {
              term: "While typing",
              text: "Shortcuts do not run while you type in a text field, so they never get in the way of writing."
            }
          }
        }
      }
    },
    activity: {
      title: "Activity",
      intro: "The feed of everything that concerns you in the organisation: mentions, tasks assigned to you, approval requests and their decisions. Each member sees their own feed.",
      sections: {
        header: {
          title: "Page header",
          items: {
            title: {
              term: "Activity",
              text: "The name of the page."
            },
            markAllRead: {
              term: "Mark all as read",
              text: "Marks all the organisation's notifications as read. The button is greyed out when nothing is unread."
            }
          }
        },
        filters: {
          title: "Filter activity",
          items: {
            all: {
              term: "All",
              text: "Every notification, including deadline reminders and messages about the subscription."
            },
            mentions: {
              term: "Mentions",
              text: "The times someone mentions you in a message or a task, or replies to one of your comments."
            },
            assignments: {
              term: "Assignments",
              text: "The tasks assigned to you."
            },
            approvals: {
              term: "Approvals",
              text: "Approval requests (sign-off on a document) and the decisions given on your documents. An approval can be VSO (approved), VAO (approved with comments) or REF (refused)."
            },
            address: {
              term: "Filter kept in the address",
              text: "The chosen filter is written in the page address: you can copy it to share the view, and it survives a reload."
            }
          }
        },
        setup: {
          title: "Finish setting up your office",
          items: {
            card: {
              term: "Setup card",
              text: 'Three first steps to get started with BatiFlow. It only shows on the "All" tab, for owners, administrators and people who can invite members.'
            },
            invite: {
              term: "Invite your team",
              text: 'The "Invite" link leads to adding engineers, draftsmen and colleagues.'
            },
            clients: {
              term: "Add a client",
              text: 'The "Add a client" link leads to recording your project owners (your clients), so you can find them in your projects.'
            },
            project: {
              term: "Create a project",
              text: 'The "Create a project" link leads to starting your first study file.'
            },
            dismiss: {
              term: "Hide",
              text: "Hides the card. Your choice is remembered for this organisation, on this device."
            }
          }
        },
        feed: {
          title: "Activity feed",
          items: {
            row: {
              term: "A notification",
              text: "An icon for its type, a sentence, the relative date, then the organisation and project concerned. Clicking it opens the item and marks it as read."
            },
            unread: {
              term: "Unread",
              text: "Unread notifications are in bold, with a small dot."
            },
            markRead: {
              term: "Mark as read",
              text: "The tick on the right marks a single notification as read without opening it."
            },
            decide: {
              term: "Decide",
              text: "On an approval request: opens the window to give your decision without leaving the page."
            },
            loadMore: {
              term: "Show more activity",
              text: "Loads older notifications. The button only shows when there are more."
            }
          }
        },
        states: {
          title: "When the list is empty or does not load",
          items: {
            emptyAll: {
              term: "Nothing new for now",
              text: 'Empty "All" tab: your mentions, assignments and approvals will appear here.'
            },
            emptyMentions: {
              term: "No mentions",
              text: "You will be told here when someone mentions you or replies to one of your comments."
            },
            emptyAssignments: {
              term: "No assignments",
              text: "Tasks assigned to you will appear here."
            },
            emptyApprovals: {
              term: "No approvals yet",
              text: "Approval requests and their decisions will arrive here with document approvals."
            },
            loadFailed: {
              term: "Activity could not be loaded",
              text: 'Check your connection, then click "Try again".'
            }
          }
        }
      }
    },
    chat: {
      title: "Conversations",
      intro: "BatiFlow's messaging: private or group discussions with your colleagues, and channels linked to your projects. The conversations are in the list on the left, and the open conversation takes the rest of the screen.",
      sections: {
        listPane: {
          title: "Conversations and channels (list on the left)",
          items: {
            newConversation: {
              term: "New conversation",
              text: "The button at the top of the list opens the window to write to a colleague or create a group."
            },
            discussions: {
              term: "Discussions",
              text: "Your private conversations (one person) and your groups (several people). A private conversation carries the other person's name."
            },
            projects: {
              term: "Projects",
              text: "Your projects, which you open or fold with a click. Under each project: its channels, that is one discussion thread per topic."
            },
            unread: {
              term: "Unread message counter",
              text: "A small number next to a conversation or channel shows how many messages you have not read."
            },
            newChannel: {
              term: "New channel in the project",
              text: "The button next to a project name opens the creation of a channel. It only shows for people who manage that project."
            },
            emptyDiscussions: {
              term: "No discussions yet",
              text: "Start a conversation with a colleague."
            },
            emptyProjects: {
              term: "You are not part of any project",
              text: "The Projects section stays empty until you are added to a project."
            },
            noChannels: {
              term: "No channels in this project",
              text: "The project has no channel yet. Project managers can create one."
            }
          }
        },
        start: {
          title: "Choose a conversation",
          items: {
            emptyState: {
              term: "Choose a conversation",
              text: "Starting screen when no conversation is open: select a conversation or a channel in the list."
            },
            newConversation: {
              term: "New conversation",
              text: "The button on this screen opens the same window as the one in the list."
            }
          }
        },
        conversation: {
          title: "A conversation",
          items: {
            header: {
              term: "Name and topic",
              text: "At the top: the name of the channel or person. Below, the channel's topic, or the number of people in a group."
            },
            call: {
              term: "Call",
              text: "Starts a call in the conversation and opens the room; the members are rung. Available in private conversations, groups and private channels."
            },
            pins: {
              term: "Pinned messages",
              text: "Opens on the right the list of important messages pinned in this conversation. The number in brackets says how many there are."
            },
            dates: {
              term: "Today, Yesterday",
              text: "Messages are grouped by day. The most recent are at the bottom, and new messages from colleagues arrive one after the other."
            },
            latest: {
              term: "Latest messages",
              text: 'A button that shows when you have scrolled up in the conversation: it takes you back to the bottom. At the top, "Loading earlier messages\u2026" shows while the history loads.'
            },
            notice: {
              term: "Archived channel, read-only",
              text: "If the channel is archived, a message says you can read it but no longer write in it. Same if you are not allowed to write: the writing box is replaced by that sentence."
            },
            empty: {
              term: "No messages yet",
              text: "Empty conversation: write the first message."
            },
            unavailable: {
              term: "Conversation not found",
              text: 'The conversation no longer exists or you do not have access to it. The "Back to conversations" button takes you back to the starting screen.'
            }
          }
        },
        messages: {
          title: "A message",
          items: {
            author: {
              term: "Author and time",
              text: "Each message shows the person who wrote it, its time and its text."
            },
            external: {
              term: "External",
              text: 'An "External \xB7" label followed by an organisation name marks a person from another organisation, invited to a shared space.'
            },
            edited: {
              term: "edited",
              text: "The message was corrected by its author after it was sent."
            },
            pinned: {
              term: "Pinned",
              text: "Label on a message pinned in the conversation."
            },
            deleted: {
              term: "This message was deleted.",
              text: "Sentence that replaces a deleted message, for everyone."
            },
            reactions: {
              term: "Reactions",
              text: "Under the message, one chip per emoji with its count. Press a chip to add or remove your reaction; it is highlighted when it is yours."
            },
            thread: {
              term: "Replies",
              text: 'A link such as "2 replies" under the message opens its thread on the right.'
            },
            sendStatus: {
              term: "Sending\u2026",
              text: 'While sending, the message is faded. If the connection drops, "Message not sent." shows with three buttons: "Try again", "Put the text back" (puts the text back in the writing box) and "Delete".'
            }
          }
        },
        messageActions: {
          title: "Actions on a message",
          items: {
            react: {
              term: "Add a reaction",
              text: "Opens eight emojis to choose from: thumbs up, green tick, heart, laughter, surprise, folded hands, eyes and party."
            },
            reply: {
              term: "Reply in a thread",
              text: "Opens the message's thread on the right so you can reply without cluttering the conversation."
            },
            pin: {
              term: "Pin the message",
              text: 'Keeps the message in view in "Pinned messages". The same button becomes "Unpin the message". You need the right to write. A conversation holds at most 50 pinned messages.'
            },
            edit: {
              term: "Edit the message",
              text: "Only for the author of the message. The text becomes editable in place."
            },
            delete: {
              term: "Delete the message",
              text: "For the author, or for moderators on any message."
            },
            deleteDialog: {
              term: "Delete the message of\u2026?",
              text: 'Confirmation window: the message is replaced by "This message was deleted" for everyone, and this cannot be undone.'
            }
          }
        },
        composer: {
          title: "Write a message",
          items: {
            field: {
              term: "Write a message",
              text: "The writing box at the bottom of the conversation. It accepts formatting and mentions: type @ then a person's name to mention them."
            },
            hint: {
              term: "Writing help",
              text: "Enter sends, Shift+Enter starts a new line, @ mentions someone."
            },
            send: {
              term: "Send",
              text: "Sends the message. You need some text or at least one attached file."
            },
            attach: {
              term: "Attach a file",
              text: "Choose one or several files on your device. A message holds at most 10 files."
            },
            attachNotices: {
              term: "Messages about attachments",
              text: "If you are not allowed to add files, a message tells you. While files are still being sent, you must wait before sending the message."
            },
            cards: {
              term: "Attached files",
              text: 'Each file becomes a card under the message, with its state: "Sending", "Antivirus check in progress", "Available" or "File refused by the antivirus check".'
            },
            cardActions: {
              term: "Open, Download",
              text: '"Open" shows the file. "Download" takes a copy, unless downloading is not allowed in this space. Without access to the folder, the card says "You do not have access to this file": ask the person who sent it for access.'
            },
            typing: {
              term: "Is typing\u2026",
              text: "Above the writing box, a line shows who is typing."
            }
          }
        },
        panels: {
          title: "Panel on the right: thread and pinned messages",
          items: {
            thread: {
              term: "Thread",
              text: 'The original message, then the replies attached to it, with their number. If there are none: "No replies yet. Write the first one."'
            },
            threadReply: {
              term: "Reply in the thread",
              text: `The thread's writing box, with its "Reply" button.`
            },
            rootDeleted: {
              term: "The original message was deleted",
              text: "You can still read the thread but no longer reply to it."
            },
            pins: {
              term: "Pinned messages",
              text: "The list of the conversation's pinned messages. When empty, it suggests pinning an important message."
            },
            pinShow: {
              term: "Show in the conversation",
              text: "Scrolls the conversation to the pinned message and highlights it."
            },
            pinThread: {
              term: "Open the thread",
              text: "Opens the discussion thread of the pinned message."
            },
            pinUnpin: {
              term: "Unpin the message",
              text: "Removes the message from the pinned list."
            },
            close: {
              term: "Close the panel",
              text: "Closes the panel on the right (so does the Esc key)."
            }
          }
        },
        dialogs: {
          title: "New conversation and new channel",
          items: {
            people: {
              term: "People",
              text: "New conversation: choose one colleague for a private conversation, several for a group. Required."
            },
            groupName: {
              term: "Group name",
              text: 'Asked only for a group (several people). The "Create the conversation" button finishes.'
            },
            kind: {
              term: "Channel type",
              text: "General or Discipline: visible to every member of the project. Private: only for the people you choose."
            },
            channelName: {
              term: "Channel name",
              text: "Required. A channel with the same name cannot exist twice in the project."
            },
            discipline: {
              term: "Discipline",
              text: "Asked for a Discipline channel: Architecture, Structure, Roads and utilities (VRD), Fluids (MEP), Electrical, Surveying, Geotechnics or Site coordination (OPC)."
            },
            topic: {
              term: "Topic (optional)",
              text: "One sentence saying what the channel is about."
            },
            members: {
              term: "Channel members",
              text: "For a Private channel, the people who will have access. You are a member automatically."
            },
            submit: {
              term: "Create the channel",
              text: 'Creates the channel. "Cancel" closes the window without creating anything.'
            }
          }
        }
      }
    },
    calendar: {
      title: "Calendar",
      intro: "Your events: meetings, site visits and deadlines from all your projects, in four views. The mini calendar and the filters are in the list on the left.",
      sections: {
        header: {
          title: "Page header",
          items: {
            feeds: {
              term: "ICS subscription",
              text: "Opens the window to show your BatiFlow calendar in Outlook, Google Calendar or Apple Calendar."
            },
            newEvent: {
              term: "New event",
              text: "Opens the form to create an event, on the date shown."
            }
          }
        },
        toolbar: {
          title: "Calendar navigation",
          items: {
            today: {
              term: "Today",
              text: "Goes back to today's date."
            },
            arrows: {
              term: "Previous week, Next week",
              text: "The two arrows move forward or back by one week, or by one month in the Month and Agenda views."
            },
            period: {
              term: "Period shown",
              text: "The title next to the arrows tells which week or month you are looking at."
            },
            week: {
              term: "Week",
              text: "Seven days in columns, with the hours down the side."
            },
            workWeek: {
              term: "Work week",
              text: "Like Week, but Monday to Friday only."
            },
            month: {
              term: "Month",
              text: "A grid of the month. Choose a day to see it in detail."
            },
            agenda: {
              term: "Agenda",
              text: 'A list of your events day by day, with the time or "All day".'
            }
          }
        },
        legend: {
          title: "Event types",
          items: {
            meeting: {
              term: "Meeting",
              text: "People icon, blue colour."
            },
            siteVisit: {
              term: "Site visit",
              text: "Building icon, green colour."
            },
            deadline: {
              term: "Deadline",
              text: "Flag icon, yellow colour."
            },
            other: {
              term: "Other",
              text: "Calendar icon, purple colour."
            },
            readOnly: {
              term: "Padlock",
              text: "The padlock marks a read-only deadline (task, phase or approval): it can only be changed at its source. Each type also has a written name, because colour is never alone."
            }
          }
        },
        grid: {
          title: "Grid and agenda",
          items: {
            allDay: {
              term: "All day",
              text: "Row at the top of the Week views: events without a time."
            },
            event: {
              term: "An event",
              text: "A chip with its title and time. Click it to open its details."
            },
            more: {
              term: "+3 more",
              text: "In the Month view, when a day holds too many events: click to see them all."
            },
            today: {
              term: "Today",
              text: "Today's date is highlighted in the grids and in the agenda."
            },
            empty: {
              term: "No events in this period",
              text: "In the agenda: create an event or change the period."
            },
            truncated: {
              term: "More events than the calendar can show",
              text: "Pick a shorter period (week or month) or filter by project."
            },
            loadFailed: {
              term: "Could not load the calendar",
              text: 'Check your connection, then click "Try again".'
            }
          }
        },
        listPane: {
          title: "Mini calendar and filters (list on the left)",
          items: {
            mini: {
              term: "Mini calendar",
              text: "A small month to choose a day. Days with events are marked."
            },
            scope: {
              term: "Calendar shown",
              text: '"This organisation" or "All my organisations". This choice only shows if you belong to several organisations.'
            },
            kinds: {
              term: "Event types",
              text: "Tick boxes Meeting, Site visit, Deadline, Other: untick a type to hide it."
            },
            project: {
              term: "Project",
              text: 'A list to show only the events of one project. "All projects" removes the filter. It only shows when projects have events.'
            },
            reset: {
              term: "Show everything",
              text: "Removes all filters in one click. The button only shows when a filter is active."
            }
          }
        },
        details: {
          title: "Details of an event",
          items: {
            whenWhere: {
              term: "When, Location",
              text: "The date and time of the event, and the place if one is given."
            },
            projectOrg: {
              term: "Project, Organisation",
              text: "The project or organisation space the event belongs to."
            },
            organiser: {
              term: "Organiser",
              text: "The person who created the event."
            },
            attendees: {
              term: "Attendees",
              text: 'The list of guests with their answer: Accepted, Declined, Maybe or No answer. An "External guest" is a person outside BatiFlow.'
            },
            rsvp: {
              term: "Your answer",
              text: "If you are invited: Accept, Maybe or Decline. Your current answer is shown below."
            },
            join: {
              term: "Join",
              text: "Opens the room of the online meeting. The button only shows for events that have a meeting."
            },
            editDelete: {
              term: "Edit, Delete",
              text: "For people allowed to change the event. Deleting asks for confirmation and cannot be undone: guests will no longer see the event."
            },
            readOnly: {
              term: "Read-only deadline",
              text: `For a deadline coming from a task, a phase or an approval: a link such as "Open the project's tasks" leads to its source, where it is changed.`
            }
          }
        },
        eventDialog: {
          title: "New event and Edit the event",
          items: {
            space: {
              term: "Space",
              text: "Required when creating: the organisation (owners and administrators) or a project where you can contribute. The event is visible to the people who have access to that space."
            },
            title: {
              term: "Title",
              text: "Required: give the event a title."
            },
            kind: {
              term: "Type",
              text: "Meeting, Site visit, Deadline or Other."
            },
            allDay: {
              term: "All day",
              text: 'A switch: no times, only "First day" and "Last day".'
            },
            dates: {
              term: "Start, End",
              text: "Start and end date and time, in Tunis time. The end must be after the start, and an event lasts 31 days at most."
            },
            locationDescription: {
              term: "Location, Description",
              text: "Two free and optional fields: where the event takes place and what people need to know."
            },
            attendees: {
              term: "Attendees",
              text: "Choose the people to invite. Only those with access to the space can be invited, and you are always invited. Guests get a reminder before it starts."
            },
            submit: {
              term: "Create the event, Save",
              text: 'Submits the form. "Cancel" closes the window. An error message tells you what to fix. With no space to contribute to, join a project first.'
            }
          }
        },
        feeds: {
          title: "Subscribe to your calendar (ICS)",
          items: {
            list: {
              term: "Your subscription feeds",
              text: "Each feed shows its name, the organisation, what it contains and when it was created."
            },
            revoke: {
              term: "Revoke",
              text: "Cuts the feed. Subscribed apps receive nothing any more, and this cannot be undone: you will have to create a new feed."
            },
            label: {
              term: "Feed name",
              text: 'Optional, for example "My phone calendar".'
            },
            scope: {
              term: "What the feed contains",
              text: '"Everything you can see" or "Only what concerns you".'
            },
            includeExternal: {
              term: "Include events from spaces shared with partners",
              text: "Tick box to also add the events of spaces shared with other organisations."
            },
            create: {
              term: "Create the feed",
              text: "Creates the feed and shows its subscription address."
            },
            address: {
              term: "Your subscription address",
              text: 'Shown only once: it gives access to your calendar like a password. Copy it with "Copy the address", then click "I have copied the address".'
            },
            limit: {
              term: "Maximum number of feeds",
              text: "When the limit is reached, revoke a feed to create another."
            }
          }
        }
      }
    },
    files: {
      title: "Files",
      intro: "The organisation's files in one place: the latest changed, the organisation's folders, the spaces other organisations share with you, and search. You only see what you are allowed to open.",
      sections: {
        page: {
          title: "The page",
          items: {
            title: {
              term: "Files",
              text: "The page name, at the top. The app also opens with Alt+5."
            },
            tabs: {
              term: "Tabs",
              text: "Recent, Organisation, Shared with me and Search. The open tab stays in the page address."
            }
          }
        },
        recent: {
          title: "Recent",
          items: {
            list: {
              term: "Recent files",
              text: "The documents last added or changed in the folders you can read, newest first."
            },
            line: {
              term: "A line",
              text: "The title, code, project or space, folder and how long ago it changed. Click to open the document."
            }
          }
        },
        organisation: {
          title: "Organisation",
          items: {
            folders: {
              term: "Organisation folders",
              text: "Documents that belong to no project. Sensitive folders (expense notes, vault) only show for the people allowed to read them."
            }
          }
        },
        shared: {
          title: "Shared with me",
          items: {
            spaces: {
              term: "Other organisations' spaces",
              text: "The spaces another organisation invited you to. Click to open the space and its documents."
            }
          }
        },
        search: {
          title: "Search",
          items: {
            field: {
              term: "Search for a file",
              text: "Type at least two letters of the title or code. Only documents you can open are found."
            }
          }
        }
      }
    },
    document: {
      title: "Document",
      intro: "The reader for a project document: you read a PDF or an image, switch version, download and, depending on your rights, annotate.",
      sections: {
        header: {
          title: "Document header",
          items: {
            back: {
              term: "Back to files",
              text: `Goes back to the project's "Files" tab.`
            },
            title: {
              term: "Code and title",
              text: "The document's code (always written left to right), followed by its title."
            },
            version: {
              term: "Document version",
              text: 'A list to choose the version to read. Each line shows a "Revision" (the version letter of a drawing: A, B, C\u2026), then the date. The current version carries the mention "(current version)". The choice is kept in the address.'
            },
            download: {
              term: "Download",
              text: "Takes a copy of the version shown. The button is greyed out while it is being prepared."
            },
            downloadStatus: {
              term: "Preparing a copy with your name\u2026",
              text: "Message during preparation. Downloads can be turned off in this space: you can then read the document without downloading it. If the download does not start, an error message invites you to try again."
            }
          }
        },
        pdfTools: {
          title: "Document tools (PDF)",
          items: {
            thumbnails: {
              term: "Show thumbnails",
              text: "Shows or hides the column of small page images on the side. Click a thumbnail to go to the page."
            },
            pages: {
              term: "Previous page, Next page",
              text: "The two arrows of the bar change page."
            },
            goToPage: {
              term: "Go to page",
              text: 'Type a number then press Enter. Next to it: "of" followed by the total number of pages.'
            },
            zoom: {
              term: "Zoom in, Zoom out",
              text: "Enlarge or reduce the page. The percentage shows between the two buttons."
            },
            fit: {
              term: "Fit to width, Fit to page",
              text: "Adapt the page size to the window: by width or by height."
            },
            search: {
              term: "Search in the document",
              text: "Opens the search bar. Ctrl+F does the same."
            },
            keys: {
              term: "Shortcuts",
              text: "Page Down and Page Up (or the right and left arrows) change page. Home and End go to the first and last page. + and \u2212 zoom."
            },
            watermark: {
              term: "Watermark",
              text: "The preview can carry a watermark with your name, your organisation and the date. A banner reminds you."
            }
          }
        },
        search: {
          title: "Search in the document",
          items: {
            field: {
              term: "Search\u2026",
              text: "Type a word: the results are highlighted in the pages."
            },
            result: {
              term: "Previous result, Next result",
              text: 'Move from one result to the next. The position shows as "Result 2 of 5".'
            },
            state: {
              term: "Searching\u2026, No results",
              text: "Status messages during or after the search."
            },
            close: {
              term: "Close search",
              text: "Hides the search bar."
            }
          }
        },
        imageTools: {
          title: "Image tools",
          items: {
            zoom: {
              term: "Zoom in, Zoom out",
              text: "Enlarge or reduce the image. The percentage shows between the two buttons."
            },
            fit: {
              term: "Fit to window",
              text: "Puts the image back to the size of the window (key 0)."
            },
            keys: {
              term: "Shortcuts",
              text: "The arrows move the image, + and \u2212 zoom."
            }
          }
        },
        annotationTools: {
          title: "Annotation tools",
          items: {
            tools: {
              term: "Annotation tools",
              text: "Select, Rectangle, Revision cloud (to circle an area to review), Arrow and Text. They only show if you may comment."
            },
            colors: {
              term: "Colour",
              text: "Red, Orange, Green, Blue or Black, for the next drawing."
            },
            draw: {
              term: "Draw on the page",
              text: "With the mouse, draw the shape. With the keyboard, the arrows move a crosshair, Enter sets the first corner then the opposite one, Escape cancels."
            },
            list: {
              term: "Show the list of annotations",
              text: "Opens or closes the list of annotations of the version shown."
            }
          }
        },
        annotationPanel: {
          title: "Annotations (list and details)",
          items: {
            filters: {
              term: "Filter by state, Filter by organisation",
              text: "State: All, Open or Resolved. Organisation: all or just one, when partners have annotated too."
            },
            item: {
              term: "Annotation 1 \xB7 Page 3",
              text: "Each line gives the annotation number, its page, its state (Open or Resolved) and the organisation of its author: My organisation or Partner organisation."
            },
            empty: {
              term: "No annotation on this version yet",
              text: "The list is empty, or no annotation matches the filters."
            },
            new: {
              term: "New annotation",
              text: 'After drawing: "Comment" (required, 2,000 characters at most) explains what to correct. For a text: "Text shown on the plan" (500 characters at most). "Add the annotation" submits.'
            },
            details: {
              term: "Details of an annotation",
              text: 'The comment, the author and the date. Buttons "Resolve" (or "Reopen"), "Edit" (not possible once resolved) and "Delete", depending on your rights.'
            },
            thread: {
              term: "Discussion",
              text: 'The replies to the annotation. "Reply" opens a field, "Send" posts. You need the right to comment.'
            }
          }
        },
        states: {
          title: "Preview status messages",
          items: {
            preparing: {
              term: "Preparing the preview\u2026",
              text: "The file is being converted for display, usually in a few seconds. The page updates by itself."
            },
            unavailable: {
              term: "This file is being uploaded or checked",
              text: "It can be read once the upload and the antivirus check are finished. If it is rejected, it cannot be opened."
            },
            none: {
              term: "No preview for this type of file",
              text: "Download the file to open it with another application."
            },
            failed: {
              term: "The preview couldn't be generated",
              text: "The file may be damaged: download it or upload a new version."
            },
            password: {
              term: "This PDF is password-protected",
              text: "It can't be shown here: download it to open it."
            },
            noVersion: {
              term: "This document has no version to view yet",
              text: "A version will appear as soon as its check is complete."
            },
            notFound: {
              term: "Document not found",
              text: `It doesn't exist, or you don't have access to it. The "Back to files" button takes you back to the project.`
            },
            noSpace: {
              term: "The file space isn't ready yet",
              text: "The documents will be available once the project's internal space has been created."
            }
          }
        }
      }
    },
    search: {
      title: "Search results",
      intro: "All the results of a search in the organisation: projects, documents, tasks, clients and messages. You arrive here from the search in the header.",
      sections: {
        page: {
          title: "The results page",
          items: {
            field: {
              term: "Your search",
              text: "Type at least 2 characters. The page updates when you pause, and the search is kept in the address."
            },
            scope: {
              term: "Result type",
              text: "Chips All, Projects, Documents, Tasks, Clients to keep a single type. The chosen chip is dark."
            },
            count: {
              term: "Number of results",
              text: 'For example "12 results".'
            },
            hasMore: {
              term: "More results: refine your search.",
              text: "Each type shows at most 20 results. If there are more, narrow your search."
            }
          }
        },
        flyout: {
          title: "Quick search in the header",
          items: {
            open: {
              term: "Search projects, files, messages\u2026",
              text: "The header field (or Ctrl+K, or /) opens a search window across the organisation."
            },
            field: {
              term: "Search the organisation",
              text: "The field of this window. It shows a few results per type."
            },
            more: {
              term: "See all projects, documents, tasks\u2026",
              text: "The last line of a type opens the results page limited to that type."
            },
            all: {
              term: "See all results for\u2026",
              text: "Opens this page with all the results of your search."
            },
            close: {
              term: "Esc",
              text: "Closes the window."
            }
          }
        },
        results: {
          title: "List of results",
          items: {
            groups: {
              term: "Projects, Documents, Tasks, Clients, Messages",
              text: "Results are sorted by type, in this order."
            },
            hit: {
              term: "A result line",
              text: "An icon for the type, then the title with the words found in bold on a coloured background. A code (of a project or document) shows beside it, and the channel name for a message."
            },
            open: {
              term: "Open a result",
              text: "Click or press Enter: a project or client opens, a document in the reader, a task in its project's tasks, a message in its conversation."
            },
            keyboard: {
              term: "With the keyboard",
              text: "The up and down arrows move through the results without leaving the typing field, and Enter opens the highlighted one."
            }
          }
        },
        states: {
          title: "Search states",
          items: {
            prompt: {
              term: "Type at least 2 characters to start searching.",
              text: 'Message while nothing is typed. "Type at least 2 characters." shows if the text is too short.'
            },
            loading: {
              term: "Searching\u2026",
              text: "A spinner turns while loading."
            },
            empty: {
              term: "No results for\u2026",
              text: "Check the spelling or try another word."
            },
            error: {
              term: "Too many searches, The search did not complete",
              text: 'In the first case, wait a moment: the number of searches per minute is limited. In both cases the "Try again" button runs the search again.'
            }
          }
        }
      }
    },
    more: {
      title: "More",
      intro: "Shortcuts to the rest of BatiFlow: clients, partnerships and office administration. Each one only shows if you have the right to it.",
      sections: {
        header: {
          title: "The page",
          items: {
            title: {
              term: "More",
              text: "The name of the page. The app also opens with Alt+7."
            },
            cards: {
              term: "Cards",
              text: "Each card is a link: click it to open the page. If you have the right to none, the page only shows the message at the bottom."
            }
          }
        },
        cards: {
          title: "The cards",
          items: {
            clients: {
              term: "Clients",
              text: "Project owners: tax profile, contacts and details. For people who can view clients."
            },
            partnerships: {
              term: "Partnerships",
              text: "Partnership requests received, and spaces of other organisations where you manage your delegates. Owners and administrators only."
            },
            approvals: {
              term: "External access approvals",
              text: "Grant or refuse a member access to another organisation's space. For people who have this approval right."
            },
            admin: {
              term: "Administration",
              text: "Members, invitations, roles and permissions of your office. Shows if you can open at least one administration page."
            }
          }
        },
        note: {
          title: "Message at the bottom",
          items: {
            soon: {
              term: "More sections will arrive",
              text: "Sentence at the bottom of the page: more sections (clients, tenders\u2026) will arrive in a future version of BatiFlow."
            },
            empty: {
              term: "No card",
              text: "If no card shows, your role opens none of these pages: ask an administrator of your office."
            }
          }
        }
      }
    },
    spaces: {
      title: "Shared spaces",
      intro: "This page lists the shared spaces you can reach: those of your own organisations and those of other organisations that opened their door to you. A shared space brings together people from several organisations around a project or a common topic.",
      sections: {
        header: {
          title: "Page header",
          items: {
            title: {
              term: "Shared spaces",
              text: "The page title, followed by a short sentence that reminds you what a shared space is."
            },
            newSpace: {
              term: "New shared space",
              text: "Opens the window to create a space. This button only appears if your role allows you to create spaces in the active organisation."
            },
            waiting: {
              term: "See the invitations",
              text: 'A blue bar shown only when invitations are waiting for your answer. The link opens the "Invitations to spaces" page.'
            }
          }
        },
        ownList: {
          title: "Spaces of my organisations",
          items: {
            list: {
              term: "Spaces of my organisations",
              text: "The spaces hosted by your own organisations: project spaces, shared spaces and working groups. Click a row to open the space."
            },
            empty: {
              term: "No shared spaces in your organisations",
              text: 'Message shown while no space exists yet. It offers the "New shared space" button if you are allowed to create one.'
            }
          }
        },
        externalList: {
          title: "External spaces",
          items: {
            list: {
              term: "External spaces",
              text: 'The spaces of other organisations that gave you access (partner, client, guest). Each row carries the "External" chip.'
            },
            empty: {
              term: "No external spaces",
              text: "Message shown while no other organisation has opened a space to you."
            },
            loadFailed: {
              term: "Your spaces could not be loaded",
              text: 'A red message shown if the list did not load. Check your connection, then use the "Try again" button.'
            }
          }
        },
        row: {
          title: "A space row",
          items: {
            name: {
              term: "Space name",
              text: "The name of the space, with the logo of the organisation that hosts it. The whole row is a link that opens the space."
            },
            kind: {
              term: "Type of space",
              text: "Organisation space, Project space, Shared space (linked to a project and open to partners) or Working group (no project, for your teams)."
            },
            host: {
              term: "Hosted by",
              text: "The name of the organisation that hosts the space and sets its rules."
            },
            access: {
              term: "Access: \u2026",
              text: 'For an external space only: how you got in (for example "Named invitation" or "Guest"), your rights ("Read only", "Read and write" or "Read, write and approve") and the end date, or "No end date".'
            },
            external: {
              term: "External",
              text: "A chip that flags a space hosted by an organisation other than your own."
            },
            closed: {
              term: "Closed",
              text: "A chip with a padlock: the space is closed, its content can still be read but not changed."
            }
          }
        },
        newDialog: {
          title: '"New shared space" window',
          items: {
            intro: {
              term: "New shared space",
              text: "You will be the manager of the space. You can then invite partner organisations to it."
            },
            kind: {
              term: "Type of space",
              text: '"Shared space of a project" is linked to one of the projects you manage. "Working group" has no project: this choice is reserved for owners and administrators.'
            },
            project: {
              term: "Project",
              text: "The projects you manage (code and name). Choose the one the space is linked to. If you manage none, a blue message explains it."
            },
            name: {
              term: "Space name",
              text: "Required, 200 characters at most. This is the name every participant will see."
            },
            submit: {
              term: "Create the space",
              text: 'Creates the space and opens it straight away. "Cancel" closes the window without creating anything.'
            },
            planLimit: {
              term: "Your plan does not allow hosting more shared spaces",
              text: "Message shown when your plan has reached its limit of spaces. Contact the account owner to move to a higher plan."
            }
          }
        }
      }
    },
    spaceInvitations: {
      title: "Invitations to spaces",
      intro: "This page gathers the invitations waiting for your answer: those addressed to you, and the partnership requests addressed to an organisation you administer. Invitation e-mails lead here.",
      sections: {
        header: {
          title: "Page header",
          items: {
            title: {
              term: "Invitations to spaces",
              text: "The page title, followed by a sentence that says what you see: the invitations waiting for your answer, to you or to an organisation you administer."
            }
          }
        },
        card: {
          title: "An invitation",
          items: {
            sentence: {
              term: "Invitation sentence",
              text: "Says who invites you, to which space, and which organisation hosts it. The logo of the host organisation is on the left."
            },
            kind: {
              term: "Partnership request",
              text: 'A chip for the type of invitation: "Partnership request" (for your organisation), "Named invitation" (for you) or "Guest" (limited, temporary access).'
            },
            scope: {
              term: "The whole space",
              text: 'What the access covers: the whole space, or "Folders: 2 \xB7 Channels: 1" when the access is limited to chosen folders and channels.'
            },
            rights: {
              term: "Rights: \u2026",
              text: 'What you will be able to do: "Read only", "Read and write" or "Read, write and approve".'
            },
            memberCap: {
              term: "Up to \u2026 people",
              text: "For a partnership request: the maximum number of people your organisation can add to the space."
            },
            dates: {
              term: "To answer before \u2026",
              text: 'The deadline to answer. When it is shown, "Until \u2026" also gives the end date of the access.'
            }
          }
        },
        answers: {
          title: "Answering an invitation",
          items: {
            accept: {
              term: "Accept",
              text: "For an invitation to you: you join the space and it opens. For a partnership request: your organisation becomes a partner, then you choose the people who reach it."
            },
            decline: {
              term: "Decline",
              text: "Opens a confirmation window. The host can invite you again later."
            },
            declineDialog: {
              term: "Decline the invitation to the space \u2026 ?",
              text: 'Confirm with "Decline" or go back with "Cancel". A message then confirms the refusal.'
            }
          }
        },
        states: {
          title: "When there is nothing to show",
          items: {
            empty: {
              term: "No pending invitation",
              text: 'Message shown when no invitation is waiting for your answer. The "See my shared spaces" button leads to the list of your spaces.'
            },
            loadFailed: {
              term: "The invitations could not be loaded",
              text: 'A red message shown if the list did not load. Use "Try again" after checking your connection.'
            }
          }
        }
      }
    },
    space: {
      documents: {
        title: "Documents",
        intro: "The Documents tab of a shared space: the folders of the space, the files they hold and their versions. It is used to drop, file and read the documents that the host organisation and its partners exchange.",
        sections: {
          frame: {
            title: "Space frame",
            items: {
              banner: {
                term: "External space hosted by\u2026",
                text: "A permanent bar shown when the space belongs to another organisation: it reminds you that its content follows the rules of that organisation."
              },
              summary: {
                term: "Hosted by",
                text: 'A strip under the title: the organisation that hosts the space, its type (for example "Shared space" or "Working group"), the "Closed" chip when the space is closed and, in an external space, your access: how you got in, your rights and the end date.'
              },
              guestNotice: {
                term: "Your guest access ends on \u2026",
                text: "A bar for guests: it gives the end date of your access. It turns into a warning in the last 14 days: ask the person who invited you to extend it."
              },
              tabs: {
                term: "Tabs",
                text: 'The tab bar of the space. Only the tabs your access lets you open are shown. The breadcrumb above ("Shared spaces") leads back to the list of your spaces.'
              },
              unavailable: {
                term: "Space not found",
                text: 'Shown if the space does not exist or you no longer have access to it: ask for a new invitation. "The space could not be loaded" points to a connection problem ("Try again" button), and "Nothing to show yet" to an access that does not give any content yet.'
              }
            }
          },
          folders: {
            title: "Folders",
            items: {
              tree: {
                term: "Project folders",
                text: 'The folder tree, on the left. "All folders" is the root. Click a folder to open it; subfolders unfold as you go.'
              },
              breadcrumb: {
                term: "Folder path",
                text: 'The folders that lead to the open folder; click one to go back to it. A "\u2026" replaces a folder you cannot access.'
              },
              customRights: {
                term: "Custom permissions",
                text: "A chip with a padlock: this folder has its own access rules, different from those of the space."
              },
              newFolder: {
                term: "New folder",
                text: "Creates a folder inside the open folder (or at the root). Only shown if you are allowed to write there."
              },
              menu: {
                term: "More actions",
                text: `The three-dot menu for folder managers: "Rename\u2026", "Move\u2026", "Permissions\u2026" (missing in another organisation's space) and "Delete". Delete sends the folder to the trash.`
              },
              empty: {
                term: "No folders yet",
                text: 'Message shown when the space has no folder visible to you yet. It offers "New folder" if you can create one; otherwise ask a manager. In an empty folder, "No subfolders" says so.'
              }
            }
          },
          upload: {
            title: "Adding files",
            items: {
              zone: {
                term: "Drag and drop files or folders here",
                text: "The upload zone, shown in a folder where you can write. Drop files or a whole folder on it: everything is added to the open folder. The maximum size per file is written under the title."
              },
              buttons: {
                term: "Add files",
                text: `Opens the file picker of your computer. "Add a folder" does the same for a whole folder. These buttons are inactive if the host's account is read-only.`
              },
              infoDialog: {
                term: "Document information",
                text: 'A window that opens before sending: Discipline, Phase, Document type, Zone, Scale and the Title of each document. This information files the document and builds its code ("Planned code").'
              },
              skip: {
                term: "Add without information",
                text: "Sends the files without filling in the window. You can complete the information later."
              },
              statuses: {
                term: "Sending",
                text: 'Each file gets its own line with its progress, then its result: "Virus check in progress", "Added to the folder", "Refused" (with the reason) or "Sending failed".'
              },
              rowButtons: {
                term: "Cancel",
                text: 'On an upload line: "Cancel" stops the upload, "Retry" starts it again after a failure, "Remove" clears the line from the list.'
              }
            }
          },
          list: {
            title: "Documents of the folder",
            items: {
              search: {
                term: "Search documents",
                text: 'The search box ("Code or title"). The list updates when you stop typing.'
              },
              filters: {
                term: "Discipline",
                text: 'Three filter chips: Discipline, Phase and Document type. Choose a value in the menu; "All" removes the filter. "Clear filters" removes them all.'
              },
              columns: {
                term: "Code, Title, Index\u2026",
                text: 'Table columns: Code, Title, Index (the version letter of a document: A, B, C\u2026), Discipline, Phase, Status, Approval, Modified and Author organisation ("Partner" if it is not yours). Code, Title and Modified sort when you click their header.'
              },
              selection: {
                term: "Clear selection",
                text: 'Tick rows to show the selection bar: the number of documents chosen, "Move to\u2026", "Delete" (only if you may do it on every one) and "Clear selection".'
              },
              more: {
                term: "Show more documents",
                text: "The list is shown page by page. This button loads the next page; the number of documents shown is written beside it."
              },
              empty: {
                term: "No documents yet",
                text: 'Message of an empty folder. It invites you to drop files, or says the documents will appear here if you can only read. "No document matches" appears when a filter finds nothing.'
              }
            }
          },
          statuses: {
            title: "Document statuses",
            items: {
              uploading: {
                term: "Uploading",
                text: "The file is arriving on the server."
              },
              scanning: {
                term: "Antivirus check",
                text: "The file is being checked by the antivirus. It can be read once the check is done."
              },
              available: {
                term: "Available",
                text: "The file is checked: you can open it."
              },
              rejected: {
                term: "Refused",
                text: "The file was refused (virus, type not accepted, size\u2026). The reason is written in the version history."
              },
              inApproval: {
                term: "In approval",
                text: 'In the "Approval" column: an approval workflow is running. Until it ends, the document cannot receive a new version.'
              }
            }
          },
          panel: {
            title: "Document panel",
            items: {
              open: {
                term: "Open",
                text: `Click a row to open the panel on the right (Esc closes it). "Open" shows the document in the viewer; this button does not exist in another organisation's space.`
              },
              details: {
                term: "Details",
                text: "Code (read-only), Title, Index, Discipline, Phase, Document type, Zone, Scale, Status, Author organisation, Modified and Linked deliverables. A blue message says what is missing before the code can be assigned."
              },
              edit: {
                term: "Edit",
                text: "Opens the form to change the title and the information. Only shown if you may edit this document."
              },
              approval: {
                term: "Approval",
                text: `The approval workflows of the document, with their steps. "Request approval" starts a workflow: it is missing in another organisation's space. VSO means approved without comments, VAO approved with comments, REF refused.`
              },
              versions: {
                term: "Versions",
                text: 'The history, newest first: index, reason, author and organisation, date, code and SHA-256 fingerprint (the copy button copies it whole). "Current version" marks the latest one.'
              },
              versionButtons: {
                term: "New version",
                text: 'Adds a file as a new version, with the next index. "Restore" adds an older version as a new version: nothing is erased. Both ask for a reason, and are missing while an approval is running.'
              }
            }
          },
          trash: {
            title: "Trash",
            items: {
              open: {
                term: "Trash",
                text: 'A button under the folder tree: it replaces the list with the trash. "Back to files" returns to the folders.'
              },
              intro: {
                term: "Deleted items",
                text: "Deleted folders and documents stay there for the number of days written at the top of the page, then are removed for good. Managers see everything; everyone else sees what they deleted."
              },
              restore: {
                term: "Restore",
                text: "Puts the item back in its place. If its original folder is in the trash too, restore that folder first."
              },
              purge: {
                term: "Delete for good",
                text: "Erases the item, its versions and its files, after confirmation. This cannot be undone."
              },
              empty: {
                term: "The trash is empty",
                text: "Message shown when nothing has been deleted."
              }
            }
          }
        }
      },
      chat: {
        title: "Conversations",
        intro: "The Conversations tab of a shared space: the channels of the space and their messages. It is used to talk with the people of the host organisation and of partner organisations.",
        sections: {
          frame: {
            title: "Space frame",
            items: {
              banner: {
                term: "External space hosted by\u2026",
                text: "A permanent bar shown when the space belongs to another organisation: it reminds you that its content follows the rules of that organisation."
              },
              summary: {
                term: "Hosted by",
                text: 'A strip under the title: the organisation that hosts the space, its type, the "Closed" chip when the space is closed and, in an external space, your access: how you got in, your rights and the end date.'
              },
              guestNotice: {
                term: "Your guest access ends on \u2026",
                text: "A bar for guests: it gives the end date of your access. It turns into a warning in the last 14 days."
              },
              tabs: {
                term: "Tabs",
                text: 'The tab bar of the space. You are in the "Conversations" tab; only the tabs your access lets you open are shown.'
              }
            }
          },
          channels: {
            title: "Channels",
            items: {
              list: {
                term: "Channels",
                text: "The list of the space's channels you can see, on the left. Click a channel to read its messages; the open channel is highlighted."
              },
              unread: {
                term: "Unread messages",
                text: "A chip with a number appears beside a channel that holds messages you have not read, and its name turns bold."
              },
              empty: {
                term: "No channels yet",
                text: "Message shown while the space has no channel visible to you."
              },
              pick: {
                term: "Choose a channel",
                text: "Invites you to select a channel in the list to read and write messages."
              },
              loadFailed: {
                term: "The channels could not be loaded",
                text: 'Shown if the list did not load. Use "Try again" in a moment.'
              }
            }
          },
          conversation: {
            title: "Conversation",
            items: {
              title: {
                term: "Channel name",
                text: "The name of the open channel, with its topic underneath when it has one."
              },
              pins: {
                term: "Pinned messages",
                text: "Opens the panel of the channel's pinned messages. The number in brackets is the number of pinned messages."
              },
              messages: {
                term: "Messages",
                text: 'The messages, newest at the bottom, split by day ("Today", "Yesterday" or the date). Each message shows its author, the time, and "edited" if it was corrected. A deleted message is replaced by "This message was deleted".'
              },
              external: {
                term: "External \xB7 \u2026",
                text: "A yellow chip beside the name of a person from another organisation, with the name of that organisation."
              },
              pinned: {
                term: "Pinned",
                text: 'Marks a pinned message: you also find it in "Pinned messages".'
              },
              jump: {
                term: "Latest messages",
                text: 'A button that appears when you have scrolled up in the conversation: it takes you back to the bottom. "Loading earlier messages\u2026" shows while older messages arrive.'
              },
              empty: {
                term: "No messages yet",
                text: "Message of an empty channel. Write the first message if you are allowed to write."
              }
            }
          },
          actions: {
            title: "Actions on a message",
            items: {
              toolbar: {
                term: "Actions on the message of \u2026",
                text: "A small bar appears when you hover over a message (always visible on a phone): reaction, reply in a thread, pin, edit and delete."
              },
              react: {
                term: "Add a reaction",
                text: "Adds an emoji under the message so you can react without writing a reply."
              },
              thread: {
                term: "Reply in a thread",
                text: "Opens the message's thread in a panel on the right, to reply without cluttering the channel. Not available to a guest without an organisation."
              },
              pin: {
                term: "Pin the message",
                text: 'Pins the message so you can find it in "Pinned messages". The same button becomes "Unpin the message". A channel holds 50 at most. Missing in a read-only channel.'
              },
              editDelete: {
                term: "Edit the message",
                text: `You can edit your own messages. "Delete the message" is offered for your own and, to moderators, for other people's: it asks for confirmation and the deletion is final.`
              },
              sending: {
                term: "Message not sent.",
                text: 'A message being sent shows "Sending\u2026". If it fails: "Try again" sends it again, "Put the text back" puts it back in the writing box, "Delete" drops it.'
              }
            }
          },
          composer: {
            title: "Writing a message",
            items: {
              box: {
                term: "Write a message",
                text: "The writing box at the bottom. Enter sends the message, Shift+Enter starts a new line and @ lets you mention someone. Unsent text is kept if you switch channels."
              },
              attach: {
                term: "Attach a file",
                text: "Attaches one or more files to the message. They are sent to the channel's attachments folder; wait until they are sent before sending the message."
              },
              send: {
                term: "Send",
                text: "Sends the message. It is greyed out while the box is empty."
              },
              typing: {
                term: "Someone is typing\u2026",
                text: "A line above the writing box says who is typing."
              },
              blocked: {
                term: "This channel is archived: you can read it but no longer write in it.",
                text: 'Replaces the writing box when the channel is archived. "You can read this conversation but not write in it" shows when your access is read-only.'
              }
            }
          },
          attachments: {
            title: "Attached files and panels",
            items: {
              cards: {
                term: "Files attached to the message from \u2026",
                text: 'Under the message, one card per file with its state ("Sending", "Antivirus check in progress", "Available" or refused).'
              },
              openDownload: {
                term: "Download",
                text: '"Open" shows the file; "Download" saves it on your computer. If the space forbids downloads, a message says so.'
              },
              noAccess: {
                term: "You do not have access to this file",
                text: "The file is kept in a folder you cannot view. Ask the person who sent it for access."
              },
              threadPanel: {
                term: "Thread",
                text: 'A panel on the right: the original message, its replies, and a "Reply in the thread" box with the "Reply" button.'
              },
              pinsPanel: {
                term: "Pinned messages",
                text: 'A panel on the right: the list of pinned messages, with "Show in the conversation", "Open the thread" and "Unpin the message".'
              }
            }
          }
        }
      },
      calendar: {
        title: "Calendar",
        intro: 'The Calendar tab of a shared space. It is announced but not available yet: for now the page shows a "coming soon" message.',
        sections: {
          header: {
            title: "Space header",
            items: {
              banner: {
                term: "External space hosted by\u2026",
                text: "A permanent bar shown when the space belongs to another organisation: it reminds you that its content follows the rules of that organisation."
              },
              summary: {
                term: "Hosted by",
                text: 'A strip under the title: the organisation that hosts the space, its type, the "Closed" chip when the space is closed and, in an external space, your access: how you got in, your rights and the end date.'
              }
            }
          },
          tabs: {
            title: "Tabs",
            items: {
              tabList: {
                term: "Tabs",
                text: 'The tab bar of the space. Only the tabs your access lets you open are shown. The breadcrumb above ("Shared spaces") leads back to the list of your spaces.'
              },
              thisTab: {
                term: "Calendar",
                text: "The tab you are on. It only appears if your access to the space allows it."
              }
            }
          },
          comingSoon: {
            title: "Tab content",
            items: {
              title: {
                term: "The space calendar is coming soon",
                text: "The title of the message shown in place of the calendar. For now there is nothing to type or click in this tab."
              },
              description: {
                term: "The space's events and appointments will appear here.",
                text: "What the tab will hold in the end: the events and appointments of the space."
              }
            }
          }
        }
      },
      meetings: {
        title: "Meetings",
        intro: 'The Meetings tab of a shared space. It is announced but not available yet: for now the page shows a "coming soon" message.',
        sections: {
          header: {
            title: "Space header",
            items: {
              banner: {
                term: "External space hosted by\u2026",
                text: "A permanent bar shown when the space belongs to another organisation: it reminds you that its content follows the rules of that organisation."
              },
              summary: {
                term: "Hosted by",
                text: 'A strip under the title: the organisation that hosts the space, its type, the "Closed" chip when the space is closed and, in an external space, your access: how you got in, your rights and the end date.'
              }
            }
          },
          tabs: {
            title: "Tabs",
            items: {
              tabList: {
                term: "Tabs",
                text: 'The tab bar of the space. Only the tabs your access lets you open are shown. The breadcrumb above ("Shared spaces") leads back to the list of your spaces.'
              },
              thisTab: {
                term: "Meetings",
                text: "The tab you are on. It only appears if your access to the space allows it."
              }
            }
          },
          comingSoon: {
            title: "Tab content",
            items: {
              title: {
                term: "Space meetings are coming soon",
                text: "The title of the message shown in place of the meetings. For now there is nothing to type or click in this tab."
              },
              description: {
                term: "You will be able to start and join the space's meetings here.",
                text: "What the tab will allow in the end: starting a meeting of the space and joining the ones in progress."
              }
            }
          }
        }
      },
      people: {
        title: "People",
        intro: "The People tab of a shared space: everyone who has access to it, from the host organisation and from partner organisations, with how each person got in.",
        sections: {
          frame: {
            title: "Space frame",
            items: {
              banner: {
                term: "External space hosted by\u2026",
                text: "A permanent bar shown when the space belongs to another organisation: it reminds you that its content follows the rules of that organisation."
              },
              summary: {
                term: "Hosted by",
                text: 'A strip under the title: the organisation that hosts the space, its type, the "Closed" chip when the space is closed and, in an external space, your access: how you got in, your rights and the end date.'
              },
              guestNotice: {
                term: "Your guest access ends on \u2026",
                text: "A bar for guests: it gives the end date of your access. It turns into a warning in the last 14 days."
              },
              tabs: {
                term: "Tabs",
                text: 'The tab bar of the space. You are in the "People" tab; only the tabs your access lets you open are shown.'
              }
            }
          },
          list: {
            title: "People with access",
            items: {
              heading: {
                term: "People with access",
                text: 'Everyone who reaches the space, with the organisation they are here for. To invite someone, use the "Partner organisations" tab.'
              },
              name: {
                term: "Person's name",
                text: 'One row per person, with a chip that says how they got in: "Host member", "Partner delegate", "Named guest" or "Guest".'
              },
              organisation: {
                term: "Organisation: \u2026",
                text: "The organisation on whose behalf the person reaches the space."
              },
              scope: {
                term: "The whole space",
                text: 'What their access covers: the whole space, or "Folders: 2 \xB7 Channels: 1" when it is limited to chosen folders and channels.'
              },
              rights: {
                term: "Rights: \u2026",
                text: '"Read only", "Read and write" or "Read, write and approve", followed by "Until \u2026" or "No end date".'
              }
            }
          },
          actions: {
            title: "Actions on a person",
            items: {
              extend: {
                term: "Extend by 90 days",
                text: "For a guest only, and for the people who manage the space: pushes the end of their access back by 90 days. A message confirms the new date."
              },
              remove: {
                term: "Remove",
                text: 'Removes the person from the space after a confirmation ("Remove \u2026 from the space?"): their access ends immediately. The button only appears if you are allowed to remove them, and never in a closed space.'
              }
            }
          },
          states: {
            title: "When there is nothing to show",
            items: {
              empty: {
                term: "Nobody else has access to this space",
                text: "Message shown while nobody else has come in: host members, partner delegates and guests will appear here."
              },
              loadFailed: {
                term: "The people could not be loaded",
                text: 'A red message shown if the list did not load. Use "Try again" after checking your connection.'
              }
            }
          }
        }
      },
      partners: {
        title: "Partner organisations",
        intro: "The Partner organisations tab of a shared space, reserved for the managers of the host organisation. It is used to share the space with other organisations, to invite people and to follow the pending invitations.",
        sections: {
          frame: {
            title: "Space frame",
            items: {
              banner: {
                term: "External space hosted by\u2026",
                text: "A permanent bar shown when the space belongs to another organisation: it reminds you that its content follows the rules of that organisation."
              },
              summary: {
                term: "Hosted by",
                text: 'A strip under the title: the organisation that hosts the space, its type, the "Closed" chip when the space is closed and, in an external space, your access: how you got in, your rights and the end date.'
              },
              tabs: {
                term: "Tabs",
                text: 'The tab bar of the space. You are in the "Partner organisations" tab; only the tabs your access lets you open are shown.'
              }
            }
          },
          partnersList: {
            title: "Partner organisations",
            items: {
              heading: {
                term: "Partner organisations",
                text: "The organisations this space is shared with, what they can reach and how many people they added."
              },
              share: {
                term: "Share with an organisation",
                text: "Opens the window to invite an organisation. Missing in a closed space."
              },
              status: {
                term: "Waiting for an answer",
                text: 'A status chip for the organisation: "Waiting for an answer", "Active", "Declined", "Expired" or "Removed". Pending requests are listed first.'
              },
              details: {
                term: "People: x/y",
                text: 'Under the name: what the organisation can reach ("The whole space" or chosen folders and channels), its rights, the number of people it added out of the maximum allowed, and "Until \u2026" or "No end date".'
              },
              remove: {
                term: "Remove",
                text: "Removes the organisation, or withdraws a request still waiting, after confirmation. Everyone from that organisation loses access immediately; you can invite it again."
              },
              empty: {
                term: "No partner organisation",
                text: "Message shown while the space is shared with nobody. The invited organisation will choose the people who access it."
              }
            }
          },
          invitations: {
            title: "Pending invitations",
            items: {
              heading: {
                term: "Pending invitations",
                text: "People invited by e-mail who have not answered yet."
              },
              invite: {
                term: "Invite a person",
                text: "Opens the window to invite a person. Missing in a closed space."
              },
              row: {
                term: "E-mail address and status",
                text: 'Each row shows the invited address, a status chip ("Waiting for an answer" or "Waiting for approval from their organisation") and the type of invitation ("Named person" or "Guest").'
              },
              details: {
                term: "To answer before \u2026",
                text: "What the access covers, the rights, and the deadline for the invited person to answer."
              },
              cancel: {
                term: "Cancel",
                text: "Cancels the invitation after confirmation: the person can no longer use the link they received. You can invite them again."
              },
              empty: {
                term: "No pending invitation",
                text: "Message shown when no invitation is waiting for an answer."
              }
            }
          },
          shareDialog: {
            title: '"Share with an organisation" window',
            items: {
              taxId: {
                term: "The organisation's tax ID",
                text: "Enter the tax ID. The name of the organisation found is shown so you can check it is the right one; otherwise a message says no BatiFlow organisation matches."
              },
              scope: {
                term: "What the access covers",
                text: '"The whole space", or "Only chosen folders and channels": you then tick the folders (a chosen folder also gives access to its subfolders) and the channels.'
              },
              rights: {
                term: "Rights",
                text: "Read (view documents and conversations), Write (view, add and edit) or Write and approve (also approve documents)."
              },
              cap: {
                term: "Maximum number of people",
                text: "How many people the organisation may add to the space, from 1 to 500."
              },
              end: {
                term: "End date (optional)",
                text: "Leave empty: the access lasts until you remove it."
              },
              submit: {
                term: "Send the invitation",
                text: "Sends the invitation. The organisation must accept it, then its administrators choose who reaches the space. Your identity may be asked again before sending."
              }
            }
          },
          inviteDialog: {
            title: '"Invite a person" window',
            items: {
              email: {
                term: "E-mail address",
                text: "The address of the person to invite. The invitation is sent to it; the address never appears in the link."
              },
              kind: {
                term: "Type of invitation",
                text: '"Named person": a person from another organisation, with the access and end date you choose; their organisation may have to approve. "Guest": a person without a BatiFlow account, limited to chosen folders or channels.'
              },
              scope: {
                term: "What the access covers",
                text: 'As for an organisation. A guest never gets "The whole space": choose at least one folder or channel.'
              },
              rights: {
                term: "Rights",
                text: "Read, Write or Write and approve, as for an organisation."
              },
              end: {
                term: "End date (optional)",
                text: 'For a named person only. A guest keeps their access for 90 days; you can then extend it by 90 days from the "People" tab.'
              },
              submit: {
                term: "Send the invitation",
                text: "Sends the invitation, or saves it until the person's organisation approves. If your plan no longer allows inviting guests, a message explains it."
              }
            }
          }
        }
      },
      delegates: {
        title: "My delegates",
        intro: "The My delegates tab of a shared space, reserved for the administrator of a partner organisation. It is used to choose, among the members of your organisation, who reaches the space, within the limits of your partnership.",
        sections: {
          frame: {
            title: "Space frame",
            items: {
              banner: {
                term: "External space hosted by\u2026",
                text: "A permanent bar shown when the space belongs to another organisation: it reminds you that its content follows the rules of that organisation."
              },
              summary: {
                term: "Hosted by",
                text: 'A strip under the title: the organisation that hosts the space, its type, the "Closed" chip when the space is closed and your access: how you got in, your rights and the end date.'
              },
              tabs: {
                term: "Tabs",
                text: 'The tab bar of the space. You are in the "My delegates" tab; only the tabs your access lets you open are shown.'
              }
            }
          },
          list: {
            title: "Manage my delegates",
            items: {
              heading: {
                term: "Manage my delegates",
                text: "The people of your organisation who reach this space. You choose who, within what your partnership allows."
              },
              usage: {
                term: "People added: x/y",
                text: "The number of people you added out of the maximum set by your partnership."
              },
              capReached: {
                term: "You have reached the maximum number of people of your partnership",
                text: "A warning shown when the maximum is reached. Remove a delegate, or ask the host organisation to raise the limit."
              },
              add: {
                term: "Add a member",
                text: "Opens the window to add people. The button disappears if the partnership is not active, if the maximum is reached or if the space is closed."
              },
              row: {
                term: "Delegate's name",
                text: "One row per person: their name, a chip that says how they got in, what their access covers, their rights and the end date."
              },
              remove: {
                term: "Remove",
                text: "Removes the delegate after confirmation: their access ends immediately. The button only appears if you are allowed to remove them."
              },
              empty: {
                term: "No delegate yet",
                text: "Message shown while you have not added anyone. It invites you to add members of your organisation."
              }
            }
          },
          addDialog: {
            title: '"Add a member" window',
            items: {
              people: {
                term: "Members of your organisation",
                text: "Choose one or more people from your organisation. They reach the host's space without seeing the rest of that organisation."
              },
              scope: {
                term: "What the access covers",
                text: 'Within the limit of your partnership: "The whole space" only if the partnership allows it, otherwise folders and channels among those open to you.'
              },
              rights: {
                term: "Rights",
                text: "The rights offered never go above those of your partnership."
              },
              submit: {
                term: "Give access",
                text: "Adds the chosen people. You cannot add more than the number still allowed."
              }
            }
          },
          leave: {
            title: "Leave the space",
            items: {
              heading: {
                term: "Leave the space",
                text: "Ends the partnership from your side: everyone in your organisation loses access. This section does not appear in a closed space."
              },
              button: {
                term: "Leave the space",
                text: "Opens a confirmation. To come back, the host organisation will have to invite you again."
              }
            }
          }
        }
      },
      settings: {
        title: "Settings",
        intro: "The Settings tab of a shared space, reserved for the managers of the host organisation. It is used to rename the space, set its rules and, for owners and administrators, close it.",
        sections: {
          frame: {
            title: "Space frame",
            items: {
              banner: {
                term: "External space hosted by\u2026",
                text: "A permanent bar shown when the space belongs to another organisation: it reminds you that its content follows the rules of that organisation."
              },
              summary: {
                term: "Hosted by",
                text: 'A strip under the title: the organisation that hosts the space, its type, the "Closed" chip when the space is closed and, in an external space, your access: how you got in, your rights and the end date.'
              },
              tabs: {
                term: "Tabs",
                text: 'The tab bar of the space. You are in the "Settings" tab; only the tabs your access lets you open are shown.'
              }
            }
          },
          general: {
            title: "General",
            items: {
              name: {
                term: "Space name",
                text: "The name under which the space appears to all its participants. Required, 200 characters at most."
              },
              closedNotice: {
                term: "This space is closed: its settings can no longer be changed.",
                text: "A yellow warning shown at the top when the space is closed: every field is then greyed out and there is no save button."
              }
            }
          },
          policy: {
            title: "Space rules",
            items: {
              intro: {
                term: "Space rules",
                text: "These rules apply to every access to the space, including those of partner organisations and guests."
              },
              download: {
                term: "Allow downloads",
                text: "A switch. Without downloads, documents can still be viewed as a preview."
              },
              watermark: {
                term: "Watermark on PDFs",
                text: "A switch. A watermark identifies the person who views each PDF."
              },
              print: {
                term: "Allow printing",
                text: "A switch. Printing is done from the document viewer."
              },
              domains: {
                term: "Domains allowed for guests",
                text: `Enter a domain, for example client.tn, then press Enter or "Add": it appears as a chip, which you remove with its cross. Empty list: guests can come from any e-mail address that your organisation's policy allows.`
              }
            }
          },
          save: {
            title: "Saving",
            items: {
              save: {
                term: "Save settings",
                text: 'Saves what changed. If nothing changed, the message "There is nothing to save" appears. Your identity may be asked again before saving.'
              },
              failed: {
                term: "The settings were not saved",
                text: "A red message that explains why in plain language: missing or too long name, invalid value, not enough rights."
              }
            }
          },
          close: {
            title: "Close the space",
            items: {
              section: {
                term: "Close the space",
                text: "A section reserved for the owners and administrators of the host, missing if the space is already closed. It ends all outside access; the space stays readable by your organisation."
              },
              button: {
                term: "Close the space",
                text: "Opens a confirmation. Your identity may be asked again before closing."
              },
              effects: {
                term: "This cannot be undone",
                text: "The confirmation lists the effects: all partners, delegates, named people and guests lose access; the space becomes a read-only archive; partners cannot yet retrieve their own files."
              },
              cancel: {
                term: "Cancel",
                text: 'Closes the confirmation without changing anything. "Close the space" in the confirmation carries out the closing.'
              }
            }
          }
        }
      },
      audit: {
        title: "Audit log",
        intro: "The Audit log tab of a shared space: who did what in the space, and when. The host sees everything; a partner only sees what concerns its organisation.",
        sections: {
          frame: {
            title: "Space frame",
            items: {
              banner: {
                term: "External space hosted by\u2026",
                text: "A permanent bar shown when the space belongs to another organisation: it reminds you that its content follows the rules of that organisation."
              },
              summary: {
                term: "Hosted by",
                text: 'A strip under the title: the organisation that hosts the space, its type, the "Closed" chip when the space is closed and, in an external space, your access: how you got in, your rights and the end date.'
              },
              tabs: {
                term: "Tabs",
                text: 'The tab bar of the space. You are in the "Audit log" tab; only the tabs your access lets you open are shown.'
              }
            }
          },
          log: {
            title: "Audit log",
            items: {
              heading: {
                term: "Audit log",
                text: "The table of the space's events, newest first. It keeps track of invitations, access and removals."
              },
              date: {
                term: "Date",
                text: "The day and time of the event."
              },
              actor: {
                term: "Person",
                text: 'Who did the action. "System" marks an automatic action, such as an access expiring.'
              },
              action: {
                term: "Action",
                text: "What happened, in plain words (see the list of actions below)."
              },
              organisation: {
                term: "Organisation concerned",
                text: 'The partner organisation the event touches. "\u2014" means no organisation is concerned, and "Another organisation" means one you do not manage.'
              }
            }
          },
          actions: {
            title: "Actions you can see",
            items: {
              space: {
                term: "Space created",
                text: 'Life of the space: "Space created", "Space settings changed" and "Space closed".'
              },
              partners: {
                term: "Partner organisation invited",
                text: 'Partnerships: "Partner organisation invited", "Partnership invitation accepted", "Partnership invitation declined", "Partner organisation removed" and "Partnership expired".'
              },
              members: {
                term: "Person joined the space",
                text: `People's access: "Person added by a partner", "Person joined the space", "A person's access removed", "A person's access expired" and "A guest's access extended".`
              },
              invitations: {
                term: "Invitation sent to a person",
                text: 'Invitations: "Invitation sent to a person", "Invitation declined", "Invitation cancelled" and "Decision on an approval request".'
              },
              other: {
                term: "Other action",
                text: "An action that has no plain-language label yet: its technical name is shown in brackets."
              }
            }
          },
          states: {
            title: "Next pages and states",
            items: {
              more: {
                term: "Load more",
                text: 'Loads older events, page by page. The button shows "Loading\u2026" while it works.'
              },
              empty: {
                term: "No event yet",
                text: "Message shown while nothing has happened: invitations, access and removals will appear here."
              },
              loadFailed: {
                term: "The log could not be loaded",
                text: 'A red message shown if the log did not load. Use "Try again" after checking your connection.'
              }
            }
          }
        }
      }
    },
    admin: {
      members: {
        title: "Members",
        intro: "This page lists the people in your office, with their role and status. The owner and the administrators invite colleagues here and manage their access.",
        sections: {
          header: {
            title: "Administration menu and page header",
            items: {
              adminNav: {
                term: "Administration",
                text: "The menu on the left groups the administration pages of your organisation (a row of links above the page on small screens). It only lists the pages your role lets you open."
              },
              invite: {
                term: "Invite",
                text: "Opens the window to invite a person to your office. The button only appears if your role allows inviting. It is greyed out, with an explanation, when the office is read-only."
              },
              seats: {
                term: "seats used",
                text: 'A counter above the list, for example "3 / 5": the seats used out of the seats included in your plan (one seat per person in the office). With no limit, it reads "seats used (no limit)".'
              }
            }
          },
          ownerBanner: {
            title: "Ownership transfer in progress",
            items: {
              pending: {
                term: "Ownership transfer in progress",
                text: 'Banner shown to the owner: it says whose answer is awaited and until when ("Expires on"). The person chosen must accept to become the owner.'
              },
              cancel: {
                term: "Cancel the transfer",
                text: "Withdraws the proposal as long as the person has not answered."
              },
              offer: {
                term: "\u2026 wants to make you the owner",
                text: "Banner shown to the chosen administrator: it explains what you would take over (billing, deleting the organisation and transferring it)."
              },
              accept: {
                term: "Accept",
                text: 'Opens the "Become the owner" confirmation. You must confirm your identity; then you become the owner and the previous owner becomes an administrator.'
              },
              decline: {
                term: "Decline",
                text: "Turns the proposal down. Nothing changes in the roles."
              }
            }
          },
          filters: {
            title: "Filter members",
            items: {
              search: {
                term: "Search for a member",
                text: 'Search field ("Name or email address"). The list narrows as you type.'
              },
              role: {
                term: "Filter by role",
                text: 'Pick a role to see only the people who have it, or "All roles" to show everyone.'
              },
              status: {
                term: "Filter by status",
                text: 'Pick Active, Invited or Deactivated, or "All statuses" to show everyone.'
              },
              clear: {
                term: "Clear filters",
                text: "Resets the search and the filters. This button also appears when no member matches."
              }
            }
          },
          table: {
            title: "Organisation members",
            items: {
              name: {
                term: "Name",
                text: `The person's name, with their picture or initials. Your own row is marked "(you)".`
              },
              email: {
                term: "Email address",
                text: "The email address the person signs in with."
              },
              role: {
                term: "Role",
                text: 'What the person can do in the office (see "Roles and permissions"). The roles are described below.'
              },
              status: {
                term: "Status",
                text: "Active: the person works in the office. Invited: they have not accepted yet. Deactivated: their access is cut, but their documents stay."
              },
              joined: {
                term: "Joined",
                text: "The date the person joined the office. A dash (\u2014) shows until they have joined."
              },
              actions: {
                term: "Actions",
                text: 'The "\u2026" button at the end of the row opens a menu: Change role, Transfer ownership, Deactivate. Only the actions your role allows are offered; with no action possible, the button does not appear.'
              },
              loadMore: {
                term: "Show more members",
                text: "Loads the rest of the list when there are many members."
              },
              empty: {
                term: "No members yet",
                text: 'Message of an empty list: invite your team. With filters on, it becomes "No member matches". If the list does not load, "Cannot show the members" appears with a "Try again" button.'
              }
            }
          },
          roles: {
            title: "Roles offered",
            items: {
              owner: {
                term: "Owner",
                text: 'The head of the office: billing, deleting the organisation and transferring ownership. It is not given with "Change role": it is handed over through an ownership transfer.'
              },
              admin: {
                term: "Administrator",
                text: "Manages the members, the settings, finance and every project of the office."
              },
              projectManager: {
                term: "Project manager",
                text: "Creates and runs their projects, follows fees, time and expense reports."
              },
              engineer: {
                term: "Engineer or architect",
                text: "Takes part in the projects you add them to: documents, tasks and discussions."
              },
              draftsman: {
                term: "Draftsman",
                text: "Prepares and uploads drawings on the projects you add them to."
              },
              accountant: {
                term: "Accountant",
                text: "Manages quotes, invoices, payments and the office's tax matters."
              }
            }
          },
          invitations: {
            title: "Pending invitations",
            items: {
              tab: {
                term: "Pending invitations",
                text: 'Tab next to "Members", visible only if you can invite. It lists the people invited who have not accepted yet.'
              },
              email: {
                term: "Email address",
                text: "The address the invitation was sent to."
              },
              role: {
                term: "Role",
                text: "The role the person will have when joining the office."
              },
              invitedBy: {
                term: "Invited by",
                text: "The member who sent the invitation."
              },
              expires: {
                term: "Expires on",
                text: 'The deadline to accept (7 days after sending). An "Expired" chip appears once it has passed.'
              },
              resend: {
                term: "Resend",
                text: "Sends the invitation email to this address again."
              },
              revoke: {
                term: "Revoke",
                text: "After you confirm, the link received by email stops working. You can invite the person again."
              },
              empty: {
                term: "No pending invitations",
                text: 'Message shown when everyone has accepted. The "Invite" button is offered there.'
              }
            }
          },
          inviteDialog: {
            title: "Invite a member",
            items: {
              email: {
                term: "Email address",
                text: "Required. The address of the person to invite. They receive an email with a link to join your office, valid for 7 days."
              },
              role: {
                term: "Role",
                text: "Required. Choose Administrator, Project manager, Engineer or architect, Draftsman or Accountant. A sentence under the list describes the chosen role."
              },
              locale: {
                term: "Language of the email",
                text: "The language the invitation is written in: Fran\xE7ais, \u0627\u0644\u0639\u0631\u0628\u064A\u0629 or English."
              },
              submit: {
                term: "Send the invitation",
                text: "Sends the email, then a message confirms it was sent. If the address is empty or invalid, an error shows under the field."
              },
              alreadyMember: {
                term: "This address already belongs to a member of your office.",
                text: "Message under the email field: the person is already in the list, no need to invite them."
              },
              resendExisting: {
                term: "Resend the invitation",
                text: "When an invitation is already waiting for this address, this button sends it again instead of creating a second one."
              },
              seatsFull: {
                term: "All the seats of your plan are in use",
                text: "Message shown when the plan is full. The owner is guided to add a seat or change plan; the other members are told to ask the owner."
              },
              cancel: {
                term: "Cancel",
                text: "Closes the window without sending anything."
              }
            }
          },
          memberDialogs: {
            title: "Windows of the Actions menu",
            items: {
              changeRole: {
                term: "Change role",
                text: 'Pick the "New role". The current role is not offered, and no owner can be named here. An identity confirmation may be asked before the change applies.'
              },
              deactivate: {
                term: "Deactivate",
                text: "A three-step assistant. First a summary: access stops at once on every device, documents, messages and tasks stay in place under the person's name, and the seat is freed at the next billing period."
              },
              defaultSuccessor: {
                term: "Default successor",
                text: 'Second step: if there are items to hand over, choose who takes them, one by one ("Use the default successor") or all at once with the default successor. If there are none, the step says so.'
              },
              confirmDeactivate: {
                term: "Deactivate \u2026?",
                text: "Last step: the confirmation. The person loses access at once and the number of items handed over is recalled. An identity confirmation may be asked."
              },
              transfer: {
                term: "Transfer ownership",
                text: 'For the owner only, towards an administrator. "Send the proposal" passes on the request, which the person must accept (see the banner at the top). You can cancel it until they answer.'
              }
            }
          }
        }
      },
      roles: {
        title: "Roles and permissions",
        intro: "This page shows, in a table, what each role can do in your office. It helps you choose the right role when you invite someone.",
        sections: {
          header: {
            title: "Administration menu and page header",
            items: {
              adminNav: {
                term: "Administration",
                text: "The menu on the left groups the administration pages of your organisation (a row of links above the page on small screens). It only lists the pages your role lets you open."
              },
              readOnly: {
                term: "Roles and permissions",
                text: "The six roles are defined by BatiFlow: this table is read-only, nothing can be changed in it."
              },
              scroll: {
                term: "Table of permissions by role (scrolls sideways)",
                text: "On a small screen, the table scrolls sideways; the permissions column stays visible. Every cell is also read out in words by a screen reader."
              }
            }
          },
          legend: {
            title: "Table legend",
            items: {
              yes: {
                term: "Granted",
                text: "A check mark: the role has this permission."
              },
              project: {
                term: "Granted on their own projects only",
                text: "The letter P: the role has the permission only on the projects they are in charge of."
              },
              delegable: {
                term: "Not granted by default; the owner can delegate it",
                text: "The letter D: the administrator does not have it by default, but the owner can give it to them."
              },
              no: {
                term: "Not granted",
                text: "A dash: the role does not have this permission."
              }
            }
          },
          table: {
            title: "Permissions granted to each role",
            items: {
              permission: {
                term: "Permission",
                text: 'The left column: what one can do, for example "Edit the office profile" or "Invite members".'
              },
              roleColumns: {
                term: "Owner, Administrator, Project manager, Engineer or architect, Draftsman, Accountant",
                text: "One column per role. Read a permission's row from side to side to see which roles have it."
              }
            }
          },
          areas: {
            title: "Permission groups",
            items: {
              organization: {
                term: "Organisation",
                text: "Office profile, fiscal profile, policies, deleting the organisation, transferring ownership and exporting the data."
              },
              billing: {
                term: "Subscription",
                text: "View the subscription and the BatiFlow invoices, manage the subscription and the seats."
              },
              members: {
                term: "Members and roles",
                text: "See the member list, invite, change a role, deactivate, manage roles."
              },
              audit: {
                term: "Audit log",
                text: "View the log (and its finance version), export it, check its integrity."
              },
              clientsProjects: {
                term: "Clients, Projects",
                text: "View, create, edit and archive clients; create projects, see or manage every project, see the fees."
              },
              sharing: {
                term: "Sharing and spaces",
                text: "Create collaboration spaces, share them with outsiders, approve the access of external participants, publish documents to the client."
              },
              financeTime: {
                term: "Finance, Time and costs",
                text: "Quotes, contracts, invoices, payments, expense reports, finance dashboard, suppliers; logging and approving time, cost rates, payroll."
              },
              other: {
                term: "Other",
                text: "The permissions that fit no group, for example managing tenders and checklists."
              }
            }
          }
        }
      },
      profile: {
        title: "Organisation",
        intro: "This page shows the legal and professional identity of your design office, with its logo. Every member can read it; the owner and the administrators can edit it.",
        sections: {
          header: {
            title: "Administration menu and saving",
            items: {
              adminNav: {
                term: "Administration",
                text: "The menu on the left groups the administration pages of your organisation (a row of links above the page on small screens). It only lists the pages your role lets you open."
              },
              readOnlyView: {
                term: "Organisation profile",
                text: 'Without the right to edit, the page shows the information as plain text, with "Not provided" for empty fields, under the note "Only the owner and administrators can change it".'
              },
              save: {
                term: "Save",
                text: 'Saves only what you changed, for the whole page except the logo. If there is nothing new, "There is nothing to save" shows. If someone else changed the profile in the meantime, your changes are not saved and the latest version is reloaded.'
              }
            }
          },
          identity: {
            title: "Office identity",
            items: {
              legalName: {
                term: "Legal name",
                text: "Required. The official name of your office, as it appears in the trade register."
              },
              tradeName: {
                term: "Trade name (optional)",
                text: "The name your clients know you by."
              },
              legalForm: {
                term: "Legal form",
                text: "Required. Pick one from the list: Sole proprietorship, SUARL, SARL, SA, SNC, SCS, GIE or Other."
              },
              taxId: {
                term: "Tax id",
                text: "Read-only: it identifies your office and cannot be changed here. To correct it, contact BatiFlow support."
              }
            }
          },
          disciplines: {
            title: "Disciplines",
            items: {
              officeDisciplines: {
                term: "Office disciplines",
                text: "Check boxes: Architecture, Structure, Roads and utilities (VRD), Fluids (MEP), Electrical, Surveying, Geotechnics, Site coordination (OPC). You can choose several, but at least one is needed."
              },
              acronyms: {
                term: "Roads and utilities (VRD) and Site coordination (OPC)",
                text: "VRD: roads and utility networks (roads, drainage, networks). OPC: scheduling, steering and coordination of the building site."
              }
            }
          },
          address: {
            title: "Address and governorate",
            items: {
              line1: {
                term: "Address",
                text: "Required. The address of your office headquarters."
              },
              line2: {
                term: "Address line 2 (optional)",
                text: "Building, floor, estate\u2026 anything that helps to find the office."
              },
              city: {
                term: "City",
                text: "Required."
              },
              postalCode: {
                term: "Postal code",
                text: "Required, for example 1002."
              },
              governorate: {
                term: "Governorate",
                text: "Required. Pick one from the list of Tunisian governorates, in alphabetical order."
              }
            }
          },
          references: {
            title: "Professional references and language",
            items: {
              professionalRegistration: {
                term: "Professional registration (optional)",
                text: "For example the registration number with the order of engineers or architects."
              },
              agreementNumber: {
                term: "Agreement number (optional)",
                text: "The approval number of your design office, if it has one."
              },
              defaultLocale: {
                term: "Default language of the organisation",
                text: "Fran\xE7ais, \u0627\u0644\u0639\u0631\u0628\u064A\u0629 or English. It is used for the documents and messages sent on behalf of the office."
              }
            }
          },
          logo: {
            title: "Logo",
            items: {
              preview: {
                term: "The organisation's current logo",
                text: 'The preview of the logo, which appears on your official documents. With no logo, "No logo yet." shows.'
              },
              choose: {
                term: "Choose an image",
                text: 'Owner and administrators only. Pick a PNG, JPEG or WebP file of 2 MB at most; it is checked, then "Applying the logo\u2026" shows before the update.'
              },
              remove: {
                term: "Remove the logo",
                text: "Owner and administrators only. This button only appears when there is already a logo."
              },
              logoErrors: {
                term: "Logo error messages",
                text: "A plain message explains the refusal: wrong format, image too large, image still being checked (try again in a moment), or saving impossible."
              }
            }
          }
        }
      },
      documents: {
        title: "Documents",
        intro: `This page sets how BatiFlow names your office's documents (the "code" of each drawing or letter) and numbers their versions. Below, you manage your team's approval workflow templates.`,
        sections: {
          header: {
            title: "Administration menu and saving",
            items: {
              adminNav: {
                term: "Administration",
                text: "The menu on the left groups the administration pages of your organisation (a row of links above the page on small screens). It only lists the pages your role lets you open."
              },
              save: {
                term: "Save",
                text: 'Only visible to people allowed to edit the organisation. If there is nothing new, "Nothing to save" shows. Next to it, a note reminds you that codes already assigned do not change: the new pattern applies to new documents and to those whose information is edited.'
              },
              readOnly: {
                term: "Only people allowed to edit the organisation can change these settings.",
                text: "For the other members, the page can be read but not edited: the field and the choices are locked."
              }
            }
          },
          pattern: {
            title: "Document code pattern",
            items: {
              patternField: {
                term: "Pattern",
                text: "The pattern of each document's code: it identifies the document on drawings, letters and transmittals. Capital letters, digits and the signs - _ . only, from 5 to 100 characters; lowercase letters turn into capitals on their own. The elements NUM and IDX, written between braces, are required."
              },
              example: {
                term: "Example code",
                text: 'An example worked out as you type, for a structure drawing of the APS phase, first document, zone RDC. If the pattern is not valid yet, "no example" shows.'
              },
              problems: {
                term: "Messages under the field",
                text: "They explain the problem in plain words: length outside 5 to 100 characters, forbidden character, unknown element between braces, unbalanced braces, or NUM and IDX missing. The server can also refuse a pattern for the same reason."
              }
            }
          },
          elements: {
            title: "Pattern elements",
            items: {
              project: {
                term: "PROJECT",
                text: "The project code."
              },
              phase: {
                term: "PHASE",
                text: "The project phase: ESQ, APS, APD\u2026"
              },
              disc: {
                term: "DISC",
                text: "The discipline: ARC, STR, VRD\u2026"
              },
              type: {
                term: "TYPE",
                text: "The document type: PLN, NDC, RAP\u2026"
              },
              num: {
                term: "NUM",
                text: "The sequence number, assigned by BatiFlow. Required."
              },
              idx: {
                term: "IDX",
                text: "The revision index (A, B\u2026 or 0, 1\u2026). Required."
              },
              zone: {
                term: "ZONE",
                text: "The zone or building, when given."
              }
            }
          },
          index: {
            title: "Revision index style",
            items: {
              letters: {
                term: "Letters: A, B, C\u2026",
                text: "Each new version of a document gets a letter (the revision index): A, then B, then C\u2026"
              },
              numbers: {
                term: "Digits: 0, 1, 2\u2026",
                text: "Each new version gets a number: 0, then 1, then 2\u2026"
              }
            }
          },
          templates: {
            title: "Approval workflow templates",
            items: {
              intro: {
                term: "Approval workflow templates",
                text: "Ready-made workflows your team can pick when requesting an approval (a document being validated by reviewers). Each template in the list shows its name and its steps."
              },
              new: {
                term: "New template",
                text: "Opens the creation window. Only visible to people allowed to edit the organisation."
              },
              delete: {
                term: "Delete",
                text: "A bin icon at the end of the row, for those who can edit the organisation. After you confirm, the template disappears; workflows already started do not change."
              },
              empty: {
                term: "No template yet.",
                text: "Message of an empty list: teams then build the steps for each request."
              },
              readOnlyTemplates: {
                term: "Creating or deleting a template is reserved for people who can edit the organisation.",
                text: "The other members see the list without being able to change it."
              }
            }
          },
          newTemplate: {
            title: "New workflow template",
            items: {
              name: {
                term: "Template name",
                text: 'Required, 120 characters at most. Without a name, "Give the template a name." shows.'
              },
              step: {
                term: "Step",
                text: 'A workflow is made of numbered steps. Each step has a mode: "In order" (each reviewer gives their opinion in turn) or "In parallel" (everyone answers at the same time, in any order). Buttons let you move a step up or down, or remove it.'
              },
              reviewers: {
                term: "Reviewers of step",
                text: 'The people who give their opinion. Pick someone in "Choose a person" then click "Add"; you can move them up, down or remove them. A step without a reviewer is refused.'
              },
              addStep: {
                term: "Add a step",
                text: "Adds a step at the end of the workflow."
              },
              create: {
                term: "Create the template",
                text: 'Saves the template. If a step has no reviewer, "Every step needs at least one reviewer." shows.'
              }
            }
          }
        }
      },
      policies: {
        title: "Policies",
        intro: "This page sets how your office shares with outsiders and how strongly sign-in is protected. It is reserved for people who can edit the policies (usually the owner and the administrators).",
        sections: {
          header: {
            title: "Administration menu and saving",
            items: {
              adminNav: {
                term: "Administration",
                text: "The menu on the left groups the administration pages of your organisation (a row of links above the page on small screens). It only lists the pages your role lets you open."
              },
              save: {
                term: "Save",
                text: "Saves only the policies you changed. For your security, it asks you to confirm your identity. If someone else changed the policies in the meantime, your changes are not saved and the latest version is reloaded."
              }
            }
          },
          sharing: {
            title: "Sharing with outsiders",
            items: {
              requireApproval: {
                term: "Approval required to join an external space",
                text: "Switch. When it is on, a member can join another organisation's space only once an administrator has agreed."
              },
              seeRequests: {
                term: "See the pending requests",
                text: "A link to the page where administrators accept or turn down access requests."
              },
              managersCanShare: {
                term: "Project managers can share",
                text: "Switch. When it is on, project managers can open their projects' space to partners. Otherwise only the owner and administrators can."
              },
              domains: {
                term: "Allowed domains for guests",
                text: 'Type a domain, for example client.tn, then press Enter or click "Add". External guests can then only come from these domains. With no domain, they can come from any email address.'
              },
              domainList: {
                term: "Allowed domains",
                text: 'The list of domains added, shown as chips. The "Remove" button on a chip deletes that domain (50 domains at most).'
              },
              domainErrors: {
                term: "Messages under the field",
                text: 'They report an empty domain, an invalid one (write it without "@" or spaces), one already in the list, or a list that is too long.'
              }
            }
          },
          security: {
            title: "Sign-in security",
            items: {
              sessionHours: {
                term: "Maximum length of a session",
                text: 'A list from 1 to 12 hours, or "Platform default (12 hours)". After this time the member must sign in again, even if they are active.'
              },
              mfaForAll: {
                term: "Two-step verification for all members",
                text: "Switch. When it is on, every member must set up an authenticator app at their next sign-in; without it they can no longer use BatiFlow. The owner, administrators and accountants already have to."
              }
            }
          }
        }
      },
      fiscal: {
        title: "Fiscal profile",
        intro: "This page sets the tax rules applied to your invoices: VAT, tax regime, withholding tax, footer and bank details. Every change creates a new version. The page also manages the numbering of your invoices. You need the right to view the fiscal profile, and one more right to edit it.",
        sections: {
          header: {
            title: "Administration menu and page header",
            items: {
              adminNav: {
                term: "Administration",
                text: "The menu on the left groups the administration pages of your organisation (a row of links above the page on small screens). It only lists the pages your role lets you open."
              },
              newVersionButton: {
                term: "New version",
                text: "Opens the window to create a version. Only visible to those who can edit the fiscal profile. The values of the version in force are kept: change only what is different; the previous version is kept."
              },
              empty: {
                term: "No fiscal profile yet",
                text: 'Starting message: the fiscal profile sets the VAT, the tax regime, the withholding tax and the bank details of your invoices. A "New version" button is offered there to those who can create one.'
              }
            }
          },
          current: {
            title: "Version in force",
            items: {
              effectiveFrom: {
                term: "In force since",
                text: "The date from which these values apply to new invoices."
              },
              createdBy: {
                term: "Created by",
                text: "The member who created this version."
              },
              vat: {
                term: "VAT",
                text: '"Registered for VAT" or "Not registered for VAT": your office applies value-added tax or not.'
              },
              regime: {
                term: "Tax regime",
                text: "Real regime or flat-rate regime."
              },
              withholding: {
                term: "Status for withholding tax",
                text: "Legal entity, Individual under the real regime or Other. It decides the withholding tax that applies to your invoices."
              },
              footer: {
                term: "Invoice footer",
                text: 'The text shown at the bottom of your invoices (legal notices, payment terms\u2026), or "None".'
              },
              bank: {
                term: "Bank details",
                text: 'The bank name and the masked RIB (bank account number), or "None".'
              },
              showRib: {
                term: "Show full RIB",
                text: 'For those who can edit the profile. After you confirm your identity, the RIB and the IBAN appear with a button to copy them; "Hide" hides them, and they hide on their own after 1 minute. Every viewing is noted in the audit log.'
              }
            }
          },
          history: {
            title: "Version history",
            items: {
              table: {
                term: "Fiscal profile versions, newest first",
                text: "A table with one row per version and the same information as above. A new version never changes the old ones: issued invoices keep the version that was in force."
              },
              status: {
                term: "Status",
                text: "In force: the version that applies today. Scheduled: it will start at a later date. Earlier: it has been replaced."
              },
              rowBank: {
                term: "Bank details",
                text: 'Each row has its own bank details column, with the same "Show full RIB" button for those who may use it.'
              }
            }
          },
          newVersion: {
            title: "New version of the fiscal profile",
            items: {
              start: {
                term: "Start of application",
                text: 'Choose "Right now" or "On a later date"; in that case give the "Start date", which cannot be in the past. A scheduled version shows with the status "Scheduled".'
              },
              vat: {
                term: "Registered for VAT",
                text: "Switch: the office applies VAT on its invoices or not."
              },
              regimeChoice: {
                term: "Tax regime",
                text: "List: Real regime or Flat-rate regime."
              },
              withholdingChoice: {
                term: "Status for withholding tax",
                text: "List: Legal entity, Individual under the real regime or Other."
              },
              footerField: {
                term: "Invoice footer",
                text: "Optional text box for legal notices or payment terms. A message flags a text that is too long."
              },
              bankField: {
                term: "Bank details (optional)",
                text: 'The "Bank name" and the "RIB" (20 digits, without the "TN59" prefix). They are not carried over from the previous version: enter them again, or leave them empty for a version without bank details.'
              },
              submit: {
                term: "Create the version",
                text: "Saves the version. For your security, you are asked to confirm your identity. A message then says whether the version is in force or scheduled."
              }
            }
          },
          series: {
            title: "Invoice numbering series",
            items: {
              add: {
                term: "Add a series",
                text: "For those who can edit the fiscal profile. Each series has its own gap-free counter; the default series is suggested on new invoices."
              },
              code: {
                term: "Code",
                text: "The short code of the series, for example FAC."
              },
              prefix: {
                term: "Prefix",
                text: 'The start of each invoice number of the series, for example "FAC-".'
              },
              reset: {
                term: "Reset",
                text: '"Every year": the counter goes back to 1 at the start of each year. "Never": it keeps counting.'
              },
              default: {
                term: "Default series",
                text: 'A "Default" chip marks the series suggested on new invoices. There is always one.'
              },
              actions: {
                term: "Actions",
                text: "The row menu offers Edit, Make default and Delete; the last two do not exist for the default series. This column only appears for those who can edit the fiscal profile."
              },
              empty: {
                term: "No invoice series",
                text: "Message of an empty list: add a series to number your invoices."
              }
            }
          },
          seriesDialog: {
            title: "Add an invoice series",
            items: {
              codeField: {
                term: "Code",
                text: "From 1 to 10 letters or digits, with no spaces or accents. It cannot be changed afterwards, because numbers already issued refer to it. A code already used by another series is refused."
              },
              prefixField: {
                term: "Prefix",
                text: 'Required. The start of every number, for example "FAC-".'
              },
              resetYearly: {
                term: "Restart the numbering every year",
                text: "Switch: the counter goes back to 1 at the start of each year."
              },
              makeDefault: {
                term: "Default series",
                text: 'Switch offered only when adding a series. For an existing series, use "Make default" in its menu.'
              },
              delete: {
                term: "Delete",
                text: "After you confirm, the series is no longer offered, and this cannot be undone. The default series cannot be deleted: make another series the default first."
              }
            }
          }
        }
      },
      audit: {
        title: "Audit log",
        intro: "This page keeps a record of who did what, and when, in your office: sign-ins, profile changes, invoices issued\u2026 The owner and the administrators see everything; an accountant sees finance events only.",
        sections: {
          header: {
            title: "Administration menu and access",
            items: {
              adminNav: {
                term: "Administration",
                text: "The menu on the left groups the administration pages of your organisation (a row of links above the page on small screens). It only lists the pages your role lets you open."
              },
              financeOnly: {
                term: "As an accountant you only see finance events",
                text: "Information message shown to accountants: invoices, quotes, contracts, payments, expenses and fiscal settings. Other events are reserved for the owner and administrators."
              }
            }
          },
          integrity: {
            title: "Log integrity",
            items: {
              intro: {
                term: "Log integrity",
                text: "Block reserved for the owner. Each event is linked to the previous one by a fingerprint; the check recomputes this chain and reports whether an event was changed, removed or moved."
              },
              verify: {
                term: "Verify integrity",
                text: 'Starts the check. While it runs, the button reads "Checking\u2026".'
              },
              intact: {
                term: "The log is intact",
                text: "Green message: no change or removal detected, with the date and time of the check."
              },
              altered: {
                term: "The log has been tampered with",
                text: "Red message: the chain is broken from a given event number, with the reason (content changed, event missing, link broken). Keep the screen and contact BatiFlow support right away."
              },
              failed: {
                term: "The check did not complete",
                text: "The check could not finish; the message explains the cause in plain words. You can run it again."
              }
            }
          },
          filters: {
            title: "Log filters",
            items: {
              actor: {
                term: "Done by",
                text: 'Choose the person who did the action, or "Everyone". This filter only appears if you can see the member list.'
              },
              action: {
                term: "Type of action",
                text: 'A group of actions: Organisation and settings, Members and invitations, Clients, Sign-ins and security, Invoices, Quotes, Contracts, Payments, Expenses. An accountant only gets those that touch finance. "All actions" shows everything.'
              },
              from: {
                term: "From",
                text: "First day to show (calendar day in Tunis)."
              },
              to: {
                term: "To",
                text: 'Last day to show, until the end of that day. It cannot be before the "From" date.'
              },
              clear: {
                term: "Clear the filters",
                text: "Appears as soon as a filter is chosen, and resets everything."
              }
            }
          },
          events: {
            title: "Audit log events",
            items: {
              when: {
                term: "Date and time",
                text: "When the action took place. Events are sorted from newest to oldest."
              },
              actor: {
                term: "Done by",
                text: 'The person who did the action. For an automatic action, "BatiFlow system"; for a support intervention, "BatiFlow support".'
              },
              action: {
                term: "Action",
                text: 'A plain sentence, for example "Sign-in" or "Invoice issued", with the technical code of the action underneath.'
              },
              resource: {
                term: "Item concerned",
                text: "What the action touched: Organisation, Member, Invitation, Ownership transfer, Fiscal profile, Invoice series, Client\u2026 with a short identifier underneath."
              },
              loadMore: {
                term: "Show more events",
                text: "Loads the rest of the log when there are many events."
              },
              empty: {
                term: "No events yet",
                text: `Message of an empty list: the office's sensitive actions will appear here as soon as they happen. With filters on, it becomes "No event matches" (try other filters or a wider period).`
              },
              loadFailed: {
                term: "Unable to show the log",
                text: 'Error message with a "Try again" button when the log does not load.'
              }
            }
          }
        }
      },
      storage: {
        title: "Storage",
        intro: "This page shows the storage space used by your files compared with your plan, project by project. It is reserved for people who can edit the organisation.",
        sections: {
          header: {
            title: "Administration menu and loading",
            items: {
              adminNav: {
                term: "Administration",
                text: "The menu on the left groups the administration pages of your organisation (a row of links above the page on small screens). It only lists the pages your role lets you open."
              },
              loadFailed: {
                term: "Storage usage could not be loaded",
                text: 'Error message shown when the figures do not load: check your connection, then click "Try again".'
              }
            }
          },
          usage: {
            title: "Space used",
            items: {
              summary: {
                term: "\u2026 used of \u2026",
                text: `The figures in words: the space taken by all your projects' files, earlier versions included, out of your plan's space. With no limit, the sentence says "Your contract sets no space limit".`
              },
              bar: {
                term: "Storage space used",
                text: 'A progress bar with the percentage written next to it ("\u2026 of the space is used"). Its colour changes with the level, but the percentage is always written.'
              },
              notes: {
                term: "Warnings",
                text: "Beyond 80%, a message advises deleting files or buying storage. With less than 5% of space left, it becomes more urgent. When the space is full, new files are refused."
              },
              buy: {
                term: "Buy storage",
                text: "Greyed-out button for now: buying storage will be available with billing, which comes later."
              }
            }
          },
          spaces: {
            title: "Storage per project",
            items: {
              name: {
                term: "Project or space",
                text: "The name of the project (or space) that holds files."
              },
              size: {
                term: "Size",
                text: "The size of all the files of this project."
              },
              reconciledAt: {
                term: "Last calculated",
                text: 'When this size was last recalculated. "Not calculated yet" shows for a brand-new project.'
              },
              empty: {
                term: "No files yet",
                text: "Message of an empty list: the size of each project will show here once it holds files."
              }
            }
          },
          files: {
            title: "The 10 largest files",
            items: {
              code: {
                term: "Code",
                text: `The document's code. "No code" shows for a file that has none.`
              },
              title: {
                term: "Title",
                text: "The file's title. When it is in a project, it is a link that opens it in the project."
              },
              size: {
                term: "Size",
                text: "The space the file takes. Deleting or replacing a file you no longer need frees space."
              },
              empty: {
                term: "No files yet",
                text: "Message of an empty list: the largest files will show here."
              }
            }
          }
        }
      },
      data: {
        title: "Data and deletion",
        intro: "This page is for getting a copy of your office's data (an export) and, for the owner, asking for or cancelling the deletion of the organisation.",
        sections: {
          header: {
            title: "Administration menu and access",
            items: {
              adminNav: {
                term: "Administration",
                text: "The menu on the left groups the administration pages of your organisation (a row of links above the page on small screens). It only lists the pages your role lets you open."
              },
              blocks: {
                term: "Data and deletion",
                text: "Each block only appears if your role allows it: the full export (owner and administrators), the finance export (accountant) and the deletion (owner only)."
              }
            }
          },
          export: {
            title: "Export the data",
            items: {
              button: {
                term: "Prepare a full export",
                text: 'Starts the preparation of an export. For an accountant, the button is called "Prepare a finance export" and only covers financial data. An identity confirmation may be asked, then a message says the export is being prepared.'
              },
              contents: {
                term: "What an export holds",
                text: "A full export gathers all the data of the organisation in one file: every data table as JSON, the documents kept in their folders and the PDFs generated by BatiFlow. The finance export holds financial data only."
              },
              retention: {
                term: "Keeping and notification",
                text: "The ZIP file is kept for 7 days, then deleted. The person who asks for the export is notified as soon as it is ready."
              }
            }
          },
          exports: {
            title: "Data exports of the organisation",
            items: {
              requestedAt: {
                term: "Requested on",
                text: "The date and time of the request."
              },
              scope: {
                term: "Type",
                text: '"Full" or "Finance".'
              },
              requestedBy: {
                term: "Requested by",
                text: "The member who asked for the export."
              },
              status: {
                term: "Status",
                text: "Queued, Being prepared, Ready, Failed or Expired. The status is always written out in words. The list updates by itself while an export is being prepared."
              },
              size: {
                term: "Size",
                text: "The file's size once ready. A dash while it is not known yet."
              },
              expiresAt: {
                term: "Available until",
                text: "The last day to download the export."
              },
              download: {
                term: "Download",
                text: 'Downloads the ZIP file. The button only appears on a "Ready" export.'
              },
              empty: {
                term: "No export yet",
                text: 'Message of an empty list: prepare an export to get a copy of the data. If the list does not load, "Could not load the exports" appears with a "Try again" button.'
              }
            }
          },
          delete: {
            title: "Delete the organisation",
            items: {
              points: {
                term: "This action is final",
                text: "Four reminders before you continue: deletion takes place 90 days after the request and can be cancelled until then; it cannot be undone (data, files, and the accounts of people who belong to no other organisation); the name, the tax ID and the audit log (3 years) are kept; prepare a full export first."
              },
              button: {
                term: "Delete the organisation",
                text: "Button reserved for the owner; it opens the request window. It only appears when no deletion is scheduled."
              },
              scheduled: {
                term: "Deletion is scheduled for \u2026",
                text: "When a deletion is planned, a banner gives the date, the person who asked for it and the reason: the owner's request, an unpaid subscription, a trial that ended without a subscription, or a cancelled subscription."
              },
              cancel: {
                term: "Cancel the deletion",
                text: 'For a deletion the owner asked for: a confirmation "Cancel the deletion of the organisation?" offers "Yes, cancel the deletion" or "No, keep it scheduled". The organisation then stays as it is today.'
              },
              payToStop: {
                term: "Go to the subscription",
                text: "For a deletion triggered by the subscription: paying the subscription stops the deletion, and this link leads to the Subscription page."
              },
              running: {
                term: "Deletion is in progress",
                text: "The data is being erased. It can no longer be stopped."
              }
            }
          },
          deleteDialog: {
            title: "Deletion request window",
            items: {
              exportState: {
                term: "A full export less than 30 days old is ready",
                text: 'A message says whether a full export less than 30 days old exists (remember to download it before the deletion) or whether none is available (prepare one in "Export the data").'
              },
              decline: {
                term: "I do not want an export of my data",
                text: "Check box, offered only when there is no recent export. Tick it to continue without an export; otherwise a message asks you to prepare one."
              },
              confirmName: {
                term: "Type the legal name to confirm",
                text: "Required. Copy the organisation's legal name exactly, shown under the field. If the text differs, a message says so."
              },
              submit: {
                term: "Schedule the deletion",
                text: "Sends the request, after an identity confirmation. The deletion will take place in 90 days; you can cancel it until then."
              }
            }
          }
        }
      },
      subscription: {
        title: "Subscription",
        intro: "This page shows your office's BatiFlow subscription: the plan, what you use, a comparison of the plans and the invoices. The billing team sees everything; only the owner can change the subscription or pay.",
        sections: {
          header: {
            title: "Administration menu and page header",
            items: {
              adminNav: {
                term: "Administration",
                text: "The menu on the left groups the administration pages of your organisation (a row of links above the page on small screens). It only lists the pages your role lets you open."
              },
              change: {
                term: "Change subscription",
                text: "Button reserved for the owner, at the top of the page: it opens the plan change window. It does not appear on an Enterprise plan."
              },
              readOnlyNote: {
                term: "You are viewing the subscription in read-only mode",
                text: "Information message for members who are not the owner: they see everything but cannot change or pay."
              },
              enterpriseNote: {
                term: "Your Enterprise plan is managed by contract",
                text: "Message for the owner of an Enterprise plan: to change it, contact the BatiFlow sales team."
              }
            }
          },
          plan: {
            title: "Your plan",
            items: {
              status: {
                term: "Subscription status",
                text: 'A chip at the top of the card: Trial, Active, Payment late, Read-only (you can view and export, but not create or edit), Suspended, Paused or Cancelled. During the trial, a "Trial ends" line gives the date.'
              },
              plan: {
                term: "Plan",
                text: "Your offer: Solo, Starter, Pro, Business or Enterprise."
              },
              cycle: {
                term: "Billing",
                text: "Monthly or Annual. The annual subscription costs 10 months instead of 12."
              },
              period: {
                term: "Current period",
                text: "The start and end dates of the period already billed."
              },
              nextDue: {
                term: "Next due date",
                text: 'The date of the next invoice to pay, or "None".'
              },
              price: {
                term: "Price per period (excl. tax)",
                text: 'The price excluding tax, "per month" or "per year". "On quote" for an Enterprise plan.'
              },
              extras: {
                term: "Options",
                text: 'The extra seats and extra storage you added, or "No options".'
              },
              payment: {
                term: "Payment method",
                text: 'Bank card, Bank transfer, Cheque or Online payment; "Not chosen yet" otherwise. A transfer or a cheque is confirmed on receipt by the BatiFlow team.'
              }
            }
          },
          notices: {
            title: "Invoice to pay and planned change",
            items: {
              openInvoice: {
                term: "Invoice \u2026 is waiting for payment",
                text: 'Orange banner under the card when an invoice is open, with the "Amount due" including tax.'
              },
              pay: {
                term: "Pay",
                text: "Pays the open invoice. Reserved for the owner."
              },
              pending: {
                term: "A change is planned",
                text: "Blue banner: on a given date, the subscription will move to another plan, be paused or be cancelled."
              },
              withdraw: {
                term: "Withdraw this change",
                text: "Withdraws the planned change. Reserved for the owner."
              }
            }
          },
          usage: {
            title: "Usage",
            items: {
              seats: {
                term: "Seats",
                text: "The number of people in the office, compared with your plan's seats."
              },
              storage: {
                term: "Storage",
                text: "The space taken by your files, compared with your plan's space."
              },
              hostedSpaces: {
                term: "Hosted shared spaces",
                text: "The number of shared spaces your office hosts, compared with the plan's limit."
              },
              reading: {
                term: "\u2026 of \u2026 and percentage",
                text: 'Each line reads "3 of 5" with a percentage and a bar. The bar turns orange from 80% and red at 100%. With no limit, the line says "(no limit)".'
              }
            }
          },
          compare: {
            title: "Compare plans",
            items: {
              columns: {
                term: "Solo, Starter, Pro, Business, Enterprise",
                text: 'One column per plan. The column of your plan is coloured and carries the "Your plan" chip.'
              },
              prices: {
                term: "Monthly price (excl. tax)",
                text: 'With "Annual price (excl. tax)": the prices excluding tax. The annual subscription costs 10 months instead of 12.'
              },
              seats: {
                term: "Seats included",
                text: 'The number of people included in the plan. The "Extra seat (per month)" line gives the price of one more person, or "Not offered".'
              },
              storage: {
                term: "Storage included",
                text: 'The storage space included in the plan. The "Hosted shared spaces" line gives the number of shared spaces allowed.'
              },
              meeting: {
                term: "Participants per meeting",
                text: "The number of people who can join an online meeting."
              },
              special: {
                term: "Unlimited, By contract, On quote",
                text: '"Unlimited": no limit. "By contract" and "On quote": values agreed with the sales team; the Enterprise plan is sold on quote.'
              }
            }
          },
          invoices: {
            title: "Subscription invoices",
            items: {
              number: {
                term: "Number",
                text: "The number of the BatiFlow invoice."
              },
              purpose: {
                term: "Purpose",
                text: "Why the invoice was issued: Subscription start, Plan change, Restart, Renewal or Resumption after pause."
              },
              dates: {
                term: "Issued on",
                text: 'The issue date. The "Due by" column gives the payment deadline.'
              },
              total: {
                term: "Total incl. tax",
                text: "The amount including all taxes."
              },
              status: {
                term: "Status",
                text: "To pay, Paid or Cancelled."
              },
              pdf: {
                term: "PDF",
                text: "Downloads the invoice as a PDF. If the file is not ready yet, a message asks you to try again."
              },
              payInvoice: {
                term: "Pay",
                text: 'Pays an invoice marked "To pay". Reserved for the owner.'
              },
              empty: {
                term: "No invoices yet",
                text: 'Message of an empty list: your subscription invoices will appear here. If the list does not load, "Could not load the invoices" appears with a "Try again" button.'
              }
            }
          },
          manage: {
            title: "Manage the subscription",
            items: {
              renew: {
                term: "Renew now",
                text: '"Renew" button: issues the invoice for the next period right away, which you can pay at once. Block reserved for the owner.'
              },
              pause: {
                term: "Pause",
                text: 'Choose the "Length of the pause" (3 months a year at most). The pause starts at the end of the current period and costs 20% of the price. Only an active subscription with no change under way can be paused.'
              },
              resume: {
                term: "Resume the subscription",
                text: "Visible when the subscription is paused. An invoice is issued (the paused months at 20% plus a new period) and the subscription resumes as soon as it is paid."
              },
              cancel: {
                term: "Cancel the subscription",
                text: "The cancellation takes effect at the end of the current period. Then the office becomes read-only for 90 days (viewing and export), after which the data is deleted. As long as the period has not ended, you can withdraw the cancellation."
              }
            }
          },
          changeDialog: {
            title: "Change the subscription",
            items: {
              plan: {
                term: "Plan",
                text: 'The new plan. Enterprise is marked "on quote": it is not bought online.'
              },
              cycle: {
                term: "Billing",
                text: "Monthly or Annual. Annual: 10 months paid for 12."
              },
              extraSeats: {
                term: "Extra seats",
                text: 'The number of people to add beyond the plan. The field is inactive when the plan offers none ("This plan does not offer extra seats").'
              },
              addon: {
                term: "Extra storage",
                text: "A quantity field for each storage pack offered, to add space to your plan."
              },
              preview: {
                term: "Price preview",
                text: "The price shows before anything is confirmed: a table with Item, Qty, Unit price and Amount, then the Total excl. tax and Total incl. tax, and a sentence saying what will happen (invoice right away, change at the end of the period, or no change)."
              },
              blocked: {
                term: "This plan is too small for your current usage",
                text: "Message that appears when you use more than the chosen plan offers: it lists what to reduce (seats, storage or hosted shared spaces) before you can choose it."
              },
              confirm: {
                term: "Confirm the change",
                text: 'Validates the change, after an identity confirmation. When an invoice is issued, the button is called "Confirm and receive the invoice".'
              },
              issued: {
                term: "Invoice \u2026 issued",
                text: 'A window gives the "Amount due" and when the change applies (as soon as the invoice is paid). Choose "Pay" to pay now or "Later".'
              }
            }
          }
        }
      }
    },
    me: {
      profile: {
        title: "My profile",
        intro: "This page gathers your personal information: your name, your language, your time zone, the look of the application and access to your personal data. It only concerns you.",
        sections: {
          header: {
            title: "Tabs and messages",
            items: {
              tabs: {
                term: "Profile, Security, Notifications",
                text: "Three tabs at the top of your account pages: Profile, Security and Notifications. Click one to move from one page to another."
              },
              messages: {
                term: "Confirmation messages",
                text: 'After each save, a short message confirms it, for example "Your language is saved.". If it fails, a plain error message shows and the previous choice comes back.'
              }
            }
          },
          identity: {
            title: "Identity",
            items: {
              name: {
                term: "Display name",
                text: 'Required. Your name as your colleagues see it. If you leave it empty, "Type your name." shows.'
              },
              email: {
                term: "E-mail address",
                text: "Read-only: it is managed by your BatiFlow account and cannot be changed here."
              },
              save: {
                term: "Save",
                text: 'Saves your name. A message confirms that "Your name is saved."'
              }
            }
          },
          region: {
            title: "Language and region",
            items: {
              language: {
                term: "Interface language",
                text: "Fran\xE7ais, \u0627\u0644\u0639\u0631\u0628\u064A\u0629 or English. The change applies immediately, including the reading direction for Arabic, and it is saved on your account."
              },
              timeZone: {
                term: "Time zone",
                text: "The application's dates and times are shown in this time zone. Each entry in the list shows its offset from universal time."
              },
              digits: {
                term: "Digits of the Arabic interface",
                text: "Latin digits (0123456789) or Arabic-Indic digits (\u0660\u0661\u0662\u0663\u0664\u0665\u0666\u0667\u0668\u0669). This choice only applies when the interface is in Arabic."
              }
            }
          },
          appearance: {
            title: "Appearance",
            items: {
              theme: {
                term: "Theme",
                text: "Same as the system (follows your device setting), Light, Dark or High contrast (strongly marked colours, easier to read)."
              },
              device: {
                term: "This choice stays on this device",
                text: "The theme is not saved on your account: on another device or browser, you will need to choose it again."
              }
            }
          },
          myData: {
            title: "My personal data",
            items: {
              law: {
                term: "My personal data",
                text: "Organic law no. 2004-63 gives you the right to access the personal data BatiFlow holds about you. This section lets you get a copy of it."
              },
              button: {
                term: "Export my data",
                text: "Starts preparing a copy of your data. A message says it is being prepared and you get a notification when it is ready."
              },
              columns: {
                term: "Requested on, Size, Available until",
                text: 'The "My data exports" table gives the date of the request, the size of the file and the last day to download it.'
              },
              status: {
                term: "Status",
                text: "Queued, Being prepared, Ready, Failed or Expired. The list updates by itself while an export is being prepared."
              },
              download: {
                term: "Download",
                text: 'Downloads your copy. The button only appears on a "Ready" export.'
              },
              empty: {
                term: "No export yet",
                text: "Message of an empty list: ask for an export to receive a copy of your personal data. If the list does not load, a message asks you to check your connection."
              }
            }
          }
        }
      },
      security: {
        title: "Account security",
        intro: "This page helps you protect your account: two-step verification, your password and the devices signed in. It only concerns you.",
        sections: {
          header: {
            title: "Tabs and page layout",
            items: {
              tabs: {
                term: "Profile, Security, Notifications",
                text: "Three tabs at the top of your account pages: Profile, Security and Notifications. Click one to move from one page to another."
              },
              order: {
                term: "Account security",
                text: "The page reads from top to bottom: two-step verification, the password and the authenticator app, then the active sessions."
              }
            }
          },
          mfa: {
            title: "Two-step verification",
            items: {
              status: {
                term: "Turned on",
                text: 'Green chip: your current session was confirmed with a second factor (besides your password, a code from an authenticator app or a security key). Otherwise the orange chip says "Not turned on".'
              },
              off: {
                term: "Not turned on",
                text: "Your sign-in relies on your password alone. A text advises you to add a six-digit code from an authenticator app on your phone."
              },
              setUp: {
                term: "Turn on two-step verification",
                text: "Only visible when it is not turned on. It takes you to your account settings to set up the authenticator app, then you come back to this page after signing in again."
              }
            }
          },
          account: {
            title: "Password and authenticator app",
            items: {
              about: {
                term: "Password and authenticator app",
                text: "This block explains that you change your password, add or remove your authenticator app and manage your security keys in your BatiFlow account settings. It only appears when an account settings address is available."
              },
              open: {
                term: "Open account settings",
                text: "Opens your BatiFlow account settings in the same tab."
              }
            }
          },
          sessions: {
            title: "Active sessions",
            items: {
              device: {
                term: "Unknown device",
                text: 'Each row is a device that is signed in, with its name (a phone or computer icon). "Unknown device" shows when its name is not known. The current device comes first.'
              },
              thisDevice: {
                term: "This device",
                text: "Chip that marks the device you are using right now. It has no button to sign it out: to end this session, use your account menu."
              },
              flagged: {
                term: "Change detected",
                text: "Warning chip: the network or the browser changed during the session. If that was not you, sign this device out."
              },
              lastActivity: {
                term: "Last activity:",
                text: 'When the device was last used, as a relative time. Next to it, "Network:" gives the start of the network address used.'
              },
              revoke: {
                term: "Sign out",
                text: 'On another device: after you confirm ("Sign out \u201C\u2026\u201D?"), this device will have to sign in again to use BatiFlow. Your data is not changed.'
              },
              revokeOthers: {
                term: "Sign out other devices",
                text: "Button at the top of the block, only visible when other devices are signed in. After you confirm, all the other devices are signed out; this one stays signed in."
              },
              noOthers: {
                term: "No other device is signed in.",
                text: 'Message shown under the list when you are signed in on one device only. If there is no session to show, "No active session to show." appears.'
              },
              loadFailed: {
                term: "Your sessions cannot be shown",
                text: 'Error message with a "Try again" button when the list does not load. Your data is not lost.'
              }
            }
          }
        }
      },
      notifications: {
        title: "My notifications",
        intro: "This page lets you choose which notifications you receive, and where: in the application or by email. You also set the email digest and the hours when you do not want to be disturbed.",
        sections: {
          header: {
            title: "Tabs and loading",
            items: {
              tabs: {
                term: "Profile, Security, Notifications",
                text: "Three tabs at the top of your account pages: Profile, Security and Notifications. Click one to move from one page to another."
              },
              loadFailed: {
                term: "Unable to show your preferences",
                text: 'Error message with a "Try again" button when your preferences do not load.'
              }
            }
          },
          matrix: {
            title: "What, and where",
            items: {
              notification: {
                term: "Notification",
                text: 'One row per type of notification, for example "You are mentioned", "A task is assigned to you" or "Payment received". The rows are grouped by theme.'
              },
              groups: {
                term: "Conversations, Tasks, Approvals and sign-offs, Calendar, Partners and external spaces, Security, Billing and subscription",
                text: "The group titles that separate the rows of the table."
              },
              inApp: {
                term: "In the app",
                text: 'A check box: the notification appears in the application. For some important security notices, the box is checked and locked ("This important notice always stays on in the app.").'
              },
              email: {
                term: "By e-mail",
                text: "A list: Never, Immediately (an email for each notification) or In the digest (grouped with others in a single email)."
              },
              push: {
                term: "Push notification",
                text: 'Greyed-out box for now: this option comes with the mobile app ("Mobile app, coming later").'
              },
              scroll: {
                term: "Notification preferences table",
                text: 'On a small screen, the table scrolls sideways. Each box or list has a full name like "type: channel" for screen readers.'
              }
            }
          },
          digest: {
            title: "E-mail digest",
            items: {
              frequency: {
                term: "Digest frequency",
                text: 'No digest, Every hour or Every day. The digest groups the notifications set to "In the digest" into a single email; it is only sent when a frequency is chosen.'
              },
              warning: {
                term: "The digest is off",
                text: 'Warning message when some notifications are set to "In the digest" while no digest is sent: they will only stay in the app. Choose a frequency to receive them by email.'
              }
            }
          },
          quietHours: {
            title: "Quiet hours",
            items: {
              enable: {
                term: "Turn on quiet hours",
                text: "Switch. During these hours you do not receive notification emails; they reach you afterwards. The hours are in your time zone. When you turn it on, 22:00 to 07:00 is suggested."
              },
              start: {
                term: "Start",
                text: "The time quiet hours begin. Only visible when they are turned on."
              },
              end: {
                term: "End",
                text: "The time they finish. The start and the end must be two different times, otherwise a message says so."
              }
            }
          },
          actions: {
            title: "Save and restore",
            items: {
              save: {
                term: "Save",
                text: 'Saves all your preferences. If there is nothing new, "There is nothing to save" shows. If your preferences were changed elsewhere in the meantime, your changes are not saved and the current preferences are reloaded.'
              },
              reset: {
                term: "Restore the defaults",
                text: 'Fills the form with the values suggested by BatiFlow. Nothing changes until you click "Save".'
              },
              failure: {
                term: "The preferences could not be saved",
                text: "Plain error message, above the buttons, when saving fails. Your choices stay on screen."
              }
            }
          }
        }
      }
    },
    finance: {
      quotes: {
        title: "Quotes",
        intro: "The list of all your office\u2019s quotes (fee proposals sent to your clients), with their status. Use it to find a quote, follow it until it is accepted and create a new one.",
        sections: {
          header: {
            title: "Page header",
            items: {
              subNav: {
                term: "Finance",
                text: "The menu on the left lists the finance areas: Quotes, Contracts, Invoices, Payments, Expenses, Dashboard and Electronic invoice. You only see the ones your permissions allow; on a small screen it becomes a row of links above the page."
              },
              newQuote: {
                term: "New quote",
                text: "Opens an empty quote to fill in. This button only appears if you may create quotes; it is greyed out when the office account is read-only (a tooltip explains why)."
              }
            }
          },
          filters: {
            title: "Quote filters",
            items: {
              status: {
                term: "Status",
                text: "A drop-down to show only the quotes with one status: Draft, Sent, Accepted, Declined or Expired. \u201CAll statuses\u201D shows everything."
              },
              clear: {
                term: "Clear the filter",
                text: "Appears when no quote has the chosen status; it goes back to \u201CAll statuses\u201D."
              }
            }
          },
          table: {
            title: "Quotes",
            items: {
              number: {
                term: "Number",
                text: "The quote number. Click it to open the quote."
              },
              title: {
                term: "Subject",
                text: "What the quote offers, for example \u201CDesign supervision, two-storey villa\u201D."
              },
              client: {
                term: "Client",
                text: "The client (project owner) the quote is addressed to."
              },
              status: {
                term: "Status",
                text: "The state of the quote, written out in words and shown with a colour (see \u201CQuote statuses\u201D)."
              }
            }
          },
          amounts: {
            title: "Amounts and dates",
            items: {
              totalHt: {
                term: "Total excl. VAT",
                text: "The quote amount before taxes (VAT and other taxes are not included)."
              },
              totalTtc: {
                term: "Total incl. VAT",
                text: "The amount with all taxes included. Shows \u201C\u2014\u201D until the total is calculated."
              },
              validUntil: {
                term: "Valid until",
                text: "The last date on which the client can still accept the quote."
              },
              sentAt: {
                term: "Sent on",
                text: "The date it was sent to the client; \u201C\u2014\u201D if the quote has not been sent."
              },
              acceptedAt: {
                term: "Accepted on",
                text: "The date the client accepted; \u201C\u2014\u201D if not accepted yet."
              }
            }
          },
          statuses: {
            title: "Quote statuses",
            items: {
              draft: {
                term: "Draft",
                text: "The quote is being prepared and has not been sent: you can still edit or delete it."
              },
              sent: {
                term: "Sent",
                text: "The quote was sent to the client through a secure link and is waiting for an answer."
              },
              accepted: {
                term: "Accepted",
                text: "The client accepted the quote; you can turn it into a project and a contract."
              },
              rejected: {
                term: "Declined",
                text: "The quote was marked as declined by the client."
              },
              expired: {
                term: "Expired",
                text: "The validity date passed without the client accepting."
              }
            }
          },
          empty: {
            title: "Empty list, error and loading",
            items: {
              none: {
                term: "No quotes yet",
                text: "The empty-list message. If you may create quotes it offers \u201CNew quote\u201D; otherwise it says your office\u2019s quotes will appear here."
              },
              noMatch: {
                term: "No quote matches",
                text: "Shown when the filter finds nothing; the \u201CClear the filter\u201D button removes it."
              },
              loadMore: {
                term: "Show more quotes",
                text: "Under the list when there are many quotes: loads the next ones."
              },
              loadError: {
                term: "The quotes could not be loaded",
                text: "An error message when the connection fails; the \u201CTry again\u201D button reloads the list."
              }
            }
          }
        }
      },
      quote: {
        title: "Quote (new or existing)",
        intro: "The screen of one quote: you prepare the information, the fees and the lines, watch the totals calculate live, then send the quote to the client. It is used by people who may create quotes.",
        sections: {
          header: {
            title: "Header and messages",
            items: {
              subNav: {
                term: "Finance",
                text: "The menu on the left lets you go to another finance area (Quotes, Contracts, Invoices\u2026), depending on your permissions."
              },
              breadcrumb: {
                term: "Quotes",
                text: "The link at the top goes back to the list of quotes. If some changes are not saved, a window asks you to confirm."
              },
              save: {
                term: "Save",
                text: "Saves the quote; the first save creates it and gives it its number. Only shown if you may edit this quote."
              },
              notices: {
                term: "Information banners",
                text: "Above the form, a banner explains the situation: quote read-only (permissions or status), a sent quote you are taking back to edit, or \u201CSomeone changed this quote\u201D with the \u201CReload the quote\u201D button."
              },
              saveFirst: {
                term: "Save your changes first to use these actions.",
                text: "Shown when the form has unsaved changes: the action buttons wait until you save."
              }
            }
          },
          actions: {
            title: "Quote actions",
            items: {
              pdf: {
                term: "View the PDF",
                text: "Opens the quote as a PDF in a new tab. If the PDF is still being prepared, a message asks you to try again in a moment."
              },
              send: {
                term: "Send / Send again",
                text: "Sends the quote to the client by email with a secure link; the button reads \u201CSend again\u201D if the quote was already sent. Only for people allowed to send."
              },
              reject: {
                term: "Declined by the client",
                text: "Marks a sent quote as declined: the client\u2019s link no longer lets them accept it. A confirmation is asked."
              },
              edit: {
                term: "Edit the quote",
                text: "For a sent quote: puts it back to draft so you can correct it. The link already sent stops working, so you will need to send the quote again."
              },
              convert: {
                term: "Create the project",
                text: "On an accepted quote with no project: creates the project with the quote\u2019s client and fees. You also need the permission to create projects."
              },
              openProject: {
                term: "Open the project",
                text: "On an accepted quote already linked to a project: opens that project."
              },
              createContract: {
                term: "Create the contract",
                text: "On an accepted quote: creates the contract from the quote and opens it. Only for people who manage contracts."
              },
              delete: {
                term: "Delete the draft",
                text: "Permanently deletes a draft that was never sent, after confirmation."
              }
            }
          },
          general: {
            title: "General information",
            items: {
              client: {
                term: "Client",
                text: "Required: the project owner the quote is addressed to. Changing the client clears the chosen project."
              },
              project: {
                term: "Project",
                text: "Optional: a project of the chosen client, or \u201CNo project (for now)\u201D; you can create the project from the accepted quote."
              },
              title: {
                term: "Quote subject",
                text: "Required: a short sentence saying what the quote offers, for example \u201CDesign supervision, two-storey villa\u201D."
              },
              language: {
                term: "PDF language",
                text: "The language of the document sent to the client: French, Arabic or Bilingual (French and Arabic)."
              },
              validUntil: {
                term: "Valid until",
                text: "Required: after this date the client can no longer accept. A date already in the past is refused."
              },
              currency: {
                term: "Currency",
                text: "The currency of the quote: TND, EUR or USD."
              },
              exchangeRate: {
                term: "Exchange rate (TND for 1 unit)",
                text: "Shown for a currency other than the dinar: how many dinars 1 unit is worth, for example 3.350 for 1 EUR. Totals are then also given in dinars."
              }
            }
          },
          calculator: {
            title: "Fee calculation",
            items: {
              feeMode: {
                term: "Calculation mode",
                text: "How to work out your fees: Lump sum split by phase, Percentage of the works cost, Time spent, or Mixed (lines entered by hand)."
              },
              lumpTotal: {
                term: "Lump-sum fee excl. VAT",
                text: "For the lump-sum mode: the total of your fees, before taxes."
              },
              worksCost: {
                term: "Estimated works cost excl. VAT",
                text: "For the percentage mode: the estimated cost of the works, before taxes. The \u201CCalculated fee excl. VAT\u201D line shows the result."
              },
              rate: {
                term: "Fee rate (%)",
                text: "For the percentage mode: the rate applied to the works cost, for example 6 or 4.5. Between 0 and 100."
              },
              scale: {
                term: "Reference scale",
                text: "Optional: a scale (for example decree 78-71 or your office\u2019s own) gives a suggestion with its source. It is only applied if you click \u201CUse this suggestion\u201D; a simple warning flags fees below the minimum."
              },
              shares: {
                term: "Split by phase",
                text: "For the lump-sum and percentage modes: pick the phases and the \u201CShare (%)\u201D of each, which must total 100%. \u201CAdd a phase\u201D adds a row; \u201CUse the split of a mission type\u201D fills in starting shares."
              },
              time: {
                term: "Time spent",
                text: "For the time-spent mode: for each \u201CTask\u201D, enter \u201CHours or days\u201D and the \u201CUnit rate excl. VAT\u201D. \u201CAdd a task\u201D adds a row."
              },
              propose: {
                term: "Propose the lines",
                text: "Turns the calculation into quote lines that you can still edit. If lines already exist, a window \u201CReplace the current lines?\u201D asks you to confirm."
              }
            }
          },
          lines: {
            title: "Quote lines",
            items: {
              description: {
                term: "Description",
                text: "Required: what the line charges for, in a few words."
              },
              phase: {
                term: "Phase",
                text: "Puts the line in a phase of the mission; \u201CNo phase\u201D puts it under \u201COther lines\u201D. Lines are grouped by phase with a subtotal excl. VAT."
              },
              quantity: {
                term: "Quantity",
                text: "Required: a positive number with at most 3 decimals."
              },
              unitPrice: {
                term: "Unit price excl. VAT",
                text: "Required: the price of one unit, before taxes, in the quote\u2019s currency."
              },
              vat: {
                term: "VAT",
                text: "The VAT rate of the line, chosen from 19%, 13%, 7% and 0%."
              },
              amount: {
                term: "Amount excl. VAT",
                text: "Calculated for you: quantity \xD7 unit price. You cannot change it."
              },
              addRemove: {
                term: "Add a line",
                text: "Adds an empty line; \u201CAdd a line to this phase\u201D adds it inside that phase. The icon button \u201CDelete line\u201D removes a line."
              },
              total: {
                term: "Total of the lines excl. VAT",
                text: "The sum of the lines before taxes, at the bottom of the section."
              }
            }
          },
          notesTotals: {
            title: "Notes and totals",
            items: {
              notes: {
                term: "Notes for the client",
                text: "Optional: special conditions, assumptions, exclusions. This text goes with the quote."
              },
              totals: {
                term: "Totals",
                text: "The totals card (excl. VAT, VAT, stamp, incl. taxes, withholdings, net payable) calculates live. It is indicative: the invoice recalculates the amounts when it is issued."
              },
              needInfo: {
                term: "Choose a client to calculate the totals\u2026",
                text: "Instead of the card, a sentence tells you what is missing: a client, the exchange rate (foreign currency) or complete lines (quantity and price)."
              }
            }
          },
          history: {
            title: "Quote history",
            items: {
              status: {
                term: "Status",
                text: "The quote status (Draft, Sent, Accepted, Declined, Expired), first in the list."
              },
              created: {
                term: "Created on \u2026 by \u2026",
                text: "The creation date and who created the quote."
              },
              sent: {
                term: "Sent on \u2026 by \u2026",
                text: "The date it was sent and by whom; otherwise \u201CThis quote has not been sent yet.\u201D"
              },
              linkExpires: {
                term: "The client\u2019s link is valid until \u2026",
                text: "For a sent quote: the date until which the link the client received works."
              },
              accepted: {
                term: "Accepted on \u2026 by \u2026",
                text: "The acceptance date and the name the client typed."
              },
              pdfHash: {
                term: "Fingerprint of the accepted PDF (SHA-256)",
                text: "A code that identifies exactly the PDF the client accepted: it proves the document did not change."
              },
              rejected: {
                term: "Declined by the client on \u2026",
                text: "The date the quote was marked as declined."
              },
              pdfReady: {
                term: "PDF ready / PDF being prepared",
                text: "Tells whether the quote\u2019s PDF has already been generated."
              }
            }
          },
          dialogs: {
            title: "Confirmation windows",
            items: {
              send: {
                term: "Send the quote",
                text: "The sending window: choose the \u201CRecipient\u201D (the client\u2019s email address or one of their contacts) and, if you wish, a \u201CMessage for the client (optional)\u201D. The link sent is valid for 30 days."
              },
              convert: {
                term: "Create the project",
                text: "The creation window: \u201CProject name\u201D (required), \u201CMission type\u201D (its standard phases and folders are created) and \u201CProject code (optional)\u201D, generated if you leave it empty."
              },
              reject: {
                term: "Mark the quote as declined?",
                text: "Asks you to confirm before marking the quote as declined by the client."
              },
              remove: {
                term: "Delete the draft?",
                text: "Asks you to confirm before permanently deleting a draft that was never sent."
              },
              editSent: {
                term: "Edit a sent quote?",
                text: "Warns that the quote goes back to draft and the link sent stops working; you will need to send it again."
              },
              leave: {
                term: "Leave without saving?",
                text: "Appears if you leave the screen with unsaved changes: \u201CLeave\u201D drops them, \u201CStay on the quote\u201D keeps them."
              }
            }
          }
        }
      },
      contracts: {
        title: "Contracts",
        intro: "The list of your office\u2019s contracts (private agreements and public markets) with their amounts and key dates. It is used by people who follow the commitments signed with clients.",
        sections: {
          header: {
            title: "Page header",
            items: {
              subNav: {
                term: "Finance",
                text: "The menu on the left lists the finance areas your permissions allow (Quotes, Contracts, Invoices, Payments\u2026); on a small screen it becomes a row of links."
              },
              newContract: {
                term: "New contract",
                text: "Opens an empty contract. Only shown to people who manage contracts."
              }
            }
          },
          filters: {
            title: "Contract filters",
            items: {
              kind: {
                term: "Kind of contract",
                text: "A drop-down to show only private agreements or only public markets; \u201CAll kinds\u201D shows everything."
              },
              clear: {
                term: "Clear the filter",
                text: "Appears when no contract is of the chosen kind; it goes back to \u201CAll kinds\u201D."
              }
            }
          },
          table: {
            title: "List of contracts",
            items: {
              reference: {
                term: "Reference",
                text: "The market or agreement number. Click it to open the contract."
              },
              client: {
                term: "Client",
                text: "The client the contract is signed with."
              },
              kind: {
                term: "Kind",
                text: "Private agreement (a deal between two parties) or Public market (a contract with a public body, subject to regulatory limits)."
              }
            }
          },
          amounts: {
            title: "Amounts and dates",
            items: {
              amount: {
                term: "Amount excl. VAT",
                text: "The signed amount, before taxes, amendments excluded."
              },
              total: {
                term: "Total with amendments",
                text: "The amount excluding VAT once the amendments are added (an amendment is a signed act that changes the amount)."
              },
              signedOn: {
                term: "Signed on",
                text: "The signature date; \u201C\u2014\u201D if it is not filled in."
              },
              bondReleaseOn: {
                term: "Bond release",
                text: "The planned date to release the performance bond (the guarantee lodged with a bank); \u201C\u2014\u201D if there is none."
              }
            }
          },
          empty: {
            title: "Empty list, error and loading",
            items: {
              none: {
                term: "No contracts yet",
                text: "The empty-list message. It offers \u201CNew contract\u201D to people who manage contracts; others see that their office\u2019s contracts will appear here."
              },
              noMatch: {
                term: "No contract matches",
                text: "Shown when the filter finds nothing; the \u201CClear the filter\u201D button removes it."
              },
              loadMore: {
                term: "Show more contracts",
                text: "Under the list: loads the next contracts."
              },
              loadError: {
                term: "The contracts could not be loaded",
                text: "An error message when the connection fails; \u201CTry again\u201D reloads the list."
              }
            }
          }
        }
      },
      contract: {
        title: "Contract (new or existing)",
        intro: "The screen of one contract: general information, payment terms (advance, retention, performance bond, penalties), amendments and invoiced progress. People who manage contracts can edit it; others can only view it.",
        sections: {
          header: {
            title: "Header and messages",
            items: {
              subNav: {
                term: "Finance",
                text: "The menu on the left lets you go to another finance area, depending on your permissions."
              },
              breadcrumb: {
                term: "Contracts",
                text: "The link at the top goes back to the list of contracts; a window asks you to confirm if changes are not saved (\u201CLeave without saving?\u201D)."
              },
              save: {
                term: "Save",
                text: "Saves the contract; the first save creates it. Only shown to people who manage contracts."
              },
              fromQuote: {
                term: "Contract created from a quote: open the quote",
                text: "A link back to the original quote, for people who can read quotes."
              },
              notices: {
                term: "Information banners",
                text: "\u201CYou can view this contract but not change it\u201D when read-only; \u201CSomeone else changed this contract\u201D with \u201CReload the contract\u201D; \u201CThe contract could not be saved\u201D when saving fails."
              }
            }
          },
          general: {
            title: "General information",
            items: {
              client: {
                term: "Client",
                text: "Required when creating. The client of a contract cannot be changed afterwards."
              },
              project: {
                term: "Project",
                text: "Optional: the project of that client, or \u201CNo project\u201D. Without a project, progress by phase is not available."
              },
              reference: {
                term: "Contract reference",
                text: "Required: the market or agreement number, unique in your office."
              },
              kind: {
                term: "Kind",
                text: "Private agreement or Public market; a public market shows warnings when its terms go above the regulatory limits."
              },
              currency: {
                term: "Currency",
                text: "The contract currency: TND, EUR or USD."
              },
              amount: {
                term: "Amount excl. VAT",
                text: "Required: the signed amount, before taxes, amendments excluded."
              },
              signedOn: {
                term: "Signature date",
                text: "Optional: the date the contract was signed."
              },
              total: {
                term: "Total excl. VAT with amendments:",
                text: "Shown on a saved contract: the amount before taxes, amendments included. Calculated for you."
              }
            }
          },
          terms: {
            title: "Payment terms",
            items: {
              advance: {
                term: "Advance",
                text: "A sum paid at the start, as a percentage of the amount, for example 10."
              },
              retention: {
                term: "Retention",
                text: "A percentage withheld on each progress invoice and released by the final invoice."
              },
              retentionBase: {
                term: "Retention base",
                text: "The amount the retention is calculated on: Amount excluding taxes (default) or Amount including taxes. To confirm with your chartered accountant."
              },
              bond: {
                term: "Performance bond",
                text: "A bank guarantee expressed as a percentage of the amount."
              },
              bondReleaseOn: {
                term: "Bond release date",
                text: "A reminder is sent 7 days before and on the day. This field is only active if a performance bond is entered."
              },
              penaltyRate: {
                term: "Late penalty per day",
                text: "As a percentage of the amount, for each day of delay."
              },
              penaltyCap: {
                term: "Penalty ceiling",
                text: "The most the penalties can reach, as a percentage of the amount."
              },
              warnings: {
                term: "Terms above the limits of a public market",
                text: "For a public market, an orange banner lists the terms that go above the limits, with the legal reference. It does not block saving: the market may provide for a derogation."
              }
            }
          },
          amendments: {
            title: "Amendments",
            items: {
              total: {
                term: "Total excl. VAT with amendments:",
                text: "The contract amount once all the amendments are added."
              },
              add: {
                term: "Add an amendment",
                text: "Opens the adding window. Only for people who manage contracts; you must save your changes first."
              },
              number: {
                term: "No.",
                text: "The order number of the amendment."
              },
              label: {
                term: "Subject",
                text: "What the amendment changes, with its description if there is one."
              },
              delta: {
                term: "Change of amount",
                text: "How much the amendment increases or reduces the contract amount."
              },
              signedOn: {
                term: "Signed on",
                text: "The signature date of the amendment."
              },
              document: {
                term: "Signed document",
                text: "The signed document linked to the amendment (taken from the project\u2019s documents), or \u201C\u2014\u201D if there is none."
              },
              empty: {
                term: "No amendments",
                text: "The empty-table message: an amendment changes the contract amount and, once saved, can no longer be changed."
              }
            }
          },
          amendmentDialog: {
            title: "Add an amendment",
            items: {
              label: {
                term: "Subject of the amendment",
                text: "Required: what the amendment changes."
              },
              description: {
                term: "Description (optional)",
                text: "A few details so you can remember why the amendment exists."
              },
              delta: {
                term: "Change of the amount excl. VAT",
                text: "Required: positive for an increase, negative for a reduction (for example -500)."
              },
              signedOn: {
                term: "Signature date",
                text: "Required: the date the amendment was signed."
              },
              document: {
                term: "Signed document (documents)",
                text: "Optional: \u201CChoose a document\u201D from the project\u2019s folders (then \u201CChange\u201D or \u201CRemove\u201D). If the contract has no linked project, this area is replaced by a reminder."
              },
              submit: {
                term: "Add the amendment",
                text: "Saves the amendment. An amendment is a signed act: it is not edited any more; if it is wrong, add a corrective amendment. \u201CCancel\u201D closes the window."
              }
            }
          },
          progress: {
            title: "Invoiced progress",
            items: {
              summary: {
                term: "Contract total (excl. VAT)",
                text: "A summary: contract total, advance, advance already recovered and retention already withheld."
              },
              phases: {
                term: "Invoiced progress by phase",
                text: "A table by phase: Phase, Status, Fee, Invoiced (cumulative) and Amount invoiced."
              },
              prepare: {
                term: "Prepare a progress invoice",
                text: "Opens the progress-invoice screen (billing according to progress). Only for people who can create invoices, and only for a contract linked to a project and in TND."
              },
              needProject: {
                term: "Link this contract to a project\u2026",
                text: "Shown when the contract has no project: following progress by phase needs one."
              },
              needTnd: {
                term: "Progress invoices are in dinars\u2026",
                text: "Shown for a contract in EUR or USD: the progress is not available."
              }
            }
          }
        }
      },
      progress: {
        title: "Progress invoice",
        intro: "The screen that prepares a progress invoice: an invoice based on how far each phase of the project has advanced. For each phase you enter the progress reached, and the amount for the period is calculated for you.",
        sections: {
          header: {
            title: "Header and messages",
            items: {
              subNav: {
                term: "Finance",
                text: "The menu on the left stays visible (the \u201CInvoices\u201D area is highlighted) and lets you change area."
              },
              breadcrumb: {
                term: "Contracts",
                text: "The breadcrumb goes back to the list of contracts, then to the contract itself, for people who can read them."
              },
              submit: {
                term: "Create the draft invoice",
                text: "Creates a draft invoice with the result of the calculation, then opens it. Only shown to people who can create invoices and when an invoice is possible."
              },
              blocked: {
                term: "Contract closed / The fee shares of the phases do not total 100 %",
                text: "\u201CContract closed\u201D: the final invoice was issued, nothing is left to prepare. \u201CThe fee shares of the phases do not total 100 %\u201D: correct them through the \u201COpen the project\u2019s phases\u201D link."
              },
              errors: {
                term: "The invoice could not be created",
                text: "A message explains why, for example if there is nothing to invoice since the last invoice or if a progress invoice is still a draft."
              }
            }
          },
          phases: {
            title: "Progress by phase",
            items: {
              help: {
                term: "Cumulative progress",
                text: "For each phase, enter the cumulative progress since the start: the amount of the period is computed live, and the summary by phase is printed on the PDF."
              },
              final: {
                term: "Final invoice at final reception",
                text: "A switch: every phase goes to 100 %, the rest of the advance is recovered and the retention is released. The percentage fields are then locked."
              },
              phase: {
                term: "Phase",
                text: "The name of the project phase."
              },
              fee: {
                term: "Fee of the phase",
                text: "The share of the contract amount that belongs to this phase."
              },
              previous: {
                term: "Already invoiced",
                text: "The percentage of the phase already invoiced by earlier progress invoices."
              },
              cumulative: {
                term: "New cumulative",
                text: "To fill in: the new cumulative percentage of the phase (0 to 100, at most 2 decimals). It cannot be lower than \u201CAlready invoiced\u201D."
              },
              period: {
                term: "Amount of the period",
                text: "Calculated for you: the amount to invoice this time for the phase; \u201C\u2014\u201D if it cannot be calculated."
              }
            }
          },
          totals: {
            title: "Amounts of this invoice",
            items: {
              work: {
                term: "Work of the period (excl. VAT)",
                text: "The total of the amounts of the period, before taxes."
              },
              advanceRecovery: {
                term: "Advance recovery",
                text: "The part of the advance paid at the start that is taken back on this invoice."
              },
              retention: {
                term: "Retention / Retention release",
                text: "The retention kept on this invoice (with its rate); on a final invoice it is replaced by the release of the retention."
              },
              net: {
                term: "Net excl. VAT of the invoice",
                text: "The result: work, minus the advance recovery, minus the retention (or plus its release)."
              },
              taxesHint: {
                term: "VAT, stamp duty and withholdings",
                text: "VAT, stamp duty and withholdings are computed on the draft invoice, which opens after saving. If a percentage is wrong, a message asks you to correct it first."
              }
            }
          },
          options: {
            title: "Invoice options",
            items: {
              language: {
                term: "PDF language",
                text: "The language of the document sent to the client: French, Arabic or Bilingual (French and Arabic)."
              },
              dueDate: {
                term: "Due date",
                text: "Optional: without a date, the client\u2019s payment terms apply."
              },
              notes: {
                term: "Notes",
                text: "Optional: free text of up to 2,000 characters for the invoice."
              }
            }
          }
        }
      },
      invoices: {
        title: "Invoices",
        intro: "The list of all your office\u2019s invoices (advances, deposits, progress statements, final invoices and credit notes), with their state, their electronic-invoice sending and their payment. Use it to find an invoice, see what is left to collect and create a new one.",
        sections: {
          header: {
            title: "Page header",
            items: {
              subNav: {
                term: "Finance",
                text: "The menu on the left lists the finance areas your permissions allow (Quotes, Contracts, Invoices, Payments\u2026); on a small screen it becomes a row of links."
              },
              newInvoice: {
                term: "New invoice",
                text: "Opens an empty invoice. Only shown if you may create invoices; greyed out when the office account is read-only."
              }
            }
          },
          filters: {
            title: "Invoice filters",
            items: {
              status: {
                term: "Status",
                text: "Shows only Draft, Issued or Cancelled by credit note invoices; \u201CAll statuses\u201D shows everything."
              },
              payment: {
                term: "Payment",
                text: "Shows only Unpaid, Partially paid or Paid invoices; \u201CAll payments\u201D shows everything."
              },
              kind: {
                term: "Type",
                text: "Shows only one type of invoice (advance, deposit, progress, final or credit note); \u201CAll types\u201D shows everything."
              },
              clear: {
                term: "Clear filters",
                text: "Appears when no invoice fits the chosen filters; it resets the three filters."
              }
            }
          },
          table: {
            title: "List of invoices",
            items: {
              number: {
                term: "Number",
                text: "The final invoice number, given when it is issued. A draft has none yet: it shows \u201CDraft\u201D. Click it to open the invoice."
              },
              client: {
                term: "Client",
                text: "The client the invoice is addressed to."
              },
              kind: {
                term: "Type",
                text: "The type of invoice (see \u201CInvoice types\u201D)."
              },
              status: {
                term: "Status",
                text: "The state of the invoice itself (see \u201CInvoice and payment states\u201D)."
              },
              ttn: {
                term: "E-invoice (TTN)",
                text: "Where the sending of the invoice to TTN, the official electronic-invoicing platform, stands; \u201C\u2014\u201D for a draft."
              },
              payment: {
                term: "Payment",
                text: "Whether the invoice is paid; \u201C\u2014\u201D for a draft and for a credit note."
              }
            }
          },
          amounts: {
            title: "Amounts and dates",
            items: {
              totalTtc: {
                term: "Total incl. taxes",
                text: "The invoice total with all taxes included."
              },
              netPayable: {
                term: "Net payable",
                text: "What the client really has to pay you, after any withholding taxes."
              },
              issueDate: {
                term: "Issued on",
                text: "The issue date; \u201C\u2014\u201D for a draft."
              },
              dueDate: {
                term: "Due date",
                text: "The payment deadline; \u201C\u2014\u201D if none is set."
              }
            }
          },
          statuses: {
            title: "Invoice and payment states",
            items: {
              draft: {
                term: "Draft",
                text: "The invoice is being prepared: it has no number and can still be changed or deleted."
              },
              issued: {
                term: "Issued",
                text: "The invoice has its final number and can never be changed again; to correct it, you issue a credit note."
              },
              credited: {
                term: "Cancelled by credit note",
                text: "A credit note cancelled the invoice."
              },
              unpaid: {
                term: "Unpaid",
                text: "No payment has been recorded yet."
              },
              partiallyPaid: {
                term: "Partially paid",
                text: "Only part of it has been paid."
              },
              paid: {
                term: "Paid",
                text: "The invoice is fully settled."
              }
            }
          },
          ttnStatuses: {
            title: "E-invoice (TTN) states",
            items: {
              notRequired: {
                term: "Not required",
                text: "This invoice does not go through electronic invoicing."
              },
              pending: {
                term: "Pending",
                text: "The sending to TTN is being prepared."
              },
              submitted: {
                term: "Submitted",
                text: "The invoice was sent to TTN, which still has to answer."
              },
              submittedManually: {
                term: "Submitted manually",
                text: "You filed the invoice yourself on TTN\u2019s portal."
              },
              accepted: {
                term: "Accepted",
                text: "TTN accepted the invoice."
              },
              rejected: {
                term: "Rejected",
                text: "TTN refused the invoice; the invoice screen explains what to do."
              }
            }
          },
          kinds: {
            title: "Invoice types",
            items: {
              advance: {
                term: "Advance invoice",
                text: "An invoice for a sum asked for at the start of a contract."
              },
              deposit: {
                term: "Deposit invoice",
                text: "An invoice for a partial payment asked for in advance."
              },
              progress: {
                term: "Progress invoice",
                text: "An invoice based on how far the works or phases have advanced."
              },
              final: {
                term: "Final invoice",
                text: "The last invoice of a contract, at final reception."
              },
              creditNote: {
                term: "Credit note",
                text: "A document that cancels all or part of an invoice already issued."
              }
            }
          },
          empty: {
            title: "Empty list, error and loading",
            items: {
              none: {
                term: "No invoices yet",
                text: "The empty-list message. It offers \u201CNew invoice\u201D to people who can create invoices; others see that their office\u2019s invoices will appear here."
              },
              noMatch: {
                term: "No invoice matches",
                text: "Shown when the filters find nothing; \u201CClear filters\u201D removes them."
              },
              loadMore: {
                term: "Show more invoices",
                text: "Under the list: loads the next invoices."
              },
              loadError: {
                term: "The invoices could not be loaded",
                text: "An error message when the connection fails; \u201CTry again\u201D reloads the list."
              }
            }
          }
        }
      },
      invoice: {
        title: "Invoice (new or existing)",
        intro: "The screen of one invoice: you prepare a draft (client, lines, VAT), watch the totals live, then issue it. An issued invoice or a credit note is view-only; there you follow the electronic sending and the payments.",
        sections: {
          header: {
            title: "Header and actions",
            items: {
              subNav: {
                term: "Finance",
                text: "The menu on the left lets you go to another finance area, depending on your permissions."
              },
              breadcrumb: {
                term: "Invoices",
                text: "The link at the top goes back to the list of invoices; a window asks you to confirm if changes are not saved."
              },
              save: {
                term: "Save",
                text: "Saves the draft; the first save creates it. Only shown for a draft you may edit."
              },
              issue: {
                term: "Issue",
                text: "On a saved draft: gives the invoice its final number. Only for people allowed to issue; save your changes first."
              },
              pdf: {
                term: "View the PDF",
                text: "On an issued invoice or a credit note: opens the PDF in a new tab, or tells you to try again if the PDF is being prepared."
              },
              recordPayment: {
                term: "Record a payment",
                text: "On an issued invoice that is not fully paid: opens the window for a payment received. Only for people who can record payments."
              },
              creditNote: {
                term: "Issue a credit note",
                text: "On an issued invoice: opens the credit-note window to cancel it in full or in part. Only for people allowed to issue."
              },
              delete: {
                term: "Delete the draft",
                text: "Permanently deletes a draft, after confirmation; no number has been used."
              }
            }
          },
          messages: {
            title: "Messages and windows",
            items: {
              readOnly: {
                term: "Read-only banners",
                text: "\u201CThis invoice is issued: it can never be changed again\u201D (with an invitation to issue a credit note), \u201CAn issued credit note is final\u201D, or \u201CYou can view this invoice, but\u2026\u201D if you may not edit it."
              },
              linesLocked: {
                term: "Lines from a progress statement",
                text: "On a draft that comes from a progress invoice, the lines (advances, retentions) are locked; delete the draft and build it again to change them. The other fields can still be edited."
              },
              missing: {
                term: "To issue this invoice, you still need to complete",
                text: "The list of mandatory mentions that are missing (office fiscal profile, client address or tax id, lines\u2026). The links \u201CComplete the fiscal profile\u201D and \u201COpen the client\u2019s page\u201D lead to where to fix it."
              },
              issueDialog: {
                term: "Issue this invoice?",
                text: "Recalls the total including taxes and the net payable, warns that an issued invoice can never be changed (if there is a mistake you issue a credit note) and says an identity check will be asked. \u201CIssue the invoice\u201D confirms."
              },
              issueProblems: {
                term: "The totals changed / Mandatory mentions are missing",
                text: "If issuing is refused: \u201CThe totals changed\u201D (the draft shows the new totals; \u201CGot it\u201D closes the message) or \u201CMandatory mentions are missing\u201D with the list to complete."
              },
              creditMode: {
                term: "Scope of the credit note",
                text: "In the credit-note window: \u201CCancel the whole invoice (stamp included)\u201D or \u201CCredit some lines\u201D. In the second case, tick each line concerned and enter the quantity to credit."
              },
              creditReason: {
                term: "Reason for the credit note",
                text: "Required, 500 characters at most. \u201CIssue the credit note\u201D creates it immediately, with its own number; \u201CCancel\u201D closes the window."
              },
              stale: {
                term: "Someone else changed this invoice",
                text: "Another user saved this draft while you were editing it: \u201CReload the invoice\u201D shows its latest version."
              }
            }
          },
          general: {
            title: "General information",
            items: {
              kind: {
                term: "Invoice type",
                text: "Advance, deposit, progress statement or final invoice (see the invoice list for what they mean)."
              },
              client: {
                term: "Client",
                text: "Required: the project owner to invoice. Changing the client clears the project and the phases of the lines."
              },
              project: {
                term: "Project",
                text: "Optional: lets you group the lines by phase of the project."
              },
              series: {
                term: "Numbering series",
                text: "Only shown if the office has several series: the number is assigned when the invoice is issued, with no gaps. \u201CDefault series\u201D suits most cases."
              },
              language: {
                term: "PDF language",
                text: "The language of the printed invoice: French, Arabic or Bilingual (French and Arabic)."
              },
              currency: {
                term: "Currency and exchange rate",
                text: "TND, EUR or USD. For a foreign currency, the \u201CExchange rate (TND for 1 unit)\u201D is required (for example 3.350 for 1 EUR) and totals are also given in dinars."
              },
              vatTreatment: {
                term: "VAT treatment",
                text: "According to the client (default), Standard VAT, VAT suspended or Export (exempt). For suspension, the \u201CTreatment reference\u201D (certificate number) is required."
              },
              dueDate: {
                term: "Due date",
                text: "Optional: without a date, the client\u2019s payment term applies when the invoice is issued. On an issued invoice you also see the \u201CIssue date\u201D and the \u201CTax rule set applied\u201D."
              }
            }
          },
          lines: {
            title: "Invoice lines",
            items: {
              description: {
                term: "Description",
                text: "Required: what the line charges for."
              },
              phase: {
                term: "Phase",
                text: "Shown when a project is chosen: puts the line in a phase of the project. Lines are grouped by phase, with a subtotal excl. VAT."
              },
              quantity: {
                term: "Quantity",
                text: "Required: a positive number with at most 3 decimals."
              },
              unitPrice: {
                term: "Unit price excl. VAT",
                text: "Required: the price of one unit, before taxes."
              },
              vat: {
                term: "VAT",
                text: "The VAT rate of the line: 19%, 13%, 7% or 0%."
              },
              amount: {
                term: "Amount excl. VAT",
                text: "Calculated for you: quantity \xD7 unit price."
              },
              addRemove: {
                term: "Add a line",
                text: "Adds an empty line; \u201CAdd a line to this phase\u201D adds it to the phase. The icon button \u201CRemove line\u201D removes one. \u201CTotal of the lines excl. VAT\u201D gives the sum."
              },
              roles: {
                term: "Line type",
                text: "On an issued invoice, the lines of a progress statement are followed by a word: Advance recovery, Retention or Retention release."
              }
            }
          },
          attachmentsNotes: {
            title: "Attachments and notes",
            items: {
              attachments: {
                term: "Attachments",
                text: "The documents attached to the invoice (for example a reception report). To add one, type at least 2 characters of the title or code in \u201CSearch for a document to attach\u201D; the \u201CRemove\u201D button takes one off. They are kept under legal hold with the invoice once it is issued."
              },
              notes: {
                term: "Invoice notes",
                text: "Optional: printed on the invoice (terms, special mention), 2,000 characters at most."
              }
            }
          },
          totals: {
            title: "Totals",
            items: {
              subtotalHt: {
                term: "Subtotal excl. VAT",
                text: "The sum of all the lines, before taxes."
              },
              vat: {
                term: "VAT (rate)",
                text: "Value-added tax, calculated line by line with each line\u2019s rate. It can be \u201CVAT suspended\u201D or \u201CVAT exemption for export\u201D depending on the treatment chosen."
              },
              stamp: {
                term: "Stamp duty",
                text: "A small fixed duty added to the invoice. It can be \u201CExempt\u201D (export, public buyer) or kept on a partial credit note."
              },
              totalTtc: {
                term: "Total incl. taxes",
                text: "The total with all taxes included: excl. VAT + VAT + stamp. This is the invoice amount."
              },
              withholding: {
                term: "Withholding tax (rate)",
                text: "A share of the total that some clients (public bodies, companies) keep to pay to the tax administration themselves. It is shown as a deduction and only appears if it applies to this client."
              },
              vatWithholding: {
                term: "VAT withholding (rate)",
                text: "A part of the VAT that the client withholds to pay to the Treasury (public bodies). It is also shown as a deduction."
              },
              netPayable: {
                term: "Net payable",
                text: "What the client really pays you: the total incl. taxes minus the withholdings. For example, for 11,544.000 TND incl. taxes and 173.000 TND withheld, the net payable is 11,371.000 TND."
              },
              details: {
                term: "Notes under the card",
                text: "Under some lines: the calculation base, the legal reference, \u201CRule to verify\u201D (depending on the environment). Further down: the VAT suspension or export mention, the \u201CAmount in words\u201D and, for a foreign currency, the equivalent in dinars."
              }
            }
          },
          history: {
            title: "Invoice history",
            items: {
              statuses: {
                term: "Invoice states",
                text: "Three badges: Invoice (Draft, Issued, Cancelled by credit note), E-invoice (TTN) and Payment, the last two only once the invoice is issued."
              },
              created: {
                term: "Created on \u2026 by \u2026",
                text: "The creation date and who created it."
              },
              issued: {
                term: "Issued as number \u2026 on \u2026 by \u2026",
                text: "The number, the date and the person who issued the invoice; otherwise \u201CThis invoice is not issued yet: it has no number.\u201D"
              },
              legalHold: {
                term: "Kept under legal hold until \u2026",
                text: "The date until which the invoice and its attachments must be kept."
              },
              credits: {
                term: "Credit notes",
                text: "\u201CCredit note on invoice\u201D with a link to the original invoice, and \u201CAlready credited by credit notes\u201D with the amount credited."
              },
              pdf: {
                term: "PDF ready / PDF being prepared",
                text: "Tells whether the invoice\u2019s PDF has already been generated."
              },
              payments: {
                term: "Payment of \u2026 (method): amount",
                text: "One payment per line, with the date, the method and the amount, plus any sums withheld by the client. If there are none: \u201CNo payment recorded.\u201D Only for people who can read payments."
              }
            }
          },
          einvoice: {
            title: "Electronic invoice (El Fatoora)",
            items: {
              panel: {
                term: "Electronic invoice (El Fatoora)",
                text: "For an issued invoice that goes through electronic invoicing: where the sending to TTN stands, what to do next and the list of attempts. The page updates by itself."
              },
              attempts: {
                term: "Sendings to TTN",
                text: "Each attempt has a number, a status (Signed, Sent to TTN, Accepted, Rejected, Failed, Filed manually), its dates and the TTN reference; if there are none: \u201CNothing has been sent to TTN yet\u201D."
              },
              wait: {
                term: "Being processed by TTN",
                text: "Nothing to do: the page updates as soon as TTN answers."
              },
              resubmit: {
                term: "Fix, then send again",
                text: "When TTN rejects the invoice or sending fails: the reason is explained, then this button sends the invoice again with the same number, without changing it. Sometimes a certificate must be sorted out first (link \u201CManage signing certificates\u201D)."
              },
              creditNoteNeeded: {
                term: "TTN refuses the content of the invoice",
                text: "The number of an issued invoice cannot be reused with corrected content: the \u201CIssue a credit note\u201D button cancels the invoice, then you create a new corrected invoice."
              },
              manual: {
                term: "Automatic sending is not possible: manual filing",
                text: "Three steps: \u201CDownload the TEIF\u201D (the invoice file, signed or not), file it on TTN\u2019s El Fatoora portal, then write down the \u201CTTN reference\u201D you get (3 to 100 characters) and \u201CSave the reference\u201D."
              },
              accepted: {
                term: "Invoice accepted by TTN",
                text: "The invoice\u2019s PDF now carries the TTN reference and the QR code."
              },
              manualDone: {
                term: "Invoice filed manually on the TTN portal",
                text: "Confirms the manual filing and recalls the reference typed by hand."
              }
            }
          }
        }
      },
      payments: {
        title: "Payments",
        intro: "The list of payments received from your clients, with the state of the withholding certificates, the aged receivables and the reminder settings. It is used by people who follow collections.",
        sections: {
          header: {
            title: "Page header",
            items: {
              subNav: {
                term: "Finance",
                text: "The menu on the left lists the finance areas your permissions allow (Quotes, Contracts, Invoices, Payments\u2026); on a small screen it becomes a row of links."
              },
              recordFrom: {
                term: "Record a payment",
                text: "There is no create button here: a payment is recorded from an issued invoice, with \u201CRecord a payment\u201D (see below)."
              }
            }
          },
          table: {
            title: "Payments received",
            items: {
              receivedOn: {
                term: "Received on",
                text: "The date the money was received."
              },
              invoice: {
                term: "Invoice",
                text: "The number of the invoice that was paid. Click it to open it."
              },
              client: {
                term: "Client",
                text: "The client who paid."
              },
              method: {
                term: "Method",
                text: "How the client paid (see \u201CPayment methods\u201D)."
              },
              amount: {
                term: "Amount received",
                text: "The amount actually collected, net of withholdings."
              },
              empty: {
                term: "No payments yet",
                text: "The empty-list message: payments are recorded from an issued invoice. \u201CShow more payments\u201D loads the rest; if there is an error, \u201CTry again\u201D reloads."
              }
            }
          },
          withholdings: {
            title: "Withholdings and certificate",
            items: {
              withholding: {
                term: "Withholding",
                text: "Withholding tax: the share the client kept to pay to the tax administration."
              },
              vatWithholding: {
                term: "VAT withholding",
                text: "The withholding on VAT, kept by the client (public bodies) for the Treasury."
              },
              certificate: {
                term: "Withholding certificate",
                text: "The document the client must give you when they withhold a sum. \u201CReceived\u201D (with its TEJ reference), \u201CMissing\u201D, or \u201CNot applicable\u201D when nothing was withheld."
              },
              add: {
                term: "Add",
                text: "Next to \u201CMissing\u201D: opens the window to attach the certificate. Only for people who can record payments."
              },
              reference: {
                term: "Reference",
                text: "The transfer or deposit number\u2026 noted with the payment; \u201C\u2014\u201D if none."
              }
            }
          },
          methods: {
            title: "Payment methods",
            items: {
              transfer: {
                term: "Bank transfer",
                text: "Payment by bank transfer."
              },
              cheque: {
                term: "Cheque",
                text: "Payment by cheque: the number, the bank and the validity are asked."
              },
              bill: {
                term: "Bill of exchange",
                text: "Payment by bill of exchange."
              },
              cash: {
                term: "Cash",
                text: "Payment in cash; a warning may say that a large amount is not tax-deductible for the client."
              },
              online: {
                term: "Online payment",
                text: "Payment made over the internet."
              }
            }
          },
          certificateDialog: {
            title: "Withholding certificate",
            items: {
              tej: {
                term: "TEJ reference of the withholding certificate",
                text: "Optional: the reference given by the tax administration\u2019s TEJ system."
              },
              document: {
                term: "Withholding certificate (document)",
                text: "Optional: search for the scan stored in the documents. You need at least the reference or the document."
              },
              save: {
                term: "Save the certificate",
                text: "Saves the certificate on the payment. \u201CCancel\u201D closes the window."
              }
            }
          },
          recordDialog: {
            title: "Record a payment on an invoice",
            items: {
              outstanding: {
                term: "Still due before this payment",
                text: "The amount still to pay on the invoice. A sentence below shows what this payment settles and what is still due afterwards."
              },
              receivedOn: {
                term: "Date received",
                text: "Required: the date the payment arrived; it cannot be in the future."
              },
              method: {
                term: "Payment method",
                text: "Bank transfer, Cheque, Bill of exchange, Cash or Online payment."
              },
              amounts: {
                term: "Amount received, Withholding tax, VAT withholding",
                text: "The amounts are proposed from the invoice and you can correct them. The payment cannot exceed what is still due."
              },
              cheque: {
                term: "Cheque number, Bank, Cheque valid until",
                text: "For a cheque only: the number and the bank are required; without a date, the validity of the tax rule set applies (6 months)."
              },
              reference: {
                term: "Payment reference",
                text: "Optional: transfer or deposit number\u2026"
              },
              certificate: {
                term: "TEJ reference of the withholding certificate",
                text: "Optional: you can also attach the certificate document; adding it later remains possible."
              },
              result: {
                term: "Payment recorded",
                text: "After saving: what is still to collect, the state of the invoice (unpaid, partially paid, paid) and any warnings. \u201CClose\u201D finishes."
              }
            }
          },
          aging: {
            title: "Aged receivables",
            items: {
              intro: {
                term: "Position on \u2026",
                text: "What your clients still owe you, sorted by how late they are, in dinars. Only shown with permission to see the finance dashboard."
              },
              client: {
                term: "Client",
                text: "One row per client, then the \u201CTotal\u201D row."
              },
              invoices: {
                term: "Invoices",
                text: "The number of unsettled invoices of the client."
              },
              current: {
                term: "Not yet due",
                text: "The sums whose due date has not arrived yet."
              },
              late: {
                term: "0 to 30 days, 31 to 60 days, 61 to 90 days",
                text: "The overdue sums, sorted by how long they are late."
              },
              over90: {
                term: "Over 90 days",
                text: "The sums overdue for more than 90 days."
              },
              total: {
                term: "Total due",
                text: "The total the client owes you. If there is nothing: \u201CNo outstanding receivables.\u201D"
              }
            }
          },
          reminders: {
            title: "Client reminders",
            items: {
              enabled: {
                term: "Send automatic reminders",
                text: "A switch: a reminder email is sent to the client when a payment is late."
              },
              days: {
                term: "Reminder days after the due date",
                text: "Up to 5 days, from smallest to largest, separated by commas (for example 7, 15, 30)."
              },
              save: {
                term: "Save the reminders",
                text: "Saves these settings. Only for people allowed to change the fiscal profile; for others, a message says only an administrator can change them."
              }
            }
          }
        }
      },
      expenses: {
        title: "Expenses",
        intro: "Your expense reports: you declare an expense with its receipt (photo or PDF), then an approver reviews it before it is reimbursed. Every member can declare their own expenses.",
        sections: {
          header: {
            title: "Header and tabs",
            items: {
              subNav: {
                term: "Finance",
                text: "The menu on the left lists the finance areas your permissions allow; on a small screen it becomes a row of links."
              },
              newExpense: {
                term: "New expense",
                text: "Opens the form to declare an expense. The button disappears while the form is open."
              },
              tabs: {
                term: "My expenses / To approve",
                text: "Two tabs shown only to people who approve or read everyone\u2019s expenses: your own expenses, and the queue of expenses to review."
              }
            }
          },
          list: {
            title: "My expenses",
            items: {
              status: {
                term: "Status",
                text: "Shows only Pending, Approved, Rejected or Reimbursed expenses; \u201CAll statuses\u201D shows everything."
              },
              empty: {
                term: "No expenses yet",
                text: "The empty-list message: take a photo of your receipt, then declare the expense. The \u201CNew expense\u201D button is offered to people who can declare."
              },
              filtered: {
                term: "No expenses with this status",
                text: "Shown when the filter finds nothing; \u201CShow all my expenses\u201D removes it."
              },
              loadMore: {
                term: "Show more expenses",
                text: "Under the list: loads the rest. If there is an error, \u201CTry again\u201D reloads."
              }
            }
          },
          card: {
            title: "One expense",
            items: {
              head: {
                term: "Subject and status",
                text: "The title is what the expense was for, with its status written in words."
              },
              meta: {
                term: "Category, date and project",
                text: "The category, \u201CSpent on \u2026\u201D and the project concerned (or \u201CNo project\u201D)."
              },
              amounts: {
                term: "Total incl. VAT",
                text: "The amount paid, with the excl. VAT and VAT detail below it, and whether the VAT is deductible or not."
              },
              decision: {
                term: "Decision",
                text: "Who approved or rejected the expense and when; for a rejection, the \u201CReason\u201D written by the approver; for a reimbursement, the date."
              },
              receipt: {
                term: "View receipt",
                text: "Opens the receipt in a new tab. While the antivirus check is not finished, \u201CReceipt being checked\u201D is shown instead."
              },
              resubmit: {
                term: "Submit again",
                text: "On a rejected expense: reopens the form with the original information so you can correct it and send it again."
              }
            }
          },
          statuses: {
            title: "Expense statuses",
            items: {
              submitted: {
                term: "Pending",
                text: "The expense was sent to the approvers, who have not decided yet."
              },
              approved: {
                term: "Approved",
                text: "An approver accepted the expense; it still has to be reimbursed."
              },
              rejected: {
                term: "Rejected",
                text: "The expense was refused with a reason; you can correct it and submit it again."
              },
              reimbursed: {
                term: "Reimbursed",
                text: "The reimbursement has been made."
              }
            }
          },
          formReceipt: {
            title: "New expense: receipt",
            items: {
              intro: {
                term: "New expense",
                text: "The form starts with the receipt. For a rejected expense it is called \u201CSubmit the expense again\u201D and keeps the original receipt."
              },
              takePhoto: {
                term: "Take a photo",
                text: "Opens the phone\u2019s camera to photograph the ticket or invoice."
              },
              chooseFile: {
                term: "Choose a file",
                text: "Picks an image or a PDF already saved. Only one receipt per expense."
              },
              upload: {
                term: "Receipt upload",
                text: "A line shows the progress of the upload and then the antivirus check. The receipt is required, and a refused file must be replaced."
              }
            }
          },
          formDetails: {
            title: "New expense: the expense",
            items: {
              category: {
                term: "Category",
                text: "Required: Transport, Fuel, Accommodation, Meals, Supplies, Printing and copying, Software and subscriptions, Telecommunications, Training, Permit fees and charges or Other."
              },
              label: {
                term: "What it was for",
                text: "Required: what you spent on, for example \u201Cmotorway toll, toner purchase\u201D."
              },
              spentOn: {
                term: "Date of the expense",
                text: "Required: it cannot be in the future."
              },
              project: {
                term: "Project",
                text: "Optional: only your projects are offered; \u201CNo project\u201D otherwise."
              }
            }
          },
          formAmounts: {
            title: "New expense: amounts",
            items: {
              ttc: {
                term: "Total incl. VAT",
                text: "Required: the total amount paid, as shown on the receipt."
              },
              vatRate: {
                term: "VAT rate",
                text: "The rate is used to work out the excl. VAT amount and the VAT from the total."
              },
              ht: {
                term: "Amount excl. VAT",
                text: "The amount before taxes, calculated but editable."
              },
              vat: {
                term: "VAT",
                text: "Calculated with the chosen rate: correct it if the receipt says otherwise. Excl. VAT + VAT must always equal the total."
              },
              vatDeductible: {
                term: "The VAT on this receipt is deductible",
                text: "A tick box: says whether the office may deduct the VAT of this expense."
              },
              submit: {
                term: "Send the expense",
                text: "Sends the expense to your approvers. \u201CCancel\u201D closes the form without sending. A summary \u201CExcl. VAT + VAT = total\u201D is shown above."
              }
            }
          }
        }
      },
      expenseApprovals: {
        title: "Expenses to review",
        intro: "The team\u2019s expense queue: you approve or reject pending expenses, then mark as reimbursed those that were paid. It is reserved for people who approve or read everyone\u2019s expenses.",
        sections: {
          header: {
            title: "Header and tabs",
            items: {
              subNav: {
                term: "Finance",
                text: "The menu on the left lists the finance areas your permissions allow; on a small screen it becomes a row of links."
              },
              tabs: {
                term: "My expenses / To approve",
                text: "Two tabs: your own expenses, and this \u201CTo approve\u201D queue."
              },
              hint: {
                term: "Expenses to review",
                text: "The title, and under it a reminder: approve or reject pending expenses, then mark them as reimbursed once the payment is made."
              },
              scope: {
                term: "You see the expenses of your projects.",
                text: "An information message for project managers: they only see the expenses of their projects."
              }
            }
          },
          list: {
            title: "List of expenses",
            items: {
              status: {
                term: "Status",
                text: "The list opens on \u201CPending\u201D expenses; change the status (Approved, Rejected, Reimbursed) or choose \u201CAll statuses\u201D."
              },
              card: {
                term: "One expense",
                text: "Each card shows the subject, status, category, date, project, \u201CDeclared by \u2026\u201D, the total incl. VAT and the receipt (\u201CView receipt\u201D)."
              },
              empty: {
                term: "No expenses to review",
                text: "The empty-list message: expenses declared by your team will appear here. For another status with no result: \u201CShow all statuses\u201D."
              },
              loadMore: {
                term: "Show more expenses",
                text: "Under the list: loads the rest. If there is an error, \u201CTry again\u201D reloads."
              }
            }
          },
          actions: {
            title: "Deciding on an expense",
            items: {
              approve: {
                term: "Approve",
                text: "On a pending expense: accepts it. Only for people allowed to approve."
              },
              reject: {
                term: "Reject",
                text: "On a pending expense: opens the rejection window, where a reason is required."
              },
              reimbursed: {
                term: "Mark as reimbursed",
                text: "On an approved expense: confirms the expense was reimbursed. Only for office-wide approvers (not project managers)."
              },
              own: {
                term: "You cannot decide on your own expense\u2026",
                text: "On your own pending expense no button is offered: another approver must handle it."
              },
              stale: {
                term: "This expense has changed",
                text: "If someone has already handled it, the list is refreshed and this message asks you to check before trying again."
              }
            }
          },
          rejectDialog: {
            title: "Reject the expense",
            items: {
              body: {
                term: "Reject the expense \u201C\u2026\u201D",
                text: "The reason is sent to the person who declared the expense; they can correct it and submit it again."
              },
              reason: {
                term: "Reason for rejecting",
                text: "Required: 500 characters at most."
              },
              confirm: {
                term: "Reject the expense",
                text: "Confirms the rejection and informs the person. \u201CCancel\u201D closes the window."
              }
            }
          },
          reimburseDialog: {
            title: "Mark as reimbursed",
            items: {
              body: {
                term: "Mark \u201C\u2026\u201D as reimbursed",
                text: "Asks whether the amount was really reimbursed to the person: this cannot be undone."
              },
              confirm: {
                term: "Confirm reimbursement",
                text: "Validates the reimbursement. \u201CCancel\u201D closes the window."
              }
            }
          }
        }
      },
      dashboard: {
        title: "Dashboard",
        intro: "The key finance figures of your office: what is invoiced and collected, what clients still owe, the withholdings to recover and the VAT of the month, with a 12-month chart. It is used by people who manage cash flow.",
        sections: {
          header: {
            title: "Page header",
            items: {
              subNav: {
                term: "Finance",
                text: "The menu on the left lists the finance areas your permissions allow; on a small screen it becomes a row of links."
              },
              asOf: {
                term: "As of \u2026",
                text: "The date of the figures. Amounts are in Tunisian dinars (TND); foreign-currency invoices are not counted."
              },
              scope: {
                term: "These figures cover only the invoices of your projects.",
                text: "An information message for project managers: they only see their own projects."
              }
            }
          },
          kpi: {
            title: "Key indicators",
            items: {
              monthInvoiced: {
                term: "Invoiced this month",
                text: "The total invoiced this month, with the excl. VAT amount and the VAT below."
              },
              monthCollected: {
                term: "Collected this month",
                text: "The money received this month, with the withholdings applied by your clients."
              },
              yearInvoiced: {
                term: "Invoiced in (year)",
                text: "The total invoiced since the start of the year, with the excl. VAT amount."
              },
              yearCollected: {
                term: "Collected in (year)",
                text: "The money received since the start of the year, with the withholdings applied."
              },
              outstanding: {
                term: "Still owed by clients",
                text: "What clients still have to pay, with the number of invoices waiting."
              },
              overdue: {
                term: "Of which overdue",
                text: "The part of the amount owed whose due date has passed. The badge \u201CTo chase\u201D (or \u201CUp to date\u201D if nothing is late) says it in words."
              },
              withholdings: {
                term: "Withholdings to recover",
                text: "The amount of withholdings whose withholding certificate is missing, with the number of payments concerned."
              },
              vat: {
                term: "VAT invoiced this month",
                text: "The VAT on the invoices issued during the month."
              }
            }
          },
          chart: {
            title: "Invoiced and collected over 12 months",
            items: {
              bars: {
                term: "Invoiced (incl. VAT) / Collected",
                text: "A bar chart: for each month, one bar for the amount invoiced with all taxes included and one bar for the money collected."
              },
              tooltip: {
                term: "Tooltip",
                text: "Hover over a month to see the exact amounts."
              },
              rtl: {
                term: "Reading direction",
                text: "In Arabic the chart is mirrored: the oldest month is on the right."
              }
            }
          },
          table: {
            title: "Chart data",
            items: {
              toggle: {
                term: "View the data / Hide the data",
                text: "Shows or hides the table with the exact figures of the chart."
              },
              month: {
                term: "Month",
                text: "The month concerned."
              },
              invoiced: {
                term: "Invoiced (incl. VAT)",
                text: "The amount invoiced that month, with all taxes included."
              },
              collected: {
                term: "Collected",
                text: "The money received that month."
              },
              total: {
                term: "Total over 12 months",
                text: "The last row adds up the 12 months."
              }
            }
          },
          errors: {
            title: "Errors and loading",
            items: {
              loadError: {
                term: "The dashboard could not be loaded",
                text: "An error message when the connection fails; \u201CTry again\u201D reloads."
              },
              loading: {
                term: "Loading",
                text: "While the figures are calculated, grey bars replace them."
              }
            }
          }
        }
      },
      einvoicing: {
        title: "Electronic invoice",
        intro: "The electronic-invoice setting of your office: how invoices are sent to TTN (El Fatoora) and the certificates used to sign them. It is reserved for people who manage electronic invoicing.",
        sections: {
          header: {
            title: "Page header",
            items: {
              subNav: {
                term: "Finance",
                text: "The menu on the left lists the finance areas your permissions allow; on a small screen it becomes a row of links."
              },
              add: {
                term: "Add a certificate",
                text: "Opens the window to add a signing certificate."
              }
            }
          },
          mode: {
            title: "Electronic invoicing mode",
            items: {
              mode: {
                term: "Mode",
                text: "Choose whether the invoices issued by your office are sent to TTN: Required, Optional or Disabled. The three choices are described under the list."
              },
              required: {
                term: "Required",
                text: "Every issued invoice is signed, then sent to TTN. Choose this if the law or your clients require it."
              },
              optional: {
                term: "Optional",
                text: "Invoices are sent to TTN when your office has an active signing certificate; without one, they are issued without being sent."
              },
              disabled: {
                term: "Disabled",
                text: "No invoice is sent to TTN; invoices already sent keep their status."
              },
              save: {
                term: "Save the mode",
                text: "Saves the choice; an identity check is asked. The button stays greyed out until you change something."
              }
            }
          },
          credentials: {
            title: "Signing certificates",
            items: {
              card: {
                term: "A certificate",
                text: "One card per certificate: its holder, its state, then Type, Label, Validity (from \u2026 to \u2026), Issuer, SHA-256 fingerprint and \u201CAdded\u201D (by whom and when). The private key is never shown."
              },
              states: {
                term: "Active / Expired / Replaced / Revoked",
                text: "The state of the certificate. Only the active certificate is used to sign; the active one is listed first."
              },
              expiring: {
                term: "Expires soon",
                text: "A warning badge on the active certificate that is about to expire, with a banner \u201CYour active certificate expires soon\u201D: add a new certificate before the date."
              },
              revoke: {
                term: "Revoke",
                text: "On the active certificate: after confirmation (\u201CRevoke the certificate\u201D), invoices are no longer signed with it and it cannot be reactivated. Invoices already accepted do not change."
              },
              empty: {
                term: "No certificate: invoices cannot be signed",
                text: "The empty-list message: add your office\u2019s electronic seal certificate to be able to send your invoices to TTN."
              }
            }
          },
          addDialog: {
            title: "Add a signing certificate",
            items: {
              kind: {
                term: "Certificate type",
                text: "Electronic seal or Test certificate."
              },
              label: {
                term: "Label (optional)",
                text: "A name to recognise it, for example \u201CSeal 2026\u201D."
              },
              certificate: {
                term: "Certificate (.pem, .crt or .cer file)",
                text: "The public certificate, in PEM format, 20 KB at most."
              },
              privateKey: {
                term: "Private key (.pem or .key file)",
                text: "The private key in PEM format (PKCS#8), 20 KB at most. It is encrypted before it is saved and can never be shown or downloaded again."
              },
              save: {
                term: "Add the certificate",
                text: "Adds the certificate, which becomes active. The files are read in your browser, then sent only once; if an identity check is asked, you will have to choose the files again. \u201CCancel\u201D closes the window."
              }
            }
          }
        }
      }
    },
    clients: {
      title: "Clients",
      intro: "The list of your office\u2019s clients (project owners): the people or bodies you carry out projects for. Their tax profile is then used for your quotes and invoices.",
      sections: {
        header: {
          title: "Page header",
          items: {
            newClient: {
              term: "New client",
              text: "Opens the window to create a client. Only shown if you may create clients; greyed out when the office account is read-only."
            },
            title: {
              term: "Clients",
              text: "Here, a client, or project owner, is the person or body you carry out a project for."
            }
          }
        },
        filters: {
          title: "Filter clients",
          items: {
            search: {
              term: "Search for a client",
              text: "Type part of the client\u2019s name: the list narrows after a short moment."
            },
            kind: {
              term: "Filter by type",
              text: "Shows only one type of client (Public body, Private company, Individual, Foreign client); \u201CAll types\u201D shows everything."
            },
            archived: {
              term: "Show archived clients only",
              text: "A switch: moves to archived clients, which do not appear in the normal list."
            },
            clear: {
              term: "Clear the filters",
              text: "Appears in the empty-list messages: resets the search, the type and the switch."
            }
          }
        },
        table: {
          title: "Clients of the office",
          items: {
            name: {
              term: "Name",
              text: "The client\u2019s name. Click it to open the record; the \u201CArchived\u201D badge marks an archived client."
            },
            kind: {
              term: "Type",
              text: "Public body, Private company, Individual or Foreign client."
            },
            taxId: {
              term: "Tax id",
              text: "The client\u2019s tax identifier; \u201C\u2014\u201D if it is not filled in."
            },
            city: {
              term: "City",
              text: "The client\u2019s city, followed by the country code in brackets if it is not in Tunisia."
            },
            contact: {
              term: "Email and phone",
              text: "The client\u2019s email address and phone; \u201C\u2014\u201D if there are none."
            }
          }
        },
        empty: {
          title: "Empty list, error and loading",
          items: {
            none: {
              term: "No clients yet",
              text: "The empty-list message. It offers \u201CNew client\u201D to people who can create one; others are asked to ask an administrator or a project manager to create one."
            },
            noMatch: {
              term: "No client matches",
              text: "Shown when the search or type finds nothing: try another name or another type."
            },
            archived: {
              term: "No archived clients",
              text: "Shown when the archived-clients switch is on and there are none."
            },
            loadMore: {
              term: "Show more clients",
              text: "Under the list: loads the next clients."
            },
            loadError: {
              term: "The clients could not be loaded",
              text: "An error message when the connection fails; \u201CTry again\u201D reloads the list."
            }
          }
        },
        identity: {
          title: "New client: Identity",
          items: {
            kind: {
              term: "Type of client",
              text: "Required, to choose first: the form adapts and pre-sets VAT and withholding. A sentence under the field explains each type."
            },
            name: {
              term: "Name or company name",
              text: "Required: the name of the person or company."
            },
            taxId: {
              term: "Tax id (matricule fiscal)",
              text: "Required for a public body or a private company (format 1234567 A / A / M / 000), optional for an individual. For a foreign client the field becomes \u201CTax identifier\u201D, free text of 50 characters at most."
            },
            paymentTerms: {
              term: "Payment terms (days)",
              text: "The number of days after the invoice date; 30 by default, between 0 and 365."
            }
          }
        },
        tax: {
          title: "New client: VAT and withholding",
          items: {
            vatRegime: {
              term: "VAT regime",
              text: "Required: Subject to VAT, VAT exempt, VAT suspended or Export (outside Tunisia). A sentence under the field explains the choice."
            },
            exemptionRef: {
              term: "Reference",
              text: "Depending on the regime: \u201CExemption certificate reference\u201D or \u201CSuspension attestation reference\u201D (required), or \u201CReference (optional)\u201D for export. Copy it as it appears on the document."
            },
            exemptionExpiresOn: {
              term: "Valid until",
              text: "The date until which the certificate is valid: required for an exemption, optional for a suspension."
            },
            withholding: {
              term: "Withholding tax (RAS)",
              text: "A switch: RAS is a share of your invoice that the client keeps and pays to the tax administration; you receive the rest and a withholding certificate. On by default for public bodies and companies."
            },
            withholdingRate: {
              term: "Specific withholding rate (%)",
              text: "Only active if RAS is on: leave empty to use the legal rate in force, or enter a percentage between 0 and 100."
            },
            vatWithholding: {
              term: "VAT withholding (RAS TVA)",
              text: "A switch: a part of the VAT on your invoice that the client withholds and pays to the Treasury; you only receive the balance. On by default for public bodies; the rate is the one set by law."
            }
          }
        },
        addressContact: {
          title: "New client: Address and Contact details",
          items: {
            line1: {
              term: "Address",
              text: "Required: the street and number."
            },
            line2: {
              term: "Address line 2",
              text: "Optional: building, floor, etc."
            },
            cityPostal: {
              term: "City and Postal code",
              text: "Both required: the city, and the postal code of 3 to 10 characters."
            },
            country: {
              term: "Country (2-letter code)",
              text: "Shown for a foreign client: for example FR for France, IT for Italy."
            },
            email: {
              term: "Email address",
              text: "Optional: used among other things to send quotes."
            },
            phone: {
              term: "Phone",
              text: "Optional, for example +216 71 000 000. The \u201CCreate the client\u201D button saves the record, \u201CCancel\u201D closes the window."
            }
          }
        }
      }
    },
    client: {
      title: "Client record",
      intro: "The record of one client (project owner): their tax profile, their contacts and, later, their projects and invoices. You can edit or archive it depending on your permissions.",
      sections: {
        header: {
          title: "Record header",
          items: {
            breadcrumb: {
              term: "Clients",
              text: "The breadcrumb goes back to the list of clients; the last item is the client\u2019s name."
            },
            archive: {
              term: "Archive",
              text: "Only shown to people allowed to archive and for a client that is not archived: opens a confirmation (\u201CArchive the client \u2026?\u201D). The client\u2019s projects, quotes and invoices are kept."
            },
            archivedChip: {
              term: "Archived",
              text: "A badge at the top of an archived client\u2019s record. A banner adds: \u201CThis client is archived: its record is read-only\u201D."
            },
            tabs: {
              term: "Profile, Contacts, Projects, Invoices",
              text: "The four tabs of the record."
            },
            notFound: {
              term: "Client not found",
              text: "Shown if the client does not exist or you have no access; \u201CBack to clients\u201D returns to the list. If the connection fails: \u201CThis client could not be loaded\u201D."
            }
          }
        },
        profile: {
          title: "Profile tab",
          items: {
            identity: {
              term: "Identity",
              text: "Type of client, name or company name, tax identifier and payment terms (in days)."
            },
            tax: {
              term: "VAT and withholding",
              text: "The VAT regime, its reference and expiry date if any, then \u201CWithholding tax (RAS)\u201D (Yes with the legal rate or a specific rate, or No) and \u201CVAT withholding (RAS TVA)\u201D (Yes or No)."
            },
            address: {
              term: "Address",
              text: "The address, email, phone, and \u201CCreated on\u201D (the date the record was created)."
            },
            edit: {
              term: "Edit",
              text: "Switches the record to edit mode. Only shown if you may edit clients and the client is not archived."
            }
          }
        },
        edit: {
          title: "Edit the client",
          items: {
            fields: {
              term: "The form fields",
              text: "The same fields as for creating a client: identity, VAT and withholding, address and contact details. The type of client changes which fields are shown."
            },
            save: {
              term: "Save",
              text: "Saves the changes; if nothing changed, the form simply closes."
            },
            cancel: {
              term: "Cancel",
              text: "Closes the form without saving anything."
            },
            stale: {
              term: "Changed by someone else",
              text: "If another person changed the record at the same time, a message says so, the record is reloaded and you must apply your changes again."
            }
          }
        },
        contacts: {
          title: "Contacts tab",
          items: {
            intro: {
              term: "Contacts",
              text: "The people to reach at this client. Only one contact is the primary contact."
            },
            add: {
              term: "Add a contact",
              text: "Opens the adding window. Only shown if you may edit the client (and if there is already at least one contact; otherwise the button is in the empty-list message)."
            },
            columns: {
              term: "Name, Role, Email, Phone",
              text: "One row per contact. The \u201CPrimary\u201D badge marks the primary contact; \u201C\u2014\u201D means the information is missing."
            },
            actions: {
              term: "Actions",
              text: "The three-dot button on each row opens a menu: \u201CEdit\u201D, \u201CMake primary\u201D (except for the primary contact) and \u201CDelete\u201D (after confirmation)."
            },
            empty: {
              term: "No contacts",
              text: "The empty-list message: add the person your quotes and invoices are addressed to."
            }
          }
        },
        contactDialog: {
          title: "New contact / Edit the contact",
          items: {
            name: {
              term: "Name",
              text: "Required: the person\u2019s name."
            },
            role: {
              term: "Role",
              text: "Optional, for example technical director or project officer."
            },
            email: {
              term: "Email address",
              text: "Optional: the address used to send a quote to this contact."
            },
            phone: {
              term: "Phone",
              text: "Optional, for example +216 71 000 000."
            },
            primary: {
              term: "Primary contact",
              text: "A tick box: one primary contact per client; ticking it replaces the previous one."
            },
            save: {
              term: "Save",
              text: "Saves the contact. \u201CCancel\u201D closes the window."
            }
          }
        },
        otherTabs: {
          title: "Projects and Invoices tabs",
          items: {
            projects: {
              term: "Projects",
              text: "For now, this tab says that this client\u2019s projects are coming soon."
            },
            invoices: {
              term: "Invoices",
              text: "For now, this tab says that this client\u2019s quotes and invoices are coming soon. Meanwhile, find them in the Finance area."
            }
          }
        }
      }
    }
  }
};

// locales/fr/guide.json
var guide_default3 = {
  drawer: {
    title: "Guide de la page",
    close: "Fermer le guide",
    loading: "Chargement du guide\u2026",
    missing: "Cette page n'a pas encore de guide d\xE9taill\xE9 : voici le guide g\xE9n\xE9ral de BatiFlow.",
    purpose: "\xC0 quoi sert cette page",
    search: "Rechercher dans ce guide",
    stats: "{sections, plural, one {# section} other {# sections}} \xB7 {items, plural, one {# \xE9l\xE9ment} other {# \xE9l\xE9ments}}",
    results: "{count, plural, =0 {Aucun r\xE9sultat} one {# r\xE9sultat} other {# r\xE9sultats}}",
    contents: "Sur cette page",
    count: "{count, plural, one {# \xE9l\xE9ment} other {# \xE9l\xE9ments}}",
    columnTerm: "\xC9l\xE9ment",
    columnText: "Ce qu'il faut savoir",
    noResults: "Aucun \xE9l\xE9ment du guide ne correspond \xE0 votre recherche.",
    clearSearch: "Effacer la recherche",
    escKey: "\xC9chap",
    escHint: "pour fermer le guide"
  },
  pages: {
    projects: {
      title: "Projets",
      intro: "La liste de tous les projets du bureau. Elle sert \xE0 retrouver un projet, \xE0 voir o\xF9 il en est et, pour les personnes autoris\xE9es, \xE0 en cr\xE9er un nouveau.",
      sections: {
        header: {
          title: "Projets",
          items: {
            newProject: {
              term: "Nouveau projet",
              text: "Bouton en haut \xE0 droite, visible seulement pour les personnes autoris\xE9es \xE0 cr\xE9er un projet. Il ouvre la fen\xEAtre de cr\xE9ation. Il est gris\xE9 si le compte du bureau est en lecture seule."
            },
            grid: {
              term: "Grille",
              text: "Affiche les projets sous forme de cartes\xA0: une carte par projet, avec son nom, son statut, son code, son client et l'avancement des phases."
            },
            list: {
              term: "Liste",
              text: "Affiche les projets sous forme de tableau, une ligne par projet. Votre choix est gard\xE9 dans l'adresse de la page."
            },
            loadMore: {
              term: "Afficher plus de projets",
              text: "Appara\xEEt sous la liste quand il reste des projets \xE0 afficher. Le texte devient \xAB\xA0Chargement\u2026\xA0\xBB pendant que la suite arrive."
            }
          }
        },
        filters: {
          title: "Filtrer les projets",
          items: {
            search: {
              term: "Rechercher un projet",
              text: "Tapez une partie du nom ou du code du projet. La liste se met \xE0 jour d\xE8s que vous arr\xEAtez de taper."
            },
            status: {
              term: "Filtrer par statut",
              text: "Ne garde que les projets d'un statut\xA0: Brouillon, En cours, En pause, Cl\xF4tur\xE9 ou Archiv\xE9. Choisissez \xAB\xA0Tous les statuts\xA0\xBB pour tout revoir."
            },
            missionType: {
              term: "Filtrer par type de mission",
              text: "Ne garde que les projets d'un type de mission, par exemple \xAB\xA0Villa individuelle\xA0\xBB. Choisissez \xAB\xA0Tous les types de mission\xA0\xBB pour tout revoir."
            },
            client: {
              term: "Filtrer par client",
              text: "Ne garde que les projets d'un client. La liste propose les clients du bureau\xA0; \xAB\xA0Tous les clients\xA0\xBB retire le filtre."
            },
            mine: {
              term: "Mes projets uniquement",
              text: "Interrupteur qui ne garde que les projets dont vous \xEAtes membre."
            },
            clear: {
              term: "Effacer les filtres",
              text: "Appara\xEEt quand aucun projet ne correspond\xA0: retire d'un coup la recherche et tous les filtres."
            }
          }
        },
        projectsList: {
          title: "Liste des projets",
          items: {
            name: {
              term: "Projet",
              text: "Le nom du projet. Cliquez dessus pour ouvrir le projet (son onglet Publications s'ouvre en premier)."
            },
            code: {
              term: "Code",
              text: "Le code du projet, par exemple 2026-014. Il est toujours lu de gauche \xE0 droite."
            },
            client: {
              term: "Client",
              text: "Le client (ma\xEEtre d'ouvrage\xA0: la personne ou l'organisme pour qui le projet est r\xE9alis\xE9). \xAB\xA0Sans client\xA0\xBB s'il n'est pas encore choisi."
            },
            missionType: {
              term: "Type de mission",
              text: "Le type de mission du projet (b\xE2timent public, villa, expertise\u2026). Dans la grille, il suit le code sur la m\xEAme ligne."
            },
            status: {
              term: "Statut",
              text: "Une pastille de couleur qui dit o\xF9 en est le projet\xA0: Brouillon, En cours, En pause, Cl\xF4tur\xE9 ou Archiv\xE9."
            },
            phase: {
              term: "Phases",
              text: "L'avancement des phases\xA0: \xAB\xA0Phases cl\xF4tur\xE9es\xA0: 2 / 7\xA0\xBB et la phase en cours. La grille ajoute une barre de progression. \xAB\xA0Aucune phase\xA0\xBB s'il n'y en a pas encore, \xAB\xA0Toutes les phases sont cl\xF4tur\xE9es\xA0\xBB quand tout est fini."
            }
          }
        },
        statuses: {
          title: "Statuts d'un projet",
          items: {
            draft: {
              term: "Brouillon",
              text: "Le projet se pr\xE9pare\xA0: il n'a pas encore d\xE9marr\xE9."
            },
            active: {
              term: "En cours",
              text: "Le projet est en cours."
            },
            onHold: {
              term: "En pause",
              text: "Le projet est suspendu temporairement\xA0; il peut reprendre."
            },
            closed: {
              term: "Cl\xF4tur\xE9",
              text: "La mission est termin\xE9e. Le projet peut \xEAtre rouvert si besoin."
            },
            archived: {
              term: "Archiv\xE9",
              text: "Le projet est rang\xE9\xA0: il n'appara\xEEt plus dans les listes, sauf avec le filtre \xAB\xA0Archiv\xE9\xA0\xBB."
            }
          }
        },
        missionTypes: {
          title: "Types de mission",
          items: {
            publicBuilding: {
              term: "B\xE2timent public",
              text: "\xC9cole, mairie, dispensaire ou tout autre b\xE2timent r\xE9alis\xE9 pour une collectivit\xE9."
            },
            collectiveHousing: {
              term: "Logement collectif",
              text: "Immeuble ou r\xE9sidence de plusieurs logements."
            },
            villa: {
              term: "Villa individuelle",
              text: "Maison construite pour une seule famille."
            },
            industrial: {
              term: "B\xE2timent industriel",
              text: "Usine, entrep\xF4t ou atelier."
            },
            facility: {
              term: "\xC9quipement",
              text: "\xC9quipement collectif, par exemple sportif, culturel ou de sant\xE9."
            },
            subdivisionVrd: {
              term: "Lotissement et VRD",
              text: "D\xE9coupage d'un terrain en lots, avec la voirie et les r\xE9seaux divers (VRD\xA0: routes, eau, assainissement, \xE9lectricit\xE9)."
            },
            expertise: {
              term: "Expertise",
              text: "Mission d'avis technique, sans conception d'un nouveau b\xE2timent."
            }
          }
        },
        newDialog: {
          title: "Nouveau projet",
          items: {
            missionType: {
              term: "Type de mission",
              text: "Champ obligatoire. Choisissez-le en premier\xA0: le projet d\xE9marre avec les phases, les dossiers et les t\xE2ches habituels de ce type."
            },
            template: {
              term: "Ce que contient ce mod\xE8le",
              text: "Un aper\xE7u sous le type de mission\xA0: les phases dans l'ordre (avec leur part d'honoraires indicative si vous pouvez la voir), puis le nombre de dossiers cr\xE9\xE9s, de t\xE2ches de d\xE9marrage et de canaux de discussion. Si l'aper\xE7u ne se charge pas, vous pouvez quand m\xEAme cr\xE9er le projet."
            },
            name: {
              term: "Nom du projet",
              text: "Champ obligatoire, 200 caract\xE8res au plus. Exemple\xA0: \xAB\xA0Lyc\xE9e pilote de Kairouan\xA0\xBB."
            },
            code: {
              term: "Code du projet",
              text: "Facultatif, 30 caract\xE8res au plus (lettres, chiffres et . _ / -). Laiss\xE9 vide, un code est g\xE9n\xE9r\xE9, par exemple 2026-014. Un code d\xE9j\xE0 utilis\xE9 par un autre projet est refus\xE9."
            },
            client: {
              term: "Client (ma\xEEtre d'ouvrage)",
              text: "Facultatif\xA0: choisissez un client du bureau, ou \xAB\xA0Aucun client pour l'instant\xA0\xBB. Vous pourrez l'ajouter plus tard."
            },
            governorate: {
              term: "Gouvernorat",
              text: "Facultatif\xA0: le gouvernorat o\xF9 se situe le projet. \xAB\xA0Non pr\xE9cis\xE9\xA0\xBB par d\xE9faut."
            },
            startsOn: {
              term: "Date de d\xE9marrage",
              text: "Facultatif. Avec une date, chaque phase re\xE7oit des dates indicatives, l'une apr\xE8s l'autre."
            },
            submit: {
              term: "Cr\xE9er le projet",
              text: "Cr\xE9e le projet et ouvre directement sa page. \xAB\xA0Annuler\xA0\xBB ferme la fen\xEAtre sans rien cr\xE9er. Les champs obligatoires manquants sont signal\xE9s en rouge."
            }
          }
        },
        leftPane: {
          title: "Mes projets",
          items: {
            myProjects: {
              term: "Mes projets",
              text: "Le volet de gauche liste les projets auxquels vous participez, avec leur code. Cliquez sur un nom pour ouvrir le projet\xA0; le projet ouvert est mis en \xE9vidence. Sans projet, vous lisez \xAB\xA0Vous ne participez \xE0 aucun projet pour le moment.\xA0\xBB"
            },
            seeAll: {
              term: "Tous les projets",
              text: "Lien sous la liste qui ram\xE8ne \xE0 cette page."
            },
            sharedSpaces: {
              term: "Espaces partag\xE9s",
              text: "En dessous, vos espaces partag\xE9s avec d'autres organisations\xA0; un espace d'une autre organisation porte l'\xE9tiquette \xAB\xA0H\xE9berg\xE9 par \u2026\xA0\xBB. Le lien \xAB\xA0Tous les espaces partag\xE9s\xA0\xBB les liste tous."
            }
          }
        },
        empty: {
          title: "Messages d'\xE9tat",
          items: {
            none: {
              term: "Aucun projet pour l'instant",
              text: "Affich\xE9 quand le bureau n'a encore aucun projet. Si vous pouvez cr\xE9er un projet, un bouton \xAB\xA0Nouveau projet\xA0\xBB est propos\xE9\xA0; sinon, demandez \xE0 un responsable de vous ajouter \xE0 un projet."
            },
            noMatch: {
              term: "Aucun projet ne correspond",
              text: "Affich\xE9 quand la recherche ou les filtres ne trouvent rien. Essayez un autre nom ou un autre statut, ou utilisez \xAB\xA0Effacer les filtres\xA0\xBB."
            },
            loadFailed: {
              term: "Impossible de charger les projets",
              text: "Message rouge en cas de probl\xE8me de connexion. V\xE9rifiez votre connexion puis cliquez sur \xAB\xA0R\xE9essayer\xA0\xBB."
            }
          }
        }
      }
    },
    project: {
      posts: {
        title: "Publications",
        intro: "L'onglet des \xE9changes du projet. Pour le moment, il annonce seulement ce qu'il contiendra\xA0: les discussions par discipline.",
        sections: {
          summary: {
            title: "R\xE9sum\xE9 du projet",
            items: {
              breadcrumb: {
                term: "Projets",
                text: "Le fil d'Ariane en haut de la page. Cliquez sur \xAB\xA0Projets\xA0\xBB pour revenir \xE0 la liste\xA0; \xE0 c\xF4t\xE9, vous voyez le nom du projet ouvert."
              },
              meeting: {
                term: "D\xE9marrer une r\xE9union",
                text: "Bouton en haut \xE0 droite, pour les membres du projet qui peuvent contribuer. Il demande le titre de la r\xE9union, puis ouvre la salle de r\xE9union."
              },
              code: {
                term: "Code",
                text: "Le code du projet, utilis\xE9 sur ses documents et ses factures."
              },
              client: {
                term: "Client",
                text: "Le client (ma\xEEtre d'ouvrage) du projet, ou \xAB\xA0Sans client\xA0\xBB s'il n'est pas encore renseign\xE9."
              },
              status: {
                term: "Statut",
                text: "Pastille de l'\xE9tat du projet\xA0: Brouillon, En cours, En pause, Cl\xF4tur\xE9 ou Archiv\xE9. Il se change dans l'onglet Param\xE8tres."
              },
              progress: {
                term: "Phases cl\xF4tur\xE9es\xA0: 2 / 7",
                text: "Une barre de progression et le nombre de phases cl\xF4tur\xE9es, avec la phase en cours. Quand tout est fini, vous lisez \xAB\xA0Toutes les phases sont cl\xF4tur\xE9es\xA0\xBB."
              },
              tabs: {
                term: "Publications, Fichiers, T\xE2ches, Phases, Livrables, Visas, Calendrier, Finance, Param\xE8tres",
                text: "Les onglets du projet. L'onglet ouvert est gard\xE9 dans l'adresse de la page. Finance n'appara\xEEt que pour les personnes qui ont acc\xE8s aux devis, aux factures ou aux contrats."
              },
              notFound: {
                term: "Projet introuvable",
                text: "Affich\xE9 si le projet n'existe pas ou si vous n'en \xEAtes pas membre\xA0; le bouton \xAB\xA0Retour aux projets\xA0\xBB ram\xE8ne \xE0 la liste. En cas de probl\xE8me de connexion, \xAB\xA0Impossible de charger le projet\xA0\xBB propose \xAB\xA0R\xE9essayer\xA0\xBB."
              }
            }
          },
          meeting: {
            title: "D\xE9marrer une r\xE9union",
            items: {
              titleField: {
                term: "Titre de la r\xE9union",
                text: "Champ obligatoire, 200 caract\xE8res au plus. Il est pr\xE9rempli avec \xAB\xA0R\xE9union -\xA0\xBB suivi du nom du projet."
              },
              start: {
                term: "D\xE9marrer",
                text: "Cr\xE9e la r\xE9union et vous emm\xE8ne dans sa salle. Les membres du projet peuvent la rejoindre."
              },
              cancel: {
                term: "Annuler",
                text: "Ferme la fen\xEAtre sans cr\xE9er de r\xE9union."
              }
            }
          },
          placeholder: {
            title: "Les \xE9changes du projet arriveront ici",
            items: {
              message: {
                term: "Les \xE9changes du projet arriveront ici",
                text: "Message affich\xE9 au centre de l'onglet\xA0: les discussions du projet ne sont pas encore disponibles dans cet onglet."
              },
              channels: {
                term: "Canaux de discussion par discipline",
                text: "Ils sont annonc\xE9s par discipline (architecture, structure, VRD\u2026)\xA0: leurs publications appara\xEEtront dans cet onglet."
              }
            }
          }
        }
      },
      files: {
        title: "Fichiers",
        intro: "Tous les documents du projet, rang\xE9s dans des dossiers. On y ajoute des fichiers, on retrouve un document, on suit ses versions et on demande son visa.",
        sections: {
          summary: {
            title: "R\xE9sum\xE9 du projet",
            items: {
              breadcrumb: {
                term: "Projets",
                text: "Le fil d'Ariane en haut de la page. Cliquez sur \xAB\xA0Projets\xA0\xBB pour revenir \xE0 la liste\xA0; \xE0 c\xF4t\xE9, vous voyez le nom du projet ouvert."
              },
              meeting: {
                term: "D\xE9marrer une r\xE9union",
                text: "Bouton en haut \xE0 droite, pour les membres du projet qui peuvent contribuer. Il demande le titre de la r\xE9union, puis ouvre la salle de r\xE9union."
              },
              code: {
                term: "Code",
                text: "Le code du projet, utilis\xE9 sur ses documents et ses factures."
              },
              client: {
                term: "Client",
                text: "Le client (ma\xEEtre d'ouvrage) du projet, ou \xAB\xA0Sans client\xA0\xBB s'il n'est pas encore renseign\xE9."
              },
              status: {
                term: "Statut",
                text: "Pastille de l'\xE9tat du projet\xA0: Brouillon, En cours, En pause, Cl\xF4tur\xE9 ou Archiv\xE9."
              },
              progress: {
                term: "Phases cl\xF4tur\xE9es\xA0: 2 / 7",
                text: "Une barre de progression et le nombre de phases cl\xF4tur\xE9es, avec la phase en cours."
              },
              tabs: {
                term: "Publications, Fichiers, T\xE2ches, Phases, Livrables, Visas, Calendrier, Finance, Param\xE8tres",
                text: "Les onglets du projet. Vous \xEAtes sur \xAB\xA0Fichiers\xA0\xBB."
              },
              noSpace: {
                term: "L'espace de fichiers n'est pas encore pr\xEAt",
                text: "Affich\xE9 si l'espace interne du projet n'est pas encore cr\xE9\xE9. R\xE9essayez dans un instant ou contactez un responsable du projet."
              }
            }
          },
          folders: {
            title: "Dossiers du projet",
            items: {
              tree: {
                term: "Dossiers du projet",
                text: "L'arbre des dossiers, \xE0 gauche. \xAB\xA0Tous les dossiers\xA0\xBB est la racine du projet\xA0; cliquez sur un dossier pour l'ouvrir."
              },
              path: {
                term: "Chemin du dossier",
                text: "Le chemin du dossier ouvert, en haut du contenu. Cliquez sur un niveau pour y remonter. Un dossier auquel vous n'avez pas acc\xE8s appara\xEEt comme \xAB\xA0\u2026\xA0\xBB."
              },
              subfolders: {
                term: "Sous-dossiers",
                text: "La liste des dossiers contenus dans le dossier ouvert. Cliquez sur l'un d'eux pour l'ouvrir."
              },
              newFolder: {
                term: "Nouveau dossier",
                text: "Cr\xE9e un dossier dans le dossier ouvert (ou \xE0 la racine). R\xE9serv\xE9 aux personnes qui peuvent \xE9crire \xE0 cet endroit\xA0; \xE0 la racine, aux responsables du projet."
              },
              customRights: {
                term: "Droits personnalis\xE9s",
                text: "\xC9tiquette avec un cadenas\xA0: ce dossier a sa propre liste de personnes autoris\xE9es, diff\xE9rente de celle du dossier parent ou du projet."
              },
              more: {
                term: "Autres actions",
                text: "Le bouton \xAB\xA0\u2026\xA0\xBB d'un dossier, pour ses responsables. Il propose Renommer\u2026, D\xE9placer\u2026, Autorisations\u2026 et Supprimer."
              },
              trash: {
                term: "Corbeille",
                text: "Bouton sous l'arbre\xA0: affiche les dossiers et documents supprim\xE9s au lieu des fichiers. Cliquez \xE0 nouveau, ou sur \xAB\xA0Retour aux fichiers\xA0\xBB, pour revenir."
              },
              empty: {
                term: "Aucun dossier pour l'instant",
                text: "Affich\xE9 quand le projet n'a pas de dossier. Un responsable peut cr\xE9er le premier\xA0; sinon il peut aussi vous y donner acc\xE8s. Dans un dossier sans sous-dossier, vous lisez \xAB\xA0Ce dossier ne contient pas encore de sous-dossier.\xA0\xBB"
              }
            }
          },
          upload: {
            title: "Ajout de fichiers",
            items: {
              zone: {
                term: "Glissez-d\xE9posez des fichiers ou des dossiers ici",
                text: "Zone qui appara\xEEt dans un dossier o\xF9 vous pouvez \xE9crire. D\xE9posez-y des fichiers\xA0: \xAB\xA0D\xE9posez pour ajouter \xE0 ce dossier\xA0\xBB s'affiche pendant le glisser. Les fichiers d'un dossier d\xE9pos\xE9 sont ajout\xE9s directement dans le dossier ouvert."
              },
              addFiles: {
                term: "Ajouter des fichiers",
                text: "Ouvre le choix de fichiers de votre ordinateur. La taille maximale par fichier est indiqu\xE9e sous la zone."
              },
              addFolder: {
                term: "Ajouter un dossier",
                text: "Ajoute tout le contenu d'un dossier de votre ordinateur."
              },
              progress: {
                term: "Fichiers en cours d'ajout",
                text: "La liste des envois, avec une barre de progression\xA0: Envoi en cours, V\xE9rification antivirus en cours, Ajout\xE9 au dossier, Refus\xE9 ou \xC9chec de l'envoi. Une raison en clair est donn\xE9e quand un fichier est refus\xE9, par exemple un type non accept\xE9 ou un fichier vide."
              },
              controls: {
                term: "Annuler, Retirer, R\xE9essayer",
                text: "\xAB\xA0Annuler\xA0\xBB arr\xEAte un envoi en cours, \xAB\xA0Retirer\xA0\xBB enl\xE8ve une ligne termin\xE9e de la liste, et le bouton de nouvel essai relance un envoi \xE9chou\xE9."
              },
              infoDialog: {
                term: "Informations du document",
                text: "Fen\xEAtre qui s'ouvre apr\xE8s le choix des fichiers\xA0: Discipline, Phase, Type de document, Zone, \xC9chelle et Titre de chaque document. Elles servent \xE0 classer le document et \xE0 composer son code\xA0; vous pourrez les modifier plus tard."
              },
              skip: {
                term: "Ajouter sans informations",
                text: "Ajoute les fichiers sans remplir ces informations. Le code du document sera alors attribu\xE9 plus tard, quand elles seront renseign\xE9es. L'autre bouton se nomme \xAB\xA0Ajouter le document\xA0\xBB ou \xAB\xA0Ajouter 3 documents\xA0\xBB."
              },
              codePreview: {
                term: "Code pr\xE9vu",
                text: "Le code que recevra le document. Les signes ### sont remplac\xE9s par le num\xE9ro d'ordre, attribu\xE9 \xE0 l'ajout du fichier."
              }
            }
          },
          documents: {
            title: "Documents",
            items: {
              search: {
                term: "Rechercher un document",
                text: "Tapez une partie du code ou du titre\xA0; la liste se met \xE0 jour d\xE8s que vous arr\xEAtez de taper."
              },
              filters: {
                term: "Discipline, Phase, Type de document",
                text: "Trois filtres en forme de boutons. Chacun propose \xAB\xA0Tous\xA0\xBB ou une valeur, et affiche votre choix dans le bouton."
              },
              clear: {
                term: "Effacer les filtres",
                text: "Retire la recherche et les filtres. Si rien ne correspond, \xAB\xA0Aucun document ne correspond\xA0\xBB propose le m\xEAme bouton."
              },
              select: {
                term: "S\xE9lectionner",
                text: "Cases \xE0 cocher devant chaque ligne\xA0; celle de l'en-t\xEAte s\xE9lectionne tous les documents affich\xE9s. Une barre d'actions appara\xEEt avec \xAB\xA02 documents s\xE9lectionn\xE9s\xA0\xBB."
              },
              move: {
                term: "D\xE9placer vers\u2026",
                text: "D\xE9place les documents s\xE9lectionn\xE9s dans un autre dossier\xA0: ouvrez le dossier de destination puis \xAB\xA0D\xE9placer ici\xA0\xBB. Les documents ne peuvent pas rester \xE0 la racine du projet."
              },
              delete: {
                term: "Supprimer",
                text: "Place les documents s\xE9lectionn\xE9s dans la corbeille, apr\xE8s confirmation. Ces deux boutons n'apparaissent que si vous avez le droit d'agir sur tous les documents choisis."
              },
              clearSelection: {
                term: "Tout d\xE9s\xE9lectionner",
                text: "Retire la s\xE9lection."
              },
              count: {
                term: "Afficher plus de documents",
                text: "Sous la liste\xA0: \xAB\xA020 documents affich\xE9s\xA0\xBB, et ce bouton quand il y en a d'autres. \xAB\xA0Aucun document pour l'instant\xA0\xBB s'affiche dans un dossier vide."
              }
            }
          },
          columns: {
            title: "Colonnes de la liste des documents",
            items: {
              code: {
                term: "Code",
                text: "Le code du document. Cliquez sur l'en-t\xEAte pour trier. \xAB\xA0Informations manquantes\xA0\xBB signifie que le code n'est pas encore attribu\xE9."
              },
              title: {
                term: "Titre",
                text: "Le titre du document. Cliquez dessus pour ouvrir son panneau de d\xE9tails. L'en-t\xEAte permet de trier."
              },
              index: {
                term: "Indice",
                text: "La lettre de version d'un plan ou d'un document (A, B, C\u2026). Elle change \xE0 chaque nouvelle version."
              },
              disciplinePhase: {
                term: "Discipline et Phase",
                text: "La discipline (Architecture, Structure, VRD, Fluides, \xC9lectricit\xE9, Topographie, G\xE9otechnique, OPC) et la phase du projet auxquelles le document se rattache."
              },
              status: {
                term: "Statut",
                text: "L'\xE9tat du fichier\xA0: Envoi en cours, V\xE9rification antivirus, Disponible ou Refus\xE9."
              },
              approval: {
                term: "Visa",
                text: "Une pastille \xAB\xA0En approbation\xA0\xBB quand un circuit de visa est en cours sur le document."
              },
              modified: {
                term: "Modifi\xE9 le",
                text: "La date de derni\xE8re modification. L'en-t\xEAte permet de trier\xA0; par d\xE9faut, les plus r\xE9cents d'abord."
              },
              author: {
                term: "Organisation auteur",
                text: "L'organisation qui a d\xE9pos\xE9 le document, ou \xAB\xA0Partenaire\xA0\xBB pour une organisation partenaire."
              }
            }
          },
          panel: {
            title: "Document",
            items: {
              open: {
                term: "Ouvrir",
                text: "Ouvre le document dans la visionneuse."
              },
              edit: {
                term: "Modifier",
                text: "Permet de changer le titre, la discipline, la phase, le type, la zone et l'\xE9chelle, pour les personnes qui peuvent modifier le document."
              },
              details: {
                term: "D\xE9tails",
                text: "Le panneau de droite\xA0: code, titre, indice, discipline, phase, type, zone, \xE9chelle, statut, organisation auteur et date de modification."
              },
              locked: {
                term: "Ce document est en cours d'approbation",
                text: "Message d'information\xA0: tant que le circuit de visa n'est pas termin\xE9 ou annul\xE9, le document ne peut pas recevoir de nouvelle version."
              },
              deliverables: {
                term: "Livrables li\xE9s",
                text: "Les livrables du projet auxquels ce document est rattach\xE9, ou \xAB\xA0Aucun livrable li\xE9\xA0\xBB."
              },
              versions: {
                term: "Versions et nouvelle version",
                text: "L'historique, de la plus r\xE9cente \xE0 la plus ancienne\xA0: indice, \xAB\xA0Version actuelle\xA0\xBB, auteur, date, code et empreinte SHA-256 (une signature qui prouve que le fichier n'a pas chang\xE9, copiable d'un clic). Le bouton \xAB\xA0Nouvelle version\xA0\xBB ajoute un fichier comme version suivante, avec l'indice suivant\xA0; l'envoi se suit sous la zone d'ajout de fichiers."
              },
              restore: {
                term: "Restaurer",
                text: "Remet une ancienne version en service en l'ajoutant comme nouvelle version. Une raison de 3 caract\xE8res au moins est obligatoire\xA0; l'historique est conserv\xE9."
              },
              approval: {
                term: "Demander le visa",
                text: "Dans le bloc \xAB\xA0Visa\xA0\xBB. La fen\xEAtre propose d'utiliser un mod\xE8le du bureau ou de composer les \xE9tapes soi-m\xEAme (relecteurs, dans l'ordre ou en parall\xE8le), avec une \xE9ch\xE9ance facultative, puis \xAB\xA0Envoyer la demande\xA0\xBB. Pendant le circuit, le document est verrouill\xE9."
              }
            }
          },
          dialogs: {
            title: "Fen\xEAtres des dossiers et des documents",
            items: {
              newFolder: {
                term: "Nouveau dossier",
                text: "Demande le nom du dossier (200 caract\xE8res au plus, sans barre oblique), puis \xAB\xA0Cr\xE9er\xA0\xBB. La fen\xEAtre pr\xE9cise l'endroit\xA0: \xAB\xA0\xC0 la racine du projet\xA0\xBB ou \xAB\xA0Dans\xA0: \u2026\xA0\xBB."
              },
              rename: {
                term: "Renommer le dossier",
                text: "Demande le nouveau nom, puis \xAB\xA0Renommer\xA0\xBB. Deux dossiers ne peuvent pas porter le m\xEAme nom au m\xEAme endroit."
              },
              move: {
                term: "D\xE9placer ici",
                text: "Pour d\xE9placer un dossier\xA0: ouvrez le dossier de destination, avec \xAB\xA0Remonter d'un niveau\xA0\xBB si besoin, puis cliquez sur ce bouton. Un dossier ne peut pas aller dans l'un de ses propres sous-dossiers."
              },
              permissions: {
                term: "Autorisations",
                text: "Choisissez d'h\xE9riter des droits du dossier parent (ou du projet), ou de lister vous-m\xEAme les personnes autoris\xE9es. Chacune est Lecteur ou \xC9diteur. \xAB\xA0Ajouter tous les membres du bureau\xA0\xBB donne l'acc\xE8s \xE0 tout le monde."
              },
              deleteFolder: {
                term: "Supprimer le dossier",
                text: "Apr\xE8s confirmation, le dossier et ses sous-dossiers vont dans la corbeille. Un dossier qui contient un document \xE0 conserver (obligation l\xE9gale) ne peut pas \xEAtre supprim\xE9."
              },
              deleteDocuments: {
                term: "Supprimer des documents",
                text: "Confirmation avant de placer les documents choisis dans la corbeille\xA0; la fen\xEAtre en liste les noms."
              },
              moveDocuments: {
                term: "D\xE9placer le document",
                text: "M\xEAme principe que pour un dossier\xA0: ouvrez le dossier de destination, puis \xAB\xA0D\xE9placer ici\xA0\xBB."
              },
              newVersionDialog: {
                term: "Fichier",
                text: "Dans la fen\xEAtre \xAB\xA0Nouvelle version\xA0\xBB\xA0: choisissez le fichier, puis \xAB\xA0Ajouter la version\xA0\xBB."
              }
            }
          },
          trash: {
            title: "Corbeille",
            items: {
              intro: {
                term: "Corbeille",
                text: "Les dossiers et documents supprim\xE9s y restent un certain nombre de jours, puis sont effac\xE9s pour de bon. Les responsables voient tout\xA0; les autres voient ce qu'ils ont supprim\xE9."
              },
              back: {
                term: "Retour aux fichiers",
                text: "Ferme la corbeille et rouvre vos dossiers."
              },
              line: {
                term: "\xC9l\xE9ments supprim\xE9s",
                text: "Chaque ligne indique qui l'a supprim\xE9 et quand, le contenu d'un dossier, et la date o\xF9 il sera effac\xE9 pour de bon."
              },
              restore: {
                term: "Restaurer",
                text: "Remet l'\xE9l\xE9ment \xE0 sa place. Si le dossier qui le contenait est aussi dans la corbeille, restaurez d'abord ce dossier."
              },
              purge: {
                term: "Supprimer d\xE9finitivement",
                text: "Efface l'\xE9l\xE9ment avec toutes ses versions et ses fichiers, apr\xE8s confirmation. Cette action ne peut pas \xEAtre annul\xE9e."
              },
              empty: {
                term: "La corbeille est vide",
                text: "Affich\xE9 quand rien n'a \xE9t\xE9 supprim\xE9 r\xE9cemment."
              }
            }
          }
        }
      },
      tasks: {
        title: "T\xE2ches",
        intro: "Le travail \xE0 faire sur le projet\xA0: on cr\xE9e des t\xE2ches, on les confie \xE0 des personnes, on suit leur avancement en liste ou en tableau.",
        sections: {
          summary: {
            title: "R\xE9sum\xE9 du projet",
            items: {
              breadcrumb: {
                term: "Projets",
                text: "Le fil d'Ariane en haut de la page. Cliquez sur \xAB\xA0Projets\xA0\xBB pour revenir \xE0 la liste\xA0; \xE0 c\xF4t\xE9, vous voyez le nom du projet ouvert."
              },
              meeting: {
                term: "D\xE9marrer une r\xE9union",
                text: "Bouton en haut \xE0 droite, pour les membres du projet qui peuvent contribuer. Il demande le titre de la r\xE9union, puis ouvre la salle de r\xE9union."
              },
              code: {
                term: "Code",
                text: "Le code du projet, utilis\xE9 sur ses documents et ses factures."
              },
              client: {
                term: "Client",
                text: "Le client (ma\xEEtre d'ouvrage) du projet, ou \xAB\xA0Sans client\xA0\xBB s'il n'est pas encore renseign\xE9."
              },
              status: {
                term: "Statut",
                text: "Pastille de l'\xE9tat du projet\xA0: Brouillon, En cours, En pause, Cl\xF4tur\xE9 ou Archiv\xE9."
              },
              progress: {
                term: "Phases cl\xF4tur\xE9es\xA0: 2 / 7",
                text: "Une barre de progression et le nombre de phases cl\xF4tur\xE9es, avec la phase en cours."
              },
              tabs: {
                term: "Publications, Fichiers, T\xE2ches, Phases, Livrables, Visas, Calendrier, Finance, Param\xE8tres",
                text: "Les onglets du projet. Vous \xEAtes sur \xAB\xA0T\xE2ches\xA0\xBB."
              }
            }
          },
          toolbar: {
            title: "Affichage des t\xE2ches",
            items: {
              list: {
                term: "Liste",
                text: "Les t\xE2ches en tableau, une ligne par t\xE2che. C'est l'affichage par d\xE9faut."
              },
              board: {
                term: "Tableau",
                text: "Les t\xE2ches en colonnes, une colonne par statut (\xE0 la mani\xE8re d'un tableau Kanban). Glissez une carte d'une colonne \xE0 l'autre pour changer son statut\xA0; si le d\xE9placement \xE9choue, la carte revient \xE0 sa place."
              },
              newTask: {
                term: "Nouvelle t\xE2che",
                text: "Ouvre la fen\xEAtre de cr\xE9ation. R\xE9serv\xE9 aux membres qui peuvent contribuer au projet\xA0; les autres consultent seulement."
              },
              loadMore: {
                term: "Afficher plus de t\xE2ches",
                text: "Appara\xEEt sous la liste quand il reste des t\xE2ches \xE0 afficher."
              }
            }
          },
          filters: {
            title: "Filtres des t\xE2ches",
            items: {
              search: {
                term: "Rechercher une t\xE2che",
                text: "Tapez une partie du titre. La liste se met \xE0 jour d\xE8s que vous arr\xEAtez de taper."
              },
              assignee: {
                term: "Responsable",
                text: "Ne garde que les t\xE2ches confi\xE9es \xE0 une personne. \xAB\xA0Tous les responsables\xA0\xBB retire le filtre."
              },
              status: {
                term: "Statut",
                text: "Ne garde que les t\xE2ches \xC0 faire, En cours, Bloqu\xE9e ou Termin\xE9e."
              },
              discipline: {
                term: "Discipline",
                text: "Ne garde que les t\xE2ches d'une discipline (Architecture, Structure, VRD\u2026)."
              },
              phase: {
                term: "Phase",
                text: "Ne garde que les t\xE2ches li\xE9es \xE0 une phase du projet."
              },
              dueBefore: {
                term: "\xC9ch\xE9ance avant le",
                text: "Choisissez une date pour ne voir que les t\xE2ches \xE0 terminer avant ce jour."
              },
              clear: {
                term: "Effacer les filtres",
                text: "Retire d'un coup tous les filtres."
              }
            }
          },
          list: {
            title: "T\xE2ches du projet",
            items: {
              title: {
                term: "T\xE2che",
                text: "Le titre de la t\xE2che. Cliquez dessus pour ouvrir son panneau de d\xE9tails \xE0 droite."
              },
              status: {
                term: "Statut",
                text: "\xC0 faire, En cours, Bloqu\xE9e ou Termin\xE9e."
              },
              priority: {
                term: "Priorit\xE9",
                text: "Basse, Normale, Haute ou Urgente."
              },
              assignees: {
                term: "Responsables",
                text: "Les personnes charg\xE9es de la t\xE2che, ou \xAB\xA0Personne\xA0\xBB."
              },
              phaseDiscipline: {
                term: "Phase et Discipline",
                text: "La phase du projet et la discipline de la t\xE2che, ou \xAB\xA0Aucune phase\xA0\xBB et \xAB\xA0Aucune discipline\xA0\xBB."
              },
              due: {
                term: "\xC9ch\xE9ance",
                text: "La date limite, ou \xAB\xA0Sans \xE9ch\xE9ance\xA0\xBB. La mention \xAB\xA0en retard\xA0\xBB appara\xEEt quand la date est pass\xE9e."
              },
              checklist: {
                term: "Liste de contr\xF4le",
                text: "L'avancement des petits points \xE0 cocher de la t\xE2che, par exemple \xAB\xA02 sur 5 termin\xE9s\xA0\xBB, ou \xAB\xA0Aucune\xA0\xBB."
              }
            }
          },
          board: {
            title: "Tableau des t\xE2ches",
            items: {
              todo: {
                term: "\xC0 faire",
                text: "Les t\xE2ches pas encore commenc\xE9es."
              },
              inProgress: {
                term: "En cours",
                text: "Les t\xE2ches sur lesquelles quelqu'un travaille."
              },
              blocked: {
                term: "Bloqu\xE9e",
                text: "Les t\xE2ches qui attendent quelque chose pour avancer."
              },
              done: {
                term: "Termin\xE9e",
                text: "Les t\xE2ches finies."
              },
              card: {
                term: "Carte",
                text: "Chaque carte montre le titre, les responsables, l'\xE9ch\xE9ance et la liste de contr\xF4le. Cliquez dessus pour ouvrir la t\xE2che."
              }
            }
          },
          newDialog: {
            title: "Nouvelle t\xE2che",
            items: {
              title: {
                term: "Titre",
                text: "Champ obligatoire, 200 caract\xE8res au plus."
              },
              phase: {
                term: "Phase",
                text: "Facultatif\xA0: rattache la t\xE2che \xE0 une phase du projet (\xAB\xA0Aucune phase\xA0\xBB par d\xE9faut)."
              },
              discipline: {
                term: "Discipline",
                text: "Facultatif (\xAB\xA0Aucune discipline\xA0\xBB par d\xE9faut)."
              },
              priority: {
                term: "Priorit\xE9",
                text: "Basse, Normale, Haute ou Urgente."
              },
              due: {
                term: "\xC9ch\xE9ance",
                text: "Facultatif\xA0: la date limite."
              },
              assignees: {
                term: "Responsables",
                text: "Facultatif\xA0: choisissez une ou plusieurs personnes parmi les membres du projet."
              },
              parent: {
                term: "T\xE2che parente",
                text: "Choisissez une t\xE2che pour cr\xE9er une sous-t\xE2che. Une sous-t\xE2che n'a pas de sous-t\xE2ches. \xAB\xA0Aucune (t\xE2che principale)\xA0\xBB par d\xE9faut."
              },
              submit: {
                term: "Cr\xE9er la t\xE2che",
                text: "Cr\xE9e la t\xE2che. \xAB\xA0Annuler\xA0\xBB ferme la fen\xEAtre."
              }
            }
          },
          panel: {
            title: "T\xE2che",
            items: {
              fields: {
                term: "Titre, Statut, Priorit\xE9, Phase, Discipline, \xC9ch\xE9ance, Responsables",
                text: "Les informations de la t\xE2che, modifiables par les membres qui peuvent contribuer. Les autres lisent seulement\xA0: \xAB\xA0Vous pouvez consulter cette t\xE2che mais pas la modifier\xA0\xBB."
              },
              description: {
                term: "Description",
                text: "Le texte d\xE9taill\xE9 de la t\xE2che. \xAB\xA0Modifier la description\xA0\xBB ouvre un \xE9diteur\xA0; si vous quittez sans enregistrer, une fen\xEAtre vous demande de confirmer."
              },
              checklist: {
                term: "Liste de contr\xF4le",
                text: "De petits points \xE0 cocher\xA0: ajoutez un \xE9l\xE9ment, renommez-le, supprimez-le."
              },
              dependencies: {
                term: "D\xE9pendances",
                text: "Les t\xE2ches \xE0 terminer avant celle-ci. Une d\xE9pendance qui cr\xE9erait une boucle est refus\xE9e."
              },
              subtasks: {
                term: "Sous-t\xE2ches",
                text: "Les t\xE2ches filles de celle-ci\xA0; ajoutez-en avec \xAB\xA0Ajouter une sous-t\xE2che\xA0\xBB."
              },
              comments: {
                term: "Commentaires",
                text: "Les \xE9changes sur la t\xE2che. Tapez @ pour mentionner un membre du projet\xA0; \xAB\xA0Publier le commentaire\xA0\xBB l'envoie. Vous pouvez modifier ou supprimer le v\xF4tre."
              },
              delete: {
                term: "Supprimer la t\xE2che",
                text: "Supprime la t\xE2che avec sa liste de contr\xF4le, ses sous-t\xE2ches et ses commentaires, apr\xE8s confirmation."
              },
              notFound: {
                term: "T\xE2che introuvable",
                text: "Affich\xE9 si la t\xE2che a \xE9t\xE9 supprim\xE9e ou si vous n'y avez plus acc\xE8s."
              }
            }
          },
          empty: {
            title: "Messages d'\xE9tat",
            items: {
              none: {
                term: "Aucune t\xE2che pour le moment",
                text: "Affich\xE9 quand le projet n'a pas de t\xE2che. Les membres qui peuvent contribuer ont un bouton \xAB\xA0Nouvelle t\xE2che\xA0\xBB."
              },
              noMatch: {
                term: "Aucune t\xE2che ne correspond",
                text: "Affich\xE9 quand les filtres ne trouvent rien\xA0: modifiez-les ou effacez-les."
              },
              loadFailed: {
                term: "Impossible de charger les t\xE2ches",
                text: "Message rouge en cas de probl\xE8me de connexion\xA0: v\xE9rifiez-la puis cliquez sur \xAB\xA0R\xE9essayer\xA0\xBB."
              }
            }
          }
        }
      },
      phases: {
        title: "Phases",
        intro: "Le d\xE9roulement de la mission, de l'esquisse \xE0 la r\xE9ception\xA0: dates pr\xE9vues et r\xE9elles, retards et part d'honoraires de chaque phase. Les responsables du projet les modifient\xA0; les autres les consultent.",
        sections: {
          summary: {
            title: "R\xE9sum\xE9 du projet",
            items: {
              breadcrumb: {
                term: "Projets",
                text: "Le fil d'Ariane en haut de la page. Cliquez sur \xAB\xA0Projets\xA0\xBB pour revenir \xE0 la liste\xA0; \xE0 c\xF4t\xE9, vous voyez le nom du projet ouvert."
              },
              meeting: {
                term: "D\xE9marrer une r\xE9union",
                text: "Bouton en haut \xE0 droite, pour les membres du projet qui peuvent contribuer. Il demande le titre de la r\xE9union, puis ouvre la salle de r\xE9union."
              },
              code: {
                term: "Code",
                text: "Le code du projet, utilis\xE9 sur ses documents et ses factures."
              },
              client: {
                term: "Client",
                text: "Le client (ma\xEEtre d'ouvrage) du projet, ou \xAB\xA0Sans client\xA0\xBB s'il n'est pas encore renseign\xE9."
              },
              status: {
                term: "Statut",
                text: "Pastille de l'\xE9tat du projet\xA0: Brouillon, En cours, En pause, Cl\xF4tur\xE9 ou Archiv\xE9."
              },
              progress: {
                term: "Phases cl\xF4tur\xE9es\xA0: 2 / 7",
                text: "Une barre de progression et le nombre de phases cl\xF4tur\xE9es, avec la phase en cours."
              },
              tabs: {
                term: "Publications, Fichiers, T\xE2ches, Phases, Livrables, Visas, Calendrier, Finance, Param\xE8tres",
                text: "Les onglets du projet. Vous \xEAtes sur \xAB\xA0Phases\xA0\xBB."
              }
            }
          },
          overview: {
            title: "Phases",
            items: {
              add: {
                term: "Ajouter une phase",
                text: "Bouton r\xE9serv\xE9 aux responsables du projet. Il ouvre la fen\xEAtre d'ajout."
              },
              readOnly: {
                term: "Seuls les responsables du projet peuvent modifier les phases.",
                text: "Message bleu affich\xE9 aux autres membres, qui peuvent seulement consulter."
              },
              timeline: {
                term: "Frise des phases du projet",
                text: "Un sch\xE9ma des phases avec leurs dates pr\xE9vues et r\xE9elles et un rep\xE8re pour aujourd'hui. Cliquez sur une phase pour ouvrir son panneau."
              },
              total: {
                term: "Total des honoraires par phase",
                text: "Sous le tableau, pour les personnes qui peuvent voir les honoraires\xA0: la somme des parts de chaque phase."
              },
              warning: {
                term: "Parts d'honoraires \xE0 v\xE9rifier",
                text: "Message orange quand le total n'est pas 100 %. Ce n'est pas bloquant\xA0: ajustez-les quand vous le souhaitez."
              },
              empty: {
                term: "Ce projet n'a pas encore de phases",
                text: "Affich\xE9 quand il n'y a aucune phase. Un responsable peut ajouter la premi\xE8re\xA0; les autres attendent qu'elle soit ajout\xE9e."
              },
              loadFailed: {
                term: "Impossible de charger les phases",
                text: "Message rouge en cas de probl\xE8me de connexion\xA0: v\xE9rifiez-la puis \xAB\xA0R\xE9essayer\xA0\xBB."
              }
            }
          },
          table: {
            title: "Phases du projet",
            items: {
              order: {
                term: "N\xB0",
                text: "Le num\xE9ro d'ordre de la phase."
              },
              phase: {
                term: "Phase",
                text: "Le nom de la phase\xA0: ESQ (esquisse), APS (avant-projet sommaire), APD (avant-projet d\xE9taill\xE9), PRO (projet), DCE (dossier de consultation des entreprises), ACT (assistance aux contrats de travaux), DET (direction de l'ex\xE9cution des travaux), AOR (assistance aux op\xE9rations de r\xE9ception), ou une phase personnalis\xE9e."
              },
              dates: {
                term: "Pr\xE9vu et R\xE9el",
                text: "Les dates de d\xE9but et de fin pr\xE9vues, puis celles r\xE9ellement constat\xE9es (un tiret quand elles sont inconnues)."
              },
              status: {
                term: "Statut",
                text: "Non d\xE9marr\xE9e, En cours, En revue ou Cl\xF4tur\xE9e."
              },
              schedule: {
                term: "D\xE9lai",
                text: "Dit si la phase tient ses dates, par exemple \xAB\xA0Dans les d\xE9lais\xA0\xBB ou \xAB\xA0En retard de 5 jours\xA0\xBB."
              },
              share: {
                term: "Honoraires",
                text: "La part des honoraires de la phase, en pourcentage. Cette colonne n'appara\xEEt que pour les personnes qui ont le droit de voir les honoraires."
              },
              actions: {
                term: "Actions",
                text: "Monter ou Descendre une phase pour changer l'ordre, puis Modifier (ou Voir pour une phase cl\xF4tur\xE9e ou si vous n'\xEAtes pas responsable) et Cl\xF4turer la phase. Ces boutons portent le nom de la phase pour les lecteurs d'\xE9cran."
              }
            }
          },
          statuses: {
            title: "Statuts et d\xE9lais",
            items: {
              notStarted: {
                term: "Non d\xE9marr\xE9e",
                text: "La phase n'a pas commenc\xE9."
              },
              inProgress: {
                term: "En cours",
                text: "La phase est en train de se faire."
              },
              inReview: {
                term: "En revue",
                text: "Le travail est fini et se relit avant la cl\xF4ture."
              },
              closed: {
                term: "Cl\xF4tur\xE9e",
                text: "La phase est termin\xE9e et ne se modifie plus."
              },
              onTrack: {
                term: "Dans les d\xE9lais",
                text: "La phase tient ses dates pr\xE9vues. \xAB\xA0Non planifi\xE9e\xA0\xBB veut dire qu'aucune date n'est pr\xE9vue."
              },
              lateStart: {
                term: "D\xE9marrage en retard de 3 jours",
                text: "La date de d\xE9but pr\xE9vue est pass\xE9e alors que la phase n'a pas commenc\xE9\xA0: le nombre de jours de retard est indiqu\xE9."
              },
              overdue: {
                term: "En retard de 3 jours",
                text: "La date de fin pr\xE9vue est pass\xE9e alors que la phase n'est pas termin\xE9e."
              },
              done: {
                term: "Termin\xE9e dans les d\xE9lais",
                text: "La phase s'est termin\xE9e \xE0 temps. \xAB\xA0Termin\xE9e avec 3 jours de retard\xA0\xBB dit le contraire."
              }
            }
          },
          panel: {
            title: "D\xE9tails de la phase",
            items: {
              name: {
                term: "Nom de la phase",
                text: "Seules les phases personnalis\xE9es ont un nom \xE0 saisir (120 caract\xE8res au plus)."
              },
              status: {
                term: "Statut",
                text: "Une phase suit l'ordre\xA0: non d\xE9marr\xE9e, en cours, en revue. Pour la terminer, utilisez \xAB\xA0Cl\xF4turer la phase\u2026\xA0\xBB."
              },
              dates: {
                term: "D\xE9but pr\xE9vu, Fin pr\xE9vue, D\xE9but r\xE9el, Fin r\xE9elle",
                text: "Quatre dates. Une fin ne peut pas pr\xE9c\xE9der le d\xE9but correspondant."
              },
              share: {
                term: "Part des honoraires",
                text: "En pourcentage des honoraires, par exemple 12,5 (entre 0 et 100, deux d\xE9cimales au plus). Visible seulement avec le droit sur les honoraires."
              },
              save: {
                term: "Enregistrer",
                text: "Enregistre les modifications\xA0; gris\xE9 tant que rien n'a chang\xE9. Si quelqu'un d'autre a modifi\xE9 la phase entretemps, elle est recharg\xE9e et vous refaites votre changement."
              },
              readOnly: {
                term: "Cette phase est cl\xF4tur\xE9e",
                text: "Pour une phase cl\xF4tur\xE9e ou pour un simple lecteur, le panneau montre les informations sans les modifier\xA0: statut, dates, honoraires, date de cl\xF4ture et d\xE9rogation de cl\xF4ture."
              }
            }
          },
          addDialog: {
            title: "Ajouter une phase",
            items: {
              type: {
                term: "Type de phase",
                text: "Champ obligatoire. Un projet n'a qu'une phase de chaque type\xA0; choisissez \xAB\xA0Phase personnalis\xE9e\xA0\xBB pour en ajouter une autre."
              },
              name: {
                term: "Nom de la phase",
                text: "Pour une phase personnalis\xE9e\xA0: le nom tel qu'il appara\xEEtra dans le projet."
              },
              planned: {
                term: "D\xE9but pr\xE9vu, Fin pr\xE9vue",
                text: "Facultatif."
              },
              share: {
                term: "Part des honoraires",
                text: "Facultatif, en pourcentage. Visible seulement avec le droit sur les honoraires."
              },
              after: {
                term: "Ins\xE9rer apr\xE8s",
                text: "Choisissez la phase apr\xE8s laquelle placer la nouvelle, ou \xAB\xA0\xC0 la fin du projet\xA0\xBB."
              },
              submit: {
                term: "Ajouter la phase",
                text: "Ajoute la phase. \xAB\xA0Annuler\xA0\xBB ferme la fen\xEAtre."
              }
            }
          },
          closeDialog: {
            title: "Cl\xF4turer la phase",
            items: {
              rule: {
                term: "Cl\xF4turer la phase \u2026\xA0?",
                text: "Une phase se cl\xF4ture quand tous ses livrables sont approuv\xE9s ou transmis. Sinon, vous pouvez la cl\xF4turer avec une d\xE9rogation, motiv\xE9e par \xE9crit."
              },
              unfinished: {
                term: "Livrables en attente",
                text: "Le nombre de livrables de la phase qui ne sont ni approuv\xE9s ni transmis. S'il n'y en a aucun, la cl\xF4ture est directe."
              },
              waiver: {
                term: "Motif de la d\xE9rogation",
                text: "Texte obligatoire, avec un compteur de caract\xE8res (un minimum est demand\xE9). Il est conserv\xE9 dans l'historique du projet."
              },
              confirm: {
                term: "Cl\xF4turer la phase",
                text: "Le bouton devient \xAB\xA0Cl\xF4turer avec d\xE9rogation\xA0\xBB quand une d\xE9rogation est n\xE9cessaire. Si les livrables changent pendant que la fen\xEAtre est ouverte, un message vous pr\xE9vient."
              }
            }
          }
        }
      },
      deliverables: {
        title: "Livrables",
        intro: "Les documents que le bureau doit remettre au client, rang\xE9s par phase, avec leur \xE9tat d'avancement. Les responsables du projet les modifient\xA0; les autres les consultent.",
        sections: {
          summary: {
            title: "R\xE9sum\xE9 du projet",
            items: {
              breadcrumb: {
                term: "Projets",
                text: "Le fil d'Ariane en haut de la page. Cliquez sur \xAB\xA0Projets\xA0\xBB pour revenir \xE0 la liste\xA0; \xE0 c\xF4t\xE9, vous voyez le nom du projet ouvert."
              },
              meeting: {
                term: "D\xE9marrer une r\xE9union",
                text: "Bouton en haut \xE0 droite, pour les membres du projet qui peuvent contribuer. Il demande le titre de la r\xE9union, puis ouvre la salle de r\xE9union."
              },
              code: {
                term: "Code",
                text: "Le code du projet, utilis\xE9 sur ses documents et ses factures."
              },
              client: {
                term: "Client",
                text: "Le client (ma\xEEtre d'ouvrage) du projet, ou \xAB\xA0Sans client\xA0\xBB s'il n'est pas encore renseign\xE9."
              },
              status: {
                term: "Statut",
                text: "Pastille de l'\xE9tat du projet\xA0: Brouillon, En cours, En pause, Cl\xF4tur\xE9 ou Archiv\xE9."
              },
              progress: {
                term: "Phases cl\xF4tur\xE9es\xA0: 2 / 7",
                text: "Une barre de progression et le nombre de phases cl\xF4tur\xE9es, avec la phase en cours."
              },
              tabs: {
                term: "Publications, Fichiers, T\xE2ches, Phases, Livrables, Visas, Calendrier, Finance, Param\xE8tres",
                text: "Les onglets du projet. Vous \xEAtes sur \xAB\xA0Livrables\xA0\xBB."
              }
            }
          },
          overview: {
            title: "Livrables",
            items: {
              add: {
                term: "Ajouter un livrable",
                text: "Bouton r\xE9serv\xE9 aux responsables du projet, propos\xE9 tant qu'une phase est encore ouverte."
              },
              readOnly: {
                term: "Seuls les responsables du projet peuvent modifier les livrables.",
                text: "Message bleu affich\xE9 aux autres membres, qui peuvent seulement consulter."
              },
              phaseBlock: {
                term: "Un bloc par phase",
                text: "Chaque phase a son titre, sa pastille de statut et son tableau. Dessous, \xAB\xA03 sur 5 approuv\xE9s ou transmis\xA0\xBB montre l'avancement."
              },
              closePhase: {
                term: "Cl\xF4turer la phase",
                text: "Bouton des responsables, sur une phase encore ouverte. Il ouvre la fen\xEAtre de cl\xF4ture (voir l'onglet Phases)."
              },
              closed: {
                term: "Phase cl\xF4tur\xE9e le",
                text: "Pour une phase cl\xF4tur\xE9e\xA0: la date, et la d\xE9rogation si elle a \xE9t\xE9 cl\xF4tur\xE9e sans que tout soit approuv\xE9."
              },
              phaseEmpty: {
                term: "Aucun livrable dans cette phase.",
                text: "Affich\xE9 quand une phase n'a pas encore de livrable."
              },
              empty: {
                term: "Ce projet n'a pas encore de phases",
                text: "Les livrables sont rang\xE9s par phase\xA0: ils appara\xEEtront d\xE8s que les phases du projet auront \xE9t\xE9 ajout\xE9es."
              }
            }
          },
          table: {
            title: "Tableau des livrables d'une phase",
            items: {
              title: {
                term: "Livrable",
                text: "Le titre du livrable."
              },
              type: {
                term: "Type",
                text: "La nature du document attendu (plan, note de calcul, rapport\u2026)."
              },
              discipline: {
                term: "Discipline",
                text: "La discipline concern\xE9e (Architecture, Structure, VRD\u2026), ou un tiret."
              },
              status: {
                term: "Statut",
                text: "L'\xE9tat du livrable\xA0: \xC0 produire, En cours, En revue, Approuv\xE9 ou Transmis."
              },
              due: {
                term: "\xC9ch\xE9ance",
                text: "La date de remise pr\xE9vue, ou un tiret."
              },
              actions: {
                term: "Actions",
                text: "Colonne des responsables\xA0: le crayon \xAB\xA0Modifier le livrable\xA0\xBB ouvre la fen\xEAtre de modification. Elle n'est pas propos\xE9e pour les phases cl\xF4tur\xE9es."
              }
            }
          },
          types: {
            title: "Types de livrable",
            items: {
              drawing: {
                term: "Plan",
                text: "Un plan ou un dessin."
              },
              calculationNote: {
                term: "Note de calcul",
                text: "Le document qui justifie les calculs de dimensionnement."
              },
              report: {
                term: "Rapport",
                text: "Un rapport d'\xE9tude ou de visite."
              },
              specification: {
                term: "Cahier des charges",
                text: "Le document qui d\xE9crit ce qui doit \xEAtre r\xE9alis\xE9 et comment."
              },
              billOfQuantities: {
                term: "Bordereau des quantit\xE9s",
                text: "La liste des ouvrages avec leurs quantit\xE9s."
              },
              estimate: {
                term: "Estimation",
                text: "L'estimation du co\xFBt des travaux."
              },
              other: {
                term: "Autre",
                text: "Tout livrable qui ne rentre pas dans les types pr\xE9c\xE9dents."
              }
            }
          },
          statuses: {
            title: "Statuts d'un livrable",
            items: {
              toProduce: {
                term: "\xC0 produire",
                text: "Le livrable n'est pas commenc\xE9."
              },
              inProgress: {
                term: "En cours",
                text: "Le livrable est en cours de production."
              },
              inReview: {
                term: "En revue",
                text: "Le livrable est en train d'\xEAtre relu."
              },
              approved: {
                term: "Approuv\xE9",
                text: "Le livrable est valid\xE9. Il compte pour pouvoir cl\xF4turer la phase."
              },
              transmitted: {
                term: "Transmis",
                text: "Le livrable a \xE9t\xE9 remis au client. Il compte aussi pour cl\xF4turer la phase."
              }
            }
          },
          dialog: {
            title: "Ajouter ou modifier un livrable",
            items: {
              title: {
                term: "Titre du livrable",
                text: "Champ obligatoire, 200 caract\xE8res au plus."
              },
              phase: {
                term: "Phase",
                text: "Champ obligatoire\xA0: choisissez une phase encore ouverte du projet."
              },
              type: {
                term: "Type",
                text: "Plan, Note de calcul, Rapport, Cahier des charges, Bordereau des quantit\xE9s, Estimation ou Autre."
              },
              discipline: {
                term: "Discipline",
                text: "Facultatif\xA0: Architecture, Structure, VRD, Fluides, \xC9lectricit\xE9, Topographie, G\xE9otechnique ou OPC (ordonnancement, pilotage et coordination du chantier). \xAB\xA0Sans discipline\xA0\xBB par d\xE9faut."
              },
              due: {
                term: "\xC9ch\xE9ance",
                text: "Facultatif\xA0: la date de remise."
              },
              status: {
                term: "Statut",
                text: "Propos\xE9 seulement quand vous modifiez un livrable existant."
              },
              save: {
                term: "Enregistrer",
                text: "Enregistre le livrable. Si quelqu'un d'autre l'a modifi\xE9 entretemps, il est recharg\xE9 et vous refaites votre changement. \xAB\xA0Annuler\xA0\xBB ferme la fen\xEAtre."
              }
            }
          }
        }
      },
      approvals: {
        title: "Visas",
        intro: "Le suivi des circuits de visa du projet\xA0: les documents envoy\xE9s \xE0 des relecteurs pour validation, o\xF9 ils en sont, et ceux qui attendent votre avis.",
        sections: {
          summary: {
            title: "R\xE9sum\xE9 du projet",
            items: {
              breadcrumb: {
                term: "Projets",
                text: "Le fil d'Ariane en haut de la page. Cliquez sur \xAB\xA0Projets\xA0\xBB pour revenir \xE0 la liste\xA0; \xE0 c\xF4t\xE9, vous voyez le nom du projet ouvert."
              },
              meeting: {
                term: "D\xE9marrer une r\xE9union",
                text: "Bouton en haut \xE0 droite, pour les membres du projet qui peuvent contribuer. Il demande le titre de la r\xE9union, puis ouvre la salle de r\xE9union."
              },
              code: {
                term: "Code",
                text: "Le code du projet, utilis\xE9 sur ses documents et ses factures."
              },
              client: {
                term: "Client",
                text: "Le client (ma\xEEtre d'ouvrage) du projet, ou \xAB\xA0Sans client\xA0\xBB s'il n'est pas encore renseign\xE9."
              },
              status: {
                term: "Statut",
                text: "Pastille de l'\xE9tat du projet\xA0: Brouillon, En cours, En pause, Cl\xF4tur\xE9 ou Archiv\xE9."
              },
              progress: {
                term: "Phases cl\xF4tur\xE9es\xA0: 2 / 7",
                text: "Une barre de progression et le nombre de phases cl\xF4tur\xE9es, avec la phase en cours."
              },
              tabs: {
                term: "Publications, Fichiers, T\xE2ches, Phases, Livrables, Visas, Calendrier, Finance, Param\xE8tres",
                text: "Les onglets du projet. Vous \xEAtes sur \xAB\xA0Visas\xA0\xBB."
              },
              noSpace: {
                term: "Les circuits de visa ne sont pas encore disponibles",
                text: "Affich\xE9 si l'espace de fichiers du projet n'est pas encore pr\xEAt."
              }
            }
          },
          filters: {
            title: "Filtrer les circuits de visa",
            items: {
              all: {
                term: "Tous",
                text: "Tous les circuits du projet."
              },
              inProgress: {
                term: "En approbation",
                text: "Les circuits encore ouverts, o\xF9 des relecteurs doivent donner leur avis."
              },
              approved: {
                term: "Approuv\xE9s",
                text: "Les circuits termin\xE9s par un avis favorable sans r\xE9serve (VSO)."
              },
              approvedWithComments: {
                term: "Approuv\xE9s avec observations",
                text: "Les circuits termin\xE9s par un avis favorable avec observations (VAO)."
              },
              rejected: {
                term: "Refus\xE9s",
                text: "Les circuits arr\xEAt\xE9s par un refus (REF)\xA0: le document doit \xEAtre corrig\xE9."
              },
              cancelled: {
                term: "Annul\xE9s",
                text: "Les circuits que la personne qui les avait demand\xE9s a arr\xEAt\xE9s."
              },
              toDecide: {
                term: "\xC0 d\xE9cider par moi",
                text: "Bouton qui se combine avec les autres\xA0: ne garde que les circuits qui attendent votre avis maintenant."
              }
            }
          },
          table: {
            title: "Circuits de visa du projet",
            items: {
              document: {
                term: "Document",
                text: "Le code et le titre du document. Cliquez dessus pour l'ouvrir dans la visionneuse."
              },
              index: {
                term: "Indice",
                text: "La lettre de version du document soumis au visa (A, B, C\u2026)."
              },
              status: {
                term: "\xC9tat",
                text: "En approbation, Approuv\xE9 (VSO), Approuv\xE9 avec observations (VAO), Refus\xE9 (REF) ou Annul\xE9."
              },
              step: {
                term: "\xC9tape en cours",
                text: "Par exemple \xAB\xA0\xC9tape 2 sur 3\xA0\xBB, tant que le circuit est ouvert\xA0; un tiret sinon."
              },
              initiator: {
                term: "Demand\xE9 par",
                text: "La personne qui a demand\xE9 le visa."
              },
              dates: {
                term: "Dates",
                text: "La date de la demande, puis la date de fin du circuit ou son \xE9ch\xE9ance."
              },
              actions: {
                term: "Actions",
                text: "\xAB\xA0Voir le circuit\xA0\xBB pour tous. \xAB\xA0Donner mon avis\xA0\xBB appara\xEEt seulement quand c'est votre tour de d\xE9cider."
              }
            }
          },
          details: {
            title: "Circuit de visa d'un document",
            items: {
              header: {
                term: "Demand\xE9 par \u2026 le",
                text: "L'en-t\xEAte de la fen\xEAtre\xA0: l'\xE9tat, l'indice, qui a demand\xE9 le visa et quand, puis la date de fin ou l'\xE9ch\xE9ance."
              },
              step: {
                term: "\xC9tape",
                text: "Chaque \xE9tape indique son mode, Dans l'ordre (chaque relecteur \xE0 son tour) ou En parall\xE8le (tous en m\xEAme temps), et \xAB\xA0\xC9tape en cours\xA0\xBB pour celle qui est ouverte. Les \xE9tapes suivantes sont \xAB\xA0\xC0 venir\xA0\xBB."
              },
              reviewers: {
                term: "Relecteurs",
                text: "Pour chacun\xA0: \xC0 son tour de d\xE9cider, En attente de son avis, Pas encore sollicit\xE9, ou la d\xE9cision d\xE9j\xE0 prise. \xAB\xA0(vous)\xA0\xBB marque votre nom."
              },
              cancel: {
                term: "Annuler le circuit",
                text: "Pour la personne qui a demand\xE9 le visa\xA0: arr\xEAte le circuit, apr\xE8s confirmation. Le document peut de nouveau recevoir une nouvelle version\xA0; les avis d\xE9j\xE0 donn\xE9s restent dans l'historique."
              }
            }
          },
          decision: {
            title: "Votre avis sur un document",
            items: {
              vso: {
                term: "VSO \u2014 Vis\xE9 sans observation",
                text: "Vous approuvez le document tel qu'il est. L'observation est facultative."
              },
              vao: {
                term: "VAO \u2014 Vis\xE9 avec observations",
                text: "Vous approuvez \xE0 condition que vos observations soient prises en compte. Une observation est obligatoire."
              },
              ref: {
                term: "REF \u2014 Refus\xE9",
                text: "Vous refusez cette version\xA0: le circuit s'arr\xEAte et le document doit \xEAtre corrig\xE9. Une observation est obligatoire."
              },
              comment: {
                term: "Observation",
                text: "Votre commentaire. Pour un VAO ou un REF, il est obligatoire, sauf si vous joignez une de vos annotations."
              },
              annotations: {
                term: "Joindre mes annotations",
                text: "Cases \xE0 cocher\xA0: les annotations que vous avez faites sur le document et que vous liez \xE0 votre avis."
              },
              send: {
                term: "Envoyer mon avis",
                text: "Votre avis est d\xE9finitif\xA0: vous ne pourrez plus le modifier une fois envoy\xE9."
              }
            }
          },
          empty: {
            title: "Messages d'\xE9tat",
            items: {
              none: {
                term: "Aucun circuit de visa",
                text: "Ouvrez un document dans l'onglet Fichiers et demandez son visa\xA0: le circuit appara\xEEtra ici."
              },
              noMatch: {
                term: "Aucun circuit ne correspond",
                text: "Choisissez un autre \xE9tat pour voir les autres circuits."
              },
              nothingToDecide: {
                term: "Rien \xE0 d\xE9cider pour le moment",
                text: "Les circuits qui attendent votre avis appara\xEEtront ici."
              },
              loadFailed: {
                term: "Impossible d'afficher les circuits de visa",
                text: "Message rouge\xA0: r\xE9essayez avec \xAB\xA0R\xE9essayer\xA0\xBB\xA0; si le probl\xE8me continue, contactez le support."
              }
            }
          }
        }
      },
      calendar: {
        title: "Calendrier",
        intro: "L'onglet des r\xE9unions, visites de chantier et \xE9ch\xE9ances du projet. Pour le moment, il annonce seulement ce qu'il contiendra.",
        sections: {
          summary: {
            title: "R\xE9sum\xE9 du projet",
            items: {
              breadcrumb: {
                term: "Projets",
                text: "Le fil d'Ariane en haut de la page. Cliquez sur \xAB\xA0Projets\xA0\xBB pour revenir \xE0 la liste\xA0; \xE0 c\xF4t\xE9, vous voyez le nom du projet ouvert."
              },
              meeting: {
                term: "D\xE9marrer une r\xE9union",
                text: "Bouton en haut \xE0 droite, pour les membres du projet qui peuvent contribuer. Il demande le titre de la r\xE9union, puis ouvre la salle de r\xE9union."
              },
              code: {
                term: "Code",
                text: "Le code du projet, utilis\xE9 sur ses documents et ses factures."
              },
              client: {
                term: "Client",
                text: "Le client (ma\xEEtre d'ouvrage) du projet, ou \xAB\xA0Sans client\xA0\xBB s'il n'est pas encore renseign\xE9."
              },
              status: {
                term: "Statut",
                text: "Pastille de l'\xE9tat du projet\xA0: Brouillon, En cours, En pause, Cl\xF4tur\xE9 ou Archiv\xE9."
              },
              progress: {
                term: "Phases cl\xF4tur\xE9es\xA0: 2 / 7",
                text: "Une barre de progression et le nombre de phases cl\xF4tur\xE9es, avec la phase en cours."
              },
              tabs: {
                term: "Publications, Fichiers, T\xE2ches, Phases, Livrables, Visas, Calendrier, Finance, Param\xE8tres",
                text: "Les onglets du projet. Vous \xEAtes sur \xAB\xA0Calendrier\xA0\xBB."
              }
            }
          },
          meeting: {
            title: "D\xE9marrer une r\xE9union",
            items: {
              titleField: {
                term: "Titre de la r\xE9union",
                text: "Champ obligatoire, 200 caract\xE8res au plus. Il est pr\xE9rempli avec \xAB\xA0R\xE9union -\xA0\xBB suivi du nom du projet."
              },
              start: {
                term: "D\xE9marrer",
                text: "Cr\xE9e la r\xE9union et vous emm\xE8ne dans sa salle. Les membres du projet peuvent la rejoindre."
              },
              cancel: {
                term: "Annuler",
                text: "Ferme la fen\xEAtre sans cr\xE9er de r\xE9union."
              }
            }
          },
          placeholder: {
            title: "Le calendrier du projet arrivera ici",
            items: {
              message: {
                term: "Le calendrier du projet arrivera ici",
                text: "Message affich\xE9 au centre de l'onglet\xA0: le calendrier du projet n'est pas encore disponible dans cet onglet."
              },
              content: {
                term: "R\xE9unions, visites de chantier et \xE9ch\xE9ances",
                text: "Ce sont les \xE9l\xE9ments annonc\xE9s\xA0: ils appara\xEEtront dans cet onglet."
              }
            }
          }
        }
      },
      finance: {
        title: "Finance",
        intro: "Le point financier du projet\xA0: son contrat, l'avancement factur\xE9 par phase, et ses devis et factures. L'onglet n'est visible que pour les personnes qui ont acc\xE8s aux devis, aux factures ou aux contrats.",
        sections: {
          summary: {
            title: "R\xE9sum\xE9 du projet",
            items: {
              breadcrumb: {
                term: "Projets",
                text: "Le fil d'Ariane en haut de la page. Cliquez sur \xAB\xA0Projets\xA0\xBB pour revenir \xE0 la liste\xA0; \xE0 c\xF4t\xE9, vous voyez le nom du projet ouvert."
              },
              meeting: {
                term: "D\xE9marrer une r\xE9union",
                text: "Bouton en haut \xE0 droite, pour les membres du projet qui peuvent contribuer. Il demande le titre de la r\xE9union, puis ouvre la salle de r\xE9union."
              },
              code: {
                term: "Code",
                text: "Le code du projet, utilis\xE9 sur ses documents et ses factures."
              },
              client: {
                term: "Client",
                text: "Le client (ma\xEEtre d'ouvrage) du projet, ou \xAB\xA0Sans client\xA0\xBB s'il n'est pas encore renseign\xE9."
              },
              status: {
                term: "Statut",
                text: "Pastille de l'\xE9tat du projet\xA0: Brouillon, En cours, En pause, Cl\xF4tur\xE9 ou Archiv\xE9."
              },
              progress: {
                term: "Phases cl\xF4tur\xE9es\xA0: 2 / 7",
                text: "Une barre de progression et le nombre de phases cl\xF4tur\xE9es, avec la phase en cours."
              },
              tabs: {
                term: "Publications, Fichiers, T\xE2ches, Phases, Livrables, Visas, Calendrier, Finance, Param\xE8tres",
                text: "Les onglets du projet. Vous \xEAtes sur \xAB\xA0Finance\xA0\xBB."
              }
            }
          },
          contract: {
            title: "Contrat",
            items: {
              reference: {
                term: "R\xE9f\xE9rence du contrat",
                text: "La r\xE9f\xE9rence du contrat du projet. Cliquez dessus pour ouvrir le contrat."
              },
              client: {
                term: "Client",
                text: "Le client du contrat."
              },
              kind: {
                term: "Nature",
                text: "Contrat priv\xE9, ou March\xE9 public."
              },
              total: {
                term: "Total HT avec avenants\xA0:",
                text: "Le montant du contrat hors taxes, en tenant compte des avenants (modifications sign\xE9es apr\xE8s coup). Exemple\xA0: 11 544,000 TND."
              },
              open: {
                term: "Ouvrir le contrat",
                text: "Lien vers la page du contrat."
              },
              prepare: {
                term: "Pr\xE9parer une facture de situation",
                text: "Lien pour les personnes qui peuvent cr\xE9er des factures, quand le contrat est en dinars (TND). Une facture de situation facture l'avancement des travaux ou des \xE9tudes \xE0 une date donn\xE9e."
              }
            }
          },
          noContract: {
            title: "Aucun contrat pour ce projet",
            items: {
              message: {
                term: "Aucun contrat pour ce projet",
                text: "Affich\xE9 quand le projet n'a pas encore de contrat. Les personnes qui ne g\xE8rent pas les contrats lisent seulement que le contrat appara\xEEtra ici."
              },
              create: {
                term: "Cr\xE9er le contrat",
                text: "Pour les personnes qui g\xE8rent les contrats\xA0: ouvre le formulaire de nouveau contrat, reli\xE9 \xE0 ce projet. Il permet ensuite de suivre l'avance, la retenue de garantie et la facturation par phase."
              },
              fromQuote: {
                term: "Cr\xE9er le contrat \xE0 partir du devis",
                text: "Propos\xE9 quand un devis du projet a \xE9t\xE9 accept\xE9\xA0: le contrat reprend le client et le montant du devis."
              }
            }
          },
          progress: {
            title: "Avancement factur\xE9",
            items: {
              total: {
                term: "Total du contrat (HT)",
                text: "Le montant du contrat hors taxes."
              },
              advance: {
                term: "Avance",
                text: "L'avance vers\xE9e par le client."
              },
              advanceRecovered: {
                term: "Avance d\xE9j\xE0 r\xE9cup\xE9r\xE9e",
                text: "La part de l'avance d\xE9j\xE0 d\xE9duite des factures."
              },
              retention: {
                term: "Retenue de garantie d\xE9j\xE0 op\xE9r\xE9e",
                text: "Le montant retenu en garantie par le client, avec son taux entre parenth\xE8ses."
              },
              phases: {
                term: "Phase, Statut, Honoraires, Factur\xE9 (cumul), Montant factur\xE9",
                text: "Un tableau par phase\xA0: son statut, ses honoraires, le pourcentage cumul\xE9 d\xE9j\xE0 factur\xE9 et le montant factur\xE9. Cette section n'appara\xEEt que pour les personnes qui voient les factures, et pour un contrat en dinars."
              }
            }
          },
          quotes: {
            title: "Devis et factures",
            items: {
              list: {
                term: "Devis du projet",
                text: "Jusqu'\xE0 cinq devis du projet\xA0: num\xE9ro (un lien), titre, statut (Brouillon, Envoy\xE9, Accept\xE9, Refus\xE9 ou Expir\xE9) et montant hors taxes."
              },
              none: {
                term: "Aucun devis n'est li\xE9 \xE0 ce projet.",
                text: "Affich\xE9 quand le projet n'a pas de devis."
              },
              allQuotes: {
                term: "Tous les devis",
                text: "Lien vers la liste de tous les devis du bureau."
              },
              allInvoices: {
                term: "Toutes les factures",
                text: "Lien vers la liste de toutes les factures du bureau."
              }
            }
          },
          access: {
            title: "Droits d'acc\xE8s",
            items: {
              noAccess: {
                term: "Finance non disponible",
                text: "Affich\xE9 si vous n'avez pas acc\xE8s aux informations financi\xE8res de ce projet."
              },
              visibility: {
                term: "Ce que vous voyez",
                text: "Chaque bloc d\xE9pend de vos droits\xA0: le contrat, l'avancement factur\xE9, puis les devis et les factures n'apparaissent que si vous avez le droit de les lire."
              }
            }
          }
        }
      },
      settings: {
        title: "Param\xE8tres",
        intro: "Les informations g\xE9n\xE9rales du projet et ses membres. Les responsables du projet les modifient\xA0; les autres les consultent.",
        sections: {
          summary: {
            title: "R\xE9sum\xE9 du projet",
            items: {
              breadcrumb: {
                term: "Projets",
                text: "Le fil d'Ariane en haut de la page. Cliquez sur \xAB\xA0Projets\xA0\xBB pour revenir \xE0 la liste\xA0; \xE0 c\xF4t\xE9, vous voyez le nom du projet ouvert."
              },
              meeting: {
                term: "D\xE9marrer une r\xE9union",
                text: "Bouton en haut \xE0 droite, pour les membres du projet qui peuvent contribuer. Il demande le titre de la r\xE9union, puis ouvre la salle de r\xE9union."
              },
              code: {
                term: "Code",
                text: "Le code du projet, utilis\xE9 sur ses documents et ses factures."
              },
              client: {
                term: "Client",
                text: "Le client (ma\xEEtre d'ouvrage) du projet, ou \xAB\xA0Sans client\xA0\xBB s'il n'est pas encore renseign\xE9."
              },
              status: {
                term: "Statut",
                text: "Pastille de l'\xE9tat du projet. Il se change plus bas, dans \xAB\xA0Statut du projet\xA0\xBB."
              },
              progress: {
                term: "Phases cl\xF4tur\xE9es\xA0: 2 / 7",
                text: "Une barre de progression et le nombre de phases cl\xF4tur\xE9es, avec la phase en cours."
              },
              tabs: {
                term: "Publications, Fichiers, T\xE2ches, Phases, Livrables, Visas, Calendrier, Finance, Param\xE8tres",
                text: "Les onglets du projet. Vous \xEAtes sur \xAB\xA0Param\xE8tres\xA0\xBB."
              }
            }
          },
          general: {
            title: "Informations g\xE9n\xE9rales",
            items: {
              readOnly: {
                term: "Seuls les responsables du projet peuvent modifier ces informations.",
                text: "Message bleu affich\xE9 aux autres membres\xA0: ils voient les valeurs sous forme de texte, sans pouvoir les changer."
              },
              missionType: {
                term: "Type de mission",
                text: "Le type de mission choisi \xE0 la cr\xE9ation. Il se lit mais ne se change pas."
              },
              name: {
                term: "Nom du projet",
                text: "Champ obligatoire, 200 caract\xE8res au plus."
              },
              code: {
                term: "Code du projet",
                text: "Champ obligatoire, 30 caract\xE8res au plus (lettres, chiffres et . _ / -). Utilis\xE9 sur les documents et les factures du projet. Un code d\xE9j\xE0 pris par un autre projet est refus\xE9."
              },
              client: {
                term: "Client (ma\xEEtre d'ouvrage)",
                text: "Choisissez un client actif du bureau, ou \xAB\xA0Aucun client\xA0\xBB."
              }
            }
          },
          status: {
            title: "Statut du projet",
            items: {
              status: {
                term: "Statut",
                text: "La liste ne propose que les changements possibles depuis le statut actuel. Le texte sous le champ explique le statut choisi."
              },
              draft: {
                term: "Brouillon",
                text: "Le projet se pr\xE9pare\xA0: il n'a pas encore d\xE9marr\xE9."
              },
              active: {
                term: "En cours",
                text: "Le projet est en cours."
              },
              onHold: {
                term: "En pause",
                text: "Le projet est suspendu temporairement\xA0; il peut reprendre."
              },
              closed: {
                term: "Cl\xF4tur\xE9",
                text: "La mission est termin\xE9e. Le projet peut \xEAtre rouvert si besoin."
              },
              archived: {
                term: "Archiv\xE9",
                text: "Le projet est rang\xE9\xA0: il n'appara\xEEt plus dans les listes, sauf avec le filtre \xAB\xA0Archiv\xE9\xA0\xBB."
              }
            }
          },
          place: {
            title: "Lieu et dates",
            items: {
              governorate: {
                term: "Gouvernorat",
                text: "Le gouvernorat du projet, ou \xAB\xA0Non pr\xE9cis\xE9\xA0\xBB."
              },
              delegation: {
                term: "D\xE9l\xE9gation",
                text: "La d\xE9l\xE9gation (subdivision du gouvernorat), 100 caract\xE8res au plus."
              },
              startsOn: {
                term: "Date de d\xE9marrage",
                text: "La date de d\xE9but du projet."
              },
              endsOn: {
                term: "Date de fin pr\xE9vue",
                text: "Elle ne peut pas pr\xE9c\xE9der la date de d\xE9marrage."
              }
            }
          },
          estimate: {
            title: "Surface, estimation et honoraires",
            items: {
              surface: {
                term: "Surface (m\xB2)",
                text: "Surface totale du projet, en m\xE8tres carr\xE9s\xA0: un nombre entier d'au moins 1."
              },
              worksCost: {
                term: "Estimation du co\xFBt des travaux",
                text: "Le co\xFBt estim\xE9 des travaux, en dinars (TND)."
              },
              feeMode: {
                term: "Mode de calcul des honoraires",
                text: "Forfait, Pourcentage du co\xFBt des travaux ou Au temps pass\xE9. Ce bloc \xAB\xA0Honoraires\xA0\xBB n'appara\xEEt que pour les personnes qui ont le droit de voir les honoraires."
              },
              feeAmount: {
                term: "Montant des honoraires",
                text: "Le montant des honoraires, en dinars (TND)."
              }
            }
          },
          references: {
            title: "R\xE9f\xE9rences",
            items: {
              contractRef: {
                term: "R\xE9f\xE9rence du contrat",
                text: "La r\xE9f\xE9rence du contrat sign\xE9 avec le client, 100 caract\xE8res au plus."
              },
              tunepsRef: {
                term: "R\xE9f\xE9rence TUNEPS",
                text: "R\xE9f\xE9rence de la consultation sur TUNEPS (la plateforme nationale des march\xE9s publics), si le march\xE9 est public."
              },
              save: {
                term: "Enregistrer les modifications",
                text: "Enregistre vos changements. Le bouton est gris\xE9 tant que rien n'a chang\xE9. Si quelqu'un d'autre a modifi\xE9 le projet entretemps, il est recharg\xE9\xA0: v\xE9rifiez les valeurs puis refaites vos changements."
              },
              reset: {
                term: "Annuler les modifications",
                text: "Remet toutes les valeurs comme \xE0 l'ouverture de la page."
              }
            }
          },
          members: {
            title: "Membres du projet",
            items: {
              intro: {
                term: "Membres du projet",
                text: "Les membres voient le projet et y contribuent\xA0; les responsables en g\xE8rent les param\xE8tres. Au moins un responsable est n\xE9cessaire."
              },
              name: {
                term: "Nom",
                text: "Le nom de chaque personne\xA0; \xAB\xA0(vous)\xA0\xBB marque le v\xF4tre."
              },
              role: {
                term: "R\xF4le",
                text: "Responsable ou Membre. Les responsables peuvent changer le r\xF4le dans la liste."
              },
              remove: {
                term: "Retirer",
                text: "Colonne \xAB\xA0Actions\xA0\xBB, pour les responsables\xA0: retire la personne de la liste (le changement n'est appliqu\xE9 qu'\xE0 l'enregistrement)."
              },
              add: {
                term: "Ajouter une personne du bureau",
                text: "Choisissez une personne dans la liste \xAB\xA0Choisir une personne\xA0\xBB, puis \xAB\xA0Ajouter\xA0\xBB. Si tout le monde est d\xE9j\xE0 dans le projet, un message le dit."
              },
              save: {
                term: "Enregistrer les membres",
                text: "Applique les changements de la liste. \xAB\xA0Annuler les modifications\xA0\xBB les abandonne."
              },
              lastManager: {
                term: "Le projet doit garder au moins un responsable",
                text: "Avertissement orange quand plus aucun responsable ne reste\xA0: d\xE9signez-en un autre avant d'enregistrer."
              }
            }
          }
        }
      },
      overview: {
        title: "Vue d'ensemble du projet",
        intro: "L'espace projet ouvre un projet en plein \xE9cran, dans son propre onglet du navigateur. La vue d'ensemble r\xE9sume l'\xE9tat du projet : avancement, t\xE2ches, \xE9ch\xE9ances, phases, fiche et \xE9quipe.",
        sections: {
          navigation: {
            title: "Navigation de l'espace projet",
            items: {
              open: {
                term: "Espace projet",
                text: "Bouton en haut de la page d'un projet. Il ouvre le m\xEAme projet en plein \xE9cran dans un nouvel onglet, sur la section affich\xE9e."
              },
              sections: {
                term: "Sections",
                text: "La colonne de gauche liste les sections du projet par groupe : Pilotage, Documents, Collaboration et Gestion. Sur un petit \xE9cran, elle s'ouvre avec le bouton de menu \xE0 c\xF4t\xE9 du titre."
              },
              back: {
                term: "Revenir \xE0 la vue standard",
                text: "Lien en bas de la colonne : il rouvre le projet avec ses onglets, dans l'application habituelle."
              }
            }
          },
          kpis: {
            title: "Chiffres cl\xE9s",
            items: {
              phases: {
                term: "Phases cl\xF4tur\xE9es",
                text: "Le nombre de phases cl\xF4tur\xE9es sur le total, avec une barre de progression et la phase en cours."
              },
              open: {
                term: "T\xE2ches ouvertes",
                text: "Les t\xE2ches qui ne sont pas termin\xE9es, avec le nombre de t\xE2ches \xAB En cours \xBB et \xAB Bloqu\xE9e \xBB."
              },
              late: {
                term: "T\xE2ches en retard",
                text: "Les t\xE2ches non termin\xE9es dont l'\xE9ch\xE9ance est pass\xE9e. La carte passe au rouge d\xE8s qu'il y en a une."
              },
              team: {
                term: "Membres de l'\xE9quipe",
                text: "Le nombre de membres du projet et de responsables. Chaque carte ouvre la section correspondante."
              }
            }
          },
          lists: {
            title: "\xC9ch\xE9ances, statuts et phases",
            items: {
              deadlines: {
                term: "Prochaines \xE9ch\xE9ances",
                text: "Les six prochaines t\xE2ches ouvertes par date d'\xE9ch\xE9ance, avec leur statut et leur priorit\xE9. Cliquez sur une t\xE2che pour l'ouvrir dans la section T\xE2ches."
              },
              status: {
                term: "T\xE2ches par statut",
                text: "Une barre de r\xE9partition et un tableau : nombre et part des t\xE2ches \xC0 faire, En cours, Bloqu\xE9e et Termin\xE9e."
              },
              phases: {
                term: "Phases du projet",
                text: "Les phases sur une frise chronologique, avec les dates pr\xE9vues et r\xE9elles et leur retard \xE9ventuel."
              }
            }
          },
          sheet: {
            title: "Fiche et \xE9quipe",
            items: {
              facts: {
                term: "Fiche du projet",
                text: "Client, type de mission, lieu, surface, estimation du co\xFBt des travaux, dates et r\xE9f\xE9rences. \xAB Modifier \xBB ouvre les Param\xE8tres."
              },
              members: {
                term: "\xC9quipe du projet",
                text: "Les membres et leur r\xF4le (Responsable ou Membre). \xAB G\xE9rer les membres \xBB ouvre les Param\xE8tres."
              }
            }
          }
        }
      }
    },
    spaceApprovals: {
      title: "Approbations d'acc\xE8s externe",
      intro: "Les demandes \xE0 valider quand un membre de votre organisation est invit\xE9 dans l'espace d'une autre organisation. Votre politique demande l'accord d'un administrateur avant qu'il puisse le rejoindre.",
      sections: {
        purpose: {
          title: "Approbations d'acc\xE8s externe",
          items: {
            intro: {
              term: "Pourquoi cette page",
              text: "Un membre de votre organisation est invit\xE9 dans l'espace d'une autre organisation (l'h\xF4te). Tant qu'un administrateur n'a pas approuv\xE9, il ne peut pas y entrer."
            },
            denied: {
              term: "Vous ne pouvez pas d\xE9cider ici",
              text: "Message affich\xE9 aux personnes qui n'ont pas le droit d'approuver les acc\xE8s externes\xA0: seuls les administrateurs autoris\xE9s voient ces demandes."
            }
          }
        },
        requests: {
          title: "Demandes \xE0 approuver",
          items: {
            person: {
              term: "Nom de la personne",
              text: "La personne invit\xE9e, ou son adresse e-mail si son nom n'est pas connu."
            },
            kind: {
              term: "Invitation nominative, Invit\xE9, Organisation",
              text: "La pastille orange donne le type de demande\xA0: une invitation \xE0 une personne pr\xE9cise, un invit\xE9 ext\xE9rieur, ou une organisation."
            },
            email: {
              term: "Adresse e-mail",
              text: "L'adresse de la personne invit\xE9e."
            },
            space: {
              term: "Espace \u2026 h\xE9berg\xE9 par \u2026",
              text: "Le nom de l'espace partag\xE9 et l'organisation qui l'h\xE9berge."
            },
            rights: {
              term: "Droits",
              text: "Ce que la personne pourra faire\xA0: Lecture seule, Lecture et \xE9criture, ou Lecture, \xE9criture et visa."
            },
            invitedBy: {
              term: "Invit\xE9 par",
              text: "La personne qui a envoy\xE9 l'invitation, quand elle est connue."
            },
            requestedOn: {
              term: "Demand\xE9 le",
              text: "La date de la demande."
            },
            answerBefore: {
              term: "\xC0 traiter avant le",
              text: "La date limite pour r\xE9pondre."
            }
          }
        },
        answers: {
          title: "R\xE9pondre \xE0 une demande",
          items: {
            approve: {
              term: "Approuver",
              text: "Autorise la personne \xE0 rejoindre l'espace. L'h\xF4te en est inform\xE9."
            },
            refuse: {
              term: "Refuser",
              text: "Ouvre une fen\xEAtre de confirmation\xA0: \xAB\xA0Refuser l'acc\xE8s de \u2026\xA0?\xA0\xBB. La personne ne rejoindra pas l'espace, mais l'h\xF4te pourra l'inviter de nouveau."
            }
          }
        },
        states: {
          title: "Messages d'\xE9tat",
          items: {
            empty: {
              term: "Aucune demande \xE0 approuver",
              text: "Affich\xE9 quand aucune demande n'attend. Une nouvelle demande appara\xEEt ici d\xE8s qu'un membre est invit\xE9 dans l'espace d'une autre organisation."
            },
            loadFailed: {
              term: "Impossible de charger les demandes",
              text: "Message rouge en cas de probl\xE8me de connexion\xA0: v\xE9rifiez-la puis cliquez sur \xAB\xA0R\xE9essayer\xA0\xBB."
            }
          }
        }
      }
    },
    partnerships: {
      title: "Partenariats",
      intro: "Les espaces d'autres organisations auxquels votre organisation est invit\xE9e ou participe. Cette page est destin\xE9e aux propri\xE9taires et aux administrateurs.",
      sections: {
        requests: {
          title: "Demandes de partenariat",
          items: {
            description: {
              term: "Acceptez pour que votre organisation rejoigne l'espace",
              text: "Une fois la demande accept\xE9e, vous choisissez ensuite qui, dans votre organisation, acc\xE8de \xE0 l'espace."
            },
            host: {
              term: "Organisation h\xF4te",
              text: "Chaque ligne montre le logo et le nom de l'organisation qui h\xE9berge l'espace, avec la pastille \xAB\xA0En attente de r\xE9ponse\xA0\xBB."
            },
            accept: {
              term: "Accepter",
              text: "Votre organisation devient partenaire de l'espace."
            },
            decline: {
              term: "Refuser",
              text: "Ouvre une confirmation \xAB\xA0Refuser l'invitation \xE0 l'espace \u2026\xA0?\xA0\xBB. Votre organisation ne rejoint pas l'espace\xA0; l'h\xF4te pourra l'inviter de nouveau."
            },
            none: {
              term: "Aucune demande en attente.",
              text: "Affich\xE9 quand il n'y a rien \xE0 r\xE9pondre."
            }
          }
        },
        active: {
          title: "Partenariats actifs",
          items: {
            description: {
              term: "Partenariats actifs",
              text: "Les espaces auxquels votre organisation participe. Ouvrez-en un pour g\xE9rer vos d\xE9l\xE9gu\xE9s."
            },
            status: {
              term: "Actif",
              text: "Pastille verte\xA0: le partenariat est en place."
            },
            manage: {
              term: "G\xE9rer mes d\xE9l\xE9gu\xE9s",
              text: "Ouvre l'espace sur l'onglet des d\xE9l\xE9gu\xE9s\xA0: les personnes de votre organisation qui y ont acc\xE8s."
            },
            none: {
              term: "Aucun partenariat actif.",
              text: "Affich\xE9 quand aucun espace n'est actif."
            }
          }
        },
        ended: {
          title: "Partenariats termin\xE9s",
          items: {
            declined: {
              term: "Refus\xE9",
              text: "Vous avez refus\xE9 l'invitation."
            },
            expired: {
              term: "Expir\xE9",
              text: "Le partenariat est arriv\xE9 \xE0 sa date de fin."
            },
            revoked: {
              term: "Retir\xE9",
              text: "L'h\xF4te a retir\xE9 votre organisation de l'espace."
            },
            visibility: {
              term: "Partenariats termin\xE9s",
              text: "Ce bloc n'appara\xEEt que s'il y a au moins un partenariat termin\xE9\xA0; il est en lecture seule."
            }
          }
        },
        details: {
          title: "D\xE9tails d'une ligne",
          items: {
            space: {
              term: "Espace",
              text: "Le nom de l'espace partag\xE9."
            },
            scope: {
              term: "Tout l'espace",
              text: "Ce que le partenariat couvre\xA0: \xAB\xA0Tout l'espace\xA0\xBB ou \xAB\xA0Dossiers\xA0: 2 \xB7 Canaux\xA0: 1\xA0\xBB quand seuls certains dossiers et canaux sont ouverts."
            },
            rights: {
              term: "Droits",
              text: "Lecture seule, Lecture et \xE9criture, ou Lecture, \xE9criture et visa."
            },
            people: {
              term: "Personnes",
              text: "Le nombre de personnes de votre organisation qui ont acc\xE8s, sur le maximum autoris\xE9, par exemple \xAB\xA03/10\xA0\xBB."
            },
            until: {
              term: "Jusqu'au",
              text: "La date de fin du partenariat, ou \xAB\xA0Sans date de fin\xA0\xBB."
            }
          }
        },
        states: {
          title: "Messages d'\xE9tat",
          items: {
            empty: {
              term: "Aucun partenariat",
              text: "Affich\xE9 quand aucune organisation ne vous a encore invit\xE9. La demande appara\xEEt ici d\xE8s qu'une autre organisation vous invite \xE0 partager un espace."
            },
            loadFailed: {
              term: "Impossible de charger les partenariats",
              text: "Message rouge en cas de probl\xE8me de connexion\xA0: v\xE9rifiez-la puis cliquez sur \xAB\xA0R\xE9essayer\xA0\xBB."
            }
          }
        }
      }
    },
    home: {
      title: "Navigation de BatiFlow",
      intro: "Cette aide explique le cadre de BatiFlow qui entoure toutes les pages\xA0: la barre d'applications, l'en-t\xEAte, les notifications, le menu du compte, la liste de gauche, le panneau de droite et les raccourcis clavier.",
      sections: {
        appBar: {
          title: "Applications",
          items: {
            activity: {
              term: "Activit\xE9",
              text: "Vos notifications\xA0: mentions, t\xE2ches qu'on vous assigne, demandes de visa. Raccourci\xA0: Alt+1."
            },
            chat: {
              term: "Conversation",
              text: "Les discussions avec vos coll\xE8gues et les canaux de vos projets. Raccourci\xA0: Alt+2."
            },
            projects: {
              term: "Projets",
              text: "La liste de vos projets et leur suivi. Raccourci\xA0: Alt+3."
            },
            calendar: {
              term: "Calendrier",
              text: "Vos r\xE9unions, visites de chantier et \xE9ch\xE9ances. Raccourci\xA0: Alt+4."
            },
            files: {
              term: "Fichiers",
              text: "La section des fichiers de l'organisation. Raccourci\xA0: Alt+5."
            },
            finance: {
              term: "Finances",
              text: "Les devis, les factures et le suivi financier. Raccourci\xA0: Alt+6."
            },
            more: {
              term: "Plus",
              text: "Les clients, les partenariats et l'administration de votre bureau. Raccourci\xA0: Alt+7."
            },
            phone: {
              term: "Sur t\xE9l\xE9phone et petit \xE9cran",
              text: "Sur t\xE9l\xE9phone, la barre passe en bas de l'\xE9cran et ne garde que Activit\xE9, Conversation, Projets, Calendrier et Plus. Sur tablette, seules les ic\xF4nes s'affichent. Un trait de couleur marque l'application ouverte, et un compteur signale les nouveaut\xE9s."
            }
          }
        },
        header: {
          title: "En-t\xEAte",
          items: {
            logo: {
              term: "Logo BatiFlow",
              text: "Le nom du produit, en haut \xE0 gauche de l'\xE9cran, y compris en arabe."
            },
            search: {
              term: "Rechercher des projets, fichiers, messages\u2026",
              text: "Ouvre la recherche rapide dans toute l'organisation. Vous pouvez aussi appuyer sur Ctrl+K ou sur la touche /. Sur t\xE9l\xE9phone, c'est une simple loupe (Ouvrir la recherche)."
            },
            orgSwitcher: {
              term: "Changer d'organisation",
              text: "Affiche le nom de l'organisation active. Si vous appartenez \xE0 plusieurs bureaux, choisissez-en un dans la liste\xA0: vous arrivez sur son Activit\xE9."
            },
            externalSpaces: {
              term: "Espaces externes",
              text: "Dans le m\xEAme menu\xA0: les espaces que d'autres organisations partagent avec vous. Le nombre entre parenth\xE8ses indique combien vous en avez."
            },
            notifications: {
              term: "Notifications",
              text: "La cloche. Un compteur indique le nombre de notifications non lues (99+ au-del\xE0). Cliquez dessus pour ouvrir les derni\xE8res notifications."
            },
            account: {
              term: "Menu du compte",
              text: "Votre photo ou vos initiales, avec un point de couleur qui indique votre statut. Il ouvre le menu d\xE9crit plus bas."
            }
          }
        },
        bell: {
          title: "Notifications (la cloche)",
          items: {
            count: {
              term: "Derni\xE8res notifications",
              text: "Chaque ligne a une ic\xF4ne selon le type, une phrase, la date relative et sa provenance (organisation, code et nom du projet). Un clic ouvre l'\xE9l\xE9ment concern\xE9 et marque la notification comme lue."
            },
            unread: {
              term: "Non lu",
              text: "Une notification non lue est \xE9crite en gras, avec un petit point devant."
            },
            markRead: {
              term: "Marquer comme lu",
              text: "La coche \xE0 droite d'une notification non lue la marque comme lue sans l'ouvrir."
            },
            decide: {
              term: "D\xE9cider",
              text: "Appara\xEEt sur une demande de visa de votre organisation active. Ouvre la fen\xEAtre pour rendre votre d\xE9cision tout de suite."
            },
            markAllRead: {
              term: "Tout marquer comme lu",
              text: "Marque toutes les notifications comme lues d'un seul clic."
            },
            viewAll: {
              term: "Voir toute l'activit\xE9",
              text: "Ouvre la page Activit\xE9 avec l'historique complet et les filtres."
            },
            empty: {
              term: "Vous \xEAtes \xE0 jour",
              text: "Message affich\xE9 quand il n'y a aucune notification. Vos mentions, affectations et rappels appara\xEEtront ici."
            },
            loadFailed: {
              term: "Impossible de charger les notifications",
              text: "V\xE9rifiez votre connexion, puis utilisez \xAB\xA0R\xE9essayer\xA0\xBB."
            }
          }
        },
        account: {
          title: "Menu du compte",
          items: {
            status: {
              term: "Statut",
              text: "Choisissez Disponible, Occup\xE9, Sur le chantier ou Absent\xA0: vos coll\xE8gues le voient \xE0 c\xF4t\xE9 de votre nom. \xAB\xA0En r\xE9union\xA0\xBB s'affiche tout seul pendant un appel, et \xAB\xA0Hors ligne\xA0\xBB quand vous n'\xEAtes pas connect\xE9. Le statut ne peut se changer que si la connexion en direct est active."
            },
            profile: {
              term: "Mon profil",
              text: "Ouvre votre profil personnel."
            },
            security: {
              term: "S\xE9curit\xE9 du compte",
              text: "Ouvre la page de s\xE9curit\xE9 de votre compte."
            },
            language: {
              term: "Langue",
              text: "Choisissez Fran\xE7ais, \u0627\u0644\u0639\u0631\u0628\u064A\u0629 ou English. Toute l'application change aussit\xF4t, et l'arabe s'\xE9crit de droite \xE0 gauche."
            },
            theme: {
              term: "Th\xE8me",
              text: "Comme le syst\xE8me, Clair, Sombre ou Contraste \xE9lev\xE9 (pour mieux voir les contours et les couleurs)."
            },
            signOut: {
              term: "Se d\xE9connecter",
              text: "Ferme votre session."
            },
            signOutFailed: {
              term: "D\xE9connexion incompl\xE8te",
              text: "Si la d\xE9connexion \xE9choue, cette fen\xEAtre vous demande de fermer votre navigateur pour terminer la session en toute s\xE9curit\xE9. Le bouton \xAB\xA0Fermer\xA0\xBB la ferme."
            }
          }
        },
        panes: {
          title: "Liste de gauche, panneau de droite et bandeaux",
          items: {
            list: {
              term: "Liste",
              text: "Certaines applications (Projets, Conversation, Calendrier) ont une liste \xE0 gauche. Le bouton \xAB\xA0Masquer la liste\xA0\xBB la replie et \xAB\xA0Afficher la liste\xA0\xBB la rouvre (Alt+L). Sur \xE9cran moyen ou petit, elle s'ouvre par-dessus la page avec \xAB\xA0Ouvrir la liste\xA0\xBB."
            },
            resize: {
              term: "Redimensionner la liste",
              text: "Tirez le bord de la liste avec la souris, ou placez-vous dessus et utilisez les fl\xE8ches gauche et droite du clavier."
            },
            rightPanel: {
              term: "Fermer le panneau",
              text: "Le panneau de droite affiche un d\xE9tail (fil de discussion, messages \xE9pingl\xE9s\u2026). Le bouton de fermeture ou la touche \xC9chap le ferme."
            },
            subscriptionBanner: {
              term: "Bandeau d'abonnement",
              text: "Au-dessus de la page, un bandeau appara\xEEt seulement quand l'abonnement demande votre attention (essai bient\xF4t termin\xE9, facture impay\xE9e, lecture seule\u2026). Un bouton comme \xAB\xA0Voir l'abonnement\xA0\xBB ou \xAB\xA0Payer la facture\xA0\xBB m\xE8ne \xE0 l'action \xE0 faire."
            },
            skipLink: {
              term: "Aller au contenu principal",
              text: "Lien cach\xE9 qui appara\xEEt quand on appuie sur Tab en arrivant sur la page. Il permet au clavier de sauter directement au contenu."
            }
          }
        },
        shortcuts: {
          title: "Raccourcis clavier",
          items: {
            search: {
              term: "Rechercher",
              text: "Ctrl+K, ou la touche /, ouvre la recherche rapide."
            },
            apps: {
              term: "Aller \xE0 une application",
              text: "Alt+1 \xE0 Alt+7 ouvrent dans l'ordre\xA0: Activit\xE9, Conversation, Projets, Calendrier, Fichiers, Finances, Plus."
            },
            list: {
              term: "Afficher ou masquer la liste",
              text: "Alt+L replie ou rouvre la liste de gauche."
            },
            close: {
              term: "Fermer le panneau ou la bo\xEEte de dialogue",
              text: "La touche \xC9chap ferme le panneau de droite ou la fen\xEAtre ouverte."
            },
            typing: {
              term: "Pendant la saisie",
              text: "Les raccourcis ne s'activent pas pendant la saisie dans un champ de texte, pour ne pas g\xEAner l'\xE9criture."
            }
          }
        }
      }
    },
    activity: {
      title: "Activit\xE9",
      intro: "Le fil de tout ce qui vous concerne dans l'organisation\xA0: mentions, t\xE2ches qu'on vous assigne, demandes de visa et leurs d\xE9cisions. Chaque membre voit son propre fil.",
      sections: {
        header: {
          title: "En-t\xEAte de la page",
          items: {
            title: {
              term: "Activit\xE9",
              text: "Le nom de la page."
            },
            markAllRead: {
              term: "Tout marquer comme lu",
              text: "Marque toutes les notifications de l'organisation comme lues. Le bouton est gris\xE9 quand il n'y a rien de non lu."
            }
          }
        },
        filters: {
          title: "Filtrer l'activit\xE9",
          items: {
            all: {
              term: "Tout",
              text: "Toutes les notifications, y compris les rappels d'\xE9ch\xE9ance et les messages sur l'abonnement."
            },
            mentions: {
              term: "Mentions",
              text: "Les fois o\xF9 quelqu'un vous mentionne dans un message ou une t\xE2che, ou r\xE9pond \xE0 l'un de vos commentaires."
            },
            assignments: {
              term: "Affectations",
              text: "Les t\xE2ches qu'on vous assigne."
            },
            approvals: {
              term: "Visas",
              text: "Les demandes de visa (approbation d'un document) et les d\xE9cisions rendues sur vos documents. Le visa peut \xEAtre VSO (approuv\xE9), VAO (approuv\xE9 avec observations) ou REF (refus\xE9)."
            },
            address: {
              term: "Filtre gard\xE9 dans l'adresse",
              text: "Le filtre choisi est \xE9crit dans l'adresse de la page\xA0: vous pouvez la copier pour partager la vue, et elle survit \xE0 un rechargement."
            }
          }
        },
        setup: {
          title: "Terminez la configuration de votre bureau",
          items: {
            card: {
              term: "Carte de configuration",
              text: "Trois premi\xE8res \xE9tapes pour bien d\xE9marrer avec BatiFlow. Elle n'appara\xEEt que sur l'onglet \xAB\xA0Tout\xA0\xBB, pour les propri\xE9taires, les administrateurs et les personnes qui peuvent inviter des membres."
            },
            invite: {
              term: "Invitez votre \xE9quipe",
              text: "Le lien \xAB\xA0Inviter\xA0\xBB m\xE8ne \xE0 l'ajout d'ing\xE9nieurs, de dessinateurs et de collaborateurs."
            },
            clients: {
              term: "Ajoutez un client",
              text: "Le lien \xAB\xA0Ajouter un client\xA0\xBB m\xE8ne \xE0 l'enregistrement de vos ma\xEEtres d'ouvrage (vos clients), pour les retrouver dans vos projets."
            },
            project: {
              term: "Cr\xE9ez un projet",
              text: "Le lien \xAB\xA0Cr\xE9er un projet\xA0\xBB m\xE8ne au lancement de votre premier dossier d'\xE9tude."
            },
            dismiss: {
              term: "Masquer",
              text: "Cache la carte. Votre choix est retenu pour cette organisation, sur cet appareil."
            }
          }
        },
        feed: {
          title: "Fil d'activit\xE9",
          items: {
            row: {
              term: "Une notification",
              text: "Une ic\xF4ne selon le type, une phrase, la date relative, puis l'organisation et le projet concern\xE9s. Cliquer dessus ouvre l'\xE9l\xE9ment et la marque comme lue."
            },
            unread: {
              term: "Non lu",
              text: "Les notifications non lues sont en gras, avec un petit point."
            },
            markRead: {
              term: "Marquer comme lu",
              text: "La coche \xE0 droite marque une seule notification comme lue sans l'ouvrir."
            },
            decide: {
              term: "D\xE9cider",
              text: "Sur une demande de visa\xA0: ouvre la fen\xEAtre pour rendre votre d\xE9cision sans quitter la page."
            },
            loadMore: {
              term: "Afficher plus d'activit\xE9",
              text: "Charge les notifications plus anciennes. Le bouton n'appara\xEEt que s'il en reste."
            }
          }
        },
        states: {
          title: "Quand la liste est vide ou ne se charge pas",
          items: {
            emptyAll: {
              term: "Rien de nouveau pour le moment",
              text: "Onglet \xAB\xA0Tout\xA0\xBB vide\xA0: vos mentions, affectations et visas appara\xEEtront ici."
            },
            emptyMentions: {
              term: "Aucune mention",
              text: "Vous serez pr\xE9venu ici quand quelqu'un vous mentionne ou r\xE9pond \xE0 l'un de vos commentaires."
            },
            emptyAssignments: {
              term: "Aucune affectation",
              text: "Les t\xE2ches qu'on vous assigne appara\xEEtront ici."
            },
            emptyApprovals: {
              term: "Aucun visa pour le moment",
              text: "Les demandes de visa et leurs d\xE9cisions arriveront ici avec l'approbation des documents."
            },
            loadFailed: {
              term: "Impossible de charger l'activit\xE9",
              text: "V\xE9rifiez votre connexion, puis cliquez sur \xAB\xA0R\xE9essayer\xA0\xBB."
            }
          }
        }
      }
    },
    chat: {
      title: "Conversations",
      intro: "La messagerie de BatiFlow\xA0: discussions priv\xE9es ou de groupe avec vos coll\xE8gues, et canaux rattach\xE9s \xE0 vos projets. Les conversations sont dans la liste de gauche, la conversation ouverte occupe le reste de l'\xE9cran.",
      sections: {
        listPane: {
          title: "Conversations et canaux (liste de gauche)",
          items: {
            newConversation: {
              term: "Nouvelle conversation",
              text: "Le bouton en haut de la liste ouvre la fen\xEAtre pour \xE9crire \xE0 un coll\xE8gue ou cr\xE9er un groupe."
            },
            discussions: {
              term: "Discussions",
              text: "Vos conversations priv\xE9es (une personne) et vos groupes (plusieurs personnes). Une conversation priv\xE9e porte le nom de l'autre personne."
            },
            projects: {
              term: "Projets",
              text: "Vos projets, que l'on d\xE9plie ou replie d'un clic. Sous chaque projet\xA0: ses canaux, c'est-\xE0-dire un fil de discussion par sujet."
            },
            unread: {
              term: "Compteur de messages non lus",
              text: "Un petit chiffre \xE0 c\xF4t\xE9 d'une conversation ou d'un canal indique combien de messages vous n'avez pas lus."
            },
            newChannel: {
              term: "Nouveau canal dans le projet",
              text: "Le bouton \xE0 c\xF4t\xE9 du nom d'un projet ouvre la cr\xE9ation d'un canal. Il n'appara\xEEt que pour les personnes qui g\xE8rent ce projet."
            },
            emptyDiscussions: {
              term: "Aucune discussion pour le moment",
              text: "D\xE9marrez une conversation avec un coll\xE8gue."
            },
            emptyProjects: {
              term: "Vous ne participez \xE0 aucun projet",
              text: "La section Projets reste vide tant qu'on ne vous a pas ajout\xE9 \xE0 un projet."
            },
            noChannels: {
              term: "Aucun canal dans ce projet",
              text: "Le projet n'a pas encore de canal. Les gestionnaires du projet peuvent en cr\xE9er un."
            }
          }
        },
        start: {
          title: "Choisissez une conversation",
          items: {
            emptyState: {
              term: "Choisissez une conversation",
              text: "\xC9cran de d\xE9part quand aucune conversation n'est ouverte\xA0: s\xE9lectionnez une conversation ou un canal dans la liste."
            },
            newConversation: {
              term: "Nouvelle conversation",
              text: "Le bouton de cet \xE9cran ouvre la m\xEAme fen\xEAtre que celui de la liste."
            }
          }
        },
        conversation: {
          title: "Une conversation",
          items: {
            header: {
              term: "Nom et sujet",
              text: "En haut\xA0: le nom du canal ou de la personne. Dessous, le sujet du canal, ou le nombre de personnes d'un groupe."
            },
            call: {
              term: "Appeler",
              text: "Lance un appel dans la conversation et ouvre la salle\xA0; les membres sont appel\xE9s. Disponible dans les conversations priv\xE9es, les groupes et les canaux priv\xE9s."
            },
            pins: {
              term: "Messages \xE9pingl\xE9s",
              text: "Ouvre \xE0 droite la liste des messages importants \xE9pingl\xE9s dans cette conversation. Le chiffre entre parenth\xE8ses indique combien il y en a."
            },
            dates: {
              term: "Aujourd'hui, Hier",
              text: "Les messages sont regroup\xE9s par jour. Les plus r\xE9cents sont en bas, et les nouveaux messages d'un coll\xE8gue arrivent \xE0 la suite."
            },
            latest: {
              term: "Derniers messages",
              text: "Bouton qui appara\xEEt quand vous avez remont\xE9 la conversation\xA0: il ram\xE8ne tout en bas. En haut, \xAB\xA0Chargement des messages pr\xE9c\xE9dents\u2026\xA0\xBB s'affiche quand l'historique se charge."
            },
            notice: {
              term: "Canal archiv\xE9, lecture seule",
              text: "Si le canal est archiv\xE9, un message dit que vous pouvez le lire mais plus y \xE9crire. M\xEAme chose si vous n'avez pas le droit d'\xE9crire\xA0: la zone de saisie est remplac\xE9e par cette phrase."
            },
            empty: {
              term: "Aucun message pour le moment",
              text: "Conversation vide\xA0: \xE9crivez le premier message."
            },
            unavailable: {
              term: "Conversation introuvable",
              text: "La conversation n'existe plus ou vous n'y avez pas acc\xE8s. Le bouton \xAB\xA0Retour aux conversations\xA0\xBB vous ram\xE8ne \xE0 l'\xE9cran de d\xE9part."
            }
          }
        },
        messages: {
          title: "Un message",
          items: {
            author: {
              term: "Auteur et heure",
              text: "Chaque message montre la personne qui l'a \xE9crit, son heure et son texte."
            },
            external: {
              term: "Externe",
              text: "Une \xE9tiquette \xAB\xA0Externe\xA0\xB7\xA0\xBB suivie du nom de l'organisation signale une personne d'une autre organisation, invit\xE9e dans un espace partag\xE9."
            },
            edited: {
              term: "modifi\xE9",
              text: "Le message a \xE9t\xE9 corrig\xE9 par son auteur apr\xE8s l'envoi."
            },
            pinned: {
              term: "\xC9pingl\xE9",
              text: "\xC9tiquette sur un message \xE9pingl\xE9 dans la conversation."
            },
            deleted: {
              term: "Ce message a \xE9t\xE9 supprim\xE9.",
              text: "Phrase qui remplace un message supprim\xE9, pour tout le monde."
            },
            reactions: {
              term: "R\xE9actions",
              text: "Sous le message, une pastille par \xE9moji avec son nombre. Appuyez sur une pastille pour ajouter ou retirer votre r\xE9action\xA0; elle est mise en \xE9vidence quand c'est la v\xF4tre."
            },
            thread: {
              term: "R\xE9ponses",
              text: "Un lien du type \xAB\xA02 r\xE9ponses\xA0\xBB sous le message ouvre son fil de discussion \xE0 droite."
            },
            sendStatus: {
              term: "Envoi en cours\u2026",
              text: "Pendant l'envoi, le message est p\xE2le. Si la connexion coupe, \xAB\xA0Message non envoy\xE9.\xA0\xBB s'affiche avec trois boutons\xA0: \xAB\xA0R\xE9essayer\xA0\xBB, \xAB\xA0Reprendre le texte\xA0\xBB (remet le texte dans la zone de saisie) et \xAB\xA0Supprimer\xA0\xBB."
            }
          }
        },
        messageActions: {
          title: "Actions sur un message",
          items: {
            react: {
              term: "Ajouter une r\xE9action",
              text: "Ouvre huit \xE9mojis au choix\xA0: pouce lev\xE9, coche verte, c\u0153ur, rire, surprise, mains jointes, yeux et f\xEAte."
            },
            reply: {
              term: "R\xE9pondre dans un fil",
              text: "Ouvre le fil du message \xE0 droite pour y r\xE9pondre sans encombrer la conversation."
            },
            pin: {
              term: "\xC9pingler le message",
              text: "Garde le message en \xE9vidence dans \xAB\xA0Messages \xE9pingl\xE9s\xA0\xBB. Le m\xEAme bouton devient \xAB\xA0D\xE9s\xE9pingler le message\xA0\xBB. Il faut avoir le droit d'\xE9crire. Une conversation compte au plus 50 messages \xE9pingl\xE9s."
            },
            edit: {
              term: "Modifier le message",
              text: "R\xE9serv\xE9 \xE0 l'auteur du message. Le texte devient modifiable sur place."
            },
            delete: {
              term: "Supprimer le message",
              text: "Pour l'auteur, ou pour les mod\xE9rateurs sur n'importe quel message."
            },
            deleteDialog: {
              term: "Supprimer le message de\u2026\xA0?",
              text: "Fen\xEAtre de confirmation\xA0: le message est remplac\xE9 par \xAB\xA0Ce message a \xE9t\xE9 supprim\xE9\xA0\xBB pour tout le monde, et c'est d\xE9finitif."
            }
          }
        },
        composer: {
          title: "\xC9crire un message",
          items: {
            field: {
              term: "\xC9crire un message",
              text: "La zone de saisie en bas de la conversation. Elle accepte la mise en forme et les mentions\xA0: tapez @ puis le nom d'une personne pour la mentionner."
            },
            hint: {
              term: "Aide \xE0 la saisie",
              text: "Entr\xE9e envoie, Maj+Entr\xE9e passe \xE0 la ligne, @ mentionne quelqu'un."
            },
            send: {
              term: "Envoyer",
              text: "Envoie le message. Il faut du texte ou au moins un fichier joint."
            },
            attach: {
              term: "Joindre un fichier",
              text: "Choisissez un ou plusieurs fichiers sur votre appareil. Un message contient au plus 10 fichiers."
            },
            attachNotices: {
              term: "Messages sur les pi\xE8ces jointes",
              text: "Si vous n'avez pas le droit d'ajouter des fichiers, un message vous le dit. Tant que des fichiers sont en cours d'envoi, il faut attendre avant d'envoyer le message."
            },
            cards: {
              term: "Fichiers joints",
              text: "Chaque fichier devient une carte sous le message, avec son \xE9tat\xA0: \xAB\xA0Envoi en cours\xA0\xBB, \xAB\xA0V\xE9rification antivirus en cours\xA0\xBB, \xAB\xA0Disponible\xA0\xBB ou \xAB\xA0Fichier refus\xE9 par la v\xE9rification antivirus\xA0\xBB."
            },
            cardActions: {
              term: "Ouvrir, T\xE9l\xE9charger",
              text: "\xAB\xA0Ouvrir\xA0\xBB affiche le fichier. \xAB\xA0T\xE9l\xE9charger\xA0\xBB en prend une copie, sauf si le t\xE9l\xE9chargement est interdit dans cet espace. Sans droit d'acc\xE8s au dossier, la carte dit \xAB\xA0Vous n'avez pas acc\xE8s \xE0 ce fichier\xA0\xBB\xA0: demandez l'acc\xE8s \xE0 la personne qui l'a envoy\xE9."
            },
            typing: {
              term: "Est en train d'\xE9crire\u2026",
              text: "Au-dessus de la zone de saisie, une ligne indique qui est en train d'\xE9crire."
            }
          }
        },
        panels: {
          title: "Panneau de droite\xA0: fil et messages \xE9pingl\xE9s",
          items: {
            thread: {
              term: "Fil de discussion",
              text: "Le message d'origine, puis les r\xE9ponses qui lui sont rattach\xE9es, avec leur nombre. S'il n'y en a pas\xA0: \xAB\xA0Aucune r\xE9ponse pour le moment. \xC9crivez la premi\xE8re.\xA0\xBB"
            },
            threadReply: {
              term: "R\xE9pondre dans le fil",
              text: "La zone de saisie du fil, avec son bouton \xAB\xA0R\xE9pondre\xA0\xBB."
            },
            rootDeleted: {
              term: "Le message d'origine a \xE9t\xE9 supprim\xE9",
              text: "On peut relire le fil mais plus y r\xE9pondre."
            },
            pins: {
              term: "Messages \xE9pingl\xE9s",
              text: "La liste des messages \xE9pingl\xE9s de la conversation. Vide, elle propose d'\xE9pingler un message important."
            },
            pinShow: {
              term: "Afficher dans la conversation",
              text: "Fait d\xE9filer la conversation jusqu'au message \xE9pingl\xE9 et le met en \xE9vidence."
            },
            pinThread: {
              term: "Ouvrir le fil",
              text: "Ouvre le fil de discussion du message \xE9pingl\xE9."
            },
            pinUnpin: {
              term: "D\xE9s\xE9pingler le message",
              text: "Retire le message de la liste des \xE9pingl\xE9s."
            },
            close: {
              term: "Fermer le panneau",
              text: "Ferme le panneau de droite (la touche \xC9chap aussi)."
            }
          }
        },
        dialogs: {
          title: "Nouvelle conversation et nouveau canal",
          items: {
            people: {
              term: "Personnes",
              text: "Nouvelle conversation\xA0: choisissez un coll\xE8gue pour une conversation priv\xE9e, plusieurs pour un groupe. Choix obligatoire."
            },
            groupName: {
              term: "Nom du groupe",
              text: "Demand\xE9 seulement pour un groupe (plusieurs personnes). Le bouton \xAB\xA0Cr\xE9er la conversation\xA0\xBB termine."
            },
            kind: {
              term: "Type de canal",
              text: "G\xE9n\xE9ral ou Discipline\xA0: visible par tous les membres du projet. Priv\xE9\xA0: r\xE9serv\xE9 aux personnes choisies."
            },
            channelName: {
              term: "Nom du canal",
              text: "Obligatoire. Un canal du m\xEAme nom ne peut pas exister deux fois dans le projet."
            },
            discipline: {
              term: "Discipline",
              text: "Demand\xE9e pour un canal Discipline\xA0: Architecture, Structure, VRD (voirie et r\xE9seaux divers), Fluides, \xC9lectricit\xE9, Topographie, G\xE9otechnique ou OPC (ordonnancement, pilotage, coordination)."
            },
            topic: {
              term: "Sujet (facultatif)",
              text: "Une phrase pour dire de quoi parle le canal."
            },
            members: {
              term: "Membres du canal",
              text: "Pour un canal Priv\xE9, les personnes qui y auront acc\xE8s. Vous en faites partie automatiquement."
            },
            submit: {
              term: "Cr\xE9er le canal",
              text: "Cr\xE9e le canal. \xAB\xA0Annuler\xA0\xBB ferme la fen\xEAtre sans rien cr\xE9er."
            }
          }
        }
      }
    },
    calendar: {
      title: "Calendrier",
      intro: "Vos \xE9v\xE9nements\xA0: r\xE9unions, visites de chantier et \xE9ch\xE9ances de tous vos projets, en quatre affichages. Le mini-calendrier et les filtres sont dans la liste de gauche.",
      sections: {
        header: {
          title: "En-t\xEAte de la page",
          items: {
            feeds: {
              term: "Abonnement ICS",
              text: "Ouvre la fen\xEAtre pour afficher votre calendrier BatiFlow dans Outlook, Google Agenda ou Apple Calendrier."
            },
            newEvent: {
              term: "Nouvel \xE9v\xE9nement",
              text: "Ouvre le formulaire de cr\xE9ation d'un \xE9v\xE9nement, \xE0 la date affich\xE9e."
            }
          }
        },
        toolbar: {
          title: "Navigation du calendrier",
          items: {
            today: {
              term: "Aujourd'hui",
              text: "Revient \xE0 la date du jour."
            },
            arrows: {
              term: "Semaine pr\xE9c\xE9dente, Semaine suivante",
              text: "Les deux fl\xE8ches avancent ou reculent d'une semaine, ou d'un mois pour les affichages Mois et Agenda."
            },
            period: {
              term: "P\xE9riode affich\xE9e",
              text: "Le titre, \xE0 c\xF4t\xE9 des fl\xE8ches, indique la semaine ou le mois en cours de consultation."
            },
            week: {
              term: "Semaine",
              text: "Sept jours en colonnes, avec les heures sur le c\xF4t\xE9."
            },
            workWeek: {
              term: "Semaine de travail",
              text: "Comme Semaine, mais du lundi au vendredi seulement."
            },
            month: {
              term: "Mois",
              text: "Une grille du mois. Choisissez un jour pour le voir en d\xE9tail."
            },
            agenda: {
              term: "Agenda",
              text: "Une liste de vos \xE9v\xE9nements jour par jour, avec l'heure ou \xAB\xA0Toute la journ\xE9e\xA0\xBB."
            }
          }
        },
        legend: {
          title: "Types d'\xE9v\xE9nements",
          items: {
            meeting: {
              term: "R\xE9union",
              text: "Ic\xF4ne de personnes, couleur bleue."
            },
            siteVisit: {
              term: "Visite de chantier",
              text: "Ic\xF4ne de b\xE2timent, couleur verte."
            },
            deadline: {
              term: "\xC9ch\xE9ance",
              text: "Ic\xF4ne de drapeau, couleur jaune."
            },
            other: {
              term: "Autre",
              text: "Ic\xF4ne de calendrier, couleur violette."
            },
            readOnly: {
              term: "Cadenas",
              text: "Le cadenas signale une \xE9ch\xE9ance en lecture seule (t\xE2che, phase ou visa)\xA0: elle ne se modifie qu'\xE0 sa source. Chaque type a aussi un nom \xE9crit, car la couleur n'est jamais seule."
            }
          }
        },
        grid: {
          title: "Grille et agenda",
          items: {
            allDay: {
              term: "Toute la journ\xE9e",
              text: "Ligne en haut des affichages Semaine\xA0: les \xE9v\xE9nements sans heure."
            },
            event: {
              term: "Un \xE9v\xE9nement",
              text: "Une pastille avec son titre et son heure. Cliquez dessus pour ouvrir ses d\xE9tails."
            },
            more: {
              term: "+3 autres",
              text: "Dans l'affichage Mois, quand un jour contient trop d'\xE9v\xE9nements\xA0: cliquez pour les voir tous."
            },
            today: {
              term: "Aujourd'hui",
              text: "Le jour du jour est mis en \xE9vidence dans les grilles et dans l'agenda."
            },
            empty: {
              term: "Aucun \xE9v\xE9nement sur cette p\xE9riode",
              text: "Dans l'agenda\xA0: cr\xE9ez un \xE9v\xE9nement ou changez de p\xE9riode."
            },
            truncated: {
              term: "Plus d'\xE9v\xE9nements que le calendrier ne peut en afficher",
              text: "Choisissez une p\xE9riode plus courte (semaine ou mois) ou filtrez par projet."
            },
            loadFailed: {
              term: "Impossible de charger le calendrier",
              text: "V\xE9rifiez votre connexion, puis cliquez sur \xAB\xA0R\xE9essayer\xA0\xBB."
            }
          }
        },
        listPane: {
          title: "Mini-calendrier et filtres (liste de gauche)",
          items: {
            mini: {
              term: "Mini-calendrier",
              text: "Un petit mois pour choisir un jour. Les jours avec des \xE9v\xE9nements sont signal\xE9s."
            },
            scope: {
              term: "Calendrier affich\xE9",
              text: "\xAB\xA0Cette organisation\xA0\xBB ou \xAB\xA0Toutes mes organisations\xA0\xBB. Ce choix n'appara\xEEt que si vous appartenez \xE0 plusieurs organisations."
            },
            kinds: {
              term: "Types d'\xE9v\xE9nements",
              text: "Cases \xE0 cocher R\xE9union, Visite de chantier, \xC9ch\xE9ance, Autre\xA0: d\xE9cochez un type pour le masquer."
            },
            project: {
              term: "Projet",
              text: "Liste pour n'afficher que les \xE9v\xE9nements d'un projet. \xAB\xA0Tous les projets\xA0\xBB enl\xE8ve le filtre. Elle appara\xEEt seulement quand des projets ont des \xE9v\xE9nements."
            },
            reset: {
              term: "Tout afficher",
              text: "Enl\xE8ve tous les filtres d'un clic. Le bouton n'appara\xEEt que lorsqu'un filtre est actif."
            }
          }
        },
        details: {
          title: "D\xE9tails d'un \xE9v\xE9nement",
          items: {
            whenWhere: {
              term: "Quand, Lieu",
              text: "La date et l'heure de l'\xE9v\xE9nement, et l'endroit s'il est renseign\xE9."
            },
            projectOrg: {
              term: "Projet, Organisation",
              text: "Le projet ou l'espace de l'organisation auquel l'\xE9v\xE9nement appartient."
            },
            organiser: {
              term: "Organisateur",
              text: "La personne qui a cr\xE9\xE9 l'\xE9v\xE9nement."
            },
            attendees: {
              term: "Participants",
              text: "La liste des invit\xE9s avec leur r\xE9ponse\xA0: A accept\xE9, A refus\xE9, Peut-\xEAtre ou Sans r\xE9ponse. Un \xAB\xA0Invit\xE9 externe\xA0\xBB est une personne hors de BatiFlow."
            },
            rsvp: {
              term: "Votre r\xE9ponse",
              text: "Si vous \xEAtes invit\xE9\xA0: Accepter, Peut-\xEAtre ou Refuser. Votre r\xE9ponse actuelle est rappel\xE9e dessous."
            },
            join: {
              term: "Rejoindre",
              text: "Ouvre la salle de la r\xE9union en ligne. Le bouton n'appara\xEEt que pour les \xE9v\xE9nements qui ont une r\xE9union."
            },
            editDelete: {
              term: "Modifier, Supprimer",
              text: "Pour les personnes qui ont le droit de modifier l'\xE9v\xE9nement. La suppression demande une confirmation et est d\xE9finitive\xA0: les invit\xE9s ne verront plus l'\xE9v\xE9nement."
            },
            readOnly: {
              term: "\xC9ch\xE9ance en lecture seule",
              text: "Pour une \xE9ch\xE9ance venue d'une t\xE2che, d'une phase ou d'un visa\xA0: un lien comme \xAB\xA0Ouvrir les t\xE2ches du projet\xA0\xBB m\xE8ne \xE0 sa source, o\xF9 on la modifie."
            }
          }
        },
        eventDialog: {
          title: "Nouvel \xE9v\xE9nement et Modifier l'\xE9v\xE9nement",
          items: {
            space: {
              term: "Espace",
              text: "Obligatoire \xE0 la cr\xE9ation\xA0: l'organisation (propri\xE9taires et administrateurs) ou un projet o\xF9 vous pouvez contribuer. L'\xE9v\xE9nement est visible des personnes qui ont acc\xE8s \xE0 cet espace."
            },
            title: {
              term: "Titre",
              text: "Obligatoire\xA0: donnez un titre \xE0 l'\xE9v\xE9nement."
            },
            kind: {
              term: "Type",
              text: "R\xE9union, Visite de chantier, \xC9ch\xE9ance ou Autre."
            },
            allDay: {
              term: "Toute la journ\xE9e",
              text: "Interrupteur\xA0: sans heures, avec seulement \xAB\xA0Premier jour\xA0\xBB et \xAB\xA0Dernier jour\xA0\xBB."
            },
            dates: {
              term: "D\xE9but, Fin",
              text: "Date et heure de d\xE9but et de fin, en temps de Tunis. La fin doit \xEAtre apr\xE8s le d\xE9but, et un \xE9v\xE9nement dure au plus 31 jours."
            },
            locationDescription: {
              term: "Lieu, Description",
              text: "Deux champs libres et facultatifs\xA0: o\xF9 a lieu l'\xE9v\xE9nement et ce qu'il faut savoir."
            },
            attendees: {
              term: "Participants",
              text: "Choisissez les personnes \xE0 inviter. Seules celles qui ont acc\xE8s \xE0 l'espace peuvent l'\xEAtre, et vous \xEAtes toujours invit\xE9. Les invit\xE9s re\xE7oivent un rappel avant le d\xE9but."
            },
            submit: {
              term: "Cr\xE9er l'\xE9v\xE9nement, Enregistrer",
              text: "Valide le formulaire. \xAB\xA0Annuler\xA0\xBB ferme la fen\xEAtre. Un message d'erreur indique ce qu'il faut corriger. Sans espace o\xF9 contribuer, rejoignez d'abord un projet."
            }
          }
        },
        feeds: {
          title: "Abonnement \xE0 votre calendrier (ICS)",
          items: {
            list: {
              term: "Vos flux d'abonnement",
              text: "Chaque flux montre son nom, l'organisation, son contenu et sa date de cr\xE9ation."
            },
            revoke: {
              term: "R\xE9voquer",
              text: "Coupe le flux. Les applications abonn\xE9es ne re\xE7oivent plus rien, et c'est d\xE9finitif\xA0: il faudra cr\xE9er un nouveau flux."
            },
            label: {
              term: "Nom du flux",
              text: "Facultatif, par exemple \xAB\xA0Agenda de mon t\xE9l\xE9phone\xA0\xBB."
            },
            scope: {
              term: "Contenu du flux",
              text: "\xAB\xA0Tout ce que vous voyez\xA0\xBB ou \xAB\xA0Seulement ce qui vous concerne\xA0\xBB."
            },
            includeExternal: {
              term: "Inclure les \xE9v\xE9nements des espaces partag\xE9s avec des partenaires",
              text: "Case \xE0 cocher pour ajouter aussi les \xE9v\xE9nements des espaces partag\xE9s avec d'autres organisations."
            },
            create: {
              term: "Cr\xE9er le flux",
              text: "Cr\xE9e le flux et affiche son adresse d'abonnement."
            },
            address: {
              term: "Votre adresse d'abonnement",
              text: "Affich\xE9e une seule fois\xA0: elle donne acc\xE8s \xE0 votre calendrier comme un mot de passe. Copiez-la avec \xAB\xA0Copier l'adresse\xA0\xBB, puis cliquez sur \xAB\xA0J'ai copi\xE9 l'adresse\xA0\xBB."
            },
            limit: {
              term: "Nombre maximal de flux",
              text: "Quand la limite est atteinte, r\xE9voquez un flux pour en cr\xE9er un autre."
            }
          }
        }
      }
    },
    files: {
      title: "Fichiers",
      intro: "Les fichiers de l'organisation au m\xEAme endroit : les derniers modifi\xE9s, les dossiers de l'organisation, les espaces que d'autres organisations partagent avec vous et la recherche. Vous ne voyez que ce que vous avez le droit d'ouvrir.",
      sections: {
        page: {
          title: "La page",
          items: {
            title: {
              term: "Fichiers",
              text: "Le nom de la page, en haut. L'application s'ouvre aussi avec Alt+5."
            },
            tabs: {
              term: "Onglets",
              text: "R\xE9cents, Organisation, Partag\xE9s avec moi et Rechercher. L'onglet ouvert reste dans l'adresse de la page."
            }
          }
        },
        recent: {
          title: "R\xE9cents",
          items: {
            list: {
              term: "Fichiers r\xE9cents",
              text: "Les documents ajout\xE9s ou modifi\xE9s en dernier dans les dossiers que vous pouvez lire, du plus r\xE9cent au plus ancien."
            },
            line: {
              term: "Une ligne",
              text: "Le titre, le code, le projet ou l'espace, le dossier et depuis quand il a chang\xE9. Cliquez pour ouvrir le document."
            }
          }
        },
        organisation: {
          title: "Organisation",
          items: {
            folders: {
              term: "Dossiers de l'organisation",
              text: "Les documents qui n'appartiennent \xE0 aucun projet. Les dossiers sensibles (notes de frais, coffre-fort) ne s'affichent que pour les personnes autoris\xE9es."
            }
          }
        },
        shared: {
          title: "Partag\xE9s avec moi",
          items: {
            spaces: {
              term: "Espaces d'autres organisations",
              text: "Les espaces o\xF9 une autre organisation vous a invit\xE9. Cliquez pour ouvrir l'espace et ses documents."
            }
          }
        },
        search: {
          title: "Rechercher",
          items: {
            field: {
              term: "Rechercher un fichier",
              text: "Tapez au moins deux lettres du titre ou du code. Seuls les documents que vous pouvez ouvrir sont trouv\xE9s."
            }
          }
        }
      }
    },
    document: {
      title: "Document",
      intro: "Le lecteur d'un document de projet\xA0: on y lit un PDF ou une image, on change de version, on t\xE9l\xE9charge et, selon vos droits, on annote.",
      sections: {
        header: {
          title: "En-t\xEAte du document",
          items: {
            back: {
              term: "Retour aux fichiers",
              text: "Revient \xE0 l'onglet \xAB\xA0Fichiers\xA0\xBB du projet."
            },
            title: {
              term: "Code et titre",
              text: "Le code du document (toujours \xE9crit de gauche \xE0 droite), suivi de son titre."
            },
            version: {
              term: "Version du document",
              text: "Liste pour choisir la version \xE0 lire. Chaque ligne affiche un \xAB\xA0Indice\xA0\xBB (la lettre de version d'un plan\xA0: A, B, C\u2026), puis la date. La version en cours porte la mention \xAB\xA0(version actuelle)\xA0\xBB. Le choix est gard\xE9 dans l'adresse."
            },
            download: {
              term: "T\xE9l\xE9charger",
              text: "Prend une copie de la version affich\xE9e. Le bouton est gris\xE9 pendant la pr\xE9paration."
            },
            downloadStatus: {
              term: "Pr\xE9paration d'une copie \xE0 votre nom\u2026",
              text: "Message pendant la pr\xE9paration. Le t\xE9l\xE9chargement peut \xEAtre d\xE9sactiv\xE9 dans cet espace\xA0: vous pouvez alors lire le document sans le t\xE9l\xE9charger. S'il ne d\xE9marre pas, un message d'erreur vous invite \xE0 r\xE9essayer."
            }
          }
        },
        pdfTools: {
          title: "Outils du document (PDF)",
          items: {
            thumbnails: {
              term: "Afficher les miniatures",
              text: "Affiche ou masque la colonne de petites images des pages, sur le c\xF4t\xE9. Cliquez sur une miniature pour aller \xE0 la page."
            },
            pages: {
              term: "Page pr\xE9c\xE9dente, Page suivante",
              text: "Les deux fl\xE8ches de la barre changent de page."
            },
            goToPage: {
              term: "Aller \xE0 la page",
              text: "Tapez un num\xE9ro puis Entr\xE9e. \xC0 c\xF4t\xE9\xA0: \xAB\xA0sur\xA0\xBB suivi du nombre total de pages."
            },
            zoom: {
              term: "Zoom avant, Zoom arri\xE8re",
              text: "Agrandissent ou r\xE9duisent la page. Le pourcentage s'affiche entre les deux boutons."
            },
            fit: {
              term: "Ajuster \xE0 la largeur, Ajuster \xE0 la page",
              text: "Adaptent la taille de la page \xE0 la fen\xEAtre\xA0: en largeur ou en hauteur."
            },
            search: {
              term: "Rechercher dans le document",
              text: "Ouvre la barre de recherche. Ctrl+F fait de m\xEAme."
            },
            keys: {
              term: "Raccourcis",
              text: "Page suivante et Page pr\xE9c\xE9dente (ou les fl\xE8ches gauche et droite) changent de page. D\xE9but et Fin vont \xE0 la premi\xE8re et \xE0 la derni\xE8re page. + et \u2212 zooment."
            },
            watermark: {
              term: "Filigrane",
              text: "L'aper\xE7u peut porter un filigrane avec votre nom, votre organisation et la date. Un bandeau le rappelle."
            }
          }
        },
        search: {
          title: "Recherche dans le document",
          items: {
            field: {
              term: "Rechercher\u2026",
              text: "Tapez un mot\xA0: les r\xE9sultats sont surlign\xE9s dans les pages."
            },
            result: {
              term: "R\xE9sultat pr\xE9c\xE9dent, R\xE9sultat suivant",
              text: "Passent d'un r\xE9sultat \xE0 l'autre. La position s'affiche sous la forme \xAB\xA0R\xE9sultat 2 sur 5\xA0\xBB."
            },
            state: {
              term: "Recherche en cours\u2026, Aucun r\xE9sultat",
              text: "Messages d'\xE9tat pendant ou apr\xE8s la recherche."
            },
            close: {
              term: "Fermer la recherche",
              text: "Cache la barre de recherche."
            }
          }
        },
        imageTools: {
          title: "Outils de l'image",
          items: {
            zoom: {
              term: "Zoom avant, Zoom arri\xE8re",
              text: "Agrandissent ou r\xE9duisent l'image. Le pourcentage s'affiche entre les deux boutons."
            },
            fit: {
              term: "Ajuster \xE0 la fen\xEAtre",
              text: "Remet l'image \xE0 la taille de la fen\xEAtre (touche 0)."
            },
            keys: {
              term: "Raccourcis",
              text: "Les fl\xE8ches d\xE9placent l'image, + et \u2212 zooment."
            }
          }
        },
        annotationTools: {
          title: "Outils d'annotation",
          items: {
            tools: {
              term: "Outils d'annotation",
              text: "S\xE9lectionner, Rectangle, Nuage de r\xE9vision (pour entourer une zone \xE0 revoir), Fl\xE8che et Texte. Ils n'apparaissent que si vous avez le droit de commenter."
            },
            colors: {
              term: "Couleur",
              text: "Rouge, Orange, Vert, Bleu ou Noir, pour le prochain dessin."
            },
            draw: {
              term: "Dessiner sur la page",
              text: "\xC0 la souris, tracez la forme. Au clavier, les fl\xE8ches d\xE9placent un r\xE9ticule, Entr\xE9e pose le premier coin puis le coin oppos\xE9, \xC9chap annule."
            },
            list: {
              term: "Afficher la liste des annotations",
              text: "Ouvre ou ferme la liste des annotations de la version affich\xE9e."
            }
          }
        },
        annotationPanel: {
          title: "Annotations (liste et d\xE9tails)",
          items: {
            filters: {
              term: "Filtrer par \xE9tat, Filtrer par organisation",
              text: "\xC9tat\xA0: Toutes, Ouvertes ou R\xE9solues. Organisation\xA0: toutes ou une seule, quand des partenaires ont aussi annot\xE9."
            },
            item: {
              term: "Annotation 1 \xB7 Page 3",
              text: "Chaque ligne donne le num\xE9ro de l'annotation, sa page, son \xE9tat (Ouverte ou R\xE9solue) et l'organisation de son auteur\xA0: Mon organisation ou Organisation partenaire."
            },
            empty: {
              term: "Aucune annotation sur cette version pour le moment",
              text: "La liste est vide, ou aucune annotation ne correspond aux filtres."
            },
            new: {
              term: "Nouvelle annotation",
              text: "Apr\xE8s le dessin\xA0: \xAB\xA0Commentaire\xA0\xBB (obligatoire, 2\xA0000 caract\xE8res au plus) explique quoi corriger. Pour un texte\xA0: \xAB\xA0Texte affich\xE9 sur le plan\xA0\xBB (500 caract\xE8res au plus). \xAB\xA0Ajouter l'annotation\xA0\xBB valide."
            },
            details: {
              term: "D\xE9tails d'une annotation",
              text: "Le commentaire, l'auteur et la date. Boutons \xAB\xA0R\xE9soudre\xA0\xBB (ou \xAB\xA0Rouvrir\xA0\xBB), \xAB\xA0Modifier\xA0\xBB (impossible une fois r\xE9solue) et \xAB\xA0Supprimer\xA0\xBB, selon vos droits."
            },
            thread: {
              term: "\xC9changes",
              text: "Les r\xE9ponses \xE0 l'annotation. \xAB\xA0R\xE9pondre\xA0\xBB ouvre un champ, \xAB\xA0Envoyer\xA0\xBB publie. Il faut avoir le droit de commenter."
            }
          }
        },
        states: {
          title: "Messages d'\xE9tat de l'aper\xE7u",
          items: {
            preparing: {
              term: "Pr\xE9paration de l'aper\xE7u\u2026",
              text: "Le fichier est converti pour l'affichage, en g\xE9n\xE9ral en quelques secondes. La page se met \xE0 jour toute seule."
            },
            unavailable: {
              term: "Ce fichier est en cours d'envoi ou de v\xE9rification",
              text: "Il sera lisible d\xE8s que l'envoi et l'analyse antivirus seront finis. S'il est refus\xE9, il ne peut pas \xEAtre ouvert."
            },
            none: {
              term: "Aucun aper\xE7u pour ce type de fichier",
              text: "T\xE9l\xE9chargez le fichier pour l'ouvrir avec une autre application."
            },
            failed: {
              term: "L'aper\xE7u n'a pas pu \xEAtre g\xE9n\xE9r\xE9",
              text: "Le fichier est peut-\xEAtre endommag\xE9\xA0: t\xE9l\xE9chargez-le ou envoyez une nouvelle version."
            },
            password: {
              term: "Ce PDF est prot\xE9g\xE9 par un mot de passe",
              text: "Il ne peut pas \xEAtre affich\xE9 ici\xA0: t\xE9l\xE9chargez-le pour l'ouvrir."
            },
            noVersion: {
              term: "Ce document n'a pas encore de version consultable",
              text: "Une version appara\xEEtra d\xE8s que son analyse sera termin\xE9e."
            },
            notFound: {
              term: "Document introuvable",
              text: "Il n'existe pas, ou vous n'y avez pas acc\xE8s. Le bouton \xAB\xA0Retour aux fichiers\xA0\xBB ram\xE8ne au projet."
            },
            noSpace: {
              term: "L'espace de fichiers n'est pas encore pr\xEAt",
              text: "Les documents seront disponibles d\xE8s que l'espace interne du projet aura \xE9t\xE9 cr\xE9\xE9."
            }
          }
        }
      }
    },
    search: {
      title: "R\xE9sultats de la recherche",
      intro: "Tous les r\xE9sultats d'une recherche dans l'organisation\xA0: projets, documents, t\xE2ches, clients et messages. Vous y arrivez depuis la recherche de l'en-t\xEAte.",
      sections: {
        page: {
          title: "La page de r\xE9sultats",
          items: {
            field: {
              term: "Votre recherche",
              text: "Tapez au moins 2 caract\xE8res. La page se met \xE0 jour quand vous marquez une pause, et la recherche est gard\xE9e dans l'adresse."
            },
            scope: {
              term: "Type de r\xE9sultats",
              text: "Pastilles Tout, Projets, Documents, T\xE2ches, Clients pour ne garder qu'un seul type. La pastille choisie est fonc\xE9e."
            },
            count: {
              term: "Nombre de r\xE9sultats",
              text: "Par exemple \xAB\xA012 r\xE9sultats\xA0\xBB."
            },
            hasMore: {
              term: "Plus de r\xE9sultats\xA0: affinez votre recherche.",
              text: "Chaque type affiche au plus 20 r\xE9sultats. S'il y en a davantage, pr\xE9cisez votre recherche."
            }
          }
        },
        flyout: {
          title: "Recherche rapide de l'en-t\xEAte",
          items: {
            open: {
              term: "Rechercher des projets, fichiers, messages\u2026",
              text: "Le champ de l'en-t\xEAte (ou Ctrl+K, ou /) ouvre une fen\xEAtre de recherche dans l'organisation."
            },
            field: {
              term: "Rechercher dans l'organisation",
              text: "Le champ de cette fen\xEAtre. Elle montre quelques r\xE9sultats par type."
            },
            more: {
              term: "Voir tous les projets, documents, t\xE2ches\u2026",
              text: "La derni\xE8re ligne d'un type ouvre la page de r\xE9sultats limit\xE9e \xE0 ce type."
            },
            all: {
              term: "Voir tous les r\xE9sultats pour\u2026",
              text: "Ouvre cette page avec tous les r\xE9sultats de votre recherche."
            },
            close: {
              term: "\xC9chap",
              text: "Ferme la fen\xEAtre."
            }
          }
        },
        results: {
          title: "Liste des r\xE9sultats",
          items: {
            groups: {
              term: "Projets, Documents, T\xE2ches, Clients, Messages",
              text: "Les r\xE9sultats sont class\xE9s par type, dans cet ordre."
            },
            hit: {
              term: "Une ligne de r\xE9sultat",
              text: "Une ic\xF4ne selon le type, puis le titre avec les mots trouv\xE9s en gras sur fond color\xE9. Un code (de projet, de document) s'affiche \xE0 c\xF4t\xE9, et le nom du canal pour un message."
            },
            open: {
              term: "Ouvrir un r\xE9sultat",
              text: "Cliquez ou appuyez sur Entr\xE9e\xA0: un projet ou un client s'ouvre, un document dans le lecteur, une t\xE2che dans les t\xE2ches de son projet, un message dans sa conversation."
            },
            keyboard: {
              term: "Au clavier",
              text: "Les fl\xE8ches haut et bas parcourent les r\xE9sultats sans quitter le champ de saisie, Entr\xE9e ouvre celui qui est en surbrillance."
            }
          }
        },
        states: {
          title: "\xC9tats de la recherche",
          items: {
            prompt: {
              term: "Saisissez au moins 2 caract\xE8res pour lancer la recherche.",
              text: "Message tant que rien n'est tap\xE9. \xAB\xA0Saisissez au moins 2 caract\xE8res.\xA0\xBB s'affiche si le texte est trop court."
            },
            loading: {
              term: "Recherche en cours\u2026",
              text: "Un indicateur tourne pendant le chargement."
            },
            empty: {
              term: "Aucun r\xE9sultat pour\u2026",
              text: "V\xE9rifiez l'orthographe ou essayez un autre mot."
            },
            error: {
              term: "Trop de recherches, La recherche n'a pas abouti",
              text: "Dans le premier cas, patientez un instant\xA0: le nombre de recherches par minute est limit\xE9. Dans les deux cas, le bouton \xAB\xA0R\xE9essayer\xA0\xBB relance la recherche."
            }
          }
        }
      }
    },
    more: {
      title: "Plus",
      intro: "Les raccourcis vers le reste de BatiFlow\xA0: clients, partenariats et administration du bureau. Chacun n'appara\xEEt que si vous y avez droit.",
      sections: {
        header: {
          title: "La page",
          items: {
            title: {
              term: "Plus",
              text: "Le nom de la page. L'application s'ouvre aussi avec Alt+7."
            },
            cards: {
              term: "Cartes",
              text: "Chaque carte est un lien\xA0: cliquez dessus pour ouvrir la page. Si vous n'avez droit \xE0 aucune, la page ne montre que le message du bas."
            }
          }
        },
        cards: {
          title: "Les cartes",
          items: {
            clients: {
              term: "Clients",
              text: "Ma\xEEtres d'ouvrage\xA0: fiche fiscale, contacts et coordonn\xE9es. Pour les personnes qui peuvent consulter les clients."
            },
            partnerships: {
              term: "Partenariats",
              text: "Demandes de partenariat re\xE7ues et espaces d'autres organisations o\xF9 vous g\xE9rez vos d\xE9l\xE9gu\xE9s. Propri\xE9taires et administrateurs seulement."
            },
            approvals: {
              term: "Approbations d'acc\xE8s externe",
              text: "Accordez ou refusez \xE0 un membre l'acc\xE8s \xE0 l'espace d'une autre organisation. Pour les personnes qui ont ce droit d'approbation."
            },
            admin: {
              term: "Administration",
              text: "Membres, invitations, r\xF4les et permissions de votre bureau. Visible si vous pouvez ouvrir au moins une page d'administration."
            }
          }
        },
        note: {
          title: "Message du bas",
          items: {
            soon: {
              term: "D'autres sections arriveront",
              text: "Phrase en bas de page\xA0: d'autres sections (clients, appels d'offres\u2026) arriveront dans une prochaine version de BatiFlow."
            },
            empty: {
              term: "Aucune carte",
              text: "Si aucune carte ne s'affiche, c'est que votre r\xF4le n'ouvre aucune de ces pages\xA0: demandez \xE0 un administrateur de votre bureau."
            }
          }
        }
      }
    },
    spaces: {
      title: "Espaces partag\xE9s",
      intro: "Cette page liste les espaces partag\xE9s auxquels vous avez acc\xE8s\xA0: ceux de vos organisations et ceux d'autres organisations qui vous ont ouvert leur porte. Un espace partag\xE9 r\xE9unit des personnes de plusieurs organisations autour d'un projet ou d'un sujet commun.",
      sections: {
        header: {
          title: "En-t\xEAte de la page",
          items: {
            title: {
              term: "Espaces partag\xE9s",
              text: "Le titre de la page, suivi d'une courte phrase qui rappelle ce qu'est un espace partag\xE9."
            },
            newSpace: {
              term: "Nouvel espace partag\xE9",
              text: "Ouvre la fen\xEAtre de cr\xE9ation d'un espace. Ce bouton n'appara\xEEt que si votre r\xF4le vous permet de cr\xE9er des espaces dans l'organisation active."
            },
            waiting: {
              term: "Voir les invitations",
              text: "Bandeau bleu affich\xE9 seulement quand des invitations attendent votre r\xE9ponse. Le lien ouvre la page \xABInvitations \xE0 des espaces\xA0\xBB."
            }
          }
        },
        ownList: {
          title: "Espaces de mes organisations",
          items: {
            list: {
              term: "Espaces de mes organisations",
              text: "Les espaces h\xE9berg\xE9s par vos propres organisations\xA0: espaces de projet, espaces partag\xE9s et groupes de travail. Cliquez sur une ligne pour ouvrir l'espace."
            },
            empty: {
              term: "Aucun espace partag\xE9 dans vos organisations",
              text: "Message affich\xE9 tant qu'aucun espace n'existe. Il propose le bouton \xABNouvel espace partag\xE9\xA0\xBB si vous avez le droit d'en cr\xE9er."
            }
          }
        },
        externalList: {
          title: "Espaces externes",
          items: {
            list: {
              term: "Espaces externes",
              text: "Les espaces d'autres organisations auxquels on vous a donn\xE9 acc\xE8s (partenaire, client, invit\xE9). Chaque ligne porte la pastille \xABExterne\xA0\xBB."
            },
            empty: {
              term: "Aucun espace externe",
              text: "Message affich\xE9 tant qu'aucune autre organisation ne vous a ouvert un espace."
            },
            loadFailed: {
              term: "Impossible de charger vos espaces",
              text: "Message rouge affich\xE9 si la liste ne s'est pas charg\xE9e. V\xE9rifiez votre connexion puis utilisez le bouton \xABR\xE9essayer\xA0\xBB."
            }
          }
        },
        row: {
          title: "Une ligne d'espace",
          items: {
            name: {
              term: "Nom de l'espace",
              text: "Le nom de l'espace, avec le logo de l'organisation qui l'h\xE9berge. Toute la ligne est un lien qui ouvre l'espace."
            },
            kind: {
              term: "Type d'espace",
              text: "Espace de l'organisation, Espace de projet, Espace partag\xE9 (li\xE9 \xE0 un projet et ouvert \xE0 des partenaires) ou Groupe de travail (sans projet, pour vos \xE9quipes)."
            },
            host: {
              term: "H\xE9berg\xE9 par",
              text: "Le nom de l'organisation qui h\xE9berge l'espace et en fixe les r\xE8gles."
            },
            access: {
              term: "Acc\xE8s\xA0: \u2026",
              text: "Pour un espace externe seulement\xA0: comment vous y \xEAtes entr\xE9 (par exemple \xABInvitation nominative\xA0\xBB ou \xABInvit\xE9\xA0\xBB), vos droits (\xABLecture seule\xA0\xBB, \xABLecture et \xE9criture\xA0\xBB ou \xABLecture, \xE9criture et visa\xA0\xBB) et la date de fin, ou \xABSans date de fin\xA0\xBB."
            },
            external: {
              term: "Externe",
              text: "Pastille qui signale un espace h\xE9berg\xE9 par une autre organisation que les v\xF4tres."
            },
            closed: {
              term: "Ferm\xE9",
              text: "Pastille avec un cadenas\xA0: l'espace est ferm\xE9, son contenu reste consultable en lecture seule."
            }
          }
        },
        newDialog: {
          title: "Fen\xEAtre \xABNouvel espace partag\xE9\xA0\xBB",
          items: {
            intro: {
              term: "Nouvel espace partag\xE9",
              text: "Vous serez le responsable de l'espace. Vous pourrez ensuite y inviter des organisations partenaires."
            },
            kind: {
              term: "Type d'espace",
              text: "\xABEspace partag\xE9 d'un projet\xA0\xBB est li\xE9 \xE0 l'un des projets dont vous \xEAtes responsable. \xABGroupe de travail\xA0\xBB n'a pas de projet\xA0: ce choix est r\xE9serv\xE9 aux propri\xE9taires et aux administrateurs."
            },
            project: {
              term: "Projet",
              text: "Liste des projets que vous g\xE9rez (code et nom). Choisissez celui auquel l'espace est li\xE9. Si vous n'en g\xE9rez aucun, un message bleu vous l'explique."
            },
            name: {
              term: "Nom de l'espace",
              text: "Obligatoire, 200 caract\xE8res au plus. C'est le nom que verront tous les participants."
            },
            submit: {
              term: "Cr\xE9er l'espace",
              text: "Cr\xE9e l'espace et l'ouvre aussit\xF4t. \xABAnnuler\xA0\xBB ferme la fen\xEAtre sans rien cr\xE9er."
            },
            planLimit: {
              term: "Votre offre ne permet pas d'h\xE9berger davantage d'espaces partag\xE9s",
              text: "Message affich\xE9 quand votre offre a atteint sa limite d'espaces. Contactez le propri\xE9taire du compte pour passer \xE0 une offre sup\xE9rieure."
            }
          }
        }
      }
    },
    spaceInvitations: {
      title: "Invitations \xE0 des espaces",
      intro: "Cette page r\xE9unit les invitations qui attendent votre r\xE9ponse\xA0: celles qui vous sont adress\xE9es, et les demandes de partenariat adress\xE9es \xE0 une organisation que vous administrez. Les e-mails d'invitation m\xE8nent ici.",
      sections: {
        header: {
          title: "En-t\xEAte de la page",
          items: {
            title: {
              term: "Invitations \xE0 des espaces",
              text: "Le titre de la page, suivi d'une phrase qui dit ce que vous voyez\xA0: les invitations qui attendent votre r\xE9ponse, \xE0 vous-m\xEAme ou \xE0 une organisation que vous administrez."
            }
          }
        },
        card: {
          title: "Une invitation",
          items: {
            sentence: {
              term: "Phrase d'invitation",
              text: "Dit qui vous invite, \xE0 quel espace, et quelle organisation l'h\xE9berge. Le logo de l'organisation h\xF4te figure \xE0 gauche."
            },
            kind: {
              term: "Demande de partenariat",
              text: "Pastille du type d'invitation\xA0: \xABDemande de partenariat\xA0\xBB (pour votre organisation), \xABInvitation nominative\xA0\xBB (pour vous) ou \xABInvit\xE9\xA0\xBB (acc\xE8s limit\xE9 et temporaire)."
            },
            scope: {
              term: "Tout l'espace",
              text: "Ce que l'acc\xE8s couvre\xA0: tout l'espace, ou \xABDossiers\xA0: 2 \xB7 Canaux\xA0: 1\xA0\xBB quand l'acc\xE8s se limite \xE0 des dossiers et \xE0 des canaux choisis."
            },
            rights: {
              term: "Droits\xA0: \u2026",
              text: "Ce que vous pourrez faire\xA0: \xABLecture seule\xA0\xBB, \xABLecture et \xE9criture\xA0\xBB ou \xABLecture, \xE9criture et visa\xA0\xBB."
            },
            memberCap: {
              term: "Jusqu'\xE0 \u2026 personnes",
              text: "Pour une demande de partenariat\xA0: le nombre maximum de personnes que votre organisation pourra ajouter \xE0 l'espace."
            },
            dates: {
              term: "\xC0 r\xE9pondre avant le \u2026",
              text: "Date limite de r\xE9ponse. Si elle est indiqu\xE9e, \xABJusqu'au \u2026\xA0\xBB donne aussi la date de fin de l'acc\xE8s."
            }
          }
        },
        answers: {
          title: "R\xE9pondre \xE0 une invitation",
          items: {
            accept: {
              term: "Accepter",
              text: "Pour une invitation \xE0 vous\xA0: vous rejoignez l'espace et il s'ouvre. Pour une demande de partenariat\xA0: votre organisation devient partenaire, puis vous choisissez les personnes qui y acc\xE8dent."
            },
            decline: {
              term: "Refuser",
              text: "Ouvre une fen\xEAtre de confirmation. L'h\xF4te pourra vous inviter de nouveau plus tard."
            },
            declineDialog: {
              term: "Refuser l'invitation \xE0 l'espace \u2026\xA0?",
              text: "Confirmez avec \xABRefuser\xA0\xBB ou revenez en arri\xE8re avec \xABAnnuler\xA0\xBB. Un message confirme ensuite le refus."
            }
          }
        },
        states: {
          title: "Quand il n'y a rien \xE0 afficher",
          items: {
            empty: {
              term: "Aucune invitation en attente",
              text: "Message affich\xE9 quand aucune invitation n'attend votre r\xE9ponse. Le bouton \xABVoir mes espaces partag\xE9s\xA0\xBB m\xE8ne \xE0 la liste de vos espaces."
            },
            loadFailed: {
              term: "Impossible de charger les invitations",
              text: "Message rouge affich\xE9 si la liste ne s'est pas charg\xE9e. Utilisez \xABR\xE9essayer\xA0\xBB apr\xE8s avoir v\xE9rifi\xE9 votre connexion."
            }
          }
        }
      }
    },
    space: {
      documents: {
        title: "Documents",
        intro: "L'onglet Documents d'un espace partag\xE9\xA0: les dossiers de l'espace, les fichiers qu'ils contiennent et leurs versions. Il sert \xE0 d\xE9poser, classer et consulter les documents que l'organisation h\xF4te et ses partenaires \xE9changent.",
        sections: {
          frame: {
            title: "Cadre de l'espace",
            items: {
              banner: {
                term: "Espace externe h\xE9berg\xE9 par\u2026",
                text: "Bandeau permanent affich\xE9 quand l'espace appartient \xE0 une autre organisation\xA0: il rappelle que son contenu suit les r\xE8gles de cette organisation."
              },
              summary: {
                term: "H\xE9berg\xE9 par",
                text: "Bande sous le titre\xA0: l'organisation qui h\xE9berge l'espace, son type (par exemple \xABEspace partag\xE9\xA0\xBB ou \xABGroupe de travail\xA0\xBB), la pastille \xABFerm\xE9\xA0\xBB quand l'espace est ferm\xE9 et, dans un espace externe, votre acc\xE8s\xA0: la fa\xE7on dont vous \xEAtes entr\xE9, vos droits et la date de fin."
              },
              guestNotice: {
                term: "Votre acc\xE8s invit\xE9 se termine le \u2026",
                text: "Bandeau r\xE9serv\xE9 aux invit\xE9s\xA0: il donne la date de fin de votre acc\xE8s. Il passe en avertissement dans les 14 derniers jours\xA0: demandez alors une prolongation \xE0 la personne qui vous a invit\xE9."
              },
              tabs: {
                term: "Onglets",
                text: "La barre d'onglets de l'espace. Seuls les onglets que votre acc\xE8s permet d'ouvrir sont affich\xE9s. Le fil d'Ariane au-dessus (\xABEspaces partag\xE9s\xA0\xBB) ram\xE8ne \xE0 la liste de vos espaces."
              },
              unavailable: {
                term: "Espace introuvable",
                text: "Affich\xE9 si l'espace n'existe pas ou si vous n'y avez plus acc\xE8s\xA0: demandez une nouvelle invitation. \xABImpossible de charger l'espace\xA0\xBB indique un probl\xE8me de connexion (bouton \xABR\xE9essayer\xA0\xBB), et \xABRien \xE0 afficher pour le moment\xA0\xBB un acc\xE8s qui ne donne encore aucun contenu."
              }
            }
          },
          folders: {
            title: "Dossiers",
            items: {
              tree: {
                term: "Dossiers du projet",
                text: "L'arbre des dossiers, \xE0 gauche. \xABTous les dossiers\xA0\xBB est la racine. Cliquez sur un dossier pour l'ouvrir\xA0; les sous-dossiers se d\xE9plient au fur et \xE0 mesure."
              },
              breadcrumb: {
                term: "Chemin du dossier",
                text: "Les dossiers qui m\xE8nent au dossier ouvert\xA0; cliquez sur l'un d'eux pour y revenir. Un \xAB\u2026\xA0\xBB remplace un dossier auquel vous n'avez pas acc\xE8s."
              },
              customRights: {
                term: "Droits personnalis\xE9s",
                text: "Pastille avec un cadenas\xA0: ce dossier a ses propres r\xE8gles d'acc\xE8s, diff\xE9rentes de celles de l'espace."
              },
              newFolder: {
                term: "Nouveau dossier",
                text: "Cr\xE9e un dossier dans le dossier ouvert (ou \xE0 la racine). Visible seulement si vous avez le droit d'\xE9crire \xE0 cet endroit."
              },
              menu: {
                term: "Autres actions",
                text: "Menu (trois points) des responsables du dossier\xA0: \xABRenommer\u2026\xA0\xBB, \xABD\xE9placer\u2026\xA0\xBB, \xABAutorisations\u2026\xA0\xBB (absent dans l'espace d'une autre organisation) et \xABSupprimer\xA0\xBB. Supprimer envoie le dossier \xE0 la corbeille."
              },
              empty: {
                term: "Aucun dossier pour l'instant",
                text: "Message affich\xE9 quand l'espace n'a encore aucun dossier visible pour vous. Il propose \xABNouveau dossier\xA0\xBB si vous pouvez en cr\xE9er\xA0; sinon demandez \xE0 un responsable. Dans un dossier vide, \xABAucun sous-dossier\xA0\xBB le confirme."
              }
            }
          },
          upload: {
            title: "Ajout de fichiers",
            items: {
              zone: {
                term: "Glissez-d\xE9posez des fichiers ou des dossiers ici",
                text: "Zone d'ajout, visible dans un dossier o\xF9 vous pouvez \xE9crire. D\xE9posez-y des fichiers ou un dossier entier\xA0: tout est ajout\xE9 dans le dossier ouvert. La taille maximale par fichier est indiqu\xE9e sous le titre."
              },
              buttons: {
                term: "Ajouter des fichiers",
                text: "Ouvre le s\xE9lecteur de fichiers de votre ordinateur. \xABAjouter un dossier\xA0\xBB fait de m\xEAme pour un dossier entier. Ces boutons sont inactifs si le compte de l'h\xF4te est en lecture seule."
              },
              infoDialog: {
                term: "Informations du document",
                text: "Fen\xEAtre qui s'ouvre avant l'envoi\xA0: Discipline, Phase, Type de document, Zone, \xC9chelle et Titre de chaque document. Ces informations servent \xE0 classer le document et \xE0 composer son code (\xABCode pr\xE9vu\xA0\xBB)."
              },
              skip: {
                term: "Ajouter sans informations",
                text: "Envoie les fichiers sans remplir la fen\xEAtre. Vous pourrez compl\xE9ter les informations plus tard."
              },
              statuses: {
                term: "Envoi en cours",
                text: "Chaque fichier a sa ligne avec sa progression, puis son r\xE9sultat\xA0: \xABV\xE9rification antivirus en cours\xA0\xBB, \xABAjout\xE9 au dossier\xA0\xBB, \xABRefus\xE9\xA0\xBB (avec la raison) ou \xAB\xC9chec de l'envoi\xA0\xBB."
              },
              rowButtons: {
                term: "Annuler",
                text: "Sur une ligne d'envoi\xA0: \xABAnnuler\xA0\xBB arr\xEAte l'envoi, \xABR\xE9essayer\xA0\xBB le relance apr\xE8s un \xE9chec, \xABRetirer\xA0\xBB efface la ligne de la liste."
              }
            }
          },
          list: {
            title: "Documents du dossier",
            items: {
              search: {
                term: "Rechercher un document",
                text: "Champ de recherche (\xABCode ou titre\xA0\xBB). La liste se met \xE0 jour quand vous arr\xEAtez de taper."
              },
              filters: {
                term: "Discipline",
                text: "Trois filtres en forme de pastilles\xA0: Discipline, Phase et Type de document. Choisissez une valeur dans le menu\xA0; \xABTous\xA0\xBB retire le filtre. \xABEffacer les filtres\xA0\xBB les retire tous."
              },
              columns: {
                term: "Code, Titre, Indice\u2026",
                text: "Colonnes du tableau\xA0: Code, Titre, Indice (lettre de version d'un document\xA0: A, B, C\u2026), Discipline, Phase, Statut, Visa, Modifi\xE9 le et Organisation auteur (\xABPartenaire\xA0\xBB si elle n'est pas la v\xF4tre). Code, Titre et Modifi\xE9 le se trient en cliquant sur leur en-t\xEAte."
              },
              selection: {
                term: "Tout d\xE9s\xE9lectionner",
                text: "Cochez des lignes pour afficher la barre de s\xE9lection\xA0: nombre de documents choisis, \xABD\xE9placer vers\u2026\xA0\xBB, \xABSupprimer\xA0\xBB (seulement si vous pouvez le faire sur chacun) et \xABTout d\xE9s\xE9lectionner\xA0\xBB."
              },
              more: {
                term: "Afficher plus de documents",
                text: "La liste s'affiche par pages. Ce bouton charge la suite\xA0; le nombre de documents affich\xE9s est \xE9crit \xE0 c\xF4t\xE9."
              },
              empty: {
                term: "Aucun document pour l'instant",
                text: "Message d'un dossier vide. Il invite \xE0 d\xE9poser des fichiers, ou dit que les documents appara\xEEtront ici si vous ne pouvez que lire. \xABAucun document ne correspond\xA0\xBB appara\xEEt quand un filtre ne trouve rien."
              }
            }
          },
          statuses: {
            title: "Statuts d'un document",
            items: {
              uploading: {
                term: "Envoi en cours",
                text: "Le fichier est en train d'arriver sur le serveur."
              },
              scanning: {
                term: "V\xE9rification antivirus",
                text: "Le fichier est contr\xF4l\xE9 par l'antivirus. Il devient consultable une fois la v\xE9rification termin\xE9e."
              },
              available: {
                term: "Disponible",
                text: "Le fichier est v\xE9rifi\xE9\xA0: vous pouvez l'ouvrir."
              },
              rejected: {
                term: "Refus\xE9",
                text: "Le fichier a \xE9t\xE9 refus\xE9 (virus, type non accept\xE9, taille\u2026). La raison est \xE9crite dans l'historique des versions."
              },
              inApproval: {
                term: "En approbation",
                text: "Colonne \xABVisa\xA0\xBB\xA0: un circuit d'approbation est en cours. Tant qu'il n'est pas termin\xE9, le document ne peut pas recevoir de nouvelle version."
              }
            }
          },
          panel: {
            title: "Panneau du document",
            items: {
              open: {
                term: "Ouvrir",
                text: "Cliquez sur une ligne pour ouvrir le panneau \xE0 droite (\xC9chap le ferme). \xABOuvrir\xA0\xBB affiche le document dans la visionneuse\xA0; ce bouton n'existe pas dans l'espace d'une autre organisation."
              },
              details: {
                term: "D\xE9tails",
                text: "Code (non modifiable), Titre, Indice, Discipline, Phase, Type de document, Zone, \xC9chelle, Statut, Organisation auteur, Modifi\xE9 le et Livrables li\xE9s. Un message bleu indique ce qui manque pour attribuer le code."
              },
              edit: {
                term: "Modifier",
                text: "Ouvre le formulaire de modification du titre et des informations. Visible seulement si vous avez le droit de modifier ce document."
              },
              approval: {
                term: "Visa",
                text: "Les circuits de visa du document, avec leurs \xE9tapes. \xABDemander le visa\xA0\xBB lance un circuit\xA0: il est absent dans l'espace d'une autre organisation. VSO veut dire vis\xE9 sans observation, VAO vis\xE9 avec observations, REF refus\xE9."
              },
              versions: {
                term: "Versions",
                text: "L'historique, de la plus r\xE9cente \xE0 la plus ancienne\xA0: indice, raison, auteur et organisation, date, code et empreinte SHA-256 (le bouton de copie la copie en entier). \xABVersion actuelle\xA0\xBB marque la derni\xE8re."
              },
              versionButtons: {
                term: "Nouvelle version",
                text: "Ajoute un fichier comme nouvelle version, avec l'indice suivant. \xABRestaurer\xA0\xBB ajoute une ancienne version comme nouvelle version\xA0: rien n'est effac\xE9. Les deux demandent une raison, et sont absents si un visa est en cours."
              }
            }
          },
          trash: {
            title: "Corbeille",
            items: {
              open: {
                term: "Corbeille",
                text: "Bouton sous l'arbre des dossiers\xA0: il remplace la liste par la corbeille. \xABRetour aux fichiers\xA0\xBB revient aux dossiers."
              },
              intro: {
                term: "\xC9l\xE9ments supprim\xE9s",
                text: "Les dossiers et documents supprim\xE9s y restent un nombre de jours indiqu\xE9 en haut de la page, puis sont effac\xE9s pour de bon. Les responsables voient tout\xA0; les autres voient ce qu'ils ont supprim\xE9."
              },
              restore: {
                term: "Restaurer",
                text: "Remet l'\xE9l\xE9ment \xE0 sa place. Si son dossier d'origine est aussi dans la corbeille, restaurez d'abord ce dossier."
              },
              purge: {
                term: "Supprimer d\xE9finitivement",
                text: "Efface l'\xE9l\xE9ment, ses versions et ses fichiers, apr\xE8s confirmation. Cette action ne peut pas \xEAtre annul\xE9e."
              },
              empty: {
                term: "La corbeille est vide",
                text: "Message affich\xE9 quand rien n'a \xE9t\xE9 supprim\xE9."
              }
            }
          }
        }
      },
      chat: {
        title: "Conversations",
        intro: "L'onglet Conversations d'un espace partag\xE9\xA0: les canaux de l'espace et leurs messages. Il sert \xE0 \xE9changer avec les personnes de l'organisation h\xF4te et des organisations partenaires.",
        sections: {
          frame: {
            title: "Cadre de l'espace",
            items: {
              banner: {
                term: "Espace externe h\xE9berg\xE9 par\u2026",
                text: "Bandeau permanent affich\xE9 quand l'espace appartient \xE0 une autre organisation\xA0: il rappelle que son contenu suit les r\xE8gles de cette organisation."
              },
              summary: {
                term: "H\xE9berg\xE9 par",
                text: "Bande sous le titre\xA0: l'organisation qui h\xE9berge l'espace, son type, la pastille \xABFerm\xE9\xA0\xBB quand l'espace est ferm\xE9 et, dans un espace externe, votre acc\xE8s\xA0: la fa\xE7on dont vous \xEAtes entr\xE9, vos droits et la date de fin."
              },
              guestNotice: {
                term: "Votre acc\xE8s invit\xE9 se termine le \u2026",
                text: "Bandeau r\xE9serv\xE9 aux invit\xE9s\xA0: il donne la date de fin de votre acc\xE8s. Il passe en avertissement dans les 14 derniers jours."
              },
              tabs: {
                term: "Onglets",
                text: "La barre d'onglets de l'espace. Vous \xEAtes dans l'onglet \xABConversations\xA0\xBB\xA0; seuls les onglets que votre acc\xE8s permet d'ouvrir sont affich\xE9s."
              }
            }
          },
          channels: {
            title: "Canaux",
            items: {
              list: {
                term: "Canaux",
                text: "La liste des canaux de l'espace que vous pouvez voir, \xE0 gauche. Cliquez sur un canal pour lire ses messages\xA0; le canal ouvert est mis en \xE9vidence."
              },
              unread: {
                term: "Messages non lus",
                text: "Une pastille avec un nombre appara\xEEt \xE0 c\xF4t\xE9 d'un canal qui contient des messages que vous n'avez pas lus, et son nom passe en gras."
              },
              empty: {
                term: "Aucun canal pour le moment",
                text: "Message affich\xE9 tant que l'espace n'a aucun canal visible pour vous."
              },
              pick: {
                term: "Choisissez un canal",
                text: "Invite \xE0 s\xE9lectionner un canal dans la liste pour lire et \xE9crire des messages."
              },
              loadFailed: {
                term: "Impossible de charger les canaux",
                text: "Affich\xE9 si la liste ne s'est pas charg\xE9e. Utilisez \xABR\xE9essayer\xA0\xBB dans un instant."
              }
            }
          },
          conversation: {
            title: "Conversation",
            items: {
              title: {
                term: "Nom du canal",
                text: "Le nom du canal ouvert, avec son sujet en dessous quand il en a un."
              },
              pins: {
                term: "Messages \xE9pingl\xE9s",
                text: "Ouvre le panneau des messages \xE9pingl\xE9s du canal. Le nombre entre parenth\xE8ses est celui des messages \xE9pingl\xE9s."
              },
              messages: {
                term: "Messages",
                text: "Les messages, le plus r\xE9cent en bas, s\xE9par\xE9s par jour (\xABAujourd'hui\xA0\xBB, \xABHier\xA0\xBB ou la date). Chaque message montre son auteur, l'heure, et \xABmodifi\xE9\xA0\xBB s'il a \xE9t\xE9 corrig\xE9. Un message supprim\xE9 est remplac\xE9 par \xABCe message a \xE9t\xE9 supprim\xE9\xA0\xBB."
              },
              external: {
                term: "Externe \xB7 \u2026",
                text: "Pastille jaune \xE0 c\xF4t\xE9 du nom d'une personne d'une autre organisation, avec le nom de cette organisation."
              },
              pinned: {
                term: "\xC9pingl\xE9",
                text: "Marque un message \xE9pingl\xE9\xA0: on le retrouve aussi dans \xAB\xA0Messages \xE9pingl\xE9s\xA0\xBB."
              },
              jump: {
                term: "Derniers messages",
                text: "Bouton qui appara\xEEt quand vous avez remont\xE9 la conversation\xA0: il ram\xE8ne en bas. \xABChargement des messages pr\xE9c\xE9dents\u2026\xA0\xBB s'affiche pendant que les anciens messages arrivent."
              },
              empty: {
                term: "Aucun message pour le moment",
                text: "Message d'un canal vide. \xC9crivez le premier message si vous avez le droit d'\xE9crire."
              }
            }
          },
          actions: {
            title: "Actions sur un message",
            items: {
              toolbar: {
                term: "Actions sur le message de \u2026",
                text: "Une petite barre appara\xEEt quand vous survolez un message (toujours visible sur t\xE9l\xE9phone)\xA0: r\xE9action, r\xE9ponse dans un fil, \xE9pinglage, modification et suppression."
              },
              react: {
                term: "Ajouter une r\xE9action",
                text: "Ajoute un emoji sous le message pour r\xE9agir sans \xE9crire de r\xE9ponse."
              },
              thread: {
                term: "R\xE9pondre dans un fil",
                text: "Ouvre le fil de discussion du message dans un panneau \xE0 droite, pour r\xE9pondre sans encombrer le canal. Pas disponible pour un invit\xE9 sans organisation."
              },
              pin: {
                term: "\xC9pingler le message",
                text: "\xC9pingle le message pour le retrouver dans \xABMessages \xE9pingl\xE9s\xA0\xBB. Le m\xEAme bouton devient \xABD\xE9s\xE9pingler le message\xA0\xBB. Un canal en compte 50 au plus. Absent dans un canal en lecture seule."
              },
              editDelete: {
                term: "Modifier le message",
                text: "Vous pouvez modifier vos propres messages. \xABSupprimer le message\xA0\xBB est offert pour les v\xF4tres et, aux mod\xE9rateurs, pour ceux des autres\xA0: il demande une confirmation et la suppression est d\xE9finitive."
              },
              sending: {
                term: "Message non envoy\xE9.",
                text: "Un message en cours d'envoi affiche \xABEnvoi en cours\u2026\xA0\xBB. S'il \xE9choue\xA0: \xABR\xE9essayer\xA0\xBB le renvoie, \xABReprendre le texte\xA0\xBB le remet dans la zone de saisie, \xABSupprimer\xA0\xBB l'abandonne."
              }
            }
          },
          composer: {
            title: "\xC9crire un message",
            items: {
              box: {
                term: "\xC9crire un message",
                text: "La zone de saisie en bas. Entr\xE9e envoie le message, Maj+Entr\xE9e passe \xE0 la ligne et @ permet de mentionner une personne. Le texte non envoy\xE9 est gard\xE9 si vous changez de canal."
              },
              attach: {
                term: "Joindre un fichier",
                text: "Joint un ou plusieurs fichiers au message. Ils sont envoy\xE9s dans le dossier des pi\xE8ces jointes du canal\xA0; attendez la fin de l'envoi avant d'envoyer le message."
              },
              send: {
                term: "Envoyer",
                text: "Envoie le message. Il est gris\xE9 tant que la zone est vide."
              },
              typing: {
                term: "Quelqu'un est en train d'\xE9crire\u2026",
                text: "Une ligne au-dessus de la zone de saisie dit qui est en train d'\xE9crire."
              },
              blocked: {
                term: "Ce canal est archiv\xE9\xA0: vous pouvez le lire, mais plus y \xE9crire.",
                text: "Remplace la zone de saisie quand le canal est archiv\xE9. \xABVous pouvez lire cette conversation, mais pas y \xE9crire\xA0\xBB s'affiche quand votre acc\xE8s est en lecture seule."
              }
            }
          },
          attachments: {
            title: "Fichiers joints et panneaux",
            items: {
              cards: {
                term: "Fichiers joints au message de \u2026",
                text: "Sous le message, une carte par fichier avec son \xE9tat (\xABEnvoi en cours\xA0\xBB, \xABV\xE9rification antivirus en cours\xA0\xBB, \xABDisponible\xA0\xBB ou refus\xE9)."
              },
              openDownload: {
                term: "T\xE9l\xE9charger",
                text: "\xABOuvrir\xA0\xBB affiche le fichier\xA0; \xABT\xE9l\xE9charger\xA0\xBB l'enregistre sur votre ordinateur. Si l'espace interdit le t\xE9l\xE9chargement, un message l'indique."
              },
              noAccess: {
                term: "Vous n'avez pas acc\xE8s \xE0 ce fichier",
                text: "Le fichier est rang\xE9 dans un dossier que vous ne pouvez pas consulter. Demandez l'acc\xE8s \xE0 la personne qui l'a envoy\xE9."
              },
              threadPanel: {
                term: "Fil de discussion",
                text: "Panneau \xE0 droite\xA0: le message d'origine, ses r\xE9ponses, et une zone \xABR\xE9pondre dans le fil\xA0\xBB avec le bouton \xABR\xE9pondre\xA0\xBB."
              },
              pinsPanel: {
                term: "Messages \xE9pingl\xE9s",
                text: "Panneau \xE0 droite\xA0: la liste des messages \xE9pingl\xE9s, avec \xABAfficher dans la conversation\xA0\xBB,\xABOuvrir le fil\xA0\xBB et \xABD\xE9s\xE9pingler le message\xA0\xBB."
              }
            }
          }
        }
      },
      calendar: {
        title: "Calendrier",
        intro: "L'onglet Calendrier d'un espace partag\xE9. Il est annonc\xE9 mais n'est pas encore disponible\xA0: la page affiche pour l'instant un message \xABbient\xF4t\xA0\xBB.",
        sections: {
          header: {
            title: "En-t\xEAte de l'espace",
            items: {
              banner: {
                term: "Espace externe h\xE9berg\xE9 par\u2026",
                text: "Bandeau permanent affich\xE9 quand l'espace appartient \xE0 une autre organisation\xA0: il rappelle que son contenu suit les r\xE8gles de cette organisation."
              },
              summary: {
                term: "H\xE9berg\xE9 par",
                text: "Bande sous le titre\xA0: l'organisation qui h\xE9berge l'espace, son type, la pastille \xABFerm\xE9\xA0\xBB quand l'espace est ferm\xE9 et, dans un espace externe, votre acc\xE8s\xA0: la fa\xE7on dont vous \xEAtes entr\xE9, vos droits et la date de fin."
              }
            }
          },
          tabs: {
            title: "Onglets",
            items: {
              tabList: {
                term: "Onglets",
                text: "La barre d'onglets de l'espace. Seuls les onglets que votre acc\xE8s permet d'ouvrir sont affich\xE9s. Le fil d'Ariane au-dessus (\xABEspaces partag\xE9s\xA0\xBB) ram\xE8ne \xE0 la liste de vos espaces."
              },
              thisTab: {
                term: "Calendrier",
                text: "L'onglet sur lequel vous \xEAtes. Il n'appara\xEEt que si votre acc\xE8s \xE0 l'espace le permet."
              }
            }
          },
          comingSoon: {
            title: "Contenu de l'onglet",
            items: {
              title: {
                term: "Le calendrier de l'espace arrive bient\xF4t",
                text: "Titre du message affich\xE9 \xE0 la place du calendrier. Il n'y a pour l'instant rien \xE0 saisir ni \xE0 cliquer dans cet onglet."
              },
              description: {
                term: "Les \xE9v\xE9nements et les rendez-vous de l'espace s'afficheront ici.",
                text: "Ce que l'onglet contiendra \xE0 terme\xA0: les \xE9v\xE9nements et les rendez-vous de l'espace."
              }
            }
          }
        }
      },
      meetings: {
        title: "R\xE9unions",
        intro: "L'onglet R\xE9unions d'un espace partag\xE9. Il est annonc\xE9 mais n'est pas encore disponible\xA0: la page affiche pour l'instant un message \xABbient\xF4t\xA0\xBB.",
        sections: {
          header: {
            title: "En-t\xEAte de l'espace",
            items: {
              banner: {
                term: "Espace externe h\xE9berg\xE9 par\u2026",
                text: "Bandeau permanent affich\xE9 quand l'espace appartient \xE0 une autre organisation\xA0: il rappelle que son contenu suit les r\xE8gles de cette organisation."
              },
              summary: {
                term: "H\xE9berg\xE9 par",
                text: "Bande sous le titre\xA0: l'organisation qui h\xE9berge l'espace, son type, la pastille \xABFerm\xE9\xA0\xBB quand l'espace est ferm\xE9 et, dans un espace externe, votre acc\xE8s\xA0: la fa\xE7on dont vous \xEAtes entr\xE9, vos droits et la date de fin."
              }
            }
          },
          tabs: {
            title: "Onglets",
            items: {
              tabList: {
                term: "Onglets",
                text: "La barre d'onglets de l'espace. Seuls les onglets que votre acc\xE8s permet d'ouvrir sont affich\xE9s. Le fil d'Ariane au-dessus (\xABEspaces partag\xE9s\xA0\xBB) ram\xE8ne \xE0 la liste de vos espaces."
              },
              thisTab: {
                term: "R\xE9unions",
                text: "L'onglet sur lequel vous \xEAtes. Il n'appara\xEEt que si votre acc\xE8s \xE0 l'espace le permet."
              }
            }
          },
          comingSoon: {
            title: "Contenu de l'onglet",
            items: {
              title: {
                term: "Les r\xE9unions de l'espace arrivent bient\xF4t",
                text: "Titre du message affich\xE9 \xE0 la place des r\xE9unions. Il n'y a pour l'instant rien \xE0 saisir ni \xE0 cliquer dans cet onglet."
              },
              description: {
                term: "Vous pourrez y lancer et rejoindre les r\xE9unions de l'espace.",
                text: "Ce que l'onglet permettra \xE0 terme\xA0: lancer une r\xE9union de l'espace et rejoindre celles qui sont en cours."
              }
            }
          }
        }
      },
      people: {
        title: "Personnes",
        intro: "L'onglet Personnes d'un espace partag\xE9\xA0: toutes les personnes qui y ont acc\xE8s, de l'organisation h\xF4te comme des organisations partenaires, avec la fa\xE7on dont chacune est entr\xE9e.",
        sections: {
          frame: {
            title: "Cadre de l'espace",
            items: {
              banner: {
                term: "Espace externe h\xE9berg\xE9 par\u2026",
                text: "Bandeau permanent affich\xE9 quand l'espace appartient \xE0 une autre organisation\xA0: il rappelle que son contenu suit les r\xE8gles de cette organisation."
              },
              summary: {
                term: "H\xE9berg\xE9 par",
                text: "Bande sous le titre\xA0: l'organisation qui h\xE9berge l'espace, son type, la pastille \xABFerm\xE9\xA0\xBB quand l'espace est ferm\xE9 et, dans un espace externe, votre acc\xE8s\xA0: la fa\xE7on dont vous \xEAtes entr\xE9, vos droits et la date de fin."
              },
              guestNotice: {
                term: "Votre acc\xE8s invit\xE9 se termine le \u2026",
                text: "Bandeau r\xE9serv\xE9 aux invit\xE9s\xA0: il donne la date de fin de votre acc\xE8s. Il passe en avertissement dans les 14 derniers jours."
              },
              tabs: {
                term: "Onglets",
                text: "La barre d'onglets de l'espace. Vous \xEAtes dans l'onglet \xABPersonnes\xA0\xBB\xA0; seuls les onglets que votre acc\xE8s permet d'ouvrir sont affich\xE9s."
              }
            }
          },
          list: {
            title: "Personnes ayant acc\xE8s",
            items: {
              heading: {
                term: "Personnes ayant acc\xE8s",
                text: "Toutes les personnes qui acc\xE8dent \xE0 l'espace, avec l'organisation au nom de laquelle elles y sont. Pour inviter quelqu'un, passez par l'onglet \xABOrganisations partenaires\xA0\xBB."
              },
              name: {
                term: "Nom de la personne",
                text: "Une ligne par personne, avec une pastille qui dit comment elle est entr\xE9e\xA0: \xABMembre de l'h\xF4te\xA0\xBB, \xABD\xE9l\xE9gu\xE9 partenaire\xA0\xBB, \xABInvit\xE9 nomm\xE9\xA0\xBB ou \xABInvit\xE9\xA0\xBB."
              },
              organisation: {
                term: "Organisation\xA0: \u2026",
                text: "L'organisation au nom de laquelle la personne acc\xE8de \xE0 l'espace."
              },
              scope: {
                term: "Tout l'espace",
                text: "Ce que son acc\xE8s couvre\xA0: tout l'espace, ou \xABDossiers\xA0: 2 \xB7 Canaux\xA0: 1\xA0\xBB quand il est limit\xE9 \xE0 des dossiers et \xE0 des canaux choisis."
              },
              rights: {
                term: "Droits\xA0: \u2026",
                text: "\xABLecture seule\xA0\xBB, \xABLecture et \xE9criture\xA0\xBB ou \xABLecture, \xE9criture et visa\xA0\xBB, suivi de \xABJusqu'au \u2026\xA0\xBB ou de \xABSans date de fin\xA0\xBB."
              }
            }
          },
          actions: {
            title: "Actions sur une personne",
            items: {
              extend: {
                term: "Prolonger de 90 jours",
                text: "Pour un invit\xE9 seulement, et pour les personnes qui g\xE8rent l'espace\xA0: repousse la fin de son acc\xE8s de 90 jours. Un message confirme la nouvelle date."
              },
              remove: {
                term: "Retirer",
                text: "Retire la personne de l'espace apr\xE8s une confirmation (\xABRetirer \u2026 de l'espace\xA0?\xA0\xBB)\xA0: son acc\xE8s prend fin imm\xE9diatement. Le bouton n'appara\xEEt que si vous avez le droit de la retirer, et jamais dans un espace ferm\xE9."
              }
            }
          },
          states: {
            title: "Quand il n'y a rien \xE0 afficher",
            items: {
              empty: {
                term: "Personne d'autre n'a acc\xE8s \xE0 cet espace",
                text: "Message affich\xE9 tant que personne d'autre n'est entr\xE9\xA0: les membres de l'h\xF4te, les d\xE9l\xE9gu\xE9s des partenaires et les invit\xE9s appara\xEEtront ici."
              },
              loadFailed: {
                term: "Impossible de charger les personnes",
                text: "Message rouge affich\xE9 si la liste ne s'est pas charg\xE9e. Utilisez \xABR\xE9essayer\xA0\xBB apr\xE8s avoir v\xE9rifi\xE9 votre connexion."
              }
            }
          }
        }
      },
      partners: {
        title: "Organisations partenaires",
        intro: "L'onglet Organisations partenaires d'un espace partag\xE9, r\xE9serv\xE9 aux responsables de l'organisation h\xF4te. Il sert \xE0 partager l'espace avec d'autres organisations, \xE0 inviter des personnes et \xE0 suivre les invitations en attente.",
        sections: {
          frame: {
            title: "Cadre de l'espace",
            items: {
              banner: {
                term: "Espace externe h\xE9berg\xE9 par\u2026",
                text: "Bandeau permanent affich\xE9 quand l'espace appartient \xE0 une autre organisation\xA0: il rappelle que son contenu suit les r\xE8gles de cette organisation."
              },
              summary: {
                term: "H\xE9berg\xE9 par",
                text: "Bande sous le titre\xA0: l'organisation qui h\xE9berge l'espace, son type, la pastille \xABFerm\xE9\xA0\xBB quand l'espace est ferm\xE9 et, dans un espace externe, votre acc\xE8s\xA0: la fa\xE7on dont vous \xEAtes entr\xE9, vos droits et la date de fin."
              },
              tabs: {
                term: "Onglets",
                text: "La barre d'onglets de l'espace. Vous \xEAtes dans l'onglet \xABOrganisations partenaires\xA0\xBB\xA0; seuls les onglets que votre acc\xE8s permet d'ouvrir sont affich\xE9s."
              }
            }
          },
          partnersList: {
            title: "Organisations partenaires",
            items: {
              heading: {
                term: "Organisations partenaires",
                text: "Les organisations avec lesquelles l'espace est partag\xE9, ce qu'elles peuvent atteindre et combien de personnes elles y ont ajout\xE9."
              },
              share: {
                term: "Partager avec une organisation",
                text: "Ouvre la fen\xEAtre d'invitation d'une organisation. Absent dans un espace ferm\xE9."
              },
              status: {
                term: "En attente de r\xE9ponse",
                text: "Pastille d'\xE9tat de l'organisation\xA0: \xABEn attente de r\xE9ponse\xA0\xBB, \xABActif\xA0\xBB, \xABRefus\xE9\xA0\xBB, \xABExpir\xE9\xA0\xBB ou \xABRetir\xE9\xA0\xBB. Les demandes en attente sont affich\xE9es en premier."
              },
              details: {
                term: "Personnes\xA0: x/y",
                text: "Sous le nom\xA0: ce que l'organisation peut atteindre (\xABTout l'espace\xA0\xBB ou des dossiers et canaux choisis), ses droits, le nombre de personnes qu'elle a ajout\xE9es sur le maximum autoris\xE9, et \xABJusqu'au \u2026\xA0\xBB ou \xABSans date de fin\xA0\xBB."
              },
              remove: {
                term: "Retirer",
                text: "Retire l'organisation, ou annule une demande encore en attente, apr\xE8s confirmation. Toutes les personnes de cette organisation perdent imm\xE9diatement leur acc\xE8s\xA0; vous pourrez la r\xE9inviter."
              },
              empty: {
                term: "Aucune organisation partenaire",
                text: "Message affich\xE9 tant que l'espace n'est partag\xE9 avec personne. L'organisation invit\xE9e choisira elle-m\xEAme les personnes qui y acc\xE8dent."
              }
            }
          },
          invitations: {
            title: "Invitations en attente",
            items: {
              heading: {
                term: "Invitations en attente",
                text: "Les personnes invit\xE9es par e-mail qui n'ont pas encore r\xE9pondu."
              },
              invite: {
                term: "Inviter une personne",
                text: "Ouvre la fen\xEAtre d'invitation d'une personne. Absent dans un espace ferm\xE9."
              },
              row: {
                term: "Adresse e-mail et \xE9tat",
                text: "Chaque ligne montre l'adresse invit\xE9e, une pastille d'\xE9tat (\xABEn attente de r\xE9ponse\xA0\xBB ou \xABEn attente de l'approbation de son organisation\xA0\xBB) et le type d'invitation (\xABPersonne nomm\xE9e\xA0\xBB ou \xABInvit\xE9\xA0\xBB)."
              },
              details: {
                term: "\xC0 r\xE9pondre avant le \u2026",
                text: "Ce que l'acc\xE8s couvre, les droits, et la date limite de r\xE9ponse de la personne invit\xE9e."
              },
              cancel: {
                term: "Annuler",
                text: "Annule l'invitation apr\xE8s confirmation\xA0: la personne ne peut plus utiliser le lien re\xE7u. Vous pourrez l'inviter de nouveau."
              },
              empty: {
                term: "Aucune invitation en attente",
                text: "Message affich\xE9 quand aucune invitation n'attend de r\xE9ponse."
              }
            }
          },
          shareDialog: {
            title: "Fen\xEAtre \xABPartager avec une organisation\xA0\xBB",
            items: {
              taxId: {
                term: "Matricule fiscal de l'organisation",
                text: "Saisissez le matricule fiscal. Le nom de l'organisation trouv\xE9e s'affiche pour que vous v\xE9rifiiez que c'est la bonne\xA0; sinon un message dit qu'aucune organisation BatiFlow ne correspond."
              },
              scope: {
                term: "Ce que l'acc\xE8s couvre",
                text: "\xABTout l'espace\xA0\xBB, ou \xABSeulement des dossiers et des canaux choisis\xA0\xBB\xA0: vous cochez alors les dossiers (un dossier choisi donne aussi acc\xE8s \xE0 ses sous-dossiers) et les canaux."
              },
              rights: {
                term: "Droits",
                text: "Lecture (consulter les documents et les conversations), \xC9criture (consulter, ajouter et modifier) ou \xC9criture et visa (en plus, viser les documents)."
              },
              cap: {
                term: "Nombre maximum de personnes",
                text: "Combien de personnes l'organisation peut ajouter \xE0 l'espace, de 1 \xE0 500."
              },
              end: {
                term: "Date de fin (facultatif)",
                text: "Laissez vide\xA0: l'acc\xE8s dure jusqu'\xE0 ce que vous le retiriez."
              },
              submit: {
                term: "Envoyer l'invitation",
                text: "Envoie l'invitation. L'organisation doit l'accepter, puis ses administrateurs choisissent qui acc\xE8de \xE0 l'espace. Votre identit\xE9 peut \xEAtre redemand\xE9e avant l'envoi."
              }
            }
          },
          inviteDialog: {
            title: "Fen\xEAtre \xABInviter une personne\xA0\xBB",
            items: {
              email: {
                term: "Adresse e-mail",
                text: "L'adresse de la personne \xE0 inviter. L'invitation lui est envoy\xE9e\xA0; l'adresse n'appara\xEEt jamais dans le lien."
              },
              kind: {
                term: "Type d'invitation",
                text: "\xABPersonne nomm\xE9e\xA0\xBB\xA0: une personne d'une autre organisation, avec l'acc\xE8s et la date de fin que vous choisissez\xA0; son organisation peut devoir l'approuver. \xABInvit\xE9\xA0\xBB\xA0: une personne sans compte BatiFlow, limit\xE9e \xE0 des dossiers ou des canaux choisis."
              },
              scope: {
                term: "Ce que l'acc\xE8s couvre",
                text: "Comme pour une organisation. Un invit\xE9 n'a jamais \xABTout l'espace\xA0\xBB\xA0: choisissez au moins un dossier ou un canal."
              },
              rights: {
                term: "Droits",
                text: "Lecture, \xC9criture ou \xC9criture et visa, comme pour une organisation."
              },
              end: {
                term: "Date de fin (facultatif)",
                text: "Pour une personne nomm\xE9e seulement. Un invit\xE9 garde son acc\xE8s 90 jours\xA0; vous pourrez ensuite le prolonger de 90 jours depuis l'onglet \xABPersonnes\xA0\xBB."
              },
              submit: {
                term: "Envoyer l'invitation",
                text: "Envoie l'invitation, ou l'enregistre en attendant l'approbation de l'organisation de la personne. Si votre offre ne permet plus d'inviter d'invit\xE9s, un message l'explique."
              }
            }
          }
        }
      },
      delegates: {
        title: "Mes d\xE9l\xE9gu\xE9s",
        intro: "L'onglet Mes d\xE9l\xE9gu\xE9s d'un espace partag\xE9, r\xE9serv\xE9 \xE0 l'administrateur d'une organisation partenaire. Il sert \xE0 choisir, parmi les membres de votre organisation, qui acc\xE8de \xE0 l'espace, dans les limites de votre partenariat.",
        sections: {
          frame: {
            title: "Cadre de l'espace",
            items: {
              banner: {
                term: "Espace externe h\xE9berg\xE9 par\u2026",
                text: "Bandeau permanent affich\xE9 quand l'espace appartient \xE0 une autre organisation\xA0: il rappelle que son contenu suit les r\xE8gles de cette organisation."
              },
              summary: {
                term: "H\xE9berg\xE9 par",
                text: "Bande sous le titre\xA0: l'organisation qui h\xE9berge l'espace, son type, la pastille \xABFerm\xE9\xA0\xBB quand l'espace est ferm\xE9 et votre acc\xE8s\xA0: la fa\xE7on dont vous \xEAtes entr\xE9, vos droits et la date de fin."
              },
              tabs: {
                term: "Onglets",
                text: "La barre d'onglets de l'espace. Vous \xEAtes dans l'onglet \xABMes d\xE9l\xE9gu\xE9s\xA0\xBB\xA0; seuls les onglets que votre acc\xE8s permet d'ouvrir sont affich\xE9s."
              }
            }
          },
          list: {
            title: "G\xE9rer mes d\xE9l\xE9gu\xE9s",
            items: {
              heading: {
                term: "G\xE9rer mes d\xE9l\xE9gu\xE9s",
                text: "Les personnes de votre organisation qui acc\xE8dent \xE0 cet espace. Vous choisissez qui, dans ce que votre partenariat permet."
              },
              usage: {
                term: "Personnes ajout\xE9es\xA0: x/y",
                text: "Le nombre de personnes que vous avez ajout\xE9es sur le maximum fix\xE9 par votre partenariat."
              },
              capReached: {
                term: "Vous avez atteint le nombre maximum de personnes de votre partenariat",
                text: "Avertissement affich\xE9 quand le maximum est atteint. Retirez un d\xE9l\xE9gu\xE9, ou demandez \xE0 l'organisation h\xF4te d'augmenter la limite."
              },
              add: {
                term: "Ajouter un membre",
                text: "Ouvre la fen\xEAtre d'ajout. Le bouton dispara\xEEt si le partenariat n'est pas actif, si le maximum est atteint ou si l'espace est ferm\xE9."
              },
              row: {
                term: "Nom du d\xE9l\xE9gu\xE9",
                text: "Une ligne par personne\xA0: son nom, une pastille qui dit comment elle est entr\xE9e, ce que son acc\xE8s couvre, ses droits et la date de fin."
              },
              remove: {
                term: "Retirer",
                text: "Retire le d\xE9l\xE9gu\xE9 apr\xE8s confirmation\xA0: son acc\xE8s prend fin imm\xE9diatement. Le bouton n'appara\xEEt que si vous avez le droit de le retirer."
              },
              empty: {
                term: "Aucun d\xE9l\xE9gu\xE9 pour le moment",
                text: "Message affich\xE9 tant que vous n'avez ajout\xE9 personne. Il vous invite \xE0 ajouter des membres de votre organisation."
              }
            }
          },
          addDialog: {
            title: "Fen\xEAtre \xABAjouter un membre\xA0\xBB",
            items: {
              people: {
                term: "Membres de votre organisation",
                text: "Choisissez une ou plusieurs personnes de votre organisation. Elles acc\xE8dent \xE0 l'espace de l'h\xF4te sans voir le reste de cette organisation."
              },
              scope: {
                term: "Ce que l'acc\xE8s couvre",
                text: "Dans la limite de votre partenariat\xA0: \xABTout l'espace\xA0\xBB seulement si le partenariat le permet, sinon des dossiers et des canaux parmi ceux qui vous sont ouverts."
              },
              rights: {
                term: "Droits",
                text: "Les droits propos\xE9s ne d\xE9passent jamais ceux de votre partenariat."
              },
              submit: {
                term: "Donner l'acc\xE8s",
                text: "Ajoute les personnes choisies. Vous ne pouvez pas en ajouter plus que le nombre restant autoris\xE9."
              }
            }
          },
          leave: {
            title: "Quitter l'espace",
            items: {
              heading: {
                term: "Quitter l'espace",
                text: "Met fin au partenariat de votre c\xF4t\xE9\xA0: toutes les personnes de votre organisation perdent leur acc\xE8s. Cette section n'appara\xEEt pas dans un espace ferm\xE9."
              },
              button: {
                term: "Quitter l'espace",
                text: "Ouvre une confirmation. Pour revenir, l'organisation h\xF4te devra vous inviter de nouveau."
              }
            }
          }
        }
      },
      settings: {
        title: "Param\xE8tres",
        intro: "L'onglet Param\xE8tres d'un espace partag\xE9, r\xE9serv\xE9 aux responsables de l'organisation h\xF4te. Il sert \xE0 renommer l'espace, fixer ses r\xE8gles et, pour les propri\xE9taires et les administrateurs, le fermer.",
        sections: {
          frame: {
            title: "Cadre de l'espace",
            items: {
              banner: {
                term: "Espace externe h\xE9berg\xE9 par\u2026",
                text: "Bandeau permanent affich\xE9 quand l'espace appartient \xE0 une autre organisation\xA0: il rappelle que son contenu suit les r\xE8gles de cette organisation."
              },
              summary: {
                term: "H\xE9berg\xE9 par",
                text: "Bande sous le titre\xA0: l'organisation qui h\xE9berge l'espace, son type, la pastille \xABFerm\xE9\xA0\xBB quand l'espace est ferm\xE9 et, dans un espace externe, votre acc\xE8s\xA0: la fa\xE7on dont vous \xEAtes entr\xE9, vos droits et la date de fin."
              },
              tabs: {
                term: "Onglets",
                text: "La barre d'onglets de l'espace. Vous \xEAtes dans l'onglet \xABParam\xE8tres\xA0\xBB\xA0; seuls les onglets que votre acc\xE8s permet d'ouvrir sont affich\xE9s."
              }
            }
          },
          general: {
            title: "G\xE9n\xE9ral",
            items: {
              name: {
                term: "Nom de l'espace",
                text: "Le nom sous lequel l'espace appara\xEEt pour tous ses participants. Obligatoire, 200 caract\xE8res au plus."
              },
              closedNotice: {
                term: "Cet espace est ferm\xE9\xA0: ses param\xE8tres ne peuvent plus \xEAtre modifi\xE9s.",
                text: "Avertissement jaune affich\xE9 en haut quand l'espace est ferm\xE9\xA0: tous les champs sont alors gris\xE9s et il n'y a plus de bouton d'enregistrement."
              }
            }
          },
          policy: {
            title: "R\xE8gles de l'espace",
            items: {
              intro: {
                term: "R\xE8gles de l'espace",
                text: "Ces r\xE8gles s'appliquent \xE0 tous les acc\xE8s \xE0 l'espace, y compris ceux des organisations partenaires et des invit\xE9s."
              },
              download: {
                term: "Autoriser le t\xE9l\xE9chargement",
                text: "Interrupteur. Sans t\xE9l\xE9chargement, les documents restent consultables en aper\xE7u."
              },
              watermark: {
                term: "Filigrane sur les PDF",
                text: "Interrupteur. Un filigrane identifie la personne qui consulte chaque PDF."
              },
              print: {
                term: "Autoriser l'impression",
                text: "Interrupteur. L'impression se fait depuis la visionneuse de documents."
              },
              domains: {
                term: "Domaines autoris\xE9s pour les invit\xE9s",
                text: "Saisissez un domaine, par exemple client.tn, puis appuyez sur Entr\xE9e ou sur \xABAjouter\xA0\xBB\xA0: il appara\xEEt sous forme de pastille, que vous retirez avec sa croix. Liste vide\xA0: les invit\xE9s peuvent venir de toute adresse e-mail que la politique de votre organisation autorise."
              }
            }
          },
          save: {
            title: "Enregistrement",
            items: {
              save: {
                term: "Enregistrer les param\xE8tres",
                text: "Enregistre ce qui a chang\xE9. Si rien n'a chang\xE9, le message \xABAucune modification \xE0 enregistrer\xA0\xBB s'affiche. Votre identit\xE9 peut \xEAtre redemand\xE9e avant l'enregistrement."
              },
              failed: {
                term: "Les param\xE8tres n'ont pas \xE9t\xE9 enregistr\xE9s",
                text: "Message rouge qui explique pourquoi en langage simple\xA0: nom manquant ou trop long, valeur invalide, droit insuffisant."
              }
            }
          },
          close: {
            title: "Fermer l'espace",
            items: {
              section: {
                term: "Fermer l'espace",
                text: "Section r\xE9serv\xE9e aux propri\xE9taires et aux administrateurs de l'h\xF4te, absente si l'espace est d\xE9j\xE0 ferm\xE9. Elle met fin \xE0 tous les acc\xE8s ext\xE9rieurs\xA0; l'espace reste consultable en lecture seule par votre organisation."
              },
              button: {
                term: "Fermer l'espace",
                text: "Ouvre une confirmation. Votre identit\xE9 peut \xEAtre redemand\xE9e avant la fermeture."
              },
              effects: {
                term: "Cette action est d\xE9finitive",
                text: "La confirmation liste les effets\xA0: tous les partenaires, d\xE9l\xE9gu\xE9s, personnes nomm\xE9es et invit\xE9s perdent leur acc\xE8s\xA0; l'espace devient une archive en lecture seule\xA0; les partenaires ne peuvent pas encore r\xE9cup\xE9rer leurs propres fichiers."
              },
              cancel: {
                term: "Annuler",
                text: "Ferme la confirmation sans rien changer. \xABFermer l'espace\xA0\xBB dans la confirmation ex\xE9cute la fermeture."
              }
            }
          }
        }
      },
      audit: {
        title: "Journal d'audit",
        intro: "L'onglet Journal d'audit d'un espace partag\xE9\xA0: qui a fait quoi dans l'espace, et quand. L'h\xF4te voit tout\xA0; un partenaire ne voit que ce qui concerne son organisation.",
        sections: {
          frame: {
            title: "Cadre de l'espace",
            items: {
              banner: {
                term: "Espace externe h\xE9berg\xE9 par\u2026",
                text: "Bandeau permanent affich\xE9 quand l'espace appartient \xE0 une autre organisation\xA0: il rappelle que son contenu suit les r\xE8gles de cette organisation."
              },
              summary: {
                term: "H\xE9berg\xE9 par",
                text: "Bande sous le titre\xA0: l'organisation qui h\xE9berge l'espace, son type, la pastille \xABFerm\xE9\xA0\xBB quand l'espace est ferm\xE9 et, dans un espace externe, votre acc\xE8s\xA0: la fa\xE7on dont vous \xEAtes entr\xE9, vos droits et la date de fin."
              },
              tabs: {
                term: "Onglets",
                text: "La barre d'onglets de l'espace. Vous \xEAtes dans l'onglet \xABJournal d'audit\xA0\xBB\xA0; seuls les onglets que votre acc\xE8s permet d'ouvrir sont affich\xE9s."
              }
            }
          },
          log: {
            title: "Journal d'audit",
            items: {
              heading: {
                term: "Journal d'audit",
                text: "Le tableau des \xE9v\xE9nements de l'espace, du plus r\xE9cent au plus ancien. Il garde la trace des invitations, des acc\xE8s et des retraits."
              },
              date: {
                term: "Date",
                text: "Le jour et l'heure de l'\xE9v\xE9nement."
              },
              actor: {
                term: "Personne",
                text: "Qui a fait l'action. \xABSyst\xE8me\xA0\xBB signale une action automatique, comme l'expiration d'un acc\xE8s."
              },
              action: {
                term: "Action",
                text: "Ce qui s'est pass\xE9, en toutes lettres (voir la liste des actions ci-dessous)."
              },
              organisation: {
                term: "Organisation concern\xE9e",
                text: "L'organisation partenaire touch\xE9e par l'\xE9v\xE9nement. \xAB\u2014\xA0\xBB veut dire qu'aucune organisation n'est concern\xE9e, et \xABAutre organisation\xA0\xBB qu'il s'agit d'une organisation que vous ne g\xE9rez pas."
              }
            }
          },
          actions: {
            title: "Actions que vous pouvez voir",
            items: {
              space: {
                term: "Espace cr\xE9\xE9",
                text: "Vie de l'espace\xA0: \xABEspace cr\xE9\xE9\xA0\xBB, \xABParam\xE8tres de l'espace modifi\xE9s\xA0\xBB et \xABEspace ferm\xE9\xA0\xBB."
              },
              partners: {
                term: "Organisation partenaire invit\xE9e",
                text: "Partenariats\xA0: \xABOrganisation partenaire invit\xE9e\xA0\xBB, \xABInvitation de partenariat accept\xE9e\xA0\xBB, \xABInvitation de partenariat refus\xE9e\xA0\xBB, \xABOrganisation partenaire retir\xE9e\xA0\xBB et \xABPartenariat expir\xE9\xA0\xBB."
              },
              members: {
                term: "Personne arriv\xE9e dans l'espace",
                text: "Acc\xE8s des personnes\xA0: \xABPersonne ajout\xE9e par un partenaire\xA0\xBB, \xABPersonne arriv\xE9e dans l'espace\xA0\xBB, \xABAcc\xE8s d'une personne retir\xE9\xA0\xBB, \xABAcc\xE8s d'une personne expir\xE9\xA0\xBB et \xABAcc\xE8s d'un invit\xE9 prolong\xE9\xA0\xBB."
              },
              invitations: {
                term: "Invitation envoy\xE9e \xE0 une personne",
                text: "Invitations\xA0: \xABInvitation envoy\xE9e \xE0 une personne\xA0\xBB, \xABInvitation refus\xE9e\xA0\xBB, \xABInvitation annul\xE9e\xA0\xBB et \xABD\xE9cision sur une demande d'approbation\xA0\xBB."
              },
              other: {
                term: "Autre action",
                text: "Une action qui n'a pas encore de libell\xE9 en clair\xA0: son nom technique est affich\xE9 entre parenth\xE8ses."
              }
            }
          },
          states: {
            title: "Pages suivantes et \xE9tats",
            items: {
              more: {
                term: "Charger plus",
                text: "Charge les \xE9v\xE9nements plus anciens, par pages. Le bouton affiche \xABChargement\u2026\xA0\xBB pendant l'op\xE9ration."
              },
              empty: {
                term: "Aucun \xE9v\xE9nement pour le moment",
                text: "Message affich\xE9 tant que rien n'a eu lieu\xA0: les invitations, les acc\xE8s et les retraits appara\xEEtront ici."
              },
              loadFailed: {
                term: "Impossible de charger le journal",
                text: "Message rouge affich\xE9 si le journal ne s'est pas charg\xE9. Utilisez \xABR\xE9essayer\xA0\xBB apr\xE8s avoir v\xE9rifi\xE9 votre connexion."
              }
            }
          }
        }
      }
    },
    admin: {
      members: {
        title: "Membres",
        intro: "Cette page liste les personnes de votre bureau, avec leur r\xF4le et leur statut. Le propri\xE9taire et les administrateurs y invitent des coll\xE8gues et g\xE8rent leurs acc\xE8s.",
        sections: {
          header: {
            title: "Menu d'administration et en-t\xEAte",
            items: {
              adminNav: {
                term: "Administration",
                text: "Le menu \xE0 gauche regroupe les pages d'administration de votre organisation (une rang\xE9e de liens au-dessus de la page sur petit \xE9cran). Il n'affiche que les pages que votre r\xF4le permet d'ouvrir."
              },
              invite: {
                term: "Inviter",
                text: "Ouvre la fen\xEAtre pour inviter une personne dans votre bureau. Le bouton n'appara\xEEt que si votre r\xF4le permet d'inviter. Il est gris\xE9, avec une explication, quand le bureau est en lecture seule."
              },
              seats: {
                term: "si\xE8ges utilis\xE9s",
                text: "Un compteur au-dessus de la liste, par exemple \xAB\xA03 / 5\xA0\xBB\xA0: les si\xE8ges utilis\xE9s sur les si\xE8ges inclus dans votre offre (un si\xE8ge par personne du bureau). Sans limite, il indique \xAB\xA0si\xE8ges utilis\xE9s (sans limite)\xA0\xBB."
              }
            }
          },
          ownerBanner: {
            title: "Transfert de propri\xE9t\xE9 en cours",
            items: {
              pending: {
                term: "Transfert de propri\xE9t\xE9 en cours",
                text: "Bandeau du propri\xE9taire\xA0: il dit de qui il attend la r\xE9ponse et jusqu'\xE0 quand (\xAB\xA0Expire le\xA0\xBB). La personne choisie doit accepter pour devenir propri\xE9taire."
              },
              cancel: {
                term: "Annuler le transfert",
                text: "Retire la proposition tant que la personne n'a pas r\xE9pondu."
              },
              offer: {
                term: "\u2026 souhaite vous nommer propri\xE9taire",
                text: "Bandeau de l'administrateur choisi\xA0: il explique ce que vous prendriez en charge (facturation, suppression de l'organisation et transfert)."
              },
              accept: {
                term: "Accepter",
                text: "Ouvre la confirmation \xAB\xA0Devenir propri\xE9taire\xA0\xBB. Vous devez confirmer votre identit\xE9\xA0; ensuite vous devenez propri\xE9taire et l'ancien propri\xE9taire devient administrateur."
              },
              decline: {
                term: "Refuser",
                text: "Refuse la proposition. Rien ne change dans les r\xF4les."
              }
            }
          },
          filters: {
            title: "Filtrer les membres",
            items: {
              search: {
                term: "Rechercher un membre",
                text: "Champ de recherche (\xAB\xA0Nom ou adresse e-mail\xA0\xBB). La liste se r\xE9duit pendant que vous tapez."
              },
              role: {
                term: "Filtrer par r\xF4le",
                text: "Choisissez un r\xF4le pour ne voir que les personnes qui l'ont, ou \xAB\xA0Tous les r\xF4les\xA0\xBB pour tout afficher."
              },
              status: {
                term: "Filtrer par statut",
                text: "Choisissez Actif, Invit\xE9 ou D\xE9sactiv\xE9, ou \xAB\xA0Tous les statuts\xA0\xBB pour tout afficher."
              },
              clear: {
                term: "Effacer les filtres",
                text: "Remet la recherche et les filtres \xE0 z\xE9ro. Ce bouton appara\xEEt aussi quand aucun membre ne correspond."
              }
            }
          },
          table: {
            title: "Membres de l'organisation",
            items: {
              name: {
                term: "Nom",
                text: "Le nom de la personne, avec sa photo ou ses initiales. Votre propre ligne porte la mention \xAB\xA0(vous)\xA0\xBB."
              },
              email: {
                term: "Adresse e-mail",
                text: "L'adresse e-mail avec laquelle la personne se connecte."
              },
              role: {
                term: "R\xF4le",
                text: "Ce que la personne peut faire dans le bureau (voir \xAB\xA0R\xF4les et permissions\xA0\xBB). Les r\xF4les sont d\xE9crits plus bas."
              },
              status: {
                term: "Statut",
                text: "Actif\xA0: la personne travaille dans le bureau. Invit\xE9\xA0: elle n'a pas encore accept\xE9. D\xE9sactiv\xE9\xA0: son acc\xE8s est coup\xE9, mais ses documents restent."
              },
              joined: {
                term: "Arriv\xE9e",
                text: "La date \xE0 laquelle la personne a rejoint le bureau. Un tiret (\u2014) s'affiche tant qu'elle n'est pas arriv\xE9e."
              },
              actions: {
                term: "Actions",
                text: "Le bouton \xAB\xA0\u2026\xA0\xBB en fin de ligne ouvre un menu\xA0: Changer le r\xF4le, Transf\xE9rer la propri\xE9t\xE9, D\xE9sactiver. Seules les actions que votre r\xF4le permet sont propos\xE9es\xA0; sans action possible, le bouton n'appara\xEEt pas."
              },
              loadMore: {
                term: "Afficher plus de membres",
                text: "Charge la suite de la liste quand il y a beaucoup de membres."
              },
              empty: {
                term: "Aucun membre pour le moment",
                text: "Message d'une liste vide\xA0: invitez votre \xE9quipe. Avec des filtres, il devient \xAB\xA0Aucun membre ne correspond\xA0\xBB. Si la liste ne se charge pas, \xAB\xA0Impossible d'afficher les membres\xA0\xBB appara\xEEt avec un bouton \xAB\xA0R\xE9essayer\xA0\xBB."
              }
            }
          },
          roles: {
            title: "R\xF4les propos\xE9s",
            items: {
              owner: {
                term: "Propri\xE9taire",
                text: "Le responsable du bureau\xA0: facturation, suppression de l'organisation et transfert de propri\xE9t\xE9. On ne l'attribue pas avec \xAB\xA0Changer le r\xF4le\xA0\xBB\xA0: il se transmet par un transfert de propri\xE9t\xE9."
              },
              admin: {
                term: "Administrateur",
                text: "G\xE8re les membres, les param\xE8tres, la finance et tous les projets du bureau."
              },
              projectManager: {
                term: "Chef de projet",
                text: "Cr\xE9e et pilote ses projets, suit les honoraires, les temps et les notes de frais."
              },
              engineer: {
                term: "Ing\xE9nieur ou architecte",
                text: "Participe aux projets auxquels vous l'ajoutez\xA0: documents, t\xE2ches et \xE9changes."
              },
              draftsman: {
                term: "Dessinateur",
                text: "Pr\xE9pare et d\xE9pose les plans sur les projets auxquels vous l'ajoutez."
              },
              accountant: {
                term: "Comptable",
                text: "G\xE8re les devis, les factures, les paiements et la fiscalit\xE9 du bureau."
              }
            }
          },
          invitations: {
            title: "Invitations en attente",
            items: {
              tab: {
                term: "Invitations en attente",
                text: "Onglet \xE0 c\xF4t\xE9 de \xAB\xA0Membres\xA0\xBB, visible seulement si vous pouvez inviter. Il liste les personnes invit\xE9es qui n'ont pas encore accept\xE9."
              },
              email: {
                term: "Adresse e-mail",
                text: "L'adresse \xE0 laquelle l'invitation a \xE9t\xE9 envoy\xE9e."
              },
              role: {
                term: "R\xF4le",
                text: "Le r\xF4le que la personne aura en rejoignant le bureau."
              },
              invitedBy: {
                term: "Invit\xE9 par",
                text: "Le membre qui a envoy\xE9 l'invitation."
              },
              expires: {
                term: "Expire le",
                text: "La date limite pour accepter (7 jours apr\xE8s l'envoi). Une pastille \xAB\xA0Expir\xE9e\xA0\xBB s'affiche quand elle est d\xE9pass\xE9e."
              },
              resend: {
                term: "Renvoyer",
                text: "Envoie \xE0 nouveau l'e-mail d'invitation \xE0 cette adresse."
              },
              revoke: {
                term: "R\xE9voquer",
                text: "Apr\xE8s confirmation, le lien re\xE7u par e-mail ne fonctionne plus. Vous pourrez inviter la personne \xE0 nouveau."
              },
              empty: {
                term: "Aucune invitation en attente",
                text: "Message affich\xE9 quand tout le monde a accept\xE9. Le bouton \xAB\xA0Inviter\xA0\xBB y est propos\xE9."
              }
            }
          },
          inviteDialog: {
            title: "Inviter un membre",
            items: {
              email: {
                term: "Adresse e-mail",
                text: "Obligatoire. L'adresse de la personne \xE0 inviter. Elle re\xE7oit un e-mail avec un lien pour rejoindre votre bureau, valable 7 jours."
              },
              role: {
                term: "R\xF4le",
                text: "Obligatoire. Choisissez Administrateur, Chef de projet, Ing\xE9nieur ou architecte, Dessinateur ou Comptable. Une phrase sous la liste d\xE9crit le r\xF4le choisi."
              },
              locale: {
                term: "Langue de l'e-mail",
                text: "La langue dans laquelle l'invitation est \xE9crite\xA0: Fran\xE7ais, \u0627\u0644\u0639\u0631\u0628\u064A\u0629 ou English."
              },
              submit: {
                term: "Envoyer l'invitation",
                text: "Envoie l'e-mail, puis un message confirme l'envoi. Si l'adresse est vide ou invalide, une erreur s'affiche sous le champ."
              },
              alreadyMember: {
                term: "Cette adresse appartient d\xE9j\xE0 \xE0 un membre de votre bureau.",
                text: "Message sous le champ e-mail\xA0: la personne est d\xE9j\xE0 dans la liste, inutile de l'inviter."
              },
              resendExisting: {
                term: "Renvoyer l'invitation",
                text: "Quand une invitation attend d\xE9j\xE0 pour cette adresse, ce bouton la renvoie au lieu d'en cr\xE9er une seconde."
              },
              seatsFull: {
                term: "Tous les si\xE8ges de votre offre sont utilis\xE9s",
                text: "Message affich\xE9 quand l'offre est compl\xE8te. Le propri\xE9taire est guid\xE9 pour ajouter un si\xE8ge ou changer d'offre\xA0; les autres membres sont invit\xE9s \xE0 le lui demander."
              },
              cancel: {
                term: "Annuler",
                text: "Ferme la fen\xEAtre sans rien envoyer."
              }
            }
          },
          memberDialogs: {
            title: "Fen\xEAtres du menu Actions",
            items: {
              changeRole: {
                term: "Changer le r\xF4le",
                text: "Choisissez le \xAB\xA0Nouveau r\xF4le\xA0\xBB. Le r\xF4le actuel n'est pas propos\xE9, et on ne nomme pas de propri\xE9taire ici. Une confirmation d'identit\xE9 peut \xEAtre demand\xE9e avant l'application."
              },
              deactivate: {
                term: "D\xE9sactiver",
                text: "Assistant en trois \xE9tapes. D'abord un r\xE9sum\xE9\xA0: l'acc\xE8s s'arr\xEAte tout de suite sur tous les appareils, les documents, messages et t\xE2ches restent \xE0 leur place avec le nom de la personne, et le si\xE8ge est lib\xE9r\xE9 \xE0 la prochaine p\xE9riode de facturation."
              },
              defaultSuccessor: {
                term: "Reprise par d\xE9faut",
                text: "Deuxi\xE8me \xE9tape\xA0: s'il y a des \xE9l\xE9ments \xE0 confier, choisissez qui les reprend, un par un (\xAB\xA0Utiliser la reprise par d\xE9faut\xA0\xBB) ou tous d'un coup avec la reprise par d\xE9faut. S'il n'y en a pas, l'\xE9tape l'indique."
              },
              confirmDeactivate: {
                term: "D\xE9sactiver \u2026\xA0?",
                text: "Derni\xE8re \xE9tape\xA0: la confirmation. La personne perd l'acc\xE8s tout de suite et le nombre d'\xE9l\xE9ments transf\xE9r\xE9s est rappel\xE9. Une confirmation d'identit\xE9 peut \xEAtre demand\xE9e."
              },
              transfer: {
                term: "Transf\xE9rer la propri\xE9t\xE9",
                text: "R\xE9serv\xE9 au propri\xE9taire, vers un administrateur. \xAB\xA0Envoyer la proposition\xA0\xBB transmet la demande, que la personne doit accepter (voir le bandeau en haut). Vous pouvez l'annuler tant qu'elle n'a pas r\xE9pondu."
              }
            }
          }
        }
      },
      roles: {
        title: "R\xF4les et permissions",
        intro: "Cette page montre, dans un tableau, ce que chaque r\xF4le peut faire dans votre bureau. Elle sert \xE0 choisir le bon r\xF4le quand vous invitez quelqu'un.",
        sections: {
          header: {
            title: "Menu d'administration et en-t\xEAte",
            items: {
              adminNav: {
                term: "Administration",
                text: "Le menu \xE0 gauche regroupe les pages d'administration de votre organisation (une rang\xE9e de liens au-dessus de la page sur petit \xE9cran). Il n'affiche que les pages que votre r\xF4le permet d'ouvrir."
              },
              readOnly: {
                term: "R\xF4les et permissions",
                text: "Les six r\xF4les sont d\xE9finis par BatiFlow\xA0: ce tableau est en lecture seule, on ne peut rien y modifier."
              },
              scroll: {
                term: "Tableau des permissions par r\xF4le (d\xE9filement horizontal)",
                text: "Sur un petit \xE9cran, le tableau d\xE9file sur le c\xF4t\xE9\xA0; la colonne des permissions reste visible. Chaque case est aussi lue en toutes lettres par un lecteur d'\xE9cran."
              }
            }
          },
          legend: {
            title: "L\xE9gende du tableau",
            items: {
              yes: {
                term: "Accord\xE9",
                text: "Une coche\xA0: le r\xF4le a cette permission."
              },
              project: {
                term: "Accord\xE9 sur ses propres projets uniquement",
                text: "La lettre P\xA0: le r\xF4le a la permission seulement sur les projets dont il est responsable."
              },
              delegable: {
                term: "Non accord\xE9 par d\xE9faut\xA0; le propri\xE9taire peut le d\xE9l\xE9guer",
                text: "La lettre D\xA0: l'administrateur ne l'a pas d'office, mais le propri\xE9taire peut la lui confier."
              },
              no: {
                term: "Non accord\xE9",
                text: "Un tiret\xA0: le r\xF4le n'a pas cette permission."
              }
            }
          },
          table: {
            title: "Permissions accord\xE9es \xE0 chaque r\xF4le",
            items: {
              permission: {
                term: "Permission",
                text: "La colonne de gauche\xA0: ce que l'on peut faire, par exemple \xAB\xA0Modifier le profil du bureau\xA0\xBB ou \xAB\xA0Inviter des membres\xA0\xBB."
              },
              roleColumns: {
                term: "Propri\xE9taire, Administrateur, Chef de projet, Ing\xE9nieur ou architecte, Dessinateur, Comptable",
                text: "Une colonne par r\xF4le. Lisez la ligne d'une permission de gauche \xE0 droite pour savoir quels r\xF4les l'ont."
              }
            }
          },
          areas: {
            title: "Groupes de permissions",
            items: {
              organization: {
                term: "Organisation",
                text: "Profil du bureau, profil fiscal, politiques, suppression de l'organisation, transfert de propri\xE9t\xE9 et export des donn\xE9es."
              },
              billing: {
                term: "Abonnement",
                text: "Consulter l'abonnement et les factures BatiFlow, g\xE9rer l'abonnement et les si\xE8ges."
              },
              members: {
                term: "Membres et r\xF4les",
                text: "Voir la liste des membres, inviter, changer un r\xF4le, d\xE9sactiver, g\xE9rer les r\xF4les."
              },
              audit: {
                term: "Journal d'audit",
                text: "Consulter le journal (et sa version financi\xE8re), l'exporter, v\xE9rifier son int\xE9grit\xE9."
              },
              clientsProjects: {
                term: "Clients, Projets",
                text: "Consulter, cr\xE9er, modifier et archiver les clients\xA0; cr\xE9er des projets, voir ou g\xE9rer tous les projets, voir les honoraires."
              },
              sharing: {
                term: "Partage et espaces",
                text: "Cr\xE9er des espaces de collaboration, les partager avec l'ext\xE9rieur, approuver les acc\xE8s des intervenants externes, publier des documents au client."
              },
              financeTime: {
                term: "Finance, Temps et co\xFBts",
                text: "Devis, contrats, factures, paiements, notes de frais, tableau de bord financier, fournisseurs\xA0; saisie et approbation des temps, taux de co\xFBt, paie."
              },
              other: {
                term: "Autres",
                text: "Les permissions qui ne rentrent dans aucun groupe, par exemple la gestion des appels d'offres et des listes de contr\xF4le."
              }
            }
          }
        }
      },
      profile: {
        title: "Organisation",
        intro: "Cette page pr\xE9sente l'identit\xE9 l\xE9gale et professionnelle de votre bureau d'\xE9tudes, avec son logo. Tous les membres peuvent la lire\xA0; le propri\xE9taire et les administrateurs peuvent la modifier.",
        sections: {
          header: {
            title: "Menu d'administration et enregistrement",
            items: {
              adminNav: {
                term: "Administration",
                text: "Le menu \xE0 gauche regroupe les pages d'administration de votre organisation (une rang\xE9e de liens au-dessus de la page sur petit \xE9cran). Il n'affiche que les pages que votre r\xF4le permet d'ouvrir."
              },
              readOnlyView: {
                term: "Profil de l'organisation",
                text: "Sans droit de modification, la page affiche les informations en simple texte, avec \xAB\xA0Non renseign\xE9\xA0\xBB pour les champs vides, sous la mention \xAB\xA0Seuls le propri\xE9taire et les administrateurs peuvent les modifier\xA0\xBB."
              },
              save: {
                term: "Enregistrer",
                text: "Enregistre seulement ce que vous avez chang\xE9, pour toute la page sauf le logo. S'il n'y a rien de nouveau, \xAB\xA0Aucune modification \xE0 enregistrer\xA0\xBB s'affiche. Si quelqu'un d'autre a modifi\xE9 le profil entre-temps, vos changements ne sont pas enregistr\xE9s et la derni\xE8re version est recharg\xE9e."
              }
            }
          },
          identity: {
            title: "Identit\xE9 du bureau",
            items: {
              legalName: {
                term: "Raison sociale",
                text: "Obligatoire. Le nom officiel de votre bureau, tel qu'il figure au registre du commerce."
              },
              tradeName: {
                term: "Nom commercial (facultatif)",
                text: "Le nom sous lequel vos clients vous connaissent."
              },
              legalForm: {
                term: "Forme juridique",
                text: "Obligatoire. \xC0 choisir dans la liste\xA0: Entreprise individuelle, SUARL, SARL, SA, SNC, SCS, GIE ou Autre."
              },
              taxId: {
                term: "Matricule fiscal",
                text: "Lecture seule\xA0: il identifie votre bureau et ne se change pas ici. Pour une correction, contactez le support BatiFlow."
              }
            }
          },
          disciplines: {
            title: "Disciplines",
            items: {
              officeDisciplines: {
                term: "Disciplines du bureau",
                text: "Cases \xE0 cocher\xA0: Architecture, Structure, VRD, Fluides, \xC9lectricit\xE9, Topographie, G\xE9otechnique, OPC. Plusieurs choix sont possibles, mais il en faut au moins un."
              },
              acronyms: {
                term: "VRD et OPC",
                text: "VRD\xA0: voirie et r\xE9seaux divers (routes, assainissement, r\xE9seaux). OPC\xA0: ordonnancement, pilotage et coordination du chantier."
              }
            }
          },
          address: {
            title: "Adresse et gouvernorat",
            items: {
              line1: {
                term: "Adresse",
                text: "Obligatoire. L'adresse du si\xE8ge de votre bureau."
              },
              line2: {
                term: "Compl\xE9ment d'adresse (facultatif)",
                text: "B\xE2timent, \xE9tage, cit\xE9\u2026 tout ce qui aide \xE0 trouver le bureau."
              },
              city: {
                term: "Ville",
                text: "Obligatoire."
              },
              postalCode: {
                term: "Code postal",
                text: "Obligatoire, par exemple 1002."
              },
              governorate: {
                term: "Gouvernorat",
                text: "Obligatoire. \xC0 choisir dans la liste des gouvernorats de Tunisie, class\xE9s par ordre alphab\xE9tique."
              }
            }
          },
          references: {
            title: "R\xE9f\xE9rences professionnelles et langue",
            items: {
              professionalRegistration: {
                term: "Inscription professionnelle (facultatif)",
                text: "Par exemple le num\xE9ro d'inscription \xE0 l'Ordre des ing\xE9nieurs ou des architectes."
              },
              agreementNumber: {
                term: "Num\xE9ro d'agr\xE9ment (facultatif)",
                text: "Le num\xE9ro de l'agr\xE9ment de votre bureau d'\xE9tudes, s'il en a un."
              },
              defaultLocale: {
                term: "Langue par d\xE9faut de l'organisation",
                text: "Fran\xE7ais, \u0627\u0644\u0639\u0631\u0628\u064A\u0629 ou English. Elle sert pour les documents et les messages envoy\xE9s au nom du bureau."
              }
            }
          },
          logo: {
            title: "Logo",
            items: {
              preview: {
                term: "Logo actuel de l'organisation",
                text: "L'aper\xE7u du logo, qui figure sur vos documents officiels. Sans logo, \xAB\xA0Aucun logo pour l'instant.\xA0\xBB s'affiche."
              },
              choose: {
                term: "Choisir une image",
                text: "Propri\xE9taire et administrateurs seulement. Choisissez un fichier PNG, JPEG ou WebP de 2 Mo au maximum\xA0; il est v\xE9rifi\xE9, puis \xAB\xA0Application du logo\u2026\xA0\xBB s'affiche avant la mise \xE0 jour."
              },
              remove: {
                term: "Supprimer le logo",
                text: "Propri\xE9taire et administrateurs seulement. Ce bouton n'appara\xEEt que s'il y a d\xE9j\xE0 un logo."
              },
              logoErrors: {
                term: "Messages d'erreur du logo",
                text: "Un message en clair explique le refus\xA0: mauvais format, image trop lourde, image encore en v\xE9rification (r\xE9essayez dans un instant), ou enregistrement impossible."
              }
            }
          }
        }
      },
      documents: {
        title: "Documents",
        intro: "Cette page r\xE8gle la fa\xE7on dont BatiFlow nomme les documents de votre bureau (le \xAB\xA0code\xA0\xBB de chaque plan ou courrier) et num\xE9rote leurs versions. En dessous, vous g\xE9rez les mod\xE8les de circuit de visa de votre \xE9quipe.",
        sections: {
          header: {
            title: "Menu d'administration et enregistrement",
            items: {
              adminNav: {
                term: "Administration",
                text: "Le menu \xE0 gauche regroupe les pages d'administration de votre organisation (une rang\xE9e de liens au-dessus de la page sur petit \xE9cran). Il n'affiche que les pages que votre r\xF4le permet d'ouvrir."
              },
              save: {
                term: "Enregistrer",
                text: "Visible seulement pour les personnes autoris\xE9es \xE0 modifier l'organisation. S'il n'y a rien de nouveau, \xAB\xA0Aucune modification \xE0 enregistrer\xA0\xBB s'affiche. \xC0 c\xF4t\xE9, une note rappelle que les codes d\xE9j\xE0 attribu\xE9s ne changent pas\xA0: le nouveau mod\xE8le s'applique aux nouveaux documents et \xE0 ceux dont les informations sont modifi\xE9es."
              },
              readOnly: {
                term: "Seules les personnes autoris\xE9es \xE0 modifier l'organisation peuvent changer ces r\xE9glages.",
                text: "Pour les autres membres, la page se lit mais ne se modifie pas\xA0: le champ et les choix sont verrouill\xE9s."
              }
            }
          },
          pattern: {
            title: "Mod\xE8le de code des documents",
            items: {
              patternField: {
                term: "Mod\xE8le",
                text: "Le mod\xE8le du code de chaque document\xA0: il sert \xE0 le rep\xE9rer sur les plans, les courriers et les bordereaux d'envoi. Majuscules, chiffres et signes - _ . uniquement, de 5 \xE0 100 caract\xE8res\xA0; vos minuscules passent en majuscules toutes seules. Les \xE9l\xE9ments NUM et IDX, \xE9crits entre accolades, sont obligatoires."
              },
              example: {
                term: "Exemple de code",
                text: "Un exemple calcul\xE9 pendant que vous tapez, pour un plan de structure de la phase APS, premier document, zone RDC. Si le mod\xE8le n'est pas encore valide, \xAB\xA0pas d'exemple\xA0\xBB s'affiche."
              },
              problems: {
                term: "Messages sous le champ",
                text: "Ils expliquent le probl\xE8me en clair\xA0: longueur hors de 5 \xE0 100 caract\xE8res, caract\xE8re interdit, \xE9l\xE9ment entre accolades inconnu, accolades mal ferm\xE9es, ou NUM et IDX absents. Le serveur peut aussi refuser un mod\xE8le pour la m\xEAme raison."
              }
            }
          },
          elements: {
            title: "\xC9l\xE9ments du mod\xE8le",
            items: {
              project: {
                term: "PROJECT",
                text: "Le code du projet."
              },
              phase: {
                term: "PHASE",
                text: "La phase du projet\xA0: ESQ, APS, APD\u2026"
              },
              disc: {
                term: "DISC",
                text: "La discipline\xA0: ARC, STR, VRD\u2026"
              },
              type: {
                term: "TYPE",
                text: "Le type de document\xA0: PLN, NDC, RAP\u2026"
              },
              num: {
                term: "NUM",
                text: "Le num\xE9ro d'ordre, attribu\xE9 par BatiFlow. Obligatoire."
              },
              idx: {
                term: "IDX",
                text: "L'indice de r\xE9vision (A, B\u2026 ou 0, 1\u2026). Obligatoire."
              },
              zone: {
                term: "ZONE",
                text: "La zone ou le b\xE2timent, lorsqu'elle est renseign\xE9e."
              }
            }
          },
          index: {
            title: "Style des indices de r\xE9vision",
            items: {
              letters: {
                term: "Lettres\xA0: A, B, C\u2026",
                text: "Chaque nouvelle version d'un document re\xE7oit une lettre (l'indice de r\xE9vision)\xA0: A, puis B, puis C\u2026"
              },
              numbers: {
                term: "Chiffres\xA0: 0, 1, 2\u2026",
                text: "Chaque nouvelle version re\xE7oit un num\xE9ro\xA0: 0, puis 1, puis 2\u2026"
              }
            }
          },
          templates: {
            title: "Mod\xE8les de circuit de visa",
            items: {
              intro: {
                term: "Mod\xE8les de circuit de visa",
                text: "Des circuits pr\xEAts \xE0 l'emploi que votre \xE9quipe peut choisir en demandant un visa (la validation d'un document par des relecteurs). Chaque mod\xE8le de la liste affiche son nom et ses \xE9tapes."
              },
              new: {
                term: "Nouveau mod\xE8le",
                text: "Ouvre la fen\xEAtre de cr\xE9ation. Visible seulement pour les personnes autoris\xE9es \xE0 modifier l'organisation."
              },
              delete: {
                term: "Supprimer",
                text: "Une ic\xF4ne corbeille en fin de ligne, pour ceux qui peuvent modifier l'organisation. Apr\xE8s confirmation, le mod\xE8le dispara\xEEt\xA0; les circuits d\xE9j\xE0 lanc\xE9s ne changent pas."
              },
              empty: {
                term: "Aucun mod\xE8le pour le moment.",
                text: "Message d'une liste vide\xA0: les \xE9quipes composent alors les \xE9tapes \xE0 chaque demande."
              },
              readOnlyTemplates: {
                term: "Cr\xE9er ou supprimer un mod\xE8le est r\xE9serv\xE9 aux personnes qui peuvent modifier l'organisation.",
                text: "Les autres membres voient la liste sans pouvoir la changer."
              }
            }
          },
          newTemplate: {
            title: "Nouveau mod\xE8le de circuit",
            items: {
              name: {
                term: "Nom du mod\xE8le",
                text: "Obligatoire, 120 caract\xE8res au maximum. Sans nom, \xAB\xA0Donnez un nom au mod\xE8le.\xA0\xBB s'affiche."
              },
              step: {
                term: "\xC9tape",
                text: "Un circuit se compose d'\xE9tapes num\xE9rot\xE9es. Chaque \xE9tape a un mode\xA0: \xAB\xA0Dans l'ordre\xA0\xBB (chaque relecteur donne son avis \xE0 son tour) ou \xAB\xA0En parall\xE8le\xA0\xBB (tous r\xE9pondent en m\xEAme temps, dans n'importe quel ordre). Des boutons permettent de monter, descendre ou supprimer une \xE9tape."
              },
              reviewers: {
                term: "Relecteurs de l'\xE9tape",
                text: "Les personnes qui donnent leur avis. Choisissez une personne dans \xAB\xA0Choisissez une personne\xA0\xBB puis cliquez sur \xAB\xA0Ajouter\xA0\xBB\xA0; vous pouvez la monter, la descendre ou la retirer. Une \xE9tape sans relecteur est refus\xE9e."
              },
              addStep: {
                term: "Ajouter une \xE9tape",
                text: "Ajoute une \xE9tape \xE0 la fin du circuit."
              },
              create: {
                term: "Cr\xE9er le mod\xE8le",
                text: "Enregistre le mod\xE8le. Si une \xE9tape n'a aucun relecteur, \xAB\xA0Chaque \xE9tape doit avoir au moins un relecteur.\xA0\xBB s'affiche."
              }
            }
          }
        }
      },
      policies: {
        title: "Politiques",
        intro: "Cette page fixe comment votre bureau partage avec l'ext\xE9rieur et \xE0 quel point la connexion est prot\xE9g\xE9e. Elle est r\xE9serv\xE9e aux personnes qui peuvent modifier les politiques (en g\xE9n\xE9ral le propri\xE9taire et les administrateurs).",
        sections: {
          header: {
            title: "Menu d'administration et enregistrement",
            items: {
              adminNav: {
                term: "Administration",
                text: "Le menu \xE0 gauche regroupe les pages d'administration de votre organisation (une rang\xE9e de liens au-dessus de la page sur petit \xE9cran). Il n'affiche que les pages que votre r\xF4le permet d'ouvrir."
              },
              save: {
                term: "Enregistrer",
                text: "Enregistre seulement les politiques que vous avez chang\xE9es. Pour votre s\xE9curit\xE9, il vous demande de confirmer votre identit\xE9. Si quelqu'un d'autre a modifi\xE9 les politiques entre-temps, vos changements ne sont pas enregistr\xE9s et la derni\xE8re version est recharg\xE9e."
              }
            }
          },
          sharing: {
            title: "Partage avec l'ext\xE9rieur",
            items: {
              requireApproval: {
                term: "Approbation requise pour rejoindre un espace externe",
                text: "Interrupteur. Quand il est actif, un membre ne peut rejoindre l'espace d'une autre organisation qu'apr\xE8s l'accord d'un administrateur."
              },
              seeRequests: {
                term: "Voir les demandes en attente",
                text: "Un lien vers la page o\xF9 les administrateurs acceptent ou refusent les demandes d'acc\xE8s."
              },
              managersCanShare: {
                term: "Les chefs de projet peuvent partager",
                text: "Interrupteur. Quand il est actif, les chefs de projet peuvent ouvrir l'espace de leurs projets \xE0 des partenaires. Sinon, seuls le propri\xE9taire et les administrateurs le peuvent."
              },
              domains: {
                term: "Domaines autoris\xE9s pour les invit\xE9s",
                text: "Saisissez un domaine, par exemple client.tn, puis appuyez sur Entr\xE9e ou cliquez sur \xAB\xA0Ajouter\xA0\xBB. Les invit\xE9s externes ne pourront venir que de ces domaines. Sans domaine, ils peuvent venir de n'importe quelle adresse e-mail."
              },
              domainList: {
                term: "Domaines autoris\xE9s",
                text: "La liste des domaines ajout\xE9s, sous forme de pastilles. Le bouton \xAB\xA0Retirer\xA0\xBB d'une pastille supprime ce domaine (50 domaines au maximum)."
              },
              domainErrors: {
                term: "Messages sous le champ",
                text: "Ils signalent un domaine vide, invalide (\xE9crivez-le sans \xAB\xA0@\xA0\xBB ni espace), d\xE9j\xE0 pr\xE9sent dans la liste, ou une liste trop longue."
              }
            }
          },
          security: {
            title: "S\xE9curit\xE9 de la connexion",
            items: {
              sessionHours: {
                term: "Dur\xE9e maximale d'une session",
                text: "Liste de 1 \xE0 12 heures, ou \xAB\xA0Dur\xE9e par d\xE9faut de la plateforme (12 heures)\xA0\xBB. Pass\xE9 ce d\xE9lai, le membre doit se reconnecter, m\xEAme s'il est actif."
              },
              mfaForAll: {
                term: "V\xE9rification en deux \xE9tapes pour tous les membres",
                text: "Interrupteur. Quand il est actif, chaque membre doit configurer une application d'authentification \xE0 sa prochaine connexion\xA0; sans cela, il n'acc\xE8de plus \xE0 BatiFlow. Le propri\xE9taire, les administrateurs et les comptables y sont d\xE9j\xE0 tenus."
              }
            }
          }
        }
      },
      fiscal: {
        title: "Profil fiscal",
        intro: "Cette page fixe les r\xE8gles fiscales appliqu\xE9es \xE0 vos factures\xA0: TVA, r\xE9gime, retenue \xE0 la source, pied de page et coordonn\xE9es bancaires. Chaque changement cr\xE9e une nouvelle version. La page g\xE8re aussi la num\xE9rotation de vos factures. Il faut le droit de consulter le profil fiscal, et un droit de plus pour le modifier.",
        sections: {
          header: {
            title: "Menu d'administration et en-t\xEAte",
            items: {
              adminNav: {
                term: "Administration",
                text: "Le menu \xE0 gauche regroupe les pages d'administration de votre organisation (une rang\xE9e de liens au-dessus de la page sur petit \xE9cran). Il n'affiche que les pages que votre r\xF4le permet d'ouvrir."
              },
              newVersionButton: {
                term: "Nouvelle version",
                text: "Ouvre la fen\xEAtre de cr\xE9ation d'une version. Visible seulement pour ceux qui peuvent modifier le profil fiscal. Les valeurs de la version en vigueur sont reprises\xA0: changez seulement ce qui \xE9volue\xA0; l'ancienne version est conserv\xE9e."
              },
              empty: {
                term: "Aucun profil fiscal pour le moment",
                text: "Message de d\xE9part\xA0: le profil fiscal fixe la TVA, le r\xE9gime, la retenue \xE0 la source et les coordonn\xE9es bancaires de vos factures. Un bouton \xAB\xA0Nouvelle version\xA0\xBB y est propos\xE9 \xE0 ceux qui peuvent le cr\xE9er."
              }
            }
          },
          current: {
            title: "Version en vigueur",
            items: {
              effectiveFrom: {
                term: "En vigueur depuis",
                text: "La date \xE0 partir de laquelle ces valeurs s'appliquent aux nouvelles factures."
              },
              createdBy: {
                term: "Cr\xE9\xE9e par",
                text: "Le membre qui a cr\xE9\xE9 cette version."
              },
              vat: {
                term: "TVA",
                text: "\xAB\xA0Assujetti \xE0 la TVA\xA0\xBB ou \xAB\xA0Non assujetti \xE0 la TVA\xA0\xBB\xA0: votre bureau applique ou non la taxe sur la valeur ajout\xE9e."
              },
              regime: {
                term: "R\xE9gime fiscal",
                text: "R\xE9gime r\xE9el ou r\xE9gime forfaitaire."
              },
              withholding: {
                term: "Statut pour la retenue \xE0 la source",
                text: "Personne morale, Personne physique au r\xE9gime r\xE9el ou Autre. Il d\xE9termine la retenue \xE0 la source applicable \xE0 vos factures."
              },
              footer: {
                term: "Pied de page des factures",
                text: "Le texte affich\xE9 en bas de vos factures (mentions l\xE9gales, conditions de paiement\u2026), ou \xAB\xA0Aucun\xA0\xBB."
              },
              bank: {
                term: "Coordonn\xE9es bancaires",
                text: "Le nom de la banque et le RIB (relev\xE9 d'identit\xE9 bancaire) masqu\xE9, ou \xAB\xA0Aucune\xA0\xBB."
              },
              showRib: {
                term: "Afficher le RIB complet",
                text: "Pour ceux qui peuvent modifier le profil. Apr\xE8s confirmation de votre identit\xE9, le RIB et l'IBAN apparaissent avec un bouton pour les copier\xA0; \xAB\xA0Masquer\xA0\xBB les cache, et ils se cachent seuls apr\xE8s 1 minute. Chaque consultation est not\xE9e dans le journal d'audit."
              }
            }
          },
          history: {
            title: "Historique des versions",
            items: {
              table: {
                term: "Versions du profil fiscal, de la plus r\xE9cente \xE0 la plus ancienne",
                text: "Un tableau avec une ligne par version et les m\xEAmes informations que ci-dessus. Une nouvelle version ne modifie jamais les anciennes\xA0: les factures \xE9mises gardent celle qui \xE9tait en vigueur."
              },
              status: {
                term: "\xC9tat",
                text: "En vigueur\xA0: la version qui s'applique aujourd'hui. Programm\xE9e\xA0: elle commencera \xE0 une date ult\xE9rieure. Ancienne\xA0: elle a \xE9t\xE9 remplac\xE9e."
              },
              rowBank: {
                term: "Coordonn\xE9es bancaires",
                text: "Chaque ligne a sa propre colonne de coordonn\xE9es bancaires, avec le m\xEAme bouton \xAB\xA0Afficher le RIB complet\xA0\xBB pour ceux qui y ont droit."
              }
            }
          },
          newVersion: {
            title: "Nouvelle version du profil fiscal",
            items: {
              start: {
                term: "D\xE9but d'application",
                text: "Choisissez \xAB\xA0D\xE8s maintenant\xA0\xBB ou \xAB\xA0\xC0 une date ult\xE9rieure\xA0\xBB\xA0; dans ce cas, indiquez la \xAB\xA0Date de d\xE9but\xA0\xBB, qui ne peut pas \xEAtre dans le pass\xE9. Une version programm\xE9e s'affiche avec l'\xE9tat \xAB\xA0Programm\xE9e\xA0\xBB."
              },
              vat: {
                term: "Assujetti \xE0 la TVA",
                text: "Interrupteur\xA0: le bureau applique ou non la TVA sur ses factures."
              },
              regimeChoice: {
                term: "R\xE9gime fiscal",
                text: "Liste\xA0: R\xE9gime r\xE9el ou R\xE9gime forfaitaire."
              },
              withholdingChoice: {
                term: "Statut pour la retenue \xE0 la source",
                text: "Liste\xA0: Personne morale, Personne physique au r\xE9gime r\xE9el ou Autre."
              },
              footerField: {
                term: "Pied de page des factures",
                text: "Zone de texte facultative pour les mentions l\xE9gales ou les conditions de paiement. Un message signale un texte trop long."
              },
              bankField: {
                term: "Coordonn\xE9es bancaires (facultatif)",
                text: "Le \xAB\xA0Nom de la banque\xA0\xBB et le \xAB\xA0RIB\xA0\xBB (20 chiffres, sans le pr\xE9fixe \xAB\xA0TN59\xA0\xBB). Ils ne sont pas repris de la version pr\xE9c\xE9dente\xA0: saisissez-les de nouveau, ou laissez vide pour une version sans coordonn\xE9es bancaires."
              },
              submit: {
                term: "Cr\xE9er la version",
                text: "Enregistre la version. Pour votre s\xE9curit\xE9, il vous est demand\xE9 de confirmer votre identit\xE9. Un message dit ensuite si la version est en vigueur ou programm\xE9e."
              }
            }
          },
          series: {
            title: "S\xE9ries de num\xE9rotation des factures",
            items: {
              add: {
                term: "Ajouter une s\xE9rie",
                text: "Pour ceux qui peuvent modifier le profil fiscal. Chaque s\xE9rie a son propre compteur sans trou\xA0; la s\xE9rie par d\xE9faut est propos\xE9e sur les nouvelles factures."
              },
              code: {
                term: "Code",
                text: "Le code court de la s\xE9rie, par exemple FAC."
              },
              prefix: {
                term: "Pr\xE9fixe",
                text: "Le d\xE9but de chaque num\xE9ro de facture de la s\xE9rie, par exemple \xAB\xA0FAC-\xA0\xBB."
              },
              reset: {
                term: "Remise \xE0 z\xE9ro",
                text: "\xAB\xA0Chaque ann\xE9e\xA0\xBB\xA0: le compteur repart de 1 au d\xE9but de chaque ann\xE9e. \xAB\xA0Jamais\xA0\xBB\xA0: il continue sans s'arr\xEAter."
              },
              default: {
                term: "S\xE9rie par d\xE9faut",
                text: "Une pastille \xAB\xA0Par d\xE9faut\xA0\xBB marque la s\xE9rie propos\xE9e sur les nouvelles factures. Il y en a toujours une."
              },
              actions: {
                term: "Actions",
                text: "Le menu de la ligne propose Modifier, D\xE9finir par d\xE9faut et Supprimer\xA0; les deux derniers n'existent pas pour la s\xE9rie par d\xE9faut. Cette colonne n'appara\xEEt que pour ceux qui peuvent modifier le profil fiscal."
              },
              empty: {
                term: "Aucune s\xE9rie de factures",
                text: "Message d'une liste vide\xA0: ajoutez une s\xE9rie pour num\xE9roter vos factures."
              }
            }
          },
          seriesDialog: {
            title: "Ajouter une s\xE9rie de factures",
            items: {
              codeField: {
                term: "Code",
                text: "De 1 \xE0 10 lettres ou chiffres, sans espace ni accent. Il ne pourra plus \xEAtre chang\xE9, car les num\xE9ros d\xE9j\xE0 \xE9mis s'y r\xE9f\xE8rent. Un code d\xE9j\xE0 pris par une autre s\xE9rie est refus\xE9."
              },
              prefixField: {
                term: "Pr\xE9fixe",
                text: "Obligatoire. Le d\xE9but de chaque num\xE9ro, par exemple \xAB\xA0FAC-\xA0\xBB."
              },
              resetYearly: {
                term: "Recommencer la num\xE9rotation chaque ann\xE9e",
                text: "Interrupteur\xA0: le compteur repart de 1 au d\xE9but de chaque ann\xE9e."
              },
              makeDefault: {
                term: "S\xE9rie par d\xE9faut",
                text: "Interrupteur propos\xE9 seulement \xE0 l'ajout d'une s\xE9rie. Pour une s\xE9rie existante, utilisez \xAB\xA0D\xE9finir par d\xE9faut\xA0\xBB dans son menu."
              },
              delete: {
                term: "Supprimer",
                text: "Apr\xE8s confirmation, la s\xE9rie ne sera plus propos\xE9e, et c'est d\xE9finitif. La s\xE9rie par d\xE9faut ne peut pas \xEAtre supprim\xE9e\xA0: d\xE9finissez d'abord une autre s\xE9rie par d\xE9faut."
              }
            }
          }
        }
      },
      audit: {
        title: "Journal d'audit",
        intro: "Cette page garde la trace de qui a fait quoi, et quand, dans votre bureau\xA0: connexions, changements de profil, factures \xE9mises\u2026 Le propri\xE9taire et les administrateurs voient tout\xA0; un comptable voit seulement les \xE9v\xE9nements financiers.",
        sections: {
          header: {
            title: "Menu d'administration et acc\xE8s",
            items: {
              adminNav: {
                term: "Administration",
                text: "Le menu \xE0 gauche regroupe les pages d'administration de votre organisation (une rang\xE9e de liens au-dessus de la page sur petit \xE9cran). Il n'affiche que les pages que votre r\xF4le permet d'ouvrir."
              },
              financeOnly: {
                term: "En tant que comptable, vous voyez uniquement les \xE9v\xE9nements financiers",
                text: "Message d'information affich\xE9 aux comptables\xA0: factures, devis, contrats, paiements, d\xE9penses et param\xE8tres fiscaux. Les autres \xE9v\xE9nements sont r\xE9serv\xE9s au propri\xE9taire et aux administrateurs."
              }
            }
          },
          integrity: {
            title: "Int\xE9grit\xE9 du journal",
            items: {
              intro: {
                term: "Int\xE9grit\xE9 du journal",
                text: "Bloc r\xE9serv\xE9 au propri\xE9taire. Chaque \xE9v\xE9nement est reli\xE9 au pr\xE9c\xE9dent par une empreinte\xA0; la v\xE9rification recalcule cet encha\xEEnement et signale si un \xE9v\xE9nement a \xE9t\xE9 modifi\xE9, supprim\xE9 ou d\xE9plac\xE9."
              },
              verify: {
                term: "V\xE9rifier l'int\xE9grit\xE9",
                text: "Lance la v\xE9rification. Pendant le calcul, le bouton indique \xAB\xA0V\xE9rification en cours\u2026\xA0\xBB."
              },
              intact: {
                term: "Le journal est intact",
                text: "Message vert\xA0: aucune modification ni suppression d\xE9tect\xE9e, avec la date et l'heure de la v\xE9rification."
              },
              altered: {
                term: "Le journal a \xE9t\xE9 alt\xE9r\xE9",
                text: "Message rouge\xA0: l'encha\xEEnement est rompu \xE0 partir d'un num\xE9ro d'\xE9v\xE9nement, avec la raison (contenu modifi\xE9, \xE9v\xE9nement disparu, lien rompu). Conservez l'\xE9cran et contactez le support BatiFlow sans attendre."
              },
              failed: {
                term: "La v\xE9rification n'a pas abouti",
                text: "Le contr\xF4le n'a pas pu se terminer\xA0; le message en explique la cause en clair. Vous pouvez relancer."
              }
            }
          },
          filters: {
            title: "Filtres du journal",
            items: {
              actor: {
                term: "Auteur",
                text: "Choisissez la personne qui a fait l'action, ou \xAB\xA0Tous les auteurs\xA0\xBB. Ce filtre n'appara\xEEt que si vous pouvez voir la liste des membres."
              },
              action: {
                term: "Type d'action",
                text: "Un groupe d'actions\xA0: Organisation et param\xE8tres, Membres et invitations, Clients, Connexions et s\xE9curit\xE9, Factures, Devis, Contrats, Paiements, D\xE9penses. Un comptable n'a que ceux qui touchent \xE0 la finance. \xAB\xA0Toutes les actions\xA0\xBB montre tout."
              },
              from: {
                term: "Du",
                text: "Premier jour \xE0 afficher (jour calendaire de Tunis)."
              },
              to: {
                term: "Au",
                text: "Dernier jour \xE0 afficher, jusqu'\xE0 la fin de la journ\xE9e. Il ne peut pas pr\xE9c\xE9der la date \xAB\xA0Du\xA0\xBB."
              },
              clear: {
                term: "Effacer les filtres",
                text: "Appara\xEEt d\xE8s qu'un filtre est choisi, et remet tout \xE0 z\xE9ro."
              }
            }
          },
          events: {
            title: "\xC9v\xE9nements du journal d'audit",
            items: {
              when: {
                term: "Date et heure",
                text: "Quand l'action a eu lieu. Les \xE9v\xE9nements sont class\xE9s du plus r\xE9cent au plus ancien."
              },
              actor: {
                term: "Auteur",
                text: "La personne qui a fait l'action. Pour une action automatique, \xAB\xA0Syst\xE8me BatiFlow\xA0\xBB\xA0; pour une intervention du support, \xAB\xA0Support BatiFlow\xA0\xBB."
              },
              action: {
                term: "Action",
                text: "Une phrase simple, par exemple \xAB\xA0Connexion\xA0\xBB ou \xAB\xA0Facture \xE9mise\xA0\xBB, avec en dessous le code technique de l'action."
              },
              resource: {
                term: "\xC9l\xE9ment concern\xE9",
                text: "Ce que l'action a touch\xE9\xA0: Organisation, Membre, Invitation, Transfert de propri\xE9t\xE9, Profil fiscal, S\xE9rie de factures, Client\u2026 avec un court identifiant dessous."
              },
              loadMore: {
                term: "Afficher plus d'\xE9v\xE9nements",
                text: "Charge la suite du journal quand il y a beaucoup d'\xE9v\xE9nements."
              },
              empty: {
                term: "Aucun \xE9v\xE9nement pour le moment",
                text: "Message d'une liste vide\xA0: les actions sensibles du bureau appara\xEEtront ici d\xE8s qu'elles auront lieu. Avec des filtres, il devient \xAB\xA0Aucun \xE9v\xE9nement ne correspond\xA0\xBB (essayez d'autres filtres ou une p\xE9riode plus large)."
              },
              loadFailed: {
                term: "Impossible d'afficher le journal",
                text: "Message d'erreur avec un bouton \xAB\xA0R\xE9essayer\xA0\xBB quand le journal ne se charge pas."
              }
            }
          }
        }
      },
      storage: {
        title: "Stockage",
        intro: "Cette page montre l'espace de stockage utilis\xE9 par vos fichiers, par rapport \xE0 votre offre, projet par projet. Elle est r\xE9serv\xE9e aux personnes qui peuvent modifier l'organisation.",
        sections: {
          header: {
            title: "Menu d'administration et chargement",
            items: {
              adminNav: {
                term: "Administration",
                text: "Le menu \xE0 gauche regroupe les pages d'administration de votre organisation (une rang\xE9e de liens au-dessus de la page sur petit \xE9cran). Il n'affiche que les pages que votre r\xF4le permet d'ouvrir."
              },
              loadFailed: {
                term: "Impossible de charger l'utilisation du stockage",
                text: "Message d'erreur affich\xE9 quand les chiffres ne se chargent pas\xA0: v\xE9rifiez votre connexion, puis cliquez sur \xAB\xA0R\xE9essayer\xA0\xBB."
              }
            }
          },
          usage: {
            title: "Espace utilis\xE9",
            items: {
              summary: {
                term: "\u2026 utilis\xE9s sur \u2026",
                text: "Les chiffres en toutes lettres\xA0: l'espace pris par tous les fichiers de vos projets, versions comprises, sur l'espace de votre offre. Sans limite, la phrase dit \xAB\xA0Votre contrat ne fixe pas de limite d'espace\xA0\xBB."
              },
              bar: {
                term: "Espace de stockage utilis\xE9",
                text: "Une barre de progression avec le pourcentage \xE9crit \xE0 c\xF4t\xE9 (\xAB\xA0\u2026 de l'espace est utilis\xE9\xA0\xBB). Sa couleur change avec le niveau, mais le pourcentage est toujours \xE9crit."
              },
              notes: {
                term: "Avertissements",
                text: "Au-del\xE0 de 80 %, un message vous conseille de supprimer des fichiers ou d'acheter du stockage. Sous 5 % d'espace restant, il devient plus pressant. Quand l'espace est plein, les nouveaux fichiers sont refus\xE9s."
              },
              buy: {
                term: "Acheter du stockage",
                text: "Bouton gris\xE9 pour l'instant\xA0: l'achat de stockage sera disponible avec la facturation, qui arrive plus tard."
              }
            }
          },
          spaces: {
            title: "Stockage par projet",
            items: {
              name: {
                term: "Projet ou espace",
                text: "Le nom du projet (ou de l'espace) qui contient des fichiers."
              },
              size: {
                term: "Taille",
                text: "La taille de tous les fichiers de ce projet."
              },
              reconciledAt: {
                term: "Dernier calcul",
                text: "Quand cette taille a \xE9t\xE9 recalcul\xE9e pour la derni\xE8re fois. \xAB\xA0Pas encore calcul\xE9\xA0\xBB s'affiche pour un projet neuf."
              },
              empty: {
                term: "Aucun fichier pour l'instant",
                text: "Message d'une liste vide\xA0: la taille de chaque projet appara\xEEtra ici d\xE8s qu'il contiendra des fichiers."
              }
            }
          },
          files: {
            title: "Les 10 plus gros fichiers",
            items: {
              code: {
                term: "Code",
                text: "Le code du document. \xAB\xA0Sans code\xA0\xBB s'affiche pour un fichier qui n'en a pas."
              },
              title: {
                term: "Titre",
                text: "Le titre du fichier. Quand il est dans un projet, c'est un lien qui l'ouvre dans le projet."
              },
              size: {
                term: "Taille",
                text: "La place prise par le fichier. Supprimer ou remplacer un fichier inutile lib\xE8re de l'espace."
              },
              empty: {
                term: "Aucun fichier pour l'instant",
                text: "Message d'une liste vide\xA0: les fichiers les plus volumineux appara\xEEtront ici."
              }
            }
          }
        }
      },
      data: {
        title: "Donn\xE9es et suppression",
        intro: "Cette page sert \xE0 r\xE9cup\xE9rer une copie des donn\xE9es de votre bureau (un export) et, pour le propri\xE9taire, \xE0 demander ou annuler la suppression de l'organisation.",
        sections: {
          header: {
            title: "Menu d'administration et acc\xE8s",
            items: {
              adminNav: {
                term: "Administration",
                text: "Le menu \xE0 gauche regroupe les pages d'administration de votre organisation (une rang\xE9e de liens au-dessus de la page sur petit \xE9cran). Il n'affiche que les pages que votre r\xF4le permet d'ouvrir."
              },
              blocks: {
                term: "Donn\xE9es et suppression",
                text: "Chaque bloc n'appara\xEEt que si votre r\xF4le le permet\xA0: l'export complet (propri\xE9taire et administrateurs), l'export des finances (comptable) et la suppression (propri\xE9taire seulement)."
              }
            }
          },
          export: {
            title: "Exporter les donn\xE9es",
            items: {
              button: {
                term: "Pr\xE9parer un export complet",
                text: "Lance la pr\xE9paration d'un export. Pour un comptable, le bouton s'appelle \xAB\xA0Pr\xE9parer un export des finances\xA0\xBB et ne couvre que les donn\xE9es financi\xE8res. Une confirmation d'identit\xE9 peut \xEAtre demand\xE9e, puis un message dit que l'export est en pr\xE9paration."
              },
              contents: {
                term: "Contenu de l'export",
                text: "Un export complet rassemble toutes les donn\xE9es de l'organisation dans un seul fichier\xA0: chaque table de donn\xE9es au format JSON, les documents rang\xE9s dans leurs dossiers et les PDF g\xE9n\xE9r\xE9s par BatiFlow. L'export des finances ne contient que les donn\xE9es financi\xE8res."
              },
              retention: {
                term: "Conservation et notification",
                text: "Le fichier ZIP est conserv\xE9 7 jours, puis supprim\xE9. La personne qui demande l'export re\xE7oit une notification d\xE8s qu'il est pr\xEAt."
              }
            }
          },
          exports: {
            title: "Exports de donn\xE9es de l'organisation",
            items: {
              requestedAt: {
                term: "Demand\xE9 le",
                text: "La date et l'heure de la demande."
              },
              scope: {
                term: "Type",
                text: "\xAB\xA0Complet\xA0\xBB ou \xAB\xA0Finances\xA0\xBB."
              },
              requestedBy: {
                term: "Demand\xE9 par",
                text: "Le membre qui a demand\xE9 l'export."
              },
              status: {
                term: "\xC9tat",
                text: "En file d'attente, En pr\xE9paration, Pr\xEAt, \xC9chec ou Expir\xE9. L'\xE9tat est toujours \xE9crit en toutes lettres. La liste se met \xE0 jour toute seule pendant une pr\xE9paration."
              },
              size: {
                term: "Taille",
                text: "Le poids du fichier une fois pr\xEAt. Un tiret quand il n'est pas encore connu."
              },
              expiresAt: {
                term: "Disponible jusqu'au",
                text: "Le dernier jour pour t\xE9l\xE9charger l'export."
              },
              download: {
                term: "T\xE9l\xE9charger",
                text: "T\xE9l\xE9charge le fichier ZIP. Le bouton n'appara\xEEt que sur un export \xAB\xA0Pr\xEAt\xA0\xBB."
              },
              empty: {
                term: "Aucun export pour le moment",
                text: "Message d'une liste vide\xA0: pr\xE9parez un export pour obtenir une copie des donn\xE9es. Si la liste ne se charge pas, \xAB\xA0Impossible de charger les exports\xA0\xBB appara\xEEt avec un bouton \xAB\xA0R\xE9essayer\xA0\xBB."
              }
            }
          },
          delete: {
            title: "Supprimer l'organisation",
            items: {
              points: {
                term: "Cette action est d\xE9finitive",
                text: "Quatre rappels avant de continuer\xA0: la suppression a lieu 90 jours apr\xE8s la demande et peut \xEAtre annul\xE9e jusque-l\xE0\xA0; elle est irr\xE9versible (donn\xE9es, fichiers, et comptes des personnes qui n'appartiennent \xE0 aucune autre organisation)\xA0; le nom, l'identifiant fiscal et le journal d'audit (3 ans) sont conserv\xE9s\xA0; pr\xE9parez d'abord un export complet."
              },
              button: {
                term: "Supprimer l'organisation",
                text: "Bouton r\xE9serv\xE9 au propri\xE9taire\xA0; il ouvre la fen\xEAtre de demande. Il n'appara\xEEt que lorsqu'aucune suppression n'est programm\xE9e."
              },
              scheduled: {
                term: "La suppression est programm\xE9e le \u2026",
                text: "Quand une suppression est pr\xE9vue, un bandeau donne la date, la personne qui l'a demand\xE9e et la raison\xA0: demande du propri\xE9taire, abonnement impay\xE9, essai termin\xE9 sans abonnement, ou abonnement r\xE9sili\xE9."
              },
              cancel: {
                term: "Annuler la suppression",
                text: "Pour une suppression demand\xE9e par le propri\xE9taire\xA0: une confirmation \xAB\xA0Annuler la suppression de l'organisation\xA0?\xA0\xBB propose \xAB\xA0Oui, annuler la suppression\xA0\xBB ou \xAB\xA0Non, la laisser programm\xE9e\xA0\xBB. L'organisation reste alors comme aujourd'hui."
              },
              payToStop: {
                term: "Aller \xE0 l'abonnement",
                text: "Pour une suppression d\xE9clench\xE9e par l'abonnement\xA0: r\xE9gler l'abonnement arr\xEAte la suppression, et ce lien m\xE8ne \xE0 la page Abonnement."
              },
              running: {
                term: "La suppression est en cours",
                text: "Les donn\xE9es sont en train d'\xEAtre effac\xE9es. Elle ne peut plus \xEAtre arr\xEAt\xE9e."
              }
            }
          },
          deleteDialog: {
            title: "Fen\xEAtre de demande de suppression",
            items: {
              exportState: {
                term: "Un export complet de moins de 30 jours est pr\xEAt",
                text: "Un message dit si un export complet de moins de 30 jours existe (pensez \xE0 le t\xE9l\xE9charger avant la suppression) ou si aucun n'est disponible (pr\xE9parez-en un dans \xAB\xA0Exporter les donn\xE9es\xA0\xBB)."
              },
              decline: {
                term: "Je ne souhaite pas d'export de mes donn\xE9es",
                text: "Case \xE0 cocher, propos\xE9e seulement quand il n'y a pas d'export r\xE9cent. Cochez-la pour continuer sans export\xA0; sinon un message vous demande d'en pr\xE9parer un."
              },
              confirmName: {
                term: "Saisissez la raison sociale pour confirmer",
                text: "Obligatoire. Recopiez exactement la raison sociale de l'organisation, indiqu\xE9e sous le champ. Si le texte diff\xE8re, un message le signale."
              },
              submit: {
                term: "Programmer la suppression",
                text: "Envoie la demande, apr\xE8s une confirmation d'identit\xE9. La suppression aura lieu dans 90 jours\xA0; vous pourrez l'annuler d'ici l\xE0."
              }
            }
          }
        }
      },
      subscription: {
        title: "Abonnement",
        intro: "Cette page montre l'abonnement BatiFlow de votre bureau\xA0: le forfait, ce que vous utilisez, la comparaison des forfaits et les factures. L'\xE9quipe de facturation voit tout\xA0; seul le propri\xE9taire peut modifier l'abonnement ou payer.",
        sections: {
          header: {
            title: "Menu d'administration et en-t\xEAte",
            items: {
              adminNav: {
                term: "Administration",
                text: "Le menu \xE0 gauche regroupe les pages d'administration de votre organisation (une rang\xE9e de liens au-dessus de la page sur petit \xE9cran). Il n'affiche que les pages que votre r\xF4le permet d'ouvrir."
              },
              change: {
                term: "Modifier l'abonnement",
                text: "Bouton r\xE9serv\xE9 au propri\xE9taire, en haut de la page\xA0: il ouvre la fen\xEAtre de changement de forfait. Il n'appara\xEEt pas avec un forfait Enterprise."
              },
              readOnlyNote: {
                term: "Vous consultez l'abonnement en lecture seule",
                text: "Message d'information pour les membres qui ne sont pas propri\xE9taires\xA0: ils voient tout mais ne peuvent ni modifier ni payer."
              },
              enterpriseNote: {
                term: "Votre forfait Enterprise est g\xE9r\xE9 par contrat",
                text: "Message pour le propri\xE9taire d'un forfait Enterprise\xA0: pour le modifier, contactez l'\xE9quipe commerciale de BatiFlow."
              }
            }
          },
          plan: {
            title: "Votre forfait",
            items: {
              status: {
                term: "\xC9tat de l'abonnement",
                text: "Une pastille en haut de la carte\xA0: P\xE9riode d'essai, Actif, Paiement en retard, Lecture seule (vous pouvez consulter et exporter, mais pas cr\xE9er ni modifier), Suspendu, En pause ou R\xE9sili\xE9. Pendant l'essai, une ligne \xAB\xA0Fin de l'essai\xA0\xBB donne la date."
              },
              plan: {
                term: "Forfait",
                text: "Votre offre\xA0: Solo, Starter, Pro, Business ou Enterprise."
              },
              cycle: {
                term: "Facturation",
                text: "Mensuel ou Annuel. L'abonnement annuel co\xFBte 10 mois au lieu de 12."
              },
              period: {
                term: "P\xE9riode en cours",
                text: "Les dates de d\xE9but et de fin de la p\xE9riode d\xE9j\xE0 factur\xE9e."
              },
              nextDue: {
                term: "Prochaine \xE9ch\xE9ance",
                text: "La date de la prochaine facture \xE0 r\xE9gler, ou \xAB\xA0Aucune\xA0\xBB."
              },
              price: {
                term: "Prix par p\xE9riode (HT)",
                text: "Le prix hors taxes, \xAB\xA0par mois\xA0\xBB ou \xAB\xA0par an\xA0\xBB. \xAB\xA0Sur devis\xA0\xBB pour un forfait Enterprise."
              },
              extras: {
                term: "Options",
                text: "Les si\xE8ges suppl\xE9mentaires et le stockage suppl\xE9mentaire que vous avez ajout\xE9s, ou \xAB\xA0Aucune option\xA0\xBB."
              },
              payment: {
                term: "Mode de paiement",
                text: "Carte bancaire, Virement bancaire, Ch\xE8que ou Paiement en ligne\xA0; \xAB\xA0Pas encore choisi\xA0\xBB sinon. Un virement ou un ch\xE8que est confirm\xE9 \xE0 la r\xE9ception par l'\xE9quipe BatiFlow."
              }
            }
          },
          notices: {
            title: "Facture \xE0 payer et changement pr\xE9vu",
            items: {
              openInvoice: {
                term: "La facture \u2026 attend son paiement",
                text: "Bandeau orange sous la carte quand une facture est ouverte, avec le \xAB\xA0Montant \xE0 r\xE9gler\xA0\xBB TTC."
              },
              pay: {
                term: "Payer",
                text: "Paie la facture ouverte. R\xE9serv\xE9 au propri\xE9taire."
              },
              pending: {
                term: "Un changement est pr\xE9vu",
                text: "Bandeau bleu\xA0: \xE0 une date donn\xE9e, l'abonnement passera \xE0 un autre forfait, sera mis en pause ou sera r\xE9sili\xE9."
              },
              withdraw: {
                term: "Annuler ce changement",
                text: "Retire le changement pr\xE9vu. R\xE9serv\xE9 au propri\xE9taire."
              }
            }
          },
          usage: {
            title: "Utilisation",
            items: {
              seats: {
                term: "Si\xE8ges",
                text: "Le nombre de personnes du bureau, compar\xE9 aux si\xE8ges de votre forfait."
              },
              storage: {
                term: "Stockage",
                text: "L'espace pris par vos fichiers, compar\xE9 \xE0 l'espace de votre forfait."
              },
              hostedSpaces: {
                term: "Espaces partag\xE9s h\xE9berg\xE9s",
                text: "Le nombre d'espaces partag\xE9s que votre bureau h\xE9berge, compar\xE9 \xE0 la limite du forfait."
              },
              reading: {
                term: "\u2026 sur \u2026 et pourcentage",
                text: "Chaque ligne s'\xE9crit \xAB\xA03 sur 5\xA0\xBB avec un pourcentage et une barre. La barre vire \xE0 l'orange d\xE8s 80 % et au rouge \xE0 100 %. Sans limite, la ligne dit \xAB\xA0(sans limite)\xA0\xBB."
              }
            }
          },
          compare: {
            title: "Comparer les forfaits",
            items: {
              columns: {
                term: "Solo, Starter, Pro, Business, Enterprise",
                text: "Une colonne par forfait. La colonne de votre forfait est color\xE9e et porte la pastille \xAB\xA0Votre forfait\xA0\xBB."
              },
              prices: {
                term: "Prix mensuel (HT)",
                text: "Avec \xAB\xA0Prix annuel (HT)\xA0\xBB\xA0: les prix hors taxes. L'abonnement annuel co\xFBte 10 mois au lieu de 12."
              },
              seats: {
                term: "Si\xE8ges inclus",
                text: "Le nombre de personnes comprises dans le forfait. La ligne \xAB\xA0Si\xE8ge suppl\xE9mentaire (par mois)\xA0\xBB donne le prix d'une personne de plus, ou \xAB\xA0Non propos\xE9\xA0\xBB."
              },
              storage: {
                term: "Stockage inclus",
                text: "L'espace de stockage compris dans le forfait. La ligne \xAB\xA0Espaces partag\xE9s h\xE9berg\xE9s\xA0\xBB donne le nombre d'espaces partag\xE9s possibles."
              },
              meeting: {
                term: "Participants par r\xE9union",
                text: "Le nombre de personnes qui peuvent rejoindre une r\xE9union en ligne."
              },
              special: {
                term: "Illimit\xE9, Selon contrat, Sur devis",
                text: "\xAB\xA0Illimit\xE9\xA0\xBB\xA0: aucune limite. \xAB\xA0Selon contrat\xA0\xBB et \xAB\xA0Sur devis\xA0\xBB\xA0: valeurs fix\xE9es avec l'\xE9quipe commerciale\xA0; le forfait Enterprise est vendu sur devis."
              }
            }
          },
          invoices: {
            title: "Factures d'abonnement",
            items: {
              number: {
                term: "Num\xE9ro",
                text: "Le num\xE9ro de la facture BatiFlow."
              },
              purpose: {
                term: "Objet",
                text: "Pourquoi la facture a \xE9t\xE9 \xE9mise\xA0: D\xE9but d'abonnement, Changement de forfait, Red\xE9marrage, Renouvellement ou Reprise apr\xE8s pause."
              },
              dates: {
                term: "\xC9mise le",
                text: "La date d'\xE9mission. La colonne \xAB\xA0\xC0 payer avant le\xA0\xBB donne la date limite de r\xE8glement."
              },
              total: {
                term: "Total TTC",
                text: "Le montant toutes taxes comprises."
              },
              status: {
                term: "\xC9tat",
                text: "\xC0 payer, Pay\xE9e ou Annul\xE9e."
              },
              pdf: {
                term: "PDF",
                text: "T\xE9l\xE9charge la facture au format PDF. Si le fichier n'est pas encore pr\xEAt, un message vous demande de r\xE9essayer."
              },
              payInvoice: {
                term: "Payer",
                text: "Paie une facture \xAB\xA0\xC0 payer\xA0\xBB. R\xE9serv\xE9 au propri\xE9taire."
              },
              empty: {
                term: "Aucune facture pour l'instant",
                text: "Message d'une liste vide\xA0: vos factures d'abonnement appara\xEEtront ici. Si la liste ne se charge pas, \xAB\xA0Impossible de charger les factures\xA0\xBB appara\xEEt avec un bouton \xAB\xA0R\xE9essayer\xA0\xBB."
              }
            }
          },
          manage: {
            title: "G\xE9rer l'abonnement",
            items: {
              renew: {
                term: "Renouveler maintenant",
                text: "Bouton \xAB\xA0Renouveler\xA0\xBB\xA0: \xE9met tout de suite la facture de la p\xE9riode suivante, que vous pouvez payer aussit\xF4t. Bloc r\xE9serv\xE9 au propri\xE9taire."
              },
              pause: {
                term: "Mettre en pause",
                text: "Choisissez la \xAB\xA0Dur\xE9e de la pause\xA0\xBB (3 mois par an au maximum). La pause commence \xE0 la fin de la p\xE9riode en cours et co\xFBte 20 % du prix. Seul un abonnement actif sans changement en cours peut \xEAtre mis en pause."
              },
              resume: {
                term: "Reprendre l'abonnement",
                text: "Visible quand l'abonnement est en pause. Une facture est \xE9mise (les mois de pause \xE0 20 % plus une nouvelle p\xE9riode) et l'abonnement reprend d\xE8s qu'elle est pay\xE9e."
              },
              cancel: {
                term: "R\xE9silier l'abonnement",
                text: "La r\xE9siliation prend effet \xE0 la fin de la p\xE9riode en cours. Ensuite le bureau passe en lecture seule pendant 90 jours (consultation et export), puis les donn\xE9es sont supprim\xE9es. Tant que la p\xE9riode n'est pas termin\xE9e, vous pouvez annuler la r\xE9siliation."
              }
            }
          },
          changeDialog: {
            title: "Modifier l'abonnement",
            items: {
              plan: {
                term: "Forfait",
                text: "Le nouveau forfait. Enterprise est indiqu\xE9 \xAB\xA0sur devis\xA0\xBB\xA0: il ne s'ach\xE8te pas en ligne."
              },
              cycle: {
                term: "Facturation",
                text: "Mensuel ou Annuel. Annuel\xA0: 10 mois pay\xE9s pour 12."
              },
              extraSeats: {
                term: "Si\xE8ges suppl\xE9mentaires",
                text: "Le nombre de personnes \xE0 ajouter au-del\xE0 du forfait. Le champ est inactif quand le forfait n'en propose pas (\xAB\xA0Ce forfait ne propose pas de si\xE8ge suppl\xE9mentaire\xA0\xBB)."
              },
              addon: {
                term: "Stockage suppl\xE9mentaire",
                text: "Un champ de quantit\xE9 par lot de stockage propos\xE9, pour ajouter de l'espace \xE0 votre forfait."
              },
              preview: {
                term: "Aper\xE7u du prix",
                text: "Le prix s'affiche avant toute confirmation\xA0: un tableau avec D\xE9tail, Qt\xE9, Prix unitaire et Montant, puis le Total HT et le Total TTC, et une phrase qui dit ce qui se passera (facture tout de suite, changement \xE0 la fin de la p\xE9riode, ou aucun changement)."
              },
              blocked: {
                term: "Ce forfait est trop petit pour votre usage actuel",
                text: "Message qui appara\xEEt quand vous utilisez plus que le forfait choisi n'offre\xA0: il liste ce qu'il faut r\xE9duire (si\xE8ges, stockage ou espaces partag\xE9s h\xE9berg\xE9s) avant de pouvoir le choisir."
              },
              confirm: {
                term: "Confirmer le changement",
                text: "Valide le changement, apr\xE8s une confirmation d'identit\xE9. Quand une facture est \xE9mise, le bouton s'appelle \xAB\xA0Confirmer et recevoir la facture\xA0\xBB."
              },
              issued: {
                term: "Facture \u2026 \xE9mise",
                text: "Une fen\xEAtre donne le \xAB\xA0Montant \xE0 r\xE9gler\xA0\xBB et quand le changement s'applique (d\xE8s que la facture est pay\xE9e). Choisissez \xAB\xA0Payer\xA0\xBB pour r\xE9gler maintenant ou \xAB\xA0Plus tard\xA0\xBB."
              }
            }
          }
        }
      }
    },
    me: {
      profile: {
        title: "Mon profil",
        intro: "Cette page rassemble vos informations personnelles\xA0: votre nom, votre langue, votre fuseau horaire, l'apparence de l'application et l'acc\xE8s \xE0 vos donn\xE9es personnelles. Elle ne concerne que vous.",
        sections: {
          header: {
            title: "Onglets et messages",
            items: {
              tabs: {
                term: "Profil, S\xE9curit\xE9, Notifications",
                text: "Trois onglets en haut des pages de votre compte\xA0: Profil, S\xE9curit\xE9 et Notifications. Cliquez sur l'un d'eux pour passer de l'une \xE0 l'autre."
              },
              messages: {
                term: "Messages de confirmation",
                text: "Apr\xE8s chaque enregistrement, un message bref confirme, par exemple \xAB\xA0Votre langue est enregistr\xE9e.\xA0\xBB. En cas d'\xE9chec, un message d'erreur en clair s'affiche et le choix pr\xE9c\xE9dent revient."
              }
            }
          },
          identity: {
            title: "Identit\xE9",
            items: {
              name: {
                term: "Nom affich\xE9",
                text: "Obligatoire. Votre nom tel que vos coll\xE8gues le voient. Si vous le laissez vide, \xAB\xA0Saisissez votre nom.\xA0\xBB s'affiche."
              },
              email: {
                term: "Adresse e-mail",
                text: "Lecture seule\xA0: elle est g\xE9r\xE9e par votre compte BatiFlow et ne se change pas ici."
              },
              save: {
                term: "Enregistrer",
                text: "Enregistre votre nom. Un message confirme que \xAB\xA0Votre nom est enregistr\xE9.\xA0\xBB"
              }
            }
          },
          region: {
            title: "Langue et r\xE9gion",
            items: {
              language: {
                term: "Langue de l'interface",
                text: "Fran\xE7ais, \u0627\u0644\u0639\u0631\u0628\u064A\u0629 ou English. Le changement s'applique tout de suite, y compris le sens de lecture pour l'arabe, et il est enregistr\xE9 sur votre compte."
              },
              timeZone: {
                term: "Fuseau horaire",
                text: "Les dates et heures de l'application s'affichent dans ce fuseau. Chaque entr\xE9e de la liste porte son d\xE9calage avec l'heure universelle."
              },
              digits: {
                term: "Chiffres de l'interface en arabe",
                text: "Chiffres latins (0123456789) ou Chiffres arabes (\u0660\u0661\u0662\u0663\u0664\u0665\u0666\u0667\u0668\u0669). Ce choix ne s'applique que lorsque l'interface est en arabe."
              }
            }
          },
          appearance: {
            title: "Apparence",
            items: {
              theme: {
                term: "Th\xE8me",
                text: "Comme le syst\xE8me (suit le r\xE9glage de votre appareil), Clair, Sombre ou Contraste \xE9lev\xE9 (couleurs tr\xE8s marqu\xE9es, plus faciles \xE0 lire)."
              },
              device: {
                term: "Ce choix reste sur cet appareil",
                text: "Le th\xE8me n'est pas enregistr\xE9 sur votre compte\xA0: sur un autre appareil ou un autre navigateur, il faudra le choisir \xE0 nouveau."
              }
            }
          },
          myData: {
            title: "Mes donn\xE9es personnelles",
            items: {
              law: {
                term: "Mes donn\xE9es personnelles",
                text: "La loi organique n\xB0 2004-63 vous donne le droit d'acc\xE9der aux donn\xE9es personnelles que BatiFlow d\xE9tient sur vous. Cette section vous permet d'en obtenir une copie."
              },
              button: {
                term: "Exporter mes donn\xE9es",
                text: "Lance la pr\xE9paration d'une copie de vos donn\xE9es. Un message dit qu'elle est en pr\xE9paration et vous recevez une notification quand elle est pr\xEAte."
              },
              columns: {
                term: "Demand\xE9 le, Taille, Disponible jusqu'au",
                text: "Le tableau \xAB\xA0Mes exports de donn\xE9es\xA0\xBB donne la date de la demande, la taille du fichier et le dernier jour pour le t\xE9l\xE9charger."
              },
              status: {
                term: "\xC9tat",
                text: "En file d'attente, En pr\xE9paration, Pr\xEAt, \xC9chec ou Expir\xE9. La liste se met \xE0 jour toute seule pendant une pr\xE9paration."
              },
              download: {
                term: "T\xE9l\xE9charger",
                text: "T\xE9l\xE9charge votre copie. Le bouton n'appara\xEEt que sur un export \xAB\xA0Pr\xEAt\xA0\xBB."
              },
              empty: {
                term: "Aucun export pour le moment",
                text: "Message d'une liste vide\xA0: demandez un export pour recevoir une copie de vos donn\xE9es personnelles. Si la liste ne se charge pas, un message vous invite \xE0 v\xE9rifier votre connexion."
              }
            }
          }
        }
      },
      security: {
        title: "S\xE9curit\xE9 du compte",
        intro: "Cette page vous aide \xE0 prot\xE9ger votre compte\xA0: la v\xE9rification en deux \xE9tapes, votre mot de passe et les appareils connect\xE9s. Elle ne concerne que vous.",
        sections: {
          header: {
            title: "Onglets et organisation de la page",
            items: {
              tabs: {
                term: "Profil, S\xE9curit\xE9, Notifications",
                text: "Trois onglets en haut des pages de votre compte\xA0: Profil, S\xE9curit\xE9 et Notifications. Cliquez sur l'un d'eux pour passer de l'une \xE0 l'autre."
              },
              order: {
                term: "S\xE9curit\xE9 du compte",
                text: "La page se lit de haut en bas\xA0: la v\xE9rification en deux \xE9tapes, le mot de passe et l'application d'authentification, puis les sessions actives."
              }
            }
          },
          mfa: {
            title: "V\xE9rification en deux \xE9tapes",
            items: {
              status: {
                term: "Activ\xE9e",
                text: "Pastille verte\xA0: votre session actuelle a \xE9t\xE9 confirm\xE9e par un second facteur (en plus du mot de passe, un code d'application d'authentification ou une cl\xE9 de s\xE9curit\xE9). Sinon la pastille orange dit \xAB\xA0Non activ\xE9e\xA0\xBB."
              },
              off: {
                term: "Non activ\xE9e",
                text: "Votre connexion repose uniquement sur le mot de passe. Un texte vous conseille d'ajouter un code \xE0 six chiffres donn\xE9 par une application d'authentification sur votre t\xE9l\xE9phone."
              },
              setUp: {
                term: "Activer la v\xE9rification en deux \xE9tapes",
                text: "Visible seulement quand elle n'est pas activ\xE9e. Il vous m\xE8ne \xE0 la gestion de votre compte pour configurer l'application d'authentification, puis vous revenez sur cette page apr\xE8s une nouvelle connexion."
              }
            }
          },
          account: {
            title: "Mot de passe et application d'authentification",
            items: {
              about: {
                term: "Mot de passe et application d'authentification",
                text: "Ce bloc explique que vous changez votre mot de passe, ajoutez ou retirez votre application d'authentification et g\xE9rez vos cl\xE9s de s\xE9curit\xE9 dans la gestion de votre compte BatiFlow. Il n'appara\xEEt que si une adresse de gestion de compte est disponible."
              },
              open: {
                term: "Ouvrir la gestion du compte",
                text: "Ouvre la gestion de votre compte BatiFlow dans le m\xEAme onglet."
              }
            }
          },
          sessions: {
            title: "Sessions actives",
            items: {
              device: {
                term: "Appareil inconnu",
                text: "Chaque ligne est un appareil connect\xE9, avec son nom (une ic\xF4ne de t\xE9l\xE9phone ou d'ordinateur). \xAB\xA0Appareil inconnu\xA0\xBB s'affiche quand son nom n'est pas connu. L'appareil actuel est en premier."
              },
              thisDevice: {
                term: "Cet appareil",
                text: "Pastille qui marque l'appareil que vous utilisez en ce moment. Il n'a pas de bouton pour le d\xE9connecter\xA0: pour fermer cette session, utilisez le menu de votre compte."
              },
              flagged: {
                term: "Changement d\xE9tect\xE9",
                text: "Pastille d'alerte\xA0: le r\xE9seau ou le navigateur a chang\xE9 pendant la session. Si ce n'\xE9tait pas vous, d\xE9connectez cet appareil."
              },
              lastActivity: {
                term: "Derni\xE8re activit\xE9\xA0:",
                text: "Quand l'appareil a servi pour la derni\xE8re fois, en dur\xE9e relative. \xC0 c\xF4t\xE9, \xAB\xA0R\xE9seau\xA0:\xA0\xBB donne le d\xE9but de l'adresse r\xE9seau utilis\xE9e."
              },
              revoke: {
                term: "D\xE9connecter",
                text: "Sur un autre appareil\xA0: apr\xE8s confirmation (\xAB\xA0D\xE9connecter \xAB\xA0\u2026\xA0\xBB\xA0?\xA0\xBB), cet appareil devra se reconnecter pour acc\xE9der \xE0 BatiFlow. Vos donn\xE9es ne sont pas modifi\xE9es."
              },
              revokeOthers: {
                term: "D\xE9connecter les autres appareils",
                text: "Bouton en haut du bloc, visible seulement s'il y a d'autres appareils connect\xE9s. Apr\xE8s confirmation, tous les autres appareils sont d\xE9connect\xE9s\xA0; celui-ci reste connect\xE9."
              },
              noOthers: {
                term: "Aucun autre appareil n'est connect\xE9.",
                text: "Message affich\xE9 sous la liste quand vous \xEAtes connect\xE9 sur un seul appareil. S'il n'y a aucune session \xE0 afficher, \xAB\xA0Aucune session active \xE0 afficher.\xA0\xBB appara\xEEt."
              },
              loadFailed: {
                term: "Impossible d'afficher vos sessions",
                text: "Message d'erreur avec un bouton \xAB\xA0R\xE9essayer\xA0\xBB quand la liste ne se charge pas. Vos donn\xE9es ne sont pas perdues."
              }
            }
          }
        }
      },
      notifications: {
        title: "Mes notifications",
        intro: "Cette page vous permet de choisir quelles notifications vous recevez, et o\xF9\xA0: dans l'application ou par e-mail. Vous r\xE9glez aussi le r\xE9sum\xE9 par e-mail et les heures o\xF9 vous ne voulez pas \xEAtre d\xE9rang\xE9.",
        sections: {
          header: {
            title: "Onglets et chargement",
            items: {
              tabs: {
                term: "Profil, S\xE9curit\xE9, Notifications",
                text: "Trois onglets en haut des pages de votre compte\xA0: Profil, S\xE9curit\xE9 et Notifications. Cliquez sur l'un d'eux pour passer de l'une \xE0 l'autre."
              },
              loadFailed: {
                term: "Impossible d'afficher vos pr\xE9f\xE9rences",
                text: "Message d'erreur avec un bouton \xAB\xA0R\xE9essayer\xA0\xBB quand vos pr\xE9f\xE9rences ne se chargent pas."
              }
            }
          },
          matrix: {
            title: "Quoi, et o\xF9",
            items: {
              notification: {
                term: "Notification",
                text: "Une ligne par type de notification, par exemple \xAB\xA0On vous mentionne\xA0\xBB, \xAB\xA0Une t\xE2che vous est assign\xE9e\xA0\xBB ou \xAB\xA0Paiement re\xE7u\xA0\xBB. Les lignes sont regroup\xE9es par th\xE8me."
              },
              groups: {
                term: "Conversations, T\xE2ches, Visas et validations, Calendrier, Partenaires et espaces externes, S\xE9curit\xE9, Facturation et abonnement",
                text: "Les titres de groupes qui s\xE9parent les lignes du tableau."
              },
              inApp: {
                term: "Dans l'application",
                text: "Une case \xE0 cocher\xA0: la notification appara\xEEt dans l'application. Pour certains avis importants de s\xE9curit\xE9, la case est coch\xE9e et verrouill\xE9e (\xAB\xA0Cet avis important reste toujours actif dans l'application.\xA0\xBB)."
              },
              email: {
                term: "Par e-mail",
                text: "Une liste\xA0: Jamais, Imm\xE9diatement (un e-mail \xE0 chaque notification) ou Dans le r\xE9sum\xE9 (regroup\xE9e avec d'autres dans un seul e-mail)."
              },
              push: {
                term: "Notification push",
                text: "Case gris\xE9e pour l'instant\xA0: cette option arrive avec l'application mobile (\xAB\xA0Application mobile, bient\xF4t\xA0\xBB)."
              },
              scroll: {
                term: "Tableau des pr\xE9f\xE9rences de notification",
                text: "Sur un petit \xE9cran, le tableau d\xE9file sur le c\xF4t\xE9. Chaque case ou liste porte un nom complet du type \xAB\xA0type\xA0: canal\xA0\xBB pour les lecteurs d'\xE9cran."
              }
            }
          },
          digest: {
            title: "R\xE9sum\xE9 par e-mail",
            items: {
              frequency: {
                term: "Fr\xE9quence du r\xE9sum\xE9",
                text: "Pas de r\xE9sum\xE9, Chaque heure ou Chaque jour. Le r\xE9sum\xE9 regroupe en un seul e-mail les notifications r\xE9gl\xE9es sur \xAB\xA0Dans le r\xE9sum\xE9\xA0\xBB\xA0; il n'est envoy\xE9 que si une fr\xE9quence est choisie."
              },
              warning: {
                term: "Le r\xE9sum\xE9 est d\xE9sactiv\xE9",
                text: "Message d'avertissement quand des notifications sont r\xE9gl\xE9es sur \xAB\xA0Dans le r\xE9sum\xE9\xA0\xBB alors qu'aucun r\xE9sum\xE9 n'est envoy\xE9\xA0: elles resteront uniquement dans l'application. Choisissez une fr\xE9quence pour les recevoir par e-mail."
              }
            }
          },
          quietHours: {
            title: "Heures calmes",
            items: {
              enable: {
                term: "Activer les heures calmes",
                text: "Interrupteur. Pendant ces heures, vous ne recevez pas d'e-mail de notification\xA0; ils vous parviennent ensuite. Les heures sont celles de votre fuseau horaire. \xC0 l'activation, 22:00 \xE0 07:00 sont propos\xE9es."
              },
              start: {
                term: "D\xE9but",
                text: "L'heure \xE0 laquelle les heures calmes commencent. Visible seulement quand elles sont activ\xE9es."
              },
              end: {
                term: "Fin",
                text: "L'heure \xE0 laquelle elles se terminent. Le d\xE9but et la fin doivent \xEAtre deux heures diff\xE9rentes, sinon un message le signale."
              }
            }
          },
          actions: {
            title: "Enregistrer et r\xE9tablir",
            items: {
              save: {
                term: "Enregistrer",
                text: "Enregistre l'ensemble de vos pr\xE9f\xE9rences. S'il n'y a rien de nouveau, \xAB\xA0Aucune modification \xE0 enregistrer\xA0\xBB s'affiche. Si vos pr\xE9f\xE9rences ont \xE9t\xE9 chang\xE9es ailleurs entre-temps, vos changements ne sont pas enregistr\xE9s et les pr\xE9f\xE9rences actuelles sont recharg\xE9es."
              },
              reset: {
                term: "R\xE9tablir les valeurs par d\xE9faut",
                text: "Remplit le formulaire avec les valeurs propos\xE9es par BatiFlow. Rien n'est chang\xE9 tant que vous n'avez pas cliqu\xE9 sur \xAB\xA0Enregistrer\xA0\xBB."
              },
              failure: {
                term: "Les pr\xE9f\xE9rences n'ont pas pu \xEAtre enregistr\xE9es",
                text: "Message d'erreur en clair, au-dessus des boutons, quand l'enregistrement \xE9choue. Vos choix restent \xE0 l'\xE9cran."
              }
            }
          }
        }
      }
    },
    finance: {
      quotes: {
        title: "Devis",
        intro: "La liste de tous les devis (propositions d\u2019honoraires envoy\xE9es \xE0 vos clients) de votre bureau, avec leur statut. Elle sert \xE0 retrouver un devis, \xE0 suivre son avancement jusqu\u2019\xE0 l\u2019acceptation et \xE0 en cr\xE9er un nouveau.",
        sections: {
          header: {
            title: "En-t\xEAte de la page",
            items: {
              subNav: {
                term: "Finance",
                text: "Le menu de gauche liste les rubriques de la finance\xA0: Devis, Contrats, Factures, Paiements, Notes de frais, Tableau de bord et Facture \xE9lectronique. Vous ne voyez que celles que vos droits permettent d\u2019ouvrir\xA0; sur un petit \xE9cran, il devient une rang\xE9e de liens au-dessus de la page."
              },
              newQuote: {
                term: "Nouveau devis",
                text: "Ouvre un devis vide \xE0 remplir. Ce bouton n\u2019appara\xEEt que si vous avez le droit de cr\xE9er des devis\xA0; il est gris\xE9 quand le compte du bureau est en lecture seule (une info-bulle explique pourquoi)."
              }
            }
          },
          filters: {
            title: "Filtres des devis",
            items: {
              status: {
                term: "Statut",
                text: "Liste d\xE9roulante pour n\u2019afficher que les devis d\u2019un statut\xA0: Brouillon, Envoy\xE9, Accept\xE9, Refus\xE9 ou Expir\xE9. \xABTous les statuts\xA0\xBB affiche tout."
              },
              clear: {
                term: "Effacer le filtre",
                text: "Appara\xEEt quand aucun devis ne correspond au statut choisi\xA0; il remet \xABTous les statuts\xA0\xBB."
              }
            }
          },
          table: {
            title: "Liste des devis",
            items: {
              number: {
                term: "Num\xE9ro",
                text: "Le num\xE9ro du devis. Cliquez dessus pour ouvrir le devis."
              },
              title: {
                term: "Objet",
                text: "Ce que le devis propose, par exemple \xABMission de ma\xEEtrise d\u2019\u0153uvre, villa R+1\xA0\xBB."
              },
              client: {
                term: "Client",
                text: "Le client (ma\xEEtre d\u2019ouvrage) \xE0 qui le devis est adress\xE9."
              },
              status: {
                term: "Statut",
                text: "L\u2019\xE9tat du devis, \xE9crit en toutes lettres et accompagn\xE9 d\u2019une couleur (voir \xABStatuts d\u2019un devis\xA0\xBB)."
              }
            }
          },
          amounts: {
            title: "Montants et dates",
            items: {
              totalHt: {
                term: "Total HT",
                text: "Montant du devis hors taxes (HT\xA0: avant TVA et autres taxes)."
              },
              totalTtc: {
                term: "Total TTC",
                text: "Montant toutes taxes comprises (TTC). Affiche \xAB\u2014\xA0\xBB tant que le total n\u2019est pas calcul\xE9."
              },
              validUntil: {
                term: "Valable jusqu\u2019au",
                text: "Date limite \xE0 laquelle le client peut encore accepter le devis."
              },
              sentAt: {
                term: "Envoy\xE9 le",
                text: "Date d\u2019envoi au client\xA0; \xAB\u2014\xA0\xBB si le devis n\u2019a pas \xE9t\xE9 envoy\xE9."
              },
              acceptedAt: {
                term: "Accept\xE9 le",
                text: "Date d\u2019acceptation par le client\xA0; \xAB\u2014\xA0\xBB s\u2019il n\u2019a pas encore accept\xE9."
              }
            }
          },
          statuses: {
            title: "Statuts d\u2019un devis",
            items: {
              draft: {
                term: "Brouillon",
                text: "Le devis est en pr\xE9paration et n\u2019a pas \xE9t\xE9 envoy\xE9\xA0: vous pouvez le modifier ou le supprimer."
              },
              sent: {
                term: "Envoy\xE9",
                text: "Le devis a \xE9t\xE9 envoy\xE9 au client par un lien s\xE9curis\xE9\xA0; il attend sa r\xE9ponse."
              },
              accepted: {
                term: "Accept\xE9",
                text: "Le client a accept\xE9 le devis\xA0; vous pouvez en faire un projet et un contrat."
              },
              rejected: {
                term: "Refus\xE9",
                text: "Le devis a \xE9t\xE9 marqu\xE9 comme refus\xE9 par le client."
              },
              expired: {
                term: "Expir\xE9",
                text: "La date de validit\xE9 est pass\xE9e sans que le client ait accept\xE9."
              }
            }
          },
          empty: {
            title: "Liste vide, erreur et chargement",
            items: {
              none: {
                term: "Aucun devis pour le moment",
                text: "Message de la liste vide. Si vous pouvez cr\xE9er des devis, il propose \xABNouveau devis\xA0\xBB\xA0; sinon il dit que les devis de votre bureau appara\xEEtront ici."
              },
              noMatch: {
                term: "Aucun devis ne correspond",
                text: "Message affich\xE9 quand le filtre ne trouve rien\xA0; le bouton \xABEffacer le filtre\xA0\xBB le retire."
              },
              loadMore: {
                term: "Afficher plus de devis",
                text: "Plac\xE9 sous la liste quand il y a beaucoup de devis\xA0: charge les suivants."
              },
              loadError: {
                term: "Les devis n\u2019ont pas pu \xEAtre charg\xE9s",
                text: "Message d\u2019erreur en cas de probl\xE8me de connexion\xA0; le bouton \xABR\xE9essayer\xA0\xBB relance le chargement."
              }
            }
          }
        }
      },
      quote: {
        title: "Devis (nouveau ou existant)",
        intro: "L\u2019\xE9cran d\u2019un devis\xA0: vous y pr\xE9parez les informations, les honoraires et les lignes, vous voyez les totaux se calculer en direct, puis vous envoyez le devis au client. Il est utilis\xE9 par les personnes qui ont le droit de cr\xE9er des devis.",
        sections: {
          header: {
            title: "En-t\xEAte et messages",
            items: {
              subNav: {
                term: "Finance",
                text: "Le menu de gauche permet de passer \xE0 une autre rubrique de la finance (Devis, Contrats, Factures\u2026), selon vos droits."
              },
              breadcrumb: {
                term: "Devis",
                text: "Le lien en haut de page ram\xE8ne \xE0 la liste des devis. S\u2019il reste des changements non enregistr\xE9s, une fen\xEAtre vous demande de confirmer."
              },
              save: {
                term: "Enregistrer",
                text: "Enregistre le devis\xA0; le premier enregistrement le cr\xE9e et lui donne son num\xE9ro. Visible seulement si vous pouvez modifier ce devis."
              },
              notices: {
                term: "Bandeaux d\u2019information",
                text: "Au-dessus du formulaire, un bandeau explique la situation\xA0: devis en lecture seule (droits ou statut), devis envoy\xE9 que vous reprenez en modification, ou \xABQuelqu\u2019un a modifi\xE9 ce devis\xA0\xBB avec le bouton \xABRecharger le devis\xA0\xBB."
              },
              saveFirst: {
                term: "Enregistrez d\u2019abord vos modifications pour utiliser ces actions.",
                text: "Phrase affich\xE9e quand le formulaire contient des changements non enregistr\xE9s\xA0: les boutons d\u2019action attendent l\u2019enregistrement."
              }
            }
          },
          actions: {
            title: "Actions sur le devis",
            items: {
              pdf: {
                term: "Voir le PDF",
                text: "Ouvre le devis en PDF dans un nouvel onglet. Si le PDF est encore en pr\xE9paration, un message vous invite \xE0 r\xE9essayer dans un instant."
              },
              send: {
                term: "Envoyer / Renvoyer",
                text: "Envoie le devis au client par e-mail avec un lien s\xE9curis\xE9\xA0; le bouton s\u2019appelle \xABRenvoyer\xA0\xBB si le devis a d\xE9j\xE0 \xE9t\xE9 envoy\xE9. R\xE9serv\xE9 \xE0 ceux qui ont le droit d\u2019envoyer."
              },
              reject: {
                term: "Refus\xE9 par le client",
                text: "Marque un devis envoy\xE9 comme refus\xE9\xA0: le lien du client ne permet plus de l\u2019accepter. Une confirmation est demand\xE9e."
              },
              edit: {
                term: "Modifier le devis",
                text: "Pour un devis envoy\xE9\xA0: le remet en brouillon afin de le corriger. Le lien d\xE9j\xE0 envoy\xE9 cesse de fonctionner, il faudra renvoyer le devis."
              },
              convert: {
                term: "Cr\xE9er le projet",
                text: "Sur un devis accept\xE9 qui n\u2019a pas de projet\xA0: cr\xE9e le projet avec le client et les honoraires du devis. Il faut aussi avoir le droit de cr\xE9er des projets."
              },
              openProject: {
                term: "Ouvrir le projet",
                text: "Sur un devis accept\xE9 d\xE9j\xE0 li\xE9 \xE0 un projet\xA0: ouvre ce projet."
              },
              createContract: {
                term: "Cr\xE9er le contrat",
                text: "Sur un devis accept\xE9\xA0: cr\xE9e le contrat \xE0 partir du devis et l\u2019ouvre. R\xE9serv\xE9 \xE0 ceux qui g\xE8rent les contrats."
              },
              delete: {
                term: "Supprimer le brouillon",
                text: "Supprime d\xE9finitivement un brouillon qui n\u2019a jamais \xE9t\xE9 envoy\xE9, apr\xE8s confirmation."
              }
            }
          },
          general: {
            title: "Informations g\xE9n\xE9rales",
            items: {
              client: {
                term: "Client",
                text: "Obligatoire\xA0: le ma\xEEtre d\u2019ouvrage destinataire du devis. Changer de client vide le projet choisi."
              },
              project: {
                term: "Projet",
                text: "Facultatif\xA0: un projet du client choisi, ou \xABAucun projet (pour le moment)\xA0\xBB\xA0; vous pourrez cr\xE9er le projet depuis le devis accept\xE9."
              },
              title: {
                term: "Objet du devis",
                text: "Obligatoire\xA0: une phrase qui dit ce que le devis propose, par exemple \xABMission de ma\xEEtrise d\u2019\u0153uvre, villa R+1\xA0\xBB."
              },
              language: {
                term: "Langue du PDF",
                text: "La langue du document envoy\xE9 au client\xA0: Fran\xE7ais, Arabe ou Bilingue (fran\xE7ais et arabe)."
              },
              validUntil: {
                term: "Valable jusqu\u2019au",
                text: "Obligatoire\xA0: apr\xE8s cette date, le client ne peut plus accepter. Une date d\xE9j\xE0 pass\xE9e est refus\xE9e."
              },
              currency: {
                term: "Devise",
                text: "La monnaie du devis\xA0: TND, EUR ou USD."
              },
              exchangeRate: {
                term: "Taux de change (TND pour 1 unit\xE9)",
                text: "Appara\xEEt pour une devise autre que le dinar\xA0: combien de dinars valent 1 unit\xE9, par exemple 3,350 pour 1 EUR. Les totaux sont alors aussi donn\xE9s en dinars."
              }
            }
          },
          calculator: {
            title: "Calcul des honoraires",
            items: {
              feeMode: {
                term: "Mode de calcul",
                text: "Comment calculer vos honoraires\xA0: Forfait r\xE9parti par phase, Pourcentage du co\xFBt des travaux, Au temps pass\xE9, ou Mixte (lignes saisies \xE0 la main)."
              },
              lumpTotal: {
                term: "Honoraires forfaitaires HT",
                text: "Pour le mode forfait\xA0: le montant total de vos honoraires, hors taxes."
              },
              worksCost: {
                term: "Co\xFBt estim\xE9 des travaux HT",
                text: "Pour le mode pourcentage\xA0: le co\xFBt estim\xE9 des travaux, hors taxes. Le champ \xABHonoraires calcul\xE9s HT\xA0\xBB affiche le r\xE9sultat."
              },
              rate: {
                term: "Taux d\u2019honoraires (%)",
                text: "Pour le mode pourcentage\xA0: le taux \xE0 appliquer au co\xFBt des travaux, par exemple 6 ou 4,5. Entre 0 et 100."
              },
              scale: {
                term: "Bar\xE8me de r\xE9f\xE9rence",
                text: "Facultatif\xA0: un bar\xE8me (par exemple le d\xE9cret 78-71 ou celui de votre bureau) donne une suggestion avec sa source. Elle n\u2019est appliqu\xE9e que si vous cliquez sur \xABUtiliser cette suggestion\xA0\xBB\xA0; un simple avertissement signale des honoraires sous le minimum."
              },
              shares: {
                term: "R\xE9partition par phase",
                text: "Pour les modes forfait et pourcentage\xA0: choisissez les phases et la \xABPart (%)\xA0\xBB de chacune, qui doivent totaliser 100 %. \xABAjouter une phase\xA0\xBB ajoute une ligne\xA0; \xABReprendre la r\xE9partition d\u2019un type de mission\xA0\xBB remplit les parts de d\xE9part."
              },
              time: {
                term: "Temps pass\xE9",
                text: "Pour le mode au temps pass\xE9\xA0: pour chaque \xABIntervention\xA0\xBB, indiquez \xABHeures ou jours\xA0\xBB et le \xABTarif unitaire HT\xA0\xBB. \xABAjouter une intervention\xA0\xBB ajoute une ligne."
              },
              propose: {
                term: "Proposer les lignes",
                text: "Transforme le calcul en lignes du devis, que vous pouvez encore modifier. Si des lignes existent d\xE9j\xE0, une fen\xEAtre \xABRemplacer les lignes actuelles\xA0?\xA0\xBB demande confirmation."
              }
            }
          },
          lines: {
            title: "Lignes du devis",
            items: {
              description: {
                term: "Description",
                text: "Obligatoire\xA0: ce que la ligne facture, en quelques mots."
              },
              phase: {
                term: "Phase",
                text: "Range la ligne dans une phase de la mission\xA0; \xABAucune phase\xA0\xBB la met dans \xABAutres lignes\xA0\xBB. Les lignes sont group\xE9es par phase avec un sous-total HT."
              },
              quantity: {
                term: "Quantit\xE9",
                text: "Obligatoire\xA0: un nombre positif avec au plus 3 d\xE9cimales."
              },
              unitPrice: {
                term: "Prix unitaire HT",
                text: "Obligatoire\xA0: le prix d\u2019une unit\xE9, hors taxes, dans la devise du devis."
              },
              vat: {
                term: "TVA",
                text: "Le taux de TVA de la ligne, \xE0 choisir parmi 19 %, 13 %, 7 % et 0 %."
              },
              amount: {
                term: "Montant HT",
                text: "Calcul\xE9 pour vous\xA0: quantit\xE9 \xD7 prix unitaire. Vous ne pouvez pas le modifier."
              },
              addRemove: {
                term: "Ajouter une ligne",
                text: "Ajoute une ligne vide\xA0; \xABAjouter une ligne \xE0 cette phase\xA0\xBB l\u2019ajoute dans la phase concern\xE9e. Le bouton \xE0 ic\xF4ne \xABSupprimer la ligne\xA0\xBB retire une ligne."
              },
              total: {
                term: "Total HT des lignes",
                text: "La somme des lignes, hors taxes, en bas de la section."
              }
            }
          },
          notesTotals: {
            title: "Notes et totaux",
            items: {
              notes: {
                term: "Notes pour le client",
                text: "Facultatif\xA0: conditions particuli\xE8res, hypoth\xE8ses, exclusions. Ce texte accompagne le devis."
              },
              totals: {
                term: "Totaux",
                text: "Le cadre des totaux (HT, TVA, timbre, TTC, retenues, net \xE0 payer) se calcule en direct. Il est indicatif\xA0: la facture recalcule les montants au moment de son \xE9mission."
              },
              needInfo: {
                term: "Choisissez un client pour calculer les totaux\u2026",
                text: "\xC0 la place du cadre, une phrase vous dit ce qui manque\xA0: un client, le taux de change (devise \xE9trang\xE8re) ou des lignes compl\xE8tes (quantit\xE9 et prix)."
              }
            }
          },
          history: {
            title: "Suivi du devis",
            items: {
              status: {
                term: "Statut",
                text: "Le statut du devis (Brouillon, Envoy\xE9, Accept\xE9, Refus\xE9, Expir\xE9), en t\xEAte de la liste."
              },
              created: {
                term: "Cr\xE9\xE9 le \u2026 par \u2026",
                text: "La date de cr\xE9ation et la personne qui a cr\xE9\xE9 le devis."
              },
              sent: {
                term: "Envoy\xE9 le \u2026 par \u2026",
                text: "La date d\u2019envoi et son auteur\xA0; sinon \xABCe devis n\u2019a pas encore \xE9t\xE9 envoy\xE9.\xA0\xBB"
              },
              linkExpires: {
                term: "Le lien du client est valable jusqu\u2019au \u2026",
                text: "Pour un devis envoy\xE9\xA0: la date jusqu\u2019\xE0 laquelle le lien re\xE7u par le client fonctionne."
              },
              accepted: {
                term: "Accept\xE9 le \u2026 par \u2026",
                text: "La date d\u2019acceptation et le nom \xE9crit par le client."
              },
              pdfHash: {
                term: "Empreinte du PDF accept\xE9 (SHA-256)",
                text: "Un code qui identifie exactement le PDF que le client a accept\xE9\xA0: il prouve que le document n\u2019a pas chang\xE9."
              },
              rejected: {
                term: "Refus\xE9 par le client le \u2026",
                text: "La date \xE0 laquelle le devis a \xE9t\xE9 marqu\xE9 comme refus\xE9."
              },
              pdfReady: {
                term: "PDF pr\xEAt / PDF en pr\xE9paration",
                text: "Indique si le PDF du devis est d\xE9j\xE0 g\xE9n\xE9r\xE9."
              }
            }
          },
          dialogs: {
            title: "Fen\xEAtres de confirmation",
            items: {
              send: {
                term: "Envoyer le devis",
                text: "Fen\xEAtre d\u2019envoi\xA0: choisissez le \xABDestinataire\xA0\xBB (l\u2019adresse e-mail du client ou l\u2019un de ses contacts) et, si vous voulez, un \xABMessage pour le client (facultatif)\xA0\xBB. Le lien envoy\xE9 est valable 30 jours."
              },
              convert: {
                term: "Cr\xE9er le projet",
                text: "Fen\xEAtre de cr\xE9ation\xA0: \xABNom du projet\xA0\xBB (obligatoire), \xABType de mission\xA0\xBB (ses phases et dossiers types sont cr\xE9\xE9s) et \xABCode du projet (facultatif)\xA0\xBB, g\xE9n\xE9r\xE9 si vous le laissez vide."
              },
              reject: {
                term: "Marquer le devis comme refus\xE9\xA0?",
                text: "Demande de confirmation avant de marquer le devis comme refus\xE9 par le client."
              },
              remove: {
                term: "Supprimer le brouillon\xA0?",
                text: "Demande de confirmation avant de supprimer d\xE9finitivement un brouillon jamais envoy\xE9."
              },
              editSent: {
                term: "Modifier un devis envoy\xE9\xA0?",
                text: "Pr\xE9vient que le devis repasse en brouillon et que le lien envoy\xE9 cesse de fonctionner\xA0; vous devrez le renvoyer."
              },
              leave: {
                term: "Quitter sans enregistrer\xA0?",
                text: "Appara\xEEt si vous quittez l\u2019\xE9cran avec des changements non enregistr\xE9s\xA0: \xABQuitter\xA0\xBB les abandonne, \xABRester sur le devis\xA0\xBB les garde."
              }
            }
          }
        }
      },
      contracts: {
        title: "Contrats",
        intro: "La liste des contrats de votre bureau (contrats priv\xE9s et march\xE9s publics) avec leurs montants et leurs dates cl\xE9s. Elle est utilis\xE9e par les personnes qui suivent les engagements sign\xE9s avec les clients.",
        sections: {
          header: {
            title: "En-t\xEAte de la page",
            items: {
              subNav: {
                term: "Finance",
                text: "Le menu de gauche liste les rubriques de la finance (Devis, Contrats, Factures, Paiements\u2026) que vos droits permettent d\u2019ouvrir\xA0; sur un petit \xE9cran, il devient une rang\xE9e de liens."
              },
              newContract: {
                term: "Nouveau contrat",
                text: "Ouvre un contrat vide. Visible seulement pour ceux qui g\xE8rent les contrats."
              }
            }
          },
          filters: {
            title: "Filtres des contrats",
            items: {
              kind: {
                term: "Nature du contrat",
                text: "Liste d\xE9roulante pour n\u2019afficher que les contrats priv\xE9s ou que les march\xE9s publics\xA0; \xABToutes les natures\xA0\xBB affiche tout."
              },
              clear: {
                term: "Effacer le filtre",
                text: "Appara\xEEt quand aucun contrat n\u2019a la nature choisie\xA0; il remet \xABToutes les natures\xA0\xBB."
              }
            }
          },
          table: {
            title: "Liste des contrats",
            items: {
              reference: {
                term: "R\xE9f\xE9rence",
                text: "Le num\xE9ro du march\xE9 ou de la convention. Cliquez dessus pour ouvrir le contrat."
              },
              client: {
                term: "Client",
                text: "Le client avec qui le contrat est sign\xE9."
              },
              kind: {
                term: "Nature",
                text: "Contrat priv\xE9 (accord entre deux parties) ou March\xE9 public (contrat avec un organisme public, soumis \xE0 des limites r\xE9glementaires)."
              }
            }
          },
          amounts: {
            title: "Montants et dates",
            items: {
              amount: {
                term: "Montant HT",
                text: "Le montant sign\xE9, hors taxes, avenants exclus."
              },
              total: {
                term: "Total avec avenants",
                text: "Le montant HT une fois les avenants ajout\xE9s (un avenant est un acte sign\xE9 qui change le montant)."
              },
              signedOn: {
                term: "Sign\xE9 le",
                text: "La date de signature\xA0; \xAB\u2014\xA0\xBB si elle n\u2019est pas renseign\xE9e."
              },
              bondReleaseOn: {
                term: "Lev\xE9e du cautionnement",
                text: "La date pr\xE9vue pour lib\xE9rer le cautionnement (la garantie d\xE9pos\xE9e en banque)\xA0; \xAB\u2014\xA0\xBB s\u2019il n\u2019y en a pas."
              }
            }
          },
          empty: {
            title: "Liste vide, erreur et chargement",
            items: {
              none: {
                term: "Aucun contrat pour le moment",
                text: "Message de la liste vide. Il propose \xABNouveau contrat\xA0\xBB \xE0 ceux qui g\xE8rent les contrats\xA0; les autres voient que les contrats de leur bureau appara\xEEtront ici."
              },
              noMatch: {
                term: "Aucun contrat ne correspond",
                text: "Message affich\xE9 quand le filtre ne trouve rien\xA0; le bouton \xABEffacer le filtre\xA0\xBB le retire."
              },
              loadMore: {
                term: "Afficher plus de contrats",
                text: "Plac\xE9 sous la liste\xA0: charge les contrats suivants."
              },
              loadError: {
                term: "Les contrats n\u2019ont pas pu \xEAtre charg\xE9s",
                text: "Message d\u2019erreur en cas de probl\xE8me de connexion\xA0; \xABR\xE9essayer\xA0\xBB relance le chargement."
              }
            }
          }
        }
      },
      contract: {
        title: "Contrat (nouveau ou existant)",
        intro: "L\u2019\xE9cran d\u2019un contrat\xA0: informations g\xE9n\xE9rales, conditions de paiement (avance, retenue, cautionnement, p\xE9nalit\xE9s), avenants et avancement factur\xE9. Les personnes qui g\xE8rent les contrats peuvent le modifier\xA0; les autres le consultent.",
        sections: {
          header: {
            title: "En-t\xEAte et messages",
            items: {
              subNav: {
                term: "Finance",
                text: "Le menu de gauche permet de passer \xE0 une autre rubrique de la finance, selon vos droits."
              },
              breadcrumb: {
                term: "Contrats",
                text: "Le lien en haut de page ram\xE8ne \xE0 la liste des contrats\xA0; une fen\xEAtre vous demande de confirmer s\u2019il reste des changements non enregistr\xE9s (\xABQuitter sans enregistrer\xA0?\xA0\xBB)."
              },
              save: {
                term: "Enregistrer",
                text: "Enregistre le contrat\xA0; le premier enregistrement le cr\xE9e. Visible seulement pour ceux qui g\xE8rent les contrats."
              },
              fromQuote: {
                term: "Contrat cr\xE9\xE9 \xE0 partir d\u2019un devis\xA0: ouvrir le devis",
                text: "Lien qui ram\xE8ne au devis d\u2019origine, pour ceux qui peuvent lire les devis."
              },
              notices: {
                term: "Bandeaux d\u2019information",
                text: "\xABVous pouvez consulter ce contrat, mais pas le modifier\xA0\xBB en lecture seule\xA0; \xABQuelqu\u2019un a modifi\xE9 ce contrat\xA0\xBB avec \xABRecharger le contrat\xA0\xBB\xA0; \xABLe contrat n\u2019a pas pu \xEAtre enregistr\xE9\xA0\xBB en cas d\u2019\xE9chec."
              }
            }
          },
          general: {
            title: "Informations g\xE9n\xE9rales",
            items: {
              client: {
                term: "Client",
                text: "Obligatoire \xE0 la cr\xE9ation. Le client d\u2019un contrat ne change plus ensuite."
              },
              project: {
                term: "Projet",
                text: "Facultatif\xA0: le projet du client concern\xE9, ou \xABAucun projet\xA0\xBB. Sans projet, l\u2019avancement par phase n\u2019est pas disponible."
              },
              reference: {
                term: "R\xE9f\xE9rence du contrat",
                text: "Obligatoire\xA0: le num\xE9ro du march\xE9 ou de la convention, unique dans votre bureau."
              },
              kind: {
                term: "Nature",
                text: "Contrat priv\xE9 ou March\xE9 public\xA0; un march\xE9 public affiche des avertissements si les conditions d\xE9passent les limites r\xE9glementaires."
              },
              currency: {
                term: "Devise",
                text: "La monnaie du contrat\xA0: TND, EUR ou USD."
              },
              amount: {
                term: "Montant HT",
                text: "Obligatoire\xA0: le montant sign\xE9, hors taxes, avenants exclus."
              },
              signedOn: {
                term: "Date de signature",
                text: "Facultatif\xA0: la date \xE0 laquelle le contrat a \xE9t\xE9 sign\xE9."
              },
              total: {
                term: "Total HT avec avenants\xA0:",
                text: "Affich\xE9 sur un contrat enregistr\xE9\xA0: le montant hors taxes, avenants compris. Calcul\xE9 pour vous."
              }
            }
          },
          terms: {
            title: "Conditions de paiement",
            items: {
              advance: {
                term: "Avance",
                text: "Une somme vers\xE9e au d\xE9but, en pourcentage du montant, par exemple 10."
              },
              retention: {
                term: "Retenue de garantie",
                text: "Un pourcentage retenu sur chaque facture de situation, lib\xE9r\xE9 par la facture finale."
              },
              retentionBase: {
                term: "Base de la retenue",
                text: "Sur quel montant la retenue est calcul\xE9e\xA0: Montant hors taxes (par d\xE9faut) ou Montant toutes taxes comprises. \xC0 confirmer avec votre expert-comptable."
              },
              bond: {
                term: "Cautionnement d\xE9finitif",
                text: "Une garantie bancaire exprim\xE9e en pourcentage du montant."
              },
              bondReleaseOn: {
                term: "Date de lev\xE9e du cautionnement",
                text: "Un rappel est envoy\xE9 7 jours avant et le jour m\xEAme. Ce champ n\u2019est actif que si un cautionnement est indiqu\xE9."
              },
              penaltyRate: {
                term: "P\xE9nalit\xE9 de retard par jour",
                text: "En pourcentage du montant, pour chaque jour de retard."
              },
              penaltyCap: {
                term: "Plafond des p\xE9nalit\xE9s",
                text: "Le maximum que les p\xE9nalit\xE9s peuvent atteindre, en pourcentage du montant."
              },
              warnings: {
                term: "Conditions au-dessus des limites d\u2019un march\xE9 public",
                text: "Pour un march\xE9 public, un bandeau orange liste les conditions qui d\xE9passent les limites, avec la r\xE9f\xE9rence l\xE9gale. Il ne bloque pas l\u2019enregistrement\xA0: le march\xE9 peut pr\xE9voir une d\xE9rogation."
              }
            }
          },
          amendments: {
            title: "Avenants",
            items: {
              total: {
                term: "Total HT avec avenants\xA0:",
                text: "Le montant du contrat une fois tous les avenants ajout\xE9s."
              },
              add: {
                term: "Ajouter un avenant",
                text: "Ouvre la fen\xEAtre d\u2019ajout. R\xE9serv\xE9 \xE0 ceux qui g\xE8rent les contrats\xA0; il faut d\u2019abord enregistrer vos modifications."
              },
              number: {
                term: "N\xB0",
                text: "Le num\xE9ro d\u2019ordre de l\u2019avenant."
              },
              label: {
                term: "Objet",
                text: "Ce que l\u2019avenant change, avec sa description s\u2019il y en a une."
              },
              delta: {
                term: "Variation du montant",
                text: "De combien l\u2019avenant augmente ou r\xE9duit le montant du contrat."
              },
              signedOn: {
                term: "Sign\xE9 le",
                text: "La date de signature de l\u2019avenant."
              },
              document: {
                term: "Document sign\xE9",
                text: "Le document sign\xE9 li\xE9 \xE0 l\u2019avenant (pris dans les documents du projet), ou \xAB\u2014\xA0\xBB s\u2019il n\u2019y en a pas."
              },
              empty: {
                term: "Aucun avenant",
                text: "Message du tableau vide\xA0: un avenant modifie le montant du contrat et, une fois enregistr\xE9, ne peut plus \xEAtre modifi\xE9."
              }
            }
          },
          amendmentDialog: {
            title: "Ajouter un avenant",
            items: {
              label: {
                term: "Objet de l\u2019avenant",
                text: "Obligatoire\xA0: ce que l\u2019avenant change."
              },
              description: {
                term: "Description (facultatif)",
                text: "Quelques pr\xE9cisions pour retrouver pourquoi l\u2019avenant existe."
              },
              delta: {
                term: "Variation du montant HT",
                text: "Obligatoire\xA0: positive pour une augmentation, n\xE9gative pour une r\xE9duction (par exemple -500)."
              },
              signedOn: {
                term: "Date de signature",
                text: "Obligatoire\xA0: la date \xE0 laquelle l\u2019avenant a \xE9t\xE9 sign\xE9."
              },
              document: {
                term: "Document sign\xE9 (GED)",
                text: "Facultatif\xA0: \xABChoisir un document\xA0\xBB parmi les dossiers du projet (\xABChanger\xA0\xBB ou \xABRetirer\xA0\xBB ensuite). Sans projet li\xE9 au contrat, cette zone est remplac\xE9e par un rappel."
              },
              submit: {
                term: "Ajouter l\u2019avenant",
                text: "Enregistre l\u2019avenant. Un avenant est un acte sign\xE9\xA0: il ne se modifie plus\xA0; en cas d\u2019erreur, ajoutez un avenant correctif. \xABAnnuler\xA0\xBB ferme la fen\xEAtre."
              }
            }
          },
          progress: {
            title: "Avancement factur\xE9",
            items: {
              summary: {
                term: "Total du contrat (HT)",
                text: "Un r\xE9capitulatif\xA0: total du contrat, avance, avance d\xE9j\xE0 r\xE9cup\xE9r\xE9e et retenue de garantie d\xE9j\xE0 op\xE9r\xE9e."
              },
              phases: {
                term: "Avancement factur\xE9 par phase",
                text: "Un tableau par phase\xA0: Phase, Statut, Honoraires, Factur\xE9 (cumul) et Montant factur\xE9."
              },
              prepare: {
                term: "Pr\xE9parer une facture de situation",
                text: "Ouvre l\u2019\xE9cran de facture de situation (facturation selon l\u2019avancement). R\xE9serv\xE9 \xE0 ceux qui peuvent cr\xE9er des factures, et seulement pour un contrat li\xE9 \xE0 un projet et en TND."
              },
              needProject: {
                term: "Rattachez ce contrat \xE0 un projet\u2026",
                text: "Message affich\xE9 quand le contrat n\u2019a pas de projet\xA0: le suivi par phase en a besoin."
              },
              needTnd: {
                term: "Les factures de situation se font en dinars\u2026",
                text: "Message affich\xE9 pour un contrat en EUR ou USD\xA0: l\u2019avancement n\u2019est pas disponible."
              }
            }
          }
        }
      },
      progress: {
        title: "Facture de situation",
        intro: "L\u2019\xE9cran qui pr\xE9pare une facture de situation\xA0: une facture \xE9tablie selon l\u2019avancement des phases du projet. Vous indiquez, pour chaque phase, o\xF9 en est l\u2019avancement, et le montant de la p\xE9riode se calcule tout seul.",
        sections: {
          header: {
            title: "En-t\xEAte et messages",
            items: {
              subNav: {
                term: "Finance",
                text: "Le menu de gauche reste affich\xE9 (la rubrique \xABFactures\xA0\xBB est mise en avant) et permet de changer de rubrique."
              },
              breadcrumb: {
                term: "Contrats",
                text: "Le fil d\u2019Ariane ram\xE8ne \xE0 la liste des contrats, puis au contrat lui-m\xEAme, pour ceux qui peuvent les lire."
              },
              submit: {
                term: "Cr\xE9er la facture brouillon",
                text: "Cr\xE9e une facture en brouillon avec le r\xE9sultat du calcul, puis l\u2019ouvre. Visible seulement pour ceux qui peuvent cr\xE9er des factures et quand la facture est possible."
              },
              blocked: {
                term: "Contrat clos / Les parts d\u2019honoraires des phases ne font pas 100\xA0%",
                text: "\xABContrat clos\xA0\xBB\xA0: la facture finale est \xE9mise, il n\u2019y a plus rien \xE0 pr\xE9parer. \xABLes parts d\u2019honoraires des phases ne font pas 100 %\xA0\xBB\xA0: corrigez-les via le lien \xABOuvrir les phases du projet\xA0\xBB."
              },
              errors: {
                term: "La facture n\u2019a pas pu \xEAtre cr\xE9\xE9e",
                text: "Un message explique pourquoi, par exemple s\u2019il n\u2019y a rien \xE0 facturer depuis la derni\xE8re facture ou si une facture de situation est encore en brouillon."
              }
            }
          },
          phases: {
            title: "Avancement par phase",
            items: {
              help: {
                term: "Avancement cumul\xE9",
                text: "Pour chaque phase, indiquez l\u2019avancement cumul\xE9 depuis le d\xE9but\xA0: le montant de la p\xE9riode est calcul\xE9 en direct, et le r\xE9capitulatif par phase est imprim\xE9 sur le PDF."
              },
              final: {
                term: "Facture finale \xE0 la r\xE9ception d\xE9finitive",
                text: "Interrupteur\xA0: toutes les phases passent \xE0 100 %, le reste de l\u2019avance est r\xE9cup\xE9r\xE9 et la retenue de garantie est lib\xE9r\xE9e. Les champs de pourcentage sont alors bloqu\xE9s."
              },
              phase: {
                term: "Phase",
                text: "Le nom de la phase du projet."
              },
              fee: {
                term: "Honoraires de la phase",
                text: "La part du montant du contrat qui revient \xE0 cette phase."
              },
              previous: {
                term: "D\xE9j\xE0 factur\xE9",
                text: "Le pourcentage de la phase d\xE9j\xE0 factur\xE9 par les factures de situation pr\xE9c\xE9dentes."
              },
              cumulative: {
                term: "Nouveau cumul",
                text: "\xC0 remplir\xA0: le nouveau pourcentage cumul\xE9 de la phase (0 \xE0 100, 2 d\xE9cimales au plus). Il ne peut pas \xEAtre inf\xE9rieur \xE0 \xABD\xE9j\xE0 factur\xE9\xA0\xBB."
              },
              period: {
                term: "Montant de la p\xE9riode",
                text: "Calcul\xE9 pour vous\xA0: le montant \xE0 facturer cette fois pour la phase\xA0; \xAB\u2014\xA0\xBB si le calcul est impossible."
              }
            }
          },
          totals: {
            title: "Montants de cette facture",
            items: {
              work: {
                term: "Travaux de la p\xE9riode (HT)",
                text: "Le total des montants de la p\xE9riode, hors taxes."
              },
              advanceRecovery: {
                term: "R\xE9cup\xE9ration de l\u2019avance",
                text: "La part de l\u2019avance vers\xE9e au d\xE9part qui est reprise sur cette facture."
              },
              retention: {
                term: "Retenue de garantie / Lib\xE9ration de la retenue de garantie",
                text: "La retenue gard\xE9e sur cette facture (avec son taux)\xA0; sur une facture finale, elle est remplac\xE9e par la lib\xE9ration de la retenue."
              },
              net: {
                term: "Net HT de la facture",
                text: "Le r\xE9sultat\xA0: travaux, moins la r\xE9cup\xE9ration d\u2019avance, moins la retenue (ou plus sa lib\xE9ration)."
              },
              taxesHint: {
                term: "TVA, timbre et retenues",
                text: "La TVA, le timbre et les retenues \xE0 la source sont calcul\xE9s sur la facture brouillon, qui s\u2019ouvre apr\xE8s l\u2019enregistrement. Si un pourcentage est faux, un message vous demande de le corriger d\u2019abord."
              }
            }
          },
          options: {
            title: "Options de la facture",
            items: {
              language: {
                term: "Langue du PDF",
                text: "La langue du document envoy\xE9 au client\xA0: Fran\xE7ais, Arabe ou Bilingue (fran\xE7ais et arabe)."
              },
              dueDate: {
                term: "Date d\u2019\xE9ch\xE9ance",
                text: "Facultatif\xA0: sans date, les conditions de paiement du client s\u2019appliquent."
              },
              notes: {
                term: "Notes",
                text: "Facultatif\xA0: un texte libre de 2 000 caract\xE8res au plus pour la facture."
              }
            }
          }
        }
      },
      invoices: {
        title: "Factures",
        intro: "La liste de toutes les factures de votre bureau (avances, acomptes, situations, factures finales et avoirs), avec leur \xE9tat, leur envoi \xE0 la facture \xE9lectronique et leur paiement. Elle sert \xE0 retrouver une facture, \xE0 voir ce qui reste \xE0 encaisser et \xE0 en cr\xE9er une nouvelle.",
        sections: {
          header: {
            title: "En-t\xEAte de la page",
            items: {
              subNav: {
                term: "Finance",
                text: "Le menu de gauche liste les rubriques de la finance que vos droits permettent d\u2019ouvrir (Devis, Contrats, Factures, Paiements\u2026)\xA0; sur un petit \xE9cran, il devient une rang\xE9e de liens."
              },
              newInvoice: {
                term: "Nouvelle facture",
                text: "Ouvre une facture vide. Visible seulement si vous avez le droit de cr\xE9er des factures\xA0; gris\xE9 quand le compte du bureau est en lecture seule."
              }
            }
          },
          filters: {
            title: "Filtres des factures",
            items: {
              status: {
                term: "Statut",
                text: "Montre seulement les factures Brouillon, \xC9mise ou Annul\xE9e par avoir\xA0; \xABTous les statuts\xA0\xBB affiche tout."
              },
              payment: {
                term: "Paiement",
                text: "Montre seulement les factures Impay\xE9e, Partiellement pay\xE9e ou Pay\xE9e\xA0; \xABTous les paiements\xA0\xBB affiche tout."
              },
              kind: {
                term: "Type",
                text: "Montre seulement un type de facture (avance, acompte, situation, finale ou avoir)\xA0; \xABTous les types\xA0\xBB affiche tout."
              },
              clear: {
                term: "Effacer les filtres",
                text: "Appara\xEEt quand aucune facture ne r\xE9pond aux filtres choisis\xA0; remet les trois filtres \xE0 z\xE9ro."
              }
            }
          },
          table: {
            title: "Liste des factures",
            items: {
              number: {
                term: "Num\xE9ro",
                text: "Le num\xE9ro d\xE9finitif de la facture, donn\xE9 \xE0 l\u2019\xE9mission. Un brouillon n\u2019en a pas encore\xA0: il affiche \xABBrouillon\xA0\xBB. Cliquez dessus pour ouvrir la facture."
              },
              client: {
                term: "Client",
                text: "Le client \xE0 qui la facture est adress\xE9e."
              },
              kind: {
                term: "Type",
                text: "Le type de la facture (voir \xABTypes de facture\xA0\xBB)."
              },
              status: {
                term: "Statut",
                text: "L\u2019\xE9tat de la facture elle-m\xEAme (voir \xAB\xC9tats de la facture et du paiement\xA0\xBB)."
              },
              ttn: {
                term: "E-facture (TTN)",
                text: "O\xF9 en est l\u2019envoi de la facture \xE0 TTN, la plateforme officielle de facturation \xE9lectronique\xA0; \xAB\u2014\xA0\xBB pour un brouillon."
              },
              payment: {
                term: "Paiement",
                text: "Si la facture est pay\xE9e\xA0; \xAB\u2014\xA0\xBB pour un brouillon et pour un avoir."
              }
            }
          },
          amounts: {
            title: "Montants et dates",
            items: {
              totalTtc: {
                term: "Total TTC",
                text: "Le total toutes taxes comprises de la facture."
              },
              netPayable: {
                term: "Net \xE0 payer",
                text: "Ce que le client doit r\xE9ellement vous r\xE9gler, apr\xE8s les \xE9ventuelles retenues \xE0 la source."
              },
              issueDate: {
                term: "\xC9mise le",
                text: "La date d\u2019\xE9mission\xA0; \xAB\u2014\xA0\xBB pour un brouillon."
              },
              dueDate: {
                term: "\xC9ch\xE9ance",
                text: "La date limite de paiement\xA0; \xAB\u2014\xA0\xBB si elle n\u2019est pas fix\xE9e."
              }
            }
          },
          statuses: {
            title: "\xC9tats de la facture et du paiement",
            items: {
              draft: {
                term: "Brouillon",
                text: "La facture se pr\xE9pare\xA0: elle n\u2019a pas de num\xE9ro et peut encore \xEAtre modifi\xE9e ou supprim\xE9e."
              },
              issued: {
                term: "\xC9mise",
                text: "La facture a son num\xE9ro d\xE9finitif et ne peut plus jamais \xEAtre modifi\xE9e\xA0; pour la corriger, on \xE9met un avoir."
              },
              credited: {
                term: "Annul\xE9e par avoir",
                text: "Un avoir a annul\xE9 la facture."
              },
              unpaid: {
                term: "Impay\xE9e",
                text: "Aucun paiement n\u2019a encore \xE9t\xE9 enregistr\xE9."
              },
              partiallyPaid: {
                term: "Partiellement pay\xE9e",
                text: "Une partie seulement a \xE9t\xE9 pay\xE9e."
              },
              paid: {
                term: "Pay\xE9e",
                text: "La facture est enti\xE8rement r\xE9gl\xE9e."
              }
            }
          },
          ttnStatuses: {
            title: "\xC9tats de l\u2019e-facture (TTN)",
            items: {
              notRequired: {
                term: "Non requise",
                text: "Cette facture ne passe pas par la facture \xE9lectronique."
              },
              pending: {
                term: "En attente",
                text: "L\u2019envoi \xE0 TTN est en pr\xE9paration."
              },
              submitted: {
                term: "Transmise",
                text: "La facture a \xE9t\xE9 envoy\xE9e \xE0 TTN, qui doit encore r\xE9pondre."
              },
              submittedManually: {
                term: "Transmise manuellement",
                text: "Vous avez d\xE9pos\xE9 la facture vous-m\xEAme sur le portail de TTN."
              },
              accepted: {
                term: "Accept\xE9e",
                text: "TTN a accept\xE9 la facture."
              },
              rejected: {
                term: "Rejet\xE9e",
                text: "TTN a refus\xE9 la facture\xA0; l\u2019\xE9cran de la facture explique quoi faire."
              }
            }
          },
          kinds: {
            title: "Types de facture",
            items: {
              advance: {
                term: "Facture d\u2019avance",
                text: "Facture d\u2019une somme demand\xE9e au d\xE9but d\u2019un contrat."
              },
              deposit: {
                term: "Facture d\u2019acompte",
                text: "Facture d\u2019un paiement partiel demand\xE9 \xE0 l\u2019avance."
              },
              progress: {
                term: "Facture de situation",
                text: "Facture \xE9tablie selon l\u2019avancement des travaux ou des phases."
              },
              final: {
                term: "Facture finale",
                text: "La derni\xE8re facture d\u2019un contrat, \xE0 la r\xE9ception d\xE9finitive."
              },
              creditNote: {
                term: "Avoir",
                text: "Document qui annule tout ou partie d\u2019une facture d\xE9j\xE0 \xE9mise."
              }
            }
          },
          empty: {
            title: "Liste vide, erreur et chargement",
            items: {
              none: {
                term: "Aucune facture pour le moment",
                text: "Message de la liste vide. Il propose \xABNouvelle facture\xA0\xBB \xE0 ceux qui peuvent en cr\xE9er\xA0; les autres voient que les factures de leur bureau appara\xEEtront ici."
              },
              noMatch: {
                term: "Aucune facture ne correspond",
                text: "Message affich\xE9 quand les filtres ne trouvent rien\xA0; \xABEffacer les filtres\xA0\xBB les retire."
              },
              loadMore: {
                term: "Afficher plus de factures",
                text: "Plac\xE9 sous la liste\xA0: charge les factures suivantes."
              },
              loadError: {
                term: "Les factures n\u2019ont pas pu \xEAtre charg\xE9es",
                text: "Message d\u2019erreur en cas de probl\xE8me de connexion\xA0; \xABR\xE9essayer\xA0\xBB relance le chargement."
              }
            }
          }
        }
      },
      invoice: {
        title: "Facture (nouvelle ou existante)",
        intro: "L\u2019\xE9cran d\u2019une facture\xA0: vous pr\xE9parez un brouillon (client, lignes, TVA), vous voyez les totaux en direct, puis vous l\u2019\xE9mettez. Une facture \xE9mise ou un avoir se consulte seulement\xA0; on y suit l\u2019envoi \xE9lectronique et les paiements.",
        sections: {
          header: {
            title: "En-t\xEAte et actions",
            items: {
              subNav: {
                term: "Finance",
                text: "Le menu de gauche permet de passer \xE0 une autre rubrique de la finance, selon vos droits."
              },
              breadcrumb: {
                term: "Factures",
                text: "Le lien en haut de page ram\xE8ne \xE0 la liste des factures\xA0; une fen\xEAtre vous demande de confirmer s\u2019il reste des changements non enregistr\xE9s."
              },
              save: {
                term: "Enregistrer",
                text: "Enregistre le brouillon\xA0; le premier enregistrement le cr\xE9e. Visible seulement pour un brouillon que vous pouvez modifier."
              },
              issue: {
                term: "\xC9mettre",
                text: "Sur un brouillon enregistr\xE9\xA0: donne \xE0 la facture son num\xE9ro d\xE9finitif. R\xE9serv\xE9 \xE0 ceux qui ont le droit d\u2019\xE9mettre\xA0; il faut d\u2019abord enregistrer vos modifications."
              },
              pdf: {
                term: "Voir le PDF",
                text: "Sur une facture \xE9mise ou un avoir\xA0: ouvre le PDF dans un nouvel onglet, ou dit de r\xE9essayer si le PDF est en pr\xE9paration."
              },
              recordPayment: {
                term: "Enregistrer un paiement",
                text: "Sur une facture \xE9mise pas encore pay\xE9e en totalit\xE9\xA0: ouvre la fen\xEAtre du paiement re\xE7u. R\xE9serv\xE9 \xE0 ceux qui peuvent enregistrer des paiements."
              },
              creditNote: {
                term: "\xC9mettre un avoir",
                text: "Sur une facture \xE9mise\xA0: ouvre la fen\xEAtre d\u2019avoir pour l\u2019annuler en tout ou en partie. R\xE9serv\xE9 \xE0 ceux qui ont le droit d\u2019\xE9mettre."
              },
              delete: {
                term: "Supprimer le brouillon",
                text: "Supprime d\xE9finitivement un brouillon, apr\xE8s confirmation\xA0; aucun num\xE9ro n\u2019a \xE9t\xE9 consomm\xE9."
              }
            }
          },
          messages: {
            title: "Messages et fen\xEAtres",
            items: {
              readOnly: {
                term: "Bandeaux de lecture seule",
                text: "\xABCette facture est \xE9mise\xA0: elle ne peut plus jamais \xEAtre modifi\xE9e\xA0\xBB (avec une invitation \xE0 \xE9mettre un avoir), \xABUn avoir \xE9mis est d\xE9finitif\xA0\xBB, ou \xABVous pouvez consulter cette facture, mais\u2026\xA0\xBB si vous n\u2019avez pas le droit de la modifier."
              },
              linesLocked: {
                term: "Lignes issues d\u2019une situation",
                text: "Sur un brouillon venu d\u2019une facture de situation, les lignes (avances, retenues) sont bloqu\xE9es\xA0; supprimez le brouillon et reconstruisez-le pour les changer. Les autres champs restent modifiables."
              },
              missing: {
                term: "Pour \xE9mettre cette facture, il reste \xE0 compl\xE9ter",
                text: "La liste des mentions obligatoires manquantes (profil fiscal du bureau, adresse ou identifiant fiscal du client, lignes\u2026). Les liens \xABCompl\xE9ter le profil fiscal\xA0\xBB et \xABOuvrir la fiche du client\xA0\xBB m\xE8nent \xE0 l\u2019endroit \xE0 corriger."
              },
              issueDialog: {
                term: "\xC9mettre cette facture\xA0?",
                text: "Rappelle le total TTC et le net \xE0 payer, avertit qu\u2019une facture \xE9mise ne peut plus \xEAtre modifi\xE9e (en cas d\u2019erreur on \xE9met un avoir) et pr\xE9vient qu\u2019une confirmation d\u2019identit\xE9 sera demand\xE9e. \xAB\xC9mettre la facture\xA0\xBB confirme."
              },
              issueProblems: {
                term: "Les montants ont chang\xE9 / Mentions obligatoires manquantes",
                text: "Si l\u2019\xE9mission est refus\xE9e\xA0: \xABLes montants ont chang\xE9\xA0\xBB (le brouillon affiche les nouveaux totaux\xA0; \xABCompris\xA0\xBB ferme le message) ou \xABMentions obligatoires manquantes\xA0\xBB avec la liste \xE0 compl\xE9ter."
              },
              creditMode: {
                term: "\xC9tendue de l\u2019avoir",
                text: "Dans la fen\xEAtre d\u2019avoir\xA0: \xABAnnuler la facture enti\xE8re (timbre compris)\xA0\xBB ou \xABCr\xE9diter certaines lignes\xA0\xBB. Dans ce second cas, cochez chaque ligne concern\xE9e et indiquez la quantit\xE9 \xE0 cr\xE9diter."
              },
              creditReason: {
                term: "Motif de l\u2019avoir",
                text: "Obligatoire, 500 caract\xE8res au plus. \xAB\xC9mettre l\u2019avoir\xA0\xBB cr\xE9e tout de suite l\u2019avoir, avec son propre num\xE9ro\xA0; \xABAnnuler\xA0\xBB ferme la fen\xEAtre."
              },
              stale: {
                term: "Quelqu\u2019un a modifi\xE9 cette facture",
                text: "Un autre utilisateur a enregistr\xE9 ce brouillon pendant que vous le modifiiez\xA0: \xABRecharger la facture\xA0\xBB affiche sa derni\xE8re version."
              }
            }
          },
          general: {
            title: "Informations g\xE9n\xE9rales",
            items: {
              kind: {
                term: "Type de facture",
                text: "Avance, acompte, situation de travaux ou facture finale (voir la liste des factures pour leur sens)."
              },
              client: {
                term: "Client",
                text: "Obligatoire\xA0: le ma\xEEtre d\u2019ouvrage \xE0 facturer. Changer de client vide le projet et les phases des lignes."
              },
              project: {
                term: "Projet",
                text: "Facultatif\xA0: permet de ranger les lignes par phase du projet."
              },
              series: {
                term: "S\xE9rie de num\xE9rotation",
                text: "Appara\xEEt seulement si le bureau a plusieurs s\xE9ries\xA0: le num\xE9ro est attribu\xE9 \xE0 l\u2019\xE9mission, sans trou. \xABS\xE9rie par d\xE9faut\xA0\xBB convient dans la plupart des cas."
              },
              language: {
                term: "Langue du PDF",
                text: "La langue de la facture imprim\xE9e\xA0: Fran\xE7ais, Arabe ou Bilingue (fran\xE7ais et arabe)."
              },
              currency: {
                term: "Devise et taux de change",
                text: "TND, EUR ou USD. Pour une devise \xE9trang\xE8re, le \xABTaux de change (TND pour 1 unit\xE9)\xA0\xBB est obligatoire (par exemple 3,350 pour 1 EUR) et les totaux sont aussi donn\xE9s en dinars."
              },
              vatTreatment: {
                term: "R\xE9gime de TVA",
                text: "Selon le client (par d\xE9faut), TVA normale, TVA en suspension ou Exportation (exon\xE9r\xE9e). Pour la suspension, la \xABR\xE9f\xE9rence du r\xE9gime\xA0\xBB (num\xE9ro de l\u2019attestation) est obligatoire."
              },
              dueDate: {
                term: "Date d\u2019\xE9ch\xE9ance",
                text: "Facultatif\xA0: sans date, le d\xE9lai de paiement du client s\u2019applique \xE0 l\u2019\xE9mission. Sur une facture \xE9mise, on voit aussi la \xABDate d\u2019\xE9mission\xA0\xBB et le \xABBar\xE8me fiscal appliqu\xE9\xA0\xBB."
              }
            }
          },
          lines: {
            title: "Lignes de la facture",
            items: {
              description: {
                term: "Description",
                text: "Obligatoire\xA0: ce que la ligne facture."
              },
              phase: {
                term: "Phase",
                text: "Appara\xEEt si un projet est choisi\xA0: range la ligne dans une phase du projet. Les lignes sont group\xE9es par phase, avec un sous-total HT."
              },
              quantity: {
                term: "Quantit\xE9",
                text: "Obligatoire\xA0: un nombre positif avec au plus 3 d\xE9cimales."
              },
              unitPrice: {
                term: "Prix unitaire HT",
                text: "Obligatoire\xA0: le prix d\u2019une unit\xE9, hors taxes."
              },
              vat: {
                term: "TVA",
                text: "Le taux de TVA de la ligne\xA0: 19 %, 13 %, 7 % ou 0 %."
              },
              amount: {
                term: "Montant HT",
                text: "Calcul\xE9 pour vous\xA0: quantit\xE9 \xD7 prix unitaire."
              },
              addRemove: {
                term: "Ajouter une ligne",
                text: "Ajoute une ligne vide\xA0; \xABAjouter une ligne \xE0 cette phase\xA0\xBB l\u2019ajoute \xE0 la phase. Le bouton \xE0 ic\xF4ne \xABSupprimer la ligne\xA0\xBB en retire une. \xABTotal HT des lignes\xA0\xBB donne la somme."
              },
              roles: {
                term: "Type de ligne",
                text: "Sur une facture \xE9mise, les lignes de situation sont suivies d\u2019un mot\xA0: R\xE9cup\xE9ration d\u2019avance, Retenue de garantie ou Restitution de retenue."
              }
            }
          },
          attachmentsNotes: {
            title: "Pi\xE8ces jointes et notes",
            items: {
              attachments: {
                term: "Pi\xE8ces jointes",
                text: "Les documents joints \xE0 la facture (par exemple un proc\xE8s-verbal de r\xE9ception). Pour en ajouter, tapez au moins 2 caract\xE8res du titre ou du code dans \xABRechercher un document \xE0 joindre\xA0\xBB\xA0; le bouton \xABRetirer\xA0\xBB enl\xE8ve une pi\xE8ce. Elles sont conserv\xE9es \xE0 titre l\xE9gal avec la facture une fois \xE9mise."
              },
              notes: {
                term: "Notes sur la facture",
                text: "Facultatif\xA0: imprim\xE9es sur la facture (conditions, mention particuli\xE8re), 2 000 caract\xE8res au plus."
              }
            }
          },
          totals: {
            title: "Totaux",
            items: {
              subtotalHt: {
                term: "Total HT",
                text: "La somme de toutes les lignes, avant taxes (HT veut dire hors taxes)."
              },
              vat: {
                term: "TVA (taux)",
                text: "La taxe sur la valeur ajout\xE9e, calcul\xE9e ligne par ligne avec le taux de chaque ligne. Elle peut \xEAtre \xABen suspension\xA0\xBB ou \xABexon\xE9r\xE9e \xE0 l\u2019export\xA0\xBB selon le r\xE9gime choisi."
              },
              stamp: {
                term: "Droit de timbre",
                text: "Un petit droit fixe ajout\xE9 \xE0 la facture. Il peut \xEAtre \xABExon\xE9r\xE9\xA0\xBB (export, acheteur public) ou conserv\xE9 sur un avoir partiel."
              },
              totalTtc: {
                term: "Total TTC",
                text: "Le total toutes taxes comprises\xA0: HT + TVA + timbre. C\u2019est le montant de la facture."
              },
              withholding: {
                term: "Retenue \xE0 la source (taux)",
                text: "Une part du total que certains clients (organismes publics, soci\xE9t\xE9s) gardent pour la verser eux-m\xEAmes \xE0 l\u2019administration fiscale. Elle s\u2019affiche en moins et n\u2019appara\xEEt que si elle s\u2019applique \xE0 ce client."
              },
              vatWithholding: {
                term: "Retenue \xE0 la source sur la TVA (taux)",
                text: "Une partie de la TVA que le client retient pour la verser au Tr\xE9sor (organismes publics). Elle s\u2019affiche aussi en moins."
              },
              netPayable: {
                term: "Net \xE0 payer",
                text: "Ce que le client vous r\xE8gle r\xE9ellement\xA0: le total TTC moins les retenues. Par exemple, pour 11 544,000 TND TTC et 173,000 TND retenus, le net \xE0 payer est de 11 371,000 TND."
              },
              details: {
                term: "Mentions sous le cadre",
                text: "Sous certaines lignes\xA0: la base de calcul, la r\xE9f\xE9rence l\xE9gale, \xABR\xE8gle \xE0 v\xE9rifier\xA0\xBB (selon l\u2019environnement). Plus bas\xA0: la mention de TVA en suspension ou \xE0 l\u2019export, le \xABMontant en lettres\xA0\xBB et, pour une devise \xE9trang\xE8re, la contre-valeur en dinars."
              }
            }
          },
          history: {
            title: "Suivi de la facture",
            items: {
              statuses: {
                term: "\xC9tats de la facture",
                text: "Trois pastilles\xA0: Facture (Brouillon, \xC9mise, Annul\xE9e par avoir), E-facture (TTN) et Paiement, ces deux derni\xE8res seulement une fois la facture \xE9mise."
              },
              created: {
                term: "Cr\xE9\xE9e le \u2026 par \u2026",
                text: "La date de cr\xE9ation et son auteur."
              },
              issued: {
                term: "\xC9mise sous le num\xE9ro \u2026 le \u2026 par \u2026",
                text: "Le num\xE9ro, la date et la personne qui a \xE9mis la facture\xA0; sinon \xABCette facture n\u2019est pas encore \xE9mise\xA0: elle n\u2019a pas de num\xE9ro\xA0\xBB."
              },
              legalHold: {
                term: "Conserv\xE9e \xE0 titre l\xE9gal jusqu\u2019au \u2026",
                text: "La date jusqu\u2019\xE0 laquelle la facture et ses pi\xE8ces jointes doivent \xEAtre conserv\xE9es."
              },
              credits: {
                term: "Avoirs",
                text: "\xABAvoir sur la facture\xA0\xBB avec un lien vers la facture d\u2019origine, et \xABD\xE9j\xE0 cr\xE9dit\xE9 par des avoirs\xA0\xBB avec le montant cr\xE9dit\xE9."
              },
              pdf: {
                term: "PDF pr\xEAt / PDF en pr\xE9paration",
                text: "Indique si le PDF de la facture est d\xE9j\xE0 g\xE9n\xE9r\xE9."
              },
              payments: {
                term: "Paiement du \u2026 (mode)\xA0: montant",
                text: "Un paiement par ligne, avec la date, le mode et le montant, plus les sommes retenues par le client. S\u2019il n\u2019y en a pas\xA0: \xABAucun paiement enregistr\xE9.\xA0\xBB R\xE9serv\xE9 \xE0 ceux qui peuvent lire les paiements."
              }
            }
          },
          einvoice: {
            title: "Facture \xE9lectronique (El Fatoora)",
            items: {
              panel: {
                term: "Facture \xE9lectronique (El Fatoora)",
                text: "Pour une facture \xE9mise qui passe par la facture \xE9lectronique\xA0: o\xF9 en est l\u2019envoi \xE0 TTN, ce qu\u2019il faut faire ensuite et la liste des tentatives. La page se met \xE0 jour toute seule."
              },
              attempts: {
                term: "Envois \xE0 TTN",
                text: "Chaque tentative a son num\xE9ro, un statut (Sign\xE9e, Envoy\xE9e \xE0 TTN, Accept\xE9e, Rejet\xE9e, \xC9chec, D\xE9pos\xE9e manuellement), ses dates et la r\xE9f\xE9rence TTN\xA0; s\u2019il n\u2019y en a pas\xA0: \xABAucun envoi \xE0 TTN pour le moment\xA0\xBB."
              },
              wait: {
                term: "En cours de traitement par TTN",
                text: "Aucune action n\u2019est n\xE9cessaire\xA0: la page se met \xE0 jour d\xE8s que TTN r\xE9pond."
              },
              resubmit: {
                term: "Corriger puis renvoyer",
                text: "Quand TTN rejette la facture ou que l\u2019envoi \xE9choue\xA0: le motif est expliqu\xE9, puis ce bouton renvoie la facture avec le m\xEAme num\xE9ro, sans la modifier. Il faut parfois d\u2019abord r\xE9gler un certificat (lien \xABG\xE9rer les certificats de signature\xA0\xBB)."
              },
              creditNoteNeeded: {
                term: "TTN refuse le contenu de la facture",
                text: "Le num\xE9ro d\u2019une facture \xE9mise ne peut pas \xEAtre r\xE9utilis\xE9 avec un contenu corrig\xE9\xA0: le bouton \xAB\xC9mettre un avoir\xA0\xBB annule la facture, puis vous cr\xE9ez une nouvelle facture corrig\xE9e."
              },
              manual: {
                term: "Envoi automatique impossible\xA0: d\xE9p\xF4t manuel",
                text: "Trois \xE9tapes\xA0: \xABT\xE9l\xE9charger le TEIF\xA0\xBB (le fichier de la facture, sign\xE9 ou non), le d\xE9poser sur le portail El Fatoora de TTN, puis noter la \xABR\xE9f\xE9rence TTN\xA0\xBB re\xE7ue (3 \xE0 100 caract\xE8res) et \xABEnregistrer la r\xE9f\xE9rence\xA0\xBB."
              },
              accepted: {
                term: "Facture accept\xE9e par TTN",
                text: "Le PDF de la facture porte maintenant la r\xE9f\xE9rence TTN et le code QR."
              },
              manualDone: {
                term: "Facture d\xE9pos\xE9e manuellement sur le portail TTN",
                text: "Confirme le d\xE9p\xF4t manuel et rappelle la r\xE9f\xE9rence saisie \xE0 la main."
              }
            }
          }
        }
      },
      payments: {
        title: "Paiements",
        intro: "La liste des paiements re\xE7us de vos clients, avec l\u2019\xE9tat des certificats de retenue \xE0 la source, la balance \xE2g\xE9e des cr\xE9ances et les r\xE9glages de relance. Elle est utilis\xE9e par les personnes qui suivent les encaissements.",
        sections: {
          header: {
            title: "En-t\xEAte de la page",
            items: {
              subNav: {
                term: "Finance",
                text: "Le menu de gauche liste les rubriques de la finance que vos droits permettent d\u2019ouvrir (Devis, Contrats, Factures, Paiements\u2026)\xA0; sur un petit \xE9cran, il devient une rang\xE9e de liens."
              },
              recordFrom: {
                term: "Enregistrer un paiement",
                text: "Il n\u2019y a pas de bouton de cr\xE9ation ici\xA0: un paiement s\u2019enregistre depuis une facture \xE9mise, avec \xABEnregistrer un paiement\xA0\xBB (voir plus bas)."
              }
            }
          },
          table: {
            title: "Paiements re\xE7us",
            items: {
              receivedOn: {
                term: "Re\xE7u le",
                text: "La date \xE0 laquelle l\u2019argent a \xE9t\xE9 re\xE7u."
              },
              invoice: {
                term: "Facture",
                text: "Le num\xE9ro de la facture pay\xE9e. Cliquez dessus pour l\u2019ouvrir."
              },
              client: {
                term: "Client",
                text: "Le client qui a pay\xE9."
              },
              method: {
                term: "Mode",
                text: "Comment le client a pay\xE9 (voir \xABModes de paiement\xA0\xBB)."
              },
              amount: {
                term: "Montant re\xE7u",
                text: "Le montant r\xE9ellement encaiss\xE9, net des retenues."
              },
              empty: {
                term: "Aucun paiement pour le moment",
                text: "Message de la liste vide\xA0: les paiements s\u2019enregistrent depuis une facture \xE9mise. \xABAfficher plus de paiements\xA0\xBB charge la suite\xA0; en cas d\u2019erreur, \xABR\xE9essayer\xA0\xBB relance le chargement."
              }
            }
          },
          withholdings: {
            title: "Retenues et certificat",
            items: {
              withholding: {
                term: "RAS",
                text: "La retenue \xE0 la source\xA0: la part que le client a gard\xE9e pour la verser \xE0 l\u2019administration fiscale."
              },
              vatWithholding: {
                term: "RAS TVA",
                text: "La retenue \xE0 la source sur la TVA, gard\xE9e par le client (organismes publics) pour le Tr\xE9sor."
              },
              certificate: {
                term: "Certificat de retenue",
                text: "Le document que le client doit vous remettre quand il retient une somme. \xABRe\xE7u\xA0\xBB (avec sa r\xE9f\xE9rence TEJ), \xABManquant\xA0\xBB ou \xABSans objet\xA0\xBB quand rien n\u2019a \xE9t\xE9 retenu."
              },
              add: {
                term: "Ajouter",
                text: "\xC0 c\xF4t\xE9 de \xABManquant\xA0\xBB\xA0: ouvre la fen\xEAtre pour joindre le certificat. R\xE9serv\xE9 \xE0 ceux qui peuvent enregistrer des paiements."
              },
              reference: {
                term: "R\xE9f\xE9rence",
                text: "Le num\xE9ro de virement, de remise\u2026 not\xE9 avec le paiement\xA0; \xAB\u2014\xA0\xBB s\u2019il n\u2019y en a pas."
              }
            }
          },
          methods: {
            title: "Modes de paiement",
            items: {
              transfer: {
                term: "Virement",
                text: "Paiement par virement bancaire."
              },
              cheque: {
                term: "Ch\xE8que",
                text: "Paiement par ch\xE8que\xA0: le num\xE9ro, la banque et la validit\xE9 sont demand\xE9s."
              },
              bill: {
                term: "Effet de commerce",
                text: "Paiement par effet de commerce (traite)."
              },
              cash: {
                term: "Esp\xE8ces",
                text: "Paiement en liquide\xA0; un avertissement peut signaler qu\u2019un montant \xE9lev\xE9 n\u2019est pas d\xE9ductible pour le client."
              },
              online: {
                term: "Paiement en ligne",
                text: "Paiement fait par internet."
              }
            }
          },
          certificateDialog: {
            title: "Certificat de retenue",
            items: {
              tej: {
                term: "R\xE9f\xE9rence TEJ du certificat de retenue",
                text: "Facultatif\xA0: la r\xE9f\xE9rence donn\xE9e par le syst\xE8me TEJ de l\u2019administration fiscale."
              },
              document: {
                term: "Certificat de retenue (document)",
                text: "Facultatif\xA0: recherchez le scan d\xE9pos\xE9 dans les documents. Il faut au moins la r\xE9f\xE9rence ou le document."
              },
              save: {
                term: "Enregistrer le certificat",
                text: "Enregistre le certificat sur le paiement. \xABAnnuler\xA0\xBB ferme la fen\xEAtre."
              }
            }
          },
          recordDialog: {
            title: "Enregistrer un paiement sur une facture",
            items: {
              outstanding: {
                term: "Reste d\xFB avant ce paiement",
                text: "Le montant qui reste \xE0 payer sur la facture. Une phrase en dessous montre ce que ce paiement r\xE8gle et ce qui reste d\xFB apr\xE8s."
              },
              receivedOn: {
                term: "Date de r\xE9ception",
                text: "Obligatoire\xA0: la date \xE0 laquelle le paiement est arriv\xE9\xA0; elle ne peut pas \xEAtre dans le futur."
              },
              method: {
                term: "Mode de paiement",
                text: "Virement, Ch\xE8que, Effet de commerce, Esp\xE8ces ou Paiement en ligne."
              },
              amounts: {
                term: "Montant re\xE7u, Retenue \xE0 la source (RAS), RAS sur la TVA",
                text: "Les montants sont propos\xE9s d\u2019apr\xE8s la facture et vous pouvez les corriger. Le paiement ne peut pas d\xE9passer ce qui reste d\xFB."
              },
              cheque: {
                term: "Num\xE9ro du ch\xE8que, Banque, Ch\xE8que valable jusqu\u2019au",
                text: "Pour un ch\xE8que seulement\xA0: le num\xE9ro et la banque sont obligatoires\xA0; sans date, la validit\xE9 du bar\xE8me fiscal s\u2019applique (6 mois)."
              },
              reference: {
                term: "R\xE9f\xE9rence du paiement",
                text: "Facultatif\xA0: num\xE9ro de virement, de remise\u2026"
              },
              certificate: {
                term: "R\xE9f\xE9rence TEJ du certificat de retenue",
                text: "Facultatif\xA0: vous pouvez aussi joindre le document du certificat\xA0; l\u2019ajout reste possible plus tard."
              },
              result: {
                term: "Paiement enregistr\xE9",
                text: "Apr\xE8s l\u2019enregistrement\xA0: ce qui reste \xE0 encaisser, l\u2019\xE9tat de la facture (impay\xE9e, partiellement pay\xE9e, pay\xE9e) et d\u2019\xE9ventuels avertissements. \xABFermer\xA0\xBB termine."
              }
            }
          },
          aging: {
            title: "Balance \xE2g\xE9e des cr\xE9ances",
            items: {
              intro: {
                term: "Situation au \u2026",
                text: "Ce que vos clients vous doivent encore, class\xE9 selon le retard sur l\u2019\xE9ch\xE9ance, en dinars. Visible seulement avec le droit d\u2019acc\xE8s au tableau de bord financier."
              },
              client: {
                term: "Client",
                text: "Une ligne par client, puis la ligne \xABTotal\xA0\xBB."
              },
              invoices: {
                term: "Factures",
                text: "Le nombre de factures non r\xE9gl\xE9es du client."
              },
              current: {
                term: "Non \xE9chu",
                text: "Les sommes dont l\u2019\xE9ch\xE9ance n\u2019est pas encore arriv\xE9e."
              },
              late: {
                term: "0 \xE0 30 jours, 31 \xE0 60 jours, 61 \xE0 90 jours",
                text: "Les sommes en retard, class\xE9es par dur\xE9e de retard."
              },
              over90: {
                term: "Plus de 90 jours",
                text: "Les sommes en retard depuis plus de 90 jours."
              },
              total: {
                term: "Total d\xFB",
                text: "Le total que le client vous doit. S\u2019il n\u2019y a rien\xA0: \xABAucune cr\xE9ance en cours.\xA0\xBB"
              }
            }
          },
          reminders: {
            title: "Relances des clients",
            items: {
              enabled: {
                term: "Envoyer des relances automatiques",
                text: "Interrupteur\xA0: un e-mail de relance est envoy\xE9 au client en cas de retard de paiement."
              },
              days: {
                term: "Jours de relance apr\xE8s l\u2019\xE9ch\xE9ance",
                text: "Jusqu\u2019\xE0 5 jours, du plus petit au plus grand, s\xE9par\xE9s par des virgules (par exemple 7, 15, 30)."
              },
              save: {
                term: "Enregistrer les relances",
                text: "Enregistre ces r\xE9glages. R\xE9serv\xE9 aux personnes autoris\xE9es \xE0 modifier le profil fiscal\xA0; pour les autres, un message dit que seul un administrateur peut les modifier."
              }
            }
          }
        }
      },
      expenses: {
        title: "Notes de frais",
        intro: "Vos notes de frais\xA0: vous d\xE9clarez une d\xE9pense avec son justificatif (photo ou PDF), puis un approbateur la valide avant son remboursement. Tous les membres peuvent d\xE9clarer leurs d\xE9penses.",
        sections: {
          header: {
            title: "En-t\xEAte et onglets",
            items: {
              subNav: {
                term: "Finance",
                text: "Le menu de gauche liste les rubriques de la finance que vos droits permettent d\u2019ouvrir\xA0; sur un petit \xE9cran, il devient une rang\xE9e de liens."
              },
              newExpense: {
                term: "Nouvelle note de frais",
                text: "Ouvre le formulaire de d\xE9claration d\u2019une d\xE9pense. Le bouton dispara\xEEt pendant que le formulaire est ouvert."
              },
              tabs: {
                term: "Mes notes de frais / \xC0 approuver",
                text: "Deux onglets visibles seulement pour ceux qui approuvent ou lisent toutes les notes de frais\xA0: vos propres d\xE9penses, et la file des notes \xE0 traiter."
              }
            }
          },
          list: {
            title: "Mes notes de frais",
            items: {
              status: {
                term: "Statut",
                text: "Montre seulement les notes En attente, Approuv\xE9e, Refus\xE9e ou Rembours\xE9e\xA0; \xABTous les statuts\xA0\xBB affiche tout."
              },
              empty: {
                term: "Aucune note de frais",
                text: "Message de la liste vide\xA0: photographiez le justificatif puis d\xE9clarez la d\xE9pense. Le bouton \xABNouvelle note de frais\xA0\xBB est propos\xE9 \xE0 ceux qui peuvent d\xE9clarer."
              },
              filtered: {
                term: "Aucune note de frais avec ce statut",
                text: "Message quand le filtre ne trouve rien\xA0; \xABAfficher toutes mes notes de frais\xA0\xBB le retire."
              },
              loadMore: {
                term: "Afficher plus de notes de frais",
                text: "Plac\xE9 sous la liste\xA0: charge la suite. En cas d\u2019erreur, \xABR\xE9essayer\xA0\xBB relance le chargement."
              }
            }
          },
          card: {
            title: "Une note de frais",
            items: {
              head: {
                term: "Objet et statut",
                text: "En titre, ce pour quoi la d\xE9pense a \xE9t\xE9 faite, avec son statut \xE9crit en toutes lettres."
              },
              meta: {
                term: "Cat\xE9gorie, date et projet",
                text: "La cat\xE9gorie, \xABD\xE9pense du \u2026\xA0\xBB et le projet concern\xE9 (ou \xABSans projet\xA0\xBB)."
              },
              amounts: {
                term: "Total TTC",
                text: "Le montant pay\xE9, avec en dessous le d\xE9tail HT et TVA, et si la TVA est d\xE9ductible ou non."
              },
              decision: {
                term: "D\xE9cision",
                text: "Qui a approuv\xE9 ou refus\xE9 la note et quand\xA0; pour un refus, le \xABMotif\xA0\xBB \xE9crit par l\u2019approbateur\xA0; pour un remboursement, la date."
              },
              receipt: {
                term: "Voir le justificatif",
                text: "Ouvre le justificatif dans un nouvel onglet. Tant que la v\xE9rification antivirus n\u2019est pas finie, \xABJustificatif en cours de v\xE9rification\xA0\xBB s\u2019affiche \xE0 la place."
              },
              resubmit: {
                term: "Soumettre \xE0 nouveau",
                text: "Sur une note refus\xE9e\xA0: rouvre le formulaire avec les informations d\u2019origine pour les corriger et renvoyer la note."
              }
            }
          },
          statuses: {
            title: "Statuts d\u2019une note de frais",
            items: {
              submitted: {
                term: "En attente",
                text: "La note est envoy\xE9e aux approbateurs, qui n\u2019ont pas encore d\xE9cid\xE9."
              },
              approved: {
                term: "Approuv\xE9e",
                text: "Un approbateur a accept\xE9 la d\xE9pense\xA0; elle reste \xE0 rembourser."
              },
              rejected: {
                term: "Refus\xE9e",
                text: "La d\xE9pense est refus\xE9e avec un motif\xA0; vous pouvez la corriger et la soumettre \xE0 nouveau."
              },
              reimbursed: {
                term: "Rembours\xE9e",
                text: "Le remboursement a \xE9t\xE9 fait."
              }
            }
          },
          formReceipt: {
            title: "Nouvelle note de frais\xA0: justificatif",
            items: {
              intro: {
                term: "Nouvelle note de frais",
                text: "Le formulaire commence par le justificatif. Pour une note refus\xE9e, il s\u2019appelle \xABSoumettre \xE0 nouveau la note de frais\xA0\xBB et garde le justificatif d\u2019origine."
              },
              takePhoto: {
                term: "Prendre une photo",
                text: "Ouvre l\u2019appareil photo du t\xE9l\xE9phone pour photographier le ticket ou la facture."
              },
              chooseFile: {
                term: "Choisir un fichier",
                text: "Choisit une image ou un PDF d\xE9j\xE0 enregistr\xE9. Un seul justificatif par note."
              },
              upload: {
                term: "Envoi du justificatif",
                text: "Une ligne montre l\u2019avancement de l\u2019envoi puis la v\xE9rification antivirus. Le justificatif est obligatoire, et un fichier refus\xE9 doit \xEAtre remplac\xE9."
              }
            }
          },
          formDetails: {
            title: "Nouvelle note de frais\xA0: la d\xE9pense",
            items: {
              category: {
                term: "Cat\xE9gorie",
                text: "Obligatoire\xA0: Transport, Carburant, H\xE9bergement, Restauration, Fournitures, Impression et reprographie, Logiciels et abonnements, T\xE9l\xE9communications, Formation, Frais de permis et redevances ou Autre."
              },
              label: {
                term: "Objet de la d\xE9pense",
                text: "Obligatoire\xA0: ce pour quoi vous avez d\xE9pens\xE9, par exemple \xABp\xE9age autoroute, achat de toner\xA0\xBB."
              },
              spentOn: {
                term: "Date de la d\xE9pense",
                text: "Obligatoire\xA0: elle ne peut pas \xEAtre dans le futur."
              },
              project: {
                term: "Projet",
                text: "Facultatif\xA0: seuls vos projets sont propos\xE9s\xA0; \xABAucun projet\xA0\xBB sinon."
              }
            }
          },
          formAmounts: {
            title: "Nouvelle note de frais\xA0: montants",
            items: {
              ttc: {
                term: "Total TTC",
                text: "Obligatoire\xA0: le montant total pay\xE9, tel qu\u2019il figure sur le justificatif."
              },
              vatRate: {
                term: "Taux de TVA",
                text: "Le taux sert \xE0 calculer le HT et la TVA \xE0 partir du total TTC."
              },
              ht: {
                term: "Montant HT",
                text: "Le montant hors taxes, calcul\xE9 mais modifiable."
              },
              vat: {
                term: "TVA",
                text: "Calcul\xE9e avec le taux choisi\xA0: corrigez-la si le justificatif indique autre chose. HT + TVA doit toujours \xE9galer le TTC."
              },
              vatDeductible: {
                term: "La TVA de ce justificatif est d\xE9ductible",
                text: "Case \xE0 cocher\xA0: indique si la TVA de cette d\xE9pense peut \xEAtre d\xE9duite par le bureau."
              },
              submit: {
                term: "Envoyer la note de frais",
                text: "Envoie la note \xE0 vos approbateurs. \xABAnnuler\xA0\xBB ferme le formulaire sans rien envoyer. Un r\xE9sum\xE9 \xABHT + TVA = TTC\xA0\xBB est affich\xE9 au-dessus."
              }
            }
          }
        }
      },
      expenseApprovals: {
        title: "Notes de frais \xE0 traiter",
        intro: "La file des notes de frais de l\u2019\xE9quipe\xA0: vous approuvez ou refusez les notes en attente, puis vous marquez comme rembours\xE9es celles qui ont \xE9t\xE9 pay\xE9es. Elle est r\xE9serv\xE9e aux personnes qui approuvent ou lisent toutes les notes de frais.",
        sections: {
          header: {
            title: "En-t\xEAte et onglets",
            items: {
              subNav: {
                term: "Finance",
                text: "Le menu de gauche liste les rubriques de la finance que vos droits permettent d\u2019ouvrir\xA0; sur un petit \xE9cran, il devient une rang\xE9e de liens."
              },
              tabs: {
                term: "Mes notes de frais / \xC0 approuver",
                text: "Deux onglets\xA0: vos propres d\xE9penses, et cette file \xAB\xC0 approuver\xA0\xBB."
              },
              hint: {
                term: "Notes de frais \xE0 traiter",
                text: "Le titre, et sous lui un rappel\xA0: approuvez ou refusez les notes en attente, puis marquez-les comme rembours\xE9es une fois le paiement effectu\xE9."
              },
              scope: {
                term: "Vous voyez les notes de frais de vos projets.",
                text: "Message d\u2019information pour les chefs de projet\xA0: ils ne voient que les notes de leurs projets."
              }
            }
          },
          list: {
            title: "Liste des notes de frais",
            items: {
              status: {
                term: "Statut",
                text: "La liste s\u2019ouvre sur les notes \xABEn attente\xA0\xBB\xA0; changez le statut (Approuv\xE9e, Refus\xE9e, Rembours\xE9e) ou choisissez \xABTous les statuts\xA0\xBB."
              },
              card: {
                term: "Une note de frais",
                text: "Chaque carte montre l\u2019objet, le statut, la cat\xE9gorie, la date, le projet, \xABD\xE9clar\xE9e par \u2026\xA0\xBB, le total TTC et le justificatif (\xABVoir le justificatif\xA0\xBB)."
              },
              empty: {
                term: "Aucune note de frais \xE0 traiter",
                text: "Message de la liste vide\xA0: les notes d\xE9clar\xE9es par l\u2019\xE9quipe appara\xEEtront ici. Pour un autre statut sans r\xE9sultat\xA0: \xABAfficher tous les statuts\xA0\xBB."
              },
              loadMore: {
                term: "Afficher plus de notes de frais",
                text: "Plac\xE9 sous la liste\xA0: charge la suite. En cas d\u2019erreur, \xABR\xE9essayer\xA0\xBB relance le chargement."
              }
            }
          },
          actions: {
            title: "D\xE9cider d\u2019une note",
            items: {
              approve: {
                term: "Approuver",
                text: "Sur une note en attente\xA0: accepte la d\xE9pense. R\xE9serv\xE9 \xE0 ceux qui ont le droit d\u2019approuver."
              },
              reject: {
                term: "Refuser",
                text: "Sur une note en attente\xA0: ouvre la fen\xEAtre de refus, o\xF9 un motif est obligatoire."
              },
              reimbursed: {
                term: "Marquer comme rembours\xE9e",
                text: "Sur une note approuv\xE9e\xA0: confirme que la d\xE9pense a \xE9t\xE9 rembours\xE9e. R\xE9serv\xE9 aux approbateurs de tout le bureau (pas aux chefs de projet)."
              },
              own: {
                term: "Vous ne pouvez pas d\xE9cider de votre propre note de frais\u2026",
                text: "Sur votre propre note en attente, aucun bouton n\u2019est propos\xE9\xA0: un autre approbateur doit s\u2019en charger."
              },
              stale: {
                term: "Cette note de frais a chang\xE9",
                text: "Si quelqu\u2019un l\u2019a d\xE9j\xE0 trait\xE9e, la liste est actualis\xE9e et ce message vous invite \xE0 v\xE9rifier avant de r\xE9essayer."
              }
            }
          },
          rejectDialog: {
            title: "Refuser la note de frais",
            items: {
              body: {
                term: "Refuser la note de frais \xAB\u2026\xA0\xBB",
                text: "Le motif est communiqu\xE9 \xE0 la personne qui a d\xE9clar\xE9 la d\xE9pense\xA0; elle pourra corriger la note et la soumettre \xE0 nouveau."
              },
              reason: {
                term: "Motif du refus",
                text: "Obligatoire\xA0: 500 caract\xE8res au maximum."
              },
              confirm: {
                term: "Refuser la note de frais",
                text: "Confirme le refus et pr\xE9vient la personne. \xABAnnuler\xA0\xBB ferme la fen\xEAtre."
              }
            }
          },
          reimburseDialog: {
            title: "Marquer comme rembours\xE9e",
            items: {
              body: {
                term: "Marquer \xAB\u2026\xA0\xBB comme rembours\xE9e",
                text: "Demande si le montant a bien \xE9t\xE9 rembours\xE9 \xE0 la personne\xA0: cette action est d\xE9finitive."
              },
              confirm: {
                term: "Confirmer le remboursement",
                text: "Valide le remboursement. \xABAnnuler\xA0\xBB ferme la fen\xEAtre."
              }
            }
          }
        }
      },
      dashboard: {
        title: "Tableau de bord",
        intro: "Les chiffres cl\xE9s de la finance de votre bureau\xA0: ce qui est factur\xE9 et encaiss\xE9, ce que les clients doivent encore, les retenues \xE0 r\xE9cup\xE9rer et la TVA du mois, avec un graphique sur 12 mois. Il est utilis\xE9 par les personnes qui pilotent la tr\xE9sorerie.",
        sections: {
          header: {
            title: "En-t\xEAte de la page",
            items: {
              subNav: {
                term: "Finance",
                text: "Le menu de gauche liste les rubriques de la finance que vos droits permettent d\u2019ouvrir\xA0; sur un petit \xE9cran, il devient une rang\xE9e de liens."
              },
              asOf: {
                term: "Situation au \u2026",
                text: "La date des chiffres. Les montants sont en dinars tunisiens (TND)\xA0; les factures en devises ne sont pas compt\xE9es."
              },
              scope: {
                term: "Ces chiffres couvrent uniquement les factures de vos projets.",
                text: "Message d\u2019information pour les chefs de projet\xA0: ils ne voient que leurs projets."
              }
            }
          },
          kpi: {
            title: "Indicateurs cl\xE9s",
            items: {
              monthInvoiced: {
                term: "Factur\xE9 ce mois-ci",
                text: "Le total factur\xE9 ce mois-ci, avec en dessous le HT et la TVA."
              },
              monthCollected: {
                term: "Encaiss\xE9 ce mois-ci",
                text: "L\u2019argent re\xE7u ce mois-ci, avec les retenues appliqu\xE9es par vos clients."
              },
              yearInvoiced: {
                term: "Factur\xE9 en (ann\xE9e)",
                text: "Le total factur\xE9 depuis le d\xE9but de l\u2019ann\xE9e, avec le HT."
              },
              yearCollected: {
                term: "Encaiss\xE9 en (ann\xE9e)",
                text: "L\u2019argent re\xE7u depuis le d\xE9but de l\u2019ann\xE9e, avec les retenues appliqu\xE9es."
              },
              outstanding: {
                term: "Restant d\xFB par les clients",
                text: "Ce que les clients doivent encore payer, avec le nombre de factures en attente."
              },
              overdue: {
                term: "Dont en retard",
                text: "La part du restant d\xFB dont l\u2019\xE9ch\xE9ance est d\xE9pass\xE9e. La pastille \xAB\xC0 relancer\xA0\xBB (ou \xAB\xC0 jour\xA0\xBB si rien n\u2019est en retard) l\u2019indique en toutes lettres."
              },
              withholdings: {
                term: "Retenues \xE0 r\xE9cup\xE9rer",
                text: "Le montant des retenues pour lesquelles le certificat de retenue manque, avec le nombre de paiements concern\xE9s."
              },
              vat: {
                term: "TVA factur\xE9e ce mois-ci",
                text: "La TVA des factures \xE9mises pendant le mois."
              }
            }
          },
          chart: {
            title: "Factur\xE9 et encaiss\xE9 sur 12 mois",
            items: {
              bars: {
                term: "Factur\xE9 (TTC) / Encaiss\xE9",
                text: "Un histogramme\xA0: pour chaque mois, une barre pour le montant factur\xE9 toutes taxes comprises et une barre pour l\u2019argent encaiss\xE9."
              },
              tooltip: {
                term: "Info-bulle",
                text: "En passant la souris sur un mois, on voit les montants exacts."
              },
              rtl: {
                term: "Sens de lecture",
                text: "En arabe, le graphique est invers\xE9\xA0: le mois le plus ancien est \xE0 droite."
              }
            }
          },
          table: {
            title: "Donn\xE9es du graphique",
            items: {
              toggle: {
                term: "Voir les donn\xE9es / Masquer les donn\xE9es",
                text: "Montre ou cache le tableau qui donne les chiffres exacts du graphique."
              },
              month: {
                term: "Mois",
                text: "Le mois concern\xE9."
              },
              invoiced: {
                term: "Factur\xE9 (TTC)",
                text: "Le montant factur\xE9 ce mois-l\xE0, toutes taxes comprises."
              },
              collected: {
                term: "Encaiss\xE9",
                text: "L\u2019argent re\xE7u ce mois-l\xE0."
              },
              total: {
                term: "Total sur 12 mois",
                text: "La derni\xE8re ligne additionne les 12 mois."
              }
            }
          },
          errors: {
            title: "Erreurs et chargement",
            items: {
              loadError: {
                term: "Le tableau de bord n\u2019a pas pu \xEAtre charg\xE9",
                text: "Message d\u2019erreur en cas de probl\xE8me de connexion\xA0; \xABR\xE9essayer\xA0\xBB relance le chargement."
              },
              loading: {
                term: "Chargement",
                text: "Pendant le calcul, des barres grises remplacent les chiffres."
              }
            }
          }
        }
      },
      einvoicing: {
        title: "Facture \xE9lectronique",
        intro: "Le r\xE9glage de la facture \xE9lectronique de votre bureau\xA0: le mode d\u2019envoi des factures \xE0 TTN (El Fatoora) et les certificats qui servent \xE0 les signer. Il est r\xE9serv\xE9 aux personnes qui g\xE8rent la facture \xE9lectronique.",
        sections: {
          header: {
            title: "En-t\xEAte de la page",
            items: {
              subNav: {
                term: "Finance",
                text: "Le menu de gauche liste les rubriques de la finance que vos droits permettent d\u2019ouvrir\xA0; sur un petit \xE9cran, il devient une rang\xE9e de liens."
              },
              add: {
                term: "Ajouter un certificat",
                text: "Ouvre la fen\xEAtre pour ajouter un certificat de signature."
              }
            }
          },
          mode: {
            title: "Mode de facturation \xE9lectronique",
            items: {
              mode: {
                term: "Mode",
                text: "Choisissez si les factures \xE9mises par votre bureau sont envoy\xE9es \xE0 TTN\xA0: Obligatoire, Facultative ou D\xE9sactiv\xE9e. Les trois choix sont d\xE9crits sous la liste."
              },
              required: {
                term: "Obligatoire",
                text: "Chaque facture \xE9mise est sign\xE9e puis envoy\xE9e \xE0 TTN. \xC0 choisir si la loi ou vos clients l\u2019exigent."
              },
              optional: {
                term: "Facultative",
                text: "Les factures sont envoy\xE9es \xE0 TTN quand votre bureau a un certificat de signature actif\xA0; sans certificat, elles sont \xE9mises sans envoi."
              },
              disabled: {
                term: "D\xE9sactiv\xE9e",
                text: "Aucune facture n\u2019est envoy\xE9e \xE0 TTN\xA0; celles d\xE9j\xE0 envoy\xE9es gardent leur statut."
              },
              save: {
                term: "Enregistrer le mode",
                text: "Enregistre le choix\xA0; une confirmation d\u2019identit\xE9 est demand\xE9e. Le bouton reste gris\xE9 tant que vous n\u2019avez rien chang\xE9."
              }
            }
          },
          credentials: {
            title: "Certificats de signature",
            items: {
              card: {
                term: "Un certificat",
                text: "Une carte par certificat\xA0: son titulaire, son \xE9tat, puis Type, Libell\xE9, Validit\xE9 (du \u2026 au \u2026), \xC9metteur, Empreinte SHA-256 et \xABAjout\xE9\xA0\xBB (par qui et quand). La cl\xE9 priv\xE9e n\u2019est jamais affich\xE9e."
              },
              states: {
                term: "Actif / Expir\xE9 / Remplac\xE9 / R\xE9voqu\xE9",
                text: "L\u2019\xE9tat du certificat. Seul le certificat actif sert \xE0 signer\xA0; le plus r\xE9cent actif est class\xE9 en premier."
              },
              expiring: {
                term: "Expire bient\xF4t",
                text: "Une pastille d\u2019avertissement sur le certificat actif qui arrive \xE0 \xE9ch\xE9ance, avec un bandeau \xABVotre certificat actif expire bient\xF4t\xA0\xBB\xA0: ajoutez un nouveau certificat avant la date."
              },
              revoke: {
                term: "R\xE9voquer",
                text: "Sur le certificat actif\xA0: apr\xE8s confirmation (\xABR\xE9voquer le certificat\xA0\xBB), les factures ne sont plus sign\xE9es avec lui et il ne peut plus \xEAtre r\xE9activ\xE9. Les factures d\xE9j\xE0 accept\xE9es ne changent pas."
              },
              empty: {
                term: "Aucun certificat\xA0: les factures ne peuvent pas \xEAtre sign\xE9es",
                text: "Message de la liste vide\xA0: ajoutez le certificat de cachet \xE9lectronique de votre bureau pour pouvoir envoyer vos factures \xE0 TTN."
              }
            }
          },
          addDialog: {
            title: "Ajouter un certificat de signature",
            items: {
              kind: {
                term: "Type de certificat",
                text: "Cachet \xE9lectronique ou Certificat de test."
              },
              label: {
                term: "Libell\xE9 (facultatif)",
                text: "Un nom pour le reconna\xEEtre, par exemple \xABCachet 2026\xA0\xBB."
              },
              certificate: {
                term: "Certificat (fichier .pem, .crt ou .cer)",
                text: "Le certificat public, au format PEM, 20 Ko au maximum."
              },
              privateKey: {
                term: "Cl\xE9 priv\xE9e (fichier .pem ou .key)",
                text: "La cl\xE9 priv\xE9e au format PEM (PKCS#8), 20 Ko au maximum. Elle est chiffr\xE9e avant d\u2019\xEAtre enregistr\xE9e et ne peut plus jamais \xEAtre affich\xE9e ni t\xE9l\xE9charg\xE9e."
              },
              save: {
                term: "Ajouter le certificat",
                text: "Ajoute le certificat, qui devient actif. Les fichiers sont lus dans votre navigateur puis envoy\xE9s une seule fois\xA0; si une confirmation d\u2019identit\xE9 est demand\xE9e, il faudra choisir de nouveau les fichiers. \xABAnnuler\xA0\xBB ferme la fen\xEAtre."
              }
            }
          }
        }
      }
    },
    clients: {
      title: "Clients",
      intro: "La liste des clients (ma\xEEtres d\u2019ouvrage) de votre bureau\xA0: les personnes ou organismes pour qui vous r\xE9alisez des projets. Leur fiche fiscale sert ensuite \xE0 vos devis et \xE0 vos factures.",
      sections: {
        header: {
          title: "En-t\xEAte de la page",
          items: {
            newClient: {
              term: "Nouveau client",
              text: "Ouvre la fen\xEAtre de cr\xE9ation d\u2019un client. Visible seulement si vous avez le droit d\u2019en cr\xE9er\xA0; gris\xE9 quand le compte du bureau est en lecture seule."
            },
            title: {
              term: "Clients",
              text: "Ici, un client, ou ma\xEEtre d'ouvrage, est la personne ou l'organisme pour qui vous r\xE9alisez un projet."
            }
          }
        },
        filters: {
          title: "Filtrer les clients",
          items: {
            search: {
              term: "Rechercher un client",
              text: "Tapez une partie du nom du client\xA0: la liste se r\xE9duit apr\xE8s un court instant."
            },
            kind: {
              term: "Filtrer par type",
              text: "Montre seulement un type de client (Organisme public, Soci\xE9t\xE9 priv\xE9e, Particulier, Client \xE9tranger)\xA0; \xABTous les types\xA0\xBB affiche tout."
            },
            archived: {
              term: "Afficher uniquement les clients archiv\xE9s",
              text: "Interrupteur\xA0: bascule vers les clients archiv\xE9s, qui n\u2019apparaissent pas dans la liste normale."
            },
            clear: {
              term: "Effacer les filtres",
              text: "Appara\xEEt dans les messages de liste vide\xA0: remet la recherche, le type et l\u2019interrupteur \xE0 z\xE9ro."
            }
          }
        },
        table: {
          title: "Clients du bureau",
          items: {
            name: {
              term: "Nom",
              text: "Le nom du client. Cliquez dessus pour ouvrir sa fiche\xA0; la pastille \xABArchiv\xE9\xA0\xBB signale un client archiv\xE9."
            },
            kind: {
              term: "Type",
              text: "Organisme public, Soci\xE9t\xE9 priv\xE9e, Particulier ou Client \xE9tranger."
            },
            taxId: {
              term: "Matricule fiscal",
              text: "L\u2019identifiant fiscal du client\xA0; \xAB\u2014\xA0\xBB s\u2019il n\u2019est pas renseign\xE9."
            },
            city: {
              term: "Ville",
              text: "La ville du client, suivie du code du pays entre parenth\xE8ses s\u2019il n\u2019est pas en Tunisie."
            },
            contact: {
              term: "E-mail et t\xE9l\xE9phone",
              text: "L\u2019adresse e-mail et le t\xE9l\xE9phone du client\xA0; \xAB\u2014\xA0\xBB s\u2019il n\u2019y en a pas."
            }
          }
        },
        empty: {
          title: "Liste vide, erreur et chargement",
          items: {
            none: {
              term: "Aucun client pour l'instant",
              text: "Message de la liste vide. Il propose \xABNouveau client\xA0\xBB \xE0 ceux qui peuvent en cr\xE9er\xA0; les autres sont invit\xE9s \xE0 demander \xE0 un administrateur ou \xE0 un chef de projet d\u2019en cr\xE9er un."
            },
            noMatch: {
              term: "Aucun client ne correspond",
              text: "Message affich\xE9 quand la recherche ou le type ne trouve rien\xA0: essayez un autre nom ou un autre type."
            },
            archived: {
              term: "Aucun client archiv\xE9",
              text: "Message affich\xE9 quand l\u2019interrupteur des clients archiv\xE9s est actif et qu\u2019il n\u2019y en a aucun."
            },
            loadMore: {
              term: "Afficher plus de clients",
              text: "Plac\xE9 sous la liste\xA0: charge les clients suivants."
            },
            loadError: {
              term: "Impossible de charger les clients",
              text: "Message d\u2019erreur en cas de probl\xE8me de connexion\xA0; \xABR\xE9essayer\xA0\xBB relance le chargement."
            }
          }
        },
        identity: {
          title: "Nouveau client\xA0: Identit\xE9",
          items: {
            kind: {
              term: "Type de client",
              text: "Obligatoire, \xE0 choisir en premier\xA0: le formulaire s\u2019adapte et pr\xE9r\xE8gle la TVA et les retenues. Une phrase sous le champ explique chaque type."
            },
            name: {
              term: "Nom ou raison sociale",
              text: "Obligatoire\xA0: le nom de la personne ou de la soci\xE9t\xE9."
            },
            taxId: {
              term: "Matricule fiscal",
              text: "Obligatoire pour un organisme public ou une soci\xE9t\xE9 priv\xE9e (format 1234567 A / A / M / 000), facultatif pour un particulier. Pour un client \xE9tranger, le champ devient \xABIdentifiant fiscal\xA0\xBB, en texte libre de 50 caract\xE8res au plus."
            },
            paymentTerms: {
              term: "D\xE9lai de paiement (jours)",
              text: "Le nombre de jours apr\xE8s la date de facture\xA0; 30 par d\xE9faut, entre 0 et 365."
            }
          }
        },
        tax: {
          title: "Nouveau client\xA0: TVA et retenues \xE0 la source",
          items: {
            vatRegime: {
              term: "R\xE9gime de TVA",
              text: "Obligatoire\xA0: Assujetti \xE0 la TVA, Exon\xE9r\xE9 de TVA, TVA en suspension ou Export (hors Tunisie). Une phrase sous le champ explique le choix."
            },
            exemptionRef: {
              term: "R\xE9f\xE9rence",
              text: "Selon le r\xE9gime\xA0: \xABR\xE9f\xE9rence du certificat d\u2019exon\xE9ration\xA0\xBB ou \xABR\xE9f\xE9rence de l\u2019attestation de suspension\xA0\xBB (obligatoires), ou \xABR\xE9f\xE9rence (facultatif)\xA0\xBB pour l\u2019export. Recopiez-la telle qu\u2019elle figure sur le document."
            },
            exemptionExpiresOn: {
              term: "Fin de validit\xE9",
              text: "Date jusqu\u2019\xE0 laquelle le certificat est valable\xA0: obligatoire pour une exon\xE9ration, facultative pour une suspension."
            },
            withholding: {
              term: "Retenue \xE0 la source (RAS)",
              text: "Interrupteur\xA0: la RAS est une part de votre facture que le client garde pour la verser \xE0 l\u2019administration fiscale\xA0; vous recevez le reste et un certificat de retenue. Activ\xE9e par d\xE9faut pour les organismes publics et les soci\xE9t\xE9s."
            },
            withholdingRate: {
              term: "Taux de retenue particulier (%)",
              text: "Actif seulement si la RAS est activ\xE9e\xA0: laissez vide pour appliquer le taux l\xE9gal en vigueur, ou saisissez un pourcentage entre 0 et 100."
            },
            vatWithholding: {
              term: "Retenue \xE0 la source sur la TVA (RAS TVA)",
              text: "Interrupteur\xA0: une partie de la TVA de votre facture que le client retient pour la verser au Tr\xE9sor\xA0; vous ne recevez que le compl\xE9ment. Activ\xE9e par d\xE9faut pour les organismes publics\xA0; le taux est celui de la loi."
            }
          }
        },
        addressContact: {
          title: "Nouveau client\xA0: Adresse et Coordonn\xE9es",
          items: {
            line1: {
              term: "Adresse",
              text: "Obligatoire\xA0: la rue et le num\xE9ro."
            },
            line2: {
              term: "Compl\xE9ment d'adresse",
              text: "Facultatif\xA0: b\xE2timent, \xE9tage, etc."
            },
            cityPostal: {
              term: "Ville et Code postal",
              text: "Obligatoires\xA0: la ville, et le code postal de 3 \xE0 10 caract\xE8res."
            },
            country: {
              term: "Pays (code \xE0 2 lettres)",
              text: "Appara\xEEt pour un client \xE9tranger\xA0: par exemple FR pour la France, IT pour l\u2019Italie."
            },
            email: {
              term: "Adresse e-mail",
              text: "Facultative\xA0: sert notamment \xE0 envoyer les devis."
            },
            phone: {
              term: "T\xE9l\xE9phone",
              text: "Facultatif, par exemple +216 71 000 000. Le bouton \xABCr\xE9er le client\xA0\xBB enregistre la fiche, \xABAnnuler\xA0\xBB ferme la fen\xEAtre."
            }
          }
        }
      }
    },
    client: {
      title: "Fiche d\u2019un client",
      intro: "La fiche d\u2019un client (ma\xEEtre d\u2019ouvrage)\xA0: son profil fiscal, ses contacts et, plus tard, ses projets et ses factures. Vous pouvez la modifier ou l\u2019archiver selon vos droits.",
      sections: {
        header: {
          title: "En-t\xEAte de la fiche",
          items: {
            breadcrumb: {
              term: "Clients",
              text: "Le fil d\u2019Ariane ram\xE8ne \xE0 la liste des clients\xA0; le dernier \xE9l\xE9ment est le nom du client."
            },
            archive: {
              term: "Archiver",
              text: "Visible seulement pour ceux qui ont le droit d\u2019archiver et pour un client non archiv\xE9\xA0: ouvre une confirmation (\xABArchiver le client \u2026\xA0?\xA0\xBB). Les projets, devis et factures du client sont conserv\xE9s."
            },
            archivedChip: {
              term: "Archiv\xE9",
              text: "Pastille en haut de la fiche d\u2019un client archiv\xE9. Un bandeau pr\xE9cise\xA0: \xABCe client est archiv\xE9\xA0: sa fiche est en lecture seule\xA0\xBB."
            },
            tabs: {
              term: "Profil, Contacts, Projets, Factures",
              text: "Les quatre onglets de la fiche."
            },
            notFound: {
              term: "Client introuvable",
              text: "Message affich\xE9 si le client n\u2019existe pas ou si vous n\u2019y avez pas acc\xE8s\xA0; \xABRetour aux clients\xA0\xBB revient \xE0 la liste. En cas de probl\xE8me de connexion\xA0: \xABImpossible de charger ce client\xA0\xBB."
            }
          }
        },
        profile: {
          title: "Onglet Profil",
          items: {
            identity: {
              term: "Identit\xE9",
              text: "Type de client, nom ou raison sociale, identifiant fiscal et d\xE9lai de paiement (en jours)."
            },
            tax: {
              term: "TVA et retenues \xE0 la source",
              text: "Le r\xE9gime de TVA, sa r\xE9f\xE9rence et sa fin de validit\xE9 s\u2019il y en a, puis \xABRetenue \xE0 la source (RAS)\xA0\xBB (Oui avec le taux l\xE9gal ou un taux particulier, ou Non) et \xABRetenue \xE0 la source sur la TVA (RAS TVA)\xA0\xBB (Oui ou Non)."
            },
            address: {
              term: "Adresse",
              text: "L\u2019adresse, l\u2019e-mail, le t\xE9l\xE9phone, et \xABCr\xE9\xE9 le\xA0\xBB (la date de cr\xE9ation de la fiche)."
            },
            edit: {
              term: "Modifier",
              text: "Passe la fiche en modification. Visible seulement si vous pouvez modifier les clients et si le client n\u2019est pas archiv\xE9."
            }
          }
        },
        edit: {
          title: "Modifier le client",
          items: {
            fields: {
              term: "Les champs du formulaire",
              text: "Les m\xEAmes champs que pour cr\xE9er un client\xA0: identit\xE9, TVA et retenues \xE0 la source, adresse et coordonn\xE9es. Le type de client change les champs affich\xE9s."
            },
            save: {
              term: "Enregistrer",
              text: "Enregistre les changements\xA0; si rien n\u2019a chang\xE9, le formulaire se referme simplement."
            },
            cancel: {
              term: "Annuler",
              text: "Ferme le formulaire sans rien enregistrer."
            },
            stale: {
              term: "Modifi\xE9 par quelqu\u2019un d\u2019autre",
              text: "Si une autre personne a modifi\xE9 la fiche en m\xEAme temps, un message l\u2019indique, la fiche est recharg\xE9e et vous devez appliquer de nouveau vos changements."
            }
          }
        },
        contacts: {
          title: "Onglet Contacts",
          items: {
            intro: {
              term: "Contacts",
              text: "Les personnes \xE0 joindre chez ce client. Un seul contact est le contact principal."
            },
            add: {
              term: "Ajouter un contact",
              text: "Ouvre la fen\xEAtre d\u2019ajout. Visible seulement si vous pouvez modifier le client (et s\u2019il y a d\xE9j\xE0 au moins un contact\xA0; sinon le bouton est dans le message de la liste vide)."
            },
            columns: {
              term: "Nom, Fonction, E-mail, T\xE9l\xE9phone",
              text: "Une ligne par contact. La pastille \xABPrincipal\xA0\xBB marque le contact principal\xA0; \xAB\u2014\xA0\xBB indique une information absente."
            },
            actions: {
              term: "Actions",
              text: "Le bouton \xE0 trois points de chaque ligne ouvre un menu\xA0: \xABModifier\xA0\xBB, \xABD\xE9finir comme principal\xA0\xBB (sauf pour le contact principal) et \xABSupprimer\xA0\xBB (apr\xE8s confirmation)."
            },
            empty: {
              term: "Aucun contact",
              text: "Message de la liste vide\xA0: ajoutez la personne \xE0 qui adresser vos devis et vos factures."
            }
          }
        },
        contactDialog: {
          title: "Nouveau contact / Modifier le contact",
          items: {
            name: {
              term: "Nom",
              text: "Obligatoire\xA0: le nom de la personne."
            },
            role: {
              term: "Fonction",
              text: "Facultatif, par exemple directeur technique ou charg\xE9 de projet."
            },
            email: {
              term: "Adresse e-mail",
              text: "Facultative\xA0: c\u2019est l\u2019adresse utilis\xE9e pour envoyer un devis \xE0 ce contact."
            },
            phone: {
              term: "T\xE9l\xE9phone",
              text: "Facultatif, par exemple +216 71 000 000."
            },
            primary: {
              term: "Contact principal",
              text: "Case \xE0 cocher\xA0: un seul contact principal par client\xA0; cocher cette case remplace l\u2019ancien."
            },
            save: {
              term: "Enregistrer",
              text: "Enregistre le contact. \xABAnnuler\xA0\xBB ferme la fen\xEAtre."
            }
          }
        },
        otherTabs: {
          title: "Onglets Projets et Factures",
          items: {
            projects: {
              term: "Projets",
              text: "Pour l\u2019instant, cet onglet annonce que les projets de ce client arriveront bient\xF4t."
            },
            invoices: {
              term: "Factures",
              text: "Pour l\u2019instant, cet onglet annonce que les devis et les factures de ce client arriveront bient\xF4t. En attendant, retrouvez-les dans la rubrique Finance."
            }
          }
        }
      }
    }
  }
};

// src/resources.ts
var NAMESPACES = [
  "common",
  "web",
  "ui",
  "email",
  "clients",
  "projects",
  "tasks",
  "documents",
  "viewer",
  "notifications",
  "search",
  "chat",
  "calendar",
  "meetings",
  "spaces",
  "finance",
  "planning",
  "field",
  "transmittals",
  "shareLinks",
  "tenders",
  "suppliers",
  "profitability",
  "accounting",
  "management",
  "signatures",
  "observations",
  "pdf",
  "backoffice",
  "guide"
];
var resources = {
  fr: {
    common: common_default3,
    web: web_default3,
    ui: ui_default3,
    email: email_default3,
    clients: clients_default3,
    projects: projects_default3,
    tasks: tasks_default3,
    documents: documents_default3,
    viewer: viewer_default3,
    notifications: notifications_default3,
    search: search_default3,
    chat: chat_default3,
    calendar: calendar_default3,
    meetings: meetings_default3,
    spaces: spaces_default3,
    finance: finance_default3,
    planning: planning_default3,
    field: field_default3,
    transmittals: transmittals_default3,
    tenders: tenders_default3,
    suppliers: suppliers_default3,
    profitability: profitability_default3,
    accounting: accounting_default3,
    management: management_default3,
    signatures: signatures_default3,
    observations: observations_default3,
    shareLinks: shareLinks_default3,
    pdf: pdf_default3,
    backoffice: backoffice_default3,
    guide: guide_default3
  },
  ar: {
    common: common_default,
    web: web_default,
    ui: ui_default,
    email: email_default,
    clients: clients_default,
    projects: projects_default,
    tasks: tasks_default,
    documents: documents_default,
    viewer: viewer_default,
    notifications: notifications_default,
    search: search_default,
    chat: chat_default,
    calendar: calendar_default,
    meetings: meetings_default,
    spaces: spaces_default,
    finance: finance_default,
    planning: planning_default,
    field: field_default,
    transmittals: transmittals_default,
    tenders: tenders_default,
    suppliers: suppliers_default,
    profitability: profitability_default,
    accounting: accounting_default,
    management: management_default,
    signatures: signatures_default,
    observations: observations_default,
    shareLinks: shareLinks_default,
    pdf: pdf_default,
    backoffice: backoffice_default,
    guide: guide_default
  },
  en: {
    common: common_default2,
    web: web_default2,
    ui: ui_default2,
    email: email_default2,
    clients: clients_default2,
    projects: projects_default2,
    tasks: tasks_default2,
    documents: documents_default2,
    viewer: viewer_default2,
    notifications: notifications_default2,
    search: search_default2,
    chat: chat_default2,
    calendar: calendar_default2,
    meetings: meetings_default2,
    spaces: spaces_default2,
    finance: finance_default2,
    planning: planning_default2,
    field: field_default2,
    transmittals: transmittals_default2,
    tenders: tenders_default2,
    suppliers: suppliers_default2,
    profitability: profitability_default2,
    accounting: accounting_default2,
    management: management_default2,
    signatures: signatures_default2,
    observations: observations_default2,
    shareLinks: shareLinks_default2,
    pdf: pdf_default2,
    backoffice: backoffice_default2,
    guide: guide_default2
  }
};

// src/instance.ts
import i18next from "i18next";
import ICU from "i18next-icu";
var LOCALES = ["fr", "ar", "en"];
var DEFAULT_LOCALE = "fr";
var directionOf = (locale) => locale === "ar" ? "rtl" : "ltr";
function createI18nInstance(options) {
  const instance = i18next.createInstance();
  instance.use(ICU);
  if (options.backend) instance.use(options.backend);
  const ready = instance.init({
    ...options.resources ? { resources: options.resources } : {},
    lng: options.locale ?? DEFAULT_LOCALE,
    // With a backend, only the language in use is loaded: every key exists in every language
    // (`pnpm i18n:check`), so French is not fetched as a fallback.
    fallbackLng: options.backend ? false : DEFAULT_LOCALE,
    supportedLngs: [...LOCALES],
    load: "currentOnly",
    ns: [...options.namespaces],
    defaultNS: options.defaultNamespace ?? "common",
    interpolation: { escapeValue: false },
    // React escapes; emails/PDFs escape in their templates
    returnNull: false,
    initAsync: Boolean(options.backend),
    saveMissing: Boolean(options.onMissingKey),
    missingKeyHandler: options.onMissingKey ? (lngs, ns, key) => options.onMissingKey?.(lngs, ns, key) : false
  });
  return { i18n: instance, ready: ready.then(() => void 0) };
}

// src/create-i18n.ts
function createI18n(options = {}) {
  const resources2 = Object.fromEntries(
    Object.entries(resources).map(([lng, nss]) => [lng, { ...nss }])
  );
  for (const [lng, nss] of Object.entries(options.resources ?? {})) {
    resources2[lng] = { ...resources2[lng] ?? {}, ...nss };
  }
  return createI18nInstance({
    locale: options.locale ?? DEFAULT_LOCALE,
    resources: resources2,
    namespaces: options.namespaces ?? NAMESPACES,
    ...options.defaultNamespace ? { defaultNamespace: options.defaultNamespace } : {},
    ...options.onMissingKey ? { onMissingKey: options.onMissingKey } : {}
  }).i18n;
}

// src/format.ts
import { CURRENCY_EXPONENT, toDecimalString } from "@batiflow/domain-fiscal";
var DEFAULT_TIME_ZONE = "Africa/Tunis";
function intlLocale(locale, digits = "latn") {
  if (locale === "ar") return `ar-TN-u-nu-${digits}`;
  return locale === "fr" ? "fr-TN" : "en-GB";
}
var CURRENCY_LABEL = {
  fr: { TND: "TND", EUR: "EUR", USD: "USD" },
  en: { TND: "TND", EUR: "EUR", USD: "USD" },
  ar: { TND: "\u062F.\u062A", EUR: "EUR", USD: "USD" }
};
function formatMoney(m, locale, { digits = "latn", withCurrency = true } = {}) {
  const exp = CURRENCY_EXPONENT[m.currency];
  const nf = new Intl.NumberFormat(intlLocale(locale, digits), {
    minimumFractionDigits: exp,
    maximumFractionDigits: exp,
    useGrouping: true
  });
  const number = nf.format(toDecimalString(m));
  return withCurrency ? `${number}\xA0${CURRENCY_LABEL[locale][m.currency]}` : number;
}
function formatRateBp(rateBp, locale, { digits = "latn" } = {}) {
  if (!Number.isSafeInteger(rateBp)) throw new RangeError("rateBp must be an integer");
  const sign = rateBp < 0 ? "-" : "";
  const abs = Math.abs(rateBp);
  const fraction = `${sign}${String(Math.trunc(abs / 1e4))}.${String(abs % 1e4).padStart(4, "0")}`;
  const text = new Intl.NumberFormat(intlLocale(locale, digits), {
    style: "percent",
    maximumFractionDigits: 2
  }).format(fraction);
  return withoutBidiMarks(text);
}
var BIDI_MARKS = /[\u200e\u200f\u061c]/g;
var withoutBidiMarks = (text) => text.replace(BIDI_MARKS, "");
function formatDate(date, locale, { digits = "latn", timeZone = DEFAULT_TIME_ZONE } = {}) {
  return withoutBidiMarks(
    new Intl.DateTimeFormat(intlLocale(locale, digits), {
      timeZone,
      day: "2-digit",
      month: "2-digit",
      year: "numeric"
    }).format(new Date(date))
  );
}
function formatDateTime(date, locale, { digits = "latn", timeZone = DEFAULT_TIME_ZONE } = {}) {
  return withoutBidiMarks(
    new Intl.DateTimeFormat(intlLocale(locale, digits), {
      timeZone,
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      // Tunisia reads a 24-hour clock in every language (CLDR's fr-TN and ar-TN default to 12 hours).
      hourCycle: "h23"
    }).format(new Date(date))
  );
}
var RELATIVE_UNITS = [
  ["year", 365 * 24 * 3600],
  ["month", 30 * 24 * 3600],
  ["week", 7 * 24 * 3600],
  ["day", 24 * 3600],
  ["hour", 3600],
  ["minute", 60],
  ["second", 1]
];
function formatRelative(date, now, locale, digits = "latn") {
  const seconds = Math.round((new Date(date).getTime() - now.getTime()) / 1e3);
  const rtf = new Intl.RelativeTimeFormat(intlLocale(locale, digits), { numeric: "auto" });
  for (const [unit, size] of RELATIVE_UNITS) {
    if (Math.abs(seconds) >= size || unit === "second")
      return rtf.format(Math.round(seconds / size), unit);
  }
  return rtf.format(0, "second");
}

// src/tax-id.ts
var CHECK_LETTERS = /^[A-HJ-NP-TV-Z]$/;
var VAT_CODES = /^[APBDN]$/;
var CATEGORIES = /^[MPCNE]$/;
function parseTaxId(input, { allowShort = false } = {}) {
  const compact = input.toUpperCase().replace(/[\s/.-]/g, "");
  if (!compact) return { valid: false, error: "EMPTY" };
  if (compact.length > 32) return { valid: false, error: "FORMAT" };
  const m = /^(\d{7})([A-Z])(?:([A-Z])([A-Z])(\d{3}))?$/.exec(compact);
  if (!m) return { valid: false, error: /^\d{7}[A-Z]/.test(compact) ? "INCOMPLETE" : "FORMAT" };
  const [, identifier = "", checkLetter = "", vatCode, category, establishment] = m;
  if (!CHECK_LETTERS.test(checkLetter)) return { valid: false, error: "CHECK_LETTER" };
  if (vatCode === void 0 || category === void 0 || establishment === void 0) {
    if (!allowShort) return { valid: false, error: "INCOMPLETE" };
    const normalized = `${identifier}${checkLetter}`;
    return {
      valid: true,
      normalized,
      display: `${identifier} ${checkLetter}`,
      short: true,
      parts: { identifier, checkLetter, vatCode: "", category: "", establishment: "" }
    };
  }
  if (!VAT_CODES.test(vatCode)) return { valid: false, error: "VAT_CODE" };
  if (!CATEGORIES.test(category)) return { valid: false, error: "CATEGORY" };
  if (!/^\d{3}$/.test(establishment)) return { valid: false, error: "ESTABLISHMENT" };
  return {
    valid: true,
    short: false,
    normalized: `${identifier}${checkLetter}/${vatCode}/${category}/${establishment}`,
    display: `${identifier} ${checkLetter} / ${vatCode} / ${category} / ${establishment}`,
    parts: { identifier, checkLetter, vatCode, category, establishment }
  };
}
function taxIdUniquenessKey(result) {
  return `${result.parts.identifier}${result.parts.checkLetter}`;
}

// src/holidays/tn-2026.json
var tn_2026_default = {
  year: 2026,
  country: "TN",
  source: "Civil holidays: Tunisian public holidays as known in 2026 (17 December replaces 14 January since 2021) \u2014 to verify against the official calendar. Religious dates are astronomical estimates, confirmed each year by the authorities.",
  verificationStatus: "to_verify",
  holidays: [
    { date: "2026-01-01", key: "new_year", kind: "civil", estimated: false },
    { date: "2026-03-20", key: "independence_day", kind: "civil", estimated: false },
    { date: "2026-03-20", key: "eid_al_fitr_1", kind: "religious", estimated: true },
    { date: "2026-03-21", key: "eid_al_fitr_2", kind: "religious", estimated: true },
    { date: "2026-04-09", key: "martyrs_day", kind: "civil", estimated: false },
    { date: "2026-05-01", key: "labour_day", kind: "civil", estimated: false },
    { date: "2026-05-27", key: "eid_al_adha_1", kind: "religious", estimated: true },
    { date: "2026-05-28", key: "eid_al_adha_2", kind: "religious", estimated: true },
    { date: "2026-06-16", key: "islamic_new_year", kind: "religious", estimated: true },
    { date: "2026-07-25", key: "republic_day", kind: "civil", estimated: false },
    { date: "2026-08-13", key: "womens_day", kind: "civil", estimated: false },
    { date: "2026-08-25", key: "mawlid", kind: "religious", estimated: true },
    { date: "2026-10-15", key: "evacuation_day", kind: "civil", estimated: false },
    { date: "2026-12-17", key: "revolution_day", kind: "civil", estimated: false }
  ]
};

// src/holidays/tn-2027.json
var tn_2027_default = {
  year: 2027,
  country: "TN",
  source: "Civil holidays: Tunisian public holidays as known in 2026 (17 December replaces 14 January since 2021) \u2014 to verify against the official calendar. Religious dates are astronomical estimates, confirmed each year by the authorities.",
  verificationStatus: "to_verify",
  holidays: [
    { date: "2027-01-01", key: "new_year", kind: "civil", estimated: false },
    { date: "2027-03-10", key: "eid_al_fitr_1", kind: "religious", estimated: true },
    { date: "2027-03-11", key: "eid_al_fitr_2", kind: "religious", estimated: true },
    { date: "2027-03-20", key: "independence_day", kind: "civil", estimated: false },
    { date: "2027-04-09", key: "martyrs_day", kind: "civil", estimated: false },
    { date: "2027-05-01", key: "labour_day", kind: "civil", estimated: false },
    { date: "2027-05-16", key: "eid_al_adha_1", kind: "religious", estimated: true },
    { date: "2027-05-17", key: "eid_al_adha_2", kind: "religious", estimated: true },
    { date: "2027-06-06", key: "islamic_new_year", kind: "religious", estimated: true },
    { date: "2027-07-25", key: "republic_day", kind: "civil", estimated: false },
    { date: "2027-08-13", key: "womens_day", kind: "civil", estimated: false },
    { date: "2027-08-15", key: "mawlid", kind: "religious", estimated: true },
    { date: "2027-10-15", key: "evacuation_day", kind: "civil", estimated: false },
    { date: "2027-12-17", key: "revolution_day", kind: "civil", estimated: false }
  ]
};

// src/holidays/tn-2028.json
var tn_2028_default = {
  year: 2028,
  country: "TN",
  source: "Civil holidays: Tunisian public holidays as known in 2026 (17 December replaces 14 January since 2021) \u2014 to verify against the official calendar. Religious dates are astronomical estimates, confirmed each year by the authorities.",
  verificationStatus: "to_verify",
  holidays: [
    { date: "2028-01-01", key: "new_year", kind: "civil", estimated: false },
    { date: "2028-02-26", key: "eid_al_fitr_1", kind: "religious", estimated: true },
    { date: "2028-02-27", key: "eid_al_fitr_2", kind: "religious", estimated: true },
    { date: "2028-03-20", key: "independence_day", kind: "civil", estimated: false },
    { date: "2028-04-09", key: "martyrs_day", kind: "civil", estimated: false },
    { date: "2028-05-01", key: "labour_day", kind: "civil", estimated: false },
    { date: "2028-05-05", key: "eid_al_adha_1", kind: "religious", estimated: true },
    { date: "2028-05-06", key: "eid_al_adha_2", kind: "religious", estimated: true },
    { date: "2028-05-25", key: "islamic_new_year", kind: "religious", estimated: true },
    { date: "2028-07-25", key: "republic_day", kind: "civil", estimated: false },
    { date: "2028-08-03", key: "mawlid", kind: "religious", estimated: true },
    { date: "2028-08-13", key: "womens_day", kind: "civil", estimated: false },
    { date: "2028-10-15", key: "evacuation_day", kind: "civil", estimated: false },
    { date: "2028-12-17", key: "revolution_day", kind: "civil", estimated: false }
  ]
};

// src/holidays/index.ts
var FILES = [
  tn_2026_default,
  tn_2027_default,
  tn_2028_default
];
var KNOWN_HOLIDAY_YEARS = FILES.map((f) => f.year);
function holidaysOf(year) {
  return FILES.find((f) => f.year === year)?.holidays ?? [];
}
function holidayOn(date) {
  return holidaysOf(Number(date.slice(0, 4))).find((h) => h.date === date);
}
function isBusinessDay(date) {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(date)) throw new RangeError(`expected YYYY-MM-DD, got ${date}`);
  const year = Number(date.slice(0, 4));
  if (!KNOWN_HOLIDAY_YEARS.includes(year))
    throw new RangeError(`no Tunisian holiday calendar for ${year}`);
  const weekday = (/* @__PURE__ */ new Date(`${date}T12:00:00Z`)).getUTCDay();
  if (weekday === 0 || weekday === 6) return false;
  return holidayOn(date) === void 0;
}

// src/words/amount-in-words.ts
import { CURRENCY_EXPONENT as CURRENCY_EXPONENT2 } from "@batiflow/domain-fiscal";

// src/words/ar.ts
var UNITS = ["", "\u0648\u0627\u062D\u062F", "\u0627\u062B\u0646\u0627\u0646", "\u062B\u0644\u0627\u062B\u0629", "\u0623\u0631\u0628\u0639\u0629", "\u062E\u0645\u0633\u0629", "\u0633\u062A\u0629", "\u0633\u0628\u0639\u0629", "\u062B\u0645\u0627\u0646\u064A\u0629", "\u062A\u0633\u0639\u0629"];
var TENS = ["", "\u0639\u0634\u0631\u0629", "\u0639\u0634\u0631\u0648\u0646", "\u062B\u0644\u0627\u062B\u0648\u0646", "\u0623\u0631\u0628\u0639\u0648\u0646", "\u062E\u0645\u0633\u0648\u0646", "\u0633\u062A\u0648\u0646", "\u0633\u0628\u0639\u0648\u0646", "\u062B\u0645\u0627\u0646\u0648\u0646", "\u062A\u0633\u0639\u0648\u0646"];
var HUNDREDS = [
  "",
  "\u0645\u0627\u0626\u0629",
  "\u0645\u0627\u0626\u062A\u0627\u0646",
  "\u062B\u0644\u0627\u062B\u0645\u0627\u0626\u0629",
  "\u0623\u0631\u0628\u0639\u0645\u0627\u0626\u0629",
  "\u062E\u0645\u0633\u0645\u0627\u0626\u0629",
  "\u0633\u062A\u0645\u0627\u0626\u0629",
  "\u0633\u0628\u0639\u0645\u0627\u0626\u0629",
  "\u062B\u0645\u0627\u0646\u0645\u0627\u0626\u0629",
  "\u062A\u0633\u0639\u0645\u0627\u0626\u0629"
];
function below100(n) {
  if (n < 10) return UNITS[n];
  if (n === 10) return "\u0639\u0634\u0631\u0629";
  if (n === 11) return "\u0623\u062D\u062F \u0639\u0634\u0631";
  if (n === 12) return "\u0627\u062B\u0646\u0627 \u0639\u0634\u0631";
  if (n < 20) return `${UNITS[n - 10]} \u0639\u0634\u0631`;
  const t = Math.floor(n / 10);
  const u = n % 10;
  return u === 0 ? TENS[t] : `${UNITS[u]} \u0648${TENS[t]}`;
}
function below1000(n, construct) {
  const h = Math.floor(n / 100);
  const r = n % 100;
  const parts = [];
  if (h > 0) parts.push(h === 2 && r === 0 && construct ? "\u0645\u0627\u0626\u062A\u0627" : HUNDREDS[h]);
  if (r > 0) parts.push(below100(r));
  return parts.join(" \u0648");
}
function counted(count, noun, inConstruct) {
  if (count === 1) return inConstruct ? noun.singular : noun.one;
  if (count === 2) return inConstruct ? noun.dualConstruct ?? noun.dual : noun.dual;
  const r = count % 100;
  if (r >= 3 && r <= 10) return `${below1000(count, false)} ${noun.plural}`;
  if (r >= 11) return `${below1000(count, false)} ${inConstruct ? noun.singular : noun.accusative}`;
  if (r === 0) return `${below1000(count, true)} ${noun.singular}`;
  return `${below1000(count, false)} ${noun.singular}`;
}
var THOUSAND = {
  one: "\u0623\u0644\u0641",
  dual: "\u0623\u0644\u0641\u0627\u0646",
  dualConstruct: "\u0623\u0644\u0641\u0627",
  plural: "\u0622\u0644\u0627\u0641",
  accusative: "\u0623\u0644\u0641\u0627",
  singular: "\u0623\u0644\u0641"
};
var MILLION = {
  one: "\u0645\u0644\u064A\u0648\u0646",
  dual: "\u0645\u0644\u064A\u0648\u0646\u0627\u0646",
  dualConstruct: "\u0645\u0644\u064A\u0648\u0646\u0627",
  plural: "\u0645\u0644\u0627\u064A\u064A\u0646",
  accusative: "\u0645\u0644\u064A\u0648\u0646\u0627",
  singular: "\u0645\u0644\u064A\u0648\u0646"
};
var BILLION = {
  one: "\u0645\u0644\u064A\u0627\u0631",
  dual: "\u0645\u0644\u064A\u0627\u0631\u0627\u0646",
  dualConstruct: "\u0645\u0644\u064A\u0627\u0631\u0627",
  plural: "\u0645\u0644\u064A\u0627\u0631\u0627\u062A",
  accusative: "\u0645\u0644\u064A\u0627\u0631\u0627",
  singular: "\u0645\u0644\u064A\u0627\u0631"
};
var SCALES = [
  { value: 1000000000n, noun: BILLION },
  { value: 1000000n, noun: MILLION },
  { value: 1000n, noun: THOUSAND }
];
function arabicCounted(value, noun) {
  if (value < 0n) throw new RangeError("negative numbers are not supported");
  if (value >= 1000000000000n) throw new RangeError("number too large");
  if (value === 0n) return `\u0635\u0641\u0631 ${noun.singular}`;
  const groups = [];
  let rest = value;
  for (const s of SCALES) {
    const c = Number(rest / s.value);
    rest %= s.value;
    if (c > 0) groups.push({ count: c, noun: s.noun });
  }
  const units = Number(rest);
  const parts = [];
  groups.forEach((g, i) => {
    const isLast = i === groups.length - 1 && units === 0;
    parts.push(counted(g.count, g.noun, isLast));
  });
  if (units > 0) {
    parts.push(counted(units, noun, false));
  } else {
    parts.push(noun.singular);
  }
  const tail = units > 0 ? parts.pop() : void 0;
  const head = units > 0 ? parts.join(" \u0648") : `${parts.slice(0, -1).join(" \u0648")} ${parts.at(-1)}`;
  return tail ? head ? `${head} \u0648${tail}` : tail : head;
}

// src/words/fr.ts
var UNITS2 = [
  "z\xE9ro",
  "un",
  "deux",
  "trois",
  "quatre",
  "cinq",
  "six",
  "sept",
  "huit",
  "neuf",
  "dix",
  "onze",
  "douze",
  "treize",
  "quatorze",
  "quinze",
  "seize"
];
var TENS2 = {
  2: "vingt",
  3: "trente",
  4: "quarante",
  5: "cinquante",
  6: "soixante"
};
function below1002(n, plural) {
  if (n <= 16) return UNITS2[n];
  if (n < 20) return `dix-${UNITS2[n - 10]}`;
  const t = Math.floor(n / 10);
  const u = n % 10;
  if (t === 7 || t === 9) {
    const base = t === 7 ? "soixante" : "quatre-vingt";
    if (t === 7 && u === 1) return "soixante et onze";
    return `${base}-${below1002(10 + u, false)}`;
  }
  if (t === 8)
    return u === 0 ? plural ? "quatre-vingts" : "quatre-vingt" : `quatre-vingt-${UNITS2[u]}`;
  const tens = TENS2[t];
  if (u === 0) return tens;
  if (u === 1) return `${tens} et un`;
  return `${tens}-${UNITS2[u]}`;
}
function below10002(n, plural) {
  const h = Math.floor(n / 100);
  const r = n % 100;
  const parts = [];
  if (h === 1) parts.push("cent");
  else if (h > 1) parts.push(`${UNITS2[h]} ${r === 0 && plural ? "cents" : "cent"}`);
  if (r > 0) parts.push(below1002(r, plural));
  return parts.join(" ");
}
var SCALES2 = [
  { value: 1000000000n, singular: "milliard", plural: "milliards" },
  { value: 1000000n, singular: "million", plural: "millions" }
];
function frenchNumber(value) {
  if (value < 0n) throw new RangeError("negative numbers are not supported");
  if (value >= 1000000000000000n) throw new RangeError("number too large");
  if (value === 0n) return { words: "z\xE9ro", endsWithScaleNoun: false };
  const parts = [];
  let rest = value;
  let endsWithScaleNoun = false;
  for (const scale of SCALES2) {
    const count = rest / scale.value;
    rest %= scale.value;
    if (count === 0n) continue;
    const countWords = count === 1n ? "un" : frenchNumber(count).words;
    parts.push(`${countWords} ${count === 1n ? scale.singular : scale.plural}`);
    endsWithScaleNoun = rest === 0n;
  }
  const thousands = Number(rest / 1000n);
  const units = Number(rest % 1000n);
  if (thousands > 0) parts.push(thousands === 1 ? "mille" : `${below10002(thousands, false)} mille`);
  if (units > 0) parts.push(below10002(units, true));
  return { words: parts.join(" "), endsWithScaleNoun };
}

// src/words/amount-in-words.ts
var FR_NOUNS = {
  TND: { major: ["dinar", "dinars"], minor: ["millime", "millimes"] },
  EUR: { major: ["euro", "euros"], minor: ["centime", "centimes"] },
  USD: { major: ["dollar", "dollars"], minor: ["cent", "cents"] }
};
var AR_NOUNS = {
  TND: {
    major: {
      one: "\u062F\u064A\u0646\u0627\u0631 \u0648\u0627\u062D\u062F",
      dual: "\u062F\u064A\u0646\u0627\u0631\u0627\u0646",
      plural: "\u062F\u0646\u0627\u0646\u064A\u0631",
      accusative: "\u062F\u064A\u0646\u0627\u0631\u0627",
      singular: "\u062F\u064A\u0646\u0627\u0631"
    },
    minor: {
      one: "\u0645\u0644\u064A\u0645 \u0648\u0627\u062D\u062F",
      dual: "\u0645\u0644\u064A\u0645\u0627\u0646",
      plural: "\u0645\u0644\u064A\u0645\u0627\u062A",
      accusative: "\u0645\u0644\u064A\u0645\u0627",
      singular: "\u0645\u0644\u064A\u0645"
    }
  },
  EUR: {
    major: {
      one: "\u064A\u0648\u0631\u0648 \u0648\u0627\u062D\u062F",
      dual: "\u064A\u0648\u0631\u0648\u0627\u0646",
      plural: "\u064A\u0648\u0631\u0648\u0647\u0627\u062A",
      accusative: "\u064A\u0648\u0631\u0648",
      singular: "\u064A\u0648\u0631\u0648"
    },
    minor: { one: "\u0633\u0646\u062A \u0648\u0627\u062D\u062F", dual: "\u0633\u0646\u062A\u0627\u0646", plural: "\u0633\u0646\u062A\u0627\u062A", accusative: "\u0633\u0646\u062A\u0627", singular: "\u0633\u0646\u062A" }
  },
  USD: {
    major: {
      one: "\u062F\u0648\u0644\u0627\u0631 \u0648\u0627\u062D\u062F",
      dual: "\u062F\u0648\u0644\u0627\u0631\u0627\u0646",
      plural: "\u062F\u0648\u0644\u0627\u0631\u0627\u062A",
      accusative: "\u062F\u0648\u0644\u0627\u0631\u0627",
      singular: "\u062F\u0648\u0644\u0627\u0631"
    },
    minor: { one: "\u0633\u0646\u062A \u0648\u0627\u062D\u062F", dual: "\u0633\u0646\u062A\u0627\u0646", plural: "\u0633\u0646\u062A\u0627\u062A", accusative: "\u0633\u0646\u062A\u0627", singular: "\u0633\u0646\u062A" }
  }
};
function split(m) {
  const base = 10n ** BigInt(CURRENCY_EXPONENT2[m.currency]);
  const abs = m.amountMinor < 0n ? -m.amountMinor : m.amountMinor;
  return { major: abs / base, minor: abs % base };
}
function frenchPart(value, [singular, plural]) {
  const { words, endsWithScaleNoun } = frenchNumber(value);
  const noun = value <= 1n ? singular : plural;
  return `${words}${endsWithScaleNoun ? " de" : ""} ${noun}`;
}
function amountInWords(m, locale) {
  const { major, minor } = split(m);
  if (locale === "fr") {
    const nouns2 = FR_NOUNS[m.currency];
    const majorText2 = frenchPart(major, nouns2.major);
    if (minor === 0n) return majorText2;
    if (major === 0n) return frenchPart(minor, nouns2.minor);
    return `${majorText2} et ${frenchPart(minor, nouns2.minor)}`;
  }
  const nouns = AR_NOUNS[m.currency];
  const majorText = arabicCounted(major, nouns.major);
  if (minor === 0n) return majorText;
  if (major === 0n) return arabicCounted(minor, nouns.minor);
  return `${majorText} \u0648${arabicCounted(minor, nouns.minor)}`;
}
export {
  DEFAULT_LOCALE,
  DEFAULT_TIME_ZONE,
  KNOWN_HOLIDAY_YEARS,
  LOCALES,
  NAMESPACES,
  amountInWords,
  arabicCounted,
  createI18n,
  createI18nInstance,
  directionOf,
  formatDate,
  formatDateTime,
  formatMoney,
  formatRateBp,
  formatRelative,
  frenchNumber,
  holidayOn,
  holidaysOf,
  intlLocale,
  isBusinessDay,
  parseTaxId,
  resources,
  taxIdUniquenessKey
};
//# sourceMappingURL=index.js.map